/* eslint-disable */
// @ts-nocheck
import { PaymentStatus as PaymentStatusTypesEnum } from '@breezy/shared';
import { TechnicianCapacityBlockReasonType as TechnicianCapacityBlockReasonTypesEnum } from '@breezy/shared';
import { InvoiceTerm as InvoiceTermsEnum } from '@breezy/shared';
import { MaintenancePlanPaymentFlow as MaintenancePlanPaymentFlowTypesEnum } from '@breezy/shared';
import { JobClass as JobClassesEnum } from '@breezy/shared';
import { AccountType } from '@breezy/shared';
import { AccountTypeArray } from '@breezy/shared';
import { AppointmentChecklistInstanceChecklist } from '@breezy/shared';
import { AppointmentNotificationType } from '@breezy/shared';
import { AppointmentType } from '@breezy/shared';
import { AttributionLinkingStrategy } from '@breezy/shared';
import { CartItemType } from '@breezy/shared';
import { CartItemVariant } from '@breezy/shared';
import { CompanyLineItemVisibility } from '@breezy/shared';
import { CreditRecordArray } from '@breezy/shared';
import { CustomerCommunicationTemplateName } from '@breezy/shared';
import { CustomerCommunicationTemplateType } from '@breezy/shared';
import { DayOfTheWeek } from '@breezy/shared';
import { DiscountType } from '@breezy/shared';
import { DynamicPricingType } from '@breezy/shared';
import { EmbeddedReportAccessControlType } from '@breezy/shared';
import { EmbeddedReportCategory } from '@breezy/shared';
import { EmbeddedReportType } from '@breezy/shared';
import { EmbeddedReportingPulseRecipientArray } from '@breezy/shared';
import { EmbeddedReportingPulseScheduleType } from '@breezy/shared';
import { EntitlementType } from '@breezy/shared';
import { EquipmentType } from '@breezy/shared';
import { EquipmentTypeArray } from '@breezy/shared';
import { EstimateTemplateMessagePreset } from '@breezy/shared';
import { EstimateV2Status } from '@breezy/shared';
import { FileMetadata } from '@breezy/shared';
import { FileStorageStrategy } from '@breezy/shared';
import { Geo } from '@breezy/shared';
import { GuidArray } from '@breezy/shared';
import { HtmlString } from '@breezy/shared';
import { InstalledEquipmentSourceType } from '@breezy/shared';
import { InstantBookingAssignmentType } from '@breezy/shared';
import { IntegratedMessageDirection } from '@breezy/shared';
import { InvoiceEventType } from '@breezy/shared';
import { InvoiceIssueWorkflow } from '@breezy/shared';
import { InvoiceStatuses } from '@breezy/shared';
import { InvoiceTermV2 } from '@breezy/shared';
import { InvoiceV2Status } from '@breezy/shared';
import { JobClass } from '@breezy/shared';
import { JobLeadAdditionalMetadata } from '@breezy/shared';
import { JobLeadEquipmentTypeArray } from '@breezy/shared';
import { JobLeadEstimateType } from '@breezy/shared';
import { JobLeadStatus } from '@breezy/shared';
import { JobLifecycleStage } from '@breezy/shared';
import { JobToEquipmentRelationshipType } from '@breezy/shared';
import { MaintenancePlanDiscountArray } from '@breezy/shared';
import { MaintenancePlanPaymentInterval } from '@breezy/shared';
import { MaintenancePlanStatus } from '@breezy/shared';
import { MaintenancePlanVisitConfigArray } from '@breezy/shared';
import { MustacheTemplate } from '@breezy/shared';
import { NotificationPreferenceType } from '@breezy/shared';
import { OnlineBookingEarliestAvailableTime } from '@breezy/shared';
import { OnlineBookingLatestAvailableTime } from '@breezy/shared';
import { OnlineBookingServiceType } from '@breezy/shared';
import { OnlineBookingType } from '@breezy/shared';
import { PaymentMethod } from '@breezy/shared';
import { PhoneNumberType } from '@breezy/shared';
import { PricebookDataSchemaVersion } from '@breezy/shared';
import { PricebookItemTypeEnum } from '@breezy/shared';
import { ReminderFrequency } from '@breezy/shared';
import { ReviewType } from '@breezy/shared';
import { RoleId } from '@breezy/shared';
import { ScheduleDetails } from '@breezy/shared';
import { SchedulingCapability } from '@breezy/shared';
import { SpecialLifecycleStatus } from '@breezy/shared';
import { TaxRoundingStrategy } from '@breezy/shared';
import { TimeZoneId } from '@breezy/shared';
import { VisitStatus } from '@breezy/shared';
import { IsoDateString, LocalDateString, LocalTimeString, StringLikeComparisonExp, IntLikeComparisonExp, GeometryLikeComparisonExp, GeographyLikeComparisonExp, JsonbLikeComparisonExp } from '@breezy/shared'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
type HtmlStringComparisonExp = StringLikeComparisonExp<HtmlString>
type JobLifecycleStageComparisonExp = StringLikeComparisonExp<JobLifecycleStage>
type SpecialLifecycleStatusComparisonExp = StringLikeComparisonExp<SpecialLifecycleStatus>
type RoleIdComparisonExp = StringLikeComparisonExp<RoleId>
type SchedulingCapabilityComparisonExp = StringLikeComparisonExp<SchedulingCapability>
type PhoneNumberTypeComparisonExp = StringLikeComparisonExp<PhoneNumberType>
type EquipmentTypeComparisonExp = StringLikeComparisonExp<EquipmentType>
type JobToEquipmentRelationshipTypeComparisonExp = StringLikeComparisonExp<JobToEquipmentRelationshipType>
type AppointmentTypeComparisonExp = StringLikeComparisonExp<AppointmentType>
type AppointmentNotificationTypeComparisonExp = StringLikeComparisonExp<AppointmentNotificationType>
type TimeZoneIdComparisonExp = StringLikeComparisonExp<TimeZoneId>
type EstimateV2StatusComparisonExp = StringLikeComparisonExp<EstimateV2Status>
type DynamicPricingTypeComparisonExp = StringLikeComparisonExp<DynamicPricingType>
type DiscountTypeComparisonExp = StringLikeComparisonExp<DiscountType>
type CartItemTypeComparisonExp = StringLikeComparisonExp<CartItemType>
type CartItemVariantComparisonExp = StringLikeComparisonExp<CartItemVariant>
type NotificationPreferenceTypeComparisonExp = StringLikeComparisonExp<NotificationPreferenceType>
type PricebookItemTypeEnumComparisonExp = StringLikeComparisonExp<PricebookItemTypeEnum>
type PricebookDataSchemaVersionComparisonExp = IntLikeComparisonExp<PricebookDataSchemaVersion>
type FileStorageStrategyComparisonExp = StringLikeComparisonExp<FileStorageStrategy>
type FileMetadataComparisonExp = JsonbLikeComparisonExp<FileMetadata>
type ReminderFrequencyComparisonExp = StringLikeComparisonExp<ReminderFrequency>
type ReviewTypeComparisonExp = StringLikeComparisonExp<ReviewType>
type GeoComparisonExp = GeographyLikeComparisonExp<Geo>
type InvoiceStatusesComparisonExp = StringLikeComparisonExp<InvoiceStatuses>
type IntegratedMessageDirectionComparisonExp = StringLikeComparisonExp<IntegratedMessageDirection>
type AccountTypeComparisonExp = StringLikeComparisonExp<AccountType>
type InvoiceTermV2ComparisonExp = StringLikeComparisonExp<InvoiceTermV2>
type InvoiceV2StatusComparisonExp = StringLikeComparisonExp<InvoiceV2Status>
type InvoiceEventTypeComparisonExp = StringLikeComparisonExp<InvoiceEventType>
type EntitlementTypeComparisonExp = StringLikeComparisonExp<EntitlementType>
type AttributionLinkingStrategyComparisonExp = StringLikeComparisonExp<AttributionLinkingStrategy>
type PaymentMethodComparisonExp = StringLikeComparisonExp<PaymentMethod>
type InstalledEquipmentSourceTypeComparisonExp = StringLikeComparisonExp<InstalledEquipmentSourceType>
type MaintenancePlanStatusComparisonExp = StringLikeComparisonExp<MaintenancePlanStatus>
type CreditRecordArrayComparisonExp = JsonbLikeComparisonExp<CreditRecordArray>
type MaintenancePlanDiscountArrayComparisonExp = JsonbLikeComparisonExp<MaintenancePlanDiscountArray>
type GuidArrayComparisonExp = JsonbLikeComparisonExp<GuidArray>
type MaintenancePlanPaymentIntervalComparisonExp = StringLikeComparisonExp<MaintenancePlanPaymentInterval>
type TaxRoundingStrategyComparisonExp = StringLikeComparisonExp<TaxRoundingStrategy>
type MaintenancePlanVisitConfigArrayComparisonExp = JsonbLikeComparisonExp<MaintenancePlanVisitConfigArray>
type VisitStatusComparisonExp = StringLikeComparisonExp<VisitStatus>
type AccountTypeArrayComparisonExp = JsonbLikeComparisonExp<AccountTypeArray>
type AppointmentChecklistInstanceChecklistComparisonExp = JsonbLikeComparisonExp<AppointmentChecklistInstanceChecklist>
type JobLeadStatusComparisonExp = StringLikeComparisonExp<JobLeadStatus>
type JobLeadAdditionalMetadataComparisonExp = JsonbLikeComparisonExp<JobLeadAdditionalMetadata>
type OnlineBookingServiceTypeComparisonExp = StringLikeComparisonExp<OnlineBookingServiceType>
type JobLeadEquipmentTypeArrayComparisonExp = JsonbLikeComparisonExp<JobLeadEquipmentTypeArray>
type JobLeadEstimateTypeComparisonExp = StringLikeComparisonExp<JobLeadEstimateType>
type EquipmentTypeArrayComparisonExp = JsonbLikeComparisonExp<EquipmentTypeArray>
type CompanyLineItemVisibilityComparisonExp = StringLikeComparisonExp<CompanyLineItemVisibility>
type MustacheTemplateComparisonExp = StringLikeComparisonExp<MustacheTemplate>
type InvoiceIssueWorkflowComparisonExp = StringLikeComparisonExp<InvoiceIssueWorkflow>
type OnlineBookingTypeComparisonExp = StringLikeComparisonExp<OnlineBookingType>
type OnlineBookingEarliestAvailableTimeComparisonExp = StringLikeComparisonExp<OnlineBookingEarliestAvailableTime>
type OnlineBookingLatestAvailableTimeComparisonExp = StringLikeComparisonExp<OnlineBookingLatestAvailableTime>
type InstantBookingAssignmentTypeComparisonExp = StringLikeComparisonExp<InstantBookingAssignmentType>
type DayOfTheWeekComparisonExp = StringLikeComparisonExp<DayOfTheWeek>
type JobClassComparisonExp = StringLikeComparisonExp<JobClass>
type EstimateTemplateMessagePresetComparisonExp = StringLikeComparisonExp<EstimateTemplateMessagePreset>
type EmbeddedReportTypeComparisonExp = StringLikeComparisonExp<EmbeddedReportType>
type EmbeddedReportCategoryComparisonExp = StringLikeComparisonExp<EmbeddedReportCategory>
type EmbeddedReportAccessControlTypeComparisonExp = StringLikeComparisonExp<EmbeddedReportAccessControlType>
type EmbeddedReportingPulseScheduleTypeComparisonExp = StringLikeComparisonExp<EmbeddedReportingPulseScheduleType>
type ScheduleDetailsComparisonExp = JsonbLikeComparisonExp<ScheduleDetails>
type EmbeddedReportingPulseRecipientArrayComparisonExp = JsonbLikeComparisonExp<EmbeddedReportingPulseRecipientArray>
type CustomerCommunicationTemplateNameComparisonExp = StringLikeComparisonExp<CustomerCommunicationTemplateName>
type CustomerCommunicationTemplateTypeComparisonExp = StringLikeComparisonExp<CustomerCommunicationTemplateType>
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AccountType: AccountType;
  AccountTypeArray: AccountTypeArray;
  AccountTypeArrayComparisonExp: AccountTypeArrayComparisonExp;
  AccountTypeComparisonExp: AccountTypeComparisonExp;
  AppointmentChecklistInstanceChecklist: AppointmentChecklistInstanceChecklist;
  AppointmentChecklistInstanceChecklistComparisonExp: AppointmentChecklistInstanceChecklistComparisonExp;
  AppointmentNotificationType: AppointmentNotificationType;
  AppointmentNotificationTypeComparisonExp: AppointmentNotificationTypeComparisonExp;
  AppointmentType: AppointmentType;
  AppointmentTypeComparisonExp: AppointmentTypeComparisonExp;
  AttributionLinkingStrategy: AttributionLinkingStrategy;
  AttributionLinkingStrategyComparisonExp: AttributionLinkingStrategyComparisonExp;
  CartItemType: CartItemType;
  CartItemTypeComparisonExp: CartItemTypeComparisonExp;
  CartItemVariant: CartItemVariant;
  CartItemVariantComparisonExp: CartItemVariantComparisonExp;
  CompanyLineItemVisibility: CompanyLineItemVisibility;
  CompanyLineItemVisibilityComparisonExp: CompanyLineItemVisibilityComparisonExp;
  CreditRecordArray: CreditRecordArray;
  CreditRecordArrayComparisonExp: CreditRecordArrayComparisonExp;
  CustomerCommunicationTemplateName: CustomerCommunicationTemplateName;
  CustomerCommunicationTemplateNameComparisonExp: CustomerCommunicationTemplateNameComparisonExp;
  CustomerCommunicationTemplateType: CustomerCommunicationTemplateType;
  CustomerCommunicationTemplateTypeComparisonExp: CustomerCommunicationTemplateTypeComparisonExp;
  DayOfTheWeek: DayOfTheWeek;
  DayOfTheWeekComparisonExp: DayOfTheWeekComparisonExp;
  DiscountType: DiscountType;
  DiscountTypeComparisonExp: DiscountTypeComparisonExp;
  DynamicPricingType: DynamicPricingType;
  DynamicPricingTypeComparisonExp: DynamicPricingTypeComparisonExp;
  EmbeddedReportAccessControlType: EmbeddedReportAccessControlType;
  EmbeddedReportAccessControlTypeComparisonExp: EmbeddedReportAccessControlTypeComparisonExp;
  EmbeddedReportCategory: EmbeddedReportCategory;
  EmbeddedReportCategoryComparisonExp: EmbeddedReportCategoryComparisonExp;
  EmbeddedReportType: EmbeddedReportType;
  EmbeddedReportTypeComparisonExp: EmbeddedReportTypeComparisonExp;
  EmbeddedReportingPulseRecipientArray: EmbeddedReportingPulseRecipientArray;
  EmbeddedReportingPulseRecipientArrayComparisonExp: EmbeddedReportingPulseRecipientArrayComparisonExp;
  EmbeddedReportingPulseScheduleType: EmbeddedReportingPulseScheduleType;
  EmbeddedReportingPulseScheduleTypeComparisonExp: EmbeddedReportingPulseScheduleTypeComparisonExp;
  EntitlementType: EntitlementType;
  EntitlementTypeComparisonExp: EntitlementTypeComparisonExp;
  EquipmentType: EquipmentType;
  EquipmentTypeArray: EquipmentTypeArray;
  EquipmentTypeArrayComparisonExp: EquipmentTypeArrayComparisonExp;
  EquipmentTypeComparisonExp: EquipmentTypeComparisonExp;
  EstimateTemplateMessagePreset: EstimateTemplateMessagePreset;
  EstimateTemplateMessagePresetComparisonExp: EstimateTemplateMessagePresetComparisonExp;
  EstimateV2Status: EstimateV2Status;
  EstimateV2StatusComparisonExp: EstimateV2StatusComparisonExp;
  FileMetadata: FileMetadata;
  FileMetadataComparisonExp: FileMetadataComparisonExp;
  FileStorageStrategy: FileStorageStrategy;
  FileStorageStrategyComparisonExp: FileStorageStrategyComparisonExp;
  Geo: Geo;
  GeoComparisonExp: GeoComparisonExp;
  GuidArray: GuidArray;
  GuidArrayComparisonExp: GuidArrayComparisonExp;
  HtmlString: HtmlString;
  HtmlStringComparisonExp: HtmlStringComparisonExp;
  InstalledEquipmentSourceType: InstalledEquipmentSourceType;
  InstalledEquipmentSourceTypeComparisonExp: InstalledEquipmentSourceTypeComparisonExp;
  InstantBookingAssignmentType: InstantBookingAssignmentType;
  InstantBookingAssignmentTypeComparisonExp: InstantBookingAssignmentTypeComparisonExp;
  IntegratedMessageDirection: IntegratedMessageDirection;
  IntegratedMessageDirectionComparisonExp: IntegratedMessageDirectionComparisonExp;
  InvoiceEventType: InvoiceEventType;
  InvoiceEventTypeComparisonExp: InvoiceEventTypeComparisonExp;
  InvoiceIssueWorkflow: InvoiceIssueWorkflow;
  InvoiceIssueWorkflowComparisonExp: InvoiceIssueWorkflowComparisonExp;
  InvoiceStatuses: InvoiceStatuses;
  InvoiceStatusesComparisonExp: InvoiceStatusesComparisonExp;
  InvoiceTermV2: InvoiceTermV2;
  InvoiceTermV2ComparisonExp: InvoiceTermV2ComparisonExp;
  InvoiceV2Status: InvoiceV2Status;
  InvoiceV2StatusComparisonExp: InvoiceV2StatusComparisonExp;
  JobClass: JobClass;
  JobClassComparisonExp: JobClassComparisonExp;
  JobLeadAdditionalMetadata: JobLeadAdditionalMetadata;
  JobLeadAdditionalMetadataComparisonExp: JobLeadAdditionalMetadataComparisonExp;
  JobLeadEquipmentTypeArray: JobLeadEquipmentTypeArray;
  JobLeadEquipmentTypeArrayComparisonExp: JobLeadEquipmentTypeArrayComparisonExp;
  JobLeadEstimateType: JobLeadEstimateType;
  JobLeadEstimateTypeComparisonExp: JobLeadEstimateTypeComparisonExp;
  JobLeadStatus: JobLeadStatus;
  JobLeadStatusComparisonExp: JobLeadStatusComparisonExp;
  JobLifecycleStage: JobLifecycleStage;
  JobLifecycleStageComparisonExp: JobLifecycleStageComparisonExp;
  JobToEquipmentRelationshipType: JobToEquipmentRelationshipType;
  JobToEquipmentRelationshipTypeComparisonExp: JobToEquipmentRelationshipTypeComparisonExp;
  MaintenancePlanDiscountArray: MaintenancePlanDiscountArray;
  MaintenancePlanDiscountArrayComparisonExp: MaintenancePlanDiscountArrayComparisonExp;
  MaintenancePlanPaymentInterval: MaintenancePlanPaymentInterval;
  MaintenancePlanPaymentIntervalComparisonExp: MaintenancePlanPaymentIntervalComparisonExp;
  MaintenancePlanStatus: MaintenancePlanStatus;
  MaintenancePlanStatusComparisonExp: MaintenancePlanStatusComparisonExp;
  MaintenancePlanVisitConfigArray: MaintenancePlanVisitConfigArray;
  MaintenancePlanVisitConfigArrayComparisonExp: MaintenancePlanVisitConfigArrayComparisonExp;
  MustacheTemplate: MustacheTemplate;
  MustacheTemplateComparisonExp: MustacheTemplateComparisonExp;
  NotificationPreferenceType: NotificationPreferenceType;
  NotificationPreferenceTypeComparisonExp: NotificationPreferenceTypeComparisonExp;
  OnlineBookingEarliestAvailableTime: OnlineBookingEarliestAvailableTime;
  OnlineBookingEarliestAvailableTimeComparisonExp: OnlineBookingEarliestAvailableTimeComparisonExp;
  OnlineBookingLatestAvailableTime: OnlineBookingLatestAvailableTime;
  OnlineBookingLatestAvailableTimeComparisonExp: OnlineBookingLatestAvailableTimeComparisonExp;
  OnlineBookingServiceType: OnlineBookingServiceType;
  OnlineBookingServiceTypeComparisonExp: OnlineBookingServiceTypeComparisonExp;
  OnlineBookingType: OnlineBookingType;
  OnlineBookingTypeComparisonExp: OnlineBookingTypeComparisonExp;
  PaymentMethod: PaymentMethod;
  PaymentMethodComparisonExp: PaymentMethodComparisonExp;
  PhoneNumberType: PhoneNumberType;
  PhoneNumberTypeComparisonExp: PhoneNumberTypeComparisonExp;
  PricebookDataSchemaVersion: PricebookDataSchemaVersion;
  PricebookDataSchemaVersionComparisonExp: PricebookDataSchemaVersionComparisonExp;
  PricebookItemTypeEnum: PricebookItemTypeEnum;
  PricebookItemTypeEnumComparisonExp: PricebookItemTypeEnumComparisonExp;
  ReminderFrequency: ReminderFrequency;
  ReminderFrequencyComparisonExp: ReminderFrequencyComparisonExp;
  ReviewType: ReviewType;
  ReviewTypeComparisonExp: ReviewTypeComparisonExp;
  RoleId: RoleId;
  RoleIdComparisonExp: RoleIdComparisonExp;
  ScheduleDetails: ScheduleDetails;
  ScheduleDetailsComparisonExp: ScheduleDetailsComparisonExp;
  SchedulingCapability: SchedulingCapability;
  SchedulingCapabilityComparisonExp: SchedulingCapabilityComparisonExp;
  SpecialLifecycleStatus: SpecialLifecycleStatus;
  SpecialLifecycleStatusComparisonExp: SpecialLifecycleStatusComparisonExp;
  TaxRoundingStrategy: TaxRoundingStrategy;
  TaxRoundingStrategyComparisonExp: TaxRoundingStrategyComparisonExp;
  TimeZoneId: TimeZoneId;
  TimeZoneIdComparisonExp: TimeZoneIdComparisonExp;
  VisitStatus: VisitStatus;
  VisitStatusComparisonExp: VisitStatusComparisonExp;
  bigint: number;
  date: LocalDateString;
  float8: number;
  geography: unknown;
  geometry: unknown;
  json: object;
  jsonb: object;
  numeric: number;
  pricebook_pricing_mode: unknown;
  smallint: number;
  time: LocalTimeString;
  timestamp: string;
  timestamptz: IsoDateString;
  uuid: string;
};

/** columns and relationships of "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfig = {
  __typename?: 'AccCartItemTypeAccountsConfig';
  accCartItemTypeAccountsConfigGuid: Scalars['uuid'];
  accountingIntegrationType: Scalars['String'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  costOfGoodsSoldAccountId?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  defaultItemIncomeAccountId: Scalars['String'];
  discountDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  equipmentItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  inventoryAssetAccountId?: Maybe<Scalars['String']>;
  laborItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  materialItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  membershipItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  serviceItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigAggregate = {
  __typename?: 'AccCartItemTypeAccountsConfigAggregate';
  aggregate?: Maybe<AccCartItemTypeAccountsConfigAggregateFields>;
  nodes: Array<AccCartItemTypeAccountsConfig>;
};

export type AccCartItemTypeAccountsConfigAggregateBoolExp = {
  count?: InputMaybe<AccCartItemTypeAccountsConfigAggregateBoolExpCount>;
};

/** aggregate fields of "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigAggregateFields = {
  __typename?: 'AccCartItemTypeAccountsConfigAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccCartItemTypeAccountsConfigMaxFields>;
  min?: Maybe<AccCartItemTypeAccountsConfigMinFields>;
};


/** aggregate fields of "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccCartItemTypeAccountsConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AccCartItemTypeAccountsConfigMaxOrderBy>;
  min?: InputMaybe<AccCartItemTypeAccountsConfigMinOrderBy>;
};

/** input type for inserting array relation for remote table "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigArrRelInsertInput = {
  data: Array<AccCartItemTypeAccountsConfigInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AccCartItemTypeAccountsConfigOnConflict>;
};

/** Boolean expression to filter rows from the table "acc_cart_item_type_accounts_config". All fields are combined with a logical 'AND'. */
export type AccCartItemTypeAccountsConfigBoolExp = {
  _and?: InputMaybe<Array<AccCartItemTypeAccountsConfigBoolExp>>;
  _not?: InputMaybe<AccCartItemTypeAccountsConfigBoolExp>;
  _or?: InputMaybe<Array<AccCartItemTypeAccountsConfigBoolExp>>;
  accCartItemTypeAccountsConfigGuid?: InputMaybe<UuidComparisonExp>;
  accountingIntegrationType?: InputMaybe<StringComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  costOfGoodsSoldAccountId?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  defaultItemIncomeAccountId?: InputMaybe<StringComparisonExp>;
  discountDefaultIncomeAccountId?: InputMaybe<StringComparisonExp>;
  equipmentItemDefaultIncomeAccountId?: InputMaybe<StringComparisonExp>;
  inventoryAssetAccountId?: InputMaybe<StringComparisonExp>;
  laborItemDefaultIncomeAccountId?: InputMaybe<StringComparisonExp>;
  materialItemDefaultIncomeAccountId?: InputMaybe<StringComparisonExp>;
  membershipItemDefaultIncomeAccountId?: InputMaybe<StringComparisonExp>;
  serviceItemDefaultIncomeAccountId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigConstraint =
  /** unique or primary key constraint on columns "accounting_integration_type", "company_guid" */
  | 'acc_cart_item_type_accounts_config_company_guid_accounting_inte'
  /** unique or primary key constraint on columns "acc_cart_item_type_accounts_config_guid" */
  | 'acc_cart_item_type_accounts_config_pkey';

/** input type for inserting data into table "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigInsertInput = {
  accCartItemTypeAccountsConfigGuid?: InputMaybe<Scalars['uuid']>;
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costOfGoodsSoldAccountId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultItemIncomeAccountId?: InputMaybe<Scalars['String']>;
  discountDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  equipmentItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  inventoryAssetAccountId?: InputMaybe<Scalars['String']>;
  laborItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  materialItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  membershipItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  serviceItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccCartItemTypeAccountsConfigMaxFields = {
  __typename?: 'AccCartItemTypeAccountsConfigMaxFields';
  accCartItemTypeAccountsConfigGuid?: Maybe<Scalars['uuid']>;
  accountingIntegrationType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  costOfGoodsSoldAccountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultItemIncomeAccountId?: Maybe<Scalars['String']>;
  discountDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  equipmentItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  inventoryAssetAccountId?: Maybe<Scalars['String']>;
  laborItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  materialItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  membershipItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  serviceItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigMaxOrderBy = {
  accCartItemTypeAccountsConfigGuid?: InputMaybe<OrderBy>;
  accountingIntegrationType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  costOfGoodsSoldAccountId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  defaultItemIncomeAccountId?: InputMaybe<OrderBy>;
  discountDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  equipmentItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  inventoryAssetAccountId?: InputMaybe<OrderBy>;
  laborItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  materialItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  membershipItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  serviceItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AccCartItemTypeAccountsConfigMinFields = {
  __typename?: 'AccCartItemTypeAccountsConfigMinFields';
  accCartItemTypeAccountsConfigGuid?: Maybe<Scalars['uuid']>;
  accountingIntegrationType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  costOfGoodsSoldAccountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultItemIncomeAccountId?: Maybe<Scalars['String']>;
  discountDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  equipmentItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  inventoryAssetAccountId?: Maybe<Scalars['String']>;
  laborItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  materialItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  membershipItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  serviceItemDefaultIncomeAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigMinOrderBy = {
  accCartItemTypeAccountsConfigGuid?: InputMaybe<OrderBy>;
  accountingIntegrationType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  costOfGoodsSoldAccountId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  defaultItemIncomeAccountId?: InputMaybe<OrderBy>;
  discountDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  equipmentItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  inventoryAssetAccountId?: InputMaybe<OrderBy>;
  laborItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  materialItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  membershipItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  serviceItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigMutationResponse = {
  __typename?: 'AccCartItemTypeAccountsConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccCartItemTypeAccountsConfig>;
};

/** on_conflict condition type for table "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigOnConflict = {
  constraint: AccCartItemTypeAccountsConfigConstraint;
  updateColumns?: Array<AccCartItemTypeAccountsConfigUpdateColumn>;
  where?: InputMaybe<AccCartItemTypeAccountsConfigBoolExp>;
};

/** Ordering options when selecting data from "acc_cart_item_type_accounts_config". */
export type AccCartItemTypeAccountsConfigOrderBy = {
  accCartItemTypeAccountsConfigGuid?: InputMaybe<OrderBy>;
  accountingIntegrationType?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  costOfGoodsSoldAccountId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  defaultItemIncomeAccountId?: InputMaybe<OrderBy>;
  discountDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  equipmentItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  inventoryAssetAccountId?: InputMaybe<OrderBy>;
  laborItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  materialItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  membershipItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  serviceItemDefaultIncomeAccountId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: acc_cart_item_type_accounts_config */
export type AccCartItemTypeAccountsConfigPkColumnsInput = {
  accCartItemTypeAccountsConfigGuid: Scalars['uuid'];
};

/** select columns of table "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigSelectColumn =
  /** column name */
  | 'accCartItemTypeAccountsConfigGuid'
  /** column name */
  | 'accountingIntegrationType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'costOfGoodsSoldAccountId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'defaultItemIncomeAccountId'
  /** column name */
  | 'discountDefaultIncomeAccountId'
  /** column name */
  | 'equipmentItemDefaultIncomeAccountId'
  /** column name */
  | 'inventoryAssetAccountId'
  /** column name */
  | 'laborItemDefaultIncomeAccountId'
  /** column name */
  | 'materialItemDefaultIncomeAccountId'
  /** column name */
  | 'membershipItemDefaultIncomeAccountId'
  /** column name */
  | 'serviceItemDefaultIncomeAccountId'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigSetInput = {
  accCartItemTypeAccountsConfigGuid?: InputMaybe<Scalars['uuid']>;
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costOfGoodsSoldAccountId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultItemIncomeAccountId?: InputMaybe<Scalars['String']>;
  discountDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  equipmentItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  inventoryAssetAccountId?: InputMaybe<Scalars['String']>;
  laborItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  materialItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  membershipItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  serviceItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccCartItemTypeAccountsConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccCartItemTypeAccountsConfigStreamCursorValueInput = {
  accCartItemTypeAccountsConfigGuid?: InputMaybe<Scalars['uuid']>;
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costOfGoodsSoldAccountId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultItemIncomeAccountId?: InputMaybe<Scalars['String']>;
  discountDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  equipmentItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  inventoryAssetAccountId?: InputMaybe<Scalars['String']>;
  laborItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  materialItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  membershipItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  serviceItemDefaultIncomeAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "acc_cart_item_type_accounts_config" */
export type AccCartItemTypeAccountsConfigUpdateColumn =
  /** column name */
  | 'accCartItemTypeAccountsConfigGuid'
  /** column name */
  | 'accountingIntegrationType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'costOfGoodsSoldAccountId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'defaultItemIncomeAccountId'
  /** column name */
  | 'discountDefaultIncomeAccountId'
  /** column name */
  | 'equipmentItemDefaultIncomeAccountId'
  /** column name */
  | 'inventoryAssetAccountId'
  /** column name */
  | 'laborItemDefaultIncomeAccountId'
  /** column name */
  | 'materialItemDefaultIncomeAccountId'
  /** column name */
  | 'membershipItemDefaultIncomeAccountId'
  /** column name */
  | 'serviceItemDefaultIncomeAccountId'
  /** column name */
  | 'updatedAt';

export type AccCartItemTypeAccountsConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccCartItemTypeAccountsConfigSetInput>;
  /** filter the rows which have to be updated */
  where: AccCartItemTypeAccountsConfigBoolExp;
};

/** columns and relationships of "acc_company_config" */
export type AccCompanyConfig = {
  __typename?: 'AccCompanyConfig';
  /** An object relationship */
  accPayoutAccountConfig?: Maybe<AccPayoutAccountsConfig>;
  /** An array relationship */
  accPayoutAccountsConfigs: Array<AccPayoutAccountsConfig>;
  /** An aggregate relationship */
  accPayoutAccountsConfigsAggregate: AccPayoutAccountsConfigAggregate;
  accountingIntegrationType?: Maybe<Scalars['String']>;
  autosyncInvoiceOnFullyPaid: Scalars['Boolean'];
  autosyncInvoiceOnIssued: Scalars['Boolean'];
  autosyncInvoiceOnPayment: Scalars['Boolean'];
  autosyncInvoiceOnVoided: Scalars['Boolean'];
  autosyncPayments: Scalars['Boolean'];
  autosyncPayouts: Scalars['Boolean'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  dynamicTaxRateCalculationEnabled: Scalars['Boolean'];
  syncBusinessUnits: Scalars['Boolean'];
  syncDiscountsAsNegativeLineItems: Scalars['Boolean'];
  syncLocationsAsQbdSubaccounts: Scalars['Boolean'];
  syncPayoutsUsingSingleItem: Scalars['Boolean'];
  syncTaxesFullIntegration: Scalars['Boolean'];
  syncUsingInventoryTracking: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "acc_company_config" */
export type AccCompanyConfigAccPayoutAccountsConfigsArgs = {
  distinctOn?: InputMaybe<Array<AccPayoutAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccPayoutAccountsConfigOrderBy>>;
  where?: InputMaybe<AccPayoutAccountsConfigBoolExp>;
};


/** columns and relationships of "acc_company_config" */
export type AccCompanyConfigAccPayoutAccountsConfigsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccPayoutAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccPayoutAccountsConfigOrderBy>>;
  where?: InputMaybe<AccPayoutAccountsConfigBoolExp>;
};

/** aggregated selection of "acc_company_config" */
export type AccCompanyConfigAggregate = {
  __typename?: 'AccCompanyConfigAggregate';
  aggregate?: Maybe<AccCompanyConfigAggregateFields>;
  nodes: Array<AccCompanyConfig>;
};

export type AccCompanyConfigAggregateBoolExp = {
  bool_and?: InputMaybe<AccCompanyConfigAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<AccCompanyConfigAggregateBoolExpBool_Or>;
  count?: InputMaybe<AccCompanyConfigAggregateBoolExpCount>;
};

/** aggregate fields of "acc_company_config" */
export type AccCompanyConfigAggregateFields = {
  __typename?: 'AccCompanyConfigAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccCompanyConfigMaxFields>;
  min?: Maybe<AccCompanyConfigMinFields>;
};


/** aggregate fields of "acc_company_config" */
export type AccCompanyConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccCompanyConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "acc_company_config" */
export type AccCompanyConfigAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AccCompanyConfigMaxOrderBy>;
  min?: InputMaybe<AccCompanyConfigMinOrderBy>;
};

/** input type for inserting array relation for remote table "acc_company_config" */
export type AccCompanyConfigArrRelInsertInput = {
  data: Array<AccCompanyConfigInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AccCompanyConfigOnConflict>;
};

/** Boolean expression to filter rows from the table "acc_company_config". All fields are combined with a logical 'AND'. */
export type AccCompanyConfigBoolExp = {
  _and?: InputMaybe<Array<AccCompanyConfigBoolExp>>;
  _not?: InputMaybe<AccCompanyConfigBoolExp>;
  _or?: InputMaybe<Array<AccCompanyConfigBoolExp>>;
  accPayoutAccountConfig?: InputMaybe<AccPayoutAccountsConfigBoolExp>;
  accPayoutAccountsConfigs?: InputMaybe<AccPayoutAccountsConfigBoolExp>;
  accPayoutAccountsConfigsAggregate?: InputMaybe<AccPayoutAccountsConfigAggregateBoolExp>;
  accountingIntegrationType?: InputMaybe<StringComparisonExp>;
  autosyncInvoiceOnFullyPaid?: InputMaybe<BooleanComparisonExp>;
  autosyncInvoiceOnIssued?: InputMaybe<BooleanComparisonExp>;
  autosyncInvoiceOnPayment?: InputMaybe<BooleanComparisonExp>;
  autosyncInvoiceOnVoided?: InputMaybe<BooleanComparisonExp>;
  autosyncPayments?: InputMaybe<BooleanComparisonExp>;
  autosyncPayouts?: InputMaybe<BooleanComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  dynamicTaxRateCalculationEnabled?: InputMaybe<BooleanComparisonExp>;
  syncBusinessUnits?: InputMaybe<BooleanComparisonExp>;
  syncDiscountsAsNegativeLineItems?: InputMaybe<BooleanComparisonExp>;
  syncLocationsAsQbdSubaccounts?: InputMaybe<BooleanComparisonExp>;
  syncPayoutsUsingSingleItem?: InputMaybe<BooleanComparisonExp>;
  syncTaxesFullIntegration?: InputMaybe<BooleanComparisonExp>;
  syncUsingInventoryTracking?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "acc_company_config" */
export type AccCompanyConfigConstraint =
  /** unique or primary key constraint on columns "accounting_integration_type", "company_guid" */
  | 'acc_company_config_company_guid_accounting_integration_type_key'
  /** unique or primary key constraint on columns "company_guid" */
  | 'acc_company_config_pkey';

/** input type for inserting data into table "acc_company_config" */
export type AccCompanyConfigInsertInput = {
  accPayoutAccountConfig?: InputMaybe<AccPayoutAccountsConfigObjRelInsertInput>;
  accPayoutAccountsConfigs?: InputMaybe<AccPayoutAccountsConfigArrRelInsertInput>;
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  autosyncInvoiceOnFullyPaid?: InputMaybe<Scalars['Boolean']>;
  autosyncInvoiceOnIssued?: InputMaybe<Scalars['Boolean']>;
  autosyncInvoiceOnPayment?: InputMaybe<Scalars['Boolean']>;
  autosyncInvoiceOnVoided?: InputMaybe<Scalars['Boolean']>;
  autosyncPayments?: InputMaybe<Scalars['Boolean']>;
  autosyncPayouts?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dynamicTaxRateCalculationEnabled?: InputMaybe<Scalars['Boolean']>;
  syncBusinessUnits?: InputMaybe<Scalars['Boolean']>;
  syncDiscountsAsNegativeLineItems?: InputMaybe<Scalars['Boolean']>;
  syncLocationsAsQbdSubaccounts?: InputMaybe<Scalars['Boolean']>;
  syncPayoutsUsingSingleItem?: InputMaybe<Scalars['Boolean']>;
  syncTaxesFullIntegration?: InputMaybe<Scalars['Boolean']>;
  syncUsingInventoryTracking?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccCompanyConfigMaxFields = {
  __typename?: 'AccCompanyConfigMaxFields';
  accountingIntegrationType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "acc_company_config" */
export type AccCompanyConfigMaxOrderBy = {
  accountingIntegrationType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AccCompanyConfigMinFields = {
  __typename?: 'AccCompanyConfigMinFields';
  accountingIntegrationType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "acc_company_config" */
export type AccCompanyConfigMinOrderBy = {
  accountingIntegrationType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "acc_company_config" */
export type AccCompanyConfigMutationResponse = {
  __typename?: 'AccCompanyConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccCompanyConfig>;
};

/** input type for inserting object relation for remote table "acc_company_config" */
export type AccCompanyConfigObjRelInsertInput = {
  data: AccCompanyConfigInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AccCompanyConfigOnConflict>;
};

/** on_conflict condition type for table "acc_company_config" */
export type AccCompanyConfigOnConflict = {
  constraint: AccCompanyConfigConstraint;
  updateColumns?: Array<AccCompanyConfigUpdateColumn>;
  where?: InputMaybe<AccCompanyConfigBoolExp>;
};

/** Ordering options when selecting data from "acc_company_config". */
export type AccCompanyConfigOrderBy = {
  accPayoutAccountConfig?: InputMaybe<AccPayoutAccountsConfigOrderBy>;
  accPayoutAccountsConfigsAggregate?: InputMaybe<AccPayoutAccountsConfigAggregateOrderBy>;
  accountingIntegrationType?: InputMaybe<OrderBy>;
  autosyncInvoiceOnFullyPaid?: InputMaybe<OrderBy>;
  autosyncInvoiceOnIssued?: InputMaybe<OrderBy>;
  autosyncInvoiceOnPayment?: InputMaybe<OrderBy>;
  autosyncInvoiceOnVoided?: InputMaybe<OrderBy>;
  autosyncPayments?: InputMaybe<OrderBy>;
  autosyncPayouts?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  dynamicTaxRateCalculationEnabled?: InputMaybe<OrderBy>;
  syncBusinessUnits?: InputMaybe<OrderBy>;
  syncDiscountsAsNegativeLineItems?: InputMaybe<OrderBy>;
  syncLocationsAsQbdSubaccounts?: InputMaybe<OrderBy>;
  syncPayoutsUsingSingleItem?: InputMaybe<OrderBy>;
  syncTaxesFullIntegration?: InputMaybe<OrderBy>;
  syncUsingInventoryTracking?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: acc_company_config */
export type AccCompanyConfigPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "acc_company_config" */
export type AccCompanyConfigSelectColumn =
  /** column name */
  | 'accountingIntegrationType'
  /** column name */
  | 'autosyncInvoiceOnFullyPaid'
  /** column name */
  | 'autosyncInvoiceOnIssued'
  /** column name */
  | 'autosyncInvoiceOnPayment'
  /** column name */
  | 'autosyncInvoiceOnVoided'
  /** column name */
  | 'autosyncPayments'
  /** column name */
  | 'autosyncPayouts'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dynamicTaxRateCalculationEnabled'
  /** column name */
  | 'syncBusinessUnits'
  /** column name */
  | 'syncDiscountsAsNegativeLineItems'
  /** column name */
  | 'syncLocationsAsQbdSubaccounts'
  /** column name */
  | 'syncPayoutsUsingSingleItem'
  /** column name */
  | 'syncTaxesFullIntegration'
  /** column name */
  | 'syncUsingInventoryTracking'
  /** column name */
  | 'updatedAt';

/** select "accCompanyConfigAggregateBoolExpBool_andArgumentsColumns" columns of table "acc_company_config" */
export type AccCompanyConfigSelectColumnAccCompanyConfigAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'autosyncInvoiceOnFullyPaid'
  /** column name */
  | 'autosyncInvoiceOnIssued'
  /** column name */
  | 'autosyncInvoiceOnPayment'
  /** column name */
  | 'autosyncInvoiceOnVoided'
  /** column name */
  | 'autosyncPayments'
  /** column name */
  | 'autosyncPayouts'
  /** column name */
  | 'dynamicTaxRateCalculationEnabled'
  /** column name */
  | 'syncBusinessUnits'
  /** column name */
  | 'syncDiscountsAsNegativeLineItems'
  /** column name */
  | 'syncLocationsAsQbdSubaccounts'
  /** column name */
  | 'syncPayoutsUsingSingleItem'
  /** column name */
  | 'syncTaxesFullIntegration'
  /** column name */
  | 'syncUsingInventoryTracking';

/** select "accCompanyConfigAggregateBoolExpBool_orArgumentsColumns" columns of table "acc_company_config" */
export type AccCompanyConfigSelectColumnAccCompanyConfigAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'autosyncInvoiceOnFullyPaid'
  /** column name */
  | 'autosyncInvoiceOnIssued'
  /** column name */
  | 'autosyncInvoiceOnPayment'
  /** column name */
  | 'autosyncInvoiceOnVoided'
  /** column name */
  | 'autosyncPayments'
  /** column name */
  | 'autosyncPayouts'
  /** column name */
  | 'dynamicTaxRateCalculationEnabled'
  /** column name */
  | 'syncBusinessUnits'
  /** column name */
  | 'syncDiscountsAsNegativeLineItems'
  /** column name */
  | 'syncLocationsAsQbdSubaccounts'
  /** column name */
  | 'syncPayoutsUsingSingleItem'
  /** column name */
  | 'syncTaxesFullIntegration'
  /** column name */
  | 'syncUsingInventoryTracking';

/** input type for updating data in table "acc_company_config" */
export type AccCompanyConfigSetInput = {
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  autosyncInvoiceOnFullyPaid?: InputMaybe<Scalars['Boolean']>;
  autosyncInvoiceOnIssued?: InputMaybe<Scalars['Boolean']>;
  autosyncInvoiceOnPayment?: InputMaybe<Scalars['Boolean']>;
  autosyncInvoiceOnVoided?: InputMaybe<Scalars['Boolean']>;
  autosyncPayments?: InputMaybe<Scalars['Boolean']>;
  autosyncPayouts?: InputMaybe<Scalars['Boolean']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dynamicTaxRateCalculationEnabled?: InputMaybe<Scalars['Boolean']>;
  syncBusinessUnits?: InputMaybe<Scalars['Boolean']>;
  syncDiscountsAsNegativeLineItems?: InputMaybe<Scalars['Boolean']>;
  syncLocationsAsQbdSubaccounts?: InputMaybe<Scalars['Boolean']>;
  syncPayoutsUsingSingleItem?: InputMaybe<Scalars['Boolean']>;
  syncTaxesFullIntegration?: InputMaybe<Scalars['Boolean']>;
  syncUsingInventoryTracking?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "acc_company_config" */
export type AccCompanyConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccCompanyConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccCompanyConfigStreamCursorValueInput = {
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  autosyncInvoiceOnFullyPaid?: InputMaybe<Scalars['Boolean']>;
  autosyncInvoiceOnIssued?: InputMaybe<Scalars['Boolean']>;
  autosyncInvoiceOnPayment?: InputMaybe<Scalars['Boolean']>;
  autosyncInvoiceOnVoided?: InputMaybe<Scalars['Boolean']>;
  autosyncPayments?: InputMaybe<Scalars['Boolean']>;
  autosyncPayouts?: InputMaybe<Scalars['Boolean']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dynamicTaxRateCalculationEnabled?: InputMaybe<Scalars['Boolean']>;
  syncBusinessUnits?: InputMaybe<Scalars['Boolean']>;
  syncDiscountsAsNegativeLineItems?: InputMaybe<Scalars['Boolean']>;
  syncLocationsAsQbdSubaccounts?: InputMaybe<Scalars['Boolean']>;
  syncPayoutsUsingSingleItem?: InputMaybe<Scalars['Boolean']>;
  syncTaxesFullIntegration?: InputMaybe<Scalars['Boolean']>;
  syncUsingInventoryTracking?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "acc_company_config" */
export type AccCompanyConfigUpdateColumn =
  /** column name */
  | 'accountingIntegrationType'
  /** column name */
  | 'autosyncInvoiceOnFullyPaid'
  /** column name */
  | 'autosyncInvoiceOnIssued'
  /** column name */
  | 'autosyncInvoiceOnPayment'
  /** column name */
  | 'autosyncInvoiceOnVoided'
  /** column name */
  | 'autosyncPayments'
  /** column name */
  | 'autosyncPayouts'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dynamicTaxRateCalculationEnabled'
  /** column name */
  | 'syncBusinessUnits'
  /** column name */
  | 'syncDiscountsAsNegativeLineItems'
  /** column name */
  | 'syncLocationsAsQbdSubaccounts'
  /** column name */
  | 'syncPayoutsUsingSingleItem'
  /** column name */
  | 'syncTaxesFullIntegration'
  /** column name */
  | 'syncUsingInventoryTracking'
  /** column name */
  | 'updatedAt';

export type AccCompanyConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccCompanyConfigSetInput>;
  /** filter the rows which have to be updated */
  where: AccCompanyConfigBoolExp;
};

/** columns and relationships of "acc_payout_accounts_config" */
export type AccPayoutAccountsConfig = {
  __typename?: 'AccPayoutAccountsConfig';
  accPayoutAccountsConfigId: Scalars['uuid'];
  accountingIntegrationType: Scalars['String'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  payoutDepositAccountId?: Maybe<Scalars['String']>;
  payoutFeesAccountId?: Maybe<Scalars['String']>;
  payoutPaymentProcessorBalanceAccountId?: Maybe<Scalars['String']>;
  payoutRefundsAccountId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigAggregate = {
  __typename?: 'AccPayoutAccountsConfigAggregate';
  aggregate?: Maybe<AccPayoutAccountsConfigAggregateFields>;
  nodes: Array<AccPayoutAccountsConfig>;
};

export type AccPayoutAccountsConfigAggregateBoolExp = {
  count?: InputMaybe<AccPayoutAccountsConfigAggregateBoolExpCount>;
};

/** aggregate fields of "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigAggregateFields = {
  __typename?: 'AccPayoutAccountsConfigAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccPayoutAccountsConfigMaxFields>;
  min?: Maybe<AccPayoutAccountsConfigMinFields>;
};


/** aggregate fields of "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccPayoutAccountsConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AccPayoutAccountsConfigMaxOrderBy>;
  min?: InputMaybe<AccPayoutAccountsConfigMinOrderBy>;
};

/** input type for inserting array relation for remote table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigArrRelInsertInput = {
  data: Array<AccPayoutAccountsConfigInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AccPayoutAccountsConfigOnConflict>;
};

/** Boolean expression to filter rows from the table "acc_payout_accounts_config". All fields are combined with a logical 'AND'. */
export type AccPayoutAccountsConfigBoolExp = {
  _and?: InputMaybe<Array<AccPayoutAccountsConfigBoolExp>>;
  _not?: InputMaybe<AccPayoutAccountsConfigBoolExp>;
  _or?: InputMaybe<Array<AccPayoutAccountsConfigBoolExp>>;
  accPayoutAccountsConfigId?: InputMaybe<UuidComparisonExp>;
  accountingIntegrationType?: InputMaybe<StringComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  payoutDepositAccountId?: InputMaybe<StringComparisonExp>;
  payoutFeesAccountId?: InputMaybe<StringComparisonExp>;
  payoutPaymentProcessorBalanceAccountId?: InputMaybe<StringComparisonExp>;
  payoutRefundsAccountId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigConstraint =
  /** unique or primary key constraint on columns "accounting_integration_type", "company_guid" */
  | 'acc_payout_accounts_config_company_guid_accounting_integrat_key'
  /** unique or primary key constraint on columns "acc_payout_accounts_config_id" */
  | 'acc_payout_accounts_config_pkey';

/** input type for inserting data into table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigInsertInput = {
  accPayoutAccountsConfigId?: InputMaybe<Scalars['uuid']>;
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  payoutDepositAccountId?: InputMaybe<Scalars['String']>;
  payoutFeesAccountId?: InputMaybe<Scalars['String']>;
  payoutPaymentProcessorBalanceAccountId?: InputMaybe<Scalars['String']>;
  payoutRefundsAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccPayoutAccountsConfigMaxFields = {
  __typename?: 'AccPayoutAccountsConfigMaxFields';
  accPayoutAccountsConfigId?: Maybe<Scalars['uuid']>;
  accountingIntegrationType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  payoutDepositAccountId?: Maybe<Scalars['String']>;
  payoutFeesAccountId?: Maybe<Scalars['String']>;
  payoutPaymentProcessorBalanceAccountId?: Maybe<Scalars['String']>;
  payoutRefundsAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigMaxOrderBy = {
  accPayoutAccountsConfigId?: InputMaybe<OrderBy>;
  accountingIntegrationType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  payoutDepositAccountId?: InputMaybe<OrderBy>;
  payoutFeesAccountId?: InputMaybe<OrderBy>;
  payoutPaymentProcessorBalanceAccountId?: InputMaybe<OrderBy>;
  payoutRefundsAccountId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AccPayoutAccountsConfigMinFields = {
  __typename?: 'AccPayoutAccountsConfigMinFields';
  accPayoutAccountsConfigId?: Maybe<Scalars['uuid']>;
  accountingIntegrationType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  payoutDepositAccountId?: Maybe<Scalars['String']>;
  payoutFeesAccountId?: Maybe<Scalars['String']>;
  payoutPaymentProcessorBalanceAccountId?: Maybe<Scalars['String']>;
  payoutRefundsAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigMinOrderBy = {
  accPayoutAccountsConfigId?: InputMaybe<OrderBy>;
  accountingIntegrationType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  payoutDepositAccountId?: InputMaybe<OrderBy>;
  payoutFeesAccountId?: InputMaybe<OrderBy>;
  payoutPaymentProcessorBalanceAccountId?: InputMaybe<OrderBy>;
  payoutRefundsAccountId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigMutationResponse = {
  __typename?: 'AccPayoutAccountsConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccPayoutAccountsConfig>;
};

/** input type for inserting object relation for remote table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigObjRelInsertInput = {
  data: AccPayoutAccountsConfigInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AccPayoutAccountsConfigOnConflict>;
};

/** on_conflict condition type for table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigOnConflict = {
  constraint: AccPayoutAccountsConfigConstraint;
  updateColumns?: Array<AccPayoutAccountsConfigUpdateColumn>;
  where?: InputMaybe<AccPayoutAccountsConfigBoolExp>;
};

/** Ordering options when selecting data from "acc_payout_accounts_config". */
export type AccPayoutAccountsConfigOrderBy = {
  accPayoutAccountsConfigId?: InputMaybe<OrderBy>;
  accountingIntegrationType?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  payoutDepositAccountId?: InputMaybe<OrderBy>;
  payoutFeesAccountId?: InputMaybe<OrderBy>;
  payoutPaymentProcessorBalanceAccountId?: InputMaybe<OrderBy>;
  payoutRefundsAccountId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: acc_payout_accounts_config */
export type AccPayoutAccountsConfigPkColumnsInput = {
  accPayoutAccountsConfigId: Scalars['uuid'];
};

/** select columns of table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigSelectColumn =
  /** column name */
  | 'accPayoutAccountsConfigId'
  /** column name */
  | 'accountingIntegrationType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'payoutDepositAccountId'
  /** column name */
  | 'payoutFeesAccountId'
  /** column name */
  | 'payoutPaymentProcessorBalanceAccountId'
  /** column name */
  | 'payoutRefundsAccountId'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigSetInput = {
  accPayoutAccountsConfigId?: InputMaybe<Scalars['uuid']>;
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  payoutDepositAccountId?: InputMaybe<Scalars['String']>;
  payoutFeesAccountId?: InputMaybe<Scalars['String']>;
  payoutPaymentProcessorBalanceAccountId?: InputMaybe<Scalars['String']>;
  payoutRefundsAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccPayoutAccountsConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccPayoutAccountsConfigStreamCursorValueInput = {
  accPayoutAccountsConfigId?: InputMaybe<Scalars['uuid']>;
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  payoutDepositAccountId?: InputMaybe<Scalars['String']>;
  payoutFeesAccountId?: InputMaybe<Scalars['String']>;
  payoutPaymentProcessorBalanceAccountId?: InputMaybe<Scalars['String']>;
  payoutRefundsAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "acc_payout_accounts_config" */
export type AccPayoutAccountsConfigUpdateColumn =
  /** column name */
  | 'accPayoutAccountsConfigId'
  /** column name */
  | 'accountingIntegrationType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'payoutDepositAccountId'
  /** column name */
  | 'payoutFeesAccountId'
  /** column name */
  | 'payoutPaymentProcessorBalanceAccountId'
  /** column name */
  | 'payoutRefundsAccountId'
  /** column name */
  | 'updatedAt';

export type AccPayoutAccountsConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccPayoutAccountsConfigSetInput>;
  /** filter the rows which have to be updated */
  where: AccPayoutAccountsConfigBoolExp;
};

/** columns and relationships of "acc_qbd_conductor_config" */
export type AccQbdConductorConfig = {
  __typename?: 'AccQbdConductorConfig';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  conductorEndUserId: Scalars['String'];
};

/** aggregated selection of "acc_qbd_conductor_config" */
export type AccQbdConductorConfigAggregate = {
  __typename?: 'AccQbdConductorConfigAggregate';
  aggregate?: Maybe<AccQbdConductorConfigAggregateFields>;
  nodes: Array<AccQbdConductorConfig>;
};

/** aggregate fields of "acc_qbd_conductor_config" */
export type AccQbdConductorConfigAggregateFields = {
  __typename?: 'AccQbdConductorConfigAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccQbdConductorConfigMaxFields>;
  min?: Maybe<AccQbdConductorConfigMinFields>;
};


/** aggregate fields of "acc_qbd_conductor_config" */
export type AccQbdConductorConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccQbdConductorConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "acc_qbd_conductor_config". All fields are combined with a logical 'AND'. */
export type AccQbdConductorConfigBoolExp = {
  _and?: InputMaybe<Array<AccQbdConductorConfigBoolExp>>;
  _not?: InputMaybe<AccQbdConductorConfigBoolExp>;
  _or?: InputMaybe<Array<AccQbdConductorConfigBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  conductorEndUserId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "acc_qbd_conductor_config" */
export type AccQbdConductorConfigConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'acc_qbd_conductor_config_company_guid_key'
  /** unique or primary key constraint on columns "conductor_end_user_id" */
  | 'acc_qbd_conductor_config_conductor_end_user_id_key'
  /** unique or primary key constraint on columns "company_guid" */
  | 'acc_qbd_conductor_config_pkey';

/** input type for inserting data into table "acc_qbd_conductor_config" */
export type AccQbdConductorConfigInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  conductorEndUserId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AccQbdConductorConfigMaxFields = {
  __typename?: 'AccQbdConductorConfigMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  conductorEndUserId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AccQbdConductorConfigMinFields = {
  __typename?: 'AccQbdConductorConfigMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  conductorEndUserId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "acc_qbd_conductor_config" */
export type AccQbdConductorConfigMutationResponse = {
  __typename?: 'AccQbdConductorConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccQbdConductorConfig>;
};

/** input type for inserting object relation for remote table "acc_qbd_conductor_config" */
export type AccQbdConductorConfigObjRelInsertInput = {
  data: AccQbdConductorConfigInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AccQbdConductorConfigOnConflict>;
};

/** on_conflict condition type for table "acc_qbd_conductor_config" */
export type AccQbdConductorConfigOnConflict = {
  constraint: AccQbdConductorConfigConstraint;
  updateColumns?: Array<AccQbdConductorConfigUpdateColumn>;
  where?: InputMaybe<AccQbdConductorConfigBoolExp>;
};

/** Ordering options when selecting data from "acc_qbd_conductor_config". */
export type AccQbdConductorConfigOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  conductorEndUserId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: acc_qbd_conductor_config */
export type AccQbdConductorConfigPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "acc_qbd_conductor_config" */
export type AccQbdConductorConfigSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'conductorEndUserId';

/** input type for updating data in table "acc_qbd_conductor_config" */
export type AccQbdConductorConfigSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  conductorEndUserId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "acc_qbd_conductor_config" */
export type AccQbdConductorConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccQbdConductorConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccQbdConductorConfigStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  conductorEndUserId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "acc_qbd_conductor_config" */
export type AccQbdConductorConfigUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'conductorEndUserId';

export type AccQbdConductorConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccQbdConductorConfigSetInput>;
  /** filter the rows which have to be updated */
  where: AccQbdConductorConfigBoolExp;
};

/** columns and relationships of "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptime = {
  __typename?: 'AccQbdConductorUptime';
  checkedAt: Scalars['timestamptz'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  conductorEndUserId: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  isConnected: Scalars['Boolean'];
  responseTimeMs?: Maybe<Scalars['Int']>;
  uptimeCheckGuid: Scalars['uuid'];
};

/** aggregated selection of "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptimeAggregate = {
  __typename?: 'AccQbdConductorUptimeAggregate';
  aggregate?: Maybe<AccQbdConductorUptimeAggregateFields>;
  nodes: Array<AccQbdConductorUptime>;
};

/** aggregate fields of "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptimeAggregateFields = {
  __typename?: 'AccQbdConductorUptimeAggregateFields';
  avg?: Maybe<AccQbdConductorUptimeAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AccQbdConductorUptimeMaxFields>;
  min?: Maybe<AccQbdConductorUptimeMinFields>;
  stddev?: Maybe<AccQbdConductorUptimeStddevFields>;
  stddevPop?: Maybe<AccQbdConductorUptimeStddevPopFields>;
  stddevSamp?: Maybe<AccQbdConductorUptimeStddevSampFields>;
  sum?: Maybe<AccQbdConductorUptimeSumFields>;
  varPop?: Maybe<AccQbdConductorUptimeVarPopFields>;
  varSamp?: Maybe<AccQbdConductorUptimeVarSampFields>;
  variance?: Maybe<AccQbdConductorUptimeVarianceFields>;
};


/** aggregate fields of "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptimeAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccQbdConductorUptimeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AccQbdConductorUptimeAvgFields = {
  __typename?: 'AccQbdConductorUptimeAvgFields';
  responseTimeMs?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "acc_qbd_conductor_uptime". All fields are combined with a logical 'AND'. */
export type AccQbdConductorUptimeBoolExp = {
  _and?: InputMaybe<Array<AccQbdConductorUptimeBoolExp>>;
  _not?: InputMaybe<AccQbdConductorUptimeBoolExp>;
  _or?: InputMaybe<Array<AccQbdConductorUptimeBoolExp>>;
  checkedAt?: InputMaybe<TimestamptzComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  conductorEndUserId?: InputMaybe<StringComparisonExp>;
  errorMessage?: InputMaybe<StringComparisonExp>;
  isConnected?: InputMaybe<BooleanComparisonExp>;
  responseTimeMs?: InputMaybe<IntComparisonExp>;
  uptimeCheckGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptimeConstraint =
  /** unique or primary key constraint on columns "uptime_check_guid" */
  | 'acc_qbd_conductor_uptime_pkey';

/** input type for incrementing numeric columns in table "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptimeIncInput = {
  responseTimeMs?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptimeInsertInput = {
  checkedAt?: InputMaybe<Scalars['timestamptz']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  conductorEndUserId?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isConnected?: InputMaybe<Scalars['Boolean']>;
  responseTimeMs?: InputMaybe<Scalars['Int']>;
  uptimeCheckGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AccQbdConductorUptimeMaxFields = {
  __typename?: 'AccQbdConductorUptimeMaxFields';
  checkedAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  conductorEndUserId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  responseTimeMs?: Maybe<Scalars['Int']>;
  uptimeCheckGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type AccQbdConductorUptimeMinFields = {
  __typename?: 'AccQbdConductorUptimeMinFields';
  checkedAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  conductorEndUserId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  responseTimeMs?: Maybe<Scalars['Int']>;
  uptimeCheckGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptimeMutationResponse = {
  __typename?: 'AccQbdConductorUptimeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccQbdConductorUptime>;
};

/** on_conflict condition type for table "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptimeOnConflict = {
  constraint: AccQbdConductorUptimeConstraint;
  updateColumns?: Array<AccQbdConductorUptimeUpdateColumn>;
  where?: InputMaybe<AccQbdConductorUptimeBoolExp>;
};

/** Ordering options when selecting data from "acc_qbd_conductor_uptime". */
export type AccQbdConductorUptimeOrderBy = {
  checkedAt?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  conductorEndUserId?: InputMaybe<OrderBy>;
  errorMessage?: InputMaybe<OrderBy>;
  isConnected?: InputMaybe<OrderBy>;
  responseTimeMs?: InputMaybe<OrderBy>;
  uptimeCheckGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: acc_qbd_conductor_uptime */
export type AccQbdConductorUptimePkColumnsInput = {
  uptimeCheckGuid: Scalars['uuid'];
};

/** select columns of table "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptimeSelectColumn =
  /** column name */
  | 'checkedAt'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'conductorEndUserId'
  /** column name */
  | 'errorMessage'
  /** column name */
  | 'isConnected'
  /** column name */
  | 'responseTimeMs'
  /** column name */
  | 'uptimeCheckGuid';

/** input type for updating data in table "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptimeSetInput = {
  checkedAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  conductorEndUserId?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isConnected?: InputMaybe<Scalars['Boolean']>;
  responseTimeMs?: InputMaybe<Scalars['Int']>;
  uptimeCheckGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type AccQbdConductorUptimeStddevFields = {
  __typename?: 'AccQbdConductorUptimeStddevFields';
  responseTimeMs?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type AccQbdConductorUptimeStddevPopFields = {
  __typename?: 'AccQbdConductorUptimeStddevPopFields';
  responseTimeMs?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type AccQbdConductorUptimeStddevSampFields = {
  __typename?: 'AccQbdConductorUptimeStddevSampFields';
  responseTimeMs?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptimeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccQbdConductorUptimeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccQbdConductorUptimeStreamCursorValueInput = {
  checkedAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  conductorEndUserId?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isConnected?: InputMaybe<Scalars['Boolean']>;
  responseTimeMs?: InputMaybe<Scalars['Int']>;
  uptimeCheckGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type AccQbdConductorUptimeSumFields = {
  __typename?: 'AccQbdConductorUptimeSumFields';
  responseTimeMs?: Maybe<Scalars['Int']>;
};

/** update columns of table "acc_qbd_conductor_uptime" */
export type AccQbdConductorUptimeUpdateColumn =
  /** column name */
  | 'checkedAt'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'conductorEndUserId'
  /** column name */
  | 'errorMessage'
  /** column name */
  | 'isConnected'
  /** column name */
  | 'responseTimeMs'
  /** column name */
  | 'uptimeCheckGuid';

export type AccQbdConductorUptimeUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AccQbdConductorUptimeIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccQbdConductorUptimeSetInput>;
  /** filter the rows which have to be updated */
  where: AccQbdConductorUptimeBoolExp;
};

/** aggregate varPop on columns */
export type AccQbdConductorUptimeVarPopFields = {
  __typename?: 'AccQbdConductorUptimeVarPopFields';
  responseTimeMs?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type AccQbdConductorUptimeVarSampFields = {
  __typename?: 'AccQbdConductorUptimeVarSampFields';
  responseTimeMs?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AccQbdConductorUptimeVarianceFields = {
  __typename?: 'AccQbdConductorUptimeVarianceFields';
  responseTimeMs?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "acc_sync_info" */
export type AccSyncInfo = {
  __typename?: 'AccSyncInfo';
  accSyncInfoGuid: Scalars['uuid'];
  accountingIntegrationType: Scalars['String'];
  breezyEntityGuid: Scalars['uuid'];
  breezyEntityType: Scalars['String'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  externalEntityId: Scalars['String'];
  externalEntitySyncKey?: Maybe<Scalars['String']>;
  externalEntityType: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "acc_sync_info" */
export type AccSyncInfoAggregate = {
  __typename?: 'AccSyncInfoAggregate';
  aggregate?: Maybe<AccSyncInfoAggregateFields>;
  nodes: Array<AccSyncInfo>;
};

export type AccSyncInfoAggregateBoolExp = {
  count?: InputMaybe<AccSyncInfoAggregateBoolExpCount>;
};

/** aggregate fields of "acc_sync_info" */
export type AccSyncInfoAggregateFields = {
  __typename?: 'AccSyncInfoAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccSyncInfoMaxFields>;
  min?: Maybe<AccSyncInfoMinFields>;
};


/** aggregate fields of "acc_sync_info" */
export type AccSyncInfoAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccSyncInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "acc_sync_info" */
export type AccSyncInfoAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AccSyncInfoMaxOrderBy>;
  min?: InputMaybe<AccSyncInfoMinOrderBy>;
};

/** input type for inserting array relation for remote table "acc_sync_info" */
export type AccSyncInfoArrRelInsertInput = {
  data: Array<AccSyncInfoInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AccSyncInfoOnConflict>;
};

/** Boolean expression to filter rows from the table "acc_sync_info". All fields are combined with a logical 'AND'. */
export type AccSyncInfoBoolExp = {
  _and?: InputMaybe<Array<AccSyncInfoBoolExp>>;
  _not?: InputMaybe<AccSyncInfoBoolExp>;
  _or?: InputMaybe<Array<AccSyncInfoBoolExp>>;
  accSyncInfoGuid?: InputMaybe<UuidComparisonExp>;
  accountingIntegrationType?: InputMaybe<StringComparisonExp>;
  breezyEntityGuid?: InputMaybe<UuidComparisonExp>;
  breezyEntityType?: InputMaybe<StringComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalEntityId?: InputMaybe<StringComparisonExp>;
  externalEntitySyncKey?: InputMaybe<StringComparisonExp>;
  externalEntityType?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "acc_sync_info" */
export type AccSyncInfoConstraint =
  /** unique or primary key constraint on columns "breezy_entity_guid", "accounting_integration_type", "breezy_entity_type", "company_guid" */
  | 'acc_sync_info_company_guid_accounting_integration_type_breezy_e'
  /** unique or primary key constraint on columns "breezy_entity_guid", "accounting_integration_type", "breezy_entity_type", "company_guid" */
  | 'acc_sync_info_pkey';

/** input type for inserting data into table "acc_sync_info" */
export type AccSyncInfoInsertInput = {
  accSyncInfoGuid?: InputMaybe<Scalars['uuid']>;
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  breezyEntityGuid?: InputMaybe<Scalars['uuid']>;
  breezyEntityType?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalEntityId?: InputMaybe<Scalars['String']>;
  externalEntitySyncKey?: InputMaybe<Scalars['String']>;
  externalEntityType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccSyncInfoMaxFields = {
  __typename?: 'AccSyncInfoMaxFields';
  accSyncInfoGuid?: Maybe<Scalars['uuid']>;
  accountingIntegrationType?: Maybe<Scalars['String']>;
  breezyEntityGuid?: Maybe<Scalars['uuid']>;
  breezyEntityType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalEntityId?: Maybe<Scalars['String']>;
  externalEntitySyncKey?: Maybe<Scalars['String']>;
  externalEntityType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "acc_sync_info" */
export type AccSyncInfoMaxOrderBy = {
  accSyncInfoGuid?: InputMaybe<OrderBy>;
  accountingIntegrationType?: InputMaybe<OrderBy>;
  breezyEntityGuid?: InputMaybe<OrderBy>;
  breezyEntityType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalEntityId?: InputMaybe<OrderBy>;
  externalEntitySyncKey?: InputMaybe<OrderBy>;
  externalEntityType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AccSyncInfoMinFields = {
  __typename?: 'AccSyncInfoMinFields';
  accSyncInfoGuid?: Maybe<Scalars['uuid']>;
  accountingIntegrationType?: Maybe<Scalars['String']>;
  breezyEntityGuid?: Maybe<Scalars['uuid']>;
  breezyEntityType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalEntityId?: Maybe<Scalars['String']>;
  externalEntitySyncKey?: Maybe<Scalars['String']>;
  externalEntityType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "acc_sync_info" */
export type AccSyncInfoMinOrderBy = {
  accSyncInfoGuid?: InputMaybe<OrderBy>;
  accountingIntegrationType?: InputMaybe<OrderBy>;
  breezyEntityGuid?: InputMaybe<OrderBy>;
  breezyEntityType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalEntityId?: InputMaybe<OrderBy>;
  externalEntitySyncKey?: InputMaybe<OrderBy>;
  externalEntityType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "acc_sync_info" */
export type AccSyncInfoMutationResponse = {
  __typename?: 'AccSyncInfoMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccSyncInfo>;
};

/** on_conflict condition type for table "acc_sync_info" */
export type AccSyncInfoOnConflict = {
  constraint: AccSyncInfoConstraint;
  updateColumns?: Array<AccSyncInfoUpdateColumn>;
  where?: InputMaybe<AccSyncInfoBoolExp>;
};

/** Ordering options when selecting data from "acc_sync_info". */
export type AccSyncInfoOrderBy = {
  accSyncInfoGuid?: InputMaybe<OrderBy>;
  accountingIntegrationType?: InputMaybe<OrderBy>;
  breezyEntityGuid?: InputMaybe<OrderBy>;
  breezyEntityType?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalEntityId?: InputMaybe<OrderBy>;
  externalEntitySyncKey?: InputMaybe<OrderBy>;
  externalEntityType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: acc_sync_info */
export type AccSyncInfoPkColumnsInput = {
  accountingIntegrationType: Scalars['String'];
  breezyEntityGuid: Scalars['uuid'];
  breezyEntityType: Scalars['String'];
  companyGuid: Scalars['uuid'];
};

/** select columns of table "acc_sync_info" */
export type AccSyncInfoSelectColumn =
  /** column name */
  | 'accSyncInfoGuid'
  /** column name */
  | 'accountingIntegrationType'
  /** column name */
  | 'breezyEntityGuid'
  /** column name */
  | 'breezyEntityType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalEntityId'
  /** column name */
  | 'externalEntitySyncKey'
  /** column name */
  | 'externalEntityType'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "acc_sync_info" */
export type AccSyncInfoSetInput = {
  accSyncInfoGuid?: InputMaybe<Scalars['uuid']>;
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  breezyEntityGuid?: InputMaybe<Scalars['uuid']>;
  breezyEntityType?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalEntityId?: InputMaybe<Scalars['String']>;
  externalEntitySyncKey?: InputMaybe<Scalars['String']>;
  externalEntityType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "acc_sync_info" */
export type AccSyncInfoStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccSyncInfoStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccSyncInfoStreamCursorValueInput = {
  accSyncInfoGuid?: InputMaybe<Scalars['uuid']>;
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  breezyEntityGuid?: InputMaybe<Scalars['uuid']>;
  breezyEntityType?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalEntityId?: InputMaybe<Scalars['String']>;
  externalEntitySyncKey?: InputMaybe<Scalars['String']>;
  externalEntityType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "acc_sync_info" */
export type AccSyncInfoUpdateColumn =
  /** column name */
  | 'accSyncInfoGuid'
  /** column name */
  | 'accountingIntegrationType'
  /** column name */
  | 'breezyEntityGuid'
  /** column name */
  | 'breezyEntityType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalEntityId'
  /** column name */
  | 'externalEntitySyncKey'
  /** column name */
  | 'externalEntityType'
  /** column name */
  | 'updatedAt';

export type AccSyncInfoUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccSyncInfoSetInput>;
  /** filter the rows which have to be updated */
  where: AccSyncInfoBoolExp;
};

/** columns and relationships of "acc_sync_queue_items" */
export type AccSyncQueueItems = {
  __typename?: 'AccSyncQueueItems';
  accSyncQueueItemGuid: Scalars['uuid'];
  breezyEntityGuid: Scalars['uuid'];
  breezyEntityType: Scalars['String'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  erroredAt?: Maybe<Scalars['timestamptz']>;
  forceSync: Scalars['Boolean'];
  syncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "acc_sync_queue_items" */
export type AccSyncQueueItemsAggregate = {
  __typename?: 'AccSyncQueueItemsAggregate';
  aggregate?: Maybe<AccSyncQueueItemsAggregateFields>;
  nodes: Array<AccSyncQueueItems>;
};

/** aggregate fields of "acc_sync_queue_items" */
export type AccSyncQueueItemsAggregateFields = {
  __typename?: 'AccSyncQueueItemsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccSyncQueueItemsMaxFields>;
  min?: Maybe<AccSyncQueueItemsMinFields>;
};


/** aggregate fields of "acc_sync_queue_items" */
export type AccSyncQueueItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccSyncQueueItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "acc_sync_queue_items". All fields are combined with a logical 'AND'. */
export type AccSyncQueueItemsBoolExp = {
  _and?: InputMaybe<Array<AccSyncQueueItemsBoolExp>>;
  _not?: InputMaybe<AccSyncQueueItemsBoolExp>;
  _or?: InputMaybe<Array<AccSyncQueueItemsBoolExp>>;
  accSyncQueueItemGuid?: InputMaybe<UuidComparisonExp>;
  breezyEntityGuid?: InputMaybe<UuidComparisonExp>;
  breezyEntityType?: InputMaybe<StringComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  erroredAt?: InputMaybe<TimestamptzComparisonExp>;
  forceSync?: InputMaybe<BooleanComparisonExp>;
  syncedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "acc_sync_queue_items" */
export type AccSyncQueueItemsConstraint =
  /** unique or primary key constraint on columns "acc_sync_queue_item_guid" */
  | 'acc_sync_queue_items_pkey';

/** input type for inserting data into table "acc_sync_queue_items" */
export type AccSyncQueueItemsInsertInput = {
  accSyncQueueItemGuid?: InputMaybe<Scalars['uuid']>;
  breezyEntityGuid?: InputMaybe<Scalars['uuid']>;
  breezyEntityType?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  erroredAt?: InputMaybe<Scalars['timestamptz']>;
  forceSync?: InputMaybe<Scalars['Boolean']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccSyncQueueItemsMaxFields = {
  __typename?: 'AccSyncQueueItemsMaxFields';
  accSyncQueueItemGuid?: Maybe<Scalars['uuid']>;
  breezyEntityGuid?: Maybe<Scalars['uuid']>;
  breezyEntityType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  erroredAt?: Maybe<Scalars['timestamptz']>;
  syncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type AccSyncQueueItemsMinFields = {
  __typename?: 'AccSyncQueueItemsMinFields';
  accSyncQueueItemGuid?: Maybe<Scalars['uuid']>;
  breezyEntityGuid?: Maybe<Scalars['uuid']>;
  breezyEntityType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  erroredAt?: Maybe<Scalars['timestamptz']>;
  syncedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "acc_sync_queue_items" */
export type AccSyncQueueItemsMutationResponse = {
  __typename?: 'AccSyncQueueItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccSyncQueueItems>;
};

/** on_conflict condition type for table "acc_sync_queue_items" */
export type AccSyncQueueItemsOnConflict = {
  constraint: AccSyncQueueItemsConstraint;
  updateColumns?: Array<AccSyncQueueItemsUpdateColumn>;
  where?: InputMaybe<AccSyncQueueItemsBoolExp>;
};

/** Ordering options when selecting data from "acc_sync_queue_items". */
export type AccSyncQueueItemsOrderBy = {
  accSyncQueueItemGuid?: InputMaybe<OrderBy>;
  breezyEntityGuid?: InputMaybe<OrderBy>;
  breezyEntityType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  erroredAt?: InputMaybe<OrderBy>;
  forceSync?: InputMaybe<OrderBy>;
  syncedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: acc_sync_queue_items */
export type AccSyncQueueItemsPkColumnsInput = {
  accSyncQueueItemGuid: Scalars['uuid'];
};

/** select columns of table "acc_sync_queue_items" */
export type AccSyncQueueItemsSelectColumn =
  /** column name */
  | 'accSyncQueueItemGuid'
  /** column name */
  | 'breezyEntityGuid'
  /** column name */
  | 'breezyEntityType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'erroredAt'
  /** column name */
  | 'forceSync'
  /** column name */
  | 'syncedAt';

/** input type for updating data in table "acc_sync_queue_items" */
export type AccSyncQueueItemsSetInput = {
  accSyncQueueItemGuid?: InputMaybe<Scalars['uuid']>;
  breezyEntityGuid?: InputMaybe<Scalars['uuid']>;
  breezyEntityType?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  erroredAt?: InputMaybe<Scalars['timestamptz']>;
  forceSync?: InputMaybe<Scalars['Boolean']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "acc_sync_queue_items" */
export type AccSyncQueueItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccSyncQueueItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccSyncQueueItemsStreamCursorValueInput = {
  accSyncQueueItemGuid?: InputMaybe<Scalars['uuid']>;
  breezyEntityGuid?: InputMaybe<Scalars['uuid']>;
  breezyEntityType?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  erroredAt?: InputMaybe<Scalars['timestamptz']>;
  forceSync?: InputMaybe<Scalars['Boolean']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "acc_sync_queue_items" */
export type AccSyncQueueItemsUpdateColumn =
  /** column name */
  | 'accSyncQueueItemGuid'
  /** column name */
  | 'breezyEntityGuid'
  /** column name */
  | 'breezyEntityType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'erroredAt'
  /** column name */
  | 'forceSync'
  /** column name */
  | 'syncedAt';

export type AccSyncQueueItemsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccSyncQueueItemsSetInput>;
  /** filter the rows which have to be updated */
  where: AccSyncQueueItemsBoolExp;
};

/** columns and relationships of "account_contacts" */
export type AccountContacts = {
  __typename?: 'AccountContacts';
  /** An object relationship */
  account: Accounts;
  accountContactGuid: Scalars['uuid'];
  accountGuid: Scalars['uuid'];
  archived: Scalars['Boolean'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  /** An object relationship */
  contact: Contacts;
  contactGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  primary: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "account_contacts" */
export type AccountContactsAggregate = {
  __typename?: 'AccountContactsAggregate';
  aggregate?: Maybe<AccountContactsAggregateFields>;
  nodes: Array<AccountContacts>;
};

export type AccountContactsAggregateBoolExp = {
  bool_and?: InputMaybe<AccountContactsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<AccountContactsAggregateBoolExpBool_Or>;
  count?: InputMaybe<AccountContactsAggregateBoolExpCount>;
};

/** aggregate fields of "account_contacts" */
export type AccountContactsAggregateFields = {
  __typename?: 'AccountContactsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccountContactsMaxFields>;
  min?: Maybe<AccountContactsMinFields>;
};


/** aggregate fields of "account_contacts" */
export type AccountContactsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccountContactsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_contacts" */
export type AccountContactsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AccountContactsMaxOrderBy>;
  min?: InputMaybe<AccountContactsMinOrderBy>;
};

/** input type for inserting array relation for remote table "account_contacts" */
export type AccountContactsArrRelInsertInput = {
  data: Array<AccountContactsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AccountContactsOnConflict>;
};

/** Boolean expression to filter rows from the table "account_contacts". All fields are combined with a logical 'AND'. */
export type AccountContactsBoolExp = {
  _and?: InputMaybe<Array<AccountContactsBoolExp>>;
  _not?: InputMaybe<AccountContactsBoolExp>;
  _or?: InputMaybe<Array<AccountContactsBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountContactGuid?: InputMaybe<UuidComparisonExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  archived?: InputMaybe<BooleanComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  contact?: InputMaybe<ContactsBoolExp>;
  contactGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  primary?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "account_contacts" */
export type AccountContactsConstraint =
  /** unique or primary key constraint on columns "account_contact_guid" */
  | 'account_contacts_pkey';

/** input type for inserting data into table "account_contacts" */
export type AccountContactsInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountContactGuid?: InputMaybe<Scalars['uuid']>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contact?: InputMaybe<ContactsObjRelInsertInput>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccountContactsMaxFields = {
  __typename?: 'AccountContactsMaxFields';
  accountContactGuid?: Maybe<Scalars['uuid']>;
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "account_contacts" */
export type AccountContactsMaxOrderBy = {
  accountContactGuid?: InputMaybe<OrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AccountContactsMinFields = {
  __typename?: 'AccountContactsMinFields';
  accountContactGuid?: Maybe<Scalars['uuid']>;
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "account_contacts" */
export type AccountContactsMinOrderBy = {
  accountContactGuid?: InputMaybe<OrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "account_contacts" */
export type AccountContactsMutationResponse = {
  __typename?: 'AccountContactsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountContacts>;
};

/** on_conflict condition type for table "account_contacts" */
export type AccountContactsOnConflict = {
  constraint: AccountContactsConstraint;
  updateColumns?: Array<AccountContactsUpdateColumn>;
  where?: InputMaybe<AccountContactsBoolExp>;
};

/** Ordering options when selecting data from "account_contacts". */
export type AccountContactsOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountContactGuid?: InputMaybe<OrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  archived?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contact?: InputMaybe<ContactsOrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  primary?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: account_contacts */
export type AccountContactsPkColumnsInput = {
  accountContactGuid: Scalars['uuid'];
};

/** select columns of table "account_contacts" */
export type AccountContactsSelectColumn =
  /** column name */
  | 'accountContactGuid'
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'archived'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'primary'
  /** column name */
  | 'updatedAt';

/** select "accountContactsAggregateBoolExpBool_andArgumentsColumns" columns of table "account_contacts" */
export type AccountContactsSelectColumnAccountContactsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'archived'
  /** column name */
  | 'primary';

/** select "accountContactsAggregateBoolExpBool_orArgumentsColumns" columns of table "account_contacts" */
export type AccountContactsSelectColumnAccountContactsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'archived'
  /** column name */
  | 'primary';

/** input type for updating data in table "account_contacts" */
export type AccountContactsSetInput = {
  accountContactGuid?: InputMaybe<Scalars['uuid']>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "account_contacts" */
export type AccountContactsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccountContactsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountContactsStreamCursorValueInput = {
  accountContactGuid?: InputMaybe<Scalars['uuid']>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "account_contacts" */
export type AccountContactsUpdateColumn =
  /** column name */
  | 'accountContactGuid'
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'archived'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'primary'
  /** column name */
  | 'updatedAt';

export type AccountContactsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountContactsSetInput>;
  /** filter the rows which have to be updated */
  where: AccountContactsBoolExp;
};

/** columns and relationships of "account_job_counts" */
export type AccountJobCounts = {
  __typename?: 'AccountJobCounts';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  jobCount?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "account_job_counts". All fields are combined with a logical 'AND'. */
export type AccountJobCountsBoolExp = {
  _and?: InputMaybe<Array<AccountJobCountsBoolExp>>;
  _not?: InputMaybe<AccountJobCountsBoolExp>;
  _or?: InputMaybe<Array<AccountJobCountsBoolExp>>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  jobCount?: InputMaybe<BigintComparisonExp>;
};

/** Ordering options when selecting data from "account_job_counts". */
export type AccountJobCountsOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  jobCount?: InputMaybe<OrderBy>;
};

/** select columns of table "account_job_counts" */
export type AccountJobCountsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'jobCount';

/** Streaming cursor of the table "account_job_counts" */
export type AccountJobCountsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccountJobCountsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountJobCountsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobCount?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "account_locations" */
export type AccountLocations = {
  __typename?: 'AccountLocations';
  /** An object relationship */
  account: Accounts;
  accountGuid: Scalars['uuid'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  /** An array relationship */
  fileLinks: Array<FileLinks>;
  /** An aggregate relationship */
  fileLinksAggregate: FileLinksAggregate;
  isArchived: Scalars['Boolean'];
  /** A computed field to check if an account location is set as the account billing address */
  isBillingAddress?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  location: Locations;
  locationGuid: Scalars['uuid'];
  /** An object relationship */
  maintenancePlan?: Maybe<MaintenancePlansQueryable>;
  /** An array relationship */
  photoLinks: Array<PhotoLinks>;
  /** An aggregate relationship */
  photoLinksAggregate: PhotoLinksAggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "account_locations" */
export type AccountLocationsFileLinksArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


/** columns and relationships of "account_locations" */
export type AccountLocationsFileLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


/** columns and relationships of "account_locations" */
export type AccountLocationsPhotoLinksArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


/** columns and relationships of "account_locations" */
export type AccountLocationsPhotoLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};

/** aggregated selection of "account_locations" */
export type AccountLocationsAggregate = {
  __typename?: 'AccountLocationsAggregate';
  aggregate?: Maybe<AccountLocationsAggregateFields>;
  nodes: Array<AccountLocations>;
};

export type AccountLocationsAggregateBoolExp = {
  bool_and?: InputMaybe<AccountLocationsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<AccountLocationsAggregateBoolExpBool_Or>;
  count?: InputMaybe<AccountLocationsAggregateBoolExpCount>;
};

/** aggregate fields of "account_locations" */
export type AccountLocationsAggregateFields = {
  __typename?: 'AccountLocationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccountLocationsMaxFields>;
  min?: Maybe<AccountLocationsMinFields>;
};


/** aggregate fields of "account_locations" */
export type AccountLocationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccountLocationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_locations" */
export type AccountLocationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AccountLocationsMaxOrderBy>;
  min?: InputMaybe<AccountLocationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "account_locations" */
export type AccountLocationsArrRelInsertInput = {
  data: Array<AccountLocationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AccountLocationsOnConflict>;
};

/** Boolean expression to filter rows from the table "account_locations". All fields are combined with a logical 'AND'. */
export type AccountLocationsBoolExp = {
  _and?: InputMaybe<Array<AccountLocationsBoolExp>>;
  _not?: InputMaybe<AccountLocationsBoolExp>;
  _or?: InputMaybe<Array<AccountLocationsBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  fileLinks?: InputMaybe<FileLinksBoolExp>;
  fileLinksAggregate?: InputMaybe<FileLinksAggregateBoolExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  isBillingAddress?: InputMaybe<BooleanComparisonExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableBoolExp>;
  photoLinks?: InputMaybe<PhotoLinksBoolExp>;
  photoLinksAggregate?: InputMaybe<PhotoLinksAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "account_locations" */
export type AccountLocationsConstraint =
  /** unique or primary key constraint on columns "account_guid", "location_guid" */
  | 'account_locations_pkey';

/** input type for inserting data into table "account_locations" */
export type AccountLocationsInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  fileLinks?: InputMaybe<FileLinksArrRelInsertInput>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<LocationsObjRelInsertInput>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableObjRelInsertInput>;
  photoLinks?: InputMaybe<PhotoLinksArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccountLocationsMaxFields = {
  __typename?: 'AccountLocationsMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "account_locations" */
export type AccountLocationsMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AccountLocationsMinFields = {
  __typename?: 'AccountLocationsMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "account_locations" */
export type AccountLocationsMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "account_locations" */
export type AccountLocationsMutationResponse = {
  __typename?: 'AccountLocationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountLocations>;
};

/** on_conflict condition type for table "account_locations" */
export type AccountLocationsOnConflict = {
  constraint: AccountLocationsConstraint;
  updateColumns?: Array<AccountLocationsUpdateColumn>;
  where?: InputMaybe<AccountLocationsBoolExp>;
};

/** Ordering options when selecting data from "account_locations". */
export type AccountLocationsOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  fileLinksAggregate?: InputMaybe<FileLinksAggregateOrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  isBillingAddress?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableOrderBy>;
  photoLinksAggregate?: InputMaybe<PhotoLinksAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: account_locations */
export type AccountLocationsPkColumnsInput = {
  accountGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
};

/** select columns of table "account_locations" */
export type AccountLocationsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'isArchived'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'updatedAt';

/** select "accountLocationsAggregateBoolExpBool_andArgumentsColumns" columns of table "account_locations" */
export type AccountLocationsSelectColumnAccountLocationsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isArchived';

/** select "accountLocationsAggregateBoolExpBool_orArgumentsColumns" columns of table "account_locations" */
export type AccountLocationsSelectColumnAccountLocationsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isArchived';

/** input type for updating data in table "account_locations" */
export type AccountLocationsSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "account_locations" */
export type AccountLocationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccountLocationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountLocationsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "account_locations" */
export type AccountLocationsUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'isArchived'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'updatedAt';

export type AccountLocationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountLocationsSetInput>;
  /** filter the rows which have to be updated */
  where: AccountLocationsBoolExp;
};

/** Account-level Reminders */
export type AccountReminders = {
  __typename?: 'AccountReminders';
  /** An object relationship */
  account: Accounts;
  accountGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  reminder: Reminders;
  reminderGuid: Scalars['uuid'];
};

/** aggregated selection of "account_reminders" */
export type AccountRemindersAggregate = {
  __typename?: 'AccountRemindersAggregate';
  aggregate?: Maybe<AccountRemindersAggregateFields>;
  nodes: Array<AccountReminders>;
};

export type AccountRemindersAggregateBoolExp = {
  count?: InputMaybe<AccountRemindersAggregateBoolExpCount>;
};

/** aggregate fields of "account_reminders" */
export type AccountRemindersAggregateFields = {
  __typename?: 'AccountRemindersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccountRemindersMaxFields>;
  min?: Maybe<AccountRemindersMinFields>;
};


/** aggregate fields of "account_reminders" */
export type AccountRemindersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccountRemindersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_reminders" */
export type AccountRemindersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AccountRemindersMaxOrderBy>;
  min?: InputMaybe<AccountRemindersMinOrderBy>;
};

/** input type for inserting array relation for remote table "account_reminders" */
export type AccountRemindersArrRelInsertInput = {
  data: Array<AccountRemindersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AccountRemindersOnConflict>;
};

/** Boolean expression to filter rows from the table "account_reminders". All fields are combined with a logical 'AND'. */
export type AccountRemindersBoolExp = {
  _and?: InputMaybe<Array<AccountRemindersBoolExp>>;
  _not?: InputMaybe<AccountRemindersBoolExp>;
  _or?: InputMaybe<Array<AccountRemindersBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  reminder?: InputMaybe<RemindersBoolExp>;
  reminderGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "account_reminders" */
export type AccountRemindersConstraint =
  /** unique or primary key constraint on columns "reminder_guid", "account_guid" */
  | 'account_reminders_pkey';

/** input type for inserting data into table "account_reminders" */
export type AccountRemindersInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  reminder?: InputMaybe<RemindersObjRelInsertInput>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AccountRemindersMaxFields = {
  __typename?: 'AccountRemindersMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  reminderGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "account_reminders" */
export type AccountRemindersMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  reminderGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AccountRemindersMinFields = {
  __typename?: 'AccountRemindersMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  reminderGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "account_reminders" */
export type AccountRemindersMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  reminderGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "account_reminders" */
export type AccountRemindersMutationResponse = {
  __typename?: 'AccountRemindersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountReminders>;
};

/** on_conflict condition type for table "account_reminders" */
export type AccountRemindersOnConflict = {
  constraint: AccountRemindersConstraint;
  updateColumns?: Array<AccountRemindersUpdateColumn>;
  where?: InputMaybe<AccountRemindersBoolExp>;
};

/** Ordering options when selecting data from "account_reminders". */
export type AccountRemindersOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  reminder?: InputMaybe<RemindersOrderBy>;
  reminderGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: account_reminders */
export type AccountRemindersPkColumnsInput = {
  accountGuid: Scalars['uuid'];
  reminderGuid: Scalars['uuid'];
};

/** select columns of table "account_reminders" */
export type AccountRemindersSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'reminderGuid';

/** input type for updating data in table "account_reminders" */
export type AccountRemindersSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "account_reminders" */
export type AccountRemindersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccountRemindersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountRemindersStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "account_reminders" */
export type AccountRemindersUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'reminderGuid';

export type AccountRemindersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountRemindersSetInput>;
  /** filter the rows which have to be updated */
  where: AccountRemindersBoolExp;
};

/** Tracks when account statements are generated, sent, or viewed */
export type AccountStatementEvents = {
  __typename?: 'AccountStatementEvents';
  accountGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['uuid']>;
  /** Optional JSON object with delivery information (e.g., email address for EMAIL_SENT events) */
  deliveryDetails?: Maybe<Scalars['jsonb']>;
  /** Type of statement event: EMAIL_SENT, PRINTED, or VIEWED */
  eventType: Scalars['String'];
  /** Array of invoice GUIDs that were included in the statement (can be empty for zero-balance statements) */
  invoiceGuids: Array<Scalars['uuid']>;
  /** The as-of date for the statement (when it was generated) */
  statementDate: Scalars['timestamptz'];
  statementEventGuid: Scalars['uuid'];
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc: Scalars['Int'];
};


/** Tracks when account statements are generated, sent, or viewed */
export type AccountStatementEventsDeliveryDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "account_statement_events" */
export type AccountStatementEventsAggregate = {
  __typename?: 'AccountStatementEventsAggregate';
  aggregate?: Maybe<AccountStatementEventsAggregateFields>;
  nodes: Array<AccountStatementEvents>;
};

/** aggregate fields of "account_statement_events" */
export type AccountStatementEventsAggregateFields = {
  __typename?: 'AccountStatementEventsAggregateFields';
  avg?: Maybe<AccountStatementEventsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AccountStatementEventsMaxFields>;
  min?: Maybe<AccountStatementEventsMinFields>;
  stddev?: Maybe<AccountStatementEventsStddevFields>;
  stddevPop?: Maybe<AccountStatementEventsStddevPopFields>;
  stddevSamp?: Maybe<AccountStatementEventsStddevSampFields>;
  sum?: Maybe<AccountStatementEventsSumFields>;
  varPop?: Maybe<AccountStatementEventsVarPopFields>;
  varSamp?: Maybe<AccountStatementEventsVarSampFields>;
  variance?: Maybe<AccountStatementEventsVarianceFields>;
};


/** aggregate fields of "account_statement_events" */
export type AccountStatementEventsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccountStatementEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AccountStatementEventsAppendInput = {
  /** Optional JSON object with delivery information (e.g., email address for EMAIL_SENT events) */
  deliveryDetails?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AccountStatementEventsAvgFields = {
  __typename?: 'AccountStatementEventsAvgFields';
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "account_statement_events". All fields are combined with a logical 'AND'. */
export type AccountStatementEventsBoolExp = {
  _and?: InputMaybe<Array<AccountStatementEventsBoolExp>>;
  _not?: InputMaybe<AccountStatementEventsBoolExp>;
  _or?: InputMaybe<Array<AccountStatementEventsBoolExp>>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  deliveryDetails?: InputMaybe<JsonbComparisonExp>;
  eventType?: InputMaybe<StringComparisonExp>;
  invoiceGuids?: InputMaybe<UuidArrayComparisonExp>;
  statementDate?: InputMaybe<TimestamptzComparisonExp>;
  statementEventGuid?: InputMaybe<UuidComparisonExp>;
  totalAmountUsc?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "account_statement_events" */
export type AccountStatementEventsConstraint =
  /** unique or primary key constraint on columns "statement_event_guid" */
  | 'account_statement_events_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AccountStatementEventsDeleteAtPathInput = {
  /** Optional JSON object with delivery information (e.g., email address for EMAIL_SENT events) */
  deliveryDetails?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AccountStatementEventsDeleteElemInput = {
  /** Optional JSON object with delivery information (e.g., email address for EMAIL_SENT events) */
  deliveryDetails?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AccountStatementEventsDeleteKeyInput = {
  /** Optional JSON object with delivery information (e.g., email address for EMAIL_SENT events) */
  deliveryDetails?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "account_statement_events" */
export type AccountStatementEventsIncInput = {
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "account_statement_events" */
export type AccountStatementEventsInsertInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  /** Optional JSON object with delivery information (e.g., email address for EMAIL_SENT events) */
  deliveryDetails?: InputMaybe<Scalars['jsonb']>;
  /** Type of statement event: EMAIL_SENT, PRINTED, or VIEWED */
  eventType?: InputMaybe<Scalars['String']>;
  /** Array of invoice GUIDs that were included in the statement (can be empty for zero-balance statements) */
  invoiceGuids?: InputMaybe<Array<Scalars['uuid']>>;
  /** The as-of date for the statement (when it was generated) */
  statementDate?: InputMaybe<Scalars['timestamptz']>;
  statementEventGuid?: InputMaybe<Scalars['uuid']>;
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AccountStatementEventsMaxFields = {
  __typename?: 'AccountStatementEventsMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  /** Type of statement event: EMAIL_SENT, PRINTED, or VIEWED */
  eventType?: Maybe<Scalars['String']>;
  /** Array of invoice GUIDs that were included in the statement (can be empty for zero-balance statements) */
  invoiceGuids?: Maybe<Array<Scalars['uuid']>>;
  /** The as-of date for the statement (when it was generated) */
  statementDate?: Maybe<Scalars['timestamptz']>;
  statementEventGuid?: Maybe<Scalars['uuid']>;
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type AccountStatementEventsMinFields = {
  __typename?: 'AccountStatementEventsMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  /** Type of statement event: EMAIL_SENT, PRINTED, or VIEWED */
  eventType?: Maybe<Scalars['String']>;
  /** Array of invoice GUIDs that were included in the statement (can be empty for zero-balance statements) */
  invoiceGuids?: Maybe<Array<Scalars['uuid']>>;
  /** The as-of date for the statement (when it was generated) */
  statementDate?: Maybe<Scalars['timestamptz']>;
  statementEventGuid?: Maybe<Scalars['uuid']>;
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "account_statement_events" */
export type AccountStatementEventsMutationResponse = {
  __typename?: 'AccountStatementEventsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountStatementEvents>;
};

/** on_conflict condition type for table "account_statement_events" */
export type AccountStatementEventsOnConflict = {
  constraint: AccountStatementEventsConstraint;
  updateColumns?: Array<AccountStatementEventsUpdateColumn>;
  where?: InputMaybe<AccountStatementEventsBoolExp>;
};

/** Ordering options when selecting data from "account_statement_events". */
export type AccountStatementEventsOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  deliveryDetails?: InputMaybe<OrderBy>;
  eventType?: InputMaybe<OrderBy>;
  invoiceGuids?: InputMaybe<OrderBy>;
  statementDate?: InputMaybe<OrderBy>;
  statementEventGuid?: InputMaybe<OrderBy>;
  totalAmountUsc?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: account_statement_events */
export type AccountStatementEventsPkColumnsInput = {
  statementEventGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AccountStatementEventsPrependInput = {
  /** Optional JSON object with delivery information (e.g., email address for EMAIL_SENT events) */
  deliveryDetails?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "account_statement_events" */
export type AccountStatementEventsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'deliveryDetails'
  /** column name */
  | 'eventType'
  /** column name */
  | 'invoiceGuids'
  /** column name */
  | 'statementDate'
  /** column name */
  | 'statementEventGuid'
  /** column name */
  | 'totalAmountUsc';

/** input type for updating data in table "account_statement_events" */
export type AccountStatementEventsSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  /** Optional JSON object with delivery information (e.g., email address for EMAIL_SENT events) */
  deliveryDetails?: InputMaybe<Scalars['jsonb']>;
  /** Type of statement event: EMAIL_SENT, PRINTED, or VIEWED */
  eventType?: InputMaybe<Scalars['String']>;
  /** Array of invoice GUIDs that were included in the statement (can be empty for zero-balance statements) */
  invoiceGuids?: InputMaybe<Array<Scalars['uuid']>>;
  /** The as-of date for the statement (when it was generated) */
  statementDate?: InputMaybe<Scalars['timestamptz']>;
  statementEventGuid?: InputMaybe<Scalars['uuid']>;
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AccountStatementEventsStddevFields = {
  __typename?: 'AccountStatementEventsStddevFields';
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type AccountStatementEventsStddevPopFields = {
  __typename?: 'AccountStatementEventsStddevPopFields';
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type AccountStatementEventsStddevSampFields = {
  __typename?: 'AccountStatementEventsStddevSampFields';
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "account_statement_events" */
export type AccountStatementEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccountStatementEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountStatementEventsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  /** Optional JSON object with delivery information (e.g., email address for EMAIL_SENT events) */
  deliveryDetails?: InputMaybe<Scalars['jsonb']>;
  /** Type of statement event: EMAIL_SENT, PRINTED, or VIEWED */
  eventType?: InputMaybe<Scalars['String']>;
  /** Array of invoice GUIDs that were included in the statement (can be empty for zero-balance statements) */
  invoiceGuids?: InputMaybe<Array<Scalars['uuid']>>;
  /** The as-of date for the statement (when it was generated) */
  statementDate?: InputMaybe<Scalars['timestamptz']>;
  statementEventGuid?: InputMaybe<Scalars['uuid']>;
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type AccountStatementEventsSumFields = {
  __typename?: 'AccountStatementEventsSumFields';
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: Maybe<Scalars['Int']>;
};

/** update columns of table "account_statement_events" */
export type AccountStatementEventsUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'deliveryDetails'
  /** column name */
  | 'eventType'
  /** column name */
  | 'invoiceGuids'
  /** column name */
  | 'statementDate'
  /** column name */
  | 'statementEventGuid'
  /** column name */
  | 'totalAmountUsc';

export type AccountStatementEventsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AccountStatementEventsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<AccountStatementEventsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<AccountStatementEventsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<AccountStatementEventsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AccountStatementEventsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AccountStatementEventsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountStatementEventsSetInput>;
  /** filter the rows which have to be updated */
  where: AccountStatementEventsBoolExp;
};

/** aggregate varPop on columns */
export type AccountStatementEventsVarPopFields = {
  __typename?: 'AccountStatementEventsVarPopFields';
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type AccountStatementEventsVarSampFields = {
  __typename?: 'AccountStatementEventsVarSampFields';
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AccountStatementEventsVarianceFields = {
  __typename?: 'AccountStatementEventsVarianceFields';
  /** Total amount due at the time the statement was generated (can be 0) */
  totalAmountUsc?: Maybe<Scalars['Float']>;
};

/** The tags associated for a specific account */
export type AccountTags = {
  __typename?: 'AccountTags';
  /** An object relationship */
  account: Accounts;
  accountGuid: Scalars['uuid'];
  addedAt: Scalars['timestamptz'];
  addedByUserGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  tag: Tags;
  tagGuid: Scalars['uuid'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** aggregated selection of "account_tags" */
export type AccountTagsAggregate = {
  __typename?: 'AccountTagsAggregate';
  aggregate?: Maybe<AccountTagsAggregateFields>;
  nodes: Array<AccountTags>;
};

export type AccountTagsAggregateBoolExp = {
  count?: InputMaybe<AccountTagsAggregateBoolExpCount>;
};

/** aggregate fields of "account_tags" */
export type AccountTagsAggregateFields = {
  __typename?: 'AccountTagsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccountTagsMaxFields>;
  min?: Maybe<AccountTagsMinFields>;
};


/** aggregate fields of "account_tags" */
export type AccountTagsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccountTagsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_tags" */
export type AccountTagsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AccountTagsMaxOrderBy>;
  min?: InputMaybe<AccountTagsMinOrderBy>;
};

/** input type for inserting array relation for remote table "account_tags" */
export type AccountTagsArrRelInsertInput = {
  data: Array<AccountTagsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AccountTagsOnConflict>;
};

/** Boolean expression to filter rows from the table "account_tags". All fields are combined with a logical 'AND'. */
export type AccountTagsBoolExp = {
  _and?: InputMaybe<Array<AccountTagsBoolExp>>;
  _not?: InputMaybe<AccountTagsBoolExp>;
  _or?: InputMaybe<Array<AccountTagsBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  addedAt?: InputMaybe<TimestamptzComparisonExp>;
  addedByUserGuid?: InputMaybe<UuidComparisonExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagGuid?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "account_tags" */
export type AccountTagsConstraint =
  /** unique or primary key constraint on columns "tag_guid", "account_guid" */
  | 'account_tags_pkey';

/** input type for inserting data into table "account_tags" */
export type AccountTagsInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByUserGuid?: InputMaybe<Scalars['uuid']>;
  tag?: InputMaybe<TagsObjRelInsertInput>;
  tagGuid?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type AccountTagsMaxFields = {
  __typename?: 'AccountTagsMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByUserGuid?: Maybe<Scalars['uuid']>;
  tagGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "account_tags" */
export type AccountTagsMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  addedAt?: InputMaybe<OrderBy>;
  addedByUserGuid?: InputMaybe<OrderBy>;
  tagGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AccountTagsMinFields = {
  __typename?: 'AccountTagsMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByUserGuid?: Maybe<Scalars['uuid']>;
  tagGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "account_tags" */
export type AccountTagsMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  addedAt?: InputMaybe<OrderBy>;
  addedByUserGuid?: InputMaybe<OrderBy>;
  tagGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "account_tags" */
export type AccountTagsMutationResponse = {
  __typename?: 'AccountTagsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountTags>;
};

/** on_conflict condition type for table "account_tags" */
export type AccountTagsOnConflict = {
  constraint: AccountTagsConstraint;
  updateColumns?: Array<AccountTagsUpdateColumn>;
  where?: InputMaybe<AccountTagsBoolExp>;
};

/** Ordering options when selecting data from "account_tags". */
export type AccountTagsOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  addedAt?: InputMaybe<OrderBy>;
  addedByUserGuid?: InputMaybe<OrderBy>;
  tag?: InputMaybe<TagsOrderBy>;
  tagGuid?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: account_tags */
export type AccountTagsPkColumnsInput = {
  accountGuid: Scalars['uuid'];
  tagGuid: Scalars['uuid'];
};

/** select columns of table "account_tags" */
export type AccountTagsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'addedAt'
  /** column name */
  | 'addedByUserGuid'
  /** column name */
  | 'tagGuid';

/** input type for updating data in table "account_tags" */
export type AccountTagsSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByUserGuid?: InputMaybe<Scalars['uuid']>;
  tagGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "account_tags" */
export type AccountTagsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccountTagsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountTagsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByUserGuid?: InputMaybe<Scalars['uuid']>;
  tagGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "account_tags" */
export type AccountTagsUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'addedAt'
  /** column name */
  | 'addedByUserGuid'
  /** column name */
  | 'tagGuid';

export type AccountTagsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountTagsSetInput>;
  /** filter the rows which have to be updated */
  where: AccountTagsBoolExp;
};

/** columns and relationships of "account_types" */
export type AccountTypes = {
  __typename?: 'AccountTypes';
  name: Scalars['String'];
};

/** aggregated selection of "account_types" */
export type AccountTypesAggregate = {
  __typename?: 'AccountTypesAggregate';
  aggregate?: Maybe<AccountTypesAggregateFields>;
  nodes: Array<AccountTypes>;
};

/** aggregate fields of "account_types" */
export type AccountTypesAggregateFields = {
  __typename?: 'AccountTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccountTypesMaxFields>;
  min?: Maybe<AccountTypesMinFields>;
};


/** aggregate fields of "account_types" */
export type AccountTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccountTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "account_types". All fields are combined with a logical 'AND'. */
export type AccountTypesBoolExp = {
  _and?: InputMaybe<Array<AccountTypesBoolExp>>;
  _not?: InputMaybe<AccountTypesBoolExp>;
  _or?: InputMaybe<Array<AccountTypesBoolExp>>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "account_types" */
export type AccountTypesConstraint =
  /** unique or primary key constraint on columns "name" */
  | 'account_types_pkey';

/** input type for inserting data into table "account_types" */
export type AccountTypesInsertInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AccountTypesMaxFields = {
  __typename?: 'AccountTypesMaxFields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AccountTypesMinFields = {
  __typename?: 'AccountTypesMinFields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "account_types" */
export type AccountTypesMutationResponse = {
  __typename?: 'AccountTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountTypes>;
};

/** on_conflict condition type for table "account_types" */
export type AccountTypesOnConflict = {
  constraint: AccountTypesConstraint;
  updateColumns?: Array<AccountTypesUpdateColumn>;
  where?: InputMaybe<AccountTypesBoolExp>;
};

/** Ordering options when selecting data from "account_types". */
export type AccountTypesOrderBy = {
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: account_types */
export type AccountTypesPkColumnsInput = {
  name: Scalars['String'];
};

/** select columns of table "account_types" */
export type AccountTypesSelectColumn =
  /** column name */
  | 'name';

/** input type for updating data in table "account_types" */
export type AccountTypesSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "account_types" */
export type AccountTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccountTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountTypesStreamCursorValueInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "account_types" */
export type AccountTypesUpdateColumn =
  /** column name */
  | 'name';

export type AccountTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountTypesSetInput>;
  /** filter the rows which have to be updated */
  where: AccountTypesBoolExp;
};

/** columns and relationships of "accounts" */
export type Accounts = {
  __typename?: 'Accounts';
  /** An array relationship */
  accountContacts: Array<AccountContacts>;
  /** An aggregate relationship */
  accountContactsAggregate: AccountContactsAggregate;
  accountCreatedAt: Scalars['timestamptz'];
  accountDisplayName: Scalars['String'];
  accountDisplayNameSetBySystem: Scalars['Boolean'];
  accountGuid: Scalars['uuid'];
  /** An object relationship */
  accountJobCount?: Maybe<AccountJobCounts>;
  /** An array relationship */
  accountLeadSource: Array<CompanyLeadSourceLinks>;
  /** An aggregate relationship */
  accountLeadSourceAggregate: CompanyLeadSourceLinksAggregate;
  /** An array relationship */
  accountLocations: Array<AccountLocations>;
  /** An aggregate relationship */
  accountLocationsAggregate: AccountLocationsAggregate;
  /** An object relationship */
  accountManager?: Maybe<Users>;
  accountManagerUserGuid?: Maybe<Scalars['uuid']>;
  accountNote?: Maybe<Scalars['String']>;
  accountReferenceNumber: Scalars['String'];
  accountType: Scalars['AccountType'];
  /** An array relationship */
  activityItems: Array<ActivityItems>;
  /** An aggregate relationship */
  activityItemsAggregate: ActivityItemsAggregate;
  /** An object relationship */
  aggregatableInvoices?: Maybe<AggregatableInvoices>;
  archived: Scalars['Boolean'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  customerNumber?: Maybe<Scalars['String']>;
  defaultInvoiceTerm: Scalars['InvoiceTermV2'];
  doNotService: Scalars['Boolean'];
  doNotServiceReason?: Maybe<Scalars['String']>;
  /** If set, Breezy will not sync this account/customer to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  /** An array relationship */
  fileLinks: Array<FileLinks>;
  /** An aggregate relationship */
  fileLinksAggregate: FileLinksAggregate;
  /** An array relationship */
  integratedPhoneCalls: Array<IntegratedPhoneCalls>;
  /** An aggregate relationship */
  integratedPhoneCallsAggregate: IntegratedPhoneCallsAggregate;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoicesAggregate: InvoicesAggregate;
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobsAggregate: JobsAggregate;
  /** The "work_completed_date" (or "created_at" if not completed) of the latest job */
  lastJobDate?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  mailingAddress?: Maybe<Addresses>;
  mailingAddressGuid?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  maintenancePlans: Array<MaintenancePlansQueryable>;
  /** An aggregate relationship */
  maintenancePlansAggregate: MaintenancePlansQueryableAggregate;
  /** An array relationship */
  noteLinks: Array<NoteLinks>;
  /** An aggregate relationship */
  noteLinksAggregate: NoteLinksAggregate;
  /** An array relationship */
  notes: Array<Notes>;
  /** An aggregate relationship */
  notesAggregate: NotesAggregate;
  /** An array relationship */
  paymentRecords: Array<PaymentRecords>;
  /** An aggregate relationship */
  paymentRecordsAggregate: PaymentRecordsAggregate;
  /** An array relationship */
  photoLinks: Array<PhotoLinks>;
  /** An aggregate relationship */
  photoLinksAggregate: PhotoLinksAggregate;
  /** An array relationship */
  tags: Array<AccountTags>;
  /** An aggregate relationship */
  tagsAggregate: AccountTagsAggregate;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  viewedByUsers: Array<AccountsViewedByUser>;
  /** An aggregate relationship */
  viewedByUsersAggregate: AccountsViewedByUserAggregate;
  /** An array relationship */
  wisetackLoanRecords: Array<WisetackLoanRecords>;
  /** An aggregate relationship */
  wisetackLoanRecordsAggregate: WisetackLoanRecordsAggregate;
  /** An array relationship */
  wisetackPrequalRecords: Array<WisetackPrequalRecords>;
  /** An aggregate relationship */
  wisetackPrequalRecordsAggregate: WisetackPrequalRecordsAggregate;
};


/** columns and relationships of "accounts" */
export type AccountsAccountContactsArgs = {
  distinctOn?: InputMaybe<Array<AccountContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountContactsOrderBy>>;
  where?: InputMaybe<AccountContactsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsAccountContactsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountContactsOrderBy>>;
  where?: InputMaybe<AccountContactsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsAccountLeadSourceArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourceLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourceLinksOrderBy>>;
  where?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsAccountLeadSourceAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourceLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourceLinksOrderBy>>;
  where?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsAccountLocationsArgs = {
  distinctOn?: InputMaybe<Array<AccountLocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountLocationsOrderBy>>;
  where?: InputMaybe<AccountLocationsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsAccountLocationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountLocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountLocationsOrderBy>>;
  where?: InputMaybe<AccountLocationsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsActivityItemsArgs = {
  distinctOn?: InputMaybe<Array<ActivityItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityItemsOrderBy>>;
  where?: InputMaybe<ActivityItemsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsActivityItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityItemsOrderBy>>;
  where?: InputMaybe<ActivityItemsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsFileLinksArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsFileLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsIntegratedPhoneCallsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsIntegratedPhoneCallsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsInvoicesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsJobsArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsMaintenancePlansArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlansQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlansQueryableOrderBy>>;
  where?: InputMaybe<MaintenancePlansQueryableBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsMaintenancePlansAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlansQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlansQueryableOrderBy>>;
  where?: InputMaybe<MaintenancePlansQueryableBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsNoteLinksArgs = {
  distinctOn?: InputMaybe<Array<NoteLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteLinksOrderBy>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsNoteLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteLinksOrderBy>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsNotesArgs = {
  distinctOn?: InputMaybe<Array<NotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
  where?: InputMaybe<NotesBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsNotesAggregateArgs = {
  distinctOn?: InputMaybe<Array<NotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
  where?: InputMaybe<NotesBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsPaymentRecordsArgs = {
  distinctOn?: InputMaybe<Array<PaymentRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecordsOrderBy>>;
  where?: InputMaybe<PaymentRecordsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsPaymentRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecordsOrderBy>>;
  where?: InputMaybe<PaymentRecordsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsPhotoLinksArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsPhotoLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsTagsArgs = {
  distinctOn?: InputMaybe<Array<AccountTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountTagsOrderBy>>;
  where?: InputMaybe<AccountTagsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsTagsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountTagsOrderBy>>;
  where?: InputMaybe<AccountTagsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsViewedByUsersArgs = {
  distinctOn?: InputMaybe<Array<AccountsViewedByUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsViewedByUserOrderBy>>;
  where?: InputMaybe<AccountsViewedByUserBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsViewedByUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountsViewedByUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsViewedByUserOrderBy>>;
  where?: InputMaybe<AccountsViewedByUserBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsWisetackLoanRecordsArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanRecordsOrderBy>>;
  where?: InputMaybe<WisetackLoanRecordsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsWisetackLoanRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanRecordsOrderBy>>;
  where?: InputMaybe<WisetackLoanRecordsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsWisetackPrequalRecordsArgs = {
  distinctOn?: InputMaybe<Array<WisetackPrequalRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackPrequalRecordsOrderBy>>;
  where?: InputMaybe<WisetackPrequalRecordsBoolExp>;
};


/** columns and relationships of "accounts" */
export type AccountsWisetackPrequalRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackPrequalRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackPrequalRecordsOrderBy>>;
  where?: InputMaybe<WisetackPrequalRecordsBoolExp>;
};

/** aggregated selection of "accounts" */
export type AccountsAggregate = {
  __typename?: 'AccountsAggregate';
  aggregate?: Maybe<AccountsAggregateFields>;
  nodes: Array<Accounts>;
};

export type AccountsAggregateBoolExp = {
  bool_and?: InputMaybe<AccountsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<AccountsAggregateBoolExpBool_Or>;
  count?: InputMaybe<AccountsAggregateBoolExpCount>;
};

/** aggregate fields of "accounts" */
export type AccountsAggregateFields = {
  __typename?: 'AccountsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccountsMaxFields>;
  min?: Maybe<AccountsMinFields>;
};


/** aggregate fields of "accounts" */
export type AccountsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "accounts" */
export type AccountsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AccountsMaxOrderBy>;
  min?: InputMaybe<AccountsMinOrderBy>;
};

/** input type for inserting array relation for remote table "accounts" */
export type AccountsArrRelInsertInput = {
  data: Array<AccountsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AccountsOnConflict>;
};

/** Boolean expression to filter rows from the table "accounts". All fields are combined with a logical 'AND'. */
export type AccountsBoolExp = {
  _and?: InputMaybe<Array<AccountsBoolExp>>;
  _not?: InputMaybe<AccountsBoolExp>;
  _or?: InputMaybe<Array<AccountsBoolExp>>;
  accountContacts?: InputMaybe<AccountContactsBoolExp>;
  accountContactsAggregate?: InputMaybe<AccountContactsAggregateBoolExp>;
  accountCreatedAt?: InputMaybe<TimestamptzComparisonExp>;
  accountDisplayName?: InputMaybe<StringComparisonExp>;
  accountDisplayNameSetBySystem?: InputMaybe<BooleanComparisonExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  accountJobCount?: InputMaybe<AccountJobCountsBoolExp>;
  accountLeadSource?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
  accountLeadSourceAggregate?: InputMaybe<CompanyLeadSourceLinksAggregateBoolExp>;
  accountLocations?: InputMaybe<AccountLocationsBoolExp>;
  accountLocationsAggregate?: InputMaybe<AccountLocationsAggregateBoolExp>;
  accountManager?: InputMaybe<UsersBoolExp>;
  accountManagerUserGuid?: InputMaybe<UuidComparisonExp>;
  accountNote?: InputMaybe<StringComparisonExp>;
  accountReferenceNumber?: InputMaybe<StringComparisonExp>;
  accountType?: InputMaybe<Scalars['AccountTypeComparisonExp']>;
  activityItems?: InputMaybe<ActivityItemsBoolExp>;
  activityItemsAggregate?: InputMaybe<ActivityItemsAggregateBoolExp>;
  aggregatableInvoices?: InputMaybe<AggregatableInvoicesBoolExp>;
  archived?: InputMaybe<BooleanComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customerNumber?: InputMaybe<StringComparisonExp>;
  defaultInvoiceTerm?: InputMaybe<Scalars['InvoiceTermV2ComparisonExp']>;
  doNotService?: InputMaybe<BooleanComparisonExp>;
  doNotServiceReason?: InputMaybe<StringComparisonExp>;
  doNotSyncToAccountingServiceReason?: InputMaybe<StringComparisonExp>;
  fileLinks?: InputMaybe<FileLinksBoolExp>;
  fileLinksAggregate?: InputMaybe<FileLinksAggregateBoolExp>;
  integratedPhoneCalls?: InputMaybe<IntegratedPhoneCallsBoolExp>;
  integratedPhoneCallsAggregate?: InputMaybe<IntegratedPhoneCallsAggregateBoolExp>;
  invoices?: InputMaybe<InvoicesBoolExp>;
  invoicesAggregate?: InputMaybe<InvoicesAggregateBoolExp>;
  jobs?: InputMaybe<JobsBoolExp>;
  jobsAggregate?: InputMaybe<JobsAggregateBoolExp>;
  lastJobDate?: InputMaybe<TimestamptzComparisonExp>;
  mailingAddress?: InputMaybe<AddressesBoolExp>;
  mailingAddressGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlans?: InputMaybe<MaintenancePlansQueryableBoolExp>;
  maintenancePlansAggregate?: InputMaybe<MaintenancePlansQueryableAggregateBoolExp>;
  noteLinks?: InputMaybe<NoteLinksBoolExp>;
  noteLinksAggregate?: InputMaybe<NoteLinksAggregateBoolExp>;
  notes?: InputMaybe<NotesBoolExp>;
  notesAggregate?: InputMaybe<NotesAggregateBoolExp>;
  paymentRecords?: InputMaybe<PaymentRecordsBoolExp>;
  paymentRecordsAggregate?: InputMaybe<PaymentRecordsAggregateBoolExp>;
  photoLinks?: InputMaybe<PhotoLinksBoolExp>;
  photoLinksAggregate?: InputMaybe<PhotoLinksAggregateBoolExp>;
  tags?: InputMaybe<AccountTagsBoolExp>;
  tagsAggregate?: InputMaybe<AccountTagsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  viewedByUsers?: InputMaybe<AccountsViewedByUserBoolExp>;
  viewedByUsersAggregate?: InputMaybe<AccountsViewedByUserAggregateBoolExp>;
  wisetackLoanRecords?: InputMaybe<WisetackLoanRecordsBoolExp>;
  wisetackLoanRecordsAggregate?: InputMaybe<WisetackLoanRecordsAggregateBoolExp>;
  wisetackPrequalRecords?: InputMaybe<WisetackPrequalRecordsBoolExp>;
  wisetackPrequalRecordsAggregate?: InputMaybe<WisetackPrequalRecordsAggregateBoolExp>;
};

/** unique or primary key constraints on table "accounts" */
export type AccountsConstraint =
  /** unique or primary key constraint on columns "account_reference_number", "company_guid" */
  | 'accounts_company_guid_account_reference_number_key'
  /** unique or primary key constraint on columns "account_guid" */
  | 'accounts_pkey';

/** input type for inserting data into table "accounts" */
export type AccountsInsertInput = {
  accountContacts?: InputMaybe<AccountContactsArrRelInsertInput>;
  accountCreatedAt?: InputMaybe<Scalars['timestamptz']>;
  accountDisplayName?: InputMaybe<Scalars['String']>;
  accountDisplayNameSetBySystem?: InputMaybe<Scalars['Boolean']>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  accountLeadSource?: InputMaybe<CompanyLeadSourceLinksArrRelInsertInput>;
  accountLocations?: InputMaybe<AccountLocationsArrRelInsertInput>;
  accountManager?: InputMaybe<UsersObjRelInsertInput>;
  accountManagerUserGuid?: InputMaybe<Scalars['uuid']>;
  accountNote?: InputMaybe<Scalars['String']>;
  accountReferenceNumber?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Scalars['AccountType']>;
  activityItems?: InputMaybe<ActivityItemsArrRelInsertInput>;
  aggregatableInvoices?: InputMaybe<AggregatableInvoicesObjRelInsertInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerNumber?: InputMaybe<Scalars['String']>;
  defaultInvoiceTerm?: InputMaybe<Scalars['InvoiceTermV2']>;
  doNotService?: InputMaybe<Scalars['Boolean']>;
  doNotServiceReason?: InputMaybe<Scalars['String']>;
  /** If set, Breezy will not sync this account/customer to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  fileLinks?: InputMaybe<FileLinksArrRelInsertInput>;
  integratedPhoneCalls?: InputMaybe<IntegratedPhoneCallsArrRelInsertInput>;
  invoices?: InputMaybe<InvoicesArrRelInsertInput>;
  jobs?: InputMaybe<JobsArrRelInsertInput>;
  mailingAddress?: InputMaybe<AddressesObjRelInsertInput>;
  mailingAddressGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlans?: InputMaybe<MaintenancePlansQueryableArrRelInsertInput>;
  noteLinks?: InputMaybe<NoteLinksArrRelInsertInput>;
  notes?: InputMaybe<NotesArrRelInsertInput>;
  paymentRecords?: InputMaybe<PaymentRecordsArrRelInsertInput>;
  photoLinks?: InputMaybe<PhotoLinksArrRelInsertInput>;
  tags?: InputMaybe<AccountTagsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  viewedByUsers?: InputMaybe<AccountsViewedByUserArrRelInsertInput>;
  wisetackLoanRecords?: InputMaybe<WisetackLoanRecordsArrRelInsertInput>;
  wisetackPrequalRecords?: InputMaybe<WisetackPrequalRecordsArrRelInsertInput>;
};

/** aggregate max on columns */
export type AccountsMaxFields = {
  __typename?: 'AccountsMaxFields';
  accountCreatedAt?: Maybe<Scalars['timestamptz']>;
  accountDisplayName?: Maybe<Scalars['String']>;
  accountGuid?: Maybe<Scalars['uuid']>;
  accountManagerUserGuid?: Maybe<Scalars['uuid']>;
  accountNote?: Maybe<Scalars['String']>;
  accountReferenceNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['AccountType']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerNumber?: Maybe<Scalars['String']>;
  defaultInvoiceTerm?: Maybe<Scalars['InvoiceTermV2']>;
  doNotServiceReason?: Maybe<Scalars['String']>;
  /** If set, Breezy will not sync this account/customer to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  /** The "work_completed_date" (or "created_at" if not completed) of the latest job */
  lastJobDate?: Maybe<Scalars['timestamptz']>;
  mailingAddressGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "accounts" */
export type AccountsMaxOrderBy = {
  accountCreatedAt?: InputMaybe<OrderBy>;
  accountDisplayName?: InputMaybe<OrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  accountManagerUserGuid?: InputMaybe<OrderBy>;
  accountNote?: InputMaybe<OrderBy>;
  accountReferenceNumber?: InputMaybe<OrderBy>;
  accountType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerNumber?: InputMaybe<OrderBy>;
  defaultInvoiceTerm?: InputMaybe<OrderBy>;
  doNotServiceReason?: InputMaybe<OrderBy>;
  /** If set, Breezy will not sync this account/customer to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<OrderBy>;
  mailingAddressGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AccountsMinFields = {
  __typename?: 'AccountsMinFields';
  accountCreatedAt?: Maybe<Scalars['timestamptz']>;
  accountDisplayName?: Maybe<Scalars['String']>;
  accountGuid?: Maybe<Scalars['uuid']>;
  accountManagerUserGuid?: Maybe<Scalars['uuid']>;
  accountNote?: Maybe<Scalars['String']>;
  accountReferenceNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['AccountType']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customerNumber?: Maybe<Scalars['String']>;
  defaultInvoiceTerm?: Maybe<Scalars['InvoiceTermV2']>;
  doNotServiceReason?: Maybe<Scalars['String']>;
  /** If set, Breezy will not sync this account/customer to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  /** The "work_completed_date" (or "created_at" if not completed) of the latest job */
  lastJobDate?: Maybe<Scalars['timestamptz']>;
  mailingAddressGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "accounts" */
export type AccountsMinOrderBy = {
  accountCreatedAt?: InputMaybe<OrderBy>;
  accountDisplayName?: InputMaybe<OrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  accountManagerUserGuid?: InputMaybe<OrderBy>;
  accountNote?: InputMaybe<OrderBy>;
  accountReferenceNumber?: InputMaybe<OrderBy>;
  accountType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerNumber?: InputMaybe<OrderBy>;
  defaultInvoiceTerm?: InputMaybe<OrderBy>;
  doNotServiceReason?: InputMaybe<OrderBy>;
  /** If set, Breezy will not sync this account/customer to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<OrderBy>;
  mailingAddressGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "accounts" */
export type AccountsMutationResponse = {
  __typename?: 'AccountsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accounts>;
};

/** input type for inserting object relation for remote table "accounts" */
export type AccountsObjRelInsertInput = {
  data: AccountsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AccountsOnConflict>;
};

/** on_conflict condition type for table "accounts" */
export type AccountsOnConflict = {
  constraint: AccountsConstraint;
  updateColumns?: Array<AccountsUpdateColumn>;
  where?: InputMaybe<AccountsBoolExp>;
};

/** Ordering options when selecting data from "accounts". */
export type AccountsOrderBy = {
  accountContactsAggregate?: InputMaybe<AccountContactsAggregateOrderBy>;
  accountCreatedAt?: InputMaybe<OrderBy>;
  accountDisplayName?: InputMaybe<OrderBy>;
  accountDisplayNameSetBySystem?: InputMaybe<OrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  accountJobCount?: InputMaybe<AccountJobCountsOrderBy>;
  accountLeadSourceAggregate?: InputMaybe<CompanyLeadSourceLinksAggregateOrderBy>;
  accountLocationsAggregate?: InputMaybe<AccountLocationsAggregateOrderBy>;
  accountManager?: InputMaybe<UsersOrderBy>;
  accountManagerUserGuid?: InputMaybe<OrderBy>;
  accountNote?: InputMaybe<OrderBy>;
  accountReferenceNumber?: InputMaybe<OrderBy>;
  accountType?: InputMaybe<OrderBy>;
  activityItemsAggregate?: InputMaybe<ActivityItemsAggregateOrderBy>;
  aggregatableInvoices?: InputMaybe<AggregatableInvoicesOrderBy>;
  archived?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerNumber?: InputMaybe<OrderBy>;
  defaultInvoiceTerm?: InputMaybe<OrderBy>;
  doNotService?: InputMaybe<OrderBy>;
  doNotServiceReason?: InputMaybe<OrderBy>;
  doNotSyncToAccountingServiceReason?: InputMaybe<OrderBy>;
  fileLinksAggregate?: InputMaybe<FileLinksAggregateOrderBy>;
  integratedPhoneCallsAggregate?: InputMaybe<IntegratedPhoneCallsAggregateOrderBy>;
  invoicesAggregate?: InputMaybe<InvoicesAggregateOrderBy>;
  jobsAggregate?: InputMaybe<JobsAggregateOrderBy>;
  lastJobDate?: InputMaybe<OrderBy>;
  mailingAddress?: InputMaybe<AddressesOrderBy>;
  mailingAddressGuid?: InputMaybe<OrderBy>;
  maintenancePlansAggregate?: InputMaybe<MaintenancePlansQueryableAggregateOrderBy>;
  noteLinksAggregate?: InputMaybe<NoteLinksAggregateOrderBy>;
  notesAggregate?: InputMaybe<NotesAggregateOrderBy>;
  paymentRecordsAggregate?: InputMaybe<PaymentRecordsAggregateOrderBy>;
  photoLinksAggregate?: InputMaybe<PhotoLinksAggregateOrderBy>;
  tagsAggregate?: InputMaybe<AccountTagsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  viewedByUsersAggregate?: InputMaybe<AccountsViewedByUserAggregateOrderBy>;
  wisetackLoanRecordsAggregate?: InputMaybe<WisetackLoanRecordsAggregateOrderBy>;
  wisetackPrequalRecordsAggregate?: InputMaybe<WisetackPrequalRecordsAggregateOrderBy>;
};

/** primary key columns input for table: accounts */
export type AccountsPkColumnsInput = {
  accountGuid: Scalars['uuid'];
};

/** Aggregated view of account balances with aging buckets for accounts receivable management */
export type AccountsReceivable = {
  __typename?: 'AccountsReceivable';
  accountDisplayName?: Maybe<Scalars['String']>;
  accountGuid?: Maybe<Scalars['uuid']>;
  accountReferenceNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  calculatedAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  /** Amount not yet due in cents */
  currentUsc?: Maybe<Scalars['numeric']>;
  doNotService?: Maybe<Scalars['Boolean']>;
  hasPaymentMethodOnFile?: Maybe<Scalars['Boolean']>;
  invoiceCount?: Maybe<Scalars['bigint']>;
  /** Array of invoice GUIDs included in this account balance */
  invoiceGuids?: Maybe<Array<Scalars['uuid']>>;
  lastStatementEventType?: Maybe<Scalars['String']>;
  lastStatementSentAt?: Maybe<Scalars['timestamptz']>;
  lastStatementSentBy?: Maybe<Scalars['uuid']>;
  maxDaysOverdue?: Maybe<Scalars['Int']>;
  newestInvoiceCreatedDate?: Maybe<Scalars['timestamptz']>;
  newestInvoiceDueDate?: Maybe<Scalars['timestamptz']>;
  oldestInvoiceCreatedDate?: Maybe<Scalars['timestamptz']>;
  oldestInvoiceDueDate?: Maybe<Scalars['timestamptz']>;
  /** Amount 90+ days past due in cents */
  pastDue90PlusUsc?: Maybe<Scalars['numeric']>;
  /** Amount 1-30 days past due in cents */
  pastDue130Usc?: Maybe<Scalars['numeric']>;
  /** Amount 31-60 days past due in cents */
  pastDue3160Usc?: Maybe<Scalars['numeric']>;
  /** Amount 61-90 days past due in cents */
  pastDue6190Usc?: Maybe<Scalars['numeric']>;
  /** Total outstanding balance in cents (divide by 100 for dollars) */
  totalBalanceUsc?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "accounts_receivable" */
export type AccountsReceivableAggregate = {
  __typename?: 'AccountsReceivableAggregate';
  aggregate?: Maybe<AccountsReceivableAggregateFields>;
  nodes: Array<AccountsReceivable>;
};

/** aggregate fields of "accounts_receivable" */
export type AccountsReceivableAggregateFields = {
  __typename?: 'AccountsReceivableAggregateFields';
  avg?: Maybe<AccountsReceivableAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AccountsReceivableMaxFields>;
  min?: Maybe<AccountsReceivableMinFields>;
  stddev?: Maybe<AccountsReceivableStddevFields>;
  stddevPop?: Maybe<AccountsReceivableStddevPopFields>;
  stddevSamp?: Maybe<AccountsReceivableStddevSampFields>;
  sum?: Maybe<AccountsReceivableSumFields>;
  varPop?: Maybe<AccountsReceivableVarPopFields>;
  varSamp?: Maybe<AccountsReceivableVarSampFields>;
  variance?: Maybe<AccountsReceivableVarianceFields>;
};


/** aggregate fields of "accounts_receivable" */
export type AccountsReceivableAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccountsReceivableSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AccountsReceivableAvgFields = {
  __typename?: 'AccountsReceivableAvgFields';
  /** Amount not yet due in cents */
  currentUsc?: Maybe<Scalars['Float']>;
  invoiceCount?: Maybe<Scalars['Float']>;
  maxDaysOverdue?: Maybe<Scalars['Float']>;
  /** Amount 90+ days past due in cents */
  pastDue90PlusUsc?: Maybe<Scalars['Float']>;
  /** Amount 1-30 days past due in cents */
  pastDue130Usc?: Maybe<Scalars['Float']>;
  /** Amount 31-60 days past due in cents */
  pastDue3160Usc?: Maybe<Scalars['Float']>;
  /** Amount 61-90 days past due in cents */
  pastDue6190Usc?: Maybe<Scalars['Float']>;
  /** Total outstanding balance in cents (divide by 100 for dollars) */
  totalBalanceUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "accounts_receivable". All fields are combined with a logical 'AND'. */
export type AccountsReceivableBoolExp = {
  _and?: InputMaybe<Array<AccountsReceivableBoolExp>>;
  _not?: InputMaybe<AccountsReceivableBoolExp>;
  _or?: InputMaybe<Array<AccountsReceivableBoolExp>>;
  accountDisplayName?: InputMaybe<StringComparisonExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  accountReferenceNumber?: InputMaybe<StringComparisonExp>;
  accountType?: InputMaybe<StringComparisonExp>;
  archived?: InputMaybe<BooleanComparisonExp>;
  calculatedAt?: InputMaybe<TimestamptzComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  currentUsc?: InputMaybe<NumericComparisonExp>;
  doNotService?: InputMaybe<BooleanComparisonExp>;
  hasPaymentMethodOnFile?: InputMaybe<BooleanComparisonExp>;
  invoiceCount?: InputMaybe<BigintComparisonExp>;
  invoiceGuids?: InputMaybe<UuidArrayComparisonExp>;
  lastStatementEventType?: InputMaybe<StringComparisonExp>;
  lastStatementSentAt?: InputMaybe<TimestamptzComparisonExp>;
  lastStatementSentBy?: InputMaybe<UuidComparisonExp>;
  maxDaysOverdue?: InputMaybe<IntComparisonExp>;
  newestInvoiceCreatedDate?: InputMaybe<TimestamptzComparisonExp>;
  newestInvoiceDueDate?: InputMaybe<TimestamptzComparisonExp>;
  oldestInvoiceCreatedDate?: InputMaybe<TimestamptzComparisonExp>;
  oldestInvoiceDueDate?: InputMaybe<TimestamptzComparisonExp>;
  pastDue90PlusUsc?: InputMaybe<NumericComparisonExp>;
  pastDue130Usc?: InputMaybe<NumericComparisonExp>;
  pastDue3160Usc?: InputMaybe<NumericComparisonExp>;
  pastDue6190Usc?: InputMaybe<NumericComparisonExp>;
  totalBalanceUsc?: InputMaybe<NumericComparisonExp>;
};

/** aggregate max on columns */
export type AccountsReceivableMaxFields = {
  __typename?: 'AccountsReceivableMaxFields';
  accountDisplayName?: Maybe<Scalars['String']>;
  accountGuid?: Maybe<Scalars['uuid']>;
  accountReferenceNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  calculatedAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  /** Amount not yet due in cents */
  currentUsc?: Maybe<Scalars['numeric']>;
  invoiceCount?: Maybe<Scalars['bigint']>;
  /** Array of invoice GUIDs included in this account balance */
  invoiceGuids?: Maybe<Array<Scalars['uuid']>>;
  lastStatementEventType?: Maybe<Scalars['String']>;
  lastStatementSentAt?: Maybe<Scalars['timestamptz']>;
  lastStatementSentBy?: Maybe<Scalars['uuid']>;
  maxDaysOverdue?: Maybe<Scalars['Int']>;
  newestInvoiceCreatedDate?: Maybe<Scalars['timestamptz']>;
  newestInvoiceDueDate?: Maybe<Scalars['timestamptz']>;
  oldestInvoiceCreatedDate?: Maybe<Scalars['timestamptz']>;
  oldestInvoiceDueDate?: Maybe<Scalars['timestamptz']>;
  /** Amount 90+ days past due in cents */
  pastDue90PlusUsc?: Maybe<Scalars['numeric']>;
  /** Amount 1-30 days past due in cents */
  pastDue130Usc?: Maybe<Scalars['numeric']>;
  /** Amount 31-60 days past due in cents */
  pastDue3160Usc?: Maybe<Scalars['numeric']>;
  /** Amount 61-90 days past due in cents */
  pastDue6190Usc?: Maybe<Scalars['numeric']>;
  /** Total outstanding balance in cents (divide by 100 for dollars) */
  totalBalanceUsc?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type AccountsReceivableMinFields = {
  __typename?: 'AccountsReceivableMinFields';
  accountDisplayName?: Maybe<Scalars['String']>;
  accountGuid?: Maybe<Scalars['uuid']>;
  accountReferenceNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  calculatedAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  /** Amount not yet due in cents */
  currentUsc?: Maybe<Scalars['numeric']>;
  invoiceCount?: Maybe<Scalars['bigint']>;
  /** Array of invoice GUIDs included in this account balance */
  invoiceGuids?: Maybe<Array<Scalars['uuid']>>;
  lastStatementEventType?: Maybe<Scalars['String']>;
  lastStatementSentAt?: Maybe<Scalars['timestamptz']>;
  lastStatementSentBy?: Maybe<Scalars['uuid']>;
  maxDaysOverdue?: Maybe<Scalars['Int']>;
  newestInvoiceCreatedDate?: Maybe<Scalars['timestamptz']>;
  newestInvoiceDueDate?: Maybe<Scalars['timestamptz']>;
  oldestInvoiceCreatedDate?: Maybe<Scalars['timestamptz']>;
  oldestInvoiceDueDate?: Maybe<Scalars['timestamptz']>;
  /** Amount 90+ days past due in cents */
  pastDue90PlusUsc?: Maybe<Scalars['numeric']>;
  /** Amount 1-30 days past due in cents */
  pastDue130Usc?: Maybe<Scalars['numeric']>;
  /** Amount 31-60 days past due in cents */
  pastDue3160Usc?: Maybe<Scalars['numeric']>;
  /** Amount 61-90 days past due in cents */
  pastDue6190Usc?: Maybe<Scalars['numeric']>;
  /** Total outstanding balance in cents (divide by 100 for dollars) */
  totalBalanceUsc?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "accounts_receivable". */
export type AccountsReceivableOrderBy = {
  accountDisplayName?: InputMaybe<OrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  accountReferenceNumber?: InputMaybe<OrderBy>;
  accountType?: InputMaybe<OrderBy>;
  archived?: InputMaybe<OrderBy>;
  calculatedAt?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  currentUsc?: InputMaybe<OrderBy>;
  doNotService?: InputMaybe<OrderBy>;
  hasPaymentMethodOnFile?: InputMaybe<OrderBy>;
  invoiceCount?: InputMaybe<OrderBy>;
  invoiceGuids?: InputMaybe<OrderBy>;
  lastStatementEventType?: InputMaybe<OrderBy>;
  lastStatementSentAt?: InputMaybe<OrderBy>;
  lastStatementSentBy?: InputMaybe<OrderBy>;
  maxDaysOverdue?: InputMaybe<OrderBy>;
  newestInvoiceCreatedDate?: InputMaybe<OrderBy>;
  newestInvoiceDueDate?: InputMaybe<OrderBy>;
  oldestInvoiceCreatedDate?: InputMaybe<OrderBy>;
  oldestInvoiceDueDate?: InputMaybe<OrderBy>;
  pastDue90PlusUsc?: InputMaybe<OrderBy>;
  pastDue130Usc?: InputMaybe<OrderBy>;
  pastDue3160Usc?: InputMaybe<OrderBy>;
  pastDue6190Usc?: InputMaybe<OrderBy>;
  totalBalanceUsc?: InputMaybe<OrderBy>;
};

/** select columns of table "accounts_receivable" */
export type AccountsReceivableSelectColumn =
  /** column name */
  | 'accountDisplayName'
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'accountReferenceNumber'
  /** column name */
  | 'accountType'
  /** column name */
  | 'archived'
  /** column name */
  | 'calculatedAt'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'currentUsc'
  /** column name */
  | 'doNotService'
  /** column name */
  | 'hasPaymentMethodOnFile'
  /** column name */
  | 'invoiceCount'
  /** column name */
  | 'invoiceGuids'
  /** column name */
  | 'lastStatementEventType'
  /** column name */
  | 'lastStatementSentAt'
  /** column name */
  | 'lastStatementSentBy'
  /** column name */
  | 'maxDaysOverdue'
  /** column name */
  | 'newestInvoiceCreatedDate'
  /** column name */
  | 'newestInvoiceDueDate'
  /** column name */
  | 'oldestInvoiceCreatedDate'
  /** column name */
  | 'oldestInvoiceDueDate'
  /** column name */
  | 'pastDue90PlusUsc'
  /** column name */
  | 'pastDue130Usc'
  /** column name */
  | 'pastDue3160Usc'
  /** column name */
  | 'pastDue6190Usc'
  /** column name */
  | 'totalBalanceUsc';

/** aggregate stddev on columns */
export type AccountsReceivableStddevFields = {
  __typename?: 'AccountsReceivableStddevFields';
  /** Amount not yet due in cents */
  currentUsc?: Maybe<Scalars['Float']>;
  invoiceCount?: Maybe<Scalars['Float']>;
  maxDaysOverdue?: Maybe<Scalars['Float']>;
  /** Amount 90+ days past due in cents */
  pastDue90PlusUsc?: Maybe<Scalars['Float']>;
  /** Amount 1-30 days past due in cents */
  pastDue130Usc?: Maybe<Scalars['Float']>;
  /** Amount 31-60 days past due in cents */
  pastDue3160Usc?: Maybe<Scalars['Float']>;
  /** Amount 61-90 days past due in cents */
  pastDue6190Usc?: Maybe<Scalars['Float']>;
  /** Total outstanding balance in cents (divide by 100 for dollars) */
  totalBalanceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type AccountsReceivableStddevPopFields = {
  __typename?: 'AccountsReceivableStddevPopFields';
  /** Amount not yet due in cents */
  currentUsc?: Maybe<Scalars['Float']>;
  invoiceCount?: Maybe<Scalars['Float']>;
  maxDaysOverdue?: Maybe<Scalars['Float']>;
  /** Amount 90+ days past due in cents */
  pastDue90PlusUsc?: Maybe<Scalars['Float']>;
  /** Amount 1-30 days past due in cents */
  pastDue130Usc?: Maybe<Scalars['Float']>;
  /** Amount 31-60 days past due in cents */
  pastDue3160Usc?: Maybe<Scalars['Float']>;
  /** Amount 61-90 days past due in cents */
  pastDue6190Usc?: Maybe<Scalars['Float']>;
  /** Total outstanding balance in cents (divide by 100 for dollars) */
  totalBalanceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type AccountsReceivableStddevSampFields = {
  __typename?: 'AccountsReceivableStddevSampFields';
  /** Amount not yet due in cents */
  currentUsc?: Maybe<Scalars['Float']>;
  invoiceCount?: Maybe<Scalars['Float']>;
  maxDaysOverdue?: Maybe<Scalars['Float']>;
  /** Amount 90+ days past due in cents */
  pastDue90PlusUsc?: Maybe<Scalars['Float']>;
  /** Amount 1-30 days past due in cents */
  pastDue130Usc?: Maybe<Scalars['Float']>;
  /** Amount 31-60 days past due in cents */
  pastDue3160Usc?: Maybe<Scalars['Float']>;
  /** Amount 61-90 days past due in cents */
  pastDue6190Usc?: Maybe<Scalars['Float']>;
  /** Total outstanding balance in cents (divide by 100 for dollars) */
  totalBalanceUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "accounts_receivable" */
export type AccountsReceivableStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccountsReceivableStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountsReceivableStreamCursorValueInput = {
  accountDisplayName?: InputMaybe<Scalars['String']>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  accountReferenceNumber?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  calculatedAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  /** Amount not yet due in cents */
  currentUsc?: InputMaybe<Scalars['numeric']>;
  doNotService?: InputMaybe<Scalars['Boolean']>;
  hasPaymentMethodOnFile?: InputMaybe<Scalars['Boolean']>;
  invoiceCount?: InputMaybe<Scalars['bigint']>;
  /** Array of invoice GUIDs included in this account balance */
  invoiceGuids?: InputMaybe<Array<Scalars['uuid']>>;
  lastStatementEventType?: InputMaybe<Scalars['String']>;
  lastStatementSentAt?: InputMaybe<Scalars['timestamptz']>;
  lastStatementSentBy?: InputMaybe<Scalars['uuid']>;
  maxDaysOverdue?: InputMaybe<Scalars['Int']>;
  newestInvoiceCreatedDate?: InputMaybe<Scalars['timestamptz']>;
  newestInvoiceDueDate?: InputMaybe<Scalars['timestamptz']>;
  oldestInvoiceCreatedDate?: InputMaybe<Scalars['timestamptz']>;
  oldestInvoiceDueDate?: InputMaybe<Scalars['timestamptz']>;
  /** Amount 90+ days past due in cents */
  pastDue90PlusUsc?: InputMaybe<Scalars['numeric']>;
  /** Amount 1-30 days past due in cents */
  pastDue130Usc?: InputMaybe<Scalars['numeric']>;
  /** Amount 31-60 days past due in cents */
  pastDue3160Usc?: InputMaybe<Scalars['numeric']>;
  /** Amount 61-90 days past due in cents */
  pastDue6190Usc?: InputMaybe<Scalars['numeric']>;
  /** Total outstanding balance in cents (divide by 100 for dollars) */
  totalBalanceUsc?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type AccountsReceivableSumFields = {
  __typename?: 'AccountsReceivableSumFields';
  /** Amount not yet due in cents */
  currentUsc?: Maybe<Scalars['numeric']>;
  invoiceCount?: Maybe<Scalars['bigint']>;
  maxDaysOverdue?: Maybe<Scalars['Int']>;
  /** Amount 90+ days past due in cents */
  pastDue90PlusUsc?: Maybe<Scalars['numeric']>;
  /** Amount 1-30 days past due in cents */
  pastDue130Usc?: Maybe<Scalars['numeric']>;
  /** Amount 31-60 days past due in cents */
  pastDue3160Usc?: Maybe<Scalars['numeric']>;
  /** Amount 61-90 days past due in cents */
  pastDue6190Usc?: Maybe<Scalars['numeric']>;
  /** Total outstanding balance in cents (divide by 100 for dollars) */
  totalBalanceUsc?: Maybe<Scalars['numeric']>;
};

/** aggregate varPop on columns */
export type AccountsReceivableVarPopFields = {
  __typename?: 'AccountsReceivableVarPopFields';
  /** Amount not yet due in cents */
  currentUsc?: Maybe<Scalars['Float']>;
  invoiceCount?: Maybe<Scalars['Float']>;
  maxDaysOverdue?: Maybe<Scalars['Float']>;
  /** Amount 90+ days past due in cents */
  pastDue90PlusUsc?: Maybe<Scalars['Float']>;
  /** Amount 1-30 days past due in cents */
  pastDue130Usc?: Maybe<Scalars['Float']>;
  /** Amount 31-60 days past due in cents */
  pastDue3160Usc?: Maybe<Scalars['Float']>;
  /** Amount 61-90 days past due in cents */
  pastDue6190Usc?: Maybe<Scalars['Float']>;
  /** Total outstanding balance in cents (divide by 100 for dollars) */
  totalBalanceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type AccountsReceivableVarSampFields = {
  __typename?: 'AccountsReceivableVarSampFields';
  /** Amount not yet due in cents */
  currentUsc?: Maybe<Scalars['Float']>;
  invoiceCount?: Maybe<Scalars['Float']>;
  maxDaysOverdue?: Maybe<Scalars['Float']>;
  /** Amount 90+ days past due in cents */
  pastDue90PlusUsc?: Maybe<Scalars['Float']>;
  /** Amount 1-30 days past due in cents */
  pastDue130Usc?: Maybe<Scalars['Float']>;
  /** Amount 31-60 days past due in cents */
  pastDue3160Usc?: Maybe<Scalars['Float']>;
  /** Amount 61-90 days past due in cents */
  pastDue6190Usc?: Maybe<Scalars['Float']>;
  /** Total outstanding balance in cents (divide by 100 for dollars) */
  totalBalanceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AccountsReceivableVarianceFields = {
  __typename?: 'AccountsReceivableVarianceFields';
  /** Amount not yet due in cents */
  currentUsc?: Maybe<Scalars['Float']>;
  invoiceCount?: Maybe<Scalars['Float']>;
  maxDaysOverdue?: Maybe<Scalars['Float']>;
  /** Amount 90+ days past due in cents */
  pastDue90PlusUsc?: Maybe<Scalars['Float']>;
  /** Amount 1-30 days past due in cents */
  pastDue130Usc?: Maybe<Scalars['Float']>;
  /** Amount 31-60 days past due in cents */
  pastDue3160Usc?: Maybe<Scalars['Float']>;
  /** Amount 61-90 days past due in cents */
  pastDue6190Usc?: Maybe<Scalars['Float']>;
  /** Total outstanding balance in cents (divide by 100 for dollars) */
  totalBalanceUsc?: Maybe<Scalars['Float']>;
};

/** select columns of table "accounts" */
export type AccountsSelectColumn =
  /** column name */
  | 'accountCreatedAt'
  /** column name */
  | 'accountDisplayName'
  /** column name */
  | 'accountDisplayNameSetBySystem'
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'accountManagerUserGuid'
  /** column name */
  | 'accountNote'
  /** column name */
  | 'accountReferenceNumber'
  /** column name */
  | 'accountType'
  /** column name */
  | 'archived'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'customerNumber'
  /** column name */
  | 'defaultInvoiceTerm'
  /** column name */
  | 'doNotService'
  /** column name */
  | 'doNotServiceReason'
  /** column name */
  | 'doNotSyncToAccountingServiceReason'
  /** column name */
  | 'mailingAddressGuid'
  /** column name */
  | 'updatedAt';

/** select "accountsAggregateBoolExpBool_andArgumentsColumns" columns of table "accounts" */
export type AccountsSelectColumnAccountsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'accountDisplayNameSetBySystem'
  /** column name */
  | 'archived'
  /** column name */
  | 'doNotService';

/** select "accountsAggregateBoolExpBool_orArgumentsColumns" columns of table "accounts" */
export type AccountsSelectColumnAccountsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'accountDisplayNameSetBySystem'
  /** column name */
  | 'archived'
  /** column name */
  | 'doNotService';

/** input type for updating data in table "accounts" */
export type AccountsSetInput = {
  accountCreatedAt?: InputMaybe<Scalars['timestamptz']>;
  accountDisplayName?: InputMaybe<Scalars['String']>;
  accountDisplayNameSetBySystem?: InputMaybe<Scalars['Boolean']>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  accountManagerUserGuid?: InputMaybe<Scalars['uuid']>;
  accountNote?: InputMaybe<Scalars['String']>;
  accountReferenceNumber?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Scalars['AccountType']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerNumber?: InputMaybe<Scalars['String']>;
  defaultInvoiceTerm?: InputMaybe<Scalars['InvoiceTermV2']>;
  doNotService?: InputMaybe<Scalars['Boolean']>;
  doNotServiceReason?: InputMaybe<Scalars['String']>;
  /** If set, Breezy will not sync this account/customer to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  mailingAddressGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "accounts" */
export type AccountsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccountsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountsStreamCursorValueInput = {
  accountCreatedAt?: InputMaybe<Scalars['timestamptz']>;
  accountDisplayName?: InputMaybe<Scalars['String']>;
  accountDisplayNameSetBySystem?: InputMaybe<Scalars['Boolean']>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  accountManagerUserGuid?: InputMaybe<Scalars['uuid']>;
  accountNote?: InputMaybe<Scalars['String']>;
  accountReferenceNumber?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Scalars['AccountType']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerNumber?: InputMaybe<Scalars['String']>;
  defaultInvoiceTerm?: InputMaybe<Scalars['InvoiceTermV2']>;
  doNotService?: InputMaybe<Scalars['Boolean']>;
  doNotServiceReason?: InputMaybe<Scalars['String']>;
  /** If set, Breezy will not sync this account/customer to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  mailingAddressGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "accounts" */
export type AccountsUpdateColumn =
  /** column name */
  | 'accountCreatedAt'
  /** column name */
  | 'accountDisplayName'
  /** column name */
  | 'accountDisplayNameSetBySystem'
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'accountManagerUserGuid'
  /** column name */
  | 'accountNote'
  /** column name */
  | 'accountReferenceNumber'
  /** column name */
  | 'accountType'
  /** column name */
  | 'archived'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'customerNumber'
  /** column name */
  | 'defaultInvoiceTerm'
  /** column name */
  | 'doNotService'
  /** column name */
  | 'doNotServiceReason'
  /** column name */
  | 'doNotSyncToAccountingServiceReason'
  /** column name */
  | 'mailingAddressGuid'
  /** column name */
  | 'updatedAt';

export type AccountsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountsSetInput>;
  /** filter the rows which have to be updated */
  where: AccountsBoolExp;
};

/** This table keeps track of when a user last viewed an account */
export type AccountsViewedByUser = {
  __typename?: 'AccountsViewedByUser';
  /** An object relationship */
  account: Accounts;
  accountGuid: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  userGuid: Scalars['uuid'];
  viewedAt: Scalars['timestamptz'];
};

/** aggregated selection of "accounts_viewed_by_user" */
export type AccountsViewedByUserAggregate = {
  __typename?: 'AccountsViewedByUserAggregate';
  aggregate?: Maybe<AccountsViewedByUserAggregateFields>;
  nodes: Array<AccountsViewedByUser>;
};

export type AccountsViewedByUserAggregateBoolExp = {
  count?: InputMaybe<AccountsViewedByUserAggregateBoolExpCount>;
};

/** aggregate fields of "accounts_viewed_by_user" */
export type AccountsViewedByUserAggregateFields = {
  __typename?: 'AccountsViewedByUserAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AccountsViewedByUserMaxFields>;
  min?: Maybe<AccountsViewedByUserMinFields>;
};


/** aggregate fields of "accounts_viewed_by_user" */
export type AccountsViewedByUserAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AccountsViewedByUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "accounts_viewed_by_user" */
export type AccountsViewedByUserAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AccountsViewedByUserMaxOrderBy>;
  min?: InputMaybe<AccountsViewedByUserMinOrderBy>;
};

/** input type for inserting array relation for remote table "accounts_viewed_by_user" */
export type AccountsViewedByUserArrRelInsertInput = {
  data: Array<AccountsViewedByUserInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AccountsViewedByUserOnConflict>;
};

/** Boolean expression to filter rows from the table "accounts_viewed_by_user". All fields are combined with a logical 'AND'. */
export type AccountsViewedByUserBoolExp = {
  _and?: InputMaybe<Array<AccountsViewedByUserBoolExp>>;
  _not?: InputMaybe<AccountsViewedByUserBoolExp>;
  _or?: InputMaybe<Array<AccountsViewedByUserBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
  viewedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "accounts_viewed_by_user" */
export type AccountsViewedByUserConstraint =
  /** unique or primary key constraint on columns "account_guid", "user_guid" */
  | 'accounts_viewed_by_user_pkey';

/** input type for inserting data into table "accounts_viewed_by_user" */
export type AccountsViewedByUserInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AccountsViewedByUserMaxFields = {
  __typename?: 'AccountsViewedByUserMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
  viewedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "accounts_viewed_by_user" */
export type AccountsViewedByUserMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
  viewedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AccountsViewedByUserMinFields = {
  __typename?: 'AccountsViewedByUserMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
  viewedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "accounts_viewed_by_user" */
export type AccountsViewedByUserMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
  viewedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "accounts_viewed_by_user" */
export type AccountsViewedByUserMutationResponse = {
  __typename?: 'AccountsViewedByUserMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccountsViewedByUser>;
};

/** on_conflict condition type for table "accounts_viewed_by_user" */
export type AccountsViewedByUserOnConflict = {
  constraint: AccountsViewedByUserConstraint;
  updateColumns?: Array<AccountsViewedByUserUpdateColumn>;
  where?: InputMaybe<AccountsViewedByUserBoolExp>;
};

/** Ordering options when selecting data from "accounts_viewed_by_user". */
export type AccountsViewedByUserOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
  viewedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: accounts_viewed_by_user */
export type AccountsViewedByUserPkColumnsInput = {
  accountGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};

/** select columns of table "accounts_viewed_by_user" */
export type AccountsViewedByUserSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'userGuid'
  /** column name */
  | 'viewedAt';

/** input type for updating data in table "accounts_viewed_by_user" */
export type AccountsViewedByUserSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "accounts_viewed_by_user" */
export type AccountsViewedByUserStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AccountsViewedByUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AccountsViewedByUserStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "accounts_viewed_by_user" */
export type AccountsViewedByUserUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'userGuid'
  /** column name */
  | 'viewedAt';

export type AccountsViewedByUserUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccountsViewedByUserSetInput>;
  /** filter the rows which have to be updated */
  where: AccountsViewedByUserBoolExp;
};

export type ActivityItemTypesEnum =
  | 'APPOINTMENT_CONFIRMED'
  | 'APPOINTMENT_SCHEDULED'
  | 'ESTIMATE_CREATED'
  | 'INVOICE_CREATED'
  | 'MAINTENANCE_PLAN_ACTIVATED'
  | 'MAINTENANCE_PLAN_CANCELED'
  | 'MAINTENANCE_PLAN_CHANGED'
  | 'MAINTENANCE_PLAN_EXPIRED'
  | 'MAINTENANCE_PLAN_LAPSED'
  | 'NOTE_CREATED';

/** Boolean expression to compare columns of type "ActivityItemTypesEnum". All fields are combined with logical 'AND'. */
export type ActivityItemTypesEnumComparisonExp = {
  _eq?: InputMaybe<ActivityItemTypesEnum>;
  _in?: InputMaybe<Array<ActivityItemTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ActivityItemTypesEnum>;
  _nin?: InputMaybe<Array<ActivityItemTypesEnum>>;
};

/** columns and relationships of "activity_items" */
export type ActivityItems = {
  __typename?: 'ActivityItems';
  accountGuid?: Maybe<Scalars['uuid']>;
  activityItemGuid: Scalars['uuid'];
  activityItemType: ActivityItemTypesEnum;
  businessEventGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
  content: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  jobGuid?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "activity_items" */
export type ActivityItemsAggregate = {
  __typename?: 'ActivityItemsAggregate';
  aggregate?: Maybe<ActivityItemsAggregateFields>;
  nodes: Array<ActivityItems>;
};

export type ActivityItemsAggregateBoolExp = {
  count?: InputMaybe<ActivityItemsAggregateBoolExpCount>;
};

/** aggregate fields of "activity_items" */
export type ActivityItemsAggregateFields = {
  __typename?: 'ActivityItemsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ActivityItemsMaxFields>;
  min?: Maybe<ActivityItemsMinFields>;
};


/** aggregate fields of "activity_items" */
export type ActivityItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ActivityItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "activity_items" */
export type ActivityItemsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ActivityItemsMaxOrderBy>;
  min?: InputMaybe<ActivityItemsMinOrderBy>;
};

/** input type for inserting array relation for remote table "activity_items" */
export type ActivityItemsArrRelInsertInput = {
  data: Array<ActivityItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ActivityItemsOnConflict>;
};

/** Boolean expression to filter rows from the table "activity_items". All fields are combined with a logical 'AND'. */
export type ActivityItemsBoolExp = {
  _and?: InputMaybe<Array<ActivityItemsBoolExp>>;
  _not?: InputMaybe<ActivityItemsBoolExp>;
  _or?: InputMaybe<Array<ActivityItemsBoolExp>>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  activityItemGuid?: InputMaybe<UuidComparisonExp>;
  activityItemType?: InputMaybe<ActivityItemTypesEnumComparisonExp>;
  businessEventGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  content?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "activity_items" */
export type ActivityItemsConstraint =
  /** unique or primary key constraint on columns "activity_item_guid" */
  | 'activity_items_pkey';

/** input type for inserting data into table "activity_items" */
export type ActivityItemsInsertInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  activityItemGuid?: InputMaybe<Scalars['uuid']>;
  activityItemType?: InputMaybe<ActivityItemTypesEnum>;
  businessEventGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ActivityItemsMaxFields = {
  __typename?: 'ActivityItemsMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  activityItemGuid?: Maybe<Scalars['uuid']>;
  businessEventGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "activity_items" */
export type ActivityItemsMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  activityItemGuid?: InputMaybe<OrderBy>;
  businessEventGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ActivityItemsMinFields = {
  __typename?: 'ActivityItemsMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  activityItemGuid?: Maybe<Scalars['uuid']>;
  businessEventGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "activity_items" */
export type ActivityItemsMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  activityItemGuid?: InputMaybe<OrderBy>;
  businessEventGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "activity_items" */
export type ActivityItemsMutationResponse = {
  __typename?: 'ActivityItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ActivityItems>;
};

/** on_conflict condition type for table "activity_items" */
export type ActivityItemsOnConflict = {
  constraint: ActivityItemsConstraint;
  updateColumns?: Array<ActivityItemsUpdateColumn>;
  where?: InputMaybe<ActivityItemsBoolExp>;
};

/** Ordering options when selecting data from "activity_items". */
export type ActivityItemsOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  activityItemGuid?: InputMaybe<OrderBy>;
  activityItemType?: InputMaybe<OrderBy>;
  businessEventGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: activity_items */
export type ActivityItemsPkColumnsInput = {
  activityItemGuid: Scalars['uuid'];
};

/** select columns of table "activity_items" */
export type ActivityItemsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'activityItemGuid'
  /** column name */
  | 'activityItemType'
  /** column name */
  | 'businessEventGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobGuid';

/** input type for updating data in table "activity_items" */
export type ActivityItemsSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  activityItemGuid?: InputMaybe<Scalars['uuid']>;
  activityItemType?: InputMaybe<ActivityItemTypesEnum>;
  businessEventGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "activity_items" */
export type ActivityItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ActivityItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ActivityItemsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  activityItemGuid?: InputMaybe<Scalars['uuid']>;
  activityItemType?: InputMaybe<ActivityItemTypesEnum>;
  businessEventGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "activity_items" */
export type ActivityItemsUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'activityItemGuid'
  /** column name */
  | 'activityItemType'
  /** column name */
  | 'businessEventGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobGuid';

export type ActivityItemsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivityItemsSetInput>;
  /** filter the rows which have to be updated */
  where: ActivityItemsBoolExp;
};

/** columns and relationships of "addresses" */
export type Addresses = {
  __typename?: 'Addresses';
  addressGuid: Scalars['uuid'];
  canonicalFullAddress: Scalars['String'];
  city: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  /** A computed field that will calculate the distance between an addresses geo_location and another point. */
  distBetweenMeters?: Maybe<Scalars['float8']>;
  geoLocation: Scalars['Geo'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  /** An array relationship */
  locations: Array<Locations>;
  /** An aggregate relationship */
  locationsAggregate: LocationsAggregate;
  stateAbbreviation: Scalars['String'];
  zipCode: Scalars['String'];
};


/** columns and relationships of "addresses" */
export type AddressesDistBetweenMetersArgs = {
  args: DistBetweenMeters_Addresses_Args;
};


/** columns and relationships of "addresses" */
export type AddressesLocationsArgs = {
  distinctOn?: InputMaybe<Array<LocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
  where?: InputMaybe<LocationsBoolExp>;
};


/** columns and relationships of "addresses" */
export type AddressesLocationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
  where?: InputMaybe<LocationsBoolExp>;
};

/** aggregated selection of "addresses" */
export type AddressesAggregate = {
  __typename?: 'AddressesAggregate';
  aggregate?: Maybe<AddressesAggregateFields>;
  nodes: Array<Addresses>;
};

/** aggregate fields of "addresses" */
export type AddressesAggregateFields = {
  __typename?: 'AddressesAggregateFields';
  avg?: Maybe<AddressesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AddressesMaxFields>;
  min?: Maybe<AddressesMinFields>;
  stddev?: Maybe<AddressesStddevFields>;
  stddevPop?: Maybe<AddressesStddevPopFields>;
  stddevSamp?: Maybe<AddressesStddevSampFields>;
  sum?: Maybe<AddressesSumFields>;
  varPop?: Maybe<AddressesVarPopFields>;
  varSamp?: Maybe<AddressesVarSampFields>;
  variance?: Maybe<AddressesVarianceFields>;
};


/** aggregate fields of "addresses" */
export type AddressesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AddressesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AddressesAvgFields = {
  __typename?: 'AddressesAvgFields';
  /** A computed field that will calculate the distance between an addresses geo_location and another point. */
  distBetweenMeters?: Maybe<Scalars['float8']>;
};


/** aggregate avg on columns */
export type AddressesAvgFieldsDistBetweenMetersArgs = {
  args: DistBetweenMeters_Addresses_Args;
};

/** Boolean expression to filter rows from the table "addresses". All fields are combined with a logical 'AND'. */
export type AddressesBoolExp = {
  _and?: InputMaybe<Array<AddressesBoolExp>>;
  _not?: InputMaybe<AddressesBoolExp>;
  _or?: InputMaybe<Array<AddressesBoolExp>>;
  addressGuid?: InputMaybe<UuidComparisonExp>;
  canonicalFullAddress?: InputMaybe<StringComparisonExp>;
  city?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  geoLocation?: InputMaybe<Scalars['GeoComparisonExp']>;
  line1?: InputMaybe<StringComparisonExp>;
  line2?: InputMaybe<StringComparisonExp>;
  locations?: InputMaybe<LocationsBoolExp>;
  locationsAggregate?: InputMaybe<LocationsAggregateBoolExp>;
  stateAbbreviation?: InputMaybe<StringComparisonExp>;
  zipCode?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "addresses" */
export type AddressesConstraint =
  /** unique or primary key constraint on columns "canonical_full_address" */
  | 'addresses_canonical_full_address_key'
  /** unique or primary key constraint on columns "address_guid" */
  | 'addresses_pkey';

/** input type for inserting data into table "addresses" */
export type AddressesInsertInput = {
  addressGuid?: InputMaybe<Scalars['uuid']>;
  canonicalFullAddress?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  geoLocation?: InputMaybe<Scalars['Geo']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationsArrRelInsertInput>;
  stateAbbreviation?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AddressesMaxFields = {
  __typename?: 'AddressesMaxFields';
  addressGuid?: Maybe<Scalars['uuid']>;
  canonicalFullAddress?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field that will calculate the distance between an addresses geo_location and another point. */
  distBetweenMeters?: Maybe<Scalars['float8']>;
  geoLocation?: Maybe<Scalars['Geo']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};


/** aggregate max on columns */
export type AddressesMaxFieldsDistBetweenMetersArgs = {
  args: DistBetweenMeters_Addresses_Args;
};

/** aggregate min on columns */
export type AddressesMinFields = {
  __typename?: 'AddressesMinFields';
  addressGuid?: Maybe<Scalars['uuid']>;
  canonicalFullAddress?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field that will calculate the distance between an addresses geo_location and another point. */
  distBetweenMeters?: Maybe<Scalars['float8']>;
  geoLocation?: Maybe<Scalars['Geo']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};


/** aggregate min on columns */
export type AddressesMinFieldsDistBetweenMetersArgs = {
  args: DistBetweenMeters_Addresses_Args;
};

/** response of any mutation on the table "addresses" */
export type AddressesMutationResponse = {
  __typename?: 'AddressesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Addresses>;
};

/** input type for inserting object relation for remote table "addresses" */
export type AddressesObjRelInsertInput = {
  data: AddressesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AddressesOnConflict>;
};

/** on_conflict condition type for table "addresses" */
export type AddressesOnConflict = {
  constraint: AddressesConstraint;
  updateColumns?: Array<AddressesUpdateColumn>;
  where?: InputMaybe<AddressesBoolExp>;
};

/** Ordering options when selecting data from "addresses". */
export type AddressesOrderBy = {
  addressGuid?: InputMaybe<OrderBy>;
  canonicalFullAddress?: InputMaybe<OrderBy>;
  city?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  geoLocation?: InputMaybe<OrderBy>;
  line1?: InputMaybe<OrderBy>;
  line2?: InputMaybe<OrderBy>;
  locationsAggregate?: InputMaybe<LocationsAggregateOrderBy>;
  stateAbbreviation?: InputMaybe<OrderBy>;
  zipCode?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: addresses */
export type AddressesPkColumnsInput = {
  addressGuid: Scalars['uuid'];
};

/** select columns of table "addresses" */
export type AddressesSelectColumn =
  /** column name */
  | 'addressGuid'
  /** column name */
  | 'canonicalFullAddress'
  /** column name */
  | 'city'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'geoLocation'
  /** column name */
  | 'line1'
  /** column name */
  | 'line2'
  /** column name */
  | 'stateAbbreviation'
  /** column name */
  | 'zipCode';

/** input type for updating data in table "addresses" */
export type AddressesSetInput = {
  addressGuid?: InputMaybe<Scalars['uuid']>;
  canonicalFullAddress?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  geoLocation?: InputMaybe<Scalars['Geo']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  stateAbbreviation?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AddressesStddevFields = {
  __typename?: 'AddressesStddevFields';
  /** A computed field that will calculate the distance between an addresses geo_location and another point. */
  distBetweenMeters?: Maybe<Scalars['float8']>;
};


/** aggregate stddev on columns */
export type AddressesStddevFieldsDistBetweenMetersArgs = {
  args: DistBetweenMeters_Addresses_Args;
};

/** aggregate stddevPop on columns */
export type AddressesStddevPopFields = {
  __typename?: 'AddressesStddevPopFields';
  /** A computed field that will calculate the distance between an addresses geo_location and another point. */
  distBetweenMeters?: Maybe<Scalars['float8']>;
};


/** aggregate stddevPop on columns */
export type AddressesStddevPopFieldsDistBetweenMetersArgs = {
  args: DistBetweenMeters_Addresses_Args;
};

/** aggregate stddevSamp on columns */
export type AddressesStddevSampFields = {
  __typename?: 'AddressesStddevSampFields';
  /** A computed field that will calculate the distance between an addresses geo_location and another point. */
  distBetweenMeters?: Maybe<Scalars['float8']>;
};


/** aggregate stddevSamp on columns */
export type AddressesStddevSampFieldsDistBetweenMetersArgs = {
  args: DistBetweenMeters_Addresses_Args;
};

/** Streaming cursor of the table "addresses" */
export type AddressesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AddressesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AddressesStreamCursorValueInput = {
  addressGuid?: InputMaybe<Scalars['uuid']>;
  canonicalFullAddress?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  geoLocation?: InputMaybe<Scalars['Geo']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  stateAbbreviation?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AddressesSumFields = {
  __typename?: 'AddressesSumFields';
  /** A computed field that will calculate the distance between an addresses geo_location and another point. */
  distBetweenMeters?: Maybe<Scalars['float8']>;
};


/** aggregate sum on columns */
export type AddressesSumFieldsDistBetweenMetersArgs = {
  args: DistBetweenMeters_Addresses_Args;
};

/** update columns of table "addresses" */
export type AddressesUpdateColumn =
  /** column name */
  | 'addressGuid'
  /** column name */
  | 'canonicalFullAddress'
  /** column name */
  | 'city'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'geoLocation'
  /** column name */
  | 'line1'
  /** column name */
  | 'line2'
  /** column name */
  | 'stateAbbreviation'
  /** column name */
  | 'zipCode';

export type AddressesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AddressesSetInput>;
  /** filter the rows which have to be updated */
  where: AddressesBoolExp;
};

/** aggregate varPop on columns */
export type AddressesVarPopFields = {
  __typename?: 'AddressesVarPopFields';
  /** A computed field that will calculate the distance between an addresses geo_location and another point. */
  distBetweenMeters?: Maybe<Scalars['float8']>;
};


/** aggregate varPop on columns */
export type AddressesVarPopFieldsDistBetweenMetersArgs = {
  args: DistBetweenMeters_Addresses_Args;
};

/** aggregate varSamp on columns */
export type AddressesVarSampFields = {
  __typename?: 'AddressesVarSampFields';
  /** A computed field that will calculate the distance between an addresses geo_location and another point. */
  distBetweenMeters?: Maybe<Scalars['float8']>;
};


/** aggregate varSamp on columns */
export type AddressesVarSampFieldsDistBetweenMetersArgs = {
  args: DistBetweenMeters_Addresses_Args;
};

/** aggregate variance on columns */
export type AddressesVarianceFields = {
  __typename?: 'AddressesVarianceFields';
  /** A computed field that will calculate the distance between an addresses geo_location and another point. */
  distBetweenMeters?: Maybe<Scalars['float8']>;
};


/** aggregate variance on columns */
export type AddressesVarianceFieldsDistBetweenMetersArgs = {
  args: DistBetweenMeters_Addresses_Args;
};

/** columns and relationships of "aggregatable_invoices" */
export type AggregatableInvoices = {
  __typename?: 'AggregatableInvoices';
  /** An object relationship */
  account?: Maybe<Accounts>;
  accountGuid: Scalars['uuid'];
  billingAddressGuid?: Maybe<Scalars['uuid']>;
  billingContactGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  businessUnitLink?: Maybe<InvoiceBusinessUnit>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy: Scalars['uuid'];
  /** An object relationship */
  createdByUser?: Maybe<Users>;
  customerPurchaseOrderNumber?: Maybe<Scalars['String']>;
  daysUnpaid?: Maybe<Scalars['numeric']>;
  displayId: Scalars['Int'];
  displayIdString?: Maybe<Scalars['String']>;
  displayIdV2?: Maybe<Scalars['String']>;
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  dueUsc?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  invoice?: Maybe<Invoices>;
  /** An array relationship */
  invoiceEvents: Array<InvoiceEvents>;
  /** An aggregate relationship */
  invoiceEventsAggregate: InvoiceEventsAggregate;
  invoiceGuid: Scalars['uuid'];
  /** An array relationship */
  invoicePayments: Array<InvoicePayments>;
  /** An aggregate relationship */
  invoicePaymentsAggregate: InvoicePaymentsAggregate;
  invoiceTerm: Scalars['InvoiceTermV2'];
  isTerminalStatus: Scalars['Boolean'];
  issuedAt?: Maybe<Scalars['timestamptz']>;
  issuedOrCreatedAt: Scalars['timestamptz'];
  /** An object relationship */
  jobLink?: Maybe<JobInvoices>;
  lastPaidAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  locationLink?: Maybe<LocationInvoices>;
  /** An object relationship */
  maintenancePlanLink?: Maybe<MaintenancePlanInvoices>;
  messageHtml?: Maybe<Scalars['HtmlString']>;
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidUsc?: Maybe<Scalars['numeric']>;
  paidUsd: Scalars['Int'];
  processingUsc?: Maybe<Scalars['numeric']>;
  processingUsd: Scalars['Int'];
  serviceAddressGuid?: Maybe<Scalars['uuid']>;
  serviceCompletionDate?: Maybe<Scalars['date']>;
  signatureFileUrl?: Maybe<Scalars['String']>;
  status: Scalars['InvoiceV2Status'];
  subtotalUsc?: Maybe<Scalars['Int']>;
  taxRate?: Maybe<Scalars['numeric']>;
  taxRateGuid?: Maybe<Scalars['uuid']>;
  taxRateName?: Maybe<Scalars['String']>;
  totalUsc: Scalars['Int'];
  totalUscString?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "aggregatable_invoices" */
export type AggregatableInvoicesInvoiceEventsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceEventsOrderBy>>;
  where?: InputMaybe<InvoiceEventsBoolExp>;
};


/** columns and relationships of "aggregatable_invoices" */
export type AggregatableInvoicesInvoiceEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceEventsOrderBy>>;
  where?: InputMaybe<InvoiceEventsBoolExp>;
};


/** columns and relationships of "aggregatable_invoices" */
export type AggregatableInvoicesInvoicePaymentsArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


/** columns and relationships of "aggregatable_invoices" */
export type AggregatableInvoicesInvoicePaymentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};

/** aggregated selection of "aggregatable_invoices" */
export type AggregatableInvoicesAggregate = {
  __typename?: 'AggregatableInvoicesAggregate';
  aggregate?: Maybe<AggregatableInvoicesAggregateFields>;
  nodes: Array<AggregatableInvoices>;
};

/** aggregate fields of "aggregatable_invoices" */
export type AggregatableInvoicesAggregateFields = {
  __typename?: 'AggregatableInvoicesAggregateFields';
  avg?: Maybe<AggregatableInvoicesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AggregatableInvoicesMaxFields>;
  min?: Maybe<AggregatableInvoicesMinFields>;
  stddev?: Maybe<AggregatableInvoicesStddevFields>;
  stddevPop?: Maybe<AggregatableInvoicesStddevPopFields>;
  stddevSamp?: Maybe<AggregatableInvoicesStddevSampFields>;
  sum?: Maybe<AggregatableInvoicesSumFields>;
  varPop?: Maybe<AggregatableInvoicesVarPopFields>;
  varSamp?: Maybe<AggregatableInvoicesVarSampFields>;
  variance?: Maybe<AggregatableInvoicesVarianceFields>;
};


/** aggregate fields of "aggregatable_invoices" */
export type AggregatableInvoicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AggregatableInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AggregatableInvoicesAvgFields = {
  __typename?: 'AggregatableInvoicesAvgFields';
  daysUnpaid?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  dueUsc?: Maybe<Scalars['Float']>;
  numDaysOverdue?: Maybe<Scalars['Float']>;
  paidUsc?: Maybe<Scalars['Float']>;
  paidUsd?: Maybe<Scalars['Float']>;
  processingUsc?: Maybe<Scalars['Float']>;
  processingUsd?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "aggregatable_invoices". All fields are combined with a logical 'AND'. */
export type AggregatableInvoicesBoolExp = {
  _and?: InputMaybe<Array<AggregatableInvoicesBoolExp>>;
  _not?: InputMaybe<AggregatableInvoicesBoolExp>;
  _or?: InputMaybe<Array<AggregatableInvoicesBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  billingAddressGuid?: InputMaybe<UuidComparisonExp>;
  billingContactGuid?: InputMaybe<UuidComparisonExp>;
  businessUnitLink?: InputMaybe<InvoiceBusinessUnitBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  customerPurchaseOrderNumber?: InputMaybe<StringComparisonExp>;
  daysUnpaid?: InputMaybe<NumericComparisonExp>;
  displayId?: InputMaybe<IntComparisonExp>;
  displayIdString?: InputMaybe<StringComparisonExp>;
  displayIdV2?: InputMaybe<StringComparisonExp>;
  doNotSyncToAccountingServiceReason?: InputMaybe<StringComparisonExp>;
  dueAt?: InputMaybe<TimestamptzComparisonExp>;
  dueUsc?: InputMaybe<NumericComparisonExp>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceEvents?: InputMaybe<InvoiceEventsBoolExp>;
  invoiceEventsAggregate?: InputMaybe<InvoiceEventsAggregateBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  invoicePayments?: InputMaybe<InvoicePaymentsBoolExp>;
  invoicePaymentsAggregate?: InputMaybe<InvoicePaymentsAggregateBoolExp>;
  invoiceTerm?: InputMaybe<Scalars['InvoiceTermV2ComparisonExp']>;
  isTerminalStatus?: InputMaybe<BooleanComparisonExp>;
  issuedAt?: InputMaybe<TimestamptzComparisonExp>;
  issuedOrCreatedAt?: InputMaybe<TimestamptzComparisonExp>;
  jobLink?: InputMaybe<JobInvoicesBoolExp>;
  lastPaidAt?: InputMaybe<TimestamptzComparisonExp>;
  locationLink?: InputMaybe<LocationInvoicesBoolExp>;
  maintenancePlanLink?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
  messageHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
  numDaysOverdue?: InputMaybe<IntComparisonExp>;
  paidUsc?: InputMaybe<NumericComparisonExp>;
  paidUsd?: InputMaybe<IntComparisonExp>;
  processingUsc?: InputMaybe<NumericComparisonExp>;
  processingUsd?: InputMaybe<IntComparisonExp>;
  serviceAddressGuid?: InputMaybe<UuidComparisonExp>;
  serviceCompletionDate?: InputMaybe<DateComparisonExp>;
  signatureFileUrl?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<Scalars['InvoiceV2StatusComparisonExp']>;
  subtotalUsc?: InputMaybe<IntComparisonExp>;
  taxRate?: InputMaybe<NumericComparisonExp>;
  taxRateGuid?: InputMaybe<UuidComparisonExp>;
  taxRateName?: InputMaybe<StringComparisonExp>;
  totalUsc?: InputMaybe<IntComparisonExp>;
  totalUscString?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "aggregatable_invoices" */
export type AggregatableInvoicesInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  billingAddressGuid?: InputMaybe<Scalars['uuid']>;
  billingContactGuid?: InputMaybe<Scalars['uuid']>;
  businessUnitLink?: InputMaybe<InvoiceBusinessUnitObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  customerPurchaseOrderNumber?: InputMaybe<Scalars['String']>;
  daysUnpaid?: InputMaybe<Scalars['numeric']>;
  displayId?: InputMaybe<Scalars['Int']>;
  displayIdString?: InputMaybe<Scalars['String']>;
  displayIdV2?: InputMaybe<Scalars['String']>;
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  dueUsc?: InputMaybe<Scalars['numeric']>;
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceEvents?: InputMaybe<InvoiceEventsArrRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoicePayments?: InputMaybe<InvoicePaymentsArrRelInsertInput>;
  invoiceTerm?: InputMaybe<Scalars['InvoiceTermV2']>;
  isTerminalStatus?: InputMaybe<Scalars['Boolean']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  issuedOrCreatedAt?: InputMaybe<Scalars['timestamptz']>;
  jobLink?: InputMaybe<JobInvoicesObjRelInsertInput>;
  lastPaidAt?: InputMaybe<Scalars['timestamptz']>;
  locationLink?: InputMaybe<LocationInvoicesObjRelInsertInput>;
  maintenancePlanLink?: InputMaybe<MaintenancePlanInvoicesObjRelInsertInput>;
  messageHtml?: InputMaybe<Scalars['HtmlString']>;
  numDaysOverdue?: InputMaybe<Scalars['Int']>;
  paidUsc?: InputMaybe<Scalars['numeric']>;
  paidUsd?: InputMaybe<Scalars['Int']>;
  processingUsc?: InputMaybe<Scalars['numeric']>;
  processingUsd?: InputMaybe<Scalars['Int']>;
  serviceAddressGuid?: InputMaybe<Scalars['uuid']>;
  serviceCompletionDate?: InputMaybe<Scalars['date']>;
  signatureFileUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['InvoiceV2Status']>;
  subtotalUsc?: InputMaybe<Scalars['Int']>;
  taxRate?: InputMaybe<Scalars['numeric']>;
  taxRateGuid?: InputMaybe<Scalars['uuid']>;
  taxRateName?: InputMaybe<Scalars['String']>;
  totalUsc?: InputMaybe<Scalars['Int']>;
  totalUscString?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AggregatableInvoicesMaxFields = {
  __typename?: 'AggregatableInvoicesMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  billingAddressGuid?: Maybe<Scalars['uuid']>;
  billingContactGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  customerPurchaseOrderNumber?: Maybe<Scalars['String']>;
  daysUnpaid?: Maybe<Scalars['numeric']>;
  displayId?: Maybe<Scalars['Int']>;
  displayIdString?: Maybe<Scalars['String']>;
  displayIdV2?: Maybe<Scalars['String']>;
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  dueUsc?: Maybe<Scalars['numeric']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceTerm?: Maybe<Scalars['InvoiceTermV2']>;
  isTerminalStatus?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  issuedOrCreatedAt?: Maybe<Scalars['timestamptz']>;
  lastPaidAt?: Maybe<Scalars['timestamptz']>;
  messageHtml?: Maybe<Scalars['HtmlString']>;
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidUsc?: Maybe<Scalars['numeric']>;
  paidUsd?: Maybe<Scalars['Int']>;
  processingUsc?: Maybe<Scalars['numeric']>;
  processingUsd?: Maybe<Scalars['Int']>;
  serviceAddressGuid?: Maybe<Scalars['uuid']>;
  serviceCompletionDate?: Maybe<Scalars['date']>;
  signatureFileUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['InvoiceV2Status']>;
  subtotalUsc?: Maybe<Scalars['Int']>;
  taxRate?: Maybe<Scalars['numeric']>;
  taxRateGuid?: Maybe<Scalars['uuid']>;
  taxRateName?: Maybe<Scalars['String']>;
  totalUsc?: Maybe<Scalars['Int']>;
  totalUscString?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type AggregatableInvoicesMinFields = {
  __typename?: 'AggregatableInvoicesMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  billingAddressGuid?: Maybe<Scalars['uuid']>;
  billingContactGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  customerPurchaseOrderNumber?: Maybe<Scalars['String']>;
  daysUnpaid?: Maybe<Scalars['numeric']>;
  displayId?: Maybe<Scalars['Int']>;
  displayIdString?: Maybe<Scalars['String']>;
  displayIdV2?: Maybe<Scalars['String']>;
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  dueUsc?: Maybe<Scalars['numeric']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceTerm?: Maybe<Scalars['InvoiceTermV2']>;
  isTerminalStatus?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  issuedOrCreatedAt?: Maybe<Scalars['timestamptz']>;
  lastPaidAt?: Maybe<Scalars['timestamptz']>;
  messageHtml?: Maybe<Scalars['HtmlString']>;
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidUsc?: Maybe<Scalars['numeric']>;
  paidUsd?: Maybe<Scalars['Int']>;
  processingUsc?: Maybe<Scalars['numeric']>;
  processingUsd?: Maybe<Scalars['Int']>;
  serviceAddressGuid?: Maybe<Scalars['uuid']>;
  serviceCompletionDate?: Maybe<Scalars['date']>;
  signatureFileUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['InvoiceV2Status']>;
  subtotalUsc?: Maybe<Scalars['Int']>;
  taxRate?: Maybe<Scalars['numeric']>;
  taxRateGuid?: Maybe<Scalars['uuid']>;
  taxRateName?: Maybe<Scalars['String']>;
  totalUsc?: Maybe<Scalars['Int']>;
  totalUscString?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "aggregatable_invoices" */
export type AggregatableInvoicesObjRelInsertInput = {
  data: AggregatableInvoicesInsertInput;
};

/** Ordering options when selecting data from "aggregatable_invoices". */
export type AggregatableInvoicesOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  billingAddressGuid?: InputMaybe<OrderBy>;
  billingContactGuid?: InputMaybe<OrderBy>;
  businessUnitLink?: InputMaybe<InvoiceBusinessUnitOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  customerPurchaseOrderNumber?: InputMaybe<OrderBy>;
  daysUnpaid?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  displayIdString?: InputMaybe<OrderBy>;
  displayIdV2?: InputMaybe<OrderBy>;
  doNotSyncToAccountingServiceReason?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  dueUsc?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceEventsAggregate?: InputMaybe<InvoiceEventsAggregateOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  invoicePaymentsAggregate?: InputMaybe<InvoicePaymentsAggregateOrderBy>;
  invoiceTerm?: InputMaybe<OrderBy>;
  isTerminalStatus?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  issuedOrCreatedAt?: InputMaybe<OrderBy>;
  jobLink?: InputMaybe<JobInvoicesOrderBy>;
  lastPaidAt?: InputMaybe<OrderBy>;
  locationLink?: InputMaybe<LocationInvoicesOrderBy>;
  maintenancePlanLink?: InputMaybe<MaintenancePlanInvoicesOrderBy>;
  messageHtml?: InputMaybe<OrderBy>;
  numDaysOverdue?: InputMaybe<OrderBy>;
  paidUsc?: InputMaybe<OrderBy>;
  paidUsd?: InputMaybe<OrderBy>;
  processingUsc?: InputMaybe<OrderBy>;
  processingUsd?: InputMaybe<OrderBy>;
  serviceAddressGuid?: InputMaybe<OrderBy>;
  serviceCompletionDate?: InputMaybe<OrderBy>;
  signatureFileUrl?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subtotalUsc?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  taxRateGuid?: InputMaybe<OrderBy>;
  taxRateName?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
  totalUscString?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "aggregatable_invoices" */
export type AggregatableInvoicesSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'billingAddressGuid'
  /** column name */
  | 'billingContactGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'customerPurchaseOrderNumber'
  /** column name */
  | 'daysUnpaid'
  /** column name */
  | 'displayId'
  /** column name */
  | 'displayIdString'
  /** column name */
  | 'displayIdV2'
  /** column name */
  | 'doNotSyncToAccountingServiceReason'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'dueUsc'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'invoiceTerm'
  /** column name */
  | 'isTerminalStatus'
  /** column name */
  | 'issuedAt'
  /** column name */
  | 'issuedOrCreatedAt'
  /** column name */
  | 'lastPaidAt'
  /** column name */
  | 'messageHtml'
  /** column name */
  | 'numDaysOverdue'
  /** column name */
  | 'paidUsc'
  /** column name */
  | 'paidUsd'
  /** column name */
  | 'processingUsc'
  /** column name */
  | 'processingUsd'
  /** column name */
  | 'serviceAddressGuid'
  /** column name */
  | 'serviceCompletionDate'
  /** column name */
  | 'signatureFileUrl'
  /** column name */
  | 'status'
  /** column name */
  | 'subtotalUsc'
  /** column name */
  | 'taxRate'
  /** column name */
  | 'taxRateGuid'
  /** column name */
  | 'taxRateName'
  /** column name */
  | 'totalUsc'
  /** column name */
  | 'totalUscString'
  /** column name */
  | 'updatedAt';

export type AggregatableInvoicesSetInput = {
  __typename?: 'AggregatableInvoicesSetInput';
  accountGuid?: Maybe<Scalars['uuid']>;
  createdBy?: Maybe<Scalars['uuid']>;
  displayId?: Maybe<Scalars['Int']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceTerm?: Maybe<Scalars['InvoiceTermV2']>;
  isTerminalStatus?: Maybe<Scalars['Boolean']>;
  issuedOrCreatedAt?: Maybe<Scalars['timestamptz']>;
  messageHtml?: Maybe<Scalars['HtmlString']>;
  paidUsd?: Maybe<Scalars['Int']>;
  processingUsd?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['InvoiceV2Status']>;
  totalUsc?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AggregatableInvoicesStddevFields = {
  __typename?: 'AggregatableInvoicesStddevFields';
  daysUnpaid?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  dueUsc?: Maybe<Scalars['Float']>;
  numDaysOverdue?: Maybe<Scalars['Float']>;
  paidUsc?: Maybe<Scalars['Float']>;
  paidUsd?: Maybe<Scalars['Float']>;
  processingUsc?: Maybe<Scalars['Float']>;
  processingUsd?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type AggregatableInvoicesStddevPopFields = {
  __typename?: 'AggregatableInvoicesStddevPopFields';
  daysUnpaid?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  dueUsc?: Maybe<Scalars['Float']>;
  numDaysOverdue?: Maybe<Scalars['Float']>;
  paidUsc?: Maybe<Scalars['Float']>;
  paidUsd?: Maybe<Scalars['Float']>;
  processingUsc?: Maybe<Scalars['Float']>;
  processingUsd?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type AggregatableInvoicesStddevSampFields = {
  __typename?: 'AggregatableInvoicesStddevSampFields';
  daysUnpaid?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  dueUsc?: Maybe<Scalars['Float']>;
  numDaysOverdue?: Maybe<Scalars['Float']>;
  paidUsc?: Maybe<Scalars['Float']>;
  paidUsd?: Maybe<Scalars['Float']>;
  processingUsc?: Maybe<Scalars['Float']>;
  processingUsd?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "aggregatable_invoices" */
export type AggregatableInvoicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AggregatableInvoicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AggregatableInvoicesStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  billingAddressGuid?: InputMaybe<Scalars['uuid']>;
  billingContactGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  customerPurchaseOrderNumber?: InputMaybe<Scalars['String']>;
  daysUnpaid?: InputMaybe<Scalars['numeric']>;
  displayId?: InputMaybe<Scalars['Int']>;
  displayIdString?: InputMaybe<Scalars['String']>;
  displayIdV2?: InputMaybe<Scalars['String']>;
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  dueUsc?: InputMaybe<Scalars['numeric']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoiceTerm?: InputMaybe<Scalars['InvoiceTermV2']>;
  isTerminalStatus?: InputMaybe<Scalars['Boolean']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  issuedOrCreatedAt?: InputMaybe<Scalars['timestamptz']>;
  lastPaidAt?: InputMaybe<Scalars['timestamptz']>;
  messageHtml?: InputMaybe<Scalars['HtmlString']>;
  numDaysOverdue?: InputMaybe<Scalars['Int']>;
  paidUsc?: InputMaybe<Scalars['numeric']>;
  paidUsd?: InputMaybe<Scalars['Int']>;
  processingUsc?: InputMaybe<Scalars['numeric']>;
  processingUsd?: InputMaybe<Scalars['Int']>;
  serviceAddressGuid?: InputMaybe<Scalars['uuid']>;
  serviceCompletionDate?: InputMaybe<Scalars['date']>;
  signatureFileUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['InvoiceV2Status']>;
  subtotalUsc?: InputMaybe<Scalars['Int']>;
  taxRate?: InputMaybe<Scalars['numeric']>;
  taxRateGuid?: InputMaybe<Scalars['uuid']>;
  taxRateName?: InputMaybe<Scalars['String']>;
  totalUsc?: InputMaybe<Scalars['Int']>;
  totalUscString?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type AggregatableInvoicesSumFields = {
  __typename?: 'AggregatableInvoicesSumFields';
  daysUnpaid?: Maybe<Scalars['numeric']>;
  displayId?: Maybe<Scalars['Int']>;
  dueUsc?: Maybe<Scalars['numeric']>;
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidUsc?: Maybe<Scalars['numeric']>;
  paidUsd?: Maybe<Scalars['numeric']>;
  processingUsc?: Maybe<Scalars['numeric']>;
  processingUsd?: Maybe<Scalars['numeric']>;
  subtotalUsc?: Maybe<Scalars['Int']>;
  taxRate?: Maybe<Scalars['numeric']>;
  totalUsc?: Maybe<Scalars['Int']>;
};

/** aggregate varPop on columns */
export type AggregatableInvoicesVarPopFields = {
  __typename?: 'AggregatableInvoicesVarPopFields';
  daysUnpaid?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  dueUsc?: Maybe<Scalars['Float']>;
  numDaysOverdue?: Maybe<Scalars['Float']>;
  paidUsc?: Maybe<Scalars['Float']>;
  paidUsd?: Maybe<Scalars['Float']>;
  processingUsc?: Maybe<Scalars['Float']>;
  processingUsd?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type AggregatableInvoicesVarSampFields = {
  __typename?: 'AggregatableInvoicesVarSampFields';
  daysUnpaid?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  dueUsc?: Maybe<Scalars['Float']>;
  numDaysOverdue?: Maybe<Scalars['Float']>;
  paidUsc?: Maybe<Scalars['Float']>;
  paidUsd?: Maybe<Scalars['Float']>;
  processingUsc?: Maybe<Scalars['Float']>;
  processingUsd?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AggregatableInvoicesVarianceFields = {
  __typename?: 'AggregatableInvoicesVarianceFields';
  daysUnpaid?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  dueUsc?: Maybe<Scalars['Float']>;
  numDaysOverdue?: Maybe<Scalars['Float']>;
  paidUsc?: Maybe<Scalars['Float']>;
  paidUsd?: Maybe<Scalars['Float']>;
  processingUsc?: Maybe<Scalars['Float']>;
  processingUsd?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "application_tasks" */
export type ApplicationTasks = {
  __typename?: 'ApplicationTasks';
  executionWorkerId?: Maybe<Scalars['String']>;
  sourceSystemInstanceId: Scalars['String'];
  sourceSystemName: Scalars['String'];
  sourceSystemVersion: Scalars['String'];
  taskAttemptCount: Scalars['numeric'];
  taskCompleted: Scalars['Boolean'];
  taskErrorMessage?: Maybe<Scalars['String']>;
  taskErroredAt?: Maybe<Scalars['timestamptz']>;
  taskGuid: Scalars['uuid'];
  taskInputJson?: Maybe<Scalars['jsonb']>;
  taskQueuedAt: Scalars['timestamptz'];
  taskScheduledExecutionTime?: Maybe<Scalars['timestamptz']>;
  taskStartedAt?: Maybe<Scalars['timestamptz']>;
  taskSucceededAt?: Maybe<Scalars['timestamptz']>;
  taskType: Scalars['String'];
};


/** columns and relationships of "application_tasks" */
export type ApplicationTasksTaskInputJsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "application_tasks" */
export type ApplicationTasksAggregate = {
  __typename?: 'ApplicationTasksAggregate';
  aggregate?: Maybe<ApplicationTasksAggregateFields>;
  nodes: Array<ApplicationTasks>;
};

/** aggregate fields of "application_tasks" */
export type ApplicationTasksAggregateFields = {
  __typename?: 'ApplicationTasksAggregateFields';
  avg?: Maybe<ApplicationTasksAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ApplicationTasksMaxFields>;
  min?: Maybe<ApplicationTasksMinFields>;
  stddev?: Maybe<ApplicationTasksStddevFields>;
  stddevPop?: Maybe<ApplicationTasksStddevPopFields>;
  stddevSamp?: Maybe<ApplicationTasksStddevSampFields>;
  sum?: Maybe<ApplicationTasksSumFields>;
  varPop?: Maybe<ApplicationTasksVarPopFields>;
  varSamp?: Maybe<ApplicationTasksVarSampFields>;
  variance?: Maybe<ApplicationTasksVarianceFields>;
};


/** aggregate fields of "application_tasks" */
export type ApplicationTasksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ApplicationTasksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ApplicationTasksAvgFields = {
  __typename?: 'ApplicationTasksAvgFields';
  taskAttemptCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "application_tasks". All fields are combined with a logical 'AND'. */
export type ApplicationTasksBoolExp = {
  _and?: InputMaybe<Array<ApplicationTasksBoolExp>>;
  _not?: InputMaybe<ApplicationTasksBoolExp>;
  _or?: InputMaybe<Array<ApplicationTasksBoolExp>>;
  executionWorkerId?: InputMaybe<StringComparisonExp>;
  sourceSystemInstanceId?: InputMaybe<StringComparisonExp>;
  sourceSystemName?: InputMaybe<StringComparisonExp>;
  sourceSystemVersion?: InputMaybe<StringComparisonExp>;
  taskAttemptCount?: InputMaybe<NumericComparisonExp>;
  taskCompleted?: InputMaybe<BooleanComparisonExp>;
  taskErrorMessage?: InputMaybe<StringComparisonExp>;
  taskErroredAt?: InputMaybe<TimestamptzComparisonExp>;
  taskGuid?: InputMaybe<UuidComparisonExp>;
  taskInputJson?: InputMaybe<JsonbComparisonExp>;
  taskQueuedAt?: InputMaybe<TimestamptzComparisonExp>;
  taskScheduledExecutionTime?: InputMaybe<TimestamptzComparisonExp>;
  taskStartedAt?: InputMaybe<TimestamptzComparisonExp>;
  taskSucceededAt?: InputMaybe<TimestamptzComparisonExp>;
  taskType?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type ApplicationTasksMaxFields = {
  __typename?: 'ApplicationTasksMaxFields';
  executionWorkerId?: Maybe<Scalars['String']>;
  sourceSystemInstanceId?: Maybe<Scalars['String']>;
  sourceSystemName?: Maybe<Scalars['String']>;
  sourceSystemVersion?: Maybe<Scalars['String']>;
  taskAttemptCount?: Maybe<Scalars['numeric']>;
  taskErrorMessage?: Maybe<Scalars['String']>;
  taskErroredAt?: Maybe<Scalars['timestamptz']>;
  taskGuid?: Maybe<Scalars['uuid']>;
  taskQueuedAt?: Maybe<Scalars['timestamptz']>;
  taskScheduledExecutionTime?: Maybe<Scalars['timestamptz']>;
  taskStartedAt?: Maybe<Scalars['timestamptz']>;
  taskSucceededAt?: Maybe<Scalars['timestamptz']>;
  taskType?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ApplicationTasksMinFields = {
  __typename?: 'ApplicationTasksMinFields';
  executionWorkerId?: Maybe<Scalars['String']>;
  sourceSystemInstanceId?: Maybe<Scalars['String']>;
  sourceSystemName?: Maybe<Scalars['String']>;
  sourceSystemVersion?: Maybe<Scalars['String']>;
  taskAttemptCount?: Maybe<Scalars['numeric']>;
  taskErrorMessage?: Maybe<Scalars['String']>;
  taskErroredAt?: Maybe<Scalars['timestamptz']>;
  taskGuid?: Maybe<Scalars['uuid']>;
  taskQueuedAt?: Maybe<Scalars['timestamptz']>;
  taskScheduledExecutionTime?: Maybe<Scalars['timestamptz']>;
  taskStartedAt?: Maybe<Scalars['timestamptz']>;
  taskSucceededAt?: Maybe<Scalars['timestamptz']>;
  taskType?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "application_tasks". */
export type ApplicationTasksOrderBy = {
  executionWorkerId?: InputMaybe<OrderBy>;
  sourceSystemInstanceId?: InputMaybe<OrderBy>;
  sourceSystemName?: InputMaybe<OrderBy>;
  sourceSystemVersion?: InputMaybe<OrderBy>;
  taskAttemptCount?: InputMaybe<OrderBy>;
  taskCompleted?: InputMaybe<OrderBy>;
  taskErrorMessage?: InputMaybe<OrderBy>;
  taskErroredAt?: InputMaybe<OrderBy>;
  taskGuid?: InputMaybe<OrderBy>;
  taskInputJson?: InputMaybe<OrderBy>;
  taskQueuedAt?: InputMaybe<OrderBy>;
  taskScheduledExecutionTime?: InputMaybe<OrderBy>;
  taskStartedAt?: InputMaybe<OrderBy>;
  taskSucceededAt?: InputMaybe<OrderBy>;
  taskType?: InputMaybe<OrderBy>;
};

/** select columns of table "application_tasks" */
export type ApplicationTasksSelectColumn =
  /** column name */
  | 'executionWorkerId'
  /** column name */
  | 'sourceSystemInstanceId'
  /** column name */
  | 'sourceSystemName'
  /** column name */
  | 'sourceSystemVersion'
  /** column name */
  | 'taskAttemptCount'
  /** column name */
  | 'taskCompleted'
  /** column name */
  | 'taskErrorMessage'
  /** column name */
  | 'taskErroredAt'
  /** column name */
  | 'taskGuid'
  /** column name */
  | 'taskInputJson'
  /** column name */
  | 'taskQueuedAt'
  /** column name */
  | 'taskScheduledExecutionTime'
  /** column name */
  | 'taskStartedAt'
  /** column name */
  | 'taskSucceededAt'
  /** column name */
  | 'taskType';

/** aggregate stddev on columns */
export type ApplicationTasksStddevFields = {
  __typename?: 'ApplicationTasksStddevFields';
  taskAttemptCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type ApplicationTasksStddevPopFields = {
  __typename?: 'ApplicationTasksStddevPopFields';
  taskAttemptCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type ApplicationTasksStddevSampFields = {
  __typename?: 'ApplicationTasksStddevSampFields';
  taskAttemptCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "application_tasks" */
export type ApplicationTasksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ApplicationTasksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ApplicationTasksStreamCursorValueInput = {
  executionWorkerId?: InputMaybe<Scalars['String']>;
  sourceSystemInstanceId?: InputMaybe<Scalars['String']>;
  sourceSystemName?: InputMaybe<Scalars['String']>;
  sourceSystemVersion?: InputMaybe<Scalars['String']>;
  taskAttemptCount?: InputMaybe<Scalars['numeric']>;
  taskCompleted?: InputMaybe<Scalars['Boolean']>;
  taskErrorMessage?: InputMaybe<Scalars['String']>;
  taskErroredAt?: InputMaybe<Scalars['timestamptz']>;
  taskGuid?: InputMaybe<Scalars['uuid']>;
  taskInputJson?: InputMaybe<Scalars['jsonb']>;
  taskQueuedAt?: InputMaybe<Scalars['timestamptz']>;
  taskScheduledExecutionTime?: InputMaybe<Scalars['timestamptz']>;
  taskStartedAt?: InputMaybe<Scalars['timestamptz']>;
  taskSucceededAt?: InputMaybe<Scalars['timestamptz']>;
  taskType?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type ApplicationTasksSumFields = {
  __typename?: 'ApplicationTasksSumFields';
  taskAttemptCount?: Maybe<Scalars['numeric']>;
};

/** aggregate varPop on columns */
export type ApplicationTasksVarPopFields = {
  __typename?: 'ApplicationTasksVarPopFields';
  taskAttemptCount?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type ApplicationTasksVarSampFields = {
  __typename?: 'ApplicationTasksVarSampFields';
  taskAttemptCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ApplicationTasksVarianceFields = {
  __typename?: 'ApplicationTasksVarianceFields';
  taskAttemptCount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRules = {
  __typename?: 'AppointmentChecklistAssociationRules';
  /** An object relationship */
  appointmentChecklist: AppointmentChecklists;
  appointmentChecklistAssociationRuleGuid: Scalars['uuid'];
  appointmentChecklistGuid: Scalars['uuid'];
  appointmentType: Scalars['AppointmentType'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  jobType?: Maybe<JobTypes>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  required?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesAggregate = {
  __typename?: 'AppointmentChecklistAssociationRulesAggregate';
  aggregate?: Maybe<AppointmentChecklistAssociationRulesAggregateFields>;
  nodes: Array<AppointmentChecklistAssociationRules>;
};

export type AppointmentChecklistAssociationRulesAggregateBoolExp = {
  bool_and?: InputMaybe<AppointmentChecklistAssociationRulesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<AppointmentChecklistAssociationRulesAggregateBoolExpBool_Or>;
  count?: InputMaybe<AppointmentChecklistAssociationRulesAggregateBoolExpCount>;
};

/** aggregate fields of "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesAggregateFields = {
  __typename?: 'AppointmentChecklistAssociationRulesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AppointmentChecklistAssociationRulesMaxFields>;
  min?: Maybe<AppointmentChecklistAssociationRulesMinFields>;
};


/** aggregate fields of "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AppointmentChecklistAssociationRulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AppointmentChecklistAssociationRulesMaxOrderBy>;
  min?: InputMaybe<AppointmentChecklistAssociationRulesMinOrderBy>;
};

/** input type for inserting array relation for remote table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesArrRelInsertInput = {
  data: Array<AppointmentChecklistAssociationRulesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AppointmentChecklistAssociationRulesOnConflict>;
};

/** Boolean expression to filter rows from the table "appointment_checklist_association_rules". All fields are combined with a logical 'AND'. */
export type AppointmentChecklistAssociationRulesBoolExp = {
  _and?: InputMaybe<Array<AppointmentChecklistAssociationRulesBoolExp>>;
  _not?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
  _or?: InputMaybe<Array<AppointmentChecklistAssociationRulesBoolExp>>;
  appointmentChecklist?: InputMaybe<AppointmentChecklistsBoolExp>;
  appointmentChecklistAssociationRuleGuid?: InputMaybe<UuidComparisonExp>;
  appointmentChecklistGuid?: InputMaybe<UuidComparisonExp>;
  appointmentType?: InputMaybe<Scalars['AppointmentTypeComparisonExp']>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  jobType?: InputMaybe<JobTypesBoolExp>;
  jobTypeGuid?: InputMaybe<UuidComparisonExp>;
  required?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesConstraint =
  /** unique or primary key constraint on columns "appointment_checklist_association_rule_guid" */
  | 'appointment_checklist_association_rules_pkey';

/** input type for inserting data into table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesInsertInput = {
  appointmentChecklist?: InputMaybe<AppointmentChecklistsObjRelInsertInput>;
  appointmentChecklistAssociationRuleGuid?: InputMaybe<Scalars['uuid']>;
  appointmentChecklistGuid?: InputMaybe<Scalars['uuid']>;
  appointmentType?: InputMaybe<Scalars['AppointmentType']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobType?: InputMaybe<JobTypesObjRelInsertInput>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  required?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AppointmentChecklistAssociationRulesMaxFields = {
  __typename?: 'AppointmentChecklistAssociationRulesMaxFields';
  appointmentChecklistAssociationRuleGuid?: Maybe<Scalars['uuid']>;
  appointmentChecklistGuid?: Maybe<Scalars['uuid']>;
  appointmentType?: Maybe<Scalars['AppointmentType']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesMaxOrderBy = {
  appointmentChecklistAssociationRuleGuid?: InputMaybe<OrderBy>;
  appointmentChecklistGuid?: InputMaybe<OrderBy>;
  appointmentType?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AppointmentChecklistAssociationRulesMinFields = {
  __typename?: 'AppointmentChecklistAssociationRulesMinFields';
  appointmentChecklistAssociationRuleGuid?: Maybe<Scalars['uuid']>;
  appointmentChecklistGuid?: Maybe<Scalars['uuid']>;
  appointmentType?: Maybe<Scalars['AppointmentType']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesMinOrderBy = {
  appointmentChecklistAssociationRuleGuid?: InputMaybe<OrderBy>;
  appointmentChecklistGuid?: InputMaybe<OrderBy>;
  appointmentType?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesMutationResponse = {
  __typename?: 'AppointmentChecklistAssociationRulesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppointmentChecklistAssociationRules>;
};

/** on_conflict condition type for table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesOnConflict = {
  constraint: AppointmentChecklistAssociationRulesConstraint;
  updateColumns?: Array<AppointmentChecklistAssociationRulesUpdateColumn>;
  where?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
};

/** Ordering options when selecting data from "appointment_checklist_association_rules". */
export type AppointmentChecklistAssociationRulesOrderBy = {
  appointmentChecklist?: InputMaybe<AppointmentChecklistsOrderBy>;
  appointmentChecklistAssociationRuleGuid?: InputMaybe<OrderBy>;
  appointmentChecklistGuid?: InputMaybe<OrderBy>;
  appointmentType?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobType?: InputMaybe<JobTypesOrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  required?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: appointment_checklist_association_rules */
export type AppointmentChecklistAssociationRulesPkColumnsInput = {
  appointmentChecklistAssociationRuleGuid: Scalars['uuid'];
};

/** select columns of table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesSelectColumn =
  /** column name */
  | 'appointmentChecklistAssociationRuleGuid'
  /** column name */
  | 'appointmentChecklistGuid'
  /** column name */
  | 'appointmentType'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'required'
  /** column name */
  | 'updatedAt';

/** select "appointmentChecklistAssociationRulesAggregateBoolExpBool_andArgumentsColumns" columns of table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesSelectColumnAppointmentChecklistAssociationRulesAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'required';

/** select "appointmentChecklistAssociationRulesAggregateBoolExpBool_orArgumentsColumns" columns of table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesSelectColumnAppointmentChecklistAssociationRulesAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'required';

/** input type for updating data in table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesSetInput = {
  appointmentChecklistAssociationRuleGuid?: InputMaybe<Scalars['uuid']>;
  appointmentChecklistGuid?: InputMaybe<Scalars['uuid']>;
  appointmentType?: InputMaybe<Scalars['AppointmentType']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  required?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AppointmentChecklistAssociationRulesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppointmentChecklistAssociationRulesStreamCursorValueInput = {
  appointmentChecklistAssociationRuleGuid?: InputMaybe<Scalars['uuid']>;
  appointmentChecklistGuid?: InputMaybe<Scalars['uuid']>;
  appointmentType?: InputMaybe<Scalars['AppointmentType']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  required?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "appointment_checklist_association_rules" */
export type AppointmentChecklistAssociationRulesUpdateColumn =
  /** column name */
  | 'appointmentChecklistAssociationRuleGuid'
  /** column name */
  | 'appointmentChecklistGuid'
  /** column name */
  | 'appointmentType'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'required'
  /** column name */
  | 'updatedAt';

export type AppointmentChecklistAssociationRulesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AppointmentChecklistAssociationRulesSetInput>;
  /** filter the rows which have to be updated */
  where: AppointmentChecklistAssociationRulesBoolExp;
};

/** columns and relationships of "appointment_checklist_instances" */
export type AppointmentChecklistInstances = {
  __typename?: 'AppointmentChecklistInstances';
  adHoc: Scalars['Boolean'];
  /** An object relationship */
  appointmentChecklist: AppointmentChecklists;
  appointmentChecklistGuid: Scalars['uuid'];
  appointmentChecklistInstanceGuid: Scalars['uuid'];
  checklist: Scalars['AppointmentChecklistInstanceChecklist'];
  createdAt: Scalars['timestamptz'];
  instanceNumber: Scalars['Int'];
  /** An object relationship */
  jobAppointment: JobAppointments;
  jobAppointmentGuid: Scalars['uuid'];
  label?: Maybe<Scalars['String']>;
  /** An object relationship */
  lastEditor?: Maybe<Users>;
  lastEditorUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "appointment_checklist_instances" */
export type AppointmentChecklistInstancesChecklistArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "appointment_checklist_instances" */
export type AppointmentChecklistInstancesAggregate = {
  __typename?: 'AppointmentChecklistInstancesAggregate';
  aggregate?: Maybe<AppointmentChecklistInstancesAggregateFields>;
  nodes: Array<AppointmentChecklistInstances>;
};

export type AppointmentChecklistInstancesAggregateBoolExp = {
  bool_and?: InputMaybe<AppointmentChecklistInstancesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<AppointmentChecklistInstancesAggregateBoolExpBool_Or>;
  count?: InputMaybe<AppointmentChecklistInstancesAggregateBoolExpCount>;
};

/** aggregate fields of "appointment_checklist_instances" */
export type AppointmentChecklistInstancesAggregateFields = {
  __typename?: 'AppointmentChecklistInstancesAggregateFields';
  avg?: Maybe<AppointmentChecklistInstancesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AppointmentChecklistInstancesMaxFields>;
  min?: Maybe<AppointmentChecklistInstancesMinFields>;
  stddev?: Maybe<AppointmentChecklistInstancesStddevFields>;
  stddevPop?: Maybe<AppointmentChecklistInstancesStddevPopFields>;
  stddevSamp?: Maybe<AppointmentChecklistInstancesStddevSampFields>;
  sum?: Maybe<AppointmentChecklistInstancesSumFields>;
  varPop?: Maybe<AppointmentChecklistInstancesVarPopFields>;
  varSamp?: Maybe<AppointmentChecklistInstancesVarSampFields>;
  variance?: Maybe<AppointmentChecklistInstancesVarianceFields>;
};


/** aggregate fields of "appointment_checklist_instances" */
export type AppointmentChecklistInstancesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AppointmentChecklistInstancesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesAggregateOrderBy = {
  avg?: InputMaybe<AppointmentChecklistInstancesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AppointmentChecklistInstancesMaxOrderBy>;
  min?: InputMaybe<AppointmentChecklistInstancesMinOrderBy>;
  stddev?: InputMaybe<AppointmentChecklistInstancesStddevOrderBy>;
  stddevPop?: InputMaybe<AppointmentChecklistInstancesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<AppointmentChecklistInstancesStddevSampOrderBy>;
  sum?: InputMaybe<AppointmentChecklistInstancesSumOrderBy>;
  varPop?: InputMaybe<AppointmentChecklistInstancesVarPopOrderBy>;
  varSamp?: InputMaybe<AppointmentChecklistInstancesVarSampOrderBy>;
  variance?: InputMaybe<AppointmentChecklistInstancesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AppointmentChecklistInstancesAppendInput = {
  checklist?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesArrRelInsertInput = {
  data: Array<AppointmentChecklistInstancesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AppointmentChecklistInstancesOnConflict>;
};

/** aggregate avg on columns */
export type AppointmentChecklistInstancesAvgFields = {
  __typename?: 'AppointmentChecklistInstancesAvgFields';
  instanceNumber?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesAvgOrderBy = {
  instanceNumber?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "appointment_checklist_instances". All fields are combined with a logical 'AND'. */
export type AppointmentChecklistInstancesBoolExp = {
  _and?: InputMaybe<Array<AppointmentChecklistInstancesBoolExp>>;
  _not?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
  _or?: InputMaybe<Array<AppointmentChecklistInstancesBoolExp>>;
  adHoc?: InputMaybe<BooleanComparisonExp>;
  appointmentChecklist?: InputMaybe<AppointmentChecklistsBoolExp>;
  appointmentChecklistGuid?: InputMaybe<UuidComparisonExp>;
  appointmentChecklistInstanceGuid?: InputMaybe<UuidComparisonExp>;
  checklist?: InputMaybe<Scalars['AppointmentChecklistInstanceChecklistComparisonExp']>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  instanceNumber?: InputMaybe<IntComparisonExp>;
  jobAppointment?: InputMaybe<JobAppointmentsBoolExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  lastEditor?: InputMaybe<UsersBoolExp>;
  lastEditorUserGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesConstraint =
  /** unique or primary key constraint on columns "appointment_checklist_guid", "job_appointment_guid", "instance_number" */
  | 'appointment_checklist_instances_job_appointment_guid_appointmen'
  /** unique or primary key constraint on columns "appointment_checklist_instance_guid" */
  | 'appointment_checklist_instances_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AppointmentChecklistInstancesDeleteAtPathInput = {
  checklist?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AppointmentChecklistInstancesDeleteElemInput = {
  checklist?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AppointmentChecklistInstancesDeleteKeyInput = {
  checklist?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesIncInput = {
  instanceNumber?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesInsertInput = {
  adHoc?: InputMaybe<Scalars['Boolean']>;
  appointmentChecklist?: InputMaybe<AppointmentChecklistsObjRelInsertInput>;
  appointmentChecklistGuid?: InputMaybe<Scalars['uuid']>;
  appointmentChecklistInstanceGuid?: InputMaybe<Scalars['uuid']>;
  checklist?: InputMaybe<Scalars['AppointmentChecklistInstanceChecklist']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  instanceNumber?: InputMaybe<Scalars['Int']>;
  jobAppointment?: InputMaybe<JobAppointmentsObjRelInsertInput>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  lastEditor?: InputMaybe<UsersObjRelInsertInput>;
  lastEditorUserGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AppointmentChecklistInstancesMaxFields = {
  __typename?: 'AppointmentChecklistInstancesMaxFields';
  appointmentChecklistGuid?: Maybe<Scalars['uuid']>;
  appointmentChecklistInstanceGuid?: Maybe<Scalars['uuid']>;
  checklist?: Maybe<Scalars['AppointmentChecklistInstanceChecklist']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  instanceNumber?: Maybe<Scalars['Int']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  lastEditorUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesMaxOrderBy = {
  appointmentChecklistGuid?: InputMaybe<OrderBy>;
  appointmentChecklistInstanceGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  instanceNumber?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  lastEditorUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AppointmentChecklistInstancesMinFields = {
  __typename?: 'AppointmentChecklistInstancesMinFields';
  appointmentChecklistGuid?: Maybe<Scalars['uuid']>;
  appointmentChecklistInstanceGuid?: Maybe<Scalars['uuid']>;
  checklist?: Maybe<Scalars['AppointmentChecklistInstanceChecklist']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  instanceNumber?: Maybe<Scalars['Int']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  label?: Maybe<Scalars['String']>;
  lastEditorUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesMinOrderBy = {
  appointmentChecklistGuid?: InputMaybe<OrderBy>;
  appointmentChecklistInstanceGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  instanceNumber?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  lastEditorUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesMutationResponse = {
  __typename?: 'AppointmentChecklistInstancesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppointmentChecklistInstances>;
};

/** input type for inserting object relation for remote table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesObjRelInsertInput = {
  data: AppointmentChecklistInstancesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AppointmentChecklistInstancesOnConflict>;
};

/** on_conflict condition type for table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesOnConflict = {
  constraint: AppointmentChecklistInstancesConstraint;
  updateColumns?: Array<AppointmentChecklistInstancesUpdateColumn>;
  where?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
};

/** Ordering options when selecting data from "appointment_checklist_instances". */
export type AppointmentChecklistInstancesOrderBy = {
  adHoc?: InputMaybe<OrderBy>;
  appointmentChecklist?: InputMaybe<AppointmentChecklistsOrderBy>;
  appointmentChecklistGuid?: InputMaybe<OrderBy>;
  appointmentChecklistInstanceGuid?: InputMaybe<OrderBy>;
  checklist?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  instanceNumber?: InputMaybe<OrderBy>;
  jobAppointment?: InputMaybe<JobAppointmentsOrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  lastEditor?: InputMaybe<UsersOrderBy>;
  lastEditorUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: appointment_checklist_instances */
export type AppointmentChecklistInstancesPkColumnsInput = {
  appointmentChecklistInstanceGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AppointmentChecklistInstancesPrependInput = {
  checklist?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesSelectColumn =
  /** column name */
  | 'adHoc'
  /** column name */
  | 'appointmentChecklistGuid'
  /** column name */
  | 'appointmentChecklistInstanceGuid'
  /** column name */
  | 'checklist'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'instanceNumber'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'label'
  /** column name */
  | 'lastEditorUserGuid'
  /** column name */
  | 'updatedAt';

/** select "appointmentChecklistInstancesAggregateBoolExpBool_andArgumentsColumns" columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesSelectColumnAppointmentChecklistInstancesAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'adHoc';

/** select "appointmentChecklistInstancesAggregateBoolExpBool_orArgumentsColumns" columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesSelectColumnAppointmentChecklistInstancesAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'adHoc';

/** input type for updating data in table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesSetInput = {
  adHoc?: InputMaybe<Scalars['Boolean']>;
  appointmentChecklistGuid?: InputMaybe<Scalars['uuid']>;
  appointmentChecklistInstanceGuid?: InputMaybe<Scalars['uuid']>;
  checklist?: InputMaybe<Scalars['AppointmentChecklistInstanceChecklist']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  instanceNumber?: InputMaybe<Scalars['Int']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  lastEditorUserGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type AppointmentChecklistInstancesStddevFields = {
  __typename?: 'AppointmentChecklistInstancesStddevFields';
  instanceNumber?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesStddevOrderBy = {
  instanceNumber?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type AppointmentChecklistInstancesStddevPopFields = {
  __typename?: 'AppointmentChecklistInstancesStddevPopFields';
  instanceNumber?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesStddevPopOrderBy = {
  instanceNumber?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type AppointmentChecklistInstancesStddevSampFields = {
  __typename?: 'AppointmentChecklistInstancesStddevSampFields';
  instanceNumber?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesStddevSampOrderBy = {
  instanceNumber?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AppointmentChecklistInstancesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppointmentChecklistInstancesStreamCursorValueInput = {
  adHoc?: InputMaybe<Scalars['Boolean']>;
  appointmentChecklistGuid?: InputMaybe<Scalars['uuid']>;
  appointmentChecklistInstanceGuid?: InputMaybe<Scalars['uuid']>;
  checklist?: InputMaybe<Scalars['AppointmentChecklistInstanceChecklist']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  instanceNumber?: InputMaybe<Scalars['Int']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  lastEditorUserGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type AppointmentChecklistInstancesSumFields = {
  __typename?: 'AppointmentChecklistInstancesSumFields';
  instanceNumber?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesSumOrderBy = {
  instanceNumber?: InputMaybe<OrderBy>;
};

/** update columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesUpdateColumn =
  /** column name */
  | 'adHoc'
  /** column name */
  | 'appointmentChecklistGuid'
  /** column name */
  | 'appointmentChecklistInstanceGuid'
  /** column name */
  | 'checklist'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'instanceNumber'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'label'
  /** column name */
  | 'lastEditorUserGuid'
  /** column name */
  | 'updatedAt';

export type AppointmentChecklistInstancesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AppointmentChecklistInstancesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<AppointmentChecklistInstancesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<AppointmentChecklistInstancesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<AppointmentChecklistInstancesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AppointmentChecklistInstancesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AppointmentChecklistInstancesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AppointmentChecklistInstancesSetInput>;
  /** filter the rows which have to be updated */
  where: AppointmentChecklistInstancesBoolExp;
};

/** aggregate varPop on columns */
export type AppointmentChecklistInstancesVarPopFields = {
  __typename?: 'AppointmentChecklistInstancesVarPopFields';
  instanceNumber?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesVarPopOrderBy = {
  instanceNumber?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type AppointmentChecklistInstancesVarSampFields = {
  __typename?: 'AppointmentChecklistInstancesVarSampFields';
  instanceNumber?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesVarSampOrderBy = {
  instanceNumber?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AppointmentChecklistInstancesVarianceFields = {
  __typename?: 'AppointmentChecklistInstancesVarianceFields';
  instanceNumber?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "appointment_checklist_instances" */
export type AppointmentChecklistInstancesVarianceOrderBy = {
  instanceNumber?: InputMaybe<OrderBy>;
};

/** columns and relationships of "appointment_checklists" */
export type AppointmentChecklists = {
  __typename?: 'AppointmentChecklists';
  appointmentChecklistGuid: Scalars['uuid'];
  associationRules?: Maybe<Scalars['jsonb']>;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  customerFacingByDefault: Scalars['Boolean'];
  items: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  rules: Array<AppointmentChecklistAssociationRules>;
  /** An aggregate relationship */
  rulesAggregate: AppointmentChecklistAssociationRulesAggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "appointment_checklists" */
export type AppointmentChecklistsAssociationRulesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "appointment_checklists" */
export type AppointmentChecklistsItemsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "appointment_checklists" */
export type AppointmentChecklistsRulesArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistAssociationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistAssociationRulesOrderBy>>;
  where?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
};


/** columns and relationships of "appointment_checklists" */
export type AppointmentChecklistsRulesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistAssociationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistAssociationRulesOrderBy>>;
  where?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
};

/** aggregated selection of "appointment_checklists" */
export type AppointmentChecklistsAggregate = {
  __typename?: 'AppointmentChecklistsAggregate';
  aggregate?: Maybe<AppointmentChecklistsAggregateFields>;
  nodes: Array<AppointmentChecklists>;
};

/** aggregate fields of "appointment_checklists" */
export type AppointmentChecklistsAggregateFields = {
  __typename?: 'AppointmentChecklistsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AppointmentChecklistsMaxFields>;
  min?: Maybe<AppointmentChecklistsMinFields>;
};


/** aggregate fields of "appointment_checklists" */
export type AppointmentChecklistsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AppointmentChecklistsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AppointmentChecklistsAppendInput = {
  associationRules?: InputMaybe<Scalars['jsonb']>;
  items?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "appointment_checklists". All fields are combined with a logical 'AND'. */
export type AppointmentChecklistsBoolExp = {
  _and?: InputMaybe<Array<AppointmentChecklistsBoolExp>>;
  _not?: InputMaybe<AppointmentChecklistsBoolExp>;
  _or?: InputMaybe<Array<AppointmentChecklistsBoolExp>>;
  appointmentChecklistGuid?: InputMaybe<UuidComparisonExp>;
  associationRules?: InputMaybe<JsonbComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customerFacingByDefault?: InputMaybe<BooleanComparisonExp>;
  items?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  rules?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
  rulesAggregate?: InputMaybe<AppointmentChecklistAssociationRulesAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "appointment_checklists" */
export type AppointmentChecklistsConstraint =
  /** unique or primary key constraint on columns "company_guid", "name" */
  | 'appointment_checklists_company_guid_name_key'
  /** unique or primary key constraint on columns "appointment_checklist_guid" */
  | 'appointment_checklists_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AppointmentChecklistsDeleteAtPathInput = {
  associationRules?: InputMaybe<Array<Scalars['String']>>;
  items?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AppointmentChecklistsDeleteElemInput = {
  associationRules?: InputMaybe<Scalars['Int']>;
  items?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AppointmentChecklistsDeleteKeyInput = {
  associationRules?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "appointment_checklists" */
export type AppointmentChecklistsInsertInput = {
  appointmentChecklistGuid?: InputMaybe<Scalars['uuid']>;
  associationRules?: InputMaybe<Scalars['jsonb']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerFacingByDefault?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<AppointmentChecklistAssociationRulesArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AppointmentChecklistsMaxFields = {
  __typename?: 'AppointmentChecklistsMaxFields';
  appointmentChecklistGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type AppointmentChecklistsMinFields = {
  __typename?: 'AppointmentChecklistsMinFields';
  appointmentChecklistGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "appointment_checklists" */
export type AppointmentChecklistsMutationResponse = {
  __typename?: 'AppointmentChecklistsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AppointmentChecklists>;
};

/** input type for inserting object relation for remote table "appointment_checklists" */
export type AppointmentChecklistsObjRelInsertInput = {
  data: AppointmentChecklistsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AppointmentChecklistsOnConflict>;
};

/** on_conflict condition type for table "appointment_checklists" */
export type AppointmentChecklistsOnConflict = {
  constraint: AppointmentChecklistsConstraint;
  updateColumns?: Array<AppointmentChecklistsUpdateColumn>;
  where?: InputMaybe<AppointmentChecklistsBoolExp>;
};

/** Ordering options when selecting data from "appointment_checklists". */
export type AppointmentChecklistsOrderBy = {
  appointmentChecklistGuid?: InputMaybe<OrderBy>;
  associationRules?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerFacingByDefault?: InputMaybe<OrderBy>;
  items?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rulesAggregate?: InputMaybe<AppointmentChecklistAssociationRulesAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: appointment_checklists */
export type AppointmentChecklistsPkColumnsInput = {
  appointmentChecklistGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AppointmentChecklistsPrependInput = {
  associationRules?: InputMaybe<Scalars['jsonb']>;
  items?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "appointment_checklists" */
export type AppointmentChecklistsSelectColumn =
  /** column name */
  | 'appointmentChecklistGuid'
  /** column name */
  | 'associationRules'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'customerFacingByDefault'
  /** column name */
  | 'items'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "appointment_checklists" */
export type AppointmentChecklistsSetInput = {
  appointmentChecklistGuid?: InputMaybe<Scalars['uuid']>;
  associationRules?: InputMaybe<Scalars['jsonb']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerFacingByDefault?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "appointment_checklists" */
export type AppointmentChecklistsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AppointmentChecklistsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AppointmentChecklistsStreamCursorValueInput = {
  appointmentChecklistGuid?: InputMaybe<Scalars['uuid']>;
  associationRules?: InputMaybe<Scalars['jsonb']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customerFacingByDefault?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "appointment_checklists" */
export type AppointmentChecklistsUpdateColumn =
  /** column name */
  | 'appointmentChecklistGuid'
  /** column name */
  | 'associationRules'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'customerFacingByDefault'
  /** column name */
  | 'items'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt';

export type AppointmentChecklistsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AppointmentChecklistsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<AppointmentChecklistsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<AppointmentChecklistsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<AppointmentChecklistsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AppointmentChecklistsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AppointmentChecklistsSetInput>;
  /** filter the rows which have to be updated */
  where: AppointmentChecklistsBoolExp;
};

/** Joiner table for assistants to integrated phones */
export type AssistantIntegratedPhones = {
  __typename?: 'AssistantIntegratedPhones';
  /** An object relationship */
  assistant: Assistants;
  assistantGuid: Scalars['uuid'];
  /** An object relationship */
  integratedPhone: IntegratedPhones;
  integratedPhoneGuid: Scalars['uuid'];
};

/** aggregated selection of "assistant_integrated_phones" */
export type AssistantIntegratedPhonesAggregate = {
  __typename?: 'AssistantIntegratedPhonesAggregate';
  aggregate?: Maybe<AssistantIntegratedPhonesAggregateFields>;
  nodes: Array<AssistantIntegratedPhones>;
};

export type AssistantIntegratedPhonesAggregateBoolExp = {
  count?: InputMaybe<AssistantIntegratedPhonesAggregateBoolExpCount>;
};

/** aggregate fields of "assistant_integrated_phones" */
export type AssistantIntegratedPhonesAggregateFields = {
  __typename?: 'AssistantIntegratedPhonesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AssistantIntegratedPhonesMaxFields>;
  min?: Maybe<AssistantIntegratedPhonesMinFields>;
};


/** aggregate fields of "assistant_integrated_phones" */
export type AssistantIntegratedPhonesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AssistantIntegratedPhonesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AssistantIntegratedPhonesMaxOrderBy>;
  min?: InputMaybe<AssistantIntegratedPhonesMinOrderBy>;
};

/** input type for inserting array relation for remote table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesArrRelInsertInput = {
  data: Array<AssistantIntegratedPhonesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<AssistantIntegratedPhonesOnConflict>;
};

/** Boolean expression to filter rows from the table "assistant_integrated_phones". All fields are combined with a logical 'AND'. */
export type AssistantIntegratedPhonesBoolExp = {
  _and?: InputMaybe<Array<AssistantIntegratedPhonesBoolExp>>;
  _not?: InputMaybe<AssistantIntegratedPhonesBoolExp>;
  _or?: InputMaybe<Array<AssistantIntegratedPhonesBoolExp>>;
  assistant?: InputMaybe<AssistantsBoolExp>;
  assistantGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhone?: InputMaybe<IntegratedPhonesBoolExp>;
  integratedPhoneGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesConstraint =
  /** unique or primary key constraint on columns "assistant_guid", "integrated_phone_guid" */
  | 'assistant_integrated_phones_pkey';

/** input type for inserting data into table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesInsertInput = {
  assistant?: InputMaybe<AssistantsObjRelInsertInput>;
  assistantGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhone?: InputMaybe<IntegratedPhonesObjRelInsertInput>;
  integratedPhoneGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AssistantIntegratedPhonesMaxFields = {
  __typename?: 'AssistantIntegratedPhonesMaxFields';
  assistantGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesMaxOrderBy = {
  assistantGuid?: InputMaybe<OrderBy>;
  integratedPhoneGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AssistantIntegratedPhonesMinFields = {
  __typename?: 'AssistantIntegratedPhonesMinFields';
  assistantGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesMinOrderBy = {
  assistantGuid?: InputMaybe<OrderBy>;
  integratedPhoneGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesMutationResponse = {
  __typename?: 'AssistantIntegratedPhonesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AssistantIntegratedPhones>;
};

/** input type for inserting object relation for remote table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesObjRelInsertInput = {
  data: AssistantIntegratedPhonesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AssistantIntegratedPhonesOnConflict>;
};

/** on_conflict condition type for table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesOnConflict = {
  constraint: AssistantIntegratedPhonesConstraint;
  updateColumns?: Array<AssistantIntegratedPhonesUpdateColumn>;
  where?: InputMaybe<AssistantIntegratedPhonesBoolExp>;
};

/** Ordering options when selecting data from "assistant_integrated_phones". */
export type AssistantIntegratedPhonesOrderBy = {
  assistant?: InputMaybe<AssistantsOrderBy>;
  assistantGuid?: InputMaybe<OrderBy>;
  integratedPhone?: InputMaybe<IntegratedPhonesOrderBy>;
  integratedPhoneGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: assistant_integrated_phones */
export type AssistantIntegratedPhonesPkColumnsInput = {
  assistantGuid: Scalars['uuid'];
  integratedPhoneGuid: Scalars['uuid'];
};

/** select columns of table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesSelectColumn =
  /** column name */
  | 'assistantGuid'
  /** column name */
  | 'integratedPhoneGuid';

/** input type for updating data in table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesSetInput = {
  assistantGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AssistantIntegratedPhonesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AssistantIntegratedPhonesStreamCursorValueInput = {
  assistantGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "assistant_integrated_phones" */
export type AssistantIntegratedPhonesUpdateColumn =
  /** column name */
  | 'assistantGuid'
  /** column name */
  | 'integratedPhoneGuid';

export type AssistantIntegratedPhonesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssistantIntegratedPhonesSetInput>;
  /** filter the rows which have to be updated */
  where: AssistantIntegratedPhonesBoolExp;
};

/** Settings for when the assistant is hooked up to a phone */
export type AssistantPhoneSettings = {
  __typename?: 'AssistantPhoneSettings';
  assistantGuid: Scalars['uuid'];
  endCallMessage?: Maybe<Scalars['String']>;
  firstMessage?: Maybe<Scalars['String']>;
  forwardPhoneNumber?: Maybe<Scalars['String']>;
  promptHtml?: Maybe<Scalars['HtmlString']>;
};

/** aggregated selection of "assistant_phone_settings" */
export type AssistantPhoneSettingsAggregate = {
  __typename?: 'AssistantPhoneSettingsAggregate';
  aggregate?: Maybe<AssistantPhoneSettingsAggregateFields>;
  nodes: Array<AssistantPhoneSettings>;
};

/** aggregate fields of "assistant_phone_settings" */
export type AssistantPhoneSettingsAggregateFields = {
  __typename?: 'AssistantPhoneSettingsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AssistantPhoneSettingsMaxFields>;
  min?: Maybe<AssistantPhoneSettingsMinFields>;
};


/** aggregate fields of "assistant_phone_settings" */
export type AssistantPhoneSettingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AssistantPhoneSettingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "assistant_phone_settings". All fields are combined with a logical 'AND'. */
export type AssistantPhoneSettingsBoolExp = {
  _and?: InputMaybe<Array<AssistantPhoneSettingsBoolExp>>;
  _not?: InputMaybe<AssistantPhoneSettingsBoolExp>;
  _or?: InputMaybe<Array<AssistantPhoneSettingsBoolExp>>;
  assistantGuid?: InputMaybe<UuidComparisonExp>;
  endCallMessage?: InputMaybe<StringComparisonExp>;
  firstMessage?: InputMaybe<StringComparisonExp>;
  forwardPhoneNumber?: InputMaybe<StringComparisonExp>;
  promptHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
};

/** unique or primary key constraints on table "assistant_phone_settings" */
export type AssistantPhoneSettingsConstraint =
  /** unique or primary key constraint on columns "assistant_guid" */
  | 'assistant_phone_settings_pkey';

/** input type for inserting data into table "assistant_phone_settings" */
export type AssistantPhoneSettingsInsertInput = {
  assistantGuid?: InputMaybe<Scalars['uuid']>;
  endCallMessage?: InputMaybe<Scalars['String']>;
  firstMessage?: InputMaybe<Scalars['String']>;
  forwardPhoneNumber?: InputMaybe<Scalars['String']>;
  promptHtml?: InputMaybe<Scalars['HtmlString']>;
};

/** aggregate max on columns */
export type AssistantPhoneSettingsMaxFields = {
  __typename?: 'AssistantPhoneSettingsMaxFields';
  assistantGuid?: Maybe<Scalars['uuid']>;
  endCallMessage?: Maybe<Scalars['String']>;
  firstMessage?: Maybe<Scalars['String']>;
  forwardPhoneNumber?: Maybe<Scalars['String']>;
  promptHtml?: Maybe<Scalars['HtmlString']>;
};

/** aggregate min on columns */
export type AssistantPhoneSettingsMinFields = {
  __typename?: 'AssistantPhoneSettingsMinFields';
  assistantGuid?: Maybe<Scalars['uuid']>;
  endCallMessage?: Maybe<Scalars['String']>;
  firstMessage?: Maybe<Scalars['String']>;
  forwardPhoneNumber?: Maybe<Scalars['String']>;
  promptHtml?: Maybe<Scalars['HtmlString']>;
};

/** response of any mutation on the table "assistant_phone_settings" */
export type AssistantPhoneSettingsMutationResponse = {
  __typename?: 'AssistantPhoneSettingsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AssistantPhoneSettings>;
};

/** input type for inserting object relation for remote table "assistant_phone_settings" */
export type AssistantPhoneSettingsObjRelInsertInput = {
  data: AssistantPhoneSettingsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AssistantPhoneSettingsOnConflict>;
};

/** on_conflict condition type for table "assistant_phone_settings" */
export type AssistantPhoneSettingsOnConflict = {
  constraint: AssistantPhoneSettingsConstraint;
  updateColumns?: Array<AssistantPhoneSettingsUpdateColumn>;
  where?: InputMaybe<AssistantPhoneSettingsBoolExp>;
};

/** Ordering options when selecting data from "assistant_phone_settings". */
export type AssistantPhoneSettingsOrderBy = {
  assistantGuid?: InputMaybe<OrderBy>;
  endCallMessage?: InputMaybe<OrderBy>;
  firstMessage?: InputMaybe<OrderBy>;
  forwardPhoneNumber?: InputMaybe<OrderBy>;
  promptHtml?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: assistant_phone_settings */
export type AssistantPhoneSettingsPkColumnsInput = {
  assistantGuid: Scalars['uuid'];
};

/** select columns of table "assistant_phone_settings" */
export type AssistantPhoneSettingsSelectColumn =
  /** column name */
  | 'assistantGuid'
  /** column name */
  | 'endCallMessage'
  /** column name */
  | 'firstMessage'
  /** column name */
  | 'forwardPhoneNumber'
  /** column name */
  | 'promptHtml';

/** input type for updating data in table "assistant_phone_settings" */
export type AssistantPhoneSettingsSetInput = {
  assistantGuid?: InputMaybe<Scalars['uuid']>;
  endCallMessage?: InputMaybe<Scalars['String']>;
  firstMessage?: InputMaybe<Scalars['String']>;
  forwardPhoneNumber?: InputMaybe<Scalars['String']>;
  promptHtml?: InputMaybe<Scalars['HtmlString']>;
};

/** Streaming cursor of the table "assistant_phone_settings" */
export type AssistantPhoneSettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AssistantPhoneSettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AssistantPhoneSettingsStreamCursorValueInput = {
  assistantGuid?: InputMaybe<Scalars['uuid']>;
  endCallMessage?: InputMaybe<Scalars['String']>;
  firstMessage?: InputMaybe<Scalars['String']>;
  forwardPhoneNumber?: InputMaybe<Scalars['String']>;
  promptHtml?: InputMaybe<Scalars['HtmlString']>;
};

/** update columns of table "assistant_phone_settings" */
export type AssistantPhoneSettingsUpdateColumn =
  /** column name */
  | 'assistantGuid'
  /** column name */
  | 'endCallMessage'
  /** column name */
  | 'firstMessage'
  /** column name */
  | 'forwardPhoneNumber'
  /** column name */
  | 'promptHtml';

export type AssistantPhoneSettingsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssistantPhoneSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: AssistantPhoneSettingsBoolExp;
};

/** AI Assistants in Breezy */
export type Assistants = {
  __typename?: 'Assistants';
  assistantGuid: Scalars['uuid'];
  /** An array relationship */
  assistantIntegratedPhones: Array<AssistantIntegratedPhones>;
  /** An aggregate relationship */
  assistantIntegratedPhonesAggregate: AssistantIntegratedPhonesAggregate;
  /** An object relationship */
  assistantPhoneSettings?: Maybe<AssistantPhoneSettings>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  name: Scalars['String'];
};


/** AI Assistants in Breezy */
export type AssistantsAssistantIntegratedPhonesArgs = {
  distinctOn?: InputMaybe<Array<AssistantIntegratedPhonesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantIntegratedPhonesOrderBy>>;
  where?: InputMaybe<AssistantIntegratedPhonesBoolExp>;
};


/** AI Assistants in Breezy */
export type AssistantsAssistantIntegratedPhonesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AssistantIntegratedPhonesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantIntegratedPhonesOrderBy>>;
  where?: InputMaybe<AssistantIntegratedPhonesBoolExp>;
};

/** aggregated selection of "assistants" */
export type AssistantsAggregate = {
  __typename?: 'AssistantsAggregate';
  aggregate?: Maybe<AssistantsAggregateFields>;
  nodes: Array<Assistants>;
};

/** aggregate fields of "assistants" */
export type AssistantsAggregateFields = {
  __typename?: 'AssistantsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<AssistantsMaxFields>;
  min?: Maybe<AssistantsMinFields>;
};


/** aggregate fields of "assistants" */
export type AssistantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AssistantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "assistants". All fields are combined with a logical 'AND'. */
export type AssistantsBoolExp = {
  _and?: InputMaybe<Array<AssistantsBoolExp>>;
  _not?: InputMaybe<AssistantsBoolExp>;
  _or?: InputMaybe<Array<AssistantsBoolExp>>;
  assistantGuid?: InputMaybe<UuidComparisonExp>;
  assistantIntegratedPhones?: InputMaybe<AssistantIntegratedPhonesBoolExp>;
  assistantIntegratedPhonesAggregate?: InputMaybe<AssistantIntegratedPhonesAggregateBoolExp>;
  assistantPhoneSettings?: InputMaybe<AssistantPhoneSettingsBoolExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "assistants" */
export type AssistantsConstraint =
  /** unique or primary key constraint on columns "assistant_guid" */
  | 'assistants_pkey';

/** input type for inserting data into table "assistants" */
export type AssistantsInsertInput = {
  assistantGuid?: InputMaybe<Scalars['uuid']>;
  assistantIntegratedPhones?: InputMaybe<AssistantIntegratedPhonesArrRelInsertInput>;
  assistantPhoneSettings?: InputMaybe<AssistantPhoneSettingsObjRelInsertInput>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AssistantsMaxFields = {
  __typename?: 'AssistantsMaxFields';
  assistantGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AssistantsMinFields = {
  __typename?: 'AssistantsMinFields';
  assistantGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "assistants" */
export type AssistantsMutationResponse = {
  __typename?: 'AssistantsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Assistants>;
};

/** input type for inserting object relation for remote table "assistants" */
export type AssistantsObjRelInsertInput = {
  data: AssistantsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AssistantsOnConflict>;
};

/** on_conflict condition type for table "assistants" */
export type AssistantsOnConflict = {
  constraint: AssistantsConstraint;
  updateColumns?: Array<AssistantsUpdateColumn>;
  where?: InputMaybe<AssistantsBoolExp>;
};

/** Ordering options when selecting data from "assistants". */
export type AssistantsOrderBy = {
  assistantGuid?: InputMaybe<OrderBy>;
  assistantIntegratedPhonesAggregate?: InputMaybe<AssistantIntegratedPhonesAggregateOrderBy>;
  assistantPhoneSettings?: InputMaybe<AssistantPhoneSettingsOrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: assistants */
export type AssistantsPkColumnsInput = {
  assistantGuid: Scalars['uuid'];
};

/** select columns of table "assistants" */
export type AssistantsSelectColumn =
  /** column name */
  | 'assistantGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'name';

/** input type for updating data in table "assistants" */
export type AssistantsSetInput = {
  assistantGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "assistants" */
export type AssistantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AssistantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AssistantsStreamCursorValueInput = {
  assistantGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "assistants" */
export type AssistantsUpdateColumn =
  /** column name */
  | 'assistantGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'name';

export type AssistantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssistantsSetInput>;
  /** filter the rows which have to be updated */
  where: AssistantsBoolExp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

export type BillingIntervalTypesEnum =
  | 'MONTHLY'
  | 'QUARTERLY'
  | 'YEARLY';

/** Boolean expression to compare columns of type "BillingIntervalTypesEnum". All fields are combined with logical 'AND'. */
export type BillingIntervalTypesEnumComparisonExp = {
  _eq?: InputMaybe<BillingIntervalTypesEnum>;
  _in?: InputMaybe<Array<BillingIntervalTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BillingIntervalTypesEnum>;
  _nin?: InputMaybe<Array<BillingIntervalTypesEnum>>;
};

/** The payment methods that are hidden for a company when collecting a payment */
export type BillingProfileHiddenPaymentMethods = {
  __typename?: 'BillingProfileHiddenPaymentMethods';
  companyGuid: Scalars['uuid'];
  paymentMethod: Scalars['PaymentMethod'];
};

/** aggregated selection of "billing_profile_hidden_payment_methods" */
export type BillingProfileHiddenPaymentMethodsAggregate = {
  __typename?: 'BillingProfileHiddenPaymentMethodsAggregate';
  aggregate?: Maybe<BillingProfileHiddenPaymentMethodsAggregateFields>;
  nodes: Array<BillingProfileHiddenPaymentMethods>;
};

/** aggregate fields of "billing_profile_hidden_payment_methods" */
export type BillingProfileHiddenPaymentMethodsAggregateFields = {
  __typename?: 'BillingProfileHiddenPaymentMethodsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BillingProfileHiddenPaymentMethodsMaxFields>;
  min?: Maybe<BillingProfileHiddenPaymentMethodsMinFields>;
};


/** aggregate fields of "billing_profile_hidden_payment_methods" */
export type BillingProfileHiddenPaymentMethodsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BillingProfileHiddenPaymentMethodsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "billing_profile_hidden_payment_methods". All fields are combined with a logical 'AND'. */
export type BillingProfileHiddenPaymentMethodsBoolExp = {
  _and?: InputMaybe<Array<BillingProfileHiddenPaymentMethodsBoolExp>>;
  _not?: InputMaybe<BillingProfileHiddenPaymentMethodsBoolExp>;
  _or?: InputMaybe<Array<BillingProfileHiddenPaymentMethodsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  paymentMethod?: InputMaybe<Scalars['PaymentMethodComparisonExp']>;
};

/** unique or primary key constraints on table "billing_profile_hidden_payment_methods" */
export type BillingProfileHiddenPaymentMethodsConstraint =
  /** unique or primary key constraint on columns "payment_method", "company_guid" */
  | 'billing_profile_hidden_payment_methods_pkey';

/** input type for inserting data into table "billing_profile_hidden_payment_methods" */
export type BillingProfileHiddenPaymentMethodsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  paymentMethod?: InputMaybe<Scalars['PaymentMethod']>;
};

/** aggregate max on columns */
export type BillingProfileHiddenPaymentMethodsMaxFields = {
  __typename?: 'BillingProfileHiddenPaymentMethodsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  paymentMethod?: Maybe<Scalars['PaymentMethod']>;
};

/** aggregate min on columns */
export type BillingProfileHiddenPaymentMethodsMinFields = {
  __typename?: 'BillingProfileHiddenPaymentMethodsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  paymentMethod?: Maybe<Scalars['PaymentMethod']>;
};

/** response of any mutation on the table "billing_profile_hidden_payment_methods" */
export type BillingProfileHiddenPaymentMethodsMutationResponse = {
  __typename?: 'BillingProfileHiddenPaymentMethodsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BillingProfileHiddenPaymentMethods>;
};

/** on_conflict condition type for table "billing_profile_hidden_payment_methods" */
export type BillingProfileHiddenPaymentMethodsOnConflict = {
  constraint: BillingProfileHiddenPaymentMethodsConstraint;
  updateColumns?: Array<BillingProfileHiddenPaymentMethodsUpdateColumn>;
  where?: InputMaybe<BillingProfileHiddenPaymentMethodsBoolExp>;
};

/** Ordering options when selecting data from "billing_profile_hidden_payment_methods". */
export type BillingProfileHiddenPaymentMethodsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: billing_profile_hidden_payment_methods */
export type BillingProfileHiddenPaymentMethodsPkColumnsInput = {
  companyGuid: Scalars['uuid'];
  paymentMethod: PaymentMethodsEnum;
};

/** select columns of table "billing_profile_hidden_payment_methods" */
export type BillingProfileHiddenPaymentMethodsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'paymentMethod';

/** input type for updating data in table "billing_profile_hidden_payment_methods" */
export type BillingProfileHiddenPaymentMethodsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  paymentMethod?: InputMaybe<Scalars['PaymentMethod']>;
};

/** Streaming cursor of the table "billing_profile_hidden_payment_methods" */
export type BillingProfileHiddenPaymentMethodsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BillingProfileHiddenPaymentMethodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BillingProfileHiddenPaymentMethodsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  paymentMethod?: InputMaybe<Scalars['PaymentMethod']>;
};

/** update columns of table "billing_profile_hidden_payment_methods" */
export type BillingProfileHiddenPaymentMethodsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'paymentMethod';

export type BillingProfileHiddenPaymentMethodsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BillingProfileHiddenPaymentMethodsSetInput>;
  /** filter the rows which have to be updated */
  where: BillingProfileHiddenPaymentMethodsBoolExp;
};

/** columns and relationships of "billing_profiles" */
export type BillingProfiles = {
  __typename?: 'BillingProfiles';
  /** An object relationship */
  businessAddress?: Maybe<Addresses>;
  businessAddressGuid?: Maybe<Scalars['uuid']>;
  businessFullLegalName: Scalars['String'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  contractorLicenseNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultPricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  defaultTaxRate?: Maybe<PricebookTaxRates>;
  /** An object relationship */
  emailAddress: EmailAddresses;
  emailAddressGuid: Scalars['uuid'];
  estimateDisclaimer: Scalars['String'];
  invoiceDisclaimer: Scalars['String'];
  invoiceMemo?: Maybe<Scalars['String']>;
  invoiceTerm?: Maybe<InvoiceTermsEnum>;
  /** An object relationship */
  logoPhoto: Photos;
  logoPhotoGuid: Scalars['uuid'];
  logoUrl: Scalars['String'];
  maintenancePlanAutoRenewalAllowed: Scalars['Boolean'];
  maintenancePlanManualRenewalAllowed: Scalars['Boolean'];
  /** An object relationship */
  maintenancePlanServiceItem?: Maybe<PricebookItems>;
  maintenancePlanServiceItemGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanStaticDurationNumYearsAllowed: Array<Scalars['Int']>;
  /** An object relationship */
  maintenancePlanTaxRate?: Maybe<PricebookTaxRates>;
  maintenancePlanTaxRateGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  phoneNumber: PhoneNumbers;
  phoneNumberGuid: Scalars['uuid'];
  tilledMerchantAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitReplenishmentDay: Scalars['Int'];
  visitReplenishmentMonth: Scalars['Int'];
  visitReplenishmentStrategy: Scalars['String'];
  websiteDisplayName?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  wisetackMerchantId?: Maybe<Scalars['String']>;
};

/** aggregated selection of "billing_profiles" */
export type BillingProfilesAggregate = {
  __typename?: 'BillingProfilesAggregate';
  aggregate?: Maybe<BillingProfilesAggregateFields>;
  nodes: Array<BillingProfiles>;
};

/** aggregate fields of "billing_profiles" */
export type BillingProfilesAggregateFields = {
  __typename?: 'BillingProfilesAggregateFields';
  avg?: Maybe<BillingProfilesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BillingProfilesMaxFields>;
  min?: Maybe<BillingProfilesMinFields>;
  stddev?: Maybe<BillingProfilesStddevFields>;
  stddevPop?: Maybe<BillingProfilesStddevPopFields>;
  stddevSamp?: Maybe<BillingProfilesStddevSampFields>;
  sum?: Maybe<BillingProfilesSumFields>;
  varPop?: Maybe<BillingProfilesVarPopFields>;
  varSamp?: Maybe<BillingProfilesVarSampFields>;
  variance?: Maybe<BillingProfilesVarianceFields>;
};


/** aggregate fields of "billing_profiles" */
export type BillingProfilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BillingProfilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type BillingProfilesAvgFields = {
  __typename?: 'BillingProfilesAvgFields';
  visitReplenishmentDay?: Maybe<Scalars['Float']>;
  visitReplenishmentMonth?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "billing_profiles". All fields are combined with a logical 'AND'. */
export type BillingProfilesBoolExp = {
  _and?: InputMaybe<Array<BillingProfilesBoolExp>>;
  _not?: InputMaybe<BillingProfilesBoolExp>;
  _or?: InputMaybe<Array<BillingProfilesBoolExp>>;
  businessAddress?: InputMaybe<AddressesBoolExp>;
  businessAddressGuid?: InputMaybe<UuidComparisonExp>;
  businessFullLegalName?: InputMaybe<StringComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  contractorLicenseNumber?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  defaultPricebookTaxRateGuid?: InputMaybe<UuidComparisonExp>;
  defaultTaxRate?: InputMaybe<PricebookTaxRatesBoolExp>;
  emailAddress?: InputMaybe<EmailAddressesBoolExp>;
  emailAddressGuid?: InputMaybe<UuidComparisonExp>;
  estimateDisclaimer?: InputMaybe<StringComparisonExp>;
  invoiceDisclaimer?: InputMaybe<StringComparisonExp>;
  invoiceMemo?: InputMaybe<StringComparisonExp>;
  invoiceTerm?: InputMaybe<InvoiceTermsEnumComparisonExp>;
  logoPhoto?: InputMaybe<PhotosBoolExp>;
  logoPhotoGuid?: InputMaybe<UuidComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  maintenancePlanAutoRenewalAllowed?: InputMaybe<BooleanComparisonExp>;
  maintenancePlanManualRenewalAllowed?: InputMaybe<BooleanComparisonExp>;
  maintenancePlanServiceItem?: InputMaybe<PricebookItemsBoolExp>;
  maintenancePlanServiceItemGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanStaticDurationNumYearsAllowed?: InputMaybe<IntArrayComparisonExp>;
  maintenancePlanTaxRate?: InputMaybe<PricebookTaxRatesBoolExp>;
  maintenancePlanTaxRateGuid?: InputMaybe<UuidComparisonExp>;
  phoneNumber?: InputMaybe<PhoneNumbersBoolExp>;
  phoneNumberGuid?: InputMaybe<UuidComparisonExp>;
  tilledMerchantAccountId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  visitReplenishmentDay?: InputMaybe<IntComparisonExp>;
  visitReplenishmentMonth?: InputMaybe<IntComparisonExp>;
  visitReplenishmentStrategy?: InputMaybe<StringComparisonExp>;
  websiteDisplayName?: InputMaybe<StringComparisonExp>;
  websiteUrl?: InputMaybe<StringComparisonExp>;
  wisetackMerchantId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "billing_profiles" */
export type BillingProfilesConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'billing_profiles_pkey'
  /** unique or primary key constraint on columns "tilled_merchant_account_id" */
  | 'billing_profiles_tilled_merchant_account_id_key'
  /** unique or primary key constraint on columns "wisetack_merchant_id" */
  | 'billing_profiles_wisetack_merchant_id_key';

/** input type for incrementing numeric columns in table "billing_profiles" */
export type BillingProfilesIncInput = {
  visitReplenishmentDay?: InputMaybe<Scalars['Int']>;
  visitReplenishmentMonth?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "billing_profiles" */
export type BillingProfilesInsertInput = {
  businessAddress?: InputMaybe<AddressesObjRelInsertInput>;
  businessAddressGuid?: InputMaybe<Scalars['uuid']>;
  businessFullLegalName?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contractorLicenseNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultPricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  defaultTaxRate?: InputMaybe<PricebookTaxRatesObjRelInsertInput>;
  emailAddress?: InputMaybe<EmailAddressesObjRelInsertInput>;
  emailAddressGuid?: InputMaybe<Scalars['uuid']>;
  estimateDisclaimer?: InputMaybe<Scalars['String']>;
  invoiceDisclaimer?: InputMaybe<Scalars['String']>;
  invoiceMemo?: InputMaybe<Scalars['String']>;
  invoiceTerm?: InputMaybe<InvoiceTermsEnum>;
  logoPhoto?: InputMaybe<PhotosObjRelInsertInput>;
  logoPhotoGuid?: InputMaybe<Scalars['uuid']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  maintenancePlanAutoRenewalAllowed?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanManualRenewalAllowed?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanServiceItem?: InputMaybe<PricebookItemsObjRelInsertInput>;
  maintenancePlanServiceItemGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanStaticDurationNumYearsAllowed?: InputMaybe<Array<Scalars['Int']>>;
  maintenancePlanTaxRate?: InputMaybe<PricebookTaxRatesObjRelInsertInput>;
  maintenancePlanTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<PhoneNumbersObjRelInsertInput>;
  phoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  tilledMerchantAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visitReplenishmentDay?: InputMaybe<Scalars['Int']>;
  visitReplenishmentMonth?: InputMaybe<Scalars['Int']>;
  visitReplenishmentStrategy?: InputMaybe<Scalars['String']>;
  websiteDisplayName?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  wisetackMerchantId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type BillingProfilesMaxFields = {
  __typename?: 'BillingProfilesMaxFields';
  businessAddressGuid?: Maybe<Scalars['uuid']>;
  businessFullLegalName?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  contractorLicenseNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultPricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  emailAddressGuid?: Maybe<Scalars['uuid']>;
  estimateDisclaimer?: Maybe<Scalars['String']>;
  invoiceDisclaimer?: Maybe<Scalars['String']>;
  invoiceMemo?: Maybe<Scalars['String']>;
  logoPhotoGuid?: Maybe<Scalars['uuid']>;
  logoUrl?: Maybe<Scalars['String']>;
  maintenancePlanServiceItemGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanStaticDurationNumYearsAllowed?: Maybe<Array<Scalars['Int']>>;
  maintenancePlanTaxRateGuid?: Maybe<Scalars['uuid']>;
  phoneNumberGuid?: Maybe<Scalars['uuid']>;
  tilledMerchantAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitReplenishmentDay?: Maybe<Scalars['Int']>;
  visitReplenishmentMonth?: Maybe<Scalars['Int']>;
  visitReplenishmentStrategy?: Maybe<Scalars['String']>;
  websiteDisplayName?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  wisetackMerchantId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type BillingProfilesMinFields = {
  __typename?: 'BillingProfilesMinFields';
  businessAddressGuid?: Maybe<Scalars['uuid']>;
  businessFullLegalName?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  contractorLicenseNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultPricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  emailAddressGuid?: Maybe<Scalars['uuid']>;
  estimateDisclaimer?: Maybe<Scalars['String']>;
  invoiceDisclaimer?: Maybe<Scalars['String']>;
  invoiceMemo?: Maybe<Scalars['String']>;
  logoPhotoGuid?: Maybe<Scalars['uuid']>;
  logoUrl?: Maybe<Scalars['String']>;
  maintenancePlanServiceItemGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanStaticDurationNumYearsAllowed?: Maybe<Array<Scalars['Int']>>;
  maintenancePlanTaxRateGuid?: Maybe<Scalars['uuid']>;
  phoneNumberGuid?: Maybe<Scalars['uuid']>;
  tilledMerchantAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitReplenishmentDay?: Maybe<Scalars['Int']>;
  visitReplenishmentMonth?: Maybe<Scalars['Int']>;
  visitReplenishmentStrategy?: Maybe<Scalars['String']>;
  websiteDisplayName?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  wisetackMerchantId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "billing_profiles" */
export type BillingProfilesMutationResponse = {
  __typename?: 'BillingProfilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BillingProfiles>;
};

/** input type for inserting object relation for remote table "billing_profiles" */
export type BillingProfilesObjRelInsertInput = {
  data: BillingProfilesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BillingProfilesOnConflict>;
};

/** on_conflict condition type for table "billing_profiles" */
export type BillingProfilesOnConflict = {
  constraint: BillingProfilesConstraint;
  updateColumns?: Array<BillingProfilesUpdateColumn>;
  where?: InputMaybe<BillingProfilesBoolExp>;
};

/** Ordering options when selecting data from "billing_profiles". */
export type BillingProfilesOrderBy = {
  businessAddress?: InputMaybe<AddressesOrderBy>;
  businessAddressGuid?: InputMaybe<OrderBy>;
  businessFullLegalName?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contractorLicenseNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  defaultPricebookTaxRateGuid?: InputMaybe<OrderBy>;
  defaultTaxRate?: InputMaybe<PricebookTaxRatesOrderBy>;
  emailAddress?: InputMaybe<EmailAddressesOrderBy>;
  emailAddressGuid?: InputMaybe<OrderBy>;
  estimateDisclaimer?: InputMaybe<OrderBy>;
  invoiceDisclaimer?: InputMaybe<OrderBy>;
  invoiceMemo?: InputMaybe<OrderBy>;
  invoiceTerm?: InputMaybe<OrderBy>;
  logoPhoto?: InputMaybe<PhotosOrderBy>;
  logoPhotoGuid?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  maintenancePlanAutoRenewalAllowed?: InputMaybe<OrderBy>;
  maintenancePlanManualRenewalAllowed?: InputMaybe<OrderBy>;
  maintenancePlanServiceItem?: InputMaybe<PricebookItemsOrderBy>;
  maintenancePlanServiceItemGuid?: InputMaybe<OrderBy>;
  maintenancePlanStaticDurationNumYearsAllowed?: InputMaybe<OrderBy>;
  maintenancePlanTaxRate?: InputMaybe<PricebookTaxRatesOrderBy>;
  maintenancePlanTaxRateGuid?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<PhoneNumbersOrderBy>;
  phoneNumberGuid?: InputMaybe<OrderBy>;
  tilledMerchantAccountId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  visitReplenishmentDay?: InputMaybe<OrderBy>;
  visitReplenishmentMonth?: InputMaybe<OrderBy>;
  visitReplenishmentStrategy?: InputMaybe<OrderBy>;
  websiteDisplayName?: InputMaybe<OrderBy>;
  websiteUrl?: InputMaybe<OrderBy>;
  wisetackMerchantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: billing_profiles */
export type BillingProfilesPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "billing_profiles" */
export type BillingProfilesSelectColumn =
  /** column name */
  | 'businessAddressGuid'
  /** column name */
  | 'businessFullLegalName'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contractorLicenseNumber'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'defaultPricebookTaxRateGuid'
  /** column name */
  | 'emailAddressGuid'
  /** column name */
  | 'estimateDisclaimer'
  /** column name */
  | 'invoiceDisclaimer'
  /** column name */
  | 'invoiceMemo'
  /** column name */
  | 'invoiceTerm'
  /** column name */
  | 'logoPhotoGuid'
  /** column name */
  | 'logoUrl'
  /** column name */
  | 'maintenancePlanAutoRenewalAllowed'
  /** column name */
  | 'maintenancePlanManualRenewalAllowed'
  /** column name */
  | 'maintenancePlanServiceItemGuid'
  /** column name */
  | 'maintenancePlanStaticDurationNumYearsAllowed'
  /** column name */
  | 'maintenancePlanTaxRateGuid'
  /** column name */
  | 'phoneNumberGuid'
  /** column name */
  | 'tilledMerchantAccountId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'visitReplenishmentDay'
  /** column name */
  | 'visitReplenishmentMonth'
  /** column name */
  | 'visitReplenishmentStrategy'
  /** column name */
  | 'websiteDisplayName'
  /** column name */
  | 'websiteUrl'
  /** column name */
  | 'wisetackMerchantId';

/** input type for updating data in table "billing_profiles" */
export type BillingProfilesSetInput = {
  businessAddressGuid?: InputMaybe<Scalars['uuid']>;
  businessFullLegalName?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contractorLicenseNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultPricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  emailAddressGuid?: InputMaybe<Scalars['uuid']>;
  estimateDisclaimer?: InputMaybe<Scalars['String']>;
  invoiceDisclaimer?: InputMaybe<Scalars['String']>;
  invoiceMemo?: InputMaybe<Scalars['String']>;
  invoiceTerm?: InputMaybe<InvoiceTermsEnum>;
  logoPhotoGuid?: InputMaybe<Scalars['uuid']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  maintenancePlanAutoRenewalAllowed?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanManualRenewalAllowed?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanServiceItemGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanStaticDurationNumYearsAllowed?: InputMaybe<Array<Scalars['Int']>>;
  maintenancePlanTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  phoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  tilledMerchantAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visitReplenishmentDay?: InputMaybe<Scalars['Int']>;
  visitReplenishmentMonth?: InputMaybe<Scalars['Int']>;
  visitReplenishmentStrategy?: InputMaybe<Scalars['String']>;
  websiteDisplayName?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  wisetackMerchantId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type BillingProfilesStddevFields = {
  __typename?: 'BillingProfilesStddevFields';
  visitReplenishmentDay?: Maybe<Scalars['Float']>;
  visitReplenishmentMonth?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type BillingProfilesStddevPopFields = {
  __typename?: 'BillingProfilesStddevPopFields';
  visitReplenishmentDay?: Maybe<Scalars['Float']>;
  visitReplenishmentMonth?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type BillingProfilesStddevSampFields = {
  __typename?: 'BillingProfilesStddevSampFields';
  visitReplenishmentDay?: Maybe<Scalars['Float']>;
  visitReplenishmentMonth?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "billing_profiles" */
export type BillingProfilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BillingProfilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BillingProfilesStreamCursorValueInput = {
  businessAddressGuid?: InputMaybe<Scalars['uuid']>;
  businessFullLegalName?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contractorLicenseNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultPricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  emailAddressGuid?: InputMaybe<Scalars['uuid']>;
  estimateDisclaimer?: InputMaybe<Scalars['String']>;
  invoiceDisclaimer?: InputMaybe<Scalars['String']>;
  invoiceMemo?: InputMaybe<Scalars['String']>;
  invoiceTerm?: InputMaybe<InvoiceTermsEnum>;
  logoPhotoGuid?: InputMaybe<Scalars['uuid']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  maintenancePlanAutoRenewalAllowed?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanManualRenewalAllowed?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanServiceItemGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanStaticDurationNumYearsAllowed?: InputMaybe<Array<Scalars['Int']>>;
  maintenancePlanTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  phoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  tilledMerchantAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visitReplenishmentDay?: InputMaybe<Scalars['Int']>;
  visitReplenishmentMonth?: InputMaybe<Scalars['Int']>;
  visitReplenishmentStrategy?: InputMaybe<Scalars['String']>;
  websiteDisplayName?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  wisetackMerchantId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type BillingProfilesSumFields = {
  __typename?: 'BillingProfilesSumFields';
  visitReplenishmentDay?: Maybe<Scalars['Int']>;
  visitReplenishmentMonth?: Maybe<Scalars['Int']>;
};

/** update columns of table "billing_profiles" */
export type BillingProfilesUpdateColumn =
  /** column name */
  | 'businessAddressGuid'
  /** column name */
  | 'businessFullLegalName'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contractorLicenseNumber'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'defaultPricebookTaxRateGuid'
  /** column name */
  | 'emailAddressGuid'
  /** column name */
  | 'estimateDisclaimer'
  /** column name */
  | 'invoiceDisclaimer'
  /** column name */
  | 'invoiceMemo'
  /** column name */
  | 'invoiceTerm'
  /** column name */
  | 'logoPhotoGuid'
  /** column name */
  | 'logoUrl'
  /** column name */
  | 'maintenancePlanAutoRenewalAllowed'
  /** column name */
  | 'maintenancePlanManualRenewalAllowed'
  /** column name */
  | 'maintenancePlanServiceItemGuid'
  /** column name */
  | 'maintenancePlanStaticDurationNumYearsAllowed'
  /** column name */
  | 'maintenancePlanTaxRateGuid'
  /** column name */
  | 'phoneNumberGuid'
  /** column name */
  | 'tilledMerchantAccountId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'visitReplenishmentDay'
  /** column name */
  | 'visitReplenishmentMonth'
  /** column name */
  | 'visitReplenishmentStrategy'
  /** column name */
  | 'websiteDisplayName'
  /** column name */
  | 'websiteUrl'
  /** column name */
  | 'wisetackMerchantId';

export type BillingProfilesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BillingProfilesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BillingProfilesSetInput>;
  /** filter the rows which have to be updated */
  where: BillingProfilesBoolExp;
};

/** aggregate varPop on columns */
export type BillingProfilesVarPopFields = {
  __typename?: 'BillingProfilesVarPopFields';
  visitReplenishmentDay?: Maybe<Scalars['Float']>;
  visitReplenishmentMonth?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type BillingProfilesVarSampFields = {
  __typename?: 'BillingProfilesVarSampFields';
  visitReplenishmentDay?: Maybe<Scalars['Float']>;
  visitReplenishmentMonth?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BillingProfilesVarianceFields = {
  __typename?: 'BillingProfilesVarianceFields';
  visitReplenishmentDay?: Maybe<Scalars['Float']>;
  visitReplenishmentMonth?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type BusinessEventTypesEnum =
  | 'APPOINTMENT_CONFIRMED'
  | 'APPOINTMENT_SCHEDULED'
  | 'CSV_EXPORT_REQUESTED'
  | 'ESTIMATE_ACCEPTED'
  | 'ESTIMATE_CREATED'
  | 'ESTIMATE_REJECTED'
  | 'INVOICE_CREATED'
  | 'JOB_LIFECYCLE_STATUS_CHANGED'
  | 'MAINTENANCE_PLAN_ACTIVATED'
  | 'MAINTENANCE_PLAN_CANCELED'
  | 'MAINTENANCE_PLAN_CHANGED'
  | 'MAINTENANCE_PLAN_EXPIRED'
  | 'MAINTENANCE_PLAN_LAPSED'
  | 'NOTE_CREATED';

/** Boolean expression to compare columns of type "BusinessEventTypesEnum". All fields are combined with logical 'AND'. */
export type BusinessEventTypesEnumComparisonExp = {
  _eq?: InputMaybe<BusinessEventTypesEnum>;
  _in?: InputMaybe<Array<BusinessEventTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<BusinessEventTypesEnum>;
  _nin?: InputMaybe<Array<BusinessEventTypesEnum>>;
};

/** columns and relationships of "business_events" */
export type BusinessEvents = {
  __typename?: 'BusinessEvents';
  businessEventGuid: Scalars['uuid'];
  businessEventType: BusinessEventTypesEnum;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  data: Scalars['jsonb'];
};


/** columns and relationships of "business_events" */
export type BusinessEventsDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "business_events" */
export type BusinessEventsAggregate = {
  __typename?: 'BusinessEventsAggregate';
  aggregate?: Maybe<BusinessEventsAggregateFields>;
  nodes: Array<BusinessEvents>;
};

/** aggregate fields of "business_events" */
export type BusinessEventsAggregateFields = {
  __typename?: 'BusinessEventsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BusinessEventsMaxFields>;
  min?: Maybe<BusinessEventsMinFields>;
};


/** aggregate fields of "business_events" */
export type BusinessEventsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BusinessEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BusinessEventsAppendInput = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "business_events". All fields are combined with a logical 'AND'. */
export type BusinessEventsBoolExp = {
  _and?: InputMaybe<Array<BusinessEventsBoolExp>>;
  _not?: InputMaybe<BusinessEventsBoolExp>;
  _or?: InputMaybe<Array<BusinessEventsBoolExp>>;
  businessEventGuid?: InputMaybe<UuidComparisonExp>;
  businessEventType?: InputMaybe<BusinessEventTypesEnumComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  data?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "business_events" */
export type BusinessEventsConstraint =
  /** unique or primary key constraint on columns "business_event_guid" */
  | 'business_events_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BusinessEventsDeleteAtPathInput = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BusinessEventsDeleteElemInput = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BusinessEventsDeleteKeyInput = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "business_events" */
export type BusinessEventsInsertInput = {
  businessEventGuid?: InputMaybe<Scalars['uuid']>;
  businessEventType?: InputMaybe<BusinessEventTypesEnum>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type BusinessEventsMaxFields = {
  __typename?: 'BusinessEventsMaxFields';
  businessEventGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type BusinessEventsMinFields = {
  __typename?: 'BusinessEventsMinFields';
  businessEventGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "business_events" */
export type BusinessEventsMutationResponse = {
  __typename?: 'BusinessEventsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessEvents>;
};

/** on_conflict condition type for table "business_events" */
export type BusinessEventsOnConflict = {
  constraint: BusinessEventsConstraint;
  updateColumns?: Array<BusinessEventsUpdateColumn>;
  where?: InputMaybe<BusinessEventsBoolExp>;
};

/** Ordering options when selecting data from "business_events". */
export type BusinessEventsOrderBy = {
  businessEventGuid?: InputMaybe<OrderBy>;
  businessEventType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  data?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business_events */
export type BusinessEventsPkColumnsInput = {
  businessEventGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BusinessEventsPrependInput = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "business_events" */
export type BusinessEventsSelectColumn =
  /** column name */
  | 'businessEventGuid'
  /** column name */
  | 'businessEventType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'data';

/** input type for updating data in table "business_events" */
export type BusinessEventsSetInput = {
  businessEventGuid?: InputMaybe<Scalars['uuid']>;
  businessEventType?: InputMaybe<BusinessEventTypesEnum>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "business_events" */
export type BusinessEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessEventsStreamCursorValueInput = {
  businessEventGuid?: InputMaybe<Scalars['uuid']>;
  businessEventType?: InputMaybe<BusinessEventTypesEnum>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "business_events" */
export type BusinessEventsUpdateColumn =
  /** column name */
  | 'businessEventGuid'
  /** column name */
  | 'businessEventType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'data';

export type BusinessEventsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BusinessEventsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<BusinessEventsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<BusinessEventsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<BusinessEventsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BusinessEventsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessEventsSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessEventsBoolExp;
};

/** columns and relationships of "business_unit_target_metrics" */
export type BusinessUnitTargetMetrics = {
  __typename?: 'BusinessUnitTargetMetrics';
  /** An object relationship */
  businessUnit: BusinessUnits;
  businessUnitGuid: Scalars['uuid'];
  businessUnitMetricName: Scalars['String'];
  businessUnitMetricValue: Scalars['numeric'];
  businessUnitTargetMetricGuid: Scalars['uuid'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  dateEnd?: Maybe<Scalars['date']>;
  dateStart: Scalars['date'];
};

/** aggregated selection of "business_unit_target_metrics" */
export type BusinessUnitTargetMetricsAggregate = {
  __typename?: 'BusinessUnitTargetMetricsAggregate';
  aggregate?: Maybe<BusinessUnitTargetMetricsAggregateFields>;
  nodes: Array<BusinessUnitTargetMetrics>;
};

/** aggregate fields of "business_unit_target_metrics" */
export type BusinessUnitTargetMetricsAggregateFields = {
  __typename?: 'BusinessUnitTargetMetricsAggregateFields';
  avg?: Maybe<BusinessUnitTargetMetricsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<BusinessUnitTargetMetricsMaxFields>;
  min?: Maybe<BusinessUnitTargetMetricsMinFields>;
  stddev?: Maybe<BusinessUnitTargetMetricsStddevFields>;
  stddevPop?: Maybe<BusinessUnitTargetMetricsStddevPopFields>;
  stddevSamp?: Maybe<BusinessUnitTargetMetricsStddevSampFields>;
  sum?: Maybe<BusinessUnitTargetMetricsSumFields>;
  varPop?: Maybe<BusinessUnitTargetMetricsVarPopFields>;
  varSamp?: Maybe<BusinessUnitTargetMetricsVarSampFields>;
  variance?: Maybe<BusinessUnitTargetMetricsVarianceFields>;
};


/** aggregate fields of "business_unit_target_metrics" */
export type BusinessUnitTargetMetricsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BusinessUnitTargetMetricsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type BusinessUnitTargetMetricsAvgFields = {
  __typename?: 'BusinessUnitTargetMetricsAvgFields';
  businessUnitMetricValue?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "business_unit_target_metrics". All fields are combined with a logical 'AND'. */
export type BusinessUnitTargetMetricsBoolExp = {
  _and?: InputMaybe<Array<BusinessUnitTargetMetricsBoolExp>>;
  _not?: InputMaybe<BusinessUnitTargetMetricsBoolExp>;
  _or?: InputMaybe<Array<BusinessUnitTargetMetricsBoolExp>>;
  businessUnit?: InputMaybe<BusinessUnitsBoolExp>;
  businessUnitGuid?: InputMaybe<UuidComparisonExp>;
  businessUnitMetricName?: InputMaybe<StringComparisonExp>;
  businessUnitMetricValue?: InputMaybe<NumericComparisonExp>;
  businessUnitTargetMetricGuid?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dateEnd?: InputMaybe<DateComparisonExp>;
  dateStart?: InputMaybe<DateComparisonExp>;
};

/** unique or primary key constraints on table "business_unit_target_metrics" */
export type BusinessUnitTargetMetricsConstraint =
  /** unique or primary key constraint on columns "business_unit_target_metric_guid" */
  | 'business_unit_target_metrics_pkey';

/** input type for incrementing numeric columns in table "business_unit_target_metrics" */
export type BusinessUnitTargetMetricsIncInput = {
  businessUnitMetricValue?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "business_unit_target_metrics" */
export type BusinessUnitTargetMetricsInsertInput = {
  businessUnit?: InputMaybe<BusinessUnitsObjRelInsertInput>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  businessUnitMetricName?: InputMaybe<Scalars['String']>;
  businessUnitMetricValue?: InputMaybe<Scalars['numeric']>;
  businessUnitTargetMetricGuid?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dateEnd?: InputMaybe<Scalars['date']>;
  dateStart?: InputMaybe<Scalars['date']>;
};

/** aggregate max on columns */
export type BusinessUnitTargetMetricsMaxFields = {
  __typename?: 'BusinessUnitTargetMetricsMaxFields';
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  businessUnitMetricName?: Maybe<Scalars['String']>;
  businessUnitMetricValue?: Maybe<Scalars['numeric']>;
  businessUnitTargetMetricGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dateEnd?: Maybe<Scalars['date']>;
  dateStart?: Maybe<Scalars['date']>;
};

/** aggregate min on columns */
export type BusinessUnitTargetMetricsMinFields = {
  __typename?: 'BusinessUnitTargetMetricsMinFields';
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  businessUnitMetricName?: Maybe<Scalars['String']>;
  businessUnitMetricValue?: Maybe<Scalars['numeric']>;
  businessUnitTargetMetricGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dateEnd?: Maybe<Scalars['date']>;
  dateStart?: Maybe<Scalars['date']>;
};

/** response of any mutation on the table "business_unit_target_metrics" */
export type BusinessUnitTargetMetricsMutationResponse = {
  __typename?: 'BusinessUnitTargetMetricsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessUnitTargetMetrics>;
};

/** on_conflict condition type for table "business_unit_target_metrics" */
export type BusinessUnitTargetMetricsOnConflict = {
  constraint: BusinessUnitTargetMetricsConstraint;
  updateColumns?: Array<BusinessUnitTargetMetricsUpdateColumn>;
  where?: InputMaybe<BusinessUnitTargetMetricsBoolExp>;
};

/** Ordering options when selecting data from "business_unit_target_metrics". */
export type BusinessUnitTargetMetricsOrderBy = {
  businessUnit?: InputMaybe<BusinessUnitsOrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  businessUnitMetricName?: InputMaybe<OrderBy>;
  businessUnitMetricValue?: InputMaybe<OrderBy>;
  businessUnitTargetMetricGuid?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dateEnd?: InputMaybe<OrderBy>;
  dateStart?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business_unit_target_metrics */
export type BusinessUnitTargetMetricsPkColumnsInput = {
  businessUnitTargetMetricGuid: Scalars['uuid'];
};

/** select columns of table "business_unit_target_metrics" */
export type BusinessUnitTargetMetricsSelectColumn =
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'businessUnitMetricName'
  /** column name */
  | 'businessUnitMetricValue'
  /** column name */
  | 'businessUnitTargetMetricGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dateEnd'
  /** column name */
  | 'dateStart';

/** input type for updating data in table "business_unit_target_metrics" */
export type BusinessUnitTargetMetricsSetInput = {
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  businessUnitMetricName?: InputMaybe<Scalars['String']>;
  businessUnitMetricValue?: InputMaybe<Scalars['numeric']>;
  businessUnitTargetMetricGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dateEnd?: InputMaybe<Scalars['date']>;
  dateStart?: InputMaybe<Scalars['date']>;
};

/** aggregate stddev on columns */
export type BusinessUnitTargetMetricsStddevFields = {
  __typename?: 'BusinessUnitTargetMetricsStddevFields';
  businessUnitMetricValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type BusinessUnitTargetMetricsStddevPopFields = {
  __typename?: 'BusinessUnitTargetMetricsStddevPopFields';
  businessUnitMetricValue?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type BusinessUnitTargetMetricsStddevSampFields = {
  __typename?: 'BusinessUnitTargetMetricsStddevSampFields';
  businessUnitMetricValue?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "business_unit_target_metrics" */
export type BusinessUnitTargetMetricsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessUnitTargetMetricsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessUnitTargetMetricsStreamCursorValueInput = {
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  businessUnitMetricName?: InputMaybe<Scalars['String']>;
  businessUnitMetricValue?: InputMaybe<Scalars['numeric']>;
  businessUnitTargetMetricGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dateEnd?: InputMaybe<Scalars['date']>;
  dateStart?: InputMaybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type BusinessUnitTargetMetricsSumFields = {
  __typename?: 'BusinessUnitTargetMetricsSumFields';
  businessUnitMetricValue?: Maybe<Scalars['numeric']>;
};

/** update columns of table "business_unit_target_metrics" */
export type BusinessUnitTargetMetricsUpdateColumn =
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'businessUnitMetricName'
  /** column name */
  | 'businessUnitMetricValue'
  /** column name */
  | 'businessUnitTargetMetricGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dateEnd'
  /** column name */
  | 'dateStart';

export type BusinessUnitTargetMetricsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BusinessUnitTargetMetricsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessUnitTargetMetricsSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessUnitTargetMetricsBoolExp;
};

/** aggregate varPop on columns */
export type BusinessUnitTargetMetricsVarPopFields = {
  __typename?: 'BusinessUnitTargetMetricsVarPopFields';
  businessUnitMetricValue?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type BusinessUnitTargetMetricsVarSampFields = {
  __typename?: 'BusinessUnitTargetMetricsVarSampFields';
  businessUnitMetricValue?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BusinessUnitTargetMetricsVarianceFields = {
  __typename?: 'BusinessUnitTargetMetricsVarianceFields';
  businessUnitMetricValue?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "business_units" */
export type BusinessUnits = {
  __typename?: 'BusinessUnits';
  accountingIntegrationName?: Maybe<Scalars['String']>;
  businessUnitGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "business_units" */
export type BusinessUnitsAggregate = {
  __typename?: 'BusinessUnitsAggregate';
  aggregate?: Maybe<BusinessUnitsAggregateFields>;
  nodes: Array<BusinessUnits>;
};

/** aggregate fields of "business_units" */
export type BusinessUnitsAggregateFields = {
  __typename?: 'BusinessUnitsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<BusinessUnitsMaxFields>;
  min?: Maybe<BusinessUnitsMinFields>;
};


/** aggregate fields of "business_units" */
export type BusinessUnitsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BusinessUnitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "business_units". All fields are combined with a logical 'AND'. */
export type BusinessUnitsBoolExp = {
  _and?: InputMaybe<Array<BusinessUnitsBoolExp>>;
  _not?: InputMaybe<BusinessUnitsBoolExp>;
  _or?: InputMaybe<Array<BusinessUnitsBoolExp>>;
  accountingIntegrationName?: InputMaybe<StringComparisonExp>;
  businessUnitGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business_units" */
export type BusinessUnitsConstraint =
  /** unique or primary key constraint on columns "company_guid", "name" */
  | 'business_units_company_guid_name_key'
  /** unique or primary key constraint on columns "business_unit_guid" */
  | 'business_units_pkey';

/** input type for inserting data into table "business_units" */
export type BusinessUnitsInsertInput = {
  accountingIntegrationName?: InputMaybe<Scalars['String']>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type BusinessUnitsMaxFields = {
  __typename?: 'BusinessUnitsMaxFields';
  accountingIntegrationName?: Maybe<Scalars['String']>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type BusinessUnitsMinFields = {
  __typename?: 'BusinessUnitsMinFields';
  accountingIntegrationName?: Maybe<Scalars['String']>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "business_units" */
export type BusinessUnitsMutationResponse = {
  __typename?: 'BusinessUnitsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessUnits>;
};

/** input type for inserting object relation for remote table "business_units" */
export type BusinessUnitsObjRelInsertInput = {
  data: BusinessUnitsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BusinessUnitsOnConflict>;
};

/** on_conflict condition type for table "business_units" */
export type BusinessUnitsOnConflict = {
  constraint: BusinessUnitsConstraint;
  updateColumns?: Array<BusinessUnitsUpdateColumn>;
  where?: InputMaybe<BusinessUnitsBoolExp>;
};

/** Ordering options when selecting data from "business_units". */
export type BusinessUnitsOrderBy = {
  accountingIntegrationName?: InputMaybe<OrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business_units */
export type BusinessUnitsPkColumnsInput = {
  businessUnitGuid: Scalars['uuid'];
};

/** select columns of table "business_units" */
export type BusinessUnitsSelectColumn =
  /** column name */
  | 'accountingIntegrationName'
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "business_units" */
export type BusinessUnitsSetInput = {
  accountingIntegrationName?: InputMaybe<Scalars['String']>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "business_units" */
export type BusinessUnitsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessUnitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessUnitsStreamCursorValueInput = {
  accountingIntegrationName?: InputMaybe<Scalars['String']>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "business_units" */
export type BusinessUnitsUpdateColumn =
  /** column name */
  | 'accountingIntegrationName'
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt';

export type BusinessUnitsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessUnitsSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessUnitsBoolExp;
};

/** columns and relationships of "canonical_lead_sources" */
export type CanonicalLeadSources = {
  __typename?: 'CanonicalLeadSources';
  attributionLinkingStrategy: Scalars['AttributionLinkingStrategy'];
  attributionPrompt?: Maybe<Scalars['String']>;
  canonicalLeadSourceName: Scalars['String'];
  /** An array relationship */
  companyLeadSources: Array<CompanyLeadSources>;
  /** An aggregate relationship */
  companyLeadSourcesAggregate: CompanyLeadSourcesAggregate;
};


/** columns and relationships of "canonical_lead_sources" */
export type CanonicalLeadSourcesCompanyLeadSourcesArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourcesOrderBy>>;
  where?: InputMaybe<CompanyLeadSourcesBoolExp>;
};


/** columns and relationships of "canonical_lead_sources" */
export type CanonicalLeadSourcesCompanyLeadSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourcesOrderBy>>;
  where?: InputMaybe<CompanyLeadSourcesBoolExp>;
};

/** aggregated selection of "canonical_lead_sources" */
export type CanonicalLeadSourcesAggregate = {
  __typename?: 'CanonicalLeadSourcesAggregate';
  aggregate?: Maybe<CanonicalLeadSourcesAggregateFields>;
  nodes: Array<CanonicalLeadSources>;
};

/** aggregate fields of "canonical_lead_sources" */
export type CanonicalLeadSourcesAggregateFields = {
  __typename?: 'CanonicalLeadSourcesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CanonicalLeadSourcesMaxFields>;
  min?: Maybe<CanonicalLeadSourcesMinFields>;
};


/** aggregate fields of "canonical_lead_sources" */
export type CanonicalLeadSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CanonicalLeadSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "canonical_lead_sources". All fields are combined with a logical 'AND'. */
export type CanonicalLeadSourcesBoolExp = {
  _and?: InputMaybe<Array<CanonicalLeadSourcesBoolExp>>;
  _not?: InputMaybe<CanonicalLeadSourcesBoolExp>;
  _or?: InputMaybe<Array<CanonicalLeadSourcesBoolExp>>;
  attributionLinkingStrategy?: InputMaybe<Scalars['AttributionLinkingStrategyComparisonExp']>;
  attributionPrompt?: InputMaybe<StringComparisonExp>;
  canonicalLeadSourceName?: InputMaybe<StringComparisonExp>;
  companyLeadSources?: InputMaybe<CompanyLeadSourcesBoolExp>;
  companyLeadSourcesAggregate?: InputMaybe<CompanyLeadSourcesAggregateBoolExp>;
};

/** unique or primary key constraints on table "canonical_lead_sources" */
export type CanonicalLeadSourcesConstraint =
  /** unique or primary key constraint on columns "canonical_lead_source_name" */
  | 'canonical_lead_sources_pkey';

/** input type for inserting data into table "canonical_lead_sources" */
export type CanonicalLeadSourcesInsertInput = {
  attributionLinkingStrategy?: InputMaybe<Scalars['AttributionLinkingStrategy']>;
  attributionPrompt?: InputMaybe<Scalars['String']>;
  canonicalLeadSourceName?: InputMaybe<Scalars['String']>;
  companyLeadSources?: InputMaybe<CompanyLeadSourcesArrRelInsertInput>;
};

/** aggregate max on columns */
export type CanonicalLeadSourcesMaxFields = {
  __typename?: 'CanonicalLeadSourcesMaxFields';
  attributionLinkingStrategy?: Maybe<Scalars['AttributionLinkingStrategy']>;
  attributionPrompt?: Maybe<Scalars['String']>;
  canonicalLeadSourceName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CanonicalLeadSourcesMinFields = {
  __typename?: 'CanonicalLeadSourcesMinFields';
  attributionLinkingStrategy?: Maybe<Scalars['AttributionLinkingStrategy']>;
  attributionPrompt?: Maybe<Scalars['String']>;
  canonicalLeadSourceName?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "canonical_lead_sources" */
export type CanonicalLeadSourcesMutationResponse = {
  __typename?: 'CanonicalLeadSourcesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CanonicalLeadSources>;
};

/** input type for inserting object relation for remote table "canonical_lead_sources" */
export type CanonicalLeadSourcesObjRelInsertInput = {
  data: CanonicalLeadSourcesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CanonicalLeadSourcesOnConflict>;
};

/** on_conflict condition type for table "canonical_lead_sources" */
export type CanonicalLeadSourcesOnConflict = {
  constraint: CanonicalLeadSourcesConstraint;
  updateColumns?: Array<CanonicalLeadSourcesUpdateColumn>;
  where?: InputMaybe<CanonicalLeadSourcesBoolExp>;
};

/** Ordering options when selecting data from "canonical_lead_sources". */
export type CanonicalLeadSourcesOrderBy = {
  attributionLinkingStrategy?: InputMaybe<OrderBy>;
  attributionPrompt?: InputMaybe<OrderBy>;
  canonicalLeadSourceName?: InputMaybe<OrderBy>;
  companyLeadSourcesAggregate?: InputMaybe<CompanyLeadSourcesAggregateOrderBy>;
};

/** primary key columns input for table: canonical_lead_sources */
export type CanonicalLeadSourcesPkColumnsInput = {
  canonicalLeadSourceName: Scalars['String'];
};

/** select columns of table "canonical_lead_sources" */
export type CanonicalLeadSourcesSelectColumn =
  /** column name */
  | 'attributionLinkingStrategy'
  /** column name */
  | 'attributionPrompt'
  /** column name */
  | 'canonicalLeadSourceName';

/** input type for updating data in table "canonical_lead_sources" */
export type CanonicalLeadSourcesSetInput = {
  attributionLinkingStrategy?: InputMaybe<Scalars['AttributionLinkingStrategy']>;
  attributionPrompt?: InputMaybe<Scalars['String']>;
  canonicalLeadSourceName?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "canonical_lead_sources" */
export type CanonicalLeadSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CanonicalLeadSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CanonicalLeadSourcesStreamCursorValueInput = {
  attributionLinkingStrategy?: InputMaybe<Scalars['AttributionLinkingStrategy']>;
  attributionPrompt?: InputMaybe<Scalars['String']>;
  canonicalLeadSourceName?: InputMaybe<Scalars['String']>;
};

/** update columns of table "canonical_lead_sources" */
export type CanonicalLeadSourcesUpdateColumn =
  /** column name */
  | 'attributionLinkingStrategy'
  /** column name */
  | 'attributionPrompt'
  /** column name */
  | 'canonicalLeadSourceName';

export type CanonicalLeadSourcesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CanonicalLeadSourcesSetInput>;
  /** filter the rows which have to be updated */
  where: CanonicalLeadSourcesBoolExp;
};

/** columns and relationships of "cart_item_job_cost_links" */
export type CartItemJobCostLinks = {
  __typename?: 'CartItemJobCostLinks';
  /** An object relationship */
  cartItem: CartItems;
  cartItemGuid: Scalars['uuid'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  costImportSuppressedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  invoice: Invoices;
  invoiceGuid: Scalars['uuid'];
  /** An object relationship */
  job: Jobs;
  /** An object relationship */
  jobCostItem?: Maybe<JobCostItems>;
  jobCostItemGuid?: Maybe<Scalars['uuid']>;
  jobGuid: Scalars['uuid'];
};

/** aggregated selection of "cart_item_job_cost_links" */
export type CartItemJobCostLinksAggregate = {
  __typename?: 'CartItemJobCostLinksAggregate';
  aggregate?: Maybe<CartItemJobCostLinksAggregateFields>;
  nodes: Array<CartItemJobCostLinks>;
};

/** aggregate fields of "cart_item_job_cost_links" */
export type CartItemJobCostLinksAggregateFields = {
  __typename?: 'CartItemJobCostLinksAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CartItemJobCostLinksMaxFields>;
  min?: Maybe<CartItemJobCostLinksMinFields>;
};


/** aggregate fields of "cart_item_job_cost_links" */
export type CartItemJobCostLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CartItemJobCostLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cart_item_job_cost_links". All fields are combined with a logical 'AND'. */
export type CartItemJobCostLinksBoolExp = {
  _and?: InputMaybe<Array<CartItemJobCostLinksBoolExp>>;
  _not?: InputMaybe<CartItemJobCostLinksBoolExp>;
  _or?: InputMaybe<Array<CartItemJobCostLinksBoolExp>>;
  cartItem?: InputMaybe<CartItemsBoolExp>;
  cartItemGuid?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  costImportSuppressedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobCostItem?: InputMaybe<JobCostItemsBoolExp>;
  jobCostItemGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "cart_item_job_cost_links" */
export type CartItemJobCostLinksConstraint =
  /** unique or primary key constraint on columns "job_guid", "cart_item_guid" */
  | 'cart_item_job_cost_links_pkey';

/** input type for inserting data into table "cart_item_job_cost_links" */
export type CartItemJobCostLinksInsertInput = {
  cartItem?: InputMaybe<CartItemsObjRelInsertInput>;
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costImportSuppressedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobCostItem?: InputMaybe<JobCostItemsObjRelInsertInput>;
  jobCostItemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CartItemJobCostLinksMaxFields = {
  __typename?: 'CartItemJobCostLinksMaxFields';
  cartItemGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  costImportSuppressedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  jobCostItemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type CartItemJobCostLinksMinFields = {
  __typename?: 'CartItemJobCostLinksMinFields';
  cartItemGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  costImportSuppressedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  jobCostItemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "cart_item_job_cost_links" */
export type CartItemJobCostLinksMutationResponse = {
  __typename?: 'CartItemJobCostLinksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CartItemJobCostLinks>;
};

/** on_conflict condition type for table "cart_item_job_cost_links" */
export type CartItemJobCostLinksOnConflict = {
  constraint: CartItemJobCostLinksConstraint;
  updateColumns?: Array<CartItemJobCostLinksUpdateColumn>;
  where?: InputMaybe<CartItemJobCostLinksBoolExp>;
};

/** Ordering options when selecting data from "cart_item_job_cost_links". */
export type CartItemJobCostLinksOrderBy = {
  cartItem?: InputMaybe<CartItemsOrderBy>;
  cartItemGuid?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  costImportSuppressedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobCostItem?: InputMaybe<JobCostItemsOrderBy>;
  jobCostItemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cart_item_job_cost_links */
export type CartItemJobCostLinksPkColumnsInput = {
  cartItemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
};

/** select columns of table "cart_item_job_cost_links" */
export type CartItemJobCostLinksSelectColumn =
  /** column name */
  | 'cartItemGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'costImportSuppressedAt'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'jobCostItemGuid'
  /** column name */
  | 'jobGuid';

/** input type for updating data in table "cart_item_job_cost_links" */
export type CartItemJobCostLinksSetInput = {
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costImportSuppressedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  jobCostItemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "cart_item_job_cost_links" */
export type CartItemJobCostLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CartItemJobCostLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CartItemJobCostLinksStreamCursorValueInput = {
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costImportSuppressedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  jobCostItemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "cart_item_job_cost_links" */
export type CartItemJobCostLinksUpdateColumn =
  /** column name */
  | 'cartItemGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'costImportSuppressedAt'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'jobCostItemGuid'
  /** column name */
  | 'jobGuid';

export type CartItemJobCostLinksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CartItemJobCostLinksSetInput>;
  /** filter the rows which have to be updated */
  where: CartItemJobCostLinksBoolExp;
};

/** columns and relationships of "cart_items" */
export type CartItems = {
  __typename?: 'CartItems';
  cartItemCode?: Maybe<Scalars['String']>;
  cartItemGuid: Scalars['uuid'];
  cartItemType: Scalars['CartItemType'];
  cartItemVariant: Scalars['CartItemVariant'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['HtmlString']>;
  /** An array relationship */
  estimateOptionCartItems: Array<EstimateOptionCartItems>;
  /** An aggregate relationship */
  estimateOptionCartItemsAggregate: EstimateOptionCartItemsAggregate;
  /** An array relationship */
  invoiceCartItems: Array<InvoiceCartItems>;
  /** An aggregate relationship */
  invoiceCartItemsAggregate: InvoiceCartItemsAggregate;
  /** An array relationship */
  invoiceTemplateCartItems: Array<InvoiceTemplateCartItems>;
  /** An aggregate relationship */
  invoiceTemplateCartItemsAggregate: InvoiceTemplateCartItemsAggregate;
  isDiscountable: Scalars['Boolean'];
  isTaxable: Scalars['Boolean'];
  name: Scalars['String'];
  originalPricebookItemGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  photo?: Maybe<Photos>;
  photoGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  pricebookItem?: Maybe<PricebookItems>;
  quantity: Scalars['numeric'];
  unitPriceUsc: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "cart_items" */
export type CartItemsEstimateOptionCartItemsArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionCartItemsOrderBy>>;
  where?: InputMaybe<EstimateOptionCartItemsBoolExp>;
};


/** columns and relationships of "cart_items" */
export type CartItemsEstimateOptionCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionCartItemsOrderBy>>;
  where?: InputMaybe<EstimateOptionCartItemsBoolExp>;
};


/** columns and relationships of "cart_items" */
export type CartItemsInvoiceCartItemsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemsBoolExp>;
};


/** columns and relationships of "cart_items" */
export type CartItemsInvoiceCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemsBoolExp>;
};


/** columns and relationships of "cart_items" */
export type CartItemsInvoiceTemplateCartItemsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceTemplateCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceTemplateCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
};


/** columns and relationships of "cart_items" */
export type CartItemsInvoiceTemplateCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceTemplateCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceTemplateCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
};

/** aggregated selection of "cart_items" */
export type CartItemsAggregate = {
  __typename?: 'CartItemsAggregate';
  aggregate?: Maybe<CartItemsAggregateFields>;
  nodes: Array<CartItems>;
};

/** aggregate fields of "cart_items" */
export type CartItemsAggregateFields = {
  __typename?: 'CartItemsAggregateFields';
  avg?: Maybe<CartItemsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CartItemsMaxFields>;
  min?: Maybe<CartItemsMinFields>;
  stddev?: Maybe<CartItemsStddevFields>;
  stddevPop?: Maybe<CartItemsStddevPopFields>;
  stddevSamp?: Maybe<CartItemsStddevSampFields>;
  sum?: Maybe<CartItemsSumFields>;
  varPop?: Maybe<CartItemsVarPopFields>;
  varSamp?: Maybe<CartItemsVarSampFields>;
  variance?: Maybe<CartItemsVarianceFields>;
};


/** aggregate fields of "cart_items" */
export type CartItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CartItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CartItemsAvgFields = {
  __typename?: 'CartItemsAvgFields';
  quantity?: Maybe<Scalars['Float']>;
  unitPriceUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cart_items". All fields are combined with a logical 'AND'. */
export type CartItemsBoolExp = {
  _and?: InputMaybe<Array<CartItemsBoolExp>>;
  _not?: InputMaybe<CartItemsBoolExp>;
  _or?: InputMaybe<Array<CartItemsBoolExp>>;
  cartItemCode?: InputMaybe<StringComparisonExp>;
  cartItemGuid?: InputMaybe<UuidComparisonExp>;
  cartItemType?: InputMaybe<Scalars['CartItemTypeComparisonExp']>;
  cartItemVariant?: InputMaybe<Scalars['CartItemVariantComparisonExp']>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
  estimateOptionCartItems?: InputMaybe<EstimateOptionCartItemsBoolExp>;
  estimateOptionCartItemsAggregate?: InputMaybe<EstimateOptionCartItemsAggregateBoolExp>;
  invoiceCartItems?: InputMaybe<InvoiceCartItemsBoolExp>;
  invoiceCartItemsAggregate?: InputMaybe<InvoiceCartItemsAggregateBoolExp>;
  invoiceTemplateCartItems?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
  invoiceTemplateCartItemsAggregate?: InputMaybe<InvoiceTemplateCartItemsAggregateBoolExp>;
  isDiscountable?: InputMaybe<BooleanComparisonExp>;
  isTaxable?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  originalPricebookItemGuid?: InputMaybe<UuidComparisonExp>;
  photo?: InputMaybe<PhotosBoolExp>;
  photoGuid?: InputMaybe<UuidComparisonExp>;
  pricebookItem?: InputMaybe<PricebookItemsBoolExp>;
  quantity?: InputMaybe<NumericComparisonExp>;
  unitPriceUsc?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "cart_items" */
export type CartItemsConstraint =
  /** unique or primary key constraint on columns "cart_item_guid" */
  | 'cart_items_pkey';

/** input type for incrementing numeric columns in table "cart_items" */
export type CartItemsIncInput = {
  quantity?: InputMaybe<Scalars['numeric']>;
  unitPriceUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "cart_items" */
export type CartItemsInsertInput = {
  cartItemCode?: InputMaybe<Scalars['String']>;
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  cartItemType?: InputMaybe<Scalars['CartItemType']>;
  cartItemVariant?: InputMaybe<Scalars['CartItemVariant']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['HtmlString']>;
  estimateOptionCartItems?: InputMaybe<EstimateOptionCartItemsArrRelInsertInput>;
  invoiceCartItems?: InputMaybe<InvoiceCartItemsArrRelInsertInput>;
  invoiceTemplateCartItems?: InputMaybe<InvoiceTemplateCartItemsArrRelInsertInput>;
  isDiscountable?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  originalPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  photo?: InputMaybe<PhotosObjRelInsertInput>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  pricebookItem?: InputMaybe<PricebookItemsObjRelInsertInput>;
  quantity?: InputMaybe<Scalars['numeric']>;
  unitPriceUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CartItemsMaxFields = {
  __typename?: 'CartItemsMaxFields';
  cartItemCode?: Maybe<Scalars['String']>;
  cartItemGuid?: Maybe<Scalars['uuid']>;
  cartItemType?: Maybe<Scalars['CartItemType']>;
  cartItemVariant?: Maybe<Scalars['CartItemVariant']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['HtmlString']>;
  name?: Maybe<Scalars['String']>;
  originalPricebookItemGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['numeric']>;
  unitPriceUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CartItemsMinFields = {
  __typename?: 'CartItemsMinFields';
  cartItemCode?: Maybe<Scalars['String']>;
  cartItemGuid?: Maybe<Scalars['uuid']>;
  cartItemType?: Maybe<Scalars['CartItemType']>;
  cartItemVariant?: Maybe<Scalars['CartItemVariant']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['HtmlString']>;
  name?: Maybe<Scalars['String']>;
  originalPricebookItemGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['numeric']>;
  unitPriceUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "cart_items" */
export type CartItemsMutationResponse = {
  __typename?: 'CartItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CartItems>;
};

/** input type for inserting object relation for remote table "cart_items" */
export type CartItemsObjRelInsertInput = {
  data: CartItemsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CartItemsOnConflict>;
};

/** on_conflict condition type for table "cart_items" */
export type CartItemsOnConflict = {
  constraint: CartItemsConstraint;
  updateColumns?: Array<CartItemsUpdateColumn>;
  where?: InputMaybe<CartItemsBoolExp>;
};

/** Ordering options when selecting data from "cart_items". */
export type CartItemsOrderBy = {
  cartItemCode?: InputMaybe<OrderBy>;
  cartItemGuid?: InputMaybe<OrderBy>;
  cartItemType?: InputMaybe<OrderBy>;
  cartItemVariant?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  estimateOptionCartItemsAggregate?: InputMaybe<EstimateOptionCartItemsAggregateOrderBy>;
  invoiceCartItemsAggregate?: InputMaybe<InvoiceCartItemsAggregateOrderBy>;
  invoiceTemplateCartItemsAggregate?: InputMaybe<InvoiceTemplateCartItemsAggregateOrderBy>;
  isDiscountable?: InputMaybe<OrderBy>;
  isTaxable?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  originalPricebookItemGuid?: InputMaybe<OrderBy>;
  photo?: InputMaybe<PhotosOrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  pricebookItem?: InputMaybe<PricebookItemsOrderBy>;
  quantity?: InputMaybe<OrderBy>;
  unitPriceUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cart_items */
export type CartItemsPkColumnsInput = {
  cartItemGuid: Scalars['uuid'];
};

/** select columns of table "cart_items" */
export type CartItemsSelectColumn =
  /** column name */
  | 'cartItemCode'
  /** column name */
  | 'cartItemGuid'
  /** column name */
  | 'cartItemType'
  /** column name */
  | 'cartItemVariant'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'isDiscountable'
  /** column name */
  | 'isTaxable'
  /** column name */
  | 'name'
  /** column name */
  | 'originalPricebookItemGuid'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'quantity'
  /** column name */
  | 'unitPriceUsc'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "cart_items" */
export type CartItemsSetInput = {
  cartItemCode?: InputMaybe<Scalars['String']>;
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  cartItemType?: InputMaybe<Scalars['CartItemType']>;
  cartItemVariant?: InputMaybe<Scalars['CartItemVariant']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['HtmlString']>;
  isDiscountable?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  originalPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  unitPriceUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type CartItemsStddevFields = {
  __typename?: 'CartItemsStddevFields';
  quantity?: Maybe<Scalars['Float']>;
  unitPriceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CartItemsStddevPopFields = {
  __typename?: 'CartItemsStddevPopFields';
  quantity?: Maybe<Scalars['Float']>;
  unitPriceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CartItemsStddevSampFields = {
  __typename?: 'CartItemsStddevSampFields';
  quantity?: Maybe<Scalars['Float']>;
  unitPriceUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cart_items" */
export type CartItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CartItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CartItemsStreamCursorValueInput = {
  cartItemCode?: InputMaybe<Scalars['String']>;
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  cartItemType?: InputMaybe<Scalars['CartItemType']>;
  cartItemVariant?: InputMaybe<Scalars['CartItemVariant']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['HtmlString']>;
  isDiscountable?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  originalPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  unitPriceUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CartItemsSumFields = {
  __typename?: 'CartItemsSumFields';
  quantity?: Maybe<Scalars['numeric']>;
  unitPriceUsc?: Maybe<Scalars['Int']>;
};

/** update columns of table "cart_items" */
export type CartItemsUpdateColumn =
  /** column name */
  | 'cartItemCode'
  /** column name */
  | 'cartItemGuid'
  /** column name */
  | 'cartItemType'
  /** column name */
  | 'cartItemVariant'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'isDiscountable'
  /** column name */
  | 'isTaxable'
  /** column name */
  | 'name'
  /** column name */
  | 'originalPricebookItemGuid'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'quantity'
  /** column name */
  | 'unitPriceUsc'
  /** column name */
  | 'updatedAt';

export type CartItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CartItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CartItemsSetInput>;
  /** filter the rows which have to be updated */
  where: CartItemsBoolExp;
};

/** aggregate varPop on columns */
export type CartItemsVarPopFields = {
  __typename?: 'CartItemsVarPopFields';
  quantity?: Maybe<Scalars['Float']>;
  unitPriceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CartItemsVarSampFields = {
  __typename?: 'CartItemsVarSampFields';
  quantity?: Maybe<Scalars['Float']>;
  unitPriceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CartItemsVarianceFields = {
  __typename?: 'CartItemsVarianceFields';
  quantity?: Maybe<Scalars['Float']>;
  unitPriceUsc?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "checklist_items" */
export type ChecklistItems = {
  __typename?: 'ChecklistItems';
  checklistItemGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
  completedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  completedByUser?: Maybe<Users>;
  completedByUserGuid?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  description: Scalars['String'];
  groupingKey: Scalars['String'];
  isCompleted: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "checklist_items" */
export type ChecklistItemsAggregate = {
  __typename?: 'ChecklistItemsAggregate';
  aggregate?: Maybe<ChecklistItemsAggregateFields>;
  nodes: Array<ChecklistItems>;
};

/** aggregate fields of "checklist_items" */
export type ChecklistItemsAggregateFields = {
  __typename?: 'ChecklistItemsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ChecklistItemsMaxFields>;
  min?: Maybe<ChecklistItemsMinFields>;
};


/** aggregate fields of "checklist_items" */
export type ChecklistItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChecklistItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "checklist_items". All fields are combined with a logical 'AND'. */
export type ChecklistItemsBoolExp = {
  _and?: InputMaybe<Array<ChecklistItemsBoolExp>>;
  _not?: InputMaybe<ChecklistItemsBoolExp>;
  _or?: InputMaybe<Array<ChecklistItemsBoolExp>>;
  checklistItemGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  completedByUser?: InputMaybe<UsersBoolExp>;
  completedByUserGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  groupingKey?: InputMaybe<StringComparisonExp>;
  isCompleted?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "checklist_items" */
export type ChecklistItemsConstraint =
  /** unique or primary key constraint on columns "checklist_item_guid" */
  | 'checklist_items_pkey';

/** input type for inserting data into table "checklist_items" */
export type ChecklistItemsInsertInput = {
  checklistItemGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  completedByUser?: InputMaybe<UsersObjRelInsertInput>;
  completedByUserGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  groupingKey?: InputMaybe<Scalars['String']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ChecklistItemsMaxFields = {
  __typename?: 'ChecklistItemsMaxFields';
  checklistItemGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  completedByUserGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  groupingKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type ChecklistItemsMinFields = {
  __typename?: 'ChecklistItemsMinFields';
  checklistItemGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  completedByUserGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  groupingKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "checklist_items" */
export type ChecklistItemsMutationResponse = {
  __typename?: 'ChecklistItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ChecklistItems>;
};

/** on_conflict condition type for table "checklist_items" */
export type ChecklistItemsOnConflict = {
  constraint: ChecklistItemsConstraint;
  updateColumns?: Array<ChecklistItemsUpdateColumn>;
  where?: InputMaybe<ChecklistItemsBoolExp>;
};

/** Ordering options when selecting data from "checklist_items". */
export type ChecklistItemsOrderBy = {
  checklistItemGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  completedByUser?: InputMaybe<UsersOrderBy>;
  completedByUserGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  groupingKey?: InputMaybe<OrderBy>;
  isCompleted?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: checklist_items */
export type ChecklistItemsPkColumnsInput = {
  checklistItemGuid: Scalars['uuid'];
};

/** select columns of table "checklist_items" */
export type ChecklistItemsSelectColumn =
  /** column name */
  | 'checklistItemGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'completedAt'
  /** column name */
  | 'completedByUserGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'groupingKey'
  /** column name */
  | 'isCompleted'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "checklist_items" */
export type ChecklistItemsSetInput = {
  checklistItemGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  completedByUserGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  groupingKey?: InputMaybe<Scalars['String']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "checklist_items" */
export type ChecklistItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChecklistItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChecklistItemsStreamCursorValueInput = {
  checklistItemGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  completedByUserGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  groupingKey?: InputMaybe<Scalars['String']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "checklist_items" */
export type ChecklistItemsUpdateColumn =
  /** column name */
  | 'checklistItemGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'completedAt'
  /** column name */
  | 'completedByUserGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'groupingKey'
  /** column name */
  | 'isCompleted'
  /** column name */
  | 'updatedAt';

export type ChecklistItemsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChecklistItemsSetInput>;
  /** filter the rows which have to be updated */
  where: ChecklistItemsBoolExp;
};

/** Residential HVAC company */
export type Companies = {
  __typename?: 'Companies';
  /** An array relationship */
  accCartItemTypeAccountsConfigs: Array<AccCartItemTypeAccountsConfig>;
  /** An aggregate relationship */
  accCartItemTypeAccountsConfigsAggregate: AccCartItemTypeAccountsConfigAggregate;
  /** An array relationship */
  accCompanyConfigs: Array<AccCompanyConfig>;
  /** An aggregate relationship */
  accCompanyConfigsAggregate: AccCompanyConfigAggregate;
  /** An object relationship */
  accQbdConductorConfig?: Maybe<AccQbdConductorConfig>;
  /** An array relationship */
  accSyncInfos: Array<AccSyncInfo>;
  /** An aggregate relationship */
  accSyncInfosAggregate: AccSyncInfoAggregate;
  /** An array relationship */
  accountContacts: Array<AccountContacts>;
  /** An aggregate relationship */
  accountContactsAggregate: AccountContactsAggregate;
  /** An array relationship */
  accountLocations: Array<AccountLocations>;
  /** An aggregate relationship */
  accountLocationsAggregate: AccountLocationsAggregate;
  /** An array relationship */
  accounts: Array<Accounts>;
  /** An aggregate relationship */
  accountsAggregate: AccountsAggregate;
  /** An object relationship */
  billingProfile?: Maybe<BillingProfiles>;
  breezySystemOfRecordDate: Scalars['timestamptz'];
  /** An array relationship */
  companyAppointmentArrivalWindows: Array<CompanyAppointmentArrivalWindows>;
  /** An aggregate relationship */
  companyAppointmentArrivalWindowsAggregate: CompanyAppointmentArrivalWindowsAggregate;
  /** An object relationship */
  companyConfig?: Maybe<CompanyConfig>;
  companyGuid: Scalars['uuid'];
  /** An array relationship */
  companyNotificationSettings: Array<CompanyNotificationSettings>;
  /** An aggregate relationship */
  companyNotificationSettingsAggregate: CompanyNotificationSettingsAggregate;
  /** An object relationship */
  companyNotificationSettingsOne?: Maybe<CompanyNotificationSettings>;
  /** An object relationship */
  companyPricingTierConfig?: Maybe<CompanyPricingTierConfig>;
  /** An array relationship */
  companyReviewLinks: Array<CompanyReviewLinks>;
  /** An aggregate relationship */
  companyReviewLinksAggregate: CompanyReviewLinksAggregate;
  /** An array relationship */
  companyUsers: Array<CompanyUsers>;
  /** An aggregate relationship */
  companyUsersAggregate: CompanyUsersAggregate;
  /** An object relationship */
  companyWorkingDisplayHours?: Maybe<CompanyWorkingDisplayHours>;
  /** An object relationship */
  currentTaxConfiguration?: Maybe<CurrentCompanyTaxConfigurationsView>;
  dataMigrationStatus: Scalars['String'];
  /** An object relationship */
  integratedPhoneCompanyConfig?: Maybe<IntegratedPhoneCompanyConfig>;
  /** An array relationship */
  integratedPhoneUsers: Array<IntegratedPhoneUsers>;
  /** An aggregate relationship */
  integratedPhoneUsersAggregate: IntegratedPhoneUsersAggregate;
  /** An array relationship */
  integratedPhones: Array<IntegratedPhones>;
  /** An aggregate relationship */
  integratedPhonesAggregate: IntegratedPhonesAggregate;
  /** An array relationship */
  invoicePayments: Array<InvoicePayments>;
  /** An aggregate relationship */
  invoicePaymentsAggregate: InvoicePaymentsAggregate;
  /** An object relationship */
  jobCostingConfig?: Maybe<JobCostingConfig>;
  /** An array relationship */
  jobTypes: Array<JobTypes>;
  /** An aggregate relationship */
  jobTypesAggregate: JobTypesAggregate;
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobsAggregate: JobsAggregate;
  /** An array relationship */
  maintenancePlanCoveredEquipmentTypes: Array<MaintenancePlanEquipmentCoverageDefinitions>;
  /** An aggregate relationship */
  maintenancePlanCoveredEquipmentTypesAggregate: MaintenancePlanEquipmentCoverageDefinitionsAggregate;
  name: Scalars['String'];
  /** An object relationship */
  onlineBookingCompanyConfig?: Maybe<OnlineBookingCompanyConfig>;
  /** An array relationship */
  onlineBookingServiceTypeConfigs: Array<OnlineBookingServiceTypeConfigs>;
  /** An aggregate relationship */
  onlineBookingServiceTypeConfigsAggregate: OnlineBookingServiceTypeConfigsAggregate;
  /** An array relationship */
  pricebookItems: Array<PricebookItems>;
  /** An aggregate relationship */
  pricebookItemsAggregate: PricebookItemsAggregate;
  /** An array relationship */
  pricebookTaxRates: Array<PricebookTaxRates>;
  /** An aggregate relationship */
  pricebookTaxRatesAggregate: PricebookTaxRatesAggregate;
  searchIndexingOnChange: Scalars['Boolean'];
  timezone: Scalars['TimeZoneId'];
};


/** Residential HVAC company */
export type CompaniesAccCartItemTypeAccountsConfigsArgs = {
  distinctOn?: InputMaybe<Array<AccCartItemTypeAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccCartItemTypeAccountsConfigOrderBy>>;
  where?: InputMaybe<AccCartItemTypeAccountsConfigBoolExp>;
};


/** Residential HVAC company */
export type CompaniesAccCartItemTypeAccountsConfigsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccCartItemTypeAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccCartItemTypeAccountsConfigOrderBy>>;
  where?: InputMaybe<AccCartItemTypeAccountsConfigBoolExp>;
};


/** Residential HVAC company */
export type CompaniesAccCompanyConfigsArgs = {
  distinctOn?: InputMaybe<Array<AccCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccCompanyConfigOrderBy>>;
  where?: InputMaybe<AccCompanyConfigBoolExp>;
};


/** Residential HVAC company */
export type CompaniesAccCompanyConfigsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccCompanyConfigOrderBy>>;
  where?: InputMaybe<AccCompanyConfigBoolExp>;
};


/** Residential HVAC company */
export type CompaniesAccSyncInfosArgs = {
  distinctOn?: InputMaybe<Array<AccSyncInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccSyncInfoOrderBy>>;
  where?: InputMaybe<AccSyncInfoBoolExp>;
};


/** Residential HVAC company */
export type CompaniesAccSyncInfosAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccSyncInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccSyncInfoOrderBy>>;
  where?: InputMaybe<AccSyncInfoBoolExp>;
};


/** Residential HVAC company */
export type CompaniesAccountContactsArgs = {
  distinctOn?: InputMaybe<Array<AccountContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountContactsOrderBy>>;
  where?: InputMaybe<AccountContactsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesAccountContactsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountContactsOrderBy>>;
  where?: InputMaybe<AccountContactsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesAccountLocationsArgs = {
  distinctOn?: InputMaybe<Array<AccountLocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountLocationsOrderBy>>;
  where?: InputMaybe<AccountLocationsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesAccountLocationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountLocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountLocationsOrderBy>>;
  where?: InputMaybe<AccountLocationsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesAccountsArgs = {
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesCompanyAppointmentArrivalWindowsArgs = {
  distinctOn?: InputMaybe<Array<CompanyAppointmentArrivalWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyAppointmentArrivalWindowsOrderBy>>;
  where?: InputMaybe<CompanyAppointmentArrivalWindowsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesCompanyAppointmentArrivalWindowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyAppointmentArrivalWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyAppointmentArrivalWindowsOrderBy>>;
  where?: InputMaybe<CompanyAppointmentArrivalWindowsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesCompanyNotificationSettingsArgs = {
  distinctOn?: InputMaybe<Array<CompanyNotificationSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyNotificationSettingsOrderBy>>;
  where?: InputMaybe<CompanyNotificationSettingsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesCompanyNotificationSettingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyNotificationSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyNotificationSettingsOrderBy>>;
  where?: InputMaybe<CompanyNotificationSettingsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesCompanyReviewLinksArgs = {
  distinctOn?: InputMaybe<Array<CompanyReviewLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyReviewLinksOrderBy>>;
  where?: InputMaybe<CompanyReviewLinksBoolExp>;
};


/** Residential HVAC company */
export type CompaniesCompanyReviewLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyReviewLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyReviewLinksOrderBy>>;
  where?: InputMaybe<CompanyReviewLinksBoolExp>;
};


/** Residential HVAC company */
export type CompaniesCompanyUsersArgs = {
  distinctOn?: InputMaybe<Array<CompanyUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyUsersOrderBy>>;
  where?: InputMaybe<CompanyUsersBoolExp>;
};


/** Residential HVAC company */
export type CompaniesCompanyUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyUsersOrderBy>>;
  where?: InputMaybe<CompanyUsersBoolExp>;
};


/** Residential HVAC company */
export type CompaniesIntegratedPhoneUsersArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneUsersOrderBy>>;
  where?: InputMaybe<IntegratedPhoneUsersBoolExp>;
};


/** Residential HVAC company */
export type CompaniesIntegratedPhoneUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneUsersOrderBy>>;
  where?: InputMaybe<IntegratedPhoneUsersBoolExp>;
};


/** Residential HVAC company */
export type CompaniesIntegratedPhonesArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhonesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhonesOrderBy>>;
  where?: InputMaybe<IntegratedPhonesBoolExp>;
};


/** Residential HVAC company */
export type CompaniesIntegratedPhonesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhonesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhonesOrderBy>>;
  where?: InputMaybe<IntegratedPhonesBoolExp>;
};


/** Residential HVAC company */
export type CompaniesInvoicePaymentsArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesInvoicePaymentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesJobTypesArgs = {
  distinctOn?: InputMaybe<Array<JobTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTypesOrderBy>>;
  where?: InputMaybe<JobTypesBoolExp>;
};


/** Residential HVAC company */
export type CompaniesJobTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTypesOrderBy>>;
  where?: InputMaybe<JobTypesBoolExp>;
};


/** Residential HVAC company */
export type CompaniesJobsArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesMaintenancePlanCoveredEquipmentTypesArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesMaintenancePlanCoveredEquipmentTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesOnlineBookingServiceTypeConfigsArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeConfigsOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeConfigsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesOnlineBookingServiceTypeConfigsAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeConfigsOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeConfigsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesPricebookItemsArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemsOrderBy>>;
  where?: InputMaybe<PricebookItemsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesPricebookItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemsOrderBy>>;
  where?: InputMaybe<PricebookItemsBoolExp>;
};


/** Residential HVAC company */
export type CompaniesPricebookTaxRatesArgs = {
  distinctOn?: InputMaybe<Array<PricebookTaxRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookTaxRatesOrderBy>>;
  where?: InputMaybe<PricebookTaxRatesBoolExp>;
};


/** Residential HVAC company */
export type CompaniesPricebookTaxRatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookTaxRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookTaxRatesOrderBy>>;
  where?: InputMaybe<PricebookTaxRatesBoolExp>;
};

/** aggregated selection of "companies" */
export type CompaniesAggregate = {
  __typename?: 'CompaniesAggregate';
  aggregate?: Maybe<CompaniesAggregateFields>;
  nodes: Array<Companies>;
};

/** aggregate fields of "companies" */
export type CompaniesAggregateFields = {
  __typename?: 'CompaniesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CompaniesMaxFields>;
  min?: Maybe<CompaniesMinFields>;
};


/** aggregate fields of "companies" */
export type CompaniesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompaniesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "companies". All fields are combined with a logical 'AND'. */
export type CompaniesBoolExp = {
  _and?: InputMaybe<Array<CompaniesBoolExp>>;
  _not?: InputMaybe<CompaniesBoolExp>;
  _or?: InputMaybe<Array<CompaniesBoolExp>>;
  accCartItemTypeAccountsConfigs?: InputMaybe<AccCartItemTypeAccountsConfigBoolExp>;
  accCartItemTypeAccountsConfigsAggregate?: InputMaybe<AccCartItemTypeAccountsConfigAggregateBoolExp>;
  accCompanyConfigs?: InputMaybe<AccCompanyConfigBoolExp>;
  accCompanyConfigsAggregate?: InputMaybe<AccCompanyConfigAggregateBoolExp>;
  accQbdConductorConfig?: InputMaybe<AccQbdConductorConfigBoolExp>;
  accSyncInfos?: InputMaybe<AccSyncInfoBoolExp>;
  accSyncInfosAggregate?: InputMaybe<AccSyncInfoAggregateBoolExp>;
  accountContacts?: InputMaybe<AccountContactsBoolExp>;
  accountContactsAggregate?: InputMaybe<AccountContactsAggregateBoolExp>;
  accountLocations?: InputMaybe<AccountLocationsBoolExp>;
  accountLocationsAggregate?: InputMaybe<AccountLocationsAggregateBoolExp>;
  accounts?: InputMaybe<AccountsBoolExp>;
  accountsAggregate?: InputMaybe<AccountsAggregateBoolExp>;
  billingProfile?: InputMaybe<BillingProfilesBoolExp>;
  breezySystemOfRecordDate?: InputMaybe<TimestamptzComparisonExp>;
  companyAppointmentArrivalWindows?: InputMaybe<CompanyAppointmentArrivalWindowsBoolExp>;
  companyAppointmentArrivalWindowsAggregate?: InputMaybe<CompanyAppointmentArrivalWindowsAggregateBoolExp>;
  companyConfig?: InputMaybe<CompanyConfigBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  companyNotificationSettings?: InputMaybe<CompanyNotificationSettingsBoolExp>;
  companyNotificationSettingsAggregate?: InputMaybe<CompanyNotificationSettingsAggregateBoolExp>;
  companyNotificationSettingsOne?: InputMaybe<CompanyNotificationSettingsBoolExp>;
  companyPricingTierConfig?: InputMaybe<CompanyPricingTierConfigBoolExp>;
  companyReviewLinks?: InputMaybe<CompanyReviewLinksBoolExp>;
  companyReviewLinksAggregate?: InputMaybe<CompanyReviewLinksAggregateBoolExp>;
  companyUsers?: InputMaybe<CompanyUsersBoolExp>;
  companyUsersAggregate?: InputMaybe<CompanyUsersAggregateBoolExp>;
  companyWorkingDisplayHours?: InputMaybe<CompanyWorkingDisplayHoursBoolExp>;
  currentTaxConfiguration?: InputMaybe<CurrentCompanyTaxConfigurationsViewBoolExp>;
  dataMigrationStatus?: InputMaybe<StringComparisonExp>;
  integratedPhoneCompanyConfig?: InputMaybe<IntegratedPhoneCompanyConfigBoolExp>;
  integratedPhoneUsers?: InputMaybe<IntegratedPhoneUsersBoolExp>;
  integratedPhoneUsersAggregate?: InputMaybe<IntegratedPhoneUsersAggregateBoolExp>;
  integratedPhones?: InputMaybe<IntegratedPhonesBoolExp>;
  integratedPhonesAggregate?: InputMaybe<IntegratedPhonesAggregateBoolExp>;
  invoicePayments?: InputMaybe<InvoicePaymentsBoolExp>;
  invoicePaymentsAggregate?: InputMaybe<InvoicePaymentsAggregateBoolExp>;
  jobCostingConfig?: InputMaybe<JobCostingConfigBoolExp>;
  jobTypes?: InputMaybe<JobTypesBoolExp>;
  jobTypesAggregate?: InputMaybe<JobTypesAggregateBoolExp>;
  jobs?: InputMaybe<JobsBoolExp>;
  jobsAggregate?: InputMaybe<JobsAggregateBoolExp>;
  maintenancePlanCoveredEquipmentTypes?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
  maintenancePlanCoveredEquipmentTypesAggregate?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  onlineBookingCompanyConfig?: InputMaybe<OnlineBookingCompanyConfigBoolExp>;
  onlineBookingServiceTypeConfigs?: InputMaybe<OnlineBookingServiceTypeConfigsBoolExp>;
  onlineBookingServiceTypeConfigsAggregate?: InputMaybe<OnlineBookingServiceTypeConfigsAggregateBoolExp>;
  pricebookItems?: InputMaybe<PricebookItemsBoolExp>;
  pricebookItemsAggregate?: InputMaybe<PricebookItemsAggregateBoolExp>;
  pricebookTaxRates?: InputMaybe<PricebookTaxRatesBoolExp>;
  pricebookTaxRatesAggregate?: InputMaybe<PricebookTaxRatesAggregateBoolExp>;
  searchIndexingOnChange?: InputMaybe<BooleanComparisonExp>;
  timezone?: InputMaybe<Scalars['TimeZoneIdComparisonExp']>;
};

/** unique or primary key constraints on table "companies" */
export type CompaniesConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'companies_pkey';

/** input type for inserting data into table "companies" */
export type CompaniesInsertInput = {
  accCartItemTypeAccountsConfigs?: InputMaybe<AccCartItemTypeAccountsConfigArrRelInsertInput>;
  accCompanyConfigs?: InputMaybe<AccCompanyConfigArrRelInsertInput>;
  accQbdConductorConfig?: InputMaybe<AccQbdConductorConfigObjRelInsertInput>;
  accSyncInfos?: InputMaybe<AccSyncInfoArrRelInsertInput>;
  accountContacts?: InputMaybe<AccountContactsArrRelInsertInput>;
  accountLocations?: InputMaybe<AccountLocationsArrRelInsertInput>;
  accounts?: InputMaybe<AccountsArrRelInsertInput>;
  billingProfile?: InputMaybe<BillingProfilesObjRelInsertInput>;
  breezySystemOfRecordDate?: InputMaybe<Scalars['timestamptz']>;
  companyAppointmentArrivalWindows?: InputMaybe<CompanyAppointmentArrivalWindowsArrRelInsertInput>;
  companyConfig?: InputMaybe<CompanyConfigObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyNotificationSettings?: InputMaybe<CompanyNotificationSettingsArrRelInsertInput>;
  companyNotificationSettingsOne?: InputMaybe<CompanyNotificationSettingsObjRelInsertInput>;
  companyPricingTierConfig?: InputMaybe<CompanyPricingTierConfigObjRelInsertInput>;
  companyUsers?: InputMaybe<CompanyUsersArrRelInsertInput>;
  companyWorkingDisplayHours?: InputMaybe<CompanyWorkingDisplayHoursObjRelInsertInput>;
  currentTaxConfiguration?: InputMaybe<CurrentCompanyTaxConfigurationsViewObjRelInsertInput>;
  dataMigrationStatus?: InputMaybe<Scalars['String']>;
  integratedPhoneCompanyConfig?: InputMaybe<IntegratedPhoneCompanyConfigObjRelInsertInput>;
  integratedPhoneUsers?: InputMaybe<IntegratedPhoneUsersArrRelInsertInput>;
  integratedPhones?: InputMaybe<IntegratedPhonesArrRelInsertInput>;
  invoicePayments?: InputMaybe<InvoicePaymentsArrRelInsertInput>;
  jobCostingConfig?: InputMaybe<JobCostingConfigObjRelInsertInput>;
  jobTypes?: InputMaybe<JobTypesArrRelInsertInput>;
  jobs?: InputMaybe<JobsArrRelInsertInput>;
  maintenancePlanCoveredEquipmentTypes?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  onlineBookingCompanyConfig?: InputMaybe<OnlineBookingCompanyConfigObjRelInsertInput>;
  onlineBookingServiceTypeConfigs?: InputMaybe<OnlineBookingServiceTypeConfigsArrRelInsertInput>;
  pricebookItems?: InputMaybe<PricebookItemsArrRelInsertInput>;
  pricebookTaxRates?: InputMaybe<PricebookTaxRatesArrRelInsertInput>;
  searchIndexingOnChange?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['TimeZoneId']>;
};

/** aggregate max on columns */
export type CompaniesMaxFields = {
  __typename?: 'CompaniesMaxFields';
  breezySystemOfRecordDate?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  dataMigrationStatus?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['TimeZoneId']>;
};

/** aggregate min on columns */
export type CompaniesMinFields = {
  __typename?: 'CompaniesMinFields';
  breezySystemOfRecordDate?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  dataMigrationStatus?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['TimeZoneId']>;
};

/** response of any mutation on the table "companies" */
export type CompaniesMutationResponse = {
  __typename?: 'CompaniesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Companies>;
};

/** input type for inserting object relation for remote table "companies" */
export type CompaniesObjRelInsertInput = {
  data: CompaniesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CompaniesOnConflict>;
};

/** on_conflict condition type for table "companies" */
export type CompaniesOnConflict = {
  constraint: CompaniesConstraint;
  updateColumns?: Array<CompaniesUpdateColumn>;
  where?: InputMaybe<CompaniesBoolExp>;
};

/** Ordering options when selecting data from "companies". */
export type CompaniesOrderBy = {
  accCartItemTypeAccountsConfigsAggregate?: InputMaybe<AccCartItemTypeAccountsConfigAggregateOrderBy>;
  accCompanyConfigsAggregate?: InputMaybe<AccCompanyConfigAggregateOrderBy>;
  accQbdConductorConfig?: InputMaybe<AccQbdConductorConfigOrderBy>;
  accSyncInfosAggregate?: InputMaybe<AccSyncInfoAggregateOrderBy>;
  accountContactsAggregate?: InputMaybe<AccountContactsAggregateOrderBy>;
  accountLocationsAggregate?: InputMaybe<AccountLocationsAggregateOrderBy>;
  accountsAggregate?: InputMaybe<AccountsAggregateOrderBy>;
  billingProfile?: InputMaybe<BillingProfilesOrderBy>;
  breezySystemOfRecordDate?: InputMaybe<OrderBy>;
  companyAppointmentArrivalWindowsAggregate?: InputMaybe<CompanyAppointmentArrivalWindowsAggregateOrderBy>;
  companyConfig?: InputMaybe<CompanyConfigOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  companyNotificationSettingsAggregate?: InputMaybe<CompanyNotificationSettingsAggregateOrderBy>;
  companyNotificationSettingsOne?: InputMaybe<CompanyNotificationSettingsOrderBy>;
  companyPricingTierConfig?: InputMaybe<CompanyPricingTierConfigOrderBy>;
  companyReviewLinksAggregate?: InputMaybe<CompanyReviewLinksAggregateOrderBy>;
  companyUsersAggregate?: InputMaybe<CompanyUsersAggregateOrderBy>;
  companyWorkingDisplayHours?: InputMaybe<CompanyWorkingDisplayHoursOrderBy>;
  currentTaxConfiguration?: InputMaybe<CurrentCompanyTaxConfigurationsViewOrderBy>;
  dataMigrationStatus?: InputMaybe<OrderBy>;
  integratedPhoneCompanyConfig?: InputMaybe<IntegratedPhoneCompanyConfigOrderBy>;
  integratedPhoneUsersAggregate?: InputMaybe<IntegratedPhoneUsersAggregateOrderBy>;
  integratedPhonesAggregate?: InputMaybe<IntegratedPhonesAggregateOrderBy>;
  invoicePaymentsAggregate?: InputMaybe<InvoicePaymentsAggregateOrderBy>;
  jobCostingConfig?: InputMaybe<JobCostingConfigOrderBy>;
  jobTypesAggregate?: InputMaybe<JobTypesAggregateOrderBy>;
  jobsAggregate?: InputMaybe<JobsAggregateOrderBy>;
  maintenancePlanCoveredEquipmentTypesAggregate?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  onlineBookingCompanyConfig?: InputMaybe<OnlineBookingCompanyConfigOrderBy>;
  onlineBookingServiceTypeConfigsAggregate?: InputMaybe<OnlineBookingServiceTypeConfigsAggregateOrderBy>;
  pricebookItemsAggregate?: InputMaybe<PricebookItemsAggregateOrderBy>;
  pricebookTaxRatesAggregate?: InputMaybe<PricebookTaxRatesAggregateOrderBy>;
  searchIndexingOnChange?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: companies */
export type CompaniesPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "companies" */
export type CompaniesSelectColumn =
  /** column name */
  | 'breezySystemOfRecordDate'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dataMigrationStatus'
  /** column name */
  | 'name'
  /** column name */
  | 'searchIndexingOnChange'
  /** column name */
  | 'timezone';

/** input type for updating data in table "companies" */
export type CompaniesSetInput = {
  breezySystemOfRecordDate?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dataMigrationStatus?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  searchIndexingOnChange?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['TimeZoneId']>;
};

/** Streaming cursor of the table "companies" */
export type CompaniesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompaniesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompaniesStreamCursorValueInput = {
  breezySystemOfRecordDate?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dataMigrationStatus?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  searchIndexingOnChange?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['TimeZoneId']>;
};

/** update columns of table "companies" */
export type CompaniesUpdateColumn =
  /** column name */
  | 'breezySystemOfRecordDate'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dataMigrationStatus'
  /** column name */
  | 'name'
  /** column name */
  | 'searchIndexingOnChange'
  /** column name */
  | 'timezone';

export type CompaniesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompaniesSetInput>;
  /** filter the rows which have to be updated */
  where: CompaniesBoolExp;
};

/** columns and relationships of "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindows = {
  __typename?: 'CompanyAppointmentArrivalWindows';
  arrivalWindowEndTime: Scalars['time'];
  arrivalWindowStartTime: Scalars['time'];
  /** An object relationship */
  company: Companies;
  companyAppointmentArrivalWindowGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  jobClass: Scalars['JobClass'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsAggregate = {
  __typename?: 'CompanyAppointmentArrivalWindowsAggregate';
  aggregate?: Maybe<CompanyAppointmentArrivalWindowsAggregateFields>;
  nodes: Array<CompanyAppointmentArrivalWindows>;
};

export type CompanyAppointmentArrivalWindowsAggregateBoolExp = {
  count?: InputMaybe<CompanyAppointmentArrivalWindowsAggregateBoolExpCount>;
};

/** aggregate fields of "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsAggregateFields = {
  __typename?: 'CompanyAppointmentArrivalWindowsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CompanyAppointmentArrivalWindowsMaxFields>;
  min?: Maybe<CompanyAppointmentArrivalWindowsMinFields>;
};


/** aggregate fields of "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyAppointmentArrivalWindowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CompanyAppointmentArrivalWindowsMaxOrderBy>;
  min?: InputMaybe<CompanyAppointmentArrivalWindowsMinOrderBy>;
};

/** input type for inserting array relation for remote table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsArrRelInsertInput = {
  data: Array<CompanyAppointmentArrivalWindowsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyAppointmentArrivalWindowsOnConflict>;
};

/** Boolean expression to filter rows from the table "company_appointment_arrival_windows". All fields are combined with a logical 'AND'. */
export type CompanyAppointmentArrivalWindowsBoolExp = {
  _and?: InputMaybe<Array<CompanyAppointmentArrivalWindowsBoolExp>>;
  _not?: InputMaybe<CompanyAppointmentArrivalWindowsBoolExp>;
  _or?: InputMaybe<Array<CompanyAppointmentArrivalWindowsBoolExp>>;
  arrivalWindowEndTime?: InputMaybe<TimeComparisonExp>;
  arrivalWindowStartTime?: InputMaybe<TimeComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyAppointmentArrivalWindowGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  jobClass?: InputMaybe<Scalars['JobClassComparisonExp']>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsConstraint =
  /** unique or primary key constraint on columns "company_appointment_arrival_window_guid" */
  | 'company_appointment_arrival_windows_pkey';

/** input type for inserting data into table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsInsertInput = {
  arrivalWindowEndTime?: InputMaybe<Scalars['time']>;
  arrivalWindowStartTime?: InputMaybe<Scalars['time']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyAppointmentArrivalWindowGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobClass?: InputMaybe<Scalars['JobClass']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CompanyAppointmentArrivalWindowsMaxFields = {
  __typename?: 'CompanyAppointmentArrivalWindowsMaxFields';
  companyAppointmentArrivalWindowGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  jobClass?: Maybe<Scalars['JobClass']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsMaxOrderBy = {
  companyAppointmentArrivalWindowGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CompanyAppointmentArrivalWindowsMinFields = {
  __typename?: 'CompanyAppointmentArrivalWindowsMinFields';
  companyAppointmentArrivalWindowGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  jobClass?: Maybe<Scalars['JobClass']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsMinOrderBy = {
  companyAppointmentArrivalWindowGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsMutationResponse = {
  __typename?: 'CompanyAppointmentArrivalWindowsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyAppointmentArrivalWindows>;
};

/** input type for inserting object relation for remote table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsObjRelInsertInput = {
  data: CompanyAppointmentArrivalWindowsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyAppointmentArrivalWindowsOnConflict>;
};

/** on_conflict condition type for table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsOnConflict = {
  constraint: CompanyAppointmentArrivalWindowsConstraint;
  updateColumns?: Array<CompanyAppointmentArrivalWindowsUpdateColumn>;
  where?: InputMaybe<CompanyAppointmentArrivalWindowsBoolExp>;
};

/** Ordering options when selecting data from "company_appointment_arrival_windows". */
export type CompanyAppointmentArrivalWindowsOrderBy = {
  arrivalWindowEndTime?: InputMaybe<OrderBy>;
  arrivalWindowStartTime?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyAppointmentArrivalWindowGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  jobClass?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_appointment_arrival_windows */
export type CompanyAppointmentArrivalWindowsPkColumnsInput = {
  companyAppointmentArrivalWindowGuid: Scalars['uuid'];
};

/** select columns of table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsSelectColumn =
  /** column name */
  | 'arrivalWindowEndTime'
  /** column name */
  | 'arrivalWindowStartTime'
  /** column name */
  | 'companyAppointmentArrivalWindowGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'jobClass'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsSetInput = {
  arrivalWindowEndTime?: InputMaybe<Scalars['time']>;
  arrivalWindowStartTime?: InputMaybe<Scalars['time']>;
  companyAppointmentArrivalWindowGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobClass?: InputMaybe<Scalars['JobClass']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyAppointmentArrivalWindowsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyAppointmentArrivalWindowsStreamCursorValueInput = {
  arrivalWindowEndTime?: InputMaybe<Scalars['time']>;
  arrivalWindowStartTime?: InputMaybe<Scalars['time']>;
  companyAppointmentArrivalWindowGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobClass?: InputMaybe<Scalars['JobClass']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "company_appointment_arrival_windows" */
export type CompanyAppointmentArrivalWindowsUpdateColumn =
  /** column name */
  | 'arrivalWindowEndTime'
  /** column name */
  | 'arrivalWindowStartTime'
  /** column name */
  | 'companyAppointmentArrivalWindowGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'jobClass'
  /** column name */
  | 'updatedAt';

export type CompanyAppointmentArrivalWindowsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyAppointmentArrivalWindowsSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyAppointmentArrivalWindowsBoolExp;
};

/** columns and relationships of "company_commission_config" */
export type CompanyCommissionConfig = {
  __typename?: 'CompanyCommissionConfig';
  companyGuid: Scalars['uuid'];
  defaultCommissionOverheadDeductionRate?: Maybe<Scalars['numeric']>;
  defaultCommissionOverheadFlatDeductionUsc?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "company_commission_config" */
export type CompanyCommissionConfigAggregate = {
  __typename?: 'CompanyCommissionConfigAggregate';
  aggregate?: Maybe<CompanyCommissionConfigAggregateFields>;
  nodes: Array<CompanyCommissionConfig>;
};

/** aggregate fields of "company_commission_config" */
export type CompanyCommissionConfigAggregateFields = {
  __typename?: 'CompanyCommissionConfigAggregateFields';
  avg?: Maybe<CompanyCommissionConfigAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompanyCommissionConfigMaxFields>;
  min?: Maybe<CompanyCommissionConfigMinFields>;
  stddev?: Maybe<CompanyCommissionConfigStddevFields>;
  stddevPop?: Maybe<CompanyCommissionConfigStddevPopFields>;
  stddevSamp?: Maybe<CompanyCommissionConfigStddevSampFields>;
  sum?: Maybe<CompanyCommissionConfigSumFields>;
  varPop?: Maybe<CompanyCommissionConfigVarPopFields>;
  varSamp?: Maybe<CompanyCommissionConfigVarSampFields>;
  variance?: Maybe<CompanyCommissionConfigVarianceFields>;
};


/** aggregate fields of "company_commission_config" */
export type CompanyCommissionConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyCommissionConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CompanyCommissionConfigAvgFields = {
  __typename?: 'CompanyCommissionConfigAvgFields';
  defaultCommissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  defaultCommissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "company_commission_config". All fields are combined with a logical 'AND'. */
export type CompanyCommissionConfigBoolExp = {
  _and?: InputMaybe<Array<CompanyCommissionConfigBoolExp>>;
  _not?: InputMaybe<CompanyCommissionConfigBoolExp>;
  _or?: InputMaybe<Array<CompanyCommissionConfigBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  defaultCommissionOverheadDeductionRate?: InputMaybe<NumericComparisonExp>;
  defaultCommissionOverheadFlatDeductionUsc?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "company_commission_config" */
export type CompanyCommissionConfigConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'company_commission_config_pkey';

/** input type for incrementing numeric columns in table "company_commission_config" */
export type CompanyCommissionConfigIncInput = {
  defaultCommissionOverheadDeductionRate?: InputMaybe<Scalars['numeric']>;
  defaultCommissionOverheadFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "company_commission_config" */
export type CompanyCommissionConfigInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  defaultCommissionOverheadDeductionRate?: InputMaybe<Scalars['numeric']>;
  defaultCommissionOverheadFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type CompanyCommissionConfigMaxFields = {
  __typename?: 'CompanyCommissionConfigMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  defaultCommissionOverheadDeductionRate?: Maybe<Scalars['numeric']>;
  defaultCommissionOverheadFlatDeductionUsc?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type CompanyCommissionConfigMinFields = {
  __typename?: 'CompanyCommissionConfigMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  defaultCommissionOverheadDeductionRate?: Maybe<Scalars['numeric']>;
  defaultCommissionOverheadFlatDeductionUsc?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "company_commission_config" */
export type CompanyCommissionConfigMutationResponse = {
  __typename?: 'CompanyCommissionConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyCommissionConfig>;
};

/** on_conflict condition type for table "company_commission_config" */
export type CompanyCommissionConfigOnConflict = {
  constraint: CompanyCommissionConfigConstraint;
  updateColumns?: Array<CompanyCommissionConfigUpdateColumn>;
  where?: InputMaybe<CompanyCommissionConfigBoolExp>;
};

/** Ordering options when selecting data from "company_commission_config". */
export type CompanyCommissionConfigOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  defaultCommissionOverheadDeductionRate?: InputMaybe<OrderBy>;
  defaultCommissionOverheadFlatDeductionUsc?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_commission_config */
export type CompanyCommissionConfigPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "company_commission_config" */
export type CompanyCommissionConfigSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'defaultCommissionOverheadDeductionRate'
  /** column name */
  | 'defaultCommissionOverheadFlatDeductionUsc';

/** input type for updating data in table "company_commission_config" */
export type CompanyCommissionConfigSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  defaultCommissionOverheadDeductionRate?: InputMaybe<Scalars['numeric']>;
  defaultCommissionOverheadFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CompanyCommissionConfigStddevFields = {
  __typename?: 'CompanyCommissionConfigStddevFields';
  defaultCommissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  defaultCommissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CompanyCommissionConfigStddevPopFields = {
  __typename?: 'CompanyCommissionConfigStddevPopFields';
  defaultCommissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  defaultCommissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CompanyCommissionConfigStddevSampFields = {
  __typename?: 'CompanyCommissionConfigStddevSampFields';
  defaultCommissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  defaultCommissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "company_commission_config" */
export type CompanyCommissionConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyCommissionConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyCommissionConfigStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  defaultCommissionOverheadDeductionRate?: InputMaybe<Scalars['numeric']>;
  defaultCommissionOverheadFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CompanyCommissionConfigSumFields = {
  __typename?: 'CompanyCommissionConfigSumFields';
  defaultCommissionOverheadDeductionRate?: Maybe<Scalars['numeric']>;
  defaultCommissionOverheadFlatDeductionUsc?: Maybe<Scalars['Int']>;
};

/** update columns of table "company_commission_config" */
export type CompanyCommissionConfigUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'defaultCommissionOverheadDeductionRate'
  /** column name */
  | 'defaultCommissionOverheadFlatDeductionUsc';

export type CompanyCommissionConfigUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompanyCommissionConfigIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyCommissionConfigSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyCommissionConfigBoolExp;
};

/** aggregate varPop on columns */
export type CompanyCommissionConfigVarPopFields = {
  __typename?: 'CompanyCommissionConfigVarPopFields';
  defaultCommissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  defaultCommissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CompanyCommissionConfigVarSampFields = {
  __typename?: 'CompanyCommissionConfigVarSampFields';
  defaultCommissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  defaultCommissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CompanyCommissionConfigVarianceFields = {
  __typename?: 'CompanyCommissionConfigVarianceFields';
  defaultCommissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  defaultCommissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "company_config" */
export type CompanyConfig = {
  __typename?: 'CompanyConfig';
  accountManagerEnabled: Scalars['Boolean'];
  accountNameDisplayTemplate: Scalars['MustacheTemplate'];
  angiId?: Maybe<Scalars['String']>;
  autoClockOutEnabled: Scalars['Boolean'];
  autoClockOutMaxContinuousHours: Scalars['Int'];
  bbbId?: Maybe<Scalars['String']>;
  blurb?: Maybe<Scalars['String']>;
  businessUnitsEnabled: Scalars['Boolean'];
  businessUnitsRequired?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  confirmationNotificationSuppressedByDefault: Scalars['Boolean'];
  customerNumberEnabled: Scalars['Boolean'];
  /** An object relationship */
  defaultAccountManager?: Maybe<Users>;
  defaultAccountManagerUserGuid?: Maybe<Scalars['uuid']>;
  endOfJobAppointmentWorkflowEnabled: Scalars['Boolean'];
  estimateAcceptNotifyCreator?: Maybe<Scalars['Boolean']>;
  estimateAcceptNotifyEmail?: Maybe<Scalars['String']>;
  estimateAcceptNotifyUserGuids?: Maybe<Array<Scalars['uuid']>>;
  estimateAutoExpirationDays: Scalars['Int'];
  estimateAutoExpirationEnabled: Scalars['Boolean'];
  estimateDisplayTechnicianName: Scalars['Boolean'];
  estimateLineItemsVisibility: Scalars['CompanyLineItemVisibility'];
  estimateRehashEnabled: Scalars['Boolean'];
  facebookId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  hiddenEquipmentTypesJsonArray?: Maybe<Scalars['EquipmentTypeArray']>;
  hideArrivalWindowInNotifications: Scalars['Boolean'];
  /** Company-wide default controlling whether per-line prices are hidden on customer-facing invoices/estimates (scope/quantity/totals stay visible). Seeds the per-record flag at create. */
  hideLineItemPrices: Scalars['Boolean'];
  invoiceDisplayTechnicianName: Scalars['Boolean'];
  invoiceIncludePaymentLink: Scalars['Boolean'];
  invoiceIssueWorkflow: Scalars['InvoiceIssueWorkflow'];
  invoiceLineItemsVisibility: Scalars['CompanyLineItemVisibility'];
  jobInvoiceIsRequiredToCompleteVisit: Scalars['Boolean'];
  jobInvoiceIsRequiredToCompleteVisitExcludeSalesClass?: Maybe<Scalars['Boolean']>;
  locationMunicipalityFieldEnabled: Scalars['Boolean'];
  /** Custom CTA URL for maintenance plan signup (optional, defaults to standard maintenance plans page) */
  maintenancePlanSavingsCtaUrl?: Maybe<Scalars['String']>;
  /** Whether to show potential maintenance plan savings on invoices/estimates for non-members */
  maintenancePlanSavingsEnabled: Scalars['Boolean'];
  maintenancePlansEnabled: Scalars['Boolean'];
  overdueAccountBalanceEnabled: Scalars['Boolean'];
  pdfLayoutConfig?: Maybe<Scalars['jsonb']>;
  pricebookPhotosEnabled: Scalars['Boolean'];
  qboAutoSyncInvoiceOnFullyPaid?: Maybe<Scalars['Boolean']>;
  qboAutoSyncInvoiceOnIssued?: Maybe<Scalars['Boolean']>;
  qboAutoSyncInvoiceOnPayment?: Maybe<Scalars['Boolean']>;
  qboEnabled: Scalars['Boolean'];
  sage100ReportingIntegrationEnabled: Scalars['Boolean'];
  scheduleColorMode: Scalars['String'];
  scheduleTechOrder: Array<Scalars['uuid']>;
  smsAppointmentTemplate?: Maybe<Scalars['String']>;
  smsReminderTemplate?: Maybe<Scalars['String']>;
  technicianPerformanceEnabled: Scalars['Boolean'];
  timesheetPayPeriodBeginAnchor: Scalars['timestamptz'];
  timesheetPayPeriodBeginRrule: Scalars['String'];
  timesheetsEnabled: Scalars['Boolean'];
  visibleInstallProjectTypesJsonArray?: Maybe<Scalars['json']>;
  wisetackEnabled: Scalars['Boolean'];
  yelpId?: Maybe<Scalars['String']>;
};


/** columns and relationships of "company_config" */
export type CompanyConfigHiddenEquipmentTypesJsonArrayArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "company_config" */
export type CompanyConfigPdfLayoutConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "company_config" */
export type CompanyConfigVisibleInstallProjectTypesJsonArrayArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "company_config" */
export type CompanyConfigAggregate = {
  __typename?: 'CompanyConfigAggregate';
  aggregate?: Maybe<CompanyConfigAggregateFields>;
  nodes: Array<CompanyConfig>;
};

/** aggregate fields of "company_config" */
export type CompanyConfigAggregateFields = {
  __typename?: 'CompanyConfigAggregateFields';
  avg?: Maybe<CompanyConfigAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompanyConfigMaxFields>;
  min?: Maybe<CompanyConfigMinFields>;
  stddev?: Maybe<CompanyConfigStddevFields>;
  stddevPop?: Maybe<CompanyConfigStddevPopFields>;
  stddevSamp?: Maybe<CompanyConfigStddevSampFields>;
  sum?: Maybe<CompanyConfigSumFields>;
  varPop?: Maybe<CompanyConfigVarPopFields>;
  varSamp?: Maybe<CompanyConfigVarSampFields>;
  variance?: Maybe<CompanyConfigVarianceFields>;
};


/** aggregate fields of "company_config" */
export type CompanyConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CompanyConfigAppendInput = {
  pdfLayoutConfig?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type CompanyConfigAvgFields = {
  __typename?: 'CompanyConfigAvgFields';
  autoClockOutMaxContinuousHours?: Maybe<Scalars['Float']>;
  estimateAutoExpirationDays?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "company_config". All fields are combined with a logical 'AND'. */
export type CompanyConfigBoolExp = {
  _and?: InputMaybe<Array<CompanyConfigBoolExp>>;
  _not?: InputMaybe<CompanyConfigBoolExp>;
  _or?: InputMaybe<Array<CompanyConfigBoolExp>>;
  accountManagerEnabled?: InputMaybe<BooleanComparisonExp>;
  accountNameDisplayTemplate?: InputMaybe<Scalars['MustacheTemplateComparisonExp']>;
  angiId?: InputMaybe<StringComparisonExp>;
  autoClockOutEnabled?: InputMaybe<BooleanComparisonExp>;
  autoClockOutMaxContinuousHours?: InputMaybe<IntComparisonExp>;
  bbbId?: InputMaybe<StringComparisonExp>;
  blurb?: InputMaybe<StringComparisonExp>;
  businessUnitsEnabled?: InputMaybe<BooleanComparisonExp>;
  businessUnitsRequired?: InputMaybe<BooleanComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  confirmationNotificationSuppressedByDefault?: InputMaybe<BooleanComparisonExp>;
  customerNumberEnabled?: InputMaybe<BooleanComparisonExp>;
  defaultAccountManager?: InputMaybe<UsersBoolExp>;
  defaultAccountManagerUserGuid?: InputMaybe<UuidComparisonExp>;
  endOfJobAppointmentWorkflowEnabled?: InputMaybe<BooleanComparisonExp>;
  estimateAcceptNotifyCreator?: InputMaybe<BooleanComparisonExp>;
  estimateAcceptNotifyEmail?: InputMaybe<StringComparisonExp>;
  estimateAcceptNotifyUserGuids?: InputMaybe<UuidArrayComparisonExp>;
  estimateAutoExpirationDays?: InputMaybe<IntComparisonExp>;
  estimateAutoExpirationEnabled?: InputMaybe<BooleanComparisonExp>;
  estimateDisplayTechnicianName?: InputMaybe<BooleanComparisonExp>;
  estimateLineItemsVisibility?: InputMaybe<Scalars['CompanyLineItemVisibilityComparisonExp']>;
  estimateRehashEnabled?: InputMaybe<BooleanComparisonExp>;
  facebookId?: InputMaybe<StringComparisonExp>;
  googlePlaceId?: InputMaybe<StringComparisonExp>;
  hiddenEquipmentTypesJsonArray?: InputMaybe<Scalars['EquipmentTypeArrayComparisonExp']>;
  hideArrivalWindowInNotifications?: InputMaybe<BooleanComparisonExp>;
  hideLineItemPrices?: InputMaybe<BooleanComparisonExp>;
  invoiceDisplayTechnicianName?: InputMaybe<BooleanComparisonExp>;
  invoiceIncludePaymentLink?: InputMaybe<BooleanComparisonExp>;
  invoiceIssueWorkflow?: InputMaybe<Scalars['InvoiceIssueWorkflowComparisonExp']>;
  invoiceLineItemsVisibility?: InputMaybe<Scalars['CompanyLineItemVisibilityComparisonExp']>;
  jobInvoiceIsRequiredToCompleteVisit?: InputMaybe<BooleanComparisonExp>;
  jobInvoiceIsRequiredToCompleteVisitExcludeSalesClass?: InputMaybe<BooleanComparisonExp>;
  locationMunicipalityFieldEnabled?: InputMaybe<BooleanComparisonExp>;
  maintenancePlanSavingsCtaUrl?: InputMaybe<StringComparisonExp>;
  maintenancePlanSavingsEnabled?: InputMaybe<BooleanComparisonExp>;
  maintenancePlansEnabled?: InputMaybe<BooleanComparisonExp>;
  overdueAccountBalanceEnabled?: InputMaybe<BooleanComparisonExp>;
  pdfLayoutConfig?: InputMaybe<JsonbComparisonExp>;
  pricebookPhotosEnabled?: InputMaybe<BooleanComparisonExp>;
  qboAutoSyncInvoiceOnFullyPaid?: InputMaybe<BooleanComparisonExp>;
  qboAutoSyncInvoiceOnIssued?: InputMaybe<BooleanComparisonExp>;
  qboAutoSyncInvoiceOnPayment?: InputMaybe<BooleanComparisonExp>;
  qboEnabled?: InputMaybe<BooleanComparisonExp>;
  sage100ReportingIntegrationEnabled?: InputMaybe<BooleanComparisonExp>;
  scheduleColorMode?: InputMaybe<StringComparisonExp>;
  scheduleTechOrder?: InputMaybe<UuidArrayComparisonExp>;
  smsAppointmentTemplate?: InputMaybe<StringComparisonExp>;
  smsReminderTemplate?: InputMaybe<StringComparisonExp>;
  technicianPerformanceEnabled?: InputMaybe<BooleanComparisonExp>;
  timesheetPayPeriodBeginAnchor?: InputMaybe<TimestamptzComparisonExp>;
  timesheetPayPeriodBeginRrule?: InputMaybe<StringComparisonExp>;
  timesheetsEnabled?: InputMaybe<BooleanComparisonExp>;
  visibleInstallProjectTypesJsonArray?: InputMaybe<JsonComparisonExp>;
  wisetackEnabled?: InputMaybe<BooleanComparisonExp>;
  yelpId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "company_config" */
export type CompanyConfigConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'company_config_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CompanyConfigDeleteAtPathInput = {
  pdfLayoutConfig?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CompanyConfigDeleteElemInput = {
  pdfLayoutConfig?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CompanyConfigDeleteKeyInput = {
  pdfLayoutConfig?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "company_config" */
export type CompanyConfigIncInput = {
  autoClockOutMaxContinuousHours?: InputMaybe<Scalars['Int']>;
  estimateAutoExpirationDays?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "company_config" */
export type CompanyConfigInsertInput = {
  accountManagerEnabled?: InputMaybe<Scalars['Boolean']>;
  accountNameDisplayTemplate?: InputMaybe<Scalars['MustacheTemplate']>;
  angiId?: InputMaybe<Scalars['String']>;
  autoClockOutEnabled?: InputMaybe<Scalars['Boolean']>;
  autoClockOutMaxContinuousHours?: InputMaybe<Scalars['Int']>;
  bbbId?: InputMaybe<Scalars['String']>;
  blurb?: InputMaybe<Scalars['String']>;
  businessUnitsEnabled?: InputMaybe<Scalars['Boolean']>;
  businessUnitsRequired?: InputMaybe<Scalars['Boolean']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  confirmationNotificationSuppressedByDefault?: InputMaybe<Scalars['Boolean']>;
  customerNumberEnabled?: InputMaybe<Scalars['Boolean']>;
  defaultAccountManager?: InputMaybe<UsersObjRelInsertInput>;
  defaultAccountManagerUserGuid?: InputMaybe<Scalars['uuid']>;
  endOfJobAppointmentWorkflowEnabled?: InputMaybe<Scalars['Boolean']>;
  estimateAcceptNotifyCreator?: InputMaybe<Scalars['Boolean']>;
  estimateAcceptNotifyEmail?: InputMaybe<Scalars['String']>;
  estimateAcceptNotifyUserGuids?: InputMaybe<Array<Scalars['uuid']>>;
  estimateAutoExpirationDays?: InputMaybe<Scalars['Int']>;
  estimateAutoExpirationEnabled?: InputMaybe<Scalars['Boolean']>;
  estimateDisplayTechnicianName?: InputMaybe<Scalars['Boolean']>;
  estimateLineItemsVisibility?: InputMaybe<Scalars['CompanyLineItemVisibility']>;
  estimateRehashEnabled?: InputMaybe<Scalars['Boolean']>;
  facebookId?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  hiddenEquipmentTypesJsonArray?: InputMaybe<Scalars['EquipmentTypeArray']>;
  hideArrivalWindowInNotifications?: InputMaybe<Scalars['Boolean']>;
  /** Company-wide default controlling whether per-line prices are hidden on customer-facing invoices/estimates (scope/quantity/totals stay visible). Seeds the per-record flag at create. */
  hideLineItemPrices?: InputMaybe<Scalars['Boolean']>;
  invoiceDisplayTechnicianName?: InputMaybe<Scalars['Boolean']>;
  invoiceIncludePaymentLink?: InputMaybe<Scalars['Boolean']>;
  invoiceIssueWorkflow?: InputMaybe<Scalars['InvoiceIssueWorkflow']>;
  invoiceLineItemsVisibility?: InputMaybe<Scalars['CompanyLineItemVisibility']>;
  jobInvoiceIsRequiredToCompleteVisit?: InputMaybe<Scalars['Boolean']>;
  jobInvoiceIsRequiredToCompleteVisitExcludeSalesClass?: InputMaybe<Scalars['Boolean']>;
  locationMunicipalityFieldEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Custom CTA URL for maintenance plan signup (optional, defaults to standard maintenance plans page) */
  maintenancePlanSavingsCtaUrl?: InputMaybe<Scalars['String']>;
  /** Whether to show potential maintenance plan savings on invoices/estimates for non-members */
  maintenancePlanSavingsEnabled?: InputMaybe<Scalars['Boolean']>;
  maintenancePlansEnabled?: InputMaybe<Scalars['Boolean']>;
  overdueAccountBalanceEnabled?: InputMaybe<Scalars['Boolean']>;
  pdfLayoutConfig?: InputMaybe<Scalars['jsonb']>;
  pricebookPhotosEnabled?: InputMaybe<Scalars['Boolean']>;
  qboAutoSyncInvoiceOnFullyPaid?: InputMaybe<Scalars['Boolean']>;
  qboAutoSyncInvoiceOnIssued?: InputMaybe<Scalars['Boolean']>;
  qboAutoSyncInvoiceOnPayment?: InputMaybe<Scalars['Boolean']>;
  qboEnabled?: InputMaybe<Scalars['Boolean']>;
  sage100ReportingIntegrationEnabled?: InputMaybe<Scalars['Boolean']>;
  scheduleColorMode?: InputMaybe<Scalars['String']>;
  scheduleTechOrder?: InputMaybe<Array<Scalars['uuid']>>;
  smsAppointmentTemplate?: InputMaybe<Scalars['String']>;
  smsReminderTemplate?: InputMaybe<Scalars['String']>;
  technicianPerformanceEnabled?: InputMaybe<Scalars['Boolean']>;
  timesheetPayPeriodBeginAnchor?: InputMaybe<Scalars['timestamptz']>;
  timesheetPayPeriodBeginRrule?: InputMaybe<Scalars['String']>;
  timesheetsEnabled?: InputMaybe<Scalars['Boolean']>;
  visibleInstallProjectTypesJsonArray?: InputMaybe<Scalars['json']>;
  wisetackEnabled?: InputMaybe<Scalars['Boolean']>;
  yelpId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CompanyConfigMaxFields = {
  __typename?: 'CompanyConfigMaxFields';
  accountNameDisplayTemplate?: Maybe<Scalars['MustacheTemplate']>;
  angiId?: Maybe<Scalars['String']>;
  autoClockOutMaxContinuousHours?: Maybe<Scalars['Int']>;
  bbbId?: Maybe<Scalars['String']>;
  blurb?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  defaultAccountManagerUserGuid?: Maybe<Scalars['uuid']>;
  estimateAcceptNotifyEmail?: Maybe<Scalars['String']>;
  estimateAcceptNotifyUserGuids?: Maybe<Array<Scalars['uuid']>>;
  estimateAutoExpirationDays?: Maybe<Scalars['Int']>;
  estimateLineItemsVisibility?: Maybe<Scalars['CompanyLineItemVisibility']>;
  facebookId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  hiddenEquipmentTypesJsonArray?: Maybe<Scalars['EquipmentTypeArray']>;
  invoiceIssueWorkflow?: Maybe<Scalars['InvoiceIssueWorkflow']>;
  invoiceLineItemsVisibility?: Maybe<Scalars['CompanyLineItemVisibility']>;
  /** Custom CTA URL for maintenance plan signup (optional, defaults to standard maintenance plans page) */
  maintenancePlanSavingsCtaUrl?: Maybe<Scalars['String']>;
  scheduleColorMode?: Maybe<Scalars['String']>;
  scheduleTechOrder?: Maybe<Array<Scalars['uuid']>>;
  smsAppointmentTemplate?: Maybe<Scalars['String']>;
  smsReminderTemplate?: Maybe<Scalars['String']>;
  timesheetPayPeriodBeginAnchor?: Maybe<Scalars['timestamptz']>;
  timesheetPayPeriodBeginRrule?: Maybe<Scalars['String']>;
  yelpId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CompanyConfigMinFields = {
  __typename?: 'CompanyConfigMinFields';
  accountNameDisplayTemplate?: Maybe<Scalars['MustacheTemplate']>;
  angiId?: Maybe<Scalars['String']>;
  autoClockOutMaxContinuousHours?: Maybe<Scalars['Int']>;
  bbbId?: Maybe<Scalars['String']>;
  blurb?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  defaultAccountManagerUserGuid?: Maybe<Scalars['uuid']>;
  estimateAcceptNotifyEmail?: Maybe<Scalars['String']>;
  estimateAcceptNotifyUserGuids?: Maybe<Array<Scalars['uuid']>>;
  estimateAutoExpirationDays?: Maybe<Scalars['Int']>;
  estimateLineItemsVisibility?: Maybe<Scalars['CompanyLineItemVisibility']>;
  facebookId?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  hiddenEquipmentTypesJsonArray?: Maybe<Scalars['EquipmentTypeArray']>;
  invoiceIssueWorkflow?: Maybe<Scalars['InvoiceIssueWorkflow']>;
  invoiceLineItemsVisibility?: Maybe<Scalars['CompanyLineItemVisibility']>;
  /** Custom CTA URL for maintenance plan signup (optional, defaults to standard maintenance plans page) */
  maintenancePlanSavingsCtaUrl?: Maybe<Scalars['String']>;
  scheduleColorMode?: Maybe<Scalars['String']>;
  scheduleTechOrder?: Maybe<Array<Scalars['uuid']>>;
  smsAppointmentTemplate?: Maybe<Scalars['String']>;
  smsReminderTemplate?: Maybe<Scalars['String']>;
  timesheetPayPeriodBeginAnchor?: Maybe<Scalars['timestamptz']>;
  timesheetPayPeriodBeginRrule?: Maybe<Scalars['String']>;
  yelpId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "company_config" */
export type CompanyConfigMutationResponse = {
  __typename?: 'CompanyConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyConfig>;
};

/** input type for inserting object relation for remote table "company_config" */
export type CompanyConfigObjRelInsertInput = {
  data: CompanyConfigInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyConfigOnConflict>;
};

/** on_conflict condition type for table "company_config" */
export type CompanyConfigOnConflict = {
  constraint: CompanyConfigConstraint;
  updateColumns?: Array<CompanyConfigUpdateColumn>;
  where?: InputMaybe<CompanyConfigBoolExp>;
};

/** Ordering options when selecting data from "company_config". */
export type CompanyConfigOrderBy = {
  accountManagerEnabled?: InputMaybe<OrderBy>;
  accountNameDisplayTemplate?: InputMaybe<OrderBy>;
  angiId?: InputMaybe<OrderBy>;
  autoClockOutEnabled?: InputMaybe<OrderBy>;
  autoClockOutMaxContinuousHours?: InputMaybe<OrderBy>;
  bbbId?: InputMaybe<OrderBy>;
  blurb?: InputMaybe<OrderBy>;
  businessUnitsEnabled?: InputMaybe<OrderBy>;
  businessUnitsRequired?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  confirmationNotificationSuppressedByDefault?: InputMaybe<OrderBy>;
  customerNumberEnabled?: InputMaybe<OrderBy>;
  defaultAccountManager?: InputMaybe<UsersOrderBy>;
  defaultAccountManagerUserGuid?: InputMaybe<OrderBy>;
  endOfJobAppointmentWorkflowEnabled?: InputMaybe<OrderBy>;
  estimateAcceptNotifyCreator?: InputMaybe<OrderBy>;
  estimateAcceptNotifyEmail?: InputMaybe<OrderBy>;
  estimateAcceptNotifyUserGuids?: InputMaybe<OrderBy>;
  estimateAutoExpirationDays?: InputMaybe<OrderBy>;
  estimateAutoExpirationEnabled?: InputMaybe<OrderBy>;
  estimateDisplayTechnicianName?: InputMaybe<OrderBy>;
  estimateLineItemsVisibility?: InputMaybe<OrderBy>;
  estimateRehashEnabled?: InputMaybe<OrderBy>;
  facebookId?: InputMaybe<OrderBy>;
  googlePlaceId?: InputMaybe<OrderBy>;
  hiddenEquipmentTypesJsonArray?: InputMaybe<OrderBy>;
  hideArrivalWindowInNotifications?: InputMaybe<OrderBy>;
  hideLineItemPrices?: InputMaybe<OrderBy>;
  invoiceDisplayTechnicianName?: InputMaybe<OrderBy>;
  invoiceIncludePaymentLink?: InputMaybe<OrderBy>;
  invoiceIssueWorkflow?: InputMaybe<OrderBy>;
  invoiceLineItemsVisibility?: InputMaybe<OrderBy>;
  jobInvoiceIsRequiredToCompleteVisit?: InputMaybe<OrderBy>;
  jobInvoiceIsRequiredToCompleteVisitExcludeSalesClass?: InputMaybe<OrderBy>;
  locationMunicipalityFieldEnabled?: InputMaybe<OrderBy>;
  maintenancePlanSavingsCtaUrl?: InputMaybe<OrderBy>;
  maintenancePlanSavingsEnabled?: InputMaybe<OrderBy>;
  maintenancePlansEnabled?: InputMaybe<OrderBy>;
  overdueAccountBalanceEnabled?: InputMaybe<OrderBy>;
  pdfLayoutConfig?: InputMaybe<OrderBy>;
  pricebookPhotosEnabled?: InputMaybe<OrderBy>;
  qboAutoSyncInvoiceOnFullyPaid?: InputMaybe<OrderBy>;
  qboAutoSyncInvoiceOnIssued?: InputMaybe<OrderBy>;
  qboAutoSyncInvoiceOnPayment?: InputMaybe<OrderBy>;
  qboEnabled?: InputMaybe<OrderBy>;
  sage100ReportingIntegrationEnabled?: InputMaybe<OrderBy>;
  scheduleColorMode?: InputMaybe<OrderBy>;
  scheduleTechOrder?: InputMaybe<OrderBy>;
  smsAppointmentTemplate?: InputMaybe<OrderBy>;
  smsReminderTemplate?: InputMaybe<OrderBy>;
  technicianPerformanceEnabled?: InputMaybe<OrderBy>;
  timesheetPayPeriodBeginAnchor?: InputMaybe<OrderBy>;
  timesheetPayPeriodBeginRrule?: InputMaybe<OrderBy>;
  timesheetsEnabled?: InputMaybe<OrderBy>;
  visibleInstallProjectTypesJsonArray?: InputMaybe<OrderBy>;
  wisetackEnabled?: InputMaybe<OrderBy>;
  yelpId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_config */
export type CompanyConfigPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CompanyConfigPrependInput = {
  pdfLayoutConfig?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "company_config" */
export type CompanyConfigSelectColumn =
  /** column name */
  | 'accountManagerEnabled'
  /** column name */
  | 'accountNameDisplayTemplate'
  /** column name */
  | 'angiId'
  /** column name */
  | 'autoClockOutEnabled'
  /** column name */
  | 'autoClockOutMaxContinuousHours'
  /** column name */
  | 'bbbId'
  /** column name */
  | 'blurb'
  /** column name */
  | 'businessUnitsEnabled'
  /** column name */
  | 'businessUnitsRequired'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'confirmationNotificationSuppressedByDefault'
  /** column name */
  | 'customerNumberEnabled'
  /** column name */
  | 'defaultAccountManagerUserGuid'
  /** column name */
  | 'endOfJobAppointmentWorkflowEnabled'
  /** column name */
  | 'estimateAcceptNotifyCreator'
  /** column name */
  | 'estimateAcceptNotifyEmail'
  /** column name */
  | 'estimateAcceptNotifyUserGuids'
  /** column name */
  | 'estimateAutoExpirationDays'
  /** column name */
  | 'estimateAutoExpirationEnabled'
  /** column name */
  | 'estimateDisplayTechnicianName'
  /** column name */
  | 'estimateLineItemsVisibility'
  /** column name */
  | 'estimateRehashEnabled'
  /** column name */
  | 'facebookId'
  /** column name */
  | 'googlePlaceId'
  /** column name */
  | 'hiddenEquipmentTypesJsonArray'
  /** column name */
  | 'hideArrivalWindowInNotifications'
  /** column name */
  | 'hideLineItemPrices'
  /** column name */
  | 'invoiceDisplayTechnicianName'
  /** column name */
  | 'invoiceIncludePaymentLink'
  /** column name */
  | 'invoiceIssueWorkflow'
  /** column name */
  | 'invoiceLineItemsVisibility'
  /** column name */
  | 'jobInvoiceIsRequiredToCompleteVisit'
  /** column name */
  | 'jobInvoiceIsRequiredToCompleteVisitExcludeSalesClass'
  /** column name */
  | 'locationMunicipalityFieldEnabled'
  /** column name */
  | 'maintenancePlanSavingsCtaUrl'
  /** column name */
  | 'maintenancePlanSavingsEnabled'
  /** column name */
  | 'maintenancePlansEnabled'
  /** column name */
  | 'overdueAccountBalanceEnabled'
  /** column name */
  | 'pdfLayoutConfig'
  /** column name */
  | 'pricebookPhotosEnabled'
  /** column name */
  | 'qboAutoSyncInvoiceOnFullyPaid'
  /** column name */
  | 'qboAutoSyncInvoiceOnIssued'
  /** column name */
  | 'qboAutoSyncInvoiceOnPayment'
  /** column name */
  | 'qboEnabled'
  /** column name */
  | 'sage100ReportingIntegrationEnabled'
  /** column name */
  | 'scheduleColorMode'
  /** column name */
  | 'scheduleTechOrder'
  /** column name */
  | 'smsAppointmentTemplate'
  /** column name */
  | 'smsReminderTemplate'
  /** column name */
  | 'technicianPerformanceEnabled'
  /** column name */
  | 'timesheetPayPeriodBeginAnchor'
  /** column name */
  | 'timesheetPayPeriodBeginRrule'
  /** column name */
  | 'timesheetsEnabled'
  /** column name */
  | 'visibleInstallProjectTypesJsonArray'
  /** column name */
  | 'wisetackEnabled'
  /** column name */
  | 'yelpId';

/** input type for updating data in table "company_config" */
export type CompanyConfigSetInput = {
  accountManagerEnabled?: InputMaybe<Scalars['Boolean']>;
  accountNameDisplayTemplate?: InputMaybe<Scalars['MustacheTemplate']>;
  angiId?: InputMaybe<Scalars['String']>;
  autoClockOutEnabled?: InputMaybe<Scalars['Boolean']>;
  autoClockOutMaxContinuousHours?: InputMaybe<Scalars['Int']>;
  bbbId?: InputMaybe<Scalars['String']>;
  blurb?: InputMaybe<Scalars['String']>;
  businessUnitsEnabled?: InputMaybe<Scalars['Boolean']>;
  businessUnitsRequired?: InputMaybe<Scalars['Boolean']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  confirmationNotificationSuppressedByDefault?: InputMaybe<Scalars['Boolean']>;
  customerNumberEnabled?: InputMaybe<Scalars['Boolean']>;
  defaultAccountManagerUserGuid?: InputMaybe<Scalars['uuid']>;
  endOfJobAppointmentWorkflowEnabled?: InputMaybe<Scalars['Boolean']>;
  estimateAcceptNotifyCreator?: InputMaybe<Scalars['Boolean']>;
  estimateAcceptNotifyEmail?: InputMaybe<Scalars['String']>;
  estimateAcceptNotifyUserGuids?: InputMaybe<Array<Scalars['uuid']>>;
  estimateAutoExpirationDays?: InputMaybe<Scalars['Int']>;
  estimateAutoExpirationEnabled?: InputMaybe<Scalars['Boolean']>;
  estimateDisplayTechnicianName?: InputMaybe<Scalars['Boolean']>;
  estimateLineItemsVisibility?: InputMaybe<Scalars['CompanyLineItemVisibility']>;
  estimateRehashEnabled?: InputMaybe<Scalars['Boolean']>;
  facebookId?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  hiddenEquipmentTypesJsonArray?: InputMaybe<Scalars['EquipmentTypeArray']>;
  hideArrivalWindowInNotifications?: InputMaybe<Scalars['Boolean']>;
  /** Company-wide default controlling whether per-line prices are hidden on customer-facing invoices/estimates (scope/quantity/totals stay visible). Seeds the per-record flag at create. */
  hideLineItemPrices?: InputMaybe<Scalars['Boolean']>;
  invoiceDisplayTechnicianName?: InputMaybe<Scalars['Boolean']>;
  invoiceIncludePaymentLink?: InputMaybe<Scalars['Boolean']>;
  invoiceIssueWorkflow?: InputMaybe<Scalars['InvoiceIssueWorkflow']>;
  invoiceLineItemsVisibility?: InputMaybe<Scalars['CompanyLineItemVisibility']>;
  jobInvoiceIsRequiredToCompleteVisit?: InputMaybe<Scalars['Boolean']>;
  jobInvoiceIsRequiredToCompleteVisitExcludeSalesClass?: InputMaybe<Scalars['Boolean']>;
  locationMunicipalityFieldEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Custom CTA URL for maintenance plan signup (optional, defaults to standard maintenance plans page) */
  maintenancePlanSavingsCtaUrl?: InputMaybe<Scalars['String']>;
  /** Whether to show potential maintenance plan savings on invoices/estimates for non-members */
  maintenancePlanSavingsEnabled?: InputMaybe<Scalars['Boolean']>;
  maintenancePlansEnabled?: InputMaybe<Scalars['Boolean']>;
  overdueAccountBalanceEnabled?: InputMaybe<Scalars['Boolean']>;
  pdfLayoutConfig?: InputMaybe<Scalars['jsonb']>;
  pricebookPhotosEnabled?: InputMaybe<Scalars['Boolean']>;
  qboAutoSyncInvoiceOnFullyPaid?: InputMaybe<Scalars['Boolean']>;
  qboAutoSyncInvoiceOnIssued?: InputMaybe<Scalars['Boolean']>;
  qboAutoSyncInvoiceOnPayment?: InputMaybe<Scalars['Boolean']>;
  qboEnabled?: InputMaybe<Scalars['Boolean']>;
  sage100ReportingIntegrationEnabled?: InputMaybe<Scalars['Boolean']>;
  scheduleColorMode?: InputMaybe<Scalars['String']>;
  scheduleTechOrder?: InputMaybe<Array<Scalars['uuid']>>;
  smsAppointmentTemplate?: InputMaybe<Scalars['String']>;
  smsReminderTemplate?: InputMaybe<Scalars['String']>;
  technicianPerformanceEnabled?: InputMaybe<Scalars['Boolean']>;
  timesheetPayPeriodBeginAnchor?: InputMaybe<Scalars['timestamptz']>;
  timesheetPayPeriodBeginRrule?: InputMaybe<Scalars['String']>;
  timesheetsEnabled?: InputMaybe<Scalars['Boolean']>;
  visibleInstallProjectTypesJsonArray?: InputMaybe<Scalars['json']>;
  wisetackEnabled?: InputMaybe<Scalars['Boolean']>;
  yelpId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CompanyConfigStddevFields = {
  __typename?: 'CompanyConfigStddevFields';
  autoClockOutMaxContinuousHours?: Maybe<Scalars['Float']>;
  estimateAutoExpirationDays?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CompanyConfigStddevPopFields = {
  __typename?: 'CompanyConfigStddevPopFields';
  autoClockOutMaxContinuousHours?: Maybe<Scalars['Float']>;
  estimateAutoExpirationDays?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CompanyConfigStddevSampFields = {
  __typename?: 'CompanyConfigStddevSampFields';
  autoClockOutMaxContinuousHours?: Maybe<Scalars['Float']>;
  estimateAutoExpirationDays?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "company_config" */
export type CompanyConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyConfigStreamCursorValueInput = {
  accountManagerEnabled?: InputMaybe<Scalars['Boolean']>;
  accountNameDisplayTemplate?: InputMaybe<Scalars['MustacheTemplate']>;
  angiId?: InputMaybe<Scalars['String']>;
  autoClockOutEnabled?: InputMaybe<Scalars['Boolean']>;
  autoClockOutMaxContinuousHours?: InputMaybe<Scalars['Int']>;
  bbbId?: InputMaybe<Scalars['String']>;
  blurb?: InputMaybe<Scalars['String']>;
  businessUnitsEnabled?: InputMaybe<Scalars['Boolean']>;
  businessUnitsRequired?: InputMaybe<Scalars['Boolean']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  confirmationNotificationSuppressedByDefault?: InputMaybe<Scalars['Boolean']>;
  customerNumberEnabled?: InputMaybe<Scalars['Boolean']>;
  defaultAccountManagerUserGuid?: InputMaybe<Scalars['uuid']>;
  endOfJobAppointmentWorkflowEnabled?: InputMaybe<Scalars['Boolean']>;
  estimateAcceptNotifyCreator?: InputMaybe<Scalars['Boolean']>;
  estimateAcceptNotifyEmail?: InputMaybe<Scalars['String']>;
  estimateAcceptNotifyUserGuids?: InputMaybe<Array<Scalars['uuid']>>;
  estimateAutoExpirationDays?: InputMaybe<Scalars['Int']>;
  estimateAutoExpirationEnabled?: InputMaybe<Scalars['Boolean']>;
  estimateDisplayTechnicianName?: InputMaybe<Scalars['Boolean']>;
  estimateLineItemsVisibility?: InputMaybe<Scalars['CompanyLineItemVisibility']>;
  estimateRehashEnabled?: InputMaybe<Scalars['Boolean']>;
  facebookId?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  hiddenEquipmentTypesJsonArray?: InputMaybe<Scalars['EquipmentTypeArray']>;
  hideArrivalWindowInNotifications?: InputMaybe<Scalars['Boolean']>;
  /** Company-wide default controlling whether per-line prices are hidden on customer-facing invoices/estimates (scope/quantity/totals stay visible). Seeds the per-record flag at create. */
  hideLineItemPrices?: InputMaybe<Scalars['Boolean']>;
  invoiceDisplayTechnicianName?: InputMaybe<Scalars['Boolean']>;
  invoiceIncludePaymentLink?: InputMaybe<Scalars['Boolean']>;
  invoiceIssueWorkflow?: InputMaybe<Scalars['InvoiceIssueWorkflow']>;
  invoiceLineItemsVisibility?: InputMaybe<Scalars['CompanyLineItemVisibility']>;
  jobInvoiceIsRequiredToCompleteVisit?: InputMaybe<Scalars['Boolean']>;
  jobInvoiceIsRequiredToCompleteVisitExcludeSalesClass?: InputMaybe<Scalars['Boolean']>;
  locationMunicipalityFieldEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Custom CTA URL for maintenance plan signup (optional, defaults to standard maintenance plans page) */
  maintenancePlanSavingsCtaUrl?: InputMaybe<Scalars['String']>;
  /** Whether to show potential maintenance plan savings on invoices/estimates for non-members */
  maintenancePlanSavingsEnabled?: InputMaybe<Scalars['Boolean']>;
  maintenancePlansEnabled?: InputMaybe<Scalars['Boolean']>;
  overdueAccountBalanceEnabled?: InputMaybe<Scalars['Boolean']>;
  pdfLayoutConfig?: InputMaybe<Scalars['jsonb']>;
  pricebookPhotosEnabled?: InputMaybe<Scalars['Boolean']>;
  qboAutoSyncInvoiceOnFullyPaid?: InputMaybe<Scalars['Boolean']>;
  qboAutoSyncInvoiceOnIssued?: InputMaybe<Scalars['Boolean']>;
  qboAutoSyncInvoiceOnPayment?: InputMaybe<Scalars['Boolean']>;
  qboEnabled?: InputMaybe<Scalars['Boolean']>;
  sage100ReportingIntegrationEnabled?: InputMaybe<Scalars['Boolean']>;
  scheduleColorMode?: InputMaybe<Scalars['String']>;
  scheduleTechOrder?: InputMaybe<Array<Scalars['uuid']>>;
  smsAppointmentTemplate?: InputMaybe<Scalars['String']>;
  smsReminderTemplate?: InputMaybe<Scalars['String']>;
  technicianPerformanceEnabled?: InputMaybe<Scalars['Boolean']>;
  timesheetPayPeriodBeginAnchor?: InputMaybe<Scalars['timestamptz']>;
  timesheetPayPeriodBeginRrule?: InputMaybe<Scalars['String']>;
  timesheetsEnabled?: InputMaybe<Scalars['Boolean']>;
  visibleInstallProjectTypesJsonArray?: InputMaybe<Scalars['json']>;
  wisetackEnabled?: InputMaybe<Scalars['Boolean']>;
  yelpId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CompanyConfigSumFields = {
  __typename?: 'CompanyConfigSumFields';
  autoClockOutMaxContinuousHours?: Maybe<Scalars['Int']>;
  estimateAutoExpirationDays?: Maybe<Scalars['Int']>;
};

/** update columns of table "company_config" */
export type CompanyConfigUpdateColumn =
  /** column name */
  | 'accountManagerEnabled'
  /** column name */
  | 'accountNameDisplayTemplate'
  /** column name */
  | 'angiId'
  /** column name */
  | 'autoClockOutEnabled'
  /** column name */
  | 'autoClockOutMaxContinuousHours'
  /** column name */
  | 'bbbId'
  /** column name */
  | 'blurb'
  /** column name */
  | 'businessUnitsEnabled'
  /** column name */
  | 'businessUnitsRequired'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'confirmationNotificationSuppressedByDefault'
  /** column name */
  | 'customerNumberEnabled'
  /** column name */
  | 'defaultAccountManagerUserGuid'
  /** column name */
  | 'endOfJobAppointmentWorkflowEnabled'
  /** column name */
  | 'estimateAcceptNotifyCreator'
  /** column name */
  | 'estimateAcceptNotifyEmail'
  /** column name */
  | 'estimateAcceptNotifyUserGuids'
  /** column name */
  | 'estimateAutoExpirationDays'
  /** column name */
  | 'estimateAutoExpirationEnabled'
  /** column name */
  | 'estimateDisplayTechnicianName'
  /** column name */
  | 'estimateLineItemsVisibility'
  /** column name */
  | 'estimateRehashEnabled'
  /** column name */
  | 'facebookId'
  /** column name */
  | 'googlePlaceId'
  /** column name */
  | 'hiddenEquipmentTypesJsonArray'
  /** column name */
  | 'hideArrivalWindowInNotifications'
  /** column name */
  | 'hideLineItemPrices'
  /** column name */
  | 'invoiceDisplayTechnicianName'
  /** column name */
  | 'invoiceIncludePaymentLink'
  /** column name */
  | 'invoiceIssueWorkflow'
  /** column name */
  | 'invoiceLineItemsVisibility'
  /** column name */
  | 'jobInvoiceIsRequiredToCompleteVisit'
  /** column name */
  | 'jobInvoiceIsRequiredToCompleteVisitExcludeSalesClass'
  /** column name */
  | 'locationMunicipalityFieldEnabled'
  /** column name */
  | 'maintenancePlanSavingsCtaUrl'
  /** column name */
  | 'maintenancePlanSavingsEnabled'
  /** column name */
  | 'maintenancePlansEnabled'
  /** column name */
  | 'overdueAccountBalanceEnabled'
  /** column name */
  | 'pdfLayoutConfig'
  /** column name */
  | 'pricebookPhotosEnabled'
  /** column name */
  | 'qboAutoSyncInvoiceOnFullyPaid'
  /** column name */
  | 'qboAutoSyncInvoiceOnIssued'
  /** column name */
  | 'qboAutoSyncInvoiceOnPayment'
  /** column name */
  | 'qboEnabled'
  /** column name */
  | 'sage100ReportingIntegrationEnabled'
  /** column name */
  | 'scheduleColorMode'
  /** column name */
  | 'scheduleTechOrder'
  /** column name */
  | 'smsAppointmentTemplate'
  /** column name */
  | 'smsReminderTemplate'
  /** column name */
  | 'technicianPerformanceEnabled'
  /** column name */
  | 'timesheetPayPeriodBeginAnchor'
  /** column name */
  | 'timesheetPayPeriodBeginRrule'
  /** column name */
  | 'timesheetsEnabled'
  /** column name */
  | 'visibleInstallProjectTypesJsonArray'
  /** column name */
  | 'wisetackEnabled'
  /** column name */
  | 'yelpId';

export type CompanyConfigUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CompanyConfigAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<CompanyConfigDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<CompanyConfigDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<CompanyConfigDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompanyConfigIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CompanyConfigPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyConfigSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyConfigBoolExp;
};

/** aggregate varPop on columns */
export type CompanyConfigVarPopFields = {
  __typename?: 'CompanyConfigVarPopFields';
  autoClockOutMaxContinuousHours?: Maybe<Scalars['Float']>;
  estimateAutoExpirationDays?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CompanyConfigVarSampFields = {
  __typename?: 'CompanyConfigVarSampFields';
  autoClockOutMaxContinuousHours?: Maybe<Scalars['Float']>;
  estimateAutoExpirationDays?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CompanyConfigVarianceFields = {
  __typename?: 'CompanyConfigVarianceFields';
  autoClockOutMaxContinuousHours?: Maybe<Scalars['Float']>;
  estimateAutoExpirationDays?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "company_drip_marketing_config" */
export type CompanyDripMarketingConfig = {
  __typename?: 'CompanyDripMarketingConfig';
  companyGuid: Scalars['uuid'];
  customerReviewUrl?: Maybe<Scalars['String']>;
  facebookReviewUrl?: Maybe<Scalars['String']>;
  googleReviewUrl?: Maybe<Scalars['String']>;
  jobCompletedCustomEmailContent?: Maybe<Scalars['String']>;
  jobCompletedDelayMs: Scalars['numeric'];
  jobCompletedEnabled: Scalars['Boolean'];
  maintenanceRemindersCustomEmailContent?: Maybe<Scalars['String']>;
  maintenanceRemindersDelayMonths: Scalars['numeric'];
  maintenanceRemindersEnabled: Scalars['Boolean'];
  maintenanceVisitRemindersEmailBodyTemplate?: Maybe<Scalars['String']>;
  maintenanceVisitRemindersEmailSubjectTemplate?: Maybe<Scalars['String']>;
  maintenanceVisitRemindersEnabled: Scalars['Boolean'];
  maintenanceVisitRemindersLimit: Scalars['numeric'];
  maintenanceVisitRemindersSchedule: Scalars['numeric'];
  maintenanceVisitRemindersSmsTemplate?: Maybe<Scalars['String']>;
  yelpReviewUrl?: Maybe<Scalars['String']>;
};

/** aggregated selection of "company_drip_marketing_config" */
export type CompanyDripMarketingConfigAggregate = {
  __typename?: 'CompanyDripMarketingConfigAggregate';
  aggregate?: Maybe<CompanyDripMarketingConfigAggregateFields>;
  nodes: Array<CompanyDripMarketingConfig>;
};

/** aggregate fields of "company_drip_marketing_config" */
export type CompanyDripMarketingConfigAggregateFields = {
  __typename?: 'CompanyDripMarketingConfigAggregateFields';
  avg?: Maybe<CompanyDripMarketingConfigAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompanyDripMarketingConfigMaxFields>;
  min?: Maybe<CompanyDripMarketingConfigMinFields>;
  stddev?: Maybe<CompanyDripMarketingConfigStddevFields>;
  stddevPop?: Maybe<CompanyDripMarketingConfigStddevPopFields>;
  stddevSamp?: Maybe<CompanyDripMarketingConfigStddevSampFields>;
  sum?: Maybe<CompanyDripMarketingConfigSumFields>;
  varPop?: Maybe<CompanyDripMarketingConfigVarPopFields>;
  varSamp?: Maybe<CompanyDripMarketingConfigVarSampFields>;
  variance?: Maybe<CompanyDripMarketingConfigVarianceFields>;
};


/** aggregate fields of "company_drip_marketing_config" */
export type CompanyDripMarketingConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyDripMarketingConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CompanyDripMarketingConfigAvgFields = {
  __typename?: 'CompanyDripMarketingConfigAvgFields';
  jobCompletedDelayMs?: Maybe<Scalars['Float']>;
  maintenanceRemindersDelayMonths?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersLimit?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersSchedule?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "company_drip_marketing_config". All fields are combined with a logical 'AND'. */
export type CompanyDripMarketingConfigBoolExp = {
  _and?: InputMaybe<Array<CompanyDripMarketingConfigBoolExp>>;
  _not?: InputMaybe<CompanyDripMarketingConfigBoolExp>;
  _or?: InputMaybe<Array<CompanyDripMarketingConfigBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  customerReviewUrl?: InputMaybe<StringComparisonExp>;
  facebookReviewUrl?: InputMaybe<StringComparisonExp>;
  googleReviewUrl?: InputMaybe<StringComparisonExp>;
  jobCompletedCustomEmailContent?: InputMaybe<StringComparisonExp>;
  jobCompletedDelayMs?: InputMaybe<NumericComparisonExp>;
  jobCompletedEnabled?: InputMaybe<BooleanComparisonExp>;
  maintenanceRemindersCustomEmailContent?: InputMaybe<StringComparisonExp>;
  maintenanceRemindersDelayMonths?: InputMaybe<NumericComparisonExp>;
  maintenanceRemindersEnabled?: InputMaybe<BooleanComparisonExp>;
  maintenanceVisitRemindersEmailBodyTemplate?: InputMaybe<StringComparisonExp>;
  maintenanceVisitRemindersEmailSubjectTemplate?: InputMaybe<StringComparisonExp>;
  maintenanceVisitRemindersEnabled?: InputMaybe<BooleanComparisonExp>;
  maintenanceVisitRemindersLimit?: InputMaybe<NumericComparisonExp>;
  maintenanceVisitRemindersSchedule?: InputMaybe<NumericComparisonExp>;
  maintenanceVisitRemindersSmsTemplate?: InputMaybe<StringComparisonExp>;
  yelpReviewUrl?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "company_drip_marketing_config" */
export type CompanyDripMarketingConfigConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'company_drip_marketing_config_pkey';

/** input type for incrementing numeric columns in table "company_drip_marketing_config" */
export type CompanyDripMarketingConfigIncInput = {
  jobCompletedDelayMs?: InputMaybe<Scalars['numeric']>;
  maintenanceRemindersDelayMonths?: InputMaybe<Scalars['numeric']>;
  maintenanceVisitRemindersLimit?: InputMaybe<Scalars['numeric']>;
  maintenanceVisitRemindersSchedule?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "company_drip_marketing_config" */
export type CompanyDripMarketingConfigInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  customerReviewUrl?: InputMaybe<Scalars['String']>;
  facebookReviewUrl?: InputMaybe<Scalars['String']>;
  googleReviewUrl?: InputMaybe<Scalars['String']>;
  jobCompletedCustomEmailContent?: InputMaybe<Scalars['String']>;
  jobCompletedDelayMs?: InputMaybe<Scalars['numeric']>;
  jobCompletedEnabled?: InputMaybe<Scalars['Boolean']>;
  maintenanceRemindersCustomEmailContent?: InputMaybe<Scalars['String']>;
  maintenanceRemindersDelayMonths?: InputMaybe<Scalars['numeric']>;
  maintenanceRemindersEnabled?: InputMaybe<Scalars['Boolean']>;
  maintenanceVisitRemindersEmailBodyTemplate?: InputMaybe<Scalars['String']>;
  maintenanceVisitRemindersEmailSubjectTemplate?: InputMaybe<Scalars['String']>;
  maintenanceVisitRemindersEnabled?: InputMaybe<Scalars['Boolean']>;
  maintenanceVisitRemindersLimit?: InputMaybe<Scalars['numeric']>;
  maintenanceVisitRemindersSchedule?: InputMaybe<Scalars['numeric']>;
  maintenanceVisitRemindersSmsTemplate?: InputMaybe<Scalars['String']>;
  yelpReviewUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CompanyDripMarketingConfigMaxFields = {
  __typename?: 'CompanyDripMarketingConfigMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  customerReviewUrl?: Maybe<Scalars['String']>;
  facebookReviewUrl?: Maybe<Scalars['String']>;
  googleReviewUrl?: Maybe<Scalars['String']>;
  jobCompletedCustomEmailContent?: Maybe<Scalars['String']>;
  jobCompletedDelayMs?: Maybe<Scalars['numeric']>;
  maintenanceRemindersCustomEmailContent?: Maybe<Scalars['String']>;
  maintenanceRemindersDelayMonths?: Maybe<Scalars['numeric']>;
  maintenanceVisitRemindersEmailBodyTemplate?: Maybe<Scalars['String']>;
  maintenanceVisitRemindersEmailSubjectTemplate?: Maybe<Scalars['String']>;
  maintenanceVisitRemindersLimit?: Maybe<Scalars['numeric']>;
  maintenanceVisitRemindersSchedule?: Maybe<Scalars['numeric']>;
  maintenanceVisitRemindersSmsTemplate?: Maybe<Scalars['String']>;
  yelpReviewUrl?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CompanyDripMarketingConfigMinFields = {
  __typename?: 'CompanyDripMarketingConfigMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  customerReviewUrl?: Maybe<Scalars['String']>;
  facebookReviewUrl?: Maybe<Scalars['String']>;
  googleReviewUrl?: Maybe<Scalars['String']>;
  jobCompletedCustomEmailContent?: Maybe<Scalars['String']>;
  jobCompletedDelayMs?: Maybe<Scalars['numeric']>;
  maintenanceRemindersCustomEmailContent?: Maybe<Scalars['String']>;
  maintenanceRemindersDelayMonths?: Maybe<Scalars['numeric']>;
  maintenanceVisitRemindersEmailBodyTemplate?: Maybe<Scalars['String']>;
  maintenanceVisitRemindersEmailSubjectTemplate?: Maybe<Scalars['String']>;
  maintenanceVisitRemindersLimit?: Maybe<Scalars['numeric']>;
  maintenanceVisitRemindersSchedule?: Maybe<Scalars['numeric']>;
  maintenanceVisitRemindersSmsTemplate?: Maybe<Scalars['String']>;
  yelpReviewUrl?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "company_drip_marketing_config" */
export type CompanyDripMarketingConfigMutationResponse = {
  __typename?: 'CompanyDripMarketingConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyDripMarketingConfig>;
};

/** on_conflict condition type for table "company_drip_marketing_config" */
export type CompanyDripMarketingConfigOnConflict = {
  constraint: CompanyDripMarketingConfigConstraint;
  updateColumns?: Array<CompanyDripMarketingConfigUpdateColumn>;
  where?: InputMaybe<CompanyDripMarketingConfigBoolExp>;
};

/** Ordering options when selecting data from "company_drip_marketing_config". */
export type CompanyDripMarketingConfigOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  customerReviewUrl?: InputMaybe<OrderBy>;
  facebookReviewUrl?: InputMaybe<OrderBy>;
  googleReviewUrl?: InputMaybe<OrderBy>;
  jobCompletedCustomEmailContent?: InputMaybe<OrderBy>;
  jobCompletedDelayMs?: InputMaybe<OrderBy>;
  jobCompletedEnabled?: InputMaybe<OrderBy>;
  maintenanceRemindersCustomEmailContent?: InputMaybe<OrderBy>;
  maintenanceRemindersDelayMonths?: InputMaybe<OrderBy>;
  maintenanceRemindersEnabled?: InputMaybe<OrderBy>;
  maintenanceVisitRemindersEmailBodyTemplate?: InputMaybe<OrderBy>;
  maintenanceVisitRemindersEmailSubjectTemplate?: InputMaybe<OrderBy>;
  maintenanceVisitRemindersEnabled?: InputMaybe<OrderBy>;
  maintenanceVisitRemindersLimit?: InputMaybe<OrderBy>;
  maintenanceVisitRemindersSchedule?: InputMaybe<OrderBy>;
  maintenanceVisitRemindersSmsTemplate?: InputMaybe<OrderBy>;
  yelpReviewUrl?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_drip_marketing_config */
export type CompanyDripMarketingConfigPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "company_drip_marketing_config" */
export type CompanyDripMarketingConfigSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'customerReviewUrl'
  /** column name */
  | 'facebookReviewUrl'
  /** column name */
  | 'googleReviewUrl'
  /** column name */
  | 'jobCompletedCustomEmailContent'
  /** column name */
  | 'jobCompletedDelayMs'
  /** column name */
  | 'jobCompletedEnabled'
  /** column name */
  | 'maintenanceRemindersCustomEmailContent'
  /** column name */
  | 'maintenanceRemindersDelayMonths'
  /** column name */
  | 'maintenanceRemindersEnabled'
  /** column name */
  | 'maintenanceVisitRemindersEmailBodyTemplate'
  /** column name */
  | 'maintenanceVisitRemindersEmailSubjectTemplate'
  /** column name */
  | 'maintenanceVisitRemindersEnabled'
  /** column name */
  | 'maintenanceVisitRemindersLimit'
  /** column name */
  | 'maintenanceVisitRemindersSchedule'
  /** column name */
  | 'maintenanceVisitRemindersSmsTemplate'
  /** column name */
  | 'yelpReviewUrl';

/** input type for updating data in table "company_drip_marketing_config" */
export type CompanyDripMarketingConfigSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  customerReviewUrl?: InputMaybe<Scalars['String']>;
  facebookReviewUrl?: InputMaybe<Scalars['String']>;
  googleReviewUrl?: InputMaybe<Scalars['String']>;
  jobCompletedCustomEmailContent?: InputMaybe<Scalars['String']>;
  jobCompletedDelayMs?: InputMaybe<Scalars['numeric']>;
  jobCompletedEnabled?: InputMaybe<Scalars['Boolean']>;
  maintenanceRemindersCustomEmailContent?: InputMaybe<Scalars['String']>;
  maintenanceRemindersDelayMonths?: InputMaybe<Scalars['numeric']>;
  maintenanceRemindersEnabled?: InputMaybe<Scalars['Boolean']>;
  maintenanceVisitRemindersEmailBodyTemplate?: InputMaybe<Scalars['String']>;
  maintenanceVisitRemindersEmailSubjectTemplate?: InputMaybe<Scalars['String']>;
  maintenanceVisitRemindersEnabled?: InputMaybe<Scalars['Boolean']>;
  maintenanceVisitRemindersLimit?: InputMaybe<Scalars['numeric']>;
  maintenanceVisitRemindersSchedule?: InputMaybe<Scalars['numeric']>;
  maintenanceVisitRemindersSmsTemplate?: InputMaybe<Scalars['String']>;
  yelpReviewUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CompanyDripMarketingConfigStddevFields = {
  __typename?: 'CompanyDripMarketingConfigStddevFields';
  jobCompletedDelayMs?: Maybe<Scalars['Float']>;
  maintenanceRemindersDelayMonths?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersLimit?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersSchedule?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CompanyDripMarketingConfigStddevPopFields = {
  __typename?: 'CompanyDripMarketingConfigStddevPopFields';
  jobCompletedDelayMs?: Maybe<Scalars['Float']>;
  maintenanceRemindersDelayMonths?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersLimit?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersSchedule?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CompanyDripMarketingConfigStddevSampFields = {
  __typename?: 'CompanyDripMarketingConfigStddevSampFields';
  jobCompletedDelayMs?: Maybe<Scalars['Float']>;
  maintenanceRemindersDelayMonths?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersLimit?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersSchedule?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "company_drip_marketing_config" */
export type CompanyDripMarketingConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyDripMarketingConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyDripMarketingConfigStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  customerReviewUrl?: InputMaybe<Scalars['String']>;
  facebookReviewUrl?: InputMaybe<Scalars['String']>;
  googleReviewUrl?: InputMaybe<Scalars['String']>;
  jobCompletedCustomEmailContent?: InputMaybe<Scalars['String']>;
  jobCompletedDelayMs?: InputMaybe<Scalars['numeric']>;
  jobCompletedEnabled?: InputMaybe<Scalars['Boolean']>;
  maintenanceRemindersCustomEmailContent?: InputMaybe<Scalars['String']>;
  maintenanceRemindersDelayMonths?: InputMaybe<Scalars['numeric']>;
  maintenanceRemindersEnabled?: InputMaybe<Scalars['Boolean']>;
  maintenanceVisitRemindersEmailBodyTemplate?: InputMaybe<Scalars['String']>;
  maintenanceVisitRemindersEmailSubjectTemplate?: InputMaybe<Scalars['String']>;
  maintenanceVisitRemindersEnabled?: InputMaybe<Scalars['Boolean']>;
  maintenanceVisitRemindersLimit?: InputMaybe<Scalars['numeric']>;
  maintenanceVisitRemindersSchedule?: InputMaybe<Scalars['numeric']>;
  maintenanceVisitRemindersSmsTemplate?: InputMaybe<Scalars['String']>;
  yelpReviewUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CompanyDripMarketingConfigSumFields = {
  __typename?: 'CompanyDripMarketingConfigSumFields';
  jobCompletedDelayMs?: Maybe<Scalars['numeric']>;
  maintenanceRemindersDelayMonths?: Maybe<Scalars['numeric']>;
  maintenanceVisitRemindersLimit?: Maybe<Scalars['numeric']>;
  maintenanceVisitRemindersSchedule?: Maybe<Scalars['numeric']>;
};

/** update columns of table "company_drip_marketing_config" */
export type CompanyDripMarketingConfigUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'customerReviewUrl'
  /** column name */
  | 'facebookReviewUrl'
  /** column name */
  | 'googleReviewUrl'
  /** column name */
  | 'jobCompletedCustomEmailContent'
  /** column name */
  | 'jobCompletedDelayMs'
  /** column name */
  | 'jobCompletedEnabled'
  /** column name */
  | 'maintenanceRemindersCustomEmailContent'
  /** column name */
  | 'maintenanceRemindersDelayMonths'
  /** column name */
  | 'maintenanceRemindersEnabled'
  /** column name */
  | 'maintenanceVisitRemindersEmailBodyTemplate'
  /** column name */
  | 'maintenanceVisitRemindersEmailSubjectTemplate'
  /** column name */
  | 'maintenanceVisitRemindersEnabled'
  /** column name */
  | 'maintenanceVisitRemindersLimit'
  /** column name */
  | 'maintenanceVisitRemindersSchedule'
  /** column name */
  | 'maintenanceVisitRemindersSmsTemplate'
  /** column name */
  | 'yelpReviewUrl';

export type CompanyDripMarketingConfigUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompanyDripMarketingConfigIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyDripMarketingConfigSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyDripMarketingConfigBoolExp;
};

/** aggregate varPop on columns */
export type CompanyDripMarketingConfigVarPopFields = {
  __typename?: 'CompanyDripMarketingConfigVarPopFields';
  jobCompletedDelayMs?: Maybe<Scalars['Float']>;
  maintenanceRemindersDelayMonths?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersLimit?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersSchedule?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CompanyDripMarketingConfigVarSampFields = {
  __typename?: 'CompanyDripMarketingConfigVarSampFields';
  jobCompletedDelayMs?: Maybe<Scalars['Float']>;
  maintenanceRemindersDelayMonths?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersLimit?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersSchedule?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CompanyDripMarketingConfigVarianceFields = {
  __typename?: 'CompanyDripMarketingConfigVarianceFields';
  jobCompletedDelayMs?: Maybe<Scalars['Float']>;
  maintenanceRemindersDelayMonths?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersLimit?: Maybe<Scalars['Float']>;
  maintenanceVisitRemindersSchedule?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "company_lead_source_links" */
export type CompanyLeadSourceLinks = {
  __typename?: 'CompanyLeadSourceLinks';
  attributionDescription?: Maybe<Scalars['String']>;
  /** An object relationship */
  companyLeadSource: CompanyLeadSources;
  companyLeadSourceGuid: Scalars['uuid'];
  companyLeadSourceLinkGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  linkedAccount?: Maybe<Accounts>;
  linkedAccountGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  linkedContact?: Maybe<Contacts>;
  linkedContactGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  linkedJob?: Maybe<Jobs>;
  linkedJobGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  linkedLocation?: Maybe<Locations>;
  linkedLocationGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  referringContact?: Maybe<Contacts>;
  referringContactGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  referringJob?: Maybe<Jobs>;
  referringJobGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  referringUser?: Maybe<Users>;
  referringUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "company_lead_source_links" */
export type CompanyLeadSourceLinksAggregate = {
  __typename?: 'CompanyLeadSourceLinksAggregate';
  aggregate?: Maybe<CompanyLeadSourceLinksAggregateFields>;
  nodes: Array<CompanyLeadSourceLinks>;
};

export type CompanyLeadSourceLinksAggregateBoolExp = {
  count?: InputMaybe<CompanyLeadSourceLinksAggregateBoolExpCount>;
};

/** aggregate fields of "company_lead_source_links" */
export type CompanyLeadSourceLinksAggregateFields = {
  __typename?: 'CompanyLeadSourceLinksAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CompanyLeadSourceLinksMaxFields>;
  min?: Maybe<CompanyLeadSourceLinksMinFields>;
};


/** aggregate fields of "company_lead_source_links" */
export type CompanyLeadSourceLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyLeadSourceLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company_lead_source_links" */
export type CompanyLeadSourceLinksAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CompanyLeadSourceLinksMaxOrderBy>;
  min?: InputMaybe<CompanyLeadSourceLinksMinOrderBy>;
};

/** input type for inserting array relation for remote table "company_lead_source_links" */
export type CompanyLeadSourceLinksArrRelInsertInput = {
  data: Array<CompanyLeadSourceLinksInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyLeadSourceLinksOnConflict>;
};

/** Boolean expression to filter rows from the table "company_lead_source_links". All fields are combined with a logical 'AND'. */
export type CompanyLeadSourceLinksBoolExp = {
  _and?: InputMaybe<Array<CompanyLeadSourceLinksBoolExp>>;
  _not?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
  _or?: InputMaybe<Array<CompanyLeadSourceLinksBoolExp>>;
  attributionDescription?: InputMaybe<StringComparisonExp>;
  companyLeadSource?: InputMaybe<CompanyLeadSourcesBoolExp>;
  companyLeadSourceGuid?: InputMaybe<UuidComparisonExp>;
  companyLeadSourceLinkGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  linkedAccount?: InputMaybe<AccountsBoolExp>;
  linkedAccountGuid?: InputMaybe<UuidComparisonExp>;
  linkedContact?: InputMaybe<ContactsBoolExp>;
  linkedContactGuid?: InputMaybe<UuidComparisonExp>;
  linkedJob?: InputMaybe<JobsBoolExp>;
  linkedJobGuid?: InputMaybe<UuidComparisonExp>;
  linkedLocation?: InputMaybe<LocationsBoolExp>;
  linkedLocationGuid?: InputMaybe<UuidComparisonExp>;
  referringContact?: InputMaybe<ContactsBoolExp>;
  referringContactGuid?: InputMaybe<UuidComparisonExp>;
  referringJob?: InputMaybe<JobsBoolExp>;
  referringJobGuid?: InputMaybe<UuidComparisonExp>;
  referringUser?: InputMaybe<UsersBoolExp>;
  referringUserGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "company_lead_source_links" */
export type CompanyLeadSourceLinksConstraint =
  /** unique or primary key constraint on columns "company_lead_source_link_guid" */
  | 'company_lead_source_links_pkey';

/** input type for inserting data into table "company_lead_source_links" */
export type CompanyLeadSourceLinksInsertInput = {
  attributionDescription?: InputMaybe<Scalars['String']>;
  companyLeadSource?: InputMaybe<CompanyLeadSourcesObjRelInsertInput>;
  companyLeadSourceGuid?: InputMaybe<Scalars['uuid']>;
  companyLeadSourceLinkGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  linkedAccount?: InputMaybe<AccountsObjRelInsertInput>;
  linkedAccountGuid?: InputMaybe<Scalars['uuid']>;
  linkedContact?: InputMaybe<ContactsObjRelInsertInput>;
  linkedContactGuid?: InputMaybe<Scalars['uuid']>;
  linkedJob?: InputMaybe<JobsObjRelInsertInput>;
  linkedJobGuid?: InputMaybe<Scalars['uuid']>;
  linkedLocation?: InputMaybe<LocationsObjRelInsertInput>;
  linkedLocationGuid?: InputMaybe<Scalars['uuid']>;
  referringContact?: InputMaybe<ContactsObjRelInsertInput>;
  referringContactGuid?: InputMaybe<Scalars['uuid']>;
  referringJob?: InputMaybe<JobsObjRelInsertInput>;
  referringJobGuid?: InputMaybe<Scalars['uuid']>;
  referringUser?: InputMaybe<UsersObjRelInsertInput>;
  referringUserGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CompanyLeadSourceLinksMaxFields = {
  __typename?: 'CompanyLeadSourceLinksMaxFields';
  attributionDescription?: Maybe<Scalars['String']>;
  companyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  companyLeadSourceLinkGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  linkedAccountGuid?: Maybe<Scalars['uuid']>;
  linkedContactGuid?: Maybe<Scalars['uuid']>;
  linkedJobGuid?: Maybe<Scalars['uuid']>;
  linkedLocationGuid?: Maybe<Scalars['uuid']>;
  referringContactGuid?: Maybe<Scalars['uuid']>;
  referringJobGuid?: Maybe<Scalars['uuid']>;
  referringUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "company_lead_source_links" */
export type CompanyLeadSourceLinksMaxOrderBy = {
  attributionDescription?: InputMaybe<OrderBy>;
  companyLeadSourceGuid?: InputMaybe<OrderBy>;
  companyLeadSourceLinkGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  linkedAccountGuid?: InputMaybe<OrderBy>;
  linkedContactGuid?: InputMaybe<OrderBy>;
  linkedJobGuid?: InputMaybe<OrderBy>;
  linkedLocationGuid?: InputMaybe<OrderBy>;
  referringContactGuid?: InputMaybe<OrderBy>;
  referringJobGuid?: InputMaybe<OrderBy>;
  referringUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CompanyLeadSourceLinksMinFields = {
  __typename?: 'CompanyLeadSourceLinksMinFields';
  attributionDescription?: Maybe<Scalars['String']>;
  companyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  companyLeadSourceLinkGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  linkedAccountGuid?: Maybe<Scalars['uuid']>;
  linkedContactGuid?: Maybe<Scalars['uuid']>;
  linkedJobGuid?: Maybe<Scalars['uuid']>;
  linkedLocationGuid?: Maybe<Scalars['uuid']>;
  referringContactGuid?: Maybe<Scalars['uuid']>;
  referringJobGuid?: Maybe<Scalars['uuid']>;
  referringUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "company_lead_source_links" */
export type CompanyLeadSourceLinksMinOrderBy = {
  attributionDescription?: InputMaybe<OrderBy>;
  companyLeadSourceGuid?: InputMaybe<OrderBy>;
  companyLeadSourceLinkGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  linkedAccountGuid?: InputMaybe<OrderBy>;
  linkedContactGuid?: InputMaybe<OrderBy>;
  linkedJobGuid?: InputMaybe<OrderBy>;
  linkedLocationGuid?: InputMaybe<OrderBy>;
  referringContactGuid?: InputMaybe<OrderBy>;
  referringJobGuid?: InputMaybe<OrderBy>;
  referringUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "company_lead_source_links" */
export type CompanyLeadSourceLinksMutationResponse = {
  __typename?: 'CompanyLeadSourceLinksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyLeadSourceLinks>;
};

/** on_conflict condition type for table "company_lead_source_links" */
export type CompanyLeadSourceLinksOnConflict = {
  constraint: CompanyLeadSourceLinksConstraint;
  updateColumns?: Array<CompanyLeadSourceLinksUpdateColumn>;
  where?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
};

/** Ordering options when selecting data from "company_lead_source_links". */
export type CompanyLeadSourceLinksOrderBy = {
  attributionDescription?: InputMaybe<OrderBy>;
  companyLeadSource?: InputMaybe<CompanyLeadSourcesOrderBy>;
  companyLeadSourceGuid?: InputMaybe<OrderBy>;
  companyLeadSourceLinkGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  linkedAccount?: InputMaybe<AccountsOrderBy>;
  linkedAccountGuid?: InputMaybe<OrderBy>;
  linkedContact?: InputMaybe<ContactsOrderBy>;
  linkedContactGuid?: InputMaybe<OrderBy>;
  linkedJob?: InputMaybe<JobsOrderBy>;
  linkedJobGuid?: InputMaybe<OrderBy>;
  linkedLocation?: InputMaybe<LocationsOrderBy>;
  linkedLocationGuid?: InputMaybe<OrderBy>;
  referringContact?: InputMaybe<ContactsOrderBy>;
  referringContactGuid?: InputMaybe<OrderBy>;
  referringJob?: InputMaybe<JobsOrderBy>;
  referringJobGuid?: InputMaybe<OrderBy>;
  referringUser?: InputMaybe<UsersOrderBy>;
  referringUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_lead_source_links */
export type CompanyLeadSourceLinksPkColumnsInput = {
  companyLeadSourceLinkGuid: Scalars['uuid'];
};

/** select columns of table "company_lead_source_links" */
export type CompanyLeadSourceLinksSelectColumn =
  /** column name */
  | 'attributionDescription'
  /** column name */
  | 'companyLeadSourceGuid'
  /** column name */
  | 'companyLeadSourceLinkGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'linkedAccountGuid'
  /** column name */
  | 'linkedContactGuid'
  /** column name */
  | 'linkedJobGuid'
  /** column name */
  | 'linkedLocationGuid'
  /** column name */
  | 'referringContactGuid'
  /** column name */
  | 'referringJobGuid'
  /** column name */
  | 'referringUserGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "company_lead_source_links" */
export type CompanyLeadSourceLinksSetInput = {
  attributionDescription?: InputMaybe<Scalars['String']>;
  companyLeadSourceGuid?: InputMaybe<Scalars['uuid']>;
  companyLeadSourceLinkGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  linkedAccountGuid?: InputMaybe<Scalars['uuid']>;
  linkedContactGuid?: InputMaybe<Scalars['uuid']>;
  linkedJobGuid?: InputMaybe<Scalars['uuid']>;
  linkedLocationGuid?: InputMaybe<Scalars['uuid']>;
  referringContactGuid?: InputMaybe<Scalars['uuid']>;
  referringJobGuid?: InputMaybe<Scalars['uuid']>;
  referringUserGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "company_lead_source_links" */
export type CompanyLeadSourceLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyLeadSourceLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyLeadSourceLinksStreamCursorValueInput = {
  attributionDescription?: InputMaybe<Scalars['String']>;
  companyLeadSourceGuid?: InputMaybe<Scalars['uuid']>;
  companyLeadSourceLinkGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  linkedAccountGuid?: InputMaybe<Scalars['uuid']>;
  linkedContactGuid?: InputMaybe<Scalars['uuid']>;
  linkedJobGuid?: InputMaybe<Scalars['uuid']>;
  linkedLocationGuid?: InputMaybe<Scalars['uuid']>;
  referringContactGuid?: InputMaybe<Scalars['uuid']>;
  referringJobGuid?: InputMaybe<Scalars['uuid']>;
  referringUserGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "company_lead_source_links" */
export type CompanyLeadSourceLinksUpdateColumn =
  /** column name */
  | 'attributionDescription'
  /** column name */
  | 'companyLeadSourceGuid'
  /** column name */
  | 'companyLeadSourceLinkGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'linkedAccountGuid'
  /** column name */
  | 'linkedContactGuid'
  /** column name */
  | 'linkedJobGuid'
  /** column name */
  | 'linkedLocationGuid'
  /** column name */
  | 'referringContactGuid'
  /** column name */
  | 'referringJobGuid'
  /** column name */
  | 'referringUserGuid'
  /** column name */
  | 'updatedAt';

export type CompanyLeadSourceLinksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyLeadSourceLinksSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyLeadSourceLinksBoolExp;
};

/** columns and relationships of "company_lead_sources" */
export type CompanyLeadSources = {
  __typename?: 'CompanyLeadSources';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  attributionLinkingStrategyOverride?: Maybe<Scalars['String']>;
  attributionPromptOverride?: Maybe<Scalars['String']>;
  /** An object relationship */
  canonicalLeadSource: CanonicalLeadSources;
  canonicalLeadSourceName: Scalars['String'];
  canonicalLeadSourceNameOverride?: Maybe<Scalars['String']>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  companyLeadSourceGuid: Scalars['uuid'];
  /** An array relationship */
  companyLeadSourceLinks: Array<CompanyLeadSourceLinks>;
  /** An aggregate relationship */
  companyLeadSourceLinksAggregate: CompanyLeadSourceLinksAggregate;
  createdAt: Scalars['timestamptz'];
  ordinal?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "company_lead_sources" */
export type CompanyLeadSourcesCompanyLeadSourceLinksArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourceLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourceLinksOrderBy>>;
  where?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
};


/** columns and relationships of "company_lead_sources" */
export type CompanyLeadSourcesCompanyLeadSourceLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourceLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourceLinksOrderBy>>;
  where?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
};

/** aggregated selection of "company_lead_sources" */
export type CompanyLeadSourcesAggregate = {
  __typename?: 'CompanyLeadSourcesAggregate';
  aggregate?: Maybe<CompanyLeadSourcesAggregateFields>;
  nodes: Array<CompanyLeadSources>;
};

export type CompanyLeadSourcesAggregateBoolExp = {
  count?: InputMaybe<CompanyLeadSourcesAggregateBoolExpCount>;
};

/** aggregate fields of "company_lead_sources" */
export type CompanyLeadSourcesAggregateFields = {
  __typename?: 'CompanyLeadSourcesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CompanyLeadSourcesMaxFields>;
  min?: Maybe<CompanyLeadSourcesMinFields>;
};


/** aggregate fields of "company_lead_sources" */
export type CompanyLeadSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyLeadSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company_lead_sources" */
export type CompanyLeadSourcesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CompanyLeadSourcesMaxOrderBy>;
  min?: InputMaybe<CompanyLeadSourcesMinOrderBy>;
};

/** input type for inserting array relation for remote table "company_lead_sources" */
export type CompanyLeadSourcesArrRelInsertInput = {
  data: Array<CompanyLeadSourcesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyLeadSourcesOnConflict>;
};

/** Boolean expression to filter rows from the table "company_lead_sources". All fields are combined with a logical 'AND'. */
export type CompanyLeadSourcesBoolExp = {
  _and?: InputMaybe<Array<CompanyLeadSourcesBoolExp>>;
  _not?: InputMaybe<CompanyLeadSourcesBoolExp>;
  _or?: InputMaybe<Array<CompanyLeadSourcesBoolExp>>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  attributionLinkingStrategyOverride?: InputMaybe<StringComparisonExp>;
  attributionPromptOverride?: InputMaybe<StringComparisonExp>;
  canonicalLeadSource?: InputMaybe<CanonicalLeadSourcesBoolExp>;
  canonicalLeadSourceName?: InputMaybe<StringComparisonExp>;
  canonicalLeadSourceNameOverride?: InputMaybe<StringComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  companyLeadSourceGuid?: InputMaybe<UuidComparisonExp>;
  companyLeadSourceLinks?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
  companyLeadSourceLinksAggregate?: InputMaybe<CompanyLeadSourceLinksAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  ordinal?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "company_lead_sources" */
export type CompanyLeadSourcesConstraint =
  /** unique or primary key constraint on columns "company_lead_source_guid" */
  | 'company_lead_sources_pkey';

/** input type for inserting data into table "company_lead_sources" */
export type CompanyLeadSourcesInsertInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  attributionLinkingStrategyOverride?: InputMaybe<Scalars['String']>;
  attributionPromptOverride?: InputMaybe<Scalars['String']>;
  canonicalLeadSource?: InputMaybe<CanonicalLeadSourcesObjRelInsertInput>;
  canonicalLeadSourceName?: InputMaybe<Scalars['String']>;
  canonicalLeadSourceNameOverride?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyLeadSourceGuid?: InputMaybe<Scalars['uuid']>;
  companyLeadSourceLinks?: InputMaybe<CompanyLeadSourceLinksArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ordinal?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CompanyLeadSourcesMaxFields = {
  __typename?: 'CompanyLeadSourcesMaxFields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  attributionLinkingStrategyOverride?: Maybe<Scalars['String']>;
  attributionPromptOverride?: Maybe<Scalars['String']>;
  canonicalLeadSourceName?: Maybe<Scalars['String']>;
  canonicalLeadSourceNameOverride?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  companyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  ordinal?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "company_lead_sources" */
export type CompanyLeadSourcesMaxOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  attributionLinkingStrategyOverride?: InputMaybe<OrderBy>;
  attributionPromptOverride?: InputMaybe<OrderBy>;
  canonicalLeadSourceName?: InputMaybe<OrderBy>;
  canonicalLeadSourceNameOverride?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  companyLeadSourceGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CompanyLeadSourcesMinFields = {
  __typename?: 'CompanyLeadSourcesMinFields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  attributionLinkingStrategyOverride?: Maybe<Scalars['String']>;
  attributionPromptOverride?: Maybe<Scalars['String']>;
  canonicalLeadSourceName?: Maybe<Scalars['String']>;
  canonicalLeadSourceNameOverride?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  companyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  ordinal?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "company_lead_sources" */
export type CompanyLeadSourcesMinOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  attributionLinkingStrategyOverride?: InputMaybe<OrderBy>;
  attributionPromptOverride?: InputMaybe<OrderBy>;
  canonicalLeadSourceName?: InputMaybe<OrderBy>;
  canonicalLeadSourceNameOverride?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  companyLeadSourceGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "company_lead_sources" */
export type CompanyLeadSourcesMutationResponse = {
  __typename?: 'CompanyLeadSourcesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyLeadSources>;
};

/** input type for inserting object relation for remote table "company_lead_sources" */
export type CompanyLeadSourcesObjRelInsertInput = {
  data: CompanyLeadSourcesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyLeadSourcesOnConflict>;
};

/** on_conflict condition type for table "company_lead_sources" */
export type CompanyLeadSourcesOnConflict = {
  constraint: CompanyLeadSourcesConstraint;
  updateColumns?: Array<CompanyLeadSourcesUpdateColumn>;
  where?: InputMaybe<CompanyLeadSourcesBoolExp>;
};

/** Ordering options when selecting data from "company_lead_sources". */
export type CompanyLeadSourcesOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  attributionLinkingStrategyOverride?: InputMaybe<OrderBy>;
  attributionPromptOverride?: InputMaybe<OrderBy>;
  canonicalLeadSource?: InputMaybe<CanonicalLeadSourcesOrderBy>;
  canonicalLeadSourceName?: InputMaybe<OrderBy>;
  canonicalLeadSourceNameOverride?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  companyLeadSourceGuid?: InputMaybe<OrderBy>;
  companyLeadSourceLinksAggregate?: InputMaybe<CompanyLeadSourceLinksAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  ordinal?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_lead_sources */
export type CompanyLeadSourcesPkColumnsInput = {
  companyLeadSourceGuid: Scalars['uuid'];
};

/** select columns of table "company_lead_sources" */
export type CompanyLeadSourcesSelectColumn =
  /** column name */
  | 'archivedAt'
  /** column name */
  | 'attributionLinkingStrategyOverride'
  /** column name */
  | 'attributionPromptOverride'
  /** column name */
  | 'canonicalLeadSourceName'
  /** column name */
  | 'canonicalLeadSourceNameOverride'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'companyLeadSourceGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'ordinal'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "company_lead_sources" */
export type CompanyLeadSourcesSetInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  attributionLinkingStrategyOverride?: InputMaybe<Scalars['String']>;
  attributionPromptOverride?: InputMaybe<Scalars['String']>;
  canonicalLeadSourceName?: InputMaybe<Scalars['String']>;
  canonicalLeadSourceNameOverride?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyLeadSourceGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ordinal?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "company_lead_sources" */
export type CompanyLeadSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyLeadSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyLeadSourcesStreamCursorValueInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  attributionLinkingStrategyOverride?: InputMaybe<Scalars['String']>;
  attributionPromptOverride?: InputMaybe<Scalars['String']>;
  canonicalLeadSourceName?: InputMaybe<Scalars['String']>;
  canonicalLeadSourceNameOverride?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyLeadSourceGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ordinal?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "company_lead_sources" */
export type CompanyLeadSourcesUpdateColumn =
  /** column name */
  | 'archivedAt'
  /** column name */
  | 'attributionLinkingStrategyOverride'
  /** column name */
  | 'attributionPromptOverride'
  /** column name */
  | 'canonicalLeadSourceName'
  /** column name */
  | 'canonicalLeadSourceNameOverride'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'companyLeadSourceGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'ordinal'
  /** column name */
  | 'updatedAt';

export type CompanyLeadSourcesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyLeadSourcesSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyLeadSourcesBoolExp;
};

/** columns and relationships of "company_notification_settings" */
export type CompanyNotificationSettings = {
  __typename?: 'CompanyNotificationSettings';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  endOfVisitSendReviewLinkCount?: Maybe<Scalars['Int']>;
  endOfVisitSendReviewLinkEnabled?: Maybe<Scalars['Boolean']>;
  endOfVisitSendReviewLinkFrequency: Scalars['ReminderFrequency'];
  endOfVisitSendReviewLinkType: Scalars['ReviewType'];
  estimateAcceptNotifyCreator?: Maybe<Scalars['Boolean']>;
  estimateAcceptNotifyEmail?: Maybe<Scalars['String']>;
  estimateAcceptNotifyUserGuids?: Maybe<Array<Scalars['String']>>;
  estimateReminderCount?: Maybe<Scalars['Int']>;
  estimateReminderFrequency: Scalars['ReminderFrequency'];
  estimateReviewedNotifyCreator?: Maybe<Scalars['Boolean']>;
  estimateReviewedNotifyUserGuids?: Maybe<Array<Scalars['String']>>;
  /** An array relationship */
  estimates: Array<Estimates>;
  /** An aggregate relationship */
  estimatesAggregate: EstimatesAggregate;
  invoicePaymentReminderCount?: Maybe<Scalars['Int']>;
  invoicePaymentReminderFrequency: Scalars['ReminderFrequency'];
  jobLeadCreatedEmail?: Maybe<Scalars['String']>;
  jobLeadCreatedUserGuids?: Maybe<Array<Scalars['String']>>;
  lapsedPaymentMaintenancePlanNotifyEmail?: Maybe<Scalars['String']>;
  lapsedPaymentMaintenancePlanUserGuids?: Maybe<Array<Scalars['String']>>;
  materialRestockReportEmail?: Maybe<Scalars['String']>;
  materialRestockReportUserGuids?: Maybe<Array<Scalars['String']>>;
  paymentFailedNotifyCreator?: Maybe<Scalars['Boolean']>;
  paymentFailedNotifyEmail?: Maybe<Scalars['String']>;
  paymentFailedNotifyUserGuids?: Maybe<Array<Scalars['String']>>;
  replyToEmail?: Maybe<Scalars['String']>;
};


/** columns and relationships of "company_notification_settings" */
export type CompanyNotificationSettingsEstimatesArgs = {
  distinctOn?: InputMaybe<Array<EstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesOrderBy>>;
  where?: InputMaybe<EstimatesBoolExp>;
};


/** columns and relationships of "company_notification_settings" */
export type CompanyNotificationSettingsEstimatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesOrderBy>>;
  where?: InputMaybe<EstimatesBoolExp>;
};

/** aggregated selection of "company_notification_settings" */
export type CompanyNotificationSettingsAggregate = {
  __typename?: 'CompanyNotificationSettingsAggregate';
  aggregate?: Maybe<CompanyNotificationSettingsAggregateFields>;
  nodes: Array<CompanyNotificationSettings>;
};

export type CompanyNotificationSettingsAggregateBoolExp = {
  bool_and?: InputMaybe<CompanyNotificationSettingsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<CompanyNotificationSettingsAggregateBoolExpBool_Or>;
  count?: InputMaybe<CompanyNotificationSettingsAggregateBoolExpCount>;
};

/** aggregate fields of "company_notification_settings" */
export type CompanyNotificationSettingsAggregateFields = {
  __typename?: 'CompanyNotificationSettingsAggregateFields';
  avg?: Maybe<CompanyNotificationSettingsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompanyNotificationSettingsMaxFields>;
  min?: Maybe<CompanyNotificationSettingsMinFields>;
  stddev?: Maybe<CompanyNotificationSettingsStddevFields>;
  stddevPop?: Maybe<CompanyNotificationSettingsStddevPopFields>;
  stddevSamp?: Maybe<CompanyNotificationSettingsStddevSampFields>;
  sum?: Maybe<CompanyNotificationSettingsSumFields>;
  varPop?: Maybe<CompanyNotificationSettingsVarPopFields>;
  varSamp?: Maybe<CompanyNotificationSettingsVarSampFields>;
  variance?: Maybe<CompanyNotificationSettingsVarianceFields>;
};


/** aggregate fields of "company_notification_settings" */
export type CompanyNotificationSettingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyNotificationSettingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company_notification_settings" */
export type CompanyNotificationSettingsAggregateOrderBy = {
  avg?: InputMaybe<CompanyNotificationSettingsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CompanyNotificationSettingsMaxOrderBy>;
  min?: InputMaybe<CompanyNotificationSettingsMinOrderBy>;
  stddev?: InputMaybe<CompanyNotificationSettingsStddevOrderBy>;
  stddevPop?: InputMaybe<CompanyNotificationSettingsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CompanyNotificationSettingsStddevSampOrderBy>;
  sum?: InputMaybe<CompanyNotificationSettingsSumOrderBy>;
  varPop?: InputMaybe<CompanyNotificationSettingsVarPopOrderBy>;
  varSamp?: InputMaybe<CompanyNotificationSettingsVarSampOrderBy>;
  variance?: InputMaybe<CompanyNotificationSettingsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "company_notification_settings" */
export type CompanyNotificationSettingsArrRelInsertInput = {
  data: Array<CompanyNotificationSettingsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyNotificationSettingsOnConflict>;
};

/** aggregate avg on columns */
export type CompanyNotificationSettingsAvgFields = {
  __typename?: 'CompanyNotificationSettingsAvgFields';
  endOfVisitSendReviewLinkCount?: Maybe<Scalars['Float']>;
  estimateReminderCount?: Maybe<Scalars['Float']>;
  invoicePaymentReminderCount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "company_notification_settings" */
export type CompanyNotificationSettingsAvgOrderBy = {
  endOfVisitSendReviewLinkCount?: InputMaybe<OrderBy>;
  estimateReminderCount?: InputMaybe<OrderBy>;
  invoicePaymentReminderCount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "company_notification_settings". All fields are combined with a logical 'AND'. */
export type CompanyNotificationSettingsBoolExp = {
  _and?: InputMaybe<Array<CompanyNotificationSettingsBoolExp>>;
  _not?: InputMaybe<CompanyNotificationSettingsBoolExp>;
  _or?: InputMaybe<Array<CompanyNotificationSettingsBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  endOfVisitSendReviewLinkCount?: InputMaybe<IntComparisonExp>;
  endOfVisitSendReviewLinkEnabled?: InputMaybe<BooleanComparisonExp>;
  endOfVisitSendReviewLinkFrequency?: InputMaybe<Scalars['ReminderFrequencyComparisonExp']>;
  endOfVisitSendReviewLinkType?: InputMaybe<Scalars['ReviewTypeComparisonExp']>;
  estimateAcceptNotifyCreator?: InputMaybe<BooleanComparisonExp>;
  estimateAcceptNotifyEmail?: InputMaybe<StringComparisonExp>;
  estimateAcceptNotifyUserGuids?: InputMaybe<StringArrayComparisonExp>;
  estimateReminderCount?: InputMaybe<IntComparisonExp>;
  estimateReminderFrequency?: InputMaybe<Scalars['ReminderFrequencyComparisonExp']>;
  estimateReviewedNotifyCreator?: InputMaybe<BooleanComparisonExp>;
  estimateReviewedNotifyUserGuids?: InputMaybe<StringArrayComparisonExp>;
  estimates?: InputMaybe<EstimatesBoolExp>;
  estimatesAggregate?: InputMaybe<EstimatesAggregateBoolExp>;
  invoicePaymentReminderCount?: InputMaybe<IntComparisonExp>;
  invoicePaymentReminderFrequency?: InputMaybe<Scalars['ReminderFrequencyComparisonExp']>;
  jobLeadCreatedEmail?: InputMaybe<StringComparisonExp>;
  jobLeadCreatedUserGuids?: InputMaybe<StringArrayComparisonExp>;
  lapsedPaymentMaintenancePlanNotifyEmail?: InputMaybe<StringComparisonExp>;
  lapsedPaymentMaintenancePlanUserGuids?: InputMaybe<StringArrayComparisonExp>;
  materialRestockReportEmail?: InputMaybe<StringComparisonExp>;
  materialRestockReportUserGuids?: InputMaybe<StringArrayComparisonExp>;
  paymentFailedNotifyCreator?: InputMaybe<BooleanComparisonExp>;
  paymentFailedNotifyEmail?: InputMaybe<StringComparisonExp>;
  paymentFailedNotifyUserGuids?: InputMaybe<StringArrayComparisonExp>;
  replyToEmail?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "company_notification_settings" */
export type CompanyNotificationSettingsConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'company_notification_settings_pkey';

/** input type for incrementing numeric columns in table "company_notification_settings" */
export type CompanyNotificationSettingsIncInput = {
  endOfVisitSendReviewLinkCount?: InputMaybe<Scalars['Int']>;
  estimateReminderCount?: InputMaybe<Scalars['Int']>;
  invoicePaymentReminderCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "company_notification_settings" */
export type CompanyNotificationSettingsInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  endOfVisitSendReviewLinkCount?: InputMaybe<Scalars['Int']>;
  endOfVisitSendReviewLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  endOfVisitSendReviewLinkFrequency?: InputMaybe<Scalars['ReminderFrequency']>;
  endOfVisitSendReviewLinkType?: InputMaybe<Scalars['ReviewType']>;
  estimateAcceptNotifyCreator?: InputMaybe<Scalars['Boolean']>;
  estimateAcceptNotifyEmail?: InputMaybe<Scalars['String']>;
  estimateAcceptNotifyUserGuids?: InputMaybe<Array<Scalars['String']>>;
  estimateReminderCount?: InputMaybe<Scalars['Int']>;
  estimateReminderFrequency?: InputMaybe<Scalars['ReminderFrequency']>;
  estimateReviewedNotifyCreator?: InputMaybe<Scalars['Boolean']>;
  estimateReviewedNotifyUserGuids?: InputMaybe<Array<Scalars['String']>>;
  estimates?: InputMaybe<EstimatesArrRelInsertInput>;
  invoicePaymentReminderCount?: InputMaybe<Scalars['Int']>;
  invoicePaymentReminderFrequency?: InputMaybe<Scalars['ReminderFrequency']>;
  jobLeadCreatedEmail?: InputMaybe<Scalars['String']>;
  jobLeadCreatedUserGuids?: InputMaybe<Array<Scalars['String']>>;
  lapsedPaymentMaintenancePlanNotifyEmail?: InputMaybe<Scalars['String']>;
  lapsedPaymentMaintenancePlanUserGuids?: InputMaybe<Array<Scalars['String']>>;
  materialRestockReportEmail?: InputMaybe<Scalars['String']>;
  materialRestockReportUserGuids?: InputMaybe<Array<Scalars['String']>>;
  paymentFailedNotifyCreator?: InputMaybe<Scalars['Boolean']>;
  paymentFailedNotifyEmail?: InputMaybe<Scalars['String']>;
  paymentFailedNotifyUserGuids?: InputMaybe<Array<Scalars['String']>>;
  replyToEmail?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CompanyNotificationSettingsMaxFields = {
  __typename?: 'CompanyNotificationSettingsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  endOfVisitSendReviewLinkCount?: Maybe<Scalars['Int']>;
  endOfVisitSendReviewLinkFrequency?: Maybe<Scalars['ReminderFrequency']>;
  endOfVisitSendReviewLinkType?: Maybe<Scalars['ReviewType']>;
  estimateAcceptNotifyEmail?: Maybe<Scalars['String']>;
  estimateAcceptNotifyUserGuids?: Maybe<Array<Scalars['String']>>;
  estimateReminderCount?: Maybe<Scalars['Int']>;
  estimateReminderFrequency?: Maybe<Scalars['ReminderFrequency']>;
  estimateReviewedNotifyUserGuids?: Maybe<Array<Scalars['String']>>;
  invoicePaymentReminderCount?: Maybe<Scalars['Int']>;
  invoicePaymentReminderFrequency?: Maybe<Scalars['ReminderFrequency']>;
  jobLeadCreatedEmail?: Maybe<Scalars['String']>;
  jobLeadCreatedUserGuids?: Maybe<Array<Scalars['String']>>;
  lapsedPaymentMaintenancePlanNotifyEmail?: Maybe<Scalars['String']>;
  lapsedPaymentMaintenancePlanUserGuids?: Maybe<Array<Scalars['String']>>;
  materialRestockReportEmail?: Maybe<Scalars['String']>;
  materialRestockReportUserGuids?: Maybe<Array<Scalars['String']>>;
  paymentFailedNotifyEmail?: Maybe<Scalars['String']>;
  paymentFailedNotifyUserGuids?: Maybe<Array<Scalars['String']>>;
  replyToEmail?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "company_notification_settings" */
export type CompanyNotificationSettingsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  endOfVisitSendReviewLinkCount?: InputMaybe<OrderBy>;
  endOfVisitSendReviewLinkFrequency?: InputMaybe<OrderBy>;
  endOfVisitSendReviewLinkType?: InputMaybe<OrderBy>;
  estimateAcceptNotifyEmail?: InputMaybe<OrderBy>;
  estimateAcceptNotifyUserGuids?: InputMaybe<OrderBy>;
  estimateReminderCount?: InputMaybe<OrderBy>;
  estimateReminderFrequency?: InputMaybe<OrderBy>;
  estimateReviewedNotifyUserGuids?: InputMaybe<OrderBy>;
  invoicePaymentReminderCount?: InputMaybe<OrderBy>;
  invoicePaymentReminderFrequency?: InputMaybe<OrderBy>;
  jobLeadCreatedEmail?: InputMaybe<OrderBy>;
  jobLeadCreatedUserGuids?: InputMaybe<OrderBy>;
  lapsedPaymentMaintenancePlanNotifyEmail?: InputMaybe<OrderBy>;
  lapsedPaymentMaintenancePlanUserGuids?: InputMaybe<OrderBy>;
  materialRestockReportEmail?: InputMaybe<OrderBy>;
  materialRestockReportUserGuids?: InputMaybe<OrderBy>;
  paymentFailedNotifyEmail?: InputMaybe<OrderBy>;
  paymentFailedNotifyUserGuids?: InputMaybe<OrderBy>;
  replyToEmail?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CompanyNotificationSettingsMinFields = {
  __typename?: 'CompanyNotificationSettingsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  endOfVisitSendReviewLinkCount?: Maybe<Scalars['Int']>;
  endOfVisitSendReviewLinkFrequency?: Maybe<Scalars['ReminderFrequency']>;
  endOfVisitSendReviewLinkType?: Maybe<Scalars['ReviewType']>;
  estimateAcceptNotifyEmail?: Maybe<Scalars['String']>;
  estimateAcceptNotifyUserGuids?: Maybe<Array<Scalars['String']>>;
  estimateReminderCount?: Maybe<Scalars['Int']>;
  estimateReminderFrequency?: Maybe<Scalars['ReminderFrequency']>;
  estimateReviewedNotifyUserGuids?: Maybe<Array<Scalars['String']>>;
  invoicePaymentReminderCount?: Maybe<Scalars['Int']>;
  invoicePaymentReminderFrequency?: Maybe<Scalars['ReminderFrequency']>;
  jobLeadCreatedEmail?: Maybe<Scalars['String']>;
  jobLeadCreatedUserGuids?: Maybe<Array<Scalars['String']>>;
  lapsedPaymentMaintenancePlanNotifyEmail?: Maybe<Scalars['String']>;
  lapsedPaymentMaintenancePlanUserGuids?: Maybe<Array<Scalars['String']>>;
  materialRestockReportEmail?: Maybe<Scalars['String']>;
  materialRestockReportUserGuids?: Maybe<Array<Scalars['String']>>;
  paymentFailedNotifyEmail?: Maybe<Scalars['String']>;
  paymentFailedNotifyUserGuids?: Maybe<Array<Scalars['String']>>;
  replyToEmail?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "company_notification_settings" */
export type CompanyNotificationSettingsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  endOfVisitSendReviewLinkCount?: InputMaybe<OrderBy>;
  endOfVisitSendReviewLinkFrequency?: InputMaybe<OrderBy>;
  endOfVisitSendReviewLinkType?: InputMaybe<OrderBy>;
  estimateAcceptNotifyEmail?: InputMaybe<OrderBy>;
  estimateAcceptNotifyUserGuids?: InputMaybe<OrderBy>;
  estimateReminderCount?: InputMaybe<OrderBy>;
  estimateReminderFrequency?: InputMaybe<OrderBy>;
  estimateReviewedNotifyUserGuids?: InputMaybe<OrderBy>;
  invoicePaymentReminderCount?: InputMaybe<OrderBy>;
  invoicePaymentReminderFrequency?: InputMaybe<OrderBy>;
  jobLeadCreatedEmail?: InputMaybe<OrderBy>;
  jobLeadCreatedUserGuids?: InputMaybe<OrderBy>;
  lapsedPaymentMaintenancePlanNotifyEmail?: InputMaybe<OrderBy>;
  lapsedPaymentMaintenancePlanUserGuids?: InputMaybe<OrderBy>;
  materialRestockReportEmail?: InputMaybe<OrderBy>;
  materialRestockReportUserGuids?: InputMaybe<OrderBy>;
  paymentFailedNotifyEmail?: InputMaybe<OrderBy>;
  paymentFailedNotifyUserGuids?: InputMaybe<OrderBy>;
  replyToEmail?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "company_notification_settings" */
export type CompanyNotificationSettingsMutationResponse = {
  __typename?: 'CompanyNotificationSettingsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyNotificationSettings>;
};

/** input type for inserting object relation for remote table "company_notification_settings" */
export type CompanyNotificationSettingsObjRelInsertInput = {
  data: CompanyNotificationSettingsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyNotificationSettingsOnConflict>;
};

/** on_conflict condition type for table "company_notification_settings" */
export type CompanyNotificationSettingsOnConflict = {
  constraint: CompanyNotificationSettingsConstraint;
  updateColumns?: Array<CompanyNotificationSettingsUpdateColumn>;
  where?: InputMaybe<CompanyNotificationSettingsBoolExp>;
};

/** Ordering options when selecting data from "company_notification_settings". */
export type CompanyNotificationSettingsOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  endOfVisitSendReviewLinkCount?: InputMaybe<OrderBy>;
  endOfVisitSendReviewLinkEnabled?: InputMaybe<OrderBy>;
  endOfVisitSendReviewLinkFrequency?: InputMaybe<OrderBy>;
  endOfVisitSendReviewLinkType?: InputMaybe<OrderBy>;
  estimateAcceptNotifyCreator?: InputMaybe<OrderBy>;
  estimateAcceptNotifyEmail?: InputMaybe<OrderBy>;
  estimateAcceptNotifyUserGuids?: InputMaybe<OrderBy>;
  estimateReminderCount?: InputMaybe<OrderBy>;
  estimateReminderFrequency?: InputMaybe<OrderBy>;
  estimateReviewedNotifyCreator?: InputMaybe<OrderBy>;
  estimateReviewedNotifyUserGuids?: InputMaybe<OrderBy>;
  estimatesAggregate?: InputMaybe<EstimatesAggregateOrderBy>;
  invoicePaymentReminderCount?: InputMaybe<OrderBy>;
  invoicePaymentReminderFrequency?: InputMaybe<OrderBy>;
  jobLeadCreatedEmail?: InputMaybe<OrderBy>;
  jobLeadCreatedUserGuids?: InputMaybe<OrderBy>;
  lapsedPaymentMaintenancePlanNotifyEmail?: InputMaybe<OrderBy>;
  lapsedPaymentMaintenancePlanUserGuids?: InputMaybe<OrderBy>;
  materialRestockReportEmail?: InputMaybe<OrderBy>;
  materialRestockReportUserGuids?: InputMaybe<OrderBy>;
  paymentFailedNotifyCreator?: InputMaybe<OrderBy>;
  paymentFailedNotifyEmail?: InputMaybe<OrderBy>;
  paymentFailedNotifyUserGuids?: InputMaybe<OrderBy>;
  replyToEmail?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_notification_settings */
export type CompanyNotificationSettingsPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "company_notification_settings" */
export type CompanyNotificationSettingsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'endOfVisitSendReviewLinkCount'
  /** column name */
  | 'endOfVisitSendReviewLinkEnabled'
  /** column name */
  | 'endOfVisitSendReviewLinkFrequency'
  /** column name */
  | 'endOfVisitSendReviewLinkType'
  /** column name */
  | 'estimateAcceptNotifyCreator'
  /** column name */
  | 'estimateAcceptNotifyEmail'
  /** column name */
  | 'estimateAcceptNotifyUserGuids'
  /** column name */
  | 'estimateReminderCount'
  /** column name */
  | 'estimateReminderFrequency'
  /** column name */
  | 'estimateReviewedNotifyCreator'
  /** column name */
  | 'estimateReviewedNotifyUserGuids'
  /** column name */
  | 'invoicePaymentReminderCount'
  /** column name */
  | 'invoicePaymentReminderFrequency'
  /** column name */
  | 'jobLeadCreatedEmail'
  /** column name */
  | 'jobLeadCreatedUserGuids'
  /** column name */
  | 'lapsedPaymentMaintenancePlanNotifyEmail'
  /** column name */
  | 'lapsedPaymentMaintenancePlanUserGuids'
  /** column name */
  | 'materialRestockReportEmail'
  /** column name */
  | 'materialRestockReportUserGuids'
  /** column name */
  | 'paymentFailedNotifyCreator'
  /** column name */
  | 'paymentFailedNotifyEmail'
  /** column name */
  | 'paymentFailedNotifyUserGuids'
  /** column name */
  | 'replyToEmail';

/** select "companyNotificationSettingsAggregateBoolExpBool_andArgumentsColumns" columns of table "company_notification_settings" */
export type CompanyNotificationSettingsSelectColumnCompanyNotificationSettingsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'endOfVisitSendReviewLinkEnabled'
  /** column name */
  | 'estimateAcceptNotifyCreator'
  /** column name */
  | 'estimateReviewedNotifyCreator'
  /** column name */
  | 'paymentFailedNotifyCreator';

/** select "companyNotificationSettingsAggregateBoolExpBool_orArgumentsColumns" columns of table "company_notification_settings" */
export type CompanyNotificationSettingsSelectColumnCompanyNotificationSettingsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'endOfVisitSendReviewLinkEnabled'
  /** column name */
  | 'estimateAcceptNotifyCreator'
  /** column name */
  | 'estimateReviewedNotifyCreator'
  /** column name */
  | 'paymentFailedNotifyCreator';

/** input type for updating data in table "company_notification_settings" */
export type CompanyNotificationSettingsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  endOfVisitSendReviewLinkCount?: InputMaybe<Scalars['Int']>;
  endOfVisitSendReviewLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  endOfVisitSendReviewLinkFrequency?: InputMaybe<Scalars['ReminderFrequency']>;
  endOfVisitSendReviewLinkType?: InputMaybe<Scalars['ReviewType']>;
  estimateAcceptNotifyCreator?: InputMaybe<Scalars['Boolean']>;
  estimateAcceptNotifyEmail?: InputMaybe<Scalars['String']>;
  estimateAcceptNotifyUserGuids?: InputMaybe<Array<Scalars['String']>>;
  estimateReminderCount?: InputMaybe<Scalars['Int']>;
  estimateReminderFrequency?: InputMaybe<Scalars['ReminderFrequency']>;
  estimateReviewedNotifyCreator?: InputMaybe<Scalars['Boolean']>;
  estimateReviewedNotifyUserGuids?: InputMaybe<Array<Scalars['String']>>;
  invoicePaymentReminderCount?: InputMaybe<Scalars['Int']>;
  invoicePaymentReminderFrequency?: InputMaybe<Scalars['ReminderFrequency']>;
  jobLeadCreatedEmail?: InputMaybe<Scalars['String']>;
  jobLeadCreatedUserGuids?: InputMaybe<Array<Scalars['String']>>;
  lapsedPaymentMaintenancePlanNotifyEmail?: InputMaybe<Scalars['String']>;
  lapsedPaymentMaintenancePlanUserGuids?: InputMaybe<Array<Scalars['String']>>;
  materialRestockReportEmail?: InputMaybe<Scalars['String']>;
  materialRestockReportUserGuids?: InputMaybe<Array<Scalars['String']>>;
  paymentFailedNotifyCreator?: InputMaybe<Scalars['Boolean']>;
  paymentFailedNotifyEmail?: InputMaybe<Scalars['String']>;
  paymentFailedNotifyUserGuids?: InputMaybe<Array<Scalars['String']>>;
  replyToEmail?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type CompanyNotificationSettingsStddevFields = {
  __typename?: 'CompanyNotificationSettingsStddevFields';
  endOfVisitSendReviewLinkCount?: Maybe<Scalars['Float']>;
  estimateReminderCount?: Maybe<Scalars['Float']>;
  invoicePaymentReminderCount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "company_notification_settings" */
export type CompanyNotificationSettingsStddevOrderBy = {
  endOfVisitSendReviewLinkCount?: InputMaybe<OrderBy>;
  estimateReminderCount?: InputMaybe<OrderBy>;
  invoicePaymentReminderCount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type CompanyNotificationSettingsStddevPopFields = {
  __typename?: 'CompanyNotificationSettingsStddevPopFields';
  endOfVisitSendReviewLinkCount?: Maybe<Scalars['Float']>;
  estimateReminderCount?: Maybe<Scalars['Float']>;
  invoicePaymentReminderCount?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "company_notification_settings" */
export type CompanyNotificationSettingsStddevPopOrderBy = {
  endOfVisitSendReviewLinkCount?: InputMaybe<OrderBy>;
  estimateReminderCount?: InputMaybe<OrderBy>;
  invoicePaymentReminderCount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type CompanyNotificationSettingsStddevSampFields = {
  __typename?: 'CompanyNotificationSettingsStddevSampFields';
  endOfVisitSendReviewLinkCount?: Maybe<Scalars['Float']>;
  estimateReminderCount?: Maybe<Scalars['Float']>;
  invoicePaymentReminderCount?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "company_notification_settings" */
export type CompanyNotificationSettingsStddevSampOrderBy = {
  endOfVisitSendReviewLinkCount?: InputMaybe<OrderBy>;
  estimateReminderCount?: InputMaybe<OrderBy>;
  invoicePaymentReminderCount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "company_notification_settings" */
export type CompanyNotificationSettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyNotificationSettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyNotificationSettingsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  endOfVisitSendReviewLinkCount?: InputMaybe<Scalars['Int']>;
  endOfVisitSendReviewLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  endOfVisitSendReviewLinkFrequency?: InputMaybe<Scalars['ReminderFrequency']>;
  endOfVisitSendReviewLinkType?: InputMaybe<Scalars['ReviewType']>;
  estimateAcceptNotifyCreator?: InputMaybe<Scalars['Boolean']>;
  estimateAcceptNotifyEmail?: InputMaybe<Scalars['String']>;
  estimateAcceptNotifyUserGuids?: InputMaybe<Array<Scalars['String']>>;
  estimateReminderCount?: InputMaybe<Scalars['Int']>;
  estimateReminderFrequency?: InputMaybe<Scalars['ReminderFrequency']>;
  estimateReviewedNotifyCreator?: InputMaybe<Scalars['Boolean']>;
  estimateReviewedNotifyUserGuids?: InputMaybe<Array<Scalars['String']>>;
  invoicePaymentReminderCount?: InputMaybe<Scalars['Int']>;
  invoicePaymentReminderFrequency?: InputMaybe<Scalars['ReminderFrequency']>;
  jobLeadCreatedEmail?: InputMaybe<Scalars['String']>;
  jobLeadCreatedUserGuids?: InputMaybe<Array<Scalars['String']>>;
  lapsedPaymentMaintenancePlanNotifyEmail?: InputMaybe<Scalars['String']>;
  lapsedPaymentMaintenancePlanUserGuids?: InputMaybe<Array<Scalars['String']>>;
  materialRestockReportEmail?: InputMaybe<Scalars['String']>;
  materialRestockReportUserGuids?: InputMaybe<Array<Scalars['String']>>;
  paymentFailedNotifyCreator?: InputMaybe<Scalars['Boolean']>;
  paymentFailedNotifyEmail?: InputMaybe<Scalars['String']>;
  paymentFailedNotifyUserGuids?: InputMaybe<Array<Scalars['String']>>;
  replyToEmail?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type CompanyNotificationSettingsSumFields = {
  __typename?: 'CompanyNotificationSettingsSumFields';
  endOfVisitSendReviewLinkCount?: Maybe<Scalars['Int']>;
  estimateReminderCount?: Maybe<Scalars['Int']>;
  invoicePaymentReminderCount?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "company_notification_settings" */
export type CompanyNotificationSettingsSumOrderBy = {
  endOfVisitSendReviewLinkCount?: InputMaybe<OrderBy>;
  estimateReminderCount?: InputMaybe<OrderBy>;
  invoicePaymentReminderCount?: InputMaybe<OrderBy>;
};

/** update columns of table "company_notification_settings" */
export type CompanyNotificationSettingsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'endOfVisitSendReviewLinkCount'
  /** column name */
  | 'endOfVisitSendReviewLinkEnabled'
  /** column name */
  | 'endOfVisitSendReviewLinkFrequency'
  /** column name */
  | 'endOfVisitSendReviewLinkType'
  /** column name */
  | 'estimateAcceptNotifyCreator'
  /** column name */
  | 'estimateAcceptNotifyEmail'
  /** column name */
  | 'estimateAcceptNotifyUserGuids'
  /** column name */
  | 'estimateReminderCount'
  /** column name */
  | 'estimateReminderFrequency'
  /** column name */
  | 'estimateReviewedNotifyCreator'
  /** column name */
  | 'estimateReviewedNotifyUserGuids'
  /** column name */
  | 'invoicePaymentReminderCount'
  /** column name */
  | 'invoicePaymentReminderFrequency'
  /** column name */
  | 'jobLeadCreatedEmail'
  /** column name */
  | 'jobLeadCreatedUserGuids'
  /** column name */
  | 'lapsedPaymentMaintenancePlanNotifyEmail'
  /** column name */
  | 'lapsedPaymentMaintenancePlanUserGuids'
  /** column name */
  | 'materialRestockReportEmail'
  /** column name */
  | 'materialRestockReportUserGuids'
  /** column name */
  | 'paymentFailedNotifyCreator'
  /** column name */
  | 'paymentFailedNotifyEmail'
  /** column name */
  | 'paymentFailedNotifyUserGuids'
  /** column name */
  | 'replyToEmail';

export type CompanyNotificationSettingsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompanyNotificationSettingsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyNotificationSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyNotificationSettingsBoolExp;
};

/** aggregate varPop on columns */
export type CompanyNotificationSettingsVarPopFields = {
  __typename?: 'CompanyNotificationSettingsVarPopFields';
  endOfVisitSendReviewLinkCount?: Maybe<Scalars['Float']>;
  estimateReminderCount?: Maybe<Scalars['Float']>;
  invoicePaymentReminderCount?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "company_notification_settings" */
export type CompanyNotificationSettingsVarPopOrderBy = {
  endOfVisitSendReviewLinkCount?: InputMaybe<OrderBy>;
  estimateReminderCount?: InputMaybe<OrderBy>;
  invoicePaymentReminderCount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type CompanyNotificationSettingsVarSampFields = {
  __typename?: 'CompanyNotificationSettingsVarSampFields';
  endOfVisitSendReviewLinkCount?: Maybe<Scalars['Float']>;
  estimateReminderCount?: Maybe<Scalars['Float']>;
  invoicePaymentReminderCount?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "company_notification_settings" */
export type CompanyNotificationSettingsVarSampOrderBy = {
  endOfVisitSendReviewLinkCount?: InputMaybe<OrderBy>;
  estimateReminderCount?: InputMaybe<OrderBy>;
  invoicePaymentReminderCount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CompanyNotificationSettingsVarianceFields = {
  __typename?: 'CompanyNotificationSettingsVarianceFields';
  endOfVisitSendReviewLinkCount?: Maybe<Scalars['Float']>;
  estimateReminderCount?: Maybe<Scalars['Float']>;
  invoicePaymentReminderCount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "company_notification_settings" */
export type CompanyNotificationSettingsVarianceOrderBy = {
  endOfVisitSendReviewLinkCount?: InputMaybe<OrderBy>;
  estimateReminderCount?: InputMaybe<OrderBy>;
  invoicePaymentReminderCount?: InputMaybe<OrderBy>;
};

/** columns and relationships of "company_pricing_tier_config" */
export type CompanyPricingTierConfig = {
  __typename?: 'CompanyPricingTierConfig';
  addonAfterhoursTierEnabled: Scalars['Boolean'];
  addonTierEnabled: Scalars['Boolean'];
  afterhoursTierEnabled: Scalars['Boolean'];
  businessHoursEndTime: Scalars['time'];
  businessHoursStartTime: Scalars['time'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  memberAddonAfterhoursTierEnabled: Scalars['Boolean'];
  memberAddonTierEnabled: Scalars['Boolean'];
  memberAfterhoursTierEnabled: Scalars['Boolean'];
  memberTierEnabled: Scalars['Boolean'];
  saturdayIsBusinessDay: Scalars['Boolean'];
  sundayIsBusinessDay: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "company_pricing_tier_config" */
export type CompanyPricingTierConfigAggregate = {
  __typename?: 'CompanyPricingTierConfigAggregate';
  aggregate?: Maybe<CompanyPricingTierConfigAggregateFields>;
  nodes: Array<CompanyPricingTierConfig>;
};

/** aggregate fields of "company_pricing_tier_config" */
export type CompanyPricingTierConfigAggregateFields = {
  __typename?: 'CompanyPricingTierConfigAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CompanyPricingTierConfigMaxFields>;
  min?: Maybe<CompanyPricingTierConfigMinFields>;
};


/** aggregate fields of "company_pricing_tier_config" */
export type CompanyPricingTierConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyPricingTierConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "company_pricing_tier_config". All fields are combined with a logical 'AND'. */
export type CompanyPricingTierConfigBoolExp = {
  _and?: InputMaybe<Array<CompanyPricingTierConfigBoolExp>>;
  _not?: InputMaybe<CompanyPricingTierConfigBoolExp>;
  _or?: InputMaybe<Array<CompanyPricingTierConfigBoolExp>>;
  addonAfterhoursTierEnabled?: InputMaybe<BooleanComparisonExp>;
  addonTierEnabled?: InputMaybe<BooleanComparisonExp>;
  afterhoursTierEnabled?: InputMaybe<BooleanComparisonExp>;
  businessHoursEndTime?: InputMaybe<TimeComparisonExp>;
  businessHoursStartTime?: InputMaybe<TimeComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  memberAddonAfterhoursTierEnabled?: InputMaybe<BooleanComparisonExp>;
  memberAddonTierEnabled?: InputMaybe<BooleanComparisonExp>;
  memberAfterhoursTierEnabled?: InputMaybe<BooleanComparisonExp>;
  memberTierEnabled?: InputMaybe<BooleanComparisonExp>;
  saturdayIsBusinessDay?: InputMaybe<BooleanComparisonExp>;
  sundayIsBusinessDay?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "company_pricing_tier_config" */
export type CompanyPricingTierConfigConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'company_pricing_tier_config_pkey';

/** input type for inserting data into table "company_pricing_tier_config" */
export type CompanyPricingTierConfigInsertInput = {
  addonAfterhoursTierEnabled?: InputMaybe<Scalars['Boolean']>;
  addonTierEnabled?: InputMaybe<Scalars['Boolean']>;
  afterhoursTierEnabled?: InputMaybe<Scalars['Boolean']>;
  businessHoursEndTime?: InputMaybe<Scalars['time']>;
  businessHoursStartTime?: InputMaybe<Scalars['time']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  memberAddonAfterhoursTierEnabled?: InputMaybe<Scalars['Boolean']>;
  memberAddonTierEnabled?: InputMaybe<Scalars['Boolean']>;
  memberAfterhoursTierEnabled?: InputMaybe<Scalars['Boolean']>;
  memberTierEnabled?: InputMaybe<Scalars['Boolean']>;
  saturdayIsBusinessDay?: InputMaybe<Scalars['Boolean']>;
  sundayIsBusinessDay?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CompanyPricingTierConfigMaxFields = {
  __typename?: 'CompanyPricingTierConfigMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CompanyPricingTierConfigMinFields = {
  __typename?: 'CompanyPricingTierConfigMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "company_pricing_tier_config" */
export type CompanyPricingTierConfigMutationResponse = {
  __typename?: 'CompanyPricingTierConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyPricingTierConfig>;
};

/** input type for inserting object relation for remote table "company_pricing_tier_config" */
export type CompanyPricingTierConfigObjRelInsertInput = {
  data: CompanyPricingTierConfigInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyPricingTierConfigOnConflict>;
};

/** on_conflict condition type for table "company_pricing_tier_config" */
export type CompanyPricingTierConfigOnConflict = {
  constraint: CompanyPricingTierConfigConstraint;
  updateColumns?: Array<CompanyPricingTierConfigUpdateColumn>;
  where?: InputMaybe<CompanyPricingTierConfigBoolExp>;
};

/** Ordering options when selecting data from "company_pricing_tier_config". */
export type CompanyPricingTierConfigOrderBy = {
  addonAfterhoursTierEnabled?: InputMaybe<OrderBy>;
  addonTierEnabled?: InputMaybe<OrderBy>;
  afterhoursTierEnabled?: InputMaybe<OrderBy>;
  businessHoursEndTime?: InputMaybe<OrderBy>;
  businessHoursStartTime?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  memberAddonAfterhoursTierEnabled?: InputMaybe<OrderBy>;
  memberAddonTierEnabled?: InputMaybe<OrderBy>;
  memberAfterhoursTierEnabled?: InputMaybe<OrderBy>;
  memberTierEnabled?: InputMaybe<OrderBy>;
  saturdayIsBusinessDay?: InputMaybe<OrderBy>;
  sundayIsBusinessDay?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_pricing_tier_config */
export type CompanyPricingTierConfigPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "company_pricing_tier_config" */
export type CompanyPricingTierConfigSelectColumn =
  /** column name */
  | 'addonAfterhoursTierEnabled'
  /** column name */
  | 'addonTierEnabled'
  /** column name */
  | 'afterhoursTierEnabled'
  /** column name */
  | 'businessHoursEndTime'
  /** column name */
  | 'businessHoursStartTime'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'memberAddonAfterhoursTierEnabled'
  /** column name */
  | 'memberAddonTierEnabled'
  /** column name */
  | 'memberAfterhoursTierEnabled'
  /** column name */
  | 'memberTierEnabled'
  /** column name */
  | 'saturdayIsBusinessDay'
  /** column name */
  | 'sundayIsBusinessDay'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "company_pricing_tier_config" */
export type CompanyPricingTierConfigSetInput = {
  addonAfterhoursTierEnabled?: InputMaybe<Scalars['Boolean']>;
  addonTierEnabled?: InputMaybe<Scalars['Boolean']>;
  afterhoursTierEnabled?: InputMaybe<Scalars['Boolean']>;
  businessHoursEndTime?: InputMaybe<Scalars['time']>;
  businessHoursStartTime?: InputMaybe<Scalars['time']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  memberAddonAfterhoursTierEnabled?: InputMaybe<Scalars['Boolean']>;
  memberAddonTierEnabled?: InputMaybe<Scalars['Boolean']>;
  memberAfterhoursTierEnabled?: InputMaybe<Scalars['Boolean']>;
  memberTierEnabled?: InputMaybe<Scalars['Boolean']>;
  saturdayIsBusinessDay?: InputMaybe<Scalars['Boolean']>;
  sundayIsBusinessDay?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "company_pricing_tier_config" */
export type CompanyPricingTierConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyPricingTierConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyPricingTierConfigStreamCursorValueInput = {
  addonAfterhoursTierEnabled?: InputMaybe<Scalars['Boolean']>;
  addonTierEnabled?: InputMaybe<Scalars['Boolean']>;
  afterhoursTierEnabled?: InputMaybe<Scalars['Boolean']>;
  businessHoursEndTime?: InputMaybe<Scalars['time']>;
  businessHoursStartTime?: InputMaybe<Scalars['time']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  memberAddonAfterhoursTierEnabled?: InputMaybe<Scalars['Boolean']>;
  memberAddonTierEnabled?: InputMaybe<Scalars['Boolean']>;
  memberAfterhoursTierEnabled?: InputMaybe<Scalars['Boolean']>;
  memberTierEnabled?: InputMaybe<Scalars['Boolean']>;
  saturdayIsBusinessDay?: InputMaybe<Scalars['Boolean']>;
  sundayIsBusinessDay?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "company_pricing_tier_config" */
export type CompanyPricingTierConfigUpdateColumn =
  /** column name */
  | 'addonAfterhoursTierEnabled'
  /** column name */
  | 'addonTierEnabled'
  /** column name */
  | 'afterhoursTierEnabled'
  /** column name */
  | 'businessHoursEndTime'
  /** column name */
  | 'businessHoursStartTime'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'memberAddonAfterhoursTierEnabled'
  /** column name */
  | 'memberAddonTierEnabled'
  /** column name */
  | 'memberAfterhoursTierEnabled'
  /** column name */
  | 'memberTierEnabled'
  /** column name */
  | 'saturdayIsBusinessDay'
  /** column name */
  | 'sundayIsBusinessDay'
  /** column name */
  | 'updatedAt';

export type CompanyPricingTierConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyPricingTierConfigSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyPricingTierConfigBoolExp;
};

/** columns and relationships of "company_review_links" */
export type CompanyReviewLinks = {
  __typename?: 'CompanyReviewLinks';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  companyReviewLinkGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  isActive: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  isEligibleForTechnician: Scalars['Boolean'];
  label: Scalars['String'];
  platformId: Scalars['String'];
  reviewType: Scalars['String'];
  sortOrder: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "company_review_links" */
export type CompanyReviewLinksAggregate = {
  __typename?: 'CompanyReviewLinksAggregate';
  aggregate?: Maybe<CompanyReviewLinksAggregateFields>;
  nodes: Array<CompanyReviewLinks>;
};

export type CompanyReviewLinksAggregateBoolExp = {
  bool_and?: InputMaybe<CompanyReviewLinksAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<CompanyReviewLinksAggregateBoolExpBool_Or>;
  count?: InputMaybe<CompanyReviewLinksAggregateBoolExpCount>;
};

/** aggregate fields of "company_review_links" */
export type CompanyReviewLinksAggregateFields = {
  __typename?: 'CompanyReviewLinksAggregateFields';
  avg?: Maybe<CompanyReviewLinksAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompanyReviewLinksMaxFields>;
  min?: Maybe<CompanyReviewLinksMinFields>;
  stddev?: Maybe<CompanyReviewLinksStddevFields>;
  stddevPop?: Maybe<CompanyReviewLinksStddevPopFields>;
  stddevSamp?: Maybe<CompanyReviewLinksStddevSampFields>;
  sum?: Maybe<CompanyReviewLinksSumFields>;
  varPop?: Maybe<CompanyReviewLinksVarPopFields>;
  varSamp?: Maybe<CompanyReviewLinksVarSampFields>;
  variance?: Maybe<CompanyReviewLinksVarianceFields>;
};


/** aggregate fields of "company_review_links" */
export type CompanyReviewLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyReviewLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company_review_links" */
export type CompanyReviewLinksAggregateOrderBy = {
  avg?: InputMaybe<CompanyReviewLinksAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CompanyReviewLinksMaxOrderBy>;
  min?: InputMaybe<CompanyReviewLinksMinOrderBy>;
  stddev?: InputMaybe<CompanyReviewLinksStddevOrderBy>;
  stddevPop?: InputMaybe<CompanyReviewLinksStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CompanyReviewLinksStddevSampOrderBy>;
  sum?: InputMaybe<CompanyReviewLinksSumOrderBy>;
  varPop?: InputMaybe<CompanyReviewLinksVarPopOrderBy>;
  varSamp?: InputMaybe<CompanyReviewLinksVarSampOrderBy>;
  variance?: InputMaybe<CompanyReviewLinksVarianceOrderBy>;
};

/** aggregate avg on columns */
export type CompanyReviewLinksAvgFields = {
  __typename?: 'CompanyReviewLinksAvgFields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "company_review_links" */
export type CompanyReviewLinksAvgOrderBy = {
  sortOrder?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "company_review_links". All fields are combined with a logical 'AND'. */
export type CompanyReviewLinksBoolExp = {
  _and?: InputMaybe<Array<CompanyReviewLinksBoolExp>>;
  _not?: InputMaybe<CompanyReviewLinksBoolExp>;
  _or?: InputMaybe<Array<CompanyReviewLinksBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  companyReviewLinkGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  isDefault?: InputMaybe<BooleanComparisonExp>;
  isEligibleForTechnician?: InputMaybe<BooleanComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  platformId?: InputMaybe<StringComparisonExp>;
  reviewType?: InputMaybe<StringComparisonExp>;
  sortOrder?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type CompanyReviewLinksMaxFields = {
  __typename?: 'CompanyReviewLinksMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  companyReviewLinkGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  label?: Maybe<Scalars['String']>;
  platformId?: Maybe<Scalars['String']>;
  reviewType?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "company_review_links" */
export type CompanyReviewLinksMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  companyReviewLinkGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  platformId?: InputMaybe<OrderBy>;
  reviewType?: InputMaybe<OrderBy>;
  sortOrder?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CompanyReviewLinksMinFields = {
  __typename?: 'CompanyReviewLinksMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  companyReviewLinkGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  label?: Maybe<Scalars['String']>;
  platformId?: Maybe<Scalars['String']>;
  reviewType?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "company_review_links" */
export type CompanyReviewLinksMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  companyReviewLinkGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  platformId?: InputMaybe<OrderBy>;
  reviewType?: InputMaybe<OrderBy>;
  sortOrder?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "company_review_links". */
export type CompanyReviewLinksOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  companyReviewLinkGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  isDefault?: InputMaybe<OrderBy>;
  isEligibleForTechnician?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  platformId?: InputMaybe<OrderBy>;
  reviewType?: InputMaybe<OrderBy>;
  sortOrder?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "company_review_links" */
export type CompanyReviewLinksSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'companyReviewLinkGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'isActive'
  /** column name */
  | 'isDefault'
  /** column name */
  | 'isEligibleForTechnician'
  /** column name */
  | 'label'
  /** column name */
  | 'platformId'
  /** column name */
  | 'reviewType'
  /** column name */
  | 'sortOrder'
  /** column name */
  | 'updatedAt';

/** select "companyReviewLinksAggregateBoolExpBool_andArgumentsColumns" columns of table "company_review_links" */
export type CompanyReviewLinksSelectColumnCompanyReviewLinksAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isActive'
  /** column name */
  | 'isDefault'
  /** column name */
  | 'isEligibleForTechnician';

/** select "companyReviewLinksAggregateBoolExpBool_orArgumentsColumns" columns of table "company_review_links" */
export type CompanyReviewLinksSelectColumnCompanyReviewLinksAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isActive'
  /** column name */
  | 'isDefault'
  /** column name */
  | 'isEligibleForTechnician';

/** aggregate stddev on columns */
export type CompanyReviewLinksStddevFields = {
  __typename?: 'CompanyReviewLinksStddevFields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "company_review_links" */
export type CompanyReviewLinksStddevOrderBy = {
  sortOrder?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type CompanyReviewLinksStddevPopFields = {
  __typename?: 'CompanyReviewLinksStddevPopFields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "company_review_links" */
export type CompanyReviewLinksStddevPopOrderBy = {
  sortOrder?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type CompanyReviewLinksStddevSampFields = {
  __typename?: 'CompanyReviewLinksStddevSampFields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "company_review_links" */
export type CompanyReviewLinksStddevSampOrderBy = {
  sortOrder?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "company_review_links" */
export type CompanyReviewLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyReviewLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyReviewLinksStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyReviewLinkGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isEligibleForTechnician?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  platformId?: InputMaybe<Scalars['String']>;
  reviewType?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type CompanyReviewLinksSumFields = {
  __typename?: 'CompanyReviewLinksSumFields';
  sortOrder?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "company_review_links" */
export type CompanyReviewLinksSumOrderBy = {
  sortOrder?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type CompanyReviewLinksVarPopFields = {
  __typename?: 'CompanyReviewLinksVarPopFields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "company_review_links" */
export type CompanyReviewLinksVarPopOrderBy = {
  sortOrder?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type CompanyReviewLinksVarSampFields = {
  __typename?: 'CompanyReviewLinksVarSampFields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "company_review_links" */
export type CompanyReviewLinksVarSampOrderBy = {
  sortOrder?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CompanyReviewLinksVarianceFields = {
  __typename?: 'CompanyReviewLinksVarianceFields';
  sortOrder?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "company_review_links" */
export type CompanyReviewLinksVarianceOrderBy = {
  sortOrder?: InputMaybe<OrderBy>;
};

/** columns and relationships of "company_roles" */
export type CompanyRoles = {
  __typename?: 'CompanyRoles';
  name: Scalars['String'];
  role: Scalars['RoleId'];
  /** An aggregate relationship */
  userRolesAggregate: UserRolesAggregate;
  /** An array relationship */
  user_roles: Array<UserRoles>;
};


/** columns and relationships of "company_roles" */
export type CompanyRolesUserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


/** columns and relationships of "company_roles" */
export type CompanyRolesUser_RolesArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};

/** aggregated selection of "company_roles" */
export type CompanyRolesAggregate = {
  __typename?: 'CompanyRolesAggregate';
  aggregate?: Maybe<CompanyRolesAggregateFields>;
  nodes: Array<CompanyRoles>;
};

/** aggregate fields of "company_roles" */
export type CompanyRolesAggregateFields = {
  __typename?: 'CompanyRolesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CompanyRolesMaxFields>;
  min?: Maybe<CompanyRolesMinFields>;
};


/** aggregate fields of "company_roles" */
export type CompanyRolesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "company_roles". All fields are combined with a logical 'AND'. */
export type CompanyRolesBoolExp = {
  _and?: InputMaybe<Array<CompanyRolesBoolExp>>;
  _not?: InputMaybe<CompanyRolesBoolExp>;
  _or?: InputMaybe<Array<CompanyRolesBoolExp>>;
  name?: InputMaybe<StringComparisonExp>;
  role?: InputMaybe<Scalars['RoleIdComparisonExp']>;
  user_roles?: InputMaybe<UserRolesBoolExp>;
  user_rolesAggregate?: InputMaybe<UserRolesAggregateBoolExp>;
};

/** unique or primary key constraints on table "company_roles" */
export type CompanyRolesConstraint =
  /** unique or primary key constraint on columns "role" */
  | 'roles_pkey';

/** input type for inserting data into table "company_roles" */
export type CompanyRolesInsertInput = {
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['RoleId']>;
};

/** aggregate max on columns */
export type CompanyRolesMaxFields = {
  __typename?: 'CompanyRolesMaxFields';
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['RoleId']>;
};

/** aggregate min on columns */
export type CompanyRolesMinFields = {
  __typename?: 'CompanyRolesMinFields';
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['RoleId']>;
};

/** response of any mutation on the table "company_roles" */
export type CompanyRolesMutationResponse = {
  __typename?: 'CompanyRolesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyRoles>;
};

/** on_conflict condition type for table "company_roles" */
export type CompanyRolesOnConflict = {
  constraint: CompanyRolesConstraint;
  updateColumns?: Array<CompanyRolesUpdateColumn>;
  where?: InputMaybe<CompanyRolesBoolExp>;
};

/** Ordering options when selecting data from "company_roles". */
export type CompanyRolesOrderBy = {
  name?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  user_rolesAggregate?: InputMaybe<UserRolesAggregateOrderBy>;
};

/** primary key columns input for table: company_roles */
export type CompanyRolesPkColumnsInput = {
  role: Scalars['String'];
};

/** select columns of table "company_roles" */
export type CompanyRolesSelectColumn =
  /** column name */
  | 'name'
  /** column name */
  | 'role';

/** input type for updating data in table "company_roles" */
export type CompanyRolesSetInput = {
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['RoleId']>;
};

/** Streaming cursor of the table "company_roles" */
export type CompanyRolesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyRolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyRolesStreamCursorValueInput = {
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['RoleId']>;
};

/** update columns of table "company_roles" */
export type CompanyRolesUpdateColumn =
  /** column name */
  | 'name'
  /** column name */
  | 'role';

export type CompanyRolesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyRolesSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyRolesBoolExp;
};

/** columns and relationships of "company_tax_configurations" */
export type CompanyTaxConfigurations = {
  __typename?: 'CompanyTaxConfigurations';
  companyGuid: Scalars['uuid'];
  companyTaxConfigurationGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  taxRoundingStrategy: Scalars['TaxRoundingStrategy'];
  updatedAt: Scalars['timestamptz'];
  validFrom: Scalars['timestamptz'];
  validTo?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "company_tax_configurations" */
export type CompanyTaxConfigurationsAggregate = {
  __typename?: 'CompanyTaxConfigurationsAggregate';
  aggregate?: Maybe<CompanyTaxConfigurationsAggregateFields>;
  nodes: Array<CompanyTaxConfigurations>;
};

/** aggregate fields of "company_tax_configurations" */
export type CompanyTaxConfigurationsAggregateFields = {
  __typename?: 'CompanyTaxConfigurationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CompanyTaxConfigurationsMaxFields>;
  min?: Maybe<CompanyTaxConfigurationsMinFields>;
};


/** aggregate fields of "company_tax_configurations" */
export type CompanyTaxConfigurationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyTaxConfigurationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "company_tax_configurations". All fields are combined with a logical 'AND'. */
export type CompanyTaxConfigurationsBoolExp = {
  _and?: InputMaybe<Array<CompanyTaxConfigurationsBoolExp>>;
  _not?: InputMaybe<CompanyTaxConfigurationsBoolExp>;
  _or?: InputMaybe<Array<CompanyTaxConfigurationsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  companyTaxConfigurationGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategyComparisonExp']>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  validFrom?: InputMaybe<TimestamptzComparisonExp>;
  validTo?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "company_tax_configurations" */
export type CompanyTaxConfigurationsConstraint =
  /** unique or primary key constraint on columns "company_tax_configuration_guid" */
  | 'company_tax_configurations_pkey'
  /** unique or primary key constraint on columns "company_guid", "valid_from" */
  | 'uniq_company_tax_configurations_valid_range';

/** input type for inserting data into table "company_tax_configurations" */
export type CompanyTaxConfigurationsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyTaxConfigurationGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validFrom?: InputMaybe<Scalars['timestamptz']>;
  validTo?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CompanyTaxConfigurationsMaxFields = {
  __typename?: 'CompanyTaxConfigurationsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  companyTaxConfigurationGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  taxRoundingStrategy?: Maybe<Scalars['TaxRoundingStrategy']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  validFrom?: Maybe<Scalars['timestamptz']>;
  validTo?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CompanyTaxConfigurationsMinFields = {
  __typename?: 'CompanyTaxConfigurationsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  companyTaxConfigurationGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  taxRoundingStrategy?: Maybe<Scalars['TaxRoundingStrategy']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  validFrom?: Maybe<Scalars['timestamptz']>;
  validTo?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "company_tax_configurations" */
export type CompanyTaxConfigurationsMutationResponse = {
  __typename?: 'CompanyTaxConfigurationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyTaxConfigurations>;
};

/** on_conflict condition type for table "company_tax_configurations" */
export type CompanyTaxConfigurationsOnConflict = {
  constraint: CompanyTaxConfigurationsConstraint;
  updateColumns?: Array<CompanyTaxConfigurationsUpdateColumn>;
  where?: InputMaybe<CompanyTaxConfigurationsBoolExp>;
};

/** Ordering options when selecting data from "company_tax_configurations". */
export type CompanyTaxConfigurationsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  companyTaxConfigurationGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  taxRoundingStrategy?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  validFrom?: InputMaybe<OrderBy>;
  validTo?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_tax_configurations */
export type CompanyTaxConfigurationsPkColumnsInput = {
  companyTaxConfigurationGuid: Scalars['uuid'];
};

/** select columns of table "company_tax_configurations" */
export type CompanyTaxConfigurationsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'companyTaxConfigurationGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'taxRoundingStrategy'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'validFrom'
  /** column name */
  | 'validTo';

/** input type for updating data in table "company_tax_configurations" */
export type CompanyTaxConfigurationsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyTaxConfigurationGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validFrom?: InputMaybe<Scalars['timestamptz']>;
  validTo?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "company_tax_configurations" */
export type CompanyTaxConfigurationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyTaxConfigurationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyTaxConfigurationsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyTaxConfigurationGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validFrom?: InputMaybe<Scalars['timestamptz']>;
  validTo?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "company_tax_configurations" */
export type CompanyTaxConfigurationsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'companyTaxConfigurationGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'taxRoundingStrategy'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'validFrom'
  /** column name */
  | 'validTo';

export type CompanyTaxConfigurationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyTaxConfigurationsSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyTaxConfigurationsBoolExp;
};

/** Mapping of users to companies. A user may belong to at most one company. A company may have many users.Breezy admins will not be associated to a company. */
export type CompanyUsers = {
  __typename?: 'CompanyUsers';
  addedByUserGuid: Scalars['uuid'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  schedulingCapability: Scalars['SchedulingCapability'];
  /** An object relationship */
  user: Users;
  /** An object relationship */
  userByUserGuid: Users;
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "company_users" */
export type CompanyUsersAggregate = {
  __typename?: 'CompanyUsersAggregate';
  aggregate?: Maybe<CompanyUsersAggregateFields>;
  nodes: Array<CompanyUsers>;
};

export type CompanyUsersAggregateBoolExp = {
  count?: InputMaybe<CompanyUsersAggregateBoolExpCount>;
};

/** aggregate fields of "company_users" */
export type CompanyUsersAggregateFields = {
  __typename?: 'CompanyUsersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CompanyUsersMaxFields>;
  min?: Maybe<CompanyUsersMinFields>;
};


/** aggregate fields of "company_users" */
export type CompanyUsersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company_users" */
export type CompanyUsersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CompanyUsersMaxOrderBy>;
  min?: InputMaybe<CompanyUsersMinOrderBy>;
};

/** input type for inserting array relation for remote table "company_users" */
export type CompanyUsersArrRelInsertInput = {
  data: Array<CompanyUsersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "company_users". All fields are combined with a logical 'AND'. */
export type CompanyUsersBoolExp = {
  _and?: InputMaybe<Array<CompanyUsersBoolExp>>;
  _not?: InputMaybe<CompanyUsersBoolExp>;
  _or?: InputMaybe<Array<CompanyUsersBoolExp>>;
  addedByUserGuid?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  schedulingCapability?: InputMaybe<Scalars['SchedulingCapabilityComparisonExp']>;
  user?: InputMaybe<UsersBoolExp>;
  userByUserGuid?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "company_users" */
export type CompanyUsersConstraint =
  /** unique or primary key constraint on columns "user_guid" */
  | 'company_users_pkey';

/** input type for inserting data into table "company_users" */
export type CompanyUsersInsertInput = {
  addedByUserGuid?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  schedulingCapability?: InputMaybe<Scalars['SchedulingCapability']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userByUserGuid?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CompanyUsersMaxFields = {
  __typename?: 'CompanyUsersMaxFields';
  addedByUserGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  schedulingCapability?: Maybe<Scalars['SchedulingCapability']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "company_users" */
export type CompanyUsersMaxOrderBy = {
  addedByUserGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  schedulingCapability?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CompanyUsersMinFields = {
  __typename?: 'CompanyUsersMinFields';
  addedByUserGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  schedulingCapability?: Maybe<Scalars['SchedulingCapability']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "company_users" */
export type CompanyUsersMinOrderBy = {
  addedByUserGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  schedulingCapability?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "company_users" */
export type CompanyUsersMutationResponse = {
  __typename?: 'CompanyUsersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyUsers>;
};

/** input type for inserting object relation for remote table "company_users" */
export type CompanyUsersObjRelInsertInput = {
  data: CompanyUsersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyUsersOnConflict>;
};

/** on_conflict condition type for table "company_users" */
export type CompanyUsersOnConflict = {
  constraint: CompanyUsersConstraint;
  updateColumns?: Array<CompanyUsersUpdateColumn>;
  where?: InputMaybe<CompanyUsersBoolExp>;
};

/** Ordering options when selecting data from "company_users". */
export type CompanyUsersOrderBy = {
  addedByUserGuid?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  schedulingCapability?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userByUserGuid?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_users */
export type CompanyUsersPkColumnsInput = {
  userGuid: Scalars['uuid'];
};

/** select columns of table "company_users" */
export type CompanyUsersSelectColumn =
  /** column name */
  | 'addedByUserGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'schedulingCapability'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "company_users" */
export type CompanyUsersSetInput = {
  addedByUserGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  schedulingCapability?: InputMaybe<Scalars['SchedulingCapability']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "company_users" */
export type CompanyUsersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyUsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyUsersStreamCursorValueInput = {
  addedByUserGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  schedulingCapability?: InputMaybe<Scalars['SchedulingCapability']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "company_users" */
export type CompanyUsersUpdateColumn =
  /** column name */
  | 'addedByUserGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'schedulingCapability'
  /** column name */
  | 'userGuid';

export type CompanyUsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyUsersSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyUsersBoolExp;
};

/** columns and relationships of "company_working_display_hours" */
export type CompanyWorkingDisplayHours = {
  __typename?: 'CompanyWorkingDisplayHours';
  companyGuid: Scalars['uuid'];
  companyWorkingDisplayHoursGuid: Scalars['uuid'];
  workingDays: Scalars['String'];
  workingEndHour: Scalars['Int'];
  workingStartHour: Scalars['Int'];
};

/** aggregated selection of "company_working_display_hours" */
export type CompanyWorkingDisplayHoursAggregate = {
  __typename?: 'CompanyWorkingDisplayHoursAggregate';
  aggregate?: Maybe<CompanyWorkingDisplayHoursAggregateFields>;
  nodes: Array<CompanyWorkingDisplayHours>;
};

/** aggregate fields of "company_working_display_hours" */
export type CompanyWorkingDisplayHoursAggregateFields = {
  __typename?: 'CompanyWorkingDisplayHoursAggregateFields';
  avg?: Maybe<CompanyWorkingDisplayHoursAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CompanyWorkingDisplayHoursMaxFields>;
  min?: Maybe<CompanyWorkingDisplayHoursMinFields>;
  stddev?: Maybe<CompanyWorkingDisplayHoursStddevFields>;
  stddevPop?: Maybe<CompanyWorkingDisplayHoursStddevPopFields>;
  stddevSamp?: Maybe<CompanyWorkingDisplayHoursStddevSampFields>;
  sum?: Maybe<CompanyWorkingDisplayHoursSumFields>;
  varPop?: Maybe<CompanyWorkingDisplayHoursVarPopFields>;
  varSamp?: Maybe<CompanyWorkingDisplayHoursVarSampFields>;
  variance?: Maybe<CompanyWorkingDisplayHoursVarianceFields>;
};


/** aggregate fields of "company_working_display_hours" */
export type CompanyWorkingDisplayHoursAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyWorkingDisplayHoursSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CompanyWorkingDisplayHoursAvgFields = {
  __typename?: 'CompanyWorkingDisplayHoursAvgFields';
  workingEndHour?: Maybe<Scalars['Float']>;
  workingStartHour?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "company_working_display_hours". All fields are combined with a logical 'AND'. */
export type CompanyWorkingDisplayHoursBoolExp = {
  _and?: InputMaybe<Array<CompanyWorkingDisplayHoursBoolExp>>;
  _not?: InputMaybe<CompanyWorkingDisplayHoursBoolExp>;
  _or?: InputMaybe<Array<CompanyWorkingDisplayHoursBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  companyWorkingDisplayHoursGuid?: InputMaybe<UuidComparisonExp>;
  workingDays?: InputMaybe<StringComparisonExp>;
  workingEndHour?: InputMaybe<IntComparisonExp>;
  workingStartHour?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "company_working_display_hours" */
export type CompanyWorkingDisplayHoursConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'company_working_display_hours_company_guid_key'
  /** unique or primary key constraint on columns "company_working_display_hours_guid" */
  | 'company_working_display_hours_pkey';

/** input type for incrementing numeric columns in table "company_working_display_hours" */
export type CompanyWorkingDisplayHoursIncInput = {
  workingEndHour?: InputMaybe<Scalars['Int']>;
  workingStartHour?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "company_working_display_hours" */
export type CompanyWorkingDisplayHoursInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyWorkingDisplayHoursGuid?: InputMaybe<Scalars['uuid']>;
  workingDays?: InputMaybe<Scalars['String']>;
  workingEndHour?: InputMaybe<Scalars['Int']>;
  workingStartHour?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type CompanyWorkingDisplayHoursMaxFields = {
  __typename?: 'CompanyWorkingDisplayHoursMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  companyWorkingDisplayHoursGuid?: Maybe<Scalars['uuid']>;
  workingDays?: Maybe<Scalars['String']>;
  workingEndHour?: Maybe<Scalars['Int']>;
  workingStartHour?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type CompanyWorkingDisplayHoursMinFields = {
  __typename?: 'CompanyWorkingDisplayHoursMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  companyWorkingDisplayHoursGuid?: Maybe<Scalars['uuid']>;
  workingDays?: Maybe<Scalars['String']>;
  workingEndHour?: Maybe<Scalars['Int']>;
  workingStartHour?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "company_working_display_hours" */
export type CompanyWorkingDisplayHoursMutationResponse = {
  __typename?: 'CompanyWorkingDisplayHoursMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyWorkingDisplayHours>;
};

/** input type for inserting object relation for remote table "company_working_display_hours" */
export type CompanyWorkingDisplayHoursObjRelInsertInput = {
  data: CompanyWorkingDisplayHoursInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CompanyWorkingDisplayHoursOnConflict>;
};

/** on_conflict condition type for table "company_working_display_hours" */
export type CompanyWorkingDisplayHoursOnConflict = {
  constraint: CompanyWorkingDisplayHoursConstraint;
  updateColumns?: Array<CompanyWorkingDisplayHoursUpdateColumn>;
  where?: InputMaybe<CompanyWorkingDisplayHoursBoolExp>;
};

/** Ordering options when selecting data from "company_working_display_hours". */
export type CompanyWorkingDisplayHoursOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  companyWorkingDisplayHoursGuid?: InputMaybe<OrderBy>;
  workingDays?: InputMaybe<OrderBy>;
  workingEndHour?: InputMaybe<OrderBy>;
  workingStartHour?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: company_working_display_hours */
export type CompanyWorkingDisplayHoursPkColumnsInput = {
  companyWorkingDisplayHoursGuid: Scalars['uuid'];
};

/** select columns of table "company_working_display_hours" */
export type CompanyWorkingDisplayHoursSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'companyWorkingDisplayHoursGuid'
  /** column name */
  | 'workingDays'
  /** column name */
  | 'workingEndHour'
  /** column name */
  | 'workingStartHour';

/** input type for updating data in table "company_working_display_hours" */
export type CompanyWorkingDisplayHoursSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyWorkingDisplayHoursGuid?: InputMaybe<Scalars['uuid']>;
  workingDays?: InputMaybe<Scalars['String']>;
  workingEndHour?: InputMaybe<Scalars['Int']>;
  workingStartHour?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CompanyWorkingDisplayHoursStddevFields = {
  __typename?: 'CompanyWorkingDisplayHoursStddevFields';
  workingEndHour?: Maybe<Scalars['Float']>;
  workingStartHour?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CompanyWorkingDisplayHoursStddevPopFields = {
  __typename?: 'CompanyWorkingDisplayHoursStddevPopFields';
  workingEndHour?: Maybe<Scalars['Float']>;
  workingStartHour?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CompanyWorkingDisplayHoursStddevSampFields = {
  __typename?: 'CompanyWorkingDisplayHoursStddevSampFields';
  workingEndHour?: Maybe<Scalars['Float']>;
  workingStartHour?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "company_working_display_hours" */
export type CompanyWorkingDisplayHoursStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompanyWorkingDisplayHoursStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyWorkingDisplayHoursStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyWorkingDisplayHoursGuid?: InputMaybe<Scalars['uuid']>;
  workingDays?: InputMaybe<Scalars['String']>;
  workingEndHour?: InputMaybe<Scalars['Int']>;
  workingStartHour?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CompanyWorkingDisplayHoursSumFields = {
  __typename?: 'CompanyWorkingDisplayHoursSumFields';
  workingEndHour?: Maybe<Scalars['Int']>;
  workingStartHour?: Maybe<Scalars['Int']>;
};

/** update columns of table "company_working_display_hours" */
export type CompanyWorkingDisplayHoursUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'companyWorkingDisplayHoursGuid'
  /** column name */
  | 'workingDays'
  /** column name */
  | 'workingEndHour'
  /** column name */
  | 'workingStartHour';

export type CompanyWorkingDisplayHoursUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompanyWorkingDisplayHoursIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyWorkingDisplayHoursSetInput>;
  /** filter the rows which have to be updated */
  where: CompanyWorkingDisplayHoursBoolExp;
};

/** aggregate varPop on columns */
export type CompanyWorkingDisplayHoursVarPopFields = {
  __typename?: 'CompanyWorkingDisplayHoursVarPopFields';
  workingEndHour?: Maybe<Scalars['Float']>;
  workingStartHour?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CompanyWorkingDisplayHoursVarSampFields = {
  __typename?: 'CompanyWorkingDisplayHoursVarSampFields';
  workingEndHour?: Maybe<Scalars['Float']>;
  workingStartHour?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CompanyWorkingDisplayHoursVarianceFields = {
  __typename?: 'CompanyWorkingDisplayHoursVarianceFields';
  workingEndHour?: Maybe<Scalars['Float']>;
  workingStartHour?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "contacts" */
export type Contacts = {
  __typename?: 'Contacts';
  /** An array relationship */
  accountContacts: Array<AccountContacts>;
  /** An aggregate relationship */
  accountContactsAggregate: AccountContactsAggregate;
  /** An object relationship */
  additionalEmailAddress?: Maybe<EmailAddresses>;
  additionalEmailAddressGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  additionalPhoneNumber?: Maybe<PhoneNumbers>;
  additionalPhoneNumberGuid?: Maybe<Scalars['uuid']>;
  companyGuid: Scalars['uuid'];
  contactGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  firstName: Scalars['String'];
  /** A computed field, that returns the user's first name with their last initial */
  firstNameInitial?: Maybe<Scalars['String']>;
  /** A computed field, concatenates the first and last name of the contact */
  fullName: Scalars['String'];
  /** An object relationship */
  integratedChannel?: Maybe<IntegratedChannels>;
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobsAggregate: JobsAggregate;
  lastName: Scalars['String'];
  /** An array relationship */
  locationContacts: Array<LocationContacts>;
  /** An aggregate relationship */
  locationContactsAggregate: LocationContactsAggregate;
  notificationPreferenceType: Scalars['NotificationPreferenceType'];
  /** An object relationship */
  primaryEmailAddress?: Maybe<EmailAddresses>;
  primaryEmailAddressGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  primaryPhoneNumber?: Maybe<PhoneNumbers>;
  primaryPhoneNumberGuid?: Maybe<Scalars['uuid']>;
  salutation?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "contacts" */
export type ContactsAccountContactsArgs = {
  distinctOn?: InputMaybe<Array<AccountContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountContactsOrderBy>>;
  where?: InputMaybe<AccountContactsBoolExp>;
};


/** columns and relationships of "contacts" */
export type ContactsAccountContactsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountContactsOrderBy>>;
  where?: InputMaybe<AccountContactsBoolExp>;
};


/** columns and relationships of "contacts" */
export type ContactsJobsArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


/** columns and relationships of "contacts" */
export type ContactsJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


/** columns and relationships of "contacts" */
export type ContactsLocationContactsArgs = {
  distinctOn?: InputMaybe<Array<LocationContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationContactsOrderBy>>;
  where?: InputMaybe<LocationContactsBoolExp>;
};


/** columns and relationships of "contacts" */
export type ContactsLocationContactsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LocationContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationContactsOrderBy>>;
  where?: InputMaybe<LocationContactsBoolExp>;
};

/** aggregated selection of "contacts" */
export type ContactsAggregate = {
  __typename?: 'ContactsAggregate';
  aggregate?: Maybe<ContactsAggregateFields>;
  nodes: Array<Contacts>;
};

export type ContactsAggregateBoolExp = {
  count?: InputMaybe<ContactsAggregateBoolExpCount>;
};

/** aggregate fields of "contacts" */
export type ContactsAggregateFields = {
  __typename?: 'ContactsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ContactsMaxFields>;
  min?: Maybe<ContactsMinFields>;
};


/** aggregate fields of "contacts" */
export type ContactsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ContactsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contacts" */
export type ContactsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ContactsMaxOrderBy>;
  min?: InputMaybe<ContactsMinOrderBy>;
};

/** input type for inserting array relation for remote table "contacts" */
export type ContactsArrRelInsertInput = {
  data: Array<ContactsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ContactsOnConflict>;
};

/** Boolean expression to filter rows from the table "contacts". All fields are combined with a logical 'AND'. */
export type ContactsBoolExp = {
  _and?: InputMaybe<Array<ContactsBoolExp>>;
  _not?: InputMaybe<ContactsBoolExp>;
  _or?: InputMaybe<Array<ContactsBoolExp>>;
  accountContacts?: InputMaybe<AccountContactsBoolExp>;
  accountContactsAggregate?: InputMaybe<AccountContactsAggregateBoolExp>;
  additionalEmailAddress?: InputMaybe<EmailAddressesBoolExp>;
  additionalEmailAddressGuid?: InputMaybe<UuidComparisonExp>;
  additionalPhoneNumber?: InputMaybe<PhoneNumbersBoolExp>;
  additionalPhoneNumberGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  contactGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  firstNameInitial?: InputMaybe<StringComparisonExp>;
  fullName?: InputMaybe<StringComparisonExp>;
  integratedChannel?: InputMaybe<IntegratedChannelsBoolExp>;
  jobs?: InputMaybe<JobsBoolExp>;
  jobsAggregate?: InputMaybe<JobsAggregateBoolExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  locationContacts?: InputMaybe<LocationContactsBoolExp>;
  locationContactsAggregate?: InputMaybe<LocationContactsAggregateBoolExp>;
  notificationPreferenceType?: InputMaybe<Scalars['NotificationPreferenceTypeComparisonExp']>;
  primaryEmailAddress?: InputMaybe<EmailAddressesBoolExp>;
  primaryEmailAddressGuid?: InputMaybe<UuidComparisonExp>;
  primaryPhoneNumber?: InputMaybe<PhoneNumbersBoolExp>;
  primaryPhoneNumberGuid?: InputMaybe<UuidComparisonExp>;
  salutation?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "contacts" */
export type ContactsConstraint =
  /** unique or primary key constraint on columns "contact_guid" */
  | 'contacts_pkey';

/** input type for inserting data into table "contacts" */
export type ContactsInsertInput = {
  accountContacts?: InputMaybe<AccountContactsArrRelInsertInput>;
  additionalEmailAddress?: InputMaybe<EmailAddressesObjRelInsertInput>;
  additionalEmailAddressGuid?: InputMaybe<Scalars['uuid']>;
  additionalPhoneNumber?: InputMaybe<PhoneNumbersObjRelInsertInput>;
  additionalPhoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  integratedChannel?: InputMaybe<IntegratedChannelsObjRelInsertInput>;
  jobs?: InputMaybe<JobsArrRelInsertInput>;
  lastName?: InputMaybe<Scalars['String']>;
  locationContacts?: InputMaybe<LocationContactsArrRelInsertInput>;
  notificationPreferenceType?: InputMaybe<Scalars['NotificationPreferenceType']>;
  primaryEmailAddress?: InputMaybe<EmailAddressesObjRelInsertInput>;
  primaryEmailAddressGuid?: InputMaybe<Scalars['uuid']>;
  primaryPhoneNumber?: InputMaybe<PhoneNumbersObjRelInsertInput>;
  primaryPhoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  salutation?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ContactsMaxFields = {
  __typename?: 'ContactsMaxFields';
  additionalEmailAddressGuid?: Maybe<Scalars['uuid']>;
  additionalPhoneNumberGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  firstName?: Maybe<Scalars['String']>;
  /** A computed field, that returns the user's first name with their last initial */
  firstNameInitial?: Maybe<Scalars['String']>;
  /** A computed field, concatenates the first and last name of the contact */
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  notificationPreferenceType?: Maybe<Scalars['NotificationPreferenceType']>;
  primaryEmailAddressGuid?: Maybe<Scalars['uuid']>;
  primaryPhoneNumberGuid?: Maybe<Scalars['uuid']>;
  salutation?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "contacts" */
export type ContactsMaxOrderBy = {
  additionalEmailAddressGuid?: InputMaybe<OrderBy>;
  additionalPhoneNumberGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  notificationPreferenceType?: InputMaybe<OrderBy>;
  primaryEmailAddressGuid?: InputMaybe<OrderBy>;
  primaryPhoneNumberGuid?: InputMaybe<OrderBy>;
  salutation?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ContactsMinFields = {
  __typename?: 'ContactsMinFields';
  additionalEmailAddressGuid?: Maybe<Scalars['uuid']>;
  additionalPhoneNumberGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  firstName?: Maybe<Scalars['String']>;
  /** A computed field, that returns the user's first name with their last initial */
  firstNameInitial?: Maybe<Scalars['String']>;
  /** A computed field, concatenates the first and last name of the contact */
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  notificationPreferenceType?: Maybe<Scalars['NotificationPreferenceType']>;
  primaryEmailAddressGuid?: Maybe<Scalars['uuid']>;
  primaryPhoneNumberGuid?: Maybe<Scalars['uuid']>;
  salutation?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "contacts" */
export type ContactsMinOrderBy = {
  additionalEmailAddressGuid?: InputMaybe<OrderBy>;
  additionalPhoneNumberGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  notificationPreferenceType?: InputMaybe<OrderBy>;
  primaryEmailAddressGuid?: InputMaybe<OrderBy>;
  primaryPhoneNumberGuid?: InputMaybe<OrderBy>;
  salutation?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "contacts" */
export type ContactsMutationResponse = {
  __typename?: 'ContactsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contacts>;
};

/** input type for inserting object relation for remote table "contacts" */
export type ContactsObjRelInsertInput = {
  data: ContactsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ContactsOnConflict>;
};

/** on_conflict condition type for table "contacts" */
export type ContactsOnConflict = {
  constraint: ContactsConstraint;
  updateColumns?: Array<ContactsUpdateColumn>;
  where?: InputMaybe<ContactsBoolExp>;
};

/** Ordering options when selecting data from "contacts". */
export type ContactsOrderBy = {
  accountContactsAggregate?: InputMaybe<AccountContactsAggregateOrderBy>;
  additionalEmailAddress?: InputMaybe<EmailAddressesOrderBy>;
  additionalEmailAddressGuid?: InputMaybe<OrderBy>;
  additionalPhoneNumber?: InputMaybe<PhoneNumbersOrderBy>;
  additionalPhoneNumberGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  firstNameInitial?: InputMaybe<OrderBy>;
  fullName?: InputMaybe<OrderBy>;
  integratedChannel?: InputMaybe<IntegratedChannelsOrderBy>;
  jobsAggregate?: InputMaybe<JobsAggregateOrderBy>;
  lastName?: InputMaybe<OrderBy>;
  locationContactsAggregate?: InputMaybe<LocationContactsAggregateOrderBy>;
  notificationPreferenceType?: InputMaybe<OrderBy>;
  primaryEmailAddress?: InputMaybe<EmailAddressesOrderBy>;
  primaryEmailAddressGuid?: InputMaybe<OrderBy>;
  primaryPhoneNumber?: InputMaybe<PhoneNumbersOrderBy>;
  primaryPhoneNumberGuid?: InputMaybe<OrderBy>;
  salutation?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: contacts */
export type ContactsPkColumnsInput = {
  contactGuid: Scalars['uuid'];
};

/** select columns of table "contacts" */
export type ContactsSelectColumn =
  /** column name */
  | 'additionalEmailAddressGuid'
  /** column name */
  | 'additionalPhoneNumberGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'firstName'
  /** column name */
  | 'lastName'
  /** column name */
  | 'notificationPreferenceType'
  /** column name */
  | 'primaryEmailAddressGuid'
  /** column name */
  | 'primaryPhoneNumberGuid'
  /** column name */
  | 'salutation'
  /** column name */
  | 'title'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "contacts" */
export type ContactsSetInput = {
  additionalEmailAddressGuid?: InputMaybe<Scalars['uuid']>;
  additionalPhoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  notificationPreferenceType?: InputMaybe<Scalars['NotificationPreferenceType']>;
  primaryEmailAddressGuid?: InputMaybe<Scalars['uuid']>;
  primaryPhoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  salutation?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "contacts" */
export type ContactsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ContactsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ContactsStreamCursorValueInput = {
  additionalEmailAddressGuid?: InputMaybe<Scalars['uuid']>;
  additionalPhoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  notificationPreferenceType?: InputMaybe<Scalars['NotificationPreferenceType']>;
  primaryEmailAddressGuid?: InputMaybe<Scalars['uuid']>;
  primaryPhoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  salutation?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "contacts" */
export type ContactsUpdateColumn =
  /** column name */
  | 'additionalEmailAddressGuid'
  /** column name */
  | 'additionalPhoneNumberGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'firstName'
  /** column name */
  | 'lastName'
  /** column name */
  | 'notificationPreferenceType'
  /** column name */
  | 'primaryEmailAddressGuid'
  /** column name */
  | 'primaryPhoneNumberGuid'
  /** column name */
  | 'salutation'
  /** column name */
  | 'title'
  /** column name */
  | 'updatedAt';

export type ContactsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ContactsSetInput>;
  /** filter the rows which have to be updated */
  where: ContactsBoolExp;
};

/** columns and relationships of "cron_jobs" */
export type CronJobs = {
  __typename?: 'CronJobs';
  lastExecutionTimestamp: Scalars['timestamptz'];
  name: Scalars['String'];
  status: Scalars['String'];
};

/** aggregated selection of "cron_jobs" */
export type CronJobsAggregate = {
  __typename?: 'CronJobsAggregate';
  aggregate?: Maybe<CronJobsAggregateFields>;
  nodes: Array<CronJobs>;
};

/** aggregate fields of "cron_jobs" */
export type CronJobsAggregateFields = {
  __typename?: 'CronJobsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CronJobsMaxFields>;
  min?: Maybe<CronJobsMinFields>;
};


/** aggregate fields of "cron_jobs" */
export type CronJobsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CronJobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cron_jobs". All fields are combined with a logical 'AND'. */
export type CronJobsBoolExp = {
  _and?: InputMaybe<Array<CronJobsBoolExp>>;
  _not?: InputMaybe<CronJobsBoolExp>;
  _or?: InputMaybe<Array<CronJobsBoolExp>>;
  lastExecutionTimestamp?: InputMaybe<TimestamptzComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type CronJobsMaxFields = {
  __typename?: 'CronJobsMaxFields';
  lastExecutionTimestamp?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CronJobsMinFields = {
  __typename?: 'CronJobsMinFields';
  lastExecutionTimestamp?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "cron_jobs". */
export type CronJobsOrderBy = {
  lastExecutionTimestamp?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** select columns of table "cron_jobs" */
export type CronJobsSelectColumn =
  /** column name */
  | 'lastExecutionTimestamp'
  /** column name */
  | 'name'
  /** column name */
  | 'status';

/** Streaming cursor of the table "cron_jobs" */
export type CronJobsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CronJobsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CronJobsStreamCursorValueInput = {
  lastExecutionTimestamp?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "current_business_unit_target_metrics_view" */
export type CurrentBusinessUnitTargetMetricsView = {
  __typename?: 'CurrentBusinessUnitTargetMetricsView';
  /** An object relationship */
  businessUnit?: Maybe<BusinessUnits>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  company?: Maybe<Companies>;
  companyGuid?: Maybe<Scalars['uuid']>;
  gpPerManDayGoalUsc?: Maybe<Scalars['numeric']>;
  gpPerManDayTargetUsc?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "current_business_unit_target_metrics_view" */
export type CurrentBusinessUnitTargetMetricsViewAggregate = {
  __typename?: 'CurrentBusinessUnitTargetMetricsViewAggregate';
  aggregate?: Maybe<CurrentBusinessUnitTargetMetricsViewAggregateFields>;
  nodes: Array<CurrentBusinessUnitTargetMetricsView>;
};

/** aggregate fields of "current_business_unit_target_metrics_view" */
export type CurrentBusinessUnitTargetMetricsViewAggregateFields = {
  __typename?: 'CurrentBusinessUnitTargetMetricsViewAggregateFields';
  avg?: Maybe<CurrentBusinessUnitTargetMetricsViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<CurrentBusinessUnitTargetMetricsViewMaxFields>;
  min?: Maybe<CurrentBusinessUnitTargetMetricsViewMinFields>;
  stddev?: Maybe<CurrentBusinessUnitTargetMetricsViewStddevFields>;
  stddevPop?: Maybe<CurrentBusinessUnitTargetMetricsViewStddevPopFields>;
  stddevSamp?: Maybe<CurrentBusinessUnitTargetMetricsViewStddevSampFields>;
  sum?: Maybe<CurrentBusinessUnitTargetMetricsViewSumFields>;
  varPop?: Maybe<CurrentBusinessUnitTargetMetricsViewVarPopFields>;
  varSamp?: Maybe<CurrentBusinessUnitTargetMetricsViewVarSampFields>;
  variance?: Maybe<CurrentBusinessUnitTargetMetricsViewVarianceFields>;
};


/** aggregate fields of "current_business_unit_target_metrics_view" */
export type CurrentBusinessUnitTargetMetricsViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CurrentBusinessUnitTargetMetricsViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type CurrentBusinessUnitTargetMetricsViewAvgFields = {
  __typename?: 'CurrentBusinessUnitTargetMetricsViewAvgFields';
  gpPerManDayGoalUsc?: Maybe<Scalars['Float']>;
  gpPerManDayTargetUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "current_business_unit_target_metrics_view". All fields are combined with a logical 'AND'. */
export type CurrentBusinessUnitTargetMetricsViewBoolExp = {
  _and?: InputMaybe<Array<CurrentBusinessUnitTargetMetricsViewBoolExp>>;
  _not?: InputMaybe<CurrentBusinessUnitTargetMetricsViewBoolExp>;
  _or?: InputMaybe<Array<CurrentBusinessUnitTargetMetricsViewBoolExp>>;
  businessUnit?: InputMaybe<BusinessUnitsBoolExp>;
  businessUnitGuid?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  gpPerManDayGoalUsc?: InputMaybe<NumericComparisonExp>;
  gpPerManDayTargetUsc?: InputMaybe<NumericComparisonExp>;
};

/** aggregate max on columns */
export type CurrentBusinessUnitTargetMetricsViewMaxFields = {
  __typename?: 'CurrentBusinessUnitTargetMetricsViewMaxFields';
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  gpPerManDayGoalUsc?: Maybe<Scalars['numeric']>;
  gpPerManDayTargetUsc?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type CurrentBusinessUnitTargetMetricsViewMinFields = {
  __typename?: 'CurrentBusinessUnitTargetMetricsViewMinFields';
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  gpPerManDayGoalUsc?: Maybe<Scalars['numeric']>;
  gpPerManDayTargetUsc?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "current_business_unit_target_metrics_view". */
export type CurrentBusinessUnitTargetMetricsViewOrderBy = {
  businessUnit?: InputMaybe<BusinessUnitsOrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  gpPerManDayGoalUsc?: InputMaybe<OrderBy>;
  gpPerManDayTargetUsc?: InputMaybe<OrderBy>;
};

/** select columns of table "current_business_unit_target_metrics_view" */
export type CurrentBusinessUnitTargetMetricsViewSelectColumn =
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'gpPerManDayGoalUsc'
  /** column name */
  | 'gpPerManDayTargetUsc';

/** aggregate stddev on columns */
export type CurrentBusinessUnitTargetMetricsViewStddevFields = {
  __typename?: 'CurrentBusinessUnitTargetMetricsViewStddevFields';
  gpPerManDayGoalUsc?: Maybe<Scalars['Float']>;
  gpPerManDayTargetUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type CurrentBusinessUnitTargetMetricsViewStddevPopFields = {
  __typename?: 'CurrentBusinessUnitTargetMetricsViewStddevPopFields';
  gpPerManDayGoalUsc?: Maybe<Scalars['Float']>;
  gpPerManDayTargetUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type CurrentBusinessUnitTargetMetricsViewStddevSampFields = {
  __typename?: 'CurrentBusinessUnitTargetMetricsViewStddevSampFields';
  gpPerManDayGoalUsc?: Maybe<Scalars['Float']>;
  gpPerManDayTargetUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "current_business_unit_target_metrics_view" */
export type CurrentBusinessUnitTargetMetricsViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CurrentBusinessUnitTargetMetricsViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CurrentBusinessUnitTargetMetricsViewStreamCursorValueInput = {
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  gpPerManDayGoalUsc?: InputMaybe<Scalars['numeric']>;
  gpPerManDayTargetUsc?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type CurrentBusinessUnitTargetMetricsViewSumFields = {
  __typename?: 'CurrentBusinessUnitTargetMetricsViewSumFields';
  gpPerManDayGoalUsc?: Maybe<Scalars['numeric']>;
  gpPerManDayTargetUsc?: Maybe<Scalars['numeric']>;
};

/** aggregate varPop on columns */
export type CurrentBusinessUnitTargetMetricsViewVarPopFields = {
  __typename?: 'CurrentBusinessUnitTargetMetricsViewVarPopFields';
  gpPerManDayGoalUsc?: Maybe<Scalars['Float']>;
  gpPerManDayTargetUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type CurrentBusinessUnitTargetMetricsViewVarSampFields = {
  __typename?: 'CurrentBusinessUnitTargetMetricsViewVarSampFields';
  gpPerManDayGoalUsc?: Maybe<Scalars['Float']>;
  gpPerManDayTargetUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CurrentBusinessUnitTargetMetricsViewVarianceFields = {
  __typename?: 'CurrentBusinessUnitTargetMetricsViewVarianceFields';
  gpPerManDayGoalUsc?: Maybe<Scalars['Float']>;
  gpPerManDayTargetUsc?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "current_company_tax_configurations_view" */
export type CurrentCompanyTaxConfigurationsView = {
  __typename?: 'CurrentCompanyTaxConfigurationsView';
  /** An object relationship */
  company?: Maybe<Companies>;
  companyGuid?: Maybe<Scalars['uuid']>;
  taxRoundingStrategy: Scalars['TaxRoundingStrategy'];
};

/** aggregated selection of "current_company_tax_configurations_view" */
export type CurrentCompanyTaxConfigurationsViewAggregate = {
  __typename?: 'CurrentCompanyTaxConfigurationsViewAggregate';
  aggregate?: Maybe<CurrentCompanyTaxConfigurationsViewAggregateFields>;
  nodes: Array<CurrentCompanyTaxConfigurationsView>;
};

/** aggregate fields of "current_company_tax_configurations_view" */
export type CurrentCompanyTaxConfigurationsViewAggregateFields = {
  __typename?: 'CurrentCompanyTaxConfigurationsViewAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CurrentCompanyTaxConfigurationsViewMaxFields>;
  min?: Maybe<CurrentCompanyTaxConfigurationsViewMinFields>;
};


/** aggregate fields of "current_company_tax_configurations_view" */
export type CurrentCompanyTaxConfigurationsViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CurrentCompanyTaxConfigurationsViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "current_company_tax_configurations_view". All fields are combined with a logical 'AND'. */
export type CurrentCompanyTaxConfigurationsViewBoolExp = {
  _and?: InputMaybe<Array<CurrentCompanyTaxConfigurationsViewBoolExp>>;
  _not?: InputMaybe<CurrentCompanyTaxConfigurationsViewBoolExp>;
  _or?: InputMaybe<Array<CurrentCompanyTaxConfigurationsViewBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategyComparisonExp']>;
};

/** input type for inserting data into table "current_company_tax_configurations_view" */
export type CurrentCompanyTaxConfigurationsViewInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
};

/** aggregate max on columns */
export type CurrentCompanyTaxConfigurationsViewMaxFields = {
  __typename?: 'CurrentCompanyTaxConfigurationsViewMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  taxRoundingStrategy?: Maybe<Scalars['TaxRoundingStrategy']>;
};

/** aggregate min on columns */
export type CurrentCompanyTaxConfigurationsViewMinFields = {
  __typename?: 'CurrentCompanyTaxConfigurationsViewMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  taxRoundingStrategy?: Maybe<Scalars['TaxRoundingStrategy']>;
};

/** response of any mutation on the table "current_company_tax_configurations_view" */
export type CurrentCompanyTaxConfigurationsViewMutationResponse = {
  __typename?: 'CurrentCompanyTaxConfigurationsViewMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CurrentCompanyTaxConfigurationsView>;
};

/** input type for inserting object relation for remote table "current_company_tax_configurations_view" */
export type CurrentCompanyTaxConfigurationsViewObjRelInsertInput = {
  data: CurrentCompanyTaxConfigurationsViewInsertInput;
};

/** Ordering options when selecting data from "current_company_tax_configurations_view". */
export type CurrentCompanyTaxConfigurationsViewOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  taxRoundingStrategy?: InputMaybe<OrderBy>;
};

/** select columns of table "current_company_tax_configurations_view" */
export type CurrentCompanyTaxConfigurationsViewSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'taxRoundingStrategy';

/** input type for updating data in table "current_company_tax_configurations_view" */
export type CurrentCompanyTaxConfigurationsViewSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
};

/** Streaming cursor of the table "current_company_tax_configurations_view" */
export type CurrentCompanyTaxConfigurationsViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CurrentCompanyTaxConfigurationsViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CurrentCompanyTaxConfigurationsViewStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
};

export type CurrentCompanyTaxConfigurationsViewUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CurrentCompanyTaxConfigurationsViewSetInput>;
  /** filter the rows which have to be updated */
  where: CurrentCompanyTaxConfigurationsViewBoolExp;
};

/** columns and relationships of "current_user_business_units_view" */
export type CurrentUserBusinessUnitsView = {
  __typename?: 'CurrentUserBusinessUnitsView';
  /** An object relationship */
  businessUnit?: Maybe<BusinessUnits>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  company?: Maybe<Companies>;
  companyGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "current_user_business_units_view" */
export type CurrentUserBusinessUnitsViewAggregate = {
  __typename?: 'CurrentUserBusinessUnitsViewAggregate';
  aggregate?: Maybe<CurrentUserBusinessUnitsViewAggregateFields>;
  nodes: Array<CurrentUserBusinessUnitsView>;
};

/** aggregate fields of "current_user_business_units_view" */
export type CurrentUserBusinessUnitsViewAggregateFields = {
  __typename?: 'CurrentUserBusinessUnitsViewAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CurrentUserBusinessUnitsViewMaxFields>;
  min?: Maybe<CurrentUserBusinessUnitsViewMinFields>;
};


/** aggregate fields of "current_user_business_units_view" */
export type CurrentUserBusinessUnitsViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CurrentUserBusinessUnitsViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "current_user_business_units_view". All fields are combined with a logical 'AND'. */
export type CurrentUserBusinessUnitsViewBoolExp = {
  _and?: InputMaybe<Array<CurrentUserBusinessUnitsViewBoolExp>>;
  _not?: InputMaybe<CurrentUserBusinessUnitsViewBoolExp>;
  _or?: InputMaybe<Array<CurrentUserBusinessUnitsViewBoolExp>>;
  businessUnit?: InputMaybe<BusinessUnitsBoolExp>;
  businessUnitGuid?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** input type for inserting data into table "current_user_business_units_view" */
export type CurrentUserBusinessUnitsViewInsertInput = {
  businessUnit?: InputMaybe<BusinessUnitsObjRelInsertInput>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type CurrentUserBusinessUnitsViewMaxFields = {
  __typename?: 'CurrentUserBusinessUnitsViewMaxFields';
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type CurrentUserBusinessUnitsViewMinFields = {
  __typename?: 'CurrentUserBusinessUnitsViewMinFields';
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "current_user_business_units_view" */
export type CurrentUserBusinessUnitsViewMutationResponse = {
  __typename?: 'CurrentUserBusinessUnitsViewMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CurrentUserBusinessUnitsView>;
};

/** Ordering options when selecting data from "current_user_business_units_view". */
export type CurrentUserBusinessUnitsViewOrderBy = {
  businessUnit?: InputMaybe<BusinessUnitsOrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** select columns of table "current_user_business_units_view" */
export type CurrentUserBusinessUnitsViewSelectColumn =
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "current_user_business_units_view" */
export type CurrentUserBusinessUnitsViewSetInput = {
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "current_user_business_units_view" */
export type CurrentUserBusinessUnitsViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CurrentUserBusinessUnitsViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CurrentUserBusinessUnitsViewStreamCursorValueInput = {
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

export type CurrentUserBusinessUnitsViewUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CurrentUserBusinessUnitsViewSetInput>;
  /** filter the rows which have to be updated */
  where: CurrentUserBusinessUnitsViewBoolExp;
};

/** ordering argument of a cursor */
export type CursorOrdering =
  /** ascending ordering of the cursor */
  | 'ASC'
  /** descending ordering of the cursor */
  | 'DESC';

/** columns and relationships of "customer_communication_templates" */
export type CustomerCommunicationTemplates = {
  __typename?: 'CustomerCommunicationTemplates';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  mustacheTemplate: Scalars['MustacheTemplate'];
  name: Scalars['CustomerCommunicationTemplateName'];
  type: Scalars['CustomerCommunicationTemplateType'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "customer_communication_templates" */
export type CustomerCommunicationTemplatesAggregate = {
  __typename?: 'CustomerCommunicationTemplatesAggregate';
  aggregate?: Maybe<CustomerCommunicationTemplatesAggregateFields>;
  nodes: Array<CustomerCommunicationTemplates>;
};

/** aggregate fields of "customer_communication_templates" */
export type CustomerCommunicationTemplatesAggregateFields = {
  __typename?: 'CustomerCommunicationTemplatesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<CustomerCommunicationTemplatesMaxFields>;
  min?: Maybe<CustomerCommunicationTemplatesMinFields>;
};


/** aggregate fields of "customer_communication_templates" */
export type CustomerCommunicationTemplatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CustomerCommunicationTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "customer_communication_templates". All fields are combined with a logical 'AND'. */
export type CustomerCommunicationTemplatesBoolExp = {
  _and?: InputMaybe<Array<CustomerCommunicationTemplatesBoolExp>>;
  _not?: InputMaybe<CustomerCommunicationTemplatesBoolExp>;
  _or?: InputMaybe<Array<CustomerCommunicationTemplatesBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  mustacheTemplate?: InputMaybe<Scalars['MustacheTemplateComparisonExp']>;
  name?: InputMaybe<Scalars['CustomerCommunicationTemplateNameComparisonExp']>;
  type?: InputMaybe<Scalars['CustomerCommunicationTemplateTypeComparisonExp']>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "customer_communication_templates" */
export type CustomerCommunicationTemplatesConstraint =
  /** unique or primary key constraint on columns "type", "company_guid", "name" */
  | 'customer_communication_templates_pkey';

/** input type for inserting data into table "customer_communication_templates" */
export type CustomerCommunicationTemplatesInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  mustacheTemplate?: InputMaybe<Scalars['MustacheTemplate']>;
  name?: InputMaybe<Scalars['CustomerCommunicationTemplateName']>;
  type?: InputMaybe<Scalars['CustomerCommunicationTemplateType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type CustomerCommunicationTemplatesMaxFields = {
  __typename?: 'CustomerCommunicationTemplatesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  mustacheTemplate?: Maybe<Scalars['MustacheTemplate']>;
  name?: Maybe<Scalars['CustomerCommunicationTemplateName']>;
  type?: Maybe<Scalars['CustomerCommunicationTemplateType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type CustomerCommunicationTemplatesMinFields = {
  __typename?: 'CustomerCommunicationTemplatesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  mustacheTemplate?: Maybe<Scalars['MustacheTemplate']>;
  name?: Maybe<Scalars['CustomerCommunicationTemplateName']>;
  type?: Maybe<Scalars['CustomerCommunicationTemplateType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "customer_communication_templates" */
export type CustomerCommunicationTemplatesMutationResponse = {
  __typename?: 'CustomerCommunicationTemplatesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomerCommunicationTemplates>;
};

/** on_conflict condition type for table "customer_communication_templates" */
export type CustomerCommunicationTemplatesOnConflict = {
  constraint: CustomerCommunicationTemplatesConstraint;
  updateColumns?: Array<CustomerCommunicationTemplatesUpdateColumn>;
  where?: InputMaybe<CustomerCommunicationTemplatesBoolExp>;
};

/** Ordering options when selecting data from "customer_communication_templates". */
export type CustomerCommunicationTemplatesOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  mustacheTemplate?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: customer_communication_templates */
export type CustomerCommunicationTemplatesPkColumnsInput = {
  companyGuid: Scalars['uuid'];
  name: Scalars['String'];
  type: Scalars['String'];
};

/** select columns of table "customer_communication_templates" */
export type CustomerCommunicationTemplatesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'mustacheTemplate'
  /** column name */
  | 'name'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "customer_communication_templates" */
export type CustomerCommunicationTemplatesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  mustacheTemplate?: InputMaybe<Scalars['MustacheTemplate']>;
  name?: InputMaybe<Scalars['CustomerCommunicationTemplateName']>;
  type?: InputMaybe<Scalars['CustomerCommunicationTemplateType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "customer_communication_templates" */
export type CustomerCommunicationTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CustomerCommunicationTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CustomerCommunicationTemplatesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  mustacheTemplate?: InputMaybe<Scalars['MustacheTemplate']>;
  name?: InputMaybe<Scalars['CustomerCommunicationTemplateName']>;
  type?: InputMaybe<Scalars['CustomerCommunicationTemplateType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "customer_communication_templates" */
export type CustomerCommunicationTemplatesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'mustacheTemplate'
  /** column name */
  | 'name'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt';

export type CustomerCommunicationTemplatesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomerCommunicationTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: CustomerCommunicationTemplatesBoolExp;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type DateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** Extends the entitlements schema to include additional information for entitlements with a "DISCOUNT" type */
export type DiscountEntitlements = {
  __typename?: 'DiscountEntitlements';
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discountJobClass?: Maybe<Scalars['String']>;
  discountRate?: Maybe<Scalars['numeric']>;
  entitlementGuid: Scalars['uuid'];
};

/** aggregated selection of "discount_entitlements" */
export type DiscountEntitlementsAggregate = {
  __typename?: 'DiscountEntitlementsAggregate';
  aggregate?: Maybe<DiscountEntitlementsAggregateFields>;
  nodes: Array<DiscountEntitlements>;
};

/** aggregate fields of "discount_entitlements" */
export type DiscountEntitlementsAggregateFields = {
  __typename?: 'DiscountEntitlementsAggregateFields';
  avg?: Maybe<DiscountEntitlementsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DiscountEntitlementsMaxFields>;
  min?: Maybe<DiscountEntitlementsMinFields>;
  stddev?: Maybe<DiscountEntitlementsStddevFields>;
  stddevPop?: Maybe<DiscountEntitlementsStddevPopFields>;
  stddevSamp?: Maybe<DiscountEntitlementsStddevSampFields>;
  sum?: Maybe<DiscountEntitlementsSumFields>;
  varPop?: Maybe<DiscountEntitlementsVarPopFields>;
  varSamp?: Maybe<DiscountEntitlementsVarSampFields>;
  variance?: Maybe<DiscountEntitlementsVarianceFields>;
};


/** aggregate fields of "discount_entitlements" */
export type DiscountEntitlementsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DiscountEntitlementsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DiscountEntitlementsAvgFields = {
  __typename?: 'DiscountEntitlementsAvgFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "discount_entitlements". All fields are combined with a logical 'AND'. */
export type DiscountEntitlementsBoolExp = {
  _and?: InputMaybe<Array<DiscountEntitlementsBoolExp>>;
  _not?: InputMaybe<DiscountEntitlementsBoolExp>;
  _or?: InputMaybe<Array<DiscountEntitlementsBoolExp>>;
  discountAmountUsc?: InputMaybe<IntComparisonExp>;
  discountJobClass?: InputMaybe<StringComparisonExp>;
  discountRate?: InputMaybe<NumericComparisonExp>;
  entitlementGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "discount_entitlements" */
export type DiscountEntitlementsConstraint =
  /** unique or primary key constraint on columns "entitlement_guid" */
  | 'discount_entitlements_pkey';

/** input type for incrementing numeric columns in table "discount_entitlements" */
export type DiscountEntitlementsIncInput = {
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "discount_entitlements" */
export type DiscountEntitlementsInsertInput = {
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discountJobClass?: InputMaybe<Scalars['String']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  entitlementGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type DiscountEntitlementsMaxFields = {
  __typename?: 'DiscountEntitlementsMaxFields';
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discountJobClass?: Maybe<Scalars['String']>;
  discountRate?: Maybe<Scalars['numeric']>;
  entitlementGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type DiscountEntitlementsMinFields = {
  __typename?: 'DiscountEntitlementsMinFields';
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discountJobClass?: Maybe<Scalars['String']>;
  discountRate?: Maybe<Scalars['numeric']>;
  entitlementGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "discount_entitlements" */
export type DiscountEntitlementsMutationResponse = {
  __typename?: 'DiscountEntitlementsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DiscountEntitlements>;
};

/** on_conflict condition type for table "discount_entitlements" */
export type DiscountEntitlementsOnConflict = {
  constraint: DiscountEntitlementsConstraint;
  updateColumns?: Array<DiscountEntitlementsUpdateColumn>;
  where?: InputMaybe<DiscountEntitlementsBoolExp>;
};

/** Ordering options when selecting data from "discount_entitlements". */
export type DiscountEntitlementsOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountJobClass?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  entitlementGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: discount_entitlements */
export type DiscountEntitlementsPkColumnsInput = {
  entitlementGuid: Scalars['uuid'];
};

/** select columns of table "discount_entitlements" */
export type DiscountEntitlementsSelectColumn =
  /** column name */
  | 'discountAmountUsc'
  /** column name */
  | 'discountJobClass'
  /** column name */
  | 'discountRate'
  /** column name */
  | 'entitlementGuid';

/** input type for updating data in table "discount_entitlements" */
export type DiscountEntitlementsSetInput = {
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discountJobClass?: InputMaybe<Scalars['String']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  entitlementGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type DiscountEntitlementsStddevFields = {
  __typename?: 'DiscountEntitlementsStddevFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type DiscountEntitlementsStddevPopFields = {
  __typename?: 'DiscountEntitlementsStddevPopFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type DiscountEntitlementsStddevSampFields = {
  __typename?: 'DiscountEntitlementsStddevSampFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "discount_entitlements" */
export type DiscountEntitlementsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DiscountEntitlementsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DiscountEntitlementsStreamCursorValueInput = {
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discountJobClass?: InputMaybe<Scalars['String']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  entitlementGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type DiscountEntitlementsSumFields = {
  __typename?: 'DiscountEntitlementsSumFields';
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['numeric']>;
};

/** update columns of table "discount_entitlements" */
export type DiscountEntitlementsUpdateColumn =
  /** column name */
  | 'discountAmountUsc'
  /** column name */
  | 'discountJobClass'
  /** column name */
  | 'discountRate'
  /** column name */
  | 'entitlementGuid';

export type DiscountEntitlementsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DiscountEntitlementsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DiscountEntitlementsSetInput>;
  /** filter the rows which have to be updated */
  where: DiscountEntitlementsBoolExp;
};

/** aggregate varPop on columns */
export type DiscountEntitlementsVarPopFields = {
  __typename?: 'DiscountEntitlementsVarPopFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type DiscountEntitlementsVarSampFields = {
  __typename?: 'DiscountEntitlementsVarSampFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DiscountEntitlementsVarianceFields = {
  __typename?: 'DiscountEntitlementsVarianceFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "display_id_counters" */
export type DisplayIdCounters = {
  __typename?: 'DisplayIdCounters';
  companyGuid: Scalars['uuid'];
  counter: Scalars['bigint'];
  entityType: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "display_id_counters" */
export type DisplayIdCountersAggregate = {
  __typename?: 'DisplayIdCountersAggregate';
  aggregate?: Maybe<DisplayIdCountersAggregateFields>;
  nodes: Array<DisplayIdCounters>;
};

/** aggregate fields of "display_id_counters" */
export type DisplayIdCountersAggregateFields = {
  __typename?: 'DisplayIdCountersAggregateFields';
  avg?: Maybe<DisplayIdCountersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DisplayIdCountersMaxFields>;
  min?: Maybe<DisplayIdCountersMinFields>;
  stddev?: Maybe<DisplayIdCountersStddevFields>;
  stddevPop?: Maybe<DisplayIdCountersStddevPopFields>;
  stddevSamp?: Maybe<DisplayIdCountersStddevSampFields>;
  sum?: Maybe<DisplayIdCountersSumFields>;
  varPop?: Maybe<DisplayIdCountersVarPopFields>;
  varSamp?: Maybe<DisplayIdCountersVarSampFields>;
  variance?: Maybe<DisplayIdCountersVarianceFields>;
};


/** aggregate fields of "display_id_counters" */
export type DisplayIdCountersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DisplayIdCountersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DisplayIdCountersAvgFields = {
  __typename?: 'DisplayIdCountersAvgFields';
  counter?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "display_id_counters". All fields are combined with a logical 'AND'. */
export type DisplayIdCountersBoolExp = {
  _and?: InputMaybe<Array<DisplayIdCountersBoolExp>>;
  _not?: InputMaybe<DisplayIdCountersBoolExp>;
  _or?: InputMaybe<Array<DisplayIdCountersBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  counter?: InputMaybe<BigintComparisonExp>;
  entityType?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "display_id_counters" */
export type DisplayIdCountersConstraint =
  /** unique or primary key constraint on columns "entity_type", "company_guid" */
  | 'display_id_counters_pkey';

/** input type for incrementing numeric columns in table "display_id_counters" */
export type DisplayIdCountersIncInput = {
  counter?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "display_id_counters" */
export type DisplayIdCountersInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  counter?: InputMaybe<Scalars['bigint']>;
  entityType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type DisplayIdCountersMaxFields = {
  __typename?: 'DisplayIdCountersMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  counter?: Maybe<Scalars['bigint']>;
  entityType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type DisplayIdCountersMinFields = {
  __typename?: 'DisplayIdCountersMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  counter?: Maybe<Scalars['bigint']>;
  entityType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "display_id_counters" */
export type DisplayIdCountersMutationResponse = {
  __typename?: 'DisplayIdCountersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DisplayIdCounters>;
};

/** on_conflict condition type for table "display_id_counters" */
export type DisplayIdCountersOnConflict = {
  constraint: DisplayIdCountersConstraint;
  updateColumns?: Array<DisplayIdCountersUpdateColumn>;
  where?: InputMaybe<DisplayIdCountersBoolExp>;
};

/** Ordering options when selecting data from "display_id_counters". */
export type DisplayIdCountersOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  counter?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: display_id_counters */
export type DisplayIdCountersPkColumnsInput = {
  companyGuid: Scalars['uuid'];
  entityType: Scalars['String'];
};

/** select columns of table "display_id_counters" */
export type DisplayIdCountersSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'counter'
  /** column name */
  | 'entityType'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "display_id_counters" */
export type DisplayIdCountersSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  counter?: InputMaybe<Scalars['bigint']>;
  entityType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type DisplayIdCountersStddevFields = {
  __typename?: 'DisplayIdCountersStddevFields';
  counter?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type DisplayIdCountersStddevPopFields = {
  __typename?: 'DisplayIdCountersStddevPopFields';
  counter?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type DisplayIdCountersStddevSampFields = {
  __typename?: 'DisplayIdCountersStddevSampFields';
  counter?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "display_id_counters" */
export type DisplayIdCountersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DisplayIdCountersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DisplayIdCountersStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  counter?: InputMaybe<Scalars['bigint']>;
  entityType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type DisplayIdCountersSumFields = {
  __typename?: 'DisplayIdCountersSumFields';
  counter?: Maybe<Scalars['bigint']>;
};

/** update columns of table "display_id_counters" */
export type DisplayIdCountersUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'counter'
  /** column name */
  | 'entityType'
  /** column name */
  | 'updatedAt';

export type DisplayIdCountersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DisplayIdCountersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DisplayIdCountersSetInput>;
  /** filter the rows which have to be updated */
  where: DisplayIdCountersBoolExp;
};

/** aggregate varPop on columns */
export type DisplayIdCountersVarPopFields = {
  __typename?: 'DisplayIdCountersVarPopFields';
  counter?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type DisplayIdCountersVarSampFields = {
  __typename?: 'DisplayIdCountersVarSampFields';
  counter?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DisplayIdCountersVarianceFields = {
  __typename?: 'DisplayIdCountersVarianceFields';
  counter?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "drip_marketing_emails" */
export type DripMarketingEmails = {
  __typename?: 'DripMarketingEmails';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  dripMarketingEmailGuid: Scalars['uuid'];
  emailBody: Scalars['String'];
  emailSubject: Scalars['String'];
  recipientEmailAddress: Scalars['String'];
  sendAt: Scalars['timestamptz'];
  sent: Scalars['Boolean'];
};

/** aggregated selection of "drip_marketing_emails" */
export type DripMarketingEmailsAggregate = {
  __typename?: 'DripMarketingEmailsAggregate';
  aggregate?: Maybe<DripMarketingEmailsAggregateFields>;
  nodes: Array<DripMarketingEmails>;
};

/** aggregate fields of "drip_marketing_emails" */
export type DripMarketingEmailsAggregateFields = {
  __typename?: 'DripMarketingEmailsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<DripMarketingEmailsMaxFields>;
  min?: Maybe<DripMarketingEmailsMinFields>;
};


/** aggregate fields of "drip_marketing_emails" */
export type DripMarketingEmailsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DripMarketingEmailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "drip_marketing_emails". All fields are combined with a logical 'AND'. */
export type DripMarketingEmailsBoolExp = {
  _and?: InputMaybe<Array<DripMarketingEmailsBoolExp>>;
  _not?: InputMaybe<DripMarketingEmailsBoolExp>;
  _or?: InputMaybe<Array<DripMarketingEmailsBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  dripMarketingEmailGuid?: InputMaybe<UuidComparisonExp>;
  emailBody?: InputMaybe<StringComparisonExp>;
  emailSubject?: InputMaybe<StringComparisonExp>;
  recipientEmailAddress?: InputMaybe<StringComparisonExp>;
  sendAt?: InputMaybe<TimestamptzComparisonExp>;
  sent?: InputMaybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "drip_marketing_emails" */
export type DripMarketingEmailsConstraint =
  /** unique or primary key constraint on columns "drip_marketing_email_guid" */
  | 'drip_marketing_email_campaigns_pkey';

/** input type for inserting data into table "drip_marketing_emails" */
export type DripMarketingEmailsInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dripMarketingEmailGuid?: InputMaybe<Scalars['uuid']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  recipientEmailAddress?: InputMaybe<Scalars['String']>;
  sendAt?: InputMaybe<Scalars['timestamptz']>;
  sent?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type DripMarketingEmailsMaxFields = {
  __typename?: 'DripMarketingEmailsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  dripMarketingEmailGuid?: Maybe<Scalars['uuid']>;
  emailBody?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  recipientEmailAddress?: Maybe<Scalars['String']>;
  sendAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type DripMarketingEmailsMinFields = {
  __typename?: 'DripMarketingEmailsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  dripMarketingEmailGuid?: Maybe<Scalars['uuid']>;
  emailBody?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  recipientEmailAddress?: Maybe<Scalars['String']>;
  sendAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "drip_marketing_emails" */
export type DripMarketingEmailsMutationResponse = {
  __typename?: 'DripMarketingEmailsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DripMarketingEmails>;
};

/** on_conflict condition type for table "drip_marketing_emails" */
export type DripMarketingEmailsOnConflict = {
  constraint: DripMarketingEmailsConstraint;
  updateColumns?: Array<DripMarketingEmailsUpdateColumn>;
  where?: InputMaybe<DripMarketingEmailsBoolExp>;
};

/** Ordering options when selecting data from "drip_marketing_emails". */
export type DripMarketingEmailsOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  dripMarketingEmailGuid?: InputMaybe<OrderBy>;
  emailBody?: InputMaybe<OrderBy>;
  emailSubject?: InputMaybe<OrderBy>;
  recipientEmailAddress?: InputMaybe<OrderBy>;
  sendAt?: InputMaybe<OrderBy>;
  sent?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: drip_marketing_emails */
export type DripMarketingEmailsPkColumnsInput = {
  dripMarketingEmailGuid: Scalars['uuid'];
};

/** select columns of table "drip_marketing_emails" */
export type DripMarketingEmailsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dripMarketingEmailGuid'
  /** column name */
  | 'emailBody'
  /** column name */
  | 'emailSubject'
  /** column name */
  | 'recipientEmailAddress'
  /** column name */
  | 'sendAt'
  /** column name */
  | 'sent';

/** input type for updating data in table "drip_marketing_emails" */
export type DripMarketingEmailsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dripMarketingEmailGuid?: InputMaybe<Scalars['uuid']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  recipientEmailAddress?: InputMaybe<Scalars['String']>;
  sendAt?: InputMaybe<Scalars['timestamptz']>;
  sent?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "drip_marketing_emails" */
export type DripMarketingEmailsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DripMarketingEmailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DripMarketingEmailsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dripMarketingEmailGuid?: InputMaybe<Scalars['uuid']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  recipientEmailAddress?: InputMaybe<Scalars['String']>;
  sendAt?: InputMaybe<Scalars['timestamptz']>;
  sent?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "drip_marketing_emails" */
export type DripMarketingEmailsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dripMarketingEmailGuid'
  /** column name */
  | 'emailBody'
  /** column name */
  | 'emailSubject'
  /** column name */
  | 'recipientEmailAddress'
  /** column name */
  | 'sendAt'
  /** column name */
  | 'sent';

export type DripMarketingEmailsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DripMarketingEmailsSetInput>;
  /** filter the rows which have to be updated */
  where: DripMarketingEmailsBoolExp;
};

/** columns and relationships of "email_addresses" */
export type EmailAddresses = {
  __typename?: 'EmailAddresses';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  emailAddress: Scalars['String'];
  emailAddressGuid: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "email_addresses" */
export type EmailAddressesAggregate = {
  __typename?: 'EmailAddressesAggregate';
  aggregate?: Maybe<EmailAddressesAggregateFields>;
  nodes: Array<EmailAddresses>;
};

/** aggregate fields of "email_addresses" */
export type EmailAddressesAggregateFields = {
  __typename?: 'EmailAddressesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EmailAddressesMaxFields>;
  min?: Maybe<EmailAddressesMinFields>;
};


/** aggregate fields of "email_addresses" */
export type EmailAddressesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EmailAddressesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "email_addresses". All fields are combined with a logical 'AND'. */
export type EmailAddressesBoolExp = {
  _and?: InputMaybe<Array<EmailAddressesBoolExp>>;
  _not?: InputMaybe<EmailAddressesBoolExp>;
  _or?: InputMaybe<Array<EmailAddressesBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  emailAddress?: InputMaybe<StringComparisonExp>;
  emailAddressGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "email_addresses" */
export type EmailAddressesConstraint =
  /** unique or primary key constraint on columns "email_address_guid" */
  | 'email_addresses_pkey';

/** input type for inserting data into table "email_addresses" */
export type EmailAddressesInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  emailAddressGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EmailAddressesMaxFields = {
  __typename?: 'EmailAddressesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  emailAddress?: Maybe<Scalars['String']>;
  emailAddressGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type EmailAddressesMinFields = {
  __typename?: 'EmailAddressesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  emailAddress?: Maybe<Scalars['String']>;
  emailAddressGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "email_addresses" */
export type EmailAddressesMutationResponse = {
  __typename?: 'EmailAddressesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EmailAddresses>;
};

/** input type for inserting object relation for remote table "email_addresses" */
export type EmailAddressesObjRelInsertInput = {
  data: EmailAddressesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EmailAddressesOnConflict>;
};

/** on_conflict condition type for table "email_addresses" */
export type EmailAddressesOnConflict = {
  constraint: EmailAddressesConstraint;
  updateColumns?: Array<EmailAddressesUpdateColumn>;
  where?: InputMaybe<EmailAddressesBoolExp>;
};

/** Ordering options when selecting data from "email_addresses". */
export type EmailAddressesOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  emailAddressGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: email_addresses */
export type EmailAddressesPkColumnsInput = {
  emailAddressGuid: Scalars['uuid'];
};

/** select columns of table "email_addresses" */
export type EmailAddressesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'emailAddressGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "email_addresses" */
export type EmailAddressesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  emailAddressGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "email_addresses" */
export type EmailAddressesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EmailAddressesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EmailAddressesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  emailAddressGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "email_addresses" */
export type EmailAddressesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'emailAddressGuid'
  /** column name */
  | 'updatedAt';

export type EmailAddressesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EmailAddressesSetInput>;
  /** filter the rows which have to be updated */
  where: EmailAddressesBoolExp;
};

export type EntitlementTypes = {
  __typename?: 'EntitlementTypes';
  type: Scalars['EntitlementType'];
};

export type EntitlementTypesBoolExp = {
  __typename?: 'EntitlementTypesBoolExp';
  type?: Maybe<Scalars['EntitlementTypeComparisonExp']>;
};

export type EntitlementTypesInsertInput = {
  __typename?: 'EntitlementTypesInsertInput';
  type?: Maybe<Scalars['EntitlementType']>;
};

export type EntitlementTypesMaxFields = {
  __typename?: 'EntitlementTypesMaxFields';
  type?: Maybe<Scalars['EntitlementType']>;
};

export type EntitlementTypesMinFields = {
  __typename?: 'EntitlementTypesMinFields';
  type?: Maybe<Scalars['EntitlementType']>;
};

export type EntitlementTypesSetInput = {
  __typename?: 'EntitlementTypesSetInput';
  type?: Maybe<Scalars['EntitlementType']>;
};

export type EntitlementTypesStreamCursorValueInput = {
  __typename?: 'EntitlementTypesStreamCursorValueInput';
  type?: Maybe<Scalars['EntitlementType']>;
};

/** columns and relationships of "entitlements" */
export type Entitlements = {
  __typename?: 'Entitlements';
  accountGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  entitlementGuid: Scalars['uuid'];
  expiresAt?: Maybe<Scalars['timestamptz']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamp'];
};

/** aggregated selection of "entitlements" */
export type EntitlementsAggregate = {
  __typename?: 'EntitlementsAggregate';
  aggregate?: Maybe<EntitlementsAggregateFields>;
  nodes: Array<Entitlements>;
};

/** aggregate fields of "entitlements" */
export type EntitlementsAggregateFields = {
  __typename?: 'EntitlementsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EntitlementsMaxFields>;
  min?: Maybe<EntitlementsMinFields>;
};


/** aggregate fields of "entitlements" */
export type EntitlementsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EntitlementsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "entitlements". All fields are combined with a logical 'AND'. */
export type EntitlementsBoolExp = {
  _and?: InputMaybe<Array<EntitlementsBoolExp>>;
  _not?: InputMaybe<EntitlementsBoolExp>;
  _or?: InputMaybe<Array<EntitlementsBoolExp>>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  entitlementGuid?: InputMaybe<UuidComparisonExp>;
  expiresAt?: InputMaybe<TimestamptzComparisonExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestampComparisonExp>;
};

/** unique or primary key constraints on table "entitlements" */
export type EntitlementsConstraint =
  /** unique or primary key constraint on columns "entitlement_guid" */
  | 'entitlements_pkey';

/** input type for inserting data into table "entitlements" */
export type EntitlementsInsertInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  entitlementGuid?: InputMaybe<Scalars['uuid']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type EntitlementsMaxFields = {
  __typename?: 'EntitlementsMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  entitlementGuid?: Maybe<Scalars['uuid']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type EntitlementsMinFields = {
  __typename?: 'EntitlementsMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  entitlementGuid?: Maybe<Scalars['uuid']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "entitlements" */
export type EntitlementsMutationResponse = {
  __typename?: 'EntitlementsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Entitlements>;
};

/** on_conflict condition type for table "entitlements" */
export type EntitlementsOnConflict = {
  constraint: EntitlementsConstraint;
  updateColumns?: Array<EntitlementsUpdateColumn>;
  where?: InputMaybe<EntitlementsBoolExp>;
};

/** Ordering options when selecting data from "entitlements". */
export type EntitlementsOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  entitlementGuid?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: entitlements */
export type EntitlementsPkColumnsInput = {
  entitlementGuid: Scalars['uuid'];
};

/** select columns of table "entitlements" */
export type EntitlementsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deletedAt'
  /** column name */
  | 'description'
  /** column name */
  | 'entitlementGuid'
  /** column name */
  | 'expiresAt'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "entitlements" */
export type EntitlementsSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  entitlementGuid?: InputMaybe<Scalars['uuid']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "entitlements" */
export type EntitlementsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EntitlementsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EntitlementsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  entitlementGuid?: InputMaybe<Scalars['uuid']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "entitlements" */
export type EntitlementsUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deletedAt'
  /** column name */
  | 'description'
  /** column name */
  | 'entitlementGuid'
  /** column name */
  | 'expiresAt'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt';

export type EntitlementsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntitlementsSetInput>;
  /** filter the rows which have to be updated */
  where: EntitlementsBoolExp;
};

/** columns and relationships of "equipment_type_links" */
export type EquipmentTypeLinks = {
  __typename?: 'EquipmentTypeLinks';
  appointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  appointmentGuid?: Maybe<Scalars['uuid']>;
  equipmentType: Scalars['EquipmentType'];
  equipmentTypeLinkGuid: Scalars['uuid'];
  /** An object relationship */
  equipmentTypeName: EquipmentTypes;
  estimatedEquipmentAge?: Maybe<Scalars['String']>;
  /** An object relationship */
  job?: Maybe<Jobs>;
  /** An object relationship */
  jobAppointment?: Maybe<JobAppointments>;
  /** An object relationship */
  jobAppointmentAssignment?: Maybe<JobAppointmentAssignments>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  location?: Maybe<Locations>;
  locationGuid?: Maybe<Scalars['uuid']>;
  relationshipType: Scalars['JobToEquipmentRelationshipType'];
};

/** aggregated selection of "equipment_type_links" */
export type EquipmentTypeLinksAggregate = {
  __typename?: 'EquipmentTypeLinksAggregate';
  aggregate?: Maybe<EquipmentTypeLinksAggregateFields>;
  nodes: Array<EquipmentTypeLinks>;
};

export type EquipmentTypeLinksAggregateBoolExp = {
  count?: InputMaybe<EquipmentTypeLinksAggregateBoolExpCount>;
};

/** aggregate fields of "equipment_type_links" */
export type EquipmentTypeLinksAggregateFields = {
  __typename?: 'EquipmentTypeLinksAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EquipmentTypeLinksMaxFields>;
  min?: Maybe<EquipmentTypeLinksMinFields>;
};


/** aggregate fields of "equipment_type_links" */
export type EquipmentTypeLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EquipmentTypeLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "equipment_type_links" */
export type EquipmentTypeLinksAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EquipmentTypeLinksMaxOrderBy>;
  min?: InputMaybe<EquipmentTypeLinksMinOrderBy>;
};

/** input type for inserting array relation for remote table "equipment_type_links" */
export type EquipmentTypeLinksArrRelInsertInput = {
  data: Array<EquipmentTypeLinksInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EquipmentTypeLinksOnConflict>;
};

/** Boolean expression to filter rows from the table "equipment_type_links". All fields are combined with a logical 'AND'. */
export type EquipmentTypeLinksBoolExp = {
  _and?: InputMaybe<Array<EquipmentTypeLinksBoolExp>>;
  _not?: InputMaybe<EquipmentTypeLinksBoolExp>;
  _or?: InputMaybe<Array<EquipmentTypeLinksBoolExp>>;
  appointmentAssignmentGuid?: InputMaybe<UuidComparisonExp>;
  appointmentGuid?: InputMaybe<UuidComparisonExp>;
  equipmentType?: InputMaybe<Scalars['EquipmentTypeComparisonExp']>;
  equipmentTypeLinkGuid?: InputMaybe<UuidComparisonExp>;
  equipmentTypeName?: InputMaybe<EquipmentTypesBoolExp>;
  estimatedEquipmentAge?: InputMaybe<StringComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobAppointment?: InputMaybe<JobAppointmentsBoolExp>;
  jobAppointmentAssignment?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  relationshipType?: InputMaybe<Scalars['JobToEquipmentRelationshipTypeComparisonExp']>;
};

/** unique or primary key constraints on table "equipment_type_links" */
export type EquipmentTypeLinksConstraint =
  /** unique or primary key constraint on columns "equipment_type_link_guid" */
  | 'equipment_type_links_pkey';

/** input type for inserting data into table "equipment_type_links" */
export type EquipmentTypeLinksInsertInput = {
  appointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  appointmentGuid?: InputMaybe<Scalars['uuid']>;
  equipmentType?: InputMaybe<Scalars['EquipmentType']>;
  equipmentTypeLinkGuid?: InputMaybe<Scalars['uuid']>;
  equipmentTypeName?: InputMaybe<EquipmentTypesObjRelInsertInput>;
  estimatedEquipmentAge?: InputMaybe<Scalars['String']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobAppointment?: InputMaybe<JobAppointmentsObjRelInsertInput>;
  jobAppointmentAssignment?: InputMaybe<JobAppointmentAssignmentsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<LocationsObjRelInsertInput>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  relationshipType?: InputMaybe<Scalars['JobToEquipmentRelationshipType']>;
};

/** aggregate max on columns */
export type EquipmentTypeLinksMaxFields = {
  __typename?: 'EquipmentTypeLinksMaxFields';
  appointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  appointmentGuid?: Maybe<Scalars['uuid']>;
  equipmentType?: Maybe<Scalars['EquipmentType']>;
  equipmentTypeLinkGuid?: Maybe<Scalars['uuid']>;
  estimatedEquipmentAge?: Maybe<Scalars['String']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  relationshipType?: Maybe<Scalars['JobToEquipmentRelationshipType']>;
};

/** order by max() on columns of table "equipment_type_links" */
export type EquipmentTypeLinksMaxOrderBy = {
  appointmentAssignmentGuid?: InputMaybe<OrderBy>;
  appointmentGuid?: InputMaybe<OrderBy>;
  equipmentType?: InputMaybe<OrderBy>;
  equipmentTypeLinkGuid?: InputMaybe<OrderBy>;
  estimatedEquipmentAge?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  relationshipType?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EquipmentTypeLinksMinFields = {
  __typename?: 'EquipmentTypeLinksMinFields';
  appointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  appointmentGuid?: Maybe<Scalars['uuid']>;
  equipmentType?: Maybe<Scalars['EquipmentType']>;
  equipmentTypeLinkGuid?: Maybe<Scalars['uuid']>;
  estimatedEquipmentAge?: Maybe<Scalars['String']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  relationshipType?: Maybe<Scalars['JobToEquipmentRelationshipType']>;
};

/** order by min() on columns of table "equipment_type_links" */
export type EquipmentTypeLinksMinOrderBy = {
  appointmentAssignmentGuid?: InputMaybe<OrderBy>;
  appointmentGuid?: InputMaybe<OrderBy>;
  equipmentType?: InputMaybe<OrderBy>;
  equipmentTypeLinkGuid?: InputMaybe<OrderBy>;
  estimatedEquipmentAge?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  relationshipType?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "equipment_type_links" */
export type EquipmentTypeLinksMutationResponse = {
  __typename?: 'EquipmentTypeLinksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EquipmentTypeLinks>;
};

/** on_conflict condition type for table "equipment_type_links" */
export type EquipmentTypeLinksOnConflict = {
  constraint: EquipmentTypeLinksConstraint;
  updateColumns?: Array<EquipmentTypeLinksUpdateColumn>;
  where?: InputMaybe<EquipmentTypeLinksBoolExp>;
};

/** Ordering options when selecting data from "equipment_type_links". */
export type EquipmentTypeLinksOrderBy = {
  appointmentAssignmentGuid?: InputMaybe<OrderBy>;
  appointmentGuid?: InputMaybe<OrderBy>;
  equipmentType?: InputMaybe<OrderBy>;
  equipmentTypeLinkGuid?: InputMaybe<OrderBy>;
  equipmentTypeName?: InputMaybe<EquipmentTypesOrderBy>;
  estimatedEquipmentAge?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobAppointment?: InputMaybe<JobAppointmentsOrderBy>;
  jobAppointmentAssignment?: InputMaybe<JobAppointmentAssignmentsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  relationshipType?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: equipment_type_links */
export type EquipmentTypeLinksPkColumnsInput = {
  equipmentTypeLinkGuid: Scalars['uuid'];
};

/** select columns of table "equipment_type_links" */
export type EquipmentTypeLinksSelectColumn =
  /** column name */
  | 'appointmentAssignmentGuid'
  /** column name */
  | 'appointmentGuid'
  /** column name */
  | 'equipmentType'
  /** column name */
  | 'equipmentTypeLinkGuid'
  /** column name */
  | 'estimatedEquipmentAge'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'relationshipType';

/** input type for updating data in table "equipment_type_links" */
export type EquipmentTypeLinksSetInput = {
  appointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  appointmentGuid?: InputMaybe<Scalars['uuid']>;
  equipmentType?: InputMaybe<Scalars['EquipmentType']>;
  equipmentTypeLinkGuid?: InputMaybe<Scalars['uuid']>;
  estimatedEquipmentAge?: InputMaybe<Scalars['String']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  relationshipType?: InputMaybe<Scalars['JobToEquipmentRelationshipType']>;
};

/** Streaming cursor of the table "equipment_type_links" */
export type EquipmentTypeLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EquipmentTypeLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EquipmentTypeLinksStreamCursorValueInput = {
  appointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  appointmentGuid?: InputMaybe<Scalars['uuid']>;
  equipmentType?: InputMaybe<Scalars['EquipmentType']>;
  equipmentTypeLinkGuid?: InputMaybe<Scalars['uuid']>;
  estimatedEquipmentAge?: InputMaybe<Scalars['String']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  relationshipType?: InputMaybe<Scalars['JobToEquipmentRelationshipType']>;
};

/** update columns of table "equipment_type_links" */
export type EquipmentTypeLinksUpdateColumn =
  /** column name */
  | 'appointmentAssignmentGuid'
  /** column name */
  | 'appointmentGuid'
  /** column name */
  | 'equipmentType'
  /** column name */
  | 'equipmentTypeLinkGuid'
  /** column name */
  | 'estimatedEquipmentAge'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'relationshipType';

export type EquipmentTypeLinksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EquipmentTypeLinksSetInput>;
  /** filter the rows which have to be updated */
  where: EquipmentTypeLinksBoolExp;
};

/** columns and relationships of "equipment_types" */
export type EquipmentTypes = {
  __typename?: 'EquipmentTypes';
  name: Scalars['String'];
};

/** aggregated selection of "equipment_types" */
export type EquipmentTypesAggregate = {
  __typename?: 'EquipmentTypesAggregate';
  aggregate?: Maybe<EquipmentTypesAggregateFields>;
  nodes: Array<EquipmentTypes>;
};

/** aggregate fields of "equipment_types" */
export type EquipmentTypesAggregateFields = {
  __typename?: 'EquipmentTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EquipmentTypesMaxFields>;
  min?: Maybe<EquipmentTypesMinFields>;
};


/** aggregate fields of "equipment_types" */
export type EquipmentTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EquipmentTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "equipment_types". All fields are combined with a logical 'AND'. */
export type EquipmentTypesBoolExp = {
  _and?: InputMaybe<Array<EquipmentTypesBoolExp>>;
  _not?: InputMaybe<EquipmentTypesBoolExp>;
  _or?: InputMaybe<Array<EquipmentTypesBoolExp>>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "equipment_types" */
export type EquipmentTypesConstraint =
  /** unique or primary key constraint on columns "name" */
  | 'equipment_types_pkey';

/** input type for inserting data into table "equipment_types" */
export type EquipmentTypesInsertInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type EquipmentTypesMaxFields = {
  __typename?: 'EquipmentTypesMaxFields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type EquipmentTypesMinFields = {
  __typename?: 'EquipmentTypesMinFields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "equipment_types" */
export type EquipmentTypesMutationResponse = {
  __typename?: 'EquipmentTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EquipmentTypes>;
};

/** input type for inserting object relation for remote table "equipment_types" */
export type EquipmentTypesObjRelInsertInput = {
  data: EquipmentTypesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EquipmentTypesOnConflict>;
};

/** on_conflict condition type for table "equipment_types" */
export type EquipmentTypesOnConflict = {
  constraint: EquipmentTypesConstraint;
  updateColumns?: Array<EquipmentTypesUpdateColumn>;
  where?: InputMaybe<EquipmentTypesBoolExp>;
};

/** Ordering options when selecting data from "equipment_types". */
export type EquipmentTypesOrderBy = {
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: equipment_types */
export type EquipmentTypesPkColumnsInput = {
  name: Scalars['String'];
};

/** select columns of table "equipment_types" */
export type EquipmentTypesSelectColumn =
  /** column name */
  | 'name';

/** input type for updating data in table "equipment_types" */
export type EquipmentTypesSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "equipment_types" */
export type EquipmentTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EquipmentTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EquipmentTypesStreamCursorValueInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "equipment_types" */
export type EquipmentTypesUpdateColumn =
  /** column name */
  | 'name';

export type EquipmentTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EquipmentTypesSetInput>;
  /** filter the rows which have to be updated */
  where: EquipmentTypesBoolExp;
};

/** A joiner table to link invoices that were converted from an estimate */
export type EstimateInvoices = {
  __typename?: 'EstimateInvoices';
  /** An object relationship */
  estimate: Estimates;
  estimateGuid: Scalars['uuid'];
  /** An object relationship */
  invoice: Invoices;
  invoiceGuid: Scalars['uuid'];
};

/** aggregated selection of "estimate_invoices" */
export type EstimateInvoicesAggregate = {
  __typename?: 'EstimateInvoicesAggregate';
  aggregate?: Maybe<EstimateInvoicesAggregateFields>;
  nodes: Array<EstimateInvoices>;
};

/** aggregate fields of "estimate_invoices" */
export type EstimateInvoicesAggregateFields = {
  __typename?: 'EstimateInvoicesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EstimateInvoicesMaxFields>;
  min?: Maybe<EstimateInvoicesMinFields>;
};


/** aggregate fields of "estimate_invoices" */
export type EstimateInvoicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EstimateInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "estimate_invoices". All fields are combined with a logical 'AND'. */
export type EstimateInvoicesBoolExp = {
  _and?: InputMaybe<Array<EstimateInvoicesBoolExp>>;
  _not?: InputMaybe<EstimateInvoicesBoolExp>;
  _or?: InputMaybe<Array<EstimateInvoicesBoolExp>>;
  estimate?: InputMaybe<EstimatesBoolExp>;
  estimateGuid?: InputMaybe<UuidComparisonExp>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "estimate_invoices" */
export type EstimateInvoicesConstraint =
  /** unique or primary key constraint on columns "invoice_guid" */
  | 'estimate_invoices_pkey';

/** input type for inserting data into table "estimate_invoices" */
export type EstimateInvoicesInsertInput = {
  estimate?: InputMaybe<EstimatesObjRelInsertInput>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EstimateInvoicesMaxFields = {
  __typename?: 'EstimateInvoicesMaxFields';
  estimateGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type EstimateInvoicesMinFields = {
  __typename?: 'EstimateInvoicesMinFields';
  estimateGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "estimate_invoices" */
export type EstimateInvoicesMutationResponse = {
  __typename?: 'EstimateInvoicesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EstimateInvoices>;
};

/** input type for inserting object relation for remote table "estimate_invoices" */
export type EstimateInvoicesObjRelInsertInput = {
  data: EstimateInvoicesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EstimateInvoicesOnConflict>;
};

/** on_conflict condition type for table "estimate_invoices" */
export type EstimateInvoicesOnConflict = {
  constraint: EstimateInvoicesConstraint;
  updateColumns?: Array<EstimateInvoicesUpdateColumn>;
  where?: InputMaybe<EstimateInvoicesBoolExp>;
};

/** Ordering options when selecting data from "estimate_invoices". */
export type EstimateInvoicesOrderBy = {
  estimate?: InputMaybe<EstimatesOrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: estimate_invoices */
export type EstimateInvoicesPkColumnsInput = {
  invoiceGuid: Scalars['uuid'];
};

/** select columns of table "estimate_invoices" */
export type EstimateInvoicesSelectColumn =
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'invoiceGuid';

/** input type for updating data in table "estimate_invoices" */
export type EstimateInvoicesSetInput = {
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "estimate_invoices" */
export type EstimateInvoicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EstimateInvoicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EstimateInvoicesStreamCursorValueInput = {
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "estimate_invoices" */
export type EstimateInvoicesUpdateColumn =
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'invoiceGuid';

export type EstimateInvoicesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EstimateInvoicesSetInput>;
  /** filter the rows which have to be updated */
  where: EstimateInvoicesBoolExp;
};

/** columns and relationships of "estimate_option_cart_items" */
export type EstimateOptionCartItems = {
  __typename?: 'EstimateOptionCartItems';
  /** An object relationship */
  cartItem: CartItems;
  cartItemGuid: Scalars['uuid'];
  /** An object relationship */
  estimateOption?: Maybe<EstimateOptions>;
  estimateOptionGuid: Scalars['uuid'];
  seq: Scalars['Int'];
};

/** aggregated selection of "estimate_option_cart_items" */
export type EstimateOptionCartItemsAggregate = {
  __typename?: 'EstimateOptionCartItemsAggregate';
  aggregate?: Maybe<EstimateOptionCartItemsAggregateFields>;
  nodes: Array<EstimateOptionCartItems>;
};

export type EstimateOptionCartItemsAggregateBoolExp = {
  count?: InputMaybe<EstimateOptionCartItemsAggregateBoolExpCount>;
};

/** aggregate fields of "estimate_option_cart_items" */
export type EstimateOptionCartItemsAggregateFields = {
  __typename?: 'EstimateOptionCartItemsAggregateFields';
  avg?: Maybe<EstimateOptionCartItemsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EstimateOptionCartItemsMaxFields>;
  min?: Maybe<EstimateOptionCartItemsMinFields>;
  stddev?: Maybe<EstimateOptionCartItemsStddevFields>;
  stddevPop?: Maybe<EstimateOptionCartItemsStddevPopFields>;
  stddevSamp?: Maybe<EstimateOptionCartItemsStddevSampFields>;
  sum?: Maybe<EstimateOptionCartItemsSumFields>;
  varPop?: Maybe<EstimateOptionCartItemsVarPopFields>;
  varSamp?: Maybe<EstimateOptionCartItemsVarSampFields>;
  variance?: Maybe<EstimateOptionCartItemsVarianceFields>;
};


/** aggregate fields of "estimate_option_cart_items" */
export type EstimateOptionCartItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EstimateOptionCartItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsAggregateOrderBy = {
  avg?: InputMaybe<EstimateOptionCartItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EstimateOptionCartItemsMaxOrderBy>;
  min?: InputMaybe<EstimateOptionCartItemsMinOrderBy>;
  stddev?: InputMaybe<EstimateOptionCartItemsStddevOrderBy>;
  stddevPop?: InputMaybe<EstimateOptionCartItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EstimateOptionCartItemsStddevSampOrderBy>;
  sum?: InputMaybe<EstimateOptionCartItemsSumOrderBy>;
  varPop?: InputMaybe<EstimateOptionCartItemsVarPopOrderBy>;
  varSamp?: InputMaybe<EstimateOptionCartItemsVarSampOrderBy>;
  variance?: InputMaybe<EstimateOptionCartItemsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "estimate_option_cart_items" */
export type EstimateOptionCartItemsArrRelInsertInput = {
  data: Array<EstimateOptionCartItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EstimateOptionCartItemsOnConflict>;
};

/** aggregate avg on columns */
export type EstimateOptionCartItemsAvgFields = {
  __typename?: 'EstimateOptionCartItemsAvgFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsAvgOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "estimate_option_cart_items". All fields are combined with a logical 'AND'. */
export type EstimateOptionCartItemsBoolExp = {
  _and?: InputMaybe<Array<EstimateOptionCartItemsBoolExp>>;
  _not?: InputMaybe<EstimateOptionCartItemsBoolExp>;
  _or?: InputMaybe<Array<EstimateOptionCartItemsBoolExp>>;
  cartItem?: InputMaybe<CartItemsBoolExp>;
  cartItemGuid?: InputMaybe<UuidComparisonExp>;
  estimateOption?: InputMaybe<EstimateOptionsBoolExp>;
  estimateOptionGuid?: InputMaybe<UuidComparisonExp>;
  seq?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "estimate_option_cart_items" */
export type EstimateOptionCartItemsConstraint =
  /** unique or primary key constraint on columns "cart_item_guid" */
  | 'estimate_option_cart_items_pkey';

/** input type for incrementing numeric columns in table "estimate_option_cart_items" */
export type EstimateOptionCartItemsIncInput = {
  seq?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "estimate_option_cart_items" */
export type EstimateOptionCartItemsInsertInput = {
  cartItem?: InputMaybe<CartItemsObjRelInsertInput>;
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  estimateOption?: InputMaybe<EstimateOptionsObjRelInsertInput>;
  estimateOptionGuid?: InputMaybe<Scalars['uuid']>;
  seq?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type EstimateOptionCartItemsMaxFields = {
  __typename?: 'EstimateOptionCartItemsMaxFields';
  cartItemGuid?: Maybe<Scalars['uuid']>;
  estimateOptionGuid?: Maybe<Scalars['uuid']>;
  seq?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsMaxOrderBy = {
  cartItemGuid?: InputMaybe<OrderBy>;
  estimateOptionGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EstimateOptionCartItemsMinFields = {
  __typename?: 'EstimateOptionCartItemsMinFields';
  cartItemGuid?: Maybe<Scalars['uuid']>;
  estimateOptionGuid?: Maybe<Scalars['uuid']>;
  seq?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsMinOrderBy = {
  cartItemGuid?: InputMaybe<OrderBy>;
  estimateOptionGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "estimate_option_cart_items" */
export type EstimateOptionCartItemsMutationResponse = {
  __typename?: 'EstimateOptionCartItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EstimateOptionCartItems>;
};

/** on_conflict condition type for table "estimate_option_cart_items" */
export type EstimateOptionCartItemsOnConflict = {
  constraint: EstimateOptionCartItemsConstraint;
  updateColumns?: Array<EstimateOptionCartItemsUpdateColumn>;
  where?: InputMaybe<EstimateOptionCartItemsBoolExp>;
};

/** Ordering options when selecting data from "estimate_option_cart_items". */
export type EstimateOptionCartItemsOrderBy = {
  cartItem?: InputMaybe<CartItemsOrderBy>;
  cartItemGuid?: InputMaybe<OrderBy>;
  estimateOption?: InputMaybe<EstimateOptionsOrderBy>;
  estimateOptionGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: estimate_option_cart_items */
export type EstimateOptionCartItemsPkColumnsInput = {
  cartItemGuid: Scalars['uuid'];
};

/** select columns of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsSelectColumn =
  /** column name */
  | 'cartItemGuid'
  /** column name */
  | 'estimateOptionGuid'
  /** column name */
  | 'seq';

/** input type for updating data in table "estimate_option_cart_items" */
export type EstimateOptionCartItemsSetInput = {
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  estimateOptionGuid?: InputMaybe<Scalars['uuid']>;
  seq?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type EstimateOptionCartItemsStddevFields = {
  __typename?: 'EstimateOptionCartItemsStddevFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsStddevOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EstimateOptionCartItemsStddevPopFields = {
  __typename?: 'EstimateOptionCartItemsStddevPopFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsStddevPopOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EstimateOptionCartItemsStddevSampFields = {
  __typename?: 'EstimateOptionCartItemsStddevSampFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsStddevSampOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "estimate_option_cart_items" */
export type EstimateOptionCartItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EstimateOptionCartItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EstimateOptionCartItemsStreamCursorValueInput = {
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  estimateOptionGuid?: InputMaybe<Scalars['uuid']>;
  seq?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type EstimateOptionCartItemsSumFields = {
  __typename?: 'EstimateOptionCartItemsSumFields';
  seq?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsSumOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** update columns of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsUpdateColumn =
  /** column name */
  | 'cartItemGuid'
  /** column name */
  | 'estimateOptionGuid'
  /** column name */
  | 'seq';

export type EstimateOptionCartItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EstimateOptionCartItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EstimateOptionCartItemsSetInput>;
  /** filter the rows which have to be updated */
  where: EstimateOptionCartItemsBoolExp;
};

/** aggregate varPop on columns */
export type EstimateOptionCartItemsVarPopFields = {
  __typename?: 'EstimateOptionCartItemsVarPopFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsVarPopOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EstimateOptionCartItemsVarSampFields = {
  __typename?: 'EstimateOptionCartItemsVarSampFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsVarSampOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EstimateOptionCartItemsVarianceFields = {
  __typename?: 'EstimateOptionCartItemsVarianceFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "estimate_option_cart_items" */
export type EstimateOptionCartItemsVarianceOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** columns and relationships of "estimate_option_discounts" */
export type EstimateOptionDiscounts = {
  __typename?: 'EstimateOptionDiscounts';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  descriptionHtml?: Maybe<Scalars['HtmlString']>;
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['numeric']>;
  discountType: Scalars['DiscountType'];
  /** An object relationship */
  estimateOption: EstimateOptions;
  estimateOptionDiscountGuid: Scalars['uuid'];
  estimateOptionGuid: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  seq: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "estimate_option_discounts" */
export type EstimateOptionDiscountsAggregate = {
  __typename?: 'EstimateOptionDiscountsAggregate';
  aggregate?: Maybe<EstimateOptionDiscountsAggregateFields>;
  nodes: Array<EstimateOptionDiscounts>;
};

export type EstimateOptionDiscountsAggregateBoolExp = {
  count?: InputMaybe<EstimateOptionDiscountsAggregateBoolExpCount>;
};

/** aggregate fields of "estimate_option_discounts" */
export type EstimateOptionDiscountsAggregateFields = {
  __typename?: 'EstimateOptionDiscountsAggregateFields';
  avg?: Maybe<EstimateOptionDiscountsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EstimateOptionDiscountsMaxFields>;
  min?: Maybe<EstimateOptionDiscountsMinFields>;
  stddev?: Maybe<EstimateOptionDiscountsStddevFields>;
  stddevPop?: Maybe<EstimateOptionDiscountsStddevPopFields>;
  stddevSamp?: Maybe<EstimateOptionDiscountsStddevSampFields>;
  sum?: Maybe<EstimateOptionDiscountsSumFields>;
  varPop?: Maybe<EstimateOptionDiscountsVarPopFields>;
  varSamp?: Maybe<EstimateOptionDiscountsVarSampFields>;
  variance?: Maybe<EstimateOptionDiscountsVarianceFields>;
};


/** aggregate fields of "estimate_option_discounts" */
export type EstimateOptionDiscountsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EstimateOptionDiscountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "estimate_option_discounts" */
export type EstimateOptionDiscountsAggregateOrderBy = {
  avg?: InputMaybe<EstimateOptionDiscountsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EstimateOptionDiscountsMaxOrderBy>;
  min?: InputMaybe<EstimateOptionDiscountsMinOrderBy>;
  stddev?: InputMaybe<EstimateOptionDiscountsStddevOrderBy>;
  stddevPop?: InputMaybe<EstimateOptionDiscountsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EstimateOptionDiscountsStddevSampOrderBy>;
  sum?: InputMaybe<EstimateOptionDiscountsSumOrderBy>;
  varPop?: InputMaybe<EstimateOptionDiscountsVarPopOrderBy>;
  varSamp?: InputMaybe<EstimateOptionDiscountsVarSampOrderBy>;
  variance?: InputMaybe<EstimateOptionDiscountsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "estimate_option_discounts" */
export type EstimateOptionDiscountsArrRelInsertInput = {
  data: Array<EstimateOptionDiscountsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EstimateOptionDiscountsOnConflict>;
};

/** aggregate avg on columns */
export type EstimateOptionDiscountsAvgFields = {
  __typename?: 'EstimateOptionDiscountsAvgFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "estimate_option_discounts" */
export type EstimateOptionDiscountsAvgOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "estimate_option_discounts". All fields are combined with a logical 'AND'. */
export type EstimateOptionDiscountsBoolExp = {
  _and?: InputMaybe<Array<EstimateOptionDiscountsBoolExp>>;
  _not?: InputMaybe<EstimateOptionDiscountsBoolExp>;
  _or?: InputMaybe<Array<EstimateOptionDiscountsBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  descriptionHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
  discountAmountUsc?: InputMaybe<IntComparisonExp>;
  discountRate?: InputMaybe<NumericComparisonExp>;
  discountType?: InputMaybe<Scalars['DiscountTypeComparisonExp']>;
  estimateOption?: InputMaybe<EstimateOptionsBoolExp>;
  estimateOptionDiscountGuid?: InputMaybe<UuidComparisonExp>;
  estimateOptionGuid?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  seq?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "estimate_option_discounts" */
export type EstimateOptionDiscountsConstraint =
  /** unique or primary key constraint on columns "estimate_option_discount_guid" */
  | 'estimate_option_discounts_pkey';

/** input type for incrementing numeric columns in table "estimate_option_discounts" */
export type EstimateOptionDiscountsIncInput = {
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  seq?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "estimate_option_discounts" */
export type EstimateOptionDiscountsInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  descriptionHtml?: InputMaybe<Scalars['HtmlString']>;
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  discountType?: InputMaybe<Scalars['DiscountType']>;
  estimateOption?: InputMaybe<EstimateOptionsObjRelInsertInput>;
  estimateOptionDiscountGuid?: InputMaybe<Scalars['uuid']>;
  estimateOptionGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  seq?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EstimateOptionDiscountsMaxFields = {
  __typename?: 'EstimateOptionDiscountsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  descriptionHtml?: Maybe<Scalars['HtmlString']>;
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['numeric']>;
  discountType?: Maybe<Scalars['DiscountType']>;
  estimateOptionDiscountGuid?: Maybe<Scalars['uuid']>;
  estimateOptionGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  seq?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "estimate_option_discounts" */
export type EstimateOptionDiscountsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  descriptionHtml?: InputMaybe<OrderBy>;
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  discountType?: InputMaybe<OrderBy>;
  estimateOptionDiscountGuid?: InputMaybe<OrderBy>;
  estimateOptionGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EstimateOptionDiscountsMinFields = {
  __typename?: 'EstimateOptionDiscountsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  descriptionHtml?: Maybe<Scalars['HtmlString']>;
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['numeric']>;
  discountType?: Maybe<Scalars['DiscountType']>;
  estimateOptionDiscountGuid?: Maybe<Scalars['uuid']>;
  estimateOptionGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  seq?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "estimate_option_discounts" */
export type EstimateOptionDiscountsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  descriptionHtml?: InputMaybe<OrderBy>;
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  discountType?: InputMaybe<OrderBy>;
  estimateOptionDiscountGuid?: InputMaybe<OrderBy>;
  estimateOptionGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "estimate_option_discounts" */
export type EstimateOptionDiscountsMutationResponse = {
  __typename?: 'EstimateOptionDiscountsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EstimateOptionDiscounts>;
};

/** on_conflict condition type for table "estimate_option_discounts" */
export type EstimateOptionDiscountsOnConflict = {
  constraint: EstimateOptionDiscountsConstraint;
  updateColumns?: Array<EstimateOptionDiscountsUpdateColumn>;
  where?: InputMaybe<EstimateOptionDiscountsBoolExp>;
};

/** Ordering options when selecting data from "estimate_option_discounts". */
export type EstimateOptionDiscountsOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  descriptionHtml?: InputMaybe<OrderBy>;
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  discountType?: InputMaybe<OrderBy>;
  estimateOption?: InputMaybe<EstimateOptionsOrderBy>;
  estimateOptionDiscountGuid?: InputMaybe<OrderBy>;
  estimateOptionGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: estimate_option_discounts */
export type EstimateOptionDiscountsPkColumnsInput = {
  estimateOptionDiscountGuid: Scalars['uuid'];
};

/** select columns of table "estimate_option_discounts" */
export type EstimateOptionDiscountsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'descriptionHtml'
  /** column name */
  | 'discountAmountUsc'
  /** column name */
  | 'discountRate'
  /** column name */
  | 'discountType'
  /** column name */
  | 'estimateOptionDiscountGuid'
  /** column name */
  | 'estimateOptionGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'seq'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "estimate_option_discounts" */
export type EstimateOptionDiscountsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  descriptionHtml?: InputMaybe<Scalars['HtmlString']>;
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  discountType?: InputMaybe<Scalars['DiscountType']>;
  estimateOptionDiscountGuid?: InputMaybe<Scalars['uuid']>;
  estimateOptionGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  seq?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EstimateOptionDiscountsStddevFields = {
  __typename?: 'EstimateOptionDiscountsStddevFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "estimate_option_discounts" */
export type EstimateOptionDiscountsStddevOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EstimateOptionDiscountsStddevPopFields = {
  __typename?: 'EstimateOptionDiscountsStddevPopFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "estimate_option_discounts" */
export type EstimateOptionDiscountsStddevPopOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EstimateOptionDiscountsStddevSampFields = {
  __typename?: 'EstimateOptionDiscountsStddevSampFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "estimate_option_discounts" */
export type EstimateOptionDiscountsStddevSampOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "estimate_option_discounts" */
export type EstimateOptionDiscountsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EstimateOptionDiscountsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EstimateOptionDiscountsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  descriptionHtml?: InputMaybe<Scalars['HtmlString']>;
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  discountType?: InputMaybe<Scalars['DiscountType']>;
  estimateOptionDiscountGuid?: InputMaybe<Scalars['uuid']>;
  estimateOptionGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  seq?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EstimateOptionDiscountsSumFields = {
  __typename?: 'EstimateOptionDiscountsSumFields';
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['numeric']>;
  seq?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "estimate_option_discounts" */
export type EstimateOptionDiscountsSumOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** update columns of table "estimate_option_discounts" */
export type EstimateOptionDiscountsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'descriptionHtml'
  /** column name */
  | 'discountAmountUsc'
  /** column name */
  | 'discountRate'
  /** column name */
  | 'discountType'
  /** column name */
  | 'estimateOptionDiscountGuid'
  /** column name */
  | 'estimateOptionGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'seq'
  /** column name */
  | 'updatedAt';

export type EstimateOptionDiscountsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EstimateOptionDiscountsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EstimateOptionDiscountsSetInput>;
  /** filter the rows which have to be updated */
  where: EstimateOptionDiscountsBoolExp;
};

/** aggregate varPop on columns */
export type EstimateOptionDiscountsVarPopFields = {
  __typename?: 'EstimateOptionDiscountsVarPopFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "estimate_option_discounts" */
export type EstimateOptionDiscountsVarPopOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EstimateOptionDiscountsVarSampFields = {
  __typename?: 'EstimateOptionDiscountsVarSampFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "estimate_option_discounts" */
export type EstimateOptionDiscountsVarSampOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EstimateOptionDiscountsVarianceFields = {
  __typename?: 'EstimateOptionDiscountsVarianceFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "estimate_option_discounts" */
export type EstimateOptionDiscountsVarianceOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** columns and relationships of "estimate_option_tax_configurations_view" */
export type EstimateOptionTaxConfigurationsView = {
  __typename?: 'EstimateOptionTaxConfigurationsView';
  /** An object relationship */
  company?: Maybe<Companies>;
  companyGuid?: Maybe<Scalars['uuid']>;
  estimateOptionGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  estimate_option?: Maybe<EstimateOptions>;
  taxRoundingStrategy: Scalars['TaxRoundingStrategy'];
};

/** aggregated selection of "estimate_option_tax_configurations_view" */
export type EstimateOptionTaxConfigurationsViewAggregate = {
  __typename?: 'EstimateOptionTaxConfigurationsViewAggregate';
  aggregate?: Maybe<EstimateOptionTaxConfigurationsViewAggregateFields>;
  nodes: Array<EstimateOptionTaxConfigurationsView>;
};

/** aggregate fields of "estimate_option_tax_configurations_view" */
export type EstimateOptionTaxConfigurationsViewAggregateFields = {
  __typename?: 'EstimateOptionTaxConfigurationsViewAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EstimateOptionTaxConfigurationsViewMaxFields>;
  min?: Maybe<EstimateOptionTaxConfigurationsViewMinFields>;
};


/** aggregate fields of "estimate_option_tax_configurations_view" */
export type EstimateOptionTaxConfigurationsViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EstimateOptionTaxConfigurationsViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "estimate_option_tax_configurations_view". All fields are combined with a logical 'AND'. */
export type EstimateOptionTaxConfigurationsViewBoolExp = {
  _and?: InputMaybe<Array<EstimateOptionTaxConfigurationsViewBoolExp>>;
  _not?: InputMaybe<EstimateOptionTaxConfigurationsViewBoolExp>;
  _or?: InputMaybe<Array<EstimateOptionTaxConfigurationsViewBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  estimateOptionGuid?: InputMaybe<UuidComparisonExp>;
  estimate_option?: InputMaybe<EstimateOptionsBoolExp>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategyComparisonExp']>;
};

/** input type for inserting data into table "estimate_option_tax_configurations_view" */
export type EstimateOptionTaxConfigurationsViewInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  estimateOptionGuid?: InputMaybe<Scalars['uuid']>;
  estimate_option?: InputMaybe<EstimateOptionsObjRelInsertInput>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
};

/** aggregate max on columns */
export type EstimateOptionTaxConfigurationsViewMaxFields = {
  __typename?: 'EstimateOptionTaxConfigurationsViewMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  estimateOptionGuid?: Maybe<Scalars['uuid']>;
  taxRoundingStrategy?: Maybe<Scalars['TaxRoundingStrategy']>;
};

/** aggregate min on columns */
export type EstimateOptionTaxConfigurationsViewMinFields = {
  __typename?: 'EstimateOptionTaxConfigurationsViewMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  estimateOptionGuid?: Maybe<Scalars['uuid']>;
  taxRoundingStrategy?: Maybe<Scalars['TaxRoundingStrategy']>;
};

/** input type for inserting object relation for remote table "estimate_option_tax_configurations_view" */
export type EstimateOptionTaxConfigurationsViewObjRelInsertInput = {
  data: EstimateOptionTaxConfigurationsViewInsertInput;
};

/** Ordering options when selecting data from "estimate_option_tax_configurations_view". */
export type EstimateOptionTaxConfigurationsViewOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  estimateOptionGuid?: InputMaybe<OrderBy>;
  estimate_option?: InputMaybe<EstimateOptionsOrderBy>;
  taxRoundingStrategy?: InputMaybe<OrderBy>;
};

/** select columns of table "estimate_option_tax_configurations_view" */
export type EstimateOptionTaxConfigurationsViewSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'estimateOptionGuid'
  /** column name */
  | 'taxRoundingStrategy';

export type EstimateOptionTaxConfigurationsViewSetInput = {
  __typename?: 'EstimateOptionTaxConfigurationsViewSetInput';
  taxRoundingStrategy?: Maybe<Scalars['TaxRoundingStrategy']>;
};

/** Streaming cursor of the table "estimate_option_tax_configurations_view" */
export type EstimateOptionTaxConfigurationsViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EstimateOptionTaxConfigurationsViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EstimateOptionTaxConfigurationsViewStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  estimateOptionGuid?: InputMaybe<Scalars['uuid']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
};

/** columns and relationships of "estimate_options" */
export type EstimateOptions = {
  __typename?: 'EstimateOptions';
  /** An array relationship */
  cartItems: Array<EstimateOptionCartItems>;
  /** An aggregate relationship */
  cartItemsAggregate: EstimateOptionCartItemsAggregate;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['HtmlString']>;
  displayName?: Maybe<Scalars['String']>;
  /** An object relationship */
  estimate?: Maybe<Estimates>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  estimateOptionDiscounts: Array<EstimateOptionDiscounts>;
  /** An aggregate relationship */
  estimateOptionDiscountsAggregate: EstimateOptionDiscountsAggregate;
  estimateOptionGuid: Scalars['uuid'];
  /** An object relationship */
  estimateTemplate?: Maybe<EstimateTemplates>;
  estimateTemplateGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  featuredPhoto?: Maybe<Photos>;
  featuredPhotoGuid?: Maybe<Scalars['uuid']>;
  isRecommended: Scalars['Boolean'];
  isSelected: Scalars['Boolean'];
  seq: Scalars['Int'];
  /** An object relationship */
  taxConfiguration?: Maybe<EstimateOptionTaxConfigurationsView>;
  totalUsc: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "estimate_options" */
export type EstimateOptionsCartItemsArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionCartItemsOrderBy>>;
  where?: InputMaybe<EstimateOptionCartItemsBoolExp>;
};


/** columns and relationships of "estimate_options" */
export type EstimateOptionsCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionCartItemsOrderBy>>;
  where?: InputMaybe<EstimateOptionCartItemsBoolExp>;
};


/** columns and relationships of "estimate_options" */
export type EstimateOptionsEstimateOptionDiscountsArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionDiscountsOrderBy>>;
  where?: InputMaybe<EstimateOptionDiscountsBoolExp>;
};


/** columns and relationships of "estimate_options" */
export type EstimateOptionsEstimateOptionDiscountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionDiscountsOrderBy>>;
  where?: InputMaybe<EstimateOptionDiscountsBoolExp>;
};

/** aggregated selection of "estimate_options" */
export type EstimateOptionsAggregate = {
  __typename?: 'EstimateOptionsAggregate';
  aggregate?: Maybe<EstimateOptionsAggregateFields>;
  nodes: Array<EstimateOptions>;
};

export type EstimateOptionsAggregateBoolExp = {
  bool_and?: InputMaybe<EstimateOptionsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<EstimateOptionsAggregateBoolExpBool_Or>;
  count?: InputMaybe<EstimateOptionsAggregateBoolExpCount>;
};

/** aggregate fields of "estimate_options" */
export type EstimateOptionsAggregateFields = {
  __typename?: 'EstimateOptionsAggregateFields';
  avg?: Maybe<EstimateOptionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EstimateOptionsMaxFields>;
  min?: Maybe<EstimateOptionsMinFields>;
  stddev?: Maybe<EstimateOptionsStddevFields>;
  stddevPop?: Maybe<EstimateOptionsStddevPopFields>;
  stddevSamp?: Maybe<EstimateOptionsStddevSampFields>;
  sum?: Maybe<EstimateOptionsSumFields>;
  varPop?: Maybe<EstimateOptionsVarPopFields>;
  varSamp?: Maybe<EstimateOptionsVarSampFields>;
  variance?: Maybe<EstimateOptionsVarianceFields>;
};


/** aggregate fields of "estimate_options" */
export type EstimateOptionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EstimateOptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "estimate_options" */
export type EstimateOptionsAggregateOrderBy = {
  avg?: InputMaybe<EstimateOptionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EstimateOptionsMaxOrderBy>;
  min?: InputMaybe<EstimateOptionsMinOrderBy>;
  stddev?: InputMaybe<EstimateOptionsStddevOrderBy>;
  stddevPop?: InputMaybe<EstimateOptionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EstimateOptionsStddevSampOrderBy>;
  sum?: InputMaybe<EstimateOptionsSumOrderBy>;
  varPop?: InputMaybe<EstimateOptionsVarPopOrderBy>;
  varSamp?: InputMaybe<EstimateOptionsVarSampOrderBy>;
  variance?: InputMaybe<EstimateOptionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "estimate_options" */
export type EstimateOptionsArrRelInsertInput = {
  data: Array<EstimateOptionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EstimateOptionsOnConflict>;
};

/** aggregate avg on columns */
export type EstimateOptionsAvgFields = {
  __typename?: 'EstimateOptionsAvgFields';
  seq?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "estimate_options" */
export type EstimateOptionsAvgOrderBy = {
  seq?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "estimate_options". All fields are combined with a logical 'AND'. */
export type EstimateOptionsBoolExp = {
  _and?: InputMaybe<Array<EstimateOptionsBoolExp>>;
  _not?: InputMaybe<EstimateOptionsBoolExp>;
  _or?: InputMaybe<Array<EstimateOptionsBoolExp>>;
  cartItems?: InputMaybe<EstimateOptionCartItemsBoolExp>;
  cartItemsAggregate?: InputMaybe<EstimateOptionCartItemsAggregateBoolExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  descriptionHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
  displayName?: InputMaybe<StringComparisonExp>;
  estimate?: InputMaybe<EstimatesBoolExp>;
  estimateGuid?: InputMaybe<UuidComparisonExp>;
  estimateOptionDiscounts?: InputMaybe<EstimateOptionDiscountsBoolExp>;
  estimateOptionDiscountsAggregate?: InputMaybe<EstimateOptionDiscountsAggregateBoolExp>;
  estimateOptionGuid?: InputMaybe<UuidComparisonExp>;
  estimateTemplate?: InputMaybe<EstimateTemplatesBoolExp>;
  estimateTemplateGuid?: InputMaybe<UuidComparisonExp>;
  featuredPhoto?: InputMaybe<PhotosBoolExp>;
  featuredPhotoGuid?: InputMaybe<UuidComparisonExp>;
  isRecommended?: InputMaybe<BooleanComparisonExp>;
  isSelected?: InputMaybe<BooleanComparisonExp>;
  seq?: InputMaybe<IntComparisonExp>;
  taxConfiguration?: InputMaybe<EstimateOptionTaxConfigurationsViewBoolExp>;
  totalUsc?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "estimate_options" */
export type EstimateOptionsConstraint =
  /** unique or primary key constraint on columns "estimate_option_guid" */
  | 'estimate_options_pkey';

/** input type for incrementing numeric columns in table "estimate_options" */
export type EstimateOptionsIncInput = {
  seq?: InputMaybe<Scalars['Int']>;
  totalUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "estimate_options" */
export type EstimateOptionsInsertInput = {
  cartItems?: InputMaybe<EstimateOptionCartItemsArrRelInsertInput>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['HtmlString']>;
  displayName?: InputMaybe<Scalars['String']>;
  estimate?: InputMaybe<EstimatesObjRelInsertInput>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  estimateOptionDiscounts?: InputMaybe<EstimateOptionDiscountsArrRelInsertInput>;
  estimateOptionGuid?: InputMaybe<Scalars['uuid']>;
  estimateTemplate?: InputMaybe<EstimateTemplatesObjRelInsertInput>;
  estimateTemplateGuid?: InputMaybe<Scalars['uuid']>;
  featuredPhoto?: InputMaybe<PhotosObjRelInsertInput>;
  featuredPhotoGuid?: InputMaybe<Scalars['uuid']>;
  isRecommended?: InputMaybe<Scalars['Boolean']>;
  isSelected?: InputMaybe<Scalars['Boolean']>;
  seq?: InputMaybe<Scalars['Int']>;
  taxConfiguration?: InputMaybe<EstimateOptionTaxConfigurationsViewObjRelInsertInput>;
  totalUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EstimateOptionsMaxFields = {
  __typename?: 'EstimateOptionsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['HtmlString']>;
  displayName?: Maybe<Scalars['String']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  estimateOptionGuid?: Maybe<Scalars['uuid']>;
  estimateTemplateGuid?: Maybe<Scalars['uuid']>;
  featuredPhotoGuid?: Maybe<Scalars['uuid']>;
  seq?: Maybe<Scalars['Int']>;
  totalUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "estimate_options" */
export type EstimateOptionsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  descriptionHtml?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  estimateOptionGuid?: InputMaybe<OrderBy>;
  estimateTemplateGuid?: InputMaybe<OrderBy>;
  featuredPhotoGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EstimateOptionsMinFields = {
  __typename?: 'EstimateOptionsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['HtmlString']>;
  displayName?: Maybe<Scalars['String']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  estimateOptionGuid?: Maybe<Scalars['uuid']>;
  estimateTemplateGuid?: Maybe<Scalars['uuid']>;
  featuredPhotoGuid?: Maybe<Scalars['uuid']>;
  seq?: Maybe<Scalars['Int']>;
  totalUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "estimate_options" */
export type EstimateOptionsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  descriptionHtml?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  estimateOptionGuid?: InputMaybe<OrderBy>;
  estimateTemplateGuid?: InputMaybe<OrderBy>;
  featuredPhotoGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "estimate_options" */
export type EstimateOptionsMutationResponse = {
  __typename?: 'EstimateOptionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EstimateOptions>;
};

/** input type for inserting object relation for remote table "estimate_options" */
export type EstimateOptionsObjRelInsertInput = {
  data: EstimateOptionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EstimateOptionsOnConflict>;
};

/** on_conflict condition type for table "estimate_options" */
export type EstimateOptionsOnConflict = {
  constraint: EstimateOptionsConstraint;
  updateColumns?: Array<EstimateOptionsUpdateColumn>;
  where?: InputMaybe<EstimateOptionsBoolExp>;
};

/** Ordering options when selecting data from "estimate_options". */
export type EstimateOptionsOrderBy = {
  cartItemsAggregate?: InputMaybe<EstimateOptionCartItemsAggregateOrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  descriptionHtml?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  estimate?: InputMaybe<EstimatesOrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  estimateOptionDiscountsAggregate?: InputMaybe<EstimateOptionDiscountsAggregateOrderBy>;
  estimateOptionGuid?: InputMaybe<OrderBy>;
  estimateTemplate?: InputMaybe<EstimateTemplatesOrderBy>;
  estimateTemplateGuid?: InputMaybe<OrderBy>;
  featuredPhoto?: InputMaybe<PhotosOrderBy>;
  featuredPhotoGuid?: InputMaybe<OrderBy>;
  isRecommended?: InputMaybe<OrderBy>;
  isSelected?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  taxConfiguration?: InputMaybe<EstimateOptionTaxConfigurationsViewOrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: estimate_options */
export type EstimateOptionsPkColumnsInput = {
  estimateOptionGuid: Scalars['uuid'];
};

/** select columns of table "estimate_options" */
export type EstimateOptionsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'descriptionHtml'
  /** column name */
  | 'displayName'
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'estimateOptionGuid'
  /** column name */
  | 'estimateTemplateGuid'
  /** column name */
  | 'featuredPhotoGuid'
  /** column name */
  | 'isRecommended'
  /** column name */
  | 'isSelected'
  /** column name */
  | 'seq'
  /** column name */
  | 'totalUsc'
  /** column name */
  | 'updatedAt';

/** select "estimateOptionsAggregateBoolExpBool_andArgumentsColumns" columns of table "estimate_options" */
export type EstimateOptionsSelectColumnEstimateOptionsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isRecommended'
  /** column name */
  | 'isSelected';

/** select "estimateOptionsAggregateBoolExpBool_orArgumentsColumns" columns of table "estimate_options" */
export type EstimateOptionsSelectColumnEstimateOptionsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isRecommended'
  /** column name */
  | 'isSelected';

/** input type for updating data in table "estimate_options" */
export type EstimateOptionsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['HtmlString']>;
  displayName?: InputMaybe<Scalars['String']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  estimateOptionGuid?: InputMaybe<Scalars['uuid']>;
  estimateTemplateGuid?: InputMaybe<Scalars['uuid']>;
  featuredPhotoGuid?: InputMaybe<Scalars['uuid']>;
  isRecommended?: InputMaybe<Scalars['Boolean']>;
  isSelected?: InputMaybe<Scalars['Boolean']>;
  seq?: InputMaybe<Scalars['Int']>;
  totalUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EstimateOptionsStddevFields = {
  __typename?: 'EstimateOptionsStddevFields';
  seq?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "estimate_options" */
export type EstimateOptionsStddevOrderBy = {
  seq?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EstimateOptionsStddevPopFields = {
  __typename?: 'EstimateOptionsStddevPopFields';
  seq?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "estimate_options" */
export type EstimateOptionsStddevPopOrderBy = {
  seq?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EstimateOptionsStddevSampFields = {
  __typename?: 'EstimateOptionsStddevSampFields';
  seq?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "estimate_options" */
export type EstimateOptionsStddevSampOrderBy = {
  seq?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "estimate_options" */
export type EstimateOptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EstimateOptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EstimateOptionsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['HtmlString']>;
  displayName?: InputMaybe<Scalars['String']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  estimateOptionGuid?: InputMaybe<Scalars['uuid']>;
  estimateTemplateGuid?: InputMaybe<Scalars['uuid']>;
  featuredPhotoGuid?: InputMaybe<Scalars['uuid']>;
  isRecommended?: InputMaybe<Scalars['Boolean']>;
  isSelected?: InputMaybe<Scalars['Boolean']>;
  seq?: InputMaybe<Scalars['Int']>;
  totalUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EstimateOptionsSumFields = {
  __typename?: 'EstimateOptionsSumFields';
  seq?: Maybe<Scalars['Int']>;
  totalUsc?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "estimate_options" */
export type EstimateOptionsSumOrderBy = {
  seq?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** update columns of table "estimate_options" */
export type EstimateOptionsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'descriptionHtml'
  /** column name */
  | 'displayName'
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'estimateOptionGuid'
  /** column name */
  | 'estimateTemplateGuid'
  /** column name */
  | 'featuredPhotoGuid'
  /** column name */
  | 'isRecommended'
  /** column name */
  | 'isSelected'
  /** column name */
  | 'seq'
  /** column name */
  | 'totalUsc'
  /** column name */
  | 'updatedAt';

export type EstimateOptionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EstimateOptionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EstimateOptionsSetInput>;
  /** filter the rows which have to be updated */
  where: EstimateOptionsBoolExp;
};

/** aggregate varPop on columns */
export type EstimateOptionsVarPopFields = {
  __typename?: 'EstimateOptionsVarPopFields';
  seq?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "estimate_options" */
export type EstimateOptionsVarPopOrderBy = {
  seq?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EstimateOptionsVarSampFields = {
  __typename?: 'EstimateOptionsVarSampFields';
  seq?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "estimate_options" */
export type EstimateOptionsVarSampOrderBy = {
  seq?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EstimateOptionsVarianceFields = {
  __typename?: 'EstimateOptionsVarianceFields';
  seq?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "estimate_options" */
export type EstimateOptionsVarianceOrderBy = {
  seq?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** columns and relationships of "estimate_photos" */
export type EstimatePhotos = {
  __typename?: 'EstimatePhotos';
  companyGuid: Scalars['uuid'];
  /** An object relationship */
  estimate: Estimates;
  estimateGuid: Scalars['uuid'];
  /** An object relationship */
  photo: Photos;
  photoGuid: Scalars['uuid'];
};

/** aggregated selection of "estimate_photos" */
export type EstimatePhotosAggregate = {
  __typename?: 'EstimatePhotosAggregate';
  aggregate?: Maybe<EstimatePhotosAggregateFields>;
  nodes: Array<EstimatePhotos>;
};

export type EstimatePhotosAggregateBoolExp = {
  count?: InputMaybe<EstimatePhotosAggregateBoolExpCount>;
};

/** aggregate fields of "estimate_photos" */
export type EstimatePhotosAggregateFields = {
  __typename?: 'EstimatePhotosAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EstimatePhotosMaxFields>;
  min?: Maybe<EstimatePhotosMinFields>;
};


/** aggregate fields of "estimate_photos" */
export type EstimatePhotosAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EstimatePhotosSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "estimate_photos" */
export type EstimatePhotosAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EstimatePhotosMaxOrderBy>;
  min?: InputMaybe<EstimatePhotosMinOrderBy>;
};

/** input type for inserting array relation for remote table "estimate_photos" */
export type EstimatePhotosArrRelInsertInput = {
  data: Array<EstimatePhotosInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EstimatePhotosOnConflict>;
};

/** Boolean expression to filter rows from the table "estimate_photos". All fields are combined with a logical 'AND'. */
export type EstimatePhotosBoolExp = {
  _and?: InputMaybe<Array<EstimatePhotosBoolExp>>;
  _not?: InputMaybe<EstimatePhotosBoolExp>;
  _or?: InputMaybe<Array<EstimatePhotosBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  estimate?: InputMaybe<EstimatesBoolExp>;
  estimateGuid?: InputMaybe<UuidComparisonExp>;
  photo?: InputMaybe<PhotosBoolExp>;
  photoGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "estimate_photos" */
export type EstimatePhotosConstraint =
  /** unique or primary key constraint on columns "photo_guid", "estimate_guid" */
  | 'estimate_photos_pkey';

/** input type for inserting data into table "estimate_photos" */
export type EstimatePhotosInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  estimate?: InputMaybe<EstimatesObjRelInsertInput>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  photo?: InputMaybe<PhotosObjRelInsertInput>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type EstimatePhotosMaxFields = {
  __typename?: 'EstimatePhotosMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "estimate_photos" */
export type EstimatePhotosMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EstimatePhotosMinFields = {
  __typename?: 'EstimatePhotosMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "estimate_photos" */
export type EstimatePhotosMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "estimate_photos" */
export type EstimatePhotosMutationResponse = {
  __typename?: 'EstimatePhotosMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EstimatePhotos>;
};

/** on_conflict condition type for table "estimate_photos" */
export type EstimatePhotosOnConflict = {
  constraint: EstimatePhotosConstraint;
  updateColumns?: Array<EstimatePhotosUpdateColumn>;
  where?: InputMaybe<EstimatePhotosBoolExp>;
};

/** Ordering options when selecting data from "estimate_photos". */
export type EstimatePhotosOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  estimate?: InputMaybe<EstimatesOrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  photo?: InputMaybe<PhotosOrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: estimate_photos */
export type EstimatePhotosPkColumnsInput = {
  estimateGuid: Scalars['uuid'];
  photoGuid: Scalars['uuid'];
};

/** select columns of table "estimate_photos" */
export type EstimatePhotosSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'photoGuid';

/** input type for updating data in table "estimate_photos" */
export type EstimatePhotosSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "estimate_photos" */
export type EstimatePhotosStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EstimatePhotosStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EstimatePhotosStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "estimate_photos" */
export type EstimatePhotosUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'photoGuid';

export type EstimatePhotosUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EstimatePhotosSetInput>;
  /** filter the rows which have to be updated */
  where: EstimatePhotosBoolExp;
};

/** Estimate templates that can be used to generate an estimate preset */
export type EstimateTemplates = {
  __typename?: 'EstimateTemplates';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  customMessageHtml?: Maybe<Scalars['HtmlString']>;
  /** An array relationship */
  estimateOptions: Array<EstimateOptions>;
  /** An aggregate relationship */
  estimateOptionsAggregate: EstimateOptionsAggregate;
  estimateTemplateGuid: Scalars['uuid'];
  isDeleted: Scalars['Boolean'];
  messagePreset: Scalars['EstimateTemplateMessagePreset'];
  templateName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** Estimate templates that can be used to generate an estimate preset */
export type EstimateTemplatesEstimateOptionsArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionsOrderBy>>;
  where?: InputMaybe<EstimateOptionsBoolExp>;
};


/** Estimate templates that can be used to generate an estimate preset */
export type EstimateTemplatesEstimateOptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionsOrderBy>>;
  where?: InputMaybe<EstimateOptionsBoolExp>;
};

/** aggregated selection of "estimate_templates" */
export type EstimateTemplatesAggregate = {
  __typename?: 'EstimateTemplatesAggregate';
  aggregate?: Maybe<EstimateTemplatesAggregateFields>;
  nodes: Array<EstimateTemplates>;
};

/** aggregate fields of "estimate_templates" */
export type EstimateTemplatesAggregateFields = {
  __typename?: 'EstimateTemplatesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<EstimateTemplatesMaxFields>;
  min?: Maybe<EstimateTemplatesMinFields>;
};


/** aggregate fields of "estimate_templates" */
export type EstimateTemplatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EstimateTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "estimate_templates". All fields are combined with a logical 'AND'. */
export type EstimateTemplatesBoolExp = {
  _and?: InputMaybe<Array<EstimateTemplatesBoolExp>>;
  _not?: InputMaybe<EstimateTemplatesBoolExp>;
  _or?: InputMaybe<Array<EstimateTemplatesBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customMessageHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
  estimateOptions?: InputMaybe<EstimateOptionsBoolExp>;
  estimateOptionsAggregate?: InputMaybe<EstimateOptionsAggregateBoolExp>;
  estimateTemplateGuid?: InputMaybe<UuidComparisonExp>;
  isDeleted?: InputMaybe<BooleanComparisonExp>;
  messagePreset?: InputMaybe<Scalars['EstimateTemplateMessagePresetComparisonExp']>;
  templateName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "estimate_templates" */
export type EstimateTemplatesConstraint =
  /** unique or primary key constraint on columns "estimate_template_guid" */
  | 'estimate_templates_pkey';

/** input type for inserting data into table "estimate_templates" */
export type EstimateTemplatesInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customMessageHtml?: InputMaybe<Scalars['HtmlString']>;
  estimateOptions?: InputMaybe<EstimateOptionsArrRelInsertInput>;
  estimateTemplateGuid?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  messagePreset?: InputMaybe<Scalars['EstimateTemplateMessagePreset']>;
  templateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EstimateTemplatesMaxFields = {
  __typename?: 'EstimateTemplatesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customMessageHtml?: Maybe<Scalars['HtmlString']>;
  estimateTemplateGuid?: Maybe<Scalars['uuid']>;
  messagePreset?: Maybe<Scalars['EstimateTemplateMessagePreset']>;
  templateName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type EstimateTemplatesMinFields = {
  __typename?: 'EstimateTemplatesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  customMessageHtml?: Maybe<Scalars['HtmlString']>;
  estimateTemplateGuid?: Maybe<Scalars['uuid']>;
  messagePreset?: Maybe<Scalars['EstimateTemplateMessagePreset']>;
  templateName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "estimate_templates" */
export type EstimateTemplatesMutationResponse = {
  __typename?: 'EstimateTemplatesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EstimateTemplates>;
};

/** input type for inserting object relation for remote table "estimate_templates" */
export type EstimateTemplatesObjRelInsertInput = {
  data: EstimateTemplatesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EstimateTemplatesOnConflict>;
};

/** on_conflict condition type for table "estimate_templates" */
export type EstimateTemplatesOnConflict = {
  constraint: EstimateTemplatesConstraint;
  updateColumns?: Array<EstimateTemplatesUpdateColumn>;
  where?: InputMaybe<EstimateTemplatesBoolExp>;
};

/** Ordering options when selecting data from "estimate_templates". */
export type EstimateTemplatesOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customMessageHtml?: InputMaybe<OrderBy>;
  estimateOptionsAggregate?: InputMaybe<EstimateOptionsAggregateOrderBy>;
  estimateTemplateGuid?: InputMaybe<OrderBy>;
  isDeleted?: InputMaybe<OrderBy>;
  messagePreset?: InputMaybe<OrderBy>;
  templateName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: estimate_templates */
export type EstimateTemplatesPkColumnsInput = {
  estimateTemplateGuid: Scalars['uuid'];
};

/** select columns of table "estimate_templates" */
export type EstimateTemplatesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'customMessageHtml'
  /** column name */
  | 'estimateTemplateGuid'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'messagePreset'
  /** column name */
  | 'templateName'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "estimate_templates" */
export type EstimateTemplatesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customMessageHtml?: InputMaybe<Scalars['HtmlString']>;
  estimateTemplateGuid?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  messagePreset?: InputMaybe<Scalars['EstimateTemplateMessagePreset']>;
  templateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "estimate_templates" */
export type EstimateTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EstimateTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EstimateTemplatesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  customMessageHtml?: InputMaybe<Scalars['HtmlString']>;
  estimateTemplateGuid?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  messagePreset?: InputMaybe<Scalars['EstimateTemplateMessagePreset']>;
  templateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "estimate_templates" */
export type EstimateTemplatesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'customMessageHtml'
  /** column name */
  | 'estimateTemplateGuid'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'messagePreset'
  /** column name */
  | 'templateName'
  /** column name */
  | 'updatedAt';

export type EstimateTemplatesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EstimateTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: EstimateTemplatesBoolExp;
};

/** columns and relationships of "estimates" */
export type Estimates = {
  __typename?: 'Estimates';
  acceptedAt?: Maybe<Scalars['timestamptz']>;
  acceptedOnBehalfBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  acceptedOnBehalfByUser?: Maybe<Users>;
  closedLostReasonCategory?: Maybe<Scalars['String']>;
  closedLostReasonNote?: Maybe<Scalars['String']>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['uuid'];
  /** An object relationship */
  createdByUser: Users;
  displayId: Scalars['bigint'];
  /** A computed field, executes function "estimate_display_id_as_text" */
  displayIdString?: Maybe<Scalars['String']>;
  dynamicPricingType?: Maybe<Scalars['DynamicPricingType']>;
  estimateGuid: Scalars['uuid'];
  /** An array relationship */
  estimateOptions: Array<EstimateOptions>;
  /** An aggregate relationship */
  estimateOptionsAggregate: EstimateOptionsAggregate;
  /** An array relationship */
  estimatePhotos: Array<EstimatePhotos>;
  /** An aggregate relationship */
  estimatePhotosAggregate: EstimatePhotosAggregate;
  /** Per-estimate override: hide per-line prices on customer-facing renders. Seeded from company_config.hide_line_item_prices at create. */
  hideLineItemPrices: Scalars['Boolean'];
  /** An object relationship */
  invoiceLink?: Maybe<EstimateInvoices>;
  /** An object relationship */
  job: Jobs;
  /** An object relationship */
  jobAppointment?: Maybe<JobAppointments>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid: Scalars['uuid'];
  lastSentAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  linkedToJobs: Array<JobsWithLinkedJobLinkedEstimates>;
  /** An aggregate relationship */
  linkedToJobsAggregate: JobsWithLinkedJobLinkedEstimatesAggregate;
  maintenancePlanSavingsEnabled: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  messageHtml?: Maybe<Scalars['HtmlString']>;
  remindersSent: Scalars['Int'];
  signatureFileUrl?: Maybe<Scalars['String']>;
  status: Scalars['EstimateV2Status'];
  taxRate: Scalars['numeric'];
  taxRateGuid: Scalars['uuid'];
  taxRateName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "estimates" */
export type EstimatesEstimateOptionsArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionsOrderBy>>;
  where?: InputMaybe<EstimateOptionsBoolExp>;
};


/** columns and relationships of "estimates" */
export type EstimatesEstimateOptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionsOrderBy>>;
  where?: InputMaybe<EstimateOptionsBoolExp>;
};


/** columns and relationships of "estimates" */
export type EstimatesEstimatePhotosArgs = {
  distinctOn?: InputMaybe<Array<EstimatePhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatePhotosOrderBy>>;
  where?: InputMaybe<EstimatePhotosBoolExp>;
};


/** columns and relationships of "estimates" */
export type EstimatesEstimatePhotosAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimatePhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatePhotosOrderBy>>;
  where?: InputMaybe<EstimatePhotosBoolExp>;
};


/** columns and relationships of "estimates" */
export type EstimatesLinkedToJobsArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
};


/** columns and relationships of "estimates" */
export type EstimatesLinkedToJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
};

/** aggregated selection of "estimates" */
export type EstimatesAggregate = {
  __typename?: 'EstimatesAggregate';
  aggregate?: Maybe<EstimatesAggregateFields>;
  nodes: Array<Estimates>;
};

export type EstimatesAggregateBoolExp = {
  bool_and?: InputMaybe<EstimatesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<EstimatesAggregateBoolExpBool_Or>;
  count?: InputMaybe<EstimatesAggregateBoolExpCount>;
};

/** aggregate fields of "estimates" */
export type EstimatesAggregateFields = {
  __typename?: 'EstimatesAggregateFields';
  avg?: Maybe<EstimatesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EstimatesMaxFields>;
  min?: Maybe<EstimatesMinFields>;
  stddev?: Maybe<EstimatesStddevFields>;
  stddevPop?: Maybe<EstimatesStddevPopFields>;
  stddevSamp?: Maybe<EstimatesStddevSampFields>;
  sum?: Maybe<EstimatesSumFields>;
  varPop?: Maybe<EstimatesVarPopFields>;
  varSamp?: Maybe<EstimatesVarSampFields>;
  variance?: Maybe<EstimatesVarianceFields>;
};


/** aggregate fields of "estimates" */
export type EstimatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EstimatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "estimates" */
export type EstimatesAggregateOrderBy = {
  avg?: InputMaybe<EstimatesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EstimatesMaxOrderBy>;
  min?: InputMaybe<EstimatesMinOrderBy>;
  stddev?: InputMaybe<EstimatesStddevOrderBy>;
  stddevPop?: InputMaybe<EstimatesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EstimatesStddevSampOrderBy>;
  sum?: InputMaybe<EstimatesSumOrderBy>;
  varPop?: InputMaybe<EstimatesVarPopOrderBy>;
  varSamp?: InputMaybe<EstimatesVarSampOrderBy>;
  variance?: InputMaybe<EstimatesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "estimates" */
export type EstimatesArrRelInsertInput = {
  data: Array<EstimatesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EstimatesOnConflict>;
};

/** aggregate avg on columns */
export type EstimatesAvgFields = {
  __typename?: 'EstimatesAvgFields';
  displayId?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "estimates" */
export type EstimatesAvgOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "estimates". All fields are combined with a logical 'AND'. */
export type EstimatesBoolExp = {
  _and?: InputMaybe<Array<EstimatesBoolExp>>;
  _not?: InputMaybe<EstimatesBoolExp>;
  _or?: InputMaybe<Array<EstimatesBoolExp>>;
  acceptedAt?: InputMaybe<TimestamptzComparisonExp>;
  acceptedOnBehalfBy?: InputMaybe<UuidComparisonExp>;
  acceptedOnBehalfByUser?: InputMaybe<UsersBoolExp>;
  closedLostReasonCategory?: InputMaybe<StringComparisonExp>;
  closedLostReasonNote?: InputMaybe<StringComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  displayId?: InputMaybe<BigintComparisonExp>;
  displayIdString?: InputMaybe<StringComparisonExp>;
  dynamicPricingType?: InputMaybe<Scalars['DynamicPricingTypeComparisonExp']>;
  estimateGuid?: InputMaybe<UuidComparisonExp>;
  estimateOptions?: InputMaybe<EstimateOptionsBoolExp>;
  estimateOptionsAggregate?: InputMaybe<EstimateOptionsAggregateBoolExp>;
  estimatePhotos?: InputMaybe<EstimatePhotosBoolExp>;
  estimatePhotosAggregate?: InputMaybe<EstimatePhotosAggregateBoolExp>;
  hideLineItemPrices?: InputMaybe<BooleanComparisonExp>;
  invoiceLink?: InputMaybe<EstimateInvoicesBoolExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobAppointment?: InputMaybe<JobAppointmentsBoolExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  lastSentAt?: InputMaybe<TimestamptzComparisonExp>;
  linkedToJobs?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
  linkedToJobsAggregate?: InputMaybe<JobsWithLinkedJobLinkedEstimatesAggregateBoolExp>;
  maintenancePlanSavingsEnabled?: InputMaybe<BooleanComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  messageHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
  remindersSent?: InputMaybe<IntComparisonExp>;
  signatureFileUrl?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<Scalars['EstimateV2StatusComparisonExp']>;
  taxRate?: InputMaybe<NumericComparisonExp>;
  taxRateGuid?: InputMaybe<UuidComparisonExp>;
  taxRateName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "estimates" */
export type EstimatesConstraint =
  /** unique or primary key constraint on columns "display_id", "company_guid" */
  | 'estimates_company_guid_display_id_key'
  /** unique or primary key constraint on columns "estimate_guid" */
  | 'estimates_pkey';

/** input type for incrementing numeric columns in table "estimates" */
export type EstimatesIncInput = {
  displayId?: InputMaybe<Scalars['bigint']>;
  remindersSent?: InputMaybe<Scalars['Int']>;
  taxRate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "estimates" */
export type EstimatesInsertInput = {
  acceptedAt?: InputMaybe<Scalars['timestamptz']>;
  acceptedOnBehalfBy?: InputMaybe<Scalars['uuid']>;
  acceptedOnBehalfByUser?: InputMaybe<UsersObjRelInsertInput>;
  closedLostReasonCategory?: InputMaybe<Scalars['String']>;
  closedLostReasonNote?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  displayId?: InputMaybe<Scalars['bigint']>;
  dynamicPricingType?: InputMaybe<Scalars['DynamicPricingType']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  estimateOptions?: InputMaybe<EstimateOptionsArrRelInsertInput>;
  estimatePhotos?: InputMaybe<EstimatePhotosArrRelInsertInput>;
  /** Per-estimate override: hide per-line prices on customer-facing renders. Seeded from company_config.hide_line_item_prices at create. */
  hideLineItemPrices?: InputMaybe<Scalars['Boolean']>;
  invoiceLink?: InputMaybe<EstimateInvoicesObjRelInsertInput>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobAppointment?: InputMaybe<JobAppointmentsObjRelInsertInput>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  lastSentAt?: InputMaybe<Scalars['timestamptz']>;
  linkedToJobs?: InputMaybe<JobsWithLinkedJobLinkedEstimatesArrRelInsertInput>;
  maintenancePlanSavingsEnabled?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  messageHtml?: InputMaybe<Scalars['HtmlString']>;
  remindersSent?: InputMaybe<Scalars['Int']>;
  signatureFileUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['EstimateV2Status']>;
  taxRate?: InputMaybe<Scalars['numeric']>;
  taxRateGuid?: InputMaybe<Scalars['uuid']>;
  taxRateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EstimatesMaxFields = {
  __typename?: 'EstimatesMaxFields';
  acceptedAt?: Maybe<Scalars['timestamptz']>;
  acceptedOnBehalfBy?: Maybe<Scalars['uuid']>;
  closedLostReasonCategory?: Maybe<Scalars['String']>;
  closedLostReasonNote?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  displayId?: Maybe<Scalars['bigint']>;
  /** A computed field, executes function "estimate_display_id_as_text" */
  displayIdString?: Maybe<Scalars['String']>;
  dynamicPricingType?: Maybe<Scalars['DynamicPricingType']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  lastSentAt?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
  messageHtml?: Maybe<Scalars['HtmlString']>;
  remindersSent?: Maybe<Scalars['Int']>;
  signatureFileUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['EstimateV2Status']>;
  taxRate?: Maybe<Scalars['numeric']>;
  taxRateGuid?: Maybe<Scalars['uuid']>;
  taxRateName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "estimates" */
export type EstimatesMaxOrderBy = {
  acceptedAt?: InputMaybe<OrderBy>;
  acceptedOnBehalfBy?: InputMaybe<OrderBy>;
  closedLostReasonCategory?: InputMaybe<OrderBy>;
  closedLostReasonNote?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  dynamicPricingType?: InputMaybe<OrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  lastSentAt?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  messageHtml?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  signatureFileUrl?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  taxRateGuid?: InputMaybe<OrderBy>;
  taxRateName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EstimatesMinFields = {
  __typename?: 'EstimatesMinFields';
  acceptedAt?: Maybe<Scalars['timestamptz']>;
  acceptedOnBehalfBy?: Maybe<Scalars['uuid']>;
  closedLostReasonCategory?: Maybe<Scalars['String']>;
  closedLostReasonNote?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  displayId?: Maybe<Scalars['bigint']>;
  /** A computed field, executes function "estimate_display_id_as_text" */
  displayIdString?: Maybe<Scalars['String']>;
  dynamicPricingType?: Maybe<Scalars['DynamicPricingType']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  lastSentAt?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
  messageHtml?: Maybe<Scalars['HtmlString']>;
  remindersSent?: Maybe<Scalars['Int']>;
  signatureFileUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['EstimateV2Status']>;
  taxRate?: Maybe<Scalars['numeric']>;
  taxRateGuid?: Maybe<Scalars['uuid']>;
  taxRateName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "estimates" */
export type EstimatesMinOrderBy = {
  acceptedAt?: InputMaybe<OrderBy>;
  acceptedOnBehalfBy?: InputMaybe<OrderBy>;
  closedLostReasonCategory?: InputMaybe<OrderBy>;
  closedLostReasonNote?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  dynamicPricingType?: InputMaybe<OrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  lastSentAt?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  messageHtml?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  signatureFileUrl?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  taxRateGuid?: InputMaybe<OrderBy>;
  taxRateName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "estimates" */
export type EstimatesMutationResponse = {
  __typename?: 'EstimatesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Estimates>;
};

/** input type for inserting object relation for remote table "estimates" */
export type EstimatesObjRelInsertInput = {
  data: EstimatesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EstimatesOnConflict>;
};

/** on_conflict condition type for table "estimates" */
export type EstimatesOnConflict = {
  constraint: EstimatesConstraint;
  updateColumns?: Array<EstimatesUpdateColumn>;
  where?: InputMaybe<EstimatesBoolExp>;
};

/** Ordering options when selecting data from "estimates". */
export type EstimatesOrderBy = {
  acceptedAt?: InputMaybe<OrderBy>;
  acceptedOnBehalfBy?: InputMaybe<OrderBy>;
  acceptedOnBehalfByUser?: InputMaybe<UsersOrderBy>;
  closedLostReasonCategory?: InputMaybe<OrderBy>;
  closedLostReasonNote?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  displayId?: InputMaybe<OrderBy>;
  displayIdString?: InputMaybe<OrderBy>;
  dynamicPricingType?: InputMaybe<OrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  estimateOptionsAggregate?: InputMaybe<EstimateOptionsAggregateOrderBy>;
  estimatePhotosAggregate?: InputMaybe<EstimatePhotosAggregateOrderBy>;
  hideLineItemPrices?: InputMaybe<OrderBy>;
  invoiceLink?: InputMaybe<EstimateInvoicesOrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobAppointment?: InputMaybe<JobAppointmentsOrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  lastSentAt?: InputMaybe<OrderBy>;
  linkedToJobsAggregate?: InputMaybe<JobsWithLinkedJobLinkedEstimatesAggregateOrderBy>;
  maintenancePlanSavingsEnabled?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  messageHtml?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  signatureFileUrl?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  taxRateGuid?: InputMaybe<OrderBy>;
  taxRateName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: estimates */
export type EstimatesPkColumnsInput = {
  estimateGuid: Scalars['uuid'];
};

/** columns and relationships of "estimates_queryable" */
export type EstimatesQueryable = {
  __typename?: 'EstimatesQueryable';
  /** An object relationship */
  account?: Maybe<Accounts>;
  accountGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  displayName?: Maybe<Scalars['String']>;
  estimateGuid: Scalars['uuid'];
  estimateStatus: Scalars['String'];
  issuedAt: Scalars['timestamptz'];
  /** An object relationship */
  job?: Maybe<Jobs>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  latestInvoice?: Maybe<InvoicesQueryable>;
  latestInvoiceGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  referenceNumber: Scalars['String'];
  soldAt?: Maybe<Scalars['timestamptz']>;
  summary?: Maybe<Scalars['String']>;
  totalAmountUsd: Scalars['numeric'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "estimates_queryable" */
export type EstimatesQueryableAggregate = {
  __typename?: 'EstimatesQueryableAggregate';
  aggregate?: Maybe<EstimatesQueryableAggregateFields>;
  nodes: Array<EstimatesQueryable>;
};

/** aggregate fields of "estimates_queryable" */
export type EstimatesQueryableAggregateFields = {
  __typename?: 'EstimatesQueryableAggregateFields';
  avg?: Maybe<EstimatesQueryableAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EstimatesQueryableMaxFields>;
  min?: Maybe<EstimatesQueryableMinFields>;
  stddev?: Maybe<EstimatesQueryableStddevFields>;
  stddevPop?: Maybe<EstimatesQueryableStddevPopFields>;
  stddevSamp?: Maybe<EstimatesQueryableStddevSampFields>;
  sum?: Maybe<EstimatesQueryableSumFields>;
  varPop?: Maybe<EstimatesQueryableVarPopFields>;
  varSamp?: Maybe<EstimatesQueryableVarSampFields>;
  variance?: Maybe<EstimatesQueryableVarianceFields>;
};


/** aggregate fields of "estimates_queryable" */
export type EstimatesQueryableAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EstimatesQueryableSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EstimatesQueryableAvgFields = {
  __typename?: 'EstimatesQueryableAvgFields';
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "estimates_queryable". All fields are combined with a logical 'AND'. */
export type EstimatesQueryableBoolExp = {
  _and?: InputMaybe<Array<EstimatesQueryableBoolExp>>;
  _not?: InputMaybe<EstimatesQueryableBoolExp>;
  _or?: InputMaybe<Array<EstimatesQueryableBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  estimateGuid?: InputMaybe<UuidComparisonExp>;
  estimateStatus?: InputMaybe<StringComparisonExp>;
  issuedAt?: InputMaybe<TimestamptzComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  latestInvoice?: InputMaybe<InvoicesQueryableBoolExp>;
  latestInvoiceGuid?: InputMaybe<UuidComparisonExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  referenceNumber?: InputMaybe<StringComparisonExp>;
  soldAt?: InputMaybe<TimestamptzComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
  totalAmountUsd?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "estimates_queryable" */
export type EstimatesQueryableConstraint =
  /** unique or primary key constraint on columns "estimate_guid" */
  | 'estimates_queryable_pkey';

/** input type for incrementing numeric columns in table "estimates_queryable" */
export type EstimatesQueryableIncInput = {
  totalAmountUsd?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "estimates_queryable" */
export type EstimatesQueryableInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  displayName?: InputMaybe<Scalars['String']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  estimateStatus?: InputMaybe<Scalars['String']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  latestInvoice?: InputMaybe<InvoicesQueryableObjRelInsertInput>;
  latestInvoiceGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  soldAt?: InputMaybe<Scalars['timestamptz']>;
  summary?: InputMaybe<Scalars['String']>;
  totalAmountUsd?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type EstimatesQueryableMaxFields = {
  __typename?: 'EstimatesQueryableMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  displayName?: Maybe<Scalars['String']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  estimateStatus?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  latestInvoiceGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  referenceNumber?: Maybe<Scalars['String']>;
  soldAt?: Maybe<Scalars['timestamptz']>;
  summary?: Maybe<Scalars['String']>;
  totalAmountUsd?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type EstimatesQueryableMinFields = {
  __typename?: 'EstimatesQueryableMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  displayName?: Maybe<Scalars['String']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  estimateStatus?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  latestInvoiceGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  referenceNumber?: Maybe<Scalars['String']>;
  soldAt?: Maybe<Scalars['timestamptz']>;
  summary?: Maybe<Scalars['String']>;
  totalAmountUsd?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "estimates_queryable" */
export type EstimatesQueryableMutationResponse = {
  __typename?: 'EstimatesQueryableMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EstimatesQueryable>;
};

/** on_conflict condition type for table "estimates_queryable" */
export type EstimatesQueryableOnConflict = {
  constraint: EstimatesQueryableConstraint;
  updateColumns?: Array<EstimatesQueryableUpdateColumn>;
  where?: InputMaybe<EstimatesQueryableBoolExp>;
};

/** Ordering options when selecting data from "estimates_queryable". */
export type EstimatesQueryableOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  estimateStatus?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  latestInvoice?: InputMaybe<InvoicesQueryableOrderBy>;
  latestInvoiceGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  referenceNumber?: InputMaybe<OrderBy>;
  soldAt?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: estimates_queryable */
export type EstimatesQueryablePkColumnsInput = {
  estimateGuid: Scalars['uuid'];
};

/** select columns of table "estimates_queryable" */
export type EstimatesQueryableSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'displayName'
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'estimateStatus'
  /** column name */
  | 'issuedAt'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'latestInvoiceGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'referenceNumber'
  /** column name */
  | 'soldAt'
  /** column name */
  | 'summary'
  /** column name */
  | 'totalAmountUsd'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "estimates_queryable" */
export type EstimatesQueryableSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  displayName?: InputMaybe<Scalars['String']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  estimateStatus?: InputMaybe<Scalars['String']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  latestInvoiceGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  soldAt?: InputMaybe<Scalars['timestamptz']>;
  summary?: InputMaybe<Scalars['String']>;
  totalAmountUsd?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EstimatesQueryableStddevFields = {
  __typename?: 'EstimatesQueryableStddevFields';
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type EstimatesQueryableStddevPopFields = {
  __typename?: 'EstimatesQueryableStddevPopFields';
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type EstimatesQueryableStddevSampFields = {
  __typename?: 'EstimatesQueryableStddevSampFields';
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "estimates_queryable" */
export type EstimatesQueryableStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EstimatesQueryableStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EstimatesQueryableStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  displayName?: InputMaybe<Scalars['String']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  estimateStatus?: InputMaybe<Scalars['String']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  latestInvoiceGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  soldAt?: InputMaybe<Scalars['timestamptz']>;
  summary?: InputMaybe<Scalars['String']>;
  totalAmountUsd?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EstimatesQueryableSumFields = {
  __typename?: 'EstimatesQueryableSumFields';
  totalAmountUsd?: Maybe<Scalars['numeric']>;
};

/** update columns of table "estimates_queryable" */
export type EstimatesQueryableUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'displayName'
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'estimateStatus'
  /** column name */
  | 'issuedAt'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'latestInvoiceGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'referenceNumber'
  /** column name */
  | 'soldAt'
  /** column name */
  | 'summary'
  /** column name */
  | 'totalAmountUsd'
  /** column name */
  | 'updatedAt';

export type EstimatesQueryableUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EstimatesQueryableIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EstimatesQueryableSetInput>;
  /** filter the rows which have to be updated */
  where: EstimatesQueryableBoolExp;
};

/** aggregate varPop on columns */
export type EstimatesQueryableVarPopFields = {
  __typename?: 'EstimatesQueryableVarPopFields';
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type EstimatesQueryableVarSampFields = {
  __typename?: 'EstimatesQueryableVarSampFields';
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EstimatesQueryableVarianceFields = {
  __typename?: 'EstimatesQueryableVarianceFields';
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** select columns of table "estimates" */
export type EstimatesSelectColumn =
  /** column name */
  | 'acceptedAt'
  /** column name */
  | 'acceptedOnBehalfBy'
  /** column name */
  | 'closedLostReasonCategory'
  /** column name */
  | 'closedLostReasonNote'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'displayId'
  /** column name */
  | 'dynamicPricingType'
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'hideLineItemPrices'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'lastSentAt'
  /** column name */
  | 'maintenancePlanSavingsEnabled'
  /** column name */
  | 'message'
  /** column name */
  | 'messageHtml'
  /** column name */
  | 'remindersSent'
  /** column name */
  | 'signatureFileUrl'
  /** column name */
  | 'status'
  /** column name */
  | 'taxRate'
  /** column name */
  | 'taxRateGuid'
  /** column name */
  | 'taxRateName'
  /** column name */
  | 'updatedAt';

/** select "estimatesAggregateBoolExpBool_andArgumentsColumns" columns of table "estimates" */
export type EstimatesSelectColumnEstimatesAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'hideLineItemPrices'
  /** column name */
  | 'maintenancePlanSavingsEnabled';

/** select "estimatesAggregateBoolExpBool_orArgumentsColumns" columns of table "estimates" */
export type EstimatesSelectColumnEstimatesAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'hideLineItemPrices'
  /** column name */
  | 'maintenancePlanSavingsEnabled';

/** input type for updating data in table "estimates" */
export type EstimatesSetInput = {
  acceptedAt?: InputMaybe<Scalars['timestamptz']>;
  acceptedOnBehalfBy?: InputMaybe<Scalars['uuid']>;
  closedLostReasonCategory?: InputMaybe<Scalars['String']>;
  closedLostReasonNote?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  displayId?: InputMaybe<Scalars['bigint']>;
  dynamicPricingType?: InputMaybe<Scalars['DynamicPricingType']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  /** Per-estimate override: hide per-line prices on customer-facing renders. Seeded from company_config.hide_line_item_prices at create. */
  hideLineItemPrices?: InputMaybe<Scalars['Boolean']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  lastSentAt?: InputMaybe<Scalars['timestamptz']>;
  maintenancePlanSavingsEnabled?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  messageHtml?: InputMaybe<Scalars['HtmlString']>;
  remindersSent?: InputMaybe<Scalars['Int']>;
  signatureFileUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['EstimateV2Status']>;
  taxRate?: InputMaybe<Scalars['numeric']>;
  taxRateGuid?: InputMaybe<Scalars['uuid']>;
  taxRateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EstimatesStddevFields = {
  __typename?: 'EstimatesStddevFields';
  displayId?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "estimates" */
export type EstimatesStddevOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EstimatesStddevPopFields = {
  __typename?: 'EstimatesStddevPopFields';
  displayId?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "estimates" */
export type EstimatesStddevPopOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EstimatesStddevSampFields = {
  __typename?: 'EstimatesStddevSampFields';
  displayId?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "estimates" */
export type EstimatesStddevSampOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "estimates" */
export type EstimatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EstimatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EstimatesStreamCursorValueInput = {
  acceptedAt?: InputMaybe<Scalars['timestamptz']>;
  acceptedOnBehalfBy?: InputMaybe<Scalars['uuid']>;
  closedLostReasonCategory?: InputMaybe<Scalars['String']>;
  closedLostReasonNote?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  displayId?: InputMaybe<Scalars['bigint']>;
  dynamicPricingType?: InputMaybe<Scalars['DynamicPricingType']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  /** Per-estimate override: hide per-line prices on customer-facing renders. Seeded from company_config.hide_line_item_prices at create. */
  hideLineItemPrices?: InputMaybe<Scalars['Boolean']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  lastSentAt?: InputMaybe<Scalars['timestamptz']>;
  maintenancePlanSavingsEnabled?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  messageHtml?: InputMaybe<Scalars['HtmlString']>;
  remindersSent?: InputMaybe<Scalars['Int']>;
  signatureFileUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['EstimateV2Status']>;
  taxRate?: InputMaybe<Scalars['numeric']>;
  taxRateGuid?: InputMaybe<Scalars['uuid']>;
  taxRateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EstimatesSumFields = {
  __typename?: 'EstimatesSumFields';
  displayId?: Maybe<Scalars['bigint']>;
  remindersSent?: Maybe<Scalars['Int']>;
  taxRate?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "estimates" */
export type EstimatesSumOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
};

/** update columns of table "estimates" */
export type EstimatesUpdateColumn =
  /** column name */
  | 'acceptedAt'
  /** column name */
  | 'acceptedOnBehalfBy'
  /** column name */
  | 'closedLostReasonCategory'
  /** column name */
  | 'closedLostReasonNote'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'displayId'
  /** column name */
  | 'dynamicPricingType'
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'hideLineItemPrices'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'lastSentAt'
  /** column name */
  | 'maintenancePlanSavingsEnabled'
  /** column name */
  | 'message'
  /** column name */
  | 'messageHtml'
  /** column name */
  | 'remindersSent'
  /** column name */
  | 'signatureFileUrl'
  /** column name */
  | 'status'
  /** column name */
  | 'taxRate'
  /** column name */
  | 'taxRateGuid'
  /** column name */
  | 'taxRateName'
  /** column name */
  | 'updatedAt';

export type EstimatesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EstimatesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EstimatesSetInput>;
  /** filter the rows which have to be updated */
  where: EstimatesBoolExp;
};

/** aggregate varPop on columns */
export type EstimatesVarPopFields = {
  __typename?: 'EstimatesVarPopFields';
  displayId?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "estimates" */
export type EstimatesVarPopOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EstimatesVarSampFields = {
  __typename?: 'EstimatesVarSampFields';
  displayId?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "estimates" */
export type EstimatesVarSampOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EstimatesVarianceFields = {
  __typename?: 'EstimatesVarianceFields';
  displayId?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "estimates" */
export type EstimatesVarianceOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
};

/** columns and relationships of "event_store" */
export type EventStore = {
  __typename?: 'EventStore';
  actingUserGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
  entityGuid: Scalars['uuid'];
  entityType: Scalars['String'];
  entityVersion: Scalars['numeric'];
  eventDataJson: Scalars['jsonb'];
  eventType: Scalars['String'];
  occurredAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
};


/** columns and relationships of "event_store" */
export type EventStoreEventDataJsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "event_store" */
export type EventStoreAggregate = {
  __typename?: 'EventStoreAggregate';
  aggregate?: Maybe<EventStoreAggregateFields>;
  nodes: Array<EventStore>;
};

export type EventStoreAggregateBoolExp = {
  count?: InputMaybe<EventStoreAggregateBoolExpCount>;
};

/** aggregate fields of "event_store" */
export type EventStoreAggregateFields = {
  __typename?: 'EventStoreAggregateFields';
  avg?: Maybe<EventStoreAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<EventStoreMaxFields>;
  min?: Maybe<EventStoreMinFields>;
  stddev?: Maybe<EventStoreStddevFields>;
  stddevPop?: Maybe<EventStoreStddevPopFields>;
  stddevSamp?: Maybe<EventStoreStddevSampFields>;
  sum?: Maybe<EventStoreSumFields>;
  varPop?: Maybe<EventStoreVarPopFields>;
  varSamp?: Maybe<EventStoreVarSampFields>;
  variance?: Maybe<EventStoreVarianceFields>;
};


/** aggregate fields of "event_store" */
export type EventStoreAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EventStoreSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_store" */
export type EventStoreAggregateOrderBy = {
  avg?: InputMaybe<EventStoreAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EventStoreMaxOrderBy>;
  min?: InputMaybe<EventStoreMinOrderBy>;
  stddev?: InputMaybe<EventStoreStddevOrderBy>;
  stddevPop?: InputMaybe<EventStoreStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EventStoreStddevSampOrderBy>;
  sum?: InputMaybe<EventStoreSumOrderBy>;
  varPop?: InputMaybe<EventStoreVarPopOrderBy>;
  varSamp?: InputMaybe<EventStoreVarSampOrderBy>;
  variance?: InputMaybe<EventStoreVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EventStoreAppendInput = {
  eventDataJson?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "event_store" */
export type EventStoreArrRelInsertInput = {
  data: Array<EventStoreInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EventStoreOnConflict>;
};

/** aggregate avg on columns */
export type EventStoreAvgFields = {
  __typename?: 'EventStoreAvgFields';
  entityVersion?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "event_store" */
export type EventStoreAvgOrderBy = {
  entityVersion?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "event_store". All fields are combined with a logical 'AND'. */
export type EventStoreBoolExp = {
  _and?: InputMaybe<Array<EventStoreBoolExp>>;
  _not?: InputMaybe<EventStoreBoolExp>;
  _or?: InputMaybe<Array<EventStoreBoolExp>>;
  actingUserGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  entityGuid?: InputMaybe<UuidComparisonExp>;
  entityType?: InputMaybe<StringComparisonExp>;
  entityVersion?: InputMaybe<NumericComparisonExp>;
  eventDataJson?: InputMaybe<JsonbComparisonExp>;
  eventType?: InputMaybe<StringComparisonExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "event_store" */
export type EventStoreConstraint =
  /** unique or primary key constraint on columns "entity_type", "entity_guid", "entity_version" */
  | 'event_store_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EventStoreDeleteAtPathInput = {
  eventDataJson?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EventStoreDeleteElemInput = {
  eventDataJson?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EventStoreDeleteKeyInput = {
  eventDataJson?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "event_store" */
export type EventStoreIncInput = {
  entityVersion?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "event_store" */
export type EventStoreInsertInput = {
  actingUserGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  entityGuid?: InputMaybe<Scalars['uuid']>;
  entityType?: InputMaybe<Scalars['String']>;
  entityVersion?: InputMaybe<Scalars['numeric']>;
  eventDataJson?: InputMaybe<Scalars['jsonb']>;
  eventType?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type EventStoreMaxFields = {
  __typename?: 'EventStoreMaxFields';
  actingUserGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  entityGuid?: Maybe<Scalars['uuid']>;
  entityType?: Maybe<Scalars['String']>;
  entityVersion?: Maybe<Scalars['numeric']>;
  eventType?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "event_store" */
export type EventStoreMaxOrderBy = {
  actingUserGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  entityGuid?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  entityVersion?: InputMaybe<OrderBy>;
  eventType?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EventStoreMinFields = {
  __typename?: 'EventStoreMinFields';
  actingUserGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  entityGuid?: Maybe<Scalars['uuid']>;
  entityType?: Maybe<Scalars['String']>;
  entityVersion?: Maybe<Scalars['numeric']>;
  eventType?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "event_store" */
export type EventStoreMinOrderBy = {
  actingUserGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  entityGuid?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  entityVersion?: InputMaybe<OrderBy>;
  eventType?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "event_store" */
export type EventStoreMutationResponse = {
  __typename?: 'EventStoreMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventStore>;
};

/** on_conflict condition type for table "event_store" */
export type EventStoreOnConflict = {
  constraint: EventStoreConstraint;
  updateColumns?: Array<EventStoreUpdateColumn>;
  where?: InputMaybe<EventStoreBoolExp>;
};

/** Ordering options when selecting data from "event_store". */
export type EventStoreOrderBy = {
  actingUserGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  entityGuid?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  entityVersion?: InputMaybe<OrderBy>;
  eventDataJson?: InputMaybe<OrderBy>;
  eventType?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: event_store */
export type EventStorePkColumnsInput = {
  entityGuid: Scalars['uuid'];
  entityType: Scalars['String'];
  entityVersion: Scalars['numeric'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EventStorePrependInput = {
  eventDataJson?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "event_store" */
export type EventStoreSelectColumn =
  /** column name */
  | 'actingUserGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'entityGuid'
  /** column name */
  | 'entityType'
  /** column name */
  | 'entityVersion'
  /** column name */
  | 'eventDataJson'
  /** column name */
  | 'eventType'
  /** column name */
  | 'occurredAt';

/** input type for updating data in table "event_store" */
export type EventStoreSetInput = {
  actingUserGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  entityGuid?: InputMaybe<Scalars['uuid']>;
  entityType?: InputMaybe<Scalars['String']>;
  entityVersion?: InputMaybe<Scalars['numeric']>;
  eventDataJson?: InputMaybe<Scalars['jsonb']>;
  eventType?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type EventStoreStddevFields = {
  __typename?: 'EventStoreStddevFields';
  entityVersion?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "event_store" */
export type EventStoreStddevOrderBy = {
  entityVersion?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EventStoreStddevPopFields = {
  __typename?: 'EventStoreStddevPopFields';
  entityVersion?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "event_store" */
export type EventStoreStddevPopOrderBy = {
  entityVersion?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EventStoreStddevSampFields = {
  __typename?: 'EventStoreStddevSampFields';
  entityVersion?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "event_store" */
export type EventStoreStddevSampOrderBy = {
  entityVersion?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "event_store" */
export type EventStoreStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EventStoreStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EventStoreStreamCursorValueInput = {
  actingUserGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  entityGuid?: InputMaybe<Scalars['uuid']>;
  entityType?: InputMaybe<Scalars['String']>;
  entityVersion?: InputMaybe<Scalars['numeric']>;
  eventDataJson?: InputMaybe<Scalars['jsonb']>;
  eventType?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type EventStoreSumFields = {
  __typename?: 'EventStoreSumFields';
  entityVersion?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "event_store" */
export type EventStoreSumOrderBy = {
  entityVersion?: InputMaybe<OrderBy>;
};

/** update columns of table "event_store" */
export type EventStoreUpdateColumn =
  /** column name */
  | 'actingUserGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'entityGuid'
  /** column name */
  | 'entityType'
  /** column name */
  | 'entityVersion'
  /** column name */
  | 'eventDataJson'
  /** column name */
  | 'eventType'
  /** column name */
  | 'occurredAt';

export type EventStoreUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EventStoreAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<EventStoreDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<EventStoreDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<EventStoreDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventStoreIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EventStorePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventStoreSetInput>;
  /** filter the rows which have to be updated */
  where: EventStoreBoolExp;
};

/** aggregate varPop on columns */
export type EventStoreVarPopFields = {
  __typename?: 'EventStoreVarPopFields';
  entityVersion?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "event_store" */
export type EventStoreVarPopOrderBy = {
  entityVersion?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EventStoreVarSampFields = {
  __typename?: 'EventStoreVarSampFields';
  entityVersion?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "event_store" */
export type EventStoreVarSampOrderBy = {
  entityVersion?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EventStoreVarianceFields = {
  __typename?: 'EventStoreVarianceFields';
  entityVersion?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "event_store" */
export type EventStoreVarianceOrderBy = {
  entityVersion?: InputMaybe<OrderBy>;
};

/** User-scoped favorite pricebook items for quick access in the picker */
export type FavoritePricebookItems = {
  __typename?: 'FavoritePricebookItems';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  pricebookItemGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "favorite_pricebook_items" */
export type FavoritePricebookItemsAggregate = {
  __typename?: 'FavoritePricebookItemsAggregate';
  aggregate?: Maybe<FavoritePricebookItemsAggregateFields>;
  nodes: Array<FavoritePricebookItems>;
};

/** aggregate fields of "favorite_pricebook_items" */
export type FavoritePricebookItemsAggregateFields = {
  __typename?: 'FavoritePricebookItemsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<FavoritePricebookItemsMaxFields>;
  min?: Maybe<FavoritePricebookItemsMinFields>;
};


/** aggregate fields of "favorite_pricebook_items" */
export type FavoritePricebookItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FavoritePricebookItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "favorite_pricebook_items". All fields are combined with a logical 'AND'. */
export type FavoritePricebookItemsBoolExp = {
  _and?: InputMaybe<Array<FavoritePricebookItemsBoolExp>>;
  _not?: InputMaybe<FavoritePricebookItemsBoolExp>;
  _or?: InputMaybe<Array<FavoritePricebookItemsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  pricebookItemGuid?: InputMaybe<UuidComparisonExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "favorite_pricebook_items" */
export type FavoritePricebookItemsConstraint =
  /** unique or primary key constraint on columns "user_guid", "pricebook_item_guid" */
  | 'favorite_pricebook_items_pkey';

/** input type for inserting data into table "favorite_pricebook_items" */
export type FavoritePricebookItemsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type FavoritePricebookItemsMaxFields = {
  __typename?: 'FavoritePricebookItemsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  pricebookItemGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type FavoritePricebookItemsMinFields = {
  __typename?: 'FavoritePricebookItemsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  pricebookItemGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "favorite_pricebook_items" */
export type FavoritePricebookItemsMutationResponse = {
  __typename?: 'FavoritePricebookItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FavoritePricebookItems>;
};

/** on_conflict condition type for table "favorite_pricebook_items" */
export type FavoritePricebookItemsOnConflict = {
  constraint: FavoritePricebookItemsConstraint;
  updateColumns?: Array<FavoritePricebookItemsUpdateColumn>;
  where?: InputMaybe<FavoritePricebookItemsBoolExp>;
};

/** Ordering options when selecting data from "favorite_pricebook_items". */
export type FavoritePricebookItemsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  pricebookItemGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: favorite_pricebook_items */
export type FavoritePricebookItemsPkColumnsInput = {
  pricebookItemGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};

/** select columns of table "favorite_pricebook_items" */
export type FavoritePricebookItemsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'pricebookItemGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "favorite_pricebook_items" */
export type FavoritePricebookItemsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "favorite_pricebook_items" */
export type FavoritePricebookItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FavoritePricebookItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FavoritePricebookItemsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "favorite_pricebook_items" */
export type FavoritePricebookItemsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'pricebookItemGuid'
  /** column name */
  | 'userGuid';

export type FavoritePricebookItemsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FavoritePricebookItemsSetInput>;
  /** filter the rows which have to be updated */
  where: FavoritePricebookItemsBoolExp;
};

/** columns and relationships of "file_links" */
export type FileLinks = {
  __typename?: 'FileLinks';
  /** An object relationship */
  account?: Maybe<Accounts>;
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  file: Files;
  fileGuid: Scalars['uuid'];
  /** An object relationship */
  job?: Maybe<Jobs>;
  /** An object relationship */
  jobAppointment?: Maybe<JobAppointments>;
  /** An object relationship */
  jobAppointmentAssignment?: Maybe<JobAppointmentAssignments>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  location?: Maybe<Locations>;
  locationGuid?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamp'];
};

/** aggregated selection of "file_links" */
export type FileLinksAggregate = {
  __typename?: 'FileLinksAggregate';
  aggregate?: Maybe<FileLinksAggregateFields>;
  nodes: Array<FileLinks>;
};

export type FileLinksAggregateBoolExp = {
  count?: InputMaybe<FileLinksAggregateBoolExpCount>;
};

/** aggregate fields of "file_links" */
export type FileLinksAggregateFields = {
  __typename?: 'FileLinksAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<FileLinksMaxFields>;
  min?: Maybe<FileLinksMinFields>;
};


/** aggregate fields of "file_links" */
export type FileLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FileLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "file_links" */
export type FileLinksAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<FileLinksMaxOrderBy>;
  min?: InputMaybe<FileLinksMinOrderBy>;
};

/** input type for inserting array relation for remote table "file_links" */
export type FileLinksArrRelInsertInput = {
  data: Array<FileLinksInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<FileLinksOnConflict>;
};

/** Boolean expression to filter rows from the table "file_links". All fields are combined with a logical 'AND'. */
export type FileLinksBoolExp = {
  _and?: InputMaybe<Array<FileLinksBoolExp>>;
  _not?: InputMaybe<FileLinksBoolExp>;
  _or?: InputMaybe<Array<FileLinksBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  file?: InputMaybe<FilesBoolExp>;
  fileGuid?: InputMaybe<UuidComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobAppointment?: InputMaybe<JobAppointmentsBoolExp>;
  jobAppointmentAssignment?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
  jobAppointmentAssignmentGuid?: InputMaybe<UuidComparisonExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestampComparisonExp>;
};

/** unique or primary key constraints on table "file_links" */
export type FileLinksConstraint =
  /** unique or primary key constraint on columns "file_guid" */
  | 'file_links_pkey';

/** input type for inserting data into table "file_links" */
export type FileLinksInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  file?: InputMaybe<FilesObjRelInsertInput>;
  fileGuid?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobAppointment?: InputMaybe<JobAppointmentsObjRelInsertInput>;
  jobAppointmentAssignment?: InputMaybe<JobAppointmentAssignmentsObjRelInsertInput>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<LocationsObjRelInsertInput>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type FileLinksMaxFields = {
  __typename?: 'FileLinksMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "file_links" */
export type FileLinksMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fileGuid?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type FileLinksMinFields = {
  __typename?: 'FileLinksMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fileGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "file_links" */
export type FileLinksMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fileGuid?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "file_links" */
export type FileLinksMutationResponse = {
  __typename?: 'FileLinksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FileLinks>;
};

/** on_conflict condition type for table "file_links" */
export type FileLinksOnConflict = {
  constraint: FileLinksConstraint;
  updateColumns?: Array<FileLinksUpdateColumn>;
  where?: InputMaybe<FileLinksBoolExp>;
};

/** Ordering options when selecting data from "file_links". */
export type FileLinksOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  file?: InputMaybe<FilesOrderBy>;
  fileGuid?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobAppointment?: InputMaybe<JobAppointmentsOrderBy>;
  jobAppointmentAssignment?: InputMaybe<JobAppointmentAssignmentsOrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: file_links */
export type FileLinksPkColumnsInput = {
  fileGuid: Scalars['uuid'];
};

/** select columns of table "file_links" */
export type FileLinksSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'fileGuid'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "file_links" */
export type FileLinksSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "file_links" */
export type FileLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FileLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FileLinksStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "file_links" */
export type FileLinksUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'fileGuid'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'updatedAt';

export type FileLinksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FileLinksSetInput>;
  /** filter the rows which have to be updated */
  where: FileLinksBoolExp;
};

/** columns and relationships of "files" */
export type Files = {
  __typename?: 'Files';
  cdnUrl: Scalars['String'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  fileGuid: Scalars['uuid'];
  fileName: Scalars['String'];
  fileSizeBytes?: Maybe<Scalars['Int']>;
  fileTypeMime: Scalars['String'];
  metadata: Scalars['FileMetadata'];
  resourceUrn: Scalars['String'];
  storageStrategy: Scalars['FileStorageStrategy'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "files" */
export type FilesMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "files" */
export type FilesAggregate = {
  __typename?: 'FilesAggregate';
  aggregate?: Maybe<FilesAggregateFields>;
  nodes: Array<Files>;
};

/** aggregate fields of "files" */
export type FilesAggregateFields = {
  __typename?: 'FilesAggregateFields';
  avg?: Maybe<FilesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<FilesMaxFields>;
  min?: Maybe<FilesMinFields>;
  stddev?: Maybe<FilesStddevFields>;
  stddevPop?: Maybe<FilesStddevPopFields>;
  stddevSamp?: Maybe<FilesStddevSampFields>;
  sum?: Maybe<FilesSumFields>;
  varPop?: Maybe<FilesVarPopFields>;
  varSamp?: Maybe<FilesVarSampFields>;
  variance?: Maybe<FilesVarianceFields>;
};


/** aggregate fields of "files" */
export type FilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FilesAppendInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type FilesAvgFields = {
  __typename?: 'FilesAvgFields';
  fileSizeBytes?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export type FilesBoolExp = {
  _and?: InputMaybe<Array<FilesBoolExp>>;
  _not?: InputMaybe<FilesBoolExp>;
  _or?: InputMaybe<Array<FilesBoolExp>>;
  cdnUrl?: InputMaybe<StringComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  fileGuid?: InputMaybe<UuidComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileSizeBytes?: InputMaybe<IntComparisonExp>;
  fileTypeMime?: InputMaybe<StringComparisonExp>;
  metadata?: InputMaybe<Scalars['FileMetadataComparisonExp']>;
  resourceUrn?: InputMaybe<StringComparisonExp>;
  storageStrategy?: InputMaybe<Scalars['FileStorageStrategyComparisonExp']>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "files" */
export type FilesConstraint =
  /** unique or primary key constraint on columns "file_guid" */
  | 'files_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FilesDeleteAtPathInput = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FilesDeleteElemInput = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FilesDeleteKeyInput = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "files" */
export type FilesIncInput = {
  fileSizeBytes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "files" */
export type FilesInsertInput = {
  cdnUrl?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  fileGuid?: InputMaybe<Scalars['uuid']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileSizeBytes?: InputMaybe<Scalars['Int']>;
  fileTypeMime?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['FileMetadata']>;
  resourceUrn?: InputMaybe<Scalars['String']>;
  storageStrategy?: InputMaybe<Scalars['FileStorageStrategy']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type FilesMaxFields = {
  __typename?: 'FilesMaxFields';
  cdnUrl?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  fileGuid?: Maybe<Scalars['uuid']>;
  fileName?: Maybe<Scalars['String']>;
  fileSizeBytes?: Maybe<Scalars['Int']>;
  fileTypeMime?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['FileMetadata']>;
  resourceUrn?: Maybe<Scalars['String']>;
  storageStrategy?: Maybe<Scalars['FileStorageStrategy']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type FilesMinFields = {
  __typename?: 'FilesMinFields';
  cdnUrl?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  fileGuid?: Maybe<Scalars['uuid']>;
  fileName?: Maybe<Scalars['String']>;
  fileSizeBytes?: Maybe<Scalars['Int']>;
  fileTypeMime?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['FileMetadata']>;
  resourceUrn?: Maybe<Scalars['String']>;
  storageStrategy?: Maybe<Scalars['FileStorageStrategy']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "files" */
export type FilesMutationResponse = {
  __typename?: 'FilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "files" */
export type FilesObjRelInsertInput = {
  data: FilesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<FilesOnConflict>;
};

/** on_conflict condition type for table "files" */
export type FilesOnConflict = {
  constraint: FilesConstraint;
  updateColumns?: Array<FilesUpdateColumn>;
  where?: InputMaybe<FilesBoolExp>;
};

/** Ordering options when selecting data from "files". */
export type FilesOrderBy = {
  cdnUrl?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  fileGuid?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileSizeBytes?: InputMaybe<OrderBy>;
  fileTypeMime?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  resourceUrn?: InputMaybe<OrderBy>;
  storageStrategy?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: files */
export type FilesPkColumnsInput = {
  fileGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FilesPrependInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "files" */
export type FilesSelectColumn =
  /** column name */
  | 'cdnUrl'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'fileGuid'
  /** column name */
  | 'fileName'
  /** column name */
  | 'fileSizeBytes'
  /** column name */
  | 'fileTypeMime'
  /** column name */
  | 'metadata'
  /** column name */
  | 'resourceUrn'
  /** column name */
  | 'storageStrategy'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "files" */
export type FilesSetInput = {
  cdnUrl?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  fileGuid?: InputMaybe<Scalars['uuid']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileSizeBytes?: InputMaybe<Scalars['Int']>;
  fileTypeMime?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['FileMetadata']>;
  resourceUrn?: InputMaybe<Scalars['String']>;
  storageStrategy?: InputMaybe<Scalars['FileStorageStrategy']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type FilesStddevFields = {
  __typename?: 'FilesStddevFields';
  fileSizeBytes?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type FilesStddevPopFields = {
  __typename?: 'FilesStddevPopFields';
  fileSizeBytes?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type FilesStddevSampFields = {
  __typename?: 'FilesStddevSampFields';
  fileSizeBytes?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "files" */
export type FilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FilesStreamCursorValueInput = {
  cdnUrl?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  fileGuid?: InputMaybe<Scalars['uuid']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileSizeBytes?: InputMaybe<Scalars['Int']>;
  fileTypeMime?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['FileMetadata']>;
  resourceUrn?: InputMaybe<Scalars['String']>;
  storageStrategy?: InputMaybe<Scalars['FileStorageStrategy']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type FilesSumFields = {
  __typename?: 'FilesSumFields';
  fileSizeBytes?: Maybe<Scalars['Int']>;
};

/** update columns of table "files" */
export type FilesUpdateColumn =
  /** column name */
  | 'cdnUrl'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'fileGuid'
  /** column name */
  | 'fileName'
  /** column name */
  | 'fileSizeBytes'
  /** column name */
  | 'fileTypeMime'
  /** column name */
  | 'metadata'
  /** column name */
  | 'resourceUrn'
  /** column name */
  | 'storageStrategy'
  /** column name */
  | 'updatedAt';

export type FilesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<FilesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<FilesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<FilesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<FilesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FilesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<FilesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FilesSetInput>;
  /** filter the rows which have to be updated */
  where: FilesBoolExp;
};

/** aggregate varPop on columns */
export type FilesVarPopFields = {
  __typename?: 'FilesVarPopFields';
  fileSizeBytes?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type FilesVarSampFields = {
  __typename?: 'FilesVarSampFields';
  fileSizeBytes?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type FilesVarianceFields = {
  __typename?: 'FilesVarianceFields';
  fileSizeBytes?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8ComparisonExp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

export type GeographyCastExp = {
  geometry?: InputMaybe<GeometryComparisonExp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type GeographyComparisonExp = {
  _cast?: InputMaybe<GeographyCastExp>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _stDWithin?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _stIntersects?: InputMaybe<Scalars['geography']>;
};

export type GeometryCastExp = {
  geography?: InputMaybe<GeographyComparisonExp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type GeometryComparisonExp = {
  _cast?: InputMaybe<GeometryCastExp>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st3dDWithin?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st3dIntersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _stContains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _stCrosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _stDWithin?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _stEquals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _stIntersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _stOverlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _stTouches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _stWithin?: InputMaybe<Scalars['geometry']>;
};

/** columns and relationships of "installed_equipment" */
export type InstalledEquipment = {
  __typename?: 'InstalledEquipment';
  averageLifeExpectancyYears?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  /** A computed field that returns the number of days since the equipment install. Returns null if installationDate is null */
  daysSinceInstall?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  equipmentCondition?: Maybe<Scalars['String']>;
  equipmentDimensions?: Maybe<Scalars['String']>;
  equipmentType: Scalars['String'];
  estimatedEndOfLifeDate?: Maybe<Scalars['date']>;
  installationDate?: Maybe<Scalars['date']>;
  installationParty?: Maybe<Scalars['String']>;
  installedEquipmentGuid: Scalars['uuid'];
  /** An object relationship */
  installedHvacSystem?: Maybe<InstalledHvacSystems>;
  installedHvacSystemGuid?: Maybe<Scalars['uuid']>;
  laborWarrantyEndDate?: Maybe<Scalars['date']>;
  laborWarrantyStartDate?: Maybe<Scalars['date']>;
  laborWarrantyTerms?: Maybe<Scalars['String']>;
  /** An object relationship */
  location: Locations;
  locationGuid: Scalars['uuid'];
  manufacturer?: Maybe<Scalars['String']>;
  manufacturerWarrantyEndDate?: Maybe<Scalars['date']>;
  manufacturerWarrantyStartDate?: Maybe<Scalars['date']>;
  manufacturerWarrantyTerms?: Maybe<Scalars['String']>;
  manufacturingDate?: Maybe<Scalars['date']>;
  modelNumber?: Maybe<Scalars['String']>;
  operationalStatus: Scalars['String'];
  serialNumber?: Maybe<Scalars['String']>;
  sourceType: Scalars['InstalledEquipmentSourceType'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "installed_equipment" */
export type InstalledEquipmentAggregate = {
  __typename?: 'InstalledEquipmentAggregate';
  aggregate?: Maybe<InstalledEquipmentAggregateFields>;
  nodes: Array<InstalledEquipment>;
};

export type InstalledEquipmentAggregateBoolExp = {
  count?: InputMaybe<InstalledEquipmentAggregateBoolExpCount>;
};

/** aggregate fields of "installed_equipment" */
export type InstalledEquipmentAggregateFields = {
  __typename?: 'InstalledEquipmentAggregateFields';
  avg?: Maybe<InstalledEquipmentAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InstalledEquipmentMaxFields>;
  min?: Maybe<InstalledEquipmentMinFields>;
  stddev?: Maybe<InstalledEquipmentStddevFields>;
  stddevPop?: Maybe<InstalledEquipmentStddevPopFields>;
  stddevSamp?: Maybe<InstalledEquipmentStddevSampFields>;
  sum?: Maybe<InstalledEquipmentSumFields>;
  varPop?: Maybe<InstalledEquipmentVarPopFields>;
  varSamp?: Maybe<InstalledEquipmentVarSampFields>;
  variance?: Maybe<InstalledEquipmentVarianceFields>;
};


/** aggregate fields of "installed_equipment" */
export type InstalledEquipmentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InstalledEquipmentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "installed_equipment" */
export type InstalledEquipmentAggregateOrderBy = {
  avg?: InputMaybe<InstalledEquipmentAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InstalledEquipmentMaxOrderBy>;
  min?: InputMaybe<InstalledEquipmentMinOrderBy>;
  stddev?: InputMaybe<InstalledEquipmentStddevOrderBy>;
  stddevPop?: InputMaybe<InstalledEquipmentStddevPopOrderBy>;
  stddevSamp?: InputMaybe<InstalledEquipmentStddevSampOrderBy>;
  sum?: InputMaybe<InstalledEquipmentSumOrderBy>;
  varPop?: InputMaybe<InstalledEquipmentVarPopOrderBy>;
  varSamp?: InputMaybe<InstalledEquipmentVarSampOrderBy>;
  variance?: InputMaybe<InstalledEquipmentVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "installed_equipment" */
export type InstalledEquipmentArrRelInsertInput = {
  data: Array<InstalledEquipmentInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InstalledEquipmentOnConflict>;
};

/** aggregate avg on columns */
export type InstalledEquipmentAvgFields = {
  __typename?: 'InstalledEquipmentAvgFields';
  averageLifeExpectancyYears?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of days since the equipment install. Returns null if installationDate is null */
  daysSinceInstall?: Maybe<Scalars['Int']>;
};

/** order by avg() on columns of table "installed_equipment" */
export type InstalledEquipmentAvgOrderBy = {
  averageLifeExpectancyYears?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "installed_equipment". All fields are combined with a logical 'AND'. */
export type InstalledEquipmentBoolExp = {
  _and?: InputMaybe<Array<InstalledEquipmentBoolExp>>;
  _not?: InputMaybe<InstalledEquipmentBoolExp>;
  _or?: InputMaybe<Array<InstalledEquipmentBoolExp>>;
  averageLifeExpectancyYears?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  daysSinceInstall?: InputMaybe<IntComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  equipmentCondition?: InputMaybe<StringComparisonExp>;
  equipmentDimensions?: InputMaybe<StringComparisonExp>;
  equipmentType?: InputMaybe<StringComparisonExp>;
  estimatedEndOfLifeDate?: InputMaybe<DateComparisonExp>;
  installationDate?: InputMaybe<DateComparisonExp>;
  installationParty?: InputMaybe<StringComparisonExp>;
  installedEquipmentGuid?: InputMaybe<UuidComparisonExp>;
  installedHvacSystem?: InputMaybe<InstalledHvacSystemsBoolExp>;
  installedHvacSystemGuid?: InputMaybe<UuidComparisonExp>;
  laborWarrantyEndDate?: InputMaybe<DateComparisonExp>;
  laborWarrantyStartDate?: InputMaybe<DateComparisonExp>;
  laborWarrantyTerms?: InputMaybe<StringComparisonExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  manufacturer?: InputMaybe<StringComparisonExp>;
  manufacturerWarrantyEndDate?: InputMaybe<DateComparisonExp>;
  manufacturerWarrantyStartDate?: InputMaybe<DateComparisonExp>;
  manufacturerWarrantyTerms?: InputMaybe<StringComparisonExp>;
  manufacturingDate?: InputMaybe<DateComparisonExp>;
  modelNumber?: InputMaybe<StringComparisonExp>;
  operationalStatus?: InputMaybe<StringComparisonExp>;
  serialNumber?: InputMaybe<StringComparisonExp>;
  sourceType?: InputMaybe<Scalars['InstalledEquipmentSourceTypeComparisonExp']>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "installed_equipment" */
export type InstalledEquipmentConstraint =
  /** unique or primary key constraint on columns "installed_equipment_guid" */
  | 'installed_equipment_pkey';

/** input type for incrementing numeric columns in table "installed_equipment" */
export type InstalledEquipmentIncInput = {
  averageLifeExpectancyYears?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "installed_equipment" */
export type InstalledEquipmentInsertInput = {
  averageLifeExpectancyYears?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  equipmentCondition?: InputMaybe<Scalars['String']>;
  equipmentDimensions?: InputMaybe<Scalars['String']>;
  equipmentType?: InputMaybe<Scalars['String']>;
  estimatedEndOfLifeDate?: InputMaybe<Scalars['date']>;
  installationDate?: InputMaybe<Scalars['date']>;
  installationParty?: InputMaybe<Scalars['String']>;
  installedEquipmentGuid?: InputMaybe<Scalars['uuid']>;
  installedHvacSystem?: InputMaybe<InstalledHvacSystemsObjRelInsertInput>;
  installedHvacSystemGuid?: InputMaybe<Scalars['uuid']>;
  laborWarrantyEndDate?: InputMaybe<Scalars['date']>;
  laborWarrantyStartDate?: InputMaybe<Scalars['date']>;
  laborWarrantyTerms?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationsObjRelInsertInput>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  manufacturerWarrantyEndDate?: InputMaybe<Scalars['date']>;
  manufacturerWarrantyStartDate?: InputMaybe<Scalars['date']>;
  manufacturerWarrantyTerms?: InputMaybe<Scalars['String']>;
  manufacturingDate?: InputMaybe<Scalars['date']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  operationalStatus?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['InstalledEquipmentSourceType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InstalledEquipmentMaxFields = {
  __typename?: 'InstalledEquipmentMaxFields';
  averageLifeExpectancyYears?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  /** A computed field that returns the number of days since the equipment install. Returns null if installationDate is null */
  daysSinceInstall?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  equipmentCondition?: Maybe<Scalars['String']>;
  equipmentDimensions?: Maybe<Scalars['String']>;
  equipmentType?: Maybe<Scalars['String']>;
  estimatedEndOfLifeDate?: Maybe<Scalars['date']>;
  installationDate?: Maybe<Scalars['date']>;
  installationParty?: Maybe<Scalars['String']>;
  installedEquipmentGuid?: Maybe<Scalars['uuid']>;
  installedHvacSystemGuid?: Maybe<Scalars['uuid']>;
  laborWarrantyEndDate?: Maybe<Scalars['date']>;
  laborWarrantyStartDate?: Maybe<Scalars['date']>;
  laborWarrantyTerms?: Maybe<Scalars['String']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturerWarrantyEndDate?: Maybe<Scalars['date']>;
  manufacturerWarrantyStartDate?: Maybe<Scalars['date']>;
  manufacturerWarrantyTerms?: Maybe<Scalars['String']>;
  manufacturingDate?: Maybe<Scalars['date']>;
  modelNumber?: Maybe<Scalars['String']>;
  operationalStatus?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['InstalledEquipmentSourceType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "installed_equipment" */
export type InstalledEquipmentMaxOrderBy = {
  averageLifeExpectancyYears?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  equipmentCondition?: InputMaybe<OrderBy>;
  equipmentDimensions?: InputMaybe<OrderBy>;
  equipmentType?: InputMaybe<OrderBy>;
  estimatedEndOfLifeDate?: InputMaybe<OrderBy>;
  installationDate?: InputMaybe<OrderBy>;
  installationParty?: InputMaybe<OrderBy>;
  installedEquipmentGuid?: InputMaybe<OrderBy>;
  installedHvacSystemGuid?: InputMaybe<OrderBy>;
  laborWarrantyEndDate?: InputMaybe<OrderBy>;
  laborWarrantyStartDate?: InputMaybe<OrderBy>;
  laborWarrantyTerms?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  manufacturer?: InputMaybe<OrderBy>;
  manufacturerWarrantyEndDate?: InputMaybe<OrderBy>;
  manufacturerWarrantyStartDate?: InputMaybe<OrderBy>;
  manufacturerWarrantyTerms?: InputMaybe<OrderBy>;
  manufacturingDate?: InputMaybe<OrderBy>;
  modelNumber?: InputMaybe<OrderBy>;
  operationalStatus?: InputMaybe<OrderBy>;
  serialNumber?: InputMaybe<OrderBy>;
  sourceType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InstalledEquipmentMinFields = {
  __typename?: 'InstalledEquipmentMinFields';
  averageLifeExpectancyYears?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  /** A computed field that returns the number of days since the equipment install. Returns null if installationDate is null */
  daysSinceInstall?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  equipmentCondition?: Maybe<Scalars['String']>;
  equipmentDimensions?: Maybe<Scalars['String']>;
  equipmentType?: Maybe<Scalars['String']>;
  estimatedEndOfLifeDate?: Maybe<Scalars['date']>;
  installationDate?: Maybe<Scalars['date']>;
  installationParty?: Maybe<Scalars['String']>;
  installedEquipmentGuid?: Maybe<Scalars['uuid']>;
  installedHvacSystemGuid?: Maybe<Scalars['uuid']>;
  laborWarrantyEndDate?: Maybe<Scalars['date']>;
  laborWarrantyStartDate?: Maybe<Scalars['date']>;
  laborWarrantyTerms?: Maybe<Scalars['String']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturerWarrantyEndDate?: Maybe<Scalars['date']>;
  manufacturerWarrantyStartDate?: Maybe<Scalars['date']>;
  manufacturerWarrantyTerms?: Maybe<Scalars['String']>;
  manufacturingDate?: Maybe<Scalars['date']>;
  modelNumber?: Maybe<Scalars['String']>;
  operationalStatus?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['InstalledEquipmentSourceType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "installed_equipment" */
export type InstalledEquipmentMinOrderBy = {
  averageLifeExpectancyYears?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  equipmentCondition?: InputMaybe<OrderBy>;
  equipmentDimensions?: InputMaybe<OrderBy>;
  equipmentType?: InputMaybe<OrderBy>;
  estimatedEndOfLifeDate?: InputMaybe<OrderBy>;
  installationDate?: InputMaybe<OrderBy>;
  installationParty?: InputMaybe<OrderBy>;
  installedEquipmentGuid?: InputMaybe<OrderBy>;
  installedHvacSystemGuid?: InputMaybe<OrderBy>;
  laborWarrantyEndDate?: InputMaybe<OrderBy>;
  laborWarrantyStartDate?: InputMaybe<OrderBy>;
  laborWarrantyTerms?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  manufacturer?: InputMaybe<OrderBy>;
  manufacturerWarrantyEndDate?: InputMaybe<OrderBy>;
  manufacturerWarrantyStartDate?: InputMaybe<OrderBy>;
  manufacturerWarrantyTerms?: InputMaybe<OrderBy>;
  manufacturingDate?: InputMaybe<OrderBy>;
  modelNumber?: InputMaybe<OrderBy>;
  operationalStatus?: InputMaybe<OrderBy>;
  serialNumber?: InputMaybe<OrderBy>;
  sourceType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "installed_equipment" */
export type InstalledEquipmentMutationResponse = {
  __typename?: 'InstalledEquipmentMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InstalledEquipment>;
};

/** input type for inserting object relation for remote table "installed_equipment" */
export type InstalledEquipmentObjRelInsertInput = {
  data: InstalledEquipmentInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<InstalledEquipmentOnConflict>;
};

/** on_conflict condition type for table "installed_equipment" */
export type InstalledEquipmentOnConflict = {
  constraint: InstalledEquipmentConstraint;
  updateColumns?: Array<InstalledEquipmentUpdateColumn>;
  where?: InputMaybe<InstalledEquipmentBoolExp>;
};

/** Ordering options when selecting data from "installed_equipment". */
export type InstalledEquipmentOrderBy = {
  averageLifeExpectancyYears?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  daysSinceInstall?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  equipmentCondition?: InputMaybe<OrderBy>;
  equipmentDimensions?: InputMaybe<OrderBy>;
  equipmentType?: InputMaybe<OrderBy>;
  estimatedEndOfLifeDate?: InputMaybe<OrderBy>;
  installationDate?: InputMaybe<OrderBy>;
  installationParty?: InputMaybe<OrderBy>;
  installedEquipmentGuid?: InputMaybe<OrderBy>;
  installedHvacSystem?: InputMaybe<InstalledHvacSystemsOrderBy>;
  installedHvacSystemGuid?: InputMaybe<OrderBy>;
  laborWarrantyEndDate?: InputMaybe<OrderBy>;
  laborWarrantyStartDate?: InputMaybe<OrderBy>;
  laborWarrantyTerms?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  manufacturer?: InputMaybe<OrderBy>;
  manufacturerWarrantyEndDate?: InputMaybe<OrderBy>;
  manufacturerWarrantyStartDate?: InputMaybe<OrderBy>;
  manufacturerWarrantyTerms?: InputMaybe<OrderBy>;
  manufacturingDate?: InputMaybe<OrderBy>;
  modelNumber?: InputMaybe<OrderBy>;
  operationalStatus?: InputMaybe<OrderBy>;
  serialNumber?: InputMaybe<OrderBy>;
  sourceType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: installed_equipment */
export type InstalledEquipmentPkColumnsInput = {
  installedEquipmentGuid: Scalars['uuid'];
};

/** select columns of table "installed_equipment" */
export type InstalledEquipmentSelectColumn =
  /** column name */
  | 'averageLifeExpectancyYears'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'equipmentCondition'
  /** column name */
  | 'equipmentDimensions'
  /** column name */
  | 'equipmentType'
  /** column name */
  | 'estimatedEndOfLifeDate'
  /** column name */
  | 'installationDate'
  /** column name */
  | 'installationParty'
  /** column name */
  | 'installedEquipmentGuid'
  /** column name */
  | 'installedHvacSystemGuid'
  /** column name */
  | 'laborWarrantyEndDate'
  /** column name */
  | 'laborWarrantyStartDate'
  /** column name */
  | 'laborWarrantyTerms'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'manufacturer'
  /** column name */
  | 'manufacturerWarrantyEndDate'
  /** column name */
  | 'manufacturerWarrantyStartDate'
  /** column name */
  | 'manufacturerWarrantyTerms'
  /** column name */
  | 'manufacturingDate'
  /** column name */
  | 'modelNumber'
  /** column name */
  | 'operationalStatus'
  /** column name */
  | 'serialNumber'
  /** column name */
  | 'sourceType'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "installed_equipment" */
export type InstalledEquipmentSetInput = {
  averageLifeExpectancyYears?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  equipmentCondition?: InputMaybe<Scalars['String']>;
  equipmentDimensions?: InputMaybe<Scalars['String']>;
  equipmentType?: InputMaybe<Scalars['String']>;
  estimatedEndOfLifeDate?: InputMaybe<Scalars['date']>;
  installationDate?: InputMaybe<Scalars['date']>;
  installationParty?: InputMaybe<Scalars['String']>;
  installedEquipmentGuid?: InputMaybe<Scalars['uuid']>;
  installedHvacSystemGuid?: InputMaybe<Scalars['uuid']>;
  laborWarrantyEndDate?: InputMaybe<Scalars['date']>;
  laborWarrantyStartDate?: InputMaybe<Scalars['date']>;
  laborWarrantyTerms?: InputMaybe<Scalars['String']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  manufacturerWarrantyEndDate?: InputMaybe<Scalars['date']>;
  manufacturerWarrantyStartDate?: InputMaybe<Scalars['date']>;
  manufacturerWarrantyTerms?: InputMaybe<Scalars['String']>;
  manufacturingDate?: InputMaybe<Scalars['date']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  operationalStatus?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['InstalledEquipmentSourceType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type InstalledEquipmentStddevFields = {
  __typename?: 'InstalledEquipmentStddevFields';
  averageLifeExpectancyYears?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of days since the equipment install. Returns null if installationDate is null */
  daysSinceInstall?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "installed_equipment" */
export type InstalledEquipmentStddevOrderBy = {
  averageLifeExpectancyYears?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type InstalledEquipmentStddevPopFields = {
  __typename?: 'InstalledEquipmentStddevPopFields';
  averageLifeExpectancyYears?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of days since the equipment install. Returns null if installationDate is null */
  daysSinceInstall?: Maybe<Scalars['Int']>;
};

/** order by stddevPop() on columns of table "installed_equipment" */
export type InstalledEquipmentStddevPopOrderBy = {
  averageLifeExpectancyYears?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type InstalledEquipmentStddevSampFields = {
  __typename?: 'InstalledEquipmentStddevSampFields';
  averageLifeExpectancyYears?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of days since the equipment install. Returns null if installationDate is null */
  daysSinceInstall?: Maybe<Scalars['Int']>;
};

/** order by stddevSamp() on columns of table "installed_equipment" */
export type InstalledEquipmentStddevSampOrderBy = {
  averageLifeExpectancyYears?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "installed_equipment" */
export type InstalledEquipmentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InstalledEquipmentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InstalledEquipmentStreamCursorValueInput = {
  averageLifeExpectancyYears?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  equipmentCondition?: InputMaybe<Scalars['String']>;
  equipmentDimensions?: InputMaybe<Scalars['String']>;
  equipmentType?: InputMaybe<Scalars['String']>;
  estimatedEndOfLifeDate?: InputMaybe<Scalars['date']>;
  installationDate?: InputMaybe<Scalars['date']>;
  installationParty?: InputMaybe<Scalars['String']>;
  installedEquipmentGuid?: InputMaybe<Scalars['uuid']>;
  installedHvacSystemGuid?: InputMaybe<Scalars['uuid']>;
  laborWarrantyEndDate?: InputMaybe<Scalars['date']>;
  laborWarrantyStartDate?: InputMaybe<Scalars['date']>;
  laborWarrantyTerms?: InputMaybe<Scalars['String']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  manufacturerWarrantyEndDate?: InputMaybe<Scalars['date']>;
  manufacturerWarrantyStartDate?: InputMaybe<Scalars['date']>;
  manufacturerWarrantyTerms?: InputMaybe<Scalars['String']>;
  manufacturingDate?: InputMaybe<Scalars['date']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  operationalStatus?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['InstalledEquipmentSourceType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type InstalledEquipmentSumFields = {
  __typename?: 'InstalledEquipmentSumFields';
  averageLifeExpectancyYears?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of days since the equipment install. Returns null if installationDate is null */
  daysSinceInstall?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "installed_equipment" */
export type InstalledEquipmentSumOrderBy = {
  averageLifeExpectancyYears?: InputMaybe<OrderBy>;
};

/** update columns of table "installed_equipment" */
export type InstalledEquipmentUpdateColumn =
  /** column name */
  | 'averageLifeExpectancyYears'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'equipmentCondition'
  /** column name */
  | 'equipmentDimensions'
  /** column name */
  | 'equipmentType'
  /** column name */
  | 'estimatedEndOfLifeDate'
  /** column name */
  | 'installationDate'
  /** column name */
  | 'installationParty'
  /** column name */
  | 'installedEquipmentGuid'
  /** column name */
  | 'installedHvacSystemGuid'
  /** column name */
  | 'laborWarrantyEndDate'
  /** column name */
  | 'laborWarrantyStartDate'
  /** column name */
  | 'laborWarrantyTerms'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'manufacturer'
  /** column name */
  | 'manufacturerWarrantyEndDate'
  /** column name */
  | 'manufacturerWarrantyStartDate'
  /** column name */
  | 'manufacturerWarrantyTerms'
  /** column name */
  | 'manufacturingDate'
  /** column name */
  | 'modelNumber'
  /** column name */
  | 'operationalStatus'
  /** column name */
  | 'serialNumber'
  /** column name */
  | 'sourceType'
  /** column name */
  | 'updatedAt';

export type InstalledEquipmentUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InstalledEquipmentIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InstalledEquipmentSetInput>;
  /** filter the rows which have to be updated */
  where: InstalledEquipmentBoolExp;
};

/** aggregate varPop on columns */
export type InstalledEquipmentVarPopFields = {
  __typename?: 'InstalledEquipmentVarPopFields';
  averageLifeExpectancyYears?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of days since the equipment install. Returns null if installationDate is null */
  daysSinceInstall?: Maybe<Scalars['Int']>;
};

/** order by varPop() on columns of table "installed_equipment" */
export type InstalledEquipmentVarPopOrderBy = {
  averageLifeExpectancyYears?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type InstalledEquipmentVarSampFields = {
  __typename?: 'InstalledEquipmentVarSampFields';
  averageLifeExpectancyYears?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of days since the equipment install. Returns null if installationDate is null */
  daysSinceInstall?: Maybe<Scalars['Int']>;
};

/** order by varSamp() on columns of table "installed_equipment" */
export type InstalledEquipmentVarSampOrderBy = {
  averageLifeExpectancyYears?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type InstalledEquipmentVarianceFields = {
  __typename?: 'InstalledEquipmentVarianceFields';
  averageLifeExpectancyYears?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of days since the equipment install. Returns null if installationDate is null */
  daysSinceInstall?: Maybe<Scalars['Int']>;
};

/** order by variance() on columns of table "installed_equipment" */
export type InstalledEquipmentVarianceOrderBy = {
  averageLifeExpectancyYears?: InputMaybe<OrderBy>;
};

/** columns and relationships of "installed_hvac_systems" */
export type InstalledHvacSystems = {
  __typename?: 'InstalledHvacSystems';
  createdAt: Scalars['timestamptz'];
  filterSize?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  /** An array relationship */
  installedEquipment: Array<InstalledEquipment>;
  /** An aggregate relationship */
  installedEquipmentAggregate: InstalledEquipmentAggregate;
  installedHvacSystemGuid: Scalars['uuid'];
  /** An object relationship */
  location: Locations;
  locationGuid: Scalars['uuid'];
  notes?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  zoningInfoJson: Scalars['jsonb'];
};


/** columns and relationships of "installed_hvac_systems" */
export type InstalledHvacSystemsInstalledEquipmentArgs = {
  distinctOn?: InputMaybe<Array<InstalledEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledEquipmentOrderBy>>;
  where?: InputMaybe<InstalledEquipmentBoolExp>;
};


/** columns and relationships of "installed_hvac_systems" */
export type InstalledHvacSystemsInstalledEquipmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstalledEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledEquipmentOrderBy>>;
  where?: InputMaybe<InstalledEquipmentBoolExp>;
};


/** columns and relationships of "installed_hvac_systems" */
export type InstalledHvacSystemsZoningInfoJsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "installed_hvac_systems" */
export type InstalledHvacSystemsAggregate = {
  __typename?: 'InstalledHvacSystemsAggregate';
  aggregate?: Maybe<InstalledHvacSystemsAggregateFields>;
  nodes: Array<InstalledHvacSystems>;
};

export type InstalledHvacSystemsAggregateBoolExp = {
  count?: InputMaybe<InstalledHvacSystemsAggregateBoolExpCount>;
};

/** aggregate fields of "installed_hvac_systems" */
export type InstalledHvacSystemsAggregateFields = {
  __typename?: 'InstalledHvacSystemsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InstalledHvacSystemsMaxFields>;
  min?: Maybe<InstalledHvacSystemsMinFields>;
};


/** aggregate fields of "installed_hvac_systems" */
export type InstalledHvacSystemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InstalledHvacSystemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "installed_hvac_systems" */
export type InstalledHvacSystemsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InstalledHvacSystemsMaxOrderBy>;
  min?: InputMaybe<InstalledHvacSystemsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type InstalledHvacSystemsAppendInput = {
  zoningInfoJson?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "installed_hvac_systems" */
export type InstalledHvacSystemsArrRelInsertInput = {
  data: Array<InstalledHvacSystemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InstalledHvacSystemsOnConflict>;
};

/** Boolean expression to filter rows from the table "installed_hvac_systems". All fields are combined with a logical 'AND'. */
export type InstalledHvacSystemsBoolExp = {
  _and?: InputMaybe<Array<InstalledHvacSystemsBoolExp>>;
  _not?: InputMaybe<InstalledHvacSystemsBoolExp>;
  _or?: InputMaybe<Array<InstalledHvacSystemsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  filterSize?: InputMaybe<StringComparisonExp>;
  friendlyName?: InputMaybe<StringComparisonExp>;
  installedEquipment?: InputMaybe<InstalledEquipmentBoolExp>;
  installedEquipmentAggregate?: InputMaybe<InstalledEquipmentAggregateBoolExp>;
  installedHvacSystemGuid?: InputMaybe<UuidComparisonExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  notes?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  zoningInfoJson?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "installed_hvac_systems" */
export type InstalledHvacSystemsConstraint =
  /** unique or primary key constraint on columns "installed_hvac_system_guid" */
  | 'installed_hvac_systems_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type InstalledHvacSystemsDeleteAtPathInput = {
  zoningInfoJson?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type InstalledHvacSystemsDeleteElemInput = {
  zoningInfoJson?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type InstalledHvacSystemsDeleteKeyInput = {
  zoningInfoJson?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "installed_hvac_systems" */
export type InstalledHvacSystemsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  filterSize?: InputMaybe<Scalars['String']>;
  friendlyName?: InputMaybe<Scalars['String']>;
  installedEquipment?: InputMaybe<InstalledEquipmentArrRelInsertInput>;
  installedHvacSystemGuid?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<LocationsObjRelInsertInput>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zoningInfoJson?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type InstalledHvacSystemsMaxFields = {
  __typename?: 'InstalledHvacSystemsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  filterSize?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  installedHvacSystemGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "installed_hvac_systems" */
export type InstalledHvacSystemsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  filterSize?: InputMaybe<OrderBy>;
  friendlyName?: InputMaybe<OrderBy>;
  installedHvacSystemGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  notes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InstalledHvacSystemsMinFields = {
  __typename?: 'InstalledHvacSystemsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  filterSize?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  installedHvacSystemGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "installed_hvac_systems" */
export type InstalledHvacSystemsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  filterSize?: InputMaybe<OrderBy>;
  friendlyName?: InputMaybe<OrderBy>;
  installedHvacSystemGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  notes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "installed_hvac_systems" */
export type InstalledHvacSystemsMutationResponse = {
  __typename?: 'InstalledHvacSystemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InstalledHvacSystems>;
};

/** input type for inserting object relation for remote table "installed_hvac_systems" */
export type InstalledHvacSystemsObjRelInsertInput = {
  data: InstalledHvacSystemsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<InstalledHvacSystemsOnConflict>;
};

/** on_conflict condition type for table "installed_hvac_systems" */
export type InstalledHvacSystemsOnConflict = {
  constraint: InstalledHvacSystemsConstraint;
  updateColumns?: Array<InstalledHvacSystemsUpdateColumn>;
  where?: InputMaybe<InstalledHvacSystemsBoolExp>;
};

/** Ordering options when selecting data from "installed_hvac_systems". */
export type InstalledHvacSystemsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  filterSize?: InputMaybe<OrderBy>;
  friendlyName?: InputMaybe<OrderBy>;
  installedEquipmentAggregate?: InputMaybe<InstalledEquipmentAggregateOrderBy>;
  installedHvacSystemGuid?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  notes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  zoningInfoJson?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: installed_hvac_systems */
export type InstalledHvacSystemsPkColumnsInput = {
  installedHvacSystemGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type InstalledHvacSystemsPrependInput = {
  zoningInfoJson?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "installed_hvac_systems" */
export type InstalledHvacSystemsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'filterSize'
  /** column name */
  | 'friendlyName'
  /** column name */
  | 'installedHvacSystemGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'notes'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'zoningInfoJson';

/** input type for updating data in table "installed_hvac_systems" */
export type InstalledHvacSystemsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  filterSize?: InputMaybe<Scalars['String']>;
  friendlyName?: InputMaybe<Scalars['String']>;
  installedHvacSystemGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zoningInfoJson?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "installed_hvac_systems" */
export type InstalledHvacSystemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InstalledHvacSystemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InstalledHvacSystemsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  filterSize?: InputMaybe<Scalars['String']>;
  friendlyName?: InputMaybe<Scalars['String']>;
  installedHvacSystemGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zoningInfoJson?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "installed_hvac_systems" */
export type InstalledHvacSystemsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'filterSize'
  /** column name */
  | 'friendlyName'
  /** column name */
  | 'installedHvacSystemGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'notes'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'zoningInfoJson';

export type InstalledHvacSystemsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<InstalledHvacSystemsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<InstalledHvacSystemsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<InstalledHvacSystemsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<InstalledHvacSystemsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<InstalledHvacSystemsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InstalledHvacSystemsSetInput>;
  /** filter the rows which have to be updated */
  where: InstalledHvacSystemsBoolExp;
};

/** Manage the instant booking weekly schedule */
export type InstantBookingWeeklyScheduleEntries = {
  __typename?: 'InstantBookingWeeklyScheduleEntries';
  /** An array relationship */
  bookableArrivalWindows: Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindows>;
  /** An aggregate relationship */
  bookableArrivalWindowsAggregate: InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregate;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  dayOfWeek: Scalars['DayOfTheWeek'];
  instantBookingWeeklyScheduleEntryGuid: Scalars['uuid'];
  isEnabled: Scalars['Boolean'];
  onlineBookingServiceTypeGuid: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};


/** Manage the instant booking weekly schedule */
export type InstantBookingWeeklyScheduleEntriesBookableArrivalWindowsArgs = {
  distinctOn?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsOrderBy>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>;
};


/** Manage the instant booking weekly schedule */
export type InstantBookingWeeklyScheduleEntriesBookableArrivalWindowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsOrderBy>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>;
};

/** aggregated selection of "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesAggregate = {
  __typename?: 'InstantBookingWeeklyScheduleEntriesAggregate';
  aggregate?: Maybe<InstantBookingWeeklyScheduleEntriesAggregateFields>;
  nodes: Array<InstantBookingWeeklyScheduleEntries>;
};

export type InstantBookingWeeklyScheduleEntriesAggregateBoolExp = {
  bool_and?: InputMaybe<InstantBookingWeeklyScheduleEntriesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<InstantBookingWeeklyScheduleEntriesAggregateBoolExpBool_Or>;
  count?: InputMaybe<InstantBookingWeeklyScheduleEntriesAggregateBoolExpCount>;
};

/** aggregate fields of "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesAggregateFields = {
  __typename?: 'InstantBookingWeeklyScheduleEntriesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InstantBookingWeeklyScheduleEntriesMaxFields>;
  min?: Maybe<InstantBookingWeeklyScheduleEntriesMinFields>;
};


/** aggregate fields of "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InstantBookingWeeklyScheduleEntriesMaxOrderBy>;
  min?: InputMaybe<InstantBookingWeeklyScheduleEntriesMinOrderBy>;
};

/** input type for inserting array relation for remote table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesArrRelInsertInput = {
  data: Array<InstantBookingWeeklyScheduleEntriesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InstantBookingWeeklyScheduleEntriesOnConflict>;
};

/** Boolean expression to filter rows from the table "instant_booking_weekly_schedule_entries". All fields are combined with a logical 'AND'. */
export type InstantBookingWeeklyScheduleEntriesBoolExp = {
  _and?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesBoolExp>>;
  _not?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
  _or?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesBoolExp>>;
  bookableArrivalWindows?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>;
  bookableArrivalWindowsAggregate?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregateBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  dayOfWeek?: InputMaybe<Scalars['DayOfTheWeekComparisonExp']>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<UuidComparisonExp>;
  isEnabled?: InputMaybe<BooleanComparisonExp>;
  onlineBookingServiceTypeGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesConstraint =
  /** unique or primary key constraint on columns "day_of_week", "online_booking_service_type_guid" */
  | 'instant_booking_weekly_schedule_entries_online_booking_service_'
  /** unique or primary key constraint on columns "instant_booking_weekly_schedule_entry_guid" */
  | 'instant_booking_weekly_schedule_entries_pkey';

/** input type for inserting data into table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesInsertInput = {
  bookableArrivalWindows?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsArrRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  dayOfWeek?: InputMaybe<Scalars['DayOfTheWeek']>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<Scalars['uuid']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  onlineBookingServiceTypeGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InstantBookingWeeklyScheduleEntriesMaxFields = {
  __typename?: 'InstantBookingWeeklyScheduleEntriesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  dayOfWeek?: Maybe<Scalars['DayOfTheWeek']>;
  instantBookingWeeklyScheduleEntryGuid?: Maybe<Scalars['uuid']>;
  onlineBookingServiceTypeGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<OrderBy>;
  onlineBookingServiceTypeGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InstantBookingWeeklyScheduleEntriesMinFields = {
  __typename?: 'InstantBookingWeeklyScheduleEntriesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  dayOfWeek?: Maybe<Scalars['DayOfTheWeek']>;
  instantBookingWeeklyScheduleEntryGuid?: Maybe<Scalars['uuid']>;
  onlineBookingServiceTypeGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<OrderBy>;
  onlineBookingServiceTypeGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesMutationResponse = {
  __typename?: 'InstantBookingWeeklyScheduleEntriesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InstantBookingWeeklyScheduleEntries>;
};

/** on_conflict condition type for table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesOnConflict = {
  constraint: InstantBookingWeeklyScheduleEntriesConstraint;
  updateColumns?: Array<InstantBookingWeeklyScheduleEntriesUpdateColumn>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
};

/** Ordering options when selecting data from "instant_booking_weekly_schedule_entries". */
export type InstantBookingWeeklyScheduleEntriesOrderBy = {
  bookableArrivalWindowsAggregate?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregateOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  dayOfWeek?: InputMaybe<OrderBy>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<OrderBy>;
  isEnabled?: InputMaybe<OrderBy>;
  onlineBookingServiceTypeGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: instant_booking_weekly_schedule_entries */
export type InstantBookingWeeklyScheduleEntriesPkColumnsInput = {
  instantBookingWeeklyScheduleEntryGuid: Scalars['uuid'];
};

/** select columns of table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'dayOfWeek'
  /** column name */
  | 'instantBookingWeeklyScheduleEntryGuid'
  /** column name */
  | 'isEnabled'
  /** column name */
  | 'onlineBookingServiceTypeGuid'
  /** column name */
  | 'updatedAt';

/** select "instantBookingWeeklyScheduleEntriesAggregateBoolExpBool_andArgumentsColumns" columns of table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesSelectColumnInstantBookingWeeklyScheduleEntriesAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isEnabled';

/** select "instantBookingWeeklyScheduleEntriesAggregateBoolExpBool_orArgumentsColumns" columns of table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesSelectColumnInstantBookingWeeklyScheduleEntriesAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isEnabled';

/** input type for updating data in table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  dayOfWeek?: InputMaybe<Scalars['DayOfTheWeek']>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<Scalars['uuid']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  onlineBookingServiceTypeGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InstantBookingWeeklyScheduleEntriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InstantBookingWeeklyScheduleEntriesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  dayOfWeek?: InputMaybe<Scalars['DayOfTheWeek']>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<Scalars['uuid']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  onlineBookingServiceTypeGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "instant_booking_weekly_schedule_entries" */
export type InstantBookingWeeklyScheduleEntriesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'dayOfWeek'
  /** column name */
  | 'instantBookingWeeklyScheduleEntryGuid'
  /** column name */
  | 'isEnabled'
  /** column name */
  | 'onlineBookingServiceTypeGuid'
  /** column name */
  | 'updatedAt';

export type InstantBookingWeeklyScheduleEntriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InstantBookingWeeklyScheduleEntriesSetInput>;
  /** filter the rows which have to be updated */
  where: InstantBookingWeeklyScheduleEntriesBoolExp;
};

/** Manage bookable company arrival windows for a day on the instant booking weekly schedule */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindows = {
  __typename?: 'InstantBookingWeeklyScheduleEntryBookableArrivalWindows';
  /** An object relationship */
  arrivalWindow: CompanyAppointmentArrivalWindows;
  companyAppointmentArrivalWindowGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
  instantBookingWeeklyScheduleEntryGuid: Scalars['uuid'];
};

/** aggregated selection of "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregate = {
  __typename?: 'InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregate';
  aggregate?: Maybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregateFields>;
  nodes: Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindows>;
};

export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregateBoolExp = {
  count?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregateBoolExpCount>;
};

/** aggregate fields of "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregateFields = {
  __typename?: 'InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMaxFields>;
  min?: Maybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMinFields>;
};


/** aggregate fields of "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMaxOrderBy>;
  min?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMinOrderBy>;
};

/** input type for inserting array relation for remote table "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsArrRelInsertInput = {
  data: Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsOnConflict>;
};

/** Boolean expression to filter rows from the table "instant_booking_weekly_schedule_entry_bookable_arrival_windows". All fields are combined with a logical 'AND'. */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp = {
  _and?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>>;
  _not?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>;
  _or?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>>;
  arrivalWindow?: InputMaybe<CompanyAppointmentArrivalWindowsBoolExp>;
  companyAppointmentArrivalWindowGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsConstraint =
  /** unique or primary key constraint on columns "instant_booking_weekly_schedule_entry_guid", "company_appointment_arrival_window_guid" */
  | 'instant_booking_weekly_schedule_entry_bookable_arrival_win_pkey';

/** input type for inserting data into table "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsInsertInput = {
  arrivalWindow?: InputMaybe<CompanyAppointmentArrivalWindowsObjRelInsertInput>;
  companyAppointmentArrivalWindowGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMaxFields = {
  __typename?: 'InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMaxFields';
  companyAppointmentArrivalWindowGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  instantBookingWeeklyScheduleEntryGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMaxOrderBy = {
  companyAppointmentArrivalWindowGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMinFields = {
  __typename?: 'InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMinFields';
  companyAppointmentArrivalWindowGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  instantBookingWeeklyScheduleEntryGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMinOrderBy = {
  companyAppointmentArrivalWindowGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMutationResponse = {
  __typename?: 'InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindows>;
};

/** on_conflict condition type for table "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsOnConflict = {
  constraint: InstantBookingWeeklyScheduleEntryBookableArrivalWindowsConstraint;
  updateColumns?: Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsUpdateColumn>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>;
};

/** Ordering options when selecting data from "instant_booking_weekly_schedule_entry_bookable_arrival_windows". */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsOrderBy = {
  arrivalWindow?: InputMaybe<CompanyAppointmentArrivalWindowsOrderBy>;
  companyAppointmentArrivalWindowGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: instant_booking_weekly_schedule_entry_bookable_arrival_windows */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsPkColumnsInput = {
  companyAppointmentArrivalWindowGuid: Scalars['uuid'];
  instantBookingWeeklyScheduleEntryGuid: Scalars['uuid'];
};

/** select columns of table "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSelectColumn =
  /** column name */
  | 'companyAppointmentArrivalWindowGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'instantBookingWeeklyScheduleEntryGuid';

/** input type for updating data in table "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSetInput = {
  companyAppointmentArrivalWindowGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InstantBookingWeeklyScheduleEntryBookableArrivalWindowsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsStreamCursorValueInput = {
  companyAppointmentArrivalWindowGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  instantBookingWeeklyScheduleEntryGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsUpdateColumn =
  /** column name */
  | 'companyAppointmentArrivalWindowGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'instantBookingWeeklyScheduleEntryGuid';

export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSetInput>;
  /** filter the rows which have to be updated */
  where: InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['Int']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['Int']>>;
  _eq?: InputMaybe<Array<Scalars['Int']>>;
  _gt?: InputMaybe<Array<Scalars['Int']>>;
  _gte?: InputMaybe<Array<Scalars['Int']>>;
  _in?: InputMaybe<Array<Array<Scalars['Int']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['Int']>>;
  _lte?: InputMaybe<Array<Scalars['Int']>>;
  _neq?: InputMaybe<Array<Scalars['Int']>>;
  _nin?: InputMaybe<Array<Array<Scalars['Int']>>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** columns and relationships of "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItems = {
  __typename?: 'IntegratedChannelCompletableItems';
  companyGuid?: Maybe<Scalars['uuid']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedChannelItemGuid?: Maybe<Scalars['uuid']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  itemType?: Maybe<Scalars['String']>;
  markedCompleted?: Maybe<Scalars['Boolean']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItemsAggregate = {
  __typename?: 'IntegratedChannelCompletableItemsAggregate';
  aggregate?: Maybe<IntegratedChannelCompletableItemsAggregateFields>;
  nodes: Array<IntegratedChannelCompletableItems>;
};

export type IntegratedChannelCompletableItemsAggregateBoolExp = {
  bool_and?: InputMaybe<IntegratedChannelCompletableItemsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<IntegratedChannelCompletableItemsAggregateBoolExpBool_Or>;
  count?: InputMaybe<IntegratedChannelCompletableItemsAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItemsAggregateFields = {
  __typename?: 'IntegratedChannelCompletableItemsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedChannelCompletableItemsMaxFields>;
  min?: Maybe<IntegratedChannelCompletableItemsMinFields>;
};


/** aggregate fields of "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedChannelCompletableItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItemsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedChannelCompletableItemsMaxOrderBy>;
  min?: InputMaybe<IntegratedChannelCompletableItemsMinOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItemsArrRelInsertInput = {
  data: Array<IntegratedChannelCompletableItemsInsertInput>;
};

/** Boolean expression to filter rows from the table "integrated_channel_completable_items". All fields are combined with a logical 'AND'. */
export type IntegratedChannelCompletableItemsBoolExp = {
  _and?: InputMaybe<Array<IntegratedChannelCompletableItemsBoolExp>>;
  _not?: InputMaybe<IntegratedChannelCompletableItemsBoolExp>;
  _or?: InputMaybe<Array<IntegratedChannelCompletableItemsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  integratedChannelGuid?: InputMaybe<UuidComparisonExp>;
  integratedChannelItemGuid?: InputMaybe<UuidComparisonExp>;
  integratedMessageGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneCallGuid?: InputMaybe<UuidComparisonExp>;
  itemType?: InputMaybe<StringComparisonExp>;
  markedCompleted?: InputMaybe<BooleanComparisonExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItemsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelItemGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessageGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  itemType?: InputMaybe<Scalars['String']>;
  markedCompleted?: InputMaybe<Scalars['Boolean']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type IntegratedChannelCompletableItemsMaxFields = {
  __typename?: 'IntegratedChannelCompletableItemsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedChannelItemGuid?: Maybe<Scalars['uuid']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  itemType?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItemsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedChannelItemGuid?: InputMaybe<OrderBy>;
  integratedMessageGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedChannelCompletableItemsMinFields = {
  __typename?: 'IntegratedChannelCompletableItemsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedChannelItemGuid?: Maybe<Scalars['uuid']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  itemType?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItemsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedChannelItemGuid?: InputMaybe<OrderBy>;
  integratedMessageGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "integrated_channel_completable_items". */
export type IntegratedChannelCompletableItemsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedChannelItemGuid?: InputMaybe<OrderBy>;
  integratedMessageGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  markedCompleted?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** select columns of table "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItemsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'integratedChannelGuid'
  /** column name */
  | 'integratedChannelItemGuid'
  /** column name */
  | 'integratedMessageGuid'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'itemType'
  /** column name */
  | 'markedCompleted'
  /** column name */
  | 'occurredAt';

/** select "integratedChannelCompletableItemsAggregateBoolExpBool_andArgumentsColumns" columns of table "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItemsSelectColumnIntegratedChannelCompletableItemsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'markedCompleted';

/** select "integratedChannelCompletableItemsAggregateBoolExpBool_orArgumentsColumns" columns of table "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItemsSelectColumnIntegratedChannelCompletableItemsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'markedCompleted';

/** Streaming cursor of the table "integrated_channel_completable_items" */
export type IntegratedChannelCompletableItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedChannelCompletableItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedChannelCompletableItemsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelItemGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessageGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  itemType?: InputMaybe<Scalars['String']>;
  markedCompleted?: InputMaybe<Scalars['Boolean']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "integrated_channel_items" */
export type IntegratedChannelItems = {
  __typename?: 'IntegratedChannelItems';
  companyGuid: Scalars['uuid'];
  integratedChannelGuid: Scalars['uuid'];
  integratedChannelItemGuid: Scalars['uuid'];
  /** An object relationship */
  integratedMessage?: Maybe<IntegratedMessages>;
  integratedMessageGuid: Scalars['uuid'];
  /** An object relationship */
  integratedPhoneCall?: Maybe<IntegratedPhoneCalls>;
  integratedPhoneCallGuid: Scalars['uuid'];
  itemType: Scalars['String'];
  occurredAt: Scalars['timestamptz'];
};

/** aggregated selection of "integrated_channel_items" */
export type IntegratedChannelItemsAggregate = {
  __typename?: 'IntegratedChannelItemsAggregate';
  aggregate?: Maybe<IntegratedChannelItemsAggregateFields>;
  nodes: Array<IntegratedChannelItems>;
};

export type IntegratedChannelItemsAggregateBoolExp = {
  count?: InputMaybe<IntegratedChannelItemsAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_channel_items" */
export type IntegratedChannelItemsAggregateFields = {
  __typename?: 'IntegratedChannelItemsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedChannelItemsMaxFields>;
  min?: Maybe<IntegratedChannelItemsMinFields>;
};


/** aggregate fields of "integrated_channel_items" */
export type IntegratedChannelItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedChannelItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_channel_items" */
export type IntegratedChannelItemsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedChannelItemsMaxOrderBy>;
  min?: InputMaybe<IntegratedChannelItemsMinOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_channel_items" */
export type IntegratedChannelItemsArrRelInsertInput = {
  data: Array<IntegratedChannelItemsInsertInput>;
};

/** Boolean expression to filter rows from the table "integrated_channel_items". All fields are combined with a logical 'AND'. */
export type IntegratedChannelItemsBoolExp = {
  _and?: InputMaybe<Array<IntegratedChannelItemsBoolExp>>;
  _not?: InputMaybe<IntegratedChannelItemsBoolExp>;
  _or?: InputMaybe<Array<IntegratedChannelItemsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  integratedChannelGuid?: InputMaybe<UuidComparisonExp>;
  integratedChannelItemGuid?: InputMaybe<UuidComparisonExp>;
  integratedMessage?: InputMaybe<IntegratedMessagesBoolExp>;
  integratedMessageGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneCall?: InputMaybe<IntegratedPhoneCallsBoolExp>;
  integratedPhoneCallGuid?: InputMaybe<UuidComparisonExp>;
  itemType?: InputMaybe<StringComparisonExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "integrated_channel_items" */
export type IntegratedChannelItemsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelItemGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessage?: InputMaybe<IntegratedMessagesObjRelInsertInput>;
  integratedMessageGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCall?: InputMaybe<IntegratedPhoneCallsObjRelInsertInput>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  itemType?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type IntegratedChannelItemsMaxFields = {
  __typename?: 'IntegratedChannelItemsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedChannelItemGuid?: Maybe<Scalars['uuid']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  itemType?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "integrated_channel_items" */
export type IntegratedChannelItemsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedChannelItemGuid?: InputMaybe<OrderBy>;
  integratedMessageGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedChannelItemsMinFields = {
  __typename?: 'IntegratedChannelItemsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedChannelItemGuid?: Maybe<Scalars['uuid']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  itemType?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "integrated_channel_items" */
export type IntegratedChannelItemsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedChannelItemGuid?: InputMaybe<OrderBy>;
  integratedMessageGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "integrated_channel_items". */
export type IntegratedChannelItemsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedChannelItemGuid?: InputMaybe<OrderBy>;
  integratedMessage?: InputMaybe<IntegratedMessagesOrderBy>;
  integratedMessageGuid?: InputMaybe<OrderBy>;
  integratedPhoneCall?: InputMaybe<IntegratedPhoneCallsOrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** select columns of table "integrated_channel_items" */
export type IntegratedChannelItemsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'integratedChannelGuid'
  /** column name */
  | 'integratedChannelItemGuid'
  /** column name */
  | 'integratedMessageGuid'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'itemType'
  /** column name */
  | 'occurredAt';

export type IntegratedChannelItemsSetInput = {
  __typename?: 'IntegratedChannelItemsSetInput';
  companyGuid?: Maybe<Scalars['uuid']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedChannelItemGuid?: Maybe<Scalars['uuid']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  itemType?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "integrated_channel_items" */
export type IntegratedChannelItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedChannelItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedChannelItemsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelItemGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessageGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  itemType?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "integrated_channel_readable_items" */
export type IntegratedChannelReadableItems = {
  __typename?: 'IntegratedChannelReadableItems';
  companyGuid?: Maybe<Scalars['uuid']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedChannelItemGuid?: Maybe<Scalars['uuid']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  itemType?: Maybe<Scalars['String']>;
  markedRead?: Maybe<Scalars['Boolean']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "integrated_channel_readable_items" */
export type IntegratedChannelReadableItemsAggregate = {
  __typename?: 'IntegratedChannelReadableItemsAggregate';
  aggregate?: Maybe<IntegratedChannelReadableItemsAggregateFields>;
  nodes: Array<IntegratedChannelReadableItems>;
};

export type IntegratedChannelReadableItemsAggregateBoolExp = {
  bool_and?: InputMaybe<IntegratedChannelReadableItemsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<IntegratedChannelReadableItemsAggregateBoolExpBool_Or>;
  count?: InputMaybe<IntegratedChannelReadableItemsAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_channel_readable_items" */
export type IntegratedChannelReadableItemsAggregateFields = {
  __typename?: 'IntegratedChannelReadableItemsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedChannelReadableItemsMaxFields>;
  min?: Maybe<IntegratedChannelReadableItemsMinFields>;
};


/** aggregate fields of "integrated_channel_readable_items" */
export type IntegratedChannelReadableItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedChannelReadableItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_channel_readable_items" */
export type IntegratedChannelReadableItemsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedChannelReadableItemsMaxOrderBy>;
  min?: InputMaybe<IntegratedChannelReadableItemsMinOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_channel_readable_items" */
export type IntegratedChannelReadableItemsArrRelInsertInput = {
  data: Array<IntegratedChannelReadableItemsInsertInput>;
};

/** Boolean expression to filter rows from the table "integrated_channel_readable_items". All fields are combined with a logical 'AND'. */
export type IntegratedChannelReadableItemsBoolExp = {
  _and?: InputMaybe<Array<IntegratedChannelReadableItemsBoolExp>>;
  _not?: InputMaybe<IntegratedChannelReadableItemsBoolExp>;
  _or?: InputMaybe<Array<IntegratedChannelReadableItemsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  integratedChannelGuid?: InputMaybe<UuidComparisonExp>;
  integratedChannelItemGuid?: InputMaybe<UuidComparisonExp>;
  integratedMessageGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneCallGuid?: InputMaybe<UuidComparisonExp>;
  itemType?: InputMaybe<StringComparisonExp>;
  markedRead?: InputMaybe<BooleanComparisonExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "integrated_channel_readable_items" */
export type IntegratedChannelReadableItemsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelItemGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessageGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  itemType?: InputMaybe<Scalars['String']>;
  markedRead?: InputMaybe<Scalars['Boolean']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type IntegratedChannelReadableItemsMaxFields = {
  __typename?: 'IntegratedChannelReadableItemsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedChannelItemGuid?: Maybe<Scalars['uuid']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  itemType?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "integrated_channel_readable_items" */
export type IntegratedChannelReadableItemsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedChannelItemGuid?: InputMaybe<OrderBy>;
  integratedMessageGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedChannelReadableItemsMinFields = {
  __typename?: 'IntegratedChannelReadableItemsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedChannelItemGuid?: Maybe<Scalars['uuid']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  itemType?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "integrated_channel_readable_items" */
export type IntegratedChannelReadableItemsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedChannelItemGuid?: InputMaybe<OrderBy>;
  integratedMessageGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "integrated_channel_readable_items". */
export type IntegratedChannelReadableItemsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedChannelItemGuid?: InputMaybe<OrderBy>;
  integratedMessageGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  markedRead?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** select columns of table "integrated_channel_readable_items" */
export type IntegratedChannelReadableItemsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'integratedChannelGuid'
  /** column name */
  | 'integratedChannelItemGuid'
  /** column name */
  | 'integratedMessageGuid'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'itemType'
  /** column name */
  | 'markedRead'
  /** column name */
  | 'occurredAt';

/** select "integratedChannelReadableItemsAggregateBoolExpBool_andArgumentsColumns" columns of table "integrated_channel_readable_items" */
export type IntegratedChannelReadableItemsSelectColumnIntegratedChannelReadableItemsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'markedRead';

/** select "integratedChannelReadableItemsAggregateBoolExpBool_orArgumentsColumns" columns of table "integrated_channel_readable_items" */
export type IntegratedChannelReadableItemsSelectColumnIntegratedChannelReadableItemsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'markedRead';

/** Streaming cursor of the table "integrated_channel_readable_items" */
export type IntegratedChannelReadableItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedChannelReadableItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedChannelReadableItemsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelItemGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessageGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  itemType?: InputMaybe<Scalars['String']>;
  markedRead?: InputMaybe<Scalars['Boolean']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "integrated_channels" */
export type IntegratedChannels = {
  __typename?: 'IntegratedChannels';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  /** An object relationship */
  contact?: Maybe<Contacts>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  externalPhoneNumber: Scalars['String'];
  /** An array relationship */
  integratedChannelCompletableItems: Array<IntegratedChannelCompletableItems>;
  /** An aggregate relationship */
  integratedChannelCompletableItemsAggregate: IntegratedChannelCompletableItemsAggregate;
  integratedChannelGuid: Scalars['uuid'];
  /** An array relationship */
  integratedChannelItems: Array<IntegratedChannelItems>;
  /** An aggregate relationship */
  integratedChannelItemsAggregate: IntegratedChannelItemsAggregate;
  /** An array relationship */
  integratedChannelReadableItems: Array<IntegratedChannelReadableItems>;
  /** An aggregate relationship */
  integratedChannelReadableItemsAggregate: IntegratedChannelReadableItemsAggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "integrated_channels" */
export type IntegratedChannelsIntegratedChannelCompletableItemsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelCompletableItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelCompletableItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelCompletableItemsBoolExp>;
};


/** columns and relationships of "integrated_channels" */
export type IntegratedChannelsIntegratedChannelCompletableItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelCompletableItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelCompletableItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelCompletableItemsBoolExp>;
};


/** columns and relationships of "integrated_channels" */
export type IntegratedChannelsIntegratedChannelItemsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelItemsBoolExp>;
};


/** columns and relationships of "integrated_channels" */
export type IntegratedChannelsIntegratedChannelItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelItemsBoolExp>;
};


/** columns and relationships of "integrated_channels" */
export type IntegratedChannelsIntegratedChannelReadableItemsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelReadableItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelReadableItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelReadableItemsBoolExp>;
};


/** columns and relationships of "integrated_channels" */
export type IntegratedChannelsIntegratedChannelReadableItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelReadableItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelReadableItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelReadableItemsBoolExp>;
};

/** aggregated selection of "integrated_channels" */
export type IntegratedChannelsAggregate = {
  __typename?: 'IntegratedChannelsAggregate';
  aggregate?: Maybe<IntegratedChannelsAggregateFields>;
  nodes: Array<IntegratedChannels>;
};

/** aggregate fields of "integrated_channels" */
export type IntegratedChannelsAggregateFields = {
  __typename?: 'IntegratedChannelsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedChannelsMaxFields>;
  min?: Maybe<IntegratedChannelsMinFields>;
};


/** aggregate fields of "integrated_channels" */
export type IntegratedChannelsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedChannelsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "integrated_channels". All fields are combined with a logical 'AND'. */
export type IntegratedChannelsBoolExp = {
  _and?: InputMaybe<Array<IntegratedChannelsBoolExp>>;
  _not?: InputMaybe<IntegratedChannelsBoolExp>;
  _or?: InputMaybe<Array<IntegratedChannelsBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  contact?: InputMaybe<ContactsBoolExp>;
  contactGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalPhoneNumber?: InputMaybe<StringComparisonExp>;
  integratedChannelCompletableItems?: InputMaybe<IntegratedChannelCompletableItemsBoolExp>;
  integratedChannelCompletableItemsAggregate?: InputMaybe<IntegratedChannelCompletableItemsAggregateBoolExp>;
  integratedChannelGuid?: InputMaybe<UuidComparisonExp>;
  integratedChannelItems?: InputMaybe<IntegratedChannelItemsBoolExp>;
  integratedChannelItemsAggregate?: InputMaybe<IntegratedChannelItemsAggregateBoolExp>;
  integratedChannelReadableItems?: InputMaybe<IntegratedChannelReadableItemsBoolExp>;
  integratedChannelReadableItemsAggregate?: InputMaybe<IntegratedChannelReadableItemsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "integrated_channels" */
export type IntegratedChannelsConstraint =
  /** unique or primary key constraint on columns "integrated_channel_guid" */
  | 'integrated_channels_pkey'
  /** unique or primary key constraint on columns "company_guid", "external_phone_number" */
  | 'uq_integrated_channels_company_external_phone'
  /** unique or primary key constraint on columns "company_guid", "external_phone_number", "contact_guid" */
  | 'uq_integrated_channels_company_external_phone_contact';

/** input type for inserting data into table "integrated_channels" */
export type IntegratedChannelsInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contact?: InputMaybe<ContactsObjRelInsertInput>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalPhoneNumber?: InputMaybe<Scalars['String']>;
  integratedChannelCompletableItems?: InputMaybe<IntegratedChannelCompletableItemsArrRelInsertInput>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedChannelItems?: InputMaybe<IntegratedChannelItemsArrRelInsertInput>;
  integratedChannelReadableItems?: InputMaybe<IntegratedChannelReadableItemsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type IntegratedChannelsMaxFields = {
  __typename?: 'IntegratedChannelsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalPhoneNumber?: Maybe<Scalars['String']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type IntegratedChannelsMinFields = {
  __typename?: 'IntegratedChannelsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalPhoneNumber?: Maybe<Scalars['String']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "integrated_channels" */
export type IntegratedChannelsMutationResponse = {
  __typename?: 'IntegratedChannelsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedChannels>;
};

/** input type for inserting object relation for remote table "integrated_channels" */
export type IntegratedChannelsObjRelInsertInput = {
  data: IntegratedChannelsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedChannelsOnConflict>;
};

/** on_conflict condition type for table "integrated_channels" */
export type IntegratedChannelsOnConflict = {
  constraint: IntegratedChannelsConstraint;
  updateColumns?: Array<IntegratedChannelsUpdateColumn>;
  where?: InputMaybe<IntegratedChannelsBoolExp>;
};

/** Ordering options when selecting data from "integrated_channels". */
export type IntegratedChannelsOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contact?: InputMaybe<ContactsOrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalPhoneNumber?: InputMaybe<OrderBy>;
  integratedChannelCompletableItemsAggregate?: InputMaybe<IntegratedChannelCompletableItemsAggregateOrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedChannelItemsAggregate?: InputMaybe<IntegratedChannelItemsAggregateOrderBy>;
  integratedChannelReadableItemsAggregate?: InputMaybe<IntegratedChannelReadableItemsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_channels */
export type IntegratedChannelsPkColumnsInput = {
  integratedChannelGuid: Scalars['uuid'];
};

/** select columns of table "integrated_channels" */
export type IntegratedChannelsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalPhoneNumber'
  /** column name */
  | 'integratedChannelGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "integrated_channels" */
export type IntegratedChannelsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalPhoneNumber?: InputMaybe<Scalars['String']>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "integrated_channels" */
export type IntegratedChannelsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedChannelsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedChannelsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalPhoneNumber?: InputMaybe<Scalars['String']>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "integrated_channels" */
export type IntegratedChannelsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalPhoneNumber'
  /** column name */
  | 'integratedChannelGuid'
  /** column name */
  | 'updatedAt';

export type IntegratedChannelsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedChannelsSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedChannelsBoolExp;
};

/** columns and relationships of "integrated_message_statuses" */
export type IntegratedMessageStatuses = {
  __typename?: 'IntegratedMessageStatuses';
  companyGuid: Scalars['uuid'];
  completedAt?: Maybe<Scalars['timestamptz']>;
  completedByUserGuid?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  deliveredAt?: Maybe<Scalars['timestamptz']>;
  dismissedAt?: Maybe<Scalars['timestamptz']>;
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  failedAt?: Maybe<Scalars['timestamptz']>;
  integratedMessageGuid: Scalars['uuid'];
  integratedMessageStatusGuid: Scalars['uuid'];
  isDraft?: Maybe<Scalars['Boolean']>;
  receivedAt?: Maybe<Scalars['timestamptz']>;
  sentAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "integrated_message_statuses" */
export type IntegratedMessageStatusesAggregate = {
  __typename?: 'IntegratedMessageStatusesAggregate';
  aggregate?: Maybe<IntegratedMessageStatusesAggregateFields>;
  nodes: Array<IntegratedMessageStatuses>;
};

/** aggregate fields of "integrated_message_statuses" */
export type IntegratedMessageStatusesAggregateFields = {
  __typename?: 'IntegratedMessageStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedMessageStatusesMaxFields>;
  min?: Maybe<IntegratedMessageStatusesMinFields>;
};


/** aggregate fields of "integrated_message_statuses" */
export type IntegratedMessageStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedMessageStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "integrated_message_statuses". All fields are combined with a logical 'AND'. */
export type IntegratedMessageStatusesBoolExp = {
  _and?: InputMaybe<Array<IntegratedMessageStatusesBoolExp>>;
  _not?: InputMaybe<IntegratedMessageStatusesBoolExp>;
  _or?: InputMaybe<Array<IntegratedMessageStatusesBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  completedByUserGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deliveredAt?: InputMaybe<TimestamptzComparisonExp>;
  dismissedAt?: InputMaybe<TimestamptzComparisonExp>;
  errorCode?: InputMaybe<StringComparisonExp>;
  errorMessage?: InputMaybe<StringComparisonExp>;
  failedAt?: InputMaybe<TimestamptzComparisonExp>;
  integratedMessageGuid?: InputMaybe<UuidComparisonExp>;
  integratedMessageStatusGuid?: InputMaybe<UuidComparisonExp>;
  isDraft?: InputMaybe<BooleanComparisonExp>;
  receivedAt?: InputMaybe<TimestamptzComparisonExp>;
  sentAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "integrated_message_statuses" */
export type IntegratedMessageStatusesConstraint =
  /** unique or primary key constraint on columns "integrated_message_status_guid" */
  | 'integrated_message_statuses_pkey'
  /** unique or primary key constraint on columns "integrated_message_guid" */
  | 'uq_integrated_message_statuses_integrated_message_guid';

/** input type for inserting data into table "integrated_message_statuses" */
export type IntegratedMessageStatusesInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  completedByUserGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deliveredAt?: InputMaybe<Scalars['timestamptz']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  errorCode?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  failedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedMessageGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessageStatusGuid?: InputMaybe<Scalars['uuid']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  receivedAt?: InputMaybe<Scalars['timestamptz']>;
  sentAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type IntegratedMessageStatusesMaxFields = {
  __typename?: 'IntegratedMessageStatusesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  completedByUserGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deliveredAt?: Maybe<Scalars['timestamptz']>;
  dismissedAt?: Maybe<Scalars['timestamptz']>;
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  failedAt?: Maybe<Scalars['timestamptz']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedMessageStatusGuid?: Maybe<Scalars['uuid']>;
  receivedAt?: Maybe<Scalars['timestamptz']>;
  sentAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type IntegratedMessageStatusesMinFields = {
  __typename?: 'IntegratedMessageStatusesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  completedByUserGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  deliveredAt?: Maybe<Scalars['timestamptz']>;
  dismissedAt?: Maybe<Scalars['timestamptz']>;
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  failedAt?: Maybe<Scalars['timestamptz']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedMessageStatusGuid?: Maybe<Scalars['uuid']>;
  receivedAt?: Maybe<Scalars['timestamptz']>;
  sentAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "integrated_message_statuses" */
export type IntegratedMessageStatusesMutationResponse = {
  __typename?: 'IntegratedMessageStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedMessageStatuses>;
};

/** input type for inserting object relation for remote table "integrated_message_statuses" */
export type IntegratedMessageStatusesObjRelInsertInput = {
  data: IntegratedMessageStatusesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedMessageStatusesOnConflict>;
};

/** on_conflict condition type for table "integrated_message_statuses" */
export type IntegratedMessageStatusesOnConflict = {
  constraint: IntegratedMessageStatusesConstraint;
  updateColumns?: Array<IntegratedMessageStatusesUpdateColumn>;
  where?: InputMaybe<IntegratedMessageStatusesBoolExp>;
};

/** Ordering options when selecting data from "integrated_message_statuses". */
export type IntegratedMessageStatusesOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  completedByUserGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deliveredAt?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  errorCode?: InputMaybe<OrderBy>;
  errorMessage?: InputMaybe<OrderBy>;
  failedAt?: InputMaybe<OrderBy>;
  integratedMessageGuid?: InputMaybe<OrderBy>;
  integratedMessageStatusGuid?: InputMaybe<OrderBy>;
  isDraft?: InputMaybe<OrderBy>;
  receivedAt?: InputMaybe<OrderBy>;
  sentAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_message_statuses */
export type IntegratedMessageStatusesPkColumnsInput = {
  integratedMessageStatusGuid: Scalars['uuid'];
};

/** select columns of table "integrated_message_statuses" */
export type IntegratedMessageStatusesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'completedAt'
  /** column name */
  | 'completedByUserGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deliveredAt'
  /** column name */
  | 'dismissedAt'
  /** column name */
  | 'errorCode'
  /** column name */
  | 'errorMessage'
  /** column name */
  | 'failedAt'
  /** column name */
  | 'integratedMessageGuid'
  /** column name */
  | 'integratedMessageStatusGuid'
  /** column name */
  | 'isDraft'
  /** column name */
  | 'receivedAt'
  /** column name */
  | 'sentAt'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "integrated_message_statuses" */
export type IntegratedMessageStatusesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  completedByUserGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deliveredAt?: InputMaybe<Scalars['timestamptz']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  errorCode?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  failedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedMessageGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessageStatusGuid?: InputMaybe<Scalars['uuid']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  receivedAt?: InputMaybe<Scalars['timestamptz']>;
  sentAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "integrated_message_statuses" */
export type IntegratedMessageStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedMessageStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedMessageStatusesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  completedByUserGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deliveredAt?: InputMaybe<Scalars['timestamptz']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  errorCode?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  failedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedMessageGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessageStatusGuid?: InputMaybe<Scalars['uuid']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  receivedAt?: InputMaybe<Scalars['timestamptz']>;
  sentAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "integrated_message_statuses" */
export type IntegratedMessageStatusesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'completedAt'
  /** column name */
  | 'completedByUserGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deliveredAt'
  /** column name */
  | 'dismissedAt'
  /** column name */
  | 'errorCode'
  /** column name */
  | 'errorMessage'
  /** column name */
  | 'failedAt'
  /** column name */
  | 'integratedMessageGuid'
  /** column name */
  | 'integratedMessageStatusGuid'
  /** column name */
  | 'isDraft'
  /** column name */
  | 'receivedAt'
  /** column name */
  | 'sentAt'
  /** column name */
  | 'updatedAt';

export type IntegratedMessageStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedMessageStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedMessageStatusesBoolExp;
};

/** columns and relationships of "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEvents = {
  __typename?: 'IntegratedMessageTwilioRawWebhookEvents';
  createdAt: Scalars['timestamptz'];
  endpoint: Scalars['String'];
  integratedMessageTwilioRawWebhookEventGuid: Scalars['uuid'];
  rawWebhookJson: Scalars['jsonb'];
};


/** columns and relationships of "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEventsRawWebhookJsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEventsAggregate = {
  __typename?: 'IntegratedMessageTwilioRawWebhookEventsAggregate';
  aggregate?: Maybe<IntegratedMessageTwilioRawWebhookEventsAggregateFields>;
  nodes: Array<IntegratedMessageTwilioRawWebhookEvents>;
};

/** aggregate fields of "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEventsAggregateFields = {
  __typename?: 'IntegratedMessageTwilioRawWebhookEventsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedMessageTwilioRawWebhookEventsMaxFields>;
  min?: Maybe<IntegratedMessageTwilioRawWebhookEventsMinFields>;
};


/** aggregate fields of "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEventsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedMessageTwilioRawWebhookEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type IntegratedMessageTwilioRawWebhookEventsAppendInput = {
  rawWebhookJson?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "integrated_message_twilio_raw_webhook_events". All fields are combined with a logical 'AND'. */
export type IntegratedMessageTwilioRawWebhookEventsBoolExp = {
  _and?: InputMaybe<Array<IntegratedMessageTwilioRawWebhookEventsBoolExp>>;
  _not?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsBoolExp>;
  _or?: InputMaybe<Array<IntegratedMessageTwilioRawWebhookEventsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  endpoint?: InputMaybe<StringComparisonExp>;
  integratedMessageTwilioRawWebhookEventGuid?: InputMaybe<UuidComparisonExp>;
  rawWebhookJson?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEventsConstraint =
  /** unique or primary key constraint on columns "integrated_message_twilio_raw_webhook_event_guid" */
  | 'integrated_message_twilio_raw_webhook_events_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type IntegratedMessageTwilioRawWebhookEventsDeleteAtPathInput = {
  rawWebhookJson?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type IntegratedMessageTwilioRawWebhookEventsDeleteElemInput = {
  rawWebhookJson?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type IntegratedMessageTwilioRawWebhookEventsDeleteKeyInput = {
  rawWebhookJson?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEventsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endpoint?: InputMaybe<Scalars['String']>;
  integratedMessageTwilioRawWebhookEventGuid?: InputMaybe<Scalars['uuid']>;
  rawWebhookJson?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type IntegratedMessageTwilioRawWebhookEventsMaxFields = {
  __typename?: 'IntegratedMessageTwilioRawWebhookEventsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  endpoint?: Maybe<Scalars['String']>;
  integratedMessageTwilioRawWebhookEventGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type IntegratedMessageTwilioRawWebhookEventsMinFields = {
  __typename?: 'IntegratedMessageTwilioRawWebhookEventsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  endpoint?: Maybe<Scalars['String']>;
  integratedMessageTwilioRawWebhookEventGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEventsMutationResponse = {
  __typename?: 'IntegratedMessageTwilioRawWebhookEventsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedMessageTwilioRawWebhookEvents>;
};

/** on_conflict condition type for table "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEventsOnConflict = {
  constraint: IntegratedMessageTwilioRawWebhookEventsConstraint;
  updateColumns?: Array<IntegratedMessageTwilioRawWebhookEventsUpdateColumn>;
  where?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsBoolExp>;
};

/** Ordering options when selecting data from "integrated_message_twilio_raw_webhook_events". */
export type IntegratedMessageTwilioRawWebhookEventsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  endpoint?: InputMaybe<OrderBy>;
  integratedMessageTwilioRawWebhookEventGuid?: InputMaybe<OrderBy>;
  rawWebhookJson?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_message_twilio_raw_webhook_events */
export type IntegratedMessageTwilioRawWebhookEventsPkColumnsInput = {
  integratedMessageTwilioRawWebhookEventGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type IntegratedMessageTwilioRawWebhookEventsPrependInput = {
  rawWebhookJson?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEventsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'endpoint'
  /** column name */
  | 'integratedMessageTwilioRawWebhookEventGuid'
  /** column name */
  | 'rawWebhookJson';

/** input type for updating data in table "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEventsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endpoint?: InputMaybe<Scalars['String']>;
  integratedMessageTwilioRawWebhookEventGuid?: InputMaybe<Scalars['uuid']>;
  rawWebhookJson?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedMessageTwilioRawWebhookEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedMessageTwilioRawWebhookEventsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endpoint?: InputMaybe<Scalars['String']>;
  integratedMessageTwilioRawWebhookEventGuid?: InputMaybe<Scalars['uuid']>;
  rawWebhookJson?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "integrated_message_twilio_raw_webhook_events" */
export type IntegratedMessageTwilioRawWebhookEventsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'endpoint'
  /** column name */
  | 'integratedMessageTwilioRawWebhookEventGuid'
  /** column name */
  | 'rawWebhookJson';

export type IntegratedMessageTwilioRawWebhookEventsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedMessageTwilioRawWebhookEventsBoolExp;
};

/** columns and relationships of "integrated_messages" */
export type IntegratedMessages = {
  __typename?: 'IntegratedMessages';
  body?: Maybe<Scalars['String']>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  direction: Scalars['IntegratedMessageDirection'];
  externalMessageId?: Maybe<Scalars['String']>;
  fromPhoneNumber: Scalars['String'];
  /** An object relationship */
  integratedChannel: IntegratedChannels;
  integratedChannelGuid: Scalars['uuid'];
  integratedMessageGuid: Scalars['uuid'];
  /** An object relationship */
  integratedMessageStatus?: Maybe<IntegratedMessageStatuses>;
  /** An object relationship */
  integratedPhone: IntegratedPhones;
  integratedPhoneGuid: Scalars['uuid'];
  sentByUserGuid?: Maybe<Scalars['uuid']>;
  toPhoneNumber: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** aggregated selection of "integrated_messages" */
export type IntegratedMessagesAggregate = {
  __typename?: 'IntegratedMessagesAggregate';
  aggregate?: Maybe<IntegratedMessagesAggregateFields>;
  nodes: Array<IntegratedMessages>;
};

/** aggregate fields of "integrated_messages" */
export type IntegratedMessagesAggregateFields = {
  __typename?: 'IntegratedMessagesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedMessagesMaxFields>;
  min?: Maybe<IntegratedMessagesMinFields>;
};


/** aggregate fields of "integrated_messages" */
export type IntegratedMessagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedMessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "integrated_messages". All fields are combined with a logical 'AND'. */
export type IntegratedMessagesBoolExp = {
  _and?: InputMaybe<Array<IntegratedMessagesBoolExp>>;
  _not?: InputMaybe<IntegratedMessagesBoolExp>;
  _or?: InputMaybe<Array<IntegratedMessagesBoolExp>>;
  body?: InputMaybe<StringComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  direction?: InputMaybe<Scalars['IntegratedMessageDirectionComparisonExp']>;
  externalMessageId?: InputMaybe<StringComparisonExp>;
  fromPhoneNumber?: InputMaybe<StringComparisonExp>;
  integratedChannel?: InputMaybe<IntegratedChannelsBoolExp>;
  integratedChannelGuid?: InputMaybe<UuidComparisonExp>;
  integratedMessageGuid?: InputMaybe<UuidComparisonExp>;
  integratedMessageStatus?: InputMaybe<IntegratedMessageStatusesBoolExp>;
  integratedPhone?: InputMaybe<IntegratedPhonesBoolExp>;
  integratedPhoneGuid?: InputMaybe<UuidComparisonExp>;
  sentByUserGuid?: InputMaybe<UuidComparisonExp>;
  toPhoneNumber?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "integrated_messages" */
export type IntegratedMessagesConstraint =
  /** unique or primary key constraint on columns "integrated_message_guid" */
  | 'integrated_messages_pkey';

/** input type for inserting data into table "integrated_messages" */
export type IntegratedMessagesInsertInput = {
  body?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  direction?: InputMaybe<Scalars['IntegratedMessageDirection']>;
  externalMessageId?: InputMaybe<Scalars['String']>;
  fromPhoneNumber?: InputMaybe<Scalars['String']>;
  integratedChannel?: InputMaybe<IntegratedChannelsObjRelInsertInput>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessageGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessageStatus?: InputMaybe<IntegratedMessageStatusesObjRelInsertInput>;
  integratedPhone?: InputMaybe<IntegratedPhonesObjRelInsertInput>;
  integratedPhoneGuid?: InputMaybe<Scalars['uuid']>;
  sentByUserGuid?: InputMaybe<Scalars['uuid']>;
  toPhoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type IntegratedMessagesMaxFields = {
  __typename?: 'IntegratedMessagesMaxFields';
  body?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  direction?: Maybe<Scalars['IntegratedMessageDirection']>;
  externalMessageId?: Maybe<Scalars['String']>;
  fromPhoneNumber?: Maybe<Scalars['String']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneGuid?: Maybe<Scalars['uuid']>;
  sentByUserGuid?: Maybe<Scalars['uuid']>;
  toPhoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type IntegratedMessagesMinFields = {
  __typename?: 'IntegratedMessagesMinFields';
  body?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  direction?: Maybe<Scalars['IntegratedMessageDirection']>;
  externalMessageId?: Maybe<Scalars['String']>;
  fromPhoneNumber?: Maybe<Scalars['String']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedMessageGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneGuid?: Maybe<Scalars['uuid']>;
  sentByUserGuid?: Maybe<Scalars['uuid']>;
  toPhoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "integrated_messages" */
export type IntegratedMessagesMutationResponse = {
  __typename?: 'IntegratedMessagesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedMessages>;
};

/** input type for inserting object relation for remote table "integrated_messages" */
export type IntegratedMessagesObjRelInsertInput = {
  data: IntegratedMessagesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedMessagesOnConflict>;
};

/** on_conflict condition type for table "integrated_messages" */
export type IntegratedMessagesOnConflict = {
  constraint: IntegratedMessagesConstraint;
  updateColumns?: Array<IntegratedMessagesUpdateColumn>;
  where?: InputMaybe<IntegratedMessagesBoolExp>;
};

/** Ordering options when selecting data from "integrated_messages". */
export type IntegratedMessagesOrderBy = {
  body?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  externalMessageId?: InputMaybe<OrderBy>;
  fromPhoneNumber?: InputMaybe<OrderBy>;
  integratedChannel?: InputMaybe<IntegratedChannelsOrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedMessageGuid?: InputMaybe<OrderBy>;
  integratedMessageStatus?: InputMaybe<IntegratedMessageStatusesOrderBy>;
  integratedPhone?: InputMaybe<IntegratedPhonesOrderBy>;
  integratedPhoneGuid?: InputMaybe<OrderBy>;
  sentByUserGuid?: InputMaybe<OrderBy>;
  toPhoneNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: integrated_messages */
export type IntegratedMessagesPkColumnsInput = {
  integratedMessageGuid: Scalars['uuid'];
};

/** select columns of table "integrated_messages" */
export type IntegratedMessagesSelectColumn =
  /** column name */
  | 'body'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'direction'
  /** column name */
  | 'externalMessageId'
  /** column name */
  | 'fromPhoneNumber'
  /** column name */
  | 'integratedChannelGuid'
  /** column name */
  | 'integratedMessageGuid'
  /** column name */
  | 'integratedPhoneGuid'
  /** column name */
  | 'sentByUserGuid'
  /** column name */
  | 'toPhoneNumber'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "integrated_messages" */
export type IntegratedMessagesSetInput = {
  body?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  direction?: InputMaybe<Scalars['IntegratedMessageDirection']>;
  externalMessageId?: InputMaybe<Scalars['String']>;
  fromPhoneNumber?: InputMaybe<Scalars['String']>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessageGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneGuid?: InputMaybe<Scalars['uuid']>;
  sentByUserGuid?: InputMaybe<Scalars['uuid']>;
  toPhoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "integrated_messages" */
export type IntegratedMessagesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedMessagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedMessagesStreamCursorValueInput = {
  body?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  direction?: InputMaybe<Scalars['IntegratedMessageDirection']>;
  externalMessageId?: InputMaybe<Scalars['String']>;
  fromPhoneNumber?: InputMaybe<Scalars['String']>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedMessageGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneGuid?: InputMaybe<Scalars['uuid']>;
  sentByUserGuid?: InputMaybe<Scalars['uuid']>;
  toPhoneNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "integrated_messages" */
export type IntegratedMessagesUpdateColumn =
  /** column name */
  | 'body'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'direction'
  /** column name */
  | 'externalMessageId'
  /** column name */
  | 'fromPhoneNumber'
  /** column name */
  | 'integratedChannelGuid'
  /** column name */
  | 'integratedMessageGuid'
  /** column name */
  | 'integratedPhoneGuid'
  /** column name */
  | 'sentByUserGuid'
  /** column name */
  | 'toPhoneNumber'
  /** column name */
  | 'updatedAt';

export type IntegratedMessagesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedMessagesSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedMessagesBoolExp;
};

/** columns and relationships of "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissals = {
  __typename?: 'IntegratedPhoneCallDismissals';
  companyGuid: Scalars['uuid'];
  dismissedAt: Scalars['timestamptz'];
  integratedPhoneCallDismissalGuid: Scalars['uuid'];
  integratedPhoneCallGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsAggregate = {
  __typename?: 'IntegratedPhoneCallDismissalsAggregate';
  aggregate?: Maybe<IntegratedPhoneCallDismissalsAggregateFields>;
  nodes: Array<IntegratedPhoneCallDismissals>;
};

export type IntegratedPhoneCallDismissalsAggregateBoolExp = {
  count?: InputMaybe<IntegratedPhoneCallDismissalsAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsAggregateFields = {
  __typename?: 'IntegratedPhoneCallDismissalsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneCallDismissalsMaxFields>;
  min?: Maybe<IntegratedPhoneCallDismissalsMinFields>;
};


/** aggregate fields of "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneCallDismissalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedPhoneCallDismissalsMaxOrderBy>;
  min?: InputMaybe<IntegratedPhoneCallDismissalsMinOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsArrRelInsertInput = {
  data: Array<IntegratedPhoneCallDismissalsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneCallDismissalsOnConflict>;
};

/** Boolean expression to filter rows from the table "integrated_phone_call_dismissals". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneCallDismissalsBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneCallDismissalsBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneCallDismissalsBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneCallDismissalsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  dismissedAt?: InputMaybe<TimestamptzComparisonExp>;
  integratedPhoneCallDismissalGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneCallGuid?: InputMaybe<UuidComparisonExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsConstraint =
  /** unique or primary key constraint on columns "integrated_phone_call_dismissal_guid" */
  | 'integrated_phone_call_dismissals_pkey';

/** input type for inserting data into table "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneCallDismissalGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type IntegratedPhoneCallDismissalsMaxFields = {
  __typename?: 'IntegratedPhoneCallDismissalsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  dismissedAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneCallDismissalGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  integratedPhoneCallDismissalGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedPhoneCallDismissalsMinFields = {
  __typename?: 'IntegratedPhoneCallDismissalsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  dismissedAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneCallDismissalGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  integratedPhoneCallDismissalGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsMutationResponse = {
  __typename?: 'IntegratedPhoneCallDismissalsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneCallDismissals>;
};

/** on_conflict condition type for table "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsOnConflict = {
  constraint: IntegratedPhoneCallDismissalsConstraint;
  updateColumns?: Array<IntegratedPhoneCallDismissalsUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneCallDismissalsBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_call_dismissals". */
export type IntegratedPhoneCallDismissalsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  integratedPhoneCallDismissalGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phone_call_dismissals */
export type IntegratedPhoneCallDismissalsPkColumnsInput = {
  integratedPhoneCallDismissalGuid: Scalars['uuid'];
};

/** select columns of table "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dismissedAt'
  /** column name */
  | 'integratedPhoneCallDismissalGuid'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneCallDismissalGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneCallDismissalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneCallDismissalsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneCallDismissalGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "integrated_phone_call_dismissals" */
export type IntegratedPhoneCallDismissalsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dismissedAt'
  /** column name */
  | 'integratedPhoneCallDismissalGuid'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'userGuid';

export type IntegratedPhoneCallDismissalsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneCallDismissalsSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneCallDismissalsBoolExp;
};

/** columns and relationships of "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobs = {
  __typename?: 'IntegratedPhoneCallJobs';
  companyGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  integratedPhoneCall: IntegratedPhoneCalls;
  integratedPhoneCallGuid: Scalars['uuid'];
  /** An object relationship */
  job: Jobs;
  jobGuid: Scalars['uuid'];
};

/** aggregated selection of "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsAggregate = {
  __typename?: 'IntegratedPhoneCallJobsAggregate';
  aggregate?: Maybe<IntegratedPhoneCallJobsAggregateFields>;
  nodes: Array<IntegratedPhoneCallJobs>;
};

export type IntegratedPhoneCallJobsAggregateBoolExp = {
  count?: InputMaybe<IntegratedPhoneCallJobsAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsAggregateFields = {
  __typename?: 'IntegratedPhoneCallJobsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneCallJobsMaxFields>;
  min?: Maybe<IntegratedPhoneCallJobsMinFields>;
};


/** aggregate fields of "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneCallJobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedPhoneCallJobsMaxOrderBy>;
  min?: InputMaybe<IntegratedPhoneCallJobsMinOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsArrRelInsertInput = {
  data: Array<IntegratedPhoneCallJobsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneCallJobsOnConflict>;
};

/** Boolean expression to filter rows from the table "integrated_phone_call_jobs". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneCallJobsBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneCallJobsBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneCallJobsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneCall?: InputMaybe<IntegratedPhoneCallsBoolExp>;
  integratedPhoneCallGuid?: InputMaybe<UuidComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsConstraint =
  /** unique or primary key constraint on columns "job_guid", "integrated_phone_call_guid" */
  | 'integrated_phone_call_jobs_pkey';

/** input type for inserting data into table "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCall?: InputMaybe<IntegratedPhoneCallsObjRelInsertInput>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type IntegratedPhoneCallJobsMaxFields = {
  __typename?: 'IntegratedPhoneCallJobsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedPhoneCallJobsMinFields = {
  __typename?: 'IntegratedPhoneCallJobsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsMutationResponse = {
  __typename?: 'IntegratedPhoneCallJobsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneCallJobs>;
};

/** on_conflict condition type for table "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsOnConflict = {
  constraint: IntegratedPhoneCallJobsConstraint;
  updateColumns?: Array<IntegratedPhoneCallJobsUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_call_jobs". */
export type IntegratedPhoneCallJobsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  integratedPhoneCall?: InputMaybe<IntegratedPhoneCallsOrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phone_call_jobs */
export type IntegratedPhoneCallJobsPkColumnsInput = {
  integratedPhoneCallGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
};

/** select columns of table "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'jobGuid';

/** input type for updating data in table "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneCallJobsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneCallJobsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "integrated_phone_call_jobs" */
export type IntegratedPhoneCallJobsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'jobGuid';

export type IntegratedPhoneCallJobsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneCallJobsSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneCallJobsBoolExp;
};

/** columns and relationships of "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecording = {
  __typename?: 'IntegratedPhoneCallRecording';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  integratedPhoneCallGuid: Scalars['uuid'];
  integratedPhoneCallRecordingGuid: Scalars['uuid'];
  recordingDurationSeconds: Scalars['Int'];
  recordingSummary?: Maybe<Scalars['String']>;
  recordingTranscript?: Maybe<Scalars['String']>;
  recordingUrl: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingAggregate = {
  __typename?: 'IntegratedPhoneCallRecordingAggregate';
  aggregate?: Maybe<IntegratedPhoneCallRecordingAggregateFields>;
  nodes: Array<IntegratedPhoneCallRecording>;
};

/** aggregate fields of "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingAggregateFields = {
  __typename?: 'IntegratedPhoneCallRecordingAggregateFields';
  avg?: Maybe<IntegratedPhoneCallRecordingAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneCallRecordingMaxFields>;
  min?: Maybe<IntegratedPhoneCallRecordingMinFields>;
  stddev?: Maybe<IntegratedPhoneCallRecordingStddevFields>;
  stddevPop?: Maybe<IntegratedPhoneCallRecordingStddevPopFields>;
  stddevSamp?: Maybe<IntegratedPhoneCallRecordingStddevSampFields>;
  sum?: Maybe<IntegratedPhoneCallRecordingSumFields>;
  varPop?: Maybe<IntegratedPhoneCallRecordingVarPopFields>;
  varSamp?: Maybe<IntegratedPhoneCallRecordingVarSampFields>;
  variance?: Maybe<IntegratedPhoneCallRecordingVarianceFields>;
};


/** aggregate fields of "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneCallRecordingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type IntegratedPhoneCallRecordingAvgFields = {
  __typename?: 'IntegratedPhoneCallRecordingAvgFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "integrated_phone_call_recording". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneCallRecordingBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneCallRecordingBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneCallRecordingBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneCallRecordingBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  integratedPhoneCallGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneCallRecordingGuid?: InputMaybe<UuidComparisonExp>;
  recordingDurationSeconds?: InputMaybe<IntComparisonExp>;
  recordingSummary?: InputMaybe<StringComparisonExp>;
  recordingTranscript?: InputMaybe<StringComparisonExp>;
  recordingUrl?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingConstraint =
  /** unique or primary key constraint on columns "integrated_phone_call_guid" */
  | 'integrated_phone_call_recording_integrated_phone_call_guid_key'
  /** unique or primary key constraint on columns "integrated_phone_call_recording_guid" */
  | 'integrated_phone_call_recording_pkey';

/** input type for incrementing numeric columns in table "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingIncInput = {
  recordingDurationSeconds?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallRecordingGuid?: InputMaybe<Scalars['uuid']>;
  recordingDurationSeconds?: InputMaybe<Scalars['Int']>;
  recordingSummary?: InputMaybe<Scalars['String']>;
  recordingTranscript?: InputMaybe<Scalars['String']>;
  recordingUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type IntegratedPhoneCallRecordingMaxFields = {
  __typename?: 'IntegratedPhoneCallRecordingMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallRecordingGuid?: Maybe<Scalars['uuid']>;
  recordingDurationSeconds?: Maybe<Scalars['Int']>;
  recordingSummary?: Maybe<Scalars['String']>;
  recordingTranscript?: Maybe<Scalars['String']>;
  recordingUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type IntegratedPhoneCallRecordingMinFields = {
  __typename?: 'IntegratedPhoneCallRecordingMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallRecordingGuid?: Maybe<Scalars['uuid']>;
  recordingDurationSeconds?: Maybe<Scalars['Int']>;
  recordingSummary?: Maybe<Scalars['String']>;
  recordingTranscript?: Maybe<Scalars['String']>;
  recordingUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingMutationResponse = {
  __typename?: 'IntegratedPhoneCallRecordingMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneCallRecording>;
};

/** input type for inserting object relation for remote table "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingObjRelInsertInput = {
  data: IntegratedPhoneCallRecordingInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneCallRecordingOnConflict>;
};

/** on_conflict condition type for table "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingOnConflict = {
  constraint: IntegratedPhoneCallRecordingConstraint;
  updateColumns?: Array<IntegratedPhoneCallRecordingUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneCallRecordingBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_call_recording". */
export type IntegratedPhoneCallRecordingOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallRecordingGuid?: InputMaybe<OrderBy>;
  recordingDurationSeconds?: InputMaybe<OrderBy>;
  recordingSummary?: InputMaybe<OrderBy>;
  recordingTranscript?: InputMaybe<OrderBy>;
  recordingUrl?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phone_call_recording */
export type IntegratedPhoneCallRecordingPkColumnsInput = {
  integratedPhoneCallRecordingGuid: Scalars['uuid'];
};

/** select columns of table "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'integratedPhoneCallRecordingGuid'
  /** column name */
  | 'recordingDurationSeconds'
  /** column name */
  | 'recordingSummary'
  /** column name */
  | 'recordingTranscript'
  /** column name */
  | 'recordingUrl'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallRecordingGuid?: InputMaybe<Scalars['uuid']>;
  recordingDurationSeconds?: InputMaybe<Scalars['Int']>;
  recordingSummary?: InputMaybe<Scalars['String']>;
  recordingTranscript?: InputMaybe<Scalars['String']>;
  recordingUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type IntegratedPhoneCallRecordingStddevFields = {
  __typename?: 'IntegratedPhoneCallRecordingStddevFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type IntegratedPhoneCallRecordingStddevPopFields = {
  __typename?: 'IntegratedPhoneCallRecordingStddevPopFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type IntegratedPhoneCallRecordingStddevSampFields = {
  __typename?: 'IntegratedPhoneCallRecordingStddevSampFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneCallRecordingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneCallRecordingStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallRecordingGuid?: InputMaybe<Scalars['uuid']>;
  recordingDurationSeconds?: InputMaybe<Scalars['Int']>;
  recordingSummary?: InputMaybe<Scalars['String']>;
  recordingTranscript?: InputMaybe<Scalars['String']>;
  recordingUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type IntegratedPhoneCallRecordingSumFields = {
  __typename?: 'IntegratedPhoneCallRecordingSumFields';
  recordingDurationSeconds?: Maybe<Scalars['Int']>;
};

/** update columns of table "integrated_phone_call_recording" */
export type IntegratedPhoneCallRecordingUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'integratedPhoneCallRecordingGuid'
  /** column name */
  | 'recordingDurationSeconds'
  /** column name */
  | 'recordingSummary'
  /** column name */
  | 'recordingTranscript'
  /** column name */
  | 'recordingUrl'
  /** column name */
  | 'updatedAt';

export type IntegratedPhoneCallRecordingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IntegratedPhoneCallRecordingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneCallRecordingSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneCallRecordingBoolExp;
};

/** aggregate varPop on columns */
export type IntegratedPhoneCallRecordingVarPopFields = {
  __typename?: 'IntegratedPhoneCallRecordingVarPopFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type IntegratedPhoneCallRecordingVarSampFields = {
  __typename?: 'IntegratedPhoneCallRecordingVarSampFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type IntegratedPhoneCallRecordingVarianceFields = {
  __typename?: 'IntegratedPhoneCallRecordingVarianceFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "integrated_phone_call_status_types" */
export type IntegratedPhoneCallStatusTypes = {
  __typename?: 'IntegratedPhoneCallStatusTypes';
  name: Scalars['String'];
};

/** aggregated selection of "integrated_phone_call_status_types" */
export type IntegratedPhoneCallStatusTypesAggregate = {
  __typename?: 'IntegratedPhoneCallStatusTypesAggregate';
  aggregate?: Maybe<IntegratedPhoneCallStatusTypesAggregateFields>;
  nodes: Array<IntegratedPhoneCallStatusTypes>;
};

/** aggregate fields of "integrated_phone_call_status_types" */
export type IntegratedPhoneCallStatusTypesAggregateFields = {
  __typename?: 'IntegratedPhoneCallStatusTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneCallStatusTypesMaxFields>;
  min?: Maybe<IntegratedPhoneCallStatusTypesMinFields>;
};


/** aggregate fields of "integrated_phone_call_status_types" */
export type IntegratedPhoneCallStatusTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneCallStatusTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "integrated_phone_call_status_types". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneCallStatusTypesBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneCallStatusTypesBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneCallStatusTypesBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneCallStatusTypesBoolExp>>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phone_call_status_types" */
export type IntegratedPhoneCallStatusTypesConstraint =
  /** unique or primary key constraint on columns "name" */
  | 'integrated_phone_call_status_types_pkey';

export type IntegratedPhoneCallStatusTypesEnum =
  | 'BUSY'
  | 'CANCELED'
  | 'COMPLETED'
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'NO_ANSWER'
  | 'QUEUED'
  | 'RINGING';

/** Boolean expression to compare columns of type "IntegratedPhoneCallStatusTypesEnum". All fields are combined with logical 'AND'. */
export type IntegratedPhoneCallStatusTypesEnumComparisonExp = {
  _eq?: InputMaybe<IntegratedPhoneCallStatusTypesEnum>;
  _in?: InputMaybe<Array<IntegratedPhoneCallStatusTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<IntegratedPhoneCallStatusTypesEnum>;
  _nin?: InputMaybe<Array<IntegratedPhoneCallStatusTypesEnum>>;
};

/** input type for inserting data into table "integrated_phone_call_status_types" */
export type IntegratedPhoneCallStatusTypesInsertInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type IntegratedPhoneCallStatusTypesMaxFields = {
  __typename?: 'IntegratedPhoneCallStatusTypesMaxFields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type IntegratedPhoneCallStatusTypesMinFields = {
  __typename?: 'IntegratedPhoneCallStatusTypesMinFields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "integrated_phone_call_status_types" */
export type IntegratedPhoneCallStatusTypesMutationResponse = {
  __typename?: 'IntegratedPhoneCallStatusTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneCallStatusTypes>;
};

/** on_conflict condition type for table "integrated_phone_call_status_types" */
export type IntegratedPhoneCallStatusTypesOnConflict = {
  constraint: IntegratedPhoneCallStatusTypesConstraint;
  updateColumns?: Array<IntegratedPhoneCallStatusTypesUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneCallStatusTypesBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_call_status_types". */
export type IntegratedPhoneCallStatusTypesOrderBy = {
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phone_call_status_types */
export type IntegratedPhoneCallStatusTypesPkColumnsInput = {
  name: Scalars['String'];
};

/** select columns of table "integrated_phone_call_status_types" */
export type IntegratedPhoneCallStatusTypesSelectColumn =
  /** column name */
  | 'name';

/** input type for updating data in table "integrated_phone_call_status_types" */
export type IntegratedPhoneCallStatusTypesSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "integrated_phone_call_status_types" */
export type IntegratedPhoneCallStatusTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneCallStatusTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneCallStatusTypesStreamCursorValueInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "integrated_phone_call_status_types" */
export type IntegratedPhoneCallStatusTypesUpdateColumn =
  /** column name */
  | 'name';

export type IntegratedPhoneCallStatusTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneCallStatusTypesSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneCallStatusTypesBoolExp;
};

/** columns and relationships of "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatuses = {
  __typename?: 'IntegratedPhoneCallStatuses';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  integratedPhoneCall: IntegratedPhoneCalls;
  integratedPhoneCallGuid: Scalars['uuid'];
  integratedPhoneCallStatusGuid: Scalars['uuid'];
  occurredAt: Scalars['timestamptz'];
  status: IntegratedPhoneCallStatusTypesEnum;
};

/** aggregated selection of "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesAggregate = {
  __typename?: 'IntegratedPhoneCallStatusesAggregate';
  aggregate?: Maybe<IntegratedPhoneCallStatusesAggregateFields>;
  nodes: Array<IntegratedPhoneCallStatuses>;
};

export type IntegratedPhoneCallStatusesAggregateBoolExp = {
  count?: InputMaybe<IntegratedPhoneCallStatusesAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesAggregateFields = {
  __typename?: 'IntegratedPhoneCallStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneCallStatusesMaxFields>;
  min?: Maybe<IntegratedPhoneCallStatusesMinFields>;
};


/** aggregate fields of "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneCallStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedPhoneCallStatusesMaxOrderBy>;
  min?: InputMaybe<IntegratedPhoneCallStatusesMinOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesArrRelInsertInput = {
  data: Array<IntegratedPhoneCallStatusesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneCallStatusesOnConflict>;
};

/** Boolean expression to filter rows from the table "integrated_phone_call_statuses". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneCallStatusesBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneCallStatusesBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneCallStatusesBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneCallStatusesBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  integratedPhoneCall?: InputMaybe<IntegratedPhoneCallsBoolExp>;
  integratedPhoneCallGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneCallStatusGuid?: InputMaybe<UuidComparisonExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<IntegratedPhoneCallStatusTypesEnumComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesConstraint =
  /** unique or primary key constraint on columns "integrated_phone_call_status_guid" */
  | 'integrated_phone_call_statuses_pkey';

/** input type for inserting data into table "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneCall?: InputMaybe<IntegratedPhoneCallsObjRelInsertInput>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallStatusGuid?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<IntegratedPhoneCallStatusTypesEnum>;
};

/** aggregate max on columns */
export type IntegratedPhoneCallStatusesMaxFields = {
  __typename?: 'IntegratedPhoneCallStatusesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallStatusGuid?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallStatusGuid?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedPhoneCallStatusesMinFields = {
  __typename?: 'IntegratedPhoneCallStatusesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallStatusGuid?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallStatusGuid?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesMutationResponse = {
  __typename?: 'IntegratedPhoneCallStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneCallStatuses>;
};

/** on_conflict condition type for table "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesOnConflict = {
  constraint: IntegratedPhoneCallStatusesConstraint;
  updateColumns?: Array<IntegratedPhoneCallStatusesUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneCallStatusesBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_call_statuses". */
export type IntegratedPhoneCallStatusesOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  integratedPhoneCall?: InputMaybe<IntegratedPhoneCallsOrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallStatusGuid?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phone_call_statuses */
export type IntegratedPhoneCallStatusesPkColumnsInput = {
  integratedPhoneCallStatusGuid: Scalars['uuid'];
};

/** select columns of table "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'integratedPhoneCallStatusGuid'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'status';

/** input type for updating data in table "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallStatusGuid?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<IntegratedPhoneCallStatusTypesEnum>;
};

/** Streaming cursor of the table "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneCallStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneCallStatusesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallStatusGuid?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<IntegratedPhoneCallStatusTypesEnum>;
};

/** update columns of table "integrated_phone_call_statuses" */
export type IntegratedPhoneCallStatusesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'integratedPhoneCallStatusGuid'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'status';

export type IntegratedPhoneCallStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneCallStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneCallStatusesBoolExp;
};

/** columns and relationships of "integrated_phone_calls" */
export type IntegratedPhoneCalls = {
  __typename?: 'IntegratedPhoneCalls';
  /** An object relationship */
  account?: Maybe<Accounts>;
  accountGuid?: Maybe<Scalars['uuid']>;
  answeredAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  completedAt?: Maybe<Scalars['timestamptz']>;
  completedByUserGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contact?: Maybe<Contacts>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  direction: Scalars['String'];
  endedAt?: Maybe<Scalars['timestamptz']>;
  externalCallId: Scalars['String'];
  fromPhoneNumber: Scalars['String'];
  /** An object relationship */
  integratedChannel?: Maybe<IntegratedChannels>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  integratedPhone: IntegratedPhones;
  /** An array relationship */
  integratedPhoneCallDismissals: Array<IntegratedPhoneCallDismissals>;
  /** An aggregate relationship */
  integratedPhoneCallDismissalsAggregate: IntegratedPhoneCallDismissalsAggregate;
  integratedPhoneCallGuid: Scalars['uuid'];
  /** An array relationship */
  integratedPhoneCallJobs: Array<IntegratedPhoneCallJobs>;
  /** An aggregate relationship */
  integratedPhoneCallJobsAggregate: IntegratedPhoneCallJobsAggregate;
  /** An object relationship */
  integratedPhoneCallRecording?: Maybe<IntegratedPhoneCallRecording>;
  /** An array relationship */
  integratedPhoneCallStatuses: Array<IntegratedPhoneCallStatuses>;
  /** An aggregate relationship */
  integratedPhoneCallStatusesAggregate: IntegratedPhoneCallStatusesAggregate;
  integratedPhoneGuid: Scalars['uuid'];
  /** An array relationship */
  integratedPhoneMissedCalls: Array<IntegratedPhoneMissedCalls>;
  /** An aggregate relationship */
  integratedPhoneMissedCallsAggregate: IntegratedPhoneMissedCallsAggregate;
  startedAt: Scalars['timestamptz'];
  toPhoneNumber: Scalars['String'];
  /** An object relationship */
  user?: Maybe<Users>;
  userGuid?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "integrated_phone_calls" */
export type IntegratedPhoneCallsIntegratedPhoneCallDismissalsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallDismissalsBoolExp>;
};


/** columns and relationships of "integrated_phone_calls" */
export type IntegratedPhoneCallsIntegratedPhoneCallDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallDismissalsBoolExp>;
};


/** columns and relationships of "integrated_phone_calls" */
export type IntegratedPhoneCallsIntegratedPhoneCallJobsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallJobsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
};


/** columns and relationships of "integrated_phone_calls" */
export type IntegratedPhoneCallsIntegratedPhoneCallJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallJobsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
};


/** columns and relationships of "integrated_phone_calls" */
export type IntegratedPhoneCallsIntegratedPhoneCallStatusesArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallStatusesOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallStatusesBoolExp>;
};


/** columns and relationships of "integrated_phone_calls" */
export type IntegratedPhoneCallsIntegratedPhoneCallStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallStatusesOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallStatusesBoolExp>;
};


/** columns and relationships of "integrated_phone_calls" */
export type IntegratedPhoneCallsIntegratedPhoneMissedCallsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneMissedCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneMissedCallsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
};


/** columns and relationships of "integrated_phone_calls" */
export type IntegratedPhoneCallsIntegratedPhoneMissedCallsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneMissedCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneMissedCallsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
};

/** aggregated selection of "integrated_phone_calls" */
export type IntegratedPhoneCallsAggregate = {
  __typename?: 'IntegratedPhoneCallsAggregate';
  aggregate?: Maybe<IntegratedPhoneCallsAggregateFields>;
  nodes: Array<IntegratedPhoneCalls>;
};

export type IntegratedPhoneCallsAggregateBoolExp = {
  count?: InputMaybe<IntegratedPhoneCallsAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_phone_calls" */
export type IntegratedPhoneCallsAggregateFields = {
  __typename?: 'IntegratedPhoneCallsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneCallsMaxFields>;
  min?: Maybe<IntegratedPhoneCallsMinFields>;
};


/** aggregate fields of "integrated_phone_calls" */
export type IntegratedPhoneCallsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneCallsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_phone_calls" */
export type IntegratedPhoneCallsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedPhoneCallsMaxOrderBy>;
  min?: InputMaybe<IntegratedPhoneCallsMinOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_phone_calls" */
export type IntegratedPhoneCallsArrRelInsertInput = {
  data: Array<IntegratedPhoneCallsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneCallsOnConflict>;
};

/** Boolean expression to filter rows from the table "integrated_phone_calls". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneCallsBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneCallsBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneCallsBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneCallsBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  answeredAt?: InputMaybe<TimestamptzComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  completedByUserGuid?: InputMaybe<UuidComparisonExp>;
  contact?: InputMaybe<ContactsBoolExp>;
  contactGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  direction?: InputMaybe<StringComparisonExp>;
  endedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalCallId?: InputMaybe<StringComparisonExp>;
  fromPhoneNumber?: InputMaybe<StringComparisonExp>;
  integratedChannel?: InputMaybe<IntegratedChannelsBoolExp>;
  integratedChannelGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhone?: InputMaybe<IntegratedPhonesBoolExp>;
  integratedPhoneCallDismissals?: InputMaybe<IntegratedPhoneCallDismissalsBoolExp>;
  integratedPhoneCallDismissalsAggregate?: InputMaybe<IntegratedPhoneCallDismissalsAggregateBoolExp>;
  integratedPhoneCallGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneCallJobs?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
  integratedPhoneCallJobsAggregate?: InputMaybe<IntegratedPhoneCallJobsAggregateBoolExp>;
  integratedPhoneCallRecording?: InputMaybe<IntegratedPhoneCallRecordingBoolExp>;
  integratedPhoneCallStatuses?: InputMaybe<IntegratedPhoneCallStatusesBoolExp>;
  integratedPhoneCallStatusesAggregate?: InputMaybe<IntegratedPhoneCallStatusesAggregateBoolExp>;
  integratedPhoneGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneMissedCalls?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
  integratedPhoneMissedCallsAggregate?: InputMaybe<IntegratedPhoneMissedCallsAggregateBoolExp>;
  startedAt?: InputMaybe<TimestamptzComparisonExp>;
  toPhoneNumber?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phone_calls" */
export type IntegratedPhoneCallsConstraint =
  /** unique or primary key constraint on columns "external_call_id" */
  | 'integrated_phone_calls_external_call_id_key'
  /** unique or primary key constraint on columns "integrated_phone_call_guid" */
  | 'integrated_phone_calls_pkey';

/** input type for inserting data into table "integrated_phone_calls" */
export type IntegratedPhoneCallsInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  answeredAt?: InputMaybe<Scalars['timestamptz']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  completedByUserGuid?: InputMaybe<Scalars['uuid']>;
  contact?: InputMaybe<ContactsObjRelInsertInput>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  direction?: InputMaybe<Scalars['String']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  externalCallId?: InputMaybe<Scalars['String']>;
  fromPhoneNumber?: InputMaybe<Scalars['String']>;
  integratedChannel?: InputMaybe<IntegratedChannelsObjRelInsertInput>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhone?: InputMaybe<IntegratedPhonesObjRelInsertInput>;
  integratedPhoneCallDismissals?: InputMaybe<IntegratedPhoneCallDismissalsArrRelInsertInput>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallJobs?: InputMaybe<IntegratedPhoneCallJobsArrRelInsertInput>;
  integratedPhoneCallRecording?: InputMaybe<IntegratedPhoneCallRecordingObjRelInsertInput>;
  integratedPhoneCallStatuses?: InputMaybe<IntegratedPhoneCallStatusesArrRelInsertInput>;
  integratedPhoneGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneMissedCalls?: InputMaybe<IntegratedPhoneMissedCallsArrRelInsertInput>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  toPhoneNumber?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type IntegratedPhoneCallsMaxFields = {
  __typename?: 'IntegratedPhoneCallsMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  answeredAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  completedByUserGuid?: Maybe<Scalars['uuid']>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  direction?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['timestamptz']>;
  externalCallId?: Maybe<Scalars['String']>;
  fromPhoneNumber?: Maybe<Scalars['String']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneGuid?: Maybe<Scalars['uuid']>;
  startedAt?: Maybe<Scalars['timestamptz']>;
  toPhoneNumber?: Maybe<Scalars['String']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "integrated_phone_calls" */
export type IntegratedPhoneCallsMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  answeredAt?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  completedByUserGuid?: InputMaybe<OrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  externalCallId?: InputMaybe<OrderBy>;
  fromPhoneNumber?: InputMaybe<OrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneGuid?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  toPhoneNumber?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedPhoneCallsMinFields = {
  __typename?: 'IntegratedPhoneCallsMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  answeredAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  completedByUserGuid?: Maybe<Scalars['uuid']>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  direction?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['timestamptz']>;
  externalCallId?: Maybe<Scalars['String']>;
  fromPhoneNumber?: Maybe<Scalars['String']>;
  integratedChannelGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneGuid?: Maybe<Scalars['uuid']>;
  startedAt?: Maybe<Scalars['timestamptz']>;
  toPhoneNumber?: Maybe<Scalars['String']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "integrated_phone_calls" */
export type IntegratedPhoneCallsMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  answeredAt?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  completedByUserGuid?: InputMaybe<OrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  externalCallId?: InputMaybe<OrderBy>;
  fromPhoneNumber?: InputMaybe<OrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneGuid?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  toPhoneNumber?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "integrated_phone_calls" */
export type IntegratedPhoneCallsMutationResponse = {
  __typename?: 'IntegratedPhoneCallsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneCalls>;
};

/** input type for inserting object relation for remote table "integrated_phone_calls" */
export type IntegratedPhoneCallsObjRelInsertInput = {
  data: IntegratedPhoneCallsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneCallsOnConflict>;
};

/** on_conflict condition type for table "integrated_phone_calls" */
export type IntegratedPhoneCallsOnConflict = {
  constraint: IntegratedPhoneCallsConstraint;
  updateColumns?: Array<IntegratedPhoneCallsUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneCallsBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_calls". */
export type IntegratedPhoneCallsOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  answeredAt?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  completedByUserGuid?: InputMaybe<OrderBy>;
  contact?: InputMaybe<ContactsOrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  externalCallId?: InputMaybe<OrderBy>;
  fromPhoneNumber?: InputMaybe<OrderBy>;
  integratedChannel?: InputMaybe<IntegratedChannelsOrderBy>;
  integratedChannelGuid?: InputMaybe<OrderBy>;
  integratedPhone?: InputMaybe<IntegratedPhonesOrderBy>;
  integratedPhoneCallDismissalsAggregate?: InputMaybe<IntegratedPhoneCallDismissalsAggregateOrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneCallJobsAggregate?: InputMaybe<IntegratedPhoneCallJobsAggregateOrderBy>;
  integratedPhoneCallRecording?: InputMaybe<IntegratedPhoneCallRecordingOrderBy>;
  integratedPhoneCallStatusesAggregate?: InputMaybe<IntegratedPhoneCallStatusesAggregateOrderBy>;
  integratedPhoneGuid?: InputMaybe<OrderBy>;
  integratedPhoneMissedCallsAggregate?: InputMaybe<IntegratedPhoneMissedCallsAggregateOrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  toPhoneNumber?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phone_calls */
export type IntegratedPhoneCallsPkColumnsInput = {
  integratedPhoneCallGuid: Scalars['uuid'];
};

/** select columns of table "integrated_phone_calls" */
export type IntegratedPhoneCallsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'answeredAt'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'completedAt'
  /** column name */
  | 'completedByUserGuid'
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'direction'
  /** column name */
  | 'endedAt'
  /** column name */
  | 'externalCallId'
  /** column name */
  | 'fromPhoneNumber'
  /** column name */
  | 'integratedChannelGuid'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'integratedPhoneGuid'
  /** column name */
  | 'startedAt'
  /** column name */
  | 'toPhoneNumber'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "integrated_phone_calls" */
export type IntegratedPhoneCallsSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  answeredAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  completedByUserGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  direction?: InputMaybe<Scalars['String']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  externalCallId?: InputMaybe<Scalars['String']>;
  fromPhoneNumber?: InputMaybe<Scalars['String']>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneGuid?: InputMaybe<Scalars['uuid']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  toPhoneNumber?: InputMaybe<Scalars['String']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "integrated_phone_calls" */
export type IntegratedPhoneCallsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneCallsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneCallsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  answeredAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  completedByUserGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  direction?: InputMaybe<Scalars['String']>;
  endedAt?: InputMaybe<Scalars['timestamptz']>;
  externalCallId?: InputMaybe<Scalars['String']>;
  fromPhoneNumber?: InputMaybe<Scalars['String']>;
  integratedChannelGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneGuid?: InputMaybe<Scalars['uuid']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  toPhoneNumber?: InputMaybe<Scalars['String']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "integrated_phone_calls" */
export type IntegratedPhoneCallsUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'answeredAt'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'completedAt'
  /** column name */
  | 'completedByUserGuid'
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'direction'
  /** column name */
  | 'endedAt'
  /** column name */
  | 'externalCallId'
  /** column name */
  | 'fromPhoneNumber'
  /** column name */
  | 'integratedChannelGuid'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'integratedPhoneGuid'
  /** column name */
  | 'startedAt'
  /** column name */
  | 'toPhoneNumber'
  /** column name */
  | 'userGuid';

export type IntegratedPhoneCallsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneCallsSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneCallsBoolExp;
};

/** columns and relationships of "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfig = {
  __typename?: 'IntegratedPhoneCompanyConfig';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  fallbackForwardToPhoneNumber?: Maybe<Scalars['String']>;
  fallbackHangupMessage?: Maybe<Scalars['String']>;
  fallbackShouldRecordVoicemail?: Maybe<Scalars['Boolean']>;
  integratedPhoneCompanyConfigGuid: Scalars['uuid'];
  integratedPhoneEnabled: Scalars['Boolean'];
  integratedVoiceCallingEnabled: Scalars['Boolean'];
};

/** aggregated selection of "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfigAggregate = {
  __typename?: 'IntegratedPhoneCompanyConfigAggregate';
  aggregate?: Maybe<IntegratedPhoneCompanyConfigAggregateFields>;
  nodes: Array<IntegratedPhoneCompanyConfig>;
};

/** aggregate fields of "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfigAggregateFields = {
  __typename?: 'IntegratedPhoneCompanyConfigAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneCompanyConfigMaxFields>;
  min?: Maybe<IntegratedPhoneCompanyConfigMinFields>;
};


/** aggregate fields of "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneCompanyConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "integrated_phone_company_config". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneCompanyConfigBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneCompanyConfigBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneCompanyConfigBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneCompanyConfigBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  fallbackForwardToPhoneNumber?: InputMaybe<StringComparisonExp>;
  fallbackHangupMessage?: InputMaybe<StringComparisonExp>;
  fallbackShouldRecordVoicemail?: InputMaybe<BooleanComparisonExp>;
  integratedPhoneCompanyConfigGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneEnabled?: InputMaybe<BooleanComparisonExp>;
  integratedVoiceCallingEnabled?: InputMaybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfigConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'integrated_phone_company_config_company_guid_key'
  /** unique or primary key constraint on columns "integrated_phone_company_config_guid" */
  | 'integrated_phone_company_config_pkey';

/** input type for inserting data into table "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfigInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  fallbackForwardToPhoneNumber?: InputMaybe<Scalars['String']>;
  fallbackHangupMessage?: InputMaybe<Scalars['String']>;
  fallbackShouldRecordVoicemail?: InputMaybe<Scalars['Boolean']>;
  integratedPhoneCompanyConfigGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneEnabled?: InputMaybe<Scalars['Boolean']>;
  integratedVoiceCallingEnabled?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type IntegratedPhoneCompanyConfigMaxFields = {
  __typename?: 'IntegratedPhoneCompanyConfigMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  fallbackForwardToPhoneNumber?: Maybe<Scalars['String']>;
  fallbackHangupMessage?: Maybe<Scalars['String']>;
  integratedPhoneCompanyConfigGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type IntegratedPhoneCompanyConfigMinFields = {
  __typename?: 'IntegratedPhoneCompanyConfigMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  fallbackForwardToPhoneNumber?: Maybe<Scalars['String']>;
  fallbackHangupMessage?: Maybe<Scalars['String']>;
  integratedPhoneCompanyConfigGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfigMutationResponse = {
  __typename?: 'IntegratedPhoneCompanyConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneCompanyConfig>;
};

/** input type for inserting object relation for remote table "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfigObjRelInsertInput = {
  data: IntegratedPhoneCompanyConfigInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneCompanyConfigOnConflict>;
};

/** on_conflict condition type for table "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfigOnConflict = {
  constraint: IntegratedPhoneCompanyConfigConstraint;
  updateColumns?: Array<IntegratedPhoneCompanyConfigUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneCompanyConfigBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_company_config". */
export type IntegratedPhoneCompanyConfigOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  fallbackForwardToPhoneNumber?: InputMaybe<OrderBy>;
  fallbackHangupMessage?: InputMaybe<OrderBy>;
  fallbackShouldRecordVoicemail?: InputMaybe<OrderBy>;
  integratedPhoneCompanyConfigGuid?: InputMaybe<OrderBy>;
  integratedPhoneEnabled?: InputMaybe<OrderBy>;
  integratedVoiceCallingEnabled?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phone_company_config */
export type IntegratedPhoneCompanyConfigPkColumnsInput = {
  integratedPhoneCompanyConfigGuid: Scalars['uuid'];
};

/** select columns of table "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfigSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'fallbackForwardToPhoneNumber'
  /** column name */
  | 'fallbackHangupMessage'
  /** column name */
  | 'fallbackShouldRecordVoicemail'
  /** column name */
  | 'integratedPhoneCompanyConfigGuid'
  /** column name */
  | 'integratedPhoneEnabled'
  /** column name */
  | 'integratedVoiceCallingEnabled';

/** input type for updating data in table "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfigSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  fallbackForwardToPhoneNumber?: InputMaybe<Scalars['String']>;
  fallbackHangupMessage?: InputMaybe<Scalars['String']>;
  fallbackShouldRecordVoicemail?: InputMaybe<Scalars['Boolean']>;
  integratedPhoneCompanyConfigGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneEnabled?: InputMaybe<Scalars['Boolean']>;
  integratedVoiceCallingEnabled?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneCompanyConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneCompanyConfigStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  fallbackForwardToPhoneNumber?: InputMaybe<Scalars['String']>;
  fallbackHangupMessage?: InputMaybe<Scalars['String']>;
  fallbackShouldRecordVoicemail?: InputMaybe<Scalars['Boolean']>;
  integratedPhoneCompanyConfigGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneEnabled?: InputMaybe<Scalars['Boolean']>;
  integratedVoiceCallingEnabled?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "integrated_phone_company_config" */
export type IntegratedPhoneCompanyConfigUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'fallbackForwardToPhoneNumber'
  /** column name */
  | 'fallbackHangupMessage'
  /** column name */
  | 'fallbackShouldRecordVoicemail'
  /** column name */
  | 'integratedPhoneCompanyConfigGuid'
  /** column name */
  | 'integratedPhoneEnabled'
  /** column name */
  | 'integratedVoiceCallingEnabled';

export type IntegratedPhoneCompanyConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneCompanyConfigSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneCompanyConfigBoolExp;
};

/** columns and relationships of "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissals = {
  __typename?: 'IntegratedPhoneMissedCallDismissals';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  dismissedAt: Scalars['timestamptz'];
  /** An object relationship */
  integratedPhoneMissedCall: IntegratedPhoneMissedCalls;
  integratedPhoneMissedCallDismissal: Scalars['uuid'];
  integratedPhoneMissedCallGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsAggregate = {
  __typename?: 'IntegratedPhoneMissedCallDismissalsAggregate';
  aggregate?: Maybe<IntegratedPhoneMissedCallDismissalsAggregateFields>;
  nodes: Array<IntegratedPhoneMissedCallDismissals>;
};

export type IntegratedPhoneMissedCallDismissalsAggregateBoolExp = {
  count?: InputMaybe<IntegratedPhoneMissedCallDismissalsAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsAggregateFields = {
  __typename?: 'IntegratedPhoneMissedCallDismissalsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneMissedCallDismissalsMaxFields>;
  min?: Maybe<IntegratedPhoneMissedCallDismissalsMinFields>;
};


/** aggregate fields of "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedPhoneMissedCallDismissalsMaxOrderBy>;
  min?: InputMaybe<IntegratedPhoneMissedCallDismissalsMinOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsArrRelInsertInput = {
  data: Array<IntegratedPhoneMissedCallDismissalsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneMissedCallDismissalsOnConflict>;
};

/** Boolean expression to filter rows from the table "integrated_phone_missed_call_dismissals". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneMissedCallDismissalsBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneMissedCallDismissalsBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  dismissedAt?: InputMaybe<TimestamptzComparisonExp>;
  integratedPhoneMissedCall?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
  integratedPhoneMissedCallDismissal?: InputMaybe<UuidComparisonExp>;
  integratedPhoneMissedCallGuid?: InputMaybe<UuidComparisonExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsConstraint =
  /** unique or primary key constraint on columns "integrated_phone_missed_call_dismissal" */
  | 'integrated_phone_missed_call_dismissals_pkey';

/** input type for inserting data into table "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneMissedCall?: InputMaybe<IntegratedPhoneMissedCallsObjRelInsertInput>;
  integratedPhoneMissedCallDismissal?: InputMaybe<Scalars['uuid']>;
  integratedPhoneMissedCallGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type IntegratedPhoneMissedCallDismissalsMaxFields = {
  __typename?: 'IntegratedPhoneMissedCallDismissalsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  dismissedAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneMissedCallDismissal?: Maybe<Scalars['uuid']>;
  integratedPhoneMissedCallGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  integratedPhoneMissedCallDismissal?: InputMaybe<OrderBy>;
  integratedPhoneMissedCallGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedPhoneMissedCallDismissalsMinFields = {
  __typename?: 'IntegratedPhoneMissedCallDismissalsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  dismissedAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneMissedCallDismissal?: Maybe<Scalars['uuid']>;
  integratedPhoneMissedCallGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  integratedPhoneMissedCallDismissal?: InputMaybe<OrderBy>;
  integratedPhoneMissedCallGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsMutationResponse = {
  __typename?: 'IntegratedPhoneMissedCallDismissalsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneMissedCallDismissals>;
};

/** on_conflict condition type for table "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsOnConflict = {
  constraint: IntegratedPhoneMissedCallDismissalsConstraint;
  updateColumns?: Array<IntegratedPhoneMissedCallDismissalsUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneMissedCallDismissalsBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_missed_call_dismissals". */
export type IntegratedPhoneMissedCallDismissalsOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  integratedPhoneMissedCall?: InputMaybe<IntegratedPhoneMissedCallsOrderBy>;
  integratedPhoneMissedCallDismissal?: InputMaybe<OrderBy>;
  integratedPhoneMissedCallGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phone_missed_call_dismissals */
export type IntegratedPhoneMissedCallDismissalsPkColumnsInput = {
  integratedPhoneMissedCallDismissal: Scalars['uuid'];
};

/** select columns of table "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dismissedAt'
  /** column name */
  | 'integratedPhoneMissedCallDismissal'
  /** column name */
  | 'integratedPhoneMissedCallGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneMissedCallDismissal?: InputMaybe<Scalars['uuid']>;
  integratedPhoneMissedCallGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneMissedCallDismissalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneMissedCallDismissalsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneMissedCallDismissal?: InputMaybe<Scalars['uuid']>;
  integratedPhoneMissedCallGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "integrated_phone_missed_call_dismissals" */
export type IntegratedPhoneMissedCallDismissalsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dismissedAt'
  /** column name */
  | 'integratedPhoneMissedCallDismissal'
  /** column name */
  | 'integratedPhoneMissedCallGuid'
  /** column name */
  | 'userGuid';

export type IntegratedPhoneMissedCallDismissalsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneMissedCallDismissalsSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneMissedCallDismissalsBoolExp;
};

/** columns and relationships of "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCalls = {
  __typename?: 'IntegratedPhoneMissedCalls';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  fallbackStrategyUsed: Scalars['String'];
  /** An object relationship */
  integratedPhoneCall: IntegratedPhoneCalls;
  integratedPhoneCallGuid: Scalars['uuid'];
  /** An array relationship */
  integratedPhoneMissedCallDismissals: Array<IntegratedPhoneMissedCallDismissals>;
  /** An aggregate relationship */
  integratedPhoneMissedCallDismissalsAggregate: IntegratedPhoneMissedCallDismissalsAggregate;
  integratedPhoneMissedCallGuid: Scalars['uuid'];
  /** An array relationship */
  integratedPhoneVoicemails: Array<IntegratedPhoneVoicemails>;
  /** An aggregate relationship */
  integratedPhoneVoicemailsAggregate: IntegratedPhoneVoicemailsAggregate;
};


/** columns and relationships of "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsIntegratedPhoneMissedCallDismissalsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneMissedCallDismissalsBoolExp>;
};


/** columns and relationships of "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsIntegratedPhoneMissedCallDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneMissedCallDismissalsBoolExp>;
};


/** columns and relationships of "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsIntegratedPhoneVoicemailsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneVoicemailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneVoicemailsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneVoicemailsBoolExp>;
};


/** columns and relationships of "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsIntegratedPhoneVoicemailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneVoicemailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneVoicemailsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneVoicemailsBoolExp>;
};

/** aggregated selection of "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsAggregate = {
  __typename?: 'IntegratedPhoneMissedCallsAggregate';
  aggregate?: Maybe<IntegratedPhoneMissedCallsAggregateFields>;
  nodes: Array<IntegratedPhoneMissedCalls>;
};

export type IntegratedPhoneMissedCallsAggregateBoolExp = {
  count?: InputMaybe<IntegratedPhoneMissedCallsAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsAggregateFields = {
  __typename?: 'IntegratedPhoneMissedCallsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneMissedCallsMaxFields>;
  min?: Maybe<IntegratedPhoneMissedCallsMinFields>;
};


/** aggregate fields of "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneMissedCallsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedPhoneMissedCallsMaxOrderBy>;
  min?: InputMaybe<IntegratedPhoneMissedCallsMinOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsArrRelInsertInput = {
  data: Array<IntegratedPhoneMissedCallsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneMissedCallsOnConflict>;
};

/** Boolean expression to filter rows from the table "integrated_phone_missed_calls". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneMissedCallsBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneMissedCallsBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneMissedCallsBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  fallbackStrategyUsed?: InputMaybe<StringComparisonExp>;
  integratedPhoneCall?: InputMaybe<IntegratedPhoneCallsBoolExp>;
  integratedPhoneCallGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneMissedCallDismissals?: InputMaybe<IntegratedPhoneMissedCallDismissalsBoolExp>;
  integratedPhoneMissedCallDismissalsAggregate?: InputMaybe<IntegratedPhoneMissedCallDismissalsAggregateBoolExp>;
  integratedPhoneMissedCallGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneVoicemails?: InputMaybe<IntegratedPhoneVoicemailsBoolExp>;
  integratedPhoneVoicemailsAggregate?: InputMaybe<IntegratedPhoneVoicemailsAggregateBoolExp>;
};

/** unique or primary key constraints on table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsConstraint =
  /** unique or primary key constraint on columns "integrated_phone_missed_call_guid" */
  | 'integrated_phone_missed_calls_pkey';

/** input type for inserting data into table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fallbackStrategyUsed?: InputMaybe<Scalars['String']>;
  integratedPhoneCall?: InputMaybe<IntegratedPhoneCallsObjRelInsertInput>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneMissedCallDismissals?: InputMaybe<IntegratedPhoneMissedCallDismissalsArrRelInsertInput>;
  integratedPhoneMissedCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneVoicemails?: InputMaybe<IntegratedPhoneVoicemailsArrRelInsertInput>;
};

/** aggregate max on columns */
export type IntegratedPhoneMissedCallsMaxFields = {
  __typename?: 'IntegratedPhoneMissedCallsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fallbackStrategyUsed?: Maybe<Scalars['String']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneMissedCallGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fallbackStrategyUsed?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneMissedCallGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedPhoneMissedCallsMinFields = {
  __typename?: 'IntegratedPhoneMissedCallsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  fallbackStrategyUsed?: Maybe<Scalars['String']>;
  integratedPhoneCallGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneMissedCallGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fallbackStrategyUsed?: InputMaybe<OrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneMissedCallGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsMutationResponse = {
  __typename?: 'IntegratedPhoneMissedCallsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneMissedCalls>;
};

/** input type for inserting object relation for remote table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsObjRelInsertInput = {
  data: IntegratedPhoneMissedCallsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneMissedCallsOnConflict>;
};

/** on_conflict condition type for table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsOnConflict = {
  constraint: IntegratedPhoneMissedCallsConstraint;
  updateColumns?: Array<IntegratedPhoneMissedCallsUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_missed_calls". */
export type IntegratedPhoneMissedCallsOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fallbackStrategyUsed?: InputMaybe<OrderBy>;
  integratedPhoneCall?: InputMaybe<IntegratedPhoneCallsOrderBy>;
  integratedPhoneCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneMissedCallDismissalsAggregate?: InputMaybe<IntegratedPhoneMissedCallDismissalsAggregateOrderBy>;
  integratedPhoneMissedCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneVoicemailsAggregate?: InputMaybe<IntegratedPhoneVoicemailsAggregateOrderBy>;
};

/** primary key columns input for table: integrated_phone_missed_calls */
export type IntegratedPhoneMissedCallsPkColumnsInput = {
  integratedPhoneMissedCallGuid: Scalars['uuid'];
};

/** select columns of table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'fallbackStrategyUsed'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'integratedPhoneMissedCallGuid';

/** input type for updating data in table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fallbackStrategyUsed?: InputMaybe<Scalars['String']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneMissedCallGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneMissedCallsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneMissedCallsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fallbackStrategyUsed?: InputMaybe<Scalars['String']>;
  integratedPhoneCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneMissedCallGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "integrated_phone_missed_calls" */
export type IntegratedPhoneMissedCallsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'fallbackStrategyUsed'
  /** column name */
  | 'integratedPhoneCallGuid'
  /** column name */
  | 'integratedPhoneMissedCallGuid';

export type IntegratedPhoneMissedCallsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneMissedCallsSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneMissedCallsBoolExp;
};

/** columns and relationships of "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEvents = {
  __typename?: 'IntegratedPhoneTwilioRawWebhookEvents';
  createdAt: Scalars['timestamptz'];
  endpoint: Scalars['String'];
  integratedPhoneTwilioRawWebhookEventGuid: Scalars['uuid'];
  rawWebhookJson: Scalars['jsonb'];
};


/** columns and relationships of "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEventsRawWebhookJsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEventsAggregate = {
  __typename?: 'IntegratedPhoneTwilioRawWebhookEventsAggregate';
  aggregate?: Maybe<IntegratedPhoneTwilioRawWebhookEventsAggregateFields>;
  nodes: Array<IntegratedPhoneTwilioRawWebhookEvents>;
};

/** aggregate fields of "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEventsAggregateFields = {
  __typename?: 'IntegratedPhoneTwilioRawWebhookEventsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneTwilioRawWebhookEventsMaxFields>;
  min?: Maybe<IntegratedPhoneTwilioRawWebhookEventsMinFields>;
};


/** aggregate fields of "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEventsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneTwilioRawWebhookEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type IntegratedPhoneTwilioRawWebhookEventsAppendInput = {
  rawWebhookJson?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "integrated_phone_twilio_raw_webhook_events". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneTwilioRawWebhookEventsBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneTwilioRawWebhookEventsBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneTwilioRawWebhookEventsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  endpoint?: InputMaybe<StringComparisonExp>;
  integratedPhoneTwilioRawWebhookEventGuid?: InputMaybe<UuidComparisonExp>;
  rawWebhookJson?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEventsConstraint =
  /** unique or primary key constraint on columns "integrated_phone_twilio_raw_webhook_event_guid" */
  | 'integrated_phone_twilio_raw_webhook_events_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type IntegratedPhoneTwilioRawWebhookEventsDeleteAtPathInput = {
  rawWebhookJson?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type IntegratedPhoneTwilioRawWebhookEventsDeleteElemInput = {
  rawWebhookJson?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type IntegratedPhoneTwilioRawWebhookEventsDeleteKeyInput = {
  rawWebhookJson?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEventsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endpoint?: InputMaybe<Scalars['String']>;
  integratedPhoneTwilioRawWebhookEventGuid?: InputMaybe<Scalars['uuid']>;
  rawWebhookJson?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type IntegratedPhoneTwilioRawWebhookEventsMaxFields = {
  __typename?: 'IntegratedPhoneTwilioRawWebhookEventsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  endpoint?: Maybe<Scalars['String']>;
  integratedPhoneTwilioRawWebhookEventGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type IntegratedPhoneTwilioRawWebhookEventsMinFields = {
  __typename?: 'IntegratedPhoneTwilioRawWebhookEventsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  endpoint?: Maybe<Scalars['String']>;
  integratedPhoneTwilioRawWebhookEventGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEventsMutationResponse = {
  __typename?: 'IntegratedPhoneTwilioRawWebhookEventsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneTwilioRawWebhookEvents>;
};

/** on_conflict condition type for table "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEventsOnConflict = {
  constraint: IntegratedPhoneTwilioRawWebhookEventsConstraint;
  updateColumns?: Array<IntegratedPhoneTwilioRawWebhookEventsUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_twilio_raw_webhook_events". */
export type IntegratedPhoneTwilioRawWebhookEventsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  endpoint?: InputMaybe<OrderBy>;
  integratedPhoneTwilioRawWebhookEventGuid?: InputMaybe<OrderBy>;
  rawWebhookJson?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phone_twilio_raw_webhook_events */
export type IntegratedPhoneTwilioRawWebhookEventsPkColumnsInput = {
  integratedPhoneTwilioRawWebhookEventGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type IntegratedPhoneTwilioRawWebhookEventsPrependInput = {
  rawWebhookJson?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEventsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'endpoint'
  /** column name */
  | 'integratedPhoneTwilioRawWebhookEventGuid'
  /** column name */
  | 'rawWebhookJson';

/** input type for updating data in table "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEventsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endpoint?: InputMaybe<Scalars['String']>;
  integratedPhoneTwilioRawWebhookEventGuid?: InputMaybe<Scalars['uuid']>;
  rawWebhookJson?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneTwilioRawWebhookEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneTwilioRawWebhookEventsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  endpoint?: InputMaybe<Scalars['String']>;
  integratedPhoneTwilioRawWebhookEventGuid?: InputMaybe<Scalars['uuid']>;
  rawWebhookJson?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "integrated_phone_twilio_raw_webhook_events" */
export type IntegratedPhoneTwilioRawWebhookEventsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'endpoint'
  /** column name */
  | 'integratedPhoneTwilioRawWebhookEventGuid'
  /** column name */
  | 'rawWebhookJson';

export type IntegratedPhoneTwilioRawWebhookEventsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneTwilioRawWebhookEventsBoolExp;
};

/** columns and relationships of "integrated_phone_users" */
export type IntegratedPhoneUsers = {
  __typename?: 'IntegratedPhoneUsers';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  identity: Scalars['String'];
  integratedPhoneUserGuid: Scalars['uuid'];
  isAvailable: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "integrated_phone_users" */
export type IntegratedPhoneUsersAggregate = {
  __typename?: 'IntegratedPhoneUsersAggregate';
  aggregate?: Maybe<IntegratedPhoneUsersAggregateFields>;
  nodes: Array<IntegratedPhoneUsers>;
};

export type IntegratedPhoneUsersAggregateBoolExp = {
  bool_and?: InputMaybe<IntegratedPhoneUsersAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<IntegratedPhoneUsersAggregateBoolExpBool_Or>;
  count?: InputMaybe<IntegratedPhoneUsersAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_phone_users" */
export type IntegratedPhoneUsersAggregateFields = {
  __typename?: 'IntegratedPhoneUsersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneUsersMaxFields>;
  min?: Maybe<IntegratedPhoneUsersMinFields>;
};


/** aggregate fields of "integrated_phone_users" */
export type IntegratedPhoneUsersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_phone_users" */
export type IntegratedPhoneUsersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedPhoneUsersMaxOrderBy>;
  min?: InputMaybe<IntegratedPhoneUsersMinOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_phone_users" */
export type IntegratedPhoneUsersArrRelInsertInput = {
  data: Array<IntegratedPhoneUsersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "integrated_phone_users". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneUsersBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneUsersBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneUsersBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneUsersBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  identity?: InputMaybe<StringComparisonExp>;
  integratedPhoneUserGuid?: InputMaybe<UuidComparisonExp>;
  isAvailable?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phone_users" */
export type IntegratedPhoneUsersConstraint =
  /** unique or primary key constraint on columns "user_guid", "company_guid" */
  | 'integrated_phone_users_company_guid_user_guid_key'
  /** unique or primary key constraint on columns "integrated_phone_user_guid" */
  | 'integrated_phone_users_pkey';

/** input type for inserting data into table "integrated_phone_users" */
export type IntegratedPhoneUsersInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Scalars['String']>;
  integratedPhoneUserGuid?: InputMaybe<Scalars['uuid']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type IntegratedPhoneUsersMaxFields = {
  __typename?: 'IntegratedPhoneUsersMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  identity?: Maybe<Scalars['String']>;
  integratedPhoneUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "integrated_phone_users" */
export type IntegratedPhoneUsersMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  identity?: InputMaybe<OrderBy>;
  integratedPhoneUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedPhoneUsersMinFields = {
  __typename?: 'IntegratedPhoneUsersMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  identity?: Maybe<Scalars['String']>;
  integratedPhoneUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "integrated_phone_users" */
export type IntegratedPhoneUsersMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  identity?: InputMaybe<OrderBy>;
  integratedPhoneUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "integrated_phone_users" */
export type IntegratedPhoneUsersMutationResponse = {
  __typename?: 'IntegratedPhoneUsersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneUsers>;
};

/** on_conflict condition type for table "integrated_phone_users" */
export type IntegratedPhoneUsersOnConflict = {
  constraint: IntegratedPhoneUsersConstraint;
  updateColumns?: Array<IntegratedPhoneUsersUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneUsersBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_users". */
export type IntegratedPhoneUsersOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  identity?: InputMaybe<OrderBy>;
  integratedPhoneUserGuid?: InputMaybe<OrderBy>;
  isAvailable?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phone_users */
export type IntegratedPhoneUsersPkColumnsInput = {
  integratedPhoneUserGuid: Scalars['uuid'];
};

/** select columns of table "integrated_phone_users" */
export type IntegratedPhoneUsersSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'identity'
  /** column name */
  | 'integratedPhoneUserGuid'
  /** column name */
  | 'isAvailable'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userGuid';

/** select "integratedPhoneUsersAggregateBoolExpBool_andArgumentsColumns" columns of table "integrated_phone_users" */
export type IntegratedPhoneUsersSelectColumnIntegratedPhoneUsersAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isAvailable';

/** select "integratedPhoneUsersAggregateBoolExpBool_orArgumentsColumns" columns of table "integrated_phone_users" */
export type IntegratedPhoneUsersSelectColumnIntegratedPhoneUsersAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isAvailable';

/** input type for updating data in table "integrated_phone_users" */
export type IntegratedPhoneUsersSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Scalars['String']>;
  integratedPhoneUserGuid?: InputMaybe<Scalars['uuid']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "integrated_phone_users" */
export type IntegratedPhoneUsersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneUsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneUsersStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  identity?: InputMaybe<Scalars['String']>;
  integratedPhoneUserGuid?: InputMaybe<Scalars['uuid']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "integrated_phone_users" */
export type IntegratedPhoneUsersUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'identity'
  /** column name */
  | 'integratedPhoneUserGuid'
  /** column name */
  | 'isAvailable'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userGuid';

export type IntegratedPhoneUsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneUsersSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneUsersBoolExp;
};

/** columns and relationships of "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissals = {
  __typename?: 'IntegratedPhoneVoicemailDismissals';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  dismissedAt: Scalars['timestamptz'];
  /** An object relationship */
  integratedPhoneVoicemail: IntegratedPhoneVoicemails;
  integratedPhoneVoicemailDismissal: Scalars['uuid'];
  integratedPhoneVoicemailGuid: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsAggregate = {
  __typename?: 'IntegratedPhoneVoicemailDismissalsAggregate';
  aggregate?: Maybe<IntegratedPhoneVoicemailDismissalsAggregateFields>;
  nodes: Array<IntegratedPhoneVoicemailDismissals>;
};

export type IntegratedPhoneVoicemailDismissalsAggregateBoolExp = {
  count?: InputMaybe<IntegratedPhoneVoicemailDismissalsAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsAggregateFields = {
  __typename?: 'IntegratedPhoneVoicemailDismissalsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneVoicemailDismissalsMaxFields>;
  min?: Maybe<IntegratedPhoneVoicemailDismissalsMinFields>;
};


/** aggregate fields of "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedPhoneVoicemailDismissalsMaxOrderBy>;
  min?: InputMaybe<IntegratedPhoneVoicemailDismissalsMinOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsArrRelInsertInput = {
  data: Array<IntegratedPhoneVoicemailDismissalsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneVoicemailDismissalsOnConflict>;
};

/** Boolean expression to filter rows from the table "integrated_phone_voicemail_dismissals". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneVoicemailDismissalsBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneVoicemailDismissalsBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  dismissedAt?: InputMaybe<TimestamptzComparisonExp>;
  integratedPhoneVoicemail?: InputMaybe<IntegratedPhoneVoicemailsBoolExp>;
  integratedPhoneVoicemailDismissal?: InputMaybe<UuidComparisonExp>;
  integratedPhoneVoicemailGuid?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsConstraint =
  /** unique or primary key constraint on columns "integrated_phone_voicemail_dismissal" */
  | 'integrated_phone_voicemail_dismissals_pkey';

/** input type for inserting data into table "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneVoicemail?: InputMaybe<IntegratedPhoneVoicemailsObjRelInsertInput>;
  integratedPhoneVoicemailDismissal?: InputMaybe<Scalars['uuid']>;
  integratedPhoneVoicemailGuid?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type IntegratedPhoneVoicemailDismissalsMaxFields = {
  __typename?: 'IntegratedPhoneVoicemailDismissalsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  dismissedAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneVoicemailDismissal?: Maybe<Scalars['uuid']>;
  integratedPhoneVoicemailGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  integratedPhoneVoicemailDismissal?: InputMaybe<OrderBy>;
  integratedPhoneVoicemailGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedPhoneVoicemailDismissalsMinFields = {
  __typename?: 'IntegratedPhoneVoicemailDismissalsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  dismissedAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneVoicemailDismissal?: Maybe<Scalars['uuid']>;
  integratedPhoneVoicemailGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  integratedPhoneVoicemailDismissal?: InputMaybe<OrderBy>;
  integratedPhoneVoicemailGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsMutationResponse = {
  __typename?: 'IntegratedPhoneVoicemailDismissalsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneVoicemailDismissals>;
};

/** on_conflict condition type for table "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsOnConflict = {
  constraint: IntegratedPhoneVoicemailDismissalsConstraint;
  updateColumns?: Array<IntegratedPhoneVoicemailDismissalsUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneVoicemailDismissalsBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_voicemail_dismissals". */
export type IntegratedPhoneVoicemailDismissalsOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  integratedPhoneVoicemail?: InputMaybe<IntegratedPhoneVoicemailsOrderBy>;
  integratedPhoneVoicemailDismissal?: InputMaybe<OrderBy>;
  integratedPhoneVoicemailGuid?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phone_voicemail_dismissals */
export type IntegratedPhoneVoicemailDismissalsPkColumnsInput = {
  integratedPhoneVoicemailDismissal: Scalars['uuid'];
};

/** select columns of table "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dismissedAt'
  /** column name */
  | 'integratedPhoneVoicemailDismissal'
  /** column name */
  | 'integratedPhoneVoicemailGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneVoicemailDismissal?: InputMaybe<Scalars['uuid']>;
  integratedPhoneVoicemailGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneVoicemailDismissalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneVoicemailDismissalsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneVoicemailDismissal?: InputMaybe<Scalars['uuid']>;
  integratedPhoneVoicemailGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "integrated_phone_voicemail_dismissals" */
export type IntegratedPhoneVoicemailDismissalsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dismissedAt'
  /** column name */
  | 'integratedPhoneVoicemailDismissal'
  /** column name */
  | 'integratedPhoneVoicemailGuid'
  /** column name */
  | 'userGuid';

export type IntegratedPhoneVoicemailDismissalsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneVoicemailDismissalsSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneVoicemailDismissalsBoolExp;
};

/** columns and relationships of "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemails = {
  __typename?: 'IntegratedPhoneVoicemails';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  integratedPhoneMissedCall: IntegratedPhoneMissedCalls;
  integratedPhoneMissedCallGuid: Scalars['uuid'];
  /** An array relationship */
  integratedPhoneVoicemailDismissals: Array<IntegratedPhoneVoicemailDismissals>;
  /** An aggregate relationship */
  integratedPhoneVoicemailDismissalsAggregate: IntegratedPhoneVoicemailDismissalsAggregate;
  integratedPhoneVoicemailGuid: Scalars['uuid'];
  recordingDurationSeconds: Scalars['Int'];
  recordingSummary?: Maybe<Scalars['String']>;
  recordingTranscript?: Maybe<Scalars['String']>;
  recordingUrl: Scalars['String'];
};


/** columns and relationships of "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsIntegratedPhoneVoicemailDismissalsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneVoicemailDismissalsBoolExp>;
};


/** columns and relationships of "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsIntegratedPhoneVoicemailDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneVoicemailDismissalsBoolExp>;
};

/** aggregated selection of "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsAggregate = {
  __typename?: 'IntegratedPhoneVoicemailsAggregate';
  aggregate?: Maybe<IntegratedPhoneVoicemailsAggregateFields>;
  nodes: Array<IntegratedPhoneVoicemails>;
};

export type IntegratedPhoneVoicemailsAggregateBoolExp = {
  count?: InputMaybe<IntegratedPhoneVoicemailsAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsAggregateFields = {
  __typename?: 'IntegratedPhoneVoicemailsAggregateFields';
  avg?: Maybe<IntegratedPhoneVoicemailsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhoneVoicemailsMaxFields>;
  min?: Maybe<IntegratedPhoneVoicemailsMinFields>;
  stddev?: Maybe<IntegratedPhoneVoicemailsStddevFields>;
  stddevPop?: Maybe<IntegratedPhoneVoicemailsStddevPopFields>;
  stddevSamp?: Maybe<IntegratedPhoneVoicemailsStddevSampFields>;
  sum?: Maybe<IntegratedPhoneVoicemailsSumFields>;
  varPop?: Maybe<IntegratedPhoneVoicemailsVarPopFields>;
  varSamp?: Maybe<IntegratedPhoneVoicemailsVarSampFields>;
  variance?: Maybe<IntegratedPhoneVoicemailsVarianceFields>;
};


/** aggregate fields of "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhoneVoicemailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsAggregateOrderBy = {
  avg?: InputMaybe<IntegratedPhoneVoicemailsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedPhoneVoicemailsMaxOrderBy>;
  min?: InputMaybe<IntegratedPhoneVoicemailsMinOrderBy>;
  stddev?: InputMaybe<IntegratedPhoneVoicemailsStddevOrderBy>;
  stddevPop?: InputMaybe<IntegratedPhoneVoicemailsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<IntegratedPhoneVoicemailsStddevSampOrderBy>;
  sum?: InputMaybe<IntegratedPhoneVoicemailsSumOrderBy>;
  varPop?: InputMaybe<IntegratedPhoneVoicemailsVarPopOrderBy>;
  varSamp?: InputMaybe<IntegratedPhoneVoicemailsVarSampOrderBy>;
  variance?: InputMaybe<IntegratedPhoneVoicemailsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsArrRelInsertInput = {
  data: Array<IntegratedPhoneVoicemailsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneVoicemailsOnConflict>;
};

/** aggregate avg on columns */
export type IntegratedPhoneVoicemailsAvgFields = {
  __typename?: 'IntegratedPhoneVoicemailsAvgFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsAvgOrderBy = {
  recordingDurationSeconds?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "integrated_phone_voicemails". All fields are combined with a logical 'AND'. */
export type IntegratedPhoneVoicemailsBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhoneVoicemailsBoolExp>>;
  _not?: InputMaybe<IntegratedPhoneVoicemailsBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhoneVoicemailsBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  integratedPhoneMissedCall?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
  integratedPhoneMissedCallGuid?: InputMaybe<UuidComparisonExp>;
  integratedPhoneVoicemailDismissals?: InputMaybe<IntegratedPhoneVoicemailDismissalsBoolExp>;
  integratedPhoneVoicemailDismissalsAggregate?: InputMaybe<IntegratedPhoneVoicemailDismissalsAggregateBoolExp>;
  integratedPhoneVoicemailGuid?: InputMaybe<UuidComparisonExp>;
  recordingDurationSeconds?: InputMaybe<IntComparisonExp>;
  recordingSummary?: InputMaybe<StringComparisonExp>;
  recordingTranscript?: InputMaybe<StringComparisonExp>;
  recordingUrl?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsConstraint =
  /** unique or primary key constraint on columns "integrated_phone_voicemail_guid" */
  | 'integrated_phone_voicemails_pkey';

/** input type for incrementing numeric columns in table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsIncInput = {
  recordingDurationSeconds?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneMissedCall?: InputMaybe<IntegratedPhoneMissedCallsObjRelInsertInput>;
  integratedPhoneMissedCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneVoicemailDismissals?: InputMaybe<IntegratedPhoneVoicemailDismissalsArrRelInsertInput>;
  integratedPhoneVoicemailGuid?: InputMaybe<Scalars['uuid']>;
  recordingDurationSeconds?: InputMaybe<Scalars['Int']>;
  recordingSummary?: InputMaybe<Scalars['String']>;
  recordingTranscript?: InputMaybe<Scalars['String']>;
  recordingUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type IntegratedPhoneVoicemailsMaxFields = {
  __typename?: 'IntegratedPhoneVoicemailsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneMissedCallGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneVoicemailGuid?: Maybe<Scalars['uuid']>;
  recordingDurationSeconds?: Maybe<Scalars['Int']>;
  recordingSummary?: Maybe<Scalars['String']>;
  recordingTranscript?: Maybe<Scalars['String']>;
  recordingUrl?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  integratedPhoneMissedCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneVoicemailGuid?: InputMaybe<OrderBy>;
  recordingDurationSeconds?: InputMaybe<OrderBy>;
  recordingSummary?: InputMaybe<OrderBy>;
  recordingTranscript?: InputMaybe<OrderBy>;
  recordingUrl?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedPhoneVoicemailsMinFields = {
  __typename?: 'IntegratedPhoneVoicemailsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneMissedCallGuid?: Maybe<Scalars['uuid']>;
  integratedPhoneVoicemailGuid?: Maybe<Scalars['uuid']>;
  recordingDurationSeconds?: Maybe<Scalars['Int']>;
  recordingSummary?: Maybe<Scalars['String']>;
  recordingTranscript?: Maybe<Scalars['String']>;
  recordingUrl?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  integratedPhoneMissedCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneVoicemailGuid?: InputMaybe<OrderBy>;
  recordingDurationSeconds?: InputMaybe<OrderBy>;
  recordingSummary?: InputMaybe<OrderBy>;
  recordingTranscript?: InputMaybe<OrderBy>;
  recordingUrl?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsMutationResponse = {
  __typename?: 'IntegratedPhoneVoicemailsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhoneVoicemails>;
};

/** input type for inserting object relation for remote table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsObjRelInsertInput = {
  data: IntegratedPhoneVoicemailsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhoneVoicemailsOnConflict>;
};

/** on_conflict condition type for table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsOnConflict = {
  constraint: IntegratedPhoneVoicemailsConstraint;
  updateColumns?: Array<IntegratedPhoneVoicemailsUpdateColumn>;
  where?: InputMaybe<IntegratedPhoneVoicemailsBoolExp>;
};

/** Ordering options when selecting data from "integrated_phone_voicemails". */
export type IntegratedPhoneVoicemailsOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  integratedPhoneMissedCall?: InputMaybe<IntegratedPhoneMissedCallsOrderBy>;
  integratedPhoneMissedCallGuid?: InputMaybe<OrderBy>;
  integratedPhoneVoicemailDismissalsAggregate?: InputMaybe<IntegratedPhoneVoicemailDismissalsAggregateOrderBy>;
  integratedPhoneVoicemailGuid?: InputMaybe<OrderBy>;
  recordingDurationSeconds?: InputMaybe<OrderBy>;
  recordingSummary?: InputMaybe<OrderBy>;
  recordingTranscript?: InputMaybe<OrderBy>;
  recordingUrl?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phone_voicemails */
export type IntegratedPhoneVoicemailsPkColumnsInput = {
  integratedPhoneVoicemailGuid: Scalars['uuid'];
};

/** select columns of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'integratedPhoneMissedCallGuid'
  /** column name */
  | 'integratedPhoneVoicemailGuid'
  /** column name */
  | 'recordingDurationSeconds'
  /** column name */
  | 'recordingSummary'
  /** column name */
  | 'recordingTranscript'
  /** column name */
  | 'recordingUrl';

/** input type for updating data in table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneMissedCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneVoicemailGuid?: InputMaybe<Scalars['uuid']>;
  recordingDurationSeconds?: InputMaybe<Scalars['Int']>;
  recordingSummary?: InputMaybe<Scalars['String']>;
  recordingTranscript?: InputMaybe<Scalars['String']>;
  recordingUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type IntegratedPhoneVoicemailsStddevFields = {
  __typename?: 'IntegratedPhoneVoicemailsStddevFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsStddevOrderBy = {
  recordingDurationSeconds?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type IntegratedPhoneVoicemailsStddevPopFields = {
  __typename?: 'IntegratedPhoneVoicemailsStddevPopFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsStddevPopOrderBy = {
  recordingDurationSeconds?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type IntegratedPhoneVoicemailsStddevSampFields = {
  __typename?: 'IntegratedPhoneVoicemailsStddevSampFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsStddevSampOrderBy = {
  recordingDurationSeconds?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhoneVoicemailsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhoneVoicemailsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneMissedCallGuid?: InputMaybe<Scalars['uuid']>;
  integratedPhoneVoicemailGuid?: InputMaybe<Scalars['uuid']>;
  recordingDurationSeconds?: InputMaybe<Scalars['Int']>;
  recordingSummary?: InputMaybe<Scalars['String']>;
  recordingTranscript?: InputMaybe<Scalars['String']>;
  recordingUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type IntegratedPhoneVoicemailsSumFields = {
  __typename?: 'IntegratedPhoneVoicemailsSumFields';
  recordingDurationSeconds?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsSumOrderBy = {
  recordingDurationSeconds?: InputMaybe<OrderBy>;
};

/** update columns of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'integratedPhoneMissedCallGuid'
  /** column name */
  | 'integratedPhoneVoicemailGuid'
  /** column name */
  | 'recordingDurationSeconds'
  /** column name */
  | 'recordingSummary'
  /** column name */
  | 'recordingTranscript'
  /** column name */
  | 'recordingUrl';

export type IntegratedPhoneVoicemailsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IntegratedPhoneVoicemailsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhoneVoicemailsSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhoneVoicemailsBoolExp;
};

/** aggregate varPop on columns */
export type IntegratedPhoneVoicemailsVarPopFields = {
  __typename?: 'IntegratedPhoneVoicemailsVarPopFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsVarPopOrderBy = {
  recordingDurationSeconds?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type IntegratedPhoneVoicemailsVarSampFields = {
  __typename?: 'IntegratedPhoneVoicemailsVarSampFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsVarSampOrderBy = {
  recordingDurationSeconds?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type IntegratedPhoneVoicemailsVarianceFields = {
  __typename?: 'IntegratedPhoneVoicemailsVarianceFields';
  recordingDurationSeconds?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "integrated_phone_voicemails" */
export type IntegratedPhoneVoicemailsVarianceOrderBy = {
  recordingDurationSeconds?: InputMaybe<OrderBy>;
};

/** columns and relationships of "integrated_phones" */
export type IntegratedPhones = {
  __typename?: 'IntegratedPhones';
  /** An object relationship */
  assistantIntegratedPhone?: Maybe<AssistantIntegratedPhones>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  /** An object relationship */
  companyLeadSource?: Maybe<CompanyLeadSources>;
  companyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  decommissionedAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneGuid: Scalars['uuid'];
  phoneNumber: Scalars['String'];
  phoneProvider: Scalars['String'];
  primaryOutboundSms: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "integrated_phones" */
export type IntegratedPhonesAggregate = {
  __typename?: 'IntegratedPhonesAggregate';
  aggregate?: Maybe<IntegratedPhonesAggregateFields>;
  nodes: Array<IntegratedPhones>;
};

export type IntegratedPhonesAggregateBoolExp = {
  bool_and?: InputMaybe<IntegratedPhonesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<IntegratedPhonesAggregateBoolExpBool_Or>;
  count?: InputMaybe<IntegratedPhonesAggregateBoolExpCount>;
};

/** aggregate fields of "integrated_phones" */
export type IntegratedPhonesAggregateFields = {
  __typename?: 'IntegratedPhonesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<IntegratedPhonesMaxFields>;
  min?: Maybe<IntegratedPhonesMinFields>;
};


/** aggregate fields of "integrated_phones" */
export type IntegratedPhonesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<IntegratedPhonesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "integrated_phones" */
export type IntegratedPhonesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<IntegratedPhonesMaxOrderBy>;
  min?: InputMaybe<IntegratedPhonesMinOrderBy>;
};

/** input type for inserting array relation for remote table "integrated_phones" */
export type IntegratedPhonesArrRelInsertInput = {
  data: Array<IntegratedPhonesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhonesOnConflict>;
};

/** Boolean expression to filter rows from the table "integrated_phones". All fields are combined with a logical 'AND'. */
export type IntegratedPhonesBoolExp = {
  _and?: InputMaybe<Array<IntegratedPhonesBoolExp>>;
  _not?: InputMaybe<IntegratedPhonesBoolExp>;
  _or?: InputMaybe<Array<IntegratedPhonesBoolExp>>;
  assistantIntegratedPhone?: InputMaybe<AssistantIntegratedPhonesBoolExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  companyLeadSource?: InputMaybe<CompanyLeadSourcesBoolExp>;
  companyLeadSourceGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  decommissionedAt?: InputMaybe<TimestamptzComparisonExp>;
  integratedPhoneGuid?: InputMaybe<UuidComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  phoneProvider?: InputMaybe<StringComparisonExp>;
  primaryOutboundSms?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "integrated_phones" */
export type IntegratedPhonesConstraint =
  /** unique or primary key constraint on columns "phone_number" */
  | 'integrated_phones_phone_number_key'
  /** unique or primary key constraint on columns "integrated_phone_guid" */
  | 'integrated_phones_pkey'
  /** unique or primary key constraint on columns "company_guid" */
  | 'uq_integrated_phones_company_primary_sms';

/** input type for inserting data into table "integrated_phones" */
export type IntegratedPhonesInsertInput = {
  assistantIntegratedPhone?: InputMaybe<AssistantIntegratedPhonesObjRelInsertInput>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyLeadSource?: InputMaybe<CompanyLeadSourcesObjRelInsertInput>;
  companyLeadSourceGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  decommissionedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneGuid?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneProvider?: InputMaybe<Scalars['String']>;
  primaryOutboundSms?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type IntegratedPhonesMaxFields = {
  __typename?: 'IntegratedPhonesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  companyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  decommissionedAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneGuid?: Maybe<Scalars['uuid']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneProvider?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "integrated_phones" */
export type IntegratedPhonesMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  companyLeadSourceGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  decommissionedAt?: InputMaybe<OrderBy>;
  integratedPhoneGuid?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneProvider?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type IntegratedPhonesMinFields = {
  __typename?: 'IntegratedPhonesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  companyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  decommissionedAt?: Maybe<Scalars['timestamptz']>;
  integratedPhoneGuid?: Maybe<Scalars['uuid']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneProvider?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "integrated_phones" */
export type IntegratedPhonesMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  companyLeadSourceGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  decommissionedAt?: InputMaybe<OrderBy>;
  integratedPhoneGuid?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneProvider?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "integrated_phones" */
export type IntegratedPhonesMutationResponse = {
  __typename?: 'IntegratedPhonesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IntegratedPhones>;
};

/** input type for inserting object relation for remote table "integrated_phones" */
export type IntegratedPhonesObjRelInsertInput = {
  data: IntegratedPhonesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<IntegratedPhonesOnConflict>;
};

/** on_conflict condition type for table "integrated_phones" */
export type IntegratedPhonesOnConflict = {
  constraint: IntegratedPhonesConstraint;
  updateColumns?: Array<IntegratedPhonesUpdateColumn>;
  where?: InputMaybe<IntegratedPhonesBoolExp>;
};

/** Ordering options when selecting data from "integrated_phones". */
export type IntegratedPhonesOrderBy = {
  assistantIntegratedPhone?: InputMaybe<AssistantIntegratedPhonesOrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  companyLeadSource?: InputMaybe<CompanyLeadSourcesOrderBy>;
  companyLeadSourceGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  decommissionedAt?: InputMaybe<OrderBy>;
  integratedPhoneGuid?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneProvider?: InputMaybe<OrderBy>;
  primaryOutboundSms?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: integrated_phones */
export type IntegratedPhonesPkColumnsInput = {
  integratedPhoneGuid: Scalars['uuid'];
};

/** select columns of table "integrated_phones" */
export type IntegratedPhonesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'companyLeadSourceGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'decommissionedAt'
  /** column name */
  | 'integratedPhoneGuid'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneProvider'
  /** column name */
  | 'primaryOutboundSms'
  /** column name */
  | 'updatedAt';

/** select "integratedPhonesAggregateBoolExpBool_andArgumentsColumns" columns of table "integrated_phones" */
export type IntegratedPhonesSelectColumnIntegratedPhonesAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'primaryOutboundSms';

/** select "integratedPhonesAggregateBoolExpBool_orArgumentsColumns" columns of table "integrated_phones" */
export type IntegratedPhonesSelectColumnIntegratedPhonesAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'primaryOutboundSms';

/** input type for updating data in table "integrated_phones" */
export type IntegratedPhonesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyLeadSourceGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  decommissionedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneGuid?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneProvider?: InputMaybe<Scalars['String']>;
  primaryOutboundSms?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "integrated_phones" */
export type IntegratedPhonesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: IntegratedPhonesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IntegratedPhonesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyLeadSourceGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  decommissionedAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneGuid?: InputMaybe<Scalars['uuid']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneProvider?: InputMaybe<Scalars['String']>;
  primaryOutboundSms?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "integrated_phones" */
export type IntegratedPhonesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'companyLeadSourceGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'decommissionedAt'
  /** column name */
  | 'integratedPhoneGuid'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneProvider'
  /** column name */
  | 'primaryOutboundSms'
  /** column name */
  | 'updatedAt';

export type IntegratedPhonesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IntegratedPhonesSetInput>;
  /** filter the rows which have to be updated */
  where: IntegratedPhonesBoolExp;
};

/** Links invoices to business units through either jobs or maintenance plans. Includes source_guid (job_guid or maintenance_plan_guid) and source_type. Prioritizes job associations over maintenance plan associations. */
export type InvoiceBusinessUnit = {
  __typename?: 'InvoiceBusinessUnit';
  /** An object relationship */
  businessUnit?: Maybe<BusinessUnits>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  sourceGuid?: Maybe<Scalars['uuid']>;
  sourceType?: Maybe<Scalars['String']>;
};

/** aggregated selection of "invoice_business_unit" */
export type InvoiceBusinessUnitAggregate = {
  __typename?: 'InvoiceBusinessUnitAggregate';
  aggregate?: Maybe<InvoiceBusinessUnitAggregateFields>;
  nodes: Array<InvoiceBusinessUnit>;
};

/** aggregate fields of "invoice_business_unit" */
export type InvoiceBusinessUnitAggregateFields = {
  __typename?: 'InvoiceBusinessUnitAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InvoiceBusinessUnitMaxFields>;
  min?: Maybe<InvoiceBusinessUnitMinFields>;
};


/** aggregate fields of "invoice_business_unit" */
export type InvoiceBusinessUnitAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoiceBusinessUnitSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "invoice_business_unit". All fields are combined with a logical 'AND'. */
export type InvoiceBusinessUnitBoolExp = {
  _and?: InputMaybe<Array<InvoiceBusinessUnitBoolExp>>;
  _not?: InputMaybe<InvoiceBusinessUnitBoolExp>;
  _or?: InputMaybe<Array<InvoiceBusinessUnitBoolExp>>;
  businessUnit?: InputMaybe<BusinessUnitsBoolExp>;
  businessUnitGuid?: InputMaybe<UuidComparisonExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  sourceGuid?: InputMaybe<UuidComparisonExp>;
  sourceType?: InputMaybe<StringComparisonExp>;
};

/** input type for inserting data into table "invoice_business_unit" */
export type InvoiceBusinessUnitInsertInput = {
  businessUnit?: InputMaybe<BusinessUnitsObjRelInsertInput>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  sourceGuid?: InputMaybe<Scalars['uuid']>;
  sourceType?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type InvoiceBusinessUnitMaxFields = {
  __typename?: 'InvoiceBusinessUnitMaxFields';
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  sourceGuid?: Maybe<Scalars['uuid']>;
  sourceType?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type InvoiceBusinessUnitMinFields = {
  __typename?: 'InvoiceBusinessUnitMinFields';
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  sourceGuid?: Maybe<Scalars['uuid']>;
  sourceType?: Maybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "invoice_business_unit" */
export type InvoiceBusinessUnitObjRelInsertInput = {
  data: InvoiceBusinessUnitInsertInput;
};

/** Ordering options when selecting data from "invoice_business_unit". */
export type InvoiceBusinessUnitOrderBy = {
  businessUnit?: InputMaybe<BusinessUnitsOrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  sourceGuid?: InputMaybe<OrderBy>;
  sourceType?: InputMaybe<OrderBy>;
};

/** select columns of table "invoice_business_unit" */
export type InvoiceBusinessUnitSelectColumn =
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'sourceGuid'
  /** column name */
  | 'sourceType';

/** Streaming cursor of the table "invoice_business_unit" */
export type InvoiceBusinessUnitStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoiceBusinessUnitStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoiceBusinessUnitStreamCursorValueInput = {
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  sourceGuid?: InputMaybe<Scalars['uuid']>;
  sourceType?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItems = {
  __typename?: 'InvoiceCartItemBundleItems';
  /** An object relationship */
  cartItem?: Maybe<CartItems>;
  cartItemGuid: Scalars['uuid'];
  /** An object relationship */
  childPricebookItem: PricebookItems;
  childPricebookItemGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  invoice: Invoices;
  invoiceCartItemBundleItemGuid: Scalars['uuid'];
  invoiceGuid: Scalars['uuid'];
  itemQuantity: Scalars['Int'];
  /** An object relationship */
  parentPricebookItem: PricebookItems;
  parentPricebookItemGuid: Scalars['uuid'];
};

/** aggregated selection of "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsAggregate = {
  __typename?: 'InvoiceCartItemBundleItemsAggregate';
  aggregate?: Maybe<InvoiceCartItemBundleItemsAggregateFields>;
  nodes: Array<InvoiceCartItemBundleItems>;
};

export type InvoiceCartItemBundleItemsAggregateBoolExp = {
  count?: InputMaybe<InvoiceCartItemBundleItemsAggregateBoolExpCount>;
};

/** aggregate fields of "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsAggregateFields = {
  __typename?: 'InvoiceCartItemBundleItemsAggregateFields';
  avg?: Maybe<InvoiceCartItemBundleItemsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InvoiceCartItemBundleItemsMaxFields>;
  min?: Maybe<InvoiceCartItemBundleItemsMinFields>;
  stddev?: Maybe<InvoiceCartItemBundleItemsStddevFields>;
  stddevPop?: Maybe<InvoiceCartItemBundleItemsStddevPopFields>;
  stddevSamp?: Maybe<InvoiceCartItemBundleItemsStddevSampFields>;
  sum?: Maybe<InvoiceCartItemBundleItemsSumFields>;
  varPop?: Maybe<InvoiceCartItemBundleItemsVarPopFields>;
  varSamp?: Maybe<InvoiceCartItemBundleItemsVarSampFields>;
  variance?: Maybe<InvoiceCartItemBundleItemsVarianceFields>;
};


/** aggregate fields of "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoiceCartItemBundleItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsAggregateOrderBy = {
  avg?: InputMaybe<InvoiceCartItemBundleItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InvoiceCartItemBundleItemsMaxOrderBy>;
  min?: InputMaybe<InvoiceCartItemBundleItemsMinOrderBy>;
  stddev?: InputMaybe<InvoiceCartItemBundleItemsStddevOrderBy>;
  stddevPop?: InputMaybe<InvoiceCartItemBundleItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<InvoiceCartItemBundleItemsStddevSampOrderBy>;
  sum?: InputMaybe<InvoiceCartItemBundleItemsSumOrderBy>;
  varPop?: InputMaybe<InvoiceCartItemBundleItemsVarPopOrderBy>;
  varSamp?: InputMaybe<InvoiceCartItemBundleItemsVarSampOrderBy>;
  variance?: InputMaybe<InvoiceCartItemBundleItemsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsArrRelInsertInput = {
  data: Array<InvoiceCartItemBundleItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InvoiceCartItemBundleItemsOnConflict>;
};

/** aggregate avg on columns */
export type InvoiceCartItemBundleItemsAvgFields = {
  __typename?: 'InvoiceCartItemBundleItemsAvgFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsAvgOrderBy = {
  itemQuantity?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "invoice_cart_item_bundle_items". All fields are combined with a logical 'AND'. */
export type InvoiceCartItemBundleItemsBoolExp = {
  _and?: InputMaybe<Array<InvoiceCartItemBundleItemsBoolExp>>;
  _not?: InputMaybe<InvoiceCartItemBundleItemsBoolExp>;
  _or?: InputMaybe<Array<InvoiceCartItemBundleItemsBoolExp>>;
  cartItem?: InputMaybe<CartItemsBoolExp>;
  cartItemGuid?: InputMaybe<UuidComparisonExp>;
  childPricebookItem?: InputMaybe<PricebookItemsBoolExp>;
  childPricebookItemGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceCartItemBundleItemGuid?: InputMaybe<UuidComparisonExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  itemQuantity?: InputMaybe<IntComparisonExp>;
  parentPricebookItem?: InputMaybe<PricebookItemsBoolExp>;
  parentPricebookItemGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsConstraint =
  /** unique or primary key constraint on columns "invoice_cart_item_bundle_item_guid" */
  | 'invoice_cart_item_bundle_items_pkey'
  /** unique or primary key constraint on columns "invoice_guid", "child_pricebook_item_guid", "cart_item_guid", "company_guid" */
  | 'invoice_cart_item_bundle_items_unique';

/** input type for incrementing numeric columns in table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsIncInput = {
  itemQuantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsInsertInput = {
  cartItem?: InputMaybe<CartItemsObjRelInsertInput>;
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  childPricebookItem?: InputMaybe<PricebookItemsObjRelInsertInput>;
  childPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceCartItemBundleItemGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  itemQuantity?: InputMaybe<Scalars['Int']>;
  parentPricebookItem?: InputMaybe<PricebookItemsObjRelInsertInput>;
  parentPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type InvoiceCartItemBundleItemsMaxFields = {
  __typename?: 'InvoiceCartItemBundleItemsMaxFields';
  cartItemGuid?: Maybe<Scalars['uuid']>;
  childPricebookItemGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  invoiceCartItemBundleItemGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  itemQuantity?: Maybe<Scalars['Int']>;
  parentPricebookItemGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsMaxOrderBy = {
  cartItemGuid?: InputMaybe<OrderBy>;
  childPricebookItemGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  invoiceCartItemBundleItemGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  itemQuantity?: InputMaybe<OrderBy>;
  parentPricebookItemGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InvoiceCartItemBundleItemsMinFields = {
  __typename?: 'InvoiceCartItemBundleItemsMinFields';
  cartItemGuid?: Maybe<Scalars['uuid']>;
  childPricebookItemGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  invoiceCartItemBundleItemGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  itemQuantity?: Maybe<Scalars['Int']>;
  parentPricebookItemGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsMinOrderBy = {
  cartItemGuid?: InputMaybe<OrderBy>;
  childPricebookItemGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  invoiceCartItemBundleItemGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  itemQuantity?: InputMaybe<OrderBy>;
  parentPricebookItemGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsMutationResponse = {
  __typename?: 'InvoiceCartItemBundleItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvoiceCartItemBundleItems>;
};

/** input type for inserting object relation for remote table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsObjRelInsertInput = {
  data: InvoiceCartItemBundleItemsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<InvoiceCartItemBundleItemsOnConflict>;
};

/** on_conflict condition type for table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsOnConflict = {
  constraint: InvoiceCartItemBundleItemsConstraint;
  updateColumns?: Array<InvoiceCartItemBundleItemsUpdateColumn>;
  where?: InputMaybe<InvoiceCartItemBundleItemsBoolExp>;
};

/** Ordering options when selecting data from "invoice_cart_item_bundle_items". */
export type InvoiceCartItemBundleItemsOrderBy = {
  cartItem?: InputMaybe<CartItemsOrderBy>;
  cartItemGuid?: InputMaybe<OrderBy>;
  childPricebookItem?: InputMaybe<PricebookItemsOrderBy>;
  childPricebookItemGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceCartItemBundleItemGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  itemQuantity?: InputMaybe<OrderBy>;
  parentPricebookItem?: InputMaybe<PricebookItemsOrderBy>;
  parentPricebookItemGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: invoice_cart_item_bundle_items */
export type InvoiceCartItemBundleItemsPkColumnsInput = {
  invoiceCartItemBundleItemGuid: Scalars['uuid'];
};

/** select columns of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsSelectColumn =
  /** column name */
  | 'cartItemGuid'
  /** column name */
  | 'childPricebookItemGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'invoiceCartItemBundleItemGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'itemQuantity'
  /** column name */
  | 'parentPricebookItemGuid';

/** input type for updating data in table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsSetInput = {
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  childPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceCartItemBundleItemGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  itemQuantity?: InputMaybe<Scalars['Int']>;
  parentPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type InvoiceCartItemBundleItemsStddevFields = {
  __typename?: 'InvoiceCartItemBundleItemsStddevFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsStddevOrderBy = {
  itemQuantity?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type InvoiceCartItemBundleItemsStddevPopFields = {
  __typename?: 'InvoiceCartItemBundleItemsStddevPopFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsStddevPopOrderBy = {
  itemQuantity?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type InvoiceCartItemBundleItemsStddevSampFields = {
  __typename?: 'InvoiceCartItemBundleItemsStddevSampFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsStddevSampOrderBy = {
  itemQuantity?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoiceCartItemBundleItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoiceCartItemBundleItemsStreamCursorValueInput = {
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  childPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceCartItemBundleItemGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  itemQuantity?: InputMaybe<Scalars['Int']>;
  parentPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type InvoiceCartItemBundleItemsSumFields = {
  __typename?: 'InvoiceCartItemBundleItemsSumFields';
  itemQuantity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsSumOrderBy = {
  itemQuantity?: InputMaybe<OrderBy>;
};

/** update columns of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsUpdateColumn =
  /** column name */
  | 'cartItemGuid'
  /** column name */
  | 'childPricebookItemGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'invoiceCartItemBundleItemGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'itemQuantity'
  /** column name */
  | 'parentPricebookItemGuid';

export type InvoiceCartItemBundleItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvoiceCartItemBundleItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoiceCartItemBundleItemsSetInput>;
  /** filter the rows which have to be updated */
  where: InvoiceCartItemBundleItemsBoolExp;
};

/** aggregate varPop on columns */
export type InvoiceCartItemBundleItemsVarPopFields = {
  __typename?: 'InvoiceCartItemBundleItemsVarPopFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsVarPopOrderBy = {
  itemQuantity?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type InvoiceCartItemBundleItemsVarSampFields = {
  __typename?: 'InvoiceCartItemBundleItemsVarSampFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsVarSampOrderBy = {
  itemQuantity?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type InvoiceCartItemBundleItemsVarianceFields = {
  __typename?: 'InvoiceCartItemBundleItemsVarianceFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice_cart_item_bundle_items" */
export type InvoiceCartItemBundleItemsVarianceOrderBy = {
  itemQuantity?: InputMaybe<OrderBy>;
};

/** columns and relationships of "invoice_cart_item_bundle_job_cost_links" */
export type InvoiceCartItemBundleJobCostLinks = {
  __typename?: 'InvoiceCartItemBundleJobCostLinks';
  /** An object relationship */
  bundleItem: InvoiceCartItemBundleItems;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  costImportSuppressedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  invoice: Invoices;
  invoiceCartItemBundleItemGuid: Scalars['uuid'];
  invoiceGuid: Scalars['uuid'];
  /** An object relationship */
  job: Jobs;
  /** An object relationship */
  jobCostItem?: Maybe<JobCostItems>;
  jobCostItemGuid?: Maybe<Scalars['uuid']>;
  jobGuid: Scalars['uuid'];
};

/** aggregated selection of "invoice_cart_item_bundle_job_cost_links" */
export type InvoiceCartItemBundleJobCostLinksAggregate = {
  __typename?: 'InvoiceCartItemBundleJobCostLinksAggregate';
  aggregate?: Maybe<InvoiceCartItemBundleJobCostLinksAggregateFields>;
  nodes: Array<InvoiceCartItemBundleJobCostLinks>;
};

/** aggregate fields of "invoice_cart_item_bundle_job_cost_links" */
export type InvoiceCartItemBundleJobCostLinksAggregateFields = {
  __typename?: 'InvoiceCartItemBundleJobCostLinksAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InvoiceCartItemBundleJobCostLinksMaxFields>;
  min?: Maybe<InvoiceCartItemBundleJobCostLinksMinFields>;
};


/** aggregate fields of "invoice_cart_item_bundle_job_cost_links" */
export type InvoiceCartItemBundleJobCostLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoiceCartItemBundleJobCostLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "invoice_cart_item_bundle_job_cost_links". All fields are combined with a logical 'AND'. */
export type InvoiceCartItemBundleJobCostLinksBoolExp = {
  _and?: InputMaybe<Array<InvoiceCartItemBundleJobCostLinksBoolExp>>;
  _not?: InputMaybe<InvoiceCartItemBundleJobCostLinksBoolExp>;
  _or?: InputMaybe<Array<InvoiceCartItemBundleJobCostLinksBoolExp>>;
  bundleItem?: InputMaybe<InvoiceCartItemBundleItemsBoolExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  costImportSuppressedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceCartItemBundleItemGuid?: InputMaybe<UuidComparisonExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobCostItem?: InputMaybe<JobCostItemsBoolExp>;
  jobCostItemGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "invoice_cart_item_bundle_job_cost_links" */
export type InvoiceCartItemBundleJobCostLinksConstraint =
  /** unique or primary key constraint on columns "job_guid", "invoice_cart_item_bundle_item_guid" */
  | 'invoice_cart_item_bundle_job_cost_links_pkey';

/** input type for inserting data into table "invoice_cart_item_bundle_job_cost_links" */
export type InvoiceCartItemBundleJobCostLinksInsertInput = {
  bundleItem?: InputMaybe<InvoiceCartItemBundleItemsObjRelInsertInput>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costImportSuppressedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceCartItemBundleItemGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobCostItem?: InputMaybe<JobCostItemsObjRelInsertInput>;
  jobCostItemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type InvoiceCartItemBundleJobCostLinksMaxFields = {
  __typename?: 'InvoiceCartItemBundleJobCostLinksMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  costImportSuppressedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  invoiceCartItemBundleItemGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  jobCostItemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type InvoiceCartItemBundleJobCostLinksMinFields = {
  __typename?: 'InvoiceCartItemBundleJobCostLinksMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  costImportSuppressedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  invoiceCartItemBundleItemGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  jobCostItemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "invoice_cart_item_bundle_job_cost_links" */
export type InvoiceCartItemBundleJobCostLinksMutationResponse = {
  __typename?: 'InvoiceCartItemBundleJobCostLinksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvoiceCartItemBundleJobCostLinks>;
};

/** on_conflict condition type for table "invoice_cart_item_bundle_job_cost_links" */
export type InvoiceCartItemBundleJobCostLinksOnConflict = {
  constraint: InvoiceCartItemBundleJobCostLinksConstraint;
  updateColumns?: Array<InvoiceCartItemBundleJobCostLinksUpdateColumn>;
  where?: InputMaybe<InvoiceCartItemBundleJobCostLinksBoolExp>;
};

/** Ordering options when selecting data from "invoice_cart_item_bundle_job_cost_links". */
export type InvoiceCartItemBundleJobCostLinksOrderBy = {
  bundleItem?: InputMaybe<InvoiceCartItemBundleItemsOrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  costImportSuppressedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceCartItemBundleItemGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobCostItem?: InputMaybe<JobCostItemsOrderBy>;
  jobCostItemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: invoice_cart_item_bundle_job_cost_links */
export type InvoiceCartItemBundleJobCostLinksPkColumnsInput = {
  invoiceCartItemBundleItemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
};

/** select columns of table "invoice_cart_item_bundle_job_cost_links" */
export type InvoiceCartItemBundleJobCostLinksSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'costImportSuppressedAt'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'invoiceCartItemBundleItemGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'jobCostItemGuid'
  /** column name */
  | 'jobGuid';

/** input type for updating data in table "invoice_cart_item_bundle_job_cost_links" */
export type InvoiceCartItemBundleJobCostLinksSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costImportSuppressedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceCartItemBundleItemGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  jobCostItemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "invoice_cart_item_bundle_job_cost_links" */
export type InvoiceCartItemBundleJobCostLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoiceCartItemBundleJobCostLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoiceCartItemBundleJobCostLinksStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costImportSuppressedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceCartItemBundleItemGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  jobCostItemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "invoice_cart_item_bundle_job_cost_links" */
export type InvoiceCartItemBundleJobCostLinksUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'costImportSuppressedAt'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'invoiceCartItemBundleItemGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'jobCostItemGuid'
  /** column name */
  | 'jobGuid';

export type InvoiceCartItemBundleJobCostLinksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoiceCartItemBundleJobCostLinksSetInput>;
  /** filter the rows which have to be updated */
  where: InvoiceCartItemBundleJobCostLinksBoolExp;
};

/** columns and relationships of "invoice_cart_items" */
export type InvoiceCartItems = {
  __typename?: 'InvoiceCartItems';
  /** An object relationship */
  cartItem: CartItems;
  cartItemGuid: Scalars['uuid'];
  /** An object relationship */
  invoice: Invoices;
  invoiceGuid: Scalars['uuid'];
  seq: Scalars['Int'];
};

/** aggregated selection of "invoice_cart_items" */
export type InvoiceCartItemsAggregate = {
  __typename?: 'InvoiceCartItemsAggregate';
  aggregate?: Maybe<InvoiceCartItemsAggregateFields>;
  nodes: Array<InvoiceCartItems>;
};

export type InvoiceCartItemsAggregateBoolExp = {
  count?: InputMaybe<InvoiceCartItemsAggregateBoolExpCount>;
};

/** aggregate fields of "invoice_cart_items" */
export type InvoiceCartItemsAggregateFields = {
  __typename?: 'InvoiceCartItemsAggregateFields';
  avg?: Maybe<InvoiceCartItemsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InvoiceCartItemsMaxFields>;
  min?: Maybe<InvoiceCartItemsMinFields>;
  stddev?: Maybe<InvoiceCartItemsStddevFields>;
  stddevPop?: Maybe<InvoiceCartItemsStddevPopFields>;
  stddevSamp?: Maybe<InvoiceCartItemsStddevSampFields>;
  sum?: Maybe<InvoiceCartItemsSumFields>;
  varPop?: Maybe<InvoiceCartItemsVarPopFields>;
  varSamp?: Maybe<InvoiceCartItemsVarSampFields>;
  variance?: Maybe<InvoiceCartItemsVarianceFields>;
};


/** aggregate fields of "invoice_cart_items" */
export type InvoiceCartItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoiceCartItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice_cart_items" */
export type InvoiceCartItemsAggregateOrderBy = {
  avg?: InputMaybe<InvoiceCartItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InvoiceCartItemsMaxOrderBy>;
  min?: InputMaybe<InvoiceCartItemsMinOrderBy>;
  stddev?: InputMaybe<InvoiceCartItemsStddevOrderBy>;
  stddevPop?: InputMaybe<InvoiceCartItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<InvoiceCartItemsStddevSampOrderBy>;
  sum?: InputMaybe<InvoiceCartItemsSumOrderBy>;
  varPop?: InputMaybe<InvoiceCartItemsVarPopOrderBy>;
  varSamp?: InputMaybe<InvoiceCartItemsVarSampOrderBy>;
  variance?: InputMaybe<InvoiceCartItemsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "invoice_cart_items" */
export type InvoiceCartItemsArrRelInsertInput = {
  data: Array<InvoiceCartItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InvoiceCartItemsOnConflict>;
};

/** aggregate avg on columns */
export type InvoiceCartItemsAvgFields = {
  __typename?: 'InvoiceCartItemsAvgFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice_cart_items" */
export type InvoiceCartItemsAvgOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "invoice_cart_items". All fields are combined with a logical 'AND'. */
export type InvoiceCartItemsBoolExp = {
  _and?: InputMaybe<Array<InvoiceCartItemsBoolExp>>;
  _not?: InputMaybe<InvoiceCartItemsBoolExp>;
  _or?: InputMaybe<Array<InvoiceCartItemsBoolExp>>;
  cartItem?: InputMaybe<CartItemsBoolExp>;
  cartItemGuid?: InputMaybe<UuidComparisonExp>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  seq?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "invoice_cart_items" */
export type InvoiceCartItemsConstraint =
  /** unique or primary key constraint on columns "invoice_guid", "cart_item_guid" */
  | 'invoice_cart_items_pkey';

/** input type for incrementing numeric columns in table "invoice_cart_items" */
export type InvoiceCartItemsIncInput = {
  seq?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "invoice_cart_items" */
export type InvoiceCartItemsInsertInput = {
  cartItem?: InputMaybe<CartItemsObjRelInsertInput>;
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  seq?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type InvoiceCartItemsMaxFields = {
  __typename?: 'InvoiceCartItemsMaxFields';
  cartItemGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  seq?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "invoice_cart_items" */
export type InvoiceCartItemsMaxOrderBy = {
  cartItemGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InvoiceCartItemsMinFields = {
  __typename?: 'InvoiceCartItemsMinFields';
  cartItemGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  seq?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "invoice_cart_items" */
export type InvoiceCartItemsMinOrderBy = {
  cartItemGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "invoice_cart_items" */
export type InvoiceCartItemsMutationResponse = {
  __typename?: 'InvoiceCartItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvoiceCartItems>;
};

/** on_conflict condition type for table "invoice_cart_items" */
export type InvoiceCartItemsOnConflict = {
  constraint: InvoiceCartItemsConstraint;
  updateColumns?: Array<InvoiceCartItemsUpdateColumn>;
  where?: InputMaybe<InvoiceCartItemsBoolExp>;
};

/** Ordering options when selecting data from "invoice_cart_items". */
export type InvoiceCartItemsOrderBy = {
  cartItem?: InputMaybe<CartItemsOrderBy>;
  cartItemGuid?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: invoice_cart_items */
export type InvoiceCartItemsPkColumnsInput = {
  cartItemGuid: Scalars['uuid'];
  invoiceGuid: Scalars['uuid'];
};

/** select columns of table "invoice_cart_items" */
export type InvoiceCartItemsSelectColumn =
  /** column name */
  | 'cartItemGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'seq';

/** input type for updating data in table "invoice_cart_items" */
export type InvoiceCartItemsSetInput = {
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  seq?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type InvoiceCartItemsStddevFields = {
  __typename?: 'InvoiceCartItemsStddevFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice_cart_items" */
export type InvoiceCartItemsStddevOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type InvoiceCartItemsStddevPopFields = {
  __typename?: 'InvoiceCartItemsStddevPopFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "invoice_cart_items" */
export type InvoiceCartItemsStddevPopOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type InvoiceCartItemsStddevSampFields = {
  __typename?: 'InvoiceCartItemsStddevSampFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "invoice_cart_items" */
export type InvoiceCartItemsStddevSampOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "invoice_cart_items" */
export type InvoiceCartItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoiceCartItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoiceCartItemsStreamCursorValueInput = {
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  seq?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type InvoiceCartItemsSumFields = {
  __typename?: 'InvoiceCartItemsSumFields';
  seq?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "invoice_cart_items" */
export type InvoiceCartItemsSumOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** update columns of table "invoice_cart_items" */
export type InvoiceCartItemsUpdateColumn =
  /** column name */
  | 'cartItemGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'seq';

export type InvoiceCartItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvoiceCartItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoiceCartItemsSetInput>;
  /** filter the rows which have to be updated */
  where: InvoiceCartItemsBoolExp;
};

/** aggregate varPop on columns */
export type InvoiceCartItemsVarPopFields = {
  __typename?: 'InvoiceCartItemsVarPopFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "invoice_cart_items" */
export type InvoiceCartItemsVarPopOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type InvoiceCartItemsVarSampFields = {
  __typename?: 'InvoiceCartItemsVarSampFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "invoice_cart_items" */
export type InvoiceCartItemsVarSampOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type InvoiceCartItemsVarianceFields = {
  __typename?: 'InvoiceCartItemsVarianceFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice_cart_items" */
export type InvoiceCartItemsVarianceOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** columns and relationships of "invoice_company_tax_configurations_view" */
export type InvoiceCompanyTaxConfigurationsView = {
  __typename?: 'InvoiceCompanyTaxConfigurationsView';
  /** An object relationship */
  company?: Maybe<Companies>;
  companyGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invoice?: Maybe<Invoices>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  taxRoundingStrategy: Scalars['TaxRoundingStrategy'];
};

/** aggregated selection of "invoice_company_tax_configurations_view" */
export type InvoiceCompanyTaxConfigurationsViewAggregate = {
  __typename?: 'InvoiceCompanyTaxConfigurationsViewAggregate';
  aggregate?: Maybe<InvoiceCompanyTaxConfigurationsViewAggregateFields>;
  nodes: Array<InvoiceCompanyTaxConfigurationsView>;
};

/** aggregate fields of "invoice_company_tax_configurations_view" */
export type InvoiceCompanyTaxConfigurationsViewAggregateFields = {
  __typename?: 'InvoiceCompanyTaxConfigurationsViewAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InvoiceCompanyTaxConfigurationsViewMaxFields>;
  min?: Maybe<InvoiceCompanyTaxConfigurationsViewMinFields>;
};


/** aggregate fields of "invoice_company_tax_configurations_view" */
export type InvoiceCompanyTaxConfigurationsViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoiceCompanyTaxConfigurationsViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "invoice_company_tax_configurations_view". All fields are combined with a logical 'AND'. */
export type InvoiceCompanyTaxConfigurationsViewBoolExp = {
  _and?: InputMaybe<Array<InvoiceCompanyTaxConfigurationsViewBoolExp>>;
  _not?: InputMaybe<InvoiceCompanyTaxConfigurationsViewBoolExp>;
  _or?: InputMaybe<Array<InvoiceCompanyTaxConfigurationsViewBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategyComparisonExp']>;
};

/** input type for inserting data into table "invoice_company_tax_configurations_view" */
export type InvoiceCompanyTaxConfigurationsViewInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
};

/** aggregate max on columns */
export type InvoiceCompanyTaxConfigurationsViewMaxFields = {
  __typename?: 'InvoiceCompanyTaxConfigurationsViewMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  taxRoundingStrategy?: Maybe<Scalars['TaxRoundingStrategy']>;
};

/** aggregate min on columns */
export type InvoiceCompanyTaxConfigurationsViewMinFields = {
  __typename?: 'InvoiceCompanyTaxConfigurationsViewMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  taxRoundingStrategy?: Maybe<Scalars['TaxRoundingStrategy']>;
};

/** input type for inserting object relation for remote table "invoice_company_tax_configurations_view" */
export type InvoiceCompanyTaxConfigurationsViewObjRelInsertInput = {
  data: InvoiceCompanyTaxConfigurationsViewInsertInput;
};

/** Ordering options when selecting data from "invoice_company_tax_configurations_view". */
export type InvoiceCompanyTaxConfigurationsViewOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  taxRoundingStrategy?: InputMaybe<OrderBy>;
};

/** select columns of table "invoice_company_tax_configurations_view" */
export type InvoiceCompanyTaxConfigurationsViewSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'taxRoundingStrategy';

export type InvoiceCompanyTaxConfigurationsViewSetInput = {
  __typename?: 'InvoiceCompanyTaxConfigurationsViewSetInput';
  taxRoundingStrategy?: Maybe<Scalars['TaxRoundingStrategy']>;
};

/** Streaming cursor of the table "invoice_company_tax_configurations_view" */
export type InvoiceCompanyTaxConfigurationsViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoiceCompanyTaxConfigurationsViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoiceCompanyTaxConfigurationsViewStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
};

/** columns and relationships of "invoice_discounts" */
export type InvoiceDiscounts = {
  __typename?: 'InvoiceDiscounts';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['uuid'];
  descriptionHtml?: Maybe<Scalars['HtmlString']>;
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['numeric']>;
  discountType: Scalars['DiscountType'];
  /** An object relationship */
  invoice: Invoices;
  invoiceDiscountGuid: Scalars['uuid'];
  invoiceGuid: Scalars['uuid'];
  name: Scalars['String'];
  seq: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "invoice_discounts" */
export type InvoiceDiscountsAggregate = {
  __typename?: 'InvoiceDiscountsAggregate';
  aggregate?: Maybe<InvoiceDiscountsAggregateFields>;
  nodes: Array<InvoiceDiscounts>;
};

export type InvoiceDiscountsAggregateBoolExp = {
  count?: InputMaybe<InvoiceDiscountsAggregateBoolExpCount>;
};

/** aggregate fields of "invoice_discounts" */
export type InvoiceDiscountsAggregateFields = {
  __typename?: 'InvoiceDiscountsAggregateFields';
  avg?: Maybe<InvoiceDiscountsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InvoiceDiscountsMaxFields>;
  min?: Maybe<InvoiceDiscountsMinFields>;
  stddev?: Maybe<InvoiceDiscountsStddevFields>;
  stddevPop?: Maybe<InvoiceDiscountsStddevPopFields>;
  stddevSamp?: Maybe<InvoiceDiscountsStddevSampFields>;
  sum?: Maybe<InvoiceDiscountsSumFields>;
  varPop?: Maybe<InvoiceDiscountsVarPopFields>;
  varSamp?: Maybe<InvoiceDiscountsVarSampFields>;
  variance?: Maybe<InvoiceDiscountsVarianceFields>;
};


/** aggregate fields of "invoice_discounts" */
export type InvoiceDiscountsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoiceDiscountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice_discounts" */
export type InvoiceDiscountsAggregateOrderBy = {
  avg?: InputMaybe<InvoiceDiscountsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InvoiceDiscountsMaxOrderBy>;
  min?: InputMaybe<InvoiceDiscountsMinOrderBy>;
  stddev?: InputMaybe<InvoiceDiscountsStddevOrderBy>;
  stddevPop?: InputMaybe<InvoiceDiscountsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<InvoiceDiscountsStddevSampOrderBy>;
  sum?: InputMaybe<InvoiceDiscountsSumOrderBy>;
  varPop?: InputMaybe<InvoiceDiscountsVarPopOrderBy>;
  varSamp?: InputMaybe<InvoiceDiscountsVarSampOrderBy>;
  variance?: InputMaybe<InvoiceDiscountsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "invoice_discounts" */
export type InvoiceDiscountsArrRelInsertInput = {
  data: Array<InvoiceDiscountsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InvoiceDiscountsOnConflict>;
};

/** aggregate avg on columns */
export type InvoiceDiscountsAvgFields = {
  __typename?: 'InvoiceDiscountsAvgFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice_discounts" */
export type InvoiceDiscountsAvgOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "invoice_discounts". All fields are combined with a logical 'AND'. */
export type InvoiceDiscountsBoolExp = {
  _and?: InputMaybe<Array<InvoiceDiscountsBoolExp>>;
  _not?: InputMaybe<InvoiceDiscountsBoolExp>;
  _or?: InputMaybe<Array<InvoiceDiscountsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  descriptionHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
  discountAmountUsc?: InputMaybe<IntComparisonExp>;
  discountRate?: InputMaybe<NumericComparisonExp>;
  discountType?: InputMaybe<Scalars['DiscountTypeComparisonExp']>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceDiscountGuid?: InputMaybe<UuidComparisonExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  seq?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "invoice_discounts" */
export type InvoiceDiscountsConstraint =
  /** unique or primary key constraint on columns "invoice_discount_guid" */
  | 'invoice_discounts_pkey';

/** input type for incrementing numeric columns in table "invoice_discounts" */
export type InvoiceDiscountsIncInput = {
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  seq?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "invoice_discounts" */
export type InvoiceDiscountsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  descriptionHtml?: InputMaybe<Scalars['HtmlString']>;
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  discountType?: InputMaybe<Scalars['DiscountType']>;
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceDiscountGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  seq?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InvoiceDiscountsMaxFields = {
  __typename?: 'InvoiceDiscountsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  descriptionHtml?: Maybe<Scalars['HtmlString']>;
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['numeric']>;
  discountType?: Maybe<Scalars['DiscountType']>;
  invoiceDiscountGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  seq?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invoice_discounts" */
export type InvoiceDiscountsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  descriptionHtml?: InputMaybe<OrderBy>;
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  discountType?: InputMaybe<OrderBy>;
  invoiceDiscountGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InvoiceDiscountsMinFields = {
  __typename?: 'InvoiceDiscountsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  descriptionHtml?: Maybe<Scalars['HtmlString']>;
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['numeric']>;
  discountType?: Maybe<Scalars['DiscountType']>;
  invoiceDiscountGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  seq?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invoice_discounts" */
export type InvoiceDiscountsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  descriptionHtml?: InputMaybe<OrderBy>;
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  discountType?: InputMaybe<OrderBy>;
  invoiceDiscountGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "invoice_discounts" */
export type InvoiceDiscountsMutationResponse = {
  __typename?: 'InvoiceDiscountsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvoiceDiscounts>;
};

/** on_conflict condition type for table "invoice_discounts" */
export type InvoiceDiscountsOnConflict = {
  constraint: InvoiceDiscountsConstraint;
  updateColumns?: Array<InvoiceDiscountsUpdateColumn>;
  where?: InputMaybe<InvoiceDiscountsBoolExp>;
};

/** Ordering options when selecting data from "invoice_discounts". */
export type InvoiceDiscountsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  descriptionHtml?: InputMaybe<OrderBy>;
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  discountType?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceDiscountGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: invoice_discounts */
export type InvoiceDiscountsPkColumnsInput = {
  invoiceDiscountGuid: Scalars['uuid'];
};

/** select columns of table "invoice_discounts" */
export type InvoiceDiscountsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'descriptionHtml'
  /** column name */
  | 'discountAmountUsc'
  /** column name */
  | 'discountRate'
  /** column name */
  | 'discountType'
  /** column name */
  | 'invoiceDiscountGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'seq'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "invoice_discounts" */
export type InvoiceDiscountsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  descriptionHtml?: InputMaybe<Scalars['HtmlString']>;
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  discountType?: InputMaybe<Scalars['DiscountType']>;
  invoiceDiscountGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  seq?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type InvoiceDiscountsStddevFields = {
  __typename?: 'InvoiceDiscountsStddevFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice_discounts" */
export type InvoiceDiscountsStddevOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type InvoiceDiscountsStddevPopFields = {
  __typename?: 'InvoiceDiscountsStddevPopFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "invoice_discounts" */
export type InvoiceDiscountsStddevPopOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type InvoiceDiscountsStddevSampFields = {
  __typename?: 'InvoiceDiscountsStddevSampFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "invoice_discounts" */
export type InvoiceDiscountsStddevSampOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "invoice_discounts" */
export type InvoiceDiscountsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoiceDiscountsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoiceDiscountsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  descriptionHtml?: InputMaybe<Scalars['HtmlString']>;
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  discountType?: InputMaybe<Scalars['DiscountType']>;
  invoiceDiscountGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  seq?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type InvoiceDiscountsSumFields = {
  __typename?: 'InvoiceDiscountsSumFields';
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['numeric']>;
  seq?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "invoice_discounts" */
export type InvoiceDiscountsSumOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** update columns of table "invoice_discounts" */
export type InvoiceDiscountsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'descriptionHtml'
  /** column name */
  | 'discountAmountUsc'
  /** column name */
  | 'discountRate'
  /** column name */
  | 'discountType'
  /** column name */
  | 'invoiceDiscountGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'seq'
  /** column name */
  | 'updatedAt';

export type InvoiceDiscountsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvoiceDiscountsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoiceDiscountsSetInput>;
  /** filter the rows which have to be updated */
  where: InvoiceDiscountsBoolExp;
};

/** aggregate varPop on columns */
export type InvoiceDiscountsVarPopFields = {
  __typename?: 'InvoiceDiscountsVarPopFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "invoice_discounts" */
export type InvoiceDiscountsVarPopOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type InvoiceDiscountsVarSampFields = {
  __typename?: 'InvoiceDiscountsVarSampFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "invoice_discounts" */
export type InvoiceDiscountsVarSampOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type InvoiceDiscountsVarianceFields = {
  __typename?: 'InvoiceDiscountsVarianceFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  seq?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice_discounts" */
export type InvoiceDiscountsVarianceOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** columns and relationships of "invoice_events" */
export type InvoiceEvents = {
  __typename?: 'InvoiceEvents';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['uuid'];
  /** An object relationship */
  createdByUser: Users;
  eventType: Scalars['InvoiceEventType'];
  infoItems: Array<Scalars['String']>;
  invoiceEventGuid: Scalars['uuid'];
  invoiceGuid: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  occurredAt: Scalars['timestamptz'];
  title: Scalars['String'];
};


/** columns and relationships of "invoice_events" */
export type InvoiceEventsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "invoice_events" */
export type InvoiceEventsAggregate = {
  __typename?: 'InvoiceEventsAggregate';
  aggregate?: Maybe<InvoiceEventsAggregateFields>;
  nodes: Array<InvoiceEvents>;
};

export type InvoiceEventsAggregateBoolExp = {
  count?: InputMaybe<InvoiceEventsAggregateBoolExpCount>;
};

/** aggregate fields of "invoice_events" */
export type InvoiceEventsAggregateFields = {
  __typename?: 'InvoiceEventsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InvoiceEventsMaxFields>;
  min?: Maybe<InvoiceEventsMinFields>;
};


/** aggregate fields of "invoice_events" */
export type InvoiceEventsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoiceEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice_events" */
export type InvoiceEventsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InvoiceEventsMaxOrderBy>;
  min?: InputMaybe<InvoiceEventsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type InvoiceEventsAppendInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "invoice_events" */
export type InvoiceEventsArrRelInsertInput = {
  data: Array<InvoiceEventsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InvoiceEventsOnConflict>;
};

/** Boolean expression to filter rows from the table "invoice_events". All fields are combined with a logical 'AND'. */
export type InvoiceEventsBoolExp = {
  _and?: InputMaybe<Array<InvoiceEventsBoolExp>>;
  _not?: InputMaybe<InvoiceEventsBoolExp>;
  _or?: InputMaybe<Array<InvoiceEventsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  eventType?: InputMaybe<Scalars['InvoiceEventTypeComparisonExp']>;
  infoItems?: InputMaybe<StringArrayComparisonExp>;
  invoiceEventGuid?: InputMaybe<UuidComparisonExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "invoice_events" */
export type InvoiceEventsConstraint =
  /** unique or primary key constraint on columns "invoice_event_guid" */
  | 'invoice_events_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type InvoiceEventsDeleteAtPathInput = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type InvoiceEventsDeleteElemInput = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type InvoiceEventsDeleteKeyInput = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "invoice_events" */
export type InvoiceEventsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  eventType?: InputMaybe<Scalars['InvoiceEventType']>;
  infoItems?: InputMaybe<Array<Scalars['String']>>;
  invoiceEventGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type InvoiceEventsMaxFields = {
  __typename?: 'InvoiceEventsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventType?: Maybe<Scalars['InvoiceEventType']>;
  infoItems?: Maybe<Array<Scalars['String']>>;
  invoiceEventGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "invoice_events" */
export type InvoiceEventsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  eventType?: InputMaybe<OrderBy>;
  infoItems?: InputMaybe<OrderBy>;
  invoiceEventGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InvoiceEventsMinFields = {
  __typename?: 'InvoiceEventsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  eventType?: Maybe<Scalars['InvoiceEventType']>;
  infoItems?: Maybe<Array<Scalars['String']>>;
  invoiceEventGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "invoice_events" */
export type InvoiceEventsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  eventType?: InputMaybe<OrderBy>;
  infoItems?: InputMaybe<OrderBy>;
  invoiceEventGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "invoice_events" */
export type InvoiceEventsMutationResponse = {
  __typename?: 'InvoiceEventsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvoiceEvents>;
};

/** on_conflict condition type for table "invoice_events" */
export type InvoiceEventsOnConflict = {
  constraint: InvoiceEventsConstraint;
  updateColumns?: Array<InvoiceEventsUpdateColumn>;
  where?: InputMaybe<InvoiceEventsBoolExp>;
};

/** Ordering options when selecting data from "invoice_events". */
export type InvoiceEventsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  eventType?: InputMaybe<OrderBy>;
  infoItems?: InputMaybe<OrderBy>;
  invoiceEventGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: invoice_events */
export type InvoiceEventsPkColumnsInput = {
  invoiceEventGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type InvoiceEventsPrependInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "invoice_events" */
export type InvoiceEventsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'eventType'
  /** column name */
  | 'infoItems'
  /** column name */
  | 'invoiceEventGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'metadata'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'title';

/** input type for updating data in table "invoice_events" */
export type InvoiceEventsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventType?: InputMaybe<Scalars['InvoiceEventType']>;
  infoItems?: InputMaybe<Array<Scalars['String']>>;
  invoiceEventGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "invoice_events" */
export type InvoiceEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoiceEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoiceEventsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  eventType?: InputMaybe<Scalars['InvoiceEventType']>;
  infoItems?: InputMaybe<Array<Scalars['String']>>;
  invoiceEventGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
};

/** update columns of table "invoice_events" */
export type InvoiceEventsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'eventType'
  /** column name */
  | 'infoItems'
  /** column name */
  | 'invoiceEventGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'metadata'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'title';

export type InvoiceEventsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<InvoiceEventsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<InvoiceEventsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<InvoiceEventsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<InvoiceEventsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<InvoiceEventsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoiceEventsSetInput>;
  /** filter the rows which have to be updated */
  where: InvoiceEventsBoolExp;
};

/** columns and relationships of "invoice_payments" */
export type InvoicePayments = {
  __typename?: 'InvoicePayments';
  appliedAmountUsc: Scalars['Int'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  /** An object relationship */
  invoice: Invoices;
  invoiceGuid: Scalars['uuid'];
  /** An object relationship */
  paymentRecord: PaymentRecords;
  paymentRecordGuid: Scalars['uuid'];
};

/** aggregated selection of "invoice_payments" */
export type InvoicePaymentsAggregate = {
  __typename?: 'InvoicePaymentsAggregate';
  aggregate?: Maybe<InvoicePaymentsAggregateFields>;
  nodes: Array<InvoicePayments>;
};

export type InvoicePaymentsAggregateBoolExp = {
  count?: InputMaybe<InvoicePaymentsAggregateBoolExpCount>;
};

/** aggregate fields of "invoice_payments" */
export type InvoicePaymentsAggregateFields = {
  __typename?: 'InvoicePaymentsAggregateFields';
  avg?: Maybe<InvoicePaymentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InvoicePaymentsMaxFields>;
  min?: Maybe<InvoicePaymentsMinFields>;
  stddev?: Maybe<InvoicePaymentsStddevFields>;
  stddevPop?: Maybe<InvoicePaymentsStddevPopFields>;
  stddevSamp?: Maybe<InvoicePaymentsStddevSampFields>;
  sum?: Maybe<InvoicePaymentsSumFields>;
  varPop?: Maybe<InvoicePaymentsVarPopFields>;
  varSamp?: Maybe<InvoicePaymentsVarSampFields>;
  variance?: Maybe<InvoicePaymentsVarianceFields>;
};


/** aggregate fields of "invoice_payments" */
export type InvoicePaymentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice_payments" */
export type InvoicePaymentsAggregateOrderBy = {
  avg?: InputMaybe<InvoicePaymentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InvoicePaymentsMaxOrderBy>;
  min?: InputMaybe<InvoicePaymentsMinOrderBy>;
  stddev?: InputMaybe<InvoicePaymentsStddevOrderBy>;
  stddevPop?: InputMaybe<InvoicePaymentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<InvoicePaymentsStddevSampOrderBy>;
  sum?: InputMaybe<InvoicePaymentsSumOrderBy>;
  varPop?: InputMaybe<InvoicePaymentsVarPopOrderBy>;
  varSamp?: InputMaybe<InvoicePaymentsVarSampOrderBy>;
  variance?: InputMaybe<InvoicePaymentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "invoice_payments" */
export type InvoicePaymentsArrRelInsertInput = {
  data: Array<InvoicePaymentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InvoicePaymentsOnConflict>;
};

/** aggregate avg on columns */
export type InvoicePaymentsAvgFields = {
  __typename?: 'InvoicePaymentsAvgFields';
  appliedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice_payments" */
export type InvoicePaymentsAvgOrderBy = {
  appliedAmountUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "invoice_payments". All fields are combined with a logical 'AND'. */
export type InvoicePaymentsBoolExp = {
  _and?: InputMaybe<Array<InvoicePaymentsBoolExp>>;
  _not?: InputMaybe<InvoicePaymentsBoolExp>;
  _or?: InputMaybe<Array<InvoicePaymentsBoolExp>>;
  appliedAmountUsc?: InputMaybe<IntComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  paymentRecord?: InputMaybe<PaymentRecordsBoolExp>;
  paymentRecordGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "invoice_payments" */
export type InvoicePaymentsConstraint =
  /** unique or primary key constraint on columns "invoice_guid", "payment_record_guid" */
  | 'invoice_payments_pkey';

/** input type for incrementing numeric columns in table "invoice_payments" */
export type InvoicePaymentsIncInput = {
  appliedAmountUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "invoice_payments" */
export type InvoicePaymentsInsertInput = {
  appliedAmountUsc?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  paymentRecord?: InputMaybe<PaymentRecordsObjRelInsertInput>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type InvoicePaymentsMaxFields = {
  __typename?: 'InvoicePaymentsMaxFields';
  appliedAmountUsc?: Maybe<Scalars['Int']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "invoice_payments" */
export type InvoicePaymentsMaxOrderBy = {
  appliedAmountUsc?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InvoicePaymentsMinFields = {
  __typename?: 'InvoicePaymentsMinFields';
  appliedAmountUsc?: Maybe<Scalars['Int']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "invoice_payments" */
export type InvoicePaymentsMinOrderBy = {
  appliedAmountUsc?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "invoice_payments" */
export type InvoicePaymentsMutationResponse = {
  __typename?: 'InvoicePaymentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvoicePayments>;
};

/** on_conflict condition type for table "invoice_payments" */
export type InvoicePaymentsOnConflict = {
  constraint: InvoicePaymentsConstraint;
  updateColumns?: Array<InvoicePaymentsUpdateColumn>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};

/** Ordering options when selecting data from "invoice_payments". */
export type InvoicePaymentsOrderBy = {
  appliedAmountUsc?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  paymentRecord?: InputMaybe<PaymentRecordsOrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: invoice_payments */
export type InvoicePaymentsPkColumnsInput = {
  invoiceGuid: Scalars['uuid'];
  paymentRecordGuid: Scalars['uuid'];
};

/** select columns of table "invoice_payments" */
export type InvoicePaymentsSelectColumn =
  /** column name */
  | 'appliedAmountUsc'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'paymentRecordGuid';

/** input type for updating data in table "invoice_payments" */
export type InvoicePaymentsSetInput = {
  appliedAmountUsc?: InputMaybe<Scalars['Int']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type InvoicePaymentsStddevFields = {
  __typename?: 'InvoicePaymentsStddevFields';
  appliedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice_payments" */
export type InvoicePaymentsStddevOrderBy = {
  appliedAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type InvoicePaymentsStddevPopFields = {
  __typename?: 'InvoicePaymentsStddevPopFields';
  appliedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "invoice_payments" */
export type InvoicePaymentsStddevPopOrderBy = {
  appliedAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type InvoicePaymentsStddevSampFields = {
  __typename?: 'InvoicePaymentsStddevSampFields';
  appliedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "invoice_payments" */
export type InvoicePaymentsStddevSampOrderBy = {
  appliedAmountUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "invoice_payments" */
export type InvoicePaymentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoicePaymentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoicePaymentsStreamCursorValueInput = {
  appliedAmountUsc?: InputMaybe<Scalars['Int']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type InvoicePaymentsSumFields = {
  __typename?: 'InvoicePaymentsSumFields';
  appliedAmountUsc?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "invoice_payments" */
export type InvoicePaymentsSumOrderBy = {
  appliedAmountUsc?: InputMaybe<OrderBy>;
};

/** update columns of table "invoice_payments" */
export type InvoicePaymentsUpdateColumn =
  /** column name */
  | 'appliedAmountUsc'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'paymentRecordGuid';

export type InvoicePaymentsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvoicePaymentsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoicePaymentsSetInput>;
  /** filter the rows which have to be updated */
  where: InvoicePaymentsBoolExp;
};

/** aggregate varPop on columns */
export type InvoicePaymentsVarPopFields = {
  __typename?: 'InvoicePaymentsVarPopFields';
  appliedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "invoice_payments" */
export type InvoicePaymentsVarPopOrderBy = {
  appliedAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type InvoicePaymentsVarSampFields = {
  __typename?: 'InvoicePaymentsVarSampFields';
  appliedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "invoice_payments" */
export type InvoicePaymentsVarSampOrderBy = {
  appliedAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type InvoicePaymentsVarianceFields = {
  __typename?: 'InvoicePaymentsVarianceFields';
  appliedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice_payments" */
export type InvoicePaymentsVarianceOrderBy = {
  appliedAmountUsc?: InputMaybe<OrderBy>;
};

/** columns and relationships of "invoice_reminder_data" */
export type InvoiceReminderData = {
  __typename?: 'InvoiceReminderData';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['uuid'];
  invoiceGuid: Scalars['uuid'];
  linkLastSentAt: Scalars['timestamptz'];
  previousSelfServePaymentLink?: Maybe<Scalars['String']>;
  remindersSent: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "invoice_reminder_data" */
export type InvoiceReminderDataAggregate = {
  __typename?: 'InvoiceReminderDataAggregate';
  aggregate?: Maybe<InvoiceReminderDataAggregateFields>;
  nodes: Array<InvoiceReminderData>;
};

/** aggregate fields of "invoice_reminder_data" */
export type InvoiceReminderDataAggregateFields = {
  __typename?: 'InvoiceReminderDataAggregateFields';
  avg?: Maybe<InvoiceReminderDataAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InvoiceReminderDataMaxFields>;
  min?: Maybe<InvoiceReminderDataMinFields>;
  stddev?: Maybe<InvoiceReminderDataStddevFields>;
  stddevPop?: Maybe<InvoiceReminderDataStddevPopFields>;
  stddevSamp?: Maybe<InvoiceReminderDataStddevSampFields>;
  sum?: Maybe<InvoiceReminderDataSumFields>;
  varPop?: Maybe<InvoiceReminderDataVarPopFields>;
  varSamp?: Maybe<InvoiceReminderDataVarSampFields>;
  variance?: Maybe<InvoiceReminderDataVarianceFields>;
};


/** aggregate fields of "invoice_reminder_data" */
export type InvoiceReminderDataAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoiceReminderDataSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type InvoiceReminderDataAvgFields = {
  __typename?: 'InvoiceReminderDataAvgFields';
  remindersSent?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "invoice_reminder_data". All fields are combined with a logical 'AND'. */
export type InvoiceReminderDataBoolExp = {
  _and?: InputMaybe<Array<InvoiceReminderDataBoolExp>>;
  _not?: InputMaybe<InvoiceReminderDataBoolExp>;
  _or?: InputMaybe<Array<InvoiceReminderDataBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  linkLastSentAt?: InputMaybe<TimestamptzComparisonExp>;
  previousSelfServePaymentLink?: InputMaybe<StringComparisonExp>;
  remindersSent?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "invoice_reminder_data" */
export type InvoiceReminderDataConstraint =
  /** unique or primary key constraint on columns "invoice_guid" */
  | 'invoice_reminder_data_pkey';

/** input type for incrementing numeric columns in table "invoice_reminder_data" */
export type InvoiceReminderDataIncInput = {
  remindersSent?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "invoice_reminder_data" */
export type InvoiceReminderDataInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  linkLastSentAt?: InputMaybe<Scalars['timestamptz']>;
  previousSelfServePaymentLink?: InputMaybe<Scalars['String']>;
  remindersSent?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InvoiceReminderDataMaxFields = {
  __typename?: 'InvoiceReminderDataMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  linkLastSentAt?: Maybe<Scalars['timestamptz']>;
  previousSelfServePaymentLink?: Maybe<Scalars['String']>;
  remindersSent?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type InvoiceReminderDataMinFields = {
  __typename?: 'InvoiceReminderDataMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  linkLastSentAt?: Maybe<Scalars['timestamptz']>;
  previousSelfServePaymentLink?: Maybe<Scalars['String']>;
  remindersSent?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "invoice_reminder_data" */
export type InvoiceReminderDataMutationResponse = {
  __typename?: 'InvoiceReminderDataMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvoiceReminderData>;
};

/** input type for inserting object relation for remote table "invoice_reminder_data" */
export type InvoiceReminderDataObjRelInsertInput = {
  data: InvoiceReminderDataInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<InvoiceReminderDataOnConflict>;
};

/** on_conflict condition type for table "invoice_reminder_data" */
export type InvoiceReminderDataOnConflict = {
  constraint: InvoiceReminderDataConstraint;
  updateColumns?: Array<InvoiceReminderDataUpdateColumn>;
  where?: InputMaybe<InvoiceReminderDataBoolExp>;
};

/** Ordering options when selecting data from "invoice_reminder_data". */
export type InvoiceReminderDataOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  linkLastSentAt?: InputMaybe<OrderBy>;
  previousSelfServePaymentLink?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: invoice_reminder_data */
export type InvoiceReminderDataPkColumnsInput = {
  invoiceGuid: Scalars['uuid'];
};

/** select columns of table "invoice_reminder_data" */
export type InvoiceReminderDataSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'linkLastSentAt'
  /** column name */
  | 'previousSelfServePaymentLink'
  /** column name */
  | 'remindersSent'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "invoice_reminder_data" */
export type InvoiceReminderDataSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  linkLastSentAt?: InputMaybe<Scalars['timestamptz']>;
  previousSelfServePaymentLink?: InputMaybe<Scalars['String']>;
  remindersSent?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type InvoiceReminderDataStddevFields = {
  __typename?: 'InvoiceReminderDataStddevFields';
  remindersSent?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type InvoiceReminderDataStddevPopFields = {
  __typename?: 'InvoiceReminderDataStddevPopFields';
  remindersSent?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type InvoiceReminderDataStddevSampFields = {
  __typename?: 'InvoiceReminderDataStddevSampFields';
  remindersSent?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "invoice_reminder_data" */
export type InvoiceReminderDataStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoiceReminderDataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoiceReminderDataStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  linkLastSentAt?: InputMaybe<Scalars['timestamptz']>;
  previousSelfServePaymentLink?: InputMaybe<Scalars['String']>;
  remindersSent?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type InvoiceReminderDataSumFields = {
  __typename?: 'InvoiceReminderDataSumFields';
  remindersSent?: Maybe<Scalars['Int']>;
};

/** update columns of table "invoice_reminder_data" */
export type InvoiceReminderDataUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'linkLastSentAt'
  /** column name */
  | 'previousSelfServePaymentLink'
  /** column name */
  | 'remindersSent'
  /** column name */
  | 'updatedAt';

export type InvoiceReminderDataUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvoiceReminderDataIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoiceReminderDataSetInput>;
  /** filter the rows which have to be updated */
  where: InvoiceReminderDataBoolExp;
};

/** aggregate varPop on columns */
export type InvoiceReminderDataVarPopFields = {
  __typename?: 'InvoiceReminderDataVarPopFields';
  remindersSent?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type InvoiceReminderDataVarSampFields = {
  __typename?: 'InvoiceReminderDataVarSampFields';
  remindersSent?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type InvoiceReminderDataVarianceFields = {
  __typename?: 'InvoiceReminderDataVarianceFields';
  remindersSent?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "invoice_template_cart_items" */
export type InvoiceTemplateCartItems = {
  __typename?: 'InvoiceTemplateCartItems';
  /** An object relationship */
  cartItem: CartItems;
  cartItemGuid: Scalars['uuid'];
  /** An object relationship */
  invoiceTemplate: InvoiceTemplates;
  invoiceTemplateGuid: Scalars['uuid'];
  seq: Scalars['Int'];
};

/** aggregated selection of "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsAggregate = {
  __typename?: 'InvoiceTemplateCartItemsAggregate';
  aggregate?: Maybe<InvoiceTemplateCartItemsAggregateFields>;
  nodes: Array<InvoiceTemplateCartItems>;
};

export type InvoiceTemplateCartItemsAggregateBoolExp = {
  count?: InputMaybe<InvoiceTemplateCartItemsAggregateBoolExpCount>;
};

/** aggregate fields of "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsAggregateFields = {
  __typename?: 'InvoiceTemplateCartItemsAggregateFields';
  avg?: Maybe<InvoiceTemplateCartItemsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InvoiceTemplateCartItemsMaxFields>;
  min?: Maybe<InvoiceTemplateCartItemsMinFields>;
  stddev?: Maybe<InvoiceTemplateCartItemsStddevFields>;
  stddevPop?: Maybe<InvoiceTemplateCartItemsStddevPopFields>;
  stddevSamp?: Maybe<InvoiceTemplateCartItemsStddevSampFields>;
  sum?: Maybe<InvoiceTemplateCartItemsSumFields>;
  varPop?: Maybe<InvoiceTemplateCartItemsVarPopFields>;
  varSamp?: Maybe<InvoiceTemplateCartItemsVarSampFields>;
  variance?: Maybe<InvoiceTemplateCartItemsVarianceFields>;
};


/** aggregate fields of "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoiceTemplateCartItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsAggregateOrderBy = {
  avg?: InputMaybe<InvoiceTemplateCartItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InvoiceTemplateCartItemsMaxOrderBy>;
  min?: InputMaybe<InvoiceTemplateCartItemsMinOrderBy>;
  stddev?: InputMaybe<InvoiceTemplateCartItemsStddevOrderBy>;
  stddevPop?: InputMaybe<InvoiceTemplateCartItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<InvoiceTemplateCartItemsStddevSampOrderBy>;
  sum?: InputMaybe<InvoiceTemplateCartItemsSumOrderBy>;
  varPop?: InputMaybe<InvoiceTemplateCartItemsVarPopOrderBy>;
  varSamp?: InputMaybe<InvoiceTemplateCartItemsVarSampOrderBy>;
  variance?: InputMaybe<InvoiceTemplateCartItemsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsArrRelInsertInput = {
  data: Array<InvoiceTemplateCartItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InvoiceTemplateCartItemsOnConflict>;
};

/** aggregate avg on columns */
export type InvoiceTemplateCartItemsAvgFields = {
  __typename?: 'InvoiceTemplateCartItemsAvgFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsAvgOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "invoice_template_cart_items". All fields are combined with a logical 'AND'. */
export type InvoiceTemplateCartItemsBoolExp = {
  _and?: InputMaybe<Array<InvoiceTemplateCartItemsBoolExp>>;
  _not?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
  _or?: InputMaybe<Array<InvoiceTemplateCartItemsBoolExp>>;
  cartItem?: InputMaybe<CartItemsBoolExp>;
  cartItemGuid?: InputMaybe<UuidComparisonExp>;
  invoiceTemplate?: InputMaybe<InvoiceTemplatesBoolExp>;
  invoiceTemplateGuid?: InputMaybe<UuidComparisonExp>;
  seq?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsConstraint =
  /** unique or primary key constraint on columns "cart_item_guid", "invoice_template_guid" */
  | 'invoice_template_cart_items_pkey';

/** input type for incrementing numeric columns in table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsIncInput = {
  seq?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsInsertInput = {
  cartItem?: InputMaybe<CartItemsObjRelInsertInput>;
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  invoiceTemplate?: InputMaybe<InvoiceTemplatesObjRelInsertInput>;
  invoiceTemplateGuid?: InputMaybe<Scalars['uuid']>;
  seq?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type InvoiceTemplateCartItemsMaxFields = {
  __typename?: 'InvoiceTemplateCartItemsMaxFields';
  cartItemGuid?: Maybe<Scalars['uuid']>;
  invoiceTemplateGuid?: Maybe<Scalars['uuid']>;
  seq?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsMaxOrderBy = {
  cartItemGuid?: InputMaybe<OrderBy>;
  invoiceTemplateGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InvoiceTemplateCartItemsMinFields = {
  __typename?: 'InvoiceTemplateCartItemsMinFields';
  cartItemGuid?: Maybe<Scalars['uuid']>;
  invoiceTemplateGuid?: Maybe<Scalars['uuid']>;
  seq?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsMinOrderBy = {
  cartItemGuid?: InputMaybe<OrderBy>;
  invoiceTemplateGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsMutationResponse = {
  __typename?: 'InvoiceTemplateCartItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvoiceTemplateCartItems>;
};

/** on_conflict condition type for table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsOnConflict = {
  constraint: InvoiceTemplateCartItemsConstraint;
  updateColumns?: Array<InvoiceTemplateCartItemsUpdateColumn>;
  where?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
};

/** Ordering options when selecting data from "invoice_template_cart_items". */
export type InvoiceTemplateCartItemsOrderBy = {
  cartItem?: InputMaybe<CartItemsOrderBy>;
  cartItemGuid?: InputMaybe<OrderBy>;
  invoiceTemplate?: InputMaybe<InvoiceTemplatesOrderBy>;
  invoiceTemplateGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: invoice_template_cart_items */
export type InvoiceTemplateCartItemsPkColumnsInput = {
  cartItemGuid: Scalars['uuid'];
  invoiceTemplateGuid: Scalars['uuid'];
};

/** select columns of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsSelectColumn =
  /** column name */
  | 'cartItemGuid'
  /** column name */
  | 'invoiceTemplateGuid'
  /** column name */
  | 'seq';

/** input type for updating data in table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsSetInput = {
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  invoiceTemplateGuid?: InputMaybe<Scalars['uuid']>;
  seq?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type InvoiceTemplateCartItemsStddevFields = {
  __typename?: 'InvoiceTemplateCartItemsStddevFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsStddevOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type InvoiceTemplateCartItemsStddevPopFields = {
  __typename?: 'InvoiceTemplateCartItemsStddevPopFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsStddevPopOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type InvoiceTemplateCartItemsStddevSampFields = {
  __typename?: 'InvoiceTemplateCartItemsStddevSampFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsStddevSampOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoiceTemplateCartItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoiceTemplateCartItemsStreamCursorValueInput = {
  cartItemGuid?: InputMaybe<Scalars['uuid']>;
  invoiceTemplateGuid?: InputMaybe<Scalars['uuid']>;
  seq?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type InvoiceTemplateCartItemsSumFields = {
  __typename?: 'InvoiceTemplateCartItemsSumFields';
  seq?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsSumOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** update columns of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsUpdateColumn =
  /** column name */
  | 'cartItemGuid'
  /** column name */
  | 'invoiceTemplateGuid'
  /** column name */
  | 'seq';

export type InvoiceTemplateCartItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvoiceTemplateCartItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoiceTemplateCartItemsSetInput>;
  /** filter the rows which have to be updated */
  where: InvoiceTemplateCartItemsBoolExp;
};

/** aggregate varPop on columns */
export type InvoiceTemplateCartItemsVarPopFields = {
  __typename?: 'InvoiceTemplateCartItemsVarPopFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsVarPopOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type InvoiceTemplateCartItemsVarSampFields = {
  __typename?: 'InvoiceTemplateCartItemsVarSampFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsVarSampOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type InvoiceTemplateCartItemsVarianceFields = {
  __typename?: 'InvoiceTemplateCartItemsVarianceFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice_template_cart_items" */
export type InvoiceTemplateCartItemsVarianceOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** columns and relationships of "invoice_templates" */
export type InvoiceTemplates = {
  __typename?: 'InvoiceTemplates';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  invoiceTemplateCartItems: Array<InvoiceTemplateCartItems>;
  /** An aggregate relationship */
  invoiceTemplateCartItemsAggregate: InvoiceTemplateCartItemsAggregate;
  invoiceTemplateGuid: Scalars['uuid'];
  isDeleted: Scalars['Boolean'];
  templateName: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "invoice_templates" */
export type InvoiceTemplatesInvoiceTemplateCartItemsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceTemplateCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceTemplateCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
};


/** columns and relationships of "invoice_templates" */
export type InvoiceTemplatesInvoiceTemplateCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceTemplateCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceTemplateCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
};

/** aggregated selection of "invoice_templates" */
export type InvoiceTemplatesAggregate = {
  __typename?: 'InvoiceTemplatesAggregate';
  aggregate?: Maybe<InvoiceTemplatesAggregateFields>;
  nodes: Array<InvoiceTemplates>;
};

/** aggregate fields of "invoice_templates" */
export type InvoiceTemplatesAggregateFields = {
  __typename?: 'InvoiceTemplatesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InvoiceTemplatesMaxFields>;
  min?: Maybe<InvoiceTemplatesMinFields>;
};


/** aggregate fields of "invoice_templates" */
export type InvoiceTemplatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoiceTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "invoice_templates". All fields are combined with a logical 'AND'. */
export type InvoiceTemplatesBoolExp = {
  _and?: InputMaybe<Array<InvoiceTemplatesBoolExp>>;
  _not?: InputMaybe<InvoiceTemplatesBoolExp>;
  _or?: InputMaybe<Array<InvoiceTemplatesBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  invoiceTemplateCartItems?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
  invoiceTemplateCartItemsAggregate?: InputMaybe<InvoiceTemplateCartItemsAggregateBoolExp>;
  invoiceTemplateGuid?: InputMaybe<UuidComparisonExp>;
  isDeleted?: InputMaybe<BooleanComparisonExp>;
  templateName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "invoice_templates" */
export type InvoiceTemplatesConstraint =
  /** unique or primary key constraint on columns "invoice_template_guid" */
  | 'invoice_templates_pkey';

/** input type for inserting data into table "invoice_templates" */
export type InvoiceTemplatesInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceTemplateCartItems?: InputMaybe<InvoiceTemplateCartItemsArrRelInsertInput>;
  invoiceTemplateGuid?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  templateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InvoiceTemplatesMaxFields = {
  __typename?: 'InvoiceTemplatesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  invoiceTemplateGuid?: Maybe<Scalars['uuid']>;
  templateName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type InvoiceTemplatesMinFields = {
  __typename?: 'InvoiceTemplatesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  invoiceTemplateGuid?: Maybe<Scalars['uuid']>;
  templateName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "invoice_templates" */
export type InvoiceTemplatesMutationResponse = {
  __typename?: 'InvoiceTemplatesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvoiceTemplates>;
};

/** input type for inserting object relation for remote table "invoice_templates" */
export type InvoiceTemplatesObjRelInsertInput = {
  data: InvoiceTemplatesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<InvoiceTemplatesOnConflict>;
};

/** on_conflict condition type for table "invoice_templates" */
export type InvoiceTemplatesOnConflict = {
  constraint: InvoiceTemplatesConstraint;
  updateColumns?: Array<InvoiceTemplatesUpdateColumn>;
  where?: InputMaybe<InvoiceTemplatesBoolExp>;
};

/** Ordering options when selecting data from "invoice_templates". */
export type InvoiceTemplatesOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  invoiceTemplateCartItemsAggregate?: InputMaybe<InvoiceTemplateCartItemsAggregateOrderBy>;
  invoiceTemplateGuid?: InputMaybe<OrderBy>;
  isDeleted?: InputMaybe<OrderBy>;
  templateName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: invoice_templates */
export type InvoiceTemplatesPkColumnsInput = {
  invoiceTemplateGuid: Scalars['uuid'];
};

/** select columns of table "invoice_templates" */
export type InvoiceTemplatesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'invoiceTemplateGuid'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'templateName'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "invoice_templates" */
export type InvoiceTemplatesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceTemplateGuid?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  templateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "invoice_templates" */
export type InvoiceTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoiceTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoiceTemplatesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceTemplateGuid?: InputMaybe<Scalars['uuid']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  templateName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "invoice_templates" */
export type InvoiceTemplatesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'invoiceTemplateGuid'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'templateName'
  /** column name */
  | 'updatedAt';

export type InvoiceTemplatesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoiceTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: InvoiceTemplatesBoolExp;
};

export { InvoiceTermsEnum };

/** Boolean expression to compare columns of type "InvoiceTermsEnum". All fields are combined with logical 'AND'. */
export type InvoiceTermsEnumComparisonExp = {
  _eq?: InputMaybe<InvoiceTermsEnum>;
  _in?: InputMaybe<Array<InvoiceTermsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<InvoiceTermsEnum>;
  _nin?: InputMaybe<Array<InvoiceTermsEnum>>;
};

/** columns and relationships of "invoices" */
export type Invoices = {
  __typename?: 'Invoices';
  /** An object relationship */
  account: Accounts;
  accountGuid: Scalars['uuid'];
  /** An object relationship */
  accountingStaleInfo?: Maybe<InvoicesV2AccountingStale>;
  /** An object relationship */
  aggregatableInvoice?: Maybe<AggregatableInvoices>;
  /** An object relationship */
  billingAddress?: Maybe<Addresses>;
  billingAddressGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  billingContact: Contacts;
  billingContactGuid: Scalars['uuid'];
  /** An object relationship */
  businessUnitLink?: Maybe<InvoiceBusinessUnit>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['uuid'];
  /** An object relationship */
  createdByUser: Users;
  customerPurchaseOrderNumber?: Maybe<Scalars['String']>;
  displayId: Scalars['Int'];
  displayIdV2: Scalars['String'];
  /** If set, Breezy will not sync this invoice to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  dynamicPricingType?: Maybe<Scalars['DynamicPricingType']>;
  /** An object relationship */
  estimateLink?: Maybe<EstimateInvoices>;
  /** Per-invoice override: hide per-line prices on customer-facing renders. Seeded from company_config.hide_line_item_prices at create. */
  hideLineItemPrices: Scalars['Boolean'];
  /** An array relationship */
  invoiceCartItemBundleItems: Array<InvoiceCartItemBundleItems>;
  /** An aggregate relationship */
  invoiceCartItemBundleItemsAggregate: InvoiceCartItemBundleItemsAggregate;
  /** An array relationship */
  invoiceCartItems: Array<InvoiceCartItems>;
  /** An aggregate relationship */
  invoiceCartItemsAggregate: InvoiceCartItemsAggregate;
  /** An array relationship */
  invoiceDiscounts: Array<InvoiceDiscounts>;
  /** An aggregate relationship */
  invoiceDiscountsAggregate: InvoiceDiscountsAggregate;
  /** An array relationship */
  invoiceEvents: Array<InvoiceEvents>;
  /** An aggregate relationship */
  invoiceEventsAggregate: InvoiceEventsAggregate;
  invoiceGuid: Scalars['uuid'];
  /** An array relationship */
  invoicePayments: Array<InvoicePayments>;
  /** An aggregate relationship */
  invoicePaymentsAggregate: InvoicePaymentsAggregate;
  /** An object relationship */
  invoiceReminderData?: Maybe<InvoiceReminderData>;
  invoiceTerm: Scalars['InvoiceTermV2'];
  issuedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  jobAppointmentInvoices: Array<JobAppointmentInvoices>;
  /** An aggregate relationship */
  jobAppointmentInvoicesAggregate: JobAppointmentInvoicesAggregate;
  /** An object relationship */
  jobAppointmentLink?: Maybe<JobAppointmentInvoices>;
  /** An array relationship */
  jobInvoices: Array<JobInvoices>;
  /** An aggregate relationship */
  jobInvoicesAggregate: JobInvoicesAggregate;
  /** An object relationship */
  jobLink?: Maybe<JobInvoices>;
  /** An array relationship */
  locationInvoices: Array<LocationInvoices>;
  /** An aggregate relationship */
  locationInvoicesAggregate: LocationInvoicesAggregate;
  /** An object relationship */
  locationLink?: Maybe<LocationInvoices>;
  /** An array relationship */
  maintenancePlanInvoices: Array<MaintenancePlanInvoices>;
  /** An aggregate relationship */
  maintenancePlanInvoicesAggregate: MaintenancePlanInvoicesAggregate;
  /** An object relationship */
  maintenancePlanLink?: Maybe<MaintenancePlanInvoices>;
  maintenancePlanSavingsEnabled: Scalars['Boolean'];
  messageHtml?: Maybe<Scalars['HtmlString']>;
  /** An array relationship */
  paymentRecords: Array<PaymentRecords>;
  /** An aggregate relationship */
  paymentRecordsAggregate: PaymentRecordsAggregate;
  /** An object relationship */
  pricebookTaxRate: PricebookTaxRates;
  /** An object relationship */
  qboStaleInfo?: Maybe<InvoicesV2QboStale>;
  /** An object relationship */
  qboSync?: Maybe<InvoicesV2QboStatus>;
  /** An object relationship */
  serviceAddress: Addresses;
  serviceAddressGuid: Scalars['uuid'];
  serviceCompletionDate?: Maybe<Scalars['date']>;
  signatureFileUrl?: Maybe<Scalars['String']>;
  status: Scalars['InvoiceV2Status'];
  subtotalUsc: Scalars['Int'];
  /** An object relationship */
  taxConfiguration?: Maybe<InvoiceCompanyTaxConfigurationsView>;
  taxRate: Scalars['numeric'];
  taxRateGuid: Scalars['uuid'];
  taxRateName: Scalars['String'];
  totalUsc: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  wisetackLoanRecords: Array<WisetackLoanRecords>;
  /** An aggregate relationship */
  wisetackLoanRecordsAggregate: WisetackLoanRecordsAggregate;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoiceCartItemBundleItemsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemBundleItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemBundleItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemBundleItemsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoiceCartItemBundleItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemBundleItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemBundleItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemBundleItemsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoiceCartItemsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoiceCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoiceDiscountsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceDiscountsOrderBy>>;
  where?: InputMaybe<InvoiceDiscountsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoiceDiscountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceDiscountsOrderBy>>;
  where?: InputMaybe<InvoiceDiscountsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoiceEventsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceEventsOrderBy>>;
  where?: InputMaybe<InvoiceEventsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoiceEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceEventsOrderBy>>;
  where?: InputMaybe<InvoiceEventsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoicePaymentsArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoicePaymentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesJobAppointmentInvoicesArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentInvoicesOrderBy>>;
  where?: InputMaybe<JobAppointmentInvoicesBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesJobAppointmentInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentInvoicesOrderBy>>;
  where?: InputMaybe<JobAppointmentInvoicesBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesJobInvoicesArgs = {
  distinctOn?: InputMaybe<Array<JobInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobInvoicesOrderBy>>;
  where?: InputMaybe<JobInvoicesBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesJobInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobInvoicesOrderBy>>;
  where?: InputMaybe<JobInvoicesBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesLocationInvoicesArgs = {
  distinctOn?: InputMaybe<Array<LocationInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationInvoicesOrderBy>>;
  where?: InputMaybe<LocationInvoicesBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesLocationInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LocationInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationInvoicesOrderBy>>;
  where?: InputMaybe<LocationInvoicesBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesMaintenancePlanInvoicesArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanInvoicesOrderBy>>;
  where?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesMaintenancePlanInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanInvoicesOrderBy>>;
  where?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesPaymentRecordsArgs = {
  distinctOn?: InputMaybe<Array<PaymentRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecordsOrderBy>>;
  where?: InputMaybe<PaymentRecordsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesPaymentRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecordsOrderBy>>;
  where?: InputMaybe<PaymentRecordsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesWisetackLoanRecordsArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanRecordsOrderBy>>;
  where?: InputMaybe<WisetackLoanRecordsBoolExp>;
};


/** columns and relationships of "invoices" */
export type InvoicesWisetackLoanRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanRecordsOrderBy>>;
  where?: InputMaybe<WisetackLoanRecordsBoolExp>;
};

/** aggregated selection of "invoices" */
export type InvoicesAggregate = {
  __typename?: 'InvoicesAggregate';
  aggregate?: Maybe<InvoicesAggregateFields>;
  nodes: Array<Invoices>;
};

export type InvoicesAggregateBoolExp = {
  bool_and?: InputMaybe<InvoicesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<InvoicesAggregateBoolExpBool_Or>;
  count?: InputMaybe<InvoicesAggregateBoolExpCount>;
};

/** aggregate fields of "invoices" */
export type InvoicesAggregateFields = {
  __typename?: 'InvoicesAggregateFields';
  avg?: Maybe<InvoicesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InvoicesMaxFields>;
  min?: Maybe<InvoicesMinFields>;
  stddev?: Maybe<InvoicesStddevFields>;
  stddevPop?: Maybe<InvoicesStddevPopFields>;
  stddevSamp?: Maybe<InvoicesStddevSampFields>;
  sum?: Maybe<InvoicesSumFields>;
  varPop?: Maybe<InvoicesVarPopFields>;
  varSamp?: Maybe<InvoicesVarSampFields>;
  variance?: Maybe<InvoicesVarianceFields>;
};


/** aggregate fields of "invoices" */
export type InvoicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoices" */
export type InvoicesAggregateOrderBy = {
  avg?: InputMaybe<InvoicesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InvoicesMaxOrderBy>;
  min?: InputMaybe<InvoicesMinOrderBy>;
  stddev?: InputMaybe<InvoicesStddevOrderBy>;
  stddevPop?: InputMaybe<InvoicesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<InvoicesStddevSampOrderBy>;
  sum?: InputMaybe<InvoicesSumOrderBy>;
  varPop?: InputMaybe<InvoicesVarPopOrderBy>;
  varSamp?: InputMaybe<InvoicesVarSampOrderBy>;
  variance?: InputMaybe<InvoicesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "invoices" */
export type InvoicesArrRelInsertInput = {
  data: Array<InvoicesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InvoicesOnConflict>;
};

/** aggregate avg on columns */
export type InvoicesAvgFields = {
  __typename?: 'InvoicesAvgFields';
  displayId?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoices" */
export type InvoicesAvgOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  subtotalUsc?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "invoices". All fields are combined with a logical 'AND'. */
export type InvoicesBoolExp = {
  _and?: InputMaybe<Array<InvoicesBoolExp>>;
  _not?: InputMaybe<InvoicesBoolExp>;
  _or?: InputMaybe<Array<InvoicesBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  accountingStaleInfo?: InputMaybe<InvoicesV2AccountingStaleBoolExp>;
  aggregatableInvoice?: InputMaybe<AggregatableInvoicesBoolExp>;
  billingAddress?: InputMaybe<AddressesBoolExp>;
  billingAddressGuid?: InputMaybe<UuidComparisonExp>;
  billingContact?: InputMaybe<ContactsBoolExp>;
  billingContactGuid?: InputMaybe<UuidComparisonExp>;
  businessUnitLink?: InputMaybe<InvoiceBusinessUnitBoolExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  customerPurchaseOrderNumber?: InputMaybe<StringComparisonExp>;
  displayId?: InputMaybe<IntComparisonExp>;
  displayIdV2?: InputMaybe<StringComparisonExp>;
  doNotSyncToAccountingServiceReason?: InputMaybe<StringComparisonExp>;
  dueAt?: InputMaybe<TimestamptzComparisonExp>;
  dynamicPricingType?: InputMaybe<Scalars['DynamicPricingTypeComparisonExp']>;
  estimateLink?: InputMaybe<EstimateInvoicesBoolExp>;
  hideLineItemPrices?: InputMaybe<BooleanComparisonExp>;
  invoiceCartItemBundleItems?: InputMaybe<InvoiceCartItemBundleItemsBoolExp>;
  invoiceCartItemBundleItemsAggregate?: InputMaybe<InvoiceCartItemBundleItemsAggregateBoolExp>;
  invoiceCartItems?: InputMaybe<InvoiceCartItemsBoolExp>;
  invoiceCartItemsAggregate?: InputMaybe<InvoiceCartItemsAggregateBoolExp>;
  invoiceDiscounts?: InputMaybe<InvoiceDiscountsBoolExp>;
  invoiceDiscountsAggregate?: InputMaybe<InvoiceDiscountsAggregateBoolExp>;
  invoiceEvents?: InputMaybe<InvoiceEventsBoolExp>;
  invoiceEventsAggregate?: InputMaybe<InvoiceEventsAggregateBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  invoicePayments?: InputMaybe<InvoicePaymentsBoolExp>;
  invoicePaymentsAggregate?: InputMaybe<InvoicePaymentsAggregateBoolExp>;
  invoiceReminderData?: InputMaybe<InvoiceReminderDataBoolExp>;
  invoiceTerm?: InputMaybe<Scalars['InvoiceTermV2ComparisonExp']>;
  issuedAt?: InputMaybe<TimestamptzComparisonExp>;
  jobAppointmentInvoices?: InputMaybe<JobAppointmentInvoicesBoolExp>;
  jobAppointmentInvoicesAggregate?: InputMaybe<JobAppointmentInvoicesAggregateBoolExp>;
  jobAppointmentLink?: InputMaybe<JobAppointmentInvoicesBoolExp>;
  jobInvoices?: InputMaybe<JobInvoicesBoolExp>;
  jobInvoicesAggregate?: InputMaybe<JobInvoicesAggregateBoolExp>;
  jobLink?: InputMaybe<JobInvoicesBoolExp>;
  locationInvoices?: InputMaybe<LocationInvoicesBoolExp>;
  locationInvoicesAggregate?: InputMaybe<LocationInvoicesAggregateBoolExp>;
  locationLink?: InputMaybe<LocationInvoicesBoolExp>;
  maintenancePlanInvoices?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
  maintenancePlanInvoicesAggregate?: InputMaybe<MaintenancePlanInvoicesAggregateBoolExp>;
  maintenancePlanLink?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
  maintenancePlanSavingsEnabled?: InputMaybe<BooleanComparisonExp>;
  messageHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
  paymentRecords?: InputMaybe<PaymentRecordsBoolExp>;
  paymentRecordsAggregate?: InputMaybe<PaymentRecordsAggregateBoolExp>;
  pricebookTaxRate?: InputMaybe<PricebookTaxRatesBoolExp>;
  qboStaleInfo?: InputMaybe<InvoicesV2QboStaleBoolExp>;
  qboSync?: InputMaybe<InvoicesV2QboStatusBoolExp>;
  serviceAddress?: InputMaybe<AddressesBoolExp>;
  serviceAddressGuid?: InputMaybe<UuidComparisonExp>;
  serviceCompletionDate?: InputMaybe<DateComparisonExp>;
  signatureFileUrl?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<Scalars['InvoiceV2StatusComparisonExp']>;
  subtotalUsc?: InputMaybe<IntComparisonExp>;
  taxConfiguration?: InputMaybe<InvoiceCompanyTaxConfigurationsViewBoolExp>;
  taxRate?: InputMaybe<NumericComparisonExp>;
  taxRateGuid?: InputMaybe<UuidComparisonExp>;
  taxRateName?: InputMaybe<StringComparisonExp>;
  totalUsc?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  wisetackLoanRecords?: InputMaybe<WisetackLoanRecordsBoolExp>;
  wisetackLoanRecordsAggregate?: InputMaybe<WisetackLoanRecordsAggregateBoolExp>;
};

/** unique or primary key constraints on table "invoices" */
export type InvoicesConstraint =
  /** unique or primary key constraint on columns "invoice_guid" */
  | 'invoices_pkey';

/** input type for incrementing numeric columns in table "invoices" */
export type InvoicesIncInput = {
  displayId?: InputMaybe<Scalars['Int']>;
  subtotalUsc?: InputMaybe<Scalars['Int']>;
  taxRate?: InputMaybe<Scalars['numeric']>;
  totalUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "invoices" */
export type InvoicesInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  accountingStaleInfo?: InputMaybe<InvoicesV2AccountingStaleObjRelInsertInput>;
  aggregatableInvoice?: InputMaybe<AggregatableInvoicesObjRelInsertInput>;
  billingAddress?: InputMaybe<AddressesObjRelInsertInput>;
  billingAddressGuid?: InputMaybe<Scalars['uuid']>;
  billingContact?: InputMaybe<ContactsObjRelInsertInput>;
  billingContactGuid?: InputMaybe<Scalars['uuid']>;
  businessUnitLink?: InputMaybe<InvoiceBusinessUnitObjRelInsertInput>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  customerPurchaseOrderNumber?: InputMaybe<Scalars['String']>;
  displayId?: InputMaybe<Scalars['Int']>;
  displayIdV2?: InputMaybe<Scalars['String']>;
  /** If set, Breezy will not sync this invoice to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  dynamicPricingType?: InputMaybe<Scalars['DynamicPricingType']>;
  estimateLink?: InputMaybe<EstimateInvoicesObjRelInsertInput>;
  /** Per-invoice override: hide per-line prices on customer-facing renders. Seeded from company_config.hide_line_item_prices at create. */
  hideLineItemPrices?: InputMaybe<Scalars['Boolean']>;
  invoiceCartItemBundleItems?: InputMaybe<InvoiceCartItemBundleItemsArrRelInsertInput>;
  invoiceCartItems?: InputMaybe<InvoiceCartItemsArrRelInsertInput>;
  invoiceDiscounts?: InputMaybe<InvoiceDiscountsArrRelInsertInput>;
  invoiceEvents?: InputMaybe<InvoiceEventsArrRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoicePayments?: InputMaybe<InvoicePaymentsArrRelInsertInput>;
  invoiceReminderData?: InputMaybe<InvoiceReminderDataObjRelInsertInput>;
  invoiceTerm?: InputMaybe<Scalars['InvoiceTermV2']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentInvoices?: InputMaybe<JobAppointmentInvoicesArrRelInsertInput>;
  jobAppointmentLink?: InputMaybe<JobAppointmentInvoicesObjRelInsertInput>;
  jobInvoices?: InputMaybe<JobInvoicesArrRelInsertInput>;
  jobLink?: InputMaybe<JobInvoicesObjRelInsertInput>;
  locationInvoices?: InputMaybe<LocationInvoicesArrRelInsertInput>;
  locationLink?: InputMaybe<LocationInvoicesObjRelInsertInput>;
  maintenancePlanInvoices?: InputMaybe<MaintenancePlanInvoicesArrRelInsertInput>;
  maintenancePlanLink?: InputMaybe<MaintenancePlanInvoicesObjRelInsertInput>;
  maintenancePlanSavingsEnabled?: InputMaybe<Scalars['Boolean']>;
  messageHtml?: InputMaybe<Scalars['HtmlString']>;
  paymentRecords?: InputMaybe<PaymentRecordsArrRelInsertInput>;
  pricebookTaxRate?: InputMaybe<PricebookTaxRatesObjRelInsertInput>;
  qboStaleInfo?: InputMaybe<InvoicesV2QboStaleObjRelInsertInput>;
  qboSync?: InputMaybe<InvoicesV2QboStatusObjRelInsertInput>;
  serviceAddress?: InputMaybe<AddressesObjRelInsertInput>;
  serviceAddressGuid?: InputMaybe<Scalars['uuid']>;
  serviceCompletionDate?: InputMaybe<Scalars['date']>;
  signatureFileUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['InvoiceV2Status']>;
  subtotalUsc?: InputMaybe<Scalars['Int']>;
  taxConfiguration?: InputMaybe<InvoiceCompanyTaxConfigurationsViewObjRelInsertInput>;
  taxRate?: InputMaybe<Scalars['numeric']>;
  taxRateGuid?: InputMaybe<Scalars['uuid']>;
  taxRateName?: InputMaybe<Scalars['String']>;
  totalUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wisetackLoanRecords?: InputMaybe<WisetackLoanRecordsArrRelInsertInput>;
};

/** aggregate max on columns */
export type InvoicesMaxFields = {
  __typename?: 'InvoicesMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  billingAddressGuid?: Maybe<Scalars['uuid']>;
  billingContactGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  customerPurchaseOrderNumber?: Maybe<Scalars['String']>;
  displayId?: Maybe<Scalars['Int']>;
  displayIdV2?: Maybe<Scalars['String']>;
  /** If set, Breezy will not sync this invoice to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  dynamicPricingType?: Maybe<Scalars['DynamicPricingType']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceTerm?: Maybe<Scalars['InvoiceTermV2']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  messageHtml?: Maybe<Scalars['HtmlString']>;
  serviceAddressGuid?: Maybe<Scalars['uuid']>;
  serviceCompletionDate?: Maybe<Scalars['date']>;
  signatureFileUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['InvoiceV2Status']>;
  subtotalUsc?: Maybe<Scalars['Int']>;
  taxRate?: Maybe<Scalars['numeric']>;
  taxRateGuid?: Maybe<Scalars['uuid']>;
  taxRateName?: Maybe<Scalars['String']>;
  totalUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invoices" */
export type InvoicesMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  billingAddressGuid?: InputMaybe<OrderBy>;
  billingContactGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  customerPurchaseOrderNumber?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  displayIdV2?: InputMaybe<OrderBy>;
  /** If set, Breezy will not sync this invoice to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  dynamicPricingType?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  invoiceTerm?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  messageHtml?: InputMaybe<OrderBy>;
  serviceAddressGuid?: InputMaybe<OrderBy>;
  serviceCompletionDate?: InputMaybe<OrderBy>;
  signatureFileUrl?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subtotalUsc?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  taxRateGuid?: InputMaybe<OrderBy>;
  taxRateName?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InvoicesMinFields = {
  __typename?: 'InvoicesMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  billingAddressGuid?: Maybe<Scalars['uuid']>;
  billingContactGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  customerPurchaseOrderNumber?: Maybe<Scalars['String']>;
  displayId?: Maybe<Scalars['Int']>;
  displayIdV2?: Maybe<Scalars['String']>;
  /** If set, Breezy will not sync this invoice to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  dynamicPricingType?: Maybe<Scalars['DynamicPricingType']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceTerm?: Maybe<Scalars['InvoiceTermV2']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  messageHtml?: Maybe<Scalars['HtmlString']>;
  serviceAddressGuid?: Maybe<Scalars['uuid']>;
  serviceCompletionDate?: Maybe<Scalars['date']>;
  signatureFileUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['InvoiceV2Status']>;
  subtotalUsc?: Maybe<Scalars['Int']>;
  taxRate?: Maybe<Scalars['numeric']>;
  taxRateGuid?: Maybe<Scalars['uuid']>;
  taxRateName?: Maybe<Scalars['String']>;
  totalUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invoices" */
export type InvoicesMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  billingAddressGuid?: InputMaybe<OrderBy>;
  billingContactGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  customerPurchaseOrderNumber?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  displayIdV2?: InputMaybe<OrderBy>;
  /** If set, Breezy will not sync this invoice to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  dynamicPricingType?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  invoiceTerm?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  messageHtml?: InputMaybe<OrderBy>;
  serviceAddressGuid?: InputMaybe<OrderBy>;
  serviceCompletionDate?: InputMaybe<OrderBy>;
  signatureFileUrl?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subtotalUsc?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  taxRateGuid?: InputMaybe<OrderBy>;
  taxRateName?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "invoices" */
export type InvoicesMutationResponse = {
  __typename?: 'InvoicesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoices>;
};

/** input type for inserting object relation for remote table "invoices" */
export type InvoicesObjRelInsertInput = {
  data: InvoicesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<InvoicesOnConflict>;
};

/** on_conflict condition type for table "invoices" */
export type InvoicesOnConflict = {
  constraint: InvoicesConstraint;
  updateColumns?: Array<InvoicesUpdateColumn>;
  where?: InputMaybe<InvoicesBoolExp>;
};

/** Ordering options when selecting data from "invoices". */
export type InvoicesOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  accountingStaleInfo?: InputMaybe<InvoicesV2AccountingStaleOrderBy>;
  aggregatableInvoice?: InputMaybe<AggregatableInvoicesOrderBy>;
  billingAddress?: InputMaybe<AddressesOrderBy>;
  billingAddressGuid?: InputMaybe<OrderBy>;
  billingContact?: InputMaybe<ContactsOrderBy>;
  billingContactGuid?: InputMaybe<OrderBy>;
  businessUnitLink?: InputMaybe<InvoiceBusinessUnitOrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  customerPurchaseOrderNumber?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  displayIdV2?: InputMaybe<OrderBy>;
  doNotSyncToAccountingServiceReason?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  dynamicPricingType?: InputMaybe<OrderBy>;
  estimateLink?: InputMaybe<EstimateInvoicesOrderBy>;
  hideLineItemPrices?: InputMaybe<OrderBy>;
  invoiceCartItemBundleItemsAggregate?: InputMaybe<InvoiceCartItemBundleItemsAggregateOrderBy>;
  invoiceCartItemsAggregate?: InputMaybe<InvoiceCartItemsAggregateOrderBy>;
  invoiceDiscountsAggregate?: InputMaybe<InvoiceDiscountsAggregateOrderBy>;
  invoiceEventsAggregate?: InputMaybe<InvoiceEventsAggregateOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  invoicePaymentsAggregate?: InputMaybe<InvoicePaymentsAggregateOrderBy>;
  invoiceReminderData?: InputMaybe<InvoiceReminderDataOrderBy>;
  invoiceTerm?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  jobAppointmentInvoicesAggregate?: InputMaybe<JobAppointmentInvoicesAggregateOrderBy>;
  jobAppointmentLink?: InputMaybe<JobAppointmentInvoicesOrderBy>;
  jobInvoicesAggregate?: InputMaybe<JobInvoicesAggregateOrderBy>;
  jobLink?: InputMaybe<JobInvoicesOrderBy>;
  locationInvoicesAggregate?: InputMaybe<LocationInvoicesAggregateOrderBy>;
  locationLink?: InputMaybe<LocationInvoicesOrderBy>;
  maintenancePlanInvoicesAggregate?: InputMaybe<MaintenancePlanInvoicesAggregateOrderBy>;
  maintenancePlanLink?: InputMaybe<MaintenancePlanInvoicesOrderBy>;
  maintenancePlanSavingsEnabled?: InputMaybe<OrderBy>;
  messageHtml?: InputMaybe<OrderBy>;
  paymentRecordsAggregate?: InputMaybe<PaymentRecordsAggregateOrderBy>;
  pricebookTaxRate?: InputMaybe<PricebookTaxRatesOrderBy>;
  qboStaleInfo?: InputMaybe<InvoicesV2QboStaleOrderBy>;
  qboSync?: InputMaybe<InvoicesV2QboStatusOrderBy>;
  serviceAddress?: InputMaybe<AddressesOrderBy>;
  serviceAddressGuid?: InputMaybe<OrderBy>;
  serviceCompletionDate?: InputMaybe<OrderBy>;
  signatureFileUrl?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subtotalUsc?: InputMaybe<OrderBy>;
  taxConfiguration?: InputMaybe<InvoiceCompanyTaxConfigurationsViewOrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  taxRateGuid?: InputMaybe<OrderBy>;
  taxRateName?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  wisetackLoanRecordsAggregate?: InputMaybe<WisetackLoanRecordsAggregateOrderBy>;
};

/** primary key columns input for table: invoices */
export type InvoicesPkColumnsInput = {
  invoiceGuid: Scalars['uuid'];
};

/** columns and relationships of "invoices_qbo_status" */
export type InvoicesQboStatus = {
  __typename?: 'InvoicesQboStatus';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "invoices_qbo_status" */
export type InvoicesQboStatusAggregate = {
  __typename?: 'InvoicesQboStatusAggregate';
  aggregate?: Maybe<InvoicesQboStatusAggregateFields>;
  nodes: Array<InvoicesQboStatus>;
};

/** aggregate fields of "invoices_qbo_status" */
export type InvoicesQboStatusAggregateFields = {
  __typename?: 'InvoicesQboStatusAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InvoicesQboStatusMaxFields>;
  min?: Maybe<InvoicesQboStatusMinFields>;
};


/** aggregate fields of "invoices_qbo_status" */
export type InvoicesQboStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoicesQboStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "invoices_qbo_status". All fields are combined with a logical 'AND'. */
export type InvoicesQboStatusBoolExp = {
  _and?: InputMaybe<Array<InvoicesQboStatusBoolExp>>;
  _not?: InputMaybe<InvoicesQboStatusBoolExp>;
  _or?: InputMaybe<Array<InvoicesQboStatusBoolExp>>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  qboId?: InputMaybe<StringComparisonExp>;
  qboSyncedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "invoices_qbo_status" */
export type InvoicesQboStatusInsertInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  qboId?: InputMaybe<Scalars['String']>;
  qboSyncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InvoicesQboStatusMaxFields = {
  __typename?: 'InvoicesQboStatusMaxFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type InvoicesQboStatusMinFields = {
  __typename?: 'InvoicesQboStatusMinFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "invoices_qbo_status" */
export type InvoicesQboStatusObjRelInsertInput = {
  data: InvoicesQboStatusInsertInput;
};

/** Ordering options when selecting data from "invoices_qbo_status". */
export type InvoicesQboStatusOrderBy = {
  invoiceGuid?: InputMaybe<OrderBy>;
  qboId?: InputMaybe<OrderBy>;
  qboSyncedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "invoices_qbo_status" */
export type InvoicesQboStatusSelectColumn =
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'qboId'
  /** column name */
  | 'qboSyncedAt';

/** Streaming cursor of the table "invoices_qbo_status" */
export type InvoicesQboStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoicesQboStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoicesQboStatusStreamCursorValueInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  qboId?: InputMaybe<Scalars['String']>;
  qboSyncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "invoices_queryable" */
export type InvoicesQueryable = {
  __typename?: 'InvoicesQueryable';
  /** An object relationship */
  account: Accounts;
  accountGuid: Scalars['uuid'];
  balanceAmountUsd: Scalars['numeric'];
  companyGuid: Scalars['uuid'];
  /** An object relationship */
  companyNotificationSettingsOne?: Maybe<CompanyNotificationSettings>;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  /** A computed field, executes function "calculate_days_unpaid" */
  daysUnpaid?: Maybe<Scalars['Int']>;
  discountAmountUsd: Scalars['numeric'];
  displayId: Scalars['Int'];
  /** A computed field, executes function "invoice_display_id_as_text" */
  displayIdString?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  dueAt: Scalars['timestamptz'];
  estimateGuid?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  events: Array<EventStore>;
  /** An aggregate relationship */
  eventsAggregate: EventStoreAggregate;
  invoiceGuid: Scalars['uuid'];
  /** An array relationship */
  invoicePayments: Array<InvoicePayments>;
  /** An aggregate relationship */
  invoicePaymentsAggregate: InvoicePaymentsAggregate;
  invoiceStatus: Scalars['InvoiceStatuses'];
  invoiceTerm: InvoiceTermsEnum;
  /** A computed field, executes function "is_terminal_invoice_status" */
  isTerminalStatus?: Maybe<Scalars['Boolean']>;
  issuedAt: Scalars['timestamptz'];
  /** An object relationship */
  job?: Maybe<Jobs>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  lastAlteredAt: Scalars['timestamptz'];
  lastPaidAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  location?: Maybe<Locations>;
  locationGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  maintenancePlan?: Maybe<MaintenancePlansQueryable>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "invoices_queryable_num_days_overdue" */
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidAmountUsd: Scalars['numeric'];
  paymentMethodTypeDescription?: Maybe<Scalars['String']>;
  previousSelfServePaymentLink?: Maybe<Scalars['String']>;
  /** An object relationship */
  qboSync?: Maybe<InvoicesQboStatus>;
  /** An object relationship */
  qbo_status?: Maybe<InvoicesQueryableWithQboStatus>;
  referenceNumber: Scalars['String'];
  remindersSent: Scalars['Int'];
  selfServePaymentLinkSentAt?: Maybe<Scalars['timestamptz']>;
  subtotalPriceUsd: Scalars['numeric'];
  summary?: Maybe<Scalars['String']>;
  taxAmountUsd: Scalars['numeric'];
  totalAmountUsd: Scalars['numeric'];
  updatedAt: Scalars['timestamptz'];
  workCompletedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "invoices_queryable" */
export type InvoicesQueryableEventsArgs = {
  distinctOn?: InputMaybe<Array<EventStoreSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventStoreOrderBy>>;
  where?: InputMaybe<EventStoreBoolExp>;
};


/** columns and relationships of "invoices_queryable" */
export type InvoicesQueryableEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventStoreSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventStoreOrderBy>>;
  where?: InputMaybe<EventStoreBoolExp>;
};


/** columns and relationships of "invoices_queryable" */
export type InvoicesQueryableInvoicePaymentsArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


/** columns and relationships of "invoices_queryable" */
export type InvoicesQueryableInvoicePaymentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};

/** aggregated selection of "invoices_queryable" */
export type InvoicesQueryableAggregate = {
  __typename?: 'InvoicesQueryableAggregate';
  aggregate?: Maybe<InvoicesQueryableAggregateFields>;
  nodes: Array<InvoicesQueryable>;
};

export type InvoicesQueryableAggregateBoolExp = {
  count?: InputMaybe<InvoicesQueryableAggregateBoolExpCount>;
};

/** aggregate fields of "invoices_queryable" */
export type InvoicesQueryableAggregateFields = {
  __typename?: 'InvoicesQueryableAggregateFields';
  avg?: Maybe<InvoicesQueryableAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InvoicesQueryableMaxFields>;
  min?: Maybe<InvoicesQueryableMinFields>;
  stddev?: Maybe<InvoicesQueryableStddevFields>;
  stddevPop?: Maybe<InvoicesQueryableStddevPopFields>;
  stddevSamp?: Maybe<InvoicesQueryableStddevSampFields>;
  sum?: Maybe<InvoicesQueryableSumFields>;
  varPop?: Maybe<InvoicesQueryableVarPopFields>;
  varSamp?: Maybe<InvoicesQueryableVarSampFields>;
  variance?: Maybe<InvoicesQueryableVarianceFields>;
};


/** aggregate fields of "invoices_queryable" */
export type InvoicesQueryableAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoicesQueryableSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoices_queryable" */
export type InvoicesQueryableAggregateOrderBy = {
  avg?: InputMaybe<InvoicesQueryableAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InvoicesQueryableMaxOrderBy>;
  min?: InputMaybe<InvoicesQueryableMinOrderBy>;
  stddev?: InputMaybe<InvoicesQueryableStddevOrderBy>;
  stddevPop?: InputMaybe<InvoicesQueryableStddevPopOrderBy>;
  stddevSamp?: InputMaybe<InvoicesQueryableStddevSampOrderBy>;
  sum?: InputMaybe<InvoicesQueryableSumOrderBy>;
  varPop?: InputMaybe<InvoicesQueryableVarPopOrderBy>;
  varSamp?: InputMaybe<InvoicesQueryableVarSampOrderBy>;
  variance?: InputMaybe<InvoicesQueryableVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "invoices_queryable" */
export type InvoicesQueryableArrRelInsertInput = {
  data: Array<InvoicesQueryableInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<InvoicesQueryableOnConflict>;
};

/** aggregate avg on columns */
export type InvoicesQueryableAvgFields = {
  __typename?: 'InvoicesQueryableAvgFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "calculate_days_unpaid" */
  daysUnpaid?: Maybe<Scalars['Int']>;
  discountAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "invoices_queryable_num_days_overdue" */
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  subtotalPriceUsd?: Maybe<Scalars['Float']>;
  taxAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoices_queryable" */
export type InvoicesQueryableAvgOrderBy = {
  balanceAmountUsd?: InputMaybe<OrderBy>;
  discountAmountUsd?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  paidAmountUsd?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  subtotalPriceUsd?: InputMaybe<OrderBy>;
  taxAmountUsd?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "invoices_queryable". All fields are combined with a logical 'AND'. */
export type InvoicesQueryableBoolExp = {
  _and?: InputMaybe<Array<InvoicesQueryableBoolExp>>;
  _not?: InputMaybe<InvoicesQueryableBoolExp>;
  _or?: InputMaybe<Array<InvoicesQueryableBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  balanceAmountUsd?: InputMaybe<NumericComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  companyNotificationSettingsOne?: InputMaybe<CompanyNotificationSettingsBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  daysUnpaid?: InputMaybe<IntComparisonExp>;
  discountAmountUsd?: InputMaybe<NumericComparisonExp>;
  displayId?: InputMaybe<IntComparisonExp>;
  displayIdString?: InputMaybe<StringComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  dueAt?: InputMaybe<TimestamptzComparisonExp>;
  estimateGuid?: InputMaybe<UuidComparisonExp>;
  events?: InputMaybe<EventStoreBoolExp>;
  eventsAggregate?: InputMaybe<EventStoreAggregateBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  invoicePayments?: InputMaybe<InvoicePaymentsBoolExp>;
  invoicePaymentsAggregate?: InputMaybe<InvoicePaymentsAggregateBoolExp>;
  invoiceStatus?: InputMaybe<Scalars['InvoiceStatusesComparisonExp']>;
  invoiceTerm?: InputMaybe<InvoiceTermsEnumComparisonExp>;
  isTerminalStatus?: InputMaybe<BooleanComparisonExp>;
  issuedAt?: InputMaybe<TimestamptzComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  lastAlteredAt?: InputMaybe<TimestamptzComparisonExp>;
  lastPaidAt?: InputMaybe<TimestamptzComparisonExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableBoolExp>;
  maintenancePlanGuid?: InputMaybe<UuidComparisonExp>;
  numDaysOverdue?: InputMaybe<IntComparisonExp>;
  paidAmountUsd?: InputMaybe<NumericComparisonExp>;
  paymentMethodTypeDescription?: InputMaybe<StringComparisonExp>;
  previousSelfServePaymentLink?: InputMaybe<StringComparisonExp>;
  qboSync?: InputMaybe<InvoicesQboStatusBoolExp>;
  qbo_status?: InputMaybe<InvoicesQueryableWithQboStatusBoolExp>;
  referenceNumber?: InputMaybe<StringComparisonExp>;
  remindersSent?: InputMaybe<IntComparisonExp>;
  selfServePaymentLinkSentAt?: InputMaybe<TimestamptzComparisonExp>;
  subtotalPriceUsd?: InputMaybe<NumericComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
  taxAmountUsd?: InputMaybe<NumericComparisonExp>;
  totalAmountUsd?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  workCompletedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "invoices_queryable" */
export type InvoicesQueryableConstraint =
  /** unique or primary key constraint on columns "display_id", "company_guid" */
  | 'invoices_queryable_display_id_company_unique'
  /** unique or primary key constraint on columns "invoice_guid" */
  | 'invoices_queryable_pkey';

/** input type for incrementing numeric columns in table "invoices_queryable" */
export type InvoicesQueryableIncInput = {
  balanceAmountUsd?: InputMaybe<Scalars['numeric']>;
  discountAmountUsd?: InputMaybe<Scalars['numeric']>;
  displayId?: InputMaybe<Scalars['Int']>;
  paidAmountUsd?: InputMaybe<Scalars['numeric']>;
  remindersSent?: InputMaybe<Scalars['Int']>;
  subtotalPriceUsd?: InputMaybe<Scalars['numeric']>;
  taxAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalAmountUsd?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "invoices_queryable" */
export type InvoicesQueryableInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  balanceAmountUsd?: InputMaybe<Scalars['numeric']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyNotificationSettingsOne?: InputMaybe<CompanyNotificationSettingsObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  discountAmountUsd?: InputMaybe<Scalars['numeric']>;
  displayId?: InputMaybe<Scalars['Int']>;
  displayName?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  events?: InputMaybe<EventStoreArrRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoicePayments?: InputMaybe<InvoicePaymentsArrRelInsertInput>;
  invoiceStatus?: InputMaybe<Scalars['InvoiceStatuses']>;
  invoiceTerm?: InputMaybe<InvoiceTermsEnum>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  lastAlteredAt?: InputMaybe<Scalars['timestamptz']>;
  lastPaidAt?: InputMaybe<Scalars['timestamptz']>;
  location?: InputMaybe<LocationsObjRelInsertInput>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableObjRelInsertInput>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  paidAmountUsd?: InputMaybe<Scalars['numeric']>;
  paymentMethodTypeDescription?: InputMaybe<Scalars['String']>;
  previousSelfServePaymentLink?: InputMaybe<Scalars['String']>;
  qboSync?: InputMaybe<InvoicesQboStatusObjRelInsertInput>;
  qbo_status?: InputMaybe<InvoicesQueryableWithQboStatusObjRelInsertInput>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  remindersSent?: InputMaybe<Scalars['Int']>;
  selfServePaymentLinkSentAt?: InputMaybe<Scalars['timestamptz']>;
  subtotalPriceUsd?: InputMaybe<Scalars['numeric']>;
  summary?: InputMaybe<Scalars['String']>;
  taxAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalAmountUsd?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workCompletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InvoicesQueryableMaxFields = {
  __typename?: 'InvoicesQueryableMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  balanceAmountUsd?: Maybe<Scalars['numeric']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "calculate_days_unpaid" */
  daysUnpaid?: Maybe<Scalars['Int']>;
  discountAmountUsd?: Maybe<Scalars['numeric']>;
  displayId?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "invoice_display_id_as_text" */
  displayIdString?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceStatus?: Maybe<Scalars['InvoiceStatuses']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  lastAlteredAt?: Maybe<Scalars['timestamptz']>;
  lastPaidAt?: Maybe<Scalars['timestamptz']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "invoices_queryable_num_days_overdue" */
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidAmountUsd?: Maybe<Scalars['numeric']>;
  paymentMethodTypeDescription?: Maybe<Scalars['String']>;
  previousSelfServePaymentLink?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  remindersSent?: Maybe<Scalars['Int']>;
  selfServePaymentLinkSentAt?: Maybe<Scalars['timestamptz']>;
  subtotalPriceUsd?: Maybe<Scalars['numeric']>;
  summary?: Maybe<Scalars['String']>;
  taxAmountUsd?: Maybe<Scalars['numeric']>;
  totalAmountUsd?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workCompletedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invoices_queryable" */
export type InvoicesQueryableMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  balanceAmountUsd?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  discountAmountUsd?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  invoiceStatus?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  lastAlteredAt?: InputMaybe<OrderBy>;
  lastPaidAt?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  paidAmountUsd?: InputMaybe<OrderBy>;
  paymentMethodTypeDescription?: InputMaybe<OrderBy>;
  previousSelfServePaymentLink?: InputMaybe<OrderBy>;
  referenceNumber?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  selfServePaymentLinkSentAt?: InputMaybe<OrderBy>;
  subtotalPriceUsd?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  taxAmountUsd?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workCompletedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type InvoicesQueryableMinFields = {
  __typename?: 'InvoicesQueryableMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  balanceAmountUsd?: Maybe<Scalars['numeric']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "calculate_days_unpaid" */
  daysUnpaid?: Maybe<Scalars['Int']>;
  discountAmountUsd?: Maybe<Scalars['numeric']>;
  displayId?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "invoice_display_id_as_text" */
  displayIdString?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceStatus?: Maybe<Scalars['InvoiceStatuses']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  lastAlteredAt?: Maybe<Scalars['timestamptz']>;
  lastPaidAt?: Maybe<Scalars['timestamptz']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "invoices_queryable_num_days_overdue" */
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidAmountUsd?: Maybe<Scalars['numeric']>;
  paymentMethodTypeDescription?: Maybe<Scalars['String']>;
  previousSelfServePaymentLink?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  remindersSent?: Maybe<Scalars['Int']>;
  selfServePaymentLinkSentAt?: Maybe<Scalars['timestamptz']>;
  subtotalPriceUsd?: Maybe<Scalars['numeric']>;
  summary?: Maybe<Scalars['String']>;
  taxAmountUsd?: Maybe<Scalars['numeric']>;
  totalAmountUsd?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workCompletedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invoices_queryable" */
export type InvoicesQueryableMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  balanceAmountUsd?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  discountAmountUsd?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  invoiceStatus?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  lastAlteredAt?: InputMaybe<OrderBy>;
  lastPaidAt?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  paidAmountUsd?: InputMaybe<OrderBy>;
  paymentMethodTypeDescription?: InputMaybe<OrderBy>;
  previousSelfServePaymentLink?: InputMaybe<OrderBy>;
  referenceNumber?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  selfServePaymentLinkSentAt?: InputMaybe<OrderBy>;
  subtotalPriceUsd?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  taxAmountUsd?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workCompletedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "invoices_queryable" */
export type InvoicesQueryableMutationResponse = {
  __typename?: 'InvoicesQueryableMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvoicesQueryable>;
};

/** input type for inserting object relation for remote table "invoices_queryable" */
export type InvoicesQueryableObjRelInsertInput = {
  data: InvoicesQueryableInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<InvoicesQueryableOnConflict>;
};

/** on_conflict condition type for table "invoices_queryable" */
export type InvoicesQueryableOnConflict = {
  constraint: InvoicesQueryableConstraint;
  updateColumns?: Array<InvoicesQueryableUpdateColumn>;
  where?: InputMaybe<InvoicesQueryableBoolExp>;
};

/** Ordering options when selecting data from "invoices_queryable". */
export type InvoicesQueryableOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  balanceAmountUsd?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  companyNotificationSettingsOne?: InputMaybe<CompanyNotificationSettingsOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  daysUnpaid?: InputMaybe<OrderBy>;
  discountAmountUsd?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  displayIdString?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  eventsAggregate?: InputMaybe<EventStoreAggregateOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  invoicePaymentsAggregate?: InputMaybe<InvoicePaymentsAggregateOrderBy>;
  invoiceStatus?: InputMaybe<OrderBy>;
  invoiceTerm?: InputMaybe<OrderBy>;
  isTerminalStatus?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  lastAlteredAt?: InputMaybe<OrderBy>;
  lastPaidAt?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableOrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  numDaysOverdue?: InputMaybe<OrderBy>;
  paidAmountUsd?: InputMaybe<OrderBy>;
  paymentMethodTypeDescription?: InputMaybe<OrderBy>;
  previousSelfServePaymentLink?: InputMaybe<OrderBy>;
  qboSync?: InputMaybe<InvoicesQboStatusOrderBy>;
  qbo_status?: InputMaybe<InvoicesQueryableWithQboStatusOrderBy>;
  referenceNumber?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  selfServePaymentLinkSentAt?: InputMaybe<OrderBy>;
  subtotalPriceUsd?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  taxAmountUsd?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workCompletedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: invoices_queryable */
export type InvoicesQueryablePkColumnsInput = {
  invoiceGuid: Scalars['uuid'];
};

/** select columns of table "invoices_queryable" */
export type InvoicesQueryableSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'balanceAmountUsd'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'discountAmountUsd'
  /** column name */
  | 'displayId'
  /** column name */
  | 'displayName'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'invoiceStatus'
  /** column name */
  | 'invoiceTerm'
  /** column name */
  | 'issuedAt'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'lastAlteredAt'
  /** column name */
  | 'lastPaidAt'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'paidAmountUsd'
  /** column name */
  | 'paymentMethodTypeDescription'
  /** column name */
  | 'previousSelfServePaymentLink'
  /** column name */
  | 'referenceNumber'
  /** column name */
  | 'remindersSent'
  /** column name */
  | 'selfServePaymentLinkSentAt'
  /** column name */
  | 'subtotalPriceUsd'
  /** column name */
  | 'summary'
  /** column name */
  | 'taxAmountUsd'
  /** column name */
  | 'totalAmountUsd'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'workCompletedAt';

/** input type for updating data in table "invoices_queryable" */
export type InvoicesQueryableSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  balanceAmountUsd?: InputMaybe<Scalars['numeric']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  discountAmountUsd?: InputMaybe<Scalars['numeric']>;
  displayId?: InputMaybe<Scalars['Int']>;
  displayName?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoiceStatus?: InputMaybe<Scalars['InvoiceStatuses']>;
  invoiceTerm?: InputMaybe<InvoiceTermsEnum>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  lastAlteredAt?: InputMaybe<Scalars['timestamptz']>;
  lastPaidAt?: InputMaybe<Scalars['timestamptz']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  paidAmountUsd?: InputMaybe<Scalars['numeric']>;
  paymentMethodTypeDescription?: InputMaybe<Scalars['String']>;
  previousSelfServePaymentLink?: InputMaybe<Scalars['String']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  remindersSent?: InputMaybe<Scalars['Int']>;
  selfServePaymentLinkSentAt?: InputMaybe<Scalars['timestamptz']>;
  subtotalPriceUsd?: InputMaybe<Scalars['numeric']>;
  summary?: InputMaybe<Scalars['String']>;
  taxAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalAmountUsd?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workCompletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type InvoicesQueryableStddevFields = {
  __typename?: 'InvoicesQueryableStddevFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "calculate_days_unpaid" */
  daysUnpaid?: Maybe<Scalars['Int']>;
  discountAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "invoices_queryable_num_days_overdue" */
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  subtotalPriceUsd?: Maybe<Scalars['Float']>;
  taxAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoices_queryable" */
export type InvoicesQueryableStddevOrderBy = {
  balanceAmountUsd?: InputMaybe<OrderBy>;
  discountAmountUsd?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  paidAmountUsd?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  subtotalPriceUsd?: InputMaybe<OrderBy>;
  taxAmountUsd?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type InvoicesQueryableStddevPopFields = {
  __typename?: 'InvoicesQueryableStddevPopFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "calculate_days_unpaid" */
  daysUnpaid?: Maybe<Scalars['Int']>;
  discountAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "invoices_queryable_num_days_overdue" */
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  subtotalPriceUsd?: Maybe<Scalars['Float']>;
  taxAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "invoices_queryable" */
export type InvoicesQueryableStddevPopOrderBy = {
  balanceAmountUsd?: InputMaybe<OrderBy>;
  discountAmountUsd?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  paidAmountUsd?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  subtotalPriceUsd?: InputMaybe<OrderBy>;
  taxAmountUsd?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type InvoicesQueryableStddevSampFields = {
  __typename?: 'InvoicesQueryableStddevSampFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "calculate_days_unpaid" */
  daysUnpaid?: Maybe<Scalars['Int']>;
  discountAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "invoices_queryable_num_days_overdue" */
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  subtotalPriceUsd?: Maybe<Scalars['Float']>;
  taxAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "invoices_queryable" */
export type InvoicesQueryableStddevSampOrderBy = {
  balanceAmountUsd?: InputMaybe<OrderBy>;
  discountAmountUsd?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  paidAmountUsd?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  subtotalPriceUsd?: InputMaybe<OrderBy>;
  taxAmountUsd?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "invoices_queryable" */
export type InvoicesQueryableStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoicesQueryableStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoicesQueryableStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  balanceAmountUsd?: InputMaybe<Scalars['numeric']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  discountAmountUsd?: InputMaybe<Scalars['numeric']>;
  displayId?: InputMaybe<Scalars['Int']>;
  displayName?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoiceStatus?: InputMaybe<Scalars['InvoiceStatuses']>;
  invoiceTerm?: InputMaybe<InvoiceTermsEnum>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  lastAlteredAt?: InputMaybe<Scalars['timestamptz']>;
  lastPaidAt?: InputMaybe<Scalars['timestamptz']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  paidAmountUsd?: InputMaybe<Scalars['numeric']>;
  paymentMethodTypeDescription?: InputMaybe<Scalars['String']>;
  previousSelfServePaymentLink?: InputMaybe<Scalars['String']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  remindersSent?: InputMaybe<Scalars['Int']>;
  selfServePaymentLinkSentAt?: InputMaybe<Scalars['timestamptz']>;
  subtotalPriceUsd?: InputMaybe<Scalars['numeric']>;
  summary?: InputMaybe<Scalars['String']>;
  taxAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalAmountUsd?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workCompletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type InvoicesQueryableSumFields = {
  __typename?: 'InvoicesQueryableSumFields';
  balanceAmountUsd?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "calculate_days_unpaid" */
  daysUnpaid?: Maybe<Scalars['Int']>;
  discountAmountUsd?: Maybe<Scalars['numeric']>;
  displayId?: Maybe<Scalars['Int']>;
  /** A computed field, executes function "invoices_queryable_num_days_overdue" */
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidAmountUsd?: Maybe<Scalars['numeric']>;
  remindersSent?: Maybe<Scalars['Int']>;
  subtotalPriceUsd?: Maybe<Scalars['numeric']>;
  taxAmountUsd?: Maybe<Scalars['numeric']>;
  totalAmountUsd?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "invoices_queryable" */
export type InvoicesQueryableSumOrderBy = {
  balanceAmountUsd?: InputMaybe<OrderBy>;
  discountAmountUsd?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  paidAmountUsd?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  subtotalPriceUsd?: InputMaybe<OrderBy>;
  taxAmountUsd?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
};

/** update columns of table "invoices_queryable" */
export type InvoicesQueryableUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'balanceAmountUsd'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'discountAmountUsd'
  /** column name */
  | 'displayId'
  /** column name */
  | 'displayName'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'invoiceStatus'
  /** column name */
  | 'invoiceTerm'
  /** column name */
  | 'issuedAt'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'lastAlteredAt'
  /** column name */
  | 'lastPaidAt'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'paidAmountUsd'
  /** column name */
  | 'paymentMethodTypeDescription'
  /** column name */
  | 'previousSelfServePaymentLink'
  /** column name */
  | 'referenceNumber'
  /** column name */
  | 'remindersSent'
  /** column name */
  | 'selfServePaymentLinkSentAt'
  /** column name */
  | 'subtotalPriceUsd'
  /** column name */
  | 'summary'
  /** column name */
  | 'taxAmountUsd'
  /** column name */
  | 'totalAmountUsd'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'workCompletedAt';

export type InvoicesQueryableUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvoicesQueryableIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoicesQueryableSetInput>;
  /** filter the rows which have to be updated */
  where: InvoicesQueryableBoolExp;
};

/** aggregate varPop on columns */
export type InvoicesQueryableVarPopFields = {
  __typename?: 'InvoicesQueryableVarPopFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "calculate_days_unpaid" */
  daysUnpaid?: Maybe<Scalars['Int']>;
  discountAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "invoices_queryable_num_days_overdue" */
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  subtotalPriceUsd?: Maybe<Scalars['Float']>;
  taxAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "invoices_queryable" */
export type InvoicesQueryableVarPopOrderBy = {
  balanceAmountUsd?: InputMaybe<OrderBy>;
  discountAmountUsd?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  paidAmountUsd?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  subtotalPriceUsd?: InputMaybe<OrderBy>;
  taxAmountUsd?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type InvoicesQueryableVarSampFields = {
  __typename?: 'InvoicesQueryableVarSampFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "calculate_days_unpaid" */
  daysUnpaid?: Maybe<Scalars['Int']>;
  discountAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "invoices_queryable_num_days_overdue" */
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  subtotalPriceUsd?: Maybe<Scalars['Float']>;
  taxAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "invoices_queryable" */
export type InvoicesQueryableVarSampOrderBy = {
  balanceAmountUsd?: InputMaybe<OrderBy>;
  discountAmountUsd?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  paidAmountUsd?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  subtotalPriceUsd?: InputMaybe<OrderBy>;
  taxAmountUsd?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type InvoicesQueryableVarianceFields = {
  __typename?: 'InvoicesQueryableVarianceFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "calculate_days_unpaid" */
  daysUnpaid?: Maybe<Scalars['Int']>;
  discountAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "invoices_queryable_num_days_overdue" */
  numDaysOverdue?: Maybe<Scalars['Int']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  remindersSent?: Maybe<Scalars['Float']>;
  subtotalPriceUsd?: Maybe<Scalars['Float']>;
  taxAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoices_queryable" */
export type InvoicesQueryableVarianceOrderBy = {
  balanceAmountUsd?: InputMaybe<OrderBy>;
  discountAmountUsd?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  paidAmountUsd?: InputMaybe<OrderBy>;
  remindersSent?: InputMaybe<OrderBy>;
  subtotalPriceUsd?: InputMaybe<OrderBy>;
  taxAmountUsd?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
};

/** columns and relationships of "invoices_queryable_with_qbo_status" */
export type InvoicesQueryableWithQboStatus = {
  __typename?: 'InvoicesQueryableWithQboStatus';
  accountGuid?: Maybe<Scalars['uuid']>;
  balanceAmountUsd?: Maybe<Scalars['numeric']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  displayId?: Maybe<Scalars['Int']>;
  displayName?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceStatus?: Maybe<Scalars['String']>;
  invoiceTerm?: Maybe<Scalars['String']>;
  isQboStale?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  lastAlteredAt?: Maybe<Scalars['timestamptz']>;
  lastPaidAt?: Maybe<Scalars['timestamptz']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  paidAmountUsd?: Maybe<Scalars['numeric']>;
  paymentMethodTypeDescription?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
  referenceNumber?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  totalAmountUsd?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workCompletedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "invoices_queryable_with_qbo_status" */
export type InvoicesQueryableWithQboStatusAggregate = {
  __typename?: 'InvoicesQueryableWithQboStatusAggregate';
  aggregate?: Maybe<InvoicesQueryableWithQboStatusAggregateFields>;
  nodes: Array<InvoicesQueryableWithQboStatus>;
};

/** aggregate fields of "invoices_queryable_with_qbo_status" */
export type InvoicesQueryableWithQboStatusAggregateFields = {
  __typename?: 'InvoicesQueryableWithQboStatusAggregateFields';
  avg?: Maybe<InvoicesQueryableWithQboStatusAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<InvoicesQueryableWithQboStatusMaxFields>;
  min?: Maybe<InvoicesQueryableWithQboStatusMinFields>;
  stddev?: Maybe<InvoicesQueryableWithQboStatusStddevFields>;
  stddevPop?: Maybe<InvoicesQueryableWithQboStatusStddevPopFields>;
  stddevSamp?: Maybe<InvoicesQueryableWithQboStatusStddevSampFields>;
  sum?: Maybe<InvoicesQueryableWithQboStatusSumFields>;
  varPop?: Maybe<InvoicesQueryableWithQboStatusVarPopFields>;
  varSamp?: Maybe<InvoicesQueryableWithQboStatusVarSampFields>;
  variance?: Maybe<InvoicesQueryableWithQboStatusVarianceFields>;
};


/** aggregate fields of "invoices_queryable_with_qbo_status" */
export type InvoicesQueryableWithQboStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoicesQueryableWithQboStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type InvoicesQueryableWithQboStatusAvgFields = {
  __typename?: 'InvoicesQueryableWithQboStatusAvgFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "invoices_queryable_with_qbo_status". All fields are combined with a logical 'AND'. */
export type InvoicesQueryableWithQboStatusBoolExp = {
  _and?: InputMaybe<Array<InvoicesQueryableWithQboStatusBoolExp>>;
  _not?: InputMaybe<InvoicesQueryableWithQboStatusBoolExp>;
  _or?: InputMaybe<Array<InvoicesQueryableWithQboStatusBoolExp>>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  balanceAmountUsd?: InputMaybe<NumericComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  displayId?: InputMaybe<IntComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  dueAt?: InputMaybe<TimestamptzComparisonExp>;
  estimateGuid?: InputMaybe<UuidComparisonExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  invoiceStatus?: InputMaybe<StringComparisonExp>;
  invoiceTerm?: InputMaybe<StringComparisonExp>;
  isQboStale?: InputMaybe<BooleanComparisonExp>;
  issuedAt?: InputMaybe<TimestamptzComparisonExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  lastAlteredAt?: InputMaybe<TimestamptzComparisonExp>;
  lastPaidAt?: InputMaybe<TimestamptzComparisonExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanGuid?: InputMaybe<UuidComparisonExp>;
  paidAmountUsd?: InputMaybe<NumericComparisonExp>;
  paymentMethodTypeDescription?: InputMaybe<StringComparisonExp>;
  qboSyncedAt?: InputMaybe<TimestamptzComparisonExp>;
  referenceNumber?: InputMaybe<StringComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
  totalAmountUsd?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  workCompletedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "invoices_queryable_with_qbo_status" */
export type InvoicesQueryableWithQboStatusInsertInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  balanceAmountUsd?: InputMaybe<Scalars['numeric']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  displayId?: InputMaybe<Scalars['Int']>;
  displayName?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoiceStatus?: InputMaybe<Scalars['String']>;
  invoiceTerm?: InputMaybe<Scalars['String']>;
  isQboStale?: InputMaybe<Scalars['Boolean']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  lastAlteredAt?: InputMaybe<Scalars['timestamptz']>;
  lastPaidAt?: InputMaybe<Scalars['timestamptz']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  paidAmountUsd?: InputMaybe<Scalars['numeric']>;
  paymentMethodTypeDescription?: InputMaybe<Scalars['String']>;
  qboSyncedAt?: InputMaybe<Scalars['timestamptz']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  totalAmountUsd?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workCompletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InvoicesQueryableWithQboStatusMaxFields = {
  __typename?: 'InvoicesQueryableWithQboStatusMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  balanceAmountUsd?: Maybe<Scalars['numeric']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  displayId?: Maybe<Scalars['Int']>;
  displayName?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceStatus?: Maybe<Scalars['String']>;
  invoiceTerm?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  lastAlteredAt?: Maybe<Scalars['timestamptz']>;
  lastPaidAt?: Maybe<Scalars['timestamptz']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  paidAmountUsd?: Maybe<Scalars['numeric']>;
  paymentMethodTypeDescription?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
  referenceNumber?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  totalAmountUsd?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workCompletedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type InvoicesQueryableWithQboStatusMinFields = {
  __typename?: 'InvoicesQueryableWithQboStatusMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  balanceAmountUsd?: Maybe<Scalars['numeric']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  displayId?: Maybe<Scalars['Int']>;
  displayName?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  estimateGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceStatus?: Maybe<Scalars['String']>;
  invoiceTerm?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  lastAlteredAt?: Maybe<Scalars['timestamptz']>;
  lastPaidAt?: Maybe<Scalars['timestamptz']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  paidAmountUsd?: Maybe<Scalars['numeric']>;
  paymentMethodTypeDescription?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
  referenceNumber?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  totalAmountUsd?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workCompletedAt?: Maybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "invoices_queryable_with_qbo_status" */
export type InvoicesQueryableWithQboStatusObjRelInsertInput = {
  data: InvoicesQueryableWithQboStatusInsertInput;
};

/** Ordering options when selecting data from "invoices_queryable_with_qbo_status". */
export type InvoicesQueryableWithQboStatusOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  balanceAmountUsd?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  invoiceStatus?: InputMaybe<OrderBy>;
  invoiceTerm?: InputMaybe<OrderBy>;
  isQboStale?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  lastAlteredAt?: InputMaybe<OrderBy>;
  lastPaidAt?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  paidAmountUsd?: InputMaybe<OrderBy>;
  paymentMethodTypeDescription?: InputMaybe<OrderBy>;
  qboSyncedAt?: InputMaybe<OrderBy>;
  referenceNumber?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  totalAmountUsd?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workCompletedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "invoices_queryable_with_qbo_status" */
export type InvoicesQueryableWithQboStatusSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'balanceAmountUsd'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'displayId'
  /** column name */
  | 'displayName'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'invoiceStatus'
  /** column name */
  | 'invoiceTerm'
  /** column name */
  | 'isQboStale'
  /** column name */
  | 'issuedAt'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'lastAlteredAt'
  /** column name */
  | 'lastPaidAt'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'paidAmountUsd'
  /** column name */
  | 'paymentMethodTypeDescription'
  /** column name */
  | 'qboSyncedAt'
  /** column name */
  | 'referenceNumber'
  /** column name */
  | 'summary'
  /** column name */
  | 'totalAmountUsd'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'workCompletedAt';

/** aggregate stddev on columns */
export type InvoicesQueryableWithQboStatusStddevFields = {
  __typename?: 'InvoicesQueryableWithQboStatusStddevFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type InvoicesQueryableWithQboStatusStddevPopFields = {
  __typename?: 'InvoicesQueryableWithQboStatusStddevPopFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type InvoicesQueryableWithQboStatusStddevSampFields = {
  __typename?: 'InvoicesQueryableWithQboStatusStddevSampFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "invoices_queryable_with_qbo_status" */
export type InvoicesQueryableWithQboStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoicesQueryableWithQboStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoicesQueryableWithQboStatusStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  balanceAmountUsd?: InputMaybe<Scalars['numeric']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  displayId?: InputMaybe<Scalars['Int']>;
  displayName?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoiceStatus?: InputMaybe<Scalars['String']>;
  invoiceTerm?: InputMaybe<Scalars['String']>;
  isQboStale?: InputMaybe<Scalars['Boolean']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  lastAlteredAt?: InputMaybe<Scalars['timestamptz']>;
  lastPaidAt?: InputMaybe<Scalars['timestamptz']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  paidAmountUsd?: InputMaybe<Scalars['numeric']>;
  paymentMethodTypeDescription?: InputMaybe<Scalars['String']>;
  qboSyncedAt?: InputMaybe<Scalars['timestamptz']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  totalAmountUsd?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  workCompletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type InvoicesQueryableWithQboStatusSumFields = {
  __typename?: 'InvoicesQueryableWithQboStatusSumFields';
  balanceAmountUsd?: Maybe<Scalars['numeric']>;
  displayId?: Maybe<Scalars['Int']>;
  paidAmountUsd?: Maybe<Scalars['numeric']>;
  totalAmountUsd?: Maybe<Scalars['numeric']>;
};

/** aggregate varPop on columns */
export type InvoicesQueryableWithQboStatusVarPopFields = {
  __typename?: 'InvoicesQueryableWithQboStatusVarPopFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type InvoicesQueryableWithQboStatusVarSampFields = {
  __typename?: 'InvoicesQueryableWithQboStatusVarSampFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type InvoicesQueryableWithQboStatusVarianceFields = {
  __typename?: 'InvoicesQueryableWithQboStatusVarianceFields';
  balanceAmountUsd?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  paidAmountUsd?: Maybe<Scalars['Float']>;
  totalAmountUsd?: Maybe<Scalars['Float']>;
};

/** select columns of table "invoices" */
export type InvoicesSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'billingAddressGuid'
  /** column name */
  | 'billingContactGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'customerPurchaseOrderNumber'
  /** column name */
  | 'displayId'
  /** column name */
  | 'displayIdV2'
  /** column name */
  | 'doNotSyncToAccountingServiceReason'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'dynamicPricingType'
  /** column name */
  | 'hideLineItemPrices'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'invoiceTerm'
  /** column name */
  | 'issuedAt'
  /** column name */
  | 'maintenancePlanSavingsEnabled'
  /** column name */
  | 'messageHtml'
  /** column name */
  | 'serviceAddressGuid'
  /** column name */
  | 'serviceCompletionDate'
  /** column name */
  | 'signatureFileUrl'
  /** column name */
  | 'status'
  /** column name */
  | 'subtotalUsc'
  /** column name */
  | 'taxRate'
  /** column name */
  | 'taxRateGuid'
  /** column name */
  | 'taxRateName'
  /** column name */
  | 'totalUsc'
  /** column name */
  | 'updatedAt';

/** select "invoicesAggregateBoolExpBool_andArgumentsColumns" columns of table "invoices" */
export type InvoicesSelectColumnInvoicesAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'hideLineItemPrices'
  /** column name */
  | 'maintenancePlanSavingsEnabled';

/** select "invoicesAggregateBoolExpBool_orArgumentsColumns" columns of table "invoices" */
export type InvoicesSelectColumnInvoicesAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'hideLineItemPrices'
  /** column name */
  | 'maintenancePlanSavingsEnabled';

/** input type for updating data in table "invoices" */
export type InvoicesSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  billingAddressGuid?: InputMaybe<Scalars['uuid']>;
  billingContactGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  customerPurchaseOrderNumber?: InputMaybe<Scalars['String']>;
  displayId?: InputMaybe<Scalars['Int']>;
  displayIdV2?: InputMaybe<Scalars['String']>;
  /** If set, Breezy will not sync this invoice to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  dynamicPricingType?: InputMaybe<Scalars['DynamicPricingType']>;
  /** Per-invoice override: hide per-line prices on customer-facing renders. Seeded from company_config.hide_line_item_prices at create. */
  hideLineItemPrices?: InputMaybe<Scalars['Boolean']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoiceTerm?: InputMaybe<Scalars['InvoiceTermV2']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  maintenancePlanSavingsEnabled?: InputMaybe<Scalars['Boolean']>;
  messageHtml?: InputMaybe<Scalars['HtmlString']>;
  serviceAddressGuid?: InputMaybe<Scalars['uuid']>;
  serviceCompletionDate?: InputMaybe<Scalars['date']>;
  signatureFileUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['InvoiceV2Status']>;
  subtotalUsc?: InputMaybe<Scalars['Int']>;
  taxRate?: InputMaybe<Scalars['numeric']>;
  taxRateGuid?: InputMaybe<Scalars['uuid']>;
  taxRateName?: InputMaybe<Scalars['String']>;
  totalUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type InvoicesStddevFields = {
  __typename?: 'InvoicesStddevFields';
  displayId?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoices" */
export type InvoicesStddevOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  subtotalUsc?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type InvoicesStddevPopFields = {
  __typename?: 'InvoicesStddevPopFields';
  displayId?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "invoices" */
export type InvoicesStddevPopOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  subtotalUsc?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type InvoicesStddevSampFields = {
  __typename?: 'InvoicesStddevSampFields';
  displayId?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "invoices" */
export type InvoicesStddevSampOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  subtotalUsc?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "invoices" */
export type InvoicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoicesStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  billingAddressGuid?: InputMaybe<Scalars['uuid']>;
  billingContactGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  customerPurchaseOrderNumber?: InputMaybe<Scalars['String']>;
  displayId?: InputMaybe<Scalars['Int']>;
  displayIdV2?: InputMaybe<Scalars['String']>;
  /** If set, Breezy will not sync this invoice to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  dynamicPricingType?: InputMaybe<Scalars['DynamicPricingType']>;
  /** Per-invoice override: hide per-line prices on customer-facing renders. Seeded from company_config.hide_line_item_prices at create. */
  hideLineItemPrices?: InputMaybe<Scalars['Boolean']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoiceTerm?: InputMaybe<Scalars['InvoiceTermV2']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  maintenancePlanSavingsEnabled?: InputMaybe<Scalars['Boolean']>;
  messageHtml?: InputMaybe<Scalars['HtmlString']>;
  serviceAddressGuid?: InputMaybe<Scalars['uuid']>;
  serviceCompletionDate?: InputMaybe<Scalars['date']>;
  signatureFileUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['InvoiceV2Status']>;
  subtotalUsc?: InputMaybe<Scalars['Int']>;
  taxRate?: InputMaybe<Scalars['numeric']>;
  taxRateGuid?: InputMaybe<Scalars['uuid']>;
  taxRateName?: InputMaybe<Scalars['String']>;
  totalUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type InvoicesSumFields = {
  __typename?: 'InvoicesSumFields';
  displayId?: Maybe<Scalars['Int']>;
  subtotalUsc?: Maybe<Scalars['Int']>;
  taxRate?: Maybe<Scalars['numeric']>;
  totalUsc?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "invoices" */
export type InvoicesSumOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  subtotalUsc?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** update columns of table "invoices" */
export type InvoicesUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'billingAddressGuid'
  /** column name */
  | 'billingContactGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'customerPurchaseOrderNumber'
  /** column name */
  | 'displayId'
  /** column name */
  | 'displayIdV2'
  /** column name */
  | 'doNotSyncToAccountingServiceReason'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'dynamicPricingType'
  /** column name */
  | 'hideLineItemPrices'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'invoiceTerm'
  /** column name */
  | 'issuedAt'
  /** column name */
  | 'maintenancePlanSavingsEnabled'
  /** column name */
  | 'messageHtml'
  /** column name */
  | 'serviceAddressGuid'
  /** column name */
  | 'serviceCompletionDate'
  /** column name */
  | 'signatureFileUrl'
  /** column name */
  | 'status'
  /** column name */
  | 'subtotalUsc'
  /** column name */
  | 'taxRate'
  /** column name */
  | 'taxRateGuid'
  /** column name */
  | 'taxRateName'
  /** column name */
  | 'totalUsc'
  /** column name */
  | 'updatedAt';

export type InvoicesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvoicesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvoicesSetInput>;
  /** filter the rows which have to be updated */
  where: InvoicesBoolExp;
};

/** columns and relationships of "invoices_v2_accounting_stale" */
export type InvoicesV2AccountingStale = {
  __typename?: 'InvoicesV2AccountingStale';
  companyGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceUpdatedAt?: Maybe<Scalars['timestamptz']>;
  isStale?: Maybe<Scalars['Boolean']>;
  latestPaymentAt?: Maybe<Scalars['timestamptz']>;
  syncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "invoices_v2_accounting_stale" */
export type InvoicesV2AccountingStaleAggregate = {
  __typename?: 'InvoicesV2AccountingStaleAggregate';
  aggregate?: Maybe<InvoicesV2AccountingStaleAggregateFields>;
  nodes: Array<InvoicesV2AccountingStale>;
};

/** aggregate fields of "invoices_v2_accounting_stale" */
export type InvoicesV2AccountingStaleAggregateFields = {
  __typename?: 'InvoicesV2AccountingStaleAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InvoicesV2AccountingStaleMaxFields>;
  min?: Maybe<InvoicesV2AccountingStaleMinFields>;
};


/** aggregate fields of "invoices_v2_accounting_stale" */
export type InvoicesV2AccountingStaleAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoicesV2AccountingStaleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "invoices_v2_accounting_stale". All fields are combined with a logical 'AND'. */
export type InvoicesV2AccountingStaleBoolExp = {
  _and?: InputMaybe<Array<InvoicesV2AccountingStaleBoolExp>>;
  _not?: InputMaybe<InvoicesV2AccountingStaleBoolExp>;
  _or?: InputMaybe<Array<InvoicesV2AccountingStaleBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  invoiceUpdatedAt?: InputMaybe<TimestamptzComparisonExp>;
  isStale?: InputMaybe<BooleanComparisonExp>;
  latestPaymentAt?: InputMaybe<TimestamptzComparisonExp>;
  syncedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "invoices_v2_accounting_stale" */
export type InvoicesV2AccountingStaleInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoiceUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  isStale?: InputMaybe<Scalars['Boolean']>;
  latestPaymentAt?: InputMaybe<Scalars['timestamptz']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InvoicesV2AccountingStaleMaxFields = {
  __typename?: 'InvoicesV2AccountingStaleMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceUpdatedAt?: Maybe<Scalars['timestamptz']>;
  latestPaymentAt?: Maybe<Scalars['timestamptz']>;
  syncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type InvoicesV2AccountingStaleMinFields = {
  __typename?: 'InvoicesV2AccountingStaleMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  invoiceUpdatedAt?: Maybe<Scalars['timestamptz']>;
  latestPaymentAt?: Maybe<Scalars['timestamptz']>;
  syncedAt?: Maybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "invoices_v2_accounting_stale" */
export type InvoicesV2AccountingStaleObjRelInsertInput = {
  data: InvoicesV2AccountingStaleInsertInput;
};

/** Ordering options when selecting data from "invoices_v2_accounting_stale". */
export type InvoicesV2AccountingStaleOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  invoiceUpdatedAt?: InputMaybe<OrderBy>;
  isStale?: InputMaybe<OrderBy>;
  latestPaymentAt?: InputMaybe<OrderBy>;
  syncedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "invoices_v2_accounting_stale" */
export type InvoicesV2AccountingStaleSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'invoiceUpdatedAt'
  /** column name */
  | 'isStale'
  /** column name */
  | 'latestPaymentAt'
  /** column name */
  | 'syncedAt';

/** Streaming cursor of the table "invoices_v2_accounting_stale" */
export type InvoicesV2AccountingStaleStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoicesV2AccountingStaleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoicesV2AccountingStaleStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoiceUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  isStale?: InputMaybe<Scalars['Boolean']>;
  latestPaymentAt?: InputMaybe<Scalars['timestamptz']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "invoices_v2_qbo_stale" */
export type InvoicesV2QboStale = {
  __typename?: 'InvoicesV2QboStale';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  isQboStale?: Maybe<Scalars['Boolean']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "invoices_v2_qbo_stale" */
export type InvoicesV2QboStaleAggregate = {
  __typename?: 'InvoicesV2QboStaleAggregate';
  aggregate?: Maybe<InvoicesV2QboStaleAggregateFields>;
  nodes: Array<InvoicesV2QboStale>;
};

/** aggregate fields of "invoices_v2_qbo_stale" */
export type InvoicesV2QboStaleAggregateFields = {
  __typename?: 'InvoicesV2QboStaleAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InvoicesV2QboStaleMaxFields>;
  min?: Maybe<InvoicesV2QboStaleMinFields>;
};


/** aggregate fields of "invoices_v2_qbo_stale" */
export type InvoicesV2QboStaleAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoicesV2QboStaleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "invoices_v2_qbo_stale". All fields are combined with a logical 'AND'. */
export type InvoicesV2QboStaleBoolExp = {
  _and?: InputMaybe<Array<InvoicesV2QboStaleBoolExp>>;
  _not?: InputMaybe<InvoicesV2QboStaleBoolExp>;
  _or?: InputMaybe<Array<InvoicesV2QboStaleBoolExp>>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  isQboStale?: InputMaybe<BooleanComparisonExp>;
  qboSyncedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "invoices_v2_qbo_stale" */
export type InvoicesV2QboStaleInsertInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  isQboStale?: InputMaybe<Scalars['Boolean']>;
  qboSyncedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InvoicesV2QboStaleMaxFields = {
  __typename?: 'InvoicesV2QboStaleMaxFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type InvoicesV2QboStaleMinFields = {
  __typename?: 'InvoicesV2QboStaleMinFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "invoices_v2_qbo_stale" */
export type InvoicesV2QboStaleObjRelInsertInput = {
  data: InvoicesV2QboStaleInsertInput;
};

/** Ordering options when selecting data from "invoices_v2_qbo_stale". */
export type InvoicesV2QboStaleOrderBy = {
  invoiceGuid?: InputMaybe<OrderBy>;
  isQboStale?: InputMaybe<OrderBy>;
  qboSyncedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "invoices_v2_qbo_stale" */
export type InvoicesV2QboStaleSelectColumn =
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'isQboStale'
  /** column name */
  | 'qboSyncedAt'
  /** column name */
  | 'updatedAt';

/** Streaming cursor of the table "invoices_v2_qbo_stale" */
export type InvoicesV2QboStaleStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoicesV2QboStaleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoicesV2QboStaleStreamCursorValueInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  isQboStale?: InputMaybe<Scalars['Boolean']>;
  qboSyncedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "invoices_v2_qbo_status" */
export type InvoicesV2QboStatus = {
  __typename?: 'InvoicesV2QboStatus';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "invoices_v2_qbo_status" */
export type InvoicesV2QboStatusAggregate = {
  __typename?: 'InvoicesV2QboStatusAggregate';
  aggregate?: Maybe<InvoicesV2QboStatusAggregateFields>;
  nodes: Array<InvoicesV2QboStatus>;
};

/** aggregate fields of "invoices_v2_qbo_status" */
export type InvoicesV2QboStatusAggregateFields = {
  __typename?: 'InvoicesV2QboStatusAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InvoicesV2QboStatusMaxFields>;
  min?: Maybe<InvoicesV2QboStatusMinFields>;
};


/** aggregate fields of "invoices_v2_qbo_status" */
export type InvoicesV2QboStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InvoicesV2QboStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "invoices_v2_qbo_status". All fields are combined with a logical 'AND'. */
export type InvoicesV2QboStatusBoolExp = {
  _and?: InputMaybe<Array<InvoicesV2QboStatusBoolExp>>;
  _not?: InputMaybe<InvoicesV2QboStatusBoolExp>;
  _or?: InputMaybe<Array<InvoicesV2QboStatusBoolExp>>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  qboId?: InputMaybe<StringComparisonExp>;
  qboSyncedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "invoices_v2_qbo_status" */
export type InvoicesV2QboStatusInsertInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  qboId?: InputMaybe<Scalars['String']>;
  qboSyncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type InvoicesV2QboStatusMaxFields = {
  __typename?: 'InvoicesV2QboStatusMaxFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type InvoicesV2QboStatusMinFields = {
  __typename?: 'InvoicesV2QboStatusMinFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "invoices_v2_qbo_status" */
export type InvoicesV2QboStatusObjRelInsertInput = {
  data: InvoicesV2QboStatusInsertInput;
};

/** Ordering options when selecting data from "invoices_v2_qbo_status". */
export type InvoicesV2QboStatusOrderBy = {
  invoiceGuid?: InputMaybe<OrderBy>;
  qboId?: InputMaybe<OrderBy>;
  qboSyncedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "invoices_v2_qbo_status" */
export type InvoicesV2QboStatusSelectColumn =
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'qboId'
  /** column name */
  | 'qboSyncedAt';

/** Streaming cursor of the table "invoices_v2_qbo_status" */
export type InvoicesV2QboStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InvoicesV2QboStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InvoicesV2QboStatusStreamCursorValueInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  qboId?: InputMaybe<Scalars['String']>;
  qboSyncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate varPop on columns */
export type InvoicesVarPopFields = {
  __typename?: 'InvoicesVarPopFields';
  displayId?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "invoices" */
export type InvoicesVarPopOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  subtotalUsc?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type InvoicesVarSampFields = {
  __typename?: 'InvoicesVarSampFields';
  displayId?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "invoices" */
export type InvoicesVarSampOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  subtotalUsc?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type InvoicesVarianceFields = {
  __typename?: 'InvoicesVarianceFields';
  displayId?: Maybe<Scalars['Float']>;
  subtotalUsc?: Maybe<Scalars['Float']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoices" */
export type InvoicesVarianceOrderBy = {
  displayId?: InputMaybe<OrderBy>;
  subtotalUsc?: InputMaybe<OrderBy>;
  taxRate?: InputMaybe<OrderBy>;
  totalUsc?: InputMaybe<OrderBy>;
};

/** columns and relationships of "job_appointment_assignment_status_types" */
export type JobAppointmentAssignmentStatusTypes = {
  __typename?: 'JobAppointmentAssignmentStatusTypes';
  name: Scalars['String'];
};

/** aggregated selection of "job_appointment_assignment_status_types" */
export type JobAppointmentAssignmentStatusTypesAggregate = {
  __typename?: 'JobAppointmentAssignmentStatusTypesAggregate';
  aggregate?: Maybe<JobAppointmentAssignmentStatusTypesAggregateFields>;
  nodes: Array<JobAppointmentAssignmentStatusTypes>;
};

/** aggregate fields of "job_appointment_assignment_status_types" */
export type JobAppointmentAssignmentStatusTypesAggregateFields = {
  __typename?: 'JobAppointmentAssignmentStatusTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobAppointmentAssignmentStatusTypesMaxFields>;
  min?: Maybe<JobAppointmentAssignmentStatusTypesMinFields>;
};


/** aggregate fields of "job_appointment_assignment_status_types" */
export type JobAppointmentAssignmentStatusTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "job_appointment_assignment_status_types". All fields are combined with a logical 'AND'. */
export type JobAppointmentAssignmentStatusTypesBoolExp = {
  _and?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesBoolExp>>;
  _not?: InputMaybe<JobAppointmentAssignmentStatusTypesBoolExp>;
  _or?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesBoolExp>>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "job_appointment_assignment_status_types" */
export type JobAppointmentAssignmentStatusTypesConstraint =
  /** unique or primary key constraint on columns "name" */
  | 'job_appointment_assignment_status_types_pkey';

export type JobAppointmentAssignmentStatusTypesEnum =
  | 'CANCELED'
  | 'COMPLETED'
  | 'EN_ROUTE'
  | 'IN_PROGRESS'
  | 'TO_DO';

/** Boolean expression to compare columns of type "JobAppointmentAssignmentStatusTypesEnum". All fields are combined with logical 'AND'. */
export type JobAppointmentAssignmentStatusTypesEnumComparisonExp = {
  _eq?: InputMaybe<JobAppointmentAssignmentStatusTypesEnum>;
  _in?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<JobAppointmentAssignmentStatusTypesEnum>;
  _nin?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesEnum>>;
};

/** input type for inserting data into table "job_appointment_assignment_status_types" */
export type JobAppointmentAssignmentStatusTypesInsertInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type JobAppointmentAssignmentStatusTypesMaxFields = {
  __typename?: 'JobAppointmentAssignmentStatusTypesMaxFields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type JobAppointmentAssignmentStatusTypesMinFields = {
  __typename?: 'JobAppointmentAssignmentStatusTypesMinFields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_appointment_assignment_status_types" */
export type JobAppointmentAssignmentStatusTypesMutationResponse = {
  __typename?: 'JobAppointmentAssignmentStatusTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobAppointmentAssignmentStatusTypes>;
};

/** on_conflict condition type for table "job_appointment_assignment_status_types" */
export type JobAppointmentAssignmentStatusTypesOnConflict = {
  constraint: JobAppointmentAssignmentStatusTypesConstraint;
  updateColumns?: Array<JobAppointmentAssignmentStatusTypesUpdateColumn>;
  where?: InputMaybe<JobAppointmentAssignmentStatusTypesBoolExp>;
};

/** Ordering options when selecting data from "job_appointment_assignment_status_types". */
export type JobAppointmentAssignmentStatusTypesOrderBy = {
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_appointment_assignment_status_types */
export type JobAppointmentAssignmentStatusTypesPkColumnsInput = {
  name: Scalars['String'];
};

/** select columns of table "job_appointment_assignment_status_types" */
export type JobAppointmentAssignmentStatusTypesSelectColumn =
  /** column name */
  | 'name';

/** input type for updating data in table "job_appointment_assignment_status_types" */
export type JobAppointmentAssignmentStatusTypesSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "job_appointment_assignment_status_types" */
export type JobAppointmentAssignmentStatusTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobAppointmentAssignmentStatusTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobAppointmentAssignmentStatusTypesStreamCursorValueInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "job_appointment_assignment_status_types" */
export type JobAppointmentAssignmentStatusTypesUpdateColumn =
  /** column name */
  | 'name';

export type JobAppointmentAssignmentStatusTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobAppointmentAssignmentStatusTypesSetInput>;
  /** filter the rows which have to be updated */
  where: JobAppointmentAssignmentStatusTypesBoolExp;
};

/** columns and relationships of "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatuses = {
  __typename?: 'JobAppointmentAssignmentStatuses';
  createdAt: Scalars['timestamptz'];
  jobAppointmentAssignmentGuid: Scalars['uuid'];
  jobAppointmentAssignmentStatusGuid: Scalars['uuid'];
  jobAppointmentAssignmentStatusType: JobAppointmentAssignmentStatusTypesEnum;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatusesAggregate = {
  __typename?: 'JobAppointmentAssignmentStatusesAggregate';
  aggregate?: Maybe<JobAppointmentAssignmentStatusesAggregateFields>;
  nodes: Array<JobAppointmentAssignmentStatuses>;
};

/** aggregate fields of "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatusesAggregateFields = {
  __typename?: 'JobAppointmentAssignmentStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobAppointmentAssignmentStatusesMaxFields>;
  min?: Maybe<JobAppointmentAssignmentStatusesMinFields>;
};


/** aggregate fields of "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobAppointmentAssignmentStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "job_appointment_assignment_statuses". All fields are combined with a logical 'AND'. */
export type JobAppointmentAssignmentStatusesBoolExp = {
  _and?: InputMaybe<Array<JobAppointmentAssignmentStatusesBoolExp>>;
  _not?: InputMaybe<JobAppointmentAssignmentStatusesBoolExp>;
  _or?: InputMaybe<Array<JobAppointmentAssignmentStatusesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  jobAppointmentAssignmentGuid?: InputMaybe<UuidComparisonExp>;
  jobAppointmentAssignmentStatusGuid?: InputMaybe<UuidComparisonExp>;
  jobAppointmentAssignmentStatusType?: InputMaybe<JobAppointmentAssignmentStatusTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatusesConstraint =
  /** unique or primary key constraint on columns "job_appointment_assignment_guid" */
  | 'job_appointment_assignment_st_job_appointment_assignment_gu_key'
  /** unique or primary key constraint on columns "job_appointment_assignment_status_guid" */
  | 'job_appointment_assignment_statuses_pkey';

/** input type for inserting data into table "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatusesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentAssignmentStatusGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentAssignmentStatusType?: InputMaybe<JobAppointmentAssignmentStatusTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobAppointmentAssignmentStatusesMaxFields = {
  __typename?: 'JobAppointmentAssignmentStatusesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentAssignmentStatusGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type JobAppointmentAssignmentStatusesMinFields = {
  __typename?: 'JobAppointmentAssignmentStatusesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentAssignmentStatusGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatusesMutationResponse = {
  __typename?: 'JobAppointmentAssignmentStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobAppointmentAssignmentStatuses>;
};

/** input type for inserting object relation for remote table "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatusesObjRelInsertInput = {
  data: JobAppointmentAssignmentStatusesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobAppointmentAssignmentStatusesOnConflict>;
};

/** on_conflict condition type for table "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatusesOnConflict = {
  constraint: JobAppointmentAssignmentStatusesConstraint;
  updateColumns?: Array<JobAppointmentAssignmentStatusesUpdateColumn>;
  where?: InputMaybe<JobAppointmentAssignmentStatusesBoolExp>;
};

/** Ordering options when selecting data from "job_appointment_assignment_statuses". */
export type JobAppointmentAssignmentStatusesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentStatusGuid?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentStatusType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_appointment_assignment_statuses */
export type JobAppointmentAssignmentStatusesPkColumnsInput = {
  jobAppointmentAssignmentStatusGuid: Scalars['uuid'];
};

/** select columns of table "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatusesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentAssignmentStatusGuid'
  /** column name */
  | 'jobAppointmentAssignmentStatusType'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatusesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentAssignmentStatusGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentAssignmentStatusType?: InputMaybe<JobAppointmentAssignmentStatusTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobAppointmentAssignmentStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobAppointmentAssignmentStatusesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentAssignmentStatusGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentAssignmentStatusType?: InputMaybe<JobAppointmentAssignmentStatusTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "job_appointment_assignment_statuses" */
export type JobAppointmentAssignmentStatusesUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentAssignmentStatusGuid'
  /** column name */
  | 'jobAppointmentAssignmentStatusType'
  /** column name */
  | 'updatedAt';

export type JobAppointmentAssignmentStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobAppointmentAssignmentStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: JobAppointmentAssignmentStatusesBoolExp;
};

/** columns and relationships of "job_appointment_assignments" */
export type JobAppointmentAssignments = {
  __typename?: 'JobAppointmentAssignments';
  assignmentEnd: Scalars['timestamptz'];
  assignmentStart: Scalars['timestamptz'];
  /** An object relationship */
  assignmentStatus?: Maybe<JobAppointmentAssignmentStatuses>;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  fileLinks: Array<FileLinks>;
  /** An aggregate relationship */
  fileLinksAggregate: FileLinksAggregate;
  /** An object relationship */
  job: Jobs;
  /** An object relationship */
  jobAppointment: JobAppointments;
  jobAppointmentAssignmentGuid: Scalars['uuid'];
  jobAppointmentGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  /** An array relationship */
  photoLinks: Array<PhotoLinks>;
  /** An aggregate relationship */
  photoLinksAggregate: PhotoLinksAggregate;
  /** An object relationship */
  technician: Users;
  technicianUserGuid: Scalars['uuid'];
  /** An array relationship */
  timesheetEntryLinkData: Array<TimesheetEntryLinkData>;
  /** An aggregate relationship */
  timesheetEntryLinkDataAggregate: TimesheetEntryLinkDataAggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "job_appointment_assignments" */
export type JobAppointmentAssignmentsFileLinksArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


/** columns and relationships of "job_appointment_assignments" */
export type JobAppointmentAssignmentsFileLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


/** columns and relationships of "job_appointment_assignments" */
export type JobAppointmentAssignmentsPhotoLinksArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


/** columns and relationships of "job_appointment_assignments" */
export type JobAppointmentAssignmentsPhotoLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


/** columns and relationships of "job_appointment_assignments" */
export type JobAppointmentAssignmentsTimesheetEntryLinkDataArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryLinkDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryLinkDataOrderBy>>;
  where?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
};


/** columns and relationships of "job_appointment_assignments" */
export type JobAppointmentAssignmentsTimesheetEntryLinkDataAggregateArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryLinkDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryLinkDataOrderBy>>;
  where?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
};

/** aggregated selection of "job_appointment_assignments" */
export type JobAppointmentAssignmentsAggregate = {
  __typename?: 'JobAppointmentAssignmentsAggregate';
  aggregate?: Maybe<JobAppointmentAssignmentsAggregateFields>;
  nodes: Array<JobAppointmentAssignments>;
};

export type JobAppointmentAssignmentsAggregateBoolExp = {
  count?: InputMaybe<JobAppointmentAssignmentsAggregateBoolExpCount>;
};

/** aggregate fields of "job_appointment_assignments" */
export type JobAppointmentAssignmentsAggregateFields = {
  __typename?: 'JobAppointmentAssignmentsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobAppointmentAssignmentsMaxFields>;
  min?: Maybe<JobAppointmentAssignmentsMinFields>;
};


/** aggregate fields of "job_appointment_assignments" */
export type JobAppointmentAssignmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobAppointmentAssignmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_appointment_assignments" */
export type JobAppointmentAssignmentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobAppointmentAssignmentsMaxOrderBy>;
  min?: InputMaybe<JobAppointmentAssignmentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "job_appointment_assignments" */
export type JobAppointmentAssignmentsArrRelInsertInput = {
  data: Array<JobAppointmentAssignmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobAppointmentAssignmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "job_appointment_assignments". All fields are combined with a logical 'AND'. */
export type JobAppointmentAssignmentsBoolExp = {
  _and?: InputMaybe<Array<JobAppointmentAssignmentsBoolExp>>;
  _not?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
  _or?: InputMaybe<Array<JobAppointmentAssignmentsBoolExp>>;
  assignmentEnd?: InputMaybe<TimestamptzComparisonExp>;
  assignmentStart?: InputMaybe<TimestamptzComparisonExp>;
  assignmentStatus?: InputMaybe<JobAppointmentAssignmentStatusesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  fileLinks?: InputMaybe<FileLinksBoolExp>;
  fileLinksAggregate?: InputMaybe<FileLinksAggregateBoolExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobAppointment?: InputMaybe<JobAppointmentsBoolExp>;
  jobAppointmentAssignmentGuid?: InputMaybe<UuidComparisonExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  photoLinks?: InputMaybe<PhotoLinksBoolExp>;
  photoLinksAggregate?: InputMaybe<PhotoLinksAggregateBoolExp>;
  technician?: InputMaybe<UsersBoolExp>;
  technicianUserGuid?: InputMaybe<UuidComparisonExp>;
  timesheetEntryLinkData?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
  timesheetEntryLinkDataAggregate?: InputMaybe<TimesheetEntryLinkDataAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_appointment_assignments" */
export type JobAppointmentAssignmentsConstraint =
  /** unique or primary key constraint on columns "job_appointment_assignment_guid" */
  | 'job_appointment_assignments_pkey';

/** input type for inserting data into table "job_appointment_assignments" */
export type JobAppointmentAssignmentsInsertInput = {
  assignmentEnd?: InputMaybe<Scalars['timestamptz']>;
  assignmentStart?: InputMaybe<Scalars['timestamptz']>;
  assignmentStatus?: InputMaybe<JobAppointmentAssignmentStatusesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  fileLinks?: InputMaybe<FileLinksArrRelInsertInput>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobAppointment?: InputMaybe<JobAppointmentsObjRelInsertInput>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  photoLinks?: InputMaybe<PhotoLinksArrRelInsertInput>;
  technician?: InputMaybe<UsersObjRelInsertInput>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
  timesheetEntryLinkData?: InputMaybe<TimesheetEntryLinkDataArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobAppointmentAssignmentsMaxFields = {
  __typename?: 'JobAppointmentAssignmentsMaxFields';
  assignmentEnd?: Maybe<Scalars['timestamptz']>;
  assignmentStart?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "job_appointment_assignments" */
export type JobAppointmentAssignmentsMaxOrderBy = {
  assignmentEnd?: InputMaybe<OrderBy>;
  assignmentStart?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobAppointmentAssignmentsMinFields = {
  __typename?: 'JobAppointmentAssignmentsMinFields';
  assignmentEnd?: Maybe<Scalars['timestamptz']>;
  assignmentStart?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "job_appointment_assignments" */
export type JobAppointmentAssignmentsMinOrderBy = {
  assignmentEnd?: InputMaybe<OrderBy>;
  assignmentStart?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "job_appointment_assignments" */
export type JobAppointmentAssignmentsMutationResponse = {
  __typename?: 'JobAppointmentAssignmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobAppointmentAssignments>;
};

/** input type for inserting object relation for remote table "job_appointment_assignments" */
export type JobAppointmentAssignmentsObjRelInsertInput = {
  data: JobAppointmentAssignmentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobAppointmentAssignmentsOnConflict>;
};

/** on_conflict condition type for table "job_appointment_assignments" */
export type JobAppointmentAssignmentsOnConflict = {
  constraint: JobAppointmentAssignmentsConstraint;
  updateColumns?: Array<JobAppointmentAssignmentsUpdateColumn>;
  where?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
};

/** Ordering options when selecting data from "job_appointment_assignments". */
export type JobAppointmentAssignmentsOrderBy = {
  assignmentEnd?: InputMaybe<OrderBy>;
  assignmentStart?: InputMaybe<OrderBy>;
  assignmentStatus?: InputMaybe<JobAppointmentAssignmentStatusesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fileLinksAggregate?: InputMaybe<FileLinksAggregateOrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobAppointment?: InputMaybe<JobAppointmentsOrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  photoLinksAggregate?: InputMaybe<PhotoLinksAggregateOrderBy>;
  technician?: InputMaybe<UsersOrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
  timesheetEntryLinkDataAggregate?: InputMaybe<TimesheetEntryLinkDataAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_appointment_assignments */
export type JobAppointmentAssignmentsPkColumnsInput = {
  jobAppointmentAssignmentGuid: Scalars['uuid'];
};

/** select columns of table "job_appointment_assignments" */
export type JobAppointmentAssignmentsSelectColumn =
  /** column name */
  | 'assignmentEnd'
  /** column name */
  | 'assignmentStart'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'technicianUserGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "job_appointment_assignments" */
export type JobAppointmentAssignmentsSetInput = {
  assignmentEnd?: InputMaybe<Scalars['timestamptz']>;
  assignmentStart?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "job_appointment_assignments" */
export type JobAppointmentAssignmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobAppointmentAssignmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobAppointmentAssignmentsStreamCursorValueInput = {
  assignmentEnd?: InputMaybe<Scalars['timestamptz']>;
  assignmentStart?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "job_appointment_assignments" */
export type JobAppointmentAssignmentsUpdateColumn =
  /** column name */
  | 'assignmentEnd'
  /** column name */
  | 'assignmentStart'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'technicianUserGuid'
  /** column name */
  | 'updatedAt';

export type JobAppointmentAssignmentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobAppointmentAssignmentsSetInput>;
  /** filter the rows which have to be updated */
  where: JobAppointmentAssignmentsBoolExp;
};

/** columns and relationships of "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatuses = {
  __typename?: 'JobAppointmentCancellationStatuses';
  canceled: Scalars['Boolean'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  jobAppointment: JobAppointments;
  jobAppointmentGuid: Scalars['uuid'];
  note?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatusesAggregate = {
  __typename?: 'JobAppointmentCancellationStatusesAggregate';
  aggregate?: Maybe<JobAppointmentCancellationStatusesAggregateFields>;
  nodes: Array<JobAppointmentCancellationStatuses>;
};

/** aggregate fields of "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatusesAggregateFields = {
  __typename?: 'JobAppointmentCancellationStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobAppointmentCancellationStatusesMaxFields>;
  min?: Maybe<JobAppointmentCancellationStatusesMinFields>;
};


/** aggregate fields of "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobAppointmentCancellationStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "job_appointment_cancellation_statuses". All fields are combined with a logical 'AND'. */
export type JobAppointmentCancellationStatusesBoolExp = {
  _and?: InputMaybe<Array<JobAppointmentCancellationStatusesBoolExp>>;
  _not?: InputMaybe<JobAppointmentCancellationStatusesBoolExp>;
  _or?: InputMaybe<Array<JobAppointmentCancellationStatusesBoolExp>>;
  canceled?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  jobAppointment?: InputMaybe<JobAppointmentsBoolExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  reason?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatusesConstraint =
  /** unique or primary key constraint on columns "job_appointment_guid" */
  | 'job_appointment_cancellation_statuses_job_appointment_guid_key'
  /** unique or primary key constraint on columns "job_appointment_guid" */
  | 'job_appointment_cancellation_statuses_pkey';

/** input type for inserting data into table "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatusesInsertInput = {
  canceled?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointment?: InputMaybe<JobAppointmentsObjRelInsertInput>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobAppointmentCancellationStatusesMaxFields = {
  __typename?: 'JobAppointmentCancellationStatusesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type JobAppointmentCancellationStatusesMinFields = {
  __typename?: 'JobAppointmentCancellationStatusesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatusesMutationResponse = {
  __typename?: 'JobAppointmentCancellationStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobAppointmentCancellationStatuses>;
};

/** input type for inserting object relation for remote table "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatusesObjRelInsertInput = {
  data: JobAppointmentCancellationStatusesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobAppointmentCancellationStatusesOnConflict>;
};

/** on_conflict condition type for table "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatusesOnConflict = {
  constraint: JobAppointmentCancellationStatusesConstraint;
  updateColumns?: Array<JobAppointmentCancellationStatusesUpdateColumn>;
  where?: InputMaybe<JobAppointmentCancellationStatusesBoolExp>;
};

/** Ordering options when selecting data from "job_appointment_cancellation_statuses". */
export type JobAppointmentCancellationStatusesOrderBy = {
  canceled?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobAppointment?: InputMaybe<JobAppointmentsOrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_appointment_cancellation_statuses */
export type JobAppointmentCancellationStatusesPkColumnsInput = {
  jobAppointmentGuid: Scalars['uuid'];
};

/** select columns of table "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatusesSelectColumn =
  /** column name */
  | 'canceled'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'note'
  /** column name */
  | 'reason'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatusesSetInput = {
  canceled?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobAppointmentCancellationStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobAppointmentCancellationStatusesStreamCursorValueInput = {
  canceled?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "job_appointment_cancellation_statuses" */
export type JobAppointmentCancellationStatusesUpdateColumn =
  /** column name */
  | 'canceled'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'note'
  /** column name */
  | 'reason'
  /** column name */
  | 'updatedAt';

export type JobAppointmentCancellationStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobAppointmentCancellationStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: JobAppointmentCancellationStatusesBoolExp;
};

/** columns and relationships of "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatuses = {
  __typename?: 'JobAppointmentConfirmationStatuses';
  confirmed: Scalars['Boolean'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  jobAppointment: JobAppointments;
  jobAppointmentGuid: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatusesAggregate = {
  __typename?: 'JobAppointmentConfirmationStatusesAggregate';
  aggregate?: Maybe<JobAppointmentConfirmationStatusesAggregateFields>;
  nodes: Array<JobAppointmentConfirmationStatuses>;
};

/** aggregate fields of "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatusesAggregateFields = {
  __typename?: 'JobAppointmentConfirmationStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobAppointmentConfirmationStatusesMaxFields>;
  min?: Maybe<JobAppointmentConfirmationStatusesMinFields>;
};


/** aggregate fields of "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobAppointmentConfirmationStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "job_appointment_confirmation_statuses". All fields are combined with a logical 'AND'. */
export type JobAppointmentConfirmationStatusesBoolExp = {
  _and?: InputMaybe<Array<JobAppointmentConfirmationStatusesBoolExp>>;
  _not?: InputMaybe<JobAppointmentConfirmationStatusesBoolExp>;
  _or?: InputMaybe<Array<JobAppointmentConfirmationStatusesBoolExp>>;
  confirmed?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  jobAppointment?: InputMaybe<JobAppointmentsBoolExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatusesConstraint =
  /** unique or primary key constraint on columns "job_appointment_guid" */
  | 'job_appointment_confirmation_statuses_job_appointment_guid_key'
  /** unique or primary key constraint on columns "job_appointment_guid" */
  | 'job_appointment_confirmation_statuses_pkey';

/** input type for inserting data into table "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatusesInsertInput = {
  confirmed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointment?: InputMaybe<JobAppointmentsObjRelInsertInput>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobAppointmentConfirmationStatusesMaxFields = {
  __typename?: 'JobAppointmentConfirmationStatusesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type JobAppointmentConfirmationStatusesMinFields = {
  __typename?: 'JobAppointmentConfirmationStatusesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatusesMutationResponse = {
  __typename?: 'JobAppointmentConfirmationStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobAppointmentConfirmationStatuses>;
};

/** input type for inserting object relation for remote table "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatusesObjRelInsertInput = {
  data: JobAppointmentConfirmationStatusesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobAppointmentConfirmationStatusesOnConflict>;
};

/** on_conflict condition type for table "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatusesOnConflict = {
  constraint: JobAppointmentConfirmationStatusesConstraint;
  updateColumns?: Array<JobAppointmentConfirmationStatusesUpdateColumn>;
  where?: InputMaybe<JobAppointmentConfirmationStatusesBoolExp>;
};

/** Ordering options when selecting data from "job_appointment_confirmation_statuses". */
export type JobAppointmentConfirmationStatusesOrderBy = {
  confirmed?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobAppointment?: InputMaybe<JobAppointmentsOrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_appointment_confirmation_statuses */
export type JobAppointmentConfirmationStatusesPkColumnsInput = {
  jobAppointmentGuid: Scalars['uuid'];
};

/** select columns of table "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatusesSelectColumn =
  /** column name */
  | 'confirmed'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatusesSetInput = {
  confirmed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobAppointmentConfirmationStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobAppointmentConfirmationStatusesStreamCursorValueInput = {
  confirmed?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "job_appointment_confirmation_statuses" */
export type JobAppointmentConfirmationStatusesUpdateColumn =
  /** column name */
  | 'confirmed'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'updatedAt';

export type JobAppointmentConfirmationStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobAppointmentConfirmationStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: JobAppointmentConfirmationStatusesBoolExp;
};

/** A joiner table to connect job appointments to invoices */
export type JobAppointmentInvoices = {
  __typename?: 'JobAppointmentInvoices';
  /** An object relationship */
  invoice: Invoices;
  invoiceGuid: Scalars['uuid'];
  /** An object relationship */
  jobAppointment: JobAppointments;
  jobAppointmentGuid: Scalars['uuid'];
};

/** aggregated selection of "job_appointment_invoices" */
export type JobAppointmentInvoicesAggregate = {
  __typename?: 'JobAppointmentInvoicesAggregate';
  aggregate?: Maybe<JobAppointmentInvoicesAggregateFields>;
  nodes: Array<JobAppointmentInvoices>;
};

export type JobAppointmentInvoicesAggregateBoolExp = {
  count?: InputMaybe<JobAppointmentInvoicesAggregateBoolExpCount>;
};

/** aggregate fields of "job_appointment_invoices" */
export type JobAppointmentInvoicesAggregateFields = {
  __typename?: 'JobAppointmentInvoicesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobAppointmentInvoicesMaxFields>;
  min?: Maybe<JobAppointmentInvoicesMinFields>;
};


/** aggregate fields of "job_appointment_invoices" */
export type JobAppointmentInvoicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobAppointmentInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_appointment_invoices" */
export type JobAppointmentInvoicesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobAppointmentInvoicesMaxOrderBy>;
  min?: InputMaybe<JobAppointmentInvoicesMinOrderBy>;
};

/** input type for inserting array relation for remote table "job_appointment_invoices" */
export type JobAppointmentInvoicesArrRelInsertInput = {
  data: Array<JobAppointmentInvoicesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobAppointmentInvoicesOnConflict>;
};

/** Boolean expression to filter rows from the table "job_appointment_invoices". All fields are combined with a logical 'AND'. */
export type JobAppointmentInvoicesBoolExp = {
  _and?: InputMaybe<Array<JobAppointmentInvoicesBoolExp>>;
  _not?: InputMaybe<JobAppointmentInvoicesBoolExp>;
  _or?: InputMaybe<Array<JobAppointmentInvoicesBoolExp>>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  jobAppointment?: InputMaybe<JobAppointmentsBoolExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "job_appointment_invoices" */
export type JobAppointmentInvoicesConstraint =
  /** unique or primary key constraint on columns "invoice_guid" */
  | 'job_appointment_invoices_pkey';

/** input type for inserting data into table "job_appointment_invoices" */
export type JobAppointmentInvoicesInsertInput = {
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointment?: InputMaybe<JobAppointmentsObjRelInsertInput>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type JobAppointmentInvoicesMaxFields = {
  __typename?: 'JobAppointmentInvoicesMaxFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "job_appointment_invoices" */
export type JobAppointmentInvoicesMaxOrderBy = {
  invoiceGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobAppointmentInvoicesMinFields = {
  __typename?: 'JobAppointmentInvoicesMinFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "job_appointment_invoices" */
export type JobAppointmentInvoicesMinOrderBy = {
  invoiceGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "job_appointment_invoices" */
export type JobAppointmentInvoicesMutationResponse = {
  __typename?: 'JobAppointmentInvoicesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobAppointmentInvoices>;
};

/** input type for inserting object relation for remote table "job_appointment_invoices" */
export type JobAppointmentInvoicesObjRelInsertInput = {
  data: JobAppointmentInvoicesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobAppointmentInvoicesOnConflict>;
};

/** on_conflict condition type for table "job_appointment_invoices" */
export type JobAppointmentInvoicesOnConflict = {
  constraint: JobAppointmentInvoicesConstraint;
  updateColumns?: Array<JobAppointmentInvoicesUpdateColumn>;
  where?: InputMaybe<JobAppointmentInvoicesBoolExp>;
};

/** Ordering options when selecting data from "job_appointment_invoices". */
export type JobAppointmentInvoicesOrderBy = {
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  jobAppointment?: InputMaybe<JobAppointmentsOrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_appointment_invoices */
export type JobAppointmentInvoicesPkColumnsInput = {
  invoiceGuid: Scalars['uuid'];
};

/** select columns of table "job_appointment_invoices" */
export type JobAppointmentInvoicesSelectColumn =
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'jobAppointmentGuid';

/** input type for updating data in table "job_appointment_invoices" */
export type JobAppointmentInvoicesSetInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "job_appointment_invoices" */
export type JobAppointmentInvoicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobAppointmentInvoicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobAppointmentInvoicesStreamCursorValueInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "job_appointment_invoices" */
export type JobAppointmentInvoicesUpdateColumn =
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'jobAppointmentGuid';

export type JobAppointmentInvoicesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobAppointmentInvoicesSetInput>;
  /** filter the rows which have to be updated */
  where: JobAppointmentInvoicesBoolExp;
};

/** columns and relationships of "job_appointments" */
export type JobAppointments = {
  __typename?: 'JobAppointments';
  /** An array relationship */
  appointmentChecklistInstances: Array<AppointmentChecklistInstances>;
  /** An aggregate relationship */
  appointmentChecklistInstancesAggregate: AppointmentChecklistInstancesAggregate;
  appointmentReferenceNumber: Scalars['String'];
  appointmentType: Scalars['AppointmentType'];
  appointmentWindowEnd: Scalars['timestamptz'];
  appointmentWindowStart: Scalars['timestamptz'];
  /** An array relationship */
  assignments: Array<JobAppointmentAssignments>;
  /** An aggregate relationship */
  assignmentsAggregate: JobAppointmentAssignmentsAggregate;
  /** An object relationship */
  cancellationStatus?: Maybe<JobAppointmentCancellationStatuses>;
  companyGuid: Scalars['uuid'];
  confirmationLastSentAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  confirmationStatus?: Maybe<JobAppointmentConfirmationStatuses>;
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['HtmlString']>;
  endOfAppointmentNextSteps?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  estimates: Array<Estimates>;
  /** An aggregate relationship */
  estimatesAggregate: EstimatesAggregate;
  /** An array relationship */
  fileLinks: Array<FileLinks>;
  /** An aggregate relationship */
  fileLinksAggregate: FileLinksAggregate;
  /** An array relationship */
  invoicesQueryables: Array<InvoicesQueryable>;
  /** An aggregate relationship */
  invoicesQueryablesAggregate: InvoicesQueryableAggregate;
  /** An object relationship */
  job: Jobs;
  jobAppointmentGuid: Scalars['uuid'];
  /** An array relationship */
  jobAppointmentInvoices: Array<JobAppointmentInvoices>;
  /** An aggregate relationship */
  jobAppointmentInvoicesAggregate: JobAppointmentInvoicesAggregate;
  jobGuid: Scalars['uuid'];
  /** An array relationship */
  jobInvoices: Array<JobInvoices>;
  /** An aggregate relationship */
  jobInvoicesAggregate: JobInvoicesAggregate;
  notificationType: Scalars['AppointmentNotificationType'];
  /** A computed field for the number of review reminders sent */
  numReviewRemindersSent?: Maybe<Scalars['Int']>;
  /** An array relationship */
  photoLinks: Array<PhotoLinks>;
  /** An aggregate relationship */
  photoLinksAggregate: PhotoLinksAggregate;
  reminderLastSentAt?: Maybe<Scalars['timestamptz']>;
  sendConfirmationEnabled: Scalars['Boolean'];
  sendConfirmationTo?: Maybe<Scalars['String']>;
  sendReminderEnabled: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsAppointmentChecklistInstancesArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistInstancesOrderBy>>;
  where?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsAppointmentChecklistInstancesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistInstancesOrderBy>>;
  where?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsAssignmentsArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsAssignmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsEndOfAppointmentNextStepsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsEstimatesArgs = {
  distinctOn?: InputMaybe<Array<EstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesOrderBy>>;
  where?: InputMaybe<EstimatesBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsEstimatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesOrderBy>>;
  where?: InputMaybe<EstimatesBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsFileLinksArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsFileLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsInvoicesQueryablesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQueryableOrderBy>>;
  where?: InputMaybe<InvoicesQueryableBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsInvoicesQueryablesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQueryableOrderBy>>;
  where?: InputMaybe<InvoicesQueryableBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsJobAppointmentInvoicesArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentInvoicesOrderBy>>;
  where?: InputMaybe<JobAppointmentInvoicesBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsJobAppointmentInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentInvoicesOrderBy>>;
  where?: InputMaybe<JobAppointmentInvoicesBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsJobInvoicesArgs = {
  distinctOn?: InputMaybe<Array<JobInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobInvoicesOrderBy>>;
  where?: InputMaybe<JobInvoicesBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsJobInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobInvoicesOrderBy>>;
  where?: InputMaybe<JobInvoicesBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsPhotoLinksArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


/** columns and relationships of "job_appointments" */
export type JobAppointmentsPhotoLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};

/** aggregated selection of "job_appointments" */
export type JobAppointmentsAggregate = {
  __typename?: 'JobAppointmentsAggregate';
  aggregate?: Maybe<JobAppointmentsAggregateFields>;
  nodes: Array<JobAppointments>;
};

export type JobAppointmentsAggregateBoolExp = {
  bool_and?: InputMaybe<JobAppointmentsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<JobAppointmentsAggregateBoolExpBool_Or>;
  count?: InputMaybe<JobAppointmentsAggregateBoolExpCount>;
};

/** aggregate fields of "job_appointments" */
export type JobAppointmentsAggregateFields = {
  __typename?: 'JobAppointmentsAggregateFields';
  avg?: Maybe<JobAppointmentsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobAppointmentsMaxFields>;
  min?: Maybe<JobAppointmentsMinFields>;
  stddev?: Maybe<JobAppointmentsStddevFields>;
  stddevPop?: Maybe<JobAppointmentsStddevPopFields>;
  stddevSamp?: Maybe<JobAppointmentsStddevSampFields>;
  sum?: Maybe<JobAppointmentsSumFields>;
  varPop?: Maybe<JobAppointmentsVarPopFields>;
  varSamp?: Maybe<JobAppointmentsVarSampFields>;
  variance?: Maybe<JobAppointmentsVarianceFields>;
};


/** aggregate fields of "job_appointments" */
export type JobAppointmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobAppointmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_appointments" */
export type JobAppointmentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobAppointmentsMaxOrderBy>;
  min?: InputMaybe<JobAppointmentsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type JobAppointmentsAppendInput = {
  endOfAppointmentNextSteps?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "job_appointments" */
export type JobAppointmentsArrRelInsertInput = {
  data: Array<JobAppointmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobAppointmentsOnConflict>;
};

/** aggregate avg on columns */
export type JobAppointmentsAvgFields = {
  __typename?: 'JobAppointmentsAvgFields';
  /** A computed field for the number of review reminders sent */
  numReviewRemindersSent?: Maybe<Scalars['Int']>;
};

/** Boolean expression to filter rows from the table "job_appointments". All fields are combined with a logical 'AND'. */
export type JobAppointmentsBoolExp = {
  _and?: InputMaybe<Array<JobAppointmentsBoolExp>>;
  _not?: InputMaybe<JobAppointmentsBoolExp>;
  _or?: InputMaybe<Array<JobAppointmentsBoolExp>>;
  appointmentChecklistInstances?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
  appointmentChecklistInstancesAggregate?: InputMaybe<AppointmentChecklistInstancesAggregateBoolExp>;
  appointmentReferenceNumber?: InputMaybe<StringComparisonExp>;
  appointmentType?: InputMaybe<Scalars['AppointmentTypeComparisonExp']>;
  appointmentWindowEnd?: InputMaybe<TimestamptzComparisonExp>;
  appointmentWindowStart?: InputMaybe<TimestamptzComparisonExp>;
  assignments?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
  assignmentsAggregate?: InputMaybe<JobAppointmentAssignmentsAggregateBoolExp>;
  cancellationStatus?: InputMaybe<JobAppointmentCancellationStatusesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  confirmationLastSentAt?: InputMaybe<TimestamptzComparisonExp>;
  confirmationStatus?: InputMaybe<JobAppointmentConfirmationStatusesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  descriptionHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
  endOfAppointmentNextSteps?: InputMaybe<JsonbComparisonExp>;
  estimates?: InputMaybe<EstimatesBoolExp>;
  estimatesAggregate?: InputMaybe<EstimatesAggregateBoolExp>;
  fileLinks?: InputMaybe<FileLinksBoolExp>;
  fileLinksAggregate?: InputMaybe<FileLinksAggregateBoolExp>;
  invoicesQueryables?: InputMaybe<InvoicesQueryableBoolExp>;
  invoicesQueryablesAggregate?: InputMaybe<InvoicesQueryableAggregateBoolExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  jobAppointmentInvoices?: InputMaybe<JobAppointmentInvoicesBoolExp>;
  jobAppointmentInvoicesAggregate?: InputMaybe<JobAppointmentInvoicesAggregateBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  jobInvoices?: InputMaybe<JobInvoicesBoolExp>;
  jobInvoicesAggregate?: InputMaybe<JobInvoicesAggregateBoolExp>;
  notificationType?: InputMaybe<Scalars['AppointmentNotificationTypeComparisonExp']>;
  numReviewRemindersSent?: InputMaybe<IntComparisonExp>;
  photoLinks?: InputMaybe<PhotoLinksBoolExp>;
  photoLinksAggregate?: InputMaybe<PhotoLinksAggregateBoolExp>;
  reminderLastSentAt?: InputMaybe<TimestamptzComparisonExp>;
  sendConfirmationEnabled?: InputMaybe<BooleanComparisonExp>;
  sendConfirmationTo?: InputMaybe<StringComparisonExp>;
  sendReminderEnabled?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "job_appointments" */
export type JobAppointmentsConstraint =
  /** unique or primary key constraint on columns "job_appointment_guid" */
  | 'job_appointments_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type JobAppointmentsDeleteAtPathInput = {
  endOfAppointmentNextSteps?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type JobAppointmentsDeleteElemInput = {
  endOfAppointmentNextSteps?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type JobAppointmentsDeleteKeyInput = {
  endOfAppointmentNextSteps?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "job_appointments" */
export type JobAppointmentsInsertInput = {
  appointmentChecklistInstances?: InputMaybe<AppointmentChecklistInstancesArrRelInsertInput>;
  appointmentReferenceNumber?: InputMaybe<Scalars['String']>;
  appointmentType?: InputMaybe<Scalars['AppointmentType']>;
  appointmentWindowEnd?: InputMaybe<Scalars['timestamptz']>;
  appointmentWindowStart?: InputMaybe<Scalars['timestamptz']>;
  assignments?: InputMaybe<JobAppointmentAssignmentsArrRelInsertInput>;
  cancellationStatus?: InputMaybe<JobAppointmentCancellationStatusesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  confirmationLastSentAt?: InputMaybe<Scalars['timestamptz']>;
  confirmationStatus?: InputMaybe<JobAppointmentConfirmationStatusesObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['HtmlString']>;
  endOfAppointmentNextSteps?: InputMaybe<Scalars['jsonb']>;
  estimates?: InputMaybe<EstimatesArrRelInsertInput>;
  fileLinks?: InputMaybe<FileLinksArrRelInsertInput>;
  invoicesQueryables?: InputMaybe<InvoicesQueryableArrRelInsertInput>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentInvoices?: InputMaybe<JobAppointmentInvoicesArrRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobInvoices?: InputMaybe<JobInvoicesArrRelInsertInput>;
  notificationType?: InputMaybe<Scalars['AppointmentNotificationType']>;
  photoLinks?: InputMaybe<PhotoLinksArrRelInsertInput>;
  reminderLastSentAt?: InputMaybe<Scalars['timestamptz']>;
  sendConfirmationEnabled?: InputMaybe<Scalars['Boolean']>;
  sendConfirmationTo?: InputMaybe<Scalars['String']>;
  sendReminderEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type JobAppointmentsMaxFields = {
  __typename?: 'JobAppointmentsMaxFields';
  appointmentReferenceNumber?: Maybe<Scalars['String']>;
  appointmentType?: Maybe<Scalars['AppointmentType']>;
  appointmentWindowEnd?: Maybe<Scalars['timestamptz']>;
  appointmentWindowStart?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  confirmationLastSentAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['HtmlString']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  notificationType?: Maybe<Scalars['AppointmentNotificationType']>;
  /** A computed field for the number of review reminders sent */
  numReviewRemindersSent?: Maybe<Scalars['Int']>;
  reminderLastSentAt?: Maybe<Scalars['timestamptz']>;
  sendConfirmationTo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "job_appointments" */
export type JobAppointmentsMaxOrderBy = {
  appointmentReferenceNumber?: InputMaybe<OrderBy>;
  appointmentType?: InputMaybe<OrderBy>;
  appointmentWindowEnd?: InputMaybe<OrderBy>;
  appointmentWindowStart?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  confirmationLastSentAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  descriptionHtml?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  notificationType?: InputMaybe<OrderBy>;
  reminderLastSentAt?: InputMaybe<OrderBy>;
  sendConfirmationTo?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobAppointmentsMinFields = {
  __typename?: 'JobAppointmentsMinFields';
  appointmentReferenceNumber?: Maybe<Scalars['String']>;
  appointmentType?: Maybe<Scalars['AppointmentType']>;
  appointmentWindowEnd?: Maybe<Scalars['timestamptz']>;
  appointmentWindowStart?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  confirmationLastSentAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['HtmlString']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  notificationType?: Maybe<Scalars['AppointmentNotificationType']>;
  /** A computed field for the number of review reminders sent */
  numReviewRemindersSent?: Maybe<Scalars['Int']>;
  reminderLastSentAt?: Maybe<Scalars['timestamptz']>;
  sendConfirmationTo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "job_appointments" */
export type JobAppointmentsMinOrderBy = {
  appointmentReferenceNumber?: InputMaybe<OrderBy>;
  appointmentType?: InputMaybe<OrderBy>;
  appointmentWindowEnd?: InputMaybe<OrderBy>;
  appointmentWindowStart?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  confirmationLastSentAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  descriptionHtml?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  notificationType?: InputMaybe<OrderBy>;
  reminderLastSentAt?: InputMaybe<OrderBy>;
  sendConfirmationTo?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "job_appointments" */
export type JobAppointmentsMutationResponse = {
  __typename?: 'JobAppointmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobAppointments>;
};

/** input type for inserting object relation for remote table "job_appointments" */
export type JobAppointmentsObjRelInsertInput = {
  data: JobAppointmentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobAppointmentsOnConflict>;
};

/** on_conflict condition type for table "job_appointments" */
export type JobAppointmentsOnConflict = {
  constraint: JobAppointmentsConstraint;
  updateColumns?: Array<JobAppointmentsUpdateColumn>;
  where?: InputMaybe<JobAppointmentsBoolExp>;
};

/** Ordering options when selecting data from "job_appointments". */
export type JobAppointmentsOrderBy = {
  appointmentChecklistInstancesAggregate?: InputMaybe<AppointmentChecklistInstancesAggregateOrderBy>;
  appointmentReferenceNumber?: InputMaybe<OrderBy>;
  appointmentType?: InputMaybe<OrderBy>;
  appointmentWindowEnd?: InputMaybe<OrderBy>;
  appointmentWindowStart?: InputMaybe<OrderBy>;
  assignmentsAggregate?: InputMaybe<JobAppointmentAssignmentsAggregateOrderBy>;
  cancellationStatus?: InputMaybe<JobAppointmentCancellationStatusesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  confirmationLastSentAt?: InputMaybe<OrderBy>;
  confirmationStatus?: InputMaybe<JobAppointmentConfirmationStatusesOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  descriptionHtml?: InputMaybe<OrderBy>;
  endOfAppointmentNextSteps?: InputMaybe<OrderBy>;
  estimatesAggregate?: InputMaybe<EstimatesAggregateOrderBy>;
  fileLinksAggregate?: InputMaybe<FileLinksAggregateOrderBy>;
  invoicesQueryablesAggregate?: InputMaybe<InvoicesQueryableAggregateOrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentInvoicesAggregate?: InputMaybe<JobAppointmentInvoicesAggregateOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  jobInvoicesAggregate?: InputMaybe<JobInvoicesAggregateOrderBy>;
  notificationType?: InputMaybe<OrderBy>;
  numReviewRemindersSent?: InputMaybe<OrderBy>;
  photoLinksAggregate?: InputMaybe<PhotoLinksAggregateOrderBy>;
  reminderLastSentAt?: InputMaybe<OrderBy>;
  sendConfirmationEnabled?: InputMaybe<OrderBy>;
  sendConfirmationTo?: InputMaybe<OrderBy>;
  sendReminderEnabled?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: job_appointments */
export type JobAppointmentsPkColumnsInput = {
  jobAppointmentGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type JobAppointmentsPrependInput = {
  endOfAppointmentNextSteps?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "job_appointments" */
export type JobAppointmentsSelectColumn =
  /** column name */
  | 'appointmentReferenceNumber'
  /** column name */
  | 'appointmentType'
  /** column name */
  | 'appointmentWindowEnd'
  /** column name */
  | 'appointmentWindowStart'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'confirmationLastSentAt'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'descriptionHtml'
  /** column name */
  | 'endOfAppointmentNextSteps'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'notificationType'
  /** column name */
  | 'reminderLastSentAt'
  /** column name */
  | 'sendConfirmationEnabled'
  /** column name */
  | 'sendConfirmationTo'
  /** column name */
  | 'sendReminderEnabled'
  /** column name */
  | 'updatedAt';

/** select "jobAppointmentsAggregateBoolExpBool_andArgumentsColumns" columns of table "job_appointments" */
export type JobAppointmentsSelectColumnJobAppointmentsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'sendConfirmationEnabled'
  /** column name */
  | 'sendReminderEnabled';

/** select "jobAppointmentsAggregateBoolExpBool_orArgumentsColumns" columns of table "job_appointments" */
export type JobAppointmentsSelectColumnJobAppointmentsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'sendConfirmationEnabled'
  /** column name */
  | 'sendReminderEnabled';

/** input type for updating data in table "job_appointments" */
export type JobAppointmentsSetInput = {
  appointmentReferenceNumber?: InputMaybe<Scalars['String']>;
  appointmentType?: InputMaybe<Scalars['AppointmentType']>;
  appointmentWindowEnd?: InputMaybe<Scalars['timestamptz']>;
  appointmentWindowStart?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  confirmationLastSentAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['HtmlString']>;
  endOfAppointmentNextSteps?: InputMaybe<Scalars['jsonb']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  notificationType?: InputMaybe<Scalars['AppointmentNotificationType']>;
  reminderLastSentAt?: InputMaybe<Scalars['timestamptz']>;
  sendConfirmationEnabled?: InputMaybe<Scalars['Boolean']>;
  sendConfirmationTo?: InputMaybe<Scalars['String']>;
  sendReminderEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type JobAppointmentsStddevFields = {
  __typename?: 'JobAppointmentsStddevFields';
  /** A computed field for the number of review reminders sent */
  numReviewRemindersSent?: Maybe<Scalars['Int']>;
};

/** aggregate stddevPop on columns */
export type JobAppointmentsStddevPopFields = {
  __typename?: 'JobAppointmentsStddevPopFields';
  /** A computed field for the number of review reminders sent */
  numReviewRemindersSent?: Maybe<Scalars['Int']>;
};

/** aggregate stddevSamp on columns */
export type JobAppointmentsStddevSampFields = {
  __typename?: 'JobAppointmentsStddevSampFields';
  /** A computed field for the number of review reminders sent */
  numReviewRemindersSent?: Maybe<Scalars['Int']>;
};

/** Streaming cursor of the table "job_appointments" */
export type JobAppointmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobAppointmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobAppointmentsStreamCursorValueInput = {
  appointmentReferenceNumber?: InputMaybe<Scalars['String']>;
  appointmentType?: InputMaybe<Scalars['AppointmentType']>;
  appointmentWindowEnd?: InputMaybe<Scalars['timestamptz']>;
  appointmentWindowStart?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  confirmationLastSentAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionHtml?: InputMaybe<Scalars['HtmlString']>;
  endOfAppointmentNextSteps?: InputMaybe<Scalars['jsonb']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  notificationType?: InputMaybe<Scalars['AppointmentNotificationType']>;
  reminderLastSentAt?: InputMaybe<Scalars['timestamptz']>;
  sendConfirmationEnabled?: InputMaybe<Scalars['Boolean']>;
  sendConfirmationTo?: InputMaybe<Scalars['String']>;
  sendReminderEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type JobAppointmentsSumFields = {
  __typename?: 'JobAppointmentsSumFields';
  /** A computed field for the number of review reminders sent */
  numReviewRemindersSent?: Maybe<Scalars['Int']>;
};

/** update columns of table "job_appointments" */
export type JobAppointmentsUpdateColumn =
  /** column name */
  | 'appointmentReferenceNumber'
  /** column name */
  | 'appointmentType'
  /** column name */
  | 'appointmentWindowEnd'
  /** column name */
  | 'appointmentWindowStart'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'confirmationLastSentAt'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'descriptionHtml'
  /** column name */
  | 'endOfAppointmentNextSteps'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'notificationType'
  /** column name */
  | 'reminderLastSentAt'
  /** column name */
  | 'sendConfirmationEnabled'
  /** column name */
  | 'sendConfirmationTo'
  /** column name */
  | 'sendReminderEnabled'
  /** column name */
  | 'updatedAt';

export type JobAppointmentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<JobAppointmentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<JobAppointmentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<JobAppointmentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<JobAppointmentsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<JobAppointmentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobAppointmentsSetInput>;
  /** filter the rows which have to be updated */
  where: JobAppointmentsBoolExp;
};

/** aggregate varPop on columns */
export type JobAppointmentsVarPopFields = {
  __typename?: 'JobAppointmentsVarPopFields';
  /** A computed field for the number of review reminders sent */
  numReviewRemindersSent?: Maybe<Scalars['Int']>;
};

/** aggregate varSamp on columns */
export type JobAppointmentsVarSampFields = {
  __typename?: 'JobAppointmentsVarSampFields';
  /** A computed field for the number of review reminders sent */
  numReviewRemindersSent?: Maybe<Scalars['Int']>;
};

/** aggregate variance on columns */
export type JobAppointmentsVarianceFields = {
  __typename?: 'JobAppointmentsVarianceFields';
  /** A computed field for the number of review reminders sent */
  numReviewRemindersSent?: Maybe<Scalars['Int']>;
};

export { JobClassesEnum };

/** Boolean expression to compare columns of type "JobClassesEnum". All fields are combined with logical 'AND'. */
export type JobClassesEnumComparisonExp = {
  _eq?: InputMaybe<JobClassesEnum>;
  _in?: InputMaybe<Array<JobClassesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<JobClassesEnum>;
  _nin?: InputMaybe<Array<JobClassesEnum>>;
};

/** columns and relationships of "job_cost_items" */
export type JobCostItems = {
  __typename?: 'JobCostItems';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  costCategory: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  /** An object relationship */
  job: Jobs;
  jobCostItemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  /** Labor activity type: DRIVE-TIME or ON-SITE. Only applicable for cost_category=labor. Null for non-labor items and legacy labor items. */
  laborActivityType?: Maybe<Scalars['String']>;
  /** An object relationship */
  lastEditByUser: Users;
  lastEditedByUserGuid: Scalars['uuid'];
  /** An object relationship */
  miscCategory?: Maybe<JobCostMiscCategories>;
  miscCategoryGuid?: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  quantity: Scalars['numeric'];
  /** An object relationship */
  sourcePricebookItem?: Maybe<PricebookItems>;
  /** The pricebook item this cost was derived from. NULL for truly manual/custom entries. */
  sourcePricebookItemGuid?: Maybe<Scalars['uuid']>;
  /** Source of the cost item: manual, timesheet, or invoice */
  sourceType: Scalars['String'];
  /** An object relationship */
  timesheetEntryLink?: Maybe<TimesheetEntryLinkData>;
  unitCostUsc: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "job_cost_items" */
export type JobCostItemsAggregate = {
  __typename?: 'JobCostItemsAggregate';
  aggregate?: Maybe<JobCostItemsAggregateFields>;
  nodes: Array<JobCostItems>;
};

export type JobCostItemsAggregateBoolExp = {
  count?: InputMaybe<JobCostItemsAggregateBoolExpCount>;
};

/** aggregate fields of "job_cost_items" */
export type JobCostItemsAggregateFields = {
  __typename?: 'JobCostItemsAggregateFields';
  avg?: Maybe<JobCostItemsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobCostItemsMaxFields>;
  min?: Maybe<JobCostItemsMinFields>;
  stddev?: Maybe<JobCostItemsStddevFields>;
  stddevPop?: Maybe<JobCostItemsStddevPopFields>;
  stddevSamp?: Maybe<JobCostItemsStddevSampFields>;
  sum?: Maybe<JobCostItemsSumFields>;
  varPop?: Maybe<JobCostItemsVarPopFields>;
  varSamp?: Maybe<JobCostItemsVarSampFields>;
  variance?: Maybe<JobCostItemsVarianceFields>;
};


/** aggregate fields of "job_cost_items" */
export type JobCostItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobCostItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_cost_items" */
export type JobCostItemsAggregateOrderBy = {
  avg?: InputMaybe<JobCostItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobCostItemsMaxOrderBy>;
  min?: InputMaybe<JobCostItemsMinOrderBy>;
  stddev?: InputMaybe<JobCostItemsStddevOrderBy>;
  stddevPop?: InputMaybe<JobCostItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<JobCostItemsStddevSampOrderBy>;
  sum?: InputMaybe<JobCostItemsSumOrderBy>;
  varPop?: InputMaybe<JobCostItemsVarPopOrderBy>;
  varSamp?: InputMaybe<JobCostItemsVarSampOrderBy>;
  variance?: InputMaybe<JobCostItemsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "job_cost_items" */
export type JobCostItemsArrRelInsertInput = {
  data: Array<JobCostItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobCostItemsOnConflict>;
};

/** aggregate avg on columns */
export type JobCostItemsAvgFields = {
  __typename?: 'JobCostItemsAvgFields';
  quantity?: Maybe<Scalars['Float']>;
  unitCostUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_cost_items" */
export type JobCostItemsAvgOrderBy = {
  quantity?: InputMaybe<OrderBy>;
  unitCostUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "job_cost_items". All fields are combined with a logical 'AND'. */
export type JobCostItemsBoolExp = {
  _and?: InputMaybe<Array<JobCostItemsBoolExp>>;
  _not?: InputMaybe<JobCostItemsBoolExp>;
  _or?: InputMaybe<Array<JobCostItemsBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  costCategory?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobCostItemGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  laborActivityType?: InputMaybe<StringComparisonExp>;
  lastEditByUser?: InputMaybe<UsersBoolExp>;
  lastEditedByUserGuid?: InputMaybe<UuidComparisonExp>;
  miscCategory?: InputMaybe<JobCostMiscCategoriesBoolExp>;
  miscCategoryGuid?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  quantity?: InputMaybe<NumericComparisonExp>;
  sourcePricebookItem?: InputMaybe<PricebookItemsBoolExp>;
  sourcePricebookItemGuid?: InputMaybe<UuidComparisonExp>;
  sourceType?: InputMaybe<StringComparisonExp>;
  timesheetEntryLink?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
  unitCostUsc?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_cost_items" */
export type JobCostItemsConstraint =
  /** unique or primary key constraint on columns "job_cost_item_guid" */
  | 'job_cost_items_pkey';

/** input type for incrementing numeric columns in table "job_cost_items" */
export type JobCostItemsIncInput = {
  quantity?: InputMaybe<Scalars['numeric']>;
  unitCostUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "job_cost_items" */
export type JobCostItemsInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costCategory?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobCostItemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  /** Labor activity type: DRIVE-TIME or ON-SITE. Only applicable for cost_category=labor. Null for non-labor items and legacy labor items. */
  laborActivityType?: InputMaybe<Scalars['String']>;
  lastEditByUser?: InputMaybe<UsersObjRelInsertInput>;
  lastEditedByUserGuid?: InputMaybe<Scalars['uuid']>;
  miscCategory?: InputMaybe<JobCostMiscCategoriesObjRelInsertInput>;
  miscCategoryGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  sourcePricebookItem?: InputMaybe<PricebookItemsObjRelInsertInput>;
  /** The pricebook item this cost was derived from. NULL for truly manual/custom entries. */
  sourcePricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  /** Source of the cost item: manual, timesheet, or invoice */
  sourceType?: InputMaybe<Scalars['String']>;
  timesheetEntryLink?: InputMaybe<TimesheetEntryLinkDataObjRelInsertInput>;
  unitCostUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobCostItemsMaxFields = {
  __typename?: 'JobCostItemsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  costCategory?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  jobCostItemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** Labor activity type: DRIVE-TIME or ON-SITE. Only applicable for cost_category=labor. Null for non-labor items and legacy labor items. */
  laborActivityType?: Maybe<Scalars['String']>;
  lastEditedByUserGuid?: Maybe<Scalars['uuid']>;
  miscCategoryGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  /** The pricebook item this cost was derived from. NULL for truly manual/custom entries. */
  sourcePricebookItemGuid?: Maybe<Scalars['uuid']>;
  /** Source of the cost item: manual, timesheet, or invoice */
  sourceType?: Maybe<Scalars['String']>;
  unitCostUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "job_cost_items" */
export type JobCostItemsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  costCategory?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  jobCostItemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  /** Labor activity type: DRIVE-TIME or ON-SITE. Only applicable for cost_category=labor. Null for non-labor items and legacy labor items. */
  laborActivityType?: InputMaybe<OrderBy>;
  lastEditedByUserGuid?: InputMaybe<OrderBy>;
  miscCategoryGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  /** The pricebook item this cost was derived from. NULL for truly manual/custom entries. */
  sourcePricebookItemGuid?: InputMaybe<OrderBy>;
  /** Source of the cost item: manual, timesheet, or invoice */
  sourceType?: InputMaybe<OrderBy>;
  unitCostUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobCostItemsMinFields = {
  __typename?: 'JobCostItemsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  costCategory?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  jobCostItemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** Labor activity type: DRIVE-TIME or ON-SITE. Only applicable for cost_category=labor. Null for non-labor items and legacy labor items. */
  laborActivityType?: Maybe<Scalars['String']>;
  lastEditedByUserGuid?: Maybe<Scalars['uuid']>;
  miscCategoryGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  /** The pricebook item this cost was derived from. NULL for truly manual/custom entries. */
  sourcePricebookItemGuid?: Maybe<Scalars['uuid']>;
  /** Source of the cost item: manual, timesheet, or invoice */
  sourceType?: Maybe<Scalars['String']>;
  unitCostUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "job_cost_items" */
export type JobCostItemsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  costCategory?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  jobCostItemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  /** Labor activity type: DRIVE-TIME or ON-SITE. Only applicable for cost_category=labor. Null for non-labor items and legacy labor items. */
  laborActivityType?: InputMaybe<OrderBy>;
  lastEditedByUserGuid?: InputMaybe<OrderBy>;
  miscCategoryGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  /** The pricebook item this cost was derived from. NULL for truly manual/custom entries. */
  sourcePricebookItemGuid?: InputMaybe<OrderBy>;
  /** Source of the cost item: manual, timesheet, or invoice */
  sourceType?: InputMaybe<OrderBy>;
  unitCostUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "job_cost_items" */
export type JobCostItemsMutationResponse = {
  __typename?: 'JobCostItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobCostItems>;
};

/** input type for inserting object relation for remote table "job_cost_items" */
export type JobCostItemsObjRelInsertInput = {
  data: JobCostItemsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobCostItemsOnConflict>;
};

/** on_conflict condition type for table "job_cost_items" */
export type JobCostItemsOnConflict = {
  constraint: JobCostItemsConstraint;
  updateColumns?: Array<JobCostItemsUpdateColumn>;
  where?: InputMaybe<JobCostItemsBoolExp>;
};

/** Ordering options when selecting data from "job_cost_items". */
export type JobCostItemsOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  costCategory?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobCostItemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  laborActivityType?: InputMaybe<OrderBy>;
  lastEditByUser?: InputMaybe<UsersOrderBy>;
  lastEditedByUserGuid?: InputMaybe<OrderBy>;
  miscCategory?: InputMaybe<JobCostMiscCategoriesOrderBy>;
  miscCategoryGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  sourcePricebookItem?: InputMaybe<PricebookItemsOrderBy>;
  sourcePricebookItemGuid?: InputMaybe<OrderBy>;
  sourceType?: InputMaybe<OrderBy>;
  timesheetEntryLink?: InputMaybe<TimesheetEntryLinkDataOrderBy>;
  unitCostUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_cost_items */
export type JobCostItemsPkColumnsInput = {
  jobCostItemGuid: Scalars['uuid'];
};

/** select columns of table "job_cost_items" */
export type JobCostItemsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'costCategory'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'jobCostItemGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'laborActivityType'
  /** column name */
  | 'lastEditedByUserGuid'
  /** column name */
  | 'miscCategoryGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'quantity'
  /** column name */
  | 'sourcePricebookItemGuid'
  /** column name */
  | 'sourceType'
  /** column name */
  | 'unitCostUsc'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "job_cost_items" */
export type JobCostItemsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costCategory?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobCostItemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  /** Labor activity type: DRIVE-TIME or ON-SITE. Only applicable for cost_category=labor. Null for non-labor items and legacy labor items. */
  laborActivityType?: InputMaybe<Scalars['String']>;
  lastEditedByUserGuid?: InputMaybe<Scalars['uuid']>;
  miscCategoryGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  /** The pricebook item this cost was derived from. NULL for truly manual/custom entries. */
  sourcePricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  /** Source of the cost item: manual, timesheet, or invoice */
  sourceType?: InputMaybe<Scalars['String']>;
  unitCostUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type JobCostItemsStddevFields = {
  __typename?: 'JobCostItemsStddevFields';
  quantity?: Maybe<Scalars['Float']>;
  unitCostUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_cost_items" */
export type JobCostItemsStddevOrderBy = {
  quantity?: InputMaybe<OrderBy>;
  unitCostUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type JobCostItemsStddevPopFields = {
  __typename?: 'JobCostItemsStddevPopFields';
  quantity?: Maybe<Scalars['Float']>;
  unitCostUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "job_cost_items" */
export type JobCostItemsStddevPopOrderBy = {
  quantity?: InputMaybe<OrderBy>;
  unitCostUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type JobCostItemsStddevSampFields = {
  __typename?: 'JobCostItemsStddevSampFields';
  quantity?: Maybe<Scalars['Float']>;
  unitCostUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "job_cost_items" */
export type JobCostItemsStddevSampOrderBy = {
  quantity?: InputMaybe<OrderBy>;
  unitCostUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "job_cost_items" */
export type JobCostItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobCostItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobCostItemsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costCategory?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobCostItemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  /** Labor activity type: DRIVE-TIME or ON-SITE. Only applicable for cost_category=labor. Null for non-labor items and legacy labor items. */
  laborActivityType?: InputMaybe<Scalars['String']>;
  lastEditedByUserGuid?: InputMaybe<Scalars['uuid']>;
  miscCategoryGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  /** The pricebook item this cost was derived from. NULL for truly manual/custom entries. */
  sourcePricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  /** Source of the cost item: manual, timesheet, or invoice */
  sourceType?: InputMaybe<Scalars['String']>;
  unitCostUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type JobCostItemsSumFields = {
  __typename?: 'JobCostItemsSumFields';
  quantity?: Maybe<Scalars['numeric']>;
  unitCostUsc?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "job_cost_items" */
export type JobCostItemsSumOrderBy = {
  quantity?: InputMaybe<OrderBy>;
  unitCostUsc?: InputMaybe<OrderBy>;
};

/** update columns of table "job_cost_items" */
export type JobCostItemsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'costCategory'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'jobCostItemGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'laborActivityType'
  /** column name */
  | 'lastEditedByUserGuid'
  /** column name */
  | 'miscCategoryGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'quantity'
  /** column name */
  | 'sourcePricebookItemGuid'
  /** column name */
  | 'sourceType'
  /** column name */
  | 'unitCostUsc'
  /** column name */
  | 'updatedAt';

export type JobCostItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<JobCostItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobCostItemsSetInput>;
  /** filter the rows which have to be updated */
  where: JobCostItemsBoolExp;
};

/** aggregate varPop on columns */
export type JobCostItemsVarPopFields = {
  __typename?: 'JobCostItemsVarPopFields';
  quantity?: Maybe<Scalars['Float']>;
  unitCostUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "job_cost_items" */
export type JobCostItemsVarPopOrderBy = {
  quantity?: InputMaybe<OrderBy>;
  unitCostUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type JobCostItemsVarSampFields = {
  __typename?: 'JobCostItemsVarSampFields';
  quantity?: Maybe<Scalars['Float']>;
  unitCostUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "job_cost_items" */
export type JobCostItemsVarSampOrderBy = {
  quantity?: InputMaybe<OrderBy>;
  unitCostUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JobCostItemsVarianceFields = {
  __typename?: 'JobCostItemsVarianceFields';
  quantity?: Maybe<Scalars['Float']>;
  unitCostUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_cost_items" */
export type JobCostItemsVarianceOrderBy = {
  quantity?: InputMaybe<OrderBy>;
  unitCostUsc?: InputMaybe<OrderBy>;
};

/** columns and relationships of "job_cost_misc_categories" */
export type JobCostMiscCategories = {
  __typename?: 'JobCostMiscCategories';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  /** An array relationship */
  jobCostItems: Array<JobCostItems>;
  /** An aggregate relationship */
  jobCostItemsAggregate: JobCostItemsAggregate;
  /** An object relationship */
  lastEditedByUser: Users;
  lastEditedByUserGuid: Scalars['uuid'];
  miscCategoryGuid: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "job_cost_misc_categories" */
export type JobCostMiscCategoriesJobCostItemsArgs = {
  distinctOn?: InputMaybe<Array<JobCostItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostItemsOrderBy>>;
  where?: InputMaybe<JobCostItemsBoolExp>;
};


/** columns and relationships of "job_cost_misc_categories" */
export type JobCostMiscCategoriesJobCostItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobCostItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostItemsOrderBy>>;
  where?: InputMaybe<JobCostItemsBoolExp>;
};

/** aggregated selection of "job_cost_misc_categories" */
export type JobCostMiscCategoriesAggregate = {
  __typename?: 'JobCostMiscCategoriesAggregate';
  aggregate?: Maybe<JobCostMiscCategoriesAggregateFields>;
  nodes: Array<JobCostMiscCategories>;
};

/** aggregate fields of "job_cost_misc_categories" */
export type JobCostMiscCategoriesAggregateFields = {
  __typename?: 'JobCostMiscCategoriesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobCostMiscCategoriesMaxFields>;
  min?: Maybe<JobCostMiscCategoriesMinFields>;
};


/** aggregate fields of "job_cost_misc_categories" */
export type JobCostMiscCategoriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobCostMiscCategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "job_cost_misc_categories". All fields are combined with a logical 'AND'. */
export type JobCostMiscCategoriesBoolExp = {
  _and?: InputMaybe<Array<JobCostMiscCategoriesBoolExp>>;
  _not?: InputMaybe<JobCostMiscCategoriesBoolExp>;
  _or?: InputMaybe<Array<JobCostMiscCategoriesBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  jobCostItems?: InputMaybe<JobCostItemsBoolExp>;
  jobCostItemsAggregate?: InputMaybe<JobCostItemsAggregateBoolExp>;
  lastEditedByUser?: InputMaybe<UsersBoolExp>;
  lastEditedByUserGuid?: InputMaybe<UuidComparisonExp>;
  miscCategoryGuid?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_cost_misc_categories" */
export type JobCostMiscCategoriesConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'job_cost_misc_categories_company_name_unique'
  /** unique or primary key constraint on columns "misc_category_guid" */
  | 'job_cost_misc_categories_pkey';

/** input type for inserting data into table "job_cost_misc_categories" */
export type JobCostMiscCategoriesInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  jobCostItems?: InputMaybe<JobCostItemsArrRelInsertInput>;
  lastEditedByUser?: InputMaybe<UsersObjRelInsertInput>;
  lastEditedByUserGuid?: InputMaybe<Scalars['uuid']>;
  miscCategoryGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobCostMiscCategoriesMaxFields = {
  __typename?: 'JobCostMiscCategoriesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  lastEditedByUserGuid?: Maybe<Scalars['uuid']>;
  miscCategoryGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type JobCostMiscCategoriesMinFields = {
  __typename?: 'JobCostMiscCategoriesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  lastEditedByUserGuid?: Maybe<Scalars['uuid']>;
  miscCategoryGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "job_cost_misc_categories" */
export type JobCostMiscCategoriesMutationResponse = {
  __typename?: 'JobCostMiscCategoriesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobCostMiscCategories>;
};

/** input type for inserting object relation for remote table "job_cost_misc_categories" */
export type JobCostMiscCategoriesObjRelInsertInput = {
  data: JobCostMiscCategoriesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobCostMiscCategoriesOnConflict>;
};

/** on_conflict condition type for table "job_cost_misc_categories" */
export type JobCostMiscCategoriesOnConflict = {
  constraint: JobCostMiscCategoriesConstraint;
  updateColumns?: Array<JobCostMiscCategoriesUpdateColumn>;
  where?: InputMaybe<JobCostMiscCategoriesBoolExp>;
};

/** Ordering options when selecting data from "job_cost_misc_categories". */
export type JobCostMiscCategoriesOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  jobCostItemsAggregate?: InputMaybe<JobCostItemsAggregateOrderBy>;
  lastEditedByUser?: InputMaybe<UsersOrderBy>;
  lastEditedByUserGuid?: InputMaybe<OrderBy>;
  miscCategoryGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_cost_misc_categories */
export type JobCostMiscCategoriesPkColumnsInput = {
  miscCategoryGuid: Scalars['uuid'];
};

/** select columns of table "job_cost_misc_categories" */
export type JobCostMiscCategoriesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'isActive'
  /** column name */
  | 'lastEditedByUserGuid'
  /** column name */
  | 'miscCategoryGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "job_cost_misc_categories" */
export type JobCostMiscCategoriesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastEditedByUserGuid?: InputMaybe<Scalars['uuid']>;
  miscCategoryGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "job_cost_misc_categories" */
export type JobCostMiscCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobCostMiscCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobCostMiscCategoriesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastEditedByUserGuid?: InputMaybe<Scalars['uuid']>;
  miscCategoryGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "job_cost_misc_categories" */
export type JobCostMiscCategoriesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'isActive'
  /** column name */
  | 'lastEditedByUserGuid'
  /** column name */
  | 'miscCategoryGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt';

export type JobCostMiscCategoriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobCostMiscCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: JobCostMiscCategoriesBoolExp;
};

/** columns and relationships of "job_costing_config" */
export type JobCostingConfig = {
  __typename?: 'JobCostingConfig';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  /** When true, technicians must review job costs before completing an appointment. */
  fieldJobCostReviewRequired: Scalars['Boolean'];
  jobCostingFeatureEnabled: Scalars['Boolean'];
  lastEditedByUserGuid: Scalars['uuid'];
  /** When true, job costing UI is shown in technician app (job costs section + review step). */
  techAppJobCostingEnabled: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "job_costing_config" */
export type JobCostingConfigAggregate = {
  __typename?: 'JobCostingConfigAggregate';
  aggregate?: Maybe<JobCostingConfigAggregateFields>;
  nodes: Array<JobCostingConfig>;
};

/** aggregate fields of "job_costing_config" */
export type JobCostingConfigAggregateFields = {
  __typename?: 'JobCostingConfigAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobCostingConfigMaxFields>;
  min?: Maybe<JobCostingConfigMinFields>;
};


/** aggregate fields of "job_costing_config" */
export type JobCostingConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobCostingConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "job_costing_config". All fields are combined with a logical 'AND'. */
export type JobCostingConfigBoolExp = {
  _and?: InputMaybe<Array<JobCostingConfigBoolExp>>;
  _not?: InputMaybe<JobCostingConfigBoolExp>;
  _or?: InputMaybe<Array<JobCostingConfigBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  fieldJobCostReviewRequired?: InputMaybe<BooleanComparisonExp>;
  jobCostingFeatureEnabled?: InputMaybe<BooleanComparisonExp>;
  lastEditedByUserGuid?: InputMaybe<UuidComparisonExp>;
  techAppJobCostingEnabled?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_costing_config" */
export type JobCostingConfigConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'job_costing_config_pkey';

/** input type for inserting data into table "job_costing_config" */
export type JobCostingConfigInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  /** When true, technicians must review job costs before completing an appointment. */
  fieldJobCostReviewRequired?: InputMaybe<Scalars['Boolean']>;
  jobCostingFeatureEnabled?: InputMaybe<Scalars['Boolean']>;
  lastEditedByUserGuid?: InputMaybe<Scalars['uuid']>;
  /** When true, job costing UI is shown in technician app (job costs section + review step). */
  techAppJobCostingEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobCostingConfigMaxFields = {
  __typename?: 'JobCostingConfigMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  lastEditedByUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type JobCostingConfigMinFields = {
  __typename?: 'JobCostingConfigMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  lastEditedByUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "job_costing_config" */
export type JobCostingConfigMutationResponse = {
  __typename?: 'JobCostingConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobCostingConfig>;
};

/** input type for inserting object relation for remote table "job_costing_config" */
export type JobCostingConfigObjRelInsertInput = {
  data: JobCostingConfigInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobCostingConfigOnConflict>;
};

/** on_conflict condition type for table "job_costing_config" */
export type JobCostingConfigOnConflict = {
  constraint: JobCostingConfigConstraint;
  updateColumns?: Array<JobCostingConfigUpdateColumn>;
  where?: InputMaybe<JobCostingConfigBoolExp>;
};

/** Ordering options when selecting data from "job_costing_config". */
export type JobCostingConfigOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  fieldJobCostReviewRequired?: InputMaybe<OrderBy>;
  jobCostingFeatureEnabled?: InputMaybe<OrderBy>;
  lastEditedByUserGuid?: InputMaybe<OrderBy>;
  techAppJobCostingEnabled?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_costing_config */
export type JobCostingConfigPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "job_costing_config" */
export type JobCostingConfigSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'fieldJobCostReviewRequired'
  /** column name */
  | 'jobCostingFeatureEnabled'
  /** column name */
  | 'lastEditedByUserGuid'
  /** column name */
  | 'techAppJobCostingEnabled'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "job_costing_config" */
export type JobCostingConfigSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  /** When true, technicians must review job costs before completing an appointment. */
  fieldJobCostReviewRequired?: InputMaybe<Scalars['Boolean']>;
  jobCostingFeatureEnabled?: InputMaybe<Scalars['Boolean']>;
  lastEditedByUserGuid?: InputMaybe<Scalars['uuid']>;
  /** When true, job costing UI is shown in technician app (job costs section + review step). */
  techAppJobCostingEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "job_costing_config" */
export type JobCostingConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobCostingConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobCostingConfigStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  /** When true, technicians must review job costs before completing an appointment. */
  fieldJobCostReviewRequired?: InputMaybe<Scalars['Boolean']>;
  jobCostingFeatureEnabled?: InputMaybe<Scalars['Boolean']>;
  lastEditedByUserGuid?: InputMaybe<Scalars['uuid']>;
  /** When true, job costing UI is shown in technician app (job costs section + review step). */
  techAppJobCostingEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "job_costing_config" */
export type JobCostingConfigUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'fieldJobCostReviewRequired'
  /** column name */
  | 'jobCostingFeatureEnabled'
  /** column name */
  | 'lastEditedByUserGuid'
  /** column name */
  | 'techAppJobCostingEnabled'
  /** column name */
  | 'updatedAt';

export type JobCostingConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobCostingConfigSetInput>;
  /** filter the rows which have to be updated */
  where: JobCostingConfigBoolExp;
};

/** columns and relationships of "job_costing_rollup_view" */
export type JobCostingRollupView = {
  __typename?: 'JobCostingRollupView';
  accountCompanyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  accountCompanyLeadSourceName?: Maybe<Scalars['String']>;
  accountDisplayName?: Maybe<Scalars['String']>;
  accountGuid?: Maybe<Scalars['uuid']>;
  accountTagGuids?: Maybe<Array<Scalars['uuid']>>;
  accountTags?: Maybe<Scalars['jsonb']>;
  accountType?: Maybe<Scalars['String']>;
  assignedTechnicianGuids?: Maybe<Array<Scalars['uuid']>>;
  assignedTechnicians?: Maybe<Scalars['jsonb']>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  company?: Maybe<Companies>;
  companyGuid?: Maybe<Scalars['uuid']>;
  displayId?: Maybe<Scalars['bigint']>;
  equipmentCostsUsc?: Maybe<Scalars['bigint']>;
  grossProfitMarginRate?: Maybe<Scalars['numeric']>;
  grossProfitUsc?: Maybe<Scalars['bigint']>;
  isIncludedInJobCosting?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  job?: Maybe<Jobs>;
  jobClass?: Maybe<Scalars['String']>;
  jobCompanyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  jobCompanyLeadSourceName?: Maybe<Scalars['String']>;
  jobCostingTrackingStatus?: Maybe<Scalars['String']>;
  jobCostingVerificationStatus?: Maybe<Scalars['String']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTagGuids?: Maybe<Array<Scalars['uuid']>>;
  jobTags?: Maybe<Scalars['jsonb']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  jobTypeName?: Maybe<Scalars['String']>;
  laborCostsUsc?: Maybe<Scalars['bigint']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  miscCostsUsc?: Maybe<Scalars['bigint']>;
  partsCostsUsc?: Maybe<Scalars['bigint']>;
  reportDateIso?: Maybe<Scalars['timestamptz']>;
  reportLocalDate?: Maybe<Scalars['date']>;
  reportLocalTimestamp?: Maybe<Scalars['timestamp']>;
  revenueUsc?: Maybe<Scalars['bigint']>;
  totalCostsUsc?: Maybe<Scalars['bigint']>;
  zipCode?: Maybe<Scalars['String']>;
};


/** columns and relationships of "job_costing_rollup_view" */
export type JobCostingRollupViewAccountTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "job_costing_rollup_view" */
export type JobCostingRollupViewAssignedTechniciansArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "job_costing_rollup_view" */
export type JobCostingRollupViewJobTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "job_costing_rollup_view" */
export type JobCostingRollupViewAggregate = {
  __typename?: 'JobCostingRollupViewAggregate';
  aggregate?: Maybe<JobCostingRollupViewAggregateFields>;
  nodes: Array<JobCostingRollupView>;
};

/** aggregate fields of "job_costing_rollup_view" */
export type JobCostingRollupViewAggregateFields = {
  __typename?: 'JobCostingRollupViewAggregateFields';
  avg?: Maybe<JobCostingRollupViewAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobCostingRollupViewMaxFields>;
  min?: Maybe<JobCostingRollupViewMinFields>;
  stddev?: Maybe<JobCostingRollupViewStddevFields>;
  stddevPop?: Maybe<JobCostingRollupViewStddevPopFields>;
  stddevSamp?: Maybe<JobCostingRollupViewStddevSampFields>;
  sum?: Maybe<JobCostingRollupViewSumFields>;
  varPop?: Maybe<JobCostingRollupViewVarPopFields>;
  varSamp?: Maybe<JobCostingRollupViewVarSampFields>;
  variance?: Maybe<JobCostingRollupViewVarianceFields>;
};


/** aggregate fields of "job_costing_rollup_view" */
export type JobCostingRollupViewAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobCostingRollupViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type JobCostingRollupViewAvgFields = {
  __typename?: 'JobCostingRollupViewAvgFields';
  displayId?: Maybe<Scalars['Float']>;
  equipmentCostsUsc?: Maybe<Scalars['Float']>;
  grossProfitMarginRate?: Maybe<Scalars['Float']>;
  grossProfitUsc?: Maybe<Scalars['Float']>;
  laborCostsUsc?: Maybe<Scalars['Float']>;
  miscCostsUsc?: Maybe<Scalars['Float']>;
  partsCostsUsc?: Maybe<Scalars['Float']>;
  revenueUsc?: Maybe<Scalars['Float']>;
  totalCostsUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_costing_rollup_view". All fields are combined with a logical 'AND'. */
export type JobCostingRollupViewBoolExp = {
  _and?: InputMaybe<Array<JobCostingRollupViewBoolExp>>;
  _not?: InputMaybe<JobCostingRollupViewBoolExp>;
  _or?: InputMaybe<Array<JobCostingRollupViewBoolExp>>;
  accountCompanyLeadSourceGuid?: InputMaybe<UuidComparisonExp>;
  accountCompanyLeadSourceName?: InputMaybe<StringComparisonExp>;
  accountDisplayName?: InputMaybe<StringComparisonExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  accountTagGuids?: InputMaybe<UuidArrayComparisonExp>;
  accountTags?: InputMaybe<JsonbComparisonExp>;
  accountType?: InputMaybe<StringComparisonExp>;
  assignedTechnicianGuids?: InputMaybe<UuidArrayComparisonExp>;
  assignedTechnicians?: InputMaybe<JsonbComparisonExp>;
  businessUnitGuid?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  displayId?: InputMaybe<BigintComparisonExp>;
  equipmentCostsUsc?: InputMaybe<BigintComparisonExp>;
  grossProfitMarginRate?: InputMaybe<NumericComparisonExp>;
  grossProfitUsc?: InputMaybe<BigintComparisonExp>;
  isIncludedInJobCosting?: InputMaybe<BooleanComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobClass?: InputMaybe<StringComparisonExp>;
  jobCompanyLeadSourceGuid?: InputMaybe<UuidComparisonExp>;
  jobCompanyLeadSourceName?: InputMaybe<StringComparisonExp>;
  jobCostingTrackingStatus?: InputMaybe<StringComparisonExp>;
  jobCostingVerificationStatus?: InputMaybe<StringComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  jobTagGuids?: InputMaybe<UuidArrayComparisonExp>;
  jobTags?: InputMaybe<JsonbComparisonExp>;
  jobTypeGuid?: InputMaybe<UuidComparisonExp>;
  jobTypeName?: InputMaybe<StringComparisonExp>;
  laborCostsUsc?: InputMaybe<BigintComparisonExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  miscCostsUsc?: InputMaybe<BigintComparisonExp>;
  partsCostsUsc?: InputMaybe<BigintComparisonExp>;
  reportDateIso?: InputMaybe<TimestamptzComparisonExp>;
  reportLocalDate?: InputMaybe<DateComparisonExp>;
  reportLocalTimestamp?: InputMaybe<TimestampComparisonExp>;
  revenueUsc?: InputMaybe<BigintComparisonExp>;
  totalCostsUsc?: InputMaybe<BigintComparisonExp>;
  zipCode?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type JobCostingRollupViewMaxFields = {
  __typename?: 'JobCostingRollupViewMaxFields';
  accountCompanyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  accountCompanyLeadSourceName?: Maybe<Scalars['String']>;
  accountDisplayName?: Maybe<Scalars['String']>;
  accountGuid?: Maybe<Scalars['uuid']>;
  accountTagGuids?: Maybe<Array<Scalars['uuid']>>;
  accountType?: Maybe<Scalars['String']>;
  assignedTechnicianGuids?: Maybe<Array<Scalars['uuid']>>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  displayId?: Maybe<Scalars['bigint']>;
  equipmentCostsUsc?: Maybe<Scalars['bigint']>;
  grossProfitMarginRate?: Maybe<Scalars['numeric']>;
  grossProfitUsc?: Maybe<Scalars['bigint']>;
  jobClass?: Maybe<Scalars['String']>;
  jobCompanyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  jobCompanyLeadSourceName?: Maybe<Scalars['String']>;
  jobCostingTrackingStatus?: Maybe<Scalars['String']>;
  jobCostingVerificationStatus?: Maybe<Scalars['String']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTagGuids?: Maybe<Array<Scalars['uuid']>>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  jobTypeName?: Maybe<Scalars['String']>;
  laborCostsUsc?: Maybe<Scalars['bigint']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  miscCostsUsc?: Maybe<Scalars['bigint']>;
  partsCostsUsc?: Maybe<Scalars['bigint']>;
  reportDateIso?: Maybe<Scalars['timestamptz']>;
  reportLocalDate?: Maybe<Scalars['date']>;
  reportLocalTimestamp?: Maybe<Scalars['timestamp']>;
  revenueUsc?: Maybe<Scalars['bigint']>;
  totalCostsUsc?: Maybe<Scalars['bigint']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type JobCostingRollupViewMinFields = {
  __typename?: 'JobCostingRollupViewMinFields';
  accountCompanyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  accountCompanyLeadSourceName?: Maybe<Scalars['String']>;
  accountDisplayName?: Maybe<Scalars['String']>;
  accountGuid?: Maybe<Scalars['uuid']>;
  accountTagGuids?: Maybe<Array<Scalars['uuid']>>;
  accountType?: Maybe<Scalars['String']>;
  assignedTechnicianGuids?: Maybe<Array<Scalars['uuid']>>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  displayId?: Maybe<Scalars['bigint']>;
  equipmentCostsUsc?: Maybe<Scalars['bigint']>;
  grossProfitMarginRate?: Maybe<Scalars['numeric']>;
  grossProfitUsc?: Maybe<Scalars['bigint']>;
  jobClass?: Maybe<Scalars['String']>;
  jobCompanyLeadSourceGuid?: Maybe<Scalars['uuid']>;
  jobCompanyLeadSourceName?: Maybe<Scalars['String']>;
  jobCostingTrackingStatus?: Maybe<Scalars['String']>;
  jobCostingVerificationStatus?: Maybe<Scalars['String']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTagGuids?: Maybe<Array<Scalars['uuid']>>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  jobTypeName?: Maybe<Scalars['String']>;
  laborCostsUsc?: Maybe<Scalars['bigint']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  miscCostsUsc?: Maybe<Scalars['bigint']>;
  partsCostsUsc?: Maybe<Scalars['bigint']>;
  reportDateIso?: Maybe<Scalars['timestamptz']>;
  reportLocalDate?: Maybe<Scalars['date']>;
  reportLocalTimestamp?: Maybe<Scalars['timestamp']>;
  revenueUsc?: Maybe<Scalars['bigint']>;
  totalCostsUsc?: Maybe<Scalars['bigint']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "job_costing_rollup_view". */
export type JobCostingRollupViewOrderBy = {
  accountCompanyLeadSourceGuid?: InputMaybe<OrderBy>;
  accountCompanyLeadSourceName?: InputMaybe<OrderBy>;
  accountDisplayName?: InputMaybe<OrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  accountTagGuids?: InputMaybe<OrderBy>;
  accountTags?: InputMaybe<OrderBy>;
  accountType?: InputMaybe<OrderBy>;
  assignedTechnicianGuids?: InputMaybe<OrderBy>;
  assignedTechnicians?: InputMaybe<OrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  equipmentCostsUsc?: InputMaybe<OrderBy>;
  grossProfitMarginRate?: InputMaybe<OrderBy>;
  grossProfitUsc?: InputMaybe<OrderBy>;
  isIncludedInJobCosting?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobClass?: InputMaybe<OrderBy>;
  jobCompanyLeadSourceGuid?: InputMaybe<OrderBy>;
  jobCompanyLeadSourceName?: InputMaybe<OrderBy>;
  jobCostingTrackingStatus?: InputMaybe<OrderBy>;
  jobCostingVerificationStatus?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  jobTagGuids?: InputMaybe<OrderBy>;
  jobTags?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  jobTypeName?: InputMaybe<OrderBy>;
  laborCostsUsc?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  miscCostsUsc?: InputMaybe<OrderBy>;
  partsCostsUsc?: InputMaybe<OrderBy>;
  reportDateIso?: InputMaybe<OrderBy>;
  reportLocalDate?: InputMaybe<OrderBy>;
  reportLocalTimestamp?: InputMaybe<OrderBy>;
  revenueUsc?: InputMaybe<OrderBy>;
  totalCostsUsc?: InputMaybe<OrderBy>;
  zipCode?: InputMaybe<OrderBy>;
};

/** select columns of table "job_costing_rollup_view" */
export type JobCostingRollupViewSelectColumn =
  /** column name */
  | 'accountCompanyLeadSourceGuid'
  /** column name */
  | 'accountCompanyLeadSourceName'
  /** column name */
  | 'accountDisplayName'
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'accountTagGuids'
  /** column name */
  | 'accountTags'
  /** column name */
  | 'accountType'
  /** column name */
  | 'assignedTechnicianGuids'
  /** column name */
  | 'assignedTechnicians'
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'displayId'
  /** column name */
  | 'equipmentCostsUsc'
  /** column name */
  | 'grossProfitMarginRate'
  /** column name */
  | 'grossProfitUsc'
  /** column name */
  | 'isIncludedInJobCosting'
  /** column name */
  | 'jobClass'
  /** column name */
  | 'jobCompanyLeadSourceGuid'
  /** column name */
  | 'jobCompanyLeadSourceName'
  /** column name */
  | 'jobCostingTrackingStatus'
  /** column name */
  | 'jobCostingVerificationStatus'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'jobTagGuids'
  /** column name */
  | 'jobTags'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'jobTypeName'
  /** column name */
  | 'laborCostsUsc'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'miscCostsUsc'
  /** column name */
  | 'partsCostsUsc'
  /** column name */
  | 'reportDateIso'
  /** column name */
  | 'reportLocalDate'
  /** column name */
  | 'reportLocalTimestamp'
  /** column name */
  | 'revenueUsc'
  /** column name */
  | 'totalCostsUsc'
  /** column name */
  | 'zipCode';

/** aggregate stddev on columns */
export type JobCostingRollupViewStddevFields = {
  __typename?: 'JobCostingRollupViewStddevFields';
  displayId?: Maybe<Scalars['Float']>;
  equipmentCostsUsc?: Maybe<Scalars['Float']>;
  grossProfitMarginRate?: Maybe<Scalars['Float']>;
  grossProfitUsc?: Maybe<Scalars['Float']>;
  laborCostsUsc?: Maybe<Scalars['Float']>;
  miscCostsUsc?: Maybe<Scalars['Float']>;
  partsCostsUsc?: Maybe<Scalars['Float']>;
  revenueUsc?: Maybe<Scalars['Float']>;
  totalCostsUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type JobCostingRollupViewStddevPopFields = {
  __typename?: 'JobCostingRollupViewStddevPopFields';
  displayId?: Maybe<Scalars['Float']>;
  equipmentCostsUsc?: Maybe<Scalars['Float']>;
  grossProfitMarginRate?: Maybe<Scalars['Float']>;
  grossProfitUsc?: Maybe<Scalars['Float']>;
  laborCostsUsc?: Maybe<Scalars['Float']>;
  miscCostsUsc?: Maybe<Scalars['Float']>;
  partsCostsUsc?: Maybe<Scalars['Float']>;
  revenueUsc?: Maybe<Scalars['Float']>;
  totalCostsUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type JobCostingRollupViewStddevSampFields = {
  __typename?: 'JobCostingRollupViewStddevSampFields';
  displayId?: Maybe<Scalars['Float']>;
  equipmentCostsUsc?: Maybe<Scalars['Float']>;
  grossProfitMarginRate?: Maybe<Scalars['Float']>;
  grossProfitUsc?: Maybe<Scalars['Float']>;
  laborCostsUsc?: Maybe<Scalars['Float']>;
  miscCostsUsc?: Maybe<Scalars['Float']>;
  partsCostsUsc?: Maybe<Scalars['Float']>;
  revenueUsc?: Maybe<Scalars['Float']>;
  totalCostsUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_costing_rollup_view" */
export type JobCostingRollupViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobCostingRollupViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobCostingRollupViewStreamCursorValueInput = {
  accountCompanyLeadSourceGuid?: InputMaybe<Scalars['uuid']>;
  accountCompanyLeadSourceName?: InputMaybe<Scalars['String']>;
  accountDisplayName?: InputMaybe<Scalars['String']>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  accountTagGuids?: InputMaybe<Array<Scalars['uuid']>>;
  accountTags?: InputMaybe<Scalars['jsonb']>;
  accountType?: InputMaybe<Scalars['String']>;
  assignedTechnicianGuids?: InputMaybe<Array<Scalars['uuid']>>;
  assignedTechnicians?: InputMaybe<Scalars['jsonb']>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  displayId?: InputMaybe<Scalars['bigint']>;
  equipmentCostsUsc?: InputMaybe<Scalars['bigint']>;
  grossProfitMarginRate?: InputMaybe<Scalars['numeric']>;
  grossProfitUsc?: InputMaybe<Scalars['bigint']>;
  isIncludedInJobCosting?: InputMaybe<Scalars['Boolean']>;
  jobClass?: InputMaybe<Scalars['String']>;
  jobCompanyLeadSourceGuid?: InputMaybe<Scalars['uuid']>;
  jobCompanyLeadSourceName?: InputMaybe<Scalars['String']>;
  jobCostingTrackingStatus?: InputMaybe<Scalars['String']>;
  jobCostingVerificationStatus?: InputMaybe<Scalars['String']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobTagGuids?: InputMaybe<Array<Scalars['uuid']>>;
  jobTags?: InputMaybe<Scalars['jsonb']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeName?: InputMaybe<Scalars['String']>;
  laborCostsUsc?: InputMaybe<Scalars['bigint']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  miscCostsUsc?: InputMaybe<Scalars['bigint']>;
  partsCostsUsc?: InputMaybe<Scalars['bigint']>;
  reportDateIso?: InputMaybe<Scalars['timestamptz']>;
  reportLocalDate?: InputMaybe<Scalars['date']>;
  reportLocalTimestamp?: InputMaybe<Scalars['timestamp']>;
  revenueUsc?: InputMaybe<Scalars['bigint']>;
  totalCostsUsc?: InputMaybe<Scalars['bigint']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type JobCostingRollupViewSumFields = {
  __typename?: 'JobCostingRollupViewSumFields';
  displayId?: Maybe<Scalars['bigint']>;
  equipmentCostsUsc?: Maybe<Scalars['bigint']>;
  grossProfitMarginRate?: Maybe<Scalars['numeric']>;
  grossProfitUsc?: Maybe<Scalars['bigint']>;
  laborCostsUsc?: Maybe<Scalars['bigint']>;
  miscCostsUsc?: Maybe<Scalars['bigint']>;
  partsCostsUsc?: Maybe<Scalars['bigint']>;
  revenueUsc?: Maybe<Scalars['bigint']>;
  totalCostsUsc?: Maybe<Scalars['bigint']>;
};

/** aggregate varPop on columns */
export type JobCostingRollupViewVarPopFields = {
  __typename?: 'JobCostingRollupViewVarPopFields';
  displayId?: Maybe<Scalars['Float']>;
  equipmentCostsUsc?: Maybe<Scalars['Float']>;
  grossProfitMarginRate?: Maybe<Scalars['Float']>;
  grossProfitUsc?: Maybe<Scalars['Float']>;
  laborCostsUsc?: Maybe<Scalars['Float']>;
  miscCostsUsc?: Maybe<Scalars['Float']>;
  partsCostsUsc?: Maybe<Scalars['Float']>;
  revenueUsc?: Maybe<Scalars['Float']>;
  totalCostsUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type JobCostingRollupViewVarSampFields = {
  __typename?: 'JobCostingRollupViewVarSampFields';
  displayId?: Maybe<Scalars['Float']>;
  equipmentCostsUsc?: Maybe<Scalars['Float']>;
  grossProfitMarginRate?: Maybe<Scalars['Float']>;
  grossProfitUsc?: Maybe<Scalars['Float']>;
  laborCostsUsc?: Maybe<Scalars['Float']>;
  miscCostsUsc?: Maybe<Scalars['Float']>;
  partsCostsUsc?: Maybe<Scalars['Float']>;
  revenueUsc?: Maybe<Scalars['Float']>;
  totalCostsUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type JobCostingRollupViewVarianceFields = {
  __typename?: 'JobCostingRollupViewVarianceFields';
  displayId?: Maybe<Scalars['Float']>;
  equipmentCostsUsc?: Maybe<Scalars['Float']>;
  grossProfitMarginRate?: Maybe<Scalars['Float']>;
  grossProfitUsc?: Maybe<Scalars['Float']>;
  laborCostsUsc?: Maybe<Scalars['Float']>;
  miscCostsUsc?: Maybe<Scalars['Float']>;
  partsCostsUsc?: Maybe<Scalars['Float']>;
  revenueUsc?: Maybe<Scalars['Float']>;
  totalCostsUsc?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_invoices" */
export type JobInvoices = {
  __typename?: 'JobInvoices';
  /** An object relationship */
  invoice: Invoices;
  invoiceGuid: Scalars['uuid'];
  /** An object relationship */
  job: Jobs;
  jobGuid: Scalars['uuid'];
};

/** aggregated selection of "job_invoices" */
export type JobInvoicesAggregate = {
  __typename?: 'JobInvoicesAggregate';
  aggregate?: Maybe<JobInvoicesAggregateFields>;
  nodes: Array<JobInvoices>;
};

export type JobInvoicesAggregateBoolExp = {
  count?: InputMaybe<JobInvoicesAggregateBoolExpCount>;
};

/** aggregate fields of "job_invoices" */
export type JobInvoicesAggregateFields = {
  __typename?: 'JobInvoicesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobInvoicesMaxFields>;
  min?: Maybe<JobInvoicesMinFields>;
};


/** aggregate fields of "job_invoices" */
export type JobInvoicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_invoices" */
export type JobInvoicesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobInvoicesMaxOrderBy>;
  min?: InputMaybe<JobInvoicesMinOrderBy>;
};

/** input type for inserting array relation for remote table "job_invoices" */
export type JobInvoicesArrRelInsertInput = {
  data: Array<JobInvoicesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobInvoicesOnConflict>;
};

/** Boolean expression to filter rows from the table "job_invoices". All fields are combined with a logical 'AND'. */
export type JobInvoicesBoolExp = {
  _and?: InputMaybe<Array<JobInvoicesBoolExp>>;
  _not?: InputMaybe<JobInvoicesBoolExp>;
  _or?: InputMaybe<Array<JobInvoicesBoolExp>>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "job_invoices" */
export type JobInvoicesConstraint =
  /** unique or primary key constraint on columns "invoice_guid" */
  | 'job_invoices_pkey';

/** input type for inserting data into table "job_invoices" */
export type JobInvoicesInsertInput = {
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type JobInvoicesMaxFields = {
  __typename?: 'JobInvoicesMaxFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "job_invoices" */
export type JobInvoicesMaxOrderBy = {
  invoiceGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobInvoicesMinFields = {
  __typename?: 'JobInvoicesMinFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "job_invoices" */
export type JobInvoicesMinOrderBy = {
  invoiceGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "job_invoices" */
export type JobInvoicesMutationResponse = {
  __typename?: 'JobInvoicesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobInvoices>;
};

/** input type for inserting object relation for remote table "job_invoices" */
export type JobInvoicesObjRelInsertInput = {
  data: JobInvoicesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobInvoicesOnConflict>;
};

/** on_conflict condition type for table "job_invoices" */
export type JobInvoicesOnConflict = {
  constraint: JobInvoicesConstraint;
  updateColumns?: Array<JobInvoicesUpdateColumn>;
  where?: InputMaybe<JobInvoicesBoolExp>;
};

/** Ordering options when selecting data from "job_invoices". */
export type JobInvoicesOrderBy = {
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_invoices */
export type JobInvoicesPkColumnsInput = {
  invoiceGuid: Scalars['uuid'];
};

/** select columns of table "job_invoices" */
export type JobInvoicesSelectColumn =
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'jobGuid';

/** input type for updating data in table "job_invoices" */
export type JobInvoicesSetInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "job_invoices" */
export type JobInvoicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobInvoicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobInvoicesStreamCursorValueInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "job_invoices" */
export type JobInvoicesUpdateColumn =
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'jobGuid';

export type JobInvoicesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobInvoicesSetInput>;
  /** filter the rows which have to be updated */
  where: JobInvoicesBoolExp;
};

/** columns and relationships of "job_leads" */
export type JobLeads = {
  __typename?: 'JobLeads';
  accountType?: Maybe<Scalars['String']>;
  additionalMetadata?: Maybe<Scalars['JobLeadAdditionalMetadata']>;
  appointmentAvailabilities?: Maybe<Scalars['jsonb']>;
  companyGuid: Scalars['uuid'];
  contactEmailAddress?: Maybe<Scalars['String']>;
  contactFirstName?: Maybe<Scalars['String']>;
  contactLastName?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  equipmentTypes?: Maybe<Scalars['JobLeadEquipmentTypeArray']>;
  estimateType?: Maybe<Scalars['JobLeadEstimateType']>;
  /** An object relationship */
  job?: Maybe<Jobs>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobLeadGuid: Scalars['uuid'];
  jobLeadStatus: Scalars['JobLeadStatus'];
  jobSummary?: Maybe<Scalars['String']>;
  jobType?: Maybe<Scalars['String']>;
  leadSource?: Maybe<Scalars['String']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  originatingPlatformLabel?: Maybe<Scalars['String']>;
  originatingPlatformUrl?: Maybe<Scalars['String']>;
  /** An object relationship */
  preExistingLocation?: Maybe<Locations>;
  preExistingLocationGuid?: Maybe<Scalars['uuid']>;
  requestType?: Maybe<Scalars['OnlineBookingServiceType']>;
  serviceAddressCity?: Maybe<Scalars['String']>;
  serviceAddressLine1?: Maybe<Scalars['String']>;
  serviceAddressLine2?: Maybe<Scalars['String']>;
  serviceAddressStateAbbreviation?: Maybe<Scalars['String']>;
  serviceAddressZipCode?: Maybe<Scalars['String']>;
  /** An object relationship */
  submittedJobType?: Maybe<JobTypes>;
  submittedJobTypeGuid?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "job_leads" */
export type JobLeadsAdditionalMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "job_leads" */
export type JobLeadsAppointmentAvailabilitiesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "job_leads" */
export type JobLeadsEquipmentTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "job_leads" */
export type JobLeadsAggregate = {
  __typename?: 'JobLeadsAggregate';
  aggregate?: Maybe<JobLeadsAggregateFields>;
  nodes: Array<JobLeads>;
};

/** aggregate fields of "job_leads" */
export type JobLeadsAggregateFields = {
  __typename?: 'JobLeadsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobLeadsMaxFields>;
  min?: Maybe<JobLeadsMinFields>;
};


/** aggregate fields of "job_leads" */
export type JobLeadsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobLeadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type JobLeadsAppendInput = {
  additionalMetadata?: InputMaybe<Scalars['jsonb']>;
  appointmentAvailabilities?: InputMaybe<Scalars['jsonb']>;
  equipmentTypes?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "job_leads". All fields are combined with a logical 'AND'. */
export type JobLeadsBoolExp = {
  _and?: InputMaybe<Array<JobLeadsBoolExp>>;
  _not?: InputMaybe<JobLeadsBoolExp>;
  _or?: InputMaybe<Array<JobLeadsBoolExp>>;
  accountType?: InputMaybe<StringComparisonExp>;
  additionalMetadata?: InputMaybe<Scalars['JobLeadAdditionalMetadataComparisonExp']>;
  appointmentAvailabilities?: InputMaybe<JsonbComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  contactEmailAddress?: InputMaybe<StringComparisonExp>;
  contactFirstName?: InputMaybe<StringComparisonExp>;
  contactLastName?: InputMaybe<StringComparisonExp>;
  contactPhoneNumber?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  equipmentTypes?: InputMaybe<Scalars['JobLeadEquipmentTypeArrayComparisonExp']>;
  estimateType?: InputMaybe<Scalars['JobLeadEstimateTypeComparisonExp']>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  jobLeadGuid?: InputMaybe<UuidComparisonExp>;
  jobLeadStatus?: InputMaybe<Scalars['JobLeadStatusComparisonExp']>;
  jobSummary?: InputMaybe<StringComparisonExp>;
  jobType?: InputMaybe<StringComparisonExp>;
  leadSource?: InputMaybe<StringComparisonExp>;
  maintenancePlanVisitGuid?: InputMaybe<UuidComparisonExp>;
  originatingPlatformLabel?: InputMaybe<StringComparisonExp>;
  originatingPlatformUrl?: InputMaybe<StringComparisonExp>;
  preExistingLocation?: InputMaybe<LocationsBoolExp>;
  preExistingLocationGuid?: InputMaybe<UuidComparisonExp>;
  requestType?: InputMaybe<Scalars['OnlineBookingServiceTypeComparisonExp']>;
  serviceAddressCity?: InputMaybe<StringComparisonExp>;
  serviceAddressLine1?: InputMaybe<StringComparisonExp>;
  serviceAddressLine2?: InputMaybe<StringComparisonExp>;
  serviceAddressStateAbbreviation?: InputMaybe<StringComparisonExp>;
  serviceAddressZipCode?: InputMaybe<StringComparisonExp>;
  submittedJobType?: InputMaybe<JobTypesBoolExp>;
  submittedJobTypeGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_leads" */
export type JobLeadsConstraint =
  /** unique or primary key constraint on columns "job_lead_guid" */
  | 'job_leads_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type JobLeadsDeleteAtPathInput = {
  additionalMetadata?: InputMaybe<Array<Scalars['String']>>;
  appointmentAvailabilities?: InputMaybe<Array<Scalars['String']>>;
  equipmentTypes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type JobLeadsDeleteElemInput = {
  additionalMetadata?: InputMaybe<Scalars['Int']>;
  appointmentAvailabilities?: InputMaybe<Scalars['Int']>;
  equipmentTypes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type JobLeadsDeleteKeyInput = {
  additionalMetadata?: InputMaybe<Scalars['String']>;
  appointmentAvailabilities?: InputMaybe<Scalars['String']>;
  equipmentTypes?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "job_leads" */
export type JobLeadsInsertInput = {
  accountType?: InputMaybe<Scalars['String']>;
  additionalMetadata?: InputMaybe<Scalars['JobLeadAdditionalMetadata']>;
  appointmentAvailabilities?: InputMaybe<Scalars['jsonb']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactEmailAddress?: InputMaybe<Scalars['String']>;
  contactFirstName?: InputMaybe<Scalars['String']>;
  contactLastName?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  equipmentTypes?: InputMaybe<Scalars['JobLeadEquipmentTypeArray']>;
  estimateType?: InputMaybe<Scalars['JobLeadEstimateType']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobLeadGuid?: InputMaybe<Scalars['uuid']>;
  jobLeadStatus?: InputMaybe<Scalars['JobLeadStatus']>;
  jobSummary?: InputMaybe<Scalars['String']>;
  jobType?: InputMaybe<Scalars['String']>;
  leadSource?: InputMaybe<Scalars['String']>;
  maintenancePlanVisitGuid?: InputMaybe<Scalars['uuid']>;
  originatingPlatformLabel?: InputMaybe<Scalars['String']>;
  originatingPlatformUrl?: InputMaybe<Scalars['String']>;
  preExistingLocation?: InputMaybe<LocationsObjRelInsertInput>;
  preExistingLocationGuid?: InputMaybe<Scalars['uuid']>;
  requestType?: InputMaybe<Scalars['OnlineBookingServiceType']>;
  serviceAddressCity?: InputMaybe<Scalars['String']>;
  serviceAddressLine1?: InputMaybe<Scalars['String']>;
  serviceAddressLine2?: InputMaybe<Scalars['String']>;
  serviceAddressStateAbbreviation?: InputMaybe<Scalars['String']>;
  serviceAddressZipCode?: InputMaybe<Scalars['String']>;
  submittedJobType?: InputMaybe<JobTypesObjRelInsertInput>;
  submittedJobTypeGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobLeadsMaxFields = {
  __typename?: 'JobLeadsMaxFields';
  accountType?: Maybe<Scalars['String']>;
  additionalMetadata?: Maybe<Scalars['JobLeadAdditionalMetadata']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  contactEmailAddress?: Maybe<Scalars['String']>;
  contactFirstName?: Maybe<Scalars['String']>;
  contactLastName?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  equipmentTypes?: Maybe<Scalars['JobLeadEquipmentTypeArray']>;
  estimateType?: Maybe<Scalars['JobLeadEstimateType']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobLeadGuid?: Maybe<Scalars['uuid']>;
  jobLeadStatus?: Maybe<Scalars['JobLeadStatus']>;
  jobSummary?: Maybe<Scalars['String']>;
  jobType?: Maybe<Scalars['String']>;
  leadSource?: Maybe<Scalars['String']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  originatingPlatformLabel?: Maybe<Scalars['String']>;
  originatingPlatformUrl?: Maybe<Scalars['String']>;
  preExistingLocationGuid?: Maybe<Scalars['uuid']>;
  requestType?: Maybe<Scalars['OnlineBookingServiceType']>;
  serviceAddressCity?: Maybe<Scalars['String']>;
  serviceAddressLine1?: Maybe<Scalars['String']>;
  serviceAddressLine2?: Maybe<Scalars['String']>;
  serviceAddressStateAbbreviation?: Maybe<Scalars['String']>;
  serviceAddressZipCode?: Maybe<Scalars['String']>;
  submittedJobTypeGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type JobLeadsMinFields = {
  __typename?: 'JobLeadsMinFields';
  accountType?: Maybe<Scalars['String']>;
  additionalMetadata?: Maybe<Scalars['JobLeadAdditionalMetadata']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  contactEmailAddress?: Maybe<Scalars['String']>;
  contactFirstName?: Maybe<Scalars['String']>;
  contactLastName?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  equipmentTypes?: Maybe<Scalars['JobLeadEquipmentTypeArray']>;
  estimateType?: Maybe<Scalars['JobLeadEstimateType']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobLeadGuid?: Maybe<Scalars['uuid']>;
  jobLeadStatus?: Maybe<Scalars['JobLeadStatus']>;
  jobSummary?: Maybe<Scalars['String']>;
  jobType?: Maybe<Scalars['String']>;
  leadSource?: Maybe<Scalars['String']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  originatingPlatformLabel?: Maybe<Scalars['String']>;
  originatingPlatformUrl?: Maybe<Scalars['String']>;
  preExistingLocationGuid?: Maybe<Scalars['uuid']>;
  requestType?: Maybe<Scalars['OnlineBookingServiceType']>;
  serviceAddressCity?: Maybe<Scalars['String']>;
  serviceAddressLine1?: Maybe<Scalars['String']>;
  serviceAddressLine2?: Maybe<Scalars['String']>;
  serviceAddressStateAbbreviation?: Maybe<Scalars['String']>;
  serviceAddressZipCode?: Maybe<Scalars['String']>;
  submittedJobTypeGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "job_leads" */
export type JobLeadsMutationResponse = {
  __typename?: 'JobLeadsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobLeads>;
};

/** on_conflict condition type for table "job_leads" */
export type JobLeadsOnConflict = {
  constraint: JobLeadsConstraint;
  updateColumns?: Array<JobLeadsUpdateColumn>;
  where?: InputMaybe<JobLeadsBoolExp>;
};

/** Ordering options when selecting data from "job_leads". */
export type JobLeadsOrderBy = {
  accountType?: InputMaybe<OrderBy>;
  additionalMetadata?: InputMaybe<OrderBy>;
  appointmentAvailabilities?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contactEmailAddress?: InputMaybe<OrderBy>;
  contactFirstName?: InputMaybe<OrderBy>;
  contactLastName?: InputMaybe<OrderBy>;
  contactPhoneNumber?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  equipmentTypes?: InputMaybe<OrderBy>;
  estimateType?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  jobLeadGuid?: InputMaybe<OrderBy>;
  jobLeadStatus?: InputMaybe<OrderBy>;
  jobSummary?: InputMaybe<OrderBy>;
  jobType?: InputMaybe<OrderBy>;
  leadSource?: InputMaybe<OrderBy>;
  maintenancePlanVisitGuid?: InputMaybe<OrderBy>;
  originatingPlatformLabel?: InputMaybe<OrderBy>;
  originatingPlatformUrl?: InputMaybe<OrderBy>;
  preExistingLocation?: InputMaybe<LocationsOrderBy>;
  preExistingLocationGuid?: InputMaybe<OrderBy>;
  requestType?: InputMaybe<OrderBy>;
  serviceAddressCity?: InputMaybe<OrderBy>;
  serviceAddressLine1?: InputMaybe<OrderBy>;
  serviceAddressLine2?: InputMaybe<OrderBy>;
  serviceAddressStateAbbreviation?: InputMaybe<OrderBy>;
  serviceAddressZipCode?: InputMaybe<OrderBy>;
  submittedJobType?: InputMaybe<JobTypesOrderBy>;
  submittedJobTypeGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_leads */
export type JobLeadsPkColumnsInput = {
  jobLeadGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type JobLeadsPrependInput = {
  additionalMetadata?: InputMaybe<Scalars['jsonb']>;
  appointmentAvailabilities?: InputMaybe<Scalars['jsonb']>;
  equipmentTypes?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "job_leads" */
export type JobLeadsSelectColumn =
  /** column name */
  | 'accountType'
  /** column name */
  | 'additionalMetadata'
  /** column name */
  | 'appointmentAvailabilities'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contactEmailAddress'
  /** column name */
  | 'contactFirstName'
  /** column name */
  | 'contactLastName'
  /** column name */
  | 'contactPhoneNumber'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'equipmentTypes'
  /** column name */
  | 'estimateType'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'jobLeadGuid'
  /** column name */
  | 'jobLeadStatus'
  /** column name */
  | 'jobSummary'
  /** column name */
  | 'jobType'
  /** column name */
  | 'leadSource'
  /** column name */
  | 'maintenancePlanVisitGuid'
  /** column name */
  | 'originatingPlatformLabel'
  /** column name */
  | 'originatingPlatformUrl'
  /** column name */
  | 'preExistingLocationGuid'
  /** column name */
  | 'requestType'
  /** column name */
  | 'serviceAddressCity'
  /** column name */
  | 'serviceAddressLine1'
  /** column name */
  | 'serviceAddressLine2'
  /** column name */
  | 'serviceAddressStateAbbreviation'
  /** column name */
  | 'serviceAddressZipCode'
  /** column name */
  | 'submittedJobTypeGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "job_leads" */
export type JobLeadsSetInput = {
  accountType?: InputMaybe<Scalars['String']>;
  additionalMetadata?: InputMaybe<Scalars['JobLeadAdditionalMetadata']>;
  appointmentAvailabilities?: InputMaybe<Scalars['jsonb']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactEmailAddress?: InputMaybe<Scalars['String']>;
  contactFirstName?: InputMaybe<Scalars['String']>;
  contactLastName?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  equipmentTypes?: InputMaybe<Scalars['JobLeadEquipmentTypeArray']>;
  estimateType?: InputMaybe<Scalars['JobLeadEstimateType']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobLeadGuid?: InputMaybe<Scalars['uuid']>;
  jobLeadStatus?: InputMaybe<Scalars['JobLeadStatus']>;
  jobSummary?: InputMaybe<Scalars['String']>;
  jobType?: InputMaybe<Scalars['String']>;
  leadSource?: InputMaybe<Scalars['String']>;
  maintenancePlanVisitGuid?: InputMaybe<Scalars['uuid']>;
  originatingPlatformLabel?: InputMaybe<Scalars['String']>;
  originatingPlatformUrl?: InputMaybe<Scalars['String']>;
  preExistingLocationGuid?: InputMaybe<Scalars['uuid']>;
  requestType?: InputMaybe<Scalars['OnlineBookingServiceType']>;
  serviceAddressCity?: InputMaybe<Scalars['String']>;
  serviceAddressLine1?: InputMaybe<Scalars['String']>;
  serviceAddressLine2?: InputMaybe<Scalars['String']>;
  serviceAddressStateAbbreviation?: InputMaybe<Scalars['String']>;
  serviceAddressZipCode?: InputMaybe<Scalars['String']>;
  submittedJobTypeGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "job_leads" */
export type JobLeadsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobLeadsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobLeadsStreamCursorValueInput = {
  accountType?: InputMaybe<Scalars['String']>;
  additionalMetadata?: InputMaybe<Scalars['JobLeadAdditionalMetadata']>;
  appointmentAvailabilities?: InputMaybe<Scalars['jsonb']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactEmailAddress?: InputMaybe<Scalars['String']>;
  contactFirstName?: InputMaybe<Scalars['String']>;
  contactLastName?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  equipmentTypes?: InputMaybe<Scalars['JobLeadEquipmentTypeArray']>;
  estimateType?: InputMaybe<Scalars['JobLeadEstimateType']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobLeadGuid?: InputMaybe<Scalars['uuid']>;
  jobLeadStatus?: InputMaybe<Scalars['JobLeadStatus']>;
  jobSummary?: InputMaybe<Scalars['String']>;
  jobType?: InputMaybe<Scalars['String']>;
  leadSource?: InputMaybe<Scalars['String']>;
  maintenancePlanVisitGuid?: InputMaybe<Scalars['uuid']>;
  originatingPlatformLabel?: InputMaybe<Scalars['String']>;
  originatingPlatformUrl?: InputMaybe<Scalars['String']>;
  preExistingLocationGuid?: InputMaybe<Scalars['uuid']>;
  requestType?: InputMaybe<Scalars['OnlineBookingServiceType']>;
  serviceAddressCity?: InputMaybe<Scalars['String']>;
  serviceAddressLine1?: InputMaybe<Scalars['String']>;
  serviceAddressLine2?: InputMaybe<Scalars['String']>;
  serviceAddressStateAbbreviation?: InputMaybe<Scalars['String']>;
  serviceAddressZipCode?: InputMaybe<Scalars['String']>;
  submittedJobTypeGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "job_leads" */
export type JobLeadsUpdateColumn =
  /** column name */
  | 'accountType'
  /** column name */
  | 'additionalMetadata'
  /** column name */
  | 'appointmentAvailabilities'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contactEmailAddress'
  /** column name */
  | 'contactFirstName'
  /** column name */
  | 'contactLastName'
  /** column name */
  | 'contactPhoneNumber'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'equipmentTypes'
  /** column name */
  | 'estimateType'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'jobLeadGuid'
  /** column name */
  | 'jobLeadStatus'
  /** column name */
  | 'jobSummary'
  /** column name */
  | 'jobType'
  /** column name */
  | 'leadSource'
  /** column name */
  | 'maintenancePlanVisitGuid'
  /** column name */
  | 'originatingPlatformLabel'
  /** column name */
  | 'originatingPlatformUrl'
  /** column name */
  | 'preExistingLocationGuid'
  /** column name */
  | 'requestType'
  /** column name */
  | 'serviceAddressCity'
  /** column name */
  | 'serviceAddressLine1'
  /** column name */
  | 'serviceAddressLine2'
  /** column name */
  | 'serviceAddressStateAbbreviation'
  /** column name */
  | 'serviceAddressZipCode'
  /** column name */
  | 'submittedJobTypeGuid'
  /** column name */
  | 'updatedAt';

export type JobLeadsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<JobLeadsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<JobLeadsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<JobLeadsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<JobLeadsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<JobLeadsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobLeadsSetInput>;
  /** filter the rows which have to be updated */
  where: JobLeadsBoolExp;
};

/** columns and relationships of "job_lifecycle_statuses" */
export type JobLifecycleStatuses = {
  __typename?: 'JobLifecycleStatuses';
  color: Scalars['String'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  description: Scalars['String'];
  isAllAppointmentsCompletedAutomationEnabled: Scalars['Boolean'];
  isAllOutstandingAppointmentsAssignedAutomationEnabled: Scalars['Boolean'];
  isCreateLinkedJobAutomationEnabled: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  isFirstAppointmentBookedAutomationEnabled: Scalars['Boolean'];
  isLeadWon: Scalars['Boolean'];
  isNoAdditionalWorkRequiredAutomationEnabled: Scalars['Boolean'];
  isOnsiteWorkNotCompleteAutomationEnabled: Scalars['Boolean'];
  isTechnicianArrivesAtAppointmentAutomationEnabled: Scalars['Boolean'];
  isTechnicianDispatchedAutomationEnabled: Scalars['Boolean'];
  isWorkComplete: Scalars['Boolean'];
  /** An object relationship */
  jobLifecycle: JobLifecycles;
  jobLifecycleGuid: Scalars['uuid'];
  jobLifecycleStatusGuid: Scalars['uuid'];
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobsAggregate: JobsAggregate;
  lastModifiedBy: Scalars['String'];
  name: Scalars['String'];
  specialStatus?: Maybe<Scalars['SpecialLifecycleStatus']>;
  stage: Scalars['JobLifecycleStage'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "job_lifecycle_statuses" */
export type JobLifecycleStatusesJobsArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


/** columns and relationships of "job_lifecycle_statuses" */
export type JobLifecycleStatusesJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};

/** aggregated selection of "job_lifecycle_statuses" */
export type JobLifecycleStatusesAggregate = {
  __typename?: 'JobLifecycleStatusesAggregate';
  aggregate?: Maybe<JobLifecycleStatusesAggregateFields>;
  nodes: Array<JobLifecycleStatuses>;
};

export type JobLifecycleStatusesAggregateBoolExp = {
  bool_and?: InputMaybe<JobLifecycleStatusesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<JobLifecycleStatusesAggregateBoolExpBool_Or>;
  count?: InputMaybe<JobLifecycleStatusesAggregateBoolExpCount>;
};

/** aggregate fields of "job_lifecycle_statuses" */
export type JobLifecycleStatusesAggregateFields = {
  __typename?: 'JobLifecycleStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobLifecycleStatusesMaxFields>;
  min?: Maybe<JobLifecycleStatusesMinFields>;
};


/** aggregate fields of "job_lifecycle_statuses" */
export type JobLifecycleStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobLifecycleStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_lifecycle_statuses" */
export type JobLifecycleStatusesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobLifecycleStatusesMaxOrderBy>;
  min?: InputMaybe<JobLifecycleStatusesMinOrderBy>;
};

/** input type for inserting array relation for remote table "job_lifecycle_statuses" */
export type JobLifecycleStatusesArrRelInsertInput = {
  data: Array<JobLifecycleStatusesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobLifecycleStatusesOnConflict>;
};

/** Boolean expression to filter rows from the table "job_lifecycle_statuses". All fields are combined with a logical 'AND'. */
export type JobLifecycleStatusesBoolExp = {
  _and?: InputMaybe<Array<JobLifecycleStatusesBoolExp>>;
  _not?: InputMaybe<JobLifecycleStatusesBoolExp>;
  _or?: InputMaybe<Array<JobLifecycleStatusesBoolExp>>;
  color?: InputMaybe<StringComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  isAllAppointmentsCompletedAutomationEnabled?: InputMaybe<BooleanComparisonExp>;
  isAllOutstandingAppointmentsAssignedAutomationEnabled?: InputMaybe<BooleanComparisonExp>;
  isCreateLinkedJobAutomationEnabled?: InputMaybe<BooleanComparisonExp>;
  isDefault?: InputMaybe<BooleanComparisonExp>;
  isFirstAppointmentBookedAutomationEnabled?: InputMaybe<BooleanComparisonExp>;
  isLeadWon?: InputMaybe<BooleanComparisonExp>;
  isNoAdditionalWorkRequiredAutomationEnabled?: InputMaybe<BooleanComparisonExp>;
  isOnsiteWorkNotCompleteAutomationEnabled?: InputMaybe<BooleanComparisonExp>;
  isTechnicianArrivesAtAppointmentAutomationEnabled?: InputMaybe<BooleanComparisonExp>;
  isTechnicianDispatchedAutomationEnabled?: InputMaybe<BooleanComparisonExp>;
  isWorkComplete?: InputMaybe<BooleanComparisonExp>;
  jobLifecycle?: InputMaybe<JobLifecyclesBoolExp>;
  jobLifecycleGuid?: InputMaybe<UuidComparisonExp>;
  jobLifecycleStatusGuid?: InputMaybe<UuidComparisonExp>;
  jobs?: InputMaybe<JobsBoolExp>;
  jobsAggregate?: InputMaybe<JobsAggregateBoolExp>;
  lastModifiedBy?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  specialStatus?: InputMaybe<Scalars['SpecialLifecycleStatusComparisonExp']>;
  stage?: InputMaybe<Scalars['JobLifecycleStageComparisonExp']>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_lifecycle_statuses" */
export type JobLifecycleStatusesConstraint =
  /** unique or primary key constraint on columns "job_lifecycle_guid", "name" */
  | 'job_lifecycle_statuses_job_lifecycle_guid_name_key'
  /** unique or primary key constraint on columns "job_lifecycle_status_guid" */
  | 'job_lifecycle_statuses_pkey';

/** input type for inserting data into table "job_lifecycle_statuses" */
export type JobLifecycleStatusesInsertInput = {
  color?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  isAllAppointmentsCompletedAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isAllOutstandingAppointmentsAssignedAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isCreateLinkedJobAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isFirstAppointmentBookedAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isLeadWon?: InputMaybe<Scalars['Boolean']>;
  isNoAdditionalWorkRequiredAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isOnsiteWorkNotCompleteAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isTechnicianArrivesAtAppointmentAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isTechnicianDispatchedAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isWorkComplete?: InputMaybe<Scalars['Boolean']>;
  jobLifecycle?: InputMaybe<JobLifecyclesObjRelInsertInput>;
  jobLifecycleGuid?: InputMaybe<Scalars['uuid']>;
  jobLifecycleStatusGuid?: InputMaybe<Scalars['uuid']>;
  jobs?: InputMaybe<JobsArrRelInsertInput>;
  lastModifiedBy?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  specialStatus?: InputMaybe<Scalars['SpecialLifecycleStatus']>;
  stage?: InputMaybe<Scalars['JobLifecycleStage']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobLifecycleStatusesMaxFields = {
  __typename?: 'JobLifecycleStatusesMaxFields';
  color?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  jobLifecycleGuid?: Maybe<Scalars['uuid']>;
  jobLifecycleStatusGuid?: Maybe<Scalars['uuid']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  specialStatus?: Maybe<Scalars['SpecialLifecycleStatus']>;
  stage?: Maybe<Scalars['JobLifecycleStage']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "job_lifecycle_statuses" */
export type JobLifecycleStatusesMaxOrderBy = {
  color?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  jobLifecycleGuid?: InputMaybe<OrderBy>;
  jobLifecycleStatusGuid?: InputMaybe<OrderBy>;
  lastModifiedBy?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  specialStatus?: InputMaybe<OrderBy>;
  stage?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobLifecycleStatusesMinFields = {
  __typename?: 'JobLifecycleStatusesMinFields';
  color?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  jobLifecycleGuid?: Maybe<Scalars['uuid']>;
  jobLifecycleStatusGuid?: Maybe<Scalars['uuid']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  specialStatus?: Maybe<Scalars['SpecialLifecycleStatus']>;
  stage?: Maybe<Scalars['JobLifecycleStage']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "job_lifecycle_statuses" */
export type JobLifecycleStatusesMinOrderBy = {
  color?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  jobLifecycleGuid?: InputMaybe<OrderBy>;
  jobLifecycleStatusGuid?: InputMaybe<OrderBy>;
  lastModifiedBy?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  specialStatus?: InputMaybe<OrderBy>;
  stage?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "job_lifecycle_statuses" */
export type JobLifecycleStatusesMutationResponse = {
  __typename?: 'JobLifecycleStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobLifecycleStatuses>;
};

/** input type for inserting object relation for remote table "job_lifecycle_statuses" */
export type JobLifecycleStatusesObjRelInsertInput = {
  data: JobLifecycleStatusesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobLifecycleStatusesOnConflict>;
};

/** on_conflict condition type for table "job_lifecycle_statuses" */
export type JobLifecycleStatusesOnConflict = {
  constraint: JobLifecycleStatusesConstraint;
  updateColumns?: Array<JobLifecycleStatusesUpdateColumn>;
  where?: InputMaybe<JobLifecycleStatusesBoolExp>;
};

/** Ordering options when selecting data from "job_lifecycle_statuses". */
export type JobLifecycleStatusesOrderBy = {
  color?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  isAllAppointmentsCompletedAutomationEnabled?: InputMaybe<OrderBy>;
  isAllOutstandingAppointmentsAssignedAutomationEnabled?: InputMaybe<OrderBy>;
  isCreateLinkedJobAutomationEnabled?: InputMaybe<OrderBy>;
  isDefault?: InputMaybe<OrderBy>;
  isFirstAppointmentBookedAutomationEnabled?: InputMaybe<OrderBy>;
  isLeadWon?: InputMaybe<OrderBy>;
  isNoAdditionalWorkRequiredAutomationEnabled?: InputMaybe<OrderBy>;
  isOnsiteWorkNotCompleteAutomationEnabled?: InputMaybe<OrderBy>;
  isTechnicianArrivesAtAppointmentAutomationEnabled?: InputMaybe<OrderBy>;
  isTechnicianDispatchedAutomationEnabled?: InputMaybe<OrderBy>;
  isWorkComplete?: InputMaybe<OrderBy>;
  jobLifecycle?: InputMaybe<JobLifecyclesOrderBy>;
  jobLifecycleGuid?: InputMaybe<OrderBy>;
  jobLifecycleStatusGuid?: InputMaybe<OrderBy>;
  jobsAggregate?: InputMaybe<JobsAggregateOrderBy>;
  lastModifiedBy?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  specialStatus?: InputMaybe<OrderBy>;
  stage?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_lifecycle_statuses */
export type JobLifecycleStatusesPkColumnsInput = {
  jobLifecycleStatusGuid: Scalars['uuid'];
};

/** select columns of table "job_lifecycle_statuses" */
export type JobLifecycleStatusesSelectColumn =
  /** column name */
  | 'color'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'isAllAppointmentsCompletedAutomationEnabled'
  /** column name */
  | 'isAllOutstandingAppointmentsAssignedAutomationEnabled'
  /** column name */
  | 'isCreateLinkedJobAutomationEnabled'
  /** column name */
  | 'isDefault'
  /** column name */
  | 'isFirstAppointmentBookedAutomationEnabled'
  /** column name */
  | 'isLeadWon'
  /** column name */
  | 'isNoAdditionalWorkRequiredAutomationEnabled'
  /** column name */
  | 'isOnsiteWorkNotCompleteAutomationEnabled'
  /** column name */
  | 'isTechnicianArrivesAtAppointmentAutomationEnabled'
  /** column name */
  | 'isTechnicianDispatchedAutomationEnabled'
  /** column name */
  | 'isWorkComplete'
  /** column name */
  | 'jobLifecycleGuid'
  /** column name */
  | 'jobLifecycleStatusGuid'
  /** column name */
  | 'lastModifiedBy'
  /** column name */
  | 'name'
  /** column name */
  | 'specialStatus'
  /** column name */
  | 'stage'
  /** column name */
  | 'updatedAt';

/** select "jobLifecycleStatusesAggregateBoolExpBool_andArgumentsColumns" columns of table "job_lifecycle_statuses" */
export type JobLifecycleStatusesSelectColumnJobLifecycleStatusesAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isAllAppointmentsCompletedAutomationEnabled'
  /** column name */
  | 'isAllOutstandingAppointmentsAssignedAutomationEnabled'
  /** column name */
  | 'isCreateLinkedJobAutomationEnabled'
  /** column name */
  | 'isDefault'
  /** column name */
  | 'isFirstAppointmentBookedAutomationEnabled'
  /** column name */
  | 'isLeadWon'
  /** column name */
  | 'isNoAdditionalWorkRequiredAutomationEnabled'
  /** column name */
  | 'isOnsiteWorkNotCompleteAutomationEnabled'
  /** column name */
  | 'isTechnicianArrivesAtAppointmentAutomationEnabled'
  /** column name */
  | 'isTechnicianDispatchedAutomationEnabled'
  /** column name */
  | 'isWorkComplete';

/** select "jobLifecycleStatusesAggregateBoolExpBool_orArgumentsColumns" columns of table "job_lifecycle_statuses" */
export type JobLifecycleStatusesSelectColumnJobLifecycleStatusesAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isAllAppointmentsCompletedAutomationEnabled'
  /** column name */
  | 'isAllOutstandingAppointmentsAssignedAutomationEnabled'
  /** column name */
  | 'isCreateLinkedJobAutomationEnabled'
  /** column name */
  | 'isDefault'
  /** column name */
  | 'isFirstAppointmentBookedAutomationEnabled'
  /** column name */
  | 'isLeadWon'
  /** column name */
  | 'isNoAdditionalWorkRequiredAutomationEnabled'
  /** column name */
  | 'isOnsiteWorkNotCompleteAutomationEnabled'
  /** column name */
  | 'isTechnicianArrivesAtAppointmentAutomationEnabled'
  /** column name */
  | 'isTechnicianDispatchedAutomationEnabled'
  /** column name */
  | 'isWorkComplete';

/** input type for updating data in table "job_lifecycle_statuses" */
export type JobLifecycleStatusesSetInput = {
  color?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  isAllAppointmentsCompletedAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isAllOutstandingAppointmentsAssignedAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isCreateLinkedJobAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isFirstAppointmentBookedAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isLeadWon?: InputMaybe<Scalars['Boolean']>;
  isNoAdditionalWorkRequiredAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isOnsiteWorkNotCompleteAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isTechnicianArrivesAtAppointmentAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isTechnicianDispatchedAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isWorkComplete?: InputMaybe<Scalars['Boolean']>;
  jobLifecycleGuid?: InputMaybe<Scalars['uuid']>;
  jobLifecycleStatusGuid?: InputMaybe<Scalars['uuid']>;
  lastModifiedBy?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  specialStatus?: InputMaybe<Scalars['SpecialLifecycleStatus']>;
  stage?: InputMaybe<Scalars['JobLifecycleStage']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "job_lifecycle_statuses" */
export type JobLifecycleStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobLifecycleStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobLifecycleStatusesStreamCursorValueInput = {
  color?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  isAllAppointmentsCompletedAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isAllOutstandingAppointmentsAssignedAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isCreateLinkedJobAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isFirstAppointmentBookedAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isLeadWon?: InputMaybe<Scalars['Boolean']>;
  isNoAdditionalWorkRequiredAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isOnsiteWorkNotCompleteAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isTechnicianArrivesAtAppointmentAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isTechnicianDispatchedAutomationEnabled?: InputMaybe<Scalars['Boolean']>;
  isWorkComplete?: InputMaybe<Scalars['Boolean']>;
  jobLifecycleGuid?: InputMaybe<Scalars['uuid']>;
  jobLifecycleStatusGuid?: InputMaybe<Scalars['uuid']>;
  lastModifiedBy?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  specialStatus?: InputMaybe<Scalars['SpecialLifecycleStatus']>;
  stage?: InputMaybe<Scalars['JobLifecycleStage']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "job_lifecycle_statuses" */
export type JobLifecycleStatusesUpdateColumn =
  /** column name */
  | 'color'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'isAllAppointmentsCompletedAutomationEnabled'
  /** column name */
  | 'isAllOutstandingAppointmentsAssignedAutomationEnabled'
  /** column name */
  | 'isCreateLinkedJobAutomationEnabled'
  /** column name */
  | 'isDefault'
  /** column name */
  | 'isFirstAppointmentBookedAutomationEnabled'
  /** column name */
  | 'isLeadWon'
  /** column name */
  | 'isNoAdditionalWorkRequiredAutomationEnabled'
  /** column name */
  | 'isOnsiteWorkNotCompleteAutomationEnabled'
  /** column name */
  | 'isTechnicianArrivesAtAppointmentAutomationEnabled'
  /** column name */
  | 'isTechnicianDispatchedAutomationEnabled'
  /** column name */
  | 'isWorkComplete'
  /** column name */
  | 'jobLifecycleGuid'
  /** column name */
  | 'jobLifecycleStatusGuid'
  /** column name */
  | 'lastModifiedBy'
  /** column name */
  | 'name'
  /** column name */
  | 'specialStatus'
  /** column name */
  | 'stage'
  /** column name */
  | 'updatedAt';

export type JobLifecycleStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobLifecycleStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: JobLifecycleStatusesBoolExp;
};

/** The different types of job lifecycles */
export type JobLifecycleTypes = {
  __typename?: 'JobLifecycleTypes';
  name: Scalars['String'];
};

/** aggregated selection of "job_lifecycle_types" */
export type JobLifecycleTypesAggregate = {
  __typename?: 'JobLifecycleTypesAggregate';
  aggregate?: Maybe<JobLifecycleTypesAggregateFields>;
  nodes: Array<JobLifecycleTypes>;
};

/** aggregate fields of "job_lifecycle_types" */
export type JobLifecycleTypesAggregateFields = {
  __typename?: 'JobLifecycleTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobLifecycleTypesMaxFields>;
  min?: Maybe<JobLifecycleTypesMinFields>;
};


/** aggregate fields of "job_lifecycle_types" */
export type JobLifecycleTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobLifecycleTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "job_lifecycle_types". All fields are combined with a logical 'AND'. */
export type JobLifecycleTypesBoolExp = {
  _and?: InputMaybe<Array<JobLifecycleTypesBoolExp>>;
  _not?: InputMaybe<JobLifecycleTypesBoolExp>;
  _or?: InputMaybe<Array<JobLifecycleTypesBoolExp>>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "job_lifecycle_types" */
export type JobLifecycleTypesConstraint =
  /** unique or primary key constraint on columns "name" */
  | 'job_lifecycle_types_pkey';

/** input type for inserting data into table "job_lifecycle_types" */
export type JobLifecycleTypesInsertInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type JobLifecycleTypesMaxFields = {
  __typename?: 'JobLifecycleTypesMaxFields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type JobLifecycleTypesMinFields = {
  __typename?: 'JobLifecycleTypesMinFields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_lifecycle_types" */
export type JobLifecycleTypesMutationResponse = {
  __typename?: 'JobLifecycleTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobLifecycleTypes>;
};

/** on_conflict condition type for table "job_lifecycle_types" */
export type JobLifecycleTypesOnConflict = {
  constraint: JobLifecycleTypesConstraint;
  updateColumns?: Array<JobLifecycleTypesUpdateColumn>;
  where?: InputMaybe<JobLifecycleTypesBoolExp>;
};

/** Ordering options when selecting data from "job_lifecycle_types". */
export type JobLifecycleTypesOrderBy = {
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_lifecycle_types */
export type JobLifecycleTypesPkColumnsInput = {
  name: Scalars['String'];
};

/** select columns of table "job_lifecycle_types" */
export type JobLifecycleTypesSelectColumn =
  /** column name */
  | 'name';

/** input type for updating data in table "job_lifecycle_types" */
export type JobLifecycleTypesSetInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "job_lifecycle_types" */
export type JobLifecycleTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobLifecycleTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobLifecycleTypesStreamCursorValueInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "job_lifecycle_types" */
export type JobLifecycleTypesUpdateColumn =
  /** column name */
  | 'name';

export type JobLifecycleTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobLifecycleTypesSetInput>;
  /** filter the rows which have to be updated */
  where: JobLifecycleTypesBoolExp;
};

/** The views a user can see for their Job Lifecycles */
export type JobLifecycleViews = {
  __typename?: 'JobLifecycleViews';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  jobLifecycleViewGuid: Scalars['uuid'];
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  view: Scalars['jsonb'];
};


/** The views a user can see for their Job Lifecycles */
export type JobLifecycleViewsViewArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "job_lifecycle_views" */
export type JobLifecycleViewsAggregate = {
  __typename?: 'JobLifecycleViewsAggregate';
  aggregate?: Maybe<JobLifecycleViewsAggregateFields>;
  nodes: Array<JobLifecycleViews>;
};

/** aggregate fields of "job_lifecycle_views" */
export type JobLifecycleViewsAggregateFields = {
  __typename?: 'JobLifecycleViewsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobLifecycleViewsMaxFields>;
  min?: Maybe<JobLifecycleViewsMinFields>;
};


/** aggregate fields of "job_lifecycle_views" */
export type JobLifecycleViewsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobLifecycleViewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type JobLifecycleViewsAppendInput = {
  view?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "job_lifecycle_views". All fields are combined with a logical 'AND'. */
export type JobLifecycleViewsBoolExp = {
  _and?: InputMaybe<Array<JobLifecycleViewsBoolExp>>;
  _not?: InputMaybe<JobLifecycleViewsBoolExp>;
  _or?: InputMaybe<Array<JobLifecycleViewsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  jobLifecycleViewGuid?: InputMaybe<UuidComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  view?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "job_lifecycle_views" */
export type JobLifecycleViewsConstraint =
  /** unique or primary key constraint on columns "title", "company_guid" */
  | 'job_lifecycle_views_company_guid_title_key'
  /** unique or primary key constraint on columns "job_lifecycle_view_guid" */
  | 'job_lifecycle_views_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type JobLifecycleViewsDeleteAtPathInput = {
  view?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type JobLifecycleViewsDeleteElemInput = {
  view?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type JobLifecycleViewsDeleteKeyInput = {
  view?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "job_lifecycle_views" */
export type JobLifecycleViewsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobLifecycleViewGuid?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  view?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type JobLifecycleViewsMaxFields = {
  __typename?: 'JobLifecycleViewsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobLifecycleViewGuid?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type JobLifecycleViewsMinFields = {
  __typename?: 'JobLifecycleViewsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobLifecycleViewGuid?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "job_lifecycle_views" */
export type JobLifecycleViewsMutationResponse = {
  __typename?: 'JobLifecycleViewsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobLifecycleViews>;
};

/** on_conflict condition type for table "job_lifecycle_views" */
export type JobLifecycleViewsOnConflict = {
  constraint: JobLifecycleViewsConstraint;
  updateColumns?: Array<JobLifecycleViewsUpdateColumn>;
  where?: InputMaybe<JobLifecycleViewsBoolExp>;
};

/** Ordering options when selecting data from "job_lifecycle_views". */
export type JobLifecycleViewsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobLifecycleViewGuid?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  view?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_lifecycle_views */
export type JobLifecycleViewsPkColumnsInput = {
  jobLifecycleViewGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type JobLifecycleViewsPrependInput = {
  view?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "job_lifecycle_views" */
export type JobLifecycleViewsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobLifecycleViewGuid'
  /** column name */
  | 'title'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'view';

/** input type for updating data in table "job_lifecycle_views" */
export type JobLifecycleViewsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobLifecycleViewGuid?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  view?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "job_lifecycle_views" */
export type JobLifecycleViewsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobLifecycleViewsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobLifecycleViewsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobLifecycleViewGuid?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  view?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "job_lifecycle_views" */
export type JobLifecycleViewsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobLifecycleViewGuid'
  /** column name */
  | 'title'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'view';

export type JobLifecycleViewsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<JobLifecycleViewsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<JobLifecycleViewsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<JobLifecycleViewsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<JobLifecycleViewsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<JobLifecycleViewsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobLifecycleViewsSetInput>;
  /** filter the rows which have to be updated */
  where: JobLifecycleViewsBoolExp;
};

/** columns and relationships of "job_lifecycles" */
export type JobLifecycles = {
  __typename?: 'JobLifecycles';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  description: Scalars['String'];
  isArchived: Scalars['Boolean'];
  jobLifecycleGuid: Scalars['uuid'];
  /** An array relationship */
  jobLifecycleStatuses: Array<JobLifecycleStatuses>;
  /** An aggregate relationship */
  jobLifecycleStatusesAggregate: JobLifecycleStatusesAggregate;
  jobLifecycleType: Scalars['String'];
  lastModifiedBy: Scalars['String'];
  name: Scalars['String'];
  sequence: Array<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "job_lifecycles" */
export type JobLifecyclesJobLifecycleStatusesArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleStatusesOrderBy>>;
  where?: InputMaybe<JobLifecycleStatusesBoolExp>;
};


/** columns and relationships of "job_lifecycles" */
export type JobLifecyclesJobLifecycleStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleStatusesOrderBy>>;
  where?: InputMaybe<JobLifecycleStatusesBoolExp>;
};

/** aggregated selection of "job_lifecycles" */
export type JobLifecyclesAggregate = {
  __typename?: 'JobLifecyclesAggregate';
  aggregate?: Maybe<JobLifecyclesAggregateFields>;
  nodes: Array<JobLifecycles>;
};

/** aggregate fields of "job_lifecycles" */
export type JobLifecyclesAggregateFields = {
  __typename?: 'JobLifecyclesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobLifecyclesMaxFields>;
  min?: Maybe<JobLifecyclesMinFields>;
};


/** aggregate fields of "job_lifecycles" */
export type JobLifecyclesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobLifecyclesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "job_lifecycles". All fields are combined with a logical 'AND'. */
export type JobLifecyclesBoolExp = {
  _and?: InputMaybe<Array<JobLifecyclesBoolExp>>;
  _not?: InputMaybe<JobLifecyclesBoolExp>;
  _or?: InputMaybe<Array<JobLifecyclesBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  jobLifecycleGuid?: InputMaybe<UuidComparisonExp>;
  jobLifecycleStatuses?: InputMaybe<JobLifecycleStatusesBoolExp>;
  jobLifecycleStatusesAggregate?: InputMaybe<JobLifecycleStatusesAggregateBoolExp>;
  jobLifecycleType?: InputMaybe<StringComparisonExp>;
  lastModifiedBy?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  sequence?: InputMaybe<StringArrayComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_lifecycles" */
export type JobLifecyclesConstraint =
  /** unique or primary key constraint on columns "company_guid", "name" */
  | 'job_lifecycle_company_guid_name_key'
  /** unique or primary key constraint on columns "job_lifecycle_guid" */
  | 'job_lifecycle_pkey';

/** input type for inserting data into table "job_lifecycles" */
export type JobLifecyclesInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jobLifecycleGuid?: InputMaybe<Scalars['uuid']>;
  jobLifecycleStatuses?: InputMaybe<JobLifecycleStatusesArrRelInsertInput>;
  jobLifecycleType?: InputMaybe<Scalars['String']>;
  lastModifiedBy?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobLifecyclesMaxFields = {
  __typename?: 'JobLifecyclesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  jobLifecycleGuid?: Maybe<Scalars['uuid']>;
  jobLifecycleType?: Maybe<Scalars['String']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type JobLifecyclesMinFields = {
  __typename?: 'JobLifecyclesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  jobLifecycleGuid?: Maybe<Scalars['uuid']>;
  jobLifecycleType?: Maybe<Scalars['String']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sequence?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "job_lifecycles" */
export type JobLifecyclesMutationResponse = {
  __typename?: 'JobLifecyclesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobLifecycles>;
};

/** input type for inserting object relation for remote table "job_lifecycles" */
export type JobLifecyclesObjRelInsertInput = {
  data: JobLifecyclesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobLifecyclesOnConflict>;
};

/** on_conflict condition type for table "job_lifecycles" */
export type JobLifecyclesOnConflict = {
  constraint: JobLifecyclesConstraint;
  updateColumns?: Array<JobLifecyclesUpdateColumn>;
  where?: InputMaybe<JobLifecyclesBoolExp>;
};

/** Ordering options when selecting data from "job_lifecycles". */
export type JobLifecyclesOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  jobLifecycleGuid?: InputMaybe<OrderBy>;
  jobLifecycleStatusesAggregate?: InputMaybe<JobLifecycleStatusesAggregateOrderBy>;
  jobLifecycleType?: InputMaybe<OrderBy>;
  lastModifiedBy?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  sequence?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_lifecycles */
export type JobLifecyclesPkColumnsInput = {
  jobLifecycleGuid: Scalars['uuid'];
};

/** select columns of table "job_lifecycles" */
export type JobLifecyclesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'isArchived'
  /** column name */
  | 'jobLifecycleGuid'
  /** column name */
  | 'jobLifecycleType'
  /** column name */
  | 'lastModifiedBy'
  /** column name */
  | 'name'
  /** column name */
  | 'sequence'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "job_lifecycles" */
export type JobLifecyclesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jobLifecycleGuid?: InputMaybe<Scalars['uuid']>;
  jobLifecycleType?: InputMaybe<Scalars['String']>;
  lastModifiedBy?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "job_lifecycles" */
export type JobLifecyclesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobLifecyclesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobLifecyclesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jobLifecycleGuid?: InputMaybe<Scalars['uuid']>;
  jobLifecycleType?: InputMaybe<Scalars['String']>;
  lastModifiedBy?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "job_lifecycles" */
export type JobLifecyclesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'isArchived'
  /** column name */
  | 'jobLifecycleGuid'
  /** column name */
  | 'jobLifecycleType'
  /** column name */
  | 'lastModifiedBy'
  /** column name */
  | 'name'
  /** column name */
  | 'sequence'
  /** column name */
  | 'updatedAt';

export type JobLifecyclesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobLifecyclesSetInput>;
  /** filter the rows which have to be updated */
  where: JobLifecyclesBoolExp;
};

/** Company Settings for Job Requests */
export type JobRequestsCompanyConfig = {
  __typename?: 'JobRequestsCompanyConfig';
  companyGuid: Scalars['uuid'];
  emergencyRequestsMessageHtml?: Maybe<Scalars['HtmlString']>;
};

/** aggregated selection of "job_requests_company_config" */
export type JobRequestsCompanyConfigAggregate = {
  __typename?: 'JobRequestsCompanyConfigAggregate';
  aggregate?: Maybe<JobRequestsCompanyConfigAggregateFields>;
  nodes: Array<JobRequestsCompanyConfig>;
};

/** aggregate fields of "job_requests_company_config" */
export type JobRequestsCompanyConfigAggregateFields = {
  __typename?: 'JobRequestsCompanyConfigAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobRequestsCompanyConfigMaxFields>;
  min?: Maybe<JobRequestsCompanyConfigMinFields>;
};


/** aggregate fields of "job_requests_company_config" */
export type JobRequestsCompanyConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobRequestsCompanyConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "job_requests_company_config". All fields are combined with a logical 'AND'. */
export type JobRequestsCompanyConfigBoolExp = {
  _and?: InputMaybe<Array<JobRequestsCompanyConfigBoolExp>>;
  _not?: InputMaybe<JobRequestsCompanyConfigBoolExp>;
  _or?: InputMaybe<Array<JobRequestsCompanyConfigBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  emergencyRequestsMessageHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
};

/** unique or primary key constraints on table "job_requests_company_config" */
export type JobRequestsCompanyConfigConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'job_requests_company_config_pkey';

/** input type for inserting data into table "job_requests_company_config" */
export type JobRequestsCompanyConfigInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  emergencyRequestsMessageHtml?: InputMaybe<Scalars['HtmlString']>;
};

/** aggregate max on columns */
export type JobRequestsCompanyConfigMaxFields = {
  __typename?: 'JobRequestsCompanyConfigMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  emergencyRequestsMessageHtml?: Maybe<Scalars['HtmlString']>;
};

/** aggregate min on columns */
export type JobRequestsCompanyConfigMinFields = {
  __typename?: 'JobRequestsCompanyConfigMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  emergencyRequestsMessageHtml?: Maybe<Scalars['HtmlString']>;
};

/** response of any mutation on the table "job_requests_company_config" */
export type JobRequestsCompanyConfigMutationResponse = {
  __typename?: 'JobRequestsCompanyConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobRequestsCompanyConfig>;
};

/** on_conflict condition type for table "job_requests_company_config" */
export type JobRequestsCompanyConfigOnConflict = {
  constraint: JobRequestsCompanyConfigConstraint;
  updateColumns?: Array<JobRequestsCompanyConfigUpdateColumn>;
  where?: InputMaybe<JobRequestsCompanyConfigBoolExp>;
};

/** Ordering options when selecting data from "job_requests_company_config". */
export type JobRequestsCompanyConfigOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  emergencyRequestsMessageHtml?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_requests_company_config */
export type JobRequestsCompanyConfigPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "job_requests_company_config" */
export type JobRequestsCompanyConfigSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'emergencyRequestsMessageHtml';

/** input type for updating data in table "job_requests_company_config" */
export type JobRequestsCompanyConfigSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  emergencyRequestsMessageHtml?: InputMaybe<Scalars['HtmlString']>;
};

/** Streaming cursor of the table "job_requests_company_config" */
export type JobRequestsCompanyConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobRequestsCompanyConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobRequestsCompanyConfigStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  emergencyRequestsMessageHtml?: InputMaybe<Scalars['HtmlString']>;
};

/** update columns of table "job_requests_company_config" */
export type JobRequestsCompanyConfigUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'emergencyRequestsMessageHtml';

export type JobRequestsCompanyConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobRequestsCompanyConfigSetInput>;
  /** filter the rows which have to be updated */
  where: JobRequestsCompanyConfigBoolExp;
};

/** The tags associated for a specific job */
export type JobTags = {
  __typename?: 'JobTags';
  addedAt: Scalars['timestamptz'];
  addedByUserGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  job: Jobs;
  jobGuid: Scalars['uuid'];
  /** An object relationship */
  tag: Tags;
  tagGuid: Scalars['uuid'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** aggregated selection of "job_tags" */
export type JobTagsAggregate = {
  __typename?: 'JobTagsAggregate';
  aggregate?: Maybe<JobTagsAggregateFields>;
  nodes: Array<JobTags>;
};

export type JobTagsAggregateBoolExp = {
  count?: InputMaybe<JobTagsAggregateBoolExpCount>;
};

/** aggregate fields of "job_tags" */
export type JobTagsAggregateFields = {
  __typename?: 'JobTagsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobTagsMaxFields>;
  min?: Maybe<JobTagsMinFields>;
};


/** aggregate fields of "job_tags" */
export type JobTagsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobTagsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_tags" */
export type JobTagsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobTagsMaxOrderBy>;
  min?: InputMaybe<JobTagsMinOrderBy>;
};

/** input type for inserting array relation for remote table "job_tags" */
export type JobTagsArrRelInsertInput = {
  data: Array<JobTagsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobTagsOnConflict>;
};

/** Boolean expression to filter rows from the table "job_tags". All fields are combined with a logical 'AND'. */
export type JobTagsBoolExp = {
  _and?: InputMaybe<Array<JobTagsBoolExp>>;
  _not?: InputMaybe<JobTagsBoolExp>;
  _or?: InputMaybe<Array<JobTagsBoolExp>>;
  addedAt?: InputMaybe<TimestamptzComparisonExp>;
  addedByUserGuid?: InputMaybe<UuidComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagGuid?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "job_tags" */
export type JobTagsConstraint =
  /** unique or primary key constraint on columns "tag_guid", "job_guid" */
  | 'job_tags_pkey';

/** input type for inserting data into table "job_tags" */
export type JobTagsInsertInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByUserGuid?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  tag?: InputMaybe<TagsObjRelInsertInput>;
  tagGuid?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type JobTagsMaxFields = {
  __typename?: 'JobTagsMaxFields';
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByUserGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  tagGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "job_tags" */
export type JobTagsMaxOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  addedByUserGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  tagGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobTagsMinFields = {
  __typename?: 'JobTagsMinFields';
  addedAt?: Maybe<Scalars['timestamptz']>;
  addedByUserGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  tagGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "job_tags" */
export type JobTagsMinOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  addedByUserGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  tagGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "job_tags" */
export type JobTagsMutationResponse = {
  __typename?: 'JobTagsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobTags>;
};

/** on_conflict condition type for table "job_tags" */
export type JobTagsOnConflict = {
  constraint: JobTagsConstraint;
  updateColumns?: Array<JobTagsUpdateColumn>;
  where?: InputMaybe<JobTagsBoolExp>;
};

/** Ordering options when selecting data from "job_tags". */
export type JobTagsOrderBy = {
  addedAt?: InputMaybe<OrderBy>;
  addedByUserGuid?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  tag?: InputMaybe<TagsOrderBy>;
  tagGuid?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: job_tags */
export type JobTagsPkColumnsInput = {
  jobGuid: Scalars['uuid'];
  tagGuid: Scalars['uuid'];
};

/** select columns of table "job_tags" */
export type JobTagsSelectColumn =
  /** column name */
  | 'addedAt'
  /** column name */
  | 'addedByUserGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'tagGuid';

/** input type for updating data in table "job_tags" */
export type JobTagsSetInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  tagGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "job_tags" */
export type JobTagsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobTagsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobTagsStreamCursorValueInput = {
  addedAt?: InputMaybe<Scalars['timestamptz']>;
  addedByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  tagGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "job_tags" */
export type JobTagsUpdateColumn =
  /** column name */
  | 'addedAt'
  /** column name */
  | 'addedByUserGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'tagGuid';

export type JobTagsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobTagsSetInput>;
  /** filter the rows which have to be updated */
  where: JobTagsBoolExp;
};

/** Stores data about all company employees that participate in a job */
export type JobTeamMembers = {
  __typename?: 'JobTeamMembers';
  bonusUsc?: Maybe<Scalars['Int']>;
  commissionRate?: Maybe<Scalars['numeric']>;
  companyGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  /** Designates whether this user turned over the associated job. This value can be null to represent an "unknown" state (i.e. we don't know if they turned over the job) */
  turnedOverJob?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  user: Users;
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "job_team_members" */
export type JobTeamMembersAggregate = {
  __typename?: 'JobTeamMembersAggregate';
  aggregate?: Maybe<JobTeamMembersAggregateFields>;
  nodes: Array<JobTeamMembers>;
};

export type JobTeamMembersAggregateBoolExp = {
  bool_and?: InputMaybe<JobTeamMembersAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<JobTeamMembersAggregateBoolExpBool_Or>;
  count?: InputMaybe<JobTeamMembersAggregateBoolExpCount>;
};

/** aggregate fields of "job_team_members" */
export type JobTeamMembersAggregateFields = {
  __typename?: 'JobTeamMembersAggregateFields';
  avg?: Maybe<JobTeamMembersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobTeamMembersMaxFields>;
  min?: Maybe<JobTeamMembersMinFields>;
  stddev?: Maybe<JobTeamMembersStddevFields>;
  stddevPop?: Maybe<JobTeamMembersStddevPopFields>;
  stddevSamp?: Maybe<JobTeamMembersStddevSampFields>;
  sum?: Maybe<JobTeamMembersSumFields>;
  varPop?: Maybe<JobTeamMembersVarPopFields>;
  varSamp?: Maybe<JobTeamMembersVarSampFields>;
  variance?: Maybe<JobTeamMembersVarianceFields>;
};


/** aggregate fields of "job_team_members" */
export type JobTeamMembersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobTeamMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_team_members" */
export type JobTeamMembersAggregateOrderBy = {
  avg?: InputMaybe<JobTeamMembersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobTeamMembersMaxOrderBy>;
  min?: InputMaybe<JobTeamMembersMinOrderBy>;
  stddev?: InputMaybe<JobTeamMembersStddevOrderBy>;
  stddevPop?: InputMaybe<JobTeamMembersStddevPopOrderBy>;
  stddevSamp?: InputMaybe<JobTeamMembersStddevSampOrderBy>;
  sum?: InputMaybe<JobTeamMembersSumOrderBy>;
  varPop?: InputMaybe<JobTeamMembersVarPopOrderBy>;
  varSamp?: InputMaybe<JobTeamMembersVarSampOrderBy>;
  variance?: InputMaybe<JobTeamMembersVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "job_team_members" */
export type JobTeamMembersArrRelInsertInput = {
  data: Array<JobTeamMembersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobTeamMembersOnConflict>;
};

/** aggregate avg on columns */
export type JobTeamMembersAvgFields = {
  __typename?: 'JobTeamMembersAvgFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_team_members" */
export type JobTeamMembersAvgOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "job_team_members". All fields are combined with a logical 'AND'. */
export type JobTeamMembersBoolExp = {
  _and?: InputMaybe<Array<JobTeamMembersBoolExp>>;
  _not?: InputMaybe<JobTeamMembersBoolExp>;
  _or?: InputMaybe<Array<JobTeamMembersBoolExp>>;
  bonusUsc?: InputMaybe<IntComparisonExp>;
  commissionRate?: InputMaybe<NumericComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  turnedOverJob?: InputMaybe<BooleanComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "job_team_members" */
export type JobTeamMembersConstraint =
  /** unique or primary key constraint on columns "job_guid", "user_guid" */
  | 'job_team_members_pkey';

/** input type for incrementing numeric columns in table "job_team_members" */
export type JobTeamMembersIncInput = {
  bonusUsc?: InputMaybe<Scalars['Int']>;
  commissionRate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "job_team_members" */
export type JobTeamMembersInsertInput = {
  bonusUsc?: InputMaybe<Scalars['Int']>;
  commissionRate?: InputMaybe<Scalars['numeric']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  /** Designates whether this user turned over the associated job. This value can be null to represent an "unknown" state (i.e. we don't know if they turned over the job) */
  turnedOverJob?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type JobTeamMembersMaxFields = {
  __typename?: 'JobTeamMembersMaxFields';
  bonusUsc?: Maybe<Scalars['Int']>;
  commissionRate?: Maybe<Scalars['numeric']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "job_team_members" */
export type JobTeamMembersMaxOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobTeamMembersMinFields = {
  __typename?: 'JobTeamMembersMinFields';
  bonusUsc?: Maybe<Scalars['Int']>;
  commissionRate?: Maybe<Scalars['numeric']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "job_team_members" */
export type JobTeamMembersMinOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "job_team_members" */
export type JobTeamMembersMutationResponse = {
  __typename?: 'JobTeamMembersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobTeamMembers>;
};

/** on_conflict condition type for table "job_team_members" */
export type JobTeamMembersOnConflict = {
  constraint: JobTeamMembersConstraint;
  updateColumns?: Array<JobTeamMembersUpdateColumn>;
  where?: InputMaybe<JobTeamMembersBoolExp>;
};

/** Ordering options when selecting data from "job_team_members". */
export type JobTeamMembersOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  turnedOverJob?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_team_members */
export type JobTeamMembersPkColumnsInput = {
  jobGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};

/** select columns of table "job_team_members" */
export type JobTeamMembersSelectColumn =
  /** column name */
  | 'bonusUsc'
  /** column name */
  | 'commissionRate'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'turnedOverJob'
  /** column name */
  | 'userGuid';

/** select "jobTeamMembersAggregateBoolExpBool_andArgumentsColumns" columns of table "job_team_members" */
export type JobTeamMembersSelectColumnJobTeamMembersAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'turnedOverJob';

/** select "jobTeamMembersAggregateBoolExpBool_orArgumentsColumns" columns of table "job_team_members" */
export type JobTeamMembersSelectColumnJobTeamMembersAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'turnedOverJob';

/** input type for updating data in table "job_team_members" */
export type JobTeamMembersSetInput = {
  bonusUsc?: InputMaybe<Scalars['Int']>;
  commissionRate?: InputMaybe<Scalars['numeric']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  /** Designates whether this user turned over the associated job. This value can be null to represent an "unknown" state (i.e. we don't know if they turned over the job) */
  turnedOverJob?: InputMaybe<Scalars['Boolean']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type JobTeamMembersStddevFields = {
  __typename?: 'JobTeamMembersStddevFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_team_members" */
export type JobTeamMembersStddevOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type JobTeamMembersStddevPopFields = {
  __typename?: 'JobTeamMembersStddevPopFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "job_team_members" */
export type JobTeamMembersStddevPopOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type JobTeamMembersStddevSampFields = {
  __typename?: 'JobTeamMembersStddevSampFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "job_team_members" */
export type JobTeamMembersStddevSampOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "job_team_members" */
export type JobTeamMembersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobTeamMembersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobTeamMembersStreamCursorValueInput = {
  bonusUsc?: InputMaybe<Scalars['Int']>;
  commissionRate?: InputMaybe<Scalars['numeric']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  /** Designates whether this user turned over the associated job. This value can be null to represent an "unknown" state (i.e. we don't know if they turned over the job) */
  turnedOverJob?: InputMaybe<Scalars['Boolean']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type JobTeamMembersSumFields = {
  __typename?: 'JobTeamMembersSumFields';
  bonusUsc?: Maybe<Scalars['Int']>;
  commissionRate?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "job_team_members" */
export type JobTeamMembersSumOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
};

/** update columns of table "job_team_members" */
export type JobTeamMembersUpdateColumn =
  /** column name */
  | 'bonusUsc'
  /** column name */
  | 'commissionRate'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'turnedOverJob'
  /** column name */
  | 'userGuid';

export type JobTeamMembersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<JobTeamMembersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobTeamMembersSetInput>;
  /** filter the rows which have to be updated */
  where: JobTeamMembersBoolExp;
};

/** aggregate varPop on columns */
export type JobTeamMembersVarPopFields = {
  __typename?: 'JobTeamMembersVarPopFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "job_team_members" */
export type JobTeamMembersVarPopOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type JobTeamMembersVarSampFields = {
  __typename?: 'JobTeamMembersVarSampFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "job_team_members" */
export type JobTeamMembersVarSampOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JobTeamMembersVarianceFields = {
  __typename?: 'JobTeamMembersVarianceFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_team_members" */
export type JobTeamMembersVarianceOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
};

/** Tracks how much Earned Revenue should be attributed to users. Each row represents attribution for a single line item to a single user. While this is meant to record data for technicians, it is possible to record revenue attributions for non-technicians as well, so this table is slightly mis-named. */
export type JobTechnicianEarnedRevenueAttributions = {
  __typename?: 'JobTechnicianEarnedRevenueAttributions';
  companyGuid: Scalars['uuid'];
  invoiceGuid: Scalars['uuid'];
  itemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  revenueUsc: Scalars['Int'];
  technicianUserGuid: Scalars['uuid'];
};

/** aggregated selection of "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsAggregate = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsAggregate';
  aggregate?: Maybe<JobTechnicianEarnedRevenueAttributionsAggregateFields>;
  nodes: Array<JobTechnicianEarnedRevenueAttributions>;
};

export type JobTechnicianEarnedRevenueAttributionsAggregateBoolExp = {
  count?: InputMaybe<JobTechnicianEarnedRevenueAttributionsAggregateBoolExpCount>;
};

/** aggregate fields of "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsAggregateFields = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsAggregateFields';
  avg?: Maybe<JobTechnicianEarnedRevenueAttributionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobTechnicianEarnedRevenueAttributionsMaxFields>;
  min?: Maybe<JobTechnicianEarnedRevenueAttributionsMinFields>;
  stddev?: Maybe<JobTechnicianEarnedRevenueAttributionsStddevFields>;
  stddevPop?: Maybe<JobTechnicianEarnedRevenueAttributionsStddevPopFields>;
  stddevSamp?: Maybe<JobTechnicianEarnedRevenueAttributionsStddevSampFields>;
  sum?: Maybe<JobTechnicianEarnedRevenueAttributionsSumFields>;
  varPop?: Maybe<JobTechnicianEarnedRevenueAttributionsVarPopFields>;
  varSamp?: Maybe<JobTechnicianEarnedRevenueAttributionsVarSampFields>;
  variance?: Maybe<JobTechnicianEarnedRevenueAttributionsVarianceFields>;
};


/** aggregate fields of "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsAggregateOrderBy = {
  avg?: InputMaybe<JobTechnicianEarnedRevenueAttributionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobTechnicianEarnedRevenueAttributionsMaxOrderBy>;
  min?: InputMaybe<JobTechnicianEarnedRevenueAttributionsMinOrderBy>;
  stddev?: InputMaybe<JobTechnicianEarnedRevenueAttributionsStddevOrderBy>;
  stddevPop?: InputMaybe<JobTechnicianEarnedRevenueAttributionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<JobTechnicianEarnedRevenueAttributionsStddevSampOrderBy>;
  sum?: InputMaybe<JobTechnicianEarnedRevenueAttributionsSumOrderBy>;
  varPop?: InputMaybe<JobTechnicianEarnedRevenueAttributionsVarPopOrderBy>;
  varSamp?: InputMaybe<JobTechnicianEarnedRevenueAttributionsVarSampOrderBy>;
  variance?: InputMaybe<JobTechnicianEarnedRevenueAttributionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsArrRelInsertInput = {
  data: Array<JobTechnicianEarnedRevenueAttributionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobTechnicianEarnedRevenueAttributionsOnConflict>;
};

/** aggregate avg on columns */
export type JobTechnicianEarnedRevenueAttributionsAvgFields = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsAvgFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsAvgOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "job_technician_earned_revenue_attributions". All fields are combined with a logical 'AND'. */
export type JobTechnicianEarnedRevenueAttributionsBoolExp = {
  _and?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsBoolExp>>;
  _not?: InputMaybe<JobTechnicianEarnedRevenueAttributionsBoolExp>;
  _or?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  itemGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  revenueUsc?: InputMaybe<IntComparisonExp>;
  technicianUserGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsConstraint =
  /** unique or primary key constraint on columns "item_guid", "job_guid", "invoice_guid", "technician_user_guid" */
  | 'job_technician_earned_revenue_attributions_pkey';

/** input type for incrementing numeric columns in table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsIncInput = {
  revenueUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  itemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  revenueUsc?: InputMaybe<Scalars['Int']>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type JobTechnicianEarnedRevenueAttributionsMaxFields = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  itemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  revenueUsc?: Maybe<Scalars['Int']>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  itemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  revenueUsc?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobTechnicianEarnedRevenueAttributionsMinFields = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  itemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  revenueUsc?: Maybe<Scalars['Int']>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  itemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  revenueUsc?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsMutationResponse = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobTechnicianEarnedRevenueAttributions>;
};

/** on_conflict condition type for table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsOnConflict = {
  constraint: JobTechnicianEarnedRevenueAttributionsConstraint;
  updateColumns?: Array<JobTechnicianEarnedRevenueAttributionsUpdateColumn>;
  where?: InputMaybe<JobTechnicianEarnedRevenueAttributionsBoolExp>;
};

/** Ordering options when selecting data from "job_technician_earned_revenue_attributions". */
export type JobTechnicianEarnedRevenueAttributionsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  itemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  revenueUsc?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_technician_earned_revenue_attributions */
export type JobTechnicianEarnedRevenueAttributionsPkColumnsInput = {
  invoiceGuid: Scalars['uuid'];
  itemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  technicianUserGuid: Scalars['uuid'];
};

/** select columns of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'itemGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'revenueUsc'
  /** column name */
  | 'technicianUserGuid';

/** input type for updating data in table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  itemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  revenueUsc?: InputMaybe<Scalars['Int']>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type JobTechnicianEarnedRevenueAttributionsStddevFields = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsStddevFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsStddevOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type JobTechnicianEarnedRevenueAttributionsStddevPopFields = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsStddevPopFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsStddevPopOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type JobTechnicianEarnedRevenueAttributionsStddevSampFields = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsStddevSampFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsStddevSampOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobTechnicianEarnedRevenueAttributionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobTechnicianEarnedRevenueAttributionsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  itemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  revenueUsc?: InputMaybe<Scalars['Int']>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type JobTechnicianEarnedRevenueAttributionsSumFields = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsSumFields';
  revenueUsc?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsSumOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** update columns of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'itemGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'revenueUsc'
  /** column name */
  | 'technicianUserGuid';

export type JobTechnicianEarnedRevenueAttributionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<JobTechnicianEarnedRevenueAttributionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobTechnicianEarnedRevenueAttributionsSetInput>;
  /** filter the rows which have to be updated */
  where: JobTechnicianEarnedRevenueAttributionsBoolExp;
};

/** aggregate varPop on columns */
export type JobTechnicianEarnedRevenueAttributionsVarPopFields = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsVarPopFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsVarPopOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type JobTechnicianEarnedRevenueAttributionsVarSampFields = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsVarSampFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsVarSampOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JobTechnicianEarnedRevenueAttributionsVarianceFields = {
  __typename?: 'JobTechnicianEarnedRevenueAttributionsVarianceFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_technician_earned_revenue_attributions" */
export type JobTechnicianEarnedRevenueAttributionsVarianceOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** columns and relationships of "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummaries = {
  __typename?: 'JobTechnicianEarnedRevenueSummaries';
  companyGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  technician?: Maybe<Users>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
  totalEarnedRevenueUsc?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesAggregate = {
  __typename?: 'JobTechnicianEarnedRevenueSummariesAggregate';
  aggregate?: Maybe<JobTechnicianEarnedRevenueSummariesAggregateFields>;
  nodes: Array<JobTechnicianEarnedRevenueSummaries>;
};

export type JobTechnicianEarnedRevenueSummariesAggregateBoolExp = {
  count?: InputMaybe<JobTechnicianEarnedRevenueSummariesAggregateBoolExpCount>;
};

/** aggregate fields of "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesAggregateFields = {
  __typename?: 'JobTechnicianEarnedRevenueSummariesAggregateFields';
  avg?: Maybe<JobTechnicianEarnedRevenueSummariesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobTechnicianEarnedRevenueSummariesMaxFields>;
  min?: Maybe<JobTechnicianEarnedRevenueSummariesMinFields>;
  stddev?: Maybe<JobTechnicianEarnedRevenueSummariesStddevFields>;
  stddevPop?: Maybe<JobTechnicianEarnedRevenueSummariesStddevPopFields>;
  stddevSamp?: Maybe<JobTechnicianEarnedRevenueSummariesStddevSampFields>;
  sum?: Maybe<JobTechnicianEarnedRevenueSummariesSumFields>;
  varPop?: Maybe<JobTechnicianEarnedRevenueSummariesVarPopFields>;
  varSamp?: Maybe<JobTechnicianEarnedRevenueSummariesVarSampFields>;
  variance?: Maybe<JobTechnicianEarnedRevenueSummariesVarianceFields>;
};


/** aggregate fields of "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesAggregateOrderBy = {
  avg?: InputMaybe<JobTechnicianEarnedRevenueSummariesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobTechnicianEarnedRevenueSummariesMaxOrderBy>;
  min?: InputMaybe<JobTechnicianEarnedRevenueSummariesMinOrderBy>;
  stddev?: InputMaybe<JobTechnicianEarnedRevenueSummariesStddevOrderBy>;
  stddevPop?: InputMaybe<JobTechnicianEarnedRevenueSummariesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<JobTechnicianEarnedRevenueSummariesStddevSampOrderBy>;
  sum?: InputMaybe<JobTechnicianEarnedRevenueSummariesSumOrderBy>;
  varPop?: InputMaybe<JobTechnicianEarnedRevenueSummariesVarPopOrderBy>;
  varSamp?: InputMaybe<JobTechnicianEarnedRevenueSummariesVarSampOrderBy>;
  variance?: InputMaybe<JobTechnicianEarnedRevenueSummariesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesArrRelInsertInput = {
  data: Array<JobTechnicianEarnedRevenueSummariesInsertInput>;
};

/** aggregate avg on columns */
export type JobTechnicianEarnedRevenueSummariesAvgFields = {
  __typename?: 'JobTechnicianEarnedRevenueSummariesAvgFields';
  totalEarnedRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesAvgOrderBy = {
  totalEarnedRevenueUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "job_technician_earned_revenue_summaries". All fields are combined with a logical 'AND'. */
export type JobTechnicianEarnedRevenueSummariesBoolExp = {
  _and?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesBoolExp>>;
  _not?: InputMaybe<JobTechnicianEarnedRevenueSummariesBoolExp>;
  _or?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  technician?: InputMaybe<UsersBoolExp>;
  technicianUserGuid?: InputMaybe<UuidComparisonExp>;
  totalEarnedRevenueUsc?: InputMaybe<BigintComparisonExp>;
};

/** input type for inserting data into table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  technician?: InputMaybe<UsersObjRelInsertInput>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
  totalEarnedRevenueUsc?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type JobTechnicianEarnedRevenueSummariesMaxFields = {
  __typename?: 'JobTechnicianEarnedRevenueSummariesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
  totalEarnedRevenueUsc?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
  totalEarnedRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobTechnicianEarnedRevenueSummariesMinFields = {
  __typename?: 'JobTechnicianEarnedRevenueSummariesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
  totalEarnedRevenueUsc?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
  totalEarnedRevenueUsc?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "job_technician_earned_revenue_summaries". */
export type JobTechnicianEarnedRevenueSummariesOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  technician?: InputMaybe<UsersOrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
  totalEarnedRevenueUsc?: InputMaybe<OrderBy>;
};

/** select columns of table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'technicianUserGuid'
  /** column name */
  | 'totalEarnedRevenueUsc';

/** aggregate stddev on columns */
export type JobTechnicianEarnedRevenueSummariesStddevFields = {
  __typename?: 'JobTechnicianEarnedRevenueSummariesStddevFields';
  totalEarnedRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesStddevOrderBy = {
  totalEarnedRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type JobTechnicianEarnedRevenueSummariesStddevPopFields = {
  __typename?: 'JobTechnicianEarnedRevenueSummariesStddevPopFields';
  totalEarnedRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesStddevPopOrderBy = {
  totalEarnedRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type JobTechnicianEarnedRevenueSummariesStddevSampFields = {
  __typename?: 'JobTechnicianEarnedRevenueSummariesStddevSampFields';
  totalEarnedRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesStddevSampOrderBy = {
  totalEarnedRevenueUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobTechnicianEarnedRevenueSummariesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobTechnicianEarnedRevenueSummariesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
  totalEarnedRevenueUsc?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JobTechnicianEarnedRevenueSummariesSumFields = {
  __typename?: 'JobTechnicianEarnedRevenueSummariesSumFields';
  totalEarnedRevenueUsc?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesSumOrderBy = {
  totalEarnedRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type JobTechnicianEarnedRevenueSummariesVarPopFields = {
  __typename?: 'JobTechnicianEarnedRevenueSummariesVarPopFields';
  totalEarnedRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesVarPopOrderBy = {
  totalEarnedRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type JobTechnicianEarnedRevenueSummariesVarSampFields = {
  __typename?: 'JobTechnicianEarnedRevenueSummariesVarSampFields';
  totalEarnedRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesVarSampOrderBy = {
  totalEarnedRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JobTechnicianEarnedRevenueSummariesVarianceFields = {
  __typename?: 'JobTechnicianEarnedRevenueSummariesVarianceFields';
  totalEarnedRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_technician_earned_revenue_summaries" */
export type JobTechnicianEarnedRevenueSummariesVarianceOrderBy = {
  totalEarnedRevenueUsc?: InputMaybe<OrderBy>;
};

/** columns and relationships of "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonus = {
  __typename?: 'JobTechnicianSalesCommissionAndBonus';
  bonusUsc?: Maybe<Scalars['Int']>;
  commissionRate?: Maybe<Scalars['numeric']>;
  commissionUsc?: Maybe<Scalars['numeric']>;
  commissionableBaseUsc?: Maybe<Scalars['numeric']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  effectiveJobCostsDeductionRate?: Maybe<Scalars['numeric']>;
  effectiveJobCostsFlatDeductionUsc?: Maybe<Scalars['Int']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  technician?: Maybe<Users>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
  totalDeductionsUsc?: Maybe<Scalars['numeric']>;
  totalSoldRevenueUsc?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusAggregate = {
  __typename?: 'JobTechnicianSalesCommissionAndBonusAggregate';
  aggregate?: Maybe<JobTechnicianSalesCommissionAndBonusAggregateFields>;
  nodes: Array<JobTechnicianSalesCommissionAndBonus>;
};

export type JobTechnicianSalesCommissionAndBonusAggregateBoolExp = {
  count?: InputMaybe<JobTechnicianSalesCommissionAndBonusAggregateBoolExpCount>;
};

/** aggregate fields of "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusAggregateFields = {
  __typename?: 'JobTechnicianSalesCommissionAndBonusAggregateFields';
  avg?: Maybe<JobTechnicianSalesCommissionAndBonusAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobTechnicianSalesCommissionAndBonusMaxFields>;
  min?: Maybe<JobTechnicianSalesCommissionAndBonusMinFields>;
  stddev?: Maybe<JobTechnicianSalesCommissionAndBonusStddevFields>;
  stddevPop?: Maybe<JobTechnicianSalesCommissionAndBonusStddevPopFields>;
  stddevSamp?: Maybe<JobTechnicianSalesCommissionAndBonusStddevSampFields>;
  sum?: Maybe<JobTechnicianSalesCommissionAndBonusSumFields>;
  varPop?: Maybe<JobTechnicianSalesCommissionAndBonusVarPopFields>;
  varSamp?: Maybe<JobTechnicianSalesCommissionAndBonusVarSampFields>;
  variance?: Maybe<JobTechnicianSalesCommissionAndBonusVarianceFields>;
};


/** aggregate fields of "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusAggregateOrderBy = {
  avg?: InputMaybe<JobTechnicianSalesCommissionAndBonusAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobTechnicianSalesCommissionAndBonusMaxOrderBy>;
  min?: InputMaybe<JobTechnicianSalesCommissionAndBonusMinOrderBy>;
  stddev?: InputMaybe<JobTechnicianSalesCommissionAndBonusStddevOrderBy>;
  stddevPop?: InputMaybe<JobTechnicianSalesCommissionAndBonusStddevPopOrderBy>;
  stddevSamp?: InputMaybe<JobTechnicianSalesCommissionAndBonusStddevSampOrderBy>;
  sum?: InputMaybe<JobTechnicianSalesCommissionAndBonusSumOrderBy>;
  varPop?: InputMaybe<JobTechnicianSalesCommissionAndBonusVarPopOrderBy>;
  varSamp?: InputMaybe<JobTechnicianSalesCommissionAndBonusVarSampOrderBy>;
  variance?: InputMaybe<JobTechnicianSalesCommissionAndBonusVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusArrRelInsertInput = {
  data: Array<JobTechnicianSalesCommissionAndBonusInsertInput>;
};

/** aggregate avg on columns */
export type JobTechnicianSalesCommissionAndBonusAvgFields = {
  __typename?: 'JobTechnicianSalesCommissionAndBonusAvgFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
  commissionUsc?: Maybe<Scalars['Float']>;
  commissionableBaseUsc?: Maybe<Scalars['Float']>;
  effectiveJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  effectiveJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  totalDeductionsUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusAvgOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  commissionUsc?: InputMaybe<OrderBy>;
  commissionableBaseUsc?: InputMaybe<OrderBy>;
  effectiveJobCostsDeductionRate?: InputMaybe<OrderBy>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  totalDeductionsUsc?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "job_technician_sales_commission_and_bonus". All fields are combined with a logical 'AND'. */
export type JobTechnicianSalesCommissionAndBonusBoolExp = {
  _and?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusBoolExp>>;
  _not?: InputMaybe<JobTechnicianSalesCommissionAndBonusBoolExp>;
  _or?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusBoolExp>>;
  bonusUsc?: InputMaybe<IntComparisonExp>;
  commissionRate?: InputMaybe<NumericComparisonExp>;
  commissionUsc?: InputMaybe<NumericComparisonExp>;
  commissionableBaseUsc?: InputMaybe<NumericComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  effectiveJobCostsDeductionRate?: InputMaybe<NumericComparisonExp>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<IntComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  technician?: InputMaybe<UsersBoolExp>;
  technicianUserGuid?: InputMaybe<UuidComparisonExp>;
  totalDeductionsUsc?: InputMaybe<NumericComparisonExp>;
  totalSoldRevenueUsc?: InputMaybe<BigintComparisonExp>;
};

/** input type for inserting data into table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusInsertInput = {
  bonusUsc?: InputMaybe<Scalars['Int']>;
  commissionRate?: InputMaybe<Scalars['numeric']>;
  commissionUsc?: InputMaybe<Scalars['numeric']>;
  commissionableBaseUsc?: InputMaybe<Scalars['numeric']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  effectiveJobCostsDeductionRate?: InputMaybe<Scalars['numeric']>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  technician?: InputMaybe<UsersObjRelInsertInput>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
  totalDeductionsUsc?: InputMaybe<Scalars['numeric']>;
  totalSoldRevenueUsc?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type JobTechnicianSalesCommissionAndBonusMaxFields = {
  __typename?: 'JobTechnicianSalesCommissionAndBonusMaxFields';
  bonusUsc?: Maybe<Scalars['Int']>;
  commissionRate?: Maybe<Scalars['numeric']>;
  commissionUsc?: Maybe<Scalars['numeric']>;
  commissionableBaseUsc?: Maybe<Scalars['numeric']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  effectiveJobCostsDeductionRate?: Maybe<Scalars['numeric']>;
  effectiveJobCostsFlatDeductionUsc?: Maybe<Scalars['Int']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
  totalDeductionsUsc?: Maybe<Scalars['numeric']>;
  totalSoldRevenueUsc?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusMaxOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  commissionUsc?: InputMaybe<OrderBy>;
  commissionableBaseUsc?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  effectiveJobCostsDeductionRate?: InputMaybe<OrderBy>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
  totalDeductionsUsc?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobTechnicianSalesCommissionAndBonusMinFields = {
  __typename?: 'JobTechnicianSalesCommissionAndBonusMinFields';
  bonusUsc?: Maybe<Scalars['Int']>;
  commissionRate?: Maybe<Scalars['numeric']>;
  commissionUsc?: Maybe<Scalars['numeric']>;
  commissionableBaseUsc?: Maybe<Scalars['numeric']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  effectiveJobCostsDeductionRate?: Maybe<Scalars['numeric']>;
  effectiveJobCostsFlatDeductionUsc?: Maybe<Scalars['Int']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
  totalDeductionsUsc?: Maybe<Scalars['numeric']>;
  totalSoldRevenueUsc?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusMinOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  commissionUsc?: InputMaybe<OrderBy>;
  commissionableBaseUsc?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  effectiveJobCostsDeductionRate?: InputMaybe<OrderBy>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
  totalDeductionsUsc?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "job_technician_sales_commission_and_bonus". */
export type JobTechnicianSalesCommissionAndBonusOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  commissionUsc?: InputMaybe<OrderBy>;
  commissionableBaseUsc?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  effectiveJobCostsDeductionRate?: InputMaybe<OrderBy>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  technician?: InputMaybe<UsersOrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
  totalDeductionsUsc?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** select columns of table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusSelectColumn =
  /** column name */
  | 'bonusUsc'
  /** column name */
  | 'commissionRate'
  /** column name */
  | 'commissionUsc'
  /** column name */
  | 'commissionableBaseUsc'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'effectiveJobCostsDeductionRate'
  /** column name */
  | 'effectiveJobCostsFlatDeductionUsc'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'technicianUserGuid'
  /** column name */
  | 'totalDeductionsUsc'
  /** column name */
  | 'totalSoldRevenueUsc';

/** aggregate stddev on columns */
export type JobTechnicianSalesCommissionAndBonusStddevFields = {
  __typename?: 'JobTechnicianSalesCommissionAndBonusStddevFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
  commissionUsc?: Maybe<Scalars['Float']>;
  commissionableBaseUsc?: Maybe<Scalars['Float']>;
  effectiveJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  effectiveJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  totalDeductionsUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusStddevOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  commissionUsc?: InputMaybe<OrderBy>;
  commissionableBaseUsc?: InputMaybe<OrderBy>;
  effectiveJobCostsDeductionRate?: InputMaybe<OrderBy>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  totalDeductionsUsc?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type JobTechnicianSalesCommissionAndBonusStddevPopFields = {
  __typename?: 'JobTechnicianSalesCommissionAndBonusStddevPopFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
  commissionUsc?: Maybe<Scalars['Float']>;
  commissionableBaseUsc?: Maybe<Scalars['Float']>;
  effectiveJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  effectiveJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  totalDeductionsUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusStddevPopOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  commissionUsc?: InputMaybe<OrderBy>;
  commissionableBaseUsc?: InputMaybe<OrderBy>;
  effectiveJobCostsDeductionRate?: InputMaybe<OrderBy>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  totalDeductionsUsc?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type JobTechnicianSalesCommissionAndBonusStddevSampFields = {
  __typename?: 'JobTechnicianSalesCommissionAndBonusStddevSampFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
  commissionUsc?: Maybe<Scalars['Float']>;
  commissionableBaseUsc?: Maybe<Scalars['Float']>;
  effectiveJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  effectiveJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  totalDeductionsUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusStddevSampOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  commissionUsc?: InputMaybe<OrderBy>;
  commissionableBaseUsc?: InputMaybe<OrderBy>;
  effectiveJobCostsDeductionRate?: InputMaybe<OrderBy>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  totalDeductionsUsc?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobTechnicianSalesCommissionAndBonusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobTechnicianSalesCommissionAndBonusStreamCursorValueInput = {
  bonusUsc?: InputMaybe<Scalars['Int']>;
  commissionRate?: InputMaybe<Scalars['numeric']>;
  commissionUsc?: InputMaybe<Scalars['numeric']>;
  commissionableBaseUsc?: InputMaybe<Scalars['numeric']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  effectiveJobCostsDeductionRate?: InputMaybe<Scalars['numeric']>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
  totalDeductionsUsc?: InputMaybe<Scalars['numeric']>;
  totalSoldRevenueUsc?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JobTechnicianSalesCommissionAndBonusSumFields = {
  __typename?: 'JobTechnicianSalesCommissionAndBonusSumFields';
  bonusUsc?: Maybe<Scalars['Int']>;
  commissionRate?: Maybe<Scalars['numeric']>;
  commissionUsc?: Maybe<Scalars['numeric']>;
  commissionableBaseUsc?: Maybe<Scalars['numeric']>;
  effectiveJobCostsDeductionRate?: Maybe<Scalars['numeric']>;
  effectiveJobCostsFlatDeductionUsc?: Maybe<Scalars['Int']>;
  totalDeductionsUsc?: Maybe<Scalars['numeric']>;
  totalSoldRevenueUsc?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusSumOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  commissionUsc?: InputMaybe<OrderBy>;
  commissionableBaseUsc?: InputMaybe<OrderBy>;
  effectiveJobCostsDeductionRate?: InputMaybe<OrderBy>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  totalDeductionsUsc?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type JobTechnicianSalesCommissionAndBonusVarPopFields = {
  __typename?: 'JobTechnicianSalesCommissionAndBonusVarPopFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
  commissionUsc?: Maybe<Scalars['Float']>;
  commissionableBaseUsc?: Maybe<Scalars['Float']>;
  effectiveJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  effectiveJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  totalDeductionsUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusVarPopOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  commissionUsc?: InputMaybe<OrderBy>;
  commissionableBaseUsc?: InputMaybe<OrderBy>;
  effectiveJobCostsDeductionRate?: InputMaybe<OrderBy>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  totalDeductionsUsc?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type JobTechnicianSalesCommissionAndBonusVarSampFields = {
  __typename?: 'JobTechnicianSalesCommissionAndBonusVarSampFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
  commissionUsc?: Maybe<Scalars['Float']>;
  commissionableBaseUsc?: Maybe<Scalars['Float']>;
  effectiveJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  effectiveJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  totalDeductionsUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusVarSampOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  commissionUsc?: InputMaybe<OrderBy>;
  commissionableBaseUsc?: InputMaybe<OrderBy>;
  effectiveJobCostsDeductionRate?: InputMaybe<OrderBy>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  totalDeductionsUsc?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JobTechnicianSalesCommissionAndBonusVarianceFields = {
  __typename?: 'JobTechnicianSalesCommissionAndBonusVarianceFields';
  bonusUsc?: Maybe<Scalars['Float']>;
  commissionRate?: Maybe<Scalars['Float']>;
  commissionUsc?: Maybe<Scalars['Float']>;
  commissionableBaseUsc?: Maybe<Scalars['Float']>;
  effectiveJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  effectiveJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  totalDeductionsUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_technician_sales_commission_and_bonus" */
export type JobTechnicianSalesCommissionAndBonusVarianceOrderBy = {
  bonusUsc?: InputMaybe<OrderBy>;
  commissionRate?: InputMaybe<OrderBy>;
  commissionUsc?: InputMaybe<OrderBy>;
  commissionableBaseUsc?: InputMaybe<OrderBy>;
  effectiveJobCostsDeductionRate?: InputMaybe<OrderBy>;
  effectiveJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  totalDeductionsUsc?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** Tracks how much Sold Revenue should be attributed to users. Each row represents attribution for a single line item to a single user. While this is meant to record data for technicians, it is possible to record revenue attributions for non-technicians as well, so this table is slightly mis-named. */
export type JobTechnicianSoldRevenueAttributions = {
  __typename?: 'JobTechnicianSoldRevenueAttributions';
  companyGuid: Scalars['uuid'];
  invoiceGuid: Scalars['uuid'];
  itemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  revenueUsc: Scalars['Int'];
  technicianUserGuid: Scalars['uuid'];
};

/** aggregated selection of "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsAggregate = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsAggregate';
  aggregate?: Maybe<JobTechnicianSoldRevenueAttributionsAggregateFields>;
  nodes: Array<JobTechnicianSoldRevenueAttributions>;
};

export type JobTechnicianSoldRevenueAttributionsAggregateBoolExp = {
  count?: InputMaybe<JobTechnicianSoldRevenueAttributionsAggregateBoolExpCount>;
};

/** aggregate fields of "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsAggregateFields = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsAggregateFields';
  avg?: Maybe<JobTechnicianSoldRevenueAttributionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobTechnicianSoldRevenueAttributionsMaxFields>;
  min?: Maybe<JobTechnicianSoldRevenueAttributionsMinFields>;
  stddev?: Maybe<JobTechnicianSoldRevenueAttributionsStddevFields>;
  stddevPop?: Maybe<JobTechnicianSoldRevenueAttributionsStddevPopFields>;
  stddevSamp?: Maybe<JobTechnicianSoldRevenueAttributionsStddevSampFields>;
  sum?: Maybe<JobTechnicianSoldRevenueAttributionsSumFields>;
  varPop?: Maybe<JobTechnicianSoldRevenueAttributionsVarPopFields>;
  varSamp?: Maybe<JobTechnicianSoldRevenueAttributionsVarSampFields>;
  variance?: Maybe<JobTechnicianSoldRevenueAttributionsVarianceFields>;
};


/** aggregate fields of "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsAggregateOrderBy = {
  avg?: InputMaybe<JobTechnicianSoldRevenueAttributionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobTechnicianSoldRevenueAttributionsMaxOrderBy>;
  min?: InputMaybe<JobTechnicianSoldRevenueAttributionsMinOrderBy>;
  stddev?: InputMaybe<JobTechnicianSoldRevenueAttributionsStddevOrderBy>;
  stddevPop?: InputMaybe<JobTechnicianSoldRevenueAttributionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<JobTechnicianSoldRevenueAttributionsStddevSampOrderBy>;
  sum?: InputMaybe<JobTechnicianSoldRevenueAttributionsSumOrderBy>;
  varPop?: InputMaybe<JobTechnicianSoldRevenueAttributionsVarPopOrderBy>;
  varSamp?: InputMaybe<JobTechnicianSoldRevenueAttributionsVarSampOrderBy>;
  variance?: InputMaybe<JobTechnicianSoldRevenueAttributionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsArrRelInsertInput = {
  data: Array<JobTechnicianSoldRevenueAttributionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobTechnicianSoldRevenueAttributionsOnConflict>;
};

/** aggregate avg on columns */
export type JobTechnicianSoldRevenueAttributionsAvgFields = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsAvgFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsAvgOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "job_technician_sold_revenue_attributions". All fields are combined with a logical 'AND'. */
export type JobTechnicianSoldRevenueAttributionsBoolExp = {
  _and?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsBoolExp>>;
  _not?: InputMaybe<JobTechnicianSoldRevenueAttributionsBoolExp>;
  _or?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  itemGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  revenueUsc?: InputMaybe<IntComparisonExp>;
  technicianUserGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsConstraint =
  /** unique or primary key constraint on columns "item_guid", "job_guid", "invoice_guid", "technician_user_guid" */
  | 'job_technician_sold_revenue_attributions_pkey';

/** input type for incrementing numeric columns in table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsIncInput = {
  revenueUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  itemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  revenueUsc?: InputMaybe<Scalars['Int']>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type JobTechnicianSoldRevenueAttributionsMaxFields = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  itemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  revenueUsc?: Maybe<Scalars['Int']>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  itemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  revenueUsc?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobTechnicianSoldRevenueAttributionsMinFields = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  itemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  revenueUsc?: Maybe<Scalars['Int']>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  itemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  revenueUsc?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsMutationResponse = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobTechnicianSoldRevenueAttributions>;
};

/** on_conflict condition type for table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsOnConflict = {
  constraint: JobTechnicianSoldRevenueAttributionsConstraint;
  updateColumns?: Array<JobTechnicianSoldRevenueAttributionsUpdateColumn>;
  where?: InputMaybe<JobTechnicianSoldRevenueAttributionsBoolExp>;
};

/** Ordering options when selecting data from "job_technician_sold_revenue_attributions". */
export type JobTechnicianSoldRevenueAttributionsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  itemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  revenueUsc?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_technician_sold_revenue_attributions */
export type JobTechnicianSoldRevenueAttributionsPkColumnsInput = {
  invoiceGuid: Scalars['uuid'];
  itemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  technicianUserGuid: Scalars['uuid'];
};

/** select columns of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'itemGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'revenueUsc'
  /** column name */
  | 'technicianUserGuid';

/** input type for updating data in table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  itemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  revenueUsc?: InputMaybe<Scalars['Int']>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type JobTechnicianSoldRevenueAttributionsStddevFields = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsStddevFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsStddevOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type JobTechnicianSoldRevenueAttributionsStddevPopFields = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsStddevPopFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsStddevPopOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type JobTechnicianSoldRevenueAttributionsStddevSampFields = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsStddevSampFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsStddevSampOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobTechnicianSoldRevenueAttributionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobTechnicianSoldRevenueAttributionsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  itemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  revenueUsc?: InputMaybe<Scalars['Int']>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type JobTechnicianSoldRevenueAttributionsSumFields = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsSumFields';
  revenueUsc?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsSumOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** update columns of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'itemGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'revenueUsc'
  /** column name */
  | 'technicianUserGuid';

export type JobTechnicianSoldRevenueAttributionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<JobTechnicianSoldRevenueAttributionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobTechnicianSoldRevenueAttributionsSetInput>;
  /** filter the rows which have to be updated */
  where: JobTechnicianSoldRevenueAttributionsBoolExp;
};

/** aggregate varPop on columns */
export type JobTechnicianSoldRevenueAttributionsVarPopFields = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsVarPopFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsVarPopOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type JobTechnicianSoldRevenueAttributionsVarSampFields = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsVarSampFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsVarSampOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JobTechnicianSoldRevenueAttributionsVarianceFields = {
  __typename?: 'JobTechnicianSoldRevenueAttributionsVarianceFields';
  revenueUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_technician_sold_revenue_attributions" */
export type JobTechnicianSoldRevenueAttributionsVarianceOrderBy = {
  revenueUsc?: InputMaybe<OrderBy>;
};

/** columns and relationships of "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummaries = {
  __typename?: 'JobTechnicianSoldRevenueSummaries';
  companyGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  technician?: Maybe<Users>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
  totalSoldRevenueUsc?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesAggregate = {
  __typename?: 'JobTechnicianSoldRevenueSummariesAggregate';
  aggregate?: Maybe<JobTechnicianSoldRevenueSummariesAggregateFields>;
  nodes: Array<JobTechnicianSoldRevenueSummaries>;
};

export type JobTechnicianSoldRevenueSummariesAggregateBoolExp = {
  count?: InputMaybe<JobTechnicianSoldRevenueSummariesAggregateBoolExpCount>;
};

/** aggregate fields of "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesAggregateFields = {
  __typename?: 'JobTechnicianSoldRevenueSummariesAggregateFields';
  avg?: Maybe<JobTechnicianSoldRevenueSummariesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobTechnicianSoldRevenueSummariesMaxFields>;
  min?: Maybe<JobTechnicianSoldRevenueSummariesMinFields>;
  stddev?: Maybe<JobTechnicianSoldRevenueSummariesStddevFields>;
  stddevPop?: Maybe<JobTechnicianSoldRevenueSummariesStddevPopFields>;
  stddevSamp?: Maybe<JobTechnicianSoldRevenueSummariesStddevSampFields>;
  sum?: Maybe<JobTechnicianSoldRevenueSummariesSumFields>;
  varPop?: Maybe<JobTechnicianSoldRevenueSummariesVarPopFields>;
  varSamp?: Maybe<JobTechnicianSoldRevenueSummariesVarSampFields>;
  variance?: Maybe<JobTechnicianSoldRevenueSummariesVarianceFields>;
};


/** aggregate fields of "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesAggregateOrderBy = {
  avg?: InputMaybe<JobTechnicianSoldRevenueSummariesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobTechnicianSoldRevenueSummariesMaxOrderBy>;
  min?: InputMaybe<JobTechnicianSoldRevenueSummariesMinOrderBy>;
  stddev?: InputMaybe<JobTechnicianSoldRevenueSummariesStddevOrderBy>;
  stddevPop?: InputMaybe<JobTechnicianSoldRevenueSummariesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<JobTechnicianSoldRevenueSummariesStddevSampOrderBy>;
  sum?: InputMaybe<JobTechnicianSoldRevenueSummariesSumOrderBy>;
  varPop?: InputMaybe<JobTechnicianSoldRevenueSummariesVarPopOrderBy>;
  varSamp?: InputMaybe<JobTechnicianSoldRevenueSummariesVarSampOrderBy>;
  variance?: InputMaybe<JobTechnicianSoldRevenueSummariesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesArrRelInsertInput = {
  data: Array<JobTechnicianSoldRevenueSummariesInsertInput>;
};

/** aggregate avg on columns */
export type JobTechnicianSoldRevenueSummariesAvgFields = {
  __typename?: 'JobTechnicianSoldRevenueSummariesAvgFields';
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesAvgOrderBy = {
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "job_technician_sold_revenue_summaries". All fields are combined with a logical 'AND'. */
export type JobTechnicianSoldRevenueSummariesBoolExp = {
  _and?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesBoolExp>>;
  _not?: InputMaybe<JobTechnicianSoldRevenueSummariesBoolExp>;
  _or?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  technician?: InputMaybe<UsersBoolExp>;
  technicianUserGuid?: InputMaybe<UuidComparisonExp>;
  totalSoldRevenueUsc?: InputMaybe<BigintComparisonExp>;
};

/** input type for inserting data into table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  technician?: InputMaybe<UsersObjRelInsertInput>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
  totalSoldRevenueUsc?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type JobTechnicianSoldRevenueSummariesMaxFields = {
  __typename?: 'JobTechnicianSoldRevenueSummariesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
  totalSoldRevenueUsc?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobTechnicianSoldRevenueSummariesMinFields = {
  __typename?: 'JobTechnicianSoldRevenueSummariesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  technicianUserGuid?: Maybe<Scalars['uuid']>;
  totalSoldRevenueUsc?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "job_technician_sold_revenue_summaries". */
export type JobTechnicianSoldRevenueSummariesOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  technician?: InputMaybe<UsersOrderBy>;
  technicianUserGuid?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** select columns of table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'technicianUserGuid'
  /** column name */
  | 'totalSoldRevenueUsc';

/** aggregate stddev on columns */
export type JobTechnicianSoldRevenueSummariesStddevFields = {
  __typename?: 'JobTechnicianSoldRevenueSummariesStddevFields';
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesStddevOrderBy = {
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type JobTechnicianSoldRevenueSummariesStddevPopFields = {
  __typename?: 'JobTechnicianSoldRevenueSummariesStddevPopFields';
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesStddevPopOrderBy = {
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type JobTechnicianSoldRevenueSummariesStddevSampFields = {
  __typename?: 'JobTechnicianSoldRevenueSummariesStddevSampFields';
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesStddevSampOrderBy = {
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobTechnicianSoldRevenueSummariesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobTechnicianSoldRevenueSummariesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  technicianUserGuid?: InputMaybe<Scalars['uuid']>;
  totalSoldRevenueUsc?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JobTechnicianSoldRevenueSummariesSumFields = {
  __typename?: 'JobTechnicianSoldRevenueSummariesSumFields';
  totalSoldRevenueUsc?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesSumOrderBy = {
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type JobTechnicianSoldRevenueSummariesVarPopFields = {
  __typename?: 'JobTechnicianSoldRevenueSummariesVarPopFields';
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesVarPopOrderBy = {
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type JobTechnicianSoldRevenueSummariesVarSampFields = {
  __typename?: 'JobTechnicianSoldRevenueSummariesVarSampFields';
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesVarSampOrderBy = {
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JobTechnicianSoldRevenueSummariesVarianceFields = {
  __typename?: 'JobTechnicianSoldRevenueSummariesVarianceFields';
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_technician_sold_revenue_summaries" */
export type JobTechnicianSoldRevenueSummariesVarianceOrderBy = {
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** Keeps track of the reason why a job's job type was changed */
export type JobTypeChangeReasons = {
  __typename?: 'JobTypeChangeReasons';
  changedByUserGuid?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  jobGuid: Scalars['uuid'];
  jobTypeChangeReasonGuid: Scalars['uuid'];
  newJobTypeGuid: Scalars['uuid'];
  oldJobTypeGuid: Scalars['uuid'];
  reason: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "job_type_change_reasons" */
export type JobTypeChangeReasonsAggregate = {
  __typename?: 'JobTypeChangeReasonsAggregate';
  aggregate?: Maybe<JobTypeChangeReasonsAggregateFields>;
  nodes: Array<JobTypeChangeReasons>;
};

/** aggregate fields of "job_type_change_reasons" */
export type JobTypeChangeReasonsAggregateFields = {
  __typename?: 'JobTypeChangeReasonsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobTypeChangeReasonsMaxFields>;
  min?: Maybe<JobTypeChangeReasonsMinFields>;
};


/** aggregate fields of "job_type_change_reasons" */
export type JobTypeChangeReasonsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobTypeChangeReasonsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "job_type_change_reasons". All fields are combined with a logical 'AND'. */
export type JobTypeChangeReasonsBoolExp = {
  _and?: InputMaybe<Array<JobTypeChangeReasonsBoolExp>>;
  _not?: InputMaybe<JobTypeChangeReasonsBoolExp>;
  _or?: InputMaybe<Array<JobTypeChangeReasonsBoolExp>>;
  changedByUserGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  jobTypeChangeReasonGuid?: InputMaybe<UuidComparisonExp>;
  newJobTypeGuid?: InputMaybe<UuidComparisonExp>;
  oldJobTypeGuid?: InputMaybe<UuidComparisonExp>;
  reason?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_type_change_reasons" */
export type JobTypeChangeReasonsConstraint =
  /** unique or primary key constraint on columns "job_type_change_reason_guid" */
  | 'job_type_change_reasons_pkey';

/** input type for inserting data into table "job_type_change_reasons" */
export type JobTypeChangeReasonsInsertInput = {
  changedByUserGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeChangeReasonGuid?: InputMaybe<Scalars['uuid']>;
  newJobTypeGuid?: InputMaybe<Scalars['uuid']>;
  oldJobTypeGuid?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobTypeChangeReasonsMaxFields = {
  __typename?: 'JobTypeChangeReasonsMaxFields';
  changedByUserGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTypeChangeReasonGuid?: Maybe<Scalars['uuid']>;
  newJobTypeGuid?: Maybe<Scalars['uuid']>;
  oldJobTypeGuid?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type JobTypeChangeReasonsMinFields = {
  __typename?: 'JobTypeChangeReasonsMinFields';
  changedByUserGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTypeChangeReasonGuid?: Maybe<Scalars['uuid']>;
  newJobTypeGuid?: Maybe<Scalars['uuid']>;
  oldJobTypeGuid?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "job_type_change_reasons" */
export type JobTypeChangeReasonsMutationResponse = {
  __typename?: 'JobTypeChangeReasonsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobTypeChangeReasons>;
};

/** on_conflict condition type for table "job_type_change_reasons" */
export type JobTypeChangeReasonsOnConflict = {
  constraint: JobTypeChangeReasonsConstraint;
  updateColumns?: Array<JobTypeChangeReasonsUpdateColumn>;
  where?: InputMaybe<JobTypeChangeReasonsBoolExp>;
};

/** Ordering options when selecting data from "job_type_change_reasons". */
export type JobTypeChangeReasonsOrderBy = {
  changedByUserGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  jobTypeChangeReasonGuid?: InputMaybe<OrderBy>;
  newJobTypeGuid?: InputMaybe<OrderBy>;
  oldJobTypeGuid?: InputMaybe<OrderBy>;
  reason?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_type_change_reasons */
export type JobTypeChangeReasonsPkColumnsInput = {
  jobTypeChangeReasonGuid: Scalars['uuid'];
};

/** select columns of table "job_type_change_reasons" */
export type JobTypeChangeReasonsSelectColumn =
  /** column name */
  | 'changedByUserGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'jobTypeChangeReasonGuid'
  /** column name */
  | 'newJobTypeGuid'
  /** column name */
  | 'oldJobTypeGuid'
  /** column name */
  | 'reason'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "job_type_change_reasons" */
export type JobTypeChangeReasonsSetInput = {
  changedByUserGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeChangeReasonGuid?: InputMaybe<Scalars['uuid']>;
  newJobTypeGuid?: InputMaybe<Scalars['uuid']>;
  oldJobTypeGuid?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "job_type_change_reasons" */
export type JobTypeChangeReasonsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobTypeChangeReasonsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobTypeChangeReasonsStreamCursorValueInput = {
  changedByUserGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeChangeReasonGuid?: InputMaybe<Scalars['uuid']>;
  newJobTypeGuid?: InputMaybe<Scalars['uuid']>;
  oldJobTypeGuid?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "job_type_change_reasons" */
export type JobTypeChangeReasonsUpdateColumn =
  /** column name */
  | 'changedByUserGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'jobTypeChangeReasonGuid'
  /** column name */
  | 'newJobTypeGuid'
  /** column name */
  | 'oldJobTypeGuid'
  /** column name */
  | 'reason'
  /** column name */
  | 'updatedAt';

export type JobTypeChangeReasonsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobTypeChangeReasonsSetInput>;
  /** filter the rows which have to be updated */
  where: JobTypeChangeReasonsBoolExp;
};

/** columns and relationships of "job_types" */
export type JobTypes = {
  __typename?: 'JobTypes';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  color?: Maybe<Scalars['String']>;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  defaultBusinessUnit?: Maybe<BusinessUnits>;
  defaultBusinessUnitGuid?: Maybe<Scalars['uuid']>;
  defaultSummary?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  durationMinutes: Scalars['Int'];
  hideJobSummaryField?: Maybe<Scalars['Boolean']>;
  hotLeadMinimumEquipmentAgeYears?: Maybe<Scalars['Int']>;
  isIncludedInJobCosting: Scalars['Boolean'];
  isOpportunity: Scalars['Boolean'];
  isPotentialHotLead: Scalars['Boolean'];
  jobClass: JobClassesEnum;
  /** An object relationship */
  jobLifecycle: JobLifecycles;
  jobLifecycleGuid: Scalars['uuid'];
  jobTypeGuid: Scalars['uuid'];
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobsAggregate: JobsAggregate;
  lastModifiedBy: Scalars['String'];
  name: Scalars['String'];
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "job_types" */
export type JobTypesJobsArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


/** columns and relationships of "job_types" */
export type JobTypesJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};

/** aggregated selection of "job_types" */
export type JobTypesAggregate = {
  __typename?: 'JobTypesAggregate';
  aggregate?: Maybe<JobTypesAggregateFields>;
  nodes: Array<JobTypes>;
};

export type JobTypesAggregateBoolExp = {
  bool_and?: InputMaybe<JobTypesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<JobTypesAggregateBoolExpBool_Or>;
  count?: InputMaybe<JobTypesAggregateBoolExpCount>;
};

/** aggregate fields of "job_types" */
export type JobTypesAggregateFields = {
  __typename?: 'JobTypesAggregateFields';
  avg?: Maybe<JobTypesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobTypesMaxFields>;
  min?: Maybe<JobTypesMinFields>;
  stddev?: Maybe<JobTypesStddevFields>;
  stddevPop?: Maybe<JobTypesStddevPopFields>;
  stddevSamp?: Maybe<JobTypesStddevSampFields>;
  sum?: Maybe<JobTypesSumFields>;
  varPop?: Maybe<JobTypesVarPopFields>;
  varSamp?: Maybe<JobTypesVarSampFields>;
  variance?: Maybe<JobTypesVarianceFields>;
};


/** aggregate fields of "job_types" */
export type JobTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_types" */
export type JobTypesAggregateOrderBy = {
  avg?: InputMaybe<JobTypesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobTypesMaxOrderBy>;
  min?: InputMaybe<JobTypesMinOrderBy>;
  stddev?: InputMaybe<JobTypesStddevOrderBy>;
  stddevPop?: InputMaybe<JobTypesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<JobTypesStddevSampOrderBy>;
  sum?: InputMaybe<JobTypesSumOrderBy>;
  varPop?: InputMaybe<JobTypesVarPopOrderBy>;
  varSamp?: InputMaybe<JobTypesVarSampOrderBy>;
  variance?: InputMaybe<JobTypesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "job_types" */
export type JobTypesArrRelInsertInput = {
  data: Array<JobTypesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobTypesOnConflict>;
};

/** aggregate avg on columns */
export type JobTypesAvgFields = {
  __typename?: 'JobTypesAvgFields';
  durationMinutes?: Maybe<Scalars['Float']>;
  hotLeadMinimumEquipmentAgeYears?: Maybe<Scalars['Float']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_types" */
export type JobTypesAvgOrderBy = {
  durationMinutes?: InputMaybe<OrderBy>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<OrderBy>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "job_types". All fields are combined with a logical 'AND'. */
export type JobTypesBoolExp = {
  _and?: InputMaybe<Array<JobTypesBoolExp>>;
  _not?: InputMaybe<JobTypesBoolExp>;
  _or?: InputMaybe<Array<JobTypesBoolExp>>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  color?: InputMaybe<StringComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  defaultBusinessUnit?: InputMaybe<BusinessUnitsBoolExp>;
  defaultBusinessUnitGuid?: InputMaybe<UuidComparisonExp>;
  defaultSummary?: InputMaybe<StringComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  durationMinutes?: InputMaybe<IntComparisonExp>;
  hideJobSummaryField?: InputMaybe<BooleanComparisonExp>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<IntComparisonExp>;
  isIncludedInJobCosting?: InputMaybe<BooleanComparisonExp>;
  isOpportunity?: InputMaybe<BooleanComparisonExp>;
  isPotentialHotLead?: InputMaybe<BooleanComparisonExp>;
  jobClass?: InputMaybe<JobClassesEnumComparisonExp>;
  jobLifecycle?: InputMaybe<JobLifecyclesBoolExp>;
  jobLifecycleGuid?: InputMaybe<UuidComparisonExp>;
  jobTypeGuid?: InputMaybe<UuidComparisonExp>;
  jobs?: InputMaybe<JobsBoolExp>;
  jobsAggregate?: InputMaybe<JobsAggregateBoolExp>;
  lastModifiedBy?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  opportunityConversionThresholdUsc?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_types" */
export type JobTypesConstraint =
  /** unique or primary key constraint on columns "company_guid", "name" */
  | 'job_types_name_company_guid_key'
  /** unique or primary key constraint on columns "job_type_guid" */
  | 'job_types_pkey';

/** input type for incrementing numeric columns in table "job_types" */
export type JobTypesIncInput = {
  durationMinutes?: InputMaybe<Scalars['Int']>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<Scalars['Int']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "job_types" */
export type JobTypesInsertInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  color?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultBusinessUnit?: InputMaybe<BusinessUnitsObjRelInsertInput>;
  defaultBusinessUnitGuid?: InputMaybe<Scalars['uuid']>;
  defaultSummary?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  hideJobSummaryField?: InputMaybe<Scalars['Boolean']>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<Scalars['Int']>;
  isIncludedInJobCosting?: InputMaybe<Scalars['Boolean']>;
  isOpportunity?: InputMaybe<Scalars['Boolean']>;
  isPotentialHotLead?: InputMaybe<Scalars['Boolean']>;
  jobClass?: InputMaybe<JobClassesEnum>;
  jobLifecycle?: InputMaybe<JobLifecyclesObjRelInsertInput>;
  jobLifecycleGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  jobs?: InputMaybe<JobsArrRelInsertInput>;
  lastModifiedBy?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobTypesMaxFields = {
  __typename?: 'JobTypesMaxFields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  color?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultBusinessUnitGuid?: Maybe<Scalars['uuid']>;
  defaultSummary?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  hotLeadMinimumEquipmentAgeYears?: Maybe<Scalars['Int']>;
  jobLifecycleGuid?: Maybe<Scalars['uuid']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "job_types" */
export type JobTypesMaxOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  color?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  defaultBusinessUnitGuid?: InputMaybe<OrderBy>;
  defaultSummary?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  durationMinutes?: InputMaybe<OrderBy>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<OrderBy>;
  jobLifecycleGuid?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  lastModifiedBy?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobTypesMinFields = {
  __typename?: 'JobTypesMinFields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  color?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultBusinessUnitGuid?: Maybe<Scalars['uuid']>;
  defaultSummary?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  hotLeadMinimumEquipmentAgeYears?: Maybe<Scalars['Int']>;
  jobLifecycleGuid?: Maybe<Scalars['uuid']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "job_types" */
export type JobTypesMinOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  color?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  defaultBusinessUnitGuid?: InputMaybe<OrderBy>;
  defaultSummary?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  durationMinutes?: InputMaybe<OrderBy>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<OrderBy>;
  jobLifecycleGuid?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  lastModifiedBy?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "job_types" */
export type JobTypesMutationResponse = {
  __typename?: 'JobTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobTypes>;
};

/** input type for inserting object relation for remote table "job_types" */
export type JobTypesObjRelInsertInput = {
  data: JobTypesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobTypesOnConflict>;
};

/** on_conflict condition type for table "job_types" */
export type JobTypesOnConflict = {
  constraint: JobTypesConstraint;
  updateColumns?: Array<JobTypesUpdateColumn>;
  where?: InputMaybe<JobTypesBoolExp>;
};

/** Ordering options when selecting data from "job_types". */
export type JobTypesOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  color?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  defaultBusinessUnit?: InputMaybe<BusinessUnitsOrderBy>;
  defaultBusinessUnitGuid?: InputMaybe<OrderBy>;
  defaultSummary?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  durationMinutes?: InputMaybe<OrderBy>;
  hideJobSummaryField?: InputMaybe<OrderBy>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<OrderBy>;
  isIncludedInJobCosting?: InputMaybe<OrderBy>;
  isOpportunity?: InputMaybe<OrderBy>;
  isPotentialHotLead?: InputMaybe<OrderBy>;
  jobClass?: InputMaybe<OrderBy>;
  jobLifecycle?: InputMaybe<JobLifecyclesOrderBy>;
  jobLifecycleGuid?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  jobsAggregate?: InputMaybe<JobsAggregateOrderBy>;
  lastModifiedBy?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  opportunityConversionThresholdUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_types */
export type JobTypesPkColumnsInput = {
  jobTypeGuid: Scalars['uuid'];
};

/** select columns of table "job_types" */
export type JobTypesSelectColumn =
  /** column name */
  | 'archivedAt'
  /** column name */
  | 'color'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'defaultBusinessUnitGuid'
  /** column name */
  | 'defaultSummary'
  /** column name */
  | 'description'
  /** column name */
  | 'durationMinutes'
  /** column name */
  | 'hideJobSummaryField'
  /** column name */
  | 'hotLeadMinimumEquipmentAgeYears'
  /** column name */
  | 'isIncludedInJobCosting'
  /** column name */
  | 'isOpportunity'
  /** column name */
  | 'isPotentialHotLead'
  /** column name */
  | 'jobClass'
  /** column name */
  | 'jobLifecycleGuid'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'lastModifiedBy'
  /** column name */
  | 'name'
  /** column name */
  | 'opportunityConversionThresholdUsc'
  /** column name */
  | 'updatedAt';

/** select "jobTypesAggregateBoolExpBool_andArgumentsColumns" columns of table "job_types" */
export type JobTypesSelectColumnJobTypesAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'hideJobSummaryField'
  /** column name */
  | 'isIncludedInJobCosting'
  /** column name */
  | 'isOpportunity'
  /** column name */
  | 'isPotentialHotLead';

/** select "jobTypesAggregateBoolExpBool_orArgumentsColumns" columns of table "job_types" */
export type JobTypesSelectColumnJobTypesAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'hideJobSummaryField'
  /** column name */
  | 'isIncludedInJobCosting'
  /** column name */
  | 'isOpportunity'
  /** column name */
  | 'isPotentialHotLead';

/** input type for updating data in table "job_types" */
export type JobTypesSetInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  color?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultBusinessUnitGuid?: InputMaybe<Scalars['uuid']>;
  defaultSummary?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  hideJobSummaryField?: InputMaybe<Scalars['Boolean']>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<Scalars['Int']>;
  isIncludedInJobCosting?: InputMaybe<Scalars['Boolean']>;
  isOpportunity?: InputMaybe<Scalars['Boolean']>;
  isPotentialHotLead?: InputMaybe<Scalars['Boolean']>;
  jobClass?: InputMaybe<JobClassesEnum>;
  jobLifecycleGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  lastModifiedBy?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type JobTypesStddevFields = {
  __typename?: 'JobTypesStddevFields';
  durationMinutes?: Maybe<Scalars['Float']>;
  hotLeadMinimumEquipmentAgeYears?: Maybe<Scalars['Float']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_types" */
export type JobTypesStddevOrderBy = {
  durationMinutes?: InputMaybe<OrderBy>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<OrderBy>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type JobTypesStddevPopFields = {
  __typename?: 'JobTypesStddevPopFields';
  durationMinutes?: Maybe<Scalars['Float']>;
  hotLeadMinimumEquipmentAgeYears?: Maybe<Scalars['Float']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "job_types" */
export type JobTypesStddevPopOrderBy = {
  durationMinutes?: InputMaybe<OrderBy>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<OrderBy>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type JobTypesStddevSampFields = {
  __typename?: 'JobTypesStddevSampFields';
  durationMinutes?: Maybe<Scalars['Float']>;
  hotLeadMinimumEquipmentAgeYears?: Maybe<Scalars['Float']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "job_types" */
export type JobTypesStddevSampOrderBy = {
  durationMinutes?: InputMaybe<OrderBy>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<OrderBy>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "job_types" */
export type JobTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobTypesStreamCursorValueInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  color?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultBusinessUnitGuid?: InputMaybe<Scalars['uuid']>;
  defaultSummary?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  hideJobSummaryField?: InputMaybe<Scalars['Boolean']>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<Scalars['Int']>;
  isIncludedInJobCosting?: InputMaybe<Scalars['Boolean']>;
  isOpportunity?: InputMaybe<Scalars['Boolean']>;
  isPotentialHotLead?: InputMaybe<Scalars['Boolean']>;
  jobClass?: InputMaybe<JobClassesEnum>;
  jobLifecycleGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  lastModifiedBy?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type JobTypesSumFields = {
  __typename?: 'JobTypesSumFields';
  durationMinutes?: Maybe<Scalars['Int']>;
  hotLeadMinimumEquipmentAgeYears?: Maybe<Scalars['Int']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "job_types" */
export type JobTypesSumOrderBy = {
  durationMinutes?: InputMaybe<OrderBy>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<OrderBy>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<OrderBy>;
};

/** update columns of table "job_types" */
export type JobTypesUpdateColumn =
  /** column name */
  | 'archivedAt'
  /** column name */
  | 'color'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'defaultBusinessUnitGuid'
  /** column name */
  | 'defaultSummary'
  /** column name */
  | 'description'
  /** column name */
  | 'durationMinutes'
  /** column name */
  | 'hideJobSummaryField'
  /** column name */
  | 'hotLeadMinimumEquipmentAgeYears'
  /** column name */
  | 'isIncludedInJobCosting'
  /** column name */
  | 'isOpportunity'
  /** column name */
  | 'isPotentialHotLead'
  /** column name */
  | 'jobClass'
  /** column name */
  | 'jobLifecycleGuid'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'lastModifiedBy'
  /** column name */
  | 'name'
  /** column name */
  | 'opportunityConversionThresholdUsc'
  /** column name */
  | 'updatedAt';

export type JobTypesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<JobTypesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobTypesSetInput>;
  /** filter the rows which have to be updated */
  where: JobTypesBoolExp;
};

/** aggregate varPop on columns */
export type JobTypesVarPopFields = {
  __typename?: 'JobTypesVarPopFields';
  durationMinutes?: Maybe<Scalars['Float']>;
  hotLeadMinimumEquipmentAgeYears?: Maybe<Scalars['Float']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "job_types" */
export type JobTypesVarPopOrderBy = {
  durationMinutes?: InputMaybe<OrderBy>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<OrderBy>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type JobTypesVarSampFields = {
  __typename?: 'JobTypesVarSampFields';
  durationMinutes?: Maybe<Scalars['Float']>;
  hotLeadMinimumEquipmentAgeYears?: Maybe<Scalars['Float']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "job_types" */
export type JobTypesVarSampOrderBy = {
  durationMinutes?: InputMaybe<OrderBy>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<OrderBy>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JobTypesVarianceFields = {
  __typename?: 'JobTypesVarianceFields';
  durationMinutes?: Maybe<Scalars['Float']>;
  hotLeadMinimumEquipmentAgeYears?: Maybe<Scalars['Float']>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_types" */
export type JobTypesVarianceOrderBy = {
  durationMinutes?: InputMaybe<OrderBy>;
  hotLeadMinimumEquipmentAgeYears?: InputMaybe<OrderBy>;
  /** This should really be "conversion_threshold_usc" since a job can be converted regardless of whether its an opportunity. BZ-2708 will rename this */
  opportunityConversionThresholdUsc?: InputMaybe<OrderBy>;
};

/** columns and relationships of "jobs" */
export type Jobs = {
  __typename?: 'Jobs';
  /** An object relationship */
  account: Accounts;
  accountGuid: Scalars['uuid'];
  /** An array relationship */
  activityItems: Array<ActivityItems>;
  /** An aggregate relationship */
  activityItemsAggregate: ActivityItemsAggregate;
  /** An array relationship */
  appointments: Array<JobAppointments>;
  /** An aggregate relationship */
  appointmentsAggregate: JobAppointmentsAggregate;
  /** An object relationship */
  businessUnit?: Maybe<BusinessUnits>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  commissionJobCostsDeductionRate?: Maybe<Scalars['numeric']>;
  commissionJobCostsFlatDeductionUsc?: Maybe<Scalars['Int']>;
  commissionOverheadDeductionRate?: Maybe<Scalars['numeric']>;
  commissionOverheadFlatDeductionUsc?: Maybe<Scalars['Int']>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  customerPurchaseOrderNumber?: Maybe<Scalars['String']>;
  displayId: Scalars['bigint'];
  /** A computed field, executes function "jobs_display_id_as_text" */
  displayIdString?: Maybe<Scalars['String']>;
  /** An array relationship */
  equipmentTypeJobLinks: Array<EquipmentTypeLinks>;
  /** An aggregate relationship */
  equipmentTypeJobLinksAggregate: EquipmentTypeLinksAggregate;
  /** An array relationship */
  estimates: Array<Estimates>;
  /** An aggregate relationship */
  estimatesAggregate: EstimatesAggregate;
  /** An array relationship */
  fileLinks: Array<FileLinks>;
  /** An aggregate relationship */
  fileLinksAggregate: FileLinksAggregate;
  installProjectType?: Maybe<Scalars['String']>;
  instantBookingAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  integratedPhoneCallJobs: Array<IntegratedPhoneCallJobs>;
  /** An aggregate relationship */
  integratedPhoneCallJobsAggregate: IntegratedPhoneCallJobsAggregate;
  /** An array relationship */
  invoicesQueryables: Array<InvoicesQueryable>;
  /** An aggregate relationship */
  invoicesQueryablesAggregate: InvoicesQueryableAggregate;
  isConverted?: Maybe<Scalars['Boolean']>;
  isHotLead: Scalars['Boolean'];
  isMembershipOpportunity: Scalars['Boolean'];
  isMembershipRenewalOpportunity: Scalars['Boolean'];
  isMembershipSold?: Maybe<Scalars['Boolean']>;
  isOpportunity: Scalars['Boolean'];
  /** An array relationship */
  jobAppointmentAssignments: Array<JobAppointmentAssignments>;
  /** An aggregate relationship */
  jobAppointmentAssignmentsAggregate: JobAppointmentAssignmentsAggregate;
  /** Whether job is part of job costing workflow. NOT_TRACKED=excluded, TRACKED=included. */
  jobCostingTrackingStatus: Scalars['String'];
  /** Verification state for job costing. UNVERIFIED=needs review, VERIFIED=confirmed. */
  jobCostingVerificationStatus: Scalars['String'];
  /** An object relationship */
  jobFullyPaidInvoicesSummary?: Maybe<JobsFullyPaidInvoicesSummary>;
  /** An object relationship */
  jobFullyPaidInvoicesV2Summary?: Maybe<JobsFullyPaidInvoicesV2Summary>;
  /** An object relationship */
  jobFullyPaidInvoicesV2SummaryMv?: Maybe<JobsFullyPaidInvoicesV2SummaryMv>;
  jobGuid: Scalars['uuid'];
  /** An array relationship */
  jobInvoices: Array<JobInvoices>;
  /** An aggregate relationship */
  jobInvoicesAggregate: JobInvoicesAggregate;
  /** An array relationship */
  jobLeadSource: Array<CompanyLeadSourceLinks>;
  /** An aggregate relationship */
  jobLeadSourceAggregate: CompanyLeadSourceLinksAggregate;
  /** An object relationship */
  jobLifecycleStatus: JobLifecycleStatuses;
  /** Records when the job is first transitioned to a Closed lifecycle status */
  jobLifecycleStatusClosedAt?: Maybe<Scalars['timestamptz']>;
  jobLifecycleStatusGuid: Scalars['uuid'];
  jobLifecycleStatusUpdatedAt: Scalars['timestamptz'];
  /** An object relationship */
  jobMaxCommissionableBase?: Maybe<JobsMaxCommissionableBase>;
  /** An array relationship */
  jobTeamMembers: Array<JobTeamMembers>;
  /** An aggregate relationship */
  jobTeamMembersAggregate: JobTeamMembersAggregate;
  /** An array relationship */
  jobTechnicianEarnedRevenueAttributions: Array<JobTechnicianEarnedRevenueAttributions>;
  /** An aggregate relationship */
  jobTechnicianEarnedRevenueAttributionsAggregate: JobTechnicianEarnedRevenueAttributionsAggregate;
  /** An array relationship */
  jobTechnicianEarnedRevenueSummaries: Array<JobTechnicianEarnedRevenueSummaries>;
  /** An aggregate relationship */
  jobTechnicianEarnedRevenueSummariesAggregate: JobTechnicianEarnedRevenueSummariesAggregate;
  /** An array relationship */
  jobTechnicianSalesCommissionsAndBonuses: Array<JobTechnicianSalesCommissionAndBonus>;
  /** An aggregate relationship */
  jobTechnicianSalesCommissionsAndBonusesAggregate: JobTechnicianSalesCommissionAndBonusAggregate;
  /** An array relationship */
  jobTechnicianSoldRevenueAttributions: Array<JobTechnicianSoldRevenueAttributions>;
  /** An aggregate relationship */
  jobTechnicianSoldRevenueAttributionsAggregate: JobTechnicianSoldRevenueAttributionsAggregate;
  /** An array relationship */
  jobTechnicianSoldRevenueSummaries: Array<JobTechnicianSoldRevenueSummaries>;
  /** An aggregate relationship */
  jobTechnicianSoldRevenueSummariesAggregate: JobTechnicianSoldRevenueSummariesAggregate;
  /** An object relationship */
  jobType: JobTypes;
  jobTypeGuid: Scalars['uuid'];
  /** An array relationship */
  linkedAppointmentChecklistInstances: Array<JobsWithLinkedJobLinkedAppointmentChecklistInstances>;
  /** An aggregate relationship */
  linkedAppointmentChecklistInstancesAggregate: JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregate;
  /** An array relationship */
  linkedJobEstimates: Array<JobsWithLinkedJobLinkedEstimates>;
  /** An aggregate relationship */
  linkedJobEstimatesAggregate: JobsWithLinkedJobLinkedEstimatesAggregate;
  /** An array relationship */
  linkedJobInvoices: Array<JobsWithLinkedJobLinkedInvoices>;
  /** An aggregate relationship */
  linkedJobInvoicesAggregate: JobsWithLinkedJobLinkedInvoicesAggregate;
  /** An array relationship */
  linkedJobs: Array<JobsWithLinkedJob>;
  /** An aggregate relationship */
  linkedJobsAggregate: JobsWithLinkedJobAggregate;
  /** An object relationship */
  linkedMaintenancePlanVisit?: Maybe<MaintenancePlanVisits>;
  /** An array relationship */
  linkedToJobs: Array<JobsWithLinkedJob>;
  /** An aggregate relationship */
  linkedToJobsAggregate: JobsWithLinkedJobAggregate;
  /** An object relationship */
  location: Locations;
  locationGuid: Scalars['uuid'];
  /** An object relationship */
  maintenancePlan?: Maybe<MaintenancePlansQueryable>;
  maintenancePlanCreditUsedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  maintenancePlans: Array<MaintenancePlansQueryable>;
  /** An aggregate relationship */
  maintenancePlansAggregate: MaintenancePlansQueryableAggregate;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: Maybe<Scalars['Int']>;
  /** An array relationship */
  noteLinks: Array<NoteLinks>;
  /** An aggregate relationship */
  noteLinksAggregate: NoteLinksAggregate;
  /** An array relationship */
  paymentLinks: Array<PaymentLinks>;
  /** An aggregate relationship */
  paymentLinksAggregate: PaymentLinksAggregate;
  /** An array relationship */
  photoLinks: Array<PhotoLinks>;
  /** An aggregate relationship */
  photoLinksAggregate: PhotoLinksAggregate;
  /** An array relationship */
  photos: Array<PhotoLinks>;
  /** An aggregate relationship */
  photosAggregate: PhotoLinksAggregate;
  /** An object relationship */
  pointOfContact: Contacts;
  pointOfContactGuid: Scalars['uuid'];
  /** An array relationship */
  purchaseOrders: Array<PurchaseOrders>;
  /** An aggregate relationship */
  purchaseOrdersAggregate: PurchaseOrdersAggregate;
  revenueRecognizedAt?: Maybe<Scalars['timestamptz']>;
  summary?: Maybe<Scalars['String']>;
  summaryHtml?: Maybe<Scalars['HtmlString']>;
  /** An array relationship */
  tags: Array<JobTags>;
  /** An aggregate relationship */
  tagsAggregate: JobTagsAggregate;
  updatedAt: Scalars['timestamptz'];
  useMaintenancePlanCredit: Scalars['Boolean'];
  workCompletedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "jobs" */
export type JobsActivityItemsArgs = {
  distinctOn?: InputMaybe<Array<ActivityItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityItemsOrderBy>>;
  where?: InputMaybe<ActivityItemsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsActivityItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityItemsOrderBy>>;
  where?: InputMaybe<ActivityItemsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsAppointmentsArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsAppointmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsEquipmentTypeJobLinksArgs = {
  distinctOn?: InputMaybe<Array<EquipmentTypeLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentTypeLinksOrderBy>>;
  where?: InputMaybe<EquipmentTypeLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsEquipmentTypeJobLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<EquipmentTypeLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentTypeLinksOrderBy>>;
  where?: InputMaybe<EquipmentTypeLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsEstimatesArgs = {
  distinctOn?: InputMaybe<Array<EstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesOrderBy>>;
  where?: InputMaybe<EstimatesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsEstimatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesOrderBy>>;
  where?: InputMaybe<EstimatesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsFileLinksArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsFileLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsIntegratedPhoneCallJobsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallJobsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsIntegratedPhoneCallJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallJobsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsInvoicesQueryablesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQueryableOrderBy>>;
  where?: InputMaybe<InvoicesQueryableBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsInvoicesQueryablesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQueryableOrderBy>>;
  where?: InputMaybe<InvoicesQueryableBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobAppointmentAssignmentsArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobAppointmentAssignmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobInvoicesArgs = {
  distinctOn?: InputMaybe<Array<JobInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobInvoicesOrderBy>>;
  where?: InputMaybe<JobInvoicesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobInvoicesOrderBy>>;
  where?: InputMaybe<JobInvoicesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobLeadSourceArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourceLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourceLinksOrderBy>>;
  where?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobLeadSourceAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourceLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourceLinksOrderBy>>;
  where?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobTeamMembersArgs = {
  distinctOn?: InputMaybe<Array<JobTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTeamMembersOrderBy>>;
  where?: InputMaybe<JobTeamMembersBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobTeamMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTeamMembersOrderBy>>;
  where?: InputMaybe<JobTeamMembersBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobTechnicianEarnedRevenueAttributionsArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsOrderBy>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueAttributionsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobTechnicianEarnedRevenueAttributionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsOrderBy>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueAttributionsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobTechnicianEarnedRevenueSummariesArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesOrderBy>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueSummariesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobTechnicianEarnedRevenueSummariesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesOrderBy>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueSummariesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobTechnicianSalesCommissionsAndBonusesArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusOrderBy>>;
  where?: InputMaybe<JobTechnicianSalesCommissionAndBonusBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobTechnicianSalesCommissionsAndBonusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusOrderBy>>;
  where?: InputMaybe<JobTechnicianSalesCommissionAndBonusBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobTechnicianSoldRevenueAttributionsArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsOrderBy>>;
  where?: InputMaybe<JobTechnicianSoldRevenueAttributionsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobTechnicianSoldRevenueAttributionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsOrderBy>>;
  where?: InputMaybe<JobTechnicianSoldRevenueAttributionsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobTechnicianSoldRevenueSummariesArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesOrderBy>>;
  where?: InputMaybe<JobTechnicianSoldRevenueSummariesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsJobTechnicianSoldRevenueSummariesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesOrderBy>>;
  where?: InputMaybe<JobTechnicianSoldRevenueSummariesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsLinkedAppointmentChecklistInstancesArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsLinkedAppointmentChecklistInstancesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsLinkedJobEstimatesArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsLinkedJobEstimatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsLinkedJobInvoicesArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedInvoicesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsLinkedJobInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedInvoicesBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsLinkedJobsArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsLinkedJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsLinkedToJobsArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsLinkedToJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsMaintenancePlansArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlansQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlansQueryableOrderBy>>;
  where?: InputMaybe<MaintenancePlansQueryableBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsMaintenancePlansAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlansQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlansQueryableOrderBy>>;
  where?: InputMaybe<MaintenancePlansQueryableBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsNoteLinksArgs = {
  distinctOn?: InputMaybe<Array<NoteLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteLinksOrderBy>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsNoteLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteLinksOrderBy>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsPaymentLinksArgs = {
  distinctOn?: InputMaybe<Array<PaymentLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentLinksOrderBy>>;
  where?: InputMaybe<PaymentLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsPaymentLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentLinksOrderBy>>;
  where?: InputMaybe<PaymentLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsPhotoLinksArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsPhotoLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsPhotosArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsPhotosAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsPurchaseOrdersArgs = {
  distinctOn?: InputMaybe<Array<PurchaseOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PurchaseOrdersOrderBy>>;
  where?: InputMaybe<PurchaseOrdersBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsPurchaseOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PurchaseOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PurchaseOrdersOrderBy>>;
  where?: InputMaybe<PurchaseOrdersBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsTagsArgs = {
  distinctOn?: InputMaybe<Array<JobTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTagsOrderBy>>;
  where?: InputMaybe<JobTagsBoolExp>;
};


/** columns and relationships of "jobs" */
export type JobsTagsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTagsOrderBy>>;
  where?: InputMaybe<JobTagsBoolExp>;
};

/** aggregated selection of "jobs" */
export type JobsAggregate = {
  __typename?: 'JobsAggregate';
  aggregate?: Maybe<JobsAggregateFields>;
  nodes: Array<Jobs>;
};

export type JobsAggregateBoolExp = {
  bool_and?: InputMaybe<JobsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<JobsAggregateBoolExpBool_Or>;
  count?: InputMaybe<JobsAggregateBoolExpCount>;
};

/** aggregate fields of "jobs" */
export type JobsAggregateFields = {
  __typename?: 'JobsAggregateFields';
  avg?: Maybe<JobsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobsMaxFields>;
  min?: Maybe<JobsMinFields>;
  stddev?: Maybe<JobsStddevFields>;
  stddevPop?: Maybe<JobsStddevPopFields>;
  stddevSamp?: Maybe<JobsStddevSampFields>;
  sum?: Maybe<JobsSumFields>;
  varPop?: Maybe<JobsVarPopFields>;
  varSamp?: Maybe<JobsVarSampFields>;
  variance?: Maybe<JobsVarianceFields>;
};


/** aggregate fields of "jobs" */
export type JobsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "jobs" */
export type JobsAggregateOrderBy = {
  avg?: InputMaybe<JobsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobsMaxOrderBy>;
  min?: InputMaybe<JobsMinOrderBy>;
  stddev?: InputMaybe<JobsStddevOrderBy>;
  stddevPop?: InputMaybe<JobsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<JobsStddevSampOrderBy>;
  sum?: InputMaybe<JobsSumOrderBy>;
  varPop?: InputMaybe<JobsVarPopOrderBy>;
  varSamp?: InputMaybe<JobsVarSampOrderBy>;
  variance?: InputMaybe<JobsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "jobs" */
export type JobsArrRelInsertInput = {
  data: Array<JobsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobsOnConflict>;
};

/** aggregate avg on columns */
export type JobsAvgFields = {
  __typename?: 'JobsAvgFields';
  commissionJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  commissionJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  commissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  commissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "jobs" */
export type JobsAvgOrderBy = {
  commissionJobCostsDeductionRate?: InputMaybe<OrderBy>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  commissionOverheadDeductionRate?: InputMaybe<OrderBy>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "jobs". All fields are combined with a logical 'AND'. */
export type JobsBoolExp = {
  _and?: InputMaybe<Array<JobsBoolExp>>;
  _not?: InputMaybe<JobsBoolExp>;
  _or?: InputMaybe<Array<JobsBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  activityItems?: InputMaybe<ActivityItemsBoolExp>;
  activityItemsAggregate?: InputMaybe<ActivityItemsAggregateBoolExp>;
  appointments?: InputMaybe<JobAppointmentsBoolExp>;
  appointmentsAggregate?: InputMaybe<JobAppointmentsAggregateBoolExp>;
  businessUnit?: InputMaybe<BusinessUnitsBoolExp>;
  businessUnitGuid?: InputMaybe<UuidComparisonExp>;
  commissionJobCostsDeductionRate?: InputMaybe<NumericComparisonExp>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<IntComparisonExp>;
  commissionOverheadDeductionRate?: InputMaybe<NumericComparisonExp>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<IntComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  customerPurchaseOrderNumber?: InputMaybe<StringComparisonExp>;
  displayId?: InputMaybe<BigintComparisonExp>;
  displayIdString?: InputMaybe<StringComparisonExp>;
  equipmentTypeJobLinks?: InputMaybe<EquipmentTypeLinksBoolExp>;
  equipmentTypeJobLinksAggregate?: InputMaybe<EquipmentTypeLinksAggregateBoolExp>;
  estimates?: InputMaybe<EstimatesBoolExp>;
  estimatesAggregate?: InputMaybe<EstimatesAggregateBoolExp>;
  fileLinks?: InputMaybe<FileLinksBoolExp>;
  fileLinksAggregate?: InputMaybe<FileLinksAggregateBoolExp>;
  installProjectType?: InputMaybe<StringComparisonExp>;
  instantBookingAt?: InputMaybe<TimestamptzComparisonExp>;
  integratedPhoneCallJobs?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
  integratedPhoneCallJobsAggregate?: InputMaybe<IntegratedPhoneCallJobsAggregateBoolExp>;
  invoicesQueryables?: InputMaybe<InvoicesQueryableBoolExp>;
  invoicesQueryablesAggregate?: InputMaybe<InvoicesQueryableAggregateBoolExp>;
  isConverted?: InputMaybe<BooleanComparisonExp>;
  isHotLead?: InputMaybe<BooleanComparisonExp>;
  isMembershipOpportunity?: InputMaybe<BooleanComparisonExp>;
  isMembershipRenewalOpportunity?: InputMaybe<BooleanComparisonExp>;
  isMembershipSold?: InputMaybe<BooleanComparisonExp>;
  isOpportunity?: InputMaybe<BooleanComparisonExp>;
  jobAppointmentAssignments?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
  jobAppointmentAssignmentsAggregate?: InputMaybe<JobAppointmentAssignmentsAggregateBoolExp>;
  jobCostingTrackingStatus?: InputMaybe<StringComparisonExp>;
  jobCostingVerificationStatus?: InputMaybe<StringComparisonExp>;
  jobFullyPaidInvoicesSummary?: InputMaybe<JobsFullyPaidInvoicesSummaryBoolExp>;
  jobFullyPaidInvoicesV2Summary?: InputMaybe<JobsFullyPaidInvoicesV2SummaryBoolExp>;
  jobFullyPaidInvoicesV2SummaryMv?: InputMaybe<JobsFullyPaidInvoicesV2SummaryMvBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  jobInvoices?: InputMaybe<JobInvoicesBoolExp>;
  jobInvoicesAggregate?: InputMaybe<JobInvoicesAggregateBoolExp>;
  jobLeadSource?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
  jobLeadSourceAggregate?: InputMaybe<CompanyLeadSourceLinksAggregateBoolExp>;
  jobLifecycleStatus?: InputMaybe<JobLifecycleStatusesBoolExp>;
  jobLifecycleStatusClosedAt?: InputMaybe<TimestamptzComparisonExp>;
  jobLifecycleStatusGuid?: InputMaybe<UuidComparisonExp>;
  jobLifecycleStatusUpdatedAt?: InputMaybe<TimestamptzComparisonExp>;
  jobMaxCommissionableBase?: InputMaybe<JobsMaxCommissionableBaseBoolExp>;
  jobTeamMembers?: InputMaybe<JobTeamMembersBoolExp>;
  jobTeamMembersAggregate?: InputMaybe<JobTeamMembersAggregateBoolExp>;
  jobTechnicianEarnedRevenueAttributions?: InputMaybe<JobTechnicianEarnedRevenueAttributionsBoolExp>;
  jobTechnicianEarnedRevenueAttributionsAggregate?: InputMaybe<JobTechnicianEarnedRevenueAttributionsAggregateBoolExp>;
  jobTechnicianEarnedRevenueSummaries?: InputMaybe<JobTechnicianEarnedRevenueSummariesBoolExp>;
  jobTechnicianEarnedRevenueSummariesAggregate?: InputMaybe<JobTechnicianEarnedRevenueSummariesAggregateBoolExp>;
  jobTechnicianSalesCommissionsAndBonuses?: InputMaybe<JobTechnicianSalesCommissionAndBonusBoolExp>;
  jobTechnicianSalesCommissionsAndBonusesAggregate?: InputMaybe<JobTechnicianSalesCommissionAndBonusAggregateBoolExp>;
  jobTechnicianSoldRevenueAttributions?: InputMaybe<JobTechnicianSoldRevenueAttributionsBoolExp>;
  jobTechnicianSoldRevenueAttributionsAggregate?: InputMaybe<JobTechnicianSoldRevenueAttributionsAggregateBoolExp>;
  jobTechnicianSoldRevenueSummaries?: InputMaybe<JobTechnicianSoldRevenueSummariesBoolExp>;
  jobTechnicianSoldRevenueSummariesAggregate?: InputMaybe<JobTechnicianSoldRevenueSummariesAggregateBoolExp>;
  jobType?: InputMaybe<JobTypesBoolExp>;
  jobTypeGuid?: InputMaybe<UuidComparisonExp>;
  linkedAppointmentChecklistInstances?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>;
  linkedAppointmentChecklistInstancesAggregate?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregateBoolExp>;
  linkedJobEstimates?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
  linkedJobEstimatesAggregate?: InputMaybe<JobsWithLinkedJobLinkedEstimatesAggregateBoolExp>;
  linkedJobInvoices?: InputMaybe<JobsWithLinkedJobLinkedInvoicesBoolExp>;
  linkedJobInvoicesAggregate?: InputMaybe<JobsWithLinkedJobLinkedInvoicesAggregateBoolExp>;
  linkedJobs?: InputMaybe<JobsWithLinkedJobBoolExp>;
  linkedJobsAggregate?: InputMaybe<JobsWithLinkedJobAggregateBoolExp>;
  linkedMaintenancePlanVisit?: InputMaybe<MaintenancePlanVisitsBoolExp>;
  linkedToJobs?: InputMaybe<JobsWithLinkedJobBoolExp>;
  linkedToJobsAggregate?: InputMaybe<JobsWithLinkedJobAggregateBoolExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableBoolExp>;
  maintenancePlanCreditUsedAt?: InputMaybe<TimestamptzComparisonExp>;
  maintenancePlans?: InputMaybe<MaintenancePlansQueryableBoolExp>;
  maintenancePlansAggregate?: InputMaybe<MaintenancePlansQueryableAggregateBoolExp>;
  maximumCommissionableBaseUsc?: InputMaybe<IntComparisonExp>;
  noteLinks?: InputMaybe<NoteLinksBoolExp>;
  noteLinksAggregate?: InputMaybe<NoteLinksAggregateBoolExp>;
  paymentLinks?: InputMaybe<PaymentLinksBoolExp>;
  paymentLinksAggregate?: InputMaybe<PaymentLinksAggregateBoolExp>;
  photoLinks?: InputMaybe<PhotoLinksBoolExp>;
  photoLinksAggregate?: InputMaybe<PhotoLinksAggregateBoolExp>;
  photos?: InputMaybe<PhotoLinksBoolExp>;
  photosAggregate?: InputMaybe<PhotoLinksAggregateBoolExp>;
  pointOfContact?: InputMaybe<ContactsBoolExp>;
  pointOfContactGuid?: InputMaybe<UuidComparisonExp>;
  purchaseOrders?: InputMaybe<PurchaseOrdersBoolExp>;
  purchaseOrdersAggregate?: InputMaybe<PurchaseOrdersAggregateBoolExp>;
  revenueRecognizedAt?: InputMaybe<TimestamptzComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
  summaryHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
  tags?: InputMaybe<JobTagsBoolExp>;
  tagsAggregate?: InputMaybe<JobTagsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  useMaintenancePlanCredit?: InputMaybe<BooleanComparisonExp>;
  workCompletedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "jobs" */
export type JobsConstraint =
  /** unique or primary key constraint on columns "display_id", "company_guid" */
  | 'jobs_display_id_company_unique'
  /** unique or primary key constraint on columns "job_guid" */
  | 'jobs_pkey';

/** columns and relationships of "jobs_fully_paid_invoiced_amount" */
export type JobsFullyPaidInvoicedAmount = {
  __typename?: 'JobsFullyPaidInvoicedAmount';
  jobGuid?: Maybe<Scalars['uuid']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "jobs_fully_paid_invoiced_amount" */
export type JobsFullyPaidInvoicedAmountAggregate = {
  __typename?: 'JobsFullyPaidInvoicedAmountAggregate';
  aggregate?: Maybe<JobsFullyPaidInvoicedAmountAggregateFields>;
  nodes: Array<JobsFullyPaidInvoicedAmount>;
};

/** aggregate fields of "jobs_fully_paid_invoiced_amount" */
export type JobsFullyPaidInvoicedAmountAggregateFields = {
  __typename?: 'JobsFullyPaidInvoicedAmountAggregateFields';
  avg?: Maybe<JobsFullyPaidInvoicedAmountAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobsFullyPaidInvoicedAmountMaxFields>;
  min?: Maybe<JobsFullyPaidInvoicedAmountMinFields>;
  stddev?: Maybe<JobsFullyPaidInvoicedAmountStddevFields>;
  stddevPop?: Maybe<JobsFullyPaidInvoicedAmountStddevPopFields>;
  stddevSamp?: Maybe<JobsFullyPaidInvoicedAmountStddevSampFields>;
  sum?: Maybe<JobsFullyPaidInvoicedAmountSumFields>;
  varPop?: Maybe<JobsFullyPaidInvoicedAmountVarPopFields>;
  varSamp?: Maybe<JobsFullyPaidInvoicedAmountVarSampFields>;
  variance?: Maybe<JobsFullyPaidInvoicedAmountVarianceFields>;
};


/** aggregate fields of "jobs_fully_paid_invoiced_amount" */
export type JobsFullyPaidInvoicedAmountAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobsFullyPaidInvoicedAmountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type JobsFullyPaidInvoicedAmountAvgFields = {
  __typename?: 'JobsFullyPaidInvoicedAmountAvgFields';
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "jobs_fully_paid_invoiced_amount". All fields are combined with a logical 'AND'. */
export type JobsFullyPaidInvoicedAmountBoolExp = {
  _and?: InputMaybe<Array<JobsFullyPaidInvoicedAmountBoolExp>>;
  _not?: InputMaybe<JobsFullyPaidInvoicedAmountBoolExp>;
  _or?: InputMaybe<Array<JobsFullyPaidInvoicedAmountBoolExp>>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  totalInvoicedAmountUsd?: InputMaybe<NumericComparisonExp>;
};

/** aggregate max on columns */
export type JobsFullyPaidInvoicedAmountMaxFields = {
  __typename?: 'JobsFullyPaidInvoicedAmountMaxFields';
  jobGuid?: Maybe<Scalars['uuid']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type JobsFullyPaidInvoicedAmountMinFields = {
  __typename?: 'JobsFullyPaidInvoicedAmountMinFields';
  jobGuid?: Maybe<Scalars['uuid']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "jobs_fully_paid_invoiced_amount". */
export type JobsFullyPaidInvoicedAmountOrderBy = {
  jobGuid?: InputMaybe<OrderBy>;
  totalInvoicedAmountUsd?: InputMaybe<OrderBy>;
};

/** select columns of table "jobs_fully_paid_invoiced_amount" */
export type JobsFullyPaidInvoicedAmountSelectColumn =
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'totalInvoicedAmountUsd';

/** aggregate stddev on columns */
export type JobsFullyPaidInvoicedAmountStddevFields = {
  __typename?: 'JobsFullyPaidInvoicedAmountStddevFields';
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type JobsFullyPaidInvoicedAmountStddevPopFields = {
  __typename?: 'JobsFullyPaidInvoicedAmountStddevPopFields';
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type JobsFullyPaidInvoicedAmountStddevSampFields = {
  __typename?: 'JobsFullyPaidInvoicedAmountStddevSampFields';
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "jobs_fully_paid_invoiced_amount" */
export type JobsFullyPaidInvoicedAmountStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobsFullyPaidInvoicedAmountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobsFullyPaidInvoicedAmountStreamCursorValueInput = {
  jobGuid?: InputMaybe<Scalars['uuid']>;
  totalInvoicedAmountUsd?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type JobsFullyPaidInvoicedAmountSumFields = {
  __typename?: 'JobsFullyPaidInvoicedAmountSumFields';
  totalInvoicedAmountUsd?: Maybe<Scalars['numeric']>;
};

/** aggregate varPop on columns */
export type JobsFullyPaidInvoicedAmountVarPopFields = {
  __typename?: 'JobsFullyPaidInvoicedAmountVarPopFields';
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type JobsFullyPaidInvoicedAmountVarSampFields = {
  __typename?: 'JobsFullyPaidInvoicedAmountVarSampFields';
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type JobsFullyPaidInvoicedAmountVarianceFields = {
  __typename?: 'JobsFullyPaidInvoicedAmountVarianceFields';
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "jobs_fully_paid_invoices_summary" */
export type JobsFullyPaidInvoicesSummary = {
  __typename?: 'JobsFullyPaidInvoicesSummary';
  jobGuid?: Maybe<Scalars['uuid']>;
  totalDiscountedAmountUsd?: Maybe<Scalars['numeric']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['numeric']>;
  totalPaidAmountUsd?: Maybe<Scalars['numeric']>;
  totalSubtotalAmountUsd?: Maybe<Scalars['numeric']>;
  totalTaxAmountUsd?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "jobs_fully_paid_invoices_summary" */
export type JobsFullyPaidInvoicesSummaryAggregate = {
  __typename?: 'JobsFullyPaidInvoicesSummaryAggregate';
  aggregate?: Maybe<JobsFullyPaidInvoicesSummaryAggregateFields>;
  nodes: Array<JobsFullyPaidInvoicesSummary>;
};

/** aggregate fields of "jobs_fully_paid_invoices_summary" */
export type JobsFullyPaidInvoicesSummaryAggregateFields = {
  __typename?: 'JobsFullyPaidInvoicesSummaryAggregateFields';
  avg?: Maybe<JobsFullyPaidInvoicesSummaryAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobsFullyPaidInvoicesSummaryMaxFields>;
  min?: Maybe<JobsFullyPaidInvoicesSummaryMinFields>;
  stddev?: Maybe<JobsFullyPaidInvoicesSummaryStddevFields>;
  stddevPop?: Maybe<JobsFullyPaidInvoicesSummaryStddevPopFields>;
  stddevSamp?: Maybe<JobsFullyPaidInvoicesSummaryStddevSampFields>;
  sum?: Maybe<JobsFullyPaidInvoicesSummarySumFields>;
  varPop?: Maybe<JobsFullyPaidInvoicesSummaryVarPopFields>;
  varSamp?: Maybe<JobsFullyPaidInvoicesSummaryVarSampFields>;
  variance?: Maybe<JobsFullyPaidInvoicesSummaryVarianceFields>;
};


/** aggregate fields of "jobs_fully_paid_invoices_summary" */
export type JobsFullyPaidInvoicesSummaryAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobsFullyPaidInvoicesSummarySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type JobsFullyPaidInvoicesSummaryAvgFields = {
  __typename?: 'JobsFullyPaidInvoicesSummaryAvgFields';
  totalDiscountedAmountUsd?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsd?: Maybe<Scalars['Float']>;
  totalTaxAmountUsd?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "jobs_fully_paid_invoices_summary". All fields are combined with a logical 'AND'. */
export type JobsFullyPaidInvoicesSummaryBoolExp = {
  _and?: InputMaybe<Array<JobsFullyPaidInvoicesSummaryBoolExp>>;
  _not?: InputMaybe<JobsFullyPaidInvoicesSummaryBoolExp>;
  _or?: InputMaybe<Array<JobsFullyPaidInvoicesSummaryBoolExp>>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  totalDiscountedAmountUsd?: InputMaybe<NumericComparisonExp>;
  totalInvoicedAmountUsd?: InputMaybe<NumericComparisonExp>;
  totalPaidAmountUsd?: InputMaybe<NumericComparisonExp>;
  totalSubtotalAmountUsd?: InputMaybe<NumericComparisonExp>;
  totalTaxAmountUsd?: InputMaybe<NumericComparisonExp>;
};

/** input type for inserting data into table "jobs_fully_paid_invoices_summary" */
export type JobsFullyPaidInvoicesSummaryInsertInput = {
  jobGuid?: InputMaybe<Scalars['uuid']>;
  totalDiscountedAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalInvoicedAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalPaidAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalSubtotalAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalTaxAmountUsd?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type JobsFullyPaidInvoicesSummaryMaxFields = {
  __typename?: 'JobsFullyPaidInvoicesSummaryMaxFields';
  jobGuid?: Maybe<Scalars['uuid']>;
  totalDiscountedAmountUsd?: Maybe<Scalars['numeric']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['numeric']>;
  totalPaidAmountUsd?: Maybe<Scalars['numeric']>;
  totalSubtotalAmountUsd?: Maybe<Scalars['numeric']>;
  totalTaxAmountUsd?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type JobsFullyPaidInvoicesSummaryMinFields = {
  __typename?: 'JobsFullyPaidInvoicesSummaryMinFields';
  jobGuid?: Maybe<Scalars['uuid']>;
  totalDiscountedAmountUsd?: Maybe<Scalars['numeric']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['numeric']>;
  totalPaidAmountUsd?: Maybe<Scalars['numeric']>;
  totalSubtotalAmountUsd?: Maybe<Scalars['numeric']>;
  totalTaxAmountUsd?: Maybe<Scalars['numeric']>;
};

/** input type for inserting object relation for remote table "jobs_fully_paid_invoices_summary" */
export type JobsFullyPaidInvoicesSummaryObjRelInsertInput = {
  data: JobsFullyPaidInvoicesSummaryInsertInput;
};

/** Ordering options when selecting data from "jobs_fully_paid_invoices_summary". */
export type JobsFullyPaidInvoicesSummaryOrderBy = {
  jobGuid?: InputMaybe<OrderBy>;
  totalDiscountedAmountUsd?: InputMaybe<OrderBy>;
  totalInvoicedAmountUsd?: InputMaybe<OrderBy>;
  totalPaidAmountUsd?: InputMaybe<OrderBy>;
  totalSubtotalAmountUsd?: InputMaybe<OrderBy>;
  totalTaxAmountUsd?: InputMaybe<OrderBy>;
};

/** select columns of table "jobs_fully_paid_invoices_summary" */
export type JobsFullyPaidInvoicesSummarySelectColumn =
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'totalDiscountedAmountUsd'
  /** column name */
  | 'totalInvoicedAmountUsd'
  /** column name */
  | 'totalPaidAmountUsd'
  /** column name */
  | 'totalSubtotalAmountUsd'
  /** column name */
  | 'totalTaxAmountUsd';

/** aggregate stddev on columns */
export type JobsFullyPaidInvoicesSummaryStddevFields = {
  __typename?: 'JobsFullyPaidInvoicesSummaryStddevFields';
  totalDiscountedAmountUsd?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsd?: Maybe<Scalars['Float']>;
  totalTaxAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type JobsFullyPaidInvoicesSummaryStddevPopFields = {
  __typename?: 'JobsFullyPaidInvoicesSummaryStddevPopFields';
  totalDiscountedAmountUsd?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsd?: Maybe<Scalars['Float']>;
  totalTaxAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type JobsFullyPaidInvoicesSummaryStddevSampFields = {
  __typename?: 'JobsFullyPaidInvoicesSummaryStddevSampFields';
  totalDiscountedAmountUsd?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsd?: Maybe<Scalars['Float']>;
  totalTaxAmountUsd?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "jobs_fully_paid_invoices_summary" */
export type JobsFullyPaidInvoicesSummaryStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobsFullyPaidInvoicesSummaryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobsFullyPaidInvoicesSummaryStreamCursorValueInput = {
  jobGuid?: InputMaybe<Scalars['uuid']>;
  totalDiscountedAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalInvoicedAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalPaidAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalSubtotalAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalTaxAmountUsd?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type JobsFullyPaidInvoicesSummarySumFields = {
  __typename?: 'JobsFullyPaidInvoicesSummarySumFields';
  totalDiscountedAmountUsd?: Maybe<Scalars['numeric']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['numeric']>;
  totalPaidAmountUsd?: Maybe<Scalars['numeric']>;
  totalSubtotalAmountUsd?: Maybe<Scalars['numeric']>;
  totalTaxAmountUsd?: Maybe<Scalars['numeric']>;
};

/** aggregate varPop on columns */
export type JobsFullyPaidInvoicesSummaryVarPopFields = {
  __typename?: 'JobsFullyPaidInvoicesSummaryVarPopFields';
  totalDiscountedAmountUsd?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsd?: Maybe<Scalars['Float']>;
  totalTaxAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type JobsFullyPaidInvoicesSummaryVarSampFields = {
  __typename?: 'JobsFullyPaidInvoicesSummaryVarSampFields';
  totalDiscountedAmountUsd?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsd?: Maybe<Scalars['Float']>;
  totalTaxAmountUsd?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type JobsFullyPaidInvoicesSummaryVarianceFields = {
  __typename?: 'JobsFullyPaidInvoicesSummaryVarianceFields';
  totalDiscountedAmountUsd?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsd?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsd?: Maybe<Scalars['Float']>;
  totalTaxAmountUsd?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "jobs_fully_paid_invoices_v2_summary" */
export type JobsFullyPaidInvoicesV2Summary = {
  __typename?: 'JobsFullyPaidInvoicesV2Summary';
  jobGuid?: Maybe<Scalars['uuid']>;
  totalDiscountAmountUsc?: Maybe<Scalars['numeric']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['bigint']>;
  totalPaidAmountUsd?: Maybe<Scalars['numeric']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['bigint']>;
  totalTaxAmountUsc?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "jobs_fully_paid_invoices_v2_summary" */
export type JobsFullyPaidInvoicesV2SummaryAggregate = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryAggregate';
  aggregate?: Maybe<JobsFullyPaidInvoicesV2SummaryAggregateFields>;
  nodes: Array<JobsFullyPaidInvoicesV2Summary>;
};

/** aggregate fields of "jobs_fully_paid_invoices_v2_summary" */
export type JobsFullyPaidInvoicesV2SummaryAggregateFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryAggregateFields';
  avg?: Maybe<JobsFullyPaidInvoicesV2SummaryAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobsFullyPaidInvoicesV2SummaryMaxFields>;
  min?: Maybe<JobsFullyPaidInvoicesV2SummaryMinFields>;
  stddev?: Maybe<JobsFullyPaidInvoicesV2SummaryStddevFields>;
  stddevPop?: Maybe<JobsFullyPaidInvoicesV2SummaryStddevPopFields>;
  stddevSamp?: Maybe<JobsFullyPaidInvoicesV2SummaryStddevSampFields>;
  sum?: Maybe<JobsFullyPaidInvoicesV2SummarySumFields>;
  varPop?: Maybe<JobsFullyPaidInvoicesV2SummaryVarPopFields>;
  varSamp?: Maybe<JobsFullyPaidInvoicesV2SummaryVarSampFields>;
  variance?: Maybe<JobsFullyPaidInvoicesV2SummaryVarianceFields>;
};


/** aggregate fields of "jobs_fully_paid_invoices_v2_summary" */
export type JobsFullyPaidInvoicesV2SummaryAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummarySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type JobsFullyPaidInvoicesV2SummaryAvgFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryAvgFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "jobs_fully_paid_invoices_v2_summary". All fields are combined with a logical 'AND'. */
export type JobsFullyPaidInvoicesV2SummaryBoolExp = {
  _and?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryBoolExp>>;
  _not?: InputMaybe<JobsFullyPaidInvoicesV2SummaryBoolExp>;
  _or?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryBoolExp>>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  totalDiscountAmountUsc?: InputMaybe<NumericComparisonExp>;
  totalInvoicedAmountUsc?: InputMaybe<BigintComparisonExp>;
  totalPaidAmountUsd?: InputMaybe<NumericComparisonExp>;
  totalSubtotalAmountUsc?: InputMaybe<BigintComparisonExp>;
  totalTaxAmountUsc?: InputMaybe<BigintComparisonExp>;
};

/** input type for inserting data into table "jobs_fully_paid_invoices_v2_summary" */
export type JobsFullyPaidInvoicesV2SummaryInsertInput = {
  jobGuid?: InputMaybe<Scalars['uuid']>;
  totalDiscountAmountUsc?: InputMaybe<Scalars['numeric']>;
  totalInvoicedAmountUsc?: InputMaybe<Scalars['bigint']>;
  totalPaidAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalSubtotalAmountUsc?: InputMaybe<Scalars['bigint']>;
  totalTaxAmountUsc?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type JobsFullyPaidInvoicesV2SummaryMaxFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMaxFields';
  jobGuid?: Maybe<Scalars['uuid']>;
  totalDiscountAmountUsc?: Maybe<Scalars['numeric']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['bigint']>;
  totalPaidAmountUsd?: Maybe<Scalars['numeric']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['bigint']>;
  totalTaxAmountUsc?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type JobsFullyPaidInvoicesV2SummaryMinFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMinFields';
  jobGuid?: Maybe<Scalars['uuid']>;
  totalDiscountAmountUsc?: Maybe<Scalars['numeric']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['bigint']>;
  totalPaidAmountUsd?: Maybe<Scalars['numeric']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['bigint']>;
  totalTaxAmountUsc?: Maybe<Scalars['bigint']>;
};

/** columns and relationships of "jobs_fully_paid_invoices_v2_summary_mv" */
export type JobsFullyPaidInvoicesV2SummaryMv = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMv';
  jobGuid?: Maybe<Scalars['uuid']>;
  totalDiscountAmountUsc?: Maybe<Scalars['numeric']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['bigint']>;
  totalPaidAmountUsd?: Maybe<Scalars['numeric']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['bigint']>;
  totalTaxAmountUsc?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "jobs_fully_paid_invoices_v2_summary_mv" */
export type JobsFullyPaidInvoicesV2SummaryMvAggregate = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMvAggregate';
  aggregate?: Maybe<JobsFullyPaidInvoicesV2SummaryMvAggregateFields>;
  nodes: Array<JobsFullyPaidInvoicesV2SummaryMv>;
};

/** aggregate fields of "jobs_fully_paid_invoices_v2_summary_mv" */
export type JobsFullyPaidInvoicesV2SummaryMvAggregateFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMvAggregateFields';
  avg?: Maybe<JobsFullyPaidInvoicesV2SummaryMvAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobsFullyPaidInvoicesV2SummaryMvMaxFields>;
  min?: Maybe<JobsFullyPaidInvoicesV2SummaryMvMinFields>;
  stddev?: Maybe<JobsFullyPaidInvoicesV2SummaryMvStddevFields>;
  stddevPop?: Maybe<JobsFullyPaidInvoicesV2SummaryMvStddevPopFields>;
  stddevSamp?: Maybe<JobsFullyPaidInvoicesV2SummaryMvStddevSampFields>;
  sum?: Maybe<JobsFullyPaidInvoicesV2SummaryMvSumFields>;
  varPop?: Maybe<JobsFullyPaidInvoicesV2SummaryMvVarPopFields>;
  varSamp?: Maybe<JobsFullyPaidInvoicesV2SummaryMvVarSampFields>;
  variance?: Maybe<JobsFullyPaidInvoicesV2SummaryMvVarianceFields>;
};


/** aggregate fields of "jobs_fully_paid_invoices_v2_summary_mv" */
export type JobsFullyPaidInvoicesV2SummaryMvAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryMvSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type JobsFullyPaidInvoicesV2SummaryMvAvgFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMvAvgFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "jobs_fully_paid_invoices_v2_summary_mv". All fields are combined with a logical 'AND'. */
export type JobsFullyPaidInvoicesV2SummaryMvBoolExp = {
  _and?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryMvBoolExp>>;
  _not?: InputMaybe<JobsFullyPaidInvoicesV2SummaryMvBoolExp>;
  _or?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryMvBoolExp>>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  totalDiscountAmountUsc?: InputMaybe<NumericComparisonExp>;
  totalInvoicedAmountUsc?: InputMaybe<BigintComparisonExp>;
  totalPaidAmountUsd?: InputMaybe<NumericComparisonExp>;
  totalSubtotalAmountUsc?: InputMaybe<BigintComparisonExp>;
  totalTaxAmountUsc?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type JobsFullyPaidInvoicesV2SummaryMvMaxFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMvMaxFields';
  jobGuid?: Maybe<Scalars['uuid']>;
  totalDiscountAmountUsc?: Maybe<Scalars['numeric']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['bigint']>;
  totalPaidAmountUsd?: Maybe<Scalars['numeric']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['bigint']>;
  totalTaxAmountUsc?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type JobsFullyPaidInvoicesV2SummaryMvMinFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMvMinFields';
  jobGuid?: Maybe<Scalars['uuid']>;
  totalDiscountAmountUsc?: Maybe<Scalars['numeric']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['bigint']>;
  totalPaidAmountUsd?: Maybe<Scalars['numeric']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['bigint']>;
  totalTaxAmountUsc?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "jobs_fully_paid_invoices_v2_summary_mv". */
export type JobsFullyPaidInvoicesV2SummaryMvOrderBy = {
  jobGuid?: InputMaybe<OrderBy>;
  totalDiscountAmountUsc?: InputMaybe<OrderBy>;
  totalInvoicedAmountUsc?: InputMaybe<OrderBy>;
  totalPaidAmountUsd?: InputMaybe<OrderBy>;
  totalSubtotalAmountUsc?: InputMaybe<OrderBy>;
  totalTaxAmountUsc?: InputMaybe<OrderBy>;
};

/** select columns of table "jobs_fully_paid_invoices_v2_summary_mv" */
export type JobsFullyPaidInvoicesV2SummaryMvSelectColumn =
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'totalDiscountAmountUsc'
  /** column name */
  | 'totalInvoicedAmountUsc'
  /** column name */
  | 'totalPaidAmountUsd'
  /** column name */
  | 'totalSubtotalAmountUsc'
  /** column name */
  | 'totalTaxAmountUsc';

/** aggregate stddev on columns */
export type JobsFullyPaidInvoicesV2SummaryMvStddevFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMvStddevFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type JobsFullyPaidInvoicesV2SummaryMvStddevPopFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMvStddevPopFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type JobsFullyPaidInvoicesV2SummaryMvStddevSampFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMvStddevSampFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "jobs_fully_paid_invoices_v2_summary_mv" */
export type JobsFullyPaidInvoicesV2SummaryMvStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobsFullyPaidInvoicesV2SummaryMvStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobsFullyPaidInvoicesV2SummaryMvStreamCursorValueInput = {
  jobGuid?: InputMaybe<Scalars['uuid']>;
  totalDiscountAmountUsc?: InputMaybe<Scalars['numeric']>;
  totalInvoicedAmountUsc?: InputMaybe<Scalars['bigint']>;
  totalPaidAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalSubtotalAmountUsc?: InputMaybe<Scalars['bigint']>;
  totalTaxAmountUsc?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JobsFullyPaidInvoicesV2SummaryMvSumFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMvSumFields';
  totalDiscountAmountUsc?: Maybe<Scalars['numeric']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['bigint']>;
  totalPaidAmountUsd?: Maybe<Scalars['numeric']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['bigint']>;
  totalTaxAmountUsc?: Maybe<Scalars['bigint']>;
};

/** aggregate varPop on columns */
export type JobsFullyPaidInvoicesV2SummaryMvVarPopFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMvVarPopFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type JobsFullyPaidInvoicesV2SummaryMvVarSampFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMvVarSampFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type JobsFullyPaidInvoicesV2SummaryMvVarianceFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryMvVarianceFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** input type for inserting object relation for remote table "jobs_fully_paid_invoices_v2_summary" */
export type JobsFullyPaidInvoicesV2SummaryObjRelInsertInput = {
  data: JobsFullyPaidInvoicesV2SummaryInsertInput;
};

/** Ordering options when selecting data from "jobs_fully_paid_invoices_v2_summary". */
export type JobsFullyPaidInvoicesV2SummaryOrderBy = {
  jobGuid?: InputMaybe<OrderBy>;
  totalDiscountAmountUsc?: InputMaybe<OrderBy>;
  totalInvoicedAmountUsc?: InputMaybe<OrderBy>;
  totalPaidAmountUsd?: InputMaybe<OrderBy>;
  totalSubtotalAmountUsc?: InputMaybe<OrderBy>;
  totalTaxAmountUsc?: InputMaybe<OrderBy>;
};

/** select columns of table "jobs_fully_paid_invoices_v2_summary" */
export type JobsFullyPaidInvoicesV2SummarySelectColumn =
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'totalDiscountAmountUsc'
  /** column name */
  | 'totalInvoicedAmountUsc'
  /** column name */
  | 'totalPaidAmountUsd'
  /** column name */
  | 'totalSubtotalAmountUsc'
  /** column name */
  | 'totalTaxAmountUsc';

/** aggregate stddev on columns */
export type JobsFullyPaidInvoicesV2SummaryStddevFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryStddevFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type JobsFullyPaidInvoicesV2SummaryStddevPopFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryStddevPopFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type JobsFullyPaidInvoicesV2SummaryStddevSampFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryStddevSampFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "jobs_fully_paid_invoices_v2_summary" */
export type JobsFullyPaidInvoicesV2SummaryStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobsFullyPaidInvoicesV2SummaryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobsFullyPaidInvoicesV2SummaryStreamCursorValueInput = {
  jobGuid?: InputMaybe<Scalars['uuid']>;
  totalDiscountAmountUsc?: InputMaybe<Scalars['numeric']>;
  totalInvoicedAmountUsc?: InputMaybe<Scalars['bigint']>;
  totalPaidAmountUsd?: InputMaybe<Scalars['numeric']>;
  totalSubtotalAmountUsc?: InputMaybe<Scalars['bigint']>;
  totalTaxAmountUsc?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JobsFullyPaidInvoicesV2SummarySumFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummarySumFields';
  totalDiscountAmountUsc?: Maybe<Scalars['numeric']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['bigint']>;
  totalPaidAmountUsd?: Maybe<Scalars['numeric']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['bigint']>;
  totalTaxAmountUsc?: Maybe<Scalars['bigint']>;
};

/** aggregate varPop on columns */
export type JobsFullyPaidInvoicesV2SummaryVarPopFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryVarPopFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type JobsFullyPaidInvoicesV2SummaryVarSampFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryVarSampFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type JobsFullyPaidInvoicesV2SummaryVarianceFields = {
  __typename?: 'JobsFullyPaidInvoicesV2SummaryVarianceFields';
  totalDiscountAmountUsc?: Maybe<Scalars['Float']>;
  totalInvoicedAmountUsc?: Maybe<Scalars['Float']>;
  totalPaidAmountUsd?: Maybe<Scalars['Float']>;
  totalSubtotalAmountUsc?: Maybe<Scalars['Float']>;
  totalTaxAmountUsc?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "jobs" */
export type JobsIncInput = {
  commissionJobCostsDeductionRate?: InputMaybe<Scalars['numeric']>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
  commissionOverheadDeductionRate?: InputMaybe<Scalars['numeric']>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
  displayId?: InputMaybe<Scalars['bigint']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "jobs" */
export type JobsInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  activityItems?: InputMaybe<ActivityItemsArrRelInsertInput>;
  appointments?: InputMaybe<JobAppointmentsArrRelInsertInput>;
  businessUnit?: InputMaybe<BusinessUnitsObjRelInsertInput>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  commissionJobCostsDeductionRate?: InputMaybe<Scalars['numeric']>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
  commissionOverheadDeductionRate?: InputMaybe<Scalars['numeric']>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  customerPurchaseOrderNumber?: InputMaybe<Scalars['String']>;
  displayId?: InputMaybe<Scalars['bigint']>;
  equipmentTypeJobLinks?: InputMaybe<EquipmentTypeLinksArrRelInsertInput>;
  estimates?: InputMaybe<EstimatesArrRelInsertInput>;
  fileLinks?: InputMaybe<FileLinksArrRelInsertInput>;
  installProjectType?: InputMaybe<Scalars['String']>;
  instantBookingAt?: InputMaybe<Scalars['timestamptz']>;
  integratedPhoneCallJobs?: InputMaybe<IntegratedPhoneCallJobsArrRelInsertInput>;
  invoicesQueryables?: InputMaybe<InvoicesQueryableArrRelInsertInput>;
  isConverted?: InputMaybe<Scalars['Boolean']>;
  isHotLead?: InputMaybe<Scalars['Boolean']>;
  isMembershipOpportunity?: InputMaybe<Scalars['Boolean']>;
  isMembershipRenewalOpportunity?: InputMaybe<Scalars['Boolean']>;
  isMembershipSold?: InputMaybe<Scalars['Boolean']>;
  isOpportunity?: InputMaybe<Scalars['Boolean']>;
  jobAppointmentAssignments?: InputMaybe<JobAppointmentAssignmentsArrRelInsertInput>;
  /** Whether job is part of job costing workflow. NOT_TRACKED=excluded, TRACKED=included. */
  jobCostingTrackingStatus?: InputMaybe<Scalars['String']>;
  /** Verification state for job costing. UNVERIFIED=needs review, VERIFIED=confirmed. */
  jobCostingVerificationStatus?: InputMaybe<Scalars['String']>;
  jobFullyPaidInvoicesSummary?: InputMaybe<JobsFullyPaidInvoicesSummaryObjRelInsertInput>;
  jobFullyPaidInvoicesV2Summary?: InputMaybe<JobsFullyPaidInvoicesV2SummaryObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobInvoices?: InputMaybe<JobInvoicesArrRelInsertInput>;
  jobLeadSource?: InputMaybe<CompanyLeadSourceLinksArrRelInsertInput>;
  jobLifecycleStatus?: InputMaybe<JobLifecycleStatusesObjRelInsertInput>;
  /** Records when the job is first transitioned to a Closed lifecycle status */
  jobLifecycleStatusClosedAt?: InputMaybe<Scalars['timestamptz']>;
  jobLifecycleStatusGuid?: InputMaybe<Scalars['uuid']>;
  jobLifecycleStatusUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  jobMaxCommissionableBase?: InputMaybe<JobsMaxCommissionableBaseObjRelInsertInput>;
  jobTeamMembers?: InputMaybe<JobTeamMembersArrRelInsertInput>;
  jobTechnicianEarnedRevenueAttributions?: InputMaybe<JobTechnicianEarnedRevenueAttributionsArrRelInsertInput>;
  jobTechnicianEarnedRevenueSummaries?: InputMaybe<JobTechnicianEarnedRevenueSummariesArrRelInsertInput>;
  jobTechnicianSalesCommissionsAndBonuses?: InputMaybe<JobTechnicianSalesCommissionAndBonusArrRelInsertInput>;
  jobTechnicianSoldRevenueAttributions?: InputMaybe<JobTechnicianSoldRevenueAttributionsArrRelInsertInput>;
  jobTechnicianSoldRevenueSummaries?: InputMaybe<JobTechnicianSoldRevenueSummariesArrRelInsertInput>;
  jobType?: InputMaybe<JobTypesObjRelInsertInput>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  linkedAppointmentChecklistInstances?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesArrRelInsertInput>;
  linkedJobEstimates?: InputMaybe<JobsWithLinkedJobLinkedEstimatesArrRelInsertInput>;
  linkedJobs?: InputMaybe<JobsWithLinkedJobArrRelInsertInput>;
  linkedMaintenancePlanVisit?: InputMaybe<MaintenancePlanVisitsObjRelInsertInput>;
  linkedToJobs?: InputMaybe<JobsWithLinkedJobArrRelInsertInput>;
  location?: InputMaybe<LocationsObjRelInsertInput>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableObjRelInsertInput>;
  maintenancePlanCreditUsedAt?: InputMaybe<Scalars['timestamptz']>;
  maintenancePlans?: InputMaybe<MaintenancePlansQueryableArrRelInsertInput>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<Scalars['Int']>;
  noteLinks?: InputMaybe<NoteLinksArrRelInsertInput>;
  paymentLinks?: InputMaybe<PaymentLinksArrRelInsertInput>;
  photoLinks?: InputMaybe<PhotoLinksArrRelInsertInput>;
  photos?: InputMaybe<PhotoLinksArrRelInsertInput>;
  pointOfContact?: InputMaybe<ContactsObjRelInsertInput>;
  pointOfContactGuid?: InputMaybe<Scalars['uuid']>;
  purchaseOrders?: InputMaybe<PurchaseOrdersArrRelInsertInput>;
  summary?: InputMaybe<Scalars['String']>;
  summaryHtml?: InputMaybe<Scalars['HtmlString']>;
  tags?: InputMaybe<JobTagsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  useMaintenancePlanCredit?: InputMaybe<Scalars['Boolean']>;
  workCompletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "jobs_max_commissionable_base" */
export type JobsMaxCommissionableBase = {
  __typename?: 'JobsMaxCommissionableBase';
  jobCostsDeductionUsc?: Maybe<Scalars['numeric']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  maxCommissionableBaseUsc?: Maybe<Scalars['numeric']>;
  overheadDeductionUsc?: Maybe<Scalars['numeric']>;
  totalSoldRevenueUsc?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "jobs_max_commissionable_base" */
export type JobsMaxCommissionableBaseAggregate = {
  __typename?: 'JobsMaxCommissionableBaseAggregate';
  aggregate?: Maybe<JobsMaxCommissionableBaseAggregateFields>;
  nodes: Array<JobsMaxCommissionableBase>;
};

/** aggregate fields of "jobs_max_commissionable_base" */
export type JobsMaxCommissionableBaseAggregateFields = {
  __typename?: 'JobsMaxCommissionableBaseAggregateFields';
  avg?: Maybe<JobsMaxCommissionableBaseAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<JobsMaxCommissionableBaseMaxFields>;
  min?: Maybe<JobsMaxCommissionableBaseMinFields>;
  stddev?: Maybe<JobsMaxCommissionableBaseStddevFields>;
  stddevPop?: Maybe<JobsMaxCommissionableBaseStddevPopFields>;
  stddevSamp?: Maybe<JobsMaxCommissionableBaseStddevSampFields>;
  sum?: Maybe<JobsMaxCommissionableBaseSumFields>;
  varPop?: Maybe<JobsMaxCommissionableBaseVarPopFields>;
  varSamp?: Maybe<JobsMaxCommissionableBaseVarSampFields>;
  variance?: Maybe<JobsMaxCommissionableBaseVarianceFields>;
};


/** aggregate fields of "jobs_max_commissionable_base" */
export type JobsMaxCommissionableBaseAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobsMaxCommissionableBaseSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type JobsMaxCommissionableBaseAvgFields = {
  __typename?: 'JobsMaxCommissionableBaseAvgFields';
  jobCostsDeductionUsc?: Maybe<Scalars['Float']>;
  maxCommissionableBaseUsc?: Maybe<Scalars['Float']>;
  overheadDeductionUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "jobs_max_commissionable_base". All fields are combined with a logical 'AND'. */
export type JobsMaxCommissionableBaseBoolExp = {
  _and?: InputMaybe<Array<JobsMaxCommissionableBaseBoolExp>>;
  _not?: InputMaybe<JobsMaxCommissionableBaseBoolExp>;
  _or?: InputMaybe<Array<JobsMaxCommissionableBaseBoolExp>>;
  jobCostsDeductionUsc?: InputMaybe<NumericComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  maxCommissionableBaseUsc?: InputMaybe<NumericComparisonExp>;
  overheadDeductionUsc?: InputMaybe<NumericComparisonExp>;
  totalSoldRevenueUsc?: InputMaybe<NumericComparisonExp>;
};

/** input type for inserting data into table "jobs_max_commissionable_base" */
export type JobsMaxCommissionableBaseInsertInput = {
  jobCostsDeductionUsc?: InputMaybe<Scalars['numeric']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  maxCommissionableBaseUsc?: InputMaybe<Scalars['numeric']>;
  overheadDeductionUsc?: InputMaybe<Scalars['numeric']>;
  totalSoldRevenueUsc?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type JobsMaxCommissionableBaseMaxFields = {
  __typename?: 'JobsMaxCommissionableBaseMaxFields';
  jobCostsDeductionUsc?: Maybe<Scalars['numeric']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  maxCommissionableBaseUsc?: Maybe<Scalars['numeric']>;
  overheadDeductionUsc?: Maybe<Scalars['numeric']>;
  totalSoldRevenueUsc?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type JobsMaxCommissionableBaseMinFields = {
  __typename?: 'JobsMaxCommissionableBaseMinFields';
  jobCostsDeductionUsc?: Maybe<Scalars['numeric']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  maxCommissionableBaseUsc?: Maybe<Scalars['numeric']>;
  overheadDeductionUsc?: Maybe<Scalars['numeric']>;
  totalSoldRevenueUsc?: Maybe<Scalars['numeric']>;
};

/** input type for inserting object relation for remote table "jobs_max_commissionable_base" */
export type JobsMaxCommissionableBaseObjRelInsertInput = {
  data: JobsMaxCommissionableBaseInsertInput;
};

/** Ordering options when selecting data from "jobs_max_commissionable_base". */
export type JobsMaxCommissionableBaseOrderBy = {
  jobCostsDeductionUsc?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  maxCommissionableBaseUsc?: InputMaybe<OrderBy>;
  overheadDeductionUsc?: InputMaybe<OrderBy>;
  totalSoldRevenueUsc?: InputMaybe<OrderBy>;
};

/** select columns of table "jobs_max_commissionable_base" */
export type JobsMaxCommissionableBaseSelectColumn =
  /** column name */
  | 'jobCostsDeductionUsc'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'maxCommissionableBaseUsc'
  /** column name */
  | 'overheadDeductionUsc'
  /** column name */
  | 'totalSoldRevenueUsc';

/** aggregate stddev on columns */
export type JobsMaxCommissionableBaseStddevFields = {
  __typename?: 'JobsMaxCommissionableBaseStddevFields';
  jobCostsDeductionUsc?: Maybe<Scalars['Float']>;
  maxCommissionableBaseUsc?: Maybe<Scalars['Float']>;
  overheadDeductionUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type JobsMaxCommissionableBaseStddevPopFields = {
  __typename?: 'JobsMaxCommissionableBaseStddevPopFields';
  jobCostsDeductionUsc?: Maybe<Scalars['Float']>;
  maxCommissionableBaseUsc?: Maybe<Scalars['Float']>;
  overheadDeductionUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type JobsMaxCommissionableBaseStddevSampFields = {
  __typename?: 'JobsMaxCommissionableBaseStddevSampFields';
  jobCostsDeductionUsc?: Maybe<Scalars['Float']>;
  maxCommissionableBaseUsc?: Maybe<Scalars['Float']>;
  overheadDeductionUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "jobs_max_commissionable_base" */
export type JobsMaxCommissionableBaseStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobsMaxCommissionableBaseStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobsMaxCommissionableBaseStreamCursorValueInput = {
  jobCostsDeductionUsc?: InputMaybe<Scalars['numeric']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  maxCommissionableBaseUsc?: InputMaybe<Scalars['numeric']>;
  overheadDeductionUsc?: InputMaybe<Scalars['numeric']>;
  totalSoldRevenueUsc?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type JobsMaxCommissionableBaseSumFields = {
  __typename?: 'JobsMaxCommissionableBaseSumFields';
  jobCostsDeductionUsc?: Maybe<Scalars['numeric']>;
  maxCommissionableBaseUsc?: Maybe<Scalars['numeric']>;
  overheadDeductionUsc?: Maybe<Scalars['numeric']>;
  totalSoldRevenueUsc?: Maybe<Scalars['numeric']>;
};

/** aggregate varPop on columns */
export type JobsMaxCommissionableBaseVarPopFields = {
  __typename?: 'JobsMaxCommissionableBaseVarPopFields';
  jobCostsDeductionUsc?: Maybe<Scalars['Float']>;
  maxCommissionableBaseUsc?: Maybe<Scalars['Float']>;
  overheadDeductionUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type JobsMaxCommissionableBaseVarSampFields = {
  __typename?: 'JobsMaxCommissionableBaseVarSampFields';
  jobCostsDeductionUsc?: Maybe<Scalars['Float']>;
  maxCommissionableBaseUsc?: Maybe<Scalars['Float']>;
  overheadDeductionUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type JobsMaxCommissionableBaseVarianceFields = {
  __typename?: 'JobsMaxCommissionableBaseVarianceFields';
  jobCostsDeductionUsc?: Maybe<Scalars['Float']>;
  maxCommissionableBaseUsc?: Maybe<Scalars['Float']>;
  overheadDeductionUsc?: Maybe<Scalars['Float']>;
  totalSoldRevenueUsc?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type JobsMaxFields = {
  __typename?: 'JobsMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  commissionJobCostsDeductionRate?: Maybe<Scalars['numeric']>;
  commissionJobCostsFlatDeductionUsc?: Maybe<Scalars['Int']>;
  commissionOverheadDeductionRate?: Maybe<Scalars['numeric']>;
  commissionOverheadFlatDeductionUsc?: Maybe<Scalars['Int']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  customerPurchaseOrderNumber?: Maybe<Scalars['String']>;
  displayId?: Maybe<Scalars['bigint']>;
  /** A computed field, executes function "jobs_display_id_as_text" */
  displayIdString?: Maybe<Scalars['String']>;
  installProjectType?: Maybe<Scalars['String']>;
  instantBookingAt?: Maybe<Scalars['timestamptz']>;
  /** Whether job is part of job costing workflow. NOT_TRACKED=excluded, TRACKED=included. */
  jobCostingTrackingStatus?: Maybe<Scalars['String']>;
  /** Verification state for job costing. UNVERIFIED=needs review, VERIFIED=confirmed. */
  jobCostingVerificationStatus?: Maybe<Scalars['String']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** Records when the job is first transitioned to a Closed lifecycle status */
  jobLifecycleStatusClosedAt?: Maybe<Scalars['timestamptz']>;
  jobLifecycleStatusGuid?: Maybe<Scalars['uuid']>;
  jobLifecycleStatusUpdatedAt?: Maybe<Scalars['timestamptz']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanCreditUsedAt?: Maybe<Scalars['timestamptz']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: Maybe<Scalars['Int']>;
  pointOfContactGuid?: Maybe<Scalars['uuid']>;
  revenueRecognizedAt?: Maybe<Scalars['timestamptz']>;
  summary?: Maybe<Scalars['String']>;
  summaryHtml?: Maybe<Scalars['HtmlString']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workCompletedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "jobs" */
export type JobsMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  commissionJobCostsDeductionRate?: InputMaybe<OrderBy>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  commissionOverheadDeductionRate?: InputMaybe<OrderBy>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  customerPurchaseOrderNumber?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  installProjectType?: InputMaybe<OrderBy>;
  instantBookingAt?: InputMaybe<OrderBy>;
  /** Whether job is part of job costing workflow. NOT_TRACKED=excluded, TRACKED=included. */
  jobCostingTrackingStatus?: InputMaybe<OrderBy>;
  /** Verification state for job costing. UNVERIFIED=needs review, VERIFIED=confirmed. */
  jobCostingVerificationStatus?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  /** Records when the job is first transitioned to a Closed lifecycle status */
  jobLifecycleStatusClosedAt?: InputMaybe<OrderBy>;
  jobLifecycleStatusGuid?: InputMaybe<OrderBy>;
  jobLifecycleStatusUpdatedAt?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlanCreditUsedAt?: InputMaybe<OrderBy>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<OrderBy>;
  pointOfContactGuid?: InputMaybe<OrderBy>;
  revenueRecognizedAt?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  summaryHtml?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workCompletedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobsMinFields = {
  __typename?: 'JobsMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  commissionJobCostsDeductionRate?: Maybe<Scalars['numeric']>;
  commissionJobCostsFlatDeductionUsc?: Maybe<Scalars['Int']>;
  commissionOverheadDeductionRate?: Maybe<Scalars['numeric']>;
  commissionOverheadFlatDeductionUsc?: Maybe<Scalars['Int']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  customerPurchaseOrderNumber?: Maybe<Scalars['String']>;
  displayId?: Maybe<Scalars['bigint']>;
  /** A computed field, executes function "jobs_display_id_as_text" */
  displayIdString?: Maybe<Scalars['String']>;
  installProjectType?: Maybe<Scalars['String']>;
  instantBookingAt?: Maybe<Scalars['timestamptz']>;
  /** Whether job is part of job costing workflow. NOT_TRACKED=excluded, TRACKED=included. */
  jobCostingTrackingStatus?: Maybe<Scalars['String']>;
  /** Verification state for job costing. UNVERIFIED=needs review, VERIFIED=confirmed. */
  jobCostingVerificationStatus?: Maybe<Scalars['String']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** Records when the job is first transitioned to a Closed lifecycle status */
  jobLifecycleStatusClosedAt?: Maybe<Scalars['timestamptz']>;
  jobLifecycleStatusGuid?: Maybe<Scalars['uuid']>;
  jobLifecycleStatusUpdatedAt?: Maybe<Scalars['timestamptz']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanCreditUsedAt?: Maybe<Scalars['timestamptz']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: Maybe<Scalars['Int']>;
  pointOfContactGuid?: Maybe<Scalars['uuid']>;
  revenueRecognizedAt?: Maybe<Scalars['timestamptz']>;
  summary?: Maybe<Scalars['String']>;
  summaryHtml?: Maybe<Scalars['HtmlString']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  workCompletedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "jobs" */
export type JobsMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  commissionJobCostsDeductionRate?: InputMaybe<OrderBy>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  commissionOverheadDeductionRate?: InputMaybe<OrderBy>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  customerPurchaseOrderNumber?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  installProjectType?: InputMaybe<OrderBy>;
  instantBookingAt?: InputMaybe<OrderBy>;
  /** Whether job is part of job costing workflow. NOT_TRACKED=excluded, TRACKED=included. */
  jobCostingTrackingStatus?: InputMaybe<OrderBy>;
  /** Verification state for job costing. UNVERIFIED=needs review, VERIFIED=confirmed. */
  jobCostingVerificationStatus?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  /** Records when the job is first transitioned to a Closed lifecycle status */
  jobLifecycleStatusClosedAt?: InputMaybe<OrderBy>;
  jobLifecycleStatusGuid?: InputMaybe<OrderBy>;
  jobLifecycleStatusUpdatedAt?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlanCreditUsedAt?: InputMaybe<OrderBy>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<OrderBy>;
  pointOfContactGuid?: InputMaybe<OrderBy>;
  revenueRecognizedAt?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  summaryHtml?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workCompletedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "jobs" */
export type JobsMutationResponse = {
  __typename?: 'JobsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Jobs>;
};

/** input type for inserting object relation for remote table "jobs" */
export type JobsObjRelInsertInput = {
  data: JobsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobsOnConflict>;
};

/** on_conflict condition type for table "jobs" */
export type JobsOnConflict = {
  constraint: JobsConstraint;
  updateColumns?: Array<JobsUpdateColumn>;
  where?: InputMaybe<JobsBoolExp>;
};

/** Ordering options when selecting data from "jobs". */
export type JobsOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  activityItemsAggregate?: InputMaybe<ActivityItemsAggregateOrderBy>;
  appointmentsAggregate?: InputMaybe<JobAppointmentsAggregateOrderBy>;
  businessUnit?: InputMaybe<BusinessUnitsOrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  commissionJobCostsDeductionRate?: InputMaybe<OrderBy>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  commissionOverheadDeductionRate?: InputMaybe<OrderBy>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  customerPurchaseOrderNumber?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  displayIdString?: InputMaybe<OrderBy>;
  equipmentTypeJobLinksAggregate?: InputMaybe<EquipmentTypeLinksAggregateOrderBy>;
  estimatesAggregate?: InputMaybe<EstimatesAggregateOrderBy>;
  fileLinksAggregate?: InputMaybe<FileLinksAggregateOrderBy>;
  installProjectType?: InputMaybe<OrderBy>;
  instantBookingAt?: InputMaybe<OrderBy>;
  integratedPhoneCallJobsAggregate?: InputMaybe<IntegratedPhoneCallJobsAggregateOrderBy>;
  invoicesQueryablesAggregate?: InputMaybe<InvoicesQueryableAggregateOrderBy>;
  isConverted?: InputMaybe<OrderBy>;
  isHotLead?: InputMaybe<OrderBy>;
  isMembershipOpportunity?: InputMaybe<OrderBy>;
  isMembershipRenewalOpportunity?: InputMaybe<OrderBy>;
  isMembershipSold?: InputMaybe<OrderBy>;
  isOpportunity?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentsAggregate?: InputMaybe<JobAppointmentAssignmentsAggregateOrderBy>;
  jobCostingTrackingStatus?: InputMaybe<OrderBy>;
  jobCostingVerificationStatus?: InputMaybe<OrderBy>;
  jobFullyPaidInvoicesSummary?: InputMaybe<JobsFullyPaidInvoicesSummaryOrderBy>;
  jobFullyPaidInvoicesV2Summary?: InputMaybe<JobsFullyPaidInvoicesV2SummaryOrderBy>;
  jobFullyPaidInvoicesV2SummaryMv?: InputMaybe<JobsFullyPaidInvoicesV2SummaryMvOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  jobInvoicesAggregate?: InputMaybe<JobInvoicesAggregateOrderBy>;
  jobLeadSourceAggregate?: InputMaybe<CompanyLeadSourceLinksAggregateOrderBy>;
  jobLifecycleStatus?: InputMaybe<JobLifecycleStatusesOrderBy>;
  jobLifecycleStatusClosedAt?: InputMaybe<OrderBy>;
  jobLifecycleStatusGuid?: InputMaybe<OrderBy>;
  jobLifecycleStatusUpdatedAt?: InputMaybe<OrderBy>;
  jobMaxCommissionableBase?: InputMaybe<JobsMaxCommissionableBaseOrderBy>;
  jobTeamMembersAggregate?: InputMaybe<JobTeamMembersAggregateOrderBy>;
  jobTechnicianEarnedRevenueAttributionsAggregate?: InputMaybe<JobTechnicianEarnedRevenueAttributionsAggregateOrderBy>;
  jobTechnicianEarnedRevenueSummariesAggregate?: InputMaybe<JobTechnicianEarnedRevenueSummariesAggregateOrderBy>;
  jobTechnicianSalesCommissionsAndBonusesAggregate?: InputMaybe<JobTechnicianSalesCommissionAndBonusAggregateOrderBy>;
  jobTechnicianSoldRevenueAttributionsAggregate?: InputMaybe<JobTechnicianSoldRevenueAttributionsAggregateOrderBy>;
  jobTechnicianSoldRevenueSummariesAggregate?: InputMaybe<JobTechnicianSoldRevenueSummariesAggregateOrderBy>;
  jobType?: InputMaybe<JobTypesOrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  linkedAppointmentChecklistInstancesAggregate?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregateOrderBy>;
  linkedJobEstimatesAggregate?: InputMaybe<JobsWithLinkedJobLinkedEstimatesAggregateOrderBy>;
  linkedJobInvoicesAggregate?: InputMaybe<JobsWithLinkedJobLinkedInvoicesAggregateOrderBy>;
  linkedJobsAggregate?: InputMaybe<JobsWithLinkedJobAggregateOrderBy>;
  linkedMaintenancePlanVisit?: InputMaybe<MaintenancePlanVisitsOrderBy>;
  linkedToJobsAggregate?: InputMaybe<JobsWithLinkedJobAggregateOrderBy>;
  location?: InputMaybe<LocationsOrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableOrderBy>;
  maintenancePlanCreditUsedAt?: InputMaybe<OrderBy>;
  maintenancePlansAggregate?: InputMaybe<MaintenancePlansQueryableAggregateOrderBy>;
  maximumCommissionableBaseUsc?: InputMaybe<OrderBy>;
  noteLinksAggregate?: InputMaybe<NoteLinksAggregateOrderBy>;
  paymentLinksAggregate?: InputMaybe<PaymentLinksAggregateOrderBy>;
  photoLinksAggregate?: InputMaybe<PhotoLinksAggregateOrderBy>;
  photosAggregate?: InputMaybe<PhotoLinksAggregateOrderBy>;
  pointOfContact?: InputMaybe<ContactsOrderBy>;
  pointOfContactGuid?: InputMaybe<OrderBy>;
  purchaseOrdersAggregate?: InputMaybe<PurchaseOrdersAggregateOrderBy>;
  revenueRecognizedAt?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  summaryHtml?: InputMaybe<OrderBy>;
  tagsAggregate?: InputMaybe<JobTagsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  useMaintenancePlanCredit?: InputMaybe<OrderBy>;
  workCompletedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: jobs */
export type JobsPkColumnsInput = {
  jobGuid: Scalars['uuid'];
};

/** select columns of table "jobs" */
export type JobsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'commissionJobCostsDeductionRate'
  /** column name */
  | 'commissionJobCostsFlatDeductionUsc'
  /** column name */
  | 'commissionOverheadDeductionRate'
  /** column name */
  | 'commissionOverheadFlatDeductionUsc'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'customerPurchaseOrderNumber'
  /** column name */
  | 'displayId'
  /** column name */
  | 'installProjectType'
  /** column name */
  | 'instantBookingAt'
  /** column name */
  | 'isConverted'
  /** column name */
  | 'isHotLead'
  /** column name */
  | 'isMembershipOpportunity'
  /** column name */
  | 'isMembershipRenewalOpportunity'
  /** column name */
  | 'isMembershipSold'
  /** column name */
  | 'isOpportunity'
  /** column name */
  | 'jobCostingTrackingStatus'
  /** column name */
  | 'jobCostingVerificationStatus'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'jobLifecycleStatusClosedAt'
  /** column name */
  | 'jobLifecycleStatusGuid'
  /** column name */
  | 'jobLifecycleStatusUpdatedAt'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'maintenancePlanCreditUsedAt'
  /** column name */
  | 'maximumCommissionableBaseUsc'
  /** column name */
  | 'pointOfContactGuid'
  /** column name */
  | 'revenueRecognizedAt'
  /** column name */
  | 'summary'
  /** column name */
  | 'summaryHtml'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'useMaintenancePlanCredit'
  /** column name */
  | 'workCompletedAt';

/** select "jobsAggregateBoolExpBool_andArgumentsColumns" columns of table "jobs" */
export type JobsSelectColumnJobsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isConverted'
  /** column name */
  | 'isHotLead'
  /** column name */
  | 'isMembershipOpportunity'
  /** column name */
  | 'isMembershipRenewalOpportunity'
  /** column name */
  | 'isMembershipSold'
  /** column name */
  | 'isOpportunity'
  /** column name */
  | 'useMaintenancePlanCredit';

/** select "jobsAggregateBoolExpBool_orArgumentsColumns" columns of table "jobs" */
export type JobsSelectColumnJobsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isConverted'
  /** column name */
  | 'isHotLead'
  /** column name */
  | 'isMembershipOpportunity'
  /** column name */
  | 'isMembershipRenewalOpportunity'
  /** column name */
  | 'isMembershipSold'
  /** column name */
  | 'isOpportunity'
  /** column name */
  | 'useMaintenancePlanCredit';

/** input type for updating data in table "jobs" */
export type JobsSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  commissionJobCostsDeductionRate?: InputMaybe<Scalars['numeric']>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
  commissionOverheadDeductionRate?: InputMaybe<Scalars['numeric']>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  customerPurchaseOrderNumber?: InputMaybe<Scalars['String']>;
  displayId?: InputMaybe<Scalars['bigint']>;
  installProjectType?: InputMaybe<Scalars['String']>;
  instantBookingAt?: InputMaybe<Scalars['timestamptz']>;
  isConverted?: InputMaybe<Scalars['Boolean']>;
  isHotLead?: InputMaybe<Scalars['Boolean']>;
  isMembershipOpportunity?: InputMaybe<Scalars['Boolean']>;
  isMembershipRenewalOpportunity?: InputMaybe<Scalars['Boolean']>;
  isMembershipSold?: InputMaybe<Scalars['Boolean']>;
  isOpportunity?: InputMaybe<Scalars['Boolean']>;
  /** Whether job is part of job costing workflow. NOT_TRACKED=excluded, TRACKED=included. */
  jobCostingTrackingStatus?: InputMaybe<Scalars['String']>;
  /** Verification state for job costing. UNVERIFIED=needs review, VERIFIED=confirmed. */
  jobCostingVerificationStatus?: InputMaybe<Scalars['String']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  /** Records when the job is first transitioned to a Closed lifecycle status */
  jobLifecycleStatusClosedAt?: InputMaybe<Scalars['timestamptz']>;
  jobLifecycleStatusGuid?: InputMaybe<Scalars['uuid']>;
  jobLifecycleStatusUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanCreditUsedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<Scalars['Int']>;
  pointOfContactGuid?: InputMaybe<Scalars['uuid']>;
  summary?: InputMaybe<Scalars['String']>;
  summaryHtml?: InputMaybe<Scalars['HtmlString']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  useMaintenancePlanCredit?: InputMaybe<Scalars['Boolean']>;
  workCompletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type JobsStddevFields = {
  __typename?: 'JobsStddevFields';
  commissionJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  commissionJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  commissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  commissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "jobs" */
export type JobsStddevOrderBy = {
  commissionJobCostsDeductionRate?: InputMaybe<OrderBy>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  commissionOverheadDeductionRate?: InputMaybe<OrderBy>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type JobsStddevPopFields = {
  __typename?: 'JobsStddevPopFields';
  commissionJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  commissionJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  commissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  commissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "jobs" */
export type JobsStddevPopOrderBy = {
  commissionJobCostsDeductionRate?: InputMaybe<OrderBy>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  commissionOverheadDeductionRate?: InputMaybe<OrderBy>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type JobsStddevSampFields = {
  __typename?: 'JobsStddevSampFields';
  commissionJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  commissionJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  commissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  commissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "jobs" */
export type JobsStddevSampOrderBy = {
  commissionJobCostsDeductionRate?: InputMaybe<OrderBy>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  commissionOverheadDeductionRate?: InputMaybe<OrderBy>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "jobs" */
export type JobsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  commissionJobCostsDeductionRate?: InputMaybe<Scalars['numeric']>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
  commissionOverheadDeductionRate?: InputMaybe<Scalars['numeric']>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<Scalars['Int']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  customerPurchaseOrderNumber?: InputMaybe<Scalars['String']>;
  displayId?: InputMaybe<Scalars['bigint']>;
  installProjectType?: InputMaybe<Scalars['String']>;
  instantBookingAt?: InputMaybe<Scalars['timestamptz']>;
  isConverted?: InputMaybe<Scalars['Boolean']>;
  isHotLead?: InputMaybe<Scalars['Boolean']>;
  isMembershipOpportunity?: InputMaybe<Scalars['Boolean']>;
  isMembershipRenewalOpportunity?: InputMaybe<Scalars['Boolean']>;
  isMembershipSold?: InputMaybe<Scalars['Boolean']>;
  isOpportunity?: InputMaybe<Scalars['Boolean']>;
  /** Whether job is part of job costing workflow. NOT_TRACKED=excluded, TRACKED=included. */
  jobCostingTrackingStatus?: InputMaybe<Scalars['String']>;
  /** Verification state for job costing. UNVERIFIED=needs review, VERIFIED=confirmed. */
  jobCostingVerificationStatus?: InputMaybe<Scalars['String']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  /** Records when the job is first transitioned to a Closed lifecycle status */
  jobLifecycleStatusClosedAt?: InputMaybe<Scalars['timestamptz']>;
  jobLifecycleStatusGuid?: InputMaybe<Scalars['uuid']>;
  jobLifecycleStatusUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanCreditUsedAt?: InputMaybe<Scalars['timestamptz']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<Scalars['Int']>;
  pointOfContactGuid?: InputMaybe<Scalars['uuid']>;
  revenueRecognizedAt?: InputMaybe<Scalars['timestamptz']>;
  summary?: InputMaybe<Scalars['String']>;
  summaryHtml?: InputMaybe<Scalars['HtmlString']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  useMaintenancePlanCredit?: InputMaybe<Scalars['Boolean']>;
  workCompletedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type JobsSumFields = {
  __typename?: 'JobsSumFields';
  commissionJobCostsDeductionRate?: Maybe<Scalars['numeric']>;
  commissionJobCostsFlatDeductionUsc?: Maybe<Scalars['Int']>;
  commissionOverheadDeductionRate?: Maybe<Scalars['numeric']>;
  commissionOverheadFlatDeductionUsc?: Maybe<Scalars['Int']>;
  displayId?: Maybe<Scalars['bigint']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "jobs" */
export type JobsSumOrderBy = {
  commissionJobCostsDeductionRate?: InputMaybe<OrderBy>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  commissionOverheadDeductionRate?: InputMaybe<OrderBy>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<OrderBy>;
};

/** update columns of table "jobs" */
export type JobsUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'commissionJobCostsDeductionRate'
  /** column name */
  | 'commissionJobCostsFlatDeductionUsc'
  /** column name */
  | 'commissionOverheadDeductionRate'
  /** column name */
  | 'commissionOverheadFlatDeductionUsc'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'customerPurchaseOrderNumber'
  /** column name */
  | 'displayId'
  /** column name */
  | 'installProjectType'
  /** column name */
  | 'instantBookingAt'
  /** column name */
  | 'isConverted'
  /** column name */
  | 'isHotLead'
  /** column name */
  | 'isMembershipOpportunity'
  /** column name */
  | 'isMembershipRenewalOpportunity'
  /** column name */
  | 'isMembershipSold'
  /** column name */
  | 'isOpportunity'
  /** column name */
  | 'jobCostingTrackingStatus'
  /** column name */
  | 'jobCostingVerificationStatus'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'jobLifecycleStatusClosedAt'
  /** column name */
  | 'jobLifecycleStatusGuid'
  /** column name */
  | 'jobLifecycleStatusUpdatedAt'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'maintenancePlanCreditUsedAt'
  /** column name */
  | 'maximumCommissionableBaseUsc'
  /** column name */
  | 'pointOfContactGuid'
  /** column name */
  | 'summary'
  /** column name */
  | 'summaryHtml'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'useMaintenancePlanCredit'
  /** column name */
  | 'workCompletedAt';

export type JobsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<JobsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobsSetInput>;
  /** filter the rows which have to be updated */
  where: JobsBoolExp;
};

/** aggregate varPop on columns */
export type JobsVarPopFields = {
  __typename?: 'JobsVarPopFields';
  commissionJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  commissionJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  commissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  commissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "jobs" */
export type JobsVarPopOrderBy = {
  commissionJobCostsDeductionRate?: InputMaybe<OrderBy>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  commissionOverheadDeductionRate?: InputMaybe<OrderBy>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type JobsVarSampFields = {
  __typename?: 'JobsVarSampFields';
  commissionJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  commissionJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  commissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  commissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "jobs" */
export type JobsVarSampOrderBy = {
  commissionJobCostsDeductionRate?: InputMaybe<OrderBy>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  commissionOverheadDeductionRate?: InputMaybe<OrderBy>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type JobsVarianceFields = {
  __typename?: 'JobsVarianceFields';
  commissionJobCostsDeductionRate?: Maybe<Scalars['Float']>;
  commissionJobCostsFlatDeductionUsc?: Maybe<Scalars['Float']>;
  commissionOverheadDeductionRate?: Maybe<Scalars['Float']>;
  commissionOverheadFlatDeductionUsc?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "jobs" */
export type JobsVarianceOrderBy = {
  commissionJobCostsDeductionRate?: InputMaybe<OrderBy>;
  commissionJobCostsFlatDeductionUsc?: InputMaybe<OrderBy>;
  commissionOverheadDeductionRate?: InputMaybe<OrderBy>;
  commissionOverheadFlatDeductionUsc?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  /** The maximum amount used to calculate sales commission for this job */
  maximumCommissionableBaseUsc?: InputMaybe<OrderBy>;
};

/** Jobs that are linked to a another Job */
export type JobsWithLinkedJob = {
  __typename?: 'JobsWithLinkedJob';
  /** An object relationship */
  job: Jobs;
  jobGuid: Scalars['uuid'];
  linkAttachments: Scalars['Boolean'];
  linkNotes: Scalars['Boolean'];
  linkPhotos: Scalars['Boolean'];
  linkedJobGuid: Scalars['uuid'];
  /** An object relationship */
  linked_job: Jobs;
};

/** aggregated selection of "jobs_with_linked_job" */
export type JobsWithLinkedJobAggregate = {
  __typename?: 'JobsWithLinkedJobAggregate';
  aggregate?: Maybe<JobsWithLinkedJobAggregateFields>;
  nodes: Array<JobsWithLinkedJob>;
};

export type JobsWithLinkedJobAggregateBoolExp = {
  bool_and?: InputMaybe<JobsWithLinkedJobAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<JobsWithLinkedJobAggregateBoolExpBool_Or>;
  count?: InputMaybe<JobsWithLinkedJobAggregateBoolExpCount>;
};

/** aggregate fields of "jobs_with_linked_job" */
export type JobsWithLinkedJobAggregateFields = {
  __typename?: 'JobsWithLinkedJobAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobsWithLinkedJobMaxFields>;
  min?: Maybe<JobsWithLinkedJobMinFields>;
};


/** aggregate fields of "jobs_with_linked_job" */
export type JobsWithLinkedJobAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobsWithLinkedJobSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "jobs_with_linked_job" */
export type JobsWithLinkedJobAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobsWithLinkedJobMaxOrderBy>;
  min?: InputMaybe<JobsWithLinkedJobMinOrderBy>;
};

/** input type for inserting array relation for remote table "jobs_with_linked_job" */
export type JobsWithLinkedJobArrRelInsertInput = {
  data: Array<JobsWithLinkedJobInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobsWithLinkedJobOnConflict>;
};

/** Boolean expression to filter rows from the table "jobs_with_linked_job". All fields are combined with a logical 'AND'. */
export type JobsWithLinkedJobBoolExp = {
  _and?: InputMaybe<Array<JobsWithLinkedJobBoolExp>>;
  _not?: InputMaybe<JobsWithLinkedJobBoolExp>;
  _or?: InputMaybe<Array<JobsWithLinkedJobBoolExp>>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  linkAttachments?: InputMaybe<BooleanComparisonExp>;
  linkNotes?: InputMaybe<BooleanComparisonExp>;
  linkPhotos?: InputMaybe<BooleanComparisonExp>;
  linkedJobGuid?: InputMaybe<UuidComparisonExp>;
  linked_job?: InputMaybe<JobsBoolExp>;
};

/** unique or primary key constraints on table "jobs_with_linked_job" */
export type JobsWithLinkedJobConstraint =
  /** unique or primary key constraint on columns "linked_job_guid", "job_guid" */
  | 'jobs_with_linked_job_pkey';

/** input type for inserting data into table "jobs_with_linked_job" */
export type JobsWithLinkedJobInsertInput = {
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  linkAttachments?: InputMaybe<Scalars['Boolean']>;
  linkNotes?: InputMaybe<Scalars['Boolean']>;
  linkPhotos?: InputMaybe<Scalars['Boolean']>;
  linkedJobGuid?: InputMaybe<Scalars['uuid']>;
  linked_job?: InputMaybe<JobsObjRelInsertInput>;
};

/** columns and relationships of "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstances = {
  __typename?: 'JobsWithLinkedJobLinkedAppointmentChecklistInstances';
  /** An object relationship */
  appointmentChecklistInstance: AppointmentChecklistInstances;
  appointmentChecklistInstanceGuid: Scalars['uuid'];
  /** An object relationship */
  followUpJob: Jobs;
  followUpJobGuid: Scalars['uuid'];
  /** An object relationship */
  originalJob: Jobs;
  originalJobGuid: Scalars['uuid'];
};

/** aggregated selection of "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregate = {
  __typename?: 'JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregate';
  aggregate?: Maybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregateFields>;
  nodes: Array<JobsWithLinkedJobLinkedAppointmentChecklistInstances>;
};

export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregateBoolExp = {
  count?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregateBoolExpCount>;
};

/** aggregate fields of "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregateFields = {
  __typename?: 'JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesMaxFields>;
  min?: Maybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesMinFields>;
};


/** aggregate fields of "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesMaxOrderBy>;
  min?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesMinOrderBy>;
};

/** input type for inserting array relation for remote table "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesArrRelInsertInput = {
  data: Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesOnConflict>;
};

/** Boolean expression to filter rows from the table "jobs_with_linked_job_linked_appointment_checklist_instances". All fields are combined with a logical 'AND'. */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp = {
  _and?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>>;
  _not?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>;
  _or?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>>;
  appointmentChecklistInstance?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
  appointmentChecklistInstanceGuid?: InputMaybe<UuidComparisonExp>;
  followUpJob?: InputMaybe<JobsBoolExp>;
  followUpJobGuid?: InputMaybe<UuidComparisonExp>;
  originalJob?: InputMaybe<JobsBoolExp>;
  originalJobGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesConstraint =
  /** unique or primary key constraint on columns "original_job_guid", "appointment_checklist_instance_guid", "follow_up_job_guid" */
  | 'jobs_with_linked_job_linked_appointment_checklist_instance_pkey';

/** input type for inserting data into table "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesInsertInput = {
  appointmentChecklistInstance?: InputMaybe<AppointmentChecklistInstancesObjRelInsertInput>;
  appointmentChecklistInstanceGuid?: InputMaybe<Scalars['uuid']>;
  followUpJob?: InputMaybe<JobsObjRelInsertInput>;
  followUpJobGuid?: InputMaybe<Scalars['uuid']>;
  originalJob?: InputMaybe<JobsObjRelInsertInput>;
  originalJobGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesMaxFields = {
  __typename?: 'JobsWithLinkedJobLinkedAppointmentChecklistInstancesMaxFields';
  appointmentChecklistInstanceGuid?: Maybe<Scalars['uuid']>;
  followUpJobGuid?: Maybe<Scalars['uuid']>;
  originalJobGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesMaxOrderBy = {
  appointmentChecklistInstanceGuid?: InputMaybe<OrderBy>;
  followUpJobGuid?: InputMaybe<OrderBy>;
  originalJobGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesMinFields = {
  __typename?: 'JobsWithLinkedJobLinkedAppointmentChecklistInstancesMinFields';
  appointmentChecklistInstanceGuid?: Maybe<Scalars['uuid']>;
  followUpJobGuid?: Maybe<Scalars['uuid']>;
  originalJobGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesMinOrderBy = {
  appointmentChecklistInstanceGuid?: InputMaybe<OrderBy>;
  followUpJobGuid?: InputMaybe<OrderBy>;
  originalJobGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesMutationResponse = {
  __typename?: 'JobsWithLinkedJobLinkedAppointmentChecklistInstancesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobsWithLinkedJobLinkedAppointmentChecklistInstances>;
};

/** on_conflict condition type for table "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesOnConflict = {
  constraint: JobsWithLinkedJobLinkedAppointmentChecklistInstancesConstraint;
  updateColumns?: Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesUpdateColumn>;
  where?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>;
};

/** Ordering options when selecting data from "jobs_with_linked_job_linked_appointment_checklist_instances". */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesOrderBy = {
  appointmentChecklistInstance?: InputMaybe<AppointmentChecklistInstancesOrderBy>;
  appointmentChecklistInstanceGuid?: InputMaybe<OrderBy>;
  followUpJob?: InputMaybe<JobsOrderBy>;
  followUpJobGuid?: InputMaybe<OrderBy>;
  originalJob?: InputMaybe<JobsOrderBy>;
  originalJobGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: jobs_with_linked_job_linked_appointment_checklist_instances */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesPkColumnsInput = {
  appointmentChecklistInstanceGuid: Scalars['uuid'];
  followUpJobGuid: Scalars['uuid'];
  originalJobGuid: Scalars['uuid'];
};

/** select columns of table "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesSelectColumn =
  /** column name */
  | 'appointmentChecklistInstanceGuid'
  /** column name */
  | 'followUpJobGuid'
  /** column name */
  | 'originalJobGuid';

/** input type for updating data in table "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesSetInput = {
  appointmentChecklistInstanceGuid?: InputMaybe<Scalars['uuid']>;
  followUpJobGuid?: InputMaybe<Scalars['uuid']>;
  originalJobGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobsWithLinkedJobLinkedAppointmentChecklistInstancesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesStreamCursorValueInput = {
  appointmentChecklistInstanceGuid?: InputMaybe<Scalars['uuid']>;
  followUpJobGuid?: InputMaybe<Scalars['uuid']>;
  originalJobGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "jobs_with_linked_job_linked_appointment_checklist_instances" */
export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesUpdateColumn =
  /** column name */
  | 'appointmentChecklistInstanceGuid'
  /** column name */
  | 'followUpJobGuid'
  /** column name */
  | 'originalJobGuid';

export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesSetInput>;
  /** filter the rows which have to be updated */
  where: JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp;
};

/** columns and relationships of "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimates = {
  __typename?: 'JobsWithLinkedJobLinkedEstimates';
  /** An object relationship */
  estimate: Estimates;
  estimateGuid: Scalars['uuid'];
  /** An object relationship */
  job: Jobs;
  jobGuid: Scalars['uuid'];
  /** An object relationship */
  linkedJob: Jobs;
  linkedJobGuid: Scalars['uuid'];
};

/** aggregated selection of "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesAggregate = {
  __typename?: 'JobsWithLinkedJobLinkedEstimatesAggregate';
  aggregate?: Maybe<JobsWithLinkedJobLinkedEstimatesAggregateFields>;
  nodes: Array<JobsWithLinkedJobLinkedEstimates>;
};

export type JobsWithLinkedJobLinkedEstimatesAggregateBoolExp = {
  count?: InputMaybe<JobsWithLinkedJobLinkedEstimatesAggregateBoolExpCount>;
};

/** aggregate fields of "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesAggregateFields = {
  __typename?: 'JobsWithLinkedJobLinkedEstimatesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobsWithLinkedJobLinkedEstimatesMaxFields>;
  min?: Maybe<JobsWithLinkedJobLinkedEstimatesMinFields>;
};


/** aggregate fields of "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobsWithLinkedJobLinkedEstimatesMaxOrderBy>;
  min?: InputMaybe<JobsWithLinkedJobLinkedEstimatesMinOrderBy>;
};

/** input type for inserting array relation for remote table "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesArrRelInsertInput = {
  data: Array<JobsWithLinkedJobLinkedEstimatesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<JobsWithLinkedJobLinkedEstimatesOnConflict>;
};

/** Boolean expression to filter rows from the table "jobs_with_linked_job_linked_estimates". All fields are combined with a logical 'AND'. */
export type JobsWithLinkedJobLinkedEstimatesBoolExp = {
  _and?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesBoolExp>>;
  _not?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
  _or?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesBoolExp>>;
  estimate?: InputMaybe<EstimatesBoolExp>;
  estimateGuid?: InputMaybe<UuidComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  linkedJob?: InputMaybe<JobsBoolExp>;
  linkedJobGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesConstraint =
  /** unique or primary key constraint on columns "linked_job_guid", "job_guid", "estimate_guid" */
  | 'jobs_with_linked_job_linked_estimates_pkey';

/** input type for inserting data into table "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesInsertInput = {
  estimate?: InputMaybe<EstimatesObjRelInsertInput>;
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  linkedJob?: InputMaybe<JobsObjRelInsertInput>;
  linkedJobGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type JobsWithLinkedJobLinkedEstimatesMaxFields = {
  __typename?: 'JobsWithLinkedJobLinkedEstimatesMaxFields';
  estimateGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  linkedJobGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesMaxOrderBy = {
  estimateGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  linkedJobGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobsWithLinkedJobLinkedEstimatesMinFields = {
  __typename?: 'JobsWithLinkedJobLinkedEstimatesMinFields';
  estimateGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  linkedJobGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesMinOrderBy = {
  estimateGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  linkedJobGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesMutationResponse = {
  __typename?: 'JobsWithLinkedJobLinkedEstimatesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobsWithLinkedJobLinkedEstimates>;
};

/** on_conflict condition type for table "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesOnConflict = {
  constraint: JobsWithLinkedJobLinkedEstimatesConstraint;
  updateColumns?: Array<JobsWithLinkedJobLinkedEstimatesUpdateColumn>;
  where?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
};

/** Ordering options when selecting data from "jobs_with_linked_job_linked_estimates". */
export type JobsWithLinkedJobLinkedEstimatesOrderBy = {
  estimate?: InputMaybe<EstimatesOrderBy>;
  estimateGuid?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  linkedJob?: InputMaybe<JobsOrderBy>;
  linkedJobGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: jobs_with_linked_job_linked_estimates */
export type JobsWithLinkedJobLinkedEstimatesPkColumnsInput = {
  estimateGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  linkedJobGuid: Scalars['uuid'];
};

/** select columns of table "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesSelectColumn =
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'linkedJobGuid';

/** input type for updating data in table "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesSetInput = {
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  linkedJobGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobsWithLinkedJobLinkedEstimatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobsWithLinkedJobLinkedEstimatesStreamCursorValueInput = {
  estimateGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  linkedJobGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "jobs_with_linked_job_linked_estimates" */
export type JobsWithLinkedJobLinkedEstimatesUpdateColumn =
  /** column name */
  | 'estimateGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'linkedJobGuid';

export type JobsWithLinkedJobLinkedEstimatesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobsWithLinkedJobLinkedEstimatesSetInput>;
  /** filter the rows which have to be updated */
  where: JobsWithLinkedJobLinkedEstimatesBoolExp;
};

/** columns and relationships of "jobs_with_linked_job_linked_invoices" */
export type JobsWithLinkedJobLinkedInvoices = {
  __typename?: 'JobsWithLinkedJobLinkedInvoices';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  invoice: Invoices;
  invoiceGuid: Scalars['uuid'];
  /** An object relationship */
  job: Jobs;
  jobGuid: Scalars['uuid'];
  /** An object relationship */
  linkedJob: Jobs;
  linkedJobGuid: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "jobs_with_linked_job_linked_invoices" */
export type JobsWithLinkedJobLinkedInvoicesAggregate = {
  __typename?: 'JobsWithLinkedJobLinkedInvoicesAggregate';
  aggregate?: Maybe<JobsWithLinkedJobLinkedInvoicesAggregateFields>;
  nodes: Array<JobsWithLinkedJobLinkedInvoices>;
};

export type JobsWithLinkedJobLinkedInvoicesAggregateBoolExp = {
  count?: InputMaybe<JobsWithLinkedJobLinkedInvoicesAggregateBoolExpCount>;
};

/** aggregate fields of "jobs_with_linked_job_linked_invoices" */
export type JobsWithLinkedJobLinkedInvoicesAggregateFields = {
  __typename?: 'JobsWithLinkedJobLinkedInvoicesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<JobsWithLinkedJobLinkedInvoicesMaxFields>;
  min?: Maybe<JobsWithLinkedJobLinkedInvoicesMinFields>;
};


/** aggregate fields of "jobs_with_linked_job_linked_invoices" */
export type JobsWithLinkedJobLinkedInvoicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "jobs_with_linked_job_linked_invoices" */
export type JobsWithLinkedJobLinkedInvoicesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<JobsWithLinkedJobLinkedInvoicesMaxOrderBy>;
  min?: InputMaybe<JobsWithLinkedJobLinkedInvoicesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "jobs_with_linked_job_linked_invoices". All fields are combined with a logical 'AND'. */
export type JobsWithLinkedJobLinkedInvoicesBoolExp = {
  _and?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesBoolExp>>;
  _not?: InputMaybe<JobsWithLinkedJobLinkedInvoicesBoolExp>;
  _or?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  linkedJob?: InputMaybe<JobsBoolExp>;
  linkedJobGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type JobsWithLinkedJobLinkedInvoicesMaxFields = {
  __typename?: 'JobsWithLinkedJobLinkedInvoicesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  linkedJobGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "jobs_with_linked_job_linked_invoices" */
export type JobsWithLinkedJobLinkedInvoicesMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  linkedJobGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobsWithLinkedJobLinkedInvoicesMinFields = {
  __typename?: 'JobsWithLinkedJobLinkedInvoicesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  linkedJobGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "jobs_with_linked_job_linked_invoices" */
export type JobsWithLinkedJobLinkedInvoicesMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  linkedJobGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "jobs_with_linked_job_linked_invoices". */
export type JobsWithLinkedJobLinkedInvoicesOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  linkedJob?: InputMaybe<JobsOrderBy>;
  linkedJobGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "jobs_with_linked_job_linked_invoices" */
export type JobsWithLinkedJobLinkedInvoicesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'linkedJobGuid'
  /** column name */
  | 'updatedAt';

/** Streaming cursor of the table "jobs_with_linked_job_linked_invoices" */
export type JobsWithLinkedJobLinkedInvoicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobsWithLinkedJobLinkedInvoicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobsWithLinkedJobLinkedInvoicesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  linkedJobGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type JobsWithLinkedJobMaxFields = {
  __typename?: 'JobsWithLinkedJobMaxFields';
  jobGuid?: Maybe<Scalars['uuid']>;
  linkedJobGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "jobs_with_linked_job" */
export type JobsWithLinkedJobMaxOrderBy = {
  jobGuid?: InputMaybe<OrderBy>;
  linkedJobGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type JobsWithLinkedJobMinFields = {
  __typename?: 'JobsWithLinkedJobMinFields';
  jobGuid?: Maybe<Scalars['uuid']>;
  linkedJobGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "jobs_with_linked_job" */
export type JobsWithLinkedJobMinOrderBy = {
  jobGuid?: InputMaybe<OrderBy>;
  linkedJobGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "jobs_with_linked_job" */
export type JobsWithLinkedJobMutationResponse = {
  __typename?: 'JobsWithLinkedJobMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobsWithLinkedJob>;
};

/** on_conflict condition type for table "jobs_with_linked_job" */
export type JobsWithLinkedJobOnConflict = {
  constraint: JobsWithLinkedJobConstraint;
  updateColumns?: Array<JobsWithLinkedJobUpdateColumn>;
  where?: InputMaybe<JobsWithLinkedJobBoolExp>;
};

/** Ordering options when selecting data from "jobs_with_linked_job". */
export type JobsWithLinkedJobOrderBy = {
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  linkAttachments?: InputMaybe<OrderBy>;
  linkNotes?: InputMaybe<OrderBy>;
  linkPhotos?: InputMaybe<OrderBy>;
  linkedJobGuid?: InputMaybe<OrderBy>;
  linked_job?: InputMaybe<JobsOrderBy>;
};

/** primary key columns input for table: jobs_with_linked_job */
export type JobsWithLinkedJobPkColumnsInput = {
  jobGuid: Scalars['uuid'];
  linkedJobGuid: Scalars['uuid'];
};

/** select columns of table "jobs_with_linked_job" */
export type JobsWithLinkedJobSelectColumn =
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'linkAttachments'
  /** column name */
  | 'linkNotes'
  /** column name */
  | 'linkPhotos'
  /** column name */
  | 'linkedJobGuid';

/** select "jobsWithLinkedJobAggregateBoolExpBool_andArgumentsColumns" columns of table "jobs_with_linked_job" */
export type JobsWithLinkedJobSelectColumnJobsWithLinkedJobAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'linkAttachments'
  /** column name */
  | 'linkNotes'
  /** column name */
  | 'linkPhotos';

/** select "jobsWithLinkedJobAggregateBoolExpBool_orArgumentsColumns" columns of table "jobs_with_linked_job" */
export type JobsWithLinkedJobSelectColumnJobsWithLinkedJobAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'linkAttachments'
  /** column name */
  | 'linkNotes'
  /** column name */
  | 'linkPhotos';

/** input type for updating data in table "jobs_with_linked_job" */
export type JobsWithLinkedJobSetInput = {
  jobGuid?: InputMaybe<Scalars['uuid']>;
  linkAttachments?: InputMaybe<Scalars['Boolean']>;
  linkNotes?: InputMaybe<Scalars['Boolean']>;
  linkPhotos?: InputMaybe<Scalars['Boolean']>;
  linkedJobGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "jobs_with_linked_job" */
export type JobsWithLinkedJobStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobsWithLinkedJobStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobsWithLinkedJobStreamCursorValueInput = {
  jobGuid?: InputMaybe<Scalars['uuid']>;
  linkAttachments?: InputMaybe<Scalars['Boolean']>;
  linkNotes?: InputMaybe<Scalars['Boolean']>;
  linkPhotos?: InputMaybe<Scalars['Boolean']>;
  linkedJobGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "jobs_with_linked_job" */
export type JobsWithLinkedJobUpdateColumn =
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'linkAttachments'
  /** column name */
  | 'linkNotes'
  /** column name */
  | 'linkPhotos'
  /** column name */
  | 'linkedJobGuid';

export type JobsWithLinkedJobUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobsWithLinkedJobSetInput>;
  /** filter the rows which have to be updated */
  where: JobsWithLinkedJobBoolExp;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type JsonComparisonExp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _containedIn?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _hasKey?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "location_contacts" */
export type LocationContacts = {
  __typename?: 'LocationContacts';
  /** An object relationship */
  contact: Contacts;
  contactGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  location: Locations;
  locationContactRelationTypes: Scalars['jsonb'];
  locationGuid: Scalars['uuid'];
  notes?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "location_contacts" */
export type LocationContactsLocationContactRelationTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "location_contacts" */
export type LocationContactsAggregate = {
  __typename?: 'LocationContactsAggregate';
  aggregate?: Maybe<LocationContactsAggregateFields>;
  nodes: Array<LocationContacts>;
};

export type LocationContactsAggregateBoolExp = {
  count?: InputMaybe<LocationContactsAggregateBoolExpCount>;
};

/** aggregate fields of "location_contacts" */
export type LocationContactsAggregateFields = {
  __typename?: 'LocationContactsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LocationContactsMaxFields>;
  min?: Maybe<LocationContactsMinFields>;
};


/** aggregate fields of "location_contacts" */
export type LocationContactsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LocationContactsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "location_contacts" */
export type LocationContactsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LocationContactsMaxOrderBy>;
  min?: InputMaybe<LocationContactsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type LocationContactsAppendInput = {
  locationContactRelationTypes?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "location_contacts" */
export type LocationContactsArrRelInsertInput = {
  data: Array<LocationContactsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LocationContactsOnConflict>;
};

/** Boolean expression to filter rows from the table "location_contacts". All fields are combined with a logical 'AND'. */
export type LocationContactsBoolExp = {
  _and?: InputMaybe<Array<LocationContactsBoolExp>>;
  _not?: InputMaybe<LocationContactsBoolExp>;
  _or?: InputMaybe<Array<LocationContactsBoolExp>>;
  contact?: InputMaybe<ContactsBoolExp>;
  contactGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationContactRelationTypes?: InputMaybe<JsonbComparisonExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  notes?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "location_contacts" */
export type LocationContactsConstraint =
  /** unique or primary key constraint on columns "location_guid", "contact_guid" */
  | 'location_contacts_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type LocationContactsDeleteAtPathInput = {
  locationContactRelationTypes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type LocationContactsDeleteElemInput = {
  locationContactRelationTypes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type LocationContactsDeleteKeyInput = {
  locationContactRelationTypes?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "location_contacts" */
export type LocationContactsInsertInput = {
  contact?: InputMaybe<ContactsObjRelInsertInput>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  location?: InputMaybe<LocationsObjRelInsertInput>;
  locationContactRelationTypes?: InputMaybe<Scalars['jsonb']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LocationContactsMaxFields = {
  __typename?: 'LocationContactsMaxFields';
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "location_contacts" */
export type LocationContactsMaxOrderBy = {
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  notes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LocationContactsMinFields = {
  __typename?: 'LocationContactsMinFields';
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "location_contacts" */
export type LocationContactsMinOrderBy = {
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  notes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "location_contacts" */
export type LocationContactsMutationResponse = {
  __typename?: 'LocationContactsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LocationContacts>;
};

/** on_conflict condition type for table "location_contacts" */
export type LocationContactsOnConflict = {
  constraint: LocationContactsConstraint;
  updateColumns?: Array<LocationContactsUpdateColumn>;
  where?: InputMaybe<LocationContactsBoolExp>;
};

/** Ordering options when selecting data from "location_contacts". */
export type LocationContactsOrderBy = {
  contact?: InputMaybe<ContactsOrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderBy>;
  locationContactRelationTypes?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  notes?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: location_contacts */
export type LocationContactsPkColumnsInput = {
  contactGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type LocationContactsPrependInput = {
  locationContactRelationTypes?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "location_contacts" */
export type LocationContactsSelectColumn =
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'locationContactRelationTypes'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'notes'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "location_contacts" */
export type LocationContactsSetInput = {
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  locationContactRelationTypes?: InputMaybe<Scalars['jsonb']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "location_contacts" */
export type LocationContactsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LocationContactsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LocationContactsStreamCursorValueInput = {
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  locationContactRelationTypes?: InputMaybe<Scalars['jsonb']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "location_contacts" */
export type LocationContactsUpdateColumn =
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'locationContactRelationTypes'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'notes'
  /** column name */
  | 'updatedAt';

export type LocationContactsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<LocationContactsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<LocationContactsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<LocationContactsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<LocationContactsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<LocationContactsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LocationContactsSetInput>;
  /** filter the rows which have to be updated */
  where: LocationContactsBoolExp;
};

/** columns and relationships of "location_invoices" */
export type LocationInvoices = {
  __typename?: 'LocationInvoices';
  /** An object relationship */
  invoice: Invoices;
  invoiceGuid: Scalars['uuid'];
  /** An object relationship */
  location: Locations;
  locationGuid: Scalars['uuid'];
};

/** aggregated selection of "location_invoices" */
export type LocationInvoicesAggregate = {
  __typename?: 'LocationInvoicesAggregate';
  aggregate?: Maybe<LocationInvoicesAggregateFields>;
  nodes: Array<LocationInvoices>;
};

export type LocationInvoicesAggregateBoolExp = {
  count?: InputMaybe<LocationInvoicesAggregateBoolExpCount>;
};

/** aggregate fields of "location_invoices" */
export type LocationInvoicesAggregateFields = {
  __typename?: 'LocationInvoicesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<LocationInvoicesMaxFields>;
  min?: Maybe<LocationInvoicesMinFields>;
};


/** aggregate fields of "location_invoices" */
export type LocationInvoicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LocationInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "location_invoices" */
export type LocationInvoicesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LocationInvoicesMaxOrderBy>;
  min?: InputMaybe<LocationInvoicesMinOrderBy>;
};

/** input type for inserting array relation for remote table "location_invoices" */
export type LocationInvoicesArrRelInsertInput = {
  data: Array<LocationInvoicesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LocationInvoicesOnConflict>;
};

/** Boolean expression to filter rows from the table "location_invoices". All fields are combined with a logical 'AND'. */
export type LocationInvoicesBoolExp = {
  _and?: InputMaybe<Array<LocationInvoicesBoolExp>>;
  _not?: InputMaybe<LocationInvoicesBoolExp>;
  _or?: InputMaybe<Array<LocationInvoicesBoolExp>>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "location_invoices" */
export type LocationInvoicesConstraint =
  /** unique or primary key constraint on columns "invoice_guid" */
  | 'location_invoices_pkey';

/** input type for inserting data into table "location_invoices" */
export type LocationInvoicesInsertInput = {
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<LocationsObjRelInsertInput>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type LocationInvoicesMaxFields = {
  __typename?: 'LocationInvoicesMaxFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "location_invoices" */
export type LocationInvoicesMaxOrderBy = {
  invoiceGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LocationInvoicesMinFields = {
  __typename?: 'LocationInvoicesMinFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "location_invoices" */
export type LocationInvoicesMinOrderBy = {
  invoiceGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "location_invoices" */
export type LocationInvoicesMutationResponse = {
  __typename?: 'LocationInvoicesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LocationInvoices>;
};

/** input type for inserting object relation for remote table "location_invoices" */
export type LocationInvoicesObjRelInsertInput = {
  data: LocationInvoicesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LocationInvoicesOnConflict>;
};

/** on_conflict condition type for table "location_invoices" */
export type LocationInvoicesOnConflict = {
  constraint: LocationInvoicesConstraint;
  updateColumns?: Array<LocationInvoicesUpdateColumn>;
  where?: InputMaybe<LocationInvoicesBoolExp>;
};

/** Ordering options when selecting data from "location_invoices". */
export type LocationInvoicesOrderBy = {
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: location_invoices */
export type LocationInvoicesPkColumnsInput = {
  invoiceGuid: Scalars['uuid'];
};

/** select columns of table "location_invoices" */
export type LocationInvoicesSelectColumn =
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'locationGuid';

/** input type for updating data in table "location_invoices" */
export type LocationInvoicesSetInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "location_invoices" */
export type LocationInvoicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LocationInvoicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LocationInvoicesStreamCursorValueInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "location_invoices" */
export type LocationInvoicesUpdateColumn =
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'locationGuid';

export type LocationInvoicesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LocationInvoicesSetInput>;
  /** filter the rows which have to be updated */
  where: LocationInvoicesBoolExp;
};

/** columns and relationships of "locations" */
export type Locations = {
  __typename?: 'Locations';
  /** An array relationship */
  accountLocations: Array<AccountLocations>;
  /** An aggregate relationship */
  accountLocationsAggregate: AccountLocationsAggregate;
  /** An object relationship */
  address: Addresses;
  addressGuid: Scalars['uuid'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  defaultPricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  displayName?: Maybe<Scalars['String']>;
  estimatedBuildDate?: Maybe<Scalars['date']>;
  estimatedSquareFootage?: Maybe<Scalars['Int']>;
  /** An array relationship */
  fileLinks: Array<FileLinks>;
  /** An aggregate relationship */
  fileLinksAggregate: FileLinksAggregate;
  /** An array relationship */
  installedEquipment: Array<InstalledEquipment>;
  /** An aggregate relationship */
  installedEquipmentAggregate: InstalledEquipmentAggregate;
  /** An array relationship */
  installedHvacSystems: Array<InstalledHvacSystems>;
  /** An aggregate relationship */
  installedHvacSystemsAggregate: InstalledHvacSystemsAggregate;
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobsAggregate: JobsAggregate;
  /** A computed field that returns the most recent appointment start time to determine when the location was last visited. */
  lastVisitedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  locationContacts: Array<LocationContacts>;
  /** An aggregate relationship */
  locationContactsAggregate: LocationContactsAggregate;
  locationDescription?: Maybe<Scalars['String']>;
  locationGuid: Scalars['uuid'];
  /** An array relationship */
  maintenancePlans: Array<MaintenancePlansQueryable>;
  /** An aggregate relationship */
  maintenancePlansAggregate: MaintenancePlansQueryableAggregate;
  municipality?: Maybe<Scalars['String']>;
  /** An array relationship */
  noteLinks: Array<NoteLinks>;
  /** An aggregate relationship */
  noteLinksAggregate: NoteLinksAggregate;
  /** An array relationship */
  photoLinks: Array<PhotoLinks>;
  /** An aggregate relationship */
  photoLinksAggregate: PhotoLinksAggregate;
  /** An object relationship */
  pricebookTaxRate?: Maybe<PricebookTaxRates>;
  propertyType: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "locations" */
export type LocationsAccountLocationsArgs = {
  distinctOn?: InputMaybe<Array<AccountLocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountLocationsOrderBy>>;
  where?: InputMaybe<AccountLocationsBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsAccountLocationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountLocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountLocationsOrderBy>>;
  where?: InputMaybe<AccountLocationsBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsFileLinksArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsFileLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsInstalledEquipmentArgs = {
  distinctOn?: InputMaybe<Array<InstalledEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledEquipmentOrderBy>>;
  where?: InputMaybe<InstalledEquipmentBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsInstalledEquipmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstalledEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledEquipmentOrderBy>>;
  where?: InputMaybe<InstalledEquipmentBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsInstalledHvacSystemsArgs = {
  distinctOn?: InputMaybe<Array<InstalledHvacSystemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledHvacSystemsOrderBy>>;
  where?: InputMaybe<InstalledHvacSystemsBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsInstalledHvacSystemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstalledHvacSystemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledHvacSystemsOrderBy>>;
  where?: InputMaybe<InstalledHvacSystemsBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsJobsArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsLocationContactsArgs = {
  distinctOn?: InputMaybe<Array<LocationContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationContactsOrderBy>>;
  where?: InputMaybe<LocationContactsBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsLocationContactsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LocationContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationContactsOrderBy>>;
  where?: InputMaybe<LocationContactsBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsMaintenancePlansArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlansQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlansQueryableOrderBy>>;
  where?: InputMaybe<MaintenancePlansQueryableBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsMaintenancePlansAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlansQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlansQueryableOrderBy>>;
  where?: InputMaybe<MaintenancePlansQueryableBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsNoteLinksArgs = {
  distinctOn?: InputMaybe<Array<NoteLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteLinksOrderBy>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsNoteLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteLinksOrderBy>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsPhotoLinksArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


/** columns and relationships of "locations" */
export type LocationsPhotoLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};

/** aggregated selection of "locations" */
export type LocationsAggregate = {
  __typename?: 'LocationsAggregate';
  aggregate?: Maybe<LocationsAggregateFields>;
  nodes: Array<Locations>;
};

export type LocationsAggregateBoolExp = {
  count?: InputMaybe<LocationsAggregateBoolExpCount>;
};

/** aggregate fields of "locations" */
export type LocationsAggregateFields = {
  __typename?: 'LocationsAggregateFields';
  avg?: Maybe<LocationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<LocationsMaxFields>;
  min?: Maybe<LocationsMinFields>;
  stddev?: Maybe<LocationsStddevFields>;
  stddevPop?: Maybe<LocationsStddevPopFields>;
  stddevSamp?: Maybe<LocationsStddevSampFields>;
  sum?: Maybe<LocationsSumFields>;
  varPop?: Maybe<LocationsVarPopFields>;
  varSamp?: Maybe<LocationsVarSampFields>;
  variance?: Maybe<LocationsVarianceFields>;
};


/** aggregate fields of "locations" */
export type LocationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LocationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "locations" */
export type LocationsAggregateOrderBy = {
  avg?: InputMaybe<LocationsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<LocationsMaxOrderBy>;
  min?: InputMaybe<LocationsMinOrderBy>;
  stddev?: InputMaybe<LocationsStddevOrderBy>;
  stddevPop?: InputMaybe<LocationsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<LocationsStddevSampOrderBy>;
  sum?: InputMaybe<LocationsSumOrderBy>;
  varPop?: InputMaybe<LocationsVarPopOrderBy>;
  varSamp?: InputMaybe<LocationsVarSampOrderBy>;
  variance?: InputMaybe<LocationsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "locations" */
export type LocationsArrRelInsertInput = {
  data: Array<LocationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<LocationsOnConflict>;
};

/** aggregate avg on columns */
export type LocationsAvgFields = {
  __typename?: 'LocationsAvgFields';
  estimatedSquareFootage?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "locations" */
export type LocationsAvgOrderBy = {
  estimatedSquareFootage?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "locations". All fields are combined with a logical 'AND'. */
export type LocationsBoolExp = {
  _and?: InputMaybe<Array<LocationsBoolExp>>;
  _not?: InputMaybe<LocationsBoolExp>;
  _or?: InputMaybe<Array<LocationsBoolExp>>;
  accountLocations?: InputMaybe<AccountLocationsBoolExp>;
  accountLocationsAggregate?: InputMaybe<AccountLocationsAggregateBoolExp>;
  address?: InputMaybe<AddressesBoolExp>;
  addressGuid?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  defaultPricebookTaxRateGuid?: InputMaybe<UuidComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  estimatedBuildDate?: InputMaybe<DateComparisonExp>;
  estimatedSquareFootage?: InputMaybe<IntComparisonExp>;
  fileLinks?: InputMaybe<FileLinksBoolExp>;
  fileLinksAggregate?: InputMaybe<FileLinksAggregateBoolExp>;
  installedEquipment?: InputMaybe<InstalledEquipmentBoolExp>;
  installedEquipmentAggregate?: InputMaybe<InstalledEquipmentAggregateBoolExp>;
  installedHvacSystems?: InputMaybe<InstalledHvacSystemsBoolExp>;
  installedHvacSystemsAggregate?: InputMaybe<InstalledHvacSystemsAggregateBoolExp>;
  jobs?: InputMaybe<JobsBoolExp>;
  jobsAggregate?: InputMaybe<JobsAggregateBoolExp>;
  lastVisitedAt?: InputMaybe<TimestamptzComparisonExp>;
  locationContacts?: InputMaybe<LocationContactsBoolExp>;
  locationContactsAggregate?: InputMaybe<LocationContactsAggregateBoolExp>;
  locationDescription?: InputMaybe<StringComparisonExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlans?: InputMaybe<MaintenancePlansQueryableBoolExp>;
  maintenancePlansAggregate?: InputMaybe<MaintenancePlansQueryableAggregateBoolExp>;
  municipality?: InputMaybe<StringComparisonExp>;
  noteLinks?: InputMaybe<NoteLinksBoolExp>;
  noteLinksAggregate?: InputMaybe<NoteLinksAggregateBoolExp>;
  photoLinks?: InputMaybe<PhotoLinksBoolExp>;
  photoLinksAggregate?: InputMaybe<PhotoLinksAggregateBoolExp>;
  pricebookTaxRate?: InputMaybe<PricebookTaxRatesBoolExp>;
  propertyType?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "locations" */
export type LocationsConstraint =
  /** unique or primary key constraint on columns "location_guid" */
  | 'locations_pkey';

/** input type for incrementing numeric columns in table "locations" */
export type LocationsIncInput = {
  estimatedSquareFootage?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "locations" */
export type LocationsInsertInput = {
  accountLocations?: InputMaybe<AccountLocationsArrRelInsertInput>;
  address?: InputMaybe<AddressesObjRelInsertInput>;
  addressGuid?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  defaultPricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  displayName?: InputMaybe<Scalars['String']>;
  estimatedBuildDate?: InputMaybe<Scalars['date']>;
  estimatedSquareFootage?: InputMaybe<Scalars['Int']>;
  fileLinks?: InputMaybe<FileLinksArrRelInsertInput>;
  installedEquipment?: InputMaybe<InstalledEquipmentArrRelInsertInput>;
  installedHvacSystems?: InputMaybe<InstalledHvacSystemsArrRelInsertInput>;
  jobs?: InputMaybe<JobsArrRelInsertInput>;
  locationContacts?: InputMaybe<LocationContactsArrRelInsertInput>;
  locationDescription?: InputMaybe<Scalars['String']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlans?: InputMaybe<MaintenancePlansQueryableArrRelInsertInput>;
  municipality?: InputMaybe<Scalars['String']>;
  noteLinks?: InputMaybe<NoteLinksArrRelInsertInput>;
  photoLinks?: InputMaybe<PhotoLinksArrRelInsertInput>;
  pricebookTaxRate?: InputMaybe<PricebookTaxRatesObjRelInsertInput>;
  propertyType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type LocationsMaxFields = {
  __typename?: 'LocationsMaxFields';
  addressGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  defaultPricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  displayName?: Maybe<Scalars['String']>;
  estimatedBuildDate?: Maybe<Scalars['date']>;
  estimatedSquareFootage?: Maybe<Scalars['Int']>;
  /** A computed field that returns the most recent appointment start time to determine when the location was last visited. */
  lastVisitedAt?: Maybe<Scalars['timestamptz']>;
  locationDescription?: Maybe<Scalars['String']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  municipality?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "locations" */
export type LocationsMaxOrderBy = {
  addressGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  defaultPricebookTaxRateGuid?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  estimatedBuildDate?: InputMaybe<OrderBy>;
  estimatedSquareFootage?: InputMaybe<OrderBy>;
  locationDescription?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  municipality?: InputMaybe<OrderBy>;
  propertyType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type LocationsMinFields = {
  __typename?: 'LocationsMinFields';
  addressGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  defaultPricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  displayName?: Maybe<Scalars['String']>;
  estimatedBuildDate?: Maybe<Scalars['date']>;
  estimatedSquareFootage?: Maybe<Scalars['Int']>;
  /** A computed field that returns the most recent appointment start time to determine when the location was last visited. */
  lastVisitedAt?: Maybe<Scalars['timestamptz']>;
  locationDescription?: Maybe<Scalars['String']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  municipality?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "locations" */
export type LocationsMinOrderBy = {
  addressGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  defaultPricebookTaxRateGuid?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  estimatedBuildDate?: InputMaybe<OrderBy>;
  estimatedSquareFootage?: InputMaybe<OrderBy>;
  locationDescription?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  municipality?: InputMaybe<OrderBy>;
  propertyType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "locations" */
export type LocationsMutationResponse = {
  __typename?: 'LocationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Locations>;
};

/** input type for inserting object relation for remote table "locations" */
export type LocationsObjRelInsertInput = {
  data: LocationsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LocationsOnConflict>;
};

/** on_conflict condition type for table "locations" */
export type LocationsOnConflict = {
  constraint: LocationsConstraint;
  updateColumns?: Array<LocationsUpdateColumn>;
  where?: InputMaybe<LocationsBoolExp>;
};

/** Ordering options when selecting data from "locations". */
export type LocationsOrderBy = {
  accountLocationsAggregate?: InputMaybe<AccountLocationsAggregateOrderBy>;
  address?: InputMaybe<AddressesOrderBy>;
  addressGuid?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  defaultPricebookTaxRateGuid?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  estimatedBuildDate?: InputMaybe<OrderBy>;
  estimatedSquareFootage?: InputMaybe<OrderBy>;
  fileLinksAggregate?: InputMaybe<FileLinksAggregateOrderBy>;
  installedEquipmentAggregate?: InputMaybe<InstalledEquipmentAggregateOrderBy>;
  installedHvacSystemsAggregate?: InputMaybe<InstalledHvacSystemsAggregateOrderBy>;
  jobsAggregate?: InputMaybe<JobsAggregateOrderBy>;
  lastVisitedAt?: InputMaybe<OrderBy>;
  locationContactsAggregate?: InputMaybe<LocationContactsAggregateOrderBy>;
  locationDescription?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlansAggregate?: InputMaybe<MaintenancePlansQueryableAggregateOrderBy>;
  municipality?: InputMaybe<OrderBy>;
  noteLinksAggregate?: InputMaybe<NoteLinksAggregateOrderBy>;
  photoLinksAggregate?: InputMaybe<PhotoLinksAggregateOrderBy>;
  pricebookTaxRate?: InputMaybe<PricebookTaxRatesOrderBy>;
  propertyType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: locations */
export type LocationsPkColumnsInput = {
  locationGuid: Scalars['uuid'];
};

/** select columns of table "locations" */
export type LocationsSelectColumn =
  /** column name */
  | 'addressGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'defaultPricebookTaxRateGuid'
  /** column name */
  | 'displayName'
  /** column name */
  | 'estimatedBuildDate'
  /** column name */
  | 'estimatedSquareFootage'
  /** column name */
  | 'locationDescription'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'municipality'
  /** column name */
  | 'propertyType'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "locations" */
export type LocationsSetInput = {
  addressGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  defaultPricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  displayName?: InputMaybe<Scalars['String']>;
  estimatedBuildDate?: InputMaybe<Scalars['date']>;
  estimatedSquareFootage?: InputMaybe<Scalars['Int']>;
  locationDescription?: InputMaybe<Scalars['String']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  municipality?: InputMaybe<Scalars['String']>;
  propertyType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type LocationsStddevFields = {
  __typename?: 'LocationsStddevFields';
  estimatedSquareFootage?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "locations" */
export type LocationsStddevOrderBy = {
  estimatedSquareFootage?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type LocationsStddevPopFields = {
  __typename?: 'LocationsStddevPopFields';
  estimatedSquareFootage?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "locations" */
export type LocationsStddevPopOrderBy = {
  estimatedSquareFootage?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type LocationsStddevSampFields = {
  __typename?: 'LocationsStddevSampFields';
  estimatedSquareFootage?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "locations" */
export type LocationsStddevSampOrderBy = {
  estimatedSquareFootage?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "locations" */
export type LocationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LocationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LocationsStreamCursorValueInput = {
  addressGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  defaultPricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  displayName?: InputMaybe<Scalars['String']>;
  estimatedBuildDate?: InputMaybe<Scalars['date']>;
  estimatedSquareFootage?: InputMaybe<Scalars['Int']>;
  locationDescription?: InputMaybe<Scalars['String']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  municipality?: InputMaybe<Scalars['String']>;
  propertyType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type LocationsSumFields = {
  __typename?: 'LocationsSumFields';
  estimatedSquareFootage?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "locations" */
export type LocationsSumOrderBy = {
  estimatedSquareFootage?: InputMaybe<OrderBy>;
};

/** update columns of table "locations" */
export type LocationsUpdateColumn =
  /** column name */
  | 'addressGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'defaultPricebookTaxRateGuid'
  /** column name */
  | 'displayName'
  /** column name */
  | 'estimatedBuildDate'
  /** column name */
  | 'estimatedSquareFootage'
  /** column name */
  | 'locationDescription'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'municipality'
  /** column name */
  | 'propertyType'
  /** column name */
  | 'updatedAt';

export type LocationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<LocationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LocationsSetInput>;
  /** filter the rows which have to be updated */
  where: LocationsBoolExp;
};

/** aggregate varPop on columns */
export type LocationsVarPopFields = {
  __typename?: 'LocationsVarPopFields';
  estimatedSquareFootage?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "locations" */
export type LocationsVarPopOrderBy = {
  estimatedSquareFootage?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type LocationsVarSampFields = {
  __typename?: 'LocationsVarSampFields';
  estimatedSquareFootage?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "locations" */
export type LocationsVarSampOrderBy = {
  estimatedSquareFootage?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type LocationsVarianceFields = {
  __typename?: 'LocationsVarianceFields';
  estimatedSquareFootage?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "locations" */
export type LocationsVarianceOrderBy = {
  estimatedSquareFootage?: InputMaybe<OrderBy>;
};

export type MaintenancePlanCancellationReasonTypesEnum =
  | 'COMPETITOR_OFFER'
  | 'CONTRACT_ISSUE'
  | 'ENVIRONMENT_HEALTH_CONCERNS'
  | 'FINANCIAL'
  | 'LIFESTYLE_CHANGE'
  | 'LOCATION_CHANGE'
  | 'NEVER_ACTIVATED'
  | 'OTHER'
  | 'PLAN_USAGE'
  | 'SERVICE_QUALITY'
  | 'SERVICE_REQUIREMENTS';

/** Boolean expression to compare columns of type "MaintenancePlanCancellationReasonTypesEnum". All fields are combined with logical 'AND'. */
export type MaintenancePlanCancellationReasonTypesEnumComparisonExp = {
  _eq?: InputMaybe<MaintenancePlanCancellationReasonTypesEnum>;
  _in?: InputMaybe<Array<MaintenancePlanCancellationReasonTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<MaintenancePlanCancellationReasonTypesEnum>;
  _nin?: InputMaybe<Array<MaintenancePlanCancellationReasonTypesEnum>>;
};

/** columns and relationships of "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervals = {
  __typename?: 'MaintenancePlanDefinitionAllowedPaymentIntervals';
  isDefault: Scalars['Boolean'];
  maintenancePlanDefinitionAllowedPaymentIntervalGuid: Scalars['uuid'];
  maintenancePlanDefinitionGuid: Scalars['uuid'];
  paymentInterval: Scalars['MaintenancePlanPaymentInterval'];
};

/** aggregated selection of "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsAggregate = {
  __typename?: 'MaintenancePlanDefinitionAllowedPaymentIntervalsAggregate';
  aggregate?: Maybe<MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateFields>;
  nodes: Array<MaintenancePlanDefinitionAllowedPaymentIntervals>;
};

export type MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExp = {
  bool_and?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExpBool_Or>;
  count?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExpCount>;
};

/** aggregate fields of "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateFields = {
  __typename?: 'MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanDefinitionAllowedPaymentIntervalsMaxFields>;
  min?: Maybe<MaintenancePlanDefinitionAllowedPaymentIntervalsMinFields>;
};


/** aggregate fields of "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsMaxOrderBy>;
  min?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsMinOrderBy>;
};

/** input type for inserting array relation for remote table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsArrRelInsertInput = {
  data: Array<MaintenancePlanDefinitionAllowedPaymentIntervalsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsOnConflict>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_definition_allowed_payment_intervals". All fields are combined with a logical 'AND'. */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>>;
  _not?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>>;
  isDefault?: InputMaybe<BooleanComparisonExp>;
  maintenancePlanDefinitionAllowedPaymentIntervalGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanDefinitionGuid?: InputMaybe<UuidComparisonExp>;
  paymentInterval?: InputMaybe<Scalars['MaintenancePlanPaymentIntervalComparisonExp']>;
};

/** unique or primary key constraints on table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsConstraint =
  /** unique or primary key constraint on columns "maintenance_plan_definition_guid", "payment_interval" */
  | 'maintenance_plan_definition_a_maintenance_plan_definition_g_key'
  /** unique or primary key constraint on columns "maintenance_plan_definition_guid" */
  | 'maintenance_plan_definition_allowed_payment_intervals_default_u'
  /** unique or primary key constraint on columns "maintenance_plan_definition_allowed_payment_interval_guid" */
  | 'maintenance_plan_definition_allowed_payment_intervals_pkey';

/** input type for inserting data into table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsInsertInput = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanDefinitionAllowedPaymentIntervalGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  paymentInterval?: InputMaybe<Scalars['MaintenancePlanPaymentInterval']>;
};

/** aggregate max on columns */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsMaxFields = {
  __typename?: 'MaintenancePlanDefinitionAllowedPaymentIntervalsMaxFields';
  maintenancePlanDefinitionAllowedPaymentIntervalGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  paymentInterval?: Maybe<Scalars['MaintenancePlanPaymentInterval']>;
};

/** order by max() on columns of table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsMaxOrderBy = {
  maintenancePlanDefinitionAllowedPaymentIntervalGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
  paymentInterval?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsMinFields = {
  __typename?: 'MaintenancePlanDefinitionAllowedPaymentIntervalsMinFields';
  maintenancePlanDefinitionAllowedPaymentIntervalGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  paymentInterval?: Maybe<Scalars['MaintenancePlanPaymentInterval']>;
};

/** order by min() on columns of table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsMinOrderBy = {
  maintenancePlanDefinitionAllowedPaymentIntervalGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
  paymentInterval?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsMutationResponse = {
  __typename?: 'MaintenancePlanDefinitionAllowedPaymentIntervalsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MaintenancePlanDefinitionAllowedPaymentIntervals>;
};

/** on_conflict condition type for table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsOnConflict = {
  constraint: MaintenancePlanDefinitionAllowedPaymentIntervalsConstraint;
  updateColumns?: Array<MaintenancePlanDefinitionAllowedPaymentIntervalsUpdateColumn>;
  where?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
};

/** Ordering options when selecting data from "maintenance_plan_definition_allowed_payment_intervals". */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsOrderBy = {
  isDefault?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionAllowedPaymentIntervalGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
  paymentInterval?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: maintenance_plan_definition_allowed_payment_intervals */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsPkColumnsInput = {
  maintenancePlanDefinitionAllowedPaymentIntervalGuid: Scalars['uuid'];
};

/** select columns of table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumn =
  /** column name */
  | 'isDefault'
  /** column name */
  | 'maintenancePlanDefinitionAllowedPaymentIntervalGuid'
  /** column name */
  | 'maintenancePlanDefinitionGuid'
  /** column name */
  | 'paymentInterval';

/** select "maintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExpBool_andArgumentsColumns" columns of table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumnMaintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isDefault';

/** select "maintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExpBool_orArgumentsColumns" columns of table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumnMaintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isDefault';

/** input type for updating data in table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsSetInput = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanDefinitionAllowedPaymentIntervalGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  paymentInterval?: InputMaybe<Scalars['MaintenancePlanPaymentInterval']>;
};

/** Streaming cursor of the table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanDefinitionAllowedPaymentIntervalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsStreamCursorValueInput = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanDefinitionAllowedPaymentIntervalGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  paymentInterval?: InputMaybe<Scalars['MaintenancePlanPaymentInterval']>;
};

/** update columns of table "maintenance_plan_definition_allowed_payment_intervals" */
export type MaintenancePlanDefinitionAllowedPaymentIntervalsUpdateColumn =
  /** column name */
  | 'isDefault'
  /** column name */
  | 'maintenancePlanDefinitionAllowedPaymentIntervalGuid'
  /** column name */
  | 'maintenancePlanDefinitionGuid'
  /** column name */
  | 'paymentInterval';

export type MaintenancePlanDefinitionAllowedPaymentIntervalsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsSetInput>;
  /** filter the rows which have to be updated */
  where: MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp;
};

/** columns and relationships of "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefits = {
  __typename?: 'MaintenancePlanDefinitionBenefits';
  createdAt: Scalars['timestamptz'];
  description: Scalars['String'];
  maintenancePlanDefinitionBenefitGuid: Scalars['uuid'];
  maintenancePlanDefinitionGuid: Scalars['uuid'];
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsAggregate = {
  __typename?: 'MaintenancePlanDefinitionBenefitsAggregate';
  aggregate?: Maybe<MaintenancePlanDefinitionBenefitsAggregateFields>;
  nodes: Array<MaintenancePlanDefinitionBenefits>;
};

export type MaintenancePlanDefinitionBenefitsAggregateBoolExp = {
  count?: InputMaybe<MaintenancePlanDefinitionBenefitsAggregateBoolExpCount>;
};

/** aggregate fields of "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsAggregateFields = {
  __typename?: 'MaintenancePlanDefinitionBenefitsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanDefinitionBenefitsMaxFields>;
  min?: Maybe<MaintenancePlanDefinitionBenefitsMinFields>;
};


/** aggregate fields of "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MaintenancePlanDefinitionBenefitsMaxOrderBy>;
  min?: InputMaybe<MaintenancePlanDefinitionBenefitsMinOrderBy>;
};

/** input type for inserting array relation for remote table "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsArrRelInsertInput = {
  data: Array<MaintenancePlanDefinitionBenefitsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanDefinitionBenefitsOnConflict>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_definition_benefits". All fields are combined with a logical 'AND'. */
export type MaintenancePlanDefinitionBenefitsBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsBoolExp>>;
  _not?: InputMaybe<MaintenancePlanDefinitionBenefitsBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  maintenancePlanDefinitionBenefitGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanDefinitionGuid?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsConstraint =
  /** unique or primary key constraint on columns "maintenance_plan_definition_benefit_guid" */
  | 'maintenance_plan_definition_benefits_pkey';

/** input type for inserting data into table "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  maintenancePlanDefinitionBenefitGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MaintenancePlanDefinitionBenefitsMaxFields = {
  __typename?: 'MaintenancePlanDefinitionBenefitsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  maintenancePlanDefinitionBenefitGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionBenefitGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MaintenancePlanDefinitionBenefitsMinFields = {
  __typename?: 'MaintenancePlanDefinitionBenefitsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  maintenancePlanDefinitionBenefitGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionBenefitGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsMutationResponse = {
  __typename?: 'MaintenancePlanDefinitionBenefitsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MaintenancePlanDefinitionBenefits>;
};

/** on_conflict condition type for table "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsOnConflict = {
  constraint: MaintenancePlanDefinitionBenefitsConstraint;
  updateColumns?: Array<MaintenancePlanDefinitionBenefitsUpdateColumn>;
  where?: InputMaybe<MaintenancePlanDefinitionBenefitsBoolExp>;
};

/** Ordering options when selecting data from "maintenance_plan_definition_benefits". */
export type MaintenancePlanDefinitionBenefitsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionBenefitGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: maintenance_plan_definition_benefits */
export type MaintenancePlanDefinitionBenefitsPkColumnsInput = {
  maintenancePlanDefinitionBenefitGuid: Scalars['uuid'];
};

/** select columns of table "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'maintenancePlanDefinitionBenefitGuid'
  /** column name */
  | 'maintenancePlanDefinitionGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  maintenancePlanDefinitionBenefitGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanDefinitionBenefitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanDefinitionBenefitsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  maintenancePlanDefinitionBenefitGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "maintenance_plan_definition_benefits" */
export type MaintenancePlanDefinitionBenefitsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'maintenancePlanDefinitionBenefitGuid'
  /** column name */
  | 'maintenancePlanDefinitionGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt';

export type MaintenancePlanDefinitionBenefitsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaintenancePlanDefinitionBenefitsSetInput>;
  /** filter the rows which have to be updated */
  where: MaintenancePlanDefinitionBenefitsBoolExp;
};

/** columns and relationships of "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscounts = {
  __typename?: 'MaintenancePlanDefinitionDiscounts';
  createdAt: Scalars['timestamptz'];
  discountJobClass: JobClassesEnum;
  discountRate: Scalars['numeric'];
  maintenancePlanDefinitionDiscountGuid: Scalars['uuid'];
  maintenancePlanDefinitionGuid: Scalars['uuid'];
};

/** aggregated selection of "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsAggregate = {
  __typename?: 'MaintenancePlanDefinitionDiscountsAggregate';
  aggregate?: Maybe<MaintenancePlanDefinitionDiscountsAggregateFields>;
  nodes: Array<MaintenancePlanDefinitionDiscounts>;
};

export type MaintenancePlanDefinitionDiscountsAggregateBoolExp = {
  count?: InputMaybe<MaintenancePlanDefinitionDiscountsAggregateBoolExpCount>;
};

/** aggregate fields of "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsAggregateFields = {
  __typename?: 'MaintenancePlanDefinitionDiscountsAggregateFields';
  avg?: Maybe<MaintenancePlanDefinitionDiscountsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanDefinitionDiscountsMaxFields>;
  min?: Maybe<MaintenancePlanDefinitionDiscountsMinFields>;
  stddev?: Maybe<MaintenancePlanDefinitionDiscountsStddevFields>;
  stddevPop?: Maybe<MaintenancePlanDefinitionDiscountsStddevPopFields>;
  stddevSamp?: Maybe<MaintenancePlanDefinitionDiscountsStddevSampFields>;
  sum?: Maybe<MaintenancePlanDefinitionDiscountsSumFields>;
  varPop?: Maybe<MaintenancePlanDefinitionDiscountsVarPopFields>;
  varSamp?: Maybe<MaintenancePlanDefinitionDiscountsVarSampFields>;
  variance?: Maybe<MaintenancePlanDefinitionDiscountsVarianceFields>;
};


/** aggregate fields of "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsAggregateOrderBy = {
  avg?: InputMaybe<MaintenancePlanDefinitionDiscountsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MaintenancePlanDefinitionDiscountsMaxOrderBy>;
  min?: InputMaybe<MaintenancePlanDefinitionDiscountsMinOrderBy>;
  stddev?: InputMaybe<MaintenancePlanDefinitionDiscountsStddevOrderBy>;
  stddevPop?: InputMaybe<MaintenancePlanDefinitionDiscountsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<MaintenancePlanDefinitionDiscountsStddevSampOrderBy>;
  sum?: InputMaybe<MaintenancePlanDefinitionDiscountsSumOrderBy>;
  varPop?: InputMaybe<MaintenancePlanDefinitionDiscountsVarPopOrderBy>;
  varSamp?: InputMaybe<MaintenancePlanDefinitionDiscountsVarSampOrderBy>;
  variance?: InputMaybe<MaintenancePlanDefinitionDiscountsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsArrRelInsertInput = {
  data: Array<MaintenancePlanDefinitionDiscountsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanDefinitionDiscountsOnConflict>;
};

/** aggregate avg on columns */
export type MaintenancePlanDefinitionDiscountsAvgFields = {
  __typename?: 'MaintenancePlanDefinitionDiscountsAvgFields';
  discountRate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsAvgOrderBy = {
  discountRate?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_definition_discounts". All fields are combined with a logical 'AND'. */
export type MaintenancePlanDefinitionDiscountsBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsBoolExp>>;
  _not?: InputMaybe<MaintenancePlanDefinitionDiscountsBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  discountJobClass?: InputMaybe<JobClassesEnumComparisonExp>;
  discountRate?: InputMaybe<NumericComparisonExp>;
  maintenancePlanDefinitionDiscountGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanDefinitionGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsConstraint =
  /** unique or primary key constraint on columns "discount_job_class", "maintenance_plan_definition_guid" */
  | 'maintenance_plan_definition_d_maintenance_plan_definition_g_key'
  /** unique or primary key constraint on columns "maintenance_plan_definition_discount_guid" */
  | 'maintenance_plan_definition_discounts_pkey';

/** input type for incrementing numeric columns in table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsIncInput = {
  discountRate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountJobClass?: InputMaybe<JobClassesEnum>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  maintenancePlanDefinitionDiscountGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type MaintenancePlanDefinitionDiscountsMaxFields = {
  __typename?: 'MaintenancePlanDefinitionDiscountsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  discountRate?: Maybe<Scalars['numeric']>;
  maintenancePlanDefinitionDiscountGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionDiscountGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MaintenancePlanDefinitionDiscountsMinFields = {
  __typename?: 'MaintenancePlanDefinitionDiscountsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  discountRate?: Maybe<Scalars['numeric']>;
  maintenancePlanDefinitionDiscountGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionDiscountGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsMutationResponse = {
  __typename?: 'MaintenancePlanDefinitionDiscountsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MaintenancePlanDefinitionDiscounts>;
};

/** on_conflict condition type for table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsOnConflict = {
  constraint: MaintenancePlanDefinitionDiscountsConstraint;
  updateColumns?: Array<MaintenancePlanDefinitionDiscountsUpdateColumn>;
  where?: InputMaybe<MaintenancePlanDefinitionDiscountsBoolExp>;
};

/** Ordering options when selecting data from "maintenance_plan_definition_discounts". */
export type MaintenancePlanDefinitionDiscountsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  discountJobClass?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionDiscountGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: maintenance_plan_definition_discounts */
export type MaintenancePlanDefinitionDiscountsPkColumnsInput = {
  maintenancePlanDefinitionDiscountGuid: Scalars['uuid'];
};

/** select columns of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'discountJobClass'
  /** column name */
  | 'discountRate'
  /** column name */
  | 'maintenancePlanDefinitionDiscountGuid'
  /** column name */
  | 'maintenancePlanDefinitionGuid';

/** input type for updating data in table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountJobClass?: InputMaybe<JobClassesEnum>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  maintenancePlanDefinitionDiscountGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type MaintenancePlanDefinitionDiscountsStddevFields = {
  __typename?: 'MaintenancePlanDefinitionDiscountsStddevFields';
  discountRate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsStddevOrderBy = {
  discountRate?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type MaintenancePlanDefinitionDiscountsStddevPopFields = {
  __typename?: 'MaintenancePlanDefinitionDiscountsStddevPopFields';
  discountRate?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsStddevPopOrderBy = {
  discountRate?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type MaintenancePlanDefinitionDiscountsStddevSampFields = {
  __typename?: 'MaintenancePlanDefinitionDiscountsStddevSampFields';
  discountRate?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsStddevSampOrderBy = {
  discountRate?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanDefinitionDiscountsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanDefinitionDiscountsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  discountJobClass?: InputMaybe<JobClassesEnum>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  maintenancePlanDefinitionDiscountGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type MaintenancePlanDefinitionDiscountsSumFields = {
  __typename?: 'MaintenancePlanDefinitionDiscountsSumFields';
  discountRate?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsSumOrderBy = {
  discountRate?: InputMaybe<OrderBy>;
};

/** update columns of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'discountJobClass'
  /** column name */
  | 'discountRate'
  /** column name */
  | 'maintenancePlanDefinitionDiscountGuid'
  /** column name */
  | 'maintenancePlanDefinitionGuid';

export type MaintenancePlanDefinitionDiscountsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MaintenancePlanDefinitionDiscountsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaintenancePlanDefinitionDiscountsSetInput>;
  /** filter the rows which have to be updated */
  where: MaintenancePlanDefinitionDiscountsBoolExp;
};

/** aggregate varPop on columns */
export type MaintenancePlanDefinitionDiscountsVarPopFields = {
  __typename?: 'MaintenancePlanDefinitionDiscountsVarPopFields';
  discountRate?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsVarPopOrderBy = {
  discountRate?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type MaintenancePlanDefinitionDiscountsVarSampFields = {
  __typename?: 'MaintenancePlanDefinitionDiscountsVarSampFields';
  discountRate?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsVarSampOrderBy = {
  discountRate?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MaintenancePlanDefinitionDiscountsVarianceFields = {
  __typename?: 'MaintenancePlanDefinitionDiscountsVarianceFields';
  discountRate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "maintenance_plan_definition_discounts" */
export type MaintenancePlanDefinitionDiscountsVarianceOrderBy = {
  discountRate?: InputMaybe<OrderBy>;
};

/** columns and relationships of "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlare = {
  __typename?: 'MaintenancePlanDefinitionFlare';
  createdAt: Scalars['timestamptz'];
  imageUrl: Scalars['String'];
  maintenancePlanDefinitionFlareGuid: Scalars['uuid'];
  maintenancePlanDefinitionGuid: Scalars['uuid'];
  /** An object relationship */
  maintenance_plan_definition: MaintenancePlanDefinitions;
  primaryColorHex: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlareAggregate = {
  __typename?: 'MaintenancePlanDefinitionFlareAggregate';
  aggregate?: Maybe<MaintenancePlanDefinitionFlareAggregateFields>;
  nodes: Array<MaintenancePlanDefinitionFlare>;
};

/** aggregate fields of "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlareAggregateFields = {
  __typename?: 'MaintenancePlanDefinitionFlareAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanDefinitionFlareMaxFields>;
  min?: Maybe<MaintenancePlanDefinitionFlareMinFields>;
};


/** aggregate fields of "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlareAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanDefinitionFlareSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_definition_flare". All fields are combined with a logical 'AND'. */
export type MaintenancePlanDefinitionFlareBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanDefinitionFlareBoolExp>>;
  _not?: InputMaybe<MaintenancePlanDefinitionFlareBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanDefinitionFlareBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  imageUrl?: InputMaybe<StringComparisonExp>;
  maintenancePlanDefinitionFlareGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanDefinitionGuid?: InputMaybe<UuidComparisonExp>;
  maintenance_plan_definition?: InputMaybe<MaintenancePlanDefinitionsBoolExp>;
  primaryColorHex?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlareConstraint =
  /** unique or primary key constraint on columns "maintenance_plan_definition_guid" */
  | 'maintenance_plan_definition_f_maintenance_plan_definition_g_key'
  /** unique or primary key constraint on columns "maintenance_plan_definition_flare_guid" */
  | 'maintenance_plan_definition_flare_pkey';

/** input type for inserting data into table "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlareInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  maintenancePlanDefinitionFlareGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  maintenance_plan_definition?: InputMaybe<MaintenancePlanDefinitionsObjRelInsertInput>;
  primaryColorHex?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MaintenancePlanDefinitionFlareMaxFields = {
  __typename?: 'MaintenancePlanDefinitionFlareMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  imageUrl?: Maybe<Scalars['String']>;
  maintenancePlanDefinitionFlareGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  primaryColorHex?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type MaintenancePlanDefinitionFlareMinFields = {
  __typename?: 'MaintenancePlanDefinitionFlareMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  imageUrl?: Maybe<Scalars['String']>;
  maintenancePlanDefinitionFlareGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  primaryColorHex?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlareMutationResponse = {
  __typename?: 'MaintenancePlanDefinitionFlareMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MaintenancePlanDefinitionFlare>;
};

/** input type for inserting object relation for remote table "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlareObjRelInsertInput = {
  data: MaintenancePlanDefinitionFlareInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanDefinitionFlareOnConflict>;
};

/** on_conflict condition type for table "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlareOnConflict = {
  constraint: MaintenancePlanDefinitionFlareConstraint;
  updateColumns?: Array<MaintenancePlanDefinitionFlareUpdateColumn>;
  where?: InputMaybe<MaintenancePlanDefinitionFlareBoolExp>;
};

/** Ordering options when selecting data from "maintenance_plan_definition_flare". */
export type MaintenancePlanDefinitionFlareOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  imageUrl?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionFlareGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
  maintenance_plan_definition?: InputMaybe<MaintenancePlanDefinitionsOrderBy>;
  primaryColorHex?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: maintenance_plan_definition_flare */
export type MaintenancePlanDefinitionFlarePkColumnsInput = {
  maintenancePlanDefinitionFlareGuid: Scalars['uuid'];
};

/** select columns of table "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlareSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'imageUrl'
  /** column name */
  | 'maintenancePlanDefinitionFlareGuid'
  /** column name */
  | 'maintenancePlanDefinitionGuid'
  /** column name */
  | 'primaryColorHex'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlareSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  maintenancePlanDefinitionFlareGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  primaryColorHex?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlareStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanDefinitionFlareStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanDefinitionFlareStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  maintenancePlanDefinitionFlareGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  primaryColorHex?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "maintenance_plan_definition_flare" */
export type MaintenancePlanDefinitionFlareUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'imageUrl'
  /** column name */
  | 'maintenancePlanDefinitionFlareGuid'
  /** column name */
  | 'maintenancePlanDefinitionGuid'
  /** column name */
  | 'primaryColorHex'
  /** column name */
  | 'updatedAt';

export type MaintenancePlanDefinitionFlareUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaintenancePlanDefinitionFlareSetInput>;
  /** filter the rows which have to be updated */
  where: MaintenancePlanDefinitionFlareBoolExp;
};

/** columns and relationships of "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfo = {
  __typename?: 'MaintenancePlanDefinitionMarketingInfo';
  createdAt: Scalars['timestamptz'];
  isAvailableForSale: Scalars['Boolean'];
  maintenancePlanDefinitionGuid: Scalars['uuid'];
  maintenancePlanDefinitionMarketingInfoGuid: Scalars['uuid'];
  name: Scalars['String'];
  shortDescription: Scalars['String'];
  termsAndConditions: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfoAggregate = {
  __typename?: 'MaintenancePlanDefinitionMarketingInfoAggregate';
  aggregate?: Maybe<MaintenancePlanDefinitionMarketingInfoAggregateFields>;
  nodes: Array<MaintenancePlanDefinitionMarketingInfo>;
};

/** aggregate fields of "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfoAggregateFields = {
  __typename?: 'MaintenancePlanDefinitionMarketingInfoAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanDefinitionMarketingInfoMaxFields>;
  min?: Maybe<MaintenancePlanDefinitionMarketingInfoMinFields>;
};


/** aggregate fields of "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfoAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanDefinitionMarketingInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_definition_marketing_info". All fields are combined with a logical 'AND'. */
export type MaintenancePlanDefinitionMarketingInfoBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanDefinitionMarketingInfoBoolExp>>;
  _not?: InputMaybe<MaintenancePlanDefinitionMarketingInfoBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanDefinitionMarketingInfoBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  isAvailableForSale?: InputMaybe<BooleanComparisonExp>;
  maintenancePlanDefinitionGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanDefinitionMarketingInfoGuid?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  shortDescription?: InputMaybe<StringComparisonExp>;
  termsAndConditions?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfoConstraint =
  /** unique or primary key constraint on columns "maintenance_plan_definition_guid" */
  | 'maintenance_plan_definition_m_maintenance_plan_definition_g_key'
  /** unique or primary key constraint on columns "maintenance_plan_definition_marketing_info_guid" */
  | 'maintenance_plan_definition_marketing_info_pkey';

/** input type for inserting data into table "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfoInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isAvailableForSale?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionMarketingInfoGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  termsAndConditions?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MaintenancePlanDefinitionMarketingInfoMaxFields = {
  __typename?: 'MaintenancePlanDefinitionMarketingInfoMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionMarketingInfoGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type MaintenancePlanDefinitionMarketingInfoMinFields = {
  __typename?: 'MaintenancePlanDefinitionMarketingInfoMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionMarketingInfoGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfoMutationResponse = {
  __typename?: 'MaintenancePlanDefinitionMarketingInfoMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MaintenancePlanDefinitionMarketingInfo>;
};

/** input type for inserting object relation for remote table "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfoObjRelInsertInput = {
  data: MaintenancePlanDefinitionMarketingInfoInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanDefinitionMarketingInfoOnConflict>;
};

/** on_conflict condition type for table "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfoOnConflict = {
  constraint: MaintenancePlanDefinitionMarketingInfoConstraint;
  updateColumns?: Array<MaintenancePlanDefinitionMarketingInfoUpdateColumn>;
  where?: InputMaybe<MaintenancePlanDefinitionMarketingInfoBoolExp>;
};

/** Ordering options when selecting data from "maintenance_plan_definition_marketing_info". */
export type MaintenancePlanDefinitionMarketingInfoOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  isAvailableForSale?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionMarketingInfoGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  shortDescription?: InputMaybe<OrderBy>;
  termsAndConditions?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: maintenance_plan_definition_marketing_info */
export type MaintenancePlanDefinitionMarketingInfoPkColumnsInput = {
  maintenancePlanDefinitionMarketingInfoGuid: Scalars['uuid'];
};

/** select columns of table "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfoSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'isAvailableForSale'
  /** column name */
  | 'maintenancePlanDefinitionGuid'
  /** column name */
  | 'maintenancePlanDefinitionMarketingInfoGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'shortDescription'
  /** column name */
  | 'termsAndConditions'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfoSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isAvailableForSale?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionMarketingInfoGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  termsAndConditions?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfoStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanDefinitionMarketingInfoStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanDefinitionMarketingInfoStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isAvailableForSale?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionMarketingInfoGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  termsAndConditions?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "maintenance_plan_definition_marketing_info" */
export type MaintenancePlanDefinitionMarketingInfoUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'isAvailableForSale'
  /** column name */
  | 'maintenancePlanDefinitionGuid'
  /** column name */
  | 'maintenancePlanDefinitionMarketingInfoGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'shortDescription'
  /** column name */
  | 'termsAndConditions'
  /** column name */
  | 'updatedAt';

export type MaintenancePlanDefinitionMarketingInfoUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaintenancePlanDefinitionMarketingInfoSetInput>;
  /** filter the rows which have to be updated */
  where: MaintenancePlanDefinitionMarketingInfoBoolExp;
};

/** columns and relationships of "maintenance_plan_definitions" */
export type MaintenancePlanDefinitions = {
  __typename?: 'MaintenancePlanDefinitions';
  /** An array relationship */
  allowedPaymentIntervals: Array<MaintenancePlanDefinitionAllowedPaymentIntervals>;
  /** An aggregate relationship */
  allowedPaymentIntervalsAggregate: MaintenancePlanDefinitionAllowedPaymentIntervalsAggregate;
  /** An array relationship */
  benefits: Array<MaintenancePlanDefinitionBenefits>;
  /** An aggregate relationship */
  benefitsAggregate: MaintenancePlanDefinitionBenefitsAggregate;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  defaultBusinessUnit?: Maybe<BusinessUnits>;
  defaultBusinessUnitGuid?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  discounts: Array<MaintenancePlanDefinitionDiscounts>;
  /** An aggregate relationship */
  discountsAggregate: MaintenancePlanDefinitionDiscountsAggregate;
  /** An object relationship */
  flare?: Maybe<MaintenancePlanDefinitionFlare>;
  maintenancePlanDefinitionGuid: Scalars['uuid'];
  /** An object relationship */
  marketingInfo?: Maybe<MaintenancePlanDefinitionMarketingInfo>;
  numDaysUntilVisitCreditExpiration: Scalars['Int'];
  numVisitCreditsPerYear: Scalars['Int'];
  visitConfigs: Scalars['MaintenancePlanVisitConfigArray'];
  yearlyStaticPriceUsc?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsAllowedPaymentIntervalsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
};


/** columns and relationships of "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsAllowedPaymentIntervalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
};


/** columns and relationships of "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsBenefitsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionBenefitsBoolExp>;
};


/** columns and relationships of "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsBenefitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionBenefitsBoolExp>;
};


/** columns and relationships of "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsDiscountsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionDiscountsBoolExp>;
};


/** columns and relationships of "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsDiscountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionDiscountsBoolExp>;
};


/** columns and relationships of "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsVisitConfigsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsAggregate = {
  __typename?: 'MaintenancePlanDefinitionsAggregate';
  aggregate?: Maybe<MaintenancePlanDefinitionsAggregateFields>;
  nodes: Array<MaintenancePlanDefinitions>;
};

/** aggregate fields of "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsAggregateFields = {
  __typename?: 'MaintenancePlanDefinitionsAggregateFields';
  avg?: Maybe<MaintenancePlanDefinitionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanDefinitionsMaxFields>;
  min?: Maybe<MaintenancePlanDefinitionsMinFields>;
  stddev?: Maybe<MaintenancePlanDefinitionsStddevFields>;
  stddevPop?: Maybe<MaintenancePlanDefinitionsStddevPopFields>;
  stddevSamp?: Maybe<MaintenancePlanDefinitionsStddevSampFields>;
  sum?: Maybe<MaintenancePlanDefinitionsSumFields>;
  varPop?: Maybe<MaintenancePlanDefinitionsVarPopFields>;
  varSamp?: Maybe<MaintenancePlanDefinitionsVarSampFields>;
  variance?: Maybe<MaintenancePlanDefinitionsVarianceFields>;
};


/** aggregate fields of "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MaintenancePlanDefinitionsAppendInput = {
  visitConfigs?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type MaintenancePlanDefinitionsAvgFields = {
  __typename?: 'MaintenancePlanDefinitionsAvgFields';
  numDaysUntilVisitCreditExpiration?: Maybe<Scalars['Float']>;
  numVisitCreditsPerYear?: Maybe<Scalars['Float']>;
  yearlyStaticPriceUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_definitions". All fields are combined with a logical 'AND'. */
export type MaintenancePlanDefinitionsBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanDefinitionsBoolExp>>;
  _not?: InputMaybe<MaintenancePlanDefinitionsBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanDefinitionsBoolExp>>;
  allowedPaymentIntervals?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
  allowedPaymentIntervalsAggregate?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExp>;
  benefits?: InputMaybe<MaintenancePlanDefinitionBenefitsBoolExp>;
  benefitsAggregate?: InputMaybe<MaintenancePlanDefinitionBenefitsAggregateBoolExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  defaultBusinessUnit?: InputMaybe<BusinessUnitsBoolExp>;
  defaultBusinessUnitGuid?: InputMaybe<UuidComparisonExp>;
  discounts?: InputMaybe<MaintenancePlanDefinitionDiscountsBoolExp>;
  discountsAggregate?: InputMaybe<MaintenancePlanDefinitionDiscountsAggregateBoolExp>;
  flare?: InputMaybe<MaintenancePlanDefinitionFlareBoolExp>;
  maintenancePlanDefinitionGuid?: InputMaybe<UuidComparisonExp>;
  marketingInfo?: InputMaybe<MaintenancePlanDefinitionMarketingInfoBoolExp>;
  numDaysUntilVisitCreditExpiration?: InputMaybe<IntComparisonExp>;
  numVisitCreditsPerYear?: InputMaybe<IntComparisonExp>;
  visitConfigs?: InputMaybe<Scalars['MaintenancePlanVisitConfigArrayComparisonExp']>;
  yearlyStaticPriceUsc?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsConstraint =
  /** unique or primary key constraint on columns "maintenance_plan_definition_guid" */
  | 'maintenance_plan_definition_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MaintenancePlanDefinitionsDeleteAtPathInput = {
  visitConfigs?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MaintenancePlanDefinitionsDeleteElemInput = {
  visitConfigs?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MaintenancePlanDefinitionsDeleteKeyInput = {
  visitConfigs?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsIncInput = {
  numDaysUntilVisitCreditExpiration?: InputMaybe<Scalars['smallint']>;
  numVisitCreditsPerYear?: InputMaybe<Scalars['smallint']>;
  yearlyStaticPriceUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsInsertInput = {
  allowedPaymentIntervals?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsArrRelInsertInput>;
  benefits?: InputMaybe<MaintenancePlanDefinitionBenefitsArrRelInsertInput>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultBusinessUnit?: InputMaybe<BusinessUnitsObjRelInsertInput>;
  defaultBusinessUnitGuid?: InputMaybe<Scalars['uuid']>;
  discounts?: InputMaybe<MaintenancePlanDefinitionDiscountsArrRelInsertInput>;
  flare?: InputMaybe<MaintenancePlanDefinitionFlareObjRelInsertInput>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  marketingInfo?: InputMaybe<MaintenancePlanDefinitionMarketingInfoObjRelInsertInput>;
  numDaysUntilVisitCreditExpiration?: InputMaybe<Scalars['Int']>;
  numVisitCreditsPerYear?: InputMaybe<Scalars['Int']>;
  visitConfigs?: InputMaybe<Scalars['MaintenancePlanVisitConfigArray']>;
  yearlyStaticPriceUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type MaintenancePlanDefinitionsMaxFields = {
  __typename?: 'MaintenancePlanDefinitionsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultBusinessUnitGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  numDaysUntilVisitCreditExpiration?: Maybe<Scalars['Int']>;
  numVisitCreditsPerYear?: Maybe<Scalars['Int']>;
  visitConfigs?: Maybe<Scalars['MaintenancePlanVisitConfigArray']>;
  yearlyStaticPriceUsc?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type MaintenancePlanDefinitionsMinFields = {
  __typename?: 'MaintenancePlanDefinitionsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultBusinessUnitGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  numDaysUntilVisitCreditExpiration?: Maybe<Scalars['Int']>;
  numVisitCreditsPerYear?: Maybe<Scalars['Int']>;
  visitConfigs?: Maybe<Scalars['MaintenancePlanVisitConfigArray']>;
  yearlyStaticPriceUsc?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsMutationResponse = {
  __typename?: 'MaintenancePlanDefinitionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MaintenancePlanDefinitions>;
};

/** input type for inserting object relation for remote table "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsObjRelInsertInput = {
  data: MaintenancePlanDefinitionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanDefinitionsOnConflict>;
};

/** on_conflict condition type for table "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsOnConflict = {
  constraint: MaintenancePlanDefinitionsConstraint;
  updateColumns?: Array<MaintenancePlanDefinitionsUpdateColumn>;
  where?: InputMaybe<MaintenancePlanDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "maintenance_plan_definitions". */
export type MaintenancePlanDefinitionsOrderBy = {
  allowedPaymentIntervalsAggregate?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateOrderBy>;
  benefitsAggregate?: InputMaybe<MaintenancePlanDefinitionBenefitsAggregateOrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  defaultBusinessUnit?: InputMaybe<BusinessUnitsOrderBy>;
  defaultBusinessUnitGuid?: InputMaybe<OrderBy>;
  discountsAggregate?: InputMaybe<MaintenancePlanDefinitionDiscountsAggregateOrderBy>;
  flare?: InputMaybe<MaintenancePlanDefinitionFlareOrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
  marketingInfo?: InputMaybe<MaintenancePlanDefinitionMarketingInfoOrderBy>;
  numDaysUntilVisitCreditExpiration?: InputMaybe<OrderBy>;
  numVisitCreditsPerYear?: InputMaybe<OrderBy>;
  visitConfigs?: InputMaybe<OrderBy>;
  yearlyStaticPriceUsc?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: maintenance_plan_definitions */
export type MaintenancePlanDefinitionsPkColumnsInput = {
  maintenancePlanDefinitionGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MaintenancePlanDefinitionsPrependInput = {
  visitConfigs?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'defaultBusinessUnitGuid'
  /** column name */
  | 'maintenancePlanDefinitionGuid'
  /** column name */
  | 'numDaysUntilVisitCreditExpiration'
  /** column name */
  | 'numVisitCreditsPerYear'
  /** column name */
  | 'visitConfigs'
  /** column name */
  | 'yearlyStaticPriceUsc';

/** input type for updating data in table "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultBusinessUnitGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  numDaysUntilVisitCreditExpiration?: InputMaybe<Scalars['Int']>;
  numVisitCreditsPerYear?: InputMaybe<Scalars['Int']>;
  visitConfigs?: InputMaybe<Scalars['MaintenancePlanVisitConfigArray']>;
  yearlyStaticPriceUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type MaintenancePlanDefinitionsStddevFields = {
  __typename?: 'MaintenancePlanDefinitionsStddevFields';
  numDaysUntilVisitCreditExpiration?: Maybe<Scalars['Float']>;
  numVisitCreditsPerYear?: Maybe<Scalars['Float']>;
  yearlyStaticPriceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type MaintenancePlanDefinitionsStddevPopFields = {
  __typename?: 'MaintenancePlanDefinitionsStddevPopFields';
  numDaysUntilVisitCreditExpiration?: Maybe<Scalars['Float']>;
  numVisitCreditsPerYear?: Maybe<Scalars['Float']>;
  yearlyStaticPriceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type MaintenancePlanDefinitionsStddevSampFields = {
  __typename?: 'MaintenancePlanDefinitionsStddevSampFields';
  numDaysUntilVisitCreditExpiration?: Maybe<Scalars['Float']>;
  numVisitCreditsPerYear?: Maybe<Scalars['Float']>;
  yearlyStaticPriceUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanDefinitionsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultBusinessUnitGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  numDaysUntilVisitCreditExpiration?: InputMaybe<Scalars['Int']>;
  numVisitCreditsPerYear?: InputMaybe<Scalars['Int']>;
  visitConfigs?: InputMaybe<Scalars['MaintenancePlanVisitConfigArray']>;
  yearlyStaticPriceUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type MaintenancePlanDefinitionsSumFields = {
  __typename?: 'MaintenancePlanDefinitionsSumFields';
  numDaysUntilVisitCreditExpiration?: Maybe<Scalars['smallint']>;
  numVisitCreditsPerYear?: Maybe<Scalars['smallint']>;
  yearlyStaticPriceUsc?: Maybe<Scalars['Int']>;
};

/** update columns of table "maintenance_plan_definitions" */
export type MaintenancePlanDefinitionsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'defaultBusinessUnitGuid'
  /** column name */
  | 'maintenancePlanDefinitionGuid'
  /** column name */
  | 'numDaysUntilVisitCreditExpiration'
  /** column name */
  | 'numVisitCreditsPerYear'
  /** column name */
  | 'visitConfigs'
  /** column name */
  | 'yearlyStaticPriceUsc';

export type MaintenancePlanDefinitionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MaintenancePlanDefinitionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<MaintenancePlanDefinitionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<MaintenancePlanDefinitionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<MaintenancePlanDefinitionsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MaintenancePlanDefinitionsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MaintenancePlanDefinitionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaintenancePlanDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: MaintenancePlanDefinitionsBoolExp;
};

/** aggregate varPop on columns */
export type MaintenancePlanDefinitionsVarPopFields = {
  __typename?: 'MaintenancePlanDefinitionsVarPopFields';
  numDaysUntilVisitCreditExpiration?: Maybe<Scalars['Float']>;
  numVisitCreditsPerYear?: Maybe<Scalars['Float']>;
  yearlyStaticPriceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type MaintenancePlanDefinitionsVarSampFields = {
  __typename?: 'MaintenancePlanDefinitionsVarSampFields';
  numDaysUntilVisitCreditExpiration?: Maybe<Scalars['Float']>;
  numVisitCreditsPerYear?: Maybe<Scalars['Float']>;
  yearlyStaticPriceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MaintenancePlanDefinitionsVarianceFields = {
  __typename?: 'MaintenancePlanDefinitionsVarianceFields';
  numDaysUntilVisitCreditExpiration?: Maybe<Scalars['Float']>;
  numVisitCreditsPerYear?: Maybe<Scalars['Float']>;
  yearlyStaticPriceUsc?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitions = {
  __typename?: 'MaintenancePlanEquipmentCoverageDefinitions';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  equipmentType: Scalars['String'];
  isAvailableForSale: Scalars['Boolean'];
  maintenancePlanEquipmentCoverageDefinitionGuid: Scalars['uuid'];
  /** An array relationship */
  pricings: Array<MaintenancePlanEquipmentCoveragePricings>;
  /** An aggregate relationship */
  pricingsAggregate: MaintenancePlanEquipmentCoveragePricingsAggregate;
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsPricingsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsBoolExp>;
};


/** columns and relationships of "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsPricingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsBoolExp>;
};

/** aggregated selection of "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsAggregate = {
  __typename?: 'MaintenancePlanEquipmentCoverageDefinitionsAggregate';
  aggregate?: Maybe<MaintenancePlanEquipmentCoverageDefinitionsAggregateFields>;
  nodes: Array<MaintenancePlanEquipmentCoverageDefinitions>;
};

export type MaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExp = {
  bool_and?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExpBool_Or>;
  count?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExpCount>;
};

/** aggregate fields of "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsAggregateFields = {
  __typename?: 'MaintenancePlanEquipmentCoverageDefinitionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanEquipmentCoverageDefinitionsMaxFields>;
  min?: Maybe<MaintenancePlanEquipmentCoverageDefinitionsMinFields>;
};


/** aggregate fields of "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsMaxOrderBy>;
  min?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsArrRelInsertInput = {
  data: Array<MaintenancePlanEquipmentCoverageDefinitionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsOnConflict>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_equipment_coverage_definitions". All fields are combined with a logical 'AND'. */
export type MaintenancePlanEquipmentCoverageDefinitionsBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>>;
  _not?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  equipmentType?: InputMaybe<StringComparisonExp>;
  isAvailableForSale?: InputMaybe<BooleanComparisonExp>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<UuidComparisonExp>;
  pricings?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsBoolExp>;
  pricingsAggregate?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsAggregateBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsConstraint =
  /** unique or primary key constraint on columns "equipment_type", "company_guid" */
  | 'maintenance_plan_equipment_cove_company_guid_equipment_type_key'
  /** unique or primary key constraint on columns "maintenance_plan_equipment_coverage_definition_guid" */
  | 'maintenance_plan_equipment_coverage_definitions_pkey';

/** input type for inserting data into table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  equipmentType?: InputMaybe<Scalars['String']>;
  isAvailableForSale?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  pricings?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsArrRelInsertInput>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type MaintenancePlanEquipmentCoverageDefinitionsMaxFields = {
  __typename?: 'MaintenancePlanEquipmentCoverageDefinitionsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  equipmentType?: Maybe<Scalars['String']>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  equipmentType?: InputMaybe<OrderBy>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MaintenancePlanEquipmentCoverageDefinitionsMinFields = {
  __typename?: 'MaintenancePlanEquipmentCoverageDefinitionsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  equipmentType?: Maybe<Scalars['String']>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  equipmentType?: InputMaybe<OrderBy>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsMutationResponse = {
  __typename?: 'MaintenancePlanEquipmentCoverageDefinitionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MaintenancePlanEquipmentCoverageDefinitions>;
};

/** input type for inserting object relation for remote table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsObjRelInsertInput = {
  data: MaintenancePlanEquipmentCoverageDefinitionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsOnConflict>;
};

/** on_conflict condition type for table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsOnConflict = {
  constraint: MaintenancePlanEquipmentCoverageDefinitionsConstraint;
  updateColumns?: Array<MaintenancePlanEquipmentCoverageDefinitionsUpdateColumn>;
  where?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "maintenance_plan_equipment_coverage_definitions". */
export type MaintenancePlanEquipmentCoverageDefinitionsOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  equipmentType?: InputMaybe<OrderBy>;
  isAvailableForSale?: InputMaybe<OrderBy>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<OrderBy>;
  pricingsAggregate?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsAggregateOrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: maintenance_plan_equipment_coverage_definitions */
export type MaintenancePlanEquipmentCoverageDefinitionsPkColumnsInput = {
  maintenancePlanEquipmentCoverageDefinitionGuid: Scalars['uuid'];
};

/** select columns of table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'equipmentType'
  /** column name */
  | 'isAvailableForSale'
  /** column name */
  | 'maintenancePlanEquipmentCoverageDefinitionGuid';

/** select "maintenancePlanEquipmentCoverageDefinitionsAggregateBoolExpBool_andArgumentsColumns" columns of table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsSelectColumnMaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isAvailableForSale';

/** select "maintenancePlanEquipmentCoverageDefinitionsAggregateBoolExpBool_orArgumentsColumns" columns of table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsSelectColumnMaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isAvailableForSale';

/** input type for updating data in table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  equipmentType?: InputMaybe<Scalars['String']>;
  isAvailableForSale?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanEquipmentCoverageDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanEquipmentCoverageDefinitionsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  equipmentType?: InputMaybe<Scalars['String']>;
  isAvailableForSale?: InputMaybe<Scalars['Boolean']>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "maintenance_plan_equipment_coverage_definitions" */
export type MaintenancePlanEquipmentCoverageDefinitionsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'equipmentType'
  /** column name */
  | 'isAvailableForSale'
  /** column name */
  | 'maintenancePlanEquipmentCoverageDefinitionGuid';

export type MaintenancePlanEquipmentCoverageDefinitionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: MaintenancePlanEquipmentCoverageDefinitionsBoolExp;
};

/** columns and relationships of "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricings = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricings';
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  maintenancePlanEquipmentCoverageDefinitionGuid: Scalars['uuid'];
  maintenancePlanEquipmentCoveragePricingGuid: Scalars['uuid'];
  /** An object relationship */
  maintenance_plan_equipment_coverage_definition: MaintenancePlanEquipmentCoverageDefinitions;
  planPricePerServiceUsd: Scalars['numeric'];
  regularPricePerServiceUsd: Scalars['numeric'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsAggregate = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsAggregate';
  aggregate?: Maybe<MaintenancePlanEquipmentCoveragePricingsAggregateFields>;
  nodes: Array<MaintenancePlanEquipmentCoveragePricings>;
};

export type MaintenancePlanEquipmentCoveragePricingsAggregateBoolExp = {
  count?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsAggregateBoolExpCount>;
};

/** aggregate fields of "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsAggregateFields = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsAggregateFields';
  avg?: Maybe<MaintenancePlanEquipmentCoveragePricingsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanEquipmentCoveragePricingsMaxFields>;
  min?: Maybe<MaintenancePlanEquipmentCoveragePricingsMinFields>;
  stddev?: Maybe<MaintenancePlanEquipmentCoveragePricingsStddevFields>;
  stddevPop?: Maybe<MaintenancePlanEquipmentCoveragePricingsStddevPopFields>;
  stddevSamp?: Maybe<MaintenancePlanEquipmentCoveragePricingsStddevSampFields>;
  sum?: Maybe<MaintenancePlanEquipmentCoveragePricingsSumFields>;
  varPop?: Maybe<MaintenancePlanEquipmentCoveragePricingsVarPopFields>;
  varSamp?: Maybe<MaintenancePlanEquipmentCoveragePricingsVarSampFields>;
  variance?: Maybe<MaintenancePlanEquipmentCoveragePricingsVarianceFields>;
};


/** aggregate fields of "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsAggregateOrderBy = {
  avg?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsMaxOrderBy>;
  min?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsMinOrderBy>;
  stddev?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsStddevOrderBy>;
  stddevPop?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsStddevSampOrderBy>;
  sum?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsSumOrderBy>;
  varPop?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsVarPopOrderBy>;
  varSamp?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsVarSampOrderBy>;
  variance?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsArrRelInsertInput = {
  data: Array<MaintenancePlanEquipmentCoveragePricingsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsOnConflict>;
};

/** aggregate avg on columns */
export type MaintenancePlanEquipmentCoveragePricingsAvgFields = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsAvgFields';
  planPricePerServiceUsd?: Maybe<Scalars['Float']>;
  regularPricePerServiceUsd?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsAvgOrderBy = {
  planPricePerServiceUsd?: InputMaybe<OrderBy>;
  regularPricePerServiceUsd?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_equipment_coverage_pricings". All fields are combined with a logical 'AND'. */
export type MaintenancePlanEquipmentCoveragePricingsBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsBoolExp>>;
  _not?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanEquipmentCoveragePricingGuid?: InputMaybe<UuidComparisonExp>;
  maintenance_plan_equipment_coverage_definition?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
  planPricePerServiceUsd?: InputMaybe<NumericComparisonExp>;
  regularPricePerServiceUsd?: InputMaybe<NumericComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsConstraint =
  /** unique or primary key constraint on columns "maintenance_plan_equipment_coverage_pricing_guid" */
  | 'maintenance_plan_equipment_coverage_pricings_pkey';

/** input type for incrementing numeric columns in table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsIncInput = {
  planPricePerServiceUsd?: InputMaybe<Scalars['numeric']>;
  regularPricePerServiceUsd?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanEquipmentCoveragePricingGuid?: InputMaybe<Scalars['uuid']>;
  maintenance_plan_equipment_coverage_definition?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsObjRelInsertInput>;
  planPricePerServiceUsd?: InputMaybe<Scalars['numeric']>;
  regularPricePerServiceUsd?: InputMaybe<Scalars['numeric']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type MaintenancePlanEquipmentCoveragePricingsMaxFields = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanEquipmentCoveragePricingGuid?: Maybe<Scalars['uuid']>;
  planPricePerServiceUsd?: Maybe<Scalars['numeric']>;
  regularPricePerServiceUsd?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<OrderBy>;
  maintenancePlanEquipmentCoveragePricingGuid?: InputMaybe<OrderBy>;
  planPricePerServiceUsd?: InputMaybe<OrderBy>;
  regularPricePerServiceUsd?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MaintenancePlanEquipmentCoveragePricingsMinFields = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanEquipmentCoveragePricingGuid?: Maybe<Scalars['uuid']>;
  planPricePerServiceUsd?: Maybe<Scalars['numeric']>;
  regularPricePerServiceUsd?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<OrderBy>;
  maintenancePlanEquipmentCoveragePricingGuid?: InputMaybe<OrderBy>;
  planPricePerServiceUsd?: InputMaybe<OrderBy>;
  regularPricePerServiceUsd?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsMutationResponse = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MaintenancePlanEquipmentCoveragePricings>;
};

/** on_conflict condition type for table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsOnConflict = {
  constraint: MaintenancePlanEquipmentCoveragePricingsConstraint;
  updateColumns?: Array<MaintenancePlanEquipmentCoveragePricingsUpdateColumn>;
  where?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsBoolExp>;
};

/** Ordering options when selecting data from "maintenance_plan_equipment_coverage_pricings". */
export type MaintenancePlanEquipmentCoveragePricingsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<OrderBy>;
  maintenancePlanEquipmentCoveragePricingGuid?: InputMaybe<OrderBy>;
  maintenance_plan_equipment_coverage_definition?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsOrderBy>;
  planPricePerServiceUsd?: InputMaybe<OrderBy>;
  regularPricePerServiceUsd?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: maintenance_plan_equipment_coverage_pricings */
export type MaintenancePlanEquipmentCoveragePricingsPkColumnsInput = {
  maintenancePlanEquipmentCoveragePricingGuid: Scalars['uuid'];
};

/** select columns of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'maintenancePlanEquipmentCoverageDefinitionGuid'
  /** column name */
  | 'maintenancePlanEquipmentCoveragePricingGuid'
  /** column name */
  | 'planPricePerServiceUsd'
  /** column name */
  | 'regularPricePerServiceUsd';

/** input type for updating data in table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanEquipmentCoveragePricingGuid?: InputMaybe<Scalars['uuid']>;
  planPricePerServiceUsd?: InputMaybe<Scalars['numeric']>;
  regularPricePerServiceUsd?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type MaintenancePlanEquipmentCoveragePricingsStddevFields = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsStddevFields';
  planPricePerServiceUsd?: Maybe<Scalars['Float']>;
  regularPricePerServiceUsd?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsStddevOrderBy = {
  planPricePerServiceUsd?: InputMaybe<OrderBy>;
  regularPricePerServiceUsd?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type MaintenancePlanEquipmentCoveragePricingsStddevPopFields = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsStddevPopFields';
  planPricePerServiceUsd?: Maybe<Scalars['Float']>;
  regularPricePerServiceUsd?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsStddevPopOrderBy = {
  planPricePerServiceUsd?: InputMaybe<OrderBy>;
  regularPricePerServiceUsd?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type MaintenancePlanEquipmentCoveragePricingsStddevSampFields = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsStddevSampFields';
  planPricePerServiceUsd?: Maybe<Scalars['Float']>;
  regularPricePerServiceUsd?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsStddevSampOrderBy = {
  planPricePerServiceUsd?: InputMaybe<OrderBy>;
  regularPricePerServiceUsd?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanEquipmentCoveragePricingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanEquipmentCoveragePricingsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanEquipmentCoverageDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanEquipmentCoveragePricingGuid?: InputMaybe<Scalars['uuid']>;
  planPricePerServiceUsd?: InputMaybe<Scalars['numeric']>;
  regularPricePerServiceUsd?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type MaintenancePlanEquipmentCoveragePricingsSumFields = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsSumFields';
  planPricePerServiceUsd?: Maybe<Scalars['numeric']>;
  regularPricePerServiceUsd?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsSumOrderBy = {
  planPricePerServiceUsd?: InputMaybe<OrderBy>;
  regularPricePerServiceUsd?: InputMaybe<OrderBy>;
};

/** update columns of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'maintenancePlanEquipmentCoverageDefinitionGuid'
  /** column name */
  | 'maintenancePlanEquipmentCoveragePricingGuid'
  /** column name */
  | 'planPricePerServiceUsd'
  /** column name */
  | 'regularPricePerServiceUsd';

export type MaintenancePlanEquipmentCoveragePricingsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsSetInput>;
  /** filter the rows which have to be updated */
  where: MaintenancePlanEquipmentCoveragePricingsBoolExp;
};

/** aggregate varPop on columns */
export type MaintenancePlanEquipmentCoveragePricingsVarPopFields = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsVarPopFields';
  planPricePerServiceUsd?: Maybe<Scalars['Float']>;
  regularPricePerServiceUsd?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsVarPopOrderBy = {
  planPricePerServiceUsd?: InputMaybe<OrderBy>;
  regularPricePerServiceUsd?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type MaintenancePlanEquipmentCoveragePricingsVarSampFields = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsVarSampFields';
  planPricePerServiceUsd?: Maybe<Scalars['Float']>;
  regularPricePerServiceUsd?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsVarSampOrderBy = {
  planPricePerServiceUsd?: InputMaybe<OrderBy>;
  regularPricePerServiceUsd?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MaintenancePlanEquipmentCoveragePricingsVarianceFields = {
  __typename?: 'MaintenancePlanEquipmentCoveragePricingsVarianceFields';
  planPricePerServiceUsd?: Maybe<Scalars['Float']>;
  regularPricePerServiceUsd?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "maintenance_plan_equipment_coverage_pricings" */
export type MaintenancePlanEquipmentCoveragePricingsVarianceOrderBy = {
  planPricePerServiceUsd?: InputMaybe<OrderBy>;
  regularPricePerServiceUsd?: InputMaybe<OrderBy>;
};

/** columns and relationships of "maintenance_plan_invoices" */
export type MaintenancePlanInvoices = {
  __typename?: 'MaintenancePlanInvoices';
  /** An object relationship */
  invoice: Invoices;
  invoiceGuid: Scalars['uuid'];
  /** An object relationship */
  maintenancePlan?: Maybe<MaintenancePlansQueryable>;
  maintenancePlanGuid: Scalars['uuid'];
};

/** aggregated selection of "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesAggregate = {
  __typename?: 'MaintenancePlanInvoicesAggregate';
  aggregate?: Maybe<MaintenancePlanInvoicesAggregateFields>;
  nodes: Array<MaintenancePlanInvoices>;
};

export type MaintenancePlanInvoicesAggregateBoolExp = {
  count?: InputMaybe<MaintenancePlanInvoicesAggregateBoolExpCount>;
};

/** aggregate fields of "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesAggregateFields = {
  __typename?: 'MaintenancePlanInvoicesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanInvoicesMaxFields>;
  min?: Maybe<MaintenancePlanInvoicesMinFields>;
};


/** aggregate fields of "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MaintenancePlanInvoicesMaxOrderBy>;
  min?: InputMaybe<MaintenancePlanInvoicesMinOrderBy>;
};

/** input type for inserting array relation for remote table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesArrRelInsertInput = {
  data: Array<MaintenancePlanInvoicesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanInvoicesOnConflict>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_invoices". All fields are combined with a logical 'AND'. */
export type MaintenancePlanInvoicesBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanInvoicesBoolExp>>;
  _not?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanInvoicesBoolExp>>;
  invoice?: InputMaybe<InvoicesBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableBoolExp>;
  maintenancePlanGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesConstraint =
  /** unique or primary key constraint on columns "invoice_guid" */
  | 'maintenance_plan_invoices_pkey';

/** input type for inserting data into table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesInsertInput = {
  invoice?: InputMaybe<InvoicesObjRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableObjRelInsertInput>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type MaintenancePlanInvoicesMaxFields = {
  __typename?: 'MaintenancePlanInvoicesMaxFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesMaxOrderBy = {
  invoiceGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MaintenancePlanInvoicesMinFields = {
  __typename?: 'MaintenancePlanInvoicesMinFields';
  invoiceGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesMinOrderBy = {
  invoiceGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesMutationResponse = {
  __typename?: 'MaintenancePlanInvoicesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MaintenancePlanInvoices>;
};

/** input type for inserting object relation for remote table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesObjRelInsertInput = {
  data: MaintenancePlanInvoicesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanInvoicesOnConflict>;
};

/** on_conflict condition type for table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesOnConflict = {
  constraint: MaintenancePlanInvoicesConstraint;
  updateColumns?: Array<MaintenancePlanInvoicesUpdateColumn>;
  where?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
};

/** Ordering options when selecting data from "maintenance_plan_invoices". */
export type MaintenancePlanInvoicesOrderBy = {
  invoice?: InputMaybe<InvoicesOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableOrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: maintenance_plan_invoices */
export type MaintenancePlanInvoicesPkColumnsInput = {
  invoiceGuid: Scalars['uuid'];
};

/** select columns of table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesSelectColumn =
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'maintenancePlanGuid';

/** input type for updating data in table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesSetInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanInvoicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanInvoicesStreamCursorValueInput = {
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "maintenance_plan_invoices" */
export type MaintenancePlanInvoicesUpdateColumn =
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'maintenancePlanGuid';

export type MaintenancePlanInvoicesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaintenancePlanInvoicesSetInput>;
  /** filter the rows which have to be updated */
  where: MaintenancePlanInvoicesBoolExp;
};

/** This view represents the next visit for each maintenance plan, considering the priority order of SCHEDULED visits, then UNSCHEDULED/OVERDUE visits within one month (in descending order), and finally future UNSCHEDULED visits. */
export type MaintenancePlanNextVisits = {
  __typename?: 'MaintenancePlanNextVisits';
  affinityDate?: Maybe<Scalars['date']>;
  /** A computed field to format the affinity date of the mp next visit. e.g 2024-07-01 -> July 2024 */
  affinityDateStr?: Maybe<Scalars['String']>;
  companyGuid: Scalars['uuid'];
  completedAtOverride?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dueAt: Scalars['timestamptz'];
  expiresAt: Scalars['timestamptz'];
  isCompletedOverride?: Maybe<Scalars['Boolean']>;
  isExpiredOverride?: Maybe<Scalars['Boolean']>;
  issuedAt: Scalars['timestamptz'];
  /** An object relationship */
  job?: Maybe<Jobs>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid: Scalars['uuid'];
  maintenancePlanVisitGuid: Scalars['uuid'];
  /** An array relationship */
  maintenancePlanVisitInstalledEquipments: Array<MaintenancePlanVisitInstalledEquipments>;
  /** An aggregate relationship */
  maintenancePlanVisitInstalledEquipmentsAggregate: MaintenancePlanVisitInstalledEquipmentsAggregate;
  /** An object relationship */
  maintenancePlansQueryable?: Maybe<MaintenancePlansQueryable>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitNote?: Maybe<Scalars['String']>;
  visitNumber?: Maybe<Scalars['bigint']>;
  visitReminderLastSentAt?: Maybe<Scalars['timestamptz']>;
  visitStatus?: Maybe<Scalars['String']>;
};


/** This view represents the next visit for each maintenance plan, considering the priority order of SCHEDULED visits, then UNSCHEDULED/OVERDUE visits within one month (in descending order), and finally future UNSCHEDULED visits. */
export type MaintenancePlanNextVisitsMaintenancePlanVisitInstalledEquipmentsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
};


/** This view represents the next visit for each maintenance plan, considering the priority order of SCHEDULED visits, then UNSCHEDULED/OVERDUE visits within one month (in descending order), and finally future UNSCHEDULED visits. */
export type MaintenancePlanNextVisitsMaintenancePlanVisitInstalledEquipmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
};

/** aggregated selection of "maintenance_plan_next_visits" */
export type MaintenancePlanNextVisitsAggregate = {
  __typename?: 'MaintenancePlanNextVisitsAggregate';
  aggregate?: Maybe<MaintenancePlanNextVisitsAggregateFields>;
  nodes: Array<MaintenancePlanNextVisits>;
};

/** aggregate fields of "maintenance_plan_next_visits" */
export type MaintenancePlanNextVisitsAggregateFields = {
  __typename?: 'MaintenancePlanNextVisitsAggregateFields';
  avg?: Maybe<MaintenancePlanNextVisitsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanNextVisitsMaxFields>;
  min?: Maybe<MaintenancePlanNextVisitsMinFields>;
  stddev?: Maybe<MaintenancePlanNextVisitsStddevFields>;
  stddevPop?: Maybe<MaintenancePlanNextVisitsStddevPopFields>;
  stddevSamp?: Maybe<MaintenancePlanNextVisitsStddevSampFields>;
  sum?: Maybe<MaintenancePlanNextVisitsSumFields>;
  varPop?: Maybe<MaintenancePlanNextVisitsVarPopFields>;
  varSamp?: Maybe<MaintenancePlanNextVisitsVarSampFields>;
  variance?: Maybe<MaintenancePlanNextVisitsVarianceFields>;
};


/** aggregate fields of "maintenance_plan_next_visits" */
export type MaintenancePlanNextVisitsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanNextVisitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type MaintenancePlanNextVisitsAvgFields = {
  __typename?: 'MaintenancePlanNextVisitsAvgFields';
  visitNumber?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_next_visits". All fields are combined with a logical 'AND'. */
export type MaintenancePlanNextVisitsBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanNextVisitsBoolExp>>;
  _not?: InputMaybe<MaintenancePlanNextVisitsBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanNextVisitsBoolExp>>;
  affinityDate?: InputMaybe<DateComparisonExp>;
  affinityDateStr?: InputMaybe<StringComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  completedAtOverride?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dueAt?: InputMaybe<TimestamptzComparisonExp>;
  expiresAt?: InputMaybe<TimestamptzComparisonExp>;
  isCompletedOverride?: InputMaybe<BooleanComparisonExp>;
  isExpiredOverride?: InputMaybe<BooleanComparisonExp>;
  issuedAt?: InputMaybe<TimestamptzComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  jobTypeGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanVisitGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanVisitInstalledEquipments?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
  maintenancePlanVisitInstalledEquipmentsAggregate?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsAggregateBoolExp>;
  maintenancePlansQueryable?: InputMaybe<MaintenancePlansQueryableBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  visitNote?: InputMaybe<StringComparisonExp>;
  visitNumber?: InputMaybe<BigintComparisonExp>;
  visitReminderLastSentAt?: InputMaybe<TimestamptzComparisonExp>;
  visitStatus?: InputMaybe<StringComparisonExp>;
};

/** input type for inserting data into table "maintenance_plan_next_visits" */
export type MaintenancePlanNextVisitsInsertInput = {
  affinityDate?: InputMaybe<Scalars['date']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAtOverride?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  isCompletedOverride?: InputMaybe<Scalars['Boolean']>;
  isExpiredOverride?: InputMaybe<Scalars['Boolean']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitInstalledEquipments?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsArrRelInsertInput>;
  maintenancePlansQueryable?: InputMaybe<MaintenancePlansQueryableObjRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visitNote?: InputMaybe<Scalars['String']>;
  visitNumber?: InputMaybe<Scalars['bigint']>;
  visitReminderLastSentAt?: InputMaybe<Scalars['timestamptz']>;
  visitStatus?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type MaintenancePlanNextVisitsMaxFields = {
  __typename?: 'MaintenancePlanNextVisitsMaxFields';
  affinityDate?: Maybe<Scalars['date']>;
  /** A computed field to format the affinity date of the mp next visit. e.g 2024-07-01 -> July 2024 */
  affinityDateStr?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAtOverride?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitNote?: Maybe<Scalars['String']>;
  visitNumber?: Maybe<Scalars['bigint']>;
  visitReminderLastSentAt?: Maybe<Scalars['timestamptz']>;
  visitStatus?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MaintenancePlanNextVisitsMinFields = {
  __typename?: 'MaintenancePlanNextVisitsMinFields';
  affinityDate?: Maybe<Scalars['date']>;
  /** A computed field to format the affinity date of the mp next visit. e.g 2024-07-01 -> July 2024 */
  affinityDateStr?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAtOverride?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitNote?: Maybe<Scalars['String']>;
  visitNumber?: Maybe<Scalars['bigint']>;
  visitReminderLastSentAt?: Maybe<Scalars['timestamptz']>;
  visitStatus?: Maybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "maintenance_plan_next_visits" */
export type MaintenancePlanNextVisitsObjRelInsertInput = {
  data: MaintenancePlanNextVisitsInsertInput;
};

/** Ordering options when selecting data from "maintenance_plan_next_visits". */
export type MaintenancePlanNextVisitsOrderBy = {
  affinityDate?: InputMaybe<OrderBy>;
  affinityDateStr?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  completedAtOverride?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  isCompletedOverride?: InputMaybe<OrderBy>;
  isExpiredOverride?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitInstalledEquipmentsAggregate?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsAggregateOrderBy>;
  maintenancePlansQueryable?: InputMaybe<MaintenancePlansQueryableOrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  visitNote?: InputMaybe<OrderBy>;
  visitNumber?: InputMaybe<OrderBy>;
  visitReminderLastSentAt?: InputMaybe<OrderBy>;
  visitStatus?: InputMaybe<OrderBy>;
};

/** select columns of table "maintenance_plan_next_visits" */
export type MaintenancePlanNextVisitsSelectColumn =
  /** column name */
  | 'affinityDate'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'completedAtOverride'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'expiresAt'
  /** column name */
  | 'isCompletedOverride'
  /** column name */
  | 'isExpiredOverride'
  /** column name */
  | 'issuedAt'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'maintenancePlanVisitGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'visitNote'
  /** column name */
  | 'visitNumber'
  /** column name */
  | 'visitReminderLastSentAt'
  /** column name */
  | 'visitStatus';

export type MaintenancePlanNextVisitsSetInput = {
  __typename?: 'MaintenancePlanNextVisitsSetInput';
  companyGuid?: Maybe<Scalars['uuid']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type MaintenancePlanNextVisitsStddevFields = {
  __typename?: 'MaintenancePlanNextVisitsStddevFields';
  visitNumber?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type MaintenancePlanNextVisitsStddevPopFields = {
  __typename?: 'MaintenancePlanNextVisitsStddevPopFields';
  visitNumber?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type MaintenancePlanNextVisitsStddevSampFields = {
  __typename?: 'MaintenancePlanNextVisitsStddevSampFields';
  visitNumber?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "maintenance_plan_next_visits" */
export type MaintenancePlanNextVisitsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanNextVisitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanNextVisitsStreamCursorValueInput = {
  affinityDate?: InputMaybe<Scalars['date']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAtOverride?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  isCompletedOverride?: InputMaybe<Scalars['Boolean']>;
  isExpiredOverride?: InputMaybe<Scalars['Boolean']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visitNote?: InputMaybe<Scalars['String']>;
  visitNumber?: InputMaybe<Scalars['bigint']>;
  visitReminderLastSentAt?: InputMaybe<Scalars['timestamptz']>;
  visitStatus?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type MaintenancePlanNextVisitsSumFields = {
  __typename?: 'MaintenancePlanNextVisitsSumFields';
  visitNumber?: Maybe<Scalars['bigint']>;
};

/** aggregate varPop on columns */
export type MaintenancePlanNextVisitsVarPopFields = {
  __typename?: 'MaintenancePlanNextVisitsVarPopFields';
  visitNumber?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type MaintenancePlanNextVisitsVarSampFields = {
  __typename?: 'MaintenancePlanNextVisitsVarSampFields';
  visitNumber?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MaintenancePlanNextVisitsVarianceFields = {
  __typename?: 'MaintenancePlanNextVisitsVarianceFields';
  visitNumber?: Maybe<Scalars['Float']>;
};

export { MaintenancePlanPaymentFlowTypesEnum };

/** Boolean expression to compare columns of type "MaintenancePlanPaymentFlowTypesEnum". All fields are combined with logical 'AND'. */
export type MaintenancePlanPaymentFlowTypesEnumComparisonExp = {
  _eq?: InputMaybe<MaintenancePlanPaymentFlowTypesEnum>;
  _in?: InputMaybe<Array<MaintenancePlanPaymentFlowTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<MaintenancePlanPaymentFlowTypesEnum>;
  _nin?: InputMaybe<Array<MaintenancePlanPaymentFlowTypesEnum>>;
};

/** columns and relationships of "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipments = {
  __typename?: 'MaintenancePlanVisitInstalledEquipments';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  /** An object relationship */
  installedEquipment: InstalledEquipment;
  installedEquipmentGuid: Scalars['uuid'];
  /** An object relationship */
  maintenancePlanVisit: MaintenancePlanVisits;
  maintenancePlanVisitGuid: Scalars['uuid'];
  maintenancePlanVisitInstalledEquipmentGuid: Scalars['uuid'];
};

/** aggregated selection of "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsAggregate = {
  __typename?: 'MaintenancePlanVisitInstalledEquipmentsAggregate';
  aggregate?: Maybe<MaintenancePlanVisitInstalledEquipmentsAggregateFields>;
  nodes: Array<MaintenancePlanVisitInstalledEquipments>;
};

export type MaintenancePlanVisitInstalledEquipmentsAggregateBoolExp = {
  count?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsAggregateBoolExpCount>;
};

/** aggregate fields of "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsAggregateFields = {
  __typename?: 'MaintenancePlanVisitInstalledEquipmentsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanVisitInstalledEquipmentsMaxFields>;
  min?: Maybe<MaintenancePlanVisitInstalledEquipmentsMinFields>;
};


/** aggregate fields of "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsMaxOrderBy>;
  min?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsArrRelInsertInput = {
  data: Array<MaintenancePlanVisitInstalledEquipmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_visit_installed_equipments". All fields are combined with a logical 'AND'. */
export type MaintenancePlanVisitInstalledEquipmentsBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsBoolExp>>;
  _not?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  installedEquipment?: InputMaybe<InstalledEquipmentBoolExp>;
  installedEquipmentGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanVisit?: InputMaybe<MaintenancePlanVisitsBoolExp>;
  maintenancePlanVisitGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanVisitInstalledEquipmentGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsConstraint =
  /** unique or primary key constraint on columns "maintenance_plan_visit_guid", "installed_equipment_guid" */
  | 'maintenance_plan_visit_instal_maintenance_plan_visit_guid_i_key'
  /** unique or primary key constraint on columns "maintenance_plan_visit_installed_equipment_guid" */
  | 'maintenance_plan_visit_installed_equipments_pkey';

/** input type for inserting data into table "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  installedEquipment?: InputMaybe<InstalledEquipmentObjRelInsertInput>;
  installedEquipmentGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisit?: InputMaybe<MaintenancePlanVisitsObjRelInsertInput>;
  maintenancePlanVisitGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitInstalledEquipmentGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type MaintenancePlanVisitInstalledEquipmentsMaxFields = {
  __typename?: 'MaintenancePlanVisitInstalledEquipmentsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  installedEquipmentGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanVisitInstalledEquipmentGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  installedEquipmentGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitInstalledEquipmentGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MaintenancePlanVisitInstalledEquipmentsMinFields = {
  __typename?: 'MaintenancePlanVisitInstalledEquipmentsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  installedEquipmentGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanVisitInstalledEquipmentGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  installedEquipmentGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitInstalledEquipmentGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsMutationResponse = {
  __typename?: 'MaintenancePlanVisitInstalledEquipmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MaintenancePlanVisitInstalledEquipments>;
};

/** on_conflict condition type for table "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsOnConflict = {
  constraint: MaintenancePlanVisitInstalledEquipmentsConstraint;
  updateColumns?: Array<MaintenancePlanVisitInstalledEquipmentsUpdateColumn>;
  where?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
};

/** Ordering options when selecting data from "maintenance_plan_visit_installed_equipments". */
export type MaintenancePlanVisitInstalledEquipmentsOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  installedEquipment?: InputMaybe<InstalledEquipmentOrderBy>;
  installedEquipmentGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisit?: InputMaybe<MaintenancePlanVisitsOrderBy>;
  maintenancePlanVisitGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitInstalledEquipmentGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: maintenance_plan_visit_installed_equipments */
export type MaintenancePlanVisitInstalledEquipmentsPkColumnsInput = {
  maintenancePlanVisitInstalledEquipmentGuid: Scalars['uuid'];
};

/** select columns of table "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'installedEquipmentGuid'
  /** column name */
  | 'maintenancePlanVisitGuid'
  /** column name */
  | 'maintenancePlanVisitInstalledEquipmentGuid';

/** input type for updating data in table "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  installedEquipmentGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitInstalledEquipmentGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanVisitInstalledEquipmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanVisitInstalledEquipmentsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  installedEquipmentGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitInstalledEquipmentGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "maintenance_plan_visit_installed_equipments" */
export type MaintenancePlanVisitInstalledEquipmentsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'installedEquipmentGuid'
  /** column name */
  | 'maintenancePlanVisitGuid'
  /** column name */
  | 'maintenancePlanVisitInstalledEquipmentGuid';

export type MaintenancePlanVisitInstalledEquipmentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsSetInput>;
  /** filter the rows which have to be updated */
  where: MaintenancePlanVisitInstalledEquipmentsBoolExp;
};

/** columns and relationships of "maintenance_plan_visits" */
export type MaintenancePlanVisits = {
  __typename?: 'MaintenancePlanVisits';
  affinityDate?: Maybe<Scalars['date']>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  completedAtOverride?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  dueAt: Scalars['timestamptz'];
  expiresAt: Scalars['timestamptz'];
  isCompletedOverride?: Maybe<Scalars['Boolean']>;
  isExpiredOverride?: Maybe<Scalars['Boolean']>;
  issuedAt: Scalars['timestamptz'];
  /** An object relationship */
  job?: Maybe<Jobs>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  jobType?: Maybe<JobTypes>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid: Scalars['uuid'];
  maintenancePlanVisitGuid: Scalars['uuid'];
  /** An array relationship */
  maintenancePlanVisitInstalledEquipments: Array<MaintenancePlanVisitInstalledEquipments>;
  /** An aggregate relationship */
  maintenancePlanVisitInstalledEquipmentsAggregate: MaintenancePlanVisitInstalledEquipmentsAggregate;
  /** An object relationship */
  maintenancePlansQueryable: MaintenancePlansQueryable;
  name: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  visitNote?: Maybe<Scalars['String']>;
  visitReminderLastSentAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "maintenance_plan_visits" */
export type MaintenancePlanVisitsMaintenancePlanVisitInstalledEquipmentsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
};


/** columns and relationships of "maintenance_plan_visits" */
export type MaintenancePlanVisitsMaintenancePlanVisitInstalledEquipmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
};

/** aggregated selection of "maintenance_plan_visits" */
export type MaintenancePlanVisitsAggregate = {
  __typename?: 'MaintenancePlanVisitsAggregate';
  aggregate?: Maybe<MaintenancePlanVisitsAggregateFields>;
  nodes: Array<MaintenancePlanVisits>;
};

export type MaintenancePlanVisitsAggregateBoolExp = {
  bool_and?: InputMaybe<MaintenancePlanVisitsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<MaintenancePlanVisitsAggregateBoolExpBool_Or>;
  count?: InputMaybe<MaintenancePlanVisitsAggregateBoolExpCount>;
};

/** aggregate fields of "maintenance_plan_visits" */
export type MaintenancePlanVisitsAggregateFields = {
  __typename?: 'MaintenancePlanVisitsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanVisitsMaxFields>;
  min?: Maybe<MaintenancePlanVisitsMinFields>;
};


/** aggregate fields of "maintenance_plan_visits" */
export type MaintenancePlanVisitsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanVisitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "maintenance_plan_visits" */
export type MaintenancePlanVisitsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MaintenancePlanVisitsMaxOrderBy>;
  min?: InputMaybe<MaintenancePlanVisitsMinOrderBy>;
};

/** input type for inserting array relation for remote table "maintenance_plan_visits" */
export type MaintenancePlanVisitsArrRelInsertInput = {
  data: Array<MaintenancePlanVisitsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanVisitsOnConflict>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_visits". All fields are combined with a logical 'AND'. */
export type MaintenancePlanVisitsBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanVisitsBoolExp>>;
  _not?: InputMaybe<MaintenancePlanVisitsBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanVisitsBoolExp>>;
  affinityDate?: InputMaybe<DateComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  completedAtOverride?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dueAt?: InputMaybe<TimestamptzComparisonExp>;
  expiresAt?: InputMaybe<TimestamptzComparisonExp>;
  isCompletedOverride?: InputMaybe<BooleanComparisonExp>;
  isExpiredOverride?: InputMaybe<BooleanComparisonExp>;
  issuedAt?: InputMaybe<TimestamptzComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  jobType?: InputMaybe<JobTypesBoolExp>;
  jobTypeGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanVisitGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanVisitInstalledEquipments?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
  maintenancePlanVisitInstalledEquipmentsAggregate?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsAggregateBoolExp>;
  maintenancePlansQueryable?: InputMaybe<MaintenancePlansQueryableBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  visitNote?: InputMaybe<StringComparisonExp>;
  visitReminderLastSentAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "maintenance_plan_visits" */
export type MaintenancePlanVisitsConstraint =
  /** unique or primary key constraint on columns "maintenance_plan_visit_guid" */
  | 'maintenance_plan_visits_pkey';

/** input type for inserting data into table "maintenance_plan_visits" */
export type MaintenancePlanVisitsInsertInput = {
  affinityDate?: InputMaybe<Scalars['date']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAtOverride?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  isCompletedOverride?: InputMaybe<Scalars['Boolean']>;
  isExpiredOverride?: InputMaybe<Scalars['Boolean']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobType?: InputMaybe<JobTypesObjRelInsertInput>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitInstalledEquipments?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsArrRelInsertInput>;
  maintenancePlansQueryable?: InputMaybe<MaintenancePlansQueryableObjRelInsertInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visitNote?: InputMaybe<Scalars['String']>;
  visitReminderLastSentAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MaintenancePlanVisitsMaxFields = {
  __typename?: 'MaintenancePlanVisitsMaxFields';
  affinityDate?: Maybe<Scalars['date']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAtOverride?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitNote?: Maybe<Scalars['String']>;
  visitReminderLastSentAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "maintenance_plan_visits" */
export type MaintenancePlanVisitsMaxOrderBy = {
  affinityDate?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  completedAtOverride?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  visitNote?: InputMaybe<OrderBy>;
  visitReminderLastSentAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MaintenancePlanVisitsMinFields = {
  __typename?: 'MaintenancePlanVisitsMinFields';
  affinityDate?: Maybe<Scalars['date']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAtOverride?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitNote?: Maybe<Scalars['String']>;
  visitReminderLastSentAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "maintenance_plan_visits" */
export type MaintenancePlanVisitsMinOrderBy = {
  affinityDate?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  completedAtOverride?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  visitNote?: InputMaybe<OrderBy>;
  visitReminderLastSentAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "maintenance_plan_visits" */
export type MaintenancePlanVisitsMutationResponse = {
  __typename?: 'MaintenancePlanVisitsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MaintenancePlanVisits>;
};

/** input type for inserting object relation for remote table "maintenance_plan_visits" */
export type MaintenancePlanVisitsObjRelInsertInput = {
  data: MaintenancePlanVisitsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlanVisitsOnConflict>;
};

/** on_conflict condition type for table "maintenance_plan_visits" */
export type MaintenancePlanVisitsOnConflict = {
  constraint: MaintenancePlanVisitsConstraint;
  updateColumns?: Array<MaintenancePlanVisitsUpdateColumn>;
  where?: InputMaybe<MaintenancePlanVisitsBoolExp>;
};

/** Ordering options when selecting data from "maintenance_plan_visits". */
export type MaintenancePlanVisitsOrderBy = {
  affinityDate?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  completedAtOverride?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  isCompletedOverride?: InputMaybe<OrderBy>;
  isExpiredOverride?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  jobType?: InputMaybe<JobTypesOrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitInstalledEquipmentsAggregate?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsAggregateOrderBy>;
  maintenancePlansQueryable?: InputMaybe<MaintenancePlansQueryableOrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  visitNote?: InputMaybe<OrderBy>;
  visitReminderLastSentAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: maintenance_plan_visits */
export type MaintenancePlanVisitsPkColumnsInput = {
  maintenancePlanVisitGuid: Scalars['uuid'];
};

/** select columns of table "maintenance_plan_visits" */
export type MaintenancePlanVisitsSelectColumn =
  /** column name */
  | 'affinityDate'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'completedAtOverride'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'expiresAt'
  /** column name */
  | 'isCompletedOverride'
  /** column name */
  | 'isExpiredOverride'
  /** column name */
  | 'issuedAt'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'maintenancePlanVisitGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'visitNote'
  /** column name */
  | 'visitReminderLastSentAt';

/** select "maintenancePlanVisitsAggregateBoolExpBool_andArgumentsColumns" columns of table "maintenance_plan_visits" */
export type MaintenancePlanVisitsSelectColumnMaintenancePlanVisitsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isCompletedOverride'
  /** column name */
  | 'isExpiredOverride';

/** select "maintenancePlanVisitsAggregateBoolExpBool_orArgumentsColumns" columns of table "maintenance_plan_visits" */
export type MaintenancePlanVisitsSelectColumnMaintenancePlanVisitsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isCompletedOverride'
  /** column name */
  | 'isExpiredOverride';

/** input type for updating data in table "maintenance_plan_visits" */
export type MaintenancePlanVisitsSetInput = {
  affinityDate?: InputMaybe<Scalars['date']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAtOverride?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  isCompletedOverride?: InputMaybe<Scalars['Boolean']>;
  isExpiredOverride?: InputMaybe<Scalars['Boolean']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visitNote?: InputMaybe<Scalars['String']>;
  visitReminderLastSentAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "maintenance_plan_visits" */
export type MaintenancePlanVisitsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanVisitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanVisitsStreamCursorValueInput = {
  affinityDate?: InputMaybe<Scalars['date']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAtOverride?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  isCompletedOverride?: InputMaybe<Scalars['Boolean']>;
  isExpiredOverride?: InputMaybe<Scalars['Boolean']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visitNote?: InputMaybe<Scalars['String']>;
  visitReminderLastSentAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "maintenance_plan_visits" */
export type MaintenancePlanVisitsUpdateColumn =
  /** column name */
  | 'affinityDate'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'completedAtOverride'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'expiresAt'
  /** column name */
  | 'isCompletedOverride'
  /** column name */
  | 'isExpiredOverride'
  /** column name */
  | 'issuedAt'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'maintenancePlanVisitGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'visitNote'
  /** column name */
  | 'visitReminderLastSentAt';

export type MaintenancePlanVisitsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaintenancePlanVisitsSetInput>;
  /** filter the rows which have to be updated */
  where: MaintenancePlanVisitsBoolExp;
};

/** columns and relationships of "maintenance_plan_visits_with_status" */
export type MaintenancePlanVisitsWithStatus = {
  __typename?: 'MaintenancePlanVisitsWithStatus';
  affinityDate?: Maybe<Scalars['date']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAtOverride?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  isCompletedOverride?: Maybe<Scalars['Boolean']>;
  isExpiredOverride?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitNote?: Maybe<Scalars['String']>;
  visitReminderLastSentAt?: Maybe<Scalars['timestamptz']>;
  visitStatus: Scalars['VisitStatus'];
};

/** aggregated selection of "maintenance_plan_visits_with_status" */
export type MaintenancePlanVisitsWithStatusAggregate = {
  __typename?: 'MaintenancePlanVisitsWithStatusAggregate';
  aggregate?: Maybe<MaintenancePlanVisitsWithStatusAggregateFields>;
  nodes: Array<MaintenancePlanVisitsWithStatus>;
};

/** aggregate fields of "maintenance_plan_visits_with_status" */
export type MaintenancePlanVisitsWithStatusAggregateFields = {
  __typename?: 'MaintenancePlanVisitsWithStatusAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlanVisitsWithStatusMaxFields>;
  min?: Maybe<MaintenancePlanVisitsWithStatusMinFields>;
};


/** aggregate fields of "maintenance_plan_visits_with_status" */
export type MaintenancePlanVisitsWithStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlanVisitsWithStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "maintenance_plan_visits_with_status". All fields are combined with a logical 'AND'. */
export type MaintenancePlanVisitsWithStatusBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlanVisitsWithStatusBoolExp>>;
  _not?: InputMaybe<MaintenancePlanVisitsWithStatusBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlanVisitsWithStatusBoolExp>>;
  affinityDate?: InputMaybe<DateComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  completedAtOverride?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dueAt?: InputMaybe<TimestamptzComparisonExp>;
  expiresAt?: InputMaybe<TimestamptzComparisonExp>;
  isCompletedOverride?: InputMaybe<BooleanComparisonExp>;
  isExpiredOverride?: InputMaybe<BooleanComparisonExp>;
  issuedAt?: InputMaybe<TimestamptzComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  jobTypeGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanVisitGuid?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  visitNote?: InputMaybe<StringComparisonExp>;
  visitReminderLastSentAt?: InputMaybe<TimestamptzComparisonExp>;
  visitStatus?: InputMaybe<Scalars['VisitStatusComparisonExp']>;
};

export type MaintenancePlanVisitsWithStatusInsertInput = {
  __typename?: 'MaintenancePlanVisitsWithStatusInsertInput';
  visitStatus?: Maybe<Scalars['VisitStatus']>;
};

/** aggregate max on columns */
export type MaintenancePlanVisitsWithStatusMaxFields = {
  __typename?: 'MaintenancePlanVisitsWithStatusMaxFields';
  affinityDate?: Maybe<Scalars['date']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAtOverride?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitNote?: Maybe<Scalars['String']>;
  visitReminderLastSentAt?: Maybe<Scalars['timestamptz']>;
  visitStatus?: Maybe<Scalars['VisitStatus']>;
};

/** aggregate min on columns */
export type MaintenancePlanVisitsWithStatusMinFields = {
  __typename?: 'MaintenancePlanVisitsWithStatusMinFields';
  affinityDate?: Maybe<Scalars['date']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAtOverride?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  issuedAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitNote?: Maybe<Scalars['String']>;
  visitReminderLastSentAt?: Maybe<Scalars['timestamptz']>;
  visitStatus?: Maybe<Scalars['VisitStatus']>;
};

/** Ordering options when selecting data from "maintenance_plan_visits_with_status". */
export type MaintenancePlanVisitsWithStatusOrderBy = {
  affinityDate?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  completedAtOverride?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  isCompletedOverride?: InputMaybe<OrderBy>;
  isExpiredOverride?: InputMaybe<OrderBy>;
  issuedAt?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  visitNote?: InputMaybe<OrderBy>;
  visitReminderLastSentAt?: InputMaybe<OrderBy>;
  visitStatus?: InputMaybe<OrderBy>;
};

/** select columns of table "maintenance_plan_visits_with_status" */
export type MaintenancePlanVisitsWithStatusSelectColumn =
  /** column name */
  | 'affinityDate'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'completedAtOverride'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'expiresAt'
  /** column name */
  | 'isCompletedOverride'
  /** column name */
  | 'isExpiredOverride'
  /** column name */
  | 'issuedAt'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'maintenancePlanVisitGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'visitNote'
  /** column name */
  | 'visitReminderLastSentAt'
  /** column name */
  | 'visitStatus';

export type MaintenancePlanVisitsWithStatusSetInput = {
  __typename?: 'MaintenancePlanVisitsWithStatusSetInput';
  visitStatus?: Maybe<Scalars['VisitStatus']>;
};

/** Streaming cursor of the table "maintenance_plan_visits_with_status" */
export type MaintenancePlanVisitsWithStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlanVisitsWithStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlanVisitsWithStatusStreamCursorValueInput = {
  affinityDate?: InputMaybe<Scalars['date']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAtOverride?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  isCompletedOverride?: InputMaybe<Scalars['Boolean']>;
  isExpiredOverride?: InputMaybe<Scalars['Boolean']>;
  issuedAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisitGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visitNote?: InputMaybe<Scalars['String']>;
  visitReminderLastSentAt?: InputMaybe<Scalars['timestamptz']>;
  visitStatus?: InputMaybe<Scalars['VisitStatus']>;
};

/** columns and relationships of "maintenance_plans_queryable" */
export type MaintenancePlansQueryable = {
  __typename?: 'MaintenancePlansQueryable';
  /** An object relationship */
  account: Accounts;
  accountGuid: Scalars['uuid'];
  activatedAt?: Maybe<Scalars['timestamptz']>;
  billingAnchor?: Maybe<Scalars['String']>;
  billingStartAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  businessUnit?: Maybe<BusinessUnits>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancellationReasonType?: Maybe<MaintenancePlanCancellationReasonTypesEnum>;
  companyGuid: Scalars['uuid'];
  coveredInstalledEquipmentGuids: Scalars['GuidArray'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  credits: Scalars['CreditRecordArray'];
  discountAmountUsc: Scalars['Int'];
  discounts: Scalars['MaintenancePlanDiscountArray'];
  expiredAt?: Maybe<Scalars['timestamptz']>;
  lapsedAt?: Maybe<Scalars['timestamptz']>;
  lastVisitedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field to calculate the number of days since the last visit. If there hasn't been a visit yet the default value is -1 */
  lastVisitedDaysAgo?: Maybe<Scalars['Int']>;
  /** An object relationship */
  location: Locations;
  locationGuid: Scalars['uuid'];
  /** An array relationship */
  maintenancePlanCoveredEquipmentTypes: Array<MaintenancePlanEquipmentCoverageDefinitions>;
  /** An aggregate relationship */
  maintenancePlanCoveredEquipmentTypesAggregate: MaintenancePlanEquipmentCoverageDefinitionsAggregate;
  /** An object relationship */
  maintenancePlanDefinition?: Maybe<MaintenancePlanDefinitions>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid: Scalars['uuid'];
  /** An array relationship */
  maintenancePlanVisits: Array<MaintenancePlanVisits>;
  /** An aggregate relationship */
  maintenancePlanVisitsAggregate: MaintenancePlanVisitsAggregate;
  /** An object relationship */
  nextVisit?: Maybe<MaintenancePlanNextVisits>;
  nextVisitAffinityDate?: Maybe<Scalars['date']>;
  numAvailableVisitCredits: Scalars['Int'];
  numCreditsNeededToMigrate?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of overdue visits. */
  numOverdueVisits?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of unused visits. */
  numUnusedVisits: Scalars['Int'];
  oldestCoveredEquipmentAgeYears?: Maybe<Scalars['Int']>;
  paymentAmountUsc: Scalars['Int'];
  paymentFlow: MaintenancePlanPaymentFlowTypesEnum;
  paymentInterval: Scalars['MaintenancePlanPaymentInterval'];
  paymentSubscriptionGuid?: Maybe<Scalars['uuid']>;
  pricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  scheduledActivationAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  soldByUser?: Maybe<Users>;
  soldByUserGuid?: Maybe<Scalars['uuid']>;
  status: Scalars['MaintenancePlanStatus'];
  taxRoundingStrategy: Scalars['TaxRoundingStrategy'];
  terminatesAt?: Maybe<Scalars['timestamptz']>;
  totalPaymentsReceivedUsc: Scalars['Int'];
  upchargeAmountUsc: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  visitReplenishmentAnchorOverride?: Maybe<Scalars['date']>;
  yearlyPriceUsc: Scalars['Int'];
};


/** columns and relationships of "maintenance_plans_queryable" */
export type MaintenancePlansQueryableCoveredInstalledEquipmentGuidsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "maintenance_plans_queryable" */
export type MaintenancePlansQueryableCreditsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "maintenance_plans_queryable" */
export type MaintenancePlansQueryableDiscountsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "maintenance_plans_queryable" */
export type MaintenancePlansQueryableMaintenancePlanCoveredEquipmentTypesArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
};


/** columns and relationships of "maintenance_plans_queryable" */
export type MaintenancePlansQueryableMaintenancePlanCoveredEquipmentTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
};


/** columns and relationships of "maintenance_plans_queryable" */
export type MaintenancePlansQueryableMaintenancePlanVisitsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitsBoolExp>;
};


/** columns and relationships of "maintenance_plans_queryable" */
export type MaintenancePlansQueryableMaintenancePlanVisitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitsBoolExp>;
};

/** aggregated selection of "maintenance_plans_queryable" */
export type MaintenancePlansQueryableAggregate = {
  __typename?: 'MaintenancePlansQueryableAggregate';
  aggregate?: Maybe<MaintenancePlansQueryableAggregateFields>;
  nodes: Array<MaintenancePlansQueryable>;
};

export type MaintenancePlansQueryableAggregateBoolExp = {
  count?: InputMaybe<MaintenancePlansQueryableAggregateBoolExpCount>;
};

/** aggregate fields of "maintenance_plans_queryable" */
export type MaintenancePlansQueryableAggregateFields = {
  __typename?: 'MaintenancePlansQueryableAggregateFields';
  avg?: Maybe<MaintenancePlansQueryableAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<MaintenancePlansQueryableMaxFields>;
  min?: Maybe<MaintenancePlansQueryableMinFields>;
  stddev?: Maybe<MaintenancePlansQueryableStddevFields>;
  stddevPop?: Maybe<MaintenancePlansQueryableStddevPopFields>;
  stddevSamp?: Maybe<MaintenancePlansQueryableStddevSampFields>;
  sum?: Maybe<MaintenancePlansQueryableSumFields>;
  varPop?: Maybe<MaintenancePlansQueryableVarPopFields>;
  varSamp?: Maybe<MaintenancePlansQueryableVarSampFields>;
  variance?: Maybe<MaintenancePlansQueryableVarianceFields>;
};


/** aggregate fields of "maintenance_plans_queryable" */
export type MaintenancePlansQueryableAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MaintenancePlansQueryableSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableAggregateOrderBy = {
  avg?: InputMaybe<MaintenancePlansQueryableAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MaintenancePlansQueryableMaxOrderBy>;
  min?: InputMaybe<MaintenancePlansQueryableMinOrderBy>;
  stddev?: InputMaybe<MaintenancePlansQueryableStddevOrderBy>;
  stddevPop?: InputMaybe<MaintenancePlansQueryableStddevPopOrderBy>;
  stddevSamp?: InputMaybe<MaintenancePlansQueryableStddevSampOrderBy>;
  sum?: InputMaybe<MaintenancePlansQueryableSumOrderBy>;
  varPop?: InputMaybe<MaintenancePlansQueryableVarPopOrderBy>;
  varSamp?: InputMaybe<MaintenancePlansQueryableVarSampOrderBy>;
  variance?: InputMaybe<MaintenancePlansQueryableVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MaintenancePlansQueryableAppendInput = {
  coveredInstalledEquipmentGuids?: InputMaybe<Scalars['jsonb']>;
  credits?: InputMaybe<Scalars['jsonb']>;
  discounts?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableArrRelInsertInput = {
  data: Array<MaintenancePlansQueryableInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlansQueryableOnConflict>;
};

/** aggregate avg on columns */
export type MaintenancePlansQueryableAvgFields = {
  __typename?: 'MaintenancePlansQueryableAvgFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  /** A computed field to calculate the number of days since the last visit. If there hasn't been a visit yet the default value is -1 */
  lastVisitedDaysAgo?: Maybe<Scalars['Int']>;
  numAvailableVisitCredits?: Maybe<Scalars['Float']>;
  numCreditsNeededToMigrate?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of overdue visits. */
  numOverdueVisits?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of unused visits. */
  numUnusedVisits?: Maybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: Maybe<Scalars['Float']>;
  paymentAmountUsc?: Maybe<Scalars['Float']>;
  totalPaymentsReceivedUsc?: Maybe<Scalars['Float']>;
  upchargeAmountUsc?: Maybe<Scalars['Float']>;
  yearlyPriceUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableAvgOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  numAvailableVisitCredits?: InputMaybe<OrderBy>;
  numCreditsNeededToMigrate?: InputMaybe<OrderBy>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<OrderBy>;
  paymentAmountUsc?: InputMaybe<OrderBy>;
  totalPaymentsReceivedUsc?: InputMaybe<OrderBy>;
  upchargeAmountUsc?: InputMaybe<OrderBy>;
  yearlyPriceUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "maintenance_plans_queryable". All fields are combined with a logical 'AND'. */
export type MaintenancePlansQueryableBoolExp = {
  _and?: InputMaybe<Array<MaintenancePlansQueryableBoolExp>>;
  _not?: InputMaybe<MaintenancePlansQueryableBoolExp>;
  _or?: InputMaybe<Array<MaintenancePlansQueryableBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  activatedAt?: InputMaybe<TimestamptzComparisonExp>;
  billingAnchor?: InputMaybe<StringComparisonExp>;
  billingStartAt?: InputMaybe<TimestamptzComparisonExp>;
  businessUnit?: InputMaybe<BusinessUnitsBoolExp>;
  businessUnitGuid?: InputMaybe<UuidComparisonExp>;
  canceledAt?: InputMaybe<TimestamptzComparisonExp>;
  cancellationReason?: InputMaybe<StringComparisonExp>;
  cancellationReasonType?: InputMaybe<MaintenancePlanCancellationReasonTypesEnumComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  coveredInstalledEquipmentGuids?: InputMaybe<Scalars['GuidArrayComparisonExp']>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  credits?: InputMaybe<Scalars['CreditRecordArrayComparisonExp']>;
  discountAmountUsc?: InputMaybe<IntComparisonExp>;
  discounts?: InputMaybe<Scalars['MaintenancePlanDiscountArrayComparisonExp']>;
  expiredAt?: InputMaybe<TimestamptzComparisonExp>;
  lapsedAt?: InputMaybe<TimestamptzComparisonExp>;
  lastVisitedAt?: InputMaybe<TimestamptzComparisonExp>;
  lastVisitedDaysAgo?: InputMaybe<IntComparisonExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanCoveredEquipmentTypes?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
  maintenancePlanCoveredEquipmentTypesAggregate?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExp>;
  maintenancePlanDefinition?: InputMaybe<MaintenancePlanDefinitionsBoolExp>;
  maintenancePlanDefinitionGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanVisits?: InputMaybe<MaintenancePlanVisitsBoolExp>;
  maintenancePlanVisitsAggregate?: InputMaybe<MaintenancePlanVisitsAggregateBoolExp>;
  nextVisit?: InputMaybe<MaintenancePlanNextVisitsBoolExp>;
  nextVisitAffinityDate?: InputMaybe<DateComparisonExp>;
  numAvailableVisitCredits?: InputMaybe<IntComparisonExp>;
  numCreditsNeededToMigrate?: InputMaybe<IntComparisonExp>;
  numOverdueVisits?: InputMaybe<IntComparisonExp>;
  numUnusedVisits?: InputMaybe<IntComparisonExp>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<IntComparisonExp>;
  paymentAmountUsc?: InputMaybe<IntComparisonExp>;
  paymentFlow?: InputMaybe<MaintenancePlanPaymentFlowTypesEnumComparisonExp>;
  paymentInterval?: InputMaybe<Scalars['MaintenancePlanPaymentIntervalComparisonExp']>;
  paymentSubscriptionGuid?: InputMaybe<UuidComparisonExp>;
  pricebookTaxRateGuid?: InputMaybe<UuidComparisonExp>;
  scheduledActivationAt?: InputMaybe<TimestamptzComparisonExp>;
  soldByUser?: InputMaybe<UsersBoolExp>;
  soldByUserGuid?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<Scalars['MaintenancePlanStatusComparisonExp']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategyComparisonExp']>;
  terminatesAt?: InputMaybe<TimestamptzComparisonExp>;
  totalPaymentsReceivedUsc?: InputMaybe<IntComparisonExp>;
  upchargeAmountUsc?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  visitReplenishmentAnchorOverride?: InputMaybe<DateComparisonExp>;
  yearlyPriceUsc?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableConstraint =
  /** unique or primary key constraint on columns "maintenance_plan_guid" */
  | 'maintenance_plans_queryable_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MaintenancePlansQueryableDeleteAtPathInput = {
  coveredInstalledEquipmentGuids?: InputMaybe<Array<Scalars['String']>>;
  credits?: InputMaybe<Array<Scalars['String']>>;
  discounts?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MaintenancePlansQueryableDeleteElemInput = {
  coveredInstalledEquipmentGuids?: InputMaybe<Scalars['Int']>;
  credits?: InputMaybe<Scalars['Int']>;
  discounts?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MaintenancePlansQueryableDeleteKeyInput = {
  coveredInstalledEquipmentGuids?: InputMaybe<Scalars['String']>;
  credits?: InputMaybe<Scalars['String']>;
  discounts?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableIncInput = {
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  numAvailableVisitCredits?: InputMaybe<Scalars['Int']>;
  numCreditsNeededToMigrate?: InputMaybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<Scalars['Int']>;
  paymentAmountUsc?: InputMaybe<Scalars['Int']>;
  totalPaymentsReceivedUsc?: InputMaybe<Scalars['Int']>;
  upchargeAmountUsc?: InputMaybe<Scalars['Int']>;
  yearlyPriceUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  activatedAt?: InputMaybe<Scalars['timestamptz']>;
  billingAnchor?: InputMaybe<Scalars['String']>;
  billingStartAt?: InputMaybe<Scalars['timestamptz']>;
  businessUnit?: InputMaybe<BusinessUnitsObjRelInsertInput>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  cancellationReasonType?: InputMaybe<MaintenancePlanCancellationReasonTypesEnum>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  coveredInstalledEquipmentGuids?: InputMaybe<Scalars['GuidArray']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  credits?: InputMaybe<Scalars['CreditRecordArray']>;
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discounts?: InputMaybe<Scalars['MaintenancePlanDiscountArray']>;
  expiredAt?: InputMaybe<Scalars['timestamptz']>;
  lapsedAt?: InputMaybe<Scalars['timestamptz']>;
  lastVisitedAt?: InputMaybe<Scalars['timestamptz']>;
  location?: InputMaybe<LocationsObjRelInsertInput>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanCoveredEquipmentTypes?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsArrRelInsertInput>;
  maintenancePlanDefinition?: InputMaybe<MaintenancePlanDefinitionsObjRelInsertInput>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanVisits?: InputMaybe<MaintenancePlanVisitsArrRelInsertInput>;
  nextVisit?: InputMaybe<MaintenancePlanNextVisitsObjRelInsertInput>;
  nextVisitAffinityDate?: InputMaybe<Scalars['date']>;
  numAvailableVisitCredits?: InputMaybe<Scalars['Int']>;
  numCreditsNeededToMigrate?: InputMaybe<Scalars['Int']>;
  numUnusedVisits?: InputMaybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<Scalars['Int']>;
  paymentAmountUsc?: InputMaybe<Scalars['Int']>;
  paymentFlow?: InputMaybe<MaintenancePlanPaymentFlowTypesEnum>;
  paymentInterval?: InputMaybe<Scalars['MaintenancePlanPaymentInterval']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  pricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  scheduledActivationAt?: InputMaybe<Scalars['timestamptz']>;
  soldByUser?: InputMaybe<UsersObjRelInsertInput>;
  soldByUserGuid?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['MaintenancePlanStatus']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
  terminatesAt?: InputMaybe<Scalars['timestamptz']>;
  totalPaymentsReceivedUsc?: InputMaybe<Scalars['Int']>;
  upchargeAmountUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visitReplenishmentAnchorOverride?: InputMaybe<Scalars['date']>;
  yearlyPriceUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type MaintenancePlansQueryableMaxFields = {
  __typename?: 'MaintenancePlansQueryableMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  activatedAt?: Maybe<Scalars['timestamptz']>;
  billingAnchor?: Maybe<Scalars['String']>;
  billingStartAt?: Maybe<Scalars['timestamptz']>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  cancellationReason?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  coveredInstalledEquipmentGuids?: Maybe<Scalars['GuidArray']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  credits?: Maybe<Scalars['CreditRecordArray']>;
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discounts?: Maybe<Scalars['MaintenancePlanDiscountArray']>;
  expiredAt?: Maybe<Scalars['timestamptz']>;
  lapsedAt?: Maybe<Scalars['timestamptz']>;
  lastVisitedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field to calculate the number of days since the last visit. If there hasn't been a visit yet the default value is -1 */
  lastVisitedDaysAgo?: Maybe<Scalars['Int']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  nextVisitAffinityDate?: Maybe<Scalars['date']>;
  numAvailableVisitCredits?: Maybe<Scalars['Int']>;
  numCreditsNeededToMigrate?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of overdue visits. */
  numOverdueVisits?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of unused visits. */
  numUnusedVisits?: Maybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: Maybe<Scalars['Int']>;
  paymentAmountUsc?: Maybe<Scalars['Int']>;
  paymentInterval?: Maybe<Scalars['MaintenancePlanPaymentInterval']>;
  paymentSubscriptionGuid?: Maybe<Scalars['uuid']>;
  pricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  scheduledActivationAt?: Maybe<Scalars['timestamptz']>;
  soldByUserGuid?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['MaintenancePlanStatus']>;
  taxRoundingStrategy?: Maybe<Scalars['TaxRoundingStrategy']>;
  terminatesAt?: Maybe<Scalars['timestamptz']>;
  totalPaymentsReceivedUsc?: Maybe<Scalars['Int']>;
  upchargeAmountUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitReplenishmentAnchorOverride?: Maybe<Scalars['date']>;
  yearlyPriceUsc?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  activatedAt?: InputMaybe<OrderBy>;
  billingAnchor?: InputMaybe<OrderBy>;
  billingStartAt?: InputMaybe<OrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  cancellationReason?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  discountAmountUsc?: InputMaybe<OrderBy>;
  expiredAt?: InputMaybe<OrderBy>;
  lapsedAt?: InputMaybe<OrderBy>;
  lastVisitedAt?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  nextVisitAffinityDate?: InputMaybe<OrderBy>;
  numAvailableVisitCredits?: InputMaybe<OrderBy>;
  numCreditsNeededToMigrate?: InputMaybe<OrderBy>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<OrderBy>;
  paymentAmountUsc?: InputMaybe<OrderBy>;
  paymentInterval?: InputMaybe<OrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  pricebookTaxRateGuid?: InputMaybe<OrderBy>;
  scheduledActivationAt?: InputMaybe<OrderBy>;
  soldByUserGuid?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  taxRoundingStrategy?: InputMaybe<OrderBy>;
  terminatesAt?: InputMaybe<OrderBy>;
  totalPaymentsReceivedUsc?: InputMaybe<OrderBy>;
  upchargeAmountUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  visitReplenishmentAnchorOverride?: InputMaybe<OrderBy>;
  yearlyPriceUsc?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MaintenancePlansQueryableMinFields = {
  __typename?: 'MaintenancePlansQueryableMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  activatedAt?: Maybe<Scalars['timestamptz']>;
  billingAnchor?: Maybe<Scalars['String']>;
  billingStartAt?: Maybe<Scalars['timestamptz']>;
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  cancellationReason?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  coveredInstalledEquipmentGuids?: Maybe<Scalars['GuidArray']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  credits?: Maybe<Scalars['CreditRecordArray']>;
  discountAmountUsc?: Maybe<Scalars['Int']>;
  discounts?: Maybe<Scalars['MaintenancePlanDiscountArray']>;
  expiredAt?: Maybe<Scalars['timestamptz']>;
  lapsedAt?: Maybe<Scalars['timestamptz']>;
  lastVisitedAt?: Maybe<Scalars['timestamptz']>;
  /** A computed field to calculate the number of days since the last visit. If there hasn't been a visit yet the default value is -1 */
  lastVisitedDaysAgo?: Maybe<Scalars['Int']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  nextVisitAffinityDate?: Maybe<Scalars['date']>;
  numAvailableVisitCredits?: Maybe<Scalars['Int']>;
  numCreditsNeededToMigrate?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of overdue visits. */
  numOverdueVisits?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of unused visits. */
  numUnusedVisits?: Maybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: Maybe<Scalars['Int']>;
  paymentAmountUsc?: Maybe<Scalars['Int']>;
  paymentInterval?: Maybe<Scalars['MaintenancePlanPaymentInterval']>;
  paymentSubscriptionGuid?: Maybe<Scalars['uuid']>;
  pricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  scheduledActivationAt?: Maybe<Scalars['timestamptz']>;
  soldByUserGuid?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['MaintenancePlanStatus']>;
  taxRoundingStrategy?: Maybe<Scalars['TaxRoundingStrategy']>;
  terminatesAt?: Maybe<Scalars['timestamptz']>;
  totalPaymentsReceivedUsc?: Maybe<Scalars['Int']>;
  upchargeAmountUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  visitReplenishmentAnchorOverride?: Maybe<Scalars['date']>;
  yearlyPriceUsc?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  activatedAt?: InputMaybe<OrderBy>;
  billingAnchor?: InputMaybe<OrderBy>;
  billingStartAt?: InputMaybe<OrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  cancellationReason?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  discountAmountUsc?: InputMaybe<OrderBy>;
  expiredAt?: InputMaybe<OrderBy>;
  lapsedAt?: InputMaybe<OrderBy>;
  lastVisitedAt?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  nextVisitAffinityDate?: InputMaybe<OrderBy>;
  numAvailableVisitCredits?: InputMaybe<OrderBy>;
  numCreditsNeededToMigrate?: InputMaybe<OrderBy>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<OrderBy>;
  paymentAmountUsc?: InputMaybe<OrderBy>;
  paymentInterval?: InputMaybe<OrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  pricebookTaxRateGuid?: InputMaybe<OrderBy>;
  scheduledActivationAt?: InputMaybe<OrderBy>;
  soldByUserGuid?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  taxRoundingStrategy?: InputMaybe<OrderBy>;
  terminatesAt?: InputMaybe<OrderBy>;
  totalPaymentsReceivedUsc?: InputMaybe<OrderBy>;
  upchargeAmountUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  visitReplenishmentAnchorOverride?: InputMaybe<OrderBy>;
  yearlyPriceUsc?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableMutationResponse = {
  __typename?: 'MaintenancePlansQueryableMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MaintenancePlansQueryable>;
};

/** input type for inserting object relation for remote table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableObjRelInsertInput = {
  data: MaintenancePlansQueryableInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MaintenancePlansQueryableOnConflict>;
};

/** on_conflict condition type for table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableOnConflict = {
  constraint: MaintenancePlansQueryableConstraint;
  updateColumns?: Array<MaintenancePlansQueryableUpdateColumn>;
  where?: InputMaybe<MaintenancePlansQueryableBoolExp>;
};

/** Ordering options when selecting data from "maintenance_plans_queryable". */
export type MaintenancePlansQueryableOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  activatedAt?: InputMaybe<OrderBy>;
  billingAnchor?: InputMaybe<OrderBy>;
  billingStartAt?: InputMaybe<OrderBy>;
  businessUnit?: InputMaybe<BusinessUnitsOrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  cancellationReason?: InputMaybe<OrderBy>;
  cancellationReasonType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  coveredInstalledEquipmentGuids?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  credits?: InputMaybe<OrderBy>;
  discountAmountUsc?: InputMaybe<OrderBy>;
  discounts?: InputMaybe<OrderBy>;
  expiredAt?: InputMaybe<OrderBy>;
  lapsedAt?: InputMaybe<OrderBy>;
  lastVisitedAt?: InputMaybe<OrderBy>;
  lastVisitedDaysAgo?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlanCoveredEquipmentTypesAggregate?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsAggregateOrderBy>;
  maintenancePlanDefinition?: InputMaybe<MaintenancePlanDefinitionsOrderBy>;
  maintenancePlanDefinitionGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  maintenancePlanVisitsAggregate?: InputMaybe<MaintenancePlanVisitsAggregateOrderBy>;
  nextVisit?: InputMaybe<MaintenancePlanNextVisitsOrderBy>;
  nextVisitAffinityDate?: InputMaybe<OrderBy>;
  numAvailableVisitCredits?: InputMaybe<OrderBy>;
  numCreditsNeededToMigrate?: InputMaybe<OrderBy>;
  numOverdueVisits?: InputMaybe<OrderBy>;
  numUnusedVisits?: InputMaybe<OrderBy>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<OrderBy>;
  paymentAmountUsc?: InputMaybe<OrderBy>;
  paymentFlow?: InputMaybe<OrderBy>;
  paymentInterval?: InputMaybe<OrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  pricebookTaxRateGuid?: InputMaybe<OrderBy>;
  scheduledActivationAt?: InputMaybe<OrderBy>;
  soldByUser?: InputMaybe<UsersOrderBy>;
  soldByUserGuid?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  taxRoundingStrategy?: InputMaybe<OrderBy>;
  terminatesAt?: InputMaybe<OrderBy>;
  totalPaymentsReceivedUsc?: InputMaybe<OrderBy>;
  upchargeAmountUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  visitReplenishmentAnchorOverride?: InputMaybe<OrderBy>;
  yearlyPriceUsc?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: maintenance_plans_queryable */
export type MaintenancePlansQueryablePkColumnsInput = {
  maintenancePlanGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MaintenancePlansQueryablePrependInput = {
  coveredInstalledEquipmentGuids?: InputMaybe<Scalars['jsonb']>;
  credits?: InputMaybe<Scalars['jsonb']>;
  discounts?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'activatedAt'
  /** column name */
  | 'billingAnchor'
  /** column name */
  | 'billingStartAt'
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'canceledAt'
  /** column name */
  | 'cancellationReason'
  /** column name */
  | 'cancellationReasonType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'coveredInstalledEquipmentGuids'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'credits'
  /** column name */
  | 'discountAmountUsc'
  /** column name */
  | 'discounts'
  /** column name */
  | 'expiredAt'
  /** column name */
  | 'lapsedAt'
  /** column name */
  | 'lastVisitedAt'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'maintenancePlanDefinitionGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'nextVisitAffinityDate'
  /** column name */
  | 'numAvailableVisitCredits'
  /** column name */
  | 'numCreditsNeededToMigrate'
  /** column name */
  | 'oldestCoveredEquipmentAgeYears'
  /** column name */
  | 'paymentAmountUsc'
  /** column name */
  | 'paymentFlow'
  /** column name */
  | 'paymentInterval'
  /** column name */
  | 'paymentSubscriptionGuid'
  /** column name */
  | 'pricebookTaxRateGuid'
  /** column name */
  | 'scheduledActivationAt'
  /** column name */
  | 'soldByUserGuid'
  /** column name */
  | 'status'
  /** column name */
  | 'taxRoundingStrategy'
  /** column name */
  | 'terminatesAt'
  /** column name */
  | 'totalPaymentsReceivedUsc'
  /** column name */
  | 'upchargeAmountUsc'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'visitReplenishmentAnchorOverride'
  /** column name */
  | 'yearlyPriceUsc';

/** input type for updating data in table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  activatedAt?: InputMaybe<Scalars['timestamptz']>;
  billingAnchor?: InputMaybe<Scalars['String']>;
  billingStartAt?: InputMaybe<Scalars['timestamptz']>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  cancellationReasonType?: InputMaybe<MaintenancePlanCancellationReasonTypesEnum>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  coveredInstalledEquipmentGuids?: InputMaybe<Scalars['GuidArray']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  credits?: InputMaybe<Scalars['CreditRecordArray']>;
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discounts?: InputMaybe<Scalars['MaintenancePlanDiscountArray']>;
  expiredAt?: InputMaybe<Scalars['timestamptz']>;
  lapsedAt?: InputMaybe<Scalars['timestamptz']>;
  lastVisitedAt?: InputMaybe<Scalars['timestamptz']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  nextVisitAffinityDate?: InputMaybe<Scalars['date']>;
  numAvailableVisitCredits?: InputMaybe<Scalars['Int']>;
  numCreditsNeededToMigrate?: InputMaybe<Scalars['Int']>;
  numUnusedVisits?: InputMaybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<Scalars['Int']>;
  paymentAmountUsc?: InputMaybe<Scalars['Int']>;
  paymentFlow?: InputMaybe<MaintenancePlanPaymentFlowTypesEnum>;
  paymentInterval?: InputMaybe<Scalars['MaintenancePlanPaymentInterval']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  pricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  scheduledActivationAt?: InputMaybe<Scalars['timestamptz']>;
  soldByUserGuid?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['MaintenancePlanStatus']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
  terminatesAt?: InputMaybe<Scalars['timestamptz']>;
  totalPaymentsReceivedUsc?: InputMaybe<Scalars['Int']>;
  upchargeAmountUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visitReplenishmentAnchorOverride?: InputMaybe<Scalars['date']>;
  yearlyPriceUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type MaintenancePlansQueryableStddevFields = {
  __typename?: 'MaintenancePlansQueryableStddevFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  /** A computed field to calculate the number of days since the last visit. If there hasn't been a visit yet the default value is -1 */
  lastVisitedDaysAgo?: Maybe<Scalars['Int']>;
  numAvailableVisitCredits?: Maybe<Scalars['Float']>;
  numCreditsNeededToMigrate?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of overdue visits. */
  numOverdueVisits?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of unused visits. */
  numUnusedVisits?: Maybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: Maybe<Scalars['Float']>;
  paymentAmountUsc?: Maybe<Scalars['Float']>;
  totalPaymentsReceivedUsc?: Maybe<Scalars['Float']>;
  upchargeAmountUsc?: Maybe<Scalars['Float']>;
  yearlyPriceUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableStddevOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  numAvailableVisitCredits?: InputMaybe<OrderBy>;
  numCreditsNeededToMigrate?: InputMaybe<OrderBy>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<OrderBy>;
  paymentAmountUsc?: InputMaybe<OrderBy>;
  totalPaymentsReceivedUsc?: InputMaybe<OrderBy>;
  upchargeAmountUsc?: InputMaybe<OrderBy>;
  yearlyPriceUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type MaintenancePlansQueryableStddevPopFields = {
  __typename?: 'MaintenancePlansQueryableStddevPopFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  /** A computed field to calculate the number of days since the last visit. If there hasn't been a visit yet the default value is -1 */
  lastVisitedDaysAgo?: Maybe<Scalars['Int']>;
  numAvailableVisitCredits?: Maybe<Scalars['Float']>;
  numCreditsNeededToMigrate?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of overdue visits. */
  numOverdueVisits?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of unused visits. */
  numUnusedVisits?: Maybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: Maybe<Scalars['Float']>;
  paymentAmountUsc?: Maybe<Scalars['Float']>;
  totalPaymentsReceivedUsc?: Maybe<Scalars['Float']>;
  upchargeAmountUsc?: Maybe<Scalars['Float']>;
  yearlyPriceUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableStddevPopOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  numAvailableVisitCredits?: InputMaybe<OrderBy>;
  numCreditsNeededToMigrate?: InputMaybe<OrderBy>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<OrderBy>;
  paymentAmountUsc?: InputMaybe<OrderBy>;
  totalPaymentsReceivedUsc?: InputMaybe<OrderBy>;
  upchargeAmountUsc?: InputMaybe<OrderBy>;
  yearlyPriceUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type MaintenancePlansQueryableStddevSampFields = {
  __typename?: 'MaintenancePlansQueryableStddevSampFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  /** A computed field to calculate the number of days since the last visit. If there hasn't been a visit yet the default value is -1 */
  lastVisitedDaysAgo?: Maybe<Scalars['Int']>;
  numAvailableVisitCredits?: Maybe<Scalars['Float']>;
  numCreditsNeededToMigrate?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of overdue visits. */
  numOverdueVisits?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of unused visits. */
  numUnusedVisits?: Maybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: Maybe<Scalars['Float']>;
  paymentAmountUsc?: Maybe<Scalars['Float']>;
  totalPaymentsReceivedUsc?: Maybe<Scalars['Float']>;
  upchargeAmountUsc?: Maybe<Scalars['Float']>;
  yearlyPriceUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableStddevSampOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  numAvailableVisitCredits?: InputMaybe<OrderBy>;
  numCreditsNeededToMigrate?: InputMaybe<OrderBy>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<OrderBy>;
  paymentAmountUsc?: InputMaybe<OrderBy>;
  totalPaymentsReceivedUsc?: InputMaybe<OrderBy>;
  upchargeAmountUsc?: InputMaybe<OrderBy>;
  yearlyPriceUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MaintenancePlansQueryableStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MaintenancePlansQueryableStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  activatedAt?: InputMaybe<Scalars['timestamptz']>;
  billingAnchor?: InputMaybe<Scalars['String']>;
  billingStartAt?: InputMaybe<Scalars['timestamptz']>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  cancellationReasonType?: InputMaybe<MaintenancePlanCancellationReasonTypesEnum>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  coveredInstalledEquipmentGuids?: InputMaybe<Scalars['GuidArray']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  credits?: InputMaybe<Scalars['CreditRecordArray']>;
  discountAmountUsc?: InputMaybe<Scalars['Int']>;
  discounts?: InputMaybe<Scalars['MaintenancePlanDiscountArray']>;
  expiredAt?: InputMaybe<Scalars['timestamptz']>;
  lapsedAt?: InputMaybe<Scalars['timestamptz']>;
  lastVisitedAt?: InputMaybe<Scalars['timestamptz']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanDefinitionGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  nextVisitAffinityDate?: InputMaybe<Scalars['date']>;
  numAvailableVisitCredits?: InputMaybe<Scalars['Int']>;
  numCreditsNeededToMigrate?: InputMaybe<Scalars['Int']>;
  numUnusedVisits?: InputMaybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<Scalars['Int']>;
  paymentAmountUsc?: InputMaybe<Scalars['Int']>;
  paymentFlow?: InputMaybe<MaintenancePlanPaymentFlowTypesEnum>;
  paymentInterval?: InputMaybe<Scalars['MaintenancePlanPaymentInterval']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  pricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  scheduledActivationAt?: InputMaybe<Scalars['timestamptz']>;
  soldByUserGuid?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['MaintenancePlanStatus']>;
  taxRoundingStrategy?: InputMaybe<Scalars['TaxRoundingStrategy']>;
  terminatesAt?: InputMaybe<Scalars['timestamptz']>;
  totalPaymentsReceivedUsc?: InputMaybe<Scalars['Int']>;
  upchargeAmountUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  visitReplenishmentAnchorOverride?: InputMaybe<Scalars['date']>;
  yearlyPriceUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type MaintenancePlansQueryableSumFields = {
  __typename?: 'MaintenancePlansQueryableSumFields';
  discountAmountUsc?: Maybe<Scalars['Int']>;
  /** A computed field to calculate the number of days since the last visit. If there hasn't been a visit yet the default value is -1 */
  lastVisitedDaysAgo?: Maybe<Scalars['Int']>;
  numAvailableVisitCredits?: Maybe<Scalars['Int']>;
  numCreditsNeededToMigrate?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of overdue visits. */
  numOverdueVisits?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of unused visits. */
  numUnusedVisits?: Maybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: Maybe<Scalars['Int']>;
  paymentAmountUsc?: Maybe<Scalars['Int']>;
  totalPaymentsReceivedUsc?: Maybe<Scalars['Int']>;
  upchargeAmountUsc?: Maybe<Scalars['Int']>;
  yearlyPriceUsc?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableSumOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  numAvailableVisitCredits?: InputMaybe<OrderBy>;
  numCreditsNeededToMigrate?: InputMaybe<OrderBy>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<OrderBy>;
  paymentAmountUsc?: InputMaybe<OrderBy>;
  totalPaymentsReceivedUsc?: InputMaybe<OrderBy>;
  upchargeAmountUsc?: InputMaybe<OrderBy>;
  yearlyPriceUsc?: InputMaybe<OrderBy>;
};

/** update columns of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'activatedAt'
  /** column name */
  | 'billingAnchor'
  /** column name */
  | 'billingStartAt'
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'canceledAt'
  /** column name */
  | 'cancellationReason'
  /** column name */
  | 'cancellationReasonType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'coveredInstalledEquipmentGuids'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'credits'
  /** column name */
  | 'discountAmountUsc'
  /** column name */
  | 'discounts'
  /** column name */
  | 'expiredAt'
  /** column name */
  | 'lapsedAt'
  /** column name */
  | 'lastVisitedAt'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'maintenancePlanDefinitionGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'nextVisitAffinityDate'
  /** column name */
  | 'numAvailableVisitCredits'
  /** column name */
  | 'numCreditsNeededToMigrate'
  /** column name */
  | 'oldestCoveredEquipmentAgeYears'
  /** column name */
  | 'paymentAmountUsc'
  /** column name */
  | 'paymentFlow'
  /** column name */
  | 'paymentInterval'
  /** column name */
  | 'paymentSubscriptionGuid'
  /** column name */
  | 'pricebookTaxRateGuid'
  /** column name */
  | 'scheduledActivationAt'
  /** column name */
  | 'soldByUserGuid'
  /** column name */
  | 'status'
  /** column name */
  | 'taxRoundingStrategy'
  /** column name */
  | 'terminatesAt'
  /** column name */
  | 'totalPaymentsReceivedUsc'
  /** column name */
  | 'upchargeAmountUsc'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'visitReplenishmentAnchorOverride'
  /** column name */
  | 'yearlyPriceUsc';

export type MaintenancePlansQueryableUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MaintenancePlansQueryableAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<MaintenancePlansQueryableDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<MaintenancePlansQueryableDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<MaintenancePlansQueryableDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MaintenancePlansQueryableIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MaintenancePlansQueryablePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaintenancePlansQueryableSetInput>;
  /** filter the rows which have to be updated */
  where: MaintenancePlansQueryableBoolExp;
};

/** aggregate varPop on columns */
export type MaintenancePlansQueryableVarPopFields = {
  __typename?: 'MaintenancePlansQueryableVarPopFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  /** A computed field to calculate the number of days since the last visit. If there hasn't been a visit yet the default value is -1 */
  lastVisitedDaysAgo?: Maybe<Scalars['Int']>;
  numAvailableVisitCredits?: Maybe<Scalars['Float']>;
  numCreditsNeededToMigrate?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of overdue visits. */
  numOverdueVisits?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of unused visits. */
  numUnusedVisits?: Maybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: Maybe<Scalars['Float']>;
  paymentAmountUsc?: Maybe<Scalars['Float']>;
  totalPaymentsReceivedUsc?: Maybe<Scalars['Float']>;
  upchargeAmountUsc?: Maybe<Scalars['Float']>;
  yearlyPriceUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableVarPopOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  numAvailableVisitCredits?: InputMaybe<OrderBy>;
  numCreditsNeededToMigrate?: InputMaybe<OrderBy>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<OrderBy>;
  paymentAmountUsc?: InputMaybe<OrderBy>;
  totalPaymentsReceivedUsc?: InputMaybe<OrderBy>;
  upchargeAmountUsc?: InputMaybe<OrderBy>;
  yearlyPriceUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type MaintenancePlansQueryableVarSampFields = {
  __typename?: 'MaintenancePlansQueryableVarSampFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  /** A computed field to calculate the number of days since the last visit. If there hasn't been a visit yet the default value is -1 */
  lastVisitedDaysAgo?: Maybe<Scalars['Int']>;
  numAvailableVisitCredits?: Maybe<Scalars['Float']>;
  numCreditsNeededToMigrate?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of overdue visits. */
  numOverdueVisits?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of unused visits. */
  numUnusedVisits?: Maybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: Maybe<Scalars['Float']>;
  paymentAmountUsc?: Maybe<Scalars['Float']>;
  totalPaymentsReceivedUsc?: Maybe<Scalars['Float']>;
  upchargeAmountUsc?: Maybe<Scalars['Float']>;
  yearlyPriceUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableVarSampOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  numAvailableVisitCredits?: InputMaybe<OrderBy>;
  numCreditsNeededToMigrate?: InputMaybe<OrderBy>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<OrderBy>;
  paymentAmountUsc?: InputMaybe<OrderBy>;
  totalPaymentsReceivedUsc?: InputMaybe<OrderBy>;
  upchargeAmountUsc?: InputMaybe<OrderBy>;
  yearlyPriceUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type MaintenancePlansQueryableVarianceFields = {
  __typename?: 'MaintenancePlansQueryableVarianceFields';
  discountAmountUsc?: Maybe<Scalars['Float']>;
  /** A computed field to calculate the number of days since the last visit. If there hasn't been a visit yet the default value is -1 */
  lastVisitedDaysAgo?: Maybe<Scalars['Int']>;
  numAvailableVisitCredits?: Maybe<Scalars['Float']>;
  numCreditsNeededToMigrate?: Maybe<Scalars['Float']>;
  /** A computed field that returns the number of overdue visits. */
  numOverdueVisits?: Maybe<Scalars['Int']>;
  /** A computed field that returns the number of unused visits. */
  numUnusedVisits?: Maybe<Scalars['Int']>;
  oldestCoveredEquipmentAgeYears?: Maybe<Scalars['Float']>;
  paymentAmountUsc?: Maybe<Scalars['Float']>;
  totalPaymentsReceivedUsc?: Maybe<Scalars['Float']>;
  upchargeAmountUsc?: Maybe<Scalars['Float']>;
  yearlyPriceUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "maintenance_plans_queryable" */
export type MaintenancePlansQueryableVarianceOrderBy = {
  discountAmountUsc?: InputMaybe<OrderBy>;
  numAvailableVisitCredits?: InputMaybe<OrderBy>;
  numCreditsNeededToMigrate?: InputMaybe<OrderBy>;
  oldestCoveredEquipmentAgeYears?: InputMaybe<OrderBy>;
  paymentAmountUsc?: InputMaybe<OrderBy>;
  totalPaymentsReceivedUsc?: InputMaybe<OrderBy>;
  upchargeAmountUsc?: InputMaybe<OrderBy>;
  yearlyPriceUsc?: InputMaybe<OrderBy>;
};

/** data that has been migrated over from legacy systems that does not have a first class mapping into the Breezy system */
export type MigrationJunk = {
  __typename?: 'MigrationJunk';
  junk: Scalars['jsonb'];
  migrationJunkGuid: Scalars['uuid'];
  /** An object relationship */
  migration_junk_link?: Maybe<MigrationJunkLinks>;
  uiLabel?: Maybe<Scalars['String']>;
};


/** data that has been migrated over from legacy systems that does not have a first class mapping into the Breezy system */
export type MigrationJunkJunkArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "migration_junk" */
export type MigrationJunkAggregate = {
  __typename?: 'MigrationJunkAggregate';
  aggregate?: Maybe<MigrationJunkAggregateFields>;
  nodes: Array<MigrationJunk>;
};

/** aggregate fields of "migration_junk" */
export type MigrationJunkAggregateFields = {
  __typename?: 'MigrationJunkAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MigrationJunkMaxFields>;
  min?: Maybe<MigrationJunkMinFields>;
};


/** aggregate fields of "migration_junk" */
export type MigrationJunkAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MigrationJunkSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MigrationJunkAppendInput = {
  junk?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "migration_junk". All fields are combined with a logical 'AND'. */
export type MigrationJunkBoolExp = {
  _and?: InputMaybe<Array<MigrationJunkBoolExp>>;
  _not?: InputMaybe<MigrationJunkBoolExp>;
  _or?: InputMaybe<Array<MigrationJunkBoolExp>>;
  junk?: InputMaybe<JsonbComparisonExp>;
  migrationJunkGuid?: InputMaybe<UuidComparisonExp>;
  migration_junk_link?: InputMaybe<MigrationJunkLinksBoolExp>;
  uiLabel?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "migration_junk" */
export type MigrationJunkConstraint =
  /** unique or primary key constraint on columns "migration_junk_guid" */
  | 'migration_junk_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MigrationJunkDeleteAtPathInput = {
  junk?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MigrationJunkDeleteElemInput = {
  junk?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MigrationJunkDeleteKeyInput = {
  junk?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "migration_junk" */
export type MigrationJunkInsertInput = {
  junk?: InputMaybe<Scalars['jsonb']>;
  migrationJunkGuid?: InputMaybe<Scalars['uuid']>;
  migration_junk_link?: InputMaybe<MigrationJunkLinksObjRelInsertInput>;
  uiLabel?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "migration_junk_links" */
export type MigrationJunkLinks = {
  __typename?: 'MigrationJunkLinks';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  jobGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  migrationJunkGuid: Scalars['uuid'];
  /** An object relationship */
  migration_junk: MigrationJunk;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "migration_junk_links" */
export type MigrationJunkLinksAggregate = {
  __typename?: 'MigrationJunkLinksAggregate';
  aggregate?: Maybe<MigrationJunkLinksAggregateFields>;
  nodes: Array<MigrationJunkLinks>;
};

/** aggregate fields of "migration_junk_links" */
export type MigrationJunkLinksAggregateFields = {
  __typename?: 'MigrationJunkLinksAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<MigrationJunkLinksMaxFields>;
  min?: Maybe<MigrationJunkLinksMinFields>;
};


/** aggregate fields of "migration_junk_links" */
export type MigrationJunkLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MigrationJunkLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "migration_junk_links". All fields are combined with a logical 'AND'. */
export type MigrationJunkLinksBoolExp = {
  _and?: InputMaybe<Array<MigrationJunkLinksBoolExp>>;
  _not?: InputMaybe<MigrationJunkLinksBoolExp>;
  _or?: InputMaybe<Array<MigrationJunkLinksBoolExp>>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  migrationJunkGuid?: InputMaybe<UuidComparisonExp>;
  migration_junk?: InputMaybe<MigrationJunkBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "migration_junk_links" */
export type MigrationJunkLinksConstraint =
  /** unique or primary key constraint on columns "migration_junk_guid" */
  | 'migration_junk_links_pkey';

/** input type for inserting data into table "migration_junk_links" */
export type MigrationJunkLinksInsertInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  migrationJunkGuid?: InputMaybe<Scalars['uuid']>;
  migration_junk?: InputMaybe<MigrationJunkObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MigrationJunkLinksMaxFields = {
  __typename?: 'MigrationJunkLinksMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  migrationJunkGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type MigrationJunkLinksMinFields = {
  __typename?: 'MigrationJunkLinksMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  migrationJunkGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "migration_junk_links" */
export type MigrationJunkLinksMutationResponse = {
  __typename?: 'MigrationJunkLinksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MigrationJunkLinks>;
};

/** input type for inserting object relation for remote table "migration_junk_links" */
export type MigrationJunkLinksObjRelInsertInput = {
  data: MigrationJunkLinksInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MigrationJunkLinksOnConflict>;
};

/** on_conflict condition type for table "migration_junk_links" */
export type MigrationJunkLinksOnConflict = {
  constraint: MigrationJunkLinksConstraint;
  updateColumns?: Array<MigrationJunkLinksUpdateColumn>;
  where?: InputMaybe<MigrationJunkLinksBoolExp>;
};

/** Ordering options when selecting data from "migration_junk_links". */
export type MigrationJunkLinksOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  migrationJunkGuid?: InputMaybe<OrderBy>;
  migration_junk?: InputMaybe<MigrationJunkOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: migration_junk_links */
export type MigrationJunkLinksPkColumnsInput = {
  migrationJunkGuid: Scalars['uuid'];
};

/** select columns of table "migration_junk_links" */
export type MigrationJunkLinksSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'migrationJunkGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "migration_junk_links" */
export type MigrationJunkLinksSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  migrationJunkGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "migration_junk_links" */
export type MigrationJunkLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MigrationJunkLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MigrationJunkLinksStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  migrationJunkGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "migration_junk_links" */
export type MigrationJunkLinksUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'migrationJunkGuid'
  /** column name */
  | 'updatedAt';

export type MigrationJunkLinksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MigrationJunkLinksSetInput>;
  /** filter the rows which have to be updated */
  where: MigrationJunkLinksBoolExp;
};

/** aggregate max on columns */
export type MigrationJunkMaxFields = {
  __typename?: 'MigrationJunkMaxFields';
  migrationJunkGuid?: Maybe<Scalars['uuid']>;
  uiLabel?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type MigrationJunkMinFields = {
  __typename?: 'MigrationJunkMinFields';
  migrationJunkGuid?: Maybe<Scalars['uuid']>;
  uiLabel?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "migration_junk" */
export type MigrationJunkMutationResponse = {
  __typename?: 'MigrationJunkMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MigrationJunk>;
};

/** input type for inserting object relation for remote table "migration_junk" */
export type MigrationJunkObjRelInsertInput = {
  data: MigrationJunkInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MigrationJunkOnConflict>;
};

/** on_conflict condition type for table "migration_junk" */
export type MigrationJunkOnConflict = {
  constraint: MigrationJunkConstraint;
  updateColumns?: Array<MigrationJunkUpdateColumn>;
  where?: InputMaybe<MigrationJunkBoolExp>;
};

/** Ordering options when selecting data from "migration_junk". */
export type MigrationJunkOrderBy = {
  junk?: InputMaybe<OrderBy>;
  migrationJunkGuid?: InputMaybe<OrderBy>;
  migration_junk_link?: InputMaybe<MigrationJunkLinksOrderBy>;
  uiLabel?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: migration_junk */
export type MigrationJunkPkColumnsInput = {
  migrationJunkGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MigrationJunkPrependInput = {
  junk?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "migration_junk" */
export type MigrationJunkSelectColumn =
  /** column name */
  | 'junk'
  /** column name */
  | 'migrationJunkGuid'
  /** column name */
  | 'uiLabel';

/** input type for updating data in table "migration_junk" */
export type MigrationJunkSetInput = {
  junk?: InputMaybe<Scalars['jsonb']>;
  migrationJunkGuid?: InputMaybe<Scalars['uuid']>;
  uiLabel?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "migration_junk" */
export type MigrationJunkStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MigrationJunkStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MigrationJunkStreamCursorValueInput = {
  junk?: InputMaybe<Scalars['jsonb']>;
  migrationJunkGuid?: InputMaybe<Scalars['uuid']>;
  uiLabel?: InputMaybe<Scalars['String']>;
};

/** update columns of table "migration_junk" */
export type MigrationJunkUpdateColumn =
  /** column name */
  | 'junk'
  /** column name */
  | 'migrationJunkGuid'
  /** column name */
  | 'uiLabel';

export type MigrationJunkUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MigrationJunkAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<MigrationJunkDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<MigrationJunkDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<MigrationJunkDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MigrationJunkPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MigrationJunkSetInput>;
  /** filter the rows which have to be updated */
  where: MigrationJunkBoolExp;
};

/** Attachments for notes */
export type NoteAttachments = {
  __typename?: 'NoteAttachments';
  createdAt: Scalars['timestamptz'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file?: Maybe<Files>;
  fileGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  note: Notes;
  noteAttachmentGuid: Scalars['uuid'];
  noteGuid: Scalars['uuid'];
  /** An object relationship */
  photo?: Maybe<Photos>;
  photoGuid?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "note_attachments" */
export type NoteAttachmentsAggregate = {
  __typename?: 'NoteAttachmentsAggregate';
  aggregate?: Maybe<NoteAttachmentsAggregateFields>;
  nodes: Array<NoteAttachments>;
};

export type NoteAttachmentsAggregateBoolExp = {
  count?: InputMaybe<NoteAttachmentsAggregateBoolExpCount>;
};

/** aggregate fields of "note_attachments" */
export type NoteAttachmentsAggregateFields = {
  __typename?: 'NoteAttachmentsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<NoteAttachmentsMaxFields>;
  min?: Maybe<NoteAttachmentsMinFields>;
};


/** aggregate fields of "note_attachments" */
export type NoteAttachmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NoteAttachmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "note_attachments" */
export type NoteAttachmentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<NoteAttachmentsMaxOrderBy>;
  min?: InputMaybe<NoteAttachmentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "note_attachments" */
export type NoteAttachmentsArrRelInsertInput = {
  data: Array<NoteAttachmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<NoteAttachmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "note_attachments". All fields are combined with a logical 'AND'. */
export type NoteAttachmentsBoolExp = {
  _and?: InputMaybe<Array<NoteAttachmentsBoolExp>>;
  _not?: InputMaybe<NoteAttachmentsBoolExp>;
  _or?: InputMaybe<Array<NoteAttachmentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  file?: InputMaybe<FilesBoolExp>;
  fileGuid?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<NotesBoolExp>;
  noteAttachmentGuid?: InputMaybe<UuidComparisonExp>;
  noteGuid?: InputMaybe<UuidComparisonExp>;
  photo?: InputMaybe<PhotosBoolExp>;
  photoGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "note_attachments" */
export type NoteAttachmentsConstraint =
  /** unique or primary key constraint on columns "file_guid", "photo_guid", "note_guid" */
  | 'note_attachments_note_guid_photo_guid_file_guid_key'
  /** unique or primary key constraint on columns "note_attachment_guid" */
  | 'note_attachments_pkey';

/** input type for inserting data into table "note_attachments" */
export type NoteAttachmentsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  file?: InputMaybe<FilesObjRelInsertInput>;
  fileGuid?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<NotesObjRelInsertInput>;
  noteAttachmentGuid?: InputMaybe<Scalars['uuid']>;
  noteGuid?: InputMaybe<Scalars['uuid']>;
  photo?: InputMaybe<PhotosObjRelInsertInput>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type NoteAttachmentsMaxFields = {
  __typename?: 'NoteAttachmentsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileGuid?: Maybe<Scalars['uuid']>;
  noteAttachmentGuid?: Maybe<Scalars['uuid']>;
  noteGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "note_attachments" */
export type NoteAttachmentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileGuid?: InputMaybe<OrderBy>;
  noteAttachmentGuid?: InputMaybe<OrderBy>;
  noteGuid?: InputMaybe<OrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type NoteAttachmentsMinFields = {
  __typename?: 'NoteAttachmentsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fileGuid?: Maybe<Scalars['uuid']>;
  noteAttachmentGuid?: Maybe<Scalars['uuid']>;
  noteGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "note_attachments" */
export type NoteAttachmentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileGuid?: InputMaybe<OrderBy>;
  noteAttachmentGuid?: InputMaybe<OrderBy>;
  noteGuid?: InputMaybe<OrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "note_attachments" */
export type NoteAttachmentsMutationResponse = {
  __typename?: 'NoteAttachmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NoteAttachments>;
};

/** on_conflict condition type for table "note_attachments" */
export type NoteAttachmentsOnConflict = {
  constraint: NoteAttachmentsConstraint;
  updateColumns?: Array<NoteAttachmentsUpdateColumn>;
  where?: InputMaybe<NoteAttachmentsBoolExp>;
};

/** Ordering options when selecting data from "note_attachments". */
export type NoteAttachmentsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  file?: InputMaybe<FilesOrderBy>;
  fileGuid?: InputMaybe<OrderBy>;
  note?: InputMaybe<NotesOrderBy>;
  noteAttachmentGuid?: InputMaybe<OrderBy>;
  noteGuid?: InputMaybe<OrderBy>;
  photo?: InputMaybe<PhotosOrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: note_attachments */
export type NoteAttachmentsPkColumnsInput = {
  noteAttachmentGuid: Scalars['uuid'];
};

/** select columns of table "note_attachments" */
export type NoteAttachmentsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deletedAt'
  /** column name */
  | 'fileGuid'
  /** column name */
  | 'noteAttachmentGuid'
  /** column name */
  | 'noteGuid'
  /** column name */
  | 'photoGuid';

/** input type for updating data in table "note_attachments" */
export type NoteAttachmentsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileGuid?: InputMaybe<Scalars['uuid']>;
  noteAttachmentGuid?: InputMaybe<Scalars['uuid']>;
  noteGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "note_attachments" */
export type NoteAttachmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NoteAttachmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NoteAttachmentsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fileGuid?: InputMaybe<Scalars['uuid']>;
  noteAttachmentGuid?: InputMaybe<Scalars['uuid']>;
  noteGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "note_attachments" */
export type NoteAttachmentsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deletedAt'
  /** column name */
  | 'fileGuid'
  /** column name */
  | 'noteAttachmentGuid'
  /** column name */
  | 'noteGuid'
  /** column name */
  | 'photoGuid';

export type NoteAttachmentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NoteAttachmentsSetInput>;
  /** filter the rows which have to be updated */
  where: NoteAttachmentsBoolExp;
};

/** columns and relationships of "note_links" */
export type NoteLinks = {
  __typename?: 'NoteLinks';
  /** An object relationship */
  account?: Maybe<Accounts>;
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  isPinned: Scalars['Boolean'];
  /** An object relationship */
  job?: Maybe<Jobs>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobCostAddressedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  jobCostAddressedByUser?: Maybe<Users>;
  jobCostAddressedByUserGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  job_appointment?: Maybe<JobAppointments>;
  /** An object relationship */
  job_appointment_assignment?: Maybe<JobAppointmentAssignments>;
  /** An object relationship */
  location?: Maybe<Locations>;
  locationGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  note: Notes;
  noteGuid: Scalars['uuid'];
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payment_record?: Maybe<PaymentRecords>;
  /** An object relationship */
  photo?: Maybe<Photos>;
  photoGuid?: Maybe<Scalars['uuid']>;
  pinnedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  pinnedByUser?: Maybe<Users>;
  pinnedByUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "note_links" */
export type NoteLinksAggregate = {
  __typename?: 'NoteLinksAggregate';
  aggregate?: Maybe<NoteLinksAggregateFields>;
  nodes: Array<NoteLinks>;
};

export type NoteLinksAggregateBoolExp = {
  bool_and?: InputMaybe<NoteLinksAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<NoteLinksAggregateBoolExpBool_Or>;
  count?: InputMaybe<NoteLinksAggregateBoolExpCount>;
};

/** aggregate fields of "note_links" */
export type NoteLinksAggregateFields = {
  __typename?: 'NoteLinksAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<NoteLinksMaxFields>;
  min?: Maybe<NoteLinksMinFields>;
};


/** aggregate fields of "note_links" */
export type NoteLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NoteLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "note_links" */
export type NoteLinksAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<NoteLinksMaxOrderBy>;
  min?: InputMaybe<NoteLinksMinOrderBy>;
};

/** input type for inserting array relation for remote table "note_links" */
export type NoteLinksArrRelInsertInput = {
  data: Array<NoteLinksInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<NoteLinksOnConflict>;
};

/** Boolean expression to filter rows from the table "note_links". All fields are combined with a logical 'AND'. */
export type NoteLinksBoolExp = {
  _and?: InputMaybe<Array<NoteLinksBoolExp>>;
  _not?: InputMaybe<NoteLinksBoolExp>;
  _or?: InputMaybe<Array<NoteLinksBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  isPinned?: InputMaybe<BooleanComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobAppointmentAssignmentGuid?: InputMaybe<UuidComparisonExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  jobCostAddressedAt?: InputMaybe<TimestamptzComparisonExp>;
  jobCostAddressedByUser?: InputMaybe<UsersBoolExp>;
  jobCostAddressedByUserGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  job_appointment?: InputMaybe<JobAppointmentsBoolExp>;
  job_appointment_assignment?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  maintenancePlanGuid?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<NotesBoolExp>;
  noteGuid?: InputMaybe<UuidComparisonExp>;
  paymentRecordGuid?: InputMaybe<UuidComparisonExp>;
  payment_record?: InputMaybe<PaymentRecordsBoolExp>;
  photo?: InputMaybe<PhotosBoolExp>;
  photoGuid?: InputMaybe<UuidComparisonExp>;
  pinnedAt?: InputMaybe<TimestamptzComparisonExp>;
  pinnedByUser?: InputMaybe<UsersBoolExp>;
  pinnedByUserGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "note_links" */
export type NoteLinksConstraint =
  /** unique or primary key constraint on columns "note_guid" */
  | 'note_links_pkey';

/** input type for inserting data into table "note_links" */
export type NoteLinksInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobCostAddressedAt?: InputMaybe<Scalars['timestamptz']>;
  jobCostAddressedByUser?: InputMaybe<UsersObjRelInsertInput>;
  jobCostAddressedByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  job_appointment?: InputMaybe<JobAppointmentsObjRelInsertInput>;
  job_appointment_assignment?: InputMaybe<JobAppointmentAssignmentsObjRelInsertInput>;
  location?: InputMaybe<LocationsObjRelInsertInput>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<NotesObjRelInsertInput>;
  noteGuid?: InputMaybe<Scalars['uuid']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  payment_record?: InputMaybe<PaymentRecordsObjRelInsertInput>;
  photo?: InputMaybe<PhotosObjRelInsertInput>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  pinnedAt?: InputMaybe<Scalars['timestamptz']>;
  pinnedByUser?: InputMaybe<UsersObjRelInsertInput>;
  pinnedByUserGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type NoteLinksMaxFields = {
  __typename?: 'NoteLinksMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobCostAddressedAt?: Maybe<Scalars['timestamptz']>;
  jobCostAddressedByUserGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  noteGuid?: Maybe<Scalars['uuid']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  pinnedAt?: Maybe<Scalars['timestamptz']>;
  pinnedByUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "note_links" */
export type NoteLinksMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobCostAddressedAt?: InputMaybe<OrderBy>;
  jobCostAddressedByUserGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  noteGuid?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  pinnedAt?: InputMaybe<OrderBy>;
  pinnedByUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type NoteLinksMinFields = {
  __typename?: 'NoteLinksMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobCostAddressedAt?: Maybe<Scalars['timestamptz']>;
  jobCostAddressedByUserGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  noteGuid?: Maybe<Scalars['uuid']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  pinnedAt?: Maybe<Scalars['timestamptz']>;
  pinnedByUserGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "note_links" */
export type NoteLinksMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobCostAddressedAt?: InputMaybe<OrderBy>;
  jobCostAddressedByUserGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  noteGuid?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  pinnedAt?: InputMaybe<OrderBy>;
  pinnedByUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "note_links" */
export type NoteLinksMutationResponse = {
  __typename?: 'NoteLinksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NoteLinks>;
};

/** on_conflict condition type for table "note_links" */
export type NoteLinksOnConflict = {
  constraint: NoteLinksConstraint;
  updateColumns?: Array<NoteLinksUpdateColumn>;
  where?: InputMaybe<NoteLinksBoolExp>;
};

/** Ordering options when selecting data from "note_links". */
export type NoteLinksOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  isPinned?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobCostAddressedAt?: InputMaybe<OrderBy>;
  jobCostAddressedByUser?: InputMaybe<UsersOrderBy>;
  jobCostAddressedByUserGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  job_appointment?: InputMaybe<JobAppointmentsOrderBy>;
  job_appointment_assignment?: InputMaybe<JobAppointmentAssignmentsOrderBy>;
  location?: InputMaybe<LocationsOrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  note?: InputMaybe<NotesOrderBy>;
  noteGuid?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  payment_record?: InputMaybe<PaymentRecordsOrderBy>;
  photo?: InputMaybe<PhotosOrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  pinnedAt?: InputMaybe<OrderBy>;
  pinnedByUser?: InputMaybe<UsersOrderBy>;
  pinnedByUserGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: note_links */
export type NoteLinksPkColumnsInput = {
  noteGuid: Scalars['uuid'];
};

/** select columns of table "note_links" */
export type NoteLinksSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'isPinned'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobCostAddressedAt'
  /** column name */
  | 'jobCostAddressedByUserGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'noteGuid'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'pinnedAt'
  /** column name */
  | 'pinnedByUserGuid'
  /** column name */
  | 'updatedAt';

/** select "noteLinksAggregateBoolExpBool_andArgumentsColumns" columns of table "note_links" */
export type NoteLinksSelectColumnNoteLinksAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isPinned';

/** select "noteLinksAggregateBoolExpBool_orArgumentsColumns" columns of table "note_links" */
export type NoteLinksSelectColumnNoteLinksAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isPinned';

/** input type for updating data in table "note_links" */
export type NoteLinksSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobCostAddressedAt?: InputMaybe<Scalars['timestamptz']>;
  jobCostAddressedByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  noteGuid?: InputMaybe<Scalars['uuid']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  pinnedAt?: InputMaybe<Scalars['timestamptz']>;
  pinnedByUserGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "note_links" */
export type NoteLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NoteLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NoteLinksStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobCostAddressedAt?: InputMaybe<Scalars['timestamptz']>;
  jobCostAddressedByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  noteGuid?: InputMaybe<Scalars['uuid']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  pinnedAt?: InputMaybe<Scalars['timestamptz']>;
  pinnedByUserGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "note_links" */
export type NoteLinksUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'isPinned'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobCostAddressedAt'
  /** column name */
  | 'jobCostAddressedByUserGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'noteGuid'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'pinnedAt'
  /** column name */
  | 'pinnedByUserGuid'
  /** column name */
  | 'updatedAt';

export type NoteLinksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NoteLinksSetInput>;
  /** filter the rows which have to be updated */
  where: NoteLinksBoolExp;
};

/** columns and relationships of "note_tagged_users" */
export type NoteTaggedUsers = {
  __typename?: 'NoteTaggedUsers';
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  /** An object relationship */
  note: Notes;
  noteGuid: Scalars['uuid'];
  noteUserTagGuid: Scalars['uuid'];
  /** An object relationship */
  taggedUser: Users;
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "note_tagged_users" */
export type NoteTaggedUsersAggregate = {
  __typename?: 'NoteTaggedUsersAggregate';
  aggregate?: Maybe<NoteTaggedUsersAggregateFields>;
  nodes: Array<NoteTaggedUsers>;
};

export type NoteTaggedUsersAggregateBoolExp = {
  count?: InputMaybe<NoteTaggedUsersAggregateBoolExpCount>;
};

/** aggregate fields of "note_tagged_users" */
export type NoteTaggedUsersAggregateFields = {
  __typename?: 'NoteTaggedUsersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<NoteTaggedUsersMaxFields>;
  min?: Maybe<NoteTaggedUsersMinFields>;
};


/** aggregate fields of "note_tagged_users" */
export type NoteTaggedUsersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NoteTaggedUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "note_tagged_users" */
export type NoteTaggedUsersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<NoteTaggedUsersMaxOrderBy>;
  min?: InputMaybe<NoteTaggedUsersMinOrderBy>;
};

/** input type for inserting array relation for remote table "note_tagged_users" */
export type NoteTaggedUsersArrRelInsertInput = {
  data: Array<NoteTaggedUsersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<NoteTaggedUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "note_tagged_users". All fields are combined with a logical 'AND'. */
export type NoteTaggedUsersBoolExp = {
  _and?: InputMaybe<Array<NoteTaggedUsersBoolExp>>;
  _not?: InputMaybe<NoteTaggedUsersBoolExp>;
  _or?: InputMaybe<Array<NoteTaggedUsersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<NotesBoolExp>;
  noteGuid?: InputMaybe<UuidComparisonExp>;
  noteUserTagGuid?: InputMaybe<UuidComparisonExp>;
  taggedUser?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "note_tagged_users" */
export type NoteTaggedUsersConstraint =
  /** unique or primary key constraint on columns "user_guid", "note_guid" */
  | 'note_user_tags_note_guid_user_guid_key'
  /** unique or primary key constraint on columns "note_user_tag_guid" */
  | 'note_user_tags_pkey';

/** input type for inserting data into table "note_tagged_users" */
export type NoteTaggedUsersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<NotesObjRelInsertInput>;
  noteGuid?: InputMaybe<Scalars['uuid']>;
  noteUserTagGuid?: InputMaybe<Scalars['uuid']>;
  taggedUser?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type NoteTaggedUsersMaxFields = {
  __typename?: 'NoteTaggedUsersMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  noteGuid?: Maybe<Scalars['uuid']>;
  noteUserTagGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "note_tagged_users" */
export type NoteTaggedUsersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  noteGuid?: InputMaybe<OrderBy>;
  noteUserTagGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type NoteTaggedUsersMinFields = {
  __typename?: 'NoteTaggedUsersMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  noteGuid?: Maybe<Scalars['uuid']>;
  noteUserTagGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "note_tagged_users" */
export type NoteTaggedUsersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  noteGuid?: InputMaybe<OrderBy>;
  noteUserTagGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "note_tagged_users" */
export type NoteTaggedUsersMutationResponse = {
  __typename?: 'NoteTaggedUsersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NoteTaggedUsers>;
};

/** on_conflict condition type for table "note_tagged_users" */
export type NoteTaggedUsersOnConflict = {
  constraint: NoteTaggedUsersConstraint;
  updateColumns?: Array<NoteTaggedUsersUpdateColumn>;
  where?: InputMaybe<NoteTaggedUsersBoolExp>;
};

/** Ordering options when selecting data from "note_tagged_users". */
export type NoteTaggedUsersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  note?: InputMaybe<NotesOrderBy>;
  noteGuid?: InputMaybe<OrderBy>;
  noteUserTagGuid?: InputMaybe<OrderBy>;
  taggedUser?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: note_tagged_users */
export type NoteTaggedUsersPkColumnsInput = {
  noteUserTagGuid: Scalars['uuid'];
};

/** select columns of table "note_tagged_users" */
export type NoteTaggedUsersSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'noteGuid'
  /** column name */
  | 'noteUserTagGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "note_tagged_users" */
export type NoteTaggedUsersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  noteGuid?: InputMaybe<Scalars['uuid']>;
  noteUserTagGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "note_tagged_users" */
export type NoteTaggedUsersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NoteTaggedUsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NoteTaggedUsersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  noteGuid?: InputMaybe<Scalars['uuid']>;
  noteUserTagGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "note_tagged_users" */
export type NoteTaggedUsersUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'noteGuid'
  /** column name */
  | 'noteUserTagGuid'
  /** column name */
  | 'userGuid';

export type NoteTaggedUsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NoteTaggedUsersSetInput>;
  /** filter the rows which have to be updated */
  where: NoteTaggedUsersBoolExp;
};

/** columns and relationships of "notes" */
export type Notes = {
  __typename?: 'Notes';
  /** An object relationship */
  account?: Maybe<Accounts>;
  accountGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  /** An object relationship */
  job?: Maybe<Jobs>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  noteAttachments: Array<NoteAttachments>;
  /** An aggregate relationship */
  noteAttachmentsAggregate: NoteAttachmentsAggregate;
  noteGuid: Scalars['uuid'];
  /** Classification for notes (e.g., job_cost). Default general for standard notes. */
  noteType: Scalars['String'];
  /** An array relationship */
  taggedUsers: Array<NoteTaggedUsers>;
  /** An aggregate relationship */
  taggedUsersAggregate: NoteTaggedUsersAggregate;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  value: Scalars['String'];
};


/** columns and relationships of "notes" */
export type NotesNoteAttachmentsArgs = {
  distinctOn?: InputMaybe<Array<NoteAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteAttachmentsOrderBy>>;
  where?: InputMaybe<NoteAttachmentsBoolExp>;
};


/** columns and relationships of "notes" */
export type NotesNoteAttachmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteAttachmentsOrderBy>>;
  where?: InputMaybe<NoteAttachmentsBoolExp>;
};


/** columns and relationships of "notes" */
export type NotesTaggedUsersArgs = {
  distinctOn?: InputMaybe<Array<NoteTaggedUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteTaggedUsersOrderBy>>;
  where?: InputMaybe<NoteTaggedUsersBoolExp>;
};


/** columns and relationships of "notes" */
export type NotesTaggedUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteTaggedUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteTaggedUsersOrderBy>>;
  where?: InputMaybe<NoteTaggedUsersBoolExp>;
};

/** aggregated selection of "notes" */
export type NotesAggregate = {
  __typename?: 'NotesAggregate';
  aggregate?: Maybe<NotesAggregateFields>;
  nodes: Array<Notes>;
};

export type NotesAggregateBoolExp = {
  count?: InputMaybe<NotesAggregateBoolExpCount>;
};

/** aggregate fields of "notes" */
export type NotesAggregateFields = {
  __typename?: 'NotesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<NotesMaxFields>;
  min?: Maybe<NotesMinFields>;
};


/** aggregate fields of "notes" */
export type NotesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NotesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notes" */
export type NotesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<NotesMaxOrderBy>;
  min?: InputMaybe<NotesMinOrderBy>;
};

/** input type for inserting array relation for remote table "notes" */
export type NotesArrRelInsertInput = {
  data: Array<NotesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<NotesOnConflict>;
};

/** Boolean expression to filter rows from the table "notes". All fields are combined with a logical 'AND'. */
export type NotesBoolExp = {
  _and?: InputMaybe<Array<NotesBoolExp>>;
  _not?: InputMaybe<NotesBoolExp>;
  _or?: InputMaybe<Array<NotesBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  noteAttachments?: InputMaybe<NoteAttachmentsBoolExp>;
  noteAttachmentsAggregate?: InputMaybe<NoteAttachmentsAggregateBoolExp>;
  noteGuid?: InputMaybe<UuidComparisonExp>;
  noteType?: InputMaybe<StringComparisonExp>;
  taggedUsers?: InputMaybe<NoteTaggedUsersBoolExp>;
  taggedUsersAggregate?: InputMaybe<NoteTaggedUsersAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "notes" */
export type NotesConstraint =
  /** unique or primary key constraint on columns "note_guid" */
  | 'notes_pkey';

/** input type for inserting data into table "notes" */
export type NotesInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  noteAttachments?: InputMaybe<NoteAttachmentsArrRelInsertInput>;
  noteGuid?: InputMaybe<Scalars['uuid']>;
  /** Classification for notes (e.g., job_cost). Default general for standard notes. */
  noteType?: InputMaybe<Scalars['String']>;
  taggedUsers?: InputMaybe<NoteTaggedUsersArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type NotesMaxFields = {
  __typename?: 'NotesMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  noteGuid?: Maybe<Scalars['uuid']>;
  /** Classification for notes (e.g., job_cost). Default general for standard notes. */
  noteType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "notes" */
export type NotesMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  noteGuid?: InputMaybe<OrderBy>;
  /** Classification for notes (e.g., job_cost). Default general for standard notes. */
  noteType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type NotesMinFields = {
  __typename?: 'NotesMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  noteGuid?: Maybe<Scalars['uuid']>;
  /** Classification for notes (e.g., job_cost). Default general for standard notes. */
  noteType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "notes" */
export type NotesMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  noteGuid?: InputMaybe<OrderBy>;
  /** Classification for notes (e.g., job_cost). Default general for standard notes. */
  noteType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "notes" */
export type NotesMutationResponse = {
  __typename?: 'NotesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notes>;
};

/** input type for inserting object relation for remote table "notes" */
export type NotesObjRelInsertInput = {
  data: NotesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<NotesOnConflict>;
};

/** on_conflict condition type for table "notes" */
export type NotesOnConflict = {
  constraint: NotesConstraint;
  updateColumns?: Array<NotesUpdateColumn>;
  where?: InputMaybe<NotesBoolExp>;
};

/** Ordering options when selecting data from "notes". */
export type NotesOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  noteAttachmentsAggregate?: InputMaybe<NoteAttachmentsAggregateOrderBy>;
  noteGuid?: InputMaybe<OrderBy>;
  noteType?: InputMaybe<OrderBy>;
  taggedUsersAggregate?: InputMaybe<NoteTaggedUsersAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notes */
export type NotesPkColumnsInput = {
  noteGuid: Scalars['uuid'];
};

/** select columns of table "notes" */
export type NotesSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'noteGuid'
  /** column name */
  | 'noteType'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'value';

/** input type for updating data in table "notes" */
export type NotesSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  noteGuid?: InputMaybe<Scalars['uuid']>;
  /** Classification for notes (e.g., job_cost). Default general for standard notes. */
  noteType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notes" */
export type NotesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NotesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotesStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  noteGuid?: InputMaybe<Scalars['uuid']>;
  /** Classification for notes (e.g., job_cost). Default general for standard notes. */
  noteType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notes" */
export type NotesUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'noteGuid'
  /** column name */
  | 'noteType'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'value';

export type NotesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotesSetInput>;
  /** filter the rows which have to be updated */
  where: NotesBoolExp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** Company config for managing online booking */
export type OnlineBookingCompanyConfig = {
  __typename?: 'OnlineBookingCompanyConfig';
  afterHoursBannerHtml?: Maybe<Scalars['HtmlString']>;
  brandingColorHex: Scalars['String'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  limitBookingsToServiceAreaEnabled: Scalars['Boolean'];
  /** An array relationship */
  serviceAreaZipCodes: Array<OnlineBookingServiceAreaZipCodes>;
  /** An aggregate relationship */
  serviceAreaZipCodesAggregate: OnlineBookingServiceAreaZipCodesAggregate;
  updatedAt: Scalars['timestamptz'];
};


/** Company config for managing online booking */
export type OnlineBookingCompanyConfigServiceAreaZipCodesArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceAreaZipCodesBoolExp>;
};


/** Company config for managing online booking */
export type OnlineBookingCompanyConfigServiceAreaZipCodesAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceAreaZipCodesBoolExp>;
};

/** aggregated selection of "online_booking_company_config" */
export type OnlineBookingCompanyConfigAggregate = {
  __typename?: 'OnlineBookingCompanyConfigAggregate';
  aggregate?: Maybe<OnlineBookingCompanyConfigAggregateFields>;
  nodes: Array<OnlineBookingCompanyConfig>;
};

/** aggregate fields of "online_booking_company_config" */
export type OnlineBookingCompanyConfigAggregateFields = {
  __typename?: 'OnlineBookingCompanyConfigAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<OnlineBookingCompanyConfigMaxFields>;
  min?: Maybe<OnlineBookingCompanyConfigMinFields>;
};


/** aggregate fields of "online_booking_company_config" */
export type OnlineBookingCompanyConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OnlineBookingCompanyConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "online_booking_company_config". All fields are combined with a logical 'AND'. */
export type OnlineBookingCompanyConfigBoolExp = {
  _and?: InputMaybe<Array<OnlineBookingCompanyConfigBoolExp>>;
  _not?: InputMaybe<OnlineBookingCompanyConfigBoolExp>;
  _or?: InputMaybe<Array<OnlineBookingCompanyConfigBoolExp>>;
  afterHoursBannerHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
  brandingColorHex?: InputMaybe<StringComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  limitBookingsToServiceAreaEnabled?: InputMaybe<BooleanComparisonExp>;
  serviceAreaZipCodes?: InputMaybe<OnlineBookingServiceAreaZipCodesBoolExp>;
  serviceAreaZipCodesAggregate?: InputMaybe<OnlineBookingServiceAreaZipCodesAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "online_booking_company_config" */
export type OnlineBookingCompanyConfigConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'online_booking_company_config_pkey';

/** input type for inserting data into table "online_booking_company_config" */
export type OnlineBookingCompanyConfigInsertInput = {
  afterHoursBannerHtml?: InputMaybe<Scalars['HtmlString']>;
  brandingColorHex?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  limitBookingsToServiceAreaEnabled?: InputMaybe<Scalars['Boolean']>;
  serviceAreaZipCodes?: InputMaybe<OnlineBookingServiceAreaZipCodesArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type OnlineBookingCompanyConfigMaxFields = {
  __typename?: 'OnlineBookingCompanyConfigMaxFields';
  afterHoursBannerHtml?: Maybe<Scalars['HtmlString']>;
  brandingColorHex?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type OnlineBookingCompanyConfigMinFields = {
  __typename?: 'OnlineBookingCompanyConfigMinFields';
  afterHoursBannerHtml?: Maybe<Scalars['HtmlString']>;
  brandingColorHex?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "online_booking_company_config" */
export type OnlineBookingCompanyConfigMutationResponse = {
  __typename?: 'OnlineBookingCompanyConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OnlineBookingCompanyConfig>;
};

/** input type for inserting object relation for remote table "online_booking_company_config" */
export type OnlineBookingCompanyConfigObjRelInsertInput = {
  data: OnlineBookingCompanyConfigInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<OnlineBookingCompanyConfigOnConflict>;
};

/** on_conflict condition type for table "online_booking_company_config" */
export type OnlineBookingCompanyConfigOnConflict = {
  constraint: OnlineBookingCompanyConfigConstraint;
  updateColumns?: Array<OnlineBookingCompanyConfigUpdateColumn>;
  where?: InputMaybe<OnlineBookingCompanyConfigBoolExp>;
};

/** Ordering options when selecting data from "online_booking_company_config". */
export type OnlineBookingCompanyConfigOrderBy = {
  afterHoursBannerHtml?: InputMaybe<OrderBy>;
  brandingColorHex?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  limitBookingsToServiceAreaEnabled?: InputMaybe<OrderBy>;
  serviceAreaZipCodesAggregate?: InputMaybe<OnlineBookingServiceAreaZipCodesAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: online_booking_company_config */
export type OnlineBookingCompanyConfigPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "online_booking_company_config" */
export type OnlineBookingCompanyConfigSelectColumn =
  /** column name */
  | 'afterHoursBannerHtml'
  /** column name */
  | 'brandingColorHex'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'limitBookingsToServiceAreaEnabled'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "online_booking_company_config" */
export type OnlineBookingCompanyConfigSetInput = {
  afterHoursBannerHtml?: InputMaybe<Scalars['HtmlString']>;
  brandingColorHex?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  limitBookingsToServiceAreaEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "online_booking_company_config" */
export type OnlineBookingCompanyConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OnlineBookingCompanyConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OnlineBookingCompanyConfigStreamCursorValueInput = {
  afterHoursBannerHtml?: InputMaybe<Scalars['HtmlString']>;
  brandingColorHex?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  limitBookingsToServiceAreaEnabled?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "online_booking_company_config" */
export type OnlineBookingCompanyConfigUpdateColumn =
  /** column name */
  | 'afterHoursBannerHtml'
  /** column name */
  | 'brandingColorHex'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'limitBookingsToServiceAreaEnabled'
  /** column name */
  | 'updatedAt';

export type OnlineBookingCompanyConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OnlineBookingCompanyConfigSetInput>;
  /** filter the rows which have to be updated */
  where: OnlineBookingCompanyConfigBoolExp;
};

/** Manage service area zip codes for online booking */
export type OnlineBookingServiceAreaZipCodes = {
  __typename?: 'OnlineBookingServiceAreaZipCodes';
  companyGuid: Scalars['uuid'];
  serviceAreaZipCodeGuid: Scalars['uuid'];
  zipCode: Scalars['String'];
};

/** aggregated selection of "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesAggregate = {
  __typename?: 'OnlineBookingServiceAreaZipCodesAggregate';
  aggregate?: Maybe<OnlineBookingServiceAreaZipCodesAggregateFields>;
  nodes: Array<OnlineBookingServiceAreaZipCodes>;
};

export type OnlineBookingServiceAreaZipCodesAggregateBoolExp = {
  count?: InputMaybe<OnlineBookingServiceAreaZipCodesAggregateBoolExpCount>;
};

/** aggregate fields of "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesAggregateFields = {
  __typename?: 'OnlineBookingServiceAreaZipCodesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<OnlineBookingServiceAreaZipCodesMaxFields>;
  min?: Maybe<OnlineBookingServiceAreaZipCodesMinFields>;
};


/** aggregate fields of "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OnlineBookingServiceAreaZipCodesMaxOrderBy>;
  min?: InputMaybe<OnlineBookingServiceAreaZipCodesMinOrderBy>;
};

/** input type for inserting array relation for remote table "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesArrRelInsertInput = {
  data: Array<OnlineBookingServiceAreaZipCodesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<OnlineBookingServiceAreaZipCodesOnConflict>;
};

/** Boolean expression to filter rows from the table "online_booking_service_area_zip_codes". All fields are combined with a logical 'AND'. */
export type OnlineBookingServiceAreaZipCodesBoolExp = {
  _and?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesBoolExp>>;
  _not?: InputMaybe<OnlineBookingServiceAreaZipCodesBoolExp>;
  _or?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  serviceAreaZipCodeGuid?: InputMaybe<UuidComparisonExp>;
  zipCode?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesConstraint =
  /** unique or primary key constraint on columns "zip_code", "company_guid" */
  | 'online_booking_service_area_zip_codes_company_guid_zip_code_key'
  /** unique or primary key constraint on columns "service_area_zip_code_guid" */
  | 'online_booking_service_area_zip_codes_pkey';

/** input type for inserting data into table "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  serviceAreaZipCodeGuid?: InputMaybe<Scalars['uuid']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type OnlineBookingServiceAreaZipCodesMaxFields = {
  __typename?: 'OnlineBookingServiceAreaZipCodesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  serviceAreaZipCodeGuid?: Maybe<Scalars['uuid']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  serviceAreaZipCodeGuid?: InputMaybe<OrderBy>;
  zipCode?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type OnlineBookingServiceAreaZipCodesMinFields = {
  __typename?: 'OnlineBookingServiceAreaZipCodesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  serviceAreaZipCodeGuid?: Maybe<Scalars['uuid']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  serviceAreaZipCodeGuid?: InputMaybe<OrderBy>;
  zipCode?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesMutationResponse = {
  __typename?: 'OnlineBookingServiceAreaZipCodesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OnlineBookingServiceAreaZipCodes>;
};

/** on_conflict condition type for table "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesOnConflict = {
  constraint: OnlineBookingServiceAreaZipCodesConstraint;
  updateColumns?: Array<OnlineBookingServiceAreaZipCodesUpdateColumn>;
  where?: InputMaybe<OnlineBookingServiceAreaZipCodesBoolExp>;
};

/** Ordering options when selecting data from "online_booking_service_area_zip_codes". */
export type OnlineBookingServiceAreaZipCodesOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  serviceAreaZipCodeGuid?: InputMaybe<OrderBy>;
  zipCode?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: online_booking_service_area_zip_codes */
export type OnlineBookingServiceAreaZipCodesPkColumnsInput = {
  serviceAreaZipCodeGuid: Scalars['uuid'];
};

/** select columns of table "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'serviceAreaZipCodeGuid'
  /** column name */
  | 'zipCode';

/** input type for updating data in table "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  serviceAreaZipCodeGuid?: InputMaybe<Scalars['uuid']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OnlineBookingServiceAreaZipCodesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OnlineBookingServiceAreaZipCodesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  serviceAreaZipCodeGuid?: InputMaybe<Scalars['uuid']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** update columns of table "online_booking_service_area_zip_codes" */
export type OnlineBookingServiceAreaZipCodesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'serviceAreaZipCodeGuid'
  /** column name */
  | 'zipCode';

export type OnlineBookingServiceAreaZipCodesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OnlineBookingServiceAreaZipCodesSetInput>;
  /** filter the rows which have to be updated */
  where: OnlineBookingServiceAreaZipCodesBoolExp;
};

/** Manage enabled job types for a online booking service type */
export type OnlineBookingServiceTypeBookableJobTypes = {
  __typename?: 'OnlineBookingServiceTypeBookableJobTypes';
  companyGuid: Scalars['uuid'];
  /** An object relationship */
  jobType: JobTypes;
  jobTypeGuid: Scalars['uuid'];
  onlineBookingServiceTypeGuid: Scalars['uuid'];
};

/** aggregated selection of "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesAggregate = {
  __typename?: 'OnlineBookingServiceTypeBookableJobTypesAggregate';
  aggregate?: Maybe<OnlineBookingServiceTypeBookableJobTypesAggregateFields>;
  nodes: Array<OnlineBookingServiceTypeBookableJobTypes>;
};

export type OnlineBookingServiceTypeBookableJobTypesAggregateBoolExp = {
  count?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesAggregateBoolExpCount>;
};

/** aggregate fields of "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesAggregateFields = {
  __typename?: 'OnlineBookingServiceTypeBookableJobTypesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<OnlineBookingServiceTypeBookableJobTypesMaxFields>;
  min?: Maybe<OnlineBookingServiceTypeBookableJobTypesMinFields>;
};


/** aggregate fields of "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesMaxOrderBy>;
  min?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesMinOrderBy>;
};

/** input type for inserting array relation for remote table "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesArrRelInsertInput = {
  data: Array<OnlineBookingServiceTypeBookableJobTypesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesOnConflict>;
};

/** Boolean expression to filter rows from the table "online_booking_service_type_bookable_job_types". All fields are combined with a logical 'AND'. */
export type OnlineBookingServiceTypeBookableJobTypesBoolExp = {
  _and?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesBoolExp>>;
  _not?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesBoolExp>;
  _or?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  jobType?: InputMaybe<JobTypesBoolExp>;
  jobTypeGuid?: InputMaybe<UuidComparisonExp>;
  onlineBookingServiceTypeGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesConstraint =
  /** unique or primary key constraint on columns "online_booking_service_type_guid", "job_type_guid" */
  | 'online_booking_service_type_bookable_job_types_pkey';

/** input type for inserting data into table "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobType?: InputMaybe<JobTypesObjRelInsertInput>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  onlineBookingServiceTypeGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type OnlineBookingServiceTypeBookableJobTypesMaxFields = {
  __typename?: 'OnlineBookingServiceTypeBookableJobTypesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  onlineBookingServiceTypeGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  onlineBookingServiceTypeGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type OnlineBookingServiceTypeBookableJobTypesMinFields = {
  __typename?: 'OnlineBookingServiceTypeBookableJobTypesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  jobTypeGuid?: Maybe<Scalars['uuid']>;
  onlineBookingServiceTypeGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  onlineBookingServiceTypeGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesMutationResponse = {
  __typename?: 'OnlineBookingServiceTypeBookableJobTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OnlineBookingServiceTypeBookableJobTypes>;
};

/** on_conflict condition type for table "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesOnConflict = {
  constraint: OnlineBookingServiceTypeBookableJobTypesConstraint;
  updateColumns?: Array<OnlineBookingServiceTypeBookableJobTypesUpdateColumn>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesBoolExp>;
};

/** Ordering options when selecting data from "online_booking_service_type_bookable_job_types". */
export type OnlineBookingServiceTypeBookableJobTypesOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  jobType?: InputMaybe<JobTypesOrderBy>;
  jobTypeGuid?: InputMaybe<OrderBy>;
  onlineBookingServiceTypeGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: online_booking_service_type_bookable_job_types */
export type OnlineBookingServiceTypeBookableJobTypesPkColumnsInput = {
  jobTypeGuid: Scalars['uuid'];
  onlineBookingServiceTypeGuid: Scalars['uuid'];
};

/** select columns of table "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'onlineBookingServiceTypeGuid';

/** input type for updating data in table "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  onlineBookingServiceTypeGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OnlineBookingServiceTypeBookableJobTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OnlineBookingServiceTypeBookableJobTypesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobTypeGuid?: InputMaybe<Scalars['uuid']>;
  onlineBookingServiceTypeGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "online_booking_service_type_bookable_job_types" */
export type OnlineBookingServiceTypeBookableJobTypesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'jobTypeGuid'
  /** column name */
  | 'onlineBookingServiceTypeGuid';

export type OnlineBookingServiceTypeBookableJobTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesSetInput>;
  /** filter the rows which have to be updated */
  where: OnlineBookingServiceTypeBookableJobTypesBoolExp;
};

/** Manage enabled technicians for an online booking service type */
export type OnlineBookingServiceTypeBookableTechnicians = {
  __typename?: 'OnlineBookingServiceTypeBookableTechnicians';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  onlineBookingServiceTypeGuid: Scalars['uuid'];
  seq: Scalars['Int'];
  /** An object relationship */
  technician: Users;
  technicianGuid: Scalars['uuid'];
};

/** aggregated selection of "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansAggregate = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansAggregate';
  aggregate?: Maybe<OnlineBookingServiceTypeBookableTechniciansAggregateFields>;
  nodes: Array<OnlineBookingServiceTypeBookableTechnicians>;
};

export type OnlineBookingServiceTypeBookableTechniciansAggregateBoolExp = {
  count?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansAggregateBoolExpCount>;
};

/** aggregate fields of "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansAggregateFields = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansAggregateFields';
  avg?: Maybe<OnlineBookingServiceTypeBookableTechniciansAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OnlineBookingServiceTypeBookableTechniciansMaxFields>;
  min?: Maybe<OnlineBookingServiceTypeBookableTechniciansMinFields>;
  stddev?: Maybe<OnlineBookingServiceTypeBookableTechniciansStddevFields>;
  stddevPop?: Maybe<OnlineBookingServiceTypeBookableTechniciansStddevPopFields>;
  stddevSamp?: Maybe<OnlineBookingServiceTypeBookableTechniciansStddevSampFields>;
  sum?: Maybe<OnlineBookingServiceTypeBookableTechniciansSumFields>;
  varPop?: Maybe<OnlineBookingServiceTypeBookableTechniciansVarPopFields>;
  varSamp?: Maybe<OnlineBookingServiceTypeBookableTechniciansVarSampFields>;
  variance?: Maybe<OnlineBookingServiceTypeBookableTechniciansVarianceFields>;
};


/** aggregate fields of "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansAggregateOrderBy = {
  avg?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansMaxOrderBy>;
  min?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansMinOrderBy>;
  stddev?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansStddevOrderBy>;
  stddevPop?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansStddevPopOrderBy>;
  stddevSamp?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansStddevSampOrderBy>;
  sum?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansSumOrderBy>;
  varPop?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansVarPopOrderBy>;
  varSamp?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansVarSampOrderBy>;
  variance?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansArrRelInsertInput = {
  data: Array<OnlineBookingServiceTypeBookableTechniciansInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansOnConflict>;
};

/** aggregate avg on columns */
export type OnlineBookingServiceTypeBookableTechniciansAvgFields = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansAvgFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansAvgOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "online_booking_service_type_bookable_technicians". All fields are combined with a logical 'AND'. */
export type OnlineBookingServiceTypeBookableTechniciansBoolExp = {
  _and?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansBoolExp>>;
  _not?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansBoolExp>;
  _or?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  onlineBookingServiceTypeGuid?: InputMaybe<UuidComparisonExp>;
  seq?: InputMaybe<IntComparisonExp>;
  technician?: InputMaybe<UsersBoolExp>;
  technicianGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansConstraint =
  /** unique or primary key constraint on columns "online_booking_service_type_guid", "technician_guid" */
  | 'online_booking_service_type_bookable_technicians_pkey';

/** input type for incrementing numeric columns in table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansIncInput = {
  seq?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  onlineBookingServiceTypeGuid?: InputMaybe<Scalars['uuid']>;
  seq?: InputMaybe<Scalars['Int']>;
  technician?: InputMaybe<UsersObjRelInsertInput>;
  technicianGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type OnlineBookingServiceTypeBookableTechniciansMaxFields = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  onlineBookingServiceTypeGuid?: Maybe<Scalars['uuid']>;
  seq?: Maybe<Scalars['Int']>;
  technicianGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  onlineBookingServiceTypeGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  technicianGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type OnlineBookingServiceTypeBookableTechniciansMinFields = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  onlineBookingServiceTypeGuid?: Maybe<Scalars['uuid']>;
  seq?: Maybe<Scalars['Int']>;
  technicianGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  onlineBookingServiceTypeGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  technicianGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansMutationResponse = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OnlineBookingServiceTypeBookableTechnicians>;
};

/** on_conflict condition type for table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansOnConflict = {
  constraint: OnlineBookingServiceTypeBookableTechniciansConstraint;
  updateColumns?: Array<OnlineBookingServiceTypeBookableTechniciansUpdateColumn>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansBoolExp>;
};

/** Ordering options when selecting data from "online_booking_service_type_bookable_technicians". */
export type OnlineBookingServiceTypeBookableTechniciansOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  onlineBookingServiceTypeGuid?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  technician?: InputMaybe<UsersOrderBy>;
  technicianGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: online_booking_service_type_bookable_technicians */
export type OnlineBookingServiceTypeBookableTechniciansPkColumnsInput = {
  onlineBookingServiceTypeGuid: Scalars['uuid'];
  technicianGuid: Scalars['uuid'];
};

/** select columns of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'onlineBookingServiceTypeGuid'
  /** column name */
  | 'seq'
  /** column name */
  | 'technicianGuid';

/** input type for updating data in table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  onlineBookingServiceTypeGuid?: InputMaybe<Scalars['uuid']>;
  seq?: InputMaybe<Scalars['Int']>;
  technicianGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type OnlineBookingServiceTypeBookableTechniciansStddevFields = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansStddevFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansStddevOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type OnlineBookingServiceTypeBookableTechniciansStddevPopFields = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansStddevPopFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansStddevPopOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type OnlineBookingServiceTypeBookableTechniciansStddevSampFields = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansStddevSampFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansStddevSampOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OnlineBookingServiceTypeBookableTechniciansStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OnlineBookingServiceTypeBookableTechniciansStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  onlineBookingServiceTypeGuid?: InputMaybe<Scalars['uuid']>;
  seq?: InputMaybe<Scalars['Int']>;
  technicianGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type OnlineBookingServiceTypeBookableTechniciansSumFields = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansSumFields';
  seq?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansSumOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** update columns of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'onlineBookingServiceTypeGuid'
  /** column name */
  | 'seq'
  /** column name */
  | 'technicianGuid';

export type OnlineBookingServiceTypeBookableTechniciansUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansSetInput>;
  /** filter the rows which have to be updated */
  where: OnlineBookingServiceTypeBookableTechniciansBoolExp;
};

/** aggregate varPop on columns */
export type OnlineBookingServiceTypeBookableTechniciansVarPopFields = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansVarPopFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansVarPopOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type OnlineBookingServiceTypeBookableTechniciansVarSampFields = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansVarSampFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansVarSampOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type OnlineBookingServiceTypeBookableTechniciansVarianceFields = {
  __typename?: 'OnlineBookingServiceTypeBookableTechniciansVarianceFields';
  seq?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "online_booking_service_type_bookable_technicians" */
export type OnlineBookingServiceTypeBookableTechniciansVarianceOrderBy = {
  seq?: InputMaybe<OrderBy>;
};

/** Manage online booking service types. */
export type OnlineBookingServiceTypeConfigs = {
  __typename?: 'OnlineBookingServiceTypeConfigs';
  /** Specifies how technicians are assigned for instant booking: RANDOM or ORDERED */
  assignmentType: Scalars['InstantBookingAssignmentType'];
  /** An array relationship */
  bookableJobTypes: Array<OnlineBookingServiceTypeBookableJobTypes>;
  /** An aggregate relationship */
  bookableJobTypesAggregate: OnlineBookingServiceTypeBookableJobTypesAggregate;
  /** An array relationship */
  bookableTechnicians: Array<OnlineBookingServiceTypeBookableTechnicians>;
  /** An aggregate relationship */
  bookableTechniciansAggregate: OnlineBookingServiceTypeBookableTechniciansAggregate;
  bookingType: Scalars['OnlineBookingType'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  earliestAvailability: Scalars['OnlineBookingEarliestAvailableTime'];
  /** An array relationship */
  instantBookingWeeklyScheduleEntries: Array<InstantBookingWeeklyScheduleEntries>;
  /** An aggregate relationship */
  instantBookingWeeklyScheduleEntriesAggregate: InstantBookingWeeklyScheduleEntriesAggregate;
  latestAvailability: Scalars['OnlineBookingLatestAvailableTime'];
  /** THIS IS DEPRECATED AND WILL BE REMOVED. USE legal_blurb_html instead */
  legalBlurb?: Maybe<Scalars['String']>;
  legalBlurbHtml?: Maybe<Scalars['HtmlString']>;
  onlineBookingServiceTypeGuid: Scalars['uuid'];
  serviceType: Scalars['OnlineBookingServiceType'];
  updatedAt: Scalars['timestamptz'];
};


/** Manage online booking service types. */
export type OnlineBookingServiceTypeConfigsBookableJobTypesArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesBoolExp>;
};


/** Manage online booking service types. */
export type OnlineBookingServiceTypeConfigsBookableJobTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesBoolExp>;
};


/** Manage online booking service types. */
export type OnlineBookingServiceTypeConfigsBookableTechniciansArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansBoolExp>;
};


/** Manage online booking service types. */
export type OnlineBookingServiceTypeConfigsBookableTechniciansAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansBoolExp>;
};


/** Manage online booking service types. */
export type OnlineBookingServiceTypeConfigsInstantBookingWeeklyScheduleEntriesArgs = {
  distinctOn?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesOrderBy>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
};


/** Manage online booking service types. */
export type OnlineBookingServiceTypeConfigsInstantBookingWeeklyScheduleEntriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesOrderBy>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
};

/** aggregated selection of "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsAggregate = {
  __typename?: 'OnlineBookingServiceTypeConfigsAggregate';
  aggregate?: Maybe<OnlineBookingServiceTypeConfigsAggregateFields>;
  nodes: Array<OnlineBookingServiceTypeConfigs>;
};

export type OnlineBookingServiceTypeConfigsAggregateBoolExp = {
  count?: InputMaybe<OnlineBookingServiceTypeConfigsAggregateBoolExpCount>;
};

/** aggregate fields of "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsAggregateFields = {
  __typename?: 'OnlineBookingServiceTypeConfigsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<OnlineBookingServiceTypeConfigsMaxFields>;
  min?: Maybe<OnlineBookingServiceTypeConfigsMinFields>;
};


/** aggregate fields of "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OnlineBookingServiceTypeConfigsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OnlineBookingServiceTypeConfigsMaxOrderBy>;
  min?: InputMaybe<OnlineBookingServiceTypeConfigsMinOrderBy>;
};

/** input type for inserting array relation for remote table "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsArrRelInsertInput = {
  data: Array<OnlineBookingServiceTypeConfigsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<OnlineBookingServiceTypeConfigsOnConflict>;
};

/** Boolean expression to filter rows from the table "online_booking_service_type_configs". All fields are combined with a logical 'AND'. */
export type OnlineBookingServiceTypeConfigsBoolExp = {
  _and?: InputMaybe<Array<OnlineBookingServiceTypeConfigsBoolExp>>;
  _not?: InputMaybe<OnlineBookingServiceTypeConfigsBoolExp>;
  _or?: InputMaybe<Array<OnlineBookingServiceTypeConfigsBoolExp>>;
  assignmentType?: InputMaybe<Scalars['InstantBookingAssignmentTypeComparisonExp']>;
  bookableJobTypes?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesBoolExp>;
  bookableJobTypesAggregate?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesAggregateBoolExp>;
  bookableTechnicians?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansBoolExp>;
  bookableTechniciansAggregate?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansAggregateBoolExp>;
  bookingType?: InputMaybe<Scalars['OnlineBookingTypeComparisonExp']>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  earliestAvailability?: InputMaybe<Scalars['OnlineBookingEarliestAvailableTimeComparisonExp']>;
  instantBookingWeeklyScheduleEntries?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
  instantBookingWeeklyScheduleEntriesAggregate?: InputMaybe<InstantBookingWeeklyScheduleEntriesAggregateBoolExp>;
  latestAvailability?: InputMaybe<Scalars['OnlineBookingLatestAvailableTimeComparisonExp']>;
  legalBlurb?: InputMaybe<StringComparisonExp>;
  legalBlurbHtml?: InputMaybe<Scalars['HtmlStringComparisonExp']>;
  onlineBookingServiceTypeGuid?: InputMaybe<UuidComparisonExp>;
  serviceType?: InputMaybe<Scalars['OnlineBookingServiceTypeComparisonExp']>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsConstraint =
  /** unique or primary key constraint on columns "online_booking_service_type_guid" */
  | 'online_booking_service_type_configs_pkey';

/** input type for inserting data into table "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsInsertInput = {
  /** Specifies how technicians are assigned for instant booking: RANDOM or ORDERED */
  assignmentType?: InputMaybe<Scalars['InstantBookingAssignmentType']>;
  bookableJobTypes?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesArrRelInsertInput>;
  bookableTechnicians?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansArrRelInsertInput>;
  bookingType?: InputMaybe<Scalars['OnlineBookingType']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  earliestAvailability?: InputMaybe<Scalars['OnlineBookingEarliestAvailableTime']>;
  instantBookingWeeklyScheduleEntries?: InputMaybe<InstantBookingWeeklyScheduleEntriesArrRelInsertInput>;
  latestAvailability?: InputMaybe<Scalars['OnlineBookingLatestAvailableTime']>;
  /** THIS IS DEPRECATED AND WILL BE REMOVED. USE legal_blurb_html instead */
  legalBlurb?: InputMaybe<Scalars['String']>;
  legalBlurbHtml?: InputMaybe<Scalars['HtmlString']>;
  onlineBookingServiceTypeGuid?: InputMaybe<Scalars['uuid']>;
  serviceType?: InputMaybe<Scalars['OnlineBookingServiceType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type OnlineBookingServiceTypeConfigsMaxFields = {
  __typename?: 'OnlineBookingServiceTypeConfigsMaxFields';
  /** Specifies how technicians are assigned for instant booking: RANDOM or ORDERED */
  assignmentType?: Maybe<Scalars['InstantBookingAssignmentType']>;
  bookingType?: Maybe<Scalars['OnlineBookingType']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  earliestAvailability?: Maybe<Scalars['OnlineBookingEarliestAvailableTime']>;
  latestAvailability?: Maybe<Scalars['OnlineBookingLatestAvailableTime']>;
  /** THIS IS DEPRECATED AND WILL BE REMOVED. USE legal_blurb_html instead */
  legalBlurb?: Maybe<Scalars['String']>;
  legalBlurbHtml?: Maybe<Scalars['HtmlString']>;
  onlineBookingServiceTypeGuid?: Maybe<Scalars['uuid']>;
  serviceType?: Maybe<Scalars['OnlineBookingServiceType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsMaxOrderBy = {
  /** Specifies how technicians are assigned for instant booking: RANDOM or ORDERED */
  assignmentType?: InputMaybe<OrderBy>;
  bookingType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  earliestAvailability?: InputMaybe<OrderBy>;
  latestAvailability?: InputMaybe<OrderBy>;
  /** THIS IS DEPRECATED AND WILL BE REMOVED. USE legal_blurb_html instead */
  legalBlurb?: InputMaybe<OrderBy>;
  legalBlurbHtml?: InputMaybe<OrderBy>;
  onlineBookingServiceTypeGuid?: InputMaybe<OrderBy>;
  serviceType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type OnlineBookingServiceTypeConfigsMinFields = {
  __typename?: 'OnlineBookingServiceTypeConfigsMinFields';
  /** Specifies how technicians are assigned for instant booking: RANDOM or ORDERED */
  assignmentType?: Maybe<Scalars['InstantBookingAssignmentType']>;
  bookingType?: Maybe<Scalars['OnlineBookingType']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  earliestAvailability?: Maybe<Scalars['OnlineBookingEarliestAvailableTime']>;
  latestAvailability?: Maybe<Scalars['OnlineBookingLatestAvailableTime']>;
  /** THIS IS DEPRECATED AND WILL BE REMOVED. USE legal_blurb_html instead */
  legalBlurb?: Maybe<Scalars['String']>;
  legalBlurbHtml?: Maybe<Scalars['HtmlString']>;
  onlineBookingServiceTypeGuid?: Maybe<Scalars['uuid']>;
  serviceType?: Maybe<Scalars['OnlineBookingServiceType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsMinOrderBy = {
  /** Specifies how technicians are assigned for instant booking: RANDOM or ORDERED */
  assignmentType?: InputMaybe<OrderBy>;
  bookingType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  earliestAvailability?: InputMaybe<OrderBy>;
  latestAvailability?: InputMaybe<OrderBy>;
  /** THIS IS DEPRECATED AND WILL BE REMOVED. USE legal_blurb_html instead */
  legalBlurb?: InputMaybe<OrderBy>;
  legalBlurbHtml?: InputMaybe<OrderBy>;
  onlineBookingServiceTypeGuid?: InputMaybe<OrderBy>;
  serviceType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsMutationResponse = {
  __typename?: 'OnlineBookingServiceTypeConfigsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OnlineBookingServiceTypeConfigs>;
};

/** on_conflict condition type for table "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsOnConflict = {
  constraint: OnlineBookingServiceTypeConfigsConstraint;
  updateColumns?: Array<OnlineBookingServiceTypeConfigsUpdateColumn>;
  where?: InputMaybe<OnlineBookingServiceTypeConfigsBoolExp>;
};

/** Ordering options when selecting data from "online_booking_service_type_configs". */
export type OnlineBookingServiceTypeConfigsOrderBy = {
  assignmentType?: InputMaybe<OrderBy>;
  bookableJobTypesAggregate?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesAggregateOrderBy>;
  bookableTechniciansAggregate?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansAggregateOrderBy>;
  bookingType?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  earliestAvailability?: InputMaybe<OrderBy>;
  instantBookingWeeklyScheduleEntriesAggregate?: InputMaybe<InstantBookingWeeklyScheduleEntriesAggregateOrderBy>;
  latestAvailability?: InputMaybe<OrderBy>;
  legalBlurb?: InputMaybe<OrderBy>;
  legalBlurbHtml?: InputMaybe<OrderBy>;
  onlineBookingServiceTypeGuid?: InputMaybe<OrderBy>;
  serviceType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: online_booking_service_type_configs */
export type OnlineBookingServiceTypeConfigsPkColumnsInput = {
  onlineBookingServiceTypeGuid: Scalars['uuid'];
};

/** select columns of table "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsSelectColumn =
  /** column name */
  | 'assignmentType'
  /** column name */
  | 'bookingType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'earliestAvailability'
  /** column name */
  | 'latestAvailability'
  /** column name */
  | 'legalBlurb'
  /** column name */
  | 'legalBlurbHtml'
  /** column name */
  | 'onlineBookingServiceTypeGuid'
  /** column name */
  | 'serviceType'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsSetInput = {
  /** Specifies how technicians are assigned for instant booking: RANDOM or ORDERED */
  assignmentType?: InputMaybe<Scalars['InstantBookingAssignmentType']>;
  bookingType?: InputMaybe<Scalars['OnlineBookingType']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  earliestAvailability?: InputMaybe<Scalars['OnlineBookingEarliestAvailableTime']>;
  latestAvailability?: InputMaybe<Scalars['OnlineBookingLatestAvailableTime']>;
  /** THIS IS DEPRECATED AND WILL BE REMOVED. USE legal_blurb_html instead */
  legalBlurb?: InputMaybe<Scalars['String']>;
  legalBlurbHtml?: InputMaybe<Scalars['HtmlString']>;
  onlineBookingServiceTypeGuid?: InputMaybe<Scalars['uuid']>;
  serviceType?: InputMaybe<Scalars['OnlineBookingServiceType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OnlineBookingServiceTypeConfigsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OnlineBookingServiceTypeConfigsStreamCursorValueInput = {
  /** Specifies how technicians are assigned for instant booking: RANDOM or ORDERED */
  assignmentType?: InputMaybe<Scalars['InstantBookingAssignmentType']>;
  bookingType?: InputMaybe<Scalars['OnlineBookingType']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  earliestAvailability?: InputMaybe<Scalars['OnlineBookingEarliestAvailableTime']>;
  latestAvailability?: InputMaybe<Scalars['OnlineBookingLatestAvailableTime']>;
  /** THIS IS DEPRECATED AND WILL BE REMOVED. USE legal_blurb_html instead */
  legalBlurb?: InputMaybe<Scalars['String']>;
  legalBlurbHtml?: InputMaybe<Scalars['HtmlString']>;
  onlineBookingServiceTypeGuid?: InputMaybe<Scalars['uuid']>;
  serviceType?: InputMaybe<Scalars['OnlineBookingServiceType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "online_booking_service_type_configs" */
export type OnlineBookingServiceTypeConfigsUpdateColumn =
  /** column name */
  | 'assignmentType'
  /** column name */
  | 'bookingType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'earliestAvailability'
  /** column name */
  | 'latestAvailability'
  /** column name */
  | 'legalBlurb'
  /** column name */
  | 'legalBlurbHtml'
  /** column name */
  | 'onlineBookingServiceTypeGuid'
  /** column name */
  | 'serviceType'
  /** column name */
  | 'updatedAt';

export type OnlineBookingServiceTypeConfigsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OnlineBookingServiceTypeConfigsSetInput>;
  /** filter the rows which have to be updated */
  where: OnlineBookingServiceTypeConfigsBoolExp;
};

/** column ordering options */
export type OrderBy =
  /** in ascending order, nulls last */
  | 'ASC'
  /** in ascending order, nulls first */
  | 'ASC_NULLS_FIRST'
  /** in ascending order, nulls last */
  | 'ASC_NULLS_LAST'
  /** in descending order, nulls first */
  | 'DESC'
  /** in descending order, nulls first */
  | 'DESC_NULLS_FIRST'
  /** in descending order, nulls last */
  | 'DESC_NULLS_LAST';

/** columns and relationships of "payment_links" */
export type PaymentLinks = {
  __typename?: 'PaymentLinks';
  /** An object relationship */
  collectedByUser?: Maybe<Users>;
  collectedByUserGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  job?: Maybe<Jobs>;
  /** An object relationship */
  jobAppointment?: Maybe<JobAppointments>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  loanRecord?: Maybe<WisetackLoanRecords>;
  /** An object relationship */
  maintenancePlan?: Maybe<MaintenancePlansQueryable>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  paymentMethodRecordGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  paymentRecord: PaymentRecords;
  paymentRecordGuid: Scalars['uuid'];
  /** An object relationship */
  paymentSubscription?: Maybe<PaymentSubscriptions>;
  paymentSubscriptionGuid?: Maybe<Scalars['uuid']>;
  wisetackLoanRecordGuid?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "payment_links" */
export type PaymentLinksAggregate = {
  __typename?: 'PaymentLinksAggregate';
  aggregate?: Maybe<PaymentLinksAggregateFields>;
  nodes: Array<PaymentLinks>;
};

export type PaymentLinksAggregateBoolExp = {
  count?: InputMaybe<PaymentLinksAggregateBoolExpCount>;
};

/** aggregate fields of "payment_links" */
export type PaymentLinksAggregateFields = {
  __typename?: 'PaymentLinksAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentLinksMaxFields>;
  min?: Maybe<PaymentLinksMinFields>;
};


/** aggregate fields of "payment_links" */
export type PaymentLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_links" */
export type PaymentLinksAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PaymentLinksMaxOrderBy>;
  min?: InputMaybe<PaymentLinksMinOrderBy>;
};

/** input type for inserting array relation for remote table "payment_links" */
export type PaymentLinksArrRelInsertInput = {
  data: Array<PaymentLinksInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentLinksOnConflict>;
};

/** Boolean expression to filter rows from the table "payment_links". All fields are combined with a logical 'AND'. */
export type PaymentLinksBoolExp = {
  _and?: InputMaybe<Array<PaymentLinksBoolExp>>;
  _not?: InputMaybe<PaymentLinksBoolExp>;
  _or?: InputMaybe<Array<PaymentLinksBoolExp>>;
  collectedByUser?: InputMaybe<UsersBoolExp>;
  collectedByUserGuid?: InputMaybe<UuidComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobAppointment?: InputMaybe<JobAppointmentsBoolExp>;
  jobAppointmentAssignmentGuid?: InputMaybe<UuidComparisonExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  loanRecord?: InputMaybe<WisetackLoanRecordsBoolExp>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableBoolExp>;
  maintenancePlanGuid?: InputMaybe<UuidComparisonExp>;
  paymentMethodRecordGuid?: InputMaybe<UuidComparisonExp>;
  paymentRecord?: InputMaybe<PaymentRecordsBoolExp>;
  paymentRecordGuid?: InputMaybe<UuidComparisonExp>;
  paymentSubscription?: InputMaybe<PaymentSubscriptionsBoolExp>;
  paymentSubscriptionGuid?: InputMaybe<UuidComparisonExp>;
  wisetackLoanRecordGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "payment_links" */
export type PaymentLinksConstraint =
  /** unique or primary key constraint on columns "payment_record_guid" */
  | 'payment_links_pkey';

/** input type for inserting data into table "payment_links" */
export type PaymentLinksInsertInput = {
  collectedByUser?: InputMaybe<UsersObjRelInsertInput>;
  collectedByUserGuid?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobAppointment?: InputMaybe<JobAppointmentsObjRelInsertInput>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  loanRecord?: InputMaybe<WisetackLoanRecordsObjRelInsertInput>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableObjRelInsertInput>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  paymentMethodRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentRecord?: InputMaybe<PaymentRecordsObjRelInsertInput>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscription?: InputMaybe<PaymentSubscriptionsObjRelInsertInput>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  wisetackLoanRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PaymentLinksMaxFields = {
  __typename?: 'PaymentLinksMaxFields';
  collectedByUserGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  paymentMethodRecordGuid?: Maybe<Scalars['uuid']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentSubscriptionGuid?: Maybe<Scalars['uuid']>;
  wisetackLoanRecordGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment_links" */
export type PaymentLinksMaxOrderBy = {
  collectedByUserGuid?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  paymentMethodRecordGuid?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  wisetackLoanRecordGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PaymentLinksMinFields = {
  __typename?: 'PaymentLinksMinFields';
  collectedByUserGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  maintenancePlanGuid?: Maybe<Scalars['uuid']>;
  paymentMethodRecordGuid?: Maybe<Scalars['uuid']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentSubscriptionGuid?: Maybe<Scalars['uuid']>;
  wisetackLoanRecordGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment_links" */
export type PaymentLinksMinOrderBy = {
  collectedByUserGuid?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  paymentMethodRecordGuid?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  wisetackLoanRecordGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "payment_links" */
export type PaymentLinksMutationResponse = {
  __typename?: 'PaymentLinksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentLinks>;
};

/** input type for inserting object relation for remote table "payment_links" */
export type PaymentLinksObjRelInsertInput = {
  data: PaymentLinksInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentLinksOnConflict>;
};

/** on_conflict condition type for table "payment_links" */
export type PaymentLinksOnConflict = {
  constraint: PaymentLinksConstraint;
  updateColumns?: Array<PaymentLinksUpdateColumn>;
  where?: InputMaybe<PaymentLinksBoolExp>;
};

/** Ordering options when selecting data from "payment_links". */
export type PaymentLinksOrderBy = {
  collectedByUser?: InputMaybe<UsersOrderBy>;
  collectedByUserGuid?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobAppointment?: InputMaybe<JobAppointmentsOrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  loanRecord?: InputMaybe<WisetackLoanRecordsOrderBy>;
  maintenancePlan?: InputMaybe<MaintenancePlansQueryableOrderBy>;
  maintenancePlanGuid?: InputMaybe<OrderBy>;
  paymentMethodRecordGuid?: InputMaybe<OrderBy>;
  paymentRecord?: InputMaybe<PaymentRecordsOrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentSubscription?: InputMaybe<PaymentSubscriptionsOrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  wisetackLoanRecordGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_links */
export type PaymentLinksPkColumnsInput = {
  paymentRecordGuid: Scalars['uuid'];
};

/** select columns of table "payment_links" */
export type PaymentLinksSelectColumn =
  /** column name */
  | 'collectedByUserGuid'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'paymentMethodRecordGuid'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentSubscriptionGuid'
  /** column name */
  | 'wisetackLoanRecordGuid';

/** input type for updating data in table "payment_links" */
export type PaymentLinksSetInput = {
  collectedByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  paymentMethodRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  wisetackLoanRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "payment_links" */
export type PaymentLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentLinksStreamCursorValueInput = {
  collectedByUserGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  maintenancePlanGuid?: InputMaybe<Scalars['uuid']>;
  paymentMethodRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  wisetackLoanRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "payment_links" */
export type PaymentLinksUpdateColumn =
  /** column name */
  | 'collectedByUserGuid'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'maintenancePlanGuid'
  /** column name */
  | 'paymentMethodRecordGuid'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentSubscriptionGuid'
  /** column name */
  | 'wisetackLoanRecordGuid';

export type PaymentLinksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentLinksSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentLinksBoolExp;
};

/** Associated billing info for a customers on file payment method */
export type PaymentMethodBillingInfo = {
  __typename?: 'PaymentMethodBillingInfo';
  /** An object relationship */
  address: Addresses;
  addressGuid: Scalars['uuid'];
  name: Scalars['String'];
  paymentMethodRecordGuid: Scalars['uuid'];
};

/** aggregated selection of "payment_method_billing_info" */
export type PaymentMethodBillingInfoAggregate = {
  __typename?: 'PaymentMethodBillingInfoAggregate';
  aggregate?: Maybe<PaymentMethodBillingInfoAggregateFields>;
  nodes: Array<PaymentMethodBillingInfo>;
};

/** aggregate fields of "payment_method_billing_info" */
export type PaymentMethodBillingInfoAggregateFields = {
  __typename?: 'PaymentMethodBillingInfoAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentMethodBillingInfoMaxFields>;
  min?: Maybe<PaymentMethodBillingInfoMinFields>;
};


/** aggregate fields of "payment_method_billing_info" */
export type PaymentMethodBillingInfoAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentMethodBillingInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment_method_billing_info". All fields are combined with a logical 'AND'. */
export type PaymentMethodBillingInfoBoolExp = {
  _and?: InputMaybe<Array<PaymentMethodBillingInfoBoolExp>>;
  _not?: InputMaybe<PaymentMethodBillingInfoBoolExp>;
  _or?: InputMaybe<Array<PaymentMethodBillingInfoBoolExp>>;
  address?: InputMaybe<AddressesBoolExp>;
  addressGuid?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  paymentMethodRecordGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "payment_method_billing_info" */
export type PaymentMethodBillingInfoConstraint =
  /** unique or primary key constraint on columns "payment_method_record_guid" */
  | 'payment_method_billing_info_pkey';

/** input type for inserting data into table "payment_method_billing_info" */
export type PaymentMethodBillingInfoInsertInput = {
  address?: InputMaybe<AddressesObjRelInsertInput>;
  addressGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  paymentMethodRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PaymentMethodBillingInfoMaxFields = {
  __typename?: 'PaymentMethodBillingInfoMaxFields';
  addressGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  paymentMethodRecordGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PaymentMethodBillingInfoMinFields = {
  __typename?: 'PaymentMethodBillingInfoMinFields';
  addressGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  paymentMethodRecordGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "payment_method_billing_info" */
export type PaymentMethodBillingInfoMutationResponse = {
  __typename?: 'PaymentMethodBillingInfoMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentMethodBillingInfo>;
};

/** input type for inserting object relation for remote table "payment_method_billing_info" */
export type PaymentMethodBillingInfoObjRelInsertInput = {
  data: PaymentMethodBillingInfoInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentMethodBillingInfoOnConflict>;
};

/** on_conflict condition type for table "payment_method_billing_info" */
export type PaymentMethodBillingInfoOnConflict = {
  constraint: PaymentMethodBillingInfoConstraint;
  updateColumns?: Array<PaymentMethodBillingInfoUpdateColumn>;
  where?: InputMaybe<PaymentMethodBillingInfoBoolExp>;
};

/** Ordering options when selecting data from "payment_method_billing_info". */
export type PaymentMethodBillingInfoOrderBy = {
  address?: InputMaybe<AddressesOrderBy>;
  addressGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  paymentMethodRecordGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_method_billing_info */
export type PaymentMethodBillingInfoPkColumnsInput = {
  paymentMethodRecordGuid: Scalars['uuid'];
};

/** select columns of table "payment_method_billing_info" */
export type PaymentMethodBillingInfoSelectColumn =
  /** column name */
  | 'addressGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'paymentMethodRecordGuid';

/** input type for updating data in table "payment_method_billing_info" */
export type PaymentMethodBillingInfoSetInput = {
  addressGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  paymentMethodRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "payment_method_billing_info" */
export type PaymentMethodBillingInfoStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentMethodBillingInfoStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentMethodBillingInfoStreamCursorValueInput = {
  addressGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  paymentMethodRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "payment_method_billing_info" */
export type PaymentMethodBillingInfoUpdateColumn =
  /** column name */
  | 'addressGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'paymentMethodRecordGuid';

export type PaymentMethodBillingInfoUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentMethodBillingInfoSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentMethodBillingInfoBoolExp;
};

/** Metadata about persistent card payment methods (e.g. last 4 digits, card brand, etc.) */
export type PaymentMethodCardMetadata = {
  __typename?: 'PaymentMethodCardMetadata';
  brand: Scalars['String'];
  expMonth: Scalars['String'];
  expYear: Scalars['String'];
  lastFourDigits: Scalars['String'];
  paymentMethodRecordGuid: Scalars['uuid'];
  type: PaymentMethodCardTypeEnum;
};

/** aggregated selection of "payment_method_card_metadata" */
export type PaymentMethodCardMetadataAggregate = {
  __typename?: 'PaymentMethodCardMetadataAggregate';
  aggregate?: Maybe<PaymentMethodCardMetadataAggregateFields>;
  nodes: Array<PaymentMethodCardMetadata>;
};

/** aggregate fields of "payment_method_card_metadata" */
export type PaymentMethodCardMetadataAggregateFields = {
  __typename?: 'PaymentMethodCardMetadataAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentMethodCardMetadataMaxFields>;
  min?: Maybe<PaymentMethodCardMetadataMinFields>;
};


/** aggregate fields of "payment_method_card_metadata" */
export type PaymentMethodCardMetadataAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentMethodCardMetadataSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment_method_card_metadata". All fields are combined with a logical 'AND'. */
export type PaymentMethodCardMetadataBoolExp = {
  _and?: InputMaybe<Array<PaymentMethodCardMetadataBoolExp>>;
  _not?: InputMaybe<PaymentMethodCardMetadataBoolExp>;
  _or?: InputMaybe<Array<PaymentMethodCardMetadataBoolExp>>;
  brand?: InputMaybe<StringComparisonExp>;
  expMonth?: InputMaybe<StringComparisonExp>;
  expYear?: InputMaybe<StringComparisonExp>;
  lastFourDigits?: InputMaybe<StringComparisonExp>;
  paymentMethodRecordGuid?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<PaymentMethodCardTypeEnumComparisonExp>;
};

/** unique or primary key constraints on table "payment_method_card_metadata" */
export type PaymentMethodCardMetadataConstraint =
  /** unique or primary key constraint on columns "payment_method_record_guid" */
  | 'payment_method_card_metadata_pkey';

/** input type for inserting data into table "payment_method_card_metadata" */
export type PaymentMethodCardMetadataInsertInput = {
  brand?: InputMaybe<Scalars['String']>;
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  lastFourDigits?: InputMaybe<Scalars['String']>;
  paymentMethodRecordGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<PaymentMethodCardTypeEnum>;
};

/** aggregate max on columns */
export type PaymentMethodCardMetadataMaxFields = {
  __typename?: 'PaymentMethodCardMetadataMaxFields';
  brand?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  lastFourDigits?: Maybe<Scalars['String']>;
  paymentMethodRecordGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PaymentMethodCardMetadataMinFields = {
  __typename?: 'PaymentMethodCardMetadataMinFields';
  brand?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  lastFourDigits?: Maybe<Scalars['String']>;
  paymentMethodRecordGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "payment_method_card_metadata" */
export type PaymentMethodCardMetadataMutationResponse = {
  __typename?: 'PaymentMethodCardMetadataMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentMethodCardMetadata>;
};

/** input type for inserting object relation for remote table "payment_method_card_metadata" */
export type PaymentMethodCardMetadataObjRelInsertInput = {
  data: PaymentMethodCardMetadataInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentMethodCardMetadataOnConflict>;
};

/** on_conflict condition type for table "payment_method_card_metadata" */
export type PaymentMethodCardMetadataOnConflict = {
  constraint: PaymentMethodCardMetadataConstraint;
  updateColumns?: Array<PaymentMethodCardMetadataUpdateColumn>;
  where?: InputMaybe<PaymentMethodCardMetadataBoolExp>;
};

/** Ordering options when selecting data from "payment_method_card_metadata". */
export type PaymentMethodCardMetadataOrderBy = {
  brand?: InputMaybe<OrderBy>;
  expMonth?: InputMaybe<OrderBy>;
  expYear?: InputMaybe<OrderBy>;
  lastFourDigits?: InputMaybe<OrderBy>;
  paymentMethodRecordGuid?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_method_card_metadata */
export type PaymentMethodCardMetadataPkColumnsInput = {
  paymentMethodRecordGuid: Scalars['uuid'];
};

/** select columns of table "payment_method_card_metadata" */
export type PaymentMethodCardMetadataSelectColumn =
  /** column name */
  | 'brand'
  /** column name */
  | 'expMonth'
  /** column name */
  | 'expYear'
  /** column name */
  | 'lastFourDigits'
  /** column name */
  | 'paymentMethodRecordGuid'
  /** column name */
  | 'type';

/** input type for updating data in table "payment_method_card_metadata" */
export type PaymentMethodCardMetadataSetInput = {
  brand?: InputMaybe<Scalars['String']>;
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  lastFourDigits?: InputMaybe<Scalars['String']>;
  paymentMethodRecordGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<PaymentMethodCardTypeEnum>;
};

/** Streaming cursor of the table "payment_method_card_metadata" */
export type PaymentMethodCardMetadataStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentMethodCardMetadataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentMethodCardMetadataStreamCursorValueInput = {
  brand?: InputMaybe<Scalars['String']>;
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  lastFourDigits?: InputMaybe<Scalars['String']>;
  paymentMethodRecordGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<PaymentMethodCardTypeEnum>;
};

/** update columns of table "payment_method_card_metadata" */
export type PaymentMethodCardMetadataUpdateColumn =
  /** column name */
  | 'brand'
  /** column name */
  | 'expMonth'
  /** column name */
  | 'expYear'
  /** column name */
  | 'lastFourDigits'
  /** column name */
  | 'paymentMethodRecordGuid'
  /** column name */
  | 'type';

export type PaymentMethodCardMetadataUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentMethodCardMetadataSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentMethodCardMetadataBoolExp;
};

export type PaymentMethodCardTypeEnum =
  | 'CREDIT'
  | 'DEBIT'
  | 'PREPAID'
  | 'UNKNOWN';

/** Boolean expression to compare columns of type "PaymentMethodCardTypeEnum". All fields are combined with logical 'AND'. */
export type PaymentMethodCardTypeEnumComparisonExp = {
  _eq?: InputMaybe<PaymentMethodCardTypeEnum>;
  _in?: InputMaybe<Array<PaymentMethodCardTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PaymentMethodCardTypeEnum>;
  _nin?: InputMaybe<Array<PaymentMethodCardTypeEnum>>;
};

/** A table to hold account persistent payment method information */
export type PaymentMethodRecords = {
  __typename?: 'PaymentMethodRecords';
  /** An object relationship */
  account: Accounts;
  accountGuid: Scalars['uuid'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  displayName?: Maybe<Scalars['String']>;
  externalCustomerId: Scalars['String'];
  externalPaymentMethodId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  /** An object relationship */
  paymentMethod: PaymentMethods;
  /** An object relationship */
  paymentMethodBillingInfo?: Maybe<PaymentMethodBillingInfo>;
  /** An object relationship */
  paymentMethodCardMetadata?: Maybe<PaymentMethodCardMetadata>;
  paymentMethodRecordGuid: Scalars['uuid'];
  paymentMethodType: Scalars['PaymentMethod'];
  /** fetch data from the table: "payment_subscriptions" */
  paymentSubscriptions: Array<PaymentSubscriptions>;
  /** fetch aggregated fields from the table: "payment_subscriptions" */
  paymentSubscriptionsAggregate: PaymentSubscriptionsAggregate;
};


/** A table to hold account persistent payment method information */
export type PaymentMethodRecordsPaymentSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionsOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionsBoolExp>;
};


/** A table to hold account persistent payment method information */
export type PaymentMethodRecordsPaymentSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionsOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionsBoolExp>;
};

/** aggregated selection of "payment_method_records" */
export type PaymentMethodRecordsAggregate = {
  __typename?: 'PaymentMethodRecordsAggregate';
  aggregate?: Maybe<PaymentMethodRecordsAggregateFields>;
  nodes: Array<PaymentMethodRecords>;
};

/** aggregate fields of "payment_method_records" */
export type PaymentMethodRecordsAggregateFields = {
  __typename?: 'PaymentMethodRecordsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentMethodRecordsMaxFields>;
  min?: Maybe<PaymentMethodRecordsMinFields>;
};


/** aggregate fields of "payment_method_records" */
export type PaymentMethodRecordsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentMethodRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment_method_records". All fields are combined with a logical 'AND'. */
export type PaymentMethodRecordsBoolExp = {
  _and?: InputMaybe<Array<PaymentMethodRecordsBoolExp>>;
  _not?: InputMaybe<PaymentMethodRecordsBoolExp>;
  _or?: InputMaybe<Array<PaymentMethodRecordsBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  externalCustomerId?: InputMaybe<StringComparisonExp>;
  externalPaymentMethodId?: InputMaybe<StringComparisonExp>;
  isDeleted?: InputMaybe<BooleanComparisonExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentMethodBillingInfo?: InputMaybe<PaymentMethodBillingInfoBoolExp>;
  paymentMethodCardMetadata?: InputMaybe<PaymentMethodCardMetadataBoolExp>;
  paymentMethodRecordGuid?: InputMaybe<UuidComparisonExp>;
  paymentMethodType?: InputMaybe<Scalars['PaymentMethodComparisonExp']>;
  paymentSubscriptions?: InputMaybe<PaymentSubscriptionsBoolExp>;
  paymentSubscriptionsAggregate?: InputMaybe<PaymentSubscriptionsAggregateBoolExp>;
};

/** unique or primary key constraints on table "payment_method_records" */
export type PaymentMethodRecordsConstraint =
  /** unique or primary key constraint on columns "payment_method_record_guid" */
  | 'payment_method_records_pkey';

/** input type for inserting data into table "payment_method_records" */
export type PaymentMethodRecordsInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  externalCustomerId?: InputMaybe<Scalars['String']>;
  externalPaymentMethodId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  paymentMethodBillingInfo?: InputMaybe<PaymentMethodBillingInfoObjRelInsertInput>;
  paymentMethodCardMetadata?: InputMaybe<PaymentMethodCardMetadataObjRelInsertInput>;
  paymentMethodRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentMethodType?: InputMaybe<Scalars['PaymentMethod']>;
  paymentSubscriptions?: InputMaybe<PaymentSubscriptionsArrRelInsertInput>;
};

/** aggregate max on columns */
export type PaymentMethodRecordsMaxFields = {
  __typename?: 'PaymentMethodRecordsMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  displayName?: Maybe<Scalars['String']>;
  externalCustomerId?: Maybe<Scalars['String']>;
  externalPaymentMethodId?: Maybe<Scalars['String']>;
  paymentMethodRecordGuid?: Maybe<Scalars['uuid']>;
  paymentMethodType?: Maybe<Scalars['PaymentMethod']>;
};

/** aggregate min on columns */
export type PaymentMethodRecordsMinFields = {
  __typename?: 'PaymentMethodRecordsMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  displayName?: Maybe<Scalars['String']>;
  externalCustomerId?: Maybe<Scalars['String']>;
  externalPaymentMethodId?: Maybe<Scalars['String']>;
  paymentMethodRecordGuid?: Maybe<Scalars['uuid']>;
  paymentMethodType?: Maybe<Scalars['PaymentMethod']>;
};

/** response of any mutation on the table "payment_method_records" */
export type PaymentMethodRecordsMutationResponse = {
  __typename?: 'PaymentMethodRecordsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentMethodRecords>;
};

/** on_conflict condition type for table "payment_method_records" */
export type PaymentMethodRecordsOnConflict = {
  constraint: PaymentMethodRecordsConstraint;
  updateColumns?: Array<PaymentMethodRecordsUpdateColumn>;
  where?: InputMaybe<PaymentMethodRecordsBoolExp>;
};

/** Ordering options when selecting data from "payment_method_records". */
export type PaymentMethodRecordsOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  externalCustomerId?: InputMaybe<OrderBy>;
  externalPaymentMethodId?: InputMaybe<OrderBy>;
  isDeleted?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<PaymentMethodsOrderBy>;
  paymentMethodBillingInfo?: InputMaybe<PaymentMethodBillingInfoOrderBy>;
  paymentMethodCardMetadata?: InputMaybe<PaymentMethodCardMetadataOrderBy>;
  paymentMethodRecordGuid?: InputMaybe<OrderBy>;
  paymentMethodType?: InputMaybe<OrderBy>;
  paymentSubscriptionsAggregate?: InputMaybe<PaymentSubscriptionsAggregateOrderBy>;
};

/** primary key columns input for table: payment_method_records */
export type PaymentMethodRecordsPkColumnsInput = {
  paymentMethodRecordGuid: Scalars['uuid'];
};

/** select columns of table "payment_method_records" */
export type PaymentMethodRecordsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'displayName'
  /** column name */
  | 'externalCustomerId'
  /** column name */
  | 'externalPaymentMethodId'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'paymentMethodRecordGuid'
  /** column name */
  | 'paymentMethodType';

/** input type for updating data in table "payment_method_records" */
export type PaymentMethodRecordsSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  externalCustomerId?: InputMaybe<Scalars['String']>;
  externalPaymentMethodId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  paymentMethodRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentMethodType?: InputMaybe<Scalars['PaymentMethod']>;
};

/** Streaming cursor of the table "payment_method_records" */
export type PaymentMethodRecordsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentMethodRecordsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentMethodRecordsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  externalCustomerId?: InputMaybe<Scalars['String']>;
  externalPaymentMethodId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  paymentMethodRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentMethodType?: InputMaybe<Scalars['PaymentMethod']>;
};

/** update columns of table "payment_method_records" */
export type PaymentMethodRecordsUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'displayName'
  /** column name */
  | 'externalCustomerId'
  /** column name */
  | 'externalPaymentMethodId'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'paymentMethodRecordGuid'
  /** column name */
  | 'paymentMethodType';

export type PaymentMethodRecordsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentMethodRecordsSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentMethodRecordsBoolExp;
};

/** columns and relationships of "payment_methods" */
export type PaymentMethods = {
  __typename?: 'PaymentMethods';
  name: Scalars['String'];
};

/** Boolean expression to filter rows from the table "payment_methods". All fields are combined with a logical 'AND'. */
export type PaymentMethodsBoolExp = {
  _and?: InputMaybe<Array<PaymentMethodsBoolExp>>;
  _not?: InputMaybe<PaymentMethodsBoolExp>;
  _or?: InputMaybe<Array<PaymentMethodsBoolExp>>;
  name?: InputMaybe<StringComparisonExp>;
};

export type PaymentMethodsEnum =
  | 'ACH'
  | 'CARD'
  | 'CASH'
  | 'CASHAPP'
  | 'CHECK'
  | 'OTHER'
  | 'PAYPAL'
  | 'VENMO'
  | 'WISETACK_LOAN';

/** Boolean expression to compare columns of type "PaymentMethodsEnum". All fields are combined with logical 'AND'. */
export type PaymentMethodsEnumComparisonExp = {
  _eq?: InputMaybe<PaymentMethodsEnum>;
  _in?: InputMaybe<Array<PaymentMethodsEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PaymentMethodsEnum>;
  _nin?: InputMaybe<Array<PaymentMethodsEnum>>;
};

/** Ordering options when selecting data from "payment_methods". */
export type PaymentMethodsOrderBy = {
  name?: InputMaybe<OrderBy>;
};

/** select columns of table "payment_methods" */
export type PaymentMethodsSelectColumn =
  /** column name */
  | 'name';

/** Streaming cursor of the table "payment_methods" */
export type PaymentMethodsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentMethodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentMethodsStreamCursorValueInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "payment_records" */
export type PaymentRecords = {
  __typename?: 'PaymentRecords';
  /** An object relationship */
  account?: Maybe<Accounts>;
  accountGuid: Scalars['uuid'];
  /** An object relationship */
  accountingStaleInfo?: Maybe<PaymentsAccountingStaleInfo>;
  amountUsd: Scalars['numeric'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  externalPaymentId?: Maybe<Scalars['String']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  invoicePayments: Array<InvoicePayments>;
  /** An aggregate relationship */
  invoicePaymentsAggregate: InvoicePaymentsAggregate;
  /** An object relationship */
  invoiceV2?: Maybe<Invoices>;
  occurredAt: Scalars['timestamptz'];
  /** An object relationship */
  paymentLink?: Maybe<PaymentLinks>;
  paymentMethod: Scalars['PaymentMethod'];
  paymentMethodAdditionalInfo?: Maybe<Scalars['String']>;
  paymentRecordGuid: Scalars['uuid'];
  paymentReferenceNumber: Scalars['String'];
  /** An array relationship */
  paymentRefunds: Array<PaymentRefunds>;
  /** An aggregate relationship */
  paymentRefundsAggregate: PaymentRefundsAggregate;
  /** An object relationship */
  paymentStatusLatest?: Maybe<PaymentStatusLatest>;
  /** An array relationship */
  paymentStatuses: Array<PaymentStatuses>;
  /** An aggregate relationship */
  paymentStatusesAggregate: PaymentStatusesAggregate;
  /** An object relationship */
  payoutItem?: Maybe<PayoutItems>;
  /** An object relationship */
  qboSync?: Maybe<PaymentsQboStatus>;
  shouldSendReceipt?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedByUserGuid?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "payment_records" */
export type PaymentRecordsInvoicePaymentsArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


/** columns and relationships of "payment_records" */
export type PaymentRecordsInvoicePaymentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


/** columns and relationships of "payment_records" */
export type PaymentRecordsPaymentRefundsArgs = {
  distinctOn?: InputMaybe<Array<PaymentRefundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRefundsOrderBy>>;
  where?: InputMaybe<PaymentRefundsBoolExp>;
};


/** columns and relationships of "payment_records" */
export type PaymentRecordsPaymentRefundsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentRefundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRefundsOrderBy>>;
  where?: InputMaybe<PaymentRefundsBoolExp>;
};


/** columns and relationships of "payment_records" */
export type PaymentRecordsPaymentStatusesArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusesOrderBy>>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};


/** columns and relationships of "payment_records" */
export type PaymentRecordsPaymentStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusesOrderBy>>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};

/** aggregated selection of "payment_records" */
export type PaymentRecordsAggregate = {
  __typename?: 'PaymentRecordsAggregate';
  aggregate?: Maybe<PaymentRecordsAggregateFields>;
  nodes: Array<PaymentRecords>;
};

export type PaymentRecordsAggregateBoolExp = {
  bool_and?: InputMaybe<PaymentRecordsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<PaymentRecordsAggregateBoolExpBool_Or>;
  count?: InputMaybe<PaymentRecordsAggregateBoolExpCount>;
};

/** aggregate fields of "payment_records" */
export type PaymentRecordsAggregateFields = {
  __typename?: 'PaymentRecordsAggregateFields';
  avg?: Maybe<PaymentRecordsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PaymentRecordsMaxFields>;
  min?: Maybe<PaymentRecordsMinFields>;
  stddev?: Maybe<PaymentRecordsStddevFields>;
  stddevPop?: Maybe<PaymentRecordsStddevPopFields>;
  stddevSamp?: Maybe<PaymentRecordsStddevSampFields>;
  sum?: Maybe<PaymentRecordsSumFields>;
  varPop?: Maybe<PaymentRecordsVarPopFields>;
  varSamp?: Maybe<PaymentRecordsVarSampFields>;
  variance?: Maybe<PaymentRecordsVarianceFields>;
};


/** aggregate fields of "payment_records" */
export type PaymentRecordsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_records" */
export type PaymentRecordsAggregateOrderBy = {
  avg?: InputMaybe<PaymentRecordsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PaymentRecordsMaxOrderBy>;
  min?: InputMaybe<PaymentRecordsMinOrderBy>;
  stddev?: InputMaybe<PaymentRecordsStddevOrderBy>;
  stddevPop?: InputMaybe<PaymentRecordsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PaymentRecordsStddevSampOrderBy>;
  sum?: InputMaybe<PaymentRecordsSumOrderBy>;
  varPop?: InputMaybe<PaymentRecordsVarPopOrderBy>;
  varSamp?: InputMaybe<PaymentRecordsVarSampOrderBy>;
  variance?: InputMaybe<PaymentRecordsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "payment_records" */
export type PaymentRecordsArrRelInsertInput = {
  data: Array<PaymentRecordsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentRecordsOnConflict>;
};

/** aggregate avg on columns */
export type PaymentRecordsAvgFields = {
  __typename?: 'PaymentRecordsAvgFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment_records" */
export type PaymentRecordsAvgOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "payment_records". All fields are combined with a logical 'AND'. */
export type PaymentRecordsBoolExp = {
  _and?: InputMaybe<Array<PaymentRecordsBoolExp>>;
  _not?: InputMaybe<PaymentRecordsBoolExp>;
  _or?: InputMaybe<Array<PaymentRecordsBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  accountingStaleInfo?: InputMaybe<PaymentsAccountingStaleInfoBoolExp>;
  amountUsd?: InputMaybe<NumericComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  doNotSyncToAccountingServiceReason?: InputMaybe<StringComparisonExp>;
  externalPaymentId?: InputMaybe<StringComparisonExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  invoicePayments?: InputMaybe<InvoicePaymentsBoolExp>;
  invoicePaymentsAggregate?: InputMaybe<InvoicePaymentsAggregateBoolExp>;
  invoiceV2?: InputMaybe<InvoicesBoolExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
  paymentLink?: InputMaybe<PaymentLinksBoolExp>;
  paymentMethod?: InputMaybe<Scalars['PaymentMethodComparisonExp']>;
  paymentMethodAdditionalInfo?: InputMaybe<StringComparisonExp>;
  paymentRecordGuid?: InputMaybe<UuidComparisonExp>;
  paymentReferenceNumber?: InputMaybe<StringComparisonExp>;
  paymentRefunds?: InputMaybe<PaymentRefundsBoolExp>;
  paymentRefundsAggregate?: InputMaybe<PaymentRefundsAggregateBoolExp>;
  paymentStatusLatest?: InputMaybe<PaymentStatusLatestBoolExp>;
  paymentStatuses?: InputMaybe<PaymentStatusesBoolExp>;
  paymentStatusesAggregate?: InputMaybe<PaymentStatusesAggregateBoolExp>;
  payoutItem?: InputMaybe<PayoutItemsBoolExp>;
  qboSync?: InputMaybe<PaymentsQboStatusBoolExp>;
  shouldSendReceipt?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedByUserGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "payment_records" */
export type PaymentRecordsConstraint =
  /** unique or primary key constraint on columns "payment_record_guid" */
  | 'payment_records_pkey'
  /** unique or primary key constraint on columns "external_payment_id", "invoice_guid", "company_guid" */
  | 'payment_records_unique_dupe_payment_records';

/** input type for incrementing numeric columns in table "payment_records" */
export type PaymentRecordsIncInput = {
  amountUsd?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "payment_records" */
export type PaymentRecordsInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  accountingStaleInfo?: InputMaybe<PaymentsAccountingStaleInfoObjRelInsertInput>;
  amountUsd?: InputMaybe<Scalars['numeric']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  externalPaymentId?: InputMaybe<Scalars['String']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoicePayments?: InputMaybe<InvoicePaymentsArrRelInsertInput>;
  invoiceV2?: InputMaybe<InvoicesObjRelInsertInput>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentLink?: InputMaybe<PaymentLinksObjRelInsertInput>;
  paymentMethod?: InputMaybe<Scalars['PaymentMethod']>;
  paymentMethodAdditionalInfo?: InputMaybe<Scalars['String']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentReferenceNumber?: InputMaybe<Scalars['String']>;
  paymentRefunds?: InputMaybe<PaymentRefundsArrRelInsertInput>;
  paymentStatusLatest?: InputMaybe<PaymentStatusLatestObjRelInsertInput>;
  paymentStatuses?: InputMaybe<PaymentStatusesArrRelInsertInput>;
  payoutItem?: InputMaybe<PayoutItemsObjRelInsertInput>;
  qboSync?: InputMaybe<PaymentsQboStatusObjRelInsertInput>;
  shouldSendReceipt?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedByUserGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PaymentRecordsMaxFields = {
  __typename?: 'PaymentRecordsMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  amountUsd?: Maybe<Scalars['numeric']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  externalPaymentId?: Maybe<Scalars['String']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  paymentMethod?: Maybe<Scalars['PaymentMethod']>;
  paymentMethodAdditionalInfo?: Maybe<Scalars['String']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentReferenceNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedByUserGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment_records" */
export type PaymentRecordsMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  amountUsd?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  doNotSyncToAccountingServiceReason?: InputMaybe<OrderBy>;
  externalPaymentId?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentMethodAdditionalInfo?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentReferenceNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedByUserGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PaymentRecordsMinFields = {
  __typename?: 'PaymentRecordsMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  amountUsd?: Maybe<Scalars['numeric']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  externalPaymentId?: Maybe<Scalars['String']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  paymentMethod?: Maybe<Scalars['PaymentMethod']>;
  paymentMethodAdditionalInfo?: Maybe<Scalars['String']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentReferenceNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedByUserGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment_records" */
export type PaymentRecordsMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  amountUsd?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  doNotSyncToAccountingServiceReason?: InputMaybe<OrderBy>;
  externalPaymentId?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentMethodAdditionalInfo?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentReferenceNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedByUserGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "payment_records" */
export type PaymentRecordsMutationResponse = {
  __typename?: 'PaymentRecordsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentRecords>;
};

/** input type for inserting object relation for remote table "payment_records" */
export type PaymentRecordsObjRelInsertInput = {
  data: PaymentRecordsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentRecordsOnConflict>;
};

/** on_conflict condition type for table "payment_records" */
export type PaymentRecordsOnConflict = {
  constraint: PaymentRecordsConstraint;
  updateColumns?: Array<PaymentRecordsUpdateColumn>;
  where?: InputMaybe<PaymentRecordsBoolExp>;
};

/** Ordering options when selecting data from "payment_records". */
export type PaymentRecordsOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  accountingStaleInfo?: InputMaybe<PaymentsAccountingStaleInfoOrderBy>;
  amountUsd?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  doNotSyncToAccountingServiceReason?: InputMaybe<OrderBy>;
  externalPaymentId?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  invoicePaymentsAggregate?: InputMaybe<InvoicePaymentsAggregateOrderBy>;
  invoiceV2?: InputMaybe<InvoicesOrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentLink?: InputMaybe<PaymentLinksOrderBy>;
  paymentMethod?: InputMaybe<OrderBy>;
  paymentMethodAdditionalInfo?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentReferenceNumber?: InputMaybe<OrderBy>;
  paymentRefundsAggregate?: InputMaybe<PaymentRefundsAggregateOrderBy>;
  paymentStatusLatest?: InputMaybe<PaymentStatusLatestOrderBy>;
  paymentStatusesAggregate?: InputMaybe<PaymentStatusesAggregateOrderBy>;
  payoutItem?: InputMaybe<PayoutItemsOrderBy>;
  qboSync?: InputMaybe<PaymentsQboStatusOrderBy>;
  shouldSendReceipt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedByUserGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_records */
export type PaymentRecordsPkColumnsInput = {
  paymentRecordGuid: Scalars['uuid'];
};

/** select columns of table "payment_records" */
export type PaymentRecordsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'amountUsd'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'doNotSyncToAccountingServiceReason'
  /** column name */
  | 'externalPaymentId'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'paymentMethod'
  /** column name */
  | 'paymentMethodAdditionalInfo'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentReferenceNumber'
  /** column name */
  | 'shouldSendReceipt'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'updatedByUserGuid';

/** select "paymentRecordsAggregateBoolExpBool_andArgumentsColumns" columns of table "payment_records" */
export type PaymentRecordsSelectColumnPaymentRecordsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'shouldSendReceipt';

/** select "paymentRecordsAggregateBoolExpBool_orArgumentsColumns" columns of table "payment_records" */
export type PaymentRecordsSelectColumnPaymentRecordsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'shouldSendReceipt';

/** input type for updating data in table "payment_records" */
export type PaymentRecordsSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  amountUsd?: InputMaybe<Scalars['numeric']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  externalPaymentId?: InputMaybe<Scalars['String']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentMethod?: InputMaybe<Scalars['PaymentMethod']>;
  paymentMethodAdditionalInfo?: InputMaybe<Scalars['String']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentReferenceNumber?: InputMaybe<Scalars['String']>;
  shouldSendReceipt?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedByUserGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type PaymentRecordsStddevFields = {
  __typename?: 'PaymentRecordsStddevFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment_records" */
export type PaymentRecordsStddevOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PaymentRecordsStddevPopFields = {
  __typename?: 'PaymentRecordsStddevPopFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "payment_records" */
export type PaymentRecordsStddevPopOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PaymentRecordsStddevSampFields = {
  __typename?: 'PaymentRecordsStddevSampFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "payment_records" */
export type PaymentRecordsStddevSampOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "payment_records" */
export type PaymentRecordsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentRecordsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentRecordsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  amountUsd?: InputMaybe<Scalars['numeric']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  externalPaymentId?: InputMaybe<Scalars['String']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentMethod?: InputMaybe<Scalars['PaymentMethod']>;
  paymentMethodAdditionalInfo?: InputMaybe<Scalars['String']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentReferenceNumber?: InputMaybe<Scalars['String']>;
  shouldSendReceipt?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedByUserGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PaymentRecordsSumFields = {
  __typename?: 'PaymentRecordsSumFields';
  amountUsd?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "payment_records" */
export type PaymentRecordsSumOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** update columns of table "payment_records" */
export type PaymentRecordsUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'amountUsd'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'doNotSyncToAccountingServiceReason'
  /** column name */
  | 'externalPaymentId'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'paymentMethod'
  /** column name */
  | 'paymentMethodAdditionalInfo'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentReferenceNumber'
  /** column name */
  | 'shouldSendReceipt'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'updatedByUserGuid';

export type PaymentRecordsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PaymentRecordsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentRecordsSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentRecordsBoolExp;
};

/** aggregate varPop on columns */
export type PaymentRecordsVarPopFields = {
  __typename?: 'PaymentRecordsVarPopFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "payment_records" */
export type PaymentRecordsVarPopOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PaymentRecordsVarSampFields = {
  __typename?: 'PaymentRecordsVarSampFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "payment_records" */
export type PaymentRecordsVarSampOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PaymentRecordsVarianceFields = {
  __typename?: 'PaymentRecordsVarianceFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment_records" */
export type PaymentRecordsVarianceOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

export type PaymentRefundStatusTypesEnum =
  | 'CANCELED'
  | 'FAILED'
  | 'PENDING'
  | 'SUCCEEDED';

/** Boolean expression to compare columns of type "PaymentRefundStatusTypesEnum". All fields are combined with logical 'AND'. */
export type PaymentRefundStatusTypesEnumComparisonExp = {
  _eq?: InputMaybe<PaymentRefundStatusTypesEnum>;
  _in?: InputMaybe<Array<PaymentRefundStatusTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PaymentRefundStatusTypesEnum>;
  _nin?: InputMaybe<Array<PaymentRefundStatusTypesEnum>>;
};

/** columns and relationships of "payment_refunds" */
export type PaymentRefunds = {
  __typename?: 'PaymentRefunds';
  amountUsd: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  externalRefundId?: Maybe<Scalars['String']>;
  issuedByUserGuid: Scalars['uuid'];
  occurredAt: Scalars['timestamptz'];
  /** An object relationship */
  paymentRecord: PaymentRecords;
  paymentRecordGuid: Scalars['uuid'];
  paymentRefundGuid: Scalars['uuid'];
  reasonDescription: Scalars['String'];
  status: PaymentRefundStatusTypesEnum;
};

/** aggregated selection of "payment_refunds" */
export type PaymentRefundsAggregate = {
  __typename?: 'PaymentRefundsAggregate';
  aggregate?: Maybe<PaymentRefundsAggregateFields>;
  nodes: Array<PaymentRefunds>;
};

export type PaymentRefundsAggregateBoolExp = {
  count?: InputMaybe<PaymentRefundsAggregateBoolExpCount>;
};

/** aggregate fields of "payment_refunds" */
export type PaymentRefundsAggregateFields = {
  __typename?: 'PaymentRefundsAggregateFields';
  avg?: Maybe<PaymentRefundsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PaymentRefundsMaxFields>;
  min?: Maybe<PaymentRefundsMinFields>;
  stddev?: Maybe<PaymentRefundsStddevFields>;
  stddevPop?: Maybe<PaymentRefundsStddevPopFields>;
  stddevSamp?: Maybe<PaymentRefundsStddevSampFields>;
  sum?: Maybe<PaymentRefundsSumFields>;
  varPop?: Maybe<PaymentRefundsVarPopFields>;
  varSamp?: Maybe<PaymentRefundsVarSampFields>;
  variance?: Maybe<PaymentRefundsVarianceFields>;
};


/** aggregate fields of "payment_refunds" */
export type PaymentRefundsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentRefundsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_refunds" */
export type PaymentRefundsAggregateOrderBy = {
  avg?: InputMaybe<PaymentRefundsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PaymentRefundsMaxOrderBy>;
  min?: InputMaybe<PaymentRefundsMinOrderBy>;
  stddev?: InputMaybe<PaymentRefundsStddevOrderBy>;
  stddevPop?: InputMaybe<PaymentRefundsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PaymentRefundsStddevSampOrderBy>;
  sum?: InputMaybe<PaymentRefundsSumOrderBy>;
  varPop?: InputMaybe<PaymentRefundsVarPopOrderBy>;
  varSamp?: InputMaybe<PaymentRefundsVarSampOrderBy>;
  variance?: InputMaybe<PaymentRefundsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "payment_refunds" */
export type PaymentRefundsArrRelInsertInput = {
  data: Array<PaymentRefundsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentRefundsOnConflict>;
};

/** aggregate avg on columns */
export type PaymentRefundsAvgFields = {
  __typename?: 'PaymentRefundsAvgFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment_refunds" */
export type PaymentRefundsAvgOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "payment_refunds". All fields are combined with a logical 'AND'. */
export type PaymentRefundsBoolExp = {
  _and?: InputMaybe<Array<PaymentRefundsBoolExp>>;
  _not?: InputMaybe<PaymentRefundsBoolExp>;
  _or?: InputMaybe<Array<PaymentRefundsBoolExp>>;
  amountUsd?: InputMaybe<NumericComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalRefundId?: InputMaybe<StringComparisonExp>;
  issuedByUserGuid?: InputMaybe<UuidComparisonExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
  paymentRecord?: InputMaybe<PaymentRecordsBoolExp>;
  paymentRecordGuid?: InputMaybe<UuidComparisonExp>;
  paymentRefundGuid?: InputMaybe<UuidComparisonExp>;
  reasonDescription?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<PaymentRefundStatusTypesEnumComparisonExp>;
};

/** unique or primary key constraints on table "payment_refunds" */
export type PaymentRefundsConstraint =
  /** unique or primary key constraint on columns "external_refund_id" */
  | 'payment_refunds_external_refund_id_key'
  /** unique or primary key constraint on columns "payment_refund_guid" */
  | 'payment_refunds_pkey';

/** input type for incrementing numeric columns in table "payment_refunds" */
export type PaymentRefundsIncInput = {
  amountUsd?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "payment_refunds" */
export type PaymentRefundsInsertInput = {
  amountUsd?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalRefundId?: InputMaybe<Scalars['String']>;
  issuedByUserGuid?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentRecord?: InputMaybe<PaymentRecordsObjRelInsertInput>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentRefundGuid?: InputMaybe<Scalars['uuid']>;
  reasonDescription?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PaymentRefundStatusTypesEnum>;
};

/** aggregate max on columns */
export type PaymentRefundsMaxFields = {
  __typename?: 'PaymentRefundsMaxFields';
  amountUsd?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalRefundId?: Maybe<Scalars['String']>;
  issuedByUserGuid?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentRefundGuid?: Maybe<Scalars['uuid']>;
  reasonDescription?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "payment_refunds" */
export type PaymentRefundsMaxOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalRefundId?: InputMaybe<OrderBy>;
  issuedByUserGuid?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentRefundGuid?: InputMaybe<OrderBy>;
  reasonDescription?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PaymentRefundsMinFields = {
  __typename?: 'PaymentRefundsMinFields';
  amountUsd?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalRefundId?: Maybe<Scalars['String']>;
  issuedByUserGuid?: Maybe<Scalars['uuid']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentRefundGuid?: Maybe<Scalars['uuid']>;
  reasonDescription?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "payment_refunds" */
export type PaymentRefundsMinOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalRefundId?: InputMaybe<OrderBy>;
  issuedByUserGuid?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentRefundGuid?: InputMaybe<OrderBy>;
  reasonDescription?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "payment_refunds" */
export type PaymentRefundsMutationResponse = {
  __typename?: 'PaymentRefundsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentRefunds>;
};

/** input type for inserting object relation for remote table "payment_refunds" */
export type PaymentRefundsObjRelInsertInput = {
  data: PaymentRefundsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentRefundsOnConflict>;
};

/** on_conflict condition type for table "payment_refunds" */
export type PaymentRefundsOnConflict = {
  constraint: PaymentRefundsConstraint;
  updateColumns?: Array<PaymentRefundsUpdateColumn>;
  where?: InputMaybe<PaymentRefundsBoolExp>;
};

/** Ordering options when selecting data from "payment_refunds". */
export type PaymentRefundsOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalRefundId?: InputMaybe<OrderBy>;
  issuedByUserGuid?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentRecord?: InputMaybe<PaymentRecordsOrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentRefundGuid?: InputMaybe<OrderBy>;
  reasonDescription?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_refunds */
export type PaymentRefundsPkColumnsInput = {
  paymentRefundGuid: Scalars['uuid'];
};

/** select columns of table "payment_refunds" */
export type PaymentRefundsSelectColumn =
  /** column name */
  | 'amountUsd'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalRefundId'
  /** column name */
  | 'issuedByUserGuid'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentRefundGuid'
  /** column name */
  | 'reasonDescription'
  /** column name */
  | 'status';

/** input type for updating data in table "payment_refunds" */
export type PaymentRefundsSetInput = {
  amountUsd?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalRefundId?: InputMaybe<Scalars['String']>;
  issuedByUserGuid?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentRefundGuid?: InputMaybe<Scalars['uuid']>;
  reasonDescription?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PaymentRefundStatusTypesEnum>;
};

/** aggregate stddev on columns */
export type PaymentRefundsStddevFields = {
  __typename?: 'PaymentRefundsStddevFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment_refunds" */
export type PaymentRefundsStddevOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PaymentRefundsStddevPopFields = {
  __typename?: 'PaymentRefundsStddevPopFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "payment_refunds" */
export type PaymentRefundsStddevPopOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PaymentRefundsStddevSampFields = {
  __typename?: 'PaymentRefundsStddevSampFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "payment_refunds" */
export type PaymentRefundsStddevSampOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "payment_refunds" */
export type PaymentRefundsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentRefundsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentRefundsStreamCursorValueInput = {
  amountUsd?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalRefundId?: InputMaybe<Scalars['String']>;
  issuedByUserGuid?: InputMaybe<Scalars['uuid']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentRefundGuid?: InputMaybe<Scalars['uuid']>;
  reasonDescription?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PaymentRefundStatusTypesEnum>;
};

/** aggregate sum on columns */
export type PaymentRefundsSumFields = {
  __typename?: 'PaymentRefundsSumFields';
  amountUsd?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "payment_refunds" */
export type PaymentRefundsSumOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** update columns of table "payment_refunds" */
export type PaymentRefundsUpdateColumn =
  /** column name */
  | 'amountUsd'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalRefundId'
  /** column name */
  | 'issuedByUserGuid'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentRefundGuid'
  /** column name */
  | 'reasonDescription'
  /** column name */
  | 'status';

export type PaymentRefundsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PaymentRefundsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentRefundsSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentRefundsBoolExp;
};

/** aggregate varPop on columns */
export type PaymentRefundsVarPopFields = {
  __typename?: 'PaymentRefundsVarPopFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "payment_refunds" */
export type PaymentRefundsVarPopOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PaymentRefundsVarSampFields = {
  __typename?: 'PaymentRefundsVarSampFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "payment_refunds" */
export type PaymentRefundsVarSampOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PaymentRefundsVarianceFields = {
  __typename?: 'PaymentRefundsVarianceFields';
  amountUsd?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment_refunds" */
export type PaymentRefundsVarianceOrderBy = {
  amountUsd?: InputMaybe<OrderBy>;
};

/** columns and relationships of "payment_status_error_detail" */
export type PaymentStatusErrorDetail = {
  __typename?: 'PaymentStatusErrorDetail';
  errorCode: Scalars['String'];
  errorMessage: Scalars['String'];
  errorSolution: Scalars['String'];
  paymentStatusErrorDetailGuid: Scalars['uuid'];
  paymentStatusGuid: Scalars['uuid'];
};

/** aggregated selection of "payment_status_error_detail" */
export type PaymentStatusErrorDetailAggregate = {
  __typename?: 'PaymentStatusErrorDetailAggregate';
  aggregate?: Maybe<PaymentStatusErrorDetailAggregateFields>;
  nodes: Array<PaymentStatusErrorDetail>;
};

/** aggregate fields of "payment_status_error_detail" */
export type PaymentStatusErrorDetailAggregateFields = {
  __typename?: 'PaymentStatusErrorDetailAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentStatusErrorDetailMaxFields>;
  min?: Maybe<PaymentStatusErrorDetailMinFields>;
};


/** aggregate fields of "payment_status_error_detail" */
export type PaymentStatusErrorDetailAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentStatusErrorDetailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment_status_error_detail". All fields are combined with a logical 'AND'. */
export type PaymentStatusErrorDetailBoolExp = {
  _and?: InputMaybe<Array<PaymentStatusErrorDetailBoolExp>>;
  _not?: InputMaybe<PaymentStatusErrorDetailBoolExp>;
  _or?: InputMaybe<Array<PaymentStatusErrorDetailBoolExp>>;
  errorCode?: InputMaybe<StringComparisonExp>;
  errorMessage?: InputMaybe<StringComparisonExp>;
  errorSolution?: InputMaybe<StringComparisonExp>;
  paymentStatusErrorDetailGuid?: InputMaybe<UuidComparisonExp>;
  paymentStatusGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "payment_status_error_detail" */
export type PaymentStatusErrorDetailConstraint =
  /** unique or primary key constraint on columns "payment_status_error_detail_guid" */
  | 'payment_status_error_detail_pkey';

/** input type for inserting data into table "payment_status_error_detail" */
export type PaymentStatusErrorDetailInsertInput = {
  errorCode?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorSolution?: InputMaybe<Scalars['String']>;
  paymentStatusErrorDetailGuid?: InputMaybe<Scalars['uuid']>;
  paymentStatusGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PaymentStatusErrorDetailMaxFields = {
  __typename?: 'PaymentStatusErrorDetailMaxFields';
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorSolution?: Maybe<Scalars['String']>;
  paymentStatusErrorDetailGuid?: Maybe<Scalars['uuid']>;
  paymentStatusGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PaymentStatusErrorDetailMinFields = {
  __typename?: 'PaymentStatusErrorDetailMinFields';
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorSolution?: Maybe<Scalars['String']>;
  paymentStatusErrorDetailGuid?: Maybe<Scalars['uuid']>;
  paymentStatusGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "payment_status_error_detail" */
export type PaymentStatusErrorDetailMutationResponse = {
  __typename?: 'PaymentStatusErrorDetailMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentStatusErrorDetail>;
};

/** input type for inserting object relation for remote table "payment_status_error_detail" */
export type PaymentStatusErrorDetailObjRelInsertInput = {
  data: PaymentStatusErrorDetailInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentStatusErrorDetailOnConflict>;
};

/** on_conflict condition type for table "payment_status_error_detail" */
export type PaymentStatusErrorDetailOnConflict = {
  constraint: PaymentStatusErrorDetailConstraint;
  updateColumns?: Array<PaymentStatusErrorDetailUpdateColumn>;
  where?: InputMaybe<PaymentStatusErrorDetailBoolExp>;
};

/** Ordering options when selecting data from "payment_status_error_detail". */
export type PaymentStatusErrorDetailOrderBy = {
  errorCode?: InputMaybe<OrderBy>;
  errorMessage?: InputMaybe<OrderBy>;
  errorSolution?: InputMaybe<OrderBy>;
  paymentStatusErrorDetailGuid?: InputMaybe<OrderBy>;
  paymentStatusGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_status_error_detail */
export type PaymentStatusErrorDetailPkColumnsInput = {
  paymentStatusErrorDetailGuid: Scalars['uuid'];
};

/** select columns of table "payment_status_error_detail" */
export type PaymentStatusErrorDetailSelectColumn =
  /** column name */
  | 'errorCode'
  /** column name */
  | 'errorMessage'
  /** column name */
  | 'errorSolution'
  /** column name */
  | 'paymentStatusErrorDetailGuid'
  /** column name */
  | 'paymentStatusGuid';

/** input type for updating data in table "payment_status_error_detail" */
export type PaymentStatusErrorDetailSetInput = {
  errorCode?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorSolution?: InputMaybe<Scalars['String']>;
  paymentStatusErrorDetailGuid?: InputMaybe<Scalars['uuid']>;
  paymentStatusGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "payment_status_error_detail" */
export type PaymentStatusErrorDetailStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentStatusErrorDetailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentStatusErrorDetailStreamCursorValueInput = {
  errorCode?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  errorSolution?: InputMaybe<Scalars['String']>;
  paymentStatusErrorDetailGuid?: InputMaybe<Scalars['uuid']>;
  paymentStatusGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "payment_status_error_detail" */
export type PaymentStatusErrorDetailUpdateColumn =
  /** column name */
  | 'errorCode'
  /** column name */
  | 'errorMessage'
  /** column name */
  | 'errorSolution'
  /** column name */
  | 'paymentStatusErrorDetailGuid'
  /** column name */
  | 'paymentStatusGuid';

export type PaymentStatusErrorDetailUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentStatusErrorDetailSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentStatusErrorDetailBoolExp;
};

/** columns and relationships of "payment_status_latest" */
export type PaymentStatusLatest = {
  __typename?: 'PaymentStatusLatest';
  /** An object relationship */
  paymentRecord: PaymentRecords;
  paymentRecordGuid: Scalars['uuid'];
  /** An object relationship */
  paymentStatus: PaymentStatuses;
  paymentStatusGuid: Scalars['uuid'];
};

/** aggregated selection of "payment_status_latest" */
export type PaymentStatusLatestAggregate = {
  __typename?: 'PaymentStatusLatestAggregate';
  aggregate?: Maybe<PaymentStatusLatestAggregateFields>;
  nodes: Array<PaymentStatusLatest>;
};

/** aggregate fields of "payment_status_latest" */
export type PaymentStatusLatestAggregateFields = {
  __typename?: 'PaymentStatusLatestAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentStatusLatestMaxFields>;
  min?: Maybe<PaymentStatusLatestMinFields>;
};


/** aggregate fields of "payment_status_latest" */
export type PaymentStatusLatestAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentStatusLatestSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment_status_latest". All fields are combined with a logical 'AND'. */
export type PaymentStatusLatestBoolExp = {
  _and?: InputMaybe<Array<PaymentStatusLatestBoolExp>>;
  _not?: InputMaybe<PaymentStatusLatestBoolExp>;
  _or?: InputMaybe<Array<PaymentStatusLatestBoolExp>>;
  paymentRecord?: InputMaybe<PaymentRecordsBoolExp>;
  paymentRecordGuid?: InputMaybe<UuidComparisonExp>;
  paymentStatus?: InputMaybe<PaymentStatusesBoolExp>;
  paymentStatusGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "payment_status_latest" */
export type PaymentStatusLatestConstraint =
  /** unique or primary key constraint on columns "payment_record_guid" */
  | 'payment_status_latest_pkey';

/** input type for inserting data into table "payment_status_latest" */
export type PaymentStatusLatestInsertInput = {
  paymentRecord?: InputMaybe<PaymentRecordsObjRelInsertInput>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentStatus?: InputMaybe<PaymentStatusesObjRelInsertInput>;
  paymentStatusGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PaymentStatusLatestMaxFields = {
  __typename?: 'PaymentStatusLatestMaxFields';
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentStatusGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PaymentStatusLatestMinFields = {
  __typename?: 'PaymentStatusLatestMinFields';
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentStatusGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "payment_status_latest" */
export type PaymentStatusLatestMutationResponse = {
  __typename?: 'PaymentStatusLatestMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentStatusLatest>;
};

/** input type for inserting object relation for remote table "payment_status_latest" */
export type PaymentStatusLatestObjRelInsertInput = {
  data: PaymentStatusLatestInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentStatusLatestOnConflict>;
};

/** on_conflict condition type for table "payment_status_latest" */
export type PaymentStatusLatestOnConflict = {
  constraint: PaymentStatusLatestConstraint;
  updateColumns?: Array<PaymentStatusLatestUpdateColumn>;
  where?: InputMaybe<PaymentStatusLatestBoolExp>;
};

/** Ordering options when selecting data from "payment_status_latest". */
export type PaymentStatusLatestOrderBy = {
  paymentRecord?: InputMaybe<PaymentRecordsOrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentStatus?: InputMaybe<PaymentStatusesOrderBy>;
  paymentStatusGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_status_latest */
export type PaymentStatusLatestPkColumnsInput = {
  paymentRecordGuid: Scalars['uuid'];
};

/** select columns of table "payment_status_latest" */
export type PaymentStatusLatestSelectColumn =
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentStatusGuid';

/** input type for updating data in table "payment_status_latest" */
export type PaymentStatusLatestSetInput = {
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentStatusGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "payment_status_latest" */
export type PaymentStatusLatestStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentStatusLatestStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentStatusLatestStreamCursorValueInput = {
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentStatusGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "payment_status_latest" */
export type PaymentStatusLatestUpdateColumn =
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentStatusGuid';

export type PaymentStatusLatestUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentStatusLatestSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentStatusLatestBoolExp;
};

export { PaymentStatusTypesEnum };

/** Boolean expression to compare columns of type "PaymentStatusTypesEnum". All fields are combined with logical 'AND'. */
export type PaymentStatusTypesEnumComparisonExp = {
  _eq?: InputMaybe<PaymentStatusTypesEnum>;
  _in?: InputMaybe<Array<PaymentStatusTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PaymentStatusTypesEnum>;
  _nin?: InputMaybe<Array<PaymentStatusTypesEnum>>;
};

/** columns and relationships of "payment_statuses" */
export type PaymentStatuses = {
  __typename?: 'PaymentStatuses';
  createdAt: Scalars['timestamptz'];
  occurredAt: Scalars['timestamptz'];
  paymentRecordGuid: Scalars['uuid'];
  paymentStatus: PaymentStatusTypesEnum;
  paymentStatusDetail?: Maybe<Scalars['String']>;
  /** An object relationship */
  paymentStatusErrorDetails?: Maybe<PaymentStatusErrorDetail>;
  paymentStatusGuid: Scalars['uuid'];
};

/** aggregated selection of "payment_statuses" */
export type PaymentStatusesAggregate = {
  __typename?: 'PaymentStatusesAggregate';
  aggregate?: Maybe<PaymentStatusesAggregateFields>;
  nodes: Array<PaymentStatuses>;
};

export type PaymentStatusesAggregateBoolExp = {
  count?: InputMaybe<PaymentStatusesAggregateBoolExpCount>;
};

/** aggregate fields of "payment_statuses" */
export type PaymentStatusesAggregateFields = {
  __typename?: 'PaymentStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentStatusesMaxFields>;
  min?: Maybe<PaymentStatusesMinFields>;
};


/** aggregate fields of "payment_statuses" */
export type PaymentStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_statuses" */
export type PaymentStatusesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PaymentStatusesMaxOrderBy>;
  min?: InputMaybe<PaymentStatusesMinOrderBy>;
};

/** input type for inserting array relation for remote table "payment_statuses" */
export type PaymentStatusesArrRelInsertInput = {
  data: Array<PaymentStatusesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentStatusesOnConflict>;
};

/** Boolean expression to filter rows from the table "payment_statuses". All fields are combined with a logical 'AND'. */
export type PaymentStatusesBoolExp = {
  _and?: InputMaybe<Array<PaymentStatusesBoolExp>>;
  _not?: InputMaybe<PaymentStatusesBoolExp>;
  _or?: InputMaybe<Array<PaymentStatusesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
  paymentRecordGuid?: InputMaybe<UuidComparisonExp>;
  paymentStatus?: InputMaybe<PaymentStatusTypesEnumComparisonExp>;
  paymentStatusDetail?: InputMaybe<StringComparisonExp>;
  paymentStatusErrorDetails?: InputMaybe<PaymentStatusErrorDetailBoolExp>;
  paymentStatusGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "payment_statuses" */
export type PaymentStatusesConstraint =
  /** unique or primary key constraint on columns "payment_status_guid" */
  | 'payment_statuses_pkey';

/** input type for inserting data into table "payment_statuses" */
export type PaymentStatusesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentStatus?: InputMaybe<PaymentStatusTypesEnum>;
  paymentStatusDetail?: InputMaybe<Scalars['String']>;
  paymentStatusErrorDetails?: InputMaybe<PaymentStatusErrorDetailObjRelInsertInput>;
  paymentStatusGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PaymentStatusesMaxFields = {
  __typename?: 'PaymentStatusesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentStatusDetail?: Maybe<Scalars['String']>;
  paymentStatusGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment_statuses" */
export type PaymentStatusesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentStatusDetail?: InputMaybe<OrderBy>;
  paymentStatusGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PaymentStatusesMinFields = {
  __typename?: 'PaymentStatusesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentStatusDetail?: Maybe<Scalars['String']>;
  paymentStatusGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment_statuses" */
export type PaymentStatusesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentStatusDetail?: InputMaybe<OrderBy>;
  paymentStatusGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "payment_statuses" */
export type PaymentStatusesMutationResponse = {
  __typename?: 'PaymentStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentStatuses>;
};

/** input type for inserting object relation for remote table "payment_statuses" */
export type PaymentStatusesObjRelInsertInput = {
  data: PaymentStatusesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentStatusesOnConflict>;
};

/** on_conflict condition type for table "payment_statuses" */
export type PaymentStatusesOnConflict = {
  constraint: PaymentStatusesConstraint;
  updateColumns?: Array<PaymentStatusesUpdateColumn>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};

/** Ordering options when selecting data from "payment_statuses". */
export type PaymentStatusesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentStatus?: InputMaybe<OrderBy>;
  paymentStatusDetail?: InputMaybe<OrderBy>;
  paymentStatusErrorDetails?: InputMaybe<PaymentStatusErrorDetailOrderBy>;
  paymentStatusGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_statuses */
export type PaymentStatusesPkColumnsInput = {
  paymentStatusGuid: Scalars['uuid'];
};

/** select columns of table "payment_statuses" */
export type PaymentStatusesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentStatus'
  /** column name */
  | 'paymentStatusDetail'
  /** column name */
  | 'paymentStatusGuid';

/** input type for updating data in table "payment_statuses" */
export type PaymentStatusesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentStatus?: InputMaybe<PaymentStatusTypesEnum>;
  paymentStatusDetail?: InputMaybe<Scalars['String']>;
  paymentStatusGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "payment_statuses" */
export type PaymentStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentStatusesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentStatus?: InputMaybe<PaymentStatusTypesEnum>;
  paymentStatusDetail?: InputMaybe<Scalars['String']>;
  paymentStatusGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "payment_statuses" */
export type PaymentStatusesUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentStatus'
  /** column name */
  | 'paymentStatusDetail'
  /** column name */
  | 'paymentStatusGuid';

export type PaymentStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentStatusesBoolExp;
};

/** columns and relationships of "payment_subscription_invoices" */
export type PaymentSubscriptionInvoices = {
  __typename?: 'PaymentSubscriptionInvoices';
  createdAt: Scalars['timestamptz'];
  invoiceGuid: Scalars['uuid'];
  paymentSubscriptionGuid: Scalars['uuid'];
  paymentSubscriptionInvoiceGuid: Scalars['uuid'];
  periodEndAt: Scalars['date'];
  periodStartAt: Scalars['date'];
};

/** aggregated selection of "payment_subscription_invoices" */
export type PaymentSubscriptionInvoicesAggregate = {
  __typename?: 'PaymentSubscriptionInvoicesAggregate';
  aggregate?: Maybe<PaymentSubscriptionInvoicesAggregateFields>;
  nodes: Array<PaymentSubscriptionInvoices>;
};

/** aggregate fields of "payment_subscription_invoices" */
export type PaymentSubscriptionInvoicesAggregateFields = {
  __typename?: 'PaymentSubscriptionInvoicesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentSubscriptionInvoicesMaxFields>;
  min?: Maybe<PaymentSubscriptionInvoicesMinFields>;
};


/** aggregate fields of "payment_subscription_invoices" */
export type PaymentSubscriptionInvoicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentSubscriptionInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment_subscription_invoices". All fields are combined with a logical 'AND'. */
export type PaymentSubscriptionInvoicesBoolExp = {
  _and?: InputMaybe<Array<PaymentSubscriptionInvoicesBoolExp>>;
  _not?: InputMaybe<PaymentSubscriptionInvoicesBoolExp>;
  _or?: InputMaybe<Array<PaymentSubscriptionInvoicesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  paymentSubscriptionGuid?: InputMaybe<UuidComparisonExp>;
  paymentSubscriptionInvoiceGuid?: InputMaybe<UuidComparisonExp>;
  periodEndAt?: InputMaybe<DateComparisonExp>;
  periodStartAt?: InputMaybe<DateComparisonExp>;
};

/** unique or primary key constraints on table "payment_subscription_invoices" */
export type PaymentSubscriptionInvoicesConstraint =
  /** unique or primary key constraint on columns "payment_subscription_invoice_guid" */
  | 'payment_subscription_invoices_pkey';

/** input type for inserting data into table "payment_subscription_invoices" */
export type PaymentSubscriptionInvoicesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscriptionInvoiceGuid?: InputMaybe<Scalars['uuid']>;
  periodEndAt?: InputMaybe<Scalars['date']>;
  periodStartAt?: InputMaybe<Scalars['date']>;
};

/** aggregate max on columns */
export type PaymentSubscriptionInvoicesMaxFields = {
  __typename?: 'PaymentSubscriptionInvoicesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  paymentSubscriptionGuid?: Maybe<Scalars['uuid']>;
  paymentSubscriptionInvoiceGuid?: Maybe<Scalars['uuid']>;
  periodEndAt?: Maybe<Scalars['date']>;
  periodStartAt?: Maybe<Scalars['date']>;
};

/** aggregate min on columns */
export type PaymentSubscriptionInvoicesMinFields = {
  __typename?: 'PaymentSubscriptionInvoicesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  paymentSubscriptionGuid?: Maybe<Scalars['uuid']>;
  paymentSubscriptionInvoiceGuid?: Maybe<Scalars['uuid']>;
  periodEndAt?: Maybe<Scalars['date']>;
  periodStartAt?: Maybe<Scalars['date']>;
};

/** response of any mutation on the table "payment_subscription_invoices" */
export type PaymentSubscriptionInvoicesMutationResponse = {
  __typename?: 'PaymentSubscriptionInvoicesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentSubscriptionInvoices>;
};

/** on_conflict condition type for table "payment_subscription_invoices" */
export type PaymentSubscriptionInvoicesOnConflict = {
  constraint: PaymentSubscriptionInvoicesConstraint;
  updateColumns?: Array<PaymentSubscriptionInvoicesUpdateColumn>;
  where?: InputMaybe<PaymentSubscriptionInvoicesBoolExp>;
};

/** Ordering options when selecting data from "payment_subscription_invoices". */
export type PaymentSubscriptionInvoicesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  paymentSubscriptionInvoiceGuid?: InputMaybe<OrderBy>;
  periodEndAt?: InputMaybe<OrderBy>;
  periodStartAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_subscription_invoices */
export type PaymentSubscriptionInvoicesPkColumnsInput = {
  paymentSubscriptionInvoiceGuid: Scalars['uuid'];
};

/** select columns of table "payment_subscription_invoices" */
export type PaymentSubscriptionInvoicesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'paymentSubscriptionGuid'
  /** column name */
  | 'paymentSubscriptionInvoiceGuid'
  /** column name */
  | 'periodEndAt'
  /** column name */
  | 'periodStartAt';

/** input type for updating data in table "payment_subscription_invoices" */
export type PaymentSubscriptionInvoicesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscriptionInvoiceGuid?: InputMaybe<Scalars['uuid']>;
  periodEndAt?: InputMaybe<Scalars['date']>;
  periodStartAt?: InputMaybe<Scalars['date']>;
};

/** Streaming cursor of the table "payment_subscription_invoices" */
export type PaymentSubscriptionInvoicesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentSubscriptionInvoicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentSubscriptionInvoicesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscriptionInvoiceGuid?: InputMaybe<Scalars['uuid']>;
  periodEndAt?: InputMaybe<Scalars['date']>;
  periodStartAt?: InputMaybe<Scalars['date']>;
};

/** update columns of table "payment_subscription_invoices" */
export type PaymentSubscriptionInvoicesUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'paymentSubscriptionGuid'
  /** column name */
  | 'paymentSubscriptionInvoiceGuid'
  /** column name */
  | 'periodEndAt'
  /** column name */
  | 'periodStartAt';

export type PaymentSubscriptionInvoicesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentSubscriptionInvoicesSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentSubscriptionInvoicesBoolExp;
};

export type PaymentSubscriptionStatusTypesEnum =
  | 'ACTIVE'
  | 'CANCELED'
  | 'PAST_DUE'
  | 'PENDING';

/** Boolean expression to compare columns of type "PaymentSubscriptionStatusTypesEnum". All fields are combined with logical 'AND'. */
export type PaymentSubscriptionStatusTypesEnumComparisonExp = {
  _eq?: InputMaybe<PaymentSubscriptionStatusTypesEnum>;
  _in?: InputMaybe<Array<PaymentSubscriptionStatusTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PaymentSubscriptionStatusTypesEnum>;
  _nin?: InputMaybe<Array<PaymentSubscriptionStatusTypesEnum>>;
};

/** columns and relationships of "payment_subscription_statuses" */
export type PaymentSubscriptionStatuses = {
  __typename?: 'PaymentSubscriptionStatuses';
  createdAt: Scalars['timestamptz'];
  occurredAt: Scalars['timestamptz'];
  paymentSubscriptionGuid: Scalars['uuid'];
  paymentSubscriptionStatusGuid: Scalars['uuid'];
  subscriptionStatus: PaymentSubscriptionStatusTypesEnum;
  subscriptionStatusDetail?: Maybe<Scalars['String']>;
};

/** aggregated selection of "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesAggregate = {
  __typename?: 'PaymentSubscriptionStatusesAggregate';
  aggregate?: Maybe<PaymentSubscriptionStatusesAggregateFields>;
  nodes: Array<PaymentSubscriptionStatuses>;
};

export type PaymentSubscriptionStatusesAggregateBoolExp = {
  count?: InputMaybe<PaymentSubscriptionStatusesAggregateBoolExpCount>;
};

/** aggregate fields of "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesAggregateFields = {
  __typename?: 'PaymentSubscriptionStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentSubscriptionStatusesMaxFields>;
  min?: Maybe<PaymentSubscriptionStatusesMinFields>;
};


/** aggregate fields of "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentSubscriptionStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PaymentSubscriptionStatusesMaxOrderBy>;
  min?: InputMaybe<PaymentSubscriptionStatusesMinOrderBy>;
};

/** input type for inserting array relation for remote table "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesArrRelInsertInput = {
  data: Array<PaymentSubscriptionStatusesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentSubscriptionStatusesOnConflict>;
};

/** Boolean expression to filter rows from the table "payment_subscription_statuses". All fields are combined with a logical 'AND'. */
export type PaymentSubscriptionStatusesBoolExp = {
  _and?: InputMaybe<Array<PaymentSubscriptionStatusesBoolExp>>;
  _not?: InputMaybe<PaymentSubscriptionStatusesBoolExp>;
  _or?: InputMaybe<Array<PaymentSubscriptionStatusesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
  paymentSubscriptionGuid?: InputMaybe<UuidComparisonExp>;
  paymentSubscriptionStatusGuid?: InputMaybe<UuidComparisonExp>;
  subscriptionStatus?: InputMaybe<PaymentSubscriptionStatusTypesEnumComparisonExp>;
  subscriptionStatusDetail?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesConstraint =
  /** unique or primary key constraint on columns "payment_subscription_status_guid" */
  | 'payment_subscription_statuses_pkey';

/** input type for inserting data into table "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscriptionStatusGuid?: InputMaybe<Scalars['uuid']>;
  subscriptionStatus?: InputMaybe<PaymentSubscriptionStatusTypesEnum>;
  subscriptionStatusDetail?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type PaymentSubscriptionStatusesMaxFields = {
  __typename?: 'PaymentSubscriptionStatusesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  paymentSubscriptionGuid?: Maybe<Scalars['uuid']>;
  paymentSubscriptionStatusGuid?: Maybe<Scalars['uuid']>;
  subscriptionStatusDetail?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  paymentSubscriptionStatusGuid?: InputMaybe<OrderBy>;
  subscriptionStatusDetail?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PaymentSubscriptionStatusesMinFields = {
  __typename?: 'PaymentSubscriptionStatusesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  paymentSubscriptionGuid?: Maybe<Scalars['uuid']>;
  paymentSubscriptionStatusGuid?: Maybe<Scalars['uuid']>;
  subscriptionStatusDetail?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  paymentSubscriptionStatusGuid?: InputMaybe<OrderBy>;
  subscriptionStatusDetail?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesMutationResponse = {
  __typename?: 'PaymentSubscriptionStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentSubscriptionStatuses>;
};

/** on_conflict condition type for table "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesOnConflict = {
  constraint: PaymentSubscriptionStatusesConstraint;
  updateColumns?: Array<PaymentSubscriptionStatusesUpdateColumn>;
  where?: InputMaybe<PaymentSubscriptionStatusesBoolExp>;
};

/** Ordering options when selecting data from "payment_subscription_statuses". */
export type PaymentSubscriptionStatusesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  paymentSubscriptionStatusGuid?: InputMaybe<OrderBy>;
  subscriptionStatus?: InputMaybe<OrderBy>;
  subscriptionStatusDetail?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_subscription_statuses */
export type PaymentSubscriptionStatusesPkColumnsInput = {
  paymentSubscriptionStatusGuid: Scalars['uuid'];
};

/** select columns of table "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'paymentSubscriptionGuid'
  /** column name */
  | 'paymentSubscriptionStatusGuid'
  /** column name */
  | 'subscriptionStatus'
  /** column name */
  | 'subscriptionStatusDetail';

/** input type for updating data in table "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscriptionStatusGuid?: InputMaybe<Scalars['uuid']>;
  subscriptionStatus?: InputMaybe<PaymentSubscriptionStatusTypesEnum>;
  subscriptionStatusDetail?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentSubscriptionStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentSubscriptionStatusesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscriptionStatusGuid?: InputMaybe<Scalars['uuid']>;
  subscriptionStatus?: InputMaybe<PaymentSubscriptionStatusTypesEnum>;
  subscriptionStatusDetail?: InputMaybe<Scalars['String']>;
};

/** update columns of table "payment_subscription_statuses" */
export type PaymentSubscriptionStatusesUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'paymentSubscriptionGuid'
  /** column name */
  | 'paymentSubscriptionStatusGuid'
  /** column name */
  | 'subscriptionStatus'
  /** column name */
  | 'subscriptionStatusDetail';

export type PaymentSubscriptionStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentSubscriptionStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentSubscriptionStatusesBoolExp;
};

/** columns and relationships of "payment_subscriptions" */
export type PaymentSubscriptions = {
  __typename?: 'PaymentSubscriptions';
  accountGuid: Scalars['uuid'];
  billingAnchor: Scalars['date'];
  billingInterval: BillingIntervalTypesEnum;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  company?: Maybe<Companies>;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  externalCustomerId: Scalars['String'];
  externalPaymentMethodId: Scalars['String'];
  externalSubscriptionId: Scalars['String'];
  paymentMethod: PaymentMethodsEnum;
  paymentMethodAdditionalInfo?: Maybe<Scalars['String']>;
  paymentSubscriptionGuid: Scalars['uuid'];
  /** An array relationship */
  paymentSubscriptionStatuses: Array<PaymentSubscriptionStatuses>;
  /** An aggregate relationship */
  paymentSubscriptionStatusesAggregate: PaymentSubscriptionStatusesAggregate;
  priceUsd: Scalars['numeric'];
  pricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  startedAt: Scalars['timestamptz'];
  terminatesAt?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "payment_subscriptions" */
export type PaymentSubscriptionsPaymentSubscriptionStatusesArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionStatusesOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionStatusesBoolExp>;
};


/** columns and relationships of "payment_subscriptions" */
export type PaymentSubscriptionsPaymentSubscriptionStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionStatusesOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionStatusesBoolExp>;
};

/** aggregated selection of "payment_subscriptions" */
export type PaymentSubscriptionsAggregate = {
  __typename?: 'PaymentSubscriptionsAggregate';
  aggregate?: Maybe<PaymentSubscriptionsAggregateFields>;
  nodes: Array<PaymentSubscriptions>;
};

export type PaymentSubscriptionsAggregateBoolExp = {
  count?: InputMaybe<PaymentSubscriptionsAggregateBoolExpCount>;
};

/** aggregate fields of "payment_subscriptions" */
export type PaymentSubscriptionsAggregateFields = {
  __typename?: 'PaymentSubscriptionsAggregateFields';
  avg?: Maybe<PaymentSubscriptionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PaymentSubscriptionsMaxFields>;
  min?: Maybe<PaymentSubscriptionsMinFields>;
  stddev?: Maybe<PaymentSubscriptionsStddevFields>;
  stddevPop?: Maybe<PaymentSubscriptionsStddevPopFields>;
  stddevSamp?: Maybe<PaymentSubscriptionsStddevSampFields>;
  sum?: Maybe<PaymentSubscriptionsSumFields>;
  varPop?: Maybe<PaymentSubscriptionsVarPopFields>;
  varSamp?: Maybe<PaymentSubscriptionsVarSampFields>;
  variance?: Maybe<PaymentSubscriptionsVarianceFields>;
};


/** aggregate fields of "payment_subscriptions" */
export type PaymentSubscriptionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentSubscriptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_subscriptions" */
export type PaymentSubscriptionsAggregateOrderBy = {
  avg?: InputMaybe<PaymentSubscriptionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PaymentSubscriptionsMaxOrderBy>;
  min?: InputMaybe<PaymentSubscriptionsMinOrderBy>;
  stddev?: InputMaybe<PaymentSubscriptionsStddevOrderBy>;
  stddevPop?: InputMaybe<PaymentSubscriptionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PaymentSubscriptionsStddevSampOrderBy>;
  sum?: InputMaybe<PaymentSubscriptionsSumOrderBy>;
  varPop?: InputMaybe<PaymentSubscriptionsVarPopOrderBy>;
  varSamp?: InputMaybe<PaymentSubscriptionsVarSampOrderBy>;
  variance?: InputMaybe<PaymentSubscriptionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "payment_subscriptions" */
export type PaymentSubscriptionsArrRelInsertInput = {
  data: Array<PaymentSubscriptionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentSubscriptionsOnConflict>;
};

/** aggregate avg on columns */
export type PaymentSubscriptionsAvgFields = {
  __typename?: 'PaymentSubscriptionsAvgFields';
  priceUsd?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment_subscriptions" */
export type PaymentSubscriptionsAvgOrderBy = {
  priceUsd?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "payment_subscriptions". All fields are combined with a logical 'AND'. */
export type PaymentSubscriptionsBoolExp = {
  _and?: InputMaybe<Array<PaymentSubscriptionsBoolExp>>;
  _not?: InputMaybe<PaymentSubscriptionsBoolExp>;
  _or?: InputMaybe<Array<PaymentSubscriptionsBoolExp>>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  billingAnchor?: InputMaybe<DateComparisonExp>;
  billingInterval?: InputMaybe<BillingIntervalTypesEnumComparisonExp>;
  canceledAt?: InputMaybe<TimestamptzComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalCustomerId?: InputMaybe<StringComparisonExp>;
  externalPaymentMethodId?: InputMaybe<StringComparisonExp>;
  externalSubscriptionId?: InputMaybe<StringComparisonExp>;
  paymentMethod?: InputMaybe<PaymentMethodsEnumComparisonExp>;
  paymentMethodAdditionalInfo?: InputMaybe<StringComparisonExp>;
  paymentSubscriptionGuid?: InputMaybe<UuidComparisonExp>;
  paymentSubscriptionStatuses?: InputMaybe<PaymentSubscriptionStatusesBoolExp>;
  paymentSubscriptionStatusesAggregate?: InputMaybe<PaymentSubscriptionStatusesAggregateBoolExp>;
  priceUsd?: InputMaybe<NumericComparisonExp>;
  pricebookTaxRateGuid?: InputMaybe<UuidComparisonExp>;
  startedAt?: InputMaybe<TimestamptzComparisonExp>;
  terminatesAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "payment_subscriptions" */
export type PaymentSubscriptionsConstraint =
  /** unique or primary key constraint on columns "payment_subscription_guid" */
  | 'payment_subscriptions_pkey';

/** input type for incrementing numeric columns in table "payment_subscriptions" */
export type PaymentSubscriptionsIncInput = {
  priceUsd?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "payment_subscriptions" */
export type PaymentSubscriptionsInsertInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  billingAnchor?: InputMaybe<Scalars['date']>;
  billingInterval?: InputMaybe<BillingIntervalTypesEnum>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalCustomerId?: InputMaybe<Scalars['String']>;
  externalPaymentMethodId?: InputMaybe<Scalars['String']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethodsEnum>;
  paymentMethodAdditionalInfo?: InputMaybe<Scalars['String']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  paymentSubscriptionStatuses?: InputMaybe<PaymentSubscriptionStatusesArrRelInsertInput>;
  priceUsd?: InputMaybe<Scalars['numeric']>;
  pricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  terminatesAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PaymentSubscriptionsMaxFields = {
  __typename?: 'PaymentSubscriptionsMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  billingAnchor?: Maybe<Scalars['date']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalCustomerId?: Maybe<Scalars['String']>;
  externalPaymentMethodId?: Maybe<Scalars['String']>;
  externalSubscriptionId?: Maybe<Scalars['String']>;
  paymentMethodAdditionalInfo?: Maybe<Scalars['String']>;
  paymentSubscriptionGuid?: Maybe<Scalars['uuid']>;
  priceUsd?: Maybe<Scalars['numeric']>;
  pricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  startedAt?: Maybe<Scalars['timestamptz']>;
  terminatesAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "payment_subscriptions" */
export type PaymentSubscriptionsMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  billingAnchor?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalCustomerId?: InputMaybe<OrderBy>;
  externalPaymentMethodId?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  paymentMethodAdditionalInfo?: InputMaybe<OrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  pricebookTaxRateGuid?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  terminatesAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PaymentSubscriptionsMinFields = {
  __typename?: 'PaymentSubscriptionsMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  billingAnchor?: Maybe<Scalars['date']>;
  canceledAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalCustomerId?: Maybe<Scalars['String']>;
  externalPaymentMethodId?: Maybe<Scalars['String']>;
  externalSubscriptionId?: Maybe<Scalars['String']>;
  paymentMethodAdditionalInfo?: Maybe<Scalars['String']>;
  paymentSubscriptionGuid?: Maybe<Scalars['uuid']>;
  priceUsd?: Maybe<Scalars['numeric']>;
  pricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  startedAt?: Maybe<Scalars['timestamptz']>;
  terminatesAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "payment_subscriptions" */
export type PaymentSubscriptionsMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  billingAnchor?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalCustomerId?: InputMaybe<OrderBy>;
  externalPaymentMethodId?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  paymentMethodAdditionalInfo?: InputMaybe<OrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  pricebookTaxRateGuid?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  terminatesAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "payment_subscriptions" */
export type PaymentSubscriptionsMutationResponse = {
  __typename?: 'PaymentSubscriptionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentSubscriptions>;
};

/** input type for inserting object relation for remote table "payment_subscriptions" */
export type PaymentSubscriptionsObjRelInsertInput = {
  data: PaymentSubscriptionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PaymentSubscriptionsOnConflict>;
};

/** on_conflict condition type for table "payment_subscriptions" */
export type PaymentSubscriptionsOnConflict = {
  constraint: PaymentSubscriptionsConstraint;
  updateColumns?: Array<PaymentSubscriptionsUpdateColumn>;
  where?: InputMaybe<PaymentSubscriptionsBoolExp>;
};

/** Ordering options when selecting data from "payment_subscriptions". */
export type PaymentSubscriptionsOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  billingAnchor?: InputMaybe<OrderBy>;
  billingInterval?: InputMaybe<OrderBy>;
  canceledAt?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalCustomerId?: InputMaybe<OrderBy>;
  externalPaymentMethodId?: InputMaybe<OrderBy>;
  externalSubscriptionId?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<OrderBy>;
  paymentMethodAdditionalInfo?: InputMaybe<OrderBy>;
  paymentSubscriptionGuid?: InputMaybe<OrderBy>;
  paymentSubscriptionStatusesAggregate?: InputMaybe<PaymentSubscriptionStatusesAggregateOrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  pricebookTaxRateGuid?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  terminatesAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_subscriptions */
export type PaymentSubscriptionsPkColumnsInput = {
  paymentSubscriptionGuid: Scalars['uuid'];
};

/** select columns of table "payment_subscriptions" */
export type PaymentSubscriptionsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'billingAnchor'
  /** column name */
  | 'billingInterval'
  /** column name */
  | 'canceledAt'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalCustomerId'
  /** column name */
  | 'externalPaymentMethodId'
  /** column name */
  | 'externalSubscriptionId'
  /** column name */
  | 'paymentMethod'
  /** column name */
  | 'paymentMethodAdditionalInfo'
  /** column name */
  | 'paymentSubscriptionGuid'
  /** column name */
  | 'priceUsd'
  /** column name */
  | 'pricebookTaxRateGuid'
  /** column name */
  | 'startedAt'
  /** column name */
  | 'terminatesAt'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "payment_subscriptions" */
export type PaymentSubscriptionsSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  billingAnchor?: InputMaybe<Scalars['date']>;
  billingInterval?: InputMaybe<BillingIntervalTypesEnum>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalCustomerId?: InputMaybe<Scalars['String']>;
  externalPaymentMethodId?: InputMaybe<Scalars['String']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethodsEnum>;
  paymentMethodAdditionalInfo?: InputMaybe<Scalars['String']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  priceUsd?: InputMaybe<Scalars['numeric']>;
  pricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  terminatesAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PaymentSubscriptionsStddevFields = {
  __typename?: 'PaymentSubscriptionsStddevFields';
  priceUsd?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment_subscriptions" */
export type PaymentSubscriptionsStddevOrderBy = {
  priceUsd?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PaymentSubscriptionsStddevPopFields = {
  __typename?: 'PaymentSubscriptionsStddevPopFields';
  priceUsd?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "payment_subscriptions" */
export type PaymentSubscriptionsStddevPopOrderBy = {
  priceUsd?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PaymentSubscriptionsStddevSampFields = {
  __typename?: 'PaymentSubscriptionsStddevSampFields';
  priceUsd?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "payment_subscriptions" */
export type PaymentSubscriptionsStddevSampOrderBy = {
  priceUsd?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "payment_subscriptions" */
export type PaymentSubscriptionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentSubscriptionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentSubscriptionsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  billingAnchor?: InputMaybe<Scalars['date']>;
  billingInterval?: InputMaybe<BillingIntervalTypesEnum>;
  canceledAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalCustomerId?: InputMaybe<Scalars['String']>;
  externalPaymentMethodId?: InputMaybe<Scalars['String']>;
  externalSubscriptionId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethodsEnum>;
  paymentMethodAdditionalInfo?: InputMaybe<Scalars['String']>;
  paymentSubscriptionGuid?: InputMaybe<Scalars['uuid']>;
  priceUsd?: InputMaybe<Scalars['numeric']>;
  pricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  startedAt?: InputMaybe<Scalars['timestamptz']>;
  terminatesAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PaymentSubscriptionsSumFields = {
  __typename?: 'PaymentSubscriptionsSumFields';
  priceUsd?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "payment_subscriptions" */
export type PaymentSubscriptionsSumOrderBy = {
  priceUsd?: InputMaybe<OrderBy>;
};

/** update columns of table "payment_subscriptions" */
export type PaymentSubscriptionsUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'billingAnchor'
  /** column name */
  | 'billingInterval'
  /** column name */
  | 'canceledAt'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalCustomerId'
  /** column name */
  | 'externalPaymentMethodId'
  /** column name */
  | 'externalSubscriptionId'
  /** column name */
  | 'paymentMethod'
  /** column name */
  | 'paymentMethodAdditionalInfo'
  /** column name */
  | 'paymentSubscriptionGuid'
  /** column name */
  | 'priceUsd'
  /** column name */
  | 'pricebookTaxRateGuid'
  /** column name */
  | 'startedAt'
  /** column name */
  | 'terminatesAt'
  /** column name */
  | 'updatedAt';

export type PaymentSubscriptionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PaymentSubscriptionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentSubscriptionsSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentSubscriptionsBoolExp;
};

/** aggregate varPop on columns */
export type PaymentSubscriptionsVarPopFields = {
  __typename?: 'PaymentSubscriptionsVarPopFields';
  priceUsd?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "payment_subscriptions" */
export type PaymentSubscriptionsVarPopOrderBy = {
  priceUsd?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PaymentSubscriptionsVarSampFields = {
  __typename?: 'PaymentSubscriptionsVarSampFields';
  priceUsd?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "payment_subscriptions" */
export type PaymentSubscriptionsVarSampOrderBy = {
  priceUsd?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PaymentSubscriptionsVarianceFields = {
  __typename?: 'PaymentSubscriptionsVarianceFields';
  priceUsd?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment_subscriptions" */
export type PaymentSubscriptionsVarianceOrderBy = {
  priceUsd?: InputMaybe<OrderBy>;
};

/** columns and relationships of "payments_accounting_stale_info" */
export type PaymentsAccountingStaleInfo = {
  __typename?: 'PaymentsAccountingStaleInfo';
  accountingIntegrationType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  externalEntityId?: Maybe<Scalars['String']>;
  isStale?: Maybe<Scalars['Boolean']>;
  paymentCreatedAt?: Maybe<Scalars['timestamptz']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentUpdatedAt?: Maybe<Scalars['timestamptz']>;
  syncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "payments_accounting_stale_info" */
export type PaymentsAccountingStaleInfoAggregate = {
  __typename?: 'PaymentsAccountingStaleInfoAggregate';
  aggregate?: Maybe<PaymentsAccountingStaleInfoAggregateFields>;
  nodes: Array<PaymentsAccountingStaleInfo>;
};

/** aggregate fields of "payments_accounting_stale_info" */
export type PaymentsAccountingStaleInfoAggregateFields = {
  __typename?: 'PaymentsAccountingStaleInfoAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentsAccountingStaleInfoMaxFields>;
  min?: Maybe<PaymentsAccountingStaleInfoMinFields>;
};


/** aggregate fields of "payments_accounting_stale_info" */
export type PaymentsAccountingStaleInfoAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentsAccountingStaleInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payments_accounting_stale_info". All fields are combined with a logical 'AND'. */
export type PaymentsAccountingStaleInfoBoolExp = {
  _and?: InputMaybe<Array<PaymentsAccountingStaleInfoBoolExp>>;
  _not?: InputMaybe<PaymentsAccountingStaleInfoBoolExp>;
  _or?: InputMaybe<Array<PaymentsAccountingStaleInfoBoolExp>>;
  accountingIntegrationType?: InputMaybe<StringComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  externalEntityId?: InputMaybe<StringComparisonExp>;
  isStale?: InputMaybe<BooleanComparisonExp>;
  paymentCreatedAt?: InputMaybe<TimestamptzComparisonExp>;
  paymentRecordGuid?: InputMaybe<UuidComparisonExp>;
  paymentUpdatedAt?: InputMaybe<TimestamptzComparisonExp>;
  syncedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "payments_accounting_stale_info" */
export type PaymentsAccountingStaleInfoInsertInput = {
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  externalEntityId?: InputMaybe<Scalars['String']>;
  isStale?: InputMaybe<Scalars['Boolean']>;
  paymentCreatedAt?: InputMaybe<Scalars['timestamptz']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PaymentsAccountingStaleInfoMaxFields = {
  __typename?: 'PaymentsAccountingStaleInfoMaxFields';
  accountingIntegrationType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  externalEntityId?: Maybe<Scalars['String']>;
  paymentCreatedAt?: Maybe<Scalars['timestamptz']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentUpdatedAt?: Maybe<Scalars['timestamptz']>;
  syncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PaymentsAccountingStaleInfoMinFields = {
  __typename?: 'PaymentsAccountingStaleInfoMinFields';
  accountingIntegrationType?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  externalEntityId?: Maybe<Scalars['String']>;
  paymentCreatedAt?: Maybe<Scalars['timestamptz']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentUpdatedAt?: Maybe<Scalars['timestamptz']>;
  syncedAt?: Maybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "payments_accounting_stale_info" */
export type PaymentsAccountingStaleInfoObjRelInsertInput = {
  data: PaymentsAccountingStaleInfoInsertInput;
};

/** Ordering options when selecting data from "payments_accounting_stale_info". */
export type PaymentsAccountingStaleInfoOrderBy = {
  accountingIntegrationType?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  externalEntityId?: InputMaybe<OrderBy>;
  isStale?: InputMaybe<OrderBy>;
  paymentCreatedAt?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentUpdatedAt?: InputMaybe<OrderBy>;
  syncedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "payments_accounting_stale_info" */
export type PaymentsAccountingStaleInfoSelectColumn =
  /** column name */
  | 'accountingIntegrationType'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'externalEntityId'
  /** column name */
  | 'isStale'
  /** column name */
  | 'paymentCreatedAt'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentUpdatedAt'
  /** column name */
  | 'syncedAt';

/** Streaming cursor of the table "payments_accounting_stale_info" */
export type PaymentsAccountingStaleInfoStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentsAccountingStaleInfoStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentsAccountingStaleInfoStreamCursorValueInput = {
  accountingIntegrationType?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  externalEntityId?: InputMaybe<Scalars['String']>;
  isStale?: InputMaybe<Scalars['Boolean']>;
  paymentCreatedAt?: InputMaybe<Scalars['timestamptz']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "payments_qbo_status" */
export type PaymentsQboStatus = {
  __typename?: 'PaymentsQboStatus';
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "payments_qbo_status" */
export type PaymentsQboStatusAggregate = {
  __typename?: 'PaymentsQboStatusAggregate';
  aggregate?: Maybe<PaymentsQboStatusAggregateFields>;
  nodes: Array<PaymentsQboStatus>;
};

/** aggregate fields of "payments_qbo_status" */
export type PaymentsQboStatusAggregateFields = {
  __typename?: 'PaymentsQboStatusAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PaymentsQboStatusMaxFields>;
  min?: Maybe<PaymentsQboStatusMinFields>;
};


/** aggregate fields of "payments_qbo_status" */
export type PaymentsQboStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PaymentsQboStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payments_qbo_status". All fields are combined with a logical 'AND'. */
export type PaymentsQboStatusBoolExp = {
  _and?: InputMaybe<Array<PaymentsQboStatusBoolExp>>;
  _not?: InputMaybe<PaymentsQboStatusBoolExp>;
  _or?: InputMaybe<Array<PaymentsQboStatusBoolExp>>;
  paymentRecordGuid?: InputMaybe<UuidComparisonExp>;
  qboId?: InputMaybe<StringComparisonExp>;
  qboSyncedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "payments_qbo_status" */
export type PaymentsQboStatusInsertInput = {
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  qboId?: InputMaybe<Scalars['String']>;
  qboSyncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PaymentsQboStatusMaxFields = {
  __typename?: 'PaymentsQboStatusMaxFields';
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PaymentsQboStatusMinFields = {
  __typename?: 'PaymentsQboStatusMinFields';
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "payments_qbo_status" */
export type PaymentsQboStatusObjRelInsertInput = {
  data: PaymentsQboStatusInsertInput;
};

/** Ordering options when selecting data from "payments_qbo_status". */
export type PaymentsQboStatusOrderBy = {
  paymentRecordGuid?: InputMaybe<OrderBy>;
  qboId?: InputMaybe<OrderBy>;
  qboSyncedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "payments_qbo_status" */
export type PaymentsQboStatusSelectColumn =
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'qboId'
  /** column name */
  | 'qboSyncedAt';

/** Streaming cursor of the table "payments_qbo_status" */
export type PaymentsQboStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PaymentsQboStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PaymentsQboStatusStreamCursorValueInput = {
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  qboId?: InputMaybe<Scalars['String']>;
  qboSyncedAt?: InputMaybe<Scalars['timestamptz']>;
};

export type PayoutItemTypesEnum =
  | 'CHARGE'
  | 'FEE'
  | 'REFUND';

/** Boolean expression to compare columns of type "PayoutItemTypesEnum". All fields are combined with logical 'AND'. */
export type PayoutItemTypesEnumComparisonExp = {
  _eq?: InputMaybe<PayoutItemTypesEnum>;
  _in?: InputMaybe<Array<PayoutItemTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<PayoutItemTypesEnum>;
  _nin?: InputMaybe<Array<PayoutItemTypesEnum>>;
};

/** columns and relationships of "payout_items" */
export type PayoutItems = {
  __typename?: 'PayoutItems';
  /** An array relationship */
  childPayoutItems: Array<PayoutItems>;
  /** An aggregate relationship */
  childPayoutItemsAggregate: PayoutItemsAggregate;
  createdAt: Scalars['timestamptz'];
  externalItemId: Scalars['String'];
  itemAmountUsc: Scalars['numeric'];
  itemDescription: Scalars['String'];
  itemType: PayoutItemTypesEnum;
  occurredAt: Scalars['timestamptz'];
  /** An object relationship */
  paymentRecord?: Maybe<PaymentRecords>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentRefundGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  payout?: Maybe<Payouts>;
  payoutGuid: Scalars['uuid'];
  payoutItemGuid: Scalars['uuid'];
  /** An object relationship */
  refundRecord?: Maybe<PaymentRefunds>;
  sourcePayoutItemGuid?: Maybe<Scalars['uuid']>;
  wisetackLoanRecordGuid?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "payout_items" */
export type PayoutItemsChildPayoutItemsArgs = {
  distinctOn?: InputMaybe<Array<PayoutItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutItemsOrderBy>>;
  where?: InputMaybe<PayoutItemsBoolExp>;
};


/** columns and relationships of "payout_items" */
export type PayoutItemsChildPayoutItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PayoutItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutItemsOrderBy>>;
  where?: InputMaybe<PayoutItemsBoolExp>;
};

/** aggregated selection of "payout_items" */
export type PayoutItemsAggregate = {
  __typename?: 'PayoutItemsAggregate';
  aggregate?: Maybe<PayoutItemsAggregateFields>;
  nodes: Array<PayoutItems>;
};

export type PayoutItemsAggregateBoolExp = {
  count?: InputMaybe<PayoutItemsAggregateBoolExpCount>;
};

/** aggregate fields of "payout_items" */
export type PayoutItemsAggregateFields = {
  __typename?: 'PayoutItemsAggregateFields';
  avg?: Maybe<PayoutItemsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PayoutItemsMaxFields>;
  min?: Maybe<PayoutItemsMinFields>;
  stddev?: Maybe<PayoutItemsStddevFields>;
  stddevPop?: Maybe<PayoutItemsStddevPopFields>;
  stddevSamp?: Maybe<PayoutItemsStddevSampFields>;
  sum?: Maybe<PayoutItemsSumFields>;
  varPop?: Maybe<PayoutItemsVarPopFields>;
  varSamp?: Maybe<PayoutItemsVarSampFields>;
  variance?: Maybe<PayoutItemsVarianceFields>;
};


/** aggregate fields of "payout_items" */
export type PayoutItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PayoutItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payout_items" */
export type PayoutItemsAggregateOrderBy = {
  avg?: InputMaybe<PayoutItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PayoutItemsMaxOrderBy>;
  min?: InputMaybe<PayoutItemsMinOrderBy>;
  stddev?: InputMaybe<PayoutItemsStddevOrderBy>;
  stddevPop?: InputMaybe<PayoutItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PayoutItemsStddevSampOrderBy>;
  sum?: InputMaybe<PayoutItemsSumOrderBy>;
  varPop?: InputMaybe<PayoutItemsVarPopOrderBy>;
  varSamp?: InputMaybe<PayoutItemsVarSampOrderBy>;
  variance?: InputMaybe<PayoutItemsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "payout_items" */
export type PayoutItemsArrRelInsertInput = {
  data: Array<PayoutItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PayoutItemsOnConflict>;
};

/** aggregate avg on columns */
export type PayoutItemsAvgFields = {
  __typename?: 'PayoutItemsAvgFields';
  itemAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payout_items" */
export type PayoutItemsAvgOrderBy = {
  itemAmountUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "payout_items". All fields are combined with a logical 'AND'. */
export type PayoutItemsBoolExp = {
  _and?: InputMaybe<Array<PayoutItemsBoolExp>>;
  _not?: InputMaybe<PayoutItemsBoolExp>;
  _or?: InputMaybe<Array<PayoutItemsBoolExp>>;
  childPayoutItems?: InputMaybe<PayoutItemsBoolExp>;
  childPayoutItemsAggregate?: InputMaybe<PayoutItemsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalItemId?: InputMaybe<StringComparisonExp>;
  itemAmountUsc?: InputMaybe<NumericComparisonExp>;
  itemDescription?: InputMaybe<StringComparisonExp>;
  itemType?: InputMaybe<PayoutItemTypesEnumComparisonExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
  paymentRecord?: InputMaybe<PaymentRecordsBoolExp>;
  paymentRecordGuid?: InputMaybe<UuidComparisonExp>;
  paymentRefundGuid?: InputMaybe<UuidComparisonExp>;
  payout?: InputMaybe<PayoutsBoolExp>;
  payoutGuid?: InputMaybe<UuidComparisonExp>;
  payoutItemGuid?: InputMaybe<UuidComparisonExp>;
  refundRecord?: InputMaybe<PaymentRefundsBoolExp>;
  sourcePayoutItemGuid?: InputMaybe<UuidComparisonExp>;
  wisetackLoanRecordGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "payout_items" */
export type PayoutItemsConstraint =
  /** unique or primary key constraint on columns "external_item_id" */
  | 'payout_items_external_item_id_key'
  /** unique or primary key constraint on columns "payout_item_guid" */
  | 'payout_items_pkey';

/** input type for incrementing numeric columns in table "payout_items" */
export type PayoutItemsIncInput = {
  itemAmountUsc?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "payout_items" */
export type PayoutItemsInsertInput = {
  childPayoutItems?: InputMaybe<PayoutItemsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalItemId?: InputMaybe<Scalars['String']>;
  itemAmountUsc?: InputMaybe<Scalars['numeric']>;
  itemDescription?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<PayoutItemTypesEnum>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentRecord?: InputMaybe<PaymentRecordsObjRelInsertInput>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentRefundGuid?: InputMaybe<Scalars['uuid']>;
  payout?: InputMaybe<PayoutsObjRelInsertInput>;
  payoutGuid?: InputMaybe<Scalars['uuid']>;
  payoutItemGuid?: InputMaybe<Scalars['uuid']>;
  refundRecord?: InputMaybe<PaymentRefundsObjRelInsertInput>;
  sourcePayoutItemGuid?: InputMaybe<Scalars['uuid']>;
  wisetackLoanRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PayoutItemsMaxFields = {
  __typename?: 'PayoutItemsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalItemId?: Maybe<Scalars['String']>;
  itemAmountUsc?: Maybe<Scalars['numeric']>;
  itemDescription?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentRefundGuid?: Maybe<Scalars['uuid']>;
  payoutGuid?: Maybe<Scalars['uuid']>;
  payoutItemGuid?: Maybe<Scalars['uuid']>;
  sourcePayoutItemGuid?: Maybe<Scalars['uuid']>;
  wisetackLoanRecordGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payout_items" */
export type PayoutItemsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  externalItemId?: InputMaybe<OrderBy>;
  itemAmountUsc?: InputMaybe<OrderBy>;
  itemDescription?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentRefundGuid?: InputMaybe<OrderBy>;
  payoutGuid?: InputMaybe<OrderBy>;
  payoutItemGuid?: InputMaybe<OrderBy>;
  sourcePayoutItemGuid?: InputMaybe<OrderBy>;
  wisetackLoanRecordGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PayoutItemsMinFields = {
  __typename?: 'PayoutItemsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalItemId?: Maybe<Scalars['String']>;
  itemAmountUsc?: Maybe<Scalars['numeric']>;
  itemDescription?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  paymentRecordGuid?: Maybe<Scalars['uuid']>;
  paymentRefundGuid?: Maybe<Scalars['uuid']>;
  payoutGuid?: Maybe<Scalars['uuid']>;
  payoutItemGuid?: Maybe<Scalars['uuid']>;
  sourcePayoutItemGuid?: Maybe<Scalars['uuid']>;
  wisetackLoanRecordGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payout_items" */
export type PayoutItemsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  externalItemId?: InputMaybe<OrderBy>;
  itemAmountUsc?: InputMaybe<OrderBy>;
  itemDescription?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentRefundGuid?: InputMaybe<OrderBy>;
  payoutGuid?: InputMaybe<OrderBy>;
  payoutItemGuid?: InputMaybe<OrderBy>;
  sourcePayoutItemGuid?: InputMaybe<OrderBy>;
  wisetackLoanRecordGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "payout_items" */
export type PayoutItemsMutationResponse = {
  __typename?: 'PayoutItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PayoutItems>;
};

/** input type for inserting object relation for remote table "payout_items" */
export type PayoutItemsObjRelInsertInput = {
  data: PayoutItemsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PayoutItemsOnConflict>;
};

/** on_conflict condition type for table "payout_items" */
export type PayoutItemsOnConflict = {
  constraint: PayoutItemsConstraint;
  updateColumns?: Array<PayoutItemsUpdateColumn>;
  where?: InputMaybe<PayoutItemsBoolExp>;
};

/** Ordering options when selecting data from "payout_items". */
export type PayoutItemsOrderBy = {
  childPayoutItemsAggregate?: InputMaybe<PayoutItemsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalItemId?: InputMaybe<OrderBy>;
  itemAmountUsc?: InputMaybe<OrderBy>;
  itemDescription?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  paymentRecord?: InputMaybe<PaymentRecordsOrderBy>;
  paymentRecordGuid?: InputMaybe<OrderBy>;
  paymentRefundGuid?: InputMaybe<OrderBy>;
  payout?: InputMaybe<PayoutsOrderBy>;
  payoutGuid?: InputMaybe<OrderBy>;
  payoutItemGuid?: InputMaybe<OrderBy>;
  refundRecord?: InputMaybe<PaymentRefundsOrderBy>;
  sourcePayoutItemGuid?: InputMaybe<OrderBy>;
  wisetackLoanRecordGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payout_items */
export type PayoutItemsPkColumnsInput = {
  payoutItemGuid: Scalars['uuid'];
};

/** select columns of table "payout_items" */
export type PayoutItemsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalItemId'
  /** column name */
  | 'itemAmountUsc'
  /** column name */
  | 'itemDescription'
  /** column name */
  | 'itemType'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentRefundGuid'
  /** column name */
  | 'payoutGuid'
  /** column name */
  | 'payoutItemGuid'
  /** column name */
  | 'sourcePayoutItemGuid'
  /** column name */
  | 'wisetackLoanRecordGuid';

/** input type for updating data in table "payout_items" */
export type PayoutItemsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalItemId?: InputMaybe<Scalars['String']>;
  itemAmountUsc?: InputMaybe<Scalars['numeric']>;
  itemDescription?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<PayoutItemTypesEnum>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentRefundGuid?: InputMaybe<Scalars['uuid']>;
  payoutGuid?: InputMaybe<Scalars['uuid']>;
  payoutItemGuid?: InputMaybe<Scalars['uuid']>;
  sourcePayoutItemGuid?: InputMaybe<Scalars['uuid']>;
  wisetackLoanRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type PayoutItemsStddevFields = {
  __typename?: 'PayoutItemsStddevFields';
  itemAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payout_items" */
export type PayoutItemsStddevOrderBy = {
  itemAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PayoutItemsStddevPopFields = {
  __typename?: 'PayoutItemsStddevPopFields';
  itemAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "payout_items" */
export type PayoutItemsStddevPopOrderBy = {
  itemAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PayoutItemsStddevSampFields = {
  __typename?: 'PayoutItemsStddevSampFields';
  itemAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "payout_items" */
export type PayoutItemsStddevSampOrderBy = {
  itemAmountUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "payout_items" */
export type PayoutItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PayoutItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PayoutItemsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalItemId?: InputMaybe<Scalars['String']>;
  itemAmountUsc?: InputMaybe<Scalars['numeric']>;
  itemDescription?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<PayoutItemTypesEnum>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  paymentRecordGuid?: InputMaybe<Scalars['uuid']>;
  paymentRefundGuid?: InputMaybe<Scalars['uuid']>;
  payoutGuid?: InputMaybe<Scalars['uuid']>;
  payoutItemGuid?: InputMaybe<Scalars['uuid']>;
  sourcePayoutItemGuid?: InputMaybe<Scalars['uuid']>;
  wisetackLoanRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PayoutItemsSumFields = {
  __typename?: 'PayoutItemsSumFields';
  itemAmountUsc?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "payout_items" */
export type PayoutItemsSumOrderBy = {
  itemAmountUsc?: InputMaybe<OrderBy>;
};

/** update columns of table "payout_items" */
export type PayoutItemsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalItemId'
  /** column name */
  | 'itemAmountUsc'
  /** column name */
  | 'itemDescription'
  /** column name */
  | 'itemType'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'paymentRecordGuid'
  /** column name */
  | 'paymentRefundGuid'
  /** column name */
  | 'payoutGuid'
  /** column name */
  | 'payoutItemGuid'
  /** column name */
  | 'sourcePayoutItemGuid'
  /** column name */
  | 'wisetackLoanRecordGuid';

export type PayoutItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PayoutItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PayoutItemsSetInput>;
  /** filter the rows which have to be updated */
  where: PayoutItemsBoolExp;
};

/** aggregate varPop on columns */
export type PayoutItemsVarPopFields = {
  __typename?: 'PayoutItemsVarPopFields';
  itemAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "payout_items" */
export type PayoutItemsVarPopOrderBy = {
  itemAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PayoutItemsVarSampFields = {
  __typename?: 'PayoutItemsVarSampFields';
  itemAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "payout_items" */
export type PayoutItemsVarSampOrderBy = {
  itemAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PayoutItemsVarianceFields = {
  __typename?: 'PayoutItemsVarianceFields';
  itemAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payout_items" */
export type PayoutItemsVarianceOrderBy = {
  itemAmountUsc?: InputMaybe<OrderBy>;
};

/** columns and relationships of "payout_qbo_accounts_config" */
export type PayoutQboAccountsConfig = {
  __typename?: 'PayoutQboAccountsConfig';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  payoutQboDepositAccountId: Scalars['String'];
  payoutQboFeesExpenseAccountId: Scalars['String'];
  payoutQboPaymentProcessorBalanceAccountId: Scalars['String'];
  payoutQboRefundsExpenseAccountId: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "payout_qbo_accounts_config" */
export type PayoutQboAccountsConfigAggregate = {
  __typename?: 'PayoutQboAccountsConfigAggregate';
  aggregate?: Maybe<PayoutQboAccountsConfigAggregateFields>;
  nodes: Array<PayoutQboAccountsConfig>;
};

/** aggregate fields of "payout_qbo_accounts_config" */
export type PayoutQboAccountsConfigAggregateFields = {
  __typename?: 'PayoutQboAccountsConfigAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PayoutQboAccountsConfigMaxFields>;
  min?: Maybe<PayoutQboAccountsConfigMinFields>;
};


/** aggregate fields of "payout_qbo_accounts_config" */
export type PayoutQboAccountsConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PayoutQboAccountsConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payout_qbo_accounts_config". All fields are combined with a logical 'AND'. */
export type PayoutQboAccountsConfigBoolExp = {
  _and?: InputMaybe<Array<PayoutQboAccountsConfigBoolExp>>;
  _not?: InputMaybe<PayoutQboAccountsConfigBoolExp>;
  _or?: InputMaybe<Array<PayoutQboAccountsConfigBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  payoutQboDepositAccountId?: InputMaybe<StringComparisonExp>;
  payoutQboFeesExpenseAccountId?: InputMaybe<StringComparisonExp>;
  payoutQboPaymentProcessorBalanceAccountId?: InputMaybe<StringComparisonExp>;
  payoutQboRefundsExpenseAccountId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "payout_qbo_accounts_config" */
export type PayoutQboAccountsConfigConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'payout_qbo_accounts_config_pkey';

/** input type for inserting data into table "payout_qbo_accounts_config" */
export type PayoutQboAccountsConfigInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  payoutQboDepositAccountId?: InputMaybe<Scalars['String']>;
  payoutQboFeesExpenseAccountId?: InputMaybe<Scalars['String']>;
  payoutQboPaymentProcessorBalanceAccountId?: InputMaybe<Scalars['String']>;
  payoutQboRefundsExpenseAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PayoutQboAccountsConfigMaxFields = {
  __typename?: 'PayoutQboAccountsConfigMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  payoutQboDepositAccountId?: Maybe<Scalars['String']>;
  payoutQboFeesExpenseAccountId?: Maybe<Scalars['String']>;
  payoutQboPaymentProcessorBalanceAccountId?: Maybe<Scalars['String']>;
  payoutQboRefundsExpenseAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PayoutQboAccountsConfigMinFields = {
  __typename?: 'PayoutQboAccountsConfigMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  payoutQboDepositAccountId?: Maybe<Scalars['String']>;
  payoutQboFeesExpenseAccountId?: Maybe<Scalars['String']>;
  payoutQboPaymentProcessorBalanceAccountId?: Maybe<Scalars['String']>;
  payoutQboRefundsExpenseAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "payout_qbo_accounts_config" */
export type PayoutQboAccountsConfigMutationResponse = {
  __typename?: 'PayoutQboAccountsConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PayoutQboAccountsConfig>;
};

/** on_conflict condition type for table "payout_qbo_accounts_config" */
export type PayoutQboAccountsConfigOnConflict = {
  constraint: PayoutQboAccountsConfigConstraint;
  updateColumns?: Array<PayoutQboAccountsConfigUpdateColumn>;
  where?: InputMaybe<PayoutQboAccountsConfigBoolExp>;
};

/** Ordering options when selecting data from "payout_qbo_accounts_config". */
export type PayoutQboAccountsConfigOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  payoutQboDepositAccountId?: InputMaybe<OrderBy>;
  payoutQboFeesExpenseAccountId?: InputMaybe<OrderBy>;
  payoutQboPaymentProcessorBalanceAccountId?: InputMaybe<OrderBy>;
  payoutQboRefundsExpenseAccountId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payout_qbo_accounts_config */
export type PayoutQboAccountsConfigPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "payout_qbo_accounts_config" */
export type PayoutQboAccountsConfigSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'payoutQboDepositAccountId'
  /** column name */
  | 'payoutQboFeesExpenseAccountId'
  /** column name */
  | 'payoutQboPaymentProcessorBalanceAccountId'
  /** column name */
  | 'payoutQboRefundsExpenseAccountId'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "payout_qbo_accounts_config" */
export type PayoutQboAccountsConfigSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  payoutQboDepositAccountId?: InputMaybe<Scalars['String']>;
  payoutQboFeesExpenseAccountId?: InputMaybe<Scalars['String']>;
  payoutQboPaymentProcessorBalanceAccountId?: InputMaybe<Scalars['String']>;
  payoutQboRefundsExpenseAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "payout_qbo_accounts_config" */
export type PayoutQboAccountsConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PayoutQboAccountsConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PayoutQboAccountsConfigStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  payoutQboDepositAccountId?: InputMaybe<Scalars['String']>;
  payoutQboFeesExpenseAccountId?: InputMaybe<Scalars['String']>;
  payoutQboPaymentProcessorBalanceAccountId?: InputMaybe<Scalars['String']>;
  payoutQboRefundsExpenseAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "payout_qbo_accounts_config" */
export type PayoutQboAccountsConfigUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'payoutQboDepositAccountId'
  /** column name */
  | 'payoutQboFeesExpenseAccountId'
  /** column name */
  | 'payoutQboPaymentProcessorBalanceAccountId'
  /** column name */
  | 'payoutQboRefundsExpenseAccountId'
  /** column name */
  | 'updatedAt';

export type PayoutQboAccountsConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PayoutQboAccountsConfigSetInput>;
  /** filter the rows which have to be updated */
  where: PayoutQboAccountsConfigBoolExp;
};

/** columns and relationships of "payouts" */
export type Payouts = {
  __typename?: 'Payouts';
  /** An object relationship */
  accCompanyConfig?: Maybe<AccCompanyConfig>;
  /** An object relationship */
  accSyncInfo?: Maybe<PayoutsAccountingStaleInfo>;
  balanceAdjustmentDescription: Scalars['String'];
  balanceAdjustmentUsc: Scalars['Int'];
  chargesAmountUsc: Scalars['Int'];
  chargesCount: Scalars['Int'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** If set, Breezy will not sync this payout to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  externalPayoutId: Scalars['String'];
  externalPayoutSource: Scalars['String'];
  feesAmountUsc: Scalars['Int'];
  feesCount: Scalars['Int'];
  grossAmountUsc: Scalars['Int'];
  netAmountUsc: Scalars['Int'];
  paidAt: Scalars['timestamptz'];
  payoutGuid: Scalars['uuid'];
  /** An array relationship */
  payoutItems: Array<PayoutItems>;
  /** An aggregate relationship */
  payoutItemsAggregate: PayoutItemsAggregate;
  /** An object relationship */
  qboSync?: Maybe<PayoutsQboStatus>;
  refundsAmountUsc: Scalars['Int'];
  refundsCount: Scalars['Int'];
};


/** columns and relationships of "payouts" */
export type PayoutsPayoutItemsArgs = {
  distinctOn?: InputMaybe<Array<PayoutItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutItemsOrderBy>>;
  where?: InputMaybe<PayoutItemsBoolExp>;
};


/** columns and relationships of "payouts" */
export type PayoutsPayoutItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PayoutItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutItemsOrderBy>>;
  where?: InputMaybe<PayoutItemsBoolExp>;
};

/** columns and relationships of "payouts_accounting_stale_info" */
export type PayoutsAccountingStaleInfo = {
  __typename?: 'PayoutsAccountingStaleInfo';
  externalEntityId?: Maybe<Scalars['String']>;
  payoutGuid?: Maybe<Scalars['uuid']>;
  syncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "payouts_accounting_stale_info" */
export type PayoutsAccountingStaleInfoAggregate = {
  __typename?: 'PayoutsAccountingStaleInfoAggregate';
  aggregate?: Maybe<PayoutsAccountingStaleInfoAggregateFields>;
  nodes: Array<PayoutsAccountingStaleInfo>;
};

/** aggregate fields of "payouts_accounting_stale_info" */
export type PayoutsAccountingStaleInfoAggregateFields = {
  __typename?: 'PayoutsAccountingStaleInfoAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PayoutsAccountingStaleInfoMaxFields>;
  min?: Maybe<PayoutsAccountingStaleInfoMinFields>;
};


/** aggregate fields of "payouts_accounting_stale_info" */
export type PayoutsAccountingStaleInfoAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PayoutsAccountingStaleInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payouts_accounting_stale_info". All fields are combined with a logical 'AND'. */
export type PayoutsAccountingStaleInfoBoolExp = {
  _and?: InputMaybe<Array<PayoutsAccountingStaleInfoBoolExp>>;
  _not?: InputMaybe<PayoutsAccountingStaleInfoBoolExp>;
  _or?: InputMaybe<Array<PayoutsAccountingStaleInfoBoolExp>>;
  externalEntityId?: InputMaybe<StringComparisonExp>;
  payoutGuid?: InputMaybe<UuidComparisonExp>;
  syncedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "payouts_accounting_stale_info" */
export type PayoutsAccountingStaleInfoInsertInput = {
  externalEntityId?: InputMaybe<Scalars['String']>;
  payoutGuid?: InputMaybe<Scalars['uuid']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PayoutsAccountingStaleInfoMaxFields = {
  __typename?: 'PayoutsAccountingStaleInfoMaxFields';
  externalEntityId?: Maybe<Scalars['String']>;
  payoutGuid?: Maybe<Scalars['uuid']>;
  syncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PayoutsAccountingStaleInfoMinFields = {
  __typename?: 'PayoutsAccountingStaleInfoMinFields';
  externalEntityId?: Maybe<Scalars['String']>;
  payoutGuid?: Maybe<Scalars['uuid']>;
  syncedAt?: Maybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "payouts_accounting_stale_info" */
export type PayoutsAccountingStaleInfoObjRelInsertInput = {
  data: PayoutsAccountingStaleInfoInsertInput;
};

/** Ordering options when selecting data from "payouts_accounting_stale_info". */
export type PayoutsAccountingStaleInfoOrderBy = {
  externalEntityId?: InputMaybe<OrderBy>;
  payoutGuid?: InputMaybe<OrderBy>;
  syncedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "payouts_accounting_stale_info" */
export type PayoutsAccountingStaleInfoSelectColumn =
  /** column name */
  | 'externalEntityId'
  /** column name */
  | 'payoutGuid'
  /** column name */
  | 'syncedAt';

/** Streaming cursor of the table "payouts_accounting_stale_info" */
export type PayoutsAccountingStaleInfoStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PayoutsAccountingStaleInfoStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PayoutsAccountingStaleInfoStreamCursorValueInput = {
  externalEntityId?: InputMaybe<Scalars['String']>;
  payoutGuid?: InputMaybe<Scalars['uuid']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregated selection of "payouts" */
export type PayoutsAggregate = {
  __typename?: 'PayoutsAggregate';
  aggregate?: Maybe<PayoutsAggregateFields>;
  nodes: Array<Payouts>;
};

/** aggregate fields of "payouts" */
export type PayoutsAggregateFields = {
  __typename?: 'PayoutsAggregateFields';
  avg?: Maybe<PayoutsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PayoutsMaxFields>;
  min?: Maybe<PayoutsMinFields>;
  stddev?: Maybe<PayoutsStddevFields>;
  stddevPop?: Maybe<PayoutsStddevPopFields>;
  stddevSamp?: Maybe<PayoutsStddevSampFields>;
  sum?: Maybe<PayoutsSumFields>;
  varPop?: Maybe<PayoutsVarPopFields>;
  varSamp?: Maybe<PayoutsVarSampFields>;
  variance?: Maybe<PayoutsVarianceFields>;
};


/** aggregate fields of "payouts" */
export type PayoutsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PayoutsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PayoutsAvgFields = {
  __typename?: 'PayoutsAvgFields';
  balanceAdjustmentUsc?: Maybe<Scalars['Float']>;
  chargesAmountUsc?: Maybe<Scalars['Float']>;
  chargesCount?: Maybe<Scalars['Float']>;
  feesAmountUsc?: Maybe<Scalars['Float']>;
  feesCount?: Maybe<Scalars['Float']>;
  grossAmountUsc?: Maybe<Scalars['Float']>;
  netAmountUsc?: Maybe<Scalars['Float']>;
  refundsAmountUsc?: Maybe<Scalars['Float']>;
  refundsCount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "payouts". All fields are combined with a logical 'AND'. */
export type PayoutsBoolExp = {
  _and?: InputMaybe<Array<PayoutsBoolExp>>;
  _not?: InputMaybe<PayoutsBoolExp>;
  _or?: InputMaybe<Array<PayoutsBoolExp>>;
  accCompanyConfig?: InputMaybe<AccCompanyConfigBoolExp>;
  accSyncInfo?: InputMaybe<PayoutsAccountingStaleInfoBoolExp>;
  balanceAdjustmentDescription?: InputMaybe<StringComparisonExp>;
  balanceAdjustmentUsc?: InputMaybe<IntComparisonExp>;
  chargesAmountUsc?: InputMaybe<IntComparisonExp>;
  chargesCount?: InputMaybe<IntComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  doNotSyncToAccountingServiceReason?: InputMaybe<StringComparisonExp>;
  externalPayoutId?: InputMaybe<StringComparisonExp>;
  externalPayoutSource?: InputMaybe<StringComparisonExp>;
  feesAmountUsc?: InputMaybe<IntComparisonExp>;
  feesCount?: InputMaybe<IntComparisonExp>;
  grossAmountUsc?: InputMaybe<IntComparisonExp>;
  netAmountUsc?: InputMaybe<IntComparisonExp>;
  paidAt?: InputMaybe<TimestamptzComparisonExp>;
  payoutGuid?: InputMaybe<UuidComparisonExp>;
  payoutItems?: InputMaybe<PayoutItemsBoolExp>;
  payoutItemsAggregate?: InputMaybe<PayoutItemsAggregateBoolExp>;
  qboSync?: InputMaybe<PayoutsQboStatusBoolExp>;
  refundsAmountUsc?: InputMaybe<IntComparisonExp>;
  refundsCount?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "payouts" */
export type PayoutsConstraint =
  /** unique or primary key constraint on columns "external_payout_source", "external_payout_id" */
  | 'payouts_external_payout_source_external_payout_id_key'
  /** unique or primary key constraint on columns "payout_guid" */
  | 'payouts_pkey';

/** input type for incrementing numeric columns in table "payouts" */
export type PayoutsIncInput = {
  balanceAdjustmentUsc?: InputMaybe<Scalars['Int']>;
  chargesAmountUsc?: InputMaybe<Scalars['Int']>;
  chargesCount?: InputMaybe<Scalars['Int']>;
  feesAmountUsc?: InputMaybe<Scalars['Int']>;
  feesCount?: InputMaybe<Scalars['Int']>;
  grossAmountUsc?: InputMaybe<Scalars['Int']>;
  netAmountUsc?: InputMaybe<Scalars['Int']>;
  refundsAmountUsc?: InputMaybe<Scalars['Int']>;
  refundsCount?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "payouts" */
export type PayoutsInsertInput = {
  accCompanyConfig?: InputMaybe<AccCompanyConfigObjRelInsertInput>;
  accSyncInfo?: InputMaybe<PayoutsAccountingStaleInfoObjRelInsertInput>;
  balanceAdjustmentDescription?: InputMaybe<Scalars['String']>;
  balanceAdjustmentUsc?: InputMaybe<Scalars['Int']>;
  chargesAmountUsc?: InputMaybe<Scalars['Int']>;
  chargesCount?: InputMaybe<Scalars['Int']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** If set, Breezy will not sync this payout to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  externalPayoutId?: InputMaybe<Scalars['String']>;
  externalPayoutSource?: InputMaybe<Scalars['String']>;
  feesAmountUsc?: InputMaybe<Scalars['Int']>;
  feesCount?: InputMaybe<Scalars['Int']>;
  grossAmountUsc?: InputMaybe<Scalars['Int']>;
  netAmountUsc?: InputMaybe<Scalars['Int']>;
  paidAt?: InputMaybe<Scalars['timestamptz']>;
  payoutGuid?: InputMaybe<Scalars['uuid']>;
  payoutItems?: InputMaybe<PayoutItemsArrRelInsertInput>;
  qboSync?: InputMaybe<PayoutsQboStatusObjRelInsertInput>;
  refundsAmountUsc?: InputMaybe<Scalars['Int']>;
  refundsCount?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type PayoutsMaxFields = {
  __typename?: 'PayoutsMaxFields';
  balanceAdjustmentDescription?: Maybe<Scalars['String']>;
  balanceAdjustmentUsc?: Maybe<Scalars['Int']>;
  chargesAmountUsc?: Maybe<Scalars['Int']>;
  chargesCount?: Maybe<Scalars['Int']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** If set, Breezy will not sync this payout to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  externalPayoutId?: Maybe<Scalars['String']>;
  externalPayoutSource?: Maybe<Scalars['String']>;
  feesAmountUsc?: Maybe<Scalars['Int']>;
  feesCount?: Maybe<Scalars['Int']>;
  grossAmountUsc?: Maybe<Scalars['Int']>;
  netAmountUsc?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['timestamptz']>;
  payoutGuid?: Maybe<Scalars['uuid']>;
  refundsAmountUsc?: Maybe<Scalars['Int']>;
  refundsCount?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type PayoutsMinFields = {
  __typename?: 'PayoutsMinFields';
  balanceAdjustmentDescription?: Maybe<Scalars['String']>;
  balanceAdjustmentUsc?: Maybe<Scalars['Int']>;
  chargesAmountUsc?: Maybe<Scalars['Int']>;
  chargesCount?: Maybe<Scalars['Int']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** If set, Breezy will not sync this payout to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: Maybe<Scalars['String']>;
  externalPayoutId?: Maybe<Scalars['String']>;
  externalPayoutSource?: Maybe<Scalars['String']>;
  feesAmountUsc?: Maybe<Scalars['Int']>;
  feesCount?: Maybe<Scalars['Int']>;
  grossAmountUsc?: Maybe<Scalars['Int']>;
  netAmountUsc?: Maybe<Scalars['Int']>;
  paidAt?: Maybe<Scalars['timestamptz']>;
  payoutGuid?: Maybe<Scalars['uuid']>;
  refundsAmountUsc?: Maybe<Scalars['Int']>;
  refundsCount?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "payouts" */
export type PayoutsMutationResponse = {
  __typename?: 'PayoutsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payouts>;
};

/** input type for inserting object relation for remote table "payouts" */
export type PayoutsObjRelInsertInput = {
  data: PayoutsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PayoutsOnConflict>;
};

/** on_conflict condition type for table "payouts" */
export type PayoutsOnConflict = {
  constraint: PayoutsConstraint;
  updateColumns?: Array<PayoutsUpdateColumn>;
  where?: InputMaybe<PayoutsBoolExp>;
};

/** Ordering options when selecting data from "payouts". */
export type PayoutsOrderBy = {
  accCompanyConfig?: InputMaybe<AccCompanyConfigOrderBy>;
  accSyncInfo?: InputMaybe<PayoutsAccountingStaleInfoOrderBy>;
  balanceAdjustmentDescription?: InputMaybe<OrderBy>;
  balanceAdjustmentUsc?: InputMaybe<OrderBy>;
  chargesAmountUsc?: InputMaybe<OrderBy>;
  chargesCount?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  doNotSyncToAccountingServiceReason?: InputMaybe<OrderBy>;
  externalPayoutId?: InputMaybe<OrderBy>;
  externalPayoutSource?: InputMaybe<OrderBy>;
  feesAmountUsc?: InputMaybe<OrderBy>;
  feesCount?: InputMaybe<OrderBy>;
  grossAmountUsc?: InputMaybe<OrderBy>;
  netAmountUsc?: InputMaybe<OrderBy>;
  paidAt?: InputMaybe<OrderBy>;
  payoutGuid?: InputMaybe<OrderBy>;
  payoutItemsAggregate?: InputMaybe<PayoutItemsAggregateOrderBy>;
  qboSync?: InputMaybe<PayoutsQboStatusOrderBy>;
  refundsAmountUsc?: InputMaybe<OrderBy>;
  refundsCount?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payouts */
export type PayoutsPkColumnsInput = {
  payoutGuid: Scalars['uuid'];
};

/** columns and relationships of "payouts_qbo_status" */
export type PayoutsQboStatus = {
  __typename?: 'PayoutsQboStatus';
  payoutGuid?: Maybe<Scalars['uuid']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "payouts_qbo_status" */
export type PayoutsQboStatusAggregate = {
  __typename?: 'PayoutsQboStatusAggregate';
  aggregate?: Maybe<PayoutsQboStatusAggregateFields>;
  nodes: Array<PayoutsQboStatus>;
};

/** aggregate fields of "payouts_qbo_status" */
export type PayoutsQboStatusAggregateFields = {
  __typename?: 'PayoutsQboStatusAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PayoutsQboStatusMaxFields>;
  min?: Maybe<PayoutsQboStatusMinFields>;
};


/** aggregate fields of "payouts_qbo_status" */
export type PayoutsQboStatusAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PayoutsQboStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payouts_qbo_status". All fields are combined with a logical 'AND'. */
export type PayoutsQboStatusBoolExp = {
  _and?: InputMaybe<Array<PayoutsQboStatusBoolExp>>;
  _not?: InputMaybe<PayoutsQboStatusBoolExp>;
  _or?: InputMaybe<Array<PayoutsQboStatusBoolExp>>;
  payoutGuid?: InputMaybe<UuidComparisonExp>;
  qboId?: InputMaybe<StringComparisonExp>;
  qboSyncedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** input type for inserting data into table "payouts_qbo_status" */
export type PayoutsQboStatusInsertInput = {
  payoutGuid?: InputMaybe<Scalars['uuid']>;
  qboId?: InputMaybe<Scalars['String']>;
  qboSyncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PayoutsQboStatusMaxFields = {
  __typename?: 'PayoutsQboStatusMaxFields';
  payoutGuid?: Maybe<Scalars['uuid']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PayoutsQboStatusMinFields = {
  __typename?: 'PayoutsQboStatusMinFields';
  payoutGuid?: Maybe<Scalars['uuid']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncedAt?: Maybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "payouts_qbo_status" */
export type PayoutsQboStatusObjRelInsertInput = {
  data: PayoutsQboStatusInsertInput;
};

/** Ordering options when selecting data from "payouts_qbo_status". */
export type PayoutsQboStatusOrderBy = {
  payoutGuid?: InputMaybe<OrderBy>;
  qboId?: InputMaybe<OrderBy>;
  qboSyncedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "payouts_qbo_status" */
export type PayoutsQboStatusSelectColumn =
  /** column name */
  | 'payoutGuid'
  /** column name */
  | 'qboId'
  /** column name */
  | 'qboSyncedAt';

/** Streaming cursor of the table "payouts_qbo_status" */
export type PayoutsQboStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PayoutsQboStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PayoutsQboStatusStreamCursorValueInput = {
  payoutGuid?: InputMaybe<Scalars['uuid']>;
  qboId?: InputMaybe<Scalars['String']>;
  qboSyncedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** select columns of table "payouts" */
export type PayoutsSelectColumn =
  /** column name */
  | 'balanceAdjustmentDescription'
  /** column name */
  | 'balanceAdjustmentUsc'
  /** column name */
  | 'chargesAmountUsc'
  /** column name */
  | 'chargesCount'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'doNotSyncToAccountingServiceReason'
  /** column name */
  | 'externalPayoutId'
  /** column name */
  | 'externalPayoutSource'
  /** column name */
  | 'feesAmountUsc'
  /** column name */
  | 'feesCount'
  /** column name */
  | 'grossAmountUsc'
  /** column name */
  | 'netAmountUsc'
  /** column name */
  | 'paidAt'
  /** column name */
  | 'payoutGuid'
  /** column name */
  | 'refundsAmountUsc'
  /** column name */
  | 'refundsCount';

/** input type for updating data in table "payouts" */
export type PayoutsSetInput = {
  balanceAdjustmentDescription?: InputMaybe<Scalars['String']>;
  balanceAdjustmentUsc?: InputMaybe<Scalars['Int']>;
  chargesAmountUsc?: InputMaybe<Scalars['Int']>;
  chargesCount?: InputMaybe<Scalars['Int']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** If set, Breezy will not sync this payout to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  externalPayoutId?: InputMaybe<Scalars['String']>;
  externalPayoutSource?: InputMaybe<Scalars['String']>;
  feesAmountUsc?: InputMaybe<Scalars['Int']>;
  feesCount?: InputMaybe<Scalars['Int']>;
  grossAmountUsc?: InputMaybe<Scalars['Int']>;
  netAmountUsc?: InputMaybe<Scalars['Int']>;
  paidAt?: InputMaybe<Scalars['timestamptz']>;
  payoutGuid?: InputMaybe<Scalars['uuid']>;
  refundsAmountUsc?: InputMaybe<Scalars['Int']>;
  refundsCount?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type PayoutsStddevFields = {
  __typename?: 'PayoutsStddevFields';
  balanceAdjustmentUsc?: Maybe<Scalars['Float']>;
  chargesAmountUsc?: Maybe<Scalars['Float']>;
  chargesCount?: Maybe<Scalars['Float']>;
  feesAmountUsc?: Maybe<Scalars['Float']>;
  feesCount?: Maybe<Scalars['Float']>;
  grossAmountUsc?: Maybe<Scalars['Float']>;
  netAmountUsc?: Maybe<Scalars['Float']>;
  refundsAmountUsc?: Maybe<Scalars['Float']>;
  refundsCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PayoutsStddevPopFields = {
  __typename?: 'PayoutsStddevPopFields';
  balanceAdjustmentUsc?: Maybe<Scalars['Float']>;
  chargesAmountUsc?: Maybe<Scalars['Float']>;
  chargesCount?: Maybe<Scalars['Float']>;
  feesAmountUsc?: Maybe<Scalars['Float']>;
  feesCount?: Maybe<Scalars['Float']>;
  grossAmountUsc?: Maybe<Scalars['Float']>;
  netAmountUsc?: Maybe<Scalars['Float']>;
  refundsAmountUsc?: Maybe<Scalars['Float']>;
  refundsCount?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PayoutsStddevSampFields = {
  __typename?: 'PayoutsStddevSampFields';
  balanceAdjustmentUsc?: Maybe<Scalars['Float']>;
  chargesAmountUsc?: Maybe<Scalars['Float']>;
  chargesCount?: Maybe<Scalars['Float']>;
  feesAmountUsc?: Maybe<Scalars['Float']>;
  feesCount?: Maybe<Scalars['Float']>;
  grossAmountUsc?: Maybe<Scalars['Float']>;
  netAmountUsc?: Maybe<Scalars['Float']>;
  refundsAmountUsc?: Maybe<Scalars['Float']>;
  refundsCount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "payouts" */
export type PayoutsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PayoutsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PayoutsStreamCursorValueInput = {
  balanceAdjustmentDescription?: InputMaybe<Scalars['String']>;
  balanceAdjustmentUsc?: InputMaybe<Scalars['Int']>;
  chargesAmountUsc?: InputMaybe<Scalars['Int']>;
  chargesCount?: InputMaybe<Scalars['Int']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  /** If set, Breezy will not sync this payout to external accounting systems (QBO/QBD). Linkage in acc_sync_info/qbo_sync_info may still exist. */
  doNotSyncToAccountingServiceReason?: InputMaybe<Scalars['String']>;
  externalPayoutId?: InputMaybe<Scalars['String']>;
  externalPayoutSource?: InputMaybe<Scalars['String']>;
  feesAmountUsc?: InputMaybe<Scalars['Int']>;
  feesCount?: InputMaybe<Scalars['Int']>;
  grossAmountUsc?: InputMaybe<Scalars['Int']>;
  netAmountUsc?: InputMaybe<Scalars['Int']>;
  paidAt?: InputMaybe<Scalars['timestamptz']>;
  payoutGuid?: InputMaybe<Scalars['uuid']>;
  refundsAmountUsc?: InputMaybe<Scalars['Int']>;
  refundsCount?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type PayoutsSumFields = {
  __typename?: 'PayoutsSumFields';
  balanceAdjustmentUsc?: Maybe<Scalars['Int']>;
  chargesAmountUsc?: Maybe<Scalars['Int']>;
  chargesCount?: Maybe<Scalars['Int']>;
  feesAmountUsc?: Maybe<Scalars['Int']>;
  feesCount?: Maybe<Scalars['Int']>;
  grossAmountUsc?: Maybe<Scalars['Int']>;
  netAmountUsc?: Maybe<Scalars['Int']>;
  refundsAmountUsc?: Maybe<Scalars['Int']>;
  refundsCount?: Maybe<Scalars['Int']>;
};

/** update columns of table "payouts" */
export type PayoutsUpdateColumn =
  /** column name */
  | 'balanceAdjustmentDescription'
  /** column name */
  | 'balanceAdjustmentUsc'
  /** column name */
  | 'chargesAmountUsc'
  /** column name */
  | 'chargesCount'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'doNotSyncToAccountingServiceReason'
  /** column name */
  | 'externalPayoutId'
  /** column name */
  | 'externalPayoutSource'
  /** column name */
  | 'feesAmountUsc'
  /** column name */
  | 'feesCount'
  /** column name */
  | 'grossAmountUsc'
  /** column name */
  | 'netAmountUsc'
  /** column name */
  | 'paidAt'
  /** column name */
  | 'payoutGuid'
  /** column name */
  | 'refundsAmountUsc'
  /** column name */
  | 'refundsCount';

export type PayoutsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PayoutsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PayoutsSetInput>;
  /** filter the rows which have to be updated */
  where: PayoutsBoolExp;
};

/** aggregate varPop on columns */
export type PayoutsVarPopFields = {
  __typename?: 'PayoutsVarPopFields';
  balanceAdjustmentUsc?: Maybe<Scalars['Float']>;
  chargesAmountUsc?: Maybe<Scalars['Float']>;
  chargesCount?: Maybe<Scalars['Float']>;
  feesAmountUsc?: Maybe<Scalars['Float']>;
  feesCount?: Maybe<Scalars['Float']>;
  grossAmountUsc?: Maybe<Scalars['Float']>;
  netAmountUsc?: Maybe<Scalars['Float']>;
  refundsAmountUsc?: Maybe<Scalars['Float']>;
  refundsCount?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PayoutsVarSampFields = {
  __typename?: 'PayoutsVarSampFields';
  balanceAdjustmentUsc?: Maybe<Scalars['Float']>;
  chargesAmountUsc?: Maybe<Scalars['Float']>;
  chargesCount?: Maybe<Scalars['Float']>;
  feesAmountUsc?: Maybe<Scalars['Float']>;
  feesCount?: Maybe<Scalars['Float']>;
  grossAmountUsc?: Maybe<Scalars['Float']>;
  netAmountUsc?: Maybe<Scalars['Float']>;
  refundsAmountUsc?: Maybe<Scalars['Float']>;
  refundsCount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PayoutsVarianceFields = {
  __typename?: 'PayoutsVarianceFields';
  balanceAdjustmentUsc?: Maybe<Scalars['Float']>;
  chargesAmountUsc?: Maybe<Scalars['Float']>;
  chargesCount?: Maybe<Scalars['Float']>;
  feesAmountUsc?: Maybe<Scalars['Float']>;
  feesCount?: Maybe<Scalars['Float']>;
  grossAmountUsc?: Maybe<Scalars['Float']>;
  netAmountUsc?: Maybe<Scalars['Float']>;
  refundsAmountUsc?: Maybe<Scalars['Float']>;
  refundsCount?: Maybe<Scalars['Float']>;
};

/** Permissions to authorize particular actions by users in the system */
export type Permissions = {
  __typename?: 'Permissions';
  name: Scalars['String'];
  /** An aggregate relationship */
  userPermissionsAggregate: UserPermissionsAggregate;
  /** An array relationship */
  user_permissions: Array<UserPermissions>;
};


/** Permissions to authorize particular actions by users in the system */
export type PermissionsUserPermissionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsOrderBy>>;
  where?: InputMaybe<UserPermissionsBoolExp>;
};


/** Permissions to authorize particular actions by users in the system */
export type PermissionsUser_PermissionsArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsOrderBy>>;
  where?: InputMaybe<UserPermissionsBoolExp>;
};

/** aggregated selection of "permissions" */
export type PermissionsAggregate = {
  __typename?: 'PermissionsAggregate';
  aggregate?: Maybe<PermissionsAggregateFields>;
  nodes: Array<Permissions>;
};

/** aggregate fields of "permissions" */
export type PermissionsAggregateFields = {
  __typename?: 'PermissionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PermissionsMaxFields>;
  min?: Maybe<PermissionsMinFields>;
};


/** aggregate fields of "permissions" */
export type PermissionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PermissionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "permissions". All fields are combined with a logical 'AND'. */
export type PermissionsBoolExp = {
  _and?: InputMaybe<Array<PermissionsBoolExp>>;
  _not?: InputMaybe<PermissionsBoolExp>;
  _or?: InputMaybe<Array<PermissionsBoolExp>>;
  name?: InputMaybe<StringComparisonExp>;
  user_permissions?: InputMaybe<UserPermissionsBoolExp>;
  user_permissionsAggregate?: InputMaybe<UserPermissionsAggregateBoolExp>;
};

/** aggregate max on columns */
export type PermissionsMaxFields = {
  __typename?: 'PermissionsMaxFields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PermissionsMinFields = {
  __typename?: 'PermissionsMinFields';
  name?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "permissions". */
export type PermissionsOrderBy = {
  name?: InputMaybe<OrderBy>;
  user_permissionsAggregate?: InputMaybe<UserPermissionsAggregateOrderBy>;
};

/** select columns of table "permissions" */
export type PermissionsSelectColumn =
  /** column name */
  | 'name';

/** Streaming cursor of the table "permissions" */
export type PermissionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PermissionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PermissionsStreamCursorValueInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "permissions_v2" */
export type PermissionsV2 = {
  __typename?: 'PermissionsV2';
  name: Scalars['String'];
};

/** aggregated selection of "permissions_v2" */
export type PermissionsV2Aggregate = {
  __typename?: 'PermissionsV2Aggregate';
  aggregate?: Maybe<PermissionsV2AggregateFields>;
  nodes: Array<PermissionsV2>;
};

/** aggregate fields of "permissions_v2" */
export type PermissionsV2AggregateFields = {
  __typename?: 'PermissionsV2AggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PermissionsV2MaxFields>;
  min?: Maybe<PermissionsV2MinFields>;
};


/** aggregate fields of "permissions_v2" */
export type PermissionsV2AggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PermissionsV2SelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "permissions_v2". All fields are combined with a logical 'AND'. */
export type PermissionsV2BoolExp = {
  _and?: InputMaybe<Array<PermissionsV2BoolExp>>;
  _not?: InputMaybe<PermissionsV2BoolExp>;
  _or?: InputMaybe<Array<PermissionsV2BoolExp>>;
  name?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type PermissionsV2MaxFields = {
  __typename?: 'PermissionsV2MaxFields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PermissionsV2MinFields = {
  __typename?: 'PermissionsV2MinFields';
  name?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "permissions_v2". */
export type PermissionsV2OrderBy = {
  name?: InputMaybe<OrderBy>;
};

/** select columns of table "permissions_v2" */
export type PermissionsV2SelectColumn =
  /** column name */
  | 'name';

/** Streaming cursor of the table "permissions_v2" */
export type PermissionsV2StreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PermissionsV2StreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PermissionsV2StreamCursorValueInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "phone_numbers" */
export type PhoneNumbers = {
  __typename?: 'PhoneNumbers';
  companyGuid: Scalars['uuid'];
  /** An array relationship */
  contacts: Array<Contacts>;
  /** An array relationship */
  contactsAdditionalPhone: Array<Contacts>;
  /** An aggregate relationship */
  contactsAdditionalPhoneAggregate: ContactsAggregate;
  /** An aggregate relationship */
  contactsAggregate: ContactsAggregate;
  createdAt: Scalars['timestamptz'];
  phoneNumber: Scalars['String'];
  phoneNumberGuid: Scalars['uuid'];
  type: Scalars['PhoneNumberType'];
  unsubscribed: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  userPhoneNumbers: Array<UserPhoneNumbers>;
  /** An aggregate relationship */
  userPhoneNumbersAggregate: UserPhoneNumbersAggregate;
};


/** columns and relationships of "phone_numbers" */
export type PhoneNumbersContactsArgs = {
  distinctOn?: InputMaybe<Array<ContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
  where?: InputMaybe<ContactsBoolExp>;
};


/** columns and relationships of "phone_numbers" */
export type PhoneNumbersContactsAdditionalPhoneArgs = {
  distinctOn?: InputMaybe<Array<ContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
  where?: InputMaybe<ContactsBoolExp>;
};


/** columns and relationships of "phone_numbers" */
export type PhoneNumbersContactsAdditionalPhoneAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
  where?: InputMaybe<ContactsBoolExp>;
};


/** columns and relationships of "phone_numbers" */
export type PhoneNumbersContactsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
  where?: InputMaybe<ContactsBoolExp>;
};


/** columns and relationships of "phone_numbers" */
export type PhoneNumbersUserPhoneNumbersArgs = {
  distinctOn?: InputMaybe<Array<UserPhoneNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPhoneNumbersOrderBy>>;
  where?: InputMaybe<UserPhoneNumbersBoolExp>;
};


/** columns and relationships of "phone_numbers" */
export type PhoneNumbersUserPhoneNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPhoneNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPhoneNumbersOrderBy>>;
  where?: InputMaybe<UserPhoneNumbersBoolExp>;
};

/** aggregated selection of "phone_numbers" */
export type PhoneNumbersAggregate = {
  __typename?: 'PhoneNumbersAggregate';
  aggregate?: Maybe<PhoneNumbersAggregateFields>;
  nodes: Array<PhoneNumbers>;
};

/** aggregate fields of "phone_numbers" */
export type PhoneNumbersAggregateFields = {
  __typename?: 'PhoneNumbersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PhoneNumbersMaxFields>;
  min?: Maybe<PhoneNumbersMinFields>;
};


/** aggregate fields of "phone_numbers" */
export type PhoneNumbersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PhoneNumbersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "phone_numbers". All fields are combined with a logical 'AND'. */
export type PhoneNumbersBoolExp = {
  _and?: InputMaybe<Array<PhoneNumbersBoolExp>>;
  _not?: InputMaybe<PhoneNumbersBoolExp>;
  _or?: InputMaybe<Array<PhoneNumbersBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  contacts?: InputMaybe<ContactsBoolExp>;
  contactsAdditionalPhone?: InputMaybe<ContactsBoolExp>;
  contactsAdditionalPhoneAggregate?: InputMaybe<ContactsAggregateBoolExp>;
  contactsAggregate?: InputMaybe<ContactsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  phoneNumberGuid?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<Scalars['PhoneNumberTypeComparisonExp']>;
  unsubscribed?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userPhoneNumbers?: InputMaybe<UserPhoneNumbersBoolExp>;
  userPhoneNumbersAggregate?: InputMaybe<UserPhoneNumbersAggregateBoolExp>;
};

/** unique or primary key constraints on table "phone_numbers" */
export type PhoneNumbersConstraint =
  /** unique or primary key constraint on columns "phone_number_guid" */
  | 'phone_numbers_pkey';

/** input type for inserting data into table "phone_numbers" */
export type PhoneNumbersInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contacts?: InputMaybe<ContactsArrRelInsertInput>;
  contactsAdditionalPhone?: InputMaybe<ContactsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['PhoneNumberType']>;
  unsubscribed?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userPhoneNumbers?: InputMaybe<UserPhoneNumbersArrRelInsertInput>;
};

/** aggregate max on columns */
export type PhoneNumbersMaxFields = {
  __typename?: 'PhoneNumbersMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberGuid?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['PhoneNumberType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PhoneNumbersMinFields = {
  __typename?: 'PhoneNumbersMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberGuid?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['PhoneNumberType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "phone_numbers" */
export type PhoneNumbersMutationResponse = {
  __typename?: 'PhoneNumbersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PhoneNumbers>;
};

/** input type for inserting object relation for remote table "phone_numbers" */
export type PhoneNumbersObjRelInsertInput = {
  data: PhoneNumbersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PhoneNumbersOnConflict>;
};

/** on_conflict condition type for table "phone_numbers" */
export type PhoneNumbersOnConflict = {
  constraint: PhoneNumbersConstraint;
  updateColumns?: Array<PhoneNumbersUpdateColumn>;
  where?: InputMaybe<PhoneNumbersBoolExp>;
};

/** Ordering options when selecting data from "phone_numbers". */
export type PhoneNumbersOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  contactsAdditionalPhoneAggregate?: InputMaybe<ContactsAggregateOrderBy>;
  contactsAggregate?: InputMaybe<ContactsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneNumberGuid?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  unsubscribed?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userPhoneNumbersAggregate?: InputMaybe<UserPhoneNumbersAggregateOrderBy>;
};

/** primary key columns input for table: phone_numbers */
export type PhoneNumbersPkColumnsInput = {
  phoneNumberGuid: Scalars['uuid'];
};

/** select columns of table "phone_numbers" */
export type PhoneNumbersSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneNumberGuid'
  /** column name */
  | 'type'
  /** column name */
  | 'unsubscribed'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "phone_numbers" */
export type PhoneNumbersSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['PhoneNumberType']>;
  unsubscribed?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "phone_numbers" */
export type PhoneNumbersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PhoneNumbersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PhoneNumbersStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['PhoneNumberType']>;
  unsubscribed?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "phone_numbers" */
export type PhoneNumbersUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneNumberGuid'
  /** column name */
  | 'type'
  /** column name */
  | 'unsubscribed'
  /** column name */
  | 'updatedAt';

export type PhoneNumbersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PhoneNumbersSetInput>;
  /** filter the rows which have to be updated */
  where: PhoneNumbersBoolExp;
};

/** columns and relationships of "photo_links" */
export type PhotoLinks = {
  __typename?: 'PhotoLinks';
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  photo: Photos;
  photoGuid: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "photo_links" */
export type PhotoLinksAggregate = {
  __typename?: 'PhotoLinksAggregate';
  aggregate?: Maybe<PhotoLinksAggregateFields>;
  nodes: Array<PhotoLinks>;
};

export type PhotoLinksAggregateBoolExp = {
  count?: InputMaybe<PhotoLinksAggregateBoolExpCount>;
};

/** aggregate fields of "photo_links" */
export type PhotoLinksAggregateFields = {
  __typename?: 'PhotoLinksAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PhotoLinksMaxFields>;
  min?: Maybe<PhotoLinksMinFields>;
};


/** aggregate fields of "photo_links" */
export type PhotoLinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "photo_links" */
export type PhotoLinksAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PhotoLinksMaxOrderBy>;
  min?: InputMaybe<PhotoLinksMinOrderBy>;
};

/** input type for inserting array relation for remote table "photo_links" */
export type PhotoLinksArrRelInsertInput = {
  data: Array<PhotoLinksInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PhotoLinksOnConflict>;
};

/** Boolean expression to filter rows from the table "photo_links". All fields are combined with a logical 'AND'. */
export type PhotoLinksBoolExp = {
  _and?: InputMaybe<Array<PhotoLinksBoolExp>>;
  _not?: InputMaybe<PhotoLinksBoolExp>;
  _or?: InputMaybe<Array<PhotoLinksBoolExp>>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  jobAppointmentAssignmentGuid?: InputMaybe<UuidComparisonExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  locationGuid?: InputMaybe<UuidComparisonExp>;
  photo?: InputMaybe<PhotosBoolExp>;
  photoGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "photo_links" */
export type PhotoLinksConstraint =
  /** unique or primary key constraint on columns "photo_guid" */
  | 'photo_links_pkey';

/** input type for inserting data into table "photo_links" */
export type PhotoLinksInsertInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  photo?: InputMaybe<PhotosObjRelInsertInput>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PhotoLinksMaxFields = {
  __typename?: 'PhotoLinksMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "photo_links" */
export type PhotoLinksMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PhotoLinksMinFields = {
  __typename?: 'PhotoLinksMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  locationGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "photo_links" */
export type PhotoLinksMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "photo_links" */
export type PhotoLinksMutationResponse = {
  __typename?: 'PhotoLinksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PhotoLinks>;
};

/** on_conflict condition type for table "photo_links" */
export type PhotoLinksOnConflict = {
  constraint: PhotoLinksConstraint;
  updateColumns?: Array<PhotoLinksUpdateColumn>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};

/** Ordering options when selecting data from "photo_links". */
export type PhotoLinksOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  locationGuid?: InputMaybe<OrderBy>;
  photo?: InputMaybe<PhotosOrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: photo_links */
export type PhotoLinksPkColumnsInput = {
  photoGuid: Scalars['uuid'];
};

/** select columns of table "photo_links" */
export type PhotoLinksSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "photo_links" */
export type PhotoLinksSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "photo_links" */
export type PhotoLinksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PhotoLinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PhotoLinksStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  locationGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "photo_links" */
export type PhotoLinksUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'locationGuid'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'updatedAt';

export type PhotoLinksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PhotoLinksSetInput>;
  /** filter the rows which have to be updated */
  where: PhotoLinksBoolExp;
};

/** columns and relationships of "photos" */
export type Photos = {
  __typename?: 'Photos';
  cdnUrl: Scalars['String'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  /** An array relationship */
  noteLinks: Array<NoteLinks>;
  /** An aggregate relationship */
  noteLinksAggregate: NoteLinksAggregate;
  photoGuid: Scalars['uuid'];
  resourceUrn: Scalars['String'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "photos" */
export type PhotosNoteLinksArgs = {
  distinctOn?: InputMaybe<Array<NoteLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteLinksOrderBy>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};


/** columns and relationships of "photos" */
export type PhotosNoteLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteLinksOrderBy>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};

/** aggregated selection of "photos" */
export type PhotosAggregate = {
  __typename?: 'PhotosAggregate';
  aggregate?: Maybe<PhotosAggregateFields>;
  nodes: Array<Photos>;
};

/** aggregate fields of "photos" */
export type PhotosAggregateFields = {
  __typename?: 'PhotosAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PhotosMaxFields>;
  min?: Maybe<PhotosMinFields>;
};


/** aggregate fields of "photos" */
export type PhotosAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PhotosSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "photos". All fields are combined with a logical 'AND'. */
export type PhotosBoolExp = {
  _and?: InputMaybe<Array<PhotosBoolExp>>;
  _not?: InputMaybe<PhotosBoolExp>;
  _or?: InputMaybe<Array<PhotosBoolExp>>;
  cdnUrl?: InputMaybe<StringComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  noteLinks?: InputMaybe<NoteLinksBoolExp>;
  noteLinksAggregate?: InputMaybe<NoteLinksAggregateBoolExp>;
  photoGuid?: InputMaybe<UuidComparisonExp>;
  resourceUrn?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "photos" */
export type PhotosConstraint =
  /** unique or primary key constraint on columns "photo_guid" */
  | 'photos_pkey';

/** input type for inserting data into table "photos" */
export type PhotosInsertInput = {
  cdnUrl?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  noteLinks?: InputMaybe<NoteLinksArrRelInsertInput>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  resourceUrn?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type PhotosMaxFields = {
  __typename?: 'PhotosMaxFields';
  cdnUrl?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  resourceUrn?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type PhotosMinFields = {
  __typename?: 'PhotosMinFields';
  cdnUrl?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  resourceUrn?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "photos" */
export type PhotosMutationResponse = {
  __typename?: 'PhotosMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Photos>;
};

/** input type for inserting object relation for remote table "photos" */
export type PhotosObjRelInsertInput = {
  data: PhotosInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PhotosOnConflict>;
};

/** on_conflict condition type for table "photos" */
export type PhotosOnConflict = {
  constraint: PhotosConstraint;
  updateColumns?: Array<PhotosUpdateColumn>;
  where?: InputMaybe<PhotosBoolExp>;
};

/** Ordering options when selecting data from "photos". */
export type PhotosOrderBy = {
  cdnUrl?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  noteLinksAggregate?: InputMaybe<NoteLinksAggregateOrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  resourceUrn?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: photos */
export type PhotosPkColumnsInput = {
  photoGuid: Scalars['uuid'];
};

/** select columns of table "photos" */
export type PhotosSelectColumn =
  /** column name */
  | 'cdnUrl'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'resourceUrn';

/** input type for updating data in table "photos" */
export type PhotosSetInput = {
  cdnUrl?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  resourceUrn?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "photos" */
export type PhotosStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PhotosStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PhotosStreamCursorValueInput = {
  cdnUrl?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  resourceUrn?: InputMaybe<Scalars['String']>;
};

/** update columns of table "photos" */
export type PhotosUpdateColumn =
  /** column name */
  | 'cdnUrl'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'resourceUrn';

export type PhotosUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PhotosSetInput>;
  /** filter the rows which have to be updated */
  where: PhotosBoolExp;
};

/** columns and relationships of "pricebook_bundle_items" */
export type PricebookBundleItems = {
  __typename?: 'PricebookBundleItems';
  /** An object relationship */
  childPricebookItem: PricebookItems;
  childPricebookItemGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
  createdAt?: Maybe<Scalars['timestamptz']>;
  itemQuantity: Scalars['Int'];
  /** An object relationship */
  parentPricebookItem: PricebookItems;
  parentPricebookItemGuid: Scalars['uuid'];
  pricebookBundleItemGuid: Scalars['uuid'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "pricebook_bundle_items" */
export type PricebookBundleItemsAggregate = {
  __typename?: 'PricebookBundleItemsAggregate';
  aggregate?: Maybe<PricebookBundleItemsAggregateFields>;
  nodes: Array<PricebookBundleItems>;
};

/** aggregate fields of "pricebook_bundle_items" */
export type PricebookBundleItemsAggregateFields = {
  __typename?: 'PricebookBundleItemsAggregateFields';
  avg?: Maybe<PricebookBundleItemsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PricebookBundleItemsMaxFields>;
  min?: Maybe<PricebookBundleItemsMinFields>;
  stddev?: Maybe<PricebookBundleItemsStddevFields>;
  stddevPop?: Maybe<PricebookBundleItemsStddevPopFields>;
  stddevSamp?: Maybe<PricebookBundleItemsStddevSampFields>;
  sum?: Maybe<PricebookBundleItemsSumFields>;
  varPop?: Maybe<PricebookBundleItemsVarPopFields>;
  varSamp?: Maybe<PricebookBundleItemsVarSampFields>;
  variance?: Maybe<PricebookBundleItemsVarianceFields>;
};


/** aggregate fields of "pricebook_bundle_items" */
export type PricebookBundleItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PricebookBundleItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PricebookBundleItemsAvgFields = {
  __typename?: 'PricebookBundleItemsAvgFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pricebook_bundle_items". All fields are combined with a logical 'AND'. */
export type PricebookBundleItemsBoolExp = {
  _and?: InputMaybe<Array<PricebookBundleItemsBoolExp>>;
  _not?: InputMaybe<PricebookBundleItemsBoolExp>;
  _or?: InputMaybe<Array<PricebookBundleItemsBoolExp>>;
  childPricebookItem?: InputMaybe<PricebookItemsBoolExp>;
  childPricebookItemGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  itemQuantity?: InputMaybe<IntComparisonExp>;
  parentPricebookItem?: InputMaybe<PricebookItemsBoolExp>;
  parentPricebookItemGuid?: InputMaybe<UuidComparisonExp>;
  pricebookBundleItemGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "pricebook_bundle_items" */
export type PricebookBundleItemsConstraint =
  /** unique or primary key constraint on columns "pricebook_bundle_item_guid" */
  | 'pricebook_bundle_items_pkey'
  /** unique or primary key constraint on columns "child_pricebook_item_guid", "parent_pricebook_item_guid", "company_guid" */
  | 'pricebook_bundle_items_unique_parent_child';

/** input type for incrementing numeric columns in table "pricebook_bundle_items" */
export type PricebookBundleItemsIncInput = {
  itemQuantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pricebook_bundle_items" */
export type PricebookBundleItemsInsertInput = {
  childPricebookItem?: InputMaybe<PricebookItemsObjRelInsertInput>;
  childPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  itemQuantity?: InputMaybe<Scalars['Int']>;
  parentPricebookItem?: InputMaybe<PricebookItemsObjRelInsertInput>;
  parentPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  pricebookBundleItemGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PricebookBundleItemsMaxFields = {
  __typename?: 'PricebookBundleItemsMaxFields';
  childPricebookItemGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  itemQuantity?: Maybe<Scalars['Int']>;
  parentPricebookItemGuid?: Maybe<Scalars['uuid']>;
  pricebookBundleItemGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PricebookBundleItemsMinFields = {
  __typename?: 'PricebookBundleItemsMinFields';
  childPricebookItemGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  itemQuantity?: Maybe<Scalars['Int']>;
  parentPricebookItemGuid?: Maybe<Scalars['uuid']>;
  pricebookBundleItemGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pricebook_bundle_items" */
export type PricebookBundleItemsMutationResponse = {
  __typename?: 'PricebookBundleItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PricebookBundleItems>;
};

/** on_conflict condition type for table "pricebook_bundle_items" */
export type PricebookBundleItemsOnConflict = {
  constraint: PricebookBundleItemsConstraint;
  updateColumns?: Array<PricebookBundleItemsUpdateColumn>;
  where?: InputMaybe<PricebookBundleItemsBoolExp>;
};

/** Ordering options when selecting data from "pricebook_bundle_items". */
export type PricebookBundleItemsOrderBy = {
  childPricebookItem?: InputMaybe<PricebookItemsOrderBy>;
  childPricebookItemGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  itemQuantity?: InputMaybe<OrderBy>;
  parentPricebookItem?: InputMaybe<PricebookItemsOrderBy>;
  parentPricebookItemGuid?: InputMaybe<OrderBy>;
  pricebookBundleItemGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pricebook_bundle_items */
export type PricebookBundleItemsPkColumnsInput = {
  pricebookBundleItemGuid: Scalars['uuid'];
};

/** select columns of table "pricebook_bundle_items" */
export type PricebookBundleItemsSelectColumn =
  /** column name */
  | 'childPricebookItemGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'itemQuantity'
  /** column name */
  | 'parentPricebookItemGuid'
  /** column name */
  | 'pricebookBundleItemGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "pricebook_bundle_items" */
export type PricebookBundleItemsSetInput = {
  childPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  itemQuantity?: InputMaybe<Scalars['Int']>;
  parentPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  pricebookBundleItemGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PricebookBundleItemsStddevFields = {
  __typename?: 'PricebookBundleItemsStddevFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PricebookBundleItemsStddevPopFields = {
  __typename?: 'PricebookBundleItemsStddevPopFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PricebookBundleItemsStddevSampFields = {
  __typename?: 'PricebookBundleItemsStddevSampFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pricebook_bundle_items" */
export type PricebookBundleItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PricebookBundleItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PricebookBundleItemsStreamCursorValueInput = {
  childPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  itemQuantity?: InputMaybe<Scalars['Int']>;
  parentPricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  pricebookBundleItemGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PricebookBundleItemsSumFields = {
  __typename?: 'PricebookBundleItemsSumFields';
  itemQuantity?: Maybe<Scalars['Int']>;
};

/** update columns of table "pricebook_bundle_items" */
export type PricebookBundleItemsUpdateColumn =
  /** column name */
  | 'childPricebookItemGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'itemQuantity'
  /** column name */
  | 'parentPricebookItemGuid'
  /** column name */
  | 'pricebookBundleItemGuid'
  /** column name */
  | 'updatedAt';

export type PricebookBundleItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PricebookBundleItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PricebookBundleItemsSetInput>;
  /** filter the rows which have to be updated */
  where: PricebookBundleItemsBoolExp;
};

/** aggregate varPop on columns */
export type PricebookBundleItemsVarPopFields = {
  __typename?: 'PricebookBundleItemsVarPopFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PricebookBundleItemsVarSampFields = {
  __typename?: 'PricebookBundleItemsVarSampFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PricebookBundleItemsVarianceFields = {
  __typename?: 'PricebookBundleItemsVarianceFields';
  itemQuantity?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pricebook_categories" */
export type PricebookCategories = {
  __typename?: 'PricebookCategories';
  /** An array relationship */
  childPricebookCategories: Array<PricebookCategories>;
  /** An aggregate relationship */
  childPricebookCategoriesAggregate: PricebookCategoriesAggregate;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  name: Scalars['String'];
  parentCategoryGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  parentPricebookCategory?: Maybe<PricebookCategories>;
  /** An object relationship */
  photo?: Maybe<Photos>;
  photoGuid?: Maybe<Scalars['uuid']>;
  pricebookCategoryGuid: Scalars['uuid'];
  /** An array relationship */
  pricebookItems: Array<PricebookItems>;
  /** An aggregate relationship */
  pricebookItemsAggregate: PricebookItemsAggregate;
  /** An object relationship */
  sourcePhoto?: Maybe<Photos>;
  sourcePhotoGuid?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "pricebook_categories" */
export type PricebookCategoriesChildPricebookCategoriesArgs = {
  distinctOn?: InputMaybe<Array<PricebookCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookCategoriesOrderBy>>;
  where?: InputMaybe<PricebookCategoriesBoolExp>;
};


/** columns and relationships of "pricebook_categories" */
export type PricebookCategoriesChildPricebookCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookCategoriesOrderBy>>;
  where?: InputMaybe<PricebookCategoriesBoolExp>;
};


/** columns and relationships of "pricebook_categories" */
export type PricebookCategoriesPricebookItemsArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemsOrderBy>>;
  where?: InputMaybe<PricebookItemsBoolExp>;
};


/** columns and relationships of "pricebook_categories" */
export type PricebookCategoriesPricebookItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemsOrderBy>>;
  where?: InputMaybe<PricebookItemsBoolExp>;
};

/** aggregated selection of "pricebook_categories" */
export type PricebookCategoriesAggregate = {
  __typename?: 'PricebookCategoriesAggregate';
  aggregate?: Maybe<PricebookCategoriesAggregateFields>;
  nodes: Array<PricebookCategories>;
};

export type PricebookCategoriesAggregateBoolExp = {
  count?: InputMaybe<PricebookCategoriesAggregateBoolExpCount>;
};

/** aggregate fields of "pricebook_categories" */
export type PricebookCategoriesAggregateFields = {
  __typename?: 'PricebookCategoriesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PricebookCategoriesMaxFields>;
  min?: Maybe<PricebookCategoriesMinFields>;
};


/** aggregate fields of "pricebook_categories" */
export type PricebookCategoriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PricebookCategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pricebook_categories" */
export type PricebookCategoriesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PricebookCategoriesMaxOrderBy>;
  min?: InputMaybe<PricebookCategoriesMinOrderBy>;
};

/** input type for inserting array relation for remote table "pricebook_categories" */
export type PricebookCategoriesArrRelInsertInput = {
  data: Array<PricebookCategoriesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PricebookCategoriesOnConflict>;
};

/** Boolean expression to filter rows from the table "pricebook_categories". All fields are combined with a logical 'AND'. */
export type PricebookCategoriesBoolExp = {
  _and?: InputMaybe<Array<PricebookCategoriesBoolExp>>;
  _not?: InputMaybe<PricebookCategoriesBoolExp>;
  _or?: InputMaybe<Array<PricebookCategoriesBoolExp>>;
  childPricebookCategories?: InputMaybe<PricebookCategoriesBoolExp>;
  childPricebookCategoriesAggregate?: InputMaybe<PricebookCategoriesAggregateBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parentCategoryGuid?: InputMaybe<UuidComparisonExp>;
  parentPricebookCategory?: InputMaybe<PricebookCategoriesBoolExp>;
  photo?: InputMaybe<PhotosBoolExp>;
  photoGuid?: InputMaybe<UuidComparisonExp>;
  pricebookCategoryGuid?: InputMaybe<UuidComparisonExp>;
  pricebookItems?: InputMaybe<PricebookItemsBoolExp>;
  pricebookItemsAggregate?: InputMaybe<PricebookItemsAggregateBoolExp>;
  sourcePhoto?: InputMaybe<PhotosBoolExp>;
  sourcePhotoGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "pricebook_categories" */
export type PricebookCategoriesConstraint =
  /** unique or primary key constraint on columns "pricebook_category_guid" */
  | 'pricebook_categories_pkey';

/** input type for inserting data into table "pricebook_categories" */
export type PricebookCategoriesInsertInput = {
  childPricebookCategories?: InputMaybe<PricebookCategoriesArrRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parentCategoryGuid?: InputMaybe<Scalars['uuid']>;
  parentPricebookCategory?: InputMaybe<PricebookCategoriesObjRelInsertInput>;
  photo?: InputMaybe<PhotosObjRelInsertInput>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  pricebookCategoryGuid?: InputMaybe<Scalars['uuid']>;
  pricebookItems?: InputMaybe<PricebookItemsArrRelInsertInput>;
  sourcePhoto?: InputMaybe<PhotosObjRelInsertInput>;
  sourcePhotoGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PricebookCategoriesMaxFields = {
  __typename?: 'PricebookCategoriesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentCategoryGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  pricebookCategoryGuid?: Maybe<Scalars['uuid']>;
  sourcePhotoGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "pricebook_categories" */
export type PricebookCategoriesMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parentCategoryGuid?: InputMaybe<OrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  pricebookCategoryGuid?: InputMaybe<OrderBy>;
  sourcePhotoGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PricebookCategoriesMinFields = {
  __typename?: 'PricebookCategoriesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  parentCategoryGuid?: Maybe<Scalars['uuid']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  pricebookCategoryGuid?: Maybe<Scalars['uuid']>;
  sourcePhotoGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "pricebook_categories" */
export type PricebookCategoriesMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parentCategoryGuid?: InputMaybe<OrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  pricebookCategoryGuid?: InputMaybe<OrderBy>;
  sourcePhotoGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pricebook_categories" */
export type PricebookCategoriesMutationResponse = {
  __typename?: 'PricebookCategoriesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PricebookCategories>;
};

/** input type for inserting object relation for remote table "pricebook_categories" */
export type PricebookCategoriesObjRelInsertInput = {
  data: PricebookCategoriesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PricebookCategoriesOnConflict>;
};

/** on_conflict condition type for table "pricebook_categories" */
export type PricebookCategoriesOnConflict = {
  constraint: PricebookCategoriesConstraint;
  updateColumns?: Array<PricebookCategoriesUpdateColumn>;
  where?: InputMaybe<PricebookCategoriesBoolExp>;
};

/** Ordering options when selecting data from "pricebook_categories". */
export type PricebookCategoriesOrderBy = {
  childPricebookCategoriesAggregate?: InputMaybe<PricebookCategoriesAggregateOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parentCategoryGuid?: InputMaybe<OrderBy>;
  parentPricebookCategory?: InputMaybe<PricebookCategoriesOrderBy>;
  photo?: InputMaybe<PhotosOrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  pricebookCategoryGuid?: InputMaybe<OrderBy>;
  pricebookItemsAggregate?: InputMaybe<PricebookItemsAggregateOrderBy>;
  sourcePhoto?: InputMaybe<PhotosOrderBy>;
  sourcePhotoGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pricebook_categories */
export type PricebookCategoriesPkColumnsInput = {
  pricebookCategoryGuid: Scalars['uuid'];
};

/** select columns of table "pricebook_categories" */
export type PricebookCategoriesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'parentCategoryGuid'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'pricebookCategoryGuid'
  /** column name */
  | 'sourcePhotoGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "pricebook_categories" */
export type PricebookCategoriesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parentCategoryGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  pricebookCategoryGuid?: InputMaybe<Scalars['uuid']>;
  sourcePhotoGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "pricebook_categories" */
export type PricebookCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PricebookCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PricebookCategoriesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  parentCategoryGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  pricebookCategoryGuid?: InputMaybe<Scalars['uuid']>;
  sourcePhotoGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "pricebook_categories" */
export type PricebookCategoriesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'parentCategoryGuid'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'pricebookCategoryGuid'
  /** column name */
  | 'sourcePhotoGuid'
  /** column name */
  | 'updatedAt';

export type PricebookCategoriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PricebookCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: PricebookCategoriesBoolExp;
};

/** columns and relationships of "pricebook_discounts" */
export type PricebookDiscounts = {
  __typename?: 'PricebookDiscounts';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  description: Scalars['String'];
  discountAmountUsd?: Maybe<Scalars['numeric']>;
  discountRate?: Maybe<Scalars['numeric']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  pricebookDiscountGuid: Scalars['uuid'];
  type: Scalars['DiscountType'];
  updatedAt: Scalars['timestamptz'];
  version: Scalars['Int'];
};

/** aggregated selection of "pricebook_discounts" */
export type PricebookDiscountsAggregate = {
  __typename?: 'PricebookDiscountsAggregate';
  aggregate?: Maybe<PricebookDiscountsAggregateFields>;
  nodes: Array<PricebookDiscounts>;
};

/** aggregate fields of "pricebook_discounts" */
export type PricebookDiscountsAggregateFields = {
  __typename?: 'PricebookDiscountsAggregateFields';
  avg?: Maybe<PricebookDiscountsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PricebookDiscountsMaxFields>;
  min?: Maybe<PricebookDiscountsMinFields>;
  stddev?: Maybe<PricebookDiscountsStddevFields>;
  stddevPop?: Maybe<PricebookDiscountsStddevPopFields>;
  stddevSamp?: Maybe<PricebookDiscountsStddevSampFields>;
  sum?: Maybe<PricebookDiscountsSumFields>;
  varPop?: Maybe<PricebookDiscountsVarPopFields>;
  varSamp?: Maybe<PricebookDiscountsVarSampFields>;
  variance?: Maybe<PricebookDiscountsVarianceFields>;
};


/** aggregate fields of "pricebook_discounts" */
export type PricebookDiscountsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PricebookDiscountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PricebookDiscountsAvgFields = {
  __typename?: 'PricebookDiscountsAvgFields';
  discountAmountUsd?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pricebook_discounts". All fields are combined with a logical 'AND'. */
export type PricebookDiscountsBoolExp = {
  _and?: InputMaybe<Array<PricebookDiscountsBoolExp>>;
  _not?: InputMaybe<PricebookDiscountsBoolExp>;
  _or?: InputMaybe<Array<PricebookDiscountsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  discountAmountUsd?: InputMaybe<NumericComparisonExp>;
  discountRate?: InputMaybe<NumericComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  pricebookDiscountGuid?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<Scalars['DiscountTypeComparisonExp']>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "pricebook_discounts" */
export type PricebookDiscountsConstraint =
  /** unique or primary key constraint on columns "pricebook_discount_guid" */
  | 'pricebook_discounts_pkey';

/** input type for incrementing numeric columns in table "pricebook_discounts" */
export type PricebookDiscountsIncInput = {
  discountAmountUsd?: InputMaybe<Scalars['numeric']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pricebook_discounts" */
export type PricebookDiscountsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  discountAmountUsd?: InputMaybe<Scalars['numeric']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pricebookDiscountGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['DiscountType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type PricebookDiscountsMaxFields = {
  __typename?: 'PricebookDiscountsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  discountAmountUsd?: Maybe<Scalars['numeric']>;
  discountRate?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  pricebookDiscountGuid?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['DiscountType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type PricebookDiscountsMinFields = {
  __typename?: 'PricebookDiscountsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  discountAmountUsd?: Maybe<Scalars['numeric']>;
  discountRate?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  pricebookDiscountGuid?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['DiscountType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "pricebook_discounts" */
export type PricebookDiscountsMutationResponse = {
  __typename?: 'PricebookDiscountsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PricebookDiscounts>;
};

/** on_conflict condition type for table "pricebook_discounts" */
export type PricebookDiscountsOnConflict = {
  constraint: PricebookDiscountsConstraint;
  updateColumns?: Array<PricebookDiscountsUpdateColumn>;
  where?: InputMaybe<PricebookDiscountsBoolExp>;
};

/** Ordering options when selecting data from "pricebook_discounts". */
export type PricebookDiscountsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  discountAmountUsd?: InputMaybe<OrderBy>;
  discountRate?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pricebookDiscountGuid?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pricebook_discounts */
export type PricebookDiscountsPkColumnsInput = {
  pricebookDiscountGuid: Scalars['uuid'];
};

/** select columns of table "pricebook_discounts" */
export type PricebookDiscountsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'discountAmountUsd'
  /** column name */
  | 'discountRate'
  /** column name */
  | 'isActive'
  /** column name */
  | 'name'
  /** column name */
  | 'pricebookDiscountGuid'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'version';

/** input type for updating data in table "pricebook_discounts" */
export type PricebookDiscountsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  discountAmountUsd?: InputMaybe<Scalars['numeric']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pricebookDiscountGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['DiscountType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type PricebookDiscountsStddevFields = {
  __typename?: 'PricebookDiscountsStddevFields';
  discountAmountUsd?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PricebookDiscountsStddevPopFields = {
  __typename?: 'PricebookDiscountsStddevPopFields';
  discountAmountUsd?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PricebookDiscountsStddevSampFields = {
  __typename?: 'PricebookDiscountsStddevSampFields';
  discountAmountUsd?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pricebook_discounts" */
export type PricebookDiscountsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PricebookDiscountsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PricebookDiscountsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  discountAmountUsd?: InputMaybe<Scalars['numeric']>;
  discountRate?: InputMaybe<Scalars['numeric']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pricebookDiscountGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['DiscountType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type PricebookDiscountsSumFields = {
  __typename?: 'PricebookDiscountsSumFields';
  discountAmountUsd?: Maybe<Scalars['numeric']>;
  discountRate?: Maybe<Scalars['numeric']>;
  version?: Maybe<Scalars['Int']>;
};

/** update columns of table "pricebook_discounts" */
export type PricebookDiscountsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'discountAmountUsd'
  /** column name */
  | 'discountRate'
  /** column name */
  | 'isActive'
  /** column name */
  | 'name'
  /** column name */
  | 'pricebookDiscountGuid'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'version';

export type PricebookDiscountsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PricebookDiscountsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PricebookDiscountsSetInput>;
  /** filter the rows which have to be updated */
  where: PricebookDiscountsBoolExp;
};

/** aggregate varPop on columns */
export type PricebookDiscountsVarPopFields = {
  __typename?: 'PricebookDiscountsVarPopFields';
  discountAmountUsd?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PricebookDiscountsVarSampFields = {
  __typename?: 'PricebookDiscountsVarSampFields';
  discountAmountUsd?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PricebookDiscountsVarianceFields = {
  __typename?: 'PricebookDiscountsVarianceFields';
  discountAmountUsd?: Maybe<Scalars['Float']>;
  discountRate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** Table to manage the fallback photos for pricebook item photos base on their item type. */
export type PricebookItemTypeFallbackPhotos = {
  __typename?: 'PricebookItemTypeFallbackPhotos';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  itemType: Scalars['PricebookItemTypeEnum'];
  /** An object relationship */
  photo: Photos;
  photoGuid: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "pricebook_item_type_fallback_photos" */
export type PricebookItemTypeFallbackPhotosAggregate = {
  __typename?: 'PricebookItemTypeFallbackPhotosAggregate';
  aggregate?: Maybe<PricebookItemTypeFallbackPhotosAggregateFields>;
  nodes: Array<PricebookItemTypeFallbackPhotos>;
};

/** aggregate fields of "pricebook_item_type_fallback_photos" */
export type PricebookItemTypeFallbackPhotosAggregateFields = {
  __typename?: 'PricebookItemTypeFallbackPhotosAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PricebookItemTypeFallbackPhotosMaxFields>;
  min?: Maybe<PricebookItemTypeFallbackPhotosMinFields>;
};


/** aggregate fields of "pricebook_item_type_fallback_photos" */
export type PricebookItemTypeFallbackPhotosAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PricebookItemTypeFallbackPhotosSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "pricebook_item_type_fallback_photos". All fields are combined with a logical 'AND'. */
export type PricebookItemTypeFallbackPhotosBoolExp = {
  _and?: InputMaybe<Array<PricebookItemTypeFallbackPhotosBoolExp>>;
  _not?: InputMaybe<PricebookItemTypeFallbackPhotosBoolExp>;
  _or?: InputMaybe<Array<PricebookItemTypeFallbackPhotosBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  itemType?: InputMaybe<Scalars['PricebookItemTypeEnumComparisonExp']>;
  photo?: InputMaybe<PhotosBoolExp>;
  photoGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "pricebook_item_type_fallback_photos" */
export type PricebookItemTypeFallbackPhotosConstraint =
  /** unique or primary key constraint on columns "item_type", "company_guid" */
  | 'pricebook_item_type_fallback_photos_pkey';

/** input type for inserting data into table "pricebook_item_type_fallback_photos" */
export type PricebookItemTypeFallbackPhotosInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  itemType?: InputMaybe<Scalars['PricebookItemTypeEnum']>;
  photo?: InputMaybe<PhotosObjRelInsertInput>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PricebookItemTypeFallbackPhotosMaxFields = {
  __typename?: 'PricebookItemTypeFallbackPhotosMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  itemType?: Maybe<Scalars['PricebookItemTypeEnum']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PricebookItemTypeFallbackPhotosMinFields = {
  __typename?: 'PricebookItemTypeFallbackPhotosMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  itemType?: Maybe<Scalars['PricebookItemTypeEnum']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pricebook_item_type_fallback_photos" */
export type PricebookItemTypeFallbackPhotosMutationResponse = {
  __typename?: 'PricebookItemTypeFallbackPhotosMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PricebookItemTypeFallbackPhotos>;
};

/** on_conflict condition type for table "pricebook_item_type_fallback_photos" */
export type PricebookItemTypeFallbackPhotosOnConflict = {
  constraint: PricebookItemTypeFallbackPhotosConstraint;
  updateColumns?: Array<PricebookItemTypeFallbackPhotosUpdateColumn>;
  where?: InputMaybe<PricebookItemTypeFallbackPhotosBoolExp>;
};

/** Ordering options when selecting data from "pricebook_item_type_fallback_photos". */
export type PricebookItemTypeFallbackPhotosOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  photo?: InputMaybe<PhotosOrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pricebook_item_type_fallback_photos */
export type PricebookItemTypeFallbackPhotosPkColumnsInput = {
  companyGuid: Scalars['uuid'];
  itemType: Scalars['String'];
};

/** select columns of table "pricebook_item_type_fallback_photos" */
export type PricebookItemTypeFallbackPhotosSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'itemType'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "pricebook_item_type_fallback_photos" */
export type PricebookItemTypeFallbackPhotosSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  itemType?: InputMaybe<Scalars['PricebookItemTypeEnum']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "pricebook_item_type_fallback_photos" */
export type PricebookItemTypeFallbackPhotosStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PricebookItemTypeFallbackPhotosStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PricebookItemTypeFallbackPhotosStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  itemType?: InputMaybe<Scalars['PricebookItemTypeEnum']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "pricebook_item_type_fallback_photos" */
export type PricebookItemTypeFallbackPhotosUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'itemType'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'updatedAt';

export type PricebookItemTypeFallbackPhotosUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PricebookItemTypeFallbackPhotosSetInput>;
  /** filter the rows which have to be updated */
  where: PricebookItemTypeFallbackPhotosBoolExp;
};

/** columns and relationships of "pricebook_items" */
export type PricebookItems = {
  __typename?: 'PricebookItems';
  addonAfterhoursPriceUsc: Scalars['Int'];
  addonPriceUsc: Scalars['Int'];
  afterhoursPriceUsc: Scalars['Int'];
  basePriceUsc: Scalars['Int'];
  companyGuid: Scalars['uuid'];
  costUsd: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  customMarkupRate?: Maybe<Scalars['numeric']>;
  description: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isDiscountable: Scalars['Boolean'];
  isTaxable: Scalars['Boolean'];
  itemType: Scalars['PricebookItemTypeEnum'];
  memberAddonAfterhoursPriceUsc: Scalars['Int'];
  memberAddonPriceUsc: Scalars['Int'];
  memberAfterhoursPriceUsc: Scalars['Int'];
  memberPriceUsc: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  photo?: Maybe<Photos>;
  photoGuid?: Maybe<Scalars['uuid']>;
  priceUsd: Scalars['numeric'];
  /** An object relationship */
  pricebookCategory?: Maybe<PricebookCategories>;
  pricebookCategoryGuid?: Maybe<Scalars['uuid']>;
  pricebookItemCode?: Maybe<Scalars['String']>;
  pricebookItemGuid: Scalars['uuid'];
  /** An object relationship */
  pricebookItemsQboIncomeAccount?: Maybe<PricebookItemsQboIncomeAccounts>;
  pricingMode: Scalars['pricebook_pricing_mode'];
  /** An object relationship */
  sourcePhoto?: Maybe<Photos>;
  sourcePhotoGuid?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
  version: Scalars['Int'];
};

/** aggregated selection of "pricebook_items" */
export type PricebookItemsAggregate = {
  __typename?: 'PricebookItemsAggregate';
  aggregate?: Maybe<PricebookItemsAggregateFields>;
  nodes: Array<PricebookItems>;
};

export type PricebookItemsAggregateBoolExp = {
  bool_and?: InputMaybe<PricebookItemsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<PricebookItemsAggregateBoolExpBool_Or>;
  count?: InputMaybe<PricebookItemsAggregateBoolExpCount>;
};

/** aggregate fields of "pricebook_items" */
export type PricebookItemsAggregateFields = {
  __typename?: 'PricebookItemsAggregateFields';
  avg?: Maybe<PricebookItemsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PricebookItemsMaxFields>;
  min?: Maybe<PricebookItemsMinFields>;
  stddev?: Maybe<PricebookItemsStddevFields>;
  stddevPop?: Maybe<PricebookItemsStddevPopFields>;
  stddevSamp?: Maybe<PricebookItemsStddevSampFields>;
  sum?: Maybe<PricebookItemsSumFields>;
  varPop?: Maybe<PricebookItemsVarPopFields>;
  varSamp?: Maybe<PricebookItemsVarSampFields>;
  variance?: Maybe<PricebookItemsVarianceFields>;
};


/** aggregate fields of "pricebook_items" */
export type PricebookItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PricebookItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pricebook_items" */
export type PricebookItemsAggregateOrderBy = {
  avg?: InputMaybe<PricebookItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PricebookItemsMaxOrderBy>;
  min?: InputMaybe<PricebookItemsMinOrderBy>;
  stddev?: InputMaybe<PricebookItemsStddevOrderBy>;
  stddevPop?: InputMaybe<PricebookItemsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PricebookItemsStddevSampOrderBy>;
  sum?: InputMaybe<PricebookItemsSumOrderBy>;
  varPop?: InputMaybe<PricebookItemsVarPopOrderBy>;
  varSamp?: InputMaybe<PricebookItemsVarSampOrderBy>;
  variance?: InputMaybe<PricebookItemsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pricebook_items" */
export type PricebookItemsArrRelInsertInput = {
  data: Array<PricebookItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PricebookItemsOnConflict>;
};

/** aggregate avg on columns */
export type PricebookItemsAvgFields = {
  __typename?: 'PricebookItemsAvgFields';
  addonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  addonPriceUsc?: Maybe<Scalars['Float']>;
  afterhoursPriceUsc?: Maybe<Scalars['Float']>;
  basePriceUsc?: Maybe<Scalars['Float']>;
  costUsd?: Maybe<Scalars['Float']>;
  customMarkupRate?: Maybe<Scalars['Float']>;
  memberAddonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberAddonPriceUsc?: Maybe<Scalars['Float']>;
  memberAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberPriceUsc?: Maybe<Scalars['Float']>;
  priceUsd?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pricebook_items" */
export type PricebookItemsAvgOrderBy = {
  addonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  addonPriceUsc?: InputMaybe<OrderBy>;
  afterhoursPriceUsc?: InputMaybe<OrderBy>;
  basePriceUsc?: InputMaybe<OrderBy>;
  costUsd?: InputMaybe<OrderBy>;
  customMarkupRate?: InputMaybe<OrderBy>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberAddonPriceUsc?: InputMaybe<OrderBy>;
  memberAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberPriceUsc?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pricebook_items". All fields are combined with a logical 'AND'. */
export type PricebookItemsBoolExp = {
  _and?: InputMaybe<Array<PricebookItemsBoolExp>>;
  _not?: InputMaybe<PricebookItemsBoolExp>;
  _or?: InputMaybe<Array<PricebookItemsBoolExp>>;
  addonAfterhoursPriceUsc?: InputMaybe<IntComparisonExp>;
  addonPriceUsc?: InputMaybe<IntComparisonExp>;
  afterhoursPriceUsc?: InputMaybe<IntComparisonExp>;
  basePriceUsc?: InputMaybe<IntComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  costUsd?: InputMaybe<NumericComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  customMarkupRate?: InputMaybe<NumericComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  imageUrl?: InputMaybe<StringComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  isDeleted?: InputMaybe<BooleanComparisonExp>;
  isDiscountable?: InputMaybe<BooleanComparisonExp>;
  isTaxable?: InputMaybe<BooleanComparisonExp>;
  itemType?: InputMaybe<Scalars['PricebookItemTypeEnumComparisonExp']>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<IntComparisonExp>;
  memberAddonPriceUsc?: InputMaybe<IntComparisonExp>;
  memberAfterhoursPriceUsc?: InputMaybe<IntComparisonExp>;
  memberPriceUsc?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  photo?: InputMaybe<PhotosBoolExp>;
  photoGuid?: InputMaybe<UuidComparisonExp>;
  priceUsd?: InputMaybe<NumericComparisonExp>;
  pricebookCategory?: InputMaybe<PricebookCategoriesBoolExp>;
  pricebookCategoryGuid?: InputMaybe<UuidComparisonExp>;
  pricebookItemCode?: InputMaybe<StringComparisonExp>;
  pricebookItemGuid?: InputMaybe<UuidComparisonExp>;
  pricebookItemsQboIncomeAccount?: InputMaybe<PricebookItemsQboIncomeAccountsBoolExp>;
  pricingMode?: InputMaybe<PricebookPricingModeComparisonExp>;
  sourcePhoto?: InputMaybe<PhotosBoolExp>;
  sourcePhotoGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "pricebook_items" */
export type PricebookItemsConstraint =
  /** unique or primary key constraint on columns "pricebook_item_guid" */
  | 'pricebook_items_pkey';

/** input type for incrementing numeric columns in table "pricebook_items" */
export type PricebookItemsIncInput = {
  addonAfterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  addonPriceUsc?: InputMaybe<Scalars['Int']>;
  afterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  basePriceUsc?: InputMaybe<Scalars['Int']>;
  costUsd?: InputMaybe<Scalars['numeric']>;
  customMarkupRate?: InputMaybe<Scalars['numeric']>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  memberAddonPriceUsc?: InputMaybe<Scalars['Int']>;
  memberAfterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  memberPriceUsc?: InputMaybe<Scalars['Int']>;
  priceUsd?: InputMaybe<Scalars['numeric']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pricebook_items" */
export type PricebookItemsInsertInput = {
  addonAfterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  addonPriceUsc?: InputMaybe<Scalars['Int']>;
  afterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  basePriceUsc?: InputMaybe<Scalars['Int']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costUsd?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  customMarkupRate?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDiscountable?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Scalars['PricebookItemTypeEnum']>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  memberAddonPriceUsc?: InputMaybe<Scalars['Int']>;
  memberAfterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  memberPriceUsc?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<PhotosObjRelInsertInput>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  priceUsd?: InputMaybe<Scalars['numeric']>;
  pricebookCategory?: InputMaybe<PricebookCategoriesObjRelInsertInput>;
  pricebookCategoryGuid?: InputMaybe<Scalars['uuid']>;
  pricebookItemCode?: InputMaybe<Scalars['String']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  pricebookItemsQboIncomeAccount?: InputMaybe<PricebookItemsQboIncomeAccountsObjRelInsertInput>;
  pricingMode?: InputMaybe<Scalars['pricebook_pricing_mode']>;
  sourcePhoto?: InputMaybe<PhotosObjRelInsertInput>;
  sourcePhotoGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type PricebookItemsMaxFields = {
  __typename?: 'PricebookItemsMaxFields';
  addonAfterhoursPriceUsc?: Maybe<Scalars['Int']>;
  addonPriceUsc?: Maybe<Scalars['Int']>;
  afterhoursPriceUsc?: Maybe<Scalars['Int']>;
  basePriceUsc?: Maybe<Scalars['Int']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  costUsd?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  customMarkupRate?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  itemType?: Maybe<Scalars['PricebookItemTypeEnum']>;
  memberAddonAfterhoursPriceUsc?: Maybe<Scalars['Int']>;
  memberAddonPriceUsc?: Maybe<Scalars['Int']>;
  memberAfterhoursPriceUsc?: Maybe<Scalars['Int']>;
  memberPriceUsc?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  priceUsd?: Maybe<Scalars['numeric']>;
  pricebookCategoryGuid?: Maybe<Scalars['uuid']>;
  pricebookItemCode?: Maybe<Scalars['String']>;
  pricebookItemGuid?: Maybe<Scalars['uuid']>;
  pricingMode?: Maybe<Scalars['pricebook_pricing_mode']>;
  sourcePhotoGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "pricebook_items" */
export type PricebookItemsMaxOrderBy = {
  addonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  addonPriceUsc?: InputMaybe<OrderBy>;
  afterhoursPriceUsc?: InputMaybe<OrderBy>;
  basePriceUsc?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  costUsd?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  customMarkupRate?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  imageUrl?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberAddonPriceUsc?: InputMaybe<OrderBy>;
  memberAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberPriceUsc?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  pricebookCategoryGuid?: InputMaybe<OrderBy>;
  pricebookItemCode?: InputMaybe<OrderBy>;
  pricebookItemGuid?: InputMaybe<OrderBy>;
  pricingMode?: InputMaybe<OrderBy>;
  sourcePhotoGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PricebookItemsMinFields = {
  __typename?: 'PricebookItemsMinFields';
  addonAfterhoursPriceUsc?: Maybe<Scalars['Int']>;
  addonPriceUsc?: Maybe<Scalars['Int']>;
  afterhoursPriceUsc?: Maybe<Scalars['Int']>;
  basePriceUsc?: Maybe<Scalars['Int']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  costUsd?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  customMarkupRate?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  itemType?: Maybe<Scalars['PricebookItemTypeEnum']>;
  memberAddonAfterhoursPriceUsc?: Maybe<Scalars['Int']>;
  memberAddonPriceUsc?: Maybe<Scalars['Int']>;
  memberAfterhoursPriceUsc?: Maybe<Scalars['Int']>;
  memberPriceUsc?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  photoGuid?: Maybe<Scalars['uuid']>;
  priceUsd?: Maybe<Scalars['numeric']>;
  pricebookCategoryGuid?: Maybe<Scalars['uuid']>;
  pricebookItemCode?: Maybe<Scalars['String']>;
  pricebookItemGuid?: Maybe<Scalars['uuid']>;
  pricingMode?: Maybe<Scalars['pricebook_pricing_mode']>;
  sourcePhotoGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "pricebook_items" */
export type PricebookItemsMinOrderBy = {
  addonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  addonPriceUsc?: InputMaybe<OrderBy>;
  afterhoursPriceUsc?: InputMaybe<OrderBy>;
  basePriceUsc?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  costUsd?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  customMarkupRate?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  imageUrl?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberAddonPriceUsc?: InputMaybe<OrderBy>;
  memberAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberPriceUsc?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  pricebookCategoryGuid?: InputMaybe<OrderBy>;
  pricebookItemCode?: InputMaybe<OrderBy>;
  pricebookItemGuid?: InputMaybe<OrderBy>;
  pricingMode?: InputMaybe<OrderBy>;
  sourcePhotoGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pricebook_items" */
export type PricebookItemsMutationResponse = {
  __typename?: 'PricebookItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PricebookItems>;
};

/** input type for inserting object relation for remote table "pricebook_items" */
export type PricebookItemsObjRelInsertInput = {
  data: PricebookItemsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PricebookItemsOnConflict>;
};

/** on_conflict condition type for table "pricebook_items" */
export type PricebookItemsOnConflict = {
  constraint: PricebookItemsConstraint;
  updateColumns?: Array<PricebookItemsUpdateColumn>;
  where?: InputMaybe<PricebookItemsBoolExp>;
};

/** Ordering options when selecting data from "pricebook_items". */
export type PricebookItemsOrderBy = {
  addonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  addonPriceUsc?: InputMaybe<OrderBy>;
  afterhoursPriceUsc?: InputMaybe<OrderBy>;
  basePriceUsc?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  costUsd?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  customMarkupRate?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  imageUrl?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  isDeleted?: InputMaybe<OrderBy>;
  isDiscountable?: InputMaybe<OrderBy>;
  isTaxable?: InputMaybe<OrderBy>;
  itemType?: InputMaybe<OrderBy>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberAddonPriceUsc?: InputMaybe<OrderBy>;
  memberAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberPriceUsc?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  photo?: InputMaybe<PhotosOrderBy>;
  photoGuid?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  pricebookCategory?: InputMaybe<PricebookCategoriesOrderBy>;
  pricebookCategoryGuid?: InputMaybe<OrderBy>;
  pricebookItemCode?: InputMaybe<OrderBy>;
  pricebookItemGuid?: InputMaybe<OrderBy>;
  pricebookItemsQboIncomeAccount?: InputMaybe<PricebookItemsQboIncomeAccountsOrderBy>;
  pricingMode?: InputMaybe<OrderBy>;
  sourcePhoto?: InputMaybe<PhotosOrderBy>;
  sourcePhotoGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pricebook_items */
export type PricebookItemsPkColumnsInput = {
  pricebookItemGuid: Scalars['uuid'];
};

/** columns and relationships of "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccounts = {
  __typename?: 'PricebookItemsQboIncomeAccounts';
  createdAt: Scalars['timestamptz'];
  pricebookItemGuid: Scalars['uuid'];
  /** An object relationship */
  pricebook_item: PricebookItems;
  qboIncomeAccountId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccountsAggregate = {
  __typename?: 'PricebookItemsQboIncomeAccountsAggregate';
  aggregate?: Maybe<PricebookItemsQboIncomeAccountsAggregateFields>;
  nodes: Array<PricebookItemsQboIncomeAccounts>;
};

/** aggregate fields of "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccountsAggregateFields = {
  __typename?: 'PricebookItemsQboIncomeAccountsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PricebookItemsQboIncomeAccountsMaxFields>;
  min?: Maybe<PricebookItemsQboIncomeAccountsMinFields>;
};


/** aggregate fields of "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccountsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PricebookItemsQboIncomeAccountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "pricebook_items_qbo_income_accounts". All fields are combined with a logical 'AND'. */
export type PricebookItemsQboIncomeAccountsBoolExp = {
  _and?: InputMaybe<Array<PricebookItemsQboIncomeAccountsBoolExp>>;
  _not?: InputMaybe<PricebookItemsQboIncomeAccountsBoolExp>;
  _or?: InputMaybe<Array<PricebookItemsQboIncomeAccountsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  pricebookItemGuid?: InputMaybe<UuidComparisonExp>;
  pricebook_item?: InputMaybe<PricebookItemsBoolExp>;
  qboIncomeAccountId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccountsConstraint =
  /** unique or primary key constraint on columns "pricebook_item_guid" */
  | 'pricebook_items_qbo_income_accounts_pkey';

/** input type for inserting data into table "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccountsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  pricebook_item?: InputMaybe<PricebookItemsObjRelInsertInput>;
  qboIncomeAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PricebookItemsQboIncomeAccountsMaxFields = {
  __typename?: 'PricebookItemsQboIncomeAccountsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  pricebookItemGuid?: Maybe<Scalars['uuid']>;
  qboIncomeAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PricebookItemsQboIncomeAccountsMinFields = {
  __typename?: 'PricebookItemsQboIncomeAccountsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  pricebookItemGuid?: Maybe<Scalars['uuid']>;
  qboIncomeAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccountsMutationResponse = {
  __typename?: 'PricebookItemsQboIncomeAccountsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PricebookItemsQboIncomeAccounts>;
};

/** input type for inserting object relation for remote table "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccountsObjRelInsertInput = {
  data: PricebookItemsQboIncomeAccountsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PricebookItemsQboIncomeAccountsOnConflict>;
};

/** on_conflict condition type for table "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccountsOnConflict = {
  constraint: PricebookItemsQboIncomeAccountsConstraint;
  updateColumns?: Array<PricebookItemsQboIncomeAccountsUpdateColumn>;
  where?: InputMaybe<PricebookItemsQboIncomeAccountsBoolExp>;
};

/** Ordering options when selecting data from "pricebook_items_qbo_income_accounts". */
export type PricebookItemsQboIncomeAccountsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  pricebookItemGuid?: InputMaybe<OrderBy>;
  pricebook_item?: InputMaybe<PricebookItemsOrderBy>;
  qboIncomeAccountId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pricebook_items_qbo_income_accounts */
export type PricebookItemsQboIncomeAccountsPkColumnsInput = {
  pricebookItemGuid: Scalars['uuid'];
};

/** select columns of table "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccountsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'pricebookItemGuid'
  /** column name */
  | 'qboIncomeAccountId'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccountsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  qboIncomeAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccountsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PricebookItemsQboIncomeAccountsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PricebookItemsQboIncomeAccountsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  qboIncomeAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "pricebook_items_qbo_income_accounts" */
export type PricebookItemsQboIncomeAccountsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'pricebookItemGuid'
  /** column name */
  | 'qboIncomeAccountId'
  /** column name */
  | 'updatedAt';

export type PricebookItemsQboIncomeAccountsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PricebookItemsQboIncomeAccountsSetInput>;
  /** filter the rows which have to be updated */
  where: PricebookItemsQboIncomeAccountsBoolExp;
};

/** select columns of table "pricebook_items" */
export type PricebookItemsSelectColumn =
  /** column name */
  | 'addonAfterhoursPriceUsc'
  /** column name */
  | 'addonPriceUsc'
  /** column name */
  | 'afterhoursPriceUsc'
  /** column name */
  | 'basePriceUsc'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'costUsd'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'customMarkupRate'
  /** column name */
  | 'description'
  /** column name */
  | 'imageUrl'
  /** column name */
  | 'isActive'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'isDiscountable'
  /** column name */
  | 'isTaxable'
  /** column name */
  | 'itemType'
  /** column name */
  | 'memberAddonAfterhoursPriceUsc'
  /** column name */
  | 'memberAddonPriceUsc'
  /** column name */
  | 'memberAfterhoursPriceUsc'
  /** column name */
  | 'memberPriceUsc'
  /** column name */
  | 'name'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'priceUsd'
  /** column name */
  | 'pricebookCategoryGuid'
  /** column name */
  | 'pricebookItemCode'
  /** column name */
  | 'pricebookItemGuid'
  /** column name */
  | 'pricingMode'
  /** column name */
  | 'sourcePhotoGuid'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'version';

/** select "pricebookItemsAggregateBoolExpBool_andArgumentsColumns" columns of table "pricebook_items" */
export type PricebookItemsSelectColumnPricebookItemsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isActive'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'isDiscountable'
  /** column name */
  | 'isTaxable';

/** select "pricebookItemsAggregateBoolExpBool_orArgumentsColumns" columns of table "pricebook_items" */
export type PricebookItemsSelectColumnPricebookItemsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isActive'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'isDiscountable'
  /** column name */
  | 'isTaxable';

/** input type for updating data in table "pricebook_items" */
export type PricebookItemsSetInput = {
  addonAfterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  addonPriceUsc?: InputMaybe<Scalars['Int']>;
  afterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  basePriceUsc?: InputMaybe<Scalars['Int']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costUsd?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  customMarkupRate?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDiscountable?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Scalars['PricebookItemTypeEnum']>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  memberAddonPriceUsc?: InputMaybe<Scalars['Int']>;
  memberAfterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  memberPriceUsc?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  priceUsd?: InputMaybe<Scalars['numeric']>;
  pricebookCategoryGuid?: InputMaybe<Scalars['uuid']>;
  pricebookItemCode?: InputMaybe<Scalars['String']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  pricingMode?: InputMaybe<Scalars['pricebook_pricing_mode']>;
  sourcePhotoGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type PricebookItemsStddevFields = {
  __typename?: 'PricebookItemsStddevFields';
  addonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  addonPriceUsc?: Maybe<Scalars['Float']>;
  afterhoursPriceUsc?: Maybe<Scalars['Float']>;
  basePriceUsc?: Maybe<Scalars['Float']>;
  costUsd?: Maybe<Scalars['Float']>;
  customMarkupRate?: Maybe<Scalars['Float']>;
  memberAddonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberAddonPriceUsc?: Maybe<Scalars['Float']>;
  memberAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberPriceUsc?: Maybe<Scalars['Float']>;
  priceUsd?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pricebook_items" */
export type PricebookItemsStddevOrderBy = {
  addonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  addonPriceUsc?: InputMaybe<OrderBy>;
  afterhoursPriceUsc?: InputMaybe<OrderBy>;
  basePriceUsc?: InputMaybe<OrderBy>;
  costUsd?: InputMaybe<OrderBy>;
  customMarkupRate?: InputMaybe<OrderBy>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberAddonPriceUsc?: InputMaybe<OrderBy>;
  memberAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberPriceUsc?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PricebookItemsStddevPopFields = {
  __typename?: 'PricebookItemsStddevPopFields';
  addonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  addonPriceUsc?: Maybe<Scalars['Float']>;
  afterhoursPriceUsc?: Maybe<Scalars['Float']>;
  basePriceUsc?: Maybe<Scalars['Float']>;
  costUsd?: Maybe<Scalars['Float']>;
  customMarkupRate?: Maybe<Scalars['Float']>;
  memberAddonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberAddonPriceUsc?: Maybe<Scalars['Float']>;
  memberAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberPriceUsc?: Maybe<Scalars['Float']>;
  priceUsd?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pricebook_items" */
export type PricebookItemsStddevPopOrderBy = {
  addonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  addonPriceUsc?: InputMaybe<OrderBy>;
  afterhoursPriceUsc?: InputMaybe<OrderBy>;
  basePriceUsc?: InputMaybe<OrderBy>;
  costUsd?: InputMaybe<OrderBy>;
  customMarkupRate?: InputMaybe<OrderBy>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberAddonPriceUsc?: InputMaybe<OrderBy>;
  memberAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberPriceUsc?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PricebookItemsStddevSampFields = {
  __typename?: 'PricebookItemsStddevSampFields';
  addonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  addonPriceUsc?: Maybe<Scalars['Float']>;
  afterhoursPriceUsc?: Maybe<Scalars['Float']>;
  basePriceUsc?: Maybe<Scalars['Float']>;
  costUsd?: Maybe<Scalars['Float']>;
  customMarkupRate?: Maybe<Scalars['Float']>;
  memberAddonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberAddonPriceUsc?: Maybe<Scalars['Float']>;
  memberAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberPriceUsc?: Maybe<Scalars['Float']>;
  priceUsd?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pricebook_items" */
export type PricebookItemsStddevSampOrderBy = {
  addonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  addonPriceUsc?: InputMaybe<OrderBy>;
  afterhoursPriceUsc?: InputMaybe<OrderBy>;
  basePriceUsc?: InputMaybe<OrderBy>;
  costUsd?: InputMaybe<OrderBy>;
  customMarkupRate?: InputMaybe<OrderBy>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberAddonPriceUsc?: InputMaybe<OrderBy>;
  memberAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberPriceUsc?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pricebook_items" */
export type PricebookItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PricebookItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PricebookItemsStreamCursorValueInput = {
  addonAfterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  addonPriceUsc?: InputMaybe<Scalars['Int']>;
  afterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  basePriceUsc?: InputMaybe<Scalars['Int']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costUsd?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  customMarkupRate?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isDiscountable?: InputMaybe<Scalars['Boolean']>;
  isTaxable?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Scalars['PricebookItemTypeEnum']>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  memberAddonPriceUsc?: InputMaybe<Scalars['Int']>;
  memberAfterhoursPriceUsc?: InputMaybe<Scalars['Int']>;
  memberPriceUsc?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
  priceUsd?: InputMaybe<Scalars['numeric']>;
  pricebookCategoryGuid?: InputMaybe<Scalars['uuid']>;
  pricebookItemCode?: InputMaybe<Scalars['String']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  pricingMode?: InputMaybe<Scalars['pricebook_pricing_mode']>;
  sourcePhotoGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type PricebookItemsSumFields = {
  __typename?: 'PricebookItemsSumFields';
  addonAfterhoursPriceUsc?: Maybe<Scalars['Int']>;
  addonPriceUsc?: Maybe<Scalars['Int']>;
  afterhoursPriceUsc?: Maybe<Scalars['Int']>;
  basePriceUsc?: Maybe<Scalars['Int']>;
  costUsd?: Maybe<Scalars['numeric']>;
  customMarkupRate?: Maybe<Scalars['numeric']>;
  memberAddonAfterhoursPriceUsc?: Maybe<Scalars['Int']>;
  memberAddonPriceUsc?: Maybe<Scalars['Int']>;
  memberAfterhoursPriceUsc?: Maybe<Scalars['Int']>;
  memberPriceUsc?: Maybe<Scalars['Int']>;
  priceUsd?: Maybe<Scalars['numeric']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pricebook_items" */
export type PricebookItemsSumOrderBy = {
  addonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  addonPriceUsc?: InputMaybe<OrderBy>;
  afterhoursPriceUsc?: InputMaybe<OrderBy>;
  basePriceUsc?: InputMaybe<OrderBy>;
  costUsd?: InputMaybe<OrderBy>;
  customMarkupRate?: InputMaybe<OrderBy>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberAddonPriceUsc?: InputMaybe<OrderBy>;
  memberAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberPriceUsc?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** update columns of table "pricebook_items" */
export type PricebookItemsUpdateColumn =
  /** column name */
  | 'addonAfterhoursPriceUsc'
  /** column name */
  | 'addonPriceUsc'
  /** column name */
  | 'afterhoursPriceUsc'
  /** column name */
  | 'basePriceUsc'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'costUsd'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'customMarkupRate'
  /** column name */
  | 'description'
  /** column name */
  | 'imageUrl'
  /** column name */
  | 'isActive'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'isDiscountable'
  /** column name */
  | 'isTaxable'
  /** column name */
  | 'itemType'
  /** column name */
  | 'memberAddonAfterhoursPriceUsc'
  /** column name */
  | 'memberAddonPriceUsc'
  /** column name */
  | 'memberAfterhoursPriceUsc'
  /** column name */
  | 'memberPriceUsc'
  /** column name */
  | 'name'
  /** column name */
  | 'photoGuid'
  /** column name */
  | 'priceUsd'
  /** column name */
  | 'pricebookCategoryGuid'
  /** column name */
  | 'pricebookItemCode'
  /** column name */
  | 'pricebookItemGuid'
  /** column name */
  | 'pricingMode'
  /** column name */
  | 'sourcePhotoGuid'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'version';

export type PricebookItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PricebookItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PricebookItemsSetInput>;
  /** filter the rows which have to be updated */
  where: PricebookItemsBoolExp;
};

/** aggregate varPop on columns */
export type PricebookItemsVarPopFields = {
  __typename?: 'PricebookItemsVarPopFields';
  addonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  addonPriceUsc?: Maybe<Scalars['Float']>;
  afterhoursPriceUsc?: Maybe<Scalars['Float']>;
  basePriceUsc?: Maybe<Scalars['Float']>;
  costUsd?: Maybe<Scalars['Float']>;
  customMarkupRate?: Maybe<Scalars['Float']>;
  memberAddonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberAddonPriceUsc?: Maybe<Scalars['Float']>;
  memberAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberPriceUsc?: Maybe<Scalars['Float']>;
  priceUsd?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pricebook_items" */
export type PricebookItemsVarPopOrderBy = {
  addonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  addonPriceUsc?: InputMaybe<OrderBy>;
  afterhoursPriceUsc?: InputMaybe<OrderBy>;
  basePriceUsc?: InputMaybe<OrderBy>;
  costUsd?: InputMaybe<OrderBy>;
  customMarkupRate?: InputMaybe<OrderBy>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberAddonPriceUsc?: InputMaybe<OrderBy>;
  memberAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberPriceUsc?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PricebookItemsVarSampFields = {
  __typename?: 'PricebookItemsVarSampFields';
  addonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  addonPriceUsc?: Maybe<Scalars['Float']>;
  afterhoursPriceUsc?: Maybe<Scalars['Float']>;
  basePriceUsc?: Maybe<Scalars['Float']>;
  costUsd?: Maybe<Scalars['Float']>;
  customMarkupRate?: Maybe<Scalars['Float']>;
  memberAddonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberAddonPriceUsc?: Maybe<Scalars['Float']>;
  memberAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberPriceUsc?: Maybe<Scalars['Float']>;
  priceUsd?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pricebook_items" */
export type PricebookItemsVarSampOrderBy = {
  addonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  addonPriceUsc?: InputMaybe<OrderBy>;
  afterhoursPriceUsc?: InputMaybe<OrderBy>;
  basePriceUsc?: InputMaybe<OrderBy>;
  costUsd?: InputMaybe<OrderBy>;
  customMarkupRate?: InputMaybe<OrderBy>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberAddonPriceUsc?: InputMaybe<OrderBy>;
  memberAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberPriceUsc?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PricebookItemsVarianceFields = {
  __typename?: 'PricebookItemsVarianceFields';
  addonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  addonPriceUsc?: Maybe<Scalars['Float']>;
  afterhoursPriceUsc?: Maybe<Scalars['Float']>;
  basePriceUsc?: Maybe<Scalars['Float']>;
  costUsd?: Maybe<Scalars['Float']>;
  customMarkupRate?: Maybe<Scalars['Float']>;
  memberAddonAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberAddonPriceUsc?: Maybe<Scalars['Float']>;
  memberAfterhoursPriceUsc?: Maybe<Scalars['Float']>;
  memberPriceUsc?: Maybe<Scalars['Float']>;
  priceUsd?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pricebook_items" */
export type PricebookItemsVarianceOrderBy = {
  addonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  addonPriceUsc?: InputMaybe<OrderBy>;
  afterhoursPriceUsc?: InputMaybe<OrderBy>;
  basePriceUsc?: InputMaybe<OrderBy>;
  costUsd?: InputMaybe<OrderBy>;
  customMarkupRate?: InputMaybe<OrderBy>;
  memberAddonAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberAddonPriceUsc?: InputMaybe<OrderBy>;
  memberAfterhoursPriceUsc?: InputMaybe<OrderBy>;
  memberPriceUsc?: InputMaybe<OrderBy>;
  priceUsd?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** columns and relationships of "pricebook_markup_tiers" */
export type PricebookMarkupTiers = {
  __typename?: 'PricebookMarkupTiers';
  companyGuid: Scalars['uuid'];
  costRangeEndInclusiveUsc?: Maybe<Scalars['bigint']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  markupRate: Scalars['numeric'];
  pricebookMarkupTierGuid: Scalars['uuid'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "pricebook_markup_tiers" */
export type PricebookMarkupTiersAggregate = {
  __typename?: 'PricebookMarkupTiersAggregate';
  aggregate?: Maybe<PricebookMarkupTiersAggregateFields>;
  nodes: Array<PricebookMarkupTiers>;
};

/** aggregate fields of "pricebook_markup_tiers" */
export type PricebookMarkupTiersAggregateFields = {
  __typename?: 'PricebookMarkupTiersAggregateFields';
  avg?: Maybe<PricebookMarkupTiersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PricebookMarkupTiersMaxFields>;
  min?: Maybe<PricebookMarkupTiersMinFields>;
  stddev?: Maybe<PricebookMarkupTiersStddevFields>;
  stddevPop?: Maybe<PricebookMarkupTiersStddevPopFields>;
  stddevSamp?: Maybe<PricebookMarkupTiersStddevSampFields>;
  sum?: Maybe<PricebookMarkupTiersSumFields>;
  varPop?: Maybe<PricebookMarkupTiersVarPopFields>;
  varSamp?: Maybe<PricebookMarkupTiersVarSampFields>;
  variance?: Maybe<PricebookMarkupTiersVarianceFields>;
};


/** aggregate fields of "pricebook_markup_tiers" */
export type PricebookMarkupTiersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PricebookMarkupTiersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PricebookMarkupTiersAvgFields = {
  __typename?: 'PricebookMarkupTiersAvgFields';
  costRangeEndInclusiveUsc?: Maybe<Scalars['Float']>;
  markupRate?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pricebook_markup_tiers". All fields are combined with a logical 'AND'. */
export type PricebookMarkupTiersBoolExp = {
  _and?: InputMaybe<Array<PricebookMarkupTiersBoolExp>>;
  _not?: InputMaybe<PricebookMarkupTiersBoolExp>;
  _or?: InputMaybe<Array<PricebookMarkupTiersBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  costRangeEndInclusiveUsc?: InputMaybe<BigintComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  markupRate?: InputMaybe<NumericComparisonExp>;
  pricebookMarkupTierGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "pricebook_markup_tiers" */
export type PricebookMarkupTiersConstraint =
  /** unique or primary key constraint on columns "cost_range_end_inclusive_usc", "company_guid" */
  | 'pricebook_markup_tiers_no_overlap_idx'
  /** unique or primary key constraint on columns "pricebook_markup_tier_guid" */
  | 'pricebook_markup_tiers_pkey';

/** input type for incrementing numeric columns in table "pricebook_markup_tiers" */
export type PricebookMarkupTiersIncInput = {
  costRangeEndInclusiveUsc?: InputMaybe<Scalars['bigint']>;
  markupRate?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "pricebook_markup_tiers" */
export type PricebookMarkupTiersInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costRangeEndInclusiveUsc?: InputMaybe<Scalars['bigint']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  markupRate?: InputMaybe<Scalars['numeric']>;
  pricebookMarkupTierGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PricebookMarkupTiersMaxFields = {
  __typename?: 'PricebookMarkupTiersMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  costRangeEndInclusiveUsc?: Maybe<Scalars['bigint']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  markupRate?: Maybe<Scalars['numeric']>;
  pricebookMarkupTierGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type PricebookMarkupTiersMinFields = {
  __typename?: 'PricebookMarkupTiersMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  costRangeEndInclusiveUsc?: Maybe<Scalars['bigint']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  markupRate?: Maybe<Scalars['numeric']>;
  pricebookMarkupTierGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "pricebook_markup_tiers" */
export type PricebookMarkupTiersMutationResponse = {
  __typename?: 'PricebookMarkupTiersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PricebookMarkupTiers>;
};

/** on_conflict condition type for table "pricebook_markup_tiers" */
export type PricebookMarkupTiersOnConflict = {
  constraint: PricebookMarkupTiersConstraint;
  updateColumns?: Array<PricebookMarkupTiersUpdateColumn>;
  where?: InputMaybe<PricebookMarkupTiersBoolExp>;
};

/** Ordering options when selecting data from "pricebook_markup_tiers". */
export type PricebookMarkupTiersOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  costRangeEndInclusiveUsc?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  markupRate?: InputMaybe<OrderBy>;
  pricebookMarkupTierGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pricebook_markup_tiers */
export type PricebookMarkupTiersPkColumnsInput = {
  pricebookMarkupTierGuid: Scalars['uuid'];
};

/** select columns of table "pricebook_markup_tiers" */
export type PricebookMarkupTiersSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'costRangeEndInclusiveUsc'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'markupRate'
  /** column name */
  | 'pricebookMarkupTierGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "pricebook_markup_tiers" */
export type PricebookMarkupTiersSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costRangeEndInclusiveUsc?: InputMaybe<Scalars['bigint']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  markupRate?: InputMaybe<Scalars['numeric']>;
  pricebookMarkupTierGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type PricebookMarkupTiersStddevFields = {
  __typename?: 'PricebookMarkupTiersStddevFields';
  costRangeEndInclusiveUsc?: Maybe<Scalars['Float']>;
  markupRate?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PricebookMarkupTiersStddevPopFields = {
  __typename?: 'PricebookMarkupTiersStddevPopFields';
  costRangeEndInclusiveUsc?: Maybe<Scalars['Float']>;
  markupRate?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PricebookMarkupTiersStddevSampFields = {
  __typename?: 'PricebookMarkupTiersStddevSampFields';
  costRangeEndInclusiveUsc?: Maybe<Scalars['Float']>;
  markupRate?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pricebook_markup_tiers" */
export type PricebookMarkupTiersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PricebookMarkupTiersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PricebookMarkupTiersStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  costRangeEndInclusiveUsc?: InputMaybe<Scalars['bigint']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  markupRate?: InputMaybe<Scalars['numeric']>;
  pricebookMarkupTierGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type PricebookMarkupTiersSumFields = {
  __typename?: 'PricebookMarkupTiersSumFields';
  costRangeEndInclusiveUsc?: Maybe<Scalars['bigint']>;
  markupRate?: Maybe<Scalars['numeric']>;
};

/** update columns of table "pricebook_markup_tiers" */
export type PricebookMarkupTiersUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'costRangeEndInclusiveUsc'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'markupRate'
  /** column name */
  | 'pricebookMarkupTierGuid'
  /** column name */
  | 'updatedAt';

export type PricebookMarkupTiersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PricebookMarkupTiersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PricebookMarkupTiersSetInput>;
  /** filter the rows which have to be updated */
  where: PricebookMarkupTiersBoolExp;
};

/** aggregate varPop on columns */
export type PricebookMarkupTiersVarPopFields = {
  __typename?: 'PricebookMarkupTiersVarPopFields';
  costRangeEndInclusiveUsc?: Maybe<Scalars['Float']>;
  markupRate?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PricebookMarkupTiersVarSampFields = {
  __typename?: 'PricebookMarkupTiersVarSampFields';
  costRangeEndInclusiveUsc?: Maybe<Scalars['Float']>;
  markupRate?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PricebookMarkupTiersVarianceFields = {
  __typename?: 'PricebookMarkupTiersVarianceFields';
  costRangeEndInclusiveUsc?: Maybe<Scalars['Float']>;
  markupRate?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "pricebook_pricing_mode". All fields are combined with logical 'AND'. */
export type PricebookPricingModeComparisonExp = {
  _eq?: InputMaybe<Scalars['pricebook_pricing_mode']>;
  _gt?: InputMaybe<Scalars['pricebook_pricing_mode']>;
  _gte?: InputMaybe<Scalars['pricebook_pricing_mode']>;
  _in?: InputMaybe<Array<Scalars['pricebook_pricing_mode']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['pricebook_pricing_mode']>;
  _lte?: InputMaybe<Scalars['pricebook_pricing_mode']>;
  _neq?: InputMaybe<Scalars['pricebook_pricing_mode']>;
  _nin?: InputMaybe<Array<Scalars['pricebook_pricing_mode']>>;
};

/** columns and relationships of "pricebook_tax_rates" */
export type PricebookTaxRates = {
  __typename?: 'PricebookTaxRates';
  accountTypes?: Maybe<Scalars['AccountTypeArray']>;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  pricebookTaxRateGuid: Scalars['uuid'];
  rate: Scalars['numeric'];
  updatedAt: Scalars['timestamptz'];
  version: Scalars['Int'];
  zipCodes?: Maybe<Array<Scalars['String']>>;
};

/** aggregated selection of "pricebook_tax_rates" */
export type PricebookTaxRatesAggregate = {
  __typename?: 'PricebookTaxRatesAggregate';
  aggregate?: Maybe<PricebookTaxRatesAggregateFields>;
  nodes: Array<PricebookTaxRates>;
};

export type PricebookTaxRatesAggregateBoolExp = {
  bool_and?: InputMaybe<PricebookTaxRatesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<PricebookTaxRatesAggregateBoolExpBool_Or>;
  count?: InputMaybe<PricebookTaxRatesAggregateBoolExpCount>;
};

/** aggregate fields of "pricebook_tax_rates" */
export type PricebookTaxRatesAggregateFields = {
  __typename?: 'PricebookTaxRatesAggregateFields';
  avg?: Maybe<PricebookTaxRatesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PricebookTaxRatesMaxFields>;
  min?: Maybe<PricebookTaxRatesMinFields>;
  stddev?: Maybe<PricebookTaxRatesStddevFields>;
  stddevPop?: Maybe<PricebookTaxRatesStddevPopFields>;
  stddevSamp?: Maybe<PricebookTaxRatesStddevSampFields>;
  sum?: Maybe<PricebookTaxRatesSumFields>;
  varPop?: Maybe<PricebookTaxRatesVarPopFields>;
  varSamp?: Maybe<PricebookTaxRatesVarSampFields>;
  variance?: Maybe<PricebookTaxRatesVarianceFields>;
};


/** aggregate fields of "pricebook_tax_rates" */
export type PricebookTaxRatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PricebookTaxRatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pricebook_tax_rates" */
export type PricebookTaxRatesAggregateOrderBy = {
  avg?: InputMaybe<PricebookTaxRatesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PricebookTaxRatesMaxOrderBy>;
  min?: InputMaybe<PricebookTaxRatesMinOrderBy>;
  stddev?: InputMaybe<PricebookTaxRatesStddevOrderBy>;
  stddevPop?: InputMaybe<PricebookTaxRatesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PricebookTaxRatesStddevSampOrderBy>;
  sum?: InputMaybe<PricebookTaxRatesSumOrderBy>;
  varPop?: InputMaybe<PricebookTaxRatesVarPopOrderBy>;
  varSamp?: InputMaybe<PricebookTaxRatesVarSampOrderBy>;
  variance?: InputMaybe<PricebookTaxRatesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "pricebook_tax_rates" */
export type PricebookTaxRatesArrRelInsertInput = {
  data: Array<PricebookTaxRatesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PricebookTaxRatesOnConflict>;
};

/** aggregate avg on columns */
export type PricebookTaxRatesAvgFields = {
  __typename?: 'PricebookTaxRatesAvgFields';
  rate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesAvgOrderBy = {
  rate?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "pricebook_tax_rates". All fields are combined with a logical 'AND'. */
export type PricebookTaxRatesBoolExp = {
  _and?: InputMaybe<Array<PricebookTaxRatesBoolExp>>;
  _not?: InputMaybe<PricebookTaxRatesBoolExp>;
  _or?: InputMaybe<Array<PricebookTaxRatesBoolExp>>;
  accountTypes?: InputMaybe<Scalars['AccountTypeArrayComparisonExp']>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  pricebookTaxRateGuid?: InputMaybe<UuidComparisonExp>;
  rate?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
  zipCodes?: InputMaybe<StringArrayComparisonExp>;
};

/** unique or primary key constraints on table "pricebook_tax_rates" */
export type PricebookTaxRatesConstraint =
  /** unique or primary key constraint on columns "pricebook_tax_rate_guid" */
  | 'pricebook_tax_rates_pkey';

/** input type for incrementing numeric columns in table "pricebook_tax_rates" */
export type PricebookTaxRatesIncInput = {
  rate?: InputMaybe<Scalars['numeric']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pricebook_tax_rates" */
export type PricebookTaxRatesInsertInput = {
  accountTypes?: InputMaybe<Scalars['AccountTypeArray']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  rate?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['Int']>;
  zipCodes?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate max on columns */
export type PricebookTaxRatesMaxFields = {
  __typename?: 'PricebookTaxRatesMaxFields';
  accountTypes?: Maybe<Scalars['AccountTypeArray']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  pricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  rate?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  zipCodes?: Maybe<Array<Scalars['String']>>;
};

/** order by max() on columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesMaxOrderBy = {
  accountTypes?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pricebookTaxRateGuid?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  zipCodes?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PricebookTaxRatesMinFields = {
  __typename?: 'PricebookTaxRatesMinFields';
  accountTypes?: Maybe<Scalars['AccountTypeArray']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  pricebookTaxRateGuid?: Maybe<Scalars['uuid']>;
  rate?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  zipCodes?: Maybe<Array<Scalars['String']>>;
};

/** order by min() on columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesMinOrderBy = {
  accountTypes?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pricebookTaxRateGuid?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  zipCodes?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "pricebook_tax_rates" */
export type PricebookTaxRatesMutationResponse = {
  __typename?: 'PricebookTaxRatesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PricebookTaxRates>;
};

/** input type for inserting object relation for remote table "pricebook_tax_rates" */
export type PricebookTaxRatesObjRelInsertInput = {
  data: PricebookTaxRatesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PricebookTaxRatesOnConflict>;
};

/** on_conflict condition type for table "pricebook_tax_rates" */
export type PricebookTaxRatesOnConflict = {
  constraint: PricebookTaxRatesConstraint;
  updateColumns?: Array<PricebookTaxRatesUpdateColumn>;
  where?: InputMaybe<PricebookTaxRatesBoolExp>;
};

/** Ordering options when selecting data from "pricebook_tax_rates". */
export type PricebookTaxRatesOrderBy = {
  accountTypes?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pricebookTaxRateGuid?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  zipCodes?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pricebook_tax_rates */
export type PricebookTaxRatesPkColumnsInput = {
  pricebookTaxRateGuid: Scalars['uuid'];
};

/** select columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesSelectColumn =
  /** column name */
  | 'accountTypes'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'isActive'
  /** column name */
  | 'name'
  /** column name */
  | 'pricebookTaxRateGuid'
  /** column name */
  | 'rate'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'version'
  /** column name */
  | 'zipCodes';

/** select "pricebookTaxRatesAggregateBoolExpBool_andArgumentsColumns" columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesSelectColumnPricebookTaxRatesAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isActive';

/** select "pricebookTaxRatesAggregateBoolExpBool_orArgumentsColumns" columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesSelectColumnPricebookTaxRatesAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isActive';

/** input type for updating data in table "pricebook_tax_rates" */
export type PricebookTaxRatesSetInput = {
  accountTypes?: InputMaybe<Scalars['AccountTypeArray']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  rate?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['Int']>;
  zipCodes?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate stddev on columns */
export type PricebookTaxRatesStddevFields = {
  __typename?: 'PricebookTaxRatesStddevFields';
  rate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesStddevOrderBy = {
  rate?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PricebookTaxRatesStddevPopFields = {
  __typename?: 'PricebookTaxRatesStddevPopFields';
  rate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesStddevPopOrderBy = {
  rate?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PricebookTaxRatesStddevSampFields = {
  __typename?: 'PricebookTaxRatesStddevSampFields';
  rate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesStddevSampOrderBy = {
  rate?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "pricebook_tax_rates" */
export type PricebookTaxRatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PricebookTaxRatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PricebookTaxRatesStreamCursorValueInput = {
  accountTypes?: InputMaybe<Scalars['AccountTypeArray']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pricebookTaxRateGuid?: InputMaybe<Scalars['uuid']>;
  rate?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['Int']>;
  zipCodes?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate sum on columns */
export type PricebookTaxRatesSumFields = {
  __typename?: 'PricebookTaxRatesSumFields';
  rate?: Maybe<Scalars['numeric']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesSumOrderBy = {
  rate?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** update columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesUpdateColumn =
  /** column name */
  | 'accountTypes'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'isActive'
  /** column name */
  | 'name'
  /** column name */
  | 'pricebookTaxRateGuid'
  /** column name */
  | 'rate'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'version'
  /** column name */
  | 'zipCodes';

export type PricebookTaxRatesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PricebookTaxRatesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PricebookTaxRatesSetInput>;
  /** filter the rows which have to be updated */
  where: PricebookTaxRatesBoolExp;
};

/** aggregate varPop on columns */
export type PricebookTaxRatesVarPopFields = {
  __typename?: 'PricebookTaxRatesVarPopFields';
  rate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesVarPopOrderBy = {
  rate?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PricebookTaxRatesVarSampFields = {
  __typename?: 'PricebookTaxRatesVarSampFields';
  rate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesVarSampOrderBy = {
  rate?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PricebookTaxRatesVarianceFields = {
  __typename?: 'PricebookTaxRatesVarianceFields';
  rate?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pricebook_tax_rates" */
export type PricebookTaxRatesVarianceOrderBy = {
  rate?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Table for managing pricebook snapshots */
export type PricebookVersions = {
  __typename?: 'PricebookVersions';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser?: Maybe<Users>;
  createdByUserGuid: Scalars['uuid'];
  dataSchemaVersion: Scalars['PricebookDataSchemaVersion'];
  displayId: Scalars['bigint'];
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  pricebookCategoriesFile?: Maybe<Files>;
  pricebookCategoriesFileGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  pricebookItemsFile?: Maybe<Files>;
  pricebookItemsFileGuid: Scalars['uuid'];
  pricebookVersionGuid: Scalars['uuid'];
};

/** aggregated selection of "pricebook_versions" */
export type PricebookVersionsAggregate = {
  __typename?: 'PricebookVersionsAggregate';
  aggregate?: Maybe<PricebookVersionsAggregateFields>;
  nodes: Array<PricebookVersions>;
};

/** aggregate fields of "pricebook_versions" */
export type PricebookVersionsAggregateFields = {
  __typename?: 'PricebookVersionsAggregateFields';
  avg?: Maybe<PricebookVersionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PricebookVersionsMaxFields>;
  min?: Maybe<PricebookVersionsMinFields>;
  stddev?: Maybe<PricebookVersionsStddevFields>;
  stddevPop?: Maybe<PricebookVersionsStddevPopFields>;
  stddevSamp?: Maybe<PricebookVersionsStddevSampFields>;
  sum?: Maybe<PricebookVersionsSumFields>;
  varPop?: Maybe<PricebookVersionsVarPopFields>;
  varSamp?: Maybe<PricebookVersionsVarSampFields>;
  variance?: Maybe<PricebookVersionsVarianceFields>;
};


/** aggregate fields of "pricebook_versions" */
export type PricebookVersionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PricebookVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PricebookVersionsAvgFields = {
  __typename?: 'PricebookVersionsAvgFields';
  dataSchemaVersion?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pricebook_versions". All fields are combined with a logical 'AND'. */
export type PricebookVersionsBoolExp = {
  _and?: InputMaybe<Array<PricebookVersionsBoolExp>>;
  _not?: InputMaybe<PricebookVersionsBoolExp>;
  _or?: InputMaybe<Array<PricebookVersionsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  dataSchemaVersion?: InputMaybe<Scalars['PricebookDataSchemaVersionComparisonExp']>;
  displayId?: InputMaybe<BigintComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  pricebookCategoriesFile?: InputMaybe<FilesBoolExp>;
  pricebookCategoriesFileGuid?: InputMaybe<UuidComparisonExp>;
  pricebookItemsFile?: InputMaybe<FilesBoolExp>;
  pricebookItemsFileGuid?: InputMaybe<UuidComparisonExp>;
  pricebookVersionGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "pricebook_versions" */
export type PricebookVersionsConstraint =
  /** unique or primary key constraint on columns "display_id", "company_guid" */
  | 'pricebook_versions_company_guid_display_id_key'
  /** unique or primary key constraint on columns "pricebook_version_guid" */
  | 'pricebook_versions_pkey';

/** input type for incrementing numeric columns in table "pricebook_versions" */
export type PricebookVersionsIncInput = {
  dataSchemaVersion?: InputMaybe<Scalars['Int']>;
  displayId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "pricebook_versions" */
export type PricebookVersionsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  dataSchemaVersion?: InputMaybe<Scalars['PricebookDataSchemaVersion']>;
  displayId?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  pricebookCategoriesFile?: InputMaybe<FilesObjRelInsertInput>;
  pricebookCategoriesFileGuid?: InputMaybe<Scalars['uuid']>;
  pricebookItemsFile?: InputMaybe<FilesObjRelInsertInput>;
  pricebookItemsFileGuid?: InputMaybe<Scalars['uuid']>;
  pricebookVersionGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type PricebookVersionsMaxFields = {
  __typename?: 'PricebookVersionsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  dataSchemaVersion?: Maybe<Scalars['PricebookDataSchemaVersion']>;
  displayId?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  pricebookCategoriesFileGuid?: Maybe<Scalars['uuid']>;
  pricebookItemsFileGuid?: Maybe<Scalars['uuid']>;
  pricebookVersionGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PricebookVersionsMinFields = {
  __typename?: 'PricebookVersionsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  dataSchemaVersion?: Maybe<Scalars['PricebookDataSchemaVersion']>;
  displayId?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  pricebookCategoriesFileGuid?: Maybe<Scalars['uuid']>;
  pricebookItemsFileGuid?: Maybe<Scalars['uuid']>;
  pricebookVersionGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "pricebook_versions" */
export type PricebookVersionsMutationResponse = {
  __typename?: 'PricebookVersionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PricebookVersions>;
};

/** on_conflict condition type for table "pricebook_versions" */
export type PricebookVersionsOnConflict = {
  constraint: PricebookVersionsConstraint;
  updateColumns?: Array<PricebookVersionsUpdateColumn>;
  where?: InputMaybe<PricebookVersionsBoolExp>;
};

/** Ordering options when selecting data from "pricebook_versions". */
export type PricebookVersionsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  dataSchemaVersion?: InputMaybe<OrderBy>;
  displayId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  pricebookCategoriesFile?: InputMaybe<FilesOrderBy>;
  pricebookCategoriesFileGuid?: InputMaybe<OrderBy>;
  pricebookItemsFile?: InputMaybe<FilesOrderBy>;
  pricebookItemsFileGuid?: InputMaybe<OrderBy>;
  pricebookVersionGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: pricebook_versions */
export type PricebookVersionsPkColumnsInput = {
  pricebookVersionGuid: Scalars['uuid'];
};

/** select columns of table "pricebook_versions" */
export type PricebookVersionsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'dataSchemaVersion'
  /** column name */
  | 'displayId'
  /** column name */
  | 'name'
  /** column name */
  | 'pricebookCategoriesFileGuid'
  /** column name */
  | 'pricebookItemsFileGuid'
  /** column name */
  | 'pricebookVersionGuid';

/** input type for updating data in table "pricebook_versions" */
export type PricebookVersionsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  dataSchemaVersion?: InputMaybe<Scalars['PricebookDataSchemaVersion']>;
  displayId?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  pricebookCategoriesFileGuid?: InputMaybe<Scalars['uuid']>;
  pricebookItemsFileGuid?: InputMaybe<Scalars['uuid']>;
  pricebookVersionGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type PricebookVersionsStddevFields = {
  __typename?: 'PricebookVersionsStddevFields';
  dataSchemaVersion?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PricebookVersionsStddevPopFields = {
  __typename?: 'PricebookVersionsStddevPopFields';
  dataSchemaVersion?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PricebookVersionsStddevSampFields = {
  __typename?: 'PricebookVersionsStddevSampFields';
  dataSchemaVersion?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pricebook_versions" */
export type PricebookVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PricebookVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PricebookVersionsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  dataSchemaVersion?: InputMaybe<Scalars['PricebookDataSchemaVersion']>;
  displayId?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  pricebookCategoriesFileGuid?: InputMaybe<Scalars['uuid']>;
  pricebookItemsFileGuid?: InputMaybe<Scalars['uuid']>;
  pricebookVersionGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PricebookVersionsSumFields = {
  __typename?: 'PricebookVersionsSumFields';
  dataSchemaVersion?: Maybe<Scalars['Int']>;
  displayId?: Maybe<Scalars['bigint']>;
};

/** update columns of table "pricebook_versions" */
export type PricebookVersionsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'dataSchemaVersion'
  /** column name */
  | 'displayId'
  /** column name */
  | 'name'
  /** column name */
  | 'pricebookCategoriesFileGuid'
  /** column name */
  | 'pricebookItemsFileGuid'
  /** column name */
  | 'pricebookVersionGuid';

export type PricebookVersionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PricebookVersionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PricebookVersionsSetInput>;
  /** filter the rows which have to be updated */
  where: PricebookVersionsBoolExp;
};

/** aggregate varPop on columns */
export type PricebookVersionsVarPopFields = {
  __typename?: 'PricebookVersionsVarPopFields';
  dataSchemaVersion?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PricebookVersionsVarSampFields = {
  __typename?: 'PricebookVersionsVarSampFields';
  dataSchemaVersion?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PricebookVersionsVarianceFields = {
  __typename?: 'PricebookVersionsVarianceFields';
  dataSchemaVersion?: Maybe<Scalars['Float']>;
  displayId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pricebooks_item_prices" */
export type PricebooksItemPrices = {
  __typename?: 'PricebooksItemPrices';
  companyGuid?: Maybe<Scalars['uuid']>;
  finalPriceUsc?: Maybe<Scalars['bigint']>;
  pricebookItemGuid?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "pricebooks_item_prices" */
export type PricebooksItemPricesAggregate = {
  __typename?: 'PricebooksItemPricesAggregate';
  aggregate?: Maybe<PricebooksItemPricesAggregateFields>;
  nodes: Array<PricebooksItemPrices>;
};

/** aggregate fields of "pricebooks_item_prices" */
export type PricebooksItemPricesAggregateFields = {
  __typename?: 'PricebooksItemPricesAggregateFields';
  avg?: Maybe<PricebooksItemPricesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<PricebooksItemPricesMaxFields>;
  min?: Maybe<PricebooksItemPricesMinFields>;
  stddev?: Maybe<PricebooksItemPricesStddevFields>;
  stddevPop?: Maybe<PricebooksItemPricesStddevPopFields>;
  stddevSamp?: Maybe<PricebooksItemPricesStddevSampFields>;
  sum?: Maybe<PricebooksItemPricesSumFields>;
  varPop?: Maybe<PricebooksItemPricesVarPopFields>;
  varSamp?: Maybe<PricebooksItemPricesVarSampFields>;
  variance?: Maybe<PricebooksItemPricesVarianceFields>;
};


/** aggregate fields of "pricebooks_item_prices" */
export type PricebooksItemPricesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PricebooksItemPricesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type PricebooksItemPricesAvgFields = {
  __typename?: 'PricebooksItemPricesAvgFields';
  finalPriceUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pricebooks_item_prices". All fields are combined with a logical 'AND'. */
export type PricebooksItemPricesBoolExp = {
  _and?: InputMaybe<Array<PricebooksItemPricesBoolExp>>;
  _not?: InputMaybe<PricebooksItemPricesBoolExp>;
  _or?: InputMaybe<Array<PricebooksItemPricesBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  finalPriceUsc?: InputMaybe<BigintComparisonExp>;
  pricebookItemGuid?: InputMaybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type PricebooksItemPricesMaxFields = {
  __typename?: 'PricebooksItemPricesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  finalPriceUsc?: Maybe<Scalars['bigint']>;
  pricebookItemGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type PricebooksItemPricesMinFields = {
  __typename?: 'PricebooksItemPricesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  finalPriceUsc?: Maybe<Scalars['bigint']>;
  pricebookItemGuid?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "pricebooks_item_prices". */
export type PricebooksItemPricesOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  finalPriceUsc?: InputMaybe<OrderBy>;
  pricebookItemGuid?: InputMaybe<OrderBy>;
};

/** select columns of table "pricebooks_item_prices" */
export type PricebooksItemPricesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'finalPriceUsc'
  /** column name */
  | 'pricebookItemGuid';

/** aggregate stddev on columns */
export type PricebooksItemPricesStddevFields = {
  __typename?: 'PricebooksItemPricesStddevFields';
  finalPriceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type PricebooksItemPricesStddevPopFields = {
  __typename?: 'PricebooksItemPricesStddevPopFields';
  finalPriceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type PricebooksItemPricesStddevSampFields = {
  __typename?: 'PricebooksItemPricesStddevSampFields';
  finalPriceUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pricebooks_item_prices" */
export type PricebooksItemPricesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PricebooksItemPricesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PricebooksItemPricesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  finalPriceUsc?: InputMaybe<Scalars['bigint']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type PricebooksItemPricesSumFields = {
  __typename?: 'PricebooksItemPricesSumFields';
  finalPriceUsc?: Maybe<Scalars['bigint']>;
};

/** aggregate varPop on columns */
export type PricebooksItemPricesVarPopFields = {
  __typename?: 'PricebooksItemPricesVarPopFields';
  finalPriceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type PricebooksItemPricesVarSampFields = {
  __typename?: 'PricebooksItemPricesVarSampFields';
  finalPriceUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PricebooksItemPricesVarianceFields = {
  __typename?: 'PricebooksItemPricesVarianceFields';
  finalPriceUsc?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "purchase_orders" */
export type PurchaseOrders = {
  __typename?: 'PurchaseOrders';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  job: Jobs;
  jobGuid: Scalars['uuid'];
  purchaseOrderGuid: Scalars['uuid'];
  purchaseOrderNumber: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "purchase_orders" */
export type PurchaseOrdersAggregate = {
  __typename?: 'PurchaseOrdersAggregate';
  aggregate?: Maybe<PurchaseOrdersAggregateFields>;
  nodes: Array<PurchaseOrders>;
};

export type PurchaseOrdersAggregateBoolExp = {
  count?: InputMaybe<PurchaseOrdersAggregateBoolExpCount>;
};

/** aggregate fields of "purchase_orders" */
export type PurchaseOrdersAggregateFields = {
  __typename?: 'PurchaseOrdersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<PurchaseOrdersMaxFields>;
  min?: Maybe<PurchaseOrdersMinFields>;
};


/** aggregate fields of "purchase_orders" */
export type PurchaseOrdersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PurchaseOrdersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "purchase_orders" */
export type PurchaseOrdersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PurchaseOrdersMaxOrderBy>;
  min?: InputMaybe<PurchaseOrdersMinOrderBy>;
};

/** input type for inserting array relation for remote table "purchase_orders" */
export type PurchaseOrdersArrRelInsertInput = {
  data: Array<PurchaseOrdersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PurchaseOrdersOnConflict>;
};

/** Boolean expression to filter rows from the table "purchase_orders". All fields are combined with a logical 'AND'. */
export type PurchaseOrdersBoolExp = {
  _and?: InputMaybe<Array<PurchaseOrdersBoolExp>>;
  _not?: InputMaybe<PurchaseOrdersBoolExp>;
  _or?: InputMaybe<Array<PurchaseOrdersBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  purchaseOrderGuid?: InputMaybe<UuidComparisonExp>;
  purchaseOrderNumber?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "purchase_orders" */
export type PurchaseOrdersConstraint =
  /** unique or primary key constraint on columns "job_guid", "purchase_order_number" */
  | 'purchase_orders_job_guid_purchase_order_number_key'
  /** unique or primary key constraint on columns "purchase_order_guid" */
  | 'purchase_orders_pkey';

/** input type for inserting data into table "purchase_orders" */
export type PurchaseOrdersInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  purchaseOrderGuid?: InputMaybe<Scalars['uuid']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type PurchaseOrdersMaxFields = {
  __typename?: 'PurchaseOrdersMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  purchaseOrderGuid?: Maybe<Scalars['uuid']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "purchase_orders" */
export type PurchaseOrdersMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  purchaseOrderGuid?: InputMaybe<OrderBy>;
  purchaseOrderNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PurchaseOrdersMinFields = {
  __typename?: 'PurchaseOrdersMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  purchaseOrderGuid?: Maybe<Scalars['uuid']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "purchase_orders" */
export type PurchaseOrdersMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  purchaseOrderGuid?: InputMaybe<OrderBy>;
  purchaseOrderNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "purchase_orders" */
export type PurchaseOrdersMutationResponse = {
  __typename?: 'PurchaseOrdersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PurchaseOrders>;
};

/** on_conflict condition type for table "purchase_orders" */
export type PurchaseOrdersOnConflict = {
  constraint: PurchaseOrdersConstraint;
  updateColumns?: Array<PurchaseOrdersUpdateColumn>;
  where?: InputMaybe<PurchaseOrdersBoolExp>;
};

/** Ordering options when selecting data from "purchase_orders". */
export type PurchaseOrdersOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  purchaseOrderGuid?: InputMaybe<OrderBy>;
  purchaseOrderNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: purchase_orders */
export type PurchaseOrdersPkColumnsInput = {
  purchaseOrderGuid: Scalars['uuid'];
};

/** select columns of table "purchase_orders" */
export type PurchaseOrdersSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'purchaseOrderGuid'
  /** column name */
  | 'purchaseOrderNumber'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "purchase_orders" */
export type PurchaseOrdersSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  purchaseOrderGuid?: InputMaybe<Scalars['uuid']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "purchase_orders" */
export type PurchaseOrdersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PurchaseOrdersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PurchaseOrdersStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  purchaseOrderGuid?: InputMaybe<Scalars['uuid']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "purchase_orders" */
export type PurchaseOrdersUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'purchaseOrderGuid'
  /** column name */
  | 'purchaseOrderNumber'
  /** column name */
  | 'updatedAt';

export type PurchaseOrdersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PurchaseOrdersSetInput>;
  /** filter the rows which have to be updated */
  where: PurchaseOrdersBoolExp;
};

/** columns and relationships of "qbo_auth_data" */
export type QboAuthData = {
  __typename?: 'QboAuthData';
  accessToken: Scalars['String'];
  accessTokenExpireAt: Scalars['timestamptz'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  isInvalid: Scalars['Boolean'];
  realmId: Scalars['String'];
  refreshToken: Scalars['String'];
  refreshTokenExpireAt: Scalars['timestamptz'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "qbo_auth_data" */
export type QboAuthDataAggregate = {
  __typename?: 'QboAuthDataAggregate';
  aggregate?: Maybe<QboAuthDataAggregateFields>;
  nodes: Array<QboAuthData>;
};

/** aggregate fields of "qbo_auth_data" */
export type QboAuthDataAggregateFields = {
  __typename?: 'QboAuthDataAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<QboAuthDataMaxFields>;
  min?: Maybe<QboAuthDataMinFields>;
};


/** aggregate fields of "qbo_auth_data" */
export type QboAuthDataAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<QboAuthDataSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "qbo_auth_data". All fields are combined with a logical 'AND'. */
export type QboAuthDataBoolExp = {
  _and?: InputMaybe<Array<QboAuthDataBoolExp>>;
  _not?: InputMaybe<QboAuthDataBoolExp>;
  _or?: InputMaybe<Array<QboAuthDataBoolExp>>;
  accessToken?: InputMaybe<StringComparisonExp>;
  accessTokenExpireAt?: InputMaybe<TimestamptzComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  isInvalid?: InputMaybe<BooleanComparisonExp>;
  realmId?: InputMaybe<StringComparisonExp>;
  refreshToken?: InputMaybe<StringComparisonExp>;
  refreshTokenExpireAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "qbo_auth_data" */
export type QboAuthDataConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'qbo_auth_data_pkey';

/** input type for inserting data into table "qbo_auth_data" */
export type QboAuthDataInsertInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  accessTokenExpireAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isInvalid?: InputMaybe<Scalars['Boolean']>;
  realmId?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  refreshTokenExpireAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type QboAuthDataMaxFields = {
  __typename?: 'QboAuthDataMaxFields';
  accessToken?: Maybe<Scalars['String']>;
  accessTokenExpireAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  realmId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpireAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type QboAuthDataMinFields = {
  __typename?: 'QboAuthDataMinFields';
  accessToken?: Maybe<Scalars['String']>;
  accessTokenExpireAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  realmId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpireAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "qbo_auth_data" */
export type QboAuthDataMutationResponse = {
  __typename?: 'QboAuthDataMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<QboAuthData>;
};

/** on_conflict condition type for table "qbo_auth_data" */
export type QboAuthDataOnConflict = {
  constraint: QboAuthDataConstraint;
  updateColumns?: Array<QboAuthDataUpdateColumn>;
  where?: InputMaybe<QboAuthDataBoolExp>;
};

/** Ordering options when selecting data from "qbo_auth_data". */
export type QboAuthDataOrderBy = {
  accessToken?: InputMaybe<OrderBy>;
  accessTokenExpireAt?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  isInvalid?: InputMaybe<OrderBy>;
  realmId?: InputMaybe<OrderBy>;
  refreshToken?: InputMaybe<OrderBy>;
  refreshTokenExpireAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: qbo_auth_data */
export type QboAuthDataPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "qbo_auth_data" */
export type QboAuthDataSelectColumn =
  /** column name */
  | 'accessToken'
  /** column name */
  | 'accessTokenExpireAt'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'isInvalid'
  /** column name */
  | 'realmId'
  /** column name */
  | 'refreshToken'
  /** column name */
  | 'refreshTokenExpireAt'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "qbo_auth_data" */
export type QboAuthDataSetInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  accessTokenExpireAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isInvalid?: InputMaybe<Scalars['Boolean']>;
  realmId?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  refreshTokenExpireAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "qbo_auth_data" */
export type QboAuthDataStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: QboAuthDataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type QboAuthDataStreamCursorValueInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  accessTokenExpireAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isInvalid?: InputMaybe<Scalars['Boolean']>;
  realmId?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  refreshTokenExpireAt?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "qbo_auth_data" */
export type QboAuthDataUpdateColumn =
  /** column name */
  | 'accessToken'
  /** column name */
  | 'accessTokenExpireAt'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'isInvalid'
  /** column name */
  | 'realmId'
  /** column name */
  | 'refreshToken'
  /** column name */
  | 'refreshTokenExpireAt'
  /** column name */
  | 'updatedAt';

export type QboAuthDataUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QboAuthDataSetInput>;
  /** filter the rows which have to be updated */
  where: QboAuthDataBoolExp;
};

/** columns and relationships of "qbo_cart_item_type_accounts_config" */
export type QboCartItemTypeAccountsConfig = {
  __typename?: 'QboCartItemTypeAccountsConfig';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  defaultItemQboIncomeAccountId: Scalars['String'];
  equipmentItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  laborItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  materialItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  membershipItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  qboCartItemTypeAccountsConfigGuid: Scalars['uuid'];
  serviceItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "qbo_cart_item_type_accounts_config" */
export type QboCartItemTypeAccountsConfigAggregate = {
  __typename?: 'QboCartItemTypeAccountsConfigAggregate';
  aggregate?: Maybe<QboCartItemTypeAccountsConfigAggregateFields>;
  nodes: Array<QboCartItemTypeAccountsConfig>;
};

/** aggregate fields of "qbo_cart_item_type_accounts_config" */
export type QboCartItemTypeAccountsConfigAggregateFields = {
  __typename?: 'QboCartItemTypeAccountsConfigAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<QboCartItemTypeAccountsConfigMaxFields>;
  min?: Maybe<QboCartItemTypeAccountsConfigMinFields>;
};


/** aggregate fields of "qbo_cart_item_type_accounts_config" */
export type QboCartItemTypeAccountsConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<QboCartItemTypeAccountsConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "qbo_cart_item_type_accounts_config". All fields are combined with a logical 'AND'. */
export type QboCartItemTypeAccountsConfigBoolExp = {
  _and?: InputMaybe<Array<QboCartItemTypeAccountsConfigBoolExp>>;
  _not?: InputMaybe<QboCartItemTypeAccountsConfigBoolExp>;
  _or?: InputMaybe<Array<QboCartItemTypeAccountsConfigBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  defaultItemQboIncomeAccountId?: InputMaybe<StringComparisonExp>;
  equipmentItemDefaultQboIncomeAccountId?: InputMaybe<StringComparisonExp>;
  laborItemDefaultQboIncomeAccountId?: InputMaybe<StringComparisonExp>;
  materialItemDefaultQboIncomeAccountId?: InputMaybe<StringComparisonExp>;
  membershipItemDefaultQboIncomeAccountId?: InputMaybe<StringComparisonExp>;
  qboCartItemTypeAccountsConfigGuid?: InputMaybe<UuidComparisonExp>;
  serviceItemDefaultQboIncomeAccountId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "qbo_cart_item_type_accounts_config" */
export type QboCartItemTypeAccountsConfigConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'qbo_cart_item_type_accounts_config_company_guid_key'
  /** unique or primary key constraint on columns "qbo_cart_item_type_accounts_config_guid" */
  | 'qbo_cart_item_type_accounts_config_pkey';

/** input type for inserting data into table "qbo_cart_item_type_accounts_config" */
export type QboCartItemTypeAccountsConfigInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultItemQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  equipmentItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  laborItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  materialItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  membershipItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  qboCartItemTypeAccountsConfigGuid?: InputMaybe<Scalars['uuid']>;
  serviceItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type QboCartItemTypeAccountsConfigMaxFields = {
  __typename?: 'QboCartItemTypeAccountsConfigMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultItemQboIncomeAccountId?: Maybe<Scalars['String']>;
  equipmentItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  laborItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  materialItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  membershipItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  qboCartItemTypeAccountsConfigGuid?: Maybe<Scalars['uuid']>;
  serviceItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type QboCartItemTypeAccountsConfigMinFields = {
  __typename?: 'QboCartItemTypeAccountsConfigMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultItemQboIncomeAccountId?: Maybe<Scalars['String']>;
  equipmentItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  laborItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  materialItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  membershipItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  qboCartItemTypeAccountsConfigGuid?: Maybe<Scalars['uuid']>;
  serviceItemDefaultQboIncomeAccountId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "qbo_cart_item_type_accounts_config" */
export type QboCartItemTypeAccountsConfigMutationResponse = {
  __typename?: 'QboCartItemTypeAccountsConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<QboCartItemTypeAccountsConfig>;
};

/** on_conflict condition type for table "qbo_cart_item_type_accounts_config" */
export type QboCartItemTypeAccountsConfigOnConflict = {
  constraint: QboCartItemTypeAccountsConfigConstraint;
  updateColumns?: Array<QboCartItemTypeAccountsConfigUpdateColumn>;
  where?: InputMaybe<QboCartItemTypeAccountsConfigBoolExp>;
};

/** Ordering options when selecting data from "qbo_cart_item_type_accounts_config". */
export type QboCartItemTypeAccountsConfigOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  defaultItemQboIncomeAccountId?: InputMaybe<OrderBy>;
  equipmentItemDefaultQboIncomeAccountId?: InputMaybe<OrderBy>;
  laborItemDefaultQboIncomeAccountId?: InputMaybe<OrderBy>;
  materialItemDefaultQboIncomeAccountId?: InputMaybe<OrderBy>;
  membershipItemDefaultQboIncomeAccountId?: InputMaybe<OrderBy>;
  qboCartItemTypeAccountsConfigGuid?: InputMaybe<OrderBy>;
  serviceItemDefaultQboIncomeAccountId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: qbo_cart_item_type_accounts_config */
export type QboCartItemTypeAccountsConfigPkColumnsInput = {
  qboCartItemTypeAccountsConfigGuid: Scalars['uuid'];
};

/** select columns of table "qbo_cart_item_type_accounts_config" */
export type QboCartItemTypeAccountsConfigSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'defaultItemQboIncomeAccountId'
  /** column name */
  | 'equipmentItemDefaultQboIncomeAccountId'
  /** column name */
  | 'laborItemDefaultQboIncomeAccountId'
  /** column name */
  | 'materialItemDefaultQboIncomeAccountId'
  /** column name */
  | 'membershipItemDefaultQboIncomeAccountId'
  /** column name */
  | 'qboCartItemTypeAccountsConfigGuid'
  /** column name */
  | 'serviceItemDefaultQboIncomeAccountId'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "qbo_cart_item_type_accounts_config" */
export type QboCartItemTypeAccountsConfigSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultItemQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  equipmentItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  laborItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  materialItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  membershipItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  qboCartItemTypeAccountsConfigGuid?: InputMaybe<Scalars['uuid']>;
  serviceItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "qbo_cart_item_type_accounts_config" */
export type QboCartItemTypeAccountsConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: QboCartItemTypeAccountsConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type QboCartItemTypeAccountsConfigStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultItemQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  equipmentItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  laborItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  materialItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  membershipItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  qboCartItemTypeAccountsConfigGuid?: InputMaybe<Scalars['uuid']>;
  serviceItemDefaultQboIncomeAccountId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "qbo_cart_item_type_accounts_config" */
export type QboCartItemTypeAccountsConfigUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'defaultItemQboIncomeAccountId'
  /** column name */
  | 'equipmentItemDefaultQboIncomeAccountId'
  /** column name */
  | 'laborItemDefaultQboIncomeAccountId'
  /** column name */
  | 'materialItemDefaultQboIncomeAccountId'
  /** column name */
  | 'membershipItemDefaultQboIncomeAccountId'
  /** column name */
  | 'qboCartItemTypeAccountsConfigGuid'
  /** column name */
  | 'serviceItemDefaultQboIncomeAccountId'
  /** column name */
  | 'updatedAt';

export type QboCartItemTypeAccountsConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QboCartItemTypeAccountsConfigSetInput>;
  /** filter the rows which have to be updated */
  where: QboCartItemTypeAccountsConfigBoolExp;
};

/** columns and relationships of "qbo_sync_info" */
export type QboSyncInfo = {
  __typename?: 'QboSyncInfo';
  breezyEntityType: Scalars['String'];
  breezyIdentifier: Scalars['String'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  qboId: Scalars['String'];
  qboSyncToken: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "qbo_sync_info" */
export type QboSyncInfoAggregate = {
  __typename?: 'QboSyncInfoAggregate';
  aggregate?: Maybe<QboSyncInfoAggregateFields>;
  nodes: Array<QboSyncInfo>;
};

/** aggregate fields of "qbo_sync_info" */
export type QboSyncInfoAggregateFields = {
  __typename?: 'QboSyncInfoAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<QboSyncInfoMaxFields>;
  min?: Maybe<QboSyncInfoMinFields>;
};


/** aggregate fields of "qbo_sync_info" */
export type QboSyncInfoAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<QboSyncInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "qbo_sync_info". All fields are combined with a logical 'AND'. */
export type QboSyncInfoBoolExp = {
  _and?: InputMaybe<Array<QboSyncInfoBoolExp>>;
  _not?: InputMaybe<QboSyncInfoBoolExp>;
  _or?: InputMaybe<Array<QboSyncInfoBoolExp>>;
  breezyEntityType?: InputMaybe<StringComparisonExp>;
  breezyIdentifier?: InputMaybe<StringComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  qboId?: InputMaybe<StringComparisonExp>;
  qboSyncToken?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "qbo_sync_info" */
export type QboSyncInfoConstraint =
  /** unique or primary key constraint on columns "breezy_identifier", "company_guid" */
  | 'qbo_sync_info_pkey';

/** input type for inserting data into table "qbo_sync_info" */
export type QboSyncInfoInsertInput = {
  breezyEntityType?: InputMaybe<Scalars['String']>;
  breezyIdentifier?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  qboId?: InputMaybe<Scalars['String']>;
  qboSyncToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type QboSyncInfoMaxFields = {
  __typename?: 'QboSyncInfoMaxFields';
  breezyEntityType?: Maybe<Scalars['String']>;
  breezyIdentifier?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type QboSyncInfoMinFields = {
  __typename?: 'QboSyncInfoMinFields';
  breezyEntityType?: Maybe<Scalars['String']>;
  breezyIdentifier?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  qboId?: Maybe<Scalars['String']>;
  qboSyncToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "qbo_sync_info" */
export type QboSyncInfoMutationResponse = {
  __typename?: 'QboSyncInfoMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<QboSyncInfo>;
};

/** on_conflict condition type for table "qbo_sync_info" */
export type QboSyncInfoOnConflict = {
  constraint: QboSyncInfoConstraint;
  updateColumns?: Array<QboSyncInfoUpdateColumn>;
  where?: InputMaybe<QboSyncInfoBoolExp>;
};

/** Ordering options when selecting data from "qbo_sync_info". */
export type QboSyncInfoOrderBy = {
  breezyEntityType?: InputMaybe<OrderBy>;
  breezyIdentifier?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  qboId?: InputMaybe<OrderBy>;
  qboSyncToken?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: qbo_sync_info */
export type QboSyncInfoPkColumnsInput = {
  breezyIdentifier: Scalars['String'];
  companyGuid: Scalars['uuid'];
};

/** select columns of table "qbo_sync_info" */
export type QboSyncInfoSelectColumn =
  /** column name */
  | 'breezyEntityType'
  /** column name */
  | 'breezyIdentifier'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'qboId'
  /** column name */
  | 'qboSyncToken'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "qbo_sync_info" */
export type QboSyncInfoSetInput = {
  breezyEntityType?: InputMaybe<Scalars['String']>;
  breezyIdentifier?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  qboId?: InputMaybe<Scalars['String']>;
  qboSyncToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "qbo_sync_info" */
export type QboSyncInfoStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: QboSyncInfoStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type QboSyncInfoStreamCursorValueInput = {
  breezyEntityType?: InputMaybe<Scalars['String']>;
  breezyIdentifier?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  qboId?: InputMaybe<Scalars['String']>;
  qboSyncToken?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "qbo_sync_info" */
export type QboSyncInfoUpdateColumn =
  /** column name */
  | 'breezyEntityType'
  /** column name */
  | 'breezyIdentifier'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'qboId'
  /** column name */
  | 'qboSyncToken'
  /** column name */
  | 'updatedAt';

export type QboSyncInfoUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QboSyncInfoSetInput>;
  /** filter the rows which have to be updated */
  where: QboSyncInfoBoolExp;
};

/** Keeps track of recently used pricebook items */
export type RecentPricebookItems = {
  __typename?: 'RecentPricebookItems';
  lastViewedAt: Scalars['timestamptz'];
  pricebookItemGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "recent_pricebook_items" */
export type RecentPricebookItemsAggregate = {
  __typename?: 'RecentPricebookItemsAggregate';
  aggregate?: Maybe<RecentPricebookItemsAggregateFields>;
  nodes: Array<RecentPricebookItems>;
};

/** aggregate fields of "recent_pricebook_items" */
export type RecentPricebookItemsAggregateFields = {
  __typename?: 'RecentPricebookItemsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<RecentPricebookItemsMaxFields>;
  min?: Maybe<RecentPricebookItemsMinFields>;
};


/** aggregate fields of "recent_pricebook_items" */
export type RecentPricebookItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecentPricebookItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "recent_pricebook_items". All fields are combined with a logical 'AND'. */
export type RecentPricebookItemsBoolExp = {
  _and?: InputMaybe<Array<RecentPricebookItemsBoolExp>>;
  _not?: InputMaybe<RecentPricebookItemsBoolExp>;
  _or?: InputMaybe<Array<RecentPricebookItemsBoolExp>>;
  lastViewedAt?: InputMaybe<TimestamptzComparisonExp>;
  pricebookItemGuid?: InputMaybe<UuidComparisonExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "recent_pricebook_items" */
export type RecentPricebookItemsConstraint =
  /** unique or primary key constraint on columns "user_guid", "pricebook_item_guid" */
  | 'recent_pricebook_items_pkey';

/** input type for inserting data into table "recent_pricebook_items" */
export type RecentPricebookItemsInsertInput = {
  lastViewedAt?: InputMaybe<Scalars['timestamptz']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type RecentPricebookItemsMaxFields = {
  __typename?: 'RecentPricebookItemsMaxFields';
  lastViewedAt?: Maybe<Scalars['timestamptz']>;
  pricebookItemGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type RecentPricebookItemsMinFields = {
  __typename?: 'RecentPricebookItemsMinFields';
  lastViewedAt?: Maybe<Scalars['timestamptz']>;
  pricebookItemGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "recent_pricebook_items" */
export type RecentPricebookItemsMutationResponse = {
  __typename?: 'RecentPricebookItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RecentPricebookItems>;
};

/** on_conflict condition type for table "recent_pricebook_items" */
export type RecentPricebookItemsOnConflict = {
  constraint: RecentPricebookItemsConstraint;
  updateColumns?: Array<RecentPricebookItemsUpdateColumn>;
  where?: InputMaybe<RecentPricebookItemsBoolExp>;
};

/** Ordering options when selecting data from "recent_pricebook_items". */
export type RecentPricebookItemsOrderBy = {
  lastViewedAt?: InputMaybe<OrderBy>;
  pricebookItemGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: recent_pricebook_items */
export type RecentPricebookItemsPkColumnsInput = {
  pricebookItemGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};

/** select columns of table "recent_pricebook_items" */
export type RecentPricebookItemsSelectColumn =
  /** column name */
  | 'lastViewedAt'
  /** column name */
  | 'pricebookItemGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "recent_pricebook_items" */
export type RecentPricebookItemsSetInput = {
  lastViewedAt?: InputMaybe<Scalars['timestamptz']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "recent_pricebook_items" */
export type RecentPricebookItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecentPricebookItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecentPricebookItemsStreamCursorValueInput = {
  lastViewedAt?: InputMaybe<Scalars['timestamptz']>;
  pricebookItemGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "recent_pricebook_items" */
export type RecentPricebookItemsUpdateColumn =
  /** column name */
  | 'lastViewedAt'
  /** column name */
  | 'pricebookItemGuid'
  /** column name */
  | 'userGuid';

export type RecentPricebookItemsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecentPricebookItemsSetInput>;
  /** filter the rows which have to be updated */
  where: RecentPricebookItemsBoolExp;
};

/** columns and relationships of "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfo = {
  __typename?: 'RecommendationAiGenerationInfo';
  createdAt: Scalars['timestamptz'];
  llmModel: Scalars['String'];
  otherGenerationInfo?: Maybe<Scalars['jsonb']>;
  promptVersion: Scalars['String'];
  recommendationAiInfoGuid: Scalars['uuid'];
  recommendationEngineVersion: Scalars['String'];
  recommendationGuid: Scalars['uuid'];
  recommendationSource: Scalars['String'];
  recommendationType: Scalars['String'];
};


/** columns and relationships of "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfoOtherGenerationInfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfoAggregate = {
  __typename?: 'RecommendationAiGenerationInfoAggregate';
  aggregate?: Maybe<RecommendationAiGenerationInfoAggregateFields>;
  nodes: Array<RecommendationAiGenerationInfo>;
};

/** aggregate fields of "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfoAggregateFields = {
  __typename?: 'RecommendationAiGenerationInfoAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<RecommendationAiGenerationInfoMaxFields>;
  min?: Maybe<RecommendationAiGenerationInfoMinFields>;
};


/** aggregate fields of "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfoAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecommendationAiGenerationInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RecommendationAiGenerationInfoAppendInput = {
  otherGenerationInfo?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "recommendation_ai_generation_info". All fields are combined with a logical 'AND'. */
export type RecommendationAiGenerationInfoBoolExp = {
  _and?: InputMaybe<Array<RecommendationAiGenerationInfoBoolExp>>;
  _not?: InputMaybe<RecommendationAiGenerationInfoBoolExp>;
  _or?: InputMaybe<Array<RecommendationAiGenerationInfoBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  llmModel?: InputMaybe<StringComparisonExp>;
  otherGenerationInfo?: InputMaybe<JsonbComparisonExp>;
  promptVersion?: InputMaybe<StringComparisonExp>;
  recommendationAiInfoGuid?: InputMaybe<UuidComparisonExp>;
  recommendationEngineVersion?: InputMaybe<StringComparisonExp>;
  recommendationGuid?: InputMaybe<UuidComparisonExp>;
  recommendationSource?: InputMaybe<StringComparisonExp>;
  recommendationType?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfoConstraint =
  /** unique or primary key constraint on columns "recommendation_ai_info_guid" */
  | 'recommendation_ai_generation_info_pkey'
  /** unique or primary key constraint on columns "recommendation_guid" */
  | 'recommendation_ai_generation_info_recommendation_guid_key';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RecommendationAiGenerationInfoDeleteAtPathInput = {
  otherGenerationInfo?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RecommendationAiGenerationInfoDeleteElemInput = {
  otherGenerationInfo?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RecommendationAiGenerationInfoDeleteKeyInput = {
  otherGenerationInfo?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfoInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  llmModel?: InputMaybe<Scalars['String']>;
  otherGenerationInfo?: InputMaybe<Scalars['jsonb']>;
  promptVersion?: InputMaybe<Scalars['String']>;
  recommendationAiInfoGuid?: InputMaybe<Scalars['uuid']>;
  recommendationEngineVersion?: InputMaybe<Scalars['String']>;
  recommendationGuid?: InputMaybe<Scalars['uuid']>;
  recommendationSource?: InputMaybe<Scalars['String']>;
  recommendationType?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RecommendationAiGenerationInfoMaxFields = {
  __typename?: 'RecommendationAiGenerationInfoMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  llmModel?: Maybe<Scalars['String']>;
  promptVersion?: Maybe<Scalars['String']>;
  recommendationAiInfoGuid?: Maybe<Scalars['uuid']>;
  recommendationEngineVersion?: Maybe<Scalars['String']>;
  recommendationGuid?: Maybe<Scalars['uuid']>;
  recommendationSource?: Maybe<Scalars['String']>;
  recommendationType?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RecommendationAiGenerationInfoMinFields = {
  __typename?: 'RecommendationAiGenerationInfoMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  llmModel?: Maybe<Scalars['String']>;
  promptVersion?: Maybe<Scalars['String']>;
  recommendationAiInfoGuid?: Maybe<Scalars['uuid']>;
  recommendationEngineVersion?: Maybe<Scalars['String']>;
  recommendationGuid?: Maybe<Scalars['uuid']>;
  recommendationSource?: Maybe<Scalars['String']>;
  recommendationType?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfoMutationResponse = {
  __typename?: 'RecommendationAiGenerationInfoMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RecommendationAiGenerationInfo>;
};

/** on_conflict condition type for table "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfoOnConflict = {
  constraint: RecommendationAiGenerationInfoConstraint;
  updateColumns?: Array<RecommendationAiGenerationInfoUpdateColumn>;
  where?: InputMaybe<RecommendationAiGenerationInfoBoolExp>;
};

/** Ordering options when selecting data from "recommendation_ai_generation_info". */
export type RecommendationAiGenerationInfoOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  llmModel?: InputMaybe<OrderBy>;
  otherGenerationInfo?: InputMaybe<OrderBy>;
  promptVersion?: InputMaybe<OrderBy>;
  recommendationAiInfoGuid?: InputMaybe<OrderBy>;
  recommendationEngineVersion?: InputMaybe<OrderBy>;
  recommendationGuid?: InputMaybe<OrderBy>;
  recommendationSource?: InputMaybe<OrderBy>;
  recommendationType?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: recommendation_ai_generation_info */
export type RecommendationAiGenerationInfoPkColumnsInput = {
  recommendationAiInfoGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RecommendationAiGenerationInfoPrependInput = {
  otherGenerationInfo?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfoSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'llmModel'
  /** column name */
  | 'otherGenerationInfo'
  /** column name */
  | 'promptVersion'
  /** column name */
  | 'recommendationAiInfoGuid'
  /** column name */
  | 'recommendationEngineVersion'
  /** column name */
  | 'recommendationGuid'
  /** column name */
  | 'recommendationSource'
  /** column name */
  | 'recommendationType';

/** input type for updating data in table "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfoSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  llmModel?: InputMaybe<Scalars['String']>;
  otherGenerationInfo?: InputMaybe<Scalars['jsonb']>;
  promptVersion?: InputMaybe<Scalars['String']>;
  recommendationAiInfoGuid?: InputMaybe<Scalars['uuid']>;
  recommendationEngineVersion?: InputMaybe<Scalars['String']>;
  recommendationGuid?: InputMaybe<Scalars['uuid']>;
  recommendationSource?: InputMaybe<Scalars['String']>;
  recommendationType?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfoStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecommendationAiGenerationInfoStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecommendationAiGenerationInfoStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  llmModel?: InputMaybe<Scalars['String']>;
  otherGenerationInfo?: InputMaybe<Scalars['jsonb']>;
  promptVersion?: InputMaybe<Scalars['String']>;
  recommendationAiInfoGuid?: InputMaybe<Scalars['uuid']>;
  recommendationEngineVersion?: InputMaybe<Scalars['String']>;
  recommendationGuid?: InputMaybe<Scalars['uuid']>;
  recommendationSource?: InputMaybe<Scalars['String']>;
  recommendationType?: InputMaybe<Scalars['String']>;
};

/** update columns of table "recommendation_ai_generation_info" */
export type RecommendationAiGenerationInfoUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'llmModel'
  /** column name */
  | 'otherGenerationInfo'
  /** column name */
  | 'promptVersion'
  /** column name */
  | 'recommendationAiInfoGuid'
  /** column name */
  | 'recommendationEngineVersion'
  /** column name */
  | 'recommendationGuid'
  /** column name */
  | 'recommendationSource'
  /** column name */
  | 'recommendationType';

export type RecommendationAiGenerationInfoUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RecommendationAiGenerationInfoAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<RecommendationAiGenerationInfoDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<RecommendationAiGenerationInfoDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<RecommendationAiGenerationInfoDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RecommendationAiGenerationInfoPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecommendationAiGenerationInfoSetInput>;
  /** filter the rows which have to be updated */
  where: RecommendationAiGenerationInfoBoolExp;
};

/** columns and relationships of "recommendation_dismissals" */
export type RecommendationDismissals = {
  __typename?: 'RecommendationDismissals';
  companyGuid: Scalars['uuid'];
  dismissedAt?: Maybe<Scalars['timestamptz']>;
  recommendationDismissalGuid: Scalars['uuid'];
  recommendationGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "recommendation_dismissals" */
export type RecommendationDismissalsAggregate = {
  __typename?: 'RecommendationDismissalsAggregate';
  aggregate?: Maybe<RecommendationDismissalsAggregateFields>;
  nodes: Array<RecommendationDismissals>;
};

export type RecommendationDismissalsAggregateBoolExp = {
  count?: InputMaybe<RecommendationDismissalsAggregateBoolExpCount>;
};

/** aggregate fields of "recommendation_dismissals" */
export type RecommendationDismissalsAggregateFields = {
  __typename?: 'RecommendationDismissalsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<RecommendationDismissalsMaxFields>;
  min?: Maybe<RecommendationDismissalsMinFields>;
};


/** aggregate fields of "recommendation_dismissals" */
export type RecommendationDismissalsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecommendationDismissalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recommendation_dismissals" */
export type RecommendationDismissalsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RecommendationDismissalsMaxOrderBy>;
  min?: InputMaybe<RecommendationDismissalsMinOrderBy>;
};

/** input type for inserting array relation for remote table "recommendation_dismissals" */
export type RecommendationDismissalsArrRelInsertInput = {
  data: Array<RecommendationDismissalsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<RecommendationDismissalsOnConflict>;
};

/** Boolean expression to filter rows from the table "recommendation_dismissals". All fields are combined with a logical 'AND'. */
export type RecommendationDismissalsBoolExp = {
  _and?: InputMaybe<Array<RecommendationDismissalsBoolExp>>;
  _not?: InputMaybe<RecommendationDismissalsBoolExp>;
  _or?: InputMaybe<Array<RecommendationDismissalsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  dismissedAt?: InputMaybe<TimestamptzComparisonExp>;
  recommendationDismissalGuid?: InputMaybe<UuidComparisonExp>;
  recommendationGuid?: InputMaybe<UuidComparisonExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "recommendation_dismissals" */
export type RecommendationDismissalsConstraint =
  /** unique or primary key constraint on columns "recommendation_dismissal_guid" */
  | 'recommendation_dismissals_pkey';

/** input type for inserting data into table "recommendation_dismissals" */
export type RecommendationDismissalsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  recommendationDismissalGuid?: InputMaybe<Scalars['uuid']>;
  recommendationGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type RecommendationDismissalsMaxFields = {
  __typename?: 'RecommendationDismissalsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  dismissedAt?: Maybe<Scalars['timestamptz']>;
  recommendationDismissalGuid?: Maybe<Scalars['uuid']>;
  recommendationGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "recommendation_dismissals" */
export type RecommendationDismissalsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  recommendationDismissalGuid?: InputMaybe<OrderBy>;
  recommendationGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RecommendationDismissalsMinFields = {
  __typename?: 'RecommendationDismissalsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  dismissedAt?: Maybe<Scalars['timestamptz']>;
  recommendationDismissalGuid?: Maybe<Scalars['uuid']>;
  recommendationGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "recommendation_dismissals" */
export type RecommendationDismissalsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  recommendationDismissalGuid?: InputMaybe<OrderBy>;
  recommendationGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "recommendation_dismissals" */
export type RecommendationDismissalsMutationResponse = {
  __typename?: 'RecommendationDismissalsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RecommendationDismissals>;
};

/** on_conflict condition type for table "recommendation_dismissals" */
export type RecommendationDismissalsOnConflict = {
  constraint: RecommendationDismissalsConstraint;
  updateColumns?: Array<RecommendationDismissalsUpdateColumn>;
  where?: InputMaybe<RecommendationDismissalsBoolExp>;
};

/** Ordering options when selecting data from "recommendation_dismissals". */
export type RecommendationDismissalsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  dismissedAt?: InputMaybe<OrderBy>;
  recommendationDismissalGuid?: InputMaybe<OrderBy>;
  recommendationGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: recommendation_dismissals */
export type RecommendationDismissalsPkColumnsInput = {
  recommendationDismissalGuid: Scalars['uuid'];
};

/** select columns of table "recommendation_dismissals" */
export type RecommendationDismissalsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dismissedAt'
  /** column name */
  | 'recommendationDismissalGuid'
  /** column name */
  | 'recommendationGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "recommendation_dismissals" */
export type RecommendationDismissalsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  recommendationDismissalGuid?: InputMaybe<Scalars['uuid']>;
  recommendationGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "recommendation_dismissals" */
export type RecommendationDismissalsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecommendationDismissalsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecommendationDismissalsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  dismissedAt?: InputMaybe<Scalars['timestamptz']>;
  recommendationDismissalGuid?: InputMaybe<Scalars['uuid']>;
  recommendationGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "recommendation_dismissals" */
export type RecommendationDismissalsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'dismissedAt'
  /** column name */
  | 'recommendationDismissalGuid'
  /** column name */
  | 'recommendationGuid'
  /** column name */
  | 'userGuid';

export type RecommendationDismissalsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecommendationDismissalsSetInput>;
  /** filter the rows which have to be updated */
  where: RecommendationDismissalsBoolExp;
};

/** columns and relationships of "recommendation_interactions" */
export type RecommendationInteractions = {
  __typename?: 'RecommendationInteractions';
  companyGuid: Scalars['uuid'];
  interactedAt?: Maybe<Scalars['timestamptz']>;
  recommendationGuid: Scalars['uuid'];
  recommendationInteractionGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "recommendation_interactions" */
export type RecommendationInteractionsAggregate = {
  __typename?: 'RecommendationInteractionsAggregate';
  aggregate?: Maybe<RecommendationInteractionsAggregateFields>;
  nodes: Array<RecommendationInteractions>;
};

export type RecommendationInteractionsAggregateBoolExp = {
  count?: InputMaybe<RecommendationInteractionsAggregateBoolExpCount>;
};

/** aggregate fields of "recommendation_interactions" */
export type RecommendationInteractionsAggregateFields = {
  __typename?: 'RecommendationInteractionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<RecommendationInteractionsMaxFields>;
  min?: Maybe<RecommendationInteractionsMinFields>;
};


/** aggregate fields of "recommendation_interactions" */
export type RecommendationInteractionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecommendationInteractionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recommendation_interactions" */
export type RecommendationInteractionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RecommendationInteractionsMaxOrderBy>;
  min?: InputMaybe<RecommendationInteractionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "recommendation_interactions" */
export type RecommendationInteractionsArrRelInsertInput = {
  data: Array<RecommendationInteractionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<RecommendationInteractionsOnConflict>;
};

/** Boolean expression to filter rows from the table "recommendation_interactions". All fields are combined with a logical 'AND'. */
export type RecommendationInteractionsBoolExp = {
  _and?: InputMaybe<Array<RecommendationInteractionsBoolExp>>;
  _not?: InputMaybe<RecommendationInteractionsBoolExp>;
  _or?: InputMaybe<Array<RecommendationInteractionsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  interactedAt?: InputMaybe<TimestamptzComparisonExp>;
  recommendationGuid?: InputMaybe<UuidComparisonExp>;
  recommendationInteractionGuid?: InputMaybe<UuidComparisonExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "recommendation_interactions" */
export type RecommendationInteractionsConstraint =
  /** unique or primary key constraint on columns "recommendation_interaction_guid" */
  | 'recommendation_interactions_pkey';

/** input type for inserting data into table "recommendation_interactions" */
export type RecommendationInteractionsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  interactedAt?: InputMaybe<Scalars['timestamptz']>;
  recommendationGuid?: InputMaybe<Scalars['uuid']>;
  recommendationInteractionGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type RecommendationInteractionsMaxFields = {
  __typename?: 'RecommendationInteractionsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  interactedAt?: Maybe<Scalars['timestamptz']>;
  recommendationGuid?: Maybe<Scalars['uuid']>;
  recommendationInteractionGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "recommendation_interactions" */
export type RecommendationInteractionsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  interactedAt?: InputMaybe<OrderBy>;
  recommendationGuid?: InputMaybe<OrderBy>;
  recommendationInteractionGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RecommendationInteractionsMinFields = {
  __typename?: 'RecommendationInteractionsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  interactedAt?: Maybe<Scalars['timestamptz']>;
  recommendationGuid?: Maybe<Scalars['uuid']>;
  recommendationInteractionGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "recommendation_interactions" */
export type RecommendationInteractionsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  interactedAt?: InputMaybe<OrderBy>;
  recommendationGuid?: InputMaybe<OrderBy>;
  recommendationInteractionGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "recommendation_interactions" */
export type RecommendationInteractionsMutationResponse = {
  __typename?: 'RecommendationInteractionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RecommendationInteractions>;
};

/** on_conflict condition type for table "recommendation_interactions" */
export type RecommendationInteractionsOnConflict = {
  constraint: RecommendationInteractionsConstraint;
  updateColumns?: Array<RecommendationInteractionsUpdateColumn>;
  where?: InputMaybe<RecommendationInteractionsBoolExp>;
};

/** Ordering options when selecting data from "recommendation_interactions". */
export type RecommendationInteractionsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  interactedAt?: InputMaybe<OrderBy>;
  recommendationGuid?: InputMaybe<OrderBy>;
  recommendationInteractionGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: recommendation_interactions */
export type RecommendationInteractionsPkColumnsInput = {
  recommendationInteractionGuid: Scalars['uuid'];
};

/** select columns of table "recommendation_interactions" */
export type RecommendationInteractionsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'interactedAt'
  /** column name */
  | 'recommendationGuid'
  /** column name */
  | 'recommendationInteractionGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "recommendation_interactions" */
export type RecommendationInteractionsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  interactedAt?: InputMaybe<Scalars['timestamptz']>;
  recommendationGuid?: InputMaybe<Scalars['uuid']>;
  recommendationInteractionGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "recommendation_interactions" */
export type RecommendationInteractionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecommendationInteractionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecommendationInteractionsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  interactedAt?: InputMaybe<Scalars['timestamptz']>;
  recommendationGuid?: InputMaybe<Scalars['uuid']>;
  recommendationInteractionGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "recommendation_interactions" */
export type RecommendationInteractionsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'interactedAt'
  /** column name */
  | 'recommendationGuid'
  /** column name */
  | 'recommendationInteractionGuid'
  /** column name */
  | 'userGuid';

export type RecommendationInteractionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecommendationInteractionsSetInput>;
  /** filter the rows which have to be updated */
  where: RecommendationInteractionsBoolExp;
};

/** columns and relationships of "recommendations" */
export type Recommendations = {
  __typename?: 'Recommendations';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  completedAt?: Maybe<Scalars['timestamptz']>;
  completedByUserGuid?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamptz'];
  ctaButtonText: Scalars['String'];
  ctaButtonUrl: Scalars['String'];
  ctaMarkdown: Scalars['String'];
  ctaText: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  deletedByUserGuid?: Maybe<Scalars['uuid']>;
  description: Scalars['String'];
  recommendAt: Scalars['timestamptz'];
  recommendUntil: Scalars['timestamptz'];
  /** An array relationship */
  recommendationDismissals: Array<RecommendationDismissals>;
  /** An aggregate relationship */
  recommendationDismissalsAggregate: RecommendationDismissalsAggregate;
  recommendationGuid: Scalars['uuid'];
  /** An array relationship */
  recommendationInteractions: Array<RecommendationInteractions>;
  /** An aggregate relationship */
  recommendationInteractionsAggregate: RecommendationInteractionsAggregate;
  recommendationType: Scalars['String'];
  valueExpectedDescription?: Maybe<Scalars['String']>;
  valueExpectedUsc?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "recommendations" */
export type RecommendationsRecommendationDismissalsArgs = {
  distinctOn?: InputMaybe<Array<RecommendationDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationDismissalsOrderBy>>;
  where?: InputMaybe<RecommendationDismissalsBoolExp>;
};


/** columns and relationships of "recommendations" */
export type RecommendationsRecommendationDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecommendationDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationDismissalsOrderBy>>;
  where?: InputMaybe<RecommendationDismissalsBoolExp>;
};


/** columns and relationships of "recommendations" */
export type RecommendationsRecommendationInteractionsArgs = {
  distinctOn?: InputMaybe<Array<RecommendationInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationInteractionsOrderBy>>;
  where?: InputMaybe<RecommendationInteractionsBoolExp>;
};


/** columns and relationships of "recommendations" */
export type RecommendationsRecommendationInteractionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecommendationInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationInteractionsOrderBy>>;
  where?: InputMaybe<RecommendationInteractionsBoolExp>;
};

/** aggregated selection of "recommendations" */
export type RecommendationsAggregate = {
  __typename?: 'RecommendationsAggregate';
  aggregate?: Maybe<RecommendationsAggregateFields>;
  nodes: Array<Recommendations>;
};

/** aggregate fields of "recommendations" */
export type RecommendationsAggregateFields = {
  __typename?: 'RecommendationsAggregateFields';
  avg?: Maybe<RecommendationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RecommendationsMaxFields>;
  min?: Maybe<RecommendationsMinFields>;
  stddev?: Maybe<RecommendationsStddevFields>;
  stddevPop?: Maybe<RecommendationsStddevPopFields>;
  stddevSamp?: Maybe<RecommendationsStddevSampFields>;
  sum?: Maybe<RecommendationsSumFields>;
  varPop?: Maybe<RecommendationsVarPopFields>;
  varSamp?: Maybe<RecommendationsVarSampFields>;
  variance?: Maybe<RecommendationsVarianceFields>;
};


/** aggregate fields of "recommendations" */
export type RecommendationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecommendationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type RecommendationsAvgFields = {
  __typename?: 'RecommendationsAvgFields';
  valueExpectedUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "recommendations". All fields are combined with a logical 'AND'. */
export type RecommendationsBoolExp = {
  _and?: InputMaybe<Array<RecommendationsBoolExp>>;
  _not?: InputMaybe<RecommendationsBoolExp>;
  _or?: InputMaybe<Array<RecommendationsBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  completedByUserGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  ctaButtonText?: InputMaybe<StringComparisonExp>;
  ctaButtonUrl?: InputMaybe<StringComparisonExp>;
  ctaMarkdown?: InputMaybe<StringComparisonExp>;
  ctaText?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedByUserGuid?: InputMaybe<UuidComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  recommendAt?: InputMaybe<TimestamptzComparisonExp>;
  recommendUntil?: InputMaybe<TimestamptzComparisonExp>;
  recommendationDismissals?: InputMaybe<RecommendationDismissalsBoolExp>;
  recommendationDismissalsAggregate?: InputMaybe<RecommendationDismissalsAggregateBoolExp>;
  recommendationGuid?: InputMaybe<UuidComparisonExp>;
  recommendationInteractions?: InputMaybe<RecommendationInteractionsBoolExp>;
  recommendationInteractionsAggregate?: InputMaybe<RecommendationInteractionsAggregateBoolExp>;
  recommendationType?: InputMaybe<StringComparisonExp>;
  valueExpectedDescription?: InputMaybe<StringComparisonExp>;
  valueExpectedUsc?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "recommendations" */
export type RecommendationsConstraint =
  /** unique or primary key constraint on columns "recommendation_guid" */
  | 'recommendations_pkey';

/** input type for incrementing numeric columns in table "recommendations" */
export type RecommendationsIncInput = {
  valueExpectedUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "recommendations" */
export type RecommendationsInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  completedByUserGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ctaButtonText?: InputMaybe<Scalars['String']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']>;
  ctaMarkdown?: InputMaybe<Scalars['String']>;
  ctaText?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deletedByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  recommendAt?: InputMaybe<Scalars['timestamptz']>;
  recommendUntil?: InputMaybe<Scalars['timestamptz']>;
  recommendationDismissals?: InputMaybe<RecommendationDismissalsArrRelInsertInput>;
  recommendationGuid?: InputMaybe<Scalars['uuid']>;
  recommendationInteractions?: InputMaybe<RecommendationInteractionsArrRelInsertInput>;
  recommendationType?: InputMaybe<Scalars['String']>;
  valueExpectedDescription?: InputMaybe<Scalars['String']>;
  valueExpectedUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type RecommendationsMaxFields = {
  __typename?: 'RecommendationsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  completedByUserGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  ctaButtonText?: Maybe<Scalars['String']>;
  ctaButtonUrl?: Maybe<Scalars['String']>;
  ctaMarkdown?: Maybe<Scalars['String']>;
  ctaText?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  deletedByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  recommendAt?: Maybe<Scalars['timestamptz']>;
  recommendUntil?: Maybe<Scalars['timestamptz']>;
  recommendationGuid?: Maybe<Scalars['uuid']>;
  recommendationType?: Maybe<Scalars['String']>;
  valueExpectedDescription?: Maybe<Scalars['String']>;
  valueExpectedUsc?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type RecommendationsMinFields = {
  __typename?: 'RecommendationsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  completedByUserGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  ctaButtonText?: Maybe<Scalars['String']>;
  ctaButtonUrl?: Maybe<Scalars['String']>;
  ctaMarkdown?: Maybe<Scalars['String']>;
  ctaText?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  deletedByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  recommendAt?: Maybe<Scalars['timestamptz']>;
  recommendUntil?: Maybe<Scalars['timestamptz']>;
  recommendationGuid?: Maybe<Scalars['uuid']>;
  recommendationType?: Maybe<Scalars['String']>;
  valueExpectedDescription?: Maybe<Scalars['String']>;
  valueExpectedUsc?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "recommendations" */
export type RecommendationsMutationResponse = {
  __typename?: 'RecommendationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Recommendations>;
};

/** on_conflict condition type for table "recommendations" */
export type RecommendationsOnConflict = {
  constraint: RecommendationsConstraint;
  updateColumns?: Array<RecommendationsUpdateColumn>;
  where?: InputMaybe<RecommendationsBoolExp>;
};

/** Ordering options when selecting data from "recommendations". */
export type RecommendationsOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  completedByUserGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  ctaButtonText?: InputMaybe<OrderBy>;
  ctaButtonUrl?: InputMaybe<OrderBy>;
  ctaMarkdown?: InputMaybe<OrderBy>;
  ctaText?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  deletedByUserGuid?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  recommendAt?: InputMaybe<OrderBy>;
  recommendUntil?: InputMaybe<OrderBy>;
  recommendationDismissalsAggregate?: InputMaybe<RecommendationDismissalsAggregateOrderBy>;
  recommendationGuid?: InputMaybe<OrderBy>;
  recommendationInteractionsAggregate?: InputMaybe<RecommendationInteractionsAggregateOrderBy>;
  recommendationType?: InputMaybe<OrderBy>;
  valueExpectedDescription?: InputMaybe<OrderBy>;
  valueExpectedUsc?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: recommendations */
export type RecommendationsPkColumnsInput = {
  recommendationGuid: Scalars['uuid'];
};

/** select columns of table "recommendations" */
export type RecommendationsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'completedAt'
  /** column name */
  | 'completedByUserGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'ctaButtonText'
  /** column name */
  | 'ctaButtonUrl'
  /** column name */
  | 'ctaMarkdown'
  /** column name */
  | 'ctaText'
  /** column name */
  | 'deletedAt'
  /** column name */
  | 'deletedByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'recommendAt'
  /** column name */
  | 'recommendUntil'
  /** column name */
  | 'recommendationGuid'
  /** column name */
  | 'recommendationType'
  /** column name */
  | 'valueExpectedDescription'
  /** column name */
  | 'valueExpectedUsc';

/** input type for updating data in table "recommendations" */
export type RecommendationsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  completedByUserGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ctaButtonText?: InputMaybe<Scalars['String']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']>;
  ctaMarkdown?: InputMaybe<Scalars['String']>;
  ctaText?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deletedByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  recommendAt?: InputMaybe<Scalars['timestamptz']>;
  recommendUntil?: InputMaybe<Scalars['timestamptz']>;
  recommendationGuid?: InputMaybe<Scalars['uuid']>;
  recommendationType?: InputMaybe<Scalars['String']>;
  valueExpectedDescription?: InputMaybe<Scalars['String']>;
  valueExpectedUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type RecommendationsStddevFields = {
  __typename?: 'RecommendationsStddevFields';
  valueExpectedUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type RecommendationsStddevPopFields = {
  __typename?: 'RecommendationsStddevPopFields';
  valueExpectedUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type RecommendationsStddevSampFields = {
  __typename?: 'RecommendationsStddevSampFields';
  valueExpectedUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "recommendations" */
export type RecommendationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecommendationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecommendationsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  completedByUserGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  ctaButtonText?: InputMaybe<Scalars['String']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']>;
  ctaMarkdown?: InputMaybe<Scalars['String']>;
  ctaText?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deletedByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  recommendAt?: InputMaybe<Scalars['timestamptz']>;
  recommendUntil?: InputMaybe<Scalars['timestamptz']>;
  recommendationGuid?: InputMaybe<Scalars['uuid']>;
  recommendationType?: InputMaybe<Scalars['String']>;
  valueExpectedDescription?: InputMaybe<Scalars['String']>;
  valueExpectedUsc?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type RecommendationsSumFields = {
  __typename?: 'RecommendationsSumFields';
  valueExpectedUsc?: Maybe<Scalars['Int']>;
};

/** update columns of table "recommendations" */
export type RecommendationsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'completedAt'
  /** column name */
  | 'completedByUserGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'ctaButtonText'
  /** column name */
  | 'ctaButtonUrl'
  /** column name */
  | 'ctaMarkdown'
  /** column name */
  | 'ctaText'
  /** column name */
  | 'deletedAt'
  /** column name */
  | 'deletedByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'recommendAt'
  /** column name */
  | 'recommendUntil'
  /** column name */
  | 'recommendationGuid'
  /** column name */
  | 'recommendationType'
  /** column name */
  | 'valueExpectedDescription'
  /** column name */
  | 'valueExpectedUsc';

export type RecommendationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RecommendationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecommendationsSetInput>;
  /** filter the rows which have to be updated */
  where: RecommendationsBoolExp;
};

/** aggregate varPop on columns */
export type RecommendationsVarPopFields = {
  __typename?: 'RecommendationsVarPopFields';
  valueExpectedUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type RecommendationsVarSampFields = {
  __typename?: 'RecommendationsVarSampFields';
  valueExpectedUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RecommendationsVarianceFields = {
  __typename?: 'RecommendationsVarianceFields';
  valueExpectedUsc?: Maybe<Scalars['Float']>;
};

/** Users are assigned to Reminders */
export type ReminderAssignments = {
  __typename?: 'ReminderAssignments';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  reminder: Reminders;
  reminderAssignmentGuid: Scalars['uuid'];
  reminderGuid: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "reminder_assignments" */
export type ReminderAssignmentsAggregate = {
  __typename?: 'ReminderAssignmentsAggregate';
  aggregate?: Maybe<ReminderAssignmentsAggregateFields>;
  nodes: Array<ReminderAssignments>;
};

export type ReminderAssignmentsAggregateBoolExp = {
  count?: InputMaybe<ReminderAssignmentsAggregateBoolExpCount>;
};

/** aggregate fields of "reminder_assignments" */
export type ReminderAssignmentsAggregateFields = {
  __typename?: 'ReminderAssignmentsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ReminderAssignmentsMaxFields>;
  min?: Maybe<ReminderAssignmentsMinFields>;
};


/** aggregate fields of "reminder_assignments" */
export type ReminderAssignmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReminderAssignmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "reminder_assignments" */
export type ReminderAssignmentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ReminderAssignmentsMaxOrderBy>;
  min?: InputMaybe<ReminderAssignmentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "reminder_assignments" */
export type ReminderAssignmentsArrRelInsertInput = {
  data: Array<ReminderAssignmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ReminderAssignmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "reminder_assignments". All fields are combined with a logical 'AND'. */
export type ReminderAssignmentsBoolExp = {
  _and?: InputMaybe<Array<ReminderAssignmentsBoolExp>>;
  _not?: InputMaybe<ReminderAssignmentsBoolExp>;
  _or?: InputMaybe<Array<ReminderAssignmentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  reminder?: InputMaybe<RemindersBoolExp>;
  reminderAssignmentGuid?: InputMaybe<UuidComparisonExp>;
  reminderGuid?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "reminder_assignments" */
export type ReminderAssignmentsConstraint =
  /** unique or primary key constraint on columns "reminder_assignment_guid" */
  | 'reminder_assignments_pkey';

/** input type for inserting data into table "reminder_assignments" */
export type ReminderAssignmentsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  reminder?: InputMaybe<RemindersObjRelInsertInput>;
  reminderAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type ReminderAssignmentsMaxFields = {
  __typename?: 'ReminderAssignmentsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  reminderAssignmentGuid?: Maybe<Scalars['uuid']>;
  reminderGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "reminder_assignments" */
export type ReminderAssignmentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  reminderAssignmentGuid?: InputMaybe<OrderBy>;
  reminderGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ReminderAssignmentsMinFields = {
  __typename?: 'ReminderAssignmentsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  reminderAssignmentGuid?: Maybe<Scalars['uuid']>;
  reminderGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "reminder_assignments" */
export type ReminderAssignmentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  reminderAssignmentGuid?: InputMaybe<OrderBy>;
  reminderGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "reminder_assignments" */
export type ReminderAssignmentsMutationResponse = {
  __typename?: 'ReminderAssignmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ReminderAssignments>;
};

/** on_conflict condition type for table "reminder_assignments" */
export type ReminderAssignmentsOnConflict = {
  constraint: ReminderAssignmentsConstraint;
  updateColumns?: Array<ReminderAssignmentsUpdateColumn>;
  where?: InputMaybe<ReminderAssignmentsBoolExp>;
};

/** Ordering options when selecting data from "reminder_assignments". */
export type ReminderAssignmentsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  reminder?: InputMaybe<RemindersOrderBy>;
  reminderAssignmentGuid?: InputMaybe<OrderBy>;
  reminderGuid?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: reminder_assignments */
export type ReminderAssignmentsPkColumnsInput = {
  reminderAssignmentGuid: Scalars['uuid'];
};

/** select columns of table "reminder_assignments" */
export type ReminderAssignmentsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'reminderAssignmentGuid'
  /** column name */
  | 'reminderGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "reminder_assignments" */
export type ReminderAssignmentsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  reminderAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "reminder_assignments" */
export type ReminderAssignmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReminderAssignmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReminderAssignmentsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  reminderAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "reminder_assignments" */
export type ReminderAssignmentsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'reminderAssignmentGuid'
  /** column name */
  | 'reminderGuid'
  /** column name */
  | 'userGuid';

export type ReminderAssignmentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReminderAssignmentsSetInput>;
  /** filter the rows which have to be updated */
  where: ReminderAssignmentsBoolExp;
};

export type ReminderInternalNotificationTypeEnum =
  | 'ACCOUNT_REMINDER_DUE';

/** Boolean expression to compare columns of type "ReminderInternalNotificationTypeEnum". All fields are combined with logical 'AND'. */
export type ReminderInternalNotificationTypeEnumComparisonExp = {
  _eq?: InputMaybe<ReminderInternalNotificationTypeEnum>;
  _in?: InputMaybe<Array<ReminderInternalNotificationTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ReminderInternalNotificationTypeEnum>;
  _nin?: InputMaybe<Array<ReminderInternalNotificationTypeEnum>>;
};

/** Table to keep track of internal notifications sent for reminders */
export type ReminderInternalNotifications = {
  __typename?: 'ReminderInternalNotifications';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  internalNotification: InternalNotifications;
  internalNotificationGuid: Scalars['uuid'];
  /** An object relationship */
  reminder: Reminders;
  reminderGuid: Scalars['uuid'];
  type: ReminderInternalNotificationTypeEnum;
};

/** aggregated selection of "reminder_internal_notifications" */
export type ReminderInternalNotificationsAggregate = {
  __typename?: 'ReminderInternalNotificationsAggregate';
  aggregate?: Maybe<ReminderInternalNotificationsAggregateFields>;
  nodes: Array<ReminderInternalNotifications>;
};

/** aggregate fields of "reminder_internal_notifications" */
export type ReminderInternalNotificationsAggregateFields = {
  __typename?: 'ReminderInternalNotificationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<ReminderInternalNotificationsMaxFields>;
  min?: Maybe<ReminderInternalNotificationsMinFields>;
};


/** aggregate fields of "reminder_internal_notifications" */
export type ReminderInternalNotificationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReminderInternalNotificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "reminder_internal_notifications". All fields are combined with a logical 'AND'. */
export type ReminderInternalNotificationsBoolExp = {
  _and?: InputMaybe<Array<ReminderInternalNotificationsBoolExp>>;
  _not?: InputMaybe<ReminderInternalNotificationsBoolExp>;
  _or?: InputMaybe<Array<ReminderInternalNotificationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  internalNotification?: InputMaybe<InternalNotificationsBoolExp>;
  internalNotificationGuid?: InputMaybe<UuidComparisonExp>;
  reminder?: InputMaybe<RemindersBoolExp>;
  reminderGuid?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<ReminderInternalNotificationTypeEnumComparisonExp>;
};

/** unique or primary key constraints on table "reminder_internal_notifications" */
export type ReminderInternalNotificationsConstraint =
  /** unique or primary key constraint on columns "reminder_guid", "internal_notification_guid", "type" */
  | 'reminder_internal_notifications_pkey';

/** input type for inserting data into table "reminder_internal_notifications" */
export type ReminderInternalNotificationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  internalNotification?: InputMaybe<InternalNotificationsObjRelInsertInput>;
  internalNotificationGuid?: InputMaybe<Scalars['uuid']>;
  reminder?: InputMaybe<RemindersObjRelInsertInput>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<ReminderInternalNotificationTypeEnum>;
};

/** aggregate max on columns */
export type ReminderInternalNotificationsMaxFields = {
  __typename?: 'ReminderInternalNotificationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  internalNotificationGuid?: Maybe<Scalars['uuid']>;
  reminderGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type ReminderInternalNotificationsMinFields = {
  __typename?: 'ReminderInternalNotificationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  internalNotificationGuid?: Maybe<Scalars['uuid']>;
  reminderGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "reminder_internal_notifications" */
export type ReminderInternalNotificationsMutationResponse = {
  __typename?: 'ReminderInternalNotificationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ReminderInternalNotifications>;
};

/** input type for inserting object relation for remote table "reminder_internal_notifications" */
export type ReminderInternalNotificationsObjRelInsertInput = {
  data: ReminderInternalNotificationsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ReminderInternalNotificationsOnConflict>;
};

/** on_conflict condition type for table "reminder_internal_notifications" */
export type ReminderInternalNotificationsOnConflict = {
  constraint: ReminderInternalNotificationsConstraint;
  updateColumns?: Array<ReminderInternalNotificationsUpdateColumn>;
  where?: InputMaybe<ReminderInternalNotificationsBoolExp>;
};

/** Ordering options when selecting data from "reminder_internal_notifications". */
export type ReminderInternalNotificationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  internalNotification?: InputMaybe<InternalNotificationsOrderBy>;
  internalNotificationGuid?: InputMaybe<OrderBy>;
  reminder?: InputMaybe<RemindersOrderBy>;
  reminderGuid?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: reminder_internal_notifications */
export type ReminderInternalNotificationsPkColumnsInput = {
  internalNotificationGuid: Scalars['uuid'];
  reminderGuid: Scalars['uuid'];
  type: ReminderInternalNotificationTypeEnum;
};

/** select columns of table "reminder_internal_notifications" */
export type ReminderInternalNotificationsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'internalNotificationGuid'
  /** column name */
  | 'reminderGuid'
  /** column name */
  | 'type';

/** input type for updating data in table "reminder_internal_notifications" */
export type ReminderInternalNotificationsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  internalNotificationGuid?: InputMaybe<Scalars['uuid']>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<ReminderInternalNotificationTypeEnum>;
};

/** Streaming cursor of the table "reminder_internal_notifications" */
export type ReminderInternalNotificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReminderInternalNotificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReminderInternalNotificationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  internalNotificationGuid?: InputMaybe<Scalars['uuid']>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<ReminderInternalNotificationTypeEnum>;
};

/** update columns of table "reminder_internal_notifications" */
export type ReminderInternalNotificationsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'internalNotificationGuid'
  /** column name */
  | 'reminderGuid'
  /** column name */
  | 'type';

export type ReminderInternalNotificationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReminderInternalNotificationsSetInput>;
  /** filter the rows which have to be updated */
  where: ReminderInternalNotificationsBoolExp;
};

export type ReminderStatusTypesEnum =
  | 'COMPLETE'
  | 'INCOMPLETE';

/** Boolean expression to compare columns of type "ReminderStatusTypesEnum". All fields are combined with logical 'AND'. */
export type ReminderStatusTypesEnumComparisonExp = {
  _eq?: InputMaybe<ReminderStatusTypesEnum>;
  _in?: InputMaybe<Array<ReminderStatusTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ReminderStatusTypesEnum>;
  _nin?: InputMaybe<Array<ReminderStatusTypesEnum>>;
};

/** Reminders throughout the system */
export type Reminders = {
  __typename?: 'Reminders';
  /** An array relationship */
  accountReminders: Array<AccountReminders>;
  /** An aggregate relationship */
  accountRemindersAggregate: AccountRemindersAggregate;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  description: Scalars['String'];
  dueAt: Scalars['timestamptz'];
  /** An array relationship */
  reminderAssignments: Array<ReminderAssignments>;
  /** An aggregate relationship */
  reminderAssignmentsAggregate: ReminderAssignmentsAggregate;
  reminderGuid: Scalars['uuid'];
  /** An object relationship */
  reminderInternalNotification?: Maybe<ReminderInternalNotifications>;
  status: ReminderStatusTypesEnum;
  updatedAt: Scalars['timestamptz'];
};


/** Reminders throughout the system */
export type RemindersAccountRemindersArgs = {
  distinctOn?: InputMaybe<Array<AccountRemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountRemindersOrderBy>>;
  where?: InputMaybe<AccountRemindersBoolExp>;
};


/** Reminders throughout the system */
export type RemindersAccountRemindersAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountRemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountRemindersOrderBy>>;
  where?: InputMaybe<AccountRemindersBoolExp>;
};


/** Reminders throughout the system */
export type RemindersReminderAssignmentsArgs = {
  distinctOn?: InputMaybe<Array<ReminderAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderAssignmentsOrderBy>>;
  where?: InputMaybe<ReminderAssignmentsBoolExp>;
};


/** Reminders throughout the system */
export type RemindersReminderAssignmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReminderAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderAssignmentsOrderBy>>;
  where?: InputMaybe<ReminderAssignmentsBoolExp>;
};

/** aggregated selection of "reminders" */
export type RemindersAggregate = {
  __typename?: 'RemindersAggregate';
  aggregate?: Maybe<RemindersAggregateFields>;
  nodes: Array<Reminders>;
};

/** aggregate fields of "reminders" */
export type RemindersAggregateFields = {
  __typename?: 'RemindersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<RemindersMaxFields>;
  min?: Maybe<RemindersMinFields>;
};


/** aggregate fields of "reminders" */
export type RemindersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RemindersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "reminders". All fields are combined with a logical 'AND'. */
export type RemindersBoolExp = {
  _and?: InputMaybe<Array<RemindersBoolExp>>;
  _not?: InputMaybe<RemindersBoolExp>;
  _or?: InputMaybe<Array<RemindersBoolExp>>;
  accountReminders?: InputMaybe<AccountRemindersBoolExp>;
  accountRemindersAggregate?: InputMaybe<AccountRemindersAggregateBoolExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  dueAt?: InputMaybe<TimestamptzComparisonExp>;
  reminderAssignments?: InputMaybe<ReminderAssignmentsBoolExp>;
  reminderAssignmentsAggregate?: InputMaybe<ReminderAssignmentsAggregateBoolExp>;
  reminderGuid?: InputMaybe<UuidComparisonExp>;
  reminderInternalNotification?: InputMaybe<ReminderInternalNotificationsBoolExp>;
  status?: InputMaybe<ReminderStatusTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "reminders" */
export type RemindersConstraint =
  /** unique or primary key constraint on columns "reminder_guid" */
  | 'reminders_pkey';

/** input type for inserting data into table "reminders" */
export type RemindersInsertInput = {
  accountReminders?: InputMaybe<AccountRemindersArrRelInsertInput>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  reminderAssignments?: InputMaybe<ReminderAssignmentsArrRelInsertInput>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
  reminderInternalNotification?: InputMaybe<ReminderInternalNotificationsObjRelInsertInput>;
  status?: InputMaybe<ReminderStatusTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RemindersMaxFields = {
  __typename?: 'RemindersMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  reminderGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type RemindersMinFields = {
  __typename?: 'RemindersMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  reminderGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "reminders" */
export type RemindersMutationResponse = {
  __typename?: 'RemindersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Reminders>;
};

/** input type for inserting object relation for remote table "reminders" */
export type RemindersObjRelInsertInput = {
  data: RemindersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RemindersOnConflict>;
};

/** on_conflict condition type for table "reminders" */
export type RemindersOnConflict = {
  constraint: RemindersConstraint;
  updateColumns?: Array<RemindersUpdateColumn>;
  where?: InputMaybe<RemindersBoolExp>;
};

/** Ordering options when selecting data from "reminders". */
export type RemindersOrderBy = {
  accountRemindersAggregate?: InputMaybe<AccountRemindersAggregateOrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  reminderAssignmentsAggregate?: InputMaybe<ReminderAssignmentsAggregateOrderBy>;
  reminderGuid?: InputMaybe<OrderBy>;
  reminderInternalNotification?: InputMaybe<ReminderInternalNotificationsOrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: reminders */
export type RemindersPkColumnsInput = {
  reminderGuid: Scalars['uuid'];
};

/** select columns of table "reminders" */
export type RemindersSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'reminderGuid'
  /** column name */
  | 'status'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "reminders" */
export type RemindersSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<ReminderStatusTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "reminders" */
export type RemindersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RemindersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RemindersStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<ReminderStatusTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "reminders" */
export type RemindersUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'reminderGuid'
  /** column name */
  | 'status'
  /** column name */
  | 'updatedAt';

export type RemindersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RemindersSetInput>;
  /** filter the rows which have to be updated */
  where: RemindersBoolExp;
};

/** Company Reporting Metabase Config */
export type RepCompanyMetabaseConfig = {
  __typename?: 'RepCompanyMetabaseConfig';
  companyGuid: Scalars['uuid'];
  companyMetabaseUserEmail: Scalars['String'];
};

/** aggregated selection of "rep_company_metabase_config" */
export type RepCompanyMetabaseConfigAggregate = {
  __typename?: 'RepCompanyMetabaseConfigAggregate';
  aggregate?: Maybe<RepCompanyMetabaseConfigAggregateFields>;
  nodes: Array<RepCompanyMetabaseConfig>;
};

/** aggregate fields of "rep_company_metabase_config" */
export type RepCompanyMetabaseConfigAggregateFields = {
  __typename?: 'RepCompanyMetabaseConfigAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<RepCompanyMetabaseConfigMaxFields>;
  min?: Maybe<RepCompanyMetabaseConfigMinFields>;
};


/** aggregate fields of "rep_company_metabase_config" */
export type RepCompanyMetabaseConfigAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RepCompanyMetabaseConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "rep_company_metabase_config". All fields are combined with a logical 'AND'. */
export type RepCompanyMetabaseConfigBoolExp = {
  _and?: InputMaybe<Array<RepCompanyMetabaseConfigBoolExp>>;
  _not?: InputMaybe<RepCompanyMetabaseConfigBoolExp>;
  _or?: InputMaybe<Array<RepCompanyMetabaseConfigBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  companyMetabaseUserEmail?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "rep_company_metabase_config" */
export type RepCompanyMetabaseConfigConstraint =
  /** unique or primary key constraint on columns "company_guid" */
  | 'rep_company_metabase_config_pkey';

/** input type for inserting data into table "rep_company_metabase_config" */
export type RepCompanyMetabaseConfigInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyMetabaseUserEmail?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RepCompanyMetabaseConfigMaxFields = {
  __typename?: 'RepCompanyMetabaseConfigMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  companyMetabaseUserEmail?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RepCompanyMetabaseConfigMinFields = {
  __typename?: 'RepCompanyMetabaseConfigMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  companyMetabaseUserEmail?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "rep_company_metabase_config" */
export type RepCompanyMetabaseConfigMutationResponse = {
  __typename?: 'RepCompanyMetabaseConfigMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RepCompanyMetabaseConfig>;
};

/** on_conflict condition type for table "rep_company_metabase_config" */
export type RepCompanyMetabaseConfigOnConflict = {
  constraint: RepCompanyMetabaseConfigConstraint;
  updateColumns?: Array<RepCompanyMetabaseConfigUpdateColumn>;
  where?: InputMaybe<RepCompanyMetabaseConfigBoolExp>;
};

/** Ordering options when selecting data from "rep_company_metabase_config". */
export type RepCompanyMetabaseConfigOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  companyMetabaseUserEmail?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rep_company_metabase_config */
export type RepCompanyMetabaseConfigPkColumnsInput = {
  companyGuid: Scalars['uuid'];
};

/** select columns of table "rep_company_metabase_config" */
export type RepCompanyMetabaseConfigSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'companyMetabaseUserEmail';

/** input type for updating data in table "rep_company_metabase_config" */
export type RepCompanyMetabaseConfigSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyMetabaseUserEmail?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "rep_company_metabase_config" */
export type RepCompanyMetabaseConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RepCompanyMetabaseConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RepCompanyMetabaseConfigStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  companyMetabaseUserEmail?: InputMaybe<Scalars['String']>;
};

/** update columns of table "rep_company_metabase_config" */
export type RepCompanyMetabaseConfigUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'companyMetabaseUserEmail';

export type RepCompanyMetabaseConfigUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RepCompanyMetabaseConfigSetInput>;
  /** filter the rows which have to be updated */
  where: RepCompanyMetabaseConfigBoolExp;
};

/** Assign report definitions to companies */
export type RepMetabaseCompanyReports = {
  __typename?: 'RepMetabaseCompanyReports';
  assignedAt: Scalars['timestamptz'];
  companyGuid: Scalars['uuid'];
  /** An object relationship */
  repMetabaseReportDefinition: RepMetabaseReportDefinitions;
  reportGuid: Scalars['uuid'];
};

/** aggregated selection of "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsAggregate = {
  __typename?: 'RepMetabaseCompanyReportsAggregate';
  aggregate?: Maybe<RepMetabaseCompanyReportsAggregateFields>;
  nodes: Array<RepMetabaseCompanyReports>;
};

export type RepMetabaseCompanyReportsAggregateBoolExp = {
  count?: InputMaybe<RepMetabaseCompanyReportsAggregateBoolExpCount>;
};

/** aggregate fields of "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsAggregateFields = {
  __typename?: 'RepMetabaseCompanyReportsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<RepMetabaseCompanyReportsMaxFields>;
  min?: Maybe<RepMetabaseCompanyReportsMinFields>;
};


/** aggregate fields of "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RepMetabaseCompanyReportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RepMetabaseCompanyReportsMaxOrderBy>;
  min?: InputMaybe<RepMetabaseCompanyReportsMinOrderBy>;
};

/** input type for inserting array relation for remote table "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsArrRelInsertInput = {
  data: Array<RepMetabaseCompanyReportsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<RepMetabaseCompanyReportsOnConflict>;
};

/** Boolean expression to filter rows from the table "rep_metabase_company_reports". All fields are combined with a logical 'AND'. */
export type RepMetabaseCompanyReportsBoolExp = {
  _and?: InputMaybe<Array<RepMetabaseCompanyReportsBoolExp>>;
  _not?: InputMaybe<RepMetabaseCompanyReportsBoolExp>;
  _or?: InputMaybe<Array<RepMetabaseCompanyReportsBoolExp>>;
  assignedAt?: InputMaybe<TimestamptzComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  repMetabaseReportDefinition?: InputMaybe<RepMetabaseReportDefinitionsBoolExp>;
  reportGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsConstraint =
  /** unique or primary key constraint on columns "report_guid", "company_guid" */
  | 'rep_metabase_company_reports_pkey';

/** input type for inserting data into table "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsInsertInput = {
  assignedAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  repMetabaseReportDefinition?: InputMaybe<RepMetabaseReportDefinitionsObjRelInsertInput>;
  reportGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type RepMetabaseCompanyReportsMaxFields = {
  __typename?: 'RepMetabaseCompanyReportsMaxFields';
  assignedAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  reportGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsMaxOrderBy = {
  assignedAt?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  reportGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RepMetabaseCompanyReportsMinFields = {
  __typename?: 'RepMetabaseCompanyReportsMinFields';
  assignedAt?: Maybe<Scalars['timestamptz']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  reportGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsMinOrderBy = {
  assignedAt?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  reportGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsMutationResponse = {
  __typename?: 'RepMetabaseCompanyReportsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RepMetabaseCompanyReports>;
};

/** on_conflict condition type for table "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsOnConflict = {
  constraint: RepMetabaseCompanyReportsConstraint;
  updateColumns?: Array<RepMetabaseCompanyReportsUpdateColumn>;
  where?: InputMaybe<RepMetabaseCompanyReportsBoolExp>;
};

/** Ordering options when selecting data from "rep_metabase_company_reports". */
export type RepMetabaseCompanyReportsOrderBy = {
  assignedAt?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  repMetabaseReportDefinition?: InputMaybe<RepMetabaseReportDefinitionsOrderBy>;
  reportGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rep_metabase_company_reports */
export type RepMetabaseCompanyReportsPkColumnsInput = {
  companyGuid: Scalars['uuid'];
  reportGuid: Scalars['uuid'];
};

/** select columns of table "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsSelectColumn =
  /** column name */
  | 'assignedAt'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'reportGuid';

/** input type for updating data in table "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsSetInput = {
  assignedAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  reportGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RepMetabaseCompanyReportsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RepMetabaseCompanyReportsStreamCursorValueInput = {
  assignedAt?: InputMaybe<Scalars['timestamptz']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  reportGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "rep_metabase_company_reports" */
export type RepMetabaseCompanyReportsUpdateColumn =
  /** column name */
  | 'assignedAt'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'reportGuid';

export type RepMetabaseCompanyReportsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RepMetabaseCompanyReportsSetInput>;
  /** filter the rows which have to be updated */
  where: RepMetabaseCompanyReportsBoolExp;
};

/** A table for tracking the metadata of pulses created via Embedded Reporting */
export type RepMetabasePulses = {
  __typename?: 'RepMetabasePulses';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  isDeleted: Scalars['Boolean'];
  metabaseNumericDashboardId: Scalars['Int'];
  metabasePulseId: Scalars['Int'];
  pulseGuid: Scalars['uuid'];
  recipients: Scalars['EmbeddedReportingPulseRecipientArray'];
  /** An object relationship */
  repMetabaseReportDefinition: RepMetabaseReportDefinitions;
  reportGuid: Scalars['uuid'];
  scheduleDetails: Scalars['ScheduleDetails'];
  scheduleType: Scalars['EmbeddedReportingPulseScheduleType'];
  skipIfEmpty: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};


/** A table for tracking the metadata of pulses created via Embedded Reporting */
export type RepMetabasePulsesRecipientsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** A table for tracking the metadata of pulses created via Embedded Reporting */
export type RepMetabasePulsesScheduleDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "rep_metabase_pulses" */
export type RepMetabasePulsesAggregate = {
  __typename?: 'RepMetabasePulsesAggregate';
  aggregate?: Maybe<RepMetabasePulsesAggregateFields>;
  nodes: Array<RepMetabasePulses>;
};

/** aggregate fields of "rep_metabase_pulses" */
export type RepMetabasePulsesAggregateFields = {
  __typename?: 'RepMetabasePulsesAggregateFields';
  avg?: Maybe<RepMetabasePulsesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RepMetabasePulsesMaxFields>;
  min?: Maybe<RepMetabasePulsesMinFields>;
  stddev?: Maybe<RepMetabasePulsesStddevFields>;
  stddevPop?: Maybe<RepMetabasePulsesStddevPopFields>;
  stddevSamp?: Maybe<RepMetabasePulsesStddevSampFields>;
  sum?: Maybe<RepMetabasePulsesSumFields>;
  varPop?: Maybe<RepMetabasePulsesVarPopFields>;
  varSamp?: Maybe<RepMetabasePulsesVarSampFields>;
  variance?: Maybe<RepMetabasePulsesVarianceFields>;
};


/** aggregate fields of "rep_metabase_pulses" */
export type RepMetabasePulsesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RepMetabasePulsesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RepMetabasePulsesAppendInput = {
  recipients?: InputMaybe<Scalars['jsonb']>;
  scheduleDetails?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type RepMetabasePulsesAvgFields = {
  __typename?: 'RepMetabasePulsesAvgFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "rep_metabase_pulses". All fields are combined with a logical 'AND'. */
export type RepMetabasePulsesBoolExp = {
  _and?: InputMaybe<Array<RepMetabasePulsesBoolExp>>;
  _not?: InputMaybe<RepMetabasePulsesBoolExp>;
  _or?: InputMaybe<Array<RepMetabasePulsesBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  isDeleted?: InputMaybe<BooleanComparisonExp>;
  metabaseNumericDashboardId?: InputMaybe<IntComparisonExp>;
  metabasePulseId?: InputMaybe<IntComparisonExp>;
  pulseGuid?: InputMaybe<UuidComparisonExp>;
  recipients?: InputMaybe<Scalars['EmbeddedReportingPulseRecipientArrayComparisonExp']>;
  repMetabaseReportDefinition?: InputMaybe<RepMetabaseReportDefinitionsBoolExp>;
  reportGuid?: InputMaybe<UuidComparisonExp>;
  scheduleDetails?: InputMaybe<Scalars['ScheduleDetailsComparisonExp']>;
  scheduleType?: InputMaybe<Scalars['EmbeddedReportingPulseScheduleTypeComparisonExp']>;
  skipIfEmpty?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "rep_metabase_pulses" */
export type RepMetabasePulsesConstraint =
  /** unique or primary key constraint on columns "pulse_guid" */
  | 'rep_metabase_pulses_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RepMetabasePulsesDeleteAtPathInput = {
  recipients?: InputMaybe<Array<Scalars['String']>>;
  scheduleDetails?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RepMetabasePulsesDeleteElemInput = {
  recipients?: InputMaybe<Scalars['Int']>;
  scheduleDetails?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RepMetabasePulsesDeleteKeyInput = {
  recipients?: InputMaybe<Scalars['String']>;
  scheduleDetails?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "rep_metabase_pulses" */
export type RepMetabasePulsesIncInput = {
  metabaseNumericDashboardId?: InputMaybe<Scalars['Int']>;
  metabasePulseId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "rep_metabase_pulses" */
export type RepMetabasePulsesInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  metabaseNumericDashboardId?: InputMaybe<Scalars['Int']>;
  metabasePulseId?: InputMaybe<Scalars['Int']>;
  pulseGuid?: InputMaybe<Scalars['uuid']>;
  recipients?: InputMaybe<Scalars['EmbeddedReportingPulseRecipientArray']>;
  repMetabaseReportDefinition?: InputMaybe<RepMetabaseReportDefinitionsObjRelInsertInput>;
  reportGuid?: InputMaybe<Scalars['uuid']>;
  scheduleDetails?: InputMaybe<Scalars['ScheduleDetails']>;
  scheduleType?: InputMaybe<Scalars['EmbeddedReportingPulseScheduleType']>;
  skipIfEmpty?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RepMetabasePulsesMaxFields = {
  __typename?: 'RepMetabasePulsesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  metabaseNumericDashboardId?: Maybe<Scalars['Int']>;
  metabasePulseId?: Maybe<Scalars['Int']>;
  pulseGuid?: Maybe<Scalars['uuid']>;
  recipients?: Maybe<Scalars['EmbeddedReportingPulseRecipientArray']>;
  reportGuid?: Maybe<Scalars['uuid']>;
  scheduleDetails?: Maybe<Scalars['ScheduleDetails']>;
  scheduleType?: Maybe<Scalars['EmbeddedReportingPulseScheduleType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type RepMetabasePulsesMinFields = {
  __typename?: 'RepMetabasePulsesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  metabaseNumericDashboardId?: Maybe<Scalars['Int']>;
  metabasePulseId?: Maybe<Scalars['Int']>;
  pulseGuid?: Maybe<Scalars['uuid']>;
  recipients?: Maybe<Scalars['EmbeddedReportingPulseRecipientArray']>;
  reportGuid?: Maybe<Scalars['uuid']>;
  scheduleDetails?: Maybe<Scalars['ScheduleDetails']>;
  scheduleType?: Maybe<Scalars['EmbeddedReportingPulseScheduleType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "rep_metabase_pulses" */
export type RepMetabasePulsesMutationResponse = {
  __typename?: 'RepMetabasePulsesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RepMetabasePulses>;
};

/** on_conflict condition type for table "rep_metabase_pulses" */
export type RepMetabasePulsesOnConflict = {
  constraint: RepMetabasePulsesConstraint;
  updateColumns?: Array<RepMetabasePulsesUpdateColumn>;
  where?: InputMaybe<RepMetabasePulsesBoolExp>;
};

/** Ordering options when selecting data from "rep_metabase_pulses". */
export type RepMetabasePulsesOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  isDeleted?: InputMaybe<OrderBy>;
  metabaseNumericDashboardId?: InputMaybe<OrderBy>;
  metabasePulseId?: InputMaybe<OrderBy>;
  pulseGuid?: InputMaybe<OrderBy>;
  recipients?: InputMaybe<OrderBy>;
  repMetabaseReportDefinition?: InputMaybe<RepMetabaseReportDefinitionsOrderBy>;
  reportGuid?: InputMaybe<OrderBy>;
  scheduleDetails?: InputMaybe<OrderBy>;
  scheduleType?: InputMaybe<OrderBy>;
  skipIfEmpty?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rep_metabase_pulses */
export type RepMetabasePulsesPkColumnsInput = {
  pulseGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RepMetabasePulsesPrependInput = {
  recipients?: InputMaybe<Scalars['jsonb']>;
  scheduleDetails?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "rep_metabase_pulses" */
export type RepMetabasePulsesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'metabaseNumericDashboardId'
  /** column name */
  | 'metabasePulseId'
  /** column name */
  | 'pulseGuid'
  /** column name */
  | 'recipients'
  /** column name */
  | 'reportGuid'
  /** column name */
  | 'scheduleDetails'
  /** column name */
  | 'scheduleType'
  /** column name */
  | 'skipIfEmpty'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "rep_metabase_pulses" */
export type RepMetabasePulsesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  metabaseNumericDashboardId?: InputMaybe<Scalars['Int']>;
  metabasePulseId?: InputMaybe<Scalars['Int']>;
  pulseGuid?: InputMaybe<Scalars['uuid']>;
  recipients?: InputMaybe<Scalars['EmbeddedReportingPulseRecipientArray']>;
  reportGuid?: InputMaybe<Scalars['uuid']>;
  scheduleDetails?: InputMaybe<Scalars['ScheduleDetails']>;
  scheduleType?: InputMaybe<Scalars['EmbeddedReportingPulseScheduleType']>;
  skipIfEmpty?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type RepMetabasePulsesStddevFields = {
  __typename?: 'RepMetabasePulsesStddevFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type RepMetabasePulsesStddevPopFields = {
  __typename?: 'RepMetabasePulsesStddevPopFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type RepMetabasePulsesStddevSampFields = {
  __typename?: 'RepMetabasePulsesStddevSampFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "rep_metabase_pulses" */
export type RepMetabasePulsesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RepMetabasePulsesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RepMetabasePulsesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  metabaseNumericDashboardId?: InputMaybe<Scalars['Int']>;
  metabasePulseId?: InputMaybe<Scalars['Int']>;
  pulseGuid?: InputMaybe<Scalars['uuid']>;
  recipients?: InputMaybe<Scalars['EmbeddedReportingPulseRecipientArray']>;
  reportGuid?: InputMaybe<Scalars['uuid']>;
  scheduleDetails?: InputMaybe<Scalars['ScheduleDetails']>;
  scheduleType?: InputMaybe<Scalars['EmbeddedReportingPulseScheduleType']>;
  skipIfEmpty?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type RepMetabasePulsesSumFields = {
  __typename?: 'RepMetabasePulsesSumFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Int']>;
  metabasePulseId?: Maybe<Scalars['Int']>;
};

/** update columns of table "rep_metabase_pulses" */
export type RepMetabasePulsesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'metabaseNumericDashboardId'
  /** column name */
  | 'metabasePulseId'
  /** column name */
  | 'pulseGuid'
  /** column name */
  | 'recipients'
  /** column name */
  | 'reportGuid'
  /** column name */
  | 'scheduleDetails'
  /** column name */
  | 'scheduleType'
  /** column name */
  | 'skipIfEmpty'
  /** column name */
  | 'updatedAt';

export type RepMetabasePulsesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RepMetabasePulsesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<RepMetabasePulsesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<RepMetabasePulsesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<RepMetabasePulsesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RepMetabasePulsesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RepMetabasePulsesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RepMetabasePulsesSetInput>;
  /** filter the rows which have to be updated */
  where: RepMetabasePulsesBoolExp;
};

/** columns and relationships of "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2 = {
  __typename?: 'RepMetabasePulsesV2';
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  externalReportId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  metabaseNumericDashboardId: Scalars['Int'];
  metabasePulseId: Scalars['Int'];
  pulseGuid: Scalars['uuid'];
  recipients: Scalars['EmbeddedReportingPulseRecipientArray'];
  scheduleDetails: Scalars['ScheduleDetails'];
  scheduleType: Scalars['EmbeddedReportingPulseScheduleType'];
  skipIfEmpty: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2RecipientsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2ScheduleDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2Aggregate = {
  __typename?: 'RepMetabasePulsesV2Aggregate';
  aggregate?: Maybe<RepMetabasePulsesV2AggregateFields>;
  nodes: Array<RepMetabasePulsesV2>;
};

/** aggregate fields of "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2AggregateFields = {
  __typename?: 'RepMetabasePulsesV2AggregateFields';
  avg?: Maybe<RepMetabasePulsesV2AvgFields>;
  count: Scalars['Int'];
  max?: Maybe<RepMetabasePulsesV2MaxFields>;
  min?: Maybe<RepMetabasePulsesV2MinFields>;
  stddev?: Maybe<RepMetabasePulsesV2StddevFields>;
  stddevPop?: Maybe<RepMetabasePulsesV2StddevPopFields>;
  stddevSamp?: Maybe<RepMetabasePulsesV2StddevSampFields>;
  sum?: Maybe<RepMetabasePulsesV2SumFields>;
  varPop?: Maybe<RepMetabasePulsesV2VarPopFields>;
  varSamp?: Maybe<RepMetabasePulsesV2VarSampFields>;
  variance?: Maybe<RepMetabasePulsesV2VarianceFields>;
};


/** aggregate fields of "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2AggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RepMetabasePulsesV2SelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RepMetabasePulsesV2AppendInput = {
  recipients?: InputMaybe<Scalars['jsonb']>;
  scheduleDetails?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type RepMetabasePulsesV2AvgFields = {
  __typename?: 'RepMetabasePulsesV2AvgFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "rep_metabase_pulses_v2". All fields are combined with a logical 'AND'. */
export type RepMetabasePulsesV2BoolExp = {
  _and?: InputMaybe<Array<RepMetabasePulsesV2BoolExp>>;
  _not?: InputMaybe<RepMetabasePulsesV2BoolExp>;
  _or?: InputMaybe<Array<RepMetabasePulsesV2BoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalReportId?: InputMaybe<StringComparisonExp>;
  isDeleted?: InputMaybe<BooleanComparisonExp>;
  metabaseNumericDashboardId?: InputMaybe<IntComparisonExp>;
  metabasePulseId?: InputMaybe<IntComparisonExp>;
  pulseGuid?: InputMaybe<UuidComparisonExp>;
  recipients?: InputMaybe<Scalars['EmbeddedReportingPulseRecipientArrayComparisonExp']>;
  scheduleDetails?: InputMaybe<Scalars['ScheduleDetailsComparisonExp']>;
  scheduleType?: InputMaybe<Scalars['EmbeddedReportingPulseScheduleTypeComparisonExp']>;
  skipIfEmpty?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2Constraint =
  /** unique or primary key constraint on columns "pulse_guid" */
  | 'rep_metabase_pulses_v2_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RepMetabasePulsesV2DeleteAtPathInput = {
  recipients?: InputMaybe<Array<Scalars['String']>>;
  scheduleDetails?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RepMetabasePulsesV2DeleteElemInput = {
  recipients?: InputMaybe<Scalars['Int']>;
  scheduleDetails?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RepMetabasePulsesV2DeleteKeyInput = {
  recipients?: InputMaybe<Scalars['String']>;
  scheduleDetails?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2IncInput = {
  metabaseNumericDashboardId?: InputMaybe<Scalars['Int']>;
  metabasePulseId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2InsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalReportId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  metabaseNumericDashboardId?: InputMaybe<Scalars['Int']>;
  metabasePulseId?: InputMaybe<Scalars['Int']>;
  pulseGuid?: InputMaybe<Scalars['uuid']>;
  recipients?: InputMaybe<Scalars['EmbeddedReportingPulseRecipientArray']>;
  scheduleDetails?: InputMaybe<Scalars['ScheduleDetails']>;
  scheduleType?: InputMaybe<Scalars['EmbeddedReportingPulseScheduleType']>;
  skipIfEmpty?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RepMetabasePulsesV2MaxFields = {
  __typename?: 'RepMetabasePulsesV2MaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalReportId?: Maybe<Scalars['String']>;
  metabaseNumericDashboardId?: Maybe<Scalars['Int']>;
  metabasePulseId?: Maybe<Scalars['Int']>;
  pulseGuid?: Maybe<Scalars['uuid']>;
  recipients?: Maybe<Scalars['EmbeddedReportingPulseRecipientArray']>;
  scheduleDetails?: Maybe<Scalars['ScheduleDetails']>;
  scheduleType?: Maybe<Scalars['EmbeddedReportingPulseScheduleType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type RepMetabasePulsesV2MinFields = {
  __typename?: 'RepMetabasePulsesV2MinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalReportId?: Maybe<Scalars['String']>;
  metabaseNumericDashboardId?: Maybe<Scalars['Int']>;
  metabasePulseId?: Maybe<Scalars['Int']>;
  pulseGuid?: Maybe<Scalars['uuid']>;
  recipients?: Maybe<Scalars['EmbeddedReportingPulseRecipientArray']>;
  scheduleDetails?: Maybe<Scalars['ScheduleDetails']>;
  scheduleType?: Maybe<Scalars['EmbeddedReportingPulseScheduleType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2MutationResponse = {
  __typename?: 'RepMetabasePulsesV2MutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RepMetabasePulsesV2>;
};

/** on_conflict condition type for table "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2OnConflict = {
  constraint: RepMetabasePulsesV2Constraint;
  updateColumns?: Array<RepMetabasePulsesV2UpdateColumn>;
  where?: InputMaybe<RepMetabasePulsesV2BoolExp>;
};

/** Ordering options when selecting data from "rep_metabase_pulses_v2". */
export type RepMetabasePulsesV2OrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalReportId?: InputMaybe<OrderBy>;
  isDeleted?: InputMaybe<OrderBy>;
  metabaseNumericDashboardId?: InputMaybe<OrderBy>;
  metabasePulseId?: InputMaybe<OrderBy>;
  pulseGuid?: InputMaybe<OrderBy>;
  recipients?: InputMaybe<OrderBy>;
  scheduleDetails?: InputMaybe<OrderBy>;
  scheduleType?: InputMaybe<OrderBy>;
  skipIfEmpty?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rep_metabase_pulses_v2 */
export type RepMetabasePulsesV2PkColumnsInput = {
  pulseGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RepMetabasePulsesV2PrependInput = {
  recipients?: InputMaybe<Scalars['jsonb']>;
  scheduleDetails?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2SelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalReportId'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'metabaseNumericDashboardId'
  /** column name */
  | 'metabasePulseId'
  /** column name */
  | 'pulseGuid'
  /** column name */
  | 'recipients'
  /** column name */
  | 'scheduleDetails'
  /** column name */
  | 'scheduleType'
  /** column name */
  | 'skipIfEmpty'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2SetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalReportId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  metabaseNumericDashboardId?: InputMaybe<Scalars['Int']>;
  metabasePulseId?: InputMaybe<Scalars['Int']>;
  pulseGuid?: InputMaybe<Scalars['uuid']>;
  recipients?: InputMaybe<Scalars['EmbeddedReportingPulseRecipientArray']>;
  scheduleDetails?: InputMaybe<Scalars['ScheduleDetails']>;
  scheduleType?: InputMaybe<Scalars['EmbeddedReportingPulseScheduleType']>;
  skipIfEmpty?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type RepMetabasePulsesV2StddevFields = {
  __typename?: 'RepMetabasePulsesV2StddevFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type RepMetabasePulsesV2StddevPopFields = {
  __typename?: 'RepMetabasePulsesV2StddevPopFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type RepMetabasePulsesV2StddevSampFields = {
  __typename?: 'RepMetabasePulsesV2StddevSampFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2StreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RepMetabasePulsesV2StreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RepMetabasePulsesV2StreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalReportId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  metabaseNumericDashboardId?: InputMaybe<Scalars['Int']>;
  metabasePulseId?: InputMaybe<Scalars['Int']>;
  pulseGuid?: InputMaybe<Scalars['uuid']>;
  recipients?: InputMaybe<Scalars['EmbeddedReportingPulseRecipientArray']>;
  scheduleDetails?: InputMaybe<Scalars['ScheduleDetails']>;
  scheduleType?: InputMaybe<Scalars['EmbeddedReportingPulseScheduleType']>;
  skipIfEmpty?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type RepMetabasePulsesV2SumFields = {
  __typename?: 'RepMetabasePulsesV2SumFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Int']>;
  metabasePulseId?: Maybe<Scalars['Int']>;
};

/** update columns of table "rep_metabase_pulses_v2" */
export type RepMetabasePulsesV2UpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalReportId'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'metabaseNumericDashboardId'
  /** column name */
  | 'metabasePulseId'
  /** column name */
  | 'pulseGuid'
  /** column name */
  | 'recipients'
  /** column name */
  | 'scheduleDetails'
  /** column name */
  | 'scheduleType'
  /** column name */
  | 'skipIfEmpty'
  /** column name */
  | 'updatedAt';

export type RepMetabasePulsesV2Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RepMetabasePulsesV2AppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<RepMetabasePulsesV2DeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<RepMetabasePulsesV2DeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<RepMetabasePulsesV2DeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RepMetabasePulsesV2IncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RepMetabasePulsesV2PrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RepMetabasePulsesV2SetInput>;
  /** filter the rows which have to be updated */
  where: RepMetabasePulsesV2BoolExp;
};

/** aggregate varPop on columns */
export type RepMetabasePulsesV2VarPopFields = {
  __typename?: 'RepMetabasePulsesV2VarPopFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type RepMetabasePulsesV2VarSampFields = {
  __typename?: 'RepMetabasePulsesV2VarSampFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RepMetabasePulsesV2VarianceFields = {
  __typename?: 'RepMetabasePulsesV2VarianceFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** aggregate varPop on columns */
export type RepMetabasePulsesVarPopFields = {
  __typename?: 'RepMetabasePulsesVarPopFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type RepMetabasePulsesVarSampFields = {
  __typename?: 'RepMetabasePulsesVarSampFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RepMetabasePulsesVarianceFields = {
  __typename?: 'RepMetabasePulsesVarianceFields';
  metabaseNumericDashboardId?: Maybe<Scalars['Float']>;
  metabasePulseId?: Maybe<Scalars['Float']>;
};

/** Contains Metabase Definitions */
export type RepMetabaseReportDefinitions = {
  __typename?: 'RepMetabaseReportDefinitions';
  accessControlType: Scalars['EmbeddedReportAccessControlType'];
  createdAt: Scalars['timestamptz'];
  externalReportId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  /** An array relationship */
  repMetabaseCompanyReports: Array<RepMetabaseCompanyReports>;
  /** An aggregate relationship */
  repMetabaseCompanyReportsAggregate: RepMetabaseCompanyReportsAggregate;
  reportCategory: Scalars['EmbeddedReportCategory'];
  reportDescription?: Maybe<Scalars['String']>;
  reportGuid: Scalars['uuid'];
  reportTitle: Scalars['String'];
  reportType: Scalars['EmbeddedReportType'];
  updatedAt: Scalars['timestamptz'];
};


/** Contains Metabase Definitions */
export type RepMetabaseReportDefinitionsRepMetabaseCompanyReportsArgs = {
  distinctOn?: InputMaybe<Array<RepMetabaseCompanyReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabaseCompanyReportsOrderBy>>;
  where?: InputMaybe<RepMetabaseCompanyReportsBoolExp>;
};


/** Contains Metabase Definitions */
export type RepMetabaseReportDefinitionsRepMetabaseCompanyReportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepMetabaseCompanyReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabaseCompanyReportsOrderBy>>;
  where?: InputMaybe<RepMetabaseCompanyReportsBoolExp>;
};

/** aggregated selection of "rep_metabase_report_definitions" */
export type RepMetabaseReportDefinitionsAggregate = {
  __typename?: 'RepMetabaseReportDefinitionsAggregate';
  aggregate?: Maybe<RepMetabaseReportDefinitionsAggregateFields>;
  nodes: Array<RepMetabaseReportDefinitions>;
};

/** aggregate fields of "rep_metabase_report_definitions" */
export type RepMetabaseReportDefinitionsAggregateFields = {
  __typename?: 'RepMetabaseReportDefinitionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<RepMetabaseReportDefinitionsMaxFields>;
  min?: Maybe<RepMetabaseReportDefinitionsMinFields>;
};


/** aggregate fields of "rep_metabase_report_definitions" */
export type RepMetabaseReportDefinitionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RepMetabaseReportDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "rep_metabase_report_definitions". All fields are combined with a logical 'AND'. */
export type RepMetabaseReportDefinitionsBoolExp = {
  _and?: InputMaybe<Array<RepMetabaseReportDefinitionsBoolExp>>;
  _not?: InputMaybe<RepMetabaseReportDefinitionsBoolExp>;
  _or?: InputMaybe<Array<RepMetabaseReportDefinitionsBoolExp>>;
  accessControlType?: InputMaybe<Scalars['EmbeddedReportAccessControlTypeComparisonExp']>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalReportId?: InputMaybe<StringComparisonExp>;
  isDeleted?: InputMaybe<BooleanComparisonExp>;
  repMetabaseCompanyReports?: InputMaybe<RepMetabaseCompanyReportsBoolExp>;
  repMetabaseCompanyReportsAggregate?: InputMaybe<RepMetabaseCompanyReportsAggregateBoolExp>;
  reportCategory?: InputMaybe<Scalars['EmbeddedReportCategoryComparisonExp']>;
  reportDescription?: InputMaybe<StringComparisonExp>;
  reportGuid?: InputMaybe<UuidComparisonExp>;
  reportTitle?: InputMaybe<StringComparisonExp>;
  reportType?: InputMaybe<Scalars['EmbeddedReportTypeComparisonExp']>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "rep_metabase_report_definitions" */
export type RepMetabaseReportDefinitionsConstraint =
  /** unique or primary key constraint on columns "report_guid" */
  | 'rep_metabase_report_definitions_pkey';

/** input type for inserting data into table "rep_metabase_report_definitions" */
export type RepMetabaseReportDefinitionsInsertInput = {
  accessControlType?: InputMaybe<Scalars['EmbeddedReportAccessControlType']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalReportId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  repMetabaseCompanyReports?: InputMaybe<RepMetabaseCompanyReportsArrRelInsertInput>;
  reportCategory?: InputMaybe<Scalars['EmbeddedReportCategory']>;
  reportDescription?: InputMaybe<Scalars['String']>;
  reportGuid?: InputMaybe<Scalars['uuid']>;
  reportTitle?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<Scalars['EmbeddedReportType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RepMetabaseReportDefinitionsMaxFields = {
  __typename?: 'RepMetabaseReportDefinitionsMaxFields';
  accessControlType?: Maybe<Scalars['EmbeddedReportAccessControlType']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalReportId?: Maybe<Scalars['String']>;
  reportCategory?: Maybe<Scalars['EmbeddedReportCategory']>;
  reportDescription?: Maybe<Scalars['String']>;
  reportGuid?: Maybe<Scalars['uuid']>;
  reportTitle?: Maybe<Scalars['String']>;
  reportType?: Maybe<Scalars['EmbeddedReportType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type RepMetabaseReportDefinitionsMinFields = {
  __typename?: 'RepMetabaseReportDefinitionsMinFields';
  accessControlType?: Maybe<Scalars['EmbeddedReportAccessControlType']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  externalReportId?: Maybe<Scalars['String']>;
  reportCategory?: Maybe<Scalars['EmbeddedReportCategory']>;
  reportDescription?: Maybe<Scalars['String']>;
  reportGuid?: Maybe<Scalars['uuid']>;
  reportTitle?: Maybe<Scalars['String']>;
  reportType?: Maybe<Scalars['EmbeddedReportType']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "rep_metabase_report_definitions" */
export type RepMetabaseReportDefinitionsMutationResponse = {
  __typename?: 'RepMetabaseReportDefinitionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RepMetabaseReportDefinitions>;
};

/** input type for inserting object relation for remote table "rep_metabase_report_definitions" */
export type RepMetabaseReportDefinitionsObjRelInsertInput = {
  data: RepMetabaseReportDefinitionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RepMetabaseReportDefinitionsOnConflict>;
};

/** on_conflict condition type for table "rep_metabase_report_definitions" */
export type RepMetabaseReportDefinitionsOnConflict = {
  constraint: RepMetabaseReportDefinitionsConstraint;
  updateColumns?: Array<RepMetabaseReportDefinitionsUpdateColumn>;
  where?: InputMaybe<RepMetabaseReportDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "rep_metabase_report_definitions". */
export type RepMetabaseReportDefinitionsOrderBy = {
  accessControlType?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalReportId?: InputMaybe<OrderBy>;
  isDeleted?: InputMaybe<OrderBy>;
  repMetabaseCompanyReportsAggregate?: InputMaybe<RepMetabaseCompanyReportsAggregateOrderBy>;
  reportCategory?: InputMaybe<OrderBy>;
  reportDescription?: InputMaybe<OrderBy>;
  reportGuid?: InputMaybe<OrderBy>;
  reportTitle?: InputMaybe<OrderBy>;
  reportType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rep_metabase_report_definitions */
export type RepMetabaseReportDefinitionsPkColumnsInput = {
  reportGuid: Scalars['uuid'];
};

/** select columns of table "rep_metabase_report_definitions" */
export type RepMetabaseReportDefinitionsSelectColumn =
  /** column name */
  | 'accessControlType'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalReportId'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'reportCategory'
  /** column name */
  | 'reportDescription'
  /** column name */
  | 'reportGuid'
  /** column name */
  | 'reportTitle'
  /** column name */
  | 'reportType'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "rep_metabase_report_definitions" */
export type RepMetabaseReportDefinitionsSetInput = {
  accessControlType?: InputMaybe<Scalars['EmbeddedReportAccessControlType']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalReportId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  reportCategory?: InputMaybe<Scalars['EmbeddedReportCategory']>;
  reportDescription?: InputMaybe<Scalars['String']>;
  reportGuid?: InputMaybe<Scalars['uuid']>;
  reportTitle?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<Scalars['EmbeddedReportType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "rep_metabase_report_definitions" */
export type RepMetabaseReportDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RepMetabaseReportDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RepMetabaseReportDefinitionsStreamCursorValueInput = {
  accessControlType?: InputMaybe<Scalars['EmbeddedReportAccessControlType']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  externalReportId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  reportCategory?: InputMaybe<Scalars['EmbeddedReportCategory']>;
  reportDescription?: InputMaybe<Scalars['String']>;
  reportGuid?: InputMaybe<Scalars['uuid']>;
  reportTitle?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<Scalars['EmbeddedReportType']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "rep_metabase_report_definitions" */
export type RepMetabaseReportDefinitionsUpdateColumn =
  /** column name */
  | 'accessControlType'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'externalReportId'
  /** column name */
  | 'isDeleted'
  /** column name */
  | 'reportCategory'
  /** column name */
  | 'reportDescription'
  /** column name */
  | 'reportGuid'
  /** column name */
  | 'reportTitle'
  /** column name */
  | 'reportType'
  /** column name */
  | 'updatedAt';

export type RepMetabaseReportDefinitionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RepMetabaseReportDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: RepMetabaseReportDefinitionsBoolExp;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type SmallintComparisonExp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Tags are arbitrary labels a user can attach to entities. */
export type Tags = {
  __typename?: 'Tags';
  color: Scalars['String'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  tagGuid: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "tags" */
export type TagsAggregate = {
  __typename?: 'TagsAggregate';
  aggregate?: Maybe<TagsAggregateFields>;
  nodes: Array<Tags>;
};

/** aggregate fields of "tags" */
export type TagsAggregateFields = {
  __typename?: 'TagsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<TagsMaxFields>;
  min?: Maybe<TagsMinFields>;
};


/** aggregate fields of "tags" */
export type TagsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TagsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "tags". All fields are combined with a logical 'AND'. */
export type TagsBoolExp = {
  _and?: InputMaybe<Array<TagsBoolExp>>;
  _not?: InputMaybe<TagsBoolExp>;
  _or?: InputMaybe<Array<TagsBoolExp>>;
  color?: InputMaybe<StringComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  tagGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "tags" */
export type TagsConstraint =
  /** unique or primary key constraint on columns "company_guid", "name" */
  | 'tags_company_guid_name_key'
  /** unique or primary key constraint on columns "tag_guid" */
  | 'tags_pkey';

/** input type for inserting data into table "tags" */
export type TagsInsertInput = {
  color?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  tagGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type TagsMaxFields = {
  __typename?: 'TagsMaxFields';
  color?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  tagGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type TagsMinFields = {
  __typename?: 'TagsMinFields';
  color?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  tagGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "tags" */
export type TagsMutationResponse = {
  __typename?: 'TagsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tags>;
};

/** input type for inserting object relation for remote table "tags" */
export type TagsObjRelInsertInput = {
  data: TagsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TagsOnConflict>;
};

/** on_conflict condition type for table "tags" */
export type TagsOnConflict = {
  constraint: TagsConstraint;
  updateColumns?: Array<TagsUpdateColumn>;
  where?: InputMaybe<TagsBoolExp>;
};

/** Ordering options when selecting data from "tags". */
export type TagsOrderBy = {
  color?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  tagGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: tags */
export type TagsPkColumnsInput = {
  tagGuid: Scalars['uuid'];
};

/** select columns of table "tags" */
export type TagsSelectColumn =
  /** column name */
  | 'color'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'tagGuid'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "tags" */
export type TagsSetInput = {
  color?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  tagGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "tags" */
export type TagsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TagsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TagsStreamCursorValueInput = {
  color?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  tagGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "tags" */
export type TagsUpdateColumn =
  /** column name */
  | 'color'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'name'
  /** column name */
  | 'tagGuid'
  /** column name */
  | 'updatedAt';

export type TagsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TagsSetInput>;
  /** filter the rows which have to be updated */
  where: TagsBoolExp;
};

/** columns and relationships of "technician_capacities" */
export type TechnicianCapacities = {
  __typename?: 'TechnicianCapacities';
  end: Scalars['timestamptz'];
  start: Scalars['timestamptz'];
  technicianCapacityGuid: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "technician_capacities" */
export type TechnicianCapacitiesAggregate = {
  __typename?: 'TechnicianCapacitiesAggregate';
  aggregate?: Maybe<TechnicianCapacitiesAggregateFields>;
  nodes: Array<TechnicianCapacities>;
};

/** aggregate fields of "technician_capacities" */
export type TechnicianCapacitiesAggregateFields = {
  __typename?: 'TechnicianCapacitiesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<TechnicianCapacitiesMaxFields>;
  min?: Maybe<TechnicianCapacitiesMinFields>;
};


/** aggregate fields of "technician_capacities" */
export type TechnicianCapacitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TechnicianCapacitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "technician_capacities". All fields are combined with a logical 'AND'. */
export type TechnicianCapacitiesBoolExp = {
  _and?: InputMaybe<Array<TechnicianCapacitiesBoolExp>>;
  _not?: InputMaybe<TechnicianCapacitiesBoolExp>;
  _or?: InputMaybe<Array<TechnicianCapacitiesBoolExp>>;
  end?: InputMaybe<TimestamptzComparisonExp>;
  start?: InputMaybe<TimestamptzComparisonExp>;
  technicianCapacityGuid?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "technician_capacities" */
export type TechnicianCapacitiesConstraint =
  /** unique or primary key constraint on columns "technician_capacity_guid" */
  | 'technician_capacities_pkey';

/** input type for inserting data into table "technician_capacities" */
export type TechnicianCapacitiesInsertInput = {
  end?: InputMaybe<Scalars['timestamptz']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  technicianCapacityGuid?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TechnicianCapacitiesMaxFields = {
  __typename?: 'TechnicianCapacitiesMaxFields';
  end?: Maybe<Scalars['timestamptz']>;
  start?: Maybe<Scalars['timestamptz']>;
  technicianCapacityGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TechnicianCapacitiesMinFields = {
  __typename?: 'TechnicianCapacitiesMinFields';
  end?: Maybe<Scalars['timestamptz']>;
  start?: Maybe<Scalars['timestamptz']>;
  technicianCapacityGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "technician_capacities" */
export type TechnicianCapacitiesMutationResponse = {
  __typename?: 'TechnicianCapacitiesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TechnicianCapacities>;
};

/** on_conflict condition type for table "technician_capacities" */
export type TechnicianCapacitiesOnConflict = {
  constraint: TechnicianCapacitiesConstraint;
  updateColumns?: Array<TechnicianCapacitiesUpdateColumn>;
  where?: InputMaybe<TechnicianCapacitiesBoolExp>;
};

/** Ordering options when selecting data from "technician_capacities". */
export type TechnicianCapacitiesOrderBy = {
  end?: InputMaybe<OrderBy>;
  start?: InputMaybe<OrderBy>;
  technicianCapacityGuid?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: technician_capacities */
export type TechnicianCapacitiesPkColumnsInput = {
  technicianCapacityGuid: Scalars['uuid'];
};

/** select columns of table "technician_capacities" */
export type TechnicianCapacitiesSelectColumn =
  /** column name */
  | 'end'
  /** column name */
  | 'start'
  /** column name */
  | 'technicianCapacityGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "technician_capacities" */
export type TechnicianCapacitiesSetInput = {
  end?: InputMaybe<Scalars['timestamptz']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  technicianCapacityGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "technician_capacities" */
export type TechnicianCapacitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TechnicianCapacitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TechnicianCapacitiesStreamCursorValueInput = {
  end?: InputMaybe<Scalars['timestamptz']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  technicianCapacityGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "technician_capacities" */
export type TechnicianCapacitiesUpdateColumn =
  /** column name */
  | 'end'
  /** column name */
  | 'start'
  /** column name */
  | 'technicianCapacityGuid'
  /** column name */
  | 'userGuid';

export type TechnicianCapacitiesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TechnicianCapacitiesSetInput>;
  /** filter the rows which have to be updated */
  where: TechnicianCapacitiesBoolExp;
};

export { TechnicianCapacityBlockReasonTypesEnum };

/** Boolean expression to compare columns of type "TechnicianCapacityBlockReasonTypesEnum". All fields are combined with logical 'AND'. */
export type TechnicianCapacityBlockReasonTypesEnumComparisonExp = {
  _eq?: InputMaybe<TechnicianCapacityBlockReasonTypesEnum>;
  _in?: InputMaybe<Array<TechnicianCapacityBlockReasonTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<TechnicianCapacityBlockReasonTypesEnum>;
  _nin?: InputMaybe<Array<TechnicianCapacityBlockReasonTypesEnum>>;
};

/** columns and relationships of "technician_capacity_blocks" */
export type TechnicianCapacityBlocks = {
  __typename?: 'TechnicianCapacityBlocks';
  companyGuid: Scalars['uuid'];
  end: Scalars['timestamptz'];
  reasonDescription?: Maybe<Scalars['String']>;
  reasonType: TechnicianCapacityBlockReasonTypesEnum;
  recurrenceRule?: Maybe<Scalars['String']>;
  recurrenceRuleExceptions?: Maybe<Scalars['String']>;
  start: Scalars['timestamptz'];
  technicianCapacityBlockGuid: Scalars['uuid'];
  userGuids: Array<Scalars['uuid']>;
};

/** aggregated selection of "technician_capacity_blocks" */
export type TechnicianCapacityBlocksAggregate = {
  __typename?: 'TechnicianCapacityBlocksAggregate';
  aggregate?: Maybe<TechnicianCapacityBlocksAggregateFields>;
  nodes: Array<TechnicianCapacityBlocks>;
};

/** aggregate fields of "technician_capacity_blocks" */
export type TechnicianCapacityBlocksAggregateFields = {
  __typename?: 'TechnicianCapacityBlocksAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<TechnicianCapacityBlocksMaxFields>;
  min?: Maybe<TechnicianCapacityBlocksMinFields>;
};


/** aggregate fields of "technician_capacity_blocks" */
export type TechnicianCapacityBlocksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TechnicianCapacityBlocksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "technician_capacity_blocks". All fields are combined with a logical 'AND'. */
export type TechnicianCapacityBlocksBoolExp = {
  _and?: InputMaybe<Array<TechnicianCapacityBlocksBoolExp>>;
  _not?: InputMaybe<TechnicianCapacityBlocksBoolExp>;
  _or?: InputMaybe<Array<TechnicianCapacityBlocksBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  end?: InputMaybe<TimestamptzComparisonExp>;
  reasonDescription?: InputMaybe<StringComparisonExp>;
  reasonType?: InputMaybe<TechnicianCapacityBlockReasonTypesEnumComparisonExp>;
  recurrenceRule?: InputMaybe<StringComparisonExp>;
  recurrenceRuleExceptions?: InputMaybe<StringComparisonExp>;
  start?: InputMaybe<TimestamptzComparisonExp>;
  technicianCapacityBlockGuid?: InputMaybe<UuidComparisonExp>;
  userGuids?: InputMaybe<UuidArrayComparisonExp>;
};

/** unique or primary key constraints on table "technician_capacity_blocks" */
export type TechnicianCapacityBlocksConstraint =
  /** unique or primary key constraint on columns "technician_capacity_block_guid" */
  | 'technician_capacity_blocks_pkey';

/** input type for inserting data into table "technician_capacity_blocks" */
export type TechnicianCapacityBlocksInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  reasonDescription?: InputMaybe<Scalars['String']>;
  reasonType?: InputMaybe<TechnicianCapacityBlockReasonTypesEnum>;
  recurrenceRule?: InputMaybe<Scalars['String']>;
  recurrenceRuleExceptions?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  technicianCapacityBlockGuid?: InputMaybe<Scalars['uuid']>;
  userGuids?: InputMaybe<Array<Scalars['uuid']>>;
};

/** aggregate max on columns */
export type TechnicianCapacityBlocksMaxFields = {
  __typename?: 'TechnicianCapacityBlocksMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  end?: Maybe<Scalars['timestamptz']>;
  reasonDescription?: Maybe<Scalars['String']>;
  recurrenceRule?: Maybe<Scalars['String']>;
  recurrenceRuleExceptions?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['timestamptz']>;
  technicianCapacityBlockGuid?: Maybe<Scalars['uuid']>;
  userGuids?: Maybe<Array<Scalars['uuid']>>;
};

/** aggregate min on columns */
export type TechnicianCapacityBlocksMinFields = {
  __typename?: 'TechnicianCapacityBlocksMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  end?: Maybe<Scalars['timestamptz']>;
  reasonDescription?: Maybe<Scalars['String']>;
  recurrenceRule?: Maybe<Scalars['String']>;
  recurrenceRuleExceptions?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['timestamptz']>;
  technicianCapacityBlockGuid?: Maybe<Scalars['uuid']>;
  userGuids?: Maybe<Array<Scalars['uuid']>>;
};

/** response of any mutation on the table "technician_capacity_blocks" */
export type TechnicianCapacityBlocksMutationResponse = {
  __typename?: 'TechnicianCapacityBlocksMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TechnicianCapacityBlocks>;
};

/** on_conflict condition type for table "technician_capacity_blocks" */
export type TechnicianCapacityBlocksOnConflict = {
  constraint: TechnicianCapacityBlocksConstraint;
  updateColumns?: Array<TechnicianCapacityBlocksUpdateColumn>;
  where?: InputMaybe<TechnicianCapacityBlocksBoolExp>;
};

/** Ordering options when selecting data from "technician_capacity_blocks". */
export type TechnicianCapacityBlocksOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  end?: InputMaybe<OrderBy>;
  reasonDescription?: InputMaybe<OrderBy>;
  reasonType?: InputMaybe<OrderBy>;
  recurrenceRule?: InputMaybe<OrderBy>;
  recurrenceRuleExceptions?: InputMaybe<OrderBy>;
  start?: InputMaybe<OrderBy>;
  technicianCapacityBlockGuid?: InputMaybe<OrderBy>;
  userGuids?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: technician_capacity_blocks */
export type TechnicianCapacityBlocksPkColumnsInput = {
  technicianCapacityBlockGuid: Scalars['uuid'];
};

/** select columns of table "technician_capacity_blocks" */
export type TechnicianCapacityBlocksSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'end'
  /** column name */
  | 'reasonDescription'
  /** column name */
  | 'reasonType'
  /** column name */
  | 'recurrenceRule'
  /** column name */
  | 'recurrenceRuleExceptions'
  /** column name */
  | 'start'
  /** column name */
  | 'technicianCapacityBlockGuid'
  /** column name */
  | 'userGuids';

/** input type for updating data in table "technician_capacity_blocks" */
export type TechnicianCapacityBlocksSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  reasonDescription?: InputMaybe<Scalars['String']>;
  reasonType?: InputMaybe<TechnicianCapacityBlockReasonTypesEnum>;
  recurrenceRule?: InputMaybe<Scalars['String']>;
  recurrenceRuleExceptions?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  technicianCapacityBlockGuid?: InputMaybe<Scalars['uuid']>;
  userGuids?: InputMaybe<Array<Scalars['uuid']>>;
};

/** Streaming cursor of the table "technician_capacity_blocks" */
export type TechnicianCapacityBlocksStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TechnicianCapacityBlocksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TechnicianCapacityBlocksStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  reasonDescription?: InputMaybe<Scalars['String']>;
  reasonType?: InputMaybe<TechnicianCapacityBlockReasonTypesEnum>;
  recurrenceRule?: InputMaybe<Scalars['String']>;
  recurrenceRuleExceptions?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  technicianCapacityBlockGuid?: InputMaybe<Scalars['uuid']>;
  userGuids?: InputMaybe<Array<Scalars['uuid']>>;
};

/** update columns of table "technician_capacity_blocks" */
export type TechnicianCapacityBlocksUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'end'
  /** column name */
  | 'reasonDescription'
  /** column name */
  | 'reasonType'
  /** column name */
  | 'recurrenceRule'
  /** column name */
  | 'recurrenceRuleExceptions'
  /** column name */
  | 'start'
  /** column name */
  | 'technicianCapacityBlockGuid'
  /** column name */
  | 'userGuids';

export type TechnicianCapacityBlocksUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TechnicianCapacityBlocksSetInput>;
  /** filter the rows which have to be updated */
  where: TechnicianCapacityBlocksBoolExp;
};

/** columns and relationships of "tilled_raw_events" */
export type TilledRawEvents = {
  __typename?: 'TilledRawEvents';
  accountId: Scalars['String'];
  consumedAt: Scalars['timestamptz'];
  createdAt: Scalars['timestamptz'];
  data: Scalars['jsonb'];
  id: Scalars['String'];
  tilledRawEventGuid: Scalars['uuid'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "tilled_raw_events" */
export type TilledRawEventsDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "tilled_raw_events" */
export type TilledRawEventsAggregate = {
  __typename?: 'TilledRawEventsAggregate';
  aggregate?: Maybe<TilledRawEventsAggregateFields>;
  nodes: Array<TilledRawEvents>;
};

/** aggregate fields of "tilled_raw_events" */
export type TilledRawEventsAggregateFields = {
  __typename?: 'TilledRawEventsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<TilledRawEventsMaxFields>;
  min?: Maybe<TilledRawEventsMinFields>;
};


/** aggregate fields of "tilled_raw_events" */
export type TilledRawEventsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TilledRawEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TilledRawEventsAppendInput = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "tilled_raw_events". All fields are combined with a logical 'AND'. */
export type TilledRawEventsBoolExp = {
  _and?: InputMaybe<Array<TilledRawEventsBoolExp>>;
  _not?: InputMaybe<TilledRawEventsBoolExp>;
  _or?: InputMaybe<Array<TilledRawEventsBoolExp>>;
  accountId?: InputMaybe<StringComparisonExp>;
  consumedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  data?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  tilledRawEventGuid?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "tilled_raw_events" */
export type TilledRawEventsConstraint =
  /** unique or primary key constraint on columns "tilled_raw_event_guid" */
  | 'tilled_raw_events_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TilledRawEventsDeleteAtPathInput = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TilledRawEventsDeleteElemInput = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TilledRawEventsDeleteKeyInput = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "tilled_raw_events" */
export type TilledRawEventsInsertInput = {
  accountId?: InputMaybe<Scalars['String']>;
  consumedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  tilledRawEventGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type TilledRawEventsMaxFields = {
  __typename?: 'TilledRawEventsMaxFields';
  accountId?: Maybe<Scalars['String']>;
  consumedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  tilledRawEventGuid?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type TilledRawEventsMinFields = {
  __typename?: 'TilledRawEventsMinFields';
  accountId?: Maybe<Scalars['String']>;
  consumedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  tilledRawEventGuid?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "tilled_raw_events" */
export type TilledRawEventsMutationResponse = {
  __typename?: 'TilledRawEventsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TilledRawEvents>;
};

/** on_conflict condition type for table "tilled_raw_events" */
export type TilledRawEventsOnConflict = {
  constraint: TilledRawEventsConstraint;
  updateColumns?: Array<TilledRawEventsUpdateColumn>;
  where?: InputMaybe<TilledRawEventsBoolExp>;
};

/** Ordering options when selecting data from "tilled_raw_events". */
export type TilledRawEventsOrderBy = {
  accountId?: InputMaybe<OrderBy>;
  consumedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  data?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tilledRawEventGuid?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: tilled_raw_events */
export type TilledRawEventsPkColumnsInput = {
  tilledRawEventGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TilledRawEventsPrependInput = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "tilled_raw_events" */
export type TilledRawEventsSelectColumn =
  /** column name */
  | 'accountId'
  /** column name */
  | 'consumedAt'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'data'
  /** column name */
  | 'id'
  /** column name */
  | 'tilledRawEventGuid'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt';

/** input type for updating data in table "tilled_raw_events" */
export type TilledRawEventsSetInput = {
  accountId?: InputMaybe<Scalars['String']>;
  consumedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  tilledRawEventGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "tilled_raw_events" */
export type TilledRawEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TilledRawEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TilledRawEventsStreamCursorValueInput = {
  accountId?: InputMaybe<Scalars['String']>;
  consumedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  tilledRawEventGuid?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "tilled_raw_events" */
export type TilledRawEventsUpdateColumn =
  /** column name */
  | 'accountId'
  /** column name */
  | 'consumedAt'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'data'
  /** column name */
  | 'id'
  /** column name */
  | 'tilledRawEventGuid'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt';

export type TilledRawEventsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TilledRawEventsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<TilledRawEventsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<TilledRawEventsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<TilledRawEventsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TilledRawEventsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TilledRawEventsSetInput>;
  /** filter the rows which have to be updated */
  where: TilledRawEventsBoolExp;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type TimeComparisonExp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** columns and relationships of "timesheet_entries" */
export type TimesheetEntries = {
  __typename?: 'TimesheetEntries';
  attentionNote?: Maybe<Scalars['String']>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  deletedByUser?: Maybe<Users>;
  deletedByUserGuid?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  endTimeOverride?: Maybe<Scalars['timestamptz']>;
  /** Computes the length of the timesheet entry (in minutes) from the final start and end time */
  entryLengthInMinutes?: Maybe<Scalars['float8']>;
  /** A computed field, executes function "timesheet_entries_compute_final_end_time" */
  finalEndTime?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "timesheet_entries_compute_final_start_time" */
  finalStartTime?: Maybe<Scalars['timestamptz']>;
  startTime: Scalars['timestamptz'];
  startTimeOverride?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  timesheetEntryActivities: Array<TimesheetEntryActivities>;
  /** An aggregate relationship */
  timesheetEntryActivitiesAggregate: TimesheetEntryActivitiesAggregate;
  /** An object relationship */
  timesheetEntryActivity?: Maybe<TimesheetEntryActivities>;
  timesheetEntryGuid: Scalars['uuid'];
  /** An array relationship */
  timesheetEntryLinkData: Array<TimesheetEntryLinkData>;
  /** An aggregate relationship */
  timesheetEntryLinkDataAggregate: TimesheetEntryLinkDataAggregate;
  /** An object relationship */
  timesheetEntryLinks?: Maybe<TimesheetEntryLinkData>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  updatedByUser?: Maybe<Users>;
  updatedByUserGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user: Users;
  userGuid: Scalars['uuid'];
};


/** columns and relationships of "timesheet_entries" */
export type TimesheetEntriesTimesheetEntryActivitiesArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryActivitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryActivitiesOrderBy>>;
  where?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
};


/** columns and relationships of "timesheet_entries" */
export type TimesheetEntriesTimesheetEntryActivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryActivitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryActivitiesOrderBy>>;
  where?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
};


/** columns and relationships of "timesheet_entries" */
export type TimesheetEntriesTimesheetEntryLinkDataArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryLinkDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryLinkDataOrderBy>>;
  where?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
};


/** columns and relationships of "timesheet_entries" */
export type TimesheetEntriesTimesheetEntryLinkDataAggregateArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryLinkDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryLinkDataOrderBy>>;
  where?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
};

/** aggregated selection of "timesheet_entries" */
export type TimesheetEntriesAggregate = {
  __typename?: 'TimesheetEntriesAggregate';
  aggregate?: Maybe<TimesheetEntriesAggregateFields>;
  nodes: Array<TimesheetEntries>;
};

export type TimesheetEntriesAggregateBoolExp = {
  count?: InputMaybe<TimesheetEntriesAggregateBoolExpCount>;
};

/** aggregate fields of "timesheet_entries" */
export type TimesheetEntriesAggregateFields = {
  __typename?: 'TimesheetEntriesAggregateFields';
  avg?: Maybe<TimesheetEntriesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TimesheetEntriesMaxFields>;
  min?: Maybe<TimesheetEntriesMinFields>;
  stddev?: Maybe<TimesheetEntriesStddevFields>;
  stddevPop?: Maybe<TimesheetEntriesStddevPopFields>;
  stddevSamp?: Maybe<TimesheetEntriesStddevSampFields>;
  sum?: Maybe<TimesheetEntriesSumFields>;
  varPop?: Maybe<TimesheetEntriesVarPopFields>;
  varSamp?: Maybe<TimesheetEntriesVarSampFields>;
  variance?: Maybe<TimesheetEntriesVarianceFields>;
};


/** aggregate fields of "timesheet_entries" */
export type TimesheetEntriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TimesheetEntriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "timesheet_entries" */
export type TimesheetEntriesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TimesheetEntriesMaxOrderBy>;
  min?: InputMaybe<TimesheetEntriesMinOrderBy>;
};

/** input type for inserting array relation for remote table "timesheet_entries" */
export type TimesheetEntriesArrRelInsertInput = {
  data: Array<TimesheetEntriesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TimesheetEntriesOnConflict>;
};

/** aggregate avg on columns */
export type TimesheetEntriesAvgFields = {
  __typename?: 'TimesheetEntriesAvgFields';
  /** Computes the length of the timesheet entry (in minutes) from the final start and end time */
  entryLengthInMinutes?: Maybe<Scalars['float8']>;
};

/** Boolean expression to filter rows from the table "timesheet_entries". All fields are combined with a logical 'AND'. */
export type TimesheetEntriesBoolExp = {
  _and?: InputMaybe<Array<TimesheetEntriesBoolExp>>;
  _not?: InputMaybe<TimesheetEntriesBoolExp>;
  _or?: InputMaybe<Array<TimesheetEntriesBoolExp>>;
  attentionNote?: InputMaybe<StringComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedByUser?: InputMaybe<UsersBoolExp>;
  deletedByUserGuid?: InputMaybe<UuidComparisonExp>;
  endTime?: InputMaybe<TimestamptzComparisonExp>;
  endTimeOverride?: InputMaybe<TimestamptzComparisonExp>;
  entryLengthInMinutes?: InputMaybe<Float8ComparisonExp>;
  finalEndTime?: InputMaybe<TimestamptzComparisonExp>;
  finalStartTime?: InputMaybe<TimestamptzComparisonExp>;
  startTime?: InputMaybe<TimestamptzComparisonExp>;
  startTimeOverride?: InputMaybe<TimestamptzComparisonExp>;
  timesheetEntryActivities?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
  timesheetEntryActivitiesAggregate?: InputMaybe<TimesheetEntryActivitiesAggregateBoolExp>;
  timesheetEntryActivity?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
  timesheetEntryGuid?: InputMaybe<UuidComparisonExp>;
  timesheetEntryLinkData?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
  timesheetEntryLinkDataAggregate?: InputMaybe<TimesheetEntryLinkDataAggregateBoolExp>;
  timesheetEntryLinks?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedByUser?: InputMaybe<UsersBoolExp>;
  updatedByUserGuid?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "timesheet_entries" */
export type TimesheetEntriesConstraint =
  /** unique or primary key constraint on columns "timesheet_entry_guid" */
  | 'timesheet_entries_pkey';

/** input type for inserting data into table "timesheet_entries" */
export type TimesheetEntriesInsertInput = {
  attentionNote?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deletedByUser?: InputMaybe<UsersObjRelInsertInput>;
  deletedByUserGuid?: InputMaybe<Scalars['uuid']>;
  endTime?: InputMaybe<Scalars['timestamptz']>;
  endTimeOverride?: InputMaybe<Scalars['timestamptz']>;
  startTime?: InputMaybe<Scalars['timestamptz']>;
  startTimeOverride?: InputMaybe<Scalars['timestamptz']>;
  timesheetEntryActivities?: InputMaybe<TimesheetEntryActivitiesArrRelInsertInput>;
  timesheetEntryActivity?: InputMaybe<TimesheetEntryActivitiesObjRelInsertInput>;
  timesheetEntryGuid?: InputMaybe<Scalars['uuid']>;
  timesheetEntryLinkData?: InputMaybe<TimesheetEntryLinkDataArrRelInsertInput>;
  timesheetEntryLinks?: InputMaybe<TimesheetEntryLinkDataObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedByUser?: InputMaybe<UsersObjRelInsertInput>;
  updatedByUserGuid?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TimesheetEntriesMaxFields = {
  __typename?: 'TimesheetEntriesMaxFields';
  attentionNote?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  deletedByUserGuid?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  endTimeOverride?: Maybe<Scalars['timestamptz']>;
  /** Computes the length of the timesheet entry (in minutes) from the final start and end time */
  entryLengthInMinutes?: Maybe<Scalars['float8']>;
  /** A computed field, executes function "timesheet_entries_compute_final_end_time" */
  finalEndTime?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "timesheet_entries_compute_final_start_time" */
  finalStartTime?: Maybe<Scalars['timestamptz']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  startTimeOverride?: Maybe<Scalars['timestamptz']>;
  timesheetEntryGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedByUserGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "timesheet_entries" */
export type TimesheetEntriesMaxOrderBy = {
  attentionNote?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  deletedByUserGuid?: InputMaybe<OrderBy>;
  endTime?: InputMaybe<OrderBy>;
  endTimeOverride?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<OrderBy>;
  startTimeOverride?: InputMaybe<OrderBy>;
  timesheetEntryGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedByUserGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TimesheetEntriesMinFields = {
  __typename?: 'TimesheetEntriesMinFields';
  attentionNote?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  deletedByUserGuid?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  endTimeOverride?: Maybe<Scalars['timestamptz']>;
  /** Computes the length of the timesheet entry (in minutes) from the final start and end time */
  entryLengthInMinutes?: Maybe<Scalars['float8']>;
  /** A computed field, executes function "timesheet_entries_compute_final_end_time" */
  finalEndTime?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "timesheet_entries_compute_final_start_time" */
  finalStartTime?: Maybe<Scalars['timestamptz']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  startTimeOverride?: Maybe<Scalars['timestamptz']>;
  timesheetEntryGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  updatedByUserGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "timesheet_entries" */
export type TimesheetEntriesMinOrderBy = {
  attentionNote?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  deletedByUserGuid?: InputMaybe<OrderBy>;
  endTime?: InputMaybe<OrderBy>;
  endTimeOverride?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<OrderBy>;
  startTimeOverride?: InputMaybe<OrderBy>;
  timesheetEntryGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedByUserGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "timesheet_entries" */
export type TimesheetEntriesMutationResponse = {
  __typename?: 'TimesheetEntriesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TimesheetEntries>;
};

/** input type for inserting object relation for remote table "timesheet_entries" */
export type TimesheetEntriesObjRelInsertInput = {
  data: TimesheetEntriesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TimesheetEntriesOnConflict>;
};

/** on_conflict condition type for table "timesheet_entries" */
export type TimesheetEntriesOnConflict = {
  constraint: TimesheetEntriesConstraint;
  updateColumns?: Array<TimesheetEntriesUpdateColumn>;
  where?: InputMaybe<TimesheetEntriesBoolExp>;
};

/** Ordering options when selecting data from "timesheet_entries". */
export type TimesheetEntriesOrderBy = {
  attentionNote?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  deletedByUser?: InputMaybe<UsersOrderBy>;
  deletedByUserGuid?: InputMaybe<OrderBy>;
  endTime?: InputMaybe<OrderBy>;
  endTimeOverride?: InputMaybe<OrderBy>;
  entryLengthInMinutes?: InputMaybe<OrderBy>;
  finalEndTime?: InputMaybe<OrderBy>;
  finalStartTime?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<OrderBy>;
  startTimeOverride?: InputMaybe<OrderBy>;
  timesheetEntryActivitiesAggregate?: InputMaybe<TimesheetEntryActivitiesAggregateOrderBy>;
  timesheetEntryActivity?: InputMaybe<TimesheetEntryActivitiesOrderBy>;
  timesheetEntryGuid?: InputMaybe<OrderBy>;
  timesheetEntryLinkDataAggregate?: InputMaybe<TimesheetEntryLinkDataAggregateOrderBy>;
  timesheetEntryLinks?: InputMaybe<TimesheetEntryLinkDataOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedByUser?: InputMaybe<UsersOrderBy>;
  updatedByUserGuid?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: timesheet_entries */
export type TimesheetEntriesPkColumnsInput = {
  timesheetEntryGuid: Scalars['uuid'];
};

/** select columns of table "timesheet_entries" */
export type TimesheetEntriesSelectColumn =
  /** column name */
  | 'attentionNote'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'deletedAt'
  /** column name */
  | 'deletedByUserGuid'
  /** column name */
  | 'endTime'
  /** column name */
  | 'endTimeOverride'
  /** column name */
  | 'startTime'
  /** column name */
  | 'startTimeOverride'
  /** column name */
  | 'timesheetEntryGuid'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'updatedByUserGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "timesheet_entries" */
export type TimesheetEntriesSetInput = {
  attentionNote?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deletedByUserGuid?: InputMaybe<Scalars['uuid']>;
  endTime?: InputMaybe<Scalars['timestamptz']>;
  endTimeOverride?: InputMaybe<Scalars['timestamptz']>;
  startTime?: InputMaybe<Scalars['timestamptz']>;
  startTimeOverride?: InputMaybe<Scalars['timestamptz']>;
  timesheetEntryGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedByUserGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type TimesheetEntriesStddevFields = {
  __typename?: 'TimesheetEntriesStddevFields';
  /** Computes the length of the timesheet entry (in minutes) from the final start and end time */
  entryLengthInMinutes?: Maybe<Scalars['float8']>;
};

/** aggregate stddevPop on columns */
export type TimesheetEntriesStddevPopFields = {
  __typename?: 'TimesheetEntriesStddevPopFields';
  /** Computes the length of the timesheet entry (in minutes) from the final start and end time */
  entryLengthInMinutes?: Maybe<Scalars['float8']>;
};

/** aggregate stddevSamp on columns */
export type TimesheetEntriesStddevSampFields = {
  __typename?: 'TimesheetEntriesStddevSampFields';
  /** Computes the length of the timesheet entry (in minutes) from the final start and end time */
  entryLengthInMinutes?: Maybe<Scalars['float8']>;
};

/** Streaming cursor of the table "timesheet_entries" */
export type TimesheetEntriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TimesheetEntriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TimesheetEntriesStreamCursorValueInput = {
  attentionNote?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deletedByUserGuid?: InputMaybe<Scalars['uuid']>;
  endTime?: InputMaybe<Scalars['timestamptz']>;
  endTimeOverride?: InputMaybe<Scalars['timestamptz']>;
  startTime?: InputMaybe<Scalars['timestamptz']>;
  startTimeOverride?: InputMaybe<Scalars['timestamptz']>;
  timesheetEntryGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  updatedByUserGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type TimesheetEntriesSumFields = {
  __typename?: 'TimesheetEntriesSumFields';
  /** Computes the length of the timesheet entry (in minutes) from the final start and end time */
  entryLengthInMinutes?: Maybe<Scalars['float8']>;
};

/** update columns of table "timesheet_entries" */
export type TimesheetEntriesUpdateColumn =
  /** column name */
  | 'attentionNote'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'deletedAt'
  /** column name */
  | 'deletedByUserGuid'
  /** column name */
  | 'endTime'
  /** column name */
  | 'endTimeOverride'
  /** column name */
  | 'startTime'
  /** column name */
  | 'startTimeOverride'
  /** column name */
  | 'timesheetEntryGuid'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'updatedByUserGuid'
  /** column name */
  | 'userGuid';

export type TimesheetEntriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TimesheetEntriesSetInput>;
  /** filter the rows which have to be updated */
  where: TimesheetEntriesBoolExp;
};

/** aggregate varPop on columns */
export type TimesheetEntriesVarPopFields = {
  __typename?: 'TimesheetEntriesVarPopFields';
  /** Computes the length of the timesheet entry (in minutes) from the final start and end time */
  entryLengthInMinutes?: Maybe<Scalars['float8']>;
};

/** aggregate varSamp on columns */
export type TimesheetEntriesVarSampFields = {
  __typename?: 'TimesheetEntriesVarSampFields';
  /** Computes the length of the timesheet entry (in minutes) from the final start and end time */
  entryLengthInMinutes?: Maybe<Scalars['float8']>;
};

/** aggregate variance on columns */
export type TimesheetEntriesVarianceFields = {
  __typename?: 'TimesheetEntriesVarianceFields';
  /** Computes the length of the timesheet entry (in minutes) from the final start and end time */
  entryLengthInMinutes?: Maybe<Scalars['float8']>;
};

/** columns and relationships of "timesheet_entry_activities" */
export type TimesheetEntryActivities = {
  __typename?: 'TimesheetEntryActivities';
  activityName: Scalars['String'];
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  isPayable: Scalars['Boolean'];
  timesheetEntryActivityGuid: Scalars['uuid'];
  timesheetEntryGuid: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "timesheet_entry_activities" */
export type TimesheetEntryActivitiesAggregate = {
  __typename?: 'TimesheetEntryActivitiesAggregate';
  aggregate?: Maybe<TimesheetEntryActivitiesAggregateFields>;
  nodes: Array<TimesheetEntryActivities>;
};

export type TimesheetEntryActivitiesAggregateBoolExp = {
  bool_and?: InputMaybe<TimesheetEntryActivitiesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<TimesheetEntryActivitiesAggregateBoolExpBool_Or>;
  count?: InputMaybe<TimesheetEntryActivitiesAggregateBoolExpCount>;
};

/** aggregate fields of "timesheet_entry_activities" */
export type TimesheetEntryActivitiesAggregateFields = {
  __typename?: 'TimesheetEntryActivitiesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<TimesheetEntryActivitiesMaxFields>;
  min?: Maybe<TimesheetEntryActivitiesMinFields>;
};


/** aggregate fields of "timesheet_entry_activities" */
export type TimesheetEntryActivitiesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TimesheetEntryActivitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TimesheetEntryActivitiesMaxOrderBy>;
  min?: InputMaybe<TimesheetEntryActivitiesMinOrderBy>;
};

/** input type for inserting array relation for remote table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesArrRelInsertInput = {
  data: Array<TimesheetEntryActivitiesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TimesheetEntryActivitiesOnConflict>;
};

/** Boolean expression to filter rows from the table "timesheet_entry_activities". All fields are combined with a logical 'AND'. */
export type TimesheetEntryActivitiesBoolExp = {
  _and?: InputMaybe<Array<TimesheetEntryActivitiesBoolExp>>;
  _not?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
  _or?: InputMaybe<Array<TimesheetEntryActivitiesBoolExp>>;
  activityName?: InputMaybe<StringComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  isPayable?: InputMaybe<BooleanComparisonExp>;
  timesheetEntryActivityGuid?: InputMaybe<UuidComparisonExp>;
  timesheetEntryGuid?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesConstraint =
  /** unique or primary key constraint on columns "timesheet_entry_activity_guid" */
  | 'timesheet_entry_activities_pkey';

/** input type for inserting data into table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesInsertInput = {
  activityName?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isPayable?: InputMaybe<Scalars['Boolean']>;
  timesheetEntryActivityGuid?: InputMaybe<Scalars['uuid']>;
  timesheetEntryGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type TimesheetEntryActivitiesMaxFields = {
  __typename?: 'TimesheetEntryActivitiesMaxFields';
  activityName?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  timesheetEntryActivityGuid?: Maybe<Scalars['uuid']>;
  timesheetEntryGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesMaxOrderBy = {
  activityName?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  timesheetEntryActivityGuid?: InputMaybe<OrderBy>;
  timesheetEntryGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TimesheetEntryActivitiesMinFields = {
  __typename?: 'TimesheetEntryActivitiesMinFields';
  activityName?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  timesheetEntryActivityGuid?: Maybe<Scalars['uuid']>;
  timesheetEntryGuid?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesMinOrderBy = {
  activityName?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  timesheetEntryActivityGuid?: InputMaybe<OrderBy>;
  timesheetEntryGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesMutationResponse = {
  __typename?: 'TimesheetEntryActivitiesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TimesheetEntryActivities>;
};

/** input type for inserting object relation for remote table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesObjRelInsertInput = {
  data: TimesheetEntryActivitiesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TimesheetEntryActivitiesOnConflict>;
};

/** on_conflict condition type for table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesOnConflict = {
  constraint: TimesheetEntryActivitiesConstraint;
  updateColumns?: Array<TimesheetEntryActivitiesUpdateColumn>;
  where?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
};

/** Ordering options when selecting data from "timesheet_entry_activities". */
export type TimesheetEntryActivitiesOrderBy = {
  activityName?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  isPayable?: InputMaybe<OrderBy>;
  timesheetEntryActivityGuid?: InputMaybe<OrderBy>;
  timesheetEntryGuid?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: timesheet_entry_activities */
export type TimesheetEntryActivitiesPkColumnsInput = {
  timesheetEntryActivityGuid: Scalars['uuid'];
};

/** select columns of table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesSelectColumn =
  /** column name */
  | 'activityName'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'isPayable'
  /** column name */
  | 'timesheetEntryActivityGuid'
  /** column name */
  | 'timesheetEntryGuid'
  /** column name */
  | 'updatedAt';

/** select "timesheetEntryActivitiesAggregateBoolExpBool_andArgumentsColumns" columns of table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesSelectColumnTimesheetEntryActivitiesAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isPayable';

/** select "timesheetEntryActivitiesAggregateBoolExpBool_orArgumentsColumns" columns of table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesSelectColumnTimesheetEntryActivitiesAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isPayable';

/** input type for updating data in table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesSetInput = {
  activityName?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isPayable?: InputMaybe<Scalars['Boolean']>;
  timesheetEntryActivityGuid?: InputMaybe<Scalars['uuid']>;
  timesheetEntryGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TimesheetEntryActivitiesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TimesheetEntryActivitiesStreamCursorValueInput = {
  activityName?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  isPayable?: InputMaybe<Scalars['Boolean']>;
  timesheetEntryActivityGuid?: InputMaybe<Scalars['uuid']>;
  timesheetEntryGuid?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "timesheet_entry_activities" */
export type TimesheetEntryActivitiesUpdateColumn =
  /** column name */
  | 'activityName'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'isPayable'
  /** column name */
  | 'timesheetEntryActivityGuid'
  /** column name */
  | 'timesheetEntryGuid'
  /** column name */
  | 'updatedAt';

export type TimesheetEntryActivitiesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TimesheetEntryActivitiesSetInput>;
  /** filter the rows which have to be updated */
  where: TimesheetEntryActivitiesBoolExp;
};

/** columns and relationships of "timesheet_entry_link_data" */
export type TimesheetEntryLinkData = {
  __typename?: 'TimesheetEntryLinkData';
  companyGuid: Scalars['uuid'];
  /** An object relationship */
  job?: Maybe<Jobs>;
  /** An object relationship */
  jobAppointment?: Maybe<JobAppointments>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  jobCostItem?: Maybe<JobCostItems>;
  jobCostItemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  laborCostSuppressedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  timesheetEntry: TimesheetEntries;
  timesheetEntryGuid: Scalars['uuid'];
};

/** aggregated selection of "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataAggregate = {
  __typename?: 'TimesheetEntryLinkDataAggregate';
  aggregate?: Maybe<TimesheetEntryLinkDataAggregateFields>;
  nodes: Array<TimesheetEntryLinkData>;
};

export type TimesheetEntryLinkDataAggregateBoolExp = {
  count?: InputMaybe<TimesheetEntryLinkDataAggregateBoolExpCount>;
};

/** aggregate fields of "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataAggregateFields = {
  __typename?: 'TimesheetEntryLinkDataAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<TimesheetEntryLinkDataMaxFields>;
  min?: Maybe<TimesheetEntryLinkDataMinFields>;
};


/** aggregate fields of "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TimesheetEntryLinkDataSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TimesheetEntryLinkDataMaxOrderBy>;
  min?: InputMaybe<TimesheetEntryLinkDataMinOrderBy>;
};

/** input type for inserting array relation for remote table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataArrRelInsertInput = {
  data: Array<TimesheetEntryLinkDataInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TimesheetEntryLinkDataOnConflict>;
};

/** Boolean expression to filter rows from the table "timesheet_entry_link_data". All fields are combined with a logical 'AND'. */
export type TimesheetEntryLinkDataBoolExp = {
  _and?: InputMaybe<Array<TimesheetEntryLinkDataBoolExp>>;
  _not?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
  _or?: InputMaybe<Array<TimesheetEntryLinkDataBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobAppointment?: InputMaybe<JobAppointmentsBoolExp>;
  jobAppointmentAssignmentGuid?: InputMaybe<UuidComparisonExp>;
  jobAppointmentGuid?: InputMaybe<UuidComparisonExp>;
  jobCostItem?: InputMaybe<JobCostItemsBoolExp>;
  jobCostItemGuid?: InputMaybe<UuidComparisonExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  laborCostSuppressedAt?: InputMaybe<TimestamptzComparisonExp>;
  timesheetEntry?: InputMaybe<TimesheetEntriesBoolExp>;
  timesheetEntryGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataConstraint =
  /** unique or primary key constraint on columns "timesheet_entry_guid" */
  | 'timesheet_entry_link_data_pkey';

/** input type for inserting data into table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobAppointment?: InputMaybe<JobAppointmentsObjRelInsertInput>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobCostItem?: InputMaybe<JobCostItemsObjRelInsertInput>;
  jobCostItemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  laborCostSuppressedAt?: InputMaybe<Scalars['timestamptz']>;
  timesheetEntry?: InputMaybe<TimesheetEntriesObjRelInsertInput>;
  timesheetEntryGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type TimesheetEntryLinkDataMaxFields = {
  __typename?: 'TimesheetEntryLinkDataMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobCostItemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  laborCostSuppressedAt?: Maybe<Scalars['timestamptz']>;
  timesheetEntryGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobCostItemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  laborCostSuppressedAt?: InputMaybe<OrderBy>;
  timesheetEntryGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TimesheetEntryLinkDataMinFields = {
  __typename?: 'TimesheetEntryLinkDataMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentAssignmentGuid?: Maybe<Scalars['uuid']>;
  jobAppointmentGuid?: Maybe<Scalars['uuid']>;
  jobCostItemGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  laborCostSuppressedAt?: Maybe<Scalars['timestamptz']>;
  timesheetEntryGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobCostItemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  laborCostSuppressedAt?: InputMaybe<OrderBy>;
  timesheetEntryGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataMutationResponse = {
  __typename?: 'TimesheetEntryLinkDataMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TimesheetEntryLinkData>;
};

/** input type for inserting object relation for remote table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataObjRelInsertInput = {
  data: TimesheetEntryLinkDataInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TimesheetEntryLinkDataOnConflict>;
};

/** on_conflict condition type for table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataOnConflict = {
  constraint: TimesheetEntryLinkDataConstraint;
  updateColumns?: Array<TimesheetEntryLinkDataUpdateColumn>;
  where?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
};

/** Ordering options when selecting data from "timesheet_entry_link_data". */
export type TimesheetEntryLinkDataOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobAppointment?: InputMaybe<JobAppointmentsOrderBy>;
  jobAppointmentAssignmentGuid?: InputMaybe<OrderBy>;
  jobAppointmentGuid?: InputMaybe<OrderBy>;
  jobCostItem?: InputMaybe<JobCostItemsOrderBy>;
  jobCostItemGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  laborCostSuppressedAt?: InputMaybe<OrderBy>;
  timesheetEntry?: InputMaybe<TimesheetEntriesOrderBy>;
  timesheetEntryGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: timesheet_entry_link_data */
export type TimesheetEntryLinkDataPkColumnsInput = {
  timesheetEntryGuid: Scalars['uuid'];
};

/** select columns of table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobCostItemGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'laborCostSuppressedAt'
  /** column name */
  | 'timesheetEntryGuid';

/** input type for updating data in table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobCostItemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  laborCostSuppressedAt?: InputMaybe<Scalars['timestamptz']>;
  timesheetEntryGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TimesheetEntryLinkDataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TimesheetEntryLinkDataStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentAssignmentGuid?: InputMaybe<Scalars['uuid']>;
  jobAppointmentGuid?: InputMaybe<Scalars['uuid']>;
  jobCostItemGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  laborCostSuppressedAt?: InputMaybe<Scalars['timestamptz']>;
  timesheetEntryGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "timesheet_entry_link_data" */
export type TimesheetEntryLinkDataUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'jobAppointmentAssignmentGuid'
  /** column name */
  | 'jobAppointmentGuid'
  /** column name */
  | 'jobCostItemGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'laborCostSuppressedAt'
  /** column name */
  | 'timesheetEntryGuid';

export type TimesheetEntryLinkDataUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TimesheetEntryLinkDataSetInput>;
  /** filter the rows which have to be updated */
  where: TimesheetEntryLinkDataBoolExp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type TimestampComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Extends the entitlements schema to include additional information for entitlements with a "TUNE_UP_VISIT" type */
export type TuneUpVisitEntitlements = {
  __typename?: 'TuneUpVisitEntitlements';
  consumedAt?: Maybe<Scalars['timestamptz']>;
  consumedByJobGuid?: Maybe<Scalars['uuid']>;
  dateRangeEndAffinity?: Maybe<Scalars['date']>;
  dateRangeStartAffinity?: Maybe<Scalars['date']>;
  entitlementGuid: Scalars['uuid'];
  equipmentTypeAffinity?: Maybe<Scalars['jsonb']>;
};


/** Extends the entitlements schema to include additional information for entitlements with a "TUNE_UP_VISIT" type */
export type TuneUpVisitEntitlementsEquipmentTypeAffinityArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "tune_up_visit_entitlements" */
export type TuneUpVisitEntitlementsAggregate = {
  __typename?: 'TuneUpVisitEntitlementsAggregate';
  aggregate?: Maybe<TuneUpVisitEntitlementsAggregateFields>;
  nodes: Array<TuneUpVisitEntitlements>;
};

/** aggregate fields of "tune_up_visit_entitlements" */
export type TuneUpVisitEntitlementsAggregateFields = {
  __typename?: 'TuneUpVisitEntitlementsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<TuneUpVisitEntitlementsMaxFields>;
  min?: Maybe<TuneUpVisitEntitlementsMinFields>;
};


/** aggregate fields of "tune_up_visit_entitlements" */
export type TuneUpVisitEntitlementsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TuneUpVisitEntitlementsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TuneUpVisitEntitlementsAppendInput = {
  equipmentTypeAffinity?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "tune_up_visit_entitlements". All fields are combined with a logical 'AND'. */
export type TuneUpVisitEntitlementsBoolExp = {
  _and?: InputMaybe<Array<TuneUpVisitEntitlementsBoolExp>>;
  _not?: InputMaybe<TuneUpVisitEntitlementsBoolExp>;
  _or?: InputMaybe<Array<TuneUpVisitEntitlementsBoolExp>>;
  consumedAt?: InputMaybe<TimestamptzComparisonExp>;
  consumedByJobGuid?: InputMaybe<UuidComparisonExp>;
  dateRangeEndAffinity?: InputMaybe<DateComparisonExp>;
  dateRangeStartAffinity?: InputMaybe<DateComparisonExp>;
  entitlementGuid?: InputMaybe<UuidComparisonExp>;
  equipmentTypeAffinity?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "tune_up_visit_entitlements" */
export type TuneUpVisitEntitlementsConstraint =
  /** unique or primary key constraint on columns "entitlement_guid" */
  | 'tune_up_visit_entitlements_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TuneUpVisitEntitlementsDeleteAtPathInput = {
  equipmentTypeAffinity?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TuneUpVisitEntitlementsDeleteElemInput = {
  equipmentTypeAffinity?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TuneUpVisitEntitlementsDeleteKeyInput = {
  equipmentTypeAffinity?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "tune_up_visit_entitlements" */
export type TuneUpVisitEntitlementsInsertInput = {
  consumedAt?: InputMaybe<Scalars['timestamptz']>;
  consumedByJobGuid?: InputMaybe<Scalars['uuid']>;
  dateRangeEndAffinity?: InputMaybe<Scalars['date']>;
  dateRangeStartAffinity?: InputMaybe<Scalars['date']>;
  entitlementGuid?: InputMaybe<Scalars['uuid']>;
  equipmentTypeAffinity?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type TuneUpVisitEntitlementsMaxFields = {
  __typename?: 'TuneUpVisitEntitlementsMaxFields';
  consumedAt?: Maybe<Scalars['timestamptz']>;
  consumedByJobGuid?: Maybe<Scalars['uuid']>;
  dateRangeEndAffinity?: Maybe<Scalars['date']>;
  dateRangeStartAffinity?: Maybe<Scalars['date']>;
  entitlementGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type TuneUpVisitEntitlementsMinFields = {
  __typename?: 'TuneUpVisitEntitlementsMinFields';
  consumedAt?: Maybe<Scalars['timestamptz']>;
  consumedByJobGuid?: Maybe<Scalars['uuid']>;
  dateRangeEndAffinity?: Maybe<Scalars['date']>;
  dateRangeStartAffinity?: Maybe<Scalars['date']>;
  entitlementGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "tune_up_visit_entitlements" */
export type TuneUpVisitEntitlementsMutationResponse = {
  __typename?: 'TuneUpVisitEntitlementsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TuneUpVisitEntitlements>;
};

/** on_conflict condition type for table "tune_up_visit_entitlements" */
export type TuneUpVisitEntitlementsOnConflict = {
  constraint: TuneUpVisitEntitlementsConstraint;
  updateColumns?: Array<TuneUpVisitEntitlementsUpdateColumn>;
  where?: InputMaybe<TuneUpVisitEntitlementsBoolExp>;
};

/** Ordering options when selecting data from "tune_up_visit_entitlements". */
export type TuneUpVisitEntitlementsOrderBy = {
  consumedAt?: InputMaybe<OrderBy>;
  consumedByJobGuid?: InputMaybe<OrderBy>;
  dateRangeEndAffinity?: InputMaybe<OrderBy>;
  dateRangeStartAffinity?: InputMaybe<OrderBy>;
  entitlementGuid?: InputMaybe<OrderBy>;
  equipmentTypeAffinity?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: tune_up_visit_entitlements */
export type TuneUpVisitEntitlementsPkColumnsInput = {
  entitlementGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TuneUpVisitEntitlementsPrependInput = {
  equipmentTypeAffinity?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "tune_up_visit_entitlements" */
export type TuneUpVisitEntitlementsSelectColumn =
  /** column name */
  | 'consumedAt'
  /** column name */
  | 'consumedByJobGuid'
  /** column name */
  | 'dateRangeEndAffinity'
  /** column name */
  | 'dateRangeStartAffinity'
  /** column name */
  | 'entitlementGuid'
  /** column name */
  | 'equipmentTypeAffinity';

/** input type for updating data in table "tune_up_visit_entitlements" */
export type TuneUpVisitEntitlementsSetInput = {
  consumedAt?: InputMaybe<Scalars['timestamptz']>;
  consumedByJobGuid?: InputMaybe<Scalars['uuid']>;
  dateRangeEndAffinity?: InputMaybe<Scalars['date']>;
  dateRangeStartAffinity?: InputMaybe<Scalars['date']>;
  entitlementGuid?: InputMaybe<Scalars['uuid']>;
  equipmentTypeAffinity?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "tune_up_visit_entitlements" */
export type TuneUpVisitEntitlementsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TuneUpVisitEntitlementsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TuneUpVisitEntitlementsStreamCursorValueInput = {
  consumedAt?: InputMaybe<Scalars['timestamptz']>;
  consumedByJobGuid?: InputMaybe<Scalars['uuid']>;
  dateRangeEndAffinity?: InputMaybe<Scalars['date']>;
  dateRangeStartAffinity?: InputMaybe<Scalars['date']>;
  entitlementGuid?: InputMaybe<Scalars['uuid']>;
  equipmentTypeAffinity?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "tune_up_visit_entitlements" */
export type TuneUpVisitEntitlementsUpdateColumn =
  /** column name */
  | 'consumedAt'
  /** column name */
  | 'consumedByJobGuid'
  /** column name */
  | 'dateRangeEndAffinity'
  /** column name */
  | 'dateRangeStartAffinity'
  /** column name */
  | 'entitlementGuid'
  /** column name */
  | 'equipmentTypeAffinity';

export type TuneUpVisitEntitlementsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TuneUpVisitEntitlementsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<TuneUpVisitEntitlementsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<TuneUpVisitEntitlementsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<TuneUpVisitEntitlementsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TuneUpVisitEntitlementsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TuneUpVisitEntitlementsSetInput>;
  /** filter the rows which have to be updated */
  where: TuneUpVisitEntitlementsBoolExp;
};

/** columns and relationships of "unnotified_account_reminders" */
export type UnnotifiedAccountReminders = {
  __typename?: 'UnnotifiedAccountReminders';
  /** An object relationship */
  account: Accounts;
  accountGuid: Scalars['uuid'];
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  reminder: Reminders;
  reminderGuid?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "unnotified_account_reminders" */
export type UnnotifiedAccountRemindersAggregate = {
  __typename?: 'UnnotifiedAccountRemindersAggregate';
  aggregate?: Maybe<UnnotifiedAccountRemindersAggregateFields>;
  nodes: Array<UnnotifiedAccountReminders>;
};

/** aggregate fields of "unnotified_account_reminders" */
export type UnnotifiedAccountRemindersAggregateFields = {
  __typename?: 'UnnotifiedAccountRemindersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UnnotifiedAccountRemindersMaxFields>;
  min?: Maybe<UnnotifiedAccountRemindersMinFields>;
};


/** aggregate fields of "unnotified_account_reminders" */
export type UnnotifiedAccountRemindersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UnnotifiedAccountRemindersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "unnotified_account_reminders". All fields are combined with a logical 'AND'. */
export type UnnotifiedAccountRemindersBoolExp = {
  _and?: InputMaybe<Array<UnnotifiedAccountRemindersBoolExp>>;
  _not?: InputMaybe<UnnotifiedAccountRemindersBoolExp>;
  _or?: InputMaybe<Array<UnnotifiedAccountRemindersBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  dueAt?: InputMaybe<TimestamptzComparisonExp>;
  reminder?: InputMaybe<RemindersBoolExp>;
  reminderGuid?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** aggregate max on columns */
export type UnnotifiedAccountRemindersMaxFields = {
  __typename?: 'UnnotifiedAccountRemindersMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  reminderGuid?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type UnnotifiedAccountRemindersMinFields = {
  __typename?: 'UnnotifiedAccountRemindersMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['timestamptz']>;
  reminderGuid?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "unnotified_account_reminders". */
export type UnnotifiedAccountRemindersOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  dueAt?: InputMaybe<OrderBy>;
  reminder?: InputMaybe<RemindersOrderBy>;
  reminderGuid?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "unnotified_account_reminders" */
export type UnnotifiedAccountRemindersSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'description'
  /** column name */
  | 'dueAt'
  /** column name */
  | 'reminderGuid'
  /** column name */
  | 'status'
  /** column name */
  | 'updatedAt';

/** Streaming cursor of the table "unnotified_account_reminders" */
export type UnnotifiedAccountRemindersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UnnotifiedAccountRemindersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UnnotifiedAccountRemindersStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['timestamptz']>;
  reminderGuid?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "user_business_units" */
export type UserBusinessUnits = {
  __typename?: 'UserBusinessUnits';
  /** An object relationship */
  businessUnit: BusinessUnits;
  businessUnitGuid: Scalars['uuid'];
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  dateEnd?: Maybe<Scalars['date']>;
  dateStart: Scalars['date'];
  /** An object relationship */
  user: Users;
  userBusinessUnitGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "user_business_units" */
export type UserBusinessUnitsAggregate = {
  __typename?: 'UserBusinessUnitsAggregate';
  aggregate?: Maybe<UserBusinessUnitsAggregateFields>;
  nodes: Array<UserBusinessUnits>;
};

/** aggregate fields of "user_business_units" */
export type UserBusinessUnitsAggregateFields = {
  __typename?: 'UserBusinessUnitsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserBusinessUnitsMaxFields>;
  min?: Maybe<UserBusinessUnitsMinFields>;
};


/** aggregate fields of "user_business_units" */
export type UserBusinessUnitsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserBusinessUnitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_business_units". All fields are combined with a logical 'AND'. */
export type UserBusinessUnitsBoolExp = {
  _and?: InputMaybe<Array<UserBusinessUnitsBoolExp>>;
  _not?: InputMaybe<UserBusinessUnitsBoolExp>;
  _or?: InputMaybe<Array<UserBusinessUnitsBoolExp>>;
  businessUnit?: InputMaybe<BusinessUnitsBoolExp>;
  businessUnitGuid?: InputMaybe<UuidComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dateEnd?: InputMaybe<DateComparisonExp>;
  dateStart?: InputMaybe<DateComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userBusinessUnitGuid?: InputMaybe<UuidComparisonExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_business_units" */
export type UserBusinessUnitsConstraint =
  /** unique or primary key constraint on columns "user_guid", "company_guid" */
  | 'uniq_user_business_units_active'
  /** unique or primary key constraint on columns "user_business_unit_guid" */
  | 'user_business_units_pkey';

/** input type for inserting data into table "user_business_units" */
export type UserBusinessUnitsInsertInput = {
  businessUnit?: InputMaybe<BusinessUnitsObjRelInsertInput>;
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dateEnd?: InputMaybe<Scalars['date']>;
  dateStart?: InputMaybe<Scalars['date']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userBusinessUnitGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserBusinessUnitsMaxFields = {
  __typename?: 'UserBusinessUnitsMaxFields';
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dateEnd?: Maybe<Scalars['date']>;
  dateStart?: Maybe<Scalars['date']>;
  userBusinessUnitGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type UserBusinessUnitsMinFields = {
  __typename?: 'UserBusinessUnitsMinFields';
  businessUnitGuid?: Maybe<Scalars['uuid']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dateEnd?: Maybe<Scalars['date']>;
  dateStart?: Maybe<Scalars['date']>;
  userBusinessUnitGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_business_units" */
export type UserBusinessUnitsMutationResponse = {
  __typename?: 'UserBusinessUnitsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserBusinessUnits>;
};

/** on_conflict condition type for table "user_business_units" */
export type UserBusinessUnitsOnConflict = {
  constraint: UserBusinessUnitsConstraint;
  updateColumns?: Array<UserBusinessUnitsUpdateColumn>;
  where?: InputMaybe<UserBusinessUnitsBoolExp>;
};

/** Ordering options when selecting data from "user_business_units". */
export type UserBusinessUnitsOrderBy = {
  businessUnit?: InputMaybe<BusinessUnitsOrderBy>;
  businessUnitGuid?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dateEnd?: InputMaybe<OrderBy>;
  dateStart?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userBusinessUnitGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_business_units */
export type UserBusinessUnitsPkColumnsInput = {
  userBusinessUnitGuid: Scalars['uuid'];
};

/** select columns of table "user_business_units" */
export type UserBusinessUnitsSelectColumn =
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dateEnd'
  /** column name */
  | 'dateStart'
  /** column name */
  | 'userBusinessUnitGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "user_business_units" */
export type UserBusinessUnitsSetInput = {
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dateEnd?: InputMaybe<Scalars['date']>;
  dateStart?: InputMaybe<Scalars['date']>;
  userBusinessUnitGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_business_units" */
export type UserBusinessUnitsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserBusinessUnitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserBusinessUnitsStreamCursorValueInput = {
  businessUnitGuid?: InputMaybe<Scalars['uuid']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dateEnd?: InputMaybe<Scalars['date']>;
  dateStart?: InputMaybe<Scalars['date']>;
  userBusinessUnitGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_business_units" */
export type UserBusinessUnitsUpdateColumn =
  /** column name */
  | 'businessUnitGuid'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dateEnd'
  /** column name */
  | 'dateStart'
  /** column name */
  | 'userBusinessUnitGuid'
  /** column name */
  | 'userGuid';

export type UserBusinessUnitsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserBusinessUnitsSetInput>;
  /** filter the rows which have to be updated */
  where: UserBusinessUnitsBoolExp;
};

/** Many to many mapping of users to permissions */
export type UserPermissions = {
  __typename?: 'UserPermissions';
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  /** An object relationship */
  permission: Permissions;
  permissionName: Scalars['String'];
  /** An object relationship */
  user: Users;
  /** An object relationship */
  userByUserGuid: Users;
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "user_permissions" */
export type UserPermissionsAggregate = {
  __typename?: 'UserPermissionsAggregate';
  aggregate?: Maybe<UserPermissionsAggregateFields>;
  nodes: Array<UserPermissions>;
};

export type UserPermissionsAggregateBoolExp = {
  count?: InputMaybe<UserPermissionsAggregateBoolExpCount>;
};

/** aggregate fields of "user_permissions" */
export type UserPermissionsAggregateFields = {
  __typename?: 'UserPermissionsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserPermissionsMaxFields>;
  min?: Maybe<UserPermissionsMinFields>;
};


/** aggregate fields of "user_permissions" */
export type UserPermissionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPermissionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_permissions" */
export type UserPermissionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserPermissionsMaxOrderBy>;
  min?: InputMaybe<UserPermissionsMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_permissions". All fields are combined with a logical 'AND'. */
export type UserPermissionsBoolExp = {
  _and?: InputMaybe<Array<UserPermissionsBoolExp>>;
  _not?: InputMaybe<UserPermissionsBoolExp>;
  _or?: InputMaybe<Array<UserPermissionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  permission?: InputMaybe<PermissionsBoolExp>;
  permissionName?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userByUserGuid?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type UserPermissionsMaxFields = {
  __typename?: 'UserPermissionsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  permissionName?: Maybe<Scalars['String']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_permissions" */
export type UserPermissionsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  permissionName?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserPermissionsMinFields = {
  __typename?: 'UserPermissionsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  permissionName?: Maybe<Scalars['String']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_permissions" */
export type UserPermissionsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  permissionName?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_permissions". */
export type UserPermissionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  permission?: InputMaybe<PermissionsOrderBy>;
  permissionName?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userByUserGuid?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** select columns of table "user_permissions" */
export type UserPermissionsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'permissionName'
  /** column name */
  | 'userGuid';

/** Streaming cursor of the table "user_permissions" */
export type UserPermissionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPermissionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPermissionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  permissionName?: InputMaybe<Scalars['String']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "user_permissions_v2" */
export type UserPermissionsV2 = {
  __typename?: 'UserPermissionsV2';
  createdAt: Scalars['timestamptz'];
  createdByUserGuid: Scalars['uuid'];
  permissionName: Scalars['String'];
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "user_permissions_v2" */
export type UserPermissionsV2Aggregate = {
  __typename?: 'UserPermissionsV2Aggregate';
  aggregate?: Maybe<UserPermissionsV2AggregateFields>;
  nodes: Array<UserPermissionsV2>;
};

export type UserPermissionsV2AggregateBoolExp = {
  count?: InputMaybe<UserPermissionsV2AggregateBoolExpCount>;
};

/** aggregate fields of "user_permissions_v2" */
export type UserPermissionsV2AggregateFields = {
  __typename?: 'UserPermissionsV2AggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserPermissionsV2MaxFields>;
  min?: Maybe<UserPermissionsV2MinFields>;
};


/** aggregate fields of "user_permissions_v2" */
export type UserPermissionsV2AggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPermissionsV2SelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_permissions_v2" */
export type UserPermissionsV2AggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserPermissionsV2MaxOrderBy>;
  min?: InputMaybe<UserPermissionsV2MinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_permissions_v2". All fields are combined with a logical 'AND'. */
export type UserPermissionsV2BoolExp = {
  _and?: InputMaybe<Array<UserPermissionsV2BoolExp>>;
  _not?: InputMaybe<UserPermissionsV2BoolExp>;
  _or?: InputMaybe<Array<UserPermissionsV2BoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  permissionName?: InputMaybe<StringComparisonExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type UserPermissionsV2MaxFields = {
  __typename?: 'UserPermissionsV2MaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  permissionName?: Maybe<Scalars['String']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_permissions_v2" */
export type UserPermissionsV2MaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  permissionName?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserPermissionsV2MinFields = {
  __typename?: 'UserPermissionsV2MinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  permissionName?: Maybe<Scalars['String']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_permissions_v2" */
export type UserPermissionsV2MinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  permissionName?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_permissions_v2". */
export type UserPermissionsV2OrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  permissionName?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** select columns of table "user_permissions_v2" */
export type UserPermissionsV2SelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'permissionName'
  /** column name */
  | 'userGuid';

/** Streaming cursor of the table "user_permissions_v2" */
export type UserPermissionsV2StreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPermissionsV2StreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPermissionsV2StreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  permissionName?: InputMaybe<Scalars['String']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "user_phone_numbers" */
export type UserPhoneNumbers = {
  __typename?: 'UserPhoneNumbers';
  /** An object relationship */
  phoneNumber: PhoneNumbers;
  phoneNumberGuid: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "user_phone_numbers" */
export type UserPhoneNumbersAggregate = {
  __typename?: 'UserPhoneNumbersAggregate';
  aggregate?: Maybe<UserPhoneNumbersAggregateFields>;
  nodes: Array<UserPhoneNumbers>;
};

export type UserPhoneNumbersAggregateBoolExp = {
  count?: InputMaybe<UserPhoneNumbersAggregateBoolExpCount>;
};

/** aggregate fields of "user_phone_numbers" */
export type UserPhoneNumbersAggregateFields = {
  __typename?: 'UserPhoneNumbersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserPhoneNumbersMaxFields>;
  min?: Maybe<UserPhoneNumbersMinFields>;
};


/** aggregate fields of "user_phone_numbers" */
export type UserPhoneNumbersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserPhoneNumbersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_phone_numbers" */
export type UserPhoneNumbersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserPhoneNumbersMaxOrderBy>;
  min?: InputMaybe<UserPhoneNumbersMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_phone_numbers" */
export type UserPhoneNumbersArrRelInsertInput = {
  data: Array<UserPhoneNumbersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserPhoneNumbersOnConflict>;
};

/** Boolean expression to filter rows from the table "user_phone_numbers". All fields are combined with a logical 'AND'. */
export type UserPhoneNumbersBoolExp = {
  _and?: InputMaybe<Array<UserPhoneNumbersBoolExp>>;
  _not?: InputMaybe<UserPhoneNumbersBoolExp>;
  _or?: InputMaybe<Array<UserPhoneNumbersBoolExp>>;
  phoneNumber?: InputMaybe<PhoneNumbersBoolExp>;
  phoneNumberGuid?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_phone_numbers" */
export type UserPhoneNumbersConstraint =
  /** unique or primary key constraint on columns "user_guid", "phone_number_guid" */
  | 'user_phone_numbers_pkey';

/** input type for inserting data into table "user_phone_numbers" */
export type UserPhoneNumbersInsertInput = {
  phoneNumber?: InputMaybe<PhoneNumbersObjRelInsertInput>;
  phoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserPhoneNumbersMaxFields = {
  __typename?: 'UserPhoneNumbersMaxFields';
  phoneNumberGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_phone_numbers" */
export type UserPhoneNumbersMaxOrderBy = {
  phoneNumberGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserPhoneNumbersMinFields = {
  __typename?: 'UserPhoneNumbersMinFields';
  phoneNumberGuid?: Maybe<Scalars['uuid']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_phone_numbers" */
export type UserPhoneNumbersMinOrderBy = {
  phoneNumberGuid?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_phone_numbers" */
export type UserPhoneNumbersMutationResponse = {
  __typename?: 'UserPhoneNumbersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPhoneNumbers>;
};

/** on_conflict condition type for table "user_phone_numbers" */
export type UserPhoneNumbersOnConflict = {
  constraint: UserPhoneNumbersConstraint;
  updateColumns?: Array<UserPhoneNumbersUpdateColumn>;
  where?: InputMaybe<UserPhoneNumbersBoolExp>;
};

/** Ordering options when selecting data from "user_phone_numbers". */
export type UserPhoneNumbersOrderBy = {
  phoneNumber?: InputMaybe<PhoneNumbersOrderBy>;
  phoneNumberGuid?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_phone_numbers */
export type UserPhoneNumbersPkColumnsInput = {
  phoneNumberGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};

/** select columns of table "user_phone_numbers" */
export type UserPhoneNumbersSelectColumn =
  /** column name */
  | 'phoneNumberGuid'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "user_phone_numbers" */
export type UserPhoneNumbersSetInput = {
  phoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_phone_numbers" */
export type UserPhoneNumbersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserPhoneNumbersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPhoneNumbersStreamCursorValueInput = {
  phoneNumberGuid?: InputMaybe<Scalars['uuid']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_phone_numbers" */
export type UserPhoneNumbersUpdateColumn =
  /** column name */
  | 'phoneNumberGuid'
  /** column name */
  | 'userGuid';

export type UserPhoneNumbersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPhoneNumbersSetInput>;
  /** filter the rows which have to be updated */
  where: UserPhoneNumbersBoolExp;
};

/** columns and relationships of "user_roles" */
export type UserRoles = {
  __typename?: 'UserRoles';
  role: Scalars['RoleId'];
  /** An object relationship */
  roleById: CompanyRoles;
  /** An object relationship */
  user: Users;
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "user_roles" */
export type UserRolesAggregate = {
  __typename?: 'UserRolesAggregate';
  aggregate?: Maybe<UserRolesAggregateFields>;
  nodes: Array<UserRoles>;
};

export type UserRolesAggregateBoolExp = {
  count?: InputMaybe<UserRolesAggregateBoolExpCount>;
};

/** aggregate fields of "user_roles" */
export type UserRolesAggregateFields = {
  __typename?: 'UserRolesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserRolesMaxFields>;
  min?: Maybe<UserRolesMinFields>;
};


/** aggregate fields of "user_roles" */
export type UserRolesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_roles" */
export type UserRolesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserRolesMaxOrderBy>;
  min?: InputMaybe<UserRolesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_roles". All fields are combined with a logical 'AND'. */
export type UserRolesBoolExp = {
  _and?: InputMaybe<Array<UserRolesBoolExp>>;
  _not?: InputMaybe<UserRolesBoolExp>;
  _or?: InputMaybe<Array<UserRolesBoolExp>>;
  role?: InputMaybe<Scalars['RoleIdComparisonExp']>;
  roleById?: InputMaybe<CompanyRolesBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

export type UserRolesInsertInput = {
  __typename?: 'UserRolesInsertInput';
  role?: Maybe<Scalars['RoleId']>;
};

/** aggregate max on columns */
export type UserRolesMaxFields = {
  __typename?: 'UserRolesMaxFields';
  role?: Maybe<Scalars['RoleId']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_roles" */
export type UserRolesMaxOrderBy = {
  role?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserRolesMinFields = {
  __typename?: 'UserRolesMinFields';
  role?: Maybe<Scalars['RoleId']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_roles" */
export type UserRolesMinOrderBy = {
  role?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "user_roles". */
export type UserRolesOrderBy = {
  role?: InputMaybe<OrderBy>;
  roleById?: InputMaybe<CompanyRolesOrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** select columns of table "user_roles" */
export type UserRolesSelectColumn =
  /** column name */
  | 'role'
  /** column name */
  | 'userGuid';

export type UserRolesSetInput = {
  __typename?: 'UserRolesSetInput';
  role?: Maybe<Scalars['RoleId']>;
};

/** Streaming cursor of the table "user_roles" */
export type UserRolesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserRolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRolesStreamCursorValueInput = {
  role?: InputMaybe<Scalars['RoleId']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "user_settings" */
export type UserSettings = {
  __typename?: 'UserSettings';
  companyGuid: Scalars['uuid'];
  hideCallerIdEnabled: Scalars['Boolean'];
  preferredMapApp?: Maybe<Scalars['String']>;
  scheduleColorPreference?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userGuid: Scalars['uuid'];
};

/** aggregated selection of "user_settings" */
export type UserSettingsAggregate = {
  __typename?: 'UserSettingsAggregate';
  aggregate?: Maybe<UserSettingsAggregateFields>;
  nodes: Array<UserSettings>;
};

export type UserSettingsAggregateBoolExp = {
  bool_and?: InputMaybe<UserSettingsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<UserSettingsAggregateBoolExpBool_Or>;
  count?: InputMaybe<UserSettingsAggregateBoolExpCount>;
};

/** aggregate fields of "user_settings" */
export type UserSettingsAggregateFields = {
  __typename?: 'UserSettingsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UserSettingsMaxFields>;
  min?: Maybe<UserSettingsMinFields>;
};


/** aggregate fields of "user_settings" */
export type UserSettingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserSettingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_settings" */
export type UserSettingsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserSettingsMaxOrderBy>;
  min?: InputMaybe<UserSettingsMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_settings" */
export type UserSettingsArrRelInsertInput = {
  data: Array<UserSettingsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserSettingsOnConflict>;
};

/** Boolean expression to filter rows from the table "user_settings". All fields are combined with a logical 'AND'. */
export type UserSettingsBoolExp = {
  _and?: InputMaybe<Array<UserSettingsBoolExp>>;
  _not?: InputMaybe<UserSettingsBoolExp>;
  _or?: InputMaybe<Array<UserSettingsBoolExp>>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  hideCallerIdEnabled?: InputMaybe<BooleanComparisonExp>;
  preferredMapApp?: InputMaybe<StringComparisonExp>;
  scheduleColorPreference?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_settings" */
export type UserSettingsConstraint =
  /** unique or primary key constraint on columns "user_guid" */
  | 'user_settings_pkey';

/** input type for inserting data into table "user_settings" */
export type UserSettingsInsertInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  hideCallerIdEnabled?: InputMaybe<Scalars['Boolean']>;
  preferredMapApp?: InputMaybe<Scalars['String']>;
  scheduleColorPreference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type UserSettingsMaxFields = {
  __typename?: 'UserSettingsMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  preferredMapApp?: Maybe<Scalars['String']>;
  scheduleColorPreference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_settings" */
export type UserSettingsMaxOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  preferredMapApp?: InputMaybe<OrderBy>;
  scheduleColorPreference?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserSettingsMinFields = {
  __typename?: 'UserSettingsMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  preferredMapApp?: Maybe<Scalars['String']>;
  scheduleColorPreference?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_settings" */
export type UserSettingsMinOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  preferredMapApp?: InputMaybe<OrderBy>;
  scheduleColorPreference?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_settings" */
export type UserSettingsMutationResponse = {
  __typename?: 'UserSettingsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserSettings>;
};

/** on_conflict condition type for table "user_settings" */
export type UserSettingsOnConflict = {
  constraint: UserSettingsConstraint;
  updateColumns?: Array<UserSettingsUpdateColumn>;
  where?: InputMaybe<UserSettingsBoolExp>;
};

/** Ordering options when selecting data from "user_settings". */
export type UserSettingsOrderBy = {
  companyGuid?: InputMaybe<OrderBy>;
  hideCallerIdEnabled?: InputMaybe<OrderBy>;
  preferredMapApp?: InputMaybe<OrderBy>;
  scheduleColorPreference?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_settings */
export type UserSettingsPkColumnsInput = {
  userGuid: Scalars['uuid'];
};

/** select columns of table "user_settings" */
export type UserSettingsSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'hideCallerIdEnabled'
  /** column name */
  | 'preferredMapApp'
  /** column name */
  | 'scheduleColorPreference'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userGuid';

/** select "userSettingsAggregateBoolExpBool_andArgumentsColumns" columns of table "user_settings" */
export type UserSettingsSelectColumnUserSettingsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'hideCallerIdEnabled';

/** select "userSettingsAggregateBoolExpBool_orArgumentsColumns" columns of table "user_settings" */
export type UserSettingsSelectColumnUserSettingsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'hideCallerIdEnabled';

/** input type for updating data in table "user_settings" */
export type UserSettingsSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  hideCallerIdEnabled?: InputMaybe<Scalars['Boolean']>;
  preferredMapApp?: InputMaybe<Scalars['String']>;
  scheduleColorPreference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_settings" */
export type UserSettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserSettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserSettingsStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  hideCallerIdEnabled?: InputMaybe<Scalars['Boolean']>;
  preferredMapApp?: InputMaybe<Scalars['String']>;
  scheduleColorPreference?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_settings" */
export type UserSettingsUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'hideCallerIdEnabled'
  /** column name */
  | 'preferredMapApp'
  /** column name */
  | 'scheduleColorPreference'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userGuid';

export type UserSettingsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: UserSettingsBoolExp;
};

/** columns and relationships of "user_wages" */
export type UserWages = {
  __typename?: 'UserWages';
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdByUser: Users;
  createdByUserGuid: Scalars['uuid'];
  fullyBurdenedHourlyWageUsc: Scalars['Int'];
  hourlyWageUsc: Scalars['Int'];
  /** An object relationship */
  user: Users;
  userGuid: Scalars['uuid'];
  userWageGuid: Scalars['uuid'];
  wageDateEnd?: Maybe<Scalars['date']>;
  wageDateStart: Scalars['date'];
};

/** aggregated selection of "user_wages" */
export type UserWagesAggregate = {
  __typename?: 'UserWagesAggregate';
  aggregate?: Maybe<UserWagesAggregateFields>;
  nodes: Array<UserWages>;
};

/** aggregate fields of "user_wages" */
export type UserWagesAggregateFields = {
  __typename?: 'UserWagesAggregateFields';
  avg?: Maybe<UserWagesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserWagesMaxFields>;
  min?: Maybe<UserWagesMinFields>;
  stddev?: Maybe<UserWagesStddevFields>;
  stddevPop?: Maybe<UserWagesStddevPopFields>;
  stddevSamp?: Maybe<UserWagesStddevSampFields>;
  sum?: Maybe<UserWagesSumFields>;
  varPop?: Maybe<UserWagesVarPopFields>;
  varSamp?: Maybe<UserWagesVarSampFields>;
  variance?: Maybe<UserWagesVarianceFields>;
};


/** aggregate fields of "user_wages" */
export type UserWagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserWagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserWagesAvgFields = {
  __typename?: 'UserWagesAvgFields';
  fullyBurdenedHourlyWageUsc?: Maybe<Scalars['Float']>;
  hourlyWageUsc?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_wages". All fields are combined with a logical 'AND'. */
export type UserWagesBoolExp = {
  _and?: InputMaybe<Array<UserWagesBoolExp>>;
  _not?: InputMaybe<UserWagesBoolExp>;
  _or?: InputMaybe<Array<UserWagesBoolExp>>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  createdByUserGuid?: InputMaybe<UuidComparisonExp>;
  fullyBurdenedHourlyWageUsc?: InputMaybe<IntComparisonExp>;
  hourlyWageUsc?: InputMaybe<IntComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
  userWageGuid?: InputMaybe<UuidComparisonExp>;
  wageDateEnd?: InputMaybe<DateComparisonExp>;
  wageDateStart?: InputMaybe<DateComparisonExp>;
};

/** unique or primary key constraints on table "user_wages" */
export type UserWagesConstraint =
  /** unique or primary key constraint on columns "user_guid", "wage_date_start", "company_guid" */
  | 'user_wages_company_user_start_uniq'
  /** unique or primary key constraint on columns "user_wage_guid" */
  | 'user_wages_pkey';

/** input type for incrementing numeric columns in table "user_wages" */
export type UserWagesIncInput = {
  fullyBurdenedHourlyWageUsc?: InputMaybe<Scalars['Int']>;
  hourlyWageUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_wages" */
export type UserWagesInsertInput = {
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  fullyBurdenedHourlyWageUsc?: InputMaybe<Scalars['Int']>;
  hourlyWageUsc?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
  userWageGuid?: InputMaybe<Scalars['uuid']>;
  wageDateEnd?: InputMaybe<Scalars['date']>;
  wageDateStart?: InputMaybe<Scalars['date']>;
};

/** aggregate max on columns */
export type UserWagesMaxFields = {
  __typename?: 'UserWagesMaxFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  fullyBurdenedHourlyWageUsc?: Maybe<Scalars['Int']>;
  hourlyWageUsc?: Maybe<Scalars['Int']>;
  userGuid?: Maybe<Scalars['uuid']>;
  userWageGuid?: Maybe<Scalars['uuid']>;
  wageDateEnd?: Maybe<Scalars['date']>;
  wageDateStart?: Maybe<Scalars['date']>;
};

/** aggregate min on columns */
export type UserWagesMinFields = {
  __typename?: 'UserWagesMinFields';
  companyGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdByUserGuid?: Maybe<Scalars['uuid']>;
  fullyBurdenedHourlyWageUsc?: Maybe<Scalars['Int']>;
  hourlyWageUsc?: Maybe<Scalars['Int']>;
  userGuid?: Maybe<Scalars['uuid']>;
  userWageGuid?: Maybe<Scalars['uuid']>;
  wageDateEnd?: Maybe<Scalars['date']>;
  wageDateStart?: Maybe<Scalars['date']>;
};

/** response of any mutation on the table "user_wages" */
export type UserWagesMutationResponse = {
  __typename?: 'UserWagesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserWages>;
};

/** on_conflict condition type for table "user_wages" */
export type UserWagesOnConflict = {
  constraint: UserWagesConstraint;
  updateColumns?: Array<UserWagesUpdateColumn>;
  where?: InputMaybe<UserWagesBoolExp>;
};

/** Ordering options when selecting data from "user_wages". */
export type UserWagesOrderBy = {
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  createdByUserGuid?: InputMaybe<OrderBy>;
  fullyBurdenedHourlyWageUsc?: InputMaybe<OrderBy>;
  hourlyWageUsc?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
  userWageGuid?: InputMaybe<OrderBy>;
  wageDateEnd?: InputMaybe<OrderBy>;
  wageDateStart?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_wages */
export type UserWagesPkColumnsInput = {
  userWageGuid: Scalars['uuid'];
};

/** select columns of table "user_wages" */
export type UserWagesSelectColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'fullyBurdenedHourlyWageUsc'
  /** column name */
  | 'hourlyWageUsc'
  /** column name */
  | 'userGuid'
  /** column name */
  | 'userWageGuid'
  /** column name */
  | 'wageDateEnd'
  /** column name */
  | 'wageDateStart';

/** input type for updating data in table "user_wages" */
export type UserWagesSetInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  fullyBurdenedHourlyWageUsc?: InputMaybe<Scalars['Int']>;
  hourlyWageUsc?: InputMaybe<Scalars['Int']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
  userWageGuid?: InputMaybe<Scalars['uuid']>;
  wageDateEnd?: InputMaybe<Scalars['date']>;
  wageDateStart?: InputMaybe<Scalars['date']>;
};

/** aggregate stddev on columns */
export type UserWagesStddevFields = {
  __typename?: 'UserWagesStddevFields';
  fullyBurdenedHourlyWageUsc?: Maybe<Scalars['Float']>;
  hourlyWageUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevPop on columns */
export type UserWagesStddevPopFields = {
  __typename?: 'UserWagesStddevPopFields';
  fullyBurdenedHourlyWageUsc?: Maybe<Scalars['Float']>;
  hourlyWageUsc?: Maybe<Scalars['Float']>;
};

/** aggregate stddevSamp on columns */
export type UserWagesStddevSampFields = {
  __typename?: 'UserWagesStddevSampFields';
  fullyBurdenedHourlyWageUsc?: Maybe<Scalars['Float']>;
  hourlyWageUsc?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_wages" */
export type UserWagesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserWagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserWagesStreamCursorValueInput = {
  companyGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdByUserGuid?: InputMaybe<Scalars['uuid']>;
  fullyBurdenedHourlyWageUsc?: InputMaybe<Scalars['Int']>;
  hourlyWageUsc?: InputMaybe<Scalars['Int']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
  userWageGuid?: InputMaybe<Scalars['uuid']>;
  wageDateEnd?: InputMaybe<Scalars['date']>;
  wageDateStart?: InputMaybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type UserWagesSumFields = {
  __typename?: 'UserWagesSumFields';
  fullyBurdenedHourlyWageUsc?: Maybe<Scalars['Int']>;
  hourlyWageUsc?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_wages" */
export type UserWagesUpdateColumn =
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserGuid'
  /** column name */
  | 'fullyBurdenedHourlyWageUsc'
  /** column name */
  | 'hourlyWageUsc'
  /** column name */
  | 'userGuid'
  /** column name */
  | 'userWageGuid'
  /** column name */
  | 'wageDateEnd'
  /** column name */
  | 'wageDateStart';

export type UserWagesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserWagesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserWagesSetInput>;
  /** filter the rows which have to be updated */
  where: UserWagesBoolExp;
};

/** aggregate varPop on columns */
export type UserWagesVarPopFields = {
  __typename?: 'UserWagesVarPopFields';
  fullyBurdenedHourlyWageUsc?: Maybe<Scalars['Float']>;
  hourlyWageUsc?: Maybe<Scalars['Float']>;
};

/** aggregate varSamp on columns */
export type UserWagesVarSampFields = {
  __typename?: 'UserWagesVarSampFields';
  fullyBurdenedHourlyWageUsc?: Maybe<Scalars['Float']>;
  hourlyWageUsc?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserWagesVarianceFields = {
  __typename?: 'UserWagesVarianceFields';
  fullyBurdenedHourlyWageUsc?: Maybe<Scalars['Float']>;
  hourlyWageUsc?: Maybe<Scalars['Float']>;
};

/** Basic info about users of the system */
export type Users = {
  __typename?: 'Users';
  /** An object relationship */
  avatarPhoto?: Maybe<Photos>;
  avatarPhotoGuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  companyUser?: Maybe<CompanyUsers>;
  /** An array relationship */
  companyUsersAdded: Array<CompanyUsers>;
  /** An aggregate relationship */
  companyUsersAddedAggregate: CompanyUsersAggregate;
  deactivatedAt?: Maybe<Scalars['timestamptz']>;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  /** A computed field, concatenates the first name and first initial of the last name e.g Riley M. */
  firstNameInitial?: Maybe<Scalars['String']>;
  /** A computed field, concatenates the first and last name of the user */
  fullName: Scalars['String'];
  /** An array relationship */
  jobAppointmentAssignments: Array<JobAppointmentAssignments>;
  /** An aggregate relationship */
  jobAppointmentAssignmentsAggregate: JobAppointmentAssignmentsAggregate;
  /** An array relationship */
  jobAppointments: Array<JobAppointments>;
  /** An aggregate relationship */
  jobAppointmentsAggregate: JobAppointmentsAggregate;
  /** An array relationship */
  jobsCreated: Array<Jobs>;
  /** An aggregate relationship */
  jobsCreatedAggregate: JobsAggregate;
  lastName: Scalars['String'];
  /** An array relationship */
  timesheetEntries: Array<TimesheetEntries>;
  /** An aggregate relationship */
  timesheetEntriesAggregate: TimesheetEntriesAggregate;
  userGuid: Scalars['uuid'];
  /** An array relationship */
  userPermissions: Array<UserPermissions>;
  /** An aggregate relationship */
  userPermissionsAggregate: UserPermissionsAggregate;
  /** An array relationship */
  userPermissionsByCreatedByUserGuid: Array<UserPermissions>;
  /** An aggregate relationship */
  userPermissionsByCreatedByUserGuidAggregate: UserPermissionsAggregate;
  /** An array relationship */
  userPermissionsV2: Array<UserPermissionsV2>;
  /** An aggregate relationship */
  userPermissionsV2Aggregate: UserPermissionsV2Aggregate;
  /** An array relationship */
  userPermissionsV2ByCreatedByUserGuid: Array<UserPermissionsV2>;
  /** An aggregate relationship */
  userPermissionsV2ByCreatedByUserGuidAggregate: UserPermissionsV2Aggregate;
  /** An array relationship */
  userPhoneNumbers: Array<UserPhoneNumbers>;
  /** An aggregate relationship */
  userPhoneNumbersAggregate: UserPhoneNumbersAggregate;
  userPrimaryHueHex?: Maybe<Scalars['String']>;
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRolesAggregate: UserRolesAggregate;
  /** An array relationship */
  userSettings: Array<UserSettings>;
  /** An aggregate relationship */
  userSettingsAggregate: UserSettingsAggregate;
};


/** Basic info about users of the system */
export type UsersCompanyUsersAddedArgs = {
  distinctOn?: InputMaybe<Array<CompanyUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyUsersOrderBy>>;
  where?: InputMaybe<CompanyUsersBoolExp>;
};


/** Basic info about users of the system */
export type UsersCompanyUsersAddedAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyUsersOrderBy>>;
  where?: InputMaybe<CompanyUsersBoolExp>;
};


/** Basic info about users of the system */
export type UsersJobAppointmentAssignmentsArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
};


/** Basic info about users of the system */
export type UsersJobAppointmentAssignmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
};


/** Basic info about users of the system */
export type UsersJobAppointmentsArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentsBoolExp>;
};


/** Basic info about users of the system */
export type UsersJobAppointmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentsBoolExp>;
};


/** Basic info about users of the system */
export type UsersJobsCreatedArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


/** Basic info about users of the system */
export type UsersJobsCreatedAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


/** Basic info about users of the system */
export type UsersTimesheetEntriesArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntriesOrderBy>>;
  where?: InputMaybe<TimesheetEntriesBoolExp>;
};


/** Basic info about users of the system */
export type UsersTimesheetEntriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntriesOrderBy>>;
  where?: InputMaybe<TimesheetEntriesBoolExp>;
};


/** Basic info about users of the system */
export type UsersUserPermissionsArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsOrderBy>>;
  where?: InputMaybe<UserPermissionsBoolExp>;
};


/** Basic info about users of the system */
export type UsersUserPermissionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsOrderBy>>;
  where?: InputMaybe<UserPermissionsBoolExp>;
};


/** Basic info about users of the system */
export type UsersUserPermissionsByCreatedByUserGuidArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsOrderBy>>;
  where?: InputMaybe<UserPermissionsBoolExp>;
};


/** Basic info about users of the system */
export type UsersUserPermissionsByCreatedByUserGuidAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsOrderBy>>;
  where?: InputMaybe<UserPermissionsBoolExp>;
};


/** Basic info about users of the system */
export type UsersUserPermissionsV2Args = {
  distinctOn?: InputMaybe<Array<UserPermissionsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsV2OrderBy>>;
  where?: InputMaybe<UserPermissionsV2BoolExp>;
};


/** Basic info about users of the system */
export type UsersUserPermissionsV2AggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsV2OrderBy>>;
  where?: InputMaybe<UserPermissionsV2BoolExp>;
};


/** Basic info about users of the system */
export type UsersUserPermissionsV2ByCreatedByUserGuidArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsV2OrderBy>>;
  where?: InputMaybe<UserPermissionsV2BoolExp>;
};


/** Basic info about users of the system */
export type UsersUserPermissionsV2ByCreatedByUserGuidAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsV2OrderBy>>;
  where?: InputMaybe<UserPermissionsV2BoolExp>;
};


/** Basic info about users of the system */
export type UsersUserPhoneNumbersArgs = {
  distinctOn?: InputMaybe<Array<UserPhoneNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPhoneNumbersOrderBy>>;
  where?: InputMaybe<UserPhoneNumbersBoolExp>;
};


/** Basic info about users of the system */
export type UsersUserPhoneNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPhoneNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPhoneNumbersOrderBy>>;
  where?: InputMaybe<UserPhoneNumbersBoolExp>;
};


/** Basic info about users of the system */
export type UsersUserRolesArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


/** Basic info about users of the system */
export type UsersUserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


/** Basic info about users of the system */
export type UsersUserSettingsArgs = {
  distinctOn?: InputMaybe<Array<UserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
  where?: InputMaybe<UserSettingsBoolExp>;
};


/** Basic info about users of the system */
export type UsersUserSettingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
  where?: InputMaybe<UserSettingsBoolExp>;
};

/** aggregated selection of "users" */
export type UsersAggregate = {
  __typename?: 'UsersAggregate';
  aggregate?: Maybe<UsersAggregateFields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type UsersAggregateFields = {
  __typename?: 'UsersAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<UsersMaxFields>;
  min?: Maybe<UsersMinFields>;
};


/** aggregate fields of "users" */
export type UsersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: InputMaybe<Array<UsersBoolExp>>;
  _not?: InputMaybe<UsersBoolExp>;
  _or?: InputMaybe<Array<UsersBoolExp>>;
  avatarPhoto?: InputMaybe<PhotosBoolExp>;
  avatarPhotoGuid?: InputMaybe<UuidComparisonExp>;
  companyUser?: InputMaybe<CompanyUsersBoolExp>;
  companyUsersAdded?: InputMaybe<CompanyUsersBoolExp>;
  companyUsersAddedAggregate?: InputMaybe<CompanyUsersAggregateBoolExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  emailAddress?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  firstNameInitial?: InputMaybe<StringComparisonExp>;
  fullName?: InputMaybe<StringComparisonExp>;
  jobAppointmentAssignments?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
  jobAppointmentAssignmentsAggregate?: InputMaybe<JobAppointmentAssignmentsAggregateBoolExp>;
  jobAppointments?: InputMaybe<JobAppointmentsBoolExp>;
  jobAppointmentsAggregate?: InputMaybe<JobAppointmentsAggregateBoolExp>;
  jobsCreated?: InputMaybe<JobsBoolExp>;
  jobsCreatedAggregate?: InputMaybe<JobsAggregateBoolExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  timesheetEntries?: InputMaybe<TimesheetEntriesBoolExp>;
  timesheetEntriesAggregate?: InputMaybe<TimesheetEntriesAggregateBoolExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
  userPermissions?: InputMaybe<UserPermissionsBoolExp>;
  userPermissionsAggregate?: InputMaybe<UserPermissionsAggregateBoolExp>;
  userPermissionsByCreatedByUserGuid?: InputMaybe<UserPermissionsBoolExp>;
  userPermissionsByCreatedByUserGuidAggregate?: InputMaybe<UserPermissionsAggregateBoolExp>;
  userPermissionsV2?: InputMaybe<UserPermissionsV2BoolExp>;
  userPermissionsV2Aggregate?: InputMaybe<UserPermissionsV2AggregateBoolExp>;
  userPermissionsV2ByCreatedByUserGuid?: InputMaybe<UserPermissionsV2BoolExp>;
  userPermissionsV2ByCreatedByUserGuidAggregate?: InputMaybe<UserPermissionsV2AggregateBoolExp>;
  userPhoneNumbers?: InputMaybe<UserPhoneNumbersBoolExp>;
  userPhoneNumbersAggregate?: InputMaybe<UserPhoneNumbersAggregateBoolExp>;
  userPrimaryHueHex?: InputMaybe<StringComparisonExp>;
  userRoles?: InputMaybe<UserRolesBoolExp>;
  userRolesAggregate?: InputMaybe<UserRolesAggregateBoolExp>;
  userSettings?: InputMaybe<UserSettingsBoolExp>;
  userSettingsAggregate?: InputMaybe<UserSettingsAggregateBoolExp>;
};

/** unique or primary key constraints on table "users" */
export type UsersConstraint =
  /** unique or primary key constraint on columns "email_address" */
  | 'users_email_address_key'
  /** unique or primary key constraint on columns "user_guid" */
  | 'users_pkey';

/** input type for inserting data into table "users" */
export type UsersInsertInput = {
  avatarPhoto?: InputMaybe<PhotosObjRelInsertInput>;
  avatarPhotoGuid?: InputMaybe<Scalars['uuid']>;
  companyUser?: InputMaybe<CompanyUsersObjRelInsertInput>;
  companyUsersAdded?: InputMaybe<CompanyUsersArrRelInsertInput>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  jobAppointmentAssignments?: InputMaybe<JobAppointmentAssignmentsArrRelInsertInput>;
  jobAppointments?: InputMaybe<JobAppointmentsArrRelInsertInput>;
  jobsCreated?: InputMaybe<JobsArrRelInsertInput>;
  lastName?: InputMaybe<Scalars['String']>;
  timesheetEntries?: InputMaybe<TimesheetEntriesArrRelInsertInput>;
  userGuid?: InputMaybe<Scalars['uuid']>;
  userPhoneNumbers?: InputMaybe<UserPhoneNumbersArrRelInsertInput>;
  userPrimaryHueHex?: InputMaybe<Scalars['String']>;
  userSettings?: InputMaybe<UserSettingsArrRelInsertInput>;
};

/** aggregate max on columns */
export type UsersMaxFields = {
  __typename?: 'UsersMaxFields';
  avatarPhotoGuid?: Maybe<Scalars['uuid']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** A computed field, concatenates the first name and first initial of the last name e.g Riley M. */
  firstNameInitial?: Maybe<Scalars['String']>;
  /** A computed field, concatenates the first and last name of the user */
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  userGuid?: Maybe<Scalars['uuid']>;
  userPrimaryHueHex?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UsersMinFields = {
  __typename?: 'UsersMinFields';
  avatarPhotoGuid?: Maybe<Scalars['uuid']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** A computed field, concatenates the first name and first initial of the last name e.g Riley M. */
  firstNameInitial?: Maybe<Scalars['String']>;
  /** A computed field, concatenates the first and last name of the user */
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  userGuid?: Maybe<Scalars['uuid']>;
  userPrimaryHueHex?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "users" */
export type UsersMutationResponse = {
  __typename?: 'UsersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type UsersObjRelInsertInput = {
  data: UsersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UsersOnConflict>;
};

/** on_conflict condition type for table "users" */
export type UsersOnConflict = {
  constraint: UsersConstraint;
  updateColumns?: Array<UsersUpdateColumn>;
  where?: InputMaybe<UsersBoolExp>;
};

/** Ordering options when selecting data from "users". */
export type UsersOrderBy = {
  avatarPhoto?: InputMaybe<PhotosOrderBy>;
  avatarPhotoGuid?: InputMaybe<OrderBy>;
  companyUser?: InputMaybe<CompanyUsersOrderBy>;
  companyUsersAddedAggregate?: InputMaybe<CompanyUsersAggregateOrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  firstNameInitial?: InputMaybe<OrderBy>;
  fullName?: InputMaybe<OrderBy>;
  jobAppointmentAssignmentsAggregate?: InputMaybe<JobAppointmentAssignmentsAggregateOrderBy>;
  jobAppointmentsAggregate?: InputMaybe<JobAppointmentsAggregateOrderBy>;
  jobsCreatedAggregate?: InputMaybe<JobsAggregateOrderBy>;
  lastName?: InputMaybe<OrderBy>;
  timesheetEntriesAggregate?: InputMaybe<TimesheetEntriesAggregateOrderBy>;
  userGuid?: InputMaybe<OrderBy>;
  userPermissionsAggregate?: InputMaybe<UserPermissionsAggregateOrderBy>;
  userPermissionsByCreatedByUserGuidAggregate?: InputMaybe<UserPermissionsAggregateOrderBy>;
  userPermissionsV2Aggregate?: InputMaybe<UserPermissionsV2AggregateOrderBy>;
  userPermissionsV2ByCreatedByUserGuidAggregate?: InputMaybe<UserPermissionsV2AggregateOrderBy>;
  userPhoneNumbersAggregate?: InputMaybe<UserPhoneNumbersAggregateOrderBy>;
  userPrimaryHueHex?: InputMaybe<OrderBy>;
  userRolesAggregate?: InputMaybe<UserRolesAggregateOrderBy>;
  userSettingsAggregate?: InputMaybe<UserSettingsAggregateOrderBy>;
};

/** primary key columns input for table: users */
export type UsersPkColumnsInput = {
  userGuid: Scalars['uuid'];
};

/** select columns of table "users" */
export type UsersSelectColumn =
  /** column name */
  | 'avatarPhotoGuid'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'lastName'
  /** column name */
  | 'userGuid'
  /** column name */
  | 'userPrimaryHueHex';

/** input type for updating data in table "users" */
export type UsersSetInput = {
  avatarPhotoGuid?: InputMaybe<Scalars['uuid']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
  userPrimaryHueHex?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "users" */
export type UsersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersStreamCursorValueInput = {
  avatarPhotoGuid?: InputMaybe<Scalars['uuid']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
  userPrimaryHueHex?: InputMaybe<Scalars['String']>;
};

/** update columns of table "users" */
export type UsersUpdateColumn =
  /** column name */
  | 'avatarPhotoGuid'
  /** column name */
  | 'deactivatedAt'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'lastName'
  /** column name */
  | 'userGuid'
  /** column name */
  | 'userPrimaryHueHex';

export type UsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersSetInput>;
  /** filter the rows which have to be updated */
  where: UsersBoolExp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['uuid']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['uuid']>>;
  _eq?: InputMaybe<Array<Scalars['uuid']>>;
  _gt?: InputMaybe<Array<Scalars['uuid']>>;
  _gte?: InputMaybe<Array<Scalars['uuid']>>;
  _in?: InputMaybe<Array<Array<Scalars['uuid']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['uuid']>>;
  _lte?: InputMaybe<Array<Scalars['uuid']>>;
  _neq?: InputMaybe<Array<Scalars['uuid']>>;
  _nin?: InputMaybe<Array<Array<Scalars['uuid']>>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "wisetack_loan_records" */
export type WisetackLoanRecords = {
  __typename?: 'WisetackLoanRecords';
  /** An object relationship */
  account: Accounts;
  accountGuid: Scalars['uuid'];
  approvedLoanAmountUsc?: Maybe<Scalars['Int']>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  /** An object relationship */
  contact: Contacts;
  contactGuid: Scalars['uuid'];
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  invoice?: Maybe<InvoicesQueryable>;
  invoiceGuid: Scalars['uuid'];
  /** An object relationship */
  invoiceV2?: Maybe<Invoices>;
  /** An object relationship */
  job?: Maybe<Jobs>;
  jobGuid?: Maybe<Scalars['uuid']>;
  loanApplicationLink: Scalars['String'];
  processingFeeUsc?: Maybe<Scalars['Int']>;
  requestedLoanAmountUsc: Scalars['Int'];
  settledLoanAmountUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  wisetackLoanRecordGuid: Scalars['uuid'];
  /** An array relationship */
  wisetackLoanStatuses: Array<WisetackLoanStatuses>;
  /** An aggregate relationship */
  wisetackLoanStatusesAggregate: WisetackLoanStatusesAggregate;
  wisetackMerchantGuid: Scalars['uuid'];
  /** An object relationship */
  wisetackPrequalRecord?: Maybe<WisetackPrequalRecords>;
  wisetackPrequalRecordGuid?: Maybe<Scalars['uuid']>;
  wisetackTransactionGuid: Scalars['uuid'];
};


/** columns and relationships of "wisetack_loan_records" */
export type WisetackLoanRecordsWisetackLoanStatusesArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanStatusesOrderBy>>;
  where?: InputMaybe<WisetackLoanStatusesBoolExp>;
};


/** columns and relationships of "wisetack_loan_records" */
export type WisetackLoanRecordsWisetackLoanStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanStatusesOrderBy>>;
  where?: InputMaybe<WisetackLoanStatusesBoolExp>;
};

/** aggregated selection of "wisetack_loan_records" */
export type WisetackLoanRecordsAggregate = {
  __typename?: 'WisetackLoanRecordsAggregate';
  aggregate?: Maybe<WisetackLoanRecordsAggregateFields>;
  nodes: Array<WisetackLoanRecords>;
};

export type WisetackLoanRecordsAggregateBoolExp = {
  count?: InputMaybe<WisetackLoanRecordsAggregateBoolExpCount>;
};

/** aggregate fields of "wisetack_loan_records" */
export type WisetackLoanRecordsAggregateFields = {
  __typename?: 'WisetackLoanRecordsAggregateFields';
  avg?: Maybe<WisetackLoanRecordsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WisetackLoanRecordsMaxFields>;
  min?: Maybe<WisetackLoanRecordsMinFields>;
  stddev?: Maybe<WisetackLoanRecordsStddevFields>;
  stddevPop?: Maybe<WisetackLoanRecordsStddevPopFields>;
  stddevSamp?: Maybe<WisetackLoanRecordsStddevSampFields>;
  sum?: Maybe<WisetackLoanRecordsSumFields>;
  varPop?: Maybe<WisetackLoanRecordsVarPopFields>;
  varSamp?: Maybe<WisetackLoanRecordsVarSampFields>;
  variance?: Maybe<WisetackLoanRecordsVarianceFields>;
};


/** aggregate fields of "wisetack_loan_records" */
export type WisetackLoanRecordsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WisetackLoanRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "wisetack_loan_records" */
export type WisetackLoanRecordsAggregateOrderBy = {
  avg?: InputMaybe<WisetackLoanRecordsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<WisetackLoanRecordsMaxOrderBy>;
  min?: InputMaybe<WisetackLoanRecordsMinOrderBy>;
  stddev?: InputMaybe<WisetackLoanRecordsStddevOrderBy>;
  stddevPop?: InputMaybe<WisetackLoanRecordsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<WisetackLoanRecordsStddevSampOrderBy>;
  sum?: InputMaybe<WisetackLoanRecordsSumOrderBy>;
  varPop?: InputMaybe<WisetackLoanRecordsVarPopOrderBy>;
  varSamp?: InputMaybe<WisetackLoanRecordsVarSampOrderBy>;
  variance?: InputMaybe<WisetackLoanRecordsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "wisetack_loan_records" */
export type WisetackLoanRecordsArrRelInsertInput = {
  data: Array<WisetackLoanRecordsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<WisetackLoanRecordsOnConflict>;
};

/** aggregate avg on columns */
export type WisetackLoanRecordsAvgFields = {
  __typename?: 'WisetackLoanRecordsAvgFields';
  approvedLoanAmountUsc?: Maybe<Scalars['Float']>;
  processingFeeUsc?: Maybe<Scalars['Float']>;
  requestedLoanAmountUsc?: Maybe<Scalars['Float']>;
  settledLoanAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "wisetack_loan_records" */
export type WisetackLoanRecordsAvgOrderBy = {
  approvedLoanAmountUsc?: InputMaybe<OrderBy>;
  processingFeeUsc?: InputMaybe<OrderBy>;
  requestedLoanAmountUsc?: InputMaybe<OrderBy>;
  settledLoanAmountUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "wisetack_loan_records". All fields are combined with a logical 'AND'. */
export type WisetackLoanRecordsBoolExp = {
  _and?: InputMaybe<Array<WisetackLoanRecordsBoolExp>>;
  _not?: InputMaybe<WisetackLoanRecordsBoolExp>;
  _or?: InputMaybe<Array<WisetackLoanRecordsBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  approvedLoanAmountUsc?: InputMaybe<IntComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  contact?: InputMaybe<ContactsBoolExp>;
  contactGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  expiresAt?: InputMaybe<TimestamptzComparisonExp>;
  invoice?: InputMaybe<InvoicesQueryableBoolExp>;
  invoiceGuid?: InputMaybe<UuidComparisonExp>;
  invoiceV2?: InputMaybe<InvoicesBoolExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  loanApplicationLink?: InputMaybe<StringComparisonExp>;
  processingFeeUsc?: InputMaybe<IntComparisonExp>;
  requestedLoanAmountUsc?: InputMaybe<IntComparisonExp>;
  settledLoanAmountUsc?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  wisetackLoanRecordGuid?: InputMaybe<UuidComparisonExp>;
  wisetackLoanStatuses?: InputMaybe<WisetackLoanStatusesBoolExp>;
  wisetackLoanStatusesAggregate?: InputMaybe<WisetackLoanStatusesAggregateBoolExp>;
  wisetackMerchantGuid?: InputMaybe<UuidComparisonExp>;
  wisetackPrequalRecord?: InputMaybe<WisetackPrequalRecordsBoolExp>;
  wisetackPrequalRecordGuid?: InputMaybe<UuidComparisonExp>;
  wisetackTransactionGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "wisetack_loan_records" */
export type WisetackLoanRecordsConstraint =
  /** unique or primary key constraint on columns "wisetack_loan_record_guid" */
  | 'wisetack_loan_records_pkey'
  /** unique or primary key constraint on columns "wisetack_transaction_guid" */
  | 'wisetack_loan_records_wisetack_transaction_guid_key';

/** input type for incrementing numeric columns in table "wisetack_loan_records" */
export type WisetackLoanRecordsIncInput = {
  approvedLoanAmountUsc?: InputMaybe<Scalars['Int']>;
  processingFeeUsc?: InputMaybe<Scalars['Int']>;
  requestedLoanAmountUsc?: InputMaybe<Scalars['Int']>;
  settledLoanAmountUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "wisetack_loan_records" */
export type WisetackLoanRecordsInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  approvedLoanAmountUsc?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contact?: InputMaybe<ContactsObjRelInsertInput>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  invoice?: InputMaybe<InvoicesQueryableObjRelInsertInput>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  invoiceV2?: InputMaybe<InvoicesObjRelInsertInput>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  loanApplicationLink?: InputMaybe<Scalars['String']>;
  processingFeeUsc?: InputMaybe<Scalars['Int']>;
  requestedLoanAmountUsc?: InputMaybe<Scalars['Int']>;
  settledLoanAmountUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wisetackLoanRecordGuid?: InputMaybe<Scalars['uuid']>;
  wisetackLoanStatuses?: InputMaybe<WisetackLoanStatusesArrRelInsertInput>;
  wisetackMerchantGuid?: InputMaybe<Scalars['uuid']>;
  wisetackPrequalRecord?: InputMaybe<WisetackPrequalRecordsObjRelInsertInput>;
  wisetackPrequalRecordGuid?: InputMaybe<Scalars['uuid']>;
  wisetackTransactionGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type WisetackLoanRecordsMaxFields = {
  __typename?: 'WisetackLoanRecordsMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  approvedLoanAmountUsc?: Maybe<Scalars['Int']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  loanApplicationLink?: Maybe<Scalars['String']>;
  processingFeeUsc?: Maybe<Scalars['Int']>;
  requestedLoanAmountUsc?: Maybe<Scalars['Int']>;
  settledLoanAmountUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  wisetackLoanRecordGuid?: Maybe<Scalars['uuid']>;
  wisetackMerchantGuid?: Maybe<Scalars['uuid']>;
  wisetackPrequalRecordGuid?: Maybe<Scalars['uuid']>;
  wisetackTransactionGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "wisetack_loan_records" */
export type WisetackLoanRecordsMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  approvedLoanAmountUsc?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  loanApplicationLink?: InputMaybe<OrderBy>;
  processingFeeUsc?: InputMaybe<OrderBy>;
  requestedLoanAmountUsc?: InputMaybe<OrderBy>;
  settledLoanAmountUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  wisetackLoanRecordGuid?: InputMaybe<OrderBy>;
  wisetackMerchantGuid?: InputMaybe<OrderBy>;
  wisetackPrequalRecordGuid?: InputMaybe<OrderBy>;
  wisetackTransactionGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type WisetackLoanRecordsMinFields = {
  __typename?: 'WisetackLoanRecordsMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  approvedLoanAmountUsc?: Maybe<Scalars['Int']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  invoiceGuid?: Maybe<Scalars['uuid']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  loanApplicationLink?: Maybe<Scalars['String']>;
  processingFeeUsc?: Maybe<Scalars['Int']>;
  requestedLoanAmountUsc?: Maybe<Scalars['Int']>;
  settledLoanAmountUsc?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  wisetackLoanRecordGuid?: Maybe<Scalars['uuid']>;
  wisetackMerchantGuid?: Maybe<Scalars['uuid']>;
  wisetackPrequalRecordGuid?: Maybe<Scalars['uuid']>;
  wisetackTransactionGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "wisetack_loan_records" */
export type WisetackLoanRecordsMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  approvedLoanAmountUsc?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  loanApplicationLink?: InputMaybe<OrderBy>;
  processingFeeUsc?: InputMaybe<OrderBy>;
  requestedLoanAmountUsc?: InputMaybe<OrderBy>;
  settledLoanAmountUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  wisetackLoanRecordGuid?: InputMaybe<OrderBy>;
  wisetackMerchantGuid?: InputMaybe<OrderBy>;
  wisetackPrequalRecordGuid?: InputMaybe<OrderBy>;
  wisetackTransactionGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "wisetack_loan_records" */
export type WisetackLoanRecordsMutationResponse = {
  __typename?: 'WisetackLoanRecordsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WisetackLoanRecords>;
};

/** input type for inserting object relation for remote table "wisetack_loan_records" */
export type WisetackLoanRecordsObjRelInsertInput = {
  data: WisetackLoanRecordsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<WisetackLoanRecordsOnConflict>;
};

/** on_conflict condition type for table "wisetack_loan_records" */
export type WisetackLoanRecordsOnConflict = {
  constraint: WisetackLoanRecordsConstraint;
  updateColumns?: Array<WisetackLoanRecordsUpdateColumn>;
  where?: InputMaybe<WisetackLoanRecordsBoolExp>;
};

/** Ordering options when selecting data from "wisetack_loan_records". */
export type WisetackLoanRecordsOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  approvedLoanAmountUsc?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contact?: InputMaybe<ContactsOrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  invoice?: InputMaybe<InvoicesQueryableOrderBy>;
  invoiceGuid?: InputMaybe<OrderBy>;
  invoiceV2?: InputMaybe<InvoicesOrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  loanApplicationLink?: InputMaybe<OrderBy>;
  processingFeeUsc?: InputMaybe<OrderBy>;
  requestedLoanAmountUsc?: InputMaybe<OrderBy>;
  settledLoanAmountUsc?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  wisetackLoanRecordGuid?: InputMaybe<OrderBy>;
  wisetackLoanStatusesAggregate?: InputMaybe<WisetackLoanStatusesAggregateOrderBy>;
  wisetackMerchantGuid?: InputMaybe<OrderBy>;
  wisetackPrequalRecord?: InputMaybe<WisetackPrequalRecordsOrderBy>;
  wisetackPrequalRecordGuid?: InputMaybe<OrderBy>;
  wisetackTransactionGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: wisetack_loan_records */
export type WisetackLoanRecordsPkColumnsInput = {
  wisetackLoanRecordGuid: Scalars['uuid'];
};

/** select columns of table "wisetack_loan_records" */
export type WisetackLoanRecordsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'approvedLoanAmountUsc'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'expiresAt'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'loanApplicationLink'
  /** column name */
  | 'processingFeeUsc'
  /** column name */
  | 'requestedLoanAmountUsc'
  /** column name */
  | 'settledLoanAmountUsc'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'wisetackLoanRecordGuid'
  /** column name */
  | 'wisetackMerchantGuid'
  /** column name */
  | 'wisetackPrequalRecordGuid'
  /** column name */
  | 'wisetackTransactionGuid';

/** input type for updating data in table "wisetack_loan_records" */
export type WisetackLoanRecordsSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  approvedLoanAmountUsc?: InputMaybe<Scalars['Int']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  loanApplicationLink?: InputMaybe<Scalars['String']>;
  processingFeeUsc?: InputMaybe<Scalars['Int']>;
  requestedLoanAmountUsc?: InputMaybe<Scalars['Int']>;
  settledLoanAmountUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wisetackLoanRecordGuid?: InputMaybe<Scalars['uuid']>;
  wisetackMerchantGuid?: InputMaybe<Scalars['uuid']>;
  wisetackPrequalRecordGuid?: InputMaybe<Scalars['uuid']>;
  wisetackTransactionGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type WisetackLoanRecordsStddevFields = {
  __typename?: 'WisetackLoanRecordsStddevFields';
  approvedLoanAmountUsc?: Maybe<Scalars['Float']>;
  processingFeeUsc?: Maybe<Scalars['Float']>;
  requestedLoanAmountUsc?: Maybe<Scalars['Float']>;
  settledLoanAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "wisetack_loan_records" */
export type WisetackLoanRecordsStddevOrderBy = {
  approvedLoanAmountUsc?: InputMaybe<OrderBy>;
  processingFeeUsc?: InputMaybe<OrderBy>;
  requestedLoanAmountUsc?: InputMaybe<OrderBy>;
  settledLoanAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type WisetackLoanRecordsStddevPopFields = {
  __typename?: 'WisetackLoanRecordsStddevPopFields';
  approvedLoanAmountUsc?: Maybe<Scalars['Float']>;
  processingFeeUsc?: Maybe<Scalars['Float']>;
  requestedLoanAmountUsc?: Maybe<Scalars['Float']>;
  settledLoanAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "wisetack_loan_records" */
export type WisetackLoanRecordsStddevPopOrderBy = {
  approvedLoanAmountUsc?: InputMaybe<OrderBy>;
  processingFeeUsc?: InputMaybe<OrderBy>;
  requestedLoanAmountUsc?: InputMaybe<OrderBy>;
  settledLoanAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type WisetackLoanRecordsStddevSampFields = {
  __typename?: 'WisetackLoanRecordsStddevSampFields';
  approvedLoanAmountUsc?: Maybe<Scalars['Float']>;
  processingFeeUsc?: Maybe<Scalars['Float']>;
  requestedLoanAmountUsc?: Maybe<Scalars['Float']>;
  settledLoanAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "wisetack_loan_records" */
export type WisetackLoanRecordsStddevSampOrderBy = {
  approvedLoanAmountUsc?: InputMaybe<OrderBy>;
  processingFeeUsc?: InputMaybe<OrderBy>;
  requestedLoanAmountUsc?: InputMaybe<OrderBy>;
  settledLoanAmountUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "wisetack_loan_records" */
export type WisetackLoanRecordsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: WisetackLoanRecordsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WisetackLoanRecordsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  approvedLoanAmountUsc?: InputMaybe<Scalars['Int']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
  invoiceGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  loanApplicationLink?: InputMaybe<Scalars['String']>;
  processingFeeUsc?: InputMaybe<Scalars['Int']>;
  requestedLoanAmountUsc?: InputMaybe<Scalars['Int']>;
  settledLoanAmountUsc?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wisetackLoanRecordGuid?: InputMaybe<Scalars['uuid']>;
  wisetackMerchantGuid?: InputMaybe<Scalars['uuid']>;
  wisetackPrequalRecordGuid?: InputMaybe<Scalars['uuid']>;
  wisetackTransactionGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type WisetackLoanRecordsSumFields = {
  __typename?: 'WisetackLoanRecordsSumFields';
  approvedLoanAmountUsc?: Maybe<Scalars['Int']>;
  processingFeeUsc?: Maybe<Scalars['Int']>;
  requestedLoanAmountUsc?: Maybe<Scalars['Int']>;
  settledLoanAmountUsc?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "wisetack_loan_records" */
export type WisetackLoanRecordsSumOrderBy = {
  approvedLoanAmountUsc?: InputMaybe<OrderBy>;
  processingFeeUsc?: InputMaybe<OrderBy>;
  requestedLoanAmountUsc?: InputMaybe<OrderBy>;
  settledLoanAmountUsc?: InputMaybe<OrderBy>;
};

/** update columns of table "wisetack_loan_records" */
export type WisetackLoanRecordsUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'approvedLoanAmountUsc'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'expiresAt'
  /** column name */
  | 'invoiceGuid'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'loanApplicationLink'
  /** column name */
  | 'processingFeeUsc'
  /** column name */
  | 'requestedLoanAmountUsc'
  /** column name */
  | 'settledLoanAmountUsc'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'wisetackLoanRecordGuid'
  /** column name */
  | 'wisetackMerchantGuid'
  /** column name */
  | 'wisetackPrequalRecordGuid'
  /** column name */
  | 'wisetackTransactionGuid';

export type WisetackLoanRecordsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WisetackLoanRecordsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WisetackLoanRecordsSetInput>;
  /** filter the rows which have to be updated */
  where: WisetackLoanRecordsBoolExp;
};

/** aggregate varPop on columns */
export type WisetackLoanRecordsVarPopFields = {
  __typename?: 'WisetackLoanRecordsVarPopFields';
  approvedLoanAmountUsc?: Maybe<Scalars['Float']>;
  processingFeeUsc?: Maybe<Scalars['Float']>;
  requestedLoanAmountUsc?: Maybe<Scalars['Float']>;
  settledLoanAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "wisetack_loan_records" */
export type WisetackLoanRecordsVarPopOrderBy = {
  approvedLoanAmountUsc?: InputMaybe<OrderBy>;
  processingFeeUsc?: InputMaybe<OrderBy>;
  requestedLoanAmountUsc?: InputMaybe<OrderBy>;
  settledLoanAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type WisetackLoanRecordsVarSampFields = {
  __typename?: 'WisetackLoanRecordsVarSampFields';
  approvedLoanAmountUsc?: Maybe<Scalars['Float']>;
  processingFeeUsc?: Maybe<Scalars['Float']>;
  requestedLoanAmountUsc?: Maybe<Scalars['Float']>;
  settledLoanAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "wisetack_loan_records" */
export type WisetackLoanRecordsVarSampOrderBy = {
  approvedLoanAmountUsc?: InputMaybe<OrderBy>;
  processingFeeUsc?: InputMaybe<OrderBy>;
  requestedLoanAmountUsc?: InputMaybe<OrderBy>;
  settledLoanAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type WisetackLoanRecordsVarianceFields = {
  __typename?: 'WisetackLoanRecordsVarianceFields';
  approvedLoanAmountUsc?: Maybe<Scalars['Float']>;
  processingFeeUsc?: Maybe<Scalars['Float']>;
  requestedLoanAmountUsc?: Maybe<Scalars['Float']>;
  settledLoanAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "wisetack_loan_records" */
export type WisetackLoanRecordsVarianceOrderBy = {
  approvedLoanAmountUsc?: InputMaybe<OrderBy>;
  processingFeeUsc?: InputMaybe<OrderBy>;
  requestedLoanAmountUsc?: InputMaybe<OrderBy>;
  settledLoanAmountUsc?: InputMaybe<OrderBy>;
};

export type WisetackLoanStatusTypesEnum =
  | 'ACTIONS_REQUIRED'
  | 'AUTHORIZED'
  | 'CANCELED'
  | 'DECLINED'
  | 'EXPIRED'
  | 'INITIATED'
  | 'LOAN_CONFIRMED'
  | 'LOAN_TERMS_ACCEPTED'
  | 'PENDING'
  | 'REFUNDED'
  | 'SETTLED';

/** Boolean expression to compare columns of type "WisetackLoanStatusTypesEnum". All fields are combined with logical 'AND'. */
export type WisetackLoanStatusTypesEnumComparisonExp = {
  _eq?: InputMaybe<WisetackLoanStatusTypesEnum>;
  _in?: InputMaybe<Array<WisetackLoanStatusTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<WisetackLoanStatusTypesEnum>;
  _nin?: InputMaybe<Array<WisetackLoanStatusTypesEnum>>;
};

/** columns and relationships of "wisetack_loan_statuses" */
export type WisetackLoanStatuses = {
  __typename?: 'WisetackLoanStatuses';
  createdAt?: Maybe<Scalars['timestamptz']>;
  loanStatus: WisetackLoanStatusTypesEnum;
  loanStatusDetail?: Maybe<Scalars['String']>;
  occurredAt: Scalars['timestamptz'];
  /** An object relationship */
  wisetackLoanRecord: WisetackLoanRecords;
  wisetackLoanRecordGuid: Scalars['uuid'];
  wisetackLoanStatusGuid: Scalars['uuid'];
};

/** aggregated selection of "wisetack_loan_statuses" */
export type WisetackLoanStatusesAggregate = {
  __typename?: 'WisetackLoanStatusesAggregate';
  aggregate?: Maybe<WisetackLoanStatusesAggregateFields>;
  nodes: Array<WisetackLoanStatuses>;
};

export type WisetackLoanStatusesAggregateBoolExp = {
  count?: InputMaybe<WisetackLoanStatusesAggregateBoolExpCount>;
};

/** aggregate fields of "wisetack_loan_statuses" */
export type WisetackLoanStatusesAggregateFields = {
  __typename?: 'WisetackLoanStatusesAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<WisetackLoanStatusesMaxFields>;
  min?: Maybe<WisetackLoanStatusesMinFields>;
};


/** aggregate fields of "wisetack_loan_statuses" */
export type WisetackLoanStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WisetackLoanStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "wisetack_loan_statuses" */
export type WisetackLoanStatusesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<WisetackLoanStatusesMaxOrderBy>;
  min?: InputMaybe<WisetackLoanStatusesMinOrderBy>;
};

/** input type for inserting array relation for remote table "wisetack_loan_statuses" */
export type WisetackLoanStatusesArrRelInsertInput = {
  data: Array<WisetackLoanStatusesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<WisetackLoanStatusesOnConflict>;
};

/** Boolean expression to filter rows from the table "wisetack_loan_statuses". All fields are combined with a logical 'AND'. */
export type WisetackLoanStatusesBoolExp = {
  _and?: InputMaybe<Array<WisetackLoanStatusesBoolExp>>;
  _not?: InputMaybe<WisetackLoanStatusesBoolExp>;
  _or?: InputMaybe<Array<WisetackLoanStatusesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  loanStatus?: InputMaybe<WisetackLoanStatusTypesEnumComparisonExp>;
  loanStatusDetail?: InputMaybe<StringComparisonExp>;
  occurredAt?: InputMaybe<TimestamptzComparisonExp>;
  wisetackLoanRecord?: InputMaybe<WisetackLoanRecordsBoolExp>;
  wisetackLoanRecordGuid?: InputMaybe<UuidComparisonExp>;
  wisetackLoanStatusGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "wisetack_loan_statuses" */
export type WisetackLoanStatusesConstraint =
  /** unique or primary key constraint on columns "wisetack_loan_status_guid" */
  | 'wisetack_loan_statuses_pkey';

/** input type for inserting data into table "wisetack_loan_statuses" */
export type WisetackLoanStatusesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  loanStatus?: InputMaybe<WisetackLoanStatusTypesEnum>;
  loanStatusDetail?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  wisetackLoanRecord?: InputMaybe<WisetackLoanRecordsObjRelInsertInput>;
  wisetackLoanRecordGuid?: InputMaybe<Scalars['uuid']>;
  wisetackLoanStatusGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type WisetackLoanStatusesMaxFields = {
  __typename?: 'WisetackLoanStatusesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  loanStatusDetail?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  wisetackLoanRecordGuid?: Maybe<Scalars['uuid']>;
  wisetackLoanStatusGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "wisetack_loan_statuses" */
export type WisetackLoanStatusesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  loanStatusDetail?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  wisetackLoanRecordGuid?: InputMaybe<OrderBy>;
  wisetackLoanStatusGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type WisetackLoanStatusesMinFields = {
  __typename?: 'WisetackLoanStatusesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  loanStatusDetail?: Maybe<Scalars['String']>;
  occurredAt?: Maybe<Scalars['timestamptz']>;
  wisetackLoanRecordGuid?: Maybe<Scalars['uuid']>;
  wisetackLoanStatusGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "wisetack_loan_statuses" */
export type WisetackLoanStatusesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  loanStatusDetail?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  wisetackLoanRecordGuid?: InputMaybe<OrderBy>;
  wisetackLoanStatusGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "wisetack_loan_statuses" */
export type WisetackLoanStatusesMutationResponse = {
  __typename?: 'WisetackLoanStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WisetackLoanStatuses>;
};

/** on_conflict condition type for table "wisetack_loan_statuses" */
export type WisetackLoanStatusesOnConflict = {
  constraint: WisetackLoanStatusesConstraint;
  updateColumns?: Array<WisetackLoanStatusesUpdateColumn>;
  where?: InputMaybe<WisetackLoanStatusesBoolExp>;
};

/** Ordering options when selecting data from "wisetack_loan_statuses". */
export type WisetackLoanStatusesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  loanStatus?: InputMaybe<OrderBy>;
  loanStatusDetail?: InputMaybe<OrderBy>;
  occurredAt?: InputMaybe<OrderBy>;
  wisetackLoanRecord?: InputMaybe<WisetackLoanRecordsOrderBy>;
  wisetackLoanRecordGuid?: InputMaybe<OrderBy>;
  wisetackLoanStatusGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: wisetack_loan_statuses */
export type WisetackLoanStatusesPkColumnsInput = {
  wisetackLoanStatusGuid: Scalars['uuid'];
};

/** select columns of table "wisetack_loan_statuses" */
export type WisetackLoanStatusesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'loanStatus'
  /** column name */
  | 'loanStatusDetail'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'wisetackLoanRecordGuid'
  /** column name */
  | 'wisetackLoanStatusGuid';

/** input type for updating data in table "wisetack_loan_statuses" */
export type WisetackLoanStatusesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  loanStatus?: InputMaybe<WisetackLoanStatusTypesEnum>;
  loanStatusDetail?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  wisetackLoanRecordGuid?: InputMaybe<Scalars['uuid']>;
  wisetackLoanStatusGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "wisetack_loan_statuses" */
export type WisetackLoanStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: WisetackLoanStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WisetackLoanStatusesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  loanStatus?: InputMaybe<WisetackLoanStatusTypesEnum>;
  loanStatusDetail?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['timestamptz']>;
  wisetackLoanRecordGuid?: InputMaybe<Scalars['uuid']>;
  wisetackLoanStatusGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "wisetack_loan_statuses" */
export type WisetackLoanStatusesUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'loanStatus'
  /** column name */
  | 'loanStatusDetail'
  /** column name */
  | 'occurredAt'
  /** column name */
  | 'wisetackLoanRecordGuid'
  /** column name */
  | 'wisetackLoanStatusGuid';

export type WisetackLoanStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WisetackLoanStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: WisetackLoanStatusesBoolExp;
};

/** columns and relationships of "wisetack_prequal_records" */
export type WisetackPrequalRecords = {
  __typename?: 'WisetackPrequalRecords';
  /** An object relationship */
  account: Accounts;
  accountGuid: Scalars['uuid'];
  aprRange?: Maybe<Scalars['String']>;
  /** An object relationship */
  company: Companies;
  companyGuid: Scalars['uuid'];
  /** An object relationship */
  contact: Contacts;
  contactGuid: Scalars['uuid'];
  createdAt?: Maybe<Scalars['timestamptz']>;
  declinedAt?: Maybe<Scalars['timestamptz']>;
  expirationDate?: Maybe<Scalars['timestamptz']>;
  expiredAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  job?: Maybe<Jobs>;
  jobGuid?: Maybe<Scalars['uuid']>;
  maxQualifiedAmountUsc?: Maybe<Scalars['Int']>;
  prequalLink: Scalars['String'];
  prequalifiedAmountUsc?: Maybe<Scalars['Int']>;
  prequalifiedAt?: Maybe<Scalars['timestamptz']>;
  status: WisetackPrequalStatusTypesEnum;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  wisetackLoanRecords: Array<WisetackLoanRecords>;
  /** An aggregate relationship */
  wisetackLoanRecordsAggregate: WisetackLoanRecordsAggregate;
  wisetackMerchantGuid: Scalars['uuid'];
  wisetackPrequalGuid: Scalars['String'];
  wisetackPrequalRecordGuid: Scalars['uuid'];
};


/** columns and relationships of "wisetack_prequal_records" */
export type WisetackPrequalRecordsWisetackLoanRecordsArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanRecordsOrderBy>>;
  where?: InputMaybe<WisetackLoanRecordsBoolExp>;
};


/** columns and relationships of "wisetack_prequal_records" */
export type WisetackPrequalRecordsWisetackLoanRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanRecordsOrderBy>>;
  where?: InputMaybe<WisetackLoanRecordsBoolExp>;
};

/** aggregated selection of "wisetack_prequal_records" */
export type WisetackPrequalRecordsAggregate = {
  __typename?: 'WisetackPrequalRecordsAggregate';
  aggregate?: Maybe<WisetackPrequalRecordsAggregateFields>;
  nodes: Array<WisetackPrequalRecords>;
};

export type WisetackPrequalRecordsAggregateBoolExp = {
  count?: InputMaybe<WisetackPrequalRecordsAggregateBoolExpCount>;
};

/** aggregate fields of "wisetack_prequal_records" */
export type WisetackPrequalRecordsAggregateFields = {
  __typename?: 'WisetackPrequalRecordsAggregateFields';
  avg?: Maybe<WisetackPrequalRecordsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<WisetackPrequalRecordsMaxFields>;
  min?: Maybe<WisetackPrequalRecordsMinFields>;
  stddev?: Maybe<WisetackPrequalRecordsStddevFields>;
  stddevPop?: Maybe<WisetackPrequalRecordsStddevPopFields>;
  stddevSamp?: Maybe<WisetackPrequalRecordsStddevSampFields>;
  sum?: Maybe<WisetackPrequalRecordsSumFields>;
  varPop?: Maybe<WisetackPrequalRecordsVarPopFields>;
  varSamp?: Maybe<WisetackPrequalRecordsVarSampFields>;
  variance?: Maybe<WisetackPrequalRecordsVarianceFields>;
};


/** aggregate fields of "wisetack_prequal_records" */
export type WisetackPrequalRecordsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WisetackPrequalRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsAggregateOrderBy = {
  avg?: InputMaybe<WisetackPrequalRecordsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<WisetackPrequalRecordsMaxOrderBy>;
  min?: InputMaybe<WisetackPrequalRecordsMinOrderBy>;
  stddev?: InputMaybe<WisetackPrequalRecordsStddevOrderBy>;
  stddevPop?: InputMaybe<WisetackPrequalRecordsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<WisetackPrequalRecordsStddevSampOrderBy>;
  sum?: InputMaybe<WisetackPrequalRecordsSumOrderBy>;
  varPop?: InputMaybe<WisetackPrequalRecordsVarPopOrderBy>;
  varSamp?: InputMaybe<WisetackPrequalRecordsVarSampOrderBy>;
  variance?: InputMaybe<WisetackPrequalRecordsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "wisetack_prequal_records" */
export type WisetackPrequalRecordsArrRelInsertInput = {
  data: Array<WisetackPrequalRecordsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<WisetackPrequalRecordsOnConflict>;
};

/** aggregate avg on columns */
export type WisetackPrequalRecordsAvgFields = {
  __typename?: 'WisetackPrequalRecordsAvgFields';
  maxQualifiedAmountUsc?: Maybe<Scalars['Float']>;
  prequalifiedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsAvgOrderBy = {
  maxQualifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalifiedAmountUsc?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "wisetack_prequal_records". All fields are combined with a logical 'AND'. */
export type WisetackPrequalRecordsBoolExp = {
  _and?: InputMaybe<Array<WisetackPrequalRecordsBoolExp>>;
  _not?: InputMaybe<WisetackPrequalRecordsBoolExp>;
  _or?: InputMaybe<Array<WisetackPrequalRecordsBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountGuid?: InputMaybe<UuidComparisonExp>;
  aprRange?: InputMaybe<StringComparisonExp>;
  company?: InputMaybe<CompaniesBoolExp>;
  companyGuid?: InputMaybe<UuidComparisonExp>;
  contact?: InputMaybe<ContactsBoolExp>;
  contactGuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  declinedAt?: InputMaybe<TimestamptzComparisonExp>;
  expirationDate?: InputMaybe<TimestamptzComparisonExp>;
  expiredAt?: InputMaybe<TimestamptzComparisonExp>;
  job?: InputMaybe<JobsBoolExp>;
  jobGuid?: InputMaybe<UuidComparisonExp>;
  maxQualifiedAmountUsc?: InputMaybe<IntComparisonExp>;
  prequalLink?: InputMaybe<StringComparisonExp>;
  prequalifiedAmountUsc?: InputMaybe<IntComparisonExp>;
  prequalifiedAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<WisetackPrequalStatusTypesEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  wisetackLoanRecords?: InputMaybe<WisetackLoanRecordsBoolExp>;
  wisetackLoanRecordsAggregate?: InputMaybe<WisetackLoanRecordsAggregateBoolExp>;
  wisetackMerchantGuid?: InputMaybe<UuidComparisonExp>;
  wisetackPrequalGuid?: InputMaybe<StringComparisonExp>;
  wisetackPrequalRecordGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "wisetack_prequal_records" */
export type WisetackPrequalRecordsConstraint =
  /** unique or primary key constraint on columns "wisetack_prequal_record_guid" */
  | 'wisetack_prequal_records_pkey'
  /** unique or primary key constraint on columns "wisetack_prequal_guid" */
  | 'wisetack_prequal_records_wisetack_prequal_guid_key';

/** input type for incrementing numeric columns in table "wisetack_prequal_records" */
export type WisetackPrequalRecordsIncInput = {
  maxQualifiedAmountUsc?: InputMaybe<Scalars['Int']>;
  prequalifiedAmountUsc?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "wisetack_prequal_records" */
export type WisetackPrequalRecordsInsertInput = {
  account?: InputMaybe<AccountsObjRelInsertInput>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
  aprRange?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<CompaniesObjRelInsertInput>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contact?: InputMaybe<ContactsObjRelInsertInput>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  declinedAt?: InputMaybe<Scalars['timestamptz']>;
  expirationDate?: InputMaybe<Scalars['timestamptz']>;
  expiredAt?: InputMaybe<Scalars['timestamptz']>;
  job?: InputMaybe<JobsObjRelInsertInput>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  maxQualifiedAmountUsc?: InputMaybe<Scalars['Int']>;
  prequalLink?: InputMaybe<Scalars['String']>;
  prequalifiedAmountUsc?: InputMaybe<Scalars['Int']>;
  prequalifiedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<WisetackPrequalStatusTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wisetackLoanRecords?: InputMaybe<WisetackLoanRecordsArrRelInsertInput>;
  wisetackMerchantGuid?: InputMaybe<Scalars['uuid']>;
  wisetackPrequalGuid?: InputMaybe<Scalars['String']>;
  wisetackPrequalRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type WisetackPrequalRecordsMaxFields = {
  __typename?: 'WisetackPrequalRecordsMaxFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  aprRange?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  declinedAt?: Maybe<Scalars['timestamptz']>;
  expirationDate?: Maybe<Scalars['timestamptz']>;
  expiredAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  maxQualifiedAmountUsc?: Maybe<Scalars['Int']>;
  prequalLink?: Maybe<Scalars['String']>;
  prequalifiedAmountUsc?: Maybe<Scalars['Int']>;
  prequalifiedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  wisetackMerchantGuid?: Maybe<Scalars['uuid']>;
  wisetackPrequalGuid?: Maybe<Scalars['String']>;
  wisetackPrequalRecordGuid?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsMaxOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  aprRange?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  declinedAt?: InputMaybe<OrderBy>;
  expirationDate?: InputMaybe<OrderBy>;
  expiredAt?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  maxQualifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalLink?: InputMaybe<OrderBy>;
  prequalifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalifiedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  wisetackMerchantGuid?: InputMaybe<OrderBy>;
  wisetackPrequalGuid?: InputMaybe<OrderBy>;
  wisetackPrequalRecordGuid?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type WisetackPrequalRecordsMinFields = {
  __typename?: 'WisetackPrequalRecordsMinFields';
  accountGuid?: Maybe<Scalars['uuid']>;
  aprRange?: Maybe<Scalars['String']>;
  companyGuid?: Maybe<Scalars['uuid']>;
  contactGuid?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  declinedAt?: Maybe<Scalars['timestamptz']>;
  expirationDate?: Maybe<Scalars['timestamptz']>;
  expiredAt?: Maybe<Scalars['timestamptz']>;
  jobGuid?: Maybe<Scalars['uuid']>;
  maxQualifiedAmountUsc?: Maybe<Scalars['Int']>;
  prequalLink?: Maybe<Scalars['String']>;
  prequalifiedAmountUsc?: Maybe<Scalars['Int']>;
  prequalifiedAt?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  wisetackMerchantGuid?: Maybe<Scalars['uuid']>;
  wisetackPrequalGuid?: Maybe<Scalars['String']>;
  wisetackPrequalRecordGuid?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsMinOrderBy = {
  accountGuid?: InputMaybe<OrderBy>;
  aprRange?: InputMaybe<OrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  declinedAt?: InputMaybe<OrderBy>;
  expirationDate?: InputMaybe<OrderBy>;
  expiredAt?: InputMaybe<OrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  maxQualifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalLink?: InputMaybe<OrderBy>;
  prequalifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalifiedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  wisetackMerchantGuid?: InputMaybe<OrderBy>;
  wisetackPrequalGuid?: InputMaybe<OrderBy>;
  wisetackPrequalRecordGuid?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "wisetack_prequal_records" */
export type WisetackPrequalRecordsMutationResponse = {
  __typename?: 'WisetackPrequalRecordsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WisetackPrequalRecords>;
};

/** input type for inserting object relation for remote table "wisetack_prequal_records" */
export type WisetackPrequalRecordsObjRelInsertInput = {
  data: WisetackPrequalRecordsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<WisetackPrequalRecordsOnConflict>;
};

/** on_conflict condition type for table "wisetack_prequal_records" */
export type WisetackPrequalRecordsOnConflict = {
  constraint: WisetackPrequalRecordsConstraint;
  updateColumns?: Array<WisetackPrequalRecordsUpdateColumn>;
  where?: InputMaybe<WisetackPrequalRecordsBoolExp>;
};

/** Ordering options when selecting data from "wisetack_prequal_records". */
export type WisetackPrequalRecordsOrderBy = {
  account?: InputMaybe<AccountsOrderBy>;
  accountGuid?: InputMaybe<OrderBy>;
  aprRange?: InputMaybe<OrderBy>;
  company?: InputMaybe<CompaniesOrderBy>;
  companyGuid?: InputMaybe<OrderBy>;
  contact?: InputMaybe<ContactsOrderBy>;
  contactGuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  declinedAt?: InputMaybe<OrderBy>;
  expirationDate?: InputMaybe<OrderBy>;
  expiredAt?: InputMaybe<OrderBy>;
  job?: InputMaybe<JobsOrderBy>;
  jobGuid?: InputMaybe<OrderBy>;
  maxQualifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalLink?: InputMaybe<OrderBy>;
  prequalifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalifiedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  wisetackLoanRecordsAggregate?: InputMaybe<WisetackLoanRecordsAggregateOrderBy>;
  wisetackMerchantGuid?: InputMaybe<OrderBy>;
  wisetackPrequalGuid?: InputMaybe<OrderBy>;
  wisetackPrequalRecordGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: wisetack_prequal_records */
export type WisetackPrequalRecordsPkColumnsInput = {
  wisetackPrequalRecordGuid: Scalars['uuid'];
};

/** select columns of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsSelectColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'aprRange'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'declinedAt'
  /** column name */
  | 'expirationDate'
  /** column name */
  | 'expiredAt'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'maxQualifiedAmountUsc'
  /** column name */
  | 'prequalLink'
  /** column name */
  | 'prequalifiedAmountUsc'
  /** column name */
  | 'prequalifiedAt'
  /** column name */
  | 'status'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'wisetackMerchantGuid'
  /** column name */
  | 'wisetackPrequalGuid'
  /** column name */
  | 'wisetackPrequalRecordGuid';

/** input type for updating data in table "wisetack_prequal_records" */
export type WisetackPrequalRecordsSetInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  aprRange?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  declinedAt?: InputMaybe<Scalars['timestamptz']>;
  expirationDate?: InputMaybe<Scalars['timestamptz']>;
  expiredAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  maxQualifiedAmountUsc?: InputMaybe<Scalars['Int']>;
  prequalLink?: InputMaybe<Scalars['String']>;
  prequalifiedAmountUsc?: InputMaybe<Scalars['Int']>;
  prequalifiedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<WisetackPrequalStatusTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wisetackMerchantGuid?: InputMaybe<Scalars['uuid']>;
  wisetackPrequalGuid?: InputMaybe<Scalars['String']>;
  wisetackPrequalRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type WisetackPrequalRecordsStddevFields = {
  __typename?: 'WisetackPrequalRecordsStddevFields';
  maxQualifiedAmountUsc?: Maybe<Scalars['Float']>;
  prequalifiedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsStddevOrderBy = {
  maxQualifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalifiedAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type WisetackPrequalRecordsStddevPopFields = {
  __typename?: 'WisetackPrequalRecordsStddevPopFields';
  maxQualifiedAmountUsc?: Maybe<Scalars['Float']>;
  prequalifiedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevPop() on columns of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsStddevPopOrderBy = {
  maxQualifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalifiedAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type WisetackPrequalRecordsStddevSampFields = {
  __typename?: 'WisetackPrequalRecordsStddevSampFields';
  maxQualifiedAmountUsc?: Maybe<Scalars['Float']>;
  prequalifiedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by stddevSamp() on columns of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsStddevSampOrderBy = {
  maxQualifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalifiedAmountUsc?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "wisetack_prequal_records" */
export type WisetackPrequalRecordsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: WisetackPrequalRecordsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WisetackPrequalRecordsStreamCursorValueInput = {
  accountGuid?: InputMaybe<Scalars['uuid']>;
  aprRange?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
  contactGuid?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  declinedAt?: InputMaybe<Scalars['timestamptz']>;
  expirationDate?: InputMaybe<Scalars['timestamptz']>;
  expiredAt?: InputMaybe<Scalars['timestamptz']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
  maxQualifiedAmountUsc?: InputMaybe<Scalars['Int']>;
  prequalLink?: InputMaybe<Scalars['String']>;
  prequalifiedAmountUsc?: InputMaybe<Scalars['Int']>;
  prequalifiedAt?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<WisetackPrequalStatusTypesEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  wisetackMerchantGuid?: InputMaybe<Scalars['uuid']>;
  wisetackPrequalGuid?: InputMaybe<Scalars['String']>;
  wisetackPrequalRecordGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type WisetackPrequalRecordsSumFields = {
  __typename?: 'WisetackPrequalRecordsSumFields';
  maxQualifiedAmountUsc?: Maybe<Scalars['Int']>;
  prequalifiedAmountUsc?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsSumOrderBy = {
  maxQualifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalifiedAmountUsc?: InputMaybe<OrderBy>;
};

/** update columns of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsUpdateColumn =
  /** column name */
  | 'accountGuid'
  /** column name */
  | 'aprRange'
  /** column name */
  | 'companyGuid'
  /** column name */
  | 'contactGuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'declinedAt'
  /** column name */
  | 'expirationDate'
  /** column name */
  | 'expiredAt'
  /** column name */
  | 'jobGuid'
  /** column name */
  | 'maxQualifiedAmountUsc'
  /** column name */
  | 'prequalLink'
  /** column name */
  | 'prequalifiedAmountUsc'
  /** column name */
  | 'prequalifiedAt'
  /** column name */
  | 'status'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'wisetackMerchantGuid'
  /** column name */
  | 'wisetackPrequalGuid'
  /** column name */
  | 'wisetackPrequalRecordGuid';

export type WisetackPrequalRecordsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WisetackPrequalRecordsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WisetackPrequalRecordsSetInput>;
  /** filter the rows which have to be updated */
  where: WisetackPrequalRecordsBoolExp;
};

/** aggregate varPop on columns */
export type WisetackPrequalRecordsVarPopFields = {
  __typename?: 'WisetackPrequalRecordsVarPopFields';
  maxQualifiedAmountUsc?: Maybe<Scalars['Float']>;
  prequalifiedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by varPop() on columns of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsVarPopOrderBy = {
  maxQualifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalifiedAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type WisetackPrequalRecordsVarSampFields = {
  __typename?: 'WisetackPrequalRecordsVarSampFields';
  maxQualifiedAmountUsc?: Maybe<Scalars['Float']>;
  prequalifiedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by varSamp() on columns of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsVarSampOrderBy = {
  maxQualifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalifiedAmountUsc?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type WisetackPrequalRecordsVarianceFields = {
  __typename?: 'WisetackPrequalRecordsVarianceFields';
  maxQualifiedAmountUsc?: Maybe<Scalars['Float']>;
  prequalifiedAmountUsc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "wisetack_prequal_records" */
export type WisetackPrequalRecordsVarianceOrderBy = {
  maxQualifiedAmountUsc?: InputMaybe<OrderBy>;
  prequalifiedAmountUsc?: InputMaybe<OrderBy>;
};

export type WisetackPrequalStatusTypesEnum =
  | 'CANCELED'
  | 'DECLINED'
  | 'EXPIRED'
  | 'INITIATED'
  | 'PENDING'
  | 'PREQUALIFIED';

/** Boolean expression to compare columns of type "WisetackPrequalStatusTypesEnum". All fields are combined with logical 'AND'. */
export type WisetackPrequalStatusTypesEnumComparisonExp = {
  _eq?: InputMaybe<WisetackPrequalStatusTypesEnum>;
  _in?: InputMaybe<Array<WisetackPrequalStatusTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<WisetackPrequalStatusTypesEnum>;
  _nin?: InputMaybe<Array<WisetackPrequalStatusTypesEnum>>;
};

/** columns and relationships of "wisetack_webhook_events" */
export type WisetackWebhookEvents = {
  __typename?: 'WisetackWebhookEvents';
  createdAt: Scalars['timestamptz'];
  eventDataJson: Scalars['jsonb'];
  eventType: Scalars['String'];
  wisetackMessageGuid: Scalars['uuid'];
  wisetackPrequalGuid?: Maybe<Scalars['String']>;
  wisetackTransactionGuid?: Maybe<Scalars['uuid']>;
  wisetackWebhookEventGuid: Scalars['uuid'];
};


/** columns and relationships of "wisetack_webhook_events" */
export type WisetackWebhookEventsEventDataJsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "wisetack_webhook_events" */
export type WisetackWebhookEventsAggregate = {
  __typename?: 'WisetackWebhookEventsAggregate';
  aggregate?: Maybe<WisetackWebhookEventsAggregateFields>;
  nodes: Array<WisetackWebhookEvents>;
};

/** aggregate fields of "wisetack_webhook_events" */
export type WisetackWebhookEventsAggregateFields = {
  __typename?: 'WisetackWebhookEventsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<WisetackWebhookEventsMaxFields>;
  min?: Maybe<WisetackWebhookEventsMinFields>;
};


/** aggregate fields of "wisetack_webhook_events" */
export type WisetackWebhookEventsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<WisetackWebhookEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type WisetackWebhookEventsAppendInput = {
  eventDataJson?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "wisetack_webhook_events". All fields are combined with a logical 'AND'. */
export type WisetackWebhookEventsBoolExp = {
  _and?: InputMaybe<Array<WisetackWebhookEventsBoolExp>>;
  _not?: InputMaybe<WisetackWebhookEventsBoolExp>;
  _or?: InputMaybe<Array<WisetackWebhookEventsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  eventDataJson?: InputMaybe<JsonbComparisonExp>;
  eventType?: InputMaybe<StringComparisonExp>;
  wisetackMessageGuid?: InputMaybe<UuidComparisonExp>;
  wisetackPrequalGuid?: InputMaybe<StringComparisonExp>;
  wisetackTransactionGuid?: InputMaybe<UuidComparisonExp>;
  wisetackWebhookEventGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "wisetack_webhook_events" */
export type WisetackWebhookEventsConstraint =
  /** unique or primary key constraint on columns "wisetack_webhook_event_guid" */
  | 'wisetack_webhook_events_pkey'
  /** unique or primary key constraint on columns "wisetack_message_guid" */
  | 'wisetack_webhook_events_wisetack_message_guid_key';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type WisetackWebhookEventsDeleteAtPathInput = {
  eventDataJson?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type WisetackWebhookEventsDeleteElemInput = {
  eventDataJson?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type WisetackWebhookEventsDeleteKeyInput = {
  eventDataJson?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "wisetack_webhook_events" */
export type WisetackWebhookEventsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventDataJson?: InputMaybe<Scalars['jsonb']>;
  eventType?: InputMaybe<Scalars['String']>;
  wisetackMessageGuid?: InputMaybe<Scalars['uuid']>;
  wisetackPrequalGuid?: InputMaybe<Scalars['String']>;
  wisetackTransactionGuid?: InputMaybe<Scalars['uuid']>;
  wisetackWebhookEventGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type WisetackWebhookEventsMaxFields = {
  __typename?: 'WisetackWebhookEventsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  eventType?: Maybe<Scalars['String']>;
  wisetackMessageGuid?: Maybe<Scalars['uuid']>;
  wisetackPrequalGuid?: Maybe<Scalars['String']>;
  wisetackTransactionGuid?: Maybe<Scalars['uuid']>;
  wisetackWebhookEventGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type WisetackWebhookEventsMinFields = {
  __typename?: 'WisetackWebhookEventsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  eventType?: Maybe<Scalars['String']>;
  wisetackMessageGuid?: Maybe<Scalars['uuid']>;
  wisetackPrequalGuid?: Maybe<Scalars['String']>;
  wisetackTransactionGuid?: Maybe<Scalars['uuid']>;
  wisetackWebhookEventGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "wisetack_webhook_events" */
export type WisetackWebhookEventsMutationResponse = {
  __typename?: 'WisetackWebhookEventsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<WisetackWebhookEvents>;
};

/** on_conflict condition type for table "wisetack_webhook_events" */
export type WisetackWebhookEventsOnConflict = {
  constraint: WisetackWebhookEventsConstraint;
  updateColumns?: Array<WisetackWebhookEventsUpdateColumn>;
  where?: InputMaybe<WisetackWebhookEventsBoolExp>;
};

/** Ordering options when selecting data from "wisetack_webhook_events". */
export type WisetackWebhookEventsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  eventDataJson?: InputMaybe<OrderBy>;
  eventType?: InputMaybe<OrderBy>;
  wisetackMessageGuid?: InputMaybe<OrderBy>;
  wisetackPrequalGuid?: InputMaybe<OrderBy>;
  wisetackTransactionGuid?: InputMaybe<OrderBy>;
  wisetackWebhookEventGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: wisetack_webhook_events */
export type WisetackWebhookEventsPkColumnsInput = {
  wisetackWebhookEventGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type WisetackWebhookEventsPrependInput = {
  eventDataJson?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "wisetack_webhook_events" */
export type WisetackWebhookEventsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'eventDataJson'
  /** column name */
  | 'eventType'
  /** column name */
  | 'wisetackMessageGuid'
  /** column name */
  | 'wisetackPrequalGuid'
  /** column name */
  | 'wisetackTransactionGuid'
  /** column name */
  | 'wisetackWebhookEventGuid';

/** input type for updating data in table "wisetack_webhook_events" */
export type WisetackWebhookEventsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventDataJson?: InputMaybe<Scalars['jsonb']>;
  eventType?: InputMaybe<Scalars['String']>;
  wisetackMessageGuid?: InputMaybe<Scalars['uuid']>;
  wisetackPrequalGuid?: InputMaybe<Scalars['String']>;
  wisetackTransactionGuid?: InputMaybe<Scalars['uuid']>;
  wisetackWebhookEventGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "wisetack_webhook_events" */
export type WisetackWebhookEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: WisetackWebhookEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type WisetackWebhookEventsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  eventDataJson?: InputMaybe<Scalars['jsonb']>;
  eventType?: InputMaybe<Scalars['String']>;
  wisetackMessageGuid?: InputMaybe<Scalars['uuid']>;
  wisetackPrequalGuid?: InputMaybe<Scalars['String']>;
  wisetackTransactionGuid?: InputMaybe<Scalars['uuid']>;
  wisetackWebhookEventGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "wisetack_webhook_events" */
export type WisetackWebhookEventsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'eventDataJson'
  /** column name */
  | 'eventType'
  /** column name */
  | 'wisetackMessageGuid'
  /** column name */
  | 'wisetackPrequalGuid'
  /** column name */
  | 'wisetackTransactionGuid'
  /** column name */
  | 'wisetackWebhookEventGuid';

export type WisetackWebhookEventsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<WisetackWebhookEventsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<WisetackWebhookEventsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<WisetackWebhookEventsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<WisetackWebhookEventsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<WisetackWebhookEventsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WisetackWebhookEventsSetInput>;
  /** filter the rows which have to be updated */
  where: WisetackWebhookEventsBoolExp;
};

export type AccCartItemTypeAccountsConfigAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AccCartItemTypeAccountsConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccCartItemTypeAccountsConfigBoolExp>;
  predicate: IntComparisonExp;
};

export type AccCompanyConfigAggregateBoolExpBool_And = {
  arguments: AccCompanyConfigSelectColumnAccCompanyConfigAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccCompanyConfigBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AccCompanyConfigAggregateBoolExpBool_Or = {
  arguments: AccCompanyConfigSelectColumnAccCompanyConfigAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccCompanyConfigBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AccCompanyConfigAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AccCompanyConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccCompanyConfigBoolExp>;
  predicate: IntComparisonExp;
};

export type AccPayoutAccountsConfigAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AccPayoutAccountsConfigSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccPayoutAccountsConfigBoolExp>;
  predicate: IntComparisonExp;
};

export type AccSyncInfoAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AccSyncInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccSyncInfoBoolExp>;
  predicate: IntComparisonExp;
};

export type AccountContactsAggregateBoolExpBool_And = {
  arguments: AccountContactsSelectColumnAccountContactsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountContactsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AccountContactsAggregateBoolExpBool_Or = {
  arguments: AccountContactsSelectColumnAccountContactsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountContactsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AccountContactsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AccountContactsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountContactsBoolExp>;
  predicate: IntComparisonExp;
};

export type AccountLocationsAggregateBoolExpBool_And = {
  arguments: AccountLocationsSelectColumnAccountLocationsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountLocationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AccountLocationsAggregateBoolExpBool_Or = {
  arguments: AccountLocationsSelectColumnAccountLocationsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountLocationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AccountLocationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AccountLocationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountLocationsBoolExp>;
  predicate: IntComparisonExp;
};

export type AccountRemindersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AccountRemindersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountRemindersBoolExp>;
  predicate: IntComparisonExp;
};

export type AccountTagsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AccountTagsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountTagsBoolExp>;
  predicate: IntComparisonExp;
};

export type AccountsAggregateBoolExpBool_And = {
  arguments: AccountsSelectColumnAccountsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AccountsAggregateBoolExpBool_Or = {
  arguments: AccountsSelectColumnAccountsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AccountsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AccountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountsBoolExp>;
  predicate: IntComparisonExp;
};

export type AccountsSortedByJobCountArgs = {
  p_company_guid?: InputMaybe<Scalars['uuid']>;
  p_limit?: InputMaybe<Scalars['Int']>;
  p_offset?: InputMaybe<Scalars['Int']>;
  p_show_archived?: InputMaybe<Scalars['Boolean']>;
};

export type AccountsSortedByRecentlyViewedForUserArgs = {
  _company_guid?: InputMaybe<Scalars['uuid']>;
  _user_guid?: InputMaybe<Scalars['uuid']>;
};

export type AccountsViewedByUserAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AccountsViewedByUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AccountsViewedByUserBoolExp>;
  predicate: IntComparisonExp;
};

export type ActivityItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ActivityItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ActivityItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type AppointmentChecklistAssociationRulesAggregateBoolExpBool_And = {
  arguments: AppointmentChecklistAssociationRulesSelectColumnAppointmentChecklistAssociationRulesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AppointmentChecklistAssociationRulesAggregateBoolExpBool_Or = {
  arguments: AppointmentChecklistAssociationRulesSelectColumnAppointmentChecklistAssociationRulesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AppointmentChecklistAssociationRulesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AppointmentChecklistAssociationRulesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
  predicate: IntComparisonExp;
};

export type AppointmentChecklistInstancesAggregateBoolExpBool_And = {
  arguments: AppointmentChecklistInstancesSelectColumnAppointmentChecklistInstancesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AppointmentChecklistInstancesAggregateBoolExpBool_Or = {
  arguments: AppointmentChecklistInstancesSelectColumnAppointmentChecklistInstancesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AppointmentChecklistInstancesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AppointmentChecklistInstancesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
  predicate: IntComparisonExp;
};

export type AssistantIntegratedPhonesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AssistantIntegratedPhonesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AssistantIntegratedPhonesBoolExp>;
  predicate: IntComparisonExp;
};

export type CompanyAppointmentArrivalWindowsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CompanyAppointmentArrivalWindowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyAppointmentArrivalWindowsBoolExp>;
  predicate: IntComparisonExp;
};

export type CompanyLeadSourceLinksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CompanyLeadSourceLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
  predicate: IntComparisonExp;
};

export type CompanyLeadSourcesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CompanyLeadSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyLeadSourcesBoolExp>;
  predicate: IntComparisonExp;
};

export type CompanyNotificationSettingsAggregateBoolExpBool_And = {
  arguments: CompanyNotificationSettingsSelectColumnCompanyNotificationSettingsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyNotificationSettingsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CompanyNotificationSettingsAggregateBoolExpBool_Or = {
  arguments: CompanyNotificationSettingsSelectColumnCompanyNotificationSettingsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyNotificationSettingsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CompanyNotificationSettingsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CompanyNotificationSettingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyNotificationSettingsBoolExp>;
  predicate: IntComparisonExp;
};

export type CompanyReviewLinksAggregateBoolExpBool_And = {
  arguments: CompanyReviewLinksSelectColumnCompanyReviewLinksAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyReviewLinksBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CompanyReviewLinksAggregateBoolExpBool_Or = {
  arguments: CompanyReviewLinksSelectColumnCompanyReviewLinksAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyReviewLinksBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CompanyReviewLinksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CompanyReviewLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyReviewLinksBoolExp>;
  predicate: IntComparisonExp;
};

export type CompanyUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CompanyUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyUsersBoolExp>;
  predicate: IntComparisonExp;
};

export type ContactsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ContactsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ContactsBoolExp>;
  predicate: IntComparisonExp;
};

export type DistBetweenMeters_Addresses_Args = {
  address_to_compare?: InputMaybe<Scalars['geography']>;
};

export type EquipmentTypeLinksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EquipmentTypeLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EquipmentTypeLinksBoolExp>;
  predicate: IntComparisonExp;
};

export type EstimateOptionCartItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EstimateOptionCartItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EstimateOptionCartItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type EstimateOptionDiscountsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EstimateOptionDiscountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EstimateOptionDiscountsBoolExp>;
  predicate: IntComparisonExp;
};

export type EstimateOptionsAggregateBoolExpBool_And = {
  arguments: EstimateOptionsSelectColumnEstimateOptionsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EstimateOptionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EstimateOptionsAggregateBoolExpBool_Or = {
  arguments: EstimateOptionsSelectColumnEstimateOptionsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EstimateOptionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EstimateOptionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EstimateOptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EstimateOptionsBoolExp>;
  predicate: IntComparisonExp;
};

export type EstimatePhotosAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EstimatePhotosSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EstimatePhotosBoolExp>;
  predicate: IntComparisonExp;
};

export type EstimatesAggregateBoolExpBool_And = {
  arguments: EstimatesSelectColumnEstimatesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EstimatesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EstimatesAggregateBoolExpBool_Or = {
  arguments: EstimatesSelectColumnEstimatesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EstimatesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EstimatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EstimatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EstimatesBoolExp>;
  predicate: IntComparisonExp;
};

export type EventStoreAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EventStoreSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<EventStoreBoolExp>;
  predicate: IntComparisonExp;
};

export type FileLinksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<FileLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FileLinksBoolExp>;
  predicate: IntComparisonExp;
};

export type InstalledEquipmentAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InstalledEquipmentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InstalledEquipmentBoolExp>;
  predicate: IntComparisonExp;
};

export type InstalledHvacSystemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InstalledHvacSystemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InstalledHvacSystemsBoolExp>;
  predicate: IntComparisonExp;
};

export type InstantBookingWeeklyScheduleEntriesAggregateBoolExpBool_And = {
  arguments: InstantBookingWeeklyScheduleEntriesSelectColumnInstantBookingWeeklyScheduleEntriesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type InstantBookingWeeklyScheduleEntriesAggregateBoolExpBool_Or = {
  arguments: InstantBookingWeeklyScheduleEntriesSelectColumnInstantBookingWeeklyScheduleEntriesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type InstantBookingWeeklyScheduleEntriesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
  predicate: IntComparisonExp;
};

export type InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedChannelCompletableItemsAggregateBoolExpBool_And = {
  arguments: IntegratedChannelCompletableItemsSelectColumnIntegratedChannelCompletableItemsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedChannelCompletableItemsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IntegratedChannelCompletableItemsAggregateBoolExpBool_Or = {
  arguments: IntegratedChannelCompletableItemsSelectColumnIntegratedChannelCompletableItemsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedChannelCompletableItemsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IntegratedChannelCompletableItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedChannelCompletableItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedChannelCompletableItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedChannelItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedChannelItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedChannelItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedChannelReadableItemsAggregateBoolExpBool_And = {
  arguments: IntegratedChannelReadableItemsSelectColumnIntegratedChannelReadableItemsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedChannelReadableItemsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IntegratedChannelReadableItemsAggregateBoolExpBool_Or = {
  arguments: IntegratedChannelReadableItemsSelectColumnIntegratedChannelReadableItemsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedChannelReadableItemsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IntegratedChannelReadableItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedChannelReadableItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedChannelReadableItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedPhoneCallDismissalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedPhoneCallDismissalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhoneCallDismissalsBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedPhoneCallJobsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedPhoneCallJobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedPhoneCallStatusesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedPhoneCallStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhoneCallStatusesBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedPhoneCallsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedPhoneCallsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhoneCallsBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedPhoneMissedCallDismissalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhoneMissedCallDismissalsBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedPhoneMissedCallsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedPhoneMissedCallsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedPhoneUsersAggregateBoolExpBool_And = {
  arguments: IntegratedPhoneUsersSelectColumnIntegratedPhoneUsersAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhoneUsersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IntegratedPhoneUsersAggregateBoolExpBool_Or = {
  arguments: IntegratedPhoneUsersSelectColumnIntegratedPhoneUsersAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhoneUsersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IntegratedPhoneUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedPhoneUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhoneUsersBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedPhoneVoicemailDismissalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhoneVoicemailDismissalsBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedPhoneVoicemailsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedPhoneVoicemailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhoneVoicemailsBoolExp>;
  predicate: IntComparisonExp;
};

export type IntegratedPhonesAggregateBoolExpBool_And = {
  arguments: IntegratedPhonesSelectColumnIntegratedPhonesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhonesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IntegratedPhonesAggregateBoolExpBool_Or = {
  arguments: IntegratedPhonesSelectColumnIntegratedPhonesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhonesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type IntegratedPhonesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<IntegratedPhonesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IntegratedPhonesBoolExp>;
  predicate: IntComparisonExp;
};

/** columns and relationships of "internal_notifications" */
export type InternalNotifications = {
  __typename?: 'internalNotifications';
  acknowledgedAt?: Maybe<Scalars['timestamptz']>;
  content: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  internalNotificationGuid: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  status: Scalars['String'];
  userGuid: Scalars['uuid'];
};


/** columns and relationships of "internal_notifications" */
export type InternalNotificationsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "internal_notifications" */
export type InternalNotificationsAggregate = {
  __typename?: 'internalNotificationsAggregate';
  aggregate?: Maybe<InternalNotificationsAggregateFields>;
  nodes: Array<InternalNotifications>;
};

/** aggregate fields of "internal_notifications" */
export type InternalNotificationsAggregateFields = {
  __typename?: 'internalNotificationsAggregateFields';
  count: Scalars['Int'];
  max?: Maybe<InternalNotificationsMaxFields>;
  min?: Maybe<InternalNotificationsMinFields>;
};


/** aggregate fields of "internal_notifications" */
export type InternalNotificationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<InternalNotificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type InternalNotificationsAppendInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "internal_notifications". All fields are combined with a logical 'AND'. */
export type InternalNotificationsBoolExp = {
  _and?: InputMaybe<Array<InternalNotificationsBoolExp>>;
  _not?: InputMaybe<InternalNotificationsBoolExp>;
  _or?: InputMaybe<Array<InternalNotificationsBoolExp>>;
  acknowledgedAt?: InputMaybe<TimestamptzComparisonExp>;
  content?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  internalNotificationGuid?: InputMaybe<UuidComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  userGuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "internal_notifications" */
export type InternalNotificationsConstraint =
  /** unique or primary key constraint on columns "internal_notification_guid" */
  | 'internal_notifications_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type InternalNotificationsDeleteAtPathInput = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type InternalNotificationsDeleteElemInput = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type InternalNotificationsDeleteKeyInput = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "internal_notifications" */
export type InternalNotificationsInsertInput = {
  acknowledgedAt?: InputMaybe<Scalars['timestamptz']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  internalNotificationGuid?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type InternalNotificationsMaxFields = {
  __typename?: 'internalNotificationsMaxFields';
  acknowledgedAt?: Maybe<Scalars['timestamptz']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  internalNotificationGuid?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type InternalNotificationsMinFields = {
  __typename?: 'internalNotificationsMinFields';
  acknowledgedAt?: Maybe<Scalars['timestamptz']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  internalNotificationGuid?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  userGuid?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "internal_notifications" */
export type InternalNotificationsMutationResponse = {
  __typename?: 'internalNotificationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InternalNotifications>;
};

/** input type for inserting object relation for remote table "internal_notifications" */
export type InternalNotificationsObjRelInsertInput = {
  data: InternalNotificationsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<InternalNotificationsOnConflict>;
};

/** on_conflict condition type for table "internal_notifications" */
export type InternalNotificationsOnConflict = {
  constraint: InternalNotificationsConstraint;
  updateColumns?: Array<InternalNotificationsUpdateColumn>;
  where?: InputMaybe<InternalNotificationsBoolExp>;
};

/** Ordering options when selecting data from "internal_notifications". */
export type InternalNotificationsOrderBy = {
  acknowledgedAt?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  internalNotificationGuid?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  userGuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: internal_notifications */
export type InternalNotificationsPkColumnsInput = {
  internalNotificationGuid: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type InternalNotificationsPrependInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "internal_notifications" */
export type InternalNotificationsSelectColumn =
  /** column name */
  | 'acknowledgedAt'
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'internalNotificationGuid'
  /** column name */
  | 'metadata'
  /** column name */
  | 'status'
  /** column name */
  | 'userGuid';

/** input type for updating data in table "internal_notifications" */
export type InternalNotificationsSetInput = {
  acknowledgedAt?: InputMaybe<Scalars['timestamptz']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  internalNotificationGuid?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "internalNotifications" */
export type InternalNotificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: InternalNotificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type InternalNotificationsStreamCursorValueInput = {
  acknowledgedAt?: InputMaybe<Scalars['timestamptz']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  internalNotificationGuid?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  userGuid?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "internal_notifications" */
export type InternalNotificationsUpdateColumn =
  /** column name */
  | 'acknowledgedAt'
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'internalNotificationGuid'
  /** column name */
  | 'metadata'
  /** column name */
  | 'status'
  /** column name */
  | 'userGuid';

export type InternalNotificationsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<InternalNotificationsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<InternalNotificationsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<InternalNotificationsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<InternalNotificationsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<InternalNotificationsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InternalNotificationsSetInput>;
  /** filter the rows which have to be updated */
  where: InternalNotificationsBoolExp;
};

export type InvoiceCartItemBundleItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InvoiceCartItemBundleItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoiceCartItemBundleItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type InvoiceCartItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InvoiceCartItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoiceCartItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type InvoiceDiscountsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InvoiceDiscountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoiceDiscountsBoolExp>;
  predicate: IntComparisonExp;
};

export type InvoiceEventsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InvoiceEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoiceEventsBoolExp>;
  predicate: IntComparisonExp;
};

export type InvoicePaymentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoicePaymentsBoolExp>;
  predicate: IntComparisonExp;
};

export type InvoiceTemplateCartItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InvoiceTemplateCartItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type InvoicesAggregateBoolExpBool_And = {
  arguments: InvoicesSelectColumnInvoicesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoicesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type InvoicesAggregateBoolExpBool_Or = {
  arguments: InvoicesSelectColumnInvoicesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoicesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type InvoicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoicesBoolExp>;
  predicate: IntComparisonExp;
};

export type InvoicesQueryableAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InvoicesQueryableSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<InvoicesQueryableBoolExp>;
  predicate: IntComparisonExp;
};

export type JobAppointmentAssignmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobAppointmentAssignmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
  predicate: IntComparisonExp;
};

export type JobAppointmentInvoicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobAppointmentInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobAppointmentInvoicesBoolExp>;
  predicate: IntComparisonExp;
};

export type JobAppointmentsAggregateBoolExpBool_And = {
  arguments: JobAppointmentsSelectColumnJobAppointmentsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobAppointmentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JobAppointmentsAggregateBoolExpBool_Or = {
  arguments: JobAppointmentsSelectColumnJobAppointmentsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobAppointmentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JobAppointmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobAppointmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobAppointmentsBoolExp>;
  predicate: IntComparisonExp;
};

export type JobCostItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobCostItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobCostItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type JobInvoicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobInvoicesBoolExp>;
  predicate: IntComparisonExp;
};

export type JobLifecycleStatusesAggregateBoolExpBool_And = {
  arguments: JobLifecycleStatusesSelectColumnJobLifecycleStatusesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobLifecycleStatusesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JobLifecycleStatusesAggregateBoolExpBool_Or = {
  arguments: JobLifecycleStatusesSelectColumnJobLifecycleStatusesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobLifecycleStatusesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JobLifecycleStatusesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobLifecycleStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobLifecycleStatusesBoolExp>;
  predicate: IntComparisonExp;
};

export type JobTagsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobTagsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobTagsBoolExp>;
  predicate: IntComparisonExp;
};

export type JobTeamMembersAggregateBoolExpBool_And = {
  arguments: JobTeamMembersSelectColumnJobTeamMembersAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobTeamMembersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JobTeamMembersAggregateBoolExpBool_Or = {
  arguments: JobTeamMembersSelectColumnJobTeamMembersAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobTeamMembersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JobTeamMembersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobTeamMembersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobTeamMembersBoolExp>;
  predicate: IntComparisonExp;
};

export type JobTechnicianEarnedRevenueAttributionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobTechnicianEarnedRevenueAttributionsBoolExp>;
  predicate: IntComparisonExp;
};

export type JobTechnicianEarnedRevenueSummariesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobTechnicianEarnedRevenueSummariesBoolExp>;
  predicate: IntComparisonExp;
};

export type JobTechnicianSalesCommissionAndBonusAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobTechnicianSalesCommissionAndBonusBoolExp>;
  predicate: IntComparisonExp;
};

export type JobTechnicianSoldRevenueAttributionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobTechnicianSoldRevenueAttributionsBoolExp>;
  predicate: IntComparisonExp;
};

export type JobTechnicianSoldRevenueSummariesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobTechnicianSoldRevenueSummariesBoolExp>;
  predicate: IntComparisonExp;
};

export type JobTypesAggregateBoolExpBool_And = {
  arguments: JobTypesSelectColumnJobTypesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobTypesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JobTypesAggregateBoolExpBool_Or = {
  arguments: JobTypesSelectColumnJobTypesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobTypesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JobTypesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobTypesBoolExp>;
  predicate: IntComparisonExp;
};

export type JobsAggregateBoolExpBool_And = {
  arguments: JobsSelectColumnJobsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JobsAggregateBoolExpBool_Or = {
  arguments: JobsSelectColumnJobsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JobsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobsBoolExp>;
  predicate: IntComparisonExp;
};

export type JobsWithLinkedJobAggregateBoolExpBool_And = {
  arguments: JobsWithLinkedJobSelectColumnJobsWithLinkedJobAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobsWithLinkedJobBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JobsWithLinkedJobAggregateBoolExpBool_Or = {
  arguments: JobsWithLinkedJobSelectColumnJobsWithLinkedJobAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobsWithLinkedJobBoolExp>;
  predicate: BooleanComparisonExp;
};

export type JobsWithLinkedJobAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobsWithLinkedJobSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobsWithLinkedJobBoolExp>;
  predicate: IntComparisonExp;
};

export type JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>;
  predicate: IntComparisonExp;
};

export type JobsWithLinkedJobLinkedEstimatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
  predicate: IntComparisonExp;
};

export type JobsWithLinkedJobLinkedInvoicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<JobsWithLinkedJobLinkedInvoicesBoolExp>;
  predicate: IntComparisonExp;
};

export type LocationContactsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LocationContactsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LocationContactsBoolExp>;
  predicate: IntComparisonExp;
};

export type LocationInvoicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LocationInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LocationInvoicesBoolExp>;
  predicate: IntComparisonExp;
};

export type LocationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<LocationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<LocationsBoolExp>;
  predicate: IntComparisonExp;
};

export type MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExpBool_And = {
  arguments: MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumnMaintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExpBool_Or = {
  arguments: MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumnMaintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type MaintenancePlanDefinitionAllowedPaymentIntervalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
  predicate: IntComparisonExp;
};

export type MaintenancePlanDefinitionBenefitsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanDefinitionBenefitsBoolExp>;
  predicate: IntComparisonExp;
};

export type MaintenancePlanDefinitionDiscountsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanDefinitionDiscountsBoolExp>;
  predicate: IntComparisonExp;
};

export type MaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExpBool_And = {
  arguments: MaintenancePlanEquipmentCoverageDefinitionsSelectColumnMaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type MaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExpBool_Or = {
  arguments: MaintenancePlanEquipmentCoverageDefinitionsSelectColumnMaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type MaintenancePlanEquipmentCoverageDefinitionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
  predicate: IntComparisonExp;
};

export type MaintenancePlanEquipmentCoveragePricingsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsBoolExp>;
  predicate: IntComparisonExp;
};

export type MaintenancePlanInvoicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MaintenancePlanInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
  predicate: IntComparisonExp;
};

export type MaintenancePlanVisitInstalledEquipmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
  predicate: IntComparisonExp;
};

export type MaintenancePlanVisitsAggregateBoolExpBool_And = {
  arguments: MaintenancePlanVisitsSelectColumnMaintenancePlanVisitsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanVisitsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type MaintenancePlanVisitsAggregateBoolExpBool_Or = {
  arguments: MaintenancePlanVisitsSelectColumnMaintenancePlanVisitsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanVisitsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type MaintenancePlanVisitsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MaintenancePlanVisitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlanVisitsBoolExp>;
  predicate: IntComparisonExp;
};

export type MaintenancePlansQueryableAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MaintenancePlansQueryableSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MaintenancePlansQueryableBoolExp>;
  predicate: IntComparisonExp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "acc_cart_item_type_accounts_config" */
  deleteAccCartItemTypeAccountsConfig?: Maybe<AccCartItemTypeAccountsConfigMutationResponse>;
  /** delete single row from the table: "acc_cart_item_type_accounts_config" */
  deleteAccCartItemTypeAccountsConfigByPk?: Maybe<AccCartItemTypeAccountsConfig>;
  /** delete data from the table: "acc_company_config" */
  deleteAccCompanyConfig?: Maybe<AccCompanyConfigMutationResponse>;
  /** delete single row from the table: "acc_company_config" */
  deleteAccCompanyConfigByPk?: Maybe<AccCompanyConfig>;
  /** delete data from the table: "acc_payout_accounts_config" */
  deleteAccPayoutAccountsConfig?: Maybe<AccPayoutAccountsConfigMutationResponse>;
  /** delete single row from the table: "acc_payout_accounts_config" */
  deleteAccPayoutAccountsConfigByPk?: Maybe<AccPayoutAccountsConfig>;
  /** delete data from the table: "acc_qbd_conductor_config" */
  deleteAccQbdConductorConfig?: Maybe<AccQbdConductorConfigMutationResponse>;
  /** delete single row from the table: "acc_qbd_conductor_config" */
  deleteAccQbdConductorConfigByPk?: Maybe<AccQbdConductorConfig>;
  /** delete data from the table: "acc_qbd_conductor_uptime" */
  deleteAccQbdConductorUptime?: Maybe<AccQbdConductorUptimeMutationResponse>;
  /** delete single row from the table: "acc_qbd_conductor_uptime" */
  deleteAccQbdConductorUptimeByPk?: Maybe<AccQbdConductorUptime>;
  /** delete data from the table: "acc_sync_info" */
  deleteAccSyncInfo?: Maybe<AccSyncInfoMutationResponse>;
  /** delete single row from the table: "acc_sync_info" */
  deleteAccSyncInfoByPk?: Maybe<AccSyncInfo>;
  /** delete data from the table: "acc_sync_queue_items" */
  deleteAccSyncQueueItems?: Maybe<AccSyncQueueItemsMutationResponse>;
  /** delete single row from the table: "acc_sync_queue_items" */
  deleteAccSyncQueueItemsByPk?: Maybe<AccSyncQueueItems>;
  /** delete data from the table: "account_contacts" */
  deleteAccountContacts?: Maybe<AccountContactsMutationResponse>;
  /** delete single row from the table: "account_contacts" */
  deleteAccountContactsByPk?: Maybe<AccountContacts>;
  /** delete data from the table: "account_locations" */
  deleteAccountLocations?: Maybe<AccountLocationsMutationResponse>;
  /** delete single row from the table: "account_locations" */
  deleteAccountLocationsByPk?: Maybe<AccountLocations>;
  /** delete data from the table: "account_reminders" */
  deleteAccountReminders?: Maybe<AccountRemindersMutationResponse>;
  /** delete single row from the table: "account_reminders" */
  deleteAccountRemindersByPk?: Maybe<AccountReminders>;
  /** delete data from the table: "account_statement_events" */
  deleteAccountStatementEvents?: Maybe<AccountStatementEventsMutationResponse>;
  /** delete single row from the table: "account_statement_events" */
  deleteAccountStatementEventsByPk?: Maybe<AccountStatementEvents>;
  /** delete data from the table: "account_tags" */
  deleteAccountTags?: Maybe<AccountTagsMutationResponse>;
  /** delete single row from the table: "account_tags" */
  deleteAccountTagsByPk?: Maybe<AccountTags>;
  /** delete data from the table: "account_types" */
  deleteAccountTypes?: Maybe<AccountTypesMutationResponse>;
  /** delete single row from the table: "account_types" */
  deleteAccountTypesByPk?: Maybe<AccountTypes>;
  /** delete data from the table: "accounts" */
  deleteAccounts?: Maybe<AccountsMutationResponse>;
  /** delete single row from the table: "accounts" */
  deleteAccountsByPk?: Maybe<Accounts>;
  /** delete data from the table: "accounts_viewed_by_user" */
  deleteAccountsViewedByUser?: Maybe<AccountsViewedByUserMutationResponse>;
  /** delete single row from the table: "accounts_viewed_by_user" */
  deleteAccountsViewedByUserByPk?: Maybe<AccountsViewedByUser>;
  /** delete data from the table: "activity_items" */
  deleteActivityItems?: Maybe<ActivityItemsMutationResponse>;
  /** delete single row from the table: "activity_items" */
  deleteActivityItemsByPk?: Maybe<ActivityItems>;
  /** delete data from the table: "addresses" */
  deleteAddresses?: Maybe<AddressesMutationResponse>;
  /** delete single row from the table: "addresses" */
  deleteAddressesByPk?: Maybe<Addresses>;
  /** delete data from the table: "appointment_checklist_association_rules" */
  deleteAppointmentChecklistAssociationRules?: Maybe<AppointmentChecklistAssociationRulesMutationResponse>;
  /** delete single row from the table: "appointment_checklist_association_rules" */
  deleteAppointmentChecklistAssociationRulesByPk?: Maybe<AppointmentChecklistAssociationRules>;
  /** delete data from the table: "appointment_checklist_instances" */
  deleteAppointmentChecklistInstances?: Maybe<AppointmentChecklistInstancesMutationResponse>;
  /** delete single row from the table: "appointment_checklist_instances" */
  deleteAppointmentChecklistInstancesByPk?: Maybe<AppointmentChecklistInstances>;
  /** delete data from the table: "appointment_checklists" */
  deleteAppointmentChecklists?: Maybe<AppointmentChecklistsMutationResponse>;
  /** delete single row from the table: "appointment_checklists" */
  deleteAppointmentChecklistsByPk?: Maybe<AppointmentChecklists>;
  /** delete data from the table: "assistant_integrated_phones" */
  deleteAssistantIntegratedPhones?: Maybe<AssistantIntegratedPhonesMutationResponse>;
  /** delete single row from the table: "assistant_integrated_phones" */
  deleteAssistantIntegratedPhonesByPk?: Maybe<AssistantIntegratedPhones>;
  /** delete data from the table: "assistant_phone_settings" */
  deleteAssistantPhoneSettings?: Maybe<AssistantPhoneSettingsMutationResponse>;
  /** delete single row from the table: "assistant_phone_settings" */
  deleteAssistantPhoneSettingsByPk?: Maybe<AssistantPhoneSettings>;
  /** delete data from the table: "assistants" */
  deleteAssistants?: Maybe<AssistantsMutationResponse>;
  /** delete single row from the table: "assistants" */
  deleteAssistantsByPk?: Maybe<Assistants>;
  /** delete data from the table: "billing_profile_hidden_payment_methods" */
  deleteBillingProfileHiddenPaymentMethods?: Maybe<BillingProfileHiddenPaymentMethodsMutationResponse>;
  /** delete single row from the table: "billing_profile_hidden_payment_methods" */
  deleteBillingProfileHiddenPaymentMethodsByPk?: Maybe<BillingProfileHiddenPaymentMethods>;
  /** delete data from the table: "billing_profiles" */
  deleteBillingProfiles?: Maybe<BillingProfilesMutationResponse>;
  /** delete single row from the table: "billing_profiles" */
  deleteBillingProfilesByPk?: Maybe<BillingProfiles>;
  /** delete data from the table: "business_events" */
  deleteBusinessEvents?: Maybe<BusinessEventsMutationResponse>;
  /** delete single row from the table: "business_events" */
  deleteBusinessEventsByPk?: Maybe<BusinessEvents>;
  /** delete data from the table: "business_unit_target_metrics" */
  deleteBusinessUnitTargetMetrics?: Maybe<BusinessUnitTargetMetricsMutationResponse>;
  /** delete single row from the table: "business_unit_target_metrics" */
  deleteBusinessUnitTargetMetricsByPk?: Maybe<BusinessUnitTargetMetrics>;
  /** delete data from the table: "business_units" */
  deleteBusinessUnits?: Maybe<BusinessUnitsMutationResponse>;
  /** delete single row from the table: "business_units" */
  deleteBusinessUnitsByPk?: Maybe<BusinessUnits>;
  /** delete data from the table: "canonical_lead_sources" */
  deleteCanonicalLeadSources?: Maybe<CanonicalLeadSourcesMutationResponse>;
  /** delete single row from the table: "canonical_lead_sources" */
  deleteCanonicalLeadSourcesByPk?: Maybe<CanonicalLeadSources>;
  /** delete data from the table: "cart_item_job_cost_links" */
  deleteCartItemJobCostLinks?: Maybe<CartItemJobCostLinksMutationResponse>;
  /** delete single row from the table: "cart_item_job_cost_links" */
  deleteCartItemJobCostLinksByPk?: Maybe<CartItemJobCostLinks>;
  /** delete data from the table: "cart_items" */
  deleteCartItems?: Maybe<CartItemsMutationResponse>;
  /** delete single row from the table: "cart_items" */
  deleteCartItemsByPk?: Maybe<CartItems>;
  /** delete data from the table: "checklist_items" */
  deleteChecklistItems?: Maybe<ChecklistItemsMutationResponse>;
  /** delete single row from the table: "checklist_items" */
  deleteChecklistItemsByPk?: Maybe<ChecklistItems>;
  /** delete data from the table: "companies" */
  deleteCompanies?: Maybe<CompaniesMutationResponse>;
  /** delete single row from the table: "companies" */
  deleteCompaniesByPk?: Maybe<Companies>;
  /** delete data from the table: "company_appointment_arrival_windows" */
  deleteCompanyAppointmentArrivalWindows?: Maybe<CompanyAppointmentArrivalWindowsMutationResponse>;
  /** delete single row from the table: "company_appointment_arrival_windows" */
  deleteCompanyAppointmentArrivalWindowsByPk?: Maybe<CompanyAppointmentArrivalWindows>;
  /** delete data from the table: "company_commission_config" */
  deleteCompanyCommissionConfig?: Maybe<CompanyCommissionConfigMutationResponse>;
  /** delete single row from the table: "company_commission_config" */
  deleteCompanyCommissionConfigByPk?: Maybe<CompanyCommissionConfig>;
  /** delete data from the table: "company_config" */
  deleteCompanyConfig?: Maybe<CompanyConfigMutationResponse>;
  /** delete single row from the table: "company_config" */
  deleteCompanyConfigByPk?: Maybe<CompanyConfig>;
  /** delete data from the table: "company_drip_marketing_config" */
  deleteCompanyDripMarketingConfig?: Maybe<CompanyDripMarketingConfigMutationResponse>;
  /** delete single row from the table: "company_drip_marketing_config" */
  deleteCompanyDripMarketingConfigByPk?: Maybe<CompanyDripMarketingConfig>;
  /** delete data from the table: "company_lead_source_links" */
  deleteCompanyLeadSourceLinks?: Maybe<CompanyLeadSourceLinksMutationResponse>;
  /** delete single row from the table: "company_lead_source_links" */
  deleteCompanyLeadSourceLinksByPk?: Maybe<CompanyLeadSourceLinks>;
  /** delete data from the table: "company_lead_sources" */
  deleteCompanyLeadSources?: Maybe<CompanyLeadSourcesMutationResponse>;
  /** delete single row from the table: "company_lead_sources" */
  deleteCompanyLeadSourcesByPk?: Maybe<CompanyLeadSources>;
  /** delete data from the table: "company_notification_settings" */
  deleteCompanyNotificationSettings?: Maybe<CompanyNotificationSettingsMutationResponse>;
  /** delete single row from the table: "company_notification_settings" */
  deleteCompanyNotificationSettingsByPk?: Maybe<CompanyNotificationSettings>;
  /** delete data from the table: "company_pricing_tier_config" */
  deleteCompanyPricingTierConfig?: Maybe<CompanyPricingTierConfigMutationResponse>;
  /** delete single row from the table: "company_pricing_tier_config" */
  deleteCompanyPricingTierConfigByPk?: Maybe<CompanyPricingTierConfig>;
  /** delete data from the table: "company_roles" */
  deleteCompanyRoles?: Maybe<CompanyRolesMutationResponse>;
  /** delete single row from the table: "company_roles" */
  deleteCompanyRolesByPk?: Maybe<CompanyRoles>;
  /** delete data from the table: "company_tax_configurations" */
  deleteCompanyTaxConfigurations?: Maybe<CompanyTaxConfigurationsMutationResponse>;
  /** delete single row from the table: "company_tax_configurations" */
  deleteCompanyTaxConfigurationsByPk?: Maybe<CompanyTaxConfigurations>;
  /** delete data from the table: "company_users" */
  deleteCompanyUsers?: Maybe<CompanyUsersMutationResponse>;
  /** delete single row from the table: "company_users" */
  deleteCompanyUsersByPk?: Maybe<CompanyUsers>;
  /** delete data from the table: "company_working_display_hours" */
  deleteCompanyWorkingDisplayHours?: Maybe<CompanyWorkingDisplayHoursMutationResponse>;
  /** delete single row from the table: "company_working_display_hours" */
  deleteCompanyWorkingDisplayHoursByPk?: Maybe<CompanyWorkingDisplayHours>;
  /** delete data from the table: "contacts" */
  deleteContacts?: Maybe<ContactsMutationResponse>;
  /** delete single row from the table: "contacts" */
  deleteContactsByPk?: Maybe<Contacts>;
  /** delete data from the table: "current_company_tax_configurations_view" */
  deleteCurrentCompanyTaxConfigurationsView?: Maybe<CurrentCompanyTaxConfigurationsViewMutationResponse>;
  /** delete data from the table: "current_user_business_units_view" */
  deleteCurrentUserBusinessUnitsView?: Maybe<CurrentUserBusinessUnitsViewMutationResponse>;
  /** delete data from the table: "customer_communication_templates" */
  deleteCustomerCommunicationTemplates?: Maybe<CustomerCommunicationTemplatesMutationResponse>;
  /** delete single row from the table: "customer_communication_templates" */
  deleteCustomerCommunicationTemplatesByPk?: Maybe<CustomerCommunicationTemplates>;
  /** delete data from the table: "discount_entitlements" */
  deleteDiscountEntitlements?: Maybe<DiscountEntitlementsMutationResponse>;
  /** delete single row from the table: "discount_entitlements" */
  deleteDiscountEntitlementsByPk?: Maybe<DiscountEntitlements>;
  /** delete data from the table: "display_id_counters" */
  deleteDisplayIdCounters?: Maybe<DisplayIdCountersMutationResponse>;
  /** delete single row from the table: "display_id_counters" */
  deleteDisplayIdCountersByPk?: Maybe<DisplayIdCounters>;
  /** delete data from the table: "drip_marketing_emails" */
  deleteDripMarketingEmails?: Maybe<DripMarketingEmailsMutationResponse>;
  /** delete single row from the table: "drip_marketing_emails" */
  deleteDripMarketingEmailsByPk?: Maybe<DripMarketingEmails>;
  /** delete data from the table: "email_addresses" */
  deleteEmailAddresses?: Maybe<EmailAddressesMutationResponse>;
  /** delete single row from the table: "email_addresses" */
  deleteEmailAddressesByPk?: Maybe<EmailAddresses>;
  /** delete data from the table: "entitlements" */
  deleteEntitlements?: Maybe<EntitlementsMutationResponse>;
  /** delete single row from the table: "entitlements" */
  deleteEntitlementsByPk?: Maybe<Entitlements>;
  /** delete data from the table: "equipment_type_links" */
  deleteEquipmentTypeLinks?: Maybe<EquipmentTypeLinksMutationResponse>;
  /** delete single row from the table: "equipment_type_links" */
  deleteEquipmentTypeLinksByPk?: Maybe<EquipmentTypeLinks>;
  /** delete data from the table: "equipment_types" */
  deleteEquipmentTypes?: Maybe<EquipmentTypesMutationResponse>;
  /** delete single row from the table: "equipment_types" */
  deleteEquipmentTypesByPk?: Maybe<EquipmentTypes>;
  /** delete data from the table: "estimate_invoices" */
  deleteEstimateInvoices?: Maybe<EstimateInvoicesMutationResponse>;
  /** delete single row from the table: "estimate_invoices" */
  deleteEstimateInvoicesByPk?: Maybe<EstimateInvoices>;
  /** delete data from the table: "estimate_option_cart_items" */
  deleteEstimateOptionCartItems?: Maybe<EstimateOptionCartItemsMutationResponse>;
  /** delete single row from the table: "estimate_option_cart_items" */
  deleteEstimateOptionCartItemsByPk?: Maybe<EstimateOptionCartItems>;
  /** delete data from the table: "estimate_option_discounts" */
  deleteEstimateOptionDiscounts?: Maybe<EstimateOptionDiscountsMutationResponse>;
  /** delete single row from the table: "estimate_option_discounts" */
  deleteEstimateOptionDiscountsByPk?: Maybe<EstimateOptionDiscounts>;
  /** delete data from the table: "estimate_options" */
  deleteEstimateOptions?: Maybe<EstimateOptionsMutationResponse>;
  /** delete single row from the table: "estimate_options" */
  deleteEstimateOptionsByPk?: Maybe<EstimateOptions>;
  /** delete data from the table: "estimate_photos" */
  deleteEstimatePhotos?: Maybe<EstimatePhotosMutationResponse>;
  /** delete single row from the table: "estimate_photos" */
  deleteEstimatePhotosByPk?: Maybe<EstimatePhotos>;
  /** delete data from the table: "estimate_templates" */
  deleteEstimateTemplates?: Maybe<EstimateTemplatesMutationResponse>;
  /** delete single row from the table: "estimate_templates" */
  deleteEstimateTemplatesByPk?: Maybe<EstimateTemplates>;
  /** delete data from the table: "estimates" */
  deleteEstimates?: Maybe<EstimatesMutationResponse>;
  /** delete single row from the table: "estimates" */
  deleteEstimatesByPk?: Maybe<Estimates>;
  /** delete data from the table: "estimates_queryable" */
  deleteEstimatesQueryable?: Maybe<EstimatesQueryableMutationResponse>;
  /** delete single row from the table: "estimates_queryable" */
  deleteEstimatesQueryableByPk?: Maybe<EstimatesQueryable>;
  /** delete data from the table: "event_store" */
  deleteEventStore?: Maybe<EventStoreMutationResponse>;
  /** delete single row from the table: "event_store" */
  deleteEventStoreByPk?: Maybe<EventStore>;
  /** delete data from the table: "favorite_pricebook_items" */
  deleteFavoritePricebookItems?: Maybe<FavoritePricebookItemsMutationResponse>;
  /** delete single row from the table: "favorite_pricebook_items" */
  deleteFavoritePricebookItemsByPk?: Maybe<FavoritePricebookItems>;
  /** delete data from the table: "file_links" */
  deleteFileLinks?: Maybe<FileLinksMutationResponse>;
  /** delete single row from the table: "file_links" */
  deleteFileLinksByPk?: Maybe<FileLinks>;
  /** delete data from the table: "files" */
  deleteFiles?: Maybe<FilesMutationResponse>;
  /** delete single row from the table: "files" */
  deleteFilesByPk?: Maybe<Files>;
  /** delete data from the table: "installed_equipment" */
  deleteInstalledEquipment?: Maybe<InstalledEquipmentMutationResponse>;
  /** delete single row from the table: "installed_equipment" */
  deleteInstalledEquipmentByPk?: Maybe<InstalledEquipment>;
  /** delete data from the table: "installed_hvac_systems" */
  deleteInstalledHvacSystems?: Maybe<InstalledHvacSystemsMutationResponse>;
  /** delete single row from the table: "installed_hvac_systems" */
  deleteInstalledHvacSystemsByPk?: Maybe<InstalledHvacSystems>;
  /** delete data from the table: "instant_booking_weekly_schedule_entries" */
  deleteInstantBookingWeeklyScheduleEntries?: Maybe<InstantBookingWeeklyScheduleEntriesMutationResponse>;
  /** delete single row from the table: "instant_booking_weekly_schedule_entries" */
  deleteInstantBookingWeeklyScheduleEntriesByPk?: Maybe<InstantBookingWeeklyScheduleEntries>;
  /** delete data from the table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
  deleteInstantBookingWeeklyScheduleEntryBookableArrivalWindows?: Maybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMutationResponse>;
  /** delete single row from the table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
  deleteInstantBookingWeeklyScheduleEntryBookableArrivalWindowsByPk?: Maybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindows>;
  /** delete data from the table: "integrated_channels" */
  deleteIntegratedChannels?: Maybe<IntegratedChannelsMutationResponse>;
  /** delete single row from the table: "integrated_channels" */
  deleteIntegratedChannelsByPk?: Maybe<IntegratedChannels>;
  /** delete data from the table: "integrated_message_statuses" */
  deleteIntegratedMessageStatuses?: Maybe<IntegratedMessageStatusesMutationResponse>;
  /** delete single row from the table: "integrated_message_statuses" */
  deleteIntegratedMessageStatusesByPk?: Maybe<IntegratedMessageStatuses>;
  /** delete data from the table: "integrated_message_twilio_raw_webhook_events" */
  deleteIntegratedMessageTwilioRawWebhookEvents?: Maybe<IntegratedMessageTwilioRawWebhookEventsMutationResponse>;
  /** delete single row from the table: "integrated_message_twilio_raw_webhook_events" */
  deleteIntegratedMessageTwilioRawWebhookEventsByPk?: Maybe<IntegratedMessageTwilioRawWebhookEvents>;
  /** delete data from the table: "integrated_messages" */
  deleteIntegratedMessages?: Maybe<IntegratedMessagesMutationResponse>;
  /** delete single row from the table: "integrated_messages" */
  deleteIntegratedMessagesByPk?: Maybe<IntegratedMessages>;
  /** delete data from the table: "integrated_phone_call_dismissals" */
  deleteIntegratedPhoneCallDismissals?: Maybe<IntegratedPhoneCallDismissalsMutationResponse>;
  /** delete single row from the table: "integrated_phone_call_dismissals" */
  deleteIntegratedPhoneCallDismissalsByPk?: Maybe<IntegratedPhoneCallDismissals>;
  /** delete data from the table: "integrated_phone_call_jobs" */
  deleteIntegratedPhoneCallJobs?: Maybe<IntegratedPhoneCallJobsMutationResponse>;
  /** delete single row from the table: "integrated_phone_call_jobs" */
  deleteIntegratedPhoneCallJobsByPk?: Maybe<IntegratedPhoneCallJobs>;
  /** delete data from the table: "integrated_phone_call_recording" */
  deleteIntegratedPhoneCallRecording?: Maybe<IntegratedPhoneCallRecordingMutationResponse>;
  /** delete single row from the table: "integrated_phone_call_recording" */
  deleteIntegratedPhoneCallRecordingByPk?: Maybe<IntegratedPhoneCallRecording>;
  /** delete data from the table: "integrated_phone_call_status_types" */
  deleteIntegratedPhoneCallStatusTypes?: Maybe<IntegratedPhoneCallStatusTypesMutationResponse>;
  /** delete single row from the table: "integrated_phone_call_status_types" */
  deleteIntegratedPhoneCallStatusTypesByPk?: Maybe<IntegratedPhoneCallStatusTypes>;
  /** delete data from the table: "integrated_phone_call_statuses" */
  deleteIntegratedPhoneCallStatuses?: Maybe<IntegratedPhoneCallStatusesMutationResponse>;
  /** delete single row from the table: "integrated_phone_call_statuses" */
  deleteIntegratedPhoneCallStatusesByPk?: Maybe<IntegratedPhoneCallStatuses>;
  /** delete data from the table: "integrated_phone_calls" */
  deleteIntegratedPhoneCalls?: Maybe<IntegratedPhoneCallsMutationResponse>;
  /** delete single row from the table: "integrated_phone_calls" */
  deleteIntegratedPhoneCallsByPk?: Maybe<IntegratedPhoneCalls>;
  /** delete data from the table: "integrated_phone_company_config" */
  deleteIntegratedPhoneCompanyConfig?: Maybe<IntegratedPhoneCompanyConfigMutationResponse>;
  /** delete single row from the table: "integrated_phone_company_config" */
  deleteIntegratedPhoneCompanyConfigByPk?: Maybe<IntegratedPhoneCompanyConfig>;
  /** delete data from the table: "integrated_phone_missed_call_dismissals" */
  deleteIntegratedPhoneMissedCallDismissals?: Maybe<IntegratedPhoneMissedCallDismissalsMutationResponse>;
  /** delete single row from the table: "integrated_phone_missed_call_dismissals" */
  deleteIntegratedPhoneMissedCallDismissalsByPk?: Maybe<IntegratedPhoneMissedCallDismissals>;
  /** delete data from the table: "integrated_phone_missed_calls" */
  deleteIntegratedPhoneMissedCalls?: Maybe<IntegratedPhoneMissedCallsMutationResponse>;
  /** delete single row from the table: "integrated_phone_missed_calls" */
  deleteIntegratedPhoneMissedCallsByPk?: Maybe<IntegratedPhoneMissedCalls>;
  /** delete data from the table: "integrated_phone_twilio_raw_webhook_events" */
  deleteIntegratedPhoneTwilioRawWebhookEvents?: Maybe<IntegratedPhoneTwilioRawWebhookEventsMutationResponse>;
  /** delete single row from the table: "integrated_phone_twilio_raw_webhook_events" */
  deleteIntegratedPhoneTwilioRawWebhookEventsByPk?: Maybe<IntegratedPhoneTwilioRawWebhookEvents>;
  /** delete data from the table: "integrated_phone_users" */
  deleteIntegratedPhoneUsers?: Maybe<IntegratedPhoneUsersMutationResponse>;
  /** delete single row from the table: "integrated_phone_users" */
  deleteIntegratedPhoneUsersByPk?: Maybe<IntegratedPhoneUsers>;
  /** delete data from the table: "integrated_phone_voicemail_dismissals" */
  deleteIntegratedPhoneVoicemailDismissals?: Maybe<IntegratedPhoneVoicemailDismissalsMutationResponse>;
  /** delete single row from the table: "integrated_phone_voicemail_dismissals" */
  deleteIntegratedPhoneVoicemailDismissalsByPk?: Maybe<IntegratedPhoneVoicemailDismissals>;
  /** delete data from the table: "integrated_phone_voicemails" */
  deleteIntegratedPhoneVoicemails?: Maybe<IntegratedPhoneVoicemailsMutationResponse>;
  /** delete single row from the table: "integrated_phone_voicemails" */
  deleteIntegratedPhoneVoicemailsByPk?: Maybe<IntegratedPhoneVoicemails>;
  /** delete data from the table: "integrated_phones" */
  deleteIntegratedPhones?: Maybe<IntegratedPhonesMutationResponse>;
  /** delete single row from the table: "integrated_phones" */
  deleteIntegratedPhonesByPk?: Maybe<IntegratedPhones>;
  /** delete data from the table: "internal_notifications" */
  deleteInternalNotifications?: Maybe<InternalNotificationsMutationResponse>;
  /** delete single row from the table: "internal_notifications" */
  deleteInternalNotificationsByPk?: Maybe<InternalNotifications>;
  /** delete data from the table: "invoice_cart_item_bundle_items" */
  deleteInvoiceCartItemBundleItems?: Maybe<InvoiceCartItemBundleItemsMutationResponse>;
  /** delete single row from the table: "invoice_cart_item_bundle_items" */
  deleteInvoiceCartItemBundleItemsByPk?: Maybe<InvoiceCartItemBundleItems>;
  /** delete data from the table: "invoice_cart_item_bundle_job_cost_links" */
  deleteInvoiceCartItemBundleJobCostLinks?: Maybe<InvoiceCartItemBundleJobCostLinksMutationResponse>;
  /** delete single row from the table: "invoice_cart_item_bundle_job_cost_links" */
  deleteInvoiceCartItemBundleJobCostLinksByPk?: Maybe<InvoiceCartItemBundleJobCostLinks>;
  /** delete data from the table: "invoice_cart_items" */
  deleteInvoiceCartItems?: Maybe<InvoiceCartItemsMutationResponse>;
  /** delete single row from the table: "invoice_cart_items" */
  deleteInvoiceCartItemsByPk?: Maybe<InvoiceCartItems>;
  /** delete data from the table: "invoice_discounts" */
  deleteInvoiceDiscounts?: Maybe<InvoiceDiscountsMutationResponse>;
  /** delete single row from the table: "invoice_discounts" */
  deleteInvoiceDiscountsByPk?: Maybe<InvoiceDiscounts>;
  /** delete data from the table: "invoice_events" */
  deleteInvoiceEvents?: Maybe<InvoiceEventsMutationResponse>;
  /** delete single row from the table: "invoice_events" */
  deleteInvoiceEventsByPk?: Maybe<InvoiceEvents>;
  /** delete data from the table: "invoice_payments" */
  deleteInvoicePayments?: Maybe<InvoicePaymentsMutationResponse>;
  /** delete single row from the table: "invoice_payments" */
  deleteInvoicePaymentsByPk?: Maybe<InvoicePayments>;
  /** delete data from the table: "invoice_reminder_data" */
  deleteInvoiceReminderData?: Maybe<InvoiceReminderDataMutationResponse>;
  /** delete single row from the table: "invoice_reminder_data" */
  deleteInvoiceReminderDataByPk?: Maybe<InvoiceReminderData>;
  /** delete data from the table: "invoice_template_cart_items" */
  deleteInvoiceTemplateCartItems?: Maybe<InvoiceTemplateCartItemsMutationResponse>;
  /** delete single row from the table: "invoice_template_cart_items" */
  deleteInvoiceTemplateCartItemsByPk?: Maybe<InvoiceTemplateCartItems>;
  /** delete data from the table: "invoice_templates" */
  deleteInvoiceTemplates?: Maybe<InvoiceTemplatesMutationResponse>;
  /** delete single row from the table: "invoice_templates" */
  deleteInvoiceTemplatesByPk?: Maybe<InvoiceTemplates>;
  /** delete data from the table: "invoices" */
  deleteInvoices?: Maybe<InvoicesMutationResponse>;
  /** delete single row from the table: "invoices" */
  deleteInvoicesByPk?: Maybe<Invoices>;
  /** delete data from the table: "invoices_queryable" */
  deleteInvoicesQueryable?: Maybe<InvoicesQueryableMutationResponse>;
  /** delete single row from the table: "invoices_queryable" */
  deleteInvoicesQueryableByPk?: Maybe<InvoicesQueryable>;
  /** delete data from the table: "job_appointment_assignment_status_types" */
  deleteJobAppointmentAssignmentStatusTypes?: Maybe<JobAppointmentAssignmentStatusTypesMutationResponse>;
  /** delete single row from the table: "job_appointment_assignment_status_types" */
  deleteJobAppointmentAssignmentStatusTypesByPk?: Maybe<JobAppointmentAssignmentStatusTypes>;
  /** delete data from the table: "job_appointment_assignment_statuses" */
  deleteJobAppointmentAssignmentStatuses?: Maybe<JobAppointmentAssignmentStatusesMutationResponse>;
  /** delete single row from the table: "job_appointment_assignment_statuses" */
  deleteJobAppointmentAssignmentStatusesByPk?: Maybe<JobAppointmentAssignmentStatuses>;
  /** delete data from the table: "job_appointment_assignments" */
  deleteJobAppointmentAssignments?: Maybe<JobAppointmentAssignmentsMutationResponse>;
  /** delete single row from the table: "job_appointment_assignments" */
  deleteJobAppointmentAssignmentsByPk?: Maybe<JobAppointmentAssignments>;
  /** delete data from the table: "job_appointment_cancellation_statuses" */
  deleteJobAppointmentCancellationStatuses?: Maybe<JobAppointmentCancellationStatusesMutationResponse>;
  /** delete single row from the table: "job_appointment_cancellation_statuses" */
  deleteJobAppointmentCancellationStatusesByPk?: Maybe<JobAppointmentCancellationStatuses>;
  /** delete data from the table: "job_appointment_confirmation_statuses" */
  deleteJobAppointmentConfirmationStatuses?: Maybe<JobAppointmentConfirmationStatusesMutationResponse>;
  /** delete single row from the table: "job_appointment_confirmation_statuses" */
  deleteJobAppointmentConfirmationStatusesByPk?: Maybe<JobAppointmentConfirmationStatuses>;
  /** delete data from the table: "job_appointment_invoices" */
  deleteJobAppointmentInvoices?: Maybe<JobAppointmentInvoicesMutationResponse>;
  /** delete single row from the table: "job_appointment_invoices" */
  deleteJobAppointmentInvoicesByPk?: Maybe<JobAppointmentInvoices>;
  /** delete data from the table: "job_appointments" */
  deleteJobAppointments?: Maybe<JobAppointmentsMutationResponse>;
  /** delete single row from the table: "job_appointments" */
  deleteJobAppointmentsByPk?: Maybe<JobAppointments>;
  /** delete data from the table: "job_cost_items" */
  deleteJobCostItems?: Maybe<JobCostItemsMutationResponse>;
  /** delete single row from the table: "job_cost_items" */
  deleteJobCostItemsByPk?: Maybe<JobCostItems>;
  /** delete data from the table: "job_cost_misc_categories" */
  deleteJobCostMiscCategories?: Maybe<JobCostMiscCategoriesMutationResponse>;
  /** delete single row from the table: "job_cost_misc_categories" */
  deleteJobCostMiscCategoriesByPk?: Maybe<JobCostMiscCategories>;
  /** delete data from the table: "job_costing_config" */
  deleteJobCostingConfig?: Maybe<JobCostingConfigMutationResponse>;
  /** delete single row from the table: "job_costing_config" */
  deleteJobCostingConfigByPk?: Maybe<JobCostingConfig>;
  /** delete data from the table: "job_invoices" */
  deleteJobInvoices?: Maybe<JobInvoicesMutationResponse>;
  /** delete single row from the table: "job_invoices" */
  deleteJobInvoicesByPk?: Maybe<JobInvoices>;
  /** delete data from the table: "job_leads" */
  deleteJobLeads?: Maybe<JobLeadsMutationResponse>;
  /** delete single row from the table: "job_leads" */
  deleteJobLeadsByPk?: Maybe<JobLeads>;
  /** delete data from the table: "job_lifecycle_statuses" */
  deleteJobLifecycleStatuses?: Maybe<JobLifecycleStatusesMutationResponse>;
  /** delete single row from the table: "job_lifecycle_statuses" */
  deleteJobLifecycleStatusesByPk?: Maybe<JobLifecycleStatuses>;
  /** delete data from the table: "job_lifecycle_types" */
  deleteJobLifecycleTypes?: Maybe<JobLifecycleTypesMutationResponse>;
  /** delete single row from the table: "job_lifecycle_types" */
  deleteJobLifecycleTypesByPk?: Maybe<JobLifecycleTypes>;
  /** delete data from the table: "job_lifecycle_views" */
  deleteJobLifecycleViews?: Maybe<JobLifecycleViewsMutationResponse>;
  /** delete single row from the table: "job_lifecycle_views" */
  deleteJobLifecycleViewsByPk?: Maybe<JobLifecycleViews>;
  /** delete data from the table: "job_lifecycles" */
  deleteJobLifecycles?: Maybe<JobLifecyclesMutationResponse>;
  /** delete single row from the table: "job_lifecycles" */
  deleteJobLifecyclesByPk?: Maybe<JobLifecycles>;
  /** delete data from the table: "job_requests_company_config" */
  deleteJobRequestsCompanyConfig?: Maybe<JobRequestsCompanyConfigMutationResponse>;
  /** delete single row from the table: "job_requests_company_config" */
  deleteJobRequestsCompanyConfigByPk?: Maybe<JobRequestsCompanyConfig>;
  /** delete data from the table: "job_tags" */
  deleteJobTags?: Maybe<JobTagsMutationResponse>;
  /** delete single row from the table: "job_tags" */
  deleteJobTagsByPk?: Maybe<JobTags>;
  /** delete data from the table: "job_team_members" */
  deleteJobTeamMembers?: Maybe<JobTeamMembersMutationResponse>;
  /** delete single row from the table: "job_team_members" */
  deleteJobTeamMembersByPk?: Maybe<JobTeamMembers>;
  /** delete data from the table: "job_technician_earned_revenue_attributions" */
  deleteJobTechnicianEarnedRevenueAttributions?: Maybe<JobTechnicianEarnedRevenueAttributionsMutationResponse>;
  /** delete single row from the table: "job_technician_earned_revenue_attributions" */
  deleteJobTechnicianEarnedRevenueAttributionsByPk?: Maybe<JobTechnicianEarnedRevenueAttributions>;
  /** delete data from the table: "job_technician_sold_revenue_attributions" */
  deleteJobTechnicianSoldRevenueAttributions?: Maybe<JobTechnicianSoldRevenueAttributionsMutationResponse>;
  /** delete single row from the table: "job_technician_sold_revenue_attributions" */
  deleteJobTechnicianSoldRevenueAttributionsByPk?: Maybe<JobTechnicianSoldRevenueAttributions>;
  /** delete data from the table: "job_type_change_reasons" */
  deleteJobTypeChangeReasons?: Maybe<JobTypeChangeReasonsMutationResponse>;
  /** delete single row from the table: "job_type_change_reasons" */
  deleteJobTypeChangeReasonsByPk?: Maybe<JobTypeChangeReasons>;
  /** delete data from the table: "job_types" */
  deleteJobTypes?: Maybe<JobTypesMutationResponse>;
  /** delete single row from the table: "job_types" */
  deleteJobTypesByPk?: Maybe<JobTypes>;
  /** delete data from the table: "jobs" */
  deleteJobs?: Maybe<JobsMutationResponse>;
  /** delete single row from the table: "jobs" */
  deleteJobsByPk?: Maybe<Jobs>;
  /** delete data from the table: "jobs_with_linked_job" */
  deleteJobsWithLinkedJob?: Maybe<JobsWithLinkedJobMutationResponse>;
  /** delete single row from the table: "jobs_with_linked_job" */
  deleteJobsWithLinkedJobByPk?: Maybe<JobsWithLinkedJob>;
  /** delete data from the table: "jobs_with_linked_job_linked_appointment_checklist_instances" */
  deleteJobsWithLinkedJobLinkedAppointmentChecklistInstances?: Maybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesMutationResponse>;
  /** delete single row from the table: "jobs_with_linked_job_linked_appointment_checklist_instances" */
  deleteJobsWithLinkedJobLinkedAppointmentChecklistInstancesByPk?: Maybe<JobsWithLinkedJobLinkedAppointmentChecklistInstances>;
  /** delete data from the table: "jobs_with_linked_job_linked_estimates" */
  deleteJobsWithLinkedJobLinkedEstimates?: Maybe<JobsWithLinkedJobLinkedEstimatesMutationResponse>;
  /** delete single row from the table: "jobs_with_linked_job_linked_estimates" */
  deleteJobsWithLinkedJobLinkedEstimatesByPk?: Maybe<JobsWithLinkedJobLinkedEstimates>;
  /** delete data from the table: "location_contacts" */
  deleteLocationContacts?: Maybe<LocationContactsMutationResponse>;
  /** delete single row from the table: "location_contacts" */
  deleteLocationContactsByPk?: Maybe<LocationContacts>;
  /** delete data from the table: "location_invoices" */
  deleteLocationInvoices?: Maybe<LocationInvoicesMutationResponse>;
  /** delete single row from the table: "location_invoices" */
  deleteLocationInvoicesByPk?: Maybe<LocationInvoices>;
  /** delete data from the table: "locations" */
  deleteLocations?: Maybe<LocationsMutationResponse>;
  /** delete single row from the table: "locations" */
  deleteLocationsByPk?: Maybe<Locations>;
  /** delete data from the table: "maintenance_plan_definition_allowed_payment_intervals" */
  deleteMaintenancePlanDefinitionAllowedPaymentIntervals?: Maybe<MaintenancePlanDefinitionAllowedPaymentIntervalsMutationResponse>;
  /** delete single row from the table: "maintenance_plan_definition_allowed_payment_intervals" */
  deleteMaintenancePlanDefinitionAllowedPaymentIntervalsByPk?: Maybe<MaintenancePlanDefinitionAllowedPaymentIntervals>;
  /** delete data from the table: "maintenance_plan_definition_benefits" */
  deleteMaintenancePlanDefinitionBenefits?: Maybe<MaintenancePlanDefinitionBenefitsMutationResponse>;
  /** delete single row from the table: "maintenance_plan_definition_benefits" */
  deleteMaintenancePlanDefinitionBenefitsByPk?: Maybe<MaintenancePlanDefinitionBenefits>;
  /** delete data from the table: "maintenance_plan_definition_discounts" */
  deleteMaintenancePlanDefinitionDiscounts?: Maybe<MaintenancePlanDefinitionDiscountsMutationResponse>;
  /** delete single row from the table: "maintenance_plan_definition_discounts" */
  deleteMaintenancePlanDefinitionDiscountsByPk?: Maybe<MaintenancePlanDefinitionDiscounts>;
  /** delete data from the table: "maintenance_plan_definition_flare" */
  deleteMaintenancePlanDefinitionFlare?: Maybe<MaintenancePlanDefinitionFlareMutationResponse>;
  /** delete single row from the table: "maintenance_plan_definition_flare" */
  deleteMaintenancePlanDefinitionFlareByPk?: Maybe<MaintenancePlanDefinitionFlare>;
  /** delete data from the table: "maintenance_plan_definition_marketing_info" */
  deleteMaintenancePlanDefinitionMarketingInfo?: Maybe<MaintenancePlanDefinitionMarketingInfoMutationResponse>;
  /** delete single row from the table: "maintenance_plan_definition_marketing_info" */
  deleteMaintenancePlanDefinitionMarketingInfoByPk?: Maybe<MaintenancePlanDefinitionMarketingInfo>;
  /** delete data from the table: "maintenance_plan_definitions" */
  deleteMaintenancePlanDefinitions?: Maybe<MaintenancePlanDefinitionsMutationResponse>;
  /** delete single row from the table: "maintenance_plan_definitions" */
  deleteMaintenancePlanDefinitionsByPk?: Maybe<MaintenancePlanDefinitions>;
  /** delete data from the table: "maintenance_plan_equipment_coverage_definitions" */
  deleteMaintenancePlanEquipmentCoverageDefinitions?: Maybe<MaintenancePlanEquipmentCoverageDefinitionsMutationResponse>;
  /** delete single row from the table: "maintenance_plan_equipment_coverage_definitions" */
  deleteMaintenancePlanEquipmentCoverageDefinitionsByPk?: Maybe<MaintenancePlanEquipmentCoverageDefinitions>;
  /** delete data from the table: "maintenance_plan_equipment_coverage_pricings" */
  deleteMaintenancePlanEquipmentCoveragePricings?: Maybe<MaintenancePlanEquipmentCoveragePricingsMutationResponse>;
  /** delete single row from the table: "maintenance_plan_equipment_coverage_pricings" */
  deleteMaintenancePlanEquipmentCoveragePricingsByPk?: Maybe<MaintenancePlanEquipmentCoveragePricings>;
  /** delete data from the table: "maintenance_plan_invoices" */
  deleteMaintenancePlanInvoices?: Maybe<MaintenancePlanInvoicesMutationResponse>;
  /** delete single row from the table: "maintenance_plan_invoices" */
  deleteMaintenancePlanInvoicesByPk?: Maybe<MaintenancePlanInvoices>;
  /** delete data from the table: "maintenance_plan_visit_installed_equipments" */
  deleteMaintenancePlanVisitInstalledEquipments?: Maybe<MaintenancePlanVisitInstalledEquipmentsMutationResponse>;
  /** delete single row from the table: "maintenance_plan_visit_installed_equipments" */
  deleteMaintenancePlanVisitInstalledEquipmentsByPk?: Maybe<MaintenancePlanVisitInstalledEquipments>;
  /** delete data from the table: "maintenance_plan_visits" */
  deleteMaintenancePlanVisits?: Maybe<MaintenancePlanVisitsMutationResponse>;
  /** delete single row from the table: "maintenance_plan_visits" */
  deleteMaintenancePlanVisitsByPk?: Maybe<MaintenancePlanVisits>;
  /** delete data from the table: "maintenance_plans_queryable" */
  deleteMaintenancePlansQueryable?: Maybe<MaintenancePlansQueryableMutationResponse>;
  /** delete single row from the table: "maintenance_plans_queryable" */
  deleteMaintenancePlansQueryableByPk?: Maybe<MaintenancePlansQueryable>;
  /** delete data from the table: "migration_junk" */
  deleteMigrationJunk?: Maybe<MigrationJunkMutationResponse>;
  /** delete single row from the table: "migration_junk" */
  deleteMigrationJunkByPk?: Maybe<MigrationJunk>;
  /** delete data from the table: "migration_junk_links" */
  deleteMigrationJunkLinks?: Maybe<MigrationJunkLinksMutationResponse>;
  /** delete single row from the table: "migration_junk_links" */
  deleteMigrationJunkLinksByPk?: Maybe<MigrationJunkLinks>;
  /** delete data from the table: "note_attachments" */
  deleteNoteAttachments?: Maybe<NoteAttachmentsMutationResponse>;
  /** delete single row from the table: "note_attachments" */
  deleteNoteAttachmentsByPk?: Maybe<NoteAttachments>;
  /** delete data from the table: "note_links" */
  deleteNoteLinks?: Maybe<NoteLinksMutationResponse>;
  /** delete single row from the table: "note_links" */
  deleteNoteLinksByPk?: Maybe<NoteLinks>;
  /** delete data from the table: "note_tagged_users" */
  deleteNoteTaggedUsers?: Maybe<NoteTaggedUsersMutationResponse>;
  /** delete single row from the table: "note_tagged_users" */
  deleteNoteTaggedUsersByPk?: Maybe<NoteTaggedUsers>;
  /** delete data from the table: "notes" */
  deleteNotes?: Maybe<NotesMutationResponse>;
  /** delete single row from the table: "notes" */
  deleteNotesByPk?: Maybe<Notes>;
  /** delete data from the table: "online_booking_company_config" */
  deleteOnlineBookingCompanyConfig?: Maybe<OnlineBookingCompanyConfigMutationResponse>;
  /** delete single row from the table: "online_booking_company_config" */
  deleteOnlineBookingCompanyConfigByPk?: Maybe<OnlineBookingCompanyConfig>;
  /** delete data from the table: "online_booking_service_area_zip_codes" */
  deleteOnlineBookingServiceAreaZipCodes?: Maybe<OnlineBookingServiceAreaZipCodesMutationResponse>;
  /** delete single row from the table: "online_booking_service_area_zip_codes" */
  deleteOnlineBookingServiceAreaZipCodesByPk?: Maybe<OnlineBookingServiceAreaZipCodes>;
  /** delete data from the table: "online_booking_service_type_bookable_job_types" */
  deleteOnlineBookingServiceTypeBookableJobTypes?: Maybe<OnlineBookingServiceTypeBookableJobTypesMutationResponse>;
  /** delete single row from the table: "online_booking_service_type_bookable_job_types" */
  deleteOnlineBookingServiceTypeBookableJobTypesByPk?: Maybe<OnlineBookingServiceTypeBookableJobTypes>;
  /** delete data from the table: "online_booking_service_type_bookable_technicians" */
  deleteOnlineBookingServiceTypeBookableTechnicians?: Maybe<OnlineBookingServiceTypeBookableTechniciansMutationResponse>;
  /** delete single row from the table: "online_booking_service_type_bookable_technicians" */
  deleteOnlineBookingServiceTypeBookableTechniciansByPk?: Maybe<OnlineBookingServiceTypeBookableTechnicians>;
  /** delete data from the table: "online_booking_service_type_configs" */
  deleteOnlineBookingServiceTypeConfigs?: Maybe<OnlineBookingServiceTypeConfigsMutationResponse>;
  /** delete single row from the table: "online_booking_service_type_configs" */
  deleteOnlineBookingServiceTypeConfigsByPk?: Maybe<OnlineBookingServiceTypeConfigs>;
  /** delete data from the table: "payment_links" */
  deletePaymentLinks?: Maybe<PaymentLinksMutationResponse>;
  /** delete single row from the table: "payment_links" */
  deletePaymentLinksByPk?: Maybe<PaymentLinks>;
  /** delete data from the table: "payment_method_billing_info" */
  deletePaymentMethodBillingInfo?: Maybe<PaymentMethodBillingInfoMutationResponse>;
  /** delete single row from the table: "payment_method_billing_info" */
  deletePaymentMethodBillingInfoByPk?: Maybe<PaymentMethodBillingInfo>;
  /** delete data from the table: "payment_method_card_metadata" */
  deletePaymentMethodCardMetadata?: Maybe<PaymentMethodCardMetadataMutationResponse>;
  /** delete single row from the table: "payment_method_card_metadata" */
  deletePaymentMethodCardMetadataByPk?: Maybe<PaymentMethodCardMetadata>;
  /** delete data from the table: "payment_method_records" */
  deletePaymentMethodRecords?: Maybe<PaymentMethodRecordsMutationResponse>;
  /** delete single row from the table: "payment_method_records" */
  deletePaymentMethodRecordsByPk?: Maybe<PaymentMethodRecords>;
  /** delete data from the table: "payment_records" */
  deletePaymentRecords?: Maybe<PaymentRecordsMutationResponse>;
  /** delete single row from the table: "payment_records" */
  deletePaymentRecordsByPk?: Maybe<PaymentRecords>;
  /** delete data from the table: "payment_refunds" */
  deletePaymentRefunds?: Maybe<PaymentRefundsMutationResponse>;
  /** delete single row from the table: "payment_refunds" */
  deletePaymentRefundsByPk?: Maybe<PaymentRefunds>;
  /** delete data from the table: "payment_status_error_detail" */
  deletePaymentStatusErrorDetail?: Maybe<PaymentStatusErrorDetailMutationResponse>;
  /** delete single row from the table: "payment_status_error_detail" */
  deletePaymentStatusErrorDetailByPk?: Maybe<PaymentStatusErrorDetail>;
  /** delete data from the table: "payment_status_latest" */
  deletePaymentStatusLatest?: Maybe<PaymentStatusLatestMutationResponse>;
  /** delete single row from the table: "payment_status_latest" */
  deletePaymentStatusLatestByPk?: Maybe<PaymentStatusLatest>;
  /** delete data from the table: "payment_statuses" */
  deletePaymentStatuses?: Maybe<PaymentStatusesMutationResponse>;
  /** delete single row from the table: "payment_statuses" */
  deletePaymentStatusesByPk?: Maybe<PaymentStatuses>;
  /** delete data from the table: "payment_subscription_invoices" */
  deletePaymentSubscriptionInvoices?: Maybe<PaymentSubscriptionInvoicesMutationResponse>;
  /** delete single row from the table: "payment_subscription_invoices" */
  deletePaymentSubscriptionInvoicesByPk?: Maybe<PaymentSubscriptionInvoices>;
  /** delete data from the table: "payment_subscription_statuses" */
  deletePaymentSubscriptionStatuses?: Maybe<PaymentSubscriptionStatusesMutationResponse>;
  /** delete single row from the table: "payment_subscription_statuses" */
  deletePaymentSubscriptionStatusesByPk?: Maybe<PaymentSubscriptionStatuses>;
  /** delete data from the table: "payment_subscriptions" */
  deletePaymentSubscriptions?: Maybe<PaymentSubscriptionsMutationResponse>;
  /** delete single row from the table: "payment_subscriptions" */
  deletePaymentSubscriptionsByPk?: Maybe<PaymentSubscriptions>;
  /** delete data from the table: "payout_items" */
  deletePayoutItems?: Maybe<PayoutItemsMutationResponse>;
  /** delete single row from the table: "payout_items" */
  deletePayoutItemsByPk?: Maybe<PayoutItems>;
  /** delete data from the table: "payout_qbo_accounts_config" */
  deletePayoutQboAccountsConfig?: Maybe<PayoutQboAccountsConfigMutationResponse>;
  /** delete single row from the table: "payout_qbo_accounts_config" */
  deletePayoutQboAccountsConfigByPk?: Maybe<PayoutQboAccountsConfig>;
  /** delete data from the table: "payouts" */
  deletePayouts?: Maybe<PayoutsMutationResponse>;
  /** delete single row from the table: "payouts" */
  deletePayoutsByPk?: Maybe<Payouts>;
  /** delete data from the table: "phone_numbers" */
  deletePhoneNumbers?: Maybe<PhoneNumbersMutationResponse>;
  /** delete single row from the table: "phone_numbers" */
  deletePhoneNumbersByPk?: Maybe<PhoneNumbers>;
  /** delete data from the table: "photo_links" */
  deletePhotoLinks?: Maybe<PhotoLinksMutationResponse>;
  /** delete single row from the table: "photo_links" */
  deletePhotoLinksByPk?: Maybe<PhotoLinks>;
  /** delete data from the table: "photos" */
  deletePhotos?: Maybe<PhotosMutationResponse>;
  /** delete single row from the table: "photos" */
  deletePhotosByPk?: Maybe<Photos>;
  /** delete data from the table: "pricebook_bundle_items" */
  deletePricebookBundleItems?: Maybe<PricebookBundleItemsMutationResponse>;
  /** delete single row from the table: "pricebook_bundle_items" */
  deletePricebookBundleItemsByPk?: Maybe<PricebookBundleItems>;
  /** delete data from the table: "pricebook_categories" */
  deletePricebookCategories?: Maybe<PricebookCategoriesMutationResponse>;
  /** delete single row from the table: "pricebook_categories" */
  deletePricebookCategoriesByPk?: Maybe<PricebookCategories>;
  /** delete data from the table: "pricebook_discounts" */
  deletePricebookDiscounts?: Maybe<PricebookDiscountsMutationResponse>;
  /** delete single row from the table: "pricebook_discounts" */
  deletePricebookDiscountsByPk?: Maybe<PricebookDiscounts>;
  /** delete data from the table: "pricebook_item_type_fallback_photos" */
  deletePricebookItemTypeFallbackPhotos?: Maybe<PricebookItemTypeFallbackPhotosMutationResponse>;
  /** delete single row from the table: "pricebook_item_type_fallback_photos" */
  deletePricebookItemTypeFallbackPhotosByPk?: Maybe<PricebookItemTypeFallbackPhotos>;
  /** delete data from the table: "pricebook_items" */
  deletePricebookItems?: Maybe<PricebookItemsMutationResponse>;
  /** delete single row from the table: "pricebook_items" */
  deletePricebookItemsByPk?: Maybe<PricebookItems>;
  /** delete data from the table: "pricebook_items_qbo_income_accounts" */
  deletePricebookItemsQboIncomeAccounts?: Maybe<PricebookItemsQboIncomeAccountsMutationResponse>;
  /** delete single row from the table: "pricebook_items_qbo_income_accounts" */
  deletePricebookItemsQboIncomeAccountsByPk?: Maybe<PricebookItemsQboIncomeAccounts>;
  /** delete data from the table: "pricebook_markup_tiers" */
  deletePricebookMarkupTiers?: Maybe<PricebookMarkupTiersMutationResponse>;
  /** delete single row from the table: "pricebook_markup_tiers" */
  deletePricebookMarkupTiersByPk?: Maybe<PricebookMarkupTiers>;
  /** delete data from the table: "pricebook_tax_rates" */
  deletePricebookTaxRates?: Maybe<PricebookTaxRatesMutationResponse>;
  /** delete single row from the table: "pricebook_tax_rates" */
  deletePricebookTaxRatesByPk?: Maybe<PricebookTaxRates>;
  /** delete data from the table: "pricebook_versions" */
  deletePricebookVersions?: Maybe<PricebookVersionsMutationResponse>;
  /** delete single row from the table: "pricebook_versions" */
  deletePricebookVersionsByPk?: Maybe<PricebookVersions>;
  /** delete data from the table: "purchase_orders" */
  deletePurchaseOrders?: Maybe<PurchaseOrdersMutationResponse>;
  /** delete single row from the table: "purchase_orders" */
  deletePurchaseOrdersByPk?: Maybe<PurchaseOrders>;
  /** delete data from the table: "qbo_auth_data" */
  deleteQboAuthData?: Maybe<QboAuthDataMutationResponse>;
  /** delete single row from the table: "qbo_auth_data" */
  deleteQboAuthDataByPk?: Maybe<QboAuthData>;
  /** delete data from the table: "qbo_cart_item_type_accounts_config" */
  deleteQboCartItemTypeAccountsConfig?: Maybe<QboCartItemTypeAccountsConfigMutationResponse>;
  /** delete single row from the table: "qbo_cart_item_type_accounts_config" */
  deleteQboCartItemTypeAccountsConfigByPk?: Maybe<QboCartItemTypeAccountsConfig>;
  /** delete data from the table: "qbo_sync_info" */
  deleteQboSyncInfo?: Maybe<QboSyncInfoMutationResponse>;
  /** delete single row from the table: "qbo_sync_info" */
  deleteQboSyncInfoByPk?: Maybe<QboSyncInfo>;
  /** delete data from the table: "recent_pricebook_items" */
  deleteRecentPricebookItems?: Maybe<RecentPricebookItemsMutationResponse>;
  /** delete single row from the table: "recent_pricebook_items" */
  deleteRecentPricebookItemsByPk?: Maybe<RecentPricebookItems>;
  /** delete data from the table: "recommendation_ai_generation_info" */
  deleteRecommendationAiGenerationInfo?: Maybe<RecommendationAiGenerationInfoMutationResponse>;
  /** delete single row from the table: "recommendation_ai_generation_info" */
  deleteRecommendationAiGenerationInfoByPk?: Maybe<RecommendationAiGenerationInfo>;
  /** delete data from the table: "recommendation_dismissals" */
  deleteRecommendationDismissals?: Maybe<RecommendationDismissalsMutationResponse>;
  /** delete single row from the table: "recommendation_dismissals" */
  deleteRecommendationDismissalsByPk?: Maybe<RecommendationDismissals>;
  /** delete data from the table: "recommendation_interactions" */
  deleteRecommendationInteractions?: Maybe<RecommendationInteractionsMutationResponse>;
  /** delete single row from the table: "recommendation_interactions" */
  deleteRecommendationInteractionsByPk?: Maybe<RecommendationInteractions>;
  /** delete data from the table: "recommendations" */
  deleteRecommendations?: Maybe<RecommendationsMutationResponse>;
  /** delete single row from the table: "recommendations" */
  deleteRecommendationsByPk?: Maybe<Recommendations>;
  /** delete data from the table: "reminder_assignments" */
  deleteReminderAssignments?: Maybe<ReminderAssignmentsMutationResponse>;
  /** delete single row from the table: "reminder_assignments" */
  deleteReminderAssignmentsByPk?: Maybe<ReminderAssignments>;
  /** delete data from the table: "reminder_internal_notifications" */
  deleteReminderInternalNotifications?: Maybe<ReminderInternalNotificationsMutationResponse>;
  /** delete single row from the table: "reminder_internal_notifications" */
  deleteReminderInternalNotificationsByPk?: Maybe<ReminderInternalNotifications>;
  /** delete data from the table: "reminders" */
  deleteReminders?: Maybe<RemindersMutationResponse>;
  /** delete single row from the table: "reminders" */
  deleteRemindersByPk?: Maybe<Reminders>;
  /** delete data from the table: "rep_company_metabase_config" */
  deleteRepCompanyMetabaseConfig?: Maybe<RepCompanyMetabaseConfigMutationResponse>;
  /** delete single row from the table: "rep_company_metabase_config" */
  deleteRepCompanyMetabaseConfigByPk?: Maybe<RepCompanyMetabaseConfig>;
  /** delete data from the table: "rep_metabase_company_reports" */
  deleteRepMetabaseCompanyReports?: Maybe<RepMetabaseCompanyReportsMutationResponse>;
  /** delete single row from the table: "rep_metabase_company_reports" */
  deleteRepMetabaseCompanyReportsByPk?: Maybe<RepMetabaseCompanyReports>;
  /** delete data from the table: "rep_metabase_pulses" */
  deleteRepMetabasePulses?: Maybe<RepMetabasePulsesMutationResponse>;
  /** delete single row from the table: "rep_metabase_pulses" */
  deleteRepMetabasePulsesByPk?: Maybe<RepMetabasePulses>;
  /** delete data from the table: "rep_metabase_pulses_v2" */
  deleteRepMetabasePulsesV2?: Maybe<RepMetabasePulsesV2MutationResponse>;
  /** delete single row from the table: "rep_metabase_pulses_v2" */
  deleteRepMetabasePulsesV2ByPk?: Maybe<RepMetabasePulsesV2>;
  /** delete data from the table: "rep_metabase_report_definitions" */
  deleteRepMetabaseReportDefinitions?: Maybe<RepMetabaseReportDefinitionsMutationResponse>;
  /** delete single row from the table: "rep_metabase_report_definitions" */
  deleteRepMetabaseReportDefinitionsByPk?: Maybe<RepMetabaseReportDefinitions>;
  /** delete data from the table: "tags" */
  deleteTags?: Maybe<TagsMutationResponse>;
  /** delete single row from the table: "tags" */
  deleteTagsByPk?: Maybe<Tags>;
  /** delete data from the table: "technician_capacities" */
  deleteTechnicianCapacities?: Maybe<TechnicianCapacitiesMutationResponse>;
  /** delete single row from the table: "technician_capacities" */
  deleteTechnicianCapacitiesByPk?: Maybe<TechnicianCapacities>;
  /** delete data from the table: "technician_capacity_blocks" */
  deleteTechnicianCapacityBlocks?: Maybe<TechnicianCapacityBlocksMutationResponse>;
  /** delete single row from the table: "technician_capacity_blocks" */
  deleteTechnicianCapacityBlocksByPk?: Maybe<TechnicianCapacityBlocks>;
  /** delete data from the table: "tilled_raw_events" */
  deleteTilledRawEvents?: Maybe<TilledRawEventsMutationResponse>;
  /** delete single row from the table: "tilled_raw_events" */
  deleteTilledRawEventsByPk?: Maybe<TilledRawEvents>;
  /** delete data from the table: "timesheet_entries" */
  deleteTimesheetEntries?: Maybe<TimesheetEntriesMutationResponse>;
  /** delete single row from the table: "timesheet_entries" */
  deleteTimesheetEntriesByPk?: Maybe<TimesheetEntries>;
  /** delete data from the table: "timesheet_entry_activities" */
  deleteTimesheetEntryActivities?: Maybe<TimesheetEntryActivitiesMutationResponse>;
  /** delete single row from the table: "timesheet_entry_activities" */
  deleteTimesheetEntryActivitiesByPk?: Maybe<TimesheetEntryActivities>;
  /** delete data from the table: "timesheet_entry_link_data" */
  deleteTimesheetEntryLinkData?: Maybe<TimesheetEntryLinkDataMutationResponse>;
  /** delete single row from the table: "timesheet_entry_link_data" */
  deleteTimesheetEntryLinkDataByPk?: Maybe<TimesheetEntryLinkData>;
  /** delete data from the table: "tune_up_visit_entitlements" */
  deleteTuneUpVisitEntitlements?: Maybe<TuneUpVisitEntitlementsMutationResponse>;
  /** delete single row from the table: "tune_up_visit_entitlements" */
  deleteTuneUpVisitEntitlementsByPk?: Maybe<TuneUpVisitEntitlements>;
  /** delete data from the table: "user_business_units" */
  deleteUserBusinessUnits?: Maybe<UserBusinessUnitsMutationResponse>;
  /** delete single row from the table: "user_business_units" */
  deleteUserBusinessUnitsByPk?: Maybe<UserBusinessUnits>;
  /** delete data from the table: "user_phone_numbers" */
  deleteUserPhoneNumbers?: Maybe<UserPhoneNumbersMutationResponse>;
  /** delete single row from the table: "user_phone_numbers" */
  deleteUserPhoneNumbersByPk?: Maybe<UserPhoneNumbers>;
  /** delete data from the table: "user_settings" */
  deleteUserSettings?: Maybe<UserSettingsMutationResponse>;
  /** delete single row from the table: "user_settings" */
  deleteUserSettingsByPk?: Maybe<UserSettings>;
  /** delete data from the table: "user_wages" */
  deleteUserWages?: Maybe<UserWagesMutationResponse>;
  /** delete single row from the table: "user_wages" */
  deleteUserWagesByPk?: Maybe<UserWages>;
  /** delete data from the table: "users" */
  deleteUsers?: Maybe<UsersMutationResponse>;
  /** delete single row from the table: "users" */
  deleteUsersByPk?: Maybe<Users>;
  /** delete data from the table: "wisetack_loan_records" */
  deleteWisetackLoanRecords?: Maybe<WisetackLoanRecordsMutationResponse>;
  /** delete single row from the table: "wisetack_loan_records" */
  deleteWisetackLoanRecordsByPk?: Maybe<WisetackLoanRecords>;
  /** delete data from the table: "wisetack_loan_statuses" */
  deleteWisetackLoanStatuses?: Maybe<WisetackLoanStatusesMutationResponse>;
  /** delete single row from the table: "wisetack_loan_statuses" */
  deleteWisetackLoanStatusesByPk?: Maybe<WisetackLoanStatuses>;
  /** delete data from the table: "wisetack_prequal_records" */
  deleteWisetackPrequalRecords?: Maybe<WisetackPrequalRecordsMutationResponse>;
  /** delete single row from the table: "wisetack_prequal_records" */
  deleteWisetackPrequalRecordsByPk?: Maybe<WisetackPrequalRecords>;
  /** delete data from the table: "wisetack_webhook_events" */
  deleteWisetackWebhookEvents?: Maybe<WisetackWebhookEventsMutationResponse>;
  /** delete single row from the table: "wisetack_webhook_events" */
  deleteWisetackWebhookEventsByPk?: Maybe<WisetackWebhookEvents>;
  /** insert data into the table: "acc_cart_item_type_accounts_config" */
  insertAccCartItemTypeAccountsConfig?: Maybe<AccCartItemTypeAccountsConfigMutationResponse>;
  /** insert a single row into the table: "acc_cart_item_type_accounts_config" */
  insertAccCartItemTypeAccountsConfigOne?: Maybe<AccCartItemTypeAccountsConfig>;
  /** insert data into the table: "acc_company_config" */
  insertAccCompanyConfig?: Maybe<AccCompanyConfigMutationResponse>;
  /** insert a single row into the table: "acc_company_config" */
  insertAccCompanyConfigOne?: Maybe<AccCompanyConfig>;
  /** insert data into the table: "acc_payout_accounts_config" */
  insertAccPayoutAccountsConfig?: Maybe<AccPayoutAccountsConfigMutationResponse>;
  /** insert a single row into the table: "acc_payout_accounts_config" */
  insertAccPayoutAccountsConfigOne?: Maybe<AccPayoutAccountsConfig>;
  /** insert data into the table: "acc_qbd_conductor_config" */
  insertAccQbdConductorConfig?: Maybe<AccQbdConductorConfigMutationResponse>;
  /** insert a single row into the table: "acc_qbd_conductor_config" */
  insertAccQbdConductorConfigOne?: Maybe<AccQbdConductorConfig>;
  /** insert data into the table: "acc_qbd_conductor_uptime" */
  insertAccQbdConductorUptime?: Maybe<AccQbdConductorUptimeMutationResponse>;
  /** insert a single row into the table: "acc_qbd_conductor_uptime" */
  insertAccQbdConductorUptimeOne?: Maybe<AccQbdConductorUptime>;
  /** insert data into the table: "acc_sync_info" */
  insertAccSyncInfo?: Maybe<AccSyncInfoMutationResponse>;
  /** insert a single row into the table: "acc_sync_info" */
  insertAccSyncInfoOne?: Maybe<AccSyncInfo>;
  /** insert data into the table: "acc_sync_queue_items" */
  insertAccSyncQueueItems?: Maybe<AccSyncQueueItemsMutationResponse>;
  /** insert a single row into the table: "acc_sync_queue_items" */
  insertAccSyncQueueItemsOne?: Maybe<AccSyncQueueItems>;
  /** insert data into the table: "account_contacts" */
  insertAccountContacts?: Maybe<AccountContactsMutationResponse>;
  /** insert a single row into the table: "account_contacts" */
  insertAccountContactsOne?: Maybe<AccountContacts>;
  /** insert data into the table: "account_locations" */
  insertAccountLocations?: Maybe<AccountLocationsMutationResponse>;
  /** insert a single row into the table: "account_locations" */
  insertAccountLocationsOne?: Maybe<AccountLocations>;
  /** insert data into the table: "account_reminders" */
  insertAccountReminders?: Maybe<AccountRemindersMutationResponse>;
  /** insert a single row into the table: "account_reminders" */
  insertAccountRemindersOne?: Maybe<AccountReminders>;
  /** insert data into the table: "account_statement_events" */
  insertAccountStatementEvents?: Maybe<AccountStatementEventsMutationResponse>;
  /** insert a single row into the table: "account_statement_events" */
  insertAccountStatementEventsOne?: Maybe<AccountStatementEvents>;
  /** insert data into the table: "account_tags" */
  insertAccountTags?: Maybe<AccountTagsMutationResponse>;
  /** insert a single row into the table: "account_tags" */
  insertAccountTagsOne?: Maybe<AccountTags>;
  /** insert data into the table: "account_types" */
  insertAccountTypes?: Maybe<AccountTypesMutationResponse>;
  /** insert a single row into the table: "account_types" */
  insertAccountTypesOne?: Maybe<AccountTypes>;
  /** insert data into the table: "accounts" */
  insertAccounts?: Maybe<AccountsMutationResponse>;
  /** insert a single row into the table: "accounts" */
  insertAccountsOne?: Maybe<Accounts>;
  /** insert data into the table: "accounts_viewed_by_user" */
  insertAccountsViewedByUser?: Maybe<AccountsViewedByUserMutationResponse>;
  /** insert a single row into the table: "accounts_viewed_by_user" */
  insertAccountsViewedByUserOne?: Maybe<AccountsViewedByUser>;
  /** insert data into the table: "activity_items" */
  insertActivityItems?: Maybe<ActivityItemsMutationResponse>;
  /** insert a single row into the table: "activity_items" */
  insertActivityItemsOne?: Maybe<ActivityItems>;
  /** insert data into the table: "addresses" */
  insertAddresses?: Maybe<AddressesMutationResponse>;
  /** insert a single row into the table: "addresses" */
  insertAddressesOne?: Maybe<Addresses>;
  /** insert data into the table: "appointment_checklist_association_rules" */
  insertAppointmentChecklistAssociationRules?: Maybe<AppointmentChecklistAssociationRulesMutationResponse>;
  /** insert a single row into the table: "appointment_checklist_association_rules" */
  insertAppointmentChecklistAssociationRulesOne?: Maybe<AppointmentChecklistAssociationRules>;
  /** insert data into the table: "appointment_checklist_instances" */
  insertAppointmentChecklistInstances?: Maybe<AppointmentChecklistInstancesMutationResponse>;
  /** insert a single row into the table: "appointment_checklist_instances" */
  insertAppointmentChecklistInstancesOne?: Maybe<AppointmentChecklistInstances>;
  /** insert data into the table: "appointment_checklists" */
  insertAppointmentChecklists?: Maybe<AppointmentChecklistsMutationResponse>;
  /** insert a single row into the table: "appointment_checklists" */
  insertAppointmentChecklistsOne?: Maybe<AppointmentChecklists>;
  /** insert data into the table: "assistant_integrated_phones" */
  insertAssistantIntegratedPhones?: Maybe<AssistantIntegratedPhonesMutationResponse>;
  /** insert a single row into the table: "assistant_integrated_phones" */
  insertAssistantIntegratedPhonesOne?: Maybe<AssistantIntegratedPhones>;
  /** insert data into the table: "assistant_phone_settings" */
  insertAssistantPhoneSettings?: Maybe<AssistantPhoneSettingsMutationResponse>;
  /** insert a single row into the table: "assistant_phone_settings" */
  insertAssistantPhoneSettingsOne?: Maybe<AssistantPhoneSettings>;
  /** insert data into the table: "assistants" */
  insertAssistants?: Maybe<AssistantsMutationResponse>;
  /** insert a single row into the table: "assistants" */
  insertAssistantsOne?: Maybe<Assistants>;
  /** insert data into the table: "billing_profile_hidden_payment_methods" */
  insertBillingProfileHiddenPaymentMethods?: Maybe<BillingProfileHiddenPaymentMethodsMutationResponse>;
  /** insert a single row into the table: "billing_profile_hidden_payment_methods" */
  insertBillingProfileHiddenPaymentMethodsOne?: Maybe<BillingProfileHiddenPaymentMethods>;
  /** insert data into the table: "billing_profiles" */
  insertBillingProfiles?: Maybe<BillingProfilesMutationResponse>;
  /** insert a single row into the table: "billing_profiles" */
  insertBillingProfilesOne?: Maybe<BillingProfiles>;
  /** insert data into the table: "business_events" */
  insertBusinessEvents?: Maybe<BusinessEventsMutationResponse>;
  /** insert a single row into the table: "business_events" */
  insertBusinessEventsOne?: Maybe<BusinessEvents>;
  /** insert data into the table: "business_unit_target_metrics" */
  insertBusinessUnitTargetMetrics?: Maybe<BusinessUnitTargetMetricsMutationResponse>;
  /** insert a single row into the table: "business_unit_target_metrics" */
  insertBusinessUnitTargetMetricsOne?: Maybe<BusinessUnitTargetMetrics>;
  /** insert data into the table: "business_units" */
  insertBusinessUnits?: Maybe<BusinessUnitsMutationResponse>;
  /** insert a single row into the table: "business_units" */
  insertBusinessUnitsOne?: Maybe<BusinessUnits>;
  /** insert data into the table: "canonical_lead_sources" */
  insertCanonicalLeadSources?: Maybe<CanonicalLeadSourcesMutationResponse>;
  /** insert a single row into the table: "canonical_lead_sources" */
  insertCanonicalLeadSourcesOne?: Maybe<CanonicalLeadSources>;
  /** insert data into the table: "cart_item_job_cost_links" */
  insertCartItemJobCostLinks?: Maybe<CartItemJobCostLinksMutationResponse>;
  /** insert a single row into the table: "cart_item_job_cost_links" */
  insertCartItemJobCostLinksOne?: Maybe<CartItemJobCostLinks>;
  /** insert data into the table: "cart_items" */
  insertCartItems?: Maybe<CartItemsMutationResponse>;
  /** insert a single row into the table: "cart_items" */
  insertCartItemsOne?: Maybe<CartItems>;
  /** insert data into the table: "checklist_items" */
  insertChecklistItems?: Maybe<ChecklistItemsMutationResponse>;
  /** insert a single row into the table: "checklist_items" */
  insertChecklistItemsOne?: Maybe<ChecklistItems>;
  /** insert data into the table: "companies" */
  insertCompanies?: Maybe<CompaniesMutationResponse>;
  /** insert a single row into the table: "companies" */
  insertCompaniesOne?: Maybe<Companies>;
  /** insert data into the table: "company_appointment_arrival_windows" */
  insertCompanyAppointmentArrivalWindows?: Maybe<CompanyAppointmentArrivalWindowsMutationResponse>;
  /** insert a single row into the table: "company_appointment_arrival_windows" */
  insertCompanyAppointmentArrivalWindowsOne?: Maybe<CompanyAppointmentArrivalWindows>;
  /** insert data into the table: "company_commission_config" */
  insertCompanyCommissionConfig?: Maybe<CompanyCommissionConfigMutationResponse>;
  /** insert a single row into the table: "company_commission_config" */
  insertCompanyCommissionConfigOne?: Maybe<CompanyCommissionConfig>;
  /** insert data into the table: "company_config" */
  insertCompanyConfig?: Maybe<CompanyConfigMutationResponse>;
  /** insert a single row into the table: "company_config" */
  insertCompanyConfigOne?: Maybe<CompanyConfig>;
  /** insert data into the table: "company_drip_marketing_config" */
  insertCompanyDripMarketingConfig?: Maybe<CompanyDripMarketingConfigMutationResponse>;
  /** insert a single row into the table: "company_drip_marketing_config" */
  insertCompanyDripMarketingConfigOne?: Maybe<CompanyDripMarketingConfig>;
  /** insert data into the table: "company_lead_source_links" */
  insertCompanyLeadSourceLinks?: Maybe<CompanyLeadSourceLinksMutationResponse>;
  /** insert a single row into the table: "company_lead_source_links" */
  insertCompanyLeadSourceLinksOne?: Maybe<CompanyLeadSourceLinks>;
  /** insert data into the table: "company_lead_sources" */
  insertCompanyLeadSources?: Maybe<CompanyLeadSourcesMutationResponse>;
  /** insert a single row into the table: "company_lead_sources" */
  insertCompanyLeadSourcesOne?: Maybe<CompanyLeadSources>;
  /** insert data into the table: "company_notification_settings" */
  insertCompanyNotificationSettings?: Maybe<CompanyNotificationSettingsMutationResponse>;
  /** insert a single row into the table: "company_notification_settings" */
  insertCompanyNotificationSettingsOne?: Maybe<CompanyNotificationSettings>;
  /** insert data into the table: "company_pricing_tier_config" */
  insertCompanyPricingTierConfig?: Maybe<CompanyPricingTierConfigMutationResponse>;
  /** insert a single row into the table: "company_pricing_tier_config" */
  insertCompanyPricingTierConfigOne?: Maybe<CompanyPricingTierConfig>;
  /** insert data into the table: "company_roles" */
  insertCompanyRoles?: Maybe<CompanyRolesMutationResponse>;
  /** insert a single row into the table: "company_roles" */
  insertCompanyRolesOne?: Maybe<CompanyRoles>;
  /** insert data into the table: "company_tax_configurations" */
  insertCompanyTaxConfigurations?: Maybe<CompanyTaxConfigurationsMutationResponse>;
  /** insert a single row into the table: "company_tax_configurations" */
  insertCompanyTaxConfigurationsOne?: Maybe<CompanyTaxConfigurations>;
  /** insert data into the table: "company_users" */
  insertCompanyUsers?: Maybe<CompanyUsersMutationResponse>;
  /** insert a single row into the table: "company_users" */
  insertCompanyUsersOne?: Maybe<CompanyUsers>;
  /** insert data into the table: "company_working_display_hours" */
  insertCompanyWorkingDisplayHours?: Maybe<CompanyWorkingDisplayHoursMutationResponse>;
  /** insert a single row into the table: "company_working_display_hours" */
  insertCompanyWorkingDisplayHoursOne?: Maybe<CompanyWorkingDisplayHours>;
  /** insert data into the table: "contacts" */
  insertContacts?: Maybe<ContactsMutationResponse>;
  /** insert a single row into the table: "contacts" */
  insertContactsOne?: Maybe<Contacts>;
  /** insert data into the table: "current_company_tax_configurations_view" */
  insertCurrentCompanyTaxConfigurationsView?: Maybe<CurrentCompanyTaxConfigurationsViewMutationResponse>;
  /** insert a single row into the table: "current_company_tax_configurations_view" */
  insertCurrentCompanyTaxConfigurationsViewOne?: Maybe<CurrentCompanyTaxConfigurationsView>;
  /** insert data into the table: "current_user_business_units_view" */
  insertCurrentUserBusinessUnitsView?: Maybe<CurrentUserBusinessUnitsViewMutationResponse>;
  /** insert a single row into the table: "current_user_business_units_view" */
  insertCurrentUserBusinessUnitsViewOne?: Maybe<CurrentUserBusinessUnitsView>;
  /** insert data into the table: "customer_communication_templates" */
  insertCustomerCommunicationTemplates?: Maybe<CustomerCommunicationTemplatesMutationResponse>;
  /** insert a single row into the table: "customer_communication_templates" */
  insertCustomerCommunicationTemplatesOne?: Maybe<CustomerCommunicationTemplates>;
  /** insert data into the table: "discount_entitlements" */
  insertDiscountEntitlements?: Maybe<DiscountEntitlementsMutationResponse>;
  /** insert a single row into the table: "discount_entitlements" */
  insertDiscountEntitlementsOne?: Maybe<DiscountEntitlements>;
  /** insert data into the table: "display_id_counters" */
  insertDisplayIdCounters?: Maybe<DisplayIdCountersMutationResponse>;
  /** insert a single row into the table: "display_id_counters" */
  insertDisplayIdCountersOne?: Maybe<DisplayIdCounters>;
  /** insert data into the table: "drip_marketing_emails" */
  insertDripMarketingEmails?: Maybe<DripMarketingEmailsMutationResponse>;
  /** insert a single row into the table: "drip_marketing_emails" */
  insertDripMarketingEmailsOne?: Maybe<DripMarketingEmails>;
  /** insert data into the table: "email_addresses" */
  insertEmailAddresses?: Maybe<EmailAddressesMutationResponse>;
  /** insert a single row into the table: "email_addresses" */
  insertEmailAddressesOne?: Maybe<EmailAddresses>;
  /** insert data into the table: "entitlements" */
  insertEntitlements?: Maybe<EntitlementsMutationResponse>;
  /** insert a single row into the table: "entitlements" */
  insertEntitlementsOne?: Maybe<Entitlements>;
  /** insert data into the table: "equipment_type_links" */
  insertEquipmentTypeLinks?: Maybe<EquipmentTypeLinksMutationResponse>;
  /** insert a single row into the table: "equipment_type_links" */
  insertEquipmentTypeLinksOne?: Maybe<EquipmentTypeLinks>;
  /** insert data into the table: "equipment_types" */
  insertEquipmentTypes?: Maybe<EquipmentTypesMutationResponse>;
  /** insert a single row into the table: "equipment_types" */
  insertEquipmentTypesOne?: Maybe<EquipmentTypes>;
  /** insert data into the table: "estimate_invoices" */
  insertEstimateInvoices?: Maybe<EstimateInvoicesMutationResponse>;
  /** insert a single row into the table: "estimate_invoices" */
  insertEstimateInvoicesOne?: Maybe<EstimateInvoices>;
  /** insert data into the table: "estimate_option_cart_items" */
  insertEstimateOptionCartItems?: Maybe<EstimateOptionCartItemsMutationResponse>;
  /** insert a single row into the table: "estimate_option_cart_items" */
  insertEstimateOptionCartItemsOne?: Maybe<EstimateOptionCartItems>;
  /** insert data into the table: "estimate_option_discounts" */
  insertEstimateOptionDiscounts?: Maybe<EstimateOptionDiscountsMutationResponse>;
  /** insert a single row into the table: "estimate_option_discounts" */
  insertEstimateOptionDiscountsOne?: Maybe<EstimateOptionDiscounts>;
  /** insert data into the table: "estimate_options" */
  insertEstimateOptions?: Maybe<EstimateOptionsMutationResponse>;
  /** insert a single row into the table: "estimate_options" */
  insertEstimateOptionsOne?: Maybe<EstimateOptions>;
  /** insert data into the table: "estimate_photos" */
  insertEstimatePhotos?: Maybe<EstimatePhotosMutationResponse>;
  /** insert a single row into the table: "estimate_photos" */
  insertEstimatePhotosOne?: Maybe<EstimatePhotos>;
  /** insert data into the table: "estimate_templates" */
  insertEstimateTemplates?: Maybe<EstimateTemplatesMutationResponse>;
  /** insert a single row into the table: "estimate_templates" */
  insertEstimateTemplatesOne?: Maybe<EstimateTemplates>;
  /** insert data into the table: "estimates" */
  insertEstimates?: Maybe<EstimatesMutationResponse>;
  /** insert a single row into the table: "estimates" */
  insertEstimatesOne?: Maybe<Estimates>;
  /** insert data into the table: "estimates_queryable" */
  insertEstimatesQueryable?: Maybe<EstimatesQueryableMutationResponse>;
  /** insert a single row into the table: "estimates_queryable" */
  insertEstimatesQueryableOne?: Maybe<EstimatesQueryable>;
  /** insert data into the table: "event_store" */
  insertEventStore?: Maybe<EventStoreMutationResponse>;
  /** insert a single row into the table: "event_store" */
  insertEventStoreOne?: Maybe<EventStore>;
  /** insert data into the table: "favorite_pricebook_items" */
  insertFavoritePricebookItems?: Maybe<FavoritePricebookItemsMutationResponse>;
  /** insert a single row into the table: "favorite_pricebook_items" */
  insertFavoritePricebookItemsOne?: Maybe<FavoritePricebookItems>;
  /** insert data into the table: "file_links" */
  insertFileLinks?: Maybe<FileLinksMutationResponse>;
  /** insert a single row into the table: "file_links" */
  insertFileLinksOne?: Maybe<FileLinks>;
  /** insert data into the table: "files" */
  insertFiles?: Maybe<FilesMutationResponse>;
  /** insert a single row into the table: "files" */
  insertFilesOne?: Maybe<Files>;
  /** insert data into the table: "installed_equipment" */
  insertInstalledEquipment?: Maybe<InstalledEquipmentMutationResponse>;
  /** insert a single row into the table: "installed_equipment" */
  insertInstalledEquipmentOne?: Maybe<InstalledEquipment>;
  /** insert data into the table: "installed_hvac_systems" */
  insertInstalledHvacSystems?: Maybe<InstalledHvacSystemsMutationResponse>;
  /** insert a single row into the table: "installed_hvac_systems" */
  insertInstalledHvacSystemsOne?: Maybe<InstalledHvacSystems>;
  /** insert data into the table: "instant_booking_weekly_schedule_entries" */
  insertInstantBookingWeeklyScheduleEntries?: Maybe<InstantBookingWeeklyScheduleEntriesMutationResponse>;
  /** insert a single row into the table: "instant_booking_weekly_schedule_entries" */
  insertInstantBookingWeeklyScheduleEntriesOne?: Maybe<InstantBookingWeeklyScheduleEntries>;
  /** insert data into the table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
  insertInstantBookingWeeklyScheduleEntryBookableArrivalWindows?: Maybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMutationResponse>;
  /** insert a single row into the table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
  insertInstantBookingWeeklyScheduleEntryBookableArrivalWindowsOne?: Maybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindows>;
  /** insert data into the table: "integrated_channels" */
  insertIntegratedChannels?: Maybe<IntegratedChannelsMutationResponse>;
  /** insert a single row into the table: "integrated_channels" */
  insertIntegratedChannelsOne?: Maybe<IntegratedChannels>;
  /** insert data into the table: "integrated_message_statuses" */
  insertIntegratedMessageStatuses?: Maybe<IntegratedMessageStatusesMutationResponse>;
  /** insert a single row into the table: "integrated_message_statuses" */
  insertIntegratedMessageStatusesOne?: Maybe<IntegratedMessageStatuses>;
  /** insert data into the table: "integrated_message_twilio_raw_webhook_events" */
  insertIntegratedMessageTwilioRawWebhookEvents?: Maybe<IntegratedMessageTwilioRawWebhookEventsMutationResponse>;
  /** insert a single row into the table: "integrated_message_twilio_raw_webhook_events" */
  insertIntegratedMessageTwilioRawWebhookEventsOne?: Maybe<IntegratedMessageTwilioRawWebhookEvents>;
  /** insert data into the table: "integrated_messages" */
  insertIntegratedMessages?: Maybe<IntegratedMessagesMutationResponse>;
  /** insert a single row into the table: "integrated_messages" */
  insertIntegratedMessagesOne?: Maybe<IntegratedMessages>;
  /** insert data into the table: "integrated_phone_call_dismissals" */
  insertIntegratedPhoneCallDismissals?: Maybe<IntegratedPhoneCallDismissalsMutationResponse>;
  /** insert a single row into the table: "integrated_phone_call_dismissals" */
  insertIntegratedPhoneCallDismissalsOne?: Maybe<IntegratedPhoneCallDismissals>;
  /** insert data into the table: "integrated_phone_call_jobs" */
  insertIntegratedPhoneCallJobs?: Maybe<IntegratedPhoneCallJobsMutationResponse>;
  /** insert a single row into the table: "integrated_phone_call_jobs" */
  insertIntegratedPhoneCallJobsOne?: Maybe<IntegratedPhoneCallJobs>;
  /** insert data into the table: "integrated_phone_call_recording" */
  insertIntegratedPhoneCallRecording?: Maybe<IntegratedPhoneCallRecordingMutationResponse>;
  /** insert a single row into the table: "integrated_phone_call_recording" */
  insertIntegratedPhoneCallRecordingOne?: Maybe<IntegratedPhoneCallRecording>;
  /** insert data into the table: "integrated_phone_call_status_types" */
  insertIntegratedPhoneCallStatusTypes?: Maybe<IntegratedPhoneCallStatusTypesMutationResponse>;
  /** insert a single row into the table: "integrated_phone_call_status_types" */
  insertIntegratedPhoneCallStatusTypesOne?: Maybe<IntegratedPhoneCallStatusTypes>;
  /** insert data into the table: "integrated_phone_call_statuses" */
  insertIntegratedPhoneCallStatuses?: Maybe<IntegratedPhoneCallStatusesMutationResponse>;
  /** insert a single row into the table: "integrated_phone_call_statuses" */
  insertIntegratedPhoneCallStatusesOne?: Maybe<IntegratedPhoneCallStatuses>;
  /** insert data into the table: "integrated_phone_calls" */
  insertIntegratedPhoneCalls?: Maybe<IntegratedPhoneCallsMutationResponse>;
  /** insert a single row into the table: "integrated_phone_calls" */
  insertIntegratedPhoneCallsOne?: Maybe<IntegratedPhoneCalls>;
  /** insert data into the table: "integrated_phone_company_config" */
  insertIntegratedPhoneCompanyConfig?: Maybe<IntegratedPhoneCompanyConfigMutationResponse>;
  /** insert a single row into the table: "integrated_phone_company_config" */
  insertIntegratedPhoneCompanyConfigOne?: Maybe<IntegratedPhoneCompanyConfig>;
  /** insert data into the table: "integrated_phone_missed_call_dismissals" */
  insertIntegratedPhoneMissedCallDismissals?: Maybe<IntegratedPhoneMissedCallDismissalsMutationResponse>;
  /** insert a single row into the table: "integrated_phone_missed_call_dismissals" */
  insertIntegratedPhoneMissedCallDismissalsOne?: Maybe<IntegratedPhoneMissedCallDismissals>;
  /** insert data into the table: "integrated_phone_missed_calls" */
  insertIntegratedPhoneMissedCalls?: Maybe<IntegratedPhoneMissedCallsMutationResponse>;
  /** insert a single row into the table: "integrated_phone_missed_calls" */
  insertIntegratedPhoneMissedCallsOne?: Maybe<IntegratedPhoneMissedCalls>;
  /** insert data into the table: "integrated_phone_twilio_raw_webhook_events" */
  insertIntegratedPhoneTwilioRawWebhookEvents?: Maybe<IntegratedPhoneTwilioRawWebhookEventsMutationResponse>;
  /** insert a single row into the table: "integrated_phone_twilio_raw_webhook_events" */
  insertIntegratedPhoneTwilioRawWebhookEventsOne?: Maybe<IntegratedPhoneTwilioRawWebhookEvents>;
  /** insert data into the table: "integrated_phone_users" */
  insertIntegratedPhoneUsers?: Maybe<IntegratedPhoneUsersMutationResponse>;
  /** insert a single row into the table: "integrated_phone_users" */
  insertIntegratedPhoneUsersOne?: Maybe<IntegratedPhoneUsers>;
  /** insert data into the table: "integrated_phone_voicemail_dismissals" */
  insertIntegratedPhoneVoicemailDismissals?: Maybe<IntegratedPhoneVoicemailDismissalsMutationResponse>;
  /** insert a single row into the table: "integrated_phone_voicemail_dismissals" */
  insertIntegratedPhoneVoicemailDismissalsOne?: Maybe<IntegratedPhoneVoicemailDismissals>;
  /** insert data into the table: "integrated_phone_voicemails" */
  insertIntegratedPhoneVoicemails?: Maybe<IntegratedPhoneVoicemailsMutationResponse>;
  /** insert a single row into the table: "integrated_phone_voicemails" */
  insertIntegratedPhoneVoicemailsOne?: Maybe<IntegratedPhoneVoicemails>;
  /** insert data into the table: "integrated_phones" */
  insertIntegratedPhones?: Maybe<IntegratedPhonesMutationResponse>;
  /** insert a single row into the table: "integrated_phones" */
  insertIntegratedPhonesOne?: Maybe<IntegratedPhones>;
  /** insert data into the table: "internal_notifications" */
  insertInternalNotifications?: Maybe<InternalNotificationsMutationResponse>;
  /** insert a single row into the table: "internal_notifications" */
  insertInternalNotificationsOne?: Maybe<InternalNotifications>;
  /** insert data into the table: "invoice_cart_item_bundle_items" */
  insertInvoiceCartItemBundleItems?: Maybe<InvoiceCartItemBundleItemsMutationResponse>;
  /** insert a single row into the table: "invoice_cart_item_bundle_items" */
  insertInvoiceCartItemBundleItemsOne?: Maybe<InvoiceCartItemBundleItems>;
  /** insert data into the table: "invoice_cart_item_bundle_job_cost_links" */
  insertInvoiceCartItemBundleJobCostLinks?: Maybe<InvoiceCartItemBundleJobCostLinksMutationResponse>;
  /** insert a single row into the table: "invoice_cart_item_bundle_job_cost_links" */
  insertInvoiceCartItemBundleJobCostLinksOne?: Maybe<InvoiceCartItemBundleJobCostLinks>;
  /** insert data into the table: "invoice_cart_items" */
  insertInvoiceCartItems?: Maybe<InvoiceCartItemsMutationResponse>;
  /** insert a single row into the table: "invoice_cart_items" */
  insertInvoiceCartItemsOne?: Maybe<InvoiceCartItems>;
  /** insert data into the table: "invoice_discounts" */
  insertInvoiceDiscounts?: Maybe<InvoiceDiscountsMutationResponse>;
  /** insert a single row into the table: "invoice_discounts" */
  insertInvoiceDiscountsOne?: Maybe<InvoiceDiscounts>;
  /** insert data into the table: "invoice_events" */
  insertInvoiceEvents?: Maybe<InvoiceEventsMutationResponse>;
  /** insert a single row into the table: "invoice_events" */
  insertInvoiceEventsOne?: Maybe<InvoiceEvents>;
  /** insert data into the table: "invoice_payments" */
  insertInvoicePayments?: Maybe<InvoicePaymentsMutationResponse>;
  /** insert a single row into the table: "invoice_payments" */
  insertInvoicePaymentsOne?: Maybe<InvoicePayments>;
  /** insert data into the table: "invoice_reminder_data" */
  insertInvoiceReminderData?: Maybe<InvoiceReminderDataMutationResponse>;
  /** insert a single row into the table: "invoice_reminder_data" */
  insertInvoiceReminderDataOne?: Maybe<InvoiceReminderData>;
  /** insert data into the table: "invoice_template_cart_items" */
  insertInvoiceTemplateCartItems?: Maybe<InvoiceTemplateCartItemsMutationResponse>;
  /** insert a single row into the table: "invoice_template_cart_items" */
  insertInvoiceTemplateCartItemsOne?: Maybe<InvoiceTemplateCartItems>;
  /** insert data into the table: "invoice_templates" */
  insertInvoiceTemplates?: Maybe<InvoiceTemplatesMutationResponse>;
  /** insert a single row into the table: "invoice_templates" */
  insertInvoiceTemplatesOne?: Maybe<InvoiceTemplates>;
  /** insert data into the table: "invoices" */
  insertInvoices?: Maybe<InvoicesMutationResponse>;
  /** insert a single row into the table: "invoices" */
  insertInvoicesOne?: Maybe<Invoices>;
  /** insert data into the table: "invoices_queryable" */
  insertInvoicesQueryable?: Maybe<InvoicesQueryableMutationResponse>;
  /** insert a single row into the table: "invoices_queryable" */
  insertInvoicesQueryableOne?: Maybe<InvoicesQueryable>;
  /** insert data into the table: "job_appointment_assignment_status_types" */
  insertJobAppointmentAssignmentStatusTypes?: Maybe<JobAppointmentAssignmentStatusTypesMutationResponse>;
  /** insert a single row into the table: "job_appointment_assignment_status_types" */
  insertJobAppointmentAssignmentStatusTypesOne?: Maybe<JobAppointmentAssignmentStatusTypes>;
  /** insert data into the table: "job_appointment_assignment_statuses" */
  insertJobAppointmentAssignmentStatuses?: Maybe<JobAppointmentAssignmentStatusesMutationResponse>;
  /** insert a single row into the table: "job_appointment_assignment_statuses" */
  insertJobAppointmentAssignmentStatusesOne?: Maybe<JobAppointmentAssignmentStatuses>;
  /** insert data into the table: "job_appointment_assignments" */
  insertJobAppointmentAssignments?: Maybe<JobAppointmentAssignmentsMutationResponse>;
  /** insert a single row into the table: "job_appointment_assignments" */
  insertJobAppointmentAssignmentsOne?: Maybe<JobAppointmentAssignments>;
  /** insert data into the table: "job_appointment_cancellation_statuses" */
  insertJobAppointmentCancellationStatuses?: Maybe<JobAppointmentCancellationStatusesMutationResponse>;
  /** insert a single row into the table: "job_appointment_cancellation_statuses" */
  insertJobAppointmentCancellationStatusesOne?: Maybe<JobAppointmentCancellationStatuses>;
  /** insert data into the table: "job_appointment_confirmation_statuses" */
  insertJobAppointmentConfirmationStatuses?: Maybe<JobAppointmentConfirmationStatusesMutationResponse>;
  /** insert a single row into the table: "job_appointment_confirmation_statuses" */
  insertJobAppointmentConfirmationStatusesOne?: Maybe<JobAppointmentConfirmationStatuses>;
  /** insert data into the table: "job_appointment_invoices" */
  insertJobAppointmentInvoices?: Maybe<JobAppointmentInvoicesMutationResponse>;
  /** insert a single row into the table: "job_appointment_invoices" */
  insertJobAppointmentInvoicesOne?: Maybe<JobAppointmentInvoices>;
  /** insert data into the table: "job_appointments" */
  insertJobAppointments?: Maybe<JobAppointmentsMutationResponse>;
  /** insert a single row into the table: "job_appointments" */
  insertJobAppointmentsOne?: Maybe<JobAppointments>;
  /** insert data into the table: "job_cost_items" */
  insertJobCostItems?: Maybe<JobCostItemsMutationResponse>;
  /** insert a single row into the table: "job_cost_items" */
  insertJobCostItemsOne?: Maybe<JobCostItems>;
  /** insert data into the table: "job_cost_misc_categories" */
  insertJobCostMiscCategories?: Maybe<JobCostMiscCategoriesMutationResponse>;
  /** insert a single row into the table: "job_cost_misc_categories" */
  insertJobCostMiscCategoriesOne?: Maybe<JobCostMiscCategories>;
  /** insert data into the table: "job_costing_config" */
  insertJobCostingConfig?: Maybe<JobCostingConfigMutationResponse>;
  /** insert a single row into the table: "job_costing_config" */
  insertJobCostingConfigOne?: Maybe<JobCostingConfig>;
  /** insert data into the table: "job_invoices" */
  insertJobInvoices?: Maybe<JobInvoicesMutationResponse>;
  /** insert a single row into the table: "job_invoices" */
  insertJobInvoicesOne?: Maybe<JobInvoices>;
  /** insert data into the table: "job_leads" */
  insertJobLeads?: Maybe<JobLeadsMutationResponse>;
  /** insert a single row into the table: "job_leads" */
  insertJobLeadsOne?: Maybe<JobLeads>;
  /** insert data into the table: "job_lifecycle_statuses" */
  insertJobLifecycleStatuses?: Maybe<JobLifecycleStatusesMutationResponse>;
  /** insert a single row into the table: "job_lifecycle_statuses" */
  insertJobLifecycleStatusesOne?: Maybe<JobLifecycleStatuses>;
  /** insert data into the table: "job_lifecycle_types" */
  insertJobLifecycleTypes?: Maybe<JobLifecycleTypesMutationResponse>;
  /** insert a single row into the table: "job_lifecycle_types" */
  insertJobLifecycleTypesOne?: Maybe<JobLifecycleTypes>;
  /** insert data into the table: "job_lifecycle_views" */
  insertJobLifecycleViews?: Maybe<JobLifecycleViewsMutationResponse>;
  /** insert a single row into the table: "job_lifecycle_views" */
  insertJobLifecycleViewsOne?: Maybe<JobLifecycleViews>;
  /** insert data into the table: "job_lifecycles" */
  insertJobLifecycles?: Maybe<JobLifecyclesMutationResponse>;
  /** insert a single row into the table: "job_lifecycles" */
  insertJobLifecyclesOne?: Maybe<JobLifecycles>;
  /** insert data into the table: "job_requests_company_config" */
  insertJobRequestsCompanyConfig?: Maybe<JobRequestsCompanyConfigMutationResponse>;
  /** insert a single row into the table: "job_requests_company_config" */
  insertJobRequestsCompanyConfigOne?: Maybe<JobRequestsCompanyConfig>;
  /** insert data into the table: "job_tags" */
  insertJobTags?: Maybe<JobTagsMutationResponse>;
  /** insert a single row into the table: "job_tags" */
  insertJobTagsOne?: Maybe<JobTags>;
  /** insert data into the table: "job_team_members" */
  insertJobTeamMembers?: Maybe<JobTeamMembersMutationResponse>;
  /** insert a single row into the table: "job_team_members" */
  insertJobTeamMembersOne?: Maybe<JobTeamMembers>;
  /** insert data into the table: "job_technician_earned_revenue_attributions" */
  insertJobTechnicianEarnedRevenueAttributions?: Maybe<JobTechnicianEarnedRevenueAttributionsMutationResponse>;
  /** insert a single row into the table: "job_technician_earned_revenue_attributions" */
  insertJobTechnicianEarnedRevenueAttributionsOne?: Maybe<JobTechnicianEarnedRevenueAttributions>;
  /** insert data into the table: "job_technician_sold_revenue_attributions" */
  insertJobTechnicianSoldRevenueAttributions?: Maybe<JobTechnicianSoldRevenueAttributionsMutationResponse>;
  /** insert a single row into the table: "job_technician_sold_revenue_attributions" */
  insertJobTechnicianSoldRevenueAttributionsOne?: Maybe<JobTechnicianSoldRevenueAttributions>;
  /** insert data into the table: "job_type_change_reasons" */
  insertJobTypeChangeReasons?: Maybe<JobTypeChangeReasonsMutationResponse>;
  /** insert a single row into the table: "job_type_change_reasons" */
  insertJobTypeChangeReasonsOne?: Maybe<JobTypeChangeReasons>;
  /** insert data into the table: "job_types" */
  insertJobTypes?: Maybe<JobTypesMutationResponse>;
  /** insert a single row into the table: "job_types" */
  insertJobTypesOne?: Maybe<JobTypes>;
  /** insert data into the table: "jobs" */
  insertJobs?: Maybe<JobsMutationResponse>;
  /** insert a single row into the table: "jobs" */
  insertJobsOne?: Maybe<Jobs>;
  /** insert data into the table: "jobs_with_linked_job" */
  insertJobsWithLinkedJob?: Maybe<JobsWithLinkedJobMutationResponse>;
  /** insert data into the table: "jobs_with_linked_job_linked_appointment_checklist_instances" */
  insertJobsWithLinkedJobLinkedAppointmentChecklistInstances?: Maybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesMutationResponse>;
  /** insert a single row into the table: "jobs_with_linked_job_linked_appointment_checklist_instances" */
  insertJobsWithLinkedJobLinkedAppointmentChecklistInstancesOne?: Maybe<JobsWithLinkedJobLinkedAppointmentChecklistInstances>;
  /** insert data into the table: "jobs_with_linked_job_linked_estimates" */
  insertJobsWithLinkedJobLinkedEstimates?: Maybe<JobsWithLinkedJobLinkedEstimatesMutationResponse>;
  /** insert a single row into the table: "jobs_with_linked_job_linked_estimates" */
  insertJobsWithLinkedJobLinkedEstimatesOne?: Maybe<JobsWithLinkedJobLinkedEstimates>;
  /** insert a single row into the table: "jobs_with_linked_job" */
  insertJobsWithLinkedJobOne?: Maybe<JobsWithLinkedJob>;
  /** insert data into the table: "location_contacts" */
  insertLocationContacts?: Maybe<LocationContactsMutationResponse>;
  /** insert a single row into the table: "location_contacts" */
  insertLocationContactsOne?: Maybe<LocationContacts>;
  /** insert data into the table: "location_invoices" */
  insertLocationInvoices?: Maybe<LocationInvoicesMutationResponse>;
  /** insert a single row into the table: "location_invoices" */
  insertLocationInvoicesOne?: Maybe<LocationInvoices>;
  /** insert data into the table: "locations" */
  insertLocations?: Maybe<LocationsMutationResponse>;
  /** insert a single row into the table: "locations" */
  insertLocationsOne?: Maybe<Locations>;
  /** insert data into the table: "maintenance_plan_definition_allowed_payment_intervals" */
  insertMaintenancePlanDefinitionAllowedPaymentIntervals?: Maybe<MaintenancePlanDefinitionAllowedPaymentIntervalsMutationResponse>;
  /** insert a single row into the table: "maintenance_plan_definition_allowed_payment_intervals" */
  insertMaintenancePlanDefinitionAllowedPaymentIntervalsOne?: Maybe<MaintenancePlanDefinitionAllowedPaymentIntervals>;
  /** insert data into the table: "maintenance_plan_definition_benefits" */
  insertMaintenancePlanDefinitionBenefits?: Maybe<MaintenancePlanDefinitionBenefitsMutationResponse>;
  /** insert a single row into the table: "maintenance_plan_definition_benefits" */
  insertMaintenancePlanDefinitionBenefitsOne?: Maybe<MaintenancePlanDefinitionBenefits>;
  /** insert data into the table: "maintenance_plan_definition_discounts" */
  insertMaintenancePlanDefinitionDiscounts?: Maybe<MaintenancePlanDefinitionDiscountsMutationResponse>;
  /** insert a single row into the table: "maintenance_plan_definition_discounts" */
  insertMaintenancePlanDefinitionDiscountsOne?: Maybe<MaintenancePlanDefinitionDiscounts>;
  /** insert data into the table: "maintenance_plan_definition_flare" */
  insertMaintenancePlanDefinitionFlare?: Maybe<MaintenancePlanDefinitionFlareMutationResponse>;
  /** insert a single row into the table: "maintenance_plan_definition_flare" */
  insertMaintenancePlanDefinitionFlareOne?: Maybe<MaintenancePlanDefinitionFlare>;
  /** insert data into the table: "maintenance_plan_definition_marketing_info" */
  insertMaintenancePlanDefinitionMarketingInfo?: Maybe<MaintenancePlanDefinitionMarketingInfoMutationResponse>;
  /** insert a single row into the table: "maintenance_plan_definition_marketing_info" */
  insertMaintenancePlanDefinitionMarketingInfoOne?: Maybe<MaintenancePlanDefinitionMarketingInfo>;
  /** insert data into the table: "maintenance_plan_definitions" */
  insertMaintenancePlanDefinitions?: Maybe<MaintenancePlanDefinitionsMutationResponse>;
  /** insert a single row into the table: "maintenance_plan_definitions" */
  insertMaintenancePlanDefinitionsOne?: Maybe<MaintenancePlanDefinitions>;
  /** insert data into the table: "maintenance_plan_equipment_coverage_definitions" */
  insertMaintenancePlanEquipmentCoverageDefinitions?: Maybe<MaintenancePlanEquipmentCoverageDefinitionsMutationResponse>;
  /** insert a single row into the table: "maintenance_plan_equipment_coverage_definitions" */
  insertMaintenancePlanEquipmentCoverageDefinitionsOne?: Maybe<MaintenancePlanEquipmentCoverageDefinitions>;
  /** insert data into the table: "maintenance_plan_equipment_coverage_pricings" */
  insertMaintenancePlanEquipmentCoveragePricings?: Maybe<MaintenancePlanEquipmentCoveragePricingsMutationResponse>;
  /** insert a single row into the table: "maintenance_plan_equipment_coverage_pricings" */
  insertMaintenancePlanEquipmentCoveragePricingsOne?: Maybe<MaintenancePlanEquipmentCoveragePricings>;
  /** insert data into the table: "maintenance_plan_invoices" */
  insertMaintenancePlanInvoices?: Maybe<MaintenancePlanInvoicesMutationResponse>;
  /** insert a single row into the table: "maintenance_plan_invoices" */
  insertMaintenancePlanInvoicesOne?: Maybe<MaintenancePlanInvoices>;
  /** insert data into the table: "maintenance_plan_visit_installed_equipments" */
  insertMaintenancePlanVisitInstalledEquipments?: Maybe<MaintenancePlanVisitInstalledEquipmentsMutationResponse>;
  /** insert a single row into the table: "maintenance_plan_visit_installed_equipments" */
  insertMaintenancePlanVisitInstalledEquipmentsOne?: Maybe<MaintenancePlanVisitInstalledEquipments>;
  /** insert data into the table: "maintenance_plan_visits" */
  insertMaintenancePlanVisits?: Maybe<MaintenancePlanVisitsMutationResponse>;
  /** insert a single row into the table: "maintenance_plan_visits" */
  insertMaintenancePlanVisitsOne?: Maybe<MaintenancePlanVisits>;
  /** insert data into the table: "maintenance_plans_queryable" */
  insertMaintenancePlansQueryable?: Maybe<MaintenancePlansQueryableMutationResponse>;
  /** insert a single row into the table: "maintenance_plans_queryable" */
  insertMaintenancePlansQueryableOne?: Maybe<MaintenancePlansQueryable>;
  /** insert data into the table: "migration_junk" */
  insertMigrationJunk?: Maybe<MigrationJunkMutationResponse>;
  /** insert data into the table: "migration_junk_links" */
  insertMigrationJunkLinks?: Maybe<MigrationJunkLinksMutationResponse>;
  /** insert a single row into the table: "migration_junk_links" */
  insertMigrationJunkLinksOne?: Maybe<MigrationJunkLinks>;
  /** insert a single row into the table: "migration_junk" */
  insertMigrationJunkOne?: Maybe<MigrationJunk>;
  /** insert data into the table: "note_attachments" */
  insertNoteAttachments?: Maybe<NoteAttachmentsMutationResponse>;
  /** insert a single row into the table: "note_attachments" */
  insertNoteAttachmentsOne?: Maybe<NoteAttachments>;
  /** insert data into the table: "note_links" */
  insertNoteLinks?: Maybe<NoteLinksMutationResponse>;
  /** insert a single row into the table: "note_links" */
  insertNoteLinksOne?: Maybe<NoteLinks>;
  /** insert data into the table: "note_tagged_users" */
  insertNoteTaggedUsers?: Maybe<NoteTaggedUsersMutationResponse>;
  /** insert a single row into the table: "note_tagged_users" */
  insertNoteTaggedUsersOne?: Maybe<NoteTaggedUsers>;
  /** insert data into the table: "notes" */
  insertNotes?: Maybe<NotesMutationResponse>;
  /** insert a single row into the table: "notes" */
  insertNotesOne?: Maybe<Notes>;
  /** insert data into the table: "online_booking_company_config" */
  insertOnlineBookingCompanyConfig?: Maybe<OnlineBookingCompanyConfigMutationResponse>;
  /** insert a single row into the table: "online_booking_company_config" */
  insertOnlineBookingCompanyConfigOne?: Maybe<OnlineBookingCompanyConfig>;
  /** insert data into the table: "online_booking_service_area_zip_codes" */
  insertOnlineBookingServiceAreaZipCodes?: Maybe<OnlineBookingServiceAreaZipCodesMutationResponse>;
  /** insert a single row into the table: "online_booking_service_area_zip_codes" */
  insertOnlineBookingServiceAreaZipCodesOne?: Maybe<OnlineBookingServiceAreaZipCodes>;
  /** insert data into the table: "online_booking_service_type_bookable_job_types" */
  insertOnlineBookingServiceTypeBookableJobTypes?: Maybe<OnlineBookingServiceTypeBookableJobTypesMutationResponse>;
  /** insert a single row into the table: "online_booking_service_type_bookable_job_types" */
  insertOnlineBookingServiceTypeBookableJobTypesOne?: Maybe<OnlineBookingServiceTypeBookableJobTypes>;
  /** insert data into the table: "online_booking_service_type_bookable_technicians" */
  insertOnlineBookingServiceTypeBookableTechnicians?: Maybe<OnlineBookingServiceTypeBookableTechniciansMutationResponse>;
  /** insert a single row into the table: "online_booking_service_type_bookable_technicians" */
  insertOnlineBookingServiceTypeBookableTechniciansOne?: Maybe<OnlineBookingServiceTypeBookableTechnicians>;
  /** insert data into the table: "online_booking_service_type_configs" */
  insertOnlineBookingServiceTypeConfigs?: Maybe<OnlineBookingServiceTypeConfigsMutationResponse>;
  /** insert a single row into the table: "online_booking_service_type_configs" */
  insertOnlineBookingServiceTypeConfigsOne?: Maybe<OnlineBookingServiceTypeConfigs>;
  /** insert data into the table: "payment_links" */
  insertPaymentLinks?: Maybe<PaymentLinksMutationResponse>;
  /** insert a single row into the table: "payment_links" */
  insertPaymentLinksOne?: Maybe<PaymentLinks>;
  /** insert data into the table: "payment_method_billing_info" */
  insertPaymentMethodBillingInfo?: Maybe<PaymentMethodBillingInfoMutationResponse>;
  /** insert a single row into the table: "payment_method_billing_info" */
  insertPaymentMethodBillingInfoOne?: Maybe<PaymentMethodBillingInfo>;
  /** insert data into the table: "payment_method_card_metadata" */
  insertPaymentMethodCardMetadata?: Maybe<PaymentMethodCardMetadataMutationResponse>;
  /** insert a single row into the table: "payment_method_card_metadata" */
  insertPaymentMethodCardMetadataOne?: Maybe<PaymentMethodCardMetadata>;
  /** insert data into the table: "payment_method_records" */
  insertPaymentMethodRecords?: Maybe<PaymentMethodRecordsMutationResponse>;
  /** insert a single row into the table: "payment_method_records" */
  insertPaymentMethodRecordsOne?: Maybe<PaymentMethodRecords>;
  /** insert data into the table: "payment_records" */
  insertPaymentRecords?: Maybe<PaymentRecordsMutationResponse>;
  /** insert a single row into the table: "payment_records" */
  insertPaymentRecordsOne?: Maybe<PaymentRecords>;
  /** insert data into the table: "payment_refunds" */
  insertPaymentRefunds?: Maybe<PaymentRefundsMutationResponse>;
  /** insert a single row into the table: "payment_refunds" */
  insertPaymentRefundsOne?: Maybe<PaymentRefunds>;
  /** insert data into the table: "payment_status_error_detail" */
  insertPaymentStatusErrorDetail?: Maybe<PaymentStatusErrorDetailMutationResponse>;
  /** insert a single row into the table: "payment_status_error_detail" */
  insertPaymentStatusErrorDetailOne?: Maybe<PaymentStatusErrorDetail>;
  /** insert data into the table: "payment_status_latest" */
  insertPaymentStatusLatest?: Maybe<PaymentStatusLatestMutationResponse>;
  /** insert a single row into the table: "payment_status_latest" */
  insertPaymentStatusLatestOne?: Maybe<PaymentStatusLatest>;
  /** insert data into the table: "payment_statuses" */
  insertPaymentStatuses?: Maybe<PaymentStatusesMutationResponse>;
  /** insert a single row into the table: "payment_statuses" */
  insertPaymentStatusesOne?: Maybe<PaymentStatuses>;
  /** insert data into the table: "payment_subscription_invoices" */
  insertPaymentSubscriptionInvoices?: Maybe<PaymentSubscriptionInvoicesMutationResponse>;
  /** insert a single row into the table: "payment_subscription_invoices" */
  insertPaymentSubscriptionInvoicesOne?: Maybe<PaymentSubscriptionInvoices>;
  /** insert data into the table: "payment_subscription_statuses" */
  insertPaymentSubscriptionStatuses?: Maybe<PaymentSubscriptionStatusesMutationResponse>;
  /** insert a single row into the table: "payment_subscription_statuses" */
  insertPaymentSubscriptionStatusesOne?: Maybe<PaymentSubscriptionStatuses>;
  /** insert data into the table: "payment_subscriptions" */
  insertPaymentSubscriptions?: Maybe<PaymentSubscriptionsMutationResponse>;
  /** insert a single row into the table: "payment_subscriptions" */
  insertPaymentSubscriptionsOne?: Maybe<PaymentSubscriptions>;
  /** insert data into the table: "payout_items" */
  insertPayoutItems?: Maybe<PayoutItemsMutationResponse>;
  /** insert a single row into the table: "payout_items" */
  insertPayoutItemsOne?: Maybe<PayoutItems>;
  /** insert data into the table: "payout_qbo_accounts_config" */
  insertPayoutQboAccountsConfig?: Maybe<PayoutQboAccountsConfigMutationResponse>;
  /** insert a single row into the table: "payout_qbo_accounts_config" */
  insertPayoutQboAccountsConfigOne?: Maybe<PayoutQboAccountsConfig>;
  /** insert data into the table: "payouts" */
  insertPayouts?: Maybe<PayoutsMutationResponse>;
  /** insert a single row into the table: "payouts" */
  insertPayoutsOne?: Maybe<Payouts>;
  /** insert data into the table: "phone_numbers" */
  insertPhoneNumbers?: Maybe<PhoneNumbersMutationResponse>;
  /** insert a single row into the table: "phone_numbers" */
  insertPhoneNumbersOne?: Maybe<PhoneNumbers>;
  /** insert data into the table: "photo_links" */
  insertPhotoLinks?: Maybe<PhotoLinksMutationResponse>;
  /** insert a single row into the table: "photo_links" */
  insertPhotoLinksOne?: Maybe<PhotoLinks>;
  /** insert data into the table: "photos" */
  insertPhotos?: Maybe<PhotosMutationResponse>;
  /** insert a single row into the table: "photos" */
  insertPhotosOne?: Maybe<Photos>;
  /** insert data into the table: "pricebook_bundle_items" */
  insertPricebookBundleItems?: Maybe<PricebookBundleItemsMutationResponse>;
  /** insert a single row into the table: "pricebook_bundle_items" */
  insertPricebookBundleItemsOne?: Maybe<PricebookBundleItems>;
  /** insert data into the table: "pricebook_categories" */
  insertPricebookCategories?: Maybe<PricebookCategoriesMutationResponse>;
  /** insert a single row into the table: "pricebook_categories" */
  insertPricebookCategoriesOne?: Maybe<PricebookCategories>;
  /** insert data into the table: "pricebook_discounts" */
  insertPricebookDiscounts?: Maybe<PricebookDiscountsMutationResponse>;
  /** insert a single row into the table: "pricebook_discounts" */
  insertPricebookDiscountsOne?: Maybe<PricebookDiscounts>;
  /** insert data into the table: "pricebook_item_type_fallback_photos" */
  insertPricebookItemTypeFallbackPhotos?: Maybe<PricebookItemTypeFallbackPhotosMutationResponse>;
  /** insert a single row into the table: "pricebook_item_type_fallback_photos" */
  insertPricebookItemTypeFallbackPhotosOne?: Maybe<PricebookItemTypeFallbackPhotos>;
  /** insert data into the table: "pricebook_items" */
  insertPricebookItems?: Maybe<PricebookItemsMutationResponse>;
  /** insert a single row into the table: "pricebook_items" */
  insertPricebookItemsOne?: Maybe<PricebookItems>;
  /** insert data into the table: "pricebook_items_qbo_income_accounts" */
  insertPricebookItemsQboIncomeAccounts?: Maybe<PricebookItemsQboIncomeAccountsMutationResponse>;
  /** insert a single row into the table: "pricebook_items_qbo_income_accounts" */
  insertPricebookItemsQboIncomeAccountsOne?: Maybe<PricebookItemsQboIncomeAccounts>;
  /** insert data into the table: "pricebook_markup_tiers" */
  insertPricebookMarkupTiers?: Maybe<PricebookMarkupTiersMutationResponse>;
  /** insert a single row into the table: "pricebook_markup_tiers" */
  insertPricebookMarkupTiersOne?: Maybe<PricebookMarkupTiers>;
  /** insert data into the table: "pricebook_tax_rates" */
  insertPricebookTaxRates?: Maybe<PricebookTaxRatesMutationResponse>;
  /** insert a single row into the table: "pricebook_tax_rates" */
  insertPricebookTaxRatesOne?: Maybe<PricebookTaxRates>;
  /** insert data into the table: "pricebook_versions" */
  insertPricebookVersions?: Maybe<PricebookVersionsMutationResponse>;
  /** insert a single row into the table: "pricebook_versions" */
  insertPricebookVersionsOne?: Maybe<PricebookVersions>;
  /** insert data into the table: "purchase_orders" */
  insertPurchaseOrders?: Maybe<PurchaseOrdersMutationResponse>;
  /** insert a single row into the table: "purchase_orders" */
  insertPurchaseOrdersOne?: Maybe<PurchaseOrders>;
  /** insert data into the table: "qbo_auth_data" */
  insertQboAuthData?: Maybe<QboAuthDataMutationResponse>;
  /** insert a single row into the table: "qbo_auth_data" */
  insertQboAuthDataOne?: Maybe<QboAuthData>;
  /** insert data into the table: "qbo_cart_item_type_accounts_config" */
  insertQboCartItemTypeAccountsConfig?: Maybe<QboCartItemTypeAccountsConfigMutationResponse>;
  /** insert a single row into the table: "qbo_cart_item_type_accounts_config" */
  insertQboCartItemTypeAccountsConfigOne?: Maybe<QboCartItemTypeAccountsConfig>;
  /** insert data into the table: "qbo_sync_info" */
  insertQboSyncInfo?: Maybe<QboSyncInfoMutationResponse>;
  /** insert a single row into the table: "qbo_sync_info" */
  insertQboSyncInfoOne?: Maybe<QboSyncInfo>;
  /** insert data into the table: "recent_pricebook_items" */
  insertRecentPricebookItems?: Maybe<RecentPricebookItemsMutationResponse>;
  /** insert a single row into the table: "recent_pricebook_items" */
  insertRecentPricebookItemsOne?: Maybe<RecentPricebookItems>;
  /** insert data into the table: "recommendation_ai_generation_info" */
  insertRecommendationAiGenerationInfo?: Maybe<RecommendationAiGenerationInfoMutationResponse>;
  /** insert a single row into the table: "recommendation_ai_generation_info" */
  insertRecommendationAiGenerationInfoOne?: Maybe<RecommendationAiGenerationInfo>;
  /** insert data into the table: "recommendation_dismissals" */
  insertRecommendationDismissals?: Maybe<RecommendationDismissalsMutationResponse>;
  /** insert a single row into the table: "recommendation_dismissals" */
  insertRecommendationDismissalsOne?: Maybe<RecommendationDismissals>;
  /** insert data into the table: "recommendation_interactions" */
  insertRecommendationInteractions?: Maybe<RecommendationInteractionsMutationResponse>;
  /** insert a single row into the table: "recommendation_interactions" */
  insertRecommendationInteractionsOne?: Maybe<RecommendationInteractions>;
  /** insert data into the table: "recommendations" */
  insertRecommendations?: Maybe<RecommendationsMutationResponse>;
  /** insert a single row into the table: "recommendations" */
  insertRecommendationsOne?: Maybe<Recommendations>;
  /** insert data into the table: "reminder_assignments" */
  insertReminderAssignments?: Maybe<ReminderAssignmentsMutationResponse>;
  /** insert a single row into the table: "reminder_assignments" */
  insertReminderAssignmentsOne?: Maybe<ReminderAssignments>;
  /** insert data into the table: "reminder_internal_notifications" */
  insertReminderInternalNotifications?: Maybe<ReminderInternalNotificationsMutationResponse>;
  /** insert a single row into the table: "reminder_internal_notifications" */
  insertReminderInternalNotificationsOne?: Maybe<ReminderInternalNotifications>;
  /** insert data into the table: "reminders" */
  insertReminders?: Maybe<RemindersMutationResponse>;
  /** insert a single row into the table: "reminders" */
  insertRemindersOne?: Maybe<Reminders>;
  /** insert data into the table: "rep_company_metabase_config" */
  insertRepCompanyMetabaseConfig?: Maybe<RepCompanyMetabaseConfigMutationResponse>;
  /** insert a single row into the table: "rep_company_metabase_config" */
  insertRepCompanyMetabaseConfigOne?: Maybe<RepCompanyMetabaseConfig>;
  /** insert data into the table: "rep_metabase_company_reports" */
  insertRepMetabaseCompanyReports?: Maybe<RepMetabaseCompanyReportsMutationResponse>;
  /** insert a single row into the table: "rep_metabase_company_reports" */
  insertRepMetabaseCompanyReportsOne?: Maybe<RepMetabaseCompanyReports>;
  /** insert data into the table: "rep_metabase_pulses" */
  insertRepMetabasePulses?: Maybe<RepMetabasePulsesMutationResponse>;
  /** insert a single row into the table: "rep_metabase_pulses" */
  insertRepMetabasePulsesOne?: Maybe<RepMetabasePulses>;
  /** insert data into the table: "rep_metabase_pulses_v2" */
  insertRepMetabasePulsesV2?: Maybe<RepMetabasePulsesV2MutationResponse>;
  /** insert a single row into the table: "rep_metabase_pulses_v2" */
  insertRepMetabasePulsesV2One?: Maybe<RepMetabasePulsesV2>;
  /** insert data into the table: "rep_metabase_report_definitions" */
  insertRepMetabaseReportDefinitions?: Maybe<RepMetabaseReportDefinitionsMutationResponse>;
  /** insert a single row into the table: "rep_metabase_report_definitions" */
  insertRepMetabaseReportDefinitionsOne?: Maybe<RepMetabaseReportDefinitions>;
  /** insert data into the table: "tags" */
  insertTags?: Maybe<TagsMutationResponse>;
  /** insert a single row into the table: "tags" */
  insertTagsOne?: Maybe<Tags>;
  /** insert data into the table: "technician_capacities" */
  insertTechnicianCapacities?: Maybe<TechnicianCapacitiesMutationResponse>;
  /** insert a single row into the table: "technician_capacities" */
  insertTechnicianCapacitiesOne?: Maybe<TechnicianCapacities>;
  /** insert data into the table: "technician_capacity_blocks" */
  insertTechnicianCapacityBlocks?: Maybe<TechnicianCapacityBlocksMutationResponse>;
  /** insert a single row into the table: "technician_capacity_blocks" */
  insertTechnicianCapacityBlocksOne?: Maybe<TechnicianCapacityBlocks>;
  /** insert data into the table: "tilled_raw_events" */
  insertTilledRawEvents?: Maybe<TilledRawEventsMutationResponse>;
  /** insert a single row into the table: "tilled_raw_events" */
  insertTilledRawEventsOne?: Maybe<TilledRawEvents>;
  /** insert data into the table: "timesheet_entries" */
  insertTimesheetEntries?: Maybe<TimesheetEntriesMutationResponse>;
  /** insert a single row into the table: "timesheet_entries" */
  insertTimesheetEntriesOne?: Maybe<TimesheetEntries>;
  /** insert data into the table: "timesheet_entry_activities" */
  insertTimesheetEntryActivities?: Maybe<TimesheetEntryActivitiesMutationResponse>;
  /** insert a single row into the table: "timesheet_entry_activities" */
  insertTimesheetEntryActivitiesOne?: Maybe<TimesheetEntryActivities>;
  /** insert data into the table: "timesheet_entry_link_data" */
  insertTimesheetEntryLinkData?: Maybe<TimesheetEntryLinkDataMutationResponse>;
  /** insert a single row into the table: "timesheet_entry_link_data" */
  insertTimesheetEntryLinkDataOne?: Maybe<TimesheetEntryLinkData>;
  /** insert data into the table: "tune_up_visit_entitlements" */
  insertTuneUpVisitEntitlements?: Maybe<TuneUpVisitEntitlementsMutationResponse>;
  /** insert a single row into the table: "tune_up_visit_entitlements" */
  insertTuneUpVisitEntitlementsOne?: Maybe<TuneUpVisitEntitlements>;
  /** insert data into the table: "user_business_units" */
  insertUserBusinessUnits?: Maybe<UserBusinessUnitsMutationResponse>;
  /** insert a single row into the table: "user_business_units" */
  insertUserBusinessUnitsOne?: Maybe<UserBusinessUnits>;
  /** insert data into the table: "user_phone_numbers" */
  insertUserPhoneNumbers?: Maybe<UserPhoneNumbersMutationResponse>;
  /** insert a single row into the table: "user_phone_numbers" */
  insertUserPhoneNumbersOne?: Maybe<UserPhoneNumbers>;
  /** insert data into the table: "user_settings" */
  insertUserSettings?: Maybe<UserSettingsMutationResponse>;
  /** insert a single row into the table: "user_settings" */
  insertUserSettingsOne?: Maybe<UserSettings>;
  /** insert data into the table: "user_wages" */
  insertUserWages?: Maybe<UserWagesMutationResponse>;
  /** insert a single row into the table: "user_wages" */
  insertUserWagesOne?: Maybe<UserWages>;
  /** insert data into the table: "users" */
  insertUsers?: Maybe<UsersMutationResponse>;
  /** insert a single row into the table: "users" */
  insertUsersOne?: Maybe<Users>;
  /** insert data into the table: "wisetack_loan_records" */
  insertWisetackLoanRecords?: Maybe<WisetackLoanRecordsMutationResponse>;
  /** insert a single row into the table: "wisetack_loan_records" */
  insertWisetackLoanRecordsOne?: Maybe<WisetackLoanRecords>;
  /** insert data into the table: "wisetack_loan_statuses" */
  insertWisetackLoanStatuses?: Maybe<WisetackLoanStatusesMutationResponse>;
  /** insert a single row into the table: "wisetack_loan_statuses" */
  insertWisetackLoanStatusesOne?: Maybe<WisetackLoanStatuses>;
  /** insert data into the table: "wisetack_prequal_records" */
  insertWisetackPrequalRecords?: Maybe<WisetackPrequalRecordsMutationResponse>;
  /** insert a single row into the table: "wisetack_prequal_records" */
  insertWisetackPrequalRecordsOne?: Maybe<WisetackPrequalRecords>;
  /** insert data into the table: "wisetack_webhook_events" */
  insertWisetackWebhookEvents?: Maybe<WisetackWebhookEventsMutationResponse>;
  /** insert a single row into the table: "wisetack_webhook_events" */
  insertWisetackWebhookEventsOne?: Maybe<WisetackWebhookEvents>;
  /** update data of the table: "acc_cart_item_type_accounts_config" */
  updateAccCartItemTypeAccountsConfig?: Maybe<AccCartItemTypeAccountsConfigMutationResponse>;
  /** update single row of the table: "acc_cart_item_type_accounts_config" */
  updateAccCartItemTypeAccountsConfigByPk?: Maybe<AccCartItemTypeAccountsConfig>;
  /** update multiples rows of table: "acc_cart_item_type_accounts_config" */
  updateAccCartItemTypeAccountsConfigMany?: Maybe<Array<Maybe<AccCartItemTypeAccountsConfigMutationResponse>>>;
  /** update data of the table: "acc_company_config" */
  updateAccCompanyConfig?: Maybe<AccCompanyConfigMutationResponse>;
  /** update single row of the table: "acc_company_config" */
  updateAccCompanyConfigByPk?: Maybe<AccCompanyConfig>;
  /** update multiples rows of table: "acc_company_config" */
  updateAccCompanyConfigMany?: Maybe<Array<Maybe<AccCompanyConfigMutationResponse>>>;
  /** update data of the table: "acc_payout_accounts_config" */
  updateAccPayoutAccountsConfig?: Maybe<AccPayoutAccountsConfigMutationResponse>;
  /** update single row of the table: "acc_payout_accounts_config" */
  updateAccPayoutAccountsConfigByPk?: Maybe<AccPayoutAccountsConfig>;
  /** update multiples rows of table: "acc_payout_accounts_config" */
  updateAccPayoutAccountsConfigMany?: Maybe<Array<Maybe<AccPayoutAccountsConfigMutationResponse>>>;
  /** update data of the table: "acc_qbd_conductor_config" */
  updateAccQbdConductorConfig?: Maybe<AccQbdConductorConfigMutationResponse>;
  /** update single row of the table: "acc_qbd_conductor_config" */
  updateAccQbdConductorConfigByPk?: Maybe<AccQbdConductorConfig>;
  /** update multiples rows of table: "acc_qbd_conductor_config" */
  updateAccQbdConductorConfigMany?: Maybe<Array<Maybe<AccQbdConductorConfigMutationResponse>>>;
  /** update data of the table: "acc_qbd_conductor_uptime" */
  updateAccQbdConductorUptime?: Maybe<AccQbdConductorUptimeMutationResponse>;
  /** update single row of the table: "acc_qbd_conductor_uptime" */
  updateAccQbdConductorUptimeByPk?: Maybe<AccQbdConductorUptime>;
  /** update multiples rows of table: "acc_qbd_conductor_uptime" */
  updateAccQbdConductorUptimeMany?: Maybe<Array<Maybe<AccQbdConductorUptimeMutationResponse>>>;
  /** update data of the table: "acc_sync_info" */
  updateAccSyncInfo?: Maybe<AccSyncInfoMutationResponse>;
  /** update single row of the table: "acc_sync_info" */
  updateAccSyncInfoByPk?: Maybe<AccSyncInfo>;
  /** update multiples rows of table: "acc_sync_info" */
  updateAccSyncInfoMany?: Maybe<Array<Maybe<AccSyncInfoMutationResponse>>>;
  /** update data of the table: "acc_sync_queue_items" */
  updateAccSyncQueueItems?: Maybe<AccSyncQueueItemsMutationResponse>;
  /** update single row of the table: "acc_sync_queue_items" */
  updateAccSyncQueueItemsByPk?: Maybe<AccSyncQueueItems>;
  /** update multiples rows of table: "acc_sync_queue_items" */
  updateAccSyncQueueItemsMany?: Maybe<Array<Maybe<AccSyncQueueItemsMutationResponse>>>;
  /** update data of the table: "account_contacts" */
  updateAccountContacts?: Maybe<AccountContactsMutationResponse>;
  /** update single row of the table: "account_contacts" */
  updateAccountContactsByPk?: Maybe<AccountContacts>;
  /** update multiples rows of table: "account_contacts" */
  updateAccountContactsMany?: Maybe<Array<Maybe<AccountContactsMutationResponse>>>;
  /** update data of the table: "account_locations" */
  updateAccountLocations?: Maybe<AccountLocationsMutationResponse>;
  /** update single row of the table: "account_locations" */
  updateAccountLocationsByPk?: Maybe<AccountLocations>;
  /** update multiples rows of table: "account_locations" */
  updateAccountLocationsMany?: Maybe<Array<Maybe<AccountLocationsMutationResponse>>>;
  /** update data of the table: "account_reminders" */
  updateAccountReminders?: Maybe<AccountRemindersMutationResponse>;
  /** update single row of the table: "account_reminders" */
  updateAccountRemindersByPk?: Maybe<AccountReminders>;
  /** update multiples rows of table: "account_reminders" */
  updateAccountRemindersMany?: Maybe<Array<Maybe<AccountRemindersMutationResponse>>>;
  /** update data of the table: "account_statement_events" */
  updateAccountStatementEvents?: Maybe<AccountStatementEventsMutationResponse>;
  /** update single row of the table: "account_statement_events" */
  updateAccountStatementEventsByPk?: Maybe<AccountStatementEvents>;
  /** update multiples rows of table: "account_statement_events" */
  updateAccountStatementEventsMany?: Maybe<Array<Maybe<AccountStatementEventsMutationResponse>>>;
  /** update data of the table: "account_tags" */
  updateAccountTags?: Maybe<AccountTagsMutationResponse>;
  /** update single row of the table: "account_tags" */
  updateAccountTagsByPk?: Maybe<AccountTags>;
  /** update multiples rows of table: "account_tags" */
  updateAccountTagsMany?: Maybe<Array<Maybe<AccountTagsMutationResponse>>>;
  /** update data of the table: "account_types" */
  updateAccountTypes?: Maybe<AccountTypesMutationResponse>;
  /** update single row of the table: "account_types" */
  updateAccountTypesByPk?: Maybe<AccountTypes>;
  /** update multiples rows of table: "account_types" */
  updateAccountTypesMany?: Maybe<Array<Maybe<AccountTypesMutationResponse>>>;
  /** update data of the table: "accounts" */
  updateAccounts?: Maybe<AccountsMutationResponse>;
  /** update single row of the table: "accounts" */
  updateAccountsByPk?: Maybe<Accounts>;
  /** update multiples rows of table: "accounts" */
  updateAccountsMany?: Maybe<Array<Maybe<AccountsMutationResponse>>>;
  /** update data of the table: "accounts_viewed_by_user" */
  updateAccountsViewedByUser?: Maybe<AccountsViewedByUserMutationResponse>;
  /** update single row of the table: "accounts_viewed_by_user" */
  updateAccountsViewedByUserByPk?: Maybe<AccountsViewedByUser>;
  /** update multiples rows of table: "accounts_viewed_by_user" */
  updateAccountsViewedByUserMany?: Maybe<Array<Maybe<AccountsViewedByUserMutationResponse>>>;
  /** update data of the table: "activity_items" */
  updateActivityItems?: Maybe<ActivityItemsMutationResponse>;
  /** update single row of the table: "activity_items" */
  updateActivityItemsByPk?: Maybe<ActivityItems>;
  /** update multiples rows of table: "activity_items" */
  updateActivityItemsMany?: Maybe<Array<Maybe<ActivityItemsMutationResponse>>>;
  /** update data of the table: "addresses" */
  updateAddresses?: Maybe<AddressesMutationResponse>;
  /** update single row of the table: "addresses" */
  updateAddressesByPk?: Maybe<Addresses>;
  /** update multiples rows of table: "addresses" */
  updateAddressesMany?: Maybe<Array<Maybe<AddressesMutationResponse>>>;
  /** update data of the table: "appointment_checklist_association_rules" */
  updateAppointmentChecklistAssociationRules?: Maybe<AppointmentChecklistAssociationRulesMutationResponse>;
  /** update single row of the table: "appointment_checklist_association_rules" */
  updateAppointmentChecklistAssociationRulesByPk?: Maybe<AppointmentChecklistAssociationRules>;
  /** update multiples rows of table: "appointment_checklist_association_rules" */
  updateAppointmentChecklistAssociationRulesMany?: Maybe<Array<Maybe<AppointmentChecklistAssociationRulesMutationResponse>>>;
  /** update data of the table: "appointment_checklist_instances" */
  updateAppointmentChecklistInstances?: Maybe<AppointmentChecklistInstancesMutationResponse>;
  /** update single row of the table: "appointment_checklist_instances" */
  updateAppointmentChecklistInstancesByPk?: Maybe<AppointmentChecklistInstances>;
  /** update multiples rows of table: "appointment_checklist_instances" */
  updateAppointmentChecklistInstancesMany?: Maybe<Array<Maybe<AppointmentChecklistInstancesMutationResponse>>>;
  /** update data of the table: "appointment_checklists" */
  updateAppointmentChecklists?: Maybe<AppointmentChecklistsMutationResponse>;
  /** update single row of the table: "appointment_checklists" */
  updateAppointmentChecklistsByPk?: Maybe<AppointmentChecklists>;
  /** update multiples rows of table: "appointment_checklists" */
  updateAppointmentChecklistsMany?: Maybe<Array<Maybe<AppointmentChecklistsMutationResponse>>>;
  /** update data of the table: "assistant_integrated_phones" */
  updateAssistantIntegratedPhones?: Maybe<AssistantIntegratedPhonesMutationResponse>;
  /** update single row of the table: "assistant_integrated_phones" */
  updateAssistantIntegratedPhonesByPk?: Maybe<AssistantIntegratedPhones>;
  /** update multiples rows of table: "assistant_integrated_phones" */
  updateAssistantIntegratedPhonesMany?: Maybe<Array<Maybe<AssistantIntegratedPhonesMutationResponse>>>;
  /** update data of the table: "assistant_phone_settings" */
  updateAssistantPhoneSettings?: Maybe<AssistantPhoneSettingsMutationResponse>;
  /** update single row of the table: "assistant_phone_settings" */
  updateAssistantPhoneSettingsByPk?: Maybe<AssistantPhoneSettings>;
  /** update multiples rows of table: "assistant_phone_settings" */
  updateAssistantPhoneSettingsMany?: Maybe<Array<Maybe<AssistantPhoneSettingsMutationResponse>>>;
  /** update data of the table: "assistants" */
  updateAssistants?: Maybe<AssistantsMutationResponse>;
  /** update single row of the table: "assistants" */
  updateAssistantsByPk?: Maybe<Assistants>;
  /** update multiples rows of table: "assistants" */
  updateAssistantsMany?: Maybe<Array<Maybe<AssistantsMutationResponse>>>;
  /** update data of the table: "billing_profile_hidden_payment_methods" */
  updateBillingProfileHiddenPaymentMethods?: Maybe<BillingProfileHiddenPaymentMethodsMutationResponse>;
  /** update single row of the table: "billing_profile_hidden_payment_methods" */
  updateBillingProfileHiddenPaymentMethodsByPk?: Maybe<BillingProfileHiddenPaymentMethods>;
  /** update multiples rows of table: "billing_profile_hidden_payment_methods" */
  updateBillingProfileHiddenPaymentMethodsMany?: Maybe<Array<Maybe<BillingProfileHiddenPaymentMethodsMutationResponse>>>;
  /** update data of the table: "billing_profiles" */
  updateBillingProfiles?: Maybe<BillingProfilesMutationResponse>;
  /** update single row of the table: "billing_profiles" */
  updateBillingProfilesByPk?: Maybe<BillingProfiles>;
  /** update multiples rows of table: "billing_profiles" */
  updateBillingProfilesMany?: Maybe<Array<Maybe<BillingProfilesMutationResponse>>>;
  /** update data of the table: "business_events" */
  updateBusinessEvents?: Maybe<BusinessEventsMutationResponse>;
  /** update single row of the table: "business_events" */
  updateBusinessEventsByPk?: Maybe<BusinessEvents>;
  /** update multiples rows of table: "business_events" */
  updateBusinessEventsMany?: Maybe<Array<Maybe<BusinessEventsMutationResponse>>>;
  /** update data of the table: "business_unit_target_metrics" */
  updateBusinessUnitTargetMetrics?: Maybe<BusinessUnitTargetMetricsMutationResponse>;
  /** update single row of the table: "business_unit_target_metrics" */
  updateBusinessUnitTargetMetricsByPk?: Maybe<BusinessUnitTargetMetrics>;
  /** update multiples rows of table: "business_unit_target_metrics" */
  updateBusinessUnitTargetMetricsMany?: Maybe<Array<Maybe<BusinessUnitTargetMetricsMutationResponse>>>;
  /** update data of the table: "business_units" */
  updateBusinessUnits?: Maybe<BusinessUnitsMutationResponse>;
  /** update single row of the table: "business_units" */
  updateBusinessUnitsByPk?: Maybe<BusinessUnits>;
  /** update multiples rows of table: "business_units" */
  updateBusinessUnitsMany?: Maybe<Array<Maybe<BusinessUnitsMutationResponse>>>;
  /** update data of the table: "canonical_lead_sources" */
  updateCanonicalLeadSources?: Maybe<CanonicalLeadSourcesMutationResponse>;
  /** update single row of the table: "canonical_lead_sources" */
  updateCanonicalLeadSourcesByPk?: Maybe<CanonicalLeadSources>;
  /** update multiples rows of table: "canonical_lead_sources" */
  updateCanonicalLeadSourcesMany?: Maybe<Array<Maybe<CanonicalLeadSourcesMutationResponse>>>;
  /** update data of the table: "cart_item_job_cost_links" */
  updateCartItemJobCostLinks?: Maybe<CartItemJobCostLinksMutationResponse>;
  /** update single row of the table: "cart_item_job_cost_links" */
  updateCartItemJobCostLinksByPk?: Maybe<CartItemJobCostLinks>;
  /** update multiples rows of table: "cart_item_job_cost_links" */
  updateCartItemJobCostLinksMany?: Maybe<Array<Maybe<CartItemJobCostLinksMutationResponse>>>;
  /** update data of the table: "cart_items" */
  updateCartItems?: Maybe<CartItemsMutationResponse>;
  /** update single row of the table: "cart_items" */
  updateCartItemsByPk?: Maybe<CartItems>;
  /** update multiples rows of table: "cart_items" */
  updateCartItemsMany?: Maybe<Array<Maybe<CartItemsMutationResponse>>>;
  /** update data of the table: "checklist_items" */
  updateChecklistItems?: Maybe<ChecklistItemsMutationResponse>;
  /** update single row of the table: "checklist_items" */
  updateChecklistItemsByPk?: Maybe<ChecklistItems>;
  /** update multiples rows of table: "checklist_items" */
  updateChecklistItemsMany?: Maybe<Array<Maybe<ChecklistItemsMutationResponse>>>;
  /** update data of the table: "companies" */
  updateCompanies?: Maybe<CompaniesMutationResponse>;
  /** update single row of the table: "companies" */
  updateCompaniesByPk?: Maybe<Companies>;
  /** update multiples rows of table: "companies" */
  updateCompaniesMany?: Maybe<Array<Maybe<CompaniesMutationResponse>>>;
  /** update data of the table: "company_appointment_arrival_windows" */
  updateCompanyAppointmentArrivalWindows?: Maybe<CompanyAppointmentArrivalWindowsMutationResponse>;
  /** update single row of the table: "company_appointment_arrival_windows" */
  updateCompanyAppointmentArrivalWindowsByPk?: Maybe<CompanyAppointmentArrivalWindows>;
  /** update multiples rows of table: "company_appointment_arrival_windows" */
  updateCompanyAppointmentArrivalWindowsMany?: Maybe<Array<Maybe<CompanyAppointmentArrivalWindowsMutationResponse>>>;
  /** update data of the table: "company_commission_config" */
  updateCompanyCommissionConfig?: Maybe<CompanyCommissionConfigMutationResponse>;
  /** update single row of the table: "company_commission_config" */
  updateCompanyCommissionConfigByPk?: Maybe<CompanyCommissionConfig>;
  /** update multiples rows of table: "company_commission_config" */
  updateCompanyCommissionConfigMany?: Maybe<Array<Maybe<CompanyCommissionConfigMutationResponse>>>;
  /** update data of the table: "company_config" */
  updateCompanyConfig?: Maybe<CompanyConfigMutationResponse>;
  /** update single row of the table: "company_config" */
  updateCompanyConfigByPk?: Maybe<CompanyConfig>;
  /** update multiples rows of table: "company_config" */
  updateCompanyConfigMany?: Maybe<Array<Maybe<CompanyConfigMutationResponse>>>;
  /** update data of the table: "company_drip_marketing_config" */
  updateCompanyDripMarketingConfig?: Maybe<CompanyDripMarketingConfigMutationResponse>;
  /** update single row of the table: "company_drip_marketing_config" */
  updateCompanyDripMarketingConfigByPk?: Maybe<CompanyDripMarketingConfig>;
  /** update multiples rows of table: "company_drip_marketing_config" */
  updateCompanyDripMarketingConfigMany?: Maybe<Array<Maybe<CompanyDripMarketingConfigMutationResponse>>>;
  /** update data of the table: "company_lead_source_links" */
  updateCompanyLeadSourceLinks?: Maybe<CompanyLeadSourceLinksMutationResponse>;
  /** update single row of the table: "company_lead_source_links" */
  updateCompanyLeadSourceLinksByPk?: Maybe<CompanyLeadSourceLinks>;
  /** update multiples rows of table: "company_lead_source_links" */
  updateCompanyLeadSourceLinksMany?: Maybe<Array<Maybe<CompanyLeadSourceLinksMutationResponse>>>;
  /** update data of the table: "company_lead_sources" */
  updateCompanyLeadSources?: Maybe<CompanyLeadSourcesMutationResponse>;
  /** update single row of the table: "company_lead_sources" */
  updateCompanyLeadSourcesByPk?: Maybe<CompanyLeadSources>;
  /** update multiples rows of table: "company_lead_sources" */
  updateCompanyLeadSourcesMany?: Maybe<Array<Maybe<CompanyLeadSourcesMutationResponse>>>;
  /** update data of the table: "company_notification_settings" */
  updateCompanyNotificationSettings?: Maybe<CompanyNotificationSettingsMutationResponse>;
  /** update single row of the table: "company_notification_settings" */
  updateCompanyNotificationSettingsByPk?: Maybe<CompanyNotificationSettings>;
  /** update multiples rows of table: "company_notification_settings" */
  updateCompanyNotificationSettingsMany?: Maybe<Array<Maybe<CompanyNotificationSettingsMutationResponse>>>;
  /** update data of the table: "company_pricing_tier_config" */
  updateCompanyPricingTierConfig?: Maybe<CompanyPricingTierConfigMutationResponse>;
  /** update single row of the table: "company_pricing_tier_config" */
  updateCompanyPricingTierConfigByPk?: Maybe<CompanyPricingTierConfig>;
  /** update multiples rows of table: "company_pricing_tier_config" */
  updateCompanyPricingTierConfigMany?: Maybe<Array<Maybe<CompanyPricingTierConfigMutationResponse>>>;
  /** update data of the table: "company_roles" */
  updateCompanyRoles?: Maybe<CompanyRolesMutationResponse>;
  /** update single row of the table: "company_roles" */
  updateCompanyRolesByPk?: Maybe<CompanyRoles>;
  /** update multiples rows of table: "company_roles" */
  updateCompanyRolesMany?: Maybe<Array<Maybe<CompanyRolesMutationResponse>>>;
  /** update data of the table: "company_tax_configurations" */
  updateCompanyTaxConfigurations?: Maybe<CompanyTaxConfigurationsMutationResponse>;
  /** update single row of the table: "company_tax_configurations" */
  updateCompanyTaxConfigurationsByPk?: Maybe<CompanyTaxConfigurations>;
  /** update multiples rows of table: "company_tax_configurations" */
  updateCompanyTaxConfigurationsMany?: Maybe<Array<Maybe<CompanyTaxConfigurationsMutationResponse>>>;
  /** update data of the table: "company_users" */
  updateCompanyUsers?: Maybe<CompanyUsersMutationResponse>;
  /** update single row of the table: "company_users" */
  updateCompanyUsersByPk?: Maybe<CompanyUsers>;
  /** update multiples rows of table: "company_users" */
  updateCompanyUsersMany?: Maybe<Array<Maybe<CompanyUsersMutationResponse>>>;
  /** update data of the table: "company_working_display_hours" */
  updateCompanyWorkingDisplayHours?: Maybe<CompanyWorkingDisplayHoursMutationResponse>;
  /** update single row of the table: "company_working_display_hours" */
  updateCompanyWorkingDisplayHoursByPk?: Maybe<CompanyWorkingDisplayHours>;
  /** update multiples rows of table: "company_working_display_hours" */
  updateCompanyWorkingDisplayHoursMany?: Maybe<Array<Maybe<CompanyWorkingDisplayHoursMutationResponse>>>;
  /** update data of the table: "contacts" */
  updateContacts?: Maybe<ContactsMutationResponse>;
  /** update single row of the table: "contacts" */
  updateContactsByPk?: Maybe<Contacts>;
  /** update multiples rows of table: "contacts" */
  updateContactsMany?: Maybe<Array<Maybe<ContactsMutationResponse>>>;
  /** update data of the table: "current_company_tax_configurations_view" */
  updateCurrentCompanyTaxConfigurationsView?: Maybe<CurrentCompanyTaxConfigurationsViewMutationResponse>;
  /** update multiples rows of table: "current_company_tax_configurations_view" */
  updateCurrentCompanyTaxConfigurationsViewMany?: Maybe<Array<Maybe<CurrentCompanyTaxConfigurationsViewMutationResponse>>>;
  /** update data of the table: "current_user_business_units_view" */
  updateCurrentUserBusinessUnitsView?: Maybe<CurrentUserBusinessUnitsViewMutationResponse>;
  /** update multiples rows of table: "current_user_business_units_view" */
  updateCurrentUserBusinessUnitsViewMany?: Maybe<Array<Maybe<CurrentUserBusinessUnitsViewMutationResponse>>>;
  /** update data of the table: "customer_communication_templates" */
  updateCustomerCommunicationTemplates?: Maybe<CustomerCommunicationTemplatesMutationResponse>;
  /** update single row of the table: "customer_communication_templates" */
  updateCustomerCommunicationTemplatesByPk?: Maybe<CustomerCommunicationTemplates>;
  /** update multiples rows of table: "customer_communication_templates" */
  updateCustomerCommunicationTemplatesMany?: Maybe<Array<Maybe<CustomerCommunicationTemplatesMutationResponse>>>;
  /** update data of the table: "discount_entitlements" */
  updateDiscountEntitlements?: Maybe<DiscountEntitlementsMutationResponse>;
  /** update single row of the table: "discount_entitlements" */
  updateDiscountEntitlementsByPk?: Maybe<DiscountEntitlements>;
  /** update multiples rows of table: "discount_entitlements" */
  updateDiscountEntitlementsMany?: Maybe<Array<Maybe<DiscountEntitlementsMutationResponse>>>;
  /** update data of the table: "display_id_counters" */
  updateDisplayIdCounters?: Maybe<DisplayIdCountersMutationResponse>;
  /** update single row of the table: "display_id_counters" */
  updateDisplayIdCountersByPk?: Maybe<DisplayIdCounters>;
  /** update multiples rows of table: "display_id_counters" */
  updateDisplayIdCountersMany?: Maybe<Array<Maybe<DisplayIdCountersMutationResponse>>>;
  /** update data of the table: "drip_marketing_emails" */
  updateDripMarketingEmails?: Maybe<DripMarketingEmailsMutationResponse>;
  /** update single row of the table: "drip_marketing_emails" */
  updateDripMarketingEmailsByPk?: Maybe<DripMarketingEmails>;
  /** update multiples rows of table: "drip_marketing_emails" */
  updateDripMarketingEmailsMany?: Maybe<Array<Maybe<DripMarketingEmailsMutationResponse>>>;
  /** update data of the table: "email_addresses" */
  updateEmailAddresses?: Maybe<EmailAddressesMutationResponse>;
  /** update single row of the table: "email_addresses" */
  updateEmailAddressesByPk?: Maybe<EmailAddresses>;
  /** update multiples rows of table: "email_addresses" */
  updateEmailAddressesMany?: Maybe<Array<Maybe<EmailAddressesMutationResponse>>>;
  /** update data of the table: "entitlements" */
  updateEntitlements?: Maybe<EntitlementsMutationResponse>;
  /** update single row of the table: "entitlements" */
  updateEntitlementsByPk?: Maybe<Entitlements>;
  /** update multiples rows of table: "entitlements" */
  updateEntitlementsMany?: Maybe<Array<Maybe<EntitlementsMutationResponse>>>;
  /** update data of the table: "equipment_type_links" */
  updateEquipmentTypeLinks?: Maybe<EquipmentTypeLinksMutationResponse>;
  /** update single row of the table: "equipment_type_links" */
  updateEquipmentTypeLinksByPk?: Maybe<EquipmentTypeLinks>;
  /** update multiples rows of table: "equipment_type_links" */
  updateEquipmentTypeLinksMany?: Maybe<Array<Maybe<EquipmentTypeLinksMutationResponse>>>;
  /** update data of the table: "equipment_types" */
  updateEquipmentTypes?: Maybe<EquipmentTypesMutationResponse>;
  /** update single row of the table: "equipment_types" */
  updateEquipmentTypesByPk?: Maybe<EquipmentTypes>;
  /** update multiples rows of table: "equipment_types" */
  updateEquipmentTypesMany?: Maybe<Array<Maybe<EquipmentTypesMutationResponse>>>;
  /** update data of the table: "estimate_invoices" */
  updateEstimateInvoices?: Maybe<EstimateInvoicesMutationResponse>;
  /** update single row of the table: "estimate_invoices" */
  updateEstimateInvoicesByPk?: Maybe<EstimateInvoices>;
  /** update multiples rows of table: "estimate_invoices" */
  updateEstimateInvoicesMany?: Maybe<Array<Maybe<EstimateInvoicesMutationResponse>>>;
  /** update data of the table: "estimate_option_cart_items" */
  updateEstimateOptionCartItems?: Maybe<EstimateOptionCartItemsMutationResponse>;
  /** update single row of the table: "estimate_option_cart_items" */
  updateEstimateOptionCartItemsByPk?: Maybe<EstimateOptionCartItems>;
  /** update multiples rows of table: "estimate_option_cart_items" */
  updateEstimateOptionCartItemsMany?: Maybe<Array<Maybe<EstimateOptionCartItemsMutationResponse>>>;
  /** update data of the table: "estimate_option_discounts" */
  updateEstimateOptionDiscounts?: Maybe<EstimateOptionDiscountsMutationResponse>;
  /** update single row of the table: "estimate_option_discounts" */
  updateEstimateOptionDiscountsByPk?: Maybe<EstimateOptionDiscounts>;
  /** update multiples rows of table: "estimate_option_discounts" */
  updateEstimateOptionDiscountsMany?: Maybe<Array<Maybe<EstimateOptionDiscountsMutationResponse>>>;
  /** update data of the table: "estimate_options" */
  updateEstimateOptions?: Maybe<EstimateOptionsMutationResponse>;
  /** update single row of the table: "estimate_options" */
  updateEstimateOptionsByPk?: Maybe<EstimateOptions>;
  /** update multiples rows of table: "estimate_options" */
  updateEstimateOptionsMany?: Maybe<Array<Maybe<EstimateOptionsMutationResponse>>>;
  /** update data of the table: "estimate_photos" */
  updateEstimatePhotos?: Maybe<EstimatePhotosMutationResponse>;
  /** update single row of the table: "estimate_photos" */
  updateEstimatePhotosByPk?: Maybe<EstimatePhotos>;
  /** update multiples rows of table: "estimate_photos" */
  updateEstimatePhotosMany?: Maybe<Array<Maybe<EstimatePhotosMutationResponse>>>;
  /** update data of the table: "estimate_templates" */
  updateEstimateTemplates?: Maybe<EstimateTemplatesMutationResponse>;
  /** update single row of the table: "estimate_templates" */
  updateEstimateTemplatesByPk?: Maybe<EstimateTemplates>;
  /** update multiples rows of table: "estimate_templates" */
  updateEstimateTemplatesMany?: Maybe<Array<Maybe<EstimateTemplatesMutationResponse>>>;
  /** update data of the table: "estimates" */
  updateEstimates?: Maybe<EstimatesMutationResponse>;
  /** update single row of the table: "estimates" */
  updateEstimatesByPk?: Maybe<Estimates>;
  /** update multiples rows of table: "estimates" */
  updateEstimatesMany?: Maybe<Array<Maybe<EstimatesMutationResponse>>>;
  /** update data of the table: "estimates_queryable" */
  updateEstimatesQueryable?: Maybe<EstimatesQueryableMutationResponse>;
  /** update single row of the table: "estimates_queryable" */
  updateEstimatesQueryableByPk?: Maybe<EstimatesQueryable>;
  /** update multiples rows of table: "estimates_queryable" */
  updateEstimatesQueryableMany?: Maybe<Array<Maybe<EstimatesQueryableMutationResponse>>>;
  /** update data of the table: "event_store" */
  updateEventStore?: Maybe<EventStoreMutationResponse>;
  /** update single row of the table: "event_store" */
  updateEventStoreByPk?: Maybe<EventStore>;
  /** update multiples rows of table: "event_store" */
  updateEventStoreMany?: Maybe<Array<Maybe<EventStoreMutationResponse>>>;
  /** update data of the table: "favorite_pricebook_items" */
  updateFavoritePricebookItems?: Maybe<FavoritePricebookItemsMutationResponse>;
  /** update single row of the table: "favorite_pricebook_items" */
  updateFavoritePricebookItemsByPk?: Maybe<FavoritePricebookItems>;
  /** update multiples rows of table: "favorite_pricebook_items" */
  updateFavoritePricebookItemsMany?: Maybe<Array<Maybe<FavoritePricebookItemsMutationResponse>>>;
  /** update data of the table: "file_links" */
  updateFileLinks?: Maybe<FileLinksMutationResponse>;
  /** update single row of the table: "file_links" */
  updateFileLinksByPk?: Maybe<FileLinks>;
  /** update multiples rows of table: "file_links" */
  updateFileLinksMany?: Maybe<Array<Maybe<FileLinksMutationResponse>>>;
  /** update data of the table: "files" */
  updateFiles?: Maybe<FilesMutationResponse>;
  /** update single row of the table: "files" */
  updateFilesByPk?: Maybe<Files>;
  /** update multiples rows of table: "files" */
  updateFilesMany?: Maybe<Array<Maybe<FilesMutationResponse>>>;
  /** update data of the table: "installed_equipment" */
  updateInstalledEquipment?: Maybe<InstalledEquipmentMutationResponse>;
  /** update single row of the table: "installed_equipment" */
  updateInstalledEquipmentByPk?: Maybe<InstalledEquipment>;
  /** update multiples rows of table: "installed_equipment" */
  updateInstalledEquipmentMany?: Maybe<Array<Maybe<InstalledEquipmentMutationResponse>>>;
  /** update data of the table: "installed_hvac_systems" */
  updateInstalledHvacSystems?: Maybe<InstalledHvacSystemsMutationResponse>;
  /** update single row of the table: "installed_hvac_systems" */
  updateInstalledHvacSystemsByPk?: Maybe<InstalledHvacSystems>;
  /** update multiples rows of table: "installed_hvac_systems" */
  updateInstalledHvacSystemsMany?: Maybe<Array<Maybe<InstalledHvacSystemsMutationResponse>>>;
  /** update data of the table: "instant_booking_weekly_schedule_entries" */
  updateInstantBookingWeeklyScheduleEntries?: Maybe<InstantBookingWeeklyScheduleEntriesMutationResponse>;
  /** update single row of the table: "instant_booking_weekly_schedule_entries" */
  updateInstantBookingWeeklyScheduleEntriesByPk?: Maybe<InstantBookingWeeklyScheduleEntries>;
  /** update multiples rows of table: "instant_booking_weekly_schedule_entries" */
  updateInstantBookingWeeklyScheduleEntriesMany?: Maybe<Array<Maybe<InstantBookingWeeklyScheduleEntriesMutationResponse>>>;
  /** update data of the table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
  updateInstantBookingWeeklyScheduleEntryBookableArrivalWindows?: Maybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMutationResponse>;
  /** update single row of the table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
  updateInstantBookingWeeklyScheduleEntryBookableArrivalWindowsByPk?: Maybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindows>;
  /** update multiples rows of table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
  updateInstantBookingWeeklyScheduleEntryBookableArrivalWindowsMany?: Maybe<Array<Maybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsMutationResponse>>>;
  /** update data of the table: "integrated_channels" */
  updateIntegratedChannels?: Maybe<IntegratedChannelsMutationResponse>;
  /** update single row of the table: "integrated_channels" */
  updateIntegratedChannelsByPk?: Maybe<IntegratedChannels>;
  /** update multiples rows of table: "integrated_channels" */
  updateIntegratedChannelsMany?: Maybe<Array<Maybe<IntegratedChannelsMutationResponse>>>;
  /** update data of the table: "integrated_message_statuses" */
  updateIntegratedMessageStatuses?: Maybe<IntegratedMessageStatusesMutationResponse>;
  /** update single row of the table: "integrated_message_statuses" */
  updateIntegratedMessageStatusesByPk?: Maybe<IntegratedMessageStatuses>;
  /** update multiples rows of table: "integrated_message_statuses" */
  updateIntegratedMessageStatusesMany?: Maybe<Array<Maybe<IntegratedMessageStatusesMutationResponse>>>;
  /** update data of the table: "integrated_message_twilio_raw_webhook_events" */
  updateIntegratedMessageTwilioRawWebhookEvents?: Maybe<IntegratedMessageTwilioRawWebhookEventsMutationResponse>;
  /** update single row of the table: "integrated_message_twilio_raw_webhook_events" */
  updateIntegratedMessageTwilioRawWebhookEventsByPk?: Maybe<IntegratedMessageTwilioRawWebhookEvents>;
  /** update multiples rows of table: "integrated_message_twilio_raw_webhook_events" */
  updateIntegratedMessageTwilioRawWebhookEventsMany?: Maybe<Array<Maybe<IntegratedMessageTwilioRawWebhookEventsMutationResponse>>>;
  /** update data of the table: "integrated_messages" */
  updateIntegratedMessages?: Maybe<IntegratedMessagesMutationResponse>;
  /** update single row of the table: "integrated_messages" */
  updateIntegratedMessagesByPk?: Maybe<IntegratedMessages>;
  /** update multiples rows of table: "integrated_messages" */
  updateIntegratedMessagesMany?: Maybe<Array<Maybe<IntegratedMessagesMutationResponse>>>;
  /** update data of the table: "integrated_phone_call_dismissals" */
  updateIntegratedPhoneCallDismissals?: Maybe<IntegratedPhoneCallDismissalsMutationResponse>;
  /** update single row of the table: "integrated_phone_call_dismissals" */
  updateIntegratedPhoneCallDismissalsByPk?: Maybe<IntegratedPhoneCallDismissals>;
  /** update multiples rows of table: "integrated_phone_call_dismissals" */
  updateIntegratedPhoneCallDismissalsMany?: Maybe<Array<Maybe<IntegratedPhoneCallDismissalsMutationResponse>>>;
  /** update data of the table: "integrated_phone_call_jobs" */
  updateIntegratedPhoneCallJobs?: Maybe<IntegratedPhoneCallJobsMutationResponse>;
  /** update single row of the table: "integrated_phone_call_jobs" */
  updateIntegratedPhoneCallJobsByPk?: Maybe<IntegratedPhoneCallJobs>;
  /** update multiples rows of table: "integrated_phone_call_jobs" */
  updateIntegratedPhoneCallJobsMany?: Maybe<Array<Maybe<IntegratedPhoneCallJobsMutationResponse>>>;
  /** update data of the table: "integrated_phone_call_recording" */
  updateIntegratedPhoneCallRecording?: Maybe<IntegratedPhoneCallRecordingMutationResponse>;
  /** update single row of the table: "integrated_phone_call_recording" */
  updateIntegratedPhoneCallRecordingByPk?: Maybe<IntegratedPhoneCallRecording>;
  /** update multiples rows of table: "integrated_phone_call_recording" */
  updateIntegratedPhoneCallRecordingMany?: Maybe<Array<Maybe<IntegratedPhoneCallRecordingMutationResponse>>>;
  /** update data of the table: "integrated_phone_call_status_types" */
  updateIntegratedPhoneCallStatusTypes?: Maybe<IntegratedPhoneCallStatusTypesMutationResponse>;
  /** update single row of the table: "integrated_phone_call_status_types" */
  updateIntegratedPhoneCallStatusTypesByPk?: Maybe<IntegratedPhoneCallStatusTypes>;
  /** update multiples rows of table: "integrated_phone_call_status_types" */
  updateIntegratedPhoneCallStatusTypesMany?: Maybe<Array<Maybe<IntegratedPhoneCallStatusTypesMutationResponse>>>;
  /** update data of the table: "integrated_phone_call_statuses" */
  updateIntegratedPhoneCallStatuses?: Maybe<IntegratedPhoneCallStatusesMutationResponse>;
  /** update single row of the table: "integrated_phone_call_statuses" */
  updateIntegratedPhoneCallStatusesByPk?: Maybe<IntegratedPhoneCallStatuses>;
  /** update multiples rows of table: "integrated_phone_call_statuses" */
  updateIntegratedPhoneCallStatusesMany?: Maybe<Array<Maybe<IntegratedPhoneCallStatusesMutationResponse>>>;
  /** update data of the table: "integrated_phone_calls" */
  updateIntegratedPhoneCalls?: Maybe<IntegratedPhoneCallsMutationResponse>;
  /** update single row of the table: "integrated_phone_calls" */
  updateIntegratedPhoneCallsByPk?: Maybe<IntegratedPhoneCalls>;
  /** update multiples rows of table: "integrated_phone_calls" */
  updateIntegratedPhoneCallsMany?: Maybe<Array<Maybe<IntegratedPhoneCallsMutationResponse>>>;
  /** update data of the table: "integrated_phone_company_config" */
  updateIntegratedPhoneCompanyConfig?: Maybe<IntegratedPhoneCompanyConfigMutationResponse>;
  /** update single row of the table: "integrated_phone_company_config" */
  updateIntegratedPhoneCompanyConfigByPk?: Maybe<IntegratedPhoneCompanyConfig>;
  /** update multiples rows of table: "integrated_phone_company_config" */
  updateIntegratedPhoneCompanyConfigMany?: Maybe<Array<Maybe<IntegratedPhoneCompanyConfigMutationResponse>>>;
  /** update data of the table: "integrated_phone_missed_call_dismissals" */
  updateIntegratedPhoneMissedCallDismissals?: Maybe<IntegratedPhoneMissedCallDismissalsMutationResponse>;
  /** update single row of the table: "integrated_phone_missed_call_dismissals" */
  updateIntegratedPhoneMissedCallDismissalsByPk?: Maybe<IntegratedPhoneMissedCallDismissals>;
  /** update multiples rows of table: "integrated_phone_missed_call_dismissals" */
  updateIntegratedPhoneMissedCallDismissalsMany?: Maybe<Array<Maybe<IntegratedPhoneMissedCallDismissalsMutationResponse>>>;
  /** update data of the table: "integrated_phone_missed_calls" */
  updateIntegratedPhoneMissedCalls?: Maybe<IntegratedPhoneMissedCallsMutationResponse>;
  /** update single row of the table: "integrated_phone_missed_calls" */
  updateIntegratedPhoneMissedCallsByPk?: Maybe<IntegratedPhoneMissedCalls>;
  /** update multiples rows of table: "integrated_phone_missed_calls" */
  updateIntegratedPhoneMissedCallsMany?: Maybe<Array<Maybe<IntegratedPhoneMissedCallsMutationResponse>>>;
  /** update data of the table: "integrated_phone_twilio_raw_webhook_events" */
  updateIntegratedPhoneTwilioRawWebhookEvents?: Maybe<IntegratedPhoneTwilioRawWebhookEventsMutationResponse>;
  /** update single row of the table: "integrated_phone_twilio_raw_webhook_events" */
  updateIntegratedPhoneTwilioRawWebhookEventsByPk?: Maybe<IntegratedPhoneTwilioRawWebhookEvents>;
  /** update multiples rows of table: "integrated_phone_twilio_raw_webhook_events" */
  updateIntegratedPhoneTwilioRawWebhookEventsMany?: Maybe<Array<Maybe<IntegratedPhoneTwilioRawWebhookEventsMutationResponse>>>;
  /** update data of the table: "integrated_phone_users" */
  updateIntegratedPhoneUsers?: Maybe<IntegratedPhoneUsersMutationResponse>;
  /** update single row of the table: "integrated_phone_users" */
  updateIntegratedPhoneUsersByPk?: Maybe<IntegratedPhoneUsers>;
  /** update multiples rows of table: "integrated_phone_users" */
  updateIntegratedPhoneUsersMany?: Maybe<Array<Maybe<IntegratedPhoneUsersMutationResponse>>>;
  /** update data of the table: "integrated_phone_voicemail_dismissals" */
  updateIntegratedPhoneVoicemailDismissals?: Maybe<IntegratedPhoneVoicemailDismissalsMutationResponse>;
  /** update single row of the table: "integrated_phone_voicemail_dismissals" */
  updateIntegratedPhoneVoicemailDismissalsByPk?: Maybe<IntegratedPhoneVoicemailDismissals>;
  /** update multiples rows of table: "integrated_phone_voicemail_dismissals" */
  updateIntegratedPhoneVoicemailDismissalsMany?: Maybe<Array<Maybe<IntegratedPhoneVoicemailDismissalsMutationResponse>>>;
  /** update data of the table: "integrated_phone_voicemails" */
  updateIntegratedPhoneVoicemails?: Maybe<IntegratedPhoneVoicemailsMutationResponse>;
  /** update single row of the table: "integrated_phone_voicemails" */
  updateIntegratedPhoneVoicemailsByPk?: Maybe<IntegratedPhoneVoicemails>;
  /** update multiples rows of table: "integrated_phone_voicemails" */
  updateIntegratedPhoneVoicemailsMany?: Maybe<Array<Maybe<IntegratedPhoneVoicemailsMutationResponse>>>;
  /** update data of the table: "integrated_phones" */
  updateIntegratedPhones?: Maybe<IntegratedPhonesMutationResponse>;
  /** update single row of the table: "integrated_phones" */
  updateIntegratedPhonesByPk?: Maybe<IntegratedPhones>;
  /** update multiples rows of table: "integrated_phones" */
  updateIntegratedPhonesMany?: Maybe<Array<Maybe<IntegratedPhonesMutationResponse>>>;
  /** update data of the table: "internal_notifications" */
  updateInternalNotifications?: Maybe<InternalNotificationsMutationResponse>;
  /** update single row of the table: "internal_notifications" */
  updateInternalNotificationsByPk?: Maybe<InternalNotifications>;
  /** update multiples rows of table: "internal_notifications" */
  updateInternalNotificationsMany?: Maybe<Array<Maybe<InternalNotificationsMutationResponse>>>;
  /** update data of the table: "invoice_cart_item_bundle_items" */
  updateInvoiceCartItemBundleItems?: Maybe<InvoiceCartItemBundleItemsMutationResponse>;
  /** update single row of the table: "invoice_cart_item_bundle_items" */
  updateInvoiceCartItemBundleItemsByPk?: Maybe<InvoiceCartItemBundleItems>;
  /** update multiples rows of table: "invoice_cart_item_bundle_items" */
  updateInvoiceCartItemBundleItemsMany?: Maybe<Array<Maybe<InvoiceCartItemBundleItemsMutationResponse>>>;
  /** update data of the table: "invoice_cart_item_bundle_job_cost_links" */
  updateInvoiceCartItemBundleJobCostLinks?: Maybe<InvoiceCartItemBundleJobCostLinksMutationResponse>;
  /** update single row of the table: "invoice_cart_item_bundle_job_cost_links" */
  updateInvoiceCartItemBundleJobCostLinksByPk?: Maybe<InvoiceCartItemBundleJobCostLinks>;
  /** update multiples rows of table: "invoice_cart_item_bundle_job_cost_links" */
  updateInvoiceCartItemBundleJobCostLinksMany?: Maybe<Array<Maybe<InvoiceCartItemBundleJobCostLinksMutationResponse>>>;
  /** update data of the table: "invoice_cart_items" */
  updateInvoiceCartItems?: Maybe<InvoiceCartItemsMutationResponse>;
  /** update single row of the table: "invoice_cart_items" */
  updateInvoiceCartItemsByPk?: Maybe<InvoiceCartItems>;
  /** update multiples rows of table: "invoice_cart_items" */
  updateInvoiceCartItemsMany?: Maybe<Array<Maybe<InvoiceCartItemsMutationResponse>>>;
  /** update data of the table: "invoice_discounts" */
  updateInvoiceDiscounts?: Maybe<InvoiceDiscountsMutationResponse>;
  /** update single row of the table: "invoice_discounts" */
  updateInvoiceDiscountsByPk?: Maybe<InvoiceDiscounts>;
  /** update multiples rows of table: "invoice_discounts" */
  updateInvoiceDiscountsMany?: Maybe<Array<Maybe<InvoiceDiscountsMutationResponse>>>;
  /** update data of the table: "invoice_events" */
  updateInvoiceEvents?: Maybe<InvoiceEventsMutationResponse>;
  /** update single row of the table: "invoice_events" */
  updateInvoiceEventsByPk?: Maybe<InvoiceEvents>;
  /** update multiples rows of table: "invoice_events" */
  updateInvoiceEventsMany?: Maybe<Array<Maybe<InvoiceEventsMutationResponse>>>;
  /** update data of the table: "invoice_payments" */
  updateInvoicePayments?: Maybe<InvoicePaymentsMutationResponse>;
  /** update single row of the table: "invoice_payments" */
  updateInvoicePaymentsByPk?: Maybe<InvoicePayments>;
  /** update multiples rows of table: "invoice_payments" */
  updateInvoicePaymentsMany?: Maybe<Array<Maybe<InvoicePaymentsMutationResponse>>>;
  /** update data of the table: "invoice_reminder_data" */
  updateInvoiceReminderData?: Maybe<InvoiceReminderDataMutationResponse>;
  /** update single row of the table: "invoice_reminder_data" */
  updateInvoiceReminderDataByPk?: Maybe<InvoiceReminderData>;
  /** update multiples rows of table: "invoice_reminder_data" */
  updateInvoiceReminderDataMany?: Maybe<Array<Maybe<InvoiceReminderDataMutationResponse>>>;
  /** update data of the table: "invoice_template_cart_items" */
  updateInvoiceTemplateCartItems?: Maybe<InvoiceTemplateCartItemsMutationResponse>;
  /** update single row of the table: "invoice_template_cart_items" */
  updateInvoiceTemplateCartItemsByPk?: Maybe<InvoiceTemplateCartItems>;
  /** update multiples rows of table: "invoice_template_cart_items" */
  updateInvoiceTemplateCartItemsMany?: Maybe<Array<Maybe<InvoiceTemplateCartItemsMutationResponse>>>;
  /** update data of the table: "invoice_templates" */
  updateInvoiceTemplates?: Maybe<InvoiceTemplatesMutationResponse>;
  /** update single row of the table: "invoice_templates" */
  updateInvoiceTemplatesByPk?: Maybe<InvoiceTemplates>;
  /** update multiples rows of table: "invoice_templates" */
  updateInvoiceTemplatesMany?: Maybe<Array<Maybe<InvoiceTemplatesMutationResponse>>>;
  /** update data of the table: "invoices" */
  updateInvoices?: Maybe<InvoicesMutationResponse>;
  /** update single row of the table: "invoices" */
  updateInvoicesByPk?: Maybe<Invoices>;
  /** update multiples rows of table: "invoices" */
  updateInvoicesMany?: Maybe<Array<Maybe<InvoicesMutationResponse>>>;
  /** update data of the table: "invoices_queryable" */
  updateInvoicesQueryable?: Maybe<InvoicesQueryableMutationResponse>;
  /** update single row of the table: "invoices_queryable" */
  updateInvoicesQueryableByPk?: Maybe<InvoicesQueryable>;
  /** update multiples rows of table: "invoices_queryable" */
  updateInvoicesQueryableMany?: Maybe<Array<Maybe<InvoicesQueryableMutationResponse>>>;
  /** update data of the table: "job_appointment_assignment_status_types" */
  updateJobAppointmentAssignmentStatusTypes?: Maybe<JobAppointmentAssignmentStatusTypesMutationResponse>;
  /** update single row of the table: "job_appointment_assignment_status_types" */
  updateJobAppointmentAssignmentStatusTypesByPk?: Maybe<JobAppointmentAssignmentStatusTypes>;
  /** update multiples rows of table: "job_appointment_assignment_status_types" */
  updateJobAppointmentAssignmentStatusTypesMany?: Maybe<Array<Maybe<JobAppointmentAssignmentStatusTypesMutationResponse>>>;
  /** update data of the table: "job_appointment_assignment_statuses" */
  updateJobAppointmentAssignmentStatuses?: Maybe<JobAppointmentAssignmentStatusesMutationResponse>;
  /** update single row of the table: "job_appointment_assignment_statuses" */
  updateJobAppointmentAssignmentStatusesByPk?: Maybe<JobAppointmentAssignmentStatuses>;
  /** update multiples rows of table: "job_appointment_assignment_statuses" */
  updateJobAppointmentAssignmentStatusesMany?: Maybe<Array<Maybe<JobAppointmentAssignmentStatusesMutationResponse>>>;
  /** update data of the table: "job_appointment_assignments" */
  updateJobAppointmentAssignments?: Maybe<JobAppointmentAssignmentsMutationResponse>;
  /** update single row of the table: "job_appointment_assignments" */
  updateJobAppointmentAssignmentsByPk?: Maybe<JobAppointmentAssignments>;
  /** update multiples rows of table: "job_appointment_assignments" */
  updateJobAppointmentAssignmentsMany?: Maybe<Array<Maybe<JobAppointmentAssignmentsMutationResponse>>>;
  /** update data of the table: "job_appointment_cancellation_statuses" */
  updateJobAppointmentCancellationStatuses?: Maybe<JobAppointmentCancellationStatusesMutationResponse>;
  /** update single row of the table: "job_appointment_cancellation_statuses" */
  updateJobAppointmentCancellationStatusesByPk?: Maybe<JobAppointmentCancellationStatuses>;
  /** update multiples rows of table: "job_appointment_cancellation_statuses" */
  updateJobAppointmentCancellationStatusesMany?: Maybe<Array<Maybe<JobAppointmentCancellationStatusesMutationResponse>>>;
  /** update data of the table: "job_appointment_confirmation_statuses" */
  updateJobAppointmentConfirmationStatuses?: Maybe<JobAppointmentConfirmationStatusesMutationResponse>;
  /** update single row of the table: "job_appointment_confirmation_statuses" */
  updateJobAppointmentConfirmationStatusesByPk?: Maybe<JobAppointmentConfirmationStatuses>;
  /** update multiples rows of table: "job_appointment_confirmation_statuses" */
  updateJobAppointmentConfirmationStatusesMany?: Maybe<Array<Maybe<JobAppointmentConfirmationStatusesMutationResponse>>>;
  /** update data of the table: "job_appointment_invoices" */
  updateJobAppointmentInvoices?: Maybe<JobAppointmentInvoicesMutationResponse>;
  /** update single row of the table: "job_appointment_invoices" */
  updateJobAppointmentInvoicesByPk?: Maybe<JobAppointmentInvoices>;
  /** update multiples rows of table: "job_appointment_invoices" */
  updateJobAppointmentInvoicesMany?: Maybe<Array<Maybe<JobAppointmentInvoicesMutationResponse>>>;
  /** update data of the table: "job_appointments" */
  updateJobAppointments?: Maybe<JobAppointmentsMutationResponse>;
  /** update single row of the table: "job_appointments" */
  updateJobAppointmentsByPk?: Maybe<JobAppointments>;
  /** update multiples rows of table: "job_appointments" */
  updateJobAppointmentsMany?: Maybe<Array<Maybe<JobAppointmentsMutationResponse>>>;
  /** update data of the table: "job_cost_items" */
  updateJobCostItems?: Maybe<JobCostItemsMutationResponse>;
  /** update single row of the table: "job_cost_items" */
  updateJobCostItemsByPk?: Maybe<JobCostItems>;
  /** update multiples rows of table: "job_cost_items" */
  updateJobCostItemsMany?: Maybe<Array<Maybe<JobCostItemsMutationResponse>>>;
  /** update data of the table: "job_cost_misc_categories" */
  updateJobCostMiscCategories?: Maybe<JobCostMiscCategoriesMutationResponse>;
  /** update single row of the table: "job_cost_misc_categories" */
  updateJobCostMiscCategoriesByPk?: Maybe<JobCostMiscCategories>;
  /** update multiples rows of table: "job_cost_misc_categories" */
  updateJobCostMiscCategoriesMany?: Maybe<Array<Maybe<JobCostMiscCategoriesMutationResponse>>>;
  /** update data of the table: "job_costing_config" */
  updateJobCostingConfig?: Maybe<JobCostingConfigMutationResponse>;
  /** update single row of the table: "job_costing_config" */
  updateJobCostingConfigByPk?: Maybe<JobCostingConfig>;
  /** update multiples rows of table: "job_costing_config" */
  updateJobCostingConfigMany?: Maybe<Array<Maybe<JobCostingConfigMutationResponse>>>;
  /** update data of the table: "job_invoices" */
  updateJobInvoices?: Maybe<JobInvoicesMutationResponse>;
  /** update single row of the table: "job_invoices" */
  updateJobInvoicesByPk?: Maybe<JobInvoices>;
  /** update multiples rows of table: "job_invoices" */
  updateJobInvoicesMany?: Maybe<Array<Maybe<JobInvoicesMutationResponse>>>;
  /** update data of the table: "job_leads" */
  updateJobLeads?: Maybe<JobLeadsMutationResponse>;
  /** update single row of the table: "job_leads" */
  updateJobLeadsByPk?: Maybe<JobLeads>;
  /** update multiples rows of table: "job_leads" */
  updateJobLeadsMany?: Maybe<Array<Maybe<JobLeadsMutationResponse>>>;
  /** update data of the table: "job_lifecycle_statuses" */
  updateJobLifecycleStatuses?: Maybe<JobLifecycleStatusesMutationResponse>;
  /** update single row of the table: "job_lifecycle_statuses" */
  updateJobLifecycleStatusesByPk?: Maybe<JobLifecycleStatuses>;
  /** update multiples rows of table: "job_lifecycle_statuses" */
  updateJobLifecycleStatusesMany?: Maybe<Array<Maybe<JobLifecycleStatusesMutationResponse>>>;
  /** update data of the table: "job_lifecycle_types" */
  updateJobLifecycleTypes?: Maybe<JobLifecycleTypesMutationResponse>;
  /** update single row of the table: "job_lifecycle_types" */
  updateJobLifecycleTypesByPk?: Maybe<JobLifecycleTypes>;
  /** update multiples rows of table: "job_lifecycle_types" */
  updateJobLifecycleTypesMany?: Maybe<Array<Maybe<JobLifecycleTypesMutationResponse>>>;
  /** update data of the table: "job_lifecycle_views" */
  updateJobLifecycleViews?: Maybe<JobLifecycleViewsMutationResponse>;
  /** update single row of the table: "job_lifecycle_views" */
  updateJobLifecycleViewsByPk?: Maybe<JobLifecycleViews>;
  /** update multiples rows of table: "job_lifecycle_views" */
  updateJobLifecycleViewsMany?: Maybe<Array<Maybe<JobLifecycleViewsMutationResponse>>>;
  /** update data of the table: "job_lifecycles" */
  updateJobLifecycles?: Maybe<JobLifecyclesMutationResponse>;
  /** update single row of the table: "job_lifecycles" */
  updateJobLifecyclesByPk?: Maybe<JobLifecycles>;
  /** update multiples rows of table: "job_lifecycles" */
  updateJobLifecyclesMany?: Maybe<Array<Maybe<JobLifecyclesMutationResponse>>>;
  /** update data of the table: "job_requests_company_config" */
  updateJobRequestsCompanyConfig?: Maybe<JobRequestsCompanyConfigMutationResponse>;
  /** update single row of the table: "job_requests_company_config" */
  updateJobRequestsCompanyConfigByPk?: Maybe<JobRequestsCompanyConfig>;
  /** update multiples rows of table: "job_requests_company_config" */
  updateJobRequestsCompanyConfigMany?: Maybe<Array<Maybe<JobRequestsCompanyConfigMutationResponse>>>;
  /** update data of the table: "job_tags" */
  updateJobTags?: Maybe<JobTagsMutationResponse>;
  /** update single row of the table: "job_tags" */
  updateJobTagsByPk?: Maybe<JobTags>;
  /** update multiples rows of table: "job_tags" */
  updateJobTagsMany?: Maybe<Array<Maybe<JobTagsMutationResponse>>>;
  /** update data of the table: "job_team_members" */
  updateJobTeamMembers?: Maybe<JobTeamMembersMutationResponse>;
  /** update single row of the table: "job_team_members" */
  updateJobTeamMembersByPk?: Maybe<JobTeamMembers>;
  /** update multiples rows of table: "job_team_members" */
  updateJobTeamMembersMany?: Maybe<Array<Maybe<JobTeamMembersMutationResponse>>>;
  /** update data of the table: "job_technician_earned_revenue_attributions" */
  updateJobTechnicianEarnedRevenueAttributions?: Maybe<JobTechnicianEarnedRevenueAttributionsMutationResponse>;
  /** update single row of the table: "job_technician_earned_revenue_attributions" */
  updateJobTechnicianEarnedRevenueAttributionsByPk?: Maybe<JobTechnicianEarnedRevenueAttributions>;
  /** update multiples rows of table: "job_technician_earned_revenue_attributions" */
  updateJobTechnicianEarnedRevenueAttributionsMany?: Maybe<Array<Maybe<JobTechnicianEarnedRevenueAttributionsMutationResponse>>>;
  /** update data of the table: "job_technician_sold_revenue_attributions" */
  updateJobTechnicianSoldRevenueAttributions?: Maybe<JobTechnicianSoldRevenueAttributionsMutationResponse>;
  /** update single row of the table: "job_technician_sold_revenue_attributions" */
  updateJobTechnicianSoldRevenueAttributionsByPk?: Maybe<JobTechnicianSoldRevenueAttributions>;
  /** update multiples rows of table: "job_technician_sold_revenue_attributions" */
  updateJobTechnicianSoldRevenueAttributionsMany?: Maybe<Array<Maybe<JobTechnicianSoldRevenueAttributionsMutationResponse>>>;
  /** update data of the table: "job_type_change_reasons" */
  updateJobTypeChangeReasons?: Maybe<JobTypeChangeReasonsMutationResponse>;
  /** update single row of the table: "job_type_change_reasons" */
  updateJobTypeChangeReasonsByPk?: Maybe<JobTypeChangeReasons>;
  /** update multiples rows of table: "job_type_change_reasons" */
  updateJobTypeChangeReasonsMany?: Maybe<Array<Maybe<JobTypeChangeReasonsMutationResponse>>>;
  /** update data of the table: "job_types" */
  updateJobTypes?: Maybe<JobTypesMutationResponse>;
  /** update single row of the table: "job_types" */
  updateJobTypesByPk?: Maybe<JobTypes>;
  /** update multiples rows of table: "job_types" */
  updateJobTypesMany?: Maybe<Array<Maybe<JobTypesMutationResponse>>>;
  /** update data of the table: "jobs" */
  updateJobs?: Maybe<JobsMutationResponse>;
  /** update single row of the table: "jobs" */
  updateJobsByPk?: Maybe<Jobs>;
  /** update multiples rows of table: "jobs" */
  updateJobsMany?: Maybe<Array<Maybe<JobsMutationResponse>>>;
  /** update data of the table: "jobs_with_linked_job" */
  updateJobsWithLinkedJob?: Maybe<JobsWithLinkedJobMutationResponse>;
  /** update single row of the table: "jobs_with_linked_job" */
  updateJobsWithLinkedJobByPk?: Maybe<JobsWithLinkedJob>;
  /** update data of the table: "jobs_with_linked_job_linked_appointment_checklist_instances" */
  updateJobsWithLinkedJobLinkedAppointmentChecklistInstances?: Maybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesMutationResponse>;
  /** update single row of the table: "jobs_with_linked_job_linked_appointment_checklist_instances" */
  updateJobsWithLinkedJobLinkedAppointmentChecklistInstancesByPk?: Maybe<JobsWithLinkedJobLinkedAppointmentChecklistInstances>;
  /** update multiples rows of table: "jobs_with_linked_job_linked_appointment_checklist_instances" */
  updateJobsWithLinkedJobLinkedAppointmentChecklistInstancesMany?: Maybe<Array<Maybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesMutationResponse>>>;
  /** update data of the table: "jobs_with_linked_job_linked_estimates" */
  updateJobsWithLinkedJobLinkedEstimates?: Maybe<JobsWithLinkedJobLinkedEstimatesMutationResponse>;
  /** update single row of the table: "jobs_with_linked_job_linked_estimates" */
  updateJobsWithLinkedJobLinkedEstimatesByPk?: Maybe<JobsWithLinkedJobLinkedEstimates>;
  /** update multiples rows of table: "jobs_with_linked_job_linked_estimates" */
  updateJobsWithLinkedJobLinkedEstimatesMany?: Maybe<Array<Maybe<JobsWithLinkedJobLinkedEstimatesMutationResponse>>>;
  /** update multiples rows of table: "jobs_with_linked_job" */
  updateJobsWithLinkedJobMany?: Maybe<Array<Maybe<JobsWithLinkedJobMutationResponse>>>;
  /** update data of the table: "location_contacts" */
  updateLocationContacts?: Maybe<LocationContactsMutationResponse>;
  /** update single row of the table: "location_contacts" */
  updateLocationContactsByPk?: Maybe<LocationContacts>;
  /** update multiples rows of table: "location_contacts" */
  updateLocationContactsMany?: Maybe<Array<Maybe<LocationContactsMutationResponse>>>;
  /** update data of the table: "location_invoices" */
  updateLocationInvoices?: Maybe<LocationInvoicesMutationResponse>;
  /** update single row of the table: "location_invoices" */
  updateLocationInvoicesByPk?: Maybe<LocationInvoices>;
  /** update multiples rows of table: "location_invoices" */
  updateLocationInvoicesMany?: Maybe<Array<Maybe<LocationInvoicesMutationResponse>>>;
  /** update data of the table: "locations" */
  updateLocations?: Maybe<LocationsMutationResponse>;
  /** update single row of the table: "locations" */
  updateLocationsByPk?: Maybe<Locations>;
  /** update multiples rows of table: "locations" */
  updateLocationsMany?: Maybe<Array<Maybe<LocationsMutationResponse>>>;
  /** update data of the table: "maintenance_plan_definition_allowed_payment_intervals" */
  updateMaintenancePlanDefinitionAllowedPaymentIntervals?: Maybe<MaintenancePlanDefinitionAllowedPaymentIntervalsMutationResponse>;
  /** update single row of the table: "maintenance_plan_definition_allowed_payment_intervals" */
  updateMaintenancePlanDefinitionAllowedPaymentIntervalsByPk?: Maybe<MaintenancePlanDefinitionAllowedPaymentIntervals>;
  /** update multiples rows of table: "maintenance_plan_definition_allowed_payment_intervals" */
  updateMaintenancePlanDefinitionAllowedPaymentIntervalsMany?: Maybe<Array<Maybe<MaintenancePlanDefinitionAllowedPaymentIntervalsMutationResponse>>>;
  /** update data of the table: "maintenance_plan_definition_benefits" */
  updateMaintenancePlanDefinitionBenefits?: Maybe<MaintenancePlanDefinitionBenefitsMutationResponse>;
  /** update single row of the table: "maintenance_plan_definition_benefits" */
  updateMaintenancePlanDefinitionBenefitsByPk?: Maybe<MaintenancePlanDefinitionBenefits>;
  /** update multiples rows of table: "maintenance_plan_definition_benefits" */
  updateMaintenancePlanDefinitionBenefitsMany?: Maybe<Array<Maybe<MaintenancePlanDefinitionBenefitsMutationResponse>>>;
  /** update data of the table: "maintenance_plan_definition_discounts" */
  updateMaintenancePlanDefinitionDiscounts?: Maybe<MaintenancePlanDefinitionDiscountsMutationResponse>;
  /** update single row of the table: "maintenance_plan_definition_discounts" */
  updateMaintenancePlanDefinitionDiscountsByPk?: Maybe<MaintenancePlanDefinitionDiscounts>;
  /** update multiples rows of table: "maintenance_plan_definition_discounts" */
  updateMaintenancePlanDefinitionDiscountsMany?: Maybe<Array<Maybe<MaintenancePlanDefinitionDiscountsMutationResponse>>>;
  /** update data of the table: "maintenance_plan_definition_flare" */
  updateMaintenancePlanDefinitionFlare?: Maybe<MaintenancePlanDefinitionFlareMutationResponse>;
  /** update single row of the table: "maintenance_plan_definition_flare" */
  updateMaintenancePlanDefinitionFlareByPk?: Maybe<MaintenancePlanDefinitionFlare>;
  /** update multiples rows of table: "maintenance_plan_definition_flare" */
  updateMaintenancePlanDefinitionFlareMany?: Maybe<Array<Maybe<MaintenancePlanDefinitionFlareMutationResponse>>>;
  /** update data of the table: "maintenance_plan_definition_marketing_info" */
  updateMaintenancePlanDefinitionMarketingInfo?: Maybe<MaintenancePlanDefinitionMarketingInfoMutationResponse>;
  /** update single row of the table: "maintenance_plan_definition_marketing_info" */
  updateMaintenancePlanDefinitionMarketingInfoByPk?: Maybe<MaintenancePlanDefinitionMarketingInfo>;
  /** update multiples rows of table: "maintenance_plan_definition_marketing_info" */
  updateMaintenancePlanDefinitionMarketingInfoMany?: Maybe<Array<Maybe<MaintenancePlanDefinitionMarketingInfoMutationResponse>>>;
  /** update data of the table: "maintenance_plan_definitions" */
  updateMaintenancePlanDefinitions?: Maybe<MaintenancePlanDefinitionsMutationResponse>;
  /** update single row of the table: "maintenance_plan_definitions" */
  updateMaintenancePlanDefinitionsByPk?: Maybe<MaintenancePlanDefinitions>;
  /** update multiples rows of table: "maintenance_plan_definitions" */
  updateMaintenancePlanDefinitionsMany?: Maybe<Array<Maybe<MaintenancePlanDefinitionsMutationResponse>>>;
  /** update data of the table: "maintenance_plan_equipment_coverage_definitions" */
  updateMaintenancePlanEquipmentCoverageDefinitions?: Maybe<MaintenancePlanEquipmentCoverageDefinitionsMutationResponse>;
  /** update single row of the table: "maintenance_plan_equipment_coverage_definitions" */
  updateMaintenancePlanEquipmentCoverageDefinitionsByPk?: Maybe<MaintenancePlanEquipmentCoverageDefinitions>;
  /** update multiples rows of table: "maintenance_plan_equipment_coverage_definitions" */
  updateMaintenancePlanEquipmentCoverageDefinitionsMany?: Maybe<Array<Maybe<MaintenancePlanEquipmentCoverageDefinitionsMutationResponse>>>;
  /** update data of the table: "maintenance_plan_equipment_coverage_pricings" */
  updateMaintenancePlanEquipmentCoveragePricings?: Maybe<MaintenancePlanEquipmentCoveragePricingsMutationResponse>;
  /** update single row of the table: "maintenance_plan_equipment_coverage_pricings" */
  updateMaintenancePlanEquipmentCoveragePricingsByPk?: Maybe<MaintenancePlanEquipmentCoveragePricings>;
  /** update multiples rows of table: "maintenance_plan_equipment_coverage_pricings" */
  updateMaintenancePlanEquipmentCoveragePricingsMany?: Maybe<Array<Maybe<MaintenancePlanEquipmentCoveragePricingsMutationResponse>>>;
  /** update data of the table: "maintenance_plan_invoices" */
  updateMaintenancePlanInvoices?: Maybe<MaintenancePlanInvoicesMutationResponse>;
  /** update single row of the table: "maintenance_plan_invoices" */
  updateMaintenancePlanInvoicesByPk?: Maybe<MaintenancePlanInvoices>;
  /** update multiples rows of table: "maintenance_plan_invoices" */
  updateMaintenancePlanInvoicesMany?: Maybe<Array<Maybe<MaintenancePlanInvoicesMutationResponse>>>;
  /** update data of the table: "maintenance_plan_visit_installed_equipments" */
  updateMaintenancePlanVisitInstalledEquipments?: Maybe<MaintenancePlanVisitInstalledEquipmentsMutationResponse>;
  /** update single row of the table: "maintenance_plan_visit_installed_equipments" */
  updateMaintenancePlanVisitInstalledEquipmentsByPk?: Maybe<MaintenancePlanVisitInstalledEquipments>;
  /** update multiples rows of table: "maintenance_plan_visit_installed_equipments" */
  updateMaintenancePlanVisitInstalledEquipmentsMany?: Maybe<Array<Maybe<MaintenancePlanVisitInstalledEquipmentsMutationResponse>>>;
  /** update data of the table: "maintenance_plan_visits" */
  updateMaintenancePlanVisits?: Maybe<MaintenancePlanVisitsMutationResponse>;
  /** update single row of the table: "maintenance_plan_visits" */
  updateMaintenancePlanVisitsByPk?: Maybe<MaintenancePlanVisits>;
  /** update multiples rows of table: "maintenance_plan_visits" */
  updateMaintenancePlanVisitsMany?: Maybe<Array<Maybe<MaintenancePlanVisitsMutationResponse>>>;
  /** update data of the table: "maintenance_plans_queryable" */
  updateMaintenancePlansQueryable?: Maybe<MaintenancePlansQueryableMutationResponse>;
  /** update single row of the table: "maintenance_plans_queryable" */
  updateMaintenancePlansQueryableByPk?: Maybe<MaintenancePlansQueryable>;
  /** update multiples rows of table: "maintenance_plans_queryable" */
  updateMaintenancePlansQueryableMany?: Maybe<Array<Maybe<MaintenancePlansQueryableMutationResponse>>>;
  /** update data of the table: "migration_junk" */
  updateMigrationJunk?: Maybe<MigrationJunkMutationResponse>;
  /** update single row of the table: "migration_junk" */
  updateMigrationJunkByPk?: Maybe<MigrationJunk>;
  /** update data of the table: "migration_junk_links" */
  updateMigrationJunkLinks?: Maybe<MigrationJunkLinksMutationResponse>;
  /** update single row of the table: "migration_junk_links" */
  updateMigrationJunkLinksByPk?: Maybe<MigrationJunkLinks>;
  /** update multiples rows of table: "migration_junk_links" */
  updateMigrationJunkLinksMany?: Maybe<Array<Maybe<MigrationJunkLinksMutationResponse>>>;
  /** update multiples rows of table: "migration_junk" */
  updateMigrationJunkMany?: Maybe<Array<Maybe<MigrationJunkMutationResponse>>>;
  /** update data of the table: "note_attachments" */
  updateNoteAttachments?: Maybe<NoteAttachmentsMutationResponse>;
  /** update single row of the table: "note_attachments" */
  updateNoteAttachmentsByPk?: Maybe<NoteAttachments>;
  /** update multiples rows of table: "note_attachments" */
  updateNoteAttachmentsMany?: Maybe<Array<Maybe<NoteAttachmentsMutationResponse>>>;
  /** update data of the table: "note_links" */
  updateNoteLinks?: Maybe<NoteLinksMutationResponse>;
  /** update single row of the table: "note_links" */
  updateNoteLinksByPk?: Maybe<NoteLinks>;
  /** update multiples rows of table: "note_links" */
  updateNoteLinksMany?: Maybe<Array<Maybe<NoteLinksMutationResponse>>>;
  /** update data of the table: "note_tagged_users" */
  updateNoteTaggedUsers?: Maybe<NoteTaggedUsersMutationResponse>;
  /** update single row of the table: "note_tagged_users" */
  updateNoteTaggedUsersByPk?: Maybe<NoteTaggedUsers>;
  /** update multiples rows of table: "note_tagged_users" */
  updateNoteTaggedUsersMany?: Maybe<Array<Maybe<NoteTaggedUsersMutationResponse>>>;
  /** update data of the table: "notes" */
  updateNotes?: Maybe<NotesMutationResponse>;
  /** update single row of the table: "notes" */
  updateNotesByPk?: Maybe<Notes>;
  /** update multiples rows of table: "notes" */
  updateNotesMany?: Maybe<Array<Maybe<NotesMutationResponse>>>;
  /** update data of the table: "online_booking_company_config" */
  updateOnlineBookingCompanyConfig?: Maybe<OnlineBookingCompanyConfigMutationResponse>;
  /** update single row of the table: "online_booking_company_config" */
  updateOnlineBookingCompanyConfigByPk?: Maybe<OnlineBookingCompanyConfig>;
  /** update multiples rows of table: "online_booking_company_config" */
  updateOnlineBookingCompanyConfigMany?: Maybe<Array<Maybe<OnlineBookingCompanyConfigMutationResponse>>>;
  /** update data of the table: "online_booking_service_area_zip_codes" */
  updateOnlineBookingServiceAreaZipCodes?: Maybe<OnlineBookingServiceAreaZipCodesMutationResponse>;
  /** update single row of the table: "online_booking_service_area_zip_codes" */
  updateOnlineBookingServiceAreaZipCodesByPk?: Maybe<OnlineBookingServiceAreaZipCodes>;
  /** update multiples rows of table: "online_booking_service_area_zip_codes" */
  updateOnlineBookingServiceAreaZipCodesMany?: Maybe<Array<Maybe<OnlineBookingServiceAreaZipCodesMutationResponse>>>;
  /** update data of the table: "online_booking_service_type_bookable_job_types" */
  updateOnlineBookingServiceTypeBookableJobTypes?: Maybe<OnlineBookingServiceTypeBookableJobTypesMutationResponse>;
  /** update single row of the table: "online_booking_service_type_bookable_job_types" */
  updateOnlineBookingServiceTypeBookableJobTypesByPk?: Maybe<OnlineBookingServiceTypeBookableJobTypes>;
  /** update multiples rows of table: "online_booking_service_type_bookable_job_types" */
  updateOnlineBookingServiceTypeBookableJobTypesMany?: Maybe<Array<Maybe<OnlineBookingServiceTypeBookableJobTypesMutationResponse>>>;
  /** update data of the table: "online_booking_service_type_bookable_technicians" */
  updateOnlineBookingServiceTypeBookableTechnicians?: Maybe<OnlineBookingServiceTypeBookableTechniciansMutationResponse>;
  /** update single row of the table: "online_booking_service_type_bookable_technicians" */
  updateOnlineBookingServiceTypeBookableTechniciansByPk?: Maybe<OnlineBookingServiceTypeBookableTechnicians>;
  /** update multiples rows of table: "online_booking_service_type_bookable_technicians" */
  updateOnlineBookingServiceTypeBookableTechniciansMany?: Maybe<Array<Maybe<OnlineBookingServiceTypeBookableTechniciansMutationResponse>>>;
  /** update data of the table: "online_booking_service_type_configs" */
  updateOnlineBookingServiceTypeConfigs?: Maybe<OnlineBookingServiceTypeConfigsMutationResponse>;
  /** update single row of the table: "online_booking_service_type_configs" */
  updateOnlineBookingServiceTypeConfigsByPk?: Maybe<OnlineBookingServiceTypeConfigs>;
  /** update multiples rows of table: "online_booking_service_type_configs" */
  updateOnlineBookingServiceTypeConfigsMany?: Maybe<Array<Maybe<OnlineBookingServiceTypeConfigsMutationResponse>>>;
  /** update data of the table: "payment_links" */
  updatePaymentLinks?: Maybe<PaymentLinksMutationResponse>;
  /** update single row of the table: "payment_links" */
  updatePaymentLinksByPk?: Maybe<PaymentLinks>;
  /** update multiples rows of table: "payment_links" */
  updatePaymentLinksMany?: Maybe<Array<Maybe<PaymentLinksMutationResponse>>>;
  /** update data of the table: "payment_method_billing_info" */
  updatePaymentMethodBillingInfo?: Maybe<PaymentMethodBillingInfoMutationResponse>;
  /** update single row of the table: "payment_method_billing_info" */
  updatePaymentMethodBillingInfoByPk?: Maybe<PaymentMethodBillingInfo>;
  /** update multiples rows of table: "payment_method_billing_info" */
  updatePaymentMethodBillingInfoMany?: Maybe<Array<Maybe<PaymentMethodBillingInfoMutationResponse>>>;
  /** update data of the table: "payment_method_card_metadata" */
  updatePaymentMethodCardMetadata?: Maybe<PaymentMethodCardMetadataMutationResponse>;
  /** update single row of the table: "payment_method_card_metadata" */
  updatePaymentMethodCardMetadataByPk?: Maybe<PaymentMethodCardMetadata>;
  /** update multiples rows of table: "payment_method_card_metadata" */
  updatePaymentMethodCardMetadataMany?: Maybe<Array<Maybe<PaymentMethodCardMetadataMutationResponse>>>;
  /** update data of the table: "payment_method_records" */
  updatePaymentMethodRecords?: Maybe<PaymentMethodRecordsMutationResponse>;
  /** update single row of the table: "payment_method_records" */
  updatePaymentMethodRecordsByPk?: Maybe<PaymentMethodRecords>;
  /** update multiples rows of table: "payment_method_records" */
  updatePaymentMethodRecordsMany?: Maybe<Array<Maybe<PaymentMethodRecordsMutationResponse>>>;
  /** update data of the table: "payment_records" */
  updatePaymentRecords?: Maybe<PaymentRecordsMutationResponse>;
  /** update single row of the table: "payment_records" */
  updatePaymentRecordsByPk?: Maybe<PaymentRecords>;
  /** update multiples rows of table: "payment_records" */
  updatePaymentRecordsMany?: Maybe<Array<Maybe<PaymentRecordsMutationResponse>>>;
  /** update data of the table: "payment_refunds" */
  updatePaymentRefunds?: Maybe<PaymentRefundsMutationResponse>;
  /** update single row of the table: "payment_refunds" */
  updatePaymentRefundsByPk?: Maybe<PaymentRefunds>;
  /** update multiples rows of table: "payment_refunds" */
  updatePaymentRefundsMany?: Maybe<Array<Maybe<PaymentRefundsMutationResponse>>>;
  /** update data of the table: "payment_status_error_detail" */
  updatePaymentStatusErrorDetail?: Maybe<PaymentStatusErrorDetailMutationResponse>;
  /** update single row of the table: "payment_status_error_detail" */
  updatePaymentStatusErrorDetailByPk?: Maybe<PaymentStatusErrorDetail>;
  /** update multiples rows of table: "payment_status_error_detail" */
  updatePaymentStatusErrorDetailMany?: Maybe<Array<Maybe<PaymentStatusErrorDetailMutationResponse>>>;
  /** update data of the table: "payment_status_latest" */
  updatePaymentStatusLatest?: Maybe<PaymentStatusLatestMutationResponse>;
  /** update single row of the table: "payment_status_latest" */
  updatePaymentStatusLatestByPk?: Maybe<PaymentStatusLatest>;
  /** update multiples rows of table: "payment_status_latest" */
  updatePaymentStatusLatestMany?: Maybe<Array<Maybe<PaymentStatusLatestMutationResponse>>>;
  /** update data of the table: "payment_statuses" */
  updatePaymentStatuses?: Maybe<PaymentStatusesMutationResponse>;
  /** update single row of the table: "payment_statuses" */
  updatePaymentStatusesByPk?: Maybe<PaymentStatuses>;
  /** update multiples rows of table: "payment_statuses" */
  updatePaymentStatusesMany?: Maybe<Array<Maybe<PaymentStatusesMutationResponse>>>;
  /** update data of the table: "payment_subscription_invoices" */
  updatePaymentSubscriptionInvoices?: Maybe<PaymentSubscriptionInvoicesMutationResponse>;
  /** update single row of the table: "payment_subscription_invoices" */
  updatePaymentSubscriptionInvoicesByPk?: Maybe<PaymentSubscriptionInvoices>;
  /** update multiples rows of table: "payment_subscription_invoices" */
  updatePaymentSubscriptionInvoicesMany?: Maybe<Array<Maybe<PaymentSubscriptionInvoicesMutationResponse>>>;
  /** update data of the table: "payment_subscription_statuses" */
  updatePaymentSubscriptionStatuses?: Maybe<PaymentSubscriptionStatusesMutationResponse>;
  /** update single row of the table: "payment_subscription_statuses" */
  updatePaymentSubscriptionStatusesByPk?: Maybe<PaymentSubscriptionStatuses>;
  /** update multiples rows of table: "payment_subscription_statuses" */
  updatePaymentSubscriptionStatusesMany?: Maybe<Array<Maybe<PaymentSubscriptionStatusesMutationResponse>>>;
  /** update data of the table: "payment_subscriptions" */
  updatePaymentSubscriptions?: Maybe<PaymentSubscriptionsMutationResponse>;
  /** update single row of the table: "payment_subscriptions" */
  updatePaymentSubscriptionsByPk?: Maybe<PaymentSubscriptions>;
  /** update multiples rows of table: "payment_subscriptions" */
  updatePaymentSubscriptionsMany?: Maybe<Array<Maybe<PaymentSubscriptionsMutationResponse>>>;
  /** update data of the table: "payout_items" */
  updatePayoutItems?: Maybe<PayoutItemsMutationResponse>;
  /** update single row of the table: "payout_items" */
  updatePayoutItemsByPk?: Maybe<PayoutItems>;
  /** update multiples rows of table: "payout_items" */
  updatePayoutItemsMany?: Maybe<Array<Maybe<PayoutItemsMutationResponse>>>;
  /** update data of the table: "payout_qbo_accounts_config" */
  updatePayoutQboAccountsConfig?: Maybe<PayoutQboAccountsConfigMutationResponse>;
  /** update single row of the table: "payout_qbo_accounts_config" */
  updatePayoutQboAccountsConfigByPk?: Maybe<PayoutQboAccountsConfig>;
  /** update multiples rows of table: "payout_qbo_accounts_config" */
  updatePayoutQboAccountsConfigMany?: Maybe<Array<Maybe<PayoutQboAccountsConfigMutationResponse>>>;
  /** update data of the table: "payouts" */
  updatePayouts?: Maybe<PayoutsMutationResponse>;
  /** update single row of the table: "payouts" */
  updatePayoutsByPk?: Maybe<Payouts>;
  /** update multiples rows of table: "payouts" */
  updatePayoutsMany?: Maybe<Array<Maybe<PayoutsMutationResponse>>>;
  /** update data of the table: "phone_numbers" */
  updatePhoneNumbers?: Maybe<PhoneNumbersMutationResponse>;
  /** update single row of the table: "phone_numbers" */
  updatePhoneNumbersByPk?: Maybe<PhoneNumbers>;
  /** update multiples rows of table: "phone_numbers" */
  updatePhoneNumbersMany?: Maybe<Array<Maybe<PhoneNumbersMutationResponse>>>;
  /** update data of the table: "photo_links" */
  updatePhotoLinks?: Maybe<PhotoLinksMutationResponse>;
  /** update single row of the table: "photo_links" */
  updatePhotoLinksByPk?: Maybe<PhotoLinks>;
  /** update multiples rows of table: "photo_links" */
  updatePhotoLinksMany?: Maybe<Array<Maybe<PhotoLinksMutationResponse>>>;
  /** update data of the table: "photos" */
  updatePhotos?: Maybe<PhotosMutationResponse>;
  /** update single row of the table: "photos" */
  updatePhotosByPk?: Maybe<Photos>;
  /** update multiples rows of table: "photos" */
  updatePhotosMany?: Maybe<Array<Maybe<PhotosMutationResponse>>>;
  /** update data of the table: "pricebook_bundle_items" */
  updatePricebookBundleItems?: Maybe<PricebookBundleItemsMutationResponse>;
  /** update single row of the table: "pricebook_bundle_items" */
  updatePricebookBundleItemsByPk?: Maybe<PricebookBundleItems>;
  /** update multiples rows of table: "pricebook_bundle_items" */
  updatePricebookBundleItemsMany?: Maybe<Array<Maybe<PricebookBundleItemsMutationResponse>>>;
  /** update data of the table: "pricebook_categories" */
  updatePricebookCategories?: Maybe<PricebookCategoriesMutationResponse>;
  /** update single row of the table: "pricebook_categories" */
  updatePricebookCategoriesByPk?: Maybe<PricebookCategories>;
  /** update multiples rows of table: "pricebook_categories" */
  updatePricebookCategoriesMany?: Maybe<Array<Maybe<PricebookCategoriesMutationResponse>>>;
  /** update data of the table: "pricebook_discounts" */
  updatePricebookDiscounts?: Maybe<PricebookDiscountsMutationResponse>;
  /** update single row of the table: "pricebook_discounts" */
  updatePricebookDiscountsByPk?: Maybe<PricebookDiscounts>;
  /** update multiples rows of table: "pricebook_discounts" */
  updatePricebookDiscountsMany?: Maybe<Array<Maybe<PricebookDiscountsMutationResponse>>>;
  /** update data of the table: "pricebook_item_type_fallback_photos" */
  updatePricebookItemTypeFallbackPhotos?: Maybe<PricebookItemTypeFallbackPhotosMutationResponse>;
  /** update single row of the table: "pricebook_item_type_fallback_photos" */
  updatePricebookItemTypeFallbackPhotosByPk?: Maybe<PricebookItemTypeFallbackPhotos>;
  /** update multiples rows of table: "pricebook_item_type_fallback_photos" */
  updatePricebookItemTypeFallbackPhotosMany?: Maybe<Array<Maybe<PricebookItemTypeFallbackPhotosMutationResponse>>>;
  /** update data of the table: "pricebook_items" */
  updatePricebookItems?: Maybe<PricebookItemsMutationResponse>;
  /** update single row of the table: "pricebook_items" */
  updatePricebookItemsByPk?: Maybe<PricebookItems>;
  /** update multiples rows of table: "pricebook_items" */
  updatePricebookItemsMany?: Maybe<Array<Maybe<PricebookItemsMutationResponse>>>;
  /** update data of the table: "pricebook_items_qbo_income_accounts" */
  updatePricebookItemsQboIncomeAccounts?: Maybe<PricebookItemsQboIncomeAccountsMutationResponse>;
  /** update single row of the table: "pricebook_items_qbo_income_accounts" */
  updatePricebookItemsQboIncomeAccountsByPk?: Maybe<PricebookItemsQboIncomeAccounts>;
  /** update multiples rows of table: "pricebook_items_qbo_income_accounts" */
  updatePricebookItemsQboIncomeAccountsMany?: Maybe<Array<Maybe<PricebookItemsQboIncomeAccountsMutationResponse>>>;
  /** update data of the table: "pricebook_markup_tiers" */
  updatePricebookMarkupTiers?: Maybe<PricebookMarkupTiersMutationResponse>;
  /** update single row of the table: "pricebook_markup_tiers" */
  updatePricebookMarkupTiersByPk?: Maybe<PricebookMarkupTiers>;
  /** update multiples rows of table: "pricebook_markup_tiers" */
  updatePricebookMarkupTiersMany?: Maybe<Array<Maybe<PricebookMarkupTiersMutationResponse>>>;
  /** update data of the table: "pricebook_tax_rates" */
  updatePricebookTaxRates?: Maybe<PricebookTaxRatesMutationResponse>;
  /** update single row of the table: "pricebook_tax_rates" */
  updatePricebookTaxRatesByPk?: Maybe<PricebookTaxRates>;
  /** update multiples rows of table: "pricebook_tax_rates" */
  updatePricebookTaxRatesMany?: Maybe<Array<Maybe<PricebookTaxRatesMutationResponse>>>;
  /** update data of the table: "pricebook_versions" */
  updatePricebookVersions?: Maybe<PricebookVersionsMutationResponse>;
  /** update single row of the table: "pricebook_versions" */
  updatePricebookVersionsByPk?: Maybe<PricebookVersions>;
  /** update multiples rows of table: "pricebook_versions" */
  updatePricebookVersionsMany?: Maybe<Array<Maybe<PricebookVersionsMutationResponse>>>;
  /** update data of the table: "purchase_orders" */
  updatePurchaseOrders?: Maybe<PurchaseOrdersMutationResponse>;
  /** update single row of the table: "purchase_orders" */
  updatePurchaseOrdersByPk?: Maybe<PurchaseOrders>;
  /** update multiples rows of table: "purchase_orders" */
  updatePurchaseOrdersMany?: Maybe<Array<Maybe<PurchaseOrdersMutationResponse>>>;
  /** update data of the table: "qbo_auth_data" */
  updateQboAuthData?: Maybe<QboAuthDataMutationResponse>;
  /** update single row of the table: "qbo_auth_data" */
  updateQboAuthDataByPk?: Maybe<QboAuthData>;
  /** update multiples rows of table: "qbo_auth_data" */
  updateQboAuthDataMany?: Maybe<Array<Maybe<QboAuthDataMutationResponse>>>;
  /** update data of the table: "qbo_cart_item_type_accounts_config" */
  updateQboCartItemTypeAccountsConfig?: Maybe<QboCartItemTypeAccountsConfigMutationResponse>;
  /** update single row of the table: "qbo_cart_item_type_accounts_config" */
  updateQboCartItemTypeAccountsConfigByPk?: Maybe<QboCartItemTypeAccountsConfig>;
  /** update multiples rows of table: "qbo_cart_item_type_accounts_config" */
  updateQboCartItemTypeAccountsConfigMany?: Maybe<Array<Maybe<QboCartItemTypeAccountsConfigMutationResponse>>>;
  /** update data of the table: "qbo_sync_info" */
  updateQboSyncInfo?: Maybe<QboSyncInfoMutationResponse>;
  /** update single row of the table: "qbo_sync_info" */
  updateQboSyncInfoByPk?: Maybe<QboSyncInfo>;
  /** update multiples rows of table: "qbo_sync_info" */
  updateQboSyncInfoMany?: Maybe<Array<Maybe<QboSyncInfoMutationResponse>>>;
  /** update data of the table: "recent_pricebook_items" */
  updateRecentPricebookItems?: Maybe<RecentPricebookItemsMutationResponse>;
  /** update single row of the table: "recent_pricebook_items" */
  updateRecentPricebookItemsByPk?: Maybe<RecentPricebookItems>;
  /** update multiples rows of table: "recent_pricebook_items" */
  updateRecentPricebookItemsMany?: Maybe<Array<Maybe<RecentPricebookItemsMutationResponse>>>;
  /** update data of the table: "recommendation_ai_generation_info" */
  updateRecommendationAiGenerationInfo?: Maybe<RecommendationAiGenerationInfoMutationResponse>;
  /** update single row of the table: "recommendation_ai_generation_info" */
  updateRecommendationAiGenerationInfoByPk?: Maybe<RecommendationAiGenerationInfo>;
  /** update multiples rows of table: "recommendation_ai_generation_info" */
  updateRecommendationAiGenerationInfoMany?: Maybe<Array<Maybe<RecommendationAiGenerationInfoMutationResponse>>>;
  /** update data of the table: "recommendation_dismissals" */
  updateRecommendationDismissals?: Maybe<RecommendationDismissalsMutationResponse>;
  /** update single row of the table: "recommendation_dismissals" */
  updateRecommendationDismissalsByPk?: Maybe<RecommendationDismissals>;
  /** update multiples rows of table: "recommendation_dismissals" */
  updateRecommendationDismissalsMany?: Maybe<Array<Maybe<RecommendationDismissalsMutationResponse>>>;
  /** update data of the table: "recommendation_interactions" */
  updateRecommendationInteractions?: Maybe<RecommendationInteractionsMutationResponse>;
  /** update single row of the table: "recommendation_interactions" */
  updateRecommendationInteractionsByPk?: Maybe<RecommendationInteractions>;
  /** update multiples rows of table: "recommendation_interactions" */
  updateRecommendationInteractionsMany?: Maybe<Array<Maybe<RecommendationInteractionsMutationResponse>>>;
  /** update data of the table: "recommendations" */
  updateRecommendations?: Maybe<RecommendationsMutationResponse>;
  /** update single row of the table: "recommendations" */
  updateRecommendationsByPk?: Maybe<Recommendations>;
  /** update multiples rows of table: "recommendations" */
  updateRecommendationsMany?: Maybe<Array<Maybe<RecommendationsMutationResponse>>>;
  /** update data of the table: "reminder_assignments" */
  updateReminderAssignments?: Maybe<ReminderAssignmentsMutationResponse>;
  /** update single row of the table: "reminder_assignments" */
  updateReminderAssignmentsByPk?: Maybe<ReminderAssignments>;
  /** update multiples rows of table: "reminder_assignments" */
  updateReminderAssignmentsMany?: Maybe<Array<Maybe<ReminderAssignmentsMutationResponse>>>;
  /** update data of the table: "reminder_internal_notifications" */
  updateReminderInternalNotifications?: Maybe<ReminderInternalNotificationsMutationResponse>;
  /** update single row of the table: "reminder_internal_notifications" */
  updateReminderInternalNotificationsByPk?: Maybe<ReminderInternalNotifications>;
  /** update multiples rows of table: "reminder_internal_notifications" */
  updateReminderInternalNotificationsMany?: Maybe<Array<Maybe<ReminderInternalNotificationsMutationResponse>>>;
  /** update data of the table: "reminders" */
  updateReminders?: Maybe<RemindersMutationResponse>;
  /** update single row of the table: "reminders" */
  updateRemindersByPk?: Maybe<Reminders>;
  /** update multiples rows of table: "reminders" */
  updateRemindersMany?: Maybe<Array<Maybe<RemindersMutationResponse>>>;
  /** update data of the table: "rep_company_metabase_config" */
  updateRepCompanyMetabaseConfig?: Maybe<RepCompanyMetabaseConfigMutationResponse>;
  /** update single row of the table: "rep_company_metabase_config" */
  updateRepCompanyMetabaseConfigByPk?: Maybe<RepCompanyMetabaseConfig>;
  /** update multiples rows of table: "rep_company_metabase_config" */
  updateRepCompanyMetabaseConfigMany?: Maybe<Array<Maybe<RepCompanyMetabaseConfigMutationResponse>>>;
  /** update data of the table: "rep_metabase_company_reports" */
  updateRepMetabaseCompanyReports?: Maybe<RepMetabaseCompanyReportsMutationResponse>;
  /** update single row of the table: "rep_metabase_company_reports" */
  updateRepMetabaseCompanyReportsByPk?: Maybe<RepMetabaseCompanyReports>;
  /** update multiples rows of table: "rep_metabase_company_reports" */
  updateRepMetabaseCompanyReportsMany?: Maybe<Array<Maybe<RepMetabaseCompanyReportsMutationResponse>>>;
  /** update data of the table: "rep_metabase_pulses" */
  updateRepMetabasePulses?: Maybe<RepMetabasePulsesMutationResponse>;
  /** update single row of the table: "rep_metabase_pulses" */
  updateRepMetabasePulsesByPk?: Maybe<RepMetabasePulses>;
  /** update multiples rows of table: "rep_metabase_pulses" */
  updateRepMetabasePulsesMany?: Maybe<Array<Maybe<RepMetabasePulsesMutationResponse>>>;
  /** update data of the table: "rep_metabase_pulses_v2" */
  updateRepMetabasePulsesV2?: Maybe<RepMetabasePulsesV2MutationResponse>;
  /** update single row of the table: "rep_metabase_pulses_v2" */
  updateRepMetabasePulsesV2ByPk?: Maybe<RepMetabasePulsesV2>;
  /** update multiples rows of table: "rep_metabase_pulses_v2" */
  updateRepMetabasePulsesV2Many?: Maybe<Array<Maybe<RepMetabasePulsesV2MutationResponse>>>;
  /** update data of the table: "rep_metabase_report_definitions" */
  updateRepMetabaseReportDefinitions?: Maybe<RepMetabaseReportDefinitionsMutationResponse>;
  /** update single row of the table: "rep_metabase_report_definitions" */
  updateRepMetabaseReportDefinitionsByPk?: Maybe<RepMetabaseReportDefinitions>;
  /** update multiples rows of table: "rep_metabase_report_definitions" */
  updateRepMetabaseReportDefinitionsMany?: Maybe<Array<Maybe<RepMetabaseReportDefinitionsMutationResponse>>>;
  /** update data of the table: "tags" */
  updateTags?: Maybe<TagsMutationResponse>;
  /** update single row of the table: "tags" */
  updateTagsByPk?: Maybe<Tags>;
  /** update multiples rows of table: "tags" */
  updateTagsMany?: Maybe<Array<Maybe<TagsMutationResponse>>>;
  /** update data of the table: "technician_capacities" */
  updateTechnicianCapacities?: Maybe<TechnicianCapacitiesMutationResponse>;
  /** update single row of the table: "technician_capacities" */
  updateTechnicianCapacitiesByPk?: Maybe<TechnicianCapacities>;
  /** update multiples rows of table: "technician_capacities" */
  updateTechnicianCapacitiesMany?: Maybe<Array<Maybe<TechnicianCapacitiesMutationResponse>>>;
  /** update data of the table: "technician_capacity_blocks" */
  updateTechnicianCapacityBlocks?: Maybe<TechnicianCapacityBlocksMutationResponse>;
  /** update single row of the table: "technician_capacity_blocks" */
  updateTechnicianCapacityBlocksByPk?: Maybe<TechnicianCapacityBlocks>;
  /** update multiples rows of table: "technician_capacity_blocks" */
  updateTechnicianCapacityBlocksMany?: Maybe<Array<Maybe<TechnicianCapacityBlocksMutationResponse>>>;
  /** update data of the table: "tilled_raw_events" */
  updateTilledRawEvents?: Maybe<TilledRawEventsMutationResponse>;
  /** update single row of the table: "tilled_raw_events" */
  updateTilledRawEventsByPk?: Maybe<TilledRawEvents>;
  /** update multiples rows of table: "tilled_raw_events" */
  updateTilledRawEventsMany?: Maybe<Array<Maybe<TilledRawEventsMutationResponse>>>;
  /** update data of the table: "timesheet_entries" */
  updateTimesheetEntries?: Maybe<TimesheetEntriesMutationResponse>;
  /** update single row of the table: "timesheet_entries" */
  updateTimesheetEntriesByPk?: Maybe<TimesheetEntries>;
  /** update multiples rows of table: "timesheet_entries" */
  updateTimesheetEntriesMany?: Maybe<Array<Maybe<TimesheetEntriesMutationResponse>>>;
  /** update data of the table: "timesheet_entry_activities" */
  updateTimesheetEntryActivities?: Maybe<TimesheetEntryActivitiesMutationResponse>;
  /** update single row of the table: "timesheet_entry_activities" */
  updateTimesheetEntryActivitiesByPk?: Maybe<TimesheetEntryActivities>;
  /** update multiples rows of table: "timesheet_entry_activities" */
  updateTimesheetEntryActivitiesMany?: Maybe<Array<Maybe<TimesheetEntryActivitiesMutationResponse>>>;
  /** update data of the table: "timesheet_entry_link_data" */
  updateTimesheetEntryLinkData?: Maybe<TimesheetEntryLinkDataMutationResponse>;
  /** update single row of the table: "timesheet_entry_link_data" */
  updateTimesheetEntryLinkDataByPk?: Maybe<TimesheetEntryLinkData>;
  /** update multiples rows of table: "timesheet_entry_link_data" */
  updateTimesheetEntryLinkDataMany?: Maybe<Array<Maybe<TimesheetEntryLinkDataMutationResponse>>>;
  /** update data of the table: "tune_up_visit_entitlements" */
  updateTuneUpVisitEntitlements?: Maybe<TuneUpVisitEntitlementsMutationResponse>;
  /** update single row of the table: "tune_up_visit_entitlements" */
  updateTuneUpVisitEntitlementsByPk?: Maybe<TuneUpVisitEntitlements>;
  /** update multiples rows of table: "tune_up_visit_entitlements" */
  updateTuneUpVisitEntitlementsMany?: Maybe<Array<Maybe<TuneUpVisitEntitlementsMutationResponse>>>;
  /** update data of the table: "user_business_units" */
  updateUserBusinessUnits?: Maybe<UserBusinessUnitsMutationResponse>;
  /** update single row of the table: "user_business_units" */
  updateUserBusinessUnitsByPk?: Maybe<UserBusinessUnits>;
  /** update multiples rows of table: "user_business_units" */
  updateUserBusinessUnitsMany?: Maybe<Array<Maybe<UserBusinessUnitsMutationResponse>>>;
  /** update data of the table: "user_phone_numbers" */
  updateUserPhoneNumbers?: Maybe<UserPhoneNumbersMutationResponse>;
  /** update single row of the table: "user_phone_numbers" */
  updateUserPhoneNumbersByPk?: Maybe<UserPhoneNumbers>;
  /** update multiples rows of table: "user_phone_numbers" */
  updateUserPhoneNumbersMany?: Maybe<Array<Maybe<UserPhoneNumbersMutationResponse>>>;
  /** update data of the table: "user_settings" */
  updateUserSettings?: Maybe<UserSettingsMutationResponse>;
  /** update single row of the table: "user_settings" */
  updateUserSettingsByPk?: Maybe<UserSettings>;
  /** update multiples rows of table: "user_settings" */
  updateUserSettingsMany?: Maybe<Array<Maybe<UserSettingsMutationResponse>>>;
  /** update data of the table: "user_wages" */
  updateUserWages?: Maybe<UserWagesMutationResponse>;
  /** update single row of the table: "user_wages" */
  updateUserWagesByPk?: Maybe<UserWages>;
  /** update multiples rows of table: "user_wages" */
  updateUserWagesMany?: Maybe<Array<Maybe<UserWagesMutationResponse>>>;
  /** update data of the table: "users" */
  updateUsers?: Maybe<UsersMutationResponse>;
  /** update single row of the table: "users" */
  updateUsersByPk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  updateUsersMany?: Maybe<Array<Maybe<UsersMutationResponse>>>;
  /** update data of the table: "wisetack_loan_records" */
  updateWisetackLoanRecords?: Maybe<WisetackLoanRecordsMutationResponse>;
  /** update single row of the table: "wisetack_loan_records" */
  updateWisetackLoanRecordsByPk?: Maybe<WisetackLoanRecords>;
  /** update multiples rows of table: "wisetack_loan_records" */
  updateWisetackLoanRecordsMany?: Maybe<Array<Maybe<WisetackLoanRecordsMutationResponse>>>;
  /** update data of the table: "wisetack_loan_statuses" */
  updateWisetackLoanStatuses?: Maybe<WisetackLoanStatusesMutationResponse>;
  /** update single row of the table: "wisetack_loan_statuses" */
  updateWisetackLoanStatusesByPk?: Maybe<WisetackLoanStatuses>;
  /** update multiples rows of table: "wisetack_loan_statuses" */
  updateWisetackLoanStatusesMany?: Maybe<Array<Maybe<WisetackLoanStatusesMutationResponse>>>;
  /** update data of the table: "wisetack_prequal_records" */
  updateWisetackPrequalRecords?: Maybe<WisetackPrequalRecordsMutationResponse>;
  /** update single row of the table: "wisetack_prequal_records" */
  updateWisetackPrequalRecordsByPk?: Maybe<WisetackPrequalRecords>;
  /** update multiples rows of table: "wisetack_prequal_records" */
  updateWisetackPrequalRecordsMany?: Maybe<Array<Maybe<WisetackPrequalRecordsMutationResponse>>>;
  /** update data of the table: "wisetack_webhook_events" */
  updateWisetackWebhookEvents?: Maybe<WisetackWebhookEventsMutationResponse>;
  /** update single row of the table: "wisetack_webhook_events" */
  updateWisetackWebhookEventsByPk?: Maybe<WisetackWebhookEvents>;
  /** update multiples rows of table: "wisetack_webhook_events" */
  updateWisetackWebhookEventsMany?: Maybe<Array<Maybe<WisetackWebhookEventsMutationResponse>>>;
};


/** mutation root */
export type Mutation_RootDeleteAccCartItemTypeAccountsConfigArgs = {
  where: AccCartItemTypeAccountsConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccCartItemTypeAccountsConfigByPkArgs = {
  accCartItemTypeAccountsConfigGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccCompanyConfigArgs = {
  where: AccCompanyConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccCompanyConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccPayoutAccountsConfigArgs = {
  where: AccPayoutAccountsConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccPayoutAccountsConfigByPkArgs = {
  accPayoutAccountsConfigId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccQbdConductorConfigArgs = {
  where: AccQbdConductorConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccQbdConductorConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccQbdConductorUptimeArgs = {
  where: AccQbdConductorUptimeBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccQbdConductorUptimeByPkArgs = {
  uptimeCheckGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccSyncInfoArgs = {
  where: AccSyncInfoBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccSyncInfoByPkArgs = {
  accountingIntegrationType: Scalars['String'];
  breezyEntityGuid: Scalars['uuid'];
  breezyEntityType: Scalars['String'];
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccSyncQueueItemsArgs = {
  where: AccSyncQueueItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccSyncQueueItemsByPkArgs = {
  accSyncQueueItemGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountContactsArgs = {
  where: AccountContactsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccountContactsByPkArgs = {
  accountContactGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountLocationsArgs = {
  where: AccountLocationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccountLocationsByPkArgs = {
  accountGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountRemindersArgs = {
  where: AccountRemindersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccountRemindersByPkArgs = {
  accountGuid: Scalars['uuid'];
  reminderGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountStatementEventsArgs = {
  where: AccountStatementEventsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccountStatementEventsByPkArgs = {
  statementEventGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountTagsArgs = {
  where: AccountTagsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccountTagsByPkArgs = {
  accountGuid: Scalars['uuid'];
  tagGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountTypesArgs = {
  where: AccountTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccountTypesByPkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteAccountsArgs = {
  where: AccountsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccountsByPkArgs = {
  accountGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAccountsViewedByUserArgs = {
  where: AccountsViewedByUserBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAccountsViewedByUserByPkArgs = {
  accountGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteActivityItemsArgs = {
  where: ActivityItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteActivityItemsByPkArgs = {
  activityItemGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAddressesArgs = {
  where: AddressesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAddressesByPkArgs = {
  addressGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAppointmentChecklistAssociationRulesArgs = {
  where: AppointmentChecklistAssociationRulesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAppointmentChecklistAssociationRulesByPkArgs = {
  appointmentChecklistAssociationRuleGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAppointmentChecklistInstancesArgs = {
  where: AppointmentChecklistInstancesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAppointmentChecklistInstancesByPkArgs = {
  appointmentChecklistInstanceGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAppointmentChecklistsArgs = {
  where: AppointmentChecklistsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAppointmentChecklistsByPkArgs = {
  appointmentChecklistGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAssistantIntegratedPhonesArgs = {
  where: AssistantIntegratedPhonesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAssistantIntegratedPhonesByPkArgs = {
  assistantGuid: Scalars['uuid'];
  integratedPhoneGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAssistantPhoneSettingsArgs = {
  where: AssistantPhoneSettingsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAssistantPhoneSettingsByPkArgs = {
  assistantGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAssistantsArgs = {
  where: AssistantsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAssistantsByPkArgs = {
  assistantGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteBillingProfileHiddenPaymentMethodsArgs = {
  where: BillingProfileHiddenPaymentMethodsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBillingProfileHiddenPaymentMethodsByPkArgs = {
  companyGuid: Scalars['uuid'];
  paymentMethod: PaymentMethodsEnum;
};


/** mutation root */
export type Mutation_RootDeleteBillingProfilesArgs = {
  where: BillingProfilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBillingProfilesByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteBusinessEventsArgs = {
  where: BusinessEventsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBusinessEventsByPkArgs = {
  businessEventGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteBusinessUnitTargetMetricsArgs = {
  where: BusinessUnitTargetMetricsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBusinessUnitTargetMetricsByPkArgs = {
  businessUnitTargetMetricGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteBusinessUnitsArgs = {
  where: BusinessUnitsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBusinessUnitsByPkArgs = {
  businessUnitGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCanonicalLeadSourcesArgs = {
  where: CanonicalLeadSourcesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCanonicalLeadSourcesByPkArgs = {
  canonicalLeadSourceName: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCartItemJobCostLinksArgs = {
  where: CartItemJobCostLinksBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCartItemJobCostLinksByPkArgs = {
  cartItemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCartItemsArgs = {
  where: CartItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCartItemsByPkArgs = {
  cartItemGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteChecklistItemsArgs = {
  where: ChecklistItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChecklistItemsByPkArgs = {
  checklistItemGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompaniesArgs = {
  where: CompaniesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompaniesByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompanyAppointmentArrivalWindowsArgs = {
  where: CompanyAppointmentArrivalWindowsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompanyAppointmentArrivalWindowsByPkArgs = {
  companyAppointmentArrivalWindowGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompanyCommissionConfigArgs = {
  where: CompanyCommissionConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompanyCommissionConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompanyConfigArgs = {
  where: CompanyConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompanyConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompanyDripMarketingConfigArgs = {
  where: CompanyDripMarketingConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompanyDripMarketingConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompanyLeadSourceLinksArgs = {
  where: CompanyLeadSourceLinksBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompanyLeadSourceLinksByPkArgs = {
  companyLeadSourceLinkGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompanyLeadSourcesArgs = {
  where: CompanyLeadSourcesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompanyLeadSourcesByPkArgs = {
  companyLeadSourceGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompanyNotificationSettingsArgs = {
  where: CompanyNotificationSettingsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompanyNotificationSettingsByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompanyPricingTierConfigArgs = {
  where: CompanyPricingTierConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompanyPricingTierConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompanyRolesArgs = {
  where: CompanyRolesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompanyRolesByPkArgs = {
  role: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCompanyTaxConfigurationsArgs = {
  where: CompanyTaxConfigurationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompanyTaxConfigurationsByPkArgs = {
  companyTaxConfigurationGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompanyUsersArgs = {
  where: CompanyUsersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompanyUsersByPkArgs = {
  userGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCompanyWorkingDisplayHoursArgs = {
  where: CompanyWorkingDisplayHoursBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompanyWorkingDisplayHoursByPkArgs = {
  companyWorkingDisplayHoursGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteContactsArgs = {
  where: ContactsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteContactsByPkArgs = {
  contactGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteCurrentCompanyTaxConfigurationsViewArgs = {
  where: CurrentCompanyTaxConfigurationsViewBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCurrentUserBusinessUnitsViewArgs = {
  where: CurrentUserBusinessUnitsViewBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCustomerCommunicationTemplatesArgs = {
  where: CustomerCommunicationTemplatesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCustomerCommunicationTemplatesByPkArgs = {
  companyGuid: Scalars['uuid'];
  name: Scalars['String'];
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteDiscountEntitlementsArgs = {
  where: DiscountEntitlementsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDiscountEntitlementsByPkArgs = {
  entitlementGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteDisplayIdCountersArgs = {
  where: DisplayIdCountersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDisplayIdCountersByPkArgs = {
  companyGuid: Scalars['uuid'];
  entityType: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteDripMarketingEmailsArgs = {
  where: DripMarketingEmailsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDripMarketingEmailsByPkArgs = {
  dripMarketingEmailGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEmailAddressesArgs = {
  where: EmailAddressesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEmailAddressesByPkArgs = {
  emailAddressGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEntitlementsArgs = {
  where: EntitlementsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEntitlementsByPkArgs = {
  entitlementGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEquipmentTypeLinksArgs = {
  where: EquipmentTypeLinksBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEquipmentTypeLinksByPkArgs = {
  equipmentTypeLinkGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEquipmentTypesArgs = {
  where: EquipmentTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEquipmentTypesByPkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteEstimateInvoicesArgs = {
  where: EstimateInvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEstimateInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEstimateOptionCartItemsArgs = {
  where: EstimateOptionCartItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEstimateOptionCartItemsByPkArgs = {
  cartItemGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEstimateOptionDiscountsArgs = {
  where: EstimateOptionDiscountsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEstimateOptionDiscountsByPkArgs = {
  estimateOptionDiscountGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEstimateOptionsArgs = {
  where: EstimateOptionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEstimateOptionsByPkArgs = {
  estimateOptionGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEstimatePhotosArgs = {
  where: EstimatePhotosBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEstimatePhotosByPkArgs = {
  estimateGuid: Scalars['uuid'];
  photoGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEstimateTemplatesArgs = {
  where: EstimateTemplatesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEstimateTemplatesByPkArgs = {
  estimateTemplateGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEstimatesArgs = {
  where: EstimatesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEstimatesByPkArgs = {
  estimateGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEstimatesQueryableArgs = {
  where: EstimatesQueryableBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEstimatesQueryableByPkArgs = {
  estimateGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteEventStoreArgs = {
  where: EventStoreBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEventStoreByPkArgs = {
  entityGuid: Scalars['uuid'];
  entityType: Scalars['String'];
  entityVersion: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDeleteFavoritePricebookItemsArgs = {
  where: FavoritePricebookItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteFavoritePricebookItemsByPkArgs = {
  pricebookItemGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFileLinksArgs = {
  where: FileLinksBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteFileLinksByPkArgs = {
  fileGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFilesArgs = {
  where: FilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteFilesByPkArgs = {
  fileGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInstalledEquipmentArgs = {
  where: InstalledEquipmentBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInstalledEquipmentByPkArgs = {
  installedEquipmentGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInstalledHvacSystemsArgs = {
  where: InstalledHvacSystemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInstalledHvacSystemsByPkArgs = {
  installedHvacSystemGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInstantBookingWeeklyScheduleEntriesArgs = {
  where: InstantBookingWeeklyScheduleEntriesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInstantBookingWeeklyScheduleEntriesByPkArgs = {
  instantBookingWeeklyScheduleEntryGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInstantBookingWeeklyScheduleEntryBookableArrivalWindowsArgs = {
  where: InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInstantBookingWeeklyScheduleEntryBookableArrivalWindowsByPkArgs = {
  companyAppointmentArrivalWindowGuid: Scalars['uuid'];
  instantBookingWeeklyScheduleEntryGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedChannelsArgs = {
  where: IntegratedChannelsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedChannelsByPkArgs = {
  integratedChannelGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedMessageStatusesArgs = {
  where: IntegratedMessageStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedMessageStatusesByPkArgs = {
  integratedMessageStatusGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedMessageTwilioRawWebhookEventsArgs = {
  where: IntegratedMessageTwilioRawWebhookEventsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedMessageTwilioRawWebhookEventsByPkArgs = {
  integratedMessageTwilioRawWebhookEventGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedMessagesArgs = {
  where: IntegratedMessagesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedMessagesByPkArgs = {
  integratedMessageGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCallDismissalsArgs = {
  where: IntegratedPhoneCallDismissalsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCallDismissalsByPkArgs = {
  integratedPhoneCallDismissalGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCallJobsArgs = {
  where: IntegratedPhoneCallJobsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCallJobsByPkArgs = {
  integratedPhoneCallGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCallRecordingArgs = {
  where: IntegratedPhoneCallRecordingBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCallRecordingByPkArgs = {
  integratedPhoneCallRecordingGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCallStatusTypesArgs = {
  where: IntegratedPhoneCallStatusTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCallStatusTypesByPkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCallStatusesArgs = {
  where: IntegratedPhoneCallStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCallStatusesByPkArgs = {
  integratedPhoneCallStatusGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCallsArgs = {
  where: IntegratedPhoneCallsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCallsByPkArgs = {
  integratedPhoneCallGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCompanyConfigArgs = {
  where: IntegratedPhoneCompanyConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneCompanyConfigByPkArgs = {
  integratedPhoneCompanyConfigGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneMissedCallDismissalsArgs = {
  where: IntegratedPhoneMissedCallDismissalsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneMissedCallDismissalsByPkArgs = {
  integratedPhoneMissedCallDismissal: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneMissedCallsArgs = {
  where: IntegratedPhoneMissedCallsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneMissedCallsByPkArgs = {
  integratedPhoneMissedCallGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneTwilioRawWebhookEventsArgs = {
  where: IntegratedPhoneTwilioRawWebhookEventsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneTwilioRawWebhookEventsByPkArgs = {
  integratedPhoneTwilioRawWebhookEventGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneUsersArgs = {
  where: IntegratedPhoneUsersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneUsersByPkArgs = {
  integratedPhoneUserGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneVoicemailDismissalsArgs = {
  where: IntegratedPhoneVoicemailDismissalsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneVoicemailDismissalsByPkArgs = {
  integratedPhoneVoicemailDismissal: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneVoicemailsArgs = {
  where: IntegratedPhoneVoicemailsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhoneVoicemailsByPkArgs = {
  integratedPhoneVoicemailGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhonesArgs = {
  where: IntegratedPhonesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteIntegratedPhonesByPkArgs = {
  integratedPhoneGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInternalNotificationsArgs = {
  where: InternalNotificationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInternalNotificationsByPkArgs = {
  internalNotificationGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoiceCartItemBundleItemsArgs = {
  where: InvoiceCartItemBundleItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInvoiceCartItemBundleItemsByPkArgs = {
  invoiceCartItemBundleItemGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoiceCartItemBundleJobCostLinksArgs = {
  where: InvoiceCartItemBundleJobCostLinksBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInvoiceCartItemBundleJobCostLinksByPkArgs = {
  invoiceCartItemBundleItemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoiceCartItemsArgs = {
  where: InvoiceCartItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInvoiceCartItemsByPkArgs = {
  cartItemGuid: Scalars['uuid'];
  invoiceGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoiceDiscountsArgs = {
  where: InvoiceDiscountsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInvoiceDiscountsByPkArgs = {
  invoiceDiscountGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoiceEventsArgs = {
  where: InvoiceEventsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInvoiceEventsByPkArgs = {
  invoiceEventGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoicePaymentsArgs = {
  where: InvoicePaymentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInvoicePaymentsByPkArgs = {
  invoiceGuid: Scalars['uuid'];
  paymentRecordGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoiceReminderDataArgs = {
  where: InvoiceReminderDataBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInvoiceReminderDataByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoiceTemplateCartItemsArgs = {
  where: InvoiceTemplateCartItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInvoiceTemplateCartItemsByPkArgs = {
  cartItemGuid: Scalars['uuid'];
  invoiceTemplateGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoiceTemplatesArgs = {
  where: InvoiceTemplatesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInvoiceTemplatesByPkArgs = {
  invoiceTemplateGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoicesArgs = {
  where: InvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteInvoicesQueryableArgs = {
  where: InvoicesQueryableBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteInvoicesQueryableByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentAssignmentStatusTypesArgs = {
  where: JobAppointmentAssignmentStatusTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentAssignmentStatusTypesByPkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentAssignmentStatusesArgs = {
  where: JobAppointmentAssignmentStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentAssignmentStatusesByPkArgs = {
  jobAppointmentAssignmentStatusGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentAssignmentsArgs = {
  where: JobAppointmentAssignmentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentAssignmentsByPkArgs = {
  jobAppointmentAssignmentGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentCancellationStatusesArgs = {
  where: JobAppointmentCancellationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentCancellationStatusesByPkArgs = {
  jobAppointmentGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentConfirmationStatusesArgs = {
  where: JobAppointmentConfirmationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentConfirmationStatusesByPkArgs = {
  jobAppointmentGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentInvoicesArgs = {
  where: JobAppointmentInvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentsArgs = {
  where: JobAppointmentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobAppointmentsByPkArgs = {
  jobAppointmentGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobCostItemsArgs = {
  where: JobCostItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobCostItemsByPkArgs = {
  jobCostItemGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobCostMiscCategoriesArgs = {
  where: JobCostMiscCategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobCostMiscCategoriesByPkArgs = {
  miscCategoryGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobCostingConfigArgs = {
  where: JobCostingConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobCostingConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobInvoicesArgs = {
  where: JobInvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobLeadsArgs = {
  where: JobLeadsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobLeadsByPkArgs = {
  jobLeadGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobLifecycleStatusesArgs = {
  where: JobLifecycleStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobLifecycleStatusesByPkArgs = {
  jobLifecycleStatusGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobLifecycleTypesArgs = {
  where: JobLifecycleTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobLifecycleTypesByPkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteJobLifecycleViewsArgs = {
  where: JobLifecycleViewsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobLifecycleViewsByPkArgs = {
  jobLifecycleViewGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobLifecyclesArgs = {
  where: JobLifecyclesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobLifecyclesByPkArgs = {
  jobLifecycleGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobRequestsCompanyConfigArgs = {
  where: JobRequestsCompanyConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobRequestsCompanyConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobTagsArgs = {
  where: JobTagsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobTagsByPkArgs = {
  jobGuid: Scalars['uuid'];
  tagGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobTeamMembersArgs = {
  where: JobTeamMembersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobTeamMembersByPkArgs = {
  jobGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobTechnicianEarnedRevenueAttributionsArgs = {
  where: JobTechnicianEarnedRevenueAttributionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobTechnicianEarnedRevenueAttributionsByPkArgs = {
  invoiceGuid: Scalars['uuid'];
  itemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  technicianUserGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobTechnicianSoldRevenueAttributionsArgs = {
  where: JobTechnicianSoldRevenueAttributionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobTechnicianSoldRevenueAttributionsByPkArgs = {
  invoiceGuid: Scalars['uuid'];
  itemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  technicianUserGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobTypeChangeReasonsArgs = {
  where: JobTypeChangeReasonsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobTypeChangeReasonsByPkArgs = {
  jobTypeChangeReasonGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobTypesArgs = {
  where: JobTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobTypesByPkArgs = {
  jobTypeGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobsArgs = {
  where: JobsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobsByPkArgs = {
  jobGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobsWithLinkedJobArgs = {
  where: JobsWithLinkedJobBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobsWithLinkedJobByPkArgs = {
  jobGuid: Scalars['uuid'];
  linkedJobGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobsWithLinkedJobLinkedAppointmentChecklistInstancesArgs = {
  where: JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobsWithLinkedJobLinkedAppointmentChecklistInstancesByPkArgs = {
  appointmentChecklistInstanceGuid: Scalars['uuid'];
  followUpJobGuid: Scalars['uuid'];
  originalJobGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteJobsWithLinkedJobLinkedEstimatesArgs = {
  where: JobsWithLinkedJobLinkedEstimatesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobsWithLinkedJobLinkedEstimatesByPkArgs = {
  estimateGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  linkedJobGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLocationContactsArgs = {
  where: LocationContactsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLocationContactsByPkArgs = {
  contactGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLocationInvoicesArgs = {
  where: LocationInvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLocationInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteLocationsArgs = {
  where: LocationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLocationsByPkArgs = {
  locationGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanDefinitionAllowedPaymentIntervalsArgs = {
  where: MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanDefinitionAllowedPaymentIntervalsByPkArgs = {
  maintenancePlanDefinitionAllowedPaymentIntervalGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanDefinitionBenefitsArgs = {
  where: MaintenancePlanDefinitionBenefitsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanDefinitionBenefitsByPkArgs = {
  maintenancePlanDefinitionBenefitGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanDefinitionDiscountsArgs = {
  where: MaintenancePlanDefinitionDiscountsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanDefinitionDiscountsByPkArgs = {
  maintenancePlanDefinitionDiscountGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanDefinitionFlareArgs = {
  where: MaintenancePlanDefinitionFlareBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanDefinitionFlareByPkArgs = {
  maintenancePlanDefinitionFlareGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanDefinitionMarketingInfoArgs = {
  where: MaintenancePlanDefinitionMarketingInfoBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanDefinitionMarketingInfoByPkArgs = {
  maintenancePlanDefinitionMarketingInfoGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanDefinitionsArgs = {
  where: MaintenancePlanDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanDefinitionsByPkArgs = {
  maintenancePlanDefinitionGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanEquipmentCoverageDefinitionsArgs = {
  where: MaintenancePlanEquipmentCoverageDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanEquipmentCoverageDefinitionsByPkArgs = {
  maintenancePlanEquipmentCoverageDefinitionGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanEquipmentCoveragePricingsArgs = {
  where: MaintenancePlanEquipmentCoveragePricingsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanEquipmentCoveragePricingsByPkArgs = {
  maintenancePlanEquipmentCoveragePricingGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanInvoicesArgs = {
  where: MaintenancePlanInvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanVisitInstalledEquipmentsArgs = {
  where: MaintenancePlanVisitInstalledEquipmentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanVisitInstalledEquipmentsByPkArgs = {
  maintenancePlanVisitInstalledEquipmentGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanVisitsArgs = {
  where: MaintenancePlanVisitsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlanVisitsByPkArgs = {
  maintenancePlanVisitGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlansQueryableArgs = {
  where: MaintenancePlansQueryableBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMaintenancePlansQueryableByPkArgs = {
  maintenancePlanGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMigrationJunkArgs = {
  where: MigrationJunkBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMigrationJunkByPkArgs = {
  migrationJunkGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMigrationJunkLinksArgs = {
  where: MigrationJunkLinksBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteMigrationJunkLinksByPkArgs = {
  migrationJunkGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteNoteAttachmentsArgs = {
  where: NoteAttachmentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteNoteAttachmentsByPkArgs = {
  noteAttachmentGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteNoteLinksArgs = {
  where: NoteLinksBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteNoteLinksByPkArgs = {
  noteGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteNoteTaggedUsersArgs = {
  where: NoteTaggedUsersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteNoteTaggedUsersByPkArgs = {
  noteUserTagGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteNotesArgs = {
  where: NotesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteNotesByPkArgs = {
  noteGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteOnlineBookingCompanyConfigArgs = {
  where: OnlineBookingCompanyConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteOnlineBookingCompanyConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteOnlineBookingServiceAreaZipCodesArgs = {
  where: OnlineBookingServiceAreaZipCodesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteOnlineBookingServiceAreaZipCodesByPkArgs = {
  serviceAreaZipCodeGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteOnlineBookingServiceTypeBookableJobTypesArgs = {
  where: OnlineBookingServiceTypeBookableJobTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteOnlineBookingServiceTypeBookableJobTypesByPkArgs = {
  jobTypeGuid: Scalars['uuid'];
  onlineBookingServiceTypeGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteOnlineBookingServiceTypeBookableTechniciansArgs = {
  where: OnlineBookingServiceTypeBookableTechniciansBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteOnlineBookingServiceTypeBookableTechniciansByPkArgs = {
  onlineBookingServiceTypeGuid: Scalars['uuid'];
  technicianGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteOnlineBookingServiceTypeConfigsArgs = {
  where: OnlineBookingServiceTypeConfigsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteOnlineBookingServiceTypeConfigsByPkArgs = {
  onlineBookingServiceTypeGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentLinksArgs = {
  where: PaymentLinksBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentLinksByPkArgs = {
  paymentRecordGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentMethodBillingInfoArgs = {
  where: PaymentMethodBillingInfoBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentMethodBillingInfoByPkArgs = {
  paymentMethodRecordGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentMethodCardMetadataArgs = {
  where: PaymentMethodCardMetadataBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentMethodCardMetadataByPkArgs = {
  paymentMethodRecordGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentMethodRecordsArgs = {
  where: PaymentMethodRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentMethodRecordsByPkArgs = {
  paymentMethodRecordGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentRecordsArgs = {
  where: PaymentRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentRecordsByPkArgs = {
  paymentRecordGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentRefundsArgs = {
  where: PaymentRefundsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentRefundsByPkArgs = {
  paymentRefundGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentStatusErrorDetailArgs = {
  where: PaymentStatusErrorDetailBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentStatusErrorDetailByPkArgs = {
  paymentStatusErrorDetailGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentStatusLatestArgs = {
  where: PaymentStatusLatestBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentStatusLatestByPkArgs = {
  paymentRecordGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentStatusesArgs = {
  where: PaymentStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentStatusesByPkArgs = {
  paymentStatusGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentSubscriptionInvoicesArgs = {
  where: PaymentSubscriptionInvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentSubscriptionInvoicesByPkArgs = {
  paymentSubscriptionInvoiceGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentSubscriptionStatusesArgs = {
  where: PaymentSubscriptionStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentSubscriptionStatusesByPkArgs = {
  paymentSubscriptionStatusGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePaymentSubscriptionsArgs = {
  where: PaymentSubscriptionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePaymentSubscriptionsByPkArgs = {
  paymentSubscriptionGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePayoutItemsArgs = {
  where: PayoutItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePayoutItemsByPkArgs = {
  payoutItemGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePayoutQboAccountsConfigArgs = {
  where: PayoutQboAccountsConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePayoutQboAccountsConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePayoutsArgs = {
  where: PayoutsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePayoutsByPkArgs = {
  payoutGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePhoneNumbersArgs = {
  where: PhoneNumbersBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePhoneNumbersByPkArgs = {
  phoneNumberGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePhotoLinksArgs = {
  where: PhotoLinksBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePhotoLinksByPkArgs = {
  photoGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePhotosArgs = {
  where: PhotosBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePhotosByPkArgs = {
  photoGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePricebookBundleItemsArgs = {
  where: PricebookBundleItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePricebookBundleItemsByPkArgs = {
  pricebookBundleItemGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePricebookCategoriesArgs = {
  where: PricebookCategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePricebookCategoriesByPkArgs = {
  pricebookCategoryGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePricebookDiscountsArgs = {
  where: PricebookDiscountsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePricebookDiscountsByPkArgs = {
  pricebookDiscountGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePricebookItemTypeFallbackPhotosArgs = {
  where: PricebookItemTypeFallbackPhotosBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePricebookItemTypeFallbackPhotosByPkArgs = {
  companyGuid: Scalars['uuid'];
  itemType: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePricebookItemsArgs = {
  where: PricebookItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePricebookItemsByPkArgs = {
  pricebookItemGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePricebookItemsQboIncomeAccountsArgs = {
  where: PricebookItemsQboIncomeAccountsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePricebookItemsQboIncomeAccountsByPkArgs = {
  pricebookItemGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePricebookMarkupTiersArgs = {
  where: PricebookMarkupTiersBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePricebookMarkupTiersByPkArgs = {
  pricebookMarkupTierGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePricebookTaxRatesArgs = {
  where: PricebookTaxRatesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePricebookTaxRatesByPkArgs = {
  pricebookTaxRateGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePricebookVersionsArgs = {
  where: PricebookVersionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePricebookVersionsByPkArgs = {
  pricebookVersionGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeletePurchaseOrdersArgs = {
  where: PurchaseOrdersBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePurchaseOrdersByPkArgs = {
  purchaseOrderGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteQboAuthDataArgs = {
  where: QboAuthDataBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteQboAuthDataByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteQboCartItemTypeAccountsConfigArgs = {
  where: QboCartItemTypeAccountsConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteQboCartItemTypeAccountsConfigByPkArgs = {
  qboCartItemTypeAccountsConfigGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteQboSyncInfoArgs = {
  where: QboSyncInfoBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteQboSyncInfoByPkArgs = {
  breezyIdentifier: Scalars['String'];
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRecentPricebookItemsArgs = {
  where: RecentPricebookItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecentPricebookItemsByPkArgs = {
  pricebookItemGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRecommendationAiGenerationInfoArgs = {
  where: RecommendationAiGenerationInfoBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecommendationAiGenerationInfoByPkArgs = {
  recommendationAiInfoGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRecommendationDismissalsArgs = {
  where: RecommendationDismissalsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecommendationDismissalsByPkArgs = {
  recommendationDismissalGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRecommendationInteractionsArgs = {
  where: RecommendationInteractionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecommendationInteractionsByPkArgs = {
  recommendationInteractionGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRecommendationsArgs = {
  where: RecommendationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecommendationsByPkArgs = {
  recommendationGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteReminderAssignmentsArgs = {
  where: ReminderAssignmentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteReminderAssignmentsByPkArgs = {
  reminderAssignmentGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteReminderInternalNotificationsArgs = {
  where: ReminderInternalNotificationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteReminderInternalNotificationsByPkArgs = {
  internalNotificationGuid: Scalars['uuid'];
  reminderGuid: Scalars['uuid'];
  type: ReminderInternalNotificationTypeEnum;
};


/** mutation root */
export type Mutation_RootDeleteRemindersArgs = {
  where: RemindersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRemindersByPkArgs = {
  reminderGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRepCompanyMetabaseConfigArgs = {
  where: RepCompanyMetabaseConfigBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRepCompanyMetabaseConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRepMetabaseCompanyReportsArgs = {
  where: RepMetabaseCompanyReportsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRepMetabaseCompanyReportsByPkArgs = {
  companyGuid: Scalars['uuid'];
  reportGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRepMetabasePulsesArgs = {
  where: RepMetabasePulsesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRepMetabasePulsesByPkArgs = {
  pulseGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRepMetabasePulsesV2Args = {
  where: RepMetabasePulsesV2BoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRepMetabasePulsesV2ByPkArgs = {
  pulseGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteRepMetabaseReportDefinitionsArgs = {
  where: RepMetabaseReportDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRepMetabaseReportDefinitionsByPkArgs = {
  reportGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTagsArgs = {
  where: TagsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTagsByPkArgs = {
  tagGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTechnicianCapacitiesArgs = {
  where: TechnicianCapacitiesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTechnicianCapacitiesByPkArgs = {
  technicianCapacityGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTechnicianCapacityBlocksArgs = {
  where: TechnicianCapacityBlocksBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTechnicianCapacityBlocksByPkArgs = {
  technicianCapacityBlockGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTilledRawEventsArgs = {
  where: TilledRawEventsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTilledRawEventsByPkArgs = {
  tilledRawEventGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTimesheetEntriesArgs = {
  where: TimesheetEntriesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTimesheetEntriesByPkArgs = {
  timesheetEntryGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTimesheetEntryActivitiesArgs = {
  where: TimesheetEntryActivitiesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTimesheetEntryActivitiesByPkArgs = {
  timesheetEntryActivityGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTimesheetEntryLinkDataArgs = {
  where: TimesheetEntryLinkDataBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTimesheetEntryLinkDataByPkArgs = {
  timesheetEntryGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteTuneUpVisitEntitlementsArgs = {
  where: TuneUpVisitEntitlementsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTuneUpVisitEntitlementsByPkArgs = {
  entitlementGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserBusinessUnitsArgs = {
  where: UserBusinessUnitsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserBusinessUnitsByPkArgs = {
  userBusinessUnitGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserPhoneNumbersArgs = {
  where: UserPhoneNumbersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserPhoneNumbersByPkArgs = {
  phoneNumberGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserSettingsArgs = {
  where: UserSettingsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserSettingsByPkArgs = {
  userGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserWagesArgs = {
  where: UserWagesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserWagesByPkArgs = {
  userWageGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: UsersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUsersByPkArgs = {
  userGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteWisetackLoanRecordsArgs = {
  where: WisetackLoanRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteWisetackLoanRecordsByPkArgs = {
  wisetackLoanRecordGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteWisetackLoanStatusesArgs = {
  where: WisetackLoanStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteWisetackLoanStatusesByPkArgs = {
  wisetackLoanStatusGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteWisetackPrequalRecordsArgs = {
  where: WisetackPrequalRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteWisetackPrequalRecordsByPkArgs = {
  wisetackPrequalRecordGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteWisetackWebhookEventsArgs = {
  where: WisetackWebhookEventsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteWisetackWebhookEventsByPkArgs = {
  wisetackWebhookEventGuid: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsertAccCartItemTypeAccountsConfigArgs = {
  objects: Array<AccCartItemTypeAccountsConfigInsertInput>;
  onConflict?: InputMaybe<AccCartItemTypeAccountsConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccCartItemTypeAccountsConfigOneArgs = {
  object: AccCartItemTypeAccountsConfigInsertInput;
  onConflict?: InputMaybe<AccCartItemTypeAccountsConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccCompanyConfigArgs = {
  objects: Array<AccCompanyConfigInsertInput>;
  onConflict?: InputMaybe<AccCompanyConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccCompanyConfigOneArgs = {
  object: AccCompanyConfigInsertInput;
  onConflict?: InputMaybe<AccCompanyConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccPayoutAccountsConfigArgs = {
  objects: Array<AccPayoutAccountsConfigInsertInput>;
  onConflict?: InputMaybe<AccPayoutAccountsConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccPayoutAccountsConfigOneArgs = {
  object: AccPayoutAccountsConfigInsertInput;
  onConflict?: InputMaybe<AccPayoutAccountsConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccQbdConductorConfigArgs = {
  objects: Array<AccQbdConductorConfigInsertInput>;
  onConflict?: InputMaybe<AccQbdConductorConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccQbdConductorConfigOneArgs = {
  object: AccQbdConductorConfigInsertInput;
  onConflict?: InputMaybe<AccQbdConductorConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccQbdConductorUptimeArgs = {
  objects: Array<AccQbdConductorUptimeInsertInput>;
  onConflict?: InputMaybe<AccQbdConductorUptimeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccQbdConductorUptimeOneArgs = {
  object: AccQbdConductorUptimeInsertInput;
  onConflict?: InputMaybe<AccQbdConductorUptimeOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccSyncInfoArgs = {
  objects: Array<AccSyncInfoInsertInput>;
  onConflict?: InputMaybe<AccSyncInfoOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccSyncInfoOneArgs = {
  object: AccSyncInfoInsertInput;
  onConflict?: InputMaybe<AccSyncInfoOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccSyncQueueItemsArgs = {
  objects: Array<AccSyncQueueItemsInsertInput>;
  onConflict?: InputMaybe<AccSyncQueueItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccSyncQueueItemsOneArgs = {
  object: AccSyncQueueItemsInsertInput;
  onConflict?: InputMaybe<AccSyncQueueItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountContactsArgs = {
  objects: Array<AccountContactsInsertInput>;
  onConflict?: InputMaybe<AccountContactsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountContactsOneArgs = {
  object: AccountContactsInsertInput;
  onConflict?: InputMaybe<AccountContactsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountLocationsArgs = {
  objects: Array<AccountLocationsInsertInput>;
  onConflict?: InputMaybe<AccountLocationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountLocationsOneArgs = {
  object: AccountLocationsInsertInput;
  onConflict?: InputMaybe<AccountLocationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountRemindersArgs = {
  objects: Array<AccountRemindersInsertInput>;
  onConflict?: InputMaybe<AccountRemindersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountRemindersOneArgs = {
  object: AccountRemindersInsertInput;
  onConflict?: InputMaybe<AccountRemindersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountStatementEventsArgs = {
  objects: Array<AccountStatementEventsInsertInput>;
  onConflict?: InputMaybe<AccountStatementEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountStatementEventsOneArgs = {
  object: AccountStatementEventsInsertInput;
  onConflict?: InputMaybe<AccountStatementEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountTagsArgs = {
  objects: Array<AccountTagsInsertInput>;
  onConflict?: InputMaybe<AccountTagsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountTagsOneArgs = {
  object: AccountTagsInsertInput;
  onConflict?: InputMaybe<AccountTagsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountTypesArgs = {
  objects: Array<AccountTypesInsertInput>;
  onConflict?: InputMaybe<AccountTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountTypesOneArgs = {
  object: AccountTypesInsertInput;
  onConflict?: InputMaybe<AccountTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountsArgs = {
  objects: Array<AccountsInsertInput>;
  onConflict?: InputMaybe<AccountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountsOneArgs = {
  object: AccountsInsertInput;
  onConflict?: InputMaybe<AccountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountsViewedByUserArgs = {
  objects: Array<AccountsViewedByUserInsertInput>;
  onConflict?: InputMaybe<AccountsViewedByUserOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAccountsViewedByUserOneArgs = {
  object: AccountsViewedByUserInsertInput;
  onConflict?: InputMaybe<AccountsViewedByUserOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertActivityItemsArgs = {
  objects: Array<ActivityItemsInsertInput>;
  onConflict?: InputMaybe<ActivityItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertActivityItemsOneArgs = {
  object: ActivityItemsInsertInput;
  onConflict?: InputMaybe<ActivityItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAddressesArgs = {
  objects: Array<AddressesInsertInput>;
  onConflict?: InputMaybe<AddressesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAddressesOneArgs = {
  object: AddressesInsertInput;
  onConflict?: InputMaybe<AddressesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAppointmentChecklistAssociationRulesArgs = {
  objects: Array<AppointmentChecklistAssociationRulesInsertInput>;
  onConflict?: InputMaybe<AppointmentChecklistAssociationRulesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAppointmentChecklistAssociationRulesOneArgs = {
  object: AppointmentChecklistAssociationRulesInsertInput;
  onConflict?: InputMaybe<AppointmentChecklistAssociationRulesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAppointmentChecklistInstancesArgs = {
  objects: Array<AppointmentChecklistInstancesInsertInput>;
  onConflict?: InputMaybe<AppointmentChecklistInstancesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAppointmentChecklistInstancesOneArgs = {
  object: AppointmentChecklistInstancesInsertInput;
  onConflict?: InputMaybe<AppointmentChecklistInstancesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAppointmentChecklistsArgs = {
  objects: Array<AppointmentChecklistsInsertInput>;
  onConflict?: InputMaybe<AppointmentChecklistsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAppointmentChecklistsOneArgs = {
  object: AppointmentChecklistsInsertInput;
  onConflict?: InputMaybe<AppointmentChecklistsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAssistantIntegratedPhonesArgs = {
  objects: Array<AssistantIntegratedPhonesInsertInput>;
  onConflict?: InputMaybe<AssistantIntegratedPhonesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAssistantIntegratedPhonesOneArgs = {
  object: AssistantIntegratedPhonesInsertInput;
  onConflict?: InputMaybe<AssistantIntegratedPhonesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAssistantPhoneSettingsArgs = {
  objects: Array<AssistantPhoneSettingsInsertInput>;
  onConflict?: InputMaybe<AssistantPhoneSettingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAssistantPhoneSettingsOneArgs = {
  object: AssistantPhoneSettingsInsertInput;
  onConflict?: InputMaybe<AssistantPhoneSettingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAssistantsArgs = {
  objects: Array<AssistantsInsertInput>;
  onConflict?: InputMaybe<AssistantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAssistantsOneArgs = {
  object: AssistantsInsertInput;
  onConflict?: InputMaybe<AssistantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBillingProfileHiddenPaymentMethodsArgs = {
  objects: Array<BillingProfileHiddenPaymentMethodsInsertInput>;
  onConflict?: InputMaybe<BillingProfileHiddenPaymentMethodsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBillingProfileHiddenPaymentMethodsOneArgs = {
  object: BillingProfileHiddenPaymentMethodsInsertInput;
  onConflict?: InputMaybe<BillingProfileHiddenPaymentMethodsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBillingProfilesArgs = {
  objects: Array<BillingProfilesInsertInput>;
  onConflict?: InputMaybe<BillingProfilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBillingProfilesOneArgs = {
  object: BillingProfilesInsertInput;
  onConflict?: InputMaybe<BillingProfilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBusinessEventsArgs = {
  objects: Array<BusinessEventsInsertInput>;
  onConflict?: InputMaybe<BusinessEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBusinessEventsOneArgs = {
  object: BusinessEventsInsertInput;
  onConflict?: InputMaybe<BusinessEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBusinessUnitTargetMetricsArgs = {
  objects: Array<BusinessUnitTargetMetricsInsertInput>;
  onConflict?: InputMaybe<BusinessUnitTargetMetricsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBusinessUnitTargetMetricsOneArgs = {
  object: BusinessUnitTargetMetricsInsertInput;
  onConflict?: InputMaybe<BusinessUnitTargetMetricsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBusinessUnitsArgs = {
  objects: Array<BusinessUnitsInsertInput>;
  onConflict?: InputMaybe<BusinessUnitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBusinessUnitsOneArgs = {
  object: BusinessUnitsInsertInput;
  onConflict?: InputMaybe<BusinessUnitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCanonicalLeadSourcesArgs = {
  objects: Array<CanonicalLeadSourcesInsertInput>;
  onConflict?: InputMaybe<CanonicalLeadSourcesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCanonicalLeadSourcesOneArgs = {
  object: CanonicalLeadSourcesInsertInput;
  onConflict?: InputMaybe<CanonicalLeadSourcesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCartItemJobCostLinksArgs = {
  objects: Array<CartItemJobCostLinksInsertInput>;
  onConflict?: InputMaybe<CartItemJobCostLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCartItemJobCostLinksOneArgs = {
  object: CartItemJobCostLinksInsertInput;
  onConflict?: InputMaybe<CartItemJobCostLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCartItemsArgs = {
  objects: Array<CartItemsInsertInput>;
  onConflict?: InputMaybe<CartItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCartItemsOneArgs = {
  object: CartItemsInsertInput;
  onConflict?: InputMaybe<CartItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChecklistItemsArgs = {
  objects: Array<ChecklistItemsInsertInput>;
  onConflict?: InputMaybe<ChecklistItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChecklistItemsOneArgs = {
  object: ChecklistItemsInsertInput;
  onConflict?: InputMaybe<ChecklistItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompaniesArgs = {
  objects: Array<CompaniesInsertInput>;
  onConflict?: InputMaybe<CompaniesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompaniesOneArgs = {
  object: CompaniesInsertInput;
  onConflict?: InputMaybe<CompaniesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyAppointmentArrivalWindowsArgs = {
  objects: Array<CompanyAppointmentArrivalWindowsInsertInput>;
  onConflict?: InputMaybe<CompanyAppointmentArrivalWindowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyAppointmentArrivalWindowsOneArgs = {
  object: CompanyAppointmentArrivalWindowsInsertInput;
  onConflict?: InputMaybe<CompanyAppointmentArrivalWindowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyCommissionConfigArgs = {
  objects: Array<CompanyCommissionConfigInsertInput>;
  onConflict?: InputMaybe<CompanyCommissionConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyCommissionConfigOneArgs = {
  object: CompanyCommissionConfigInsertInput;
  onConflict?: InputMaybe<CompanyCommissionConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyConfigArgs = {
  objects: Array<CompanyConfigInsertInput>;
  onConflict?: InputMaybe<CompanyConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyConfigOneArgs = {
  object: CompanyConfigInsertInput;
  onConflict?: InputMaybe<CompanyConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyDripMarketingConfigArgs = {
  objects: Array<CompanyDripMarketingConfigInsertInput>;
  onConflict?: InputMaybe<CompanyDripMarketingConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyDripMarketingConfigOneArgs = {
  object: CompanyDripMarketingConfigInsertInput;
  onConflict?: InputMaybe<CompanyDripMarketingConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyLeadSourceLinksArgs = {
  objects: Array<CompanyLeadSourceLinksInsertInput>;
  onConflict?: InputMaybe<CompanyLeadSourceLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyLeadSourceLinksOneArgs = {
  object: CompanyLeadSourceLinksInsertInput;
  onConflict?: InputMaybe<CompanyLeadSourceLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyLeadSourcesArgs = {
  objects: Array<CompanyLeadSourcesInsertInput>;
  onConflict?: InputMaybe<CompanyLeadSourcesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyLeadSourcesOneArgs = {
  object: CompanyLeadSourcesInsertInput;
  onConflict?: InputMaybe<CompanyLeadSourcesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyNotificationSettingsArgs = {
  objects: Array<CompanyNotificationSettingsInsertInput>;
  onConflict?: InputMaybe<CompanyNotificationSettingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyNotificationSettingsOneArgs = {
  object: CompanyNotificationSettingsInsertInput;
  onConflict?: InputMaybe<CompanyNotificationSettingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyPricingTierConfigArgs = {
  objects: Array<CompanyPricingTierConfigInsertInput>;
  onConflict?: InputMaybe<CompanyPricingTierConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyPricingTierConfigOneArgs = {
  object: CompanyPricingTierConfigInsertInput;
  onConflict?: InputMaybe<CompanyPricingTierConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyRolesArgs = {
  objects: Array<CompanyRolesInsertInput>;
  onConflict?: InputMaybe<CompanyRolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyRolesOneArgs = {
  object: CompanyRolesInsertInput;
  onConflict?: InputMaybe<CompanyRolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyTaxConfigurationsArgs = {
  objects: Array<CompanyTaxConfigurationsInsertInput>;
  onConflict?: InputMaybe<CompanyTaxConfigurationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyTaxConfigurationsOneArgs = {
  object: CompanyTaxConfigurationsInsertInput;
  onConflict?: InputMaybe<CompanyTaxConfigurationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyUsersArgs = {
  objects: Array<CompanyUsersInsertInput>;
  onConflict?: InputMaybe<CompanyUsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyUsersOneArgs = {
  object: CompanyUsersInsertInput;
  onConflict?: InputMaybe<CompanyUsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyWorkingDisplayHoursArgs = {
  objects: Array<CompanyWorkingDisplayHoursInsertInput>;
  onConflict?: InputMaybe<CompanyWorkingDisplayHoursOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompanyWorkingDisplayHoursOneArgs = {
  object: CompanyWorkingDisplayHoursInsertInput;
  onConflict?: InputMaybe<CompanyWorkingDisplayHoursOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContactsArgs = {
  objects: Array<ContactsInsertInput>;
  onConflict?: InputMaybe<ContactsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertContactsOneArgs = {
  object: ContactsInsertInput;
  onConflict?: InputMaybe<ContactsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCurrentCompanyTaxConfigurationsViewArgs = {
  objects: Array<CurrentCompanyTaxConfigurationsViewInsertInput>;
};


/** mutation root */
export type Mutation_RootInsertCurrentCompanyTaxConfigurationsViewOneArgs = {
  object: CurrentCompanyTaxConfigurationsViewInsertInput;
};


/** mutation root */
export type Mutation_RootInsertCurrentUserBusinessUnitsViewArgs = {
  objects: Array<CurrentUserBusinessUnitsViewInsertInput>;
};


/** mutation root */
export type Mutation_RootInsertCurrentUserBusinessUnitsViewOneArgs = {
  object: CurrentUserBusinessUnitsViewInsertInput;
};


/** mutation root */
export type Mutation_RootInsertCustomerCommunicationTemplatesArgs = {
  objects: Array<CustomerCommunicationTemplatesInsertInput>;
  onConflict?: InputMaybe<CustomerCommunicationTemplatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCustomerCommunicationTemplatesOneArgs = {
  object: CustomerCommunicationTemplatesInsertInput;
  onConflict?: InputMaybe<CustomerCommunicationTemplatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDiscountEntitlementsArgs = {
  objects: Array<DiscountEntitlementsInsertInput>;
  onConflict?: InputMaybe<DiscountEntitlementsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDiscountEntitlementsOneArgs = {
  object: DiscountEntitlementsInsertInput;
  onConflict?: InputMaybe<DiscountEntitlementsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDisplayIdCountersArgs = {
  objects: Array<DisplayIdCountersInsertInput>;
  onConflict?: InputMaybe<DisplayIdCountersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDisplayIdCountersOneArgs = {
  object: DisplayIdCountersInsertInput;
  onConflict?: InputMaybe<DisplayIdCountersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDripMarketingEmailsArgs = {
  objects: Array<DripMarketingEmailsInsertInput>;
  onConflict?: InputMaybe<DripMarketingEmailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDripMarketingEmailsOneArgs = {
  object: DripMarketingEmailsInsertInput;
  onConflict?: InputMaybe<DripMarketingEmailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEmailAddressesArgs = {
  objects: Array<EmailAddressesInsertInput>;
  onConflict?: InputMaybe<EmailAddressesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEmailAddressesOneArgs = {
  object: EmailAddressesInsertInput;
  onConflict?: InputMaybe<EmailAddressesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEntitlementsArgs = {
  objects: Array<EntitlementsInsertInput>;
  onConflict?: InputMaybe<EntitlementsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEntitlementsOneArgs = {
  object: EntitlementsInsertInput;
  onConflict?: InputMaybe<EntitlementsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEquipmentTypeLinksArgs = {
  objects: Array<EquipmentTypeLinksInsertInput>;
  onConflict?: InputMaybe<EquipmentTypeLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEquipmentTypeLinksOneArgs = {
  object: EquipmentTypeLinksInsertInput;
  onConflict?: InputMaybe<EquipmentTypeLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEquipmentTypesArgs = {
  objects: Array<EquipmentTypesInsertInput>;
  onConflict?: InputMaybe<EquipmentTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEquipmentTypesOneArgs = {
  object: EquipmentTypesInsertInput;
  onConflict?: InputMaybe<EquipmentTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimateInvoicesArgs = {
  objects: Array<EstimateInvoicesInsertInput>;
  onConflict?: InputMaybe<EstimateInvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimateInvoicesOneArgs = {
  object: EstimateInvoicesInsertInput;
  onConflict?: InputMaybe<EstimateInvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimateOptionCartItemsArgs = {
  objects: Array<EstimateOptionCartItemsInsertInput>;
  onConflict?: InputMaybe<EstimateOptionCartItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimateOptionCartItemsOneArgs = {
  object: EstimateOptionCartItemsInsertInput;
  onConflict?: InputMaybe<EstimateOptionCartItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimateOptionDiscountsArgs = {
  objects: Array<EstimateOptionDiscountsInsertInput>;
  onConflict?: InputMaybe<EstimateOptionDiscountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimateOptionDiscountsOneArgs = {
  object: EstimateOptionDiscountsInsertInput;
  onConflict?: InputMaybe<EstimateOptionDiscountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimateOptionsArgs = {
  objects: Array<EstimateOptionsInsertInput>;
  onConflict?: InputMaybe<EstimateOptionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimateOptionsOneArgs = {
  object: EstimateOptionsInsertInput;
  onConflict?: InputMaybe<EstimateOptionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimatePhotosArgs = {
  objects: Array<EstimatePhotosInsertInput>;
  onConflict?: InputMaybe<EstimatePhotosOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimatePhotosOneArgs = {
  object: EstimatePhotosInsertInput;
  onConflict?: InputMaybe<EstimatePhotosOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimateTemplatesArgs = {
  objects: Array<EstimateTemplatesInsertInput>;
  onConflict?: InputMaybe<EstimateTemplatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimateTemplatesOneArgs = {
  object: EstimateTemplatesInsertInput;
  onConflict?: InputMaybe<EstimateTemplatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimatesArgs = {
  objects: Array<EstimatesInsertInput>;
  onConflict?: InputMaybe<EstimatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimatesOneArgs = {
  object: EstimatesInsertInput;
  onConflict?: InputMaybe<EstimatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimatesQueryableArgs = {
  objects: Array<EstimatesQueryableInsertInput>;
  onConflict?: InputMaybe<EstimatesQueryableOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEstimatesQueryableOneArgs = {
  object: EstimatesQueryableInsertInput;
  onConflict?: InputMaybe<EstimatesQueryableOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventStoreArgs = {
  objects: Array<EventStoreInsertInput>;
  onConflict?: InputMaybe<EventStoreOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEventStoreOneArgs = {
  object: EventStoreInsertInput;
  onConflict?: InputMaybe<EventStoreOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFavoritePricebookItemsArgs = {
  objects: Array<FavoritePricebookItemsInsertInput>;
  onConflict?: InputMaybe<FavoritePricebookItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFavoritePricebookItemsOneArgs = {
  object: FavoritePricebookItemsInsertInput;
  onConflict?: InputMaybe<FavoritePricebookItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFileLinksArgs = {
  objects: Array<FileLinksInsertInput>;
  onConflict?: InputMaybe<FileLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFileLinksOneArgs = {
  object: FileLinksInsertInput;
  onConflict?: InputMaybe<FileLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFilesArgs = {
  objects: Array<FilesInsertInput>;
  onConflict?: InputMaybe<FilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFilesOneArgs = {
  object: FilesInsertInput;
  onConflict?: InputMaybe<FilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInstalledEquipmentArgs = {
  objects: Array<InstalledEquipmentInsertInput>;
  onConflict?: InputMaybe<InstalledEquipmentOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInstalledEquipmentOneArgs = {
  object: InstalledEquipmentInsertInput;
  onConflict?: InputMaybe<InstalledEquipmentOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInstalledHvacSystemsArgs = {
  objects: Array<InstalledHvacSystemsInsertInput>;
  onConflict?: InputMaybe<InstalledHvacSystemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInstalledHvacSystemsOneArgs = {
  object: InstalledHvacSystemsInsertInput;
  onConflict?: InputMaybe<InstalledHvacSystemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInstantBookingWeeklyScheduleEntriesArgs = {
  objects: Array<InstantBookingWeeklyScheduleEntriesInsertInput>;
  onConflict?: InputMaybe<InstantBookingWeeklyScheduleEntriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInstantBookingWeeklyScheduleEntriesOneArgs = {
  object: InstantBookingWeeklyScheduleEntriesInsertInput;
  onConflict?: InputMaybe<InstantBookingWeeklyScheduleEntriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInstantBookingWeeklyScheduleEntryBookableArrivalWindowsArgs = {
  objects: Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsInsertInput>;
  onConflict?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInstantBookingWeeklyScheduleEntryBookableArrivalWindowsOneArgs = {
  object: InstantBookingWeeklyScheduleEntryBookableArrivalWindowsInsertInput;
  onConflict?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedChannelsArgs = {
  objects: Array<IntegratedChannelsInsertInput>;
  onConflict?: InputMaybe<IntegratedChannelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedChannelsOneArgs = {
  object: IntegratedChannelsInsertInput;
  onConflict?: InputMaybe<IntegratedChannelsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedMessageStatusesArgs = {
  objects: Array<IntegratedMessageStatusesInsertInput>;
  onConflict?: InputMaybe<IntegratedMessageStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedMessageStatusesOneArgs = {
  object: IntegratedMessageStatusesInsertInput;
  onConflict?: InputMaybe<IntegratedMessageStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedMessageTwilioRawWebhookEventsArgs = {
  objects: Array<IntegratedMessageTwilioRawWebhookEventsInsertInput>;
  onConflict?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedMessageTwilioRawWebhookEventsOneArgs = {
  object: IntegratedMessageTwilioRawWebhookEventsInsertInput;
  onConflict?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedMessagesArgs = {
  objects: Array<IntegratedMessagesInsertInput>;
  onConflict?: InputMaybe<IntegratedMessagesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedMessagesOneArgs = {
  object: IntegratedMessagesInsertInput;
  onConflict?: InputMaybe<IntegratedMessagesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCallDismissalsArgs = {
  objects: Array<IntegratedPhoneCallDismissalsInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneCallDismissalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCallDismissalsOneArgs = {
  object: IntegratedPhoneCallDismissalsInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneCallDismissalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCallJobsArgs = {
  objects: Array<IntegratedPhoneCallJobsInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneCallJobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCallJobsOneArgs = {
  object: IntegratedPhoneCallJobsInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneCallJobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCallRecordingArgs = {
  objects: Array<IntegratedPhoneCallRecordingInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneCallRecordingOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCallRecordingOneArgs = {
  object: IntegratedPhoneCallRecordingInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneCallRecordingOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCallStatusTypesArgs = {
  objects: Array<IntegratedPhoneCallStatusTypesInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneCallStatusTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCallStatusTypesOneArgs = {
  object: IntegratedPhoneCallStatusTypesInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneCallStatusTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCallStatusesArgs = {
  objects: Array<IntegratedPhoneCallStatusesInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneCallStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCallStatusesOneArgs = {
  object: IntegratedPhoneCallStatusesInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneCallStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCallsArgs = {
  objects: Array<IntegratedPhoneCallsInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneCallsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCallsOneArgs = {
  object: IntegratedPhoneCallsInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneCallsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCompanyConfigArgs = {
  objects: Array<IntegratedPhoneCompanyConfigInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneCompanyConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneCompanyConfigOneArgs = {
  object: IntegratedPhoneCompanyConfigInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneCompanyConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneMissedCallDismissalsArgs = {
  objects: Array<IntegratedPhoneMissedCallDismissalsInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneMissedCallDismissalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneMissedCallDismissalsOneArgs = {
  object: IntegratedPhoneMissedCallDismissalsInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneMissedCallDismissalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneMissedCallsArgs = {
  objects: Array<IntegratedPhoneMissedCallsInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneMissedCallsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneMissedCallsOneArgs = {
  object: IntegratedPhoneMissedCallsInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneMissedCallsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneTwilioRawWebhookEventsArgs = {
  objects: Array<IntegratedPhoneTwilioRawWebhookEventsInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneTwilioRawWebhookEventsOneArgs = {
  object: IntegratedPhoneTwilioRawWebhookEventsInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneUsersArgs = {
  objects: Array<IntegratedPhoneUsersInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneUsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneUsersOneArgs = {
  object: IntegratedPhoneUsersInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneUsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneVoicemailDismissalsArgs = {
  objects: Array<IntegratedPhoneVoicemailDismissalsInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneVoicemailDismissalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneVoicemailDismissalsOneArgs = {
  object: IntegratedPhoneVoicemailDismissalsInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneVoicemailDismissalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneVoicemailsArgs = {
  objects: Array<IntegratedPhoneVoicemailsInsertInput>;
  onConflict?: InputMaybe<IntegratedPhoneVoicemailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhoneVoicemailsOneArgs = {
  object: IntegratedPhoneVoicemailsInsertInput;
  onConflict?: InputMaybe<IntegratedPhoneVoicemailsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhonesArgs = {
  objects: Array<IntegratedPhonesInsertInput>;
  onConflict?: InputMaybe<IntegratedPhonesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertIntegratedPhonesOneArgs = {
  object: IntegratedPhonesInsertInput;
  onConflict?: InputMaybe<IntegratedPhonesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInternalNotificationsArgs = {
  objects: Array<InternalNotificationsInsertInput>;
  onConflict?: InputMaybe<InternalNotificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInternalNotificationsOneArgs = {
  object: InternalNotificationsInsertInput;
  onConflict?: InputMaybe<InternalNotificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceCartItemBundleItemsArgs = {
  objects: Array<InvoiceCartItemBundleItemsInsertInput>;
  onConflict?: InputMaybe<InvoiceCartItemBundleItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceCartItemBundleItemsOneArgs = {
  object: InvoiceCartItemBundleItemsInsertInput;
  onConflict?: InputMaybe<InvoiceCartItemBundleItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceCartItemBundleJobCostLinksArgs = {
  objects: Array<InvoiceCartItemBundleJobCostLinksInsertInput>;
  onConflict?: InputMaybe<InvoiceCartItemBundleJobCostLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceCartItemBundleJobCostLinksOneArgs = {
  object: InvoiceCartItemBundleJobCostLinksInsertInput;
  onConflict?: InputMaybe<InvoiceCartItemBundleJobCostLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceCartItemsArgs = {
  objects: Array<InvoiceCartItemsInsertInput>;
  onConflict?: InputMaybe<InvoiceCartItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceCartItemsOneArgs = {
  object: InvoiceCartItemsInsertInput;
  onConflict?: InputMaybe<InvoiceCartItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceDiscountsArgs = {
  objects: Array<InvoiceDiscountsInsertInput>;
  onConflict?: InputMaybe<InvoiceDiscountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceDiscountsOneArgs = {
  object: InvoiceDiscountsInsertInput;
  onConflict?: InputMaybe<InvoiceDiscountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceEventsArgs = {
  objects: Array<InvoiceEventsInsertInput>;
  onConflict?: InputMaybe<InvoiceEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceEventsOneArgs = {
  object: InvoiceEventsInsertInput;
  onConflict?: InputMaybe<InvoiceEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoicePaymentsArgs = {
  objects: Array<InvoicePaymentsInsertInput>;
  onConflict?: InputMaybe<InvoicePaymentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoicePaymentsOneArgs = {
  object: InvoicePaymentsInsertInput;
  onConflict?: InputMaybe<InvoicePaymentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceReminderDataArgs = {
  objects: Array<InvoiceReminderDataInsertInput>;
  onConflict?: InputMaybe<InvoiceReminderDataOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceReminderDataOneArgs = {
  object: InvoiceReminderDataInsertInput;
  onConflict?: InputMaybe<InvoiceReminderDataOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceTemplateCartItemsArgs = {
  objects: Array<InvoiceTemplateCartItemsInsertInput>;
  onConflict?: InputMaybe<InvoiceTemplateCartItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceTemplateCartItemsOneArgs = {
  object: InvoiceTemplateCartItemsInsertInput;
  onConflict?: InputMaybe<InvoiceTemplateCartItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceTemplatesArgs = {
  objects: Array<InvoiceTemplatesInsertInput>;
  onConflict?: InputMaybe<InvoiceTemplatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoiceTemplatesOneArgs = {
  object: InvoiceTemplatesInsertInput;
  onConflict?: InputMaybe<InvoiceTemplatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoicesArgs = {
  objects: Array<InvoicesInsertInput>;
  onConflict?: InputMaybe<InvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoicesOneArgs = {
  object: InvoicesInsertInput;
  onConflict?: InputMaybe<InvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoicesQueryableArgs = {
  objects: Array<InvoicesQueryableInsertInput>;
  onConflict?: InputMaybe<InvoicesQueryableOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertInvoicesQueryableOneArgs = {
  object: InvoicesQueryableInsertInput;
  onConflict?: InputMaybe<InvoicesQueryableOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentAssignmentStatusTypesArgs = {
  objects: Array<JobAppointmentAssignmentStatusTypesInsertInput>;
  onConflict?: InputMaybe<JobAppointmentAssignmentStatusTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentAssignmentStatusTypesOneArgs = {
  object: JobAppointmentAssignmentStatusTypesInsertInput;
  onConflict?: InputMaybe<JobAppointmentAssignmentStatusTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentAssignmentStatusesArgs = {
  objects: Array<JobAppointmentAssignmentStatusesInsertInput>;
  onConflict?: InputMaybe<JobAppointmentAssignmentStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentAssignmentStatusesOneArgs = {
  object: JobAppointmentAssignmentStatusesInsertInput;
  onConflict?: InputMaybe<JobAppointmentAssignmentStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentAssignmentsArgs = {
  objects: Array<JobAppointmentAssignmentsInsertInput>;
  onConflict?: InputMaybe<JobAppointmentAssignmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentAssignmentsOneArgs = {
  object: JobAppointmentAssignmentsInsertInput;
  onConflict?: InputMaybe<JobAppointmentAssignmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentCancellationStatusesArgs = {
  objects: Array<JobAppointmentCancellationStatusesInsertInput>;
  onConflict?: InputMaybe<JobAppointmentCancellationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentCancellationStatusesOneArgs = {
  object: JobAppointmentCancellationStatusesInsertInput;
  onConflict?: InputMaybe<JobAppointmentCancellationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentConfirmationStatusesArgs = {
  objects: Array<JobAppointmentConfirmationStatusesInsertInput>;
  onConflict?: InputMaybe<JobAppointmentConfirmationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentConfirmationStatusesOneArgs = {
  object: JobAppointmentConfirmationStatusesInsertInput;
  onConflict?: InputMaybe<JobAppointmentConfirmationStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentInvoicesArgs = {
  objects: Array<JobAppointmentInvoicesInsertInput>;
  onConflict?: InputMaybe<JobAppointmentInvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentInvoicesOneArgs = {
  object: JobAppointmentInvoicesInsertInput;
  onConflict?: InputMaybe<JobAppointmentInvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentsArgs = {
  objects: Array<JobAppointmentsInsertInput>;
  onConflict?: InputMaybe<JobAppointmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobAppointmentsOneArgs = {
  object: JobAppointmentsInsertInput;
  onConflict?: InputMaybe<JobAppointmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobCostItemsArgs = {
  objects: Array<JobCostItemsInsertInput>;
  onConflict?: InputMaybe<JobCostItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobCostItemsOneArgs = {
  object: JobCostItemsInsertInput;
  onConflict?: InputMaybe<JobCostItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobCostMiscCategoriesArgs = {
  objects: Array<JobCostMiscCategoriesInsertInput>;
  onConflict?: InputMaybe<JobCostMiscCategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobCostMiscCategoriesOneArgs = {
  object: JobCostMiscCategoriesInsertInput;
  onConflict?: InputMaybe<JobCostMiscCategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobCostingConfigArgs = {
  objects: Array<JobCostingConfigInsertInput>;
  onConflict?: InputMaybe<JobCostingConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobCostingConfigOneArgs = {
  object: JobCostingConfigInsertInput;
  onConflict?: InputMaybe<JobCostingConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobInvoicesArgs = {
  objects: Array<JobInvoicesInsertInput>;
  onConflict?: InputMaybe<JobInvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobInvoicesOneArgs = {
  object: JobInvoicesInsertInput;
  onConflict?: InputMaybe<JobInvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobLeadsArgs = {
  objects: Array<JobLeadsInsertInput>;
  onConflict?: InputMaybe<JobLeadsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobLeadsOneArgs = {
  object: JobLeadsInsertInput;
  onConflict?: InputMaybe<JobLeadsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobLifecycleStatusesArgs = {
  objects: Array<JobLifecycleStatusesInsertInput>;
  onConflict?: InputMaybe<JobLifecycleStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobLifecycleStatusesOneArgs = {
  object: JobLifecycleStatusesInsertInput;
  onConflict?: InputMaybe<JobLifecycleStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobLifecycleTypesArgs = {
  objects: Array<JobLifecycleTypesInsertInput>;
  onConflict?: InputMaybe<JobLifecycleTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobLifecycleTypesOneArgs = {
  object: JobLifecycleTypesInsertInput;
  onConflict?: InputMaybe<JobLifecycleTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobLifecycleViewsArgs = {
  objects: Array<JobLifecycleViewsInsertInput>;
  onConflict?: InputMaybe<JobLifecycleViewsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobLifecycleViewsOneArgs = {
  object: JobLifecycleViewsInsertInput;
  onConflict?: InputMaybe<JobLifecycleViewsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobLifecyclesArgs = {
  objects: Array<JobLifecyclesInsertInput>;
  onConflict?: InputMaybe<JobLifecyclesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobLifecyclesOneArgs = {
  object: JobLifecyclesInsertInput;
  onConflict?: InputMaybe<JobLifecyclesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobRequestsCompanyConfigArgs = {
  objects: Array<JobRequestsCompanyConfigInsertInput>;
  onConflict?: InputMaybe<JobRequestsCompanyConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobRequestsCompanyConfigOneArgs = {
  object: JobRequestsCompanyConfigInsertInput;
  onConflict?: InputMaybe<JobRequestsCompanyConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobTagsArgs = {
  objects: Array<JobTagsInsertInput>;
  onConflict?: InputMaybe<JobTagsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobTagsOneArgs = {
  object: JobTagsInsertInput;
  onConflict?: InputMaybe<JobTagsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobTeamMembersArgs = {
  objects: Array<JobTeamMembersInsertInput>;
  onConflict?: InputMaybe<JobTeamMembersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobTeamMembersOneArgs = {
  object: JobTeamMembersInsertInput;
  onConflict?: InputMaybe<JobTeamMembersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobTechnicianEarnedRevenueAttributionsArgs = {
  objects: Array<JobTechnicianEarnedRevenueAttributionsInsertInput>;
  onConflict?: InputMaybe<JobTechnicianEarnedRevenueAttributionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobTechnicianEarnedRevenueAttributionsOneArgs = {
  object: JobTechnicianEarnedRevenueAttributionsInsertInput;
  onConflict?: InputMaybe<JobTechnicianEarnedRevenueAttributionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobTechnicianSoldRevenueAttributionsArgs = {
  objects: Array<JobTechnicianSoldRevenueAttributionsInsertInput>;
  onConflict?: InputMaybe<JobTechnicianSoldRevenueAttributionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobTechnicianSoldRevenueAttributionsOneArgs = {
  object: JobTechnicianSoldRevenueAttributionsInsertInput;
  onConflict?: InputMaybe<JobTechnicianSoldRevenueAttributionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobTypeChangeReasonsArgs = {
  objects: Array<JobTypeChangeReasonsInsertInput>;
  onConflict?: InputMaybe<JobTypeChangeReasonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobTypeChangeReasonsOneArgs = {
  object: JobTypeChangeReasonsInsertInput;
  onConflict?: InputMaybe<JobTypeChangeReasonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobTypesArgs = {
  objects: Array<JobTypesInsertInput>;
  onConflict?: InputMaybe<JobTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobTypesOneArgs = {
  object: JobTypesInsertInput;
  onConflict?: InputMaybe<JobTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobsArgs = {
  objects: Array<JobsInsertInput>;
  onConflict?: InputMaybe<JobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobsOneArgs = {
  object: JobsInsertInput;
  onConflict?: InputMaybe<JobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobsWithLinkedJobArgs = {
  objects: Array<JobsWithLinkedJobInsertInput>;
  onConflict?: InputMaybe<JobsWithLinkedJobOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobsWithLinkedJobLinkedAppointmentChecklistInstancesArgs = {
  objects: Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesInsertInput>;
  onConflict?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobsWithLinkedJobLinkedAppointmentChecklistInstancesOneArgs = {
  object: JobsWithLinkedJobLinkedAppointmentChecklistInstancesInsertInput;
  onConflict?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobsWithLinkedJobLinkedEstimatesArgs = {
  objects: Array<JobsWithLinkedJobLinkedEstimatesInsertInput>;
  onConflict?: InputMaybe<JobsWithLinkedJobLinkedEstimatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobsWithLinkedJobLinkedEstimatesOneArgs = {
  object: JobsWithLinkedJobLinkedEstimatesInsertInput;
  onConflict?: InputMaybe<JobsWithLinkedJobLinkedEstimatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobsWithLinkedJobOneArgs = {
  object: JobsWithLinkedJobInsertInput;
  onConflict?: InputMaybe<JobsWithLinkedJobOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLocationContactsArgs = {
  objects: Array<LocationContactsInsertInput>;
  onConflict?: InputMaybe<LocationContactsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLocationContactsOneArgs = {
  object: LocationContactsInsertInput;
  onConflict?: InputMaybe<LocationContactsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLocationInvoicesArgs = {
  objects: Array<LocationInvoicesInsertInput>;
  onConflict?: InputMaybe<LocationInvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLocationInvoicesOneArgs = {
  object: LocationInvoicesInsertInput;
  onConflict?: InputMaybe<LocationInvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLocationsArgs = {
  objects: Array<LocationsInsertInput>;
  onConflict?: InputMaybe<LocationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLocationsOneArgs = {
  object: LocationsInsertInput;
  onConflict?: InputMaybe<LocationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanDefinitionAllowedPaymentIntervalsArgs = {
  objects: Array<MaintenancePlanDefinitionAllowedPaymentIntervalsInsertInput>;
  onConflict?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanDefinitionAllowedPaymentIntervalsOneArgs = {
  object: MaintenancePlanDefinitionAllowedPaymentIntervalsInsertInput;
  onConflict?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanDefinitionBenefitsArgs = {
  objects: Array<MaintenancePlanDefinitionBenefitsInsertInput>;
  onConflict?: InputMaybe<MaintenancePlanDefinitionBenefitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanDefinitionBenefitsOneArgs = {
  object: MaintenancePlanDefinitionBenefitsInsertInput;
  onConflict?: InputMaybe<MaintenancePlanDefinitionBenefitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanDefinitionDiscountsArgs = {
  objects: Array<MaintenancePlanDefinitionDiscountsInsertInput>;
  onConflict?: InputMaybe<MaintenancePlanDefinitionDiscountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanDefinitionDiscountsOneArgs = {
  object: MaintenancePlanDefinitionDiscountsInsertInput;
  onConflict?: InputMaybe<MaintenancePlanDefinitionDiscountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanDefinitionFlareArgs = {
  objects: Array<MaintenancePlanDefinitionFlareInsertInput>;
  onConflict?: InputMaybe<MaintenancePlanDefinitionFlareOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanDefinitionFlareOneArgs = {
  object: MaintenancePlanDefinitionFlareInsertInput;
  onConflict?: InputMaybe<MaintenancePlanDefinitionFlareOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanDefinitionMarketingInfoArgs = {
  objects: Array<MaintenancePlanDefinitionMarketingInfoInsertInput>;
  onConflict?: InputMaybe<MaintenancePlanDefinitionMarketingInfoOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanDefinitionMarketingInfoOneArgs = {
  object: MaintenancePlanDefinitionMarketingInfoInsertInput;
  onConflict?: InputMaybe<MaintenancePlanDefinitionMarketingInfoOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanDefinitionsArgs = {
  objects: Array<MaintenancePlanDefinitionsInsertInput>;
  onConflict?: InputMaybe<MaintenancePlanDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanDefinitionsOneArgs = {
  object: MaintenancePlanDefinitionsInsertInput;
  onConflict?: InputMaybe<MaintenancePlanDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanEquipmentCoverageDefinitionsArgs = {
  objects: Array<MaintenancePlanEquipmentCoverageDefinitionsInsertInput>;
  onConflict?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanEquipmentCoverageDefinitionsOneArgs = {
  object: MaintenancePlanEquipmentCoverageDefinitionsInsertInput;
  onConflict?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanEquipmentCoveragePricingsArgs = {
  objects: Array<MaintenancePlanEquipmentCoveragePricingsInsertInput>;
  onConflict?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanEquipmentCoveragePricingsOneArgs = {
  object: MaintenancePlanEquipmentCoveragePricingsInsertInput;
  onConflict?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanInvoicesArgs = {
  objects: Array<MaintenancePlanInvoicesInsertInput>;
  onConflict?: InputMaybe<MaintenancePlanInvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanInvoicesOneArgs = {
  object: MaintenancePlanInvoicesInsertInput;
  onConflict?: InputMaybe<MaintenancePlanInvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanVisitInstalledEquipmentsArgs = {
  objects: Array<MaintenancePlanVisitInstalledEquipmentsInsertInput>;
  onConflict?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanVisitInstalledEquipmentsOneArgs = {
  object: MaintenancePlanVisitInstalledEquipmentsInsertInput;
  onConflict?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanVisitsArgs = {
  objects: Array<MaintenancePlanVisitsInsertInput>;
  onConflict?: InputMaybe<MaintenancePlanVisitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlanVisitsOneArgs = {
  object: MaintenancePlanVisitsInsertInput;
  onConflict?: InputMaybe<MaintenancePlanVisitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlansQueryableArgs = {
  objects: Array<MaintenancePlansQueryableInsertInput>;
  onConflict?: InputMaybe<MaintenancePlansQueryableOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMaintenancePlansQueryableOneArgs = {
  object: MaintenancePlansQueryableInsertInput;
  onConflict?: InputMaybe<MaintenancePlansQueryableOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMigrationJunkArgs = {
  objects: Array<MigrationJunkInsertInput>;
  onConflict?: InputMaybe<MigrationJunkOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMigrationJunkLinksArgs = {
  objects: Array<MigrationJunkLinksInsertInput>;
  onConflict?: InputMaybe<MigrationJunkLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMigrationJunkLinksOneArgs = {
  object: MigrationJunkLinksInsertInput;
  onConflict?: InputMaybe<MigrationJunkLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertMigrationJunkOneArgs = {
  object: MigrationJunkInsertInput;
  onConflict?: InputMaybe<MigrationJunkOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNoteAttachmentsArgs = {
  objects: Array<NoteAttachmentsInsertInput>;
  onConflict?: InputMaybe<NoteAttachmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNoteAttachmentsOneArgs = {
  object: NoteAttachmentsInsertInput;
  onConflict?: InputMaybe<NoteAttachmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNoteLinksArgs = {
  objects: Array<NoteLinksInsertInput>;
  onConflict?: InputMaybe<NoteLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNoteLinksOneArgs = {
  object: NoteLinksInsertInput;
  onConflict?: InputMaybe<NoteLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNoteTaggedUsersArgs = {
  objects: Array<NoteTaggedUsersInsertInput>;
  onConflict?: InputMaybe<NoteTaggedUsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNoteTaggedUsersOneArgs = {
  object: NoteTaggedUsersInsertInput;
  onConflict?: InputMaybe<NoteTaggedUsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNotesArgs = {
  objects: Array<NotesInsertInput>;
  onConflict?: InputMaybe<NotesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertNotesOneArgs = {
  object: NotesInsertInput;
  onConflict?: InputMaybe<NotesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOnlineBookingCompanyConfigArgs = {
  objects: Array<OnlineBookingCompanyConfigInsertInput>;
  onConflict?: InputMaybe<OnlineBookingCompanyConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOnlineBookingCompanyConfigOneArgs = {
  object: OnlineBookingCompanyConfigInsertInput;
  onConflict?: InputMaybe<OnlineBookingCompanyConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOnlineBookingServiceAreaZipCodesArgs = {
  objects: Array<OnlineBookingServiceAreaZipCodesInsertInput>;
  onConflict?: InputMaybe<OnlineBookingServiceAreaZipCodesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOnlineBookingServiceAreaZipCodesOneArgs = {
  object: OnlineBookingServiceAreaZipCodesInsertInput;
  onConflict?: InputMaybe<OnlineBookingServiceAreaZipCodesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOnlineBookingServiceTypeBookableJobTypesArgs = {
  objects: Array<OnlineBookingServiceTypeBookableJobTypesInsertInput>;
  onConflict?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOnlineBookingServiceTypeBookableJobTypesOneArgs = {
  object: OnlineBookingServiceTypeBookableJobTypesInsertInput;
  onConflict?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOnlineBookingServiceTypeBookableTechniciansArgs = {
  objects: Array<OnlineBookingServiceTypeBookableTechniciansInsertInput>;
  onConflict?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOnlineBookingServiceTypeBookableTechniciansOneArgs = {
  object: OnlineBookingServiceTypeBookableTechniciansInsertInput;
  onConflict?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOnlineBookingServiceTypeConfigsArgs = {
  objects: Array<OnlineBookingServiceTypeConfigsInsertInput>;
  onConflict?: InputMaybe<OnlineBookingServiceTypeConfigsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOnlineBookingServiceTypeConfigsOneArgs = {
  object: OnlineBookingServiceTypeConfigsInsertInput;
  onConflict?: InputMaybe<OnlineBookingServiceTypeConfigsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentLinksArgs = {
  objects: Array<PaymentLinksInsertInput>;
  onConflict?: InputMaybe<PaymentLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentLinksOneArgs = {
  object: PaymentLinksInsertInput;
  onConflict?: InputMaybe<PaymentLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentMethodBillingInfoArgs = {
  objects: Array<PaymentMethodBillingInfoInsertInput>;
  onConflict?: InputMaybe<PaymentMethodBillingInfoOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentMethodBillingInfoOneArgs = {
  object: PaymentMethodBillingInfoInsertInput;
  onConflict?: InputMaybe<PaymentMethodBillingInfoOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentMethodCardMetadataArgs = {
  objects: Array<PaymentMethodCardMetadataInsertInput>;
  onConflict?: InputMaybe<PaymentMethodCardMetadataOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentMethodCardMetadataOneArgs = {
  object: PaymentMethodCardMetadataInsertInput;
  onConflict?: InputMaybe<PaymentMethodCardMetadataOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentMethodRecordsArgs = {
  objects: Array<PaymentMethodRecordsInsertInput>;
  onConflict?: InputMaybe<PaymentMethodRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentMethodRecordsOneArgs = {
  object: PaymentMethodRecordsInsertInput;
  onConflict?: InputMaybe<PaymentMethodRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentRecordsArgs = {
  objects: Array<PaymentRecordsInsertInput>;
  onConflict?: InputMaybe<PaymentRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentRecordsOneArgs = {
  object: PaymentRecordsInsertInput;
  onConflict?: InputMaybe<PaymentRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentRefundsArgs = {
  objects: Array<PaymentRefundsInsertInput>;
  onConflict?: InputMaybe<PaymentRefundsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentRefundsOneArgs = {
  object: PaymentRefundsInsertInput;
  onConflict?: InputMaybe<PaymentRefundsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentStatusErrorDetailArgs = {
  objects: Array<PaymentStatusErrorDetailInsertInput>;
  onConflict?: InputMaybe<PaymentStatusErrorDetailOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentStatusErrorDetailOneArgs = {
  object: PaymentStatusErrorDetailInsertInput;
  onConflict?: InputMaybe<PaymentStatusErrorDetailOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentStatusLatestArgs = {
  objects: Array<PaymentStatusLatestInsertInput>;
  onConflict?: InputMaybe<PaymentStatusLatestOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentStatusLatestOneArgs = {
  object: PaymentStatusLatestInsertInput;
  onConflict?: InputMaybe<PaymentStatusLatestOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentStatusesArgs = {
  objects: Array<PaymentStatusesInsertInput>;
  onConflict?: InputMaybe<PaymentStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentStatusesOneArgs = {
  object: PaymentStatusesInsertInput;
  onConflict?: InputMaybe<PaymentStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentSubscriptionInvoicesArgs = {
  objects: Array<PaymentSubscriptionInvoicesInsertInput>;
  onConflict?: InputMaybe<PaymentSubscriptionInvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentSubscriptionInvoicesOneArgs = {
  object: PaymentSubscriptionInvoicesInsertInput;
  onConflict?: InputMaybe<PaymentSubscriptionInvoicesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentSubscriptionStatusesArgs = {
  objects: Array<PaymentSubscriptionStatusesInsertInput>;
  onConflict?: InputMaybe<PaymentSubscriptionStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentSubscriptionStatusesOneArgs = {
  object: PaymentSubscriptionStatusesInsertInput;
  onConflict?: InputMaybe<PaymentSubscriptionStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentSubscriptionsArgs = {
  objects: Array<PaymentSubscriptionsInsertInput>;
  onConflict?: InputMaybe<PaymentSubscriptionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPaymentSubscriptionsOneArgs = {
  object: PaymentSubscriptionsInsertInput;
  onConflict?: InputMaybe<PaymentSubscriptionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPayoutItemsArgs = {
  objects: Array<PayoutItemsInsertInput>;
  onConflict?: InputMaybe<PayoutItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPayoutItemsOneArgs = {
  object: PayoutItemsInsertInput;
  onConflict?: InputMaybe<PayoutItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPayoutQboAccountsConfigArgs = {
  objects: Array<PayoutQboAccountsConfigInsertInput>;
  onConflict?: InputMaybe<PayoutQboAccountsConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPayoutQboAccountsConfigOneArgs = {
  object: PayoutQboAccountsConfigInsertInput;
  onConflict?: InputMaybe<PayoutQboAccountsConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPayoutsArgs = {
  objects: Array<PayoutsInsertInput>;
  onConflict?: InputMaybe<PayoutsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPayoutsOneArgs = {
  object: PayoutsInsertInput;
  onConflict?: InputMaybe<PayoutsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPhoneNumbersArgs = {
  objects: Array<PhoneNumbersInsertInput>;
  onConflict?: InputMaybe<PhoneNumbersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPhoneNumbersOneArgs = {
  object: PhoneNumbersInsertInput;
  onConflict?: InputMaybe<PhoneNumbersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPhotoLinksArgs = {
  objects: Array<PhotoLinksInsertInput>;
  onConflict?: InputMaybe<PhotoLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPhotoLinksOneArgs = {
  object: PhotoLinksInsertInput;
  onConflict?: InputMaybe<PhotoLinksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPhotosArgs = {
  objects: Array<PhotosInsertInput>;
  onConflict?: InputMaybe<PhotosOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPhotosOneArgs = {
  object: PhotosInsertInput;
  onConflict?: InputMaybe<PhotosOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookBundleItemsArgs = {
  objects: Array<PricebookBundleItemsInsertInput>;
  onConflict?: InputMaybe<PricebookBundleItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookBundleItemsOneArgs = {
  object: PricebookBundleItemsInsertInput;
  onConflict?: InputMaybe<PricebookBundleItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookCategoriesArgs = {
  objects: Array<PricebookCategoriesInsertInput>;
  onConflict?: InputMaybe<PricebookCategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookCategoriesOneArgs = {
  object: PricebookCategoriesInsertInput;
  onConflict?: InputMaybe<PricebookCategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookDiscountsArgs = {
  objects: Array<PricebookDiscountsInsertInput>;
  onConflict?: InputMaybe<PricebookDiscountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookDiscountsOneArgs = {
  object: PricebookDiscountsInsertInput;
  onConflict?: InputMaybe<PricebookDiscountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookItemTypeFallbackPhotosArgs = {
  objects: Array<PricebookItemTypeFallbackPhotosInsertInput>;
  onConflict?: InputMaybe<PricebookItemTypeFallbackPhotosOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookItemTypeFallbackPhotosOneArgs = {
  object: PricebookItemTypeFallbackPhotosInsertInput;
  onConflict?: InputMaybe<PricebookItemTypeFallbackPhotosOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookItemsArgs = {
  objects: Array<PricebookItemsInsertInput>;
  onConflict?: InputMaybe<PricebookItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookItemsOneArgs = {
  object: PricebookItemsInsertInput;
  onConflict?: InputMaybe<PricebookItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookItemsQboIncomeAccountsArgs = {
  objects: Array<PricebookItemsQboIncomeAccountsInsertInput>;
  onConflict?: InputMaybe<PricebookItemsQboIncomeAccountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookItemsQboIncomeAccountsOneArgs = {
  object: PricebookItemsQboIncomeAccountsInsertInput;
  onConflict?: InputMaybe<PricebookItemsQboIncomeAccountsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookMarkupTiersArgs = {
  objects: Array<PricebookMarkupTiersInsertInput>;
  onConflict?: InputMaybe<PricebookMarkupTiersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookMarkupTiersOneArgs = {
  object: PricebookMarkupTiersInsertInput;
  onConflict?: InputMaybe<PricebookMarkupTiersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookTaxRatesArgs = {
  objects: Array<PricebookTaxRatesInsertInput>;
  onConflict?: InputMaybe<PricebookTaxRatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookTaxRatesOneArgs = {
  object: PricebookTaxRatesInsertInput;
  onConflict?: InputMaybe<PricebookTaxRatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookVersionsArgs = {
  objects: Array<PricebookVersionsInsertInput>;
  onConflict?: InputMaybe<PricebookVersionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPricebookVersionsOneArgs = {
  object: PricebookVersionsInsertInput;
  onConflict?: InputMaybe<PricebookVersionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPurchaseOrdersArgs = {
  objects: Array<PurchaseOrdersInsertInput>;
  onConflict?: InputMaybe<PurchaseOrdersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPurchaseOrdersOneArgs = {
  object: PurchaseOrdersInsertInput;
  onConflict?: InputMaybe<PurchaseOrdersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertQboAuthDataArgs = {
  objects: Array<QboAuthDataInsertInput>;
  onConflict?: InputMaybe<QboAuthDataOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertQboAuthDataOneArgs = {
  object: QboAuthDataInsertInput;
  onConflict?: InputMaybe<QboAuthDataOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertQboCartItemTypeAccountsConfigArgs = {
  objects: Array<QboCartItemTypeAccountsConfigInsertInput>;
  onConflict?: InputMaybe<QboCartItemTypeAccountsConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertQboCartItemTypeAccountsConfigOneArgs = {
  object: QboCartItemTypeAccountsConfigInsertInput;
  onConflict?: InputMaybe<QboCartItemTypeAccountsConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertQboSyncInfoArgs = {
  objects: Array<QboSyncInfoInsertInput>;
  onConflict?: InputMaybe<QboSyncInfoOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertQboSyncInfoOneArgs = {
  object: QboSyncInfoInsertInput;
  onConflict?: InputMaybe<QboSyncInfoOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecentPricebookItemsArgs = {
  objects: Array<RecentPricebookItemsInsertInput>;
  onConflict?: InputMaybe<RecentPricebookItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecentPricebookItemsOneArgs = {
  object: RecentPricebookItemsInsertInput;
  onConflict?: InputMaybe<RecentPricebookItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecommendationAiGenerationInfoArgs = {
  objects: Array<RecommendationAiGenerationInfoInsertInput>;
  onConflict?: InputMaybe<RecommendationAiGenerationInfoOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecommendationAiGenerationInfoOneArgs = {
  object: RecommendationAiGenerationInfoInsertInput;
  onConflict?: InputMaybe<RecommendationAiGenerationInfoOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecommendationDismissalsArgs = {
  objects: Array<RecommendationDismissalsInsertInput>;
  onConflict?: InputMaybe<RecommendationDismissalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecommendationDismissalsOneArgs = {
  object: RecommendationDismissalsInsertInput;
  onConflict?: InputMaybe<RecommendationDismissalsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecommendationInteractionsArgs = {
  objects: Array<RecommendationInteractionsInsertInput>;
  onConflict?: InputMaybe<RecommendationInteractionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecommendationInteractionsOneArgs = {
  object: RecommendationInteractionsInsertInput;
  onConflict?: InputMaybe<RecommendationInteractionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecommendationsArgs = {
  objects: Array<RecommendationsInsertInput>;
  onConflict?: InputMaybe<RecommendationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecommendationsOneArgs = {
  object: RecommendationsInsertInput;
  onConflict?: InputMaybe<RecommendationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReminderAssignmentsArgs = {
  objects: Array<ReminderAssignmentsInsertInput>;
  onConflict?: InputMaybe<ReminderAssignmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReminderAssignmentsOneArgs = {
  object: ReminderAssignmentsInsertInput;
  onConflict?: InputMaybe<ReminderAssignmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReminderInternalNotificationsArgs = {
  objects: Array<ReminderInternalNotificationsInsertInput>;
  onConflict?: InputMaybe<ReminderInternalNotificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReminderInternalNotificationsOneArgs = {
  object: ReminderInternalNotificationsInsertInput;
  onConflict?: InputMaybe<ReminderInternalNotificationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRemindersArgs = {
  objects: Array<RemindersInsertInput>;
  onConflict?: InputMaybe<RemindersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRemindersOneArgs = {
  object: RemindersInsertInput;
  onConflict?: InputMaybe<RemindersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRepCompanyMetabaseConfigArgs = {
  objects: Array<RepCompanyMetabaseConfigInsertInput>;
  onConflict?: InputMaybe<RepCompanyMetabaseConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRepCompanyMetabaseConfigOneArgs = {
  object: RepCompanyMetabaseConfigInsertInput;
  onConflict?: InputMaybe<RepCompanyMetabaseConfigOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRepMetabaseCompanyReportsArgs = {
  objects: Array<RepMetabaseCompanyReportsInsertInput>;
  onConflict?: InputMaybe<RepMetabaseCompanyReportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRepMetabaseCompanyReportsOneArgs = {
  object: RepMetabaseCompanyReportsInsertInput;
  onConflict?: InputMaybe<RepMetabaseCompanyReportsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRepMetabasePulsesArgs = {
  objects: Array<RepMetabasePulsesInsertInput>;
  onConflict?: InputMaybe<RepMetabasePulsesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRepMetabasePulsesOneArgs = {
  object: RepMetabasePulsesInsertInput;
  onConflict?: InputMaybe<RepMetabasePulsesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRepMetabasePulsesV2Args = {
  objects: Array<RepMetabasePulsesV2InsertInput>;
  onConflict?: InputMaybe<RepMetabasePulsesV2OnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRepMetabasePulsesV2OneArgs = {
  object: RepMetabasePulsesV2InsertInput;
  onConflict?: InputMaybe<RepMetabasePulsesV2OnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRepMetabaseReportDefinitionsArgs = {
  objects: Array<RepMetabaseReportDefinitionsInsertInput>;
  onConflict?: InputMaybe<RepMetabaseReportDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRepMetabaseReportDefinitionsOneArgs = {
  object: RepMetabaseReportDefinitionsInsertInput;
  onConflict?: InputMaybe<RepMetabaseReportDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTagsArgs = {
  objects: Array<TagsInsertInput>;
  onConflict?: InputMaybe<TagsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTagsOneArgs = {
  object: TagsInsertInput;
  onConflict?: InputMaybe<TagsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTechnicianCapacitiesArgs = {
  objects: Array<TechnicianCapacitiesInsertInput>;
  onConflict?: InputMaybe<TechnicianCapacitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTechnicianCapacitiesOneArgs = {
  object: TechnicianCapacitiesInsertInput;
  onConflict?: InputMaybe<TechnicianCapacitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTechnicianCapacityBlocksArgs = {
  objects: Array<TechnicianCapacityBlocksInsertInput>;
  onConflict?: InputMaybe<TechnicianCapacityBlocksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTechnicianCapacityBlocksOneArgs = {
  object: TechnicianCapacityBlocksInsertInput;
  onConflict?: InputMaybe<TechnicianCapacityBlocksOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTilledRawEventsArgs = {
  objects: Array<TilledRawEventsInsertInput>;
  onConflict?: InputMaybe<TilledRawEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTilledRawEventsOneArgs = {
  object: TilledRawEventsInsertInput;
  onConflict?: InputMaybe<TilledRawEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTimesheetEntriesArgs = {
  objects: Array<TimesheetEntriesInsertInput>;
  onConflict?: InputMaybe<TimesheetEntriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTimesheetEntriesOneArgs = {
  object: TimesheetEntriesInsertInput;
  onConflict?: InputMaybe<TimesheetEntriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTimesheetEntryActivitiesArgs = {
  objects: Array<TimesheetEntryActivitiesInsertInput>;
  onConflict?: InputMaybe<TimesheetEntryActivitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTimesheetEntryActivitiesOneArgs = {
  object: TimesheetEntryActivitiesInsertInput;
  onConflict?: InputMaybe<TimesheetEntryActivitiesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTimesheetEntryLinkDataArgs = {
  objects: Array<TimesheetEntryLinkDataInsertInput>;
  onConflict?: InputMaybe<TimesheetEntryLinkDataOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTimesheetEntryLinkDataOneArgs = {
  object: TimesheetEntryLinkDataInsertInput;
  onConflict?: InputMaybe<TimesheetEntryLinkDataOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTuneUpVisitEntitlementsArgs = {
  objects: Array<TuneUpVisitEntitlementsInsertInput>;
  onConflict?: InputMaybe<TuneUpVisitEntitlementsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTuneUpVisitEntitlementsOneArgs = {
  object: TuneUpVisitEntitlementsInsertInput;
  onConflict?: InputMaybe<TuneUpVisitEntitlementsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserBusinessUnitsArgs = {
  objects: Array<UserBusinessUnitsInsertInput>;
  onConflict?: InputMaybe<UserBusinessUnitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserBusinessUnitsOneArgs = {
  object: UserBusinessUnitsInsertInput;
  onConflict?: InputMaybe<UserBusinessUnitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPhoneNumbersArgs = {
  objects: Array<UserPhoneNumbersInsertInput>;
  onConflict?: InputMaybe<UserPhoneNumbersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserPhoneNumbersOneArgs = {
  object: UserPhoneNumbersInsertInput;
  onConflict?: InputMaybe<UserPhoneNumbersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserSettingsArgs = {
  objects: Array<UserSettingsInsertInput>;
  onConflict?: InputMaybe<UserSettingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserSettingsOneArgs = {
  object: UserSettingsInsertInput;
  onConflict?: InputMaybe<UserSettingsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserWagesArgs = {
  objects: Array<UserWagesInsertInput>;
  onConflict?: InputMaybe<UserWagesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserWagesOneArgs = {
  object: UserWagesInsertInput;
  onConflict?: InputMaybe<UserWagesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<UsersInsertInput>;
  onConflict?: InputMaybe<UsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersOneArgs = {
  object: UsersInsertInput;
  onConflict?: InputMaybe<UsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWisetackLoanRecordsArgs = {
  objects: Array<WisetackLoanRecordsInsertInput>;
  onConflict?: InputMaybe<WisetackLoanRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWisetackLoanRecordsOneArgs = {
  object: WisetackLoanRecordsInsertInput;
  onConflict?: InputMaybe<WisetackLoanRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWisetackLoanStatusesArgs = {
  objects: Array<WisetackLoanStatusesInsertInput>;
  onConflict?: InputMaybe<WisetackLoanStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWisetackLoanStatusesOneArgs = {
  object: WisetackLoanStatusesInsertInput;
  onConflict?: InputMaybe<WisetackLoanStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWisetackPrequalRecordsArgs = {
  objects: Array<WisetackPrequalRecordsInsertInput>;
  onConflict?: InputMaybe<WisetackPrequalRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWisetackPrequalRecordsOneArgs = {
  object: WisetackPrequalRecordsInsertInput;
  onConflict?: InputMaybe<WisetackPrequalRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWisetackWebhookEventsArgs = {
  objects: Array<WisetackWebhookEventsInsertInput>;
  onConflict?: InputMaybe<WisetackWebhookEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertWisetackWebhookEventsOneArgs = {
  object: WisetackWebhookEventsInsertInput;
  onConflict?: InputMaybe<WisetackWebhookEventsOnConflict>;
};


/** mutation root */
export type Mutation_RootUpdateAccCartItemTypeAccountsConfigArgs = {
  _set?: InputMaybe<AccCartItemTypeAccountsConfigSetInput>;
  where: AccCartItemTypeAccountsConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccCartItemTypeAccountsConfigByPkArgs = {
  _set?: InputMaybe<AccCartItemTypeAccountsConfigSetInput>;
  pkColumns: AccCartItemTypeAccountsConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccCartItemTypeAccountsConfigManyArgs = {
  updates: Array<AccCartItemTypeAccountsConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccCompanyConfigArgs = {
  _set?: InputMaybe<AccCompanyConfigSetInput>;
  where: AccCompanyConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccCompanyConfigByPkArgs = {
  _set?: InputMaybe<AccCompanyConfigSetInput>;
  pkColumns: AccCompanyConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccCompanyConfigManyArgs = {
  updates: Array<AccCompanyConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccPayoutAccountsConfigArgs = {
  _set?: InputMaybe<AccPayoutAccountsConfigSetInput>;
  where: AccPayoutAccountsConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccPayoutAccountsConfigByPkArgs = {
  _set?: InputMaybe<AccPayoutAccountsConfigSetInput>;
  pkColumns: AccPayoutAccountsConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccPayoutAccountsConfigManyArgs = {
  updates: Array<AccPayoutAccountsConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccQbdConductorConfigArgs = {
  _set?: InputMaybe<AccQbdConductorConfigSetInput>;
  where: AccQbdConductorConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccQbdConductorConfigByPkArgs = {
  _set?: InputMaybe<AccQbdConductorConfigSetInput>;
  pkColumns: AccQbdConductorConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccQbdConductorConfigManyArgs = {
  updates: Array<AccQbdConductorConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccQbdConductorUptimeArgs = {
  _inc?: InputMaybe<AccQbdConductorUptimeIncInput>;
  _set?: InputMaybe<AccQbdConductorUptimeSetInput>;
  where: AccQbdConductorUptimeBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccQbdConductorUptimeByPkArgs = {
  _inc?: InputMaybe<AccQbdConductorUptimeIncInput>;
  _set?: InputMaybe<AccQbdConductorUptimeSetInput>;
  pkColumns: AccQbdConductorUptimePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccQbdConductorUptimeManyArgs = {
  updates: Array<AccQbdConductorUptimeUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccSyncInfoArgs = {
  _set?: InputMaybe<AccSyncInfoSetInput>;
  where: AccSyncInfoBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccSyncInfoByPkArgs = {
  _set?: InputMaybe<AccSyncInfoSetInput>;
  pkColumns: AccSyncInfoPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccSyncInfoManyArgs = {
  updates: Array<AccSyncInfoUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccSyncQueueItemsArgs = {
  _set?: InputMaybe<AccSyncQueueItemsSetInput>;
  where: AccSyncQueueItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccSyncQueueItemsByPkArgs = {
  _set?: InputMaybe<AccSyncQueueItemsSetInput>;
  pkColumns: AccSyncQueueItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccSyncQueueItemsManyArgs = {
  updates: Array<AccSyncQueueItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccountContactsArgs = {
  _set?: InputMaybe<AccountContactsSetInput>;
  where: AccountContactsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccountContactsByPkArgs = {
  _set?: InputMaybe<AccountContactsSetInput>;
  pkColumns: AccountContactsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccountContactsManyArgs = {
  updates: Array<AccountContactsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccountLocationsArgs = {
  _set?: InputMaybe<AccountLocationsSetInput>;
  where: AccountLocationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccountLocationsByPkArgs = {
  _set?: InputMaybe<AccountLocationsSetInput>;
  pkColumns: AccountLocationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccountLocationsManyArgs = {
  updates: Array<AccountLocationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccountRemindersArgs = {
  _set?: InputMaybe<AccountRemindersSetInput>;
  where: AccountRemindersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccountRemindersByPkArgs = {
  _set?: InputMaybe<AccountRemindersSetInput>;
  pkColumns: AccountRemindersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccountRemindersManyArgs = {
  updates: Array<AccountRemindersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccountStatementEventsArgs = {
  _append?: InputMaybe<AccountStatementEventsAppendInput>;
  _deleteAtPath?: InputMaybe<AccountStatementEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<AccountStatementEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<AccountStatementEventsDeleteKeyInput>;
  _inc?: InputMaybe<AccountStatementEventsIncInput>;
  _prepend?: InputMaybe<AccountStatementEventsPrependInput>;
  _set?: InputMaybe<AccountStatementEventsSetInput>;
  where: AccountStatementEventsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccountStatementEventsByPkArgs = {
  _append?: InputMaybe<AccountStatementEventsAppendInput>;
  _deleteAtPath?: InputMaybe<AccountStatementEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<AccountStatementEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<AccountStatementEventsDeleteKeyInput>;
  _inc?: InputMaybe<AccountStatementEventsIncInput>;
  _prepend?: InputMaybe<AccountStatementEventsPrependInput>;
  _set?: InputMaybe<AccountStatementEventsSetInput>;
  pkColumns: AccountStatementEventsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccountStatementEventsManyArgs = {
  updates: Array<AccountStatementEventsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccountTagsArgs = {
  _set?: InputMaybe<AccountTagsSetInput>;
  where: AccountTagsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccountTagsByPkArgs = {
  _set?: InputMaybe<AccountTagsSetInput>;
  pkColumns: AccountTagsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccountTagsManyArgs = {
  updates: Array<AccountTagsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccountTypesArgs = {
  _set?: InputMaybe<AccountTypesSetInput>;
  where: AccountTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccountTypesByPkArgs = {
  _set?: InputMaybe<AccountTypesSetInput>;
  pkColumns: AccountTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccountTypesManyArgs = {
  updates: Array<AccountTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccountsArgs = {
  _set?: InputMaybe<AccountsSetInput>;
  where: AccountsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccountsByPkArgs = {
  _set?: InputMaybe<AccountsSetInput>;
  pkColumns: AccountsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccountsManyArgs = {
  updates: Array<AccountsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAccountsViewedByUserArgs = {
  _set?: InputMaybe<AccountsViewedByUserSetInput>;
  where: AccountsViewedByUserBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAccountsViewedByUserByPkArgs = {
  _set?: InputMaybe<AccountsViewedByUserSetInput>;
  pkColumns: AccountsViewedByUserPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAccountsViewedByUserManyArgs = {
  updates: Array<AccountsViewedByUserUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateActivityItemsArgs = {
  _set?: InputMaybe<ActivityItemsSetInput>;
  where: ActivityItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateActivityItemsByPkArgs = {
  _set?: InputMaybe<ActivityItemsSetInput>;
  pkColumns: ActivityItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateActivityItemsManyArgs = {
  updates: Array<ActivityItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAddressesArgs = {
  _set?: InputMaybe<AddressesSetInput>;
  where: AddressesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAddressesByPkArgs = {
  _set?: InputMaybe<AddressesSetInput>;
  pkColumns: AddressesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAddressesManyArgs = {
  updates: Array<AddressesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAppointmentChecklistAssociationRulesArgs = {
  _set?: InputMaybe<AppointmentChecklistAssociationRulesSetInput>;
  where: AppointmentChecklistAssociationRulesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAppointmentChecklistAssociationRulesByPkArgs = {
  _set?: InputMaybe<AppointmentChecklistAssociationRulesSetInput>;
  pkColumns: AppointmentChecklistAssociationRulesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAppointmentChecklistAssociationRulesManyArgs = {
  updates: Array<AppointmentChecklistAssociationRulesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAppointmentChecklistInstancesArgs = {
  _append?: InputMaybe<AppointmentChecklistInstancesAppendInput>;
  _deleteAtPath?: InputMaybe<AppointmentChecklistInstancesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<AppointmentChecklistInstancesDeleteElemInput>;
  _deleteKey?: InputMaybe<AppointmentChecklistInstancesDeleteKeyInput>;
  _inc?: InputMaybe<AppointmentChecklistInstancesIncInput>;
  _prepend?: InputMaybe<AppointmentChecklistInstancesPrependInput>;
  _set?: InputMaybe<AppointmentChecklistInstancesSetInput>;
  where: AppointmentChecklistInstancesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAppointmentChecklistInstancesByPkArgs = {
  _append?: InputMaybe<AppointmentChecklistInstancesAppendInput>;
  _deleteAtPath?: InputMaybe<AppointmentChecklistInstancesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<AppointmentChecklistInstancesDeleteElemInput>;
  _deleteKey?: InputMaybe<AppointmentChecklistInstancesDeleteKeyInput>;
  _inc?: InputMaybe<AppointmentChecklistInstancesIncInput>;
  _prepend?: InputMaybe<AppointmentChecklistInstancesPrependInput>;
  _set?: InputMaybe<AppointmentChecklistInstancesSetInput>;
  pkColumns: AppointmentChecklistInstancesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAppointmentChecklistInstancesManyArgs = {
  updates: Array<AppointmentChecklistInstancesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAppointmentChecklistsArgs = {
  _append?: InputMaybe<AppointmentChecklistsAppendInput>;
  _deleteAtPath?: InputMaybe<AppointmentChecklistsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<AppointmentChecklistsDeleteElemInput>;
  _deleteKey?: InputMaybe<AppointmentChecklistsDeleteKeyInput>;
  _prepend?: InputMaybe<AppointmentChecklistsPrependInput>;
  _set?: InputMaybe<AppointmentChecklistsSetInput>;
  where: AppointmentChecklistsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAppointmentChecklistsByPkArgs = {
  _append?: InputMaybe<AppointmentChecklistsAppendInput>;
  _deleteAtPath?: InputMaybe<AppointmentChecklistsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<AppointmentChecklistsDeleteElemInput>;
  _deleteKey?: InputMaybe<AppointmentChecklistsDeleteKeyInput>;
  _prepend?: InputMaybe<AppointmentChecklistsPrependInput>;
  _set?: InputMaybe<AppointmentChecklistsSetInput>;
  pkColumns: AppointmentChecklistsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAppointmentChecklistsManyArgs = {
  updates: Array<AppointmentChecklistsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAssistantIntegratedPhonesArgs = {
  _set?: InputMaybe<AssistantIntegratedPhonesSetInput>;
  where: AssistantIntegratedPhonesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAssistantIntegratedPhonesByPkArgs = {
  _set?: InputMaybe<AssistantIntegratedPhonesSetInput>;
  pkColumns: AssistantIntegratedPhonesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAssistantIntegratedPhonesManyArgs = {
  updates: Array<AssistantIntegratedPhonesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAssistantPhoneSettingsArgs = {
  _set?: InputMaybe<AssistantPhoneSettingsSetInput>;
  where: AssistantPhoneSettingsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAssistantPhoneSettingsByPkArgs = {
  _set?: InputMaybe<AssistantPhoneSettingsSetInput>;
  pkColumns: AssistantPhoneSettingsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAssistantPhoneSettingsManyArgs = {
  updates: Array<AssistantPhoneSettingsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateAssistantsArgs = {
  _set?: InputMaybe<AssistantsSetInput>;
  where: AssistantsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAssistantsByPkArgs = {
  _set?: InputMaybe<AssistantsSetInput>;
  pkColumns: AssistantsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAssistantsManyArgs = {
  updates: Array<AssistantsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBillingProfileHiddenPaymentMethodsArgs = {
  _set?: InputMaybe<BillingProfileHiddenPaymentMethodsSetInput>;
  where: BillingProfileHiddenPaymentMethodsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBillingProfileHiddenPaymentMethodsByPkArgs = {
  _set?: InputMaybe<BillingProfileHiddenPaymentMethodsSetInput>;
  pkColumns: BillingProfileHiddenPaymentMethodsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBillingProfileHiddenPaymentMethodsManyArgs = {
  updates: Array<BillingProfileHiddenPaymentMethodsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBillingProfilesArgs = {
  _inc?: InputMaybe<BillingProfilesIncInput>;
  _set?: InputMaybe<BillingProfilesSetInput>;
  where: BillingProfilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBillingProfilesByPkArgs = {
  _inc?: InputMaybe<BillingProfilesIncInput>;
  _set?: InputMaybe<BillingProfilesSetInput>;
  pkColumns: BillingProfilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBillingProfilesManyArgs = {
  updates: Array<BillingProfilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBusinessEventsArgs = {
  _append?: InputMaybe<BusinessEventsAppendInput>;
  _deleteAtPath?: InputMaybe<BusinessEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BusinessEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<BusinessEventsDeleteKeyInput>;
  _prepend?: InputMaybe<BusinessEventsPrependInput>;
  _set?: InputMaybe<BusinessEventsSetInput>;
  where: BusinessEventsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBusinessEventsByPkArgs = {
  _append?: InputMaybe<BusinessEventsAppendInput>;
  _deleteAtPath?: InputMaybe<BusinessEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BusinessEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<BusinessEventsDeleteKeyInput>;
  _prepend?: InputMaybe<BusinessEventsPrependInput>;
  _set?: InputMaybe<BusinessEventsSetInput>;
  pkColumns: BusinessEventsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBusinessEventsManyArgs = {
  updates: Array<BusinessEventsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBusinessUnitTargetMetricsArgs = {
  _inc?: InputMaybe<BusinessUnitTargetMetricsIncInput>;
  _set?: InputMaybe<BusinessUnitTargetMetricsSetInput>;
  where: BusinessUnitTargetMetricsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBusinessUnitTargetMetricsByPkArgs = {
  _inc?: InputMaybe<BusinessUnitTargetMetricsIncInput>;
  _set?: InputMaybe<BusinessUnitTargetMetricsSetInput>;
  pkColumns: BusinessUnitTargetMetricsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBusinessUnitTargetMetricsManyArgs = {
  updates: Array<BusinessUnitTargetMetricsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBusinessUnitsArgs = {
  _set?: InputMaybe<BusinessUnitsSetInput>;
  where: BusinessUnitsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBusinessUnitsByPkArgs = {
  _set?: InputMaybe<BusinessUnitsSetInput>;
  pkColumns: BusinessUnitsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBusinessUnitsManyArgs = {
  updates: Array<BusinessUnitsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCanonicalLeadSourcesArgs = {
  _set?: InputMaybe<CanonicalLeadSourcesSetInput>;
  where: CanonicalLeadSourcesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCanonicalLeadSourcesByPkArgs = {
  _set?: InputMaybe<CanonicalLeadSourcesSetInput>;
  pkColumns: CanonicalLeadSourcesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCanonicalLeadSourcesManyArgs = {
  updates: Array<CanonicalLeadSourcesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCartItemJobCostLinksArgs = {
  _set?: InputMaybe<CartItemJobCostLinksSetInput>;
  where: CartItemJobCostLinksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCartItemJobCostLinksByPkArgs = {
  _set?: InputMaybe<CartItemJobCostLinksSetInput>;
  pkColumns: CartItemJobCostLinksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCartItemJobCostLinksManyArgs = {
  updates: Array<CartItemJobCostLinksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCartItemsArgs = {
  _inc?: InputMaybe<CartItemsIncInput>;
  _set?: InputMaybe<CartItemsSetInput>;
  where: CartItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCartItemsByPkArgs = {
  _inc?: InputMaybe<CartItemsIncInput>;
  _set?: InputMaybe<CartItemsSetInput>;
  pkColumns: CartItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCartItemsManyArgs = {
  updates: Array<CartItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChecklistItemsArgs = {
  _set?: InputMaybe<ChecklistItemsSetInput>;
  where: ChecklistItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChecklistItemsByPkArgs = {
  _set?: InputMaybe<ChecklistItemsSetInput>;
  pkColumns: ChecklistItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChecklistItemsManyArgs = {
  updates: Array<ChecklistItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompaniesArgs = {
  _set?: InputMaybe<CompaniesSetInput>;
  where: CompaniesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompaniesByPkArgs = {
  _set?: InputMaybe<CompaniesSetInput>;
  pkColumns: CompaniesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompaniesManyArgs = {
  updates: Array<CompaniesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompanyAppointmentArrivalWindowsArgs = {
  _set?: InputMaybe<CompanyAppointmentArrivalWindowsSetInput>;
  where: CompanyAppointmentArrivalWindowsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompanyAppointmentArrivalWindowsByPkArgs = {
  _set?: InputMaybe<CompanyAppointmentArrivalWindowsSetInput>;
  pkColumns: CompanyAppointmentArrivalWindowsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompanyAppointmentArrivalWindowsManyArgs = {
  updates: Array<CompanyAppointmentArrivalWindowsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompanyCommissionConfigArgs = {
  _inc?: InputMaybe<CompanyCommissionConfigIncInput>;
  _set?: InputMaybe<CompanyCommissionConfigSetInput>;
  where: CompanyCommissionConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompanyCommissionConfigByPkArgs = {
  _inc?: InputMaybe<CompanyCommissionConfigIncInput>;
  _set?: InputMaybe<CompanyCommissionConfigSetInput>;
  pkColumns: CompanyCommissionConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompanyCommissionConfigManyArgs = {
  updates: Array<CompanyCommissionConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompanyConfigArgs = {
  _append?: InputMaybe<CompanyConfigAppendInput>;
  _deleteAtPath?: InputMaybe<CompanyConfigDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CompanyConfigDeleteElemInput>;
  _deleteKey?: InputMaybe<CompanyConfigDeleteKeyInput>;
  _inc?: InputMaybe<CompanyConfigIncInput>;
  _prepend?: InputMaybe<CompanyConfigPrependInput>;
  _set?: InputMaybe<CompanyConfigSetInput>;
  where: CompanyConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompanyConfigByPkArgs = {
  _append?: InputMaybe<CompanyConfigAppendInput>;
  _deleteAtPath?: InputMaybe<CompanyConfigDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CompanyConfigDeleteElemInput>;
  _deleteKey?: InputMaybe<CompanyConfigDeleteKeyInput>;
  _inc?: InputMaybe<CompanyConfigIncInput>;
  _prepend?: InputMaybe<CompanyConfigPrependInput>;
  _set?: InputMaybe<CompanyConfigSetInput>;
  pkColumns: CompanyConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompanyConfigManyArgs = {
  updates: Array<CompanyConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompanyDripMarketingConfigArgs = {
  _inc?: InputMaybe<CompanyDripMarketingConfigIncInput>;
  _set?: InputMaybe<CompanyDripMarketingConfigSetInput>;
  where: CompanyDripMarketingConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompanyDripMarketingConfigByPkArgs = {
  _inc?: InputMaybe<CompanyDripMarketingConfigIncInput>;
  _set?: InputMaybe<CompanyDripMarketingConfigSetInput>;
  pkColumns: CompanyDripMarketingConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompanyDripMarketingConfigManyArgs = {
  updates: Array<CompanyDripMarketingConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompanyLeadSourceLinksArgs = {
  _set?: InputMaybe<CompanyLeadSourceLinksSetInput>;
  where: CompanyLeadSourceLinksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompanyLeadSourceLinksByPkArgs = {
  _set?: InputMaybe<CompanyLeadSourceLinksSetInput>;
  pkColumns: CompanyLeadSourceLinksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompanyLeadSourceLinksManyArgs = {
  updates: Array<CompanyLeadSourceLinksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompanyLeadSourcesArgs = {
  _set?: InputMaybe<CompanyLeadSourcesSetInput>;
  where: CompanyLeadSourcesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompanyLeadSourcesByPkArgs = {
  _set?: InputMaybe<CompanyLeadSourcesSetInput>;
  pkColumns: CompanyLeadSourcesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompanyLeadSourcesManyArgs = {
  updates: Array<CompanyLeadSourcesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompanyNotificationSettingsArgs = {
  _inc?: InputMaybe<CompanyNotificationSettingsIncInput>;
  _set?: InputMaybe<CompanyNotificationSettingsSetInput>;
  where: CompanyNotificationSettingsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompanyNotificationSettingsByPkArgs = {
  _inc?: InputMaybe<CompanyNotificationSettingsIncInput>;
  _set?: InputMaybe<CompanyNotificationSettingsSetInput>;
  pkColumns: CompanyNotificationSettingsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompanyNotificationSettingsManyArgs = {
  updates: Array<CompanyNotificationSettingsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompanyPricingTierConfigArgs = {
  _set?: InputMaybe<CompanyPricingTierConfigSetInput>;
  where: CompanyPricingTierConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompanyPricingTierConfigByPkArgs = {
  _set?: InputMaybe<CompanyPricingTierConfigSetInput>;
  pkColumns: CompanyPricingTierConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompanyPricingTierConfigManyArgs = {
  updates: Array<CompanyPricingTierConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompanyRolesArgs = {
  _set?: InputMaybe<CompanyRolesSetInput>;
  where: CompanyRolesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompanyRolesByPkArgs = {
  _set?: InputMaybe<CompanyRolesSetInput>;
  pkColumns: CompanyRolesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompanyRolesManyArgs = {
  updates: Array<CompanyRolesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompanyTaxConfigurationsArgs = {
  _set?: InputMaybe<CompanyTaxConfigurationsSetInput>;
  where: CompanyTaxConfigurationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompanyTaxConfigurationsByPkArgs = {
  _set?: InputMaybe<CompanyTaxConfigurationsSetInput>;
  pkColumns: CompanyTaxConfigurationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompanyTaxConfigurationsManyArgs = {
  updates: Array<CompanyTaxConfigurationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompanyUsersArgs = {
  _set?: InputMaybe<CompanyUsersSetInput>;
  where: CompanyUsersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompanyUsersByPkArgs = {
  _set?: InputMaybe<CompanyUsersSetInput>;
  pkColumns: CompanyUsersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompanyUsersManyArgs = {
  updates: Array<CompanyUsersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompanyWorkingDisplayHoursArgs = {
  _inc?: InputMaybe<CompanyWorkingDisplayHoursIncInput>;
  _set?: InputMaybe<CompanyWorkingDisplayHoursSetInput>;
  where: CompanyWorkingDisplayHoursBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompanyWorkingDisplayHoursByPkArgs = {
  _inc?: InputMaybe<CompanyWorkingDisplayHoursIncInput>;
  _set?: InputMaybe<CompanyWorkingDisplayHoursSetInput>;
  pkColumns: CompanyWorkingDisplayHoursPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompanyWorkingDisplayHoursManyArgs = {
  updates: Array<CompanyWorkingDisplayHoursUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateContactsArgs = {
  _set?: InputMaybe<ContactsSetInput>;
  where: ContactsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateContactsByPkArgs = {
  _set?: InputMaybe<ContactsSetInput>;
  pkColumns: ContactsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateContactsManyArgs = {
  updates: Array<ContactsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCurrentCompanyTaxConfigurationsViewArgs = {
  _set?: InputMaybe<CurrentCompanyTaxConfigurationsViewSetInput>;
  where: CurrentCompanyTaxConfigurationsViewBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCurrentCompanyTaxConfigurationsViewManyArgs = {
  updates: Array<CurrentCompanyTaxConfigurationsViewUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCurrentUserBusinessUnitsViewArgs = {
  _set?: InputMaybe<CurrentUserBusinessUnitsViewSetInput>;
  where: CurrentUserBusinessUnitsViewBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCurrentUserBusinessUnitsViewManyArgs = {
  updates: Array<CurrentUserBusinessUnitsViewUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCustomerCommunicationTemplatesArgs = {
  _set?: InputMaybe<CustomerCommunicationTemplatesSetInput>;
  where: CustomerCommunicationTemplatesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCustomerCommunicationTemplatesByPkArgs = {
  _set?: InputMaybe<CustomerCommunicationTemplatesSetInput>;
  pkColumns: CustomerCommunicationTemplatesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCustomerCommunicationTemplatesManyArgs = {
  updates: Array<CustomerCommunicationTemplatesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDiscountEntitlementsArgs = {
  _inc?: InputMaybe<DiscountEntitlementsIncInput>;
  _set?: InputMaybe<DiscountEntitlementsSetInput>;
  where: DiscountEntitlementsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDiscountEntitlementsByPkArgs = {
  _inc?: InputMaybe<DiscountEntitlementsIncInput>;
  _set?: InputMaybe<DiscountEntitlementsSetInput>;
  pkColumns: DiscountEntitlementsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDiscountEntitlementsManyArgs = {
  updates: Array<DiscountEntitlementsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDisplayIdCountersArgs = {
  _inc?: InputMaybe<DisplayIdCountersIncInput>;
  _set?: InputMaybe<DisplayIdCountersSetInput>;
  where: DisplayIdCountersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDisplayIdCountersByPkArgs = {
  _inc?: InputMaybe<DisplayIdCountersIncInput>;
  _set?: InputMaybe<DisplayIdCountersSetInput>;
  pkColumns: DisplayIdCountersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDisplayIdCountersManyArgs = {
  updates: Array<DisplayIdCountersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDripMarketingEmailsArgs = {
  _set?: InputMaybe<DripMarketingEmailsSetInput>;
  where: DripMarketingEmailsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDripMarketingEmailsByPkArgs = {
  _set?: InputMaybe<DripMarketingEmailsSetInput>;
  pkColumns: DripMarketingEmailsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDripMarketingEmailsManyArgs = {
  updates: Array<DripMarketingEmailsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEmailAddressesArgs = {
  _set?: InputMaybe<EmailAddressesSetInput>;
  where: EmailAddressesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEmailAddressesByPkArgs = {
  _set?: InputMaybe<EmailAddressesSetInput>;
  pkColumns: EmailAddressesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEmailAddressesManyArgs = {
  updates: Array<EmailAddressesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEntitlementsArgs = {
  _set?: InputMaybe<EntitlementsSetInput>;
  where: EntitlementsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEntitlementsByPkArgs = {
  _set?: InputMaybe<EntitlementsSetInput>;
  pkColumns: EntitlementsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEntitlementsManyArgs = {
  updates: Array<EntitlementsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEquipmentTypeLinksArgs = {
  _set?: InputMaybe<EquipmentTypeLinksSetInput>;
  where: EquipmentTypeLinksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEquipmentTypeLinksByPkArgs = {
  _set?: InputMaybe<EquipmentTypeLinksSetInput>;
  pkColumns: EquipmentTypeLinksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEquipmentTypeLinksManyArgs = {
  updates: Array<EquipmentTypeLinksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEquipmentTypesArgs = {
  _set?: InputMaybe<EquipmentTypesSetInput>;
  where: EquipmentTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEquipmentTypesByPkArgs = {
  _set?: InputMaybe<EquipmentTypesSetInput>;
  pkColumns: EquipmentTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEquipmentTypesManyArgs = {
  updates: Array<EquipmentTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEstimateInvoicesArgs = {
  _set?: InputMaybe<EstimateInvoicesSetInput>;
  where: EstimateInvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEstimateInvoicesByPkArgs = {
  _set?: InputMaybe<EstimateInvoicesSetInput>;
  pkColumns: EstimateInvoicesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEstimateInvoicesManyArgs = {
  updates: Array<EstimateInvoicesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEstimateOptionCartItemsArgs = {
  _inc?: InputMaybe<EstimateOptionCartItemsIncInput>;
  _set?: InputMaybe<EstimateOptionCartItemsSetInput>;
  where: EstimateOptionCartItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEstimateOptionCartItemsByPkArgs = {
  _inc?: InputMaybe<EstimateOptionCartItemsIncInput>;
  _set?: InputMaybe<EstimateOptionCartItemsSetInput>;
  pkColumns: EstimateOptionCartItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEstimateOptionCartItemsManyArgs = {
  updates: Array<EstimateOptionCartItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEstimateOptionDiscountsArgs = {
  _inc?: InputMaybe<EstimateOptionDiscountsIncInput>;
  _set?: InputMaybe<EstimateOptionDiscountsSetInput>;
  where: EstimateOptionDiscountsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEstimateOptionDiscountsByPkArgs = {
  _inc?: InputMaybe<EstimateOptionDiscountsIncInput>;
  _set?: InputMaybe<EstimateOptionDiscountsSetInput>;
  pkColumns: EstimateOptionDiscountsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEstimateOptionDiscountsManyArgs = {
  updates: Array<EstimateOptionDiscountsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEstimateOptionsArgs = {
  _inc?: InputMaybe<EstimateOptionsIncInput>;
  _set?: InputMaybe<EstimateOptionsSetInput>;
  where: EstimateOptionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEstimateOptionsByPkArgs = {
  _inc?: InputMaybe<EstimateOptionsIncInput>;
  _set?: InputMaybe<EstimateOptionsSetInput>;
  pkColumns: EstimateOptionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEstimateOptionsManyArgs = {
  updates: Array<EstimateOptionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEstimatePhotosArgs = {
  _set?: InputMaybe<EstimatePhotosSetInput>;
  where: EstimatePhotosBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEstimatePhotosByPkArgs = {
  _set?: InputMaybe<EstimatePhotosSetInput>;
  pkColumns: EstimatePhotosPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEstimatePhotosManyArgs = {
  updates: Array<EstimatePhotosUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEstimateTemplatesArgs = {
  _set?: InputMaybe<EstimateTemplatesSetInput>;
  where: EstimateTemplatesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEstimateTemplatesByPkArgs = {
  _set?: InputMaybe<EstimateTemplatesSetInput>;
  pkColumns: EstimateTemplatesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEstimateTemplatesManyArgs = {
  updates: Array<EstimateTemplatesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEstimatesArgs = {
  _inc?: InputMaybe<EstimatesIncInput>;
  _set?: InputMaybe<EstimatesSetInput>;
  where: EstimatesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEstimatesByPkArgs = {
  _inc?: InputMaybe<EstimatesIncInput>;
  _set?: InputMaybe<EstimatesSetInput>;
  pkColumns: EstimatesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEstimatesManyArgs = {
  updates: Array<EstimatesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEstimatesQueryableArgs = {
  _inc?: InputMaybe<EstimatesQueryableIncInput>;
  _set?: InputMaybe<EstimatesQueryableSetInput>;
  where: EstimatesQueryableBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEstimatesQueryableByPkArgs = {
  _inc?: InputMaybe<EstimatesQueryableIncInput>;
  _set?: InputMaybe<EstimatesQueryableSetInput>;
  pkColumns: EstimatesQueryablePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEstimatesQueryableManyArgs = {
  updates: Array<EstimatesQueryableUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEventStoreArgs = {
  _append?: InputMaybe<EventStoreAppendInput>;
  _deleteAtPath?: InputMaybe<EventStoreDeleteAtPathInput>;
  _deleteElem?: InputMaybe<EventStoreDeleteElemInput>;
  _deleteKey?: InputMaybe<EventStoreDeleteKeyInput>;
  _inc?: InputMaybe<EventStoreIncInput>;
  _prepend?: InputMaybe<EventStorePrependInput>;
  _set?: InputMaybe<EventStoreSetInput>;
  where: EventStoreBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEventStoreByPkArgs = {
  _append?: InputMaybe<EventStoreAppendInput>;
  _deleteAtPath?: InputMaybe<EventStoreDeleteAtPathInput>;
  _deleteElem?: InputMaybe<EventStoreDeleteElemInput>;
  _deleteKey?: InputMaybe<EventStoreDeleteKeyInput>;
  _inc?: InputMaybe<EventStoreIncInput>;
  _prepend?: InputMaybe<EventStorePrependInput>;
  _set?: InputMaybe<EventStoreSetInput>;
  pkColumns: EventStorePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEventStoreManyArgs = {
  updates: Array<EventStoreUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateFavoritePricebookItemsArgs = {
  _set?: InputMaybe<FavoritePricebookItemsSetInput>;
  where: FavoritePricebookItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateFavoritePricebookItemsByPkArgs = {
  _set?: InputMaybe<FavoritePricebookItemsSetInput>;
  pkColumns: FavoritePricebookItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateFavoritePricebookItemsManyArgs = {
  updates: Array<FavoritePricebookItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateFileLinksArgs = {
  _set?: InputMaybe<FileLinksSetInput>;
  where: FileLinksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateFileLinksByPkArgs = {
  _set?: InputMaybe<FileLinksSetInput>;
  pkColumns: FileLinksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateFileLinksManyArgs = {
  updates: Array<FileLinksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateFilesArgs = {
  _append?: InputMaybe<FilesAppendInput>;
  _deleteAtPath?: InputMaybe<FilesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<FilesDeleteElemInput>;
  _deleteKey?: InputMaybe<FilesDeleteKeyInput>;
  _inc?: InputMaybe<FilesIncInput>;
  _prepend?: InputMaybe<FilesPrependInput>;
  _set?: InputMaybe<FilesSetInput>;
  where: FilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateFilesByPkArgs = {
  _append?: InputMaybe<FilesAppendInput>;
  _deleteAtPath?: InputMaybe<FilesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<FilesDeleteElemInput>;
  _deleteKey?: InputMaybe<FilesDeleteKeyInput>;
  _inc?: InputMaybe<FilesIncInput>;
  _prepend?: InputMaybe<FilesPrependInput>;
  _set?: InputMaybe<FilesSetInput>;
  pkColumns: FilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateFilesManyArgs = {
  updates: Array<FilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInstalledEquipmentArgs = {
  _inc?: InputMaybe<InstalledEquipmentIncInput>;
  _set?: InputMaybe<InstalledEquipmentSetInput>;
  where: InstalledEquipmentBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInstalledEquipmentByPkArgs = {
  _inc?: InputMaybe<InstalledEquipmentIncInput>;
  _set?: InputMaybe<InstalledEquipmentSetInput>;
  pkColumns: InstalledEquipmentPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInstalledEquipmentManyArgs = {
  updates: Array<InstalledEquipmentUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInstalledHvacSystemsArgs = {
  _append?: InputMaybe<InstalledHvacSystemsAppendInput>;
  _deleteAtPath?: InputMaybe<InstalledHvacSystemsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<InstalledHvacSystemsDeleteElemInput>;
  _deleteKey?: InputMaybe<InstalledHvacSystemsDeleteKeyInput>;
  _prepend?: InputMaybe<InstalledHvacSystemsPrependInput>;
  _set?: InputMaybe<InstalledHvacSystemsSetInput>;
  where: InstalledHvacSystemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInstalledHvacSystemsByPkArgs = {
  _append?: InputMaybe<InstalledHvacSystemsAppendInput>;
  _deleteAtPath?: InputMaybe<InstalledHvacSystemsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<InstalledHvacSystemsDeleteElemInput>;
  _deleteKey?: InputMaybe<InstalledHvacSystemsDeleteKeyInput>;
  _prepend?: InputMaybe<InstalledHvacSystemsPrependInput>;
  _set?: InputMaybe<InstalledHvacSystemsSetInput>;
  pkColumns: InstalledHvacSystemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInstalledHvacSystemsManyArgs = {
  updates: Array<InstalledHvacSystemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInstantBookingWeeklyScheduleEntriesArgs = {
  _set?: InputMaybe<InstantBookingWeeklyScheduleEntriesSetInput>;
  where: InstantBookingWeeklyScheduleEntriesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInstantBookingWeeklyScheduleEntriesByPkArgs = {
  _set?: InputMaybe<InstantBookingWeeklyScheduleEntriesSetInput>;
  pkColumns: InstantBookingWeeklyScheduleEntriesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInstantBookingWeeklyScheduleEntriesManyArgs = {
  updates: Array<InstantBookingWeeklyScheduleEntriesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInstantBookingWeeklyScheduleEntryBookableArrivalWindowsArgs = {
  _set?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSetInput>;
  where: InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInstantBookingWeeklyScheduleEntryBookableArrivalWindowsByPkArgs = {
  _set?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSetInput>;
  pkColumns: InstantBookingWeeklyScheduleEntryBookableArrivalWindowsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInstantBookingWeeklyScheduleEntryBookableArrivalWindowsManyArgs = {
  updates: Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedChannelsArgs = {
  _set?: InputMaybe<IntegratedChannelsSetInput>;
  where: IntegratedChannelsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedChannelsByPkArgs = {
  _set?: InputMaybe<IntegratedChannelsSetInput>;
  pkColumns: IntegratedChannelsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedChannelsManyArgs = {
  updates: Array<IntegratedChannelsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedMessageStatusesArgs = {
  _set?: InputMaybe<IntegratedMessageStatusesSetInput>;
  where: IntegratedMessageStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedMessageStatusesByPkArgs = {
  _set?: InputMaybe<IntegratedMessageStatusesSetInput>;
  pkColumns: IntegratedMessageStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedMessageStatusesManyArgs = {
  updates: Array<IntegratedMessageStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedMessageTwilioRawWebhookEventsArgs = {
  _append?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsAppendInput>;
  _deleteAtPath?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsDeleteKeyInput>;
  _prepend?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsPrependInput>;
  _set?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsSetInput>;
  where: IntegratedMessageTwilioRawWebhookEventsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedMessageTwilioRawWebhookEventsByPkArgs = {
  _append?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsAppendInput>;
  _deleteAtPath?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsDeleteKeyInput>;
  _prepend?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsPrependInput>;
  _set?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsSetInput>;
  pkColumns: IntegratedMessageTwilioRawWebhookEventsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedMessageTwilioRawWebhookEventsManyArgs = {
  updates: Array<IntegratedMessageTwilioRawWebhookEventsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedMessagesArgs = {
  _set?: InputMaybe<IntegratedMessagesSetInput>;
  where: IntegratedMessagesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedMessagesByPkArgs = {
  _set?: InputMaybe<IntegratedMessagesSetInput>;
  pkColumns: IntegratedMessagesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedMessagesManyArgs = {
  updates: Array<IntegratedMessagesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallDismissalsArgs = {
  _set?: InputMaybe<IntegratedPhoneCallDismissalsSetInput>;
  where: IntegratedPhoneCallDismissalsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallDismissalsByPkArgs = {
  _set?: InputMaybe<IntegratedPhoneCallDismissalsSetInput>;
  pkColumns: IntegratedPhoneCallDismissalsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallDismissalsManyArgs = {
  updates: Array<IntegratedPhoneCallDismissalsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallJobsArgs = {
  _set?: InputMaybe<IntegratedPhoneCallJobsSetInput>;
  where: IntegratedPhoneCallJobsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallJobsByPkArgs = {
  _set?: InputMaybe<IntegratedPhoneCallJobsSetInput>;
  pkColumns: IntegratedPhoneCallJobsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallJobsManyArgs = {
  updates: Array<IntegratedPhoneCallJobsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallRecordingArgs = {
  _inc?: InputMaybe<IntegratedPhoneCallRecordingIncInput>;
  _set?: InputMaybe<IntegratedPhoneCallRecordingSetInput>;
  where: IntegratedPhoneCallRecordingBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallRecordingByPkArgs = {
  _inc?: InputMaybe<IntegratedPhoneCallRecordingIncInput>;
  _set?: InputMaybe<IntegratedPhoneCallRecordingSetInput>;
  pkColumns: IntegratedPhoneCallRecordingPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallRecordingManyArgs = {
  updates: Array<IntegratedPhoneCallRecordingUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallStatusTypesArgs = {
  _set?: InputMaybe<IntegratedPhoneCallStatusTypesSetInput>;
  where: IntegratedPhoneCallStatusTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallStatusTypesByPkArgs = {
  _set?: InputMaybe<IntegratedPhoneCallStatusTypesSetInput>;
  pkColumns: IntegratedPhoneCallStatusTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallStatusTypesManyArgs = {
  updates: Array<IntegratedPhoneCallStatusTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallStatusesArgs = {
  _set?: InputMaybe<IntegratedPhoneCallStatusesSetInput>;
  where: IntegratedPhoneCallStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallStatusesByPkArgs = {
  _set?: InputMaybe<IntegratedPhoneCallStatusesSetInput>;
  pkColumns: IntegratedPhoneCallStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallStatusesManyArgs = {
  updates: Array<IntegratedPhoneCallStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallsArgs = {
  _set?: InputMaybe<IntegratedPhoneCallsSetInput>;
  where: IntegratedPhoneCallsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallsByPkArgs = {
  _set?: InputMaybe<IntegratedPhoneCallsSetInput>;
  pkColumns: IntegratedPhoneCallsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCallsManyArgs = {
  updates: Array<IntegratedPhoneCallsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCompanyConfigArgs = {
  _set?: InputMaybe<IntegratedPhoneCompanyConfigSetInput>;
  where: IntegratedPhoneCompanyConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCompanyConfigByPkArgs = {
  _set?: InputMaybe<IntegratedPhoneCompanyConfigSetInput>;
  pkColumns: IntegratedPhoneCompanyConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneCompanyConfigManyArgs = {
  updates: Array<IntegratedPhoneCompanyConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneMissedCallDismissalsArgs = {
  _set?: InputMaybe<IntegratedPhoneMissedCallDismissalsSetInput>;
  where: IntegratedPhoneMissedCallDismissalsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneMissedCallDismissalsByPkArgs = {
  _set?: InputMaybe<IntegratedPhoneMissedCallDismissalsSetInput>;
  pkColumns: IntegratedPhoneMissedCallDismissalsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneMissedCallDismissalsManyArgs = {
  updates: Array<IntegratedPhoneMissedCallDismissalsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneMissedCallsArgs = {
  _set?: InputMaybe<IntegratedPhoneMissedCallsSetInput>;
  where: IntegratedPhoneMissedCallsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneMissedCallsByPkArgs = {
  _set?: InputMaybe<IntegratedPhoneMissedCallsSetInput>;
  pkColumns: IntegratedPhoneMissedCallsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneMissedCallsManyArgs = {
  updates: Array<IntegratedPhoneMissedCallsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneTwilioRawWebhookEventsArgs = {
  _append?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsAppendInput>;
  _deleteAtPath?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsDeleteKeyInput>;
  _prepend?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsPrependInput>;
  _set?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsSetInput>;
  where: IntegratedPhoneTwilioRawWebhookEventsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneTwilioRawWebhookEventsByPkArgs = {
  _append?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsAppendInput>;
  _deleteAtPath?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsDeleteKeyInput>;
  _prepend?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsPrependInput>;
  _set?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsSetInput>;
  pkColumns: IntegratedPhoneTwilioRawWebhookEventsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneTwilioRawWebhookEventsManyArgs = {
  updates: Array<IntegratedPhoneTwilioRawWebhookEventsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneUsersArgs = {
  _set?: InputMaybe<IntegratedPhoneUsersSetInput>;
  where: IntegratedPhoneUsersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneUsersByPkArgs = {
  _set?: InputMaybe<IntegratedPhoneUsersSetInput>;
  pkColumns: IntegratedPhoneUsersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneUsersManyArgs = {
  updates: Array<IntegratedPhoneUsersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneVoicemailDismissalsArgs = {
  _set?: InputMaybe<IntegratedPhoneVoicemailDismissalsSetInput>;
  where: IntegratedPhoneVoicemailDismissalsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneVoicemailDismissalsByPkArgs = {
  _set?: InputMaybe<IntegratedPhoneVoicemailDismissalsSetInput>;
  pkColumns: IntegratedPhoneVoicemailDismissalsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneVoicemailDismissalsManyArgs = {
  updates: Array<IntegratedPhoneVoicemailDismissalsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneVoicemailsArgs = {
  _inc?: InputMaybe<IntegratedPhoneVoicemailsIncInput>;
  _set?: InputMaybe<IntegratedPhoneVoicemailsSetInput>;
  where: IntegratedPhoneVoicemailsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneVoicemailsByPkArgs = {
  _inc?: InputMaybe<IntegratedPhoneVoicemailsIncInput>;
  _set?: InputMaybe<IntegratedPhoneVoicemailsSetInput>;
  pkColumns: IntegratedPhoneVoicemailsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhoneVoicemailsManyArgs = {
  updates: Array<IntegratedPhoneVoicemailsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhonesArgs = {
  _set?: InputMaybe<IntegratedPhonesSetInput>;
  where: IntegratedPhonesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhonesByPkArgs = {
  _set?: InputMaybe<IntegratedPhonesSetInput>;
  pkColumns: IntegratedPhonesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateIntegratedPhonesManyArgs = {
  updates: Array<IntegratedPhonesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInternalNotificationsArgs = {
  _append?: InputMaybe<InternalNotificationsAppendInput>;
  _deleteAtPath?: InputMaybe<InternalNotificationsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<InternalNotificationsDeleteElemInput>;
  _deleteKey?: InputMaybe<InternalNotificationsDeleteKeyInput>;
  _prepend?: InputMaybe<InternalNotificationsPrependInput>;
  _set?: InputMaybe<InternalNotificationsSetInput>;
  where: InternalNotificationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInternalNotificationsByPkArgs = {
  _append?: InputMaybe<InternalNotificationsAppendInput>;
  _deleteAtPath?: InputMaybe<InternalNotificationsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<InternalNotificationsDeleteElemInput>;
  _deleteKey?: InputMaybe<InternalNotificationsDeleteKeyInput>;
  _prepend?: InputMaybe<InternalNotificationsPrependInput>;
  _set?: InputMaybe<InternalNotificationsSetInput>;
  pkColumns: InternalNotificationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInternalNotificationsManyArgs = {
  updates: Array<InternalNotificationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceCartItemBundleItemsArgs = {
  _inc?: InputMaybe<InvoiceCartItemBundleItemsIncInput>;
  _set?: InputMaybe<InvoiceCartItemBundleItemsSetInput>;
  where: InvoiceCartItemBundleItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceCartItemBundleItemsByPkArgs = {
  _inc?: InputMaybe<InvoiceCartItemBundleItemsIncInput>;
  _set?: InputMaybe<InvoiceCartItemBundleItemsSetInput>;
  pkColumns: InvoiceCartItemBundleItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceCartItemBundleItemsManyArgs = {
  updates: Array<InvoiceCartItemBundleItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceCartItemBundleJobCostLinksArgs = {
  _set?: InputMaybe<InvoiceCartItemBundleJobCostLinksSetInput>;
  where: InvoiceCartItemBundleJobCostLinksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceCartItemBundleJobCostLinksByPkArgs = {
  _set?: InputMaybe<InvoiceCartItemBundleJobCostLinksSetInput>;
  pkColumns: InvoiceCartItemBundleJobCostLinksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceCartItemBundleJobCostLinksManyArgs = {
  updates: Array<InvoiceCartItemBundleJobCostLinksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceCartItemsArgs = {
  _inc?: InputMaybe<InvoiceCartItemsIncInput>;
  _set?: InputMaybe<InvoiceCartItemsSetInput>;
  where: InvoiceCartItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceCartItemsByPkArgs = {
  _inc?: InputMaybe<InvoiceCartItemsIncInput>;
  _set?: InputMaybe<InvoiceCartItemsSetInput>;
  pkColumns: InvoiceCartItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceCartItemsManyArgs = {
  updates: Array<InvoiceCartItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceDiscountsArgs = {
  _inc?: InputMaybe<InvoiceDiscountsIncInput>;
  _set?: InputMaybe<InvoiceDiscountsSetInput>;
  where: InvoiceDiscountsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceDiscountsByPkArgs = {
  _inc?: InputMaybe<InvoiceDiscountsIncInput>;
  _set?: InputMaybe<InvoiceDiscountsSetInput>;
  pkColumns: InvoiceDiscountsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceDiscountsManyArgs = {
  updates: Array<InvoiceDiscountsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceEventsArgs = {
  _append?: InputMaybe<InvoiceEventsAppendInput>;
  _deleteAtPath?: InputMaybe<InvoiceEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<InvoiceEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<InvoiceEventsDeleteKeyInput>;
  _prepend?: InputMaybe<InvoiceEventsPrependInput>;
  _set?: InputMaybe<InvoiceEventsSetInput>;
  where: InvoiceEventsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceEventsByPkArgs = {
  _append?: InputMaybe<InvoiceEventsAppendInput>;
  _deleteAtPath?: InputMaybe<InvoiceEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<InvoiceEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<InvoiceEventsDeleteKeyInput>;
  _prepend?: InputMaybe<InvoiceEventsPrependInput>;
  _set?: InputMaybe<InvoiceEventsSetInput>;
  pkColumns: InvoiceEventsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceEventsManyArgs = {
  updates: Array<InvoiceEventsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInvoicePaymentsArgs = {
  _inc?: InputMaybe<InvoicePaymentsIncInput>;
  _set?: InputMaybe<InvoicePaymentsSetInput>;
  where: InvoicePaymentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInvoicePaymentsByPkArgs = {
  _inc?: InputMaybe<InvoicePaymentsIncInput>;
  _set?: InputMaybe<InvoicePaymentsSetInput>;
  pkColumns: InvoicePaymentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoicePaymentsManyArgs = {
  updates: Array<InvoicePaymentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceReminderDataArgs = {
  _inc?: InputMaybe<InvoiceReminderDataIncInput>;
  _set?: InputMaybe<InvoiceReminderDataSetInput>;
  where: InvoiceReminderDataBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceReminderDataByPkArgs = {
  _inc?: InputMaybe<InvoiceReminderDataIncInput>;
  _set?: InputMaybe<InvoiceReminderDataSetInput>;
  pkColumns: InvoiceReminderDataPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceReminderDataManyArgs = {
  updates: Array<InvoiceReminderDataUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceTemplateCartItemsArgs = {
  _inc?: InputMaybe<InvoiceTemplateCartItemsIncInput>;
  _set?: InputMaybe<InvoiceTemplateCartItemsSetInput>;
  where: InvoiceTemplateCartItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceTemplateCartItemsByPkArgs = {
  _inc?: InputMaybe<InvoiceTemplateCartItemsIncInput>;
  _set?: InputMaybe<InvoiceTemplateCartItemsSetInput>;
  pkColumns: InvoiceTemplateCartItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceTemplateCartItemsManyArgs = {
  updates: Array<InvoiceTemplateCartItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceTemplatesArgs = {
  _set?: InputMaybe<InvoiceTemplatesSetInput>;
  where: InvoiceTemplatesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceTemplatesByPkArgs = {
  _set?: InputMaybe<InvoiceTemplatesSetInput>;
  pkColumns: InvoiceTemplatesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoiceTemplatesManyArgs = {
  updates: Array<InvoiceTemplatesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInvoicesArgs = {
  _inc?: InputMaybe<InvoicesIncInput>;
  _set?: InputMaybe<InvoicesSetInput>;
  where: InvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInvoicesByPkArgs = {
  _inc?: InputMaybe<InvoicesIncInput>;
  _set?: InputMaybe<InvoicesSetInput>;
  pkColumns: InvoicesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoicesManyArgs = {
  updates: Array<InvoicesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateInvoicesQueryableArgs = {
  _inc?: InputMaybe<InvoicesQueryableIncInput>;
  _set?: InputMaybe<InvoicesQueryableSetInput>;
  where: InvoicesQueryableBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateInvoicesQueryableByPkArgs = {
  _inc?: InputMaybe<InvoicesQueryableIncInput>;
  _set?: InputMaybe<InvoicesQueryableSetInput>;
  pkColumns: InvoicesQueryablePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateInvoicesQueryableManyArgs = {
  updates: Array<InvoicesQueryableUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentAssignmentStatusTypesArgs = {
  _set?: InputMaybe<JobAppointmentAssignmentStatusTypesSetInput>;
  where: JobAppointmentAssignmentStatusTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentAssignmentStatusTypesByPkArgs = {
  _set?: InputMaybe<JobAppointmentAssignmentStatusTypesSetInput>;
  pkColumns: JobAppointmentAssignmentStatusTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentAssignmentStatusTypesManyArgs = {
  updates: Array<JobAppointmentAssignmentStatusTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentAssignmentStatusesArgs = {
  _set?: InputMaybe<JobAppointmentAssignmentStatusesSetInput>;
  where: JobAppointmentAssignmentStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentAssignmentStatusesByPkArgs = {
  _set?: InputMaybe<JobAppointmentAssignmentStatusesSetInput>;
  pkColumns: JobAppointmentAssignmentStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentAssignmentStatusesManyArgs = {
  updates: Array<JobAppointmentAssignmentStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentAssignmentsArgs = {
  _set?: InputMaybe<JobAppointmentAssignmentsSetInput>;
  where: JobAppointmentAssignmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentAssignmentsByPkArgs = {
  _set?: InputMaybe<JobAppointmentAssignmentsSetInput>;
  pkColumns: JobAppointmentAssignmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentAssignmentsManyArgs = {
  updates: Array<JobAppointmentAssignmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentCancellationStatusesArgs = {
  _set?: InputMaybe<JobAppointmentCancellationStatusesSetInput>;
  where: JobAppointmentCancellationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentCancellationStatusesByPkArgs = {
  _set?: InputMaybe<JobAppointmentCancellationStatusesSetInput>;
  pkColumns: JobAppointmentCancellationStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentCancellationStatusesManyArgs = {
  updates: Array<JobAppointmentCancellationStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentConfirmationStatusesArgs = {
  _set?: InputMaybe<JobAppointmentConfirmationStatusesSetInput>;
  where: JobAppointmentConfirmationStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentConfirmationStatusesByPkArgs = {
  _set?: InputMaybe<JobAppointmentConfirmationStatusesSetInput>;
  pkColumns: JobAppointmentConfirmationStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentConfirmationStatusesManyArgs = {
  updates: Array<JobAppointmentConfirmationStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentInvoicesArgs = {
  _set?: InputMaybe<JobAppointmentInvoicesSetInput>;
  where: JobAppointmentInvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentInvoicesByPkArgs = {
  _set?: InputMaybe<JobAppointmentInvoicesSetInput>;
  pkColumns: JobAppointmentInvoicesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentInvoicesManyArgs = {
  updates: Array<JobAppointmentInvoicesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentsArgs = {
  _append?: InputMaybe<JobAppointmentsAppendInput>;
  _deleteAtPath?: InputMaybe<JobAppointmentsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<JobAppointmentsDeleteElemInput>;
  _deleteKey?: InputMaybe<JobAppointmentsDeleteKeyInput>;
  _prepend?: InputMaybe<JobAppointmentsPrependInput>;
  _set?: InputMaybe<JobAppointmentsSetInput>;
  where: JobAppointmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentsByPkArgs = {
  _append?: InputMaybe<JobAppointmentsAppendInput>;
  _deleteAtPath?: InputMaybe<JobAppointmentsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<JobAppointmentsDeleteElemInput>;
  _deleteKey?: InputMaybe<JobAppointmentsDeleteKeyInput>;
  _prepend?: InputMaybe<JobAppointmentsPrependInput>;
  _set?: InputMaybe<JobAppointmentsSetInput>;
  pkColumns: JobAppointmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobAppointmentsManyArgs = {
  updates: Array<JobAppointmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobCostItemsArgs = {
  _inc?: InputMaybe<JobCostItemsIncInput>;
  _set?: InputMaybe<JobCostItemsSetInput>;
  where: JobCostItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobCostItemsByPkArgs = {
  _inc?: InputMaybe<JobCostItemsIncInput>;
  _set?: InputMaybe<JobCostItemsSetInput>;
  pkColumns: JobCostItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobCostItemsManyArgs = {
  updates: Array<JobCostItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobCostMiscCategoriesArgs = {
  _set?: InputMaybe<JobCostMiscCategoriesSetInput>;
  where: JobCostMiscCategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobCostMiscCategoriesByPkArgs = {
  _set?: InputMaybe<JobCostMiscCategoriesSetInput>;
  pkColumns: JobCostMiscCategoriesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobCostMiscCategoriesManyArgs = {
  updates: Array<JobCostMiscCategoriesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobCostingConfigArgs = {
  _set?: InputMaybe<JobCostingConfigSetInput>;
  where: JobCostingConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobCostingConfigByPkArgs = {
  _set?: InputMaybe<JobCostingConfigSetInput>;
  pkColumns: JobCostingConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobCostingConfigManyArgs = {
  updates: Array<JobCostingConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobInvoicesArgs = {
  _set?: InputMaybe<JobInvoicesSetInput>;
  where: JobInvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobInvoicesByPkArgs = {
  _set?: InputMaybe<JobInvoicesSetInput>;
  pkColumns: JobInvoicesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobInvoicesManyArgs = {
  updates: Array<JobInvoicesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobLeadsArgs = {
  _append?: InputMaybe<JobLeadsAppendInput>;
  _deleteAtPath?: InputMaybe<JobLeadsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<JobLeadsDeleteElemInput>;
  _deleteKey?: InputMaybe<JobLeadsDeleteKeyInput>;
  _prepend?: InputMaybe<JobLeadsPrependInput>;
  _set?: InputMaybe<JobLeadsSetInput>;
  where: JobLeadsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobLeadsByPkArgs = {
  _append?: InputMaybe<JobLeadsAppendInput>;
  _deleteAtPath?: InputMaybe<JobLeadsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<JobLeadsDeleteElemInput>;
  _deleteKey?: InputMaybe<JobLeadsDeleteKeyInput>;
  _prepend?: InputMaybe<JobLeadsPrependInput>;
  _set?: InputMaybe<JobLeadsSetInput>;
  pkColumns: JobLeadsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobLeadsManyArgs = {
  updates: Array<JobLeadsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobLifecycleStatusesArgs = {
  _set?: InputMaybe<JobLifecycleStatusesSetInput>;
  where: JobLifecycleStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobLifecycleStatusesByPkArgs = {
  _set?: InputMaybe<JobLifecycleStatusesSetInput>;
  pkColumns: JobLifecycleStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobLifecycleStatusesManyArgs = {
  updates: Array<JobLifecycleStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobLifecycleTypesArgs = {
  _set?: InputMaybe<JobLifecycleTypesSetInput>;
  where: JobLifecycleTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobLifecycleTypesByPkArgs = {
  _set?: InputMaybe<JobLifecycleTypesSetInput>;
  pkColumns: JobLifecycleTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobLifecycleTypesManyArgs = {
  updates: Array<JobLifecycleTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobLifecycleViewsArgs = {
  _append?: InputMaybe<JobLifecycleViewsAppendInput>;
  _deleteAtPath?: InputMaybe<JobLifecycleViewsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<JobLifecycleViewsDeleteElemInput>;
  _deleteKey?: InputMaybe<JobLifecycleViewsDeleteKeyInput>;
  _prepend?: InputMaybe<JobLifecycleViewsPrependInput>;
  _set?: InputMaybe<JobLifecycleViewsSetInput>;
  where: JobLifecycleViewsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobLifecycleViewsByPkArgs = {
  _append?: InputMaybe<JobLifecycleViewsAppendInput>;
  _deleteAtPath?: InputMaybe<JobLifecycleViewsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<JobLifecycleViewsDeleteElemInput>;
  _deleteKey?: InputMaybe<JobLifecycleViewsDeleteKeyInput>;
  _prepend?: InputMaybe<JobLifecycleViewsPrependInput>;
  _set?: InputMaybe<JobLifecycleViewsSetInput>;
  pkColumns: JobLifecycleViewsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobLifecycleViewsManyArgs = {
  updates: Array<JobLifecycleViewsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobLifecyclesArgs = {
  _set?: InputMaybe<JobLifecyclesSetInput>;
  where: JobLifecyclesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobLifecyclesByPkArgs = {
  _set?: InputMaybe<JobLifecyclesSetInput>;
  pkColumns: JobLifecyclesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobLifecyclesManyArgs = {
  updates: Array<JobLifecyclesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobRequestsCompanyConfigArgs = {
  _set?: InputMaybe<JobRequestsCompanyConfigSetInput>;
  where: JobRequestsCompanyConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobRequestsCompanyConfigByPkArgs = {
  _set?: InputMaybe<JobRequestsCompanyConfigSetInput>;
  pkColumns: JobRequestsCompanyConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobRequestsCompanyConfigManyArgs = {
  updates: Array<JobRequestsCompanyConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobTagsArgs = {
  _set?: InputMaybe<JobTagsSetInput>;
  where: JobTagsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobTagsByPkArgs = {
  _set?: InputMaybe<JobTagsSetInput>;
  pkColumns: JobTagsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobTagsManyArgs = {
  updates: Array<JobTagsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobTeamMembersArgs = {
  _inc?: InputMaybe<JobTeamMembersIncInput>;
  _set?: InputMaybe<JobTeamMembersSetInput>;
  where: JobTeamMembersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobTeamMembersByPkArgs = {
  _inc?: InputMaybe<JobTeamMembersIncInput>;
  _set?: InputMaybe<JobTeamMembersSetInput>;
  pkColumns: JobTeamMembersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobTeamMembersManyArgs = {
  updates: Array<JobTeamMembersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobTechnicianEarnedRevenueAttributionsArgs = {
  _inc?: InputMaybe<JobTechnicianEarnedRevenueAttributionsIncInput>;
  _set?: InputMaybe<JobTechnicianEarnedRevenueAttributionsSetInput>;
  where: JobTechnicianEarnedRevenueAttributionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobTechnicianEarnedRevenueAttributionsByPkArgs = {
  _inc?: InputMaybe<JobTechnicianEarnedRevenueAttributionsIncInput>;
  _set?: InputMaybe<JobTechnicianEarnedRevenueAttributionsSetInput>;
  pkColumns: JobTechnicianEarnedRevenueAttributionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobTechnicianEarnedRevenueAttributionsManyArgs = {
  updates: Array<JobTechnicianEarnedRevenueAttributionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobTechnicianSoldRevenueAttributionsArgs = {
  _inc?: InputMaybe<JobTechnicianSoldRevenueAttributionsIncInput>;
  _set?: InputMaybe<JobTechnicianSoldRevenueAttributionsSetInput>;
  where: JobTechnicianSoldRevenueAttributionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobTechnicianSoldRevenueAttributionsByPkArgs = {
  _inc?: InputMaybe<JobTechnicianSoldRevenueAttributionsIncInput>;
  _set?: InputMaybe<JobTechnicianSoldRevenueAttributionsSetInput>;
  pkColumns: JobTechnicianSoldRevenueAttributionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobTechnicianSoldRevenueAttributionsManyArgs = {
  updates: Array<JobTechnicianSoldRevenueAttributionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobTypeChangeReasonsArgs = {
  _set?: InputMaybe<JobTypeChangeReasonsSetInput>;
  where: JobTypeChangeReasonsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobTypeChangeReasonsByPkArgs = {
  _set?: InputMaybe<JobTypeChangeReasonsSetInput>;
  pkColumns: JobTypeChangeReasonsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobTypeChangeReasonsManyArgs = {
  updates: Array<JobTypeChangeReasonsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobTypesArgs = {
  _inc?: InputMaybe<JobTypesIncInput>;
  _set?: InputMaybe<JobTypesSetInput>;
  where: JobTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobTypesByPkArgs = {
  _inc?: InputMaybe<JobTypesIncInput>;
  _set?: InputMaybe<JobTypesSetInput>;
  pkColumns: JobTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobTypesManyArgs = {
  updates: Array<JobTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobsArgs = {
  _inc?: InputMaybe<JobsIncInput>;
  _set?: InputMaybe<JobsSetInput>;
  where: JobsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobsByPkArgs = {
  _inc?: InputMaybe<JobsIncInput>;
  _set?: InputMaybe<JobsSetInput>;
  pkColumns: JobsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobsManyArgs = {
  updates: Array<JobsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobsWithLinkedJobArgs = {
  _set?: InputMaybe<JobsWithLinkedJobSetInput>;
  where: JobsWithLinkedJobBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobsWithLinkedJobByPkArgs = {
  _set?: InputMaybe<JobsWithLinkedJobSetInput>;
  pkColumns: JobsWithLinkedJobPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobsWithLinkedJobLinkedAppointmentChecklistInstancesArgs = {
  _set?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesSetInput>;
  where: JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobsWithLinkedJobLinkedAppointmentChecklistInstancesByPkArgs = {
  _set?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesSetInput>;
  pkColumns: JobsWithLinkedJobLinkedAppointmentChecklistInstancesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobsWithLinkedJobLinkedAppointmentChecklistInstancesManyArgs = {
  updates: Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobsWithLinkedJobLinkedEstimatesArgs = {
  _set?: InputMaybe<JobsWithLinkedJobLinkedEstimatesSetInput>;
  where: JobsWithLinkedJobLinkedEstimatesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobsWithLinkedJobLinkedEstimatesByPkArgs = {
  _set?: InputMaybe<JobsWithLinkedJobLinkedEstimatesSetInput>;
  pkColumns: JobsWithLinkedJobLinkedEstimatesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobsWithLinkedJobLinkedEstimatesManyArgs = {
  updates: Array<JobsWithLinkedJobLinkedEstimatesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobsWithLinkedJobManyArgs = {
  updates: Array<JobsWithLinkedJobUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLocationContactsArgs = {
  _append?: InputMaybe<LocationContactsAppendInput>;
  _deleteAtPath?: InputMaybe<LocationContactsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<LocationContactsDeleteElemInput>;
  _deleteKey?: InputMaybe<LocationContactsDeleteKeyInput>;
  _prepend?: InputMaybe<LocationContactsPrependInput>;
  _set?: InputMaybe<LocationContactsSetInput>;
  where: LocationContactsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLocationContactsByPkArgs = {
  _append?: InputMaybe<LocationContactsAppendInput>;
  _deleteAtPath?: InputMaybe<LocationContactsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<LocationContactsDeleteElemInput>;
  _deleteKey?: InputMaybe<LocationContactsDeleteKeyInput>;
  _prepend?: InputMaybe<LocationContactsPrependInput>;
  _set?: InputMaybe<LocationContactsSetInput>;
  pkColumns: LocationContactsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLocationContactsManyArgs = {
  updates: Array<LocationContactsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLocationInvoicesArgs = {
  _set?: InputMaybe<LocationInvoicesSetInput>;
  where: LocationInvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLocationInvoicesByPkArgs = {
  _set?: InputMaybe<LocationInvoicesSetInput>;
  pkColumns: LocationInvoicesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLocationInvoicesManyArgs = {
  updates: Array<LocationInvoicesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLocationsArgs = {
  _inc?: InputMaybe<LocationsIncInput>;
  _set?: InputMaybe<LocationsSetInput>;
  where: LocationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLocationsByPkArgs = {
  _inc?: InputMaybe<LocationsIncInput>;
  _set?: InputMaybe<LocationsSetInput>;
  pkColumns: LocationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLocationsManyArgs = {
  updates: Array<LocationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionAllowedPaymentIntervalsArgs = {
  _set?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsSetInput>;
  where: MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionAllowedPaymentIntervalsByPkArgs = {
  _set?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsSetInput>;
  pkColumns: MaintenancePlanDefinitionAllowedPaymentIntervalsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionAllowedPaymentIntervalsManyArgs = {
  updates: Array<MaintenancePlanDefinitionAllowedPaymentIntervalsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionBenefitsArgs = {
  _set?: InputMaybe<MaintenancePlanDefinitionBenefitsSetInput>;
  where: MaintenancePlanDefinitionBenefitsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionBenefitsByPkArgs = {
  _set?: InputMaybe<MaintenancePlanDefinitionBenefitsSetInput>;
  pkColumns: MaintenancePlanDefinitionBenefitsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionBenefitsManyArgs = {
  updates: Array<MaintenancePlanDefinitionBenefitsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionDiscountsArgs = {
  _inc?: InputMaybe<MaintenancePlanDefinitionDiscountsIncInput>;
  _set?: InputMaybe<MaintenancePlanDefinitionDiscountsSetInput>;
  where: MaintenancePlanDefinitionDiscountsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionDiscountsByPkArgs = {
  _inc?: InputMaybe<MaintenancePlanDefinitionDiscountsIncInput>;
  _set?: InputMaybe<MaintenancePlanDefinitionDiscountsSetInput>;
  pkColumns: MaintenancePlanDefinitionDiscountsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionDiscountsManyArgs = {
  updates: Array<MaintenancePlanDefinitionDiscountsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionFlareArgs = {
  _set?: InputMaybe<MaintenancePlanDefinitionFlareSetInput>;
  where: MaintenancePlanDefinitionFlareBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionFlareByPkArgs = {
  _set?: InputMaybe<MaintenancePlanDefinitionFlareSetInput>;
  pkColumns: MaintenancePlanDefinitionFlarePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionFlareManyArgs = {
  updates: Array<MaintenancePlanDefinitionFlareUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionMarketingInfoArgs = {
  _set?: InputMaybe<MaintenancePlanDefinitionMarketingInfoSetInput>;
  where: MaintenancePlanDefinitionMarketingInfoBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionMarketingInfoByPkArgs = {
  _set?: InputMaybe<MaintenancePlanDefinitionMarketingInfoSetInput>;
  pkColumns: MaintenancePlanDefinitionMarketingInfoPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionMarketingInfoManyArgs = {
  updates: Array<MaintenancePlanDefinitionMarketingInfoUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionsArgs = {
  _append?: InputMaybe<MaintenancePlanDefinitionsAppendInput>;
  _deleteAtPath?: InputMaybe<MaintenancePlanDefinitionsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<MaintenancePlanDefinitionsDeleteElemInput>;
  _deleteKey?: InputMaybe<MaintenancePlanDefinitionsDeleteKeyInput>;
  _inc?: InputMaybe<MaintenancePlanDefinitionsIncInput>;
  _prepend?: InputMaybe<MaintenancePlanDefinitionsPrependInput>;
  _set?: InputMaybe<MaintenancePlanDefinitionsSetInput>;
  where: MaintenancePlanDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionsByPkArgs = {
  _append?: InputMaybe<MaintenancePlanDefinitionsAppendInput>;
  _deleteAtPath?: InputMaybe<MaintenancePlanDefinitionsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<MaintenancePlanDefinitionsDeleteElemInput>;
  _deleteKey?: InputMaybe<MaintenancePlanDefinitionsDeleteKeyInput>;
  _inc?: InputMaybe<MaintenancePlanDefinitionsIncInput>;
  _prepend?: InputMaybe<MaintenancePlanDefinitionsPrependInput>;
  _set?: InputMaybe<MaintenancePlanDefinitionsSetInput>;
  pkColumns: MaintenancePlanDefinitionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanDefinitionsManyArgs = {
  updates: Array<MaintenancePlanDefinitionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanEquipmentCoverageDefinitionsArgs = {
  _set?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsSetInput>;
  where: MaintenancePlanEquipmentCoverageDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanEquipmentCoverageDefinitionsByPkArgs = {
  _set?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsSetInput>;
  pkColumns: MaintenancePlanEquipmentCoverageDefinitionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanEquipmentCoverageDefinitionsManyArgs = {
  updates: Array<MaintenancePlanEquipmentCoverageDefinitionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanEquipmentCoveragePricingsArgs = {
  _inc?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsIncInput>;
  _set?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsSetInput>;
  where: MaintenancePlanEquipmentCoveragePricingsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanEquipmentCoveragePricingsByPkArgs = {
  _inc?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsIncInput>;
  _set?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsSetInput>;
  pkColumns: MaintenancePlanEquipmentCoveragePricingsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanEquipmentCoveragePricingsManyArgs = {
  updates: Array<MaintenancePlanEquipmentCoveragePricingsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanInvoicesArgs = {
  _set?: InputMaybe<MaintenancePlanInvoicesSetInput>;
  where: MaintenancePlanInvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanInvoicesByPkArgs = {
  _set?: InputMaybe<MaintenancePlanInvoicesSetInput>;
  pkColumns: MaintenancePlanInvoicesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanInvoicesManyArgs = {
  updates: Array<MaintenancePlanInvoicesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanVisitInstalledEquipmentsArgs = {
  _set?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsSetInput>;
  where: MaintenancePlanVisitInstalledEquipmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanVisitInstalledEquipmentsByPkArgs = {
  _set?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsSetInput>;
  pkColumns: MaintenancePlanVisitInstalledEquipmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanVisitInstalledEquipmentsManyArgs = {
  updates: Array<MaintenancePlanVisitInstalledEquipmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanVisitsArgs = {
  _set?: InputMaybe<MaintenancePlanVisitsSetInput>;
  where: MaintenancePlanVisitsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanVisitsByPkArgs = {
  _set?: InputMaybe<MaintenancePlanVisitsSetInput>;
  pkColumns: MaintenancePlanVisitsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlanVisitsManyArgs = {
  updates: Array<MaintenancePlanVisitsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlansQueryableArgs = {
  _append?: InputMaybe<MaintenancePlansQueryableAppendInput>;
  _deleteAtPath?: InputMaybe<MaintenancePlansQueryableDeleteAtPathInput>;
  _deleteElem?: InputMaybe<MaintenancePlansQueryableDeleteElemInput>;
  _deleteKey?: InputMaybe<MaintenancePlansQueryableDeleteKeyInput>;
  _inc?: InputMaybe<MaintenancePlansQueryableIncInput>;
  _prepend?: InputMaybe<MaintenancePlansQueryablePrependInput>;
  _set?: InputMaybe<MaintenancePlansQueryableSetInput>;
  where: MaintenancePlansQueryableBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlansQueryableByPkArgs = {
  _append?: InputMaybe<MaintenancePlansQueryableAppendInput>;
  _deleteAtPath?: InputMaybe<MaintenancePlansQueryableDeleteAtPathInput>;
  _deleteElem?: InputMaybe<MaintenancePlansQueryableDeleteElemInput>;
  _deleteKey?: InputMaybe<MaintenancePlansQueryableDeleteKeyInput>;
  _inc?: InputMaybe<MaintenancePlansQueryableIncInput>;
  _prepend?: InputMaybe<MaintenancePlansQueryablePrependInput>;
  _set?: InputMaybe<MaintenancePlansQueryableSetInput>;
  pkColumns: MaintenancePlansQueryablePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMaintenancePlansQueryableManyArgs = {
  updates: Array<MaintenancePlansQueryableUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMigrationJunkArgs = {
  _append?: InputMaybe<MigrationJunkAppendInput>;
  _deleteAtPath?: InputMaybe<MigrationJunkDeleteAtPathInput>;
  _deleteElem?: InputMaybe<MigrationJunkDeleteElemInput>;
  _deleteKey?: InputMaybe<MigrationJunkDeleteKeyInput>;
  _prepend?: InputMaybe<MigrationJunkPrependInput>;
  _set?: InputMaybe<MigrationJunkSetInput>;
  where: MigrationJunkBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMigrationJunkByPkArgs = {
  _append?: InputMaybe<MigrationJunkAppendInput>;
  _deleteAtPath?: InputMaybe<MigrationJunkDeleteAtPathInput>;
  _deleteElem?: InputMaybe<MigrationJunkDeleteElemInput>;
  _deleteKey?: InputMaybe<MigrationJunkDeleteKeyInput>;
  _prepend?: InputMaybe<MigrationJunkPrependInput>;
  _set?: InputMaybe<MigrationJunkSetInput>;
  pkColumns: MigrationJunkPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMigrationJunkLinksArgs = {
  _set?: InputMaybe<MigrationJunkLinksSetInput>;
  where: MigrationJunkLinksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateMigrationJunkLinksByPkArgs = {
  _set?: InputMaybe<MigrationJunkLinksSetInput>;
  pkColumns: MigrationJunkLinksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateMigrationJunkLinksManyArgs = {
  updates: Array<MigrationJunkLinksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateMigrationJunkManyArgs = {
  updates: Array<MigrationJunkUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateNoteAttachmentsArgs = {
  _set?: InputMaybe<NoteAttachmentsSetInput>;
  where: NoteAttachmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateNoteAttachmentsByPkArgs = {
  _set?: InputMaybe<NoteAttachmentsSetInput>;
  pkColumns: NoteAttachmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateNoteAttachmentsManyArgs = {
  updates: Array<NoteAttachmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateNoteLinksArgs = {
  _set?: InputMaybe<NoteLinksSetInput>;
  where: NoteLinksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateNoteLinksByPkArgs = {
  _set?: InputMaybe<NoteLinksSetInput>;
  pkColumns: NoteLinksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateNoteLinksManyArgs = {
  updates: Array<NoteLinksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateNoteTaggedUsersArgs = {
  _set?: InputMaybe<NoteTaggedUsersSetInput>;
  where: NoteTaggedUsersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateNoteTaggedUsersByPkArgs = {
  _set?: InputMaybe<NoteTaggedUsersSetInput>;
  pkColumns: NoteTaggedUsersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateNoteTaggedUsersManyArgs = {
  updates: Array<NoteTaggedUsersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateNotesArgs = {
  _set?: InputMaybe<NotesSetInput>;
  where: NotesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateNotesByPkArgs = {
  _set?: InputMaybe<NotesSetInput>;
  pkColumns: NotesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateNotesManyArgs = {
  updates: Array<NotesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingCompanyConfigArgs = {
  _set?: InputMaybe<OnlineBookingCompanyConfigSetInput>;
  where: OnlineBookingCompanyConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingCompanyConfigByPkArgs = {
  _set?: InputMaybe<OnlineBookingCompanyConfigSetInput>;
  pkColumns: OnlineBookingCompanyConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingCompanyConfigManyArgs = {
  updates: Array<OnlineBookingCompanyConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingServiceAreaZipCodesArgs = {
  _set?: InputMaybe<OnlineBookingServiceAreaZipCodesSetInput>;
  where: OnlineBookingServiceAreaZipCodesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingServiceAreaZipCodesByPkArgs = {
  _set?: InputMaybe<OnlineBookingServiceAreaZipCodesSetInput>;
  pkColumns: OnlineBookingServiceAreaZipCodesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingServiceAreaZipCodesManyArgs = {
  updates: Array<OnlineBookingServiceAreaZipCodesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingServiceTypeBookableJobTypesArgs = {
  _set?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesSetInput>;
  where: OnlineBookingServiceTypeBookableJobTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingServiceTypeBookableJobTypesByPkArgs = {
  _set?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesSetInput>;
  pkColumns: OnlineBookingServiceTypeBookableJobTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingServiceTypeBookableJobTypesManyArgs = {
  updates: Array<OnlineBookingServiceTypeBookableJobTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingServiceTypeBookableTechniciansArgs = {
  _inc?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansIncInput>;
  _set?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansSetInput>;
  where: OnlineBookingServiceTypeBookableTechniciansBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingServiceTypeBookableTechniciansByPkArgs = {
  _inc?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansIncInput>;
  _set?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansSetInput>;
  pkColumns: OnlineBookingServiceTypeBookableTechniciansPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingServiceTypeBookableTechniciansManyArgs = {
  updates: Array<OnlineBookingServiceTypeBookableTechniciansUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingServiceTypeConfigsArgs = {
  _set?: InputMaybe<OnlineBookingServiceTypeConfigsSetInput>;
  where: OnlineBookingServiceTypeConfigsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingServiceTypeConfigsByPkArgs = {
  _set?: InputMaybe<OnlineBookingServiceTypeConfigsSetInput>;
  pkColumns: OnlineBookingServiceTypeConfigsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateOnlineBookingServiceTypeConfigsManyArgs = {
  updates: Array<OnlineBookingServiceTypeConfigsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentLinksArgs = {
  _set?: InputMaybe<PaymentLinksSetInput>;
  where: PaymentLinksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentLinksByPkArgs = {
  _set?: InputMaybe<PaymentLinksSetInput>;
  pkColumns: PaymentLinksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentLinksManyArgs = {
  updates: Array<PaymentLinksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentMethodBillingInfoArgs = {
  _set?: InputMaybe<PaymentMethodBillingInfoSetInput>;
  where: PaymentMethodBillingInfoBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentMethodBillingInfoByPkArgs = {
  _set?: InputMaybe<PaymentMethodBillingInfoSetInput>;
  pkColumns: PaymentMethodBillingInfoPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentMethodBillingInfoManyArgs = {
  updates: Array<PaymentMethodBillingInfoUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentMethodCardMetadataArgs = {
  _set?: InputMaybe<PaymentMethodCardMetadataSetInput>;
  where: PaymentMethodCardMetadataBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentMethodCardMetadataByPkArgs = {
  _set?: InputMaybe<PaymentMethodCardMetadataSetInput>;
  pkColumns: PaymentMethodCardMetadataPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentMethodCardMetadataManyArgs = {
  updates: Array<PaymentMethodCardMetadataUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentMethodRecordsArgs = {
  _set?: InputMaybe<PaymentMethodRecordsSetInput>;
  where: PaymentMethodRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentMethodRecordsByPkArgs = {
  _set?: InputMaybe<PaymentMethodRecordsSetInput>;
  pkColumns: PaymentMethodRecordsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentMethodRecordsManyArgs = {
  updates: Array<PaymentMethodRecordsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentRecordsArgs = {
  _inc?: InputMaybe<PaymentRecordsIncInput>;
  _set?: InputMaybe<PaymentRecordsSetInput>;
  where: PaymentRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentRecordsByPkArgs = {
  _inc?: InputMaybe<PaymentRecordsIncInput>;
  _set?: InputMaybe<PaymentRecordsSetInput>;
  pkColumns: PaymentRecordsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentRecordsManyArgs = {
  updates: Array<PaymentRecordsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentRefundsArgs = {
  _inc?: InputMaybe<PaymentRefundsIncInput>;
  _set?: InputMaybe<PaymentRefundsSetInput>;
  where: PaymentRefundsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentRefundsByPkArgs = {
  _inc?: InputMaybe<PaymentRefundsIncInput>;
  _set?: InputMaybe<PaymentRefundsSetInput>;
  pkColumns: PaymentRefundsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentRefundsManyArgs = {
  updates: Array<PaymentRefundsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusErrorDetailArgs = {
  _set?: InputMaybe<PaymentStatusErrorDetailSetInput>;
  where: PaymentStatusErrorDetailBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusErrorDetailByPkArgs = {
  _set?: InputMaybe<PaymentStatusErrorDetailSetInput>;
  pkColumns: PaymentStatusErrorDetailPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusErrorDetailManyArgs = {
  updates: Array<PaymentStatusErrorDetailUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusLatestArgs = {
  _set?: InputMaybe<PaymentStatusLatestSetInput>;
  where: PaymentStatusLatestBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusLatestByPkArgs = {
  _set?: InputMaybe<PaymentStatusLatestSetInput>;
  pkColumns: PaymentStatusLatestPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusLatestManyArgs = {
  updates: Array<PaymentStatusLatestUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusesArgs = {
  _set?: InputMaybe<PaymentStatusesSetInput>;
  where: PaymentStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusesByPkArgs = {
  _set?: InputMaybe<PaymentStatusesSetInput>;
  pkColumns: PaymentStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentStatusesManyArgs = {
  updates: Array<PaymentStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentSubscriptionInvoicesArgs = {
  _set?: InputMaybe<PaymentSubscriptionInvoicesSetInput>;
  where: PaymentSubscriptionInvoicesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentSubscriptionInvoicesByPkArgs = {
  _set?: InputMaybe<PaymentSubscriptionInvoicesSetInput>;
  pkColumns: PaymentSubscriptionInvoicesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentSubscriptionInvoicesManyArgs = {
  updates: Array<PaymentSubscriptionInvoicesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentSubscriptionStatusesArgs = {
  _set?: InputMaybe<PaymentSubscriptionStatusesSetInput>;
  where: PaymentSubscriptionStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentSubscriptionStatusesByPkArgs = {
  _set?: InputMaybe<PaymentSubscriptionStatusesSetInput>;
  pkColumns: PaymentSubscriptionStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentSubscriptionStatusesManyArgs = {
  updates: Array<PaymentSubscriptionStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePaymentSubscriptionsArgs = {
  _inc?: InputMaybe<PaymentSubscriptionsIncInput>;
  _set?: InputMaybe<PaymentSubscriptionsSetInput>;
  where: PaymentSubscriptionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePaymentSubscriptionsByPkArgs = {
  _inc?: InputMaybe<PaymentSubscriptionsIncInput>;
  _set?: InputMaybe<PaymentSubscriptionsSetInput>;
  pkColumns: PaymentSubscriptionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePaymentSubscriptionsManyArgs = {
  updates: Array<PaymentSubscriptionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePayoutItemsArgs = {
  _inc?: InputMaybe<PayoutItemsIncInput>;
  _set?: InputMaybe<PayoutItemsSetInput>;
  where: PayoutItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePayoutItemsByPkArgs = {
  _inc?: InputMaybe<PayoutItemsIncInput>;
  _set?: InputMaybe<PayoutItemsSetInput>;
  pkColumns: PayoutItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePayoutItemsManyArgs = {
  updates: Array<PayoutItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePayoutQboAccountsConfigArgs = {
  _set?: InputMaybe<PayoutQboAccountsConfigSetInput>;
  where: PayoutQboAccountsConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePayoutQboAccountsConfigByPkArgs = {
  _set?: InputMaybe<PayoutQboAccountsConfigSetInput>;
  pkColumns: PayoutQboAccountsConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePayoutQboAccountsConfigManyArgs = {
  updates: Array<PayoutQboAccountsConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePayoutsArgs = {
  _inc?: InputMaybe<PayoutsIncInput>;
  _set?: InputMaybe<PayoutsSetInput>;
  where: PayoutsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePayoutsByPkArgs = {
  _inc?: InputMaybe<PayoutsIncInput>;
  _set?: InputMaybe<PayoutsSetInput>;
  pkColumns: PayoutsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePayoutsManyArgs = {
  updates: Array<PayoutsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePhoneNumbersArgs = {
  _set?: InputMaybe<PhoneNumbersSetInput>;
  where: PhoneNumbersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePhoneNumbersByPkArgs = {
  _set?: InputMaybe<PhoneNumbersSetInput>;
  pkColumns: PhoneNumbersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePhoneNumbersManyArgs = {
  updates: Array<PhoneNumbersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePhotoLinksArgs = {
  _set?: InputMaybe<PhotoLinksSetInput>;
  where: PhotoLinksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePhotoLinksByPkArgs = {
  _set?: InputMaybe<PhotoLinksSetInput>;
  pkColumns: PhotoLinksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePhotoLinksManyArgs = {
  updates: Array<PhotoLinksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePhotosArgs = {
  _set?: InputMaybe<PhotosSetInput>;
  where: PhotosBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePhotosByPkArgs = {
  _set?: InputMaybe<PhotosSetInput>;
  pkColumns: PhotosPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePhotosManyArgs = {
  updates: Array<PhotosUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePricebookBundleItemsArgs = {
  _inc?: InputMaybe<PricebookBundleItemsIncInput>;
  _set?: InputMaybe<PricebookBundleItemsSetInput>;
  where: PricebookBundleItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePricebookBundleItemsByPkArgs = {
  _inc?: InputMaybe<PricebookBundleItemsIncInput>;
  _set?: InputMaybe<PricebookBundleItemsSetInput>;
  pkColumns: PricebookBundleItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePricebookBundleItemsManyArgs = {
  updates: Array<PricebookBundleItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePricebookCategoriesArgs = {
  _set?: InputMaybe<PricebookCategoriesSetInput>;
  where: PricebookCategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePricebookCategoriesByPkArgs = {
  _set?: InputMaybe<PricebookCategoriesSetInput>;
  pkColumns: PricebookCategoriesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePricebookCategoriesManyArgs = {
  updates: Array<PricebookCategoriesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePricebookDiscountsArgs = {
  _inc?: InputMaybe<PricebookDiscountsIncInput>;
  _set?: InputMaybe<PricebookDiscountsSetInput>;
  where: PricebookDiscountsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePricebookDiscountsByPkArgs = {
  _inc?: InputMaybe<PricebookDiscountsIncInput>;
  _set?: InputMaybe<PricebookDiscountsSetInput>;
  pkColumns: PricebookDiscountsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePricebookDiscountsManyArgs = {
  updates: Array<PricebookDiscountsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePricebookItemTypeFallbackPhotosArgs = {
  _set?: InputMaybe<PricebookItemTypeFallbackPhotosSetInput>;
  where: PricebookItemTypeFallbackPhotosBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePricebookItemTypeFallbackPhotosByPkArgs = {
  _set?: InputMaybe<PricebookItemTypeFallbackPhotosSetInput>;
  pkColumns: PricebookItemTypeFallbackPhotosPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePricebookItemTypeFallbackPhotosManyArgs = {
  updates: Array<PricebookItemTypeFallbackPhotosUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePricebookItemsArgs = {
  _inc?: InputMaybe<PricebookItemsIncInput>;
  _set?: InputMaybe<PricebookItemsSetInput>;
  where: PricebookItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePricebookItemsByPkArgs = {
  _inc?: InputMaybe<PricebookItemsIncInput>;
  _set?: InputMaybe<PricebookItemsSetInput>;
  pkColumns: PricebookItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePricebookItemsManyArgs = {
  updates: Array<PricebookItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePricebookItemsQboIncomeAccountsArgs = {
  _set?: InputMaybe<PricebookItemsQboIncomeAccountsSetInput>;
  where: PricebookItemsQboIncomeAccountsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePricebookItemsQboIncomeAccountsByPkArgs = {
  _set?: InputMaybe<PricebookItemsQboIncomeAccountsSetInput>;
  pkColumns: PricebookItemsQboIncomeAccountsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePricebookItemsQboIncomeAccountsManyArgs = {
  updates: Array<PricebookItemsQboIncomeAccountsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePricebookMarkupTiersArgs = {
  _inc?: InputMaybe<PricebookMarkupTiersIncInput>;
  _set?: InputMaybe<PricebookMarkupTiersSetInput>;
  where: PricebookMarkupTiersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePricebookMarkupTiersByPkArgs = {
  _inc?: InputMaybe<PricebookMarkupTiersIncInput>;
  _set?: InputMaybe<PricebookMarkupTiersSetInput>;
  pkColumns: PricebookMarkupTiersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePricebookMarkupTiersManyArgs = {
  updates: Array<PricebookMarkupTiersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePricebookTaxRatesArgs = {
  _inc?: InputMaybe<PricebookTaxRatesIncInput>;
  _set?: InputMaybe<PricebookTaxRatesSetInput>;
  where: PricebookTaxRatesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePricebookTaxRatesByPkArgs = {
  _inc?: InputMaybe<PricebookTaxRatesIncInput>;
  _set?: InputMaybe<PricebookTaxRatesSetInput>;
  pkColumns: PricebookTaxRatesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePricebookTaxRatesManyArgs = {
  updates: Array<PricebookTaxRatesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePricebookVersionsArgs = {
  _inc?: InputMaybe<PricebookVersionsIncInput>;
  _set?: InputMaybe<PricebookVersionsSetInput>;
  where: PricebookVersionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePricebookVersionsByPkArgs = {
  _inc?: InputMaybe<PricebookVersionsIncInput>;
  _set?: InputMaybe<PricebookVersionsSetInput>;
  pkColumns: PricebookVersionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePricebookVersionsManyArgs = {
  updates: Array<PricebookVersionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePurchaseOrdersArgs = {
  _set?: InputMaybe<PurchaseOrdersSetInput>;
  where: PurchaseOrdersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePurchaseOrdersByPkArgs = {
  _set?: InputMaybe<PurchaseOrdersSetInput>;
  pkColumns: PurchaseOrdersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePurchaseOrdersManyArgs = {
  updates: Array<PurchaseOrdersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateQboAuthDataArgs = {
  _set?: InputMaybe<QboAuthDataSetInput>;
  where: QboAuthDataBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateQboAuthDataByPkArgs = {
  _set?: InputMaybe<QboAuthDataSetInput>;
  pkColumns: QboAuthDataPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateQboAuthDataManyArgs = {
  updates: Array<QboAuthDataUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateQboCartItemTypeAccountsConfigArgs = {
  _set?: InputMaybe<QboCartItemTypeAccountsConfigSetInput>;
  where: QboCartItemTypeAccountsConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateQboCartItemTypeAccountsConfigByPkArgs = {
  _set?: InputMaybe<QboCartItemTypeAccountsConfigSetInput>;
  pkColumns: QboCartItemTypeAccountsConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateQboCartItemTypeAccountsConfigManyArgs = {
  updates: Array<QboCartItemTypeAccountsConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateQboSyncInfoArgs = {
  _set?: InputMaybe<QboSyncInfoSetInput>;
  where: QboSyncInfoBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateQboSyncInfoByPkArgs = {
  _set?: InputMaybe<QboSyncInfoSetInput>;
  pkColumns: QboSyncInfoPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateQboSyncInfoManyArgs = {
  updates: Array<QboSyncInfoUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecentPricebookItemsArgs = {
  _set?: InputMaybe<RecentPricebookItemsSetInput>;
  where: RecentPricebookItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecentPricebookItemsByPkArgs = {
  _set?: InputMaybe<RecentPricebookItemsSetInput>;
  pkColumns: RecentPricebookItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecentPricebookItemsManyArgs = {
  updates: Array<RecentPricebookItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationAiGenerationInfoArgs = {
  _append?: InputMaybe<RecommendationAiGenerationInfoAppendInput>;
  _deleteAtPath?: InputMaybe<RecommendationAiGenerationInfoDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RecommendationAiGenerationInfoDeleteElemInput>;
  _deleteKey?: InputMaybe<RecommendationAiGenerationInfoDeleteKeyInput>;
  _prepend?: InputMaybe<RecommendationAiGenerationInfoPrependInput>;
  _set?: InputMaybe<RecommendationAiGenerationInfoSetInput>;
  where: RecommendationAiGenerationInfoBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationAiGenerationInfoByPkArgs = {
  _append?: InputMaybe<RecommendationAiGenerationInfoAppendInput>;
  _deleteAtPath?: InputMaybe<RecommendationAiGenerationInfoDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RecommendationAiGenerationInfoDeleteElemInput>;
  _deleteKey?: InputMaybe<RecommendationAiGenerationInfoDeleteKeyInput>;
  _prepend?: InputMaybe<RecommendationAiGenerationInfoPrependInput>;
  _set?: InputMaybe<RecommendationAiGenerationInfoSetInput>;
  pkColumns: RecommendationAiGenerationInfoPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationAiGenerationInfoManyArgs = {
  updates: Array<RecommendationAiGenerationInfoUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationDismissalsArgs = {
  _set?: InputMaybe<RecommendationDismissalsSetInput>;
  where: RecommendationDismissalsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationDismissalsByPkArgs = {
  _set?: InputMaybe<RecommendationDismissalsSetInput>;
  pkColumns: RecommendationDismissalsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationDismissalsManyArgs = {
  updates: Array<RecommendationDismissalsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationInteractionsArgs = {
  _set?: InputMaybe<RecommendationInteractionsSetInput>;
  where: RecommendationInteractionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationInteractionsByPkArgs = {
  _set?: InputMaybe<RecommendationInteractionsSetInput>;
  pkColumns: RecommendationInteractionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationInteractionsManyArgs = {
  updates: Array<RecommendationInteractionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationsArgs = {
  _inc?: InputMaybe<RecommendationsIncInput>;
  _set?: InputMaybe<RecommendationsSetInput>;
  where: RecommendationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationsByPkArgs = {
  _inc?: InputMaybe<RecommendationsIncInput>;
  _set?: InputMaybe<RecommendationsSetInput>;
  pkColumns: RecommendationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationsManyArgs = {
  updates: Array<RecommendationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateReminderAssignmentsArgs = {
  _set?: InputMaybe<ReminderAssignmentsSetInput>;
  where: ReminderAssignmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateReminderAssignmentsByPkArgs = {
  _set?: InputMaybe<ReminderAssignmentsSetInput>;
  pkColumns: ReminderAssignmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateReminderAssignmentsManyArgs = {
  updates: Array<ReminderAssignmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateReminderInternalNotificationsArgs = {
  _set?: InputMaybe<ReminderInternalNotificationsSetInput>;
  where: ReminderInternalNotificationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateReminderInternalNotificationsByPkArgs = {
  _set?: InputMaybe<ReminderInternalNotificationsSetInput>;
  pkColumns: ReminderInternalNotificationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateReminderInternalNotificationsManyArgs = {
  updates: Array<ReminderInternalNotificationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRemindersArgs = {
  _set?: InputMaybe<RemindersSetInput>;
  where: RemindersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRemindersByPkArgs = {
  _set?: InputMaybe<RemindersSetInput>;
  pkColumns: RemindersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRemindersManyArgs = {
  updates: Array<RemindersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRepCompanyMetabaseConfigArgs = {
  _set?: InputMaybe<RepCompanyMetabaseConfigSetInput>;
  where: RepCompanyMetabaseConfigBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRepCompanyMetabaseConfigByPkArgs = {
  _set?: InputMaybe<RepCompanyMetabaseConfigSetInput>;
  pkColumns: RepCompanyMetabaseConfigPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRepCompanyMetabaseConfigManyArgs = {
  updates: Array<RepCompanyMetabaseConfigUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRepMetabaseCompanyReportsArgs = {
  _set?: InputMaybe<RepMetabaseCompanyReportsSetInput>;
  where: RepMetabaseCompanyReportsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRepMetabaseCompanyReportsByPkArgs = {
  _set?: InputMaybe<RepMetabaseCompanyReportsSetInput>;
  pkColumns: RepMetabaseCompanyReportsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRepMetabaseCompanyReportsManyArgs = {
  updates: Array<RepMetabaseCompanyReportsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRepMetabasePulsesArgs = {
  _append?: InputMaybe<RepMetabasePulsesAppendInput>;
  _deleteAtPath?: InputMaybe<RepMetabasePulsesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RepMetabasePulsesDeleteElemInput>;
  _deleteKey?: InputMaybe<RepMetabasePulsesDeleteKeyInput>;
  _inc?: InputMaybe<RepMetabasePulsesIncInput>;
  _prepend?: InputMaybe<RepMetabasePulsesPrependInput>;
  _set?: InputMaybe<RepMetabasePulsesSetInput>;
  where: RepMetabasePulsesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRepMetabasePulsesByPkArgs = {
  _append?: InputMaybe<RepMetabasePulsesAppendInput>;
  _deleteAtPath?: InputMaybe<RepMetabasePulsesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RepMetabasePulsesDeleteElemInput>;
  _deleteKey?: InputMaybe<RepMetabasePulsesDeleteKeyInput>;
  _inc?: InputMaybe<RepMetabasePulsesIncInput>;
  _prepend?: InputMaybe<RepMetabasePulsesPrependInput>;
  _set?: InputMaybe<RepMetabasePulsesSetInput>;
  pkColumns: RepMetabasePulsesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRepMetabasePulsesManyArgs = {
  updates: Array<RepMetabasePulsesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRepMetabasePulsesV2Args = {
  _append?: InputMaybe<RepMetabasePulsesV2AppendInput>;
  _deleteAtPath?: InputMaybe<RepMetabasePulsesV2DeleteAtPathInput>;
  _deleteElem?: InputMaybe<RepMetabasePulsesV2DeleteElemInput>;
  _deleteKey?: InputMaybe<RepMetabasePulsesV2DeleteKeyInput>;
  _inc?: InputMaybe<RepMetabasePulsesV2IncInput>;
  _prepend?: InputMaybe<RepMetabasePulsesV2PrependInput>;
  _set?: InputMaybe<RepMetabasePulsesV2SetInput>;
  where: RepMetabasePulsesV2BoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRepMetabasePulsesV2ByPkArgs = {
  _append?: InputMaybe<RepMetabasePulsesV2AppendInput>;
  _deleteAtPath?: InputMaybe<RepMetabasePulsesV2DeleteAtPathInput>;
  _deleteElem?: InputMaybe<RepMetabasePulsesV2DeleteElemInput>;
  _deleteKey?: InputMaybe<RepMetabasePulsesV2DeleteKeyInput>;
  _inc?: InputMaybe<RepMetabasePulsesV2IncInput>;
  _prepend?: InputMaybe<RepMetabasePulsesV2PrependInput>;
  _set?: InputMaybe<RepMetabasePulsesV2SetInput>;
  pkColumns: RepMetabasePulsesV2PkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRepMetabasePulsesV2ManyArgs = {
  updates: Array<RepMetabasePulsesV2Updates>;
};


/** mutation root */
export type Mutation_RootUpdateRepMetabaseReportDefinitionsArgs = {
  _set?: InputMaybe<RepMetabaseReportDefinitionsSetInput>;
  where: RepMetabaseReportDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRepMetabaseReportDefinitionsByPkArgs = {
  _set?: InputMaybe<RepMetabaseReportDefinitionsSetInput>;
  pkColumns: RepMetabaseReportDefinitionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRepMetabaseReportDefinitionsManyArgs = {
  updates: Array<RepMetabaseReportDefinitionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTagsArgs = {
  _set?: InputMaybe<TagsSetInput>;
  where: TagsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTagsByPkArgs = {
  _set?: InputMaybe<TagsSetInput>;
  pkColumns: TagsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTagsManyArgs = {
  updates: Array<TagsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTechnicianCapacitiesArgs = {
  _set?: InputMaybe<TechnicianCapacitiesSetInput>;
  where: TechnicianCapacitiesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTechnicianCapacitiesByPkArgs = {
  _set?: InputMaybe<TechnicianCapacitiesSetInput>;
  pkColumns: TechnicianCapacitiesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTechnicianCapacitiesManyArgs = {
  updates: Array<TechnicianCapacitiesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTechnicianCapacityBlocksArgs = {
  _set?: InputMaybe<TechnicianCapacityBlocksSetInput>;
  where: TechnicianCapacityBlocksBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTechnicianCapacityBlocksByPkArgs = {
  _set?: InputMaybe<TechnicianCapacityBlocksSetInput>;
  pkColumns: TechnicianCapacityBlocksPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTechnicianCapacityBlocksManyArgs = {
  updates: Array<TechnicianCapacityBlocksUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTilledRawEventsArgs = {
  _append?: InputMaybe<TilledRawEventsAppendInput>;
  _deleteAtPath?: InputMaybe<TilledRawEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<TilledRawEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<TilledRawEventsDeleteKeyInput>;
  _prepend?: InputMaybe<TilledRawEventsPrependInput>;
  _set?: InputMaybe<TilledRawEventsSetInput>;
  where: TilledRawEventsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTilledRawEventsByPkArgs = {
  _append?: InputMaybe<TilledRawEventsAppendInput>;
  _deleteAtPath?: InputMaybe<TilledRawEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<TilledRawEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<TilledRawEventsDeleteKeyInput>;
  _prepend?: InputMaybe<TilledRawEventsPrependInput>;
  _set?: InputMaybe<TilledRawEventsSetInput>;
  pkColumns: TilledRawEventsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTilledRawEventsManyArgs = {
  updates: Array<TilledRawEventsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTimesheetEntriesArgs = {
  _set?: InputMaybe<TimesheetEntriesSetInput>;
  where: TimesheetEntriesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTimesheetEntriesByPkArgs = {
  _set?: InputMaybe<TimesheetEntriesSetInput>;
  pkColumns: TimesheetEntriesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTimesheetEntriesManyArgs = {
  updates: Array<TimesheetEntriesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTimesheetEntryActivitiesArgs = {
  _set?: InputMaybe<TimesheetEntryActivitiesSetInput>;
  where: TimesheetEntryActivitiesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTimesheetEntryActivitiesByPkArgs = {
  _set?: InputMaybe<TimesheetEntryActivitiesSetInput>;
  pkColumns: TimesheetEntryActivitiesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTimesheetEntryActivitiesManyArgs = {
  updates: Array<TimesheetEntryActivitiesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTimesheetEntryLinkDataArgs = {
  _set?: InputMaybe<TimesheetEntryLinkDataSetInput>;
  where: TimesheetEntryLinkDataBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTimesheetEntryLinkDataByPkArgs = {
  _set?: InputMaybe<TimesheetEntryLinkDataSetInput>;
  pkColumns: TimesheetEntryLinkDataPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTimesheetEntryLinkDataManyArgs = {
  updates: Array<TimesheetEntryLinkDataUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTuneUpVisitEntitlementsArgs = {
  _append?: InputMaybe<TuneUpVisitEntitlementsAppendInput>;
  _deleteAtPath?: InputMaybe<TuneUpVisitEntitlementsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<TuneUpVisitEntitlementsDeleteElemInput>;
  _deleteKey?: InputMaybe<TuneUpVisitEntitlementsDeleteKeyInput>;
  _prepend?: InputMaybe<TuneUpVisitEntitlementsPrependInput>;
  _set?: InputMaybe<TuneUpVisitEntitlementsSetInput>;
  where: TuneUpVisitEntitlementsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTuneUpVisitEntitlementsByPkArgs = {
  _append?: InputMaybe<TuneUpVisitEntitlementsAppendInput>;
  _deleteAtPath?: InputMaybe<TuneUpVisitEntitlementsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<TuneUpVisitEntitlementsDeleteElemInput>;
  _deleteKey?: InputMaybe<TuneUpVisitEntitlementsDeleteKeyInput>;
  _prepend?: InputMaybe<TuneUpVisitEntitlementsPrependInput>;
  _set?: InputMaybe<TuneUpVisitEntitlementsSetInput>;
  pkColumns: TuneUpVisitEntitlementsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTuneUpVisitEntitlementsManyArgs = {
  updates: Array<TuneUpVisitEntitlementsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserBusinessUnitsArgs = {
  _set?: InputMaybe<UserBusinessUnitsSetInput>;
  where: UserBusinessUnitsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserBusinessUnitsByPkArgs = {
  _set?: InputMaybe<UserBusinessUnitsSetInput>;
  pkColumns: UserBusinessUnitsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserBusinessUnitsManyArgs = {
  updates: Array<UserBusinessUnitsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserPhoneNumbersArgs = {
  _set?: InputMaybe<UserPhoneNumbersSetInput>;
  where: UserPhoneNumbersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserPhoneNumbersByPkArgs = {
  _set?: InputMaybe<UserPhoneNumbersSetInput>;
  pkColumns: UserPhoneNumbersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserPhoneNumbersManyArgs = {
  updates: Array<UserPhoneNumbersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserSettingsArgs = {
  _set?: InputMaybe<UserSettingsSetInput>;
  where: UserSettingsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserSettingsByPkArgs = {
  _set?: InputMaybe<UserSettingsSetInput>;
  pkColumns: UserSettingsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserSettingsManyArgs = {
  updates: Array<UserSettingsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserWagesArgs = {
  _inc?: InputMaybe<UserWagesIncInput>;
  _set?: InputMaybe<UserWagesSetInput>;
  where: UserWagesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserWagesByPkArgs = {
  _inc?: InputMaybe<UserWagesIncInput>;
  _set?: InputMaybe<UserWagesSetInput>;
  pkColumns: UserWagesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserWagesManyArgs = {
  updates: Array<UserWagesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _set?: InputMaybe<UsersSetInput>;
  where: UsersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUsersByPkArgs = {
  _set?: InputMaybe<UsersSetInput>;
  pkColumns: UsersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUsersManyArgs = {
  updates: Array<UsersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateWisetackLoanRecordsArgs = {
  _inc?: InputMaybe<WisetackLoanRecordsIncInput>;
  _set?: InputMaybe<WisetackLoanRecordsSetInput>;
  where: WisetackLoanRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateWisetackLoanRecordsByPkArgs = {
  _inc?: InputMaybe<WisetackLoanRecordsIncInput>;
  _set?: InputMaybe<WisetackLoanRecordsSetInput>;
  pkColumns: WisetackLoanRecordsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateWisetackLoanRecordsManyArgs = {
  updates: Array<WisetackLoanRecordsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateWisetackLoanStatusesArgs = {
  _set?: InputMaybe<WisetackLoanStatusesSetInput>;
  where: WisetackLoanStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateWisetackLoanStatusesByPkArgs = {
  _set?: InputMaybe<WisetackLoanStatusesSetInput>;
  pkColumns: WisetackLoanStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateWisetackLoanStatusesManyArgs = {
  updates: Array<WisetackLoanStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateWisetackPrequalRecordsArgs = {
  _inc?: InputMaybe<WisetackPrequalRecordsIncInput>;
  _set?: InputMaybe<WisetackPrequalRecordsSetInput>;
  where: WisetackPrequalRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateWisetackPrequalRecordsByPkArgs = {
  _inc?: InputMaybe<WisetackPrequalRecordsIncInput>;
  _set?: InputMaybe<WisetackPrequalRecordsSetInput>;
  pkColumns: WisetackPrequalRecordsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateWisetackPrequalRecordsManyArgs = {
  updates: Array<WisetackPrequalRecordsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateWisetackWebhookEventsArgs = {
  _append?: InputMaybe<WisetackWebhookEventsAppendInput>;
  _deleteAtPath?: InputMaybe<WisetackWebhookEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<WisetackWebhookEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<WisetackWebhookEventsDeleteKeyInput>;
  _prepend?: InputMaybe<WisetackWebhookEventsPrependInput>;
  _set?: InputMaybe<WisetackWebhookEventsSetInput>;
  where: WisetackWebhookEventsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateWisetackWebhookEventsByPkArgs = {
  _append?: InputMaybe<WisetackWebhookEventsAppendInput>;
  _deleteAtPath?: InputMaybe<WisetackWebhookEventsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<WisetackWebhookEventsDeleteElemInput>;
  _deleteKey?: InputMaybe<WisetackWebhookEventsDeleteKeyInput>;
  _prepend?: InputMaybe<WisetackWebhookEventsPrependInput>;
  _set?: InputMaybe<WisetackWebhookEventsSetInput>;
  pkColumns: WisetackWebhookEventsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateWisetackWebhookEventsManyArgs = {
  updates: Array<WisetackWebhookEventsUpdates>;
};

export type NoteAttachmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<NoteAttachmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NoteAttachmentsBoolExp>;
  predicate: IntComparisonExp;
};

export type NoteLinksAggregateBoolExpBool_And = {
  arguments: NoteLinksSelectColumnNoteLinksAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NoteLinksBoolExp>;
  predicate: BooleanComparisonExp;
};

export type NoteLinksAggregateBoolExpBool_Or = {
  arguments: NoteLinksSelectColumnNoteLinksAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NoteLinksBoolExp>;
  predicate: BooleanComparisonExp;
};

export type NoteLinksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<NoteLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NoteLinksBoolExp>;
  predicate: IntComparisonExp;
};

export type NoteTaggedUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<NoteTaggedUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NoteTaggedUsersBoolExp>;
  predicate: IntComparisonExp;
};

export type NotesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<NotesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NotesBoolExp>;
  predicate: IntComparisonExp;
};

export type OnlineBookingServiceAreaZipCodesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<OnlineBookingServiceAreaZipCodesBoolExp>;
  predicate: IntComparisonExp;
};

export type OnlineBookingServiceTypeBookableJobTypesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesBoolExp>;
  predicate: IntComparisonExp;
};

export type OnlineBookingServiceTypeBookableTechniciansAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansBoolExp>;
  predicate: IntComparisonExp;
};

export type OnlineBookingServiceTypeConfigsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OnlineBookingServiceTypeConfigsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<OnlineBookingServiceTypeConfigsBoolExp>;
  predicate: IntComparisonExp;
};

export type PaymentLinksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PaymentLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PaymentLinksBoolExp>;
  predicate: IntComparisonExp;
};

export type PaymentRecordsAggregateBoolExpBool_And = {
  arguments: PaymentRecordsSelectColumnPaymentRecordsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PaymentRecordsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PaymentRecordsAggregateBoolExpBool_Or = {
  arguments: PaymentRecordsSelectColumnPaymentRecordsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PaymentRecordsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PaymentRecordsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PaymentRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PaymentRecordsBoolExp>;
  predicate: IntComparisonExp;
};

export type PaymentRefundsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PaymentRefundsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PaymentRefundsBoolExp>;
  predicate: IntComparisonExp;
};

export type PaymentStatusesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PaymentStatusesBoolExp>;
  predicate: IntComparisonExp;
};

export type PaymentSubscriptionStatusesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PaymentSubscriptionStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PaymentSubscriptionStatusesBoolExp>;
  predicate: IntComparisonExp;
};

export type PaymentSubscriptionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PaymentSubscriptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PaymentSubscriptionsBoolExp>;
  predicate: IntComparisonExp;
};

export type PayoutItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PayoutItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PayoutItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type PhotoLinksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PhotoLinksBoolExp>;
  predicate: IntComparisonExp;
};

export type PricebookCategoriesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PricebookCategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PricebookCategoriesBoolExp>;
  predicate: IntComparisonExp;
};

export type PricebookItemsAggregateBoolExpBool_And = {
  arguments: PricebookItemsSelectColumnPricebookItemsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PricebookItemsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PricebookItemsAggregateBoolExpBool_Or = {
  arguments: PricebookItemsSelectColumnPricebookItemsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PricebookItemsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PricebookItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PricebookItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PricebookItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type PricebookTaxRatesAggregateBoolExpBool_And = {
  arguments: PricebookTaxRatesSelectColumnPricebookTaxRatesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PricebookTaxRatesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PricebookTaxRatesAggregateBoolExpBool_Or = {
  arguments: PricebookTaxRatesSelectColumnPricebookTaxRatesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PricebookTaxRatesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PricebookTaxRatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PricebookTaxRatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PricebookTaxRatesBoolExp>;
  predicate: IntComparisonExp;
};

export type PurchaseOrdersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PurchaseOrdersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<PurchaseOrdersBoolExp>;
  predicate: IntComparisonExp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "acc_cart_item_type_accounts_config" */
  accCartItemTypeAccountsConfig: Array<AccCartItemTypeAccountsConfig>;
  /** fetch aggregated fields from the table: "acc_cart_item_type_accounts_config" */
  accCartItemTypeAccountsConfigAggregate: AccCartItemTypeAccountsConfigAggregate;
  /** fetch data from the table: "acc_cart_item_type_accounts_config" using primary key columns */
  accCartItemTypeAccountsConfigByPk?: Maybe<AccCartItemTypeAccountsConfig>;
  /** fetch data from the table: "acc_company_config" */
  accCompanyConfig: Array<AccCompanyConfig>;
  /** fetch aggregated fields from the table: "acc_company_config" */
  accCompanyConfigAggregate: AccCompanyConfigAggregate;
  /** fetch data from the table: "acc_company_config" using primary key columns */
  accCompanyConfigByPk?: Maybe<AccCompanyConfig>;
  /** fetch data from the table: "acc_payout_accounts_config" */
  accPayoutAccountsConfig: Array<AccPayoutAccountsConfig>;
  /** fetch aggregated fields from the table: "acc_payout_accounts_config" */
  accPayoutAccountsConfigAggregate: AccPayoutAccountsConfigAggregate;
  /** fetch data from the table: "acc_payout_accounts_config" using primary key columns */
  accPayoutAccountsConfigByPk?: Maybe<AccPayoutAccountsConfig>;
  /** fetch data from the table: "acc_qbd_conductor_config" */
  accQbdConductorConfig: Array<AccQbdConductorConfig>;
  /** fetch aggregated fields from the table: "acc_qbd_conductor_config" */
  accQbdConductorConfigAggregate: AccQbdConductorConfigAggregate;
  /** fetch data from the table: "acc_qbd_conductor_config" using primary key columns */
  accQbdConductorConfigByPk?: Maybe<AccQbdConductorConfig>;
  /** fetch data from the table: "acc_qbd_conductor_uptime" */
  accQbdConductorUptime: Array<AccQbdConductorUptime>;
  /** fetch aggregated fields from the table: "acc_qbd_conductor_uptime" */
  accQbdConductorUptimeAggregate: AccQbdConductorUptimeAggregate;
  /** fetch data from the table: "acc_qbd_conductor_uptime" using primary key columns */
  accQbdConductorUptimeByPk?: Maybe<AccQbdConductorUptime>;
  /** fetch data from the table: "acc_sync_info" */
  accSyncInfo: Array<AccSyncInfo>;
  /** fetch aggregated fields from the table: "acc_sync_info" */
  accSyncInfoAggregate: AccSyncInfoAggregate;
  /** fetch data from the table: "acc_sync_info" using primary key columns */
  accSyncInfoByPk?: Maybe<AccSyncInfo>;
  /** fetch data from the table: "acc_sync_queue_items" */
  accSyncQueueItems: Array<AccSyncQueueItems>;
  /** fetch aggregated fields from the table: "acc_sync_queue_items" */
  accSyncQueueItemsAggregate: AccSyncQueueItemsAggregate;
  /** fetch data from the table: "acc_sync_queue_items" using primary key columns */
  accSyncQueueItemsByPk?: Maybe<AccSyncQueueItems>;
  /** An array relationship */
  accountContacts: Array<AccountContacts>;
  /** An aggregate relationship */
  accountContactsAggregate: AccountContactsAggregate;
  /** fetch data from the table: "account_contacts" using primary key columns */
  accountContactsByPk?: Maybe<AccountContacts>;
  /** fetch data from the table: "account_job_counts" */
  accountJobCounts: Array<AccountJobCounts>;
  /** An array relationship */
  accountLocations: Array<AccountLocations>;
  /** An aggregate relationship */
  accountLocationsAggregate: AccountLocationsAggregate;
  /** fetch data from the table: "account_locations" using primary key columns */
  accountLocationsByPk?: Maybe<AccountLocations>;
  /** An array relationship */
  accountReminders: Array<AccountReminders>;
  /** An aggregate relationship */
  accountRemindersAggregate: AccountRemindersAggregate;
  /** fetch data from the table: "account_reminders" using primary key columns */
  accountRemindersByPk?: Maybe<AccountReminders>;
  /** fetch data from the table: "account_statement_events" */
  accountStatementEvents: Array<AccountStatementEvents>;
  /** fetch aggregated fields from the table: "account_statement_events" */
  accountStatementEventsAggregate: AccountStatementEventsAggregate;
  /** fetch data from the table: "account_statement_events" using primary key columns */
  accountStatementEventsByPk?: Maybe<AccountStatementEvents>;
  /** fetch data from the table: "account_tags" */
  accountTags: Array<AccountTags>;
  /** fetch aggregated fields from the table: "account_tags" */
  accountTagsAggregate: AccountTagsAggregate;
  /** fetch data from the table: "account_tags" using primary key columns */
  accountTagsByPk?: Maybe<AccountTags>;
  /** fetch data from the table: "account_types" */
  accountTypes: Array<AccountTypes>;
  /** fetch aggregated fields from the table: "account_types" */
  accountTypesAggregate: AccountTypesAggregate;
  /** fetch data from the table: "account_types" using primary key columns */
  accountTypesByPk?: Maybe<AccountTypes>;
  /** An array relationship */
  accounts: Array<Accounts>;
  /** An aggregate relationship */
  accountsAggregate: AccountsAggregate;
  /** fetch data from the table: "accounts" using primary key columns */
  accountsByPk?: Maybe<Accounts>;
  /** fetch data from the table: "accounts_receivable" */
  accountsReceivable: Array<AccountsReceivable>;
  /** fetch aggregated fields from the table: "accounts_receivable" */
  accountsReceivableAggregate: AccountsReceivableAggregate;
  /** execute function "accounts_sorted_by_job_count" which returns "accounts" */
  accountsSortedByJobCount: Array<Accounts>;
  /** execute function "accounts_sorted_by_job_count" and query aggregates on result of table type "accounts" */
  accountsSortedByJobCountAggregate: AccountsAggregate;
  /** execute function "accounts_sorted_by_recently_viewed_for_user" which returns "accounts" */
  accountsSortedByRecentlyViewedForUser: Array<Accounts>;
  /** execute function "accounts_sorted_by_recently_viewed_for_user" and query aggregates on result of table type "accounts" */
  accountsSortedByRecentlyViewedForUserAggregate: AccountsAggregate;
  /** fetch data from the table: "accounts_viewed_by_user" */
  accountsViewedByUser: Array<AccountsViewedByUser>;
  /** fetch aggregated fields from the table: "accounts_viewed_by_user" */
  accountsViewedByUserAggregate: AccountsViewedByUserAggregate;
  /** fetch data from the table: "accounts_viewed_by_user" using primary key columns */
  accountsViewedByUserByPk?: Maybe<AccountsViewedByUser>;
  /** An array relationship */
  activityItems: Array<ActivityItems>;
  /** An aggregate relationship */
  activityItemsAggregate: ActivityItemsAggregate;
  /** fetch data from the table: "activity_items" using primary key columns */
  activityItemsByPk?: Maybe<ActivityItems>;
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch aggregated fields from the table: "addresses" */
  addressesAggregate: AddressesAggregate;
  /** fetch data from the table: "addresses" using primary key columns */
  addressesByPk?: Maybe<Addresses>;
  /** fetch data from the table: "aggregatable_invoices" */
  aggregatableInvoices: Array<AggregatableInvoices>;
  /** fetch aggregated fields from the table: "aggregatable_invoices" */
  aggregatableInvoicesAggregate: AggregatableInvoicesAggregate;
  /** fetch data from the table: "application_tasks" */
  applicationTasks: Array<ApplicationTasks>;
  /** fetch aggregated fields from the table: "application_tasks" */
  applicationTasksAggregate: ApplicationTasksAggregate;
  /** fetch data from the table: "application_tasks" using primary key columns */
  applicationTasksByPk?: Maybe<ApplicationTasks>;
  /** fetch data from the table: "appointment_checklist_association_rules" */
  appointmentChecklistAssociationRules: Array<AppointmentChecklistAssociationRules>;
  /** fetch aggregated fields from the table: "appointment_checklist_association_rules" */
  appointmentChecklistAssociationRulesAggregate: AppointmentChecklistAssociationRulesAggregate;
  /** fetch data from the table: "appointment_checklist_association_rules" using primary key columns */
  appointmentChecklistAssociationRulesByPk?: Maybe<AppointmentChecklistAssociationRules>;
  /** An array relationship */
  appointmentChecklistInstances: Array<AppointmentChecklistInstances>;
  /** An aggregate relationship */
  appointmentChecklistInstancesAggregate: AppointmentChecklistInstancesAggregate;
  /** fetch data from the table: "appointment_checklist_instances" using primary key columns */
  appointmentChecklistInstancesByPk?: Maybe<AppointmentChecklistInstances>;
  /** fetch data from the table: "appointment_checklists" */
  appointmentChecklists: Array<AppointmentChecklists>;
  /** fetch aggregated fields from the table: "appointment_checklists" */
  appointmentChecklistsAggregate: AppointmentChecklistsAggregate;
  /** fetch data from the table: "appointment_checklists" using primary key columns */
  appointmentChecklistsByPk?: Maybe<AppointmentChecklists>;
  /** An array relationship */
  assistantIntegratedPhones: Array<AssistantIntegratedPhones>;
  /** An aggregate relationship */
  assistantIntegratedPhonesAggregate: AssistantIntegratedPhonesAggregate;
  /** fetch data from the table: "assistant_integrated_phones" using primary key columns */
  assistantIntegratedPhonesByPk?: Maybe<AssistantIntegratedPhones>;
  /** fetch data from the table: "assistant_phone_settings" */
  assistantPhoneSettings: Array<AssistantPhoneSettings>;
  /** fetch aggregated fields from the table: "assistant_phone_settings" */
  assistantPhoneSettingsAggregate: AssistantPhoneSettingsAggregate;
  /** fetch data from the table: "assistant_phone_settings" using primary key columns */
  assistantPhoneSettingsByPk?: Maybe<AssistantPhoneSettings>;
  /** fetch data from the table: "assistants" */
  assistants: Array<Assistants>;
  /** fetch aggregated fields from the table: "assistants" */
  assistantsAggregate: AssistantsAggregate;
  /** fetch data from the table: "assistants" using primary key columns */
  assistantsByPk?: Maybe<Assistants>;
  /** fetch data from the table: "billing_profile_hidden_payment_methods" */
  billingProfileHiddenPaymentMethods: Array<BillingProfileHiddenPaymentMethods>;
  /** fetch aggregated fields from the table: "billing_profile_hidden_payment_methods" */
  billingProfileHiddenPaymentMethodsAggregate: BillingProfileHiddenPaymentMethodsAggregate;
  /** fetch data from the table: "billing_profile_hidden_payment_methods" using primary key columns */
  billingProfileHiddenPaymentMethodsByPk?: Maybe<BillingProfileHiddenPaymentMethods>;
  /** fetch data from the table: "billing_profiles" */
  billingProfiles: Array<BillingProfiles>;
  /** fetch aggregated fields from the table: "billing_profiles" */
  billingProfilesAggregate: BillingProfilesAggregate;
  /** fetch data from the table: "billing_profiles" using primary key columns */
  billingProfilesByPk?: Maybe<BillingProfiles>;
  /** fetch data from the table: "business_events" */
  businessEvents: Array<BusinessEvents>;
  /** fetch aggregated fields from the table: "business_events" */
  businessEventsAggregate: BusinessEventsAggregate;
  /** fetch data from the table: "business_events" using primary key columns */
  businessEventsByPk?: Maybe<BusinessEvents>;
  /** fetch data from the table: "business_unit_target_metrics" */
  businessUnitTargetMetrics: Array<BusinessUnitTargetMetrics>;
  /** fetch aggregated fields from the table: "business_unit_target_metrics" */
  businessUnitTargetMetricsAggregate: BusinessUnitTargetMetricsAggregate;
  /** fetch data from the table: "business_unit_target_metrics" using primary key columns */
  businessUnitTargetMetricsByPk?: Maybe<BusinessUnitTargetMetrics>;
  /** fetch data from the table: "business_units" */
  businessUnits: Array<BusinessUnits>;
  /** fetch aggregated fields from the table: "business_units" */
  businessUnitsAggregate: BusinessUnitsAggregate;
  /** fetch data from the table: "business_units" using primary key columns */
  businessUnitsByPk?: Maybe<BusinessUnits>;
  /** fetch data from the table: "canonical_lead_sources" */
  canonicalLeadSources: Array<CanonicalLeadSources>;
  /** fetch aggregated fields from the table: "canonical_lead_sources" */
  canonicalLeadSourcesAggregate: CanonicalLeadSourcesAggregate;
  /** fetch data from the table: "canonical_lead_sources" using primary key columns */
  canonicalLeadSourcesByPk?: Maybe<CanonicalLeadSources>;
  /** fetch data from the table: "cart_item_job_cost_links" */
  cartItemJobCostLinks: Array<CartItemJobCostLinks>;
  /** fetch aggregated fields from the table: "cart_item_job_cost_links" */
  cartItemJobCostLinksAggregate: CartItemJobCostLinksAggregate;
  /** fetch data from the table: "cart_item_job_cost_links" using primary key columns */
  cartItemJobCostLinksByPk?: Maybe<CartItemJobCostLinks>;
  /** fetch data from the table: "cart_items" */
  cartItems: Array<CartItems>;
  /** fetch aggregated fields from the table: "cart_items" */
  cartItemsAggregate: CartItemsAggregate;
  /** fetch data from the table: "cart_items" using primary key columns */
  cartItemsByPk?: Maybe<CartItems>;
  /** fetch data from the table: "checklist_items" */
  checklistItems: Array<ChecklistItems>;
  /** fetch aggregated fields from the table: "checklist_items" */
  checklistItemsAggregate: ChecklistItemsAggregate;
  /** fetch data from the table: "checklist_items" using primary key columns */
  checklistItemsByPk?: Maybe<ChecklistItems>;
  /** fetch data from the table: "companies" */
  companies: Array<Companies>;
  /** fetch aggregated fields from the table: "companies" */
  companiesAggregate: CompaniesAggregate;
  /** fetch data from the table: "companies" using primary key columns */
  companiesByPk?: Maybe<Companies>;
  /** An array relationship */
  companyAppointmentArrivalWindows: Array<CompanyAppointmentArrivalWindows>;
  /** An aggregate relationship */
  companyAppointmentArrivalWindowsAggregate: CompanyAppointmentArrivalWindowsAggregate;
  /** fetch data from the table: "company_appointment_arrival_windows" using primary key columns */
  companyAppointmentArrivalWindowsByPk?: Maybe<CompanyAppointmentArrivalWindows>;
  /** fetch data from the table: "company_commission_config" */
  companyCommissionConfig: Array<CompanyCommissionConfig>;
  /** fetch aggregated fields from the table: "company_commission_config" */
  companyCommissionConfigAggregate: CompanyCommissionConfigAggregate;
  /** fetch data from the table: "company_commission_config" using primary key columns */
  companyCommissionConfigByPk?: Maybe<CompanyCommissionConfig>;
  /** fetch data from the table: "company_config" */
  companyConfig: Array<CompanyConfig>;
  /** fetch aggregated fields from the table: "company_config" */
  companyConfigAggregate: CompanyConfigAggregate;
  /** fetch data from the table: "company_config" using primary key columns */
  companyConfigByPk?: Maybe<CompanyConfig>;
  /** fetch data from the table: "company_drip_marketing_config" */
  companyDripMarketingConfig: Array<CompanyDripMarketingConfig>;
  /** fetch aggregated fields from the table: "company_drip_marketing_config" */
  companyDripMarketingConfigAggregate: CompanyDripMarketingConfigAggregate;
  /** fetch data from the table: "company_drip_marketing_config" using primary key columns */
  companyDripMarketingConfigByPk?: Maybe<CompanyDripMarketingConfig>;
  /** An array relationship */
  companyLeadSourceLinks: Array<CompanyLeadSourceLinks>;
  /** An aggregate relationship */
  companyLeadSourceLinksAggregate: CompanyLeadSourceLinksAggregate;
  /** fetch data from the table: "company_lead_source_links" using primary key columns */
  companyLeadSourceLinksByPk?: Maybe<CompanyLeadSourceLinks>;
  /** An array relationship */
  companyLeadSources: Array<CompanyLeadSources>;
  /** An aggregate relationship */
  companyLeadSourcesAggregate: CompanyLeadSourcesAggregate;
  /** fetch data from the table: "company_lead_sources" using primary key columns */
  companyLeadSourcesByPk?: Maybe<CompanyLeadSources>;
  /** An array relationship */
  companyNotificationSettings: Array<CompanyNotificationSettings>;
  /** An aggregate relationship */
  companyNotificationSettingsAggregate: CompanyNotificationSettingsAggregate;
  /** fetch data from the table: "company_notification_settings" using primary key columns */
  companyNotificationSettingsByPk?: Maybe<CompanyNotificationSettings>;
  /** fetch data from the table: "company_pricing_tier_config" */
  companyPricingTierConfig: Array<CompanyPricingTierConfig>;
  /** fetch aggregated fields from the table: "company_pricing_tier_config" */
  companyPricingTierConfigAggregate: CompanyPricingTierConfigAggregate;
  /** fetch data from the table: "company_pricing_tier_config" using primary key columns */
  companyPricingTierConfigByPk?: Maybe<CompanyPricingTierConfig>;
  /** An array relationship */
  companyReviewLinks: Array<CompanyReviewLinks>;
  /** An aggregate relationship */
  companyReviewLinksAggregate: CompanyReviewLinksAggregate;
  /** fetch data from the table: "company_review_links" using primary key columns */
  companyReviewLinksByPk?: Maybe<CompanyReviewLinks>;
  /** fetch data from the table: "company_roles" */
  companyRoles: Array<CompanyRoles>;
  /** fetch aggregated fields from the table: "company_roles" */
  companyRolesAggregate: CompanyRolesAggregate;
  /** fetch data from the table: "company_roles" using primary key columns */
  companyRolesByPk?: Maybe<CompanyRoles>;
  /** fetch data from the table: "company_tax_configurations" */
  companyTaxConfigurations: Array<CompanyTaxConfigurations>;
  /** fetch aggregated fields from the table: "company_tax_configurations" */
  companyTaxConfigurationsAggregate: CompanyTaxConfigurationsAggregate;
  /** fetch data from the table: "company_tax_configurations" using primary key columns */
  companyTaxConfigurationsByPk?: Maybe<CompanyTaxConfigurations>;
  /** An array relationship */
  companyUsers: Array<CompanyUsers>;
  /** An aggregate relationship */
  companyUsersAggregate: CompanyUsersAggregate;
  /** fetch data from the table: "company_users" using primary key columns */
  companyUsersByPk?: Maybe<CompanyUsers>;
  /** fetch data from the table: "company_working_display_hours" */
  companyWorkingDisplayHours: Array<CompanyWorkingDisplayHours>;
  /** fetch aggregated fields from the table: "company_working_display_hours" */
  companyWorkingDisplayHoursAggregate: CompanyWorkingDisplayHoursAggregate;
  /** fetch data from the table: "company_working_display_hours" using primary key columns */
  companyWorkingDisplayHoursByPk?: Maybe<CompanyWorkingDisplayHours>;
  /** An array relationship */
  contacts: Array<Contacts>;
  /** An aggregate relationship */
  contactsAggregate: ContactsAggregate;
  /** fetch data from the table: "contacts" using primary key columns */
  contactsByPk?: Maybe<Contacts>;
  /** fetch data from the table: "cron_jobs" */
  cronJobs: Array<CronJobs>;
  /** fetch aggregated fields from the table: "cron_jobs" */
  cronJobsAggregate: CronJobsAggregate;
  /** fetch data from the table: "cron_jobs" using primary key columns */
  cronJobsByPk?: Maybe<CronJobs>;
  /** fetch data from the table: "current_business_unit_target_metrics_view" */
  currentBusinessUnitTargetMetricsView: Array<CurrentBusinessUnitTargetMetricsView>;
  /** fetch aggregated fields from the table: "current_business_unit_target_metrics_view" */
  currentBusinessUnitTargetMetricsViewAggregate: CurrentBusinessUnitTargetMetricsViewAggregate;
  /** fetch data from the table: "current_company_tax_configurations_view" */
  currentCompanyTaxConfigurationsView: Array<CurrentCompanyTaxConfigurationsView>;
  /** fetch aggregated fields from the table: "current_company_tax_configurations_view" */
  currentCompanyTaxConfigurationsViewAggregate: CurrentCompanyTaxConfigurationsViewAggregate;
  /** fetch data from the table: "current_user_business_units_view" */
  currentUserBusinessUnitsView: Array<CurrentUserBusinessUnitsView>;
  /** fetch aggregated fields from the table: "current_user_business_units_view" */
  currentUserBusinessUnitsViewAggregate: CurrentUserBusinessUnitsViewAggregate;
  /** fetch data from the table: "customer_communication_templates" */
  customerCommunicationTemplates: Array<CustomerCommunicationTemplates>;
  /** fetch aggregated fields from the table: "customer_communication_templates" */
  customerCommunicationTemplatesAggregate: CustomerCommunicationTemplatesAggregate;
  /** fetch data from the table: "customer_communication_templates" using primary key columns */
  customerCommunicationTemplatesByPk?: Maybe<CustomerCommunicationTemplates>;
  /** fetch data from the table: "discount_entitlements" */
  discountEntitlements: Array<DiscountEntitlements>;
  /** fetch aggregated fields from the table: "discount_entitlements" */
  discountEntitlementsAggregate: DiscountEntitlementsAggregate;
  /** fetch data from the table: "discount_entitlements" using primary key columns */
  discountEntitlementsByPk?: Maybe<DiscountEntitlements>;
  /** fetch data from the table: "display_id_counters" */
  displayIdCounters: Array<DisplayIdCounters>;
  /** fetch aggregated fields from the table: "display_id_counters" */
  displayIdCountersAggregate: DisplayIdCountersAggregate;
  /** fetch data from the table: "display_id_counters" using primary key columns */
  displayIdCountersByPk?: Maybe<DisplayIdCounters>;
  /** fetch data from the table: "drip_marketing_emails" */
  dripMarketingEmails: Array<DripMarketingEmails>;
  /** fetch aggregated fields from the table: "drip_marketing_emails" */
  dripMarketingEmailsAggregate: DripMarketingEmailsAggregate;
  /** fetch data from the table: "drip_marketing_emails" using primary key columns */
  dripMarketingEmailsByPk?: Maybe<DripMarketingEmails>;
  /** fetch data from the table: "email_addresses" */
  emailAddresses: Array<EmailAddresses>;
  /** fetch aggregated fields from the table: "email_addresses" */
  emailAddressesAggregate: EmailAddressesAggregate;
  /** fetch data from the table: "email_addresses" using primary key columns */
  emailAddressesByPk?: Maybe<EmailAddresses>;
  /** fetch data from the table: "entitlements" */
  entitlements: Array<Entitlements>;
  /** fetch aggregated fields from the table: "entitlements" */
  entitlementsAggregate: EntitlementsAggregate;
  /** fetch data from the table: "entitlements" using primary key columns */
  entitlementsByPk?: Maybe<Entitlements>;
  /** fetch data from the table: "equipment_type_links" */
  equipmentTypeLinks: Array<EquipmentTypeLinks>;
  /** fetch aggregated fields from the table: "equipment_type_links" */
  equipmentTypeLinksAggregate: EquipmentTypeLinksAggregate;
  /** fetch data from the table: "equipment_type_links" using primary key columns */
  equipmentTypeLinksByPk?: Maybe<EquipmentTypeLinks>;
  /** fetch data from the table: "equipment_types" */
  equipmentTypes: Array<EquipmentTypes>;
  /** fetch aggregated fields from the table: "equipment_types" */
  equipmentTypesAggregate: EquipmentTypesAggregate;
  /** fetch data from the table: "equipment_types" using primary key columns */
  equipmentTypesByPk?: Maybe<EquipmentTypes>;
  /** fetch data from the table: "estimate_invoices" */
  estimateInvoices: Array<EstimateInvoices>;
  /** fetch aggregated fields from the table: "estimate_invoices" */
  estimateInvoicesAggregate: EstimateInvoicesAggregate;
  /** fetch data from the table: "estimate_invoices" using primary key columns */
  estimateInvoicesByPk?: Maybe<EstimateInvoices>;
  /** An array relationship */
  estimateOptionCartItems: Array<EstimateOptionCartItems>;
  /** An aggregate relationship */
  estimateOptionCartItemsAggregate: EstimateOptionCartItemsAggregate;
  /** fetch data from the table: "estimate_option_cart_items" using primary key columns */
  estimateOptionCartItemsByPk?: Maybe<EstimateOptionCartItems>;
  /** An array relationship */
  estimateOptionDiscounts: Array<EstimateOptionDiscounts>;
  /** An aggregate relationship */
  estimateOptionDiscountsAggregate: EstimateOptionDiscountsAggregate;
  /** fetch data from the table: "estimate_option_discounts" using primary key columns */
  estimateOptionDiscountsByPk?: Maybe<EstimateOptionDiscounts>;
  /** fetch data from the table: "estimate_option_tax_configurations_view" */
  estimateOptionTaxConfigurationsView: Array<EstimateOptionTaxConfigurationsView>;
  /** fetch aggregated fields from the table: "estimate_option_tax_configurations_view" */
  estimateOptionTaxConfigurationsViewAggregate: EstimateOptionTaxConfigurationsViewAggregate;
  /** An array relationship */
  estimateOptions: Array<EstimateOptions>;
  /** An aggregate relationship */
  estimateOptionsAggregate: EstimateOptionsAggregate;
  /** fetch data from the table: "estimate_options" using primary key columns */
  estimateOptionsByPk?: Maybe<EstimateOptions>;
  /** An array relationship */
  estimatePhotos: Array<EstimatePhotos>;
  /** An aggregate relationship */
  estimatePhotosAggregate: EstimatePhotosAggregate;
  /** fetch data from the table: "estimate_photos" using primary key columns */
  estimatePhotosByPk?: Maybe<EstimatePhotos>;
  /** fetch data from the table: "estimate_templates" */
  estimateTemplates: Array<EstimateTemplates>;
  /** fetch aggregated fields from the table: "estimate_templates" */
  estimateTemplatesAggregate: EstimateTemplatesAggregate;
  /** fetch data from the table: "estimate_templates" using primary key columns */
  estimateTemplatesByPk?: Maybe<EstimateTemplates>;
  /** An array relationship */
  estimates: Array<Estimates>;
  /** An aggregate relationship */
  estimatesAggregate: EstimatesAggregate;
  /** fetch data from the table: "estimates" using primary key columns */
  estimatesByPk?: Maybe<Estimates>;
  /** fetch data from the table: "estimates_queryable" */
  estimatesQueryable: Array<EstimatesQueryable>;
  /** fetch aggregated fields from the table: "estimates_queryable" */
  estimatesQueryableAggregate: EstimatesQueryableAggregate;
  /** fetch data from the table: "estimates_queryable" using primary key columns */
  estimatesQueryableByPk?: Maybe<EstimatesQueryable>;
  /** fetch data from the table: "event_store" */
  eventStore: Array<EventStore>;
  /** fetch aggregated fields from the table: "event_store" */
  eventStoreAggregate: EventStoreAggregate;
  /** fetch data from the table: "event_store" using primary key columns */
  eventStoreByPk?: Maybe<EventStore>;
  /** fetch data from the table: "favorite_pricebook_items" */
  favoritePricebookItems: Array<FavoritePricebookItems>;
  /** fetch aggregated fields from the table: "favorite_pricebook_items" */
  favoritePricebookItemsAggregate: FavoritePricebookItemsAggregate;
  /** fetch data from the table: "favorite_pricebook_items" using primary key columns */
  favoritePricebookItemsByPk?: Maybe<FavoritePricebookItems>;
  /** An array relationship */
  fileLinks: Array<FileLinks>;
  /** An aggregate relationship */
  fileLinksAggregate: FileLinksAggregate;
  /** fetch data from the table: "file_links" using primary key columns */
  fileLinksByPk?: Maybe<FileLinks>;
  /** fetch data from the table: "files" */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "files" */
  filesAggregate: FilesAggregate;
  /** fetch data from the table: "files" using primary key columns */
  filesByPk?: Maybe<Files>;
  /** An array relationship */
  installedEquipment: Array<InstalledEquipment>;
  /** An aggregate relationship */
  installedEquipmentAggregate: InstalledEquipmentAggregate;
  /** fetch data from the table: "installed_equipment" using primary key columns */
  installedEquipmentByPk?: Maybe<InstalledEquipment>;
  /** An array relationship */
  installedHvacSystems: Array<InstalledHvacSystems>;
  /** An aggregate relationship */
  installedHvacSystemsAggregate: InstalledHvacSystemsAggregate;
  /** fetch data from the table: "installed_hvac_systems" using primary key columns */
  installedHvacSystemsByPk?: Maybe<InstalledHvacSystems>;
  /** An array relationship */
  instantBookingWeeklyScheduleEntries: Array<InstantBookingWeeklyScheduleEntries>;
  /** An aggregate relationship */
  instantBookingWeeklyScheduleEntriesAggregate: InstantBookingWeeklyScheduleEntriesAggregate;
  /** fetch data from the table: "instant_booking_weekly_schedule_entries" using primary key columns */
  instantBookingWeeklyScheduleEntriesByPk?: Maybe<InstantBookingWeeklyScheduleEntries>;
  /** fetch data from the table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
  instantBookingWeeklyScheduleEntryBookableArrivalWindows: Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindows>;
  /** fetch aggregated fields from the table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
  instantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregate: InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregate;
  /** fetch data from the table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" using primary key columns */
  instantBookingWeeklyScheduleEntryBookableArrivalWindowsByPk?: Maybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindows>;
  /** An array relationship */
  integratedChannelCompletableItems: Array<IntegratedChannelCompletableItems>;
  /** An aggregate relationship */
  integratedChannelCompletableItemsAggregate: IntegratedChannelCompletableItemsAggregate;
  /** An array relationship */
  integratedChannelItems: Array<IntegratedChannelItems>;
  /** An aggregate relationship */
  integratedChannelItemsAggregate: IntegratedChannelItemsAggregate;
  /** An array relationship */
  integratedChannelReadableItems: Array<IntegratedChannelReadableItems>;
  /** An aggregate relationship */
  integratedChannelReadableItemsAggregate: IntegratedChannelReadableItemsAggregate;
  /** fetch data from the table: "integrated_channels" */
  integratedChannels: Array<IntegratedChannels>;
  /** fetch aggregated fields from the table: "integrated_channels" */
  integratedChannelsAggregate: IntegratedChannelsAggregate;
  /** fetch data from the table: "integrated_channels" using primary key columns */
  integratedChannelsByPk?: Maybe<IntegratedChannels>;
  /** fetch data from the table: "integrated_message_statuses" */
  integratedMessageStatuses: Array<IntegratedMessageStatuses>;
  /** fetch aggregated fields from the table: "integrated_message_statuses" */
  integratedMessageStatusesAggregate: IntegratedMessageStatusesAggregate;
  /** fetch data from the table: "integrated_message_statuses" using primary key columns */
  integratedMessageStatusesByPk?: Maybe<IntegratedMessageStatuses>;
  /** fetch data from the table: "integrated_message_twilio_raw_webhook_events" */
  integratedMessageTwilioRawWebhookEvents: Array<IntegratedMessageTwilioRawWebhookEvents>;
  /** fetch aggregated fields from the table: "integrated_message_twilio_raw_webhook_events" */
  integratedMessageTwilioRawWebhookEventsAggregate: IntegratedMessageTwilioRawWebhookEventsAggregate;
  /** fetch data from the table: "integrated_message_twilio_raw_webhook_events" using primary key columns */
  integratedMessageTwilioRawWebhookEventsByPk?: Maybe<IntegratedMessageTwilioRawWebhookEvents>;
  /** fetch data from the table: "integrated_messages" */
  integratedMessages: Array<IntegratedMessages>;
  /** fetch aggregated fields from the table: "integrated_messages" */
  integratedMessagesAggregate: IntegratedMessagesAggregate;
  /** fetch data from the table: "integrated_messages" using primary key columns */
  integratedMessagesByPk?: Maybe<IntegratedMessages>;
  /** An array relationship */
  integratedPhoneCallDismissals: Array<IntegratedPhoneCallDismissals>;
  /** An aggregate relationship */
  integratedPhoneCallDismissalsAggregate: IntegratedPhoneCallDismissalsAggregate;
  /** fetch data from the table: "integrated_phone_call_dismissals" using primary key columns */
  integratedPhoneCallDismissalsByPk?: Maybe<IntegratedPhoneCallDismissals>;
  /** An array relationship */
  integratedPhoneCallJobs: Array<IntegratedPhoneCallJobs>;
  /** An aggregate relationship */
  integratedPhoneCallJobsAggregate: IntegratedPhoneCallJobsAggregate;
  /** fetch data from the table: "integrated_phone_call_jobs" using primary key columns */
  integratedPhoneCallJobsByPk?: Maybe<IntegratedPhoneCallJobs>;
  /** fetch data from the table: "integrated_phone_call_recording" */
  integratedPhoneCallRecording: Array<IntegratedPhoneCallRecording>;
  /** fetch aggregated fields from the table: "integrated_phone_call_recording" */
  integratedPhoneCallRecordingAggregate: IntegratedPhoneCallRecordingAggregate;
  /** fetch data from the table: "integrated_phone_call_recording" using primary key columns */
  integratedPhoneCallRecordingByPk?: Maybe<IntegratedPhoneCallRecording>;
  /** fetch data from the table: "integrated_phone_call_status_types" */
  integratedPhoneCallStatusTypes: Array<IntegratedPhoneCallStatusTypes>;
  /** fetch aggregated fields from the table: "integrated_phone_call_status_types" */
  integratedPhoneCallStatusTypesAggregate: IntegratedPhoneCallStatusTypesAggregate;
  /** fetch data from the table: "integrated_phone_call_status_types" using primary key columns */
  integratedPhoneCallStatusTypesByPk?: Maybe<IntegratedPhoneCallStatusTypes>;
  /** An array relationship */
  integratedPhoneCallStatuses: Array<IntegratedPhoneCallStatuses>;
  /** An aggregate relationship */
  integratedPhoneCallStatusesAggregate: IntegratedPhoneCallStatusesAggregate;
  /** fetch data from the table: "integrated_phone_call_statuses" using primary key columns */
  integratedPhoneCallStatusesByPk?: Maybe<IntegratedPhoneCallStatuses>;
  /** An array relationship */
  integratedPhoneCalls: Array<IntegratedPhoneCalls>;
  /** An aggregate relationship */
  integratedPhoneCallsAggregate: IntegratedPhoneCallsAggregate;
  /** fetch data from the table: "integrated_phone_calls" using primary key columns */
  integratedPhoneCallsByPk?: Maybe<IntegratedPhoneCalls>;
  /** fetch data from the table: "integrated_phone_company_config" */
  integratedPhoneCompanyConfig: Array<IntegratedPhoneCompanyConfig>;
  /** fetch aggregated fields from the table: "integrated_phone_company_config" */
  integratedPhoneCompanyConfigAggregate: IntegratedPhoneCompanyConfigAggregate;
  /** fetch data from the table: "integrated_phone_company_config" using primary key columns */
  integratedPhoneCompanyConfigByPk?: Maybe<IntegratedPhoneCompanyConfig>;
  /** An array relationship */
  integratedPhoneMissedCallDismissals: Array<IntegratedPhoneMissedCallDismissals>;
  /** An aggregate relationship */
  integratedPhoneMissedCallDismissalsAggregate: IntegratedPhoneMissedCallDismissalsAggregate;
  /** fetch data from the table: "integrated_phone_missed_call_dismissals" using primary key columns */
  integratedPhoneMissedCallDismissalsByPk?: Maybe<IntegratedPhoneMissedCallDismissals>;
  /** An array relationship */
  integratedPhoneMissedCalls: Array<IntegratedPhoneMissedCalls>;
  /** An aggregate relationship */
  integratedPhoneMissedCallsAggregate: IntegratedPhoneMissedCallsAggregate;
  /** fetch data from the table: "integrated_phone_missed_calls" using primary key columns */
  integratedPhoneMissedCallsByPk?: Maybe<IntegratedPhoneMissedCalls>;
  /** fetch data from the table: "integrated_phone_twilio_raw_webhook_events" */
  integratedPhoneTwilioRawWebhookEvents: Array<IntegratedPhoneTwilioRawWebhookEvents>;
  /** fetch aggregated fields from the table: "integrated_phone_twilio_raw_webhook_events" */
  integratedPhoneTwilioRawWebhookEventsAggregate: IntegratedPhoneTwilioRawWebhookEventsAggregate;
  /** fetch data from the table: "integrated_phone_twilio_raw_webhook_events" using primary key columns */
  integratedPhoneTwilioRawWebhookEventsByPk?: Maybe<IntegratedPhoneTwilioRawWebhookEvents>;
  /** An array relationship */
  integratedPhoneUsers: Array<IntegratedPhoneUsers>;
  /** An aggregate relationship */
  integratedPhoneUsersAggregate: IntegratedPhoneUsersAggregate;
  /** fetch data from the table: "integrated_phone_users" using primary key columns */
  integratedPhoneUsersByPk?: Maybe<IntegratedPhoneUsers>;
  /** An array relationship */
  integratedPhoneVoicemailDismissals: Array<IntegratedPhoneVoicemailDismissals>;
  /** An aggregate relationship */
  integratedPhoneVoicemailDismissalsAggregate: IntegratedPhoneVoicemailDismissalsAggregate;
  /** fetch data from the table: "integrated_phone_voicemail_dismissals" using primary key columns */
  integratedPhoneVoicemailDismissalsByPk?: Maybe<IntegratedPhoneVoicemailDismissals>;
  /** An array relationship */
  integratedPhoneVoicemails: Array<IntegratedPhoneVoicemails>;
  /** An aggregate relationship */
  integratedPhoneVoicemailsAggregate: IntegratedPhoneVoicemailsAggregate;
  /** fetch data from the table: "integrated_phone_voicemails" using primary key columns */
  integratedPhoneVoicemailsByPk?: Maybe<IntegratedPhoneVoicemails>;
  /** An array relationship */
  integratedPhones: Array<IntegratedPhones>;
  /** An aggregate relationship */
  integratedPhonesAggregate: IntegratedPhonesAggregate;
  /** fetch data from the table: "integrated_phones" using primary key columns */
  integratedPhonesByPk?: Maybe<IntegratedPhones>;
  /** fetch data from the table: "internal_notifications" */
  internalNotifications: Array<InternalNotifications>;
  /** fetch aggregated fields from the table: "internal_notifications" */
  internalNotificationsAggregate: InternalNotificationsAggregate;
  /** fetch data from the table: "internal_notifications" using primary key columns */
  internalNotificationsByPk?: Maybe<InternalNotifications>;
  /** fetch data from the table: "invoice_business_unit" */
  invoiceBusinessUnit: Array<InvoiceBusinessUnit>;
  /** fetch aggregated fields from the table: "invoice_business_unit" */
  invoiceBusinessUnitAggregate: InvoiceBusinessUnitAggregate;
  /** An array relationship */
  invoiceCartItemBundleItems: Array<InvoiceCartItemBundleItems>;
  /** An aggregate relationship */
  invoiceCartItemBundleItemsAggregate: InvoiceCartItemBundleItemsAggregate;
  /** fetch data from the table: "invoice_cart_item_bundle_items" using primary key columns */
  invoiceCartItemBundleItemsByPk?: Maybe<InvoiceCartItemBundleItems>;
  /** fetch data from the table: "invoice_cart_item_bundle_job_cost_links" */
  invoiceCartItemBundleJobCostLinks: Array<InvoiceCartItemBundleJobCostLinks>;
  /** fetch aggregated fields from the table: "invoice_cart_item_bundle_job_cost_links" */
  invoiceCartItemBundleJobCostLinksAggregate: InvoiceCartItemBundleJobCostLinksAggregate;
  /** fetch data from the table: "invoice_cart_item_bundle_job_cost_links" using primary key columns */
  invoiceCartItemBundleJobCostLinksByPk?: Maybe<InvoiceCartItemBundleJobCostLinks>;
  /** An array relationship */
  invoiceCartItems: Array<InvoiceCartItems>;
  /** An aggregate relationship */
  invoiceCartItemsAggregate: InvoiceCartItemsAggregate;
  /** fetch data from the table: "invoice_cart_items" using primary key columns */
  invoiceCartItemsByPk?: Maybe<InvoiceCartItems>;
  /** fetch data from the table: "invoice_company_tax_configurations_view" */
  invoiceCompanyTaxConfigurationsView: Array<InvoiceCompanyTaxConfigurationsView>;
  /** fetch aggregated fields from the table: "invoice_company_tax_configurations_view" */
  invoiceCompanyTaxConfigurationsViewAggregate: InvoiceCompanyTaxConfigurationsViewAggregate;
  /** An array relationship */
  invoiceDiscounts: Array<InvoiceDiscounts>;
  /** An aggregate relationship */
  invoiceDiscountsAggregate: InvoiceDiscountsAggregate;
  /** fetch data from the table: "invoice_discounts" using primary key columns */
  invoiceDiscountsByPk?: Maybe<InvoiceDiscounts>;
  /** An array relationship */
  invoiceEvents: Array<InvoiceEvents>;
  /** An aggregate relationship */
  invoiceEventsAggregate: InvoiceEventsAggregate;
  /** fetch data from the table: "invoice_events" using primary key columns */
  invoiceEventsByPk?: Maybe<InvoiceEvents>;
  /** An array relationship */
  invoicePayments: Array<InvoicePayments>;
  /** An aggregate relationship */
  invoicePaymentsAggregate: InvoicePaymentsAggregate;
  /** fetch data from the table: "invoice_payments" using primary key columns */
  invoicePaymentsByPk?: Maybe<InvoicePayments>;
  /** fetch data from the table: "invoice_reminder_data" */
  invoiceReminderData: Array<InvoiceReminderData>;
  /** fetch aggregated fields from the table: "invoice_reminder_data" */
  invoiceReminderDataAggregate: InvoiceReminderDataAggregate;
  /** fetch data from the table: "invoice_reminder_data" using primary key columns */
  invoiceReminderDataByPk?: Maybe<InvoiceReminderData>;
  /** An array relationship */
  invoiceTemplateCartItems: Array<InvoiceTemplateCartItems>;
  /** An aggregate relationship */
  invoiceTemplateCartItemsAggregate: InvoiceTemplateCartItemsAggregate;
  /** fetch data from the table: "invoice_template_cart_items" using primary key columns */
  invoiceTemplateCartItemsByPk?: Maybe<InvoiceTemplateCartItems>;
  /** fetch data from the table: "invoice_templates" */
  invoiceTemplates: Array<InvoiceTemplates>;
  /** fetch aggregated fields from the table: "invoice_templates" */
  invoiceTemplatesAggregate: InvoiceTemplatesAggregate;
  /** fetch data from the table: "invoice_templates" using primary key columns */
  invoiceTemplatesByPk?: Maybe<InvoiceTemplates>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoicesAggregate: InvoicesAggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoicesByPk?: Maybe<Invoices>;
  /** fetch data from the table: "invoices_qbo_status" */
  invoicesQboStatus: Array<InvoicesQboStatus>;
  /** fetch aggregated fields from the table: "invoices_qbo_status" */
  invoicesQboStatusAggregate: InvoicesQboStatusAggregate;
  /** fetch data from the table: "invoices_queryable" */
  invoicesQueryable: Array<InvoicesQueryable>;
  /** fetch aggregated fields from the table: "invoices_queryable" */
  invoicesQueryableAggregate: InvoicesQueryableAggregate;
  /** fetch data from the table: "invoices_queryable" using primary key columns */
  invoicesQueryableByPk?: Maybe<InvoicesQueryable>;
  /** fetch data from the table: "invoices_queryable_with_qbo_status" */
  invoicesQueryableWithQboStatus: Array<InvoicesQueryableWithQboStatus>;
  /** fetch aggregated fields from the table: "invoices_queryable_with_qbo_status" */
  invoicesQueryableWithQboStatusAggregate: InvoicesQueryableWithQboStatusAggregate;
  /** fetch data from the table: "invoices_v2_accounting_stale" */
  invoicesV2AccountingStale: Array<InvoicesV2AccountingStale>;
  /** fetch aggregated fields from the table: "invoices_v2_accounting_stale" */
  invoicesV2AccountingStaleAggregate: InvoicesV2AccountingStaleAggregate;
  /** fetch data from the table: "invoices_v2_qbo_stale" */
  invoicesV2QboStale: Array<InvoicesV2QboStale>;
  /** fetch aggregated fields from the table: "invoices_v2_qbo_stale" */
  invoicesV2QboStaleAggregate: InvoicesV2QboStaleAggregate;
  /** fetch data from the table: "invoices_v2_qbo_status" */
  invoicesV2QboStatus: Array<InvoicesV2QboStatus>;
  /** fetch aggregated fields from the table: "invoices_v2_qbo_status" */
  invoicesV2QboStatusAggregate: InvoicesV2QboStatusAggregate;
  /** fetch data from the table: "job_appointment_assignment_status_types" */
  jobAppointmentAssignmentStatusTypes: Array<JobAppointmentAssignmentStatusTypes>;
  /** fetch aggregated fields from the table: "job_appointment_assignment_status_types" */
  jobAppointmentAssignmentStatusTypesAggregate: JobAppointmentAssignmentStatusTypesAggregate;
  /** fetch data from the table: "job_appointment_assignment_status_types" using primary key columns */
  jobAppointmentAssignmentStatusTypesByPk?: Maybe<JobAppointmentAssignmentStatusTypes>;
  /** fetch data from the table: "job_appointment_assignment_statuses" */
  jobAppointmentAssignmentStatuses: Array<JobAppointmentAssignmentStatuses>;
  /** fetch aggregated fields from the table: "job_appointment_assignment_statuses" */
  jobAppointmentAssignmentStatusesAggregate: JobAppointmentAssignmentStatusesAggregate;
  /** fetch data from the table: "job_appointment_assignment_statuses" using primary key columns */
  jobAppointmentAssignmentStatusesByPk?: Maybe<JobAppointmentAssignmentStatuses>;
  /** An array relationship */
  jobAppointmentAssignments: Array<JobAppointmentAssignments>;
  /** An aggregate relationship */
  jobAppointmentAssignmentsAggregate: JobAppointmentAssignmentsAggregate;
  /** fetch data from the table: "job_appointment_assignments" using primary key columns */
  jobAppointmentAssignmentsByPk?: Maybe<JobAppointmentAssignments>;
  /** fetch data from the table: "job_appointment_cancellation_statuses" */
  jobAppointmentCancellationStatuses: Array<JobAppointmentCancellationStatuses>;
  /** fetch aggregated fields from the table: "job_appointment_cancellation_statuses" */
  jobAppointmentCancellationStatusesAggregate: JobAppointmentCancellationStatusesAggregate;
  /** fetch data from the table: "job_appointment_cancellation_statuses" using primary key columns */
  jobAppointmentCancellationStatusesByPk?: Maybe<JobAppointmentCancellationStatuses>;
  /** fetch data from the table: "job_appointment_confirmation_statuses" */
  jobAppointmentConfirmationStatuses: Array<JobAppointmentConfirmationStatuses>;
  /** fetch aggregated fields from the table: "job_appointment_confirmation_statuses" */
  jobAppointmentConfirmationStatusesAggregate: JobAppointmentConfirmationStatusesAggregate;
  /** fetch data from the table: "job_appointment_confirmation_statuses" using primary key columns */
  jobAppointmentConfirmationStatusesByPk?: Maybe<JobAppointmentConfirmationStatuses>;
  /** An array relationship */
  jobAppointmentInvoices: Array<JobAppointmentInvoices>;
  /** An aggregate relationship */
  jobAppointmentInvoicesAggregate: JobAppointmentInvoicesAggregate;
  /** fetch data from the table: "job_appointment_invoices" using primary key columns */
  jobAppointmentInvoicesByPk?: Maybe<JobAppointmentInvoices>;
  /** An array relationship */
  jobAppointments: Array<JobAppointments>;
  /** An aggregate relationship */
  jobAppointmentsAggregate: JobAppointmentsAggregate;
  /** fetch data from the table: "job_appointments" using primary key columns */
  jobAppointmentsByPk?: Maybe<JobAppointments>;
  /** An array relationship */
  jobCostItems: Array<JobCostItems>;
  /** An aggregate relationship */
  jobCostItemsAggregate: JobCostItemsAggregate;
  /** fetch data from the table: "job_cost_items" using primary key columns */
  jobCostItemsByPk?: Maybe<JobCostItems>;
  /** fetch data from the table: "job_cost_misc_categories" */
  jobCostMiscCategories: Array<JobCostMiscCategories>;
  /** fetch aggregated fields from the table: "job_cost_misc_categories" */
  jobCostMiscCategoriesAggregate: JobCostMiscCategoriesAggregate;
  /** fetch data from the table: "job_cost_misc_categories" using primary key columns */
  jobCostMiscCategoriesByPk?: Maybe<JobCostMiscCategories>;
  /** fetch data from the table: "job_costing_config" */
  jobCostingConfig: Array<JobCostingConfig>;
  /** fetch aggregated fields from the table: "job_costing_config" */
  jobCostingConfigAggregate: JobCostingConfigAggregate;
  /** fetch data from the table: "job_costing_config" using primary key columns */
  jobCostingConfigByPk?: Maybe<JobCostingConfig>;
  /** fetch data from the table: "job_costing_rollup_view" */
  jobCostingRollupView: Array<JobCostingRollupView>;
  /** fetch aggregated fields from the table: "job_costing_rollup_view" */
  jobCostingRollupViewAggregate: JobCostingRollupViewAggregate;
  /** An array relationship */
  jobInvoices: Array<JobInvoices>;
  /** An aggregate relationship */
  jobInvoicesAggregate: JobInvoicesAggregate;
  /** fetch data from the table: "job_invoices" using primary key columns */
  jobInvoicesByPk?: Maybe<JobInvoices>;
  /** fetch data from the table: "job_leads" */
  jobLeads: Array<JobLeads>;
  /** fetch aggregated fields from the table: "job_leads" */
  jobLeadsAggregate: JobLeadsAggregate;
  /** fetch data from the table: "job_leads" using primary key columns */
  jobLeadsByPk?: Maybe<JobLeads>;
  /** An array relationship */
  jobLifecycleStatuses: Array<JobLifecycleStatuses>;
  /** An aggregate relationship */
  jobLifecycleStatusesAggregate: JobLifecycleStatusesAggregate;
  /** fetch data from the table: "job_lifecycle_statuses" using primary key columns */
  jobLifecycleStatusesByPk?: Maybe<JobLifecycleStatuses>;
  /** fetch data from the table: "job_lifecycle_types" */
  jobLifecycleTypes: Array<JobLifecycleTypes>;
  /** fetch aggregated fields from the table: "job_lifecycle_types" */
  jobLifecycleTypesAggregate: JobLifecycleTypesAggregate;
  /** fetch data from the table: "job_lifecycle_types" using primary key columns */
  jobLifecycleTypesByPk?: Maybe<JobLifecycleTypes>;
  /** fetch data from the table: "job_lifecycle_views" */
  jobLifecycleViews: Array<JobLifecycleViews>;
  /** fetch aggregated fields from the table: "job_lifecycle_views" */
  jobLifecycleViewsAggregate: JobLifecycleViewsAggregate;
  /** fetch data from the table: "job_lifecycle_views" using primary key columns */
  jobLifecycleViewsByPk?: Maybe<JobLifecycleViews>;
  /** fetch data from the table: "job_lifecycles" */
  jobLifecycles: Array<JobLifecycles>;
  /** fetch aggregated fields from the table: "job_lifecycles" */
  jobLifecyclesAggregate: JobLifecyclesAggregate;
  /** fetch data from the table: "job_lifecycles" using primary key columns */
  jobLifecyclesByPk?: Maybe<JobLifecycles>;
  /** fetch data from the table: "job_requests_company_config" */
  jobRequestsCompanyConfig: Array<JobRequestsCompanyConfig>;
  /** fetch aggregated fields from the table: "job_requests_company_config" */
  jobRequestsCompanyConfigAggregate: JobRequestsCompanyConfigAggregate;
  /** fetch data from the table: "job_requests_company_config" using primary key columns */
  jobRequestsCompanyConfigByPk?: Maybe<JobRequestsCompanyConfig>;
  /** fetch data from the table: "job_tags" */
  jobTags: Array<JobTags>;
  /** fetch aggregated fields from the table: "job_tags" */
  jobTagsAggregate: JobTagsAggregate;
  /** fetch data from the table: "job_tags" using primary key columns */
  jobTagsByPk?: Maybe<JobTags>;
  /** An array relationship */
  jobTeamMembers: Array<JobTeamMembers>;
  /** An aggregate relationship */
  jobTeamMembersAggregate: JobTeamMembersAggregate;
  /** fetch data from the table: "job_team_members" using primary key columns */
  jobTeamMembersByPk?: Maybe<JobTeamMembers>;
  /** An array relationship */
  jobTechnicianEarnedRevenueAttributions: Array<JobTechnicianEarnedRevenueAttributions>;
  /** An aggregate relationship */
  jobTechnicianEarnedRevenueAttributionsAggregate: JobTechnicianEarnedRevenueAttributionsAggregate;
  /** fetch data from the table: "job_technician_earned_revenue_attributions" using primary key columns */
  jobTechnicianEarnedRevenueAttributionsByPk?: Maybe<JobTechnicianEarnedRevenueAttributions>;
  /** An array relationship */
  jobTechnicianEarnedRevenueSummaries: Array<JobTechnicianEarnedRevenueSummaries>;
  /** An aggregate relationship */
  jobTechnicianEarnedRevenueSummariesAggregate: JobTechnicianEarnedRevenueSummariesAggregate;
  /** fetch data from the table: "job_technician_sales_commission_and_bonus" */
  jobTechnicianSalesCommissionAndBonus: Array<JobTechnicianSalesCommissionAndBonus>;
  /** fetch aggregated fields from the table: "job_technician_sales_commission_and_bonus" */
  jobTechnicianSalesCommissionAndBonusAggregate: JobTechnicianSalesCommissionAndBonusAggregate;
  /** An array relationship */
  jobTechnicianSoldRevenueAttributions: Array<JobTechnicianSoldRevenueAttributions>;
  /** An aggregate relationship */
  jobTechnicianSoldRevenueAttributionsAggregate: JobTechnicianSoldRevenueAttributionsAggregate;
  /** fetch data from the table: "job_technician_sold_revenue_attributions" using primary key columns */
  jobTechnicianSoldRevenueAttributionsByPk?: Maybe<JobTechnicianSoldRevenueAttributions>;
  /** An array relationship */
  jobTechnicianSoldRevenueSummaries: Array<JobTechnicianSoldRevenueSummaries>;
  /** An aggregate relationship */
  jobTechnicianSoldRevenueSummariesAggregate: JobTechnicianSoldRevenueSummariesAggregate;
  /** fetch data from the table: "job_type_change_reasons" */
  jobTypeChangeReasons: Array<JobTypeChangeReasons>;
  /** fetch aggregated fields from the table: "job_type_change_reasons" */
  jobTypeChangeReasonsAggregate: JobTypeChangeReasonsAggregate;
  /** fetch data from the table: "job_type_change_reasons" using primary key columns */
  jobTypeChangeReasonsByPk?: Maybe<JobTypeChangeReasons>;
  /** An array relationship */
  jobTypes: Array<JobTypes>;
  /** An aggregate relationship */
  jobTypesAggregate: JobTypesAggregate;
  /** fetch data from the table: "job_types" using primary key columns */
  jobTypesByPk?: Maybe<JobTypes>;
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobsAggregate: JobsAggregate;
  /** fetch data from the table: "jobs" using primary key columns */
  jobsByPk?: Maybe<Jobs>;
  /** fetch data from the table: "jobs_fully_paid_invoiced_amount" */
  jobsFullyPaidInvoicedAmount: Array<JobsFullyPaidInvoicedAmount>;
  /** fetch aggregated fields from the table: "jobs_fully_paid_invoiced_amount" */
  jobsFullyPaidInvoicedAmountAggregate: JobsFullyPaidInvoicedAmountAggregate;
  /** fetch data from the table: "jobs_fully_paid_invoices_summary" */
  jobsFullyPaidInvoicesSummary: Array<JobsFullyPaidInvoicesSummary>;
  /** fetch aggregated fields from the table: "jobs_fully_paid_invoices_summary" */
  jobsFullyPaidInvoicesSummaryAggregate: JobsFullyPaidInvoicesSummaryAggregate;
  /** fetch data from the table: "jobs_fully_paid_invoices_v2_summary" */
  jobsFullyPaidInvoicesV2Summary: Array<JobsFullyPaidInvoicesV2Summary>;
  /** fetch aggregated fields from the table: "jobs_fully_paid_invoices_v2_summary" */
  jobsFullyPaidInvoicesV2SummaryAggregate: JobsFullyPaidInvoicesV2SummaryAggregate;
  /** fetch data from the table: "jobs_fully_paid_invoices_v2_summary_mv" */
  jobsFullyPaidInvoicesV2SummaryMv: Array<JobsFullyPaidInvoicesV2SummaryMv>;
  /** fetch aggregated fields from the table: "jobs_fully_paid_invoices_v2_summary_mv" */
  jobsFullyPaidInvoicesV2SummaryMvAggregate: JobsFullyPaidInvoicesV2SummaryMvAggregate;
  /** fetch data from the table: "jobs_max_commissionable_base" */
  jobsMaxCommissionableBase: Array<JobsMaxCommissionableBase>;
  /** fetch aggregated fields from the table: "jobs_max_commissionable_base" */
  jobsMaxCommissionableBaseAggregate: JobsMaxCommissionableBaseAggregate;
  /** fetch data from the table: "jobs_with_linked_job" */
  jobsWithLinkedJob: Array<JobsWithLinkedJob>;
  /** fetch aggregated fields from the table: "jobs_with_linked_job" */
  jobsWithLinkedJobAggregate: JobsWithLinkedJobAggregate;
  /** fetch data from the table: "jobs_with_linked_job" using primary key columns */
  jobsWithLinkedJobByPk?: Maybe<JobsWithLinkedJob>;
  /** fetch data from the table: "jobs_with_linked_job_linked_appointment_checklist_instances" */
  jobsWithLinkedJobLinkedAppointmentChecklistInstances: Array<JobsWithLinkedJobLinkedAppointmentChecklistInstances>;
  /** fetch aggregated fields from the table: "jobs_with_linked_job_linked_appointment_checklist_instances" */
  jobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregate: JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregate;
  /** fetch data from the table: "jobs_with_linked_job_linked_appointment_checklist_instances" using primary key columns */
  jobsWithLinkedJobLinkedAppointmentChecklistInstancesByPk?: Maybe<JobsWithLinkedJobLinkedAppointmentChecklistInstances>;
  /** fetch data from the table: "jobs_with_linked_job_linked_estimates" */
  jobsWithLinkedJobLinkedEstimates: Array<JobsWithLinkedJobLinkedEstimates>;
  /** fetch aggregated fields from the table: "jobs_with_linked_job_linked_estimates" */
  jobsWithLinkedJobLinkedEstimatesAggregate: JobsWithLinkedJobLinkedEstimatesAggregate;
  /** fetch data from the table: "jobs_with_linked_job_linked_estimates" using primary key columns */
  jobsWithLinkedJobLinkedEstimatesByPk?: Maybe<JobsWithLinkedJobLinkedEstimates>;
  /** fetch data from the table: "jobs_with_linked_job_linked_invoices" */
  jobsWithLinkedJobLinkedInvoices: Array<JobsWithLinkedJobLinkedInvoices>;
  /** fetch aggregated fields from the table: "jobs_with_linked_job_linked_invoices" */
  jobsWithLinkedJobLinkedInvoicesAggregate: JobsWithLinkedJobLinkedInvoicesAggregate;
  /** fetch data from the table: "jobs_with_linked_job_linked_invoices" using primary key columns */
  jobsWithLinkedJobLinkedInvoicesByPk?: Maybe<JobsWithLinkedJobLinkedInvoices>;
  /** An array relationship */
  locationContacts: Array<LocationContacts>;
  /** An aggregate relationship */
  locationContactsAggregate: LocationContactsAggregate;
  /** fetch data from the table: "location_contacts" using primary key columns */
  locationContactsByPk?: Maybe<LocationContacts>;
  /** An array relationship */
  locationInvoices: Array<LocationInvoices>;
  /** An aggregate relationship */
  locationInvoicesAggregate: LocationInvoicesAggregate;
  /** fetch data from the table: "location_invoices" using primary key columns */
  locationInvoicesByPk?: Maybe<LocationInvoices>;
  /** An array relationship */
  locations: Array<Locations>;
  /** An aggregate relationship */
  locationsAggregate: LocationsAggregate;
  /** fetch data from the table: "locations" using primary key columns */
  locationsByPk?: Maybe<Locations>;
  /** fetch data from the table: "maintenance_plan_definition_allowed_payment_intervals" */
  maintenancePlanDefinitionAllowedPaymentIntervals: Array<MaintenancePlanDefinitionAllowedPaymentIntervals>;
  /** fetch aggregated fields from the table: "maintenance_plan_definition_allowed_payment_intervals" */
  maintenancePlanDefinitionAllowedPaymentIntervalsAggregate: MaintenancePlanDefinitionAllowedPaymentIntervalsAggregate;
  /** fetch data from the table: "maintenance_plan_definition_allowed_payment_intervals" using primary key columns */
  maintenancePlanDefinitionAllowedPaymentIntervalsByPk?: Maybe<MaintenancePlanDefinitionAllowedPaymentIntervals>;
  /** fetch data from the table: "maintenance_plan_definition_benefits" */
  maintenancePlanDefinitionBenefits: Array<MaintenancePlanDefinitionBenefits>;
  /** fetch aggregated fields from the table: "maintenance_plan_definition_benefits" */
  maintenancePlanDefinitionBenefitsAggregate: MaintenancePlanDefinitionBenefitsAggregate;
  /** fetch data from the table: "maintenance_plan_definition_benefits" using primary key columns */
  maintenancePlanDefinitionBenefitsByPk?: Maybe<MaintenancePlanDefinitionBenefits>;
  /** fetch data from the table: "maintenance_plan_definition_discounts" */
  maintenancePlanDefinitionDiscounts: Array<MaintenancePlanDefinitionDiscounts>;
  /** fetch aggregated fields from the table: "maintenance_plan_definition_discounts" */
  maintenancePlanDefinitionDiscountsAggregate: MaintenancePlanDefinitionDiscountsAggregate;
  /** fetch data from the table: "maintenance_plan_definition_discounts" using primary key columns */
  maintenancePlanDefinitionDiscountsByPk?: Maybe<MaintenancePlanDefinitionDiscounts>;
  /** fetch data from the table: "maintenance_plan_definition_flare" */
  maintenancePlanDefinitionFlare: Array<MaintenancePlanDefinitionFlare>;
  /** fetch aggregated fields from the table: "maintenance_plan_definition_flare" */
  maintenancePlanDefinitionFlareAggregate: MaintenancePlanDefinitionFlareAggregate;
  /** fetch data from the table: "maintenance_plan_definition_flare" using primary key columns */
  maintenancePlanDefinitionFlareByPk?: Maybe<MaintenancePlanDefinitionFlare>;
  /** fetch data from the table: "maintenance_plan_definition_marketing_info" */
  maintenancePlanDefinitionMarketingInfo: Array<MaintenancePlanDefinitionMarketingInfo>;
  /** fetch aggregated fields from the table: "maintenance_plan_definition_marketing_info" */
  maintenancePlanDefinitionMarketingInfoAggregate: MaintenancePlanDefinitionMarketingInfoAggregate;
  /** fetch data from the table: "maintenance_plan_definition_marketing_info" using primary key columns */
  maintenancePlanDefinitionMarketingInfoByPk?: Maybe<MaintenancePlanDefinitionMarketingInfo>;
  /** fetch data from the table: "maintenance_plan_definitions" */
  maintenancePlanDefinitions: Array<MaintenancePlanDefinitions>;
  /** fetch aggregated fields from the table: "maintenance_plan_definitions" */
  maintenancePlanDefinitionsAggregate: MaintenancePlanDefinitionsAggregate;
  /** fetch data from the table: "maintenance_plan_definitions" using primary key columns */
  maintenancePlanDefinitionsByPk?: Maybe<MaintenancePlanDefinitions>;
  /** fetch data from the table: "maintenance_plan_equipment_coverage_definitions" */
  maintenancePlanEquipmentCoverageDefinitions: Array<MaintenancePlanEquipmentCoverageDefinitions>;
  /** fetch aggregated fields from the table: "maintenance_plan_equipment_coverage_definitions" */
  maintenancePlanEquipmentCoverageDefinitionsAggregate: MaintenancePlanEquipmentCoverageDefinitionsAggregate;
  /** fetch data from the table: "maintenance_plan_equipment_coverage_definitions" using primary key columns */
  maintenancePlanEquipmentCoverageDefinitionsByPk?: Maybe<MaintenancePlanEquipmentCoverageDefinitions>;
  /** fetch data from the table: "maintenance_plan_equipment_coverage_pricings" */
  maintenancePlanEquipmentCoveragePricings: Array<MaintenancePlanEquipmentCoveragePricings>;
  /** fetch aggregated fields from the table: "maintenance_plan_equipment_coverage_pricings" */
  maintenancePlanEquipmentCoveragePricingsAggregate: MaintenancePlanEquipmentCoveragePricingsAggregate;
  /** fetch data from the table: "maintenance_plan_equipment_coverage_pricings" using primary key columns */
  maintenancePlanEquipmentCoveragePricingsByPk?: Maybe<MaintenancePlanEquipmentCoveragePricings>;
  /** An array relationship */
  maintenancePlanInvoices: Array<MaintenancePlanInvoices>;
  /** An aggregate relationship */
  maintenancePlanInvoicesAggregate: MaintenancePlanInvoicesAggregate;
  /** fetch data from the table: "maintenance_plan_invoices" using primary key columns */
  maintenancePlanInvoicesByPk?: Maybe<MaintenancePlanInvoices>;
  /** fetch data from the table: "maintenance_plan_next_visits" */
  maintenancePlanNextVisits: Array<MaintenancePlanNextVisits>;
  /** fetch aggregated fields from the table: "maintenance_plan_next_visits" */
  maintenancePlanNextVisitsAggregate: MaintenancePlanNextVisitsAggregate;
  /** An array relationship */
  maintenancePlanVisitInstalledEquipments: Array<MaintenancePlanVisitInstalledEquipments>;
  /** An aggregate relationship */
  maintenancePlanVisitInstalledEquipmentsAggregate: MaintenancePlanVisitInstalledEquipmentsAggregate;
  /** fetch data from the table: "maintenance_plan_visit_installed_equipments" using primary key columns */
  maintenancePlanVisitInstalledEquipmentsByPk?: Maybe<MaintenancePlanVisitInstalledEquipments>;
  /** An array relationship */
  maintenancePlanVisits: Array<MaintenancePlanVisits>;
  /** An aggregate relationship */
  maintenancePlanVisitsAggregate: MaintenancePlanVisitsAggregate;
  /** fetch data from the table: "maintenance_plan_visits" using primary key columns */
  maintenancePlanVisitsByPk?: Maybe<MaintenancePlanVisits>;
  /** fetch data from the table: "maintenance_plan_visits_with_status" */
  maintenancePlanVisitsWithStatus: Array<MaintenancePlanVisitsWithStatus>;
  /** fetch aggregated fields from the table: "maintenance_plan_visits_with_status" */
  maintenancePlanVisitsWithStatusAggregate: MaintenancePlanVisitsWithStatusAggregate;
  /** fetch data from the table: "maintenance_plans_queryable" */
  maintenancePlansQueryable: Array<MaintenancePlansQueryable>;
  /** fetch aggregated fields from the table: "maintenance_plans_queryable" */
  maintenancePlansQueryableAggregate: MaintenancePlansQueryableAggregate;
  /** fetch data from the table: "maintenance_plans_queryable" using primary key columns */
  maintenancePlansQueryableByPk?: Maybe<MaintenancePlansQueryable>;
  /** fetch data from the table: "migration_junk" */
  migrationJunk: Array<MigrationJunk>;
  /** fetch aggregated fields from the table: "migration_junk" */
  migrationJunkAggregate: MigrationJunkAggregate;
  /** fetch data from the table: "migration_junk" using primary key columns */
  migrationJunkByPk?: Maybe<MigrationJunk>;
  /** fetch data from the table: "migration_junk_links" */
  migrationJunkLinks: Array<MigrationJunkLinks>;
  /** fetch aggregated fields from the table: "migration_junk_links" */
  migrationJunkLinksAggregate: MigrationJunkLinksAggregate;
  /** fetch data from the table: "migration_junk_links" using primary key columns */
  migrationJunkLinksByPk?: Maybe<MigrationJunkLinks>;
  /** An array relationship */
  noteAttachments: Array<NoteAttachments>;
  /** An aggregate relationship */
  noteAttachmentsAggregate: NoteAttachmentsAggregate;
  /** fetch data from the table: "note_attachments" using primary key columns */
  noteAttachmentsByPk?: Maybe<NoteAttachments>;
  /** An array relationship */
  noteLinks: Array<NoteLinks>;
  /** An aggregate relationship */
  noteLinksAggregate: NoteLinksAggregate;
  /** fetch data from the table: "note_links" using primary key columns */
  noteLinksByPk?: Maybe<NoteLinks>;
  /** fetch data from the table: "note_tagged_users" */
  noteTaggedUsers: Array<NoteTaggedUsers>;
  /** fetch aggregated fields from the table: "note_tagged_users" */
  noteTaggedUsersAggregate: NoteTaggedUsersAggregate;
  /** fetch data from the table: "note_tagged_users" using primary key columns */
  noteTaggedUsersByPk?: Maybe<NoteTaggedUsers>;
  /** An array relationship */
  notes: Array<Notes>;
  /** An aggregate relationship */
  notesAggregate: NotesAggregate;
  /** fetch data from the table: "notes" using primary key columns */
  notesByPk?: Maybe<Notes>;
  /** fetch data from the table: "online_booking_company_config" */
  onlineBookingCompanyConfig: Array<OnlineBookingCompanyConfig>;
  /** fetch aggregated fields from the table: "online_booking_company_config" */
  onlineBookingCompanyConfigAggregate: OnlineBookingCompanyConfigAggregate;
  /** fetch data from the table: "online_booking_company_config" using primary key columns */
  onlineBookingCompanyConfigByPk?: Maybe<OnlineBookingCompanyConfig>;
  /** fetch data from the table: "online_booking_service_area_zip_codes" */
  onlineBookingServiceAreaZipCodes: Array<OnlineBookingServiceAreaZipCodes>;
  /** fetch aggregated fields from the table: "online_booking_service_area_zip_codes" */
  onlineBookingServiceAreaZipCodesAggregate: OnlineBookingServiceAreaZipCodesAggregate;
  /** fetch data from the table: "online_booking_service_area_zip_codes" using primary key columns */
  onlineBookingServiceAreaZipCodesByPk?: Maybe<OnlineBookingServiceAreaZipCodes>;
  /** fetch data from the table: "online_booking_service_type_bookable_job_types" */
  onlineBookingServiceTypeBookableJobTypes: Array<OnlineBookingServiceTypeBookableJobTypes>;
  /** fetch aggregated fields from the table: "online_booking_service_type_bookable_job_types" */
  onlineBookingServiceTypeBookableJobTypesAggregate: OnlineBookingServiceTypeBookableJobTypesAggregate;
  /** fetch data from the table: "online_booking_service_type_bookable_job_types" using primary key columns */
  onlineBookingServiceTypeBookableJobTypesByPk?: Maybe<OnlineBookingServiceTypeBookableJobTypes>;
  /** fetch data from the table: "online_booking_service_type_bookable_technicians" */
  onlineBookingServiceTypeBookableTechnicians: Array<OnlineBookingServiceTypeBookableTechnicians>;
  /** fetch aggregated fields from the table: "online_booking_service_type_bookable_technicians" */
  onlineBookingServiceTypeBookableTechniciansAggregate: OnlineBookingServiceTypeBookableTechniciansAggregate;
  /** fetch data from the table: "online_booking_service_type_bookable_technicians" using primary key columns */
  onlineBookingServiceTypeBookableTechniciansByPk?: Maybe<OnlineBookingServiceTypeBookableTechnicians>;
  /** An array relationship */
  onlineBookingServiceTypeConfigs: Array<OnlineBookingServiceTypeConfigs>;
  /** An aggregate relationship */
  onlineBookingServiceTypeConfigsAggregate: OnlineBookingServiceTypeConfigsAggregate;
  /** fetch data from the table: "online_booking_service_type_configs" using primary key columns */
  onlineBookingServiceTypeConfigsByPk?: Maybe<OnlineBookingServiceTypeConfigs>;
  /** An array relationship */
  paymentLinks: Array<PaymentLinks>;
  /** An aggregate relationship */
  paymentLinksAggregate: PaymentLinksAggregate;
  /** fetch data from the table: "payment_links" using primary key columns */
  paymentLinksByPk?: Maybe<PaymentLinks>;
  /** fetch data from the table: "payment_method_billing_info" */
  paymentMethodBillingInfo: Array<PaymentMethodBillingInfo>;
  /** fetch aggregated fields from the table: "payment_method_billing_info" */
  paymentMethodBillingInfoAggregate: PaymentMethodBillingInfoAggregate;
  /** fetch data from the table: "payment_method_billing_info" using primary key columns */
  paymentMethodBillingInfoByPk?: Maybe<PaymentMethodBillingInfo>;
  /** fetch data from the table: "payment_method_card_metadata" */
  paymentMethodCardMetadata: Array<PaymentMethodCardMetadata>;
  /** fetch aggregated fields from the table: "payment_method_card_metadata" */
  paymentMethodCardMetadataAggregate: PaymentMethodCardMetadataAggregate;
  /** fetch data from the table: "payment_method_card_metadata" using primary key columns */
  paymentMethodCardMetadataByPk?: Maybe<PaymentMethodCardMetadata>;
  /** fetch data from the table: "payment_method_records" */
  paymentMethodRecords: Array<PaymentMethodRecords>;
  /** fetch aggregated fields from the table: "payment_method_records" */
  paymentMethodRecordsAggregate: PaymentMethodRecordsAggregate;
  /** fetch data from the table: "payment_method_records" using primary key columns */
  paymentMethodRecordsByPk?: Maybe<PaymentMethodRecords>;
  /** fetch data from the table: "payment_methods" */
  paymentMethods: Array<PaymentMethods>;
  /** fetch data from the table: "payment_methods" using primary key columns */
  paymentMethodsByPk?: Maybe<PaymentMethods>;
  /** An array relationship */
  paymentRecords: Array<PaymentRecords>;
  /** An aggregate relationship */
  paymentRecordsAggregate: PaymentRecordsAggregate;
  /** fetch data from the table: "payment_records" using primary key columns */
  paymentRecordsByPk?: Maybe<PaymentRecords>;
  /** An array relationship */
  paymentRefunds: Array<PaymentRefunds>;
  /** An aggregate relationship */
  paymentRefundsAggregate: PaymentRefundsAggregate;
  /** fetch data from the table: "payment_refunds" using primary key columns */
  paymentRefundsByPk?: Maybe<PaymentRefunds>;
  /** fetch data from the table: "payment_status_error_detail" */
  paymentStatusErrorDetail: Array<PaymentStatusErrorDetail>;
  /** fetch aggregated fields from the table: "payment_status_error_detail" */
  paymentStatusErrorDetailAggregate: PaymentStatusErrorDetailAggregate;
  /** fetch data from the table: "payment_status_error_detail" using primary key columns */
  paymentStatusErrorDetailByPk?: Maybe<PaymentStatusErrorDetail>;
  /** fetch data from the table: "payment_status_latest" */
  paymentStatusLatest: Array<PaymentStatusLatest>;
  /** fetch aggregated fields from the table: "payment_status_latest" */
  paymentStatusLatestAggregate: PaymentStatusLatestAggregate;
  /** fetch data from the table: "payment_status_latest" using primary key columns */
  paymentStatusLatestByPk?: Maybe<PaymentStatusLatest>;
  /** An array relationship */
  paymentStatuses: Array<PaymentStatuses>;
  /** An aggregate relationship */
  paymentStatusesAggregate: PaymentStatusesAggregate;
  /** fetch data from the table: "payment_statuses" using primary key columns */
  paymentStatusesByPk?: Maybe<PaymentStatuses>;
  /** fetch data from the table: "payment_subscription_invoices" */
  paymentSubscriptionInvoices: Array<PaymentSubscriptionInvoices>;
  /** fetch aggregated fields from the table: "payment_subscription_invoices" */
  paymentSubscriptionInvoicesAggregate: PaymentSubscriptionInvoicesAggregate;
  /** fetch data from the table: "payment_subscription_invoices" using primary key columns */
  paymentSubscriptionInvoicesByPk?: Maybe<PaymentSubscriptionInvoices>;
  /** An array relationship */
  paymentSubscriptionStatuses: Array<PaymentSubscriptionStatuses>;
  /** An aggregate relationship */
  paymentSubscriptionStatusesAggregate: PaymentSubscriptionStatusesAggregate;
  /** fetch data from the table: "payment_subscription_statuses" using primary key columns */
  paymentSubscriptionStatusesByPk?: Maybe<PaymentSubscriptionStatuses>;
  /** fetch data from the table: "payment_subscriptions" */
  paymentSubscriptions: Array<PaymentSubscriptions>;
  /** fetch aggregated fields from the table: "payment_subscriptions" */
  paymentSubscriptionsAggregate: PaymentSubscriptionsAggregate;
  /** fetch data from the table: "payment_subscriptions" using primary key columns */
  paymentSubscriptionsByPk?: Maybe<PaymentSubscriptions>;
  /** fetch data from the table: "payments_accounting_stale_info" */
  paymentsAccountingStaleInfo: Array<PaymentsAccountingStaleInfo>;
  /** fetch aggregated fields from the table: "payments_accounting_stale_info" */
  paymentsAccountingStaleInfoAggregate: PaymentsAccountingStaleInfoAggregate;
  /** fetch data from the table: "payments_qbo_status" */
  paymentsQboStatus: Array<PaymentsQboStatus>;
  /** fetch aggregated fields from the table: "payments_qbo_status" */
  paymentsQboStatusAggregate: PaymentsQboStatusAggregate;
  /** An array relationship */
  payoutItems: Array<PayoutItems>;
  /** An aggregate relationship */
  payoutItemsAggregate: PayoutItemsAggregate;
  /** fetch data from the table: "payout_items" using primary key columns */
  payoutItemsByPk?: Maybe<PayoutItems>;
  /** fetch data from the table: "payout_qbo_accounts_config" */
  payoutQboAccountsConfig: Array<PayoutQboAccountsConfig>;
  /** fetch aggregated fields from the table: "payout_qbo_accounts_config" */
  payoutQboAccountsConfigAggregate: PayoutQboAccountsConfigAggregate;
  /** fetch data from the table: "payout_qbo_accounts_config" using primary key columns */
  payoutQboAccountsConfigByPk?: Maybe<PayoutQboAccountsConfig>;
  /** fetch data from the table: "payouts" */
  payouts: Array<Payouts>;
  /** fetch data from the table: "payouts_accounting_stale_info" */
  payoutsAccountingStaleInfo: Array<PayoutsAccountingStaleInfo>;
  /** fetch aggregated fields from the table: "payouts_accounting_stale_info" */
  payoutsAccountingStaleInfoAggregate: PayoutsAccountingStaleInfoAggregate;
  /** fetch aggregated fields from the table: "payouts" */
  payoutsAggregate: PayoutsAggregate;
  /** fetch data from the table: "payouts" using primary key columns */
  payoutsByPk?: Maybe<Payouts>;
  /** fetch data from the table: "payouts_qbo_status" */
  payoutsQboStatus: Array<PayoutsQboStatus>;
  /** fetch aggregated fields from the table: "payouts_qbo_status" */
  payoutsQboStatusAggregate: PayoutsQboStatusAggregate;
  /** fetch data from the table: "permissions" */
  permissions: Array<Permissions>;
  /** fetch aggregated fields from the table: "permissions" */
  permissionsAggregate: PermissionsAggregate;
  /** fetch data from the table: "permissions" using primary key columns */
  permissionsByPk?: Maybe<Permissions>;
  /** fetch data from the table: "permissions_v2" */
  permissionsV2: Array<PermissionsV2>;
  /** fetch aggregated fields from the table: "permissions_v2" */
  permissionsV2Aggregate: PermissionsV2Aggregate;
  /** fetch data from the table: "permissions_v2" using primary key columns */
  permissionsV2ByPk?: Maybe<PermissionsV2>;
  /** fetch data from the table: "phone_numbers" */
  phoneNumbers: Array<PhoneNumbers>;
  /** fetch aggregated fields from the table: "phone_numbers" */
  phoneNumbersAggregate: PhoneNumbersAggregate;
  /** fetch data from the table: "phone_numbers" using primary key columns */
  phoneNumbersByPk?: Maybe<PhoneNumbers>;
  /** An array relationship */
  photoLinks: Array<PhotoLinks>;
  /** An aggregate relationship */
  photoLinksAggregate: PhotoLinksAggregate;
  /** fetch data from the table: "photo_links" using primary key columns */
  photoLinksByPk?: Maybe<PhotoLinks>;
  /** fetch data from the table: "photos" */
  photos: Array<Photos>;
  /** fetch aggregated fields from the table: "photos" */
  photosAggregate: PhotosAggregate;
  /** fetch data from the table: "photos" using primary key columns */
  photosByPk?: Maybe<Photos>;
  /** fetch data from the table: "pricebook_bundle_items" */
  pricebookBundleItems: Array<PricebookBundleItems>;
  /** fetch aggregated fields from the table: "pricebook_bundle_items" */
  pricebookBundleItemsAggregate: PricebookBundleItemsAggregate;
  /** fetch data from the table: "pricebook_bundle_items" using primary key columns */
  pricebookBundleItemsByPk?: Maybe<PricebookBundleItems>;
  /** fetch data from the table: "pricebook_categories" */
  pricebookCategories: Array<PricebookCategories>;
  /** fetch aggregated fields from the table: "pricebook_categories" */
  pricebookCategoriesAggregate: PricebookCategoriesAggregate;
  /** fetch data from the table: "pricebook_categories" using primary key columns */
  pricebookCategoriesByPk?: Maybe<PricebookCategories>;
  /** fetch data from the table: "pricebook_discounts" */
  pricebookDiscounts: Array<PricebookDiscounts>;
  /** fetch aggregated fields from the table: "pricebook_discounts" */
  pricebookDiscountsAggregate: PricebookDiscountsAggregate;
  /** fetch data from the table: "pricebook_discounts" using primary key columns */
  pricebookDiscountsByPk?: Maybe<PricebookDiscounts>;
  /** fetch data from the table: "pricebook_item_type_fallback_photos" */
  pricebookItemTypeFallbackPhotos: Array<PricebookItemTypeFallbackPhotos>;
  /** fetch aggregated fields from the table: "pricebook_item_type_fallback_photos" */
  pricebookItemTypeFallbackPhotosAggregate: PricebookItemTypeFallbackPhotosAggregate;
  /** fetch data from the table: "pricebook_item_type_fallback_photos" using primary key columns */
  pricebookItemTypeFallbackPhotosByPk?: Maybe<PricebookItemTypeFallbackPhotos>;
  /** An array relationship */
  pricebookItems: Array<PricebookItems>;
  /** An aggregate relationship */
  pricebookItemsAggregate: PricebookItemsAggregate;
  /** fetch data from the table: "pricebook_items" using primary key columns */
  pricebookItemsByPk?: Maybe<PricebookItems>;
  /** fetch data from the table: "pricebook_items_qbo_income_accounts" */
  pricebookItemsQboIncomeAccounts: Array<PricebookItemsQboIncomeAccounts>;
  /** fetch aggregated fields from the table: "pricebook_items_qbo_income_accounts" */
  pricebookItemsQboIncomeAccountsAggregate: PricebookItemsQboIncomeAccountsAggregate;
  /** fetch data from the table: "pricebook_items_qbo_income_accounts" using primary key columns */
  pricebookItemsQboIncomeAccountsByPk?: Maybe<PricebookItemsQboIncomeAccounts>;
  /** fetch data from the table: "pricebook_markup_tiers" */
  pricebookMarkupTiers: Array<PricebookMarkupTiers>;
  /** fetch aggregated fields from the table: "pricebook_markup_tiers" */
  pricebookMarkupTiersAggregate: PricebookMarkupTiersAggregate;
  /** fetch data from the table: "pricebook_markup_tiers" using primary key columns */
  pricebookMarkupTiersByPk?: Maybe<PricebookMarkupTiers>;
  /** An array relationship */
  pricebookTaxRates: Array<PricebookTaxRates>;
  /** An aggregate relationship */
  pricebookTaxRatesAggregate: PricebookTaxRatesAggregate;
  /** fetch data from the table: "pricebook_tax_rates" using primary key columns */
  pricebookTaxRatesByPk?: Maybe<PricebookTaxRates>;
  /** fetch data from the table: "pricebook_versions" */
  pricebookVersions: Array<PricebookVersions>;
  /** fetch aggregated fields from the table: "pricebook_versions" */
  pricebookVersionsAggregate: PricebookVersionsAggregate;
  /** fetch data from the table: "pricebook_versions" using primary key columns */
  pricebookVersionsByPk?: Maybe<PricebookVersions>;
  /** fetch data from the table: "pricebooks_item_prices" */
  pricebooksItemPrices: Array<PricebooksItemPrices>;
  /** fetch aggregated fields from the table: "pricebooks_item_prices" */
  pricebooksItemPricesAggregate: PricebooksItemPricesAggregate;
  /** An array relationship */
  purchaseOrders: Array<PurchaseOrders>;
  /** An aggregate relationship */
  purchaseOrdersAggregate: PurchaseOrdersAggregate;
  /** fetch data from the table: "purchase_orders" using primary key columns */
  purchaseOrdersByPk?: Maybe<PurchaseOrders>;
  /** fetch data from the table: "qbo_auth_data" */
  qboAuthData: Array<QboAuthData>;
  /** fetch aggregated fields from the table: "qbo_auth_data" */
  qboAuthDataAggregate: QboAuthDataAggregate;
  /** fetch data from the table: "qbo_auth_data" using primary key columns */
  qboAuthDataByPk?: Maybe<QboAuthData>;
  /** fetch data from the table: "qbo_cart_item_type_accounts_config" */
  qboCartItemTypeAccountsConfig: Array<QboCartItemTypeAccountsConfig>;
  /** fetch aggregated fields from the table: "qbo_cart_item_type_accounts_config" */
  qboCartItemTypeAccountsConfigAggregate: QboCartItemTypeAccountsConfigAggregate;
  /** fetch data from the table: "qbo_cart_item_type_accounts_config" using primary key columns */
  qboCartItemTypeAccountsConfigByPk?: Maybe<QboCartItemTypeAccountsConfig>;
  /** fetch data from the table: "qbo_sync_info" */
  qboSyncInfo: Array<QboSyncInfo>;
  /** fetch aggregated fields from the table: "qbo_sync_info" */
  qboSyncInfoAggregate: QboSyncInfoAggregate;
  /** fetch data from the table: "qbo_sync_info" using primary key columns */
  qboSyncInfoByPk?: Maybe<QboSyncInfo>;
  /** fetch data from the table: "recent_pricebook_items" */
  recentPricebookItems: Array<RecentPricebookItems>;
  /** fetch aggregated fields from the table: "recent_pricebook_items" */
  recentPricebookItemsAggregate: RecentPricebookItemsAggregate;
  /** fetch data from the table: "recent_pricebook_items" using primary key columns */
  recentPricebookItemsByPk?: Maybe<RecentPricebookItems>;
  /** fetch data from the table: "recommendation_ai_generation_info" */
  recommendationAiGenerationInfo: Array<RecommendationAiGenerationInfo>;
  /** fetch aggregated fields from the table: "recommendation_ai_generation_info" */
  recommendationAiGenerationInfoAggregate: RecommendationAiGenerationInfoAggregate;
  /** fetch data from the table: "recommendation_ai_generation_info" using primary key columns */
  recommendationAiGenerationInfoByPk?: Maybe<RecommendationAiGenerationInfo>;
  /** An array relationship */
  recommendationDismissals: Array<RecommendationDismissals>;
  /** An aggregate relationship */
  recommendationDismissalsAggregate: RecommendationDismissalsAggregate;
  /** fetch data from the table: "recommendation_dismissals" using primary key columns */
  recommendationDismissalsByPk?: Maybe<RecommendationDismissals>;
  /** An array relationship */
  recommendationInteractions: Array<RecommendationInteractions>;
  /** An aggregate relationship */
  recommendationInteractionsAggregate: RecommendationInteractionsAggregate;
  /** fetch data from the table: "recommendation_interactions" using primary key columns */
  recommendationInteractionsByPk?: Maybe<RecommendationInteractions>;
  /** fetch data from the table: "recommendations" */
  recommendations: Array<Recommendations>;
  /** fetch aggregated fields from the table: "recommendations" */
  recommendationsAggregate: RecommendationsAggregate;
  /** fetch data from the table: "recommendations" using primary key columns */
  recommendationsByPk?: Maybe<Recommendations>;
  /** An array relationship */
  reminderAssignments: Array<ReminderAssignments>;
  /** An aggregate relationship */
  reminderAssignmentsAggregate: ReminderAssignmentsAggregate;
  /** fetch data from the table: "reminder_assignments" using primary key columns */
  reminderAssignmentsByPk?: Maybe<ReminderAssignments>;
  /** fetch data from the table: "reminder_internal_notifications" */
  reminderInternalNotifications: Array<ReminderInternalNotifications>;
  /** fetch aggregated fields from the table: "reminder_internal_notifications" */
  reminderInternalNotificationsAggregate: ReminderInternalNotificationsAggregate;
  /** fetch data from the table: "reminder_internal_notifications" using primary key columns */
  reminderInternalNotificationsByPk?: Maybe<ReminderInternalNotifications>;
  /** fetch data from the table: "reminders" */
  reminders: Array<Reminders>;
  /** fetch aggregated fields from the table: "reminders" */
  remindersAggregate: RemindersAggregate;
  /** fetch data from the table: "reminders" using primary key columns */
  remindersByPk?: Maybe<Reminders>;
  /** fetch data from the table: "rep_company_metabase_config" */
  repCompanyMetabaseConfig: Array<RepCompanyMetabaseConfig>;
  /** fetch aggregated fields from the table: "rep_company_metabase_config" */
  repCompanyMetabaseConfigAggregate: RepCompanyMetabaseConfigAggregate;
  /** fetch data from the table: "rep_company_metabase_config" using primary key columns */
  repCompanyMetabaseConfigByPk?: Maybe<RepCompanyMetabaseConfig>;
  /** An array relationship */
  repMetabaseCompanyReports: Array<RepMetabaseCompanyReports>;
  /** An aggregate relationship */
  repMetabaseCompanyReportsAggregate: RepMetabaseCompanyReportsAggregate;
  /** fetch data from the table: "rep_metabase_company_reports" using primary key columns */
  repMetabaseCompanyReportsByPk?: Maybe<RepMetabaseCompanyReports>;
  /** fetch data from the table: "rep_metabase_pulses" */
  repMetabasePulses: Array<RepMetabasePulses>;
  /** fetch aggregated fields from the table: "rep_metabase_pulses" */
  repMetabasePulsesAggregate: RepMetabasePulsesAggregate;
  /** fetch data from the table: "rep_metabase_pulses" using primary key columns */
  repMetabasePulsesByPk?: Maybe<RepMetabasePulses>;
  /** fetch data from the table: "rep_metabase_pulses_v2" */
  repMetabasePulsesV2: Array<RepMetabasePulsesV2>;
  /** fetch aggregated fields from the table: "rep_metabase_pulses_v2" */
  repMetabasePulsesV2Aggregate: RepMetabasePulsesV2Aggregate;
  /** fetch data from the table: "rep_metabase_pulses_v2" using primary key columns */
  repMetabasePulsesV2ByPk?: Maybe<RepMetabasePulsesV2>;
  /** fetch data from the table: "rep_metabase_report_definitions" */
  repMetabaseReportDefinitions: Array<RepMetabaseReportDefinitions>;
  /** fetch aggregated fields from the table: "rep_metabase_report_definitions" */
  repMetabaseReportDefinitionsAggregate: RepMetabaseReportDefinitionsAggregate;
  /** fetch data from the table: "rep_metabase_report_definitions" using primary key columns */
  repMetabaseReportDefinitionsByPk?: Maybe<RepMetabaseReportDefinitions>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tagsAggregate: TagsAggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tagsByPk?: Maybe<Tags>;
  /** fetch data from the table: "technician_capacities" */
  technicianCapacities: Array<TechnicianCapacities>;
  /** fetch aggregated fields from the table: "technician_capacities" */
  technicianCapacitiesAggregate: TechnicianCapacitiesAggregate;
  /** fetch data from the table: "technician_capacities" using primary key columns */
  technicianCapacitiesByPk?: Maybe<TechnicianCapacities>;
  /** fetch data from the table: "technician_capacity_blocks" */
  technicianCapacityBlocks: Array<TechnicianCapacityBlocks>;
  /** fetch aggregated fields from the table: "technician_capacity_blocks" */
  technicianCapacityBlocksAggregate: TechnicianCapacityBlocksAggregate;
  /** fetch data from the table: "technician_capacity_blocks" using primary key columns */
  technicianCapacityBlocksByPk?: Maybe<TechnicianCapacityBlocks>;
  /** fetch data from the table: "tilled_raw_events" */
  tilledRawEvents: Array<TilledRawEvents>;
  /** fetch aggregated fields from the table: "tilled_raw_events" */
  tilledRawEventsAggregate: TilledRawEventsAggregate;
  /** fetch data from the table: "tilled_raw_events" using primary key columns */
  tilledRawEventsByPk?: Maybe<TilledRawEvents>;
  /** An array relationship */
  timesheetEntries: Array<TimesheetEntries>;
  /** An aggregate relationship */
  timesheetEntriesAggregate: TimesheetEntriesAggregate;
  /** fetch data from the table: "timesheet_entries" using primary key columns */
  timesheetEntriesByPk?: Maybe<TimesheetEntries>;
  /** An array relationship */
  timesheetEntryActivities: Array<TimesheetEntryActivities>;
  /** An aggregate relationship */
  timesheetEntryActivitiesAggregate: TimesheetEntryActivitiesAggregate;
  /** fetch data from the table: "timesheet_entry_activities" using primary key columns */
  timesheetEntryActivitiesByPk?: Maybe<TimesheetEntryActivities>;
  /** An array relationship */
  timesheetEntryLinkData: Array<TimesheetEntryLinkData>;
  /** An aggregate relationship */
  timesheetEntryLinkDataAggregate: TimesheetEntryLinkDataAggregate;
  /** fetch data from the table: "timesheet_entry_link_data" using primary key columns */
  timesheetEntryLinkDataByPk?: Maybe<TimesheetEntryLinkData>;
  /** fetch data from the table: "tune_up_visit_entitlements" */
  tuneUpVisitEntitlements: Array<TuneUpVisitEntitlements>;
  /** fetch aggregated fields from the table: "tune_up_visit_entitlements" */
  tuneUpVisitEntitlementsAggregate: TuneUpVisitEntitlementsAggregate;
  /** fetch data from the table: "tune_up_visit_entitlements" using primary key columns */
  tuneUpVisitEntitlementsByPk?: Maybe<TuneUpVisitEntitlements>;
  /** fetch data from the table: "unnotified_account_reminders" */
  unnotifiedAccountReminders: Array<UnnotifiedAccountReminders>;
  /** fetch aggregated fields from the table: "unnotified_account_reminders" */
  unnotifiedAccountRemindersAggregate: UnnotifiedAccountRemindersAggregate;
  /** fetch data from the table: "user_business_units" */
  userBusinessUnits: Array<UserBusinessUnits>;
  /** fetch aggregated fields from the table: "user_business_units" */
  userBusinessUnitsAggregate: UserBusinessUnitsAggregate;
  /** fetch data from the table: "user_business_units" using primary key columns */
  userBusinessUnitsByPk?: Maybe<UserBusinessUnits>;
  /** An array relationship */
  userPermissions: Array<UserPermissions>;
  /** An aggregate relationship */
  userPermissionsAggregate: UserPermissionsAggregate;
  /** fetch data from the table: "user_permissions" using primary key columns */
  userPermissionsByPk?: Maybe<UserPermissions>;
  /** An array relationship */
  userPermissionsV2: Array<UserPermissionsV2>;
  /** An aggregate relationship */
  userPermissionsV2Aggregate: UserPermissionsV2Aggregate;
  /** fetch data from the table: "user_permissions_v2" using primary key columns */
  userPermissionsV2ByPk?: Maybe<UserPermissionsV2>;
  /** An array relationship */
  userPhoneNumbers: Array<UserPhoneNumbers>;
  /** An aggregate relationship */
  userPhoneNumbersAggregate: UserPhoneNumbersAggregate;
  /** fetch data from the table: "user_phone_numbers" using primary key columns */
  userPhoneNumbersByPk?: Maybe<UserPhoneNumbers>;
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRolesAggregate: UserRolesAggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  userRolesByPk?: Maybe<UserRoles>;
  /** An array relationship */
  userSettings: Array<UserSettings>;
  /** An aggregate relationship */
  userSettingsAggregate: UserSettingsAggregate;
  /** fetch data from the table: "user_settings" using primary key columns */
  userSettingsByPk?: Maybe<UserSettings>;
  /** fetch data from the table: "user_wages" */
  userWages: Array<UserWages>;
  /** fetch aggregated fields from the table: "user_wages" */
  userWagesAggregate: UserWagesAggregate;
  /** fetch data from the table: "user_wages" using primary key columns */
  userWagesByPk?: Maybe<UserWages>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  usersAggregate: UsersAggregate;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk?: Maybe<Users>;
  /** An array relationship */
  wisetackLoanRecords: Array<WisetackLoanRecords>;
  /** An aggregate relationship */
  wisetackLoanRecordsAggregate: WisetackLoanRecordsAggregate;
  /** fetch data from the table: "wisetack_loan_records" using primary key columns */
  wisetackLoanRecordsByPk?: Maybe<WisetackLoanRecords>;
  /** An array relationship */
  wisetackLoanStatuses: Array<WisetackLoanStatuses>;
  /** An aggregate relationship */
  wisetackLoanStatusesAggregate: WisetackLoanStatusesAggregate;
  /** fetch data from the table: "wisetack_loan_statuses" using primary key columns */
  wisetackLoanStatusesByPk?: Maybe<WisetackLoanStatuses>;
  /** An array relationship */
  wisetackPrequalRecords: Array<WisetackPrequalRecords>;
  /** An aggregate relationship */
  wisetackPrequalRecordsAggregate: WisetackPrequalRecordsAggregate;
  /** fetch data from the table: "wisetack_prequal_records" using primary key columns */
  wisetackPrequalRecordsByPk?: Maybe<WisetackPrequalRecords>;
  /** fetch data from the table: "wisetack_webhook_events" */
  wisetackWebhookEvents: Array<WisetackWebhookEvents>;
  /** fetch aggregated fields from the table: "wisetack_webhook_events" */
  wisetackWebhookEventsAggregate: WisetackWebhookEventsAggregate;
  /** fetch data from the table: "wisetack_webhook_events" using primary key columns */
  wisetackWebhookEventsByPk?: Maybe<WisetackWebhookEvents>;
};


export type Query_RootAccCartItemTypeAccountsConfigArgs = {
  distinctOn?: InputMaybe<Array<AccCartItemTypeAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccCartItemTypeAccountsConfigOrderBy>>;
  where?: InputMaybe<AccCartItemTypeAccountsConfigBoolExp>;
};


export type Query_RootAccCartItemTypeAccountsConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccCartItemTypeAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccCartItemTypeAccountsConfigOrderBy>>;
  where?: InputMaybe<AccCartItemTypeAccountsConfigBoolExp>;
};


export type Query_RootAccCartItemTypeAccountsConfigByPkArgs = {
  accCartItemTypeAccountsConfigGuid: Scalars['uuid'];
};


export type Query_RootAccCompanyConfigArgs = {
  distinctOn?: InputMaybe<Array<AccCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccCompanyConfigOrderBy>>;
  where?: InputMaybe<AccCompanyConfigBoolExp>;
};


export type Query_RootAccCompanyConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccCompanyConfigOrderBy>>;
  where?: InputMaybe<AccCompanyConfigBoolExp>;
};


export type Query_RootAccCompanyConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootAccPayoutAccountsConfigArgs = {
  distinctOn?: InputMaybe<Array<AccPayoutAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccPayoutAccountsConfigOrderBy>>;
  where?: InputMaybe<AccPayoutAccountsConfigBoolExp>;
};


export type Query_RootAccPayoutAccountsConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccPayoutAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccPayoutAccountsConfigOrderBy>>;
  where?: InputMaybe<AccPayoutAccountsConfigBoolExp>;
};


export type Query_RootAccPayoutAccountsConfigByPkArgs = {
  accPayoutAccountsConfigId: Scalars['uuid'];
};


export type Query_RootAccQbdConductorConfigArgs = {
  distinctOn?: InputMaybe<Array<AccQbdConductorConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccQbdConductorConfigOrderBy>>;
  where?: InputMaybe<AccQbdConductorConfigBoolExp>;
};


export type Query_RootAccQbdConductorConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccQbdConductorConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccQbdConductorConfigOrderBy>>;
  where?: InputMaybe<AccQbdConductorConfigBoolExp>;
};


export type Query_RootAccQbdConductorConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootAccQbdConductorUptimeArgs = {
  distinctOn?: InputMaybe<Array<AccQbdConductorUptimeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccQbdConductorUptimeOrderBy>>;
  where?: InputMaybe<AccQbdConductorUptimeBoolExp>;
};


export type Query_RootAccQbdConductorUptimeAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccQbdConductorUptimeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccQbdConductorUptimeOrderBy>>;
  where?: InputMaybe<AccQbdConductorUptimeBoolExp>;
};


export type Query_RootAccQbdConductorUptimeByPkArgs = {
  uptimeCheckGuid: Scalars['uuid'];
};


export type Query_RootAccSyncInfoArgs = {
  distinctOn?: InputMaybe<Array<AccSyncInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccSyncInfoOrderBy>>;
  where?: InputMaybe<AccSyncInfoBoolExp>;
};


export type Query_RootAccSyncInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccSyncInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccSyncInfoOrderBy>>;
  where?: InputMaybe<AccSyncInfoBoolExp>;
};


export type Query_RootAccSyncInfoByPkArgs = {
  accountingIntegrationType: Scalars['String'];
  breezyEntityGuid: Scalars['uuid'];
  breezyEntityType: Scalars['String'];
  companyGuid: Scalars['uuid'];
};


export type Query_RootAccSyncQueueItemsArgs = {
  distinctOn?: InputMaybe<Array<AccSyncQueueItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccSyncQueueItemsOrderBy>>;
  where?: InputMaybe<AccSyncQueueItemsBoolExp>;
};


export type Query_RootAccSyncQueueItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccSyncQueueItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccSyncQueueItemsOrderBy>>;
  where?: InputMaybe<AccSyncQueueItemsBoolExp>;
};


export type Query_RootAccSyncQueueItemsByPkArgs = {
  accSyncQueueItemGuid: Scalars['uuid'];
};


export type Query_RootAccountContactsArgs = {
  distinctOn?: InputMaybe<Array<AccountContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountContactsOrderBy>>;
  where?: InputMaybe<AccountContactsBoolExp>;
};


export type Query_RootAccountContactsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountContactsOrderBy>>;
  where?: InputMaybe<AccountContactsBoolExp>;
};


export type Query_RootAccountContactsByPkArgs = {
  accountContactGuid: Scalars['uuid'];
};


export type Query_RootAccountJobCountsArgs = {
  distinctOn?: InputMaybe<Array<AccountJobCountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountJobCountsOrderBy>>;
  where?: InputMaybe<AccountJobCountsBoolExp>;
};


export type Query_RootAccountLocationsArgs = {
  distinctOn?: InputMaybe<Array<AccountLocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountLocationsOrderBy>>;
  where?: InputMaybe<AccountLocationsBoolExp>;
};


export type Query_RootAccountLocationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountLocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountLocationsOrderBy>>;
  where?: InputMaybe<AccountLocationsBoolExp>;
};


export type Query_RootAccountLocationsByPkArgs = {
  accountGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
};


export type Query_RootAccountRemindersArgs = {
  distinctOn?: InputMaybe<Array<AccountRemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountRemindersOrderBy>>;
  where?: InputMaybe<AccountRemindersBoolExp>;
};


export type Query_RootAccountRemindersAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountRemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountRemindersOrderBy>>;
  where?: InputMaybe<AccountRemindersBoolExp>;
};


export type Query_RootAccountRemindersByPkArgs = {
  accountGuid: Scalars['uuid'];
  reminderGuid: Scalars['uuid'];
};


export type Query_RootAccountStatementEventsArgs = {
  distinctOn?: InputMaybe<Array<AccountStatementEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountStatementEventsOrderBy>>;
  where?: InputMaybe<AccountStatementEventsBoolExp>;
};


export type Query_RootAccountStatementEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountStatementEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountStatementEventsOrderBy>>;
  where?: InputMaybe<AccountStatementEventsBoolExp>;
};


export type Query_RootAccountStatementEventsByPkArgs = {
  statementEventGuid: Scalars['uuid'];
};


export type Query_RootAccountTagsArgs = {
  distinctOn?: InputMaybe<Array<AccountTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountTagsOrderBy>>;
  where?: InputMaybe<AccountTagsBoolExp>;
};


export type Query_RootAccountTagsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountTagsOrderBy>>;
  where?: InputMaybe<AccountTagsBoolExp>;
};


export type Query_RootAccountTagsByPkArgs = {
  accountGuid: Scalars['uuid'];
  tagGuid: Scalars['uuid'];
};


export type Query_RootAccountTypesArgs = {
  distinctOn?: InputMaybe<Array<AccountTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountTypesOrderBy>>;
  where?: InputMaybe<AccountTypesBoolExp>;
};


export type Query_RootAccountTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountTypesOrderBy>>;
  where?: InputMaybe<AccountTypesBoolExp>;
};


export type Query_RootAccountTypesByPkArgs = {
  name: Scalars['String'];
};


export type Query_RootAccountsArgs = {
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Query_RootAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Query_RootAccountsByPkArgs = {
  accountGuid: Scalars['uuid'];
};


export type Query_RootAccountsReceivableArgs = {
  distinctOn?: InputMaybe<Array<AccountsReceivableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsReceivableOrderBy>>;
  where?: InputMaybe<AccountsReceivableBoolExp>;
};


export type Query_RootAccountsReceivableAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountsReceivableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsReceivableOrderBy>>;
  where?: InputMaybe<AccountsReceivableBoolExp>;
};


export type Query_RootAccountsSortedByJobCountArgs = {
  args: AccountsSortedByJobCountArgs;
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Query_RootAccountsSortedByJobCountAggregateArgs = {
  args: AccountsSortedByJobCountArgs;
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Query_RootAccountsSortedByRecentlyViewedForUserArgs = {
  args: AccountsSortedByRecentlyViewedForUserArgs;
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Query_RootAccountsSortedByRecentlyViewedForUserAggregateArgs = {
  args: AccountsSortedByRecentlyViewedForUserArgs;
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Query_RootAccountsViewedByUserArgs = {
  distinctOn?: InputMaybe<Array<AccountsViewedByUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsViewedByUserOrderBy>>;
  where?: InputMaybe<AccountsViewedByUserBoolExp>;
};


export type Query_RootAccountsViewedByUserAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountsViewedByUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsViewedByUserOrderBy>>;
  where?: InputMaybe<AccountsViewedByUserBoolExp>;
};


export type Query_RootAccountsViewedByUserByPkArgs = {
  accountGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


export type Query_RootActivityItemsArgs = {
  distinctOn?: InputMaybe<Array<ActivityItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityItemsOrderBy>>;
  where?: InputMaybe<ActivityItemsBoolExp>;
};


export type Query_RootActivityItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityItemsOrderBy>>;
  where?: InputMaybe<ActivityItemsBoolExp>;
};


export type Query_RootActivityItemsByPkArgs = {
  activityItemGuid: Scalars['uuid'];
};


export type Query_RootAddressesArgs = {
  distinctOn?: InputMaybe<Array<AddressesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
  where?: InputMaybe<AddressesBoolExp>;
};


export type Query_RootAddressesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AddressesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
  where?: InputMaybe<AddressesBoolExp>;
};


export type Query_RootAddressesByPkArgs = {
  addressGuid: Scalars['uuid'];
};


export type Query_RootAggregatableInvoicesArgs = {
  distinctOn?: InputMaybe<Array<AggregatableInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AggregatableInvoicesOrderBy>>;
  where?: InputMaybe<AggregatableInvoicesBoolExp>;
};


export type Query_RootAggregatableInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AggregatableInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AggregatableInvoicesOrderBy>>;
  where?: InputMaybe<AggregatableInvoicesBoolExp>;
};


export type Query_RootApplicationTasksArgs = {
  distinctOn?: InputMaybe<Array<ApplicationTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ApplicationTasksOrderBy>>;
  where?: InputMaybe<ApplicationTasksBoolExp>;
};


export type Query_RootApplicationTasksAggregateArgs = {
  distinctOn?: InputMaybe<Array<ApplicationTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ApplicationTasksOrderBy>>;
  where?: InputMaybe<ApplicationTasksBoolExp>;
};


export type Query_RootApplicationTasksByPkArgs = {
  taskGuid: Scalars['uuid'];
};


export type Query_RootAppointmentChecklistAssociationRulesArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistAssociationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistAssociationRulesOrderBy>>;
  where?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
};


export type Query_RootAppointmentChecklistAssociationRulesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistAssociationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistAssociationRulesOrderBy>>;
  where?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
};


export type Query_RootAppointmentChecklistAssociationRulesByPkArgs = {
  appointmentChecklistAssociationRuleGuid: Scalars['uuid'];
};


export type Query_RootAppointmentChecklistInstancesArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistInstancesOrderBy>>;
  where?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
};


export type Query_RootAppointmentChecklistInstancesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistInstancesOrderBy>>;
  where?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
};


export type Query_RootAppointmentChecklistInstancesByPkArgs = {
  appointmentChecklistInstanceGuid: Scalars['uuid'];
};


export type Query_RootAppointmentChecklistsArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistsOrderBy>>;
  where?: InputMaybe<AppointmentChecklistsBoolExp>;
};


export type Query_RootAppointmentChecklistsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistsOrderBy>>;
  where?: InputMaybe<AppointmentChecklistsBoolExp>;
};


export type Query_RootAppointmentChecklistsByPkArgs = {
  appointmentChecklistGuid: Scalars['uuid'];
};


export type Query_RootAssistantIntegratedPhonesArgs = {
  distinctOn?: InputMaybe<Array<AssistantIntegratedPhonesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantIntegratedPhonesOrderBy>>;
  where?: InputMaybe<AssistantIntegratedPhonesBoolExp>;
};


export type Query_RootAssistantIntegratedPhonesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AssistantIntegratedPhonesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantIntegratedPhonesOrderBy>>;
  where?: InputMaybe<AssistantIntegratedPhonesBoolExp>;
};


export type Query_RootAssistantIntegratedPhonesByPkArgs = {
  assistantGuid: Scalars['uuid'];
  integratedPhoneGuid: Scalars['uuid'];
};


export type Query_RootAssistantPhoneSettingsArgs = {
  distinctOn?: InputMaybe<Array<AssistantPhoneSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantPhoneSettingsOrderBy>>;
  where?: InputMaybe<AssistantPhoneSettingsBoolExp>;
};


export type Query_RootAssistantPhoneSettingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AssistantPhoneSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantPhoneSettingsOrderBy>>;
  where?: InputMaybe<AssistantPhoneSettingsBoolExp>;
};


export type Query_RootAssistantPhoneSettingsByPkArgs = {
  assistantGuid: Scalars['uuid'];
};


export type Query_RootAssistantsArgs = {
  distinctOn?: InputMaybe<Array<AssistantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantsOrderBy>>;
  where?: InputMaybe<AssistantsBoolExp>;
};


export type Query_RootAssistantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AssistantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantsOrderBy>>;
  where?: InputMaybe<AssistantsBoolExp>;
};


export type Query_RootAssistantsByPkArgs = {
  assistantGuid: Scalars['uuid'];
};


export type Query_RootBillingProfileHiddenPaymentMethodsArgs = {
  distinctOn?: InputMaybe<Array<BillingProfileHiddenPaymentMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingProfileHiddenPaymentMethodsOrderBy>>;
  where?: InputMaybe<BillingProfileHiddenPaymentMethodsBoolExp>;
};


export type Query_RootBillingProfileHiddenPaymentMethodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BillingProfileHiddenPaymentMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingProfileHiddenPaymentMethodsOrderBy>>;
  where?: InputMaybe<BillingProfileHiddenPaymentMethodsBoolExp>;
};


export type Query_RootBillingProfileHiddenPaymentMethodsByPkArgs = {
  companyGuid: Scalars['uuid'];
  paymentMethod: PaymentMethodsEnum;
};


export type Query_RootBillingProfilesArgs = {
  distinctOn?: InputMaybe<Array<BillingProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingProfilesOrderBy>>;
  where?: InputMaybe<BillingProfilesBoolExp>;
};


export type Query_RootBillingProfilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BillingProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingProfilesOrderBy>>;
  where?: InputMaybe<BillingProfilesBoolExp>;
};


export type Query_RootBillingProfilesByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootBusinessEventsArgs = {
  distinctOn?: InputMaybe<Array<BusinessEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessEventsOrderBy>>;
  where?: InputMaybe<BusinessEventsBoolExp>;
};


export type Query_RootBusinessEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessEventsOrderBy>>;
  where?: InputMaybe<BusinessEventsBoolExp>;
};


export type Query_RootBusinessEventsByPkArgs = {
  businessEventGuid: Scalars['uuid'];
};


export type Query_RootBusinessUnitTargetMetricsArgs = {
  distinctOn?: InputMaybe<Array<BusinessUnitTargetMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessUnitTargetMetricsOrderBy>>;
  where?: InputMaybe<BusinessUnitTargetMetricsBoolExp>;
};


export type Query_RootBusinessUnitTargetMetricsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUnitTargetMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessUnitTargetMetricsOrderBy>>;
  where?: InputMaybe<BusinessUnitTargetMetricsBoolExp>;
};


export type Query_RootBusinessUnitTargetMetricsByPkArgs = {
  businessUnitTargetMetricGuid: Scalars['uuid'];
};


export type Query_RootBusinessUnitsArgs = {
  distinctOn?: InputMaybe<Array<BusinessUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessUnitsOrderBy>>;
  where?: InputMaybe<BusinessUnitsBoolExp>;
};


export type Query_RootBusinessUnitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessUnitsOrderBy>>;
  where?: InputMaybe<BusinessUnitsBoolExp>;
};


export type Query_RootBusinessUnitsByPkArgs = {
  businessUnitGuid: Scalars['uuid'];
};


export type Query_RootCanonicalLeadSourcesArgs = {
  distinctOn?: InputMaybe<Array<CanonicalLeadSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CanonicalLeadSourcesOrderBy>>;
  where?: InputMaybe<CanonicalLeadSourcesBoolExp>;
};


export type Query_RootCanonicalLeadSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CanonicalLeadSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CanonicalLeadSourcesOrderBy>>;
  where?: InputMaybe<CanonicalLeadSourcesBoolExp>;
};


export type Query_RootCanonicalLeadSourcesByPkArgs = {
  canonicalLeadSourceName: Scalars['String'];
};


export type Query_RootCartItemJobCostLinksArgs = {
  distinctOn?: InputMaybe<Array<CartItemJobCostLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CartItemJobCostLinksOrderBy>>;
  where?: InputMaybe<CartItemJobCostLinksBoolExp>;
};


export type Query_RootCartItemJobCostLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<CartItemJobCostLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CartItemJobCostLinksOrderBy>>;
  where?: InputMaybe<CartItemJobCostLinksBoolExp>;
};


export type Query_RootCartItemJobCostLinksByPkArgs = {
  cartItemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
};


export type Query_RootCartItemsArgs = {
  distinctOn?: InputMaybe<Array<CartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CartItemsOrderBy>>;
  where?: InputMaybe<CartItemsBoolExp>;
};


export type Query_RootCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CartItemsOrderBy>>;
  where?: InputMaybe<CartItemsBoolExp>;
};


export type Query_RootCartItemsByPkArgs = {
  cartItemGuid: Scalars['uuid'];
};


export type Query_RootChecklistItemsArgs = {
  distinctOn?: InputMaybe<Array<ChecklistItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChecklistItemsOrderBy>>;
  where?: InputMaybe<ChecklistItemsBoolExp>;
};


export type Query_RootChecklistItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChecklistItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChecklistItemsOrderBy>>;
  where?: InputMaybe<ChecklistItemsBoolExp>;
};


export type Query_RootChecklistItemsByPkArgs = {
  checklistItemGuid: Scalars['uuid'];
};


export type Query_RootCompaniesArgs = {
  distinctOn?: InputMaybe<Array<CompaniesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompaniesOrderBy>>;
  where?: InputMaybe<CompaniesBoolExp>;
};


export type Query_RootCompaniesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompaniesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompaniesOrderBy>>;
  where?: InputMaybe<CompaniesBoolExp>;
};


export type Query_RootCompaniesByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootCompanyAppointmentArrivalWindowsArgs = {
  distinctOn?: InputMaybe<Array<CompanyAppointmentArrivalWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyAppointmentArrivalWindowsOrderBy>>;
  where?: InputMaybe<CompanyAppointmentArrivalWindowsBoolExp>;
};


export type Query_RootCompanyAppointmentArrivalWindowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyAppointmentArrivalWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyAppointmentArrivalWindowsOrderBy>>;
  where?: InputMaybe<CompanyAppointmentArrivalWindowsBoolExp>;
};


export type Query_RootCompanyAppointmentArrivalWindowsByPkArgs = {
  companyAppointmentArrivalWindowGuid: Scalars['uuid'];
};


export type Query_RootCompanyCommissionConfigArgs = {
  distinctOn?: InputMaybe<Array<CompanyCommissionConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyCommissionConfigOrderBy>>;
  where?: InputMaybe<CompanyCommissionConfigBoolExp>;
};


export type Query_RootCompanyCommissionConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyCommissionConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyCommissionConfigOrderBy>>;
  where?: InputMaybe<CompanyCommissionConfigBoolExp>;
};


export type Query_RootCompanyCommissionConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootCompanyConfigArgs = {
  distinctOn?: InputMaybe<Array<CompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyConfigOrderBy>>;
  where?: InputMaybe<CompanyConfigBoolExp>;
};


export type Query_RootCompanyConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyConfigOrderBy>>;
  where?: InputMaybe<CompanyConfigBoolExp>;
};


export type Query_RootCompanyConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootCompanyDripMarketingConfigArgs = {
  distinctOn?: InputMaybe<Array<CompanyDripMarketingConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDripMarketingConfigOrderBy>>;
  where?: InputMaybe<CompanyDripMarketingConfigBoolExp>;
};


export type Query_RootCompanyDripMarketingConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyDripMarketingConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDripMarketingConfigOrderBy>>;
  where?: InputMaybe<CompanyDripMarketingConfigBoolExp>;
};


export type Query_RootCompanyDripMarketingConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootCompanyLeadSourceLinksArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourceLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourceLinksOrderBy>>;
  where?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
};


export type Query_RootCompanyLeadSourceLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourceLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourceLinksOrderBy>>;
  where?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
};


export type Query_RootCompanyLeadSourceLinksByPkArgs = {
  companyLeadSourceLinkGuid: Scalars['uuid'];
};


export type Query_RootCompanyLeadSourcesArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourcesOrderBy>>;
  where?: InputMaybe<CompanyLeadSourcesBoolExp>;
};


export type Query_RootCompanyLeadSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourcesOrderBy>>;
  where?: InputMaybe<CompanyLeadSourcesBoolExp>;
};


export type Query_RootCompanyLeadSourcesByPkArgs = {
  companyLeadSourceGuid: Scalars['uuid'];
};


export type Query_RootCompanyNotificationSettingsArgs = {
  distinctOn?: InputMaybe<Array<CompanyNotificationSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyNotificationSettingsOrderBy>>;
  where?: InputMaybe<CompanyNotificationSettingsBoolExp>;
};


export type Query_RootCompanyNotificationSettingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyNotificationSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyNotificationSettingsOrderBy>>;
  where?: InputMaybe<CompanyNotificationSettingsBoolExp>;
};


export type Query_RootCompanyNotificationSettingsByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootCompanyPricingTierConfigArgs = {
  distinctOn?: InputMaybe<Array<CompanyPricingTierConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyPricingTierConfigOrderBy>>;
  where?: InputMaybe<CompanyPricingTierConfigBoolExp>;
};


export type Query_RootCompanyPricingTierConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyPricingTierConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyPricingTierConfigOrderBy>>;
  where?: InputMaybe<CompanyPricingTierConfigBoolExp>;
};


export type Query_RootCompanyPricingTierConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootCompanyReviewLinksArgs = {
  distinctOn?: InputMaybe<Array<CompanyReviewLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyReviewLinksOrderBy>>;
  where?: InputMaybe<CompanyReviewLinksBoolExp>;
};


export type Query_RootCompanyReviewLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyReviewLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyReviewLinksOrderBy>>;
  where?: InputMaybe<CompanyReviewLinksBoolExp>;
};


export type Query_RootCompanyReviewLinksByPkArgs = {
  companyReviewLinkGuid: Scalars['uuid'];
};


export type Query_RootCompanyRolesArgs = {
  distinctOn?: InputMaybe<Array<CompanyRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyRolesOrderBy>>;
  where?: InputMaybe<CompanyRolesBoolExp>;
};


export type Query_RootCompanyRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyRolesOrderBy>>;
  where?: InputMaybe<CompanyRolesBoolExp>;
};


export type Query_RootCompanyRolesByPkArgs = {
  role: Scalars['String'];
};


export type Query_RootCompanyTaxConfigurationsArgs = {
  distinctOn?: InputMaybe<Array<CompanyTaxConfigurationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyTaxConfigurationsOrderBy>>;
  where?: InputMaybe<CompanyTaxConfigurationsBoolExp>;
};


export type Query_RootCompanyTaxConfigurationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyTaxConfigurationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyTaxConfigurationsOrderBy>>;
  where?: InputMaybe<CompanyTaxConfigurationsBoolExp>;
};


export type Query_RootCompanyTaxConfigurationsByPkArgs = {
  companyTaxConfigurationGuid: Scalars['uuid'];
};


export type Query_RootCompanyUsersArgs = {
  distinctOn?: InputMaybe<Array<CompanyUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyUsersOrderBy>>;
  where?: InputMaybe<CompanyUsersBoolExp>;
};


export type Query_RootCompanyUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyUsersOrderBy>>;
  where?: InputMaybe<CompanyUsersBoolExp>;
};


export type Query_RootCompanyUsersByPkArgs = {
  userGuid: Scalars['uuid'];
};


export type Query_RootCompanyWorkingDisplayHoursArgs = {
  distinctOn?: InputMaybe<Array<CompanyWorkingDisplayHoursSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyWorkingDisplayHoursOrderBy>>;
  where?: InputMaybe<CompanyWorkingDisplayHoursBoolExp>;
};


export type Query_RootCompanyWorkingDisplayHoursAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyWorkingDisplayHoursSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyWorkingDisplayHoursOrderBy>>;
  where?: InputMaybe<CompanyWorkingDisplayHoursBoolExp>;
};


export type Query_RootCompanyWorkingDisplayHoursByPkArgs = {
  companyWorkingDisplayHoursGuid: Scalars['uuid'];
};


export type Query_RootContactsArgs = {
  distinctOn?: InputMaybe<Array<ContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
  where?: InputMaybe<ContactsBoolExp>;
};


export type Query_RootContactsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
  where?: InputMaybe<ContactsBoolExp>;
};


export type Query_RootContactsByPkArgs = {
  contactGuid: Scalars['uuid'];
};


export type Query_RootCronJobsArgs = {
  distinctOn?: InputMaybe<Array<CronJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CronJobsOrderBy>>;
  where?: InputMaybe<CronJobsBoolExp>;
};


export type Query_RootCronJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CronJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CronJobsOrderBy>>;
  where?: InputMaybe<CronJobsBoolExp>;
};


export type Query_RootCronJobsByPkArgs = {
  name: Scalars['String'];
};


export type Query_RootCurrentBusinessUnitTargetMetricsViewArgs = {
  distinctOn?: InputMaybe<Array<CurrentBusinessUnitTargetMetricsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrentBusinessUnitTargetMetricsViewOrderBy>>;
  where?: InputMaybe<CurrentBusinessUnitTargetMetricsViewBoolExp>;
};


export type Query_RootCurrentBusinessUnitTargetMetricsViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<CurrentBusinessUnitTargetMetricsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrentBusinessUnitTargetMetricsViewOrderBy>>;
  where?: InputMaybe<CurrentBusinessUnitTargetMetricsViewBoolExp>;
};


export type Query_RootCurrentCompanyTaxConfigurationsViewArgs = {
  distinctOn?: InputMaybe<Array<CurrentCompanyTaxConfigurationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrentCompanyTaxConfigurationsViewOrderBy>>;
  where?: InputMaybe<CurrentCompanyTaxConfigurationsViewBoolExp>;
};


export type Query_RootCurrentCompanyTaxConfigurationsViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<CurrentCompanyTaxConfigurationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrentCompanyTaxConfigurationsViewOrderBy>>;
  where?: InputMaybe<CurrentCompanyTaxConfigurationsViewBoolExp>;
};


export type Query_RootCurrentUserBusinessUnitsViewArgs = {
  distinctOn?: InputMaybe<Array<CurrentUserBusinessUnitsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrentUserBusinessUnitsViewOrderBy>>;
  where?: InputMaybe<CurrentUserBusinessUnitsViewBoolExp>;
};


export type Query_RootCurrentUserBusinessUnitsViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<CurrentUserBusinessUnitsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrentUserBusinessUnitsViewOrderBy>>;
  where?: InputMaybe<CurrentUserBusinessUnitsViewBoolExp>;
};


export type Query_RootCustomerCommunicationTemplatesArgs = {
  distinctOn?: InputMaybe<Array<CustomerCommunicationTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomerCommunicationTemplatesOrderBy>>;
  where?: InputMaybe<CustomerCommunicationTemplatesBoolExp>;
};


export type Query_RootCustomerCommunicationTemplatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CustomerCommunicationTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomerCommunicationTemplatesOrderBy>>;
  where?: InputMaybe<CustomerCommunicationTemplatesBoolExp>;
};


export type Query_RootCustomerCommunicationTemplatesByPkArgs = {
  companyGuid: Scalars['uuid'];
  name: Scalars['String'];
  type: Scalars['String'];
};


export type Query_RootDiscountEntitlementsArgs = {
  distinctOn?: InputMaybe<Array<DiscountEntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiscountEntitlementsOrderBy>>;
  where?: InputMaybe<DiscountEntitlementsBoolExp>;
};


export type Query_RootDiscountEntitlementsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DiscountEntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiscountEntitlementsOrderBy>>;
  where?: InputMaybe<DiscountEntitlementsBoolExp>;
};


export type Query_RootDiscountEntitlementsByPkArgs = {
  entitlementGuid: Scalars['uuid'];
};


export type Query_RootDisplayIdCountersArgs = {
  distinctOn?: InputMaybe<Array<DisplayIdCountersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisplayIdCountersOrderBy>>;
  where?: InputMaybe<DisplayIdCountersBoolExp>;
};


export type Query_RootDisplayIdCountersAggregateArgs = {
  distinctOn?: InputMaybe<Array<DisplayIdCountersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisplayIdCountersOrderBy>>;
  where?: InputMaybe<DisplayIdCountersBoolExp>;
};


export type Query_RootDisplayIdCountersByPkArgs = {
  companyGuid: Scalars['uuid'];
  entityType: Scalars['String'];
};


export type Query_RootDripMarketingEmailsArgs = {
  distinctOn?: InputMaybe<Array<DripMarketingEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DripMarketingEmailsOrderBy>>;
  where?: InputMaybe<DripMarketingEmailsBoolExp>;
};


export type Query_RootDripMarketingEmailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DripMarketingEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DripMarketingEmailsOrderBy>>;
  where?: InputMaybe<DripMarketingEmailsBoolExp>;
};


export type Query_RootDripMarketingEmailsByPkArgs = {
  dripMarketingEmailGuid: Scalars['uuid'];
};


export type Query_RootEmailAddressesArgs = {
  distinctOn?: InputMaybe<Array<EmailAddressesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmailAddressesOrderBy>>;
  where?: InputMaybe<EmailAddressesBoolExp>;
};


export type Query_RootEmailAddressesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailAddressesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmailAddressesOrderBy>>;
  where?: InputMaybe<EmailAddressesBoolExp>;
};


export type Query_RootEmailAddressesByPkArgs = {
  emailAddressGuid: Scalars['uuid'];
};


export type Query_RootEntitlementsArgs = {
  distinctOn?: InputMaybe<Array<EntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EntitlementsOrderBy>>;
  where?: InputMaybe<EntitlementsBoolExp>;
};


export type Query_RootEntitlementsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EntitlementsOrderBy>>;
  where?: InputMaybe<EntitlementsBoolExp>;
};


export type Query_RootEntitlementsByPkArgs = {
  entitlementGuid: Scalars['uuid'];
};


export type Query_RootEquipmentTypeLinksArgs = {
  distinctOn?: InputMaybe<Array<EquipmentTypeLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentTypeLinksOrderBy>>;
  where?: InputMaybe<EquipmentTypeLinksBoolExp>;
};


export type Query_RootEquipmentTypeLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<EquipmentTypeLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentTypeLinksOrderBy>>;
  where?: InputMaybe<EquipmentTypeLinksBoolExp>;
};


export type Query_RootEquipmentTypeLinksByPkArgs = {
  equipmentTypeLinkGuid: Scalars['uuid'];
};


export type Query_RootEquipmentTypesArgs = {
  distinctOn?: InputMaybe<Array<EquipmentTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentTypesOrderBy>>;
  where?: InputMaybe<EquipmentTypesBoolExp>;
};


export type Query_RootEquipmentTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EquipmentTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentTypesOrderBy>>;
  where?: InputMaybe<EquipmentTypesBoolExp>;
};


export type Query_RootEquipmentTypesByPkArgs = {
  name: Scalars['String'];
};


export type Query_RootEstimateInvoicesArgs = {
  distinctOn?: InputMaybe<Array<EstimateInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateInvoicesOrderBy>>;
  where?: InputMaybe<EstimateInvoicesBoolExp>;
};


export type Query_RootEstimateInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateInvoicesOrderBy>>;
  where?: InputMaybe<EstimateInvoicesBoolExp>;
};


export type Query_RootEstimateInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Query_RootEstimateOptionCartItemsArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionCartItemsOrderBy>>;
  where?: InputMaybe<EstimateOptionCartItemsBoolExp>;
};


export type Query_RootEstimateOptionCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionCartItemsOrderBy>>;
  where?: InputMaybe<EstimateOptionCartItemsBoolExp>;
};


export type Query_RootEstimateOptionCartItemsByPkArgs = {
  cartItemGuid: Scalars['uuid'];
};


export type Query_RootEstimateOptionDiscountsArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionDiscountsOrderBy>>;
  where?: InputMaybe<EstimateOptionDiscountsBoolExp>;
};


export type Query_RootEstimateOptionDiscountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionDiscountsOrderBy>>;
  where?: InputMaybe<EstimateOptionDiscountsBoolExp>;
};


export type Query_RootEstimateOptionDiscountsByPkArgs = {
  estimateOptionDiscountGuid: Scalars['uuid'];
};


export type Query_RootEstimateOptionTaxConfigurationsViewArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionTaxConfigurationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionTaxConfigurationsViewOrderBy>>;
  where?: InputMaybe<EstimateOptionTaxConfigurationsViewBoolExp>;
};


export type Query_RootEstimateOptionTaxConfigurationsViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionTaxConfigurationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionTaxConfigurationsViewOrderBy>>;
  where?: InputMaybe<EstimateOptionTaxConfigurationsViewBoolExp>;
};


export type Query_RootEstimateOptionsArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionsOrderBy>>;
  where?: InputMaybe<EstimateOptionsBoolExp>;
};


export type Query_RootEstimateOptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionsOrderBy>>;
  where?: InputMaybe<EstimateOptionsBoolExp>;
};


export type Query_RootEstimateOptionsByPkArgs = {
  estimateOptionGuid: Scalars['uuid'];
};


export type Query_RootEstimatePhotosArgs = {
  distinctOn?: InputMaybe<Array<EstimatePhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatePhotosOrderBy>>;
  where?: InputMaybe<EstimatePhotosBoolExp>;
};


export type Query_RootEstimatePhotosAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimatePhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatePhotosOrderBy>>;
  where?: InputMaybe<EstimatePhotosBoolExp>;
};


export type Query_RootEstimatePhotosByPkArgs = {
  estimateGuid: Scalars['uuid'];
  photoGuid: Scalars['uuid'];
};


export type Query_RootEstimateTemplatesArgs = {
  distinctOn?: InputMaybe<Array<EstimateTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateTemplatesOrderBy>>;
  where?: InputMaybe<EstimateTemplatesBoolExp>;
};


export type Query_RootEstimateTemplatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateTemplatesOrderBy>>;
  where?: InputMaybe<EstimateTemplatesBoolExp>;
};


export type Query_RootEstimateTemplatesByPkArgs = {
  estimateTemplateGuid: Scalars['uuid'];
};


export type Query_RootEstimatesArgs = {
  distinctOn?: InputMaybe<Array<EstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesOrderBy>>;
  where?: InputMaybe<EstimatesBoolExp>;
};


export type Query_RootEstimatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesOrderBy>>;
  where?: InputMaybe<EstimatesBoolExp>;
};


export type Query_RootEstimatesByPkArgs = {
  estimateGuid: Scalars['uuid'];
};


export type Query_RootEstimatesQueryableArgs = {
  distinctOn?: InputMaybe<Array<EstimatesQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesQueryableOrderBy>>;
  where?: InputMaybe<EstimatesQueryableBoolExp>;
};


export type Query_RootEstimatesQueryableAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimatesQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesQueryableOrderBy>>;
  where?: InputMaybe<EstimatesQueryableBoolExp>;
};


export type Query_RootEstimatesQueryableByPkArgs = {
  estimateGuid: Scalars['uuid'];
};


export type Query_RootEventStoreArgs = {
  distinctOn?: InputMaybe<Array<EventStoreSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventStoreOrderBy>>;
  where?: InputMaybe<EventStoreBoolExp>;
};


export type Query_RootEventStoreAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventStoreSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventStoreOrderBy>>;
  where?: InputMaybe<EventStoreBoolExp>;
};


export type Query_RootEventStoreByPkArgs = {
  entityGuid: Scalars['uuid'];
  entityType: Scalars['String'];
  entityVersion: Scalars['numeric'];
};


export type Query_RootFavoritePricebookItemsArgs = {
  distinctOn?: InputMaybe<Array<FavoritePricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FavoritePricebookItemsOrderBy>>;
  where?: InputMaybe<FavoritePricebookItemsBoolExp>;
};


export type Query_RootFavoritePricebookItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<FavoritePricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FavoritePricebookItemsOrderBy>>;
  where?: InputMaybe<FavoritePricebookItemsBoolExp>;
};


export type Query_RootFavoritePricebookItemsByPkArgs = {
  pricebookItemGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


export type Query_RootFileLinksArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


export type Query_RootFileLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


export type Query_RootFileLinksByPkArgs = {
  fileGuid: Scalars['uuid'];
};


export type Query_RootFilesArgs = {
  distinctOn?: InputMaybe<Array<FilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
  where?: InputMaybe<FilesBoolExp>;
};


export type Query_RootFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<FilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
  where?: InputMaybe<FilesBoolExp>;
};


export type Query_RootFilesByPkArgs = {
  fileGuid: Scalars['uuid'];
};


export type Query_RootInstalledEquipmentArgs = {
  distinctOn?: InputMaybe<Array<InstalledEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledEquipmentOrderBy>>;
  where?: InputMaybe<InstalledEquipmentBoolExp>;
};


export type Query_RootInstalledEquipmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstalledEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledEquipmentOrderBy>>;
  where?: InputMaybe<InstalledEquipmentBoolExp>;
};


export type Query_RootInstalledEquipmentByPkArgs = {
  installedEquipmentGuid: Scalars['uuid'];
};


export type Query_RootInstalledHvacSystemsArgs = {
  distinctOn?: InputMaybe<Array<InstalledHvacSystemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledHvacSystemsOrderBy>>;
  where?: InputMaybe<InstalledHvacSystemsBoolExp>;
};


export type Query_RootInstalledHvacSystemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstalledHvacSystemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledHvacSystemsOrderBy>>;
  where?: InputMaybe<InstalledHvacSystemsBoolExp>;
};


export type Query_RootInstalledHvacSystemsByPkArgs = {
  installedHvacSystemGuid: Scalars['uuid'];
};


export type Query_RootInstantBookingWeeklyScheduleEntriesArgs = {
  distinctOn?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesOrderBy>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
};


export type Query_RootInstantBookingWeeklyScheduleEntriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesOrderBy>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
};


export type Query_RootInstantBookingWeeklyScheduleEntriesByPkArgs = {
  instantBookingWeeklyScheduleEntryGuid: Scalars['uuid'];
};


export type Query_RootInstantBookingWeeklyScheduleEntryBookableArrivalWindowsArgs = {
  distinctOn?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsOrderBy>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>;
};


export type Query_RootInstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsOrderBy>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>;
};


export type Query_RootInstantBookingWeeklyScheduleEntryBookableArrivalWindowsByPkArgs = {
  companyAppointmentArrivalWindowGuid: Scalars['uuid'];
  instantBookingWeeklyScheduleEntryGuid: Scalars['uuid'];
};


export type Query_RootIntegratedChannelCompletableItemsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelCompletableItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelCompletableItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelCompletableItemsBoolExp>;
};


export type Query_RootIntegratedChannelCompletableItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelCompletableItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelCompletableItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelCompletableItemsBoolExp>;
};


export type Query_RootIntegratedChannelItemsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelItemsBoolExp>;
};


export type Query_RootIntegratedChannelItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelItemsBoolExp>;
};


export type Query_RootIntegratedChannelReadableItemsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelReadableItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelReadableItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelReadableItemsBoolExp>;
};


export type Query_RootIntegratedChannelReadableItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelReadableItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelReadableItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelReadableItemsBoolExp>;
};


export type Query_RootIntegratedChannelsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelsOrderBy>>;
  where?: InputMaybe<IntegratedChannelsBoolExp>;
};


export type Query_RootIntegratedChannelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelsOrderBy>>;
  where?: InputMaybe<IntegratedChannelsBoolExp>;
};


export type Query_RootIntegratedChannelsByPkArgs = {
  integratedChannelGuid: Scalars['uuid'];
};


export type Query_RootIntegratedMessageStatusesArgs = {
  distinctOn?: InputMaybe<Array<IntegratedMessageStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedMessageStatusesOrderBy>>;
  where?: InputMaybe<IntegratedMessageStatusesBoolExp>;
};


export type Query_RootIntegratedMessageStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedMessageStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedMessageStatusesOrderBy>>;
  where?: InputMaybe<IntegratedMessageStatusesBoolExp>;
};


export type Query_RootIntegratedMessageStatusesByPkArgs = {
  integratedMessageStatusGuid: Scalars['uuid'];
};


export type Query_RootIntegratedMessageTwilioRawWebhookEventsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedMessageTwilioRawWebhookEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedMessageTwilioRawWebhookEventsOrderBy>>;
  where?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsBoolExp>;
};


export type Query_RootIntegratedMessageTwilioRawWebhookEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedMessageTwilioRawWebhookEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedMessageTwilioRawWebhookEventsOrderBy>>;
  where?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsBoolExp>;
};


export type Query_RootIntegratedMessageTwilioRawWebhookEventsByPkArgs = {
  integratedMessageTwilioRawWebhookEventGuid: Scalars['uuid'];
};


export type Query_RootIntegratedMessagesArgs = {
  distinctOn?: InputMaybe<Array<IntegratedMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedMessagesOrderBy>>;
  where?: InputMaybe<IntegratedMessagesBoolExp>;
};


export type Query_RootIntegratedMessagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedMessagesOrderBy>>;
  where?: InputMaybe<IntegratedMessagesBoolExp>;
};


export type Query_RootIntegratedMessagesByPkArgs = {
  integratedMessageGuid: Scalars['uuid'];
};


export type Query_RootIntegratedPhoneCallDismissalsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallDismissalsBoolExp>;
};


export type Query_RootIntegratedPhoneCallDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallDismissalsBoolExp>;
};


export type Query_RootIntegratedPhoneCallDismissalsByPkArgs = {
  integratedPhoneCallDismissalGuid: Scalars['uuid'];
};


export type Query_RootIntegratedPhoneCallJobsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallJobsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
};


export type Query_RootIntegratedPhoneCallJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallJobsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
};


export type Query_RootIntegratedPhoneCallJobsByPkArgs = {
  integratedPhoneCallGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
};


export type Query_RootIntegratedPhoneCallRecordingArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallRecordingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallRecordingOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallRecordingBoolExp>;
};


export type Query_RootIntegratedPhoneCallRecordingAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallRecordingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallRecordingOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallRecordingBoolExp>;
};


export type Query_RootIntegratedPhoneCallRecordingByPkArgs = {
  integratedPhoneCallRecordingGuid: Scalars['uuid'];
};


export type Query_RootIntegratedPhoneCallStatusTypesArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallStatusTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallStatusTypesOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallStatusTypesBoolExp>;
};


export type Query_RootIntegratedPhoneCallStatusTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallStatusTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallStatusTypesOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallStatusTypesBoolExp>;
};


export type Query_RootIntegratedPhoneCallStatusTypesByPkArgs = {
  name: Scalars['String'];
};


export type Query_RootIntegratedPhoneCallStatusesArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallStatusesOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallStatusesBoolExp>;
};


export type Query_RootIntegratedPhoneCallStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallStatusesOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallStatusesBoolExp>;
};


export type Query_RootIntegratedPhoneCallStatusesByPkArgs = {
  integratedPhoneCallStatusGuid: Scalars['uuid'];
};


export type Query_RootIntegratedPhoneCallsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallsBoolExp>;
};


export type Query_RootIntegratedPhoneCallsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallsBoolExp>;
};


export type Query_RootIntegratedPhoneCallsByPkArgs = {
  integratedPhoneCallGuid: Scalars['uuid'];
};


export type Query_RootIntegratedPhoneCompanyConfigArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCompanyConfigOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCompanyConfigBoolExp>;
};


export type Query_RootIntegratedPhoneCompanyConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCompanyConfigOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCompanyConfigBoolExp>;
};


export type Query_RootIntegratedPhoneCompanyConfigByPkArgs = {
  integratedPhoneCompanyConfigGuid: Scalars['uuid'];
};


export type Query_RootIntegratedPhoneMissedCallDismissalsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneMissedCallDismissalsBoolExp>;
};


export type Query_RootIntegratedPhoneMissedCallDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneMissedCallDismissalsBoolExp>;
};


export type Query_RootIntegratedPhoneMissedCallDismissalsByPkArgs = {
  integratedPhoneMissedCallDismissal: Scalars['uuid'];
};


export type Query_RootIntegratedPhoneMissedCallsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneMissedCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneMissedCallsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
};


export type Query_RootIntegratedPhoneMissedCallsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneMissedCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneMissedCallsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
};


export type Query_RootIntegratedPhoneMissedCallsByPkArgs = {
  integratedPhoneMissedCallGuid: Scalars['uuid'];
};


export type Query_RootIntegratedPhoneTwilioRawWebhookEventsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneTwilioRawWebhookEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneTwilioRawWebhookEventsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsBoolExp>;
};


export type Query_RootIntegratedPhoneTwilioRawWebhookEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneTwilioRawWebhookEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneTwilioRawWebhookEventsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsBoolExp>;
};


export type Query_RootIntegratedPhoneTwilioRawWebhookEventsByPkArgs = {
  integratedPhoneTwilioRawWebhookEventGuid: Scalars['uuid'];
};


export type Query_RootIntegratedPhoneUsersArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneUsersOrderBy>>;
  where?: InputMaybe<IntegratedPhoneUsersBoolExp>;
};


export type Query_RootIntegratedPhoneUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneUsersOrderBy>>;
  where?: InputMaybe<IntegratedPhoneUsersBoolExp>;
};


export type Query_RootIntegratedPhoneUsersByPkArgs = {
  integratedPhoneUserGuid: Scalars['uuid'];
};


export type Query_RootIntegratedPhoneVoicemailDismissalsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneVoicemailDismissalsBoolExp>;
};


export type Query_RootIntegratedPhoneVoicemailDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneVoicemailDismissalsBoolExp>;
};


export type Query_RootIntegratedPhoneVoicemailDismissalsByPkArgs = {
  integratedPhoneVoicemailDismissal: Scalars['uuid'];
};


export type Query_RootIntegratedPhoneVoicemailsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneVoicemailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneVoicemailsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneVoicemailsBoolExp>;
};


export type Query_RootIntegratedPhoneVoicemailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneVoicemailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneVoicemailsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneVoicemailsBoolExp>;
};


export type Query_RootIntegratedPhoneVoicemailsByPkArgs = {
  integratedPhoneVoicemailGuid: Scalars['uuid'];
};


export type Query_RootIntegratedPhonesArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhonesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhonesOrderBy>>;
  where?: InputMaybe<IntegratedPhonesBoolExp>;
};


export type Query_RootIntegratedPhonesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhonesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhonesOrderBy>>;
  where?: InputMaybe<IntegratedPhonesBoolExp>;
};


export type Query_RootIntegratedPhonesByPkArgs = {
  integratedPhoneGuid: Scalars['uuid'];
};


export type Query_RootInternalNotificationsArgs = {
  distinctOn?: InputMaybe<Array<InternalNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InternalNotificationsOrderBy>>;
  where?: InputMaybe<InternalNotificationsBoolExp>;
};


export type Query_RootInternalNotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InternalNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InternalNotificationsOrderBy>>;
  where?: InputMaybe<InternalNotificationsBoolExp>;
};


export type Query_RootInternalNotificationsByPkArgs = {
  internalNotificationGuid: Scalars['uuid'];
};


export type Query_RootInvoiceBusinessUnitArgs = {
  distinctOn?: InputMaybe<Array<InvoiceBusinessUnitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceBusinessUnitOrderBy>>;
  where?: InputMaybe<InvoiceBusinessUnitBoolExp>;
};


export type Query_RootInvoiceBusinessUnitAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceBusinessUnitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceBusinessUnitOrderBy>>;
  where?: InputMaybe<InvoiceBusinessUnitBoolExp>;
};


export type Query_RootInvoiceCartItemBundleItemsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemBundleItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemBundleItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemBundleItemsBoolExp>;
};


export type Query_RootInvoiceCartItemBundleItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemBundleItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemBundleItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemBundleItemsBoolExp>;
};


export type Query_RootInvoiceCartItemBundleItemsByPkArgs = {
  invoiceCartItemBundleItemGuid: Scalars['uuid'];
};


export type Query_RootInvoiceCartItemBundleJobCostLinksArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemBundleJobCostLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemBundleJobCostLinksOrderBy>>;
  where?: InputMaybe<InvoiceCartItemBundleJobCostLinksBoolExp>;
};


export type Query_RootInvoiceCartItemBundleJobCostLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemBundleJobCostLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemBundleJobCostLinksOrderBy>>;
  where?: InputMaybe<InvoiceCartItemBundleJobCostLinksBoolExp>;
};


export type Query_RootInvoiceCartItemBundleJobCostLinksByPkArgs = {
  invoiceCartItemBundleItemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
};


export type Query_RootInvoiceCartItemsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemsBoolExp>;
};


export type Query_RootInvoiceCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemsBoolExp>;
};


export type Query_RootInvoiceCartItemsByPkArgs = {
  cartItemGuid: Scalars['uuid'];
  invoiceGuid: Scalars['uuid'];
};


export type Query_RootInvoiceCompanyTaxConfigurationsViewArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCompanyTaxConfigurationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCompanyTaxConfigurationsViewOrderBy>>;
  where?: InputMaybe<InvoiceCompanyTaxConfigurationsViewBoolExp>;
};


export type Query_RootInvoiceCompanyTaxConfigurationsViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCompanyTaxConfigurationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCompanyTaxConfigurationsViewOrderBy>>;
  where?: InputMaybe<InvoiceCompanyTaxConfigurationsViewBoolExp>;
};


export type Query_RootInvoiceDiscountsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceDiscountsOrderBy>>;
  where?: InputMaybe<InvoiceDiscountsBoolExp>;
};


export type Query_RootInvoiceDiscountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceDiscountsOrderBy>>;
  where?: InputMaybe<InvoiceDiscountsBoolExp>;
};


export type Query_RootInvoiceDiscountsByPkArgs = {
  invoiceDiscountGuid: Scalars['uuid'];
};


export type Query_RootInvoiceEventsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceEventsOrderBy>>;
  where?: InputMaybe<InvoiceEventsBoolExp>;
};


export type Query_RootInvoiceEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceEventsOrderBy>>;
  where?: InputMaybe<InvoiceEventsBoolExp>;
};


export type Query_RootInvoiceEventsByPkArgs = {
  invoiceEventGuid: Scalars['uuid'];
};


export type Query_RootInvoicePaymentsArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


export type Query_RootInvoicePaymentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


export type Query_RootInvoicePaymentsByPkArgs = {
  invoiceGuid: Scalars['uuid'];
  paymentRecordGuid: Scalars['uuid'];
};


export type Query_RootInvoiceReminderDataArgs = {
  distinctOn?: InputMaybe<Array<InvoiceReminderDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceReminderDataOrderBy>>;
  where?: InputMaybe<InvoiceReminderDataBoolExp>;
};


export type Query_RootInvoiceReminderDataAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceReminderDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceReminderDataOrderBy>>;
  where?: InputMaybe<InvoiceReminderDataBoolExp>;
};


export type Query_RootInvoiceReminderDataByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Query_RootInvoiceTemplateCartItemsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceTemplateCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceTemplateCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
};


export type Query_RootInvoiceTemplateCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceTemplateCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceTemplateCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
};


export type Query_RootInvoiceTemplateCartItemsByPkArgs = {
  cartItemGuid: Scalars['uuid'];
  invoiceTemplateGuid: Scalars['uuid'];
};


export type Query_RootInvoiceTemplatesArgs = {
  distinctOn?: InputMaybe<Array<InvoiceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceTemplatesOrderBy>>;
  where?: InputMaybe<InvoiceTemplatesBoolExp>;
};


export type Query_RootInvoiceTemplatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceTemplatesOrderBy>>;
  where?: InputMaybe<InvoiceTemplatesBoolExp>;
};


export type Query_RootInvoiceTemplatesByPkArgs = {
  invoiceTemplateGuid: Scalars['uuid'];
};


export type Query_RootInvoicesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Query_RootInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Query_RootInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Query_RootInvoicesQboStatusArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQboStatusOrderBy>>;
  where?: InputMaybe<InvoicesQboStatusBoolExp>;
};


export type Query_RootInvoicesQboStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQboStatusOrderBy>>;
  where?: InputMaybe<InvoicesQboStatusBoolExp>;
};


export type Query_RootInvoicesQueryableArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQueryableOrderBy>>;
  where?: InputMaybe<InvoicesQueryableBoolExp>;
};


export type Query_RootInvoicesQueryableAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQueryableOrderBy>>;
  where?: InputMaybe<InvoicesQueryableBoolExp>;
};


export type Query_RootInvoicesQueryableByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Query_RootInvoicesQueryableWithQboStatusArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQueryableWithQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQueryableWithQboStatusOrderBy>>;
  where?: InputMaybe<InvoicesQueryableWithQboStatusBoolExp>;
};


export type Query_RootInvoicesQueryableWithQboStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQueryableWithQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQueryableWithQboStatusOrderBy>>;
  where?: InputMaybe<InvoicesQueryableWithQboStatusBoolExp>;
};


export type Query_RootInvoicesV2AccountingStaleArgs = {
  distinctOn?: InputMaybe<Array<InvoicesV2AccountingStaleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesV2AccountingStaleOrderBy>>;
  where?: InputMaybe<InvoicesV2AccountingStaleBoolExp>;
};


export type Query_RootInvoicesV2AccountingStaleAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesV2AccountingStaleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesV2AccountingStaleOrderBy>>;
  where?: InputMaybe<InvoicesV2AccountingStaleBoolExp>;
};


export type Query_RootInvoicesV2QboStaleArgs = {
  distinctOn?: InputMaybe<Array<InvoicesV2QboStaleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesV2QboStaleOrderBy>>;
  where?: InputMaybe<InvoicesV2QboStaleBoolExp>;
};


export type Query_RootInvoicesV2QboStaleAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesV2QboStaleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesV2QboStaleOrderBy>>;
  where?: InputMaybe<InvoicesV2QboStaleBoolExp>;
};


export type Query_RootInvoicesV2QboStatusArgs = {
  distinctOn?: InputMaybe<Array<InvoicesV2QboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesV2QboStatusOrderBy>>;
  where?: InputMaybe<InvoicesV2QboStatusBoolExp>;
};


export type Query_RootInvoicesV2QboStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesV2QboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesV2QboStatusOrderBy>>;
  where?: InputMaybe<InvoicesV2QboStatusBoolExp>;
};


export type Query_RootJobAppointmentAssignmentStatusTypesArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentStatusTypesBoolExp>;
};


export type Query_RootJobAppointmentAssignmentStatusTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentStatusTypesBoolExp>;
};


export type Query_RootJobAppointmentAssignmentStatusTypesByPkArgs = {
  name: Scalars['String'];
};


export type Query_RootJobAppointmentAssignmentStatusesArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentStatusesOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentStatusesBoolExp>;
};


export type Query_RootJobAppointmentAssignmentStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentStatusesOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentStatusesBoolExp>;
};


export type Query_RootJobAppointmentAssignmentStatusesByPkArgs = {
  jobAppointmentAssignmentStatusGuid: Scalars['uuid'];
};


export type Query_RootJobAppointmentAssignmentsArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
};


export type Query_RootJobAppointmentAssignmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
};


export type Query_RootJobAppointmentAssignmentsByPkArgs = {
  jobAppointmentAssignmentGuid: Scalars['uuid'];
};


export type Query_RootJobAppointmentCancellationStatusesArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentCancellationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentCancellationStatusesOrderBy>>;
  where?: InputMaybe<JobAppointmentCancellationStatusesBoolExp>;
};


export type Query_RootJobAppointmentCancellationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentCancellationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentCancellationStatusesOrderBy>>;
  where?: InputMaybe<JobAppointmentCancellationStatusesBoolExp>;
};


export type Query_RootJobAppointmentCancellationStatusesByPkArgs = {
  jobAppointmentGuid: Scalars['uuid'];
};


export type Query_RootJobAppointmentConfirmationStatusesArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentConfirmationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentConfirmationStatusesOrderBy>>;
  where?: InputMaybe<JobAppointmentConfirmationStatusesBoolExp>;
};


export type Query_RootJobAppointmentConfirmationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentConfirmationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentConfirmationStatusesOrderBy>>;
  where?: InputMaybe<JobAppointmentConfirmationStatusesBoolExp>;
};


export type Query_RootJobAppointmentConfirmationStatusesByPkArgs = {
  jobAppointmentGuid: Scalars['uuid'];
};


export type Query_RootJobAppointmentInvoicesArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentInvoicesOrderBy>>;
  where?: InputMaybe<JobAppointmentInvoicesBoolExp>;
};


export type Query_RootJobAppointmentInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentInvoicesOrderBy>>;
  where?: InputMaybe<JobAppointmentInvoicesBoolExp>;
};


export type Query_RootJobAppointmentInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Query_RootJobAppointmentsArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentsBoolExp>;
};


export type Query_RootJobAppointmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentsBoolExp>;
};


export type Query_RootJobAppointmentsByPkArgs = {
  jobAppointmentGuid: Scalars['uuid'];
};


export type Query_RootJobCostItemsArgs = {
  distinctOn?: InputMaybe<Array<JobCostItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostItemsOrderBy>>;
  where?: InputMaybe<JobCostItemsBoolExp>;
};


export type Query_RootJobCostItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobCostItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostItemsOrderBy>>;
  where?: InputMaybe<JobCostItemsBoolExp>;
};


export type Query_RootJobCostItemsByPkArgs = {
  jobCostItemGuid: Scalars['uuid'];
};


export type Query_RootJobCostMiscCategoriesArgs = {
  distinctOn?: InputMaybe<Array<JobCostMiscCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostMiscCategoriesOrderBy>>;
  where?: InputMaybe<JobCostMiscCategoriesBoolExp>;
};


export type Query_RootJobCostMiscCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobCostMiscCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostMiscCategoriesOrderBy>>;
  where?: InputMaybe<JobCostMiscCategoriesBoolExp>;
};


export type Query_RootJobCostMiscCategoriesByPkArgs = {
  miscCategoryGuid: Scalars['uuid'];
};


export type Query_RootJobCostingConfigArgs = {
  distinctOn?: InputMaybe<Array<JobCostingConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostingConfigOrderBy>>;
  where?: InputMaybe<JobCostingConfigBoolExp>;
};


export type Query_RootJobCostingConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobCostingConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostingConfigOrderBy>>;
  where?: InputMaybe<JobCostingConfigBoolExp>;
};


export type Query_RootJobCostingConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootJobCostingRollupViewArgs = {
  distinctOn?: InputMaybe<Array<JobCostingRollupViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostingRollupViewOrderBy>>;
  where?: InputMaybe<JobCostingRollupViewBoolExp>;
};


export type Query_RootJobCostingRollupViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobCostingRollupViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostingRollupViewOrderBy>>;
  where?: InputMaybe<JobCostingRollupViewBoolExp>;
};


export type Query_RootJobInvoicesArgs = {
  distinctOn?: InputMaybe<Array<JobInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobInvoicesOrderBy>>;
  where?: InputMaybe<JobInvoicesBoolExp>;
};


export type Query_RootJobInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobInvoicesOrderBy>>;
  where?: InputMaybe<JobInvoicesBoolExp>;
};


export type Query_RootJobInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Query_RootJobLeadsArgs = {
  distinctOn?: InputMaybe<Array<JobLeadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLeadsOrderBy>>;
  where?: InputMaybe<JobLeadsBoolExp>;
};


export type Query_RootJobLeadsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobLeadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLeadsOrderBy>>;
  where?: InputMaybe<JobLeadsBoolExp>;
};


export type Query_RootJobLeadsByPkArgs = {
  jobLeadGuid: Scalars['uuid'];
};


export type Query_RootJobLifecycleStatusesArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleStatusesOrderBy>>;
  where?: InputMaybe<JobLifecycleStatusesBoolExp>;
};


export type Query_RootJobLifecycleStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleStatusesOrderBy>>;
  where?: InputMaybe<JobLifecycleStatusesBoolExp>;
};


export type Query_RootJobLifecycleStatusesByPkArgs = {
  jobLifecycleStatusGuid: Scalars['uuid'];
};


export type Query_RootJobLifecycleTypesArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleTypesOrderBy>>;
  where?: InputMaybe<JobLifecycleTypesBoolExp>;
};


export type Query_RootJobLifecycleTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleTypesOrderBy>>;
  where?: InputMaybe<JobLifecycleTypesBoolExp>;
};


export type Query_RootJobLifecycleTypesByPkArgs = {
  name: Scalars['String'];
};


export type Query_RootJobLifecycleViewsArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleViewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleViewsOrderBy>>;
  where?: InputMaybe<JobLifecycleViewsBoolExp>;
};


export type Query_RootJobLifecycleViewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleViewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleViewsOrderBy>>;
  where?: InputMaybe<JobLifecycleViewsBoolExp>;
};


export type Query_RootJobLifecycleViewsByPkArgs = {
  jobLifecycleViewGuid: Scalars['uuid'];
};


export type Query_RootJobLifecyclesArgs = {
  distinctOn?: InputMaybe<Array<JobLifecyclesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecyclesOrderBy>>;
  where?: InputMaybe<JobLifecyclesBoolExp>;
};


export type Query_RootJobLifecyclesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobLifecyclesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecyclesOrderBy>>;
  where?: InputMaybe<JobLifecyclesBoolExp>;
};


export type Query_RootJobLifecyclesByPkArgs = {
  jobLifecycleGuid: Scalars['uuid'];
};


export type Query_RootJobRequestsCompanyConfigArgs = {
  distinctOn?: InputMaybe<Array<JobRequestsCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobRequestsCompanyConfigOrderBy>>;
  where?: InputMaybe<JobRequestsCompanyConfigBoolExp>;
};


export type Query_RootJobRequestsCompanyConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobRequestsCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobRequestsCompanyConfigOrderBy>>;
  where?: InputMaybe<JobRequestsCompanyConfigBoolExp>;
};


export type Query_RootJobRequestsCompanyConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootJobTagsArgs = {
  distinctOn?: InputMaybe<Array<JobTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTagsOrderBy>>;
  where?: InputMaybe<JobTagsBoolExp>;
};


export type Query_RootJobTagsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTagsOrderBy>>;
  where?: InputMaybe<JobTagsBoolExp>;
};


export type Query_RootJobTagsByPkArgs = {
  jobGuid: Scalars['uuid'];
  tagGuid: Scalars['uuid'];
};


export type Query_RootJobTeamMembersArgs = {
  distinctOn?: InputMaybe<Array<JobTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTeamMembersOrderBy>>;
  where?: InputMaybe<JobTeamMembersBoolExp>;
};


export type Query_RootJobTeamMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTeamMembersOrderBy>>;
  where?: InputMaybe<JobTeamMembersBoolExp>;
};


export type Query_RootJobTeamMembersByPkArgs = {
  jobGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


export type Query_RootJobTechnicianEarnedRevenueAttributionsArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsOrderBy>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueAttributionsBoolExp>;
};


export type Query_RootJobTechnicianEarnedRevenueAttributionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsOrderBy>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueAttributionsBoolExp>;
};


export type Query_RootJobTechnicianEarnedRevenueAttributionsByPkArgs = {
  invoiceGuid: Scalars['uuid'];
  itemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  technicianUserGuid: Scalars['uuid'];
};


export type Query_RootJobTechnicianEarnedRevenueSummariesArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesOrderBy>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueSummariesBoolExp>;
};


export type Query_RootJobTechnicianEarnedRevenueSummariesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesOrderBy>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueSummariesBoolExp>;
};


export type Query_RootJobTechnicianSalesCommissionAndBonusArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusOrderBy>>;
  where?: InputMaybe<JobTechnicianSalesCommissionAndBonusBoolExp>;
};


export type Query_RootJobTechnicianSalesCommissionAndBonusAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusOrderBy>>;
  where?: InputMaybe<JobTechnicianSalesCommissionAndBonusBoolExp>;
};


export type Query_RootJobTechnicianSoldRevenueAttributionsArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsOrderBy>>;
  where?: InputMaybe<JobTechnicianSoldRevenueAttributionsBoolExp>;
};


export type Query_RootJobTechnicianSoldRevenueAttributionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsOrderBy>>;
  where?: InputMaybe<JobTechnicianSoldRevenueAttributionsBoolExp>;
};


export type Query_RootJobTechnicianSoldRevenueAttributionsByPkArgs = {
  invoiceGuid: Scalars['uuid'];
  itemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  technicianUserGuid: Scalars['uuid'];
};


export type Query_RootJobTechnicianSoldRevenueSummariesArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesOrderBy>>;
  where?: InputMaybe<JobTechnicianSoldRevenueSummariesBoolExp>;
};


export type Query_RootJobTechnicianSoldRevenueSummariesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesOrderBy>>;
  where?: InputMaybe<JobTechnicianSoldRevenueSummariesBoolExp>;
};


export type Query_RootJobTypeChangeReasonsArgs = {
  distinctOn?: InputMaybe<Array<JobTypeChangeReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTypeChangeReasonsOrderBy>>;
  where?: InputMaybe<JobTypeChangeReasonsBoolExp>;
};


export type Query_RootJobTypeChangeReasonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTypeChangeReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTypeChangeReasonsOrderBy>>;
  where?: InputMaybe<JobTypeChangeReasonsBoolExp>;
};


export type Query_RootJobTypeChangeReasonsByPkArgs = {
  jobTypeChangeReasonGuid: Scalars['uuid'];
};


export type Query_RootJobTypesArgs = {
  distinctOn?: InputMaybe<Array<JobTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTypesOrderBy>>;
  where?: InputMaybe<JobTypesBoolExp>;
};


export type Query_RootJobTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTypesOrderBy>>;
  where?: InputMaybe<JobTypesBoolExp>;
};


export type Query_RootJobTypesByPkArgs = {
  jobTypeGuid: Scalars['uuid'];
};


export type Query_RootJobsArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


export type Query_RootJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


export type Query_RootJobsByPkArgs = {
  jobGuid: Scalars['uuid'];
};


export type Query_RootJobsFullyPaidInvoicedAmountArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicedAmountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicedAmountOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicedAmountBoolExp>;
};


export type Query_RootJobsFullyPaidInvoicedAmountAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicedAmountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicedAmountOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicedAmountBoolExp>;
};


export type Query_RootJobsFullyPaidInvoicesSummaryArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicesSummarySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicesSummaryOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicesSummaryBoolExp>;
};


export type Query_RootJobsFullyPaidInvoicesSummaryAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicesSummarySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicesSummaryOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicesSummaryBoolExp>;
};


export type Query_RootJobsFullyPaidInvoicesV2SummaryArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummarySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicesV2SummaryBoolExp>;
};


export type Query_RootJobsFullyPaidInvoicesV2SummaryAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummarySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicesV2SummaryBoolExp>;
};


export type Query_RootJobsFullyPaidInvoicesV2SummaryMvArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryMvSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryMvOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicesV2SummaryMvBoolExp>;
};


export type Query_RootJobsFullyPaidInvoicesV2SummaryMvAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryMvSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryMvOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicesV2SummaryMvBoolExp>;
};


export type Query_RootJobsMaxCommissionableBaseArgs = {
  distinctOn?: InputMaybe<Array<JobsMaxCommissionableBaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsMaxCommissionableBaseOrderBy>>;
  where?: InputMaybe<JobsMaxCommissionableBaseBoolExp>;
};


export type Query_RootJobsMaxCommissionableBaseAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsMaxCommissionableBaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsMaxCommissionableBaseOrderBy>>;
  where?: InputMaybe<JobsMaxCommissionableBaseBoolExp>;
};


export type Query_RootJobsWithLinkedJobArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobBoolExp>;
};


export type Query_RootJobsWithLinkedJobAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobBoolExp>;
};


export type Query_RootJobsWithLinkedJobByPkArgs = {
  jobGuid: Scalars['uuid'];
  linkedJobGuid: Scalars['uuid'];
};


export type Query_RootJobsWithLinkedJobLinkedAppointmentChecklistInstancesArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>;
};


export type Query_RootJobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>;
};


export type Query_RootJobsWithLinkedJobLinkedAppointmentChecklistInstancesByPkArgs = {
  appointmentChecklistInstanceGuid: Scalars['uuid'];
  followUpJobGuid: Scalars['uuid'];
  originalJobGuid: Scalars['uuid'];
};


export type Query_RootJobsWithLinkedJobLinkedEstimatesArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
};


export type Query_RootJobsWithLinkedJobLinkedEstimatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
};


export type Query_RootJobsWithLinkedJobLinkedEstimatesByPkArgs = {
  estimateGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  linkedJobGuid: Scalars['uuid'];
};


export type Query_RootJobsWithLinkedJobLinkedInvoicesArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedInvoicesBoolExp>;
};


export type Query_RootJobsWithLinkedJobLinkedInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedInvoicesBoolExp>;
};


export type Query_RootJobsWithLinkedJobLinkedInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  linkedJobGuid: Scalars['uuid'];
};


export type Query_RootLocationContactsArgs = {
  distinctOn?: InputMaybe<Array<LocationContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationContactsOrderBy>>;
  where?: InputMaybe<LocationContactsBoolExp>;
};


export type Query_RootLocationContactsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LocationContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationContactsOrderBy>>;
  where?: InputMaybe<LocationContactsBoolExp>;
};


export type Query_RootLocationContactsByPkArgs = {
  contactGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
};


export type Query_RootLocationInvoicesArgs = {
  distinctOn?: InputMaybe<Array<LocationInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationInvoicesOrderBy>>;
  where?: InputMaybe<LocationInvoicesBoolExp>;
};


export type Query_RootLocationInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LocationInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationInvoicesOrderBy>>;
  where?: InputMaybe<LocationInvoicesBoolExp>;
};


export type Query_RootLocationInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Query_RootLocationsArgs = {
  distinctOn?: InputMaybe<Array<LocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
  where?: InputMaybe<LocationsBoolExp>;
};


export type Query_RootLocationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
  where?: InputMaybe<LocationsBoolExp>;
};


export type Query_RootLocationsByPkArgs = {
  locationGuid: Scalars['uuid'];
};


export type Query_RootMaintenancePlanDefinitionAllowedPaymentIntervalsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
};


export type Query_RootMaintenancePlanDefinitionAllowedPaymentIntervalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
};


export type Query_RootMaintenancePlanDefinitionAllowedPaymentIntervalsByPkArgs = {
  maintenancePlanDefinitionAllowedPaymentIntervalGuid: Scalars['uuid'];
};


export type Query_RootMaintenancePlanDefinitionBenefitsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionBenefitsBoolExp>;
};


export type Query_RootMaintenancePlanDefinitionBenefitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionBenefitsBoolExp>;
};


export type Query_RootMaintenancePlanDefinitionBenefitsByPkArgs = {
  maintenancePlanDefinitionBenefitGuid: Scalars['uuid'];
};


export type Query_RootMaintenancePlanDefinitionDiscountsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionDiscountsBoolExp>;
};


export type Query_RootMaintenancePlanDefinitionDiscountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionDiscountsBoolExp>;
};


export type Query_RootMaintenancePlanDefinitionDiscountsByPkArgs = {
  maintenancePlanDefinitionDiscountGuid: Scalars['uuid'];
};


export type Query_RootMaintenancePlanDefinitionFlareArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionFlareSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionFlareOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionFlareBoolExp>;
};


export type Query_RootMaintenancePlanDefinitionFlareAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionFlareSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionFlareOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionFlareBoolExp>;
};


export type Query_RootMaintenancePlanDefinitionFlareByPkArgs = {
  maintenancePlanDefinitionFlareGuid: Scalars['uuid'];
};


export type Query_RootMaintenancePlanDefinitionMarketingInfoArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionMarketingInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionMarketingInfoOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionMarketingInfoBoolExp>;
};


export type Query_RootMaintenancePlanDefinitionMarketingInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionMarketingInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionMarketingInfoOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionMarketingInfoBoolExp>;
};


export type Query_RootMaintenancePlanDefinitionMarketingInfoByPkArgs = {
  maintenancePlanDefinitionMarketingInfoGuid: Scalars['uuid'];
};


export type Query_RootMaintenancePlanDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionsBoolExp>;
};


export type Query_RootMaintenancePlanDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionsBoolExp>;
};


export type Query_RootMaintenancePlanDefinitionsByPkArgs = {
  maintenancePlanDefinitionGuid: Scalars['uuid'];
};


export type Query_RootMaintenancePlanEquipmentCoverageDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
};


export type Query_RootMaintenancePlanEquipmentCoverageDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
};


export type Query_RootMaintenancePlanEquipmentCoverageDefinitionsByPkArgs = {
  maintenancePlanEquipmentCoverageDefinitionGuid: Scalars['uuid'];
};


export type Query_RootMaintenancePlanEquipmentCoveragePricingsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsBoolExp>;
};


export type Query_RootMaintenancePlanEquipmentCoveragePricingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsBoolExp>;
};


export type Query_RootMaintenancePlanEquipmentCoveragePricingsByPkArgs = {
  maintenancePlanEquipmentCoveragePricingGuid: Scalars['uuid'];
};


export type Query_RootMaintenancePlanInvoicesArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanInvoicesOrderBy>>;
  where?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
};


export type Query_RootMaintenancePlanInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanInvoicesOrderBy>>;
  where?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
};


export type Query_RootMaintenancePlanInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Query_RootMaintenancePlanNextVisitsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanNextVisitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanNextVisitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanNextVisitsBoolExp>;
};


export type Query_RootMaintenancePlanNextVisitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanNextVisitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanNextVisitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanNextVisitsBoolExp>;
};


export type Query_RootMaintenancePlanVisitInstalledEquipmentsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
};


export type Query_RootMaintenancePlanVisitInstalledEquipmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
};


export type Query_RootMaintenancePlanVisitInstalledEquipmentsByPkArgs = {
  maintenancePlanVisitInstalledEquipmentGuid: Scalars['uuid'];
};


export type Query_RootMaintenancePlanVisitsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitsBoolExp>;
};


export type Query_RootMaintenancePlanVisitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitsBoolExp>;
};


export type Query_RootMaintenancePlanVisitsByPkArgs = {
  maintenancePlanVisitGuid: Scalars['uuid'];
};


export type Query_RootMaintenancePlanVisitsWithStatusArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitsWithStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitsWithStatusOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitsWithStatusBoolExp>;
};


export type Query_RootMaintenancePlanVisitsWithStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitsWithStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitsWithStatusOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitsWithStatusBoolExp>;
};


export type Query_RootMaintenancePlansQueryableArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlansQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlansQueryableOrderBy>>;
  where?: InputMaybe<MaintenancePlansQueryableBoolExp>;
};


export type Query_RootMaintenancePlansQueryableAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlansQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlansQueryableOrderBy>>;
  where?: InputMaybe<MaintenancePlansQueryableBoolExp>;
};


export type Query_RootMaintenancePlansQueryableByPkArgs = {
  maintenancePlanGuid: Scalars['uuid'];
};


export type Query_RootMigrationJunkArgs = {
  distinctOn?: InputMaybe<Array<MigrationJunkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MigrationJunkOrderBy>>;
  where?: InputMaybe<MigrationJunkBoolExp>;
};


export type Query_RootMigrationJunkAggregateArgs = {
  distinctOn?: InputMaybe<Array<MigrationJunkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MigrationJunkOrderBy>>;
  where?: InputMaybe<MigrationJunkBoolExp>;
};


export type Query_RootMigrationJunkByPkArgs = {
  migrationJunkGuid: Scalars['uuid'];
};


export type Query_RootMigrationJunkLinksArgs = {
  distinctOn?: InputMaybe<Array<MigrationJunkLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MigrationJunkLinksOrderBy>>;
  where?: InputMaybe<MigrationJunkLinksBoolExp>;
};


export type Query_RootMigrationJunkLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<MigrationJunkLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MigrationJunkLinksOrderBy>>;
  where?: InputMaybe<MigrationJunkLinksBoolExp>;
};


export type Query_RootMigrationJunkLinksByPkArgs = {
  migrationJunkGuid: Scalars['uuid'];
};


export type Query_RootNoteAttachmentsArgs = {
  distinctOn?: InputMaybe<Array<NoteAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteAttachmentsOrderBy>>;
  where?: InputMaybe<NoteAttachmentsBoolExp>;
};


export type Query_RootNoteAttachmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteAttachmentsOrderBy>>;
  where?: InputMaybe<NoteAttachmentsBoolExp>;
};


export type Query_RootNoteAttachmentsByPkArgs = {
  noteAttachmentGuid: Scalars['uuid'];
};


export type Query_RootNoteLinksArgs = {
  distinctOn?: InputMaybe<Array<NoteLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteLinksOrderBy>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};


export type Query_RootNoteLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteLinksOrderBy>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};


export type Query_RootNoteLinksByPkArgs = {
  noteGuid: Scalars['uuid'];
};


export type Query_RootNoteTaggedUsersArgs = {
  distinctOn?: InputMaybe<Array<NoteTaggedUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteTaggedUsersOrderBy>>;
  where?: InputMaybe<NoteTaggedUsersBoolExp>;
};


export type Query_RootNoteTaggedUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteTaggedUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteTaggedUsersOrderBy>>;
  where?: InputMaybe<NoteTaggedUsersBoolExp>;
};


export type Query_RootNoteTaggedUsersByPkArgs = {
  noteUserTagGuid: Scalars['uuid'];
};


export type Query_RootNotesArgs = {
  distinctOn?: InputMaybe<Array<NotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
  where?: InputMaybe<NotesBoolExp>;
};


export type Query_RootNotesAggregateArgs = {
  distinctOn?: InputMaybe<Array<NotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
  where?: InputMaybe<NotesBoolExp>;
};


export type Query_RootNotesByPkArgs = {
  noteGuid: Scalars['uuid'];
};


export type Query_RootOnlineBookingCompanyConfigArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingCompanyConfigOrderBy>>;
  where?: InputMaybe<OnlineBookingCompanyConfigBoolExp>;
};


export type Query_RootOnlineBookingCompanyConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingCompanyConfigOrderBy>>;
  where?: InputMaybe<OnlineBookingCompanyConfigBoolExp>;
};


export type Query_RootOnlineBookingCompanyConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootOnlineBookingServiceAreaZipCodesArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceAreaZipCodesBoolExp>;
};


export type Query_RootOnlineBookingServiceAreaZipCodesAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceAreaZipCodesBoolExp>;
};


export type Query_RootOnlineBookingServiceAreaZipCodesByPkArgs = {
  serviceAreaZipCodeGuid: Scalars['uuid'];
};


export type Query_RootOnlineBookingServiceTypeBookableJobTypesArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesBoolExp>;
};


export type Query_RootOnlineBookingServiceTypeBookableJobTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesBoolExp>;
};


export type Query_RootOnlineBookingServiceTypeBookableJobTypesByPkArgs = {
  jobTypeGuid: Scalars['uuid'];
  onlineBookingServiceTypeGuid: Scalars['uuid'];
};


export type Query_RootOnlineBookingServiceTypeBookableTechniciansArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansBoolExp>;
};


export type Query_RootOnlineBookingServiceTypeBookableTechniciansAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansBoolExp>;
};


export type Query_RootOnlineBookingServiceTypeBookableTechniciansByPkArgs = {
  onlineBookingServiceTypeGuid: Scalars['uuid'];
  technicianGuid: Scalars['uuid'];
};


export type Query_RootOnlineBookingServiceTypeConfigsArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeConfigsOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeConfigsBoolExp>;
};


export type Query_RootOnlineBookingServiceTypeConfigsAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeConfigsOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeConfigsBoolExp>;
};


export type Query_RootOnlineBookingServiceTypeConfigsByPkArgs = {
  onlineBookingServiceTypeGuid: Scalars['uuid'];
};


export type Query_RootPaymentLinksArgs = {
  distinctOn?: InputMaybe<Array<PaymentLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentLinksOrderBy>>;
  where?: InputMaybe<PaymentLinksBoolExp>;
};


export type Query_RootPaymentLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentLinksOrderBy>>;
  where?: InputMaybe<PaymentLinksBoolExp>;
};


export type Query_RootPaymentLinksByPkArgs = {
  paymentRecordGuid: Scalars['uuid'];
};


export type Query_RootPaymentMethodBillingInfoArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodBillingInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodBillingInfoOrderBy>>;
  where?: InputMaybe<PaymentMethodBillingInfoBoolExp>;
};


export type Query_RootPaymentMethodBillingInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodBillingInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodBillingInfoOrderBy>>;
  where?: InputMaybe<PaymentMethodBillingInfoBoolExp>;
};


export type Query_RootPaymentMethodBillingInfoByPkArgs = {
  paymentMethodRecordGuid: Scalars['uuid'];
};


export type Query_RootPaymentMethodCardMetadataArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodCardMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodCardMetadataOrderBy>>;
  where?: InputMaybe<PaymentMethodCardMetadataBoolExp>;
};


export type Query_RootPaymentMethodCardMetadataAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodCardMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodCardMetadataOrderBy>>;
  where?: InputMaybe<PaymentMethodCardMetadataBoolExp>;
};


export type Query_RootPaymentMethodCardMetadataByPkArgs = {
  paymentMethodRecordGuid: Scalars['uuid'];
};


export type Query_RootPaymentMethodRecordsArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodRecordsOrderBy>>;
  where?: InputMaybe<PaymentMethodRecordsBoolExp>;
};


export type Query_RootPaymentMethodRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodRecordsOrderBy>>;
  where?: InputMaybe<PaymentMethodRecordsBoolExp>;
};


export type Query_RootPaymentMethodRecordsByPkArgs = {
  paymentMethodRecordGuid: Scalars['uuid'];
};


export type Query_RootPaymentMethodsArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodsOrderBy>>;
  where?: InputMaybe<PaymentMethodsBoolExp>;
};


export type Query_RootPaymentMethodsByPkArgs = {
  name: Scalars['String'];
};


export type Query_RootPaymentRecordsArgs = {
  distinctOn?: InputMaybe<Array<PaymentRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecordsOrderBy>>;
  where?: InputMaybe<PaymentRecordsBoolExp>;
};


export type Query_RootPaymentRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecordsOrderBy>>;
  where?: InputMaybe<PaymentRecordsBoolExp>;
};


export type Query_RootPaymentRecordsByPkArgs = {
  paymentRecordGuid: Scalars['uuid'];
};


export type Query_RootPaymentRefundsArgs = {
  distinctOn?: InputMaybe<Array<PaymentRefundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRefundsOrderBy>>;
  where?: InputMaybe<PaymentRefundsBoolExp>;
};


export type Query_RootPaymentRefundsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentRefundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRefundsOrderBy>>;
  where?: InputMaybe<PaymentRefundsBoolExp>;
};


export type Query_RootPaymentRefundsByPkArgs = {
  paymentRefundGuid: Scalars['uuid'];
};


export type Query_RootPaymentStatusErrorDetailArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusErrorDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusErrorDetailOrderBy>>;
  where?: InputMaybe<PaymentStatusErrorDetailBoolExp>;
};


export type Query_RootPaymentStatusErrorDetailAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusErrorDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusErrorDetailOrderBy>>;
  where?: InputMaybe<PaymentStatusErrorDetailBoolExp>;
};


export type Query_RootPaymentStatusErrorDetailByPkArgs = {
  paymentStatusErrorDetailGuid: Scalars['uuid'];
};


export type Query_RootPaymentStatusLatestArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusLatestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusLatestOrderBy>>;
  where?: InputMaybe<PaymentStatusLatestBoolExp>;
};


export type Query_RootPaymentStatusLatestAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusLatestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusLatestOrderBy>>;
  where?: InputMaybe<PaymentStatusLatestBoolExp>;
};


export type Query_RootPaymentStatusLatestByPkArgs = {
  paymentRecordGuid: Scalars['uuid'];
};


export type Query_RootPaymentStatusesArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusesOrderBy>>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};


export type Query_RootPaymentStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusesOrderBy>>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};


export type Query_RootPaymentStatusesByPkArgs = {
  paymentStatusGuid: Scalars['uuid'];
};


export type Query_RootPaymentSubscriptionInvoicesArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionInvoicesOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionInvoicesBoolExp>;
};


export type Query_RootPaymentSubscriptionInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionInvoicesOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionInvoicesBoolExp>;
};


export type Query_RootPaymentSubscriptionInvoicesByPkArgs = {
  paymentSubscriptionInvoiceGuid: Scalars['uuid'];
};


export type Query_RootPaymentSubscriptionStatusesArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionStatusesOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionStatusesBoolExp>;
};


export type Query_RootPaymentSubscriptionStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionStatusesOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionStatusesBoolExp>;
};


export type Query_RootPaymentSubscriptionStatusesByPkArgs = {
  paymentSubscriptionStatusGuid: Scalars['uuid'];
};


export type Query_RootPaymentSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionsOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionsBoolExp>;
};


export type Query_RootPaymentSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionsOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionsBoolExp>;
};


export type Query_RootPaymentSubscriptionsByPkArgs = {
  paymentSubscriptionGuid: Scalars['uuid'];
};


export type Query_RootPaymentsAccountingStaleInfoArgs = {
  distinctOn?: InputMaybe<Array<PaymentsAccountingStaleInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsAccountingStaleInfoOrderBy>>;
  where?: InputMaybe<PaymentsAccountingStaleInfoBoolExp>;
};


export type Query_RootPaymentsAccountingStaleInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentsAccountingStaleInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsAccountingStaleInfoOrderBy>>;
  where?: InputMaybe<PaymentsAccountingStaleInfoBoolExp>;
};


export type Query_RootPaymentsQboStatusArgs = {
  distinctOn?: InputMaybe<Array<PaymentsQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsQboStatusOrderBy>>;
  where?: InputMaybe<PaymentsQboStatusBoolExp>;
};


export type Query_RootPaymentsQboStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentsQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsQboStatusOrderBy>>;
  where?: InputMaybe<PaymentsQboStatusBoolExp>;
};


export type Query_RootPayoutItemsArgs = {
  distinctOn?: InputMaybe<Array<PayoutItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutItemsOrderBy>>;
  where?: InputMaybe<PayoutItemsBoolExp>;
};


export type Query_RootPayoutItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PayoutItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutItemsOrderBy>>;
  where?: InputMaybe<PayoutItemsBoolExp>;
};


export type Query_RootPayoutItemsByPkArgs = {
  payoutItemGuid: Scalars['uuid'];
};


export type Query_RootPayoutQboAccountsConfigArgs = {
  distinctOn?: InputMaybe<Array<PayoutQboAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutQboAccountsConfigOrderBy>>;
  where?: InputMaybe<PayoutQboAccountsConfigBoolExp>;
};


export type Query_RootPayoutQboAccountsConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<PayoutQboAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutQboAccountsConfigOrderBy>>;
  where?: InputMaybe<PayoutQboAccountsConfigBoolExp>;
};


export type Query_RootPayoutQboAccountsConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootPayoutsArgs = {
  distinctOn?: InputMaybe<Array<PayoutsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutsOrderBy>>;
  where?: InputMaybe<PayoutsBoolExp>;
};


export type Query_RootPayoutsAccountingStaleInfoArgs = {
  distinctOn?: InputMaybe<Array<PayoutsAccountingStaleInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutsAccountingStaleInfoOrderBy>>;
  where?: InputMaybe<PayoutsAccountingStaleInfoBoolExp>;
};


export type Query_RootPayoutsAccountingStaleInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<PayoutsAccountingStaleInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutsAccountingStaleInfoOrderBy>>;
  where?: InputMaybe<PayoutsAccountingStaleInfoBoolExp>;
};


export type Query_RootPayoutsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PayoutsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutsOrderBy>>;
  where?: InputMaybe<PayoutsBoolExp>;
};


export type Query_RootPayoutsByPkArgs = {
  payoutGuid: Scalars['uuid'];
};


export type Query_RootPayoutsQboStatusArgs = {
  distinctOn?: InputMaybe<Array<PayoutsQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutsQboStatusOrderBy>>;
  where?: InputMaybe<PayoutsQboStatusBoolExp>;
};


export type Query_RootPayoutsQboStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<PayoutsQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutsQboStatusOrderBy>>;
  where?: InputMaybe<PayoutsQboStatusBoolExp>;
};


export type Query_RootPermissionsArgs = {
  distinctOn?: InputMaybe<Array<PermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PermissionsOrderBy>>;
  where?: InputMaybe<PermissionsBoolExp>;
};


export type Query_RootPermissionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PermissionsOrderBy>>;
  where?: InputMaybe<PermissionsBoolExp>;
};


export type Query_RootPermissionsByPkArgs = {
  name: Scalars['String'];
};


export type Query_RootPermissionsV2Args = {
  distinctOn?: InputMaybe<Array<PermissionsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PermissionsV2OrderBy>>;
  where?: InputMaybe<PermissionsV2BoolExp>;
};


export type Query_RootPermissionsV2AggregateArgs = {
  distinctOn?: InputMaybe<Array<PermissionsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PermissionsV2OrderBy>>;
  where?: InputMaybe<PermissionsV2BoolExp>;
};


export type Query_RootPermissionsV2ByPkArgs = {
  name: Scalars['String'];
};


export type Query_RootPhoneNumbersArgs = {
  distinctOn?: InputMaybe<Array<PhoneNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhoneNumbersOrderBy>>;
  where?: InputMaybe<PhoneNumbersBoolExp>;
};


export type Query_RootPhoneNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhoneNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhoneNumbersOrderBy>>;
  where?: InputMaybe<PhoneNumbersBoolExp>;
};


export type Query_RootPhoneNumbersByPkArgs = {
  phoneNumberGuid: Scalars['uuid'];
};


export type Query_RootPhotoLinksArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


export type Query_RootPhotoLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


export type Query_RootPhotoLinksByPkArgs = {
  photoGuid: Scalars['uuid'];
};


export type Query_RootPhotosArgs = {
  distinctOn?: InputMaybe<Array<PhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotosOrderBy>>;
  where?: InputMaybe<PhotosBoolExp>;
};


export type Query_RootPhotosAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotosOrderBy>>;
  where?: InputMaybe<PhotosBoolExp>;
};


export type Query_RootPhotosByPkArgs = {
  photoGuid: Scalars['uuid'];
};


export type Query_RootPricebookBundleItemsArgs = {
  distinctOn?: InputMaybe<Array<PricebookBundleItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookBundleItemsOrderBy>>;
  where?: InputMaybe<PricebookBundleItemsBoolExp>;
};


export type Query_RootPricebookBundleItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookBundleItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookBundleItemsOrderBy>>;
  where?: InputMaybe<PricebookBundleItemsBoolExp>;
};


export type Query_RootPricebookBundleItemsByPkArgs = {
  pricebookBundleItemGuid: Scalars['uuid'];
};


export type Query_RootPricebookCategoriesArgs = {
  distinctOn?: InputMaybe<Array<PricebookCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookCategoriesOrderBy>>;
  where?: InputMaybe<PricebookCategoriesBoolExp>;
};


export type Query_RootPricebookCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookCategoriesOrderBy>>;
  where?: InputMaybe<PricebookCategoriesBoolExp>;
};


export type Query_RootPricebookCategoriesByPkArgs = {
  pricebookCategoryGuid: Scalars['uuid'];
};


export type Query_RootPricebookDiscountsArgs = {
  distinctOn?: InputMaybe<Array<PricebookDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookDiscountsOrderBy>>;
  where?: InputMaybe<PricebookDiscountsBoolExp>;
};


export type Query_RootPricebookDiscountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookDiscountsOrderBy>>;
  where?: InputMaybe<PricebookDiscountsBoolExp>;
};


export type Query_RootPricebookDiscountsByPkArgs = {
  pricebookDiscountGuid: Scalars['uuid'];
};


export type Query_RootPricebookItemTypeFallbackPhotosArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemTypeFallbackPhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemTypeFallbackPhotosOrderBy>>;
  where?: InputMaybe<PricebookItemTypeFallbackPhotosBoolExp>;
};


export type Query_RootPricebookItemTypeFallbackPhotosAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemTypeFallbackPhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemTypeFallbackPhotosOrderBy>>;
  where?: InputMaybe<PricebookItemTypeFallbackPhotosBoolExp>;
};


export type Query_RootPricebookItemTypeFallbackPhotosByPkArgs = {
  companyGuid: Scalars['uuid'];
  itemType: Scalars['String'];
};


export type Query_RootPricebookItemsArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemsOrderBy>>;
  where?: InputMaybe<PricebookItemsBoolExp>;
};


export type Query_RootPricebookItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemsOrderBy>>;
  where?: InputMaybe<PricebookItemsBoolExp>;
};


export type Query_RootPricebookItemsByPkArgs = {
  pricebookItemGuid: Scalars['uuid'];
};


export type Query_RootPricebookItemsQboIncomeAccountsArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemsQboIncomeAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemsQboIncomeAccountsOrderBy>>;
  where?: InputMaybe<PricebookItemsQboIncomeAccountsBoolExp>;
};


export type Query_RootPricebookItemsQboIncomeAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemsQboIncomeAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemsQboIncomeAccountsOrderBy>>;
  where?: InputMaybe<PricebookItemsQboIncomeAccountsBoolExp>;
};


export type Query_RootPricebookItemsQboIncomeAccountsByPkArgs = {
  pricebookItemGuid: Scalars['uuid'];
};


export type Query_RootPricebookMarkupTiersArgs = {
  distinctOn?: InputMaybe<Array<PricebookMarkupTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookMarkupTiersOrderBy>>;
  where?: InputMaybe<PricebookMarkupTiersBoolExp>;
};


export type Query_RootPricebookMarkupTiersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookMarkupTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookMarkupTiersOrderBy>>;
  where?: InputMaybe<PricebookMarkupTiersBoolExp>;
};


export type Query_RootPricebookMarkupTiersByPkArgs = {
  pricebookMarkupTierGuid: Scalars['uuid'];
};


export type Query_RootPricebookTaxRatesArgs = {
  distinctOn?: InputMaybe<Array<PricebookTaxRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookTaxRatesOrderBy>>;
  where?: InputMaybe<PricebookTaxRatesBoolExp>;
};


export type Query_RootPricebookTaxRatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookTaxRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookTaxRatesOrderBy>>;
  where?: InputMaybe<PricebookTaxRatesBoolExp>;
};


export type Query_RootPricebookTaxRatesByPkArgs = {
  pricebookTaxRateGuid: Scalars['uuid'];
};


export type Query_RootPricebookVersionsArgs = {
  distinctOn?: InputMaybe<Array<PricebookVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookVersionsOrderBy>>;
  where?: InputMaybe<PricebookVersionsBoolExp>;
};


export type Query_RootPricebookVersionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookVersionsOrderBy>>;
  where?: InputMaybe<PricebookVersionsBoolExp>;
};


export type Query_RootPricebookVersionsByPkArgs = {
  pricebookVersionGuid: Scalars['uuid'];
};


export type Query_RootPricebooksItemPricesArgs = {
  distinctOn?: InputMaybe<Array<PricebooksItemPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebooksItemPricesOrderBy>>;
  where?: InputMaybe<PricebooksItemPricesBoolExp>;
};


export type Query_RootPricebooksItemPricesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebooksItemPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebooksItemPricesOrderBy>>;
  where?: InputMaybe<PricebooksItemPricesBoolExp>;
};


export type Query_RootPurchaseOrdersArgs = {
  distinctOn?: InputMaybe<Array<PurchaseOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PurchaseOrdersOrderBy>>;
  where?: InputMaybe<PurchaseOrdersBoolExp>;
};


export type Query_RootPurchaseOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PurchaseOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PurchaseOrdersOrderBy>>;
  where?: InputMaybe<PurchaseOrdersBoolExp>;
};


export type Query_RootPurchaseOrdersByPkArgs = {
  purchaseOrderGuid: Scalars['uuid'];
};


export type Query_RootQboAuthDataArgs = {
  distinctOn?: InputMaybe<Array<QboAuthDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QboAuthDataOrderBy>>;
  where?: InputMaybe<QboAuthDataBoolExp>;
};


export type Query_RootQboAuthDataAggregateArgs = {
  distinctOn?: InputMaybe<Array<QboAuthDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QboAuthDataOrderBy>>;
  where?: InputMaybe<QboAuthDataBoolExp>;
};


export type Query_RootQboAuthDataByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootQboCartItemTypeAccountsConfigArgs = {
  distinctOn?: InputMaybe<Array<QboCartItemTypeAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QboCartItemTypeAccountsConfigOrderBy>>;
  where?: InputMaybe<QboCartItemTypeAccountsConfigBoolExp>;
};


export type Query_RootQboCartItemTypeAccountsConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<QboCartItemTypeAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QboCartItemTypeAccountsConfigOrderBy>>;
  where?: InputMaybe<QboCartItemTypeAccountsConfigBoolExp>;
};


export type Query_RootQboCartItemTypeAccountsConfigByPkArgs = {
  qboCartItemTypeAccountsConfigGuid: Scalars['uuid'];
};


export type Query_RootQboSyncInfoArgs = {
  distinctOn?: InputMaybe<Array<QboSyncInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QboSyncInfoOrderBy>>;
  where?: InputMaybe<QboSyncInfoBoolExp>;
};


export type Query_RootQboSyncInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<QboSyncInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QboSyncInfoOrderBy>>;
  where?: InputMaybe<QboSyncInfoBoolExp>;
};


export type Query_RootQboSyncInfoByPkArgs = {
  breezyIdentifier: Scalars['String'];
  companyGuid: Scalars['uuid'];
};


export type Query_RootRecentPricebookItemsArgs = {
  distinctOn?: InputMaybe<Array<RecentPricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecentPricebookItemsOrderBy>>;
  where?: InputMaybe<RecentPricebookItemsBoolExp>;
};


export type Query_RootRecentPricebookItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecentPricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecentPricebookItemsOrderBy>>;
  where?: InputMaybe<RecentPricebookItemsBoolExp>;
};


export type Query_RootRecentPricebookItemsByPkArgs = {
  pricebookItemGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


export type Query_RootRecommendationAiGenerationInfoArgs = {
  distinctOn?: InputMaybe<Array<RecommendationAiGenerationInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationAiGenerationInfoOrderBy>>;
  where?: InputMaybe<RecommendationAiGenerationInfoBoolExp>;
};


export type Query_RootRecommendationAiGenerationInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecommendationAiGenerationInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationAiGenerationInfoOrderBy>>;
  where?: InputMaybe<RecommendationAiGenerationInfoBoolExp>;
};


export type Query_RootRecommendationAiGenerationInfoByPkArgs = {
  recommendationAiInfoGuid: Scalars['uuid'];
};


export type Query_RootRecommendationDismissalsArgs = {
  distinctOn?: InputMaybe<Array<RecommendationDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationDismissalsOrderBy>>;
  where?: InputMaybe<RecommendationDismissalsBoolExp>;
};


export type Query_RootRecommendationDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecommendationDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationDismissalsOrderBy>>;
  where?: InputMaybe<RecommendationDismissalsBoolExp>;
};


export type Query_RootRecommendationDismissalsByPkArgs = {
  recommendationDismissalGuid: Scalars['uuid'];
};


export type Query_RootRecommendationInteractionsArgs = {
  distinctOn?: InputMaybe<Array<RecommendationInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationInteractionsOrderBy>>;
  where?: InputMaybe<RecommendationInteractionsBoolExp>;
};


export type Query_RootRecommendationInteractionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecommendationInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationInteractionsOrderBy>>;
  where?: InputMaybe<RecommendationInteractionsBoolExp>;
};


export type Query_RootRecommendationInteractionsByPkArgs = {
  recommendationInteractionGuid: Scalars['uuid'];
};


export type Query_RootRecommendationsArgs = {
  distinctOn?: InputMaybe<Array<RecommendationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationsOrderBy>>;
  where?: InputMaybe<RecommendationsBoolExp>;
};


export type Query_RootRecommendationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecommendationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationsOrderBy>>;
  where?: InputMaybe<RecommendationsBoolExp>;
};


export type Query_RootRecommendationsByPkArgs = {
  recommendationGuid: Scalars['uuid'];
};


export type Query_RootReminderAssignmentsArgs = {
  distinctOn?: InputMaybe<Array<ReminderAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderAssignmentsOrderBy>>;
  where?: InputMaybe<ReminderAssignmentsBoolExp>;
};


export type Query_RootReminderAssignmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReminderAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderAssignmentsOrderBy>>;
  where?: InputMaybe<ReminderAssignmentsBoolExp>;
};


export type Query_RootReminderAssignmentsByPkArgs = {
  reminderAssignmentGuid: Scalars['uuid'];
};


export type Query_RootReminderInternalNotificationsArgs = {
  distinctOn?: InputMaybe<Array<ReminderInternalNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderInternalNotificationsOrderBy>>;
  where?: InputMaybe<ReminderInternalNotificationsBoolExp>;
};


export type Query_RootReminderInternalNotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReminderInternalNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderInternalNotificationsOrderBy>>;
  where?: InputMaybe<ReminderInternalNotificationsBoolExp>;
};


export type Query_RootReminderInternalNotificationsByPkArgs = {
  internalNotificationGuid: Scalars['uuid'];
  reminderGuid: Scalars['uuid'];
  type: ReminderInternalNotificationTypeEnum;
};


export type Query_RootRemindersArgs = {
  distinctOn?: InputMaybe<Array<RemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RemindersOrderBy>>;
  where?: InputMaybe<RemindersBoolExp>;
};


export type Query_RootRemindersAggregateArgs = {
  distinctOn?: InputMaybe<Array<RemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RemindersOrderBy>>;
  where?: InputMaybe<RemindersBoolExp>;
};


export type Query_RootRemindersByPkArgs = {
  reminderGuid: Scalars['uuid'];
};


export type Query_RootRepCompanyMetabaseConfigArgs = {
  distinctOn?: InputMaybe<Array<RepCompanyMetabaseConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepCompanyMetabaseConfigOrderBy>>;
  where?: InputMaybe<RepCompanyMetabaseConfigBoolExp>;
};


export type Query_RootRepCompanyMetabaseConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepCompanyMetabaseConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepCompanyMetabaseConfigOrderBy>>;
  where?: InputMaybe<RepCompanyMetabaseConfigBoolExp>;
};


export type Query_RootRepCompanyMetabaseConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Query_RootRepMetabaseCompanyReportsArgs = {
  distinctOn?: InputMaybe<Array<RepMetabaseCompanyReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabaseCompanyReportsOrderBy>>;
  where?: InputMaybe<RepMetabaseCompanyReportsBoolExp>;
};


export type Query_RootRepMetabaseCompanyReportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepMetabaseCompanyReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabaseCompanyReportsOrderBy>>;
  where?: InputMaybe<RepMetabaseCompanyReportsBoolExp>;
};


export type Query_RootRepMetabaseCompanyReportsByPkArgs = {
  companyGuid: Scalars['uuid'];
  reportGuid: Scalars['uuid'];
};


export type Query_RootRepMetabasePulsesArgs = {
  distinctOn?: InputMaybe<Array<RepMetabasePulsesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabasePulsesOrderBy>>;
  where?: InputMaybe<RepMetabasePulsesBoolExp>;
};


export type Query_RootRepMetabasePulsesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepMetabasePulsesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabasePulsesOrderBy>>;
  where?: InputMaybe<RepMetabasePulsesBoolExp>;
};


export type Query_RootRepMetabasePulsesByPkArgs = {
  pulseGuid: Scalars['uuid'];
};


export type Query_RootRepMetabasePulsesV2Args = {
  distinctOn?: InputMaybe<Array<RepMetabasePulsesV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabasePulsesV2OrderBy>>;
  where?: InputMaybe<RepMetabasePulsesV2BoolExp>;
};


export type Query_RootRepMetabasePulsesV2AggregateArgs = {
  distinctOn?: InputMaybe<Array<RepMetabasePulsesV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabasePulsesV2OrderBy>>;
  where?: InputMaybe<RepMetabasePulsesV2BoolExp>;
};


export type Query_RootRepMetabasePulsesV2ByPkArgs = {
  pulseGuid: Scalars['uuid'];
};


export type Query_RootRepMetabaseReportDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<RepMetabaseReportDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabaseReportDefinitionsOrderBy>>;
  where?: InputMaybe<RepMetabaseReportDefinitionsBoolExp>;
};


export type Query_RootRepMetabaseReportDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepMetabaseReportDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabaseReportDefinitionsOrderBy>>;
  where?: InputMaybe<RepMetabaseReportDefinitionsBoolExp>;
};


export type Query_RootRepMetabaseReportDefinitionsByPkArgs = {
  reportGuid: Scalars['uuid'];
};


export type Query_RootTagsArgs = {
  distinctOn?: InputMaybe<Array<TagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TagsOrderBy>>;
  where?: InputMaybe<TagsBoolExp>;
};


export type Query_RootTagsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TagsOrderBy>>;
  where?: InputMaybe<TagsBoolExp>;
};


export type Query_RootTagsByPkArgs = {
  tagGuid: Scalars['uuid'];
};


export type Query_RootTechnicianCapacitiesArgs = {
  distinctOn?: InputMaybe<Array<TechnicianCapacitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechnicianCapacitiesOrderBy>>;
  where?: InputMaybe<TechnicianCapacitiesBoolExp>;
};


export type Query_RootTechnicianCapacitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TechnicianCapacitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechnicianCapacitiesOrderBy>>;
  where?: InputMaybe<TechnicianCapacitiesBoolExp>;
};


export type Query_RootTechnicianCapacitiesByPkArgs = {
  technicianCapacityGuid: Scalars['uuid'];
};


export type Query_RootTechnicianCapacityBlocksArgs = {
  distinctOn?: InputMaybe<Array<TechnicianCapacityBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechnicianCapacityBlocksOrderBy>>;
  where?: InputMaybe<TechnicianCapacityBlocksBoolExp>;
};


export type Query_RootTechnicianCapacityBlocksAggregateArgs = {
  distinctOn?: InputMaybe<Array<TechnicianCapacityBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechnicianCapacityBlocksOrderBy>>;
  where?: InputMaybe<TechnicianCapacityBlocksBoolExp>;
};


export type Query_RootTechnicianCapacityBlocksByPkArgs = {
  technicianCapacityBlockGuid: Scalars['uuid'];
};


export type Query_RootTilledRawEventsArgs = {
  distinctOn?: InputMaybe<Array<TilledRawEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TilledRawEventsOrderBy>>;
  where?: InputMaybe<TilledRawEventsBoolExp>;
};


export type Query_RootTilledRawEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TilledRawEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TilledRawEventsOrderBy>>;
  where?: InputMaybe<TilledRawEventsBoolExp>;
};


export type Query_RootTilledRawEventsByPkArgs = {
  tilledRawEventGuid: Scalars['uuid'];
};


export type Query_RootTimesheetEntriesArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntriesOrderBy>>;
  where?: InputMaybe<TimesheetEntriesBoolExp>;
};


export type Query_RootTimesheetEntriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntriesOrderBy>>;
  where?: InputMaybe<TimesheetEntriesBoolExp>;
};


export type Query_RootTimesheetEntriesByPkArgs = {
  timesheetEntryGuid: Scalars['uuid'];
};


export type Query_RootTimesheetEntryActivitiesArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryActivitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryActivitiesOrderBy>>;
  where?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
};


export type Query_RootTimesheetEntryActivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryActivitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryActivitiesOrderBy>>;
  where?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
};


export type Query_RootTimesheetEntryActivitiesByPkArgs = {
  timesheetEntryActivityGuid: Scalars['uuid'];
};


export type Query_RootTimesheetEntryLinkDataArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryLinkDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryLinkDataOrderBy>>;
  where?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
};


export type Query_RootTimesheetEntryLinkDataAggregateArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryLinkDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryLinkDataOrderBy>>;
  where?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
};


export type Query_RootTimesheetEntryLinkDataByPkArgs = {
  timesheetEntryGuid: Scalars['uuid'];
};


export type Query_RootTuneUpVisitEntitlementsArgs = {
  distinctOn?: InputMaybe<Array<TuneUpVisitEntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TuneUpVisitEntitlementsOrderBy>>;
  where?: InputMaybe<TuneUpVisitEntitlementsBoolExp>;
};


export type Query_RootTuneUpVisitEntitlementsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TuneUpVisitEntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TuneUpVisitEntitlementsOrderBy>>;
  where?: InputMaybe<TuneUpVisitEntitlementsBoolExp>;
};


export type Query_RootTuneUpVisitEntitlementsByPkArgs = {
  entitlementGuid: Scalars['uuid'];
};


export type Query_RootUnnotifiedAccountRemindersArgs = {
  distinctOn?: InputMaybe<Array<UnnotifiedAccountRemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UnnotifiedAccountRemindersOrderBy>>;
  where?: InputMaybe<UnnotifiedAccountRemindersBoolExp>;
};


export type Query_RootUnnotifiedAccountRemindersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UnnotifiedAccountRemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UnnotifiedAccountRemindersOrderBy>>;
  where?: InputMaybe<UnnotifiedAccountRemindersBoolExp>;
};


export type Query_RootUserBusinessUnitsArgs = {
  distinctOn?: InputMaybe<Array<UserBusinessUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBusinessUnitsOrderBy>>;
  where?: InputMaybe<UserBusinessUnitsBoolExp>;
};


export type Query_RootUserBusinessUnitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserBusinessUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBusinessUnitsOrderBy>>;
  where?: InputMaybe<UserBusinessUnitsBoolExp>;
};


export type Query_RootUserBusinessUnitsByPkArgs = {
  userBusinessUnitGuid: Scalars['uuid'];
};


export type Query_RootUserPermissionsArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsOrderBy>>;
  where?: InputMaybe<UserPermissionsBoolExp>;
};


export type Query_RootUserPermissionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsOrderBy>>;
  where?: InputMaybe<UserPermissionsBoolExp>;
};


export type Query_RootUserPermissionsByPkArgs = {
  permissionName: Scalars['String'];
  userGuid: Scalars['uuid'];
};


export type Query_RootUserPermissionsV2Args = {
  distinctOn?: InputMaybe<Array<UserPermissionsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsV2OrderBy>>;
  where?: InputMaybe<UserPermissionsV2BoolExp>;
};


export type Query_RootUserPermissionsV2AggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsV2OrderBy>>;
  where?: InputMaybe<UserPermissionsV2BoolExp>;
};


export type Query_RootUserPermissionsV2ByPkArgs = {
  permissionName: Scalars['String'];
  userGuid: Scalars['uuid'];
};


export type Query_RootUserPhoneNumbersArgs = {
  distinctOn?: InputMaybe<Array<UserPhoneNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPhoneNumbersOrderBy>>;
  where?: InputMaybe<UserPhoneNumbersBoolExp>;
};


export type Query_RootUserPhoneNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPhoneNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPhoneNumbersOrderBy>>;
  where?: InputMaybe<UserPhoneNumbersBoolExp>;
};


export type Query_RootUserPhoneNumbersByPkArgs = {
  phoneNumberGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


export type Query_RootUserRolesArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type Query_RootUserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type Query_RootUserRolesByPkArgs = {
  role: Scalars['String'];
  userGuid: Scalars['uuid'];
};


export type Query_RootUserSettingsArgs = {
  distinctOn?: InputMaybe<Array<UserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
  where?: InputMaybe<UserSettingsBoolExp>;
};


export type Query_RootUserSettingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
  where?: InputMaybe<UserSettingsBoolExp>;
};


export type Query_RootUserSettingsByPkArgs = {
  userGuid: Scalars['uuid'];
};


export type Query_RootUserWagesArgs = {
  distinctOn?: InputMaybe<Array<UserWagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserWagesOrderBy>>;
  where?: InputMaybe<UserWagesBoolExp>;
};


export type Query_RootUserWagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserWagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserWagesOrderBy>>;
  where?: InputMaybe<UserWagesBoolExp>;
};


export type Query_RootUserWagesByPkArgs = {
  userWageGuid: Scalars['uuid'];
};


export type Query_RootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Query_RootUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Query_RootUsersByPkArgs = {
  userGuid: Scalars['uuid'];
};


export type Query_RootWisetackLoanRecordsArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanRecordsOrderBy>>;
  where?: InputMaybe<WisetackLoanRecordsBoolExp>;
};


export type Query_RootWisetackLoanRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanRecordsOrderBy>>;
  where?: InputMaybe<WisetackLoanRecordsBoolExp>;
};


export type Query_RootWisetackLoanRecordsByPkArgs = {
  wisetackLoanRecordGuid: Scalars['uuid'];
};


export type Query_RootWisetackLoanStatusesArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanStatusesOrderBy>>;
  where?: InputMaybe<WisetackLoanStatusesBoolExp>;
};


export type Query_RootWisetackLoanStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanStatusesOrderBy>>;
  where?: InputMaybe<WisetackLoanStatusesBoolExp>;
};


export type Query_RootWisetackLoanStatusesByPkArgs = {
  wisetackLoanStatusGuid: Scalars['uuid'];
};


export type Query_RootWisetackPrequalRecordsArgs = {
  distinctOn?: InputMaybe<Array<WisetackPrequalRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackPrequalRecordsOrderBy>>;
  where?: InputMaybe<WisetackPrequalRecordsBoolExp>;
};


export type Query_RootWisetackPrequalRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackPrequalRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackPrequalRecordsOrderBy>>;
  where?: InputMaybe<WisetackPrequalRecordsBoolExp>;
};


export type Query_RootWisetackPrequalRecordsByPkArgs = {
  wisetackPrequalRecordGuid: Scalars['uuid'];
};


export type Query_RootWisetackWebhookEventsArgs = {
  distinctOn?: InputMaybe<Array<WisetackWebhookEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackWebhookEventsOrderBy>>;
  where?: InputMaybe<WisetackWebhookEventsBoolExp>;
};


export type Query_RootWisetackWebhookEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackWebhookEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackWebhookEventsOrderBy>>;
  where?: InputMaybe<WisetackWebhookEventsBoolExp>;
};


export type Query_RootWisetackWebhookEventsByPkArgs = {
  wisetackWebhookEventGuid: Scalars['uuid'];
};

export type RecommendationDismissalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RecommendationDismissalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RecommendationDismissalsBoolExp>;
  predicate: IntComparisonExp;
};

export type RecommendationInteractionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RecommendationInteractionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RecommendationInteractionsBoolExp>;
  predicate: IntComparisonExp;
};

export type ReminderAssignmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ReminderAssignmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ReminderAssignmentsBoolExp>;
  predicate: IntComparisonExp;
};

export type RepMetabaseCompanyReportsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RepMetabaseCompanyReportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RepMetabaseCompanyReportsBoolExp>;
  predicate: IntComparisonExp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "acc_cart_item_type_accounts_config" */
  accCartItemTypeAccountsConfig: Array<AccCartItemTypeAccountsConfig>;
  /** fetch aggregated fields from the table: "acc_cart_item_type_accounts_config" */
  accCartItemTypeAccountsConfigAggregate: AccCartItemTypeAccountsConfigAggregate;
  /** fetch data from the table: "acc_cart_item_type_accounts_config" using primary key columns */
  accCartItemTypeAccountsConfigByPk?: Maybe<AccCartItemTypeAccountsConfig>;
  /** fetch data from the table in a streaming manner: "acc_cart_item_type_accounts_config" */
  accCartItemTypeAccountsConfigStream: Array<AccCartItemTypeAccountsConfig>;
  /** fetch data from the table: "acc_company_config" */
  accCompanyConfig: Array<AccCompanyConfig>;
  /** fetch aggregated fields from the table: "acc_company_config" */
  accCompanyConfigAggregate: AccCompanyConfigAggregate;
  /** fetch data from the table: "acc_company_config" using primary key columns */
  accCompanyConfigByPk?: Maybe<AccCompanyConfig>;
  /** fetch data from the table in a streaming manner: "acc_company_config" */
  accCompanyConfigStream: Array<AccCompanyConfig>;
  /** fetch data from the table: "acc_payout_accounts_config" */
  accPayoutAccountsConfig: Array<AccPayoutAccountsConfig>;
  /** fetch aggregated fields from the table: "acc_payout_accounts_config" */
  accPayoutAccountsConfigAggregate: AccPayoutAccountsConfigAggregate;
  /** fetch data from the table: "acc_payout_accounts_config" using primary key columns */
  accPayoutAccountsConfigByPk?: Maybe<AccPayoutAccountsConfig>;
  /** fetch data from the table in a streaming manner: "acc_payout_accounts_config" */
  accPayoutAccountsConfigStream: Array<AccPayoutAccountsConfig>;
  /** fetch data from the table: "acc_qbd_conductor_config" */
  accQbdConductorConfig: Array<AccQbdConductorConfig>;
  /** fetch aggregated fields from the table: "acc_qbd_conductor_config" */
  accQbdConductorConfigAggregate: AccQbdConductorConfigAggregate;
  /** fetch data from the table: "acc_qbd_conductor_config" using primary key columns */
  accQbdConductorConfigByPk?: Maybe<AccQbdConductorConfig>;
  /** fetch data from the table in a streaming manner: "acc_qbd_conductor_config" */
  accQbdConductorConfigStream: Array<AccQbdConductorConfig>;
  /** fetch data from the table: "acc_qbd_conductor_uptime" */
  accQbdConductorUptime: Array<AccQbdConductorUptime>;
  /** fetch aggregated fields from the table: "acc_qbd_conductor_uptime" */
  accQbdConductorUptimeAggregate: AccQbdConductorUptimeAggregate;
  /** fetch data from the table: "acc_qbd_conductor_uptime" using primary key columns */
  accQbdConductorUptimeByPk?: Maybe<AccQbdConductorUptime>;
  /** fetch data from the table in a streaming manner: "acc_qbd_conductor_uptime" */
  accQbdConductorUptimeStream: Array<AccQbdConductorUptime>;
  /** fetch data from the table: "acc_sync_info" */
  accSyncInfo: Array<AccSyncInfo>;
  /** fetch aggregated fields from the table: "acc_sync_info" */
  accSyncInfoAggregate: AccSyncInfoAggregate;
  /** fetch data from the table: "acc_sync_info" using primary key columns */
  accSyncInfoByPk?: Maybe<AccSyncInfo>;
  /** fetch data from the table in a streaming manner: "acc_sync_info" */
  accSyncInfoStream: Array<AccSyncInfo>;
  /** fetch data from the table: "acc_sync_queue_items" */
  accSyncQueueItems: Array<AccSyncQueueItems>;
  /** fetch aggregated fields from the table: "acc_sync_queue_items" */
  accSyncQueueItemsAggregate: AccSyncQueueItemsAggregate;
  /** fetch data from the table: "acc_sync_queue_items" using primary key columns */
  accSyncQueueItemsByPk?: Maybe<AccSyncQueueItems>;
  /** fetch data from the table in a streaming manner: "acc_sync_queue_items" */
  accSyncQueueItemsStream: Array<AccSyncQueueItems>;
  /** An array relationship */
  accountContacts: Array<AccountContacts>;
  /** An aggregate relationship */
  accountContactsAggregate: AccountContactsAggregate;
  /** fetch data from the table: "account_contacts" using primary key columns */
  accountContactsByPk?: Maybe<AccountContacts>;
  /** fetch data from the table in a streaming manner: "account_contacts" */
  accountContactsStream: Array<AccountContacts>;
  /** fetch data from the table: "account_job_counts" */
  accountJobCounts: Array<AccountJobCounts>;
  /** fetch data from the table in a streaming manner: "account_job_counts" */
  accountJobCountsStream: Array<AccountJobCounts>;
  /** An array relationship */
  accountLocations: Array<AccountLocations>;
  /** An aggregate relationship */
  accountLocationsAggregate: AccountLocationsAggregate;
  /** fetch data from the table: "account_locations" using primary key columns */
  accountLocationsByPk?: Maybe<AccountLocations>;
  /** fetch data from the table in a streaming manner: "account_locations" */
  accountLocationsStream: Array<AccountLocations>;
  /** An array relationship */
  accountReminders: Array<AccountReminders>;
  /** An aggregate relationship */
  accountRemindersAggregate: AccountRemindersAggregate;
  /** fetch data from the table: "account_reminders" using primary key columns */
  accountRemindersByPk?: Maybe<AccountReminders>;
  /** fetch data from the table in a streaming manner: "account_reminders" */
  accountRemindersStream: Array<AccountReminders>;
  /** fetch data from the table: "account_statement_events" */
  accountStatementEvents: Array<AccountStatementEvents>;
  /** fetch aggregated fields from the table: "account_statement_events" */
  accountStatementEventsAggregate: AccountStatementEventsAggregate;
  /** fetch data from the table: "account_statement_events" using primary key columns */
  accountStatementEventsByPk?: Maybe<AccountStatementEvents>;
  /** fetch data from the table in a streaming manner: "account_statement_events" */
  accountStatementEventsStream: Array<AccountStatementEvents>;
  /** fetch data from the table: "account_tags" */
  accountTags: Array<AccountTags>;
  /** fetch aggregated fields from the table: "account_tags" */
  accountTagsAggregate: AccountTagsAggregate;
  /** fetch data from the table: "account_tags" using primary key columns */
  accountTagsByPk?: Maybe<AccountTags>;
  /** fetch data from the table in a streaming manner: "account_tags" */
  accountTagsStream: Array<AccountTags>;
  /** fetch data from the table: "account_types" */
  accountTypes: Array<AccountTypes>;
  /** fetch aggregated fields from the table: "account_types" */
  accountTypesAggregate: AccountTypesAggregate;
  /** fetch data from the table: "account_types" using primary key columns */
  accountTypesByPk?: Maybe<AccountTypes>;
  /** fetch data from the table in a streaming manner: "account_types" */
  accountTypesStream: Array<AccountTypes>;
  /** An array relationship */
  accounts: Array<Accounts>;
  /** An aggregate relationship */
  accountsAggregate: AccountsAggregate;
  /** fetch data from the table: "accounts" using primary key columns */
  accountsByPk?: Maybe<Accounts>;
  /** fetch data from the table: "accounts_receivable" */
  accountsReceivable: Array<AccountsReceivable>;
  /** fetch aggregated fields from the table: "accounts_receivable" */
  accountsReceivableAggregate: AccountsReceivableAggregate;
  /** fetch data from the table in a streaming manner: "accounts_receivable" */
  accountsReceivableStream: Array<AccountsReceivable>;
  /** execute function "accounts_sorted_by_job_count" which returns "accounts" */
  accountsSortedByJobCount: Array<Accounts>;
  /** execute function "accounts_sorted_by_job_count" and query aggregates on result of table type "accounts" */
  accountsSortedByJobCountAggregate: AccountsAggregate;
  /** execute function "accounts_sorted_by_recently_viewed_for_user" which returns "accounts" */
  accountsSortedByRecentlyViewedForUser: Array<Accounts>;
  /** execute function "accounts_sorted_by_recently_viewed_for_user" and query aggregates on result of table type "accounts" */
  accountsSortedByRecentlyViewedForUserAggregate: AccountsAggregate;
  /** fetch data from the table in a streaming manner: "accounts" */
  accountsStream: Array<Accounts>;
  /** fetch data from the table: "accounts_viewed_by_user" */
  accountsViewedByUser: Array<AccountsViewedByUser>;
  /** fetch aggregated fields from the table: "accounts_viewed_by_user" */
  accountsViewedByUserAggregate: AccountsViewedByUserAggregate;
  /** fetch data from the table: "accounts_viewed_by_user" using primary key columns */
  accountsViewedByUserByPk?: Maybe<AccountsViewedByUser>;
  /** fetch data from the table in a streaming manner: "accounts_viewed_by_user" */
  accountsViewedByUserStream: Array<AccountsViewedByUser>;
  /** An array relationship */
  activityItems: Array<ActivityItems>;
  /** An aggregate relationship */
  activityItemsAggregate: ActivityItemsAggregate;
  /** fetch data from the table: "activity_items" using primary key columns */
  activityItemsByPk?: Maybe<ActivityItems>;
  /** fetch data from the table in a streaming manner: "activity_items" */
  activityItemsStream: Array<ActivityItems>;
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch aggregated fields from the table: "addresses" */
  addressesAggregate: AddressesAggregate;
  /** fetch data from the table: "addresses" using primary key columns */
  addressesByPk?: Maybe<Addresses>;
  /** fetch data from the table in a streaming manner: "addresses" */
  addressesStream: Array<Addresses>;
  /** fetch data from the table: "aggregatable_invoices" */
  aggregatableInvoices: Array<AggregatableInvoices>;
  /** fetch aggregated fields from the table: "aggregatable_invoices" */
  aggregatableInvoicesAggregate: AggregatableInvoicesAggregate;
  /** fetch data from the table in a streaming manner: "aggregatable_invoices" */
  aggregatableInvoicesStream: Array<AggregatableInvoices>;
  /** fetch data from the table: "application_tasks" */
  applicationTasks: Array<ApplicationTasks>;
  /** fetch aggregated fields from the table: "application_tasks" */
  applicationTasksAggregate: ApplicationTasksAggregate;
  /** fetch data from the table: "application_tasks" using primary key columns */
  applicationTasksByPk?: Maybe<ApplicationTasks>;
  /** fetch data from the table in a streaming manner: "application_tasks" */
  applicationTasksStream: Array<ApplicationTasks>;
  /** fetch data from the table: "appointment_checklist_association_rules" */
  appointmentChecklistAssociationRules: Array<AppointmentChecklistAssociationRules>;
  /** fetch aggregated fields from the table: "appointment_checklist_association_rules" */
  appointmentChecklistAssociationRulesAggregate: AppointmentChecklistAssociationRulesAggregate;
  /** fetch data from the table: "appointment_checklist_association_rules" using primary key columns */
  appointmentChecklistAssociationRulesByPk?: Maybe<AppointmentChecklistAssociationRules>;
  /** fetch data from the table in a streaming manner: "appointment_checklist_association_rules" */
  appointmentChecklistAssociationRulesStream: Array<AppointmentChecklistAssociationRules>;
  /** An array relationship */
  appointmentChecklistInstances: Array<AppointmentChecklistInstances>;
  /** An aggregate relationship */
  appointmentChecklistInstancesAggregate: AppointmentChecklistInstancesAggregate;
  /** fetch data from the table: "appointment_checklist_instances" using primary key columns */
  appointmentChecklistInstancesByPk?: Maybe<AppointmentChecklistInstances>;
  /** fetch data from the table in a streaming manner: "appointment_checklist_instances" */
  appointmentChecklistInstancesStream: Array<AppointmentChecklistInstances>;
  /** fetch data from the table: "appointment_checklists" */
  appointmentChecklists: Array<AppointmentChecklists>;
  /** fetch aggregated fields from the table: "appointment_checklists" */
  appointmentChecklistsAggregate: AppointmentChecklistsAggregate;
  /** fetch data from the table: "appointment_checklists" using primary key columns */
  appointmentChecklistsByPk?: Maybe<AppointmentChecklists>;
  /** fetch data from the table in a streaming manner: "appointment_checklists" */
  appointmentChecklistsStream: Array<AppointmentChecklists>;
  /** An array relationship */
  assistantIntegratedPhones: Array<AssistantIntegratedPhones>;
  /** An aggregate relationship */
  assistantIntegratedPhonesAggregate: AssistantIntegratedPhonesAggregate;
  /** fetch data from the table: "assistant_integrated_phones" using primary key columns */
  assistantIntegratedPhonesByPk?: Maybe<AssistantIntegratedPhones>;
  /** fetch data from the table in a streaming manner: "assistant_integrated_phones" */
  assistantIntegratedPhonesStream: Array<AssistantIntegratedPhones>;
  /** fetch data from the table: "assistant_phone_settings" */
  assistantPhoneSettings: Array<AssistantPhoneSettings>;
  /** fetch aggregated fields from the table: "assistant_phone_settings" */
  assistantPhoneSettingsAggregate: AssistantPhoneSettingsAggregate;
  /** fetch data from the table: "assistant_phone_settings" using primary key columns */
  assistantPhoneSettingsByPk?: Maybe<AssistantPhoneSettings>;
  /** fetch data from the table in a streaming manner: "assistant_phone_settings" */
  assistantPhoneSettingsStream: Array<AssistantPhoneSettings>;
  /** fetch data from the table: "assistants" */
  assistants: Array<Assistants>;
  /** fetch aggregated fields from the table: "assistants" */
  assistantsAggregate: AssistantsAggregate;
  /** fetch data from the table: "assistants" using primary key columns */
  assistantsByPk?: Maybe<Assistants>;
  /** fetch data from the table in a streaming manner: "assistants" */
  assistantsStream: Array<Assistants>;
  /** fetch data from the table: "billing_profile_hidden_payment_methods" */
  billingProfileHiddenPaymentMethods: Array<BillingProfileHiddenPaymentMethods>;
  /** fetch aggregated fields from the table: "billing_profile_hidden_payment_methods" */
  billingProfileHiddenPaymentMethodsAggregate: BillingProfileHiddenPaymentMethodsAggregate;
  /** fetch data from the table: "billing_profile_hidden_payment_methods" using primary key columns */
  billingProfileHiddenPaymentMethodsByPk?: Maybe<BillingProfileHiddenPaymentMethods>;
  /** fetch data from the table in a streaming manner: "billing_profile_hidden_payment_methods" */
  billingProfileHiddenPaymentMethodsStream: Array<BillingProfileHiddenPaymentMethods>;
  /** fetch data from the table: "billing_profiles" */
  billingProfiles: Array<BillingProfiles>;
  /** fetch aggregated fields from the table: "billing_profiles" */
  billingProfilesAggregate: BillingProfilesAggregate;
  /** fetch data from the table: "billing_profiles" using primary key columns */
  billingProfilesByPk?: Maybe<BillingProfiles>;
  /** fetch data from the table in a streaming manner: "billing_profiles" */
  billingProfilesStream: Array<BillingProfiles>;
  /** fetch data from the table: "business_events" */
  businessEvents: Array<BusinessEvents>;
  /** fetch aggregated fields from the table: "business_events" */
  businessEventsAggregate: BusinessEventsAggregate;
  /** fetch data from the table: "business_events" using primary key columns */
  businessEventsByPk?: Maybe<BusinessEvents>;
  /** fetch data from the table in a streaming manner: "business_events" */
  businessEventsStream: Array<BusinessEvents>;
  /** fetch data from the table: "business_unit_target_metrics" */
  businessUnitTargetMetrics: Array<BusinessUnitTargetMetrics>;
  /** fetch aggregated fields from the table: "business_unit_target_metrics" */
  businessUnitTargetMetricsAggregate: BusinessUnitTargetMetricsAggregate;
  /** fetch data from the table: "business_unit_target_metrics" using primary key columns */
  businessUnitTargetMetricsByPk?: Maybe<BusinessUnitTargetMetrics>;
  /** fetch data from the table in a streaming manner: "business_unit_target_metrics" */
  businessUnitTargetMetricsStream: Array<BusinessUnitTargetMetrics>;
  /** fetch data from the table: "business_units" */
  businessUnits: Array<BusinessUnits>;
  /** fetch aggregated fields from the table: "business_units" */
  businessUnitsAggregate: BusinessUnitsAggregate;
  /** fetch data from the table: "business_units" using primary key columns */
  businessUnitsByPk?: Maybe<BusinessUnits>;
  /** fetch data from the table in a streaming manner: "business_units" */
  businessUnitsStream: Array<BusinessUnits>;
  /** fetch data from the table: "canonical_lead_sources" */
  canonicalLeadSources: Array<CanonicalLeadSources>;
  /** fetch aggregated fields from the table: "canonical_lead_sources" */
  canonicalLeadSourcesAggregate: CanonicalLeadSourcesAggregate;
  /** fetch data from the table: "canonical_lead_sources" using primary key columns */
  canonicalLeadSourcesByPk?: Maybe<CanonicalLeadSources>;
  /** fetch data from the table in a streaming manner: "canonical_lead_sources" */
  canonicalLeadSourcesStream: Array<CanonicalLeadSources>;
  /** fetch data from the table: "cart_item_job_cost_links" */
  cartItemJobCostLinks: Array<CartItemJobCostLinks>;
  /** fetch aggregated fields from the table: "cart_item_job_cost_links" */
  cartItemJobCostLinksAggregate: CartItemJobCostLinksAggregate;
  /** fetch data from the table: "cart_item_job_cost_links" using primary key columns */
  cartItemJobCostLinksByPk?: Maybe<CartItemJobCostLinks>;
  /** fetch data from the table in a streaming manner: "cart_item_job_cost_links" */
  cartItemJobCostLinksStream: Array<CartItemJobCostLinks>;
  /** fetch data from the table: "cart_items" */
  cartItems: Array<CartItems>;
  /** fetch aggregated fields from the table: "cart_items" */
  cartItemsAggregate: CartItemsAggregate;
  /** fetch data from the table: "cart_items" using primary key columns */
  cartItemsByPk?: Maybe<CartItems>;
  /** fetch data from the table in a streaming manner: "cart_items" */
  cartItemsStream: Array<CartItems>;
  /** fetch data from the table: "checklist_items" */
  checklistItems: Array<ChecklistItems>;
  /** fetch aggregated fields from the table: "checklist_items" */
  checklistItemsAggregate: ChecklistItemsAggregate;
  /** fetch data from the table: "checklist_items" using primary key columns */
  checklistItemsByPk?: Maybe<ChecklistItems>;
  /** fetch data from the table in a streaming manner: "checklist_items" */
  checklistItemsStream: Array<ChecklistItems>;
  /** fetch data from the table: "companies" */
  companies: Array<Companies>;
  /** fetch aggregated fields from the table: "companies" */
  companiesAggregate: CompaniesAggregate;
  /** fetch data from the table: "companies" using primary key columns */
  companiesByPk?: Maybe<Companies>;
  /** fetch data from the table in a streaming manner: "companies" */
  companiesStream: Array<Companies>;
  /** An array relationship */
  companyAppointmentArrivalWindows: Array<CompanyAppointmentArrivalWindows>;
  /** An aggregate relationship */
  companyAppointmentArrivalWindowsAggregate: CompanyAppointmentArrivalWindowsAggregate;
  /** fetch data from the table: "company_appointment_arrival_windows" using primary key columns */
  companyAppointmentArrivalWindowsByPk?: Maybe<CompanyAppointmentArrivalWindows>;
  /** fetch data from the table in a streaming manner: "company_appointment_arrival_windows" */
  companyAppointmentArrivalWindowsStream: Array<CompanyAppointmentArrivalWindows>;
  /** fetch data from the table: "company_commission_config" */
  companyCommissionConfig: Array<CompanyCommissionConfig>;
  /** fetch aggregated fields from the table: "company_commission_config" */
  companyCommissionConfigAggregate: CompanyCommissionConfigAggregate;
  /** fetch data from the table: "company_commission_config" using primary key columns */
  companyCommissionConfigByPk?: Maybe<CompanyCommissionConfig>;
  /** fetch data from the table in a streaming manner: "company_commission_config" */
  companyCommissionConfigStream: Array<CompanyCommissionConfig>;
  /** fetch data from the table: "company_config" */
  companyConfig: Array<CompanyConfig>;
  /** fetch aggregated fields from the table: "company_config" */
  companyConfigAggregate: CompanyConfigAggregate;
  /** fetch data from the table: "company_config" using primary key columns */
  companyConfigByPk?: Maybe<CompanyConfig>;
  /** fetch data from the table in a streaming manner: "company_config" */
  companyConfigStream: Array<CompanyConfig>;
  /** fetch data from the table: "company_drip_marketing_config" */
  companyDripMarketingConfig: Array<CompanyDripMarketingConfig>;
  /** fetch aggregated fields from the table: "company_drip_marketing_config" */
  companyDripMarketingConfigAggregate: CompanyDripMarketingConfigAggregate;
  /** fetch data from the table: "company_drip_marketing_config" using primary key columns */
  companyDripMarketingConfigByPk?: Maybe<CompanyDripMarketingConfig>;
  /** fetch data from the table in a streaming manner: "company_drip_marketing_config" */
  companyDripMarketingConfigStream: Array<CompanyDripMarketingConfig>;
  /** An array relationship */
  companyLeadSourceLinks: Array<CompanyLeadSourceLinks>;
  /** An aggregate relationship */
  companyLeadSourceLinksAggregate: CompanyLeadSourceLinksAggregate;
  /** fetch data from the table: "company_lead_source_links" using primary key columns */
  companyLeadSourceLinksByPk?: Maybe<CompanyLeadSourceLinks>;
  /** fetch data from the table in a streaming manner: "company_lead_source_links" */
  companyLeadSourceLinksStream: Array<CompanyLeadSourceLinks>;
  /** An array relationship */
  companyLeadSources: Array<CompanyLeadSources>;
  /** An aggregate relationship */
  companyLeadSourcesAggregate: CompanyLeadSourcesAggregate;
  /** fetch data from the table: "company_lead_sources" using primary key columns */
  companyLeadSourcesByPk?: Maybe<CompanyLeadSources>;
  /** fetch data from the table in a streaming manner: "company_lead_sources" */
  companyLeadSourcesStream: Array<CompanyLeadSources>;
  /** An array relationship */
  companyNotificationSettings: Array<CompanyNotificationSettings>;
  /** An aggregate relationship */
  companyNotificationSettingsAggregate: CompanyNotificationSettingsAggregate;
  /** fetch data from the table: "company_notification_settings" using primary key columns */
  companyNotificationSettingsByPk?: Maybe<CompanyNotificationSettings>;
  /** fetch data from the table in a streaming manner: "company_notification_settings" */
  companyNotificationSettingsStream: Array<CompanyNotificationSettings>;
  /** fetch data from the table: "company_pricing_tier_config" */
  companyPricingTierConfig: Array<CompanyPricingTierConfig>;
  /** fetch aggregated fields from the table: "company_pricing_tier_config" */
  companyPricingTierConfigAggregate: CompanyPricingTierConfigAggregate;
  /** fetch data from the table: "company_pricing_tier_config" using primary key columns */
  companyPricingTierConfigByPk?: Maybe<CompanyPricingTierConfig>;
  /** fetch data from the table in a streaming manner: "company_pricing_tier_config" */
  companyPricingTierConfigStream: Array<CompanyPricingTierConfig>;
  /** An array relationship */
  companyReviewLinks: Array<CompanyReviewLinks>;
  /** An aggregate relationship */
  companyReviewLinksAggregate: CompanyReviewLinksAggregate;
  /** fetch data from the table: "company_review_links" using primary key columns */
  companyReviewLinksByPk?: Maybe<CompanyReviewLinks>;
  /** fetch data from the table in a streaming manner: "company_review_links" */
  companyReviewLinksStream: Array<CompanyReviewLinks>;
  /** fetch data from the table: "company_roles" */
  companyRoles: Array<CompanyRoles>;
  /** fetch aggregated fields from the table: "company_roles" */
  companyRolesAggregate: CompanyRolesAggregate;
  /** fetch data from the table: "company_roles" using primary key columns */
  companyRolesByPk?: Maybe<CompanyRoles>;
  /** fetch data from the table in a streaming manner: "company_roles" */
  companyRolesStream: Array<CompanyRoles>;
  /** fetch data from the table: "company_tax_configurations" */
  companyTaxConfigurations: Array<CompanyTaxConfigurations>;
  /** fetch aggregated fields from the table: "company_tax_configurations" */
  companyTaxConfigurationsAggregate: CompanyTaxConfigurationsAggregate;
  /** fetch data from the table: "company_tax_configurations" using primary key columns */
  companyTaxConfigurationsByPk?: Maybe<CompanyTaxConfigurations>;
  /** fetch data from the table in a streaming manner: "company_tax_configurations" */
  companyTaxConfigurationsStream: Array<CompanyTaxConfigurations>;
  /** An array relationship */
  companyUsers: Array<CompanyUsers>;
  /** An aggregate relationship */
  companyUsersAggregate: CompanyUsersAggregate;
  /** fetch data from the table: "company_users" using primary key columns */
  companyUsersByPk?: Maybe<CompanyUsers>;
  /** fetch data from the table in a streaming manner: "company_users" */
  companyUsersStream: Array<CompanyUsers>;
  /** fetch data from the table: "company_working_display_hours" */
  companyWorkingDisplayHours: Array<CompanyWorkingDisplayHours>;
  /** fetch aggregated fields from the table: "company_working_display_hours" */
  companyWorkingDisplayHoursAggregate: CompanyWorkingDisplayHoursAggregate;
  /** fetch data from the table: "company_working_display_hours" using primary key columns */
  companyWorkingDisplayHoursByPk?: Maybe<CompanyWorkingDisplayHours>;
  /** fetch data from the table in a streaming manner: "company_working_display_hours" */
  companyWorkingDisplayHoursStream: Array<CompanyWorkingDisplayHours>;
  /** An array relationship */
  contacts: Array<Contacts>;
  /** An aggregate relationship */
  contactsAggregate: ContactsAggregate;
  /** fetch data from the table: "contacts" using primary key columns */
  contactsByPk?: Maybe<Contacts>;
  /** fetch data from the table in a streaming manner: "contacts" */
  contactsStream: Array<Contacts>;
  /** fetch data from the table: "cron_jobs" */
  cronJobs: Array<CronJobs>;
  /** fetch aggregated fields from the table: "cron_jobs" */
  cronJobsAggregate: CronJobsAggregate;
  /** fetch data from the table: "cron_jobs" using primary key columns */
  cronJobsByPk?: Maybe<CronJobs>;
  /** fetch data from the table in a streaming manner: "cron_jobs" */
  cronJobsStream: Array<CronJobs>;
  /** fetch data from the table: "current_business_unit_target_metrics_view" */
  currentBusinessUnitTargetMetricsView: Array<CurrentBusinessUnitTargetMetricsView>;
  /** fetch aggregated fields from the table: "current_business_unit_target_metrics_view" */
  currentBusinessUnitTargetMetricsViewAggregate: CurrentBusinessUnitTargetMetricsViewAggregate;
  /** fetch data from the table in a streaming manner: "current_business_unit_target_metrics_view" */
  currentBusinessUnitTargetMetricsViewStream: Array<CurrentBusinessUnitTargetMetricsView>;
  /** fetch data from the table: "current_company_tax_configurations_view" */
  currentCompanyTaxConfigurationsView: Array<CurrentCompanyTaxConfigurationsView>;
  /** fetch aggregated fields from the table: "current_company_tax_configurations_view" */
  currentCompanyTaxConfigurationsViewAggregate: CurrentCompanyTaxConfigurationsViewAggregate;
  /** fetch data from the table in a streaming manner: "current_company_tax_configurations_view" */
  currentCompanyTaxConfigurationsViewStream: Array<CurrentCompanyTaxConfigurationsView>;
  /** fetch data from the table: "current_user_business_units_view" */
  currentUserBusinessUnitsView: Array<CurrentUserBusinessUnitsView>;
  /** fetch aggregated fields from the table: "current_user_business_units_view" */
  currentUserBusinessUnitsViewAggregate: CurrentUserBusinessUnitsViewAggregate;
  /** fetch data from the table in a streaming manner: "current_user_business_units_view" */
  currentUserBusinessUnitsViewStream: Array<CurrentUserBusinessUnitsView>;
  /** fetch data from the table: "customer_communication_templates" */
  customerCommunicationTemplates: Array<CustomerCommunicationTemplates>;
  /** fetch aggregated fields from the table: "customer_communication_templates" */
  customerCommunicationTemplatesAggregate: CustomerCommunicationTemplatesAggregate;
  /** fetch data from the table: "customer_communication_templates" using primary key columns */
  customerCommunicationTemplatesByPk?: Maybe<CustomerCommunicationTemplates>;
  /** fetch data from the table in a streaming manner: "customer_communication_templates" */
  customerCommunicationTemplatesStream: Array<CustomerCommunicationTemplates>;
  /** fetch data from the table: "discount_entitlements" */
  discountEntitlements: Array<DiscountEntitlements>;
  /** fetch aggregated fields from the table: "discount_entitlements" */
  discountEntitlementsAggregate: DiscountEntitlementsAggregate;
  /** fetch data from the table: "discount_entitlements" using primary key columns */
  discountEntitlementsByPk?: Maybe<DiscountEntitlements>;
  /** fetch data from the table in a streaming manner: "discount_entitlements" */
  discountEntitlementsStream: Array<DiscountEntitlements>;
  /** fetch data from the table: "display_id_counters" */
  displayIdCounters: Array<DisplayIdCounters>;
  /** fetch aggregated fields from the table: "display_id_counters" */
  displayIdCountersAggregate: DisplayIdCountersAggregate;
  /** fetch data from the table: "display_id_counters" using primary key columns */
  displayIdCountersByPk?: Maybe<DisplayIdCounters>;
  /** fetch data from the table in a streaming manner: "display_id_counters" */
  displayIdCountersStream: Array<DisplayIdCounters>;
  /** fetch data from the table: "drip_marketing_emails" */
  dripMarketingEmails: Array<DripMarketingEmails>;
  /** fetch aggregated fields from the table: "drip_marketing_emails" */
  dripMarketingEmailsAggregate: DripMarketingEmailsAggregate;
  /** fetch data from the table: "drip_marketing_emails" using primary key columns */
  dripMarketingEmailsByPk?: Maybe<DripMarketingEmails>;
  /** fetch data from the table in a streaming manner: "drip_marketing_emails" */
  dripMarketingEmailsStream: Array<DripMarketingEmails>;
  /** fetch data from the table: "email_addresses" */
  emailAddresses: Array<EmailAddresses>;
  /** fetch aggregated fields from the table: "email_addresses" */
  emailAddressesAggregate: EmailAddressesAggregate;
  /** fetch data from the table: "email_addresses" using primary key columns */
  emailAddressesByPk?: Maybe<EmailAddresses>;
  /** fetch data from the table in a streaming manner: "email_addresses" */
  emailAddressesStream: Array<EmailAddresses>;
  /** fetch data from the table: "entitlements" */
  entitlements: Array<Entitlements>;
  /** fetch aggregated fields from the table: "entitlements" */
  entitlementsAggregate: EntitlementsAggregate;
  /** fetch data from the table: "entitlements" using primary key columns */
  entitlementsByPk?: Maybe<Entitlements>;
  /** fetch data from the table in a streaming manner: "entitlements" */
  entitlementsStream: Array<Entitlements>;
  /** fetch data from the table: "equipment_type_links" */
  equipmentTypeLinks: Array<EquipmentTypeLinks>;
  /** fetch aggregated fields from the table: "equipment_type_links" */
  equipmentTypeLinksAggregate: EquipmentTypeLinksAggregate;
  /** fetch data from the table: "equipment_type_links" using primary key columns */
  equipmentTypeLinksByPk?: Maybe<EquipmentTypeLinks>;
  /** fetch data from the table in a streaming manner: "equipment_type_links" */
  equipmentTypeLinksStream: Array<EquipmentTypeLinks>;
  /** fetch data from the table: "equipment_types" */
  equipmentTypes: Array<EquipmentTypes>;
  /** fetch aggregated fields from the table: "equipment_types" */
  equipmentTypesAggregate: EquipmentTypesAggregate;
  /** fetch data from the table: "equipment_types" using primary key columns */
  equipmentTypesByPk?: Maybe<EquipmentTypes>;
  /** fetch data from the table in a streaming manner: "equipment_types" */
  equipmentTypesStream: Array<EquipmentTypes>;
  /** fetch data from the table: "estimate_invoices" */
  estimateInvoices: Array<EstimateInvoices>;
  /** fetch aggregated fields from the table: "estimate_invoices" */
  estimateInvoicesAggregate: EstimateInvoicesAggregate;
  /** fetch data from the table: "estimate_invoices" using primary key columns */
  estimateInvoicesByPk?: Maybe<EstimateInvoices>;
  /** fetch data from the table in a streaming manner: "estimate_invoices" */
  estimateInvoicesStream: Array<EstimateInvoices>;
  /** An array relationship */
  estimateOptionCartItems: Array<EstimateOptionCartItems>;
  /** An aggregate relationship */
  estimateOptionCartItemsAggregate: EstimateOptionCartItemsAggregate;
  /** fetch data from the table: "estimate_option_cart_items" using primary key columns */
  estimateOptionCartItemsByPk?: Maybe<EstimateOptionCartItems>;
  /** fetch data from the table in a streaming manner: "estimate_option_cart_items" */
  estimateOptionCartItemsStream: Array<EstimateOptionCartItems>;
  /** An array relationship */
  estimateOptionDiscounts: Array<EstimateOptionDiscounts>;
  /** An aggregate relationship */
  estimateOptionDiscountsAggregate: EstimateOptionDiscountsAggregate;
  /** fetch data from the table: "estimate_option_discounts" using primary key columns */
  estimateOptionDiscountsByPk?: Maybe<EstimateOptionDiscounts>;
  /** fetch data from the table in a streaming manner: "estimate_option_discounts" */
  estimateOptionDiscountsStream: Array<EstimateOptionDiscounts>;
  /** fetch data from the table: "estimate_option_tax_configurations_view" */
  estimateOptionTaxConfigurationsView: Array<EstimateOptionTaxConfigurationsView>;
  /** fetch aggregated fields from the table: "estimate_option_tax_configurations_view" */
  estimateOptionTaxConfigurationsViewAggregate: EstimateOptionTaxConfigurationsViewAggregate;
  /** fetch data from the table in a streaming manner: "estimate_option_tax_configurations_view" */
  estimateOptionTaxConfigurationsViewStream: Array<EstimateOptionTaxConfigurationsView>;
  /** An array relationship */
  estimateOptions: Array<EstimateOptions>;
  /** An aggregate relationship */
  estimateOptionsAggregate: EstimateOptionsAggregate;
  /** fetch data from the table: "estimate_options" using primary key columns */
  estimateOptionsByPk?: Maybe<EstimateOptions>;
  /** fetch data from the table in a streaming manner: "estimate_options" */
  estimateOptionsStream: Array<EstimateOptions>;
  /** An array relationship */
  estimatePhotos: Array<EstimatePhotos>;
  /** An aggregate relationship */
  estimatePhotosAggregate: EstimatePhotosAggregate;
  /** fetch data from the table: "estimate_photos" using primary key columns */
  estimatePhotosByPk?: Maybe<EstimatePhotos>;
  /** fetch data from the table in a streaming manner: "estimate_photos" */
  estimatePhotosStream: Array<EstimatePhotos>;
  /** fetch data from the table: "estimate_templates" */
  estimateTemplates: Array<EstimateTemplates>;
  /** fetch aggregated fields from the table: "estimate_templates" */
  estimateTemplatesAggregate: EstimateTemplatesAggregate;
  /** fetch data from the table: "estimate_templates" using primary key columns */
  estimateTemplatesByPk?: Maybe<EstimateTemplates>;
  /** fetch data from the table in a streaming manner: "estimate_templates" */
  estimateTemplatesStream: Array<EstimateTemplates>;
  /** An array relationship */
  estimates: Array<Estimates>;
  /** An aggregate relationship */
  estimatesAggregate: EstimatesAggregate;
  /** fetch data from the table: "estimates" using primary key columns */
  estimatesByPk?: Maybe<Estimates>;
  /** fetch data from the table: "estimates_queryable" */
  estimatesQueryable: Array<EstimatesQueryable>;
  /** fetch aggregated fields from the table: "estimates_queryable" */
  estimatesQueryableAggregate: EstimatesQueryableAggregate;
  /** fetch data from the table: "estimates_queryable" using primary key columns */
  estimatesQueryableByPk?: Maybe<EstimatesQueryable>;
  /** fetch data from the table in a streaming manner: "estimates_queryable" */
  estimatesQueryableStream: Array<EstimatesQueryable>;
  /** fetch data from the table in a streaming manner: "estimates" */
  estimatesStream: Array<Estimates>;
  /** fetch data from the table: "event_store" */
  eventStore: Array<EventStore>;
  /** fetch aggregated fields from the table: "event_store" */
  eventStoreAggregate: EventStoreAggregate;
  /** fetch data from the table: "event_store" using primary key columns */
  eventStoreByPk?: Maybe<EventStore>;
  /** fetch data from the table in a streaming manner: "event_store" */
  eventStoreStream: Array<EventStore>;
  /** fetch data from the table: "favorite_pricebook_items" */
  favoritePricebookItems: Array<FavoritePricebookItems>;
  /** fetch aggregated fields from the table: "favorite_pricebook_items" */
  favoritePricebookItemsAggregate: FavoritePricebookItemsAggregate;
  /** fetch data from the table: "favorite_pricebook_items" using primary key columns */
  favoritePricebookItemsByPk?: Maybe<FavoritePricebookItems>;
  /** fetch data from the table in a streaming manner: "favorite_pricebook_items" */
  favoritePricebookItemsStream: Array<FavoritePricebookItems>;
  /** An array relationship */
  fileLinks: Array<FileLinks>;
  /** An aggregate relationship */
  fileLinksAggregate: FileLinksAggregate;
  /** fetch data from the table: "file_links" using primary key columns */
  fileLinksByPk?: Maybe<FileLinks>;
  /** fetch data from the table in a streaming manner: "file_links" */
  fileLinksStream: Array<FileLinks>;
  /** fetch data from the table: "files" */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "files" */
  filesAggregate: FilesAggregate;
  /** fetch data from the table: "files" using primary key columns */
  filesByPk?: Maybe<Files>;
  /** fetch data from the table in a streaming manner: "files" */
  filesStream: Array<Files>;
  /** An array relationship */
  installedEquipment: Array<InstalledEquipment>;
  /** An aggregate relationship */
  installedEquipmentAggregate: InstalledEquipmentAggregate;
  /** fetch data from the table: "installed_equipment" using primary key columns */
  installedEquipmentByPk?: Maybe<InstalledEquipment>;
  /** fetch data from the table in a streaming manner: "installed_equipment" */
  installedEquipmentStream: Array<InstalledEquipment>;
  /** An array relationship */
  installedHvacSystems: Array<InstalledHvacSystems>;
  /** An aggregate relationship */
  installedHvacSystemsAggregate: InstalledHvacSystemsAggregate;
  /** fetch data from the table: "installed_hvac_systems" using primary key columns */
  installedHvacSystemsByPk?: Maybe<InstalledHvacSystems>;
  /** fetch data from the table in a streaming manner: "installed_hvac_systems" */
  installedHvacSystemsStream: Array<InstalledHvacSystems>;
  /** An array relationship */
  instantBookingWeeklyScheduleEntries: Array<InstantBookingWeeklyScheduleEntries>;
  /** An aggregate relationship */
  instantBookingWeeklyScheduleEntriesAggregate: InstantBookingWeeklyScheduleEntriesAggregate;
  /** fetch data from the table: "instant_booking_weekly_schedule_entries" using primary key columns */
  instantBookingWeeklyScheduleEntriesByPk?: Maybe<InstantBookingWeeklyScheduleEntries>;
  /** fetch data from the table in a streaming manner: "instant_booking_weekly_schedule_entries" */
  instantBookingWeeklyScheduleEntriesStream: Array<InstantBookingWeeklyScheduleEntries>;
  /** fetch data from the table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
  instantBookingWeeklyScheduleEntryBookableArrivalWindows: Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindows>;
  /** fetch aggregated fields from the table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
  instantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregate: InstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregate;
  /** fetch data from the table: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" using primary key columns */
  instantBookingWeeklyScheduleEntryBookableArrivalWindowsByPk?: Maybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindows>;
  /** fetch data from the table in a streaming manner: "instant_booking_weekly_schedule_entry_bookable_arrival_windows" */
  instantBookingWeeklyScheduleEntryBookableArrivalWindowsStream: Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindows>;
  /** An array relationship */
  integratedChannelCompletableItems: Array<IntegratedChannelCompletableItems>;
  /** An aggregate relationship */
  integratedChannelCompletableItemsAggregate: IntegratedChannelCompletableItemsAggregate;
  /** fetch data from the table in a streaming manner: "integrated_channel_completable_items" */
  integratedChannelCompletableItemsStream: Array<IntegratedChannelCompletableItems>;
  /** An array relationship */
  integratedChannelItems: Array<IntegratedChannelItems>;
  /** An aggregate relationship */
  integratedChannelItemsAggregate: IntegratedChannelItemsAggregate;
  /** fetch data from the table in a streaming manner: "integrated_channel_items" */
  integratedChannelItemsStream: Array<IntegratedChannelItems>;
  /** An array relationship */
  integratedChannelReadableItems: Array<IntegratedChannelReadableItems>;
  /** An aggregate relationship */
  integratedChannelReadableItemsAggregate: IntegratedChannelReadableItemsAggregate;
  /** fetch data from the table in a streaming manner: "integrated_channel_readable_items" */
  integratedChannelReadableItemsStream: Array<IntegratedChannelReadableItems>;
  /** fetch data from the table: "integrated_channels" */
  integratedChannels: Array<IntegratedChannels>;
  /** fetch aggregated fields from the table: "integrated_channels" */
  integratedChannelsAggregate: IntegratedChannelsAggregate;
  /** fetch data from the table: "integrated_channels" using primary key columns */
  integratedChannelsByPk?: Maybe<IntegratedChannels>;
  /** fetch data from the table in a streaming manner: "integrated_channels" */
  integratedChannelsStream: Array<IntegratedChannels>;
  /** fetch data from the table: "integrated_message_statuses" */
  integratedMessageStatuses: Array<IntegratedMessageStatuses>;
  /** fetch aggregated fields from the table: "integrated_message_statuses" */
  integratedMessageStatusesAggregate: IntegratedMessageStatusesAggregate;
  /** fetch data from the table: "integrated_message_statuses" using primary key columns */
  integratedMessageStatusesByPk?: Maybe<IntegratedMessageStatuses>;
  /** fetch data from the table in a streaming manner: "integrated_message_statuses" */
  integratedMessageStatusesStream: Array<IntegratedMessageStatuses>;
  /** fetch data from the table: "integrated_message_twilio_raw_webhook_events" */
  integratedMessageTwilioRawWebhookEvents: Array<IntegratedMessageTwilioRawWebhookEvents>;
  /** fetch aggregated fields from the table: "integrated_message_twilio_raw_webhook_events" */
  integratedMessageTwilioRawWebhookEventsAggregate: IntegratedMessageTwilioRawWebhookEventsAggregate;
  /** fetch data from the table: "integrated_message_twilio_raw_webhook_events" using primary key columns */
  integratedMessageTwilioRawWebhookEventsByPk?: Maybe<IntegratedMessageTwilioRawWebhookEvents>;
  /** fetch data from the table in a streaming manner: "integrated_message_twilio_raw_webhook_events" */
  integratedMessageTwilioRawWebhookEventsStream: Array<IntegratedMessageTwilioRawWebhookEvents>;
  /** fetch data from the table: "integrated_messages" */
  integratedMessages: Array<IntegratedMessages>;
  /** fetch aggregated fields from the table: "integrated_messages" */
  integratedMessagesAggregate: IntegratedMessagesAggregate;
  /** fetch data from the table: "integrated_messages" using primary key columns */
  integratedMessagesByPk?: Maybe<IntegratedMessages>;
  /** fetch data from the table in a streaming manner: "integrated_messages" */
  integratedMessagesStream: Array<IntegratedMessages>;
  /** An array relationship */
  integratedPhoneCallDismissals: Array<IntegratedPhoneCallDismissals>;
  /** An aggregate relationship */
  integratedPhoneCallDismissalsAggregate: IntegratedPhoneCallDismissalsAggregate;
  /** fetch data from the table: "integrated_phone_call_dismissals" using primary key columns */
  integratedPhoneCallDismissalsByPk?: Maybe<IntegratedPhoneCallDismissals>;
  /** fetch data from the table in a streaming manner: "integrated_phone_call_dismissals" */
  integratedPhoneCallDismissalsStream: Array<IntegratedPhoneCallDismissals>;
  /** An array relationship */
  integratedPhoneCallJobs: Array<IntegratedPhoneCallJobs>;
  /** An aggregate relationship */
  integratedPhoneCallJobsAggregate: IntegratedPhoneCallJobsAggregate;
  /** fetch data from the table: "integrated_phone_call_jobs" using primary key columns */
  integratedPhoneCallJobsByPk?: Maybe<IntegratedPhoneCallJobs>;
  /** fetch data from the table in a streaming manner: "integrated_phone_call_jobs" */
  integratedPhoneCallJobsStream: Array<IntegratedPhoneCallJobs>;
  /** fetch data from the table: "integrated_phone_call_recording" */
  integratedPhoneCallRecording: Array<IntegratedPhoneCallRecording>;
  /** fetch aggregated fields from the table: "integrated_phone_call_recording" */
  integratedPhoneCallRecordingAggregate: IntegratedPhoneCallRecordingAggregate;
  /** fetch data from the table: "integrated_phone_call_recording" using primary key columns */
  integratedPhoneCallRecordingByPk?: Maybe<IntegratedPhoneCallRecording>;
  /** fetch data from the table in a streaming manner: "integrated_phone_call_recording" */
  integratedPhoneCallRecordingStream: Array<IntegratedPhoneCallRecording>;
  /** fetch data from the table: "integrated_phone_call_status_types" */
  integratedPhoneCallStatusTypes: Array<IntegratedPhoneCallStatusTypes>;
  /** fetch aggregated fields from the table: "integrated_phone_call_status_types" */
  integratedPhoneCallStatusTypesAggregate: IntegratedPhoneCallStatusTypesAggregate;
  /** fetch data from the table: "integrated_phone_call_status_types" using primary key columns */
  integratedPhoneCallStatusTypesByPk?: Maybe<IntegratedPhoneCallStatusTypes>;
  /** fetch data from the table in a streaming manner: "integrated_phone_call_status_types" */
  integratedPhoneCallStatusTypesStream: Array<IntegratedPhoneCallStatusTypes>;
  /** An array relationship */
  integratedPhoneCallStatuses: Array<IntegratedPhoneCallStatuses>;
  /** An aggregate relationship */
  integratedPhoneCallStatusesAggregate: IntegratedPhoneCallStatusesAggregate;
  /** fetch data from the table: "integrated_phone_call_statuses" using primary key columns */
  integratedPhoneCallStatusesByPk?: Maybe<IntegratedPhoneCallStatuses>;
  /** fetch data from the table in a streaming manner: "integrated_phone_call_statuses" */
  integratedPhoneCallStatusesStream: Array<IntegratedPhoneCallStatuses>;
  /** An array relationship */
  integratedPhoneCalls: Array<IntegratedPhoneCalls>;
  /** An aggregate relationship */
  integratedPhoneCallsAggregate: IntegratedPhoneCallsAggregate;
  /** fetch data from the table: "integrated_phone_calls" using primary key columns */
  integratedPhoneCallsByPk?: Maybe<IntegratedPhoneCalls>;
  /** fetch data from the table in a streaming manner: "integrated_phone_calls" */
  integratedPhoneCallsStream: Array<IntegratedPhoneCalls>;
  /** fetch data from the table: "integrated_phone_company_config" */
  integratedPhoneCompanyConfig: Array<IntegratedPhoneCompanyConfig>;
  /** fetch aggregated fields from the table: "integrated_phone_company_config" */
  integratedPhoneCompanyConfigAggregate: IntegratedPhoneCompanyConfigAggregate;
  /** fetch data from the table: "integrated_phone_company_config" using primary key columns */
  integratedPhoneCompanyConfigByPk?: Maybe<IntegratedPhoneCompanyConfig>;
  /** fetch data from the table in a streaming manner: "integrated_phone_company_config" */
  integratedPhoneCompanyConfigStream: Array<IntegratedPhoneCompanyConfig>;
  /** An array relationship */
  integratedPhoneMissedCallDismissals: Array<IntegratedPhoneMissedCallDismissals>;
  /** An aggregate relationship */
  integratedPhoneMissedCallDismissalsAggregate: IntegratedPhoneMissedCallDismissalsAggregate;
  /** fetch data from the table: "integrated_phone_missed_call_dismissals" using primary key columns */
  integratedPhoneMissedCallDismissalsByPk?: Maybe<IntegratedPhoneMissedCallDismissals>;
  /** fetch data from the table in a streaming manner: "integrated_phone_missed_call_dismissals" */
  integratedPhoneMissedCallDismissalsStream: Array<IntegratedPhoneMissedCallDismissals>;
  /** An array relationship */
  integratedPhoneMissedCalls: Array<IntegratedPhoneMissedCalls>;
  /** An aggregate relationship */
  integratedPhoneMissedCallsAggregate: IntegratedPhoneMissedCallsAggregate;
  /** fetch data from the table: "integrated_phone_missed_calls" using primary key columns */
  integratedPhoneMissedCallsByPk?: Maybe<IntegratedPhoneMissedCalls>;
  /** fetch data from the table in a streaming manner: "integrated_phone_missed_calls" */
  integratedPhoneMissedCallsStream: Array<IntegratedPhoneMissedCalls>;
  /** fetch data from the table: "integrated_phone_twilio_raw_webhook_events" */
  integratedPhoneTwilioRawWebhookEvents: Array<IntegratedPhoneTwilioRawWebhookEvents>;
  /** fetch aggregated fields from the table: "integrated_phone_twilio_raw_webhook_events" */
  integratedPhoneTwilioRawWebhookEventsAggregate: IntegratedPhoneTwilioRawWebhookEventsAggregate;
  /** fetch data from the table: "integrated_phone_twilio_raw_webhook_events" using primary key columns */
  integratedPhoneTwilioRawWebhookEventsByPk?: Maybe<IntegratedPhoneTwilioRawWebhookEvents>;
  /** fetch data from the table in a streaming manner: "integrated_phone_twilio_raw_webhook_events" */
  integratedPhoneTwilioRawWebhookEventsStream: Array<IntegratedPhoneTwilioRawWebhookEvents>;
  /** An array relationship */
  integratedPhoneUsers: Array<IntegratedPhoneUsers>;
  /** An aggregate relationship */
  integratedPhoneUsersAggregate: IntegratedPhoneUsersAggregate;
  /** fetch data from the table: "integrated_phone_users" using primary key columns */
  integratedPhoneUsersByPk?: Maybe<IntegratedPhoneUsers>;
  /** fetch data from the table in a streaming manner: "integrated_phone_users" */
  integratedPhoneUsersStream: Array<IntegratedPhoneUsers>;
  /** An array relationship */
  integratedPhoneVoicemailDismissals: Array<IntegratedPhoneVoicemailDismissals>;
  /** An aggregate relationship */
  integratedPhoneVoicemailDismissalsAggregate: IntegratedPhoneVoicemailDismissalsAggregate;
  /** fetch data from the table: "integrated_phone_voicemail_dismissals" using primary key columns */
  integratedPhoneVoicemailDismissalsByPk?: Maybe<IntegratedPhoneVoicemailDismissals>;
  /** fetch data from the table in a streaming manner: "integrated_phone_voicemail_dismissals" */
  integratedPhoneVoicemailDismissalsStream: Array<IntegratedPhoneVoicemailDismissals>;
  /** An array relationship */
  integratedPhoneVoicemails: Array<IntegratedPhoneVoicemails>;
  /** An aggregate relationship */
  integratedPhoneVoicemailsAggregate: IntegratedPhoneVoicemailsAggregate;
  /** fetch data from the table: "integrated_phone_voicemails" using primary key columns */
  integratedPhoneVoicemailsByPk?: Maybe<IntegratedPhoneVoicemails>;
  /** fetch data from the table in a streaming manner: "integrated_phone_voicemails" */
  integratedPhoneVoicemailsStream: Array<IntegratedPhoneVoicemails>;
  /** An array relationship */
  integratedPhones: Array<IntegratedPhones>;
  /** An aggregate relationship */
  integratedPhonesAggregate: IntegratedPhonesAggregate;
  /** fetch data from the table: "integrated_phones" using primary key columns */
  integratedPhonesByPk?: Maybe<IntegratedPhones>;
  /** fetch data from the table in a streaming manner: "integrated_phones" */
  integratedPhonesStream: Array<IntegratedPhones>;
  /** fetch data from the table: "internal_notifications" */
  internalNotifications: Array<InternalNotifications>;
  /** fetch aggregated fields from the table: "internal_notifications" */
  internalNotificationsAggregate: InternalNotificationsAggregate;
  /** fetch data from the table: "internal_notifications" using primary key columns */
  internalNotificationsByPk?: Maybe<InternalNotifications>;
  /** fetch data from the table in a streaming manner: "internal_notifications" */
  internalNotificationsStream: Array<InternalNotifications>;
  /** fetch data from the table: "invoice_business_unit" */
  invoiceBusinessUnit: Array<InvoiceBusinessUnit>;
  /** fetch aggregated fields from the table: "invoice_business_unit" */
  invoiceBusinessUnitAggregate: InvoiceBusinessUnitAggregate;
  /** fetch data from the table in a streaming manner: "invoice_business_unit" */
  invoiceBusinessUnitStream: Array<InvoiceBusinessUnit>;
  /** An array relationship */
  invoiceCartItemBundleItems: Array<InvoiceCartItemBundleItems>;
  /** An aggregate relationship */
  invoiceCartItemBundleItemsAggregate: InvoiceCartItemBundleItemsAggregate;
  /** fetch data from the table: "invoice_cart_item_bundle_items" using primary key columns */
  invoiceCartItemBundleItemsByPk?: Maybe<InvoiceCartItemBundleItems>;
  /** fetch data from the table in a streaming manner: "invoice_cart_item_bundle_items" */
  invoiceCartItemBundleItemsStream: Array<InvoiceCartItemBundleItems>;
  /** fetch data from the table: "invoice_cart_item_bundle_job_cost_links" */
  invoiceCartItemBundleJobCostLinks: Array<InvoiceCartItemBundleJobCostLinks>;
  /** fetch aggregated fields from the table: "invoice_cart_item_bundle_job_cost_links" */
  invoiceCartItemBundleJobCostLinksAggregate: InvoiceCartItemBundleJobCostLinksAggregate;
  /** fetch data from the table: "invoice_cart_item_bundle_job_cost_links" using primary key columns */
  invoiceCartItemBundleJobCostLinksByPk?: Maybe<InvoiceCartItemBundleJobCostLinks>;
  /** fetch data from the table in a streaming manner: "invoice_cart_item_bundle_job_cost_links" */
  invoiceCartItemBundleJobCostLinksStream: Array<InvoiceCartItemBundleJobCostLinks>;
  /** An array relationship */
  invoiceCartItems: Array<InvoiceCartItems>;
  /** An aggregate relationship */
  invoiceCartItemsAggregate: InvoiceCartItemsAggregate;
  /** fetch data from the table: "invoice_cart_items" using primary key columns */
  invoiceCartItemsByPk?: Maybe<InvoiceCartItems>;
  /** fetch data from the table in a streaming manner: "invoice_cart_items" */
  invoiceCartItemsStream: Array<InvoiceCartItems>;
  /** fetch data from the table: "invoice_company_tax_configurations_view" */
  invoiceCompanyTaxConfigurationsView: Array<InvoiceCompanyTaxConfigurationsView>;
  /** fetch aggregated fields from the table: "invoice_company_tax_configurations_view" */
  invoiceCompanyTaxConfigurationsViewAggregate: InvoiceCompanyTaxConfigurationsViewAggregate;
  /** fetch data from the table in a streaming manner: "invoice_company_tax_configurations_view" */
  invoiceCompanyTaxConfigurationsViewStream: Array<InvoiceCompanyTaxConfigurationsView>;
  /** An array relationship */
  invoiceDiscounts: Array<InvoiceDiscounts>;
  /** An aggregate relationship */
  invoiceDiscountsAggregate: InvoiceDiscountsAggregate;
  /** fetch data from the table: "invoice_discounts" using primary key columns */
  invoiceDiscountsByPk?: Maybe<InvoiceDiscounts>;
  /** fetch data from the table in a streaming manner: "invoice_discounts" */
  invoiceDiscountsStream: Array<InvoiceDiscounts>;
  /** An array relationship */
  invoiceEvents: Array<InvoiceEvents>;
  /** An aggregate relationship */
  invoiceEventsAggregate: InvoiceEventsAggregate;
  /** fetch data from the table: "invoice_events" using primary key columns */
  invoiceEventsByPk?: Maybe<InvoiceEvents>;
  /** fetch data from the table in a streaming manner: "invoice_events" */
  invoiceEventsStream: Array<InvoiceEvents>;
  /** An array relationship */
  invoicePayments: Array<InvoicePayments>;
  /** An aggregate relationship */
  invoicePaymentsAggregate: InvoicePaymentsAggregate;
  /** fetch data from the table: "invoice_payments" using primary key columns */
  invoicePaymentsByPk?: Maybe<InvoicePayments>;
  /** fetch data from the table in a streaming manner: "invoice_payments" */
  invoicePaymentsStream: Array<InvoicePayments>;
  /** fetch data from the table: "invoice_reminder_data" */
  invoiceReminderData: Array<InvoiceReminderData>;
  /** fetch aggregated fields from the table: "invoice_reminder_data" */
  invoiceReminderDataAggregate: InvoiceReminderDataAggregate;
  /** fetch data from the table: "invoice_reminder_data" using primary key columns */
  invoiceReminderDataByPk?: Maybe<InvoiceReminderData>;
  /** fetch data from the table in a streaming manner: "invoice_reminder_data" */
  invoiceReminderDataStream: Array<InvoiceReminderData>;
  /** An array relationship */
  invoiceTemplateCartItems: Array<InvoiceTemplateCartItems>;
  /** An aggregate relationship */
  invoiceTemplateCartItemsAggregate: InvoiceTemplateCartItemsAggregate;
  /** fetch data from the table: "invoice_template_cart_items" using primary key columns */
  invoiceTemplateCartItemsByPk?: Maybe<InvoiceTemplateCartItems>;
  /** fetch data from the table in a streaming manner: "invoice_template_cart_items" */
  invoiceTemplateCartItemsStream: Array<InvoiceTemplateCartItems>;
  /** fetch data from the table: "invoice_templates" */
  invoiceTemplates: Array<InvoiceTemplates>;
  /** fetch aggregated fields from the table: "invoice_templates" */
  invoiceTemplatesAggregate: InvoiceTemplatesAggregate;
  /** fetch data from the table: "invoice_templates" using primary key columns */
  invoiceTemplatesByPk?: Maybe<InvoiceTemplates>;
  /** fetch data from the table in a streaming manner: "invoice_templates" */
  invoiceTemplatesStream: Array<InvoiceTemplates>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoicesAggregate: InvoicesAggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoicesByPk?: Maybe<Invoices>;
  /** fetch data from the table: "invoices_qbo_status" */
  invoicesQboStatus: Array<InvoicesQboStatus>;
  /** fetch aggregated fields from the table: "invoices_qbo_status" */
  invoicesQboStatusAggregate: InvoicesQboStatusAggregate;
  /** fetch data from the table in a streaming manner: "invoices_qbo_status" */
  invoicesQboStatusStream: Array<InvoicesQboStatus>;
  /** fetch data from the table: "invoices_queryable" */
  invoicesQueryable: Array<InvoicesQueryable>;
  /** fetch aggregated fields from the table: "invoices_queryable" */
  invoicesQueryableAggregate: InvoicesQueryableAggregate;
  /** fetch data from the table: "invoices_queryable" using primary key columns */
  invoicesQueryableByPk?: Maybe<InvoicesQueryable>;
  /** fetch data from the table in a streaming manner: "invoices_queryable" */
  invoicesQueryableStream: Array<InvoicesQueryable>;
  /** fetch data from the table: "invoices_queryable_with_qbo_status" */
  invoicesQueryableWithQboStatus: Array<InvoicesQueryableWithQboStatus>;
  /** fetch aggregated fields from the table: "invoices_queryable_with_qbo_status" */
  invoicesQueryableWithQboStatusAggregate: InvoicesQueryableWithQboStatusAggregate;
  /** fetch data from the table in a streaming manner: "invoices_queryable_with_qbo_status" */
  invoicesQueryableWithQboStatusStream: Array<InvoicesQueryableWithQboStatus>;
  /** fetch data from the table in a streaming manner: "invoices" */
  invoicesStream: Array<Invoices>;
  /** fetch data from the table: "invoices_v2_accounting_stale" */
  invoicesV2AccountingStale: Array<InvoicesV2AccountingStale>;
  /** fetch aggregated fields from the table: "invoices_v2_accounting_stale" */
  invoicesV2AccountingStaleAggregate: InvoicesV2AccountingStaleAggregate;
  /** fetch data from the table in a streaming manner: "invoices_v2_accounting_stale" */
  invoicesV2AccountingStaleStream: Array<InvoicesV2AccountingStale>;
  /** fetch data from the table: "invoices_v2_qbo_stale" */
  invoicesV2QboStale: Array<InvoicesV2QboStale>;
  /** fetch aggregated fields from the table: "invoices_v2_qbo_stale" */
  invoicesV2QboStaleAggregate: InvoicesV2QboStaleAggregate;
  /** fetch data from the table in a streaming manner: "invoices_v2_qbo_stale" */
  invoicesV2QboStaleStream: Array<InvoicesV2QboStale>;
  /** fetch data from the table: "invoices_v2_qbo_status" */
  invoicesV2QboStatus: Array<InvoicesV2QboStatus>;
  /** fetch aggregated fields from the table: "invoices_v2_qbo_status" */
  invoicesV2QboStatusAggregate: InvoicesV2QboStatusAggregate;
  /** fetch data from the table in a streaming manner: "invoices_v2_qbo_status" */
  invoicesV2QboStatusStream: Array<InvoicesV2QboStatus>;
  /** fetch data from the table: "job_appointment_assignment_status_types" */
  jobAppointmentAssignmentStatusTypes: Array<JobAppointmentAssignmentStatusTypes>;
  /** fetch aggregated fields from the table: "job_appointment_assignment_status_types" */
  jobAppointmentAssignmentStatusTypesAggregate: JobAppointmentAssignmentStatusTypesAggregate;
  /** fetch data from the table: "job_appointment_assignment_status_types" using primary key columns */
  jobAppointmentAssignmentStatusTypesByPk?: Maybe<JobAppointmentAssignmentStatusTypes>;
  /** fetch data from the table in a streaming manner: "job_appointment_assignment_status_types" */
  jobAppointmentAssignmentStatusTypesStream: Array<JobAppointmentAssignmentStatusTypes>;
  /** fetch data from the table: "job_appointment_assignment_statuses" */
  jobAppointmentAssignmentStatuses: Array<JobAppointmentAssignmentStatuses>;
  /** fetch aggregated fields from the table: "job_appointment_assignment_statuses" */
  jobAppointmentAssignmentStatusesAggregate: JobAppointmentAssignmentStatusesAggregate;
  /** fetch data from the table: "job_appointment_assignment_statuses" using primary key columns */
  jobAppointmentAssignmentStatusesByPk?: Maybe<JobAppointmentAssignmentStatuses>;
  /** fetch data from the table in a streaming manner: "job_appointment_assignment_statuses" */
  jobAppointmentAssignmentStatusesStream: Array<JobAppointmentAssignmentStatuses>;
  /** An array relationship */
  jobAppointmentAssignments: Array<JobAppointmentAssignments>;
  /** An aggregate relationship */
  jobAppointmentAssignmentsAggregate: JobAppointmentAssignmentsAggregate;
  /** fetch data from the table: "job_appointment_assignments" using primary key columns */
  jobAppointmentAssignmentsByPk?: Maybe<JobAppointmentAssignments>;
  /** fetch data from the table in a streaming manner: "job_appointment_assignments" */
  jobAppointmentAssignmentsStream: Array<JobAppointmentAssignments>;
  /** fetch data from the table: "job_appointment_cancellation_statuses" */
  jobAppointmentCancellationStatuses: Array<JobAppointmentCancellationStatuses>;
  /** fetch aggregated fields from the table: "job_appointment_cancellation_statuses" */
  jobAppointmentCancellationStatusesAggregate: JobAppointmentCancellationStatusesAggregate;
  /** fetch data from the table: "job_appointment_cancellation_statuses" using primary key columns */
  jobAppointmentCancellationStatusesByPk?: Maybe<JobAppointmentCancellationStatuses>;
  /** fetch data from the table in a streaming manner: "job_appointment_cancellation_statuses" */
  jobAppointmentCancellationStatusesStream: Array<JobAppointmentCancellationStatuses>;
  /** fetch data from the table: "job_appointment_confirmation_statuses" */
  jobAppointmentConfirmationStatuses: Array<JobAppointmentConfirmationStatuses>;
  /** fetch aggregated fields from the table: "job_appointment_confirmation_statuses" */
  jobAppointmentConfirmationStatusesAggregate: JobAppointmentConfirmationStatusesAggregate;
  /** fetch data from the table: "job_appointment_confirmation_statuses" using primary key columns */
  jobAppointmentConfirmationStatusesByPk?: Maybe<JobAppointmentConfirmationStatuses>;
  /** fetch data from the table in a streaming manner: "job_appointment_confirmation_statuses" */
  jobAppointmentConfirmationStatusesStream: Array<JobAppointmentConfirmationStatuses>;
  /** An array relationship */
  jobAppointmentInvoices: Array<JobAppointmentInvoices>;
  /** An aggregate relationship */
  jobAppointmentInvoicesAggregate: JobAppointmentInvoicesAggregate;
  /** fetch data from the table: "job_appointment_invoices" using primary key columns */
  jobAppointmentInvoicesByPk?: Maybe<JobAppointmentInvoices>;
  /** fetch data from the table in a streaming manner: "job_appointment_invoices" */
  jobAppointmentInvoicesStream: Array<JobAppointmentInvoices>;
  /** An array relationship */
  jobAppointments: Array<JobAppointments>;
  /** An aggregate relationship */
  jobAppointmentsAggregate: JobAppointmentsAggregate;
  /** fetch data from the table: "job_appointments" using primary key columns */
  jobAppointmentsByPk?: Maybe<JobAppointments>;
  /** fetch data from the table in a streaming manner: "job_appointments" */
  jobAppointmentsStream: Array<JobAppointments>;
  /** An array relationship */
  jobCostItems: Array<JobCostItems>;
  /** An aggregate relationship */
  jobCostItemsAggregate: JobCostItemsAggregate;
  /** fetch data from the table: "job_cost_items" using primary key columns */
  jobCostItemsByPk?: Maybe<JobCostItems>;
  /** fetch data from the table in a streaming manner: "job_cost_items" */
  jobCostItemsStream: Array<JobCostItems>;
  /** fetch data from the table: "job_cost_misc_categories" */
  jobCostMiscCategories: Array<JobCostMiscCategories>;
  /** fetch aggregated fields from the table: "job_cost_misc_categories" */
  jobCostMiscCategoriesAggregate: JobCostMiscCategoriesAggregate;
  /** fetch data from the table: "job_cost_misc_categories" using primary key columns */
  jobCostMiscCategoriesByPk?: Maybe<JobCostMiscCategories>;
  /** fetch data from the table in a streaming manner: "job_cost_misc_categories" */
  jobCostMiscCategoriesStream: Array<JobCostMiscCategories>;
  /** fetch data from the table: "job_costing_config" */
  jobCostingConfig: Array<JobCostingConfig>;
  /** fetch aggregated fields from the table: "job_costing_config" */
  jobCostingConfigAggregate: JobCostingConfigAggregate;
  /** fetch data from the table: "job_costing_config" using primary key columns */
  jobCostingConfigByPk?: Maybe<JobCostingConfig>;
  /** fetch data from the table in a streaming manner: "job_costing_config" */
  jobCostingConfigStream: Array<JobCostingConfig>;
  /** fetch data from the table: "job_costing_rollup_view" */
  jobCostingRollupView: Array<JobCostingRollupView>;
  /** fetch aggregated fields from the table: "job_costing_rollup_view" */
  jobCostingRollupViewAggregate: JobCostingRollupViewAggregate;
  /** fetch data from the table in a streaming manner: "job_costing_rollup_view" */
  jobCostingRollupViewStream: Array<JobCostingRollupView>;
  /** An array relationship */
  jobInvoices: Array<JobInvoices>;
  /** An aggregate relationship */
  jobInvoicesAggregate: JobInvoicesAggregate;
  /** fetch data from the table: "job_invoices" using primary key columns */
  jobInvoicesByPk?: Maybe<JobInvoices>;
  /** fetch data from the table in a streaming manner: "job_invoices" */
  jobInvoicesStream: Array<JobInvoices>;
  /** fetch data from the table: "job_leads" */
  jobLeads: Array<JobLeads>;
  /** fetch aggregated fields from the table: "job_leads" */
  jobLeadsAggregate: JobLeadsAggregate;
  /** fetch data from the table: "job_leads" using primary key columns */
  jobLeadsByPk?: Maybe<JobLeads>;
  /** fetch data from the table in a streaming manner: "job_leads" */
  jobLeadsStream: Array<JobLeads>;
  /** An array relationship */
  jobLifecycleStatuses: Array<JobLifecycleStatuses>;
  /** An aggregate relationship */
  jobLifecycleStatusesAggregate: JobLifecycleStatusesAggregate;
  /** fetch data from the table: "job_lifecycle_statuses" using primary key columns */
  jobLifecycleStatusesByPk?: Maybe<JobLifecycleStatuses>;
  /** fetch data from the table in a streaming manner: "job_lifecycle_statuses" */
  jobLifecycleStatusesStream: Array<JobLifecycleStatuses>;
  /** fetch data from the table: "job_lifecycle_types" */
  jobLifecycleTypes: Array<JobLifecycleTypes>;
  /** fetch aggregated fields from the table: "job_lifecycle_types" */
  jobLifecycleTypesAggregate: JobLifecycleTypesAggregate;
  /** fetch data from the table: "job_lifecycle_types" using primary key columns */
  jobLifecycleTypesByPk?: Maybe<JobLifecycleTypes>;
  /** fetch data from the table in a streaming manner: "job_lifecycle_types" */
  jobLifecycleTypesStream: Array<JobLifecycleTypes>;
  /** fetch data from the table: "job_lifecycle_views" */
  jobLifecycleViews: Array<JobLifecycleViews>;
  /** fetch aggregated fields from the table: "job_lifecycle_views" */
  jobLifecycleViewsAggregate: JobLifecycleViewsAggregate;
  /** fetch data from the table: "job_lifecycle_views" using primary key columns */
  jobLifecycleViewsByPk?: Maybe<JobLifecycleViews>;
  /** fetch data from the table in a streaming manner: "job_lifecycle_views" */
  jobLifecycleViewsStream: Array<JobLifecycleViews>;
  /** fetch data from the table: "job_lifecycles" */
  jobLifecycles: Array<JobLifecycles>;
  /** fetch aggregated fields from the table: "job_lifecycles" */
  jobLifecyclesAggregate: JobLifecyclesAggregate;
  /** fetch data from the table: "job_lifecycles" using primary key columns */
  jobLifecyclesByPk?: Maybe<JobLifecycles>;
  /** fetch data from the table in a streaming manner: "job_lifecycles" */
  jobLifecyclesStream: Array<JobLifecycles>;
  /** fetch data from the table: "job_requests_company_config" */
  jobRequestsCompanyConfig: Array<JobRequestsCompanyConfig>;
  /** fetch aggregated fields from the table: "job_requests_company_config" */
  jobRequestsCompanyConfigAggregate: JobRequestsCompanyConfigAggregate;
  /** fetch data from the table: "job_requests_company_config" using primary key columns */
  jobRequestsCompanyConfigByPk?: Maybe<JobRequestsCompanyConfig>;
  /** fetch data from the table in a streaming manner: "job_requests_company_config" */
  jobRequestsCompanyConfigStream: Array<JobRequestsCompanyConfig>;
  /** fetch data from the table: "job_tags" */
  jobTags: Array<JobTags>;
  /** fetch aggregated fields from the table: "job_tags" */
  jobTagsAggregate: JobTagsAggregate;
  /** fetch data from the table: "job_tags" using primary key columns */
  jobTagsByPk?: Maybe<JobTags>;
  /** fetch data from the table in a streaming manner: "job_tags" */
  jobTagsStream: Array<JobTags>;
  /** An array relationship */
  jobTeamMembers: Array<JobTeamMembers>;
  /** An aggregate relationship */
  jobTeamMembersAggregate: JobTeamMembersAggregate;
  /** fetch data from the table: "job_team_members" using primary key columns */
  jobTeamMembersByPk?: Maybe<JobTeamMembers>;
  /** fetch data from the table in a streaming manner: "job_team_members" */
  jobTeamMembersStream: Array<JobTeamMembers>;
  /** An array relationship */
  jobTechnicianEarnedRevenueAttributions: Array<JobTechnicianEarnedRevenueAttributions>;
  /** An aggregate relationship */
  jobTechnicianEarnedRevenueAttributionsAggregate: JobTechnicianEarnedRevenueAttributionsAggregate;
  /** fetch data from the table: "job_technician_earned_revenue_attributions" using primary key columns */
  jobTechnicianEarnedRevenueAttributionsByPk?: Maybe<JobTechnicianEarnedRevenueAttributions>;
  /** fetch data from the table in a streaming manner: "job_technician_earned_revenue_attributions" */
  jobTechnicianEarnedRevenueAttributionsStream: Array<JobTechnicianEarnedRevenueAttributions>;
  /** An array relationship */
  jobTechnicianEarnedRevenueSummaries: Array<JobTechnicianEarnedRevenueSummaries>;
  /** An aggregate relationship */
  jobTechnicianEarnedRevenueSummariesAggregate: JobTechnicianEarnedRevenueSummariesAggregate;
  /** fetch data from the table in a streaming manner: "job_technician_earned_revenue_summaries" */
  jobTechnicianEarnedRevenueSummariesStream: Array<JobTechnicianEarnedRevenueSummaries>;
  /** fetch data from the table: "job_technician_sales_commission_and_bonus" */
  jobTechnicianSalesCommissionAndBonus: Array<JobTechnicianSalesCommissionAndBonus>;
  /** fetch aggregated fields from the table: "job_technician_sales_commission_and_bonus" */
  jobTechnicianSalesCommissionAndBonusAggregate: JobTechnicianSalesCommissionAndBonusAggregate;
  /** fetch data from the table in a streaming manner: "job_technician_sales_commission_and_bonus" */
  jobTechnicianSalesCommissionAndBonusStream: Array<JobTechnicianSalesCommissionAndBonus>;
  /** An array relationship */
  jobTechnicianSoldRevenueAttributions: Array<JobTechnicianSoldRevenueAttributions>;
  /** An aggregate relationship */
  jobTechnicianSoldRevenueAttributionsAggregate: JobTechnicianSoldRevenueAttributionsAggregate;
  /** fetch data from the table: "job_technician_sold_revenue_attributions" using primary key columns */
  jobTechnicianSoldRevenueAttributionsByPk?: Maybe<JobTechnicianSoldRevenueAttributions>;
  /** fetch data from the table in a streaming manner: "job_technician_sold_revenue_attributions" */
  jobTechnicianSoldRevenueAttributionsStream: Array<JobTechnicianSoldRevenueAttributions>;
  /** An array relationship */
  jobTechnicianSoldRevenueSummaries: Array<JobTechnicianSoldRevenueSummaries>;
  /** An aggregate relationship */
  jobTechnicianSoldRevenueSummariesAggregate: JobTechnicianSoldRevenueSummariesAggregate;
  /** fetch data from the table in a streaming manner: "job_technician_sold_revenue_summaries" */
  jobTechnicianSoldRevenueSummariesStream: Array<JobTechnicianSoldRevenueSummaries>;
  /** fetch data from the table: "job_type_change_reasons" */
  jobTypeChangeReasons: Array<JobTypeChangeReasons>;
  /** fetch aggregated fields from the table: "job_type_change_reasons" */
  jobTypeChangeReasonsAggregate: JobTypeChangeReasonsAggregate;
  /** fetch data from the table: "job_type_change_reasons" using primary key columns */
  jobTypeChangeReasonsByPk?: Maybe<JobTypeChangeReasons>;
  /** fetch data from the table in a streaming manner: "job_type_change_reasons" */
  jobTypeChangeReasonsStream: Array<JobTypeChangeReasons>;
  /** An array relationship */
  jobTypes: Array<JobTypes>;
  /** An aggregate relationship */
  jobTypesAggregate: JobTypesAggregate;
  /** fetch data from the table: "job_types" using primary key columns */
  jobTypesByPk?: Maybe<JobTypes>;
  /** fetch data from the table in a streaming manner: "job_types" */
  jobTypesStream: Array<JobTypes>;
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobsAggregate: JobsAggregate;
  /** fetch data from the table: "jobs" using primary key columns */
  jobsByPk?: Maybe<Jobs>;
  /** fetch data from the table: "jobs_fully_paid_invoiced_amount" */
  jobsFullyPaidInvoicedAmount: Array<JobsFullyPaidInvoicedAmount>;
  /** fetch aggregated fields from the table: "jobs_fully_paid_invoiced_amount" */
  jobsFullyPaidInvoicedAmountAggregate: JobsFullyPaidInvoicedAmountAggregate;
  /** fetch data from the table in a streaming manner: "jobs_fully_paid_invoiced_amount" */
  jobsFullyPaidInvoicedAmountStream: Array<JobsFullyPaidInvoicedAmount>;
  /** fetch data from the table: "jobs_fully_paid_invoices_summary" */
  jobsFullyPaidInvoicesSummary: Array<JobsFullyPaidInvoicesSummary>;
  /** fetch aggregated fields from the table: "jobs_fully_paid_invoices_summary" */
  jobsFullyPaidInvoicesSummaryAggregate: JobsFullyPaidInvoicesSummaryAggregate;
  /** fetch data from the table in a streaming manner: "jobs_fully_paid_invoices_summary" */
  jobsFullyPaidInvoicesSummaryStream: Array<JobsFullyPaidInvoicesSummary>;
  /** fetch data from the table: "jobs_fully_paid_invoices_v2_summary" */
  jobsFullyPaidInvoicesV2Summary: Array<JobsFullyPaidInvoicesV2Summary>;
  /** fetch aggregated fields from the table: "jobs_fully_paid_invoices_v2_summary" */
  jobsFullyPaidInvoicesV2SummaryAggregate: JobsFullyPaidInvoicesV2SummaryAggregate;
  /** fetch data from the table: "jobs_fully_paid_invoices_v2_summary_mv" */
  jobsFullyPaidInvoicesV2SummaryMv: Array<JobsFullyPaidInvoicesV2SummaryMv>;
  /** fetch aggregated fields from the table: "jobs_fully_paid_invoices_v2_summary_mv" */
  jobsFullyPaidInvoicesV2SummaryMvAggregate: JobsFullyPaidInvoicesV2SummaryMvAggregate;
  /** fetch data from the table in a streaming manner: "jobs_fully_paid_invoices_v2_summary_mv" */
  jobsFullyPaidInvoicesV2SummaryMvStream: Array<JobsFullyPaidInvoicesV2SummaryMv>;
  /** fetch data from the table in a streaming manner: "jobs_fully_paid_invoices_v2_summary" */
  jobsFullyPaidInvoicesV2SummaryStream: Array<JobsFullyPaidInvoicesV2Summary>;
  /** fetch data from the table: "jobs_max_commissionable_base" */
  jobsMaxCommissionableBase: Array<JobsMaxCommissionableBase>;
  /** fetch aggregated fields from the table: "jobs_max_commissionable_base" */
  jobsMaxCommissionableBaseAggregate: JobsMaxCommissionableBaseAggregate;
  /** fetch data from the table in a streaming manner: "jobs_max_commissionable_base" */
  jobsMaxCommissionableBaseStream: Array<JobsMaxCommissionableBase>;
  /** fetch data from the table in a streaming manner: "jobs" */
  jobsStream: Array<Jobs>;
  /** fetch data from the table: "jobs_with_linked_job" */
  jobsWithLinkedJob: Array<JobsWithLinkedJob>;
  /** fetch aggregated fields from the table: "jobs_with_linked_job" */
  jobsWithLinkedJobAggregate: JobsWithLinkedJobAggregate;
  /** fetch data from the table: "jobs_with_linked_job" using primary key columns */
  jobsWithLinkedJobByPk?: Maybe<JobsWithLinkedJob>;
  /** fetch data from the table: "jobs_with_linked_job_linked_appointment_checklist_instances" */
  jobsWithLinkedJobLinkedAppointmentChecklistInstances: Array<JobsWithLinkedJobLinkedAppointmentChecklistInstances>;
  /** fetch aggregated fields from the table: "jobs_with_linked_job_linked_appointment_checklist_instances" */
  jobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregate: JobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregate;
  /** fetch data from the table: "jobs_with_linked_job_linked_appointment_checklist_instances" using primary key columns */
  jobsWithLinkedJobLinkedAppointmentChecklistInstancesByPk?: Maybe<JobsWithLinkedJobLinkedAppointmentChecklistInstances>;
  /** fetch data from the table in a streaming manner: "jobs_with_linked_job_linked_appointment_checklist_instances" */
  jobsWithLinkedJobLinkedAppointmentChecklistInstancesStream: Array<JobsWithLinkedJobLinkedAppointmentChecklistInstances>;
  /** fetch data from the table: "jobs_with_linked_job_linked_estimates" */
  jobsWithLinkedJobLinkedEstimates: Array<JobsWithLinkedJobLinkedEstimates>;
  /** fetch aggregated fields from the table: "jobs_with_linked_job_linked_estimates" */
  jobsWithLinkedJobLinkedEstimatesAggregate: JobsWithLinkedJobLinkedEstimatesAggregate;
  /** fetch data from the table: "jobs_with_linked_job_linked_estimates" using primary key columns */
  jobsWithLinkedJobLinkedEstimatesByPk?: Maybe<JobsWithLinkedJobLinkedEstimates>;
  /** fetch data from the table in a streaming manner: "jobs_with_linked_job_linked_estimates" */
  jobsWithLinkedJobLinkedEstimatesStream: Array<JobsWithLinkedJobLinkedEstimates>;
  /** fetch data from the table: "jobs_with_linked_job_linked_invoices" */
  jobsWithLinkedJobLinkedInvoices: Array<JobsWithLinkedJobLinkedInvoices>;
  /** fetch aggregated fields from the table: "jobs_with_linked_job_linked_invoices" */
  jobsWithLinkedJobLinkedInvoicesAggregate: JobsWithLinkedJobLinkedInvoicesAggregate;
  /** fetch data from the table: "jobs_with_linked_job_linked_invoices" using primary key columns */
  jobsWithLinkedJobLinkedInvoicesByPk?: Maybe<JobsWithLinkedJobLinkedInvoices>;
  /** fetch data from the table in a streaming manner: "jobs_with_linked_job_linked_invoices" */
  jobsWithLinkedJobLinkedInvoicesStream: Array<JobsWithLinkedJobLinkedInvoices>;
  /** fetch data from the table in a streaming manner: "jobs_with_linked_job" */
  jobsWithLinkedJobStream: Array<JobsWithLinkedJob>;
  /** An array relationship */
  locationContacts: Array<LocationContacts>;
  /** An aggregate relationship */
  locationContactsAggregate: LocationContactsAggregate;
  /** fetch data from the table: "location_contacts" using primary key columns */
  locationContactsByPk?: Maybe<LocationContacts>;
  /** fetch data from the table in a streaming manner: "location_contacts" */
  locationContactsStream: Array<LocationContacts>;
  /** An array relationship */
  locationInvoices: Array<LocationInvoices>;
  /** An aggregate relationship */
  locationInvoicesAggregate: LocationInvoicesAggregate;
  /** fetch data from the table: "location_invoices" using primary key columns */
  locationInvoicesByPk?: Maybe<LocationInvoices>;
  /** fetch data from the table in a streaming manner: "location_invoices" */
  locationInvoicesStream: Array<LocationInvoices>;
  /** An array relationship */
  locations: Array<Locations>;
  /** An aggregate relationship */
  locationsAggregate: LocationsAggregate;
  /** fetch data from the table: "locations" using primary key columns */
  locationsByPk?: Maybe<Locations>;
  /** fetch data from the table in a streaming manner: "locations" */
  locationsStream: Array<Locations>;
  /** fetch data from the table: "maintenance_plan_definition_allowed_payment_intervals" */
  maintenancePlanDefinitionAllowedPaymentIntervals: Array<MaintenancePlanDefinitionAllowedPaymentIntervals>;
  /** fetch aggregated fields from the table: "maintenance_plan_definition_allowed_payment_intervals" */
  maintenancePlanDefinitionAllowedPaymentIntervalsAggregate: MaintenancePlanDefinitionAllowedPaymentIntervalsAggregate;
  /** fetch data from the table: "maintenance_plan_definition_allowed_payment_intervals" using primary key columns */
  maintenancePlanDefinitionAllowedPaymentIntervalsByPk?: Maybe<MaintenancePlanDefinitionAllowedPaymentIntervals>;
  /** fetch data from the table in a streaming manner: "maintenance_plan_definition_allowed_payment_intervals" */
  maintenancePlanDefinitionAllowedPaymentIntervalsStream: Array<MaintenancePlanDefinitionAllowedPaymentIntervals>;
  /** fetch data from the table: "maintenance_plan_definition_benefits" */
  maintenancePlanDefinitionBenefits: Array<MaintenancePlanDefinitionBenefits>;
  /** fetch aggregated fields from the table: "maintenance_plan_definition_benefits" */
  maintenancePlanDefinitionBenefitsAggregate: MaintenancePlanDefinitionBenefitsAggregate;
  /** fetch data from the table: "maintenance_plan_definition_benefits" using primary key columns */
  maintenancePlanDefinitionBenefitsByPk?: Maybe<MaintenancePlanDefinitionBenefits>;
  /** fetch data from the table in a streaming manner: "maintenance_plan_definition_benefits" */
  maintenancePlanDefinitionBenefitsStream: Array<MaintenancePlanDefinitionBenefits>;
  /** fetch data from the table: "maintenance_plan_definition_discounts" */
  maintenancePlanDefinitionDiscounts: Array<MaintenancePlanDefinitionDiscounts>;
  /** fetch aggregated fields from the table: "maintenance_plan_definition_discounts" */
  maintenancePlanDefinitionDiscountsAggregate: MaintenancePlanDefinitionDiscountsAggregate;
  /** fetch data from the table: "maintenance_plan_definition_discounts" using primary key columns */
  maintenancePlanDefinitionDiscountsByPk?: Maybe<MaintenancePlanDefinitionDiscounts>;
  /** fetch data from the table in a streaming manner: "maintenance_plan_definition_discounts" */
  maintenancePlanDefinitionDiscountsStream: Array<MaintenancePlanDefinitionDiscounts>;
  /** fetch data from the table: "maintenance_plan_definition_flare" */
  maintenancePlanDefinitionFlare: Array<MaintenancePlanDefinitionFlare>;
  /** fetch aggregated fields from the table: "maintenance_plan_definition_flare" */
  maintenancePlanDefinitionFlareAggregate: MaintenancePlanDefinitionFlareAggregate;
  /** fetch data from the table: "maintenance_plan_definition_flare" using primary key columns */
  maintenancePlanDefinitionFlareByPk?: Maybe<MaintenancePlanDefinitionFlare>;
  /** fetch data from the table in a streaming manner: "maintenance_plan_definition_flare" */
  maintenancePlanDefinitionFlareStream: Array<MaintenancePlanDefinitionFlare>;
  /** fetch data from the table: "maintenance_plan_definition_marketing_info" */
  maintenancePlanDefinitionMarketingInfo: Array<MaintenancePlanDefinitionMarketingInfo>;
  /** fetch aggregated fields from the table: "maintenance_plan_definition_marketing_info" */
  maintenancePlanDefinitionMarketingInfoAggregate: MaintenancePlanDefinitionMarketingInfoAggregate;
  /** fetch data from the table: "maintenance_plan_definition_marketing_info" using primary key columns */
  maintenancePlanDefinitionMarketingInfoByPk?: Maybe<MaintenancePlanDefinitionMarketingInfo>;
  /** fetch data from the table in a streaming manner: "maintenance_plan_definition_marketing_info" */
  maintenancePlanDefinitionMarketingInfoStream: Array<MaintenancePlanDefinitionMarketingInfo>;
  /** fetch data from the table: "maintenance_plan_definitions" */
  maintenancePlanDefinitions: Array<MaintenancePlanDefinitions>;
  /** fetch aggregated fields from the table: "maintenance_plan_definitions" */
  maintenancePlanDefinitionsAggregate: MaintenancePlanDefinitionsAggregate;
  /** fetch data from the table: "maintenance_plan_definitions" using primary key columns */
  maintenancePlanDefinitionsByPk?: Maybe<MaintenancePlanDefinitions>;
  /** fetch data from the table in a streaming manner: "maintenance_plan_definitions" */
  maintenancePlanDefinitionsStream: Array<MaintenancePlanDefinitions>;
  /** fetch data from the table: "maintenance_plan_equipment_coverage_definitions" */
  maintenancePlanEquipmentCoverageDefinitions: Array<MaintenancePlanEquipmentCoverageDefinitions>;
  /** fetch aggregated fields from the table: "maintenance_plan_equipment_coverage_definitions" */
  maintenancePlanEquipmentCoverageDefinitionsAggregate: MaintenancePlanEquipmentCoverageDefinitionsAggregate;
  /** fetch data from the table: "maintenance_plan_equipment_coverage_definitions" using primary key columns */
  maintenancePlanEquipmentCoverageDefinitionsByPk?: Maybe<MaintenancePlanEquipmentCoverageDefinitions>;
  /** fetch data from the table in a streaming manner: "maintenance_plan_equipment_coverage_definitions" */
  maintenancePlanEquipmentCoverageDefinitionsStream: Array<MaintenancePlanEquipmentCoverageDefinitions>;
  /** fetch data from the table: "maintenance_plan_equipment_coverage_pricings" */
  maintenancePlanEquipmentCoveragePricings: Array<MaintenancePlanEquipmentCoveragePricings>;
  /** fetch aggregated fields from the table: "maintenance_plan_equipment_coverage_pricings" */
  maintenancePlanEquipmentCoveragePricingsAggregate: MaintenancePlanEquipmentCoveragePricingsAggregate;
  /** fetch data from the table: "maintenance_plan_equipment_coverage_pricings" using primary key columns */
  maintenancePlanEquipmentCoveragePricingsByPk?: Maybe<MaintenancePlanEquipmentCoveragePricings>;
  /** fetch data from the table in a streaming manner: "maintenance_plan_equipment_coverage_pricings" */
  maintenancePlanEquipmentCoveragePricingsStream: Array<MaintenancePlanEquipmentCoveragePricings>;
  /** An array relationship */
  maintenancePlanInvoices: Array<MaintenancePlanInvoices>;
  /** An aggregate relationship */
  maintenancePlanInvoicesAggregate: MaintenancePlanInvoicesAggregate;
  /** fetch data from the table: "maintenance_plan_invoices" using primary key columns */
  maintenancePlanInvoicesByPk?: Maybe<MaintenancePlanInvoices>;
  /** fetch data from the table in a streaming manner: "maintenance_plan_invoices" */
  maintenancePlanInvoicesStream: Array<MaintenancePlanInvoices>;
  /** fetch data from the table: "maintenance_plan_next_visits" */
  maintenancePlanNextVisits: Array<MaintenancePlanNextVisits>;
  /** fetch aggregated fields from the table: "maintenance_plan_next_visits" */
  maintenancePlanNextVisitsAggregate: MaintenancePlanNextVisitsAggregate;
  /** fetch data from the table in a streaming manner: "maintenance_plan_next_visits" */
  maintenancePlanNextVisitsStream: Array<MaintenancePlanNextVisits>;
  /** An array relationship */
  maintenancePlanVisitInstalledEquipments: Array<MaintenancePlanVisitInstalledEquipments>;
  /** An aggregate relationship */
  maintenancePlanVisitInstalledEquipmentsAggregate: MaintenancePlanVisitInstalledEquipmentsAggregate;
  /** fetch data from the table: "maintenance_plan_visit_installed_equipments" using primary key columns */
  maintenancePlanVisitInstalledEquipmentsByPk?: Maybe<MaintenancePlanVisitInstalledEquipments>;
  /** fetch data from the table in a streaming manner: "maintenance_plan_visit_installed_equipments" */
  maintenancePlanVisitInstalledEquipmentsStream: Array<MaintenancePlanVisitInstalledEquipments>;
  /** An array relationship */
  maintenancePlanVisits: Array<MaintenancePlanVisits>;
  /** An aggregate relationship */
  maintenancePlanVisitsAggregate: MaintenancePlanVisitsAggregate;
  /** fetch data from the table: "maintenance_plan_visits" using primary key columns */
  maintenancePlanVisitsByPk?: Maybe<MaintenancePlanVisits>;
  /** fetch data from the table in a streaming manner: "maintenance_plan_visits" */
  maintenancePlanVisitsStream: Array<MaintenancePlanVisits>;
  /** fetch data from the table: "maintenance_plan_visits_with_status" */
  maintenancePlanVisitsWithStatus: Array<MaintenancePlanVisitsWithStatus>;
  /** fetch aggregated fields from the table: "maintenance_plan_visits_with_status" */
  maintenancePlanVisitsWithStatusAggregate: MaintenancePlanVisitsWithStatusAggregate;
  /** fetch data from the table in a streaming manner: "maintenance_plan_visits_with_status" */
  maintenancePlanVisitsWithStatusStream: Array<MaintenancePlanVisitsWithStatus>;
  /** fetch data from the table: "maintenance_plans_queryable" */
  maintenancePlansQueryable: Array<MaintenancePlansQueryable>;
  /** fetch aggregated fields from the table: "maintenance_plans_queryable" */
  maintenancePlansQueryableAggregate: MaintenancePlansQueryableAggregate;
  /** fetch data from the table: "maintenance_plans_queryable" using primary key columns */
  maintenancePlansQueryableByPk?: Maybe<MaintenancePlansQueryable>;
  /** fetch data from the table in a streaming manner: "maintenance_plans_queryable" */
  maintenancePlansQueryableStream: Array<MaintenancePlansQueryable>;
  /** fetch data from the table: "migration_junk" */
  migrationJunk: Array<MigrationJunk>;
  /** fetch aggregated fields from the table: "migration_junk" */
  migrationJunkAggregate: MigrationJunkAggregate;
  /** fetch data from the table: "migration_junk" using primary key columns */
  migrationJunkByPk?: Maybe<MigrationJunk>;
  /** fetch data from the table: "migration_junk_links" */
  migrationJunkLinks: Array<MigrationJunkLinks>;
  /** fetch aggregated fields from the table: "migration_junk_links" */
  migrationJunkLinksAggregate: MigrationJunkLinksAggregate;
  /** fetch data from the table: "migration_junk_links" using primary key columns */
  migrationJunkLinksByPk?: Maybe<MigrationJunkLinks>;
  /** fetch data from the table in a streaming manner: "migration_junk_links" */
  migrationJunkLinksStream: Array<MigrationJunkLinks>;
  /** fetch data from the table in a streaming manner: "migration_junk" */
  migrationJunkStream: Array<MigrationJunk>;
  /** An array relationship */
  noteAttachments: Array<NoteAttachments>;
  /** An aggregate relationship */
  noteAttachmentsAggregate: NoteAttachmentsAggregate;
  /** fetch data from the table: "note_attachments" using primary key columns */
  noteAttachmentsByPk?: Maybe<NoteAttachments>;
  /** fetch data from the table in a streaming manner: "note_attachments" */
  noteAttachmentsStream: Array<NoteAttachments>;
  /** An array relationship */
  noteLinks: Array<NoteLinks>;
  /** An aggregate relationship */
  noteLinksAggregate: NoteLinksAggregate;
  /** fetch data from the table: "note_links" using primary key columns */
  noteLinksByPk?: Maybe<NoteLinks>;
  /** fetch data from the table in a streaming manner: "note_links" */
  noteLinksStream: Array<NoteLinks>;
  /** fetch data from the table: "note_tagged_users" */
  noteTaggedUsers: Array<NoteTaggedUsers>;
  /** fetch aggregated fields from the table: "note_tagged_users" */
  noteTaggedUsersAggregate: NoteTaggedUsersAggregate;
  /** fetch data from the table: "note_tagged_users" using primary key columns */
  noteTaggedUsersByPk?: Maybe<NoteTaggedUsers>;
  /** fetch data from the table in a streaming manner: "note_tagged_users" */
  noteTaggedUsersStream: Array<NoteTaggedUsers>;
  /** An array relationship */
  notes: Array<Notes>;
  /** An aggregate relationship */
  notesAggregate: NotesAggregate;
  /** fetch data from the table: "notes" using primary key columns */
  notesByPk?: Maybe<Notes>;
  /** fetch data from the table in a streaming manner: "notes" */
  notesStream: Array<Notes>;
  /** fetch data from the table: "online_booking_company_config" */
  onlineBookingCompanyConfig: Array<OnlineBookingCompanyConfig>;
  /** fetch aggregated fields from the table: "online_booking_company_config" */
  onlineBookingCompanyConfigAggregate: OnlineBookingCompanyConfigAggregate;
  /** fetch data from the table: "online_booking_company_config" using primary key columns */
  onlineBookingCompanyConfigByPk?: Maybe<OnlineBookingCompanyConfig>;
  /** fetch data from the table in a streaming manner: "online_booking_company_config" */
  onlineBookingCompanyConfigStream: Array<OnlineBookingCompanyConfig>;
  /** fetch data from the table: "online_booking_service_area_zip_codes" */
  onlineBookingServiceAreaZipCodes: Array<OnlineBookingServiceAreaZipCodes>;
  /** fetch aggregated fields from the table: "online_booking_service_area_zip_codes" */
  onlineBookingServiceAreaZipCodesAggregate: OnlineBookingServiceAreaZipCodesAggregate;
  /** fetch data from the table: "online_booking_service_area_zip_codes" using primary key columns */
  onlineBookingServiceAreaZipCodesByPk?: Maybe<OnlineBookingServiceAreaZipCodes>;
  /** fetch data from the table in a streaming manner: "online_booking_service_area_zip_codes" */
  onlineBookingServiceAreaZipCodesStream: Array<OnlineBookingServiceAreaZipCodes>;
  /** fetch data from the table: "online_booking_service_type_bookable_job_types" */
  onlineBookingServiceTypeBookableJobTypes: Array<OnlineBookingServiceTypeBookableJobTypes>;
  /** fetch aggregated fields from the table: "online_booking_service_type_bookable_job_types" */
  onlineBookingServiceTypeBookableJobTypesAggregate: OnlineBookingServiceTypeBookableJobTypesAggregate;
  /** fetch data from the table: "online_booking_service_type_bookable_job_types" using primary key columns */
  onlineBookingServiceTypeBookableJobTypesByPk?: Maybe<OnlineBookingServiceTypeBookableJobTypes>;
  /** fetch data from the table in a streaming manner: "online_booking_service_type_bookable_job_types" */
  onlineBookingServiceTypeBookableJobTypesStream: Array<OnlineBookingServiceTypeBookableJobTypes>;
  /** fetch data from the table: "online_booking_service_type_bookable_technicians" */
  onlineBookingServiceTypeBookableTechnicians: Array<OnlineBookingServiceTypeBookableTechnicians>;
  /** fetch aggregated fields from the table: "online_booking_service_type_bookable_technicians" */
  onlineBookingServiceTypeBookableTechniciansAggregate: OnlineBookingServiceTypeBookableTechniciansAggregate;
  /** fetch data from the table: "online_booking_service_type_bookable_technicians" using primary key columns */
  onlineBookingServiceTypeBookableTechniciansByPk?: Maybe<OnlineBookingServiceTypeBookableTechnicians>;
  /** fetch data from the table in a streaming manner: "online_booking_service_type_bookable_technicians" */
  onlineBookingServiceTypeBookableTechniciansStream: Array<OnlineBookingServiceTypeBookableTechnicians>;
  /** An array relationship */
  onlineBookingServiceTypeConfigs: Array<OnlineBookingServiceTypeConfigs>;
  /** An aggregate relationship */
  onlineBookingServiceTypeConfigsAggregate: OnlineBookingServiceTypeConfigsAggregate;
  /** fetch data from the table: "online_booking_service_type_configs" using primary key columns */
  onlineBookingServiceTypeConfigsByPk?: Maybe<OnlineBookingServiceTypeConfigs>;
  /** fetch data from the table in a streaming manner: "online_booking_service_type_configs" */
  onlineBookingServiceTypeConfigsStream: Array<OnlineBookingServiceTypeConfigs>;
  /** An array relationship */
  paymentLinks: Array<PaymentLinks>;
  /** An aggregate relationship */
  paymentLinksAggregate: PaymentLinksAggregate;
  /** fetch data from the table: "payment_links" using primary key columns */
  paymentLinksByPk?: Maybe<PaymentLinks>;
  /** fetch data from the table in a streaming manner: "payment_links" */
  paymentLinksStream: Array<PaymentLinks>;
  /** fetch data from the table: "payment_method_billing_info" */
  paymentMethodBillingInfo: Array<PaymentMethodBillingInfo>;
  /** fetch aggregated fields from the table: "payment_method_billing_info" */
  paymentMethodBillingInfoAggregate: PaymentMethodBillingInfoAggregate;
  /** fetch data from the table: "payment_method_billing_info" using primary key columns */
  paymentMethodBillingInfoByPk?: Maybe<PaymentMethodBillingInfo>;
  /** fetch data from the table in a streaming manner: "payment_method_billing_info" */
  paymentMethodBillingInfoStream: Array<PaymentMethodBillingInfo>;
  /** fetch data from the table: "payment_method_card_metadata" */
  paymentMethodCardMetadata: Array<PaymentMethodCardMetadata>;
  /** fetch aggregated fields from the table: "payment_method_card_metadata" */
  paymentMethodCardMetadataAggregate: PaymentMethodCardMetadataAggregate;
  /** fetch data from the table: "payment_method_card_metadata" using primary key columns */
  paymentMethodCardMetadataByPk?: Maybe<PaymentMethodCardMetadata>;
  /** fetch data from the table in a streaming manner: "payment_method_card_metadata" */
  paymentMethodCardMetadataStream: Array<PaymentMethodCardMetadata>;
  /** fetch data from the table: "payment_method_records" */
  paymentMethodRecords: Array<PaymentMethodRecords>;
  /** fetch aggregated fields from the table: "payment_method_records" */
  paymentMethodRecordsAggregate: PaymentMethodRecordsAggregate;
  /** fetch data from the table: "payment_method_records" using primary key columns */
  paymentMethodRecordsByPk?: Maybe<PaymentMethodRecords>;
  /** fetch data from the table in a streaming manner: "payment_method_records" */
  paymentMethodRecordsStream: Array<PaymentMethodRecords>;
  /** fetch data from the table: "payment_methods" */
  paymentMethods: Array<PaymentMethods>;
  /** fetch data from the table: "payment_methods" using primary key columns */
  paymentMethodsByPk?: Maybe<PaymentMethods>;
  /** fetch data from the table in a streaming manner: "payment_methods" */
  paymentMethodsStream: Array<PaymentMethods>;
  /** An array relationship */
  paymentRecords: Array<PaymentRecords>;
  /** An aggregate relationship */
  paymentRecordsAggregate: PaymentRecordsAggregate;
  /** fetch data from the table: "payment_records" using primary key columns */
  paymentRecordsByPk?: Maybe<PaymentRecords>;
  /** fetch data from the table in a streaming manner: "payment_records" */
  paymentRecordsStream: Array<PaymentRecords>;
  /** An array relationship */
  paymentRefunds: Array<PaymentRefunds>;
  /** An aggregate relationship */
  paymentRefundsAggregate: PaymentRefundsAggregate;
  /** fetch data from the table: "payment_refunds" using primary key columns */
  paymentRefundsByPk?: Maybe<PaymentRefunds>;
  /** fetch data from the table in a streaming manner: "payment_refunds" */
  paymentRefundsStream: Array<PaymentRefunds>;
  /** fetch data from the table: "payment_status_error_detail" */
  paymentStatusErrorDetail: Array<PaymentStatusErrorDetail>;
  /** fetch aggregated fields from the table: "payment_status_error_detail" */
  paymentStatusErrorDetailAggregate: PaymentStatusErrorDetailAggregate;
  /** fetch data from the table: "payment_status_error_detail" using primary key columns */
  paymentStatusErrorDetailByPk?: Maybe<PaymentStatusErrorDetail>;
  /** fetch data from the table in a streaming manner: "payment_status_error_detail" */
  paymentStatusErrorDetailStream: Array<PaymentStatusErrorDetail>;
  /** fetch data from the table: "payment_status_latest" */
  paymentStatusLatest: Array<PaymentStatusLatest>;
  /** fetch aggregated fields from the table: "payment_status_latest" */
  paymentStatusLatestAggregate: PaymentStatusLatestAggregate;
  /** fetch data from the table: "payment_status_latest" using primary key columns */
  paymentStatusLatestByPk?: Maybe<PaymentStatusLatest>;
  /** fetch data from the table in a streaming manner: "payment_status_latest" */
  paymentStatusLatestStream: Array<PaymentStatusLatest>;
  /** An array relationship */
  paymentStatuses: Array<PaymentStatuses>;
  /** An aggregate relationship */
  paymentStatusesAggregate: PaymentStatusesAggregate;
  /** fetch data from the table: "payment_statuses" using primary key columns */
  paymentStatusesByPk?: Maybe<PaymentStatuses>;
  /** fetch data from the table in a streaming manner: "payment_statuses" */
  paymentStatusesStream: Array<PaymentStatuses>;
  /** fetch data from the table: "payment_subscription_invoices" */
  paymentSubscriptionInvoices: Array<PaymentSubscriptionInvoices>;
  /** fetch aggregated fields from the table: "payment_subscription_invoices" */
  paymentSubscriptionInvoicesAggregate: PaymentSubscriptionInvoicesAggregate;
  /** fetch data from the table: "payment_subscription_invoices" using primary key columns */
  paymentSubscriptionInvoicesByPk?: Maybe<PaymentSubscriptionInvoices>;
  /** fetch data from the table in a streaming manner: "payment_subscription_invoices" */
  paymentSubscriptionInvoicesStream: Array<PaymentSubscriptionInvoices>;
  /** An array relationship */
  paymentSubscriptionStatuses: Array<PaymentSubscriptionStatuses>;
  /** An aggregate relationship */
  paymentSubscriptionStatusesAggregate: PaymentSubscriptionStatusesAggregate;
  /** fetch data from the table: "payment_subscription_statuses" using primary key columns */
  paymentSubscriptionStatusesByPk?: Maybe<PaymentSubscriptionStatuses>;
  /** fetch data from the table in a streaming manner: "payment_subscription_statuses" */
  paymentSubscriptionStatusesStream: Array<PaymentSubscriptionStatuses>;
  /** fetch data from the table: "payment_subscriptions" */
  paymentSubscriptions: Array<PaymentSubscriptions>;
  /** fetch aggregated fields from the table: "payment_subscriptions" */
  paymentSubscriptionsAggregate: PaymentSubscriptionsAggregate;
  /** fetch data from the table: "payment_subscriptions" using primary key columns */
  paymentSubscriptionsByPk?: Maybe<PaymentSubscriptions>;
  /** fetch data from the table in a streaming manner: "payment_subscriptions" */
  paymentSubscriptionsStream: Array<PaymentSubscriptions>;
  /** fetch data from the table: "payments_accounting_stale_info" */
  paymentsAccountingStaleInfo: Array<PaymentsAccountingStaleInfo>;
  /** fetch aggregated fields from the table: "payments_accounting_stale_info" */
  paymentsAccountingStaleInfoAggregate: PaymentsAccountingStaleInfoAggregate;
  /** fetch data from the table in a streaming manner: "payments_accounting_stale_info" */
  paymentsAccountingStaleInfoStream: Array<PaymentsAccountingStaleInfo>;
  /** fetch data from the table: "payments_qbo_status" */
  paymentsQboStatus: Array<PaymentsQboStatus>;
  /** fetch aggregated fields from the table: "payments_qbo_status" */
  paymentsQboStatusAggregate: PaymentsQboStatusAggregate;
  /** fetch data from the table in a streaming manner: "payments_qbo_status" */
  paymentsQboStatusStream: Array<PaymentsQboStatus>;
  /** An array relationship */
  payoutItems: Array<PayoutItems>;
  /** An aggregate relationship */
  payoutItemsAggregate: PayoutItemsAggregate;
  /** fetch data from the table: "payout_items" using primary key columns */
  payoutItemsByPk?: Maybe<PayoutItems>;
  /** fetch data from the table in a streaming manner: "payout_items" */
  payoutItemsStream: Array<PayoutItems>;
  /** fetch data from the table: "payout_qbo_accounts_config" */
  payoutQboAccountsConfig: Array<PayoutQboAccountsConfig>;
  /** fetch aggregated fields from the table: "payout_qbo_accounts_config" */
  payoutQboAccountsConfigAggregate: PayoutQboAccountsConfigAggregate;
  /** fetch data from the table: "payout_qbo_accounts_config" using primary key columns */
  payoutQboAccountsConfigByPk?: Maybe<PayoutQboAccountsConfig>;
  /** fetch data from the table in a streaming manner: "payout_qbo_accounts_config" */
  payoutQboAccountsConfigStream: Array<PayoutQboAccountsConfig>;
  /** fetch data from the table: "payouts" */
  payouts: Array<Payouts>;
  /** fetch data from the table: "payouts_accounting_stale_info" */
  payoutsAccountingStaleInfo: Array<PayoutsAccountingStaleInfo>;
  /** fetch aggregated fields from the table: "payouts_accounting_stale_info" */
  payoutsAccountingStaleInfoAggregate: PayoutsAccountingStaleInfoAggregate;
  /** fetch data from the table in a streaming manner: "payouts_accounting_stale_info" */
  payoutsAccountingStaleInfoStream: Array<PayoutsAccountingStaleInfo>;
  /** fetch aggregated fields from the table: "payouts" */
  payoutsAggregate: PayoutsAggregate;
  /** fetch data from the table: "payouts" using primary key columns */
  payoutsByPk?: Maybe<Payouts>;
  /** fetch data from the table: "payouts_qbo_status" */
  payoutsQboStatus: Array<PayoutsQboStatus>;
  /** fetch aggregated fields from the table: "payouts_qbo_status" */
  payoutsQboStatusAggregate: PayoutsQboStatusAggregate;
  /** fetch data from the table in a streaming manner: "payouts_qbo_status" */
  payoutsQboStatusStream: Array<PayoutsQboStatus>;
  /** fetch data from the table in a streaming manner: "payouts" */
  payoutsStream: Array<Payouts>;
  /** fetch data from the table: "permissions" */
  permissions: Array<Permissions>;
  /** fetch aggregated fields from the table: "permissions" */
  permissionsAggregate: PermissionsAggregate;
  /** fetch data from the table: "permissions" using primary key columns */
  permissionsByPk?: Maybe<Permissions>;
  /** fetch data from the table in a streaming manner: "permissions" */
  permissionsStream: Array<Permissions>;
  /** fetch data from the table: "permissions_v2" */
  permissionsV2: Array<PermissionsV2>;
  /** fetch aggregated fields from the table: "permissions_v2" */
  permissionsV2Aggregate: PermissionsV2Aggregate;
  /** fetch data from the table: "permissions_v2" using primary key columns */
  permissionsV2ByPk?: Maybe<PermissionsV2>;
  /** fetch data from the table in a streaming manner: "permissions_v2" */
  permissionsV2Stream: Array<PermissionsV2>;
  /** fetch data from the table: "phone_numbers" */
  phoneNumbers: Array<PhoneNumbers>;
  /** fetch aggregated fields from the table: "phone_numbers" */
  phoneNumbersAggregate: PhoneNumbersAggregate;
  /** fetch data from the table: "phone_numbers" using primary key columns */
  phoneNumbersByPk?: Maybe<PhoneNumbers>;
  /** fetch data from the table in a streaming manner: "phone_numbers" */
  phoneNumbersStream: Array<PhoneNumbers>;
  /** An array relationship */
  photoLinks: Array<PhotoLinks>;
  /** An aggregate relationship */
  photoLinksAggregate: PhotoLinksAggregate;
  /** fetch data from the table: "photo_links" using primary key columns */
  photoLinksByPk?: Maybe<PhotoLinks>;
  /** fetch data from the table in a streaming manner: "photo_links" */
  photoLinksStream: Array<PhotoLinks>;
  /** fetch data from the table: "photos" */
  photos: Array<Photos>;
  /** fetch aggregated fields from the table: "photos" */
  photosAggregate: PhotosAggregate;
  /** fetch data from the table: "photos" using primary key columns */
  photosByPk?: Maybe<Photos>;
  /** fetch data from the table in a streaming manner: "photos" */
  photosStream: Array<Photos>;
  /** fetch data from the table: "pricebook_bundle_items" */
  pricebookBundleItems: Array<PricebookBundleItems>;
  /** fetch aggregated fields from the table: "pricebook_bundle_items" */
  pricebookBundleItemsAggregate: PricebookBundleItemsAggregate;
  /** fetch data from the table: "pricebook_bundle_items" using primary key columns */
  pricebookBundleItemsByPk?: Maybe<PricebookBundleItems>;
  /** fetch data from the table in a streaming manner: "pricebook_bundle_items" */
  pricebookBundleItemsStream: Array<PricebookBundleItems>;
  /** fetch data from the table: "pricebook_categories" */
  pricebookCategories: Array<PricebookCategories>;
  /** fetch aggregated fields from the table: "pricebook_categories" */
  pricebookCategoriesAggregate: PricebookCategoriesAggregate;
  /** fetch data from the table: "pricebook_categories" using primary key columns */
  pricebookCategoriesByPk?: Maybe<PricebookCategories>;
  /** fetch data from the table in a streaming manner: "pricebook_categories" */
  pricebookCategoriesStream: Array<PricebookCategories>;
  /** fetch data from the table: "pricebook_discounts" */
  pricebookDiscounts: Array<PricebookDiscounts>;
  /** fetch aggregated fields from the table: "pricebook_discounts" */
  pricebookDiscountsAggregate: PricebookDiscountsAggregate;
  /** fetch data from the table: "pricebook_discounts" using primary key columns */
  pricebookDiscountsByPk?: Maybe<PricebookDiscounts>;
  /** fetch data from the table in a streaming manner: "pricebook_discounts" */
  pricebookDiscountsStream: Array<PricebookDiscounts>;
  /** fetch data from the table: "pricebook_item_type_fallback_photos" */
  pricebookItemTypeFallbackPhotos: Array<PricebookItemTypeFallbackPhotos>;
  /** fetch aggregated fields from the table: "pricebook_item_type_fallback_photos" */
  pricebookItemTypeFallbackPhotosAggregate: PricebookItemTypeFallbackPhotosAggregate;
  /** fetch data from the table: "pricebook_item_type_fallback_photos" using primary key columns */
  pricebookItemTypeFallbackPhotosByPk?: Maybe<PricebookItemTypeFallbackPhotos>;
  /** fetch data from the table in a streaming manner: "pricebook_item_type_fallback_photos" */
  pricebookItemTypeFallbackPhotosStream: Array<PricebookItemTypeFallbackPhotos>;
  /** An array relationship */
  pricebookItems: Array<PricebookItems>;
  /** An aggregate relationship */
  pricebookItemsAggregate: PricebookItemsAggregate;
  /** fetch data from the table: "pricebook_items" using primary key columns */
  pricebookItemsByPk?: Maybe<PricebookItems>;
  /** fetch data from the table: "pricebook_items_qbo_income_accounts" */
  pricebookItemsQboIncomeAccounts: Array<PricebookItemsQboIncomeAccounts>;
  /** fetch aggregated fields from the table: "pricebook_items_qbo_income_accounts" */
  pricebookItemsQboIncomeAccountsAggregate: PricebookItemsQboIncomeAccountsAggregate;
  /** fetch data from the table: "pricebook_items_qbo_income_accounts" using primary key columns */
  pricebookItemsQboIncomeAccountsByPk?: Maybe<PricebookItemsQboIncomeAccounts>;
  /** fetch data from the table in a streaming manner: "pricebook_items_qbo_income_accounts" */
  pricebookItemsQboIncomeAccountsStream: Array<PricebookItemsQboIncomeAccounts>;
  /** fetch data from the table in a streaming manner: "pricebook_items" */
  pricebookItemsStream: Array<PricebookItems>;
  /** fetch data from the table: "pricebook_markup_tiers" */
  pricebookMarkupTiers: Array<PricebookMarkupTiers>;
  /** fetch aggregated fields from the table: "pricebook_markup_tiers" */
  pricebookMarkupTiersAggregate: PricebookMarkupTiersAggregate;
  /** fetch data from the table: "pricebook_markup_tiers" using primary key columns */
  pricebookMarkupTiersByPk?: Maybe<PricebookMarkupTiers>;
  /** fetch data from the table in a streaming manner: "pricebook_markup_tiers" */
  pricebookMarkupTiersStream: Array<PricebookMarkupTiers>;
  /** An array relationship */
  pricebookTaxRates: Array<PricebookTaxRates>;
  /** An aggregate relationship */
  pricebookTaxRatesAggregate: PricebookTaxRatesAggregate;
  /** fetch data from the table: "pricebook_tax_rates" using primary key columns */
  pricebookTaxRatesByPk?: Maybe<PricebookTaxRates>;
  /** fetch data from the table in a streaming manner: "pricebook_tax_rates" */
  pricebookTaxRatesStream: Array<PricebookTaxRates>;
  /** fetch data from the table: "pricebook_versions" */
  pricebookVersions: Array<PricebookVersions>;
  /** fetch aggregated fields from the table: "pricebook_versions" */
  pricebookVersionsAggregate: PricebookVersionsAggregate;
  /** fetch data from the table: "pricebook_versions" using primary key columns */
  pricebookVersionsByPk?: Maybe<PricebookVersions>;
  /** fetch data from the table in a streaming manner: "pricebook_versions" */
  pricebookVersionsStream: Array<PricebookVersions>;
  /** fetch data from the table: "pricebooks_item_prices" */
  pricebooksItemPrices: Array<PricebooksItemPrices>;
  /** fetch aggregated fields from the table: "pricebooks_item_prices" */
  pricebooksItemPricesAggregate: PricebooksItemPricesAggregate;
  /** fetch data from the table in a streaming manner: "pricebooks_item_prices" */
  pricebooksItemPricesStream: Array<PricebooksItemPrices>;
  /** An array relationship */
  purchaseOrders: Array<PurchaseOrders>;
  /** An aggregate relationship */
  purchaseOrdersAggregate: PurchaseOrdersAggregate;
  /** fetch data from the table: "purchase_orders" using primary key columns */
  purchaseOrdersByPk?: Maybe<PurchaseOrders>;
  /** fetch data from the table in a streaming manner: "purchase_orders" */
  purchaseOrdersStream: Array<PurchaseOrders>;
  /** fetch data from the table: "qbo_auth_data" */
  qboAuthData: Array<QboAuthData>;
  /** fetch aggregated fields from the table: "qbo_auth_data" */
  qboAuthDataAggregate: QboAuthDataAggregate;
  /** fetch data from the table: "qbo_auth_data" using primary key columns */
  qboAuthDataByPk?: Maybe<QboAuthData>;
  /** fetch data from the table in a streaming manner: "qbo_auth_data" */
  qboAuthDataStream: Array<QboAuthData>;
  /** fetch data from the table: "qbo_cart_item_type_accounts_config" */
  qboCartItemTypeAccountsConfig: Array<QboCartItemTypeAccountsConfig>;
  /** fetch aggregated fields from the table: "qbo_cart_item_type_accounts_config" */
  qboCartItemTypeAccountsConfigAggregate: QboCartItemTypeAccountsConfigAggregate;
  /** fetch data from the table: "qbo_cart_item_type_accounts_config" using primary key columns */
  qboCartItemTypeAccountsConfigByPk?: Maybe<QboCartItemTypeAccountsConfig>;
  /** fetch data from the table in a streaming manner: "qbo_cart_item_type_accounts_config" */
  qboCartItemTypeAccountsConfigStream: Array<QboCartItemTypeAccountsConfig>;
  /** fetch data from the table: "qbo_sync_info" */
  qboSyncInfo: Array<QboSyncInfo>;
  /** fetch aggregated fields from the table: "qbo_sync_info" */
  qboSyncInfoAggregate: QboSyncInfoAggregate;
  /** fetch data from the table: "qbo_sync_info" using primary key columns */
  qboSyncInfoByPk?: Maybe<QboSyncInfo>;
  /** fetch data from the table in a streaming manner: "qbo_sync_info" */
  qboSyncInfoStream: Array<QboSyncInfo>;
  /** fetch data from the table: "recent_pricebook_items" */
  recentPricebookItems: Array<RecentPricebookItems>;
  /** fetch aggregated fields from the table: "recent_pricebook_items" */
  recentPricebookItemsAggregate: RecentPricebookItemsAggregate;
  /** fetch data from the table: "recent_pricebook_items" using primary key columns */
  recentPricebookItemsByPk?: Maybe<RecentPricebookItems>;
  /** fetch data from the table in a streaming manner: "recent_pricebook_items" */
  recentPricebookItemsStream: Array<RecentPricebookItems>;
  /** fetch data from the table: "recommendation_ai_generation_info" */
  recommendationAiGenerationInfo: Array<RecommendationAiGenerationInfo>;
  /** fetch aggregated fields from the table: "recommendation_ai_generation_info" */
  recommendationAiGenerationInfoAggregate: RecommendationAiGenerationInfoAggregate;
  /** fetch data from the table: "recommendation_ai_generation_info" using primary key columns */
  recommendationAiGenerationInfoByPk?: Maybe<RecommendationAiGenerationInfo>;
  /** fetch data from the table in a streaming manner: "recommendation_ai_generation_info" */
  recommendationAiGenerationInfoStream: Array<RecommendationAiGenerationInfo>;
  /** An array relationship */
  recommendationDismissals: Array<RecommendationDismissals>;
  /** An aggregate relationship */
  recommendationDismissalsAggregate: RecommendationDismissalsAggregate;
  /** fetch data from the table: "recommendation_dismissals" using primary key columns */
  recommendationDismissalsByPk?: Maybe<RecommendationDismissals>;
  /** fetch data from the table in a streaming manner: "recommendation_dismissals" */
  recommendationDismissalsStream: Array<RecommendationDismissals>;
  /** An array relationship */
  recommendationInteractions: Array<RecommendationInteractions>;
  /** An aggregate relationship */
  recommendationInteractionsAggregate: RecommendationInteractionsAggregate;
  /** fetch data from the table: "recommendation_interactions" using primary key columns */
  recommendationInteractionsByPk?: Maybe<RecommendationInteractions>;
  /** fetch data from the table in a streaming manner: "recommendation_interactions" */
  recommendationInteractionsStream: Array<RecommendationInteractions>;
  /** fetch data from the table: "recommendations" */
  recommendations: Array<Recommendations>;
  /** fetch aggregated fields from the table: "recommendations" */
  recommendationsAggregate: RecommendationsAggregate;
  /** fetch data from the table: "recommendations" using primary key columns */
  recommendationsByPk?: Maybe<Recommendations>;
  /** fetch data from the table in a streaming manner: "recommendations" */
  recommendationsStream: Array<Recommendations>;
  /** An array relationship */
  reminderAssignments: Array<ReminderAssignments>;
  /** An aggregate relationship */
  reminderAssignmentsAggregate: ReminderAssignmentsAggregate;
  /** fetch data from the table: "reminder_assignments" using primary key columns */
  reminderAssignmentsByPk?: Maybe<ReminderAssignments>;
  /** fetch data from the table in a streaming manner: "reminder_assignments" */
  reminderAssignmentsStream: Array<ReminderAssignments>;
  /** fetch data from the table: "reminder_internal_notifications" */
  reminderInternalNotifications: Array<ReminderInternalNotifications>;
  /** fetch aggregated fields from the table: "reminder_internal_notifications" */
  reminderInternalNotificationsAggregate: ReminderInternalNotificationsAggregate;
  /** fetch data from the table: "reminder_internal_notifications" using primary key columns */
  reminderInternalNotificationsByPk?: Maybe<ReminderInternalNotifications>;
  /** fetch data from the table in a streaming manner: "reminder_internal_notifications" */
  reminderInternalNotificationsStream: Array<ReminderInternalNotifications>;
  /** fetch data from the table: "reminders" */
  reminders: Array<Reminders>;
  /** fetch aggregated fields from the table: "reminders" */
  remindersAggregate: RemindersAggregate;
  /** fetch data from the table: "reminders" using primary key columns */
  remindersByPk?: Maybe<Reminders>;
  /** fetch data from the table in a streaming manner: "reminders" */
  remindersStream: Array<Reminders>;
  /** fetch data from the table: "rep_company_metabase_config" */
  repCompanyMetabaseConfig: Array<RepCompanyMetabaseConfig>;
  /** fetch aggregated fields from the table: "rep_company_metabase_config" */
  repCompanyMetabaseConfigAggregate: RepCompanyMetabaseConfigAggregate;
  /** fetch data from the table: "rep_company_metabase_config" using primary key columns */
  repCompanyMetabaseConfigByPk?: Maybe<RepCompanyMetabaseConfig>;
  /** fetch data from the table in a streaming manner: "rep_company_metabase_config" */
  repCompanyMetabaseConfigStream: Array<RepCompanyMetabaseConfig>;
  /** An array relationship */
  repMetabaseCompanyReports: Array<RepMetabaseCompanyReports>;
  /** An aggregate relationship */
  repMetabaseCompanyReportsAggregate: RepMetabaseCompanyReportsAggregate;
  /** fetch data from the table: "rep_metabase_company_reports" using primary key columns */
  repMetabaseCompanyReportsByPk?: Maybe<RepMetabaseCompanyReports>;
  /** fetch data from the table in a streaming manner: "rep_metabase_company_reports" */
  repMetabaseCompanyReportsStream: Array<RepMetabaseCompanyReports>;
  /** fetch data from the table: "rep_metabase_pulses" */
  repMetabasePulses: Array<RepMetabasePulses>;
  /** fetch aggregated fields from the table: "rep_metabase_pulses" */
  repMetabasePulsesAggregate: RepMetabasePulsesAggregate;
  /** fetch data from the table: "rep_metabase_pulses" using primary key columns */
  repMetabasePulsesByPk?: Maybe<RepMetabasePulses>;
  /** fetch data from the table in a streaming manner: "rep_metabase_pulses" */
  repMetabasePulsesStream: Array<RepMetabasePulses>;
  /** fetch data from the table: "rep_metabase_pulses_v2" */
  repMetabasePulsesV2: Array<RepMetabasePulsesV2>;
  /** fetch aggregated fields from the table: "rep_metabase_pulses_v2" */
  repMetabasePulsesV2Aggregate: RepMetabasePulsesV2Aggregate;
  /** fetch data from the table: "rep_metabase_pulses_v2" using primary key columns */
  repMetabasePulsesV2ByPk?: Maybe<RepMetabasePulsesV2>;
  /** fetch data from the table in a streaming manner: "rep_metabase_pulses_v2" */
  repMetabasePulsesV2Stream: Array<RepMetabasePulsesV2>;
  /** fetch data from the table: "rep_metabase_report_definitions" */
  repMetabaseReportDefinitions: Array<RepMetabaseReportDefinitions>;
  /** fetch aggregated fields from the table: "rep_metabase_report_definitions" */
  repMetabaseReportDefinitionsAggregate: RepMetabaseReportDefinitionsAggregate;
  /** fetch data from the table: "rep_metabase_report_definitions" using primary key columns */
  repMetabaseReportDefinitionsByPk?: Maybe<RepMetabaseReportDefinitions>;
  /** fetch data from the table in a streaming manner: "rep_metabase_report_definitions" */
  repMetabaseReportDefinitionsStream: Array<RepMetabaseReportDefinitions>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tagsAggregate: TagsAggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tagsByPk?: Maybe<Tags>;
  /** fetch data from the table in a streaming manner: "tags" */
  tagsStream: Array<Tags>;
  /** fetch data from the table: "technician_capacities" */
  technicianCapacities: Array<TechnicianCapacities>;
  /** fetch aggregated fields from the table: "technician_capacities" */
  technicianCapacitiesAggregate: TechnicianCapacitiesAggregate;
  /** fetch data from the table: "technician_capacities" using primary key columns */
  technicianCapacitiesByPk?: Maybe<TechnicianCapacities>;
  /** fetch data from the table in a streaming manner: "technician_capacities" */
  technicianCapacitiesStream: Array<TechnicianCapacities>;
  /** fetch data from the table: "technician_capacity_blocks" */
  technicianCapacityBlocks: Array<TechnicianCapacityBlocks>;
  /** fetch aggregated fields from the table: "technician_capacity_blocks" */
  technicianCapacityBlocksAggregate: TechnicianCapacityBlocksAggregate;
  /** fetch data from the table: "technician_capacity_blocks" using primary key columns */
  technicianCapacityBlocksByPk?: Maybe<TechnicianCapacityBlocks>;
  /** fetch data from the table in a streaming manner: "technician_capacity_blocks" */
  technicianCapacityBlocksStream: Array<TechnicianCapacityBlocks>;
  /** fetch data from the table: "tilled_raw_events" */
  tilledRawEvents: Array<TilledRawEvents>;
  /** fetch aggregated fields from the table: "tilled_raw_events" */
  tilledRawEventsAggregate: TilledRawEventsAggregate;
  /** fetch data from the table: "tilled_raw_events" using primary key columns */
  tilledRawEventsByPk?: Maybe<TilledRawEvents>;
  /** fetch data from the table in a streaming manner: "tilled_raw_events" */
  tilledRawEventsStream: Array<TilledRawEvents>;
  /** An array relationship */
  timesheetEntries: Array<TimesheetEntries>;
  /** An aggregate relationship */
  timesheetEntriesAggregate: TimesheetEntriesAggregate;
  /** fetch data from the table: "timesheet_entries" using primary key columns */
  timesheetEntriesByPk?: Maybe<TimesheetEntries>;
  /** fetch data from the table in a streaming manner: "timesheet_entries" */
  timesheetEntriesStream: Array<TimesheetEntries>;
  /** An array relationship */
  timesheetEntryActivities: Array<TimesheetEntryActivities>;
  /** An aggregate relationship */
  timesheetEntryActivitiesAggregate: TimesheetEntryActivitiesAggregate;
  /** fetch data from the table: "timesheet_entry_activities" using primary key columns */
  timesheetEntryActivitiesByPk?: Maybe<TimesheetEntryActivities>;
  /** fetch data from the table in a streaming manner: "timesheet_entry_activities" */
  timesheetEntryActivitiesStream: Array<TimesheetEntryActivities>;
  /** An array relationship */
  timesheetEntryLinkData: Array<TimesheetEntryLinkData>;
  /** An aggregate relationship */
  timesheetEntryLinkDataAggregate: TimesheetEntryLinkDataAggregate;
  /** fetch data from the table: "timesheet_entry_link_data" using primary key columns */
  timesheetEntryLinkDataByPk?: Maybe<TimesheetEntryLinkData>;
  /** fetch data from the table in a streaming manner: "timesheet_entry_link_data" */
  timesheetEntryLinkDataStream: Array<TimesheetEntryLinkData>;
  /** fetch data from the table: "tune_up_visit_entitlements" */
  tuneUpVisitEntitlements: Array<TuneUpVisitEntitlements>;
  /** fetch aggregated fields from the table: "tune_up_visit_entitlements" */
  tuneUpVisitEntitlementsAggregate: TuneUpVisitEntitlementsAggregate;
  /** fetch data from the table: "tune_up_visit_entitlements" using primary key columns */
  tuneUpVisitEntitlementsByPk?: Maybe<TuneUpVisitEntitlements>;
  /** fetch data from the table in a streaming manner: "tune_up_visit_entitlements" */
  tuneUpVisitEntitlementsStream: Array<TuneUpVisitEntitlements>;
  /** fetch data from the table: "unnotified_account_reminders" */
  unnotifiedAccountReminders: Array<UnnotifiedAccountReminders>;
  /** fetch aggregated fields from the table: "unnotified_account_reminders" */
  unnotifiedAccountRemindersAggregate: UnnotifiedAccountRemindersAggregate;
  /** fetch data from the table in a streaming manner: "unnotified_account_reminders" */
  unnotifiedAccountRemindersStream: Array<UnnotifiedAccountReminders>;
  /** fetch data from the table: "user_business_units" */
  userBusinessUnits: Array<UserBusinessUnits>;
  /** fetch aggregated fields from the table: "user_business_units" */
  userBusinessUnitsAggregate: UserBusinessUnitsAggregate;
  /** fetch data from the table: "user_business_units" using primary key columns */
  userBusinessUnitsByPk?: Maybe<UserBusinessUnits>;
  /** fetch data from the table in a streaming manner: "user_business_units" */
  userBusinessUnitsStream: Array<UserBusinessUnits>;
  /** An array relationship */
  userPermissions: Array<UserPermissions>;
  /** An aggregate relationship */
  userPermissionsAggregate: UserPermissionsAggregate;
  /** fetch data from the table: "user_permissions" using primary key columns */
  userPermissionsByPk?: Maybe<UserPermissions>;
  /** fetch data from the table in a streaming manner: "user_permissions" */
  userPermissionsStream: Array<UserPermissions>;
  /** An array relationship */
  userPermissionsV2: Array<UserPermissionsV2>;
  /** An aggregate relationship */
  userPermissionsV2Aggregate: UserPermissionsV2Aggregate;
  /** fetch data from the table: "user_permissions_v2" using primary key columns */
  userPermissionsV2ByPk?: Maybe<UserPermissionsV2>;
  /** fetch data from the table in a streaming manner: "user_permissions_v2" */
  userPermissionsV2Stream: Array<UserPermissionsV2>;
  /** An array relationship */
  userPhoneNumbers: Array<UserPhoneNumbers>;
  /** An aggregate relationship */
  userPhoneNumbersAggregate: UserPhoneNumbersAggregate;
  /** fetch data from the table: "user_phone_numbers" using primary key columns */
  userPhoneNumbersByPk?: Maybe<UserPhoneNumbers>;
  /** fetch data from the table in a streaming manner: "user_phone_numbers" */
  userPhoneNumbersStream: Array<UserPhoneNumbers>;
  /** An array relationship */
  userRoles: Array<UserRoles>;
  /** An aggregate relationship */
  userRolesAggregate: UserRolesAggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  userRolesByPk?: Maybe<UserRoles>;
  /** fetch data from the table in a streaming manner: "user_roles" */
  userRolesStream: Array<UserRoles>;
  /** An array relationship */
  userSettings: Array<UserSettings>;
  /** An aggregate relationship */
  userSettingsAggregate: UserSettingsAggregate;
  /** fetch data from the table: "user_settings" using primary key columns */
  userSettingsByPk?: Maybe<UserSettings>;
  /** fetch data from the table in a streaming manner: "user_settings" */
  userSettingsStream: Array<UserSettings>;
  /** fetch data from the table: "user_wages" */
  userWages: Array<UserWages>;
  /** fetch aggregated fields from the table: "user_wages" */
  userWagesAggregate: UserWagesAggregate;
  /** fetch data from the table: "user_wages" using primary key columns */
  userWagesByPk?: Maybe<UserWages>;
  /** fetch data from the table in a streaming manner: "user_wages" */
  userWagesStream: Array<UserWages>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  usersAggregate: UsersAggregate;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  usersStream: Array<Users>;
  /** An array relationship */
  wisetackLoanRecords: Array<WisetackLoanRecords>;
  /** An aggregate relationship */
  wisetackLoanRecordsAggregate: WisetackLoanRecordsAggregate;
  /** fetch data from the table: "wisetack_loan_records" using primary key columns */
  wisetackLoanRecordsByPk?: Maybe<WisetackLoanRecords>;
  /** fetch data from the table in a streaming manner: "wisetack_loan_records" */
  wisetackLoanRecordsStream: Array<WisetackLoanRecords>;
  /** An array relationship */
  wisetackLoanStatuses: Array<WisetackLoanStatuses>;
  /** An aggregate relationship */
  wisetackLoanStatusesAggregate: WisetackLoanStatusesAggregate;
  /** fetch data from the table: "wisetack_loan_statuses" using primary key columns */
  wisetackLoanStatusesByPk?: Maybe<WisetackLoanStatuses>;
  /** fetch data from the table in a streaming manner: "wisetack_loan_statuses" */
  wisetackLoanStatusesStream: Array<WisetackLoanStatuses>;
  /** An array relationship */
  wisetackPrequalRecords: Array<WisetackPrequalRecords>;
  /** An aggregate relationship */
  wisetackPrequalRecordsAggregate: WisetackPrequalRecordsAggregate;
  /** fetch data from the table: "wisetack_prequal_records" using primary key columns */
  wisetackPrequalRecordsByPk?: Maybe<WisetackPrequalRecords>;
  /** fetch data from the table in a streaming manner: "wisetack_prequal_records" */
  wisetackPrequalRecordsStream: Array<WisetackPrequalRecords>;
  /** fetch data from the table: "wisetack_webhook_events" */
  wisetackWebhookEvents: Array<WisetackWebhookEvents>;
  /** fetch aggregated fields from the table: "wisetack_webhook_events" */
  wisetackWebhookEventsAggregate: WisetackWebhookEventsAggregate;
  /** fetch data from the table: "wisetack_webhook_events" using primary key columns */
  wisetackWebhookEventsByPk?: Maybe<WisetackWebhookEvents>;
  /** fetch data from the table in a streaming manner: "wisetack_webhook_events" */
  wisetackWebhookEventsStream: Array<WisetackWebhookEvents>;
};


export type Subscription_RootAccCartItemTypeAccountsConfigArgs = {
  distinctOn?: InputMaybe<Array<AccCartItemTypeAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccCartItemTypeAccountsConfigOrderBy>>;
  where?: InputMaybe<AccCartItemTypeAccountsConfigBoolExp>;
};


export type Subscription_RootAccCartItemTypeAccountsConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccCartItemTypeAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccCartItemTypeAccountsConfigOrderBy>>;
  where?: InputMaybe<AccCartItemTypeAccountsConfigBoolExp>;
};


export type Subscription_RootAccCartItemTypeAccountsConfigByPkArgs = {
  accCartItemTypeAccountsConfigGuid: Scalars['uuid'];
};


export type Subscription_RootAccCartItemTypeAccountsConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccCartItemTypeAccountsConfigStreamCursorInput>>;
  where?: InputMaybe<AccCartItemTypeAccountsConfigBoolExp>;
};


export type Subscription_RootAccCompanyConfigArgs = {
  distinctOn?: InputMaybe<Array<AccCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccCompanyConfigOrderBy>>;
  where?: InputMaybe<AccCompanyConfigBoolExp>;
};


export type Subscription_RootAccCompanyConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccCompanyConfigOrderBy>>;
  where?: InputMaybe<AccCompanyConfigBoolExp>;
};


export type Subscription_RootAccCompanyConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootAccCompanyConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccCompanyConfigStreamCursorInput>>;
  where?: InputMaybe<AccCompanyConfigBoolExp>;
};


export type Subscription_RootAccPayoutAccountsConfigArgs = {
  distinctOn?: InputMaybe<Array<AccPayoutAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccPayoutAccountsConfigOrderBy>>;
  where?: InputMaybe<AccPayoutAccountsConfigBoolExp>;
};


export type Subscription_RootAccPayoutAccountsConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccPayoutAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccPayoutAccountsConfigOrderBy>>;
  where?: InputMaybe<AccPayoutAccountsConfigBoolExp>;
};


export type Subscription_RootAccPayoutAccountsConfigByPkArgs = {
  accPayoutAccountsConfigId: Scalars['uuid'];
};


export type Subscription_RootAccPayoutAccountsConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccPayoutAccountsConfigStreamCursorInput>>;
  where?: InputMaybe<AccPayoutAccountsConfigBoolExp>;
};


export type Subscription_RootAccQbdConductorConfigArgs = {
  distinctOn?: InputMaybe<Array<AccQbdConductorConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccQbdConductorConfigOrderBy>>;
  where?: InputMaybe<AccQbdConductorConfigBoolExp>;
};


export type Subscription_RootAccQbdConductorConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccQbdConductorConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccQbdConductorConfigOrderBy>>;
  where?: InputMaybe<AccQbdConductorConfigBoolExp>;
};


export type Subscription_RootAccQbdConductorConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootAccQbdConductorConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccQbdConductorConfigStreamCursorInput>>;
  where?: InputMaybe<AccQbdConductorConfigBoolExp>;
};


export type Subscription_RootAccQbdConductorUptimeArgs = {
  distinctOn?: InputMaybe<Array<AccQbdConductorUptimeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccQbdConductorUptimeOrderBy>>;
  where?: InputMaybe<AccQbdConductorUptimeBoolExp>;
};


export type Subscription_RootAccQbdConductorUptimeAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccQbdConductorUptimeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccQbdConductorUptimeOrderBy>>;
  where?: InputMaybe<AccQbdConductorUptimeBoolExp>;
};


export type Subscription_RootAccQbdConductorUptimeByPkArgs = {
  uptimeCheckGuid: Scalars['uuid'];
};


export type Subscription_RootAccQbdConductorUptimeStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccQbdConductorUptimeStreamCursorInput>>;
  where?: InputMaybe<AccQbdConductorUptimeBoolExp>;
};


export type Subscription_RootAccSyncInfoArgs = {
  distinctOn?: InputMaybe<Array<AccSyncInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccSyncInfoOrderBy>>;
  where?: InputMaybe<AccSyncInfoBoolExp>;
};


export type Subscription_RootAccSyncInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccSyncInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccSyncInfoOrderBy>>;
  where?: InputMaybe<AccSyncInfoBoolExp>;
};


export type Subscription_RootAccSyncInfoByPkArgs = {
  accountingIntegrationType: Scalars['String'];
  breezyEntityGuid: Scalars['uuid'];
  breezyEntityType: Scalars['String'];
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootAccSyncInfoStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccSyncInfoStreamCursorInput>>;
  where?: InputMaybe<AccSyncInfoBoolExp>;
};


export type Subscription_RootAccSyncQueueItemsArgs = {
  distinctOn?: InputMaybe<Array<AccSyncQueueItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccSyncQueueItemsOrderBy>>;
  where?: InputMaybe<AccSyncQueueItemsBoolExp>;
};


export type Subscription_RootAccSyncQueueItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccSyncQueueItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccSyncQueueItemsOrderBy>>;
  where?: InputMaybe<AccSyncQueueItemsBoolExp>;
};


export type Subscription_RootAccSyncQueueItemsByPkArgs = {
  accSyncQueueItemGuid: Scalars['uuid'];
};


export type Subscription_RootAccSyncQueueItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccSyncQueueItemsStreamCursorInput>>;
  where?: InputMaybe<AccSyncQueueItemsBoolExp>;
};


export type Subscription_RootAccountContactsArgs = {
  distinctOn?: InputMaybe<Array<AccountContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountContactsOrderBy>>;
  where?: InputMaybe<AccountContactsBoolExp>;
};


export type Subscription_RootAccountContactsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountContactsOrderBy>>;
  where?: InputMaybe<AccountContactsBoolExp>;
};


export type Subscription_RootAccountContactsByPkArgs = {
  accountContactGuid: Scalars['uuid'];
};


export type Subscription_RootAccountContactsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccountContactsStreamCursorInput>>;
  where?: InputMaybe<AccountContactsBoolExp>;
};


export type Subscription_RootAccountJobCountsArgs = {
  distinctOn?: InputMaybe<Array<AccountJobCountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountJobCountsOrderBy>>;
  where?: InputMaybe<AccountJobCountsBoolExp>;
};


export type Subscription_RootAccountJobCountsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccountJobCountsStreamCursorInput>>;
  where?: InputMaybe<AccountJobCountsBoolExp>;
};


export type Subscription_RootAccountLocationsArgs = {
  distinctOn?: InputMaybe<Array<AccountLocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountLocationsOrderBy>>;
  where?: InputMaybe<AccountLocationsBoolExp>;
};


export type Subscription_RootAccountLocationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountLocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountLocationsOrderBy>>;
  where?: InputMaybe<AccountLocationsBoolExp>;
};


export type Subscription_RootAccountLocationsByPkArgs = {
  accountGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
};


export type Subscription_RootAccountLocationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccountLocationsStreamCursorInput>>;
  where?: InputMaybe<AccountLocationsBoolExp>;
};


export type Subscription_RootAccountRemindersArgs = {
  distinctOn?: InputMaybe<Array<AccountRemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountRemindersOrderBy>>;
  where?: InputMaybe<AccountRemindersBoolExp>;
};


export type Subscription_RootAccountRemindersAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountRemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountRemindersOrderBy>>;
  where?: InputMaybe<AccountRemindersBoolExp>;
};


export type Subscription_RootAccountRemindersByPkArgs = {
  accountGuid: Scalars['uuid'];
  reminderGuid: Scalars['uuid'];
};


export type Subscription_RootAccountRemindersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccountRemindersStreamCursorInput>>;
  where?: InputMaybe<AccountRemindersBoolExp>;
};


export type Subscription_RootAccountStatementEventsArgs = {
  distinctOn?: InputMaybe<Array<AccountStatementEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountStatementEventsOrderBy>>;
  where?: InputMaybe<AccountStatementEventsBoolExp>;
};


export type Subscription_RootAccountStatementEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountStatementEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountStatementEventsOrderBy>>;
  where?: InputMaybe<AccountStatementEventsBoolExp>;
};


export type Subscription_RootAccountStatementEventsByPkArgs = {
  statementEventGuid: Scalars['uuid'];
};


export type Subscription_RootAccountStatementEventsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccountStatementEventsStreamCursorInput>>;
  where?: InputMaybe<AccountStatementEventsBoolExp>;
};


export type Subscription_RootAccountTagsArgs = {
  distinctOn?: InputMaybe<Array<AccountTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountTagsOrderBy>>;
  where?: InputMaybe<AccountTagsBoolExp>;
};


export type Subscription_RootAccountTagsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountTagsOrderBy>>;
  where?: InputMaybe<AccountTagsBoolExp>;
};


export type Subscription_RootAccountTagsByPkArgs = {
  accountGuid: Scalars['uuid'];
  tagGuid: Scalars['uuid'];
};


export type Subscription_RootAccountTagsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccountTagsStreamCursorInput>>;
  where?: InputMaybe<AccountTagsBoolExp>;
};


export type Subscription_RootAccountTypesArgs = {
  distinctOn?: InputMaybe<Array<AccountTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountTypesOrderBy>>;
  where?: InputMaybe<AccountTypesBoolExp>;
};


export type Subscription_RootAccountTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountTypesOrderBy>>;
  where?: InputMaybe<AccountTypesBoolExp>;
};


export type Subscription_RootAccountTypesByPkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootAccountTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccountTypesStreamCursorInput>>;
  where?: InputMaybe<AccountTypesBoolExp>;
};


export type Subscription_RootAccountsArgs = {
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Subscription_RootAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Subscription_RootAccountsByPkArgs = {
  accountGuid: Scalars['uuid'];
};


export type Subscription_RootAccountsReceivableArgs = {
  distinctOn?: InputMaybe<Array<AccountsReceivableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsReceivableOrderBy>>;
  where?: InputMaybe<AccountsReceivableBoolExp>;
};


export type Subscription_RootAccountsReceivableAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountsReceivableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsReceivableOrderBy>>;
  where?: InputMaybe<AccountsReceivableBoolExp>;
};


export type Subscription_RootAccountsReceivableStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccountsReceivableStreamCursorInput>>;
  where?: InputMaybe<AccountsReceivableBoolExp>;
};


export type Subscription_RootAccountsSortedByJobCountArgs = {
  args: AccountsSortedByJobCountArgs;
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Subscription_RootAccountsSortedByJobCountAggregateArgs = {
  args: AccountsSortedByJobCountArgs;
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Subscription_RootAccountsSortedByRecentlyViewedForUserArgs = {
  args: AccountsSortedByRecentlyViewedForUserArgs;
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Subscription_RootAccountsSortedByRecentlyViewedForUserAggregateArgs = {
  args: AccountsSortedByRecentlyViewedForUserArgs;
  distinctOn?: InputMaybe<Array<AccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Subscription_RootAccountsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccountsStreamCursorInput>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type Subscription_RootAccountsViewedByUserArgs = {
  distinctOn?: InputMaybe<Array<AccountsViewedByUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsViewedByUserOrderBy>>;
  where?: InputMaybe<AccountsViewedByUserBoolExp>;
};


export type Subscription_RootAccountsViewedByUserAggregateArgs = {
  distinctOn?: InputMaybe<Array<AccountsViewedByUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsViewedByUserOrderBy>>;
  where?: InputMaybe<AccountsViewedByUserBoolExp>;
};


export type Subscription_RootAccountsViewedByUserByPkArgs = {
  accountGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


export type Subscription_RootAccountsViewedByUserStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AccountsViewedByUserStreamCursorInput>>;
  where?: InputMaybe<AccountsViewedByUserBoolExp>;
};


export type Subscription_RootActivityItemsArgs = {
  distinctOn?: InputMaybe<Array<ActivityItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityItemsOrderBy>>;
  where?: InputMaybe<ActivityItemsBoolExp>;
};


export type Subscription_RootActivityItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ActivityItemsOrderBy>>;
  where?: InputMaybe<ActivityItemsBoolExp>;
};


export type Subscription_RootActivityItemsByPkArgs = {
  activityItemGuid: Scalars['uuid'];
};


export type Subscription_RootActivityItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ActivityItemsStreamCursorInput>>;
  where?: InputMaybe<ActivityItemsBoolExp>;
};


export type Subscription_RootAddressesArgs = {
  distinctOn?: InputMaybe<Array<AddressesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
  where?: InputMaybe<AddressesBoolExp>;
};


export type Subscription_RootAddressesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AddressesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AddressesOrderBy>>;
  where?: InputMaybe<AddressesBoolExp>;
};


export type Subscription_RootAddressesByPkArgs = {
  addressGuid: Scalars['uuid'];
};


export type Subscription_RootAddressesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AddressesStreamCursorInput>>;
  where?: InputMaybe<AddressesBoolExp>;
};


export type Subscription_RootAggregatableInvoicesArgs = {
  distinctOn?: InputMaybe<Array<AggregatableInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AggregatableInvoicesOrderBy>>;
  where?: InputMaybe<AggregatableInvoicesBoolExp>;
};


export type Subscription_RootAggregatableInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AggregatableInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AggregatableInvoicesOrderBy>>;
  where?: InputMaybe<AggregatableInvoicesBoolExp>;
};


export type Subscription_RootAggregatableInvoicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AggregatableInvoicesStreamCursorInput>>;
  where?: InputMaybe<AggregatableInvoicesBoolExp>;
};


export type Subscription_RootApplicationTasksArgs = {
  distinctOn?: InputMaybe<Array<ApplicationTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ApplicationTasksOrderBy>>;
  where?: InputMaybe<ApplicationTasksBoolExp>;
};


export type Subscription_RootApplicationTasksAggregateArgs = {
  distinctOn?: InputMaybe<Array<ApplicationTasksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ApplicationTasksOrderBy>>;
  where?: InputMaybe<ApplicationTasksBoolExp>;
};


export type Subscription_RootApplicationTasksByPkArgs = {
  taskGuid: Scalars['uuid'];
};


export type Subscription_RootApplicationTasksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ApplicationTasksStreamCursorInput>>;
  where?: InputMaybe<ApplicationTasksBoolExp>;
};


export type Subscription_RootAppointmentChecklistAssociationRulesArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistAssociationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistAssociationRulesOrderBy>>;
  where?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
};


export type Subscription_RootAppointmentChecklistAssociationRulesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistAssociationRulesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistAssociationRulesOrderBy>>;
  where?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
};


export type Subscription_RootAppointmentChecklistAssociationRulesByPkArgs = {
  appointmentChecklistAssociationRuleGuid: Scalars['uuid'];
};


export type Subscription_RootAppointmentChecklistAssociationRulesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AppointmentChecklistAssociationRulesStreamCursorInput>>;
  where?: InputMaybe<AppointmentChecklistAssociationRulesBoolExp>;
};


export type Subscription_RootAppointmentChecklistInstancesArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistInstancesOrderBy>>;
  where?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
};


export type Subscription_RootAppointmentChecklistInstancesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistInstancesOrderBy>>;
  where?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
};


export type Subscription_RootAppointmentChecklistInstancesByPkArgs = {
  appointmentChecklistInstanceGuid: Scalars['uuid'];
};


export type Subscription_RootAppointmentChecklistInstancesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AppointmentChecklistInstancesStreamCursorInput>>;
  where?: InputMaybe<AppointmentChecklistInstancesBoolExp>;
};


export type Subscription_RootAppointmentChecklistsArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistsOrderBy>>;
  where?: InputMaybe<AppointmentChecklistsBoolExp>;
};


export type Subscription_RootAppointmentChecklistsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AppointmentChecklistsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppointmentChecklistsOrderBy>>;
  where?: InputMaybe<AppointmentChecklistsBoolExp>;
};


export type Subscription_RootAppointmentChecklistsByPkArgs = {
  appointmentChecklistGuid: Scalars['uuid'];
};


export type Subscription_RootAppointmentChecklistsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AppointmentChecklistsStreamCursorInput>>;
  where?: InputMaybe<AppointmentChecklistsBoolExp>;
};


export type Subscription_RootAssistantIntegratedPhonesArgs = {
  distinctOn?: InputMaybe<Array<AssistantIntegratedPhonesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantIntegratedPhonesOrderBy>>;
  where?: InputMaybe<AssistantIntegratedPhonesBoolExp>;
};


export type Subscription_RootAssistantIntegratedPhonesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AssistantIntegratedPhonesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantIntegratedPhonesOrderBy>>;
  where?: InputMaybe<AssistantIntegratedPhonesBoolExp>;
};


export type Subscription_RootAssistantIntegratedPhonesByPkArgs = {
  assistantGuid: Scalars['uuid'];
  integratedPhoneGuid: Scalars['uuid'];
};


export type Subscription_RootAssistantIntegratedPhonesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AssistantIntegratedPhonesStreamCursorInput>>;
  where?: InputMaybe<AssistantIntegratedPhonesBoolExp>;
};


export type Subscription_RootAssistantPhoneSettingsArgs = {
  distinctOn?: InputMaybe<Array<AssistantPhoneSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantPhoneSettingsOrderBy>>;
  where?: InputMaybe<AssistantPhoneSettingsBoolExp>;
};


export type Subscription_RootAssistantPhoneSettingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AssistantPhoneSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantPhoneSettingsOrderBy>>;
  where?: InputMaybe<AssistantPhoneSettingsBoolExp>;
};


export type Subscription_RootAssistantPhoneSettingsByPkArgs = {
  assistantGuid: Scalars['uuid'];
};


export type Subscription_RootAssistantPhoneSettingsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AssistantPhoneSettingsStreamCursorInput>>;
  where?: InputMaybe<AssistantPhoneSettingsBoolExp>;
};


export type Subscription_RootAssistantsArgs = {
  distinctOn?: InputMaybe<Array<AssistantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantsOrderBy>>;
  where?: InputMaybe<AssistantsBoolExp>;
};


export type Subscription_RootAssistantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<AssistantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssistantsOrderBy>>;
  where?: InputMaybe<AssistantsBoolExp>;
};


export type Subscription_RootAssistantsByPkArgs = {
  assistantGuid: Scalars['uuid'];
};


export type Subscription_RootAssistantsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<AssistantsStreamCursorInput>>;
  where?: InputMaybe<AssistantsBoolExp>;
};


export type Subscription_RootBillingProfileHiddenPaymentMethodsArgs = {
  distinctOn?: InputMaybe<Array<BillingProfileHiddenPaymentMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingProfileHiddenPaymentMethodsOrderBy>>;
  where?: InputMaybe<BillingProfileHiddenPaymentMethodsBoolExp>;
};


export type Subscription_RootBillingProfileHiddenPaymentMethodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BillingProfileHiddenPaymentMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingProfileHiddenPaymentMethodsOrderBy>>;
  where?: InputMaybe<BillingProfileHiddenPaymentMethodsBoolExp>;
};


export type Subscription_RootBillingProfileHiddenPaymentMethodsByPkArgs = {
  companyGuid: Scalars['uuid'];
  paymentMethod: PaymentMethodsEnum;
};


export type Subscription_RootBillingProfileHiddenPaymentMethodsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BillingProfileHiddenPaymentMethodsStreamCursorInput>>;
  where?: InputMaybe<BillingProfileHiddenPaymentMethodsBoolExp>;
};


export type Subscription_RootBillingProfilesArgs = {
  distinctOn?: InputMaybe<Array<BillingProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingProfilesOrderBy>>;
  where?: InputMaybe<BillingProfilesBoolExp>;
};


export type Subscription_RootBillingProfilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BillingProfilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BillingProfilesOrderBy>>;
  where?: InputMaybe<BillingProfilesBoolExp>;
};


export type Subscription_RootBillingProfilesByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootBillingProfilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BillingProfilesStreamCursorInput>>;
  where?: InputMaybe<BillingProfilesBoolExp>;
};


export type Subscription_RootBusinessEventsArgs = {
  distinctOn?: InputMaybe<Array<BusinessEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessEventsOrderBy>>;
  where?: InputMaybe<BusinessEventsBoolExp>;
};


export type Subscription_RootBusinessEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessEventsOrderBy>>;
  where?: InputMaybe<BusinessEventsBoolExp>;
};


export type Subscription_RootBusinessEventsByPkArgs = {
  businessEventGuid: Scalars['uuid'];
};


export type Subscription_RootBusinessEventsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BusinessEventsStreamCursorInput>>;
  where?: InputMaybe<BusinessEventsBoolExp>;
};


export type Subscription_RootBusinessUnitTargetMetricsArgs = {
  distinctOn?: InputMaybe<Array<BusinessUnitTargetMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessUnitTargetMetricsOrderBy>>;
  where?: InputMaybe<BusinessUnitTargetMetricsBoolExp>;
};


export type Subscription_RootBusinessUnitTargetMetricsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUnitTargetMetricsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessUnitTargetMetricsOrderBy>>;
  where?: InputMaybe<BusinessUnitTargetMetricsBoolExp>;
};


export type Subscription_RootBusinessUnitTargetMetricsByPkArgs = {
  businessUnitTargetMetricGuid: Scalars['uuid'];
};


export type Subscription_RootBusinessUnitTargetMetricsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BusinessUnitTargetMetricsStreamCursorInput>>;
  where?: InputMaybe<BusinessUnitTargetMetricsBoolExp>;
};


export type Subscription_RootBusinessUnitsArgs = {
  distinctOn?: InputMaybe<Array<BusinessUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessUnitsOrderBy>>;
  where?: InputMaybe<BusinessUnitsBoolExp>;
};


export type Subscription_RootBusinessUnitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BusinessUnitsOrderBy>>;
  where?: InputMaybe<BusinessUnitsBoolExp>;
};


export type Subscription_RootBusinessUnitsByPkArgs = {
  businessUnitGuid: Scalars['uuid'];
};


export type Subscription_RootBusinessUnitsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<BusinessUnitsStreamCursorInput>>;
  where?: InputMaybe<BusinessUnitsBoolExp>;
};


export type Subscription_RootCanonicalLeadSourcesArgs = {
  distinctOn?: InputMaybe<Array<CanonicalLeadSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CanonicalLeadSourcesOrderBy>>;
  where?: InputMaybe<CanonicalLeadSourcesBoolExp>;
};


export type Subscription_RootCanonicalLeadSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CanonicalLeadSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CanonicalLeadSourcesOrderBy>>;
  where?: InputMaybe<CanonicalLeadSourcesBoolExp>;
};


export type Subscription_RootCanonicalLeadSourcesByPkArgs = {
  canonicalLeadSourceName: Scalars['String'];
};


export type Subscription_RootCanonicalLeadSourcesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CanonicalLeadSourcesStreamCursorInput>>;
  where?: InputMaybe<CanonicalLeadSourcesBoolExp>;
};


export type Subscription_RootCartItemJobCostLinksArgs = {
  distinctOn?: InputMaybe<Array<CartItemJobCostLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CartItemJobCostLinksOrderBy>>;
  where?: InputMaybe<CartItemJobCostLinksBoolExp>;
};


export type Subscription_RootCartItemJobCostLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<CartItemJobCostLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CartItemJobCostLinksOrderBy>>;
  where?: InputMaybe<CartItemJobCostLinksBoolExp>;
};


export type Subscription_RootCartItemJobCostLinksByPkArgs = {
  cartItemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
};


export type Subscription_RootCartItemJobCostLinksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CartItemJobCostLinksStreamCursorInput>>;
  where?: InputMaybe<CartItemJobCostLinksBoolExp>;
};


export type Subscription_RootCartItemsArgs = {
  distinctOn?: InputMaybe<Array<CartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CartItemsOrderBy>>;
  where?: InputMaybe<CartItemsBoolExp>;
};


export type Subscription_RootCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CartItemsOrderBy>>;
  where?: InputMaybe<CartItemsBoolExp>;
};


export type Subscription_RootCartItemsByPkArgs = {
  cartItemGuid: Scalars['uuid'];
};


export type Subscription_RootCartItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CartItemsStreamCursorInput>>;
  where?: InputMaybe<CartItemsBoolExp>;
};


export type Subscription_RootChecklistItemsArgs = {
  distinctOn?: InputMaybe<Array<ChecklistItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChecklistItemsOrderBy>>;
  where?: InputMaybe<ChecklistItemsBoolExp>;
};


export type Subscription_RootChecklistItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChecklistItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ChecklistItemsOrderBy>>;
  where?: InputMaybe<ChecklistItemsBoolExp>;
};


export type Subscription_RootChecklistItemsByPkArgs = {
  checklistItemGuid: Scalars['uuid'];
};


export type Subscription_RootChecklistItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ChecklistItemsStreamCursorInput>>;
  where?: InputMaybe<ChecklistItemsBoolExp>;
};


export type Subscription_RootCompaniesArgs = {
  distinctOn?: InputMaybe<Array<CompaniesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompaniesOrderBy>>;
  where?: InputMaybe<CompaniesBoolExp>;
};


export type Subscription_RootCompaniesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompaniesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompaniesOrderBy>>;
  where?: InputMaybe<CompaniesBoolExp>;
};


export type Subscription_RootCompaniesByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootCompaniesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompaniesStreamCursorInput>>;
  where?: InputMaybe<CompaniesBoolExp>;
};


export type Subscription_RootCompanyAppointmentArrivalWindowsArgs = {
  distinctOn?: InputMaybe<Array<CompanyAppointmentArrivalWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyAppointmentArrivalWindowsOrderBy>>;
  where?: InputMaybe<CompanyAppointmentArrivalWindowsBoolExp>;
};


export type Subscription_RootCompanyAppointmentArrivalWindowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyAppointmentArrivalWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyAppointmentArrivalWindowsOrderBy>>;
  where?: InputMaybe<CompanyAppointmentArrivalWindowsBoolExp>;
};


export type Subscription_RootCompanyAppointmentArrivalWindowsByPkArgs = {
  companyAppointmentArrivalWindowGuid: Scalars['uuid'];
};


export type Subscription_RootCompanyAppointmentArrivalWindowsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyAppointmentArrivalWindowsStreamCursorInput>>;
  where?: InputMaybe<CompanyAppointmentArrivalWindowsBoolExp>;
};


export type Subscription_RootCompanyCommissionConfigArgs = {
  distinctOn?: InputMaybe<Array<CompanyCommissionConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyCommissionConfigOrderBy>>;
  where?: InputMaybe<CompanyCommissionConfigBoolExp>;
};


export type Subscription_RootCompanyCommissionConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyCommissionConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyCommissionConfigOrderBy>>;
  where?: InputMaybe<CompanyCommissionConfigBoolExp>;
};


export type Subscription_RootCompanyCommissionConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootCompanyCommissionConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyCommissionConfigStreamCursorInput>>;
  where?: InputMaybe<CompanyCommissionConfigBoolExp>;
};


export type Subscription_RootCompanyConfigArgs = {
  distinctOn?: InputMaybe<Array<CompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyConfigOrderBy>>;
  where?: InputMaybe<CompanyConfigBoolExp>;
};


export type Subscription_RootCompanyConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyConfigOrderBy>>;
  where?: InputMaybe<CompanyConfigBoolExp>;
};


export type Subscription_RootCompanyConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootCompanyConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyConfigStreamCursorInput>>;
  where?: InputMaybe<CompanyConfigBoolExp>;
};


export type Subscription_RootCompanyDripMarketingConfigArgs = {
  distinctOn?: InputMaybe<Array<CompanyDripMarketingConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDripMarketingConfigOrderBy>>;
  where?: InputMaybe<CompanyDripMarketingConfigBoolExp>;
};


export type Subscription_RootCompanyDripMarketingConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyDripMarketingConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyDripMarketingConfigOrderBy>>;
  where?: InputMaybe<CompanyDripMarketingConfigBoolExp>;
};


export type Subscription_RootCompanyDripMarketingConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootCompanyDripMarketingConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyDripMarketingConfigStreamCursorInput>>;
  where?: InputMaybe<CompanyDripMarketingConfigBoolExp>;
};


export type Subscription_RootCompanyLeadSourceLinksArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourceLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourceLinksOrderBy>>;
  where?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
};


export type Subscription_RootCompanyLeadSourceLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourceLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourceLinksOrderBy>>;
  where?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
};


export type Subscription_RootCompanyLeadSourceLinksByPkArgs = {
  companyLeadSourceLinkGuid: Scalars['uuid'];
};


export type Subscription_RootCompanyLeadSourceLinksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyLeadSourceLinksStreamCursorInput>>;
  where?: InputMaybe<CompanyLeadSourceLinksBoolExp>;
};


export type Subscription_RootCompanyLeadSourcesArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourcesOrderBy>>;
  where?: InputMaybe<CompanyLeadSourcesBoolExp>;
};


export type Subscription_RootCompanyLeadSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyLeadSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyLeadSourcesOrderBy>>;
  where?: InputMaybe<CompanyLeadSourcesBoolExp>;
};


export type Subscription_RootCompanyLeadSourcesByPkArgs = {
  companyLeadSourceGuid: Scalars['uuid'];
};


export type Subscription_RootCompanyLeadSourcesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyLeadSourcesStreamCursorInput>>;
  where?: InputMaybe<CompanyLeadSourcesBoolExp>;
};


export type Subscription_RootCompanyNotificationSettingsArgs = {
  distinctOn?: InputMaybe<Array<CompanyNotificationSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyNotificationSettingsOrderBy>>;
  where?: InputMaybe<CompanyNotificationSettingsBoolExp>;
};


export type Subscription_RootCompanyNotificationSettingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyNotificationSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyNotificationSettingsOrderBy>>;
  where?: InputMaybe<CompanyNotificationSettingsBoolExp>;
};


export type Subscription_RootCompanyNotificationSettingsByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootCompanyNotificationSettingsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyNotificationSettingsStreamCursorInput>>;
  where?: InputMaybe<CompanyNotificationSettingsBoolExp>;
};


export type Subscription_RootCompanyPricingTierConfigArgs = {
  distinctOn?: InputMaybe<Array<CompanyPricingTierConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyPricingTierConfigOrderBy>>;
  where?: InputMaybe<CompanyPricingTierConfigBoolExp>;
};


export type Subscription_RootCompanyPricingTierConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyPricingTierConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyPricingTierConfigOrderBy>>;
  where?: InputMaybe<CompanyPricingTierConfigBoolExp>;
};


export type Subscription_RootCompanyPricingTierConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootCompanyPricingTierConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyPricingTierConfigStreamCursorInput>>;
  where?: InputMaybe<CompanyPricingTierConfigBoolExp>;
};


export type Subscription_RootCompanyReviewLinksArgs = {
  distinctOn?: InputMaybe<Array<CompanyReviewLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyReviewLinksOrderBy>>;
  where?: InputMaybe<CompanyReviewLinksBoolExp>;
};


export type Subscription_RootCompanyReviewLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyReviewLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyReviewLinksOrderBy>>;
  where?: InputMaybe<CompanyReviewLinksBoolExp>;
};


export type Subscription_RootCompanyReviewLinksByPkArgs = {
  companyReviewLinkGuid: Scalars['uuid'];
};


export type Subscription_RootCompanyReviewLinksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyReviewLinksStreamCursorInput>>;
  where?: InputMaybe<CompanyReviewLinksBoolExp>;
};


export type Subscription_RootCompanyRolesArgs = {
  distinctOn?: InputMaybe<Array<CompanyRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyRolesOrderBy>>;
  where?: InputMaybe<CompanyRolesBoolExp>;
};


export type Subscription_RootCompanyRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyRolesOrderBy>>;
  where?: InputMaybe<CompanyRolesBoolExp>;
};


export type Subscription_RootCompanyRolesByPkArgs = {
  role: Scalars['String'];
};


export type Subscription_RootCompanyRolesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyRolesStreamCursorInput>>;
  where?: InputMaybe<CompanyRolesBoolExp>;
};


export type Subscription_RootCompanyTaxConfigurationsArgs = {
  distinctOn?: InputMaybe<Array<CompanyTaxConfigurationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyTaxConfigurationsOrderBy>>;
  where?: InputMaybe<CompanyTaxConfigurationsBoolExp>;
};


export type Subscription_RootCompanyTaxConfigurationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyTaxConfigurationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyTaxConfigurationsOrderBy>>;
  where?: InputMaybe<CompanyTaxConfigurationsBoolExp>;
};


export type Subscription_RootCompanyTaxConfigurationsByPkArgs = {
  companyTaxConfigurationGuid: Scalars['uuid'];
};


export type Subscription_RootCompanyTaxConfigurationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyTaxConfigurationsStreamCursorInput>>;
  where?: InputMaybe<CompanyTaxConfigurationsBoolExp>;
};


export type Subscription_RootCompanyUsersArgs = {
  distinctOn?: InputMaybe<Array<CompanyUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyUsersOrderBy>>;
  where?: InputMaybe<CompanyUsersBoolExp>;
};


export type Subscription_RootCompanyUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyUsersOrderBy>>;
  where?: InputMaybe<CompanyUsersBoolExp>;
};


export type Subscription_RootCompanyUsersByPkArgs = {
  userGuid: Scalars['uuid'];
};


export type Subscription_RootCompanyUsersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyUsersStreamCursorInput>>;
  where?: InputMaybe<CompanyUsersBoolExp>;
};


export type Subscription_RootCompanyWorkingDisplayHoursArgs = {
  distinctOn?: InputMaybe<Array<CompanyWorkingDisplayHoursSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyWorkingDisplayHoursOrderBy>>;
  where?: InputMaybe<CompanyWorkingDisplayHoursBoolExp>;
};


export type Subscription_RootCompanyWorkingDisplayHoursAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompanyWorkingDisplayHoursSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CompanyWorkingDisplayHoursOrderBy>>;
  where?: InputMaybe<CompanyWorkingDisplayHoursBoolExp>;
};


export type Subscription_RootCompanyWorkingDisplayHoursByPkArgs = {
  companyWorkingDisplayHoursGuid: Scalars['uuid'];
};


export type Subscription_RootCompanyWorkingDisplayHoursStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyWorkingDisplayHoursStreamCursorInput>>;
  where?: InputMaybe<CompanyWorkingDisplayHoursBoolExp>;
};


export type Subscription_RootContactsArgs = {
  distinctOn?: InputMaybe<Array<ContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
  where?: InputMaybe<ContactsBoolExp>;
};


export type Subscription_RootContactsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
  where?: InputMaybe<ContactsBoolExp>;
};


export type Subscription_RootContactsByPkArgs = {
  contactGuid: Scalars['uuid'];
};


export type Subscription_RootContactsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ContactsStreamCursorInput>>;
  where?: InputMaybe<ContactsBoolExp>;
};


export type Subscription_RootCronJobsArgs = {
  distinctOn?: InputMaybe<Array<CronJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CronJobsOrderBy>>;
  where?: InputMaybe<CronJobsBoolExp>;
};


export type Subscription_RootCronJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CronJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CronJobsOrderBy>>;
  where?: InputMaybe<CronJobsBoolExp>;
};


export type Subscription_RootCronJobsByPkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCronJobsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CronJobsStreamCursorInput>>;
  where?: InputMaybe<CronJobsBoolExp>;
};


export type Subscription_RootCurrentBusinessUnitTargetMetricsViewArgs = {
  distinctOn?: InputMaybe<Array<CurrentBusinessUnitTargetMetricsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrentBusinessUnitTargetMetricsViewOrderBy>>;
  where?: InputMaybe<CurrentBusinessUnitTargetMetricsViewBoolExp>;
};


export type Subscription_RootCurrentBusinessUnitTargetMetricsViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<CurrentBusinessUnitTargetMetricsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrentBusinessUnitTargetMetricsViewOrderBy>>;
  where?: InputMaybe<CurrentBusinessUnitTargetMetricsViewBoolExp>;
};


export type Subscription_RootCurrentBusinessUnitTargetMetricsViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CurrentBusinessUnitTargetMetricsViewStreamCursorInput>>;
  where?: InputMaybe<CurrentBusinessUnitTargetMetricsViewBoolExp>;
};


export type Subscription_RootCurrentCompanyTaxConfigurationsViewArgs = {
  distinctOn?: InputMaybe<Array<CurrentCompanyTaxConfigurationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrentCompanyTaxConfigurationsViewOrderBy>>;
  where?: InputMaybe<CurrentCompanyTaxConfigurationsViewBoolExp>;
};


export type Subscription_RootCurrentCompanyTaxConfigurationsViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<CurrentCompanyTaxConfigurationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrentCompanyTaxConfigurationsViewOrderBy>>;
  where?: InputMaybe<CurrentCompanyTaxConfigurationsViewBoolExp>;
};


export type Subscription_RootCurrentCompanyTaxConfigurationsViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CurrentCompanyTaxConfigurationsViewStreamCursorInput>>;
  where?: InputMaybe<CurrentCompanyTaxConfigurationsViewBoolExp>;
};


export type Subscription_RootCurrentUserBusinessUnitsViewArgs = {
  distinctOn?: InputMaybe<Array<CurrentUserBusinessUnitsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrentUserBusinessUnitsViewOrderBy>>;
  where?: InputMaybe<CurrentUserBusinessUnitsViewBoolExp>;
};


export type Subscription_RootCurrentUserBusinessUnitsViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<CurrentUserBusinessUnitsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CurrentUserBusinessUnitsViewOrderBy>>;
  where?: InputMaybe<CurrentUserBusinessUnitsViewBoolExp>;
};


export type Subscription_RootCurrentUserBusinessUnitsViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CurrentUserBusinessUnitsViewStreamCursorInput>>;
  where?: InputMaybe<CurrentUserBusinessUnitsViewBoolExp>;
};


export type Subscription_RootCustomerCommunicationTemplatesArgs = {
  distinctOn?: InputMaybe<Array<CustomerCommunicationTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomerCommunicationTemplatesOrderBy>>;
  where?: InputMaybe<CustomerCommunicationTemplatesBoolExp>;
};


export type Subscription_RootCustomerCommunicationTemplatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CustomerCommunicationTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomerCommunicationTemplatesOrderBy>>;
  where?: InputMaybe<CustomerCommunicationTemplatesBoolExp>;
};


export type Subscription_RootCustomerCommunicationTemplatesByPkArgs = {
  companyGuid: Scalars['uuid'];
  name: Scalars['String'];
  type: Scalars['String'];
};


export type Subscription_RootCustomerCommunicationTemplatesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<CustomerCommunicationTemplatesStreamCursorInput>>;
  where?: InputMaybe<CustomerCommunicationTemplatesBoolExp>;
};


export type Subscription_RootDiscountEntitlementsArgs = {
  distinctOn?: InputMaybe<Array<DiscountEntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiscountEntitlementsOrderBy>>;
  where?: InputMaybe<DiscountEntitlementsBoolExp>;
};


export type Subscription_RootDiscountEntitlementsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DiscountEntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiscountEntitlementsOrderBy>>;
  where?: InputMaybe<DiscountEntitlementsBoolExp>;
};


export type Subscription_RootDiscountEntitlementsByPkArgs = {
  entitlementGuid: Scalars['uuid'];
};


export type Subscription_RootDiscountEntitlementsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<DiscountEntitlementsStreamCursorInput>>;
  where?: InputMaybe<DiscountEntitlementsBoolExp>;
};


export type Subscription_RootDisplayIdCountersArgs = {
  distinctOn?: InputMaybe<Array<DisplayIdCountersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisplayIdCountersOrderBy>>;
  where?: InputMaybe<DisplayIdCountersBoolExp>;
};


export type Subscription_RootDisplayIdCountersAggregateArgs = {
  distinctOn?: InputMaybe<Array<DisplayIdCountersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DisplayIdCountersOrderBy>>;
  where?: InputMaybe<DisplayIdCountersBoolExp>;
};


export type Subscription_RootDisplayIdCountersByPkArgs = {
  companyGuid: Scalars['uuid'];
  entityType: Scalars['String'];
};


export type Subscription_RootDisplayIdCountersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<DisplayIdCountersStreamCursorInput>>;
  where?: InputMaybe<DisplayIdCountersBoolExp>;
};


export type Subscription_RootDripMarketingEmailsArgs = {
  distinctOn?: InputMaybe<Array<DripMarketingEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DripMarketingEmailsOrderBy>>;
  where?: InputMaybe<DripMarketingEmailsBoolExp>;
};


export type Subscription_RootDripMarketingEmailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DripMarketingEmailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DripMarketingEmailsOrderBy>>;
  where?: InputMaybe<DripMarketingEmailsBoolExp>;
};


export type Subscription_RootDripMarketingEmailsByPkArgs = {
  dripMarketingEmailGuid: Scalars['uuid'];
};


export type Subscription_RootDripMarketingEmailsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<DripMarketingEmailsStreamCursorInput>>;
  where?: InputMaybe<DripMarketingEmailsBoolExp>;
};


export type Subscription_RootEmailAddressesArgs = {
  distinctOn?: InputMaybe<Array<EmailAddressesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmailAddressesOrderBy>>;
  where?: InputMaybe<EmailAddressesBoolExp>;
};


export type Subscription_RootEmailAddressesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailAddressesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmailAddressesOrderBy>>;
  where?: InputMaybe<EmailAddressesBoolExp>;
};


export type Subscription_RootEmailAddressesByPkArgs = {
  emailAddressGuid: Scalars['uuid'];
};


export type Subscription_RootEmailAddressesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EmailAddressesStreamCursorInput>>;
  where?: InputMaybe<EmailAddressesBoolExp>;
};


export type Subscription_RootEntitlementsArgs = {
  distinctOn?: InputMaybe<Array<EntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EntitlementsOrderBy>>;
  where?: InputMaybe<EntitlementsBoolExp>;
};


export type Subscription_RootEntitlementsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EntitlementsOrderBy>>;
  where?: InputMaybe<EntitlementsBoolExp>;
};


export type Subscription_RootEntitlementsByPkArgs = {
  entitlementGuid: Scalars['uuid'];
};


export type Subscription_RootEntitlementsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EntitlementsStreamCursorInput>>;
  where?: InputMaybe<EntitlementsBoolExp>;
};


export type Subscription_RootEquipmentTypeLinksArgs = {
  distinctOn?: InputMaybe<Array<EquipmentTypeLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentTypeLinksOrderBy>>;
  where?: InputMaybe<EquipmentTypeLinksBoolExp>;
};


export type Subscription_RootEquipmentTypeLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<EquipmentTypeLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentTypeLinksOrderBy>>;
  where?: InputMaybe<EquipmentTypeLinksBoolExp>;
};


export type Subscription_RootEquipmentTypeLinksByPkArgs = {
  equipmentTypeLinkGuid: Scalars['uuid'];
};


export type Subscription_RootEquipmentTypeLinksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EquipmentTypeLinksStreamCursorInput>>;
  where?: InputMaybe<EquipmentTypeLinksBoolExp>;
};


export type Subscription_RootEquipmentTypesArgs = {
  distinctOn?: InputMaybe<Array<EquipmentTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentTypesOrderBy>>;
  where?: InputMaybe<EquipmentTypesBoolExp>;
};


export type Subscription_RootEquipmentTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EquipmentTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EquipmentTypesOrderBy>>;
  where?: InputMaybe<EquipmentTypesBoolExp>;
};


export type Subscription_RootEquipmentTypesByPkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEquipmentTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EquipmentTypesStreamCursorInput>>;
  where?: InputMaybe<EquipmentTypesBoolExp>;
};


export type Subscription_RootEstimateInvoicesArgs = {
  distinctOn?: InputMaybe<Array<EstimateInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateInvoicesOrderBy>>;
  where?: InputMaybe<EstimateInvoicesBoolExp>;
};


export type Subscription_RootEstimateInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateInvoicesOrderBy>>;
  where?: InputMaybe<EstimateInvoicesBoolExp>;
};


export type Subscription_RootEstimateInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Subscription_RootEstimateInvoicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EstimateInvoicesStreamCursorInput>>;
  where?: InputMaybe<EstimateInvoicesBoolExp>;
};


export type Subscription_RootEstimateOptionCartItemsArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionCartItemsOrderBy>>;
  where?: InputMaybe<EstimateOptionCartItemsBoolExp>;
};


export type Subscription_RootEstimateOptionCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionCartItemsOrderBy>>;
  where?: InputMaybe<EstimateOptionCartItemsBoolExp>;
};


export type Subscription_RootEstimateOptionCartItemsByPkArgs = {
  cartItemGuid: Scalars['uuid'];
};


export type Subscription_RootEstimateOptionCartItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EstimateOptionCartItemsStreamCursorInput>>;
  where?: InputMaybe<EstimateOptionCartItemsBoolExp>;
};


export type Subscription_RootEstimateOptionDiscountsArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionDiscountsOrderBy>>;
  where?: InputMaybe<EstimateOptionDiscountsBoolExp>;
};


export type Subscription_RootEstimateOptionDiscountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionDiscountsOrderBy>>;
  where?: InputMaybe<EstimateOptionDiscountsBoolExp>;
};


export type Subscription_RootEstimateOptionDiscountsByPkArgs = {
  estimateOptionDiscountGuid: Scalars['uuid'];
};


export type Subscription_RootEstimateOptionDiscountsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EstimateOptionDiscountsStreamCursorInput>>;
  where?: InputMaybe<EstimateOptionDiscountsBoolExp>;
};


export type Subscription_RootEstimateOptionTaxConfigurationsViewArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionTaxConfigurationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionTaxConfigurationsViewOrderBy>>;
  where?: InputMaybe<EstimateOptionTaxConfigurationsViewBoolExp>;
};


export type Subscription_RootEstimateOptionTaxConfigurationsViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionTaxConfigurationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionTaxConfigurationsViewOrderBy>>;
  where?: InputMaybe<EstimateOptionTaxConfigurationsViewBoolExp>;
};


export type Subscription_RootEstimateOptionTaxConfigurationsViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EstimateOptionTaxConfigurationsViewStreamCursorInput>>;
  where?: InputMaybe<EstimateOptionTaxConfigurationsViewBoolExp>;
};


export type Subscription_RootEstimateOptionsArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionsOrderBy>>;
  where?: InputMaybe<EstimateOptionsBoolExp>;
};


export type Subscription_RootEstimateOptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateOptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateOptionsOrderBy>>;
  where?: InputMaybe<EstimateOptionsBoolExp>;
};


export type Subscription_RootEstimateOptionsByPkArgs = {
  estimateOptionGuid: Scalars['uuid'];
};


export type Subscription_RootEstimateOptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EstimateOptionsStreamCursorInput>>;
  where?: InputMaybe<EstimateOptionsBoolExp>;
};


export type Subscription_RootEstimatePhotosArgs = {
  distinctOn?: InputMaybe<Array<EstimatePhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatePhotosOrderBy>>;
  where?: InputMaybe<EstimatePhotosBoolExp>;
};


export type Subscription_RootEstimatePhotosAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimatePhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatePhotosOrderBy>>;
  where?: InputMaybe<EstimatePhotosBoolExp>;
};


export type Subscription_RootEstimatePhotosByPkArgs = {
  estimateGuid: Scalars['uuid'];
  photoGuid: Scalars['uuid'];
};


export type Subscription_RootEstimatePhotosStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EstimatePhotosStreamCursorInput>>;
  where?: InputMaybe<EstimatePhotosBoolExp>;
};


export type Subscription_RootEstimateTemplatesArgs = {
  distinctOn?: InputMaybe<Array<EstimateTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateTemplatesOrderBy>>;
  where?: InputMaybe<EstimateTemplatesBoolExp>;
};


export type Subscription_RootEstimateTemplatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimateTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimateTemplatesOrderBy>>;
  where?: InputMaybe<EstimateTemplatesBoolExp>;
};


export type Subscription_RootEstimateTemplatesByPkArgs = {
  estimateTemplateGuid: Scalars['uuid'];
};


export type Subscription_RootEstimateTemplatesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EstimateTemplatesStreamCursorInput>>;
  where?: InputMaybe<EstimateTemplatesBoolExp>;
};


export type Subscription_RootEstimatesArgs = {
  distinctOn?: InputMaybe<Array<EstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesOrderBy>>;
  where?: InputMaybe<EstimatesBoolExp>;
};


export type Subscription_RootEstimatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesOrderBy>>;
  where?: InputMaybe<EstimatesBoolExp>;
};


export type Subscription_RootEstimatesByPkArgs = {
  estimateGuid: Scalars['uuid'];
};


export type Subscription_RootEstimatesQueryableArgs = {
  distinctOn?: InputMaybe<Array<EstimatesQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesQueryableOrderBy>>;
  where?: InputMaybe<EstimatesQueryableBoolExp>;
};


export type Subscription_RootEstimatesQueryableAggregateArgs = {
  distinctOn?: InputMaybe<Array<EstimatesQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EstimatesQueryableOrderBy>>;
  where?: InputMaybe<EstimatesQueryableBoolExp>;
};


export type Subscription_RootEstimatesQueryableByPkArgs = {
  estimateGuid: Scalars['uuid'];
};


export type Subscription_RootEstimatesQueryableStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EstimatesQueryableStreamCursorInput>>;
  where?: InputMaybe<EstimatesQueryableBoolExp>;
};


export type Subscription_RootEstimatesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EstimatesStreamCursorInput>>;
  where?: InputMaybe<EstimatesBoolExp>;
};


export type Subscription_RootEventStoreArgs = {
  distinctOn?: InputMaybe<Array<EventStoreSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventStoreOrderBy>>;
  where?: InputMaybe<EventStoreBoolExp>;
};


export type Subscription_RootEventStoreAggregateArgs = {
  distinctOn?: InputMaybe<Array<EventStoreSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EventStoreOrderBy>>;
  where?: InputMaybe<EventStoreBoolExp>;
};


export type Subscription_RootEventStoreByPkArgs = {
  entityGuid: Scalars['uuid'];
  entityType: Scalars['String'];
  entityVersion: Scalars['numeric'];
};


export type Subscription_RootEventStoreStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<EventStoreStreamCursorInput>>;
  where?: InputMaybe<EventStoreBoolExp>;
};


export type Subscription_RootFavoritePricebookItemsArgs = {
  distinctOn?: InputMaybe<Array<FavoritePricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FavoritePricebookItemsOrderBy>>;
  where?: InputMaybe<FavoritePricebookItemsBoolExp>;
};


export type Subscription_RootFavoritePricebookItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<FavoritePricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FavoritePricebookItemsOrderBy>>;
  where?: InputMaybe<FavoritePricebookItemsBoolExp>;
};


export type Subscription_RootFavoritePricebookItemsByPkArgs = {
  pricebookItemGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


export type Subscription_RootFavoritePricebookItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FavoritePricebookItemsStreamCursorInput>>;
  where?: InputMaybe<FavoritePricebookItemsBoolExp>;
};


export type Subscription_RootFileLinksArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


export type Subscription_RootFileLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<FileLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileLinksOrderBy>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


export type Subscription_RootFileLinksByPkArgs = {
  fileGuid: Scalars['uuid'];
};


export type Subscription_RootFileLinksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FileLinksStreamCursorInput>>;
  where?: InputMaybe<FileLinksBoolExp>;
};


export type Subscription_RootFilesArgs = {
  distinctOn?: InputMaybe<Array<FilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
  where?: InputMaybe<FilesBoolExp>;
};


export type Subscription_RootFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<FilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
  where?: InputMaybe<FilesBoolExp>;
};


export type Subscription_RootFilesByPkArgs = {
  fileGuid: Scalars['uuid'];
};


export type Subscription_RootFilesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<FilesStreamCursorInput>>;
  where?: InputMaybe<FilesBoolExp>;
};


export type Subscription_RootInstalledEquipmentArgs = {
  distinctOn?: InputMaybe<Array<InstalledEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledEquipmentOrderBy>>;
  where?: InputMaybe<InstalledEquipmentBoolExp>;
};


export type Subscription_RootInstalledEquipmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstalledEquipmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledEquipmentOrderBy>>;
  where?: InputMaybe<InstalledEquipmentBoolExp>;
};


export type Subscription_RootInstalledEquipmentByPkArgs = {
  installedEquipmentGuid: Scalars['uuid'];
};


export type Subscription_RootInstalledEquipmentStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InstalledEquipmentStreamCursorInput>>;
  where?: InputMaybe<InstalledEquipmentBoolExp>;
};


export type Subscription_RootInstalledHvacSystemsArgs = {
  distinctOn?: InputMaybe<Array<InstalledHvacSystemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledHvacSystemsOrderBy>>;
  where?: InputMaybe<InstalledHvacSystemsBoolExp>;
};


export type Subscription_RootInstalledHvacSystemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstalledHvacSystemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstalledHvacSystemsOrderBy>>;
  where?: InputMaybe<InstalledHvacSystemsBoolExp>;
};


export type Subscription_RootInstalledHvacSystemsByPkArgs = {
  installedHvacSystemGuid: Scalars['uuid'];
};


export type Subscription_RootInstalledHvacSystemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InstalledHvacSystemsStreamCursorInput>>;
  where?: InputMaybe<InstalledHvacSystemsBoolExp>;
};


export type Subscription_RootInstantBookingWeeklyScheduleEntriesArgs = {
  distinctOn?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesOrderBy>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
};


export type Subscription_RootInstantBookingWeeklyScheduleEntriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstantBookingWeeklyScheduleEntriesOrderBy>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
};


export type Subscription_RootInstantBookingWeeklyScheduleEntriesByPkArgs = {
  instantBookingWeeklyScheduleEntryGuid: Scalars['uuid'];
};


export type Subscription_RootInstantBookingWeeklyScheduleEntriesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InstantBookingWeeklyScheduleEntriesStreamCursorInput>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntriesBoolExp>;
};


export type Subscription_RootInstantBookingWeeklyScheduleEntryBookableArrivalWindowsArgs = {
  distinctOn?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsOrderBy>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>;
};


export type Subscription_RootInstantBookingWeeklyScheduleEntryBookableArrivalWindowsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsOrderBy>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>;
};


export type Subscription_RootInstantBookingWeeklyScheduleEntryBookableArrivalWindowsByPkArgs = {
  companyAppointmentArrivalWindowGuid: Scalars['uuid'];
  instantBookingWeeklyScheduleEntryGuid: Scalars['uuid'];
};


export type Subscription_RootInstantBookingWeeklyScheduleEntryBookableArrivalWindowsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsStreamCursorInput>>;
  where?: InputMaybe<InstantBookingWeeklyScheduleEntryBookableArrivalWindowsBoolExp>;
};


export type Subscription_RootIntegratedChannelCompletableItemsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelCompletableItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelCompletableItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelCompletableItemsBoolExp>;
};


export type Subscription_RootIntegratedChannelCompletableItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelCompletableItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelCompletableItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelCompletableItemsBoolExp>;
};


export type Subscription_RootIntegratedChannelCompletableItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedChannelCompletableItemsStreamCursorInput>>;
  where?: InputMaybe<IntegratedChannelCompletableItemsBoolExp>;
};


export type Subscription_RootIntegratedChannelItemsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelItemsBoolExp>;
};


export type Subscription_RootIntegratedChannelItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelItemsBoolExp>;
};


export type Subscription_RootIntegratedChannelItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedChannelItemsStreamCursorInput>>;
  where?: InputMaybe<IntegratedChannelItemsBoolExp>;
};


export type Subscription_RootIntegratedChannelReadableItemsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelReadableItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelReadableItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelReadableItemsBoolExp>;
};


export type Subscription_RootIntegratedChannelReadableItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelReadableItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelReadableItemsOrderBy>>;
  where?: InputMaybe<IntegratedChannelReadableItemsBoolExp>;
};


export type Subscription_RootIntegratedChannelReadableItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedChannelReadableItemsStreamCursorInput>>;
  where?: InputMaybe<IntegratedChannelReadableItemsBoolExp>;
};


export type Subscription_RootIntegratedChannelsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelsOrderBy>>;
  where?: InputMaybe<IntegratedChannelsBoolExp>;
};


export type Subscription_RootIntegratedChannelsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedChannelsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedChannelsOrderBy>>;
  where?: InputMaybe<IntegratedChannelsBoolExp>;
};


export type Subscription_RootIntegratedChannelsByPkArgs = {
  integratedChannelGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedChannelsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedChannelsStreamCursorInput>>;
  where?: InputMaybe<IntegratedChannelsBoolExp>;
};


export type Subscription_RootIntegratedMessageStatusesArgs = {
  distinctOn?: InputMaybe<Array<IntegratedMessageStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedMessageStatusesOrderBy>>;
  where?: InputMaybe<IntegratedMessageStatusesBoolExp>;
};


export type Subscription_RootIntegratedMessageStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedMessageStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedMessageStatusesOrderBy>>;
  where?: InputMaybe<IntegratedMessageStatusesBoolExp>;
};


export type Subscription_RootIntegratedMessageStatusesByPkArgs = {
  integratedMessageStatusGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedMessageStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedMessageStatusesStreamCursorInput>>;
  where?: InputMaybe<IntegratedMessageStatusesBoolExp>;
};


export type Subscription_RootIntegratedMessageTwilioRawWebhookEventsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedMessageTwilioRawWebhookEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedMessageTwilioRawWebhookEventsOrderBy>>;
  where?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsBoolExp>;
};


export type Subscription_RootIntegratedMessageTwilioRawWebhookEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedMessageTwilioRawWebhookEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedMessageTwilioRawWebhookEventsOrderBy>>;
  where?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsBoolExp>;
};


export type Subscription_RootIntegratedMessageTwilioRawWebhookEventsByPkArgs = {
  integratedMessageTwilioRawWebhookEventGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedMessageTwilioRawWebhookEventsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedMessageTwilioRawWebhookEventsStreamCursorInput>>;
  where?: InputMaybe<IntegratedMessageTwilioRawWebhookEventsBoolExp>;
};


export type Subscription_RootIntegratedMessagesArgs = {
  distinctOn?: InputMaybe<Array<IntegratedMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedMessagesOrderBy>>;
  where?: InputMaybe<IntegratedMessagesBoolExp>;
};


export type Subscription_RootIntegratedMessagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedMessagesOrderBy>>;
  where?: InputMaybe<IntegratedMessagesBoolExp>;
};


export type Subscription_RootIntegratedMessagesByPkArgs = {
  integratedMessageGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedMessagesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedMessagesStreamCursorInput>>;
  where?: InputMaybe<IntegratedMessagesBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallDismissalsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallDismissalsBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallDismissalsBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallDismissalsByPkArgs = {
  integratedPhoneCallDismissalGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhoneCallDismissalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneCallDismissalsStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneCallDismissalsBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallJobsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallJobsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallJobsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallJobsByPkArgs = {
  integratedPhoneCallGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhoneCallJobsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneCallJobsStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneCallJobsBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallRecordingArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallRecordingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallRecordingOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallRecordingBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallRecordingAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallRecordingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallRecordingOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallRecordingBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallRecordingByPkArgs = {
  integratedPhoneCallRecordingGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhoneCallRecordingStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneCallRecordingStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneCallRecordingBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallStatusTypesArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallStatusTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallStatusTypesOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallStatusTypesBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallStatusTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallStatusTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallStatusTypesOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallStatusTypesBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallStatusTypesByPkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootIntegratedPhoneCallStatusTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneCallStatusTypesStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneCallStatusTypesBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallStatusesArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallStatusesOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallStatusesBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallStatusesOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallStatusesBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallStatusesByPkArgs = {
  integratedPhoneCallStatusGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhoneCallStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneCallStatusesStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneCallStatusesBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallsBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCallsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCallsBoolExp>;
};


export type Subscription_RootIntegratedPhoneCallsByPkArgs = {
  integratedPhoneCallGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhoneCallsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneCallsStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneCallsBoolExp>;
};


export type Subscription_RootIntegratedPhoneCompanyConfigArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCompanyConfigOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCompanyConfigBoolExp>;
};


export type Subscription_RootIntegratedPhoneCompanyConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneCompanyConfigOrderBy>>;
  where?: InputMaybe<IntegratedPhoneCompanyConfigBoolExp>;
};


export type Subscription_RootIntegratedPhoneCompanyConfigByPkArgs = {
  integratedPhoneCompanyConfigGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhoneCompanyConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneCompanyConfigStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneCompanyConfigBoolExp>;
};


export type Subscription_RootIntegratedPhoneMissedCallDismissalsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneMissedCallDismissalsBoolExp>;
};


export type Subscription_RootIntegratedPhoneMissedCallDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneMissedCallDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneMissedCallDismissalsBoolExp>;
};


export type Subscription_RootIntegratedPhoneMissedCallDismissalsByPkArgs = {
  integratedPhoneMissedCallDismissal: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhoneMissedCallDismissalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneMissedCallDismissalsStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneMissedCallDismissalsBoolExp>;
};


export type Subscription_RootIntegratedPhoneMissedCallsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneMissedCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneMissedCallsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
};


export type Subscription_RootIntegratedPhoneMissedCallsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneMissedCallsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneMissedCallsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
};


export type Subscription_RootIntegratedPhoneMissedCallsByPkArgs = {
  integratedPhoneMissedCallGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhoneMissedCallsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneMissedCallsStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneMissedCallsBoolExp>;
};


export type Subscription_RootIntegratedPhoneTwilioRawWebhookEventsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneTwilioRawWebhookEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneTwilioRawWebhookEventsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsBoolExp>;
};


export type Subscription_RootIntegratedPhoneTwilioRawWebhookEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneTwilioRawWebhookEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneTwilioRawWebhookEventsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsBoolExp>;
};


export type Subscription_RootIntegratedPhoneTwilioRawWebhookEventsByPkArgs = {
  integratedPhoneTwilioRawWebhookEventGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhoneTwilioRawWebhookEventsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneTwilioRawWebhookEventsStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneTwilioRawWebhookEventsBoolExp>;
};


export type Subscription_RootIntegratedPhoneUsersArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneUsersOrderBy>>;
  where?: InputMaybe<IntegratedPhoneUsersBoolExp>;
};


export type Subscription_RootIntegratedPhoneUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneUsersOrderBy>>;
  where?: InputMaybe<IntegratedPhoneUsersBoolExp>;
};


export type Subscription_RootIntegratedPhoneUsersByPkArgs = {
  integratedPhoneUserGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhoneUsersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneUsersStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneUsersBoolExp>;
};


export type Subscription_RootIntegratedPhoneVoicemailDismissalsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneVoicemailDismissalsBoolExp>;
};


export type Subscription_RootIntegratedPhoneVoicemailDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneVoicemailDismissalsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneVoicemailDismissalsBoolExp>;
};


export type Subscription_RootIntegratedPhoneVoicemailDismissalsByPkArgs = {
  integratedPhoneVoicemailDismissal: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhoneVoicemailDismissalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneVoicemailDismissalsStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneVoicemailDismissalsBoolExp>;
};


export type Subscription_RootIntegratedPhoneVoicemailsArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneVoicemailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneVoicemailsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneVoicemailsBoolExp>;
};


export type Subscription_RootIntegratedPhoneVoicemailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhoneVoicemailsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhoneVoicemailsOrderBy>>;
  where?: InputMaybe<IntegratedPhoneVoicemailsBoolExp>;
};


export type Subscription_RootIntegratedPhoneVoicemailsByPkArgs = {
  integratedPhoneVoicemailGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhoneVoicemailsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhoneVoicemailsStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhoneVoicemailsBoolExp>;
};


export type Subscription_RootIntegratedPhonesArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhonesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhonesOrderBy>>;
  where?: InputMaybe<IntegratedPhonesBoolExp>;
};


export type Subscription_RootIntegratedPhonesAggregateArgs = {
  distinctOn?: InputMaybe<Array<IntegratedPhonesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<IntegratedPhonesOrderBy>>;
  where?: InputMaybe<IntegratedPhonesBoolExp>;
};


export type Subscription_RootIntegratedPhonesByPkArgs = {
  integratedPhoneGuid: Scalars['uuid'];
};


export type Subscription_RootIntegratedPhonesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<IntegratedPhonesStreamCursorInput>>;
  where?: InputMaybe<IntegratedPhonesBoolExp>;
};


export type Subscription_RootInternalNotificationsArgs = {
  distinctOn?: InputMaybe<Array<InternalNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InternalNotificationsOrderBy>>;
  where?: InputMaybe<InternalNotificationsBoolExp>;
};


export type Subscription_RootInternalNotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InternalNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InternalNotificationsOrderBy>>;
  where?: InputMaybe<InternalNotificationsBoolExp>;
};


export type Subscription_RootInternalNotificationsByPkArgs = {
  internalNotificationGuid: Scalars['uuid'];
};


export type Subscription_RootInternalNotificationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InternalNotificationsStreamCursorInput>>;
  where?: InputMaybe<InternalNotificationsBoolExp>;
};


export type Subscription_RootInvoiceBusinessUnitArgs = {
  distinctOn?: InputMaybe<Array<InvoiceBusinessUnitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceBusinessUnitOrderBy>>;
  where?: InputMaybe<InvoiceBusinessUnitBoolExp>;
};


export type Subscription_RootInvoiceBusinessUnitAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceBusinessUnitSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceBusinessUnitOrderBy>>;
  where?: InputMaybe<InvoiceBusinessUnitBoolExp>;
};


export type Subscription_RootInvoiceBusinessUnitStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoiceBusinessUnitStreamCursorInput>>;
  where?: InputMaybe<InvoiceBusinessUnitBoolExp>;
};


export type Subscription_RootInvoiceCartItemBundleItemsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemBundleItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemBundleItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemBundleItemsBoolExp>;
};


export type Subscription_RootInvoiceCartItemBundleItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemBundleItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemBundleItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemBundleItemsBoolExp>;
};


export type Subscription_RootInvoiceCartItemBundleItemsByPkArgs = {
  invoiceCartItemBundleItemGuid: Scalars['uuid'];
};


export type Subscription_RootInvoiceCartItemBundleItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoiceCartItemBundleItemsStreamCursorInput>>;
  where?: InputMaybe<InvoiceCartItemBundleItemsBoolExp>;
};


export type Subscription_RootInvoiceCartItemBundleJobCostLinksArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemBundleJobCostLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemBundleJobCostLinksOrderBy>>;
  where?: InputMaybe<InvoiceCartItemBundleJobCostLinksBoolExp>;
};


export type Subscription_RootInvoiceCartItemBundleJobCostLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemBundleJobCostLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemBundleJobCostLinksOrderBy>>;
  where?: InputMaybe<InvoiceCartItemBundleJobCostLinksBoolExp>;
};


export type Subscription_RootInvoiceCartItemBundleJobCostLinksByPkArgs = {
  invoiceCartItemBundleItemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
};


export type Subscription_RootInvoiceCartItemBundleJobCostLinksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoiceCartItemBundleJobCostLinksStreamCursorInput>>;
  where?: InputMaybe<InvoiceCartItemBundleJobCostLinksBoolExp>;
};


export type Subscription_RootInvoiceCartItemsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemsBoolExp>;
};


export type Subscription_RootInvoiceCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceCartItemsBoolExp>;
};


export type Subscription_RootInvoiceCartItemsByPkArgs = {
  cartItemGuid: Scalars['uuid'];
  invoiceGuid: Scalars['uuid'];
};


export type Subscription_RootInvoiceCartItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoiceCartItemsStreamCursorInput>>;
  where?: InputMaybe<InvoiceCartItemsBoolExp>;
};


export type Subscription_RootInvoiceCompanyTaxConfigurationsViewArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCompanyTaxConfigurationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCompanyTaxConfigurationsViewOrderBy>>;
  where?: InputMaybe<InvoiceCompanyTaxConfigurationsViewBoolExp>;
};


export type Subscription_RootInvoiceCompanyTaxConfigurationsViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceCompanyTaxConfigurationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceCompanyTaxConfigurationsViewOrderBy>>;
  where?: InputMaybe<InvoiceCompanyTaxConfigurationsViewBoolExp>;
};


export type Subscription_RootInvoiceCompanyTaxConfigurationsViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoiceCompanyTaxConfigurationsViewStreamCursorInput>>;
  where?: InputMaybe<InvoiceCompanyTaxConfigurationsViewBoolExp>;
};


export type Subscription_RootInvoiceDiscountsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceDiscountsOrderBy>>;
  where?: InputMaybe<InvoiceDiscountsBoolExp>;
};


export type Subscription_RootInvoiceDiscountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceDiscountsOrderBy>>;
  where?: InputMaybe<InvoiceDiscountsBoolExp>;
};


export type Subscription_RootInvoiceDiscountsByPkArgs = {
  invoiceDiscountGuid: Scalars['uuid'];
};


export type Subscription_RootInvoiceDiscountsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoiceDiscountsStreamCursorInput>>;
  where?: InputMaybe<InvoiceDiscountsBoolExp>;
};


export type Subscription_RootInvoiceEventsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceEventsOrderBy>>;
  where?: InputMaybe<InvoiceEventsBoolExp>;
};


export type Subscription_RootInvoiceEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceEventsOrderBy>>;
  where?: InputMaybe<InvoiceEventsBoolExp>;
};


export type Subscription_RootInvoiceEventsByPkArgs = {
  invoiceEventGuid: Scalars['uuid'];
};


export type Subscription_RootInvoiceEventsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoiceEventsStreamCursorInput>>;
  where?: InputMaybe<InvoiceEventsBoolExp>;
};


export type Subscription_RootInvoicePaymentsArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


export type Subscription_RootInvoicePaymentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicePaymentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicePaymentsOrderBy>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


export type Subscription_RootInvoicePaymentsByPkArgs = {
  invoiceGuid: Scalars['uuid'];
  paymentRecordGuid: Scalars['uuid'];
};


export type Subscription_RootInvoicePaymentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoicePaymentsStreamCursorInput>>;
  where?: InputMaybe<InvoicePaymentsBoolExp>;
};


export type Subscription_RootInvoiceReminderDataArgs = {
  distinctOn?: InputMaybe<Array<InvoiceReminderDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceReminderDataOrderBy>>;
  where?: InputMaybe<InvoiceReminderDataBoolExp>;
};


export type Subscription_RootInvoiceReminderDataAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceReminderDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceReminderDataOrderBy>>;
  where?: InputMaybe<InvoiceReminderDataBoolExp>;
};


export type Subscription_RootInvoiceReminderDataByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Subscription_RootInvoiceReminderDataStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoiceReminderDataStreamCursorInput>>;
  where?: InputMaybe<InvoiceReminderDataBoolExp>;
};


export type Subscription_RootInvoiceTemplateCartItemsArgs = {
  distinctOn?: InputMaybe<Array<InvoiceTemplateCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceTemplateCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
};


export type Subscription_RootInvoiceTemplateCartItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceTemplateCartItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceTemplateCartItemsOrderBy>>;
  where?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
};


export type Subscription_RootInvoiceTemplateCartItemsByPkArgs = {
  cartItemGuid: Scalars['uuid'];
  invoiceTemplateGuid: Scalars['uuid'];
};


export type Subscription_RootInvoiceTemplateCartItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoiceTemplateCartItemsStreamCursorInput>>;
  where?: InputMaybe<InvoiceTemplateCartItemsBoolExp>;
};


export type Subscription_RootInvoiceTemplatesArgs = {
  distinctOn?: InputMaybe<Array<InvoiceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceTemplatesOrderBy>>;
  where?: InputMaybe<InvoiceTemplatesBoolExp>;
};


export type Subscription_RootInvoiceTemplatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoiceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoiceTemplatesOrderBy>>;
  where?: InputMaybe<InvoiceTemplatesBoolExp>;
};


export type Subscription_RootInvoiceTemplatesByPkArgs = {
  invoiceTemplateGuid: Scalars['uuid'];
};


export type Subscription_RootInvoiceTemplatesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoiceTemplatesStreamCursorInput>>;
  where?: InputMaybe<InvoiceTemplatesBoolExp>;
};


export type Subscription_RootInvoicesArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Subscription_RootInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Subscription_RootInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Subscription_RootInvoicesQboStatusArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQboStatusOrderBy>>;
  where?: InputMaybe<InvoicesQboStatusBoolExp>;
};


export type Subscription_RootInvoicesQboStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQboStatusOrderBy>>;
  where?: InputMaybe<InvoicesQboStatusBoolExp>;
};


export type Subscription_RootInvoicesQboStatusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoicesQboStatusStreamCursorInput>>;
  where?: InputMaybe<InvoicesQboStatusBoolExp>;
};


export type Subscription_RootInvoicesQueryableArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQueryableOrderBy>>;
  where?: InputMaybe<InvoicesQueryableBoolExp>;
};


export type Subscription_RootInvoicesQueryableAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQueryableOrderBy>>;
  where?: InputMaybe<InvoicesQueryableBoolExp>;
};


export type Subscription_RootInvoicesQueryableByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Subscription_RootInvoicesQueryableStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoicesQueryableStreamCursorInput>>;
  where?: InputMaybe<InvoicesQueryableBoolExp>;
};


export type Subscription_RootInvoicesQueryableWithQboStatusArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQueryableWithQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQueryableWithQboStatusOrderBy>>;
  where?: InputMaybe<InvoicesQueryableWithQboStatusBoolExp>;
};


export type Subscription_RootInvoicesQueryableWithQboStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesQueryableWithQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesQueryableWithQboStatusOrderBy>>;
  where?: InputMaybe<InvoicesQueryableWithQboStatusBoolExp>;
};


export type Subscription_RootInvoicesQueryableWithQboStatusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoicesQueryableWithQboStatusStreamCursorInput>>;
  where?: InputMaybe<InvoicesQueryableWithQboStatusBoolExp>;
};


export type Subscription_RootInvoicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoicesStreamCursorInput>>;
  where?: InputMaybe<InvoicesBoolExp>;
};


export type Subscription_RootInvoicesV2AccountingStaleArgs = {
  distinctOn?: InputMaybe<Array<InvoicesV2AccountingStaleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesV2AccountingStaleOrderBy>>;
  where?: InputMaybe<InvoicesV2AccountingStaleBoolExp>;
};


export type Subscription_RootInvoicesV2AccountingStaleAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesV2AccountingStaleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesV2AccountingStaleOrderBy>>;
  where?: InputMaybe<InvoicesV2AccountingStaleBoolExp>;
};


export type Subscription_RootInvoicesV2AccountingStaleStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoicesV2AccountingStaleStreamCursorInput>>;
  where?: InputMaybe<InvoicesV2AccountingStaleBoolExp>;
};


export type Subscription_RootInvoicesV2QboStaleArgs = {
  distinctOn?: InputMaybe<Array<InvoicesV2QboStaleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesV2QboStaleOrderBy>>;
  where?: InputMaybe<InvoicesV2QboStaleBoolExp>;
};


export type Subscription_RootInvoicesV2QboStaleAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesV2QboStaleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesV2QboStaleOrderBy>>;
  where?: InputMaybe<InvoicesV2QboStaleBoolExp>;
};


export type Subscription_RootInvoicesV2QboStaleStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoicesV2QboStaleStreamCursorInput>>;
  where?: InputMaybe<InvoicesV2QboStaleBoolExp>;
};


export type Subscription_RootInvoicesV2QboStatusArgs = {
  distinctOn?: InputMaybe<Array<InvoicesV2QboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesV2QboStatusOrderBy>>;
  where?: InputMaybe<InvoicesV2QboStatusBoolExp>;
};


export type Subscription_RootInvoicesV2QboStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<InvoicesV2QboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InvoicesV2QboStatusOrderBy>>;
  where?: InputMaybe<InvoicesV2QboStatusBoolExp>;
};


export type Subscription_RootInvoicesV2QboStatusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<InvoicesV2QboStatusStreamCursorInput>>;
  where?: InputMaybe<InvoicesV2QboStatusBoolExp>;
};


export type Subscription_RootJobAppointmentAssignmentStatusTypesArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentStatusTypesBoolExp>;
};


export type Subscription_RootJobAppointmentAssignmentStatusTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentStatusTypesOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentStatusTypesBoolExp>;
};


export type Subscription_RootJobAppointmentAssignmentStatusTypesByPkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootJobAppointmentAssignmentStatusTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobAppointmentAssignmentStatusTypesStreamCursorInput>>;
  where?: InputMaybe<JobAppointmentAssignmentStatusTypesBoolExp>;
};


export type Subscription_RootJobAppointmentAssignmentStatusesArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentStatusesOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentStatusesBoolExp>;
};


export type Subscription_RootJobAppointmentAssignmentStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentStatusesOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentStatusesBoolExp>;
};


export type Subscription_RootJobAppointmentAssignmentStatusesByPkArgs = {
  jobAppointmentAssignmentStatusGuid: Scalars['uuid'];
};


export type Subscription_RootJobAppointmentAssignmentStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobAppointmentAssignmentStatusesStreamCursorInput>>;
  where?: InputMaybe<JobAppointmentAssignmentStatusesBoolExp>;
};


export type Subscription_RootJobAppointmentAssignmentsArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
};


export type Subscription_RootJobAppointmentAssignmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentAssignmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
};


export type Subscription_RootJobAppointmentAssignmentsByPkArgs = {
  jobAppointmentAssignmentGuid: Scalars['uuid'];
};


export type Subscription_RootJobAppointmentAssignmentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobAppointmentAssignmentsStreamCursorInput>>;
  where?: InputMaybe<JobAppointmentAssignmentsBoolExp>;
};


export type Subscription_RootJobAppointmentCancellationStatusesArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentCancellationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentCancellationStatusesOrderBy>>;
  where?: InputMaybe<JobAppointmentCancellationStatusesBoolExp>;
};


export type Subscription_RootJobAppointmentCancellationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentCancellationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentCancellationStatusesOrderBy>>;
  where?: InputMaybe<JobAppointmentCancellationStatusesBoolExp>;
};


export type Subscription_RootJobAppointmentCancellationStatusesByPkArgs = {
  jobAppointmentGuid: Scalars['uuid'];
};


export type Subscription_RootJobAppointmentCancellationStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobAppointmentCancellationStatusesStreamCursorInput>>;
  where?: InputMaybe<JobAppointmentCancellationStatusesBoolExp>;
};


export type Subscription_RootJobAppointmentConfirmationStatusesArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentConfirmationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentConfirmationStatusesOrderBy>>;
  where?: InputMaybe<JobAppointmentConfirmationStatusesBoolExp>;
};


export type Subscription_RootJobAppointmentConfirmationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentConfirmationStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentConfirmationStatusesOrderBy>>;
  where?: InputMaybe<JobAppointmentConfirmationStatusesBoolExp>;
};


export type Subscription_RootJobAppointmentConfirmationStatusesByPkArgs = {
  jobAppointmentGuid: Scalars['uuid'];
};


export type Subscription_RootJobAppointmentConfirmationStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobAppointmentConfirmationStatusesStreamCursorInput>>;
  where?: InputMaybe<JobAppointmentConfirmationStatusesBoolExp>;
};


export type Subscription_RootJobAppointmentInvoicesArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentInvoicesOrderBy>>;
  where?: InputMaybe<JobAppointmentInvoicesBoolExp>;
};


export type Subscription_RootJobAppointmentInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentInvoicesOrderBy>>;
  where?: InputMaybe<JobAppointmentInvoicesBoolExp>;
};


export type Subscription_RootJobAppointmentInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Subscription_RootJobAppointmentInvoicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobAppointmentInvoicesStreamCursorInput>>;
  where?: InputMaybe<JobAppointmentInvoicesBoolExp>;
};


export type Subscription_RootJobAppointmentsArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentsBoolExp>;
};


export type Subscription_RootJobAppointmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobAppointmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobAppointmentsOrderBy>>;
  where?: InputMaybe<JobAppointmentsBoolExp>;
};


export type Subscription_RootJobAppointmentsByPkArgs = {
  jobAppointmentGuid: Scalars['uuid'];
};


export type Subscription_RootJobAppointmentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobAppointmentsStreamCursorInput>>;
  where?: InputMaybe<JobAppointmentsBoolExp>;
};


export type Subscription_RootJobCostItemsArgs = {
  distinctOn?: InputMaybe<Array<JobCostItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostItemsOrderBy>>;
  where?: InputMaybe<JobCostItemsBoolExp>;
};


export type Subscription_RootJobCostItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobCostItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostItemsOrderBy>>;
  where?: InputMaybe<JobCostItemsBoolExp>;
};


export type Subscription_RootJobCostItemsByPkArgs = {
  jobCostItemGuid: Scalars['uuid'];
};


export type Subscription_RootJobCostItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobCostItemsStreamCursorInput>>;
  where?: InputMaybe<JobCostItemsBoolExp>;
};


export type Subscription_RootJobCostMiscCategoriesArgs = {
  distinctOn?: InputMaybe<Array<JobCostMiscCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostMiscCategoriesOrderBy>>;
  where?: InputMaybe<JobCostMiscCategoriesBoolExp>;
};


export type Subscription_RootJobCostMiscCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobCostMiscCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostMiscCategoriesOrderBy>>;
  where?: InputMaybe<JobCostMiscCategoriesBoolExp>;
};


export type Subscription_RootJobCostMiscCategoriesByPkArgs = {
  miscCategoryGuid: Scalars['uuid'];
};


export type Subscription_RootJobCostMiscCategoriesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobCostMiscCategoriesStreamCursorInput>>;
  where?: InputMaybe<JobCostMiscCategoriesBoolExp>;
};


export type Subscription_RootJobCostingConfigArgs = {
  distinctOn?: InputMaybe<Array<JobCostingConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostingConfigOrderBy>>;
  where?: InputMaybe<JobCostingConfigBoolExp>;
};


export type Subscription_RootJobCostingConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobCostingConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostingConfigOrderBy>>;
  where?: InputMaybe<JobCostingConfigBoolExp>;
};


export type Subscription_RootJobCostingConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootJobCostingConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobCostingConfigStreamCursorInput>>;
  where?: InputMaybe<JobCostingConfigBoolExp>;
};


export type Subscription_RootJobCostingRollupViewArgs = {
  distinctOn?: InputMaybe<Array<JobCostingRollupViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostingRollupViewOrderBy>>;
  where?: InputMaybe<JobCostingRollupViewBoolExp>;
};


export type Subscription_RootJobCostingRollupViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobCostingRollupViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobCostingRollupViewOrderBy>>;
  where?: InputMaybe<JobCostingRollupViewBoolExp>;
};


export type Subscription_RootJobCostingRollupViewStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobCostingRollupViewStreamCursorInput>>;
  where?: InputMaybe<JobCostingRollupViewBoolExp>;
};


export type Subscription_RootJobInvoicesArgs = {
  distinctOn?: InputMaybe<Array<JobInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobInvoicesOrderBy>>;
  where?: InputMaybe<JobInvoicesBoolExp>;
};


export type Subscription_RootJobInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobInvoicesOrderBy>>;
  where?: InputMaybe<JobInvoicesBoolExp>;
};


export type Subscription_RootJobInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Subscription_RootJobInvoicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobInvoicesStreamCursorInput>>;
  where?: InputMaybe<JobInvoicesBoolExp>;
};


export type Subscription_RootJobLeadsArgs = {
  distinctOn?: InputMaybe<Array<JobLeadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLeadsOrderBy>>;
  where?: InputMaybe<JobLeadsBoolExp>;
};


export type Subscription_RootJobLeadsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobLeadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLeadsOrderBy>>;
  where?: InputMaybe<JobLeadsBoolExp>;
};


export type Subscription_RootJobLeadsByPkArgs = {
  jobLeadGuid: Scalars['uuid'];
};


export type Subscription_RootJobLeadsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobLeadsStreamCursorInput>>;
  where?: InputMaybe<JobLeadsBoolExp>;
};


export type Subscription_RootJobLifecycleStatusesArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleStatusesOrderBy>>;
  where?: InputMaybe<JobLifecycleStatusesBoolExp>;
};


export type Subscription_RootJobLifecycleStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleStatusesOrderBy>>;
  where?: InputMaybe<JobLifecycleStatusesBoolExp>;
};


export type Subscription_RootJobLifecycleStatusesByPkArgs = {
  jobLifecycleStatusGuid: Scalars['uuid'];
};


export type Subscription_RootJobLifecycleStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobLifecycleStatusesStreamCursorInput>>;
  where?: InputMaybe<JobLifecycleStatusesBoolExp>;
};


export type Subscription_RootJobLifecycleTypesArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleTypesOrderBy>>;
  where?: InputMaybe<JobLifecycleTypesBoolExp>;
};


export type Subscription_RootJobLifecycleTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleTypesOrderBy>>;
  where?: InputMaybe<JobLifecycleTypesBoolExp>;
};


export type Subscription_RootJobLifecycleTypesByPkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootJobLifecycleTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobLifecycleTypesStreamCursorInput>>;
  where?: InputMaybe<JobLifecycleTypesBoolExp>;
};


export type Subscription_RootJobLifecycleViewsArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleViewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleViewsOrderBy>>;
  where?: InputMaybe<JobLifecycleViewsBoolExp>;
};


export type Subscription_RootJobLifecycleViewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobLifecycleViewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecycleViewsOrderBy>>;
  where?: InputMaybe<JobLifecycleViewsBoolExp>;
};


export type Subscription_RootJobLifecycleViewsByPkArgs = {
  jobLifecycleViewGuid: Scalars['uuid'];
};


export type Subscription_RootJobLifecycleViewsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobLifecycleViewsStreamCursorInput>>;
  where?: InputMaybe<JobLifecycleViewsBoolExp>;
};


export type Subscription_RootJobLifecyclesArgs = {
  distinctOn?: InputMaybe<Array<JobLifecyclesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecyclesOrderBy>>;
  where?: InputMaybe<JobLifecyclesBoolExp>;
};


export type Subscription_RootJobLifecyclesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobLifecyclesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobLifecyclesOrderBy>>;
  where?: InputMaybe<JobLifecyclesBoolExp>;
};


export type Subscription_RootJobLifecyclesByPkArgs = {
  jobLifecycleGuid: Scalars['uuid'];
};


export type Subscription_RootJobLifecyclesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobLifecyclesStreamCursorInput>>;
  where?: InputMaybe<JobLifecyclesBoolExp>;
};


export type Subscription_RootJobRequestsCompanyConfigArgs = {
  distinctOn?: InputMaybe<Array<JobRequestsCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobRequestsCompanyConfigOrderBy>>;
  where?: InputMaybe<JobRequestsCompanyConfigBoolExp>;
};


export type Subscription_RootJobRequestsCompanyConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobRequestsCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobRequestsCompanyConfigOrderBy>>;
  where?: InputMaybe<JobRequestsCompanyConfigBoolExp>;
};


export type Subscription_RootJobRequestsCompanyConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootJobRequestsCompanyConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobRequestsCompanyConfigStreamCursorInput>>;
  where?: InputMaybe<JobRequestsCompanyConfigBoolExp>;
};


export type Subscription_RootJobTagsArgs = {
  distinctOn?: InputMaybe<Array<JobTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTagsOrderBy>>;
  where?: InputMaybe<JobTagsBoolExp>;
};


export type Subscription_RootJobTagsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTagsOrderBy>>;
  where?: InputMaybe<JobTagsBoolExp>;
};


export type Subscription_RootJobTagsByPkArgs = {
  jobGuid: Scalars['uuid'];
  tagGuid: Scalars['uuid'];
};


export type Subscription_RootJobTagsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobTagsStreamCursorInput>>;
  where?: InputMaybe<JobTagsBoolExp>;
};


export type Subscription_RootJobTeamMembersArgs = {
  distinctOn?: InputMaybe<Array<JobTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTeamMembersOrderBy>>;
  where?: InputMaybe<JobTeamMembersBoolExp>;
};


export type Subscription_RootJobTeamMembersAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTeamMembersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTeamMembersOrderBy>>;
  where?: InputMaybe<JobTeamMembersBoolExp>;
};


export type Subscription_RootJobTeamMembersByPkArgs = {
  jobGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


export type Subscription_RootJobTeamMembersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobTeamMembersStreamCursorInput>>;
  where?: InputMaybe<JobTeamMembersBoolExp>;
};


export type Subscription_RootJobTechnicianEarnedRevenueAttributionsArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsOrderBy>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueAttributionsBoolExp>;
};


export type Subscription_RootJobTechnicianEarnedRevenueAttributionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianEarnedRevenueAttributionsOrderBy>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueAttributionsBoolExp>;
};


export type Subscription_RootJobTechnicianEarnedRevenueAttributionsByPkArgs = {
  invoiceGuid: Scalars['uuid'];
  itemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  technicianUserGuid: Scalars['uuid'];
};


export type Subscription_RootJobTechnicianEarnedRevenueAttributionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobTechnicianEarnedRevenueAttributionsStreamCursorInput>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueAttributionsBoolExp>;
};


export type Subscription_RootJobTechnicianEarnedRevenueSummariesArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesOrderBy>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueSummariesBoolExp>;
};


export type Subscription_RootJobTechnicianEarnedRevenueSummariesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianEarnedRevenueSummariesOrderBy>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueSummariesBoolExp>;
};


export type Subscription_RootJobTechnicianEarnedRevenueSummariesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobTechnicianEarnedRevenueSummariesStreamCursorInput>>;
  where?: InputMaybe<JobTechnicianEarnedRevenueSummariesBoolExp>;
};


export type Subscription_RootJobTechnicianSalesCommissionAndBonusArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusOrderBy>>;
  where?: InputMaybe<JobTechnicianSalesCommissionAndBonusBoolExp>;
};


export type Subscription_RootJobTechnicianSalesCommissionAndBonusAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSalesCommissionAndBonusOrderBy>>;
  where?: InputMaybe<JobTechnicianSalesCommissionAndBonusBoolExp>;
};


export type Subscription_RootJobTechnicianSalesCommissionAndBonusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobTechnicianSalesCommissionAndBonusStreamCursorInput>>;
  where?: InputMaybe<JobTechnicianSalesCommissionAndBonusBoolExp>;
};


export type Subscription_RootJobTechnicianSoldRevenueAttributionsArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsOrderBy>>;
  where?: InputMaybe<JobTechnicianSoldRevenueAttributionsBoolExp>;
};


export type Subscription_RootJobTechnicianSoldRevenueAttributionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSoldRevenueAttributionsOrderBy>>;
  where?: InputMaybe<JobTechnicianSoldRevenueAttributionsBoolExp>;
};


export type Subscription_RootJobTechnicianSoldRevenueAttributionsByPkArgs = {
  invoiceGuid: Scalars['uuid'];
  itemGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  technicianUserGuid: Scalars['uuid'];
};


export type Subscription_RootJobTechnicianSoldRevenueAttributionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobTechnicianSoldRevenueAttributionsStreamCursorInput>>;
  where?: InputMaybe<JobTechnicianSoldRevenueAttributionsBoolExp>;
};


export type Subscription_RootJobTechnicianSoldRevenueSummariesArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesOrderBy>>;
  where?: InputMaybe<JobTechnicianSoldRevenueSummariesBoolExp>;
};


export type Subscription_RootJobTechnicianSoldRevenueSummariesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTechnicianSoldRevenueSummariesOrderBy>>;
  where?: InputMaybe<JobTechnicianSoldRevenueSummariesBoolExp>;
};


export type Subscription_RootJobTechnicianSoldRevenueSummariesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobTechnicianSoldRevenueSummariesStreamCursorInput>>;
  where?: InputMaybe<JobTechnicianSoldRevenueSummariesBoolExp>;
};


export type Subscription_RootJobTypeChangeReasonsArgs = {
  distinctOn?: InputMaybe<Array<JobTypeChangeReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTypeChangeReasonsOrderBy>>;
  where?: InputMaybe<JobTypeChangeReasonsBoolExp>;
};


export type Subscription_RootJobTypeChangeReasonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTypeChangeReasonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTypeChangeReasonsOrderBy>>;
  where?: InputMaybe<JobTypeChangeReasonsBoolExp>;
};


export type Subscription_RootJobTypeChangeReasonsByPkArgs = {
  jobTypeChangeReasonGuid: Scalars['uuid'];
};


export type Subscription_RootJobTypeChangeReasonsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobTypeChangeReasonsStreamCursorInput>>;
  where?: InputMaybe<JobTypeChangeReasonsBoolExp>;
};


export type Subscription_RootJobTypesArgs = {
  distinctOn?: InputMaybe<Array<JobTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTypesOrderBy>>;
  where?: InputMaybe<JobTypesBoolExp>;
};


export type Subscription_RootJobTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobTypesOrderBy>>;
  where?: InputMaybe<JobTypesBoolExp>;
};


export type Subscription_RootJobTypesByPkArgs = {
  jobTypeGuid: Scalars['uuid'];
};


export type Subscription_RootJobTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobTypesStreamCursorInput>>;
  where?: InputMaybe<JobTypesBoolExp>;
};


export type Subscription_RootJobsArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


export type Subscription_RootJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsOrderBy>>;
  where?: InputMaybe<JobsBoolExp>;
};


export type Subscription_RootJobsByPkArgs = {
  jobGuid: Scalars['uuid'];
};


export type Subscription_RootJobsFullyPaidInvoicedAmountArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicedAmountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicedAmountOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicedAmountBoolExp>;
};


export type Subscription_RootJobsFullyPaidInvoicedAmountAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicedAmountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicedAmountOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicedAmountBoolExp>;
};


export type Subscription_RootJobsFullyPaidInvoicedAmountStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobsFullyPaidInvoicedAmountStreamCursorInput>>;
  where?: InputMaybe<JobsFullyPaidInvoicedAmountBoolExp>;
};


export type Subscription_RootJobsFullyPaidInvoicesSummaryArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicesSummarySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicesSummaryOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicesSummaryBoolExp>;
};


export type Subscription_RootJobsFullyPaidInvoicesSummaryAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicesSummarySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicesSummaryOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicesSummaryBoolExp>;
};


export type Subscription_RootJobsFullyPaidInvoicesSummaryStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobsFullyPaidInvoicesSummaryStreamCursorInput>>;
  where?: InputMaybe<JobsFullyPaidInvoicesSummaryBoolExp>;
};


export type Subscription_RootJobsFullyPaidInvoicesV2SummaryArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummarySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicesV2SummaryBoolExp>;
};


export type Subscription_RootJobsFullyPaidInvoicesV2SummaryAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummarySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicesV2SummaryBoolExp>;
};


export type Subscription_RootJobsFullyPaidInvoicesV2SummaryMvArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryMvSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryMvOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicesV2SummaryMvBoolExp>;
};


export type Subscription_RootJobsFullyPaidInvoicesV2SummaryMvAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryMvSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsFullyPaidInvoicesV2SummaryMvOrderBy>>;
  where?: InputMaybe<JobsFullyPaidInvoicesV2SummaryMvBoolExp>;
};


export type Subscription_RootJobsFullyPaidInvoicesV2SummaryMvStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobsFullyPaidInvoicesV2SummaryMvStreamCursorInput>>;
  where?: InputMaybe<JobsFullyPaidInvoicesV2SummaryMvBoolExp>;
};


export type Subscription_RootJobsFullyPaidInvoicesV2SummaryStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobsFullyPaidInvoicesV2SummaryStreamCursorInput>>;
  where?: InputMaybe<JobsFullyPaidInvoicesV2SummaryBoolExp>;
};


export type Subscription_RootJobsMaxCommissionableBaseArgs = {
  distinctOn?: InputMaybe<Array<JobsMaxCommissionableBaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsMaxCommissionableBaseOrderBy>>;
  where?: InputMaybe<JobsMaxCommissionableBaseBoolExp>;
};


export type Subscription_RootJobsMaxCommissionableBaseAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsMaxCommissionableBaseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsMaxCommissionableBaseOrderBy>>;
  where?: InputMaybe<JobsMaxCommissionableBaseBoolExp>;
};


export type Subscription_RootJobsMaxCommissionableBaseStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobsMaxCommissionableBaseStreamCursorInput>>;
  where?: InputMaybe<JobsMaxCommissionableBaseBoolExp>;
};


export type Subscription_RootJobsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobsStreamCursorInput>>;
  where?: InputMaybe<JobsBoolExp>;
};


export type Subscription_RootJobsWithLinkedJobArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobBoolExp>;
};


export type Subscription_RootJobsWithLinkedJobAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobBoolExp>;
};


export type Subscription_RootJobsWithLinkedJobByPkArgs = {
  jobGuid: Scalars['uuid'];
  linkedJobGuid: Scalars['uuid'];
};


export type Subscription_RootJobsWithLinkedJobLinkedAppointmentChecklistInstancesArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>;
};


export type Subscription_RootJobsWithLinkedJobLinkedAppointmentChecklistInstancesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedAppointmentChecklistInstancesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>;
};


export type Subscription_RootJobsWithLinkedJobLinkedAppointmentChecklistInstancesByPkArgs = {
  appointmentChecklistInstanceGuid: Scalars['uuid'];
  followUpJobGuid: Scalars['uuid'];
  originalJobGuid: Scalars['uuid'];
};


export type Subscription_RootJobsWithLinkedJobLinkedAppointmentChecklistInstancesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesStreamCursorInput>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedAppointmentChecklistInstancesBoolExp>;
};


export type Subscription_RootJobsWithLinkedJobLinkedEstimatesArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
};


export type Subscription_RootJobsWithLinkedJobLinkedEstimatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedEstimatesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
};


export type Subscription_RootJobsWithLinkedJobLinkedEstimatesByPkArgs = {
  estimateGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  linkedJobGuid: Scalars['uuid'];
};


export type Subscription_RootJobsWithLinkedJobLinkedEstimatesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobsWithLinkedJobLinkedEstimatesStreamCursorInput>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedEstimatesBoolExp>;
};


export type Subscription_RootJobsWithLinkedJobLinkedInvoicesArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedInvoicesBoolExp>;
};


export type Subscription_RootJobsWithLinkedJobLinkedInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobsWithLinkedJobLinkedInvoicesOrderBy>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedInvoicesBoolExp>;
};


export type Subscription_RootJobsWithLinkedJobLinkedInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
  linkedJobGuid: Scalars['uuid'];
};


export type Subscription_RootJobsWithLinkedJobLinkedInvoicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobsWithLinkedJobLinkedInvoicesStreamCursorInput>>;
  where?: InputMaybe<JobsWithLinkedJobLinkedInvoicesBoolExp>;
};


export type Subscription_RootJobsWithLinkedJobStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<JobsWithLinkedJobStreamCursorInput>>;
  where?: InputMaybe<JobsWithLinkedJobBoolExp>;
};


export type Subscription_RootLocationContactsArgs = {
  distinctOn?: InputMaybe<Array<LocationContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationContactsOrderBy>>;
  where?: InputMaybe<LocationContactsBoolExp>;
};


export type Subscription_RootLocationContactsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LocationContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationContactsOrderBy>>;
  where?: InputMaybe<LocationContactsBoolExp>;
};


export type Subscription_RootLocationContactsByPkArgs = {
  contactGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
};


export type Subscription_RootLocationContactsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LocationContactsStreamCursorInput>>;
  where?: InputMaybe<LocationContactsBoolExp>;
};


export type Subscription_RootLocationInvoicesArgs = {
  distinctOn?: InputMaybe<Array<LocationInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationInvoicesOrderBy>>;
  where?: InputMaybe<LocationInvoicesBoolExp>;
};


export type Subscription_RootLocationInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<LocationInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationInvoicesOrderBy>>;
  where?: InputMaybe<LocationInvoicesBoolExp>;
};


export type Subscription_RootLocationInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Subscription_RootLocationInvoicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LocationInvoicesStreamCursorInput>>;
  where?: InputMaybe<LocationInvoicesBoolExp>;
};


export type Subscription_RootLocationsArgs = {
  distinctOn?: InputMaybe<Array<LocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
  where?: InputMaybe<LocationsBoolExp>;
};


export type Subscription_RootLocationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<LocationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
  where?: InputMaybe<LocationsBoolExp>;
};


export type Subscription_RootLocationsByPkArgs = {
  locationGuid: Scalars['uuid'];
};


export type Subscription_RootLocationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<LocationsStreamCursorInput>>;
  where?: InputMaybe<LocationsBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionAllowedPaymentIntervalsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionAllowedPaymentIntervalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionAllowedPaymentIntervalsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionAllowedPaymentIntervalsByPkArgs = {
  maintenancePlanDefinitionAllowedPaymentIntervalGuid: Scalars['uuid'];
};


export type Subscription_RootMaintenancePlanDefinitionAllowedPaymentIntervalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanDefinitionAllowedPaymentIntervalsBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionBenefitsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionBenefitsBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionBenefitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionBenefitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionBenefitsBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionBenefitsByPkArgs = {
  maintenancePlanDefinitionBenefitGuid: Scalars['uuid'];
};


export type Subscription_RootMaintenancePlanDefinitionBenefitsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanDefinitionBenefitsStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanDefinitionBenefitsBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionDiscountsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionDiscountsBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionDiscountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionDiscountsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionDiscountsBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionDiscountsByPkArgs = {
  maintenancePlanDefinitionDiscountGuid: Scalars['uuid'];
};


export type Subscription_RootMaintenancePlanDefinitionDiscountsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanDefinitionDiscountsStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanDefinitionDiscountsBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionFlareArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionFlareSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionFlareOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionFlareBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionFlareAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionFlareSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionFlareOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionFlareBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionFlareByPkArgs = {
  maintenancePlanDefinitionFlareGuid: Scalars['uuid'];
};


export type Subscription_RootMaintenancePlanDefinitionFlareStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanDefinitionFlareStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanDefinitionFlareBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionMarketingInfoArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionMarketingInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionMarketingInfoOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionMarketingInfoBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionMarketingInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionMarketingInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionMarketingInfoOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionMarketingInfoBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionMarketingInfoByPkArgs = {
  maintenancePlanDefinitionMarketingInfoGuid: Scalars['uuid'];
};


export type Subscription_RootMaintenancePlanDefinitionMarketingInfoStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanDefinitionMarketingInfoStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanDefinitionMarketingInfoBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionsBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanDefinitionsOrderBy>>;
  where?: InputMaybe<MaintenancePlanDefinitionsBoolExp>;
};


export type Subscription_RootMaintenancePlanDefinitionsByPkArgs = {
  maintenancePlanDefinitionGuid: Scalars['uuid'];
};


export type Subscription_RootMaintenancePlanDefinitionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanDefinitionsStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanDefinitionsBoolExp>;
};


export type Subscription_RootMaintenancePlanEquipmentCoverageDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
};


export type Subscription_RootMaintenancePlanEquipmentCoverageDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoverageDefinitionsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
};


export type Subscription_RootMaintenancePlanEquipmentCoverageDefinitionsByPkArgs = {
  maintenancePlanEquipmentCoverageDefinitionGuid: Scalars['uuid'];
};


export type Subscription_RootMaintenancePlanEquipmentCoverageDefinitionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoverageDefinitionsBoolExp>;
};


export type Subscription_RootMaintenancePlanEquipmentCoveragePricingsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsBoolExp>;
};


export type Subscription_RootMaintenancePlanEquipmentCoveragePricingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanEquipmentCoveragePricingsOrderBy>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsBoolExp>;
};


export type Subscription_RootMaintenancePlanEquipmentCoveragePricingsByPkArgs = {
  maintenancePlanEquipmentCoveragePricingGuid: Scalars['uuid'];
};


export type Subscription_RootMaintenancePlanEquipmentCoveragePricingsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanEquipmentCoveragePricingsStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanEquipmentCoveragePricingsBoolExp>;
};


export type Subscription_RootMaintenancePlanInvoicesArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanInvoicesOrderBy>>;
  where?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
};


export type Subscription_RootMaintenancePlanInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanInvoicesOrderBy>>;
  where?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
};


export type Subscription_RootMaintenancePlanInvoicesByPkArgs = {
  invoiceGuid: Scalars['uuid'];
};


export type Subscription_RootMaintenancePlanInvoicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanInvoicesStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanInvoicesBoolExp>;
};


export type Subscription_RootMaintenancePlanNextVisitsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanNextVisitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanNextVisitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanNextVisitsBoolExp>;
};


export type Subscription_RootMaintenancePlanNextVisitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanNextVisitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanNextVisitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanNextVisitsBoolExp>;
};


export type Subscription_RootMaintenancePlanNextVisitsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanNextVisitsStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanNextVisitsBoolExp>;
};


export type Subscription_RootMaintenancePlanVisitInstalledEquipmentsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
};


export type Subscription_RootMaintenancePlanVisitInstalledEquipmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitInstalledEquipmentsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
};


export type Subscription_RootMaintenancePlanVisitInstalledEquipmentsByPkArgs = {
  maintenancePlanVisitInstalledEquipmentGuid: Scalars['uuid'];
};


export type Subscription_RootMaintenancePlanVisitInstalledEquipmentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanVisitInstalledEquipmentsStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanVisitInstalledEquipmentsBoolExp>;
};


export type Subscription_RootMaintenancePlanVisitsArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitsBoolExp>;
};


export type Subscription_RootMaintenancePlanVisitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitsOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitsBoolExp>;
};


export type Subscription_RootMaintenancePlanVisitsByPkArgs = {
  maintenancePlanVisitGuid: Scalars['uuid'];
};


export type Subscription_RootMaintenancePlanVisitsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanVisitsStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanVisitsBoolExp>;
};


export type Subscription_RootMaintenancePlanVisitsWithStatusArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitsWithStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitsWithStatusOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitsWithStatusBoolExp>;
};


export type Subscription_RootMaintenancePlanVisitsWithStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlanVisitsWithStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlanVisitsWithStatusOrderBy>>;
  where?: InputMaybe<MaintenancePlanVisitsWithStatusBoolExp>;
};


export type Subscription_RootMaintenancePlanVisitsWithStatusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlanVisitsWithStatusStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlanVisitsWithStatusBoolExp>;
};


export type Subscription_RootMaintenancePlansQueryableArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlansQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlansQueryableOrderBy>>;
  where?: InputMaybe<MaintenancePlansQueryableBoolExp>;
};


export type Subscription_RootMaintenancePlansQueryableAggregateArgs = {
  distinctOn?: InputMaybe<Array<MaintenancePlansQueryableSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MaintenancePlansQueryableOrderBy>>;
  where?: InputMaybe<MaintenancePlansQueryableBoolExp>;
};


export type Subscription_RootMaintenancePlansQueryableByPkArgs = {
  maintenancePlanGuid: Scalars['uuid'];
};


export type Subscription_RootMaintenancePlansQueryableStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MaintenancePlansQueryableStreamCursorInput>>;
  where?: InputMaybe<MaintenancePlansQueryableBoolExp>;
};


export type Subscription_RootMigrationJunkArgs = {
  distinctOn?: InputMaybe<Array<MigrationJunkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MigrationJunkOrderBy>>;
  where?: InputMaybe<MigrationJunkBoolExp>;
};


export type Subscription_RootMigrationJunkAggregateArgs = {
  distinctOn?: InputMaybe<Array<MigrationJunkSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MigrationJunkOrderBy>>;
  where?: InputMaybe<MigrationJunkBoolExp>;
};


export type Subscription_RootMigrationJunkByPkArgs = {
  migrationJunkGuid: Scalars['uuid'];
};


export type Subscription_RootMigrationJunkLinksArgs = {
  distinctOn?: InputMaybe<Array<MigrationJunkLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MigrationJunkLinksOrderBy>>;
  where?: InputMaybe<MigrationJunkLinksBoolExp>;
};


export type Subscription_RootMigrationJunkLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<MigrationJunkLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MigrationJunkLinksOrderBy>>;
  where?: InputMaybe<MigrationJunkLinksBoolExp>;
};


export type Subscription_RootMigrationJunkLinksByPkArgs = {
  migrationJunkGuid: Scalars['uuid'];
};


export type Subscription_RootMigrationJunkLinksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MigrationJunkLinksStreamCursorInput>>;
  where?: InputMaybe<MigrationJunkLinksBoolExp>;
};


export type Subscription_RootMigrationJunkStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<MigrationJunkStreamCursorInput>>;
  where?: InputMaybe<MigrationJunkBoolExp>;
};


export type Subscription_RootNoteAttachmentsArgs = {
  distinctOn?: InputMaybe<Array<NoteAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteAttachmentsOrderBy>>;
  where?: InputMaybe<NoteAttachmentsBoolExp>;
};


export type Subscription_RootNoteAttachmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteAttachmentsOrderBy>>;
  where?: InputMaybe<NoteAttachmentsBoolExp>;
};


export type Subscription_RootNoteAttachmentsByPkArgs = {
  noteAttachmentGuid: Scalars['uuid'];
};


export type Subscription_RootNoteAttachmentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<NoteAttachmentsStreamCursorInput>>;
  where?: InputMaybe<NoteAttachmentsBoolExp>;
};


export type Subscription_RootNoteLinksArgs = {
  distinctOn?: InputMaybe<Array<NoteLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteLinksOrderBy>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};


export type Subscription_RootNoteLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteLinksOrderBy>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};


export type Subscription_RootNoteLinksByPkArgs = {
  noteGuid: Scalars['uuid'];
};


export type Subscription_RootNoteLinksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<NoteLinksStreamCursorInput>>;
  where?: InputMaybe<NoteLinksBoolExp>;
};


export type Subscription_RootNoteTaggedUsersArgs = {
  distinctOn?: InputMaybe<Array<NoteTaggedUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteTaggedUsersOrderBy>>;
  where?: InputMaybe<NoteTaggedUsersBoolExp>;
};


export type Subscription_RootNoteTaggedUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<NoteTaggedUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoteTaggedUsersOrderBy>>;
  where?: InputMaybe<NoteTaggedUsersBoolExp>;
};


export type Subscription_RootNoteTaggedUsersByPkArgs = {
  noteUserTagGuid: Scalars['uuid'];
};


export type Subscription_RootNoteTaggedUsersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<NoteTaggedUsersStreamCursorInput>>;
  where?: InputMaybe<NoteTaggedUsersBoolExp>;
};


export type Subscription_RootNotesArgs = {
  distinctOn?: InputMaybe<Array<NotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
  where?: InputMaybe<NotesBoolExp>;
};


export type Subscription_RootNotesAggregateArgs = {
  distinctOn?: InputMaybe<Array<NotesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotesOrderBy>>;
  where?: InputMaybe<NotesBoolExp>;
};


export type Subscription_RootNotesByPkArgs = {
  noteGuid: Scalars['uuid'];
};


export type Subscription_RootNotesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<NotesStreamCursorInput>>;
  where?: InputMaybe<NotesBoolExp>;
};


export type Subscription_RootOnlineBookingCompanyConfigArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingCompanyConfigOrderBy>>;
  where?: InputMaybe<OnlineBookingCompanyConfigBoolExp>;
};


export type Subscription_RootOnlineBookingCompanyConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingCompanyConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingCompanyConfigOrderBy>>;
  where?: InputMaybe<OnlineBookingCompanyConfigBoolExp>;
};


export type Subscription_RootOnlineBookingCompanyConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootOnlineBookingCompanyConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<OnlineBookingCompanyConfigStreamCursorInput>>;
  where?: InputMaybe<OnlineBookingCompanyConfigBoolExp>;
};


export type Subscription_RootOnlineBookingServiceAreaZipCodesArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceAreaZipCodesBoolExp>;
};


export type Subscription_RootOnlineBookingServiceAreaZipCodesAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceAreaZipCodesOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceAreaZipCodesBoolExp>;
};


export type Subscription_RootOnlineBookingServiceAreaZipCodesByPkArgs = {
  serviceAreaZipCodeGuid: Scalars['uuid'];
};


export type Subscription_RootOnlineBookingServiceAreaZipCodesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<OnlineBookingServiceAreaZipCodesStreamCursorInput>>;
  where?: InputMaybe<OnlineBookingServiceAreaZipCodesBoolExp>;
};


export type Subscription_RootOnlineBookingServiceTypeBookableJobTypesArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesBoolExp>;
};


export type Subscription_RootOnlineBookingServiceTypeBookableJobTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeBookableJobTypesOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesBoolExp>;
};


export type Subscription_RootOnlineBookingServiceTypeBookableJobTypesByPkArgs = {
  jobTypeGuid: Scalars['uuid'];
  onlineBookingServiceTypeGuid: Scalars['uuid'];
};


export type Subscription_RootOnlineBookingServiceTypeBookableJobTypesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<OnlineBookingServiceTypeBookableJobTypesStreamCursorInput>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableJobTypesBoolExp>;
};


export type Subscription_RootOnlineBookingServiceTypeBookableTechniciansArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansBoolExp>;
};


export type Subscription_RootOnlineBookingServiceTypeBookableTechniciansAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeBookableTechniciansOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansBoolExp>;
};


export type Subscription_RootOnlineBookingServiceTypeBookableTechniciansByPkArgs = {
  onlineBookingServiceTypeGuid: Scalars['uuid'];
  technicianGuid: Scalars['uuid'];
};


export type Subscription_RootOnlineBookingServiceTypeBookableTechniciansStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<OnlineBookingServiceTypeBookableTechniciansStreamCursorInput>>;
  where?: InputMaybe<OnlineBookingServiceTypeBookableTechniciansBoolExp>;
};


export type Subscription_RootOnlineBookingServiceTypeConfigsArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeConfigsOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeConfigsBoolExp>;
};


export type Subscription_RootOnlineBookingServiceTypeConfigsAggregateArgs = {
  distinctOn?: InputMaybe<Array<OnlineBookingServiceTypeConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OnlineBookingServiceTypeConfigsOrderBy>>;
  where?: InputMaybe<OnlineBookingServiceTypeConfigsBoolExp>;
};


export type Subscription_RootOnlineBookingServiceTypeConfigsByPkArgs = {
  onlineBookingServiceTypeGuid: Scalars['uuid'];
};


export type Subscription_RootOnlineBookingServiceTypeConfigsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<OnlineBookingServiceTypeConfigsStreamCursorInput>>;
  where?: InputMaybe<OnlineBookingServiceTypeConfigsBoolExp>;
};


export type Subscription_RootPaymentLinksArgs = {
  distinctOn?: InputMaybe<Array<PaymentLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentLinksOrderBy>>;
  where?: InputMaybe<PaymentLinksBoolExp>;
};


export type Subscription_RootPaymentLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentLinksOrderBy>>;
  where?: InputMaybe<PaymentLinksBoolExp>;
};


export type Subscription_RootPaymentLinksByPkArgs = {
  paymentRecordGuid: Scalars['uuid'];
};


export type Subscription_RootPaymentLinksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentLinksStreamCursorInput>>;
  where?: InputMaybe<PaymentLinksBoolExp>;
};


export type Subscription_RootPaymentMethodBillingInfoArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodBillingInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodBillingInfoOrderBy>>;
  where?: InputMaybe<PaymentMethodBillingInfoBoolExp>;
};


export type Subscription_RootPaymentMethodBillingInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodBillingInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodBillingInfoOrderBy>>;
  where?: InputMaybe<PaymentMethodBillingInfoBoolExp>;
};


export type Subscription_RootPaymentMethodBillingInfoByPkArgs = {
  paymentMethodRecordGuid: Scalars['uuid'];
};


export type Subscription_RootPaymentMethodBillingInfoStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentMethodBillingInfoStreamCursorInput>>;
  where?: InputMaybe<PaymentMethodBillingInfoBoolExp>;
};


export type Subscription_RootPaymentMethodCardMetadataArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodCardMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodCardMetadataOrderBy>>;
  where?: InputMaybe<PaymentMethodCardMetadataBoolExp>;
};


export type Subscription_RootPaymentMethodCardMetadataAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodCardMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodCardMetadataOrderBy>>;
  where?: InputMaybe<PaymentMethodCardMetadataBoolExp>;
};


export type Subscription_RootPaymentMethodCardMetadataByPkArgs = {
  paymentMethodRecordGuid: Scalars['uuid'];
};


export type Subscription_RootPaymentMethodCardMetadataStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentMethodCardMetadataStreamCursorInput>>;
  where?: InputMaybe<PaymentMethodCardMetadataBoolExp>;
};


export type Subscription_RootPaymentMethodRecordsArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodRecordsOrderBy>>;
  where?: InputMaybe<PaymentMethodRecordsBoolExp>;
};


export type Subscription_RootPaymentMethodRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodRecordsOrderBy>>;
  where?: InputMaybe<PaymentMethodRecordsBoolExp>;
};


export type Subscription_RootPaymentMethodRecordsByPkArgs = {
  paymentMethodRecordGuid: Scalars['uuid'];
};


export type Subscription_RootPaymentMethodRecordsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentMethodRecordsStreamCursorInput>>;
  where?: InputMaybe<PaymentMethodRecordsBoolExp>;
};


export type Subscription_RootPaymentMethodsArgs = {
  distinctOn?: InputMaybe<Array<PaymentMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentMethodsOrderBy>>;
  where?: InputMaybe<PaymentMethodsBoolExp>;
};


export type Subscription_RootPaymentMethodsByPkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootPaymentMethodsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentMethodsStreamCursorInput>>;
  where?: InputMaybe<PaymentMethodsBoolExp>;
};


export type Subscription_RootPaymentRecordsArgs = {
  distinctOn?: InputMaybe<Array<PaymentRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecordsOrderBy>>;
  where?: InputMaybe<PaymentRecordsBoolExp>;
};


export type Subscription_RootPaymentRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRecordsOrderBy>>;
  where?: InputMaybe<PaymentRecordsBoolExp>;
};


export type Subscription_RootPaymentRecordsByPkArgs = {
  paymentRecordGuid: Scalars['uuid'];
};


export type Subscription_RootPaymentRecordsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentRecordsStreamCursorInput>>;
  where?: InputMaybe<PaymentRecordsBoolExp>;
};


export type Subscription_RootPaymentRefundsArgs = {
  distinctOn?: InputMaybe<Array<PaymentRefundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRefundsOrderBy>>;
  where?: InputMaybe<PaymentRefundsBoolExp>;
};


export type Subscription_RootPaymentRefundsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentRefundsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentRefundsOrderBy>>;
  where?: InputMaybe<PaymentRefundsBoolExp>;
};


export type Subscription_RootPaymentRefundsByPkArgs = {
  paymentRefundGuid: Scalars['uuid'];
};


export type Subscription_RootPaymentRefundsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentRefundsStreamCursorInput>>;
  where?: InputMaybe<PaymentRefundsBoolExp>;
};


export type Subscription_RootPaymentStatusErrorDetailArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusErrorDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusErrorDetailOrderBy>>;
  where?: InputMaybe<PaymentStatusErrorDetailBoolExp>;
};


export type Subscription_RootPaymentStatusErrorDetailAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusErrorDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusErrorDetailOrderBy>>;
  where?: InputMaybe<PaymentStatusErrorDetailBoolExp>;
};


export type Subscription_RootPaymentStatusErrorDetailByPkArgs = {
  paymentStatusErrorDetailGuid: Scalars['uuid'];
};


export type Subscription_RootPaymentStatusErrorDetailStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentStatusErrorDetailStreamCursorInput>>;
  where?: InputMaybe<PaymentStatusErrorDetailBoolExp>;
};


export type Subscription_RootPaymentStatusLatestArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusLatestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusLatestOrderBy>>;
  where?: InputMaybe<PaymentStatusLatestBoolExp>;
};


export type Subscription_RootPaymentStatusLatestAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusLatestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusLatestOrderBy>>;
  where?: InputMaybe<PaymentStatusLatestBoolExp>;
};


export type Subscription_RootPaymentStatusLatestByPkArgs = {
  paymentRecordGuid: Scalars['uuid'];
};


export type Subscription_RootPaymentStatusLatestStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentStatusLatestStreamCursorInput>>;
  where?: InputMaybe<PaymentStatusLatestBoolExp>;
};


export type Subscription_RootPaymentStatusesArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusesOrderBy>>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};


export type Subscription_RootPaymentStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentStatusesOrderBy>>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};


export type Subscription_RootPaymentStatusesByPkArgs = {
  paymentStatusGuid: Scalars['uuid'];
};


export type Subscription_RootPaymentStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentStatusesStreamCursorInput>>;
  where?: InputMaybe<PaymentStatusesBoolExp>;
};


export type Subscription_RootPaymentSubscriptionInvoicesArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionInvoicesOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionInvoicesBoolExp>;
};


export type Subscription_RootPaymentSubscriptionInvoicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionInvoicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionInvoicesOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionInvoicesBoolExp>;
};


export type Subscription_RootPaymentSubscriptionInvoicesByPkArgs = {
  paymentSubscriptionInvoiceGuid: Scalars['uuid'];
};


export type Subscription_RootPaymentSubscriptionInvoicesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentSubscriptionInvoicesStreamCursorInput>>;
  where?: InputMaybe<PaymentSubscriptionInvoicesBoolExp>;
};


export type Subscription_RootPaymentSubscriptionStatusesArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionStatusesOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionStatusesBoolExp>;
};


export type Subscription_RootPaymentSubscriptionStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionStatusesOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionStatusesBoolExp>;
};


export type Subscription_RootPaymentSubscriptionStatusesByPkArgs = {
  paymentSubscriptionStatusGuid: Scalars['uuid'];
};


export type Subscription_RootPaymentSubscriptionStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentSubscriptionStatusesStreamCursorInput>>;
  where?: InputMaybe<PaymentSubscriptionStatusesBoolExp>;
};


export type Subscription_RootPaymentSubscriptionsArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionsOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionsBoolExp>;
};


export type Subscription_RootPaymentSubscriptionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentSubscriptionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentSubscriptionsOrderBy>>;
  where?: InputMaybe<PaymentSubscriptionsBoolExp>;
};


export type Subscription_RootPaymentSubscriptionsByPkArgs = {
  paymentSubscriptionGuid: Scalars['uuid'];
};


export type Subscription_RootPaymentSubscriptionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentSubscriptionsStreamCursorInput>>;
  where?: InputMaybe<PaymentSubscriptionsBoolExp>;
};


export type Subscription_RootPaymentsAccountingStaleInfoArgs = {
  distinctOn?: InputMaybe<Array<PaymentsAccountingStaleInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsAccountingStaleInfoOrderBy>>;
  where?: InputMaybe<PaymentsAccountingStaleInfoBoolExp>;
};


export type Subscription_RootPaymentsAccountingStaleInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentsAccountingStaleInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsAccountingStaleInfoOrderBy>>;
  where?: InputMaybe<PaymentsAccountingStaleInfoBoolExp>;
};


export type Subscription_RootPaymentsAccountingStaleInfoStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentsAccountingStaleInfoStreamCursorInput>>;
  where?: InputMaybe<PaymentsAccountingStaleInfoBoolExp>;
};


export type Subscription_RootPaymentsQboStatusArgs = {
  distinctOn?: InputMaybe<Array<PaymentsQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsQboStatusOrderBy>>;
  where?: InputMaybe<PaymentsQboStatusBoolExp>;
};


export type Subscription_RootPaymentsQboStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<PaymentsQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PaymentsQboStatusOrderBy>>;
  where?: InputMaybe<PaymentsQboStatusBoolExp>;
};


export type Subscription_RootPaymentsQboStatusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PaymentsQboStatusStreamCursorInput>>;
  where?: InputMaybe<PaymentsQboStatusBoolExp>;
};


export type Subscription_RootPayoutItemsArgs = {
  distinctOn?: InputMaybe<Array<PayoutItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutItemsOrderBy>>;
  where?: InputMaybe<PayoutItemsBoolExp>;
};


export type Subscription_RootPayoutItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PayoutItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutItemsOrderBy>>;
  where?: InputMaybe<PayoutItemsBoolExp>;
};


export type Subscription_RootPayoutItemsByPkArgs = {
  payoutItemGuid: Scalars['uuid'];
};


export type Subscription_RootPayoutItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PayoutItemsStreamCursorInput>>;
  where?: InputMaybe<PayoutItemsBoolExp>;
};


export type Subscription_RootPayoutQboAccountsConfigArgs = {
  distinctOn?: InputMaybe<Array<PayoutQboAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutQboAccountsConfigOrderBy>>;
  where?: InputMaybe<PayoutQboAccountsConfigBoolExp>;
};


export type Subscription_RootPayoutQboAccountsConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<PayoutQboAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutQboAccountsConfigOrderBy>>;
  where?: InputMaybe<PayoutQboAccountsConfigBoolExp>;
};


export type Subscription_RootPayoutQboAccountsConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootPayoutQboAccountsConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PayoutQboAccountsConfigStreamCursorInput>>;
  where?: InputMaybe<PayoutQboAccountsConfigBoolExp>;
};


export type Subscription_RootPayoutsArgs = {
  distinctOn?: InputMaybe<Array<PayoutsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutsOrderBy>>;
  where?: InputMaybe<PayoutsBoolExp>;
};


export type Subscription_RootPayoutsAccountingStaleInfoArgs = {
  distinctOn?: InputMaybe<Array<PayoutsAccountingStaleInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutsAccountingStaleInfoOrderBy>>;
  where?: InputMaybe<PayoutsAccountingStaleInfoBoolExp>;
};


export type Subscription_RootPayoutsAccountingStaleInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<PayoutsAccountingStaleInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutsAccountingStaleInfoOrderBy>>;
  where?: InputMaybe<PayoutsAccountingStaleInfoBoolExp>;
};


export type Subscription_RootPayoutsAccountingStaleInfoStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PayoutsAccountingStaleInfoStreamCursorInput>>;
  where?: InputMaybe<PayoutsAccountingStaleInfoBoolExp>;
};


export type Subscription_RootPayoutsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PayoutsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutsOrderBy>>;
  where?: InputMaybe<PayoutsBoolExp>;
};


export type Subscription_RootPayoutsByPkArgs = {
  payoutGuid: Scalars['uuid'];
};


export type Subscription_RootPayoutsQboStatusArgs = {
  distinctOn?: InputMaybe<Array<PayoutsQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutsQboStatusOrderBy>>;
  where?: InputMaybe<PayoutsQboStatusBoolExp>;
};


export type Subscription_RootPayoutsQboStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<PayoutsQboStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PayoutsQboStatusOrderBy>>;
  where?: InputMaybe<PayoutsQboStatusBoolExp>;
};


export type Subscription_RootPayoutsQboStatusStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PayoutsQboStatusStreamCursorInput>>;
  where?: InputMaybe<PayoutsQboStatusBoolExp>;
};


export type Subscription_RootPayoutsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PayoutsStreamCursorInput>>;
  where?: InputMaybe<PayoutsBoolExp>;
};


export type Subscription_RootPermissionsArgs = {
  distinctOn?: InputMaybe<Array<PermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PermissionsOrderBy>>;
  where?: InputMaybe<PermissionsBoolExp>;
};


export type Subscription_RootPermissionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PermissionsOrderBy>>;
  where?: InputMaybe<PermissionsBoolExp>;
};


export type Subscription_RootPermissionsByPkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootPermissionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PermissionsStreamCursorInput>>;
  where?: InputMaybe<PermissionsBoolExp>;
};


export type Subscription_RootPermissionsV2Args = {
  distinctOn?: InputMaybe<Array<PermissionsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PermissionsV2OrderBy>>;
  where?: InputMaybe<PermissionsV2BoolExp>;
};


export type Subscription_RootPermissionsV2AggregateArgs = {
  distinctOn?: InputMaybe<Array<PermissionsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PermissionsV2OrderBy>>;
  where?: InputMaybe<PermissionsV2BoolExp>;
};


export type Subscription_RootPermissionsV2ByPkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootPermissionsV2StreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PermissionsV2StreamCursorInput>>;
  where?: InputMaybe<PermissionsV2BoolExp>;
};


export type Subscription_RootPhoneNumbersArgs = {
  distinctOn?: InputMaybe<Array<PhoneNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhoneNumbersOrderBy>>;
  where?: InputMaybe<PhoneNumbersBoolExp>;
};


export type Subscription_RootPhoneNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhoneNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhoneNumbersOrderBy>>;
  where?: InputMaybe<PhoneNumbersBoolExp>;
};


export type Subscription_RootPhoneNumbersByPkArgs = {
  phoneNumberGuid: Scalars['uuid'];
};


export type Subscription_RootPhoneNumbersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PhoneNumbersStreamCursorInput>>;
  where?: InputMaybe<PhoneNumbersBoolExp>;
};


export type Subscription_RootPhotoLinksArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


export type Subscription_RootPhotoLinksAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhotoLinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotoLinksOrderBy>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


export type Subscription_RootPhotoLinksByPkArgs = {
  photoGuid: Scalars['uuid'];
};


export type Subscription_RootPhotoLinksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PhotoLinksStreamCursorInput>>;
  where?: InputMaybe<PhotoLinksBoolExp>;
};


export type Subscription_RootPhotosArgs = {
  distinctOn?: InputMaybe<Array<PhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotosOrderBy>>;
  where?: InputMaybe<PhotosBoolExp>;
};


export type Subscription_RootPhotosAggregateArgs = {
  distinctOn?: InputMaybe<Array<PhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PhotosOrderBy>>;
  where?: InputMaybe<PhotosBoolExp>;
};


export type Subscription_RootPhotosByPkArgs = {
  photoGuid: Scalars['uuid'];
};


export type Subscription_RootPhotosStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PhotosStreamCursorInput>>;
  where?: InputMaybe<PhotosBoolExp>;
};


export type Subscription_RootPricebookBundleItemsArgs = {
  distinctOn?: InputMaybe<Array<PricebookBundleItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookBundleItemsOrderBy>>;
  where?: InputMaybe<PricebookBundleItemsBoolExp>;
};


export type Subscription_RootPricebookBundleItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookBundleItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookBundleItemsOrderBy>>;
  where?: InputMaybe<PricebookBundleItemsBoolExp>;
};


export type Subscription_RootPricebookBundleItemsByPkArgs = {
  pricebookBundleItemGuid: Scalars['uuid'];
};


export type Subscription_RootPricebookBundleItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PricebookBundleItemsStreamCursorInput>>;
  where?: InputMaybe<PricebookBundleItemsBoolExp>;
};


export type Subscription_RootPricebookCategoriesArgs = {
  distinctOn?: InputMaybe<Array<PricebookCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookCategoriesOrderBy>>;
  where?: InputMaybe<PricebookCategoriesBoolExp>;
};


export type Subscription_RootPricebookCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookCategoriesOrderBy>>;
  where?: InputMaybe<PricebookCategoriesBoolExp>;
};


export type Subscription_RootPricebookCategoriesByPkArgs = {
  pricebookCategoryGuid: Scalars['uuid'];
};


export type Subscription_RootPricebookCategoriesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PricebookCategoriesStreamCursorInput>>;
  where?: InputMaybe<PricebookCategoriesBoolExp>;
};


export type Subscription_RootPricebookDiscountsArgs = {
  distinctOn?: InputMaybe<Array<PricebookDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookDiscountsOrderBy>>;
  where?: InputMaybe<PricebookDiscountsBoolExp>;
};


export type Subscription_RootPricebookDiscountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookDiscountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookDiscountsOrderBy>>;
  where?: InputMaybe<PricebookDiscountsBoolExp>;
};


export type Subscription_RootPricebookDiscountsByPkArgs = {
  pricebookDiscountGuid: Scalars['uuid'];
};


export type Subscription_RootPricebookDiscountsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PricebookDiscountsStreamCursorInput>>;
  where?: InputMaybe<PricebookDiscountsBoolExp>;
};


export type Subscription_RootPricebookItemTypeFallbackPhotosArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemTypeFallbackPhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemTypeFallbackPhotosOrderBy>>;
  where?: InputMaybe<PricebookItemTypeFallbackPhotosBoolExp>;
};


export type Subscription_RootPricebookItemTypeFallbackPhotosAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemTypeFallbackPhotosSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemTypeFallbackPhotosOrderBy>>;
  where?: InputMaybe<PricebookItemTypeFallbackPhotosBoolExp>;
};


export type Subscription_RootPricebookItemTypeFallbackPhotosByPkArgs = {
  companyGuid: Scalars['uuid'];
  itemType: Scalars['String'];
};


export type Subscription_RootPricebookItemTypeFallbackPhotosStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PricebookItemTypeFallbackPhotosStreamCursorInput>>;
  where?: InputMaybe<PricebookItemTypeFallbackPhotosBoolExp>;
};


export type Subscription_RootPricebookItemsArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemsOrderBy>>;
  where?: InputMaybe<PricebookItemsBoolExp>;
};


export type Subscription_RootPricebookItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemsOrderBy>>;
  where?: InputMaybe<PricebookItemsBoolExp>;
};


export type Subscription_RootPricebookItemsByPkArgs = {
  pricebookItemGuid: Scalars['uuid'];
};


export type Subscription_RootPricebookItemsQboIncomeAccountsArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemsQboIncomeAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemsQboIncomeAccountsOrderBy>>;
  where?: InputMaybe<PricebookItemsQboIncomeAccountsBoolExp>;
};


export type Subscription_RootPricebookItemsQboIncomeAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookItemsQboIncomeAccountsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookItemsQboIncomeAccountsOrderBy>>;
  where?: InputMaybe<PricebookItemsQboIncomeAccountsBoolExp>;
};


export type Subscription_RootPricebookItemsQboIncomeAccountsByPkArgs = {
  pricebookItemGuid: Scalars['uuid'];
};


export type Subscription_RootPricebookItemsQboIncomeAccountsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PricebookItemsQboIncomeAccountsStreamCursorInput>>;
  where?: InputMaybe<PricebookItemsQboIncomeAccountsBoolExp>;
};


export type Subscription_RootPricebookItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PricebookItemsStreamCursorInput>>;
  where?: InputMaybe<PricebookItemsBoolExp>;
};


export type Subscription_RootPricebookMarkupTiersArgs = {
  distinctOn?: InputMaybe<Array<PricebookMarkupTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookMarkupTiersOrderBy>>;
  where?: InputMaybe<PricebookMarkupTiersBoolExp>;
};


export type Subscription_RootPricebookMarkupTiersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookMarkupTiersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookMarkupTiersOrderBy>>;
  where?: InputMaybe<PricebookMarkupTiersBoolExp>;
};


export type Subscription_RootPricebookMarkupTiersByPkArgs = {
  pricebookMarkupTierGuid: Scalars['uuid'];
};


export type Subscription_RootPricebookMarkupTiersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PricebookMarkupTiersStreamCursorInput>>;
  where?: InputMaybe<PricebookMarkupTiersBoolExp>;
};


export type Subscription_RootPricebookTaxRatesArgs = {
  distinctOn?: InputMaybe<Array<PricebookTaxRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookTaxRatesOrderBy>>;
  where?: InputMaybe<PricebookTaxRatesBoolExp>;
};


export type Subscription_RootPricebookTaxRatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookTaxRatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookTaxRatesOrderBy>>;
  where?: InputMaybe<PricebookTaxRatesBoolExp>;
};


export type Subscription_RootPricebookTaxRatesByPkArgs = {
  pricebookTaxRateGuid: Scalars['uuid'];
};


export type Subscription_RootPricebookTaxRatesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PricebookTaxRatesStreamCursorInput>>;
  where?: InputMaybe<PricebookTaxRatesBoolExp>;
};


export type Subscription_RootPricebookVersionsArgs = {
  distinctOn?: InputMaybe<Array<PricebookVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookVersionsOrderBy>>;
  where?: InputMaybe<PricebookVersionsBoolExp>;
};


export type Subscription_RootPricebookVersionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebookVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebookVersionsOrderBy>>;
  where?: InputMaybe<PricebookVersionsBoolExp>;
};


export type Subscription_RootPricebookVersionsByPkArgs = {
  pricebookVersionGuid: Scalars['uuid'];
};


export type Subscription_RootPricebookVersionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PricebookVersionsStreamCursorInput>>;
  where?: InputMaybe<PricebookVersionsBoolExp>;
};


export type Subscription_RootPricebooksItemPricesArgs = {
  distinctOn?: InputMaybe<Array<PricebooksItemPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebooksItemPricesOrderBy>>;
  where?: InputMaybe<PricebooksItemPricesBoolExp>;
};


export type Subscription_RootPricebooksItemPricesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PricebooksItemPricesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PricebooksItemPricesOrderBy>>;
  where?: InputMaybe<PricebooksItemPricesBoolExp>;
};


export type Subscription_RootPricebooksItemPricesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PricebooksItemPricesStreamCursorInput>>;
  where?: InputMaybe<PricebooksItemPricesBoolExp>;
};


export type Subscription_RootPurchaseOrdersArgs = {
  distinctOn?: InputMaybe<Array<PurchaseOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PurchaseOrdersOrderBy>>;
  where?: InputMaybe<PurchaseOrdersBoolExp>;
};


export type Subscription_RootPurchaseOrdersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PurchaseOrdersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PurchaseOrdersOrderBy>>;
  where?: InputMaybe<PurchaseOrdersBoolExp>;
};


export type Subscription_RootPurchaseOrdersByPkArgs = {
  purchaseOrderGuid: Scalars['uuid'];
};


export type Subscription_RootPurchaseOrdersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<PurchaseOrdersStreamCursorInput>>;
  where?: InputMaybe<PurchaseOrdersBoolExp>;
};


export type Subscription_RootQboAuthDataArgs = {
  distinctOn?: InputMaybe<Array<QboAuthDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QboAuthDataOrderBy>>;
  where?: InputMaybe<QboAuthDataBoolExp>;
};


export type Subscription_RootQboAuthDataAggregateArgs = {
  distinctOn?: InputMaybe<Array<QboAuthDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QboAuthDataOrderBy>>;
  where?: InputMaybe<QboAuthDataBoolExp>;
};


export type Subscription_RootQboAuthDataByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootQboAuthDataStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<QboAuthDataStreamCursorInput>>;
  where?: InputMaybe<QboAuthDataBoolExp>;
};


export type Subscription_RootQboCartItemTypeAccountsConfigArgs = {
  distinctOn?: InputMaybe<Array<QboCartItemTypeAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QboCartItemTypeAccountsConfigOrderBy>>;
  where?: InputMaybe<QboCartItemTypeAccountsConfigBoolExp>;
};


export type Subscription_RootQboCartItemTypeAccountsConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<QboCartItemTypeAccountsConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QboCartItemTypeAccountsConfigOrderBy>>;
  where?: InputMaybe<QboCartItemTypeAccountsConfigBoolExp>;
};


export type Subscription_RootQboCartItemTypeAccountsConfigByPkArgs = {
  qboCartItemTypeAccountsConfigGuid: Scalars['uuid'];
};


export type Subscription_RootQboCartItemTypeAccountsConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<QboCartItemTypeAccountsConfigStreamCursorInput>>;
  where?: InputMaybe<QboCartItemTypeAccountsConfigBoolExp>;
};


export type Subscription_RootQboSyncInfoArgs = {
  distinctOn?: InputMaybe<Array<QboSyncInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QboSyncInfoOrderBy>>;
  where?: InputMaybe<QboSyncInfoBoolExp>;
};


export type Subscription_RootQboSyncInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<QboSyncInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QboSyncInfoOrderBy>>;
  where?: InputMaybe<QboSyncInfoBoolExp>;
};


export type Subscription_RootQboSyncInfoByPkArgs = {
  breezyIdentifier: Scalars['String'];
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootQboSyncInfoStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<QboSyncInfoStreamCursorInput>>;
  where?: InputMaybe<QboSyncInfoBoolExp>;
};


export type Subscription_RootRecentPricebookItemsArgs = {
  distinctOn?: InputMaybe<Array<RecentPricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecentPricebookItemsOrderBy>>;
  where?: InputMaybe<RecentPricebookItemsBoolExp>;
};


export type Subscription_RootRecentPricebookItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecentPricebookItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecentPricebookItemsOrderBy>>;
  where?: InputMaybe<RecentPricebookItemsBoolExp>;
};


export type Subscription_RootRecentPricebookItemsByPkArgs = {
  pricebookItemGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


export type Subscription_RootRecentPricebookItemsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RecentPricebookItemsStreamCursorInput>>;
  where?: InputMaybe<RecentPricebookItemsBoolExp>;
};


export type Subscription_RootRecommendationAiGenerationInfoArgs = {
  distinctOn?: InputMaybe<Array<RecommendationAiGenerationInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationAiGenerationInfoOrderBy>>;
  where?: InputMaybe<RecommendationAiGenerationInfoBoolExp>;
};


export type Subscription_RootRecommendationAiGenerationInfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecommendationAiGenerationInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationAiGenerationInfoOrderBy>>;
  where?: InputMaybe<RecommendationAiGenerationInfoBoolExp>;
};


export type Subscription_RootRecommendationAiGenerationInfoByPkArgs = {
  recommendationAiInfoGuid: Scalars['uuid'];
};


export type Subscription_RootRecommendationAiGenerationInfoStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RecommendationAiGenerationInfoStreamCursorInput>>;
  where?: InputMaybe<RecommendationAiGenerationInfoBoolExp>;
};


export type Subscription_RootRecommendationDismissalsArgs = {
  distinctOn?: InputMaybe<Array<RecommendationDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationDismissalsOrderBy>>;
  where?: InputMaybe<RecommendationDismissalsBoolExp>;
};


export type Subscription_RootRecommendationDismissalsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecommendationDismissalsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationDismissalsOrderBy>>;
  where?: InputMaybe<RecommendationDismissalsBoolExp>;
};


export type Subscription_RootRecommendationDismissalsByPkArgs = {
  recommendationDismissalGuid: Scalars['uuid'];
};


export type Subscription_RootRecommendationDismissalsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RecommendationDismissalsStreamCursorInput>>;
  where?: InputMaybe<RecommendationDismissalsBoolExp>;
};


export type Subscription_RootRecommendationInteractionsArgs = {
  distinctOn?: InputMaybe<Array<RecommendationInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationInteractionsOrderBy>>;
  where?: InputMaybe<RecommendationInteractionsBoolExp>;
};


export type Subscription_RootRecommendationInteractionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecommendationInteractionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationInteractionsOrderBy>>;
  where?: InputMaybe<RecommendationInteractionsBoolExp>;
};


export type Subscription_RootRecommendationInteractionsByPkArgs = {
  recommendationInteractionGuid: Scalars['uuid'];
};


export type Subscription_RootRecommendationInteractionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RecommendationInteractionsStreamCursorInput>>;
  where?: InputMaybe<RecommendationInteractionsBoolExp>;
};


export type Subscription_RootRecommendationsArgs = {
  distinctOn?: InputMaybe<Array<RecommendationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationsOrderBy>>;
  where?: InputMaybe<RecommendationsBoolExp>;
};


export type Subscription_RootRecommendationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecommendationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RecommendationsOrderBy>>;
  where?: InputMaybe<RecommendationsBoolExp>;
};


export type Subscription_RootRecommendationsByPkArgs = {
  recommendationGuid: Scalars['uuid'];
};


export type Subscription_RootRecommendationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RecommendationsStreamCursorInput>>;
  where?: InputMaybe<RecommendationsBoolExp>;
};


export type Subscription_RootReminderAssignmentsArgs = {
  distinctOn?: InputMaybe<Array<ReminderAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderAssignmentsOrderBy>>;
  where?: InputMaybe<ReminderAssignmentsBoolExp>;
};


export type Subscription_RootReminderAssignmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReminderAssignmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderAssignmentsOrderBy>>;
  where?: InputMaybe<ReminderAssignmentsBoolExp>;
};


export type Subscription_RootReminderAssignmentsByPkArgs = {
  reminderAssignmentGuid: Scalars['uuid'];
};


export type Subscription_RootReminderAssignmentsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ReminderAssignmentsStreamCursorInput>>;
  where?: InputMaybe<ReminderAssignmentsBoolExp>;
};


export type Subscription_RootReminderInternalNotificationsArgs = {
  distinctOn?: InputMaybe<Array<ReminderInternalNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderInternalNotificationsOrderBy>>;
  where?: InputMaybe<ReminderInternalNotificationsBoolExp>;
};


export type Subscription_RootReminderInternalNotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReminderInternalNotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReminderInternalNotificationsOrderBy>>;
  where?: InputMaybe<ReminderInternalNotificationsBoolExp>;
};


export type Subscription_RootReminderInternalNotificationsByPkArgs = {
  internalNotificationGuid: Scalars['uuid'];
  reminderGuid: Scalars['uuid'];
  type: ReminderInternalNotificationTypeEnum;
};


export type Subscription_RootReminderInternalNotificationsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<ReminderInternalNotificationsStreamCursorInput>>;
  where?: InputMaybe<ReminderInternalNotificationsBoolExp>;
};


export type Subscription_RootRemindersArgs = {
  distinctOn?: InputMaybe<Array<RemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RemindersOrderBy>>;
  where?: InputMaybe<RemindersBoolExp>;
};


export type Subscription_RootRemindersAggregateArgs = {
  distinctOn?: InputMaybe<Array<RemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RemindersOrderBy>>;
  where?: InputMaybe<RemindersBoolExp>;
};


export type Subscription_RootRemindersByPkArgs = {
  reminderGuid: Scalars['uuid'];
};


export type Subscription_RootRemindersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RemindersStreamCursorInput>>;
  where?: InputMaybe<RemindersBoolExp>;
};


export type Subscription_RootRepCompanyMetabaseConfigArgs = {
  distinctOn?: InputMaybe<Array<RepCompanyMetabaseConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepCompanyMetabaseConfigOrderBy>>;
  where?: InputMaybe<RepCompanyMetabaseConfigBoolExp>;
};


export type Subscription_RootRepCompanyMetabaseConfigAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepCompanyMetabaseConfigSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepCompanyMetabaseConfigOrderBy>>;
  where?: InputMaybe<RepCompanyMetabaseConfigBoolExp>;
};


export type Subscription_RootRepCompanyMetabaseConfigByPkArgs = {
  companyGuid: Scalars['uuid'];
};


export type Subscription_RootRepCompanyMetabaseConfigStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RepCompanyMetabaseConfigStreamCursorInput>>;
  where?: InputMaybe<RepCompanyMetabaseConfigBoolExp>;
};


export type Subscription_RootRepMetabaseCompanyReportsArgs = {
  distinctOn?: InputMaybe<Array<RepMetabaseCompanyReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabaseCompanyReportsOrderBy>>;
  where?: InputMaybe<RepMetabaseCompanyReportsBoolExp>;
};


export type Subscription_RootRepMetabaseCompanyReportsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepMetabaseCompanyReportsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabaseCompanyReportsOrderBy>>;
  where?: InputMaybe<RepMetabaseCompanyReportsBoolExp>;
};


export type Subscription_RootRepMetabaseCompanyReportsByPkArgs = {
  companyGuid: Scalars['uuid'];
  reportGuid: Scalars['uuid'];
};


export type Subscription_RootRepMetabaseCompanyReportsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RepMetabaseCompanyReportsStreamCursorInput>>;
  where?: InputMaybe<RepMetabaseCompanyReportsBoolExp>;
};


export type Subscription_RootRepMetabasePulsesArgs = {
  distinctOn?: InputMaybe<Array<RepMetabasePulsesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabasePulsesOrderBy>>;
  where?: InputMaybe<RepMetabasePulsesBoolExp>;
};


export type Subscription_RootRepMetabasePulsesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepMetabasePulsesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabasePulsesOrderBy>>;
  where?: InputMaybe<RepMetabasePulsesBoolExp>;
};


export type Subscription_RootRepMetabasePulsesByPkArgs = {
  pulseGuid: Scalars['uuid'];
};


export type Subscription_RootRepMetabasePulsesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RepMetabasePulsesStreamCursorInput>>;
  where?: InputMaybe<RepMetabasePulsesBoolExp>;
};


export type Subscription_RootRepMetabasePulsesV2Args = {
  distinctOn?: InputMaybe<Array<RepMetabasePulsesV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabasePulsesV2OrderBy>>;
  where?: InputMaybe<RepMetabasePulsesV2BoolExp>;
};


export type Subscription_RootRepMetabasePulsesV2AggregateArgs = {
  distinctOn?: InputMaybe<Array<RepMetabasePulsesV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabasePulsesV2OrderBy>>;
  where?: InputMaybe<RepMetabasePulsesV2BoolExp>;
};


export type Subscription_RootRepMetabasePulsesV2ByPkArgs = {
  pulseGuid: Scalars['uuid'];
};


export type Subscription_RootRepMetabasePulsesV2StreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RepMetabasePulsesV2StreamCursorInput>>;
  where?: InputMaybe<RepMetabasePulsesV2BoolExp>;
};


export type Subscription_RootRepMetabaseReportDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<RepMetabaseReportDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabaseReportDefinitionsOrderBy>>;
  where?: InputMaybe<RepMetabaseReportDefinitionsBoolExp>;
};


export type Subscription_RootRepMetabaseReportDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepMetabaseReportDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RepMetabaseReportDefinitionsOrderBy>>;
  where?: InputMaybe<RepMetabaseReportDefinitionsBoolExp>;
};


export type Subscription_RootRepMetabaseReportDefinitionsByPkArgs = {
  reportGuid: Scalars['uuid'];
};


export type Subscription_RootRepMetabaseReportDefinitionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<RepMetabaseReportDefinitionsStreamCursorInput>>;
  where?: InputMaybe<RepMetabaseReportDefinitionsBoolExp>;
};


export type Subscription_RootTagsArgs = {
  distinctOn?: InputMaybe<Array<TagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TagsOrderBy>>;
  where?: InputMaybe<TagsBoolExp>;
};


export type Subscription_RootTagsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TagsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TagsOrderBy>>;
  where?: InputMaybe<TagsBoolExp>;
};


export type Subscription_RootTagsByPkArgs = {
  tagGuid: Scalars['uuid'];
};


export type Subscription_RootTagsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TagsStreamCursorInput>>;
  where?: InputMaybe<TagsBoolExp>;
};


export type Subscription_RootTechnicianCapacitiesArgs = {
  distinctOn?: InputMaybe<Array<TechnicianCapacitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechnicianCapacitiesOrderBy>>;
  where?: InputMaybe<TechnicianCapacitiesBoolExp>;
};


export type Subscription_RootTechnicianCapacitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TechnicianCapacitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechnicianCapacitiesOrderBy>>;
  where?: InputMaybe<TechnicianCapacitiesBoolExp>;
};


export type Subscription_RootTechnicianCapacitiesByPkArgs = {
  technicianCapacityGuid: Scalars['uuid'];
};


export type Subscription_RootTechnicianCapacitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TechnicianCapacitiesStreamCursorInput>>;
  where?: InputMaybe<TechnicianCapacitiesBoolExp>;
};


export type Subscription_RootTechnicianCapacityBlocksArgs = {
  distinctOn?: InputMaybe<Array<TechnicianCapacityBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechnicianCapacityBlocksOrderBy>>;
  where?: InputMaybe<TechnicianCapacityBlocksBoolExp>;
};


export type Subscription_RootTechnicianCapacityBlocksAggregateArgs = {
  distinctOn?: InputMaybe<Array<TechnicianCapacityBlocksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechnicianCapacityBlocksOrderBy>>;
  where?: InputMaybe<TechnicianCapacityBlocksBoolExp>;
};


export type Subscription_RootTechnicianCapacityBlocksByPkArgs = {
  technicianCapacityBlockGuid: Scalars['uuid'];
};


export type Subscription_RootTechnicianCapacityBlocksStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TechnicianCapacityBlocksStreamCursorInput>>;
  where?: InputMaybe<TechnicianCapacityBlocksBoolExp>;
};


export type Subscription_RootTilledRawEventsArgs = {
  distinctOn?: InputMaybe<Array<TilledRawEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TilledRawEventsOrderBy>>;
  where?: InputMaybe<TilledRawEventsBoolExp>;
};


export type Subscription_RootTilledRawEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TilledRawEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TilledRawEventsOrderBy>>;
  where?: InputMaybe<TilledRawEventsBoolExp>;
};


export type Subscription_RootTilledRawEventsByPkArgs = {
  tilledRawEventGuid: Scalars['uuid'];
};


export type Subscription_RootTilledRawEventsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TilledRawEventsStreamCursorInput>>;
  where?: InputMaybe<TilledRawEventsBoolExp>;
};


export type Subscription_RootTimesheetEntriesArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntriesOrderBy>>;
  where?: InputMaybe<TimesheetEntriesBoolExp>;
};


export type Subscription_RootTimesheetEntriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntriesOrderBy>>;
  where?: InputMaybe<TimesheetEntriesBoolExp>;
};


export type Subscription_RootTimesheetEntriesByPkArgs = {
  timesheetEntryGuid: Scalars['uuid'];
};


export type Subscription_RootTimesheetEntriesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TimesheetEntriesStreamCursorInput>>;
  where?: InputMaybe<TimesheetEntriesBoolExp>;
};


export type Subscription_RootTimesheetEntryActivitiesArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryActivitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryActivitiesOrderBy>>;
  where?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
};


export type Subscription_RootTimesheetEntryActivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryActivitiesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryActivitiesOrderBy>>;
  where?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
};


export type Subscription_RootTimesheetEntryActivitiesByPkArgs = {
  timesheetEntryActivityGuid: Scalars['uuid'];
};


export type Subscription_RootTimesheetEntryActivitiesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TimesheetEntryActivitiesStreamCursorInput>>;
  where?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
};


export type Subscription_RootTimesheetEntryLinkDataArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryLinkDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryLinkDataOrderBy>>;
  where?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
};


export type Subscription_RootTimesheetEntryLinkDataAggregateArgs = {
  distinctOn?: InputMaybe<Array<TimesheetEntryLinkDataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TimesheetEntryLinkDataOrderBy>>;
  where?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
};


export type Subscription_RootTimesheetEntryLinkDataByPkArgs = {
  timesheetEntryGuid: Scalars['uuid'];
};


export type Subscription_RootTimesheetEntryLinkDataStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TimesheetEntryLinkDataStreamCursorInput>>;
  where?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
};


export type Subscription_RootTuneUpVisitEntitlementsArgs = {
  distinctOn?: InputMaybe<Array<TuneUpVisitEntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TuneUpVisitEntitlementsOrderBy>>;
  where?: InputMaybe<TuneUpVisitEntitlementsBoolExp>;
};


export type Subscription_RootTuneUpVisitEntitlementsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TuneUpVisitEntitlementsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TuneUpVisitEntitlementsOrderBy>>;
  where?: InputMaybe<TuneUpVisitEntitlementsBoolExp>;
};


export type Subscription_RootTuneUpVisitEntitlementsByPkArgs = {
  entitlementGuid: Scalars['uuid'];
};


export type Subscription_RootTuneUpVisitEntitlementsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<TuneUpVisitEntitlementsStreamCursorInput>>;
  where?: InputMaybe<TuneUpVisitEntitlementsBoolExp>;
};


export type Subscription_RootUnnotifiedAccountRemindersArgs = {
  distinctOn?: InputMaybe<Array<UnnotifiedAccountRemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UnnotifiedAccountRemindersOrderBy>>;
  where?: InputMaybe<UnnotifiedAccountRemindersBoolExp>;
};


export type Subscription_RootUnnotifiedAccountRemindersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UnnotifiedAccountRemindersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UnnotifiedAccountRemindersOrderBy>>;
  where?: InputMaybe<UnnotifiedAccountRemindersBoolExp>;
};


export type Subscription_RootUnnotifiedAccountRemindersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UnnotifiedAccountRemindersStreamCursorInput>>;
  where?: InputMaybe<UnnotifiedAccountRemindersBoolExp>;
};


export type Subscription_RootUserBusinessUnitsArgs = {
  distinctOn?: InputMaybe<Array<UserBusinessUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBusinessUnitsOrderBy>>;
  where?: InputMaybe<UserBusinessUnitsBoolExp>;
};


export type Subscription_RootUserBusinessUnitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserBusinessUnitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserBusinessUnitsOrderBy>>;
  where?: InputMaybe<UserBusinessUnitsBoolExp>;
};


export type Subscription_RootUserBusinessUnitsByPkArgs = {
  userBusinessUnitGuid: Scalars['uuid'];
};


export type Subscription_RootUserBusinessUnitsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserBusinessUnitsStreamCursorInput>>;
  where?: InputMaybe<UserBusinessUnitsBoolExp>;
};


export type Subscription_RootUserPermissionsArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsOrderBy>>;
  where?: InputMaybe<UserPermissionsBoolExp>;
};


export type Subscription_RootUserPermissionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsOrderBy>>;
  where?: InputMaybe<UserPermissionsBoolExp>;
};


export type Subscription_RootUserPermissionsByPkArgs = {
  permissionName: Scalars['String'];
  userGuid: Scalars['uuid'];
};


export type Subscription_RootUserPermissionsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPermissionsStreamCursorInput>>;
  where?: InputMaybe<UserPermissionsBoolExp>;
};


export type Subscription_RootUserPermissionsV2Args = {
  distinctOn?: InputMaybe<Array<UserPermissionsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsV2OrderBy>>;
  where?: InputMaybe<UserPermissionsV2BoolExp>;
};


export type Subscription_RootUserPermissionsV2AggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPermissionsV2SelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPermissionsV2OrderBy>>;
  where?: InputMaybe<UserPermissionsV2BoolExp>;
};


export type Subscription_RootUserPermissionsV2ByPkArgs = {
  permissionName: Scalars['String'];
  userGuid: Scalars['uuid'];
};


export type Subscription_RootUserPermissionsV2StreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPermissionsV2StreamCursorInput>>;
  where?: InputMaybe<UserPermissionsV2BoolExp>;
};


export type Subscription_RootUserPhoneNumbersArgs = {
  distinctOn?: InputMaybe<Array<UserPhoneNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPhoneNumbersOrderBy>>;
  where?: InputMaybe<UserPhoneNumbersBoolExp>;
};


export type Subscription_RootUserPhoneNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserPhoneNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserPhoneNumbersOrderBy>>;
  where?: InputMaybe<UserPhoneNumbersBoolExp>;
};


export type Subscription_RootUserPhoneNumbersByPkArgs = {
  phoneNumberGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
};


export type Subscription_RootUserPhoneNumbersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserPhoneNumbersStreamCursorInput>>;
  where?: InputMaybe<UserPhoneNumbersBoolExp>;
};


export type Subscription_RootUserRolesArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type Subscription_RootUserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type Subscription_RootUserRolesByPkArgs = {
  role: Scalars['String'];
  userGuid: Scalars['uuid'];
};


export type Subscription_RootUserRolesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserRolesStreamCursorInput>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type Subscription_RootUserSettingsArgs = {
  distinctOn?: InputMaybe<Array<UserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
  where?: InputMaybe<UserSettingsBoolExp>;
};


export type Subscription_RootUserSettingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
  where?: InputMaybe<UserSettingsBoolExp>;
};


export type Subscription_RootUserSettingsByPkArgs = {
  userGuid: Scalars['uuid'];
};


export type Subscription_RootUserSettingsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserSettingsStreamCursorInput>>;
  where?: InputMaybe<UserSettingsBoolExp>;
};


export type Subscription_RootUserWagesArgs = {
  distinctOn?: InputMaybe<Array<UserWagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserWagesOrderBy>>;
  where?: InputMaybe<UserWagesBoolExp>;
};


export type Subscription_RootUserWagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserWagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserWagesOrderBy>>;
  where?: InputMaybe<UserWagesBoolExp>;
};


export type Subscription_RootUserWagesByPkArgs = {
  userWageGuid: Scalars['uuid'];
};


export type Subscription_RootUserWagesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UserWagesStreamCursorInput>>;
  where?: InputMaybe<UserWagesBoolExp>;
};


export type Subscription_RootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootUsersByPkArgs = {
  userGuid: Scalars['uuid'];
};


export type Subscription_RootUsersStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<UsersStreamCursorInput>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootWisetackLoanRecordsArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanRecordsOrderBy>>;
  where?: InputMaybe<WisetackLoanRecordsBoolExp>;
};


export type Subscription_RootWisetackLoanRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanRecordsOrderBy>>;
  where?: InputMaybe<WisetackLoanRecordsBoolExp>;
};


export type Subscription_RootWisetackLoanRecordsByPkArgs = {
  wisetackLoanRecordGuid: Scalars['uuid'];
};


export type Subscription_RootWisetackLoanRecordsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<WisetackLoanRecordsStreamCursorInput>>;
  where?: InputMaybe<WisetackLoanRecordsBoolExp>;
};


export type Subscription_RootWisetackLoanStatusesArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanStatusesOrderBy>>;
  where?: InputMaybe<WisetackLoanStatusesBoolExp>;
};


export type Subscription_RootWisetackLoanStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackLoanStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackLoanStatusesOrderBy>>;
  where?: InputMaybe<WisetackLoanStatusesBoolExp>;
};


export type Subscription_RootWisetackLoanStatusesByPkArgs = {
  wisetackLoanStatusGuid: Scalars['uuid'];
};


export type Subscription_RootWisetackLoanStatusesStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<WisetackLoanStatusesStreamCursorInput>>;
  where?: InputMaybe<WisetackLoanStatusesBoolExp>;
};


export type Subscription_RootWisetackPrequalRecordsArgs = {
  distinctOn?: InputMaybe<Array<WisetackPrequalRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackPrequalRecordsOrderBy>>;
  where?: InputMaybe<WisetackPrequalRecordsBoolExp>;
};


export type Subscription_RootWisetackPrequalRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackPrequalRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackPrequalRecordsOrderBy>>;
  where?: InputMaybe<WisetackPrequalRecordsBoolExp>;
};


export type Subscription_RootWisetackPrequalRecordsByPkArgs = {
  wisetackPrequalRecordGuid: Scalars['uuid'];
};


export type Subscription_RootWisetackPrequalRecordsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<WisetackPrequalRecordsStreamCursorInput>>;
  where?: InputMaybe<WisetackPrequalRecordsBoolExp>;
};


export type Subscription_RootWisetackWebhookEventsArgs = {
  distinctOn?: InputMaybe<Array<WisetackWebhookEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackWebhookEventsOrderBy>>;
  where?: InputMaybe<WisetackWebhookEventsBoolExp>;
};


export type Subscription_RootWisetackWebhookEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<WisetackWebhookEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WisetackWebhookEventsOrderBy>>;
  where?: InputMaybe<WisetackWebhookEventsBoolExp>;
};


export type Subscription_RootWisetackWebhookEventsByPkArgs = {
  wisetackWebhookEventGuid: Scalars['uuid'];
};


export type Subscription_RootWisetackWebhookEventsStreamArgs = {
  batchSize: Scalars['Int'];
  cursor: Array<InputMaybe<WisetackWebhookEventsStreamCursorInput>>;
  where?: InputMaybe<WisetackWebhookEventsBoolExp>;
};

export type TimesheetEntriesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TimesheetEntriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TimesheetEntriesBoolExp>;
  predicate: IntComparisonExp;
};

export type TimesheetEntryActivitiesAggregateBoolExpBool_And = {
  arguments: TimesheetEntryActivitiesSelectColumnTimesheetEntryActivitiesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type TimesheetEntryActivitiesAggregateBoolExpBool_Or = {
  arguments: TimesheetEntryActivitiesSelectColumnTimesheetEntryActivitiesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type TimesheetEntryActivitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TimesheetEntryActivitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TimesheetEntryActivitiesBoolExp>;
  predicate: IntComparisonExp;
};

export type TimesheetEntryLinkDataAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TimesheetEntryLinkDataSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TimesheetEntryLinkDataBoolExp>;
  predicate: IntComparisonExp;
};

export type UserPermissionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserPermissionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserPermissionsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserPermissionsV2AggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserPermissionsV2SelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserPermissionsV2BoolExp>;
  predicate: IntComparisonExp;
};

export type UserPhoneNumbersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserPhoneNumbersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserPhoneNumbersBoolExp>;
  predicate: IntComparisonExp;
};

export type UserRolesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserRolesBoolExp>;
  predicate: IntComparisonExp;
};

export type UserSettingsAggregateBoolExpBool_And = {
  arguments: UserSettingsSelectColumnUserSettingsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserSettingsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UserSettingsAggregateBoolExpBool_Or = {
  arguments: UserSettingsSelectColumnUserSettingsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserSettingsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UserSettingsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserSettingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserSettingsBoolExp>;
  predicate: IntComparisonExp;
};

export type WisetackLoanRecordsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<WisetackLoanRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<WisetackLoanRecordsBoolExp>;
  predicate: IntComparisonExp;
};

export type WisetackLoanStatusesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<WisetackLoanStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<WisetackLoanStatusesBoolExp>;
  predicate: IntComparisonExp;
};

export type WisetackPrequalRecordsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<WisetackPrequalRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<WisetackPrequalRecordsBoolExp>;
  predicate: IntComparisonExp;
};

export type FetchCompanyInfoBoxDataQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  companyUsersWhere?: InputMaybe<CompanyUsersBoolExp>;
}>;


export type FetchCompanyInfoBoxDataQuery = { __typename?: 'query_root', companies: Array<{ __typename?: 'Companies', name: string, companyConfig?: { __typename?: 'CompanyConfig', blurb?: string | undefined } | undefined, billingProfile?: { __typename?: 'BillingProfiles', logoUrl: string, websiteUrl?: string | undefined, websiteDisplayName?: string | undefined, phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string }, emailAddress: { __typename?: 'EmailAddresses', emailAddress: string } } | undefined, companyUsers: Array<{ __typename?: 'CompanyUsers', userByUserGuid: { __typename?: 'Users', userGuid: string, fullName: string, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined } }> }> };

export type CompanyUsersQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type CompanyUsersQuery = { __typename?: 'query_root', companyUsers: Array<{ __typename?: 'CompanyUsers', userByUserGuid: { __typename?: 'Users', deactivatedAt?: IsoDateString | undefined, userGuid: string, firstNameInitial?: string | undefined } }> };

export type DeleteReminderMutationVariables = Exact<{
  reminderGuid: Scalars['uuid'];
}>;


export type DeleteReminderMutation = { __typename?: 'mutation_root', deleteRemindersByPk?: { __typename?: 'Reminders', companyGuid: string } | undefined };

export type AccountRemindersQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
}>;


export type AccountRemindersQuery = { __typename?: 'query_root', accountReminders: Array<{ __typename?: 'AccountReminders', reminder: { __typename?: 'Reminders', reminderGuid: string, status: ReminderStatusTypesEnum, description: string, dueAt: IsoDateString, updatedAt: IsoDateString, createdByUser: { __typename?: 'Users', userGuid: string, firstNameInitial?: string | undefined }, reminderAssignments: Array<{ __typename?: 'ReminderAssignments', user: { __typename?: 'Users', userGuid: string, firstNameInitial?: string | undefined } }> } }> };

export type DistinctReminderDescriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DistinctReminderDescriptionsQuery = { __typename?: 'query_root', remindersAggregate: { __typename?: 'RemindersAggregate', nodes: Array<{ __typename?: 'Reminders', description: string }> } };

export type UpdateReminderStatusMutationVariables = Exact<{
  reminderGuid: Scalars['uuid'];
  status: ReminderStatusTypesEnum;
}>;


export type UpdateReminderStatusMutation = { __typename?: 'mutation_root', updateRemindersByPk?: { __typename?: 'Reminders', reminderGuid: string, status: ReminderStatusTypesEnum } | undefined };

export type UpsertAccountingCartItemTypeAccountsConfigMutationVariables = Exact<{
  object?: InputMaybe<AccCartItemTypeAccountsConfigInsertInput>;
}>;


export type UpsertAccountingCartItemTypeAccountsConfigMutation = { __typename?: 'mutation_root', insertAccCartItemTypeAccountsConfigOne?: { __typename: 'AccCartItemTypeAccountsConfig' } | undefined };

export type FetchAccountingCartItemTypeAccountsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchAccountingCartItemTypeAccountsQuery = { __typename?: 'query_root', accCartItemTypeAccountsConfig: Array<{ __typename?: 'AccCartItemTypeAccountsConfig', defaultItemIncomeAccountId: string, equipmentItemDefaultIncomeAccountId?: string | undefined, laborItemDefaultIncomeAccountId?: string | undefined, materialItemDefaultIncomeAccountId?: string | undefined, membershipItemDefaultIncomeAccountId?: string | undefined, serviceItemDefaultIncomeAccountId?: string | undefined, inventoryAssetAccountId?: string | undefined, costOfGoodsSoldAccountId?: string | undefined, discountDefaultIncomeAccountId?: string | undefined }> };

export type FetchAccountingPayoutAccountsConfigQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchAccountingPayoutAccountsConfigQuery = { __typename?: 'query_root', accPayoutAccountsConfig: Array<{ __typename?: 'AccPayoutAccountsConfig', payoutDepositAccountId?: string | undefined, payoutFeesAccountId?: string | undefined, payoutPaymentProcessorBalanceAccountId?: string | undefined, payoutRefundsAccountId?: string | undefined, accountingIntegrationType: string }> };

export type UpsertAccountingPayoutAccountsConfigMutationVariables = Exact<{
  object?: InputMaybe<AccPayoutAccountsConfigInsertInput>;
}>;


export type UpsertAccountingPayoutAccountsConfigMutation = { __typename?: 'mutation_root', insertAccPayoutAccountsConfigOne?: { __typename: 'AccPayoutAccountsConfig' } | undefined };

export type FetchQboAuthTokensInvalidQueryVariables = Exact<{
  companyGuid?: InputMaybe<Scalars['uuid']>;
}>;


export type FetchQboAuthTokensInvalidQuery = { __typename?: 'query_root', qboAuthData: Array<{ __typename?: 'QboAuthData', isInvalid: boolean }> };

export type DoNotServiceQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type DoNotServiceQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', doNotService: boolean, doNotServiceReason?: string | undefined } | undefined };

export type OpenAccountBalanceSubscriptionVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type OpenAccountBalanceSubscription = { __typename?: 'subscription_root', aggregatableInvoicesAggregate: { __typename?: 'AggregatableInvoicesAggregate', nodes: Array<{ __typename?: 'AggregatableInvoices', dueAt?: IsoDateString | undefined, invoiceGuid: string, displayIdString?: string | undefined, paidUsd: number, totalUsc: number, issuedAt?: IsoDateString | undefined, status: InvoiceV2Status, dueUsc?: number | undefined, jobLink?: { __typename?: 'JobInvoices', job: { __typename?: 'Jobs', jobGuid: string, displayIdString?: string | undefined, jobType: { __typename?: 'JobTypes', name: string } } } | undefined, createdByUser?: { __typename?: 'Users', deactivatedAt?: IsoDateString | undefined, userGuid: string, firstName: string, lastName: string, userPrimaryHueHex?: string | undefined, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }>, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined } | undefined }> } };

export type OverdueAccountBalanceConfigQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type OverdueAccountBalanceConfigQuery = { __typename?: 'query_root', companyConfig: Array<{ __typename?: 'CompanyConfig', overdueAccountBalanceEnabled: boolean }> };

export type FetchActivityItemsByCompanyGuidQueryVariables = Exact<{
  companyGuid?: InputMaybe<Scalars['uuid']>;
}>;


export type FetchActivityItemsByCompanyGuidQuery = { __typename?: 'query_root', activityItems: Array<{ __typename?: 'ActivityItems', activityItemGuid: string, activityItemType: ActivityItemTypesEnum, content: string, createdAt: IsoDateString }> };

export type FetchActivityItemsByAccountGuidQueryVariables = Exact<{
  companyGuid?: InputMaybe<Scalars['uuid']>;
  accountGuid?: InputMaybe<Scalars['uuid']>;
}>;


export type FetchActivityItemsByAccountGuidQuery = { __typename?: 'query_root', activityItems: Array<{ __typename?: 'ActivityItems', activityItemGuid: string, activityItemType: ActivityItemTypesEnum, createdAt: IsoDateString, content: string }> };

export type FetchActivityItemsByJobGuidQueryVariables = Exact<{
  companyGuid?: InputMaybe<Scalars['uuid']>;
  jobGuid?: InputMaybe<Scalars['uuid']>;
}>;


export type FetchActivityItemsByJobGuidQuery = { __typename?: 'query_root', activityItems: Array<{ __typename?: 'ActivityItems', activityItemGuid: string, activityItemType: ActivityItemTypesEnum, content: string, createdAt: IsoDateString }> };

export type FetchReportDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchReportDefinitionsQuery = { __typename?: 'query_root', repMetabaseReportDefinitions: Array<{ __typename?: 'RepMetabaseReportDefinitions', reportGuid: string, reportTitle: string, reportCategory: EmbeddedReportCategory, reportType: EmbeddedReportType }> };

export type FetchPayableInvoicesForAccountQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type FetchPayableInvoicesForAccountQuery = { __typename?: 'query_root', aggregatableInvoices: Array<{ __typename?: 'AggregatableInvoices', invoiceGuid: string, displayIdV2?: string | undefined, dueUsc?: number | undefined, totalUsc: number, paidUsc?: number | undefined, issuedAt?: IsoDateString | undefined, numDaysOverdue?: number | undefined }> };

export type CancelAppointmentMutationVariables = Exact<{
  jobAppointmentGuid: Scalars['uuid'];
  cancellationStatus: JobAppointmentCancellationStatusesInsertInput;
}>;


export type CancelAppointmentMutation = { __typename?: 'mutation_root', deleteJobAppointmentAssignments?: { __typename: 'JobAppointmentAssignmentsMutationResponse' } | undefined, insertJobAppointmentCancellationStatusesOne?: { __typename: 'JobAppointmentCancellationStatuses' } | undefined };

export type DeleteAssignmentMutationVariables = Exact<{
  jobAppointmentAssignmentGuid: Scalars['uuid'];
}>;


export type DeleteAssignmentMutation = { __typename?: 'mutation_root', deleteJobAppointmentAssignmentsByPk?: { __typename: 'JobAppointmentAssignments' } | undefined, deleteJobAppointmentAssignmentStatuses?: { __typename?: 'JobAppointmentAssignmentStatusesMutationResponse', affectedRows: number } | undefined };

export type WisetackFinancingPrequalRecordCardQueryQueryVariables = Exact<{
  where: WisetackPrequalRecordsBoolExp;
}>;


export type WisetackFinancingPrequalRecordCardQueryQuery = { __typename?: 'query_root', wisetackPrequalRecords: Array<{ __typename?: 'WisetackPrequalRecords', contact: { __typename?: 'Contacts', fullName: string } }> };

export type ContactsWidgetContactFragment = { __typename?: 'AccountContacts', contactGuid: string, primary: boolean, contact: { __typename?: 'Contacts', fullName: string, notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined } };

export type ContactsWidgetDataSubscriptionVariables = Exact<{
  where: AccountContactsBoolExp;
}>;


export type ContactsWidgetDataSubscription = { __typename?: 'subscription_root', accountContacts: Array<{ __typename?: 'AccountContacts', contactGuid: string, primary: boolean, contact: { __typename?: 'Contacts', fullName: string, notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined } }> };

export type FindActiveMaintenancePlanAtAccountLocationQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  accountGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
}>;


export type FindActiveMaintenancePlanAtAccountLocationQuery = { __typename?: 'query_root', maintenancePlansQueryable: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, status: MaintenancePlanStatus, credits: CreditRecordArray, terminatesAt?: IsoDateString | undefined, lastVisitedAt?: IsoDateString | undefined, activatedAt?: IsoDateString | undefined, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined }> };

export type FindJobTypeRevenuePotentialQueryVariables = Exact<{
  jobTypeGuid: Scalars['uuid'];
}>;


export type FindJobTypeRevenuePotentialQuery = { __typename?: 'query_root', jobTypesByPk?: { __typename?: 'JobTypes', isOpportunity: boolean, opportunityConversionThresholdUsc?: number | undefined, isPotentialHotLead: boolean, hotLeadMinimumEquipmentAgeYears?: number | undefined } | undefined };

export type CreateOrEditJobFormLinkedJobQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
}>;


export type CreateOrEditJobFormLinkedJobQueryQuery = { __typename?: 'query_root', jobs: Array<{ __typename?: 'Jobs', pointOfContact: { __typename?: 'Contacts', fullName: string }, jobType: { __typename?: 'JobTypes', name: string }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', jobLifecycle: { __typename?: 'JobLifecycles', name: string } }, photoLinksAggregate: { __typename?: 'PhotoLinksAggregate', aggregate?: { __typename?: 'PhotoLinksAggregateFields', count: number } | undefined }, noteLinksAggregate: { __typename?: 'NoteLinksAggregate', aggregate?: { __typename?: 'NoteLinksAggregateFields', count: number } | undefined }, fileLinksAggregate: { __typename?: 'FileLinksAggregate', aggregate?: { __typename?: 'FileLinksAggregateFields', count: number } | undefined }, estimates: Array<{ __typename?: 'Estimates', estimateGuid: string, displayId: number, estimateOptions: Array<{ __typename?: 'EstimateOptions', isSelected: boolean, totalUsc: number }> }>, jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, displayIdV2: string, totalUsc: number } }>, appointments: Array<{ __typename?: 'JobAppointments', appointmentType: AppointmentType, appointmentChecklistInstances: Array<{ __typename?: 'AppointmentChecklistInstances', appointmentChecklistInstanceGuid: string, lastEditor?: { __typename?: 'Users', fullName: string } | undefined, appointmentChecklist: { __typename?: 'AppointmentChecklists', name: string } }> }> }> };

export type GetDownloadableInvoiceDataQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
}>;


export type GetDownloadableInvoiceDataQuery = { __typename?: 'query_root', billingProfilesByPk?: { __typename?: 'BillingProfiles', estimateDisclaimer: string, invoiceTerm?: InvoiceTermsEnum | undefined, logoUrl: string, invoiceMemo?: string | undefined, businessFullLegalName: string, contractorLicenseNumber?: string | undefined, websiteDisplayName?: string | undefined, defaultTaxRate?: { __typename?: 'PricebookTaxRates', pricebookTaxRateGuid: string, rate: number, name: string } | undefined, logoPhoto: { __typename?: 'Photos', cdnUrl: string }, businessAddress?: { __typename?: 'Addresses', city: string, line1: string, line2?: string | undefined, zipCode: string, stateAbbreviation: string } | undefined, emailAddress: { __typename?: 'EmailAddresses', emailAddress: string }, phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string } } | undefined, companyConfigByPk?: { __typename?: 'CompanyConfig', blurb?: string | undefined } | undefined, jobsByPk?: { __typename?: 'Jobs', location: { __typename?: 'Locations', address: { __typename?: 'Addresses', city: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string, geoLocation: Geo } }, pointOfContact: { __typename?: 'Contacts', fullName: string }, account: { __typename?: 'Accounts', mailingAddress?: { __typename?: 'Addresses', line2?: string | undefined, line1: string, city: string, zipCode: string, stateAbbreviation: string } | undefined, primaryContact: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', fullName: string } }>, firstLocation: Array<{ __typename?: 'AccountLocations', location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string, geoLocation: Geo } } }> } } | undefined };

export type EditJobModalJobQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
}>;


export type EditJobModalJobQueryQuery = { __typename?: 'query_root', jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, locationGuid: string, accountGuid: string, installProjectType?: string | undefined, summary?: string | undefined, summaryHtml?: HtmlString | undefined, pointOfContactGuid: string, isOpportunity: boolean, isHotLead: boolean, isMembershipOpportunity: boolean, isMembershipRenewalOpportunity: boolean, workCompletedAt?: IsoDateString | undefined, useMaintenancePlanCredit: boolean, customerPurchaseOrderNumber?: string | undefined, businessUnit?: { __typename?: 'BusinessUnits', businessUnitGuid: string, name: string } | undefined, jobType: { __typename?: 'JobTypes', name: string, description: string, defaultSummary?: string | undefined, hideJobSummaryField?: boolean | undefined, isIncludedInJobCosting: boolean, companyGuid: string, lastModifiedBy: string, jobTypeGuid: string, jobLifecycleGuid: string, jobClass: JobClassesEnum, createdAt: IsoDateString, updatedAt: IsoDateString, isOpportunity: boolean, opportunityConversionThresholdUsc?: number | undefined, isPotentialHotLead: boolean, hotLeadMinimumEquipmentAgeYears?: number | undefined, durationMinutes: number, defaultBusinessUnitGuid?: string | undefined, color?: string | undefined, jobLifecycle: { __typename?: 'JobLifecycles', name: string, jobLifecycleGuid: string } }, equipmentTypeJobLinks: Array<{ __typename?: 'EquipmentTypeLinks', equipmentType: EquipmentType, estimatedEquipmentAge?: string | undefined, relationshipType: JobToEquipmentRelationshipType }>, tags: Array<{ __typename?: 'JobTags', tagGuid: string }>, location: { __typename?: 'Locations', maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }> }> }, purchaseOrders: Array<{ __typename?: 'PurchaseOrders', purchaseOrderGuid: string, purchaseOrderNumber: string }> }>, companyLeadSourceLinks: Array<{ __typename?: 'CompanyLeadSourceLinks', companyLeadSourceGuid: string, referringContactGuid?: string | undefined, attributionDescription?: string | undefined }> };

export type EquipmentWidgetEquipmentFragment = { __typename?: 'InstalledEquipment', installedEquipmentGuid: string, manufacturer?: string | undefined, installationDate?: LocalDateString | undefined, installationParty?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, equipmentType: string, serialNumber?: string | undefined, modelNumber?: string | undefined, operationalStatus: string, equipmentCondition?: string | undefined, averageLifeExpectancyYears?: number | undefined, manufacturerWarrantyEndDate?: LocalDateString | undefined, manufacturerWarrantyStartDate?: LocalDateString | undefined, manufacturerWarrantyTerms?: string | undefined, laborWarrantyStartDate?: LocalDateString | undefined, laborWarrantyEndDate?: LocalDateString | undefined, laborWarrantyTerms?: string | undefined, equipmentDimensions?: string | undefined, manufacturingDate?: LocalDateString | undefined, description?: string | undefined, sourceType: InstalledEquipmentSourceType, location: { __typename?: 'Locations', jobs: Array<{ __typename?: 'Jobs', account: { __typename?: 'Accounts', lastJobDate?: IsoDateString | undefined } }> } };

export type EquipmentWidgetDataSubscriptionVariables = Exact<{
  where: InstalledEquipmentBoolExp;
}>;


export type EquipmentWidgetDataSubscription = { __typename?: 'subscription_root', equipment: Array<{ __typename?: 'InstalledEquipment', installedEquipmentGuid: string, manufacturer?: string | undefined, installationDate?: LocalDateString | undefined, installationParty?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, equipmentType: string, serialNumber?: string | undefined, modelNumber?: string | undefined, operationalStatus: string, equipmentCondition?: string | undefined, averageLifeExpectancyYears?: number | undefined, manufacturerWarrantyEndDate?: LocalDateString | undefined, manufacturerWarrantyStartDate?: LocalDateString | undefined, manufacturerWarrantyTerms?: string | undefined, laborWarrantyStartDate?: LocalDateString | undefined, laborWarrantyEndDate?: LocalDateString | undefined, laborWarrantyTerms?: string | undefined, equipmentDimensions?: string | undefined, manufacturingDate?: LocalDateString | undefined, description?: string | undefined, sourceType: InstalledEquipmentSourceType, location: { __typename?: 'Locations', jobs: Array<{ __typename?: 'Jobs', account: { __typename?: 'Accounts', lastJobDate?: IsoDateString | undefined } }> } }> };

export type EquipmentWidgetUpdateOperationalStatusMutationMutationVariables = Exact<{
  installedEquipmentGuid: Scalars['uuid'];
  operationalStatus: Scalars['String'];
}>;


export type EquipmentWidgetUpdateOperationalStatusMutationMutation = { __typename?: 'mutation_root', updateInstalledEquipmentByPk?: { __typename?: 'InstalledEquipment', operationalStatus: string } | undefined };

export type EstimatesWidgetEstimateFragment = { __typename?: 'Estimates', displayId: number, createdAt: IsoDateString, status: EstimateV2Status, estimateGuid: string, createdByUser: { __typename?: 'Users', fullName: string }, options: Array<{ __typename?: 'EstimateOptions', seq: number, displayName?: string | undefined, totalUsc: number, isRecommended: boolean, isSelected: boolean, taxConfiguration?: { __typename?: 'EstimateOptionTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined, cartItems: Array<{ __typename?: 'EstimateOptionCartItems', cartItem: { __typename?: 'CartItems', name: string, unitPriceUsc: number, quantity: number, isDiscountable: boolean, cartItemCode?: string | undefined } }>, discounts: Array<{ __typename?: 'EstimateOptionDiscounts', discountAmountUsc?: number | undefined, discountRate?: number | undefined, type: DiscountType }> }>, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, account: { __typename?: 'Accounts', accountGuid: string, accountDisplayName: string }, pointOfContact: { __typename?: 'Contacts', fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string, zipCode: string } } } };

export type EstimatesWidgetDataSubscriptionVariables = Exact<{
  where: EstimatesBoolExp;
}>;


export type EstimatesWidgetDataSubscription = { __typename?: 'subscription_root', estimates: Array<{ __typename?: 'Estimates', displayId: number, createdAt: IsoDateString, status: EstimateV2Status, estimateGuid: string, createdByUser: { __typename?: 'Users', fullName: string }, options: Array<{ __typename?: 'EstimateOptions', seq: number, displayName?: string | undefined, totalUsc: number, isRecommended: boolean, isSelected: boolean, taxConfiguration?: { __typename?: 'EstimateOptionTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined, cartItems: Array<{ __typename?: 'EstimateOptionCartItems', cartItem: { __typename?: 'CartItems', name: string, unitPriceUsc: number, quantity: number, isDiscountable: boolean, cartItemCode?: string | undefined } }>, discounts: Array<{ __typename?: 'EstimateOptionDiscounts', discountAmountUsc?: number | undefined, discountRate?: number | undefined, type: DiscountType }> }>, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, account: { __typename?: 'Accounts', accountGuid: string, accountDisplayName: string }, pointOfContact: { __typename?: 'Contacts', fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string, zipCode: string } } } }> };

export type FileUpdateNameMutationVariables = Exact<{
  fileGuid: Scalars['uuid'];
  fileName: Scalars['String'];
}>;


export type FileUpdateNameMutation = { __typename?: 'mutation_root', updateFilesByPk?: { __typename?: 'Files', fileName: string } | undefined };

export type LoanRecordSubscriptionVariables = Exact<{
  companyGuid: Scalars['uuid'];
  loanRecordGuid: Scalars['uuid'];
}>;


export type LoanRecordSubscription = { __typename?: 'subscription_root', wisetackLoanRecords: Array<{ __typename?: 'WisetackLoanRecords', wisetackLoanRecordGuid: string, accountGuid: string, companyGuid: string, invoiceGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackMerchantGuid: string, wisetackTransactionGuid: string, requestedLoanAmountUsc: number, approvedLoanAmountUsc?: number | undefined, settledLoanAmountUsc?: number | undefined, processingFeeUsc?: number | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, expiresAt?: IsoDateString | undefined, loanApplicationLink: string, wisetackLoanStatuses: Array<{ __typename?: 'WisetackLoanStatuses', loanStatus: WisetackLoanStatusTypesEnum, loanStatusDetail?: string | undefined, occurredAt: IsoDateString, createdAt?: IsoDateString | undefined }>, contact: { __typename?: 'Contacts', fullName: string } }> };

export type PrequalRecordSubscriptionVariables = Exact<{
  companyGuid: Scalars['uuid'];
  prequalRecordGuid: Scalars['uuid'];
}>;


export type PrequalRecordSubscription = { __typename?: 'subscription_root', wisetackPrequalRecords: Array<{ __typename?: 'WisetackPrequalRecords', wisetackPrequalRecordGuid: string, accountGuid: string, companyGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackPrequalGuid: string, wisetackMerchantGuid: string, prequalifiedAmountUsc?: number | undefined, maxQualifiedAmountUsc?: number | undefined, aprRange?: string | undefined, status: WisetackPrequalStatusTypesEnum, expirationDate?: IsoDateString | undefined, prequalifiedAt?: IsoDateString | undefined, declinedAt?: IsoDateString | undefined, expiredAt?: IsoDateString | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, prequalLink: string }> };

export type FinancingAccountInfoQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type FinancingAccountInfoQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', accountGuid: string, accountContacts: Array<{ __typename?: 'AccountContacts', primary: boolean, accountContactGuid: string, archived: boolean, accountGuid: string, companyGuid: string, contact: { __typename?: 'Contacts', contactGuid: string, companyGuid: string, firstName: string, lastName: string, notificationPreferenceType: NotificationPreferenceType, salutation?: string | undefined, title?: string | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddressGuid: string, emailAddress: string, companyGuid: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, type: PhoneNumberType, companyGuid: string } | undefined } }> } | undefined };

export type LoanRecordInvoiceDetailsSubscriptionSubscriptionVariables = Exact<{
  invoiceGuid: Scalars['uuid'];
}>;


export type LoanRecordInvoiceDetailsSubscriptionSubscription = { __typename?: 'subscription_root', wisetackLoanRecords: Array<{ __typename?: 'WisetackLoanRecords', invoiceV2?: { __typename?: 'Invoices', invoiceGuid: string, displayId: number, displayIdV2: string, serviceCompletionDate?: LocalDateString | undefined, messageHtml?: HtmlString | undefined } | undefined }> };

export type FetchPrequalRecordQueryVariables = Exact<{
  where: WisetackPrequalRecordsBoolExp;
}>;


export type FetchPrequalRecordQuery = { __typename?: 'query_root', wisetackPrequalRecords: Array<{ __typename?: 'WisetackPrequalRecords', contact: { __typename?: 'Contacts', fullName: string } }> };

export type FetchContactInvoiceLoanAmountsQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
}>;


export type FetchContactInvoiceLoanAmountsQuery = { __typename?: 'query_root', wisetackLoanRecords: Array<{ __typename?: 'WisetackLoanRecords', requestedLoanAmountUsc: number, contactGuid: string, invoiceGuid: string, wisetackLoanStatuses: Array<{ __typename?: 'WisetackLoanStatuses', loanStatus: WisetackLoanStatusTypesEnum }> }> };

export type DeclinedAccountPrequalRecordsQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type DeclinedAccountPrequalRecordsQuery = { __typename?: 'query_root', wisetackPrequalRecords: Array<{ __typename?: 'WisetackPrequalRecords', contact: { __typename?: 'Contacts', contactGuid: string } }> };

export type PrequalRecordsSubByAccountSubscriptionVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type PrequalRecordsSubByAccountSubscription = { __typename?: 'subscription_root', wisetackPrequalRecords: Array<{ __typename?: 'WisetackPrequalRecords', wisetackPrequalRecordGuid: string, accountGuid: string, companyGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackPrequalGuid: string, wisetackMerchantGuid: string, prequalifiedAmountUsc?: number | undefined, maxQualifiedAmountUsc?: number | undefined, aprRange?: string | undefined, status: WisetackPrequalStatusTypesEnum, expirationDate?: IsoDateString | undefined, prequalifiedAt?: IsoDateString | undefined, declinedAt?: IsoDateString | undefined, expiredAt?: IsoDateString | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, prequalLink: string, contact: { __typename?: 'Contacts', fullName: string } }> };

export type PrequalRecordsByAccountQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type PrequalRecordsByAccountQuery = { __typename?: 'query_root', wisetackPrequalRecords: Array<{ __typename?: 'WisetackPrequalRecords', wisetackPrequalRecordGuid: string, accountGuid: string, companyGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackPrequalGuid: string, wisetackMerchantGuid: string, prequalifiedAmountUsc?: number | undefined, maxQualifiedAmountUsc?: number | undefined, aprRange?: string | undefined, status: WisetackPrequalStatusTypesEnum, expirationDate?: IsoDateString | undefined, prequalifiedAt?: IsoDateString | undefined, declinedAt?: IsoDateString | undefined, expiredAt?: IsoDateString | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, prequalLink: string, contact: { __typename?: 'Contacts', fullName: string } }> };

export type FetchDisplayIdCountersQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchDisplayIdCountersQuery = { __typename?: 'query_root', displayIdCounters: Array<{ __typename?: 'DisplayIdCounters', entityType: string, counter: number, updatedAt: IsoDateString }> };

export type UpdateDisplayIdCounterMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  entityType: Scalars['String'];
  counter: Scalars['bigint'];
}>;


export type UpdateDisplayIdCounterMutation = { __typename?: 'mutation_root', updateDisplayIdCounters?: { __typename?: 'DisplayIdCountersMutationResponse', affectedRows: number } | undefined };

export type UpsertDisplayIdCounterMutationVariables = Exact<{
  object: DisplayIdCountersInsertInput;
}>;


export type UpsertDisplayIdCounterMutation = { __typename?: 'mutation_root', insertDisplayIdCountersOne?: { __typename?: 'DisplayIdCounters', entityType: string, counter: number, updatedAt: IsoDateString } | undefined };

export type UpsertInstallHvacSystemAndLinkedEquipmentMutationVariables = Exact<{
  installedHvacSystemGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
  filterSize?: InputMaybe<Scalars['String']>;
  friendlyName?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  zoningInfoJson: Scalars['jsonb'];
  linkedInstalledEquipmentGuids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type UpsertInstallHvacSystemAndLinkedEquipmentMutation = { __typename?: 'mutation_root', insertInstalledHvacSystemsOne?: { __typename: 'InstalledHvacSystems' } | undefined, addNewEquipmentLinks?: { __typename: 'InstalledEquipmentMutationResponse' } | undefined, removeOldEquipmentLinks?: { __typename: 'InstalledEquipmentMutationResponse' } | undefined };

export type InvoicesWidgetInvoiceFragment = { __typename?: 'Invoices', invoiceGuid: string, displayIdV2: string, status: InvoiceV2Status, totalUsc: number, issuedAt?: IsoDateString | undefined, createdByUser: { __typename?: 'Users', fullName: string }, taxConfiguration?: { __typename?: 'InvoiceCompanyTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined, cartItems: Array<{ __typename?: 'InvoiceCartItems', cartItem: { __typename?: 'CartItems', name: string, unitPriceUsc: number, quantity: number, isDiscountable: boolean, cartItemCode?: string | undefined } }>, discounts: Array<{ __typename?: 'InvoiceDiscounts', discountRate?: number | undefined, discountAmountUsc?: number | undefined, type: DiscountType }>, invoicePayments: Array<{ __typename?: 'InvoicePayments', appliedAmountUsc: number, paymentRecord: { __typename?: 'PaymentRecords', paymentMethod: PaymentMethod, paymentRecordGuid: string, amountUsd: number } }>, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', displayId: number, jobType: { __typename?: 'JobTypes', name: string } } } | undefined, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string } | undefined };

export type InvoicesWidgetDataSubscriptionVariables = Exact<{
  where: InvoicesBoolExp;
}>;


export type InvoicesWidgetDataSubscription = { __typename?: 'subscription_root', invoices: Array<{ __typename?: 'Invoices', invoiceGuid: string, displayIdV2: string, status: InvoiceV2Status, totalUsc: number, issuedAt?: IsoDateString | undefined, createdByUser: { __typename?: 'Users', fullName: string }, taxConfiguration?: { __typename?: 'InvoiceCompanyTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined, cartItems: Array<{ __typename?: 'InvoiceCartItems', cartItem: { __typename?: 'CartItems', name: string, unitPriceUsc: number, quantity: number, isDiscountable: boolean, cartItemCode?: string | undefined } }>, discounts: Array<{ __typename?: 'InvoiceDiscounts', discountRate?: number | undefined, discountAmountUsc?: number | undefined, type: DiscountType }>, invoicePayments: Array<{ __typename?: 'InvoicePayments', appliedAmountUsc: number, paymentRecord: { __typename?: 'PaymentRecords', paymentMethod: PaymentMethod, paymentRecordGuid: string, amountUsd: number } }>, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', displayId: number, jobType: { __typename?: 'JobTypes', name: string } } } | undefined, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string } | undefined }> };

export type GetInvoiceIdentifyingInfoQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
}>;


export type GetInvoiceIdentifyingInfoQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', accountDisplayName: string } | undefined, jobsByPk?: { __typename?: 'Jobs', pointOfContact: { __typename?: 'Contacts', fullName: string } } | undefined };

export type PrimaryContactInfoForAccountQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type PrimaryContactInfoForAccountQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', contactGuid: string, firstName: string, lastName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined } }> } | undefined };

export type QueryContactQueryVariables = Exact<{
  query: ContactsBoolExp;
}>;


export type QueryContactQuery = { __typename?: 'query_root', contacts: Array<{ __typename?: 'Contacts', contactGuid: string, companyGuid: string, firstName: string, lastName: string, salutation?: string | undefined, title?: string | undefined, notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddressGuid: string, emailAddress: string, companyGuid: string } | undefined, additionalEmailAddress?: { __typename?: 'EmailAddresses', emailAddressGuid: string, emailAddress: string, companyGuid: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, additionalPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', accountGuid: string }> }> };

export type JobAttachmentsLinkedJobDataQuerySubscriptionVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type JobAttachmentsLinkedJobDataQuerySubscription = { __typename?: 'subscription_root', jobsWithLinkedJob: Array<{ __typename?: 'JobsWithLinkedJob', jobGuid: string, linkNotes: boolean, linkAttachments: boolean, linked_job: { __typename?: 'Jobs', jobGuid: string, displayId: number, companyGuid: string, jobType: { __typename?: 'JobTypes', name: string }, fileLinks: Array<{ __typename?: 'FileLinks', fileGuid: string, file: { __typename?: 'Files', fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, cdnUrl: string, resourceUrn: string, storageStrategy: FileStorageStrategy, createdAt: IsoDateString } }> } }> };

export type AllJobAssignedTechniciansQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type AllJobAssignedTechniciansQuery = { __typename?: 'query_root', jobsByPk?: { __typename?: 'Jobs', jobAppointmentAssignments: Array<{ __typename?: 'JobAppointmentAssignments', technicianUserGuid: string, jobAppointment: { __typename?: 'JobAppointments', invoicesQueryables: Array<{ __typename?: 'InvoicesQueryable', invoiceGuid: string }>, jobAppointmentInvoices: Array<{ __typename?: 'JobAppointmentInvoices', invoiceGuid: string }> } }> } | undefined };

export type UsersInfoForRevenueAttributionQueryVariables = Exact<{
  userGuids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type UsersInfoForRevenueAttributionQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', userGuid: string, firstName: string, lastName: string, firstNameInitial?: string | undefined }> };

export type AllRevenueAttributionsForJobQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type AllRevenueAttributionsForJobQuery = { __typename?: 'query_root', jobTechnicianSoldRevenueAttributions: Array<{ __typename?: 'JobTechnicianSoldRevenueAttributions', invoiceGuid: string, itemGuid: string, revenueUsc: number, technicianUserGuid: string }>, jobTechnicianEarnedRevenueAttributions: Array<{ __typename?: 'JobTechnicianEarnedRevenueAttributions', invoiceGuid: string, itemGuid: string, revenueUsc: number, technicianUserGuid: string }> };

export type SoldMaintenancePlanForJobQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type SoldMaintenancePlanForJobQuery = { __typename?: 'query_root', jobsByPk?: { __typename?: 'Jobs', createdAt: IsoDateString, workCompletedAt?: IsoDateString | undefined, maintenancePlan?: { __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, status: MaintenancePlanStatus, activatedAt?: IsoDateString | undefined, yearlyPriceUsc: number, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined } | undefined } | undefined };

export type InvoiceForJobSoldMaintenancePlanQueryVariables = Exact<{
  maintenancePlanGuid: Scalars['uuid'];
}>;


export type InvoiceForJobSoldMaintenancePlanQuery = { __typename?: 'query_root', invoices: Array<{ __typename?: 'Invoices', displayId: number }> };

export type JobOutcomeInvoicesQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
}>;


export type JobOutcomeInvoicesQuery = { __typename?: 'query_root', invoices: Array<{ __typename?: 'Invoices', invoiceGuid: string, displayId: number, displayIdV2: string, subtotalUsc: number, totalUsc: number, status: InvoiceV2Status, issuedAt?: IsoDateString | undefined, createdAt: IsoDateString, invoiceCartItems: Array<{ __typename?: 'InvoiceCartItems', seq: number, cartItem: { __typename?: 'CartItems', description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, unitPriceUsc: number, quantity: number, cartItemGuid: string, originalPricebookItemGuid?: string | undefined, cartItemCode?: string | undefined, itemType: CartItemType } }> }> };

export type GetJobsPickerDataForAccountQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
}>;


export type GetJobsPickerDataForAccountQuery = { __typename?: 'query_root', jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, createdAt: IsoDateString, jobType: { __typename?: 'JobTypes', name: string } }> };

export type JobsWidgetJobFragment = { __typename?: 'Jobs', jobGuid: string, displayId: number, createdAt: IsoDateString, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string, color: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string } }, jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, displayId: number, displayIdV2: string, totalUsc: number } }>, paymentLinks: Array<{ __typename?: 'PaymentLinks', paymentRecord: { __typename?: 'PaymentRecords', paymentRecordGuid: string, paymentMethod: PaymentMethod, amountUsd: number } }>, estimates: Array<{ __typename?: 'Estimates', estimateGuid: string, displayId: number, estimateOptionsAggregate: { __typename?: 'EstimateOptionsAggregate', aggregate?: { __typename?: 'EstimateOptionsAggregateFields', count: number } | undefined } }>, appointments: Array<{ __typename?: 'JobAppointments', appointmentType: AppointmentType, appointmentWindowStart: IsoDateString, jobAppointmentGuid: string }> };

export type JobsWidgetDataSubscriptionVariables = Exact<{
  where: JobsBoolExp;
}>;


export type JobsWidgetDataSubscription = { __typename?: 'subscription_root', jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, createdAt: IsoDateString, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string, color: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string } }, jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, displayId: number, displayIdV2: string, totalUsc: number } }>, paymentLinks: Array<{ __typename?: 'PaymentLinks', paymentRecord: { __typename?: 'PaymentRecords', paymentRecordGuid: string, paymentMethod: PaymentMethod, amountUsd: number } }>, estimates: Array<{ __typename?: 'Estimates', estimateGuid: string, displayId: number, estimateOptionsAggregate: { __typename?: 'EstimateOptionsAggregate', aggregate?: { __typename?: 'EstimateOptionsAggregateFields', count: number } | undefined } }>, appointments: Array<{ __typename?: 'JobAppointments', appointmentType: AppointmentType, appointmentWindowStart: IsoDateString, jobAppointmentGuid: string }> }> };

export type LinkedIntegratedPhoneCallFragment = { __typename?: 'IntegratedPhoneCalls', integratedPhoneCallGuid: string, startedAt: IsoDateString, endedAt?: IsoDateString | undefined, contact?: { __typename?: 'Contacts', fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined } | undefined, user?: { __typename?: 'Users', fullName: string } | undefined, integratedPhoneMissedCalls: Array<{ __typename?: 'IntegratedPhoneMissedCalls', integratedPhoneVoicemails: Array<{ __typename?: 'IntegratedPhoneVoicemails', recordingSummary?: string | undefined, recordingTranscript?: string | undefined, recordingUrl: string }> }>, integratedPhoneCallRecording?: { __typename?: 'IntegratedPhoneCallRecording', recordingSummary?: string | undefined, recordingTranscript?: string | undefined, recordingUrl: string } | undefined, integratedPhoneCallJobs: Array<{ __typename?: 'IntegratedPhoneCallJobs', job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', locationGuid: string, displayName?: string | undefined, locationDescription?: string | undefined, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, zipCode: string, stateAbbreviation: string } } } }> };

export type MaintenancePlansWidgetDataSubscriptionVariables = Exact<{
  where: MaintenancePlansQueryableBoolExp;
}>;


export type MaintenancePlansWidgetDataSubscription = { __typename?: 'subscription_root', maintenancePlansQueryable: Array<{ __typename?: 'MaintenancePlansQueryable', activatedAt?: IsoDateString | undefined, billingAnchor?: string | undefined, terminatesAt?: IsoDateString | undefined, paymentAmountUsc: number, paymentInterval: MaintenancePlanPaymentInterval, maintenancePlanGuid: string, locationGuid: string, status: MaintenancePlanStatus, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, yearlyPriceUsc: number, credits: CreditRecordArray, discounts: MaintenancePlanDiscountArray, coveredInstalledEquipmentGuids: GuidArray, scheduledActivationAt?: IsoDateString | undefined, billingStartAt?: IsoDateString | undefined, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined, maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }>, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string } } }> };

export type UpsertAppointmentFormCompanyUsersQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type UpsertAppointmentFormCompanyUsersQueryQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', userGuid: string, firstName: string, lastName: string, emailAddress: string, deactivatedAt?: IsoDateString | undefined, userPrimaryHueHex?: string | undefined, userPhoneNumbers: Array<{ __typename?: 'UserPhoneNumbers', phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } }>, userRoles: Array<{ __typename?: 'UserRoles', roleById: { __typename?: 'CompanyRoles', role: RoleId, name: string } }>, companyUser?: { __typename?: 'CompanyUsers', schedulingCapability: SchedulingCapability } | undefined, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined }> };

export type JobTypeDurationMinutesQueryQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type JobTypeDurationMinutesQueryQuery = { __typename?: 'query_root', jobsByPk?: { __typename?: 'Jobs', jobType: { __typename?: 'JobTypes', durationMinutes: number } } | undefined };

export type AccountBillingInfoQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AccountBillingInfoQuery = { __typename?: 'query_root', accounts: Array<{ __typename?: 'Accounts', accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', fullName: string } }>, mailingAddress?: { __typename?: 'Addresses', addressGuid: string, line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string } | undefined }>, accountLocations: Array<{ __typename?: 'AccountLocations', location: { __typename?: 'Locations', address: { __typename?: 'Addresses', addressGuid: string, line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string } } }> };

export type InvoiceLinksQueryVariables = Exact<{
  invoiceGuid: Scalars['uuid'];
}>;


export type InvoiceLinksQuery = { __typename?: 'query_root', invoices: Array<{ __typename?: 'Invoices', jobLink?: { __typename?: 'JobInvoices', jobGuid: string } | undefined, jobAppointmentLink?: { __typename?: 'JobAppointmentInvoices', jobAppointmentGuid: string } | undefined, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string } | undefined, locationLink?: { __typename?: 'LocationInvoices', locationGuid: string } | undefined, estimateLink?: { __typename?: 'EstimateInvoices', estimateGuid: string } | undefined }> };

export type ResyncPaymentInvoiceEventsMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  invoiceGuid: Scalars['uuid'];
  paymentRecordGuid: Scalars['String'];
  newTitle: Scalars['String'];
  newOccurredAt: Scalars['timestamptz'];
}>;


export type ResyncPaymentInvoiceEventsMutation = { __typename?: 'mutation_root', updateInvoiceEvents?: { __typename?: 'InvoiceEventsMutationResponse', affectedRows: number } | undefined };

export type DeleteInvoiceEventsByPaymentRecordGuidMutationVariables = Exact<{
  paymentRecordGuid: Scalars['String'];
  companyGuid: Scalars['uuid'];
}>;


export type DeleteInvoiceEventsByPaymentRecordGuidMutation = { __typename?: 'mutation_root', deleteInvoiceEvents?: { __typename?: 'InvoiceEventsMutationResponse', affectedRows: number } | undefined };

export type UserPersonResourceSelectUserAvatarQueryQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type UserPersonResourceSelectUserAvatarQueryQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', userGuid: string, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined }> };

export type FetchCompanyPhoneSettingsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchCompanyPhoneSettingsQuery = { __typename?: 'query_root', integratedPhoneCompanyConfig: Array<{ __typename?: 'IntegratedPhoneCompanyConfig', integratedPhoneEnabled: boolean, integratedVoiceCallingEnabled: boolean, company: { __typename?: 'Companies', integratedPhones: Array<{ __typename?: 'IntegratedPhones', phoneNumber: string, phoneProvider: string, primaryOutboundSms: boolean, companyLeadSource?: { __typename?: 'CompanyLeadSources', canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined } | undefined }> } }> };

export type FetchContactLiteByPhoneNumberQueryVariables = Exact<{
  phoneNumber?: InputMaybe<Scalars['String']>;
  companyGuid?: InputMaybe<Scalars['uuid']>;
}>;


export type FetchContactLiteByPhoneNumberQuery = { __typename?: 'query_root', phoneNumbers: Array<{ __typename?: 'PhoneNumbers', contacts: Array<{ __typename?: 'Contacts', contactGuid: string, fullName: string, firstName: string, lastName: string, accountContacts: Array<{ __typename?: 'AccountContacts', accountGuid: string, contact: { __typename?: 'Contacts', fullName: string } }> }>, contactsAdditionalPhone: Array<{ __typename?: 'Contacts', contactGuid: string, fullName: string, firstName: string, lastName: string, accountContacts: Array<{ __typename?: 'AccountContacts', accountGuid: string, contact: { __typename?: 'Contacts', fullName: string } }> }> }> };

export type FetchIntegratedPhoneCallGuidByExternalCallIdQueryVariables = Exact<{
  externalCallId: Scalars['String'];
}>;


export type FetchIntegratedPhoneCallGuidByExternalCallIdQuery = { __typename?: 'query_root', integratedPhoneCalls: Array<{ __typename?: 'IntegratedPhoneCalls', integratedPhoneCallGuid: string }> };

export type UpsertUserPhoneStatusMutationVariables = Exact<{
  obj: IntegratedPhoneUsersInsertInput;
}>;


export type UpsertUserPhoneStatusMutation = { __typename?: 'mutation_root', insertIntegratedPhoneUsersOne?: { __typename: 'IntegratedPhoneUsers' } | undefined };

export type AccountPhotoAlbumWidgetQueryQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AccountPhotoAlbumWidgetQueryQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', photoLinks: Array<{ __typename?: 'PhotoLinks', updatedAt: IsoDateString, photo: { __typename?: 'Photos', photoGuid: string, cdnUrl: string, createdByUserGuid: string, resourceUrn: string, createdAt: IsoDateString } }>, jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', city: string, stateAbbreviation: string, zipCode: string, line1: string } }, photoLinks: Array<{ __typename?: 'PhotoLinks', updatedAt: IsoDateString, photo: { __typename?: 'Photos', photoGuid: string, cdnUrl: string, createdByUserGuid: string, resourceUrn: string, createdAt: IsoDateString, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }> }> } | undefined };

export type JobPhotoAlbumWidgetQueryQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type JobPhotoAlbumWidgetQueryQuery = { __typename?: 'query_root', jobsByPk?: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', city: string, stateAbbreviation: string, zipCode: string, line1: string } }, linkedToJobs: Array<{ __typename?: 'JobsWithLinkedJob', linked_job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', city: string, stateAbbreviation: string, zipCode: string, line1: string } }, photoLinks: Array<{ __typename?: 'PhotoLinks', createdAt: IsoDateString, updatedAt: IsoDateString, photo: { __typename?: 'Photos', photoGuid: string, cdnUrl: string, resourceUrn: string, createdByUserGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }> } }> } | undefined, photoLinks: Array<{ __typename?: 'PhotoLinks', createdAt: IsoDateString, updatedAt: IsoDateString, photo: { __typename?: 'Photos', photoGuid: string, cdnUrl: string, resourceUrn: string, createdByUserGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }> };

export type AccountPhotoGalleryModalPhotosQueryQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  limit: Scalars['Int'];
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
}>;


export type AccountPhotoGalleryModalPhotosQueryQuery = { __typename?: 'query_root', photoLinksAggregate: { __typename?: 'PhotoLinksAggregate', aggregate?: { __typename?: 'PhotoLinksAggregateFields', count: number } | undefined }, photoLinks: Array<{ __typename?: 'PhotoLinks', updatedAt: IsoDateString, photo: { __typename?: 'Photos', photoGuid: string, cdnUrl: string } }> };

export type InsertPricebookItemMutationVariables = Exact<{
  pricebookItem: PricebookItemsInsertInput;
}>;


export type InsertPricebookItemMutation = { __typename?: 'mutation_root', insertPricebookItemsOne?: { __typename: 'PricebookItems' } | undefined };

export type GetPricebookDiscountsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetPricebookDiscountsQuery = { __typename?: 'query_root', pricebookDiscounts: Array<{ __typename?: 'PricebookDiscounts', description: string, discountAmountUsd?: number | undefined, discountRate?: number | undefined, name: string, type: DiscountType, pricebookDiscountGuid: string }> };

export type GetPricebookTaxRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPricebookTaxRatesQuery = { __typename?: 'query_root', pricebookTaxRates: Array<{ __typename?: 'PricebookTaxRates', rate: number, name: string, pricebookTaxRateGuid: string, accountTypes?: AccountTypeArray | undefined, zipCodes?: Array<string> | undefined }> };

export type GetPricebookItemsAdminQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetPricebookItemsAdminQuery = { __typename?: 'query_root', pricebookItems: Array<{ __typename?: 'PricebookItems', pricebookItemGuid: string, companyGuid: string, name: string, description: string, itemType: PricebookItemTypeEnum, imageUrl?: string | undefined, isTaxable: boolean, version: number, isActive: boolean, isDiscountable: boolean, sourcePhotoGuid?: string | undefined, pricebookItemCode?: string | undefined, basePriceUsc: number, memberPriceUsc: number, memberAddonPriceUsc: number, memberAfterhoursPriceUsc: number, memberAddonAfterhoursPriceUsc: number, addonPriceUsc: number, addonAfterhoursPriceUsc: number, afterhoursPriceUsc: number, photoGuid?: string | undefined, costUSD: number, priceUSD: number, sourcePhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined, photo?: { __typename?: 'Photos', cdnUrl: string } | undefined, pricebookCategory?: { __typename?: 'PricebookCategories', pricebookCategoryGuid: string, name: string, parentCategoryGuid?: string | undefined } | undefined, qboIncomeAccount?: { __typename?: 'PricebookItemsQboIncomeAccounts', qboIncomeAccountId?: string | undefined } | undefined }>, pricebookCategories: Array<{ __typename?: 'PricebookCategories', pricebookCategoryGuid: string, name: string, parentCategoryGuid?: string | undefined, sourcePhotoGuid?: string | undefined, photoGuid?: string | undefined, sourcePhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined, photo?: { __typename?: 'Photos', cdnUrl: string } | undefined }> };

export type GetPricebookCategoriesAdminQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetPricebookCategoriesAdminQuery = { __typename?: 'query_root', pricebookCategories: Array<{ __typename?: 'PricebookCategories', pricebookCategoryGuid: string, name: string, parentCategoryGuid?: string | undefined, sourcePhotoGuid?: string | undefined, photoGuid?: string | undefined, parentPricebookCategory?: { __typename?: 'PricebookCategories', name: string, pricebookCategoryGuid: string, parentCategoryGuid?: string | undefined } | undefined, sourcePhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined, photo?: { __typename?: 'Photos', cdnUrl: string } | undefined }> };

export type GetPricebookTaxRatesAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPricebookTaxRatesAdminQuery = { __typename?: 'query_root', pricebookTaxRates: Array<{ __typename?: 'PricebookTaxRates', pricebookTaxRateGuid: string, companyGuid: string, name: string, rate: number, isActive: boolean, version: number, accountTypes?: AccountTypeArray | undefined, zipCodes?: Array<string> | undefined }>, billingProfiles: Array<{ __typename?: 'BillingProfiles', defaultPricebookTaxRateGuid?: string | undefined }> };

export type GetPricebookDiscountsAdminQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetPricebookDiscountsAdminQuery = { __typename?: 'query_root', pricebookDiscounts: Array<{ __typename?: 'PricebookDiscounts', pricebookDiscountGuid: string, companyGuid: string, name: string, type: DiscountType, discountAmountUsd?: number | undefined, discountRate?: number | undefined, description: string, isActive: boolean, version: number }> };

export type UpdatePricebookSettingsMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  memberTierEnabled: Scalars['Boolean'];
  memberAddonTierEnabled: Scalars['Boolean'];
  memberAfterhoursTierEnabled: Scalars['Boolean'];
  memberAddonAfterhoursTierEnabled: Scalars['Boolean'];
  addonTierEnabled: Scalars['Boolean'];
  addonAfterhoursTierEnabled: Scalars['Boolean'];
  afterhoursTierEnabled: Scalars['Boolean'];
  businessHoursStartTime: Scalars['time'];
  businessHoursEndTime: Scalars['time'];
  saturdayIsBusinessDay: Scalars['Boolean'];
  sundayIsBusinessDay: Scalars['Boolean'];
  pricebookPhotosEnabled: Scalars['Boolean'];
}>;


export type UpdatePricebookSettingsMutation = { __typename?: 'mutation_root', updateCompanyPricingTierConfig?: { __typename: 'CompanyPricingTierConfigMutationResponse' } | undefined, updateCompanyConfig?: { __typename: 'CompanyConfigMutationResponse' } | undefined };

export type GetPricebookMarkupTiersQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetPricebookMarkupTiersQuery = { __typename?: 'query_root', pricebookMarkupTiers: Array<{ __typename?: 'PricebookMarkupTiers', pricebookMarkupTierGuid: string, companyGuid: string, costRangeEndInclusiveUsc?: number | undefined, markupRate: number, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined }> };

export type UpsertPricebookMarkupTierMutationVariables = Exact<{
  input: PricebookMarkupTiersInsertInput;
}>;


export type UpsertPricebookMarkupTierMutation = { __typename?: 'mutation_root', insertPricebookMarkupTiersOne?: { __typename?: 'PricebookMarkupTiers', pricebookMarkupTierGuid: string, companyGuid: string, costRangeEndInclusiveUsc?: number | undefined, markupRate: number, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined } | undefined };

export type DeletePricebookMarkupTierMutationVariables = Exact<{
  pricebookMarkupTierGuid: Scalars['uuid'];
}>;


export type DeletePricebookMarkupTierMutation = { __typename?: 'mutation_root', deletePricebookMarkupTiersByPk?: { __typename?: 'PricebookMarkupTiers', pricebookMarkupTierGuid: string } | undefined };

export type UpsertCompanyConfigPricebookPhotosEnabledMutationVariables = Exact<{
  config: CompanyConfigInsertInput;
}>;


export type UpsertCompanyConfigPricebookPhotosEnabledMutation = { __typename?: 'mutation_root', insertCompanyConfigOne?: { __typename: 'CompanyConfig' } | undefined };

export type PricebookVersionHistorySubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PricebookVersionHistorySubscription = { __typename?: 'subscription_root', pricebookVersions: Array<{ __typename?: 'PricebookVersions', pricebookVersionGuid: string, createdAt: IsoDateString, createdByUserGuid: string, displayId: number, name?: string | undefined, dataSchemaVersion: PricebookDataSchemaVersion, pricebookItemsFileGuid: string, pricebookCategoriesFileGuid?: string | undefined, createdByUser?: { __typename?: 'Users', firstNameInitial?: string | undefined } | undefined, pricebookItemsFile?: { __typename?: 'Files', fileGuid: string, fileName: string, cdnUrl: string } | undefined, pricebookCategoriesFile?: { __typename?: 'Files', fileGuid: string, fileName: string, cdnUrl: string } | undefined }> };

export type PricebookItemDefaultPhotoQueryAdminQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type PricebookItemDefaultPhotoQueryAdminQuery = { __typename?: 'query_root', pricebookItemTypeFallbackPhotos: Array<{ __typename?: 'PricebookItemTypeFallbackPhotos', itemType: PricebookItemTypeEnum, photoGuid: string, photo: { __typename?: 'Photos', cdnUrl: string } }> };

export type AccountDropdownOptionsQueryQueryVariables = Exact<{
  where: AccountsBoolExp;
}>;


export type AccountDropdownOptionsQueryQuery = { __typename?: 'query_root', accounts: Array<{ __typename?: 'Accounts', accountGuid: string, accountReferenceNumber: string, archived: boolean, doNotService: boolean, doNotServiceReason?: string | undefined, accountDisplayName: string, accountDisplayNameSetBySystem: boolean, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } }>, accountLocations: Array<{ __typename?: 'AccountLocations', locationGuid: string, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', canonicalFullAddress: string, line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string } } }>, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined }> }> };

export type CreateOrEditAccountFormCompanyConfigQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type CreateOrEditAccountFormCompanyConfigQueryQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', companyGuid: string, accountManagerEnabled: boolean, customerNumberEnabled: boolean, accountNameDisplayTemplate: MustacheTemplate } | undefined };

export type InsertJobPhoneCallLinkMutationVariables = Exact<{
  object: IntegratedPhoneCallJobsInsertInput;
}>;


export type InsertJobPhoneCallLinkMutation = { __typename?: 'mutation_root', insertIntegratedPhoneCallJobsOne?: { __typename: 'IntegratedPhoneCallJobs' } | undefined };

export type SettingsTeamPageUserAvatarsQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type SettingsTeamPageUserAvatarsQueryQuery = { __typename?: 'query_root', companyUsers: Array<{ __typename?: 'CompanyUsers', userGuid: string, userByUserGuid: { __typename?: 'Users', fullName: string, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined } }> };

export type CurrentVisitDataSubscriptionVariables = Exact<{
  userGuid: Scalars['uuid'];
}>;


export type CurrentVisitDataSubscription = { __typename?: 'subscription_root', assignments: Array<{ __typename?: 'JobAppointmentAssignments', appointmentGuid: string, job: { __typename?: 'Jobs', displayId: number, jobType: { __typename?: 'JobTypes', name: string, jobClass: JobClassesEnum }, maintenancePlan?: { __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined } | undefined }, appointment: { __typename?: 'JobAppointments', appointmentType: AppointmentType } }> };

export type TechAppHomePageDataSubscriptionVariables = Exact<{
  userGuid: Scalars['uuid'];
  tomorrow: Scalars['timestamptz'];
  today: Scalars['timestamptz'];
}>;


export type TechAppHomePageDataSubscription = { __typename?: 'subscription_root', assignments: Array<{ __typename?: 'JobAppointmentAssignments', assignmentStart: IsoDateString, assignmentEnd: IsoDateString, assignmentGuid: string, appointmentGuid: string, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, isHotLead: boolean, isOpportunity: boolean, isMembershipRenewalOpportunity: boolean, isMembershipOpportunity: boolean, isMembershipSold?: boolean | undefined, isConverted?: boolean | undefined, jobType: { __typename?: 'JobTypes', jobClass: JobClassesEnum, name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, zipCode: string, stateAbbreviation: string, geoLocation: Geo }, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }> }, pointOfContact: { __typename?: 'Contacts', fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', isWorkComplete: boolean } }, jobAppointment: { __typename?: 'JobAppointments', appointmentType: AppointmentType, cancellationStatus?: { __typename?: 'JobAppointmentCancellationStatuses', canceled: boolean, updatedAt: IsoDateString } | undefined }, assignmentStatus?: { __typename?: 'JobAppointmentAssignmentStatuses', jobAppointmentAssignmentStatusType: JobAppointmentAssignmentStatusTypesEnum, updatedAt: IsoDateString } | undefined }> };

export type TechAppHomeTechnicianCapacityBlocksSubscriptionVariables = Exact<{
  userGuid: Scalars['uuid'];
  tomorrow: Scalars['timestamptz'];
  today: Scalars['timestamptz'];
}>;


export type TechAppHomeTechnicianCapacityBlocksSubscription = { __typename?: 'subscription_root', blocks: Array<{ __typename?: 'TechnicianCapacityBlocks', reasonType: TechnicianCapacityBlockReasonTypesEnum, reasonDescription?: string | undefined, start: IsoDateString, end: IsoDateString }> };

export type FetchPurchaseOrdersDataQueryVariables = Exact<{
  jobGuid?: InputMaybe<Scalars['uuid']>;
}>;


export type FetchPurchaseOrdersDataQuery = { __typename?: 'query_root', purchaseOrders: Array<{ __typename?: 'PurchaseOrders', purchaseOrderGuid: string, purchaseOrderNumber: string }> };

export type UpdateJobPurchaseOrdersMutationVariables = Exact<{
  jobGuid?: InputMaybe<Scalars['uuid']>;
  purchaseOrders: Array<PurchaseOrdersInsertInput> | PurchaseOrdersInsertInput;
}>;


export type UpdateJobPurchaseOrdersMutation = { __typename?: 'mutation_root', deletePurchaseOrders?: { __typename: 'PurchaseOrdersMutationResponse' } | undefined, insertPurchaseOrders?: { __typename: 'PurchaseOrdersMutationResponse' } | undefined };

export type AppointmentDetailsFragment = { __typename?: 'JobAppointments', appointmentType: AppointmentType, appointmentWindowEnd: IsoDateString, appointmentWindowStart: IsoDateString, description?: string | undefined, descriptionHtml?: HtmlString | undefined, sendConfirmationEnabled: boolean, sendConfirmationTo?: string | undefined, notificationType: AppointmentNotificationType, sendReminderEnabled: boolean, reminderLastSentAt?: IsoDateString | undefined, endOfAppointmentNextSteps?: object | undefined, appointmentGuid: string, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, isMembershipOpportunity: boolean, isMembershipRenewalOpportunity: boolean, isHotLead: boolean, isOpportunity: boolean, isMembershipSold?: boolean | undefined, summary?: string | undefined, summaryHtml?: HtmlString | undefined, isJobConverted?: boolean | undefined, jobType: { __typename?: 'JobTypes', name: string, jobClass: JobClassesEnum, jobTypeGuid: string }, location: { __typename?: 'Locations', locationGuid: string, locationDescription?: string | undefined, displayName?: string | undefined, address: { __typename?: 'Addresses', city: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string, addressGuid: string }, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', terminatesAt?: IsoDateString | undefined, lapsedAt?: IsoDateString | undefined, expiredAt?: IsoDateString | undefined, createdAt: IsoDateString, accountGuid: string, companyGuid: string, paymentInterval: MaintenancePlanPaymentInterval, paymentAmountUsc: number, pricebookTaxRateGuid?: string | undefined, maintenancePlanGuid: string, locationGuid: string, status: MaintenancePlanStatus, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, yearlyPriceUsc: number, credits: CreditRecordArray, discounts: MaintenancePlanDiscountArray, coveredInstalledEquipmentGuids: GuidArray, activatedAt?: IsoDateString | undefined, scheduledActivationAt?: IsoDateString | undefined, billingStartAt?: IsoDateString | undefined, account: { __typename?: 'Accounts', accountContacts: Array<{ __typename?: 'AccountContacts', primary: boolean, contact: { __typename?: 'Contacts', primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } }> }, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined, maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }>, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string } } }> }, purchaseOrders: Array<{ __typename?: 'PurchaseOrders', purchaseOrderGuid: string, purchaseOrderNumber: string }>, pointOfContact: { __typename?: 'Contacts', fullName: string, firstName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, additionalPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined }, equipment: Array<{ __typename?: 'EquipmentTypeLinks', estimatedEquipmentAge?: string | undefined, equipmentType: EquipmentType, equipmentTypeLinkGuid: string }>, tags: Array<{ __typename?: 'JobTags', tag: { __typename?: 'Tags', name: string } }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', isWorkComplete: boolean, name: string, color: string }, account: { __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, accountType: AccountType, accountGuid: string, doNotService: boolean, doNotServiceReason?: string | undefined }, linkedMaintenancePlanVisit?: { __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, name: string, visitNote?: string | undefined } | undefined, assignments: Array<{ __typename?: 'JobAppointmentAssignments', assignmentStart: IsoDateString, assignmentEnd: IsoDateString, appointmentGuid: string, assignmentGuid: string, technician: { __typename?: 'Users', firstName: string, lastName: string, userGuid: string, assignments: Array<{ __typename?: 'JobAppointmentAssignments', appointmentGuid: string, job: { __typename?: 'Jobs', pointOfContact: { __typename?: 'Contacts', fullName: string }, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string } } } }>, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined }, assignmentStatus?: { __typename?: 'JobAppointmentAssignmentStatuses', updatedAt: IsoDateString, status: JobAppointmentAssignmentStatusTypesEnum } | undefined }> }, cancellationStatus?: { __typename?: 'JobAppointmentCancellationStatuses', canceled: boolean, updatedAt: IsoDateString } | undefined, checklists: Array<{ __typename?: 'AppointmentChecklistInstances', checklist: AppointmentChecklistInstanceChecklist, instanceNumber: number, label?: string | undefined, instanceGuid: string, checklistGuid: string }> };

export type AppointmentDetailByGuidSubscriptionVariables = Exact<{
  jobAppointmentGuid: Scalars['uuid'];
}>;


export type AppointmentDetailByGuidSubscription = { __typename?: 'subscription_root', jobAppointmentsByPk?: { __typename?: 'JobAppointments', appointmentType: AppointmentType, appointmentWindowEnd: IsoDateString, appointmentWindowStart: IsoDateString, description?: string | undefined, descriptionHtml?: HtmlString | undefined, sendConfirmationEnabled: boolean, sendConfirmationTo?: string | undefined, notificationType: AppointmentNotificationType, sendReminderEnabled: boolean, reminderLastSentAt?: IsoDateString | undefined, endOfAppointmentNextSteps?: object | undefined, appointmentGuid: string, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, isMembershipOpportunity: boolean, isMembershipRenewalOpportunity: boolean, isHotLead: boolean, isOpportunity: boolean, isMembershipSold?: boolean | undefined, summary?: string | undefined, summaryHtml?: HtmlString | undefined, isJobConverted?: boolean | undefined, jobType: { __typename?: 'JobTypes', name: string, jobClass: JobClassesEnum, jobTypeGuid: string }, location: { __typename?: 'Locations', locationGuid: string, locationDescription?: string | undefined, displayName?: string | undefined, address: { __typename?: 'Addresses', city: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string, addressGuid: string }, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', terminatesAt?: IsoDateString | undefined, lapsedAt?: IsoDateString | undefined, expiredAt?: IsoDateString | undefined, createdAt: IsoDateString, accountGuid: string, companyGuid: string, paymentInterval: MaintenancePlanPaymentInterval, paymentAmountUsc: number, pricebookTaxRateGuid?: string | undefined, maintenancePlanGuid: string, locationGuid: string, status: MaintenancePlanStatus, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, yearlyPriceUsc: number, credits: CreditRecordArray, discounts: MaintenancePlanDiscountArray, coveredInstalledEquipmentGuids: GuidArray, activatedAt?: IsoDateString | undefined, scheduledActivationAt?: IsoDateString | undefined, billingStartAt?: IsoDateString | undefined, account: { __typename?: 'Accounts', accountContacts: Array<{ __typename?: 'AccountContacts', primary: boolean, contact: { __typename?: 'Contacts', primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } }> }, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined, maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }>, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string } } }> }, purchaseOrders: Array<{ __typename?: 'PurchaseOrders', purchaseOrderGuid: string, purchaseOrderNumber: string }>, pointOfContact: { __typename?: 'Contacts', fullName: string, firstName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, additionalPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined }, equipment: Array<{ __typename?: 'EquipmentTypeLinks', estimatedEquipmentAge?: string | undefined, equipmentType: EquipmentType, equipmentTypeLinkGuid: string }>, tags: Array<{ __typename?: 'JobTags', tag: { __typename?: 'Tags', name: string } }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', isWorkComplete: boolean, name: string, color: string }, account: { __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, accountType: AccountType, accountGuid: string, doNotService: boolean, doNotServiceReason?: string | undefined }, linkedMaintenancePlanVisit?: { __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, name: string, visitNote?: string | undefined } | undefined, assignments: Array<{ __typename?: 'JobAppointmentAssignments', assignmentStart: IsoDateString, assignmentEnd: IsoDateString, appointmentGuid: string, assignmentGuid: string, technician: { __typename?: 'Users', firstName: string, lastName: string, userGuid: string, assignments: Array<{ __typename?: 'JobAppointmentAssignments', appointmentGuid: string, job: { __typename?: 'Jobs', pointOfContact: { __typename?: 'Contacts', fullName: string }, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string } } } }>, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined }, assignmentStatus?: { __typename?: 'JobAppointmentAssignmentStatuses', updatedAt: IsoDateString, status: JobAppointmentAssignmentStatusTypesEnum } | undefined }> }, cancellationStatus?: { __typename?: 'JobAppointmentCancellationStatuses', canceled: boolean, updatedAt: IsoDateString } | undefined, checklists: Array<{ __typename?: 'AppointmentChecklistInstances', checklist: AppointmentChecklistInstanceChecklist, instanceNumber: number, label?: string | undefined, instanceGuid: string, checklistGuid: string }> } | undefined };

export type AppointmentDetailByRefNumQueryVariables = Exact<{
  refNum: Scalars['String'];
}>;


export type AppointmentDetailByRefNumQuery = { __typename?: 'query_root', jobAppointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }> };

export type UserAssignmentTimeClockStatusCardCurrentAssignmentTimesheetEntriesQuerySubscriptionVariables = Exact<{
  userGuid: Scalars['uuid'];
  jobAppointmentAssignmentGuid: Scalars['uuid'];
}>;


export type UserAssignmentTimeClockStatusCardCurrentAssignmentTimesheetEntriesQuerySubscription = { __typename?: 'subscription_root', timesheetEntries: Array<{ __typename?: 'TimesheetEntries', finalStartTime?: IsoDateString | undefined, finalEndTime?: IsoDateString | undefined, entryLengthInMinutes?: number | undefined, timesheetEntryActivity?: { __typename?: 'TimesheetEntryActivities', activityName: string, isPayable: boolean } | undefined, timesheetEntryLinkData: Array<{ __typename?: 'TimesheetEntryLinkData', jobGuid?: string | undefined, jobAppointmentGuid?: string | undefined, jobAppointmentAssignmentGuid?: string | undefined }> }> };

export type VisitAccountDetailsAccountFragment = { __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, accountType: AccountType, lastJobDate?: IsoDateString | undefined, createdAt: IsoDateString, accountLeadSource: Array<{ __typename?: 'CompanyLeadSourceLinks', companyLeadSource: { __typename?: 'CompanyLeadSources', canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined } }>, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', name: string } }>, jobsAggregate: { __typename?: 'JobsAggregate', aggregate?: { __typename?: 'JobsAggregateFields', count: number } | undefined, nodes: Array<{ __typename?: 'Jobs', jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', totalUsc: number } }> }> } };

export type VisitAccountDetailsDataSubscriptionVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type VisitAccountDetailsDataSubscription = { __typename?: 'subscription_root', accountsByPk?: { __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, accountType: AccountType, lastJobDate?: IsoDateString | undefined, createdAt: IsoDateString, accountLeadSource: Array<{ __typename?: 'CompanyLeadSourceLinks', companyLeadSource: { __typename?: 'CompanyLeadSources', canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined } }>, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', name: string } }>, jobsAggregate: { __typename?: 'JobsAggregate', aggregate?: { __typename?: 'JobsAggregateFields', count: number } | undefined, nodes: Array<{ __typename?: 'Jobs', jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', totalUsc: number } }> }> } } | undefined };

export type VisitAccountTabJobsDataSubscriptionVariables = Exact<{
  locationGuid: Scalars['uuid'];
  limit: Scalars['Int'];
}>;


export type VisitAccountTabJobsDataSubscription = { __typename?: 'subscription_root', jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, createdAt: IsoDateString, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string, color: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string, zipCode: string } }, estimates: Array<{ __typename?: 'Estimates', estimateGuid: string, displayId: number, createdAt: IsoDateString, status: EstimateV2Status, estimateOptionsAggregate: { __typename?: 'EstimateOptionsAggregate', aggregate?: { __typename?: 'EstimateOptionsAggregateFields', count: number } | undefined }, createdByUser: { __typename?: 'Users', fullName: string }, options: Array<{ __typename?: 'EstimateOptions', seq: number, displayName?: string | undefined, totalUsc: number, isRecommended: boolean, isSelected: boolean, cartItems: Array<{ __typename?: 'EstimateOptionCartItems', cartItem: { __typename?: 'CartItems', name: string, unitPriceUsc: number, quantity: number, isDiscountable: boolean, cartItemCode?: string | undefined } }>, discounts: Array<{ __typename?: 'EstimateOptionDiscounts', discountAmountUsc?: number | undefined, discountRate?: number | undefined, type: DiscountType }> }> }>, appointments: Array<{ __typename?: 'JobAppointments', appointmentType: AppointmentType, appointmentWindowStart: IsoDateString, jobAppointmentGuid: string }> }> };

export type VisitAccountTabInvoicesDataSubscriptionVariables = Exact<{
  locationGuid: Scalars['uuid'];
}>;


export type VisitAccountTabInvoicesDataSubscription = { __typename?: 'subscription_root', locationInvoices: Array<{ __typename?: 'LocationInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, displayId: number, displayIdV2: string, status: InvoiceV2Status, totalUsc: number, issuedAt?: IsoDateString | undefined, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', displayId: number, jobType: { __typename?: 'JobTypes', name: string } } } | undefined, createdByUser: { __typename?: 'Users', fullName: string }, cartItems: Array<{ __typename?: 'InvoiceCartItems', cartItem: { __typename?: 'CartItems', name: string, unitPriceUsc: number, quantity: number, isDiscountable: boolean, cartItemCode?: string | undefined } }>, discounts: Array<{ __typename?: 'InvoiceDiscounts', discountRate?: number | undefined, discountAmountUsc?: number | undefined, type: DiscountType }>, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string } | undefined, invoicePayments: Array<{ __typename?: 'InvoicePayments', appliedAmountUsc: number, paymentRecord: { __typename?: 'PaymentRecords', paymentMethod: PaymentMethod, paymentRecordGuid: string, amountUsd: number } }> } }> };

export type AppointmentDetailAccountPhotosQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AppointmentDetailAccountPhotosQuery = { __typename?: 'query_root', photoLinksAggregate: { __typename?: 'PhotoLinksAggregate', aggregate?: { __typename?: 'PhotoLinksAggregateFields', count: number } | undefined }, photoLinks: Array<{ __typename?: 'PhotoLinks', updatedAt: IsoDateString, photo: { __typename?: 'Photos', photoGuid: string, cdnUrl: string } }> };

export type AppointmentDetailLocationPhotosQueryVariables = Exact<{
  locationGuid: Scalars['uuid'];
}>;


export type AppointmentDetailLocationPhotosQuery = { __typename?: 'query_root', photoLinksAggregate: { __typename?: 'PhotoLinksAggregate', aggregate?: { __typename?: 'PhotoLinksAggregateFields', count: number } | undefined }, photoLinks: Array<{ __typename?: 'PhotoLinks', updatedAt: IsoDateString, photo: { __typename?: 'Photos', photoGuid: string, cdnUrl: string } }>, jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', photoGuid: string, cdnUrl: string } }>, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', city: string, line1: string, stateAbbreviation: string, zipCode: string } } }> };

export type AppointmentDetailAccountJobsPhotosQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AppointmentDetailAccountJobsPhotosQuery = { __typename?: 'query_root', photoLinksAggregate: { __typename?: 'PhotoLinksAggregate', aggregate?: { __typename?: 'PhotoLinksAggregateFields', count: number } | undefined }, jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', photoGuid: string, cdnUrl: string } }>, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', city: string, line1: string, stateAbbreviation: string, zipCode: string } } }> };

export type GetJobInvoiceStatusesSubscriptionSubscriptionVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type GetJobInvoiceStatusesSubscriptionSubscription = { __typename?: 'subscription_root', jobsByPk?: { __typename?: 'Jobs', jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', status: InvoiceV2Status } }> } | undefined };

export type AttachmentsSectionFilesQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
}>;


export type AttachmentsSectionFilesQueryQuery = { __typename?: 'query_root', jobs: Array<{ __typename?: 'Jobs', fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', fileGuid: string, fileName: string, createdAt: IsoDateString, cdnUrl: string } }>, linkedToJobs: Array<{ __typename?: 'JobsWithLinkedJob', job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string } }, linked_job: { __typename?: 'Jobs', fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', fileGuid: string, fileName: string, createdAt: IsoDateString, cdnUrl: string } }> } }> }> };

export type GetRelevantChecklistDataQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  appointmentChecklistInstanceGuids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetRelevantChecklistDataQuery = { __typename?: 'query_root', companiesByPk?: { __typename?: 'Companies', name: string } | undefined, appointmentChecklistInstances: Array<{ __typename?: 'AppointmentChecklistInstances', jobAppointment: { __typename?: 'JobAppointments', job: { __typename?: 'Jobs', pointOfContact: { __typename?: 'Contacts', fullName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined }, account: { __typename?: 'Accounts', accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', fullName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } }> } } } }> };

export type SubscribeToFetchEndOfAppointmentNextStepsSubscriptionVariables = Exact<{
  jobAppointmentGuid: Scalars['uuid'];
}>;


export type SubscribeToFetchEndOfAppointmentNextStepsSubscription = { __typename?: 'subscription_root', jobAppointmentsByPk?: { __typename?: 'JobAppointments', endOfAppointmentNextSteps?: object | undefined } | undefined };

export type PhotoGalleryPhotoDetailModalPhotoQueryQueryVariables = Exact<{
  photoGuid: Scalars['uuid'];
}>;


export type PhotoGalleryPhotoDetailModalPhotoQueryQuery = { __typename?: 'query_root', photoLinks: Array<{ __typename?: 'PhotoLinks', jobGuid?: string | undefined, photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string, createdByUserGuid: string, createdAt: IsoDateString, companyGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', noteGuid: string, value: string, updatedAt: IsoDateString } }>, user: { __typename?: 'Users', fullName: string } } }> };

export type PhotoGalleryPhotoDetailModalSetDescriptionMutationMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  noteGuid: Scalars['uuid'];
  createdByUserGuid: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
  value: Scalars['String'];
  photoGuid: Scalars['uuid'];
}>;


export type PhotoGalleryPhotoDetailModalSetDescriptionMutationMutation = { __typename?: 'mutation_root', insertNotesOne?: { __typename: 'Notes' } | undefined, insertNoteLinksOne?: { __typename: 'NoteLinks' } | undefined };

export type PhotoGalleryPhotoDetailModalDeletePhotoMutationMutationVariables = Exact<{
  noteGuid?: InputMaybe<Scalars['uuid']>;
  photoGuid?: InputMaybe<Scalars['uuid']>;
}>;


export type PhotoGalleryPhotoDetailModalDeletePhotoMutationMutation = { __typename?: 'mutation_root', deleteNoteLinksByPk?: { __typename: 'NoteLinks' } | undefined, deleteNotesByPk?: { __typename: 'Notes' } | undefined, deletePhotoLinksByPk?: { __typename: 'PhotoLinks' } | undefined, deletePhotosByPk?: { __typename: 'Photos' } | undefined };

export type VisitDetailPastVisitCardqueryQueryVariables = Exact<{
  jobAppointmentGuid: Scalars['uuid'];
}>;


export type VisitDetailPastVisitCardqueryQuery = { __typename?: 'query_root', jobAppointments: Array<{ __typename?: 'JobAppointments', appointmentType: AppointmentType, appointmentWindowStart: IsoDateString, appointmentWindowEnd: IsoDateString, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined } } }, assignments: Array<{ __typename?: 'JobAppointmentAssignments', assignmentStart: IsoDateString, assignmentEnd: IsoDateString, technician: { __typename?: 'Users', fullName: string }, assignmentStatus?: { __typename?: 'JobAppointmentAssignmentStatuses', jobAppointmentAssignmentStatusType: JobAppointmentAssignmentStatusTypesEnum } | undefined }> }> };

export type JobPointOfContactFragmentFragment = { __typename?: 'Contacts', notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, unsubscribed: boolean } | undefined };

export type JobPointOfContactNotificationPreferenceTypeQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type JobPointOfContactNotificationPreferenceTypeQuery = { __typename?: 'query_root', jobsByPk?: { __typename?: 'Jobs', pointOfContact: { __typename?: 'Contacts', notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, unsubscribed: boolean } | undefined } } | undefined };

export type UpsertMaintenancePlanVisitsMutationVariables = Exact<{
  objects: Array<MaintenancePlanVisitsInsertInput> | MaintenancePlanVisitsInsertInput;
}>;


export type UpsertMaintenancePlanVisitsMutation = { __typename?: 'mutation_root', insertMaintenancePlanVisits?: { __typename?: 'MaintenancePlanVisitsMutationResponse', affectedRows: number } | undefined };

export type UpsertMaintenancePlanVisitInstalledEquipmentsMutationVariables = Exact<{
  maintenancePlanVisitGuid: Scalars['uuid'];
  installedEquipments: Array<MaintenancePlanVisitInstalledEquipmentsInsertInput> | MaintenancePlanVisitInstalledEquipmentsInsertInput;
}>;


export type UpsertMaintenancePlanVisitInstalledEquipmentsMutation = { __typename?: 'mutation_root', deleteMaintenancePlanVisitInstalledEquipments?: { __typename?: 'MaintenancePlanVisitInstalledEquipmentsMutationResponse', affectedRows: number } | undefined, insertMaintenancePlanVisitInstalledEquipments?: { __typename?: 'MaintenancePlanVisitInstalledEquipmentsMutationResponse', affectedRows: number } | undefined };

export type ClearMaintenancePlanVisitJobLinkFrontendMutationVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type ClearMaintenancePlanVisitJobLinkFrontendMutation = { __typename?: 'mutation_root', clearMaintenancePlanVisitLink?: { __typename: 'MaintenancePlanVisitsMutationResponse' } | undefined };

export type MutateAccountContactArchivedMutationVariables = Exact<{
  accountContactGuid: Scalars['uuid'];
  archived: Scalars['Boolean'];
}>;


export type MutateAccountContactArchivedMutation = { __typename?: 'mutation_root', updateAccountContactsByPk?: { __typename: 'AccountContacts' } | undefined };

export type AppointmentChecklistsFragment = { __typename?: 'JobAppointments', checklists: Array<{ __typename?: 'AppointmentChecklistInstances', jobAppointmentGuid: string, appointmentChecklistInstanceGuid: string, appointmentChecklistGuid: string, checklist: AppointmentChecklistInstanceChecklist, adHoc: boolean, instanceNumber: number, label?: string | undefined }> };

export type AppointmentChecklistsSubscriptionSubscriptionVariables = Exact<{
  jobAppointmentGuid: Scalars['uuid'];
}>;


export type AppointmentChecklistsSubscriptionSubscription = { __typename?: 'subscription_root', jobAppointmentsByPk?: { __typename?: 'JobAppointments', checklists: Array<{ __typename?: 'AppointmentChecklistInstances', jobAppointmentGuid: string, appointmentChecklistInstanceGuid: string, appointmentChecklistGuid: string, checklist: AppointmentChecklistInstanceChecklist, adHoc: boolean, instanceNumber: number, label?: string | undefined }> } | undefined };

export type AllChecklistsSubscriptionSubscriptionVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type AllChecklistsSubscriptionSubscription = { __typename?: 'subscription_root', appointmentChecklists: Array<{ __typename?: 'AppointmentChecklists', name: string, appointmentChecklistGuid: string, items: object }> };

export type EstimateCollapsibleEstimateFragment = { __typename?: 'Estimates', estimateGuid: string, displayId: number, status: EstimateV2Status, closedLostReasonCategory?: string | undefined, closedLostReasonNote?: string | undefined, createdAt: IsoDateString, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string } }, createdByUser: { __typename?: 'Users', fullName: string }, estimateOptions: Array<{ __typename?: 'EstimateOptions', estimateOptionGuid: string, displayName?: string | undefined, seq: number, totalUsc: number, isSelected: boolean }> };

export type EstimatesForCollapsibleSubscriptionVariables = Exact<{
  where: EstimatesBoolExp;
}>;


export type EstimatesForCollapsibleSubscription = { __typename?: 'subscription_root', estimates: Array<{ __typename?: 'Estimates', estimateGuid: string, displayId: number, status: EstimateV2Status, closedLostReasonCategory?: string | undefined, closedLostReasonNote?: string | undefined, createdAt: IsoDateString, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string } }, createdByUser: { __typename?: 'Users', fullName: string }, estimateOptions: Array<{ __typename?: 'EstimateOptions', estimateOptionGuid: string, displayName?: string | undefined, seq: number, totalUsc: number, isSelected: boolean }> }> };

export type EstimatesCollapsibleLinkedEstimatesSubscriptionSubscriptionVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type EstimatesCollapsibleLinkedEstimatesSubscriptionSubscription = { __typename?: 'subscription_root', jobsByPk?: { __typename?: 'Jobs', linkedJobEstimates: Array<{ __typename?: 'JobsWithLinkedJobLinkedEstimates', jobGuid: string, estimate: { __typename?: 'Estimates', estimateGuid: string, displayId: number, status: EstimateV2Status, closedLostReasonCategory?: string | undefined, closedLostReasonNote?: string | undefined, createdAt: IsoDateString, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string } }, createdByUser: { __typename?: 'Users', fullName: string }, estimateOptions: Array<{ __typename?: 'EstimateOptions', estimateOptionGuid: string, displayName?: string | undefined, seq: number, totalUsc: number, isSelected: boolean }> } }> } | undefined };

export type EquipmentCollapsibleUpdateOperationalStatusMutationMutationVariables = Exact<{
  installedEquipmentGuid: Scalars['uuid'];
  operationalStatus: Scalars['String'];
}>;


export type EquipmentCollapsibleUpdateOperationalStatusMutationMutation = { __typename?: 'mutation_root', updateInstalledEquipmentByPk?: { __typename?: 'InstalledEquipment', operationalStatus: string } | undefined };

export type InvoiceCollapsibleDataSubscriptionVariables = Exact<{
  where: InvoicesBoolExp;
}>;


export type InvoiceCollapsibleDataSubscription = { __typename?: 'subscription_root', invoices: Array<{ __typename?: 'Invoices', serviceCompletionDate?: LocalDateString | undefined, displayId: number, displayIdV2: string, invoiceGuid: string, status: InvoiceV2Status, totalUsc: number, invoiceTerm: InvoiceTermV2, issuedAt?: IsoDateString | undefined, taxConfiguration?: { __typename?: 'InvoiceCompanyTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string } | undefined, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', displayId: number, jobType: { __typename?: 'JobTypes', name: string } } } | undefined, invoicePayments: Array<{ __typename?: 'InvoicePayments', appliedAmountUsc: number, paymentRecord: { __typename?: 'PaymentRecords', paymentMethod: PaymentMethod, paymentRecordGuid: string, amountUsd: number } }>, createdByUser: { __typename?: 'Users', fullName: string }, cartItems: Array<{ __typename?: 'InvoiceCartItems', cartItem: { __typename?: 'CartItems', name: string, unitPriceUsc: number, quantity: number, isDiscountable: boolean, cartItemCode?: string | undefined } }>, discounts: Array<{ __typename?: 'InvoiceDiscounts', discountRate?: number | undefined, discountAmountUsc?: number | undefined, type: DiscountType }> }> };

export type InvoicesCollapsibleLinkedInvoicesSubscriptionVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type InvoicesCollapsibleLinkedInvoicesSubscription = { __typename?: 'subscription_root', jobsByPk?: { __typename?: 'Jobs', linkedJobInvoices: Array<{ __typename?: 'JobsWithLinkedJobLinkedInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, displayIdV2: string, status: InvoiceV2Status, totalUsc: number, issuedAt?: IsoDateString | undefined, createdByUser: { __typename?: 'Users', fullName: string }, taxConfiguration?: { __typename?: 'InvoiceCompanyTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined, cartItems: Array<{ __typename?: 'InvoiceCartItems', cartItem: { __typename?: 'CartItems', name: string, unitPriceUsc: number, quantity: number, isDiscountable: boolean, cartItemCode?: string | undefined } }>, discounts: Array<{ __typename?: 'InvoiceDiscounts', discountRate?: number | undefined, discountAmountUsc?: number | undefined, type: DiscountType }>, invoicePayments: Array<{ __typename?: 'InvoicePayments', appliedAmountUsc: number, paymentRecord: { __typename?: 'PaymentRecords', paymentMethod: PaymentMethod, paymentRecordGuid: string, amountUsd: number } }>, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', displayId: number, jobType: { __typename?: 'JobTypes', name: string } } } | undefined, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string } | undefined } }> } | undefined };

export type JobCardDataFragment = { __typename?: 'Jobs', displayId: number, jobGuid: string, createdAt: IsoDateString, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string, addressGuid: string } }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string, color: string }, jobTechnicianSoldRevenueSummaries: Array<{ __typename?: 'JobTechnicianSoldRevenueSummaries', technicianUserGuid?: string | undefined, totalSoldRevenueUsc?: number | undefined, technician?: { __typename?: 'Users', fullName: string, userGuid: string } | undefined }>, appointments: Array<{ __typename?: 'JobAppointments', appointmentGuid: string, assignments: Array<{ __typename?: 'JobAppointmentAssignments', jobAppointmentAssignmentGuid: string, technician: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string } }> }> };

export type LinkedJobsCollapsibleLinkedJobsQueryQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type LinkedJobsCollapsibleLinkedJobsQueryQuery = { __typename?: 'query_root', jobsWithLinkedJob: Array<{ __typename?: 'JobsWithLinkedJob', linked_job: { __typename?: 'Jobs', displayId: number, jobGuid: string, createdAt: IsoDateString, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string, addressGuid: string } }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string, color: string }, jobTechnicianSoldRevenueSummaries: Array<{ __typename?: 'JobTechnicianSoldRevenueSummaries', technicianUserGuid?: string | undefined, totalSoldRevenueUsc?: number | undefined, technician?: { __typename?: 'Users', fullName: string, userGuid: string } | undefined }>, appointments: Array<{ __typename?: 'JobAppointments', appointmentGuid: string, assignments: Array<{ __typename?: 'JobAppointmentAssignments', jobAppointmentAssignmentGuid: string, technician: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string } }> }> } }> };

export type LinkedJobsCollapsibleFollowUpJobsQueryQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type LinkedJobsCollapsibleFollowUpJobsQueryQuery = { __typename?: 'query_root', jobsWithLinkedJob: Array<{ __typename?: 'JobsWithLinkedJob', job: { __typename?: 'Jobs', displayId: number, jobGuid: string, createdAt: IsoDateString, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string, addressGuid: string } }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string, color: string }, jobTechnicianSoldRevenueSummaries: Array<{ __typename?: 'JobTechnicianSoldRevenueSummaries', technicianUserGuid?: string | undefined, totalSoldRevenueUsc?: number | undefined, technician?: { __typename?: 'Users', fullName: string, userGuid: string } | undefined }>, appointments: Array<{ __typename?: 'JobAppointments', appointmentGuid: string, assignments: Array<{ __typename?: 'JobAppointmentAssignments', jobAppointmentAssignmentGuid: string, technician: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string } }> }> } }> };

export type ReadStaleInvoiceInfoForCompanyQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type ReadStaleInvoiceInfoForCompanyQuery = { __typename?: 'query_root', invoicesV2AccountingStale: Array<{ __typename?: 'InvoicesV2AccountingStale', invoiceGuid?: string | undefined, isStale?: boolean | undefined, syncedAt?: IsoDateString | undefined, invoiceUpdatedAt?: IsoDateString | undefined }> };

export type ReadStalePaymentInfoForCompanyQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type ReadStalePaymentInfoForCompanyQuery = { __typename?: 'query_root', paymentsAccountingStaleInfo: Array<{ __typename?: 'PaymentsAccountingStaleInfo', paymentRecordGuid?: string | undefined, syncedAt?: IsoDateString | undefined, externalEntityId?: string | undefined, accountingIntegrationType?: string | undefined, paymentUpdatedAt?: IsoDateString | undefined, paymentCreatedAt?: IsoDateString | undefined, isStale?: boolean | undefined, companyGuid?: string | undefined }> };

export type UpsertAccountingCompanyConfigAutoSyncInvoiceOnFullyPaidMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigAutoSyncInvoiceOnFullyPaidMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type UpsertAccountingCompanyConfigAutoSyncInvoiceOnIssuedMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigAutoSyncInvoiceOnIssuedMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type UpsertAccountingCompanyConfigDynamicTaxRateCalculationEnabledMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigDynamicTaxRateCalculationEnabledMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type UpsertAccountingCompanyConfigAutoSyncInvoiceOnPaymentMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigAutoSyncInvoiceOnPaymentMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type UpsertAccountingCompanyConfigAutoSyncInvoiceOnVoidedMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigAutoSyncInvoiceOnVoidedMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type UpsertAccountingCompanyConfigAutoSyncPayoutsMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigAutoSyncPayoutsMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type UpsertAccountingCompanyConfigAutoSyncPaymentsMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigAutoSyncPaymentsMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type UpsertAccountingCompanyConfigSyncBusinessUnitsMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigSyncBusinessUnitsMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type UpsertAccountingCompanyConfigSyncTaxesFullIntegrationMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigSyncTaxesFullIntegrationMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type UpsertAccountingCompanyConfigSyncInventoryTrackingMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigSyncInventoryTrackingMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type UpsertAccountingCompanyConfigSyncDiscountsAsNegativeLineItemsMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigSyncDiscountsAsNegativeLineItemsMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type UpsertAccountingCompanyConfigSyncPayoutsUsingSingleItemMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigSyncPayoutsUsingSingleItemMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type UpsertAccountingCompanyConfigSyncLocationsAsQbdSubaccountsMutationVariables = Exact<{
  object: AccCompanyConfigInsertInput;
}>;


export type UpsertAccountingCompanyConfigSyncLocationsAsQbdSubaccountsMutation = { __typename?: 'mutation_root', insertAccCompanyConfigOne?: { __typename: 'AccCompanyConfig' } | undefined };

export type ReadAccountingCompanyConfigQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type ReadAccountingCompanyConfigQueryQuery = { __typename?: 'query_root', accCompanyConfigByPk?: { __typename?: 'AccCompanyConfig', autosyncInvoiceOnFullyPaid: boolean, autosyncInvoiceOnIssued: boolean, autosyncInvoiceOnPayment: boolean, autosyncInvoiceOnVoided: boolean, autosyncPayouts: boolean, autosyncPayments: boolean, syncBusinessUnits: boolean, syncTaxesFullIntegration: boolean, syncUsingInventoryTracking: boolean, dynamicTaxRateCalculationEnabled: boolean, syncDiscountsAsNegativeLineItems: boolean, syncPayoutsUsingSingleItem: boolean, syncLocationsAsQbdSubaccounts: boolean } | undefined };

export type UpsertCompanyConfigMutationVariables = Exact<{
  config: CompanyConfigInsertInput;
}>;


export type UpsertCompanyConfigMutation = { __typename?: 'mutation_root', insertCompanyConfigOne?: { __typename: 'CompanyConfig' } | undefined };

export type UpsertCompanyNotificationSettingsMutationVariables = Exact<{
  settings: CompanyNotificationSettingsInsertInput;
}>;


export type UpsertCompanyNotificationSettingsMutation = { __typename?: 'mutation_root', insertCompanyNotificationSettingsOne?: { __typename: 'CompanyNotificationSettings' } | undefined };

export type UpsertCompanyConfigMaintenancePlansEnabledMutationVariables = Exact<{
  config: CompanyConfigInsertInput;
}>;


export type UpsertCompanyConfigMaintenancePlansEnabledMutation = { __typename?: 'mutation_root', insertCompanyConfigOne?: { __typename: 'CompanyConfig' } | undefined };

export type UpsertCompanyConfigTimesheetsEnabledMutationVariables = Exact<{
  config: CompanyConfigInsertInput;
}>;


export type UpsertCompanyConfigTimesheetsEnabledMutation = { __typename?: 'mutation_root', insertCompanyConfigOne?: { __typename: 'CompanyConfig' } | undefined };

export type UpsertCompanyConfigTimesheetsPayPeriodEndAnchorMutationVariables = Exact<{
  config: CompanyConfigInsertInput;
}>;


export type UpsertCompanyConfigTimesheetsPayPeriodEndAnchorMutation = { __typename?: 'mutation_root', insertCompanyConfigOne?: { __typename: 'CompanyConfig' } | undefined };

export type UpsertCompanyConfigTimesheetsPayPeriodEndRRuleMutationVariables = Exact<{
  config: CompanyConfigInsertInput;
}>;


export type UpsertCompanyConfigTimesheetsPayPeriodEndRRuleMutation = { __typename?: 'mutation_root', insertCompanyConfigOne?: { __typename: 'CompanyConfig' } | undefined };

export type UpsertCompanyConfigTechnicianPerformanceEnabledMutationVariables = Exact<{
  config: CompanyConfigInsertInput;
}>;


export type UpsertCompanyConfigTechnicianPerformanceEnabledMutation = { __typename?: 'mutation_root', insertCompanyConfigOne?: { __typename: 'CompanyConfig' } | undefined };

export type UpsertCompanyConfigDripMarketingSettingsMutationVariables = Exact<{
  settings: CompanyDripMarketingConfigInsertInput;
}>;


export type UpsertCompanyConfigDripMarketingSettingsMutation = { __typename?: 'mutation_root', insertCompanyDripMarketingConfigOne?: { __typename: 'CompanyDripMarketingConfig' } | undefined };

export type ReadCompanyConfigQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type ReadCompanyConfigQueryQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', confirmationNotificationSuppressedByDefault: boolean, defaultAccountManagerUserGuid?: string | undefined, hiddenEquipmentTypesJsonArray?: EquipmentTypeArray | undefined, locationMunicipalityFieldEnabled: boolean, visibleInstallProjectTypesJsonArray?: object | undefined, blurb?: string | undefined, maintenancePlansEnabled: boolean } | undefined };

export type FetchPricebookSettingsConfigQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchPricebookSettingsConfigQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', pricebookPhotosEnabled: boolean } | undefined, companyPricingTierConfigByPk?: { __typename?: 'CompanyPricingTierConfig', memberTierEnabled: boolean, memberAddonTierEnabled: boolean, memberAfterhoursTierEnabled: boolean, memberAddonAfterhoursTierEnabled: boolean, addonTierEnabled: boolean, addonAfterhoursTierEnabled: boolean, afterhoursTierEnabled: boolean, businessHoursStartTime: LocalTimeString, businessHoursEndTime: LocalTimeString, saturdayIsBusinessDay: boolean, sundayIsBusinessDay: boolean } | undefined };

export type AddressFragment = { __typename?: 'Addresses', addressGuid: string, canonicalFullAddress: string, line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string, createdAt: IsoDateString, geoLocation: Geo };

export type ContactFragment = { __typename?: 'Contacts', contactGuid: string, companyGuid: string, firstName: string, lastName: string, salutation?: string | undefined, title?: string | undefined, notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddressGuid: string, emailAddress: string, companyGuid: string } | undefined, additionalEmailAddress?: { __typename?: 'EmailAddresses', emailAddressGuid: string, emailAddress: string, companyGuid: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, additionalPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', accountGuid: string }> };

export type JobTypeFragment = { __typename?: 'JobTypes', name: string, description: string, defaultSummary?: string | undefined, hideJobSummaryField?: boolean | undefined, isIncludedInJobCosting: boolean, companyGuid: string, lastModifiedBy: string, jobTypeGuid: string, jobLifecycleGuid: string, jobClass: JobClassesEnum, createdAt: IsoDateString, updatedAt: IsoDateString, isOpportunity: boolean, opportunityConversionThresholdUsc?: number | undefined, isPotentialHotLead: boolean, hotLeadMinimumEquipmentAgeYears?: number | undefined, durationMinutes: number, defaultBusinessUnitGuid?: string | undefined, color?: string | undefined, jobLifecycle: { __typename?: 'JobLifecycles', name: string, jobLifecycleGuid: string } };

export type LoanRecordFragment = { __typename?: 'WisetackLoanRecords', wisetackLoanRecordGuid: string, accountGuid: string, companyGuid: string, invoiceGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackMerchantGuid: string, wisetackTransactionGuid: string, requestedLoanAmountUsc: number, approvedLoanAmountUsc?: number | undefined, settledLoanAmountUsc?: number | undefined, processingFeeUsc?: number | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, expiresAt?: IsoDateString | undefined, loanApplicationLink: string, wisetackLoanStatuses: Array<{ __typename?: 'WisetackLoanStatuses', loanStatus: WisetackLoanStatusTypesEnum, loanStatusDetail?: string | undefined, occurredAt: IsoDateString, createdAt?: IsoDateString | undefined }>, contact: { __typename?: 'Contacts', fullName: string } };

export type LoanRecordStatusFragment = { __typename?: 'WisetackLoanStatuses', loanStatus: WisetackLoanStatusTypesEnum, loanStatusDetail?: string | undefined, occurredAt: IsoDateString, createdAt?: IsoDateString | undefined };

export type LocationContactRecordFragment = { __typename?: 'LocationContacts', locationGuid: string, contactGuid: string, createdAt: IsoDateString, locationContactRelationTypes: object, notes?: string | undefined, updatedAt: IsoDateString };

export type LocationContactWithoutLocationFragment = { __typename?: 'LocationContacts', locationGuid: string, contactGuid: string, createdAt: IsoDateString, locationContactRelationTypes: object, notes?: string | undefined, updatedAt: IsoDateString, contact: { __typename?: 'Contacts', contactGuid: string, companyGuid: string, firstName: string, lastName: string, salutation?: string | undefined, title?: string | undefined, notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddressGuid: string, emailAddress: string, companyGuid: string } | undefined, additionalEmailAddress?: { __typename?: 'EmailAddresses', emailAddressGuid: string, emailAddress: string, companyGuid: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, additionalPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', accountGuid: string }> } };

export type MaintenancePlanMinimalFragment = { __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, status: MaintenancePlanStatus, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', imageUrl: string, primaryColorHex: string } | undefined } | undefined };

export type MaintenancePlanDefinitionMinimalFragment = { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', imageUrl: string, primaryColorHex: string } | undefined };

export type MaintenancePlanOpportunityMinimalInfoFragment = { __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, accountGuid: string, locationGuid: string, status: MaintenancePlanStatus, credits: CreditRecordArray, lastVisitedAt?: IsoDateString | undefined, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', numVisitCreditsPerYear: number, marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined };

export type MaintenancePlanVisitFragment = { __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> };

export type PrequalRecordFragment = { __typename?: 'WisetackPrequalRecords', wisetackPrequalRecordGuid: string, accountGuid: string, companyGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackPrequalGuid: string, wisetackMerchantGuid: string, prequalifiedAmountUsc?: number | undefined, maxQualifiedAmountUsc?: number | undefined, aprRange?: string | undefined, status: WisetackPrequalStatusTypesEnum, expirationDate?: IsoDateString | undefined, prequalifiedAt?: IsoDateString | undefined, declinedAt?: IsoDateString | undefined, expiredAt?: IsoDateString | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, prequalLink: string };

export type PrequalRecordWithContactNameFragment = { __typename?: 'WisetackPrequalRecords', wisetackPrequalRecordGuid: string, accountGuid: string, companyGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackPrequalGuid: string, wisetackMerchantGuid: string, prequalifiedAmountUsc?: number | undefined, maxQualifiedAmountUsc?: number | undefined, aprRange?: string | undefined, status: WisetackPrequalStatusTypesEnum, expirationDate?: IsoDateString | undefined, prequalifiedAt?: IsoDateString | undefined, declinedAt?: IsoDateString | undefined, expiredAt?: IsoDateString | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, prequalLink: string, contact: { __typename?: 'Contacts', fullName: string } };

export type TagFragment = { __typename?: 'Tags', tagGuid: string, companyGuid: string, createdByUserGuid?: string | undefined, name: string, color: string };

export type TagMinimalFragment = { __typename?: 'Tags', companyGuid: string, tagGuid: string, name: string, color: string };

export type GetJobSummaryQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type GetJobSummaryQuery = { __typename?: 'query_root', jobsByPk?: { __typename?: 'Jobs', jobGuid: string, displayId: number, summary?: string | undefined, summaryHtml?: HtmlString | undefined } | undefined };

export type CompanyConfigAccountNameTemplateQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type CompanyConfigAccountNameTemplateQuery = { __typename?: 'query_root', companiesByPk?: { __typename?: 'Companies', companyConfig?: { __typename?: 'CompanyConfig', accountNameDisplayTemplate: MustacheTemplate } | undefined } | undefined };

export type JobsRecentJobsQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  closedStatuses: Array<Scalars['String']> | Scalars['String'];
  jobLifecycleStatusUpdatedAt: Scalars['timestamptz'];
}>;


export type JobsRecentJobsQueryQuery = { __typename?: 'query_root', jobs: Array<{ __typename?: 'Jobs', companyGuid: string, jobGuid: string, jobLifecycleStatusGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, isOpportunity: boolean, isHotLead: boolean, isMembershipOpportunity: boolean, isMembershipRenewalOpportunity: boolean, isConverted?: boolean | undefined, isMembershipSold?: boolean | undefined, commissionOverheadDeductionRate?: number | undefined, commissionOverheadFlatDeductionUsc?: number | undefined, commissionJobCostsDeductionRate?: number | undefined, commissionJobCostsFlatDeductionUsc?: number | undefined, businessUnitGuid?: string | undefined, account: { __typename?: 'Accounts', accountGuid: string, accountDisplayName: string, accountReferenceNumber: string, accountManager?: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string } | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', primary: boolean, contact: { __typename?: 'Contacts', firstName: string, lastName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } }>, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', tagGuid: string, companyGuid: string, createdByUserGuid?: string | undefined, name: string, color: string } }> }, appointments: Array<{ __typename?: 'JobAppointments', appointmentWindowStart: IsoDateString, appointmentWindowEnd: IsoDateString, assignments: Array<{ __typename?: 'JobAppointmentAssignments', technician: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string, userPrimaryHueHex?: string | undefined, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined } }> }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', stage: JobLifecycleStage, name: string, jobLifecycleGuid: string }, jobType: { __typename?: 'JobTypes', name: string, jobClass: JobClassesEnum, opportunityConversionThresholdUsc?: number | undefined }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', addressGuid: string, line1: string, zipCode: string, city: string, stateAbbreviation: string, geoLocation: Geo } }, tags: Array<{ __typename?: 'JobTags', tag: { __typename?: 'Tags', tagGuid: string, companyGuid: string, createdByUserGuid?: string | undefined, name: string, color: string } }>, jobTeamMembers: Array<{ __typename?: 'JobTeamMembers', jobGuid: string, userGuid: string, turnedOverJob?: boolean | undefined, commissionRate?: number | undefined, bonusUsc?: number | undefined }>, estimates: Array<{ __typename?: 'Estimates', estimateGuid: string, displayId: number, status: EstimateV2Status, estimateOptions: Array<{ __typename?: 'EstimateOptions', totalUsc: number, estimateGuid?: string | undefined, isSelected: boolean, estimateOptionGuid: string, seq: number }> }>, linkedJobEstimates: Array<{ __typename?: 'JobsWithLinkedJobLinkedEstimates', estimate: { __typename?: 'Estimates', estimateGuid: string, displayId: number, status: EstimateV2Status, estimateOptions: Array<{ __typename?: 'EstimateOptions', totalUsc: number, estimateGuid?: string | undefined, isSelected: boolean, estimateOptionGuid: string, seq: number }> } }>, invoicesQueryables: Array<{ __typename?: 'InvoicesQueryable', displayId: number, invoiceGuid: string, invoiceStatus: InvoiceStatuses, invoiceTerm: InvoiceTermsEnum, totalAmountUsd: number }>, jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', displayId: number, displayIdV2: string, invoiceGuid: string, status: InvoiceV2Status, invoiceTerm: InvoiceTermV2, totalUsc: number } }>, linkedJobs: Array<{ __typename?: 'JobsWithLinkedJob', job: { __typename?: 'Jobs', displayId: number, jobGuid: string, jobType: { __typename?: 'JobTypes', name: string } } }>, linkedToJobs: Array<{ __typename?: 'JobsWithLinkedJob', job: { __typename?: 'Jobs', displayId: number, jobGuid: string }, linked_job: { __typename?: 'Jobs', displayId: number, jobGuid: string } }>, businessUnit?: { __typename?: 'BusinessUnits', businessUnitGuid: string, name: string } | undefined }> };

export type TagsMinimalForCompanyQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type TagsMinimalForCompanyQueryQuery = { __typename?: 'query_root', tags: Array<{ __typename?: 'Tags', companyGuid: string, tagGuid: string, name: string, color: string }> };

export type GetCompanyUniqueZipCodesQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetCompanyUniqueZipCodesQuery = { __typename?: 'query_root', locations: Array<{ __typename?: 'Locations', address: { __typename?: 'Addresses', zipCode: string } }> };

export type FetchTimesheetsConfigQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchTimesheetsConfigQuery = { __typename?: 'query_root', companyConfig: Array<{ __typename?: 'CompanyConfig', timesheetsEnabled: boolean, timesheetPayPeriodBeginRrule: string, timesheetPayPeriodBeginAnchor: IsoDateString }> };

export type FetchEndOfJobAppointmentWorkflowEnabledQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchEndOfJobAppointmentWorkflowEnabledQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', endOfJobAppointmentWorkflowEnabled: boolean } | undefined };

export type FetchScheduleColorModeQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchScheduleColorModeQuery = { __typename?: 'query_root', companyConfig?: { __typename?: 'CompanyConfig', scheduleColorMode: string } | undefined };

export type UnlinkJobFromIntegratedPhoneCallMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  integratedPhoneCallGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
}>;


export type UnlinkJobFromIntegratedPhoneCallMutation = { __typename?: 'mutation_root', deleteIntegratedPhoneCallJobs?: { __typename?: 'IntegratedPhoneCallJobsMutationResponse', affectedRows: number } | undefined };

export type FetchTechnicianLocationAppointmentAssignmentsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  technicianUserGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
}>;


export type FetchTechnicianLocationAppointmentAssignmentsQuery = { __typename?: 'query_root', jobAppointments: Array<{ __typename?: 'JobAppointments', job: { __typename?: 'Jobs', locationGuid: string }, assignments: Array<{ __typename?: 'JobAppointmentAssignments', technician: { __typename?: 'Users', userGuid: string } }> }> };

export type FetchTechnicianAccountAppointmentAssignmentsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  technicianUserGuid: Scalars['uuid'];
  accountGuid: Scalars['uuid'];
}>;


export type FetchTechnicianAccountAppointmentAssignmentsQuery = { __typename?: 'query_root', jobAppointments: Array<{ __typename?: 'JobAppointments', job: { __typename?: 'Jobs', account: { __typename?: 'Accounts', accountGuid: string } }, assignments: Array<{ __typename?: 'JobAppointmentAssignments', technician: { __typename?: 'Users', userGuid: string } }> }> };

export type FetchTechnicianJobAppointmentAssignmentQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
  technicianUserGuid: Scalars['uuid'];
}>;


export type FetchTechnicianJobAppointmentAssignmentQuery = { __typename?: 'query_root', jobAppointmentAssignments: Array<{ __typename?: 'JobAppointmentAssignments', technicianUserGuid: string }> };

export type FetchJobCreatedByUserQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
}>;


export type FetchJobCreatedByUserQuery = { __typename?: 'query_root', jobs: Array<{ __typename?: 'Jobs', createdByUserGuid: string }> };

export type UseCompanyHiddenPaymentMethodsQueryQueryVariables = Exact<{
  companyGuid?: InputMaybe<Scalars['uuid']>;
}>;


export type UseCompanyHiddenPaymentMethodsQueryQuery = { __typename?: 'query_root', billingProfileHiddenPaymentMethods: Array<{ __typename?: 'BillingProfileHiddenPaymentMethods', companyGuid: string, paymentMethod: PaymentMethod }> };

export type CompanyUnreadNotificationsCountSubscriptionVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type CompanyUnreadNotificationsCountSubscription = { __typename?: 'subscription_root', integratedChannelReadableItemsAggregate: { __typename?: 'IntegratedChannelReadableItemsAggregate', aggregate?: { __typename?: 'IntegratedChannelReadableItemsAggregateFields', count: number } | undefined } };

export type EndOfVisitJobInvoiceRequiredSettingsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type EndOfVisitJobInvoiceRequiredSettingsQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', jobInvoiceIsRequiredToCompleteVisit: boolean, jobInvoiceIsRequiredToCompleteVisitExcludeSalesClass?: boolean | undefined } | undefined };

export type JobClassQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type JobClassQuery = { __typename?: 'query_root', jobsByPk?: { __typename?: 'Jobs', jobType: { __typename?: 'JobTypes', jobClass: JobClassesEnum } } | undefined };

export type EndOfVisitReviewSettingsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type EndOfVisitReviewSettingsQuery = { __typename?: 'query_root', companyNotificationSettingsByPk?: { __typename?: 'CompanyNotificationSettings', endOfVisitSendReviewLinkEnabled?: boolean | undefined, endOfVisitSendReviewLinkFrequency: ReminderFrequency, endOfVisitSendReviewLinkCount?: number | undefined, endOfVisitSendReviewLinkType: ReviewType } | undefined, companiesByPk?: { __typename?: 'Companies', companyReviewLinks: Array<{ __typename?: 'CompanyReviewLinks', companyReviewLinkGuid: string, companyGuid: string, label: string, reviewType: string, platformId: string, sortOrder: number, isActive: boolean, isEligibleForTechnician: boolean, isDefault: boolean }> } | undefined };

export type EstimateTemplateFragment = { __typename?: 'EstimateTemplates', estimateTemplateGuid: string, templateName: string, messagePreset: EstimateTemplateMessagePreset, customMessageHtml?: HtmlString | undefined, updatedAt: IsoDateString, estimateOptions: Array<{ __typename?: 'EstimateOptions', descriptionHtml?: HtmlString | undefined, displayName?: string | undefined, totalUsc: number, featuredPhotoGuid?: string | undefined, seq: number, optionGuid: string, recommended: boolean, selected: boolean, featuredPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined, estimateOptionDiscounts: Array<{ __typename?: 'EstimateOptionDiscounts', discountAmountUsc?: number | undefined, discountRate?: number | undefined, discountType: DiscountType, descriptionHtml?: HtmlString | undefined, name?: string | undefined, seq: number, discountGuid: string }>, cartItems: Array<{ __typename?: 'EstimateOptionCartItems', seq: number, cartItem: { __typename?: 'CartItems', cartItemGuid: string, description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, originalPricebookItemGuid?: string | undefined, quantity: number, unitPriceUsc: number, cartItemCode?: string | undefined, cartItemVariant: CartItemVariant, itemType: CartItemType, photo?: { __typename?: 'Photos', photoGuid: string, cdnUrl: string } | undefined } }> }> };

export type ReadEstimateTemplatesQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type ReadEstimateTemplatesQuery = { __typename?: 'query_root', estimateTemplates: Array<{ __typename?: 'EstimateTemplates', estimateTemplateGuid: string, templateName: string, messagePreset: EstimateTemplateMessagePreset, customMessageHtml?: HtmlString | undefined, updatedAt: IsoDateString, estimateOptions: Array<{ __typename?: 'EstimateOptions', descriptionHtml?: HtmlString | undefined, displayName?: string | undefined, totalUsc: number, featuredPhotoGuid?: string | undefined, seq: number, optionGuid: string, recommended: boolean, selected: boolean, featuredPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined, estimateOptionDiscounts: Array<{ __typename?: 'EstimateOptionDiscounts', discountAmountUsc?: number | undefined, discountRate?: number | undefined, discountType: DiscountType, descriptionHtml?: HtmlString | undefined, name?: string | undefined, seq: number, discountGuid: string }>, cartItems: Array<{ __typename?: 'EstimateOptionCartItems', seq: number, cartItem: { __typename?: 'CartItems', cartItemGuid: string, description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, originalPricebookItemGuid?: string | undefined, quantity: number, unitPriceUsc: number, cartItemCode?: string | undefined, cartItemVariant: CartItemVariant, itemType: CartItemType, photo?: { __typename?: 'Photos', photoGuid: string, cdnUrl: string } | undefined } }> }> }> };

export type ReadEstimateTemplateQueryVariables = Exact<{
  estimateTemplateGuid: Scalars['uuid'];
}>;


export type ReadEstimateTemplateQuery = { __typename?: 'query_root', estimateTemplatesByPk?: { __typename?: 'EstimateTemplates', estimateTemplateGuid: string, templateName: string, messagePreset: EstimateTemplateMessagePreset, customMessageHtml?: HtmlString | undefined, updatedAt: IsoDateString, estimateOptions: Array<{ __typename?: 'EstimateOptions', descriptionHtml?: HtmlString | undefined, displayName?: string | undefined, totalUsc: number, featuredPhotoGuid?: string | undefined, seq: number, optionGuid: string, recommended: boolean, selected: boolean, featuredPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined, estimateOptionDiscounts: Array<{ __typename?: 'EstimateOptionDiscounts', discountAmountUsc?: number | undefined, discountRate?: number | undefined, discountType: DiscountType, descriptionHtml?: HtmlString | undefined, name?: string | undefined, seq: number, discountGuid: string }>, cartItems: Array<{ __typename?: 'EstimateOptionCartItems', seq: number, cartItem: { __typename?: 'CartItems', cartItemGuid: string, description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, originalPricebookItemGuid?: string | undefined, quantity: number, unitPriceUsc: number, cartItemCode?: string | undefined, cartItemVariant: CartItemVariant, itemType: CartItemType, photo?: { __typename?: 'Photos', photoGuid: string, cdnUrl: string } | undefined } }> }> } | undefined };

export type ReadEstimateTemplateMetadataQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type ReadEstimateTemplateMetadataQuery = { __typename?: 'query_root', estimateTemplates: Array<{ __typename?: 'EstimateTemplates', estimateTemplateGuid: string, templateName: string }> };

export type GetCompanyBillingProfileFrontendQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetCompanyBillingProfileFrontendQuery = { __typename?: 'query_root', billingProfiles: Array<{ __typename?: 'BillingProfiles', companyGuid: string, visitReplenishmentStrategy: string, visitReplenishmentMonth: number, visitReplenishmentDay: number, invoiceMemo?: string | undefined, invoiceTerm?: InvoiceTermsEnum | undefined, businessFullLegalName: string, contractorLicenseNumber?: string | undefined, logoUrl: string, estimateDisclaimer: string, invoiceDisclaimer: string, tilledMerchantAccountId?: string | undefined, emailAddressGuid: string, phoneNumberGuid: string, websiteUrl?: string | undefined, websiteDisplayName?: string | undefined, wisetackMerchantId?: string | undefined, businessAddressGuid?: string | undefined, defaultPricebookTaxRateGuid?: string | undefined, maintenancePlanTaxRateGuid?: string | undefined, maintenancePlanServiceItemGuid?: string | undefined, maintenancePlanAutoRenewalAllowed: boolean, maintenancePlanManualRenewalAllowed: boolean, maintenancePlanStaticDurationNumYearsAllowed: Array<number>, emailAddress: { __typename?: 'EmailAddresses', emailAddress: string, emailAddressGuid: string, companyGuid: string, createdByUserGuid: string }, phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType }, businessAddress?: { __typename?: 'Addresses', canonicalFullAddress: string, line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string } | undefined, defaultTaxRate?: { __typename?: 'PricebookTaxRates', pricebookTaxRateGuid: string, name: string, rate: number } | undefined, maintenancePlanTaxRate?: { __typename?: 'PricebookTaxRates', pricebookTaxRateGuid: string, name: string, rate: number } | undefined, maintenancePlanServiceItem?: { __typename?: 'PricebookItems', name: string, description: string, guid: string } | undefined }> };

export type CompanyConfigLineItemVisibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyConfigLineItemVisibilityQuery = { __typename?: 'query_root', companyConfig: Array<{ __typename?: 'CompanyConfig', estimateLineItemsVisibility: CompanyLineItemVisibility, invoiceLineItemsVisibility: CompanyLineItemVisibility }> };

export type LocationMaintenancePlansQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
}>;


export type LocationMaintenancePlansQuery = { __typename?: 'query_root', maintenancePlansQueryable: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, status: MaintenancePlanStatus, terminatesAt?: IsoDateString | undefined, lastVisitedAt?: IsoDateString | undefined, activatedAt?: IsoDateString | undefined, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined, maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }> }> };

export type JobMaintenancePlanDiscountQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type JobMaintenancePlanDiscountQuery = { __typename?: 'query_root', jobsByPk?: { __typename?: 'Jobs', jobGuid: string, jobType: { __typename?: 'JobTypes', jobClass: JobClassesEnum }, maintenancePlan?: { __typename?: 'MaintenancePlansQueryable', status: MaintenancePlanStatus, discounts: MaintenancePlanDiscountArray } | undefined } | undefined };

export type UpsertCompanyBillingProfileMutationVariables = Exact<{
  object: BillingProfilesInsertInput;
}>;


export type UpsertCompanyBillingProfileMutation = { __typename?: 'mutation_root', insertBillingProfilesOne?: { __typename: 'BillingProfiles' } | undefined };

export type UpsertRecentPricebookItemsMutationVariables = Exact<{
  recentPricebookItems: Array<RecentPricebookItemsInsertInput> | RecentPricebookItemsInsertInput;
  onConflict?: InputMaybe<RecentPricebookItemsOnConflict>;
}>;


export type UpsertRecentPricebookItemsMutation = { __typename?: 'mutation_root', insertRecentPricebookItems?: { __typename: 'RecentPricebookItemsMutationResponse' } | undefined };

export type AccountDetailsPageUpdatedAccountViewedAtTimeForUserMutationMutationVariables = Exact<{
  accountGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
  viewedAt: Scalars['timestamptz'];
}>;


export type AccountDetailsPageUpdatedAccountViewedAtTimeForUserMutationMutation = { __typename?: 'mutation_root', insertAccountsViewedByUserOne?: { __typename: 'AccountsViewedByUser' } | undefined };

export type AccountsDetailsPageCompanyConfigQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type AccountsDetailsPageCompanyConfigQueryQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', companyGuid: string, accountManagerEnabled: boolean } | undefined };

export type PhotoRecordFragment = { __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string, resourceUrn: string, createdAt: IsoDateString, createdByUserGuid: string, companyGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } };

export type FileRecordFragment = { __typename?: 'FileLinks', file: { __typename?: 'Files', cdnUrl: string, storageStrategy: FileStorageStrategy, resourceUrn: string, fileGuid: string, fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, createdAt: IsoDateString } };

export type MaintenancePlanCollapsibleDataFragment = { __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, locationGuid: string, status: MaintenancePlanStatus, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, yearlyPriceUsc: number, credits: CreditRecordArray, discounts: MaintenancePlanDiscountArray, coveredInstalledEquipmentGuids: GuidArray, activatedAt?: IsoDateString | undefined, scheduledActivationAt?: IsoDateString | undefined, billingStartAt?: IsoDateString | undefined, terminatesAt?: IsoDateString | undefined, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined, maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }>, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string } } };

export type AccountsDetailsQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AccountsDetailsQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', accountGuid: string, companyGuid: string, accountType: AccountType, accountDisplayName: string, accountManagerUserGuid?: string | undefined, archived: boolean, doNotService: boolean, doNotServiceReason?: string | undefined, defaultInvoiceTerm: InvoiceTermV2, accountReferenceNumber: string, accountCreatedAt: IsoDateString, mailingAddressGuid?: string | undefined, accountLeadSource: Array<{ __typename?: 'CompanyLeadSourceLinks', companyLeadSourceGuid: string, referringContactGuid?: string | undefined, attributionDescription?: string | undefined, referringContact?: { __typename?: 'Contacts', firstName: string, lastName: string } | undefined, companyLeadSource: { __typename?: 'CompanyLeadSources', canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined } }>, tags: Array<{ __typename?: 'AccountTags', tagGuid: string, tag: { __typename?: 'Tags', name: string, color: string } }>, photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string, resourceUrn: string, createdAt: IsoDateString, createdByUserGuid: string, companyGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }>, accountLocations: Array<{ __typename?: 'AccountLocations', accountGuid: string, companyGuid: string, isArchived: boolean, photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string, resourceUrn: string, createdAt: IsoDateString, createdByUserGuid: string, companyGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }>, fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', cdnUrl: string, storageStrategy: FileStorageStrategy, resourceUrn: string, fileGuid: string, fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, createdAt: IsoDateString } }>, location: { __typename?: 'Locations', locationGuid: string, companyGuid: string, displayName?: string | undefined, locationDescription?: string | undefined, estimatedBuildDate?: LocalDateString | undefined, estimatedSquareFootage?: number | undefined, propertyType: string, municipality?: string | undefined, installedHvacSystems: Array<{ __typename?: 'InstalledHvacSystems', installedHvacSystemGuid: string, filterSize?: string | undefined, friendlyName?: string | undefined, notes?: string | undefined, zoningInfo: object, installedEquipment: Array<{ __typename?: 'InstalledEquipment', installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, installationParty?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, description?: string | undefined, manufacturer?: string | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined, manufacturingDate?: LocalDateString | undefined, manufacturerWarrantyEndDate?: LocalDateString | undefined, manufacturerWarrantyStartDate?: LocalDateString | undefined, manufacturerWarrantyTerms?: string | undefined, operationalStatus: string, equipmentCondition?: string | undefined, laborWarrantyStartDate?: LocalDateString | undefined, laborWarrantyEndDate?: LocalDateString | undefined, laborWarrantyTerms?: string | undefined, equipmentDimensions?: string | undefined, locationGuid: string, sourceType: InstalledEquipmentSourceType }> }>, installedEquipment: Array<{ __typename?: 'InstalledEquipment', installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, installationParty?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, description?: string | undefined, manufacturer?: string | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined, manufacturingDate?: LocalDateString | undefined, manufacturerWarrantyEndDate?: LocalDateString | undefined, manufacturerWarrantyStartDate?: LocalDateString | undefined, manufacturerWarrantyTerms?: string | undefined, operationalStatus: string, equipmentCondition?: string | undefined, laborWarrantyStartDate?: LocalDateString | undefined, laborWarrantyEndDate?: LocalDateString | undefined, laborWarrantyTerms?: string | undefined, equipmentDimensions?: string | undefined, locationGuid: string, sourceType: InstalledEquipmentSourceType }>, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string }>, address: { __typename?: 'Addresses', addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string, city: string } } }>, jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, createdAt: IsoDateString, workCompletedAt?: IsoDateString | undefined, appointments: Array<{ __typename?: 'JobAppointments', description?: string | undefined, jobAppointmentGuid: string, appointmentWindowEnd: IsoDateString, appointmentWindowStart: IsoDateString, appointmentType: AppointmentType, appointmentReferenceNumber: string, sendConfirmationEnabled: boolean, notificationType: AppointmentNotificationType, sendConfirmationTo?: string | undefined, sendReminderEnabled: boolean, reminderLastSentAt?: IsoDateString | undefined, assignments: Array<{ __typename?: 'JobAppointmentAssignments', jobAppointmentAssignmentGuid: string, technicianUserGuid: string, assignmentEnd: IsoDateString, assignmentStart: IsoDateString, photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string, resourceUrn: string, createdAt: IsoDateString, createdByUserGuid: string, companyGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }>, fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', cdnUrl: string, storageStrategy: FileStorageStrategy, resourceUrn: string, fileGuid: string, fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, createdAt: IsoDateString } }>, assignmentStatus?: { __typename?: 'JobAppointmentAssignmentStatuses', jobAppointmentAssignmentStatusType: JobAppointmentAssignmentStatusTypesEnum } | undefined, technician: { __typename?: 'Users', firstName: string, lastName: string, userGuid: string } }>, photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string, resourceUrn: string, createdAt: IsoDateString, createdByUserGuid: string, companyGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }>, fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', cdnUrl: string, storageStrategy: FileStorageStrategy, resourceUrn: string, fileGuid: string, fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, createdAt: IsoDateString } }>, cancellationStatus?: { __typename?: 'JobAppointmentCancellationStatuses', canceled: boolean } | undefined, jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, displayId: number, displayIdV2: string, totalUsc: number, invoicePayments: Array<{ __typename?: 'InvoicePayments', paymentRecordGuid: string, appliedAmountUsc: number, paymentRecord: { __typename?: 'PaymentRecords', paymentMethod: PaymentMethod, amountUsd: number } }> } }>, invoicesQueryables: Array<{ __typename?: 'InvoicesQueryable', invoiceGuid: string, displayId: number, totalAmountUsd: number }> }>, photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string, resourceUrn: string, createdAt: IsoDateString, createdByUserGuid: string, companyGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }>, fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', cdnUrl: string, storageStrategy: FileStorageStrategy, resourceUrn: string, fileGuid: string, fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, createdAt: IsoDateString } }>, jobType: { __typename?: 'JobTypes', jobClass: JobClassesEnum, name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line2?: string | undefined, line1: string, city: string, stateAbbreviation: string, zipCode: string } }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string, color: string }, tags: Array<{ __typename?: 'JobTags', tagGuid: string, addedByUserGuid?: string | undefined, tag: { __typename?: 'Tags', name: string, color: string } }> }>, fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', cdnUrl: string, storageStrategy: FileStorageStrategy, resourceUrn: string, fileGuid: string, fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, createdAt: IsoDateString } }>, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, locationGuid: string, status: MaintenancePlanStatus, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, yearlyPriceUsc: number, credits: CreditRecordArray, discounts: MaintenancePlanDiscountArray, coveredInstalledEquipmentGuids: GuidArray, activatedAt?: IsoDateString | undefined, scheduledActivationAt?: IsoDateString | undefined, billingStartAt?: IsoDateString | undefined, terminatesAt?: IsoDateString | undefined, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined, maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }>, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string } } }>, accountManager?: { __typename?: 'Users', firstName: string, lastName: string } | undefined, wisetackLoanRecords: Array<{ __typename?: 'WisetackLoanRecords', wisetackLoanRecordGuid: string, accountGuid: string, companyGuid: string, invoiceGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackMerchantGuid: string, wisetackTransactionGuid: string, requestedLoanAmountUsc: number, approvedLoanAmountUsc?: number | undefined, settledLoanAmountUsc?: number | undefined, processingFeeUsc?: number | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, expiresAt?: IsoDateString | undefined, loanApplicationLink: string, wisetackLoanStatuses: Array<{ __typename?: 'WisetackLoanStatuses', loanStatus: WisetackLoanStatusTypesEnum, loanStatusDetail?: string | undefined, occurredAt: IsoDateString, createdAt?: IsoDateString | undefined }>, contact: { __typename?: 'Contacts', fullName: string } }>, wisetackPrequalRecords: Array<{ __typename?: 'WisetackPrequalRecords', wisetackPrequalRecordGuid: string, accountGuid: string, companyGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackPrequalGuid: string, wisetackMerchantGuid: string, prequalifiedAmountUsc?: number | undefined, maxQualifiedAmountUsc?: number | undefined, aprRange?: string | undefined, status: WisetackPrequalStatusTypesEnum, expirationDate?: IsoDateString | undefined, prequalifiedAt?: IsoDateString | undefined, declinedAt?: IsoDateString | undefined, expiredAt?: IsoDateString | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, prequalLink: string }>, paymentRecords: Array<{ __typename?: 'PaymentRecords', externalPaymentId?: string | undefined, amountUsd: number, paymentMethod: PaymentMethod, paymentRecordGuid: string, occurredAt: IsoDateString, paymentReferenceNumber: string, paymentStatuses: Array<{ __typename?: 'PaymentStatuses', paymentStatus: PaymentStatusTypesEnum }>, paymentLink?: { __typename?: 'PaymentLinks', wisetackLoanRecordGuid?: string | undefined } | undefined, invoicePayments: Array<{ __typename?: 'InvoicePayments', invoiceGuid: string, appliedAmountUsc: number, invoice: { __typename?: 'Invoices', displayIdV2: string } }> }>, mailingAddress?: { __typename?: 'Addresses', city: string, line1: string, line2?: string | undefined, zipCode: string, stateAbbreviation: string } | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', accountContactGuid: string, archived: boolean, primary: boolean, companyGuid: string, accountGuid: string, contact: { __typename?: 'Contacts', contactGuid: string, companyGuid: string, firstName: string, lastName: string, salutation?: string | undefined, title?: string | undefined, notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string, emailAddressGuid: string, companyGuid: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, additionalEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string, emailAddressGuid: string, companyGuid: string } | undefined, additionalPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined } }>, aggregatableInvoices?: { __typename?: 'AggregatableInvoices', status: InvoiceV2Status, dueUsc?: number | undefined, dueAt?: IsoDateString | undefined } | undefined } | undefined };

export type SetAccountArchivedMutationVariables = Exact<{
  accountGuid: Scalars['uuid'];
  archived: Scalars['Boolean'];
}>;


export type SetAccountArchivedMutation = { __typename?: 'mutation_root', updateAccountsByPk?: { __typename: 'Accounts' } | undefined };

export type AccountDetailsPageLinkedPhoneCallsSubscriptionSubscriptionVariables = Exact<{
  accountGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
}>;


export type AccountDetailsPageLinkedPhoneCallsSubscriptionSubscription = { __typename?: 'subscription_root', accounts: Array<{ __typename?: 'Accounts', integratedPhoneCalls: Array<{ __typename?: 'IntegratedPhoneCalls', integratedPhoneCallGuid: string, startedAt: IsoDateString, endedAt?: IsoDateString | undefined, contact?: { __typename?: 'Contacts', fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined } | undefined, user?: { __typename?: 'Users', fullName: string } | undefined, integratedPhoneMissedCalls: Array<{ __typename?: 'IntegratedPhoneMissedCalls', integratedPhoneVoicemails: Array<{ __typename?: 'IntegratedPhoneVoicemails', recordingSummary?: string | undefined, recordingTranscript?: string | undefined, recordingUrl: string }> }>, integratedPhoneCallRecording?: { __typename?: 'IntegratedPhoneCallRecording', recordingSummary?: string | undefined, recordingTranscript?: string | undefined, recordingUrl: string } | undefined, integratedPhoneCallJobs: Array<{ __typename?: 'IntegratedPhoneCallJobs', job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', locationGuid: string, displayName?: string | undefined, locationDescription?: string | undefined, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, zipCode: string, stateAbbreviation: string } } } }> }> }> };

export type InstalledEquipmentFragment = { __typename?: 'InstalledEquipment', installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, installationParty?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, description?: string | undefined, manufacturer?: string | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined, manufacturingDate?: LocalDateString | undefined, manufacturerWarrantyEndDate?: LocalDateString | undefined, manufacturerWarrantyStartDate?: LocalDateString | undefined, manufacturerWarrantyTerms?: string | undefined, operationalStatus: string, equipmentCondition?: string | undefined, laborWarrantyStartDate?: LocalDateString | undefined, laborWarrantyEndDate?: LocalDateString | undefined, laborWarrantyTerms?: string | undefined, equipmentDimensions?: string | undefined, locationGuid: string, sourceType: InstalledEquipmentSourceType };

export type AccountsDetailsV2QueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AccountsDetailsV2Query = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', accountGuid: string, companyGuid: string, accountType: AccountType, accountDisplayName: string, doNotSyncToAccountingServiceReason?: string | undefined, accountManagerUserGuid?: string | undefined, archived: boolean, accountReferenceNumber: string, accountCreatedAt: IsoDateString, accountLeadSource: Array<{ __typename?: 'CompanyLeadSourceLinks', companyLeadSourceGuid: string, referringContactGuid?: string | undefined, attributionDescription?: string | undefined, referringContact?: { __typename?: 'Contacts', firstName: string, lastName: string } | undefined, companyLeadSource: { __typename?: 'CompanyLeadSources', canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined } }>, tags: Array<{ __typename?: 'AccountTags', tagGuid: string, tag: { __typename?: 'Tags', name: string, color: string } }>, photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string, resourceUrn: string, createdAt: IsoDateString, createdByUserGuid: string, companyGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }>, accountLocations: Array<{ __typename?: 'AccountLocations', accountGuid: string, companyGuid: string, isArchived: boolean, photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string, resourceUrn: string, createdAt: IsoDateString, createdByUserGuid: string, companyGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }>, fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', cdnUrl: string, storageStrategy: FileStorageStrategy, resourceUrn: string, fileGuid: string, fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, createdAt: IsoDateString } }>, location: { __typename?: 'Locations', locationGuid: string, companyGuid: string, displayName?: string | undefined, locationDescription?: string | undefined, estimatedBuildDate?: LocalDateString | undefined, estimatedSquareFootage?: number | undefined, propertyType: string, municipality?: string | undefined, installedHvacSystems: Array<{ __typename?: 'InstalledHvacSystems', installedHvacSystemGuid: string, filterSize?: string | undefined, friendlyName?: string | undefined, notes?: string | undefined, zoningInfo: object, installedEquipment: Array<{ __typename?: 'InstalledEquipment', installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, installationParty?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, description?: string | undefined, manufacturer?: string | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined, manufacturingDate?: LocalDateString | undefined, manufacturerWarrantyEndDate?: LocalDateString | undefined, manufacturerWarrantyStartDate?: LocalDateString | undefined, manufacturerWarrantyTerms?: string | undefined, operationalStatus: string, equipmentCondition?: string | undefined, laborWarrantyStartDate?: LocalDateString | undefined, laborWarrantyEndDate?: LocalDateString | undefined, laborWarrantyTerms?: string | undefined, equipmentDimensions?: string | undefined, locationGuid: string, sourceType: InstalledEquipmentSourceType }> }>, installedEquipment: Array<{ __typename?: 'InstalledEquipment', installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, installationParty?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, description?: string | undefined, manufacturer?: string | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined, manufacturingDate?: LocalDateString | undefined, manufacturerWarrantyEndDate?: LocalDateString | undefined, manufacturerWarrantyStartDate?: LocalDateString | undefined, manufacturerWarrantyTerms?: string | undefined, operationalStatus: string, equipmentCondition?: string | undefined, laborWarrantyStartDate?: LocalDateString | undefined, laborWarrantyEndDate?: LocalDateString | undefined, laborWarrantyTerms?: string | undefined, equipmentDimensions?: string | undefined, locationGuid: string, sourceType: InstalledEquipmentSourceType }>, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string }>, address: { __typename?: 'Addresses', addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string, city: string } } }>, jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, createdAt: IsoDateString, workCompletedAt?: IsoDateString | undefined, appointments: Array<{ __typename?: 'JobAppointments', description?: string | undefined, jobAppointmentGuid: string, appointmentWindowEnd: IsoDateString, appointmentWindowStart: IsoDateString, appointmentType: AppointmentType, appointmentReferenceNumber: string, sendConfirmationEnabled: boolean, notificationType: AppointmentNotificationType, sendConfirmationTo?: string | undefined, sendReminderEnabled: boolean, reminderLastSentAt?: IsoDateString | undefined, assignments: Array<{ __typename?: 'JobAppointmentAssignments', jobAppointmentAssignmentGuid: string, technicianUserGuid: string, assignmentEnd: IsoDateString, assignmentStart: IsoDateString, photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string, resourceUrn: string, createdAt: IsoDateString, createdByUserGuid: string, companyGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }>, fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', cdnUrl: string, storageStrategy: FileStorageStrategy, resourceUrn: string, fileGuid: string, fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, createdAt: IsoDateString } }>, assignmentStatus?: { __typename?: 'JobAppointmentAssignmentStatuses', jobAppointmentAssignmentStatusType: JobAppointmentAssignmentStatusTypesEnum } | undefined, technician: { __typename?: 'Users', firstName: string, lastName: string, userGuid: string } }>, photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string, resourceUrn: string, createdAt: IsoDateString, createdByUserGuid: string, companyGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }>, fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', cdnUrl: string, storageStrategy: FileStorageStrategy, resourceUrn: string, fileGuid: string, fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, createdAt: IsoDateString } }>, cancellationStatus?: { __typename?: 'JobAppointmentCancellationStatuses', canceled: boolean } | undefined }>, photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string, resourceUrn: string, createdAt: IsoDateString, createdByUserGuid: string, companyGuid: string, noteLinks: Array<{ __typename?: 'NoteLinks', note: { __typename?: 'Notes', value: string } }> } }>, fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', cdnUrl: string, storageStrategy: FileStorageStrategy, resourceUrn: string, fileGuid: string, fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, createdAt: IsoDateString } }>, jobType: { __typename?: 'JobTypes', jobClass: JobClassesEnum, name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line2?: string | undefined, line1: string, city: string, stateAbbreviation: string, zipCode: string } }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string, color: string }, tags: Array<{ __typename?: 'JobTags', tagGuid: string, addedByUserGuid?: string | undefined, tag: { __typename?: 'Tags', name: string, color: string } }> }>, fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', cdnUrl: string, storageStrategy: FileStorageStrategy, resourceUrn: string, fileGuid: string, fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, createdAt: IsoDateString } }>, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, locationGuid: string, status: MaintenancePlanStatus, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, yearlyPriceUsc: number, credits: CreditRecordArray, discounts: MaintenancePlanDiscountArray, coveredInstalledEquipmentGuids: GuidArray, activatedAt?: IsoDateString | undefined, scheduledActivationAt?: IsoDateString | undefined, billingStartAt?: IsoDateString | undefined, terminatesAt?: IsoDateString | undefined, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined, maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }>, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string } } }>, accountManager?: { __typename?: 'Users', firstName: string, lastName: string } | undefined, wisetackLoanRecords: Array<{ __typename?: 'WisetackLoanRecords', wisetackLoanRecordGuid: string, accountGuid: string, companyGuid: string, invoiceGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackMerchantGuid: string, wisetackTransactionGuid: string, requestedLoanAmountUsc: number, approvedLoanAmountUsc?: number | undefined, settledLoanAmountUsc?: number | undefined, processingFeeUsc?: number | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, expiresAt?: IsoDateString | undefined, loanApplicationLink: string, wisetackLoanStatuses: Array<{ __typename?: 'WisetackLoanStatuses', loanStatus: WisetackLoanStatusTypesEnum, loanStatusDetail?: string | undefined, occurredAt: IsoDateString, createdAt?: IsoDateString | undefined }>, contact: { __typename?: 'Contacts', fullName: string } }>, wisetackPrequalRecords: Array<{ __typename?: 'WisetackPrequalRecords', wisetackPrequalRecordGuid: string, accountGuid: string, companyGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackPrequalGuid: string, wisetackMerchantGuid: string, prequalifiedAmountUsc?: number | undefined, maxQualifiedAmountUsc?: number | undefined, aprRange?: string | undefined, status: WisetackPrequalStatusTypesEnum, expirationDate?: IsoDateString | undefined, prequalifiedAt?: IsoDateString | undefined, declinedAt?: IsoDateString | undefined, expiredAt?: IsoDateString | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, prequalLink: string }>, paymentRecords: Array<{ __typename?: 'PaymentRecords', externalPaymentId?: string | undefined, amountUsd: number, paymentMethod: PaymentMethod, paymentRecordGuid: string, occurredAt: IsoDateString, paymentReferenceNumber: string, paymentStatuses: Array<{ __typename?: 'PaymentStatuses', paymentStatus: PaymentStatusTypesEnum }>, paymentLink?: { __typename?: 'PaymentLinks', wisetackLoanRecordGuid?: string | undefined } | undefined }>, mailingAddress?: { __typename?: 'Addresses', city: string, line1: string, line2?: string | undefined, zipCode: string, stateAbbreviation: string } | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', accountContactGuid: string, archived: boolean, primary: boolean, companyGuid: string, accountGuid: string, contact: { __typename?: 'Contacts', contactGuid: string, companyGuid: string, firstName: string, lastName: string, salutation?: string | undefined, title?: string | undefined, notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string, emailAddressGuid: string, companyGuid: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, additionalEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string, emailAddressGuid: string, companyGuid: string } | undefined, additionalPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined } }> } | undefined };

export type AccountMetadataQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AccountMetadataQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', accountGuid: string, companyGuid: string, accountType: AccountType, accountDisplayName: string, doNotSyncToAccountingServiceReason?: string | undefined, accountManagerUserGuid?: string | undefined, archived: boolean, doNotService: boolean, doNotServiceReason?: string | undefined, defaultInvoiceTerm: InvoiceTermV2, accountReferenceNumber: string, customerNumber?: string | undefined, accountCreatedAt: IsoDateString, accountLeadSource: Array<{ __typename?: 'CompanyLeadSourceLinks', companyLeadSourceGuid: string, referringContactGuid?: string | undefined, attributionDescription?: string | undefined, referringContact?: { __typename?: 'Contacts', firstName: string, lastName: string } | undefined, companyLeadSource: { __typename?: 'CompanyLeadSources', canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined } }>, mailingAddress?: { __typename?: 'Addresses', city: string, line1: string, line2?: string | undefined, zipCode: string, stateAbbreviation: string } | undefined, accountManager?: { __typename?: 'Users', firstName: string, lastName: string } | undefined, tags: Array<{ __typename?: 'AccountTags', tagGuid: string, tag: { __typename?: 'Tags', name: string, color: string } }>, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined }> } | undefined };

export type AccountManagerEnabledQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type AccountManagerEnabledQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', accountManagerEnabled: boolean } | undefined };

export type AvailableAccountJobsQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AvailableAccountJobsQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string, jobClass: JobClassesEnum }, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string } } }> } | undefined };

export type AvailableAccountLocationsQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AvailableAccountLocationsQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', accountLocations: Array<{ __typename?: 'AccountLocations', isArchived: boolean, location: { __typename?: 'Locations', locationGuid: string, displayName?: string | undefined, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string } } }> } | undefined };

export type CustomerNumberEnabledQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type CustomerNumberEnabledQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', customerNumberEnabled: boolean } | undefined };

export type AccountContactsQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AccountContactsQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', accountContactsAggregate: { __typename?: 'AccountContactsAggregate', aggregate?: { __typename?: 'AccountContactsAggregateFields', count: number } | undefined }, accountContacts: Array<{ __typename?: 'AccountContacts', accountContactGuid: string, archived: boolean, primary: boolean, companyGuid: string, accountGuid: string, contact: { __typename?: 'Contacts', contactGuid: string, companyGuid: string, firstName: string, lastName: string, salutation?: string | undefined, title?: string | undefined, notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string, emailAddressGuid: string, companyGuid: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, additionalEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string, emailAddressGuid: string, companyGuid: string } | undefined, additionalPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined } }> } | undefined };

export type AccountLocationsEquipmentAndHvacSystemsQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AccountLocationsEquipmentAndHvacSystemsQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', mailingAddressGuid?: string | undefined, accountLocations: Array<{ __typename?: 'AccountLocations', accountGuid: string, companyGuid: string, isArchived: boolean, isBillingAddress?: boolean | undefined, location: { __typename?: 'Locations', locationGuid: string, installedHvacSystems: Array<{ __typename?: 'InstalledHvacSystems', installedHvacSystemGuid: string, filterSize?: string | undefined, friendlyName?: string | undefined, notes?: string | undefined, zoningInfo: object, installedEquipment: Array<{ __typename?: 'InstalledEquipment', installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, installationParty?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, description?: string | undefined, manufacturer?: string | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined, manufacturingDate?: LocalDateString | undefined, manufacturerWarrantyEndDate?: LocalDateString | undefined, manufacturerWarrantyStartDate?: LocalDateString | undefined, manufacturerWarrantyTerms?: string | undefined, operationalStatus: string, equipmentCondition?: string | undefined, laborWarrantyStartDate?: LocalDateString | undefined, laborWarrantyEndDate?: LocalDateString | undefined, laborWarrantyTerms?: string | undefined, equipmentDimensions?: string | undefined, locationGuid: string, sourceType: InstalledEquipmentSourceType }> }>, installedEquipment: Array<{ __typename?: 'InstalledEquipment', installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, installationParty?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, description?: string | undefined, manufacturer?: string | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined, manufacturingDate?: LocalDateString | undefined, manufacturerWarrantyEndDate?: LocalDateString | undefined, manufacturerWarrantyStartDate?: LocalDateString | undefined, manufacturerWarrantyTerms?: string | undefined, operationalStatus: string, equipmentCondition?: string | undefined, laborWarrantyStartDate?: LocalDateString | undefined, laborWarrantyEndDate?: LocalDateString | undefined, laborWarrantyTerms?: string | undefined, equipmentDimensions?: string | undefined, locationGuid: string, sourceType: InstalledEquipmentSourceType }> } }> } | undefined };

export type PaginatedEstimatesCollapsibleQueryVariables = Exact<{
  where: EstimatesBoolExp;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type PaginatedEstimatesCollapsibleQuery = { __typename?: 'query_root', estimatesAggregate: { __typename?: 'EstimatesAggregate', aggregate?: { __typename?: 'EstimatesAggregateFields', count: number } | undefined }, estimates: Array<{ __typename?: 'Estimates', estimateGuid: string, displayId: number, status: EstimateV2Status, closedLostReasonCategory?: string | undefined, closedLostReasonNote?: string | undefined, createdAt: IsoDateString, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string } }, createdByUser: { __typename?: 'Users', fullName: string }, estimateOptions: Array<{ __typename?: 'EstimateOptions', estimateOptionGuid: string, displayName?: string | undefined, seq: number, totalUsc: number, isSelected: boolean }> }> };

export type AccountInvoicesCollapsibleCardsQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AccountInvoicesCollapsibleCardsQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', invoicesAggregate: { __typename?: 'InvoicesAggregate', aggregate?: { __typename?: 'InvoicesAggregateFields', count: number } | undefined }, invoices: Array<{ __typename?: 'Invoices', serviceCompletionDate?: LocalDateString | undefined, displayId: number, displayIdV2: string, invoiceGuid: string, status: InvoiceV2Status, totalUsc: number, invoiceTerm: InvoiceTermV2, issuedAt?: IsoDateString | undefined, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string } | undefined, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', displayId: number, jobType: { __typename?: 'JobTypes', name: string } } } | undefined, invoicePayments: Array<{ __typename?: 'InvoicePayments', appliedAmountUsc: number, paymentRecord: { __typename?: 'PaymentRecords', paymentMethod: PaymentMethod, paymentRecordGuid: string, amountUsd: number } }>, createdByUser: { __typename?: 'Users', fullName: string }, taxConfiguration?: { __typename?: 'InvoiceCompanyTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined, cartItems: Array<{ __typename?: 'InvoiceCartItems', cartItem: { __typename?: 'CartItems', name: string, unitPriceUsc: number, quantity: number, isDiscountable: boolean, cartItemCode?: string | undefined } }>, discounts: Array<{ __typename?: 'InvoiceDiscounts', discountRate?: number | undefined, discountAmountUsc?: number | undefined, type: DiscountType }> }> } | undefined };

export type AccountJobsCollapsibleV2QueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AccountJobsCollapsibleV2Query = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', jobsAggregate: { __typename?: 'JobsAggregate', aggregate?: { __typename?: 'JobsAggregateFields', count: number } | undefined }, jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, createdAt: IsoDateString, completedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', jobClass: JobClassesEnum, name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string } }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string, color: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string, appointmentType: AppointmentType, appointmentWindowStart: IsoDateString, jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, displayId: number, displayIdV2: string, totalUsc: number, invoicePayments: Array<{ __typename?: 'InvoicePayments', paymentRecordGuid: string, appliedAmountUsc: number, paymentRecord: { __typename?: 'PaymentRecords', paymentMethod: PaymentMethod, amountUsd: number } }> } }> }> }> } | undefined };

export type AccountLocationsQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AccountLocationsQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', mailingAddressGuid?: string | undefined, accountLocationsAggregate: { __typename?: 'AccountLocationsAggregate', aggregate?: { __typename?: 'AccountLocationsAggregateFields', count: number } | undefined }, archivedAccountLocationsAggregate: { __typename?: 'AccountLocationsAggregate', aggregate?: { __typename?: 'AccountLocationsAggregateFields', count: number } | undefined }, accountLocations: Array<{ __typename?: 'AccountLocations', accountGuid: string, companyGuid: string, isArchived: boolean, isBillingAddress?: boolean | undefined, location: { __typename?: 'Locations', locationGuid: string, companyGuid: string, displayName?: string | undefined, locationDescription?: string | undefined, estimatedBuildDate?: LocalDateString | undefined, estimatedSquareFootage?: number | undefined, propertyType: string, municipality?: string | undefined, address: { __typename?: 'Addresses', addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string, city: string } } }> } | undefined };

export type AccountMaintenancePlansCollapsibleQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AccountMaintenancePlansCollapsibleQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', maintenancePlansAggregate: { __typename?: 'MaintenancePlansQueryableAggregate', aggregate?: { __typename?: 'MaintenancePlansQueryableAggregateFields', count: number } | undefined }, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, locationGuid: string, status: MaintenancePlanStatus, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, yearlyPriceUsc: number, credits: CreditRecordArray, discounts: MaintenancePlanDiscountArray, coveredInstalledEquipmentGuids: GuidArray, activatedAt?: IsoDateString | undefined, scheduledActivationAt?: IsoDateString | undefined, billingStartAt?: IsoDateString | undefined, terminatesAt?: IsoDateString | undefined, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined, maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }>, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string } } }> } | undefined };

export type AccountPaymentsCollapsibleV2QueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AccountPaymentsCollapsibleV2Query = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', paymentRecordsAggregate: { __typename?: 'PaymentRecordsAggregate', aggregate?: { __typename?: 'PaymentRecordsAggregateFields', count: number } | undefined }, paymentRecords: Array<{ __typename?: 'PaymentRecords', externalPaymentId?: string | undefined, paymentMethodAdditionalInfo?: string | undefined, amountUsd: number, paymentMethod: PaymentMethod, paymentRecordGuid: string, occurredAt: IsoDateString, paymentReferenceNumber: string, paymentStatuses: Array<{ __typename?: 'PaymentStatuses', paymentStatus: PaymentStatusTypesEnum }>, invoicePayments: Array<{ __typename?: 'InvoicePayments', invoiceGuid: string, appliedAmountUsc: number, invoice: { __typename?: 'Invoices', displayIdV2: string } }>, paymentLink?: { __typename?: 'PaymentLinks', jobGuid?: string | undefined, loanRecord?: { __typename?: 'WisetackLoanRecords', wisetackLoanRecordGuid: string, accountGuid: string, companyGuid: string, invoiceGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackMerchantGuid: string, wisetackTransactionGuid: string, requestedLoanAmountUsc: number, approvedLoanAmountUsc?: number | undefined, settledLoanAmountUsc?: number | undefined, processingFeeUsc?: number | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, expiresAt?: IsoDateString | undefined, loanApplicationLink: string, wisetackLoanStatuses: Array<{ __typename?: 'WisetackLoanStatuses', loanStatus: WisetackLoanStatusTypesEnum, loanStatusDetail?: string | undefined, occurredAt: IsoDateString, createdAt?: IsoDateString | undefined }>, contact: { __typename?: 'Contacts', fullName: string } } | undefined } | undefined }> } | undefined };

export type AccountVisitsCollapsibleQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AccountVisitsCollapsibleQuery = { __typename?: 'query_root', jobAppointmentsAggregate: { __typename?: 'JobAppointmentsAggregate', aggregate?: { __typename?: 'JobAppointmentsAggregateFields', count: number } | undefined }, jobAppointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string, appointmentType: AppointmentType, appointmentWindowStart: IsoDateString, appointmentWindowEnd: IsoDateString, description?: string | undefined, descriptionHtml?: HtmlString | undefined, cancellationStatus?: { __typename?: 'JobAppointmentCancellationStatuses', canceled: boolean, reason?: string | undefined, note?: string | undefined, createdAt: IsoDateString } | undefined, assignments: Array<{ __typename?: 'JobAppointmentAssignments', assignmentStart: IsoDateString, assignmentEnd: IsoDateString, assignmentStatus?: { __typename?: 'JobAppointmentAssignmentStatuses', jobAppointmentAssignmentStatusType: JobAppointmentAssignmentStatusTypesEnum } | undefined, technician: { __typename?: 'Users', fullName: string } }>, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string } } } }> };

export type AccountWisetackFinancingQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AccountWisetackFinancingQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', wisetackLoanRecords: Array<{ __typename?: 'WisetackLoanRecords', wisetackLoanRecordGuid: string, accountGuid: string, companyGuid: string, invoiceGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackMerchantGuid: string, wisetackTransactionGuid: string, requestedLoanAmountUsc: number, approvedLoanAmountUsc?: number | undefined, settledLoanAmountUsc?: number | undefined, processingFeeUsc?: number | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, expiresAt?: IsoDateString | undefined, loanApplicationLink: string, wisetackLoanStatuses: Array<{ __typename?: 'WisetackLoanStatuses', loanStatus: WisetackLoanStatusTypesEnum, loanStatusDetail?: string | undefined, occurredAt: IsoDateString, createdAt?: IsoDateString | undefined }>, contact: { __typename?: 'Contacts', fullName: string } }>, wisetackPrequalRecords: Array<{ __typename?: 'WisetackPrequalRecords', wisetackPrequalRecordGuid: string, accountGuid: string, companyGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackPrequalGuid: string, wisetackMerchantGuid: string, prequalifiedAmountUsc?: number | undefined, maxQualifiedAmountUsc?: number | undefined, aprRange?: string | undefined, status: WisetackPrequalStatusTypesEnum, expirationDate?: IsoDateString | undefined, prequalifiedAt?: IsoDateString | undefined, declinedAt?: IsoDateString | undefined, expiredAt?: IsoDateString | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, prequalLink: string }> } | undefined };

export type AttachmentsTabAccountFilesQueryQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type AttachmentsTabAccountFilesQueryQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', fileLinks: Array<{ __typename?: 'FileLinks', file: { __typename?: 'Files', cdnUrl: string, storageStrategy: FileStorageStrategy, resourceUrn: string, fileGuid: string, fileName: string, metadata: FileMetadata, createdByUserGuid: string, fileSizeBytes?: number | undefined, fileTypeMime: string, createdAt: IsoDateString }, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', addressGuid: string, line1: string } } } | undefined }> } | undefined };

export type AccountExperienceOnlineBookingCompanyConfigFragment = { __typename?: 'OnlineBookingCompanyConfig', limitBookingsToServiceAreaEnabled: boolean, brandingColorHex: string, afterHoursBannerHtml?: HtmlString | undefined, serviceAreaZipCodes: Array<{ __typename?: 'OnlineBookingServiceAreaZipCodes', zipCode: string }> };

export type AccountExperienceOnlineBookingServiceTypeConfigFragment = { __typename?: 'OnlineBookingServiceTypeConfigs', onlineBookingServiceTypeGuid: string, companyGuid: string, serviceType: OnlineBookingServiceType, bookingType: OnlineBookingType, earliestAvailability: OnlineBookingEarliestAvailableTime, latestAvailability: OnlineBookingLatestAvailableTime, legalBlurbHtml?: HtmlString | undefined, bookableJobTypes: Array<{ __typename?: 'OnlineBookingServiceTypeBookableJobTypes', jobType: { __typename?: 'JobTypes', jobTypeGuid: string, name: string, jobClass: JobClassesEnum } }>, instantBookingWeeklyScheduleEntries: Array<{ __typename?: 'InstantBookingWeeklyScheduleEntries', dayOfWeek: DayOfTheWeek, isEnabled: boolean, bookableArrivalWindows: Array<{ __typename?: 'InstantBookingWeeklyScheduleEntryBookableArrivalWindows', arrivalWindow: { __typename?: 'CompanyAppointmentArrivalWindows', companyAppointmentArrivalWindowGuid: string, arrivalWindowStartTime: LocalTimeString, arrivalWindowEndTime: LocalTimeString } }> }> };

export type CompanyAppointmentArrivalWindowFragment = { __typename?: 'CompanyAppointmentArrivalWindows', companyAppointmentArrivalWindowGuid: string, arrivalWindowStartTime: LocalTimeString, arrivalWindowEndTime: LocalTimeString };

export type AccountExperienceOnlineBookingConfigQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type AccountExperienceOnlineBookingConfigQuery = { __typename?: 'query_root', companiesByPk?: { __typename?: 'Companies', tzId: TimeZoneId, billingProfile?: { __typename?: 'BillingProfiles', phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string } } | undefined, onlineBookingCompanyConfig?: { __typename?: 'OnlineBookingCompanyConfig', limitBookingsToServiceAreaEnabled: boolean, brandingColorHex: string, afterHoursBannerHtml?: HtmlString | undefined, serviceAreaZipCodes: Array<{ __typename?: 'OnlineBookingServiceAreaZipCodes', zipCode: string }> } | undefined, onlineBookingServiceTypeConfigs: Array<{ __typename?: 'OnlineBookingServiceTypeConfigs', onlineBookingServiceTypeGuid: string, companyGuid: string, serviceType: OnlineBookingServiceType, bookingType: OnlineBookingType, earliestAvailability: OnlineBookingEarliestAvailableTime, latestAvailability: OnlineBookingLatestAvailableTime, legalBlurbHtml?: HtmlString | undefined, bookableJobTypes: Array<{ __typename?: 'OnlineBookingServiceTypeBookableJobTypes', jobType: { __typename?: 'JobTypes', jobTypeGuid: string, name: string, jobClass: JobClassesEnum } }>, instantBookingWeeklyScheduleEntries: Array<{ __typename?: 'InstantBookingWeeklyScheduleEntries', dayOfWeek: DayOfTheWeek, isEnabled: boolean, bookableArrivalWindows: Array<{ __typename?: 'InstantBookingWeeklyScheduleEntryBookableArrivalWindows', arrivalWindow: { __typename?: 'CompanyAppointmentArrivalWindows', companyAppointmentArrivalWindowGuid: string, arrivalWindowStartTime: LocalTimeString, arrivalWindowEndTime: LocalTimeString } }> }> }>, companyAppointmentArrivalWindows: Array<{ __typename?: 'CompanyAppointmentArrivalWindows', companyAppointmentArrivalWindowGuid: string, arrivalWindowStartTime: LocalTimeString, arrivalWindowEndTime: LocalTimeString }> } | undefined };

export type AccountExperienceOnlineBookingCompanyConfigQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type AccountExperienceOnlineBookingCompanyConfigQuery = { __typename?: 'query_root', companiesByPk?: { __typename?: 'Companies', tzId: TimeZoneId, billingProfile?: { __typename?: 'BillingProfiles', phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string } } | undefined, onlineBookingCompanyConfig?: { __typename?: 'OnlineBookingCompanyConfig', limitBookingsToServiceAreaEnabled: boolean, brandingColorHex: string, afterHoursBannerHtml?: HtmlString | undefined, serviceAreaZipCodes: Array<{ __typename?: 'OnlineBookingServiceAreaZipCodes', zipCode: string }> } | undefined, companyAppointmentArrivalWindows: Array<{ __typename?: 'CompanyAppointmentArrivalWindows', companyAppointmentArrivalWindowGuid: string, arrivalWindowStartTime: LocalTimeString, arrivalWindowEndTime: LocalTimeString }> } | undefined };

export type JobTypeQueryQueryVariables = Exact<{
  jobTypeGuid: Scalars['uuid'];
}>;


export type JobTypeQueryQuery = { __typename?: 'query_root', jobTypesByPk?: { __typename?: 'JobTypes', name: string, jobClass: JobClassesEnum } | undefined };

export type AccountsListPageAccountsFragmentFragment = { __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, customerNumber?: string | undefined, accountType: AccountType, archived: boolean, doNotService: boolean, doNotServiceReason?: string | undefined, lastJobDate?: IsoDateString | undefined, accountGuid: string, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', fullName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', type: PhoneNumberType, phoneNumber: string } | undefined } }>, accountJobCount?: { __typename?: 'AccountJobCounts', jobCount?: number | undefined } | undefined, accountLocations: Array<{ __typename?: 'AccountLocations', locationGuid: string, location: { __typename?: 'Locations', locationGuid: string, locationDescription?: string | undefined, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string }, installedEquipment: Array<{ __typename?: 'InstalledEquipment', modelNumber?: string | undefined, serialNumber?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, manufacturer?: string | undefined, equipmentType: string, installationDate?: LocalDateString | undefined, installedEquipmentGuid: string }> } }>, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', name: string } }>, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }>, aggregatableInvoices?: { __typename?: 'AggregatableInvoices', status: InvoiceV2Status, dueUsc?: number | undefined, dueAt?: IsoDateString | undefined } | undefined };

export type AccountsListPageDataQueryVariables = Exact<{
  where: AccountsBoolExp;
  orderBy: Array<AccountsOrderBy> | AccountsOrderBy;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AccountsListPageDataQuery = { __typename?: 'query_root', accounts: Array<{ __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, customerNumber?: string | undefined, accountType: AccountType, archived: boolean, doNotService: boolean, doNotServiceReason?: string | undefined, lastJobDate?: IsoDateString | undefined, accountGuid: string, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', fullName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', type: PhoneNumberType, phoneNumber: string } | undefined } }>, accountJobCount?: { __typename?: 'AccountJobCounts', jobCount?: number | undefined } | undefined, accountLocations: Array<{ __typename?: 'AccountLocations', locationGuid: string, location: { __typename?: 'Locations', locationGuid: string, locationDescription?: string | undefined, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string }, installedEquipment: Array<{ __typename?: 'InstalledEquipment', modelNumber?: string | undefined, serialNumber?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, manufacturer?: string | undefined, equipmentType: string, installationDate?: LocalDateString | undefined, installedEquipmentGuid: string }> } }>, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', name: string } }>, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }>, aggregatableInvoices?: { __typename?: 'AggregatableInvoices', status: InvoiceV2Status, dueUsc?: number | undefined, dueAt?: IsoDateString | undefined } | undefined }>, accountsAggregate: { __typename?: 'AccountsAggregate', aggregate?: { __typename?: 'AccountsAggregateFields', count: number } | undefined } };

export type AccountsListPageDataByJobCountQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  showArchived: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AccountsListPageDataByJobCountQuery = { __typename?: 'query_root', accounts: Array<{ __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, customerNumber?: string | undefined, accountType: AccountType, archived: boolean, doNotService: boolean, doNotServiceReason?: string | undefined, lastJobDate?: IsoDateString | undefined, accountGuid: string, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', fullName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', type: PhoneNumberType, phoneNumber: string } | undefined } }>, accountJobCount?: { __typename?: 'AccountJobCounts', jobCount?: number | undefined } | undefined, accountLocations: Array<{ __typename?: 'AccountLocations', locationGuid: string, location: { __typename?: 'Locations', locationGuid: string, locationDescription?: string | undefined, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string }, installedEquipment: Array<{ __typename?: 'InstalledEquipment', modelNumber?: string | undefined, serialNumber?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, manufacturer?: string | undefined, equipmentType: string, installationDate?: LocalDateString | undefined, installedEquipmentGuid: string }> } }>, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', name: string } }>, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }>, aggregatableInvoices?: { __typename?: 'AggregatableInvoices', status: InvoiceV2Status, dueUsc?: number | undefined, dueAt?: IsoDateString | undefined } | undefined }>, accountsAggregate: { __typename?: 'AccountsAggregate', aggregate?: { __typename?: 'AccountsAggregateFields', count: number } | undefined } };

export type AccountsListPageDataByRecentlyViewedQueryVariables = Exact<{
  where: AccountsBoolExp;
  companyGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type AccountsListPageDataByRecentlyViewedQuery = { __typename?: 'query_root', accounts: Array<{ __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, customerNumber?: string | undefined, accountType: AccountType, archived: boolean, doNotService: boolean, doNotServiceReason?: string | undefined, lastJobDate?: IsoDateString | undefined, accountGuid: string, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', fullName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', type: PhoneNumberType, phoneNumber: string } | undefined } }>, accountJobCount?: { __typename?: 'AccountJobCounts', jobCount?: number | undefined } | undefined, accountLocations: Array<{ __typename?: 'AccountLocations', locationGuid: string, location: { __typename?: 'Locations', locationGuid: string, locationDescription?: string | undefined, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string }, installedEquipment: Array<{ __typename?: 'InstalledEquipment', modelNumber?: string | undefined, serialNumber?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, manufacturer?: string | undefined, equipmentType: string, installationDate?: LocalDateString | undefined, installedEquipmentGuid: string }> } }>, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', name: string } }>, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }>, aggregatableInvoices?: { __typename?: 'AggregatableInvoices', status: InvoiceV2Status, dueUsc?: number | undefined, dueAt?: IsoDateString | undefined } | undefined }>, accountsAggregate: { __typename?: 'AccountsAggregate', aggregate?: { __typename?: 'AccountsAggregateFields', count: number } | undefined } };

export type AccountsListPageTotalAccountsQueryVariables = Exact<{
  where: AccountsBoolExp;
}>;


export type AccountsListPageTotalAccountsQuery = { __typename?: 'query_root', accountsAggregate: { __typename?: 'AccountsAggregate', aggregate?: { __typename?: 'AccountsAggregateFields', count: number } | undefined } };

export type AccountsListPageCompanyConfigQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type AccountsListPageCompanyConfigQueryQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', customerNumberEnabled: boolean } | undefined };

export type CreateCompanyDrawerLeadSourcesSectionCanonicalLeadSourcesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateCompanyDrawerLeadSourcesSectionCanonicalLeadSourcesQueryQuery = { __typename?: 'query_root', canonicalLeadSources: Array<{ __typename?: 'CanonicalLeadSources', canonicalLeadSourceName: string, attributionLinkingStrategy: AttributionLinkingStrategy, attributionPrompt?: string | undefined }> };

export type UpdateEndOfJobAppointmentWorkflowEnabledMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  enabled: Scalars['Boolean'];
}>;


export type UpdateEndOfJobAppointmentWorkflowEnabledMutation = { __typename?: 'mutation_root', updateCompanyConfigByPk?: { __typename: 'CompanyConfig' } | undefined };

export type UpdateEndOfJobAppointmentWorkflowSettingsMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  enabled: Scalars['Boolean'];
  notificationSettings: CompanyNotificationSettingsInsertInput;
  jobInvoiceRequired: Scalars['Boolean'];
  jobInvoiceRequiredExcludeSalesClass: Scalars['Boolean'];
}>;


export type UpdateEndOfJobAppointmentWorkflowSettingsMutation = { __typename?: 'mutation_root', updateCompanyConfigByPk?: { __typename: 'CompanyConfig' } | undefined, insertCompanyNotificationSettingsOne?: { __typename: 'CompanyNotificationSettings' } | undefined };

export type GetEndOfVisitNotificationSettingsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetEndOfVisitNotificationSettingsQuery = { __typename?: 'query_root', companyNotificationSettingsByPk?: { __typename?: 'CompanyNotificationSettings', endOfVisitSendReviewLinkEnabled?: boolean | undefined, endOfVisitSendReviewLinkFrequency: ReminderFrequency, endOfVisitSendReviewLinkCount?: number | undefined, endOfVisitSendReviewLinkType: ReviewType } | undefined };

export type AssistantsSettingsQueryVariables = Exact<{
  where: AssistantsBoolExp;
}>;


export type AssistantsSettingsQuery = { __typename?: 'query_root', assistants: Array<{ __typename?: 'Assistants', assistantGuid: string, name: string, companyGuid: string, assistantPhoneSettings?: { __typename?: 'AssistantPhoneSettings', firstMessage?: string | undefined, promptHtml?: HtmlString | undefined, endCallMessage?: string | undefined, forwardPhoneNumber?: string | undefined } | undefined, assistantIntegratedPhones: Array<{ __typename?: 'AssistantIntegratedPhones', integratedPhone: { __typename?: 'IntegratedPhones', phoneNumber: string } }> }> };

export type UpsertAssistantsSettingsMutationVariables = Exact<{
  object: AssistantsInsertInput;
  onConflict?: InputMaybe<AssistantsOnConflict>;
}>;


export type UpsertAssistantsSettingsMutation = { __typename?: 'mutation_root', insertAssistantsOne?: { __typename?: 'Assistants', companyGuid: string } | undefined };

export type BillingProfileSettingsPageBillingProfileQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type BillingProfileSettingsPageBillingProfileQueryQuery = { __typename?: 'query_root', billingProfiles: Array<{ __typename?: 'BillingProfiles', businessFullLegalName: string, contractorLicenseNumber?: string | undefined, defaultPricebookTaxRateGuid?: string | undefined, estimateDisclaimer: string, invoiceDisclaimer: string, invoiceMemo?: string | undefined, invoiceTerm?: InvoiceTermsEnum | undefined, logoUrl: string, logoPhotoGuid: string, maintenancePlanTaxRateGuid?: string | undefined, maintenancePlanServiceItemGuid?: string | undefined, maintenancePlanAutoRenewalAllowed: boolean, maintenancePlanManualRenewalAllowed: boolean, tilledMerchantAccountId?: string | undefined, updatedAt?: IsoDateString | undefined, websiteDisplayName?: string | undefined, websiteUrl?: string | undefined, logoPhoto: { __typename?: 'Photos', cdnUrl: string }, businessAddress?: { __typename?: 'Addresses', line1: string, line2?: string | undefined, zipCode: string, city: string, stateAbbreviation: string } | undefined, emailAddress: { __typename?: 'EmailAddresses', emailAddress: string }, phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string } }>, companyConfigByPk?: { __typename?: 'CompanyConfig', blurb?: string | undefined } | undefined };

export type BillingProfileSettingsPageBillingProfileUpsertMutationMutationVariables = Exact<{
  object: BillingProfilesInsertInput;
}>;


export type BillingProfileSettingsPageBillingProfileUpsertMutationMutation = { __typename?: 'mutation_root', insertBillingProfilesOne?: { __typename: 'BillingProfiles' } | undefined };

export type BillingProfileSettingsPagePricebookTaxRatesQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type BillingProfileSettingsPagePricebookTaxRatesQueryQuery = { __typename?: 'query_root', pricebookTaxRates: Array<{ __typename?: 'PricebookTaxRates', name: string, pricebookTaxRateGuid: string }> };

export type BillingProfileSettingsPageCompanyConfigUpsertMutationVariables = Exact<{
  object: CompanyConfigInsertInput;
}>;


export type BillingProfileSettingsPageCompanyConfigUpsertMutation = { __typename?: 'mutation_root', insertCompanyConfigOne?: { __typename: 'CompanyConfig' } | undefined };

export type BookkeeperListPageQueryInvoiceV2QueryVariables = Exact<{
  where?: InputMaybe<InvoicesBoolExp>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy> | InvoicesOrderBy>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type BookkeeperListPageQueryInvoiceV2Query = { __typename?: 'query_root', invoices: Array<{ __typename?: 'Invoices', accountGuid: string, companyGuid: string, createdAt: IsoDateString, createdBy: string, dueAt?: IsoDateString | undefined, invoiceGuid: string, status: InvoiceV2Status, invoiceTerm: InvoiceTermV2, issuedAt?: IsoDateString | undefined, subtotalUsc: number, totalUsc: number, displayId: number, displayIdV2: string, taxRate: number, dynamicPricingType?: DynamicPricingType | undefined, serviceCompletionDate?: LocalDateString | undefined, taxRateName: string, taxRateGuid: string, billingContactGuid: string, updatedAt: IsoDateString, messageHtml?: HtmlString | undefined, doNotSyncToAccountingServiceReason?: string | undefined, estimateLink?: { __typename?: 'EstimateInvoices', estimateGuid: string } | undefined, locationLink?: { __typename?: 'LocationInvoices', locationGuid: string } | undefined, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', workCompletedAt?: IsoDateString | undefined } } | undefined, invoiceReminderData?: { __typename?: 'InvoiceReminderData', remindersSent: number } | undefined, invoiceDiscounts: Array<{ __typename?: 'InvoiceDiscounts', name: string, discountType: DiscountType, discountAmountUsc?: number | undefined, discountRate?: number | undefined, invoiceDiscountGuid: string, descriptionHtml?: HtmlString | undefined }>, invoiceCartItems: Array<{ __typename?: 'InvoiceCartItems', seq: number, cartItem: { __typename?: 'CartItems', cartItemGuid: string, name: string, description?: HtmlString | undefined, quantity: number, unitPriceUsc: number, isTaxable: boolean, isDiscountable: boolean, cartItemType: CartItemType, cartItemCode?: string | undefined } }>, account: { __typename?: 'Accounts', accountDisplayName: string, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } }>, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, status: MaintenancePlanStatus, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', imageUrl: string, primaryColorHex: string } | undefined } | undefined }> }, qboStaleInfo?: { __typename?: 'InvoicesV2QboStale', updatedAt?: IsoDateString | undefined, syncedAt?: IsoDateString | undefined, stale?: boolean | undefined } | undefined, qboSync?: { __typename?: 'InvoicesV2QboStatus', qboId?: string | undefined } | undefined, accountingStaleInfo?: { __typename?: 'InvoicesV2AccountingStale', isStale?: boolean | undefined } | undefined, invoicePayments: Array<{ __typename?: 'InvoicePayments', appliedAmountUsc: number, paymentRecordGuid: string, paymentRecord: { __typename?: 'PaymentRecords', amountUsd: number, paymentMethod: PaymentMethod, occurredAt: IsoDateString, paymentStatuses: Array<{ __typename?: 'PaymentStatuses', paymentStatus: PaymentStatusTypesEnum }>, payoutItem?: { __typename?: 'PayoutItems', itemAmountUsc: number, payout?: { __typename?: 'Payouts', paidAt: IsoDateString, payoutGuid: string, qboSync?: { __typename?: 'PayoutsQboStatus', qboId?: string | undefined } | undefined } | undefined, childPayoutItems: Array<{ __typename?: 'PayoutItems', itemAmountUsc: number }> } | undefined, qboSync?: { __typename?: 'PaymentsQboStatus', qboId?: string | undefined } | undefined } }>, aggregatableInvoice?: { __typename?: 'AggregatableInvoices', dueUsc?: number | undefined, lastPaidAt?: IsoDateString | undefined, paidUsc?: number | undefined } | undefined }>, invoicesAggregate: { __typename?: 'InvoicesAggregate', aggregate?: { __typename?: 'InvoicesAggregateFields', count: number } | undefined } };

export type FetchCompanyBusinessUnitsEnabledQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchCompanyBusinessUnitsEnabledQuery = { __typename?: 'query_root', companyConfig: Array<{ __typename?: 'CompanyConfig', businessUnitsEnabled: boolean, businessUnitsRequired?: boolean | undefined }> };

export type UpsertCompanyBusinessUnitsEnabledMutationVariables = Exact<{
  object: CompanyConfigInsertInput;
}>;


export type UpsertCompanyBusinessUnitsEnabledMutation = { __typename?: 'mutation_root', insertCompanyConfigOne?: { __typename: 'CompanyConfig' } | undefined };

export type UpsertCompanyBusinessUnitsRequiredMutationVariables = Exact<{
  object: CompanyConfigInsertInput;
}>;


export type UpsertCompanyBusinessUnitsRequiredMutation = { __typename?: 'mutation_root', insertCompanyConfigOne?: { __typename: 'CompanyConfig' } | undefined };

export type FetchCompanyBusinessUnitsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchCompanyBusinessUnitsQuery = { __typename?: 'query_root', companyConfig: Array<{ __typename?: 'CompanyConfig', businessUnitsEnabled: boolean, businessUnitsRequired?: boolean | undefined }>, businessUnits: Array<{ __typename?: 'BusinessUnits', businessUnitGuid: string, companyGuid: string, name: string, accountingIntegrationName?: string | undefined }>, currentBusinessUnitTargetMetricsView: Array<{ __typename?: 'CurrentBusinessUnitTargetMetricsView', businessUnitGuid?: string | undefined, gpPerManDayTargetUsc?: number | undefined, gpPerManDayGoalUsc?: number | undefined }> };

export type UpsertBusinessUnitMutationVariables = Exact<{
  object: BusinessUnitsInsertInput;
}>;


export type UpsertBusinessUnitMutation = { __typename?: 'mutation_root', insertBusinessUnitsOne?: { __typename: 'BusinessUnits' } | undefined };

export type CloseBusinessUnitTargetMetricsMutationVariables = Exact<{
  businessUnitGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
  dateEnd: Scalars['date'];
}>;


export type CloseBusinessUnitTargetMetricsMutation = { __typename?: 'mutation_root', updateBusinessUnitTargetMetrics?: { __typename?: 'BusinessUnitTargetMetricsMutationResponse', affectedRows: number } | undefined };

export type InsertBusinessUnitTargetMetricsMutationVariables = Exact<{
  objects: Array<BusinessUnitTargetMetricsInsertInput> | BusinessUnitTargetMetricsInsertInput;
}>;


export type InsertBusinessUnitTargetMetricsMutation = { __typename?: 'mutation_root', insertBusinessUnitTargetMetrics?: { __typename?: 'BusinessUnitTargetMetricsMutationResponse', affectedRows: number } | undefined };

export type GetRecentPhoneCallsSubscriptionVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetRecentPhoneCallsSubscription = { __typename?: 'subscription_root', integratedPhoneCalls: Array<{ __typename?: 'IntegratedPhoneCalls', integratedPhoneCallGuid: string, startedAt: IsoDateString, endedAt?: IsoDateString | undefined, completedAt?: IsoDateString | undefined, answeredAt?: IsoDateString | undefined, accountGuid?: string | undefined, fromPhoneNumber: string, toPhoneNumber: string, direction: string, contact?: { __typename?: 'Contacts', firstNameInitial?: string | undefined, contactGuid: string, fullName: string, firstName: string, lastName: string, accountContacts: Array<{ __typename?: 'AccountContacts', account: { __typename?: 'Accounts', accountDisplayName: string, accountGuid: string } }> } | undefined, integratedPhone: { __typename?: 'IntegratedPhones', phoneNumber: string, companyLeadSource?: { __typename?: 'CompanyLeadSources', companyLeadSourceGuid: string, canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined } | undefined, assistantIntegratedPhone?: { __typename?: 'AssistantIntegratedPhones', assistant: { __typename?: 'Assistants', assistantGuid: string, name: string } } | undefined }, integratedPhoneCallStatuses: Array<{ __typename?: 'IntegratedPhoneCallStatuses', status: IntegratedPhoneCallStatusTypesEnum }>, integratedPhoneMissedCalls: Array<{ __typename?: 'IntegratedPhoneMissedCalls', integratedPhoneMissedCallGuid: string, fallbackStrategyUsed: string, integratedPhoneMissedCallDismissals: Array<{ __typename?: 'IntegratedPhoneMissedCallDismissals', dismissedAt: IsoDateString }>, integratedPhoneVoicemails: Array<{ __typename?: 'IntegratedPhoneVoicemails', recordingTranscript?: string | undefined, recordingUrl: string, recordingDurationSeconds: number, recordingSummary?: string | undefined }> }>, integratedPhoneCallRecording?: { __typename?: 'IntegratedPhoneCallRecording', recordingUrl: string, recordingTranscript?: string | undefined, recordingDurationSeconds: number, recordingSummary?: string | undefined } | undefined, user?: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string } | undefined, integratedPhoneCallJobs: Array<{ __typename?: 'IntegratedPhoneCallJobs', jobGuid: string, job: { __typename?: 'Jobs', displayId: number } }> }> };

export type DismissMissedCallMutationVariables = Exact<{
  obj: IntegratedPhoneMissedCallDismissalsInsertInput;
}>;


export type DismissMissedCallMutation = { __typename?: 'mutation_root', insertIntegratedPhoneMissedCallDismissalsOne?: { __typename: 'IntegratedPhoneMissedCallDismissals' } | undefined };

export type DeleteMissedCallDismissalsMutationVariables = Exact<{
  integratedPhoneMissedCallGuid: Scalars['uuid'];
}>;


export type DeleteMissedCallDismissalsMutation = { __typename?: 'mutation_root', deleteIntegratedPhoneMissedCallDismissals?: { __typename?: 'IntegratedPhoneMissedCallDismissalsMutationResponse', affectedRows: number } | undefined };

export type CompleteCallsMutationVariables = Exact<{
  completedAt: Scalars['timestamptz'];
  completedByUserGuid: Scalars['uuid'];
  integratedPhoneCallGuids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type CompleteCallsMutation = { __typename?: 'mutation_root', updateIntegratedPhoneCalls?: { __typename?: 'IntegratedPhoneCallsMutationResponse', affectedRows: number } | undefined };

export type UncompleteCallMutationVariables = Exact<{
  integratedPhoneCallGuid: Scalars['uuid'];
}>;


export type UncompleteCallMutation = { __typename?: 'mutation_root', updateIntegratedPhoneCalls?: { __typename?: 'IntegratedPhoneCallsMutationResponse', affectedRows: number } | undefined };

export type GetChannelItemsSubscriptionVariables = Exact<{
  channelGuid: Scalars['uuid'];
}>;


export type GetChannelItemsSubscription = { __typename?: 'subscription_root', integratedChannels: Array<{ __typename?: 'IntegratedChannels', externalPhoneNumber: string, contact?: { __typename?: 'Contacts', contactGuid: string, fullName: string, firstName: string, lastName: string, accountContacts: Array<{ __typename?: 'AccountContacts', account: { __typename?: 'Accounts', accountGuid: string, accountDisplayName: string } }> } | undefined, integratedChannelReadableItems: Array<{ __typename?: 'IntegratedChannelReadableItems', integratedChannelItemGuid?: string | undefined }>, allIntegratedChannelReadableItems: Array<{ __typename?: 'IntegratedChannelReadableItems', integratedChannelItemGuid?: string | undefined }>, integratedChannelCompletableItems: Array<{ __typename?: 'IntegratedChannelCompletableItems', integratedChannelItemGuid?: string | undefined }>, allIntegratedChannelCompletableItems: Array<{ __typename?: 'IntegratedChannelCompletableItems', integratedChannelItemGuid?: string | undefined }>, integratedChannelItems: Array<{ __typename?: 'IntegratedChannelItems', integratedChannelItemGuid: string, itemType: string, occurredAt: IsoDateString, integratedPhoneCall?: { __typename?: 'IntegratedPhoneCalls', integratedPhoneCallGuid: string, startedAt: IsoDateString, endedAt?: IsoDateString | undefined, completedAt?: IsoDateString | undefined, answeredAt?: IsoDateString | undefined, accountGuid?: string | undefined, fromPhoneNumber: string, toPhoneNumber: string, direction: string, contact?: { __typename?: 'Contacts', firstNameInitial?: string | undefined, contactGuid: string, fullName: string, firstName: string, lastName: string, accountContacts: Array<{ __typename?: 'AccountContacts', account: { __typename?: 'Accounts', accountDisplayName: string, accountGuid: string } }> } | undefined, integratedPhone: { __typename?: 'IntegratedPhones', phoneNumber: string, companyLeadSource?: { __typename?: 'CompanyLeadSources', companyLeadSourceGuid: string, canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined } | undefined, assistantIntegratedPhone?: { __typename?: 'AssistantIntegratedPhones', assistant: { __typename?: 'Assistants', assistantGuid: string, name: string } } | undefined }, integratedPhoneCallStatuses: Array<{ __typename?: 'IntegratedPhoneCallStatuses', status: IntegratedPhoneCallStatusTypesEnum }>, integratedPhoneMissedCalls: Array<{ __typename?: 'IntegratedPhoneMissedCalls', integratedPhoneMissedCallGuid: string, fallbackStrategyUsed: string, integratedPhoneMissedCallDismissals: Array<{ __typename?: 'IntegratedPhoneMissedCallDismissals', dismissedAt: IsoDateString }>, integratedPhoneVoicemails: Array<{ __typename?: 'IntegratedPhoneVoicemails', recordingTranscript?: string | undefined, recordingUrl: string, recordingDurationSeconds: number, recordingSummary?: string | undefined }> }>, integratedPhoneCallRecording?: { __typename?: 'IntegratedPhoneCallRecording', recordingUrl: string, recordingTranscript?: string | undefined, recordingDurationSeconds: number, recordingSummary?: string | undefined } | undefined, user?: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string } | undefined, integratedPhoneCallJobs: Array<{ __typename?: 'IntegratedPhoneCallJobs', jobGuid: string, job: { __typename?: 'Jobs', displayId: number } }> } | undefined, integratedMessage?: { __typename?: 'IntegratedMessages', integratedMessageGuid: string, direction: IntegratedMessageDirection, fromPhoneNumber: string, toPhoneNumber: string, body?: string | undefined, externalMessageId?: string | undefined, sentByUserGuid?: string | undefined, createdAt: IsoDateString, integratedMessageStatus?: { __typename?: 'IntegratedMessageStatuses', integratedMessageStatusGuid: string, isDraft?: boolean | undefined, sentAt?: IsoDateString | undefined, deliveredAt?: IsoDateString | undefined, receivedAt?: IsoDateString | undefined, failedAt?: IsoDateString | undefined, errorCode?: string | undefined, errorMessage?: string | undefined, dismissedAt?: IsoDateString | undefined, completedAt?: IsoDateString | undefined, completedByUserGuid?: string | undefined } | undefined, user?: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string } | undefined } | undefined }> }> };

export type GetLatestInboxChannelQueryVariables = Exact<{
  where: IntegratedChannelsBoolExp;
  orderBy: Array<IntegratedChannelsOrderBy> | IntegratedChannelsOrderBy;
}>;


export type GetLatestInboxChannelQuery = { __typename?: 'query_root', integratedChannels: Array<{ __typename?: 'IntegratedChannels', integratedChannelGuid: string }> };

export type GetInboxChannelPreviewsSubscriptionVariables = Exact<{
  where: IntegratedChannelsBoolExp;
  orderBy: Array<IntegratedChannelsOrderBy> | IntegratedChannelsOrderBy;
}>;


export type GetInboxChannelPreviewsSubscription = { __typename?: 'subscription_root', integratedChannels: Array<{ __typename?: 'IntegratedChannels', integratedChannelGuid: string, externalPhoneNumber: string, contact?: { __typename?: 'Contacts', contactGuid: string, fullName: string, firstName: string, lastName: string } | undefined, integratedChannelItems: Array<{ __typename?: 'IntegratedChannelItems', integratedChannelItemGuid: string, itemType: string, occurredAt: IsoDateString, integratedMessage?: { __typename?: 'IntegratedMessages', integratedMessageGuid: string, body?: string | undefined, direction: IntegratedMessageDirection, integratedMessageStatus?: { __typename?: 'IntegratedMessageStatuses', isDraft?: boolean | undefined, sentAt?: IsoDateString | undefined, deliveredAt?: IsoDateString | undefined, receivedAt?: IsoDateString | undefined, failedAt?: IsoDateString | undefined, dismissedAt?: IsoDateString | undefined } | undefined } | undefined, integratedPhoneCall?: { __typename?: 'IntegratedPhoneCalls', integratedPhoneCallGuid: string, direction: string, startedAt: IsoDateString, endedAt?: IsoDateString | undefined, answeredAt?: IsoDateString | undefined, integratedPhoneCallStatuses: Array<{ __typename?: 'IntegratedPhoneCallStatuses', status: IntegratedPhoneCallStatusTypesEnum }>, integratedPhoneMissedCalls: Array<{ __typename?: 'IntegratedPhoneMissedCalls', integratedPhoneMissedCallGuid: string, integratedPhoneMissedCallDismissals: Array<{ __typename?: 'IntegratedPhoneMissedCallDismissals', dismissedAt: IsoDateString }>, integratedPhoneVoicemails: Array<{ __typename?: 'IntegratedPhoneVoicemails', recordingTranscript?: string | undefined, recordingDurationSeconds: number }> }> } | undefined }>, integratedChannelReadableItems: Array<{ __typename?: 'IntegratedChannelReadableItems', integratedChannelItemGuid?: string | undefined }>, integratedChannelCompletableItems: Array<{ __typename?: 'IntegratedChannelCompletableItems', integratedChannelItemGuid?: string | undefined }>, allIntegratedChannelCompletableItems: Array<{ __typename?: 'IntegratedChannelCompletableItems', integratedChannelItemGuid?: string | undefined, markedCompleted?: boolean | undefined }> }> };

export type GetAllPhoneContactsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetAllPhoneContactsQuery = { __typename?: 'query_root', contacts: Array<{ __typename?: 'Contacts', contactGuid: string, firstName: string, lastName: string, fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', account: { __typename?: 'Accounts', accountGuid: string, accountDisplayName: string } }> }> };

export type CompanyConfigSettingsPageCompanyConfigSettingsQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type CompanyConfigSettingsPageCompanyConfigSettingsQueryQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', confirmationNotificationSuppressedByDefault: boolean, hideArrivalWindowInNotifications: boolean, defaultAccountManagerUserGuid?: string | undefined, hiddenEquipmentTypesJsonArray?: EquipmentTypeArray | undefined, locationMunicipalityFieldEnabled: boolean, visibleInstallProjectTypesJsonArray?: object | undefined, blurb?: string | undefined, maintenancePlansEnabled: boolean, accountManagerEnabled: boolean, customerNumberEnabled: boolean } | undefined, companyUsers: Array<{ __typename?: 'CompanyUsers', userByUserGuid: { __typename?: 'Users', userGuid: string, fullName: string } }> };

export type CompanyConfigSettingsPageCompanyConfigUpsertOneMutationVariables = Exact<{
  object: CompanyConfigInsertInput;
}>;


export type CompanyConfigSettingsPageCompanyConfigUpsertOneMutation = { __typename?: 'mutation_root', insertCompanyConfigOne?: { __typename: 'CompanyConfig' } | undefined };

export type LocationOptionMaintenancePlanQueryVariables = Exact<{
  locationGuid: Scalars['uuid'];
}>;


export type LocationOptionMaintenancePlanQuery = { __typename?: 'query_root', locationsByPk?: { __typename?: 'Locations', maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, status: MaintenancePlanStatus, scheduledActivationAt?: IsoDateString | undefined, activatedAt?: IsoDateString | undefined, yearlyPriceUsc: number, coveredInstalledEquipmentGuids: GuidArray, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', numVisitCreditsPerYear: number, marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined, maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }> }> } | undefined };

export type MostRecentAppointmentQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  locationGuid: Scalars['uuid'];
}>;


export type MostRecentAppointmentQuery = { __typename?: 'query_root', jobAppointments: Array<{ __typename?: 'JobAppointments', appointmentWindowStart: IsoDateString, jobAppointmentGuid: string }> };

export type FetchActivatedMaintenancePlanDataSubscriptionVariables = Exact<{
  maintenancePlanGuid: Scalars['uuid'];
}>;


export type FetchActivatedMaintenancePlanDataSubscription = { __typename?: 'subscription_root', maintenancePlansQueryable: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }>, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', maintenancePlanDefinitionGuid: string, defaultBusinessUnitGuid?: string | undefined, createdAt: IsoDateString, numDaysUntilVisitCreditExpiration: number, numVisitCreditsPerYear: number, yearlyStaticPriceUsc?: number | undefined, visitConfigs: MaintenancePlanVisitConfigArray, companyGuid: string, allowedPaymentIntervals: Array<{ __typename?: 'MaintenancePlanDefinitionAllowedPaymentIntervals', maintenancePlanDefinitionAllowedPaymentIntervalGuid: string, paymentInterval: MaintenancePlanPaymentInterval, isDefault: boolean }>, benefits: Array<{ __typename?: 'MaintenancePlanDefinitionBenefits', maintenancePlanDefinitionBenefitGuid: string, maintenancePlanDefinitionGuid: string, description: string, name: string }>, discounts: Array<{ __typename?: 'MaintenancePlanDefinitionDiscounts', discountJobClass: JobClassesEnum, discountRate: number, maintenancePlanDefinitionDiscountGuid: string }>, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', imageUrl: string, primaryColorHex: string } | undefined, marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', isAvailableForSale: boolean, maintenancePlanDefinitionGuid: string, maintenancePlanDefinitionMarketingInfoGuid: string, name: string, shortDescription: string, termsAndConditions: string } | undefined } | undefined }> };

export type MaintenancePlanWizardAccountQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type MaintenancePlanWizardAccountQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', accountContacts: Array<{ __typename?: 'AccountContacts', accountContactGuid: string, archived: boolean, primary: boolean, companyGuid: string, accountGuid: string, contact: { __typename?: 'Contacts', contactGuid: string, companyGuid: string, firstName: string, lastName: string, salutation?: string | undefined, title?: string | undefined, notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string, emailAddressGuid: string, companyGuid: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined, additionalEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string, emailAddressGuid: string, companyGuid: string } | undefined, additionalPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, phoneNumberGuid: string, companyGuid: string, type: PhoneNumberType, unsubscribed: boolean } | undefined } }> } | undefined };

export type MaintenancePlanWizardSelectedAccountLocationQueryVariables = Exact<{
  locationGuid: Scalars['uuid'];
}>;


export type MaintenancePlanWizardSelectedAccountLocationQuery = { __typename?: 'query_root', accountLocations: Array<{ __typename?: 'AccountLocations', accountGuid: string, companyGuid: string, isArchived: boolean, isBillingAddress?: boolean | undefined, location: { __typename?: 'Locations', locationGuid: string, companyGuid: string, displayName?: string | undefined, estimatedBuildDate?: LocalDateString | undefined, estimatedSquareFootage?: number | undefined, propertyType: string, municipality?: string | undefined, address: { __typename?: 'Addresses', addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string, city: string }, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, status: MaintenancePlanStatus, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', imageUrl: string, primaryColorHex: string } | undefined } | undefined }>, installedEquipment: Array<{ __typename?: 'InstalledEquipment', installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, installationParty?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, description?: string | undefined, manufacturer?: string | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined, manufacturingDate?: LocalDateString | undefined, manufacturerWarrantyEndDate?: LocalDateString | undefined, manufacturerWarrantyStartDate?: LocalDateString | undefined, manufacturerWarrantyTerms?: string | undefined, operationalStatus: string, equipmentCondition?: string | undefined, laborWarrantyStartDate?: LocalDateString | undefined, laborWarrantyEndDate?: LocalDateString | undefined, laborWarrantyTerms?: string | undefined, equipmentDimensions?: string | undefined, locationGuid: string, sourceType: InstalledEquipmentSourceType }>, jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, createdAt: IsoDateString, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string, zipCode: string } } }> } }> };

export type MaintenancePlanWizardPaginatedAccountLocationsQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  where: AccountLocationsBoolExp;
}>;


export type MaintenancePlanWizardPaginatedAccountLocationsQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', accountLocationsAggregate: { __typename?: 'AccountLocationsAggregate', aggregate?: { __typename?: 'AccountLocationsAggregateFields', count: number } | undefined }, accountLocations: Array<{ __typename?: 'AccountLocations', accountGuid: string, companyGuid: string, isArchived: boolean, isBillingAddress?: boolean | undefined, location: { __typename?: 'Locations', locationGuid: string, companyGuid: string, displayName?: string | undefined, estimatedBuildDate?: LocalDateString | undefined, estimatedSquareFootage?: number | undefined, propertyType: string, municipality?: string | undefined, address: { __typename?: 'Addresses', addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string, city: string }, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, status: MaintenancePlanStatus, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', imageUrl: string, primaryColorHex: string } | undefined } | undefined }>, installedEquipment: Array<{ __typename?: 'InstalledEquipment', installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, installationParty?: string | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, description?: string | undefined, manufacturer?: string | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined, manufacturingDate?: LocalDateString | undefined, manufacturerWarrantyEndDate?: LocalDateString | undefined, manufacturerWarrantyStartDate?: LocalDateString | undefined, manufacturerWarrantyTerms?: string | undefined, operationalStatus: string, equipmentCondition?: string | undefined, laborWarrantyStartDate?: LocalDateString | undefined, laborWarrantyEndDate?: LocalDateString | undefined, laborWarrantyTerms?: string | undefined, equipmentDimensions?: string | undefined, locationGuid: string, sourceType: InstalledEquipmentSourceType }> } }> } | undefined };

export type MaintenancePlanLimitedAccountJobsQueryVariables = Exact<{
  where: JobsBoolExp;
}>;


export type MaintenancePlanLimitedAccountJobsQuery = { __typename?: 'query_root', jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined }, appointments: Array<{ __typename?: 'JobAppointments', appointmentGuid: string }> }> };

export type MaintenancePlanWizardSelectedAccountQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type MaintenancePlanWizardSelectedAccountQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', accountDisplayName: string, createdAt: IsoDateString, jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, jobLifecycleStatusUpdatedAt: IsoDateString, jobCreatedAt: IsoDateString, jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, status: InvoiceV2Status, totalUsc: number } }>, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', assignments: Array<{ __typename?: 'JobAppointmentAssignments', technician: { __typename?: 'Users', firstName: string, lastName: string } }> }>, location: { __typename?: 'Locations', displayName?: string | undefined, address: { __typename?: 'Addresses', addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string, city: string } }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } }>, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', tagGuid: string, name: string, color: string } }> } | undefined };

export type FetchCompanyUsersQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchCompanyUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', userGuid: string, fullName: string, firstName: string, lastName: string, userPrimaryHueHex?: string | undefined, userRoles: Array<{ __typename?: 'UserRoles', roleById: { __typename?: 'CompanyRoles', role: RoleId, name: string } }>, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined }> };

export type HcpCompanyMigrationProfileDataQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type HcpCompanyMigrationProfileDataQueryQuery = { __typename?: 'query_root', jobTypes: Array<{ __typename?: 'JobTypes', jobClass: JobClassesEnum, jobTypeGuid: string, name: string, jobLifecycleGuid: string }>, users: Array<{ __typename?: 'Users', userGuid: string, firstName: string, lastName: string, emailAddress: string }>, companyLeadSources: Array<{ __typename?: 'CompanyLeadSources', companyLeadSourceGuid: string, canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined }>, pricebookTaxRates: Array<{ __typename?: 'PricebookTaxRates', pricebookTaxRateGuid: string, rate: number, name: string }>, jobLifecycleStatuses: Array<{ __typename?: 'JobLifecycleStatuses', jobLifecycleStatusGuid: string, jobLifecycleGuid: string, name: string, jobLifecycle: { __typename?: 'JobLifecycles', name: string } }> };

export type CompanyDripMarketingConfigQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type CompanyDripMarketingConfigQuery = { __typename?: 'query_root', companyDripMarketingConfigByPk?: { __typename?: 'CompanyDripMarketingConfig', yelpReviewUrl?: string | undefined, googleReviewUrl?: string | undefined, facebookReviewUrl?: string | undefined, jobCompletedEnabled: boolean, jobCompletedDelayMs: number, jobCompletedCustomEmailContent?: string | undefined, maintenanceVisitRemindersEnabled: boolean, maintenanceVisitRemindersLimit: number, maintenanceVisitRemindersSchedule: number, maintenanceVisitRemindersEmailBodyTemplate?: string | undefined, maintenanceVisitRemindersEmailSubjectTemplate?: string | undefined, maintenanceVisitRemindersSmsTemplate?: string | undefined, maintenanceRemindersEnabled: boolean, maintenanceRemindersDelayMonths: number, maintenanceRemindersCustomEmailContent?: string | undefined } | undefined };

export type FetchVisitRemindersQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  startTime: Scalars['date'];
  endTime: Scalars['date'];
}>;


export type FetchVisitRemindersQuery = { __typename?: 'query_root', maintenancePlanNextVisits: Array<{ __typename?: 'MaintenancePlanNextVisits', maintenancePlanVisitGuid: string }> };

export type BillingProfileForBasicBrandedEmailPreviewQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type BillingProfileForBasicBrandedEmailPreviewQuery = { __typename?: 'query_root', billingProfilesByPk?: { __typename?: 'BillingProfiles', logoUrl: string, websiteUrl?: string | undefined, websiteDisplayName?: string | undefined, phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string }, emailAddress: { __typename?: 'EmailAddresses', emailAddress: string } } | undefined, companiesByPk?: { __typename?: 'Companies', name: string } | undefined };

export type CompanyEstimateSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyEstimateSettingsQuery = { __typename?: 'query_root', companyConfig: Array<{ __typename?: 'CompanyConfig', estimateDisplayTechnicianName: boolean, estimateLineItemsVisibility: CompanyLineItemVisibility, estimateRehashEnabled: boolean, estimateAutoExpirationEnabled: boolean, estimateAutoExpirationDays: number }> };

export type UpdateCompanyEstimateSettingsMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  set: CompanyConfigSetInput;
}>;


export type UpdateCompanyEstimateSettingsMutation = { __typename?: 'mutation_root', updateCompanyConfigByPk?: { __typename: 'CompanyConfig' } | undefined };

export type MarkEstimateTemplateDeletedMutationVariables = Exact<{
  estimateTemplateGuid: Scalars['uuid'];
}>;


export type MarkEstimateTemplateDeletedMutation = { __typename?: 'mutation_root', updateEstimateTemplatesByPk?: { __typename?: 'EstimateTemplates', isDeleted: boolean } | undefined };

export type GetEstimateTemplateQueryVariables = Exact<{
  estimateTemplateGuid: Scalars['uuid'];
}>;


export type GetEstimateTemplateQuery = { __typename?: 'query_root', estimateTemplatesByPk?: { __typename?: 'EstimateTemplates', estimateTemplateGuid: string, templateName: string, customMessageHtml?: HtmlString | undefined, messagePreset: EstimateTemplateMessagePreset, createdAt: IsoDateString, updatedAt: IsoDateString, companyGuid: string, estimateOptions: Array<{ __typename?: 'EstimateOptions', estimateOptionGuid: string, displayName?: string | undefined, description?: string | undefined, descriptionHtml?: HtmlString | undefined, seq: number, isRecommended: boolean, isSelected: boolean, totalUsc: number, featuredPhotoGuid?: string | undefined, featuredPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined, cartItems: Array<{ __typename?: 'EstimateOptionCartItems', seq: number, cartItem: { __typename?: 'CartItems', cartItemGuid: string, name: string, description?: HtmlString | undefined, quantity: number, unitPriceUsc: number, isTaxable: boolean, isDiscountable: boolean, cartItemType: CartItemType, originalPricebookItemGuid?: string | undefined, photoGuid?: string | undefined, cartItemVariant: CartItemVariant, cartItemCode?: string | undefined, photo?: { __typename?: 'Photos', cdnUrl: string } | undefined } }>, estimateOptionDiscounts: Array<{ __typename?: 'EstimateOptionDiscounts', estimateOptionDiscountGuid: string, name?: string | undefined, descriptionHtml?: HtmlString | undefined, discountType: DiscountType, discountAmountUsc?: number | undefined, discountRate?: number | undefined, seq: number }> }> } | undefined };

export type CreateEstimateTemplateMutationVariables = Exact<{
  input: EstimateTemplatesInsertInput;
}>;


export type CreateEstimateTemplateMutation = { __typename?: 'mutation_root', insertEstimateTemplatesOne?: { __typename?: 'EstimateTemplates', estimateTemplateGuid: string, templateName: string } | undefined };

export type UpdateEstimateTemplateMutationVariables = Exact<{
  estimateTemplateGuid: Scalars['uuid'];
  input: EstimateTemplatesSetInput;
}>;


export type UpdateEstimateTemplateMutation = { __typename?: 'mutation_root', updateEstimateTemplatesByPk?: { __typename?: 'EstimateTemplates', estimateTemplateGuid: string, templateName: string } | undefined };

export type UpsertEstimateTemplateWithOptionsMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  estimateTemplateGuid: Scalars['uuid'];
  input: EstimateTemplatesInsertInput;
  validCartItemGuids: Array<Scalars['uuid']> | Scalars['uuid'];
  estimateOptionDiscountGuids: Array<Scalars['uuid']> | Scalars['uuid'];
  estimateOptionGuids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type UpsertEstimateTemplateWithOptionsMutation = { __typename?: 'mutation_root', insertEstimateTemplatesOne?: { __typename?: 'EstimateTemplates', estimateTemplateGuid: string, templateName: string } | undefined, deleteCartItems?: { __typename: 'CartItemsMutationResponse' } | undefined, deleteEstimateOptionDiscounts?: { __typename: 'EstimateOptionDiscountsMutationResponse' } | undefined, deleteEstimateOptions?: { __typename?: 'EstimateOptionsMutationResponse', affectedRows: number } | undefined };

export type UpdateEstimateMutationVariables = Exact<{
  estimateGuid: Scalars['uuid'];
  estimate: EstimatesSetInput;
  clearSelectedOptionsEstimateGuid: Scalars['uuid'];
}>;


export type UpdateEstimateMutation = { __typename?: 'mutation_root', updateEstimates?: { __typename?: 'EstimatesMutationResponse', affectedRows: number } | undefined, updateEstimateOptionsMany?: Array<{ __typename: 'EstimateOptionsMutationResponse' } | undefined> | undefined };

export type UpsertEstimateMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  estimateGuid: Scalars['uuid'];
  estimate: EstimatesInsertInput;
  validCartItemGuids: Array<Scalars['uuid']> | Scalars['uuid'];
  estimateOptionDiscountGuids: Array<Scalars['uuid']> | Scalars['uuid'];
  estimateOptionGuids: Array<Scalars['uuid']> | Scalars['uuid'];
  estimatePhotoGuids: Array<Scalars['uuid']> | Scalars['uuid'];
  jobPhotoLinks: Array<PhotoLinksInsertInput> | PhotoLinksInsertInput;
}>;


export type UpsertEstimateMutation = { __typename?: 'mutation_root', insertEstimatesOne?: { __typename: 'Estimates' } | undefined, deleteCartItems?: { __typename: 'CartItemsMutationResponse' } | undefined, deleteEstimateOptionDiscounts?: { __typename: 'EstimateOptionDiscountsMutationResponse' } | undefined, deleteEstimateOptions?: { __typename?: 'EstimateOptionsMutationResponse', affectedRows: number } | undefined, deleteEstimatePhotos?: { __typename?: 'EstimatePhotosMutationResponse', affectedRows: number } | undefined, insertPhotoLinks?: { __typename?: 'PhotoLinksMutationResponse', affectedRows: number } | undefined };

export type GetRelevantEstimateDataQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetRelevantEstimateDataQuery = { __typename?: 'query_root', pricebookItems: Array<{ __typename?: 'PricebookItems', pricebookItemGuid: string }>, billingProfilesByPk?: { __typename?: 'BillingProfiles', defaultPricebookTaxRateGuid?: string | undefined, estimateDisclaimer: string, businessFullLegalName: string, contractorLicenseNumber?: string | undefined, invoiceTerm?: InvoiceTermsEnum | undefined, logoUrl: string, logoPhotoGuid: string, logoPhoto: { __typename?: 'Photos', cdnUrl: string } } | undefined, companyConfigByPk?: { __typename?: 'CompanyConfig', blurb?: string | undefined, estimateLineItemsVisibility: CompanyLineItemVisibility, maintenancePlanSavingsEnabled: boolean, hideLineItemPrices: boolean } | undefined, pricebookTaxRates: Array<{ __typename?: 'PricebookTaxRates', name: string, rate: number, pricebookTaxRateGuid: string }>, companiesByPk?: { __typename?: 'Companies', name: string } | undefined };

export type GetRelevantNewEstimateDataQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type GetRelevantNewEstimateDataQuery = { __typename?: 'query_root', jobsByPk?: { __typename?: 'Jobs', accountGuid: string, locationGuid: string, account: { __typename?: 'Accounts', accountType: AccountType }, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', zipCode: string, line1: string, city: string, stateAbbreviation: string }, pricebookTaxRate?: { __typename?: 'PricebookTaxRates', pricebookTaxRateGuid: string, name: string, rate: number } | undefined }, pointOfContact: { __typename?: 'Contacts', fullName: string, firstName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } } | undefined };

export type GetEstimateSubscriptionVariables = Exact<{
  estimateGuid: Scalars['uuid'];
}>;


export type GetEstimateSubscription = { __typename?: 'subscription_root', estimatesByPk?: { __typename?: 'Estimates', createdAt: IsoDateString, displayId: number, estimateGuid: string, jobGuid: string, jobAppointmentGuid?: string | undefined, messageHtml?: HtmlString | undefined, maintenancePlanSavingsEnabled: boolean, hideLineItemPrices: boolean, status: EstimateV2Status, closedLostReasonCategory?: string | undefined, closedLostReasonNote?: string | undefined, acceptedAt?: IsoDateString | undefined, signatureFileUrl?: string | undefined, taxRate: number, taxRateName: string, taxRateGuid: string, dynamicPricingType?: DynamicPricingType | undefined, job: { __typename?: 'Jobs', displayId: number, accountGuid: string, locationGuid: string, createdAt: IsoDateString, account: { __typename?: 'Accounts', createdAt: IsoDateString }, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string, city: string, stateAbbreviation: string, zipCode: string } }, pointOfContact: { __typename?: 'Contacts', fullName: string, firstName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined }, jobType: { __typename?: 'JobTypes', name: string } }, invoiceLink?: { __typename?: 'EstimateInvoices', invoiceGuid: string, invoice: { __typename?: 'Invoices', displayId: number, displayIdV2: string, issuedAt?: IsoDateString | undefined } } | undefined, acceptedOnBehalfByUser?: { __typename?: 'Users', firstName: string, lastName: string } | undefined, estimatePhotos: Array<{ __typename?: 'EstimatePhotos', photoGuid: string, photo: { __typename?: 'Photos', cdnUrl: string } }>, estimateOptions: Array<{ __typename?: 'EstimateOptions', descriptionHtml?: HtmlString | undefined, displayName?: string | undefined, totalUsc: number, featuredPhotoGuid?: string | undefined, seq: number, optionGuid: string, recommended: boolean, selected: boolean, featuredPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined, taxConfiguration?: { __typename?: 'EstimateOptionTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined, estimateOptionDiscounts: Array<{ __typename?: 'EstimateOptionDiscounts', discountAmountUsc?: number | undefined, discountRate?: number | undefined, discountType: DiscountType, descriptionHtml?: HtmlString | undefined, name?: string | undefined, seq: number, discountGuid: string }>, cartItems: Array<{ __typename?: 'EstimateOptionCartItems', seq: number, cartItem: { __typename?: 'CartItems', cartItemGuid: string, description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, originalPricebookItemGuid?: string | undefined, quantity: number, unitPriceUsc: number, cartItemCode?: string | undefined, cartItemVariant: CartItemVariant, itemType: CartItemType, photo?: { __typename?: 'Photos', photoGuid: string, cdnUrl: string } | undefined } }> }>, linkedToJobs: Array<{ __typename?: 'JobsWithLinkedJobLinkedEstimates', linkedJobGuid: string, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, accountGuid: string, locationGuid: string, createdAt: IsoDateString, jobType: { __typename?: 'JobTypes', name: string } } }> } | undefined };

export type DeleteEstimateOptionsMutationVariables = Exact<{
  estimateGuid: Scalars['uuid'];
}>;


export type DeleteEstimateOptionsMutation = { __typename?: 'mutation_root', deleteEstimatesByPk?: { __typename: 'Estimates' } | undefined };

export type GetJobPhotosQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type GetJobPhotosQuery = { __typename?: 'query_root', photoLinks: Array<{ __typename?: 'PhotoLinks', photo: { __typename?: 'Photos', cdnUrl: string, photoGuid: string } }> };

export type GetRelevantEstimateDataForAccountReviewQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetRelevantEstimateDataForAccountReviewQuery = { __typename?: 'query_root', billingProfilesByPk?: { __typename?: 'BillingProfiles', estimateDisclaimer: string, businessFullLegalName: string, contractorLicenseNumber?: string | undefined, logoUrl: string, wisetackMerchantId?: string | undefined, logoPhotoGuid: string, logoPhoto: { __typename?: 'Photos', cdnUrl: string }, phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string } } | undefined, companyConfigByPk?: { __typename?: 'CompanyConfig', blurb?: string | undefined, wisetackEnabled: boolean, estimateLineItemsVisibility: CompanyLineItemVisibility, maintenancePlanSavingsEnabled: boolean, hideLineItemPrices: boolean } | undefined, companiesByPk?: { __typename?: 'Companies', name: string } | undefined };

export type GetEstimateForAccountReviewQueryVariables = Exact<{
  estimateGuid: Scalars['uuid'];
}>;


export type GetEstimateForAccountReviewQuery = { __typename?: 'query_root', estimatesByPk?: { __typename?: 'Estimates', companyGuid: string, displayId: number, estimateGuid: string, messageHtml?: HtmlString | undefined, status: EstimateV2Status, taxRate: number, maintenancePlanSavingsEnabled: boolean, hideLineItemPrices: boolean, dynamicPricingType?: DynamicPricingType | undefined, acceptedAt?: IsoDateString | undefined, job: { __typename?: 'Jobs', jobGuid: string, accountGuid: string, locationGuid: string, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string, city: string, stateAbbreviation: string, zipCode: string } }, pointOfContact: { __typename?: 'Contacts', fullName: string, firstName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } }, createdByUser: { __typename?: 'Users', fullName: string, userPhoneNumbers: Array<{ __typename?: 'UserPhoneNumbers', phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string } }>, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined }, estimatePhotos: Array<{ __typename?: 'EstimatePhotos', photoGuid: string, photo: { __typename?: 'Photos', cdnUrl: string } }>, estimateOptions: Array<{ __typename?: 'EstimateOptions', descriptionHtml?: HtmlString | undefined, displayName?: string | undefined, totalUsc: number, featuredPhotoGuid?: string | undefined, seq: number, optionGuid: string, selected: boolean, recommended: boolean, featuredPhoto?: { __typename?: 'Photos', cdnUrl: string, photoGuid: string } | undefined, taxConfiguration?: { __typename?: 'EstimateOptionTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined, estimateOptionDiscounts: Array<{ __typename?: 'EstimateOptionDiscounts', discountAmountUsc?: number | undefined, discountRate?: number | undefined, discountType: DiscountType, descriptionHtml?: HtmlString | undefined, name?: string | undefined, seq: number, discountGuid: string }>, cartItems: Array<{ __typename?: 'EstimateOptionCartItems', seq: number, cartItem: { __typename?: 'CartItems', description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, quantity: number, unitPriceUsc: number, cartItemCode?: string | undefined, photo?: { __typename?: 'Photos', photoGuid: string, cdnUrl: string } | undefined } }> }> } | undefined };

export type EstimateFlowEstimateWithLinkedJobQueryQueryVariables = Exact<{
  estimateGuid: Scalars['uuid'];
}>;


export type EstimateFlowEstimateWithLinkedJobQueryQuery = { __typename?: 'query_root', estimatesByPk?: { __typename?: 'Estimates', jobGuid: string, job: { __typename?: 'Jobs', accountGuid: string, locationGuid: string, displayId: number, createdAt: IsoDateString, jobType: { __typename?: 'JobTypes', name: string } }, linkedToJobs: Array<{ __typename?: 'JobsWithLinkedJobLinkedEstimates', linkedJobGuid: string, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, accountGuid: string, locationGuid: string, createdAt: IsoDateString, jobType: { __typename?: 'JobTypes', name: string } } }> } | undefined };

export type EstimateDataForDownloadQueryVariables = Exact<{
  estimateGuid: Scalars['uuid'];
}>;


export type EstimateDataForDownloadQuery = { __typename?: 'query_root', estimatesByPk?: { __typename?: 'Estimates', companyGuid: string, displayId: number, jobGuid: string } | undefined };

export type SaveEstimateTemplateMutationVariables = Exact<{
  input: EstimateTemplatesInsertInput;
}>;


export type SaveEstimateTemplateMutation = { __typename?: 'mutation_root', insertEstimateTemplatesOne?: { __typename: 'EstimateTemplates' } | undefined };

export type GetEstimateListQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy: Array<EstimatesOrderBy> | EstimatesOrderBy;
  whereClause: EstimatesBoolExp;
}>;


export type GetEstimateListQuery = { __typename?: 'query_root', estimatesAggregate: { __typename?: 'EstimatesAggregate', aggregate?: { __typename?: 'EstimatesAggregateFields', count: number } | undefined }, estimates: Array<{ __typename?: 'Estimates', estimateGuid: string, displayId: number, taxRate: number, dynamicPricingType?: DynamicPricingType | undefined, status: EstimateV2Status, closedLostReasonCategory?: string | undefined, closedLostReasonNote?: string | undefined, createdAt: IsoDateString, jobAppointmentGuid?: string | undefined, createdByUser: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string, deactivatedAt?: IsoDateString | undefined, userPrimaryHueHex?: string | undefined, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }>, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined }, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, accountGuid: string, pointOfContact: { __typename?: 'Contacts', fullName: string, firstName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', type: PhoneNumberType, phoneNumber: string } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined }, location: { __typename?: 'Locations', locationGuid: string, locationDescription?: string | undefined, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string } }, jobType: { __typename?: 'JobTypes', name: string }, account: { __typename?: 'Accounts', accountReferenceNumber: string, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', fullName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined } }> } }, estimateOptions: Array<{ __typename?: 'EstimateOptions', seq: number, totalUsc: number, isSelected: boolean, optionGuid: string }> }> };

export type GetEstimateListUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEstimateListUsersQuery = { __typename?: 'query_root', companyUsers: Array<{ __typename?: 'CompanyUsers', userGuid: string, userByUserGuid: { __typename?: 'Users', fullName: string } }> };

export type EstimatePdfDataQueryVariables = Exact<{
  estimateGuid: Scalars['uuid'];
}>;


export type EstimatePdfDataQuery = { __typename?: 'query_root', estimatesByPk?: { __typename?: 'Estimates', messageHtml?: HtmlString | undefined, acceptedAt?: IsoDateString | undefined, signatureFileUrl?: string | undefined, taxRate: number, taxRateName: string, taxRateGuid: string, dynamicPricingType?: DynamicPricingType | undefined, hideLineItemPrices: boolean, acceptedOnBehalfByUser?: { __typename?: 'Users', firstName: string, lastName: string } | undefined, company: { __typename?: 'Companies', companyConfig?: { __typename?: 'CompanyConfig', maintenancePlanSavingsEnabled: boolean } | undefined } } | undefined };

export type EstimateListingOptionsQueryVariables = Exact<{
  estimateGuid: Scalars['uuid'];
}>;


export type EstimateListingOptionsQuery = { __typename?: 'query_root', estimatesByPk?: { __typename?: 'Estimates', estimateOptions: Array<{ __typename?: 'EstimateOptions', descriptionHtml?: HtmlString | undefined, displayName?: string | undefined, totalUsc: number, featuredPhotoGuid?: string | undefined, seq: number, optionGuid: string, recommended: boolean, selected: boolean, featuredPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined, estimateOptionDiscounts: Array<{ __typename?: 'EstimateOptionDiscounts', discountAmountUsc?: number | undefined, discountRate?: number | undefined, discountType: DiscountType, name?: string | undefined, seq: number, discountGuid: string }>, cartItems: Array<{ __typename?: 'EstimateOptionCartItems', seq: number, cartItem: { __typename?: 'CartItems', cartItemGuid: string, description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, originalPricebookItemGuid?: string | undefined, quantity: number, unitPriceUsc: number, cartItemCode?: string | undefined, cartItemVariant: CartItemVariant, itemType: CartItemType } }> }> } | undefined };

export type CompanyInvoiceSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyInvoiceSettingsQuery = { __typename?: 'query_root', companyConfig: Array<{ __typename?: 'CompanyConfig', invoiceDisplayTechnicianName: boolean, invoiceIssueWorkflow: InvoiceIssueWorkflow, invoiceLineItemsVisibility: CompanyLineItemVisibility, invoiceIncludePaymentLink: boolean, hideLineItemPrices: boolean }> };

export type UpdateCompanyInvoiceSettingsMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  set?: InputMaybe<CompanyConfigSetInput>;
}>;


export type UpdateCompanyInvoiceSettingsMutation = { __typename?: 'mutation_root', updateCompanyConfigByPk?: { __typename: 'CompanyConfig' } | undefined };

export type UpsertInvoiceTemplateMutationVariables = Exact<{
  invoiceTemplateGuid: Scalars['uuid'];
  template: InvoiceTemplatesInsertInput;
  validCartItemGuids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type UpsertInvoiceTemplateMutation = { __typename?: 'mutation_root', insertInvoiceTemplatesOne?: { __typename: 'InvoiceTemplates' } | undefined, deleteCartItems?: { __typename: 'CartItemsMutationResponse' } | undefined };

export type MarkInvoiceTemplateDeletedMutationVariables = Exact<{
  invoiceTemplateGuid: Scalars['uuid'];
}>;


export type MarkInvoiceTemplateDeletedMutation = { __typename?: 'mutation_root', updateInvoiceTemplatesByPk?: { __typename?: 'InvoiceTemplates', isDeleted: boolean } | undefined };

export type ReadInvoiceTemplatesQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type ReadInvoiceTemplatesQuery = { __typename?: 'query_root', invoiceTemplates: Array<{ __typename?: 'InvoiceTemplates', invoiceTemplateGuid: string, templateName: string, updatedAt: IsoDateString, invoiceTemplateCartItems: Array<{ __typename?: 'InvoiceTemplateCartItems', cartItem: { __typename?: 'CartItems', cartItemGuid: string, cartItemType: CartItemType, companyGuid: string, createdAt: IsoDateString, description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, originalPricebookItemGuid?: string | undefined, photoGuid?: string | undefined, quantity: number, unitPriceUsc: number, updatedAt: IsoDateString, cartItemCode?: string | undefined, cartItemVariant: CartItemVariant, photo?: { __typename?: 'Photos', cdnUrl: string, photoGuid: string } | undefined } }> }> };

export type GetRelevantInvoiceDataSubscriptionVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetRelevantInvoiceDataSubscription = { __typename?: 'subscription_root', companiesByPk?: { __typename?: 'Companies', name: string, companyConfig?: { __typename?: 'CompanyConfig', blurb?: string | undefined, invoiceIncludePaymentLink: boolean, invoiceDisplayTechnicianName: boolean, invoiceIssueWorkflow: InvoiceIssueWorkflow, maintenancePlanSavingsEnabled: boolean, hideLineItemPrices: boolean, customerNumberEnabled: boolean } | undefined, billingProfile?: { __typename?: 'BillingProfiles', businessFullLegalName: string, contractorLicenseNumber?: string | undefined, invoiceTerm?: InvoiceTermsEnum | undefined, logoUrl: string, invoiceDisclaimer: string, websiteDisplayName?: string | undefined, defaultPricebookTaxRateGuid?: string | undefined, businessAddress?: { __typename?: 'Addresses', city: string, line1: string, line2?: string | undefined, zipCode: string, stateAbbreviation: string } | undefined, emailAddress: { __typename?: 'EmailAddresses', emailAddress: string }, phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string } } | undefined, pricebookItems: Array<{ __typename?: 'PricebookItems', pricebookItemGuid: string }>, accCompanyConfigs: Array<{ __typename?: 'AccCompanyConfig', accountingIntegrationType?: string | undefined, autosyncInvoiceOnIssued: boolean, autosyncInvoiceOnPayment: boolean, autosyncInvoiceOnFullyPaid: boolean, autosyncInvoiceOnVoided: boolean }> } | undefined };

export type QueryRelevantInvoiceEditAccountDataQueryVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type QueryRelevantInvoiceEditAccountDataQuery = { __typename?: 'query_root', accountsByPk?: { __typename?: 'Accounts', accountType: AccountType, accountReferenceNumber: string, customerNumber?: string | undefined, accountLocations: Array<{ __typename?: 'AccountLocations', locationGuid: string, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', addressGuid: string, city: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string } } }>, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', contactGuid: string, fullName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined } }>, mailingAddress?: { __typename?: 'Addresses', addressGuid: string, city: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string } | undefined } | undefined };

export type InvoiceChecklistsQueryVariables = Exact<{
  invoiceGuid: Scalars['uuid'];
}>;


export type InvoiceChecklistsQuery = { __typename?: 'query_root', invoicesByPk?: { __typename?: 'Invoices', jobLink?: { __typename?: 'JobInvoices', job: { __typename?: 'Jobs', jobGuid: string, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string, appointmentWindowStart: IsoDateString, appointmentChecklistInstances: Array<{ __typename?: 'AppointmentChecklistInstances', appointmentChecklistInstanceGuid: string, name: AppointmentChecklistInstanceChecklist, appointmentChecklist: { __typename?: 'AppointmentChecklists', customerFacingByDefault: boolean } }>, assignments: Array<{ __typename?: 'JobAppointmentAssignments', technician: { __typename?: 'Users', firstName: string, lastName: string } }> }> } } | undefined } | undefined };

export type QueryRelevantInvoiceEditJobDataQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type QueryRelevantInvoiceEditJobDataQuery = { __typename?: 'query_root', jobsByPk?: { __typename?: 'Jobs', locationGuid: string, customerPurchaseOrderNumber?: string | undefined, location: { __typename?: 'Locations', addressGuid: string, address: { __typename?: 'Addresses', zipCode: string }, pricebookTaxRate?: { __typename?: 'PricebookTaxRates', pricebookTaxRateGuid: string, name: string, rate: number } | undefined }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string, appointmentWindowStart: IsoDateString }>, pointOfContact: { __typename?: 'Contacts', contactGuid: string, fullName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined } } | undefined };

export type GetRelevantInvoiceEditAccountDataSubscriptionVariables = Exact<{
  accountGuid: Scalars['uuid'];
}>;


export type GetRelevantInvoiceEditAccountDataSubscription = { __typename?: 'subscription_root', accountsByPk?: { __typename?: 'Accounts', accountType: AccountType, defaultInvoiceTerm: InvoiceTermV2, accountReferenceNumber: string, customerNumber?: string | undefined, accountLocations: Array<{ __typename?: 'AccountLocations', locationGuid: string, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', addressGuid: string, city: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string } } }>, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', contactGuid: string, fullName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined } }>, mailingAddress?: { __typename?: 'Addresses', addressGuid: string, city: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string } | undefined } | undefined };

export type GetRelevantInvoiceEditJobDataSubscriptionVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type GetRelevantInvoiceEditJobDataSubscription = { __typename?: 'subscription_root', jobsByPk?: { __typename?: 'Jobs', locationGuid: string, customerPurchaseOrderNumber?: string | undefined, location: { __typename?: 'Locations', addressGuid: string, address: { __typename?: 'Addresses', zipCode: string }, pricebookTaxRate?: { __typename?: 'PricebookTaxRates', pricebookTaxRateGuid: string, name: string, rate: number } | undefined }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string, appointmentWindowStart: IsoDateString }>, pointOfContact: { __typename?: 'Contacts', contactGuid: string, fullName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined } } | undefined };

export type UpsertInvoiceMutationVariables = Exact<{
  invoiceGuid: Scalars['uuid'];
  validCartItemGuids: Array<Scalars['uuid']> | Scalars['uuid'];
  validInvoiceDiscountGuids: Array<Scalars['uuid']> | Scalars['uuid'];
  invoice: InvoicesInsertInput;
}>;


export type UpsertInvoiceMutation = { __typename?: 'mutation_root', insertInvoicesOne?: { __typename: 'Invoices' } | undefined, deleteCartItems?: { __typename: 'CartItemsMutationResponse' } | undefined, deleteInvoiceDiscounts?: { __typename: 'InvoiceDiscountsMutationResponse' } | undefined };

export type UpdateInvoiceMutationVariables = Exact<{
  invoiceGuid: Scalars['uuid'];
  set: InvoicesSetInput;
}>;


export type UpdateInvoiceMutation = { __typename?: 'mutation_root', updateInvoicesByPk?: { __typename: 'Invoices' } | undefined };

export type InvoiceFragment = { __typename?: 'Invoices', messageHtml?: HtmlString | undefined, status: InvoiceV2Status, doNotSyncToAccountingServiceReason?: string | undefined, maintenancePlanSavingsEnabled: boolean, hideLineItemPrices: boolean, companyGuid: string, serviceCompletionDate?: LocalDateString | undefined, taxRate: number, taxRateName: string, taxRateGuid: string, invoiceTerm: InvoiceTermV2, dynamicPricingType?: DynamicPricingType | undefined, accountGuid: string, displayId: number, displayIdV2: string, dueAt?: IsoDateString | undefined, issuedAt?: IsoDateString | undefined, createdAt: IsoDateString, updatedAt: IsoDateString, customerPurchaseOrderNumber?: string | undefined, billingContactGuid: string, signatureFileUrl?: string | undefined, serviceAddress: { __typename?: 'Addresses', city: string, addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string }, billingContact: { __typename?: 'Contacts', fullName: string, firstName: string, contactGuid: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined }, billingAddress?: { __typename?: 'Addresses', city: string, addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string } | undefined, invoiceEvents: Array<{ __typename?: 'InvoiceEvents', eventType: InvoiceEventType, title: string, metadata: object, occurredAt: IsoDateString, createdByUser: { __typename?: 'Users', userGuid: string, fullName: string, firstName: string, lastName: string } }>, invoiceDiscounts: Array<{ __typename?: 'InvoiceDiscounts', name: string, discountType: DiscountType, discountAmountUsc?: number | undefined, discountRate?: number | undefined, invoiceDiscountGuid: string, descriptionHtml?: HtmlString | undefined }>, invoiceCartItems: Array<{ __typename?: 'InvoiceCartItems', seq: number, cartItem: { __typename?: 'CartItems', description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, unitPriceUsc: number, quantity: number, cartItemGuid: string, originalPricebookItemGuid?: string | undefined, cartItemCode?: string | undefined, cartItemVariant: CartItemVariant, itemType: CartItemType, photo?: { __typename?: 'Photos', cdnUrl: string, photoGuid: string } | undefined } }>, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', createdAt: IsoDateString, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, pointOfContact: { __typename?: 'Contacts', firstName: string, fullName: string, lastName: string, contactGuid: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } } } | undefined, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string, maintenancePlan?: { __typename?: 'MaintenancePlansQueryable', activatedAt?: IsoDateString | undefined, createdAt: IsoDateString, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined, location: { __typename?: 'Locations', addressGuid: string } } | undefined } | undefined, locationLink?: { __typename?: 'LocationInvoices', locationGuid: string, location: { __typename?: 'Locations', addressGuid: string } } | undefined, estimateLink?: { __typename?: 'EstimateInvoices', estimate: { __typename?: 'Estimates', estimateGuid: string, displayId: number, createdAt: IsoDateString, acceptedAt?: IsoDateString | undefined } } | undefined, jobAppointmentLink?: { __typename?: 'JobAppointmentInvoices', jobAppointment: { __typename?: 'JobAppointments', jobAppointmentGuid: string, appointmentType: AppointmentType, appointmentWindowStart: IsoDateString, assignments: Array<{ __typename?: 'JobAppointmentAssignments', technicianUserGuid: string, technician: { __typename?: 'Users', firstNameInitial?: string | undefined } }> } } | undefined, account: { __typename?: 'Accounts', createdAt: IsoDateString, accountReferenceNumber: string, customerNumber?: string | undefined, mailingAddressGuid?: string | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', firstName: string, fullName: string, lastName: string, contactGuid: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined } }> }, invoicePayments: Array<{ __typename?: 'InvoicePayments', paymentRecordGuid: string, appliedAmountUsc: number, invoice: { __typename?: 'Invoices', displayIdV2: string }, paymentRecord: { __typename?: 'PaymentRecords', paymentRecordGuid: string, paymentMethod: PaymentMethod, occurredAt: IsoDateString, amountUsd: number, paymentRefunds: Array<{ __typename?: 'PaymentRefunds', amountUsd: number, occurredAt: IsoDateString }>, paymentStatuses: Array<{ __typename?: 'PaymentStatuses', paymentStatus: PaymentStatusTypesEnum }> } }>, qboStaleInfo?: { __typename?: 'InvoicesV2QboStale', updatedAt?: IsoDateString | undefined, stale?: boolean | undefined, syncedAt?: IsoDateString | undefined } | undefined, accountingStaleInfo?: { __typename?: 'InvoicesV2AccountingStale', isStale?: boolean | undefined, syncedAt?: IsoDateString | undefined, latestPaymentAt?: IsoDateString | undefined, invoiceUpdatedAt?: IsoDateString | undefined } | undefined, businessUnitLink?: { __typename?: 'InvoiceBusinessUnit', businessUnitGuid?: string | undefined, businessUnit?: { __typename?: 'BusinessUnits', name: string } | undefined } | undefined, taxConfiguration?: { __typename?: 'InvoiceCompanyTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined };

export type InvoiceWithGuidFragment = { __typename?: 'Invoices', invoiceGuid: string, messageHtml?: HtmlString | undefined, status: InvoiceV2Status, doNotSyncToAccountingServiceReason?: string | undefined, maintenancePlanSavingsEnabled: boolean, hideLineItemPrices: boolean, companyGuid: string, serviceCompletionDate?: LocalDateString | undefined, taxRate: number, taxRateName: string, taxRateGuid: string, invoiceTerm: InvoiceTermV2, dynamicPricingType?: DynamicPricingType | undefined, accountGuid: string, displayId: number, displayIdV2: string, dueAt?: IsoDateString | undefined, issuedAt?: IsoDateString | undefined, createdAt: IsoDateString, updatedAt: IsoDateString, customerPurchaseOrderNumber?: string | undefined, billingContactGuid: string, signatureFileUrl?: string | undefined, serviceAddress: { __typename?: 'Addresses', city: string, addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string }, billingContact: { __typename?: 'Contacts', fullName: string, firstName: string, contactGuid: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined }, billingAddress?: { __typename?: 'Addresses', city: string, addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string } | undefined, invoiceEvents: Array<{ __typename?: 'InvoiceEvents', eventType: InvoiceEventType, title: string, metadata: object, occurredAt: IsoDateString, createdByUser: { __typename?: 'Users', userGuid: string, fullName: string, firstName: string, lastName: string } }>, invoiceDiscounts: Array<{ __typename?: 'InvoiceDiscounts', name: string, discountType: DiscountType, discountAmountUsc?: number | undefined, discountRate?: number | undefined, invoiceDiscountGuid: string, descriptionHtml?: HtmlString | undefined }>, invoiceCartItems: Array<{ __typename?: 'InvoiceCartItems', seq: number, cartItem: { __typename?: 'CartItems', description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, unitPriceUsc: number, quantity: number, cartItemGuid: string, originalPricebookItemGuid?: string | undefined, cartItemCode?: string | undefined, cartItemVariant: CartItemVariant, itemType: CartItemType, photo?: { __typename?: 'Photos', cdnUrl: string, photoGuid: string } | undefined } }>, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', createdAt: IsoDateString, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, pointOfContact: { __typename?: 'Contacts', firstName: string, fullName: string, lastName: string, contactGuid: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } } } | undefined, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string, maintenancePlan?: { __typename?: 'MaintenancePlansQueryable', activatedAt?: IsoDateString | undefined, createdAt: IsoDateString, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined, location: { __typename?: 'Locations', addressGuid: string } } | undefined } | undefined, locationLink?: { __typename?: 'LocationInvoices', locationGuid: string, location: { __typename?: 'Locations', addressGuid: string } } | undefined, estimateLink?: { __typename?: 'EstimateInvoices', estimate: { __typename?: 'Estimates', estimateGuid: string, displayId: number, createdAt: IsoDateString, acceptedAt?: IsoDateString | undefined } } | undefined, jobAppointmentLink?: { __typename?: 'JobAppointmentInvoices', jobAppointment: { __typename?: 'JobAppointments', jobAppointmentGuid: string, appointmentType: AppointmentType, appointmentWindowStart: IsoDateString, assignments: Array<{ __typename?: 'JobAppointmentAssignments', technicianUserGuid: string, technician: { __typename?: 'Users', firstNameInitial?: string | undefined } }> } } | undefined, account: { __typename?: 'Accounts', createdAt: IsoDateString, accountReferenceNumber: string, customerNumber?: string | undefined, mailingAddressGuid?: string | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', firstName: string, fullName: string, lastName: string, contactGuid: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined } }> }, invoicePayments: Array<{ __typename?: 'InvoicePayments', paymentRecordGuid: string, appliedAmountUsc: number, invoice: { __typename?: 'Invoices', displayIdV2: string }, paymentRecord: { __typename?: 'PaymentRecords', paymentRecordGuid: string, paymentMethod: PaymentMethod, occurredAt: IsoDateString, amountUsd: number, paymentRefunds: Array<{ __typename?: 'PaymentRefunds', amountUsd: number, occurredAt: IsoDateString }>, paymentStatuses: Array<{ __typename?: 'PaymentStatuses', paymentStatus: PaymentStatusTypesEnum }> } }>, qboStaleInfo?: { __typename?: 'InvoicesV2QboStale', updatedAt?: IsoDateString | undefined, stale?: boolean | undefined, syncedAt?: IsoDateString | undefined } | undefined, accountingStaleInfo?: { __typename?: 'InvoicesV2AccountingStale', isStale?: boolean | undefined, syncedAt?: IsoDateString | undefined, latestPaymentAt?: IsoDateString | undefined, invoiceUpdatedAt?: IsoDateString | undefined } | undefined, businessUnitLink?: { __typename?: 'InvoiceBusinessUnit', businessUnitGuid?: string | undefined, businessUnit?: { __typename?: 'BusinessUnits', name: string } | undefined } | undefined, taxConfiguration?: { __typename?: 'InvoiceCompanyTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined };

export type InvoiceDataSubscriptionVariables = Exact<{
  invoiceGuid: Scalars['uuid'];
}>;


export type InvoiceDataSubscription = { __typename?: 'subscription_root', invoicesByPk?: { __typename?: 'Invoices', messageHtml?: HtmlString | undefined, status: InvoiceV2Status, doNotSyncToAccountingServiceReason?: string | undefined, maintenancePlanSavingsEnabled: boolean, hideLineItemPrices: boolean, companyGuid: string, serviceCompletionDate?: LocalDateString | undefined, taxRate: number, taxRateName: string, taxRateGuid: string, invoiceTerm: InvoiceTermV2, dynamicPricingType?: DynamicPricingType | undefined, accountGuid: string, displayId: number, displayIdV2: string, dueAt?: IsoDateString | undefined, issuedAt?: IsoDateString | undefined, createdAt: IsoDateString, updatedAt: IsoDateString, customerPurchaseOrderNumber?: string | undefined, billingContactGuid: string, signatureFileUrl?: string | undefined, serviceAddress: { __typename?: 'Addresses', city: string, addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string }, billingContact: { __typename?: 'Contacts', fullName: string, firstName: string, contactGuid: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined }, billingAddress?: { __typename?: 'Addresses', city: string, addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string } | undefined, invoiceEvents: Array<{ __typename?: 'InvoiceEvents', eventType: InvoiceEventType, title: string, metadata: object, occurredAt: IsoDateString, createdByUser: { __typename?: 'Users', userGuid: string, fullName: string, firstName: string, lastName: string } }>, invoiceDiscounts: Array<{ __typename?: 'InvoiceDiscounts', name: string, discountType: DiscountType, discountAmountUsc?: number | undefined, discountRate?: number | undefined, invoiceDiscountGuid: string, descriptionHtml?: HtmlString | undefined }>, invoiceCartItems: Array<{ __typename?: 'InvoiceCartItems', seq: number, cartItem: { __typename?: 'CartItems', description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, unitPriceUsc: number, quantity: number, cartItemGuid: string, originalPricebookItemGuid?: string | undefined, cartItemCode?: string | undefined, cartItemVariant: CartItemVariant, itemType: CartItemType, photo?: { __typename?: 'Photos', cdnUrl: string, photoGuid: string } | undefined } }>, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', createdAt: IsoDateString, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, pointOfContact: { __typename?: 'Contacts', firstName: string, fullName: string, lastName: string, contactGuid: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } } } | undefined, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string, maintenancePlan?: { __typename?: 'MaintenancePlansQueryable', activatedAt?: IsoDateString | undefined, createdAt: IsoDateString, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined, location: { __typename?: 'Locations', addressGuid: string } } | undefined } | undefined, locationLink?: { __typename?: 'LocationInvoices', locationGuid: string, location: { __typename?: 'Locations', addressGuid: string } } | undefined, estimateLink?: { __typename?: 'EstimateInvoices', estimate: { __typename?: 'Estimates', estimateGuid: string, displayId: number, createdAt: IsoDateString, acceptedAt?: IsoDateString | undefined } } | undefined, jobAppointmentLink?: { __typename?: 'JobAppointmentInvoices', jobAppointment: { __typename?: 'JobAppointments', jobAppointmentGuid: string, appointmentType: AppointmentType, appointmentWindowStart: IsoDateString, assignments: Array<{ __typename?: 'JobAppointmentAssignments', technicianUserGuid: string, technician: { __typename?: 'Users', firstNameInitial?: string | undefined } }> } } | undefined, account: { __typename?: 'Accounts', createdAt: IsoDateString, accountReferenceNumber: string, customerNumber?: string | undefined, mailingAddressGuid?: string | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', firstName: string, fullName: string, lastName: string, contactGuid: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined } }> }, invoicePayments: Array<{ __typename?: 'InvoicePayments', paymentRecordGuid: string, appliedAmountUsc: number, invoice: { __typename?: 'Invoices', displayIdV2: string }, paymentRecord: { __typename?: 'PaymentRecords', paymentRecordGuid: string, paymentMethod: PaymentMethod, occurredAt: IsoDateString, amountUsd: number, paymentRefunds: Array<{ __typename?: 'PaymentRefunds', amountUsd: number, occurredAt: IsoDateString }>, paymentStatuses: Array<{ __typename?: 'PaymentStatuses', paymentStatus: PaymentStatusTypesEnum }> } }>, qboStaleInfo?: { __typename?: 'InvoicesV2QboStale', updatedAt?: IsoDateString | undefined, stale?: boolean | undefined, syncedAt?: IsoDateString | undefined } | undefined, accountingStaleInfo?: { __typename?: 'InvoicesV2AccountingStale', isStale?: boolean | undefined, syncedAt?: IsoDateString | undefined, latestPaymentAt?: IsoDateString | undefined, invoiceUpdatedAt?: IsoDateString | undefined } | undefined, businessUnitLink?: { __typename?: 'InvoiceBusinessUnit', businessUnitGuid?: string | undefined, businessUnit?: { __typename?: 'BusinessUnits', name: string } | undefined } | undefined, taxConfiguration?: { __typename?: 'InvoiceCompanyTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined } | undefined };

export type InvoicesDataSubscriptionVariables = Exact<{
  where?: InputMaybe<InvoicesBoolExp>;
}>;


export type InvoicesDataSubscription = { __typename?: 'subscription_root', invoices: Array<{ __typename?: 'Invoices', invoiceGuid: string, messageHtml?: HtmlString | undefined, status: InvoiceV2Status, doNotSyncToAccountingServiceReason?: string | undefined, maintenancePlanSavingsEnabled: boolean, hideLineItemPrices: boolean, companyGuid: string, serviceCompletionDate?: LocalDateString | undefined, taxRate: number, taxRateName: string, taxRateGuid: string, invoiceTerm: InvoiceTermV2, dynamicPricingType?: DynamicPricingType | undefined, accountGuid: string, displayId: number, displayIdV2: string, dueAt?: IsoDateString | undefined, issuedAt?: IsoDateString | undefined, createdAt: IsoDateString, updatedAt: IsoDateString, customerPurchaseOrderNumber?: string | undefined, billingContactGuid: string, signatureFileUrl?: string | undefined, serviceAddress: { __typename?: 'Addresses', city: string, addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string }, billingContact: { __typename?: 'Contacts', fullName: string, firstName: string, contactGuid: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined }, billingAddress?: { __typename?: 'Addresses', city: string, addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string } | undefined, invoiceEvents: Array<{ __typename?: 'InvoiceEvents', eventType: InvoiceEventType, title: string, metadata: object, occurredAt: IsoDateString, createdByUser: { __typename?: 'Users', userGuid: string, fullName: string, firstName: string, lastName: string } }>, invoiceDiscounts: Array<{ __typename?: 'InvoiceDiscounts', name: string, discountType: DiscountType, discountAmountUsc?: number | undefined, discountRate?: number | undefined, invoiceDiscountGuid: string, descriptionHtml?: HtmlString | undefined }>, invoiceCartItems: Array<{ __typename?: 'InvoiceCartItems', seq: number, cartItem: { __typename?: 'CartItems', description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, unitPriceUsc: number, quantity: number, cartItemGuid: string, originalPricebookItemGuid?: string | undefined, cartItemCode?: string | undefined, cartItemVariant: CartItemVariant, itemType: CartItemType, photo?: { __typename?: 'Photos', cdnUrl: string, photoGuid: string } | undefined } }>, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', createdAt: IsoDateString, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, pointOfContact: { __typename?: 'Contacts', firstName: string, fullName: string, lastName: string, contactGuid: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } } } | undefined, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string, maintenancePlan?: { __typename?: 'MaintenancePlansQueryable', activatedAt?: IsoDateString | undefined, createdAt: IsoDateString, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined, location: { __typename?: 'Locations', addressGuid: string } } | undefined } | undefined, locationLink?: { __typename?: 'LocationInvoices', locationGuid: string, location: { __typename?: 'Locations', addressGuid: string } } | undefined, estimateLink?: { __typename?: 'EstimateInvoices', estimate: { __typename?: 'Estimates', estimateGuid: string, displayId: number, createdAt: IsoDateString, acceptedAt?: IsoDateString | undefined } } | undefined, jobAppointmentLink?: { __typename?: 'JobAppointmentInvoices', jobAppointment: { __typename?: 'JobAppointments', jobAppointmentGuid: string, appointmentType: AppointmentType, appointmentWindowStart: IsoDateString, assignments: Array<{ __typename?: 'JobAppointmentAssignments', technicianUserGuid: string, technician: { __typename?: 'Users', firstNameInitial?: string | undefined } }> } } | undefined, account: { __typename?: 'Accounts', createdAt: IsoDateString, accountReferenceNumber: string, customerNumber?: string | undefined, mailingAddressGuid?: string | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', firstName: string, fullName: string, lastName: string, contactGuid: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined } }> }, invoicePayments: Array<{ __typename?: 'InvoicePayments', paymentRecordGuid: string, appliedAmountUsc: number, invoice: { __typename?: 'Invoices', displayIdV2: string }, paymentRecord: { __typename?: 'PaymentRecords', paymentRecordGuid: string, paymentMethod: PaymentMethod, occurredAt: IsoDateString, amountUsd: number, paymentRefunds: Array<{ __typename?: 'PaymentRefunds', amountUsd: number, occurredAt: IsoDateString }>, paymentStatuses: Array<{ __typename?: 'PaymentStatuses', paymentStatus: PaymentStatusTypesEnum }> } }>, qboStaleInfo?: { __typename?: 'InvoicesV2QboStale', updatedAt?: IsoDateString | undefined, stale?: boolean | undefined, syncedAt?: IsoDateString | undefined } | undefined, accountingStaleInfo?: { __typename?: 'InvoicesV2AccountingStale', isStale?: boolean | undefined, syncedAt?: IsoDateString | undefined, latestPaymentAt?: IsoDateString | undefined, invoiceUpdatedAt?: IsoDateString | undefined } | undefined, businessUnitLink?: { __typename?: 'InvoiceBusinessUnit', businessUnitGuid?: string | undefined, businessUnit?: { __typename?: 'BusinessUnits', name: string } | undefined } | undefined, taxConfiguration?: { __typename?: 'InvoiceCompanyTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined }> };

export type InvoicesDataQueryQueryVariables = Exact<{
  where?: InputMaybe<InvoicesBoolExp>;
}>;


export type InvoicesDataQueryQuery = { __typename?: 'query_root', invoices: Array<{ __typename?: 'Invoices', invoiceGuid: string, messageHtml?: HtmlString | undefined, status: InvoiceV2Status, doNotSyncToAccountingServiceReason?: string | undefined, maintenancePlanSavingsEnabled: boolean, hideLineItemPrices: boolean, companyGuid: string, serviceCompletionDate?: LocalDateString | undefined, taxRate: number, taxRateName: string, taxRateGuid: string, invoiceTerm: InvoiceTermV2, dynamicPricingType?: DynamicPricingType | undefined, accountGuid: string, displayId: number, displayIdV2: string, dueAt?: IsoDateString | undefined, issuedAt?: IsoDateString | undefined, createdAt: IsoDateString, updatedAt: IsoDateString, customerPurchaseOrderNumber?: string | undefined, billingContactGuid: string, signatureFileUrl?: string | undefined, serviceAddress: { __typename?: 'Addresses', city: string, addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string }, billingContact: { __typename?: 'Contacts', fullName: string, firstName: string, contactGuid: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined }, billingAddress?: { __typename?: 'Addresses', city: string, addressGuid: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string } | undefined, invoiceEvents: Array<{ __typename?: 'InvoiceEvents', eventType: InvoiceEventType, title: string, metadata: object, occurredAt: IsoDateString, createdByUser: { __typename?: 'Users', userGuid: string, fullName: string, firstName: string, lastName: string } }>, invoiceDiscounts: Array<{ __typename?: 'InvoiceDiscounts', name: string, discountType: DiscountType, discountAmountUsc?: number | undefined, discountRate?: number | undefined, invoiceDiscountGuid: string, descriptionHtml?: HtmlString | undefined }>, invoiceCartItems: Array<{ __typename?: 'InvoiceCartItems', seq: number, cartItem: { __typename?: 'CartItems', description?: HtmlString | undefined, isDiscountable: boolean, isTaxable: boolean, name: string, unitPriceUsc: number, quantity: number, cartItemGuid: string, originalPricebookItemGuid?: string | undefined, cartItemCode?: string | undefined, cartItemVariant: CartItemVariant, itemType: CartItemType, photo?: { __typename?: 'Photos', cdnUrl: string, photoGuid: string } | undefined } }>, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', createdAt: IsoDateString, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, pointOfContact: { __typename?: 'Contacts', firstName: string, fullName: string, lastName: string, contactGuid: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } } } | undefined, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string, maintenancePlan?: { __typename?: 'MaintenancePlansQueryable', activatedAt?: IsoDateString | undefined, createdAt: IsoDateString, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined, location: { __typename?: 'Locations', addressGuid: string } } | undefined } | undefined, locationLink?: { __typename?: 'LocationInvoices', locationGuid: string, location: { __typename?: 'Locations', addressGuid: string } } | undefined, estimateLink?: { __typename?: 'EstimateInvoices', estimate: { __typename?: 'Estimates', estimateGuid: string, displayId: number, createdAt: IsoDateString, acceptedAt?: IsoDateString | undefined } } | undefined, jobAppointmentLink?: { __typename?: 'JobAppointmentInvoices', jobAppointment: { __typename?: 'JobAppointments', jobAppointmentGuid: string, appointmentType: AppointmentType, appointmentWindowStart: IsoDateString, assignments: Array<{ __typename?: 'JobAppointmentAssignments', technicianUserGuid: string, technician: { __typename?: 'Users', firstNameInitial?: string | undefined } }> } } | undefined, account: { __typename?: 'Accounts', createdAt: IsoDateString, accountReferenceNumber: string, customerNumber?: string | undefined, mailingAddressGuid?: string | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', firstName: string, fullName: string, lastName: string, contactGuid: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined } }> }, invoicePayments: Array<{ __typename?: 'InvoicePayments', paymentRecordGuid: string, appliedAmountUsc: number, invoice: { __typename?: 'Invoices', displayIdV2: string }, paymentRecord: { __typename?: 'PaymentRecords', paymentRecordGuid: string, paymentMethod: PaymentMethod, occurredAt: IsoDateString, amountUsd: number, paymentRefunds: Array<{ __typename?: 'PaymentRefunds', amountUsd: number, occurredAt: IsoDateString }>, paymentStatuses: Array<{ __typename?: 'PaymentStatuses', paymentStatus: PaymentStatusTypesEnum }> } }>, qboStaleInfo?: { __typename?: 'InvoicesV2QboStale', updatedAt?: IsoDateString | undefined, stale?: boolean | undefined, syncedAt?: IsoDateString | undefined } | undefined, accountingStaleInfo?: { __typename?: 'InvoicesV2AccountingStale', isStale?: boolean | undefined, syncedAt?: IsoDateString | undefined, latestPaymentAt?: IsoDateString | undefined, invoiceUpdatedAt?: IsoDateString | undefined } | undefined, businessUnitLink?: { __typename?: 'InvoiceBusinessUnit', businessUnitGuid?: string | undefined, businessUnit?: { __typename?: 'BusinessUnits', name: string } | undefined } | undefined, taxConfiguration?: { __typename?: 'InvoiceCompanyTaxConfigurationsView', taxRoundingStrategy: TaxRoundingStrategy } | undefined }> };

export type MaintenancePlanDetailsQueryQueryVariables = Exact<{
  maintenancePlanGuid: Scalars['uuid'];
}>;


export type MaintenancePlanDetailsQueryQuery = { __typename?: 'query_root', maintenancePlansQueryableByPk?: { __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined } | undefined };

export type CheckInvoiceNumberUniquenessQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  invoiceNumber: Scalars['String'];
  excludeInvoiceGuid?: InputMaybe<Scalars['uuid']>;
}>;


export type CheckInvoiceNumberUniquenessQuery = { __typename?: 'query_root', invoices: Array<{ __typename?: 'Invoices', invoiceGuid: string, displayIdV2: string }> };

export type InvoicesListPageInvoiceSummaryStatisticsQueryQueryVariables = Exact<{
  where?: InputMaybe<InvoicesQueryableBoolExp>;
}>;


export type InvoicesListPageInvoiceSummaryStatisticsQueryQuery = { __typename?: 'query_root', invoicesQueryableAggregate: { __typename?: 'InvoicesQueryableAggregate', aggregate?: { __typename?: 'InvoicesQueryableAggregateFields', count: number, sum?: { __typename?: 'InvoicesQueryableSumFields', totalAmountUsd?: number | undefined } | undefined } | undefined } };

export type InvoicesListPageInvoiceSummaryStatisticAvgValuesQueryQueryVariables = Exact<{
  where?: InputMaybe<InvoicesQueryableBoolExp>;
}>;


export type InvoicesListPageInvoiceSummaryStatisticAvgValuesQueryQuery = { __typename?: 'query_root', invoicesQueryableAggregate: { __typename?: 'InvoicesQueryableAggregate', aggregate?: { __typename?: 'InvoicesQueryableAggregateFields', avg?: { __typename?: 'InvoicesQueryableAvgFields', totalAmountUsd?: number | undefined } | undefined } | undefined } };

export type InvoicesListPageInvoiceAvgUnpaidDaysQueryQueryVariables = Exact<{
  where?: InputMaybe<InvoicesQueryableBoolExp>;
}>;


export type InvoicesListPageInvoiceAvgUnpaidDaysQueryQuery = { __typename?: 'query_root', invoicesQueryableAggregate: { __typename?: 'InvoicesQueryableAggregate', aggregate?: { __typename?: 'InvoicesQueryableAggregateFields', avg?: { __typename?: 'InvoicesQueryableAvgFields', daysUnpaid?: number | undefined } | undefined } | undefined } };

export type InvoicesListPageInvoicesV2QueryQueryVariables = Exact<{
  where?: InputMaybe<AggregatableInvoicesBoolExp>;
  orderBy?: InputMaybe<Array<AggregatableInvoicesOrderBy> | AggregatableInvoicesOrderBy>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type InvoicesListPageInvoicesV2QueryQuery = { __typename?: 'query_root', aggregatableInvoices: Array<{ __typename?: 'AggregatableInvoices', accountGuid: string, companyGuid?: string | undefined, createdAt?: IsoDateString | undefined, dueAt?: IsoDateString | undefined, invoiceGuid: string, status: InvoiceV2Status, invoiceTerm: InvoiceTermV2, issuedAt?: IsoDateString | undefined, issuedOrCreatedAt: IsoDateString, displayId: number, displayIdV2?: string | undefined, totalUsc: number, serviceCompletionDate?: LocalDateString | undefined, updatedAt?: IsoDateString | undefined, paidUsd: number, paidUsc?: number | undefined, processingUsd: number, processingUsc?: number | undefined, numDaysOverdue?: number | undefined, isTerminalStatus: boolean, createdBy: string, doNotSyncToAccountingServiceReason?: string | undefined, account?: { __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, customerNumber?: string | undefined, accountManagerUserGuid?: string | undefined, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } }> } | undefined, locationLink?: { __typename?: 'LocationInvoices', locationGuid: string, location: { __typename?: 'Locations', locationDescription?: string | undefined, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string } } } | undefined, jobLink?: { __typename?: 'JobInvoices', jobGuid: string, job: { __typename?: 'Jobs', displayId: number, jobType: { __typename?: 'JobTypes', name: string }, pointOfContact: { __typename?: 'Contacts', fullName: string, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined }, jobLeadSource: Array<{ __typename?: 'CompanyLeadSourceLinks', companyLeadSource: { __typename?: 'CompanyLeadSources', companyLeadSourceGuid: string, canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined } }> } } | undefined, maintenancePlanLink?: { __typename?: 'MaintenancePlanInvoices', maintenancePlanGuid: string, maintenancePlan?: { __typename?: 'MaintenancePlansQueryable', createdByUserGuid: string, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined } | undefined } | undefined, businessUnitLink?: { __typename?: 'InvoiceBusinessUnit', businessUnitGuid?: string | undefined, sourceType?: string | undefined, sourceGuid?: string | undefined, businessUnit?: { __typename?: 'BusinessUnits', name: string } | undefined } | undefined, invoiceEvents: Array<{ __typename?: 'InvoiceEvents', eventType: InvoiceEventType, occurredAt: IsoDateString }> }>, aggregatableInvoicesAggregate: { __typename?: 'AggregatableInvoicesAggregate', aggregate?: { __typename?: 'AggregatableInvoicesAggregateFields', count: number } | undefined } };

export type InvoicesListPageInvoiceV2SummaryStatisticsQueryQueryVariables = Exact<{
  where?: InputMaybe<AggregatableInvoicesBoolExp>;
}>;


export type InvoicesListPageInvoiceV2SummaryStatisticsQueryQuery = { __typename?: 'query_root', aggregatableInvoicesAggregate: { __typename?: 'AggregatableInvoicesAggregate', aggregate?: { __typename?: 'AggregatableInvoicesAggregateFields', count: number, sum?: { __typename?: 'AggregatableInvoicesSumFields', totalUsc?: number | undefined, paidUsd?: number | undefined, processingUsd?: number | undefined } | undefined } | undefined } };

export type InvoicesListPageInvoiceV2SummaryStatisticAvgValuesQueryQueryVariables = Exact<{
  where?: InputMaybe<AggregatableInvoicesBoolExp>;
}>;


export type InvoicesListPageInvoiceV2SummaryStatisticAvgValuesQueryQuery = { __typename?: 'query_root', aggregatableInvoicesAggregate: { __typename?: 'AggregatableInvoicesAggregate', aggregate?: { __typename?: 'AggregatableInvoicesAggregateFields', avg?: { __typename?: 'AggregatableInvoicesAvgFields', totalUsc?: number | undefined } | undefined } | undefined } };

export type InvoicesListPageInvoiceV2AvgUnpaidDaysQueryQueryVariables = Exact<{
  where?: InputMaybe<AggregatableInvoicesBoolExp>;
}>;


export type InvoicesListPageInvoiceV2AvgUnpaidDaysQueryQuery = { __typename?: 'query_root', aggregatableInvoicesAggregate: { __typename?: 'AggregatableInvoicesAggregate', aggregate?: { __typename?: 'AggregatableInvoicesAggregateFields', avg?: { __typename?: 'AggregatableInvoicesAvgFields', daysUnpaid?: number | undefined } | undefined } | undefined } };

export type GetInvoiceListUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvoiceListUsersQuery = { __typename?: 'query_root', companyUsers: Array<{ __typename?: 'CompanyUsers', userGuid: string, userByUserGuid: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string, fullName: string, deactivatedAt?: IsoDateString | undefined, userPrimaryHueHex?: string | undefined, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }>, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined } }> };

export type InvoiceListPageCompanyConfigQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type InvoiceListPageCompanyConfigQueryQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', companyGuid: string, accountManagerEnabled: boolean, customerNumberEnabled: boolean } | undefined };

export type InvoiceListPageBusinessUnitsQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type InvoiceListPageBusinessUnitsQueryQuery = { __typename?: 'query_root', businessUnits: Array<{ __typename?: 'BusinessUnits', businessUnitGuid: string, name: string }> };

export type JobCostingTeamMembersQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type JobCostingTeamMembersQueryQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', userGuid: string, fullName: string, deactivatedAt?: IsoDateString | undefined }> };

export type JobDetailsPageCompanyConfigQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type JobDetailsPageCompanyConfigQueryQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', companyGuid: string, accountManagerEnabled: boolean } | undefined };

export type JobDetailsPageLinkedJobDataQuerySubscriptionVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type JobDetailsPageLinkedJobDataQuerySubscription = { __typename?: 'subscription_root', jobsWithLinkedJob: Array<{ __typename?: 'JobsWithLinkedJob', jobGuid: string, linkNotes: boolean, linkPhotos: boolean, linkAttachments: boolean, linked_job: { __typename?: 'Jobs', jobGuid: string, displayId: number, noteLinks: Array<{ __typename?: 'NoteLinks', noteGuid: string }>, photoLinks: Array<{ __typename?: 'PhotoLinks', photoGuid: string, photo: { __typename?: 'Photos', cdnUrl: string, resourceUrn: string, createdAt: IsoDateString, createdByUserGuid: string } }> } }> };

export type JobDetailsPageLinkedJobsQueryQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type JobDetailsPageLinkedJobsQueryQuery = { __typename?: 'query_root', jobsWithLinkedJob: Array<{ __typename?: 'JobsWithLinkedJob', linked_job: { __typename?: 'Jobs', displayId: number, jobGuid: string, createdAt: IsoDateString, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string, addressGuid: string } }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string } } }> };

export type JobDetailsPageLinkedToJobsQueryQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type JobDetailsPageLinkedToJobsQueryQuery = { __typename?: 'query_root', jobsWithLinkedJob: Array<{ __typename?: 'JobsWithLinkedJob', job: { __typename?: 'Jobs', displayId: number, jobGuid: string, createdAt: IsoDateString, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string, addressGuid: string } }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string } } }> };

export type JobDetailsPageLinkedPhoneCallsSubscriptionSubscriptionVariables = Exact<{
  jobGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
}>;


export type JobDetailsPageLinkedPhoneCallsSubscriptionSubscription = { __typename?: 'subscription_root', jobs: Array<{ __typename?: 'Jobs', integratedPhoneCallJobs: Array<{ __typename?: 'IntegratedPhoneCallJobs', integratedPhoneCall: { __typename?: 'IntegratedPhoneCalls', integratedPhoneCallGuid: string, startedAt: IsoDateString, endedAt?: IsoDateString | undefined, contact?: { __typename?: 'Contacts', fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined } | undefined, user?: { __typename?: 'Users', fullName: string } | undefined, integratedPhoneMissedCalls: Array<{ __typename?: 'IntegratedPhoneMissedCalls', integratedPhoneVoicemails: Array<{ __typename?: 'IntegratedPhoneVoicemails', recordingSummary?: string | undefined, recordingTranscript?: string | undefined, recordingUrl: string }> }>, integratedPhoneCallRecording?: { __typename?: 'IntegratedPhoneCallRecording', recordingSummary?: string | undefined, recordingTranscript?: string | undefined, recordingUrl: string } | undefined, integratedPhoneCallJobs: Array<{ __typename?: 'IntegratedPhoneCallJobs', job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', name: string }, location: { __typename?: 'Locations', locationGuid: string, displayName?: string | undefined, locationDescription?: string | undefined, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, zipCode: string, stateAbbreviation: string } } } }> } }> }> };

export type JobOriginatingPlatformQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
}>;


export type JobOriginatingPlatformQuery = { __typename?: 'query_root', jobLeads: Array<{ __typename?: 'JobLeads', originatingPlatformUrl?: string | undefined, originatingPlatformLabel?: string | undefined }> };

export type UpdateJobUseMaintenancePlanCreditMutationVariables = Exact<{
  jobGuid: Scalars['uuid'];
  useCredit: Scalars['Boolean'];
}>;


export type UpdateJobUseMaintenancePlanCreditMutation = { __typename?: 'mutation_root', updateJobsByPk?: { __typename?: 'Jobs', jobGuid: string, useMaintenancePlanCredit: boolean } | undefined };

export type FetchJobTechnicianPerformanceInfoQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type FetchJobTechnicianPerformanceInfoQuery = { __typename?: 'query_root', jobTechnicianEarnedRevenueSummaries: Array<{ __typename?: 'JobTechnicianEarnedRevenueSummaries', technicianUserGuid?: string | undefined, totalEarnedRevenueUsc?: number | undefined, technician?: { __typename?: 'Users', fullName: string, userGuid: string } | undefined }>, jobTechnicianSalesCommissionAndBonus: Array<{ __typename?: 'JobTechnicianSalesCommissionAndBonus', technicianUserGuid?: string | undefined, totalSoldRevenueUsc?: number | undefined, totalDeductionsUsc?: number | undefined, commissionableBaseUsc?: number | undefined, commissionUsc?: number | undefined, commissionRate?: number | undefined, bonusUsc?: number | undefined, technician?: { __typename?: 'Users', fullName: string, userGuid: string } | undefined }> };

export type FetchJobWorkCompletedAtLiveQuerySubscriptionVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type FetchJobWorkCompletedAtLiveQuerySubscription = { __typename?: 'subscription_root', jobsByPk?: { __typename?: 'Jobs', workCompletedAt?: IsoDateString | undefined } | undefined };

export type JobsTimesheetEntriesQueryVariables = Exact<{
  jobGuid: Scalars['uuid'];
}>;


export type JobsTimesheetEntriesQuery = { __typename?: 'query_root', timesheetEntries: Array<{ __typename?: 'TimesheetEntries', timesheetEntryGuid: string, userGuid: string, finalStartTime?: IsoDateString | undefined, finalEndTime?: IsoDateString | undefined, entryLengthInMinutes?: number | undefined, deletedAt?: IsoDateString | undefined, attentionNote?: string | undefined, user: { __typename?: 'Users', firstName: string, lastName: string, userGuid: string, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }> }, timesheetEntryActivity?: { __typename?: 'TimesheetEntryActivities', timesheetEntryActivityGuid: string, activityName: string, isPayable: boolean } | undefined, timesheetEntryLinkData: Array<{ __typename?: 'TimesheetEntryLinkData', jobAppointment?: { __typename?: 'JobAppointments', appointmentType: AppointmentType } | undefined }> }> };

export type JobRequestFragmentFragment = { __typename?: 'JobLeads', jobLeadGuid: string, contactFirstName?: string | undefined, contactLastName?: string | undefined, contactPhoneNumber?: string | undefined, contactEmailAddress?: string | undefined, serviceAddressLine1?: string | undefined, serviceAddressLine2?: string | undefined, serviceAddressCity?: string | undefined, serviceAddressStateAbbreviation?: string | undefined, serviceAddressZipCode?: string | undefined, accountType?: string | undefined, jobType?: string | undefined, requestType?: OnlineBookingServiceType | undefined, equipmentTypes?: JobLeadEquipmentTypeArray | undefined, estimateType?: JobLeadEstimateType | undefined, appointmentAvailabilities?: object | undefined, additionalMetadata?: JobLeadAdditionalMetadata | undefined, createdAt: IsoDateString, jobSummary?: string | undefined, leadSource?: string | undefined, jobLeadStatus: JobLeadStatus, jobGuid?: string | undefined, maintenancePlanVisitGuid?: string | undefined, originatingPlatformUrl?: string | undefined, originatingPlatformLabel?: string | undefined, submittedJobType?: { __typename?: 'JobTypes', jobTypeGuid: string, name: string } | undefined, job?: { __typename?: 'Jobs', displayId: number, createdAt: IsoDateString, jobType: { __typename?: 'JobTypes', name: string }, account: { __typename?: 'Accounts', accountGuid: string, accountDisplayName: string }, location: { __typename?: 'Locations', maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }> } } | undefined, preExistingLocation?: { __typename?: 'Locations', maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }> } | undefined };

export type FetchJobLeadsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  timeStart?: InputMaybe<Scalars['timestamptz']>;
  timeEnd?: InputMaybe<Scalars['timestamptz']>;
}>;


export type FetchJobLeadsQuery = { __typename?: 'query_root', jobLeads: Array<{ __typename?: 'JobLeads', jobLeadGuid: string, contactFirstName?: string | undefined, contactLastName?: string | undefined, contactPhoneNumber?: string | undefined, contactEmailAddress?: string | undefined, serviceAddressLine1?: string | undefined, serviceAddressLine2?: string | undefined, serviceAddressCity?: string | undefined, serviceAddressStateAbbreviation?: string | undefined, serviceAddressZipCode?: string | undefined, accountType?: string | undefined, jobType?: string | undefined, requestType?: OnlineBookingServiceType | undefined, equipmentTypes?: JobLeadEquipmentTypeArray | undefined, estimateType?: JobLeadEstimateType | undefined, appointmentAvailabilities?: object | undefined, additionalMetadata?: JobLeadAdditionalMetadata | undefined, createdAt: IsoDateString, jobSummary?: string | undefined, leadSource?: string | undefined, jobLeadStatus: JobLeadStatus, jobGuid?: string | undefined, maintenancePlanVisitGuid?: string | undefined, originatingPlatformUrl?: string | undefined, originatingPlatformLabel?: string | undefined, submittedJobType?: { __typename?: 'JobTypes', jobTypeGuid: string, name: string } | undefined, job?: { __typename?: 'Jobs', displayId: number, createdAt: IsoDateString, jobType: { __typename?: 'JobTypes', name: string }, account: { __typename?: 'Accounts', accountGuid: string, accountDisplayName: string }, location: { __typename?: 'Locations', maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }> } } | undefined, preExistingLocation?: { __typename?: 'Locations', maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }> } | undefined }> };

export type FetchJobLeadsSubscriptionSubscriptionVariables = Exact<{
  companyGuid: Scalars['uuid'];
  timeStart?: InputMaybe<Scalars['timestamptz']>;
  timeEnd?: InputMaybe<Scalars['timestamptz']>;
}>;


export type FetchJobLeadsSubscriptionSubscription = { __typename?: 'subscription_root', jobLeads: Array<{ __typename?: 'JobLeads', jobLeadGuid: string, contactFirstName?: string | undefined, contactLastName?: string | undefined, contactPhoneNumber?: string | undefined, contactEmailAddress?: string | undefined, serviceAddressLine1?: string | undefined, serviceAddressLine2?: string | undefined, serviceAddressCity?: string | undefined, serviceAddressStateAbbreviation?: string | undefined, serviceAddressZipCode?: string | undefined, accountType?: string | undefined, jobType?: string | undefined, requestType?: OnlineBookingServiceType | undefined, equipmentTypes?: JobLeadEquipmentTypeArray | undefined, estimateType?: JobLeadEstimateType | undefined, appointmentAvailabilities?: object | undefined, additionalMetadata?: JobLeadAdditionalMetadata | undefined, createdAt: IsoDateString, jobSummary?: string | undefined, leadSource?: string | undefined, jobLeadStatus: JobLeadStatus, jobGuid?: string | undefined, maintenancePlanVisitGuid?: string | undefined, originatingPlatformUrl?: string | undefined, originatingPlatformLabel?: string | undefined, submittedJobType?: { __typename?: 'JobTypes', jobTypeGuid: string, name: string } | undefined, job?: { __typename?: 'Jobs', displayId: number, createdAt: IsoDateString, jobType: { __typename?: 'JobTypes', name: string }, account: { __typename?: 'Accounts', accountGuid: string, accountDisplayName: string }, location: { __typename?: 'Locations', maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }> } } | undefined, preExistingLocation?: { __typename?: 'Locations', maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }> } | undefined }> };

export type FetchJobLeadByJobLeadGuidQueryVariables = Exact<{
  jobLeadGuid: Scalars['uuid'];
}>;


export type FetchJobLeadByJobLeadGuidQuery = { __typename?: 'query_root', jobLeads: Array<{ __typename?: 'JobLeads', jobLeadGuid: string, contactFirstName?: string | undefined, contactLastName?: string | undefined, contactPhoneNumber?: string | undefined, contactEmailAddress?: string | undefined, serviceAddressLine1?: string | undefined, serviceAddressLine2?: string | undefined, serviceAddressCity?: string | undefined, serviceAddressStateAbbreviation?: string | undefined, serviceAddressZipCode?: string | undefined, accountType?: string | undefined, jobType?: string | undefined, requestType?: OnlineBookingServiceType | undefined, equipmentTypes?: JobLeadEquipmentTypeArray | undefined, estimateType?: JobLeadEstimateType | undefined, appointmentAvailabilities?: object | undefined, additionalMetadata?: JobLeadAdditionalMetadata | undefined, createdAt: IsoDateString, jobSummary?: string | undefined, leadSource?: string | undefined, jobLeadStatus: JobLeadStatus, jobGuid?: string | undefined, maintenancePlanVisitGuid?: string | undefined, originatingPlatformUrl?: string | undefined, originatingPlatformLabel?: string | undefined, submittedJobType?: { __typename?: 'JobTypes', jobTypeGuid: string, name: string } | undefined, job?: { __typename?: 'Jobs', displayId: number, createdAt: IsoDateString, jobType: { __typename?: 'JobTypes', name: string }, account: { __typename?: 'Accounts', accountGuid: string, accountDisplayName: string }, location: { __typename?: 'Locations', maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }> } } | undefined, preExistingLocation?: { __typename?: 'Locations', maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined }> } | undefined }> };

export type UpdateJobLeadStatusMutationVariables = Exact<{
  set?: InputMaybe<JobLeadsSetInput>;
  companyGuid: Scalars['uuid'];
  jobLeadGuid: Scalars['uuid'];
}>;


export type UpdateJobLeadStatusMutation = { __typename?: 'mutation_root', updateJobLeads?: { __typename?: 'JobLeadsMutationResponse', affectedRows: number } | undefined };

export type ConvertJobLeadMutationVariables = Exact<{
  jobLeadGuid: Scalars['uuid'];
  jobGuid: Scalars['uuid'];
}>;


export type ConvertJobLeadMutation = { __typename?: 'mutation_root', updateJobLeadsByPk?: { __typename: 'JobLeads' } | undefined };

export type FetchCountOfOpenJobLeadsByCompanySubscriptionVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchCountOfOpenJobLeadsByCompanySubscription = { __typename?: 'subscription_root', jobLeadsAggregate: { __typename?: 'JobLeadsAggregate', aggregate?: { __typename?: 'JobLeadsAggregateFields', count: number } | undefined } };

export type FetchCompanyLeadSourcesQueryVariables = Exact<{
  where: CompanyLeadSourcesBoolExp;
}>;


export type FetchCompanyLeadSourcesQuery = { __typename?: 'query_root', companyLeadSources: Array<{ __typename?: 'CompanyLeadSources', companyLeadSourceGuid: string }> };

export type JobsPageAllTagsQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type JobsPageAllTagsQueryQuery = { __typename?: 'query_root', tags: Array<{ __typename?: 'Tags', companyGuid: string, tagGuid: string, name: string, color: string }> };

export type JobsPageJobLifecyclesQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type JobsPageJobLifecyclesQueryQuery = { __typename?: 'query_root', jobLifecycles: Array<{ __typename?: 'JobLifecycles', sequence: Array<string>, lastModifiedBy: string, name: string, updatedAt: IsoDateString, companyGuid: string, createdAt: IsoDateString, description: string, jobLifecycleGuid: string, isArchived: boolean, jobLifecycleType: string, statuses: Array<{ __typename?: 'JobLifecycleStatuses', color: string, companyGuid: string, description: string, isDefault: boolean, isLeadWon: boolean, isWorkComplete: boolean, isFirstAppointmentBookedAutomationEnabled: boolean, isAllOutstandingAppointmentsAssignedAutomationEnabled: boolean, isTechnicianDispatchedAutomationEnabled: boolean, isTechnicianArrivesAtAppointmentAutomationEnabled: boolean, isAllAppointmentsCompletedAutomationEnabled: boolean, isCreateLinkedJobAutomationEnabled: boolean, isNoAdditionalWorkRequiredAutomationEnabled: boolean, isOnsiteWorkNotCompleteAutomationEnabled: boolean, jobLifecycleGuid: string, jobLifecycleStatusGuid: string, name: string, stage: JobLifecycleStage, specialStatus?: SpecialLifecycleStatus | undefined, jobsAggregate: { __typename?: 'JobsAggregate', aggregate?: { __typename?: 'JobsAggregateFields', count: number } | undefined } }> }> };

export type JobsPageV2CompanyUsersQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type JobsPageV2CompanyUsersQueryQuery = { __typename?: 'query_root', companyUsers: Array<{ __typename?: 'CompanyUsers', userByUserGuid: { __typename?: 'Users', userGuid: string, fullName: string } }> };

export type JobsPageV2CompanyUsersSingleQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
}>;


export type JobsPageV2CompanyUsersSingleQueryQuery = { __typename?: 'query_root', companyUsers: Array<{ __typename?: 'CompanyUsers', userByUserGuid: { __typename?: 'Users', userGuid: string, fullName: string } }> };

export type JobPageV2CompanyConfigQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type JobPageV2CompanyConfigQueryQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', companyGuid: string, accountManagerEnabled: boolean } | undefined };

export type ChangeJobPipelineCardSelectJobTypeWithJobLifecycleQueryQueryVariables = Exact<{
  jobTypeGuid: Scalars['uuid'];
}>;


export type ChangeJobPipelineCardSelectJobTypeWithJobLifecycleQueryQuery = { __typename?: 'query_root', jobTypesByPk?: { __typename?: 'JobTypes', jobLifecycle: { __typename?: 'JobLifecycles', name: string, jobLifecycleGuid: string, sequence: Array<string>, jobLifecycleStatuses: Array<{ __typename?: 'JobLifecycleStatuses', jobLifecycleStatusGuid: string, name: string }> } } | undefined };

export type JobTypeSettingsListPageJobTypeArchiveMutationMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  jobTypeGuid: Scalars['uuid'];
  archivedAt: Scalars['timestamptz'];
}>;


export type JobTypeSettingsListPageJobTypeArchiveMutationMutation = { __typename?: 'mutation_root', updateJobTypes?: { __typename?: 'JobTypesMutationResponse', affectedRows: number } | undefined };

export type JobTypeSettingsListPageJobTypeUnarchiveMutationMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  jobTypeGuid: Scalars['uuid'];
  unarchivedAt: Scalars['timestamptz'];
}>;


export type JobTypeSettingsListPageJobTypeUnarchiveMutationMutation = { __typename?: 'mutation_root', updateJobTypes?: { __typename?: 'JobTypesMutationResponse', affectedRows: number } | undefined };

export type FetchJobTypesSettingsJobTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchJobTypesSettingsJobTypeQuery = { __typename?: 'query_root', jobTypes: Array<{ __typename?: 'JobTypes', name: string, description: string, defaultSummary?: string | undefined, hideJobSummaryField?: boolean | undefined, isIncludedInJobCosting: boolean, defaultBusinessUnitGuid?: string | undefined, companyGuid: string, lastModifiedBy: string, jobTypeGuid: string, jobLifecycleGuid: string, jobClass: JobClassesEnum, createdAt: IsoDateString, updatedAt: IsoDateString, isOpportunity: boolean, opportunityConversionThresholdUsc?: number | undefined, isPotentialHotLead: boolean, hotLeadMinimumEquipmentAgeYears?: number | undefined, archivedAt?: IsoDateString | undefined, durationMinutes: number, color?: string | undefined, jobLifecycle: { __typename?: 'JobLifecycles', name: string, jobLifecycleGuid: string }, jobsAggregate: { __typename?: 'JobsAggregate', aggregate?: { __typename?: 'JobsAggregateFields', count: number } | undefined } }> };

export type LeadSourcesSettingsPageLeadSourcesQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type LeadSourcesSettingsPageLeadSourcesQueryQuery = { __typename?: 'query_root', activeCompanyLeadSources: Array<{ __typename?: 'CompanyLeadSources', canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined, ordinal?: string | undefined, companyLeadSourceGuid: string, companyLeadSourceLinksAggregate: { __typename?: 'CompanyLeadSourceLinksAggregate', aggregate?: { __typename?: 'CompanyLeadSourceLinksAggregateFields', count: number } | undefined } }>, archivedCompanyLeadSources: Array<{ __typename?: 'CompanyLeadSources', canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined, ordinal?: string | undefined, companyLeadSourceGuid: string, companyLeadSourceLinksAggregate: { __typename?: 'CompanyLeadSourceLinksAggregate', aggregate?: { __typename?: 'CompanyLeadSourceLinksAggregateFields', count: number } | undefined } }> };

export type LeadSourcesSettingsPageCanonicalLeadSourcesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type LeadSourcesSettingsPageCanonicalLeadSourcesQueryQuery = { __typename?: 'query_root', canonicalLeadSources: Array<{ __typename?: 'CanonicalLeadSources', canonicalLeadSourceName: string, attributionLinkingStrategy: AttributionLinkingStrategy, attributionPrompt?: string | undefined }> };

export type LeadSourcesSettingsPageUpsertLeadSourceMutationMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  companyLeadSourceGuid: Scalars['uuid'];
  canonicalLeadSourceName: Scalars['String'];
  canonicalLeadSourceNameOverride?: InputMaybe<Scalars['String']>;
  attributionPromptOverride?: InputMaybe<Scalars['String']>;
  attributionLinkingStrategyOverride?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type LeadSourcesSettingsPageUpsertLeadSourceMutationMutation = { __typename?: 'mutation_root', insertCompanyLeadSources?: { __typename?: 'CompanyLeadSourcesMutationResponse', affectedRows: number } | undefined };

export type LeadSourcesSettingsPageLeadSourcesSingleQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  companyLeadSourceGuid: Scalars['uuid'];
}>;


export type LeadSourcesSettingsPageLeadSourcesSingleQueryQuery = { __typename?: 'query_root', companyLeadSources: Array<{ __typename?: 'CompanyLeadSources', canonicalLeadSourceNameOverride?: string | undefined, attributionPromptOverride?: string | undefined, attributionLinkingStrategyOverride?: string | undefined, archivedAt?: IsoDateString | undefined, canonicalLeadSource: { __typename?: 'CanonicalLeadSources', canonicalLeadSourceName: string, attributionLinkingStrategy: AttributionLinkingStrategy, attributionPrompt?: string | undefined } }> };

export type CheckIfCompanyHasActiveMaintenancePlansQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type CheckIfCompanyHasActiveMaintenancePlansQuery = { __typename?: 'query_root', maintenancePlansQueryable: Array<{ __typename?: 'MaintenancePlansQueryable', status: MaintenancePlanStatus }> };

export type FetchCompanyMaintenancePlansEnabledQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchCompanyMaintenancePlansEnabledQuery = { __typename?: 'query_root', companyConfig: Array<{ __typename?: 'CompanyConfig', maintenancePlansEnabled: boolean }> };

export type UpsertCompanyBillingProfileRenewalTypesMutationVariables = Exact<{
  object: BillingProfilesInsertInput;
}>;


export type UpsertCompanyBillingProfileRenewalTypesMutation = { __typename?: 'mutation_root', insertBillingProfilesOne?: { __typename: 'BillingProfiles' } | undefined };

export type UpsertCompanyBillingProfileFixedPlanDurationsMutationVariables = Exact<{
  object: BillingProfilesInsertInput;
}>;


export type UpsertCompanyBillingProfileFixedPlanDurationsMutation = { __typename?: 'mutation_root', insertBillingProfilesOne?: { __typename: 'BillingProfiles' } | undefined };

export type MaintenancePlanCollapsiblesQueryQueryVariables = Exact<{
  paymentWhereClause?: InputMaybe<PaymentRecordsBoolExp>;
  jobsWhereClause?: InputMaybe<JobsBoolExp>;
  appointmentsWhereClause?: InputMaybe<JobAppointmentsBoolExp>;
}>;


export type MaintenancePlanCollapsiblesQueryQuery = { __typename?: 'query_root', paymentRecords: Array<{ __typename?: 'PaymentRecords', amountUsd: number, occurredAt: IsoDateString, paymentMethod: PaymentMethod, externalPaymentId?: string | undefined, paymentMethodAdditionalInfo?: string | undefined, shouldSendReceipt?: boolean | undefined, doNotSyncToAccountingServiceReason?: string | undefined, accountGuid: string, guid: string, referenceNumber: string, account?: { __typename?: 'Accounts', accountDisplayName: string } | undefined, paymentStatusesAggregate: { __typename?: 'PaymentStatusesAggregate', nodes: Array<{ __typename?: 'PaymentStatuses', paymentStatus: PaymentStatusTypesEnum }> }, links?: { __typename?: 'PaymentLinks', jobGuid?: string | undefined, jobAppointmentGuid?: string | undefined, jobAppointmentAssignmentGuid?: string | undefined, collectedByUserGuid?: string | undefined, loanRecord?: { __typename?: 'WisetackLoanRecords', wisetackLoanRecordGuid: string, accountGuid: string, companyGuid: string, invoiceGuid: string, contactGuid: string, jobGuid?: string | undefined, wisetackMerchantGuid: string, wisetackTransactionGuid: string, requestedLoanAmountUsc: number, approvedLoanAmountUsc?: number | undefined, settledLoanAmountUsc?: number | undefined, processingFeeUsc?: number | undefined, createdAt?: IsoDateString | undefined, updatedAt?: IsoDateString | undefined, expiresAt?: IsoDateString | undefined, loanApplicationLink: string, wisetackLoanStatuses: Array<{ __typename?: 'WisetackLoanStatuses', loanStatus: WisetackLoanStatusTypesEnum, loanStatusDetail?: string | undefined, occurredAt: IsoDateString, createdAt?: IsoDateString | undefined }>, contact: { __typename?: 'Contacts', fullName: string } } | undefined } | undefined, invoicePayments: Array<{ __typename?: 'InvoicePayments', invoiceGuid: string, appliedAmountUsc: number, invoice: { __typename?: 'Invoices', displayIdV2: string } }> }>, jobs: Array<{ __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobCreatedAt: IsoDateString, jobType: { __typename?: 'JobTypes', name: string }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string, color: string }, appointments: Array<{ __typename?: 'JobAppointments', appointmentType: AppointmentType, appointmentWindowStart: IsoDateString, appointmentWindowEnd: IsoDateString, jobAppointmentGuid: string }> }>, jobAppointments: Array<{ __typename?: 'JobAppointments', appointmentReferenceNumber: string, appointmentWindowEnd: IsoDateString, appointmentWindowStart: IsoDateString, jobAppointmentGuid: string, appointmentType: AppointmentType, description?: string | undefined, descriptionHtml?: HtmlString | undefined, endOfAppointmentNextSteps?: object | undefined, sendConfirmationEnabled: boolean, notificationType: AppointmentNotificationType, sendConfirmationTo?: string | undefined, confirmationLastSentAt?: IsoDateString | undefined, sendReminderEnabled: boolean, reminderLastSentAt?: IsoDateString | undefined, job: { __typename?: 'Jobs', jobGuid: string, displayId: number, jobType: { __typename?: 'JobTypes', jobClass: JobClassesEnum, name: string }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string } } }, assignments: Array<{ __typename?: 'JobAppointmentAssignments', assignmentStart: IsoDateString, assignmentEnd: IsoDateString, jobAppointmentAssignmentGuid: string, assignmentStatus?: { __typename?: 'JobAppointmentAssignmentStatuses', jobAppointmentAssignmentStatusGuid: string, jobAppointmentAssignmentStatusType: JobAppointmentAssignmentStatusTypesEnum, createdAt: IsoDateString } | undefined, technician: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string } }>, cancellationStatus?: { __typename?: 'JobAppointmentCancellationStatuses', canceled: boolean, createdAt: IsoDateString, updatedAt: IsoDateString } | undefined, confirmationStatus?: { __typename?: 'JobAppointmentConfirmationStatuses', confirmed: boolean, createdAt: IsoDateString, updatedAt: IsoDateString } | undefined }> };

export type ExpireVisitMutationVariables = Exact<{
  visitGuid: Scalars['uuid'];
  isExpiredOverride: Scalars['Boolean'];
}>;


export type ExpireVisitMutation = { __typename?: 'mutation_root', updateMaintenancePlanVisits?: { __typename?: 'MaintenancePlanVisitsMutationResponse', affectedRows: number } | undefined };

export type RestoreVisitMutationVariables = Exact<{
  visitGuid: Scalars['uuid'];
  expiresAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type RestoreVisitMutation = { __typename?: 'mutation_root', updateMaintenancePlanVisits?: { __typename?: 'MaintenancePlanVisitsMutationResponse', affectedRows: number } | undefined };

export type MaintenancePlanInvoiceQueryVariables = Exact<{
  maintenancePlanGuid: Scalars['uuid'];
}>;


export type MaintenancePlanInvoiceQuery = { __typename?: 'query_root', maintenancePlanInvoices: Array<{ __typename?: 'MaintenancePlanInvoices', invoiceGuid: string }> };

export type MaintenancePlanNextVisitFragment = { __typename?: 'MaintenancePlanNextVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitNumber?: number | undefined, visitReminderLastSentAt?: IsoDateString | undefined, status?: string | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> };

export type MaintenancePlansListPageFragmentFragment = { __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, status: MaintenancePlanStatus, companyGuid: string, paymentAmountUsc: number, yearlyPriceUsc: number, pricebookTaxRateGuid?: string | undefined, locationGuid: string, paymentInterval: MaintenancePlanPaymentInterval, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, activatedAt?: IsoDateString | undefined, scheduledActivationAt?: IsoDateString | undefined, billingStartAt?: IsoDateString | undefined, lapsedAt?: IsoDateString | undefined, terminatesAt?: IsoDateString | undefined, visitReplenishmentAnchorOverride?: LocalDateString | undefined, accountGuid: string, paymentSubscriptionGuid?: string | undefined, numUnusedVisits: number, soldByUser?: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string, userPrimaryHueHex?: string | undefined, deactivatedAt?: IsoDateString | undefined, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }> } | undefined, account: { __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, accountContacts: Array<{ __typename?: 'AccountContacts', primary: boolean, contact: { __typename?: 'Contacts', fullName: string, notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', type: PhoneNumberType, phoneNumber: string, unsubscribed: boolean } | undefined } }>, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', name: string } }> }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string } }, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', numDaysUntilVisitCreditExpiration: number, marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined, maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }>, nextVisit?: { __typename?: 'MaintenancePlanNextVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitNumber?: number | undefined, visitReminderLastSentAt?: IsoDateString | undefined, status?: string | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> } | undefined };

export type MaintenancePlanListPageDataQueryVariables = Exact<{
  where: MaintenancePlansQueryableBoolExp;
  orderBy: Array<MaintenancePlansQueryableOrderBy> | MaintenancePlansQueryableOrderBy;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type MaintenancePlanListPageDataQuery = { __typename?: 'query_root', maintenancePlansQueryable: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, status: MaintenancePlanStatus, companyGuid: string, paymentAmountUsc: number, yearlyPriceUsc: number, pricebookTaxRateGuid?: string | undefined, locationGuid: string, paymentInterval: MaintenancePlanPaymentInterval, paymentFlow: MaintenancePlanPaymentFlowTypesEnum, activatedAt?: IsoDateString | undefined, scheduledActivationAt?: IsoDateString | undefined, billingStartAt?: IsoDateString | undefined, lapsedAt?: IsoDateString | undefined, terminatesAt?: IsoDateString | undefined, visitReplenishmentAnchorOverride?: LocalDateString | undefined, accountGuid: string, paymentSubscriptionGuid?: string | undefined, numUnusedVisits: number, soldByUser?: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string, userPrimaryHueHex?: string | undefined, deactivatedAt?: IsoDateString | undefined, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }> } | undefined, account: { __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, accountContacts: Array<{ __typename?: 'AccountContacts', primary: boolean, contact: { __typename?: 'Contacts', fullName: string, notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', type: PhoneNumberType, phoneNumber: string, unsubscribed: boolean } | undefined } }>, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', name: string } }> }, location: { __typename?: 'Locations', locationGuid: string, address: { __typename?: 'Addresses', line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string } }, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', numDaysUntilVisitCreditExpiration: number, marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined, flare?: { __typename?: 'MaintenancePlanDefinitionFlare', primaryColorHex: string } | undefined } | undefined, maintenancePlanVisits: Array<{ __typename?: 'MaintenancePlanVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitReminderLastSentAt?: IsoDateString | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> }>, nextVisit?: { __typename?: 'MaintenancePlanNextVisits', maintenancePlanVisitGuid: string, maintenancePlanGuid: string, affinityDate?: LocalDateString | undefined, companyGuid: string, completedAtOverride?: IsoDateString | undefined, dueAt: IsoDateString, expiresAt: IsoDateString, isExpiredOverride?: boolean | undefined, isCompletedOverride?: boolean | undefined, issuedAt: IsoDateString, jobGuid?: string | undefined, name: string, visitNote?: string | undefined, visitNumber?: number | undefined, visitReminderLastSentAt?: IsoDateString | undefined, status?: string | undefined, job?: { __typename?: 'Jobs', jobGuid: string, displayId: number, workCompletedAt?: IsoDateString | undefined, jobType: { __typename?: 'JobTypes', name: string }, appointments: Array<{ __typename?: 'JobAppointments', jobAppointmentGuid: string }>, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', specialStatus?: SpecialLifecycleStatus | undefined } } | undefined, maintenancePlanVisitInstalledEquipments: Array<{ __typename?: 'MaintenancePlanVisitInstalledEquipments', installedEquipment: { __typename?: 'InstalledEquipment', manufacturer?: string | undefined, installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined, estimatedEndOfLifeDate?: LocalDateString | undefined, averageLifeExpectancyYears?: number | undefined, modelNumber?: string | undefined, serialNumber?: string | undefined } }> } | undefined }>, maintenancePlansQueryableAggregate: { __typename?: 'MaintenancePlansQueryableAggregate', aggregate?: { __typename?: 'MaintenancePlansQueryableAggregateFields', count: number } | undefined } };

export type MaintenancePlanActivePlansSummaryQueryVariables = Exact<{
  where: MaintenancePlansQueryableBoolExp;
}>;


export type MaintenancePlanActivePlansSummaryQuery = { __typename?: 'query_root', maintenancePlansQueryableAggregate: { __typename?: 'MaintenancePlansQueryableAggregate', aggregate?: { __typename?: 'MaintenancePlansQueryableAggregateFields', count: number } | undefined } };

export type MaintenancePlanYearlyPriceSummaryQueryVariables = Exact<{
  where: MaintenancePlansQueryableBoolExp;
}>;


export type MaintenancePlanYearlyPriceSummaryQuery = { __typename?: 'query_root', maintenancePlansQueryableAggregate: { __typename?: 'MaintenancePlansQueryableAggregate', aggregate?: { __typename?: 'MaintenancePlansQueryableAggregateFields', sum?: { __typename?: 'MaintenancePlansQueryableSumFields', yearlyPriceUsc?: number | undefined } | undefined } | undefined } };

export type MaintenancePlanOverdueVisitsSummaryQueryVariables = Exact<{
  where: MaintenancePlansQueryableBoolExp;
}>;


export type MaintenancePlanOverdueVisitsSummaryQuery = { __typename?: 'query_root', maintenancePlansQueryableAggregate: { __typename?: 'MaintenancePlansQueryableAggregate', aggregate?: { __typename?: 'MaintenancePlansQueryableAggregateFields', sum?: { __typename?: 'MaintenancePlansQueryableSumFields', numOverdueVisits?: number | undefined } | undefined } | undefined } };

export type CompanyMaintenancePlanTypesQueryVariables = Exact<{
  where: MaintenancePlanDefinitionsBoolExp;
}>;


export type CompanyMaintenancePlanTypesQuery = { __typename?: 'query_root', maintenancePlanDefinitions: Array<{ __typename?: 'MaintenancePlanDefinitions', maintenancePlanDefinitionGuid: string, marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined }> };

export type CompanyUsersForMaintenancePlansListPageQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type CompanyUsersForMaintenancePlansListPageQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', firstName: string, lastName: string }> };

export type UpsertOnlineBookingServiceTypeConfigMutationVariables = Exact<{
  onlineBookingServiceTypeGuid: Scalars['uuid'];
  config: OnlineBookingServiceTypeConfigsInsertInput;
  onConflict?: InputMaybe<OnlineBookingServiceTypeConfigsOnConflict>;
}>;


export type UpsertOnlineBookingServiceTypeConfigMutation = { __typename?: 'mutation_root', deleteOnlineBookingServiceTypeBookableJobTypes?: { __typename: 'OnlineBookingServiceTypeBookableJobTypesMutationResponse' } | undefined, deleteOnlineBookingServiceTypeBookableTechnicians?: { __typename: 'OnlineBookingServiceTypeBookableTechniciansMutationResponse' } | undefined, deleteInstantBookingWeeklyScheduleEntries?: { __typename: 'InstantBookingWeeklyScheduleEntriesMutationResponse' } | undefined, insertOnlineBookingServiceTypeConfigsOne?: { __typename: 'OnlineBookingServiceTypeConfigs' } | undefined };

export type UpsertOnlineBookingConfigMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  config: OnlineBookingCompanyConfigInsertInput;
  onConflict?: InputMaybe<OnlineBookingCompanyConfigOnConflict>;
}>;


export type UpsertOnlineBookingConfigMutation = { __typename?: 'mutation_root', deleteOnlineBookingServiceAreaZipCodes?: { __typename: 'OnlineBookingServiceAreaZipCodesMutationResponse' } | undefined, insertOnlineBookingCompanyConfigOne?: { __typename: 'OnlineBookingCompanyConfig' } | undefined };

export type FetchOnlineBookingCompanyConfigQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchOnlineBookingCompanyConfigQuery = { __typename?: 'query_root', companiesByPk?: { __typename?: 'Companies', onlineBookingCompanyConfig?: { __typename?: 'OnlineBookingCompanyConfig', limitBookingsToServiceAreaEnabled: boolean, brandingColorHex: string, afterHoursBannerHtml?: HtmlString | undefined, serviceAreaZipCodes: Array<{ __typename?: 'OnlineBookingServiceAreaZipCodes', zipCode: string }> } | undefined, onlineBookingServiceTypeConfigs: Array<{ __typename?: 'OnlineBookingServiceTypeConfigs', serviceType: OnlineBookingServiceType, bookingType: OnlineBookingType, onlineBookingServiceTypeGuid: string, updatedAt: IsoDateString }> } | undefined };

export type FetchOnlineBookingServiceTypeConfigQueryVariables = Exact<{
  onlineServiceTypeConfigGuid: Scalars['uuid'];
}>;


export type FetchOnlineBookingServiceTypeConfigQuery = { __typename?: 'query_root', onlineBookingServiceTypeConfigsByPk?: { __typename?: 'OnlineBookingServiceTypeConfigs', onlineBookingServiceTypeGuid: string, companyGuid: string, serviceType: OnlineBookingServiceType, bookingType: OnlineBookingType, assignmentType: InstantBookingAssignmentType, earliestAvailability: OnlineBookingEarliestAvailableTime, latestAvailability: OnlineBookingLatestAvailableTime, legalBlurbHtml?: HtmlString | undefined, bookableJobTypes: Array<{ __typename?: 'OnlineBookingServiceTypeBookableJobTypes', jobTypeGuid: string }>, bookableTechnicians: Array<{ __typename?: 'OnlineBookingServiceTypeBookableTechnicians', technicianGuid: string, seq: number }>, instantBookingWeeklyScheduleEntries: Array<{ __typename?: 'InstantBookingWeeklyScheduleEntries', dayOfWeek: DayOfTheWeek, isEnabled: boolean, bookableArrivalWindows: Array<{ __typename?: 'InstantBookingWeeklyScheduleEntryBookableArrivalWindows', arrivalWindow: { __typename?: 'CompanyAppointmentArrivalWindows', companyAppointmentArrivalWindowGuid: string, arrivalWindowStartTime: LocalTimeString, arrivalWindowEndTime: LocalTimeString } }> }>, company: { __typename?: 'Companies', companyUsers: Array<{ __typename?: 'CompanyUsers', userByUserGuid: { __typename?: 'Users', userGuid: string, fullName: string, deactivatedAt?: IsoDateString | undefined, userRoles: Array<{ __typename?: 'UserRoles', roleById: { __typename?: 'CompanyRoles', role: RoleId } }> } }>, companyAppointmentArrivalWindows: Array<{ __typename?: 'CompanyAppointmentArrivalWindows', companyAppointmentArrivalWindowGuid: string, jobClass: JobClass, arrivalWindowStartTime: LocalTimeString, arrivalWindowEndTime: LocalTimeString }>, jobTypes: Array<{ __typename?: 'JobTypes', jobTypeGuid: string, jobClass: JobClassesEnum, name: string }> } } | undefined };

export type PaymentsListPageCompanyConfigQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type PaymentsListPageCompanyConfigQueryQuery = { __typename?: 'query_root', companyConfigByPk?: { __typename?: 'CompanyConfig', customerNumberEnabled: boolean } | undefined };

export type FetchCompanyIntegratedPhonesQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchCompanyIntegratedPhonesQuery = { __typename?: 'query_root', integratedPhones: Array<{ __typename?: 'IntegratedPhones', integratedPhoneGuid: string, phoneNumber: string, phoneProvider: string, companyLeadSourceGuid?: string | undefined, primaryOutboundSms: boolean, createdAt: IsoDateString, companyLeadSource?: { __typename?: 'CompanyLeadSources', canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined } | undefined }> };

export type FetchCompanyPhoneConfigQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchCompanyPhoneConfigQuery = { __typename?: 'query_root', integratedPhoneCompanyConfig: Array<{ __typename?: 'IntegratedPhoneCompanyConfig', integratedPhoneEnabled: boolean, integratedVoiceCallingEnabled: boolean, integratedPhoneCompanyConfigGuid: string, fallbackShouldRecordVoicemail?: boolean | undefined, fallbackForwardToPhoneNumber?: string | undefined, fallbackHangupMessage?: string | undefined }> };

export type UpdatePhoneLeadSourceMutationVariables = Exact<{
  phoneGuid: Scalars['uuid'];
  leadSourceGuid?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdatePhoneLeadSourceMutation = { __typename?: 'mutation_root', updateIntegratedPhonesByPk?: { __typename?: 'IntegratedPhones', integratedPhoneGuid: string, companyLeadSourceGuid?: string | undefined } | undefined };

export type UpdatePrimaryOutboundSmsPhoneMutationVariables = Exact<{
  phoneGuid: Scalars['uuid'];
  companyGuid: Scalars['uuid'];
}>;


export type UpdatePrimaryOutboundSmsPhoneMutation = { __typename?: 'mutation_root', updateIntegratedPhones?: { __typename?: 'IntegratedPhonesMutationResponse', affectedRows: number } | undefined, updateIntegratedPhonesByPk?: { __typename?: 'IntegratedPhones', integratedPhoneGuid: string, primaryOutboundSms: boolean } | undefined };

export type UpdateCompanyPhoneConfigMutationVariables = Exact<{
  object: IntegratedPhoneCompanyConfigInsertInput;
}>;


export type UpdateCompanyPhoneConfigMutation = { __typename?: 'mutation_root', insertIntegratedPhoneCompanyConfigOne?: { __typename?: 'IntegratedPhoneCompanyConfig', integratedPhoneCompanyConfigGuid: string, integratedPhoneEnabled: boolean, integratedVoiceCallingEnabled: boolean, fallbackShouldRecordVoicemail?: boolean | undefined, fallbackForwardToPhoneNumber?: string | undefined, fallbackHangupMessage?: string | undefined } | undefined };

export type CreateIntegratedPhoneMutationVariables = Exact<{
  object: IntegratedPhonesInsertInput;
}>;


export type CreateIntegratedPhoneMutation = { __typename?: 'mutation_root', insertIntegratedPhonesOne?: { __typename?: 'IntegratedPhones', integratedPhoneGuid: string, phoneNumber: string, phoneProvider: string, companyGuid: string, companyLeadSourceGuid?: string | undefined, primaryOutboundSms: boolean, createdAt: IsoDateString } | undefined };

export type ReadonlyCustomFormPageQueryVariables = Exact<{
  appointmentChecklistInstanceId: Scalars['uuid'];
}>;


export type ReadonlyCustomFormPageQuery = { __typename?: 'query_root', appointmentChecklistInstancesByPk?: { __typename?: 'AppointmentChecklistInstances', checklist: AppointmentChecklistInstanceChecklist } | undefined };

export type ReadUpcomingAppointmentsQueryVariables = Exact<{
  endWindow: Scalars['timestamptz'];
  startWindow: Scalars['timestamptz'];
}>;


export type ReadUpcomingAppointmentsQuery = { __typename?: 'query_root', jobAppointments: Array<{ __typename?: 'JobAppointments', appointmentReferenceNumber: string, appointmentWindowEnd: IsoDateString, appointmentWindowStart: IsoDateString, appointmentType: AppointmentType, endOfAppointmentNextSteps?: object | undefined, sendConfirmationEnabled: boolean, notificationType: AppointmentNotificationType, sendConfirmationTo?: string | undefined, confirmationLastSentAt?: IsoDateString | undefined, sendReminderEnabled: boolean, reminderLastSentAt?: IsoDateString | undefined, description?: string | undefined, appointmentGuid: string, assignments: Array<{ __typename?: 'JobAppointmentAssignments', assignmentStart: IsoDateString, assignmentEnd: IsoDateString, assignmentGuid: string, assignmentStatus?: { __typename?: 'JobAppointmentAssignmentStatuses', jobAppointmentAssignmentStatusType: JobAppointmentAssignmentStatusTypesEnum } | undefined, technician: { __typename?: 'Users', deactivatedAt?: IsoDateString | undefined, firstName: string, lastName: string, userGuid: string, emailAddress: string, roles: Array<{ __typename?: 'UserRoles', role: RoleId }>, phoneNumbers: Array<{ __typename?: 'UserPhoneNumbers', phoneNumber: { __typename?: 'PhoneNumbers', companyGuid: string, phoneNumber: string, phoneNumberGuid: string, type: PhoneNumberType } }> } }>, job: { __typename?: 'Jobs', jobGuid: string, accountGuid: string, displayId: number, equipmentTypeJobLinks: Array<{ __typename?: 'EquipmentTypeLinks', estimatedEquipmentAge?: string | undefined, equipmentType: EquipmentType, relationshipType: JobToEquipmentRelationshipType, equipmentTypeName: { __typename?: 'EquipmentTypes', name: string } }>, jobType: { __typename?: 'JobTypes', name: string, jobTypeGuid: string, jobClass: JobClassesEnum, jobLifecycleGuid: string, durationMinutes: number, isIncludedInJobCosting: boolean }, account: { __typename?: 'Accounts', accountDisplayName: string }, location: { __typename?: 'Locations', locationGuid: string, propertyType: string, address: { __typename?: 'Addresses', addressGuid: string, canonicalFullAddress: string, city: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string, geoLocation: Geo } }, pointOfContact: { __typename?: 'Contacts', firstName: string, lastName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, type: PhoneNumberType } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } }, cancellationStatus?: { __typename?: 'JobAppointmentCancellationStatuses', canceled: boolean } | undefined, confirmationStatus?: { __typename?: 'JobAppointmentConfirmationStatuses', confirmed: boolean } | undefined }> };

export type NumberOfInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type NumberOfInvoicesQuery = { __typename?: 'query_root', invoicesAggregate: { __typename?: 'InvoicesAggregate', aggregate?: { __typename?: 'InvoicesAggregateFields', count: number } | undefined } };

export type InvoicesByLeadSourceReportQueryVariables = Exact<{
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type InvoicesByLeadSourceReportQuery = { __typename?: 'query_root', invoices: Array<{ __typename?: 'Invoices', displayId: number, issuedAt?: IsoDateString | undefined, appliedAmountUscSum: { __typename?: 'InvoicePaymentsAggregate', aggregate?: { __typename?: 'InvoicePaymentsAggregateFields', sum?: { __typename?: 'InvoicePaymentsSumFields', appliedAmountUsc?: number | undefined } | undefined } | undefined }, mostRecentInvoicePayment: Array<{ __typename?: 'InvoicePayments', paymentRecord: { __typename?: 'PaymentRecords', occurredAt: IsoDateString } }>, jobLink?: { __typename?: 'JobInvoices', job: { __typename?: 'Jobs', displayId: number, location: { __typename?: 'Locations', address: { __typename?: 'Addresses', city: string, line1: string, line2?: string | undefined, stateAbbreviation: string, zipCode: string } }, pointOfContact: { __typename?: 'Contacts', fullName: string }, jobLeadSource: Array<{ __typename?: 'CompanyLeadSourceLinks', companyLeadSource: { __typename?: 'CompanyLeadSources', canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined } }> } } | undefined }> };

export type TeamPerformanceJobFragmentFragment = { __typename?: 'Jobs', jobGuid: string, createdAt: IsoDateString, workCompletedAt?: IsoDateString | undefined, isOpportunity: boolean, isConverted?: boolean | undefined, isHotLead: boolean, isMembershipOpportunity: boolean, isMembershipRenewalOpportunity: boolean, isMembershipSold?: boolean | undefined, jobType: { __typename?: 'JobTypes', jobTypeGuid: string, jobClass: JobClassesEnum }, jobTeamMembers: Array<{ __typename?: 'JobTeamMembers', userGuid: string, turnedOverJob?: boolean | undefined }>, maintenancePlan?: { __typename?: 'MaintenancePlansQueryable', yearlyPriceUsc: number } | undefined, estimates: Array<{ __typename?: 'Estimates', status: EstimateV2Status, estimateOptions: Array<{ __typename?: 'EstimateOptions', isSelected: boolean, totalUsc: number }> }>, jobTechnicianEarnedRevenueSummaries: Array<{ __typename?: 'JobTechnicianEarnedRevenueSummaries', technicianUserGuid?: string | undefined, totalEarnedRevenueUsc?: number | undefined }>, jobTechnicianSoldRevenueSummaries: Array<{ __typename?: 'JobTechnicianSoldRevenueSummaries', technicianUserGuid?: string | undefined, totalSoldRevenueUsc?: number | undefined }>, jobFullyPaidInvoicesV2Summary?: { __typename?: 'JobsFullyPaidInvoicesV2SummaryMv', totalInvoicedAmountUsc?: number | undefined, totalPaidAmountUsd?: number | undefined, totalSubtotalAmountUsc?: number | undefined, totalDiscountAmountUsc?: number | undefined, totalTaxAmountUsc?: number | undefined } | undefined, jobAppointmentAssignments: Array<{ __typename?: 'JobAppointmentAssignments', technicianUserGuid: string, jobAppointment: { __typename?: 'JobAppointments', jobAppointmentInvoices: Array<{ __typename?: 'JobAppointmentInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, subtotalUsc: number, status: InvoiceV2Status } }> } }> };

export type TeamPerformanceDashboardMetricsQueryVariables = Exact<{
  where: JobsBoolExp;
}>;


export type TeamPerformanceDashboardMetricsQuery = { __typename?: 'query_root', jobs: Array<{ __typename?: 'Jobs', jobGuid: string, createdAt: IsoDateString, workCompletedAt?: IsoDateString | undefined, isOpportunity: boolean, isConverted?: boolean | undefined, isHotLead: boolean, isMembershipOpportunity: boolean, isMembershipRenewalOpportunity: boolean, isMembershipSold?: boolean | undefined, jobType: { __typename?: 'JobTypes', jobTypeGuid: string, jobClass: JobClassesEnum }, jobTeamMembers: Array<{ __typename?: 'JobTeamMembers', userGuid: string, turnedOverJob?: boolean | undefined }>, maintenancePlan?: { __typename?: 'MaintenancePlansQueryable', yearlyPriceUsc: number } | undefined, estimates: Array<{ __typename?: 'Estimates', status: EstimateV2Status, estimateOptions: Array<{ __typename?: 'EstimateOptions', isSelected: boolean, totalUsc: number }> }>, jobTechnicianEarnedRevenueSummaries: Array<{ __typename?: 'JobTechnicianEarnedRevenueSummaries', technicianUserGuid?: string | undefined, totalEarnedRevenueUsc?: number | undefined }>, jobTechnicianSoldRevenueSummaries: Array<{ __typename?: 'JobTechnicianSoldRevenueSummaries', technicianUserGuid?: string | undefined, totalSoldRevenueUsc?: number | undefined }>, jobFullyPaidInvoicesV2Summary?: { __typename?: 'JobsFullyPaidInvoicesV2SummaryMv', totalInvoicedAmountUsc?: number | undefined, totalPaidAmountUsd?: number | undefined, totalSubtotalAmountUsc?: number | undefined, totalDiscountAmountUsc?: number | undefined, totalTaxAmountUsc?: number | undefined } | undefined, jobAppointmentAssignments: Array<{ __typename?: 'JobAppointmentAssignments', technicianUserGuid: string, jobAppointment: { __typename?: 'JobAppointments', jobAppointmentInvoices: Array<{ __typename?: 'JobAppointmentInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, subtotalUsc: number, status: InvoiceV2Status } }> } }> }> };

export type UnpaidInvoicesV2QueryVariables = Exact<{
  where?: InputMaybe<AggregatableInvoicesBoolExp>;
}>;


export type UnpaidInvoicesV2Query = { __typename?: 'query_root', aggregatableInvoices: Array<{ __typename?: 'AggregatableInvoices', invoiceGuid: string, displayIdV2?: string | undefined, dueUsc?: number | undefined, dueAt?: IsoDateString | undefined, paidUsc?: number | undefined, totalUsc: number, invoice?: { __typename?: 'Invoices', billingContact: { __typename?: 'Contacts', fullName: string }, account: { __typename?: 'Accounts', accountGuid: string, accountDisplayName: string } } | undefined }>, aggregatableInvoicesAggregate: { __typename?: 'AggregatableInvoicesAggregate', aggregate?: { __typename?: 'AggregatableInvoicesAggregateFields', count: number, sum?: { __typename?: 'AggregatableInvoicesSumFields', totalUsc?: number | undefined } | undefined } | undefined } };

export type ActiveCompanyUsersWithEmailsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type ActiveCompanyUsersWithEmailsQuery = { __typename?: 'query_root', companyUsers: Array<{ __typename?: 'CompanyUsers', userByUserGuid: { __typename?: 'Users', userGuid: string, firstNameInitial?: string | undefined, emailAddress: string } }> };

export type UpdateSmsSettingsMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  smsAppointmentTemplate?: InputMaybe<Scalars['String']>;
  smsReminderTemplate?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSmsSettingsMutation = { __typename?: 'mutation_root', updateCompanyConfig?: { __typename: 'CompanyConfigMutationResponse' } | undefined };

export type SmsSettingsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type SmsSettingsQuery = { __typename?: 'query_root', companiesByPk?: { __typename?: 'Companies', billingProfile?: { __typename?: 'BillingProfiles', phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string } } | undefined } | undefined, companyConfig: Array<{ __typename?: 'CompanyConfig', smsAppointmentTemplate?: string | undefined, smsReminderTemplate?: string | undefined }> };

export type UpdateJobSummaryMutationVariables = Exact<{
  jobGuid: Scalars['uuid'];
  set: JobsSetInput;
}>;


export type UpdateJobSummaryMutation = { __typename?: 'mutation_root', updateJobsByPk?: { __typename: 'Jobs' } | undefined };

export type ScheduleAppointmentFragment = { __typename?: 'JobAppointments', appointmentType: AppointmentType, appointmentWindowEnd: IsoDateString, appointmentWindowStart: IsoDateString, description?: string | undefined, descriptionHtml?: HtmlString | undefined, endOfAppointmentNextSteps?: object | undefined, sendConfirmationEnabled: boolean, notificationType: AppointmentNotificationType, sendConfirmationTo?: string | undefined, confirmationLastSentAt?: IsoDateString | undefined, sendReminderEnabled: boolean, reminderLastSentAt?: IsoDateString | undefined, appointmentGuid: string, job: { __typename?: 'Jobs', displayId: number, jobGuid: string, instantBookingAt?: IsoDateString | undefined, summary?: string | undefined, summaryHtml?: HtmlString | undefined, location: { __typename?: 'Locations', locationGuid: string, locationDescription?: string | undefined, displayName?: string | undefined, address: { __typename?: 'Addresses', addressGuid: string, line1: string, zipCode: string, line2?: string | undefined, stateAbbreviation: string, city: string, geoLocation: Geo } }, pointOfContact: { __typename?: 'Contacts', fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined }, jobType: { __typename?: 'JobTypes', jobClass: JobClassesEnum, jobTypeGuid: string, name: string, description: string, durationMinutes: number, color?: string | undefined }, account: { __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, accountGuid: string, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', name: string, color: string } }> }, jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, displayId: number, displayIdV2: string, totalUsc: number, status: InvoiceV2Status } }>, equipmentTypeJobLinks: Array<{ __typename?: 'EquipmentTypeLinks', estimatedEquipmentAge?: string | undefined, equipmentTypeName: { __typename?: 'EquipmentTypes', name: string } }> }, appointmentChecklistInstances: Array<{ __typename?: 'AppointmentChecklistInstances', appointmentChecklistGuid: string, appointmentChecklistInstanceGuid: string, lastEditorUserGuid?: string | undefined, checklist: AppointmentChecklistInstanceChecklist, updatedAt: IsoDateString, jobAppointmentGuid: string, adHoc: boolean, instanceNumber: number, label?: string | undefined, appointmentChecklist: { __typename?: 'AppointmentChecklists', name: string }, lastEditor?: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string } | undefined }>, cancellationStatus?: { __typename?: 'JobAppointmentCancellationStatuses', canceled: boolean, updatedAt: IsoDateString, reason?: string | undefined, note?: string | undefined } | undefined };

export type UnassignedAppointmentsSubscriptionVariables = Exact<{
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type UnassignedAppointmentsSubscription = { __typename?: 'subscription_root', appointments: Array<{ __typename?: 'JobAppointments', appointmentType: AppointmentType, appointmentWindowEnd: IsoDateString, appointmentWindowStart: IsoDateString, description?: string | undefined, descriptionHtml?: HtmlString | undefined, endOfAppointmentNextSteps?: object | undefined, sendConfirmationEnabled: boolean, notificationType: AppointmentNotificationType, sendConfirmationTo?: string | undefined, confirmationLastSentAt?: IsoDateString | undefined, sendReminderEnabled: boolean, reminderLastSentAt?: IsoDateString | undefined, appointmentGuid: string, job: { __typename?: 'Jobs', displayId: number, jobGuid: string, instantBookingAt?: IsoDateString | undefined, summary?: string | undefined, summaryHtml?: HtmlString | undefined, location: { __typename?: 'Locations', locationGuid: string, locationDescription?: string | undefined, displayName?: string | undefined, address: { __typename?: 'Addresses', addressGuid: string, line1: string, zipCode: string, line2?: string | undefined, stateAbbreviation: string, city: string, geoLocation: Geo } }, pointOfContact: { __typename?: 'Contacts', fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined }, jobType: { __typename?: 'JobTypes', jobClass: JobClassesEnum, jobTypeGuid: string, name: string, description: string, durationMinutes: number, color?: string | undefined }, account: { __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, accountGuid: string, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', name: string, color: string } }> }, jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, displayId: number, displayIdV2: string, totalUsc: number, status: InvoiceV2Status } }>, equipmentTypeJobLinks: Array<{ __typename?: 'EquipmentTypeLinks', estimatedEquipmentAge?: string | undefined, equipmentTypeName: { __typename?: 'EquipmentTypes', name: string } }> }, appointmentChecklistInstances: Array<{ __typename?: 'AppointmentChecklistInstances', appointmentChecklistGuid: string, appointmentChecklistInstanceGuid: string, lastEditorUserGuid?: string | undefined, checklist: AppointmentChecklistInstanceChecklist, updatedAt: IsoDateString, jobAppointmentGuid: string, adHoc: boolean, instanceNumber: number, label?: string | undefined, appointmentChecklist: { __typename?: 'AppointmentChecklists', name: string }, lastEditor?: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string } | undefined }>, cancellationStatus?: { __typename?: 'JobAppointmentCancellationStatuses', canceled: boolean, updatedAt: IsoDateString, reason?: string | undefined, note?: string | undefined } | undefined }> };

export type TechnicianTimesheetEntryFragment = { __typename?: 'TimesheetEntries', timesheetEntryGuid: string, userGuid: string, finalStartTime?: IsoDateString | undefined, finalEndTime?: IsoDateString | undefined, entryLengthInMinutes?: number | undefined, deletedAt?: IsoDateString | undefined, attentionNote?: string | undefined, user: { __typename?: 'Users', firstName: string, lastName: string, userGuid: string, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }> }, timesheetEntryActivity?: { __typename?: 'TimesheetEntryActivities', timesheetEntryActivityGuid: string, activityName: string, isPayable: boolean } | undefined, timesheetEntryLinkData: Array<{ __typename?: 'TimesheetEntryLinkData', jobAppointment?: { __typename?: 'JobAppointments', appointmentType: AppointmentType } | undefined }> };

export type ScheduleAssignmentsSubscriptionVariables = Exact<{
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type ScheduleAssignmentsSubscription = { __typename?: 'subscription_root', jobAppointmentAssignments: Array<{ __typename?: 'JobAppointmentAssignments', technicianUserGuid: string, start: IsoDateString, end: IsoDateString, assignmentGuid: string, appointmentGuid: string, appointment: { __typename?: 'JobAppointments', appointmentType: AppointmentType, appointmentWindowEnd: IsoDateString, appointmentWindowStart: IsoDateString, description?: string | undefined, descriptionHtml?: HtmlString | undefined, endOfAppointmentNextSteps?: object | undefined, sendConfirmationEnabled: boolean, notificationType: AppointmentNotificationType, sendConfirmationTo?: string | undefined, confirmationLastSentAt?: IsoDateString | undefined, sendReminderEnabled: boolean, reminderLastSentAt?: IsoDateString | undefined, appointmentGuid: string, job: { __typename?: 'Jobs', displayId: number, jobGuid: string, instantBookingAt?: IsoDateString | undefined, summary?: string | undefined, summaryHtml?: HtmlString | undefined, location: { __typename?: 'Locations', locationGuid: string, locationDescription?: string | undefined, displayName?: string | undefined, address: { __typename?: 'Addresses', addressGuid: string, line1: string, zipCode: string, line2?: string | undefined, stateAbbreviation: string, city: string, geoLocation: Geo } }, pointOfContact: { __typename?: 'Contacts', fullName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined }, jobType: { __typename?: 'JobTypes', jobClass: JobClassesEnum, jobTypeGuid: string, name: string, description: string, durationMinutes: number, color?: string | undefined }, account: { __typename?: 'Accounts', accountDisplayName: string, accountReferenceNumber: string, accountGuid: string, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', name: string, color: string } }> }, jobInvoices: Array<{ __typename?: 'JobInvoices', invoice: { __typename?: 'Invoices', invoiceGuid: string, displayId: number, displayIdV2: string, totalUsc: number, status: InvoiceV2Status } }>, equipmentTypeJobLinks: Array<{ __typename?: 'EquipmentTypeLinks', estimatedEquipmentAge?: string | undefined, equipmentTypeName: { __typename?: 'EquipmentTypes', name: string } }> }, appointmentChecklistInstances: Array<{ __typename?: 'AppointmentChecklistInstances', appointmentChecklistGuid: string, appointmentChecklistInstanceGuid: string, lastEditorUserGuid?: string | undefined, checklist: AppointmentChecklistInstanceChecklist, updatedAt: IsoDateString, jobAppointmentGuid: string, adHoc: boolean, instanceNumber: number, label?: string | undefined, appointmentChecklist: { __typename?: 'AppointmentChecklists', name: string }, lastEditor?: { __typename?: 'Users', userGuid: string, firstName: string, lastName: string } | undefined }>, cancellationStatus?: { __typename?: 'JobAppointmentCancellationStatuses', canceled: boolean, updatedAt: IsoDateString, reason?: string | undefined, note?: string | undefined } | undefined }, assignmentStatus?: { __typename?: 'JobAppointmentAssignmentStatuses', status: JobAppointmentAssignmentStatusTypesEnum } | undefined, timesheetEntryLinkData: Array<{ __typename?: 'TimesheetEntryLinkData', timesheetEntry: { __typename?: 'TimesheetEntries', timesheetEntryGuid: string, userGuid: string, finalStartTime?: IsoDateString | undefined, finalEndTime?: IsoDateString | undefined, entryLengthInMinutes?: number | undefined, deletedAt?: IsoDateString | undefined, attentionNote?: string | undefined, user: { __typename?: 'Users', firstName: string, lastName: string, userGuid: string, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }> }, timesheetEntryActivity?: { __typename?: 'TimesheetEntryActivities', timesheetEntryActivityGuid: string, activityName: string, isPayable: boolean } | undefined, timesheetEntryLinkData: Array<{ __typename?: 'TimesheetEntryLinkData', jobAppointment?: { __typename?: 'JobAppointments', appointmentType: AppointmentType } | undefined }> } }> }> };

export type InternalEventsSubscriptionVariables = Exact<{
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type InternalEventsSubscription = { __typename?: 'subscription_root', technicianCapacityBlocks: Array<{ __typename?: 'TechnicianCapacityBlocks', end: IsoDateString, reasonDescription?: string | undefined, reasonType: TechnicianCapacityBlockReasonTypesEnum, recurrenceRule?: string | undefined, recurrenceRuleExceptions?: string | undefined, start: IsoDateString, userGuids: Array<string>, technicianCapacityBlockGuid: string }> };

export type CompanyScheduleInfoQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type CompanyScheduleInfoQuery = { __typename?: 'query_root', companyWorkingDisplayHours: Array<{ __typename?: 'CompanyWorkingDisplayHours', workingEndHour: number, workingStartHour: number }>, companyUsers: Array<{ __typename?: 'CompanyUsers', userGuid: string, schedulingCapability: SchedulingCapability, user: { __typename?: 'Users', firstName: string, lastName: string, deactivatedAt?: IsoDateString | undefined, userPrimaryHueHex?: string | undefined, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }>, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined } }>, companyConfigByPk?: { __typename?: 'CompanyConfig', scheduleTechOrder: Array<string> } | undefined };

export type ApplyScheduleChangesMutationVariables = Exact<{
  blocks: Array<TechnicianCapacityBlocksInsertInput> | TechnicianCapacityBlocksInsertInput;
  deletedBlockGuids: Array<Scalars['uuid']> | Scalars['uuid'];
  canceledAppointmentGuids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type ApplyScheduleChangesMutation = { __typename?: 'mutation_root', insertTechnicianCapacityBlocks?: { __typename: 'TechnicianCapacityBlocksMutationResponse' } | undefined, deleteTechnicianCapacityBlocks?: { __typename: 'TechnicianCapacityBlocksMutationResponse' } | undefined, updateJobAppointmentCancellationStatuses?: { __typename?: 'JobAppointmentCancellationStatusesMutationResponse', affectedRows: number } | undefined };

export type AppointmentDetailsSubscriptionVariables = Exact<{
  appointmentGuid: Scalars['uuid'];
}>;


export type AppointmentDetailsSubscription = { __typename?: 'subscription_root', jobAppointmentsByPk?: { __typename?: 'JobAppointments', description?: string | undefined, cancellationStatus?: { __typename?: 'JobAppointmentCancellationStatuses', canceled: boolean } | undefined, assignments: Array<{ __typename?: 'JobAppointmentAssignments', assignmentEnd: IsoDateString, assignmentStart: IsoDateString, assignmentGuid: string, assignmentStatus?: { __typename?: 'JobAppointmentAssignmentStatuses', status: JobAppointmentAssignmentStatusTypesEnum } | undefined, technician: { __typename?: 'Users', fullName: string, userGuid: string, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }>, userPhoneNumbers: Array<{ __typename?: 'UserPhoneNumbers', phoneNumber: { __typename?: 'PhoneNumbers', phoneNumber: string } }> }, timesheetEntryLinkData: Array<{ __typename?: 'TimesheetEntryLinkData', timesheetEntry: { __typename?: 'TimesheetEntries', timesheetEntryGuid: string, userGuid: string, finalStartTime?: IsoDateString | undefined, finalEndTime?: IsoDateString | undefined, entryLengthInMinutes?: number | undefined, deletedAt?: IsoDateString | undefined, attentionNote?: string | undefined, user: { __typename?: 'Users', firstName: string, lastName: string, userGuid: string, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }> }, timesheetEntryActivity?: { __typename?: 'TimesheetEntryActivities', timesheetEntryActivityGuid: string, activityName: string, isPayable: boolean } | undefined, timesheetEntryLinkData: Array<{ __typename?: 'TimesheetEntryLinkData', jobAppointment?: { __typename?: 'JobAppointments', appointmentType: AppointmentType } | undefined }> } }> }>, job: { __typename?: 'Jobs', summary?: string | undefined, summaryHtml?: HtmlString | undefined, equipmentTypeJobLinks: Array<{ __typename?: 'EquipmentTypeLinks', estimatedEquipmentAge?: string | undefined, equipmentType: EquipmentType }>, estimates: Array<{ __typename?: 'Estimates', displayId: number, estimateGuid: string, estimateOptionsAggregate: { __typename?: 'EstimateOptionsAggregate', aggregate?: { __typename?: 'EstimateOptionsAggregateFields', count: number } | undefined } }>, account: { __typename?: 'Accounts', accountGuid: string, accountDisplayName: string, accountReferenceNumber: string, accountType: AccountType, accountLeadSource: Array<{ __typename?: 'CompanyLeadSourceLinks', attributionDescription?: string | undefined, companyLeadSource: { __typename?: 'CompanyLeadSources', canonicalLeadSourceName: string, canonicalLeadSourceNameOverride?: string | undefined } }> }, pointOfContact: { __typename?: 'Contacts', notificationPreferenceType: NotificationPreferenceType, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string, unsubscribed: boolean } | undefined }, tags: Array<{ __typename?: 'JobTags', tag: { __typename?: 'Tags', name: string } }> } } | undefined };

export type EquipmentTypeLinksForAppointmentQueryVariables = Exact<{
  appointmentGuid: Scalars['uuid'];
}>;


export type EquipmentTypeLinksForAppointmentQuery = { __typename?: 'query_root', jobAppointmentsByPk?: { __typename?: 'JobAppointments', job: { __typename?: 'Jobs', equipmentTypeJobLinks: Array<{ __typename?: 'EquipmentTypeLinks', estimatedEquipmentAge?: string | undefined, equipmentType: EquipmentType, relationshipType: JobToEquipmentRelationshipType }> } } | undefined };

export type ReorderTechMutationMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  scheduleTechOrder: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type ReorderTechMutationMutation = { __typename?: 'mutation_root', updateCompanyConfigByPk?: { __typename: 'CompanyConfig' } | undefined };

export type FetchAllJobsForScheduleQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchAllJobsForScheduleQuery = { __typename?: 'query_root', jobs: Array<{ __typename?: 'Jobs', jobGuid: string, account: { __typename?: 'Accounts', accountDisplayName: string }, jobType: { __typename?: 'JobTypes', name: string, jobClass: JobClassesEnum }, location: { __typename?: 'Locations', displayName?: string | undefined, locationDescription?: string | undefined, address: { __typename?: 'Addresses', addressGuid: string, line1: string, zipCode: string, city: string, stateAbbreviation: string, geoLocation: Geo } }, jobLifecycleStatus: { __typename?: 'JobLifecycleStatuses', name: string } }> };

export type ScheduleV2PageUserSettingsQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
}>;


export type ScheduleV2PageUserSettingsQueryQuery = { __typename?: 'query_root', companyUsers: Array<{ __typename?: 'CompanyUsers', userByUserGuid: { __typename?: 'Users', userSettings: Array<{ __typename?: 'UserSettings', scheduleColorPreference?: string | undefined }> } }> };

export type ScheduleV2PageUpdateUserSettingsMutationMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
  scheduleColorPreference?: InputMaybe<Scalars['String']>;
}>;


export type ScheduleV2PageUpdateUserSettingsMutationMutation = { __typename?: 'mutation_root', insertUserSettingsOne?: { __typename?: 'UserSettings', scheduleColorPreference?: string | undefined } | undefined };

export type LocationsWithinRadiusQueryVariables = Exact<{
  radius: Scalars['Float'];
  point: Scalars['geography'];
  appointmentAddressGuids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type LocationsWithinRadiusQuery = { __typename?: 'query_root', locations: Array<{ __typename?: 'Locations', locationGuid: string, lastVisitedAt?: IsoDateString | undefined, displayName?: string | undefined, address: { __typename?: 'Addresses', distBetweenMeters?: number | undefined, addressGuid: string, canonicalFullAddress: string, line1: string, line2?: string | undefined, city: string, stateAbbreviation: string, zipCode: string, createdAt: IsoDateString, geoLocation: Geo }, installedEquipment: Array<{ __typename?: 'InstalledEquipment', installedEquipmentGuid: string, equipmentType: string, installationDate?: LocalDateString | undefined }>, maintenancePlans: Array<{ __typename?: 'MaintenancePlansQueryable', maintenancePlanGuid: string, accountGuid: string, locationGuid: string, status: MaintenancePlanStatus, credits: CreditRecordArray, lastVisitedAt?: IsoDateString | undefined, maintenancePlanDefinition?: { __typename?: 'MaintenancePlanDefinitions', numVisitCreditsPerYear: number, marketingInfo?: { __typename?: 'MaintenancePlanDefinitionMarketingInfo', name: string } | undefined } | undefined }>, accountLocations: Array<{ __typename?: 'AccountLocations', account: { __typename?: 'Accounts', accountGuid: string, tags: Array<{ __typename?: 'AccountTags', tag: { __typename?: 'Tags', companyGuid: string, tagGuid: string, name: string, color: string } }>, accountContacts: Array<{ __typename?: 'AccountContacts', contact: { __typename?: 'Contacts', firstName: string, lastName: string, primaryPhoneNumber?: { __typename?: 'PhoneNumbers', phoneNumber: string } | undefined, primaryEmailAddress?: { __typename?: 'EmailAddresses', emailAddress: string } | undefined } }> } }> }> };

export type UserSettingsQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
}>;


export type UserSettingsQueryQuery = { __typename?: 'query_root', userSettings: Array<{ __typename?: 'UserSettings', hideCallerIdEnabled: boolean }> };

export type UpdateUserSettingsMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
  hideCallerIdEnabled: Scalars['Boolean'];
}>;


export type UpdateUserSettingsMutation = { __typename?: 'mutation_root', insertUserSettingsOne?: { __typename: 'UserSettings' } | undefined };

export type FetchUserSettingsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
}>;


export type FetchUserSettingsQuery = { __typename?: 'query_root', userSettings: Array<{ __typename?: 'UserSettings', preferredMapApp?: string | undefined }> };

export type UpsertUserSettingMapPreferenceMutationVariables = Exact<{
  obj: UserSettingsInsertInput;
}>;


export type UpsertUserSettingMapPreferenceMutation = { __typename?: 'mutation_root', insertUserSettingsOne?: { __typename: 'UserSettings' } | undefined };

export type ScheduleColorPreferencesQueryQueryVariables = Exact<{
  userGuid: Scalars['uuid'];
}>;


export type ScheduleColorPreferencesQueryQuery = { __typename?: 'query_root', userSettingsByPk?: { __typename?: 'UserSettings', scheduleColorPreference?: string | undefined } | undefined };

export type ScheduleColorPreferencesUpdateScheduleColorPreferenceMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  scheduleColorPreference: Scalars['String'];
  userGuid: Scalars['uuid'];
}>;


export type ScheduleColorPreferencesUpdateScheduleColorPreferenceMutation = { __typename?: 'mutation_root', insertUserSettingsOne?: { __typename?: 'UserSettings', scheduleColorPreference?: string | undefined } | undefined };

export type SettingsEditTeamMemberPageUserAvatarQueryQueryVariables = Exact<{
  photoGuid: Scalars['uuid'];
}>;


export type SettingsEditTeamMemberPageUserAvatarQueryQuery = { __typename?: 'query_root', photosByPk?: { __typename?: 'Photos', photoGuid: string, cdnUrl: string } | undefined };

export type GetNotificationSettingsQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type GetNotificationSettingsQuery = { __typename?: 'query_root', companyNotificationSettingsByPk?: { __typename?: 'CompanyNotificationSettings', replyToEmail?: string | undefined, estimateAcceptNotifyCreator?: boolean | undefined, estimateAcceptNotifyEmail?: string | undefined, estimateAcceptNotifyUserGuids?: Array<string> | undefined, estimateReminderCount?: number | undefined, estimateReminderFrequency: ReminderFrequency, estimateReviewedNotifyCreator?: boolean | undefined, estimateReviewedNotifyUserGuids?: Array<string> | undefined, invoicePaymentReminderCount?: number | undefined, invoicePaymentReminderFrequency: ReminderFrequency, paymentFailedNotifyCreator?: boolean | undefined, paymentFailedNotifyEmail?: string | undefined, paymentFailedNotifyUserGuids?: Array<string> | undefined, materialRestockReportEmail?: string | undefined, materialRestockReportUserGuids?: Array<string> | undefined, jobLeadCreatedUserGuids?: Array<string> | undefined, jobLeadCreatedEmail?: string | undefined, lapsedPaymentMaintenancePlanUserGuids?: Array<string> | undefined, lapsedPaymentMaintenancePlanNotifyEmail?: string | undefined } | undefined, companyUsers: Array<{ __typename?: 'CompanyUsers', userGuid: string, userByUserGuid: { __typename?: 'Users', fullName: string } }> };

export type TagsAllQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type TagsAllQueryQuery = { __typename?: 'query_root', tags: Array<{ __typename?: 'Tags', tagGuid: string, companyGuid: string, createdByUserGuid?: string | undefined, name: string, color: string }> };

export type TagUpsertOneMutationVariables = Exact<{
  tag: TagsInsertInput;
}>;


export type TagUpsertOneMutation = { __typename?: 'mutation_root', insertTagsOne?: { __typename?: 'Tags', tagGuid: string } | undefined };

export type DeleteTagMutationVariables = Exact<{
  companyGuid: Scalars['uuid'];
  tagGuid: Scalars['uuid'];
}>;


export type DeleteTagMutation = { __typename?: 'mutation_root', deleteTags?: { __typename: 'TagsMutationResponse' } | undefined };

export type FetchCompanyTechnicianPerformanceConfigQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchCompanyTechnicianPerformanceConfigQuery = { __typename?: 'query_root', companyConfig: Array<{ __typename?: 'CompanyConfig', technicianPerformanceEnabled: boolean }> };

export type FetchCompanyTechnicianPerformanceCommissionConfigQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
}>;


export type FetchCompanyTechnicianPerformanceCommissionConfigQuery = { __typename?: 'query_root', companyCommissionConfig: Array<{ __typename?: 'CompanyCommissionConfig', defaultCommissionOverheadDeductionRate?: number | undefined, defaultCommissionOverheadFlatDeductionUsc?: number | undefined }> };

export type UpsertCompanyCommissionConfigMutationVariables = Exact<{
  config: CompanyCommissionConfigInsertInput;
}>;


export type UpsertCompanyCommissionConfigMutation = { __typename?: 'mutation_root', insertCompanyCommissionConfigOne?: { __typename?: 'CompanyCommissionConfig', defaultCommissionOverheadDeductionRate?: number | undefined, defaultCommissionOverheadFlatDeductionUsc?: number | undefined } | undefined };

export type TechnicianSchedulePageUserScheduleColorPreferenceSubscriptionSubscriptionVariables = Exact<{
  userGuid: Scalars['uuid'];
}>;


export type TechnicianSchedulePageUserScheduleColorPreferenceSubscriptionSubscription = { __typename?: 'subscription_root', userSettingsByPk?: { __typename?: 'UserSettings', scheduleColorPreference?: string | undefined } | undefined };

export type TechnicianSchedulePageUserAvatarPhotosQueryQueryVariables = Exact<{
  _in: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type TechnicianSchedulePageUserAvatarPhotosQueryQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', userGuid: string, userPrimaryHueHex?: string | undefined, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined }> };

export type FetchTimesheetEntriesPaginatedQueryVariables = Exact<{
  where?: InputMaybe<TimesheetEntriesBoolExp>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FetchTimesheetEntriesPaginatedQuery = { __typename?: 'query_root', timesheetEntries: Array<{ __typename?: 'TimesheetEntries', timesheetEntryGuid: string, userGuid: string, finalStartTime?: IsoDateString | undefined, finalEndTime?: IsoDateString | undefined, entryLengthInMinutes?: number | undefined, deletedAt?: IsoDateString | undefined, attentionNote?: string | undefined, user: { __typename?: 'Users', firstName: string, lastName: string, userGuid: string, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }> }, timesheetEntryActivity?: { __typename?: 'TimesheetEntryActivities', timesheetEntryActivityGuid: string, activityName: string, isPayable: boolean } | undefined, timesheetEntryLinks?: { __typename?: 'TimesheetEntryLinkData', jobGuid?: string | undefined, jobAppointmentGuid?: string | undefined, jobAppointmentAssignmentGuid?: string | undefined, job?: { __typename?: 'Jobs', displayId: number } | undefined } | undefined }>, timesheetEntriesAggregate: { __typename?: 'TimesheetEntriesAggregate', aggregate?: { __typename?: 'TimesheetEntriesAggregateFields', count: number } | undefined } };

export type FetchTimesheetEntriesQueryVariables = Exact<{
  where?: InputMaybe<TimesheetEntriesBoolExp>;
}>;


export type FetchTimesheetEntriesQuery = { __typename?: 'query_root', timesheetEntries: Array<{ __typename?: 'TimesheetEntries', timesheetEntryGuid: string, userGuid: string, finalStartTime?: IsoDateString | undefined, finalEndTime?: IsoDateString | undefined, entryLengthInMinutes?: number | undefined, deletedAt?: IsoDateString | undefined, attentionNote?: string | undefined, user: { __typename?: 'Users', firstName: string, lastName: string, userGuid: string, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }> }, timesheetEntryActivity?: { __typename?: 'TimesheetEntryActivities', timesheetEntryActivityGuid: string, activityName: string, isPayable: boolean } | undefined, timesheetEntryLinks?: { __typename?: 'TimesheetEntryLinkData', jobGuid?: string | undefined, jobAppointmentGuid?: string | undefined, jobAppointmentAssignmentGuid?: string | undefined, job?: { __typename?: 'Jobs', displayId: number } | undefined } | undefined }> };

export type UpsertTimesheetEntryMutationVariables = Exact<{
  entry: TimesheetEntriesInsertInput;
}>;


export type UpsertTimesheetEntryMutation = { __typename?: 'mutation_root', insertTimesheetEntriesOne?: { __typename: 'TimesheetEntries' } | undefined };

export type UpdateTimesheetEntryMutationVariables = Exact<{
  updatedByUserGuid: Scalars['uuid'];
  timesheetEntryGuid: Scalars['uuid'];
  startTimeOverride?: InputMaybe<Scalars['timestamptz']>;
  endTimeOverride?: InputMaybe<Scalars['timestamptz']>;
  timesheetEntryActivityGuid: Scalars['uuid'];
  activityName: Scalars['String'];
  isPayable: Scalars['Boolean'];
  attentionNote?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTimesheetEntryMutation = { __typename?: 'mutation_root', updateTimesheetEntriesByPk?: { __typename: 'TimesheetEntries' } | undefined, updateTimesheetEntryActivitiesByPk?: { __typename: 'TimesheetEntryActivities' } | undefined };

export type ClearAttentionNoteMutationVariables = Exact<{
  timesheetEntryGuid: Scalars['uuid'];
  updatedByUserGuid: Scalars['uuid'];
}>;


export type ClearAttentionNoteMutation = { __typename?: 'mutation_root', updateTimesheetEntriesByPk?: { __typename: 'TimesheetEntries' } | undefined };

export type DeleteTimesheetEntryMutationVariables = Exact<{
  timesheetEntryGuid: Scalars['uuid'];
  deletedAt: Scalars['timestamptz'];
  deletedByUserGuid: Scalars['uuid'];
}>;


export type DeleteTimesheetEntryMutation = { __typename?: 'mutation_root', updateTimesheetEntriesByPk?: { __typename: 'TimesheetEntries' } | undefined };

export type TimesheetsSummaryPageTimesheetsDetailSummaryQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type TimesheetsSummaryPageTimesheetsDetailSummaryQueryQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', userGuid: string, firstName: string, lastName: string, deactivatedAt?: IsoDateString | undefined, userPrimaryHueHex?: string | undefined, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }>, timesheetEntries: Array<{ __typename?: 'TimesheetEntries', timesheetEntryGuid: string, finalStartTime?: IsoDateString | undefined, finalEndTime?: IsoDateString | undefined, entryLengthInMinutes?: number | undefined, attentionNote?: string | undefined, deletedAt?: IsoDateString | undefined, timesheetEntryActivity?: { __typename?: 'TimesheetEntryActivities', isPayable: boolean } | undefined }>, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined }> };

export type TimesheetsSummaryPageTechniciansQueryQueryVariables = Exact<{
  companyGuid: Scalars['uuid'];
  search: Scalars['String'];
  roleSearch: Scalars['String'];
}>;


export type TimesheetsSummaryPageTechniciansQueryQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'Users', userGuid: string, fullName: string, firstName: string, lastName: string, userPrimaryHueHex?: string | undefined, userRoles: Array<{ __typename?: 'UserRoles', role: RoleId }>, avatarPhoto?: { __typename?: 'Photos', cdnUrl: string } | undefined }> };

export type PricebookItemFragment = { __typename?: 'PricebookItems', description: string, isActive: boolean, isDeleted: boolean, isDiscountable: boolean, isTaxable: boolean, itemType: PricebookItemTypeEnum, name: string, priceUsd: number, costUsd: number, pricebookItemCode?: string | undefined, pricebookItemGuid: string, version: number, basePriceUsc: number, memberPriceUsc: number, memberAddonPriceUsc: number, memberAfterhoursPriceUsc: number, memberAddonAfterhoursPriceUsc: number, addonPriceUsc: number, addonAfterhoursPriceUsc: number, afterhoursPriceUsc: number, photo?: { __typename?: 'Photos', cdnUrl: string, photoGuid: string } | undefined };

export type GetPricebookDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPricebookDataQuery = { __typename?: 'query_root', pricebookCategories: Array<{ __typename?: 'PricebookCategories', name: string, pricebookCategoryGuid: string, parentCategoryGuid?: string | undefined, pricebookItems: Array<{ __typename?: 'PricebookItems', description: string, isActive: boolean, isDeleted: boolean, isDiscountable: boolean, isTaxable: boolean, itemType: PricebookItemTypeEnum, name: string, priceUsd: number, costUsd: number, pricebookItemCode?: string | undefined, pricebookItemGuid: string, version: number, basePriceUsc: number, memberPriceUsc: number, memberAddonPriceUsc: number, memberAfterhoursPriceUsc: number, memberAddonAfterhoursPriceUsc: number, addonPriceUsc: number, addonAfterhoursPriceUsc: number, afterhoursPriceUsc: number, photo?: { __typename?: 'Photos', cdnUrl: string, photoGuid: string } | undefined }>, photo?: { __typename?: 'Photos', cdnUrl: string, photoGuid: string } | undefined }>, uncategorizedItems: Array<{ __typename?: 'PricebookItems', description: string, isActive: boolean, isDeleted: boolean, isDiscountable: boolean, isTaxable: boolean, itemType: PricebookItemTypeEnum, name: string, priceUsd: number, costUsd: number, pricebookItemCode?: string | undefined, pricebookItemGuid: string, version: number, basePriceUsc: number, memberPriceUsc: number, memberAddonPriceUsc: number, memberAfterhoursPriceUsc: number, memberAddonAfterhoursPriceUsc: number, addonPriceUsc: number, addonAfterhoursPriceUsc: number, afterhoursPriceUsc: number, photo?: { __typename?: 'Photos', cdnUrl: string, photoGuid: string } | undefined }> };

export type GetRecentPricebookItemsQueryVariables = Exact<{
  userGuid: Scalars['uuid'];
  limit: Scalars['Int'];
}>;


export type GetRecentPricebookItemsQuery = { __typename?: 'query_root', recentPricebookItems: Array<{ __typename?: 'RecentPricebookItems', pricebookItemGuid: string }> };

export type GetFavoritePricebookItemsQueryVariables = Exact<{
  userGuid: Scalars['uuid'];
  limit: Scalars['Int'];
}>;


export type GetFavoritePricebookItemsQuery = { __typename?: 'query_root', favoritePricebookItems: Array<{ __typename?: 'FavoritePricebookItems', pricebookItemGuid: string }> };

export type InsertFavoritePricebookItemMutationVariables = Exact<{
  object: FavoritePricebookItemsInsertInput;
}>;


export type InsertFavoritePricebookItemMutation = { __typename?: 'mutation_root', insertFavoritePricebookItemsOne?: { __typename?: 'FavoritePricebookItems', pricebookItemGuid: string } | undefined };

export type DeleteFavoritePricebookItemMutationVariables = Exact<{
  pricebookItemGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
}>;


export type DeleteFavoritePricebookItemMutation = { __typename?: 'mutation_root', deleteFavoritePricebookItemsByPk?: { __typename?: 'FavoritePricebookItems', pricebookItemGuid: string } | undefined };

export type TimeClockProviderDataSubscriptionVariables = Exact<{
  companyGuid: Scalars['uuid'];
  userGuid: Scalars['uuid'];
  startTime: Scalars['timestamptz'];
}>;


export type TimeClockProviderDataSubscription = { __typename?: 'subscription_root', timesheetEntries: Array<{ __typename?: 'TimesheetEntries', finalStartTime?: IsoDateString | undefined, finalEndTime?: IsoDateString | undefined, entryLengthInMinutes?: number | undefined, timesheetEntryActivity?: { __typename?: 'TimesheetEntryActivities', activityName: string } | undefined, timesheetEntryLinkData: Array<{ __typename?: 'TimesheetEntryLinkData', jobGuid?: string | undefined, jobAppointmentGuid?: string | undefined, jobAppointmentAssignmentGuid?: string | undefined }> }> };

export type FetchMetabasePulseSubscriptionsQueryVariables = Exact<{
  where?: InputMaybe<RepMetabasePulsesV2BoolExp>;
}>;


export type FetchMetabasePulseSubscriptionsQuery = { __typename?: 'query_root', repMetabasePulsesV2: Array<{ __typename?: 'RepMetabasePulsesV2', pulseGuid: string, recipients: EmbeddedReportingPulseRecipientArray, scheduleType: EmbeddedReportingPulseScheduleType, scheduleDetails: ScheduleDetails, createdAt: IsoDateString }> };

export type FetchMetabasePulseByGuidQueryVariables = Exact<{
  pulseGuid: Scalars['uuid'];
}>;


export type FetchMetabasePulseByGuidQuery = { __typename?: 'query_root', repMetabasePulsesV2ByPk?: { __typename?: 'RepMetabasePulsesV2', pulseGuid: string, recipients: EmbeddedReportingPulseRecipientArray, scheduleType: EmbeddedReportingPulseScheduleType, scheduleDetails: ScheduleDetails } | undefined };

export type FetchReportsByCategoryQueryVariables = Exact<{
  reportCategory: Scalars['String'];
}>;


export type FetchReportsByCategoryQuery = { __typename?: 'query_root', repMetabaseReportDefinitions: Array<{ __typename?: 'RepMetabaseReportDefinitions', reportGuid: string, reportCategory: EmbeddedReportCategory, reportType: EmbeddedReportType, reportTitle: string, reportDescription?: string | undefined, externalReportId: string }>, repMetabaseCompanyReports: Array<{ __typename?: 'RepMetabaseCompanyReports', repMetabaseReportDefinition: { __typename?: 'RepMetabaseReportDefinitions', reportGuid: string, reportCategory: EmbeddedReportCategory, reportType: EmbeddedReportType, reportTitle: string, reportDescription?: string | undefined, externalReportId: string } }> };

export type FetchReportByGuidQueryVariables = Exact<{
  reportGuid: Scalars['uuid'];
}>;


export type FetchReportByGuidQuery = { __typename?: 'query_root', repMetabaseReportDefinitionsByPk?: { __typename?: 'RepMetabaseReportDefinitions', reportGuid: string, reportCategory: EmbeddedReportCategory, reportType: EmbeddedReportType, reportTitle: string, reportDescription?: string | undefined, externalReportId: string } | undefined };

export const ContactsWidgetContactFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactsWidgetContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountContacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}}]}}]}}]} as unknown as DocumentNode<ContactsWidgetContactFragment, unknown>;
export const EquipmentWidgetEquipmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EquipmentWidgetEquipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstalledEquipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"installationParty"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"operationalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCondition"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturingDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastJobDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EquipmentWidgetEquipmentFragment, unknown>;
export const EstimatesWidgetEstimateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EstimatesWidgetEstimate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Estimates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"discounts"},"name":{"kind":"Name","value":"estimateOptionDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EstimatesWidgetEstimateFragment, unknown>;
export const InvoicesWidgetInvoiceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoicesWidgetInvoice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartItems"},"name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"discounts"},"name":{"kind":"Name","value":"invoiceDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}}]}}]} as unknown as DocumentNode<InvoicesWidgetInvoiceFragment, unknown>;
export const JobsWidgetJobFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobsWidgetJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Jobs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}}]}}]} as unknown as DocumentNode<JobsWidgetJobFragment, unknown>;
export const LinkedIntegratedPhoneCallFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkedIntegratedPhoneCall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegratedPhoneCalls"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallGuid"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneMissedCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneVoicemails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingSummary"}},{"kind":"Field","name":{"kind":"Name","value":"recordingTranscript"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallRecording"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingSummary"}},{"kind":"Field","name":{"kind":"Name","value":"recordingTranscript"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LinkedIntegratedPhoneCallFragment, unknown>;
export const MaintenancePlanVisitFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanVisitFragment, unknown>;
export const MaintenancePlanCollapsibleDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}},{"kind":"Field","name":{"kind":"Name","value":"coveredInstalledEquipmentGuids"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledActivationAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingStartAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanCollapsibleDataFragment, unknown>;
export const AppointmentDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobAppointments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"CANCELED","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}},{"kind":"Field","name":{"kind":"Name","value":"lapsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInterval"}},{"kind":"Field","name":{"kind":"Name","value":"paymentAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderGuid"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"equipment"},"name":{"kind":"Name","value":"equipmentTypeJobLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedEquipmentAge"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeLinkGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipRenewalOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isHotLead"}},{"kind":"Field","name":{"kind":"Name","value":"isOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipSold"}},{"kind":"Field","alias":{"kind":"Name","value":"isJobConverted"},"name":{"kind":"Name","value":"isConverted"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isWorkComplete"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"summaryHtml"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"doNotService"}},{"kind":"Field","name":{"kind":"Name","value":"doNotServiceReason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedMaintenancePlanVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"assignments"},"name":{"kind":"Name","value":"jobAppointmentAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"assignments"},"name":{"kind":"Name","value":"jobAppointmentAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assignmentStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"EN_ROUTE"},{"kind":"EnumValue","value":"IN_PROGRESS"}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentEnd"}},{"kind":"Field","alias":{"kind":"Name","value":"assignmentGuid"},"name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationTo"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"sendReminderEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"endOfAppointmentNextSteps"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canceled"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"checklists"},"name":{"kind":"Name","value":"appointmentChecklistInstances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"instanceGuid"},"name":{"kind":"Name","value":"appointmentChecklistInstanceGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"checklistGuid"},"name":{"kind":"Name","value":"appointmentChecklistGuid"}},{"kind":"Field","name":{"kind":"Name","value":"checklist"}},{"kind":"Field","name":{"kind":"Name","value":"instanceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}},{"kind":"Field","name":{"kind":"Name","value":"coveredInstalledEquipmentGuids"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledActivationAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingStartAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}}]}}]} as unknown as DocumentNode<AppointmentDetailsFragment, unknown>;
export const VisitAccountDetailsAccountFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisitAccountDetailsAccount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Accounts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"accountLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastJobDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoice"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"PAID","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<VisitAccountDetailsAccountFragment, unknown>;
export const JobPointOfContactFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPointOfContactFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}}]}}]} as unknown as DocumentNode<JobPointOfContactFragmentFragment, unknown>;
export const AppointmentChecklistsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentChecklists"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobAppointments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"checklists"},"name":{"kind":"Name","value":"appointmentChecklistInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentChecklistGuid"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"instanceNumber"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstanceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistGuid"}},{"kind":"Field","name":{"kind":"Name","value":"checklist"}},{"kind":"Field","name":{"kind":"Name","value":"adHoc"}},{"kind":"Field","name":{"kind":"Name","value":"instanceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<AppointmentChecklistsFragment, unknown>;
export const EstimateCollapsibleEstimateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EstimateCollapsibleEstimate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Estimates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"closedLostReasonCategory"}},{"kind":"Field","name":{"kind":"Name","value":"closedLostReasonNote"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}}]}}]}}]} as unknown as DocumentNode<EstimateCollapsibleEstimateFragment, unknown>;
export const JobCardDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobCardData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Jobs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTechnicianSoldRevenueSummaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"totalSoldRevenueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobCardDataFragment, unknown>;
export const AddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Addresses"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalFullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}}]} as unknown as DocumentNode<AddressFragment, unknown>;
export const JobTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobTypes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultSummary"}},{"kind":"Field","name":{"kind":"Name","value":"hideJobSummaryField"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInJobCosting"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityConversionThresholdUsc"}},{"kind":"Field","name":{"kind":"Name","value":"isPotentialHotLead"}},{"kind":"Field","name":{"kind":"Name","value":"hotLeadMinimumEquipmentAgeYears"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"defaultBusinessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<JobTypeFragment, unknown>;
export const LoanRecordStatusFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecordStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanStatuses"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loanStatusDetail"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<LoanRecordStatusFragment, unknown>;
export const LoanRecordFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackTransactionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"requestedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"approvedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"settledLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"processingFeeUsc"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"loanApplicationLink"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecordStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecordStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanStatuses"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loanStatusDetail"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<LoanRecordFragment, unknown>;
export const LocationContactRecordFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationContactRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationContacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locationContactRelationTypes"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<LocationContactRecordFragment, unknown>;
export const ContactFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"salutation"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}}]}}]}}]} as unknown as DocumentNode<ContactFragment, unknown>;
export const LocationContactWithoutLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationContactWithoutLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationContacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationContactRecord"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationContactRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationContacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"locationContactRelationTypes"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"salutation"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}}]}}]}}]} as unknown as DocumentNode<LocationContactWithoutLocationFragment, unknown>;
export const MaintenancePlanDefinitionMinimalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanDefinitionMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanDefinitions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanDefinitionMinimalFragment, unknown>;
export const MaintenancePlanMinimalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanDefinitionMinimal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanDefinitionMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanDefinitions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanMinimalFragment, unknown>;
export const MaintenancePlanOpportunityMinimalInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanOpportunityMinimalInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numVisitCreditsPerYear"}},{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"lastVisitedAt"}}]}}]} as unknown as DocumentNode<MaintenancePlanOpportunityMinimalInfoFragment, unknown>;
export const PrequalRecordFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrequalRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maxQualifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"aprRange"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"prequalLink"}}]}}]} as unknown as DocumentNode<PrequalRecordFragment, unknown>;
export const PrequalRecordWithContactNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrequalRecordWithContactName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrequalRecord"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrequalRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maxQualifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"aprRange"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"prequalLink"}}]}}]} as unknown as DocumentNode<PrequalRecordWithContactNameFragment, unknown>;
export const TagFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Tag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tags"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TagFragment, unknown>;
export const TagMinimalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tags"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TagMinimalFragment, unknown>;
export const EstimateTemplateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EstimateTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EstimateTemplates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateTemplateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}},{"kind":"Field","name":{"kind":"Name","value":"messagePreset"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"optionGuid"},"name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"discountGuid"},"name":{"kind":"Name","value":"estimateOptionDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recommended"},"name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","alias":{"kind":"Name","value":"selected"},"name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"itemType"},"name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemVariant"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]} as unknown as DocumentNode<EstimateTemplateFragment, unknown>;
export const PhotoRecordFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhotoRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoLinks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"noteLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PhotoRecordFragment, unknown>;
export const FileRecordFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileLinks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"storageStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"fileGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileSizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"fileTypeMime"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FileRecordFragment, unknown>;
export const InstalledEquipmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InstalledEquipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstalledEquipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"installationParty"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturingDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"operationalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCondition"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}}]}}]} as unknown as DocumentNode<InstalledEquipmentFragment, unknown>;
export const AccountExperienceOnlineBookingCompanyConfigFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountExperienceOnlineBookingCompanyConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OnlineBookingCompanyConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limitBookingsToServiceAreaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"brandingColorHex"}},{"kind":"Field","name":{"kind":"Name","value":"afterHoursBannerHtml"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAreaZipCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]} as unknown as DocumentNode<AccountExperienceOnlineBookingCompanyConfigFragment, unknown>;
export const AccountExperienceOnlineBookingServiceTypeConfigFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountExperienceOnlineBookingServiceTypeConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OnlineBookingServiceTypeConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlineBookingServiceTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"serviceType"}},{"kind":"Field","name":{"kind":"Name","value":"bookingType"}},{"kind":"Field","name":{"kind":"Name","value":"earliestAvailability"}},{"kind":"Field","name":{"kind":"Name","value":"latestAvailability"}},{"kind":"Field","name":{"kind":"Name","value":"legalBlurbHtml"}},{"kind":"Field","name":{"kind":"Name","value":"bookableJobTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"instantBookingWeeklyScheduleEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"bookableArrivalWindows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arrivalWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyAppointmentArrivalWindowGuid"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowEndTime"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountExperienceOnlineBookingServiceTypeConfigFragment, unknown>;
export const CompanyAppointmentArrivalWindowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyAppointmentArrivalWindow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyAppointmentArrivalWindows"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyAppointmentArrivalWindowGuid"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowEndTime"}}]}}]} as unknown as DocumentNode<CompanyAppointmentArrivalWindowFragment, unknown>;
export const AccountsListPageAccountsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountsListPageAccountsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Accounts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"doNotService"}},{"kind":"Field","name":{"kind":"Name","value":"doNotServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastJobDate"}},{"kind":"Field","name":{"kind":"Name","value":"accountJobCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equipmentType"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}}]} as unknown as DocumentNode<AccountsListPageAccountsFragmentFragment, unknown>;
export const InvoiceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Invoice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"doNotSyncToAccountingServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanSavingsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hideLineItemPrices"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateName"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicPricingType"}},{"kind":"Field","name":{"kind":"Name","value":"billingContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"itemType"},"name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemVariant"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerPurchaseOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"billingContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddressGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecord"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentStatuses"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CANCELED"}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecord"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRefunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qboStaleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stale"},"name":{"kind":"Name","value":"isQboStale"}},{"kind":"Field","alias":{"kind":"Name","value":"syncedAt"},"name":{"kind":"Name","value":"qboSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingStaleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isStale"}},{"kind":"Field","name":{"kind":"Name","value":"syncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestPaymentAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUpdatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnitLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}}]}}]} as unknown as DocumentNode<InvoiceFragment, unknown>;
export const InvoiceWithGuidFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceWithGuid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Invoice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Invoice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"doNotSyncToAccountingServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanSavingsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hideLineItemPrices"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateName"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicPricingType"}},{"kind":"Field","name":{"kind":"Name","value":"billingContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"itemType"},"name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemVariant"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerPurchaseOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"billingContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddressGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecord"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentStatuses"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CANCELED"}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecord"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRefunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qboStaleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stale"},"name":{"kind":"Name","value":"isQboStale"}},{"kind":"Field","alias":{"kind":"Name","value":"syncedAt"},"name":{"kind":"Name","value":"qboSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingStaleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isStale"}},{"kind":"Field","name":{"kind":"Name","value":"syncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestPaymentAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUpdatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnitLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}}]}}]} as unknown as DocumentNode<InvoiceWithGuidFragment, unknown>;
export const JobRequestFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobRequestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobLeads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLeadGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"contactLastName"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressCity"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressStateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressZipCode"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"}},{"kind":"Field","name":{"kind":"Name","value":"requestType"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypes"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentAvailabilities"}},{"kind":"Field","name":{"kind":"Name","value":"additionalMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobSummary"}},{"kind":"Field","name":{"kind":"Name","value":"leadSource"}},{"kind":"Field","name":{"kind":"Name","value":"jobLeadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"originatingPlatformUrl"}},{"kind":"Field","name":{"kind":"Name","value":"originatingPlatformLabel"}},{"kind":"Field","name":{"kind":"Name","value":"submittedJobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preExistingLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobRequestFragmentFragment, unknown>;
export const MaintenancePlanNextVisitFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanNextVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanNextVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"visitStatus"}},{"kind":"Field","name":{"kind":"Name","value":"visitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanNextVisitFragment, unknown>;
export const MaintenancePlansListPageFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlansListPageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInterval"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledActivationAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingStartAt"}},{"kind":"Field","name":{"kind":"Name","value":"lapsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}},{"kind":"Field","name":{"kind":"Name","value":"visitReplenishmentAnchorOverride"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSubscriptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"numUnusedVisits"}},{"kind":"Field","name":{"kind":"Name","value":"soldByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userPrimaryHueHex"}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numDaysUntilVisitCreditExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanNextVisit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanNextVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanNextVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"visitStatus"}},{"kind":"Field","name":{"kind":"Name","value":"visitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]} as unknown as DocumentNode<MaintenancePlansListPageFragmentFragment, unknown>;
export const TeamPerformanceJobFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamPerformanceJobFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Jobs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isConverted"}},{"kind":"Field","name":{"kind":"Name","value":"isHotLead"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipRenewalOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipSold"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTeamMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"turnedOverJob"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTechnicianEarnedRevenueSummaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"totalEarnedRevenueUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTechnicianSoldRevenueSummaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"totalSoldRevenueUsc"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"jobFullyPaidInvoicesV2Summary"},"name":{"kind":"Name","value":"jobFullyPaidInvoicesV2SummaryMv"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalInvoicedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"totalPaidAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalSubtotalAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"totalTaxAmountUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TeamPerformanceJobFragmentFragment, unknown>;
export const ScheduleAppointmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleAppointment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobAppointments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"endOfAppointmentNextSteps"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationTo"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendReminderEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"instantBookingAt"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"summaryHtml"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoice"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeJobLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedEquipmentAge"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"instanceNumber"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstanceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"lastEditorUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"checklist"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"adHoc"}},{"kind":"Field","name":{"kind":"Name","value":"instanceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastEditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canceled"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]} as unknown as DocumentNode<ScheduleAppointmentFragment, unknown>;
export const TechnicianTimesheetEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnicianTimesheetEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimesheetEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"finalStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"finalEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"entryLengthInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attentionNote"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivityGuid"}},{"kind":"Field","name":{"kind":"Name","value":"activityName"}},{"kind":"Field","name":{"kind":"Name","value":"isPayable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryLinkData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}}]}}]}}]}}]} as unknown as DocumentNode<TechnicianTimesheetEntryFragment, unknown>;
export const PricebookItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PricebookItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricebookItems"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priceUsd"}},{"kind":"Field","name":{"kind":"Name","value":"costUsd"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"basePriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"memberPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"memberAddonPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"memberAfterhoursPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"memberAddonAfterhoursPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"addonPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"addonAfterhoursPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"afterhoursPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}}]}}]}}]} as unknown as DocumentNode<PricebookItemFragment, unknown>;
export const FetchCompanyInfoBoxDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchCompanyInfoBoxData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyUsersWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyUsersBoolExp"}},"defaultValue":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blurb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"websiteDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyUsersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchCompanyInfoBoxDataQuery, FetchCompanyInfoBoxDataQueryVariables>;
export const CompanyUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyUsersQuery, CompanyUsersQueryVariables>;
export const DeleteReminderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReminder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reminderGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRemindersByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reminderGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reminderGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}}]}}]} as unknown as DocumentNode<DeleteReminderMutation, DeleteReminderMutationVariables>;
export const AccountRemindersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountReminders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountReminders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"reminder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reminder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reminder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dueAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reminder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reminderGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reminderAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountRemindersQuery, AccountRemindersQueryVariables>;
export const DistinctReminderDescriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DistinctReminderDescriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remindersAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinctOn"},"value":{"kind":"EnumValue","value":"description"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<DistinctReminderDescriptionsQuery, DistinctReminderDescriptionsQueryVariables>;
export const UpdateReminderStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReminderStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reminderGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReminderStatusTypesEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRemindersByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reminderGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reminderGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reminderGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateReminderStatusMutation, UpdateReminderStatusMutationVariables>;
export const UpsertAccountingCartItemTypeAccountsConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCartItemTypeAccountsConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCartItemTypeAccountsConfigInsertInput"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCartItemTypeAccountsConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_cart_item_type_accounts_config_company_guid_accounting_inte"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"defaultItemIncomeAccountId"},{"kind":"EnumValue","value":"serviceItemDefaultIncomeAccountId"},{"kind":"EnumValue","value":"materialItemDefaultIncomeAccountId"},{"kind":"EnumValue","value":"equipmentItemDefaultIncomeAccountId"},{"kind":"EnumValue","value":"laborItemDefaultIncomeAccountId"},{"kind":"EnumValue","value":"membershipItemDefaultIncomeAccountId"},{"kind":"EnumValue","value":"inventoryAssetAccountId"},{"kind":"EnumValue","value":"costOfGoodsSoldAccountId"},{"kind":"EnumValue","value":"discountDefaultIncomeAccountId"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCartItemTypeAccountsConfigMutation, UpsertAccountingCartItemTypeAccountsConfigMutationVariables>;
export const FetchAccountingCartItemTypeAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchAccountingCartItemTypeAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accCartItemTypeAccountsConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultItemIncomeAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentItemDefaultIncomeAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"laborItemDefaultIncomeAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"materialItemDefaultIncomeAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"membershipItemDefaultIncomeAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"serviceItemDefaultIncomeAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryAssetAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"costOfGoodsSoldAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"discountDefaultIncomeAccountId"}}]}}]}}]} as unknown as DocumentNode<FetchAccountingCartItemTypeAccountsQuery, FetchAccountingCartItemTypeAccountsQueryVariables>;
export const FetchAccountingPayoutAccountsConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchAccountingPayoutAccountsConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accPayoutAccountsConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payoutDepositAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"payoutFeesAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"payoutPaymentProcessorBalanceAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"payoutRefundsAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"accountingIntegrationType"}}]}}]}}]} as unknown as DocumentNode<FetchAccountingPayoutAccountsConfigQuery, FetchAccountingPayoutAccountsConfigQueryVariables>;
export const UpsertAccountingPayoutAccountsConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingPayoutAccountsConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccPayoutAccountsConfigInsertInput"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccPayoutAccountsConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_payout_accounts_config_company_guid_accounting_integrat_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"payoutDepositAccountId"},{"kind":"EnumValue","value":"payoutFeesAccountId"},{"kind":"EnumValue","value":"payoutPaymentProcessorBalanceAccountId"},{"kind":"EnumValue","value":"payoutRefundsAccountId"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingPayoutAccountsConfigMutation, UpsertAccountingPayoutAccountsConfigMutationVariables>;
export const FetchQboAuthTokensInvalidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchQboAuthTokensInvalid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qboAuthData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isInvalid"}}]}}]}}]} as unknown as DocumentNode<FetchQboAuthTokensInvalidQuery, FetchQboAuthTokensInvalidQueryVariables>;
export const DoNotServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DoNotService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doNotService"}},{"kind":"Field","name":{"kind":"Name","value":"doNotServiceReason"}}]}}]}}]} as unknown as DocumentNode<DoNotServiceQuery, DoNotServiceQueryVariables>;
export const OpenAccountBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OpenAccountBalance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoicesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OPEN","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dueUsc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdString"}},{"kind":"Field","name":{"kind":"Name","value":"paidUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdString"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userPrimaryHueHex"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OpenAccountBalanceSubscription, OpenAccountBalanceSubscriptionVariables>;
export const OverdueAccountBalanceConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverdueAccountBalanceConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overdueAccountBalanceEnabled"}}]}}]}}]} as unknown as DocumentNode<OverdueAccountBalanceConfigQuery, OverdueAccountBalanceConfigQueryVariables>;
export const FetchActivityItemsByCompanyGuidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchActivityItemsByCompanyGuid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"activityItemType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FetchActivityItemsByCompanyGuidQuery, FetchActivityItemsByCompanyGuidQueryVariables>;
export const FetchActivityItemsByAccountGuidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchActivityItemsByAccountGuid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"activityItemType"}},{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FetchActivityItemsByAccountGuidQuery, FetchActivityItemsByAccountGuidQueryVariables>;
export const FetchActivityItemsByJobGuidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchActivityItemsByJobGuid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"activityItemType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FetchActivityItemsByJobGuidQuery, FetchActivityItemsByJobGuidQueryVariables>;
export const FetchReportDefinitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchReportDefinitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repMetabaseReportDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accessControlType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OPT_IN","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reportTitle"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportGuid"}},{"kind":"Field","name":{"kind":"Name","value":"reportTitle"}},{"kind":"Field","name":{"kind":"Name","value":"reportCategory"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}}]}}]}}]} as unknown as DocumentNode<FetchReportDefinitionsQuery, FetchReportDefinitionsQueryVariables>;
export const FetchPayableInvoicesForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchPayableInvoicesForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dueUsc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issuedAt"},"value":{"kind":"EnumValue","value":"ASC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"displayIdV2"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"dueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"paidUsc"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"numDaysOverdue"}}]}}]}}]} as unknown as DocumentNode<FetchPayableInvoicesForAccountQuery, FetchPayableInvoicesForAccountQueryVariables>;
export const CancelAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cancellationStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobAppointmentCancellationStatusesInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteJobAppointmentAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertJobAppointmentCancellationStatusesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cancellationStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"job_appointment_cancellation_statuses_job_appointment_guid_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"canceled"},{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"reason"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<CancelAppointmentMutation, CancelAppointmentMutationVariables>;
export const DeleteAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteJobAppointmentAssignmentsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteJobAppointmentAssignmentStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>;
export const WisetackFinancingPrequalRecordCardQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WisetackFinancingPrequalRecordCardQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecordsBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<WisetackFinancingPrequalRecordCardQueryQuery, WisetackFinancingPrequalRecordCardQueryQueryVariables>;
export const ContactsWidgetDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ContactsWidgetData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountContactsBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactsWidgetContact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactsWidgetContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountContacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}}]}}]}}]} as unknown as DocumentNode<ContactsWidgetDataSubscription, ContactsWidgetDataSubscriptionVariables>;
export const FindActiveMaintenancePlanAtAccountLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindActiveMaintenancePlanAtAccountLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansQueryable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACTIVE","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastVisitedAt"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindActiveMaintenancePlanAtAccountLocationQuery, FindActiveMaintenancePlanAtAccountLocationQueryVariables>;
export const FindJobTypeRevenuePotentialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindJobTypeRevenuePotential"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTypeGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobTypeGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobTypeGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityConversionThresholdUsc"}},{"kind":"Field","name":{"kind":"Name","value":"isPotentialHotLead"}},{"kind":"Field","name":{"kind":"Name","value":"hotLeadMinimumEquipmentAgeYears"}}]}}]}}]} as unknown as DocumentNode<FindJobTypeRevenuePotentialQuery, FindJobTypeRevenuePotentialQueryVariables>;
export const CreateOrEditJobFormLinkedJobQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateOrEditJobFormLinkedJobQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLifecycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinksAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"noteLinksAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileLinksAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACCEPTED","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isSelected"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoice"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"OPEN","block":false},{"kind":"StringValue","value":"PAID","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentChecklistInstancesAggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"predicate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstanceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"lastEditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateOrEditJobFormLinkedJobQueryQuery, CreateOrEditJobFormLinkedJobQueryQueryVariables>;
export const GetDownloadableInvoiceDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDownloadableInvoiceData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingProfilesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultTaxRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"logoPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceMemo"}},{"kind":"Field","name":{"kind":"Name","value":"businessAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessFullLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"contractorLicenseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"websiteDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blurb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"primaryContact"},"name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"firstLocation"},"name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDownloadableInvoiceDataQuery, GetDownloadableInvoiceDataQueryVariables>;
export const EditJobModalJobQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EditJobModalJobQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installProjectType"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"summaryHtml"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"isOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isHotLead"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipRenewalOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeJobLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEquipmentAge"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"useMaintenancePlanCredit"}},{"kind":"Field","name":{"kind":"Name","value":"customerPurchaseOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderGuid"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"linkedJobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"referringContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"attributionDescription"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobTypes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultSummary"}},{"kind":"Field","name":{"kind":"Name","value":"hideJobSummaryField"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInJobCosting"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityConversionThresholdUsc"}},{"kind":"Field","name":{"kind":"Name","value":"isPotentialHotLead"}},{"kind":"Field","name":{"kind":"Name","value":"hotLeadMinimumEquipmentAgeYears"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"defaultBusinessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]} as unknown as DocumentNode<EditJobModalJobQueryQuery, EditJobModalJobQueryQueryVariables>;
export const EquipmentWidgetDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"EquipmentWidgetData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InstalledEquipmentBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"equipment"},"name":{"kind":"Name","value":"installedEquipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EquipmentWidgetEquipment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EquipmentWidgetEquipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstalledEquipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"installationParty"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"operationalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCondition"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturingDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastJobDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EquipmentWidgetDataSubscription, EquipmentWidgetDataSubscriptionVariables>;
export const EquipmentWidgetUpdateOperationalStatusMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EquipmentWidgetUpdateOperationalStatusMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installedEquipmentGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operationalStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInstalledEquipmentByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"installedEquipmentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installedEquipmentGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operationalStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operationalStatus"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operationalStatus"}}]}}]}}]} as unknown as DocumentNode<EquipmentWidgetUpdateOperationalStatusMutationMutation, EquipmentWidgetUpdateOperationalStatusMutationMutationVariables>;
export const EstimatesWidgetDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"EstimatesWidgetData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimatesBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EstimatesWidgetEstimate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EstimatesWidgetEstimate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Estimates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"discounts"},"name":{"kind":"Name","value":"estimateOptionDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EstimatesWidgetDataSubscription, EstimatesWidgetDataSubscriptionVariables>;
export const FileUpdateNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FileUpdateName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFilesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fileGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}}]} as unknown as DocumentNode<FileUpdateNameMutation, FileUpdateNameMutationVariables>;
export const LoanRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"LoanRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loanRecordGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wisetackLoanRecordGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loanRecordGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecord"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecordStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanStatuses"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loanStatusDetail"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackTransactionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"requestedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"approvedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"settledLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"processingFeeUsc"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"loanApplicationLink"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecordStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<LoanRecordSubscription, LoanRecordSubscriptionVariables>;
export const PrequalRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PrequalRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prequalRecordGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wisetackPrequalRecordGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prequalRecordGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrequalRecord"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrequalRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maxQualifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"aprRange"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"prequalLink"}}]}}]} as unknown as DocumentNode<PrequalRecordSubscription, PrequalRecordSubscriptionVariables>;
export const FinancingAccountInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FinancingAccountInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"accountContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salutation"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}}]}}]}}]} as unknown as DocumentNode<FinancingAccountInfoQuery, FinancingAccountInfoQueryVariables>;
export const LoanRecordInvoiceDetailsSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"LoanRecordInvoiceDetailsSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"messageHtml"}}]}}]}}]}}]} as unknown as DocumentNode<LoanRecordInvoiceDetailsSubscriptionSubscription, LoanRecordInvoiceDetailsSubscriptionSubscriptionVariables>;
export const FetchPrequalRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchPrequalRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecordsBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<FetchPrequalRecordQuery, FetchPrequalRecordQueryVariables>;
export const FetchContactInvoiceLoanAmountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchContactInvoiceLoanAmounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanStatus"}}]}}]}}]}}]} as unknown as DocumentNode<FetchContactInvoiceLoanAmountsQuery, FetchContactInvoiceLoanAmountsQueryVariables>;
export const DeclinedAccountPrequalRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeclinedAccountPrequalRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"DECLINED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}}]}}]}}]}}]} as unknown as DocumentNode<DeclinedAccountPrequalRecordsQuery, DeclinedAccountPrequalRecordsQueryVariables>;
export const PrequalRecordsSubByAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PrequalRecordsSubByAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrequalRecordWithContactName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrequalRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maxQualifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"aprRange"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"prequalLink"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrequalRecordWithContactName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrequalRecord"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<PrequalRecordsSubByAccountSubscription, PrequalRecordsSubByAccountSubscriptionVariables>;
export const PrequalRecordsByAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PrequalRecordsByAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrequalRecordWithContactName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrequalRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maxQualifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"aprRange"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"prequalLink"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrequalRecordWithContactName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrequalRecord"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<PrequalRecordsByAccountQuery, PrequalRecordsByAccountQueryVariables>;
export const FetchDisplayIdCountersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchDisplayIdCounters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayIdCounters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"counter"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<FetchDisplayIdCountersQuery, FetchDisplayIdCountersQueryVariables>;
export const UpdateDisplayIdCounterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDisplayIdCounter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"counter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDisplayIdCounters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"counter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"counter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<UpdateDisplayIdCounterMutation, UpdateDisplayIdCounterMutationVariables>;
export const UpsertDisplayIdCounterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertDisplayIdCounter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DisplayIdCountersInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertDisplayIdCountersOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"display_id_counters_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"counter"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"counter"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpsertDisplayIdCounterMutation, UpsertDisplayIdCounterMutationVariables>;
export const UpsertInstallHvacSystemAndLinkedEquipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertInstallHvacSystemAndLinkedEquipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installedHvacSystemGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"friendlyName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoningInfoJson"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkedInstalledEquipmentGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertInstalledHvacSystemsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"installedHvacSystemGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installedHvacSystemGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterSize"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"friendlyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"friendlyName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"zoningInfoJson"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoningInfoJson"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"installed_hvac_systems_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"filterSize"},{"kind":"EnumValue","value":"friendlyName"},{"kind":"EnumValue","value":"notes"},{"kind":"EnumValue","value":"zoningInfoJson"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"addNewEquipmentLinks"},"name":{"kind":"Name","value":"updateInstalledEquipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"installedHvacSystemGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installedHvacSystemGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"installedEquipmentGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkedInstalledEquipmentGuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"removeOldEquipmentLinks"},"name":{"kind":"Name","value":"updateInstalledEquipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"installedHvacSystemGuid"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"installedEquipmentGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkedInstalledEquipmentGuids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"installedHvacSystemGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installedHvacSystemGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertInstallHvacSystemAndLinkedEquipmentMutation, UpsertInstallHvacSystemAndLinkedEquipmentMutationVariables>;
export const InvoicesWidgetDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"InvoicesWidgetData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicesBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoicesWidgetInvoice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoicesWidgetInvoice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartItems"},"name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"discounts"},"name":{"kind":"Name","value":"invoiceDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}}]}}]} as unknown as DocumentNode<InvoicesWidgetDataSubscription, InvoicesWidgetDataSubscriptionVariables>;
export const GetInvoiceIdentifyingInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvoiceIdentifyingInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<GetInvoiceIdentifyingInfoQuery, GetInvoiceIdentifyingInfoQueryVariables>;
export const PrimaryContactInfoForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PrimaryContactInfoForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrimaryContactInfoForAccountQuery, PrimaryContactInfoForAccountQueryVariables>;
export const QueryContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactsBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"salutation"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}}]}}]}}]} as unknown as DocumentNode<QueryContactQuery, QueryContactQueryVariables>;
export const JobAttachmentsLinkedJobDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"JobAttachmentsLinkedJobDataQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsWithLinkedJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"linkNotes"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachments"}},{"kind":"Field","name":{"kind":"Name","value":"linked_job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileGuid"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileSizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"fileTypeMime"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"storageStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobAttachmentsLinkedJobDataQuerySubscription, JobAttachmentsLinkedJobDataQuerySubscriptionVariables>;
export const AllJobAssignedTechniciansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllJobAssignedTechnicians"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoicesQueryables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllJobAssignedTechniciansQuery, AllJobAssignedTechniciansQueryVariables>;
export const UsersInfoForRevenueAttributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersInfoForRevenueAttribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}}]}}]}}]} as unknown as DocumentNode<UsersInfoForRevenueAttributionQuery, UsersInfoForRevenueAttributionQueryVariables>;
export const AllRevenueAttributionsForJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllRevenueAttributionsForJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTechnicianSoldRevenueAttributions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"itemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"revenueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTechnicianEarnedRevenueAttributions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"itemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"revenueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}}]}}]}}]} as unknown as DocumentNode<AllRevenueAttributionsForJobQuery, AllRevenueAttributionsForJobQueryVariables>;
export const SoldMaintenancePlanForJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SoldMaintenancePlanForJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}}]}}]}}]}}]} as unknown as DocumentNode<SoldMaintenancePlanForJobQuery, SoldMaintenancePlanForJobQueryVariables>;
export const InvoiceForJobSoldMaintenancePlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoiceForJobSoldMaintenancePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"maintenancePlanLink"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"maintenancePlanGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanGuid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}}]}}]}}]} as unknown as DocumentNode<InvoiceForJobSoldMaintenancePlanQuery, InvoiceForJobSoldMaintenancePlanQueryVariables>;
export const JobOutcomeInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobOutcomeInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobLink"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"PAID"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"itemType"},"name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobOutcomeInvoicesQuery, JobOutcomeInvoicesQueryVariables>;
export const GetJobsPickerDataForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobsPickerDataForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetJobsPickerDataForAccountQuery, GetJobsPickerDataForAccountQueryVariables>;
export const JobsWidgetDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"JobsWidgetData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobsBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobsWidgetJob"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobsWidgetJob"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Jobs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}}]}}]} as unknown as DocumentNode<JobsWidgetDataSubscription, JobsWidgetDataSubscriptionVariables>;
export const MaintenancePlansWidgetDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"MaintenancePlansWidgetData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryableBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansQueryable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingAnchor"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInterval"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}},{"kind":"Field","name":{"kind":"Name","value":"coveredInstalledEquipmentGuids"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledActivationAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingStartAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}}]}}]} as unknown as DocumentNode<MaintenancePlansWidgetDataSubscription, MaintenancePlansWidgetDataSubscriptionVariables>;
export const UpsertAppointmentFormCompanyUsersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpsertAppointmentFormCompanyUsersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userPhoneNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleById"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schedulingCapability"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPrimaryHueHex"}}]}}]}}]} as unknown as DocumentNode<UpsertAppointmentFormCompanyUsersQueryQuery, UpsertAppointmentFormCompanyUsersQueryQueryVariables>;
export const JobTypeDurationMinutesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobTypeDurationMinutesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}}]}}]}}]}}]} as unknown as DocumentNode<JobTypeDurationMinutesQueryQuery, JobTypeDurationMinutesQueryQueryVariables>;
export const AccountBillingInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountBillingInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountBillingInfoQuery, AccountBillingInfoQueryVariables>;
export const InvoiceLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoiceLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}}]}}]}}]}}]} as unknown as DocumentNode<InvoiceLinksQuery, InvoiceLinksQueryVariables>;
export const ResyncPaymentInvoiceEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResyncPaymentInvoiceEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentRecordGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newTitle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newOccurredAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInvoiceEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecordGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentRecordGuid"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newOccurredAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newTitle"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<ResyncPaymentInvoiceEventsMutation, ResyncPaymentInvoiceEventsMutationVariables>;
export const DeleteInvoiceEventsByPaymentRecordGuidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteInvoiceEventsByPaymentRecordGuid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentRecordGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteInvoiceEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecordGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentRecordGuid"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<DeleteInvoiceEventsByPaymentRecordGuidMutation, DeleteInvoiceEventsByPaymentRecordGuidMutationVariables>;
export const UserPersonResourceSelectUserAvatarQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserPersonResourceSelectUserAvatarQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_in"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_in"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]} as unknown as DocumentNode<UserPersonResourceSelectUserAvatarQueryQuery, UserPersonResourceSelectUserAvatarQueryQueryVariables>;
export const FetchCompanyPhoneSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchCompanyPhoneSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCompanyConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"integratedVoiceCallingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneProvider"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryOutboundSms"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchCompanyPhoneSettingsQuery, FetchCompanyPhoneSettingsQueryVariables>;
export const FetchContactLiteByPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchContactLiteByPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactsAdditionalPhone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<FetchContactLiteByPhoneNumberQuery, FetchContactLiteByPhoneNumberQueryVariables>;
export const FetchIntegratedPhoneCallGuidByExternalCallIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchIntegratedPhoneCallGuidByExternalCallId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalCallId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCalls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"externalCallId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalCallId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallGuid"}}]}}]}}]} as unknown as DocumentNode<FetchIntegratedPhoneCallGuidByExternalCallIdQuery, FetchIntegratedPhoneCallGuidByExternalCallIdQueryVariables>;
export const UpsertUserPhoneStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertUserPhoneStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"obj"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegratedPhoneUsersInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertIntegratedPhoneUsersOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"integrated_phone_users_company_guid_user_guid_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"updatedAt"},{"kind":"EnumValue","value":"isAvailable"},{"kind":"EnumValue","value":"identity"}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"obj"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertUserPhoneStatusMutation, UpsertUserPhoneStatusMutationVariables>;
export const AccountPhotoAlbumWidgetQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountPhotoAlbumWidgetQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"noteLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountPhotoAlbumWidgetQueryQuery, AccountPhotoAlbumWidgetQueryQueryVariables>;
export const JobPhotoAlbumWidgetQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobPhotoAlbumWidgetQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedToJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linked_job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"noteLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"noteLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobPhotoAlbumWidgetQueryQuery, JobPhotoAlbumWidgetQueryQueryVariables>;
export const AccountPhotoGalleryModalPhotosQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountPhotoGalleryModalPhotosQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TimestamptzComparisonExp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinksAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatedAt"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]} as unknown as DocumentNode<AccountPhotoGalleryModalPhotosQueryQuery, AccountPhotoGalleryModalPhotosQueryQueryVariables>;
export const InsertPricebookItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPricebookItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricebookItem"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PricebookItemsInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertPricebookItemsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricebookItem"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<InsertPricebookItemMutation, InsertPricebookItemMutationVariables>;
export const GetPricebookDiscountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPricebookDiscounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookDiscountGuid"}}]}}]}}]} as unknown as DocumentNode<GetPricebookDiscountsQuery, GetPricebookDiscountsQueryVariables>;
export const GetPricebookTaxRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPricebookTaxRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountTypes"}},{"kind":"Field","name":{"kind":"Name","value":"zipCodes"}}]}}]}}]} as unknown as DocumentNode<GetPricebookTaxRatesQuery, GetPricebookTaxRatesQueryVariables>;
export const GetPricebookItemsAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPricebookItemsAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","alias":{"kind":"Name","value":"costUSD"},"name":{"kind":"Name","value":"costUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"priceUSD"},"name":{"kind":"Name","value":"priceUsd"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"sourcePhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"basePriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"memberPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"memberAddonPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"memberAfterhoursPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"memberAddonAfterhoursPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"addonPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"addonAfterhoursPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"afterhoursPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"sourcePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricebookCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookCategoryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentCategoryGuid"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"qboIncomeAccount"},"name":{"kind":"Name","value":"pricebookItemsQboIncomeAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qboIncomeAccountId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricebookCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookCategoryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentCategoryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"sourcePhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"sourcePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetPricebookItemsAdminQuery, GetPricebookItemsAdminQueryVariables>;
export const GetPricebookCategoriesAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPricebookCategoriesAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookCategoryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentCategoryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"parentPricebookCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookCategoryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"parentCategoryGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourcePhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"sourcePhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetPricebookCategoriesAdminQuery, GetPricebookCategoriesAdminQueryVariables>;
export const GetPricebookTaxRatesAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPricebookTaxRatesAdmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"accountTypes"}},{"kind":"Field","name":{"kind":"Name","value":"zipCodes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultPricebookTaxRateGuid"}}]}}]}}]} as unknown as DocumentNode<GetPricebookTaxRatesAdminQuery, GetPricebookTaxRatesAdminQueryVariables>;
export const GetPricebookDiscountsAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPricebookDiscountsAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]} as unknown as DocumentNode<GetPricebookDiscountsAdminQuery, GetPricebookDiscountsAdminQueryVariables>;
export const UpdatePricebookSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePricebookSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberTierEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberAddonTierEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberAfterhoursTierEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberAddonAfterhoursTierEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addonTierEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addonAfterhoursTierEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterhoursTierEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessHoursStartTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessHoursEndTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"saturdayIsBusinessDay"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sundayIsBusinessDay"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricebookPhotosEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyPricingTierConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"memberTierEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberTierEnabled"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"memberAddonTierEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberAddonTierEnabled"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"memberAfterhoursTierEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberAfterhoursTierEnabled"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"memberAddonAfterhoursTierEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberAddonAfterhoursTierEnabled"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"addonTierEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addonTierEnabled"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"addonAfterhoursTierEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addonAfterhoursTierEnabled"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"afterhoursTierEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"afterhoursTierEnabled"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"businessHoursStartTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessHoursStartTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"businessHoursEndTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessHoursEndTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"saturdayIsBusinessDay"},"value":{"kind":"Variable","name":{"kind":"Name","value":"saturdayIsBusinessDay"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sundayIsBusinessDay"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sundayIsBusinessDay"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateCompanyConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pricebookPhotosEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricebookPhotosEnabled"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdatePricebookSettingsMutation, UpdatePricebookSettingsMutationVariables>;
export const GetPricebookMarkupTiersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPricebookMarkupTiers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookMarkupTiers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookMarkupTierGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"costRangeEndInclusiveUsc"}},{"kind":"Field","name":{"kind":"Name","value":"markupRate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetPricebookMarkupTiersQuery, GetPricebookMarkupTiersQueryVariables>;
export const UpsertPricebookMarkupTierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertPricebookMarkupTier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PricebookMarkupTiersInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertPricebookMarkupTiersOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"pricebook_markup_tiers_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"costRangeEndInclusiveUsc"},{"kind":"EnumValue","value":"markupRate"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookMarkupTierGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"costRangeEndInclusiveUsc"}},{"kind":"Field","name":{"kind":"Name","value":"markupRate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpsertPricebookMarkupTierMutation, UpsertPricebookMarkupTierMutationVariables>;
export const DeletePricebookMarkupTierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePricebookMarkupTier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricebookMarkupTierGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePricebookMarkupTiersByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pricebookMarkupTierGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricebookMarkupTierGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookMarkupTierGuid"}}]}}]}}]} as unknown as DocumentNode<DeletePricebookMarkupTierMutation, DeletePricebookMarkupTierMutationVariables>;
export const UpsertCompanyConfigPricebookPhotosEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyConfigPricebookPhotosEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"pricebookPhotosEnabled"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyConfigPricebookPhotosEnabledMutation, UpsertCompanyConfigPricebookPhotosEnabledMutationVariables>;
export const PricebookVersionHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PricebookVersionHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookVersions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookVersionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataSchemaVersion"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookItemsFileGuid"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookCategoriesFileGuid"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookItemsFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricebookCategoriesFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]} as unknown as DocumentNode<PricebookVersionHistorySubscription, PricebookVersionHistorySubscriptionVariables>;
export const PricebookItemDefaultPhotoQueryAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PricebookItemDefaultPhotoQueryAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookItemTypeFallbackPhotos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]} as unknown as DocumentNode<PricebookItemDefaultPhotoQueryAdminQuery, PricebookItemDefaultPhotoQueryAdminQueryVariables>;
export const AccountDropdownOptionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountDropdownOptionsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountsBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"doNotService"}},{"kind":"Field","name":{"kind":"Name","value":"doNotServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayNameSetBySystem"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalFullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountDropdownOptionsQueryQuery, AccountDropdownOptionsQueryQueryVariables>;
export const CreateOrEditAccountFormCompanyConfigQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateOrEditAccountFormCompanyConfigQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountManagerEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumberEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"accountNameDisplayTemplate"}}]}}]}}]} as unknown as DocumentNode<CreateOrEditAccountFormCompanyConfigQueryQuery, CreateOrEditAccountFormCompanyConfigQueryQueryVariables>;
export const InsertJobPhoneCallLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertJobPhoneCallLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegratedPhoneCallJobsInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertIntegratedPhoneCallJobsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"integrated_phone_call_jobs_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<InsertJobPhoneCallLinkMutation, InsertJobPhoneCallLinkMutationVariables>;
export const SettingsTeamPageUserAvatarsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SettingsTeamPageUserAvatarsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}}]}}]}}]} as unknown as DocumentNode<SettingsTeamPageUserAvatarsQueryQuery, SettingsTeamPageUserAvatarsQueryQueryVariables>;
export const CurrentVisitDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CurrentVisitData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"assignments"},"name":{"kind":"Name","value":"jobAppointmentAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignmentStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"EN_ROUTE"},{"kind":"EnumValue","value":"IN_PROGRESS"}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"technicianUserGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"appointment"},"name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentVisitDataSubscription, CurrentVisitDataSubscriptionVariables>;
export const TechAppHomePageDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"TechAppHomePageData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tomorrow"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"today"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"assignments"},"name":{"kind":"Name","value":"jobAppointmentAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"technicianUserGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assignmentStart"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tomorrow"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assignmentEnd"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"today"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignmentStart"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"assignmentGuid"},"name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isHotLead"}},{"kind":"Field","name":{"kind":"Name","value":"isOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipRenewalOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipSold"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isWorkComplete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isConverted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canceled"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<TechAppHomePageDataSubscription, TechAppHomePageDataSubscriptionVariables>;
export const TechAppHomeTechnicianCapacityBlocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"TechAppHomeTechnicianCapacityBlocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tomorrow"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"today"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"blocks"},"name":{"kind":"Name","value":"technicianCapacityBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGuids"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"today"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tomorrow"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reasonType"}},{"kind":"Field","name":{"kind":"Name","value":"reasonDescription"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]} as unknown as DocumentNode<TechAppHomeTechnicianCapacityBlocksSubscription, TechAppHomeTechnicianCapacityBlocksSubscriptionVariables>;
export const FetchPurchaseOrdersDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchPurchaseOrdersData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderGuid"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderNumber"}}]}}]}}]} as unknown as DocumentNode<FetchPurchaseOrdersDataQuery, FetchPurchaseOrdersDataQueryVariables>;
export const UpdateJobPurchaseOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateJobPurchaseOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purchaseOrders"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseOrdersInsertInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePurchaseOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertPurchaseOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purchaseOrders"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateJobPurchaseOrdersMutation, UpdateJobPurchaseOrdersMutationVariables>;
export const AppointmentDetailByGuidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AppointmentDetailByGuid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobAppointmentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}},{"kind":"Field","name":{"kind":"Name","value":"coveredInstalledEquipmentGuids"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledActivationAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingStartAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobAppointments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"CANCELED","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}},{"kind":"Field","name":{"kind":"Name","value":"lapsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInterval"}},{"kind":"Field","name":{"kind":"Name","value":"paymentAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderGuid"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrderNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"equipment"},"name":{"kind":"Name","value":"equipmentTypeJobLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedEquipmentAge"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeLinkGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipRenewalOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isHotLead"}},{"kind":"Field","name":{"kind":"Name","value":"isOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipSold"}},{"kind":"Field","alias":{"kind":"Name","value":"isJobConverted"},"name":{"kind":"Name","value":"isConverted"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isWorkComplete"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"summaryHtml"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"doNotService"}},{"kind":"Field","name":{"kind":"Name","value":"doNotServiceReason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedMaintenancePlanVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"assignments"},"name":{"kind":"Name","value":"jobAppointmentAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"assignments"},"name":{"kind":"Name","value":"jobAppointmentAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assignmentStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"EN_ROUTE"},{"kind":"EnumValue","value":"IN_PROGRESS"}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentEnd"}},{"kind":"Field","alias":{"kind":"Name","value":"assignmentGuid"},"name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationTo"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"sendReminderEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"endOfAppointmentNextSteps"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canceled"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"checklists"},"name":{"kind":"Name","value":"appointmentChecklistInstances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"instanceGuid"},"name":{"kind":"Name","value":"appointmentChecklistInstanceGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"checklistGuid"},"name":{"kind":"Name","value":"appointmentChecklistGuid"}},{"kind":"Field","name":{"kind":"Name","value":"checklist"}},{"kind":"Field","name":{"kind":"Name","value":"instanceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<AppointmentDetailByGuidSubscription, AppointmentDetailByGuidSubscriptionVariables>;
export const AppointmentDetailByRefNumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentDetailByRefNum"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refNum"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentReferenceNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refNum"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}}]}}]} as unknown as DocumentNode<AppointmentDetailByRefNumQuery, AppointmentDetailByRefNumQueryVariables>;
export const UserAssignmentTimeClockStatusCardCurrentAssignmentTimesheetEntriesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserAssignmentTimeClockStatusCardCurrentAssignmentTimesheetEntriesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"timesheetEntryLinkData"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"finalStartTime"},"value":{"kind":"EnumValue","value":"ASC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"finalEndTime"},"value":{"kind":"EnumValue","value":"ASC_NULLS_LAST"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"finalEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"entryLengthInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityName"}},{"kind":"Field","name":{"kind":"Name","value":"isPayable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryLinkData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}}]}}]}}]}}]} as unknown as DocumentNode<UserAssignmentTimeClockStatusCardCurrentAssignmentTimesheetEntriesQuerySubscription, UserAssignmentTimeClockStatusCardCurrentAssignmentTimesheetEntriesQuerySubscriptionVariables>;
export const VisitAccountDetailsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"VisitAccountDetailsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisitAccountDetailsAccount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisitAccountDetailsAccount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Accounts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"accountLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastJobDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoice"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"PAID","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<VisitAccountDetailsDataSubscription, VisitAccountDetailsDataSubscriptionVariables>;
export const VisitAccountTabJobsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"VisitAccountTabJobsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locationGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"estimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"options"},"name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"cartItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"discounts"},"name":{"kind":"Name","value":"estimateOptionDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"discountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}}]}}]}}]} as unknown as DocumentNode<VisitAccountTabJobsDataSubscription, VisitAccountTabJobsDataSubscriptionVariables>;
export const VisitAccountTabInvoicesDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"VisitAccountTabInvoicesData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locationGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartItems"},"name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"discounts"},"name":{"kind":"Name","value":"invoiceDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<VisitAccountTabInvoicesDataSubscription, VisitAccountTabInvoicesDataSubscriptionVariables>;
export const AppointmentDetailAccountPhotosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentDetailAccountPhotos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinksAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentDetailAccountPhotosQuery, AppointmentDetailAccountPhotosQueryVariables>;
export const AppointmentDetailLocationPhotosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentDetailLocationPhotos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinksAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locationGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locationGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locationGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayId"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentDetailLocationPhotosQuery, AppointmentDetailLocationPhotosQueryVariables>;
export const AppointmentDetailAccountJobsPhotosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentDetailAccountJobsPhotos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinksAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayId"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentDetailAccountJobsPhotosQuery, AppointmentDetailAccountJobsPhotosQueryVariables>;
export const GetJobInvoiceStatusesSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GetJobInvoiceStatusesSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetJobInvoiceStatusesSubscriptionSubscription, GetJobInvoiceStatusesSubscriptionSubscriptionVariables>;
export const AttachmentsSectionFilesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AttachmentsSectionFilesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedToJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linked_job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AttachmentsSectionFilesQueryQuery, AttachmentsSectionFilesQueryQueryVariables>;
export const GetRelevantChecklistDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRelevantChecklistData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentChecklistInstanceGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentChecklistInstanceGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentChecklistInstanceGuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRelevantChecklistDataQuery, GetRelevantChecklistDataQueryVariables>;
export const SubscribeToFetchEndOfAppointmentNextStepsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SubscribeToFetchEndOfAppointmentNextSteps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobAppointmentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endOfAppointmentNextSteps"}}]}}]}}]} as unknown as DocumentNode<SubscribeToFetchEndOfAppointmentNextStepsSubscription, SubscribeToFetchEndOfAppointmentNextStepsSubscriptionVariables>;
export const PhotoGalleryPhotoDetailModalPhotoQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PhotoGalleryPhotoDetailModalPhotoQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photoGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"photoGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photoGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"noteLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noteGuid"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PhotoGalleryPhotoDetailModalPhotoQueryQuery, PhotoGalleryPhotoDetailModalPhotoQueryQueryVariables>;
export const PhotoGalleryPhotoDetailModalSetDescriptionMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PhotoGalleryPhotoDetailModalSetDescriptionMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noteGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdByUserGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photoGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertNotesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"noteGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdByUserGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdByUserGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatedAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"notes_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"value"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertNoteLinksOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"noteGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"photoGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photoGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatedAt"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"note_links_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"photoGuid"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<PhotoGalleryPhotoDetailModalSetDescriptionMutationMutation, PhotoGalleryPhotoDetailModalSetDescriptionMutationMutationVariables>;
export const PhotoGalleryPhotoDetailModalDeletePhotoMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PhotoGalleryPhotoDetailModalDeletePhotoMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noteGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photoGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteNoteLinksByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"noteGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteNotesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"noteGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletePhotoLinksByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"photoGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photoGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletePhotosByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"photoGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photoGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<PhotoGalleryPhotoDetailModalDeletePhotoMutationMutation, PhotoGalleryPhotoDetailModalDeletePhotoMutationMutationVariables>;
export const VisitDetailPastVisitCardqueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisitDetailPastVisitCardquery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignmentStart"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<VisitDetailPastVisitCardqueryQuery, VisitDetailPastVisitCardqueryQueryVariables>;
export const JobPointOfContactNotificationPreferenceTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobPointOfContactNotificationPreferenceType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPointOfContactFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPointOfContactFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}}]}}]} as unknown as DocumentNode<JobPointOfContactNotificationPreferenceTypeQuery, JobPointOfContactNotificationPreferenceTypeQueryVariables>;
export const UpsertMaintenancePlanVisitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertMaintenancePlanVisits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisitsInsertInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertMaintenancePlanVisits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"maintenance_plan_visits_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"affinityDate"},{"kind":"EnumValue","value":"companyGuid"},{"kind":"EnumValue","value":"completedAtOverride"},{"kind":"EnumValue","value":"dueAt"},{"kind":"EnumValue","value":"expiresAt"},{"kind":"EnumValue","value":"isCompletedOverride"},{"kind":"EnumValue","value":"isExpiredOverride"},{"kind":"EnumValue","value":"issuedAt"},{"kind":"EnumValue","value":"jobGuid"},{"kind":"EnumValue","value":"maintenancePlanGuid"},{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"updatedAt"},{"kind":"EnumValue","value":"visitNote"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<UpsertMaintenancePlanVisitsMutation, UpsertMaintenancePlanVisitsMutationVariables>;
export const UpsertMaintenancePlanVisitInstalledEquipmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertMaintenancePlanVisitInstalledEquipments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installedEquipments"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisitInstalledEquipmentsInsertInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMaintenancePlanVisitInstalledEquipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"maintenancePlanVisitGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertMaintenancePlanVisitInstalledEquipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installedEquipments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<UpsertMaintenancePlanVisitInstalledEquipmentsMutation, UpsertMaintenancePlanVisitInstalledEquipmentsMutationVariables>;
export const ClearMaintenancePlanVisitJobLinkFrontendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClearMaintenancePlanVisitJobLinkFrontend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clearMaintenancePlanVisitLink"},"name":{"kind":"Name","value":"updateMaintenancePlanVisits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"isCompletedOverride"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"completedAtOverride"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<ClearMaintenancePlanVisitJobLinkFrontendMutation, ClearMaintenancePlanVisitJobLinkFrontendMutationVariables>;
export const MutateAccountContactArchivedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MutateAccountContactArchived"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountContactGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archived"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountContactsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountContactGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountContactGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archived"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<MutateAccountContactArchivedMutation, MutateAccountContactArchivedMutationVariables>;
export const AppointmentChecklistsSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AppointmentChecklistsSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobAppointmentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobAppointmentGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentChecklists"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentChecklists"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobAppointments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"checklists"},"name":{"kind":"Name","value":"appointmentChecklistInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentChecklistGuid"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"instanceNumber"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstanceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistGuid"}},{"kind":"Field","name":{"kind":"Name","value":"checklist"}},{"kind":"Field","name":{"kind":"Name","value":"adHoc"}},{"kind":"Field","name":{"kind":"Name","value":"instanceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<AppointmentChecklistsSubscriptionSubscription, AppointmentChecklistsSubscriptionSubscriptionVariables>;
export const AllChecklistsSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AllChecklistsSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistGuid"}},{"kind":"Field","name":{"kind":"Name","value":"items"}}]}}]}}]} as unknown as DocumentNode<AllChecklistsSubscriptionSubscription, AllChecklistsSubscriptionSubscriptionVariables>;
export const EstimatesForCollapsibleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"EstimatesForCollapsible"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimatesBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EstimateCollapsibleEstimate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EstimateCollapsibleEstimate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Estimates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"closedLostReasonCategory"}},{"kind":"Field","name":{"kind":"Name","value":"closedLostReasonNote"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}}]}}]}}]} as unknown as DocumentNode<EstimatesForCollapsibleSubscription, EstimatesForCollapsibleSubscriptionVariables>;
export const EstimatesCollapsibleLinkedEstimatesSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"EstimatesCollapsibleLinkedEstimatesSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedJobEstimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"estimate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EstimateCollapsibleEstimate"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EstimateCollapsibleEstimate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Estimates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"closedLostReasonCategory"}},{"kind":"Field","name":{"kind":"Name","value":"closedLostReasonNote"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}}]}}]}}]} as unknown as DocumentNode<EstimatesCollapsibleLinkedEstimatesSubscriptionSubscription, EstimatesCollapsibleLinkedEstimatesSubscriptionSubscriptionVariables>;
export const EquipmentCollapsibleUpdateOperationalStatusMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EquipmentCollapsibleUpdateOperationalStatusMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installedEquipmentGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operationalStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInstalledEquipmentByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"installedEquipmentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installedEquipmentGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operationalStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operationalStatus"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operationalStatus"}}]}}]}}]} as unknown as DocumentNode<EquipmentCollapsibleUpdateOperationalStatusMutationMutation, EquipmentCollapsibleUpdateOperationalStatusMutationMutationVariables>;
export const InvoiceCollapsibleDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"InvoiceCollapsibleData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicesBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issuedAt"},"value":{"kind":"EnumValue","value":"DESC_NULLS_FIRST"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartItems"},"name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"discounts"},"name":{"kind":"Name","value":"invoiceDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}}]}}]}}]}}]} as unknown as DocumentNode<InvoiceCollapsibleDataSubscription, InvoiceCollapsibleDataSubscriptionVariables>;
export const InvoicesCollapsibleLinkedInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"InvoicesCollapsibleLinkedInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedJobInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoicesWidgetInvoice"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoicesWidgetInvoice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartItems"},"name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"discounts"},"name":{"kind":"Name","value":"invoiceDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}}]}}]} as unknown as DocumentNode<InvoicesCollapsibleLinkedInvoicesSubscription, InvoicesCollapsibleLinkedInvoicesSubscriptionVariables>;
export const LinkedJobsCollapsibleLinkedJobsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LinkedJobsCollapsibleLinkedJobsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsWithLinkedJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linked_job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobCardData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobCardData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Jobs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTechnicianSoldRevenueSummaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"totalSoldRevenueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LinkedJobsCollapsibleLinkedJobsQueryQuery, LinkedJobsCollapsibleLinkedJobsQueryQueryVariables>;
export const LinkedJobsCollapsibleFollowUpJobsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LinkedJobsCollapsibleFollowUpJobsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsWithLinkedJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"linkedJobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobCardData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobCardData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Jobs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTechnicianSoldRevenueSummaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"totalSoldRevenueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LinkedJobsCollapsibleFollowUpJobsQueryQuery, LinkedJobsCollapsibleFollowUpJobsQueryQueryVariables>;
export const ReadStaleInvoiceInfoForCompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadStaleInvoiceInfoForCompany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoicesV2AccountingStale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"isStale"}},{"kind":"Field","name":{"kind":"Name","value":"syncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUpdatedAt"}}]}}]}}]} as unknown as DocumentNode<ReadStaleInvoiceInfoForCompanyQuery, ReadStaleInvoiceInfoForCompanyQueryVariables>;
export const ReadStalePaymentInfoForCompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadStalePaymentInfoForCompany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentsAccountingStaleInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"syncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"accountingIntegrationType"}},{"kind":"Field","name":{"kind":"Name","value":"paymentUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isStale"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}}]}}]} as unknown as DocumentNode<ReadStalePaymentInfoForCompanyQuery, ReadStalePaymentInfoForCompanyQueryVariables>;
export const UpsertAccountingCompanyConfigAutoSyncInvoiceOnFullyPaidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigAutoSyncInvoiceOnFullyPaid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"autosyncInvoiceOnFullyPaid"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigAutoSyncInvoiceOnFullyPaidMutation, UpsertAccountingCompanyConfigAutoSyncInvoiceOnFullyPaidMutationVariables>;
export const UpsertAccountingCompanyConfigAutoSyncInvoiceOnIssuedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigAutoSyncInvoiceOnIssued"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"autosyncInvoiceOnIssued"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigAutoSyncInvoiceOnIssuedMutation, UpsertAccountingCompanyConfigAutoSyncInvoiceOnIssuedMutationVariables>;
export const UpsertAccountingCompanyConfigDynamicTaxRateCalculationEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigDynamicTaxRateCalculationEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"dynamicTaxRateCalculationEnabled"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigDynamicTaxRateCalculationEnabledMutation, UpsertAccountingCompanyConfigDynamicTaxRateCalculationEnabledMutationVariables>;
export const UpsertAccountingCompanyConfigAutoSyncInvoiceOnPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigAutoSyncInvoiceOnPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"autosyncInvoiceOnPayment"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigAutoSyncInvoiceOnPaymentMutation, UpsertAccountingCompanyConfigAutoSyncInvoiceOnPaymentMutationVariables>;
export const UpsertAccountingCompanyConfigAutoSyncInvoiceOnVoidedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigAutoSyncInvoiceOnVoided"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"autosyncInvoiceOnVoided"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigAutoSyncInvoiceOnVoidedMutation, UpsertAccountingCompanyConfigAutoSyncInvoiceOnVoidedMutationVariables>;
export const UpsertAccountingCompanyConfigAutoSyncPayoutsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigAutoSyncPayouts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"autosyncPayouts"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigAutoSyncPayoutsMutation, UpsertAccountingCompanyConfigAutoSyncPayoutsMutationVariables>;
export const UpsertAccountingCompanyConfigAutoSyncPaymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigAutoSyncPayments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"autosyncPayments"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigAutoSyncPaymentsMutation, UpsertAccountingCompanyConfigAutoSyncPaymentsMutationVariables>;
export const UpsertAccountingCompanyConfigSyncBusinessUnitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigSyncBusinessUnits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"syncBusinessUnits"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigSyncBusinessUnitsMutation, UpsertAccountingCompanyConfigSyncBusinessUnitsMutationVariables>;
export const UpsertAccountingCompanyConfigSyncTaxesFullIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigSyncTaxesFullIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"syncTaxesFullIntegration"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigSyncTaxesFullIntegrationMutation, UpsertAccountingCompanyConfigSyncTaxesFullIntegrationMutationVariables>;
export const UpsertAccountingCompanyConfigSyncInventoryTrackingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigSyncInventoryTracking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"syncUsingInventoryTracking"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigSyncInventoryTrackingMutation, UpsertAccountingCompanyConfigSyncInventoryTrackingMutationVariables>;
export const UpsertAccountingCompanyConfigSyncDiscountsAsNegativeLineItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigSyncDiscountsAsNegativeLineItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"syncDiscountsAsNegativeLineItems"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigSyncDiscountsAsNegativeLineItemsMutation, UpsertAccountingCompanyConfigSyncDiscountsAsNegativeLineItemsMutationVariables>;
export const UpsertAccountingCompanyConfigSyncPayoutsUsingSingleItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigSyncPayoutsUsingSingleItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"syncPayoutsUsingSingleItem"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigSyncPayoutsUsingSingleItemMutation, UpsertAccountingCompanyConfigSyncPayoutsUsingSingleItemMutationVariables>;
export const UpsertAccountingCompanyConfigSyncLocationsAsQbdSubaccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountingCompanyConfigSyncLocationsAsQbdSubaccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"acc_company_config_company_guid_accounting_integration_type_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"syncLocationsAsQbdSubaccounts"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountingCompanyConfigSyncLocationsAsQbdSubaccountsMutation, UpsertAccountingCompanyConfigSyncLocationsAsQbdSubaccountsMutationVariables>;
export const ReadAccountingCompanyConfigQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadAccountingCompanyConfigQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accCompanyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autosyncInvoiceOnFullyPaid"}},{"kind":"Field","name":{"kind":"Name","value":"autosyncInvoiceOnIssued"}},{"kind":"Field","name":{"kind":"Name","value":"autosyncInvoiceOnPayment"}},{"kind":"Field","name":{"kind":"Name","value":"autosyncInvoiceOnVoided"}},{"kind":"Field","name":{"kind":"Name","value":"autosyncPayouts"}},{"kind":"Field","name":{"kind":"Name","value":"autosyncPayments"}},{"kind":"Field","name":{"kind":"Name","value":"syncBusinessUnits"}},{"kind":"Field","name":{"kind":"Name","value":"syncTaxesFullIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"syncUsingInventoryTracking"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicTaxRateCalculationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"syncDiscountsAsNegativeLineItems"}},{"kind":"Field","name":{"kind":"Name","value":"syncPayoutsUsingSingleItem"}},{"kind":"Field","name":{"kind":"Name","value":"syncLocationsAsQbdSubaccounts"}}]}}]}}]} as unknown as DocumentNode<ReadAccountingCompanyConfigQueryQuery, ReadAccountingCompanyConfigQueryQueryVariables>;
export const UpsertCompanyConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"confirmationNotificationSuppressedByDefault"},{"kind":"EnumValue","value":"defaultAccountManagerUserGuid"},{"kind":"EnumValue","value":"locationMunicipalityFieldEnabled"},{"kind":"EnumValue","value":"hiddenEquipmentTypesJsonArray"},{"kind":"EnumValue","value":"visibleInstallProjectTypesJsonArray"},{"kind":"EnumValue","value":"blurb"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyConfigMutation, UpsertCompanyConfigMutationVariables>;
export const UpsertCompanyNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyNotificationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"settings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyNotificationSettingsInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyNotificationSettingsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"settings"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_notification_settings_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"replyToEmail"},{"kind":"EnumValue","value":"estimateAcceptNotifyCreator"},{"kind":"EnumValue","value":"estimateAcceptNotifyEmail"},{"kind":"EnumValue","value":"estimateAcceptNotifyUserGuids"},{"kind":"EnumValue","value":"estimateReminderCount"},{"kind":"EnumValue","value":"estimateReminderFrequency"},{"kind":"EnumValue","value":"estimateReviewedNotifyCreator"},{"kind":"EnumValue","value":"estimateReviewedNotifyUserGuids"},{"kind":"EnumValue","value":"invoicePaymentReminderCount"},{"kind":"EnumValue","value":"invoicePaymentReminderFrequency"},{"kind":"EnumValue","value":"paymentFailedNotifyCreator"},{"kind":"EnumValue","value":"paymentFailedNotifyEmail"},{"kind":"EnumValue","value":"paymentFailedNotifyUserGuids"},{"kind":"EnumValue","value":"materialRestockReportUserGuids"},{"kind":"EnumValue","value":"materialRestockReportEmail"},{"kind":"EnumValue","value":"jobLeadCreatedUserGuids"},{"kind":"EnumValue","value":"jobLeadCreatedEmail"},{"kind":"EnumValue","value":"lapsedPaymentMaintenancePlanUserGuids"},{"kind":"EnumValue","value":"lapsedPaymentMaintenancePlanNotifyEmail"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyNotificationSettingsMutation, UpsertCompanyNotificationSettingsMutationVariables>;
export const UpsertCompanyConfigMaintenancePlansEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyConfigMaintenancePlansEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"maintenancePlansEnabled"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyConfigMaintenancePlansEnabledMutation, UpsertCompanyConfigMaintenancePlansEnabledMutationVariables>;
export const UpsertCompanyConfigTimesheetsEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyConfigTimesheetsEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"timesheetsEnabled"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyConfigTimesheetsEnabledMutation, UpsertCompanyConfigTimesheetsEnabledMutationVariables>;
export const UpsertCompanyConfigTimesheetsPayPeriodEndAnchorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyConfigTimesheetsPayPeriodEndAnchor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"timesheetPayPeriodBeginAnchor"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyConfigTimesheetsPayPeriodEndAnchorMutation, UpsertCompanyConfigTimesheetsPayPeriodEndAnchorMutationVariables>;
export const UpsertCompanyConfigTimesheetsPayPeriodEndRRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyConfigTimesheetsPayPeriodEndRRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"timesheetPayPeriodBeginRrule"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyConfigTimesheetsPayPeriodEndRRuleMutation, UpsertCompanyConfigTimesheetsPayPeriodEndRRuleMutationVariables>;
export const UpsertCompanyConfigTechnicianPerformanceEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyConfigTechnicianPerformanceEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"technicianPerformanceEnabled"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyConfigTechnicianPerformanceEnabledMutation, UpsertCompanyConfigTechnicianPerformanceEnabledMutationVariables>;
export const UpsertCompanyConfigDripMarketingSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyConfigDripMarketingSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"settings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyDripMarketingConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyDripMarketingConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"settings"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_drip_marketing_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"yelpReviewUrl"},{"kind":"EnumValue","value":"googleReviewUrl"},{"kind":"EnumValue","value":"facebookReviewUrl"},{"kind":"EnumValue","value":"jobCompletedEnabled"},{"kind":"EnumValue","value":"jobCompletedDelayMs"},{"kind":"EnumValue","value":"jobCompletedCustomEmailContent"},{"kind":"EnumValue","value":"maintenanceVisitRemindersEnabled"},{"kind":"EnumValue","value":"maintenanceVisitRemindersLimit"},{"kind":"EnumValue","value":"maintenanceVisitRemindersSchedule"},{"kind":"EnumValue","value":"maintenanceVisitRemindersEmailBodyTemplate"},{"kind":"EnumValue","value":"maintenanceVisitRemindersEmailSubjectTemplate"},{"kind":"EnumValue","value":"maintenanceVisitRemindersSmsTemplate"},{"kind":"EnumValue","value":"maintenanceRemindersEnabled"},{"kind":"EnumValue","value":"maintenanceRemindersDelayMonths"},{"kind":"EnumValue","value":"maintenanceRemindersCustomEmailContent"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyConfigDripMarketingSettingsMutation, UpsertCompanyConfigDripMarketingSettingsMutationVariables>;
export const ReadCompanyConfigQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadCompanyConfigQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmationNotificationSuppressedByDefault"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAccountManagerUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenEquipmentTypesJsonArray"}},{"kind":"Field","name":{"kind":"Name","value":"locationMunicipalityFieldEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"visibleInstallProjectTypesJsonArray"}},{"kind":"Field","name":{"kind":"Name","value":"blurb"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansEnabled"}}]}}]}}]} as unknown as DocumentNode<ReadCompanyConfigQueryQuery, ReadCompanyConfigQueryQueryVariables>;
export const FetchPricebookSettingsConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchPricebookSettingsConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookPhotosEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyPricingTierConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberTierEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"memberAddonTierEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"memberAfterhoursTierEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"memberAddonAfterhoursTierEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"addonTierEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"addonAfterhoursTierEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"afterhoursTierEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"businessHoursStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"businessHoursEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"saturdayIsBusinessDay"}},{"kind":"Field","name":{"kind":"Name","value":"sundayIsBusinessDay"}}]}}]}}]} as unknown as DocumentNode<FetchPricebookSettingsConfigQuery, FetchPricebookSettingsConfigQueryVariables>;
export const GetJobSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"summaryHtml"}}]}}]}}]} as unknown as DocumentNode<GetJobSummaryQuery, GetJobSummaryQueryVariables>;
export const CompanyConfigAccountNameTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyConfigAccountNameTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountNameDisplayTemplate"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyConfigAccountNameTemplateQuery, CompanyConfigAccountNameTemplateQueryVariables>;
export const JobsRecentJobsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsRecentJobsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"closedStatuses"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobLifecycleStatusUpdatedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobLifecycleStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"specialStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"closedStatuses"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobLifecycleStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"specialStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobLifecycleStatusUpdatedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobLifecycleStatusUpdatedAt"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatusGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isHotLead"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipRenewalOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isConverted"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipSold"}},{"kind":"Field","name":{"kind":"Name","value":"commissionOverheadDeductionRate"}},{"kind":"Field","name":{"kind":"Name","value":"commissionOverheadFlatDeductionUsc"}},{"kind":"Field","name":{"kind":"Name","value":"commissionJobCostsDeductionRate"}},{"kind":"Field","name":{"kind":"Name","value":"commissionJobCostsFlatDeductionUsc"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userPrimaryHueHex"}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityConversionThresholdUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTeamMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"turnedOverJob"}},{"kind":"Field","name":{"kind":"Name","value":"commissionRate"}},{"kind":"Field","name":{"kind":"Name","value":"bonusUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedJobEstimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicesQueryables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceStatus"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedToJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linked_job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnitGuid"}}]}}]}}]} as unknown as DocumentNode<JobsRecentJobsQueryQuery, JobsRecentJobsQueryQueryVariables>;
export const TagsMinimalForCompanyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TagsMinimalForCompanyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagMinimal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tags"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TagsMinimalForCompanyQueryQuery, TagsMinimalForCompanyQueryQueryVariables>;
export const GetCompanyUniqueZipCodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyUniqueZipCodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinctOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"addressGuid"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}}]} as unknown as DocumentNode<GetCompanyUniqueZipCodesQuery, GetCompanyUniqueZipCodesQueryVariables>;
export const FetchTimesheetsConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchTimesheetsConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"timesheetPayPeriodBeginRrule"}},{"kind":"Field","name":{"kind":"Name","value":"timesheetPayPeriodBeginAnchor"}}]}}]}}]} as unknown as DocumentNode<FetchTimesheetsConfigQuery, FetchTimesheetsConfigQueryVariables>;
export const FetchEndOfJobAppointmentWorkflowEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchEndOfJobAppointmentWorkflowEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endOfJobAppointmentWorkflowEnabled"}}]}}]}}]} as unknown as DocumentNode<FetchEndOfJobAppointmentWorkflowEnabledQuery, FetchEndOfJobAppointmentWorkflowEnabledQueryVariables>;
export const FetchScheduleColorModeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchScheduleColorMode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"companyConfig"},"name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleColorMode"}}]}}]}}]} as unknown as DocumentNode<FetchScheduleColorModeQuery, FetchScheduleColorModeQueryVariables>;
export const UnlinkJobFromIntegratedPhoneCallDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnlinkJobFromIntegratedPhoneCall"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"integratedPhoneCallGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteIntegratedPhoneCallJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"integratedPhoneCallGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"integratedPhoneCallGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<UnlinkJobFromIntegratedPhoneCallMutation, UnlinkJobFromIntegratedPhoneCallMutationVariables>;
export const FetchTechnicianLocationAppointmentAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchTechnicianLocationAppointmentAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"technicianUserGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"technicianUserGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"technicianUserGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchTechnicianLocationAppointmentAssignmentsQuery, FetchTechnicianLocationAppointmentAssignmentsQueryVariables>;
export const FetchTechnicianAccountAppointmentAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchTechnicianAccountAppointmentAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"technicianUserGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"technicianUserGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"technicianUserGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchTechnicianAccountAppointmentAssignmentsQuery, FetchTechnicianAccountAppointmentAssignmentsQueryVariables>;
export const FetchTechnicianJobAppointmentAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchTechnicianJobAppointmentAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"technicianUserGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"technicianUserGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"technicianUserGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}}]}}]}}]} as unknown as DocumentNode<FetchTechnicianJobAppointmentAssignmentQuery, FetchTechnicianJobAppointmentAssignmentQueryVariables>;
export const FetchJobCreatedByUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchJobCreatedByUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}}]}}]}}]} as unknown as DocumentNode<FetchJobCreatedByUserQuery, FetchJobCreatedByUserQueryVariables>;
export const UseCompanyHiddenPaymentMethodsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UseCompanyHiddenPaymentMethodsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingProfileHiddenPaymentMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}}]}}]} as unknown as DocumentNode<UseCompanyHiddenPaymentMethodsQueryQuery, UseCompanyHiddenPaymentMethodsQueryQueryVariables>;
export const CompanyUnreadNotificationsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CompanyUnreadNotificationsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannelReadableItemsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"markedRead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyUnreadNotificationsCountSubscription, CompanyUnreadNotificationsCountSubscriptionVariables>;
export const EndOfVisitJobInvoiceRequiredSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EndOfVisitJobInvoiceRequiredSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobInvoiceIsRequiredToCompleteVisit"}},{"kind":"Field","name":{"kind":"Name","value":"jobInvoiceIsRequiredToCompleteVisitExcludeSalesClass"}}]}}]}}]} as unknown as DocumentNode<EndOfVisitJobInvoiceRequiredSettingsQuery, EndOfVisitJobInvoiceRequiredSettingsQueryVariables>;
export const JobClassDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobClass"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobClass"}}]}}]}}]}}]} as unknown as DocumentNode<JobClassQuery, JobClassQueryVariables>;
export const EndOfVisitReviewSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EndOfVisitReviewSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyNotificationSettingsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endOfVisitSendReviewLinkEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"endOfVisitSendReviewLinkFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"endOfVisitSendReviewLinkCount"}},{"kind":"Field","name":{"kind":"Name","value":"endOfVisitSendReviewLinkType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyReviewLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyReviewLinkGuid"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyReviewLinkGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"reviewType"}},{"kind":"Field","name":{"kind":"Name","value":"platformId"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isEligibleForTechnician"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]}}]} as unknown as DocumentNode<EndOfVisitReviewSettingsQuery, EndOfVisitReviewSettingsQueryVariables>;
export const ReadEstimateTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadEstimateTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EstimateTemplate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EstimateTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EstimateTemplates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateTemplateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}},{"kind":"Field","name":{"kind":"Name","value":"messagePreset"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"optionGuid"},"name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"discountGuid"},"name":{"kind":"Name","value":"estimateOptionDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recommended"},"name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","alias":{"kind":"Name","value":"selected"},"name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"itemType"},"name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemVariant"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]} as unknown as DocumentNode<ReadEstimateTemplatesQuery, ReadEstimateTemplatesQueryVariables>;
export const ReadEstimateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadEstimateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateTemplateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateTemplatesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"estimateTemplateGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateTemplateGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EstimateTemplate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EstimateTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EstimateTemplates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateTemplateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}},{"kind":"Field","name":{"kind":"Name","value":"messagePreset"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"optionGuid"},"name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"discountGuid"},"name":{"kind":"Name","value":"estimateOptionDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recommended"},"name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","alias":{"kind":"Name","value":"selected"},"name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"itemType"},"name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemVariant"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]} as unknown as DocumentNode<ReadEstimateTemplateQuery, ReadEstimateTemplateQueryVariables>;
export const ReadEstimateTemplateMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadEstimateTemplateMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateTemplateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}}]}}]}}]} as unknown as DocumentNode<ReadEstimateTemplateMetadataQuery, ReadEstimateTemplateMetadataQueryVariables>;
export const GetCompanyBillingProfileFrontendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyBillingProfileFrontend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"visitReplenishmentStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"visitReplenishmentMonth"}},{"kind":"Field","name":{"kind":"Name","value":"visitReplenishmentDay"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceMemo"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"businessFullLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"contractorLicenseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"estimateDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"tilledMerchantAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"websiteDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"businessAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"businessAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalFullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultPricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"defaultTaxRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanTaxRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanServiceItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanServiceItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"guid"},"name":{"kind":"Name","value":"pricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanAutoRenewalAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanManualRenewalAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanStaticDurationNumYearsAllowed"}}]}}]}}]} as unknown as DocumentNode<GetCompanyBillingProfileFrontendQuery, GetCompanyBillingProfileFrontendQueryVariables>;
export const CompanyConfigLineItemVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyConfigLineItemVisibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateLineItemsVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceLineItemsVisibility"}}]}}]}}]} as unknown as DocumentNode<CompanyConfigLineItemVisibilityQuery, CompanyConfigLineItemVisibilityQueryVariables>;
export const LocationMaintenancePlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationMaintenancePlans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansQueryable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACTIVE","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastVisitedAt"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]} as unknown as DocumentNode<LocationMaintenancePlansQuery, LocationMaintenancePlansQueryVariables>;
export const JobMaintenancePlanDiscountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobMaintenancePlanDiscount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobClass"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}}]}}]}}]}}]} as unknown as DocumentNode<JobMaintenancePlanDiscountQuery, JobMaintenancePlanDiscountQueryVariables>;
export const UpsertCompanyBillingProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyBillingProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingProfilesInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertBillingProfilesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"billing_profiles_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"businessAddressGuid"},{"kind":"EnumValue","value":"businessFullLegalName"},{"kind":"EnumValue","value":"contractorLicenseNumber"},{"kind":"EnumValue","value":"defaultPricebookTaxRateGuid"},{"kind":"EnumValue","value":"emailAddressGuid"},{"kind":"EnumValue","value":"estimateDisclaimer"},{"kind":"EnumValue","value":"invoiceMemo"},{"kind":"EnumValue","value":"invoiceTerm"},{"kind":"EnumValue","value":"logoUrl"},{"kind":"EnumValue","value":"maintenancePlanTaxRateGuid"},{"kind":"EnumValue","value":"maintenancePlanServiceItemGuid"},{"kind":"EnumValue","value":"maintenancePlanAutoRenewalAllowed"},{"kind":"EnumValue","value":"maintenancePlanManualRenewalAllowed"},{"kind":"EnumValue","value":"phoneNumberGuid"},{"kind":"EnumValue","value":"tilledMerchantAccountId"},{"kind":"EnumValue","value":"updatedAt"},{"kind":"EnumValue","value":"websiteDisplayName"},{"kind":"EnumValue","value":"websiteUrl"},{"kind":"EnumValue","value":"maintenancePlanStaticDurationNumYearsAllowed"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyBillingProfileMutation, UpsertCompanyBillingProfileMutationVariables>;
export const UpsertRecentPricebookItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertRecentPricebookItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recentPricebookItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecentPricebookItemsInsertInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onConflict"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RecentPricebookItemsOnConflict"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertRecentPricebookItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recentPricebookItems"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onConflict"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertRecentPricebookItemsMutation, UpsertRecentPricebookItemsMutationVariables>;
export const AccountDetailsPageUpdatedAccountViewedAtTimeForUserMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountDetailsPageUpdatedAccountViewedAtTimeForUserMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"viewedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAccountsViewedByUserOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"viewedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"viewedAt"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"accounts_viewed_by_user_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"viewedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<AccountDetailsPageUpdatedAccountViewedAtTimeForUserMutationMutation, AccountDetailsPageUpdatedAccountViewedAtTimeForUserMutationMutationVariables>;
export const AccountsDetailsPageCompanyConfigQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountsDetailsPageCompanyConfigQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountManagerEnabled"}}]}}]}}]} as unknown as DocumentNode<AccountsDetailsPageCompanyConfigQueryQuery, AccountsDetailsPageCompanyConfigQueryQueryVariables>;
export const AccountsDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountsDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountManagerUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"doNotService"}},{"kind":"Field","name":{"kind":"Name","value":"doNotServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"defaultInvoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"accountLeadSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"referringContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"attributionDescription"}},{"kind":"Field","name":{"kind":"Name","value":"referringContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhotoRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhotoRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedHvacSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedHvacSystemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"filterSize"}},{"kind":"Field","name":{"kind":"Name","value":"friendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","alias":{"kind":"Name","value":"zoningInfo"},"name":{"kind":"Name","value":"zoningInfoJson"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InstalledEquipment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InstalledEquipment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedBuildDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSquareFootage"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"municipality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhotoRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhotoRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canceled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationTo"}},{"kind":"Field","name":{"kind":"Name","value":"sendReminderEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicesQueryables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhotoRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"addedByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrequalRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalPaymentId"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecordGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"salutation"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecordStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanStatuses"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loanStatusDetail"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhotoRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoLinks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"noteLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileLinks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"storageStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"fileGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileSizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"fileTypeMime"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InstalledEquipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstalledEquipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"installationParty"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturingDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"operationalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCondition"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}},{"kind":"Field","name":{"kind":"Name","value":"coveredInstalledEquipmentGuids"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledActivationAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingStartAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackTransactionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"requestedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"approvedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"settledLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"processingFeeUsc"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"loanApplicationLink"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecordStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrequalRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maxQualifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"aprRange"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"prequalLink"}}]}}]} as unknown as DocumentNode<AccountsDetailsQuery, AccountsDetailsQueryVariables>;
export const SetAccountArchivedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetAccountArchived"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archived"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archived"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<SetAccountArchivedMutation, SetAccountArchivedMutationVariables>;
export const AccountDetailsPageLinkedPhoneCallsSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AccountDetailsPageLinkedPhoneCallsSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkedIntegratedPhoneCall"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkedIntegratedPhoneCall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegratedPhoneCalls"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallGuid"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneMissedCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneVoicemails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingSummary"}},{"kind":"Field","name":{"kind":"Name","value":"recordingTranscript"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallRecording"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingSummary"}},{"kind":"Field","name":{"kind":"Name","value":"recordingTranscript"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountDetailsPageLinkedPhoneCallsSubscriptionSubscription, AccountDetailsPageLinkedPhoneCallsSubscriptionSubscriptionVariables>;
export const AccountsDetailsV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountsDetailsV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"doNotSyncToAccountingServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"accountManagerUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"accountLeadSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"referringContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"attributionDescription"}},{"kind":"Field","name":{"kind":"Name","value":"referringContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhotoRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhotoRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedHvacSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedHvacSystemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"filterSize"}},{"kind":"Field","name":{"kind":"Name","value":"friendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","alias":{"kind":"Name","value":"zoningInfo"},"name":{"kind":"Name","value":"zoningInfoJson"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InstalledEquipment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InstalledEquipment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedBuildDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSquareFootage"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"municipality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhotoRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhotoRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canceled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationTo"}},{"kind":"Field","name":{"kind":"Name","value":"sendReminderEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reminderLastSentAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhotoRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"addedByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrequalRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalPaymentId"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecordGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"salutation"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecordStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanStatuses"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loanStatusDetail"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhotoRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoLinks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"noteLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"note"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileLinks"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"storageStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"fileGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileSizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"fileTypeMime"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InstalledEquipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstalledEquipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"installationParty"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturingDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"operationalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCondition"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}},{"kind":"Field","name":{"kind":"Name","value":"coveredInstalledEquipmentGuids"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledActivationAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingStartAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackTransactionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"requestedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"approvedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"settledLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"processingFeeUsc"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"loanApplicationLink"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecordStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrequalRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maxQualifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"aprRange"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"prequalLink"}}]}}]} as unknown as DocumentNode<AccountsDetailsV2Query, AccountsDetailsV2QueryVariables>;
export const AccountMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"doNotSyncToAccountingServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"accountManagerUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"doNotService"}},{"kind":"Field","name":{"kind":"Name","value":"doNotServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"defaultInvoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountLeadSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"referringContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"attributionDescription"}},{"kind":"Field","name":{"kind":"Name","value":"referringContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountMetadataQuery, AccountMetadataQueryVariables>;
export const AccountManagerEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountManagerEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountManagerEnabled"}}]}}]}}]} as unknown as DocumentNode<AccountManagerEnabledQuery, AccountManagerEnabledQueryVariables>;
export const AvailableAccountJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailableAccountJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayId"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AvailableAccountJobsQuery, AvailableAccountJobsQueryVariables>;
export const AvailableAccountLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailableAccountLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AvailableAccountLocationsQuery, AvailableAccountLocationsQueryVariables>;
export const CustomerNumberEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerNumberEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerNumberEnabled"}}]}}]}}]} as unknown as DocumentNode<CustomerNumberEnabledQuery, CustomerNumberEnabledQueryVariables>;
export const AccountContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountContactsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"salutation"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountContactsQuery, AccountContactsQueryVariables>;
export const AccountLocationsEquipmentAndHvacSystemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountLocationsEquipmentAndHvacSystems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mailingAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"installedHvacSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedHvacSystemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"filterSize"}},{"kind":"Field","name":{"kind":"Name","value":"friendlyName"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","alias":{"kind":"Name","value":"zoningInfo"},"name":{"kind":"Name","value":"zoningInfoJson"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InstalledEquipment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InstalledEquipment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"isBillingAddress"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InstalledEquipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstalledEquipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"installationParty"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturingDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"operationalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCondition"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}}]}}]} as unknown as DocumentNode<AccountLocationsEquipmentAndHvacSystemsQuery, AccountLocationsEquipmentAndHvacSystemsQueryVariables>;
export const PaginatedEstimatesCollapsibleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaginatedEstimatesCollapsible"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimatesBoolExp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EstimateCollapsibleEstimate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EstimateCollapsibleEstimate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Estimates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"closedLostReasonCategory"}},{"kind":"Field","name":{"kind":"Name","value":"closedLostReasonNote"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}}]}}]}}]} as unknown as DocumentNode<PaginatedEstimatesCollapsibleQuery, PaginatedEstimatesCollapsibleQueryVariables>;
export const AccountInvoicesCollapsibleCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountInvoicesCollapsibleCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoicesAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issuedAt"},"value":{"kind":"EnumValue","value":"DESC_NULLS_FIRST"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cartItems"},"name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"discounts"},"name":{"kind":"Name","value":"invoiceDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountInvoicesCollapsibleCardsQuery, AccountInvoicesCollapsibleCardsQueryVariables>;
export const AccountJobsCollapsibleV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountJobsCollapsibleV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecord"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","alias":{"kind":"Name","value":"completedAt"},"name":{"kind":"Name","value":"workCompletedAt"}}]}}]}}]}}]} as unknown as DocumentNode<AccountJobsCollapsibleV2Query, AccountJobsCollapsibleV2QueryVariables>;
export const AccountLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountLocationsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"archivedAccountLocationsAggregate"},"name":{"kind":"Name","value":"accountLocationsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isBillingAddress"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedBuildDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSquareFootage"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"municipality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"isBillingAddress"}}]}}]}}]}}]} as unknown as DocumentNode<AccountLocationsQuery, AccountLocationsQueryVariables>;
export const AccountMaintenancePlansCollapsibleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountMaintenancePlansCollapsible"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanCollapsibleData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}},{"kind":"Field","name":{"kind":"Name","value":"coveredInstalledEquipmentGuids"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledActivationAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingStartAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}}]}}]} as unknown as DocumentNode<AccountMaintenancePlansCollapsibleQuery, AccountMaintenancePlansCollapsibleQueryVariables>;
export const AccountPaymentsCollapsibleV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountPaymentsCollapsibleV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalPaymentId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodAdditionalInfo"}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"loanRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecord"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecordStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanStatuses"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loanStatusDetail"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackTransactionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"requestedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"approvedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"settledLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"processingFeeUsc"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"loanApplicationLink"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecordStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<AccountPaymentsCollapsibleV2Query, AccountPaymentsCollapsibleV2QueryVariables>;
export const AccountVisitsCollapsibleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountVisitsCollapsible"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentWindowStart"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canceled"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountVisitsCollapsibleQuery, AccountVisitsCollapsibleQueryVariables>;
export const AccountWisetackFinancingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountWisetackFinancing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecord"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrequalRecord"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecordStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanStatuses"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loanStatusDetail"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackTransactionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"requestedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"approvedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"settledLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"processingFeeUsc"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"loanApplicationLink"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecordStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrequalRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackPrequalRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackPrequalGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"maxQualifiedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"aprRange"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"prequalifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"prequalLink"}}]}}]} as unknown as DocumentNode<AccountWisetackFinancingQuery, AccountWisetackFinancingQueryVariables>;
export const AttachmentsTabAccountFilesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AttachmentsTabAccountFilesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"storageStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"fileGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fileSizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"fileTypeMime"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AttachmentsTabAccountFilesQueryQuery, AttachmentsTabAccountFilesQueryQueryVariables>;
export const AccountExperienceOnlineBookingConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountExperienceOnlineBookingConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tzId"},"name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"billingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingCompanyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountExperienceOnlineBookingCompanyConfig"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingServiceTypeConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountExperienceOnlineBookingServiceTypeConfig"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyAppointmentArrivalWindows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyAppointmentArrivalWindow"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountExperienceOnlineBookingCompanyConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OnlineBookingCompanyConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limitBookingsToServiceAreaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"brandingColorHex"}},{"kind":"Field","name":{"kind":"Name","value":"afterHoursBannerHtml"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAreaZipCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountExperienceOnlineBookingServiceTypeConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OnlineBookingServiceTypeConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlineBookingServiceTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"serviceType"}},{"kind":"Field","name":{"kind":"Name","value":"bookingType"}},{"kind":"Field","name":{"kind":"Name","value":"earliestAvailability"}},{"kind":"Field","name":{"kind":"Name","value":"latestAvailability"}},{"kind":"Field","name":{"kind":"Name","value":"legalBlurbHtml"}},{"kind":"Field","name":{"kind":"Name","value":"bookableJobTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"instantBookingWeeklyScheduleEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"bookableArrivalWindows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arrivalWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyAppointmentArrivalWindowGuid"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowEndTime"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyAppointmentArrivalWindow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyAppointmentArrivalWindows"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyAppointmentArrivalWindowGuid"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowEndTime"}}]}}]} as unknown as DocumentNode<AccountExperienceOnlineBookingConfigQuery, AccountExperienceOnlineBookingConfigQueryVariables>;
export const AccountExperienceOnlineBookingCompanyConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountExperienceOnlineBookingCompanyConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tzId"},"name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"billingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingCompanyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountExperienceOnlineBookingCompanyConfig"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyAppointmentArrivalWindows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyAppointmentArrivalWindow"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountExperienceOnlineBookingCompanyConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OnlineBookingCompanyConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limitBookingsToServiceAreaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"brandingColorHex"}},{"kind":"Field","name":{"kind":"Name","value":"afterHoursBannerHtml"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAreaZipCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyAppointmentArrivalWindow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyAppointmentArrivalWindows"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyAppointmentArrivalWindowGuid"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowEndTime"}}]}}]} as unknown as DocumentNode<AccountExperienceOnlineBookingCompanyConfigQuery, AccountExperienceOnlineBookingCompanyConfigQueryVariables>;
export const JobTypeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobTypeQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTypeGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobTypeGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobTypeGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}}]}}]}}]} as unknown as DocumentNode<JobTypeQueryQuery, JobTypeQueryQueryVariables>;
export const AccountsListPageDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountsListPageData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountsBoolExp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountsOrderBy"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountsListPageAccountsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountsListPageAccountsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Accounts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"doNotService"}},{"kind":"Field","name":{"kind":"Name","value":"doNotServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastJobDate"}},{"kind":"Field","name":{"kind":"Name","value":"accountJobCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equipmentType"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}}]} as unknown as DocumentNode<AccountsListPageDataQuery, AccountsListPageDataQueryVariables>;
export const AccountsListPageDataByJobCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountsListPageDataByJobCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showArchived"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"accountsSortedByJobCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_company_guid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_show_archived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showArchived"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountsListPageAccountsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showArchived"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountsListPageAccountsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Accounts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"doNotService"}},{"kind":"Field","name":{"kind":"Name","value":"doNotServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastJobDate"}},{"kind":"Field","name":{"kind":"Name","value":"accountJobCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equipmentType"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}}]} as unknown as DocumentNode<AccountsListPageDataByJobCountQuery, AccountsListPageDataByJobCountQueryVariables>;
export const AccountsListPageDataByRecentlyViewedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountsListPageDataByRecentlyViewed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountsBoolExp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"accountsSortedByRecentlyViewedForUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_company_guid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_user_guid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountsListPageAccountsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountsListPageAccountsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Accounts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"doNotService"}},{"kind":"Field","name":{"kind":"Name","value":"doNotServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastJobDate"}},{"kind":"Field","name":{"kind":"Name","value":"accountJobCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equipmentType"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}}]} as unknown as DocumentNode<AccountsListPageDataByRecentlyViewedQuery, AccountsListPageDataByRecentlyViewedQueryVariables>;
export const AccountsListPageTotalAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountsListPageTotalAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountsBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<AccountsListPageTotalAccountsQuery, AccountsListPageTotalAccountsQueryVariables>;
export const AccountsListPageCompanyConfigQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountsListPageCompanyConfigQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerNumberEnabled"}}]}}]}}]} as unknown as DocumentNode<AccountsListPageCompanyConfigQueryQuery, AccountsListPageCompanyConfigQueryQueryVariables>;
export const CreateCompanyDrawerLeadSourcesSectionCanonicalLeadSourcesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateCompanyDrawerLeadSourcesSectionCanonicalLeadSourcesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"attributionLinkingStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"attributionPrompt"}}]}}]}}]} as unknown as DocumentNode<CreateCompanyDrawerLeadSourcesSectionCanonicalLeadSourcesQueryQuery, CreateCompanyDrawerLeadSourcesSectionCanonicalLeadSourcesQueryQueryVariables>;
export const UpdateEndOfJobAppointmentWorkflowEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEndOfJobAppointmentWorkflowEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endOfJobAppointmentWorkflowEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateEndOfJobAppointmentWorkflowEnabledMutation, UpdateEndOfJobAppointmentWorkflowEnabledMutationVariables>;
export const UpdateEndOfJobAppointmentWorkflowSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEndOfJobAppointmentWorkflowSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyNotificationSettingsInsertInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobInvoiceRequired"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobInvoiceRequiredExcludeSalesClass"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endOfJobAppointmentWorkflowEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobInvoiceIsRequiredToCompleteVisit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobInvoiceRequired"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobInvoiceIsRequiredToCompleteVisitExcludeSalesClass"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobInvoiceRequiredExcludeSalesClass"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertCompanyNotificationSettingsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationSettings"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_notification_settings_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"replyToEmail"},{"kind":"EnumValue","value":"estimateAcceptNotifyCreator"},{"kind":"EnumValue","value":"estimateAcceptNotifyEmail"},{"kind":"EnumValue","value":"estimateAcceptNotifyUserGuids"},{"kind":"EnumValue","value":"estimateReminderCount"},{"kind":"EnumValue","value":"estimateReminderFrequency"},{"kind":"EnumValue","value":"estimateReviewedNotifyCreator"},{"kind":"EnumValue","value":"estimateReviewedNotifyUserGuids"},{"kind":"EnumValue","value":"invoicePaymentReminderCount"},{"kind":"EnumValue","value":"invoicePaymentReminderFrequency"},{"kind":"EnumValue","value":"paymentFailedNotifyCreator"},{"kind":"EnumValue","value":"paymentFailedNotifyEmail"},{"kind":"EnumValue","value":"paymentFailedNotifyUserGuids"},{"kind":"EnumValue","value":"materialRestockReportUserGuids"},{"kind":"EnumValue","value":"materialRestockReportEmail"},{"kind":"EnumValue","value":"jobLeadCreatedUserGuids"},{"kind":"EnumValue","value":"jobLeadCreatedEmail"},{"kind":"EnumValue","value":"endOfVisitSendReviewLinkEnabled"},{"kind":"EnumValue","value":"endOfVisitSendReviewLinkFrequency"},{"kind":"EnumValue","value":"endOfVisitSendReviewLinkCount"},{"kind":"EnumValue","value":"endOfVisitSendReviewLinkType"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateEndOfJobAppointmentWorkflowSettingsMutation, UpdateEndOfJobAppointmentWorkflowSettingsMutationVariables>;
export const GetEndOfVisitNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEndOfVisitNotificationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyNotificationSettingsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endOfVisitSendReviewLinkEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"endOfVisitSendReviewLinkFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"endOfVisitSendReviewLinkCount"}},{"kind":"Field","name":{"kind":"Name","value":"endOfVisitSendReviewLinkType"}}]}}]}}]} as unknown as DocumentNode<GetEndOfVisitNotificationSettingsQuery, GetEndOfVisitNotificationSettingsQueryVariables>;
export const AssistantsSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssistantsSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssistantsBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assistants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assistantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"assistantPhoneSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstMessage"}},{"kind":"Field","name":{"kind":"Name","value":"promptHtml"}},{"kind":"Field","name":{"kind":"Name","value":"endCallMessage"}},{"kind":"Field","name":{"kind":"Name","value":"forwardPhoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assistantIntegratedPhones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssistantsSettingsQuery, AssistantsSettingsQueryVariables>;
export const UpsertAssistantsSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAssistantsSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssistantsInsertInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onConflict"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssistantsOnConflict"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAssistantsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onConflict"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}}]}}]} as unknown as DocumentNode<UpsertAssistantsSettingsMutation, UpsertAssistantsSettingsMutationVariables>;
export const BillingProfileSettingsPageBillingProfileQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BillingProfileSettingsPageBillingProfileQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessFullLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"contractorLicenseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"defaultPricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"estimateDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceMemo"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"logoPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"logoPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanServiceItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanAutoRenewalAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanManualRenewalAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"tilledMerchantAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"websiteDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"businessAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blurb"}}]}}]}}]} as unknown as DocumentNode<BillingProfileSettingsPageBillingProfileQueryQuery, BillingProfileSettingsPageBillingProfileQueryQueryVariables>;
export const BillingProfileSettingsPageBillingProfileUpsertMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BillingProfileSettingsPageBillingProfileUpsertMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingProfilesInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertBillingProfilesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"billing_profiles_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"businessAddressGuid"},{"kind":"EnumValue","value":"businessFullLegalName"},{"kind":"EnumValue","value":"contractorLicenseNumber"},{"kind":"EnumValue","value":"defaultPricebookTaxRateGuid"},{"kind":"EnumValue","value":"emailAddressGuid"},{"kind":"EnumValue","value":"estimateDisclaimer"},{"kind":"EnumValue","value":"invoiceDisclaimer"},{"kind":"EnumValue","value":"invoiceMemo"},{"kind":"EnumValue","value":"invoiceTerm"},{"kind":"EnumValue","value":"logoUrl"},{"kind":"EnumValue","value":"maintenancePlanTaxRateGuid"},{"kind":"EnumValue","value":"maintenancePlanServiceItemGuid"},{"kind":"EnumValue","value":"maintenancePlanAutoRenewalAllowed"},{"kind":"EnumValue","value":"maintenancePlanManualRenewalAllowed"},{"kind":"EnumValue","value":"phoneNumberGuid"},{"kind":"EnumValue","value":"tilledMerchantAccountId"},{"kind":"EnumValue","value":"updatedAt"},{"kind":"EnumValue","value":"websiteDisplayName"},{"kind":"EnumValue","value":"websiteUrl"},{"kind":"EnumValue","value":"logoPhotoGuid"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<BillingProfileSettingsPageBillingProfileUpsertMutationMutation, BillingProfileSettingsPageBillingProfileUpsertMutationMutationVariables>;
export const BillingProfileSettingsPagePricebookTaxRatesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BillingProfileSettingsPagePricebookTaxRatesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}}]}}]}}]} as unknown as DocumentNode<BillingProfileSettingsPagePricebookTaxRatesQueryQuery, BillingProfileSettingsPagePricebookTaxRatesQueryQueryVariables>;
export const BillingProfileSettingsPageCompanyConfigUpsertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BillingProfileSettingsPageCompanyConfigUpsert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"blurb"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<BillingProfileSettingsPageCompanyConfigUpsertMutation, BillingProfileSettingsPageCompanyConfigUpsertMutationVariables>;
export const BookkeeperListPageQueryInvoiceV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BookkeeperListPageQueryInvoiceV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicesBoolExp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"estimateLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"locationLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicPricingType"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateName"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"billingContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"messageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceReminderData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remindersSent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qboStaleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"syncedAt"},"name":{"kind":"Name","value":"qboSyncedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"stale"},"name":{"kind":"Name","value":"isQboStale"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qboSync"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qboId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingStaleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isStale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doNotSyncToAccountingServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"payoutItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"payoutGuid"}},{"kind":"Field","name":{"kind":"Name","value":"qboSync"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qboId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"childPayoutItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemAmountUsc"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qboSync"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qboId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaidAt"}},{"kind":"Field","name":{"kind":"Name","value":"paidUsc"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<BookkeeperListPageQueryInvoiceV2Query, BookkeeperListPageQueryInvoiceV2QueryVariables>;
export const FetchCompanyBusinessUnitsEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchCompanyBusinessUnitsEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnitsRequired"}}]}}]}}]} as unknown as DocumentNode<FetchCompanyBusinessUnitsEnabledQuery, FetchCompanyBusinessUnitsEnabledQueryVariables>;
export const UpsertCompanyBusinessUnitsEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyBusinessUnitsEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"businessUnitsEnabled"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyBusinessUnitsEnabledMutation, UpsertCompanyBusinessUnitsEnabledMutationVariables>;
export const UpsertCompanyBusinessUnitsRequiredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyBusinessUnitsRequired"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"businessUnitsRequired"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyBusinessUnitsRequiredMutation, UpsertCompanyBusinessUnitsRequiredMutationVariables>;
export const FetchCompanyBusinessUnitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchCompanyBusinessUnits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnitsRequired"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountingIntegrationName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentBusinessUnitTargetMetricsView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"gpPerManDayTargetUsc"}},{"kind":"Field","name":{"kind":"Name","value":"gpPerManDayGoalUsc"}}]}}]}}]} as unknown as DocumentNode<FetchCompanyBusinessUnitsQuery, FetchCompanyBusinessUnitsQueryVariables>;
export const UpsertBusinessUnitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertBusinessUnit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitsInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertBusinessUnitsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"business_units_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"updatedAt"},{"kind":"EnumValue","value":"accountingIntegrationName"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertBusinessUnitMutation, UpsertBusinessUnitMutationVariables>;
export const CloseBusinessUnitTargetMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CloseBusinessUnitTargetMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBusinessUnitTargetMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"businessUnitGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessUnitGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dateEnd"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dateEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateEnd"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<CloseBusinessUnitTargetMetricsMutation, CloseBusinessUnitTargetMetricsMutationVariables>;
export const InsertBusinessUnitTargetMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertBusinessUnitTargetMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessUnitTargetMetricsInsertInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertBusinessUnitTargetMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<InsertBusinessUnitTargetMetricsMutation, InsertBusinessUnitTargetMetricsMutationVariables>;
export const GetRecentPhoneCallsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GetRecentPhoneCalls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCalls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"500"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallGuid"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"answeredAt"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assistantIntegratedPhone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assistant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assistantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneMissedCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneMissedCallGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackStrategyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneMissedCallDismissals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneVoicemails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingTranscript"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"recordingDurationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"recordingSummary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallRecording"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"recordingTranscript"}},{"kind":"Field","name":{"kind":"Name","value":"recordingDurationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"recordingSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fromPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"toPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRecentPhoneCallsSubscription, GetRecentPhoneCallsSubscriptionVariables>;
export const DismissMissedCallDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissMissedCall"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"obj"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegratedPhoneMissedCallDismissalsInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertIntegratedPhoneMissedCallDismissalsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"obj"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<DismissMissedCallMutation, DismissMissedCallMutationVariables>;
export const DeleteMissedCallDismissalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMissedCallDismissals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"integratedPhoneMissedCallGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteIntegratedPhoneMissedCallDismissals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"integratedPhoneMissedCallGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"integratedPhoneMissedCallGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<DeleteMissedCallDismissalsMutation, DeleteMissedCallDismissalsMutationVariables>;
export const CompleteCallsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteCalls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completedByUserGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"integratedPhoneCallGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegratedPhoneCalls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completedAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"completedByUserGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completedByUserGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"integratedPhoneCallGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"integratedPhoneCallGuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<CompleteCallsMutation, CompleteCallsMutationVariables>;
export const UncompleteCallDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UncompleteCall"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"integratedPhoneCallGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegratedPhoneCalls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completedAt"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"completedByUserGuid"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"integratedPhoneCallGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"integratedPhoneCallGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<UncompleteCallMutation, UncompleteCallMutationVariables>;
export const GetChannelItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GetChannelItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"integratedChannelGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedChannelReadableItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"markedRead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannelItemGuid"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"allIntegratedChannelReadableItems"},"name":{"kind":"Name","value":"integratedChannelReadableItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannelItemGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedChannelCompletableItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"markedCompleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannelItemGuid"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"allIntegratedChannelCompletableItems"},"name":{"kind":"Name","value":"integratedChannelCompletableItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannelItemGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedChannelItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC_NULLS_LAST"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannelItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallGuid"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"answeredAt"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assistantIntegratedPhone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assistant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assistantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneMissedCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneMissedCallGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackStrategyUsed"}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneMissedCallDismissals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneVoicemails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingTranscript"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"recordingDurationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"recordingSummary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallRecording"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"recordingTranscript"}},{"kind":"Field","name":{"kind":"Name","value":"recordingDurationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"recordingSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fromPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"toPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedMessageGuid"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"fromPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"toPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"externalMessageId"}},{"kind":"Field","name":{"kind":"Name","value":"sentByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"integratedMessageStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedMessageStatusGuid"}},{"kind":"Field","name":{"kind":"Name","value":"isDraft"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"deliveredAt"}},{"kind":"Field","name":{"kind":"Name","value":"receivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"failedAt"}},{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"dismissedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedByUserGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetChannelItemsSubscription, GetChannelItemsSubscriptionVariables>;
export const GetLatestInboxChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestInboxChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegratedChannelsBoolExp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegratedChannelsOrderBy"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannelGuid"}}]}}]}}]} as unknown as DocumentNode<GetLatestInboxChannelQuery, GetLatestInboxChannelQueryVariables>;
export const GetInboxChannelPreviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GetInboxChannelPreviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegratedChannelsBoolExp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegratedChannelsOrderBy"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannelGuid"}},{"kind":"Field","name":{"kind":"Name","value":"externalPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedChannelItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC_NULLS_LAST"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannelItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"integratedMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedMessageGuid"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"integratedMessageStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDraft"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"deliveredAt"}},{"kind":"Field","name":{"kind":"Name","value":"receivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"failedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dismissedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallGuid"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"answeredAt"}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneMissedCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneMissedCallGuid"}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneMissedCallDismissals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneVoicemails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingTranscript"}},{"kind":"Field","name":{"kind":"Name","value":"recordingDurationSeconds"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedChannelReadableItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"markedRead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannelItemGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedChannelCompletableItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"markedCompleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannelItemGuid"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"allIntegratedChannelCompletableItems"},"name":{"kind":"Name","value":"integratedChannelCompletableItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedChannelItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"markedCompleted"}}]}}]}}]}}]} as unknown as DocumentNode<GetInboxChannelPreviewsSubscription, GetInboxChannelPreviewsSubscriptionVariables>;
export const GetAllPhoneContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllPhoneContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllPhoneContactsQuery, GetAllPhoneContactsQueryVariables>;
export const CompanyConfigSettingsPageCompanyConfigSettingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyConfigSettingsPageCompanyConfigSettingsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmationNotificationSuppressedByDefault"}},{"kind":"Field","name":{"kind":"Name","value":"hideArrivalWindowInNotifications"}},{"kind":"Field","name":{"kind":"Name","value":"defaultAccountManagerUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenEquipmentTypesJsonArray"}},{"kind":"Field","name":{"kind":"Name","value":"locationMunicipalityFieldEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"visibleInstallProjectTypesJsonArray"}},{"kind":"Field","name":{"kind":"Name","value":"blurb"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"accountManagerEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumberEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userByUserGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fullName"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyConfigSettingsPageCompanyConfigSettingsQueryQuery, CompanyConfigSettingsPageCompanyConfigSettingsQueryQueryVariables>;
export const CompanyConfigSettingsPageCompanyConfigUpsertOneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompanyConfigSettingsPageCompanyConfigUpsertOne"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"blurb"},{"kind":"EnumValue","value":"confirmationNotificationSuppressedByDefault"},{"kind":"EnumValue","value":"hideArrivalWindowInNotifications"},{"kind":"EnumValue","value":"defaultAccountManagerUserGuid"},{"kind":"EnumValue","value":"hiddenEquipmentTypesJsonArray"},{"kind":"EnumValue","value":"locationMunicipalityFieldEnabled"},{"kind":"EnumValue","value":"visibleInstallProjectTypesJsonArray"},{"kind":"EnumValue","value":"accountManagerEnabled"},{"kind":"EnumValue","value":"customerNumberEnabled"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<CompanyConfigSettingsPageCompanyConfigUpsertOneMutation, CompanyConfigSettingsPageCompanyConfigUpsertOneMutationVariables>;
export const LocationOptionMaintenancePlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationOptionMaintenancePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledActivationAt"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"numVisitCreditsPerYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"coveredInstalledEquipmentGuids"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]} as unknown as DocumentNode<LocationOptionMaintenancePlanQuery, LocationOptionMaintenancePlanQueryVariables>;
export const MostRecentAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MostRecentAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentWindowStart"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"locationGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}}]}}]} as unknown as DocumentNode<MostRecentAppointmentQuery, MostRecentAppointmentQueryVariables>;
export const FetchActivatedMaintenancePlanDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"FetchActivatedMaintenancePlanData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansQueryable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"maintenancePlanGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinitionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"defaultBusinessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"allowedPaymentIntervals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinitionAllowedPaymentIntervalGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInterval"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinitionBenefitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinitionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountJobClass"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinitionDiscountGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}},{"kind":"Field","name":{"kind":"Name","value":"numDaysUntilVisitCreditExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"numVisitCreditsPerYear"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyStaticPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"visitConfigs"}},{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAvailableForSale"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinitionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinitionMarketingInfoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]} as unknown as DocumentNode<FetchActivatedMaintenancePlanDataSubscription, FetchActivatedMaintenancePlanDataSubscriptionVariables>;
export const MaintenancePlanWizardAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaintenancePlanWizardAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"salutation"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanWizardAccountQuery, MaintenancePlanWizardAccountQueryVariables>;
export const MaintenancePlanWizardSelectedAccountLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaintenancePlanWizardSelectedAccountLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"locationGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGuid"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedBuildDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSquareFootage"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"municipality"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanMinimal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InstalledEquipment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"isBillingAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanDefinitionMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanDefinitions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanDefinitionMinimal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InstalledEquipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstalledEquipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"installationParty"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturingDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"operationalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCondition"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}}]}}]} as unknown as DocumentNode<MaintenancePlanWizardSelectedAccountLocationQuery, MaintenancePlanWizardSelectedAccountLocationQueryVariables>;
export const MaintenancePlanWizardPaginatedAccountLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaintenancePlanWizardPaginatedAccountLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountLocationsBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountLocationsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isBillingAddress"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedBuildDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSquareFootage"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"municipality"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanMinimal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InstalledEquipment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"isBillingAddress"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanDefinitionMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanDefinitions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanDefinitionMinimal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InstalledEquipment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InstalledEquipment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"installationParty"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturingDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"operationalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCondition"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"laborWarrantyTerms"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentDimensions"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}}]}}]} as unknown as DocumentNode<MaintenancePlanWizardPaginatedAccountLocationsQuery, MaintenancePlanWizardPaginatedAccountLocationsQueryVariables>;
export const MaintenancePlanLimitedAccountJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaintenancePlanLimitedAccountJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobsBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}}]}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanLimitedAccountJobsQuery, MaintenancePlanLimitedAccountJobsQueryVariables>;
export const MaintenancePlanWizardSelectedAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaintenancePlanWizardSelectedAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobLifecycleStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"specialStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"Completed","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatusUpdatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"jobCreatedAt"},"name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanWizardSelectedAccountQuery, MaintenancePlanWizardSelectedAccountQueryVariables>;
export const FetchCompanyUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchCompanyUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deactivatedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleById"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPrimaryHueHex"}}]}}]}}]} as unknown as DocumentNode<FetchCompanyUsersQuery, FetchCompanyUsersQueryVariables>;
export const HcpCompanyMigrationProfileDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HCPCompanyMigrationProfileDataQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatusGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<HcpCompanyMigrationProfileDataQueryQuery, HcpCompanyMigrationProfileDataQueryQueryVariables>;
export const CompanyDripMarketingConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyDripMarketingConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyDripMarketingConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yelpReviewUrl"}},{"kind":"Field","name":{"kind":"Name","value":"googleReviewUrl"}},{"kind":"Field","name":{"kind":"Name","value":"facebookReviewUrl"}},{"kind":"Field","name":{"kind":"Name","value":"jobCompletedEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"jobCompletedDelayMs"}},{"kind":"Field","name":{"kind":"Name","value":"jobCompletedCustomEmailContent"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceVisitRemindersEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceVisitRemindersLimit"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceVisitRemindersSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceVisitRemindersEmailBodyTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceVisitRemindersEmailSubjectTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceVisitRemindersSmsTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceRemindersEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceRemindersDelayMonths"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceRemindersCustomEmailContent"}}]}}]}}]} as unknown as DocumentNode<CompanyDripMarketingConfigQuery, CompanyDripMarketingConfigQueryVariables>;
export const FetchVisitRemindersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchVisitReminders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanNextVisits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"visitReminderLastSentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"visitStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"SCHEDULED","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"affinityDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endTime"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}}]}}]}}]} as unknown as DocumentNode<FetchVisitRemindersQuery, FetchVisitRemindersQueryVariables>;
export const BillingProfileForBasicBrandedEmailPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BillingProfileForBasicBrandedEmailPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingProfilesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"websiteDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<BillingProfileForBasicBrandedEmailPreviewQuery, BillingProfileForBasicBrandedEmailPreviewQueryVariables>;
export const CompanyEstimateSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyEstimateSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateDisplayTechnicianName"}},{"kind":"Field","name":{"kind":"Name","value":"estimateLineItemsVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRehashEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"estimateAutoExpirationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"estimateAutoExpirationDays"}}]}}]}}]} as unknown as DocumentNode<CompanyEstimateSettingsQuery, CompanyEstimateSettingsQueryVariables>;
export const UpdateCompanyEstimateSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCompanyEstimateSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigSetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateCompanyEstimateSettingsMutation, UpdateCompanyEstimateSettingsMutationVariables>;
export const MarkEstimateTemplateDeletedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkEstimateTemplateDeleted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateTemplateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEstimateTemplatesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"estimateTemplateGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateTemplateGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]}}]} as unknown as DocumentNode<MarkEstimateTemplateDeletedMutation, MarkEstimateTemplateDeletedMutationVariables>;
export const GetEstimateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEstimateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateTemplateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateTemplatesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"estimateTemplateGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateTemplateGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateTemplateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}},{"kind":"Field","name":{"kind":"Name","value":"customMessageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"messagePreset"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemVariant"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateOptionDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEstimateTemplateQuery, GetEstimateTemplateQueryVariables>;
export const CreateEstimateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEstimateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimateTemplatesInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertEstimateTemplatesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateTemplateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}}]}}]}}]} as unknown as DocumentNode<CreateEstimateTemplateMutation, CreateEstimateTemplateMutationVariables>;
export const UpdateEstimateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEstimateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateTemplateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimateTemplatesSetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEstimateTemplatesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"estimateTemplateGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateTemplateGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateTemplateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}}]}}]}}]} as unknown as DocumentNode<UpdateEstimateTemplateMutation, UpdateEstimateTemplateMutationVariables>;
export const UpsertEstimateTemplateWithOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertEstimateTemplateWithOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateTemplateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimateTemplatesInsertInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validCartItemGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateOptionDiscountGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateOptionGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertEstimateTemplatesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"estimate_templates_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"templateName"},{"kind":"EnumValue","value":"customMessageHtml"},{"kind":"EnumValue","value":"messagePreset"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateTemplateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"estimateOptionCartItems"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"estimateOptionGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateOptionGuids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cartItemGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validCartItemGuids"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteEstimateOptionDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"estimateOptionGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateOptionGuids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"estimateOptionDiscountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateOptionDiscountGuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteEstimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"estimateTemplateGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateTemplateGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"estimateOptionGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateOptionGuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<UpsertEstimateTemplateWithOptionsMutation, UpsertEstimateTemplateWithOptionsMutationVariables>;
export const UpdateEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimatesSetInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clearSelectedOptionsEstimateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEstimates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"estimateGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateEstimateOptionsMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"estimateGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clearSelectedOptionsEstimateGuid"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isSelected"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateEstimateMutation, UpdateEstimateMutationVariables>;
export const UpsertEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimatesInsertInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validCartItemGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateOptionDiscountGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateOptionGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimatePhotoGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPhotoLinks"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoLinksInsertInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertEstimatesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimate"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"estimates_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"messageHtml"},{"kind":"EnumValue","value":"maintenancePlanSavingsEnabled"},{"kind":"EnumValue","value":"hideLineItemPrices"},{"kind":"EnumValue","value":"status"},{"kind":"EnumValue","value":"taxRate"},{"kind":"EnumValue","value":"taxRateName"},{"kind":"EnumValue","value":"taxRateGuid"},{"kind":"EnumValue","value":"dynamicPricingType"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"estimateOptionCartItems"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"estimateOptionGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateOptionGuids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cartItemGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validCartItemGuids"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteEstimateOptionDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"estimateOption"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"estimateGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"estimateOptionDiscountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateOptionDiscountGuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteEstimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"estimateGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"estimateOptionGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateOptionGuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteEstimatePhotos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"estimateGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"photoGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimatePhotoGuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertPhotoLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPhotoLinks"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"photo_links_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<UpsertEstimateMutation, UpsertEstimateMutationVariables>;
export const GetRelevantEstimateDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRelevantEstimateData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookItemGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingProfilesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultPricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"estimateDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"businessFullLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"contractorLicenseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"logoPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"logoPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blurb"}},{"kind":"Field","name":{"kind":"Name","value":"estimateLineItemsVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanSavingsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hideLineItemPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetRelevantEstimateDataQuery, GetRelevantEstimateDataQueryVariables>;
export const GetRelevantNewEstimateDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRelevantNewEstimateData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRelevantNewEstimateDataQuery, GetRelevantNewEstimateDataQueryVariables>;
export const GetEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GetEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"estimateGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"messageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanSavingsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hideLineItemPrices"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"closedLostReasonCategory"}},{"kind":"Field","name":{"kind":"Name","value":"closedLostReasonNote"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedOnBehalfByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateName"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicPricingType"}},{"kind":"Field","name":{"kind":"Name","value":"estimatePhotos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"optionGuid"},"name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"discountGuid"},"name":{"kind":"Name","value":"estimateOptionDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recommended"},"name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","alias":{"kind":"Name","value":"selected"},"name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"itemType"},"name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemVariant"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedToJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedJobGuid"}}]}}]}}]}}]} as unknown as DocumentNode<GetEstimateSubscription, GetEstimateSubscriptionVariables>;
export const DeleteEstimateOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEstimateOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEstimatesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"estimateGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<DeleteEstimateOptionsMutation, DeleteEstimateOptionsMutationVariables>;
export const GetJobPhotosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobPhotos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}}]}}]}}]}}]} as unknown as DocumentNode<GetJobPhotosQuery, GetJobPhotosQueryVariables>;
export const GetRelevantEstimateDataForAccountReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRelevantEstimateDataForAccountReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingProfilesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"businessFullLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"contractorLicenseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"logoPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"logoPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blurb"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"estimateLineItemsVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanSavingsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hideLineItemPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetRelevantEstimateDataForAccountReviewQuery, GetRelevantEstimateDataForAccountReviewQueryVariables>;
export const GetEstimateForAccountReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEstimateForAccountReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"estimateGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"messageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanSavingsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hideLineItemPrices"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicPricingType"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userPhoneNumbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatePhotos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"optionGuid"},"name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"discountGuid"},"name":{"kind":"Name","value":"estimateOptionDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"selected"},"name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","alias":{"kind":"Name","value":"recommended"},"name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEstimateForAccountReviewQuery, GetEstimateForAccountReviewQueryVariables>;
export const EstimateFlowEstimateWithLinkedJobQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EstimateFlowEstimateWithLinkedJobQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"estimateGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedToJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedJobGuid"}}]}}]}}]}}]} as unknown as DocumentNode<EstimateFlowEstimateWithLinkedJobQueryQuery, EstimateFlowEstimateWithLinkedJobQueryQueryVariables>;
export const EstimateDataForDownloadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EstimateDataForDownload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"estimateGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}}]}}]}}]} as unknown as DocumentNode<EstimateDataForDownloadQuery, EstimateDataForDownloadQueryVariables>;
export const SaveEstimateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveEstimateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimateTemplatesInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertEstimateTemplatesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<SaveEstimateTemplateMutation, SaveEstimateTemplateMutationVariables>;
export const GetEstimateListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEstimateList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimatesOrderBy"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimatesBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicPricingType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"closedLostReasonCategory"}},{"kind":"Field","name":{"kind":"Name","value":"closedLostReasonNote"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPrimaryHueHex"}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"optionGuid"},"name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}}]}}]}}]}}]} as unknown as DocumentNode<GetEstimateListQuery, GetEstimateListQueryVariables>;
export const GetEstimateListUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEstimateListUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<GetEstimateListUsersQuery, GetEstimateListUsersQueryVariables>;
export const EstimatePdfDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EstimatePDFData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"estimateGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedOnBehalfByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateName"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicPricingType"}},{"kind":"Field","name":{"kind":"Name","value":"hideLineItemPrices"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanSavingsEnabled"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EstimatePdfDataQuery, EstimatePdfDataQueryVariables>;
export const EstimateListingOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EstimateListingOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"estimateGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"estimateGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"optionGuid"},"name":{"kind":"Name","value":"estimateOptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhotoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"discountGuid"},"name":{"kind":"Name","value":"estimateOptionDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recommended"},"name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","alias":{"kind":"Name","value":"selected"},"name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"itemType"},"name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemVariant"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EstimateListingOptionsQuery, EstimateListingOptionsQueryVariables>;
export const CompanyInvoiceSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyInvoiceSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceDisplayTechnicianName"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceIssueWorkflow"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceLineItemsVisibility"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceIncludePaymentLink"}},{"kind":"Field","name":{"kind":"Name","value":"hideLineItemPrices"}}]}}]}}]} as unknown as DocumentNode<CompanyInvoiceSettingsQuery, CompanyInvoiceSettingsQueryVariables>;
export const UpdateCompanyInvoiceSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCompanyInvoiceSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyConfigSetInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateCompanyInvoiceSettingsMutation, UpdateCompanyInvoiceSettingsMutationVariables>;
export const UpsertInvoiceTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertInvoiceTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceTemplateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"template"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceTemplatesInsertInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validCartItemGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertInvoiceTemplatesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"template"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"invoice_templates_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"updatedAt"},{"kind":"EnumValue","value":"templateName"},{"kind":"EnumValue","value":"isDeleted"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceTemplateCartItems"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceTemplateGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceTemplateGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cartItemGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validCartItemGuids"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertInvoiceTemplateMutation, UpsertInvoiceTemplateMutationVariables>;
export const MarkInvoiceTemplateDeletedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkInvoiceTemplateDeleted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceTemplateGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInvoiceTemplatesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceTemplateGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceTemplateGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]}}]} as unknown as DocumentNode<MarkInvoiceTemplateDeletedMutation, MarkInvoiceTemplateDeletedMutationVariables>;
export const ReadInvoiceTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadInvoiceTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceTemplateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTemplateCartItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemVariant"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReadInvoiceTemplatesQuery, ReadInvoiceTemplatesQueryVariables>;
export const GetRelevantInvoiceDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GetRelevantInvoiceData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blurb"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceIncludePaymentLink"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDisplayTechnicianName"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceIssueWorkflow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanSavingsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hideLineItemPrices"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumberEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessFullLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"contractorLicenseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDisclaimer"}},{"kind":"Field","name":{"kind":"Name","value":"businessAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"websiteDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultPricebookTaxRateGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricebookItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookItemGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accCompanyConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountingIntegrationType"}},{"kind":"Field","name":{"kind":"Name","value":"autosyncInvoiceOnIssued"}},{"kind":"Field","name":{"kind":"Name","value":"autosyncInvoiceOnPayment"}},{"kind":"Field","name":{"kind":"Name","value":"autosyncInvoiceOnFullyPaid"}},{"kind":"Field","name":{"kind":"Name","value":"autosyncInvoiceOnVoided"}}]}}]}}]}}]} as unknown as DocumentNode<GetRelevantInvoiceDataSubscription, GetRelevantInvoiceDataSubscriptionVariables>;
export const QueryRelevantInvoiceEditAccountDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryRelevantInvoiceEditAccountData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}}]}}]}}]} as unknown as DocumentNode<QueryRelevantInvoiceEditAccountDataQuery, QueryRelevantInvoiceEditAccountDataQueryVariables>;
export const InvoiceChecklistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoiceChecklists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoicesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invoiceGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstanceGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"checklist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"name","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerFacingByDefault"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InvoiceChecklistsQuery, InvoiceChecklistsQueryVariables>;
export const QueryRelevantInvoiceEditJobDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryRelevantInvoiceEditJobData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerPurchaseOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QueryRelevantInvoiceEditJobDataQuery, QueryRelevantInvoiceEditJobDataQueryVariables>;
export const GetRelevantInvoiceEditAccountDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GetRelevantInvoiceEditAccountData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isArchived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultInvoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}}]}}]}}]} as unknown as DocumentNode<GetRelevantInvoiceEditAccountDataSubscription, GetRelevantInvoiceEditAccountDataSubscriptionVariables>;
export const GetRelevantInvoiceEditJobDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"GetRelevantInvoiceEditJobData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerPurchaseOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRelevantInvoiceEditJobDataSubscription, GetRelevantInvoiceEditJobDataSubscriptionVariables>;
export const UpsertInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validCartItemGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validInvoiceDiscountGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoice"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicesInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertInvoicesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoice"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"invoices_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"billingAddressGuid"},{"kind":"EnumValue","value":"billingContactGuid"},{"kind":"EnumValue","value":"customerPurchaseOrderNumber"},{"kind":"EnumValue","value":"displayId"},{"kind":"EnumValue","value":"displayIdV2"},{"kind":"EnumValue","value":"dueAt"},{"kind":"EnumValue","value":"invoiceTerm"},{"kind":"EnumValue","value":"messageHtml"},{"kind":"EnumValue","value":"maintenancePlanSavingsEnabled"},{"kind":"EnumValue","value":"hideLineItemPrices"},{"kind":"EnumValue","value":"serviceAddressGuid"},{"kind":"EnumValue","value":"serviceCompletionDate"},{"kind":"EnumValue","value":"status"},{"kind":"EnumValue","value":"subtotalUsc"},{"kind":"EnumValue","value":"taxRate"},{"kind":"EnumValue","value":"taxRateGuid"},{"kind":"EnumValue","value":"totalUsc"},{"kind":"EnumValue","value":"taxRateName"},{"kind":"EnumValue","value":"issuedAt"},{"kind":"EnumValue","value":"updatedAt"},{"kind":"EnumValue","value":"dynamicPricingType"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceCartItems"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cartItemGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validCartItemGuids"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteInvoiceDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceDiscountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validInvoiceDiscountGuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertInvoiceMutation, UpsertInvoiceMutationVariables>;
export const UpdateInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicesSetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInvoicesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const InvoiceDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"InvoiceData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoicesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invoiceGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Invoice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Invoice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"doNotSyncToAccountingServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanSavingsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hideLineItemPrices"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateName"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicPricingType"}},{"kind":"Field","name":{"kind":"Name","value":"billingContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"itemType"},"name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemVariant"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerPurchaseOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"billingContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddressGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecord"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentStatuses"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CANCELED"}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecord"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRefunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qboStaleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stale"},"name":{"kind":"Name","value":"isQboStale"}},{"kind":"Field","alias":{"kind":"Name","value":"syncedAt"},"name":{"kind":"Name","value":"qboSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingStaleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isStale"}},{"kind":"Field","name":{"kind":"Name","value":"syncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestPaymentAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUpdatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnitLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}}]}}]} as unknown as DocumentNode<InvoiceDataSubscription, InvoiceDataSubscriptionVariables>;
export const InvoicesDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"InvoicesData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicesBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoiceWithGuid"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Invoice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"doNotSyncToAccountingServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanSavingsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hideLineItemPrices"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateName"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicPricingType"}},{"kind":"Field","name":{"kind":"Name","value":"billingContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"itemType"},"name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemVariant"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerPurchaseOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"billingContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddressGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecord"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentStatuses"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CANCELED"}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecord"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRefunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qboStaleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stale"},"name":{"kind":"Name","value":"isQboStale"}},{"kind":"Field","alias":{"kind":"Name","value":"syncedAt"},"name":{"kind":"Name","value":"qboSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingStaleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isStale"}},{"kind":"Field","name":{"kind":"Name","value":"syncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestPaymentAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUpdatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnitLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceWithGuid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Invoice"}}]}}]} as unknown as DocumentNode<InvoicesDataSubscription, InvoicesDataSubscriptionVariables>;
export const InvoicesDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoicesDataQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicesBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoiceWithGuid"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Invoice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"doNotSyncToAccountingServiceReason"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanSavingsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hideLineItemPrices"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateName"}},{"kind":"Field","name":{"kind":"Name","value":"taxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicPricingType"}},{"kind":"Field","name":{"kind":"Name","value":"billingContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDiscountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceCartItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seq"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"cartItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"itemType"},"name":{"kind":"Name","value":"cartItemType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"originalPricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"cartItemVariant"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerPurchaseOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"billingContactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddressGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecord"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentStatuses"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CANCELED"}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecord"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRefunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qboStaleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stale"},"name":{"kind":"Name","value":"isQboStale"}},{"kind":"Field","alias":{"kind":"Name","value":"syncedAt"},"name":{"kind":"Name","value":"qboSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingStaleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isStale"}},{"kind":"Field","name":{"kind":"Name","value":"syncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestPaymentAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUpdatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnitLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxRoundingStrategy"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceWithGuid"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Invoice"}}]}}]} as unknown as DocumentNode<InvoicesDataQueryQuery, InvoicesDataQueryQueryVariables>;
export const MaintenancePlanDetailsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaintenancePlanDetailsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansQueryableByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maintenancePlanGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanDetailsQueryQuery, MaintenancePlanDetailsQueryQueryVariables>;
export const CheckInvoiceNumberUniquenessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckInvoiceNumberUniqueness"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeInvoiceGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"displayIdV2"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceNumber"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeInvoiceGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}}]}}]}}]} as unknown as DocumentNode<CheckInvoiceNumberUniquenessQuery, CheckInvoiceNumberUniquenessQueryVariables>;
export const InvoicesListPageInvoiceSummaryStatisticsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoicesListPageInvoiceSummaryStatisticsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicesQueryableBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoicesQueryableAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmountUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<InvoicesListPageInvoiceSummaryStatisticsQueryQuery, InvoicesListPageInvoiceSummaryStatisticsQueryQueryVariables>;
export const InvoicesListPageInvoiceSummaryStatisticAvgValuesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoicesListPageInvoiceSummaryStatisticAvgValuesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicesQueryableBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoicesQueryableAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmountUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InvoicesListPageInvoiceSummaryStatisticAvgValuesQueryQuery, InvoicesListPageInvoiceSummaryStatisticAvgValuesQueryQueryVariables>;
export const InvoicesListPageInvoiceAvgUnpaidDaysQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoicesListPageInvoiceAvgUnpaidDaysQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicesQueryableBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoicesQueryableAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysUnpaid"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InvoicesListPageInvoiceAvgUnpaidDaysQueryQuery, InvoicesListPageInvoiceAvgUnpaidDaysQueryQueryVariables>;
export const InvoicesListPageInvoicesV2QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoicesListPageInvoicesV2Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AggregatableInvoicesBoolExp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AggregatableInvoicesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerm"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"issuedOrCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"serviceCompletionDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountManagerUserGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paidUsd"}},{"kind":"Field","name":{"kind":"Name","value":"paidUsc"}},{"kind":"Field","name":{"kind":"Name","value":"processingUsd"}},{"kind":"Field","name":{"kind":"Name","value":"processingUsc"}},{"kind":"Field","name":{"kind":"Name","value":"numDaysOverdue"}},{"kind":"Field","name":{"kind":"Name","value":"isTerminalStatus"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessUnitLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"sourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"businessUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doNotSyncToAccountingServiceReason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoicesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<InvoicesListPageInvoicesV2QueryQuery, InvoicesListPageInvoicesV2QueryQueryVariables>;
export const InvoicesListPageInvoiceV2SummaryStatisticsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoicesListPageInvoiceV2SummaryStatisticsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AggregatableInvoicesBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoicesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paidUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processingUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InvoicesListPageInvoiceV2SummaryStatisticsQueryQuery, InvoicesListPageInvoiceV2SummaryStatisticsQueryQueryVariables>;
export const InvoicesListPageInvoiceV2SummaryStatisticAvgValuesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoicesListPageInvoiceV2SummaryStatisticAvgValuesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AggregatableInvoicesBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoicesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InvoicesListPageInvoiceV2SummaryStatisticAvgValuesQueryQuery, InvoicesListPageInvoiceV2SummaryStatisticAvgValuesQueryQueryVariables>;
export const InvoicesListPageInvoiceV2AvgUnpaidDaysQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoicesListPageInvoiceV2AvgUnpaidDaysQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AggregatableInvoicesBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoicesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"daysUnpaid"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InvoicesListPageInvoiceV2AvgUnpaidDaysQueryQuery, InvoicesListPageInvoiceV2AvgUnpaidDaysQueryQueryVariables>;
export const GetInvoiceListUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvoiceListUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPrimaryHueHex"}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInvoiceListUsersQuery, GetInvoiceListUsersQueryVariables>;
export const InvoiceListPageCompanyConfigQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoiceListPageCompanyConfigQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountManagerEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumberEnabled"}}]}}]}}]} as unknown as DocumentNode<InvoiceListPageCompanyConfigQueryQuery, InvoiceListPageCompanyConfigQueryQueryVariables>;
export const InvoiceListPageBusinessUnitsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoiceListPageBusinessUnitsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<InvoiceListPageBusinessUnitsQueryQuery, InvoiceListPageBusinessUnitsQueryQueryVariables>;
export const JobCostingTeamMembersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobCostingTeamMembersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fullName"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}}]}}]}}]} as unknown as DocumentNode<JobCostingTeamMembersQueryQuery, JobCostingTeamMembersQueryQueryVariables>;
export const JobDetailsPageCompanyConfigQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobDetailsPageCompanyConfigQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountManagerEnabled"}}]}}]}}]} as unknown as DocumentNode<JobDetailsPageCompanyConfigQueryQuery, JobDetailsPageCompanyConfigQueryQueryVariables>;
export const JobDetailsPageLinkedJobDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"JobDetailsPageLinkedJobDataQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsWithLinkedJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"linkNotes"}},{"kind":"Field","name":{"kind":"Name","value":"linkPhotos"}},{"kind":"Field","name":{"kind":"Name","value":"linkAttachments"}},{"kind":"Field","name":{"kind":"Name","value":"linked_job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"noteLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noteGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"resourceUrn"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobDetailsPageLinkedJobDataQuerySubscription, JobDetailsPageLinkedJobDataQuerySubscriptionVariables>;
export const JobDetailsPageLinkedJobsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobDetailsPageLinkedJobsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsWithLinkedJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linked_job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobDetailsPageLinkedJobsQueryQuery, JobDetailsPageLinkedJobsQueryQueryVariables>;
export const JobDetailsPageLinkedToJobsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobDetailsPageLinkedToJobsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsWithLinkedJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"linkedJobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobDetailsPageLinkedToJobsQueryQuery, JobDetailsPageLinkedToJobsQueryQueryVariables>;
export const JobDetailsPageLinkedPhoneCallsSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"JobDetailsPageLinkedPhoneCallsSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkedIntegratedPhoneCall"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkedIntegratedPhoneCall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntegratedPhoneCalls"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallGuid"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneMissedCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneVoicemails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingSummary"}},{"kind":"Field","name":{"kind":"Name","value":"recordingTranscript"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallRecording"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingSummary"}},{"kind":"Field","name":{"kind":"Name","value":"recordingTranscript"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCallJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobDetailsPageLinkedPhoneCallsSubscriptionSubscription, JobDetailsPageLinkedPhoneCallsSubscriptionSubscriptionVariables>;
export const JobOriginatingPlatformDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobOriginatingPlatform"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLeads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originatingPlatformUrl"}},{"kind":"Field","name":{"kind":"Name","value":"originatingPlatformLabel"}}]}}]}}]} as unknown as DocumentNode<JobOriginatingPlatformQuery, JobOriginatingPlatformQueryVariables>;
export const UpdateJobUseMaintenancePlanCreditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateJobUseMaintenancePlanCredit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useCredit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"useMaintenancePlanCredit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useCredit"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"useMaintenancePlanCredit"}}]}}]}}]} as unknown as DocumentNode<UpdateJobUseMaintenancePlanCreditMutation, UpdateJobUseMaintenancePlanCreditMutationVariables>;
export const FetchJobTechnicianPerformanceInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchJobTechnicianPerformanceInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTechnicianEarnedRevenueSummaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"totalEarnedRevenueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTechnicianSalesCommissionAndBonus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"totalSoldRevenueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"totalDeductionsUsc"}},{"kind":"Field","name":{"kind":"Name","value":"commissionableBaseUsc"}},{"kind":"Field","name":{"kind":"Name","value":"commissionUsc"}},{"kind":"Field","name":{"kind":"Name","value":"commissionRate"}},{"kind":"Field","name":{"kind":"Name","value":"bonusUsc"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}}]}}]}}]}}]} as unknown as DocumentNode<FetchJobTechnicianPerformanceInfoQuery, FetchJobTechnicianPerformanceInfoQueryVariables>;
export const FetchJobWorkCompletedAtLiveQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"FetchJobWorkCompletedAtLiveQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}}]}}]} as unknown as DocumentNode<FetchJobWorkCompletedAtLiveQuerySubscription, FetchJobWorkCompletedAtLiveQuerySubscriptionVariables>;
export const JobsTimesheetEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsTimesheetEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timesheetEntryLinks"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnicianTimesheetEntry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnicianTimesheetEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimesheetEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"finalStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"finalEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"entryLengthInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attentionNote"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivityGuid"}},{"kind":"Field","name":{"kind":"Name","value":"activityName"}},{"kind":"Field","name":{"kind":"Name","value":"isPayable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryLinkData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}}]}}]}}]}}]} as unknown as DocumentNode<JobsTimesheetEntriesQuery, JobsTimesheetEntriesQueryVariables>;
export const FetchJobLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchJobLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLeads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeEnd"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobRequestFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobRequestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobLeads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLeadGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"contactLastName"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressCity"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressStateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressZipCode"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"}},{"kind":"Field","name":{"kind":"Name","value":"requestType"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypes"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentAvailabilities"}},{"kind":"Field","name":{"kind":"Name","value":"additionalMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobSummary"}},{"kind":"Field","name":{"kind":"Name","value":"leadSource"}},{"kind":"Field","name":{"kind":"Name","value":"jobLeadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"originatingPlatformUrl"}},{"kind":"Field","name":{"kind":"Name","value":"originatingPlatformLabel"}},{"kind":"Field","name":{"kind":"Name","value":"submittedJobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preExistingLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchJobLeadsQuery, FetchJobLeadsQueryVariables>;
export const FetchJobLeadsSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"FetchJobLeadsSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLeads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeEnd"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobRequestFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobRequestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobLeads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLeadGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"contactLastName"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressCity"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressStateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressZipCode"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"}},{"kind":"Field","name":{"kind":"Name","value":"requestType"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypes"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentAvailabilities"}},{"kind":"Field","name":{"kind":"Name","value":"additionalMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobSummary"}},{"kind":"Field","name":{"kind":"Name","value":"leadSource"}},{"kind":"Field","name":{"kind":"Name","value":"jobLeadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"originatingPlatformUrl"}},{"kind":"Field","name":{"kind":"Name","value":"originatingPlatformLabel"}},{"kind":"Field","name":{"kind":"Name","value":"submittedJobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preExistingLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchJobLeadsSubscriptionSubscription, FetchJobLeadsSubscriptionSubscriptionVariables>;
export const FetchJobLeadByJobLeadGuidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchJobLeadByJobLeadGuid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobLeadGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLeads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobLeadGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobLeadGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobRequestFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobRequestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobLeads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLeadGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"contactLastName"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressCity"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressStateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAddressZipCode"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"}},{"kind":"Field","name":{"kind":"Name","value":"requestType"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypes"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentAvailabilities"}},{"kind":"Field","name":{"kind":"Name","value":"additionalMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobSummary"}},{"kind":"Field","name":{"kind":"Name","value":"leadSource"}},{"kind":"Field","name":{"kind":"Name","value":"jobLeadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"originatingPlatformUrl"}},{"kind":"Field","name":{"kind":"Name","value":"originatingPlatformLabel"}},{"kind":"Field","name":{"kind":"Name","value":"submittedJobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preExistingLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceledAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"yearlyPriceUsc"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchJobLeadByJobLeadGuidQuery, FetchJobLeadByJobLeadGuidQueryVariables>;
export const UpdateJobLeadStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateJobLeadStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobLeadsSetInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobLeadGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJobLeads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobLeadGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobLeadGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<UpdateJobLeadStatusMutation, UpdateJobLeadStatusMutationVariables>;
export const ConvertJobLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConvertJobLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobLeadGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJobLeadsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobLeadStatus"},"value":{"kind":"StringValue","value":"converted","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobLeadGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobLeadGuid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<ConvertJobLeadMutation, ConvertJobLeadMutationVariables>;
export const FetchCountOfOpenJobLeadsByCompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"FetchCountOfOpenJobLeadsByCompany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLeadsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobLeadStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"open","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<FetchCountOfOpenJobLeadsByCompanySubscription, FetchCountOfOpenJobLeadsByCompanySubscriptionVariables>;
export const FetchCompanyLeadSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchCompanyLeadSources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyLeadSourcesBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}}]}}]}}]} as unknown as DocumentNode<FetchCompanyLeadSourcesQuery, FetchCompanyLeadSourcesQueryVariables>;
export const JobsPageAllTagsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsPageAllTagsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagMinimal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tags"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<JobsPageAllTagsQueryQuery, JobsPageAllTagsQueryQueryVariables>;
export const JobsPageJobLifecyclesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsPageJobLifecyclesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLifecycles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleType"}},{"kind":"Field","alias":{"kind":"Name","value":"statuses"},"name":{"kind":"Name","value":"jobLifecycleStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"isLeadWon"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkComplete"}},{"kind":"Field","name":{"kind":"Name","value":"isFirstAppointmentBookedAutomationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isAllOutstandingAppointmentsAssignedAutomationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isTechnicianDispatchedAutomationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isTechnicianArrivesAtAppointmentAutomationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isAllAppointmentsCompletedAutomationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isCreateLinkedJobAutomationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isNoAdditionalWorkRequiredAutomationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isOnsiteWorkNotCompleteAutomationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatusGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}},{"kind":"Field","name":{"kind":"Name","value":"jobsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobsPageJobLifecyclesQueryQuery, JobsPageJobLifecyclesQueryQueryVariables>;
export const JobsPageV2CompanyUsersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsPageV2CompanyUsersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<JobsPageV2CompanyUsersQueryQuery, JobsPageV2CompanyUsersQueryQueryVariables>;
export const JobsPageV2CompanyUsersSingleQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobsPageV2CompanyUsersSingleQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<JobsPageV2CompanyUsersSingleQueryQuery, JobsPageV2CompanyUsersSingleQueryQueryVariables>;
export const JobPageV2CompanyConfigQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobPageV2CompanyConfigQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountManagerEnabled"}}]}}]}}]} as unknown as DocumentNode<JobPageV2CompanyConfigQueryQuery, JobPageV2CompanyConfigQueryQueryVariables>;
export const ChangeJobPipelineCardSelectJobTypeWithJobLifecycleQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChangeJobPipelineCardSelectJobTypeWithJobLifecycleQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTypeGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobTypeGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobTypeGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLifecycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatusGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}}]}}]}}]}}]} as unknown as DocumentNode<ChangeJobPipelineCardSelectJobTypeWithJobLifecycleQueryQuery, ChangeJobPipelineCardSelectJobTypeWithJobLifecycleQueryQueryVariables>;
export const JobTypeSettingsListPageJobTypeArchiveMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JobTypeSettingsListPageJobTypeArchiveMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTypeGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archivedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJobTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobTypeGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobTypeGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archivedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archivedAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archivedAt"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<JobTypeSettingsListPageJobTypeArchiveMutationMutation, JobTypeSettingsListPageJobTypeArchiveMutationMutationVariables>;
export const JobTypeSettingsListPageJobTypeUnarchiveMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JobTypeSettingsListPageJobTypeUnarchiveMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobTypeGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unarchivedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJobTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobTypeGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobTypeGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archivedAt"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unarchivedAt"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<JobTypeSettingsListPageJobTypeUnarchiveMutationMutation, JobTypeSettingsListPageJobTypeUnarchiveMutationMutationVariables>;
export const FetchJobTypesSettingsJobTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchJobTypesSettingsJobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultSummary"}},{"kind":"Field","name":{"kind":"Name","value":"hideJobSummaryField"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInJobCosting"}},{"kind":"Field","name":{"kind":"Name","value":"defaultBusinessUnitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityConversionThresholdUsc"}},{"kind":"Field","name":{"kind":"Name","value":"isPotentialHotLead"}},{"kind":"Field","name":{"kind":"Name","value":"hotLeadMinimumEquipmentAgeYears"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"jobsAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobLifecycleStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"Closed","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchJobTypesSettingsJobTypeQuery, FetchJobTypesSettingsJobTypeQueryVariables>;
export const LeadSourcesSettingsPageLeadSourcesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadSourcesSettingsPageLeadSourcesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activeCompanyLeadSources"},"name":{"kind":"Name","value":"companyLeadSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archivedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceLinksAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"archivedCompanyLeadSources"},"name":{"kind":"Name","value":"companyLeadSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archivedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}},{"kind":"Field","name":{"kind":"Name","value":"ordinal"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceLinksAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LeadSourcesSettingsPageLeadSourcesQueryQuery, LeadSourcesSettingsPageLeadSourcesQueryQueryVariables>;
export const LeadSourcesSettingsPageCanonicalLeadSourcesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadSourcesSettingsPageCanonicalLeadSourcesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"attributionLinkingStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"attributionPrompt"}}]}}]}}]} as unknown as DocumentNode<LeadSourcesSettingsPageCanonicalLeadSourcesQueryQuery, LeadSourcesSettingsPageCanonicalLeadSourcesQueryQueryVariables>;
export const LeadSourcesSettingsPageUpsertLeadSourceMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeadSourcesSettingsPageUpsertLeadSourceMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyLeadSourceGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canonicalLeadSourceName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributionPromptOverride"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributionLinkingStrategyOverride"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archivedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyLeadSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyLeadSourceGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyLeadSourceGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"canonicalLeadSourceName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canonicalLeadSourceName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"attributionPromptOverride"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributionPromptOverride"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"attributionLinkingStrategyOverride"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributionLinkingStrategyOverride"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"archivedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archivedAt"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_lead_sources_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"canonicalLeadSourceName"},{"kind":"EnumValue","value":"canonicalLeadSourceNameOverride"},{"kind":"EnumValue","value":"attributionLinkingStrategyOverride"},{"kind":"EnumValue","value":"attributionPromptOverride"},{"kind":"EnumValue","value":"archivedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<LeadSourcesSettingsPageUpsertLeadSourceMutationMutation, LeadSourcesSettingsPageUpsertLeadSourceMutationMutationVariables>;
export const LeadSourcesSettingsPageLeadSourcesSingleQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadSourcesSettingsPageLeadSourcesSingleQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyLeadSourceGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyLeadSourceGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyLeadSourceGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"attributionLinkingStrategy"}},{"kind":"Field","name":{"kind":"Name","value":"attributionPrompt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}},{"kind":"Field","name":{"kind":"Name","value":"attributionPromptOverride"}},{"kind":"Field","name":{"kind":"Name","value":"attributionLinkingStrategyOverride"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}}]}}]}}]} as unknown as DocumentNode<LeadSourcesSettingsPageLeadSourcesSingleQueryQuery, LeadSourcesSettingsPageLeadSourcesSingleQueryQueryVariables>;
export const CheckIfCompanyHasActiveMaintenancePlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckIfCompanyHasActiveMaintenancePlans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansQueryable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACTIVE","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CheckIfCompanyHasActiveMaintenancePlansQuery, CheckIfCompanyHasActiveMaintenancePlansQueryVariables>;
export const FetchCompanyMaintenancePlansEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchCompanyMaintenancePlansEnabled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansEnabled"}}]}}]}}]} as unknown as DocumentNode<FetchCompanyMaintenancePlansEnabledQuery, FetchCompanyMaintenancePlansEnabledQueryVariables>;
export const UpsertCompanyBillingProfileRenewalTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyBillingProfileRenewalTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingProfilesInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertBillingProfilesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"billing_profiles_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"maintenancePlanAutoRenewalAllowed"},{"kind":"EnumValue","value":"maintenancePlanManualRenewalAllowed"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyBillingProfileRenewalTypesMutation, UpsertCompanyBillingProfileRenewalTypesMutationVariables>;
export const UpsertCompanyBillingProfileFixedPlanDurationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyBillingProfileFixedPlanDurations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingProfilesInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertBillingProfilesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"billing_profiles_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"maintenancePlanStaticDurationNumYearsAllowed"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyBillingProfileFixedPlanDurationsMutation, UpsertCompanyBillingProfileFixedPlanDurationsMutationVariables>;
export const MaintenancePlanCollapsiblesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaintenancePlanCollapsiblesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentWhereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentRecordsBoolExp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobsWhereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobsBoolExp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentsWhereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobAppointmentsBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentWhereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"externalPaymentId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodAdditionalInfo"}},{"kind":"Field","name":{"kind":"Name","value":"shouldSendReceipt"}},{"kind":"Field","name":{"kind":"Name","value":"doNotSyncToAccountingServiceReason"}},{"kind":"Field","alias":{"kind":"Name","value":"guid"},"name":{"kind":"Name","value":"paymentRecordGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"referenceNumber"},"name":{"kind":"Name","value":"paymentReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatusesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"links"},"name":{"kind":"Name","value":"paymentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"collectedByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"loanRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecord"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobsWhereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","alias":{"kind":"Name","value":"jobCreatedAt"},"name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentsWhereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"endOfAppointmentNextSteps"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationTo"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendReminderEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentStatusGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canceled"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecordStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanStatuses"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loanStatusDetail"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoanRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WisetackLoanRecords"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanRecordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"contactGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackMerchantGuid"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackTransactionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"requestedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"approvedLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"settledLoanAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"processingFeeUsc"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"loanApplicationLink"}},{"kind":"Field","name":{"kind":"Name","value":"wisetackLoanStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoanRecordStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanCollapsiblesQueryQuery, MaintenancePlanCollapsiblesQueryQueryVariables>;
export const ExpireVisitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExpireVisit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isExpiredOverride"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMaintenancePlanVisits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"maintenancePlanVisitGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isExpiredOverride"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isExpiredOverride"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isCompletedOverride"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"completedAtOverride"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<ExpireVisitMutation, ExpireVisitMutationVariables>;
export const RestoreVisitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestoreVisit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiresAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMaintenancePlanVisits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"maintenancePlanVisitGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isExpiredOverride"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiresAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiresAt"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<RestoreVisitMutation, RestoreVisitMutationVariables>;
export const MaintenancePlanInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaintenancePlanInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"maintenancePlanGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maintenancePlanGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanInvoiceQuery, MaintenancePlanInvoiceQueryVariables>;
export const MaintenancePlanListPageDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaintenancePlanListPageData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryableBoolExp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryableOrderBy"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansQueryable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlansListPageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansQueryableAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanNextVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanNextVisits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"affinityDate"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtOverride"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExpiredOverride"}},{"kind":"Field","name":{"kind":"Name","value":"isCompletedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visitNote"}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"visitStatus"}},{"kind":"Field","name":{"kind":"Name","value":"visitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"visitReminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specialStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisitInstalledEquipments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedEndOfLifeDate"}},{"kind":"Field","name":{"kind":"Name","value":"averageLifeExpectancyYears"}},{"kind":"Field","name":{"kind":"Name","value":"modelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlansListPageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookTaxRateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInterval"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFlow"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledActivationAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingStartAt"}},{"kind":"Field","name":{"kind":"Name","value":"lapsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminatesAt"}},{"kind":"Field","name":{"kind":"Name","value":"visitReplenishmentAnchorOverride"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"paymentSubscriptionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"numUnusedVisits"}},{"kind":"Field","name":{"kind":"Name","value":"soldByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userPrimaryHueHex"}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numDaysUntilVisitCreditExpiration"}},{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryColorHex"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanVisits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanNextVisit"}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanListPageDataQuery, MaintenancePlanListPageDataQueryVariables>;
export const MaintenancePlanActivePlansSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaintenancePlanActivePlansSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryableBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansQueryableAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanActivePlansSummaryQuery, MaintenancePlanActivePlansSummaryQueryVariables>;
export const MaintenancePlanYearlyPriceSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaintenancePlanYearlyPriceSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryableBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansQueryableAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanYearlyPriceSummaryQuery, MaintenancePlanYearlyPriceSummaryQueryVariables>;
export const MaintenancePlanOverdueVisitsSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaintenancePlanOverdueVisitsSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryableBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlansQueryableAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numOverdueVisits"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MaintenancePlanOverdueVisitsSummaryQuery, MaintenancePlanOverdueVisitsSummaryQueryVariables>;
export const CompanyMaintenancePlanTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyMaintenancePlanTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlanDefinitionsBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinitionGuid"}},{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyMaintenancePlanTypesQuery, CompanyMaintenancePlanTypesQueryVariables>;
export const CompanyUsersForMaintenancePlansListPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyUsersForMaintenancePlansListPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deactivatedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<CompanyUsersForMaintenancePlansListPageQuery, CompanyUsersForMaintenancePlansListPageQueryVariables>;
export const UpsertOnlineBookingServiceTypeConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertOnlineBookingServiceTypeConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlineBookingServiceTypeGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OnlineBookingServiceTypeConfigsInsertInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onConflict"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OnlineBookingServiceTypeConfigsOnConflict"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOnlineBookingServiceTypeBookableJobTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onlineBookingServiceTypeGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlineBookingServiceTypeGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteOnlineBookingServiceTypeBookableTechnicians"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onlineBookingServiceTypeGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlineBookingServiceTypeGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteInstantBookingWeeklyScheduleEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onlineBookingServiceTypeGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlineBookingServiceTypeGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertOnlineBookingServiceTypeConfigsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onConflict"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertOnlineBookingServiceTypeConfigMutation, UpsertOnlineBookingServiceTypeConfigMutationVariables>;
export const UpsertOnlineBookingConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertOnlineBookingConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OnlineBookingCompanyConfigInsertInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onConflict"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OnlineBookingCompanyConfigOnConflict"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOnlineBookingServiceAreaZipCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertOnlineBookingCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onConflict"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertOnlineBookingConfigMutation, UpsertOnlineBookingConfigMutationVariables>;
export const FetchOnlineBookingCompanyConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchOnlineBookingCompanyConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlineBookingCompanyConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limitBookingsToServiceAreaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"brandingColorHex"}},{"kind":"Field","name":{"kind":"Name","value":"afterHoursBannerHtml"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAreaZipCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingServiceTypeConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceType"}},{"kind":"Field","name":{"kind":"Name","value":"bookingType"}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingServiceTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<FetchOnlineBookingCompanyConfigQuery, FetchOnlineBookingCompanyConfigQueryVariables>;
export const FetchOnlineBookingServiceTypeConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchOnlineBookingServiceTypeConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlineServiceTypeConfigGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlineBookingServiceTypeConfigsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlineBookingServiceTypeGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlineServiceTypeConfigGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlineBookingServiceTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"serviceType"}},{"kind":"Field","name":{"kind":"Name","value":"bookingType"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentType"}},{"kind":"Field","name":{"kind":"Name","value":"earliestAvailability"}},{"kind":"Field","name":{"kind":"Name","value":"latestAvailability"}},{"kind":"Field","name":{"kind":"Name","value":"legalBlurbHtml"}},{"kind":"Field","name":{"kind":"Name","value":"bookableJobTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookableTechnicians"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianGuid"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instantBookingWeeklyScheduleEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"bookableArrivalWindows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arrivalWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyAppointmentArrivalWindowGuid"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowEndTime"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivatedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleById"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyAppointmentArrivalWindows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyAppointmentArrivalWindowGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalWindowEndTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archivedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchOnlineBookingServiceTypeConfigQuery, FetchOnlineBookingServiceTypeConfigQueryVariables>;
export const PaymentsListPageCompanyConfigQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentsListPageCompanyConfigQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerNumberEnabled"}}]}}]}}]} as unknown as DocumentNode<PaymentsListPageCompanyConfigQueryQuery, PaymentsListPageCompanyConfigQueryQueryVariables>;
export const FetchCompanyIntegratedPhonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchCompanyIntegratedPhones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"decommissionedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneGuid"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneProvider"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"primaryOutboundSms"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FetchCompanyIntegratedPhonesQuery, FetchCompanyIntegratedPhonesQueryVariables>;
export const FetchCompanyPhoneConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchCompanyPhoneConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCompanyConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"integratedVoiceCallingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCompanyConfigGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackShouldRecordVoicemail"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackForwardToPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackHangupMessage"}}]}}]}}]} as unknown as DocumentNode<FetchCompanyPhoneConfigQuery, FetchCompanyPhoneConfigQueryVariables>;
export const UpdatePhoneLeadSourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePhoneLeadSource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadSourceGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegratedPhonesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"integratedPhoneGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyLeadSourceGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadSourceGuid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}}]}}]}}]} as unknown as DocumentNode<UpdatePhoneLeadSourceMutation, UpdatePhoneLeadSourceMutationVariables>;
export const UpdatePrimaryOutboundSmsPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePrimaryOutboundSmsPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegratedPhones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"decommissionedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primaryOutboundSms"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateIntegratedPhonesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"integratedPhoneGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primaryOutboundSms"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneGuid"}},{"kind":"Field","name":{"kind":"Name","value":"primaryOutboundSms"}}]}}]}}]} as unknown as DocumentNode<UpdatePrimaryOutboundSmsPhoneMutation, UpdatePrimaryOutboundSmsPhoneMutationVariables>;
export const UpdateCompanyPhoneConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCompanyPhoneConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegratedPhoneCompanyConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertIntegratedPhoneCompanyConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"integrated_phone_company_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"integratedPhoneEnabled"},{"kind":"EnumValue","value":"integratedVoiceCallingEnabled"},{"kind":"EnumValue","value":"fallbackShouldRecordVoicemail"},{"kind":"EnumValue","value":"fallbackForwardToPhoneNumber"},{"kind":"EnumValue","value":"fallbackHangupMessage"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneCompanyConfigGuid"}},{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"integratedVoiceCallingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackShouldRecordVoicemail"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackForwardToPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackHangupMessage"}}]}}]}}]} as unknown as DocumentNode<UpdateCompanyPhoneConfigMutation, UpdateCompanyPhoneConfigMutationVariables>;
export const CreateIntegratedPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIntegratedPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntegratedPhonesInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertIntegratedPhonesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integratedPhoneGuid"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneProvider"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSourceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"primaryOutboundSms"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<CreateIntegratedPhoneMutation, CreateIntegratedPhoneMutationVariables>;
export const ReadonlyCustomFormPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadonlyCustomFormPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentChecklistInstanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstancesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentChecklistInstanceGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentChecklistInstanceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checklist"}}]}}]}}]} as unknown as DocumentNode<ReadonlyCustomFormPageQuery, ReadonlyCustomFormPageQueryVariables>;
export const ReadUpcomingAppointmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadUpcomingAppointments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endWindow"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startWindow"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentWindowEnd"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endWindow"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentWindowStart"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startWindow"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancellationStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancellationStatus"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentWindowStart"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"endOfAppointmentNextSteps"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationTo"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendReminderEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentEnd"}},{"kind":"Field","alias":{"kind":"Name","value":"assignmentGuid"},"name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"roles"},"name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"phoneNumbers"},"name":{"kind":"Name","value":"userPhoneNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumberGuid"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeJobLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedEquipmentAge"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipType"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleGuid"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInJobCosting"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalFullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canceled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"}}]}}]}}]}}]} as unknown as DocumentNode<ReadUpcomingAppointmentsQuery, ReadUpcomingAppointmentsQueryVariables>;
export const NumberOfInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NumberOfInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoicesAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<NumberOfInvoicesQuery, NumberOfInvoicesQueryVariables>;
export const InvoicesByLeadSourceReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoicesByLeadSourceReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issuedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobLink"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"PAID","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"invoicePaymentsAggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"predicate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","alias":{"kind":"Name","value":"appliedAmountUscSum"},"name":{"kind":"Name","value":"invoicePaymentsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliedAmountUsc"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mostRecentInvoicePayment"},"name":{"kind":"Name","value":"invoicePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paymentRecord"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"occurredAt"},"value":{"kind":"EnumValue","value":"DESC_NULLS_LAST"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InvoicesByLeadSourceReportQuery, InvoicesByLeadSourceReportQueryVariables>;
export const TeamPerformanceDashboardMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamPerformanceDashboardMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobsBoolExp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayId"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamPerformanceJobFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamPerformanceJobFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Jobs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"workCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isConverted"}},{"kind":"Field","name":{"kind":"Name","value":"isHotLead"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipRenewalOpportunity"}},{"kind":"Field","name":{"kind":"Name","value":"isMembershipSold"}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTeamMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"turnedOverJob"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"yearlyPriceUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTechnicianEarnedRevenueSummaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"totalEarnedRevenueUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobTechnicianSoldRevenueSummaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"totalSoldRevenueUsc"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"jobFullyPaidInvoicesV2Summary"},"name":{"kind":"Name","value":"jobFullyPaidInvoicesV2SummaryMv"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalInvoicedAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"totalPaidAmountUsd"}},{"kind":"Field","name":{"kind":"Name","value":"totalSubtotalAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscountAmountUsc"}},{"kind":"Field","name":{"kind":"Name","value":"totalTaxAmountUsc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TeamPerformanceDashboardMetricsQuery, TeamPerformanceDashboardMetricsQueryVariables>;
export const UnpaidInvoicesV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnpaidInvoicesV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AggregatableInvoicesBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dueUsc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"dueUsc"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}},{"kind":"Field","name":{"kind":"Name","value":"paidUsc"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatableInvoicesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dueUsc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnpaidInvoicesV2Query, UnpaidInvoicesV2QueryVariables>;
export const ActiveCompanyUsersWithEmailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActiveCompanyUsersWithEmails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userByUserGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivatedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstNameInitial"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}}]} as unknown as DocumentNode<ActiveCompanyUsersWithEmailsQuery, ActiveCompanyUsersWithEmailsQueryVariables>;
export const UpdateSmsSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSMSSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smsAppointmentTemplate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smsReminderTemplate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"smsAppointmentTemplate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smsAppointmentTemplate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"smsReminderTemplate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smsReminderTemplate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateSmsSettingsMutation, UpdateSmsSettingsMutationVariables>;
export const SmsSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SMSSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smsAppointmentTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"smsReminderTemplate"}}]}}]}}]} as unknown as DocumentNode<SmsSettingsQuery, SmsSettingsQueryVariables>;
export const UpdateJobSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateJobSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobsSetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJobsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateJobSummaryMutation, UpdateJobSummaryMutationVariables>;
export const UnassignedAppointmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UnassignedAppointments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointments"},"name":{"kind":"Name","value":"jobAppointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignmentsAggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"predicate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"0"}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentWindowStart"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentWindowEnd"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleAppointment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleAppointment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobAppointments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"endOfAppointmentNextSteps"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationTo"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendReminderEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"instantBookingAt"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"summaryHtml"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoice"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeJobLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedEquipmentAge"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"instanceNumber"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstanceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"lastEditorUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"checklist"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"adHoc"}},{"kind":"Field","name":{"kind":"Name","value":"instanceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastEditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canceled"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]} as unknown as DocumentNode<UnassignedAppointmentsSubscription, UnassignedAppointmentsSubscriptionVariables>;
export const ScheduleAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ScheduleAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignmentEnd"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assignmentStart"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"start"},"name":{"kind":"Name","value":"assignmentStart"}},{"kind":"Field","alias":{"kind":"Name","value":"end"},"name":{"kind":"Name","value":"assignmentEnd"}},{"kind":"Field","alias":{"kind":"Name","value":"assignmentGuid"},"name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technicianUserGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","alias":{"kind":"Name","value":"appointment"},"name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleAppointment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryLinkData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnicianTimesheetEntry"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleAppointment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobAppointments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowEnd"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentWindowStart"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentGuid"},"name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"endOfAppointmentNextSteps"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"sendConfirmationTo"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"sendReminderEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reminderLastSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"instantBookingAt"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"summaryHtml"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobClass"}},{"kind":"Field","name":{"kind":"Name","value":"jobTypeGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invoice"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"displayIdV2"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsc"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeJobLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedEquipmentAge"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"instanceNumber"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistGuid"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklistInstanceGuid"}},{"kind":"Field","name":{"kind":"Name","value":"lastEditorUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"checklist"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"adHoc"}},{"kind":"Field","name":{"kind":"Name","value":"instanceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentChecklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastEditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canceled"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnicianTimesheetEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimesheetEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"finalStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"finalEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"entryLengthInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attentionNote"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivityGuid"}},{"kind":"Field","name":{"kind":"Name","value":"activityName"}},{"kind":"Field","name":{"kind":"Name","value":"isPayable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryLinkData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}}]}}]}}]}}]} as unknown as DocumentNode<ScheduleAssignmentsSubscription, ScheduleAssignmentsSubscriptionVariables>;
export const InternalEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"InternalEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianCapacityBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"recurrenceRule"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"reasonDescription"}},{"kind":"Field","name":{"kind":"Name","value":"reasonType"}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceRule"}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceRuleExceptions"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"userGuids"}},{"kind":"Field","name":{"kind":"Name","value":"technicianCapacityBlockGuid"}}]}}]}}]} as unknown as DocumentNode<InternalEventsSubscription, InternalEventsSubscriptionVariables>;
export const CompanyScheduleInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyScheduleInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyWorkingDisplayHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workingEndHour"}},{"kind":"Field","name":{"kind":"Name","value":"workingStartHour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"schedulingCapability"}},{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userPrimaryHueHex"}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleTechOrder"}}]}}]}}]} as unknown as DocumentNode<CompanyScheduleInfoQuery, CompanyScheduleInfoQueryVariables>;
export const ApplyScheduleChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplyScheduleChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blocks"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TechnicianCapacityBlocksInsertInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletedBlockGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canceledAppointmentGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertTechnicianCapacityBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blocks"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"technician_capacity_blocks_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"userGuids"},{"kind":"EnumValue","value":"start"},{"kind":"EnumValue","value":"end"},{"kind":"EnumValue","value":"reasonType"},{"kind":"EnumValue","value":"reasonDescription"},{"kind":"EnumValue","value":"recurrenceRule"},{"kind":"EnumValue","value":"recurrenceRuleExceptions"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteTechnicianCapacityBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"technicianCapacityBlockGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletedBlockGuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateJobAppointmentCancellationStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobAppointmentGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canceledAppointmentGuids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canceled"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedRows"}}]}}]}}]} as unknown as DocumentNode<ApplyScheduleChangesMutation, ApplyScheduleChangesMutationVariables>;
export const AppointmentDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AppointmentDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobAppointmentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancellationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canceled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"jobAppointmentAssignmentStatusType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentEnd"}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStart"}},{"kind":"Field","alias":{"kind":"Name","value":"assignmentGuid"},"name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"technician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPhoneNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryLinkData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechnicianTimesheetEntry"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeJobLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedEquipmentAge"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}},{"kind":"Field","name":{"kind":"Name","value":"estimateGuid"}},{"kind":"Field","name":{"kind":"Name","value":"estimateOptionsAggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"BooleanValue","value":false}}]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"accountReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"accountLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributionDescription"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalLeadSourceNameOverride"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPointOfContactFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"summaryHtml"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechnicianTimesheetEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TimesheetEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"finalStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"finalEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"entryLengthInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attentionNote"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivityGuid"}},{"kind":"Field","name":{"kind":"Name","value":"activityName"}},{"kind":"Field","name":{"kind":"Name","value":"isPayable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryLinkData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPointOfContactFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationPreferenceType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unsubscribed"}}]}}]}}]} as unknown as DocumentNode<AppointmentDetailsSubscription, AppointmentDetailsSubscriptionVariables>;
export const EquipmentTypeLinksForAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EquipmentTypeLinksForAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jobAppointmentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentTypeJobLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedEquipmentAge"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"relationshipType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EquipmentTypeLinksForAppointmentQuery, EquipmentTypeLinksForAppointmentQueryVariables>;
export const ReorderTechMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReorderTechMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduleTechOrder"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompanyConfigByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"scheduleTechOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduleTechOrder"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<ReorderTechMutationMutation, ReorderTechMutationMutationVariables>;
export const FetchAllJobsForScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchAllJobsForSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobLifecycleStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"specialStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobClass"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"locationDescription"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobLifecycleStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<FetchAllJobsForScheduleQuery, FetchAllJobsForScheduleQueryVariables>;
export const ScheduleV2PageUserSettingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScheduleV2PageUserSettingsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleColorPreference"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ScheduleV2PageUserSettingsQueryQuery, ScheduleV2PageUserSettingsQueryQueryVariables>;
export const ScheduleV2PageUpdateUserSettingsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScheduleV2PageUpdateUserSettingsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduleColorPreference"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertUserSettingsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scheduleColorPreference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduleColorPreference"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_settings_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"EnumValue","value":"scheduleColorPreference"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleColorPreference"}}]}}]}}]} as unknown as DocumentNode<ScheduleV2PageUpdateUserSettingsMutationMutation, ScheduleV2PageUpdateUserSettingsMutationMutationVariables>;
export const LocationsWithinRadiusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationsWithinRadius"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"radius"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"point"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"geography"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentAddressGuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geoLocation"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_stDWithin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"Variable","name":{"kind":"Name","value":"radius"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"point"}}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"addressGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentAddressGuids"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountLocations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"lastVisitedAt"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Address"}},{"kind":"Field","name":{"kind":"Name","value":"distBetweenMeters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address_to_compare"},"value":{"kind":"Variable","name":{"kind":"Name","value":"point"}}}]}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"installedEquipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installedEquipmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"installationDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaintenancePlanOpportunityMinimalInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagMinimal"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Address"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Addresses"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressGuid"}},{"kind":"Field","name":{"kind":"Name","value":"canonicalFullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaintenancePlanOpportunityMinimalInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenancePlansQueryable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanGuid"}},{"kind":"Field","name":{"kind":"Name","value":"accountGuid"}},{"kind":"Field","name":{"kind":"Name","value":"locationGuid"}},{"kind":"Field","name":{"kind":"Name","value":"maintenancePlanDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numVisitCreditsPerYear"}},{"kind":"Field","name":{"kind":"Name","value":"marketingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}},{"kind":"Field","name":{"kind":"Name","value":"lastVisitedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tags"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<LocationsWithinRadiusQuery, LocationsWithinRadiusQueryVariables>;
export const UserSettingsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSettingsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hideCallerIdEnabled"}}]}}]}}]} as unknown as DocumentNode<UserSettingsQueryQuery, UserSettingsQueryQueryVariables>;
export const UpdateUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hideCallerIdEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertUserSettingsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hideCallerIdEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hideCallerIdEnabled"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_settings_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"hideCallerIdEnabled"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const FetchUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchUserSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preferredMapApp"}}]}}]}}]} as unknown as DocumentNode<FetchUserSettingsQuery, FetchUserSettingsQueryVariables>;
export const UpsertUserSettingMapPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertUserSettingMapPreference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"obj"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSettingsInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertUserSettingsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"obj"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_settings_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"preferredMapApp"},{"kind":"EnumValue","value":"updatedAt"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertUserSettingMapPreferenceMutation, UpsertUserSettingMapPreferenceMutationVariables>;
export const ScheduleColorPreferencesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScheduleColorPreferencesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSettingsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleColorPreference"}}]}}]}}]} as unknown as DocumentNode<ScheduleColorPreferencesQueryQuery, ScheduleColorPreferencesQueryQueryVariables>;
export const ScheduleColorPreferencesUpdateScheduleColorPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScheduleColorPreferencesUpdateScheduleColorPreference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduleColorPreference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertUserSettingsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"scheduleColorPreference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduleColorPreference"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_settings_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"EnumValue","value":"scheduleColorPreference"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleColorPreference"}}]}}]}}]} as unknown as DocumentNode<ScheduleColorPreferencesUpdateScheduleColorPreferenceMutation, ScheduleColorPreferencesUpdateScheduleColorPreferenceMutationVariables>;
export const SettingsEditTeamMemberPageUserAvatarQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SettingsEditTeamMemberPageUserAvatarQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photoGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photosByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"photoGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photoGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}},{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]} as unknown as DocumentNode<SettingsEditTeamMemberPageUserAvatarQueryQuery, SettingsEditTeamMemberPageUserAvatarQueryQueryVariables>;
export const GetNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNotificationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyNotificationSettingsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"replyToEmail"}},{"kind":"Field","name":{"kind":"Name","value":"estimateAcceptNotifyCreator"}},{"kind":"Field","name":{"kind":"Name","value":"estimateAcceptNotifyEmail"}},{"kind":"Field","name":{"kind":"Name","value":"estimateAcceptNotifyUserGuids"}},{"kind":"Field","name":{"kind":"Name","value":"estimateReminderCount"}},{"kind":"Field","name":{"kind":"Name","value":"estimateReminderFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"estimateReviewedNotifyCreator"}},{"kind":"Field","name":{"kind":"Name","value":"estimateReviewedNotifyUserGuids"}},{"kind":"Field","name":{"kind":"Name","value":"invoicePaymentReminderCount"}},{"kind":"Field","name":{"kind":"Name","value":"invoicePaymentReminderFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFailedNotifyCreator"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFailedNotifyEmail"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFailedNotifyUserGuids"}},{"kind":"Field","name":{"kind":"Name","value":"materialRestockReportEmail"}},{"kind":"Field","name":{"kind":"Name","value":"materialRestockReportUserGuids"}},{"kind":"Field","name":{"kind":"Name","value":"jobLeadCreatedUserGuids"}},{"kind":"Field","name":{"kind":"Name","value":"jobLeadCreatedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"lapsedPaymentMaintenancePlanUserGuids"}},{"kind":"Field","name":{"kind":"Name","value":"lapsedPaymentMaintenancePlanNotifyEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userByUserGuid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>;
export const TagsAllQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TagsAllQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Tag"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Tag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tags"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}},{"kind":"Field","name":{"kind":"Name","value":"companyGuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUserGuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TagsAllQueryQuery, TagsAllQueryQueryVariables>;
export const TagUpsertOneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TagUpsertOne"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tag"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TagsInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertTagsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tag"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"tags_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"color"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagGuid"}}]}}]}}]} as unknown as DocumentNode<TagUpsertOneMutation, TagUpsertOneMutationVariables>;
export const DeleteTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tagGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<DeleteTagMutation, DeleteTagMutationVariables>;
export const FetchCompanyTechnicianPerformanceConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchCompanyTechnicianPerformanceConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"technicianPerformanceEnabled"}}]}}]}}]} as unknown as DocumentNode<FetchCompanyTechnicianPerformanceConfigQuery, FetchCompanyTechnicianPerformanceConfigQueryVariables>;
export const FetchCompanyTechnicianPerformanceCommissionConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchCompanyTechnicianPerformanceCommissionConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyCommissionConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultCommissionOverheadDeductionRate"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCommissionOverheadFlatDeductionUsc"}}]}}]}}]} as unknown as DocumentNode<FetchCompanyTechnicianPerformanceCommissionConfigQuery, FetchCompanyTechnicianPerformanceCommissionConfigQueryVariables>;
export const UpsertCompanyCommissionConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCompanyCommissionConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"config"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyCommissionConfigInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertCompanyCommissionConfigOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"config"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"company_commission_config_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"defaultCommissionOverheadDeductionRate"},{"kind":"EnumValue","value":"defaultCommissionOverheadFlatDeductionUsc"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultCommissionOverheadDeductionRate"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCommissionOverheadFlatDeductionUsc"}}]}}]}}]} as unknown as DocumentNode<UpsertCompanyCommissionConfigMutation, UpsertCompanyCommissionConfigMutationVariables>;
export const TechnicianSchedulePageUserScheduleColorPreferenceSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"TechnicianSchedulePageUserScheduleColorPreferenceSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSettingsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleColorPreference"}}]}}]}}]} as unknown as DocumentNode<TechnicianSchedulePageUserScheduleColorPreferenceSubscriptionSubscription, TechnicianSchedulePageUserScheduleColorPreferenceSubscriptionSubscriptionVariables>;
export const TechnicianSchedulePageUserAvatarPhotosQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TechnicianSchedulePageUserAvatarPhotosQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_in"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_in"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userPrimaryHueHex"}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}}]}}]}}]} as unknown as DocumentNode<TechnicianSchedulePageUserAvatarPhotosQueryQuery, TechnicianSchedulePageUserAvatarPhotosQueryQueryVariables>;
export const FetchTimesheetEntriesPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchTimesheetEntriesPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TimesheetEntriesBoolExp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"finalStartTime"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"finalEndTime"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"finalStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"finalEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"entryLengthInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attentionNote"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivityGuid"}},{"kind":"Field","name":{"kind":"Name","value":"activityName"}},{"kind":"Field","name":{"kind":"Name","value":"isPayable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntriesAggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<FetchTimesheetEntriesPaginatedQuery, FetchTimesheetEntriesPaginatedQueryVariables>;
export const FetchTimesheetEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchTimesheetEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TimesheetEntriesBoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"finalStartTime"},"value":{"kind":"EnumValue","value":"ASC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"finalEndTime"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"finalStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"finalEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"entryLengthInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attentionNote"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivityGuid"}},{"kind":"Field","name":{"kind":"Name","value":"activityName"}},{"kind":"Field","name":{"kind":"Name","value":"isPayable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchTimesheetEntriesQuery, FetchTimesheetEntriesQueryVariables>;
export const UpsertTimesheetEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertTimesheetEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entry"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimesheetEntriesInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertTimesheetEntriesOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entry"}}},{"kind":"Argument","name":{"kind":"Name","value":"onConflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"timesheet_entries_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updateColumns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpsertTimesheetEntryMutation, UpsertTimesheetEntryMutationVariables>;
export const UpdateTimesheetEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTimesheetEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatedByUserGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timesheetEntryGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTimeOverride"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endTimeOverride"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timesheetEntryActivityGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPayable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attentionNote"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimesheetEntriesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timesheetEntryGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timesheetEntryGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startTimeOverride"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTimeOverride"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endTimeOverride"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endTimeOverride"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatedByUserGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatedByUserGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"attentionNote"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attentionNote"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateTimesheetEntryActivitiesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timesheetEntryActivityGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timesheetEntryActivityGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activityName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isPayable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPayable"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateTimesheetEntryMutation, UpdateTimesheetEntryMutationVariables>;
export const ClearAttentionNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClearAttentionNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timesheetEntryGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatedByUserGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimesheetEntriesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timesheetEntryGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timesheetEntryGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"attentionNote"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"updatedByUserGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatedByUserGuid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<ClearAttentionNoteMutation, ClearAttentionNoteMutationVariables>;
export const DeleteTimesheetEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTimesheetEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timesheetEntryGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletedAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletedByUserGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTimesheetEntriesByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pkColumns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timesheetEntryGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timesheetEntryGuid"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletedAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletedByUserGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletedByUserGuid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<DeleteTimesheetEntryMutation, DeleteTimesheetEntryMutationVariables>;
export const TimesheetsSummaryPageTimesheetsDetailSummaryQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TimesheetsSummaryPageTimesheetsDetailSummaryQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"finalStartTime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"finalEndTime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"finalStartTime"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"finalStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"finalEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"entryLengthInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"attentionNote"}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPayable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPrimaryHueHex"}}]}}]}}]} as unknown as DocumentNode<TimesheetsSummaryPageTimesheetsDetailSummaryQueryQuery, TimesheetsSummaryPageTimesheetsDetailSummaryQueryQueryVariables>;
export const TimesheetsSummaryPageTechniciansQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TimesheetsSummaryPageTechniciansQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleSearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyUser"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fullName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userRoles"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleSearch"}}}]}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGuid"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userPrimaryHueHex"}}]}}]}}]} as unknown as DocumentNode<TimesheetsSummaryPageTechniciansQueryQuery, TimesheetsSummaryPageTechniciansQueryQueryVariables>;
export const GetPricebookDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPricebookData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricebookItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookCategoryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"parentCategoryGuid"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"uncategorizedItems"},"name":{"kind":"Name","value":"pricebookItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pricebookCategoryGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_isNull"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricebookItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PricebookItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PricebookItems"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscountable"}},{"kind":"Field","name":{"kind":"Name","value":"isTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priceUsd"}},{"kind":"Field","name":{"kind":"Name","value":"costUsd"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookItemCode"}},{"kind":"Field","name":{"kind":"Name","value":"pricebookItemGuid"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"basePriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"memberPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"memberAddonPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"memberAfterhoursPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"memberAddonAfterhoursPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"addonPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"addonAfterhoursPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"afterhoursPriceUsc"}},{"kind":"Field","name":{"kind":"Name","value":"photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdnUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoGuid"}}]}}]}}]} as unknown as DocumentNode<GetPricebookDataQuery, GetPricebookDataQueryVariables>;
export const GetRecentPricebookItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecentPricebookItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recentPricebookItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastViewedAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookItemGuid"}}]}}]}}]} as unknown as DocumentNode<GetRecentPricebookItemsQuery, GetRecentPricebookItemsQueryVariables>;
export const GetFavoritePricebookItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFavoritePricebookItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoritePricebookItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookItemGuid"}}]}}]}}]} as unknown as DocumentNode<GetFavoritePricebookItemsQuery, GetFavoritePricebookItemsQueryVariables>;
export const InsertFavoritePricebookItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertFavoritePricebookItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FavoritePricebookItemsInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertFavoritePricebookItemsOne"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookItemGuid"}}]}}]}}]} as unknown as DocumentNode<InsertFavoritePricebookItemMutation, InsertFavoritePricebookItemMutationVariables>;
export const DeleteFavoritePricebookItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFavoritePricebookItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pricebookItemGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFavoritePricebookItemsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pricebookItemGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pricebookItemGuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pricebookItemGuid"}}]}}]}}]} as unknown as DocumentNode<DeleteFavoritePricebookItemMutation, DeleteFavoritePricebookItemMutationVariables>;
export const TimeClockProviderDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"TimeClockProviderData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timesheetEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGuid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGuid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"finalStartTime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"finalStartTime"},"value":{"kind":"EnumValue","value":"ASC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"finalEndTime"},"value":{"kind":"EnumValue","value":"DESC_NULLS_LAST"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"finalEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"entryLengthInMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetEntryLinkData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentGuid"}},{"kind":"Field","name":{"kind":"Name","value":"jobAppointmentAssignmentGuid"}}]}}]}}]}}]} as unknown as DocumentNode<TimeClockProviderDataSubscription, TimeClockProviderDataSubscriptionVariables>;
export const FetchMetabasePulseSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchMetabasePulseSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RepMetabasePulsesV2BoolExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repMetabasePulsesV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseGuid"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleType"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleDetails"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<FetchMetabasePulseSubscriptionsQuery, FetchMetabasePulseSubscriptionsQueryVariables>;
export const FetchMetabasePulseByGuidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchMetabasePulseByGuid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pulseGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repMetabasePulsesV2ByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pulseGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pulseGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pulseGuid"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleType"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleDetails"}}]}}]}}]} as unknown as DocumentNode<FetchMetabasePulseByGuidQuery, FetchMetabasePulseByGuidQueryVariables>;
export const FetchReportsByCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchReportsByCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportCategory"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repMetabaseReportDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reportCategory"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportCategory"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accessControlType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"GLOBAL","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reportTitle"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportGuid"}},{"kind":"Field","name":{"kind":"Name","value":"reportCategory"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"reportTitle"}},{"kind":"Field","name":{"kind":"Name","value":"reportDescription"}},{"kind":"Field","name":{"kind":"Name","value":"externalReportId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"repMetabaseCompanyReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"repMetabaseReportDefinition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reportCategory"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportCategory"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accessControlType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OPT_IN","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repMetabaseReportDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportGuid"}},{"kind":"Field","name":{"kind":"Name","value":"reportCategory"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"reportTitle"}},{"kind":"Field","name":{"kind":"Name","value":"reportDescription"}},{"kind":"Field","name":{"kind":"Name","value":"externalReportId"}}]}}]}}]}}]} as unknown as DocumentNode<FetchReportsByCategoryQuery, FetchReportsByCategoryQueryVariables>;
export const FetchReportByGuidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchReportByGuid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportGuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repMetabaseReportDefinitionsByPk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportGuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportGuid"}},{"kind":"Field","name":{"kind":"Name","value":"reportCategory"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"reportTitle"}},{"kind":"Field","name":{"kind":"Name","value":"reportDescription"}},{"kind":"Field","name":{"kind":"Name","value":"externalReportId"}}]}}]}}]} as unknown as DocumentNode<FetchReportByGuidQuery, FetchReportByGuidQueryVariables>;